webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _isPlaceholder = __webpack_require__(70);


/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2
             : _curry1(function(_b) { return fn(a, _b); });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
             : fn(a, b);
    }
  };
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  F: __webpack_require__(266),
  T: __webpack_require__(267),
  __: __webpack_require__(268),
  add: __webpack_require__(71),
  addIndex: __webpack_require__(269),
  adjust: __webpack_require__(147),
  all: __webpack_require__(270),
  allPass: __webpack_require__(272),
  always: __webpack_require__(49),
  and: __webpack_require__(151),
  any: __webpack_require__(152),
  anyPass: __webpack_require__(274),
  ap: __webpack_require__(97),
  aperture: __webpack_require__(275),
  append: __webpack_require__(278),
  apply: __webpack_require__(154),
  applySpec: __webpack_require__(279),
  ascend: __webpack_require__(280),
  assoc: __webpack_require__(75),
  assocPath: __webpack_require__(156),
  binary: __webpack_require__(281),
  bind: __webpack_require__(149),
  both: __webpack_require__(282),
  call: __webpack_require__(283),
  chain: __webpack_require__(99),
  clamp: __webpack_require__(287),
  clone: __webpack_require__(288),
  comparator: __webpack_require__(289),
  complement: __webpack_require__(290),
  compose: __webpack_require__(101),
  composeK: __webpack_require__(164),
  composeP: __webpack_require__(292),
  concat: __webpack_require__(103),
  cond: __webpack_require__(301),
  construct: __webpack_require__(302),
  constructN: __webpack_require__(169),
  contains: __webpack_require__(303),
  converge: __webpack_require__(170),
  countBy: __webpack_require__(304),
  curry: __webpack_require__(79),
  curryN: __webpack_require__(13),
  dec: __webpack_require__(306),
  defaultTo: __webpack_require__(171),
  descend: __webpack_require__(307),
  difference: __webpack_require__(172),
  differenceWith: __webpack_require__(173),
  dissoc: __webpack_require__(174),
  dissocPath: __webpack_require__(308),
  divide: __webpack_require__(309),
  drop: __webpack_require__(176),
  dropLast: __webpack_require__(311),
  dropLastWhile: __webpack_require__(315),
  dropRepeats: __webpack_require__(318),
  dropRepeatsWith: __webpack_require__(178),
  dropWhile: __webpack_require__(319),
  either: __webpack_require__(321),
  empty: __webpack_require__(181),
  endsWith: __webpack_require__(322),
  eqBy: __webpack_require__(323),
  eqProps: __webpack_require__(324),
  equals: __webpack_require__(19),
  evolve: __webpack_require__(325),
  filter: __webpack_require__(104),
  find: __webpack_require__(326),
  findIndex: __webpack_require__(328),
  findLast: __webpack_require__(330),
  findLastIndex: __webpack_require__(332),
  flatten: __webpack_require__(334),
  flip: __webpack_require__(84),
  forEach: __webpack_require__(335),
  forEachObjIndexed: __webpack_require__(336),
  fromPairs: __webpack_require__(337),
  groupBy: __webpack_require__(338),
  groupWith: __webpack_require__(339),
  gt: __webpack_require__(340),
  gte: __webpack_require__(341),
  has: __webpack_require__(342),
  hasIn: __webpack_require__(343),
  head: __webpack_require__(344),
  identical: __webpack_require__(167),
  identity: __webpack_require__(109),
  ifElse: __webpack_require__(345),
  inc: __webpack_require__(346),
  indexBy: __webpack_require__(347),
  indexOf: __webpack_require__(348),
  init: __webpack_require__(349),
  innerJoin: __webpack_require__(350),
  insert: __webpack_require__(351),
  insertAll: __webpack_require__(352),
  intersection: __webpack_require__(353),
  intersectionWith: __webpack_require__(355),
  intersperse: __webpack_require__(356),
  into: __webpack_require__(357),
  invert: __webpack_require__(360),
  invertObj: __webpack_require__(361),
  invoker: __webpack_require__(62),
  is: __webpack_require__(185),
  isEmpty: __webpack_require__(362),
  isNil: __webpack_require__(157),
  join: __webpack_require__(363),
  juxt: __webpack_require__(186),
  keys: __webpack_require__(32),
  keysIn: __webpack_require__(364),
  last: __webpack_require__(179),
  lastIndexOf: __webpack_require__(365),
  length: __webpack_require__(187),
  lens: __webpack_require__(85),
  lensIndex: __webpack_require__(366),
  lensPath: __webpack_require__(367),
  lensProp: __webpack_require__(368),
  lift: __webpack_require__(78),
  liftN: __webpack_require__(158),
  lt: __webpack_require__(369),
  lte: __webpack_require__(370),
  map: __webpack_require__(16),
  mapAccum: __webpack_require__(371),
  mapAccumRight: __webpack_require__(372),
  mapObjIndexed: __webpack_require__(373),
  match: __webpack_require__(374),
  mathMod: __webpack_require__(375),
  max: __webpack_require__(50),
  maxBy: __webpack_require__(376),
  mean: __webpack_require__(189),
  median: __webpack_require__(377),
  memoize: __webpack_require__(378),
  memoizeWith: __webpack_require__(191),
  merge: __webpack_require__(379),
  mergeAll: __webpack_require__(380),
  mergeDeepLeft: __webpack_require__(381),
  mergeDeepRight: __webpack_require__(382),
  mergeDeepWith: __webpack_require__(383),
  mergeDeepWithKey: __webpack_require__(86),
  mergeWith: __webpack_require__(384),
  mergeWithKey: __webpack_require__(114),
  min: __webpack_require__(385),
  minBy: __webpack_require__(386),
  modulo: __webpack_require__(387),
  multiply: __webpack_require__(192),
  nAry: __webpack_require__(76),
  negate: __webpack_require__(388),
  none: __webpack_require__(389),
  not: __webpack_require__(162),
  nth: __webpack_require__(61),
  nthArg: __webpack_require__(390),
  o: __webpack_require__(391),
  objOf: __webpack_require__(184),
  of: __webpack_require__(392),
  omit: __webpack_require__(394),
  once: __webpack_require__(395),
  or: __webpack_require__(180),
  over: __webpack_require__(193),
  pair: __webpack_require__(396),
  partial: __webpack_require__(397),
  partialRight: __webpack_require__(398),
  partition: __webpack_require__(399),
  path: __webpack_require__(63),
  pathEq: __webpack_require__(400),
  pathOr: __webpack_require__(401),
  pathSatisfies: __webpack_require__(402),
  pick: __webpack_require__(403),
  pickAll: __webpack_require__(195),
  pickBy: __webpack_require__(404),
  pipe: __webpack_require__(163),
  pipeK: __webpack_require__(405),
  pipeP: __webpack_require__(165),
  pluck: __webpack_require__(57),
  prepend: __webpack_require__(196),
  product: __webpack_require__(406),
  project: __webpack_require__(407),
  prop: __webpack_require__(96),
  propEq: __webpack_require__(408),
  propIs: __webpack_require__(409),
  propOr: __webpack_require__(410),
  propSatisfies: __webpack_require__(411),
  props: __webpack_require__(412),
  range: __webpack_require__(413),
  reduce: __webpack_require__(33),
  reduceBy: __webpack_require__(82),
  reduceRight: __webpack_require__(198),
  reduceWhile: __webpack_require__(414),
  reduced: __webpack_require__(415),
  reject: __webpack_require__(81),
  remove: __webpack_require__(175),
  repeat: __webpack_require__(416),
  replace: __webpack_require__(417),
  reverse: __webpack_require__(80),
  scan: __webpack_require__(418),
  sequence: __webpack_require__(200),
  set: __webpack_require__(419),
  slice: __webpack_require__(45),
  sort: __webpack_require__(420),
  sortBy: __webpack_require__(421),
  sortWith: __webpack_require__(422),
  split: __webpack_require__(423),
  splitAt: __webpack_require__(424),
  splitEvery: __webpack_require__(425),
  splitWhen: __webpack_require__(426),
  startsWith: __webpack_require__(427),
  subtract: __webpack_require__(428),
  sum: __webpack_require__(190),
  symmetricDifference: __webpack_require__(429),
  symmetricDifferenceWith: __webpack_require__(430),
  tail: __webpack_require__(102),
  take: __webpack_require__(108),
  takeLast: __webpack_require__(182),
  takeLastWhile: __webpack_require__(431),
  takeWhile: __webpack_require__(432),
  tap: __webpack_require__(434),
  test: __webpack_require__(435),
  times: __webpack_require__(199),
  toLower: __webpack_require__(437),
  toPairs: __webpack_require__(438),
  toPairsIn: __webpack_require__(439),
  toString: __webpack_require__(60),
  toUpper: __webpack_require__(440),
  transduce: __webpack_require__(441),
  transpose: __webpack_require__(442),
  traverse: __webpack_require__(443),
  trim: __webpack_require__(444),
  tryCatch: __webpack_require__(445),
  type: __webpack_require__(100),
  unapply: __webpack_require__(446),
  unary: __webpack_require__(447),
  uncurryN: __webpack_require__(448),
  unfold: __webpack_require__(449),
  union: __webpack_require__(450),
  unionWith: __webpack_require__(451),
  uniq: __webpack_require__(111),
  uniqBy: __webpack_require__(183),
  uniqWith: __webpack_require__(112),
  unless: __webpack_require__(452),
  unnest: __webpack_require__(453),
  until: __webpack_require__(454),
  update: __webpack_require__(107),
  useWith: __webpack_require__(197),
  values: __webpack_require__(155),
  valuesIn: __webpack_require__(455),
  view: __webpack_require__(456),
  when: __webpack_require__(457),
  where: __webpack_require__(201),
  whereEq: __webpack_require__(458),
  without: __webpack_require__(459),
  xprod: __webpack_require__(460),
  zip: __webpack_require__(461),
  zipObj: __webpack_require__(462),
  zipWith: __webpack_require__(463)
};


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var _isPlaceholder = __webpack_require__(70);


/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _curry2 = __webpack_require__(1);
var _isPlaceholder = __webpack_require__(70);


/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3
             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
             : _curry1(function(_c) { return fn(a, b, _c); });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
             : fn(a, b, c);
    }
  };
};


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(469);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var _isArray = __webpack_require__(41);
var _isTransformer = __webpack_require__(95);


/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer [xf] to return a new transformer (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} xf transducer to initialize if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */
module.exports = function _dispatchable(methodNames, xf, fn) {
  return function() {
    if (arguments.length === 0) {
      return fn();
    }
    var args = Array.prototype.slice.call(arguments, 0);
    var obj = args.pop();
    if (!_isArray(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === 'function') {
          return obj[methodNames[idx]].apply(obj, args);
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = xf.apply(null, args);
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
};


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

module.exports = {
  init: function() {
    return this.xf['@@transducer/init']();
  },
  result: function(result) {
    return this.xf['@@transducer/result'](result);
  }
};


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _curry1 = __webpack_require__(4);
var _curry2 = __webpack_require__(1);
var _curryN = __webpack_require__(72);


/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */
module.exports = _curry2(function curryN(length, fn) {
  if (length === 1) {
    return _curry1(fn);
  }
  return _arity(length, _curryN(length, [], fn));
});


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};


/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _map = __webpack_require__(73);
var _reduce = __webpack_require__(18);
var _xmap = __webpack_require__(273);
var curryN = __webpack_require__(13);
var keys = __webpack_require__(32);


/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      var double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */
module.exports = _curry2(_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return curryN(functor.length, function() {
        return fn.call(this, functor.apply(this, arguments));
      });
    case '[object Object]':
      return _reduce(function(acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, keys(functor));
    default:
      return _map(fn, functor);
  }
}));


/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var _isArrayLike = __webpack_require__(74);
var _xwrap = __webpack_require__(148);
var bind = __webpack_require__(149);


module.exports = (function() {
  function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while (idx < len) {
      acc = xf['@@transducer/step'](acc, list[idx]);
      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }
      idx += 1;
    }
    return xf['@@transducer/result'](acc);
  }

  function _iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while (!step.done) {
      acc = xf['@@transducer/step'](acc, step.value);
      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }
      step = iter.next();
    }
    return xf['@@transducer/result'](acc);
  }

  function _methodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
  }

  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
  return function _reduce(fn, acc, list) {
    if (typeof fn === 'function') {
      fn = _xwrap(fn);
    }
    if (_isArrayLike(list)) {
      return _arrayReduce(fn, acc, list);
    }
    if (typeof list['fantasy-land/reduce'] === 'function') {
      return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
    }
    if (list[symIterator] != null) {
      return _iterableReduce(fn, acc, list[symIterator]());
    }
    if (typeof list.next === 'function') {
      return _iterableReduce(fn, acc, list);
    }
    if (typeof list.reduce === 'function') {
      return _methodReduce(fn, acc, list, 'reduce');
    }

    throw new TypeError('reduce: list must be array or iterable');
  };
}());


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _equals = __webpack_require__(295);


/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      var a = {}; a.v = a;
 *      var b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */
module.exports = _curry2(function equals(a, b) {
  return _equals(a, b, [], []);
});


/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */
module.exports = function _concat(set1, set2) {
  set1 = set1 || [];
  set2 = set2 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set2.length;
  var result = [];

  idx = 0;
  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }
  idx = 0;
  while (idx < len2) {
    result[result.length] = set2[idx];
    idx += 1;
  }
  return result;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(685).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)(module)))

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(580);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(581);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(912);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(913);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

module.exports = function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0: return function() { return fn.apply(this, arguments); };
    case 1: return function(a0) { return fn.apply(this, arguments); };
    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _has = __webpack_require__(14);
var _isArguments = __webpack_require__(150);


/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
module.exports = (function() {
  // cover IE < 9 keys issues
  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
  // Safari bug
  var hasArgsEnumBug = (function() {
    'use strict';
    return arguments.propertyIsEnumerable('length');
  }());

  var contains = function contains(list, item) {
    var idx = 0;
    while (idx < list.length) {
      if (list[idx] === item) {
        return true;
      }
      idx += 1;
    }
    return false;
  };

  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
    _curry1(function keys(obj) {
      return Object(obj) !== obj ? [] : Object.keys(obj);
    }) :
    _curry1(function keys(obj) {
      if (Object(obj) !== obj) {
        return [];
      }
      var prop, nIdx;
      var ks = [];
      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
      for (prop in obj) {
        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
          ks[ks.length] = prop;
        }
      }
      if (hasEnumBug) {
        nIdx = nonEnumerableProps.length - 1;
        while (nIdx >= 0) {
          prop = nonEnumerableProps[nIdx];
          if (_has(prop, obj) && !contains(ks, prop)) {
            ks[ks.length] = prop;
          }
          nIdx -= 1;
        }
      }
      return ks;
    });
}());


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var _reduce = __webpack_require__(18);


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *                -               -10
 *               / \              / \
 *              -   4           -6   4
 *             / \              / \
 *            -   3   ==>     -3   3
 *           / \              / \
 *          -   2           -1   2
 *         / \              / \
 *        0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */
module.exports = _curry3(_reduce);


/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var support = __webpack_require__(117);
var base64 = __webpack_require__(589);
var nodejsUtils = __webpack_require__(238);
var setImmediate = __webpack_require__(921);
var external = __webpack_require__(218);


/**
 * Convert a string that pass as a "binary string": it should represent a byte
 * array but may have > 255 char codes. Be sure to take only the first byte
 * and returns the byte array.
 * @param {String} str the string to transform.
 * @return {Array|Uint8Array} the string in a binary format.
 */
function string2binary(str) {
    var result = null;
    if (support.uint8array) {
      result = new Uint8Array(str.length);
    } else {
      result = new Array(str.length);
    }
    return stringToArrayLike(str, result);
}

/**
 * Create a new blob with the given content and the given type.
 * @param {Array[String|ArrayBuffer]} parts the content to put in the blob. DO NOT use
 * an Uint8Array because the stock browser of android 4 won't accept it (it
 * will be silently converted to a string, "[object Uint8Array]").
 * @param {String} type the mime type of the blob.
 * @return {Blob} the created blob.
 */
exports.newBlob = function(parts, type) {
    exports.checkSupport("blob");

    try {
        // Blob constructor
        return new Blob(parts, {
            type: type
        });
    }
    catch (e) {

        try {
            // deprecated, browser only, old way
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            for (var i = 0; i < parts.length; i++) {
                builder.append(parts[i]);
            }
            return builder.getBlob(type);
        }
        catch (e) {

            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
        }
    }


};
/**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */
function identity(input) {
    return input;
}

/**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */
function stringToArrayLike(str, array) {
    for (var i = 0; i < str.length; ++i) {
        array[i] = str.charCodeAt(i) & 0xFF;
    }
    return array;
}

/**
 * An helper for the function arrayLikeToString.
 * This contains static informations and functions that
 * can be optimized by the browser JIT compiler.
 */
var arrayToStringHelper = {
    /**
     * Transform an array of int into a string, chunk by chunk.
     * See the performances notes on arrayLikeToString.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @param {String} type the type of the array.
     * @param {Integer} chunk the chunk size.
     * @return {String} the resulting string.
     * @throws Error if the chunk is too big for the stack.
     */
    stringifyByChunk: function(array, type, chunk) {
        var result = [], k = 0, len = array.length;
        // shortcut
        if (len <= chunk) {
            return String.fromCharCode.apply(null, array);
        }
        while (k < len) {
            if (type === "array" || type === "nodebuffer") {
                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            }
            else {
                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
        }
        return result.join("");
    },
    /**
     * Call String.fromCharCode on every item in the array.
     * This is the naive implementation, which generate A LOT of intermediate string.
     * This should be used when everything else fail.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @return {String} the result.
     */
    stringifyByChar: function(array){
        var resultStr = "";
        for(var i = 0; i < array.length; i++) {
            resultStr += String.fromCharCode(array[i]);
        }
        return resultStr;
    },
    applyCanBeUsed : {
        /**
         * true if the browser accepts to use String.fromCharCode on Uint8Array
         */
        uint8array : (function () {
            try {
                return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
            } catch (e) {
                return false;
            }
        })(),
        /**
         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
         */
        nodebuffer : (function () {
            try {
                return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.newBuffer(1)).length === 1;
            } catch (e) {
                return false;
            }
        })()
    }
};

/**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */
function arrayLikeToString(array) {
    // Performances notes :
    // --------------------
    // String.fromCharCode.apply(null, array) is the fastest, see
    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
    // but the stack is limited (and we can get huge arrays !).
    //
    // result += String.fromCharCode(array[i]); generate too many strings !
    //
    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
    // TODO : we now have workers that split the work. Do we still need that ?
    var chunk = 65536,
        type = exports.getTypeOf(array),
        canUseApply = true;
    if (type === "uint8array") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
    } else if (type === "nodebuffer") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
    }

    if (canUseApply) {
        while (chunk > 1) {
            try {
                return arrayToStringHelper.stringifyByChunk(array, type, chunk);
            } catch (e) {
                chunk = Math.floor(chunk / 2);
            }
        }
    }

    // no apply or chunk error : slow and painful algorithm
    // default browser on android 4.*
    return arrayToStringHelper.stringifyByChar(array);
}

exports.applyFromCharCode = arrayLikeToString;


/**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */
function arrayLikeToArrayLike(arrayFrom, arrayTo) {
    for (var i = 0; i < arrayFrom.length; i++) {
        arrayTo[i] = arrayFrom[i];
    }
    return arrayTo;
}

// a matrix containing functions to transform everything into everything.
var transform = {};

// string to ?
transform["string"] = {
    "string": identity,
    "array": function(input) {
        return stringToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["string"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return stringToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": function(input) {
        return stringToArrayLike(input, nodejsUtils.newBuffer(input.length));
    }
};

// array to ?
transform["array"] = {
    "string": arrayLikeToString,
    "array": identity,
    "arraybuffer": function(input) {
        return (new Uint8Array(input)).buffer;
    },
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBuffer(input);
    }
};

// arraybuffer to ?
transform["arraybuffer"] = {
    "string": function(input) {
        return arrayLikeToString(new Uint8Array(input));
    },
    "array": function(input) {
        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
    },
    "arraybuffer": identity,
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBuffer(new Uint8Array(input));
    }
};

// uint8array to ?
transform["uint8array"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        // copy the uint8array: DO NOT propagate the original ArrayBuffer, it
        // can be way larger (the whole zip file for example).
        var copy = new Uint8Array(input.length);
        if (input.length) {
            copy.set(input, 0);
        }
        return copy.buffer;
    },
    "uint8array": identity,
    "nodebuffer": function(input) {
        return nodejsUtils.newBuffer(input);
    }
};

// nodebuffer to ?
transform["nodebuffer"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["nodebuffer"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": identity
};

/**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */
exports.transformTo = function(outputType, input) {
    if (!input) {
        // undefined, null, etc
        // an empty string won't harm.
        input = "";
    }
    if (!outputType) {
        return input;
    }
    exports.checkSupport(outputType);
    var inputType = exports.getTypeOf(input);
    var result = transform[inputType][outputType](input);
    return result;
};

/**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */
exports.getTypeOf = function(input) {
    if (typeof input === "string") {
        return "string";
    }
    if (Object.prototype.toString.call(input) === "[object Array]") {
        return "array";
    }
    if (support.nodebuffer && nodejsUtils.isBuffer(input)) {
        return "nodebuffer";
    }
    if (support.uint8array && input instanceof Uint8Array) {
        return "uint8array";
    }
    if (support.arraybuffer && input instanceof ArrayBuffer) {
        return "arraybuffer";
    }
};

/**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */
exports.checkSupport = function(type) {
    var supported = support[type.toLowerCase()];
    if (!supported) {
        throw new Error(type + " is not supported by this platform");
    }
};

exports.MAX_VALUE_16BITS = 65535;
exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

/**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */
exports.pretty = function(str) {
    var res = '',
        code, i;
    for (i = 0; i < (str || "").length; i++) {
        code = str.charCodeAt(i);
        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
    }
    return res;
};

/**
 * Defer the call of a function.
 * @param {Function} callback the function to call asynchronously.
 * @param {Array} args the arguments to give to the callback.
 */
exports.delay = function(callback, args, self) {
    setImmediate(function () {
        callback.apply(self || null, args || []);
    });
};

/**
 * Extends a prototype with an other, without calling a constructor with
 * side effects. Inspired by nodejs' `utils.inherits`
 * @param {Function} ctor the constructor to augment
 * @param {Function} superCtor the parent constructor to use
 */
exports.inherits = function (ctor, superCtor) {
    var Obj = function() {};
    Obj.prototype = superCtor.prototype;
    ctor.prototype = new Obj();
};

/**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */
exports.extend = function() {
    var result = {}, i, attr;
    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
        for (attr in arguments[i]) {
            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
                result[attr] = arguments[i][attr];
            }
        }
    }
    return result;
};

/**
 * Transform arbitrary content into a Promise.
 * @param {String} name a name for the content being processed.
 * @param {Object} inputData the content to process.
 * @param {Boolean} isBinary true if the content is not an unicode string
 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
 * @param {Boolean} isBase64 true if the string content is encoded with base64.
 * @return {Promise} a promise in a format usable by JSZip.
 */
exports.prepareContent = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {

    // if inputData is already a promise, this flatten it.
    var promise = external.Promise.resolve(inputData).then(function(data) {
        
        
        var isBlob = support.blob && (data instanceof Blob || ['[object File]', '[object Blob]'].indexOf(Object.prototype.toString.call(data)) !== -1);

        if (isBlob && typeof FileReader !== "undefined") {
            return new external.Promise(function (resolve, reject) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    resolve(e.target.result);
                };
                reader.onerror = function(e) {
                    reject(e.target.error);
                };
                reader.readAsArrayBuffer(data);
            });
        } else {
            return data;
        }
    });

    return promise.then(function(data) {
        var dataType = exports.getTypeOf(data);

        if (!dataType) {
            return external.Promise.reject(
                new Error("The data of '" + name + "' is in an unsupported format !")
            );
        }
        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
        if (dataType === "arraybuffer") {
            data = exports.transformTo("uint8array", data);
        } else if (dataType === "string") {
            if (isBase64) {
                data = base64.decode(data);
            }
            else if (isBinary) {
                // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
                if (isOptimizedBinaryString !== true) {
                    // this is a string, not in a base64 format.
                    // Be sure that this is a correct "binary string"
                    data = string2binary(data);
                }
            }
        }
        return data;
    });
};


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takem", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "put", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "race", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "call", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "apply", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cps", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fork", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "spawn", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "join", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "actionChannel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancelled", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["q"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__ = __webpack_require__(918);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["c"]; });




/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billing = exports.integration = exports.contentful = exports.settings = exports.assetLanding = exports.profile = exports.massMessage = exports.connection = exports.admin = exports.masterTemplates = exports.contracting = exports.downloads = exports.fileUrls = exports.historyFeed = exports.workspace = exports.partner = exports.account = exports.callApiwithToken = exports.callApiJWT = exports.callApi = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _locationGraphqlQuery = __webpack_require__(862);

var _profileGraphqlQuery = __webpack_require__(863);

var _graphqlQueries = __webpack_require__(864);

var contractInfoQueries = _interopRequireWildcard(_graphqlQueries);

var _productGraphqlQuery = __webpack_require__(865);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* global window */


// import * as companyGQL from './stores/company/company/company-graphql-query';

var API_ROOT = '/proxy/';
var API_CONTENTFUL = 'https://cdn.contentful.com/';
var API_URL = undefined || "https://rest.tourconnect.com";

var jsonDecode = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
    var jsonRet;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return response.json();

          case 3:
            jsonRet = _context.sent;
            return _context.abrupt('return', jsonRet);

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](0);
            return _context.abrupt('return', {});

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 7]]);
  }));

  return function jsonDecode(_x) {
    return _ref.apply(this, arguments);
  };
}();

var callApi = exports.callApi = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(endpoint) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
    var bodyParam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var useOriginalUrl = arguments[3];
    var fullUrl, body, response, json;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fullUrl = endpoint.indexOf(API_ROOT) === -1 && !useOriginalUrl ? API_ROOT + endpoint : endpoint;
            body = bodyParam ? JSON.stringify(bodyParam) : null;
            response = void 0;
            _context2.prev = 3;
            _context2.next = 6;
            return fetch(fullUrl, {
              method: method,
              credentials: 'same-origin',
              headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
              body: body
            });

          case 6:
            response = _context2.sent;
            _context2.next = 12;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2['catch'](3);

            response = _context2.t0;

          case 12:
            _context2.next = 14;
            return jsonDecode(response);

          case 14:
            json = _context2.sent;

            if (response.ok) {
              _context2.next = 17;
              break;
            }

            return _context2.abrupt('return', {
              error: {
                response: response,
                json: json,
                request: {
                  url: fullUrl,
                  body: body,
                  method: method
                }
              }
            });

          case 17:
            return _context2.abrupt('return', { response: json });

          case 18:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[3, 9]]);
  }));

  return function callApi(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var callApiJWT = exports.callApiJWT = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(endpoint) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
    var bodyParam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var fullUrl, token, body, response, json, newToken;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            fullUrl = /^https?:\/\/*/.test(endpoint) ? endpoint : '' + API_URL + endpoint;
            token = localStorage.getItem('jwt');

            if (token) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt('return', {});

          case 4:
            body = bodyParam ? JSON.stringify(bodyParam) : null;
            response = void 0;
            _context3.prev = 6;
            _context3.next = 9;
            return fetch(fullUrl, {
              method: method,
              credentials: 'same-origin',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
              },
              body: body
            });

          case 9:
            response = _context3.sent;
            _context3.next = 15;
            break;

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3['catch'](6);

            response = _context3.t0;

          case 15:
            _context3.next = 17;
            return jsonDecode(response);

          case 17:
            json = _context3.sent;

            if (response.ok) {
              _context3.next = 21;
              break;
            }

            // if something is wrong with jwt, force reauthenticate
            if (json.code === 'InvalidCredentials') {
              if (json.message.indexOf('jwt expired') > -1) {
                localStorage.removeItem('jwt');
              }
              window.location.assign(window.location.protocol + '//' + window.location.host + '/signin?logout=true');
            }
            return _context3.abrupt('return', {
              error: {
                response: response,
                json: json,
                request: {
                  url: fullUrl,
                  body: body,
                  method: method
                }
              }
            });

          case 21:
            newToken = response.headers.get('new-token');

            if (Boolean(newToken)) localStorage.setItem('jwt', newToken);
            return _context3.abrupt('return', { response: json });

          case 24:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[6, 12]]);
  }));

  return function callApiJWT(_x5) {
    return _ref3.apply(this, arguments);
  };
}();

var callApiwithToken = exports.callApiwithToken = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(endpoint) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
    var bodyParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var fullUrl, body, hashtoken, encryptedemail, response, json;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            fullUrl = /^https?:\/\/*/.test(endpoint) ? endpoint : API_URL + endpoint;
            body = bodyParams ? JSON.stringify(bodyParams) : null;
            hashtoken = sessionStorage.getItem('hashtoken') || '';
            encryptedemail = sessionStorage.getItem('encryptedemail') || '';
            response = void 0;
            _context4.prev = 5;
            _context4.next = 8;
            return fetch(fullUrl, {
              method: method,
              // credentials: 'same-origin',
              // mode: 'no-cors',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                hashtoken: hashtoken,
                encryptedemail: encryptedemail
              },
              body: body
            });

          case 8:
            response = _context4.sent;
            _context4.next = 14;
            break;

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4['catch'](5);

            response = _context4.t0;

          case 14:
            _context4.next = 16;
            return jsonDecode(response);

          case 16:
            json = _context4.sent;

            if (response.ok) {
              _context4.next = 19;
              break;
            }

            return _context4.abrupt('return', {
              error: {
                response: response,
                json: json,
                request: {
                  url: fullUrl,
                  body: body,
                  method: method
                }
              }
            });

          case 19:
            return _context4.abrupt('return', { response: json });

          case 20:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined, [[5, 11]]);
  }));

  return function callApiwithToken(_x8) {
    return _ref4.apply(this, arguments);
  };
}();

// api services
var account = exports.account = {
  getUsersById: function getUsersById(_ref5) {
    var companyId = _ref5.companyId;
    return callApi('/proxy/company/' + companyId + '/users', 'get');
  },
  confirmEmail: function confirmEmail(token) {
    return callApi('/proxy/confirm-signin-email', 'put', { token: token });
  },
  login: function login(payload) {
    return callApi('/signin', 'post', payload, true);
  },
  shellSignUp: function shellSignUp(payload) {
    return callApiwithToken('/contractingSignUp/signUp', 'post', payload);
  },
  loginAsUser: function loginAsUser(payload) {
    return callApi('/loginAsUser', 'post', payload, true);
  },
  sendInternalEmail: function sendInternalEmail(payload) {
    return callApi('/internal/notification', 'post', payload);
  },
  sendNotification: function sendNotification(payload) {
    return callApiJWT('/sendNotification', 'post', payload);
  },
  updateUIpreferences: function updateUIpreferences(payload) {
    return callApiJWT('/updateUIpreferences', 'put', payload);
  }
};

var partner = exports.partner = {
  getCompanyInfo: function getCompanyInfo(_ref6) {
    var partnerId = _ref6.partnerId;
    return callApi('partner/' + partnerId, 'get');
  },
  getActivities: function getActivities(_ref7) {
    var assetId = _ref7.assetId,
        activityType = _ref7.activityType;
    return callApiJWT('/asset-activities/' + assetId + '?activityType=' + (activityType || ''), 'get');
  },
  addConnectionAsPartner: function addConnectionAsPartner(_ref8) {
    var connectionId = _ref8.connectionId,
        targetCompanyId = _ref8.targetCompanyId;
    return callApiJWT('/partner-management/partner/connection', 'post', { connectionId: connectionId, targetCompanyId: targetCompanyId });
  }
};

var workspace = exports.workspace = {
  getConnections: function getConnections() {
    var selectedConnection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return callApi('workspace/connections' + (selectedConnection ? '/' + selectedConnection : ''), 'get');
  },
  archiveConnection: function archiveConnection(connection) {
    return callApi('workspace/connections/' + connection + '/archive', 'get');
  },
  deleteMessage: function deleteMessage(message) {
    return callApi('workspace/message/' + message, 'delete');
  },
  getChannels: function getChannels(connection) {
    var channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var contract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    if (!contract) return callApi('workspace/connections/' + connection + '/channels', 'get');
    return callApi('workspace/connections/' + connection + '/channels/' + channel + '/' + contract, 'get');
  },
  getConversations: function getConversations(assetId, channelId) {
    return callApi('workspace/connections/' + assetId + '/channels/' + channelId + '/conversation', 'get');
  },
  archiveConversation: function archiveConversation(connection, channel, contract) {
    return callApi('workspace/connections/' + connection + '/channels/' + channel + '/archive/' + (contract || ''), 'post');
  },
  newMessage: function newMessage(body) {
    return callApi('workspace/newMessage', 'post', body);
  },
  saveSelectedChannel: function saveSelectedChannel(partnerId, channel) {
    return callApi('workspace/connections/' + partnerId, 'post', { lastChannel: channel });
  },
  conversationsRead: function conversationsRead(_ref9) {
    var assetId = _ref9.assetId,
        _ref9$assetType = _ref9.assetType,
        assetType = _ref9$assetType === undefined ? 'partner' : _ref9$assetType,
        messageId = _ref9.messageId;
    return callApiJWT('/workspace/markRead', 'post', { assetId: assetId, assetType: assetType, messageId: messageId });
  },
  statusMessages: function statusMessages() {
    return callApiJWT('/statusMessages', 'get');
  },
  unreadAcceptedRead: function unreadAcceptedRead(connectionIds) {
    return callApi('/statusMessages/markConnectionAcceptedAsRead', 'post', { connectionIds: connectionIds });
  },
  getActivities: partner.getActivities
};

var historyFeed = exports.historyFeed = {
  getHistory: function getHistory(contractId) {
    return callApi('/proxy/contracting/getHistoryFeed/' + contractId + '/contract', 'get');
  }
};

var fileUrls = exports.fileUrls = {
  getDownloadUrlSync: function getDownloadUrlSync(path) {
    if (path && path.indexOf('/') > -1) return API_ROOT + 's3/file?key=' + encodeURIComponent(path);
    return '/filebyhash/' + path;
  },
  getDownloadTCContractingDoc: function getDownloadTCContractingDoc(_ref10) {
    var docId = _ref10.docId,
        _ref10$collection = _ref10.collection,
        collection = _ref10$collection === undefined ? 'contract' : _ref10$collection,
        locale = _ref10.locale,
        ratesOnly = _ref10.ratesOnly,
        downloadRateFormat = _ref10.downloadRateFormat,
        forAL = _ref10.forAL;

    var url = void 0;
    if (forAL) {
      url = (downloadRateFormat || '').split('_')[0] === 'quickview' ? '/landingproxy/contracting/pipeXls' : '/landingproxy/download-pdf';
    } else {
      url = (downloadRateFormat || '').split('_')[0] === 'quickview' ? '/proxy/contracting/pipeXls' : '/proxy/download-pdf';
    }
    var qs = _queryString2.default.stringify({
      docId: docId,
      locale: locale,
      collection: collection,
      ratesOnly: downloadRateFormat === 'condensed' || ratesOnly,
      type: (downloadRateFormat || '').indexOf('quickview') > -1 ? (downloadRateFormat || '').split('_')[1] : ''
    });
    return url + '?' + qs;
  },
  downloadGroup: function downloadGroup(_ref11) {
    var _ref11$collection = _ref11.collection,
        collection = _ref11$collection === undefined ? 'contract' : _ref11$collection,
        locale = _ref11.locale,
        downloadRateFormat = _ref11.downloadRateFormat,
        forAL = _ref11.forAL,
        docIds = _ref11.docIds;

    var qs = _queryString2.default.stringify({
      locale: locale,
      collection: collection,
      downloadRateFormat: downloadRateFormat
    });
    var url = '/contracting/download-group?' + qs;
    var params = { docIds: docIds };
    var callFunc = forAL ? callApiwithToken : callApiJWT;
    return callFunc(url, 'post', params);
  },
  checkJobUrl: function checkJobUrl(_ref12) {
    var jobUrl = _ref12.jobUrl,
        forAL = _ref12.forAL;

    var callFunc = forAL ? callApiwithToken : callApiJWT;
    return callFunc(jobUrl, 'get');
  }
};

var downloads = exports.downloads = {
  downloadTCContractingDoc: function downloadTCContractingDoc(payload) {
    // window.open(fileUrls.getDownloadTCContractingDoc(payload));
    var downloadUrl = fileUrls.getDownloadTCContractingDoc(payload);
    var a = document.createElement('a');
    a.download = true;
    a.target = '_blank';
    a.setAttribute('download', true);
    a.href = downloadUrl;
    a.dispatchEvent(new MouseEvent('click'));
  },
  getXls: function getXls(docType, docId, exportType) {
    return callApi('contracting/exportXls/' + docType + '/' + docId + '?type=' + exportType, 'get');
  }
};

var contracting = {
  deleteOrUndelete: function deleteOrUndelete(params) {
    return callApi('/proxy/contracting/deleteOrUndelete', 'put', params);
  }, // params: { contractIds, state: <true or false> } true means delete, false means restore
  getContractList: function getContractList(params) {
    return callApiJWT('/contracting/contracts', 'post', params);
  },
  checkContractReadiness: function checkContractReadiness(draftId) {
    return callApiJWT('/contracting/checkContractReadiness/' + draftId, 'put');
  },
  getRespondedContractList: function getRespondedContractList(_ref13) {
    var requestId = _ref13.requestId;
    return callApiJWT('/contracting/request/' + requestId + '/contracts', 'get');
  },
  getContractRequestInfo: function getContractRequestInfo(_ref14) {
    var requestId = _ref14.requestId;

    return callApiJWT('/contracting/getContractInfo/' + requestId, 'post', {
      query: '\n          query getContract ($contractId: ID!, $viewerId: ID!, $viewBy: String!) {\n            Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy) {\n              contractId\n              startDate\n              endDate\n              supplierId\n              buyerId\n              buyerChecked\n              buyerInfo {\n                submissionCriteria\n                termsAndConditions\n              }\n              partners {\n                id\n                name\n                avatar\n                tags {\n                  id\n                  name\n                }\n                contacts {\n                  firstName\n                  lastName\n                  email\n                  id\n                }\n              }\n              contacts {\n                id\n                firstName\n                lastName\n                email\n              }\n              from {\n                avatar\n                name\n                email\n              }\n              to {\n                avatar\n                name\n                partnerId\n                contactIds\n              }\n            }\n          }\n        ',
      contractId: requestId,
      collection: 'contract'
    });
  },
  getContractPartners: function getContractPartners(_ref15) {
    var contractId = _ref15.contractId;

    return callApiJWT('/contracting/getContractInfo/' + contractId, 'post', {
      query: '\n          query getContract ($contractId: ID!, $viewerId: ID!, $viewBy: String!) {\n            Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy) {\n              partners {\n                id\n                name\n                tags {\n                  id\n                  name\n                }\n                contacts {\n                  id\n                  firstName\n                  lastName\n                  email\n                }\n              }\n            }\n          }\n        ',
      contractId: contractId,
      collection: 'contract'
    });
  },
  getContractInfo: function getContractInfo(_ref16) {
    var collection = _ref16.collection,
        docId = _ref16.docId,
        type = _ref16.type,
        forAL = _ref16.forAL;

    // type: 'metaData', 'content'
    var callFunc = forAL ? callApi : callApiJWT;
    return callFunc((forAL ? '/landingproxy' : '') + '/contracting/getContractInfo/' + docId, 'post', {
      query: function () {
        if (type === 'policyNotes') {
          return collection === 'contract' || collection === 'workspace' ? contractInfoQueries.getContractDetailsQuery : contractInfoQueries.draftTemplateContractDetails;
        }
        return collection === 'contract' || collection === 'workspace' ? contractInfoQueries.getLeftNavQuery : contractInfoQueries.draftTemplateLeftNav;
      }(),
      contractId: docId,
      collection: collection === 'workspace' ? 'contract' : collection
    }, true);
  },
  getContractProductInfo: function getContractProductInfo(_ref17) {
    var docId = _ref17.docId,
        productId = _ref17.productId,
        ratePackage = _ref17.ratePackage,
        collection = _ref17.collection;

    return callApiJWT('/contracting/getProductInfo/' + docId + '/' + productId + '/' + ratePackage, 'post', {
      query: collection === 'contract' || collection === 'workspace' ? contractInfoQueries.getProductDetailsQuery : contractInfoQueries.draftTemplateProductQuery,
      contractId: docId,
      productId: productId,
      collection: collection === 'workspace' ? 'contract' : collection
    });
  },
  manageExtrasOffers: function manageExtrasOffers(_ref18) {
    var draftId = _ref18.draftId,
        list = _ref18.list,
        type = _ref18.type;

    return callApiJWT('/contracting/contract/product/shared-data', 'put', { draftId: draftId, list: list, type: type });
  },
  archiveUnarchiveTemplate: function archiveUnarchiveTemplate(_ref19) {
    var templateId = _ref19.templateId,
        isArchived = _ref19.isArchived;
    return callApi('/proxy/contracting/template/' + templateId + '/archiveUnarchive', 'put', { isArchived: isArchived });
  },
  updateFolders: function updateFolders(_ref20) {
    var folders = _ref20.folders,
        originalFolder = _ref20.originalFolder,
        newFolderName = _ref20.newFolderName;

    return callApi('/proxy/contracting/contract-list/folder', 'put', { folders: folders, originalFolder: originalFolder, newFolderName: newFolderName });
  },
  updatePartnerForSentDoc: function updatePartnerForSentDoc(_ref21) {
    var contractId = _ref21.contractId,
        extraPayload = _objectWithoutProperties(_ref21, ['contractId']);

    return callApi('/proxy/contracting/contract/' + contractId + '/partner', 'put', extraPayload);
  },
  addFilesToContract: function addFilesToContract(_ref22) {
    var contractId = _ref22.contractId,
        files = _ref22.files,
        msgId = _ref22.msgId;
    return callApi('/proxy/contracting/contract/files', 'post', { contractId: contractId, files: files, msgId: msgId });
  },
  submitContractingComment: function submitContractingComment(_ref23) {
    var historyFeedId = _ref23.historyFeedId,
        payload = _objectWithoutProperties(_ref23, ['historyFeedId']);

    return callApi('/proxy/contracting/saveComment/' + historyFeedId, 'put', payload);
  },
  getContractForwardingEmail: function getContractForwardingEmail(contractId) {
    return callApi('/proxy/contracting/contract/forwardingemail', 'post', { contractId: contractId });
  },
  getDiffReport: function getDiffReport(_ref24) {
    var docs = _ref24.docs,
        onlyGetSummary = _ref24.onlyGetSummary;
    return callApi('/proxy/contracting/report/diff/' + docs + '?onlyGetSummary=' + onlyGetSummary, 'get');
  },
  /*
  * difference between getTemplates and getTemplateList
  *
  * getTemplates only provides completed templates and template groups,
  * and is currently being used in send rates wizard
  *
  * getTemplateList provides all templates, initial drafts, and template groups
  * */
  getTemplates: function getTemplates(_ref25) {
    var query = _ref25.query;

    var qs = query ? _queryString2.default.stringify({ additionalQuery: JSON.stringify(query) }) : '';
    return callApi('/proxy/contracting/templates?' + qs);
  },
  getTemplateList: function getTemplateList() {
    return callApi('/proxy/contracting/template-list?');
  },
  getTemplatesForLocOrCC: function getTemplatesForLocOrCC(_ref26) {
    var locationId = _ref26.locationId,
        searchInput = _ref26.searchInput;

    return callApi('/proxy/contracting/location/' + locationId + '/templates?searchInput=' + searchInput);
  },
  getContracts: function getContracts(_ref27) {
    var query = _ref27.query,
        _ref27$includeTemplat = _ref27.includeTemplateNames,
        includeTemplateNames = _ref27$includeTemplat === undefined ? false : _ref27$includeTemplat;

    var qs = query ? _queryString2.default.stringify({ additionalQuery: JSON.stringify(query), includeTemplateNames: includeTemplateNames }) : '';
    return callApi('/proxy/contracting/contracts?' + qs);
  },
  getFolders: function getFolders() {
    return callApi('/proxy/contracting/contract-list/folder');
  },
  sendContract: function sendContract(_ref28) {
    var payload = _ref28.payload;
    return callApi('contracting/supplier/sendContracts', 'post', payload);
  },
  sendContractRequest: function sendContractRequest(_ref29) {
    var payload = _ref29.payload;
    return callApi('contracting/request', 'post', payload);
  },
  supplierSendUpdates: function supplierSendUpdates(_ref30) {
    var templateIds = _ref30.templateIds,
        subject = _ref30.subject;
    return callApi('contracting/supplier-updates', 'post', { templateIds: templateIds, subject: subject });
  },
  updateSameAsCorporatePolicyNotes: function updateSameAsCorporatePolicyNotes(_ref31) {
    var templateDraftId = _ref31.templateDraftId,
        sameAsCorporatePolicyNotes = _ref31.sameAsCorporatePolicyNotes;
    return callApi('/proxy/contracting/draft/sameAsCorporatePolicyNotes', 'put', { templateDraftId: templateDraftId, sameAsCorporatePolicyNotes: sameAsCorporatePolicyNotes });
  },
  removePolicyNotesTemplate: function removePolicyNotesTemplate(templateDraftId) {
    return callApi('/proxy/contracting/draft/policyNotesTemplate/' + templateDraftId, 'delete');
  },
  contractFromHF: function contractFromHF(payload) {
    return callApi('contracting/contractIdFromHistoryFeedId/' + payload.historyFeedId, 'post', payload);
  },
  addDraftToQueue: function addDraftToQueue(_ref32) {
    var templateId = _ref32.templateId,
        source = _ref32.source,
        sourceId = _ref32.sourceId,
        message = _ref32.message;
    return callApi('/proxy/contracting/supplier-updates/queue', 'post', {
      templateId: templateId,
      source: source,
      sourceId: sourceId,
      message: message
    });
  },
  removeDraftOutOfQueue: function removeDraftOutOfQueue(_ref33) {
    var templateId = _ref33.templateId,
        sourceId = _ref33.sourceId;
    return callApi('/proxy/contracting/supplier-updates/queue', 'delete', {
      templateId: templateId,
      sourceId: sourceId
    });
  },
  removeSingleFeedByTCAdmin: function removeSingleFeedByTCAdmin(_ref34) {
    var messageId = _ref34.messageId,
        historyFeedId = _ref34.historyFeedId;
    return callApi('/proxy/asset-activity/' + messageId, 'put', {
      assetId: historyFeedId
    });
  },
  fileContractForRequest: function fileContractForRequest(_ref35) {
    var requestId = _ref35.requestId,
        contractId = _ref35.contractId;
    return callApi('/proxy/contracting/buyer/fileContractForRequest', 'post', {
      requestId: requestId,
      contractId: contractId
    });
  },
  removeContractsFromRequests: function removeContractsFromRequests(_ref36) {
    var requestId = _ref36.requestId,
        contractIds = _ref36.contractIds;
    return callApi('/proxy/contracting/buyer/removeContractsFromRequests', 'post', {
      requestId: requestId,
      contractIds: contractIds
    });
  },
  updateContractStatus: function updateContractStatus(payload) {
    return callApi(payload.forAL ? '/landingproxy/contracting/updateContractStatus' : '/proxy/contracting/updateContractStatus', 'put', payload, true);
  },
  requestDL: function requestDL(payload) {
    return callApiJWT('/contracting/requestDL', 'put', payload);
  },
  getTemplateChangeLog: function getTemplateChangeLog(threadId, search) {
    return callApiJWT('/contracting/template/logs/' + threadId + search, 'get');
  },
  createTemplatesInDummyAcct: function createTemplatesInDummyAcct(payload) {
    return callApiJWT('/contracting/cr-dl/start', 'post', payload);
  },
  acceptDummyTemplate: function acceptDummyTemplate(payload) {
    return callApiJWT('/contracting/dummy/template/accept', 'put', payload);
  },
  sendRCMsg: function sendRCMsg(payload) {
    return callApiJWT('/contracting/send-rc-msg', 'post', payload);
  },
  // update data in the rate container/request that's only for the buyer
  updateWorkspaceContract: function updateWorkspaceContract(payload) {
    return callApiJWT('/contracting/workspace-contract', 'put', payload);
  },
  submitRCRates: function submitRCRates(payload) {
    return callApiJWT('/contracting/submitRCRates', 'post', payload);
  },
  createTemplateDraft: function createTemplateDraft(payload) {
    return callApiJWT('/contracting/draft/' + payload.contractId, 'post', payload);
  },
  createEditedDraftForBuyer: function createEditedDraftForBuyer(payload) {
    return callApiJWT('/contracting/buyer/draft', 'post', payload);
  },
  omniImport: function omniImport(payload) {
    return callApiJWT('/contracting/template/omniimport', 'put', payload);
  },
  deleteTemplateDraft: function deleteTemplateDraft(payload) {
    return callApiJWT('/contracting/template/draft', 'delete', payload);
  },
  loadDataForIframe: function loadDataForIframe(payload) {
    return callApiJWT('/contracting/getContractInfo/' + payload.rateDocId, 'post', {
      query: '\n          query getContract ($contractId: ID!, $collection: String!, $viewerId: ID!, $viewBy: String!) {\n            DraftnTemplate (id: $contractId, collection: $collection, viewerId: $viewerId, viewBy: $viewBy) {\n              completionPercent\n              acceptedBy\n              crIds\n              ownerIds\n              defaultInvitees\n              signatures {\n                 invitee\n                 inviteSentAt\n                 signedBy\n                 signedAt\n              }\n              originFrom\n              draftType\n              editHistory {\n                detail\n                productId\n                ratePackageName\n              }\n            }\n          }\n        ',
      contractId: payload.rateDocId,
      collection: payload.collection
    });
  },
  deleteEditedDraft: function deleteEditedDraft(originalContractId) {
    return callApiJWT('/contracting/discardEditedDraft/' + originalContractId, 'delete');
  },
  updateProductNameBeddingConfig: function updateProductNameBeddingConfig(payload) {
    return callApiJWT('/contracting/updateProductNameBeddingConfig', 'put', payload);
  },
  makeACopyForBuyer: function makeACopyForBuyer(payload) {
    return callApiJWT('/contracting/buyer/makeACopy', 'post', payload);
  },
  resendContract: function resendContract(payload) {
    return callApiJWT('/contracting/resendContract/' + payload.contractId, 'put', payload);
  }
};

exports.contracting = contracting;
var masterTemplates = exports.masterTemplates = {
  getAll: function getAll(type) {
    return callApi('/proxy/contracting/master-templates/' + type, 'get');
  },
  getOne: function getOne(id) {
    return callApi('/proxy/contracting/master-template/' + id, 'get');
  },
  getDiff: function getDiff(_ref37) {
    var lhsDocId = _ref37.lhsDocId,
        rhsDocId = _ref37.rhsDocId,
        onlyGetSummary = _ref37.onlyGetSummary;
    return callApi('/proxy/contracting/master-template-diff', 'post', { lhsDocId: lhsDocId, rhsDocId: rhsDocId, onlyGetSummary: onlyGetSummary });
  },
  createInitial: function createInitial(_ref38) {
    var type = _ref38.type,
        templateName = _ref38.templateName;
    return callApi('/proxy/contracting/initial-master-template-draft', 'post', { type: type, templateName: templateName });
  },
  createEditedDraft: function createEditedDraft(id) {
    return callApi('/proxy/contracting/edited-master-template-draft', 'post', { id: id });
  },
  edit: function edit(id, updates) {
    return callApi('/proxy/contracting/master-template/edit/' + id, 'put', { updates: updates });
  },
  finalise: function finalise(draftId) {
    return callApi('/proxy/contracting/master-template/finalise', 'put', { draftId: draftId });
  },
  applyMasterToTemplates: function applyMasterToTemplates(_ref39) {
    var masterTemplateId = _ref39.masterTemplateId,
        type = _ref39.type,
        templateDraftIds = _ref39.templateDraftIds,
        sameAsCorporatePolicyNotes = _ref39.sameAsCorporatePolicyNotes,
        honorPreloadContent = _ref39.honorPreloadContent;
    return callApi('/proxy/contracting/master-template/associate/templates', 'put', {
      masterTemplateId: masterTemplateId,
      type: type,
      templateDraftIds: templateDraftIds,
      sameAsCorporatePolicyNotes: sameAsCorporatePolicyNotes,
      honorPreloadContent: honorPreloadContent
    });
  },
  discardDraft: function discardDraft(draftId) {
    return callApi('/proxy/contracting/master-template-draft/' + draftId, 'delete');
  },
  getAssociatedTemplates: function getAssociatedTemplates(_ref40) {
    var id = _ref40.id,
        type = _ref40.type;
    return callApi('/proxy/contracting/master-template/templates', 'post', { id: id, type: type });
  },
  renameTemplate: function renameTemplate(_ref41) {
    var id = _ref41.id,
        newName = _ref41.newName;
    return callApi('/proxy/contracting/master-template/name', 'put', { id: id, newName: newName });
  },
  deleteTemplate: function deleteTemplate(_ref42) {
    var id = _ref42.id;
    return callApi('/proxy/contracting/master-template/' + id, 'delete');
  },
  getAffectedBuyers: function getAffectedBuyers(id) {
    return callApi('/proxy/contracting/master-template/buyers/' + id, 'get');
  }
};

var admin = exports.admin = {
  toogleTourWriter: function toogleTourWriter(companyId, enabled) {
    return callApi('/proxy/admin/toggleTourWriter', 'post', { companyId: companyId, enabled: enabled });
  },
  toogleTourplan: function toogleTourplan(companyId, enabled) {
    return callApi('/proxy/admin/toggleTourplan', 'post', { companyId: companyId, enabled: enabled });
  },
  convertUserToAssociatedEmail: function convertUserToAssociatedEmail(userId) {
    return callApi('/proxy/admin/turnUserIntoAssociatedEmail', 'post', { userId: userId });
  },
  consolidateAccount: function consolidateAccount(email, companyId, associateEmail) {
    return callApi('/proxy/admin/consolidate', 'post', { email: email, companyId: companyId, associateEmail: associateEmail, getList: false });
  },
  consolidateAccountTest: function consolidateAccountTest(email, companyId) {
    return callApi('/proxy/admin/consolidate', 'post', { email: email, companyId: companyId, getList: true });
  },
  updatePropertyNameForContractingDocs: function updatePropertyNameForContractingDocs(payload) {
    return callApi('/proxy/admin/contracting/docs', 'put', payload);
  },
  getSignedToken: function getSignedToken(payload) {
    return callApi('/proxy/admin/getSignedToken', 'post', payload);
  },
  getSessionInfo: function getSessionInfo() {
    return callApi('/getSessionInfo', 'get', null, true);
  },
  getDLQueue: function getDLQueue() {
    return callApi('/proxy/dl-queue', 'get');
  },
  updateTemplateInQueue: function updateTemplateInQueue(payload) {
    return callApi('/proxy/dl-queue/template', 'put', payload);
  },
  addNote: function addNote(payload) {
    return callApi('/proxy/dl-queue/note', 'post', payload);
  },
  addTemplate: function addTemplate(id) {
    return callApi('/proxy/dl-queue/template', 'post', { id: id });
  },
  deleteTemplateFromQueue: function deleteTemplateFromQueue(templateId) {
    return callApi('/proxy/dl-queue/template/' + templateId, 'delete');
  },
  deleteSupplierFromQueue: function deleteSupplierFromQueue(supplierId) {
    return callApi('/proxy/dl-queue/supplier/' + supplierId, 'delete');
  },
  toggleTCVerified: function toggleTCVerified(payload) {
    return callApi('admin/toggleTCVerified', 'post', payload);
  },
  resendBulkMessage: function resendBulkMessage(payload) {
    return callApi('admin/resendBulkMessage', 'post', payload);
  }
};

var connection = exports.connection = {
  pendingInvites: function pendingInvites(payload) {
    return callApi('/proxy/connections?status=invites&get=' + payload.get, 'get');
  }
};

var massMessage = exports.massMessage = {
  newMessage: function newMessage(body) {
    return callApi('workspace/newMassMessage', 'post', body);
  },
  getPartners: function getPartners() {
    return callApi('partners', 'get');
  }
};

var profile = exports.profile = {
  getUserLocationProfile: function getUserLocationProfile() {
    var _ref43 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        locationId = _ref43.locationId;

    var qs = _queryString2.default.stringify({ query: _locationGraphqlQuery.myLocationProfileQuery });
    return callApi('/proxy/profile/locations/' + locationId + '?' + qs, 'get');
  },
  getCompanyProfile: function getCompanyProfile() {
    return callApi('/proxy/profile?query=' + _profileGraphqlQuery.profileQuery, 'get');
  },
  updateGroup: function updateGroup(payload) {
    return callApi('/proxy/profile/group', 'put', payload);
  },
  deleteGroup: function deleteGroup(payload) {
    return callApi('/proxy/profile/group', 'delete', payload);
  },
  reorderLocations: function reorderLocations(locationIds) {
    return callApi('/proxy/profile/reorderLocations', 'put', { locationIds: locationIds });
  },
  reorderProducts: function reorderProducts(productIds) {
    return callApi('/proxy/profile/reorderProducts', 'put', { productIds: productIds });
  },
  editProductField: function editProductField(_ref44) {
    var updateField = _ref44.updateField,
        updateBody = _ref44.updateBody,
        productId = _ref44.productId,
        locationId = _ref44.locationId;

    var body = updateBody;
    if ((updateField === 'coverImageUrl' || updateField === 'profileImageUrl') && updateBody) {
      body += '?' + Date.now();
    }
    return callApiJWT('/profile/products/' + productId + '?mutation=' + _productGraphqlQuery.myProductMutation, 'put', {
      locationId: locationId,
      update: _defineProperty({}, updateField, body)
    });
  }
};

var assetLanding = exports.assetLanding = {
  ezLoadRequest: function ezLoadRequest(payload) {
    return callApiwithToken('/dl-queue/supplier', 'post', {
      supplierId: payload.supplierId,
      files: payload.files,
      requests: payload.requests,
      email: payload.email
    });
  },
  sendExternalRates: function sendExternalRates(payload) {
    return callApiwithToken('/landing/sendExternalRates', 'post', {
      subject: payload.subject,
      message: payload.message,
      files: payload.files,
      requests: payload.requests,
      userId: payload.userId,
      fromEmail: payload.fromEmail,
      supplierId: payload.supplierId
    });
  },
  authByToken: function authByToken() {
    var hashToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'oldUrl';
    var encryptedEmail = arguments[1];
    return callApi('/authByToken', 'post', { hashToken: hashToken, encryptedEmail: encryptedEmail }, true);
  },
  verifyToken: function verifyToken() {
    var hashToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'oldUrl';
    var oldUrlPayload = arguments[1];
    return callApiwithToken('/verifyToken/' + hashToken, 'post', { oldUrlPayload: oldUrlPayload });
  },
  getAssets: function getAssets(senderId) {
    return callApiwithToken('/landing/assets?senderId=' + senderId, 'get', null);
  },
  // TODO: replace with real endpoint
  checkDummyAccount: function checkDummyAccount(payload) {
    return callApiwithToken('/landing/checkDummyAccount?hashToken=' + payload.shortid + '&contractId=' + payload.contractId, 'get');
  },
  signRateDocs: function signRateDocs(payload) {
    return callApiwithToken('/contracting/submitRCRates', 'post', payload);
  },
  markDummyTemplateAsViewed: function markDummyTemplateAsViewed(payload) {
    return callApiwithToken('/contracting/dummy/template/viewed', 'put', payload);
  }
};

var settings = exports.settings = {
  getSettings: function getSettings() {
    return callApi('settings', 'get');
  },
  saveSettings: function saveSettings(payload) {
    return callApi('settings', 'put', payload);
  }
};

// Contentful for sidebar

var buildURLQuery = function buildURLQuery(obj) {
  return Object.entries(obj).map(function (pair) {
    return pair.map(encodeURIComponent).join('=');
  }).join('&');
};

function contentfulApi() {
  var _ref45 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref45$accessToken = _ref45.accessToken,
      accessToken = _ref45$accessToken === undefined ? '' + "5829e984567fa554706e6cfed3a025cfcf1df1d9a1495ef9b32962299e4400ac" : _ref45$accessToken,
      _ref45$bodyParam = _ref45.bodyParam,
      bodyParam = _ref45$bodyParam === undefined ? null : _ref45$bodyParam,
      endpoint = _ref45.endpoint,
      _ref45$environment = _ref45.environment,
      environment = _ref45$environment === undefined ? 'master' : _ref45$environment,
      _ref45$method = _ref45.method,
      method = _ref45$method === undefined ? 'get' : _ref45$method,
      _ref45$searchParams = _ref45.searchParams,
      searchParams = _ref45$searchParams === undefined ? {} : _ref45$searchParams,
      _ref45$space = _ref45.space,
      space = _ref45$space === undefined ? 'wwevjgfp8hg4' : _ref45$space;

  searchParams.access_token = accessToken;
  var fullUrl = API_CONTENTFUL + 'spaces/' + space + '/environments/' + environment + '/' + endpoint + '?' + buildURLQuery(searchParams);
  var body = bodyParam ? JSON.stringify(bodyParam) : null;
  return fetch(fullUrl, {
    method: method,
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: body
  }).then(function (response) {
    return response.json().then(function (json) {
      return { json: json, response: response };
    });
  }).then(function (_ref46) {
    var json = _ref46.json,
        response = _ref46.response;

    if (!response.ok) {
      return Promise.reject(json);
    }
    if (Array.isArray(json)) return json;
    return _extends({}, json);
  }).then(function (response) {
    return { response: response };
  }, function (error) {
    return { error: error || 'Something bad happened' };
  });
}

var contentful = exports.contentful = {
  sidebarHelp: {
    getAllEntries: function getAllEntries() {
      return contentfulApi({ endpoint: 'entries', searchParams: { content_type: 'sidebarHelp', select: 'sys.id,fields.matchingUrls,fields.matchingRole,fields.title' } });
    },
    getHelp: function getHelp(articleId) {
      return contentfulApi({ endpoint: 'entries', searchParams: { content_type: 'sidebarHelp', 'sys.id': articleId } });
    }
  }
};

var integration = exports.integration = {
  saveExportResponse: function saveExportResponse(payload) {
    return callApiJWT('/integration/saveExportResponse', 'post', payload);
  },
  getJobStatus: function getJobStatus(payload) {
    return callApi('/integrationproxy/jobStatus?jobId=' + payload.jobId, 'get', null, true);
  }
};

var billing = exports.billing = {
  getInvoices: function getInvoices(payload) {
    return callApiJWT('/billing/invoices?starting_after=' + (payload.starting_after || '') + '&ending_before=' + (payload.ending_before || ''), 'get');
  }
};

/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _theming = __webpack_require__(1100);

Object.defineProperty(exports, 'ThemeProvider', {
  enumerable: true,
  get: function get() {
    return _theming.ThemeProvider;
  }
});
Object.defineProperty(exports, 'withTheme', {
  enumerable: true,
  get: function get() {
    return _theming.withTheme;
  }
});
Object.defineProperty(exports, 'createTheming', {
  enumerable: true,
  get: function get() {
    return _theming.createTheming;
  }
});

var _JssProvider = __webpack_require__(1435);

Object.defineProperty(exports, 'JssProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_JssProvider)['default'];
  }
});

var _jss = __webpack_require__(910);

Object.defineProperty(exports, 'jss', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_jss)['default'];
  }
});
Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _jss.SheetsRegistry;
  }
});
Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _jss.createGenerateClassNameDefault;
  }
});

var _injectSheet = __webpack_require__(1438);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_injectSheet)['default'];
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, exports) {

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
module.exports = Array.isArray || function _isArray(val) {
  return (val != null &&
          val.length >= 0 &&
          Object.prototype.toString.call(val) === '[object Array]');
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x :
    {
      '@@transducer/value': x,
      '@@transducer/reduced': true
    };
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = rootSaga;
exports.checkUpload = checkUpload;
exports.apiSaga = apiSaga;
exports.zipDownloadContracts = zipDownloadContracts;
exports.zipDownloadTemplates = zipDownloadTemplates;

var _effects = __webpack_require__(36);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _jszip = __webpack_require__(587);

var _jszip2 = _interopRequireDefault(_jszip);

var _jszipUtils = __webpack_require__(606);

var _jszipUtils2 = _interopRequireDefault(_jszipUtils);

var _fileSaver = __webpack_require__(607);

var _sagas = __webpack_require__(954);

var _sagas2 = _interopRequireDefault(_sagas);

var _sagas3 = __webpack_require__(955);

var _sagas4 = _interopRequireDefault(_sagas3);

var _sagas5 = __webpack_require__(956);

var _sagas6 = _interopRequireDefault(_sagas5);

var _sagas7 = __webpack_require__(957);

var _sagas8 = __webpack_require__(958);

var _sagas9 = __webpack_require__(609);

var _sagas10 = _interopRequireDefault(_sagas9);

var _saga = __webpack_require__(960);

var _saga2 = _interopRequireDefault(_saga);

var _sagas11 = __webpack_require__(961);

var _sagas12 = _interopRequireDefault(_sagas11);

var _sagas13 = __webpack_require__(962);

var _sagas14 = _interopRequireDefault(_sagas13);

var _saga3 = __webpack_require__(963);

var _saga4 = _interopRequireDefault(_saga3);

var _sagas15 = __webpack_require__(964);

var _sagas16 = _interopRequireDefault(_sagas15);

var _sagas17 = __webpack_require__(965);

var _sagas18 = _interopRequireDefault(_sagas17);

var _sagas19 = __webpack_require__(969);

var _sagas20 = _interopRequireDefault(_sagas19);

var _thirdPartyTracking = __webpack_require__(970);

var _thirdPartyTracking2 = _interopRequireDefault(_thirdPartyTracking);

var _sagas21 = __webpack_require__(971);

var _sagas22 = _interopRequireDefault(_sagas21);

var _sagas23 = __webpack_require__(972);

var _sagas24 = _interopRequireDefault(_sagas23);

var _sagas25 = __webpack_require__(973);

var _sagas26 = _interopRequireDefault(_sagas25);

var _integrationSagas = __webpack_require__(974);

var _integrationSagas2 = _interopRequireDefault(_integrationSagas);

var _billingSagas = __webpack_require__(975);

var _billingSagas2 = _interopRequireDefault(_billingSagas);

var _s3Upload = __webpack_require__(564);

var _s3Upload2 = _interopRequireDefault(_s3Upload);

var _api = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(refreshDataInPage),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(handleDummyTemplateErrors),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(updateUIpreferences),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(rootSaga),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(checkUpload),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(apiSaga),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(getBinaryContent),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(generateZipAsync),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(updateDownloadCountNFinalise),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(zipDownloadContracts),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(zipDownloadTemplates);

function refreshDataInPage() {
  var _ref, crId;

  return regeneratorRuntime.wrap(function refreshDataInPage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(window.location.href.indexOf('assets-landing-signing') > -1)) {
            _context.next = 8;
            break;
          }

          _context.next = 3;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 3:
          _ref = _context.sent;
          crId = _ref.crId;

          if (!crId) {
            _context.next = 8;
            break;
          }

          _context.next = 8;
          return (0, _sagas25.refreshPolicyNotes)({ args: [{ crId: crId }] });

        case 8:
          if (!(window.location.pathname.indexOf('/contracting/contract/') === 0 || window.location.pathname.indexOf('/contracting/draft/') === 0 || window.location.pathname.indexOf('/contracting/workspace/') === 0)) {
            _context.next = 11;
            break;
          }

          _context.next = 11;
          return (0, _sagas9.refreshContractDoc)({ bgRefresh: true });

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function handleDummyTemplateErrors(_ref2) {
  var error = _ref2.error;
  return regeneratorRuntime.wrap(function handleDummyTemplateErrors$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!(error.message === 'Not Authorized to This Doc')) {
            _context2.next = 3;
            break;
          }

          _context2.next = 3;
          return (0, _effects.put)({
            type: 'GET_CONTRACT_INFO_ERROR',
            payload: {
              errorOccurs: window.location.href.indexOf("https://sec.tourconnect.com") > -1 ? 'In order to protect the security and integrity of rate data, you can only have one rate sheet open at a time.' : 'Something is wrong, please close the tab and reopen.'
            }
          });

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function updateUIpreferences(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  return regeneratorRuntime.wrap(function updateUIpreferences$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return apiSaga(type, _api.account.updateUIpreferences, [payload]);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

/* Sagas from components export */

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return [(0, _effects.takeLatest)('REFRESH_DATA_IN_PAGE_BACKGROUND', refreshDataInPage), (0, _effects.takeLatest)('{rates-draft} REFRESH_LEFT_NAV_ERROR', handleDummyTemplateErrors), (0, _effects.takeLatest)('updateUIpreferences', updateUIpreferences)].concat(_sagas7.workspaceSagas).concat(_sagas2.default).concat(_sagas10.default).concat(_sagas8.massMessageSagas).concat(_sagas12.default).concat(_sagas14.default).concat(_saga4.default).concat(_sagas16.default).concat(_sagas20.default).concat(_thirdPartyTracking2.default).concat(_sagas18.default).concat(_sagas4.default).concat(_sagas6.default).concat(_sagas22.default).concat(_saga2.default).concat(_sagas24.default).concat(_sagas26.default).concat(_integrationSagas2.default).concat(_billingSagas2.default).concat([]);

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

/* Saga Utils */

// checks if a value is an uploadable File class
function checkUpload(val, type) {
  var retval;
  return regeneratorRuntime.wrap(function checkUpload$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)({ type: type + '_S3UPLOAD_STARTED' });

        case 2:
          _context5.next = 4;
          return _s3Upload2.default.s3uploadPromise(val);

        case 4:
          retval = _context5.sent;
          _context5.next = 7;
          return (0, _effects.put)({ type: type + '_S3UPLOAD_SUCCESS', payload: retval });

        case 7:
          return _context5.abrupt('return', retval);

        case 8:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

// generic API call wrapper
function apiSaga(type, fn, args) {
  var nuArgs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, arg, item, key, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, val, _item, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _val, _ref4, response, error, url, errorStr;

  return regeneratorRuntime.wrap(function apiSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)({ type: type + '_STARTED', args: args });

        case 2:

          // look for files and upload them
          nuArgs = [];
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context6.prev = 6;
          _iterator = args[Symbol.iterator]();

        case 8:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context6.next = 106;
            break;
          }

          arg = _step.value;

          if (!((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null && !Array.isArray(arg))) {
            _context6.next = 64;
            break;
          }

          item = {};
          _context6.t0 = regeneratorRuntime.keys(arg);

        case 13:
          if ((_context6.t1 = _context6.t0()).done) {
            _context6.next = 61;
            break;
          }

          key = _context6.t1.value;

          if (!Array.isArray(arg[key])) {
            _context6.next = 52;
            break;
          }

          item[key] = [];
          _iteratorNormalCompletion2 = true;
          _didIteratorError2 = false;
          _iteratorError2 = undefined;
          _context6.prev = 20;
          _iterator2 = arg[key][Symbol.iterator]();

        case 22:
          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
            _context6.next = 36;
            break;
          }

          val = _step2.value;

          if (!(val instanceof File)) {
            _context6.next = 32;
            break;
          }

          _context6.t2 = item[key];
          _context6.next = 28;
          return checkUpload(val, type);

        case 28:
          _context6.t3 = _context6.sent;

          _context6.t2.push.call(_context6.t2, _context6.t3);

          _context6.next = 33;
          break;

        case 32:
          item[key].push(val);

        case 33:
          _iteratorNormalCompletion2 = true;
          _context6.next = 22;
          break;

        case 36:
          _context6.next = 42;
          break;

        case 38:
          _context6.prev = 38;
          _context6.t4 = _context6['catch'](20);
          _didIteratorError2 = true;
          _iteratorError2 = _context6.t4;

        case 42:
          _context6.prev = 42;
          _context6.prev = 43;

          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }

        case 45:
          _context6.prev = 45;

          if (!_didIteratorError2) {
            _context6.next = 48;
            break;
          }

          throw _iteratorError2;

        case 48:
          return _context6.finish(45);

        case 49:
          return _context6.finish(42);

        case 50:
          _context6.next = 59;
          break;

        case 52:
          if (!(arg[key] instanceof File)) {
            _context6.next = 58;
            break;
          }

          _context6.next = 55;
          return checkUpload(arg[key], type);

        case 55:
          item[key] = _context6.sent;
          _context6.next = 59;
          break;

        case 58:
          item[key] = arg[key];

        case 59:
          _context6.next = 13;
          break;

        case 61:
          nuArgs.push(item);
          _context6.next = 103;
          break;

        case 64:
          if (!Array.isArray(arg)) {
            _context6.next = 102;
            break;
          }

          _item = [];
          _iteratorNormalCompletion3 = true;
          _didIteratorError3 = false;
          _iteratorError3 = undefined;
          _context6.prev = 69;
          _iterator3 = arg[Symbol.iterator]();

        case 71:
          if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
            _context6.next = 85;
            break;
          }

          _val = _step3.value;

          if (!(_val instanceof File)) {
            _context6.next = 81;
            break;
          }

          _context6.t5 = _item;
          _context6.next = 77;
          return checkUpload(_val, type);

        case 77:
          _context6.t6 = _context6.sent;

          _context6.t5.push.call(_context6.t5, _context6.t6);

          _context6.next = 82;
          break;

        case 81:
          _item.push(_val);

        case 82:
          _iteratorNormalCompletion3 = true;
          _context6.next = 71;
          break;

        case 85:
          _context6.next = 91;
          break;

        case 87:
          _context6.prev = 87;
          _context6.t7 = _context6['catch'](69);
          _didIteratorError3 = true;
          _iteratorError3 = _context6.t7;

        case 91:
          _context6.prev = 91;
          _context6.prev = 92;

          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }

        case 94:
          _context6.prev = 94;

          if (!_didIteratorError3) {
            _context6.next = 97;
            break;
          }

          throw _iteratorError3;

        case 97:
          return _context6.finish(94);

        case 98:
          return _context6.finish(91);

        case 99:
          nuArgs.push(_item);
          _context6.next = 103;
          break;

        case 102:
          nuArgs.push(arg);

        case 103:
          _iteratorNormalCompletion = true;
          _context6.next = 8;
          break;

        case 106:
          _context6.next = 112;
          break;

        case 108:
          _context6.prev = 108;
          _context6.t8 = _context6['catch'](6);
          _didIteratorError = true;
          _iteratorError = _context6.t8;

        case 112:
          _context6.prev = 112;
          _context6.prev = 113;

          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }

        case 115:
          _context6.prev = 115;

          if (!_didIteratorError) {
            _context6.next = 118;
            break;
          }

          throw _iteratorError;

        case 118:
          return _context6.finish(115);

        case 119:
          return _context6.finish(112);

        case 120:
          _context6.next = 122;
          return _effects.call.apply(undefined, [fn].concat(nuArgs));

        case 122:
          _ref4 = _context6.sent;
          response = _ref4.response;
          error = _ref4.error;

          if (!error) {
            _context6.next = 136;
            break;
          }

          if (!(_ramda2.default.pathOr(0, ['response', 'status'], error) === 403)) {
            _context6.next = 129;
            break;
          }

          _context6.next = 129;
          return (0, _effects.put)({
            type: 'GLOBAL_ERROR_TRIGGERED',
            payload: { noAccessDialog: true }
          });

        case 129:
          _context6.next = 131;
          return (0, _effects.put)({ type: type + '_ERROR', payload: error.message, error: error, args: args });

        case 131:
          url = _ramda2.default.pathOr('<??>', ['request', 'url'], error);

          errorStr = function () {
            var method = _ramda2.default.pathOr('access', ['request', 'method'], error);
            return '[API] unable to ' + method + ' ' + url;
          }();

          if (window.Rollbar) {
            window.Rollbar.warning(errorStr, {
              error: error,
              args: _ramda2.default.omit(['headers'], args)
            });
          } else {
            console.warn(errorStr);
          }
          _context6.next = 138;
          break;

        case 136:
          _context6.next = 138;
          return (0, _effects.put)({ type: type + '_SUCCESS', payload: response, args: args });

        case 138:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[6, 108, 112, 120], [20, 38, 42, 50], [43,, 45, 49], [69, 87, 91, 99], [92,, 94, 98], [113,, 115, 119]]);
}

function getBinaryContent(url) {
  return regeneratorRuntime.wrap(function getBinaryContent$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.abrupt('return', new Promise(function (resolve, reject) {
            return _jszipUtils2.default.getBinaryContent(url, function (err, data) {
              if (err) return resolve(null);
              resolve(data);
            });
          }));

        case 1:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}
function generateZipAsync(zip) {
  return regeneratorRuntime.wrap(function generateZipAsync$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt('return', new Promise(function (resolve) {
            return zip.generateAsync({ type: 'blob' }).then(resolve).catch(function (err) {
              console.log('generateZipAsync error', err);
            });
          }));

        case 1:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}
function updateDownloadCountNFinalise(zip, count, totalLength, actionType, zipFileName) {
  return regeneratorRuntime.wrap(function updateDownloadCountNFinalise$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          if (!(count === totalLength)) {
            _context9.next = 6;
            break;
          }

          _context9.next = 3;
          return (0, _effects.put)({ type: (actionType || '[contracting-download]BULK_DOWNLOAD') + '_SUCCESS' });

        case 3:
          zip.generateAsync({ type: 'blob' }).then(function (content) {
            return (0, _fileSaver.saveAs)(content, zipFileName);
          });
          _context9.next = 8;
          break;

        case 6:
          _context9.next = 8;
          return (0, _effects.put)({ type: '[contracting-download]UPDATE_PROPS', payload: { downloadedCount: count + 1 } });

        case 8:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function zipDownloadContracts(_ref5) {
  var actionType = _ref5.actionType,
      contractIds = _ref5.contractIds,
      extraPayload = _objectWithoutProperties(_ref5, ['actionType', 'contractIds']);

  var zipFileName, _ref6, response, error, contracts, zip, count, contractIndex, contract, from, to, locationName, files, templateId, respondedContracts, externalZip, fileCount, fileIndex, file, bufferData, fileData, content, respondedZip, subContractCount, rcIndex, respondedContract, _bufferData, contractData, contractName, _content, _bufferData2, data, fileName;

  return regeneratorRuntime.wrap(function zipDownloadContracts$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          zipFileName = function () {
            var downloadRateFormat = extraPayload.downloadRateFormat,
                zipFileName = extraPayload.zipFileName;

            if (downloadRateFormat === 'quickview_desummarized') {
              return '' + (zipFileName || '') + (zipFileName ? '-' : '') + 'Quickview (xls) Rates.zip';
            } else if (downloadRateFormat === 'quickview_summarized') {
              return '' + (zipFileName || '') + (zipFileName ? '-' : '') + 'Quickview w/summary (xls) Rates.zip';
            } else if (downloadRateFormat === 'condensed') {
              return '' + (zipFileName || '') + (zipFileName ? '-' : '') + 'Compact Version Rates.zip';
            }
            return '' + (zipFileName || '') + (zipFileName ? '-' : '') + 'Full Version Rates.zip';
          }();

          _context10.next = 3;
          return (0, _effects.put)({ type: (actionType || '[contracting-download]BULK_DOWNLOAD') + '_STARTED' });

        case 3:
          _context10.next = 5;
          return (0, _api.callApi)('/proxy/contracting/pdf-zip', 'post', { contractIds: contractIds });

        case 5:
          _ref6 = _context10.sent;
          response = _ref6.response;
          error = _ref6.error;

          if (!error) {
            _context10.next = 12;
            break;
          }

          _context10.next = 11;
          return (0, _effects.put)({ type: (actionType || '[contracting-download]BULK_DOWNLOAD') + '_ERROR' });

        case 11:
          return _context10.abrupt('return', _context10.sent);

        case 12:
          contracts = response;

          if (contracts && contracts.length) {
            _context10.next = 17;
            break;
          }

          _context10.next = 16;
          return (0, _effects.put)({ type: (actionType || '[contracting-download]BULK_DOWNLOAD') + '_SUCCESS' });

        case 16:
          return _context10.abrupt('return', _context10.sent);

        case 17:
          _context10.next = 19;
          return (0, _effects.put)({ type: '[contracting-download]UPDATE_PROPS', payload: { validLengthForBulkDownload: contracts.length } });

        case 19:
          zip = new _jszip2.default();
          count = 0;
          contractIndex = 0;

        case 22:
          if (!(contractIndex < contracts.length)) {
            _context10.next = 101;
            break;
          }

          contract = contracts[contractIndex];
          from = contract.from, to = contract.to, locationName = contract.locationName, files = contract.files, templateId = contract.templateId, respondedContracts = contract.respondedContracts;
          // if external, download files

          if (!(files && files.length && !templateId)) {
            _context10.next = 51;
            break;
          }

          externalZip = new _jszip2.default();
          fileCount = 0;
          fileIndex = 0;

        case 29:
          if (!(fileIndex < files.length)) {
            _context10.next = 49;
            break;
          }

          file = files[fileIndex];
          return _context10.delegateYield(getBinaryContent('/proxy/s3/file?key=' + encodeURIComponent(file.path)), 't0', 32);

        case 32:
          bufferData = _context10.t0;
          _context10.next = 35;
          return bufferData;

        case 35:
          fileData = _context10.sent;
          // not sure why need to yield twice, but it works
          if (fileData) externalZip.file(count + 1 + '-' + (fileCount + 1) + '-' + file.name, fileData, { binary: true });
          fileCount++;

          if (!(fileCount === files.length)) {
            _context10.next = 46;
            break;
          }

          _context10.next = 41;
          return generateZipAsync(externalZip);

        case 41:
          content = _context10.sent;

          if (content) zip.file(contractIndex + 1 + '-' + to.name + '.zip', content, { binary: true });
          count++;
          _context10.next = 46;
          return updateDownloadCountNFinalise(zip, count, contracts.length, actionType, zipFileName);

        case 46:
          fileIndex++;
          _context10.next = 29;
          break;

        case 49:
          _context10.next = 98;
          break;

        case 51:
          if (!(respondedContracts && respondedContracts.length && !templateId)) {
            _context10.next = 83;
            break;
          }

          respondedZip = new _jszip2.default();
          subContractCount = 0;
          rcIndex = 0;

        case 55:
          if (!(rcIndex < respondedContracts.length)) {
            _context10.next = 81;
            break;
          }

          respondedContract = respondedContracts[rcIndex];
          _context10.t1 = getBinaryContent;
          _context10.t2 = _api.fileUrls.getDownloadTCContractingDoc(_extends({}, extraPayload, {
            docId: respondedContract._id
          }));
          _context10.next = 61;
          return;

        case 61:
          _context10.t3 = _context10.sent;
          _context10.next = 64;
          return (0, _context10.t1)(_context10.t2, _context10.t3);

        case 64:
          _bufferData = _context10.sent;
          _context10.next = 67;
          return _bufferData;

        case 67:
          contractData = _context10.sent;
          // not sure why need to yield twice, but it works
          if (contractData) {
            contractName = contractIndex + 1 + '-' + respondedContract.from.name + '-' + respondedContract.locationName;

            respondedZip.file(contractName + '.' + ((extraPayload.downloadRateFormat || '').split('_')[0] === 'quickview' ? 'xlsx' : 'pdf'), contractData, { binary: true });
          }
          subContractCount++;

          if (!(subContractCount === respondedContracts.length)) {
            _context10.next = 78;
            break;
          }

          _context10.next = 73;
          return generateZipAsync(respondedZip);

        case 73:
          _content = _context10.sent;

          if (_content) zip.file(contractIndex + 1 + '-' + to.name + '.zip', _content, { binary: true });
          count++;
          _context10.next = 78;
          return updateDownloadCountNFinalise(zip, count, contracts.length, actionType, zipFileName);

        case 78:
          rcIndex++;
          _context10.next = 55;
          break;

        case 81:
          _context10.next = 98;
          break;

        case 83:
          _context10.t4 = getBinaryContent;
          _context10.t5 = _api.fileUrls.getDownloadTCContractingDoc(_extends({}, extraPayload, {
            docId: contract._id
          }));
          _context10.next = 87;
          return;

        case 87:
          _context10.t6 = _context10.sent;
          _context10.next = 90;
          return (0, _context10.t4)(_context10.t5, _context10.t6);

        case 90:
          _bufferData2 = _context10.sent;
          _context10.next = 93;
          return _bufferData2;

        case 93:
          data = _context10.sent;

          if (data) {
            fileName = contractIndex + 1 + '-' + to.name + '-' + from.name + '-' + locationName;

            zip.file(fileName + '.' + ((extraPayload.downloadRateFormat || '').split('_')[0] === 'quickview' ? 'xlsx' : 'pdf'), data, { binary: true });
          }
          count++;
          _context10.next = 98;
          return updateDownloadCountNFinalise(zip, count, contracts.length, actionType, zipFileName);

        case 98:
          contractIndex++;
          _context10.next = 22;
          break;

        case 101:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function zipDownloadTemplates(_ref7) {
  var actionType = _ref7.actionType,
      templates = _ref7.templates,
      downloadRateFormat = _ref7.downloadRateFormat,
      templateGroupName = _ref7.templateGroupName,
      extraPayload = _objectWithoutProperties(_ref7, ['actionType', 'templates', 'downloadRateFormat', 'templateGroupName']);

  var zip, count, templateIndex, template, templateName, _locationName, data;

  return regeneratorRuntime.wrap(function zipDownloadTemplates$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.put)({ type: (actionType || '[contracting-download]BULK_DOWNLOAD') + '_STARTED\'' });

        case 2:
          zip = new _jszip2.default();
          count = 0;
          templateIndex = 0;

        case 5:
          if (!(templateIndex < templates.length)) {
            _context11.next = 18;
            break;
          }

          template = templates[templateIndex];
          templateName = template.templateName, _locationName = template.locationName;
          _context11.next = 10;
          return getBinaryContent(_api.fileUrls.getDownloadTCContractingDoc({
            docId: template._id,
            collection: 'template',
            locale: extraPayload.locale,
            ratesOnly: extraPayload.ratesOnly,
            downloadRateFormat: downloadRateFormat
          }));

        case 10:
          data = _context11.sent;

          if (data) zip.file(count + 1 + '-' + _locationName + '-' + templateName + '.pdf', data, { binary: true });
          count++;
          _context11.next = 15;
          return updateDownloadCountNFinalise(zip, count, templates.length, actionType, extraPayload.ratesOnly ? templateGroupName + ' Compact Version Rates.zip' : templateGroupName + ' Full Version Rates.zip');

        case 15:
          templateIndex++;
          _context11.next = 5;
          break;

        case 18:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(691).version;
elliptic.utils = __webpack_require__(692);
elliptic.rand = __webpack_require__(524);
elliptic.curve = __webpack_require__(214);
elliptic.curves = __webpack_require__(697);

// Protocols
elliptic.ec = __webpack_require__(705);
elliptic.eddsa = __webpack_require__(709);


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(59);
var _curry3 = __webpack_require__(5);


/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */
module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
  return Array.prototype.slice.call(list, fromIndex, toIndex);
}));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var _indexOf = __webpack_require__(166);


module.exports = function _contains(a, list) {
  return _indexOf(list, a, 0) >= 0;
};


/***/ }),
/* 47 */,
/* 48 */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      var t = R.always('Tee');
 *      t(); //=> 'Tee'
 */
module.exports = _curry1(function always(val) {
  return function() {
    return val;
  };
});


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */
module.exports = _curry2(function max(a, b) { return b > a ? b : a; });


/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/



Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(146);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(220);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(47);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactInputAutosize = __webpack_require__(986);

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

var _classnames = __webpack_require__(249);

var _classnames2 = _interopRequireDefault(_classnames);

var _utilsDefaultArrowRenderer = __webpack_require__(990);

var _utilsDefaultArrowRenderer2 = _interopRequireDefault(_utilsDefaultArrowRenderer);

var _utilsDefaultFilterOptions = __webpack_require__(613);

var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);

var _utilsDefaultMenuRenderer = __webpack_require__(615);

var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);

var _utilsDefaultClearRenderer = __webpack_require__(991);

var _utilsDefaultClearRenderer2 = _interopRequireDefault(_utilsDefaultClearRenderer);

var _Async = __webpack_require__(992);

var _Async2 = _interopRequireDefault(_Async);

var _AsyncCreatable = __webpack_require__(993);

var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);

var _Creatable = __webpack_require__(994);

var _Creatable2 = _interopRequireDefault(_Creatable);

var _Option = __webpack_require__(995);

var _Option2 = _interopRequireDefault(_Option);

var _Value = __webpack_require__(996);

var _Value2 = _interopRequireDefault(_Value);

function stringifyValue(value) {
	var valueType = typeof value;
	if (valueType === 'string') {
		return value;
	} else if (valueType === 'object') {
		return JSON.stringify(value);
	} else if (valueType === 'number' || valueType === 'boolean') {
		return String(value);
	} else {
		return '';
	}
}

var stringOrNode = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]);

var instanceId = 1;

var Select = (0, _createReactClass2['default'])({

	displayName: 'Select',

	propTypes: {
		addLabelText: _propTypes2['default'].string, // placeholder displayed when you want to add a label on a multi-value input
		'aria-describedby': _propTypes2['default'].string, // HTML ID(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2['default'].string, // Aria label (for assistive tech)
		'aria-labelledby': _propTypes2['default'].string, // HTML ID of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2['default'].func, // Create drop-down caret element
		autoBlur: _propTypes2['default'].bool, // automatically blur the component when an option is selected
		autofocus: _propTypes2['default'].bool, // autofocus the component on mount
		autosize: _propTypes2['default'].bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2['default'].bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2['default'].string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2['default'].string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2['default'].func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2['default'].bool, // should it be possible to reset value
		deleteRemoves: _propTypes2['default'].bool, // whether backspace removes an item if there is no text input
		delimiter: _propTypes2['default'].string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2['default'].bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2['default'].bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2['default'].func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2['default'].any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		ignoreAccents: _propTypes2['default'].bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2['default'].bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2['default'].object, // custom attributes for the Input
		inputRenderer: _propTypes2['default'].func, // returns a custom input component
		instanceId: _propTypes2['default'].string, // set the components instanceId
		isLoading: _propTypes2['default'].bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2['default'].bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2['default'].string, // path of the label value in option objects
		matchPos: _propTypes2['default'].string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2['default'].string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2['default'].number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2['default'].object, // optional style to apply to the menu container
		menuRenderer: _propTypes2['default'].func, // renders a custom menu with options
		menuStyle: _propTypes2['default'].object, // optional style to apply to the menu
		multi: _propTypes2['default'].bool, // multi-value input
		name: _propTypes2['default'].string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2['default'].func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2['default'].bool, // whether input is cleared on blur
		onChange: _propTypes2['default'].func, // onChange handler: function (newValue) {}
		onClose: _propTypes2['default'].func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2['default'].bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2['default'].func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2['default'].func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2['default'].func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2['default'].func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2['default'].func, // fires when the menu is opened
		onValueClick: _propTypes2['default'].func, // onClick handler for value labels: function (value, event) {}
		openAfterFocus: _propTypes2['default'].bool, // boolean to enable opening dropdown when focused
		openOnFocus: _propTypes2['default'].bool, // always open options menu on focus
		optionClassName: _propTypes2['default'].string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2['default'].func, // option component to render in dropdown
		optionRenderer: _propTypes2['default'].func, // optionRenderer: function (option) {}
		options: _propTypes2['default'].array, // array of options
		pageSize: _propTypes2['default'].number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		required: _propTypes2['default'].bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2['default'].any, // value to use when you clear the control
		scrollMenuIntoView: _propTypes2['default'].bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2['default'].bool, // whether to enable searching feature or not
		simpleValue: _propTypes2['default'].bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2['default'].object, // optional style to apply to the control
		tabIndex: _propTypes2['default'].string, // optional tab index of the control
		tabSelectsValue: _propTypes2['default'].bool, // whether to treat tabbing out while focused to be value selection
		value: _propTypes2['default'].any, // initial field value
		valueComponent: _propTypes2['default'].func, // value component to render
		valueKey: _propTypes2['default'].string, // path of the label value in option objects
		valueRenderer: _propTypes2['default'].func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2['default'].object },

	// optional style to apply to the component wrapper
	statics: { Async: _Async2['default'], AsyncCreatable: _AsyncCreatable2['default'], Creatable: _Creatable2['default'] },

	getDefaultProps: function getDefaultProps() {
		return {
			addLabelText: 'Add "{label}"?',
			arrowRenderer: _utilsDefaultArrowRenderer2['default'],
			autosize: true,
			backspaceRemoves: true,
			backspaceToRemoveMessage: 'Press backspace to remove {label}',
			clearable: true,
			clearAllText: 'Clear all',
			clearRenderer: _utilsDefaultClearRenderer2['default'],
			clearValueText: 'Clear value',
			deleteRemoves: true,
			delimiter: ',',
			disabled: false,
			escapeClearsValue: true,
			filterOptions: _utilsDefaultFilterOptions2['default'],
			ignoreAccents: true,
			ignoreCase: true,
			inputProps: {},
			isLoading: false,
			joinValues: false,
			labelKey: 'label',
			matchPos: 'any',
			matchProp: 'any',
			menuBuffer: 0,
			menuRenderer: _utilsDefaultMenuRenderer2['default'],
			multi: false,
			noResultsText: 'No results found',
			onBlurResetsInput: true,
			onCloseResetsInput: true,
			optionComponent: _Option2['default'],
			pageSize: 5,
			placeholder: 'Select...',
			required: false,
			scrollMenuIntoView: true,
			searchable: true,
			simpleValue: false,
			tabSelectsValue: true,
			valueComponent: _Value2['default'],
			valueKey: 'value'
		};
	},

	getInitialState: function getInitialState() {
		return {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
	},

	componentWillMount: function componentWillMount() {
		this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
		var valueArray = this.getValueArray(this.props.value);

		if (this.props.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], this.props.multi)
			});
		}
	},

	componentDidMount: function componentDidMount() {
		if (this.props.autofocus) {
			this.focus();
		}
	},

	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		var valueArray = this.getValueArray(nextProps.value, nextProps);

		if (nextProps.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], nextProps.multi)
			});
		}
	},

	componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
		if (nextState.isOpen !== this.state.isOpen) {
			this.toggleTouchOutsideEvent(nextState.isOpen);
			var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
			handler && handler();
		}
	},

	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		// focus to the selected option
		if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
			var focusedOptionNode = _reactDom2['default'].findDOMNode(this.focused);
			var menuNode = _reactDom2['default'].findDOMNode(this.menu);
			menuNode.scrollTop = focusedOptionNode.offsetTop;
			this.hasScrolledToOption = true;
		} else if (!this.state.isOpen) {
			this.hasScrolledToOption = false;
		}

		if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
			this._scrollToFocusedOptionOnUpdate = false;
			var focusedDOM = _reactDom2['default'].findDOMNode(this.focused);
			var menuDOM = _reactDom2['default'].findDOMNode(this.menu);
			var focusedRect = focusedDOM.getBoundingClientRect();
			var menuRect = menuDOM.getBoundingClientRect();
			if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
				menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
			}
		}
		if (this.props.scrollMenuIntoView && this.menuContainer) {
			var menuContainerRect = this.menuContainer.getBoundingClientRect();
			if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
				window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
			}
		}
		if (prevProps.disabled !== this.props.disabled) {
			this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
			this.closeMenu();
		}
	},

	componentWillUnmount: function componentWillUnmount() {
		if (!document.removeEventListener && document.detachEvent) {
			document.detachEvent('ontouchstart', this.handleTouchOutside);
		} else {
			document.removeEventListener('touchstart', this.handleTouchOutside);
		}
	},

	toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
		if (enabled) {
			if (!document.addEventListener && document.attachEvent) {
				document.attachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.addEventListener('touchstart', this.handleTouchOutside);
			}
		} else {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		}
	},

	handleTouchOutside: function handleTouchOutside(event) {
		// handle touch outside on ios to dismiss menu
		if (this.wrapper && !this.wrapper.contains(event.target)) {
			this.closeMenu();
		}
	},

	focus: function focus() {
		if (!this.input) return;
		this.input.focus();
	},

	blurInput: function blurInput() {
		if (!this.input) return;
		this.input.blur();
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.handleMouseDown(event);
	},

	handleTouchEndClearValue: function handleTouchEndClearValue(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Clear the value
		this.clearValue(event);
	},

	handleMouseDown: function handleMouseDown(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}

		if (event.target.tagName === 'INPUT') {
			return;
		}

		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();

		// for the non-searchable select, toggle the menu
		if (!this.props.searchable) {
			this.focus();
			return this.setState({
				isOpen: !this.state.isOpen
			});
		}

		if (this.state.isFocused) {
			// On iOS, we can get into a state where we think the input is focused but it isn't really,
			// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
			// Call focus() again here to be safe.
			this.focus();

			var input = this.input;
			if (typeof input.getInput === 'function') {
				// Get the actual DOM input if the ref is an <AutosizeInput /> component
				input = input.getInput();
			}

			// clears the value so that the cursor will be at the end of input when the component re-renders
			input.value = '';

			// if the input is focused, ensure the menu is open
			this.setState({
				isOpen: true,
				isPseudoFocused: false
			});
		} else {
			// otherwise, focus the input and open the menu
			this._openAfterFocus = true;
			this.focus();
		}
	},

	handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		// If the menu isn't open, let the event bubble to the main handleMouseDown
		if (!this.state.isOpen) {
			return;
		}
		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();
		// close the menu
		this.closeMenu();
	},

	handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();

		this._openAfterFocus = true;
		this.focus();
	},

	closeMenu: function closeMenu() {
		if (this.props.onCloseResetsInput) {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: ''
			});
		} else {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: this.state.inputValue
			});
		}
		this.hasScrolledToOption = false;
	},

	handleInputFocus: function handleInputFocus(event) {
		if (this.props.disabled) return;
		var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
		if (this.props.onFocus) {
			this.props.onFocus(event);
		}
		this.setState({
			isFocused: true,
			isOpen: isOpen
		});
		this._openAfterFocus = false;
	},

	handleInputBlur: function handleInputBlur(event) {
		// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
		if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
			this.focus();
			return;
		}

		if (this.props.onBlur) {
			this.props.onBlur(event);
		}
		var onBlurredState = {
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false
		};
		if (this.props.onBlurResetsInput) {
			onBlurredState.inputValue = '';
		}
		this.setState(onBlurredState);
	},

	handleInputChange: function handleInputChange(event) {
		var newInputValue = event.target.value;

		if (this.state.inputValue !== event.target.value && this.props.onInputChange) {
			var nextState = this.props.onInputChange(newInputValue);
			// Note: != used deliberately here to catch undefined and null
			if (nextState != null && typeof nextState !== 'object') {
				newInputValue = '' + nextState;
			}
		}

		this.setState({
			isOpen: true,
			isPseudoFocused: false,
			inputValue: newInputValue
		});
	},

	handleKeyDown: function handleKeyDown(event) {
		if (this.props.disabled) return;

		if (typeof this.props.onInputKeyDown === 'function') {
			this.props.onInputKeyDown(event);
			if (event.defaultPrevented) {
				return;
			}
		}

		switch (event.keyCode) {
			case 8:
				// backspace
				if (!this.state.inputValue && this.props.backspaceRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			case 9:
				// tab
				if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
					return;
				}
				this.selectFocusedOption();
				return;
			case 13:
				// enter
				if (!this.state.isOpen) return;
				event.stopPropagation();
				this.selectFocusedOption();
				break;
			case 27:
				// escape
				if (this.state.isOpen) {
					this.closeMenu();
					event.stopPropagation();
				} else if (this.props.clearable && this.props.escapeClearsValue) {
					this.clearValue(event);
					event.stopPropagation();
				}
				break;
			case 38:
				// up
				this.focusPreviousOption();
				break;
			case 40:
				// down
				this.focusNextOption();
				break;
			case 33:
				// page up
				this.focusPageUpOption();
				break;
			case 34:
				// page down
				this.focusPageDownOption();
				break;
			case 35:
				// end key
				if (event.shiftKey) {
					return;
				}
				this.focusEndOption();
				break;
			case 36:
				// home key
				if (event.shiftKey) {
					return;
				}
				this.focusStartOption();
				break;
			case 46:
				// backspace
				if (!this.state.inputValue && this.props.deleteRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			default:
				return;
		}
		event.preventDefault();
	},

	handleValueClick: function handleValueClick(option, event) {
		if (!this.props.onValueClick) return;
		this.props.onValueClick(option, event);
	},

	handleMenuScroll: function handleMenuScroll(event) {
		if (!this.props.onMenuScrollToBottom) return;
		var target = event.target;

		if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
			this.props.onMenuScrollToBottom();
		}
	},

	handleRequired: function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	},

	getOptionLabel: function getOptionLabel(op) {
		return op[this.props.labelKey];
	},

	/**
  * Turns a value into an array from the given options
  * @param	{String|Number|Array}	value		- the value of the select input
  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
  * @returns	{Array}	the value of the select represented in an array
  */
	getValueArray: function getValueArray(value, nextProps) {
		var _this = this;

		/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
		var props = typeof nextProps === 'object' ? nextProps : this.props;
		if (props.multi) {
			if (typeof value === 'string') value = value.split(props.delimiter);
			if (!Array.isArray(value)) {
				if (value === null || value === undefined) return [];
				value = [value];
			}
			return value.map(function (value) {
				return _this.expandValue(value, props);
			}).filter(function (i) {
				return i;
			});
		}
		var expandedValue = this.expandValue(value, props);
		return expandedValue ? [expandedValue] : [];
	},

	/**
  * Retrieve a value from the given options and valueKey
  * @param	{String|Number|Array}	value	- the selected value(s)
  * @param	{Object}		props	- the Select component's props (or nextProps)
  */
	expandValue: function expandValue(value, props) {
		var valueType = typeof value;
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options;
		var valueKey = props.valueKey;

		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (options[i][valueKey] === value) return options[i];
		}
	},

	setValue: function setValue(value) {
		var _this2 = this;

		if (this.props.autoBlur) {
			this.blurInput();
		}
		if (!this.props.onChange) return;
		if (this.props.required) {
			var required = this.handleRequired(value, this.props.multi);
			this.setState({ required: required });
		}
		if (this.props.simpleValue && value) {
			value = this.props.multi ? value.map(function (i) {
				return i[_this2.props.valueKey];
			}).join(this.props.delimiter) : value[this.props.valueKey];
		}
		this.props.onChange(value);
	},

	selectValue: function selectValue(value) {
		var _this3 = this;

		//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
		this.hasScrolledToOption = false;
		if (this.props.multi) {
			this.setState({
				inputValue: '',
				focusedIndex: null
			}, function () {
				_this3.addValue(value);
			});
		} else {
			this.setState({
				isOpen: false,
				inputValue: '',
				isPseudoFocused: this.state.isFocused
			}, function () {
				_this3.setValue(value);
			});
		}
	},

	addValue: function addValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		var visibleOptions = this._visibleOptions.filter(function (val) {
			return !val.disabled;
		});
		var lastValueIndex = visibleOptions.indexOf(value);
		this.setValue(valueArray.concat(value));
		if (visibleOptions.length - 1 === lastValueIndex) {
			// the last option was selected; focus the second-last one
			this.focusOption(visibleOptions[lastValueIndex - 1]);
		} else if (visibleOptions.length > lastValueIndex) {
			// focus the option below the selected one
			this.focusOption(visibleOptions[lastValueIndex + 1]);
		}
	},

	popValue: function popValue() {
		var valueArray = this.getValueArray(this.props.value);
		if (!valueArray.length) return;
		if (valueArray[valueArray.length - 1].clearableValue === false) return;
		this.setValue(valueArray.slice(0, valueArray.length - 1));
	},

	removeValue: function removeValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		this.setValue(valueArray.filter(function (i) {
			return i !== value;
		}));
		this.focus();
	},

	clearValue: function clearValue(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, ignore it.
		if (event && event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();
		this.setValue(this.getResetValue());
		this.setState({
			isOpen: false,
			inputValue: ''
		}, this.focus);
	},

	getResetValue: function getResetValue() {
		if (this.props.resetValue !== undefined) {
			return this.props.resetValue;
		} else if (this.props.multi) {
			return [];
		} else {
			return null;
		}
	},

	focusOption: function focusOption(option) {
		this.setState({
			focusedOption: option
		});
	},

	focusNextOption: function focusNextOption() {
		this.focusAdjacentOption('next');
	},

	focusPreviousOption: function focusPreviousOption() {
		this.focusAdjacentOption('previous');
	},

	focusPageUpOption: function focusPageUpOption() {
		this.focusAdjacentOption('page_up');
	},

	focusPageDownOption: function focusPageDownOption() {
		this.focusAdjacentOption('page_down');
	},

	focusStartOption: function focusStartOption() {
		this.focusAdjacentOption('start');
	},

	focusEndOption: function focusEndOption() {
		this.focusAdjacentOption('end');
	},

	focusAdjacentOption: function focusAdjacentOption(dir) {
		var options = this._visibleOptions.map(function (option, index) {
			return { option: option, index: index };
		}).filter(function (option) {
			return !option.option.disabled;
		});
		this._scrollToFocusedOptionOnUpdate = true;
		if (!this.state.isOpen) {
			this.setState({
				isOpen: true,
				inputValue: '',
				focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
			});
			return;
		}
		if (!options.length) return;
		var focusedIndex = -1;
		for (var i = 0; i < options.length; i++) {
			if (this._focusedOption === options[i].option) {
				focusedIndex = i;
				break;
			}
		}
		if (dir === 'next' && focusedIndex !== -1) {
			focusedIndex = (focusedIndex + 1) % options.length;
		} else if (dir === 'previous') {
			if (focusedIndex > 0) {
				focusedIndex = focusedIndex - 1;
			} else {
				focusedIndex = options.length - 1;
			}
		} else if (dir === 'start') {
			focusedIndex = 0;
		} else if (dir === 'end') {
			focusedIndex = options.length - 1;
		} else if (dir === 'page_up') {
			var potentialIndex = focusedIndex - this.props.pageSize;
			if (potentialIndex < 0) {
				focusedIndex = 0;
			} else {
				focusedIndex = potentialIndex;
			}
		} else if (dir === 'page_down') {
			var potentialIndex = focusedIndex + this.props.pageSize;
			if (potentialIndex > options.length - 1) {
				focusedIndex = options.length - 1;
			} else {
				focusedIndex = potentialIndex;
			}
		}

		if (focusedIndex === -1) {
			focusedIndex = 0;
		}

		this.setState({
			focusedIndex: options[focusedIndex].index,
			focusedOption: options[focusedIndex].option
		});
	},

	getFocusedOption: function getFocusedOption() {
		return this._focusedOption;
	},

	getInputValue: function getInputValue() {
		return this.state.inputValue;
	},

	selectFocusedOption: function selectFocusedOption() {
		if (this._focusedOption) {
			return this.selectValue(this._focusedOption);
		}
	},

	renderLoading: function renderLoading() {
		if (!this.props.isLoading) return;
		return _react2['default'].createElement(
			'span',
			{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
			_react2['default'].createElement('span', { className: 'Select-loading' })
		);
	},

	renderValue: function renderValue(valueArray, isOpen) {
		var _this4 = this;

		var renderLabel = this.props.valueRenderer || this.getOptionLabel;
		var ValueComponent = this.props.valueComponent;
		if (!valueArray.length) {
			return !this.state.inputValue ? _react2['default'].createElement(
				'div',
				{ className: 'Select-placeholder' },
				this.props.placeholder
			) : null;
		}
		var onClick = this.props.onValueClick ? this.handleValueClick : null;
		if (this.props.multi) {
			return valueArray.map(function (value, i) {
				return _react2['default'].createElement(
					ValueComponent,
					{
						id: _this4._instancePrefix + '-value-' + i,
						instancePrefix: _this4._instancePrefix,
						disabled: _this4.props.disabled || value.clearableValue === false,
						key: 'value-' + i + '-' + value[_this4.props.valueKey],
						onClick: onClick,
						onRemove: _this4.removeValue,
						value: value
					},
					renderLabel(value, i),
					_react2['default'].createElement(
						'span',
						{ className: 'Select-aria-only' },
						' '
					)
				);
			});
		} else if (!this.state.inputValue) {
			if (isOpen) onClick = null;
			return _react2['default'].createElement(
				ValueComponent,
				{
					id: this._instancePrefix + '-value-item',
					disabled: this.props.disabled,
					instancePrefix: this._instancePrefix,
					onClick: onClick,
					value: valueArray[0]
				},
				renderLabel(valueArray[0])
			);
		}
	},

	renderInput: function renderInput(valueArray, focusedOptionIndex) {
		var _classNames,
		    _this5 = this;

		var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
		var isOpen = !!this.state.isOpen;

		var ariaOwns = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

		// TODO: Check how this project includes Object.assign()
		var inputProps = _extends({}, this.props.inputProps, {
			role: 'combobox',
			'aria-expanded': '' + isOpen,
			'aria-owns': ariaOwns,
			'aria-haspopup': '' + isOpen,
			'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
			'aria-describedby': this.props['aria-describedby'],
			'aria-labelledby': this.props['aria-labelledby'],
			'aria-label': this.props['aria-label'],
			className: className,
			tabIndex: this.props.tabIndex,
			onBlur: this.handleInputBlur,
			onChange: this.handleInputChange,
			onFocus: this.handleInputFocus,
			ref: function ref(_ref) {
				return _this5.input = _ref;
			},
			required: this.state.required,
			value: this.state.inputValue
		});

		if (this.props.inputRenderer) {
			return this.props.inputRenderer(inputProps);
		}

		if (this.props.disabled || !this.props.searchable) {
			var _props$inputProps = this.props.inputProps;
			var inputClassName = _props$inputProps.inputClassName;

			var divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);

			var _ariaOwns = (0, _classnames2['default'])(_defineProperty({}, this._instancePrefix + '-list', isOpen));

			return _react2['default'].createElement('div', _extends({}, divProps, {
				role: 'combobox',
				'aria-expanded': isOpen,
				'aria-owns': _ariaOwns,
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				className: className,
				tabIndex: this.props.tabIndex || 0,
				onBlur: this.handleInputBlur,
				onFocus: this.handleInputFocus,
				ref: function (ref) {
					return _this5.input = ref;
				},
				'aria-readonly': '' + !!this.props.disabled,
				style: { border: 0, width: 1, display: 'inline-block' } }));
		}

		if (this.props.autosize) {
			return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, inputProps, { minWidth: '5' }));
		}
		return _react2['default'].createElement(
			'div',
			{ className: className },
			_react2['default'].createElement('input', inputProps)
		);
	},

	renderClear: function renderClear() {

		if (!this.props.clearable || this.props.value === undefined || this.props.value === null || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
		var clear = this.props.clearRenderer();

		return _react2['default'].createElement(
			'span',
			{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				onMouseDown: this.clearValue,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEndClearValue
			},
			clear
		);
	},

	renderArrow: function renderArrow() {
		var onMouseDown = this.handleMouseDownOnArrow;
		var isOpen = this.state.isOpen;
		var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

		return _react2['default'].createElement(
			'span',
			{
				className: 'Select-arrow-zone',
				onMouseDown: onMouseDown
			},
			arrow
		);
	},

	filterOptions: function filterOptions(excludeOptions) {
		var filterValue = this.state.inputValue;
		var options = this.props.options || [];
		if (this.props.filterOptions) {
			// Maintain backwards compatibility with boolean attribute
			var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _utilsDefaultFilterOptions2['default'];

			return filterOptions(options, filterValue, excludeOptions, {
				filterOption: this.props.filterOption,
				ignoreAccents: this.props.ignoreAccents,
				ignoreCase: this.props.ignoreCase,
				labelKey: this.props.labelKey,
				matchPos: this.props.matchPos,
				matchProp: this.props.matchProp,
				valueKey: this.props.valueKey
			});
		} else {
			return options;
		}
	},

	onOptionRef: function onOptionRef(ref, isFocused) {
		if (isFocused) {
			this.focused = ref;
		}
	},

	renderMenu: function renderMenu(options, valueArray, focusedOption) {
		if (options && options.length) {
			return this.props.menuRenderer({
				focusedOption: focusedOption,
				focusOption: this.focusOption,
				instancePrefix: this._instancePrefix,
				labelKey: this.props.labelKey,
				onFocus: this.focusOption,
				onSelect: this.selectValue,
				optionClassName: this.props.optionClassName,
				optionComponent: this.props.optionComponent,
				optionRenderer: this.props.optionRenderer || this.getOptionLabel,
				options: options,
				selectValue: this.selectValue,
				valueArray: valueArray,
				valueKey: this.props.valueKey,
				onOptionRef: this.onOptionRef
			});
		} else if (this.props.noResultsText) {
			return _react2['default'].createElement(
				'div',
				{ className: 'Select-noresults' },
				this.props.noResultsText
			);
		} else {
			return null;
		}
	},

	renderHiddenField: function renderHiddenField(valueArray) {
		var _this6 = this;

		if (!this.props.name) return;
		if (this.props.joinValues) {
			var value = valueArray.map(function (i) {
				return stringifyValue(i[_this6.props.valueKey]);
			}).join(this.props.delimiter);
			return _react2['default'].createElement('input', {
				type: 'hidden',
				ref: function (ref) {
					return _this6.value = ref;
				},
				name: this.props.name,
				value: value,
				disabled: this.props.disabled });
		}
		return valueArray.map(function (item, index) {
			return _react2['default'].createElement('input', { key: 'hidden.' + index,
				type: 'hidden',
				ref: 'value' + index,
				name: _this6.props.name,
				value: stringifyValue(item[_this6.props.valueKey]),
				disabled: _this6.props.disabled });
		});
	},

	getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
		var options = this._visibleOptions;
		if (!options.length) return null;

		var valueKey = this.props.valueKey;
		var focusedOption = this.state.focusedOption || selectedOption;
		if (focusedOption && !focusedOption.disabled) {
			var focusedOptionIndex = -1;
			options.some(function (option, index) {
				var isOptionEqual = option[valueKey] === focusedOption[valueKey];
				if (isOptionEqual) {
					focusedOptionIndex = index;
				}
				return isOptionEqual;
			});
			if (focusedOptionIndex !== -1) {
				return focusedOptionIndex;
			}
		}

		for (var i = 0; i < options.length; i++) {
			if (!options[i].disabled) return i;
		}
		return null;
	},

	renderOuter: function renderOuter(options, valueArray, focusedOption) {
		var _this7 = this;

		var menu = this.renderMenu(options, valueArray, focusedOption);
		if (!menu) {
			return null;
		}

		return _react2['default'].createElement(
			'div',
			{ ref: function (ref) {
					return _this7.menuContainer = ref;
				}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
			_react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this7.menu = ref;
					}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
					style: this.props.menuStyle,
					onScroll: this.handleMenuScroll,
					onMouseDown: this.handleMouseDownOnMenu },
				menu
			)
		);
	},

	render: function render() {
		var _this8 = this;

		var valueArray = this.getValueArray(this.props.value);
		var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
		var isOpen = this.state.isOpen;
		if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
		var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

		var focusedOption = null;
		if (focusedOptionIndex !== null) {
			focusedOption = this._focusedOption = options[focusedOptionIndex];
		} else {
			focusedOption = this._focusedOption = null;
		}
		var className = (0, _classnames2['default'])('Select', this.props.className, {
			'Select--multi': this.props.multi,
			'Select--single': !this.props.multi,
			'is-clearable': this.props.clearable,
			'is-disabled': this.props.disabled,
			'is-focused': this.state.isFocused,
			'is-loading': this.props.isLoading,
			'is-open': isOpen,
			'is-pseudo-focused': this.state.isPseudoFocused,
			'is-searchable': this.props.searchable,
			'has-value': valueArray.length
		});

		var removeMessage = null;
		if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
			removeMessage = _react2['default'].createElement(
				'span',
				{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
				this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
			);
		}

		return _react2['default'].createElement(
			'div',
			{ ref: function (ref) {
					return _this8.wrapper = ref;
				},
				className: className,
				style: this.props.wrapperStyle },
			this.renderHiddenField(valueArray),
			_react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this8.control = ref;
					},
					className: 'Select-control',
					style: this.props.style,
					onKeyDown: this.handleKeyDown,
					onMouseDown: this.handleMouseDown,
					onTouchEnd: this.handleTouchEnd,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove
				},
				_react2['default'].createElement(
					'span',
					{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
					this.renderValue(valueArray, isOpen),
					this.renderInput(valueArray, focusedOptionIndex)
				),
				removeMessage,
				this.renderLoading(),
				this.renderClear(),
				this.renderArrow()
			),
			isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
		);
	}

});

exports['default'] = Select;
module.exports = exports['default'];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = checkStatus;
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  var error = new Error(response.statusText);
  error.response = response;
  throw error;
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(48);
var inherits = __webpack_require__(8);

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1109)();
}


/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var map = __webpack_require__(16);
var prop = __webpack_require__(96);


/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */
module.exports = _curry2(function pluck(p, list) {
  return map(prop(p), list);
});


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var _isArray = __webpack_require__(41);


/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implemtation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */
module.exports = function _checkForMethod(methodname, fn) {
  return function() {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
      fn.apply(this, arguments) :
      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _toString = __webpack_require__(294);


/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */
module.exports = _curry1(function toString(val) { return _toString(val, []); });


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isString = __webpack_require__(58);


/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      var list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */
module.exports = _curry2(function nth(offset, list) {
  var idx = offset < 0 ? list.length + offset : offset;
  return _isString(list) ? list.charAt(idx) : list[idx];
});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isFunction = __webpack_require__(77);
var curryN = __webpack_require__(13);
var toString = __webpack_require__(60);


/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of the method to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      var sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */
module.exports = _curry2(function invoker(arity, method) {
  return curryN(arity + 1, function() {
    var target = arguments[arity];
    if (target != null && _isFunction(target[method])) {
      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
    }
    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
  });
});


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */
module.exports = _curry2(function path(paths, obj) {
  var val = obj;
  var idx = 0;
  while (idx < paths.length) {
    if (val == null) {
      return;
    }
    val = val[paths[idx]];
    idx += 1;
  }
  return val;
});


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["h"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["w"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["l"] = deferred;
/* harmony export (immutable) */ __webpack_exports__["g"] = arrayOfDeffered;
/* harmony export (immutable) */ __webpack_exports__["m"] = delay;
/* harmony export (immutable) */ __webpack_exports__["j"] = createMockTask;
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["t"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["s"] = log;
/* harmony export (immutable) */ __webpack_exports__["n"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return wrapSagaDispatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return cloneableGenerator; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A worker that does nothing but passing chunks to the next one. This is like
 * a nodejs stream but with some differences. On the good side :
 * - it works on IE 6-9 without any issue / polyfill
 * - it weights less than the full dependencies bundled with browserify
 * - it forwards errors (no need to declare an error handler EVERYWHERE)
 *
 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
 * object containing anything (`percent` for example), see each worker for more
 * details. The latter is the real data (String, Uint8Array, etc).
 *
 * @constructor
 * @param {String} name the name of the stream (mainly used for debugging purposes)
 */
function GenericWorker(name) {
    // the name of the worker
    this.name = name || "default";
    // an object containing metadata about the workers chain
    this.streamInfo = {};
    // an error which happened when the worker was paused
    this.generatedError = null;
    // an object containing metadata to be merged by this worker into the general metadata
    this.extraStreamInfo = {};
    // true if the stream is paused (and should not do anything), false otherwise
    this.isPaused = true;
    // true if the stream is finished (and should not do anything), false otherwise
    this.isFinished = false;
    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
    this.isLocked = false;
    // the event listeners
    this._listeners = {
        'data':[],
        'end':[],
        'error':[]
    };
    // the previous worker, if any
    this.previous = null;
}

GenericWorker.prototype = {
    /**
     * Push a chunk to the next workers.
     * @param {Object} chunk the chunk to push
     */
    push : function (chunk) {
        this.emit("data", chunk);
    },
    /**
     * End the stream.
     * @return {Boolean} true if this call ended the worker, false otherwise.
     */
    end : function () {
        if (this.isFinished) {
            return false;
        }

        this.flush();
        try {
            this.emit("end");
            this.cleanUp();
            this.isFinished = true;
        } catch (e) {
            this.emit("error", e);
        }
        return true;
    },
    /**
     * End the stream with an error.
     * @param {Error} e the error which caused the premature end.
     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
     */
    error : function (e) {
        if (this.isFinished) {
            return false;
        }

        if(this.isPaused) {
            this.generatedError = e;
        } else {
            this.isFinished = true;

            this.emit("error", e);

            // in the workers chain exploded in the middle of the chain,
            // the error event will go downward but we also need to notify
            // workers upward that there has been an error.
            if(this.previous) {
                this.previous.error(e);
            }

            this.cleanUp();
        }
        return true;
    },
    /**
     * Add a callback on an event.
     * @param {String} name the name of the event (data, end, error)
     * @param {Function} listener the function to call when the event is triggered
     * @return {GenericWorker} the current object for chainability
     */
    on : function (name, listener) {
        this._listeners[name].push(listener);
        return this;
    },
    /**
     * Clean any references when a worker is ending.
     */
    cleanUp : function () {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
        this._listeners = [];
    },
    /**
     * Trigger an event. This will call registered callback with the provided arg.
     * @param {String} name the name of the event (data, end, error)
     * @param {Object} arg the argument to call the callback with.
     */
    emit : function (name, arg) {
        if (this._listeners[name]) {
            for(var i = 0; i < this._listeners[name].length; i++) {
                this._listeners[name][i].call(this, arg);
            }
        }
    },
    /**
     * Chain a worker with an other.
     * @param {Worker} next the worker receiving events from the current one.
     * @return {worker} the next worker for chainability
     */
    pipe : function (next) {
        return next.registerPrevious(this);
    },
    /**
     * Same as `pipe` in the other direction.
     * Using an API with `pipe(next)` is very easy.
     * Implementing the API with the point of view of the next one registering
     * a source is easier, see the ZipFileWorker.
     * @param {Worker} previous the previous worker, sending events to this one
     * @return {Worker} the current worker for chainability
     */
    registerPrevious : function (previous) {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }

        // sharing the streamInfo...
        this.streamInfo = previous.streamInfo;
        // ... and adding our own bits
        this.mergeStreamInfo();
        this.previous =  previous;
        var self = this;
        previous.on('data', function (chunk) {
            self.processChunk(chunk);
        });
        previous.on('end', function () {
            self.end();
        });
        previous.on('error', function (e) {
            self.error(e);
        });
        return this;
    },
    /**
     * Pause the stream so it doesn't send events anymore.
     * @return {Boolean} true if this call paused the worker, false otherwise.
     */
    pause : function () {
        if(this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = true;

        if(this.previous) {
            this.previous.pause();
        }
        return true;
    },
    /**
     * Resume a paused stream.
     * @return {Boolean} true if this call resumed the worker, false otherwise.
     */
    resume : function () {
        if(!this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = false;

        // if true, the worker tried to resume but failed
        var withError = false;
        if(this.generatedError) {
            this.error(this.generatedError);
            withError = true;
        }
        if(this.previous) {
            this.previous.resume();
        }

        return !withError;
    },
    /**
     * Flush any remaining bytes as the stream is ending.
     */
    flush : function () {},
    /**
     * Process a chunk. This is usually the method overridden.
     * @param {Object} chunk the chunk to process.
     */
    processChunk : function(chunk) {
        this.push(chunk);
    },
    /**
     * Add a key/value to be added in the workers chain streamInfo once activated.
     * @param {String} key the key to use
     * @param {Object} value the associated value
     * @return {Worker} the current worker for chainability
     */
    withStreamInfo : function (key, value) {
        this.extraStreamInfo[key] = value;
        this.mergeStreamInfo();
        return this;
    },
    /**
     * Merge this worker's streamInfo into the chain's streamInfo.
     */
    mergeStreamInfo : function () {
        for(var key in this.extraStreamInfo) {
            if (!this.extraStreamInfo.hasOwnProperty(key)) {
                continue;
            }
            this.streamInfo[key] = this.extraStreamInfo[key];
        }
    },

    /**
     * Lock the stream to prevent further updates on the workers chain.
     * After calling this method, all calls to pipe will fail.
     */
    lock: function () {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }
        this.isLocked = true;
        if (this.previous) {
            this.previous.lock();
        }
    },

    /**
     *
     * Pretty print the workers chain.
     */
    toString : function () {
        var me = "Worker " + this.name;
        if (this.previous) {
            return this.previous + " -> " + me;
        } else {
            return me;
        }
    }
};

module.exports = GenericWorker;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Icon = (0, _react.createClass)({

  propTypes: {
    className: _react.PropTypes.string,
    label: _react.PropTypes.string,
    children: _react.PropTypes.any
  },

  render: function render() {
    var _props = this.props,
        className = _props.className,
        label = _props.label,
        iconStyle = _props.iconStyle,
        style = _props.style,
        other = _objectWithoutProperties(_props, ['className', 'label', 'iconStyle', 'style']);

    var classes = (0, _classnames2.default)('tc-icon', className);
    var child = void 0;
    if (label) {
      child = _react2.default.createElement(
        'div',
        {
          style: {
            'display': 'inline-block',
            'fontFamily': 'Open Sans',
            'marginLeft': '4px,'
          },
          className: 'tc-icon-label'
        },
        label
      );
    } else {
      child = this.props.children;
    }

    return _react2.default.createElement(
      'span',
      _extends({}, other, { style: _ramda2.default.merge(iconStyle, style), className: classes }),
      child
    );
  }
});

exports.default = Icon;

/***/ }),
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

/* global define */

(function (root, pluralize) {
  /* istanbul ignore else */
  if (true) {
    // Node.
    module.exports = pluralize();
  } else if (typeof define === 'function' && define.amd) {
    // AMD, registers as an anonymous module.
    define(function () {
      return pluralize();
    });
  } else {
    // Browser global.
    root.pluralize = pluralize();
  }
})(this, function () {
  // Rule storage - pluralize and singularize need to be run sequentially,
  // while other rules can be optimized using an object for instant lookups.
  var pluralRules = [];
  var singularRules = [];
  var uncountables = {};
  var irregularPlurals = {};
  var irregularSingles = {};

  /**
   * Title case a string.
   *
   * @param  {string} str
   * @return {string}
   */
  function toTitleCase (str) {
    return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
  }

  /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */
  function sanitizeRule (rule) {
    if (typeof rule === 'string') {
      return new RegExp('^' + rule + '$', 'i');
    }

    return rule;
  }

  /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */
  function restoreCase (word, token) {
    // Tokens are an exact match.
    if (word === token) {
      return token;
    }

    // Upper cased words. E.g. "HELLO".
    if (word === word.toUpperCase()) {
      return token.toUpperCase();
    }

    // Title cased words. E.g. "Title".
    if (word[0] === word[0].toUpperCase()) {
      return toTitleCase(token);
    }

    // Lower cased words. E.g. "test".
    return token.toLowerCase();
  }

  /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */
  function interpolate (str, args) {
    return str.replace(/\$(\d{1,2})/g, function (match, index) {
      return args[index] || '';
    });
  }

  /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {string}   token
   * @param  {string}   word
   * @param  {Array}    collection
   * @return {string}
   */
  function sanitizeWord (token, word, collection) {
    // Empty string or doesn't need fixing.
    if (!token.length || uncountables.hasOwnProperty(token)) {
      return word;
    }

    var len = collection.length;

    // Iterate over the sanitization rules and use the first one to match.
    while (len--) {
      var rule = collection[len];

      // If the rule passes, return the replacement.
      if (rule[0].test(word)) {
        return word.replace(rule[0], function (match, index, word) {
          var result = interpolate(rule[1], arguments);

          if (match === '') {
            return restoreCase(word[index - 1], result);
          }

          return restoreCase(match, result);
        });
      }
    }

    return word;
  }

  /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */
  function replaceWord (replaceMap, keepMap, rules) {
    return function (word) {
      // Get the correct token and case restoration functions.
      var token = word.toLowerCase();

      // Check against the keep object map.
      if (keepMap.hasOwnProperty(token)) {
        return restoreCase(word, token);
      }

      // Check against the replacement map for a direct word replacement.
      if (replaceMap.hasOwnProperty(token)) {
        return restoreCase(word, replaceMap[token]);
      }

      // Run all the rules against the word.
      return sanitizeWord(token, word, rules);
    };
  }

  /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {string}  word
   * @param  {number}  count
   * @param  {boolean} inclusive
   * @return {string}
   */
  function pluralize (word, count, inclusive) {
    var pluralized = count === 1
      ? pluralize.singular(word) : pluralize.plural(word);

    return (inclusive ? count + ' ' : '') + pluralized;
  }

  /**
   * Pluralize a word.
   *
   * @type {Function}
   */
  pluralize.plural = replaceWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Singularize a word.
   *
   * @type {Function}
   */
  pluralize.singular = replaceWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addPluralRule = function (rule, replacement) {
    pluralRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addSingularRule = function (rule, replacement) {
    singularRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */
  pluralize.addUncountableRule = function (word) {
    if (typeof word === 'string') {
      uncountables[word.toLowerCase()] = true;
      return;
    }

    // Set singular and plural references for the word.
    pluralize.addPluralRule(word, '$0');
    pluralize.addSingularRule(word, '$0');
  };

  /**
   * Add an irregular word definition.
   *
   * @param {string} single
   * @param {string} plural
   */
  pluralize.addIrregularRule = function (single, plural) {
    plural = plural.toLowerCase();
    single = single.toLowerCase();

    irregularSingles[single] = plural;
    irregularPlurals[plural] = single;
  };

  /**
   * Irregular rules.
   */
  [
    // Pronouns.
    ['I', 'we'],
    ['me', 'us'],
    ['he', 'they'],
    ['she', 'they'],
    ['them', 'them'],
    ['myself', 'ourselves'],
    ['yourself', 'yourselves'],
    ['itself', 'themselves'],
    ['herself', 'themselves'],
    ['himself', 'themselves'],
    ['themself', 'themselves'],
    ['is', 'are'],
    ['was', 'were'],
    ['has', 'have'],
    ['this', 'these'],
    ['that', 'those'],
    // Words ending in with a consonant and `o`.
    ['echo', 'echoes'],
    ['dingo', 'dingoes'],
    ['volcano', 'volcanoes'],
    ['tornado', 'tornadoes'],
    ['torpedo', 'torpedoes'],
    // Ends with `us`.
    ['genus', 'genera'],
    ['viscus', 'viscera'],
    // Ends with `ma`.
    ['stigma', 'stigmata'],
    ['stoma', 'stomata'],
    ['dogma', 'dogmata'],
    ['lemma', 'lemmata'],
    ['schema', 'schemata'],
    ['anathema', 'anathemata'],
    // Other irregular rules.
    ['ox', 'oxen'],
    ['axe', 'axes'],
    ['die', 'dice'],
    ['yes', 'yeses'],
    ['foot', 'feet'],
    ['eave', 'eaves'],
    ['goose', 'geese'],
    ['tooth', 'teeth'],
    ['quiz', 'quizzes'],
    ['human', 'humans'],
    ['proof', 'proofs'],
    ['carve', 'carves'],
    ['valve', 'valves'],
    ['looey', 'looies'],
    ['thief', 'thieves'],
    ['groove', 'grooves'],
    ['pickaxe', 'pickaxes'],
    ['whiskey', 'whiskies']
  ].forEach(function (rule) {
    return pluralize.addIrregularRule(rule[0], rule[1]);
  });

  /**
   * Pluralization rules.
   */
  [
    [/s?$/i, 's'],
    [/[^\u0000-\u007F]$/i, '$0'],
    [/([^aeiou]ese)$/i, '$1'],
    [/(ax|test)is$/i, '$1es'],
    [/(alias|[^aou]us|tlas|gas|ris)$/i, '$1es'],
    [/(e[mn]u)s?$/i, '$1s'],
    [/([^l]ias|[aeiou]las|[emjzr]as|[iu]am)$/i, '$1'],
    [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
    [/(seraph|cherub)(?:im)?$/i, '$1im'],
    [/(her|at|gr)o$/i, '$1oes'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
    [/sis$/i, 'ses'],
    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
    [/([^aeiouy]|qu)y$/i, '$1ies'],
    [/([^ch][ieo][ln])ey$/i, '$1ies'],
    [/(x|ch|ss|sh|zz)$/i, '$1es'],
    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
    [/(m|l)(?:ice|ouse)$/i, '$1ice'],
    [/(pe)(?:rson|ople)$/i, '$1ople'],
    [/(child)(?:ren)?$/i, '$1ren'],
    [/eaux$/i, '$0'],
    [/m[ae]n$/i, 'men'],
    ['thou', 'you']
  ].forEach(function (rule) {
    return pluralize.addPluralRule(rule[0], rule[1]);
  });

  /**
   * Singularization rules.
   */
  [
    [/s$/i, ''],
    [/(ss)$/i, '$1'],
    [/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)(?:sis|ses)$/i, '$1sis'],
    [/(^analy)(?:sis|ses)$/i, '$1sis'],
    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
    [/ies$/i, 'y'],
    [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'],
    [/\b(mon|smil)ies$/i, '$1ey'],
    [/(m|l)ice$/i, '$1ouse'],
    [/(seraph|cherub)im$/i, '$1'],
    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|tlas|gas|(?:her|at|gr)o|ris)(?:es)?$/i, '$1'],
    [/(e[mn]u)s?$/i, '$1'],
    [/(movie|twelve)s$/i, '$1'],
    [/(cris|test|diagnos)(?:is|es)$/i, '$1is'],
    [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
    [/(alumn|alg|vertebr)ae$/i, '$1a'],
    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
    [/(matr|append)ices$/i, '$1ix'],
    [/(pe)(rson|ople)$/i, '$1rson'],
    [/(child)ren$/i, '$1'],
    [/(eau)x?$/i, '$1'],
    [/men$/i, 'man']
  ].forEach(function (rule) {
    return pluralize.addSingularRule(rule[0], rule[1]);
  });

  /**
   * Uncountable rules.
   */
  [
    // Singular words with no plurals.
    'advice',
    'adulthood',
    'agenda',
    'aid',
    'alcohol',
    'ammo',
    'athletics',
    'bison',
    'blood',
    'bream',
    'buffalo',
    'butter',
    'carp',
    'cash',
    'chassis',
    'chess',
    'clothing',
    'commerce',
    'cod',
    'cooperation',
    'corps',
    'digestion',
    'debris',
    'diabetes',
    'energy',
    'equipment',
    'elk',
    'excretion',
    'expertise',
    'flounder',
    'fun',
    'gallows',
    'garbage',
    'graffiti',
    'headquarters',
    'health',
    'herpes',
    'highjinks',
    'homework',
    'housework',
    'information',
    'jeans',
    'justice',
    'kudos',
    'labour',
    'literature',
    'machinery',
    'mackerel',
    'mail',
    'media',
    'mews',
    'moose',
    'music',
    'news',
    'pike',
    'plankton',
    'pliers',
    'pollution',
    'premises',
    'rain',
    'research',
    'rice',
    'salmon',
    'scissors',
    'series',
    'sewage',
    'shambles',
    'shrimp',
    'species',
    'staff',
    'swine',
    'trout',
    'traffic',
    'transporation',
    'tuna',
    'wealth',
    'welfare',
    'whiting',
    'wildebeest',
    'wildlife',
    'you',
    // Regexes.
    /pox$/i, // "chickpox", "smallpox"
    /ois$/i,
    /deer$/i, // "deer", "reindeer"
    /fish$/i, // "fish", "blowfish", "angelfish"
    /sheep$/i,
    /measles$/i,
    /[^aeiou]ese$/i // "chinese", "japanese"
  ].forEach(pluralize.addUncountableRule);

  return pluralize;
});


/***/ }),
/* 69 */,
/* 70 */
/***/ (function(module, exports) {

module.exports = function _isPlaceholder(a) {
  return a != null &&
         typeof a === 'object' &&
         a['@@functional/placeholder'] === true;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */
module.exports = _curry2(function add(a, b) {
  return Number(a) + Number(b);
});


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _isPlaceholder = __webpack_require__(70);


/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curryN(length, received, fn) {
  return function() {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length &&
          (!_isPlaceholder(received[combinedIdx]) ||
           argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!_isPlaceholder(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined)
                     : _arity(left, _curryN(length, combined, fn));
  };
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _isArray = __webpack_require__(41);
var _isString = __webpack_require__(58);


/**
 * Tests whether or not an object is similar to an array.
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @deprecated since v0.23.0
 * @example
 *
 *      R.isArrayLike([]); //=> true
 *      R.isArrayLike(true); //=> false
 *      R.isArrayLike({}); //=> false
 *      R.isArrayLike({length: 10}); //=> false
 *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */
module.exports = _curry1(function isArrayLike(x) {
  if (_isArray(x)) { return true; }
  if (!x) { return false; }
  if (typeof x !== 'object') { return false; }
  if (_isString(x)) { return false; }
  if (x.nodeType === 1) { return !!x.length; }
  if (x.length === 0) { return true; }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig String -> a -> {k: v} -> {k: v}
 * @param {String} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */
module.exports = _curry3(function assoc(prop, val, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  result[prop] = val;
  return result;
});


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      var takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      var takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */
module.exports = _curry2(function nAry(n, fn) {
  switch (n) {
    case 0: return function() {return fn.call(this);};
    case 1: return function(a0) {return fn.call(this, a0);};
    case 2: return function(a0, a1) {return fn.call(this, a0, a1);};
    case 3: return function(a0, a1, a2) {return fn.call(this, a0, a1, a2);};
    case 4: return function(a0, a1, a2, a3) {return fn.call(this, a0, a1, a2, a3);};
    case 5: return function(a0, a1, a2, a3, a4) {return fn.call(this, a0, a1, a2, a3, a4);};
    case 6: return function(a0, a1, a2, a3, a4, a5) {return fn.call(this, a0, a1, a2, a3, a4, a5);};
    case 7: return function(a0, a1, a2, a3, a4, a5, a6) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6);};
    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);};
    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);};
    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);};
    default: throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
  }
});


/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var liftN = __webpack_require__(158);


/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      var madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */
module.exports = _curry1(function lift(fn) {
  return liftN(fn.length, fn);
});


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var curryN = __webpack_require__(13);


/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN
 * @example
 *
 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */
module.exports = _curry1(function curry(fn) {
  return curryN(fn.length, fn);
});


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _isString = __webpack_require__(58);


/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */
module.exports = _curry1(function reverse(list) {
  return _isString(list) ? list.split('').reverse().join('') :
                           Array.prototype.slice.call(list, 0).reverse();
});


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var _complement = __webpack_require__(168);
var _curry2 = __webpack_require__(1);
var filter = __webpack_require__(104);


/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      var isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
module.exports = _curry2(function reject(pred, filterable) {
  return filter(_complement(pred), filterable);
});


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var _curryN = __webpack_require__(72);
var _dispatchable = __webpack_require__(7);
var _has = __webpack_require__(14);
var _reduce = __webpack_require__(18);
var _xreduceBy = __webpack_require__(305);


/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
 *      var namesByGrade = reduceToNamesBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Lucy', score: 92},
 *                      {name: 'Drew', score: 85},
 *                      // ...
 *                      {name: 'Bart', score: 62}];
 *      namesByGrade(students);
 *      // {
 *      //   'A': ['Lucy'],
 *      //   'B': ['Drew']
 *      //   // ...,
 *      //   'F': ['Bart']
 *      // }
 */
module.exports = _curryN(4, [], _dispatchable([], _xreduceBy,
  function reduceBy(valueFn, valueAcc, keyFn, list) {
    return _reduce(function(acc, elt) {
      var key = keyFn(elt);
      acc[key] = valueFn(_has(key, acc) ? acc[key] : valueAcc, elt);
      return acc;
    }, {}, list);
  }));


/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = function _containsWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var curry = __webpack_require__(79);


/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> b -> c -> ... -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */
module.exports = _curry1(function flip(fn) {
  return curry(function(a, b) {
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = b;
    args[1] = a;
    return fn.apply(this, args);
  });
});


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var map = __webpack_require__(16);


/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */
module.exports = _curry2(function lens(getter, setter) {
  return function(toFunctorFn) {
    return function(target) {
      return map(
        function(focus) {
          return setter(focus, target);
        },
        toFunctorFn(getter(target))
      );
    };
  };
});


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var _isObject = __webpack_require__(106);
var mergeWithKey = __webpack_require__(114);


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeep, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */
module.exports = _curry3(function mergeDeepWithKey(fn, lObj, rObj) {
  return mergeWithKey(function(k, lVal, rVal) {
    if (_isObject(lVal) && _isObject(rVal)) {
      return mergeDeepWithKey(fn, lVal, rVal);
    } else {
      return fn(k, lVal, rVal);
    }
  }, lObj, rObj);
});


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer
var Transform = __webpack_require__(229).Transform
var StringDecoder = __webpack_require__(905).StringDecoder
var inherits = __webpack_require__(8)

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FlatButtonWithLoader = function (_Component) {
  _inherits(FlatButtonWithLoader, _Component);

  function FlatButtonWithLoader() {
    _classCallCheck(this, FlatButtonWithLoader);

    return _possibleConstructorReturn(this, (FlatButtonWithLoader.__proto__ || Object.getPrototypeOf(FlatButtonWithLoader)).apply(this, arguments));
  }

  _createClass(FlatButtonWithLoader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          loader = _props.loader,
          style = _props.style,
          extra = _objectWithoutProperties(_props, ['loader', 'style']);

      var combinedStyle = _extends({}, style);
      if (loader) return _react2.default.createElement(_materialUi.FlatButton, _extends({ className: 'signin-button loader', label: '...' }, extra, { disabled: true, style: combinedStyle }));
      return _react2.default.createElement(_materialUi.FlatButton, _extends({}, extra, { style: combinedStyle }));
    }
  }]);

  return FlatButtonWithLoader;
}(_react.Component);

FlatButtonWithLoader.propTypes = {
  loader: _react.PropTypes.any,
  style: _react.PropTypes.object
};

exports.default = FlatButtonWithLoader;

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(584);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "runSaga", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "END", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "eventChannel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "channel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "buffers", function() { return __WEBPACK_IMPORTED_MODULE_3__internal_buffers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(586);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "detach", function() { return __WEBPACK_IMPORTED_MODULE_6__internal_io__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(919);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "effects", function() { return __WEBPACK_IMPORTED_MODULE_7__effects__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_8__utils__; });

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmallRaisedButton = exports.SmallFlatButton = exports.JiraFlatButton = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var JiraFlatButton = function JiraFlatButton(_ref) {
  var labelStyle = _ref.labelStyle,
      extraProps = _objectWithoutProperties(_ref, ['labelStyle']);

  return _react2.default.createElement(SmallFlatButton, _extends({
    labelStyle: _ramda2.default.merge({ color: extraProps.secondary || extraProps.primary ? '' : '#5E6C84' }, labelStyle),
    backgroundColor: '#f4f5f7'
  }, extraProps));
};

exports.JiraFlatButton = JiraFlatButton;
var SmallFlatButton = function SmallFlatButton(_ref2) {
  var style = _ref2.style,
      labelStyle = _ref2.labelStyle,
      icon = _ref2.icon,
      extraProps = _objectWithoutProperties(_ref2, ['style', 'labelStyle', 'icon']);

  return _react2.default.createElement(_materialUi.FlatButton, _extends({
    labelStyle: _ramda2.default.merge({ textTransform: 'none', padding: '2px 4px', lineHeight: '24px', fontSize: '14px' }, labelStyle),
    style: _ramda2.default.merge({ height: '24px', lineHeight: '24px', minWidth: 0 }, style),
    icon: icon ? (0, _react.cloneElement)(icon, { style: _ramda2.default.merge({ width: '16px', fontSize: '14px', margin: '0 2px' }, _ramda2.default.path(['props', 'style'], icon)) }) : icon
  }, extraProps));
};

exports.SmallFlatButton = SmallFlatButton;
var SmallRaisedButton = function SmallRaisedButton(_ref3) {
  var style = _ref3.style,
      labelStyle = _ref3.labelStyle,
      icon = _ref3.icon,
      extraProps = _objectWithoutProperties(_ref3, ['style', 'labelStyle', 'icon']);

  return _react2.default.createElement(_materialUi.RaisedButton, _extends({
    labelStyle: _ramda2.default.merge({ textTransform: 'none', padding: '2px 4px', lineHeight: '24px', fontSize: '14px', bottom: '1px' }, labelStyle),
    style: _ramda2.default.merge({ height: '24px', lineHeight: '24px', minWidth: 0 }, style),
    icon: icon ? (0, _react.cloneElement)(icon, { style: _ramda2.default.merge({ width: '16px', fontSize: '14px', margin: '0 2px', position: 'relative' }, _ramda2.default.path(['props', 'style'], icon)) }) : icon
  }, extraProps));
};
exports.SmallRaisedButton = SmallRaisedButton;

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 */
module.exports = _curry2(function prop(p, obj) { return obj[p]; });


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry2 = __webpack_require__(1);
var _reduce = __webpack_require__(18);
var map = __webpack_require__(16);


/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */
module.exports = _curry2(function ap(applyF, applyX) {
  return (
    typeof applyX['fantasy-land/ap'] === 'function' ?
      applyX['fantasy-land/ap'](applyF) :
    typeof applyF.ap === 'function' ?
      applyF.ap(applyX) :
    typeof applyF === 'function' ?
      function(x) { return applyF(x)(applyX(x)); } :
    // else
      _reduce(function(acc, f) { return _concat(acc, map(f, applyX)); }, [], applyF)
  );
});


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */
module.exports = Number.isInteger || function _isInteger(n) {
  return (n << 0) === n;
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _makeFlat = __webpack_require__(159);
var _xchain = __webpack_require__(284);
var map = __webpack_require__(16);


/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      var duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */
module.exports = _curry2(_dispatchable(['fantasy-land/chain', 'chain'], _xchain, function chain(fn, monad) {
  if (typeof monad === 'function') {
    return function(x) { return fn(monad(x))(x); };
  }
  return _makeFlat(false)(map(fn, monad));
}));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 */
module.exports = _curry1(function type(val) {
  return val === null      ? 'Null'      :
         val === undefined ? 'Undefined' :
         Object.prototype.toString.call(val).slice(8, -1);
});


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var pipe = __webpack_require__(163);
var reverse = __webpack_require__(80);


/**
 * Performs right-to-left function composition. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipe
 * @example
 *
 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
 *
 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
 */
module.exports = function compose() {
  if (arguments.length === 0) {
    throw new Error('compose requires at least one argument');
  }
  return pipe.apply(this, reverse(arguments));
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(59);
var _curry1 = __webpack_require__(4);
var slice = __webpack_require__(45);


/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */
module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isArray = __webpack_require__(41);
var _isFunction = __webpack_require__(77);
var _isString = __webpack_require__(58);
var toString = __webpack_require__(60);


/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */
module.exports = _curry2(function concat(a, b) {
  if (_isArray(a)) {
    if (_isArray(b)) {
      return a.concat(b);
    }
    throw new TypeError(toString(b) + ' is not an array');
  }
  if (_isString(a)) {
    if (_isString(b)) {
      return a + b;
    }
    throw new TypeError(toString(b) + ' is not a string');
  }
  if (a != null && _isFunction(a['fantasy-land/concat'])) {
    return a['fantasy-land/concat'](b);
  }
  if (a != null && _isFunction(a.concat)) {
    return a.concat(b);
  }
  throw new TypeError(toString(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _filter = __webpack_require__(105);
var _isObject = __webpack_require__(106);
var _reduce = __webpack_require__(18);
var _xfilter = __webpack_require__(300);
var keys = __webpack_require__(32);


/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
module.exports = _curry2(_dispatchable(['filter'], _xfilter, function(pred, filterable) {
  return (
    _isObject(filterable) ?
      _reduce(function(acc, key) {
        if (pred(filterable[key])) {
          acc[key] = filterable[key];
        }
        return acc;
      }, {}, keys(filterable)) :
    // else
      _filter(pred, filterable)
  );
}));


/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var adjust = __webpack_require__(147);
var always = __webpack_require__(49);


/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
 *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */
module.exports = _curry3(function update(idx, x, list) {
  return adjust(always(x), idx, list);
});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xtake = __webpack_require__(313);
var slice = __webpack_require__(45);


/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      var personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      var takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */
module.exports = _curry2(_dispatchable(['take'], _xtake, function take(n, xs) {
  return slice(0, n < 0 ? Infinity : n, xs);
}));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _identity = __webpack_require__(110);


/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      var obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */
module.exports = _curry1(_identity);


/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = function _identity(x) { return x; };


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(109);
var uniqBy = __webpack_require__(183);


/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */
module.exports = uniqBy(identity);


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var _containsWith = __webpack_require__(83);
var _curry2 = __webpack_require__(1);


/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig (a, a -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      var strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */
module.exports = _curry2(function uniqWith(pred, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  var item;
  while (idx < len) {
    item = list[idx];
    if (!_containsWith(pred, item, result)) {
      result[result.length] = item;
    }
    idx += 1;
  }
  return result;
});


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var _objectAssign = __webpack_require__(359);

module.exports =
  typeof Object.assign === 'function' ? Object.assign : _objectAssign;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var _has = __webpack_require__(14);


/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */
module.exports = _curry3(function mergeWithKey(fn, l, r) {
  var result = {};
  var k;

  for (k in l) {
    if (_has(k, l)) {
      result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
    }
  }

  for (k in r) {
    if (_has(k, r) && !(_has(k, result))) {
      result[k] = r[k];
    }
  }

  return result;
});


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return detach; });
/* harmony export (immutable) */ __webpack_exports__["s"] = take;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return takem; });
/* harmony export (immutable) */ __webpack_exports__["n"] = put;
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* harmony export (immutable) */ __webpack_exports__["o"] = race;
/* harmony export (immutable) */ __webpack_exports__["e"] = call;
/* harmony export (immutable) */ __webpack_exports__["c"] = apply;
/* harmony export (immutable) */ __webpack_exports__["h"] = cps;
/* harmony export (immutable) */ __webpack_exports__["k"] = fork;
/* harmony export (immutable) */ __webpack_exports__["r"] = spawn;
/* harmony export (immutable) */ __webpack_exports__["m"] = join;
/* harmony export (immutable) */ __webpack_exports__["f"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["p"] = select;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* harmony export (immutable) */ __webpack_exports__["g"] = cancelled;
/* harmony export (immutable) */ __webpack_exports__["j"] = flush;
/* harmony export (immutable) */ __webpack_exports__["l"] = getContext;
/* harmony export (immutable) */ __webpack_exports__["q"] = setContext;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);


var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

exports.base64 = true;
exports.array = true;
exports.string = true;
exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
exports.nodebuffer = typeof Buffer !== "undefined";
// contains true if JSZip can read/generate Uint8Array, false otherwise.
exports.uint8array = typeof Uint8Array !== "undefined";

if (typeof ArrayBuffer === "undefined") {
    exports.blob = false;
}
else {
    var buffer = new ArrayBuffer(0);
    try {
        exports.blob = new Blob([buffer], {
            type: "application/zip"
        }).size === 0;
    }
    catch (e) {
        try {
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            exports.blob = builder.getBlob('application/zip').size === 0;
        }
        catch (e) {
            exports.blob = false;
        }
    }
}

try {
    exports.nodestream = !!__webpack_require__(588).Readable;
} catch(e) {
    exports.nodestream = false;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var request = function request(method, url) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var opts = {
    method: method,
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    cache: 'no-store'
  };

  if (body) {
    opts.body = JSON.stringify(body);
  }
  return fetch(url, opts);
};

var get = exports.get = function get(url) {
  return request('GET', url);
};

var post = exports.post = function post(url, body) {
  return request('POST', url, body);
};

var put = exports.put = function put(url, body) {
  return request('PUT', url, body);
};

var del = exports.del = function del(url, body) {
  return request('DELETE', url, body);
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(10).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > 65536) throw new Error('requested too many random bytes')
  // in case browserify  isn't using the Uint8Array version
  var rawBytes = new global.Uint8Array(size)

  // This will not work in older browsers.
  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
  if (size > 0) {  // getRandomValues fails on IE if size == 0
    crypto.getRandomValues(rawBytes)
  }

  // XXX: phantomjs doesn't like a buffer being passed here
  var bytes = Buffer.from(rawBytes.buffer)

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(93)))

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _util = __webpack_require__(997);

var _inject = __webpack_require__(1127);

var StyleSheet = {
    create: function create(sheetDefinition) {
        return (0, _util.mapObj)(sheetDefinition, function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2);

            var key = _ref2[0];
            var val = _ref2[1];

            return [key, {
                // TODO(emily): Make a 'production' mode which doesn't prepend
                // the class name here, to make the generated CSS smaller.
                _name: key + '_' + (0, _util.hashObject)(val),
                _definition: val
            }];
        });
    },

    rehydrate: function rehydrate() {
        var renderedClassNames = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

        (0, _inject.addRenderedClassNames)(renderedClassNames);
    }
};

/**
 * Utilities for using Aphrodite server-side.
 */
var StyleSheetServer = {
    renderStatic: function renderStatic(renderFunc) {
        (0, _inject.reset)();
        (0, _inject.startBuffering)();
        var html = renderFunc();
        var cssContent = (0, _inject.flushToString)();

        return {
            html: html,
            css: {
                content: cssContent,
                renderedClassNames: (0, _inject.getRenderedClassNames)()
            }
        };
    }
};

/**
 * Utilities for using Aphrodite in tests.
 *
 * Not meant to be used in production.
 */
var StyleSheetTestUtils = {
    /**
     * Prevent styles from being injected into the DOM.
     *
     * This is useful in situations where you'd like to test rendering UI
     * components which use Aphrodite without any of the side-effects of
     * Aphrodite happening. Particularly useful for testing the output of
     * components when you have no DOM, e.g. testing in Node without a fake DOM.
     *
     * Should be paired with a subsequent call to
     * clearBufferAndResumeStyleInjection.
     */
    suppressStyleInjection: function suppressStyleInjection() {
        (0, _inject.reset)();
        (0, _inject.startBuffering)();
    },

    /**
     * Opposite method of preventStyleInject.
     */
    clearBufferAndResumeStyleInjection: function clearBufferAndResumeStyleInjection() {
        (0, _inject.reset)();
    }
};

var css = function css() {
    for (var _len = arguments.length, styleDefinitions = Array(_len), _key = 0; _key < _len; _key++) {
        styleDefinitions[_key] = arguments[_key];
    }

    var useImportant = true; // Append !important to all style definitions
    return (0, _inject.injectAndGetClassName)(useImportant, styleDefinitions);
};

exports['default'] = {
    StyleSheet: StyleSheet,
    StyleSheetServer: StyleSheetServer,
    StyleSheetTestUtils: StyleSheetTestUtils,
    css: css
};
module.exports = exports['default'];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPriorityIcon = exports.getPriorityColor = exports.processPartnersForSendingRates = exports.checkIfDuplicateTemplatesSent = exports.getTemplateStatus = exports.getTemplateStatusColor = exports.processEditHistories = exports.stateValMap = exports.getActionIndicatorColor = exports.prettifyDays = exports.checkIfRatesReceived = exports.checkIfIsANewDraft = exports.checkIfIsANewRequest = exports.getIconEle = exports.getStatusIcon = exports.getStatusColor = exports.getSentState = exports.getShownState = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _description = __webpack_require__(561);

var _description2 = _interopRequireDefault(_description);

var _send = __webpack_require__(577);

var _send2 = _interopRequireDefault(_send);

var _lock = __webpack_require__(578);

var _lock2 = _interopRequireDefault(_lock);

var _contentPaste = __webpack_require__(1424);

var _contentPaste2 = _interopRequireDefault(_contentPaste);

var _highlight = __webpack_require__(1213);

var _highlight2 = _interopRequireDefault(_highlight);

var _arrowUpward = __webpack_require__(1425);

var _arrowUpward2 = _interopRequireDefault(_arrowUpward);

var _arrowDownward = __webpack_require__(1426);

var _arrowDownward2 = _interopRequireDefault(_arrowDownward);

var _tourconnectLogoGlobe = __webpack_require__(231);

var _tourconnectLogoGlobe2 = _interopRequireDefault(_tourconnectLogoGlobe);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var originFromMap = {
  multiLocSinglePartner: true,
  multiLocMultiPartners: true,
  multiLocRes: true,
  singleLocStarter: true
};

var locationIdExists = (0, _ramda.compose)(function (val) {
  return (0, _ramda.identity)(val);
}, (0, _ramda.prop)('locationId'));

var transformSupplierState = (0, _ramda.cond)([[function (contract) {
  return !contract.locationId && !contract.buyerChecked;
}, (0, _ramda.always)('request')], [function (contract) {
  return contract.state === 'pending';
}, (0, _ramda.always)('sent')], [_ramda.T, (0, _ramda.prop)('state')]]);

var separatePendingForBuyer = (0, _ramda.cond)([[locationIdExists, (0, _ramda.always)('received')], [function (obj) {
  return (0, _ramda.prop)('buyerChecked', obj);
}, (0, _ramda.always)('received')], [_ramda.T, (0, _ramda.always)('sent')]]);
var transformBuyerState = function transformBuyerState(contract) {
  if (contract.locationId) {
    if (contract.state === 'pending') return separatePendingForBuyer(contract);
    return contract.state;
  }
  if (contract.rateConversionStatus === 'in progress' || contract.rateConversionStatus === 'complete') {
    if (contract.lastSent) {
      if (contract.buyerChecked) return 'received';
      return 'sent';
    }
  }
  return contract.rateConversionStatus;
};

var getShownState = function getShownState(contract) {
  return contract.companyType === 'Contractor' ? transformBuyerState(contract) : transformSupplierState(contract);
};

var getTemplateStatus = function getTemplateStatus(doc) {
  var hasSeenResponseWizard = doc.hasSeenResponseWizard,
      state = doc.state,
      isArchived = doc.isArchived;

  return _ramda2.default.call(_ramda2.default.cond([[function () {
    return hasSeenResponseWizard;
  }, _ramda2.default.always('draft')], [function () {
    return Boolean(state);
  }, _ramda2.default.always('new draft')], [function () {
    return isArchived;
  }, _ramda2.default.always('archived')], [_ramda2.default.T, _ramda2.default.always('completed')]]));
};

var getTemplateStatusColor = _ramda2.default.cond([[(0, _ramda.equals)('completed'), (0, _ramda.always)('green')], [(0, _ramda.equals)('draft'), (0, _ramda.always)('#911ba8')], [(0, _ramda.equals)('new draft'), (0, _ramda.always)('#ffb700')], [(0, _ramda.equals)('archived'), (0, _ramda.always)('#005662')], [_ramda2.default.T, (0, _ramda.always)('#005662')]]);

var getStatusColor = (0, _ramda.cond)([
// [equals('downloaded'), always('#009688')],
[(0, _ramda.anyPass)([(0, _ramda.equals)('viewed'), (0, _ramda.equals)('pending')]), (0, _ramda.always)('#ffb700')], [(0, _ramda.equals)('accepted'), (0, _ramda.always)('#31b5f7')], [(0, _ramda.equals)('loading'), (0, _ramda.always)('#3fa641')], [(0, _ramda.equals)('loaded'), (0, _ramda.always)('#33691e')], [(0, _ramda.equals)('rejected'), (0, _ramda.always)('#f5372a')], [(0, _ramda.equals)('bounced'), (0, _ramda.always)('red')], [_ramda2.default.equals('in progress'), _ramda2.default.always('#911ba8')], [_ramda2.default.equals('complete'), _ramda2.default.always('#7ac5ec')], [(0, _ramda.anyPass)([(0, _ramda.equals)('rates received'), (0, _ramda.equals)('request')]), (0, _ramda.always)('#ffb700')], [(0, _ramda.equals)('sent'), (0, _ramda.always)('#616061')], [(0, _ramda.equals)('total'), (0, _ramda.always)('#f9a8259c')], [(0, _ramda.equals)('received-analytics'), (0, _ramda.always)('#06a9bf')], [(0, _ramda.equals)('accepted-analytics'), (0, _ramda.always)('#7ac5ec')], [(0, _ramda.equals)('loaded-analytics'), (0, _ramda.always)('#69af90')], [_ramda.T, (0, _ramda.always)('#06a9bf')]]);
var getPriorityColor = (0, _ramda.cond)([[(0, _ramda.equals)('Highest'), (0, _ramda.always)('#b71c1c')], [(0, _ramda.equals)('High'), (0, _ramda.always)('#e53935')], [(0, _ramda.equals)('Medium'), (0, _ramda.always)('#f57c00')], [(0, _ramda.equals)('Low'), (0, _ramda.always)('#33691e')], [(0, _ramda.equals)('Lowest'), (0, _ramda.always)('#8bc34a')]]);

var getPriorityIcon = (0, _ramda.cond)([[(0, _ramda.equals)('Highest'), (0, _ramda.always)(_react2.default.createElement(_arrowUpward2.default, { color: '#b71c1c' }))], [(0, _ramda.equals)('High'), (0, _ramda.always)(_react2.default.createElement(_arrowUpward2.default, { color: '#e53935' }))], [(0, _ramda.equals)('Medium'), (0, _ramda.always)(_react2.default.createElement(_arrowUpward2.default, { color: '#f57c00' }))], [(0, _ramda.equals)('Low'), (0, _ramda.always)(_react2.default.createElement(_arrowDownward2.default, { color: '#33691e' }))], [(0, _ramda.equals)('Lowest'), (0, _ramda.always)(_react2.default.createElement(_arrowDownward2.default, { color: '#8bc34a' }))]]);

var getStatusIcon = (0, _ramda.cond)([
// [equals('downloaded'), always('tc-icon-archive')],
[(0, _ramda.anyPass)([(0, _ramda.equals)('viewed'), (0, _ramda.equals)('pending')]), (0, _ramda.always)('tc-icon-av_timer')], [(0, _ramda.equals)('accepted'), (0, _ramda.always)('tc-icon-thumb_up')], [(0, _ramda.equals)('loading'), (0, _ramda.always)('tc-icon-watch_later')], [(0, _ramda.equals)('loaded'), (0, _ramda.always)('tc-icon-assignment_turned_in')], [(0, _ramda.equals)('rejected'), (0, _ramda.always)('tc-icon-thumb_down')], [(0, _ramda.anyPass)([(0, _ramda.equals)('draft'), (0, _ramda.equals)('publish-ready'), (0, _ramda.equals)('new draft')]), (0, _ramda.always)('tc-icon-mode_edit')], [(0, _ramda.equals)('sent'), (0, _ramda.always)('tc-icon-paperplane')], [_ramda.T, (0, _ramda.always)('tc-icon-description')]]);

var getIconEle = function getIconEle(_ref) {
  var _ref$showEmailAndCont = _ref.showEmailAndContractStatus,
      showEmailAndContractStatus = _ref$showEmailAndCont === undefined ? true : _ref$showEmailAndCont,
      contractStatus = _ref.status,
      companyType = _ref.companyType,
      overwriteColor = _ref.overwriteColor,
      otherSideRead = _ref.otherSideRead,
      emailStatus = _ref.emailStatus,
      convertedFromExternal = _ref.convertedFromExternal;

  var addMailAndReadIcons = function addMailAndReadIcons(largeIcon) {
    var mailStatusIcon = showEmailAndContractStatus ? function () {
      if (emailStatus === 0) return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-more_vert', style: { fontSize: '10px', color: 'rgba(0, 0, 0, 0.44)' } });
      if (emailStatus < 2) return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-close', style: { fontSize: '10px', color: 'red' } });
      if (emailStatus === 2) return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-check', style: { fontSize: '10px', color: 'green' } });
      if (emailStatus > 2) return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-drafts', style: { fontSize: '10px', color: 'rgba(0, 0, 0, 0.44)' } });
      return undefined;
    }() : undefined;
    var mailAndReadStatusIcons = function () {
      if (otherSideRead && showEmailAndContractStatus) {
        return _react2.default.createElement(
          'div',
          { style: { display: 'flex', flexDirection: 'column' } },
          mailStatusIcon,
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-remove_red_eye', style: { fontSize: '10px', color: 'rgba(0, 0, 0, 0.44)' } })
        );
      }
      return mailStatusIcon;
    }();
    return _react2.default.createElement(
      'div',
      { className: 'flex-tc-sb' },
      mailAndReadStatusIcons,
      largeIcon
    );
  };
  var getIconHover = function getIconHover(defaultText) {
    var retVal = defaultText ? [defaultText] : [];
    if (showEmailAndContractStatus) {
      if (emailStatus === 0) retVal.push('Email Sending');
      if (emailStatus === 1) retVal.push('Email Bounced');
      if (emailStatus === 2) retVal.push('Email Delivered');
      if (emailStatus === 3) retVal.push('Email Opened');
      if (emailStatus === 4) retVal.push('Email Clicked');
      if (otherSideRead) retVal.push('' + (contractStatus === 'request' ? 'Request Viewed' : 'Contract Viewed/Downloaded'));
    }
    return retVal.join(', ');
  };
  var addIconHover = function addIconHover(largeIcon) {
    if (!showEmailAndContractStatus) return largeIcon;
    return _react2.default.createElement(
      'div',
      {
        className: 'hint--top',
        'aria-label': getIconHover()
      },
      addMailAndReadIcons(largeIcon)
    );
  };
  var fontIconStyle = { marginLeft: '0.1em' }; // the svg icons hav e a margin by default
  return _ramda2.default.cond([[_ramda2.default.equals('unpaid'), (0, _ramda.always)(_react2.default.createElement(
    _wrapper2.default,
    { slug: 'upgrade-rates-msgs', hideOnSkip: true, blocker: true, skipBack: true },
    _react2.default.createElement(
      'div',
      {
        className: 'hint--top',
        'aria-label': 'Upgrade to view the status of your Sent ' + (companyType === 'Contractor' ? 'Requests' : 'Contracts') + ' (Bounced, Delivered, Opened)'
      },
      _react2.default.createElement(_lock2.default, { style: { fill: overwriteColor || '#FFD700', cursor: 'pointer' } })
    )
  ))], [_ramda2.default.equals('sent'), (0, _ramda.always)(addIconHover(_react2.default.createElement(_send2.default, { color: overwriteColor || 'rgba(0, 0, 0, 0.44)' })))], [_ramda2.default.equals('rates received externally'), (0, _ramda.always)(_react2.default.createElement(
    'span',
    {
      className: 'hint--top',
      'aria-label': getIconHover(convertedFromExternal ? 'TC Rate Conversion' : 'Non-Standard format'),
      style: { width: '35px', display: 'inline-block' }
    },
    addMailAndReadIcons(_react2.default.createElement(
      'div',
      { style: { position: 'relative' } },
      Boolean(convertedFromExternal) && _react2.default.createElement(_highlight2.default, {
        style: {
          position: 'absolute',
          right: '13px',
          top: '13px',
          height: '15px',
          width: '15px',
          color: '#8f8f8f'
        }
      }),
      _react2.default.createElement(_description2.default, { color: overwriteColor || 'rgba(0, 0, 0, 0.44)' }),
      _react2.default.createElement(
        'span',
        {
          style: {
            position: 'absolute',
            display: 'inline-block',
            top: '13px',
            left: '13px',
            height: '12px',
            width: '12px',
            lineHeight: '12px',
            textAlign: 'center',
            fontSize: '10px',
            fontWeight: 'bold',
            borderRadius: '50%',
            backgroundColor: '#8f8f8f',
            color: 'white'
          }
        },
        '?'
      )
    ))
  ))], [_ramda2.default.equals('rates received'), (0, _ramda.always)(_react2.default.createElement(
    'span',
    {
      className: 'hint--top',
      'aria-label': getIconHover(convertedFromExternal ? 'TC format converted by assignee' : 'TourConnect format'),
      style: { width: '35px', display: 'inline-block' }
    },
    addMailAndReadIcons(_react2.default.createElement(
      'div',
      { style: { position: 'relative' } },
      Boolean(convertedFromExternal) && _react2.default.createElement(_highlight2.default, {
        style: {
          position: 'absolute',
          right: '13px',
          top: '13px',
          height: '15px',
          width: '15px',
          color: '#3fbbe5'
        }
      }),
      _react2.default.createElement(_description2.default, { color: overwriteColor || 'rgba(0, 0, 0, 0.44)' }),
      _react2.default.createElement('img', {
        src: _tourconnectLogoGlobe2.default,
        style: {
          position: 'absolute',
          left: '13px',
          top: '13px',
          height: '15px',
          width: '15px'
        }
      })
    ))
  ))], [_ramda2.default.equals('received'), (0, _ramda.always)(_react2.default.createElement(_description2.default, { color: overwriteColor || 'rgba(0, 0, 0, 0.44)' }))], [_ramda2.default.equals('viewed'), (0, _ramda.always)(_react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-remove_red_eye', color: overwriteColor || '#00bcd4', style: fontIconStyle }))], [_ramda2.default.equals('accepted'), (0, _ramda.always)(addIconHover(_react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-thumb_up', color: overwriteColor || '#31b5f7', style: fontIconStyle })))], [_ramda2.default.equals('loading'), (0, _ramda.always)(addIconHover(_react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-watch_later', color: overwriteColor || '#3fa641', style: fontIconStyle })))], [_ramda2.default.equals('loaded'), (0, _ramda.always)(addIconHover(_react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-assignment_turned_in', color: overwriteColor || '#33691e', style: fontIconStyle })))], [_ramda2.default.equals('rejected'), (0, _ramda.always)(addIconHover(_react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-thumb_down', color: overwriteColor || '#f5372a', style: fontIconStyle })))], [_ramda2.default.equals('request'), (0, _ramda.always)(addIconHover(_react2.default.createElement(_contentPaste2.default, { style: { color: overwriteColor || '#ffb700' } })))]])(contractStatus);
};

var checkIfIsANewRequest = function checkIfIsANewRequest(contract) {
  return !(0, _ramda.prop)('locationId', contract);
};
var checkIfIsANewDraft = (0, _ramda.both)(function (contract) {
  return (0, _ramda.has)((0, _ramda.prop)('originFrom', contract), originFromMap);
}, (0, _ramda.propEq)('hasSeenResponseWizard', false));
var checkIfRatesReceived = (0, _ramda.both)((0, _ramda.propEq)('state', 'pending'), function (contract) {
  return Boolean((0, _ramda.prop)('locationId', contract));
});

var prettifyDays = function prettifyDays(days) {
  if (days && days.length > 0) {
    if (days.length === 7) return '';
    if (days.length === 1) return days[0] + ' Only';
    var _getConsectuiveDays = function _getConsectuiveDays() {
      var _mapDaysToNumbers = function _mapDaysToNumbers(day) {
        switch (day) {
          case 'Monday':
            return 1;
          case 'Tuesday':
            return 2;
          case 'Wednesday':
            return 3;
          case 'Thursday':
            return 4;
          case 'Friday':
            return 5;
          case 'Saturday':
            return 6;
          case 'Sunday':
            return 7;
        }
      };
      var _mapNumbersToDays = function _mapNumbersToDays(num) {
        switch (num) {
          case 1:
            return 'Mon';
          case 2:
            return 'Tue';
          case 3:
            return 'Wed';
          case 4:
            return 'Thu';
          case 5:
            return 'Fri';
          case 6:
            return 'Sat';
          case 7:
            return 'Sun';
        }
      };
      var dayNumbers = (0, _ramda.map)(_mapDaysToNumbers, days).sort();
      var currentDay, previousDay, firstDay, lastDay;
      for (var i = 0; i < dayNumbers.length; i++) {
        currentDay = dayNumbers[i];
        if (!firstDay) firstDay = currentDay;
        lastDay = currentDay;
        if (i > 0 && i < dayNumbers.length) {
          previousDay = dayNumbers[i - 1];
          if (currentDay - previousDay > 1) return false;
        }
      }
      return _mapNumbersToDays(firstDay) + ' - ' + _mapNumbersToDays(lastDay);
    };
    var _mapLongNameToShort = function _mapLongNameToShort(long) {
      switch (long) {
        case 'Monday':
          return 'Mon';
        case 'Tuesday':
          return 'Tue';
        case 'Wednesday':
          return 'Wed';
        case 'Thursday':
          return 'Thu';
        case 'Friday':
          return 'Fri';
        case 'Saturday':
          return 'Sat';
        case 'Sunday':
          return 'Sun';
      }
    };
    var consecutiveDays = _getConsectuiveDays(days);
    return consecutiveDays ? consecutiveDays : days.map(_mapLongNameToShort).join(', ');
  }
};
var getActionIndicatorColor = function getActionIndicatorColor(_ref2) {
  var viewingBy = _ref2.viewingBy,
      ratesReceived = _ref2.ratesReceived,
      ratesLoaded = _ref2.ratesLoaded;

  if (ratesLoaded) return 'transparent';
  if (viewingBy === 'Supplier') {
    if (ratesReceived) return '#4db6ac';
    return '#ff6f00';
  }
  if (ratesReceived) return '#ff6f00';
  return '#4db6ac';
};

var stateValMap = {
  sent: 1,
  received: 2,
  accepted: 3,
  rejected: 3,
  loading: 3,
  loaded: 3
};
var getSentState = function getSentState(viewedFlag, emailStatus) {
  if (viewedFlag || emailStatus > 2) return 'opened';
  if (emailStatus === 0) return 'sent';
  if (emailStatus === 2) return 'delivered';
  if (emailStatus > 2) return 'opened';
  return 'bounced';
};
var processEditHistories = function processEditHistories(editHistory, productsArray) {
  var productsMap = productsArray.reduce(function (result, product) {
    result[product.productId] = product.productName;
    return result;
  }, {});
  var nonProductEditDetails = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.join('|'), _ramda2.default.uniq, _ramda2.default.map(_ramda2.default.prop('detail')), _ramda2.default.reject(_ramda2.default.prop('productId'))), editHistory);
  // filter edits for product that has been removed
  var productEdits = editHistory.filter(function (item) {
    return item.productId && productsMap[item.productId];
  });
  var groupedByProdNameNPackage = _ramda2.default.groupBy(function (_ref3) {
    var productId = _ref3.productId,
        ratePackageName = _ref3.ratePackageName;

    var isSinglePackage = productsArray.filter(function (obj) {
      return obj.productId === productId;
    }).length < 2;
    return '' + productsMap[productId] + (ratePackageName && !isSinglePackage ? ' - ' + ratePackageName : '');
  }, productEdits);
  return [{
    name: 'Policies & Notes',
    details: nonProductEditDetails
  }].concat(_toConsumableArray(_ramda2.default.keys(groupedByProdNameNPackage).map(function (name) {
    var edits = groupedByProdNameNPackage[name];
    return {
      name: name,
      details: _ramda2.default.call(_ramda2.default.compose(_ramda2.default.join('|'), _ramda2.default.uniq, _ramda2.default.map(_ramda2.default.prop('detail'))), edits)
    };
  }))).filter(_ramda2.default.prop('details'));
};

var checkIfDuplicateTemplatesSent = function checkIfDuplicateTemplatesSent(contract, template) {
  // not the save contracting period
  if (contract.startDate !== template.startDate || contract.endDate !== template.endDate) return false;
  if (contract.templateId === template._id) return true;
  if (contract.locationId === template.locationId &&
  // for some reason, some contract passed to this function have the marketInfo out of the supplierInfo
  // therefore adding ternary check to avoid breaking other processes
  (_ramda2.default.path(['supplierInfo', 'marketInfo'], contract) || contract.marketInfo || '') === (_ramda2.default.path(['supplierInfo', 'marketInfo'], template) || '')) return true;
  return false;
};

var processPartnersForSendingRates = _ramda2.default.curry(function (templateSelected, templateGroupSelected, partner) {
  // if email has account but wrong account type, treat it as external
  if (partner._type === 'Supplier' && !(partner.email && partner.email.indexOf('@') > -1)) return 'Cannot send to Supplier';
  var existingContracts = partner.contracts ? partner.contracts.filter(function (contract) {
    if (templateGroupSelected && templateGroupSelected.templates && templateGroupSelected.templates.length) {
      return templateGroupSelected.templates.some(function (template) {
        return checkIfDuplicateTemplatesSent(contract, template);
      });
    }
    return checkIfDuplicateTemplatesSent(contract, templateSelected);
  }) : [];
  if (existingContracts.length) {
    // const ids = encodeURIComponent(JSON.stringify(existingContracts.map(obj => obj._id)));
    // return (
    //   <span>
    //   * Contract exists
    //     <a
    //       target="_blank"
    //       href={`/contracting/contract-list/search?ids=${ids}&resend=true`}
    //     >
    //       View & Resend
    //     </a>
    //   </span>);
    return '* Contract exists';
  }
});

exports.getShownState = getShownState;
exports.getSentState = getSentState;
exports.getStatusColor = getStatusColor;
exports.getStatusIcon = getStatusIcon;
exports.getIconEle = getIconEle;
exports.checkIfIsANewRequest = checkIfIsANewRequest;
exports.checkIfIsANewDraft = checkIfIsANewDraft;
exports.checkIfRatesReceived = checkIfRatesReceived;
exports.prettifyDays = prettifyDays;
exports.getActionIndicatorColor = getActionIndicatorColor;
exports.stateValMap = stateValMap;
exports.processEditHistories = processEditHistories;
exports.getTemplateStatusColor = getTemplateStatusColor;
exports.getTemplateStatus = getTemplateStatus;
exports.checkIfDuplicateTemplatesSent = checkIfDuplicateTemplatesSent;
exports.processPartnersForSendingRates = processPartnersForSendingRates;
exports.getPriorityColor = getPriorityColor;
exports.getPriorityIcon = getPriorityIcon;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1027);
var objectAssign = __webpack_require__(127);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1571)();
}


/***/ }),
/* 127 */,
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TwoColumnRow = function (_Component) {
  _inherits(TwoColumnRow, _Component);

  function TwoColumnRow() {
    _classCallCheck(this, TwoColumnRow);

    return _possibleConstructorReturn(this, (TwoColumnRow.__proto__ || Object.getPrototypeOf(TwoColumnRow)).apply(this, arguments));
  }

  _createClass(TwoColumnRow, [{
    key: 'render',
    value: function render() {
      if (this.props.hide) return false;
      var leftColumnStyle = _extends({}, {
        float: 'left'
      }, this.props.leftColumnStyle);
      var rightColumnStyle = _extends({}, {
        float: 'right'
      }, this.props.rightColumnStyle);
      var outerContainerStyle = _extends({}, {
        overflow: 'auto',
        display: 'block',
        marginBottom: '24px'
      }, this.props.outerContainerStyle);
      return _react2.default.createElement(
        'div',
        { style: outerContainerStyle },
        _react2.default.createElement(
          'div',
          { style: leftColumnStyle, className: this.props.leftColumnClassName },
          this.props.leftColumnContent
        ),
        _react2.default.createElement(
          'div',
          { style: rightColumnStyle, className: this.props.rightColumnClassName },
          this.props.rightColumnContent
        )
      );
    }
  }]);

  return TwoColumnRow;
}(_react.Component);

TwoColumnRow.propTypes = {
  leftColumnClassName: _react.PropTypes.string,
  rightColumnClassName: _react.PropTypes.string,
  className: _react.PropTypes.string,
  outerContainerStyle: _react.PropTypes.object,
  leftColumnStyle: _react.PropTypes.object,
  rightColumnStyle: _react.PropTypes.object,
  leftColumnContent: _react.PropTypes.node,
  rightColumnContent: _react.PropTypes.node,
  hide: _react.PropTypes.bool
};

exports.default = TwoColumnRow;

/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RaisedButtonWithLoader = function (_Component) {
  _inherits(RaisedButtonWithLoader, _Component);

  function RaisedButtonWithLoader() {
    _classCallCheck(this, RaisedButtonWithLoader);

    return _possibleConstructorReturn(this, (RaisedButtonWithLoader.__proto__ || Object.getPrototypeOf(RaisedButtonWithLoader)).apply(this, arguments));
  }

  _createClass(RaisedButtonWithLoader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          loader = _props.loader,
          extraProps = _objectWithoutProperties(_props, ['loader']);

      if (loader) return _react2.default.createElement(_materialUi.RaisedButton, _extends({ className: 'loader', label: ' ' }, extraProps, { disabled: true }));
      return _react2.default.createElement(_materialUi.RaisedButton, extraProps);
    }
  }]);

  return RaisedButtonWithLoader;
}(_react.Component);

RaisedButtonWithLoader.propTypes = {
  loader: _react.PropTypes.any
};

exports.default = RaisedButtonWithLoader;

/***/ }),
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(8)
var MD5 = __webpack_require__(240)
var RIPEMD160 = __webpack_require__(241)
var sha = __webpack_require__(242)
var Base = __webpack_require__(87)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var assert = __webpack_require__(48);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(22);

asn1.define = __webpack_require__(713).define;
asn1.base = __webpack_require__(139);
asn1.constants = __webpack_require__(530);
asn1.decoders = __webpack_require__(719);
asn1.encoders = __webpack_require__(721);


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(716).Reporter;
base.DecoderBuffer = __webpack_require__(529).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(529).EncoderBuffer;
base.Node = __webpack_require__(717);


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(565);

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeNow = getNative(Date, 'now');

/**
 * Gets the number of milliseconds that have elapsed since the Unix epoch
 * (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @category Date
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => logs the number of milliseconds it took for the deferred function to be invoked
 */
var now = nativeNow || function() {
  return new Date().getTime();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed invocations. Provide an options object to indicate that `func`
 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
 * Subsequent calls to the debounced function return the result of the last
 * `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
 * on the trailing edge of the timeout only if the the debounced function is
 * invoked more than once during the `wait` timeout.
 *
 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.leading=false] Specify invoking on the leading
 *  edge of the timeout.
 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
 *  delayed before it is invoked.
 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
 *  edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // avoid costly calculations while the window size is in flux
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // ensure `batchLog` is invoked once after 1 second of debounced calls
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', _.debounce(batchLog, 250, {
 *   'maxWait': 1000
 * }));
 *
 * // cancel a debounced call
 * var todoChanges = _.debounce(batchLog, 1000);
 * Object.observe(models.todo, todoChanges);
 *
 * Object.observe(models, function(changes) {
 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
 *     todoChanges.cancel();
 *   }
 * }, ['delete']);
 *
 * // ...at some point `models.todo` is changed
 * models.todo.completed = true;
 *
 * // ...before 1 second has passed `models.todo` is deleted
 * // which cancels the debounced `todoChanges` call
 * delete models.todo;
 */
function debounce(func, wait, options) {
  var args,
      maxTimeoutId,
      result,
      stamp,
      thisArg,
      timeoutId,
      trailingCall,
      lastCalled = 0,
      maxWait = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = wait < 0 ? 0 : (+wait || 0);
  if (options === true) {
    var leading = true;
    trailing = false;
  } else if (isObject(options)) {
    leading = !!options.leading;
    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (maxTimeoutId) {
      clearTimeout(maxTimeoutId);
    }
    lastCalled = 0;
    maxTimeoutId = timeoutId = trailingCall = undefined;
  }

  function complete(isCalled, id) {
    if (id) {
      clearTimeout(id);
    }
    maxTimeoutId = timeoutId = trailingCall = undefined;
    if (isCalled) {
      lastCalled = now();
      result = func.apply(thisArg, args);
      if (!timeoutId && !maxTimeoutId) {
        args = thisArg = undefined;
      }
    }
  }

  function delayed() {
    var remaining = wait - (now() - stamp);
    if (remaining <= 0 || remaining > wait) {
      complete(trailingCall, maxTimeoutId);
    } else {
      timeoutId = setTimeout(delayed, remaining);
    }
  }

  function maxDelayed() {
    complete(trailing, timeoutId);
  }

  function debounced() {
    args = arguments;
    stamp = now();
    thisArg = this;
    trailingCall = trailing && (timeoutId || !leading);

    if (maxWait === false) {
      var leadingCall = leading && !timeoutId;
    } else {
      if (!maxTimeoutId && !leading) {
        lastCalled = stamp;
      }
      var remaining = maxWait - (stamp - lastCalled),
          isCalled = remaining <= 0 || remaining > maxWait;

      if (isCalled) {
        if (maxTimeoutId) {
          maxTimeoutId = clearTimeout(maxTimeoutId);
        }
        lastCalled = stamp;
        result = func.apply(thisArg, args);
      }
      else if (!maxTimeoutId) {
        maxTimeoutId = setTimeout(maxDelayed, remaining);
      }
    }
    if (isCalled && timeoutId) {
      timeoutId = clearTimeout(timeoutId);
    }
    else if (!timeoutId && wait !== maxWait) {
      timeoutId = setTimeout(delayed, wait);
    }
    if (leadingCall) {
      isCalled = true;
      result = func.apply(thisArg, args);
    }
    if (isCalled && !timeoutId && !maxTimeoutId) {
      args = thisArg = undefined;
    }
    return result;
  }
  debounced.cancel = cancel;
  return debounced;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = debounce;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var marketSegments = exports.marketSegments = [{ value: 'Adventure', label: 'Adventure' }, { value: 'Business', label: 'Business' }, { value: 'Cultural and Heritage', label: 'Cultural and Heritage' }, { value: 'Eco-Tourism', label: 'Eco-Tourism' }, { value: 'Family', label: 'Family' }, { value: 'Group Travel', label: 'Group Travel' }, { value: 'Health and Wellness', label: 'Health and Wellness' }, { value: 'Luxury', label: 'Luxury' }, { value: 'Senior Travel', label: 'Senior Travel' }, { value: 'Sport Tourism', label: 'Sport Tourism' }, { value: 'Student Travel', label: 'Student Travel' }];

var beddingConfigOptions = exports.beddingConfigOptions = [{ value: 'Single/Twin Bed', label: 'Single/Twin Bed' }, { value: 'Double', label: 'Double' }, { value: 'Queen Bed', label: 'Queen Bed' }, { value: 'King Bed', label: 'King Bed' }, { value: 'Sofa Bed', label: 'Sofa Bed' }, { value: 'Roll Away', label: 'Roll Away' }, { value: 'Dormitory Bed', label: 'Dormitory Bed' }, { value: 'Other', label: 'Other' }];

var tourDurationOptions = exports.tourDurationOptions = [{ value: 'Minute(s)', label: 'Minute(s)' }, { value: 'Hour(s)', label: 'Hour(s)' }, { value: 'Day(s)', label: 'Day(s)' }, { value: 'Week(s)', label: 'Week(s)' }, { value: 'Month(s)', label: 'Month(s)' }, { value: 'Year(s)', label: 'Year(s)' }];

var roomCountOptions = exports.roomCountOptions = [{ value: 'room', label: 'Rooms' }, { value: 'suite', label: 'Suites' }];

var roomSizeOptions = exports.roomSizeOptions = [{ value: 'square meters', label: 'Square Meters' }, { value: 'square feet', label: 'Square Feet' }];

var basicBuyerTypes = exports.basicBuyerTypes = ['Inbound/Incoming/Receptive Tour Operator (ITO)', 'Destination Management Company (DMC)', 'Outbound/Outgoing Wholesaler', 'Wholesaler', 'Online Travel Agency (OTA)', 'Retail Travel Agency'];

var DMOtypes = exports.DMOtypes = ['Destination Marketing Organization (DMO)', 'National Tourism Board', 'City & Regional Tourism Board', "Convention & Visitor's Bureau (CVB)"];

var otherBuyersTypes = exports.otherBuyersTypes = ['Marketing Representation Agency', 'Public Relations Agency', 'Technology Provider', 'Industry Member Organization/Association', 'Media', 'Other Provider'];

var contractorCompanyTypesFields = exports.contractorCompanyTypesFields = [].concat(basicBuyerTypes, DMOtypes, otherBuyersTypes);
var contractorCompanyTypes = exports.contractorCompanyTypes = contractorCompanyTypesFields.map(function (str) {
  return {
    value: str, label: str
  };
});

var accomCompanyTypesFields = exports.accomCompanyTypesFields = ['Hotel', 'Motel', 'Hotel Chain', 'Hostel', 'Dormitory', 'Hostel Group', 'Holiday Homes', 'Resort', 'Apartments', 'Bed & Breakfast', 'Lodge', 'Cottages', 'Homestay/Farmstay', 'Caravan Park'];
var accomCompanyTypes = exports.accomCompanyTypes = accomCompanyTypesFields.map(function (str) {
  return {
    value: str, label: str
  };
});

var nonAccomCompanyTypesFields = exports.nonAccomCompanyTypesFields = ['Attractions', 'Day Tours/Excursions', 'Multi-Day Tours', 'Restaurant/Bar', 'Transfers', 'Auto Rental', 'Dining', 'Cruise Line', 'Coach Tours', 'Railway Operator', 'Discount Ticket Passes'];

var nonAccomCompanyTypes = exports.nonAccomCompanyTypes = nonAccomCompanyTypesFields.map(function (str) {
  return {
    value: str, label: str
  };
});

var amenitiesOptions = exports.amenitiesOptions = [{ value: '24 Hour Reception', label: '24 Hour Reception' }, { value: '24 Hour Room Service', label: '24 Hour Room Service' }, { value: 'Advanced Eco Accredited', label: 'Advanced Eco Accredited' }, { value: 'Air-Conditioning', label: 'Air-Conditioning' }, { value: 'Apple TV', label: 'Apple TV' }, { value: 'Babysitting Available', label: 'Babysitting Available' }, { value: 'Baggage Holding Room', label: 'Baggage Holding Room' }, { value: 'Baggage Storage', label: 'Baggage Storage' }, { value: 'Baggage Storage (fees apply)', label: 'Baggage Storage (fees apply)' }, { value: 'Balcony', label: 'Balcony' }, { value: 'Bar Fridge', label: 'Bar Fridge' }, { value: 'Bar on Premises', label: 'Bar on Premises' }, { value: 'Barbecue', label: 'Barbecue' }, { value: 'Bath', label: 'Bath' }, { value: 'Bath Robes', label: 'Bath Robes' }, { value: 'Bicycle Hire', label: 'Bicycle Hire' }, { value: 'Blanket', label: 'Blanket' }, { value: 'BOSE Sound System', label: 'BOSE Sound System' }, { value: 'Business Service Available', label: 'Business Service Available' }, { value: 'CD Player', label: 'CD Player' }, { value: 'Cafe', label: 'Cafe' }, { value: 'Car Charging Station', label: 'Car Charging Station' }, { value: 'Ceiling Fan/s', label: 'Ceiling Fan/s' }, { value: 'Central Heating', label: 'Central Heating' }, { value: 'Child Activity Program', label: 'Child Activity Program' }, { value: 'Child Minding Facilities', label: 'Child Minding Facilities' }, { value: 'Child Wading Pool', label: 'Child Wading Pool' }, { value: 'Children Not Catered For', label: 'Children Not Catered For' }, { value: 'Children\'s Play Area', label: 'Children\'s Play Area' }, { value: 'Clock Radio', label: 'Clock Radio' }, { value: 'Clothes Dryer', label: 'Clothes Dryer' }, { value: 'Combination Washer/Dryer', label: 'Combination Washer/Dryer' }, { value: 'Communal Lounge', label: 'Communal Lounge' }, { value: 'Conference Facilities', label: 'Conference Facilities' }, { value: 'Cots Available', label: 'Cots Available' }, { value: 'Courtesy Transfers', label: 'Courtesy Transfers' }, { value: 'Currency Exchange', label: 'Currency Exchange' }, { value: 'Cycle/Running Path', label: 'Cycle/Running Path' }, { value: 'DVD Hire', label: 'DVD Hire' }, { value: 'DVD Player', label: 'DVD Player' }, { value: 'Day Spa', label: 'Day Spa' }, { value: 'Day Tours/Tour Desk', label: 'Day Tours/Tour Desk' }, { value: 'Dedicated Non-smoking Floors', label: 'Dedicated Non-smoking Floors' }, { value: 'Desk', label: 'Desk' }, { value: 'Disabled Facilities', label: 'Disabled Facilities' }, { value: 'Disabled Facilities-Assistance', label: 'Disabled Facilities-Assistance' }, { value: 'Dishwasher', label: 'Dishwasher' }, { value: 'Drycleaning', label: 'Drycleaning' }, { value: 'Dual Key Apartment', label: 'Dual Key Apartment' }, { value: 'Eco Accredited', label: 'Eco Accredited' }, { value: 'Eftpos Facilities', label: 'Eftpos Facilities' }, { value: 'Electric Blanket', label: 'Electric Blanket' }, { value: 'Ensuite', label: 'Ensuite' }, { value: 'Entertainment', label: 'Entertainment' }, { value: 'Equipment Hire', label: 'Equipment Hire' }, { value: 'Established Gardens', label: 'Established Gardens' }, { value: 'Exercise Equipment', label: 'Exercise Equipment' }, { value: 'Facsimile', label: 'Facsimile' }, { value: 'Fireplace-Gas', label: 'Fireplace-Gas' }, { value: 'Fireplace-Wood', label: 'Fireplace-Wood' }, { value: 'Free Car Charging Station', label: 'Free Car Charging Station' }, { value: 'Free In Room Internet', label: 'Free In Room Internet' }, { value: 'Free Morning Paper', label: 'Free Morning Paper' }, { value: 'Free Pay TV', label: 'Free Pay TV' }, { value: 'Free Public Area Internet', label: 'Free Public Area Internet' }, { value: 'Full Cooking Facilities', label: 'Full Cooking Facilities' }, { value: 'Games Room', label: 'Games Room' }, { value: 'Gaming Machines', label: 'Gaming Machines' }, { value: 'Golf', label: 'Golf' }, { value: 'Groups', label: 'Groups' }, { value: 'Guest Laundry', label: 'Guest Laundry' }, { value: 'Guest Lounge', label: 'Guest Lounge' }, { value: 'Gymnasium', label: 'Gymnasium' }, { value: 'Hairdresser', label: 'Hairdresser' }, { value: 'Hairdryer', label: 'Hairdryer' }, { value: 'Heater', label: 'Heater' }, { value: 'High Rise (3 Floors or More)', label: 'High Rise (3 Floors or More)' }, { value: 'Homestay/Farmstay', label: 'Homestay/Farmstay' }, { value: 'ISD Phone In Room', label: 'ISD Phone In Room' }, { value: 'In House Movies', label: 'In House Movies' }, { value: 'Insect Screens', label: 'Insect Screens' }, { value: 'Interconnecting Rooms', label: 'Interconnecting Rooms' }, { value: 'Internet Access Broadband', label: 'Internet Access Broadband' }, { value: 'Internet Access Dial-up', label: 'Internet Access Dial-up' }, { value: 'Internet Access Wireless', label: 'Internet Access Wireless' }, { value: 'Internet Facilities', label: 'Internet Facilities' }, { value: 'Interpreter Services', label: 'Interpreter Services' }, { value: 'Ipod Connection/Dock', label: 'Ipod Connection/Dock' }, { value: 'Iron In Room', label: 'Iron In Room' }, { value: 'Iron in Guest Laundry', label: 'Iron in Guest Laundry' }, { value: 'Kids Club', label: 'Kids Club' }, { value: 'Kiosk', label: 'Kiosk' }, { value: 'LCD/Plasma Television', label: 'LCD/Plasma Television' }, { value: 'Library', label: 'Library' }, { value: 'Lift', label: 'Lift' }, { value: 'Limited Cooking Facilities', label: 'Limited Cooking Facilities' }, { value: 'Linen Provided/Incl in Tariff', label: 'Linen Provided/Incl in Tariff' }, { value: 'Low Rise (2 Floors or Less)', label: 'Low Rise (2 Floors or Less)' }, { value: 'Marina Facilities', label: 'Marina Facilities' }, { value: 'Masseur/Masseuse', label: 'Masseur/Masseuse' }, { value: 'Medical Facilities', label: 'Medical Facilities' }, { value: 'Microwave Oven', label: 'Microwave Oven' }, { value: 'Mini Bar', label: 'Mini Bar' }, { value: 'Night Entertainment', label: 'Night Entertainment' }, { value: 'Non Smoking Property', label: 'Non Smoking Property' }, { value: 'Open Fireplace', label: 'Open Fireplace' }, { value: 'Outdoor Shower', label: 'Outdoor Shower' }, { value: 'Parking - Outdoor Parking', label: 'Parking - Outdoor Parking' }, { value: 'Parking - Security Undercover', label: 'Parking - Security Undercover' }, { value: 'Parking/Car Space Available', label: 'Parking/Car Space Available' }, { value: 'Patio', label: 'Patio' }, { value: 'Pay Phone', label: 'Pay Phone' }, { value: 'Pets Allowed', label: 'Pets Allowed' }, { value: 'Photocopier', label: 'Photocopier' }, { value: 'Pool', label: 'Pool' }, { value: 'Pool - Heated', label: 'Pool - Heated' }, { value: 'Pool - Heated (Winter Only)', label: 'Pool - Heated (Winter Only)' }, { value: 'Pool - Indoor', label: 'Pool - Indoor' }, { value: 'Pool - Lap Pool', label: 'Pool - Lap Pool' }, { value: 'Pool Lagoon Pool', label: 'Pool Lagoon Pool' }, { value: 'Porter Service', label: 'Porter Service' }, { value: 'Private Bathroom', label: 'Private Bathroom' }, { value: 'Private Bathroom Accessible', label: 'Private Bathroom Accessible' }, { value: 'Private Plunge Pool', label: 'Private Plunge Pool' }, { value: 'Recreation Facilities', label: 'Recreation Facilities' }, { value: 'Refrigerator', label: 'Refrigerator' }, { value: 'Resort Shop', label: 'Resort Shop' }, { value: 'Restaurant - BYO', label: 'Restaurant - BYO' }, { value: 'Restaurant - Licensed', label: 'Restaurant - Licensed' }, { value: 'Restaurant - On Premises', label: 'Restaurant - On Premises' }, { value: 'Rooftop Pool', label: 'Rooftop Pool' }, { value: 'Room Service Available', label: 'Room Service Available' }, { value: 'Safe', label: 'Safe' }, { value: 'Safety Deposit Box Available', label: 'Safety Deposit Box Available' }, { value: 'Sauna', label: 'Sauna' }, { value: 'Secretarial Services', label: 'Secretarial Services' }, { value: 'Security Intercom', label: 'Security Intercom' }, { value: 'Security System', label: 'Security System' }, { value: 'Shared Bathroom', label: 'Shared Bathroom' }, { value: 'Ski equipment drying room', label: 'Ski equipment drying room' }, { value: 'Ski equipment secure storage', label: 'Ski equipment secure storage' }, { value: 'Spa', label: 'Spa' }, { value: 'Spa In Bath', label: 'Spa In Bath' }, { value: 'Spa on Deck/Balcony', label: 'Spa on Deck/Balcony' }, { value: 'Squash Court', label: 'Squash Court' }, { value: 'Standard Television', label: 'Standard Television' }, { value: 'Steam Room', label: 'Steam Room' }, { value: 'Surround Sound System', label: 'Surround Sound System' }, { value: 'Tea/Coffee Making Facilities', label: 'Tea/Coffee Making Facilities' }, { value: 'Telephone', label: 'Telephone' }, { value: 'Tennis Court - Full Size', label: 'Tennis Court - Full Size' }, { value: 'Tennis Court - Half Size', label: 'Tennis Court - Half Size' }, { value: 'Turndown Service', label: 'Turndown Service' }, { value: 'Video Games', label: 'Video Games' }, { value: 'Washing Machine', label: 'Washing Machine' }, { value: 'Water Sports Gear', label: 'Water Sports Gear' }, { value: 'Wood Heater', label: 'Wood Heater' }, { value: 'Yoga Studio', label: 'Yoga Studio' }];

var howTheyHeard = exports.howTheyHeard = [{ value: 'coworker-colleague', label: 'Coworker / Colleague' }, { value: 'heard-from-a-friend', label: 'Industry Peer / Friend' }, { value: 'search-engine', label: 'Search Engine (Google, Bing, Yahoo, etc.)' }, { value: 'intl-tourism-event', label: 'International Tourism Event' }, { value: 'nat-tourism-event', label: 'National Tourism Event' }, { value: 'reg-tourism-event', label: 'Regional Tourism Event' }, { value: 'tc-request-contract', label: 'TourConnect Invitation / Email' }, { value: 'association-organization', label: 'Tourism Association / Organization' }, { value: 'media-publication', label: 'Tourism Media / Publication' }, { value: 'other', label: 'Other' }];

var countries = exports.countries = [{ value: 'Afghanistan', label: 'Afghanistan' }, { value: 'Albania', label: 'Albania' }, { value: 'Algeria', label: 'Algeria' }, { value: 'American Samoa', label: 'American Samoa' }, { value: 'Andorra', label: 'Andorra' }, { value: 'Angola', label: 'Angola' }, { value: 'Anguilla', label: 'Anguilla' }, { value: 'Antarctica', label: 'Antarctica' }, { value: 'Antigua and Barbuda', label: 'Antigua and Barbuda' }, { value: 'Argentina', label: 'Argentina' }, { value: 'Armenia', label: 'Armenia' }, { value: 'Aruba', label: 'Aruba' }, { value: 'Australia', label: 'Australia' }, { value: 'Austria', label: 'Austria' }, { value: 'Azerbaijan', label: 'Azerbaijan' }, { value: 'Bahamas', label: 'Bahamas' }, { value: 'Bahrain', label: 'Bahrain' }, { value: 'Bangladesh', label: 'Bangladesh' }, { value: 'Barbados', label: 'Barbados' }, { value: 'Belarus', label: 'Belarus' }, { value: 'Belgium', label: 'Belgium' }, { value: 'Belize', label: 'Belize' }, { value: 'Benin', label: 'Benin' }, { value: 'Bermuda', label: 'Bermuda' }, { value: 'Bhutan', label: 'Bhutan' }, { value: 'Bolivia', label: 'Bolivia' }, { value: 'Bonaire, Sint Eustatius and Saba', label: 'Bonaire, Sint Eustatius and Saba' }, { value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina' }, { value: 'Botswana', label: 'Botswana' }, { value: 'Bouvet Island', label: 'Bouvet Island' }, { value: 'Brazil', label: 'Brazil' }, { value: 'British Indian Ocean Territory', label: 'British Indian Ocean Territory' }, { value: 'Brunei Darussalam', label: 'Brunei Darussalam' }, { value: 'Bulgaria', label: 'Bulgaria' }, { value: 'Burkina Faso', label: 'Burkina Faso' }, { value: 'Burundi', label: 'Burundi' }, { value: 'Cambodia', label: 'Cambodia' }, { value: 'Cameroon', label: 'Cameroon' }, { value: 'Canada', label: 'Canada' }, { value: 'Cape Verde', label: 'Cape Verde' }, { value: 'Cayman Islands', label: 'Cayman Islands' }, { value: 'Central African Republic', label: 'Central African Republic' }, { value: 'Chad', label: 'Chad' }, { value: 'Chile', label: 'Chile' }, { value: 'China', label: 'China' }, { value: 'Christmas Island', label: 'Christmas Island' }, { value: 'Cocos (Keeling) Islands', label: 'Cocos (Keeling) Islands' }, { value: 'Colombia', label: 'Colombia' }, { value: 'Comoros', label: 'Comoros' }, { value: 'Congo', label: 'Congo' }, { value: 'Congo, The Democratic Republic of the', label: 'Congo, The Democratic Republic of the' }, { value: 'Cook Islands', label: 'Cook Islands' }, { value: 'Costa Rica', label: 'Costa Rica' }, { value: 'Croatia', label: 'Croatia' }, { value: 'Cuba', label: 'Cuba' }, { value: 'Curaçao', label: 'Curaçao' }, { value: 'Cyprus', label: 'Cyprus' }, { value: 'Czech Republic', label: 'Czech Republic' }, { value: 'Côte D\'Ivoire', label: 'Côte D\'Ivoire' }, { value: 'Denmark', label: 'Denmark' }, { value: 'Djibouti', label: 'Djibouti' }, { value: 'Dominica', label: 'Dominica' }, { value: 'Dominican Republic', label: 'Dominican Republic' }, { value: 'Ecuador', label: 'Ecuador' }, { value: 'Egypt', label: 'Egypt' }, { value: 'El Salvador', label: 'El Salvador' }, { value: 'Equatorial Guinea', label: 'Equatorial Guinea' }, { value: 'Eritrea', label: 'Eritrea' }, { value: 'Estonia', label: 'Estonia' }, { value: 'Ethiopia', label: 'Ethiopia' },
//  { value: 'European Economic and Monetary Union area', label: 'European Economic and Monetary Union area' },
{ value: 'Falkland Islands (Malvinas)', label: 'Falkland Islands (Malvinas)' }, { value: 'Faroe Islands', label: 'Faroe Islands' }, { value: 'Fiji', label: 'Fiji' }, { value: 'Finland', label: 'Finland' }, { value: 'France', label: 'France' }, { value: 'French Guiana', label: 'French Guiana' }, { value: 'French Polynesia', label: 'French Polynesia' }, { value: 'French Southern Territories', label: 'French Southern Territories' }, { value: 'Gabon', label: 'Gabon' }, { value: 'Gambia', label: 'Gambia' }, { value: 'Georgia', label: 'Georgia' }, { value: 'Germany', label: 'Germany' }, { value: 'Ghana', label: 'Ghana' }, { value: 'Gibraltar', label: 'Gibraltar' }, { value: 'Greece', label: 'Greece' }, { value: 'Greenland', label: 'Greenland' }, { value: 'Grenada', label: 'Grenada' }, { value: 'Guadeloupe', label: 'Guadeloupe' }, { value: 'Guam', label: 'Guam' }, { value: 'Guatemala', label: 'Guatemala' }, { value: 'Guernsey', label: 'Guernsey' }, { value: 'Guinea', label: 'Guinea' }, { value: 'Guinea-Bissau', label: 'Guinea-Bissau' }, { value: 'Guyana', label: 'Guyana' }, { value: 'Haiti', label: 'Haiti' }, { value: 'Heard Island and McDonald Islands', label: 'Heard Island and McDonald Islands' }, { value: 'Vatican City', label: 'Vatican City' }, { value: 'Honduras', label: 'Honduras' }, { value: 'Hong Kong', label: 'Hong Kong' }, { value: 'Hungary', label: 'Hungary' }, { value: 'Iceland', label: 'Iceland' }, { value: 'India', label: 'India' }, { value: 'Indonesia', label: 'Indonesia' }, { value: 'Iran', label: 'Iran' }, { value: 'Iraq', label: 'Iraq' }, { value: 'Ireland', label: 'Ireland' }, { value: 'Isle of Man', label: 'Isle of Man' }, { value: 'Israel', label: 'Israel' }, { value: 'Italy', label: 'Italy' }, { value: 'Jamaica', label: 'Jamaica' }, { value: 'Japan', label: 'Japan' }, { value: 'Jersey', label: 'Jersey' }, { value: 'Jordan', label: 'Jordan' }, { value: 'Kazakhstan', label: 'Kazakhstan' }, { value: 'Kenya', label: 'Kenya' }, { value: 'Kiribati', label: 'Kiribati' }, { value: 'North Korea', label: 'North Korea' }, { value: 'South Korea', label: 'South Korea' }, { value: 'Kuwait', label: 'Kuwait' }, { value: 'Kyrgyzstan', label: 'Kyrgyzstan' }, { value: 'Laos', label: 'Laos' }, { value: 'Latvia', label: 'Latvia' }, { value: 'Lebanon', label: 'Lebanon' }, { value: 'Lesotho', label: 'Lesotho' }, { value: 'Liberia', label: 'Liberia' }, { value: 'Libya', label: 'Libya' }, { value: 'Liechtenstein', label: 'Liechtenstein' }, { value: 'Lithuania', label: 'Lithuania' }, { value: 'Luxembourg', label: 'Luxembourg' }, { value: 'Macao', label: 'Macao' }, { value: 'Macedonia', label: 'Macedonia' }, { value: 'Madagascar', label: 'Madagascar' }, { value: 'Malawi', label: 'Malawi' }, { value: 'Malaysia', label: 'Malaysia' }, { value: 'Maldives', label: 'Maldives' }, { value: 'Mali', label: 'Mali' }, { value: 'Malta', label: 'Malta' }, { value: 'Marshall Islands', label: 'Marshall Islands' }, { value: 'Martinique', label: 'Martinique' }, { value: 'Mauritania', label: 'Mauritania' }, { value: 'Mauritius', label: 'Mauritius' }, { value: 'Mayotte', label: 'Mayotte' }, { value: 'Mexico', label: 'Mexico' }, { value: 'Micronesia', label: 'Micronesia' }, { value: 'Moldova', label: 'Moldova' }, { value: 'Monaco', label: 'Monaco' }, { value: 'Mongolia', label: 'Mongolia' }, { value: 'Montenegro', label: 'Montenegro' }, { value: 'Montserrat', label: 'Montserrat' }, { value: 'Morocco', label: 'Morocco' }, { value: 'Mozambique', label: 'Mozambique' }, { value: 'Myanmar', label: 'Myanmar' }, { value: 'Namibia', label: 'Namibia' }, { value: 'Nauru', label: 'Nauru' }, { value: 'Nepal', label: 'Nepal' }, { value: 'Netherlands', label: 'Netherlands' }, { value: 'Netherlands Antilles', label: 'Netherlands Antilles' }, { value: 'New Caledonia', label: 'New Caledonia' }, { value: 'New Zealand', label: 'New Zealand' }, { value: 'Nicaragua', label: 'Nicaragua' }, { value: 'Niger', label: 'Niger' }, { value: 'Nigeria', label: 'Nigeria' }, { value: 'Niue', label: 'Niue' }, { value: 'Norfolk Island', label: 'Norfolk Island' }, { value: 'Northern Mariana Islands', label: 'Northern Mariana Islands' }, { value: 'Norway', label: 'Norway' }, { value: 'Oman', label: 'Oman' }, { value: 'Pakistan', label: 'Pakistan' }, { value: 'Palau', label: 'Palau' }, { value: 'Palestine', label: 'Palestine' }, { value: 'Panama', label: 'Panama' }, { value: 'Papua New Guinea', label: 'Papua New Guinea' }, { value: 'Paraguay', label: 'Paraguay' }, { value: 'Peru', label: 'Peru' }, { value: 'Philippines', label: 'Philippines' }, { value: 'Pitcairn', label: 'Pitcairn' }, { value: 'Poland', label: 'Poland' }, { value: 'Portugal', label: 'Portugal' }, { value: 'Puerto Rico', label: 'Puerto Rico' }, { value: 'Qatar', label: 'Qatar' }, { value: 'Romania', label: 'Romania' }, { value: 'Russia', label: 'Russia' }, { value: 'Rwanda', label: 'Rwanda' }, { value: 'Réunion', label: 'Réunion' }, { value: 'Saint Barthélemy', label: 'Saint Barthélemy' }, { value: 'Saint Helena, Ascension and Tristan Da Cunha', label: 'Saint Helena, Ascension and Tristan Da Cunha' }, { value: 'Saint Kitts and Nevis', label: 'Saint Kitts and Nevis' }, { value: 'Saint Lucia', label: 'Saint Lucia' }, { value: 'Saint Martin (French part)', label: 'Saint Martin (French part)' }, { value: 'Saint Pierre and Miquelon', label: 'Saint Pierre and Miquelon' }, { value: 'Saint Vincent and The Grenadines', label: 'Saint Vincent and The Grenadines' }, { value: 'Samoa', label: 'Samoa' }, { value: 'San Marino', label: 'San Marino' }, { value: 'Sao Tome and Principe', label: 'Sao Tome and Principe' }, { value: 'Saudi Arabia', label: 'Saudi Arabia' }, { value: 'Senegal', label: 'Senegal' }, { value: 'Serbia', label: 'Serbia' }, { value: 'Seychelles', label: 'Seychelles' }, { value: 'Sierra Leone', label: 'Sierra Leone' }, { value: 'Singapore', label: 'Singapore' }, { value: 'Sint Maarten (Dutch part)', label: 'Sint Maarten (Dutch part)' }, { value: 'Slovakia', label: 'Slovakia' }, { value: 'Slovenia', label: 'Slovenia' }, { value: 'Solomon Islands', label: 'Solomon Islands' }, { value: 'Somalia', label: 'Somalia' }, { value: 'South Africa', label: 'South Africa' }, { value: 'South Georgia and the South Sandwich Islands', label: 'South Georgia and the South Sandwich Islands' }, { value: 'South Sudan', label: 'South Sudan' }, { value: 'Spain', label: 'Spain' }, { value: 'Sri Lanka', label: 'Sri Lanka' }, { value: 'Sudan', label: 'Sudan' }, { value: 'Suriname', label: 'Suriname' }, { value: 'Svalbard and Jan Mayen', label: 'Svalbard and Jan Mayen' }, { value: 'Swaziland', label: 'Swaziland' }, { value: 'Sweden', label: 'Sweden' }, { value: 'Switzerland', label: 'Switzerland' }, { value: 'Syria', label: 'Syria' }, { value: 'Taiwan', label: 'Taiwan' }, { value: 'Tajikistan', label: 'Tajikistan' }, { value: 'Tanzania', label: 'Tanzania' }, { value: 'Thailand', label: 'Thailand' }, { value: 'Timor-Leste', label: 'Timor-Leste' }, { value: 'Togo', label: 'Togo' }, { value: 'Tokelau', label: 'Tokelau' }, { value: 'Tonga', label: 'Tonga' }, { value: 'Trinidad and Tobago', label: 'Trinidad and Tobago' }, { value: 'Tunisia', label: 'Tunisia' }, { value: 'Turkey', label: 'Turkey' }, { value: 'Turkmenistan', label: 'Turkmenistan' }, { value: 'Turks and Caicos Islands', label: 'Turks and Caicos Islands' }, { value: 'Tuvalu', label: 'Tuvalu' }, { value: 'Uganda', label: 'Uganda' }, { value: 'Ukraine', label: 'Ukraine' }, { value: 'United Arab Emirates', label: 'United Arab Emirates' }, { value: 'United Kingdom', label: 'United Kingdom' }, { value: 'United States', label: 'United States' }, { value: 'United States Minor Outlying Islands', label: 'United States Minor Outlying Islands' }, { value: 'Uruguay', label: 'Uruguay' }, { value: 'Uzbekistan', label: 'Uzbekistan' }, { value: 'Vanuatu', label: 'Vanuatu' }, { value: 'Venezuela', label: 'Venezuela' }, { value: 'Vietnam', label: 'Vietnam' }, { value: 'Virgin Islands, British', label: 'Virgin Islands, British' }, { value: 'Virgin Islands, U.S.', label: 'Virgin Islands, U.S.' }, { value: 'Wallis And Futuna', label: 'Wallis And Futuna' }, { value: 'Western Sahara', label: 'Western Sahara' }, { value: 'Yemen', label: 'Yemen' }, { value: 'Zambia', label: 'Zambia' }, { value: 'Zimbabwe', label: 'Zimbabwe' }];

var taxTypes = exports.taxTypes = [{ value: 'VAT', label: 'VAT' }, { value: 'GST', label: 'GST' }, { value: 'No sales tax', label: 'No sales tax' }, { value: 'Sales Tax', label: 'Sales Tax' }, { value: 'ICMS', label: 'ICMS' }, { value: 'GST + PST', label: 'GST + PST' }, { value: 'HST', label: 'HST' }, { value: 'GST + QST', label: 'GST + QST' }, { value: 'IGIC', label: 'IGIC' }, { value: 'ISV', label: 'ISV' }, { value: 'Consumption tax', label: 'Consumption tax' }, { value: 'Commercial tax', label: 'Commercial tax' }, { value: 'ITBM Tax (VAT)', label: 'ITBM Tax (VAT)' }, { value: 'Federal VAT (IGV)', label: 'Federal VAT (IGV)' }, { value: 'IVU', label: 'IVU' }, { value: 'MwSt/USt', label: 'MwSt/USt' }, { value: 'BTW', label: 'BTW' }, { value: 'TVA', label: 'TVA' }, { value: 'MWSt', label: 'MWSt' }, { value: 'PDV', label: 'PDV' }, { value: 'DPH', label: 'DPH' }, { value: 'Moms', label: 'Moms' }, { value: 'km', label: 'km' }, { value: 'ALV', label: 'ALV' }, { value: 'CBL', label: 'CBL' }, { value: 'IVA', label: 'IVA' }, { value: 'PVN', label: 'PVN' }, { value: 'PVM', label: 'PVM' }, { value: 'PTU', label: 'PTU' }, { value: 'DDV', label: 'DDV' }, { value: 'TVSH', label: 'TVSH' }, { value: 'IGI', label: 'IGI' }, { value: 'AAH', label: 'AAH' }, { value: 'Musok', label: 'Musok' }, { value: 'IPI', label: 'IPI' }, { value: 'ISS', label: 'ISS' }, { value: 'ITBIS', label: 'ITBIS' }, { value: 'MVG', label: 'MVG' }, { value: 'DGhG', label: 'DGhG' }, { value: 'VSK', label: 'VSK' }, { value: 'PPN', label: 'PPN' }, { value: 'RVAT', label: 'RVAT' }, { value: 'KDV', label: 'KDV' }, { value: 'GTGT', label: 'GTGT' }];

var timeSelect15MinsInterval = exports.timeSelect15MinsInterval = [{ value: '0:00am', label: '0:00am' }, { value: '0:15am', label: '0:15am' }, { value: '0:30am', label: '0:30am' }, { value: '0:45am', label: '0:45am' }, { value: '1:00am', label: '1:00am' }, { value: '1:15am', label: '1:15am' }, { value: '1:30am', label: '1:30am' }, { value: '1:45am', label: '1:45am' }, { value: '2:00am', label: '2:00am' }, { value: '2:15am', label: '2:15am' }, { value: '2:30am', label: '2:30am' }, { value: '2:45am', label: '2:45am' }, { value: '3:00am', label: '3:00am' }, { value: '3:15am', label: '3:15am' }, { value: '3:30am', label: '3:30am' }, { value: '3:45am', label: '3:45am' }, { value: '4:00am', label: '4:00am' }, { value: '4:15am', label: '4:15am' }, { value: '4:30am', label: '4:30am' }, { value: '4:45am', label: '4:45am' }, { value: '5:00am', label: '5:00am' }, { value: '5:15am', label: '5:15am' }, { value: '5:30am', label: '5:30am' }, { value: '5:45am', label: '5:45am' }, { value: '6:00am', label: '6:00am' }, { value: '6:15am', label: '6:15am' }, { value: '6:30am', label: '6:30am' }, { value: '6:45am', label: '6:45am' }, { value: '7:00am', label: '7:00am' }, { value: '7:15am', label: '7:15am' }, { value: '7:30am', label: '7:30am' }, { value: '7:45am', label: '7:45am' }, { value: '8:00am', label: '8:00am' }, { value: '8:15am', label: '8:15am' }, { value: '8:30am', label: '8:30am' }, { value: '8:45am', label: '8:45am' }, { value: '9:00am', label: '9:00am' }, { value: '9:15am', label: '9:15am' }, { value: '9:30am', label: '9:30am' }, { value: '9:45am', label: '9:45am' }, { value: '10:00am', label: '10:00am' }, { value: '10:15am', label: '10:15am' }, { value: '10:30am', label: '10:30am' }, { value: '10:45am', label: '10:45am' }, { value: '11:00am', label: '11:00am' }, { value: '11:15am', label: '11:15am' }, { value: '11:30am', label: '11:30am' }, { value: '11:45am', label: '11:45am' }, { value: '12:00pm', label: '12:00pm' }, { value: '12:15pm', label: '12:15pm' }, { value: '12:30pm', label: '12:30pm' }, { value: '12:45pm', label: '12:45pm' }, { value: '1:00pm', label: '1:00pm' }, { value: '1:15pm', label: '1:15pm' }, { value: '1:30pm', label: '1:30pm' }, { value: '1:45pm', label: '1:45pm' }, { value: '2:00pm', label: '2:00pm' }, { value: '2:15pm', label: '2:15pm' }, { value: '2:30pm', label: '2:30pm' }, { value: '2:45pm', label: '2:45pm' }, { value: '3:00pm', label: '3:00pm' }, { value: '3:15pm', label: '3:15pm' }, { value: '3:30pm', label: '3:30pm' }, { value: '3:45pm', label: '3:45pm' }, { value: '4:00pm', label: '4:00pm' }, { value: '4:15pm', label: '4:15pm' }, { value: '4:30pm', label: '4:30pm' }, { value: '4:45pm', label: '4:45pm' }, { value: '5:00pm', label: '5:00pm' }, { value: '5:15pm', label: '5:15pm' }, { value: '5:30pm', label: '5:30pm' }, { value: '5:45pm', label: '5:45pm' }, { value: '6:00pm', label: '6:00pm' }, { value: '6:15pm', label: '6:15pm' }, { value: '6:30pm', label: '6:30pm' }, { value: '6:45pm', label: '6:45pm' }, { value: '7:00pm', label: '7:00pm' }, { value: '7:15pm', label: '7:15pm' }, { value: '7:30pm', label: '7:30pm' }, { value: '7:45pm', label: '7:45pm' }, { value: '8:00pm', label: '8:00pm' }, { value: '8:15pm', label: '8:15pm' }, { value: '8:30pm', label: '8:30pm' }, { value: '8:45pm', label: '8:45pm' }, { value: '9:00pm', label: '9:00pm' }, { value: '9:15pm', label: '9:15pm' }, { value: '9:30pm', label: '9:30pm' }, { value: '9:45pm', label: '9:45pm' }, { value: '10:00pm', label: '10:00pm' }, { value: '10:15pm', label: '10:15pm' }, { value: '10:30pm', label: '10:30pm' }, { value: '10:45pm', label: '10:45pm' }, { value: '11:00pm', label: '11:00pm' }, { value: '11:15pm', label: '11:15pm' }, { value: '11:30pm', label: '11:30pm' }, { value: '11:45pm', label: '11:45pm' }];

var currencies = exports.currencies = [{ value: 'AED', label: 'AED' }, { value: 'AFN', label: 'AFN' }, { value: 'AMD', label: 'AMD' }, { value: 'ANG', label: 'ANG' }, { value: 'AOA', label: 'AOA' }, { value: 'ARS', label: 'ARS' }, { value: 'AUD', label: 'AUD' }, { value: 'AWG', label: 'AWG' }, { value: 'AZN', label: 'AZN' }, { value: 'BAM', label: 'BAM' }, { value: 'BBD', label: 'BBD' }, { value: 'BDT', label: 'BDT' }, { value: 'BGN', label: 'BGN' }, { value: 'BHD', label: 'BHD' }, { value: 'BIF', label: 'BIF' }, { value: 'BMD', label: 'BMD' }, { value: 'BND', label: 'BND' }, { value: 'BOB', label: 'BOB' }, { value: 'BOV', label: 'BOV' }, { value: 'BRL', label: 'BRL' }, { value: 'BSD', label: 'BSD' }, { value: 'BTN', label: 'BTN' }, { value: 'BWP', label: 'BWP' }, { value: 'BYR', label: 'BYR' }, { value: 'BZD', label: 'BZD' }, { value: 'CAD', label: 'CAD' }, { value: 'CDF', label: 'CDF' }, { value: 'CHE', label: 'CHE' }, { value: 'CHF', label: 'CHF' }, { value: 'CHW', label: 'CHW' }, { value: 'CLF', label: 'CLF' }, { value: 'CLP', label: 'CLP' }, { value: 'CNY', label: 'CNY' }, { value: 'COP', label: 'COP' }, { value: 'COU', label: 'COU' }, { value: 'CRC', label: 'CRC' }, { value: 'CUP', label: 'CUP' }, { value: 'CVE', label: 'CVE' }, { value: 'CYP', label: 'CYP' }, { value: 'CZK', label: 'CZK' }, { value: 'DJF', label: 'DJF' }, { value: 'DKK', label: 'DKK' }, { value: 'DOP', label: 'DOP' }, { value: 'DZD', label: 'DZD' }, { value: 'EEK', label: 'EEK' }, { value: 'EGP', label: 'EGP' }, { value: 'ERN', label: 'ERN' }, { value: 'ETB', label: 'ETB' }, { value: 'EUR', label: 'EUR' }, { value: 'FJD', label: 'FJD' }, { value: 'FKP', label: 'FKP' }, { value: 'GBP', label: 'GBP' }, { value: 'GEL', label: 'GEL' }, { value: 'GHS', label: 'GHS' }, { value: 'GIP', label: 'GIP' }, { value: 'GMD', label: 'GMD' }, { value: 'GNF', label: 'GNF' }, { value: 'GTQ', label: 'GTQ' }, { value: 'GYD', label: 'GYD' }, { value: 'HKD', label: 'HKD' }, { value: 'HNL', label: 'HNL' }, { value: 'HRK', label: 'HRK' }, { value: 'HTG', label: 'HTG' }, { value: 'HUF', label: 'HUF' }, { value: 'IDR', label: 'IDR' }, { value: 'ILS', label: 'ILS' }, { value: 'INR', label: 'INR' }, { value: 'IQD', label: 'IQD' }, { value: 'IRR', label: 'IRR' }, { value: 'ISK', label: 'ISK' }, { value: 'JMD', label: 'JMD' }, { value: 'JOD', label: 'JOD' }, { value: 'JPY', label: 'JPY' }, { value: 'KES', label: 'KES' }, { value: 'KGS', label: 'KGS' }, { value: 'KHR', label: 'KHR' }, { value: 'KMF', label: 'KMF' }, { value: 'KPW', label: 'KPW' }, { value: 'KRW', label: 'KRW' }, { value: 'KWD', label: 'KWD' }, { value: 'KYD', label: 'KYD' }, { value: 'KZT', label: 'KZT' }, { value: 'LAK', label: 'LAK' }, { value: 'LBP', label: 'LBP' }, { value: 'LKR', label: 'LKR' }, { value: 'LRD', label: 'LRD' }, { value: 'LSL', label: 'LSL' }, { value: 'LTL', label: 'LTL' }, { value: 'LVL', label: 'LVL' }, { value: 'LYD', label: 'LYD' }, { value: 'MAD', label: 'MAD' }, { value: 'MDL', label: 'MDL' }, { value: 'MGA', label: 'MGA' }, { value: 'MKD', label: 'MKD' }, { value: 'MMK', label: 'MMK' }, { value: 'MNT', label: 'MNT' }, { value: 'MOP', label: 'MOP' }, { value: 'MRO', label: 'MRO' }, { value: 'MTL', label: 'MTL' }, { value: 'MUR', label: 'MUR' }, { value: 'MVR', label: 'MVR' }, { value: 'MWK', label: 'MWK' }, { value: 'MXN', label: 'MXN' }, { value: 'MXV', label: 'MXV' }, { value: 'MYR', label: 'MYR' }, { value: 'MZN', label: 'MZN' }, { value: 'NAD', label: 'NAD' }, { value: 'NGN', label: 'NGN' }, { value: 'NIO', label: 'NIO' }, { value: 'NOK', label: 'NOK' }, { value: 'NPR', label: 'NPR' }, { value: 'NZD', label: 'NZD' }, { value: 'OMR', label: 'OMR' }, { value: 'PAB', label: 'PAB' }, { value: 'PEN', label: 'PEN' }, { value: 'PGK', label: 'PGK' }, { value: 'PHP', label: 'PHP' }, { value: 'PKR', label: 'PKR' }, { value: 'PLN', label: 'PLN' }, { value: 'PYG', label: 'PYG' }, { value: 'QAR', label: 'QAR' }, { value: 'RON', label: 'RON' }, { value: 'RSD', label: 'RSD' }, { value: 'RUB', label: 'RUB' }, { value: 'RWF', label: 'RWF' }, { value: 'SAR', label: 'SAR' }, { value: 'SBD', label: 'SBD' }, { value: 'SCR', label: 'SCR' }, { value: 'SDG', label: 'SDG' }, { value: 'SEK', label: 'SEK' }, { value: 'SGD', label: 'SGD' }, { value: 'SHP', label: 'SHP' }, { value: 'SKK', label: 'SKK' }, { value: 'SLL', label: 'SLL' }, { value: 'SOS', label: 'SOS' }, { value: 'SRD', label: 'SRD' }, { value: 'STD', label: 'STD' }, { value: 'SYP', label: 'SYP' }, { value: 'SZL', label: 'SZL' }, { value: 'THB', label: 'THB' }, { value: 'TJS', label: 'TJS' }, { value: 'TMM', label: 'TMM' }, { value: 'TND', label: 'TND' }, { value: 'TOP', label: 'TOP' }, { value: 'TRY', label: 'TRY' }, { value: 'TTD', label: 'TTD' }, { value: 'TWD', label: 'TWD' }, { value: 'TZS', label: 'TZS' }, { value: 'UAH', label: 'UAH' }, { value: 'UGX', label: 'UGX' }, { value: 'USD', label: 'USD' }, { value: 'USN', label: 'USN' }, { value: 'USS', label: 'USS' }, { value: 'UYU', label: 'UYU' }, { value: 'UZS', label: 'UZS' }, { value: 'VEB', label: 'VEB' }, { value: 'VND', label: 'VND' }, { value: 'VUV', label: 'VUV' }, { value: 'WST', label: 'WST' }, { value: 'XAF', label: 'XAF' }, { value: 'XAG', label: 'XAG' }, { value: 'XAU', label: 'XAU' }, { value: 'XBA', label: 'XBA' }, { value: 'XBB', label: 'XBB' }, { value: 'XBC', label: 'XBC' }, { value: 'XBD', label: 'XBD' }, { value: 'XCD', label: 'XCD' }, { value: 'XDR', label: 'XDR' }, { value: 'XFO', label: 'XFO' }, { value: 'XFU', label: 'XFU' }, { value: 'XOF', label: 'XOF' }, { value: 'XPD', label: 'XPD' }, { value: 'XPF', label: 'XPF' }, { value: 'XPT', label: 'XPT' }, { value: 'XTS', label: 'XTS' }, { value: 'XXX', label: 'XXX' }, { value: 'YER', label: 'YER' }, { value: 'ZAR', label: 'ZAR' }, { value: 'ZMK', label: 'ZMK' }, { value: 'ZWD', label: 'ZWD' }];

var months = exports.months = [{ value: 1, label: 1 }, { value: 2, label: 2 }, { value: 3, label: 3 }, { value: 4, label: 4 }, { value: 5, label: 5 }, { value: 6, label: 6 }, { value: 7, label: 7 }, { value: 8, label: 8 }, { value: 9, label: 9 }, { value: 10, label: 10 }, { value: 11, label: 11 }, { value: 12, label: 12 }];

var years = exports.years = [{ value: 2016, label: 2016 }, { value: 2017, label: 2017 }, { value: 2018, label: 2018 }, { value: 2019, label: 2019 }, { value: 2020, label: 2020 }, { value: 2021, label: 2021 }, { value: 2022, label: 2022 }, { value: 2023, label: 2023 }, { value: 2024, label: 2024 }, { value: 2025, label: 2025 }];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* \
|*|
|*|  :: cookies.js ::
|*|
|*|  A complete cookies reader/writer framework with full unicode support.
|*|
|*|  Revision #1 - September 4, 2014
|*|
|*|  https://developer.mozilla.org/en-US/docs/Web/API/document.cookie
|*|  https://developer.mozilla.org/User:fusionchess
|*|
|*|  This framework is released under the GNU Public License, version 3 or later.
|*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
|*|
|*|  Syntaxes:
|*|
|*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
|*|  * docCookies.getItem(name)
|*|  * docCookies.removeItem(name[, path[, domain]])
|*|  * docCookies.hasItem(name)
|*|  * docCookies.keys()
|*|
\*/

exports.default = {
  getItem: function getItem(sKey) {
    if (!sKey) {
      return null;
    }
    return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
  },
  setItem: function setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    var sExpires = '';
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
          break;
        case String:
          sExpires = '; expires=' + vEnd;
          break;
        case Date:
          sExpires = '; expires=' + vEnd.toUTCString();
          break;
        default:
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + '=' + (encodeURIComponent(sValue) + sExpires + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : ''));
    return true;
  },
  removeItem: function removeItem(sKey, sPath, sDomain) {
    if (!this.hasItem(sKey)) {
      return false;
    }
    document.cookie = encodeURIComponent(sKey) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + ((sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : ''));
    return true;
  },
  hasItem: function hasItem(sKey) {
    if (!sKey) {
      return false;
    }
    return new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=').test(document.cookie);
  },
  keys: function keys() {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }
    return aKeys;
  }
};

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* harmony export (immutable) */ __webpack_exports__["b"] = channel;
/* harmony export (immutable) */ __webpack_exports__["d"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["f"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(583);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["p" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["p" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var support = __webpack_require__(117);
var nodejsUtils = __webpack_require__(238);
var GenericWorker = __webpack_require__(65);

/**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new Array(256);
for (var i=0; i<256; i++) {
  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start

// convert string to array (typed, when possible)
var string2buf = function (str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

    // count binary size
    for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }

    // allocate buffer
    if (support.uint8array) {
        buf = new Uint8Array(buf_len);
    } else {
        buf = new Array(buf_len);
    }

    // convert
    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
        } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | (c >>> 6);
            buf[i++] = 0x80 | (c & 0x3f);
        } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | (c >>> 12);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        } else {
            /* four bytes */
            buf[i++] = 0xf0 | (c >>> 18);
            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        }
    }

    return buf;
};

// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = function(buf, max) {
    var pos;

    max = max || buf.length;
    if (max > buf.length) { max = buf.length; }

    // go back from last position, until start of sequence found
    pos = max-1;
    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

    // Fuckup - very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) { return max; }

    // If we came to start of buffer - that means vuffer is too small,
    // return max too.
    if (pos === 0) { return max; }

    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

// convert array to string
var buf2string = function (buf) {
    var str, i, out, c, c_len;
    var len = buf.length;

    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len*2);

    for (out=0, i=0; i<len;) {
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) { utf16buf[out++] = c; continue; }

        c_len = _utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while (c_len > 1 && i < len) {
            c = (c << 6) | (buf[i++] & 0x3f);
            c_len--;
        }

        // terminated by end of string?
        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

        if (c < 0x10000) {
            utf16buf[out++] = c;
        } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
        }
    }

    // shrinkBuf(utf16buf, out)
    if (utf16buf.length !== out) {
        if(utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
        } else {
            utf16buf.length = out;
        }
    }

    // return String.fromCharCode.apply(null, utf16buf);
    return utils.applyFromCharCode(utf16buf);
};


// That's all for the pako functions.


/**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */
exports.utf8encode = function utf8encode(str) {
    if (support.nodebuffer) {
        return nodejsUtils.newBuffer(str, "utf-8");
    }

    return string2buf(str);
};


/**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */
exports.utf8decode = function utf8decode(buf) {
    if (support.nodebuffer) {
        return utils.transformTo("nodebuffer", buf).toString("utf-8");
    }

    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

    return buf2string(buf);
};

/**
 * A worker to decode utf8 encoded binary chunks into string chunks.
 * @constructor
 */
function Utf8DecodeWorker() {
    GenericWorker.call(this, "utf-8 decode");
    // the last bytes if a chunk didn't end with a complete codepoint.
    this.leftOver = null;
}
utils.inherits(Utf8DecodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8DecodeWorker.prototype.processChunk = function (chunk) {

    var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);

    // 1st step, re-use what's left of the previous chunk
    if (this.leftOver && this.leftOver.length) {
        if(support.uint8array) {
            var previousData = data;
            data = new Uint8Array(previousData.length + this.leftOver.length);
            data.set(this.leftOver, 0);
            data.set(previousData, this.leftOver.length);
        } else {
            data = this.leftOver.concat(data);
        }
        this.leftOver = null;
    }

    var nextBoundary = utf8border(data);
    var usableData = data;
    if (nextBoundary !== data.length) {
        if (support.uint8array) {
            usableData = data.subarray(0, nextBoundary);
            this.leftOver = data.subarray(nextBoundary, data.length);
        } else {
            usableData = data.slice(0, nextBoundary);
            this.leftOver = data.slice(nextBoundary, data.length);
        }
    }

    this.push({
        data : exports.utf8decode(usableData),
        meta : chunk.meta
    });
};

/**
 * @see GenericWorker.flush
 */
Utf8DecodeWorker.prototype.flush = function () {
    if(this.leftOver && this.leftOver.length) {
        this.push({
            data : exports.utf8decode(this.leftOver),
            meta : {}
        });
        this.leftOver = null;
    }
};
exports.Utf8DecodeWorker = Utf8DecodeWorker;

/**
 * A worker to endcode string chunks into utf8 encoded binary chunks.
 * @constructor
 */
function Utf8EncodeWorker() {
    GenericWorker.call(this, "utf-8 encode");
}
utils.inherits(Utf8EncodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8EncodeWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : exports.utf8encode(chunk.data),
        meta : chunk.meta
    });
};
exports.Utf8EncodeWorker = Utf8EncodeWorker;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.parseStartTime = parseStartTime;
exports.parseEndTime = parseEndTime;
exports.randomString = randomString;
exports.queryString = queryString;
exports.getSDK = getSDK;
exports.getConfig = getConfig;
exports.omit = omit;
exports.callPlayer = callPlayer;
exports.isObject = isObject;
exports.isEqual = isEqual;
exports.isMediaStream = isMediaStream;

var _loadScript = __webpack_require__(1470);

var _loadScript2 = _interopRequireDefault(_loadScript);

var _deepmerge = __webpack_require__(1471);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _props = __webpack_require__(733);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/;

// Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds
function parseTimeParam(url, pattern) {
  var match = url.match(pattern);
  if (match) {
    var stamp = match[1];
    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }
    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }
  return undefined;
}

function parseTimeString(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);
  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }
  return seconds;
}

function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}

function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
}

// http://stackoverflow.com/a/38622545
function randomString() {
  return Math.random().toString(36).substr(2, 5);
}

function queryString(object) {
  return Object.keys(object).map(function (key) {
    return key + '=' + object[key];
  }).join('&');
}

// Util function to load an external SDK
// or return the SDK if it is already loaded
var resolves = {};
function getSDK(url, sdkGlobal) {
  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };
  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript2['default'];

  if (window[sdkGlobal] && isLoaded(window[sdkGlobal])) {
    return Promise.resolve(window[sdkGlobal]);
  }
  return new Promise(function (resolve, reject) {
    // If we are already loading the SDK, add the resolve
    // function to the existing array of resolve functions
    if (resolves[url]) {
      resolves[url].push(resolve);
      return;
    }
    resolves[url] = [resolve];
    var onLoaded = function onLoaded(sdk) {
      // When loaded, resolve all pending promises
      resolves[url].forEach(function (resolve) {
        return resolve(sdk);
      });
    };
    if (sdkReady) {
      var previousOnReady = window[sdkReady];
      window[sdkReady] = function () {
        if (previousOnReady) previousOnReady();
        onLoaded(window[sdkGlobal]);
      };
    }
    fetchScript(url, function (err) {
      if (err) reject(err);
      if (!sdkReady) {
        onLoaded(window[sdkGlobal]);
      }
    });
  });
}

function getConfig(props, defaultProps, showWarning) {
  var config = (0, _deepmerge2['default'])(defaultProps.config, props.config);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _props.DEPRECATED_CONFIG_PROPS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var p = _step.value;

      if (props[p]) {
        var key = p.replace(/Config$/, '');
        config = (0, _deepmerge2['default'])(config, _defineProperty({}, key, props[p]));
        if (showWarning) {
          var link = 'https://github.com/CookPete/react-player#config-prop';
          var message = 'ReactPlayer: %c' + p + ' %cis deprecated, please use the config prop instead \u2013 ' + link;
          console.warn(message, 'font-weight: bold', '');
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return config;
}

function omit(object) {
  var _ref;

  for (var _len = arguments.length, arrays = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  var omitKeys = (_ref = []).concat.apply(_ref, arrays);
  var output = {};
  var keys = Object.keys(object);
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      if (omitKeys.indexOf(key) === -1) {
        output[key] = object[key];
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2['return']) {
        _iterator2['return']();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return output;
}

function callPlayer(method) {
  var _player;

  // Util method for calling a method on this.player
  // but guard against errors and console.warn instead
  if (!this.player || !this.player[method]) {
    var message = 'ReactPlayer: ' + this.constructor.displayName + ' player could not call %c' + method + '%c \u2013 ';
    if (!this.player) {
      message += 'The player was not available';
    } else if (!this.player[method]) {
      message += 'The method was not available';
    }
    console.warn(message, 'font-weight: bold', '');
    return null;
  }

  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_player = this.player)[method].apply(_player, args);
}

function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

// Deep comparison of two objects but ignoring
// functions, for use in shouldComponentUpdate
function isEqual(a, b) {
  if (typeof a === 'function' && typeof b === 'function') {
    return true;
  }
  if (a instanceof Array && b instanceof Array) {
    if (a.length !== b.length) {
      return false;
    }
    for (var i = 0; i !== a.length; i++) {
      if (!isEqual(a[i], b[i])) {
        return false;
      }
    }
    return true;
  }
  if (isObject(a) && isObject(b)) {
    if (Object.keys(a).length !== Object.keys(b).length) {
      return false;
    }
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = Object.keys(a)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var key = _step3.value;

        if (!isEqual(a[key], b[key])) {
          return false;
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
          _iterator3['return']();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return true;
  }
  return a === b;
}

function isMediaStream(url) {
  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(1066);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry3 = __webpack_require__(5);


/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig (a -> a) -> Number -> [a] -> [a]
 * @param {Function} fn The function to apply.
 * @param {Number} idx The index.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
 */
module.exports = _curry3(function adjust(fn, idx, list) {
  if (idx >= list.length || idx < -list.length) {
    return list;
  }
  var start = idx < 0 ? list.length : 0;
  var _idx = start + idx;
  var _list = _concat(list);
  _list[_idx] = fn(list[_idx]);
  return _list;
});


/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = (function() {
  function XWrap(fn) {
    this.f = fn;
  }
  XWrap.prototype['@@transducer/init'] = function() {
    throw new Error('init not implemented on XWrap');
  };
  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
  XWrap.prototype['@@transducer/step'] = function(acc, x) {
    return this.f(acc, x);
  };

  return function _xwrap(fn) { return new XWrap(fn); };
}());


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _curry2 = __webpack_require__(1);


/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      var log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */
module.exports = _curry2(function bind(fn, thisObj) {
  return _arity(fn.length, function() {
    return fn.apply(thisObj, arguments);
  });
});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var _has = __webpack_require__(14);


module.exports = (function() {
  var toString = Object.prototype.toString;
  return toString.call(arguments) === '[object Arguments]' ?
    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
    function _isArguments(x) { return _has('callee', x); };
}());


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if both arguments are `true`; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if it is falsy, otherwise the second argument.
 * @see R.both
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */
module.exports = _curry2(function and(a, b) {
  return a && b;
});


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xany = __webpack_require__(153);


/**
 * Returns `true` if at least one of elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      var lessThan0 = R.flip(R.lt)(0);
 *      var lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */
module.exports = _curry2(_dispatchable(['any'], _xany, function any(fn, list) {
  var idx = 0;
  while (idx < list.length) {
    if (fn(list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduced = __webpack_require__(42);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XAny(f, xf) {
    this.xf = xf;
    this.f = f;
    this.any = false;
  }
  XAny.prototype['@@transducer/init'] = _xfBase.init;
  XAny.prototype['@@transducer/result'] = function(result) {
    if (!this.any) {
      result = this.xf['@@transducer/step'](result, false);
    }
    return this.xf['@@transducer/result'](result);
  };
  XAny.prototype['@@transducer/step'] = function(result, input) {
    if (this.f(input)) {
      this.any = true;
      result = _reduced(this.xf['@@transducer/step'](result, true));
    }
    return result;
  };

  return _curry2(function _xany(f, xf) { return new XAny(f, xf); });
}());


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      var nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */
module.exports = _curry2(function apply(fn, args) {
  return fn.apply(this, args);
});


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var keys = __webpack_require__(32);


/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */
module.exports = _curry1(function values(obj) {
  var props = keys(obj);
  var len = props.length;
  var vals = [];
  var idx = 0;
  while (idx < len) {
    vals[idx] = obj[props[idx]];
    idx += 1;
  }
  return vals;
});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var _has = __webpack_require__(14);
var _isArray = __webpack_require__(41);
var _isInteger = __webpack_require__(98);
var assoc = __webpack_require__(75);
var isNil = __webpack_require__(157);


/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */
module.exports = _curry3(function assocPath(path, val, obj) {
  if (path.length === 0) {
    return val;
  }
  var idx = path[0];
  if (path.length > 1) {
    var nextObj = (!isNil(obj) && _has(idx, obj)) ? obj[idx] : _isInteger(path[1]) ? [] : {};
    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
  }
  if (_isInteger(idx) && _isArray(obj)) {
    var arr = [].concat(obj);
    arr[idx] = val;
    return arr;
  } else {
    return assoc(idx, val, obj);
  }
});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */
module.exports = _curry1(function isNil(x) { return x == null; });


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduce = __webpack_require__(18);
var ap = __webpack_require__(97);
var curryN = __webpack_require__(13);
var map = __webpack_require__(16);


/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */
module.exports = _curry2(function liftN(arity, fn) {
  var lifted = curryN(arity, fn);
  return curryN(arity, function() {
    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
  });
});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var _isArrayLike = __webpack_require__(74);


/**
 * `_makeFlat` is a helper function that returns a one-level or fully recursive
 * function based on the flag passed in.
 *
 * @private
 */
module.exports = function _makeFlat(recursive) {
  return function flatt(list) {
    var value, jlen, j;
    var result = [];
    var idx = 0;
    var ilen = list.length;

    while (idx < ilen) {
      if (_isArrayLike(list[idx])) {
        value = recursive ? flatt(list[idx]) : list[idx];
        j = 0;
        jlen = value.length;
        while (j < jlen) {
          result[result.length] = value[j];
          j += 1;
        }
      } else {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
    return result;
  };
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var _cloneRegExp = __webpack_require__(161);
var type = __webpack_require__(100);


/**
 * Copies an object.
 *
 * @private
 * @param {*} value The value to be copied
 * @param {Array} refFrom Array containing the source references
 * @param {Array} refTo Array containing the copied source references
 * @param {Boolean} deep Whether or not to perform deep cloning.
 * @return {*} The copied value.
 */
module.exports = function _clone(value, refFrom, refTo, deep) {
  var copy = function copy(copiedValue) {
    var len = refFrom.length;
    var idx = 0;
    while (idx < len) {
      if (value === refFrom[idx]) {
        return refTo[idx];
      }
      idx += 1;
    }
    refFrom[idx + 1] = value;
    refTo[idx + 1] = copiedValue;
    for (var key in value) {
      copiedValue[key] = deep ?
        _clone(value[key], refFrom, refTo, true) : value[key];
    }
    return copiedValue;
  };
  switch (type(value)) {
    case 'Object':  return copy({});
    case 'Array':   return copy([]);
    case 'Date':    return new Date(value.valueOf());
    case 'RegExp':  return _cloneRegExp(value);
    default:        return value;
  }
};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = function _cloneRegExp(pattern) {
  return new RegExp(pattern.source, (pattern.global     ? 'g' : '') +
                                    (pattern.ignoreCase ? 'i' : '') +
                                    (pattern.multiline  ? 'm' : '') +
                                    (pattern.sticky     ? 'y' : '') +
                                    (pattern.unicode    ? 'u' : ''));
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */
module.exports = _curry1(function not(a) {
  return !a;
});


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _pipe = __webpack_require__(291);
var reduce = __webpack_require__(33);
var tail = __webpack_require__(102);


/**
 * Performs left-to-right function composition. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      var f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 */
module.exports = function pipe() {
  if (arguments.length === 0) {
    throw new Error('pipe requires at least one argument');
  }
  return _arity(arguments[0].length,
                reduce(_pipe, arguments[0], tail(arguments)));
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var chain = __webpack_require__(99);
var compose = __webpack_require__(101);
var map = __webpack_require__(16);


/**
 * Returns the right-to-left Kleisli composition of the provided functions,
 * each of which must return a value of a type supported by [`chain`](#chain).
 *
 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), R.chain(f))`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Function
 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipeK
 * @example
 *
 *       //  get :: String -> Object -> Maybe *
 *       var get = R.curry((propName, obj) => Maybe(obj[propName]))
 *
 *       //  getStateCode :: Maybe String -> Maybe String
 *       var getStateCode = R.composeK(
 *         R.compose(Maybe.of, R.toUpper),
 *         get('state'),
 *         get('address'),
 *         get('user'),
 *       );
 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
 *       getStateCode({}); //=> Maybe.Nothing()
 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
 */
module.exports = function composeK() {
  if (arguments.length === 0) {
    throw new Error('composeK requires at least one argument');
  }
  var init = Array.prototype.slice.call(arguments);
  var last = init.pop();
  return compose(compose.apply(this, map(chain, init)), last);
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _pipeP = __webpack_require__(293);
var reduce = __webpack_require__(33);
var tail = __webpack_require__(102);


/**
 * Performs left-to-right composition of one or more Promise-returning
 * functions. The leftmost function may have any arity; the remaining functions
 * must be unary.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.composeP
 * @example
 *
 *      //  followersForUser :: String -> Promise [User]
 *      var followersForUser = R.pipeP(db.getUserById, db.getFollowers);
 */
module.exports = function pipeP() {
  if (arguments.length === 0) {
    throw new Error('pipeP requires at least one argument');
  }
  return _arity(arguments[0].length,
                reduce(_pipeP, arguments[0], tail(arguments)));
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var equals = __webpack_require__(19);


module.exports = function _indexOf(list, a, idx) {
  var inf, item;
  // Array.prototype.indexOf doesn't exist below IE9
  if (typeof list.indexOf === 'function') {
    switch (typeof a) {
      case 'number':
        if (a === 0) {
          // manually crawl the list to distinguish between +0 and -0
          inf = 1 / a;
          while (idx < list.length) {
            item = list[idx];
            if (item === 0 && 1 / item === inf) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        } else if (a !== a) {
          // NaN
          while (idx < list.length) {
            item = list[idx];
            if (typeof item === 'number' && item !== item) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        }
        // non-zero numbers can utilise Set
        return list.indexOf(a, idx);

      // all these types can utilise Set
      case 'string':
      case 'boolean':
      case 'function':
      case 'undefined':
        return list.indexOf(a, idx);

      case 'object':
        if (a === null) {
          // null can utilise Set
          return list.indexOf(a, idx);
        }
    }
  }
  // anything else not covered above, defer to R.equals
  while (idx < list.length) {
    if (equals(list[idx], a)) {
      return idx;
    }
    idx += 1;
  }
  return -1;
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      var o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */
module.exports = _curry2(function identical(a, b) {
  // SameValue algorithm
  if (a === b) { // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
  } else {
    // Step 6.a: NaN == NaN
    return a !== a && b !== b;
  }
});


/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = function _complement(f) {
  return function() {
    return !f.apply(this, arguments);
  };
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var curry = __webpack_require__(79);
var nAry = __webpack_require__(76);


/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      };
 *      Salad.prototype.recipe = function() {
 *        var instructions = R.map((ingredient) => (
 *          'Add a whollop of ' + ingredient, this.ingredients)
 *        )
 *        return R.join('\n', instructions)
 *      }
 *
 *      var ThreeLayerSalad = R.constructN(3, Salad)
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      var salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup')
 *      console.log(salad.recipe());
 *      // Add a whollop of Mayonnaise
 *      // Add a whollop of Potato Chips
 *      // Add a whollop of Potato Ketchup
 */
module.exports = _curry2(function constructN(n, Fn) {
  if (n > 10) {
    throw new Error('Constructor with greater than ten arguments');
  }
  if (n === 0) {
    return function() { return new Fn(); };
  }
  return curry(nAry(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
    switch (arguments.length) {
      case  1: return new Fn($0);
      case  2: return new Fn($0, $1);
      case  3: return new Fn($0, $1, $2);
      case  4: return new Fn($0, $1, $2, $3);
      case  5: return new Fn($0, $1, $2, $3, $4);
      case  6: return new Fn($0, $1, $2, $3, $4, $5);
      case  7: return new Fn($0, $1, $2, $3, $4, $5, $6);
      case  8: return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
      case  9: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
      case 10: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
    }
  }));
});


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _map = __webpack_require__(73);
var curryN = __webpack_require__(13);
var max = __webpack_require__(50);
var pluck = __webpack_require__(57);
var reduce = __webpack_require__(33);


/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. When invoked, this new function is applied to some
 * arguments, each branching function is applied to those same arguments. The
 * results of each branching function are passed as arguments to the converging
 * function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig (x1 -> x2 -> ... -> z) -> [(a -> b -> ... -> x1), (a -> b -> ... -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      var average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */
module.exports = _curry2(function converge(after, fns) {
  return curryN(reduce(max, 0, pluck('length', fns)), function() {
    var args = arguments;
    var context = this;
    return after.apply(context, _map(function(fn) {
      return fn.apply(context, args);
    }, fns));
  });
});


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      var defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */
module.exports = _curry2(function defaultTo(d, v) {
  return v == null || v !== v ? d : v;
});


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);
var _curry2 = __webpack_require__(1);


/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */
module.exports = _curry2(function difference(first, second) {
  var out = [];
  var idx = 0;
  var firstLen = first.length;
  while (idx < firstLen) {
    if (!_contains(first[idx], second) && !_contains(first[idx], out)) {
      out[out.length] = first[idx];
    }
    idx += 1;
  }
  return out;
});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var _containsWith = __webpack_require__(83);
var _curry3 = __webpack_require__(5);


/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      var cmp = (x, y) => x.a === y.a;
 *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      var l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */
module.exports = _curry3(function differenceWith(pred, first, second) {
  var out = [];
  var idx = 0;
  var firstLen = first.length;
  while (idx < firstLen) {
    if (!_containsWith(pred, first[idx], second) &&
        !_containsWith(pred, first[idx], out)) {
      out.push(first[idx]);
    }
    idx += 1;
  }
  return out;
});


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */
module.exports = _curry2(function dissoc(prop, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  delete result[prop];
  return result;
});


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */
module.exports = _curry3(function remove(start, count, list) {
  var result = Array.prototype.slice.call(list, 0);
  result.splice(start, count);
  return result;
});


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xdrop = __webpack_require__(310);
var slice = __webpack_require__(45);


/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */
module.exports = _curry2(_dispatchable(['drop'], _xdrop, function drop(n, xs) {
  return slice(Math.max(0, n), Infinity, xs);
}));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XDropRepeatsWith(pred, xf) {
    this.xf = xf;
    this.pred = pred;
    this.lastValue = undefined;
    this.seenFirstValue = false;
  }

  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;
  XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
    var sameAsLast = false;
    if (!this.seenFirstValue) {
      this.seenFirstValue = true;
    } else if (this.pred(this.lastValue, input)) {
      sameAsLast = true;
    }
    this.lastValue = input;
    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
  };

  return _curry2(function _xdropRepeatsWith(pred, xf) { return new XDropRepeatsWith(pred, xf); });
}());


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xdropRepeatsWith = __webpack_require__(177);
var last = __webpack_require__(179);


/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig (a, a -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */
module.exports = _curry2(_dispatchable([], _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
  var result = [];
  var idx = 1;
  var len = list.length;
  if (len !== 0) {
    result[0] = list[0];
    while (idx < len) {
      if (!pred(last(result), list[idx])) {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
  }
  return result;
}));



/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var nth = __webpack_require__(61);


/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */
module.exports = nth(-1);


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if one or both of its arguments are `true`. Returns `false`
 * if both arguments are `false`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if truthy, otherwise the second argument.
 * @see R.either
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */
module.exports = _curry2(function or(a, b) {
  return a || b;
});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _isArguments = __webpack_require__(150);
var _isArray = __webpack_require__(41);
var _isObject = __webpack_require__(106);
var _isString = __webpack_require__(58);


/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
 * types are supported if they define `<Type>.empty` and/or
 * `<Type>.prototype.empty`.
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));      //=> Nothing()
 *      R.empty([1, 2, 3]);     //=> []
 *      R.empty('unicorns');    //=> ''
 *      R.empty({x: 1, y: 2});  //=> {}
 */
module.exports = _curry1(function empty(x) {
  return (
    (x != null && typeof x['fantasy-land/empty'] === 'function') ?
      x['fantasy-land/empty']() :
    (x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function') ?
      x.constructor['fantasy-land/empty']() :
    (x != null && typeof x.empty === 'function') ?
      x.empty() :
    (x != null && x.constructor != null && typeof x.constructor.empty === 'function') ?
      x.constructor.empty() :
    _isArray(x) ?
      [] :
    _isString(x) ?
      '' :
    _isObject(x) ?
      {} :
    _isArguments(x) ?
      (function() { return arguments; }()) :
    // else
      void 0
  );
});


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var drop = __webpack_require__(176);


/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */
module.exports = _curry2(function takeLast(n, xs) {
  return drop(n >= 0 ? xs.length - n : 0, xs);
});


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var _Set = __webpack_require__(354);
var _curry2 = __webpack_require__(1);


/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */
module.exports = _curry2(function uniqBy(fn, list) {
  var set = new _Set();
  var result = [];
  var idx = 0;
  var appliedItem, item;

  while (idx < list.length) {
    item = list[idx];
    appliedItem = fn(item);
    if (set.add(appliedItem)) {
      result.push(item);
    }
    idx += 1;
  }
  return result;
});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      var matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */
module.exports = _curry2(function objOf(key, val) {
  var obj = {};
  obj[key] = val;
  return obj;
});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * See if an object (`val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */
module.exports = _curry2(function is(Ctor, val) {
  return val != null && val.constructor === Ctor || val instanceof Ctor;
});


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var converge = __webpack_require__(170);


/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      var getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */
module.exports = _curry1(function juxt(fns) {
  return converge(function() { return Array.prototype.slice.call(arguments, 0); }, fns);
});


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _isNumber = __webpack_require__(188);


/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */
module.exports = _curry1(function length(list) {
  return list != null && _isNumber(list.length) ? list.length : NaN;
});


/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var sum = __webpack_require__(190);


/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */
module.exports = _curry1(function mean(list) {
  return sum(list) / list.length;
});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var add = __webpack_require__(71);
var reduce = __webpack_require__(33);


/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */
module.exports = reduce(add, 0);


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _curry2 = __webpack_require__(1);
var _has = __webpack_require__(14);


/**
 * A customisable version of [`R.memoize`](#memoize). `memoizeWith` takes an
 * additional function that will be applied to a given argument set and used to
 * create the cache key under which the results of the function to be memoized
 * will be stored. Care must be taken when implementing key generation to avoid
 * clashes that may overwrite previous entries erroneously.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoize
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */
module.exports = _curry2(function memoizeWith(mFn, fn) {
  var cache = {};
  return _arity(fn.length, function() {
    var key = mFn.apply(this, arguments);
    if (!_has(key, cache)) {
      cache[key] = fn.apply(this, arguments);
    }
    return cache[key];
  });
});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      var double = R.multiply(2);
 *      var triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */
module.exports = _curry2(function multiply(a, b) { return a * b; });


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */
module.exports = (function() {
  // `Identity` is a functor that holds a single value, where `map` simply
  // transforms the held value with the provided function.
  var Identity = function(x) {
    return {value: x, map: function(f) { return Identity(f(x)); }};
  };

  return _curry3(function over(lens, f, x) {
    // The value returned by the getter function is first transformed with `f`,
    // then set as the value of an `Identity`. This is then mapped over with the
    // setter function of the lens.
    return lens(function(y) { return Identity(f(y)); })(x).value;
  });
}());


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _curry2 = __webpack_require__(1);


module.exports = function _createPartialApplicator(concat) {
  return _curry2(function(fn, args) {
    return _arity(Math.max(0, fn.length - args.length), function() {
      return fn.apply(this, concat(args, arguments));
    });
  });
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */
module.exports = _curry2(function pickAll(names, obj) {
  var result = {};
  var idx = 0;
  var len = names.length;
  while (idx < len) {
    var name = names[idx];
    result[name] = obj[name];
    idx += 1;
  }
  return result;
});


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry2 = __webpack_require__(1);


/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */
module.exports = _curry2(function prepend(el, list) {
  return _concat([el], list);
});


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var curryN = __webpack_require__(13);


/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (x1 -> x2 -> ... -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */
module.exports = _curry2(function useWith(fn, transformers) {
  return curryN(transformers.length, function() {
    var args = [];
    var idx = 0;
    while (idx < transformers.length) {
      args.push(transformers[idx].call(this, arguments[idx]));
      idx += 1;
    }
    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
  });
});


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a, b -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *          -               -2
 *         / \              / \
 *        1   -            1   3
 *           / \              / \
 *          2   -     ==>    2  -1
 *             / \              / \
 *            3   -            3   4
 *               / \              / \
 *              4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */
module.exports = _curry3(function reduceRight(fn, acc, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    acc = fn(list[idx], acc);
    idx -= 1;
  }
  return acc;
});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */
module.exports = _curry2(function times(fn, n) {
  var len = Number(n);
  var idx = 0;
  var list;

  if (len < 0 || isNaN(len)) {
    throw new RangeError('n must be a non-negative number');
  }
  list = new Array(len);
  while (idx < len) {
    list[idx] = fn(idx);
    idx += 1;
  }
  return list;
});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var ap = __webpack_require__(97);
var map = __webpack_require__(16);
var prepend = __webpack_require__(196);
var reduceRight = __webpack_require__(198);


/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */
module.exports = _curry2(function sequence(of, traversable) {
  return typeof traversable.sequence === 'function' ?
    traversable.sequence(of) :
    reduceRight(function(x, acc) { return ap(map(prepend, x), acc); },
                of([]),
                traversable);
});


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _has = __webpack_require__(14);


/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @example
 *
 *      // pred :: Object -> Boolean
 *      var pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */
module.exports = _curry2(function where(spec, testObj) {
  for (var prop in spec) {
    if (_has(prop, spec) && !spec[prop](testObj[prop])) {
      return false;
    }
  }
  return true;
});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(466)();
}


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(203);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(206);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(115);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7392f206d905d9f0514a5acc03261bd0.eot";

/***/ }),
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var neither = (0, _ramda.complement)(_ramda.and);
var sortByDateAsc = (0, _ramda.sort)((0, _ramda.cond)([[_ramda.lt, (0, _ramda.always)(-1)], [_ramda.gt, (0, _ramda.always)(1)], [_ramda.T, (0, _ramda.always)(0)]]));
var NewDate = function NewDate(date) {
  return new Date(date);
};
var getStartDate = function getStartDate(obj) {
  var start = obj.startDate || obj.seasonStartDate || obj.fromDate;
  if (start) return new Date(start);
  // below block is legacy, might not get to be called
  // but not 100% sure
  return (0, _ramda.call)((0, _ramda.compose)((0, _ramda.ifElse)(_ramda.identity, (0, _ramda.construct)(NewDate), (0, _ramda.always)(null)), (0, _ramda.ifElse)((0, _ramda.compose)((0, _ramda.equals)(2), _ramda.length), (0, _ramda.apply)(_ramda.min), (0, _ramda.prop)(0)), _ramda.values, (0, _ramda.omit)(['_id', 'eventName'])), obj);
};
var getEndDate = function getEndDate(obj) {
  var end = obj.endDate || obj.seasonEndDate || obj.toDate || obj.startDate;
  if (end) return new Date(end);
  return (0, _ramda.call)((0, _ramda.compose)((0, _ramda.ifElse)(_ramda.identity, (0, _ramda.construct)(NewDate), (0, _ramda.always)(null)), (0, _ramda.ifElse)((0, _ramda.compose)((0, _ramda.equals)(2), _ramda.length), (0, _ramda.apply)(_ramda.max), (0, _ramda.prop)(0)), _ramda.values, (0, _ramda.omit)(['_id', 'eventName'])), obj);
};

var getFirstDayFromAnArrayOfRanges = (0, _ramda.compose)(_ramda.head, sortByDateAsc, (0, _ramda.map)(getStartDate));

var getLastDayFromAnArrayOfRanges = (0, _ramda.compose)(_ramda.last, sortByDateAsc, (0, _ramda.map)(getEndDate));

var sortDateRangeAsc = (0, _ramda.sort)((0, _ramda.cond)([[(0, _ramda.useWith)(_ramda.lt, [getStartDate, getStartDate]), (0, _ramda.always)(-1)], [(0, _ramda.useWith)(_ramda.gt, [getStartDate, getStartDate]), (0, _ramda.always)(1)], [_ramda.T, (0, _ramda.always)(0)]]));
var notEqual = (0, _ramda.complement)(_ramda.equals);

var getMissingRangesReducerFn = function getMissingRangesReducerFn(missingRanges, currentRange, index, ranges) {
  if (!index) return missingRanges;
  var currentStartDate = getStartDate(currentRange);
  var yesterday = _moment2.default.utc(currentStartDate).subtract(1, 'days');
  var lastEndDate = getEndDate(ranges[index - 1]);
  var tomorrow = _moment2.default.utc(lastEndDate).add(1, 'days');
  return (0, _ramda.call)((0, _ramda.ifElse)(function () {
    return _moment2.default.utc(lastEndDate).isBefore(yesterday, 'day');
  }, (0, _ramda.append)({ from: tomorrow, to: yesterday }), _ramda.identity), missingRanges);
};

var getMissingRanges = function getMissingRanges(allRanges, contractingPeriod) {
  return (0, _ramda.call)((0, _ramda.compose)((0, _ramda.addIndex)(_ramda.reduce)(getMissingRangesReducerFn, []), sortDateRangeAsc, function () {
    return addContractingPeriodToDateRanges(allRanges, contractingPeriod);
  }));
};
var dateToString = function dateToString(date) {
  return _moment2.default.utc(date).format('DD MMM YYYY');
};

var notInContractingPeriod = function notInContractingPeriod(seasons, start, end) {
  var seasonFirst = getFirstDayFromAnArrayOfRanges(seasons);
  var seasonLast = getLastDayFromAnArrayOfRanges(seasons);
  if (neither(_moment2.default.utc(seasonFirst).isBetween(start, end, 'day', '[]'), _moment2.default.utc(seasonLast).isBetween(start, end, 'day', '[]'))) {
    return 'Your seasons, which start from ' + dateToString(seasonFirst) + ' - ' + dateToString(seasonLast) + ',\n    are not within your contract validity period.';
  }
  return '';
};

var _getDateFromUTC = function _getDateFromUTC(date) {
  var dateObject = new Date(date);
  return new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate());
};
var transformDateRanges = function transformDateRanges(dateRanges) {
  return dateRanges.map(function (dateRange) {
    return Object.keys(dateRange).reduce(function (result, key) {
      if (key.indexOf('tartDate') > 0) result.from = _getDateFromUTC(dateRange[key]);
      if (key.indexOf('ndDate') > 0) result.to = _getDateFromUTC(dateRange[key]);
      return result;
    }, {});
  });
};
var sameDay = function sameDay(d1, d2) {
  return (0, _moment2.default)(d1).isSame(d2, 'day');
};
var datesMatch = (0, _ramda.curry)(function (range1, range2) {
  return sameDay(getStartDate(range1), getStartDate(range2)) && sameDay(getEndDate(range1), getEndDate(range2));
});
var existsIn = (0, _ramda.curry)(function (rangesFromSeason, range) {
  return (0, _ramda.any)(datesMatch(range), rangesFromSeason);
});
var checkIfSameSeason = (0, _ramda.curry)(function (ranges, rangesFromSeason) {
  return (0, _ramda.and)((0, _ramda.all)(existsIn(rangesFromSeason), ranges), (0, _ramda.all)(existsIn(ranges), rangesFromSeason));
});
var getSeasonNameIfMatch = (0, _ramda.curry)(function (seasons, ranges) {
  return (0, _ramda.call)((0, _ramda.compose)((0, _ramda.propOr)('', 'seasonName'), (0, _ramda.find)((0, _ramda.compose)(checkIfSameSeason(ranges), (0, _ramda.propOr)([], 'dateRanges')))), seasons);
});
var displayRange = function displayRange(range) {
  var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var start = getStartDate(range);
  var end = getEndDate(range);
  return sameDay(start, end) ? _react2.default.createElement(
    'span',
    { className: classes.start },
    dateToString(start)
  ) : _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(
      'span',
      { className: classes.start },
      dateToString(start)
    ),
    ' - ',
    _react2.default.createElement(
      'span',
      { className: classes.end },
      dateToString(end)
    )
  );
};
var displayDateRanges = function displayDateRanges(dateRanges) {
  return dateRanges.map(function (range, index) {
    return _react2.default.createElement(
      'div',
      { key: index },
      displayRange(range)
    );
  });
};

var addContractingPeriodToDateRanges = function addContractingPeriodToDateRanges(dateRanges, contractingPeriod) {
  return (0, _ramda.concat)(dateRanges, [{
    seasonStartDate: _moment2.default.utc(contractingPeriod.startDate).subtract(1, 'days'),
    seasonEndDate: _moment2.default.utc(contractingPeriod.startDate).subtract(1, 'days')
  }, {
    seasonStartDate: _moment2.default.utc(contractingPeriod.endDate).add(1, 'days')
  }]);
};
var seasonCovered = function seasonCovered(dateRanges, contractingPeriod) {
  var dateRangesWithStartAndEnd = addContractingPeriodToDateRanges(dateRanges, contractingPeriod);
  return !notInContractingPeriod(dateRanges, getStartDate(contractingPeriod), getEndDate(contractingPeriod)) && (0, _ramda.isEmpty)(getMissingRanges(dateRangesWithStartAndEnd, contractingPeriod));
};
var isSeasonSameWithContractingPeriod = function isSeasonSameWithContractingPeriod(dateRanges, contractingPeriod) {
  return datesMatch(contractingPeriod, (0, _ramda.pathOr)({}, [0, 0], dateRanges));
};

// const matchAllocationOrPolicyWithSeasons = (seasons, contents) => addIndex(map)(ifElse(
//   (season, index) => checkIfSameSeason(prop('dateRanges', season), pathOr([{}], [index, 'dateRanges'], contents)),
//     compose(propOr({}, __, contents), nthArg(1)),
//   (season, index) => {
//     if (index < contents.length) return merge({ correctDateRanges: prop('dateRanges', season), correctSeasonName: prop('seasonName', season) }, contents[index]);
//     return omit(['_id', 'seasonName'], season);
//   }
// ), seasons);
var matchAllocationOrPolicyWithSeasons = function matchAllocationOrPolicyWithSeasons(seasons, contents) {
  return seasons.map(function (season, i) {
    // for allocation, product cancellation, pickup, dropoff
    if (contents[i]) return (0, _ramda.merge)(contents[i], { dateRanges: season.dateRanges });
    return { dateRanges: season.dateRanges };
  });
};

var dayInRange = (0, _ramda.curry)(function (day, _ref) {
  var seasonStartDate = _ref.seasonStartDate,
      seasonEndDate = _ref.seasonEndDate;
  return seasonStartDate && _moment2.default.utc(day).isBetween(seasonStartDate, seasonEndDate || seasonStartDate, 'day', []);
});
var dayInDateRanges = (0, _ramda.curry)(function (day, dateRanges) {
  return dateRanges.some(dayInRange(day));
});
var dayInSeason = (0, _ramda.curry)(function (day, seasons) {
  return seasons.some(function (_ref2) {
    var dateRanges = _ref2.dateRanges;
    return dayInDateRanges(day, dateRanges);
  });
});

exports.default = {
  sortDateRangeAsc: sortDateRangeAsc,
  getMissingRanges: getMissingRanges,
  notInContractingPeriod: notInContractingPeriod,
  dateToString: dateToString,
  transformDateRanges: transformDateRanges,
  datesMatch: datesMatch,
  checkIfSameSeason: checkIfSameSeason,
  getSeasonNameIfMatch: getSeasonNameIfMatch,
  displayDateRanges: displayDateRanges,
  addContractingPeriodToDateRanges: addContractingPeriodToDateRanges,
  seasonCovered: seasonCovered,
  isSeasonSameWithContractingPeriod: isSeasonSameWithContractingPeriod,
  isDateRangesWithEmptyDates: function isDateRangesWithEmptyDates(dateRanges) {
    return !(dateRanges && dateRanges.length && dateRanges.some(function (range) {
      return range.seasonStartDate;
    }));
  },
  getFlattenedUnEmptyDates: (0, _ramda.compose)((0, _ramda.reject)(_ramda.isEmpty), (0, _ramda.chain)((0, _ramda.propOr)([], 'dateRanges'))),
  matchAllocationOrPolicyWithSeasons: matchAllocationOrPolicyWithSeasons,
  checkIfFullSeasonCoveredForAProduct: function checkIfFullSeasonCoveredForAProduct(start, end, arrayOfDates) {
    if (!arrayOfDates.length) return 1;
    var daysInSeason = Math.abs((0, _moment2.default)(start).diff((0, _moment2.default)(end), 'days')) + 1;
    var numOfDays = arrayOfDates.map(function (obj) {
      if (!(getStartDate(obj) && getEndDate(obj))) return 0;
      var rangeStart = (0, _moment2.default)(getStartDate(obj)).add(1, 'd');
      var rangeEnd = (0, _moment2.default)(getEndDate(obj)).add(1, 'd');
      return Math.round((0, _moment2.default)(rangeEnd).diff((0, _moment2.default)(rangeStart), 'days', true) + 1);
    });
    var totalNumOfDaysCovered = numOfDays.reduce(function (a, b) {
      return a + b;
    });
    return daysInSeason - totalNumOfDaysCovered;
  },
  _getDateFromUTC: function _getDateFromUTC(date) {
    if (!date) return date;
    var dateObject = new Date(date);
    return new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate());
  },
  dayInDateRanges: dayInDateRanges,
  dayInSeason: dayInSeason,
  getFirstDayFromAnArrayOfRanges: getFirstDayFromAnArrayOfRanges,
  displayRange: displayRange,
  overlapExisting: function overlapExisting(_ref3, existingSeasons) {
    var from = _ref3.from,
        to = _ref3.to;

    if (!(from && to)) return false;
    return existingSeasons.some(function (_ref4) {
      var dateRanges = _ref4.dateRanges;
      return dateRanges.some(function (range) {
        return range.seasonStartDate && (dayInRange(range.seasonStartDate, { seasonStartDate: from, seasonEndDate: to }) || dayInRange(range.seasonEndDate, { seasonStartDate: from, seasonEndDate: to }) || dayInRange(from, range) || dayInRange(to, range));
      });
    });
    // return (dayInSeason(from, existingSeasons) || dayInSeason(to, existingSeasons));
  },
  removeOverlapDates: function removeOverlapDates(_ref5, existingSeasons) {
    var from = _ref5.from,
        to = _ref5.to;

    var removeOneRangeAFromRangeB = _ramda2.default.curry(function (rangeA, rangeB) {
      var startDate = rangeB.seasonStartDate;
      var endDate = rangeB.seasonEndDate;
      if (!rangeA || !startDate) return [rangeB];
      var rangeAStart = _moment2.default.utc(rangeA.from).format();
      var rangeAEnd = _moment2.default.utc(rangeA.to || rangeA.from).format();
      var dateRangesToReturn = [];
      if (_moment2.default.utc(rangeAEnd).isBefore(startDate, 'day') || _moment2.default.utc(rangeAStart).isAfter(endDate, 'day')) {
        dateRangesToReturn = [rangeB];
      } else if (_moment2.default.utc(rangeAStart).isSameOrAfter(startDate, 'day')) {
        if (_moment2.default.utc(rangeAEnd).isBefore(endDate, 'day')) {
          dateRangesToReturn = [{
            seasonStartDate: startDate,
            seasonEndDate: _moment2.default.utc(rangeAStart).subtract(1, 'days').format()
          }, {
            seasonStartDate: _moment2.default.utc(rangeAEnd).add(1, 'days').format(),
            seasonEndDate: endDate
          }];
        } else {
          dateRangesToReturn = [{
            seasonStartDate: startDate,
            seasonEndDate: _moment2.default.utc(rangeAStart).subtract(1, 'days').format()
          }];
        }
      } else {
        if (_moment2.default.utc(rangeAEnd).isBetween(startDate, endDate, 'day', '[)')) {
          dateRangesToReturn = [{
            seasonStartDate: _moment2.default.utc(rangeAEnd).add(1, 'days').format(),
            seasonEndDate: endDate
          }];
        } else {
          dateRangesToReturn = [];
        }
      }
      return dateRangesToReturn.filter(function (dateRangeToFilter) {
        return _moment2.default.utc(dateRangeToFilter.seasonEndDate).isSameOrAfter(dateRangeToFilter.seasonStartDate, 'day');
      });
    });
    return existingSeasons.map(function (season) {
      var dateRanges = _ramda2.default.chain(removeOneRangeAFromRangeB({ from: from, to: to }), season.dateRanges);
      return (0, _ramda.merge)(season, { dateRanges: dateRanges });
    });
  }
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _delete = __webpack_require__(738);

var _delete2 = _interopRequireDefault(_delete);

var _accessCheckHelperFns = __webpack_require__(631);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditButton = function EditButton(_ref) {
  var onEdit = _ref.onEdit,
      editLabel = _ref.editLabel,
      onDelete = _ref.onDelete,
      deleteButton = _ref.deleteButton,
      readOnly = _ref.readOnly,
      onClick = _ref.onClick;
  return readOnly ? _react2.default.createElement(
    'div',
    { className: 'edit-button', style: { color: '#9e9e9e' } },
    'READ ONLY'
  ) : _react2.default.createElement(
    'div',
    { className: 'edit-button' },
    _react2.default.createElement(
      'span',
      { onClick: onEdit || onClick, className: 'flex-tc-sb' },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-mode_edit', style: { fontSize: '14px', color: '#00bcd4' } }),
      ' ',
      editLabel || 'Edit'
    ),
    deleteButton ? _react2.default.createElement(
      'span',
      { onClick: function onClick(e) {
          e.stopPropagation();
          onDelete();
        }, style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '64px' } },
      _react2.default.createElement(_delete2.default, { style: { fontSize: '18px', color: '#00bcd4', margin: '0 0 1px 8px' } }),
      'Delete'
    ) : _react2.default.createElement('span', null)
  );
};

EditButton.propTypes = {
  onEdit: _react.PropTypes.func,
  onDelete: _react.PropTypes.func,
  deleteButton: _react.PropTypes.bool,
  readOnly: _react.PropTypes.bool,
  editLabel: _react.PropTypes.string
};
var mapStateToProps = function mapStateToProps(state) {
  var user = state.user,
      contracting = state.contracting;

  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  var readOnly = !(0, _accessCheckHelperFns.checkLocAccess)(state, leftNav.locationId, 'contracting', 'write');
  return { readOnly: readOnly };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(EditButton);

/***/ }),
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(10).Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer
var MD5 = __webpack_require__(240)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(693);
curve.short = __webpack_require__(694);
curve.mont = __webpack_require__(695);
curve.edwards = __webpack_require__(696);


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var asn1 = __webpack_require__(712)
var aesid = __webpack_require__(724)
var fixProc = __webpack_require__(725)
var ciphers = __webpack_require__(244)
var compat = __webpack_require__(513)
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = new Buffer(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen)
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var loading = _ref.loading,
      text = _ref.text,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style;
  return _react2.default.createElement(
    'div',
    {
      style: _extends({
        display: loading ? 'block' : 'none',
        height: '100%',
        width: '100%',
        position: 'fixed',
        zIndex: 30,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        overflowX: 'hidden',
        transition: '0.5s',
        textAlign: 'center',
        paddingTop: '20%'
      }, style)
    },
    _react2.default.createElement(_materialUi.CircularProgress, { size: 100, thickness: 7 }),
    _react2.default.createElement(
      'div',
      { style: { fontSize: '20px', color: 'white', marginTop: '24px', whiteSpace: 'pre-wrap', width: '50%', margin: 'auto' } },
      text
    )
  );
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MouseOverEditDiv = function (_Component) {
  _inherits(MouseOverEditDiv, _Component);

  function MouseOverEditDiv(props) {
    _classCallCheck(this, MouseOverEditDiv);

    var _this = _possibleConstructorReturn(this, (MouseOverEditDiv.__proto__ || Object.getPrototypeOf(MouseOverEditDiv)).call(this, props));

    _this._showActionButtons = function () {
      if (_this.props.editable) _this.setState({ showButtons: true });
    };

    _this._hideActionButtons = function () {
      if (_this.props.editable) _this.setState({ showButtons: false });
    };

    _this.state = {
      showButtons: false
    };
    return _this;
  }

  _createClass(MouseOverEditDiv, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var style = _extends({}, { alignItems: 'center', height: '16px', marginRight: '4px' }, this.props.style);
      if (this.props.singleLineTitle || this.props.doubleLineTitle) {
        style.width = '110px';
        style.float = 'right';
        if (this.props.singleLineTitle) style.marginTop = '0';
      }
      var onEdit = _ramda2.default.path(['props', 'actionButtons', 'props', 'onEdit'], this);
      return _react2.default.createElement(
        'div',
        {
          className: this.props.className,
          onMouseOver: function onMouseOver() {
            return _this2._showActionButtons();
          },
          onMouseLeave: function onMouseLeave() {
            return _this2._hideActionButtons();
          },
          style: {
            position: 'relative',
            paddingTop: this.props.editable && this.props.extendPadding ? '14px' : '0px'
          }
        },
        this.props.children,
        _react2.default.createElement(
          'div',
          {
            style: {
              display: this.state.showButtons ? 'block' : 'none',
              position: 'absolute',
              color: 'white',
              top: 0,
              left: 0,
              height: this.props.exposeBottomButtons ? 'calc(100% - 48px)' : '100%',
              width: '100%',
              zIndex: 1,
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              overflowX: 'hidden',
              transition: '0.5s',
              paddingTop: 'auto',
              cursor: 'pointer',
              textAlign: this.props.hintOnRight ? 'right' : 'center'
            },
            onClick: onEdit
          },
          _react2.default.createElement(
            'div',
            { style: style, className: 'mouse-over-edit' },
            this.props.actionButtons
          )
        )
      );
    }
  }]);

  return MouseOverEditDiv;
}(_react.Component);

MouseOverEditDiv.propTypes = {
  editable: _react.PropTypes.bool,
  actionButtons: _react.PropTypes.node,
  children: _react.PropTypes.node,
  singleLineTitle: _react.PropTypes.bool,
  doubleLineTitle: _react.PropTypes.bool,
  regularDiv: _react.PropTypes.bool,
  style: _react.PropTypes.object,
  hintOnRight: _react.PropTypes.bool,
  extendPadding: _react.PropTypes.bool
};

exports.default = MouseOverEditDiv;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global Promise */


// load the global object first:
// - it should be better integrated in the system (unhandledRejection in node)
// - the environment may have a custom Promise implementation (see zone.js)
var ES6Promise = null;
if (typeof Promise !== "undefined") {
    ES6Promise = Promise;
} else {
    ES6Promise = __webpack_require__(935);
}

/**
 * Let the user use/change some implementations.
 */
module.exports = {
    Promise: ES6Promise
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var __WEBPACK_AMD_DEFINE_RESULT__;//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

/*global window, require, define */
(function(_window) {
  'use strict';

  // Unique ID creation requires a high quality random # generator.  We feature
  // detect to determine the best RNG source, normalizing to a function that
  // returns 128-bits of randomness, since that's what's usually required
  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;

  function setupBrowser() {
    // Allow for MSIE11 msCrypto
    var _crypto = _window.crypto || _window.msCrypto;

    if (!_rng && _crypto && _crypto.getRandomValues) {
      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
      //
      // Moderately fast, high quality
      try {
        var _rnds8 = new Uint8Array(16);
        _whatwgRNG = _rng = function whatwgRNG() {
          _crypto.getRandomValues(_rnds8);
          return _rnds8;
        };
        _rng();
      } catch(e) {}
    }

    if (!_rng) {
      // Math.random()-based (RNG)
      //
      // If all else fails, use Math.random().  It's fast, but is of unspecified
      // quality.
      var  _rnds = new Array(16);
      _mathRNG = _rng = function() {
        for (var i = 0, r; i < 16; i++) {
          if ((i & 0x03) === 0) { r = Math.random() * 0x100000000; }
          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }

        return _rnds;
      };
      if ('undefined' !== typeof console && console.warn) {
        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
      }
    }
  }

  function setupNode() {
    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
    //
    // Moderately fast, high quality
    if (true) {
      try {
        var _rb = __webpack_require__(659).randomBytes;
        _nodeRNG = _rng = _rb && function() {return _rb(16);};
        _rng();
      } catch(e) {}
    }
  }

  if (_window) {
    setupBrowser();
  } else {
    setupNode();
  }

  // Buffer class to use
  var BufferClass = ('function' === typeof Buffer) ? Buffer : Array;

  // Maps for number <-> hex string conversion
  var _byteToHex = [];
  var _hexToByte = {};
  for (var i = 0; i < 256; i++) {
    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
    _hexToByte[_byteToHex[i]] = i;
  }

  // **`parse()` - Parse a UUID into it's component bytes**
  function parse(s, buf, offset) {
    var i = (buf && offset) || 0, ii = 0;

    buf = buf || [];
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
      if (ii < 16) { // Don't overflow!
        buf[i + ii++] = _hexToByte[oct];
      }
    });

    // Zero out remaining bytes if string was short
    while (ii < 16) {
      buf[i + ii++] = 0;
    }

    return buf;
  }

  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
  function unparse(buf, offset) {
    var i = offset || 0, bth = _byteToHex;
    return  bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]];
  }

  // **`v1()` - Generate time-based UUID**
  //
  // Inspired by https://github.com/LiosK/UUID.js
  // and http://docs.python.org/library/uuid.html

  // random #'s we need to init node and clockseq
  var _seedBytes = _rng();

  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
  var _nodeId = [
    _seedBytes[0] | 0x01,
    _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
  ];

  // Per 4.2.2, randomize (14 bit) clockseq
  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

  // Previous uuid creation time
  var _lastMSecs = 0, _lastNSecs = 0;

  // See https://github.com/broofa/node-uuid for API details
  function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];

    options = options || {};

    var clockseq = (options.clockseq != null) ? options.clockseq : _clockseq;

    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = (options.msecs != null) ? options.msecs : new Date().getTime();

    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = (options.nsecs != null) ? options.nsecs : _lastNSecs + 1;

    // Time since last uuid creation (in msecs)
    var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq == null) {
      clockseq = clockseq + 1 & 0x3fff;
    }

    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
      nsecs = 0;
    }

    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) {
      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    }

    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;

    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;

    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;

    // `time_mid`
    var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;

    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;

    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;

    // `clock_seq_low`
    b[i++] = clockseq & 0xff;

    // `node`
    var node = options.node || _nodeId;
    for (var n = 0; n < 6; n++) {
      b[i + n] = node[n];
    }

    return buf ? buf : unparse(b);
  }

  // **`v4()` - Generate random UUID**

  // See https://github.com/broofa/node-uuid for API details
  function v4(options, buf, offset) {
    // Deprecated - 'format' argument, as supported in v1.2
    var i = buf && offset || 0;

    if (typeof(options) === 'string') {
      buf = (options === 'binary') ? new BufferClass(16) : null;
      options = null;
    }
    options = options || {};

    var rnds = options.random || (options.rng || _rng)();

    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;

    // Copy bytes to buffer, if provided
    if (buf) {
      for (var ii = 0; ii < 16; ii++) {
        buf[i + ii] = rnds[ii];
      }
    }

    return buf || unparse(rnds);
  }

  // Export public API
  var uuid = v4;
  uuid.v1 = v1;
  uuid.v4 = v4;
  uuid.parse = parse;
  uuid.unparse = unparse;
  uuid.BufferClass = BufferClass;
  uuid._rng = _rng;
  uuid._mathRNG = _mathRNG;
  uuid._nodeRNG = _nodeRNG;
  uuid._whatwgRNG = _whatwgRNG;

  if (('undefined' !== typeof module) && module.exports) {
    // Publish as node.js module
    module.exports = uuid;
  } else if (true) {
    // Publish as AMD module
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {return uuid;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


  } else {
    // Publish as global (in browsers)
    _previousRoot = _window.uuid;

    // **`noConflict()` - (browser only) to reset global 'uuid' var**
    uuid.noConflict = function() {
      _window.uuid = _previousRoot;
      return uuid;
    };

    _window.uuid = uuid;
  }
})('undefined' !== typeof window ? window : null);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(984)();
}


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(1156)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)(module)))

/***/ }),
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePost = exports.reportComment = exports.reportPost = exports.deletePost = exports.getPostForList = exports.changeNewsfeedFilter = exports.loadMoreComments = exports.loadMore = exports.initialNewsfeedLoad = exports.submitPost = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.updateProps = updateProps;
exports.getHashtags = getHashtags;

var _constants = __webpack_require__(1214);

var constants = _interopRequireWildcard(_constants);

var _http = __webpack_require__(118);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

var _metaDataActions = __webpack_require__(1113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

function updateProps(payload) {
  return { type: constants.UPDATE_NEWSFEED_PROP, payload: payload };
}

var submitPost = exports.submitPost = function submitPost() {
  return function (dispatch, getState) {
    var newsfeedReducer = getState().newsfeed.toJS();
    var locations = getState().user.get('mrLocations');
    var isSingleLoc = _ramda2.default.propEq('length', 1, locations);
    var payload = {
      locations: newsfeedReducer.selectedLocations,
      message: newsfeedReducer.postMessage,
      category: newsfeedReducer.selectedSubCategory,
      template: 'general',
      sendAsCorporate: newsfeedReducer.corporateLocSelected,
      hashtags: _ramda2.default.prepend(newsfeedReducer.subCategoryHash, _ramda2.default.propOr([], 'selectedHashtags', newsfeedReducer))
    };
    if (!isNilOrEmpty(newsfeedReducer.selectedFiles)) payload.files = newsfeedReducer.selectedFiles;

    /* Track Post  */
    dispatch({
      type: 'TRACK_EVENT',
      payload: {
        name: '[newsfeed] new post',
        values: _extends({
          category: payload.template
        }, _extends({}, !isSingleLoc && { selectedLocations: payload.locations.length }))
      }
    });

    dispatch({ type: constants.SUBMIT_POST });
    return (0, _http.post)('/proxy/newsfeed/post', payload).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.error) return dispatch({ type: constants.SUBMIT_POST_FAILED });
      dispatch((0, _metaDataActions.getMetadata)());
      return dispatch({ type: constants.POST_SUBMITTED, payload: _extends({}, response, { isSingleLoc: isSingleLoc }) });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.SUBMIT_POST_FAILED });
    });
  };
};

var getNewsfeedApiCall = function getNewsfeedApiCall(query, dispatch, successConstant) {
  dispatch({ type: constants.GET_NEWSFEED_STARTED });
  return (0, _http.get)('/proxy/newsfeed?' + _queryString2.default.stringify(query)).then(_checkStatus2.default).then(function (res) {
    return res.json();
  }).then(function (response) {
    if (response.error) return dispatch({ type: constants.GET_NEWSFEED_FAILED, payload: response });
    return dispatch({ type: successConstant, payload: response });
  }).catch(function (err) {
    console.log(err);
    dispatch({ type: constants.GET_NEWSFEED_FAILED });
  });
};

var initialNewsfeedLoad = exports.initialNewsfeedLoad = function initialNewsfeedLoad() {
  return function (dispatch) {
    return getNewsfeedApiCall({}, dispatch, constants.GOT_INITIAL_LOAD_NEWSFEED);
  };
};

var loadMore = exports.loadMore = function loadMore() {
  return function (dispatch, getState) {
    var newsfeedReducer = getState().newsfeed.toJS();
    var lastPostId = newsfeedReducer.lastPostId;
    var filter = _ramda2.default.pathOr('', ['filter', 'value'], newsfeedReducer);
    var filterType = newsfeedReducer.filterType;
    var numOfLoadedPosts = _ramda2.default.pathOr(0, ['newsfeed', 'length'], newsfeedReducer);
    var query = _ramda2.default.merge({
      lastPostId: lastPostId,
      numOfLoadedPosts: numOfLoadedPosts
    }, filter && filterType ? {
      filter: filter, filterType: filterType
    } : {});
    return getNewsfeedApiCall(query, dispatch, constants.LOADED_MORE_NEWSFEED);
  };
};

var loadMoreComments = exports.loadMoreComments = function loadMoreComments(postId, displayType) {
  return function (dispatch, getState) {
    var newsfeedReducer = getState().newsfeed.toJS();
    var publicPost = getState().publicPost.toJS();
    var query = {
      lastCommentId: displayType === 'internalPostPage' ? _ramda2.default.prop('_id', _ramda2.default.last(publicPost.comments)) : _ramda2.default.prop('_id', _ramda2.default.last(_ramda2.default.path([0, 'body', 'comments'], newsfeedReducer.newsfeed.filter(function (obj) {
        return obj.postId === postId;
      }))))
    };
    dispatch({ type: constants.LOAD_MORE_COMMENTS_STARTED });
    return (0, _http.get)('/proxy/newsfeed/' + postId + '?' + _queryString2.default.stringify(query)).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.error) return dispatch({ type: constants.LOAD_MORE_COMMENTS_FAILED, payload: response });
      return dispatch({ type: constants.LOADED_MORE_COMMENTS, payload: { comments: response, postId: postId } });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.LOAD_MORE_COMMENTS_FAILED });
    });
  };
};

var changeNewsfeedFilter = exports.changeNewsfeedFilter = function changeNewsfeedFilter(selectedfilter, selectedfilterType) {
  return function (dispatch, getState) {
    var newsfeedReducer = getState().newsfeed.toJS();
    var filterInReducer = _ramda2.default.pathOr('', ['filter', 'value'], newsfeedReducer);
    var filterTypeInReducer = newsfeedReducer.filterType;
    var filter = _ramda2.default.propOr('', 'value', selectedfilter);
    var filterType = selectedfilterType;
    if (filter === filterInReducer && filterType === filterTypeInReducer) return;
    var query = filter && filterType ? {
      filter: filter, filterType: filterType
    } : {};
    dispatch(updateProps(_ramda2.default.merge({
      filterType: selectedfilterType,
      filter: selectedfilter,
      newsfeed: [],
      lastPostId: ''
    }, filterType === 'hashtag' ? { selectedLeftNav: '' } : {})));
    return getNewsfeedApiCall(query, dispatch, constants.GOT_INITIAL_LOAD_NEWSFEED);
  };
};

function getHashtags() {
  return function (dispatch) {
    dispatch({ type: constants.GET_HASHTAGS_STARTED });
    return (0, _http.get)('/proxy/newsfeed/hashtags').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.error) return dispatch({ type: constants.GET_HASHTAGS_FAILED, payload: response });
      return dispatch({ type: constants.GOT_HASHTAGS, payload: response });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.GET_HASHTAGS_FAILED });
    });
  };
}

var getPostForList = exports.getPostForList = function getPostForList(postId) {
  return function (dispatch, getState) {
    var userId = getState().user.get('id') || undefined;
    if (!postId) return dispatch({ type: constants.GET_SINGLE_POST_FAILED });
    dispatch({ type: constants.GET_SINGLE_POST_STARTING, payload: { postId: postId } });
    return (0, _http.get)('/proxy/post/' + postId).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.error) return dispatch({ type: constants.GET_SINGLE_POST_FAILED, payload: { postId: postId } });
      return dispatch({ type: constants.GOT_SINGLE_POST, payload: { body: _ramda2.default.merge(response, { didUserLike: _ramda2.default.contains(userId, response.userIdsOfLikes || []) }), postId: postId } });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.GET_SINGLE_POST_FAILED, payload: { postId: postId } });
    });
  };
};

var deletePost = exports.deletePost = function deletePost(postId, locations) {
  return function (dispatch, getState) {
    var newsfeed = getState().newsfeed.toJS().newsfeed;
    dispatch({ type: constants.DELETE_POST_STARTED });
    return (0, _http.del)('/proxy/newsfeed/post/' + postId, { locations: locations }).then(_checkStatus2.default).then(function (response) {
      if (response.error) return dispatch({ type: constants.DELETE_POST_FAILED, payload: response });
      return dispatch({ type: constants.DELETED_POST, payload: newsfeed.filter(function (feed) {
          return feed.postId !== postId;
        }) });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.DELETE_POST_FAILED });
    });
  };
};

var reportPost = exports.reportPost = function reportPost(postId) {
  return function (dispatch) {
    dispatch({ type: constants.REPORT_POST_STARTED });
    return (0, _http.put)('proxy/newsfeed/reportPost/' + postId).then(_checkStatus2.default).then(function (response) {
      if (response.error) return dispatch({ type: constants.REPORT_POST_FAILED, payload: { postId: postId } });
      return dispatch({ type: constants.REPORTED_POST, payload: { postId: postId } });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.REPORT_POST_FAILED, payload: { postId: postId } });
    });
  };
};

var reportComment = exports.reportComment = function reportComment(postId, commentId) {
  return function (dispatch) {
    dispatch({ type: constants.REPORT_COMMENT_STARTED });
    return (0, _http.put)('proxy/newsfeed/reportComment/' + postId + '/' + commentId).then(_checkStatus2.default).then(function (response) {
      if (response.error) return dispatch({ type: constants.REPORT_COMMENT_FAILED, payload: { postId: postId } });
      return dispatch({ type: constants.REPORTED_COMMENT, payload: { postId: postId, commentId: commentId } });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.REPORT_COMMENT_FAILED, payload: { postId: postId } });
    });
  };
};

// updateType: LIKE - UNLIKE - COMMENT - DELETECOMMENT - EDIT
// updater = { field: value }
var updatePost = exports.updatePost = function updatePost(postId, updateType, updater) {
  return function (dispatch) {
    dispatch({ type: 'TRACK_EVENT', payload: { name: '[newsfeed] ' + updateType.toLowerCase() + ' post' } });
    // REASON for having START_UPDATING_A_POST && temporaryUuid: make the experience seems faster to user
    var temporaryUuid = _nodeUuid2.default.v1();
    dispatch({ type: constants.START_UPDATING_A_POST, payload: { postId: postId, updateType: updateType, updater: updater, temporaryUuid: temporaryUuid } });
    return fetch('/proxy/newsfeed/post/' + postId, {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ updateType: updateType, updater: updater })
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.error) return dispatch({ type: constants.UPDATE_POST_FAILED, payload: { postId: postId, temporaryUuid: temporaryUuid } });
      dispatch({ type: constants.UPDATED_POST, payload: { postId: postId, updateType: updateType, updater: updater, response: response, temporaryUuid: temporaryUuid } }).then(function () {
        return dispatch((0, _metaDataActions.getMetadata)());
      });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.UPDATE_POST_FAILED, payload: { postId: postId } });
    });
  };
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = createSinglePlayer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props2 = __webpack_require__(733);

var _utils = __webpack_require__(145);

var _Player = __webpack_require__(980);

var _Player2 = _interopRequireDefault(_Player);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SUPPORTED_PROPS = Object.keys(_props2.propTypes);

function createSinglePlayer(activePlayer) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    _inherits(SinglePlayer, _Component);

    function SinglePlayer() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, SinglePlayer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SinglePlayer.__proto__ || Object.getPrototypeOf(SinglePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.getDuration = function () {
        if (!_this.player) return null;
        return _this.player.getDuration();
      }, _this.getCurrentTime = function () {
        if (!_this.player) return null;
        return _this.player.getCurrentTime();
      }, _this.getSecondsLoaded = function () {
        if (!_this.player) return null;
        return _this.player.getSecondsLoaded();
      }, _this.getInternalPlayer = function () {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';

        if (!_this.player) return null;
        return _this.player.getInternalPlayer(key);
      }, _this.seekTo = function (fraction) {
        if (!_this.player) return null;
        _this.player.seekTo(fraction);
      }, _this.ref = function (player) {
        _this.player = player;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SinglePlayer, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return !(0, _utils.isEqual)(this.props, nextProps);
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps) {
        this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
      }
    }, {
      key: 'render',
      value: function render() {
        var _config$file = this.config.file,
            forceVideo = _config$file.forceVideo,
            forceAudio = _config$file.forceAudio,
            forceHLS = _config$file.forceHLS,
            forceDASH = _config$file.forceDASH;

        var skipCanPlay = forceVideo || forceAudio || forceHLS || forceDASH;
        if (!activePlayer.canPlay(this.props.url) && !skipCanPlay) {
          return null;
        }
        var _props = this.props,
            style = _props.style,
            width = _props.width,
            height = _props.height,
            Wrapper = _props.wrapper;

        var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
        return _react2['default'].createElement(
          Wrapper,
          _extends({ style: _extends({}, style, { width: width, height: height }) }, otherProps),
          _react2['default'].createElement(_Player2['default'], _extends({}, this.props, {
            ref: this.ref,
            activePlayer: activePlayer,
            config: this.config
          }))
        );
      }
    }]);

    return SinglePlayer;
  }(_react.Component), _class.displayName = activePlayer.displayName + 'Player', _class.propTypes = _props2.propTypes, _class.defaultProps = _props2.defaultProps, _class.canPlay = activePlayer.canPlay, _temp2;
}

/***/ }),
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "31d482aeaac8657a877c23b5ac53465c.svg";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _lock = __webpack_require__(578);

var _lock2 = _interopRequireDefault(_lock);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  heavText: {
    fontWeight: 'bold'
  }
  /*
   * componentType is an override of the class detection, currently
   * happens on the Partner Finder listing.
   *
   * skipClick is relevant for matches that apply via the reducer,
   * not sending it when there is a match at the same time it will
   * efectively override it's settings.
   *
  */
};var WallWrapper = function WallWrapper(_ref) {
  var _ref$amazonOrange = _ref.amazonOrange,
      amazonOrange = _ref$amazonOrange === undefined ? false : _ref$amazonOrange,
      _ref$blocker = _ref.blocker,
      blocker = _ref$blocker === undefined ? false : _ref$blocker,
      propsChildren = _ref.children,
      css = _ref.classes,
      componentType = _ref.componentType,
      _ref$hideOnSkip = _ref.hideOnSkip,
      hideOnSkip = _ref$hideOnSkip === undefined ? false : _ref$hideOnSkip,
      _ref$lockIcon = _ref.lockIcon,
      lockIcon = _ref$lockIcon === undefined ? false : _ref$lockIcon,
      openSlug = _ref.openSlug,
      plan = _ref.plan,
      _ref$skipClick = _ref.skipClick,
      skipClick = _ref$skipClick === undefined ? false : _ref$skipClick,
      _ref$skipBack = _ref.skipBack,
      skipBack = _ref$skipBack === undefined ? false : _ref$skipBack,
      _ref$slug = _ref.slug,
      slug = _ref$slug === undefined ? 'upgrade-general' : _ref$slug,
      _ref$upgradeStyle = _ref.upgradeStyle,
      upgradeStyle = _ref$upgradeStyle === undefined ? {} : _ref$upgradeStyle;

  var shouldAction = Boolean(plan === 'basic' || plan === 'free');
  if (!shouldAction) {
    if (hideOnSkip) return _react2.default.createElement('span', null);
    return propsChildren;
  }
  var childType = componentType || (0, _ramda.path)(['type', 'muiName'], propsChildren) || (0, _ramda.path)(['type', 'name'], propsChildren);
  var children = function () {
    return _react2.default.Children.map(propsChildren, function (child) {
      var props = child.props;

      var disabledLabelColor = 'rgba(0, 0, 0, 0.5)';
      var fontColor = props.disabled ? disabledLabelColor : 'black';
      return _react2.default.cloneElement(child, _extends({}, blocker ? {
        onClick: undefined,
        onTouchTap: undefined
      } : {}, lockIcon && /(.*)Button/.test(childType) ? {
        icon: _react2.default.createElement(_lock2.default, { style: { fill: amazonOrange ? fontColor : '#FFD700' } })
      } : {}, !lockIcon && (0, _ramda.path)(['icon', 'props', 'style', 'color'], props) ? {
        icon: _extends({}, props.icon, {
          props: _extends({}, props.icon.props, {
            style: _extends({}, (0, _ramda.pathOr)({}, ['props', 'style'], props.icon), { color: fontColor })
          })
        })
      } : {}, Object.keys(upgradeStyle).length > 0 ? { style: upgradeStyle } : {}, amazonOrange ? function () {
        var backgroundColor = props.disabled ? 'rgba(255, 193, 7, 0.85)' : '#ffc107';
        var backgroundColorMenuItem = 'rgba(255, 193, 7, 0.5)';
        var labelStyle = _extends({}, props.labelStyle || {}, { fontWeight: 'bold' });
        if (/RaisedButton(.*)/.test(childType)) {
          return {
            backgroundColor: backgroundColor,
            disabledBackgroundColor: backgroundColor,
            labelColor: 'black',
            disabledLabelColor: disabledLabelColor,
            primary: undefined,
            secondary: undefined,
            labelStyle: labelStyle
          };
        }
        if (/(.*)Button/.test(childType)) {
          return {
            backgroundColor: backgroundColor,
            primary: undefined,
            secondary: undefined,
            labelStyle: _extends({}, labelStyle, {
              color: fontColor
            }),
            style: (0, _ramda.omit)(['color'], props.style) // some instances use the root color
          };
        }
        if (childType === 'MenuItem') {
          return {
            style: _extends({}, (0, _ramda.omit)(['backgroundColor'], props.style), { backgroundColor: backgroundColorMenuItem })
          };
        }
        if (typeof childType === 'undefined' && propsChildren.type === 'div') {
          return {
            style: _extends({}, (0, _ramda.omit)(['backgroundColor'], props.style), { backgroundColor: backgroundColorMenuItem })
          };
        }
        return {};
      }() : {}));
    });
  }();
  var handleClick = function handleClick(e) {
    if (blocker) e.preventDefault();
    openSlug({ slug: slug, blocker: blocker, skipBack: skipBack });
  };
  if (skipClick) return _react2.default.createElement(
    'div',
    null,
    children
  );
  return _react2.default.createElement(
    'div',
    { onClick: handleClick },
    children
  );
};

exports.default = (0, _reactRedux.connect)(function (_ref2) {
  var user = _ref2.user;
  return {
    plan: user.getIn(['company', 'plan']) || 'basic'
  };
}, {
  openSlug: function openSlug(payload) {
    return {
      type: '[wall] openSlug',
      payload: payload
    };
  }
})((0, _reactJss2.default)(styles)(WallWrapper));

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = '[workspace] ';

var CHANGE_SELECTION = exports.CHANGE_SELECTION = prefix + 'CHANGE_SELECTION';
// connections
var CONNECTIONS_FETCH = exports.CONNECTIONS_FETCH = prefix + 'CONNECTIONS_FETCH';
var CONNECTIONS_SELECT = exports.CONNECTIONS_SELECT = prefix + 'CONNECTIONS_SELECT';
var CONNECTIONS_ARCHIVE = exports.CONNECTIONS_ARCHIVE = prefix + 'CONNECTIONS_ARCHIVE';

// channels
var CHANNELS_FETCH = exports.CHANNELS_FETCH = prefix + 'CHANNELS_FETCH';
var CHANNELS_SELECT = exports.CHANNELS_SELECT = prefix + 'CHANNELS_SELECT';
var CHANNELS_SELECT_SAVE = exports.CHANNELS_SELECT_SAVE = prefix + 'CHANNELS_SELECT_SAVE';
var CHANNELS_RESET = exports.CHANNELS_RESET = prefix + 'CHANNELS_RESET';
var CHANNELS_ARCHIVE = exports.CHANNELS_ARCHIVE = prefix + 'CHANNELS_ARCHIVE';

// conversations
var CONVERSATIONS_FETCH = exports.CONVERSATIONS_FETCH = prefix + 'CONVERSATIONS_FETCH';
var CONVERSATIONS_RESET = exports.CONVERSATIONS_RESET = prefix + 'CONVERSATIONS_RESET';
var CONVERSATIONS_READ = exports.CONVERSATIONS_READ = prefix + 'CONVERSATIONS_READ';
var CONVERSATIONS_READ_WITH_PARAMS = exports.CONVERSATIONS_READ_WITH_PARAMS = prefix + 'CONVERSATIONS_READ_WITH_PARAMS';

// messages
var MESSAGE_CREATE = exports.MESSAGE_CREATE = prefix + 'MESSAGE_CREATE';
var MESSAGE_DELETE = exports.MESSAGE_DELETE = prefix + 'MESSAGE_DELETE';
var MESSAGE_DISABLE = exports.MESSAGE_DISABLE = prefix + 'MESSAGE_DISABLE';
var MESSAGE_ADD_FILES_TO_CONTRACT = exports.MESSAGE_ADD_FILES_TO_CONTRACT = prefix + 'MESSAGE_ADD_FILES_TO_CONTRACT';

// contract
var CONTRACT_SELECT = exports.CONTRACT_SELECT = prefix + 'CONTRACT_SELECT';

// unread headers
var STATUS_MESSAGES = exports.STATUS_MESSAGES = '$[topbar] STATUS_MESSAGES';
var STATUS_MESSAGES_REMOVE_CONNECTION = exports.STATUS_MESSAGES_REMOVE_CONNECTION = '$[topbar] REMOVE_CONNECTION';
var STATUS_CONNECTIONS_MARK_READ = exports.STATUS_CONNECTIONS_MARK_READ = '[topbar] MARK_ACCEPTED_AS_READ';

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeControlledTextField = function (_Component) {
  _inherits(TypeControlledTextField, _Component);

  function TypeControlledTextField(props) {
    _classCallCheck(this, TypeControlledTextField);

    var _this = _possibleConstructorReturn(this, (TypeControlledTextField.__proto__ || Object.getPrototypeOf(TypeControlledTextField)).call(this, props));

    _this._handleErrors = function (errorText, cb) {
      _this.setState({ errorText: errorText }, function () {
        if (cb) return cb();
        if (_this.props.onError) _this.props.onError(errorText);
      });
    };

    _this._handleOnChange = function (e) {
      if (e.target.value && _this.props.controlledType === 'number' && isNaN(e.target.value)) {
        _this._handleErrors('Only ' + _this.props.controlledType + 's allowed', function () {
          return _this.props.onChange({ target: { value: undefined } });
        });
      } else if (_this.props.limitLength && e.target.value && e.target.value.length > _this.props.limitLength) {
        _this._handleErrors('Maximum ' + _this.props.limitLength + ' characters allowed');
      } else {
        _this.props.onChange(e);
        _this._handleErrors('');
      }
    };

    _this._handleOnBlur = function (e) {
      _this.setState({ errorText: '' });
    };

    _this.state = {
      errorText: ''
    };
    return _this;
  }

  _createClass(TypeControlledTextField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          controlledType = _props.controlledType,
          onChange = _props.onChange,
          limitLength = _props.limitLength,
          errorText = _props.errorText,
          value = _props.value,
          id = _props.id,
          extraProps = _objectWithoutProperties(_props, ['controlledType', 'onChange', 'limitLength', 'errorText', 'value', 'id']);

      return _react2.default.createElement(_materialUi.TextField, _extends({
        id: id || 'type-controlled-textfield',
        errorText: errorText || this.state.errorText,
        onChange: this._handleOnChange,
        onBlur: this._handleOnBlur,
        value: value || ''
      }, extraProps));
    }
  }]);

  return TypeControlledTextField;
}(_react.Component);

TypeControlledTextField.propTypes = {
  controlledType: _react.PropTypes.string,
  errorText: _react.PropTypes.string,
  limitLength: _react.PropTypes.number,
  onBlur: _react.PropTypes.func,
  onChange: _react.PropTypes.func,
  onError: _react.PropTypes.func
};

exports.default = TypeControlledTextField;

/***/ }),
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

module.exports = {
    /**
     * True if this is running in Nodejs, will be undefined in a browser.
     * In a browser, browserify won't include this file and the whole module
     * will be resolved an empty object.
     */
    isNode : typeof Buffer !== "undefined",
    /**
     * Create a new nodejs Buffer.
     * @param {Object} data the data to pass to the constructor.
     * @param {String} encoding the encoding to use.
     * @return {Buffer} a new Buffer.
     */
    newBuffer : function(data, encoding){
        return new Buffer(data, encoding);
    },
    /**
     * Find out if an object is a Buffer.
     * @param {Object} b the object to test.
     * @return {Boolean} true if the object is a Buffer, false otherwise.
     */
    isBuffer : function(b){
        return Buffer.isBuffer(b);
    },

    isStream : function (obj) {
        return obj &&
            typeof obj.on === "function" &&
            typeof obj.pause === "function" &&
            typeof obj.resume === "function";
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(8)
var HashBase = __webpack_require__(507)
var Buffer = __webpack_require__(10).Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(24).Buffer
var inherits = __webpack_require__(8)
var HashBase = __webpack_require__(507)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(660)
exports.sha1 = __webpack_require__(661)
exports.sha224 = __webpack_require__(662)
exports.sha256 = __webpack_require__(508)
exports.sha384 = __webpack_require__(663)
exports.sha512 = __webpack_require__(509)


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(669);
exports.Cipher = __webpack_require__(670);
exports.DES = __webpack_require__(671);
exports.CBC = __webpack_require__(672);
exports.EDE = __webpack_require__(673);


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(674)
var deciphers = __webpack_require__(682)
var modes = __webpack_require__(519)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(675),
  CBC: __webpack_require__(676),
  CFB: __webpack_require__(677),
  CFB8: __webpack_require__(678),
  CFB1: __webpack_require__(679),
  OFB: __webpack_require__(680),
  CTR: __webpack_require__(517),
  GCM: __webpack_require__(517)
}

var modes = __webpack_require__(519)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(22);
var randomBytes = __webpack_require__(121);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(54);
hash.common = __webpack_require__(137);
hash.sha = __webpack_require__(698);
hash.ripemd = __webpack_require__(702);
hash.hmac = __webpack_require__(703);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports = {"en-US":{"BillingLink":"Billing","PlanLink":"Billing","Back to Admin":"Back to Admin","Billing":"Billing","Connections":"Connections","Contracting":"Rates & Contracts","Dashboard":"Dashboard","Home":"Home","Find Partners":"PartnerFinder","Log Out":"Log Out","Profile":"Profile","Settings":"Settings","Support":"Support","ConnectCommunicate":"Connect & Communicate","connectionsSplash":{"addConnection":"Add Connection","title":"Connect & Communicate","subtitle":"TourConnect is built on connections. Connect with business partners and get important messages to the right people even when contacts change."},"company":{"amenities":{"title":"Amenities"},"leftNav":{"resend":"RESEND INVITATION","accept":"ACCEPT CONNECTION?","connected":"CONNECTED","unconnected":"CONNECT"},"more":"+ More","less":"- Less"},"integration":{"routeNames":{"authentication":"Credentials","mappings":"Mappings","histories":"Exported Contracts","contracts":"Contracts to Be Exported"},"leftNav":{"addMapping":"Add Mapping"}},"connections":{"resend":{"error":{"message":"There was an error resending this email.","button":"Retry"},"success":{"message":"Invitation Resent.","button":"OK"}},"accepted":{"error":{"message":"There was an error accepting this connection.","button":"Retry"}},"rejected":{"error":{"message":"There was an error rejecting this connection.","button":"Retry"},"undo":{"message":"Connection Rejected","button":"Undo"},"undoError":{"message":"There was an error undoing your last method.","button":"Retry"}},"archive":{"error":{"message":"There was an error removing this connection.","button":"Retry"}},"routeNames":{"invites":"Sent","requests":"Received","connected":"Connected"},"findPartnerDialog":{"title":"Free Access to PartnerFinder until July 2015","dismiss":"dismiss","content":"TourConnect is built on connections. Help us by adding 5 connections with your current partners or industry colleagues and get free access to PartnerFinder until July 2015."},"leftNav":{"addConnection":"+ Add Connections","findPartners":"Find Partners","download":"Download All Contacts"},"listItem":{"editTag":"Edit Tags","addTag":"Add Tags","resendInvite":"Resend Invite","ignore":"Ignore Connection","removeConnection":"Remove Connection","accept":"Accept Connection","addConnection":"Add Connection"}},"error":{"general":"There was a problem processing your request. If this problem persists, please call us at +1 (214) 446-0721."},"signin":{"incorrectPassword":"Password you entered is not correct.","userNotFound":"We did not find any account associated with this email.","verify":"Please confirm your email address before logging in for the first time.","invalidEmail":"Please provide a valid email.","invalidPassword":"Please provide a valid password.","bothInvalid":"Invalid email or password. Please check your email and password, and try again.","deletedUser":"This user has been deleted, please contact the administrator of this account.","disabledUser":"This user has been disabled, please contact the administrator of this account."},"partnerFinder":{"leftNavTitle":"Partner Finder","searchWidget":{"searchFor":"Search For","contractors":"Contractors","suppliers":"Suppliers","country":"Country","destinationsSold":"Destinations Sold","tooltipCountry":"Where the hotel/tour/attraction is located","tooltipDestinationsSold":"Where the contractor is sending travelers to","cityOrRegion":"City/Region","cityHintText":"City/Region","destinationsSoldHintText":"Destinations Sold","searchButtonText":"Search"},"rightContent":{"searchBarText":"Search...","supplierSearchResultsTitle":"Supplier Search Results","contractorSearchResultsTitle":"Buyer Search Results","otherSearchResultsTitle":"Other Search Results","upgradeToPremiumPlan":"Upgrade to the Connected or Unlimited Plan to view company profiles and connect.","selectPremiumPlan":"Select the Connected or Unlimited Plan to view company profiles and connect.","listView":"List View","mapView":"Map View","connect":"Connect","resend":"ReSend","connected":"Connected","tootipAccept":"Accept Connection","tootipReject":"Reject Connection","lastSent":"Last sent ","ignored":"ignored"}},"onboarding":{"submitButton":"Submit Profile","verifyTitle":"Welcome back! Please check your profile.","onBoardingTitle":"Welcome! Let's Create Your Profile","onBoardingSubTitle":"Add a logo and tell us about your company.","companyTypes":"Company Types","countriesServed":"Destinations Sold","propertyTypes":"Property Types","companyLogo":"Company Logo","corporatePhone":"Corporate Phone","optional":"* Optional","logoParagraph":"Your logo is the first thing people see when they want to learn more about your company. We recommend uploading a square image of your logo for the best look.","logoButton":"Choose an Image\nFrom Your Computer","aboutYourCompany":"About Your Company","required":"* All Fields Required","shortDescription":"Short Description","shortDescriptionReminder":"Remember, this is what partners read when they search for your company.","textAreaParagraph":"We'd like to help you connect with new and existing business partners. Use the information below to tell your partners a little bit about you.","marketSegments":"Market Segments","contactInfo":"Contact Information","address":"Corporate Address","phoneInfoParagraph":"You can manage additional contacts in your profile later.","addressOnePlaceholder":"Street Address, P.O.Box, c/o","addressTwoPlaceholder":"Apartment, Suite, Unit Building, etc","city":"City","statePlaceholder":"State, Province, Region","zipPlaceholder":"Zip/Postal Code","country":"Country","website":"Website","contact":"Contact","firstName":"First Name","lastName":"Last Name","email":"Email","phone":"Phone","fax":"Fax","dialogErrorTitle":"SORRY! THERE WAS AN ERROR","dialogErrorMessage":"It looks like there was an error processing your form. Please refresh the page and try again.","dialogRefreshButton":"REFRESH","dialogVerifyAddressTitle":"IS THIS YOUR ADDRESS?","dialogYes":"YES","dialogNo":"NO","dialogSkip":"SKIP","marketSegmentsDesc":"These are the types of travelers you best serve.","destinationsSoldDesc":"These are the countries that you send travelers to.","contactInfoParagraph":"Your contact information makes it easier for global partners to find and recognize you.  Don't worry, your personal contact details will only be shared with the partners you choose to connect with."}}}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(478);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(483)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./main.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./main.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 251 */,
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var rateDraft = '{rates-draft}';
var UPDATE_SAME_AS_CORPORATE_POLICY_NOTES = exports.UPDATE_SAME_AS_CORPORATE_POLICY_NOTES = '{rates-draft} UPDATE_SAME_AS_CORPORATE_POLICY_NOTES';
var REFRESH_STARTED = exports.REFRESH_STARTED = rateDraft + ' REFRESH_STARTED';
var REFRESH_COMPLETION_CHECK = exports.REFRESH_COMPLETION_CHECK = rateDraft + ' REFRESH_COMPLETION_CHECK';
var REFRESH_LEFT_NAV = exports.REFRESH_LEFT_NAV = rateDraft + ' REFRESH_LEFT_NAV';
var REFRESH_POLICIES_NOTES = exports.REFRESH_POLICIES_NOTES = rateDraft + ' REFRESH_POLICIES_NOTES';
var REFRESH_PRODUCT_DETAILS = exports.REFRESH_PRODUCT_DETAILS = rateDraft + ' REFRESH_PRODUCT_DETAILS';
var REFRESH_FINISHED = exports.REFRESH_FINISHED = rateDraft + ' REFRESH_FINISHED';
var REVIEW_MY_RATES_DRAFT = exports.REVIEW_MY_RATES_DRAFT = rateDraft + '_REVIEW_MY_RATES_DRAFT';
var MANAGE_EXTRAS_OFFERS = exports.MANAGE_EXTRAS_OFFERS = rateDraft + ' MANAGE_EXTRAS_OFFERS';
var REMOVE_MASTER_TEMPLATE = exports.REMOVE_MASTER_TEMPLATE = rateDraft + ' REMOVE_MASTER_TEMPLATE';

var ADD_DRAFT_TO_QUEUE = exports.ADD_DRAFT_TO_QUEUE = '{contracting} ADD_DRAFT_TO_QUEUE';
var REMOVE_DRAFT_FROM_QUEUE = exports.REMOVE_DRAFT_FROM_QUEUE = '{contracting} REMOVE_DRAFT_FROM_QUEUE';

var SEND_UPDATES_FROM_QUEUE = exports.SEND_UPDATES_FROM_QUEUE = '{update-queue} SEND_UPDATES_FROM_QUEUE';
var CLEAR_QUEUE_STATE = exports.CLEAR_QUEUE_STATE = '{update-queue} CLEAR STATE';

var REFRESH_TEMPLATE_LIST = exports.REFRESH_TEMPLATE_LIST = '{template-list} REFRESH_TEMPLATE_LIST';

var SEND_TOURWRITER = exports.SEND_TOURWRITER = 'SEND_TOURWRITER';

var REMOVE_SINGLE_FEED_BY_TC_ADMIN = exports.REMOVE_SINGLE_FEED_BY_TC_ADMIN = '{history-feed} REMOVE_SINGLE_FEED_BY_TC_ADMIN';
var GET_NOTES = exports.GET_NOTES = '{history-feed} GET_NOTES';

var FILE_CONTRACT_FOR_REQUEST = exports.FILE_CONTRACT_FOR_REQUEST = '{contract-request} FILE_CONTRACT_FOR_REQUEST';

var REMOVE_CONTRACT_FROM_REQUEST = exports.REMOVE_CONTRACT_FROM_REQUEST = '{contract-request} REMOVE_CONTRACT_FROM_REQUEST';

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteUser = exports.editUser = exports.addUser = exports.approveOrRejectUser = exports.getUsersByFilter = exports.getCompanyAdmin = undefined;
exports.updateUMProps = updateUMProps;

var _constants = __webpack_require__(858);

var constants = _interopRequireWildcard(_constants);

var _http = __webpack_require__(118);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* global fetch */


function updateUMProps(payload) {
  return { type: constants.UPDATE_UM_PROP, payload: payload };
}

var getCompanyAdmin = exports.getCompanyAdmin = function getCompanyAdmin(companyType) {
  return function (dispatch) {
    dispatch({ type: constants.GETTING_COMP_ADMIN });
    return (0, _http.get)('/proxy/userManagement/admin/' + companyType).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: constants.GOT_COMP_ADMIN, payload: response });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.GETTING_COMP_ADMIN_FAILED, payload: err });
    });
  };
};

var getUsersByFilter = exports.getUsersByFilter = function getUsersByFilter(filterBy) {
  return function (dispatch) {
    dispatch({ type: constants.GETTING_USERS_BY_FILTER });
    return (0, _http.get)('/proxy/userManagement/' + filterBy).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: constants.GOT_USERS_BY_FILTER, payload: response });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.GETTING_USERS_BY_FILTER_FAILED, payload: err });
    });
  };
};

var approveOrRejectUser = exports.approveOrRejectUser = function approveOrRejectUser(user, action) {
  return function (dispatch) {
    dispatch({ type: constants.APPROVE_REJECT_USER_STARTED });
    return fetch('/proxy/settings/approveOrRejectUser', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ user: user, action: action })
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.error) return dispatch({ type: constants.APPROVE_REJECT_USER_FAILED, payload: response.error });
      return dispatch({ type: constants.APPROVE_REJECT_USER_DONE, payload: response });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.APPROVE_REJECT_USER_FAILED });
    });
  };
};

var addUser = exports.addUser = function addUser(payload) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var response, json;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              dispatch({ type: constants.ADD_USER_STARTING });
              _context.next = 4;
              return fetch('/proxy/userManagement/addUser', {
                method: 'put',
                credentials: 'same-origin',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
              });

            case 4:
              response = _context.sent;
              _context.next = 7;
              return response.json();

            case 7:
              json = _context.sent;

              if (!(json.error || response.status < 200 || response.status > 300)) {
                _context.next = 10;
                break;
              }

              return _context.abrupt('return', dispatch({ type: constants.ADD_USER_FAILED, payload: json || response }));

            case 10:
              return _context.abrupt('return', dispatch({ type: constants.ADDED_USER, payload: response }));

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](0);
              return _context.abrupt('return', dispatch({ type: constants.ADD_USER_FAILED, payload: _context.t0 }));

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[0, 13]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var editUser = exports.editUser = function editUser(payload) {
  return function (dispatch) {
    dispatch({ type: constants.UPDATE_USER_STARTING });
    return fetch('/proxy/userManagement/editUser', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.error) return dispatch({ type: constants.UPDATE_USER_FAILED, payload: response });
      dispatch({ type: constants.UPDATED_USER, payload: response });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.UPDATE_USER_FAILED, payload: err });
    });
  };
};

var deleteUser = exports.deleteUser = function deleteUser(userId) {
  return function (dispatch) {
    dispatch({ type: constants.DELETE_USER_STARTING });
    return (0, _http.del)('/proxy/userManagement/editUser/' + userId).then(_checkStatus2.default).then(function (response) {
      if (response.error) return dispatch({ type: constants.DELETE_USER_FAILED });
      dispatch({ type: constants.DELETED_USER, payload: userId });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.DELETE_USER_FAILED, payload: err });
    });
  };
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.getQS = getQS;
exports.soFetch = soFetch;

__webpack_require__(1183);

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function getQS(params) {
  if (!params || typeof params === 'object' && !Array.isArray(params) && !Object.keys(params).length) {
    throw new TypeError('Params Should be an object');
  }

  return Object.keys(params).reduce(function (string, key, index, outerKeys) {
    if (Array.isArray(params[key]) && params[key].length || !Array.isArray(params[key]) && params[key] !== undefined) {
      if (params[key] && Array.isArray(params[key])) {
        return string + (string === '?' ? '' : '&') + params[key].reduce(function (innerString, value, index, innerKeys) {
          return innerString + encodeURIComponent(key) + '[]=' + encodeURIComponent(value) + (index !== innerKeys.length - 1 ? '&' : '');
        }, '');
      } else if (params[key] && typeof params[key] === 'object' && Object.keys(params[key]).length) {
        return string + (string === '?' ? '' : '&') + Object.keys(params[key]).reduce(function (innerString, innerKey, index, innerKeys) {
          return innerString + encodeURIComponent(key) + '[' + encodeURIComponent(innerKey) + ']=' + encodeURIComponent(params[key][innerKey]) + (index !== innerKeys.length - 1 ? '&' : '');
        }, '');
      } else {
        return string + (string === '?' ? '' : '&') + encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
      }
    }
    return string;
  }, '?');
}

;

function soFetch(url, options) {
  var body = options.body;
  var method = options.method;
  var actionType = options.actionType;
  var responseBinding = options.responseBinding;
  var qs = options.qs;
  var headers = options.headers;
  var credentials = options.credentials;

  return function (dispatch) {
    var optionsForFetch = { method: method || 'get' };
    if (credentials === undefined) optionsForFetch.credentials = 'same-origin';
    if (credentials) optionsForFetch.credentials = credentials;
    if (body) optionsForFetch.body = JSON.stringify(body);
    if (method === 'put' || method === 'post') {
      optionsForFetch.headers = headers || { 'Accept': 'application/json', 'Content-Type': 'application/json' };
    }
    return fetch(url + (qs ? getQS(qs) : ''), optionsForFetch).then(checkStatus).then(function (res) {
      return res.json();
    }).then(function (res) {
      var action = { type: actionType };
      action[responseBinding || 'payload'] = res;
      return dispatch(action);
    });
  };
}

;

/***/ }),
/* 255 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _AddItemCard = __webpack_require__(1245);

var _AddItemCard2 = _interopRequireDefault(_AddItemCard);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddItemCardConnected = function AddItemCardConnected(_ref) {
  var onClick = _ref.onClick,
      text = _ref.text,
      editable = _ref.editable,
      hide = _ref.hide,
      readOnly = _ref.readOnly;

  if (hide) return _react2.default.createElement('div', null);
  if (!editable) return _react2.default.createElement(
    'div',
    { style: { color: 'rgba(0, 0, 0, 0.34)' } },
    'NA'
  );
  var color = readOnly ? '#9e9e9e' : '#00bcd4';
  return _react2.default.createElement(_AddItemCard2.default, {
    onClick: onClick,
    text: text,
    color: color
  });
};

AddItemCardConnected.propTypes = {
  onClick: _react.PropTypes.func,
  text: _react.PropTypes.string,
  editable: _react.PropTypes.bool,
  hide: _react.PropTypes.bool,
  readOnly: _react.PropTypes.bool
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var user = _ref2.user,
      contracting = _ref2.contracting;

  if (user.getIn(['user', 'email']) && user.getIn(['user', 'email']).indexOf('dl+') > -1) return { readOnly: false };
  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  var accessForLoc = leftNav.locationId ? _ramda2.default.find(_ramda2.default.propEq('locId', leftNav.locationId), user.get('locAccess')) : {};
  var companyType = user.getIn(['user', 'type']);
  var readOnly = companyType === 'Supplier' && (accessForLoc || {}).contracting && !_ramda2.default.contains('write', (accessForLoc || {}).contracting);
  return { readOnly: readOnly };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddItemCardConnected);

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StepperActions = function StepperActions(_ref) {
  var backButtonFunc = _ref.backButtonFunc,
      showBackButton = _ref.showBackButton,
      style = _ref.style,
      rightButtons = _ref.rightButtons;

  var backButton = _react2.default.createElement(_materialUi.FlatButton, {
    label: 'back',
    secondary: true,
    hoverColor: 'none',
    labelStyle: { fontWeight: '600', left: '-20px' },
    onTouchTap: backButtonFunc
  });
  var leftButton = showBackButton ? backButton : undefined;
  var outerContainerStyle = _extends({}, { width: '100%', flexDirection: 'row-reverse' }, style);
  return _react2.default.createElement(
    'div',
    { style: outerContainerStyle, className: 'flex-center' },
    _react2.default.createElement(
      'div',
      { style: { float: 'right' } },
      rightButtons
    ),
    _react2.default.createElement(
      'div',
      { style: { float: 'left' } },
      leftButton
    )
  );
};

StepperActions.propTypes = {
  backButtonFunc: _react.PropTypes.func,
  showBackButton: _react.PropTypes.bool,
  rightButtons: _react.PropTypes.node,
  style: _react.PropTypes.object
};

exports.default = StepperActions;

/***/ }),
/* 258 */,
/* 259 */,
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var invariant = __webpack_require__(56);
var defaultClickRejectionStrategy = __webpack_require__(261);

var alreadyInjected = false;

module.exports = function injectTapEventPlugin (strategyOverrides) {
  strategyOverrides = strategyOverrides || {}
  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;

  if (false) {
    invariant(
      !alreadyInjected,
      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
It is recommended to call injectTapEventPlugin() just before you call \
ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
itself, please contact the maintainer as it shouldn\'t be called in library code and \
should be injected by the application.'
    )
  }

  alreadyInjected = true;

  __webpack_require__(500).injection.injectEventPluginsByName({
    'TapEventPlugin':       __webpack_require__(262)(shouldRejectClick)
  });
};


/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = function(lastTouchEvent, clickTimestamp) {
  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
    return true;
  }
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule TapEventPlugin
 * @typechecks static-only
 */



var EventConstants = __webpack_require__(263);
var EventPluginUtils = __webpack_require__(557);
var EventPropagators = __webpack_require__(499);
var SyntheticUIEvent = __webpack_require__(502);
var TouchEventUtils = __webpack_require__(264);
var ViewportMetrics = __webpack_require__(573);

var keyOf = __webpack_require__(265);
var topLevelTypes = EventConstants.topLevelTypes;

var isStartish = EventPluginUtils.isStartish;
var isEndish = EventPluginUtils.isEndish;

var isTouch = function(topLevelType) {
  var touchTypes = [
    'topTouchCancel',
    'topTouchEnd',
    'topTouchStart',
    'topTouchMove'
  ];
  return touchTypes.indexOf(topLevelType) >= 0;
}

/**
 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
 * in order to still be considered a 'tap' event.
 */
var tapMoveThreshold = 10;
var ignoreMouseThreshold = 750;
var startCoords = {x: null, y: null};
var lastTouchEvent = null;

var Axis = {
  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
};

function getAxisCoordOfEvent(axis, nativeEvent) {
  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
  if (singleTouch) {
    return singleTouch[axis.page];
  }
  return axis.page in nativeEvent ?
    nativeEvent[axis.page] :
    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
}

function getDistance(coords, nativeEvent) {
  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
  return Math.pow(
    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
    0.5
  );
}

var touchEvents = [
  'topTouchStart',
  'topTouchCancel',
  'topTouchEnd',
  'topTouchMove',
];

var dependencies = [
  'topMouseDown',
  'topMouseMove',
  'topMouseUp',
].concat(touchEvents);

var eventTypes = {
  touchTap: {
    phasedRegistrationNames: {
      bubbled: keyOf({onTouchTap: null}),
      captured: keyOf({onTouchTapCapture: null})
    },
    dependencies: dependencies
  }
};

var now = (function() {
  if (Date.now) {
    return Date.now;
  } else {
    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
    return function () {
      return +new Date;
    }
  }
})();

function createTapEventPlugin(shouldRejectClick) {
  return {

    tapMoveThreshold: tapMoveThreshold,

    ignoreMouseThreshold: ignoreMouseThreshold,

    eventTypes: eventTypes,

    /**
     * @param {string} topLevelType Record from `EventConstants`.
     * @param {DOMEventTarget} targetInst The listening component root node.
     * @param {object} nativeEvent Native browser event.
     * @return {*} An accumulation of synthetic events.
     * @see {EventPluginHub.extractEvents}
     */
    extractEvents: function(
      topLevelType,
      targetInst,
      nativeEvent,
      nativeEventTarget
    ) {

      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
        return null;
      }

      if (isTouch(topLevelType)) {
        lastTouchEvent = now();
      } else {
        if (shouldRejectClick(lastTouchEvent, now())) {
          return null;
        }
      }

      var event = null;
      var distance = getDistance(startCoords, nativeEvent);
      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
        event = SyntheticUIEvent.getPooled(
          eventTypes.touchTap,
          targetInst,
          nativeEvent,
          nativeEventTarget
        );
      }
      if (isStartish(topLevelType)) {
        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
      } else if (isEndish(topLevelType)) {
        startCoords.x = 0;
        startCoords.y = 0;
      }
      EventPropagators.accumulateTwoPhaseDispatches(event);
      return event;
    }

  };
}

module.exports = createTapEventPlugin;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Types of raw signals from the browser caught at the top level.
 */
var topLevelTypes = {
  topAbort: null,
  topAnimationEnd: null,
  topAnimationIteration: null,
  topAnimationStart: null,
  topBlur: null,
  topCanPlay: null,
  topCanPlayThrough: null,
  topChange: null,
  topClick: null,
  topCompositionEnd: null,
  topCompositionStart: null,
  topCompositionUpdate: null,
  topContextMenu: null,
  topCopy: null,
  topCut: null,
  topDoubleClick: null,
  topDrag: null,
  topDragEnd: null,
  topDragEnter: null,
  topDragExit: null,
  topDragLeave: null,
  topDragOver: null,
  topDragStart: null,
  topDrop: null,
  topDurationChange: null,
  topEmptied: null,
  topEncrypted: null,
  topEnded: null,
  topError: null,
  topFocus: null,
  topInput: null,
  topInvalid: null,
  topKeyDown: null,
  topKeyPress: null,
  topKeyUp: null,
  topLoad: null,
  topLoadedData: null,
  topLoadedMetadata: null,
  topLoadStart: null,
  topMouseDown: null,
  topMouseMove: null,
  topMouseOut: null,
  topMouseOver: null,
  topMouseUp: null,
  topPaste: null,
  topPause: null,
  topPlay: null,
  topPlaying: null,
  topProgress: null,
  topRateChange: null,
  topReset: null,
  topScroll: null,
  topSeeked: null,
  topSeeking: null,
  topSelectionChange: null,
  topStalled: null,
  topSubmit: null,
  topSuspend: null,
  topTextInput: null,
  topTimeUpdate: null,
  topTouchCancel: null,
  topTouchEnd: null,
  topTouchMove: null,
  topTouchStart: null,
  topTransitionEnd: null,
  topVolumeChange: null,
  topWaiting: null,
  topWheel: null
};

var EventConstants = {
  topLevelTypes: topLevelTypes
};

module.exports = EventConstants;

/***/ }),
/* 264 */
/***/ (function(module, exports) {

/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule TouchEventUtils
 */

var TouchEventUtils = {
  /**
   * Utility function for common case of extracting out the primary touch from a
   * touch event.
   * - `touchEnd` events usually do not have the `touches` property.
   *   http://stackoverflow.com/questions/3666929/
   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
   *
   * @param {Event} nativeEvent Native event that may or may not be a touch.
   * @return {TouchesObject?} an object with pageX and pageY or null.
   */
  extractSingleTouch: function(nativeEvent) {
    var touches = nativeEvent.touches;
    var changedTouches = nativeEvent.changedTouches;
    var hasTouches = touches && touches.length > 0;
    var hasChangedTouches = changedTouches && changedTouches.length > 0;

    return !hasTouches && hasChangedTouches ? changedTouches[0] :
           hasTouches ? touches[0] :
           nativeEvent;
  }
};

module.exports = TouchEventUtils;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Allows extraction of a minified key. Let's the build system minify keys
 * without losing the ability to dynamically use key strings as values
 * themselves. Pass in an object with a single key/val pair and it will return
 * you the string key of that single record. Suppose you want to grab the
 * value for a key 'className' inside of an object. Key/val minification may
 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
 * reuse those resolutions.
 */
var keyOf = function keyOf(oneKeyObj) {
  var key;
  for (key in oneKeyObj) {
    if (!oneKeyObj.hasOwnProperty(key)) {
      continue;
    }
    return key;
  }
  return null;
};

module.exports = keyOf;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var always = __webpack_require__(49);


/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.T
 * @example
 *
 *      R.F(); //=> false
 */
module.exports = always(false);


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var always = __webpack_require__(49);


/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.F
 * @example
 *
 *      R.T(); //=> true
 */
module.exports = always(true);


/***/ }),
/* 268 */
/***/ (function(module, exports) {

/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */
module.exports = {'@@functional/placeholder': true};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry1 = __webpack_require__(4);
var curryN = __webpack_require__(13);


/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      var mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */
module.exports = _curry1(function addIndex(fn) {
  return curryN(fn.length, function() {
    var idx = 0;
    var origFn = arguments[0];
    var list = arguments[arguments.length - 1];
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = function() {
      var result = origFn.apply(this, _concat(arguments, [idx, list]));
      idx += 1;
      return result;
    };
    return fn.apply(this, args);
  });
});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xall = __webpack_require__(271);


/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      var equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */
module.exports = _curry2(_dispatchable(['all'], _xall, function all(fn, list) {
  var idx = 0;
  while (idx < list.length) {
    if (!fn(list[idx])) {
      return false;
    }
    idx += 1;
  }
  return true;
}));


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduced = __webpack_require__(42);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XAll(f, xf) {
    this.xf = xf;
    this.f = f;
    this.all = true;
  }
  XAll.prototype['@@transducer/init'] = _xfBase.init;
  XAll.prototype['@@transducer/result'] = function(result) {
    if (this.all) {
      result = this.xf['@@transducer/step'](result, true);
    }
    return this.xf['@@transducer/result'](result);
  };
  XAll.prototype['@@transducer/step'] = function(result, input) {
    if (!this.f(input)) {
      this.all = false;
      result = _reduced(this.xf['@@transducer/step'](result, false));
    }
    return result;
  };

  return _curry2(function _xall(f, xf) { return new XAll(f, xf); });
}());


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var curryN = __webpack_require__(13);
var max = __webpack_require__(50);
var pluck = __webpack_require__(57);
var reduce = __webpack_require__(33);


/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      var isQueen = R.propEq('rank', 'Q');
 *      var isSpade = R.propEq('suit', '♠︎');
 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */
module.exports = _curry1(function allPass(preds) {
  return curryN(reduce(max, 0, pluck('length', preds)), function() {
    var idx = 0;
    var len = preds.length;
    while (idx < len) {
      if (!preds[idx].apply(this, arguments)) {
        return false;
      }
      idx += 1;
    }
    return true;
  });
});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap.prototype['@@transducer/init'] = _xfBase.init;
  XMap.prototype['@@transducer/result'] = _xfBase.result;
  XMap.prototype['@@transducer/step'] = function(result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };

  return _curry2(function _xmap(f, xf) { return new XMap(f, xf); });
}());


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var curryN = __webpack_require__(13);
var max = __webpack_require__(50);
var pluck = __webpack_require__(57);
var reduce = __webpack_require__(33);


/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      var isClub = R.propEq('suit', '♣');
 *      var isSpade = R.propEq('suit', '♠');
 *      var isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */
module.exports = _curry1(function anyPass(preds) {
  return curryN(reduce(max, 0, pluck('length', preds)), function() {
    var idx = 0;
    var len = preds.length;
    while (idx < len) {
      if (preds[idx].apply(this, arguments)) {
        return true;
      }
      idx += 1;
    }
    return false;
  });
});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var _aperture = __webpack_require__(276);
var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xaperture = __webpack_require__(277);


/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */
module.exports = _curry2(_dispatchable([], _xaperture, _aperture));


/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = function _aperture(n, list) {
  var idx = 0;
  var limit = list.length - (n - 1);
  var acc = new Array(limit >= 0 ? limit : 0);
  while (idx < limit) {
    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
    idx += 1;
  }
  return acc;
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XAperture(n, xf) {
    this.xf = xf;
    this.pos = 0;
    this.full = false;
    this.acc = new Array(n);
  }
  XAperture.prototype['@@transducer/init'] = _xfBase.init;
  XAperture.prototype['@@transducer/result'] = function(result) {
    this.acc = null;
    return this.xf['@@transducer/result'](result);
  };
  XAperture.prototype['@@transducer/step'] = function(result, input) {
    this.store(input);
    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
  };
  XAperture.prototype.store = function(input) {
    this.acc[this.pos] = input;
    this.pos += 1;
    if (this.pos === this.acc.length) {
      this.pos = 0;
      this.full = true;
    }
  };
  XAperture.prototype.getCopy = function() {
    return _concat(Array.prototype.slice.call(this.acc, this.pos),
                   Array.prototype.slice.call(this.acc, 0, this.pos));
  };

  return _curry2(function _xaperture(n, xf) { return new XAperture(n, xf); });
}());


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry2 = __webpack_require__(1);


/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */
module.exports = _curry2(function append(el, list) {
  return _concat(list, [el]);
});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var apply = __webpack_require__(154);
var curryN = __webpack_require__(13);
var map = __webpack_require__(16);
var max = __webpack_require__(50);
var pluck = __webpack_require__(57);
var reduce = __webpack_require__(33);
var values = __webpack_require__(155);


/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      var getMetrics = R.applySpec({
 *                                      sum: R.add,
 *                                      nested: { mul: R.multiply }
 *                                   });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */
module.exports = _curry1(function applySpec(spec) {
  spec = map(function(v) { return typeof v == 'function' ? v : applySpec(v); },
             spec);
  return curryN(reduce(max, 0, pluck('length', values(spec))),
                function() {
                  var args = arguments;
                  return map(function(f) { return apply(f, args); }, spec);
                });
});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      var byAge = R.ascend(R.prop('age'));
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByYoungestFirst = R.sort(byAge, people);
 */
module.exports = _curry3(function ascend(fn, a, b) {
  var aa = fn(a);
  var bb = fn(b);
  return aa < bb ? -1 : aa > bb ? 1 : 0;
});


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var nAry = __webpack_require__(76);


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> c) -> (a, b -> c)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      var takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      var takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */
module.exports = _curry1(function binary(fn) {
  return nAry(2, fn);
});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isFunction = __webpack_require__(77);
var and = __webpack_require__(151);
var lift = __webpack_require__(78);


/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.and
 * @example
 *
 *      var gt10 = R.gt(R.__, 10)
 *      var lt20 = R.lt(R.__, 20)
 *      var f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 */
module.exports = _curry2(function both(f, g) {
  return _isFunction(f) ?
    function _both() {
      return f.apply(this, arguments) && g.apply(this, arguments);
    } :
    lift(and)(f, g);
});


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var curry = __webpack_require__(79);


/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      var indentN = R.pipe(R.times(R.always(' ')),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      var format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */
module.exports = curry(function call(fn) {
  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _flatCat = __webpack_require__(285);
var map = __webpack_require__(16);


module.exports = _curry2(function _xchain(f, xf) {
  return map(f, _flatCat(xf));
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var _forceReduced = __webpack_require__(286);
var _isArrayLike = __webpack_require__(74);
var _reduce = __webpack_require__(18);
var _xfBase = __webpack_require__(9);

module.exports = (function() {
  var preservingReduced = function(xf) {
    return {
      '@@transducer/init': _xfBase.init,
      '@@transducer/result': function(result) {
        return xf['@@transducer/result'](result);
      },
      '@@transducer/step': function(result, input) {
        var ret = xf['@@transducer/step'](result, input);
        return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
      }
    };
  };

  return function _xcat(xf) {
    var rxf = preservingReduced(xf);
    return {
      '@@transducer/init': _xfBase.init,
      '@@transducer/result': function(result) {
        return rxf['@@transducer/result'](result);
      },
      '@@transducer/step': function(result, input) {
        return !_isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
      }
    };
  };
}());


/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);

/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */
module.exports = _curry3(function clamp(min, max, value) {
  if (min > max) {
    throw new Error('min must not be greater than max in clamp(min, max, value)');
  }
  return value < min ? min :
         value > max ? max :
         value;
});


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var _clone = __webpack_require__(160);
var _curry1 = __webpack_require__(4);


/**
 * Creates a deep copy of the value which may contain (nested) `Array`s and
 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
 * assigned by reference rather than copied
 *
 * Dispatches to a `clone` method if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      var objects = [{}, {}, {}];
 *      var objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */
module.exports = _curry1(function clone(value) {
  return value != null && typeof value.clone === 'function' ?
    value.clone() :
    _clone(value, [], [], true);
});


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a, b -> Boolean) -> (a, b -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      var byAge = R.comparator((a, b) => a.age < b.age);
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByIncreasingAge = R.sort(byAge, people);
 */
module.exports = _curry1(function comparator(pred) {
  return function(a, b) {
    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
  };
});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var lift = __webpack_require__(78);
var not = __webpack_require__(162);


/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      var isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */
module.exports = lift(not);


/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = function _pipe(f, g) {
  return function() {
    return g.call(this, f.apply(this, arguments));
  };
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var pipeP = __webpack_require__(165);
var reverse = __webpack_require__(80);


/**
 * Performs right-to-left composition of one or more Promise-returning
 * functions. The rightmost function may have any arity; the remaining
 * functions must be unary.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
 * @param {...Function} functions The functions to compose
 * @return {Function}
 * @see R.pipeP
 * @example
 *
 *      var db = {
 *        users: {
 *          JOE: {
 *            name: 'Joe',
 *            followers: ['STEVE', 'SUZY']
 *          }
 *        }
 *      }
 *
 *      // We'll pretend to do a db lookup which returns a promise
 *      var lookupUser = (userId) => Promise.resolve(db.users[userId])
 *      var lookupFollowers = (user) => Promise.resolve(user.followers)
 *      lookupUser('JOE').then(lookupFollowers)
 *
 *      //  followersForUser :: String -> Promise [UserId]
 *      var followersForUser = R.composeP(lookupFollowers, lookupUser);
 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
 *      // Followers: ["STEVE","SUZY"]
 */
module.exports = function composeP() {
  if (arguments.length === 0) {
    throw new Error('composeP requires at least one argument');
  }
  return pipeP.apply(this, reverse(arguments));
};


/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports = function _pipeP(f, g) {
  return function() {
    var ctx = this;
    return f.apply(ctx, arguments).then(function(x) {
      return g.call(ctx, x);
    });
  };
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);
var _map = __webpack_require__(73);
var _quote = __webpack_require__(298);
var _toISOString = __webpack_require__(299);
var keys = __webpack_require__(32);
var reject = __webpack_require__(81);


module.exports = function _toString(x, seen) {
  var recur = function recur(y) {
    var xs = seen.concat([x]);
    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
  };

  //  mapPairs :: (Object, [String]) -> [String]
  var mapPairs = function(obj, keys) {
    return _map(function(k) { return _quote(k) + ': ' + recur(obj[k]); }, keys.slice().sort());
  };

  switch (Object.prototype.toString.call(x)) {
    case '[object Arguments]':
      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
    case '[object Array]':
      return '[' + _map(recur, x).concat(mapPairs(x, reject(function(k) { return /^\d+$/.test(k); }, keys(x)))).join(', ') + ']';
    case '[object Boolean]':
      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
    case '[object Date]':
      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
    case '[object Null]':
      return 'null';
    case '[object Number]':
      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
    case '[object String]':
      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
    case '[object Undefined]':
      return 'undefined';
    default:
      if (typeof x.toString === 'function') {
        var repr = x.toString();
        if (repr !== '[object Object]') {
          return repr;
        }
      }
      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
  }
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var _arrayFromIterator = __webpack_require__(296);
var _functionName = __webpack_require__(297);
var _has = __webpack_require__(14);
var identical = __webpack_require__(167);
var keys = __webpack_require__(32);
var type = __webpack_require__(100);


module.exports = function _equals(a, b, stackA, stackB) {
  if (identical(a, b)) {
    return true;
  }

  if (type(a) !== type(b)) {
    return false;
  }

  if (a == null || b == null) {
    return false;
  }

  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) &&
           typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
  }

  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
    return typeof a.equals === 'function' && a.equals(b) &&
           typeof b.equals === 'function' && b.equals(a);
  }

  switch (type(a)) {
    case 'Arguments':
    case 'Array':
    case 'Object':
      if (typeof a.constructor === 'function' &&
          _functionName(a.constructor) === 'Promise') {
        return a === b;
      }
      break;
    case 'Boolean':
    case 'Number':
    case 'String':
      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
        return false;
      }
      break;
    case 'Date':
      if (!identical(a.valueOf(), b.valueOf())) {
        return false;
      }
      break;
    case 'Error':
      return a.name === b.name && a.message === b.message;
    case 'RegExp':
      if (!(a.source === b.source &&
            a.global === b.global &&
            a.ignoreCase === b.ignoreCase &&
            a.multiline === b.multiline &&
            a.sticky === b.sticky &&
            a.unicode === b.unicode)) {
        return false;
      }
      break;
    case 'Map':
    case 'Set':
      if (!_equals(_arrayFromIterator(a.entries()), _arrayFromIterator(b.entries()), stackA, stackB)) {
        return false;
      }
      break;
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
      break;
    case 'ArrayBuffer':
      break;
    default:
      // Values of other types are only equal if identical.
      return false;
  }

  var keysA = keys(a);
  if (keysA.length !== keys(b).length) {
    return false;
  }

  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }
    idx -= 1;
  }

  stackA.push(a);
  stackB.push(b);
  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has(key, b) && _equals(b[key], a[key], stackA, stackB))) {
      return false;
    }
    idx -= 1;
  }
  stackA.pop();
  stackB.pop();
  return true;
};


/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
};


/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
};


/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = function _quote(s) {
  var escaped = s
    .replace(/\\/g, '\\\\')
    .replace(/[\b]/g, '\\b')  // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, '\\f')
    .replace(/\n/g, '\\n')
    .replace(/\r/g, '\\r')
    .replace(/\t/g, '\\t')
    .replace(/\v/g, '\\v')
    .replace(/\0/g, '\\0');

  return '"' + escaped.replace(/"/g, '\\"') + '"';
};


/***/ }),
/* 299 */
/***/ (function(module, exports) {

/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */
module.exports = (function() {
  var pad = function pad(n) { return (n < 10 ? '0' : '') + n; };

  return typeof Date.prototype.toISOString === 'function' ?
    function _toISOString(d) {
      return d.toISOString();
    } :
    function _toISOString(d) {
      return (
        d.getUTCFullYear() + '-' +
        pad(d.getUTCMonth() + 1) + '-' +
        pad(d.getUTCDate()) + 'T' +
        pad(d.getUTCHours()) + ':' +
        pad(d.getUTCMinutes()) + ':' +
        pad(d.getUTCSeconds()) + '.' +
        (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z'
      );
    };
}());


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XFilter(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFilter.prototype['@@transducer/init'] = _xfBase.init;
  XFilter.prototype['@@transducer/result'] = _xfBase.result;
  XFilter.prototype['@@transducer/step'] = function(result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
  };

  return _curry2(function _xfilter(f, xf) { return new XFilter(f, xf); });
}());


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _curry1 = __webpack_require__(4);
var map = __webpack_require__(16);
var max = __webpack_require__(50);
var reduce = __webpack_require__(33);


/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @example
 *
 *      var fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */
module.exports = _curry1(function cond(pairs) {
  var arity = reduce(max,
                     0,
                     map(function(pair) { return pair[0].length; }, pairs));
  return _arity(arity, function() {
    var idx = 0;
    while (idx < pairs.length) {
      if (pairs[idx][0].apply(this, arguments)) {
        return pairs[idx][1].apply(this, arguments);
      }
      idx += 1;
    }
  });
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var constructN = __webpack_require__(169);


/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      var AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      var animalTypes = ["Lion", "Tiger", "Bear"];
 *      var animalSighting = R.invoker(0, 'sighting');
 *      var sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */
module.exports = _curry1(function construct(Fn) {
  return constructN(Fn.length, Fn);
});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);
var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.contains(3, [1, 2, 3]); //=> true
 *      R.contains(4, [1, 2, 3]); //=> false
 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.contains([42], [[42]]); //=> true
 */
module.exports = _curry2(_contains);


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var reduceBy = __webpack_require__(82);


/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */
module.exports = reduceBy(function(acc, elem) { return acc + 1; }, 0);


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var _curryN = __webpack_require__(72);
var _has = __webpack_require__(14);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
    this.valueFn = valueFn;
    this.valueAcc = valueAcc;
    this.keyFn = keyFn;
    this.xf = xf;
    this.inputs = {};
  }
  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;
  XReduceBy.prototype['@@transducer/result'] = function(result) {
    var key;
    for (key in this.inputs) {
      if (_has(key, this.inputs)) {
        result = this.xf['@@transducer/step'](result, this.inputs[key]);
        if (result['@@transducer/reduced']) {
          result = result['@@transducer/value'];
          break;
        }
      }
    }
    this.inputs = null;
    return this.xf['@@transducer/result'](result);
  };
  XReduceBy.prototype['@@transducer/step'] = function(result, input) {
    var key = this.keyFn(input);
    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
    return result;
  };

  return _curryN(4, [],
                 function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
                   return new XReduceBy(valueFn, valueAcc, keyFn, xf);
                 });
}());


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var add = __webpack_require__(71);


/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */
module.exports = add(-1);


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      var byAge = R.descend(R.prop('age'));
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByOldestFirst = R.sort(byAge, people);
 */
module.exports = _curry3(function descend(fn, a, b) {
  var aa = fn(a);
  var bb = fn(b);
  return aa > bb ? -1 : aa < bb ? 1 : 0;
});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isInteger = __webpack_require__(98);
var assoc = __webpack_require__(75);
var dissoc = __webpack_require__(174);
var remove = __webpack_require__(175);
var update = __webpack_require__(107);


/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */
module.exports = _curry2(function dissocPath(path, obj) {
  switch (path.length) {
    case 0:
      return obj;
    case 1:
      return _isInteger(path[0]) ? remove(path[0], 1, obj) : dissoc(path[0], obj);
    default:
      var head = path[0];
      var tail = Array.prototype.slice.call(path, 1);
      if (obj[head] == null) {
        return obj;
      } else if (_isInteger(path[0])) {
        return update(head, dissocPath(tail, obj[head]), obj);
      } else {
        return assoc(head, dissocPath(tail, obj[head]), obj);
      }
  }
});


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      var half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      var reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */
module.exports = _curry2(function divide(a, b) { return a / b; });


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XDrop(n, xf) {
    this.xf = xf;
    this.n = n;
  }
  XDrop.prototype['@@transducer/init'] = _xfBase.init;
  XDrop.prototype['@@transducer/result'] = _xfBase.result;
  XDrop.prototype['@@transducer/step'] = function(result, input) {
    if (this.n > 0) {
      this.n -= 1;
      return result;
    }
    return this.xf['@@transducer/step'](result, input);
  };

  return _curry2(function _xdrop(n, xf) { return new XDrop(n, xf); });
}());


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _dropLast = __webpack_require__(312);
var _xdropLast = __webpack_require__(314);


/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */
module.exports = _curry2(_dispatchable([], _xdropLast, _dropLast));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var take = __webpack_require__(108);

module.exports = function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduced = __webpack_require__(42);
var _xfBase = __webpack_require__(9);

module.exports = (function() {
  function XTake(n, xf) {
    this.xf = xf;
    this.n = n;
    this.i = 0;
  }
  XTake.prototype['@@transducer/init'] = _xfBase.init;
  XTake.prototype['@@transducer/result'] = _xfBase.result;
  XTake.prototype['@@transducer/step'] = function(result, input) {
    this.i += 1;
    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
    return this.n >= 0 && this.i >= this.n ? _reduced(ret) : ret;
  };

  return _curry2(function _xtake(n, xf) { return new XTake(n, xf); });
}());


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XDropLast(n, xf) {
    this.xf = xf;
    this.pos = 0;
    this.full = false;
    this.acc = new Array(n);
  }
  XDropLast.prototype['@@transducer/init'] = _xfBase.init;
  XDropLast.prototype['@@transducer/result'] =  function(result) {
    this.acc = null;
    return this.xf['@@transducer/result'](result);
  };
  XDropLast.prototype['@@transducer/step'] = function(result, input) {
    if (this.full) {
      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
    }
    this.store(input);
    return result;
  };
  XDropLast.prototype.store = function(input) {
    this.acc[this.pos] = input;
    this.pos += 1;
    if (this.pos === this.acc.length) {
      this.pos = 0;
      this.full = true;
    }
  };

  return _curry2(function _xdropLast(n, xf) { return new XDropLast(n, xf); });
}());


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _dropLastWhile = __webpack_require__(316);
var _xdropLastWhile = __webpack_require__(317);


/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @param {Function} predicate The function to be called on each element
 * @param {Array} list The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      var lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 */
module.exports = _curry2(_dispatchable([], _xdropLastWhile, _dropLastWhile));


/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = function dropLastWhile(pred, list) {
  var idx = list.length - 1;
  while (idx >= 0 && pred(list[idx])) {
    idx -= 1;
  }
  return Array.prototype.slice.call(list, 0, idx + 1);
};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduce = __webpack_require__(18);
var _xfBase = __webpack_require__(9);

module.exports = (function() {
  function XDropLastWhile(fn, xf) {
    this.f = fn;
    this.retained = [];
    this.xf = xf;
  }
  XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;
  XDropLastWhile.prototype['@@transducer/result'] = function(result) {
    this.retained = null;
    return this.xf['@@transducer/result'](result);
  };
  XDropLastWhile.prototype['@@transducer/step'] = function(result, input) {
    return this.f(input) ? this.retain(result, input)
                         : this.flush(result, input);
  };
  XDropLastWhile.prototype.flush = function(result, input) {
    result = _reduce(
      this.xf['@@transducer/step'],
      result,
      this.retained
    );
    this.retained = [];
    return this.xf['@@transducer/step'](result, input);
  };
  XDropLastWhile.prototype.retain = function(result, input) {
    this.retained.push(input);
    return result;
  };

  return _curry2(function _xdropLastWhile(fn, xf) { return new XDropLastWhile(fn, xf); });
}());


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _dispatchable = __webpack_require__(7);
var _xdropRepeatsWith = __webpack_require__(177);
var dropRepeatsWith = __webpack_require__(178);
var equals = __webpack_require__(19);


/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */
module.exports = _curry1(_dispatchable([], _xdropRepeatsWith(equals), dropRepeatsWith(equals)));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xdropWhile = __webpack_require__(320);


/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @param {Function} fn The function called per iteration.
 * @param {Array} list The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      var lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 */
module.exports = _curry2(_dispatchable(['dropWhile'], _xdropWhile, function dropWhile(pred, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len && pred(list[idx])) {
    idx += 1;
  }
  return Array.prototype.slice.call(list, idx);
}));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XDropWhile(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
  XDropWhile.prototype['@@transducer/result'] = _xfBase.result;
  XDropWhile.prototype['@@transducer/step'] = function(result, input) {
    if (this.f) {
      if (this.f(input)) {
        return result;
      }
      this.f = null;
    }
    return this.xf['@@transducer/step'](result, input);
  };

  return _curry2(function _xdropWhile(f, xf) { return new XDropWhile(f, xf); });
}());


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isFunction = __webpack_require__(77);
var lift = __webpack_require__(78);
var or = __webpack_require__(180);


/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.or
 * @example
 *
 *      var gt10 = x => x > 10;
 *      var even = x => x % 2 === 0;
 *      var f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 */
module.exports = _curry2(function either(f, g) {
  return _isFunction(f) ?
    function _either() {
      return f.apply(this, arguments) || g.apply(this, arguments);
    } :
    lift(or)(f, g);
});


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var equals = __webpack_require__(19);
var takeLast = __webpack_require__(182);

/**
 * Checks if a list ends with the provided values
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> Boolean
 * @sig String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */
module.exports = _curry2(function(suffix, list) {
  return equals(takeLast(suffix.length, list), suffix);
});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var equals = __webpack_require__(19);


/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */
module.exports = _curry3(function eqBy(f, x, y) {
  return equals(f(x), f(y));
});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var equals = __webpack_require__(19);


/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */
module.exports = _curry3(function eqProps(prop, obj1, obj2) {
  return equals(obj1[prop], obj2[prop]);
});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      var transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */
module.exports = _curry2(function evolve(transformations, object) {
  var result = {};
  var transformation, key, type;
  for (key in object) {
    transformation = transformations[key];
    type = typeof transformation;
    result[key] = type === 'function'                 ? transformation(object[key])
                : transformation && type === 'object' ? evolve(transformation, object[key])
                                                      : object[key];
  }
  return result;
});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xfind = __webpack_require__(327);


/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */
module.exports = _curry2(_dispatchable(['find'], _xfind, function find(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (fn(list[idx])) {
      return list[idx];
    }
    idx += 1;
  }
}));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduced = __webpack_require__(42);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XFind(f, xf) {
    this.xf = xf;
    this.f = f;
    this.found = false;
  }
  XFind.prototype['@@transducer/init'] = _xfBase.init;
  XFind.prototype['@@transducer/result'] = function(result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, void 0);
    }
    return this.xf['@@transducer/result'](result);
  };
  XFind.prototype['@@transducer/step'] = function(result, input) {
    if (this.f(input)) {
      this.found = true;
      result = _reduced(this.xf['@@transducer/step'](result, input));
    }
    return result;
  };

  return _curry2(function _xfind(f, xf) { return new XFind(f, xf); });
}());


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xfindIndex = __webpack_require__(329);


/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */
module.exports = _curry2(_dispatchable([], _xfindIndex, function findIndex(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (fn(list[idx])) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduced = __webpack_require__(42);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XFindIndex(f, xf) {
    this.xf = xf;
    this.f = f;
    this.idx = -1;
    this.found = false;
  }
  XFindIndex.prototype['@@transducer/init'] = _xfBase.init;
  XFindIndex.prototype['@@transducer/result'] = function(result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, -1);
    }
    return this.xf['@@transducer/result'](result);
  };
  XFindIndex.prototype['@@transducer/step'] = function(result, input) {
    this.idx += 1;
    if (this.f(input)) {
      this.found = true;
      result = _reduced(this.xf['@@transducer/step'](result, this.idx));
    }
    return result;
  };

  return _curry2(function _xfindIndex(f, xf) { return new XFindIndex(f, xf); });
}());


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xfindLast = __webpack_require__(331);


/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */
module.exports = _curry2(_dispatchable([], _xfindLast, function findLast(fn, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    if (fn(list[idx])) {
      return list[idx];
    }
    idx -= 1;
  }
}));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XFindLast(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFindLast.prototype['@@transducer/init'] = _xfBase.init;
  XFindLast.prototype['@@transducer/result'] = function(result) {
    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
  };
  XFindLast.prototype['@@transducer/step'] = function(result, input) {
    if (this.f(input)) {
      this.last = input;
    }
    return result;
  };

  return _curry2(function _xfindLast(f, xf) { return new XFindLast(f, xf); });
}());


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xfindLastIndex = __webpack_require__(333);


/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */
module.exports = _curry2(_dispatchable([], _xfindLastIndex, function findLastIndex(fn, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    if (fn(list[idx])) {
      return idx;
    }
    idx -= 1;
  }
  return -1;
}));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XFindLastIndex(f, xf) {
    this.xf = xf;
    this.f = f;
    this.idx = -1;
    this.lastIdx = -1;
  }
  XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;
  XFindLastIndex.prototype['@@transducer/result'] = function(result) {
    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
  };
  XFindLastIndex.prototype['@@transducer/step'] = function(result, input) {
    this.idx += 1;
    if (this.f(input)) {
      this.lastIdx = this.idx;
    }
    return result;
  };

  return _curry2(function _xfindLastIndex(f, xf) { return new XFindLastIndex(f, xf); });
}());


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _makeFlat = __webpack_require__(159);


/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */
module.exports = _curry1(_makeFlat(true));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(59);
var _curry2 = __webpack_require__(1);


/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      var printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */
module.exports = _curry2(_checkForMethod('forEach', function forEach(fn, list) {
  var len = list.length;
  var idx = 0;
  while (idx < len) {
    fn(list[idx]);
    idx += 1;
  }
  return list;
}));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var keys = __webpack_require__(32);


/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      var printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */
module.exports = _curry2(function forEachObjIndexed(fn, obj) {
  var keyList = keys(obj);
  var idx = 0;
  while (idx < keyList.length) {
    var key = keyList[idx];
    fn(obj[key], key, obj);
    idx += 1;
  }
  return obj;
});


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */
module.exports = _curry1(function fromPairs(pairs) {
  var result = {};
  var idx = 0;
  while (idx < pairs.length) {
    result[pairs[idx][0]] = pairs[idx][1];
    idx += 1;
  }
  return result;
});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(59);
var _curry2 = __webpack_require__(1);
var reduceBy = __webpack_require__(82);

/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.transduce
 * @example
 *
 *      var byGrade = R.groupBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */
module.exports = _curry2(_checkForMethod('groupBy', reduceBy(function(acc, item) {
  if (acc == null) {
    acc = [];
  }
  acc.push(item);
  return acc;
}, null)));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);

/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */
module.exports = _curry2(function(fn, list) {
  var res = [];
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    var nextidx = idx + 1;
    while (nextidx < len && fn(list[nextidx - 1], list[nextidx])) {
      nextidx += 1;
    }
    res.push(list.slice(idx, nextidx));
    idx = nextidx;
  }
  return res;
});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */
module.exports = _curry2(function gt(a, b) { return a > b; });


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */
module.exports = _curry2(function gte(a, b) { return a >= b; });


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _has = __webpack_require__(14);


/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      var hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      var point = {x: 0, y: 0};
 *      var pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */
module.exports = _curry2(_has);


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      var square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */
module.exports = _curry2(function hasIn(prop, obj) {
  return prop in obj;
});


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var nth = __webpack_require__(61);


/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */
module.exports = nth(0);


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var curryN = __webpack_require__(13);


/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when
 * @example
 *
 *      var incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({});           //=> { count: 1 }
 *      incCount({ count: 1 }); //=> { count: 2 }
 */
module.exports = _curry3(function ifElse(condition, onTrue, onFalse) {
  return curryN(Math.max(condition.length, onTrue.length, onFalse.length),
    function _ifElse() {
      return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    }
  );
});


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var add = __webpack_require__(71);


/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */
module.exports = add(1);


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var reduceBy = __webpack_require__(82);


/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */
module.exports = reduceBy(function(acc, elem) { return elem; }, null);


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _indexOf = __webpack_require__(166);
var _isArray = __webpack_require__(41);


/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */
module.exports = _curry2(function indexOf(target, xs) {
  return typeof xs.indexOf === 'function' && !_isArray(xs) ?
    xs.indexOf(target) :
    _indexOf(xs, target, 0);
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var slice = __webpack_require__(45);


/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */
module.exports = slice(0, -1);


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var _containsWith = __webpack_require__(83);
var _curry3 = __webpack_require__(5);
var _filter = __webpack_require__(105);


/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig (a -> b -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */
module.exports = _curry3(function innerJoin(pred, xs, ys) {
  return _filter(function(x) { return _containsWith(pred, x, ys); }, xs);
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */
module.exports = _curry3(function insert(idx, elt, list) {
  idx = idx < list.length && idx >= 0 ? idx : list.length;
  var result = Array.prototype.slice.call(list, 0);
  result.splice(idx, 0, elt);
  return result;
});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */
module.exports = _curry3(function insertAll(idx, elts, list) {
  idx = idx < list.length && idx >= 0 ? idx : list.length;
  return [].concat(Array.prototype.slice.call(list, 0, idx),
                   elts,
                   Array.prototype.slice.call(list, idx));
});


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);
var _curry2 = __webpack_require__(1);
var _filter = __webpack_require__(105);
var flip = __webpack_require__(84);
var uniq = __webpack_require__(111);


/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */
module.exports = _curry2(function intersection(list1, list2) {
  var lookupList, filteredList;
  if (list1.length > list2.length) {
    lookupList = list1;
    filteredList = list2;
  } else {
    lookupList = list2;
    filteredList = list1;
  }
  return uniq(_filter(flip(_contains)(lookupList), filteredList));
});


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);


// A simple Set type that honours R.equals semantics
module.exports = (function() {
  function _Set() {
    /* globals Set */
    this._nativeSet = typeof Set === 'function' ? new Set() : null;
    this._items = {};
  }

  // until we figure out why jsdoc chokes on this
  // @param item The item to add to the Set
  // @returns {boolean} true if the item did not exist prior, otherwise false
  //
  _Set.prototype.add = function(item) {
    return !hasOrAdd(item, true, this);
  };

  //
  // @param item The item to check for existence in the Set
  // @returns {boolean} true if the item exists in the Set, otherwise false
  //
  _Set.prototype.has = function(item) {
    return hasOrAdd(item, false, this);
  };

  //
  // Combines the logic for checking whether an item is a member of the set and
  // for adding a new item to the set.
  //
  // @param item       The item to check or add to the Set instance.
  // @param shouldAdd  If true, the item will be added to the set if it doesn't
  //                   already exist.
  // @param set        The set instance to check or add to.
  // @return {boolean} true if the item already existed, otherwise false.
  //
  function hasOrAdd(item, shouldAdd, set) {
    var type = typeof item;
    var prevSize, newSize;
    switch (type) {
      case 'string':
      case 'number':
        // distinguish between +0 and -0
        if (item === 0 && 1 / item === -Infinity) {
          if (set._items['-0']) {
            return true;
          } else {
            if (shouldAdd) {
              set._items['-0'] = true;
            }
            return false;
          }
        }
        // these types can all utilise the native Set
        if (set._nativeSet !== null) {
          if (shouldAdd) {
            prevSize = set._nativeSet.size;
            set._nativeSet.add(item);
            newSize = set._nativeSet.size;
            return newSize === prevSize;
          } else {
            return set._nativeSet.has(item);
          }
        } else {
          if (!(type in set._items)) {
            if (shouldAdd) {
              set._items[type] = {};
              set._items[type][item] = true;
            }
            return false;
          } else if (item in set._items[type]) {
            return true;
          } else {
            if (shouldAdd) {
              set._items[type][item] = true;
            }
            return false;
          }
        }

      case 'boolean':
        // set._items['boolean'] holds a two element array
        // representing [ falseExists, trueExists ]
        if (type in set._items) {
          var bIdx = item ? 1 : 0;
          if (set._items[type][bIdx]) {
            return true;
          } else {
            if (shouldAdd) {
              set._items[type][bIdx] = true;
            }
            return false;
          }
        } else {
          if (shouldAdd) {
            set._items[type] = item ? [false, true] : [true, false];
          }
          return false;
        }

      case 'function':
        // compare functions for reference equality
        if (set._nativeSet !== null) {
          if (shouldAdd) {
            prevSize = set._nativeSet.size;
            set._nativeSet.add(item);
            newSize = set._nativeSet.size;
            return newSize === prevSize;
          } else {
            return set._nativeSet.has(item);
          }
        } else {
          if (!(type in set._items)) {
            if (shouldAdd) {
              set._items[type] = [item];
            }
            return false;
          }
          if (!_contains(item, set._items[type])) {
            if (shouldAdd) {
              set._items[type].push(item);
            }
            return false;
          }
          return true;
        }

      case 'undefined':
        if (set._items[type]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type] = true;
          }
          return false;
        }

      case 'object':
        if (item === null) {
          if (!set._items['null']) {
            if (shouldAdd) {
              set._items['null'] = true;
            }
            return false;
          }
          return true;
        }
      /* falls through */
      default:
        // reduce the search size of heterogeneous sets by creating buckets
        // for each type.
        type = Object.prototype.toString.call(item);
        if (!(type in set._items)) {
          if (shouldAdd) {
            set._items[type] = [item];
          }
          return false;
        }
        // scan through all previously applied items
        if (!_contains(item, set._items[type])) {
          if (shouldAdd) {
            set._items[type].push(item);
          }
          return false;
        }
        return true;
    }
  }
  return _Set;
}());


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var _containsWith = __webpack_require__(83);
var _curry3 = __webpack_require__(5);
var uniqWith = __webpack_require__(112);


/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate function that determines whether
 *        the two supplied elements are equal.
 * @param {Array} list1 One list of items to compare
 * @param {Array} list2 A second list of items to compare
 * @return {Array} A new list containing those elements common to both lists.
 * @see R.innerJoin
 * @deprecated since v0.24.0
 * @example
 *
 *      var buffaloSpringfield = [
 *        {id: 824, name: 'Richie Furay'},
 *        {id: 956, name: 'Dewey Martin'},
 *        {id: 313, name: 'Bruce Palmer'},
 *        {id: 456, name: 'Stephen Stills'},
 *        {id: 177, name: 'Neil Young'}
 *      ];
 *      var csny = [
 *        {id: 204, name: 'David Crosby'},
 *        {id: 456, name: 'Stephen Stills'},
 *        {id: 539, name: 'Graham Nash'},
 *        {id: 177, name: 'Neil Young'}
 *      ];
 *
 *      R.intersectionWith(R.eqBy(R.prop('id')), buffaloSpringfield, csny);
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */
module.exports = _curry3(function intersectionWith(pred, list1, list2) {
  var lookupList, filteredList;
  if (list1.length > list2.length) {
    lookupList = list1;
    filteredList = list2;
  } else {
    lookupList = list2;
    filteredList = list1;
  }
  var results = [];
  var idx = 0;
  while (idx < filteredList.length) {
    if (_containsWith(pred, filteredList[idx], lookupList)) {
      results[results.length] = filteredList[idx];
    }
    idx += 1;
  }
  return uniqWith(pred, results);
});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(59);
var _curry2 = __webpack_require__(1);


/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
 */
module.exports = _curry2(_checkForMethod('intersperse', function intersperse(separator, list) {
  var out = [];
  var idx = 0;
  var length = list.length;
  while (idx < length) {
    if (idx === length - 1) {
      out.push(list[idx]);
    } else {
      out.push(list[idx], separator);
    }
    idx += 1;
  }
  return out;
}));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var _clone = __webpack_require__(160);
var _curry3 = __webpack_require__(5);
var _isTransformer = __webpack_require__(95);
var _reduce = __webpack_require__(18);
var _stepCat = __webpack_require__(358);


/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      var intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */
module.exports = _curry3(function into(acc, xf, list) {
  return _isTransformer(acc) ?
    _reduce(xf(acc), acc['@@transducer/init'](), list) :
    _reduce(xf(_stepCat(acc)), _clone(acc, [], [], false), list);
});


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var _assign = __webpack_require__(113);
var _identity = __webpack_require__(110);
var _isArrayLike = __webpack_require__(74);
var _isTransformer = __webpack_require__(95);
var objOf = __webpack_require__(184);


module.exports = (function() {
  var _stepCatArray = {
    '@@transducer/init': Array,
    '@@transducer/step': function(xs, x) {
      xs.push(x);
      return xs;
    },
    '@@transducer/result': _identity
  };
  var _stepCatString = {
    '@@transducer/init': String,
    '@@transducer/step': function(a, b) { return a + b; },
    '@@transducer/result': _identity
  };
  var _stepCatObject = {
    '@@transducer/init': Object,
    '@@transducer/step': function(result, input) {
      return _assign(
        result,
        _isArrayLike(input) ? objOf(input[0], input[1]) : input
      );
    },
    '@@transducer/result': _identity
  };

  return function _stepCat(obj) {
    if (_isTransformer(obj)) {
      return obj;
    }
    if (_isArrayLike(obj)) {
      return _stepCatArray;
    }
    if (typeof obj === 'string') {
      return _stepCatString;
    }
    if (typeof obj === 'object') {
      return _stepCatObject;
    }
    throw new Error('Cannot create transformer for ' + obj);
  };
}());


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var _has = __webpack_require__(14);

// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
module.exports = function _objectAssign(target) {
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var output = Object(target);
  var idx = 1;
  var length = arguments.length;
  while (idx < length) {
    var source = arguments[idx];
    if (source != null) {
      for (var nextKey in source) {
        if (_has(nextKey, source)) {
          output[nextKey] = source[nextKey];
        }
      }
    }
    idx += 1;
  }
  return output;
};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _has = __webpack_require__(14);
var keys = __webpack_require__(32);


/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      var raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */
module.exports = _curry1(function invert(obj) {
  var props = keys(obj);
  var len = props.length;
  var idx = 0;
  var out = {};

  while (idx < len) {
    var key = props[idx];
    var val = obj[key];
    var list = _has(val, out) ? out[val] : (out[val] = []);
    list[list.length] = key;
    idx += 1;
  }
  return out;
});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var keys = __webpack_require__(32);


/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      var raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      var raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */
module.exports = _curry1(function invertObj(obj) {
  var props = keys(obj);
  var len = props.length;
  var idx = 0;
  var out = {};

  while (idx < len) {
    var key = props[idx];
    out[obj[key]] = key;
    idx += 1;
  }
  return out;
});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var empty = __webpack_require__(181);
var equals = __webpack_require__(19);


/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);   //=> false
 *      R.isEmpty([]);          //=> true
 *      R.isEmpty('');          //=> true
 *      R.isEmpty(null);        //=> false
 *      R.isEmpty({});          //=> true
 *      R.isEmpty({length: 0}); //=> false
 */
module.exports = _curry1(function isEmpty(x) {
  return x != null && equals(x, empty(x));
});


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var invoker = __webpack_require__(62);


/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      var spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */
module.exports = invoker(1, 'join');


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */
module.exports = _curry1(function keysIn(obj) {
  var prop;
  var ks = [];
  for (prop in obj) {
    ks[ks.length] = prop;
  }
  return ks;
});


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isArray = __webpack_require__(41);
var equals = __webpack_require__(19);


/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */
module.exports = _curry2(function lastIndexOf(target, xs) {
  if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
    return xs.lastIndexOf(target);
  } else {
    var idx = xs.length - 1;
    while (idx >= 0) {
      if (equals(xs[idx], target)) {
        return idx;
      }
      idx -= 1;
    }
    return -1;
  }
});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var lens = __webpack_require__(85);
var nth = __webpack_require__(61);
var update = __webpack_require__(107);


/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */
module.exports = _curry1(function lensIndex(n) {
  return lens(nth(n), update(n));
});


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var assocPath = __webpack_require__(156);
var lens = __webpack_require__(85);
var path = __webpack_require__(63);


/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */
module.exports = _curry1(function lensPath(p) {
  return lens(path(p), assocPath(p));
});


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var assoc = __webpack_require__(75);
var lens = __webpack_require__(85);
var prop = __webpack_require__(96);


/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */
module.exports = _curry1(function lensProp(k) {
  return lens(prop(k), assoc(k));
});


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */
module.exports = _curry2(function lt(a, b) { return a < b; });


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */
module.exports = _curry2(function lte(a, b) { return a <= b; });


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (acc -> x -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccumRight
 * @example
 *
 *      var digits = ['1', '2', '3', '4'];
 *      var appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */
module.exports = _curry3(function mapAccum(fn, acc, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  var tuple = [acc];
  while (idx < len) {
    tuple = fn(tuple[0], list[idx]);
    result[idx] = tuple[1];
    idx += 1;
  }
  return [tuple[0], result];
});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *value* and *acc*, and should
 * return a tuple *[value, acc]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (x-> acc -> (y, acc)) -> acc -> [x] -> ([y], acc)
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      var digits = ['1', '2', '3', '4'];
 *      var append = (a, b) => [a + b, a + b];
 *
 *      R.mapAccumRight(append, 5, digits); //=> [['12345', '2345', '345', '45'], '12345']
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   [
 *     f(b, f(c, f(d, a)[0])[0])[1],
 *     f(c, f(d, a)[0])[1],
 *     f(d, a)[1],
 *   ]
 *   f(b, f(c, f(d, a)[0])[0])[0],
 * ]
 */
module.exports = _curry3(function mapAccumRight(fn, acc, list) {
  var idx = list.length - 1;
  var result = [];
  var tuple = [acc];
  while (idx >= 0) {
    tuple = fn(list[idx], tuple[0]);
    result[idx] = tuple[1];
    idx -= 1;
  }
  return [result, tuple[0]];
});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduce = __webpack_require__(18);
var keys = __webpack_require__(32);


/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      var values = { x: 1, y: 2, z: 3 };
 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */
module.exports = _curry2(function mapObjIndexed(fn, obj) {
  return _reduce(function(acc, key) {
    acc[key] = fn(obj[key], key, obj);
    return acc;
  }, {}, keys(obj));
});


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */
module.exports = _curry2(function match(rx, str) {
  return str.match(rx) || [];
});


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isInteger = __webpack_require__(98);


/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      var clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      var seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */
module.exports = _curry2(function mathMod(m, p) {
  if (!_isInteger(m)) { return NaN; }
  if (!_isInteger(p) || p < 1) { return NaN; }
  return ((m % p) + p) % p;
});


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      var square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */
module.exports = _curry3(function maxBy(f, a, b) {
  return f(b) > f(a) ? b : a;
});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var mean = __webpack_require__(189);


/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */
module.exports = _curry1(function median(list) {
  var len = list.length;
  if (len === 0) {
    return NaN;
  }
  var width = 2 - len % 2;
  var idx = (len - width) / 2;
  return mean(Array.prototype.slice.call(list, 0).sort(function(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }).slice(idx, idx + width));
});


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeWith = __webpack_require__(191);
var toString = __webpack_require__(60);


/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoizeWith
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoize(n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */
module.exports = memoizeWith(toString);


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var _assign = __webpack_require__(113);
var _curry2 = __webpack_require__(1);


/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      var resetToDefault = R.merge(R.__, {x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.merge({ x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: 5, z: 3 }
 */
module.exports = _curry2(function merge(l, r) {
  return _assign({}, l, r);
});


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var _assign = __webpack_require__(113);
var _curry1 = __webpack_require__(4);


/**
 * Merges a list of objects together into one object.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */
module.exports = _curry1(function mergeAll(list) {
  return _assign.apply(null, [{}].concat(list));
});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var mergeDeepWithKey = __webpack_require__(86);


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */
module.exports = _curry2(function mergeDeepLeft(lObj, rObj) {
  return mergeDeepWithKey(function(k, lVal, rVal) {
    return lVal;
  }, lObj, rObj);
});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var mergeDeepWithKey = __webpack_require__(86);


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */
module.exports = _curry2(function mergeDeepRight(lObj, rObj) {
  return mergeDeepWithKey(function(k, lVal, rVal) {
    return rVal;
  }, lObj, rObj);
});


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var mergeDeepWithKey = __webpack_require__(86);


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeep, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */
module.exports = _curry3(function mergeDeepWith(fn, lObj, rObj) {
  return mergeDeepWithKey(function(k, lVal, rVal) {
    return fn(lVal, rVal);
  }, lObj, rObj);
});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var mergeWithKey = __webpack_require__(114);


/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */
module.exports = _curry3(function mergeWith(fn, l, r) {
  return mergeWithKey(function(_, _l, _r) {
    return fn(_l, _r);
  }, l, r);
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */
module.exports = _curry2(function min(a, b) { return b < a ? b : a; });


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      var square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */
module.exports = _curry3(function minBy(f, a, b) {
  return f(b) < f(a) ? b : a;
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      var isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */
module.exports = _curry2(function modulo(a, b) { return a % b; });


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */
module.exports = _curry1(function negate(n) { return -n; });


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var _complement = __webpack_require__(168);
var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xany = __webpack_require__(153);
var any = __webpack_require__(152);


/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isEven, [1, 3, 5, 7, 8, 11]); //=> false
 */
module.exports = _curry2(_complement(_dispatchable(['any'], _xany, any)));


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var curryN = __webpack_require__(13);
var nth = __webpack_require__(61);


/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */
module.exports = _curry1(function nthArg(n) {
  var arity = n < 0 ? 1 : n + 1;
  return curryN(arity, function() {
    return nth(n, arguments);
  });
});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      var classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + lastName
 *      var yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */
module.exports = _curry3(function o(f, g, x) {
  return f(g(x));
});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _of = __webpack_require__(393);


/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */
module.exports = _curry1(_of);


/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports = function _of(x) { return [x]; };


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);
var _curry2 = __webpack_require__(1);


/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */
module.exports = _curry2(function omit(names, obj) {
  var result = {};
  for (var prop in obj) {
    if (!_contains(prop, names)) {
      result[prop] = obj[prop];
    }
  }
  return result;
});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _curry1 = __webpack_require__(4);


/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      var addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */
module.exports = _curry1(function once(fn) {
  var called = false;
  var result;
  return _arity(fn.length, function() {
    if (called) {
      return result;
    }
    called = true;
    result = fn.apply(this, arguments);
    return result;
  });
});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */
module.exports = _curry2(function pair(fst, snd) { return [fst, snd]; });


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _createPartialApplicator = __webpack_require__(194);


/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight
 * @example
 *
 *      var multiply2 = (a, b) => a * b;
 *      var double = R.partial(multiply2, [2]);
 *      double(2); //=> 4
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var sayHello = R.partial(greet, ['Hello']);
 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */
module.exports = _createPartialApplicator(_concat);


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _createPartialApplicator = __webpack_require__(194);
var flip = __webpack_require__(84);


/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */
module.exports = _createPartialApplicator(flip(_concat));


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var filter = __webpack_require__(104);
var juxt = __webpack_require__(186);
var reject = __webpack_require__(81);


/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */
module.exports = juxt([filter, reject]);


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var equals = __webpack_require__(19);
var path = __webpack_require__(63);


/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      var user1 = { address: { zipCode: 90210 } };
 *      var user2 = { address: { zipCode: 55555 } };
 *      var user3 = { name: 'Bob' };
 *      var users = [ user1, user2, user3 ];
 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */
module.exports = _curry3(function pathEq(_path, val, obj) {
  return equals(path(_path, obj), val);
});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var defaultTo = __webpack_require__(171);
var path = __webpack_require__(63);


/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */
module.exports = _curry3(function pathOr(d, p, obj) {
  return defaultTo(d, path(p, obj));
});


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var path = __webpack_require__(63);


/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 */
module.exports = _curry3(function pathSatisfies(pred, propPath, obj) {
  return propPath.length > 0 && pred(path(propPath, obj));
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */
module.exports = _curry2(function pick(names, obj) {
  var result = {};
  var idx = 0;
  while (idx < names.length) {
    if (names[idx] in obj) {
      result[names[idx]] = obj[names[idx]];
    }
    idx += 1;
  }
  return result;
});


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */
module.exports = _curry2(function pickBy(test, obj) {
  var result = {};
  for (var prop in obj) {
    if (test(obj[prop], prop, obj)) {
      result[prop] = obj[prop];
    }
  }
  return result;
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var composeK = __webpack_require__(164);
var reverse = __webpack_require__(80);

/**
 * Returns the left-to-right Kleisli composition of the provided functions,
 * each of which must return a value of a type supported by [`chain`](#chain).
 *
 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(R.chain(f), R.chain(g), R.chain(h))`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Function
 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
 * @param {...Function}
 * @return {Function}
 * @see R.composeK
 * @example
 *
 *      //  parseJson :: String -> Maybe *
 *      //  get :: String -> Object -> Maybe *
 *
 *      //  getStateCode :: Maybe String -> Maybe String
 *      var getStateCode = R.pipeK(
 *        parseJson,
 *        get('user'),
 *        get('address'),
 *        get('state'),
 *        R.compose(Maybe.of, R.toUpper)
 *      );
 *
 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
 *      //=> Just('NY')
 *      getStateCode('[Invalid JSON]');
 *      //=> Nothing()
 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
 */
module.exports = function pipeK() {
  if (arguments.length === 0) {
    throw new Error('pipeK requires at least one argument');
  }
  return composeK.apply(this, reverse(arguments));
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var multiply = __webpack_require__(192);
var reduce = __webpack_require__(33);


/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */
module.exports = reduce(multiply, 1);


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var _map = __webpack_require__(73);
var identity = __webpack_require__(109);
var pickAll = __webpack_require__(195);
var useWith = __webpack_require__(197);


/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      var kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */
module.exports = useWith(_map, [pickAll, identity]); // passing `identity` gives correct arity


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var equals = __webpack_require__(19);


/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.equals, R.propSatisfies
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      var kids = [abby, fred, rusty, alois];
 *      var hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */
module.exports = _curry3(function propEq(name, val, obj) {
  return equals(val, obj[name]);
});


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var is = __webpack_require__(185);


/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */
module.exports = _curry3(function propIs(type, name, obj) {
  return is(type, obj[name]);
});


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var _has = __webpack_require__(14);


/**
 * If the given, non-null object has an own property with the specified name,
 * returns the value of that property. Otherwise returns the provided default
 * value.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      var alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      var favorite = R.prop('favoriteLibrary');
 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */
module.exports = _curry3(function propOr(val, p, obj) {
  return (obj != null && _has(p, obj)) ? obj[p] : val;
});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */
module.exports = _curry3(function propSatisfies(pred, name, obj) {
  return pred(obj[name]);
});


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */
module.exports = _curry2(function props(ps, obj) {
  var len = ps.length;
  var out = [];
  var idx = 0;

  while (idx < len) {
    out[idx] = obj[ps[idx]];
    idx += 1;
  }

  return out;
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _isNumber = __webpack_require__(188);


/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in tthe set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */
module.exports = _curry2(function range(from, to) {
  if (!(_isNumber(from) && _isNumber(to))) {
    throw new TypeError('Both arguments to range must be numbers');
  }
  var result = [];
  var n = from;
  while (n < to) {
    result.push(n);
    n += 1;
  }
  return result;
});


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var _curryN = __webpack_require__(72);
var _reduce = __webpack_require__(18);
var _reduced = __webpack_require__(42);


/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator.
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      var isOdd = (acc, x) => x % 2 === 1;
 *      var xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      var ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */
module.exports = _curryN(4, [], function _reduceWhile(pred, fn, a, list) {
  return _reduce(function(acc, x) {
    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
  }, a, list);
});


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _reduced = __webpack_require__(42);

/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * Note: this optimization is unavailable to functions not explicitly listed
 * above. For instance, it is not currently supported by
 * [`reduceRight`](#reduceRight).
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */

module.exports = _curry1(_reduced);


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var always = __webpack_require__(49);
var times = __webpack_require__(199);


/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      var obj = {};
 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */
module.exports = _curry2(function repeat(value, n) {
  return times(always(value), n);
});


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */
module.exports = _curry3(function replace(regex, replacement, str) {
  return str.replace(regex, replacement);
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a,b -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */
module.exports = _curry3(function scan(fn, acc, list) {
  var idx = 0;
  var len = list.length;
  var result = [acc];
  while (idx < len) {
    acc = fn(acc, list[idx]);
    result[idx + 1] = acc;
    idx += 1;
  }
  return result;
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var always = __webpack_require__(49);
var over = __webpack_require__(193);


/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */
module.exports = _curry3(function set(lens, v, x) {
  return over(lens, always(v), x);
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a,a -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @example
 *
 *      var diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */
module.exports = _curry2(function sort(comparator, list) {
  return Array.prototype.slice.call(list, 0).sort(comparator);
});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      var sortByFirstItem = R.sortBy(R.prop(0));
 *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *      var alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      var bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      var clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      var people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */
module.exports = _curry2(function sortBy(fn, list) {
  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
  });
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [a -> a -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @example
 *
 *      var alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      var bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      var clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      var people = [clara, bob, alice];
 *      var ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */
module.exports = _curry2(function sortWith(fns, list) {
  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
    var result = 0;
    var i = 0;
    while (result === 0 && i < fns.length) {
      result = fns[i](a, b);
      i += 1;
    }
    return result;
  });
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var invoker = __webpack_require__(62);


/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `str`.
 * @see R.join
 * @example
 *
 *      var pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */
module.exports = invoker(1, 'split');


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var length = __webpack_require__(187);
var slice = __webpack_require__(45);


/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */
module.exports = _curry2(function splitAt(index, array) {
  return [slice(0, index, array), slice(index, length(array), array)];
});


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var slice = __webpack_require__(45);


/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */
module.exports = _curry2(function splitEvery(n, list) {
  if (n <= 0) {
    throw new Error('First argument to splitEvery must be a positive integer');
  }
  var result = [];
  var idx = 0;
  while (idx < list.length) {
    result.push(slice(idx, idx += n, list));
  }
  return result;
});


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */
module.exports = _curry2(function splitWhen(pred, list) {
  var idx = 0;
  var len = list.length;
  var prefix = [];

  while (idx < len && !pred(list[idx])) {
    prefix.push(list[idx]);
    idx += 1;
  }

  return [prefix, Array.prototype.slice.call(list, idx)];
});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var equals = __webpack_require__(19);
var take = __webpack_require__(108);

/**
 * Checks if a list starts with the provided values
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> Boolean
 * @sig String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */
module.exports = _curry2(function(prefix, list) {
  return equals(take(prefix.length, list), prefix);
});


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      var minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      var complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */
module.exports = _curry2(function subtract(a, b) {
  return Number(a) - Number(b);
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var concat = __webpack_require__(103);
var difference = __webpack_require__(172);


/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */
module.exports = _curry2(function symmetricDifference(list1, list2) {
  return concat(difference(list1, list2), difference(list2, list1));
});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var concat = __webpack_require__(103);
var differenceWith = __webpack_require__(173);


/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      var eqA = R.eqBy(R.prop('a'));
 *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */
module.exports = _curry3(function symmetricDifferenceWith(pred, list1, list2) {
  return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @param {Function} fn The function called per iteration.
 * @param {Array} list The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      var isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 */
module.exports = _curry2(function takeLastWhile(fn, list) {
  var idx = list.length - 1;
  while (idx >= 0 && fn(list[idx])) {
    idx -= 1;
  }
  return Array.prototype.slice.call(list, idx + 1);
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _dispatchable = __webpack_require__(7);
var _xtakeWhile = __webpack_require__(433);


/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @param {Function} fn The function called per iteration.
 * @param {Array} list The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      var isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 */
module.exports = _curry2(_dispatchable(['takeWhile'], _xtakeWhile, function takeWhile(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len && fn(list[idx])) {
    idx += 1;
  }
  return Array.prototype.slice.call(list, 0, idx);
}));


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var _reduced = __webpack_require__(42);
var _xfBase = __webpack_require__(9);


module.exports = (function() {
  function XTakeWhile(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
  XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;
  XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced(result);
  };

  return _curry2(function _xtakeWhile(f, xf) { return new XTakeWhile(f, xf); });
}());


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      var sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */
module.exports = _curry2(function tap(fn, x) {
  fn(x);
  return x;
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var _cloneRegExp = __webpack_require__(161);
var _curry2 = __webpack_require__(1);
var _isRegExp = __webpack_require__(436);
var toString = __webpack_require__(60);


/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */
module.exports = _curry2(function test(pattern, str) {
  if (!_isRegExp(pattern)) {
    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + toString(pattern));
  }
  return _cloneRegExp(pattern).test(str);
});


/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var invoker = __webpack_require__(62);


/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */
module.exports = invoker(0, 'toLowerCase');


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var _has = __webpack_require__(14);


/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */
module.exports = _curry1(function toPairs(obj) {
  var pairs = [];
  for (var prop in obj) {
    if (_has(prop, obj)) {
      pairs[pairs.length] = [prop, obj[prop]];
    }
  }
  return pairs;
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */
module.exports = _curry1(function toPairsIn(obj) {
  var pairs = [];
  for (var prop in obj) {
    pairs[pairs.length] = [prop, obj[prop]];
  }
  return pairs;
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var invoker = __webpack_require__(62);


/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */
module.exports = invoker(0, 'toUpperCase');


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var _reduce = __webpack_require__(18);
var _xwrap = __webpack_require__(148);
var curryN = __webpack_require__(13);


/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> (a,b -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 */
module.exports = curryN(4, function transduce(xf, fn, acc, list) {
  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */
module.exports = _curry1(function transpose(outerlist) {
  var i = 0;
  var result = [];
  while (i < outerlist.length) {
    var innerlist = outerlist[i];
    var j = 0;
    while (j < innerlist.length) {
      if (typeof result[j] === 'undefined') {
        result[j] = [];
      }
      result[j].push(innerlist[j]);
      j += 1;
    }
    i += 1;
  }
  return result;
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);
var map = __webpack_require__(16);
var sequence = __webpack_require__(200);


/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Nothing` if the given divisor is `0`
 *      safeDiv = n => d => d === 0 ? Nothing() : Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Nothing
 */
module.exports = _curry3(function traverse(of, f, traversable) {
  return typeof traversable['fantasy-land/traverse'] === 'function' ?
    traversable['fantasy-land/traverse'](f, of) :
    sequence(of, map(f, traversable));
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */
module.exports = (function() {
  var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
           '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' +
           '\u2029\uFEFF';
  var zeroWidth = '\u200b';
  var hasProtoTrim = (typeof String.prototype.trim === 'function');
  if (!hasProtoTrim || (ws.trim() || !zeroWidth.trim())) {
    return _curry1(function trim(str) {
      var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
      var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
      return str.replace(beginRx, '').replace(endRx, '');
    });
  } else {
    return _curry1(function trim(str) {
      return str.trim();
    });
  }
}());


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(31);
var _concat = __webpack_require__(21);
var _curry2 = __webpack_require__(1);


/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send then to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(R.prop('x'), R.F)(null);      //=> false
 */
module.exports = _curry2(function _tryCatch(tryer, catcher) {
  return _arity(tryer.length, function() {
    try {
      return tryer.apply(this, arguments);
    } catch (e) {
      return catcher.apply(this, _concat([e], arguments));
    }
  });
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */
module.exports = _curry1(function unapply(fn) {
  return function() {
    return fn(Array.prototype.slice.call(arguments, 0));
  };
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);
var nAry = __webpack_require__(76);


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> b) -> (a -> b)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      var takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      var takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */
module.exports = _curry1(function unary(fn) {
  return nAry(1, fn);
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var curryN = __webpack_require__(13);


/**
 * Returns a function of arity `n` from a (manually) curried function.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b) -> (a -> c)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry
 * @example
 *
 *      var addFour = a => b => c => d => a + b + c + d;
 *
 *      var uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */
module.exports = _curry2(function uncurryN(depth, fn) {
  return curryN(depth, function() {
    var currentDepth = 1;
    var value = fn;
    var idx = 0;
    var endIdx;
    while (currentDepth <= depth && typeof value === 'function') {
      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
      currentDepth += 1;
      idx = endIdx;
    }
    return value;
  });
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      var f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */
module.exports = _curry2(function unfold(fn, seed) {
  var pair = fn(seed);
  var result = [];
  while (pair && pair.length) {
    result[result.length] = pair[0];
    pair = fn(pair[1]);
  }
  return result;
});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry2 = __webpack_require__(1);
var compose = __webpack_require__(101);
var uniq = __webpack_require__(111);


/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */
module.exports = _curry2(compose(uniq, _concat));


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(21);
var _curry3 = __webpack_require__(5);
var uniqWith = __webpack_require__(112);


/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> a -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      var l1 = [{a: 1}, {a: 2}];
 *      var l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */
module.exports = _curry3(function unionWith(pred, list1, list2) {
  return uniqWith(pred, _concat(list1, list2));
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */
module.exports = _curry3(function unless(pred, whenFalseFn, x) {
  return pred(x) ? x : whenFalseFn(x);
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var _identity = __webpack_require__(110);
var chain = __webpack_require__(99);


/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */
module.exports = chain(_identity);


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */
module.exports = _curry3(function until(pred, fn, init) {
  var val = init;
  while (!pred(val)) {
    val = fn(val);
  }
  return val;
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(4);


/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */
module.exports = _curry1(function valuesIn(obj) {
  var prop;
  var vs = [];
  for (prop in obj) {
    vs[vs.length] = obj[prop];
  }
  return vs;
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */
module.exports = (function() {
  // `Const` is a functor that effectively ignores the function given to `map`.
  var Const = function(x) {
    return {value: x, 'fantasy-land/map': function() { return this; }};
  };

  return _curry2(function view(lens, x) {
    // Using `Const` effectively ignores the setter function of the `lens`,
    // leaving the value returned by the getter function unmodified.
    return lens(Const)(x).value;
  });
}());


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless
 * @example
 *
 *      // truncate :: String -> String
 *      var truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */
module.exports = _curry3(function when(pred, whenTrueFn, x) {
  return pred(x) ? whenTrueFn(x) : x;
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);
var equals = __webpack_require__(19);
var map = __webpack_require__(16);
var where = __webpack_require__(201);


/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      var pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */
module.exports = _curry2(function whereEq(spec, testObj) {
  return where(map(equals, spec), testObj);
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(46);
var _curry2 = __webpack_require__(1);
var flip = __webpack_require__(84);
var reject = __webpack_require__(81);


/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */
module.exports = _curry2(function(xs, list) {
  return reject(flip(_contains)(xs), list);
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */
module.exports = _curry2(function xprod(a, b) { // = xprodWith(prepend); (takes about 3 times as long...)
  var idx = 0;
  var ilen = a.length;
  var j;
  var jlen = b.length;
  var result = [];
  while (idx < ilen) {
    j = 0;
    while (j < jlen) {
      result[result.length] = [a[idx], b[j]];
      j += 1;
    }
    idx += 1;
  }
  return result;
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */
module.exports = _curry2(function zip(a, b) {
  var rv = [];
  var idx = 0;
  var len = Math.min(a.length, b.length);
  while (idx < len) {
    rv[idx] = [a[idx], b[idx]];
    idx += 1;
  }
  return rv;
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(1);


/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zipWith(pair), fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */
module.exports = _curry2(function zipObj(keys, values) {
  var idx = 0;
  var len = Math.min(keys.length, values.length);
  var out = {};
  while (idx < len) {
    out[keys[idx]] = values[idx];
    idx += 1;
  }
  return out;
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(5);


/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a,b -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      var f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */
module.exports = _curry3(function zipWith(fn, a, b) {
  var rv = [];
  var idx = 0;
  var len = Math.min(a.length, b.length);
  while (idx < len) {
    rv[idx] = fn(a[idx], b[idx]);
    idx += 1;
  }
  return rv;
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var rateSetNamesMapAccommo = exports.rateSetNamesMapAccommo = {
  'Nightly': 'ie DBLNIGHTLY',
  'Nightly: Midweek': 'ie DBLMIDWEEK1NT',
  'Nightly: Weekend': 'ie DBLWKEND1NT',
  'Minimum Night Stay': 'ie DBLNEWYEARS',
  'Extended Stay': 'ie DBLEXT5NT',
  'Special Event': 'ie DBLFORMULA1',
  'Stay Pay': 'ie DBLSTAYPAY3-4',
  'Bed & Breakfast': '',
  'Bed & Breakfast: Midweek': '',
  'Bed & Breakfast: Weekend': '',
  'Package': 'ie DBLSPAPKG',
  'Group': 'ie DBLGROUP',
  'Indicative': ''
};

var rateSetNamesMapNonAccommo = exports.rateSetNamesMapNonAccommo = {
  'Private/Custom': 'ie PVTCRS2HR',
  'Depart/Entry: Morning': 'ie AMCRS2HR',
  'Depart/Entry: Afternoon': 'ie NOONCRS1HR',
  'Depart/Entry: Evening': 'ie EVECRS2HR',
  'Depart/Entry: Night': 'ie PMCRS2HR',
  'Special Event': 'ie NYECRUISE',
  'Foreign Language': 'ie SPANISH',
  'Indicative': ''
};

var seasonColors = exports.seasonColors = ['#d81b60', '#8e24aa', '#3949ab', '#00897b', '#00600f', '#f57f17', '#3e2723'];

var extraNameAndCode = exports.extraNameAndCode = {
  'Car Hire': 'ie WKENDHIRE',
  'Day Tour/Activity': 'ie BICYCLEHIRE',
  'Diving: Certified Dive': '',
  'Diving: Intro Dive': '',
  'Diving: Helmet Dive': '',
  'Diving: Equipment Hire': '',
  'Extra Night: Double': 'ie EXNIGHTDBL',
  'Extra Night: Quad': 'ie EXNIGHTQUAD',
  'Extra Night: Room': 'ie EXNIGHTDBL',
  'Extra Night: Single': 'ie EXNIGHTSGL',
  'Extra Night: Triple': 'ie EXNIGHTTRPL',
  'Extra Night: Twin': 'ie EXNIGHTTWIN',
  'Meal: Breakfast - A La Carte': '',
  'Meal: Breakfast - American': '',
  'Meal: Breakfast - Buffet': '',
  'Meal: Breakfast - Continental': '',
  'Meal: Breakfast - Full': '',
  'Meal: Breakfast': 'ie CONTINENTAL',
  'Meal: Lunch - A La Carte': '',
  'Meal: Lunch - Buffet': '',
  'Meal: Lunch - BBQ': '',
  'Meal: Lunch - Two Course': '',
  'Meal: Lunch - Three Course': '',
  'Meal: Lunch': 'ie PICNICLUNCH',
  'Meal: Dinner - A La Carte': '',
  'Meal: Dinner - Buffet': '',
  'Meal: Dinner - BBQ': '',
  'Meal: Dinner - Two Course': '',
  'Meal: Dinner - Three Course': '',
  'Meal: Dinner': 'ie ALACARTE',
  'Meal: Full Board': 'ie FULLBOARD',
  'Meal: Half Board': 'ie HALFBOARD',
  'Meal: Package': 'ie SUNDAYROAST',
  'Miscellaneous': 'ie WIFI',
  'Porterage: One Way': '',
  'Porterage: Return': '',
  'Surcharge: Additional Bedding': 'ie ROLLAWAY',
  'Surcharge: Baby Seat': '',
  'Surcharge: Entry': '',
  'Surcharge: Equipment Hire': '',
  'Surcharge: Extra Hour(s)': '',
  'Surcharge: Extra Pax': 'ie EXTRAADULT',
  'Surcharge: Family Rate': '',
  'Surcharge: Foreign Language': 'ie SPANISH',
  'Surcharge: Fuel': 'ie TANKREFILL',
  'Surcharge: General Sundry': 'ie BEACHGEAR',
  'Surcharge: Insurance': 'ie CANCELLATION',
  'Surcharge: Internet': 'ie INTERNET',
  'Surcharge: Park Fee': 'ie NTLPARKSFEE',
  'Surcharge: Parking': 'ie CARPARK',
  'Surcharge: Private Guide': '',
  'Surcharge: Refresh Service': 'ie DAILYSERVICE',
  'Surcharge: Tax': 'ie STATETAX',
  'Surcharge: Other': '',
  'Transfer: One Way': 'ie ONEWAY',
  'Transfer: Return': 'ie RETURN',
  'Transfer: Baby Seat': '',
  'Upgrade: Room': 'ie UPGRADE',
  'Upgrade: Package': 'ie SPAPACKAGE',
  'Upgrade: Person': ''
};

var seasonNamesMap = exports.seasonNamesMap = {
  'All Year': [],
  'Standard': [],
  'Premium': [],
  'Peak/High Season': [],
  'Mid/Shoulder Season': [],
  'Off-Peak/Low Season': [],
  'Special Event': [],
  'Summer': [],
  'Winter': [],
  'Spring': [],
  'Fall/Autumn': [],
  'Christmas Holidays': [],
  'Easter Holidays': [],
  'New Years Holidays': [],
  'Chinese/Lunar New Years Holidays': [],
  'January': [],
  'February': [],
  'March': [],
  'April': [],
  'May': [],
  'June': [],
  'July': [],
  'August': [],
  'September': [],
  'October': [],
  'November': [],
  'December': [],
  '1st Quarter: January - March': [],
  '2nd Quarter: April - June': [],
  '3rd Quarter: July - September': [],
  '4th Quarter: October - December': [],
  'Not Operating': [],
  'Dynamic Rates': []
};

var standardNonAccomDescrs = exports.standardNonAccomDescrs = ['Adult', 'Child', 'Infant', 'Family', 'Senior/Concession', 'Student', 'General'];

var multiDayTourDescrs = exports.multiDayTourDescrs = ['Single', 'Twin (Share)', 'Twin (Private)', 'Double', 'Triple', 'Quad', 'Single Supplement', 'Extra Adult', 'Extra Child', 'Extra Child (Quad Share)', 'Extra Infant'];

var standardAccomDescr = exports.standardAccomDescr = ['Single', 'Twin', 'Double', 'Triple', 'Quad', 'Extra Adult', 'Extra Child', 'Extra Infant'];
// multi day tour is per person rate
var multiDayToursMaxAdultOne = exports.multiDayToursMaxAdultOne = ['Single', 'Twin (Share)', 'Twin (Private)', 'Double', 'Triple', 'Quad', 'Extra Adult'];

var multiDayToursMaxChildOne = exports.multiDayToursMaxChildOne = ['Extra Child'];

var policyNotesSections = exports.policyNotesSections = {
  submissionCriteria: 'Notes',
  termsAndConditions: 'Terms & Condition',
  marketInfo: 'Market Information',
  cancellation: 'Cancellation Policy',
  child: 'Child Policy',
  infant: 'Infant Policy',
  group: 'Group Policy',
  freeOfCharge: 'Free of Charge Policy',
  family: 'Family Policy',
  checkinout: 'Check-in and Check-out Policy',
  billingInfo: 'Billing Information',
  insuranceInfo: 'Insurance Information'
};

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(115);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(467);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(474);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(205);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(205);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(206);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(475);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(115);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markAcceptedRead = exports.addFilesToContract = exports.deleteMessage = exports.changeSelection = exports.removeConnectionFromStatus = exports.getStatusMessages = exports.markReadWithParams = exports.markRead = exports.getConversations = exports.selectContract = exports.sendMessage = exports.archiveConversation = exports.resetConversations = exports.resetChannels = exports.selectChannel = exports.getChannels = exports.archiveConnection = exports.selectConnection = exports.getConnections = undefined;

var _constants = __webpack_require__(233);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getConnections = exports.getConnections = function getConnections() {
  return { type: cnt.CONNECTIONS_FETCH };
};
var selectConnection = exports.selectConnection = function selectConnection(connection) {
  return { type: cnt.CONNECTIONS_SELECT, payload: connection };
};
var archiveConnection = exports.archiveConnection = function archiveConnection(connection) {
  return { type: cnt.CONNECTIONS_ARCHIVE, payload: connection };
};
var getChannels = exports.getChannels = function getChannels(payload) {
  return { type: cnt.CHANNELS_FETCH, payload: payload };
};
var selectChannel = exports.selectChannel = function selectChannel(channel) {
  return { type: cnt.CHANNELS_SELECT, payload: channel };
};
var resetChannels = exports.resetChannels = function resetChannels(channel) {
  return { type: cnt.CHANNELS_RESET, payload: channel };
};
var resetConversations = exports.resetConversations = function resetConversations(channel) {
  return { type: cnt.CONVERSATIONS_RESET, payload: channel };
};
var archiveConversation = exports.archiveConversation = function archiveConversation(channel, contract) {
  return { type: cnt.CHANNELS_ARCHIVE, payload: { channel: channel, contract: contract } };
};
var sendMessage = exports.sendMessage = function sendMessage(message) {
  return { type: cnt.MESSAGE_CREATE, payload: message };
};
var selectContract = exports.selectContract = function selectContract(contractId) {
  return { type: cnt.CONTRACT_SELECT, payload: contractId };
};
var getConversations = exports.getConversations = function getConversations() {
  return { type: cnt.CONVERSATIONS_FETCH };
};
var markRead = exports.markRead = function markRead() {
  return { type: cnt.CONVERSATIONS_READ };
};
var markReadWithParams = exports.markReadWithParams = function markReadWithParams(payload) {
  return { type: cnt.CONVERSATIONS_READ_WITH_PARAMS, payload: payload };
};
var getStatusMessages = exports.getStatusMessages = function getStatusMessages() {
  return { type: cnt.STATUS_MESSAGES };
};
var removeConnectionFromStatus = exports.removeConnectionFromStatus = function removeConnectionFromStatus(payload) {
  return { type: cnt.STATUS_MESSAGES_REMOVE_CONNECTION, payload: payload };
};
var changeSelection = exports.changeSelection = function changeSelection(connection, channel) {
  return { type: cnt.CHANGE_SELECTION, payload: { connection: connection, channel: channel } };
};
var deleteMessage = exports.deleteMessage = function deleteMessage(message) {
  return { type: cnt.MESSAGE_DELETE, payload: message };
};
var addFilesToContract = exports.addFilesToContract = function addFilesToContract(message) {
  return { type: cnt.MESSAGE_ADD_FILES_TO_CONTRACT, payload: message };
};
var markAcceptedRead = exports.markAcceptedRead = function markAcceptedRead(payload) {
  return { type: cnt.STATUS_CONNECTIONS_MARK_READ, payload: payload };
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getMuiTheme = __webpack_require__(628);

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

var _colors = __webpack_require__(259);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var muiTheme = (0, _getMuiTheme2.default)({
  fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  palette: {
    textColor: 'rgba(0, 0, 0, 0.84)'
  },
  raisedButton: {
    primaryColor: _colors.pinkA200,
    secondaryColor: _colors.cyan500
  },
  flatButton: {
    primaryTextColor: _colors.pinkA200,
    secondaryTextColor: _colors.cyan500
  }
});

exports.default = muiTheme;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(479)();
// imports


// module
exports.push([module.i, "@font-face {\n  font-family: 'TourConnect-Icons';\n  src: url(" + __webpack_require__(207) + ");\n  src: url(" + __webpack_require__(207) + "#iefix) format('embedded-opentype'), url(" + __webpack_require__(480) + ") format('truetype'), url(" + __webpack_require__(481) + ") format('woff'), url(" + __webpack_require__(482) + "#TourConnect-Icons) format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=\"tc-icon-\"],\n[class*=\" tc-icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'TourConnect-Icons' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.tc-icon-newspaper:before {\n  content: \"\\E91A\";\n}\n.tc-icon-move-up:before {\n  content: \"\\EA46\";\n}\n.tc-icon-move-down:before {\n  content: \"\\EA47\";\n}\n.tc-icon-filter:before {\n  content: \"\\EA5B\";\n}\n.tc-icon-star-empty:before {\n  content: \"\\E9D7\";\n}\n.tc-icon-star-half:before {\n  content: \"\\E9D8\";\n}\n.tc-icon-cursor-default-outline:before {\n  content: \"\\E919\";\n}\n.tc-icon-email-open:before {\n  content: \"\\E910\";\n}\n.tc-icon-email-alert:before {\n  content: \"\\E914\";\n}\n.tc-icon-email-open-outline:before {\n  content: \"\\E915\";\n}\n.tc-icon-email-outline:before {\n  content: \"\\E918\";\n}\n.tc-icon-send-plus:before {\n  content: \"\\E90F\";\n}\n.tc-icon-marketing-materials:before {\n  content: \"\\E906\";\n}\n.tc-icon-partner-finder:before {\n  content: \"\\E90A\";\n}\n.tc-icon-exchange-rates:before {\n  content: \"\\E90B\";\n}\n.tc-icon-bulb:before {\n  content: \"\\E907\";\n}\n.tc-icon-paperplane:before {\n  content: \"\\E616\";\n}\n.tc-icon-amex:before {\n  content: \"\\E901\";\n  color: #2e77bc;\n}\n.tc-icon-discover:before {\n  content: \"\\E903\";\n  color: #ff6000;\n}\n.tc-icon-mastercard:before {\n  content: \"\\E902\";\n  color: #eb001b;\n}\n.tc-icon-paypal:before {\n  content: \"\\E905\";\n  color: #00457c;\n}\n.tc-icon-visa:before {\n  content: \"\\E904\";\n  color: #142787;\n}\n.tc-icon-swap_vert:before {\n  content: \"\\E8D5\";\n}\n.tc-icon-lock:before {\n  content: \"\\E908\";\n}\n.tc-icon-folder_open:before {\n  content: \"\\E909\";\n}\n.tc-icon-restore:before {\n  content: \"\\E8B3\";\n}\n.tc-icon-create_new_folder:before {\n  content: \"\\E2CC\";\n}\n.tc-icon-inbox:before {\n  content: \"\\E156\";\n}\n.tc-icon-av_timer:before {\n  content: \"\\E01B\";\n}\n.tc-icon-email:before {\n  content: \"\\E0BE\";\n}\n.tc-icon-archive2:before {\n  content: \"\\E149\";\n}\n.tc-icon-content_copy:before {\n  content: \"\\E14D\";\n}\n.tc-icon-move_to_inbox:before {\n  content: \"\\E168\";\n}\n.tc-icon-attach_file:before {\n  content: \"\\E226\";\n}\n.tc-icon-picture_as_pdf:before {\n  content: \"\\E415\";\n}\n.tc-icon-assignment_turned_in:before {\n  content: \"\\E862\";\n}\n.tc-icon-change_history:before {\n  content: \"\\E86B\";\n}\n.tc-icon-chrome_reader_mode:before {\n  content: \"\\E86D\";\n}\n.tc-icon-language:before {\n  content: \"\\E894\";\n}\n.tc-icon-question_answer:before {\n  content: \"\\E8AF\";\n}\n.tc-icon-receipt:before {\n  content: \"\\E8B0\";\n}\n.tc-icon-thumb_down:before {\n  content: \"\\E8DB\";\n}\n.tc-icon-thumb_up:before {\n  content: \"\\E8DC\";\n}\n.tc-icon-location_on:before {\n  content: \"\\E900\";\n}\n.tc-icon-info:before {\n  content: \"\\E2A2\";\n}\n.tc-icon-hotel:before {\n  content: \"\\E1D2\";\n}\n.tc-icon-add:before {\n  content: \"\\E614\";\n}\n.tc-icon-menu:before {\n  content: \"\\E613\";\n}\n.tc-icon-check:before {\n  content: \"\\E612\";\n}\n.tc-icon-chevron-left:before {\n  content: \"\\E60E\";\n}\n.tc-icon-chevron-right:before {\n  content: \"\\E60F\";\n}\n.tc-icon-archive:before {\n  content: \"\\E60A\";\n}\n.tc-icon-perm-contact-cal:before {\n  content: \"\\E60B\";\n}\n.tc-icon-cloud-download:before {\n  content: \"\\E60C\";\n}\n.tc-icon-more-vert:before {\n  content: \"\\E60D\";\n}\n.tc-icon-arrow-drop-up:before {\n  content: \"\\E609\";\n}\n.tc-icon-close:before {\n  content: \"\\E608\";\n}\n.tc-icon-office:before {\n  content: \"\\E600\";\n  color: #444;\n}\n.tc-icon-checkbox-marked-circle:before {\n  content: \"\\E605\";\n  color: #444;\n}\n.tc-icon-search:before {\n  content: \"\\E606\";\n  color: #444;\n}\n.tc-icon-tag:before {\n  content: \"\\E602\";\n  color: #444;\n}\n.tc-icon-users:before {\n  content: \"\\E603\";\n  color: #444;\n}\n.tc-icon-user:before {\n  content: \"\\E604\";\n  color: #444;\n}\n.tc-icon-arrow-drop-down:before {\n  content: \"\\E601\";\n  color: #444;\n}\n.tc-icon-print:before {\n  content: \"\\E617\";\n}\n.tc-icon-insert-drive-file:before {\n  content: \"\\E615\";\n}\n.tc-icon-local-phone:before {\n  content: \"\\E618\";\n}\n.tc-icon-ticket:before {\n  content: \"\\E62A\";\n}\n.tc-icon-briefcase:before {\n  content: \"\\E628\";\n}\n.tc-icon-earth:before {\n  content: \"\\E629\";\n}\n.tc-icon-flag:before {\n  content: \"\\E62B\";\n}\n.tc-icon-remove_red_eye:before {\n  content: \"\\E417\";\n}\n.tc-icon-date_range:before {\n  content: \"\\E916\";\n}\n.tc-icon-watch_later:before {\n  content: \"\\E924\";\n}\n.tc-icon-alarm:before {\n  content: \"\\E855\";\n}\n.tc-icon-access_alarms:before {\n  content: \"\\E191\";\n}\n.tc-icon-schedule:before {\n  content: \"\\E8B5\";\n}\n.tc-icon-account_balance_wallet:before {\n  content: \"\\E850\";\n}\n.tc-icon-account_box:before {\n  content: \"\\E851\";\n}\n.tc-icon-account_circle:before {\n  content: \"\\E853\";\n}\n.tc-icon-add2:before {\n  content: \"\\E145\";\n}\n.tc-icon-add_a_photo:before {\n  content: \"\\E439\";\n}\n.tc-icon-add_box:before {\n  content: \"\\E146\";\n}\n.tc-icon-add_circle:before {\n  content: \"\\E147\";\n}\n.tc-icon-control_point:before {\n  content: \"\\E3BA\";\n}\n.tc-icon-add_shopping_cart:before {\n  content: \"\\E854\";\n}\n.tc-icon-queue:before {\n  content: \"\\E03C\";\n}\n.tc-icon-add_to_queue:before {\n  content: \"\\E05C\";\n}\n.tc-icon-airplay:before {\n  content: \"\\E055\";\n}\n.tc-icon-announcement:before {\n  content: \"\\E85A\";\n}\n.tc-icon-archive3:before {\n  content: \"\\E14A\";\n}\n.tc-icon-arrow_back:before {\n  content: \"\\E5C4\";\n}\n.tc-icon-arrow_downward:before {\n  content: \"\\E5DB\";\n}\n.tc-icon-arrow_drop_down:before {\n  content: \"\\E5C5\";\n}\n.tc-icon-arrow_drop_down_circle:before {\n  content: \"\\E5C6\";\n}\n.tc-icon-arrow_drop_up:before {\n  content: \"\\E5C7\";\n}\n.tc-icon-arrow_forward:before {\n  content: \"\\E5C8\";\n}\n.tc-icon-arrow_upward:before {\n  content: \"\\E5D8\";\n}\n.tc-icon-art_track:before {\n  content: \"\\E060\";\n}\n.tc-icon-aspect_ratio:before {\n  content: \"\\E85B\";\n}\n.tc-icon-poll:before {\n  content: \"\\E805\";\n}\n.tc-icon-assignment:before {\n  content: \"\\E85D\";\n}\n.tc-icon-assistant:before {\n  content: \"\\E39F\";\n}\n.tc-icon-flag2:before {\n  content: \"\\E153\";\n}\n.tc-icon-attach_file2:before {\n  content: \"\\E227\";\n}\n.tc-icon-attach_money:before {\n  content: \"\\E228\";\n}\n.tc-icon-attachment:before {\n  content: \"\\E2BC\";\n}\n.tc-icon-autorenew:before {\n  content: \"\\E863\";\n}\n.tc-icon-av_timer2:before {\n  content: \"\\E01C\";\n}\n.tc-icon-backspace:before {\n  content: \"\\E14B\";\n}\n.tc-icon-cloud_upload:before {\n  content: \"\\E2C3\";\n}\n.tc-icon-beenhere:before {\n  content: \"\\E52D\";\n}\n.tc-icon-block:before {\n  content: \"\\E14C\";\n}\n.tc-icon-class:before {\n  content: \"\\E86E\";\n}\n.tc-icon-turned_in:before {\n  content: \"\\E8E6\";\n}\n.tc-icon-turned_in_not:before {\n  content: \"\\E8E7\";\n}\n.tc-icon-border_color:before {\n  content: \"\\E22B\";\n}\n.tc-icon-brightness_1:before {\n  content: \"\\E3A6\";\n}\n.tc-icon-build:before {\n  content: \"\\E869\";\n}\n.tc-icon-burst_mode:before {\n  content: \"\\E43C\";\n}\n.tc-icon-cached:before {\n  content: \"\\E86A\";\n}\n.tc-icon-phone:before {\n  content: \"\\E0CD\";\n}\n.tc-icon-call_end:before {\n  content: \"\\E0B1\";\n}\n.tc-icon-call_made:before {\n  content: \"\\E0B2\";\n}\n.tc-icon-call_received:before {\n  content: \"\\E0B5\";\n}\n.tc-icon-call_to_action:before {\n  content: \"\\E06C\";\n}\n.tc-icon-photo_camera:before {\n  content: \"\\E412\";\n}\n.tc-icon-camera_enhance:before {\n  content: \"\\E8FC\";\n}\n.tc-icon-cancel:before {\n  content: \"\\E5C9\";\n}\n.tc-icon-card_membership:before {\n  content: \"\\E8F7\";\n}\n.tc-icon-card_travel:before {\n  content: \"\\E8F8\";\n}\n.tc-icon-cast:before {\n  content: \"\\E307\";\n}\n.tc-icon-cast_connected:before {\n  content: \"\\E308\";\n}\n.tc-icon-center_focus_strong:before {\n  content: \"\\E3B4\";\n}\n.tc-icon-center_focus_weak:before {\n  content: \"\\E3B5\";\n}\n.tc-icon-change_history2:before {\n  content: \"\\E86C\";\n}\n.tc-icon-chat:before {\n  content: \"\\E0B7\";\n}\n.tc-icon-chat_bubble:before {\n  content: \"\\E0CA\";\n}\n.tc-icon-chat_bubble_outline:before {\n  content: \"\\E0CB\";\n}\n.tc-icon-check2:before {\n  content: \"\\E5CA\";\n}\n.tc-icon-check_box:before {\n  content: \"\\E834\";\n}\n.tc-icon-check_box_outline_blank:before {\n  content: \"\\E835\";\n}\n.tc-icon-check_circle:before {\n  content: \"\\E86F\";\n}\n.tc-icon-navigate_before:before {\n  content: \"\\E408\";\n}\n.tc-icon-navigate_next:before {\n  content: \"\\E409\";\n}\n.tc-icon-close2:before {\n  content: \"\\E5CD\";\n}\n.tc-icon-closed_caption:before {\n  content: \"\\E01D\";\n}\n.tc-icon-wb_cloudy:before {\n  content: \"\\E42D\";\n}\n.tc-icon-cloud_circle:before {\n  content: \"\\E2BE\";\n}\n.tc-icon-cloud_done:before {\n  content: \"\\E2BF\";\n}\n.tc-icon-cloud_download:before {\n  content: \"\\E2C0\";\n}\n.tc-icon-code:before {\n  content: \"\\E870\";\n}\n.tc-icon-photo_library:before {\n  content: \"\\E413\";\n}\n.tc-icon-contact_mail:before {\n  content: \"\\E0D0\";\n}\n.tc-icon-contact_phone:before {\n  content: \"\\E0CF\";\n}\n.tc-icon-content_copy2:before {\n  content: \"\\E14E\";\n}\n.tc-icon-content_cut:before {\n  content: \"\\E14F\";\n}\n.tc-icon-content_paste:before {\n  content: \"\\E150\";\n}\n.tc-icon-copyright:before {\n  content: \"\\E90C\";\n}\n.tc-icon-mode_edit:before {\n  content: \"\\E254\";\n}\n.tc-icon-create_new_folder2:before {\n  content: \"\\E2CD\";\n}\n.tc-icon-payment:before {\n  content: \"\\E8A1\";\n}\n.tc-icon-crop_original:before {\n  content: \"\\E3C4\";\n}\n.tc-icon-date_range2:before {\n  content: \"\\E917\";\n}\n.tc-icon-delete2:before {\n  content: \"\\E872\";\n}\n.tc-icon-description:before {\n  content: \"\\E873\";\n}\n.tc-icon-done:before {\n  content: \"\\E876\";\n}\n.tc-icon-drafts:before {\n  content: \"\\E151\";\n}\n.tc-icon-drag_handle:before {\n  content: \"\\E25D\";\n}\n.tc-icon-markunread:before {\n  content: \"\\E159\";\n}\n.tc-icon-error:before {\n  content: \"\\E000\";\n}\n.tc-icon-error_outline:before {\n  content: \"\\E001\";\n}\n.tc-icon-event_note:before {\n  content: \"\\E62C\";\n}\n.tc-icon-expand_less:before {\n  content: \"\\E5CE\";\n}\n.tc-icon-expand_more:before {\n  content: \"\\E5CF\";\n}\n.tc-icon-fast_forward:before {\n  content: \"\\E01F\";\n}\n.tc-icon-fast_rewind:before {\n  content: \"\\E020\";\n}\n.tc-icon-featured_play_list:before {\n  content: \"\\E06D\";\n}\n.tc-icon-sms_failed:before {\n  content: \"\\E62D\";\n}\n.tc-icon-fiber_manual_record:before {\n  content: \"\\E061\";\n}\n.tc-icon-fiber_pin:before {\n  content: \"\\E06A\";\n}\n.tc-icon-get_app:before {\n  content: \"\\E884\";\n}\n.tc-icon-file_upload:before {\n  content: \"\\E2C6\";\n}\n.tc-icon-filter2:before {\n  content: \"\\E3D3\";\n}\n.tc-icon-format_shapes:before {\n  content: \"\\E25E\";\n}\n.tc-icon-question_answer2:before {\n  content: \"\\E8B1\";\n}\n.tc-icon-forward:before {\n  content: \"\\E154\";\n}\n.tc-icon-star:before {\n  content: \"\\E838\";\n}\n.tc-icon-people:before {\n  content: \"\\E7FB\";\n}\n.tc-icon-group_add:before {\n  content: \"\\E7F0\";\n}\n.tc-icon-help:before {\n  content: \"\\E887\";\n}\n.tc-icon-help_outline:before {\n  content: \"\\E8FD\";\n}\n.tc-icon-highlight_off:before {\n  content: \"\\E888\";\n}\n.tc-icon-restore2:before {\n  content: \"\\E8B4\";\n}\n.tc-icon-home:before {\n  content: \"\\E88A\";\n}\n.tc-icon-local_hotel:before {\n  content: \"\\E549\";\n}\n.tc-icon-photo:before {\n  content: \"\\E410\";\n}\n.tc-icon-indeterminate_check_box:before {\n  content: \"\\E90D\";\n}\n.tc-icon-info2:before {\n  content: \"\\E88E\";\n}\n.tc-icon-info_outline:before {\n  content: \"\\E88F\";\n}\n.tc-icon-insert_drive_file:before {\n  content: \"\\E24D\";\n}\n.tc-icon-keyboard_arrow_down:before {\n  content: \"\\E313\";\n}\n.tc-icon-keyboard_arrow_left:before {\n  content: \"\\E314\";\n}\n.tc-icon-keyboard_arrow_right:before {\n  content: \"\\E315\";\n}\n.tc-icon-keyboard_arrow_up:before {\n  content: \"\\E316\";\n}\n.tc-icon-keyboard_backspace:before {\n  content: \"\\E317\";\n}\n.tc-icon-language2:before {\n  content: \"\\E895\";\n}\n.tc-icon-last_page:before {\n  content: \"\\E5DD\";\n}\n.tc-icon-linked_camera:before {\n  content: \"\\E438\";\n}\n.tc-icon-restaurant_menu:before {\n  content: \"\\E561\";\n}\n.tc-icon-print2:before {\n  content: \"\\E8AD\";\n}\n.tc-icon-sync:before {\n  content: \"\\E62E\";\n}\n.tc-icon-mail_outline:before {\n  content: \"\\E0E1\";\n}\n.tc-icon-message:before {\n  content: \"\\E0C9\";\n}\n.tc-icon-mms:before {\n  content: \"\\E62F\";\n}\n.tc-icon-mode_comment:before {\n  content: \"\\E253\";\n}\n.tc-icon-monetization_on:before {\n  content: \"\\E263\";\n}\n.tc-icon-money_off:before {\n  content: \"\\E25C\";\n}\n.tc-icon-more_horiz:before {\n  content: \"\\E5D3\";\n}\n.tc-icon-more_vert:before {\n  content: \"\\E5D4\";\n}\n.tc-icon-near_me:before {\n  content: \"\\E569\";\n}\n.tc-icon-signal_cellular_no_sim:before {\n  content: \"\\E1CE\";\n}\n.tc-icon-note_add:before {\n  content: \"\\E89C\";\n}\n.tc-icon-notifications:before {\n  content: \"\\E7F4\";\n}\n.tc-icon-pan_tool:before {\n  content: \"\\E925\";\n}\n.tc-icon-panorama:before {\n  content: \"\\E40B\";\n}\n.tc-icon-radio_button_unchecked:before {\n  content: \"\\E836\";\n}\n.tc-icon-pause:before {\n  content: \"\\E034\";\n}\n.tc-icon-pause_circle_filled:before {\n  content: \"\\E035\";\n}\n.tc-icon-pause_circle_outline:before {\n  content: \"\\E036\";\n}\n.tc-icon-perm_media:before {\n  content: \"\\E8A7\";\n}\n.tc-icon-person:before {\n  content: \"\\E7FD\";\n}\n.tc-icon-person_add:before {\n  content: \"\\E7FE\";\n}\n.tc-icon-photo_size_select_actual:before {\n  content: \"\\E432\";\n}\n.tc-icon-play_arrow:before {\n  content: \"\\E037\";\n}\n.tc-icon-play_circle_filled:before {\n  content: \"\\E038\";\n}\n.tc-icon-play_circle_outline:before {\n  content: \"\\E039\";\n}\n.tc-icon-portrait:before {\n  content: \"\\E416\";\n}\n.tc-icon-priority_high:before {\n  content: \"\\E645\";\n}\n.tc-icon-remove_shopping_cart:before {\n  content: \"\\E928\";\n}\n.tc-icon-report:before {\n  content: \"\\E160\";\n}\n.tc-icon-warning2:before {\n  content: \"\\E002\";\n}\n.tc-icon-security:before {\n  content: \"\\E32A\";\n}\n.tc-icon-sentiment_dissatisfied:before {\n  content: \"\\E811\";\n}\n.tc-icon-sentiment_neutral:before {\n  content: \"\\E812\";\n}\n.tc-icon-sentiment_satisfied:before {\n  content: \"\\E813\";\n}\n.tc-icon-sentiment_very_dissatisfied:before {\n  content: \"\\E814\";\n}\n.tc-icon-sentiment_very_satisfied:before {\n  content: \"\\E815\";\n}\n.tc-icon-shopping_basket:before {\n  content: \"\\E8CB\";\n}\n.tc-icon-skip_next:before {\n  content: \"\\E044\";\n}\n.tc-icon-skip_previous:before {\n  content: \"\\E045\";\n}\n.tc-icon-slideshow:before {\n  content: \"\\E41B\";\n}\n.tc-icon-swap_calls:before {\n  content: \"\\E0D7\";\n}\n.tc-icon-swap_horiz:before {\n  content: \"\\E8D4\";\n}\n.tc-icon-swap_vert2:before {\n  content: \"\\E8D6\";\n}\n.tc-icon-swap_vertical_circle:before {\n  content: \"\\E8D7\";\n}\n.tc-icon-thumb_down2:before {\n  content: \"\\E8DD\";\n}\n.tc-icon-thumb_up2:before {\n  content: \"\\E8DE\";\n}\n.tc-icon-toc:before {\n  content: \"\\E8DF\";\n}\n.tc-icon-trending_down:before {\n  content: \"\\E8E3\";\n}\n.tc-icon-trending_flat:before {\n  content: \"\\E8E4\";\n}\n.tc-icon-trending_up:before {\n  content: \"\\E8E5\";\n}\n.tc-icon-update:before {\n  content: \"\\E923\";\n}\n.tc-icon-verified_user:before {\n  content: \"\\E8E8\";\n}\n.tc-icon-vertical_align_bottom:before {\n  content: \"\\E258\";\n}\n.tc-icon-vertical_align_center:before {\n  content: \"\\E259\";\n}\n.tc-icon-vertical_align_top:before {\n  content: \"\\E25A\";\n}\n.tc-icon-video_library:before {\n  content: \"\\E04A\";\n}\n.tc-icon-wallpaper:before {\n  content: \"\\E1BC\";\n}\n.tc-icon-watch_later2:before {\n  content: \"\\E926\";\n}\n.tc-icon-weekend:before {\n  content: \"\\E16B\";\n}\n.tc-icon-zoom_in:before {\n  content: \"\\E8FF\";\n}\n.tc-icon-zoom_out:before {\n  content: \"\\E90E\";\n}\n.tc-icon-zoom_out_map:before {\n  content: \"\\E56B\";\n}\n.tc-icon-alarm2:before {\n  content: \"\\E856\";\n}\n.tc-icon-access_alarms2:before {\n  content: \"\\E192\";\n}\n.tc-icon-schedule2:before {\n  content: \"\\E8B6\";\n}\n.tc-icon-account_box2:before {\n  content: \"\\E852\";\n}\n.tc-icon-add22:before {\n  content: \"\\E157\";\n}\n.tc-icon-add_a_photo2:before {\n  content: \"\\E43B\";\n}\n.tc-icon-add_box2:before {\n  content: \"\\E158\";\n}\n.tc-icon-add_circle2:before {\n  content: \"\\E148\";\n}\n.tc-icon-control_point2:before {\n  content: \"\\E3BB\";\n}\n.tc-icon-adjust:before {\n  content: \"\\E39E\";\n}\n.tc-icon-alarm_on:before {\n  content: \"\\E858\";\n}\n.tc-icon-announcement2:before {\n  content: \"\\E85C\";\n}\n.tc-icon-arrow_back2:before {\n  content: \"\\E5D1\";\n}\n.tc-icon-arrow_downward2:before {\n  content: \"\\E5DF\";\n}\n.tc-icon-arrow_drop_down2:before {\n  content: \"\\E5D2\";\n}\n.tc-icon-arrow_drop_down_circle2:before {\n  content: \"\\E5D7\";\n}\n.tc-icon-arrow_drop_up2:before {\n  content: \"\\E5E0\";\n}\n.tc-icon-arrow_forward2:before {\n  content: \"\\E5E1\";\n}\n.tc-icon-arrow_upward2:before {\n  content: \"\\E5DC\";\n}\n.tc-icon-assignment_late:before {\n  content: \"\\E85F\";\n}\n.tc-icon-assignment_turned_in2:before {\n  content: \"\\E865\";\n}\n.tc-icon-attach_file22:before {\n  content: \"\\E229\";\n}\n.tc-icon-autorenew2:before {\n  content: \"\\E864\";\n}\n.tc-icon-backspace2:before {\n  content: \"\\E152\";\n}\n.tc-icon-beenhere2:before {\n  content: \"\\E52E\";\n}\n.tc-icon-border_color2:before {\n  content: \"\\E22C\";\n}\n.tc-icon-brightness_12:before {\n  content: \"\\E3A7\";\n}\n.tc-icon-build2:before {\n  content: \"\\E87A\";\n}\n.tc-icon-cached2:before {\n  content: \"\\E879\";\n}\n.tc-icon-phone2:before {\n  content: \"\\E0D2\";\n}\n.tc-icon-call_end2:before {\n  content: \"\\E0B4\";\n}\n.tc-icon-call_made2:before {\n  content: \"\\E0B3\";\n}\n.tc-icon-merge_type:before {\n  content: \"\\E252\";\n}\n.tc-icon-call_missed:before {\n  content: \"\\E0B9\";\n}\n.tc-icon-call_missed_outgoing:before {\n  content: \"\\E0E4\";\n}\n.tc-icon-call_received2:before {\n  content: \"\\E0B6\";\n}\n.tc-icon-call_split:before {\n  content: \"\\E0BA\";\n}\n.tc-icon-photo_camera2:before {\n  content: \"\\E414\";\n}\n.tc-icon-cancel2:before {\n  content: \"\\E5CC\";\n}\n.tc-icon-center_focus_strong2:before {\n  content: \"\\E3B6\";\n}\n.tc-icon-change_history22:before {\n  content: \"\\E875\";\n}\n.tc-icon-chat2:before {\n  content: \"\\E0B8\";\n}\n.tc-icon-chat_bubble2:before {\n  content: \"\\E0D1\";\n}\n.tc-icon-chat_bubble_outline2:before {\n  content: \"\\E0CE\";\n}\n.tc-icon-check22:before {\n  content: \"\\E5CB\";\n}\n.tc-icon-check_box2:before {\n  content: \"\\E83B\";\n}\n.tc-icon-check_box_outline_blank2:before {\n  content: \"\\E83A\";\n}\n.tc-icon-check_circle2:before {\n  content: \"\\E871\";\n}\n.tc-icon-navigate_before2:before {\n  content: \"\\E40D\";\n}\n.tc-icon-navigate_next2:before {\n  content: \"\\E40A\";\n}\n.tc-icon-close22:before {\n  content: \"\\E5D0\";\n}\n.tc-icon-copyright2:before {\n  content: \"\\E913\";\n}\n.tc-icon-delete_forever:before {\n  content: \"\\E92B\";\n}\n.tc-icon-do_not_disturb_off:before {\n  content: \"\\E643\";\n}\n.tc-icon-remove_circle:before {\n  content: \"\\E15C\";\n}\n.tc-icon-done2:before {\n  content: \"\\E877\";\n}\n.tc-icon-done_all:before {\n  content: \"\\E878\";\n}\n.tc-icon-drafts2:before {\n  content: \"\\E155\";\n}\n.tc-icon-markunread2:before {\n  content: \"\\E15A\";\n}\n.tc-icon-error2:before {\n  content: \"\\E005\";\n}\n.tc-icon-error_outline2:before {\n  content: \"\\E004\";\n}\n.tc-icon-event_available:before {\n  content: \"\\E630\";\n}\n.tc-icon-event_busy:before {\n  content: \"\\E631\";\n}\n.tc-icon-fast_forward2:before {\n  content: \"\\E022\";\n}\n.tc-icon-fast_rewind2:before {\n  content: \"\\E021\";\n}\n.tc-icon-favorite:before {\n  content: \"\\E87D\";\n}\n.tc-icon-favorite_border:before {\n  content: \"\\E87E\";\n}\n.tc-icon-fiber_manual_record2:before {\n  content: \"\\E062\";\n}\n.tc-icon-format_shapes2:before {\n  content: \"\\E261\";\n}\n.tc-icon-fullscreen:before {\n  content: \"\\E5E4\";\n}\n.tc-icon-fullscreen_exit:before {\n  content: \"\\E5E5\";\n}\n.tc-icon-people2:before {\n  content: \"\\E7FC\";\n}\n.tc-icon-group_add2:before {\n  content: \"\\E7F1\";\n}\n.tc-icon-home2:before {\n  content: \"\\E88B\";\n}\n.tc-icon-local_hotel2:before {\n  content: \"\\E54A\";\n}\n.tc-icon-hourglass_empty:before {\n  content: \"\\E88C\";\n}\n.tc-icon-hourglass_full:before {\n  content: \"\\E88D\";\n}\n.tc-icon-tag_faces:before {\n  content: \"\\E420\";\n}\n.tc-icon-keyboard_arrow_down2:before {\n  content: \"\\E31C\";\n}\n.tc-icon-keyboard_arrow_left2:before {\n  content: \"\\E31B\";\n}\n.tc-icon-keyboard_arrow_right2:before {\n  content: \"\\E31A\";\n}\n.tc-icon-keyboard_arrow_up2:before {\n  content: \"\\E319\";\n}\n.tc-icon-keyboard_backspace2:before {\n  content: \"\\E318\";\n}\n.tc-icon-keyboard_capslock:before {\n  content: \"\\E31D\";\n}\n.tc-icon-keyboard_return:before {\n  content: \"\\E31E\";\n}\n.tc-icon-keyboard_tab:before {\n  content: \"\\E31F\";\n}\n.tc-icon-last_page2:before {\n  content: \"\\E5DE\";\n}\n.tc-icon-lens:before {\n  content: \"\\E3FA\";\n}\n.tc-icon-linked_camera2:before {\n  content: \"\\E43A\";\n}\n.tc-icon-local_airport:before {\n  content: \"\\E53D\";\n}\n.tc-icon-shopping_cart:before {\n  content: \"\\E8CC\";\n}\n.tc-icon-location_off:before {\n  content: \"\\E0C7\";\n}\n.tc-icon-room:before {\n  content: \"\\E8B7\";\n}\n.tc-icon-message2:before {\n  content: \"\\E0CC\";\n}\n.tc-icon-more_horiz2:before {\n  content: \"\\E5D5\";\n}\n.tc-icon-more_vert2:before {\n  content: \"\\E5D6\";\n}\n.tc-icon-new_releases:before {\n  content: \"\\E031\";\n}\n.tc-icon-notifications_active:before {\n  content: \"\\E7F7\";\n}\n.tc-icon-panorama2:before {\n  content: \"\\E40C\";\n}\n.tc-icon-radio_button_unchecked2:before {\n  content: \"\\E837\";\n}\n.tc-icon-person_outline:before {\n  content: \"\\E807\";\n}\n.tc-icon-perm_media2:before {\n  content: \"\\E8A8\";\n}\n.tc-icon-person2:before {\n  content: \"\\E7FF\";\n}\n.tc-icon-person_add2:before {\n  content: \"\\E806\";\n}\n.tc-icon-person_pin:before {\n  content: \"\\E55A\";\n}\n.tc-icon-person_pin_circle:before {\n  content: \"\\E56A\";\n}\n.tc-icon-photo_size_select_actual2:before {\n  content: \"\\E433\";\n}\n.tc-icon-play_arrow2:before {\n  content: \"\\E03D\";\n}\n.tc-icon-play_circle_filled2:before {\n  content: \"\\E03B\";\n}\n.tc-icon-play_circle_outline2:before {\n  content: \"\\E03A\";\n}\n.tc-icon-priority_high2:before {\n  content: \"\\E646\";\n}\n.tc-icon-report2:before {\n  content: \"\\E161\";\n}\n.tc-icon-warning22:before {\n  content: \"\\E003\";\n}\n.tc-icon-cog:before {\n  content: \"\\E8B8\";\n}\n.tc-icon-subdirectory_arrow_left:before {\n  content: \"\\E5D9\";\n}\n.tc-icon-subdirectory_arrow_right:before {\n  content: \"\\E5DA\";\n}\n.tc-icon-subscriptions:before {\n  content: \"\\E064\";\n}\n.tc-icon-thumb_down22:before {\n  content: \"\\E8E1\";\n}\n.tc-icon-thumb_up22:before {\n  content: \"\\E8E0\";\n}\n.tc-icon-unfold_less:before {\n  content: \"\\E5E2\";\n}\n.tc-icon-unfold_more:before {\n  content: \"\\E5E3\";\n}\n.tc-icon-verified_user2:before {\n  content: \"\\E8E9\";\n}\n.tc-icon-volume_down:before {\n  content: \"\\E04D\";\n}\n.tc-icon-volume_mute:before {\n  content: \"\\E04E\";\n}\n.tc-icon-volume_off:before {\n  content: \"\\E04F\";\n}\n.tc-icon-volume_up:before {\n  content: \"\\E050\";\n}\n.tc-icon-watch_later22:before {\n  content: \"\\E927\";\n}\n.tc-icon-weekend2:before {\n  content: \"\\E16C\";\n}\n.tc-icon-zoom_in2:before {\n  content: \"\\E912\";\n}\n.tc-icon-zoom_out2:before {\n  content: \"\\E911\";\n}\n.tc-icon-google:before {\n  content: \"\\EA88\";\n}\n.tc-icon-yahoo:before {\n  content: \"\\EABB\";\n}\n.tc-icon-windows8:before {\n  content: \"\\EAC2\";\n}\n.tc-icon-linkedin:before {\n  content: \"\\EACA\";\n}\n/**\n * React Select\n * ============\n * Created by Jed Watson and Joss Mackison for KeystoneJS, http://www.keystonejs.com/\n * https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\n * MIT License: https://github.com/JedWatson/react-select\n*/\n.Select {\n  position: relative;\n}\n.Select,\n.Select div,\n.Select input,\n.Select span {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.Select.is-disabled > .Select-control {\n  background-color: #f9f9f9;\n}\n.Select.is-disabled > .Select-control:hover {\n  box-shadow: none;\n}\n.Select.is-disabled .Select-arrow-zone {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0.35;\n}\n.Select-control {\n  background-color: #fff;\n  border-color: #d9d9d9 #ccc #b3b3b3;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  color: #333;\n  cursor: default;\n  display: table;\n  border-spacing: 0;\n  border-collapse: separate;\n  height: 36px;\n  outline: none;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.Select-control:hover {\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n}\n.Select-control .Select-input:focus {\n  outline: none;\n}\n.is-searchable.is-open > .Select-control {\n  cursor: text;\n}\n.is-open > .Select-control {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  background: #fff;\n  border-color: #b3b3b3 #ccc #d9d9d9;\n}\n.is-open > .Select-control .Select-arrow {\n  top: -2px;\n  border-color: transparent transparent #999;\n  border-width: 0 5px 5px;\n}\n.is-searchable.is-focused:not(.is-open) > .Select-control {\n  cursor: text;\n}\n.is-focused:not(.is-open) > .Select-control {\n  border-color: #007eff;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1);\n}\n.Select-placeholder,\n.Select--single > .Select-control .Select-value {\n  bottom: 0;\n  color: #aaa;\n  left: 0;\n  line-height: 34px;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.has-value.Select--single > .Select-control .Select-value .Select-value-label,\n.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value .Select-value-label {\n  color: #333;\n}\n.has-value.Select--single > .Select-control .Select-value a.Select-value-label,\n.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label {\n  cursor: pointer;\n  text-decoration: none;\n}\n.has-value.Select--single > .Select-control .Select-value a.Select-value-label:hover,\n.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:hover,\n.has-value.Select--single > .Select-control .Select-value a.Select-value-label:focus,\n.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:focus {\n  color: #007eff;\n  outline: none;\n  text-decoration: underline;\n}\n.Select-input {\n  height: 34px;\n  padding-left: 10px;\n  padding-right: 10px;\n  vertical-align: middle;\n}\n.Select-input > input {\n  width: 100%;\n  background: none transparent;\n  border: 0 none;\n  box-shadow: none;\n  cursor: default;\n  display: inline-block;\n  font-family: inherit;\n  font-size: inherit;\n  margin: 0;\n  outline: none;\n  line-height: 14px;\n  /* For IE 8 compatibility */\n  padding: 8px 0 12px;\n  /* For IE 8 compatibility */\n  -webkit-appearance: none;\n}\n.is-focused .Select-input > input {\n  cursor: text;\n}\n.has-value.is-pseudo-focused .Select-input {\n  opacity: 0;\n}\n.Select-control:not(.is-searchable) > .Select-input {\n  outline: none;\n}\n.Select-loading-zone {\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 16px;\n}\n.Select-loading {\n  -webkit-animation: Select-animation-spin 400ms infinite linear;\n  -o-animation: Select-animation-spin 400ms infinite linear;\n  animation: Select-animation-spin 400ms infinite linear;\n  width: 16px;\n  height: 16px;\n  box-sizing: border-box;\n  border-radius: 50%;\n  border: 2px solid #ccc;\n  border-right-color: #333;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n}\n.Select-clear-zone {\n  -webkit-animation: Select-animation-fadeIn 200ms;\n  -o-animation: Select-animation-fadeIn 200ms;\n  animation: Select-animation-fadeIn 200ms;\n  color: #999;\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 17px;\n}\n.Select-clear-zone:hover {\n  color: #D0021B;\n}\n.Select-clear {\n  display: inline-block;\n  font-size: 18px;\n  line-height: 1;\n}\n.Select--multi .Select-clear-zone {\n  width: 17px;\n}\n.Select-arrow-zone {\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 25px;\n  padding-right: 5px;\n}\n.Select-arrow {\n  border-color: #999 transparent transparent;\n  border-style: solid;\n  border-width: 5px 5px 2.5px;\n  display: inline-block;\n  height: 0;\n  width: 0;\n  position: relative;\n}\n.is-open .Select-arrow,\n.Select-arrow-zone:hover > .Select-arrow {\n  border-top-color: #666;\n}\n.Select--multi .Select-multi-value-wrapper {\n  display: inline-block;\n}\n.Select .Select-aria-only {\n  display: inline-block;\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  clip: rect(0, 0, 0, 0);\n  overflow: hidden;\n  float: left;\n}\n@-webkit-keyframes Select-animation-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes Select-animation-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.Select-menu-outer {\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-top-color: #e6e6e6;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n  margin-top: -1px;\n  max-height: 200px;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: 1;\n  -webkit-overflow-scrolling: touch;\n}\n.Select-menu {\n  max-height: 198px;\n  overflow-y: auto;\n}\n.Select-option {\n  box-sizing: border-box;\n  background-color: #fff;\n  color: #666666;\n  cursor: pointer;\n  display: block;\n  padding: 8px 10px;\n}\n.Select-option:last-child {\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.Select-option.is-selected {\n  background-color: #f5faff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.04);\n  color: #333;\n}\n.Select-option.is-focused {\n  background-color: #ebf5ff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.08);\n  color: #333;\n}\n.Select-option.is-disabled {\n  color: #cccccc;\n  cursor: default;\n}\n.Select-noresults {\n  box-sizing: border-box;\n  color: #999999;\n  cursor: default;\n  display: block;\n  padding: 8px 10px;\n}\n.Select--multi .Select-input {\n  vertical-align: middle;\n  margin-left: 10px;\n  padding: 0;\n}\n.Select--multi.has-value .Select-input {\n  margin-left: 5px;\n}\n.Select--multi .Select-value {\n  background-color: #ebf5ff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.08);\n  border-radius: 2px;\n  border: 1px solid #c2e0ff;\n  /* Fallback color for IE 8 */\n  border: 1px solid rgba(0, 126, 255, 0.24);\n  color: #007eff;\n  display: inline-block;\n  font-size: 0.9em;\n  line-height: 1.4;\n  margin-left: 5px;\n  margin-top: 5px;\n  vertical-align: top;\n}\n.Select--multi .Select-value-icon,\n.Select--multi .Select-value-label {\n  display: inline-block;\n  vertical-align: middle;\n}\n.Select--multi .Select-value-label {\n  border-bottom-right-radius: 2px;\n  border-top-right-radius: 2px;\n  cursor: default;\n  padding: 2px 5px;\n}\n.Select--multi a.Select-value-label {\n  color: #007eff;\n  cursor: pointer;\n  text-decoration: none;\n}\n.Select--multi a.Select-value-label:hover {\n  text-decoration: underline;\n}\n.Select--multi .Select-value-icon {\n  cursor: pointer;\n  border-bottom-left-radius: 2px;\n  border-top-left-radius: 2px;\n  border-right: 1px solid #c2e0ff;\n  /* Fallback color for IE 8 */\n  border-right: 1px solid rgba(0, 126, 255, 0.24);\n  padding: 1px 5px 3px;\n}\n.Select--multi .Select-value-icon:hover,\n.Select--multi .Select-value-icon:focus {\n  background-color: #d8eafd;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 113, 230, 0.08);\n  color: #0071e6;\n}\n.Select--multi .Select-value-icon:active {\n  background-color: #c2e0ff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.24);\n}\n.Select--multi.is-disabled .Select-value {\n  background-color: #fcfcfc;\n  border: 1px solid #e3e3e3;\n  color: #333;\n}\n.Select--multi.is-disabled .Select-value-icon {\n  cursor: not-allowed;\n  border-right: 1px solid #e3e3e3;\n}\n.Select--multi.is-disabled .Select-value-icon:hover,\n.Select--multi.is-disabled .Select-value-icon:focus,\n.Select--multi.is-disabled .Select-value-icon:active {\n  background-color: #fcfcfc;\n}\n@keyframes Select-animation-spin {\n  to {\n    transform: rotate(1turn);\n  }\n}\n@-webkit-keyframes Select-animation-spin {\n  to {\n    -webkit-transform: rotate(1turn);\n  }\n}\n/*! normalize.css v3.0.2 | MIT License | git.io/normalize */\n/**\n * 1. Set default font family to sans-serif.\n * 2. Prevent iOS text size adjust after orientation change, without disabling\n *    user zoom.\n */\nhtml {\n  font-family: sans-serif;\n  /* 1 */\n  -ms-text-size-adjust: 100%;\n  /* 2 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */\n}\n/**\n * Remove default margin.\n */\nbody {\n  margin: 0;\n}\n/* HTML5 display definitions\n   ========================================================================== */\n/**\n * Correct `block` display not defined for any HTML5 element in IE 8/9.\n * Correct `block` display not defined for `details` or `summary` in IE 10/11\n * and Firefox.\n * Correct `block` display not defined for `main` in IE 11.\n */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\n/**\n * 1. Correct `inline-block` display not defined in IE 8/9.\n * 2. Normalize vertical alignment of `progress` in Chrome, Firefox, and Opera.\n */\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  /* 1 */\n  vertical-align: baseline;\n  /* 2 */\n}\n/**\n * Prevent modern browsers from displaying `audio` without controls.\n * Remove excess height in iOS 5 devices.\n */\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n/**\n * Address `[hidden]` styling not present in IE 8/9/10.\n * Hide the `template` element in IE 8/9/11, Safari, and Firefox < 22.\n */\n[hidden],\ntemplate {\n  display: none;\n}\n/* Links\n   ========================================================================== */\n/**\n * Remove the gray background color from active links in IE 10.\n */\na {\n  background-color: transparent;\n}\n/**\n * Improve readability when focused and also mouse hovered in all browsers.\n */\na:active,\na:hover {\n  outline: 0;\n}\n/* Text-level semantics\n   ========================================================================== */\n/**\n * Address styling not present in IE 8/9/10/11, Safari, and Chrome.\n */\nabbr[title] {\n  border-bottom: 1px dotted;\n}\n/**\n * Address style set to `bolder` in Firefox 4+, Safari, and Chrome.\n */\nb,\nstrong {\n  font-weight: bold;\n}\n/**\n * Address styling not present in Safari and Chrome.\n */\ndfn {\n  font-style: italic;\n}\n/**\n * Address variable `h1` font-size and margin within `section` and `article`\n * contexts in Firefox 4+, Safari, and Chrome.\n */\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n/**\n * Address styling not present in IE 8/9.\n */\nmark {\n  background: #ff0;\n  color: #000;\n}\n/**\n * Address inconsistent and variable font size in all browsers.\n */\nsmall {\n  font-size: 80%;\n}\n/**\n * Prevent `sub` and `sup` affecting `line-height` in all browsers.\n */\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsup {\n  top: -0.5em;\n}\nsub {\n  bottom: -0.25em;\n}\n/* Embedded content\n   ========================================================================== */\n/**\n * Remove border when inside `a` element in IE 8/9/10.\n */\nimg {\n  border: 0;\n}\n/**\n * Correct overflow not hidden in IE 9/10/11.\n */\nsvg:not(:root) {\n  overflow: hidden;\n}\n/* Grouping content\n   ========================================================================== */\n/**\n * Address margin not present in IE 8/9 and Safari.\n */\nfigure {\n  margin: 1em 40px;\n}\n/**\n * Address differences between Firefox and other browsers.\n */\nhr {\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n  height: 0;\n}\n/**\n * Contain overflow in all browsers.\n */\npre {\n  overflow: auto;\n}\n/**\n * Address odd `em`-unit font size rendering in all browsers.\n */\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n/* Forms\n   ========================================================================== */\n/**\n * Known limitation: by default, Chrome and Safari on OS X allow very limited\n * styling of `select`, unless a `border` property is set.\n */\n/**\n * 1. Correct color not being inherited.\n *    Known issue: affects color of disabled elements.\n * 2. Correct font properties not being inherited.\n * 3. Address margins set differently in Firefox 4+, Safari, and Chrome.\n */\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit;\n  /* 1 */\n  font: inherit;\n  /* 2 */\n  margin: 0;\n  /* 3 */\n}\n/**\n * Address `overflow` set to `hidden` in IE 8/9/10/11.\n */\nbutton {\n  overflow: visible;\n}\n/**\n * Address inconsistent `text-transform` inheritance for `button` and `select`.\n * All other form control elements do not inherit `text-transform` values.\n * Correct `button` style inheritance in Firefox, IE 8/9/10/11, and Opera.\n * Correct `select` style inheritance in Firefox.\n */\nbutton,\nselect {\n  text-transform: none;\n}\n/**\n * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n *    and `video` controls.\n * 2. Correct inability to style clickable `input` types in iOS.\n * 3. Improve usability and consistency of cursor style between image-type\n *    `input` and others.\n */\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  /* 2 */\n  cursor: pointer;\n  /* 3 */\n}\n/**\n * Re-set default cursor for disabled elements.\n */\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n/**\n * Remove inner padding and border in Firefox 4+.\n */\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n/**\n * Address Firefox 4+ setting `line-height` on `input` using `!important` in\n * the UA stylesheet.\n */\ninput {\n  line-height: normal;\n}\n/**\n * It's recommended that you don't attempt to style these elements.\n * Firefox's implementation doesn't respect box-sizing, padding, or width.\n *\n * 1. Address box sizing set to `content-box` in IE 8/9/10.\n * 2. Remove excess padding in IE 8/9/10.\n */\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  /* 1 */\n  padding: 0;\n  /* 2 */\n}\n/**\n * Fix the cursor style for Chrome's increment/decrement buttons. For certain\n * `font-size` values of the `input`, it causes the cursor style of the\n * decrement button to change from `default` to `text`.\n */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n/**\n * 1. Address `appearance` set to `searchfield` in Safari and Chrome.\n * 2. Address `box-sizing` set to `border-box` in Safari and Chrome\n *    (include `-moz` to future-proof).\n */\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box;\n  /* 2 */\n  box-sizing: content-box;\n}\n/**\n * Remove inner padding and search cancel button in Safari and Chrome on OS X.\n * Safari (but not Chrome) clips the cancel button when the search input has\n * padding (and `textfield` appearance).\n */\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n/**\n * Define consistent border, margin, and padding.\n */\n/*\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}*/\n/**\n * 1. Correct `color` not being inherited in IE 8/9/10/11.\n * 2. Remove padding so people aren't caught out if they zero out fieldsets.\n */\nlegend {\n  border: 0;\n  /* 1 */\n  padding: 0;\n  /* 2 */\n}\n/**\n * Remove default vertical scrollbar in IE 8/9/10/11.\n */\ntextarea {\n  overflow: auto;\n}\n/**\n * Don't inherit the `font-weight` (applied by a rule above).\n * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.\n */\noptgroup {\n  font-weight: bold;\n}\n/* Tables\n   ========================================================================== */\n/**\n * Remove most spacing between table cells.\n */\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\ntd,\nth {\n  padding: 0;\n}\n/*------------------------------------*\n  RESET\n*------------------------------------*/\nbody,\ndiv,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\npre,\nform,\nfieldset,\ninput,\ntextarea,\np,\nblockquote,\nth,\ntd {\n  margin: 0;\n  padding: 0;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\nfieldset,\nimg {\n  border: 0;\n}\naddress,\ncaption,\ncite,\ndfn,\nth,\nvar {\n  font-style: normal;\n  font-weight: normal;\n}\ncaption,\nth {\n  text-align: left;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: 100%;\n  font-weight: normal;\n}\nq:before,\nq:after {\n  content: '';\n}\nabbr,\nacronym {\n  border: 0;\n}\n.no-wrap {\n  white-space: nowrap;\n}\n* {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n*:before,\n*:after {\n  box-sizing: border-box;\n}\nhtml,\nbody {\n  height: 100%;\n  width: 100%;\n}\nhtml {\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  -webkit-font-smoothing: antialiased;\n  color: rgba(0, 0, 0, 0.54);\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  background-color: #fafafa;\n}\nhr {\n  border: none;\n  border-bottom: solid 1px #e0e0e0;\n}\n.mui-text-full-black {\n  color: #000000;\n}\n.mui-text-dark-black {\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-text-light-black {\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-text-min-black {\n  color: rgba(0, 0, 0, 0.26);\n}\n.mui-text-full-white {\n  color: #ffffff;\n}\n.mui-text-dark-white {\n  color: rgba(255, 255, 255, 0.87);\n}\n.mui-text-light-white {\n  color: rgba(255, 255, 255, 0.54);\n}\n.mui-font-weight-light {\n  font-weight: 300;\n}\n.mui-font-weight-normal {\n  font-weight: 400;\n}\n.mui-font-weight-medium {\n  font-weight: 500;\n}\n/* Type Styles */\n.mui-font-style-display-4 {\n  font-size: 112px;\n  line-height: 128px;\n  letter-spacing: -7px;\n  padding-top: 17px;\n  margin-bottom: 15px;\n  font-weight: 300;\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-font-style-display-3 {\n  font-size: 56px;\n  line-height: 64px;\n  letter-spacing: -2px;\n  padding-top: 8px;\n  margin-bottom: 28px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-font-style-display-2 {\n  font-size: 45px;\n  line-height: 48px;\n  margin-bottom: 11px;\n  letter-spacing: -1px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-font-style-display-1 {\n  font-size: 34px;\n  line-height: 40px;\n  padding-top: 8px;\n  margin-bottom: 12px;\n  letter-spacing: -1px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-font-style-headline {\n  font-size: 24px;\n  line-height: 32px;\n  padding-top: 16px;\n  margin-bottom: 12px;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-title {\n  font-size: 20px;\n  line-height: 28px;\n  padding-top: 19px;\n  margin-bottom: 13px;\n  letter-spacing: 0;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-subhead-2 {\n  font-size: 15px;\n  line-height: 28px;\n  padding-top: 2px;\n  margin-bottom: 10px;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-subhead-1 {\n  font-size: 15px;\n  line-height: 28px;\n  padding-top: 2px;\n  margin-bottom: 10px;\n  letter-spacing: 0;\n  font-weight: 400;\n  line-height: 24px;\n  padding-top: 3px;\n  margin-bottom: 13px;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-body-2 {\n  font-size: 13px;\n  line-height: 24px;\n  padding-top: 4px;\n  margin-bottom: 12px;\n  letter-spacing: 0;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-body-1 {\n  font-size: 13px;\n  line-height: 20px;\n  padding-top: 6px;\n  margin-bottom: 14px;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-caption {\n  font-size: 12px;\n  line-height: 20px;\n  padding-top: 6px;\n  margin-bottom: 14px;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-font-style-menu {\n  font-size: 13px;\n  line-height: 20px;\n  padding-top: 6px;\n  margin-bottom: 14px;\n  letter-spacing: 0;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\n.mui-font-style-button {\n  font-size: 14px;\n  line-height: 20px;\n  padding-top: 5px;\n  margin-bottom: 15px;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\n/* General HTML Typography */\nbody {\n  font-size: 13px;\n  line-height: 20px;\n}\nh1 {\n  font-size: 45px;\n  line-height: 48px;\n  margin-bottom: 11px;\n  letter-spacing: -1px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.54);\n}\nh2 {\n  font-size: 34px;\n  line-height: 40px;\n  padding-top: 8px;\n  margin-bottom: 12px;\n  letter-spacing: -1px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.54);\n}\nh3 {\n  font-size: 24px;\n  line-height: 32px;\n  padding-top: 16px;\n  margin-bottom: 12px;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n}\nh4 {\n  font-size: 20px;\n  line-height: 28px;\n  padding-top: 19px;\n  margin-bottom: 13px;\n  letter-spacing: 0;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\nh5 {\n  font-size: 15px;\n  line-height: 28px;\n  padding-top: 2px;\n  margin-bottom: 10px;\n  letter-spacing: 0;\n  font-weight: 400;\n  line-height: 24px;\n  padding-top: 3px;\n  margin-bottom: 13px;\n  color: rgba(0, 0, 0, 0.87);\n}\nh6 {\n  font-size: 13px;\n  line-height: 24px;\n  padding-top: 4px;\n  margin-bottom: 12px;\n  letter-spacing: 0;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\np {\n  font-size: 13px;\n  line-height: 20px;\n  padding-top: 6px;\n  margin-bottom: 14px;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n}\nhr {\n  margin-top: 0;\n  margin-bottom: 18px;\n}\n.mui-predefined-layout-1 .mui-app-content-canvas {\n  padding-top: 64px;\n}\n.mui-predefined-layout-1 .mui-app-bar {\n  position: fixed;\n  height: 64px;\n}\n.mui-key-width-1 {\n  width: 64px;\n}\n.mui-key-width-2 {\n  width: 128px;\n}\n.mui-key-width-3 {\n  width: 192px;\n}\n.mui-key-width-4 {\n  width: 256px;\n}\n.mui-key-width-5 {\n  width: 320px;\n}\n.mui-key-width-6 {\n  width: 384px;\n}\n.mui-key-width-7 {\n  width: 448px;\n}\n.mui-key-width-8 {\n  width: 512px;\n}\n.mui-key-width-9 {\n  width: 576px;\n}\n.mui-key-width-10 {\n  width: 640px;\n}\n.mui-key-height-1 {\n  height: 64px;\n}\n.mui-key-height-2 {\n  height: 128px;\n}\n.mui-key-height-3 {\n  height: 192px;\n}\n.mui-key-height-4 {\n  height: 256px;\n}\n.mui-key-height-5 {\n  height: 320px;\n}\n.mui-key-height-6 {\n  height: 384px;\n}\n.mui-key-height-7 {\n  height: 448px;\n}\n.mui-key-height-8 {\n  height: 512px;\n}\n.mui-key-height-9 {\n  height: 576px;\n}\n.mui-key-height-10 {\n  height: 640px;\n}\n.mui-paper.mui-rounded {\n  border-radius: 2px;\n}\n.mui-paper.mui-rounded > .mui-paper-container {\n  border-radius: 2px;\n}\n.mui-paper.mui-circle {\n  border-radius: 50%;\n}\n.mui-paper.mui-circle > .mui-paper-container {\n  border-radius: 50%;\n}\n.mui-paper > .mui-paper-container {\n  height: 100%;\n  width: 100%;\n}\n.mui-paper.mui-z-depth-1 {\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.24);\n}\n.mui-paper.mui-z-depth-1 > .mui-z-depth-bottom {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);\n}\n.mui-paper.mui-z-depth-2 {\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23);\n}\n.mui-paper.mui-z-depth-2 > .mui-z-depth-bottom {\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16);\n}\n.mui-paper.mui-z-depth-3 {\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.23);\n}\n.mui-paper.mui-z-depth-3 > .mui-z-depth-bottom {\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.19);\n}\n.mui-paper.mui-z-depth-4 {\n  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.22);\n}\n.mui-paper.mui-z-depth-4 > .mui-z-depth-bottom {\n  box-shadow: 0 14px 45px rgba(0, 0, 0, 0.25);\n}\n.mui-paper.mui-z-depth-5 {\n  box-shadow: 0 15px 20px rgba(0, 0, 0, 0.22);\n}\n.mui-paper.mui-z-depth-5 > .mui-z-depth-bottom {\n  box-shadow: 0 19px 60px rgba(0, 0, 0, 0.3);\n}\n.mui-dialog .mui-dialog-title {\n  padding: 24px 24px 0 24px;\n  margin-bottom: 0;\n}\n.mui-dialog .mui-dialog-content {\n  padding: 24px;\n}\n.mui-dialog-window {\n  position: fixed;\n  z-index: 10;\n  top: 0px;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms;\n}\n.mui-dialog-window .mui-dialog-window-contents {\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  position: relative;\n  width: 75%;\n  max-width: 768px;\n  margin: 0 auto;\n  z-index: 10;\n  background: #fafafa;\n  opacity: 0;\n}\n.mui-dialog-window .mui-dialog-window-actions {\n  padding: 8px;\n  margin-bottom: 8px;\n  width: 100%;\n  text-align: right;\n}\n.mui-dialog-window .mui-dialog-window-actions .mui-dialog-window-action {\n  margin-right: 8px;\n}\n.mui-dialog-window.mui-is-shown {\n  left: 0px;\n  transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-dialog-window.mui-is-shown .mui-dialog-window-contents {\n  opacity: 1;\n  top: 0px;\n  transform: translate3d(0, 64px, 0);\n}\n.mui-enhanced-button {\n  border: 0;\n  background: none;\n}\n.mui-enhanced-button:focus {\n  outline: none;\n}\n.mui-enhanced-button.mui-is-link-button {\n  display: inline-block;\n  cursor: pointer;\n  text-decoration: none;\n}\n.mui-enhanced-button.mui-is-link-button:hover {\n  text-decoration: none;\n}\n.mui-enhanced-button.mui-is-link-button.mui-is-disabled {\n  cursor: default;\n}\n.mui-enhanced-textarea .mui-enhanced-textarea-shadow,\n.mui-enhanced-textarea .mui-enhanced-textarea-input {\n  width: 100%;\n  resize: none;\n}\n.mui-enhanced-textarea .mui-enhanced-textarea-input {\n  overflow: hidden;\n}\n.mui-enhanced-textarea .mui-enhanced-textarea-shadow {\n  transform: scale(0);\n  position: absolute;\n}\n.mui-icon-button {\n  position: relative;\n  padding: 12px;\n}\n.mui-icon-button * {\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-icon-button .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1);\n  border: solid 6px rgba(0, 0, 0, 0);\n  background-clip: padding-box;\n  animation: icon-button-focus-ripple-pulsate 1.5s ease 0s infinite;\n}\n@keyframes icon-button-focus-ripple-pulsate {\n  0%,\n  100% {\n    transform: scale(0.75);\n  }\n  50% {\n    transform: scale(1);\n  }\n}\n.mui-icon-button .mui-icon-button-tooltip {\n  margin-top: 52px;\n}\n.mui-icon-button.mui-is-disabled * {\n  color: rgba(191, 191, 191, 0.54);\n  fill: rgba(191, 191, 191, 0.54);\n}\n.mui-dark-theme .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n.mui-dark-theme .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(255, 255, 255, 0.3);\n  box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.3);\n}\n.mui-tooltip {\n  position: absolute;\n  font-size: 12px;\n  line-height: 22px;\n  padding: 0 8px;\n  color: #ffffff;\n  overflow: hidden;\n  top: -10000px;\n  border-radius: 2px;\n  user-select: none;\n  opacity: 0;\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-tooltip .mui-tooltip-label {\n  position: relative;\n  white-space: nowrap;\n}\n.mui-tooltip .mui-tooltip-ripple {\n  position: absolute;\n  left: 50%;\n  top: 0px;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  background-color: transparent;\n  transition: width 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, height 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, background-color 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-tooltip.mui-is-shown {\n  top: 24px;\n  opacity: 1;\n  transform: translate3d(0px, 16px, 0px);\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-tooltip.mui-is-shown .mui-tooltip-ripple {\n  background-color: #757575;\n  transition: width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, height 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, background-color 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-tooltip.mui-is-touch {\n  font-size: 14px;\n  line-height: 44px;\n  padding: 0 16px;\n}\n.mui-tooltip.mui-is-touch.mui-is-shown .mui-tooltip-ripple {\n  height: 105px;\n  width: 105px;\n}\n.mui-flat-button {\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  font-size: 14px;\n  line-height: 20px;\n  padding-top: 5px;\n  margin-bottom: 15px;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n  border-radius: 2px;\n  user-select: none;\n  position: relative;\n  overflow: hidden;\n  background-color: #ffffff;\n  color: rgba(0, 0, 0, 0.54);\n  line-height: 36px;\n  min-width: 88px;\n  padding: 0 16px;\n  margin: 0;\n  transform: translate3d(0, 0, 0);\n}\n.mui-flat-button .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.mui-flat-button .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(0, 0, 0, 0.07);\n}\n.mui-flat-button .mui-flat-button-label {\n  position: relative;\n}\n.mui-flat-button:hover,\n.mui-flat-button.mui-is-keyboard-focused {\n  background-color: #e6e6e6;\n}\n.mui-flat-button.mui-is-disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n.mui-flat-button.mui-is-disabled:hover {\n  background-color: inherit;\n}\n.mui-flat-button.mui-is-primary {\n  color: #ff4081;\n}\n.mui-flat-button.mui-is-primary:hover,\n.mui-flat-button.mui-is-primary.mui-is-keyboard-focused {\n  background-color: #ffe3ed;\n}\n.mui-flat-button.mui-is-primary .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(255, 64, 129, 0.2);\n}\n.mui-flat-button.mui-is-primary .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(255, 64, 129, 0.2);\n}\n.mui-flat-button.mui-is-secondary {\n  color: #00bcd4;\n}\n.mui-flat-button.mui-is-secondary:hover,\n.mui-flat-button.mui-is-secondary.mui-is-keyboard-focused {\n  background-color: #defbff;\n}\n.mui-flat-button.mui-is-secondary .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(0, 188, 212, 0.2);\n}\n.mui-flat-button.mui-is-secondary .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(0, 188, 212, 0.2);\n}\n.mui-font-icon {\n  position: relative;\n  font-size: 24px;\n  display: inline-block;\n  user-select: none;\n}\n.mui-raised-button {\n  display: inline-block;\n  min-width: 88px;\n  height: 36px;\n}\n.mui-raised-button,\n.mui-raised-button * {\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-raised-button .mui-raised-button-container {\n  position: relative;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n  border-radius: 2px;\n  background-color: #ffffff;\n  transform: translate3d(0, 0, 0);\n}\n.mui-raised-button .mui-raised-button-container.mui-is-keyboard-focused {\n  background-color: #e6e6e6;\n}\n.mui-raised-button .mui-raised-button-container.mui-is-disabled {\n  background-color: #e6e6e6;\n}\n.mui-raised-button .mui-raised-button-container.mui-is-disabled .mui-raised-button-label {\n  color: rgba(0, 0, 0, 0.3);\n}\n.mui-raised-button .mui-raised-button-container.mui-is-disabled:hover {\n  background-color: #e6e6e6;\n}\n.mui-raised-button .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.mui-raised-button .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(0, 0, 0, 0.07);\n}\n.mui-raised-button .mui-raised-button-label {\n  position: relative;\n  font-size: 14px;\n  line-height: 20px;\n  padding-top: 5px;\n  margin-bottom: 15px;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n  margin: 0;\n  padding: 0 16px;\n  user-select: none;\n  line-height: 36px;\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-raised-button:hover .mui-raised-button-container {\n  background-color: #e6e6e6;\n}\n.mui-raised-button.mui-is-primary .mui-raised-button-container {\n  background-color: #ff4081;\n}\n.mui-raised-button.mui-is-primary .mui-raised-button-container.mui-is-keyboard-focused {\n  background-color: #f30053;\n}\n.mui-raised-button.mui-is-primary .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.mui-raised-button.mui-is-primary .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.mui-raised-button.mui-is-primary .mui-raised-button-label {\n  color: #ffffff;\n}\n.mui-raised-button.mui-is-primary:hover .mui-raised-button-container {\n  background-color: #f30053;\n}\n.mui-raised-button.mui-is-secondary .mui-raised-button-container {\n  background-color: #00bcd4;\n}\n.mui-raised-button.mui-is-secondary .mui-raised-button-container.mui-is-keyboard-focused {\n  background-color: #00aac0;\n}\n.mui-raised-button.mui-is-secondary .mui-touch-ripple .mui-ripple-circle-inner {\n  background-color: rgba(255, 255, 255, 0.35);\n}\n.mui-raised-button.mui-is-secondary .mui-focus-ripple .mui-focus-ripple-inner {\n  background-color: rgba(255, 255, 255, 0.35);\n}\n.mui-raised-button.mui-is-secondary .mui-raised-button-label {\n  color: #ffffff;\n}\n.mui-raised-button.mui-is-secondary:hover .mui-raised-button-container {\n  background-color: #00aac0;\n}\n.mui-focus-ripple {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  transform: scale(0);\n  opacity: 0;\n}\n.mui-focus-ripple .mui-focus-ripple-inner {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.1);\n  animation: focus-ripple-pulsate 1.5s ease 0s infinite;\n}\n@keyframes focus-ripple-pulsate {\n  0%,\n  100% {\n    transform: scale(0.75);\n  }\n  50% {\n    transform: scale(0.85);\n  }\n}\n.mui-focus-ripple.mui-is-shown {\n  transform: scale(1);\n  opacity: 1;\n}\n.mui-ripple-circle {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0.7;\n  transition: opacity 2s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-ripple-circle .mui-ripple-circle-inner {\n  height: 100%;\n  width: 100%;\n  border-radius: 50%;\n  transform: scale(0);\n  background-color: rgba(0, 0, 0, 0.2);\n  transition: transform 1s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-ripple-circle.mui-is-started {\n  opacity: 1;\n}\n.mui-ripple-circle.mui-is-started .mui-ripple-circle-inner {\n  transform: scale(1);\n}\n.mui-ripple-circle.mui-is-ending {\n  opacity: 0;\n}\n.mui-touch-ripple {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.mui-snackbar {\n  color: white;\n  background-color: #323232;\n  border-radius: 2px;\n  padding: 0 24px;\n  height: 48px;\n  line-height: 48px;\n  min-width: 288px;\n  max-width: 568px;\n  position: fixed;\n  z-index: 10;\n  bottom: 24px;\n  margin-left: 24px;\n  left: -10000px;\n  opacity: 0;\n  transform: translate3d(0, 20px, 0);\n  transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 400ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-snackbar .mui-snackbar-action {\n  color: #ff4081;\n  float: right;\n  margin-top: 6px;\n  margin-right: -16px;\n  margin-left: 24px;\n  background-color: transparent;\n}\n.mui-snackbar.mui-is-open {\n  left: 0;\n  opacity: 1;\n  transform: translate3d(0, 0, 0);\n  transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.individual-invitation {\n  height: 60px;\n}\n.individual-invitation .mui-text-field {\n  width: 220px;\n  margin-right: 16px;\n}\n.individual-invitation .mui-text-field:nth-child(4) {\n  margin-right: 0px;\n}\n.individual-invitation .tc-icon {\n  float: none;\n  vertical-align: bottom;\n  font-size: 24px;\n  line-height: 48px;\n  margin-left: 12px;\n  cursor: pointer;\n}\n.individual-invitation .tc-icon.tc-icon-add {\n  margin-left: 0;\n}\n.mui-text-field {\n  font-size: 14px;\n  line-height: 24px;\n  height: 48px;\n  width: 100%;\n  display: inline-block;\n  position: relative;\n  transition: height 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-text-field .mui-text-field-hint,\n.mui-text-field .mui-text-field-floating-label {\n  position: absolute;\n  line-height: 48px;\n  color: rgba(0, 0, 0, 0.3);\n  opacity: 1;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-text-field .mui-text-field-error {\n  position: absolute;\n  bottom: -10px;\n  font-size: 12px;\n  line-height: 12px;\n  color: #f44336;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-text-field .mui-text-field-character-count {\n  position: absolute;\n  bottom: -10px;\n  font-size: 12px;\n  line-height: 12px;\n  right: 0;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-text-field .mui-text-field-character-count.mui-text-field-character-count-error {\n  color: #f44336;\n}\n.mui-text-field .mui-text-field-input,\n.mui-text-field .mui-text-field-textarea {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n  background-color: rgba(0, 0, 0, 0);\n  color: rgba(0, 0, 0, 0.54);\n}\n.mui-text-field .mui-text-field-textarea {\n  margin-top: 12px;\n}\n.mui-text-field .mui-text-field-underline,\n.mui-text-field .mui-text-field-focus-underline {\n  position: absolute;\n  width: 100%;\n  bottom: 8px;\n  margin: 0;\n}\n.mui-text-field .mui-text-field-focus-underline {\n  border-color: #00bcd4;\n  border-bottom-width: 2px;\n  transform: scaleX(0);\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.mui-text-field.mui-has-error .mui-text-field-focus-underline {\n  border-color: #f44336;\n  transform: scaleX(1);\n}\n.mui-text-field.mui-has-value .mui-text-field-hint {\n  opacity: 0;\n}\n.mui-text-field.mui-is-disabled .mui-text-field-input {\n  color: rgba(0, 0, 0, 0.3);\n}\n.mui-text-field.mui-is-disabled .mui-text-field-underline {\n  border: none;\n  height: 40px;\n  border-bottom: 1px dotted #9e9e9e;\n}\n.mui-text-field.mui-is-focused .mui-text-field-focus-underline {\n  transform: scaleX(1);\n}\n.mui-text-field.mui-has-floating-labels {\n  height: 72px;\n}\n.mui-text-field.mui-has-floating-labels .mui-text-field-floating-label {\n  top: 24px;\n  transform: scale(1) translate3d(0, 0, 0);\n  transform-origin: left top;\n}\n.mui-text-field.mui-has-floating-labels .mui-text-field-hint {\n  top: 24px;\n  opacity: 0;\n}\n.mui-text-field.mui-has-floating-labels .mui-text-field-input {\n  padding-top: 24px;\n}\n.mui-text-field.mui-has-floating-labels.mui-has-value .mui-text-field-floating-label,\n.mui-text-field.mui-has-floating-labels.mui-is-focused .mui-text-field-floating-label {\n  transform: scale(0.75) translate3d(0, -18px, 0);\n}\n.mui-text-field.mui-has-floating-labels.mui-has-value .mui-text-field-floating-label {\n  color: rgba(0, 0, 0, 0.5);\n}\n.mui-text-field.mui-has-floating-labels.mui-is-disabled .mui-text-field-hint {\n  color: rgba(0, 0, 0, 0.3);\n}\n.mui-text-field.mui-has-floating-labels.mui-is-focused .mui-text-field-hint {\n  opacity: 1;\n}\n.mui-text-field.mui-has-floating-labels.mui-is-focused .mui-text-field-floating-label {\n  transform: scale(0.75) translate3d(0, -18px, 0);\n  color: #00bcd4;\n}\n.mui-text-field.mui-has-floating-labels.mui-is-focused.mui-has-error .mui-text-field-floating-label {\n  color: #f44336;\n}\n.mui-text-field.mui-has-floating-labels.mui-is-focused.mui-has-value .mui-text-field-hint {\n  opacity: 0;\n}\nbody {\n  font-size: 14px;\n  line-height: 21px;\n  width: 100%;\n  height: 100%;\n}\n.flex-tc-sb {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.flex-center {\n  display: flex;\n  align-items: center;\n}\n.flex-tc-stretch {\n  display: flex;\n  align-items: stretch;\n}\n.autocomplete-list-container {\n  height: 200px;\n  width: 100%;\n  z-index: 4000 !important;\n  border-bottom: honeydew;\n  border-left: honeydew;\n  border-right: honeydew;\n  border-top: 1px solid #e6e6e6;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border-radius: 0 0 2px 2px;\n}\n#livechat-compact-container,\n#livechat-full {\n  left: 20px;\n  right: auto;\n}\n::-ms-clear {\n  display: none;\n}\na {\n  color: #00bcd4;\n  text-decoration: none;\n}\na:hover {\n  color: #ff4081;\n}\n.mui-overlay.mui-is-shown {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0;\n}\n.last-sent {\n  font-size: 10px;\n  width: auto;\n  display: inline-block;\n  line-height: 48px;\n  vertical-align: middle;\n}\n.individual-tags-container {\n  max-height: 190px;\n  overflow-x: auto;\n  padding-right: 10px;\n}\n.tags-typeahead-search-bar-container {\n  width: calc(96.25% - 22px);\n  display: inline-block;\n  position: relative;\n}\n.tags-typeahead-search-bar-container .tc-icon-add {\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 40px;\n  float: right;\n  cursor: pointer;\n  padding-left: 15px;\n}\n.individual-tag {\n  display: block;\n  vertical-align: middle;\n  line-height: 36px;\n}\n.company-tags-container {\n  display: inline;\n  overflow: auto;\n  clear: both;\n}\n.diff-deleted {\n  background-color: rgba(255, 0, 0, 0.1) !important;\n}\n.diff-added {\n  background-color: rgba(0, 128, 0, 0.1) !important;\n}\n.diff-block-deleted {\n  background-color: rgba(255, 0, 0, 0.1) !important;\n  border: 1px solid rgba(255, 0, 0, 0.4) !important;\n  margin-top: 8px;\n}\n.diff-block-added {\n  background-color: rgba(0, 128, 0, 0.1) !important;\n  border: 1px solid rgba(0, 128, 0, 0.4) !important;\n  margin-top: 8px;\n}\n.send-email-more {\n  color: #00bcd4;\n}\n.send-email-more:hover {\n  color: #ff4081;\n}\n.diff-nav-active {\n  font-size: 18px;\n}\n.individual-company-tag {\n  display: inline-block;\n  margin-right: 8px;\n  padding: 0px 5px;\n  line-height: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  vertical-align: baseline;\n  font-size: 12px;\n  color: white;\n  background-color: #00bcd4;\n  border-radius: 8px;\n}\n.image-loading-indicater {\n  transition: all 0s linear;\n}\n.image-loading-indicater:before {\n  position: absolute;\n  content: '';\n  top: calc(50% - 25px);\n  left: calc(50% - 25px);\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  border: 3px solid rgba(202, 204, 205, 0.15);\n}\n.image-loading-indicater.black-border:after {\n  border-color: #000 transparent transparent;\n}\n.image-loading-indicater:after {\n  position: absolute;\n  content: '';\n  top: calc(50% - 25px);\n  left: calc(50% - 25px);\n  width: 50px;\n  height: 50px;\n  animation: loader .6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 100%;\n  border-color: #fff transparent transparent;\n  border-style: solid;\n  border-width: 3px;\n  box-shadow: 0 0 0 1px transparent;\n}\n.font-weight-light {\n  font-weight: 300;\n}\n.font-weight-normal {\n  font-weight: 400;\n}\n.font-weight-bold {\n  font-weight: 700;\n}\n.tc-card {\n  background-color: #ffffff;\n}\n.tc-card .tc-card-header {\n  background-color: #f5f5f5;\n  padding: 0 16px;\n  border-radius: 2px 2px 0 0;\n}\n.tc-card .tc-card-header:before,\n.tc-card .tc-card-header:after {\n  content: \" \";\n  display: table;\n}\n.tc-card .tc-card-header:after {\n  clear: both;\n}\n.tc-card .tc-card-header.search-header {\n  position: relative;\n  padding: 0;\n  height: auto;\n}\n.tc-card .tc-card-header-tags {\n  width: 50%;\n  float: left;\n  margin: 6.5px 0px;\n}\n.tc-card .tc-card-header-title,\n.tc-card .tc-card-header-subtitle {\n  margin: 0;\n  padding: 0;\n  line-height: 48px;\n}\n.tc-card .tc-card-header-title {\n  float: left;\n}\n.tc-card .tc-card-header-subtitle {\n  float: right;\n}\n.tc-card .tc-card-contents {\n  position: relative;\n}\n.tc-card .tc-card-contents:before,\n.tc-card .tc-card-contents:after {\n  content: \" \";\n  display: table;\n}\n.tc-card .tc-card-contents:after {\n  clear: both;\n}\n.tc-card.is-padded .tc-card-contents {\n  padding: 16px;\n}\n.tc-card.is-sticky {\n  background-color: #ffffff;\n  margin-bottom: 32px;\n  position: relative;\n}\n.tc-card.is-sticky .tc-card-header {\n  background-color: #f5f5f5;\n  position: relative;\n  padding: 0 16px;\n  width: 100%;\n}\n.tc-card.is-sticky .tc-card-header:before,\n.tc-card.is-sticky .tc-card-header:after {\n  content: \" \";\n  display: table;\n}\n.tc-card.is-sticky .tc-card-header:after {\n  clear: both;\n}\n.tc-card.is-sticky.is-fixed {\n  top: 92px;\n}\n.tc-card.is-sticky.is-fixed .tc-header-container {\n  position: fixed;\n  top: 64px;\n  z-index: 5;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.24);\n}\n.tc-card.is-sticky.is-fixed .tc-card-header {\n  border-radius: 0;\n}\n.tc-card.is-sticky.is-fixed .tc-card-contents:before,\n.tc-card.is-sticky.is-fixed .tc-card-contents:after {\n  content: \" \";\n  display: table;\n}\n.tc-card.is-sticky.is-fixed .tc-card-contents:after {\n  clear: both;\n}\n.send-email-card {\n  width: 512px;\n  margin: auto;\n}\n.cardGradient {\n  background: linear-gradient(to top, #ffffff 20%, rgba(255, 255, 255, 0) 80%);\n  bottom: 32px;\n  width: 95%;\n  height: 46px;\n  display: block;\n  position: absolute;\n}\n.cardGradient.productsGradient {\n  bottom: 12px;\n}\n.tc-card-rating.header {\n  float: right;\n  color: rgba(0, 0, 0, 0.87);\n}\n.tc-card-rating.inner-description {\n  top: 3px;\n  position: absolute;\n  right: 28px;\n}\n.tc-card-rating .tc-icon-star,\n.tc-card-rating .tc-icon-star-half {\n  line-height: 44px;\n  font-size: 20px;\n}\n.tc-icon {\n  position: relative;\n  font-size: 24px;\n  display: inline-block;\n  user-select: none;\n}\n.tc-icon-with-label:hover {\n  color: #ff4081;\n}\n.tc-section-heading {\n  margin-bottom: 32px;\n  text-align: center;\n}\n.tc-section-heading .tc-section-heading-title {\n  display: inline-block;\n  padding: 0 24px;\n  font-size: 24px;\n  line-height: 24px;\n  margin: 0;\n  background-color: #fafafa;\n  letter-spacing: 0;\n  font-weight: 300;\n}\n.tc-section-heading .tc-section-heading-subtitle {\n  font-size: 14px;\n  line-height: 21px;\n  max-width: 80%;\n  margin: 0 auto;\n  letter-spacing: 0;\n  font-weight: 400;\n}\n.tc-section-heading .tc-section-heading-underline {\n  margin-top: -13px;\n}\n.carousel {\n  position: relative;\n  margin: 0;\n  overflow: hidden;\n}\n.carousel-info-left,\n.carousel-info-right {\n  font-size: 26px;\n  position: absolute;\n  z-index: 2;\n  top: 0px;\n  cursor: pointer;\n  opacity: .9;\n  height: 100%;\n  background-color: #fafafa;\n  transition: opacity 0.8s cubic-bezier(0.77, 0, 0.175, 1);\n}\n.carousel-info-left .tc-icon,\n.carousel-info-right .tc-icon {\n  line-height: 320px;\n  vertical-align: middle;\n  color: #ff4081;\n}\n.carousel-info-left:hover .tc-icon,\n.carousel-info-right:hover .tc-icon {\n  color: #00bcd4;\n}\n.carousel-info-left.hidden,\n.carousel-info-right.hidden {\n  opacity: 0;\n  cursor: auto;\n}\n.carousel-info-left {\n  left: 0;\n}\n.carousel-info-right {\n  right: 0;\n}\n.carousel-inner {\n  width: 100%;\n  height: 100%;\n  background-color: #000000;\n  overflow: hidden;\n  position: relative;\n  height: 320px;\n}\n.carousel-inner ul {\n  list-style: none;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  left: 0px;\n  transition: left 0.8s cubic-bezier(0.77, 0, 0.175, 1);\n}\n.carousel-inner ul .carouselBackground {\n  width: 744px;\n  height: 320px;\n  float: left;\n  position: relative;\n}\n.carousel-inner ul .carouselBackground img {\n  position: relative;\n}\n/*keyframe animations*/\n.first-filmstrip {\n  -webkit-animation: bannermove 30s linear infinite;\n  -moz-animation: bannermove 30s linear infinite;\n  -ms-animation: bannermove 30s linear infinite;\n  -o-animation: bannermove 30s linear infinite;\n  animation: bannermove 30s linear infinite;\n}\n@keyframes \"bannermove\" {\n  0% {\n    margin-left: 0px;\n  }\n  100% {\n    margin-left: -100%;\n  }\n}\n@-moz-keyframes bannermove {\n  0% {\n    margin-left: 0px;\n  }\n  100% {\n    margin-left: -100%;\n  }\n}\n@-webkit-keyframes \"bannermove\" {\n  0% {\n    margin-left: 0px;\n  }\n  100% {\n    margin-left: -100%;\n  }\n}\n@-ms-keyframes \"bannermove\" {\n  0% {\n    margin-left: 0px;\n  }\n  100% {\n    margin-left: -100%;\n  }\n}\n@-o-keyframes \"bannermove\" {\n  0% {\n    margin-left: 0px;\n  }\n  100% {\n    margin-left: -100%;\n  }\n}\n.filmstrip-container {\n  overflow: hidden;\n  padding: 5px 0px;\n}\n.photobanner {\n  height: 50px;\n}\n.photobanner img {\n  -webkit-transition: all 0.5s ease;\n  -moz-transition: all 0.5s ease;\n  -o-transition: all 0.5s ease;\n  -ms-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n  height: 50px;\n  margin: 0 5px;\n  border-radius: 7px;\n}\n.photobanner img:hover {\n  -webkit-transform: scale(1.1);\n  -moz-transform: scale(1.1);\n  -o-transform: scale(1.1);\n  -ms-transform: scale(1.1);\n  transform: scale(1.1);\n  cursor: pointer;\n  -webkit-box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);\n}\n.photobanner:hover .first-filmstrip {\n  -webkit-animation-play-state: paused;\n  -moz-animation-play-state: paused;\n  -ms-animation-play-state: paused;\n  -o-animation-play-state: paused;\n  animation-play-state: paused;\n}\n.more-vert {\n  position: relative;\n}\n.more-vert .tc-icon-more-vert {\n  position: static;\n}\n.more-vert .more-vert-action-container {\n  box-shadow: 0 0 !important;\n}\n.more-vert .more-vert-drop-down {\n  top: 18px;\n  font-size: 14px;\n  padding: 8px 16px;\n  position: absolute;\n  right: 0;\n  background-color: #ffffff;\n  min-width: 170px;\n  margin-top: 4px;\n  text-align: left;\n  opacity: 1;\n  transform: translate3d(0, 0, 0) scale(1);\n  transform-origin: top right;\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.more-vert .more-vert-drop-down.is-closed {\n  top: -500px;\n  opacity: 0;\n  transform: translate3d(0, -20px, 0) scale(0);\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.more-vert .more-vert-drop-down.is-vert-multi-select {\n  transform: translateX(50%);\n  width: 250px;\n}\n.more-vert .more-vert-drop-down .more-vert-link {\n  display: block;\n  z-index: 1000;\n  line-height: 36px;\n  color: rgba(0, 0, 0, 0.54);\n}\n.more-vert .more-vert-drop-down .more-vert-link:hover,\n.more-vert .more-vert-drop-down .more-vert-link.active {\n  cursor: pointer;\n  color: #ff4081;\n}\n.more-vert .more-vert-drop-down .more-vert-link .tc-icon-chevron-right,\n.more-vert .more-vert-drop-down .more-vert-link .tc-icon-chevron-left {\n  line-height: 36px;\n  vertical-align: middle;\n  font-size: 24px;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select {\n  font-size: 15px;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select .multi-select-input-container {\n  margin: 0;\n  border: 0;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select .multi-select-input-container input {\n  padding: 0 0 0 8px;\n  line-height: 40px;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select .multi-select-input-dropdown {\n  background-color: initial;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select .multi-select-option-container {\n  width: 100%;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select .multi-select-option-container .multi-select-option-checkbox {\n  width: 23px;\n  line-height: 42.5px;\n}\n.more-vert .more-vert-drop-down .more-vert-link .multi-select .multi-select-option-container .multi-select-option {\n  width: calc(100% - 29px);\n  line-height: 34px;\n}\n.accordian-list-title {\n  display: inline-block;\n  width: calc(98% - 120px);\n  min-height: 80px;\n  padding: 16px 0px;\n}\n.accordian-list-title h4 {\n  padding-top: 0px;\n  margin-bottom: 0px;\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 46px;\n}\n.accordian-chevron {\n  display: inline-block;\n  width: 2%;\n}\n.arrow-box {\n  background: white;\n  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.24);\n  -moz-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.24);\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.24);\n}\n.arrow-box-inner {\n  background: white;\n  margin-top: -50px;\n  /* transform z-index hack */\n  -moz-transform: rotate(0deg);\n  -webkit-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  transform: rotate(0deg);\n}\n.arrow-box:before {\n  content: '';\n  position: relative;\n  margin-left: 25px;\n  top: -10px;\n  background: white;\n  display: block;\n  width: 50px;\n  height: 50px;\n  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.24);\n  -moz-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.24);\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.24);\n  -moz-transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.blue-arrow-box:before {\n  background: #4285f4;\n}\n.counter {\n  display: inline-block;\n  background-color: #00bcd4;\n  float: right;\n  color: #ffffff;\n  line-height: 18px;\n  font-size: 12px;\n  margin-top: -1px;\n  min-width: 18px;\n  text-align: center;\n  border-radius: 9px;\n  padding: 0 5px;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.counter.is-zero {\n  background-color: #bdbdbd;\n  color: #f5f5f5;\n}\n.counter:hover {\n  background-color: #ff4081;\n}\n.counter.is-active {\n  background-color: #00bcd4;\n}\n.app-bar {\n  width: 100%;\n  z-index: 3;\n  height: 64px;\n  position: fixed;\n  background-color: white;\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.26);\n}\n.app-bar .app-bar-content {\n  padding: 0 24px 0 24px;\n  height: 100%;\n  margin: 0 auto;\n  position: relative;\n}\n.app-bar .tourconnect-logo {\n  margin-top: 12px;\n  margin-left: 24px;\n  width: 42px;\n  position: absolute;\n  display: block;\n  left: 0;\n  overflow: hidden;\n  text-align: left;\n  transition: left 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, width 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms;\n}\n.app-bar .tourconnect-logo .tourconnect-logo-globe,\n.app-bar .tourconnect-logo .tourconnect-logo-name {\n  height: 42px;\n}\n.app-bar .tourconnect-logo .tourconnect-logo-name {\n  position: absolute;\n  transition: opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  opacity: 0;\n}\n.app-bar .nav-link-container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  line-height: 64px;\n  font-size: 13px;\n  position: relative;\n  z-index: 0;\n  margin-left: 32px;\n  width: calc(100% - 108px);\n  opacity: 1;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 450ms;\n}\n.app-bar .nav-link-container .invitation-request-container {\n  height: 100%;\n  max-height: 64px;\n  float: right;\n}\n.app-bar .nav-link-container .invitation-request-container:hover .tc-icon-user {\n  color: #00bcd4;\n  transition: all 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.app-bar .nav-link-container .invitation-request-container:hover .tc-icon-cog {\n  color: #00bcd4;\n  transition: all 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.app-bar .nav-link-container .invitation-request-container .invitation-request-icon {\n  font-size: 28px;\n  line-height: 64px;\n  color: rgba(0, 0, 0, 0.54);\n}\n.app-bar .nav-link-container .invitation-request-container .invitation-request-counter {\n  border-radius: 9px;\n  font-size: 12px;\n  min-width: 18px;\n  line-height: 16px;\n  padding: 0px 4px;\n  top: 10px;\n  right: 29px;\n  position: absolute;\n  color: #ffffff;\n  text-align: center;\n  background-color: #f44336;\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.26);\n  border: solid 1px #ffffff;\n}\n.app-bar .nav-link-container .nav-link {\n  float: left;\n  margin-left: 24px;\n  text-decoration: none;\n  color: rgba(0, 0, 0, 0.54);\n  font-weight: 500;\n  font-size: 14px;\n  position: relative;\n  overflow: hidden;\n  background-color: rgba(0, 0, 0, 0);\n  transition: all 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.app-bar .nav-link-container .nav-link:focus {\n  outline: none;\n}\n.app-bar .nav-link-container .nav-link:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  height: 4px;\n  width: 100%;\n  background-color: #ff4081;\n  transform: translate3d(0, 0, 0);\n  transition: all 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.app-bar .nav-link-container .nav-link:hover,\n.app-bar .nav-link-container .nav-link.active {\n  color: #ff4081;\n}\n.app-bar .nav-link-container .nav-link:hover:after,\n.app-bar .nav-link-container .nav-link.active:after {\n  transform: translate3d(0, -4px, 0);\n}\n.app-bar .app-bar-profile-link {\n  position: absolute;\n  right: 24px;\n}\n.app-bar.is-on-onboarding .tourconnect-logo,\n.app-bar.is-not-logged-in .tourconnect-logo {\n  left: calc(50% - 117.25px);\n  width: 235px;\n  transition: left 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, width 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.app-bar.is-on-onboarding .tourconnect-logo .tourconnect-logo-name,\n.app-bar.is-not-logged-in .tourconnect-logo .tourconnect-logo-name {\n  opacity: 1;\n}\n.app-bar.is-on-onboarding .nav-link-container,\n.app-bar.is-not-logged-in .nav-link-container,\n.app-bar.is-on-onboarding .app-bar-profile-link,\n.app-bar.is-not-logged-in .app-bar-profile-link {\n  z-index: -1;\n  opacity: 0;\n}\n.app-bar.is-on-onboarding .nav-link-container,\n.app-bar.is-not-logged-in .nav-link-container {\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.app-bar.is-on-modal {\n  display: none;\n}\n.app-bar.is-on-admin {\n  display: none;\n}\n.app-window {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n.underline:hover {\n  text-decoration: underline;\n}\n.marketing-readiness-div {\n  margin-top: 32px;\n  color: rgba(0, 0, 0, 0.870588);\n  border-bottom: solid 1px #eeeeee;\n}\n.marketing-readiness-div.marketing-is-ready .market-readiness-error-container {\n  border: 2px solid #5bbd72;\n}\n.marketing-readiness-div.marketing-is-not-ready .market-readiness-error-container {\n  border: 2px solid #f2c037;\n}\n.marketing-readiness-div.marketing-is-not-ready .l-paper-split-segment,\n.marketing-readiness-div.marketing-is-ready .l-paper-split-segment {\n  color: rgba(0, 0, 0, 0.541176);\n}\n.marketing-readiness-div.marketing-is-not-ready .l-paper-split-segment ul,\n.marketing-readiness-div.marketing-is-ready .l-paper-split-segment ul {\n  position: relative;\n  width: 90%;\n  float: right;\n}\n.marketing-readiness-div.marketing-is-not-ready .l-paper-split-segment ul li,\n.marketing-readiness-div.marketing-is-ready .l-paper-split-segment ul li {\n  margin-top: 8px 0px;\n}\n.marketing-readiness-div.marketing-is-not-ready .market-readiness-error-container,\n.marketing-readiness-div.marketing-is-ready .market-readiness-error-container {\n  position: relative;\n  border-radius: 0px 0px 2px 2px;\n  padding: 16px;\n  width: 100%;\n  display: block;\n  height: 100%;\n  overflow: hidden;\n  clear: both;\n  background-color: white;\n}\n.textarea-container {\n  margin-bottom: 16px;\n  min-height: 83px;\n}\n.textarea-container .error-message {\n  color: red;\n  margin-top: 4px;\n}\n.l-app-profile-content {\n  width: 100%;\n  z-index: 0;\n  padding: 0;\n}\n.l-app-profile-content .profile-cover-photo {\n  height: auto;\n  width: 100%;\n  max-height: 381px;\n}\n.l-app-profile-content .profile-cover-photo img {\n  height: 100%;\n  width: 100%;\n  display: block;\n}\n.l-app-profile-content .full-container {\n  width: 100%;\n}\n.add-cover-image-url {\n  top: 40%;\n  left: calc(50% - 286px);\n  position: absolute;\n  color: #00bcd4;\n  font-size: 64px;\n}\n.add-cover-image-url input {\n  cursor: default;\n}\n.add-cover-image-url:hover {\n  color: #ff4081;\n}\n.cover-photo-gradient {\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0) 33%);\n  bottom: 32px;\n  width: 95%;\n  height: 46px;\n  display: block;\n  position: absolute;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n}\n.add-item-card {\n  vertical-align: middle;\n  background-color: #f5f5f5;\n  border: 2px dashed #00bcd4;\n  margin: auto;\n  margin-top: 32px;\n  width: 100%;\n  cursor: pointer;\n  padding: 30px 30px;\n  color: #00bcd4;\n}\n.add-item-card:hover {\n  border-color: #ff4081;\n  color: #ff4081;\n}\n.profile-add-individual-photo-container {\n  width: 128px;\n  display: inline-block;\n  margin: 16px;\n  height: 128px;\n  line-height: 128px;\n  position: relative;\n  color: #00bcd4;\n  background-color: #f5f5f5;\n  text-align: center;\n  border: 2px dashed #00bcd4;\n  overflow: hidden;\n  clear: both;\n  cursor: pointer;\n}\n.profile-add-individual-photo-container .tc-icon-add {\n  color: #00bcd4;\n}\n.profile-add-individual-photo-container:hover {\n  border-color: #ff4081;\n  color: #ff4081;\n}\n.profile-add-individual-photo-container:hover .tc-icon-add {\n  color: #ff4081;\n}\n.profile-top-bar-top-info {\n  display: block;\n  bottom: 0;\n  color: white;\n  padding: 8px;\n  position: relative;\n  max-width: 1232px;\n  width: 100%;\n  margin: auto;\n  left: 275px;\n  line-height: 24px;\n}\n.profile-top-bar-top-info .tc-icon-star,\n.profile-top-bar-top-info .tc-icon-star-half,\n.profile-top-bar-top-info .tc-icon-star-empty {\n  font-size: 14px;\n}\n.profile-cover-photo-ideal-size-text {\n  position: absolute;\n  display: block;\n  bottom: 35px;\n  right: 40px;\n  cursor: pointer;\n  overflow: hidden;\n  margin-right: 16px;\n  padding: 8px;\n  color: white;\n  font-weight: 500;\n}\n.profile-cover-edit-image-icon {\n  position: absolute;\n  display: block;\n  bottom: 0;\n  cursor: pointer;\n  overflow: hidden;\n  margin-right: 16px;\n  background-color: rgba(138, 138, 138, 0.5);\n  padding: 8px;\n  color: white;\n  font-weight: 600;\n}\n.profile-edit-address .profile-edit-address-break {\n  margin-bottom: 12px;\n}\n.profile-edit-icon,\n.profile-edit-icon-white {\n  cursor: pointer;\n  font-size: 14px;\n  margin-right: 4px;\n}\n.description-segments-add-icon {\n  cursor: pointer;\n}\n.top-bar-edit-container,\n.profile-edit-icon-container {\n  cursor: pointer;\n  display: inline-block;\n  margin-left: 8px;\n  color: #00bcd4;\n}\n.top-bar-edit-container .description-segments-add-icon,\n.profile-edit-icon-container .description-segments-add-icon {\n  font-size: 16px;\n  border: 1px dashed #00bcd4;\n  color: #00bcd4;\n  margin-top: 8px;\n  margin-right: 8px;\n}\n.top-bar-edit-container:hover,\n.profile-edit-icon-container:hover {\n  color: #ff4081;\n}\n.top-bar-edit-container:hover .description-segments-add-icon,\n.profile-edit-icon-container:hover .description-segments-add-icon {\n  border: 1px dashed #ff4081;\n  color: #ff4081;\n}\n.profile-edit {\n  cursor: pointer;\n  line-height: 48px;\n  float: right;\n  color: #00bcd4;\n}\n.profile-edit:hover {\n  color: #ff4081;\n}\n.div-link {\n  cursor: pointer;\n  color: #00bcd4;\n}\n.div-link:hover {\n  color: #ff4081;\n}\n.l-profile-tool-panel-container {\n  height: 139px;\n  background-color: white;\n  position: relative;\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.26);\n}\n.l-profile-tool-panel-container .profile-connection-info {\n  z-index: 1;\n  width: 216px;\n  line-height: 18px;\n  top: -53px;\n  position: relative;\n  text-align: center;\n}\n.l-profile-tool-panel-container .views-info {\n  width: 166px;\n  line-height: 8px;\n  top: -60px;\n  position: relative;\n  text-align: center;\n}\n.l-profile-tool-panel-container .l-profile-logo-edit {\n  cursor: pointer;\n  position: absolute;\n  background-color: white;\n  line-height: 30px;\n  width: 128px;\n  height: 30px;\n  vertical-align: middle;\n  top: 34px;\n  left: 19px;\n  border: 1px solid;\n  text-align: center;\n  z-index: 1;\n}\n.l-profile-tool-panel-container .l-profile-logo-container {\n  height: 100%;\n  float: left;\n  width: 256px;\n}\n.l-profile-tool-panel-container .l-profile-logo-container .l-profile-logo {\n  width: 128px;\n  height: 128px;\n  top: -64px;\n  left: 47px;\n  line-height: 128px;\n  position: relative;\n  color: white;\n  border-radius: 50%;\n  text-align: center;\n}\n.l-profile-tool-panel-container .l-profile-logo-container .l-profile-logo:hover + .l-profile-logo-background {\n  visibility: visible;\n}\n.l-profile-tool-panel-container .l-profile-logo-container .l-profile-logo.l-profile-logo-grey-background {\n  background-color: rgba(184, 184, 184, 0.8);\n}\n.l-profile-tool-panel-container .l-profile-logo-container .l-profile-logo .profileViewImage {\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n}\n.l-profile-tool-panel-container .l-profile-logo-container .l-profile-logo-background {\n  width: 128px;\n  height: 128px;\n  top: -64px;\n  left: 19px;\n  line-height: 128px;\n  position: absolute;\n  color: #fff;\n  background-color: rgba(184, 184, 184, 0.8);\n  background-size: cover;\n  text-align: center;\n  visibility: hidden;\n}\n.l-profile-tool-panel-container .l-profile-logo-container .l-profile-logo-background:hover {\n  visibility: visible;\n  cursor: pointer;\n}\n.l-profile-tool-panel-container .l-profile-tool-panel {\n  padding: 16px;\n  padding-left: 28px;\n  height: 100%;\n  float: left;\n  width: calc(100% - 256px);\n}\n.l-profile-content .l-profile-left-content {\n  padding: 0px 16px 32px 0px;\n  width: 256px;\n  float: left;\n}\n.l-profile-content .l-profile-right-content {\n  padding: 32px 0px 32px 16px;\n  padding-right: 0px;\n  float: left;\n  width: calc(100% - 256px);\n}\n.l-profile-content .l-profile-right-content .add-contacts .profile-image-add,\n.l-profile-content .l-profile-right-content .profile-image-add-container .profile-image-add {\n  border: dashed 1px #00bcd4;\n}\n.l-profile-content .l-profile-right-content .add-contacts .profile-image-add .profile-image-letter,\n.l-profile-content .l-profile-right-content .profile-image-add-container .profile-image-add .profile-image-letter {\n  color: #00bcd4;\n}\n.l-profile-content .l-profile-right-content .add-contacts .add-contacts-header,\n.l-profile-content .l-profile-right-content .profile-image-add-container .add-contacts-header,\n.l-profile-content .l-profile-right-content .add-contacts .add-location-header,\n.l-profile-content .l-profile-right-content .profile-image-add-container .add-location-header {\n  color: #00bcd4;\n}\n.l-profile-content .l-profile-right-content .add-contacts:hover .profile-image-add,\n.l-profile-content .l-profile-right-content .profile-image-add-container:hover .profile-image-add {\n  border-color: #ff4081;\n}\n.l-profile-content .l-profile-right-content .add-contacts:hover .profile-image-add .profile-image-letter,\n.l-profile-content .l-profile-right-content .profile-image-add-container:hover .profile-image-add .profile-image-letter {\n  color: #ff4081;\n}\n.l-profile-content .l-profile-right-content .add-contacts:hover .add-contacts-header,\n.l-profile-content .l-profile-right-content .profile-image-add-container:hover .add-contacts-header,\n.l-profile-content .l-profile-right-content .add-contacts:hover .add-location-header,\n.l-profile-content .l-profile-right-content .profile-image-add-container:hover .add-location-header {\n  color: #ff4081;\n}\n.l-profile-content .l-profile-right-content .location-content {\n  display: flex;\n  min-height: 48px;\n  max-height: 48px;\n  height: 48px;\n}\n.l-profile-content .l-profile-right-content .tc-icon-more-vert {\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n}\n.l-profile-content .l-profile-right-content .location-content-link {\n  display: inline-block;\n}\n.l-profile-content .l-profile-right-content .location-content-contract-readiness {\n  display: inline-block;\n  margin-left: 10px;\n  padding: 0px 5px;\n  line-height: 16px;\n  font-weight: bold;\n  cursor: default;\n  font-size: 12px;\n  color: white;\n  background-color: #00bcd4;\n  border-radius: 8px;\n}\n.l-profile-content .l-profile-right-content .location-content-contract-readiness-draft {\n  display: inline-block;\n  margin-left: 10px;\n  padding: 0px 5px;\n  line-height: 16px;\n  font-weight: bold;\n  cursor: default;\n  font-size: 12px;\n  color: white;\n  background-color: #911ba8;\n  border-radius: 8px;\n}\n.l-profile-content .l-profile-right-content .location-product-count {\n  display: inline-block;\n  width: 15%;\n  text-align: center;\n  vertical-align: middle;\n}\n.l-profile-content .l-profile-right-content .location-content-menu {\n  display: inline-block;\n  width: 5%;\n  text-align: right;\n  vertical-align: middle;\n}\n.l-profile-content .l-profile-right-content .profile-image:not(.profile-image-add) {\n  cursor: default;\n}\n.l-profile-content .l-profile-right-content .profile-image-add-container {\n  cursor: pointer;\n}\n.l-profile-content .l-profile-right-content .location-name h4 {\n  color: grey;\n  font-weight: 300;\n  padding-top: 4px;\n  margin-bottom: 10px;\n}\n.l-profile-content .l-profile-right-content .location-data,\n.l-profile-content .l-profile-right-content .contact-sale,\n.l-profile-content .l-profile-right-content .multiple-locations {\n  margin-top: 32px;\n}\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-question,\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-yes,\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-no {\n  display: inline-block;\n}\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-question {\n  width: 88%;\n}\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-yes {\n  width: 9%;\n}\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-no {\n  width: 3%;\n}\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-answer {\n  color: #00bcd4;\n}\n.l-profile-content .l-profile-right-content .multiple-locations .multiple-locations-answer:hover {\n  cursor: pointer;\n  color: #ff4081;\n}\n.tc-icon-star.is-editing {\n  color: grey;\n}\n.form-dialog .cancel-modal {\n  float: left;\n}\n.form-dialog .save-modal {\n  float: right;\n}\n.l-profile-address {\n  clear: both;\n}\n.change-color-on-hover {\n  color: #ffffff;\n}\n.change-color-on-hover:hover {\n  color: #00bcd4 !important;\n}\n.contact-div-hover:hover,\n.contact-div-hover:focus,\n.contact-div-hover:active {\n  background-color: #f6f6f6;\n}\n.profile-views {\n  z-index: 1100;\n  display: inline-block;\n}\n.profile-views .profile-views-container {\n  position: absolute;\n  z-index: 1;\n  right: 0;\n  background-color: #ffffff;\n  width: 150px;\n  margin-top: 8px;\n  text-align: left;\n  opacity: 1;\n  transform: translate3d(0, 0, 0) scale(1);\n  transform-origin: top right;\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.profile-views.is-closed .profile-views-container {\n  top: -500px;\n  opacity: 0;\n  transform: translate3d(0, -20px, 0) scale(0);\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.logo .l-profile-logo {\n  display: inline-block;\n  width: 80px;\n  height: 80px;\n  top: -40px;\n  line-height: 80px;\n  position: relative;\n  color: white;\n  border-radius: 50%;\n  text-align: center;\n}\n.logo .l-profile-logo:hover + .logo-background {\n  visibility: visible;\n}\n.logo .l-profile-logo.l-profile-logo-grey-background {\n  background-color: rgba(184, 184, 184, 0.8);\n}\n.logo .logo-background {\n  top: -10px;\n  position: absolute;\n  color: #fff;\n  left: calc(45.5%);\n  visibility: hidden;\n}\n.logo .logo-background:hover {\n  visibility: visible;\n  cursor: pointer;\n}\n.profile-cover-photo-edit-image {\n  position: absolute;\n  bottom: 0;\n  cursor: pointer;\n  overflow: hidden;\n  color: white;\n}\n.full-cover-photo-gradient {\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.87), rgba(0, 0, 0, 0) 100%);\n  display: block;\n  position: absolute;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n}\n.verified-member-block:hover > .what-is-org-hover {\n  display: block;\n}\n.what-is-org-hover {\n  display: none;\n}\n.what-is-org-hover:active {\n  display: block;\n}\n.image-container .video-playbutton-mask {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  overflow: hidden;\n  top: 0;\n  left: 0;\n}\n.effect .video-playbutton-mask {\n  opacity: 0;\n  overflow: visible;\n  box-sizing: border-box;\n  transition: all 0.4s ease-in-out;\n}\n.effect:hover .video-playbutton-mask {\n  opacity: 1;\n  background-color: rgba(0, 0, 0, 0.7);\n}\n#marketing-materials ::-webkit-scrollbar {\n  width: 0px;\n  /* remove scrollbar space */\n  background: transparent;\n  /* optional: just make scrollbar invisible */\n}\n.blur-photos {\n  filter: blur(10px);\n  -webkit-filter: blur(10px);\n  -moz-filter: blur(10px);\n  -o-filter: blur(10px);\n  -ms-filter: blur(10px);\n}\n.flip-icon {\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n/*==================================================\n=            Bootstrap 3 Media Queries             =\n==================================================*/\n/* Large Devices, Wide Screens */\n@media only screen and (min-width: 1200px) {\n  .arrow_box {\n    display: none;\n  }\n}\n@media only screen and (min-width: 1170px) {\n}\n@media only screen and (min-width: 1500px) {\n  .connections-floating-help-box {\n    display: none;\n  }\n}\n@media only screen and (max-width: 1358px) {\n  .connections-floating-help-box {\n    display: none;\n  }\n}\n@media only screen and (min-width: 1529px) {\n  .contracting-floating-help-box {\n    display: none;\n  }\n}\n@media only screen and (max-width: 1306px) {\n  .contracting-floating-help-box {\n    display: none;\n  }\n}\n/* Medium Devices, Desktops */\n/* Small Devices, Tablets */\n@media only screen and (max-width: 768px) {\n  .top-action-bar {\n    display: none !important;\n  }\n}\n/* Extra Small Devices, Phones */\n@media only screen and (max-width: 480px) {\n  .two-column-row-right-button {\n    float: left !important;\n    margin-top: 10px;\n  }\n  .full-width-block-label {\n    display: block;\n    width: 100%;\n  }\n}\n/* Custom, iPhone Retina */\n.breadcrumb-container .tc-icon-chevron-right {\n  display: inline-block;\n  vertical-align: middle;\n}\n.breadcrumb-container .breadcrumb {\n  display: inline-block;\n  position: relative;\n  margin-bottom: 8px;\n}\n.breadcrumb-container .breadcrumb.breadcrumb-link {\n  cursor: pointer;\n  color: #00bcd4;\n}\n.breadcrumb-container .breadcrumb.breadcrumb-link:hover {\n  color: #ff4081;\n}\n.address-data {\n  border: 1px solid #f5f5f5;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.24);\n  height: 300px;\n  margin-bottom: 20px;\n  position: relative;\n  margin-top: 32px;\n}\n.address-data .gmap {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.address-data .l-paper-right-address {\n  width: 100%;\n  max-width: 1232px;\n  margin-top: 5px;\n  font-size: 16px;\n  position: relative;\n  z-index: 9;\n  border: 1px solid #e6e6fa;\n  margin: auto;\n}\n.address-data .l-paper-right-address .title {\n  font-size: 16px;\n  padding-left: 20px;\n}\n.address-data .l-paper-right-address .address-column {\n  padding: 20px;\n  margin-top: 5px;\n  font-size: 16px;\n  width: 200px;\n  background-color: rgba(255, 255, 255, 0.8);\n}\n.address-data .l-paper-right-address .address-column p {\n  font-size: 14px;\n  margin-bottom: 3px;\n}\n.l-paper-right-info.profile-description-paragraph {\n  white-space: pre-wrap;\n}\n.company-right-panel .profile-card {\n  margin-bottom: 20px;\n}\n.company-right-panel .profile-card .tc-card-contents {\n  position: relative;\n}\n.company-right-panel .profile-card .tc-card-contents .l-paper-right-info {\n  margin-bottom: 8px;\n}\n.company-right-panel .profile-card .tc-card-contents .l-paper-right-info.description-info {\n  word-wrap: break-word;\n  white-space: pre;\n}\n.company-right-panel .profile-card .tc-card-contents .short-info {\n  height: 126px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.company-right-panel .profile-card .tc-card-contents .short-contacts {\n  height: 362.5px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.company-right-panel .profile-card .tc-card-contents .short-location {\n  height: 362.5px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.company-right-panel .profile-card .tc-card-contents .load-more {\n  position: relative;\n  float: right;\n  right: 15px;\n  bottom: 10px;\n}\n.contact-details {\n  margin-bottom: 20px;\n}\n.contact-details .contact .contact-header {\n  width: 172px;\n  display: inline-block;\n  font-size: 14px;\n  margin-bottom: 3px;\n  line-height: 20px;\n}\n.contact-details .contact .name-detail,\n.contact-details .contact .email-detail {\n  width: 196px;\n}\n.contact-details .contact .phone-detail,\n.contact-details .contact .fax-detail {\n  width: 148px;\n}\n.contact-details .contact-info .contact-detail {\n  width: 172px;\n  display: inline-block;\n  word-wrap: break-word;\n  margin-bottom: 0px;\n  font-size: 13px;\n  line-height: 20px;\n}\n.contact-details .contact-info .name-detail,\n.contact-details .contact-info .email-detail {\n  width: 196px;\n  word-wrap: break-word;\n}\n.contact-details .contact-info .phone-detail,\n.contact-details .contact-info .fax-detail {\n  width: 148px;\n}\n.contact-details hr {\n  margin-bottom: 0px;\n}\n.profile-logo {\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n.profile-logo .profile-image {\n  height: 128px;\n  width: 128px;\n  margin: 0 auto;\n}\n.profile-logo .profile-image .profile-image-letter {\n  line-height: 128px;\n  font-size: 35px;\n}\n.profile-logo .company-name {\n  margin-top: 8px;\n  font-size: 16px;\n}\n.company-left-nav {\n  position: fixed;\n  height: 100%;\n  margin-top: -96px;\n  text-align: center;\n}\n.company-left-nav .company-left-nav-inner {\n  margin-top: 96px;\n}\n.company-connected-status {\n  display: inline-block;\n  min-width: 88px;\n  height: 36px;\n}\n.company-connected-status .tc-icon-users {\n  vertical-align: middle;\n  padding-right: 4px;\n}\n.company-connected-status .company-connection-buttons {\n  position: relative;\n  z-index: 1;\n  margin: 8px;\n}\n.company-connected-status .company-connection-buttons .tc-icon-check {\n  color: green;\n  margin-right: 16px;\n}\n.company-connected-status .company-connection-buttons .tc-icon-check,\n.company-connected-status .company-connection-buttons .tc-icon-close {\n  cursor: pointer;\n}\n.l-paper-split-location .location-name {\n  display: block;\n  clear: both;\n}\n.l-paper-split-location .location-name .profile-image {\n  float: left;\n}\n.l-paper-split-location .location-name .location-content {\n  margin-left: 70px;\n  min-height: 80px;\n  padding: 16px 0px;\n}\n.l-paper-split-location .location-name .location-content h5 {\n  line-height: 15px;\n  padding-top: 0px;\n  margin-bottom: 0px;\n}\n.l-paper-split-location .location-name .location-content .location-list-content {\n  line-height: 20px;\n  padding-top: 6px;\n  margin-bottom: 14px;\n  letter-spacing: 0;\n}\n.l-paper-split-location .location-name:last-child hr {\n  border: none;\n}\n.segment-content {\n  font-size: 14px;\n  padding-left: 16px;\n  line-height: 48px;\n}\n.segment-option {\n  cursor: pointer;\n  display: inline-block;\n}\n.segment-option span {\n  line-height: 27px;\n  vertical-align: middle;\n}\n.segment-icon {\n  color: #4caf50;\n}\n.segment-icon.hide {\n  visibility: hidden;\n}\n.segment-icon.show {\n  visibility: visible;\n}\n.description-segments-title {\n  display: inline-block;\n  width: 80%;\n  color: rgba(0, 0, 0, 0.870588);\n}\n.description-segments-edit {\n  cursor: pointer;\n  text-align: right;\n  display: inline-block;\n  width: 20%;\n  color: #00bcd4;\n}\n.description-segments-edit:hover {\n  color: #ff4081;\n}\n.description-segments-add {\n  cursor: pointer;\n  color: #00bcd4;\n}\n.description-segments-add .description-segments-add-icon {\n  font-size: 14px;\n  border: 1px dashed;\n}\n.description-segments-add .description-segments-add-label {\n  font-size: 16px;\n  margin-left: 6px;\n}\n.description-segments-add:hover {\n  color: #ff4081;\n}\n.segments-options {\n  max-height: 375px;\n  overflow: auto;\n}\n.description-segments {\n  font-size: 14px;\n  line-height: 48px;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  border-bottom: solid 1px #eeeeee;\n}\n.product-paragraph {\n  height: 20px;\n}\n.amenity {\n  display: inline-block;\n  width: 33%;\n}\n.connections-splash {\n  text-align: center;\n  max-width: 75%;\n  margin: 0 auto;\n}\n.connections-splash .connections-splash-icon {\n  color: #00bcd4;\n  font-size: 128px;\n  margin: 32px 0;\n}\n.connections-splash ul {\n  list-style-type: none;\n}\n.connections-splash ul li {\n  margin-bottom: 5px;\n}\n.connections-splash span.connections-info {\n  display: block;\n}\n.connections-splash .connections-splash-details-container {\n  font-size: 16px;\n  line-height: 28px;\n}\n.connections-splash .connections-splash-details-container .connections-splash-details {\n  width: 291px;\n  text-align: left;\n  margin: 20px auto;\n}\n.connections-splash .connections-splash-details-container .connections-splash-details .tc-icon {\n  margin-right: 6px;\n  font-size: 24px;\n  color: #00bcd4;\n  line-height: 28px;\n  float: left;\n}\n.connections-left-nav {\n  position: fixed;\n  height: 100%;\n  margin-top: -96px;\n}\n.connections-left-nav .connections-left-nav-inner {\n  margin-top: 96px;\n}\n.connections-left-nav .connections-left-nav-heading {\n  font-size: 14px;\n  padding-left: 16px;\n  line-height: 48px;\n  text-transform: uppercase;\n  border-bottom: solid 1px #eeeeee;\n}\n/**\n * Author:      Matt Hinchliffe <www.maketea.co.uk>\n * Description: Responsive image placeholders\n */\ninput::-ms-close {\n  width: 0;\n  display: none;\n  height: 0;\n}\n/* Preload and loaded animations */\n@-webkit-keyframes bobble {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(0);\n  }\n  35% {\n    opacity: 1;\n    -webkit-transform: translateY(-20px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(0);\n  }\n}\n@keyframes bobble {\n  0% {\n    opacity: 0;\n    transform: translateY(0);\n  }\n  35% {\n    opacity: 1;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(0);\n  }\n}\n.no-connections-loading {\n  background: white;\n}\n.no-connections-loading::after {\n  content: ' ';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 1em;\n  height: 1em;\n  margin: -0.5em 0 0 -0.5em;\n  background: #8C8C8C;\n  border-radius: 100%;\n  animation: bobble 2s cubic-bezier(0.6, 1, 1, 1) infinite;\n}\n.no-connections {\n  padding: 16px;\n  height: 110px;\n}\n.no-connections h4.no-connections-message {\n  padding: 0;\n  margin: 0;\n  line-height: 78px;\n  vertical-align: middle;\n  font-size: 16px;\n}\n.connections-list {\n  padding-left: 16px;\n}\n.connections-list .loader {\n  position: relative;\n  transition: all 0s linear;\n  background-color: 'black';\n  height: 30px;\n}\n.connections-list .loader:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.15);\n}\n.connections-list .loader:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  animation: loader .6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #fff transparent transparent;\n  border-style: solid;\n  border-width: .2em;\n  box-shadow: 0 0 0 1px transparent;\n}\n.connections-actions {\n  float: right;\n  line-height: 48px;\n}\n.connections-actions .tc-icon-more-vert {\n  padding-right: 8px;\n  display: inline;\n  position: relative;\n  vertical-align: middle;\n  cursor: pointer;\n}\n.connections-actions .connections-actions-dropdown {\n  top: 50%;\n  transform: translateY(-50%);\n}\n.connections-actions .connections-action-container {\n  display: inline;\n  vertical-align: middle;\n  position: relative;\n}\n.connections-actions .connections-action-container .mui-flat-button {\n  height: 36px;\n  border: 1px solid #f5f5f5;\n  border-radius: 0px;\n  padding-left: 18px;\n  padding-right: 0px;\n}\n.connections-actions .connections-action-container .mui-flat-button .tc-icon-arrow-drop-down.tc-icon {\n  float: right;\n  line-height: 36px;\n}\n.connections-actions .connections-action-drop-down {\n  font-size: 14px;\n  position: absolute;\n  top: 34px;\n  z-index: 2;\n  right: 0;\n  background-color: #ffffff;\n  min-width: 224px;\n  margin-top: 4px;\n  text-align: left;\n  opacity: 1;\n  transform: translate3d(0, 0, 0) scale(1);\n  transform-origin: top right;\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-actions .connections-action-drop-down.is-vert-multi-select {\n  transform: translateX(50%);\n  width: 250px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-contents {\n  padding: 8px 16px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link {\n  display: block;\n  z-index: 1000;\n  line-height: 36px;\n  color: rgba(0, 0, 0, 0.54);\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .tc-icon-chevron-right,\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .tc-icon-chevron-left {\n  line-height: 36px;\n  vertical-align: middle;\n  font-size: 24px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select {\n  font-size: 15px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select .multi-select-input-container {\n  margin: 0;\n  border: 0;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select .multi-select-input-container input {\n  padding: 0 0 0 8px;\n  line-height: 40px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select .multi-select-input-dropdown {\n  background-color: initial;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select .multi-select-option-container {\n  width: 100%;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select .multi-select-option-container .multi-select-option-checkbox {\n  width: 23px;\n  line-height: 42.5px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link .multi-select .multi-select-option-container .multi-select-option {\n  width: calc(100% - 29px);\n  line-height: 34px;\n}\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link:hover,\n.connections-actions .connections-action-drop-down .connections-action-drop-down-link.active {\n  cursor: pointer;\n  color: #ff4081;\n}\n.connections-actions .connections-action-drop-down.is-closed {\n  top: -500px;\n  opacity: 0;\n  transform: translate3d(0, -20px, 0) scale(0);\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-list-header,\n.connections-list-email {\n  width: auto;\n  display: inline;\n  margin-right: 16px;\n  min-height: 24px;\n  line-height: 24px;\n  color: rgba(0, 0, 0, 0.54);\n  padding-left: 0px;\n}\n.connections-list-header {\n  font-size: 16px;\n}\n.connections-company-container {\n  padding-left: 0px;\n  padding: 16px 0px;\n  min-height: 80px;\n  display: inline-block;\n  float: right;\n  width: calc(100% - 128px);\n}\n.connections-tags-container {\n  display: inline-block;\n  position: relative;\n  white-space: pre;\n  width: calc(100% - 177px);\n  margin-top: 3px;\n  min-height: 21px;\n  padding-left: 5px;\n}\n.connections-tags-container .connections-tags-tag-icon {\n  font-size: 16px;\n  float: left;\n  margin-left: 2px;\n  padding: 0px 4px;\n  display: none;\n  cursor: pointer;\n}\n.connections-tags-container .connections-tags {\n  color: #00bcd4;\n  font-weight: 700;\n  cursor: pointer;\n  font-size: 12px;\n  position: relative;\n  box-sizing: border-box;\n  display: inline-block;\n  text-align: center;\n  float: left;\n  vertical-align: baseline;\n}\n.connections-tags-container .connections-tags:hover {\n  color: #ff4081;\n}\n.connections-profile-image-container {\n  display: inline-block;\n  float: left;\n  width: 48px;\n  height: 48px;\n  padding: 16px 16px 16px 0px;\n}\n.connections-profile-image-container .profile-image {\n  border-radius: 50%;\n  height: 48px;\n  width: 48px;\n}\n.connections-profile-image-container .profile-image .profile-image-image {\n  height: 48px;\n  width: 48px;\n}\n.connections-profile-image-container .profile-image .profile-image-letter {\n  line-height: 48px;\n}\n.connections-list-item {\n  width: 100%;\n  position: relative;\n}\n.connections-list-item .connections-accept-button {\n  opacity: 0;\n}\n.connections-list-item:first-child .connections-accept-button {\n  opacity: 1;\n}\n.connections-list-item:last-child .connections-company-container {\n  border-bottom: none;\n}\n.connections-list-item.is-open {\n  z-index: 1;\n}\n.connections-list-item:hover .connections-accept-button {\n  opacity: 1;\n}\n.connections-list-item:before,\n.connections-list-item:after {\n  content: \" \";\n  display: table;\n}\n.connections-list-item:after {\n  clear: both;\n}\n.connections-search-bar {\n  position: relative;\n  line-height: 36px;\n  height: 36px;\n  float: right;\n  margin-top: 6px;\n  clear: right;\n}\n.connections-search-bar.search-header-tool-bar {\n  width: auto;\n}\n.connections-search-bar.search-header-search-bar {\n  width: 100%;\n}\n.connections-search-bar .connections-more-options {\n  float: none;\n  display: inline-block;\n}\n.connections-search-bar .connections-more-options .connections-action-drop-down {\n  z-index: 1001;\n  top: 36px;\n}\n.connections-search-bar .more-vert-label {\n  font-size: 16px;\n}\n.connections-search-bar .tc-icon-close,\n.connections-search-bar .tc-icon-search {\n  position: absolute;\n  right: 6px;\n  padding-left: 12.25px;\n}\n.connections-search-bar .connections-more-options,\n.connections-search-bar .tc-icon-cloud-download,\n.connections-search-bar .tc-icon-close,\n.connections-search-bar .tc-icon-menu,\n.connections-search-bar .tc-icon-search {\n  cursor: pointer;\n  vertical-align: middle;\n  line-height: 36px;\n  font-size: 18px;\n  color: rgba(0, 0, 0, 0.26);\n}\n.connections-search-bar .connections-more-options:hover,\n.connections-search-bar .tc-icon-cloud-download:hover,\n.connections-search-bar .tc-icon-close:hover,\n.connections-search-bar .tc-icon-menu:hover,\n.connections-search-bar .tc-icon-search:hover {\n  color: #ff4081;\n  transition: all 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-search-bar .tc-icon-cloud-download {\n  font-size: 24px;\n  margin: 0px 6px;\n}\n.connections-search-bar .connections-search-input {\n  float: left;\n  line-height: 36px;\n  height: 36px;\n  border: 0;\n  opacity: 1;\n  display: inline-block;\n  border-bottom: 2px solid #e8e8e8;\n  background-color: #f5f5f5;\n  transform-origin: 100% 100%;\n  width: 99.5%;\n  position: relative;\n  transition: transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-search-bar .connections-search-input:focus {\n  outline: 0;\n}\n.request-action-buttons {\n  display: inline;\n  position: relative;\n  vertical-align: middle;\n  cursor: pointer;\n  margin-right: 16px;\n}\n.request-action-buttons.accept-button {\n  color: green;\n}\n.request-action-buttons.reject-button {\n  margin-right: 8px;\n}\n.connections-company-name {\n  padding-left: 5px;\n  max-width: 65%;\n  word-wrap: break-word;\n  display: inline-block;\n  vertical-align: top;\n  overflow: auto;\n  clear: both;\n}\n.connections-company-name.is-link .connections-list-header {\n  color: #00bcd4;\n}\n.connections-company-name.is-link .connections-list-header:hover {\n  cursor: pointer;\n  color: #ff4081;\n}\n.connections-widget {\n  padding: 8px 0;\n  width: 100%;\n  margin-bottom: 8px;\n}\n.connections-widget .connections-widget-link {\n  display: block;\n  position: relative;\n  line-height: 16px;\n  padding: 16px;\n  overflow: hidden;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-widget .connections-widget-link:focus {\n  outline: none;\n}\n.connections-widget .connections-widget-link.is-zero {\n  color: #bdbdbd;\n}\n.connections-widget .connections-widget-link:after {\n  content: '';\n  position: absolute;\n  top: 0px;\n  left: -3px;\n  width: 3px;\n  height: 100%;\n  background-color: #ff4081;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-widget .connections-widget-link:hover:after {\n  transform: translate3d(3px, 0px, 0px);\n  background-color: #ff4081;\n}\n.connections-widget .connections-widget-link:hover .counter {\n  background-color: #ff4081;\n}\n.connections-widget .connections-widget-link.is-active {\n  background-color: #f5f5f5;\n  cursor: default;\n}\n.connections-widget .connections-widget-link.is-active:after {\n  transform: translate3d(3px, 0px, 0px);\n  background-color: #00bcd4;\n}\n.connections-widget .connections-widget-link.is-active .counter {\n  background-color: #00bcd4;\n}\n.connections-widget .connections-widget-link.is-active:hover {\n  color: #00bcd4;\n}\n.connections-widget .connections-widget-link.is-active:hover:after {\n  background-color: #00bcd4;\n}\n.connections-widget .counter {\n  display: inline-block;\n  background-color: #00bcd4;\n  float: right;\n  color: #ffffff;\n  line-height: 18px;\n  font-size: 12px;\n  margin-top: -1px;\n  min-width: 18px;\n  text-align: center;\n  border-radius: 9px;\n  padding: 0 5px;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-widget .counter.is-zero {\n  background-color: #bdbdbd;\n  color: #f5f5f5;\n}\n.partnerbutton,\n.addbutton {\n  display: block;\n  width: calc(100% - 32px);\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 16px;\n}\n.partnerbutton {\n  background-color: #eeeeee;\n}\n.connections {\n  width: 100%;\n  height: 100%;\n}\n.mui-tooltip {\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.connections-tag-contianer {\n  display: inline-block;\n  margin: .125em;\n  background-color: #e8e8e8;\n  vertical-align: middle;\n  border-color: #e8e8e8;\n  background-image: none;\n  padding: 3px 8px;\n  color: rgba(0, 0, 0, 0.6);\n  text-transform: none;\n  font-weight: 700;\n  border-radius: 15px;\n  box-sizing: border-box;\n  transition: background .2s ease;\n}\n.connections-tag-contianer .connections-tag-name {\n  display: inline-block;\n  float: left;\n  clear: left;\n}\n.connections-tag-contianer .tc-icon-close {\n  display: inline-block;\n  float: right;\n  font-size: 12px;\n  line-height: 24px;\n  padding-left: 10px;\n  clear: right;\n  cursor: pointer;\n}\n.type-ahead-search-input {\n  width: 100%;\n  background-color: #e8e8e8;\n  color: black;\n  line-height: 24px;\n  border: none;\n  margin-bottom: 12px;\n  border-radius: 2px;\n  padding: 8px;\n}\n.type-ahead-search-input:focus {\n  outline: 0;\n}\n.type-ahead-input-add {\n  position: absolute;\n  color: green;\n}\n.type-ahead-container {\n  line-height: 24px;\n}\n.individual-tag {\n  line-height: 36px;\n  border-bottom: 2px solid #e8e8e8;\n}\n.individual-tag .tc-icon-close {\n  float: right;\n  line-height: 36px;\n  vertical-align: middle;\n  cursor: pointer;\n}\n.tags-modal .mui-dialog-window-contents {\n  max-width: none;\n  width: 25%;\n}\n.connections-tags-container {\n  width: 100%;\n}\n.type-ahead-options-container {\n  overflow: auto;\n  width: 95%;\n}\n.connections-typeahead-tag-icon {\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 40px;\n  cursor: pointer;\n  position: absolute;\n  right: 55px;\n}\n.connections-company-container {\n  padding-left: 0px;\n  padding: 16px 0px;\n  min-height: 80px;\n  display: inline-block;\n  float: right;\n  display: flex;\n  justify-content: space-between;\n  margin-right: 18px;\n}\n.connections-company-container .connections-typeahead-container,\n.connections-company-container .connections-tags-container {\n  display: inline-block;\n  position: relative;\n}\n.connections-company-container .connections-typeahead-container .connections-tags-tag-icon,\n.connections-company-container .connections-tags-container .connections-tags-tag-icon {\n  font-size: 16px;\n  margin-left: 2px;\n  padding: 0px 4px;\n  cursor: pointer;\n}\n.connections-company-container .connections-typeahead-container .connections-tags,\n.connections-company-container .connections-tags-container .connections-tags {\n  color: #00bcd4;\n  font-weight: 700;\n  cursor: pointer;\n  font-size: 0.9em;\n  position: relative;\n  box-sizing: border-box;\n  display: inline-block;\n  text-align: center;\n  float: left;\n  vertical-align: baseline;\n}\n.connections-company-container .connections-typeahead-container .connections-tags:hover,\n.connections-company-container .connections-tags-container .connections-tags:hover {\n  color: #ff4081;\n}\n.connections-company-container .connections-typeahead-container .connection-typeahead-tag-icon {\n  display: inline-block;\n  float: right;\n  vertical-align: super;\n  font-size: 0.9em;\n  line-height: 24px;\n  padding-left: 10px;\n  clear: right;\n  cursor: pointer;\n}\n.connections-company-container .connections-typeahead-container .connections-tag-contianer {\n  display: inline-block;\n  margin-bottom: 8px;\n  background-color: #e8e8e8;\n  border-color: #e8e8e8;\n  background-image: none;\n  padding: 2px 6px;\n  color: rgba(0, 0, 0, 0.6);\n  text-transform: none;\n  font-weight: 700;\n  border-radius: .2857rem;\n  box-sizing: border-box;\n  transition: background .2s ease;\n}\n.connections-company-container .connections-typeahead-container .connections-tag-contianer .connections-tag-name {\n  display: inline-block;\n  font-size: 0.9em;\n  float: left;\n  clear: left;\n}\n.connections-company-container .connections-typeahead-container .connections-tag-contianer .tc-icon-close {\n  display: inline-block;\n  float: right;\n  font-size: 0.9em;\n  line-height: 24px;\n  padding-left: 10px;\n  clear: right;\n  cursor: pointer;\n}\n.connections-company-container .connections-tags-container .connection-tags-tag-icon {\n  display: none;\n  float: left;\n}\n.connections-company-container .connections-tags-container:hover .connections-tags-tag-icon {\n  display: inline-block;\n}\n.connections-typeahead-container {\n  width: 100%;\n}\n.connections-typeahead-container .type-ahead-search-input {\n  border-radius: 3px;\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);\n  padding-left: 10px;\n  width: calc(100% - 40px);\n  position: relative;\n  float: left;\n  display: inline-block;\n  background-color: #fafafa;\n  min-height: 24px;\n  transform-origin: 100% 100%;\n  opacity: 1;\n  transition: transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.connections-typeahead-container .type-ahead-search-input.is-closed {\n  transform: scaleX(0);\n  opacity: 0;\n}\n.connections-typeahead-container .type-ahead-search-input:focus {\n  outline: 0;\n}\n.connections-typeahead-container .connections-typeahead-tag-icon {\n  display: inline-block;\n  float: right;\n  vertical-align: super;\n  font-size: 24px;\n  line-height: 24px;\n  padding-left: 5px;\n  padding-right: 5px;\n  clear: right;\n  cursor: pointer;\n}\n.new-connection-container .csvRow {\n  clear: both;\n}\n.new-connection-container .csvItem,\n.new-connection-container .multi-select,\n.new-connection-container input {\n  width: 200px;\n}\n.new-connection-container .csvItem,\n.new-connection-container .multi-select {\n  margin-left: 10px;\n  float: left;\n}\n.new-connection-container .csvItem:first-of-type,\n.new-connection-container .multi-select:first-of-type {\n  margin-left: 0px;\n}\n.new-connection-container .tc-card {\n  font-size: 16px;\n  line-height: 28px;\n  max-height: 500px;\n}\n.new-connection-container .tc-card.send-email-card {\n  max-height: none;\n}\n.new-connection-container .tc-card .connections-splash-details {\n  width: 291px;\n  text-align: left;\n  margin: 20px auto;\n}\n.new-connection-container .tc-card .connections-splash-details ul {\n  list-style-type: none;\n}\n.new-connection-container .tc-card .connections-splash-details ul li {\n  margin-bottom: 5px;\n}\n.new-connection-container .tc-card .connections-splash-details .tc-icon {\n  margin-right: 6px;\n  font-size: 24px;\n  color: #00bcd4;\n  line-height: 28px;\n  float: left;\n}\n.exchange-rates-long-card {\n  position: relative;\n  display: block;\n  margin: 20px 256px auto;\n  clear: both;\n  overflow: hidden;\n}\n.justify-rates-paragraph {\n  font-size: 16px;\n  margin-bottom: 5%;\n  color: rgba(0, 0, 0, 0.54);\n  text-align: justify;\n  -webkit-hyphens: auto;\n  -moz-hyphens: auto;\n  hyphens: auto;\n}\n.hyphen-get-started {\n  color: #00bcd4;\n  font-size: 16px;\n  margin-bottom: 5%;\n  -webkit-hyphens: auto;\n  -moz-hyphens: auto;\n  hyphens: auto;\n}\n.new-contract-paper {\n  margin: 24px 128px auto;\n  position: relative;\n  clear: both;\n  overflow: auto;\n}\n.more-vert-link {\n  clear: both;\n  display: inline-block;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.terms-conditions-overlay {\n  width: 100%;\n  text-align: center;\n}\n.terms-conditions-content {\n  width: 448px !important;\n}\n.add-circle-icon:before {\n  font-family: 'Material Icons';\n  content: \"\\E147\";\n  position: relative;\n  top: -4px;\n}\n.connection-list-search-input {\n  border: none;\n  margin-left: 2%;\n  font-size: 14px;\n}\n.connection-list-search-input:focus {\n  outline: 0;\n}\n.add-individ-connection-dialog {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n.edit-button {\n  display: flex;\n  align-items: center;\n  color: #00bcd4;\n  margin-right: 4px;\n  cursor: pointer;\n  margin-left: auto;\n}\n.season-start-and-end-dates {\n  display: flex;\n  margin-bottom: 12px;\n  align-items: flex-end;\n}\n.retail-rate {\n  display: flex;\n  font-size: 12px;\n  margin-top: 12px;\n}\n.rates-saved {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: auto;\n  margin: 0 auto;\n  position: relative;\n  background-color: #00bcd4;\n  color: #fff;\n  padding: 18px;\n}\n.retail-rate {\n  display: flex;\n  font-size: 12px;\n  padding-top: 4px;\n}\n.without-retail-rate {\n  display: flex;\n  font-size: 12px;\n  margin-top: 12px;\n}\n.Select-menu-outer {\n  z-index: 2000 !important;\n  position: absolute;\n}\n.Select-multi-value-wrapper {\n  max-height: 150px;\n  overflow-y: scroll;\n}\n.DayPicker-Month:nth-child(odd) {\n  float: right;\n}\n@media only screen and (max-width: 1008px) {\n  .step-container .step-grey-line {\n    display: none;\n  }\n}\n@media only screen and (max-width: 611px) {\n  .step-container .step-title {\n    display: none;\n  }\n}\n@media screen and (min-width: 1232px) {\n  .step-container .step-title {\n    font-size: 14px;\n  }\n}\n.step-grey-line {\n  display: inline-block;\n  border-bottom: solid #BDBDBD;\n  border-width: thin;\n  position: relative;\n  margin-left: auto;\n  bottom: 8px;\n}\n_::-webkit-full-page-media .step-grey-line,\n_:future .step-grey-line,\n:root .step-grey-line {\n  margin-left: 20px;\n  margin-top: 22px;\n  margin-right: -20px;\n}\n.step-container {\n  display: inline-block;\n  vertical-align: middle;\n}\n.stepper-container {\n  padding: 17px;\n  box-shadow: 0px 1px 1px #E0E0E0;\n  display: inline-block;\n  width: 100%;\n}\n.stepper-container li {\n  display: inline-block;\n  text-align: center;\n  cursor: pointer;\n  float: left;\n}\n.stepper-container li:before {\n  float: left;\n}\n.stepper-container li.stepper-container-todo {\n  color: #BDBDBD;\n  cursor: default;\n}\n.stepper-container li.stepper-container-todo:before {\n  content: \" \";\n  background: #BDBDBD;\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  color: #FFFFFF;\n  line-height: 1.6em;\n  font-size: 16px;\n}\n.stepper-container li.stepper-container-doing {\n  color: #000000;\n  opacity: 87%;\n  cursor: default;\n}\n.stepper-container li.stepper-container-doing:before {\n  content: \"\";\n  background: #00bcd4;\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  color: #FFFFFF;\n  line-height: 1.6em;\n  font-size: 16px;\n}\n.stepper-container li.stepper-container-done:before {\n  font-family: 'Material Icons';\n  content: '\\E150';\n  color: #FFFFFF;\n  background: #00bcd4;\n  line-height: 1.7em;\n  border-radius: 1.2em;\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n}\n.step-title {\n  display: inline-block;\n  margin-left: 15px;\n  margin-top: 3px;\n  font-family: 'Roboto', sans-serif;\n  cursor: default;\n  float: left;\n  font-size: 1vw;\n}\nli.stepper-container-doing .step-title {\n  font-weight: 600;\n  color: #616161;\n}\nli.stepper-container-done .step-title {\n  color: #616161;\n}\n.stepper-body {\n  display: flex;\n}\n.contracting-left-nav-widget .contracting-left-nav-title {\n  font-weight: 600;\n  line-height: 36px;\n  margin-top: 12px;\n  margin-left: 18px;\n}\n.contracting-left-nav-widget .counter {\n  background-color: #e0e0e0;\n  color: #424242;\n  margin-top: 4px;\n  margin-right: 4px;\n}\n.contracting-left-nav-widget .content-with-icon {\n  color: #424242;\n  position: relative;\n  top: -4px;\n  margin-left: 8px;\n}\n.contracting-left-nav-widget .content-without-icon {\n  color: #424242;\n}\n.contracting-left-nav-widget .icon {\n  color: #424242;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link {\n  margin: 8px 0;\n  cursor: pointer;\n  display: block;\n  position: relative;\n  line-height: 16px;\n  padding: 12px;\n  padding-left: 16px;\n  overflow: hidden;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:focus {\n  outline: none;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-zero {\n  color: #bdbdbd;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:after {\n  content: '';\n  position: absolute;\n  top: 0px;\n  left: -3px;\n  width: 3px;\n  height: 100%;\n  background-color: #ff4081;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:hover:after {\n  transform: translate3d(3px, 0px, 0px);\n  background-color: #ff4081;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:hover .counter {\n  color: #ffffff;\n  background-color: #ff4081;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:hover .content-with-icon {\n  color: #ff4081;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:hover .content-without-icon {\n  color: #ff4081;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link:hover .icon {\n  color: #ff4081;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active {\n  cursor: default;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active:after {\n  transform: translate3d(3px, 0px, 0px);\n  background-color: #00bcd4;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active .counter {\n  color: white;\n  background-color: #00bcd4;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active .content-with-icon {\n  color: #00bcd4;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active .content-without-icon {\n  color: #00bcd4;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active .icon {\n  color: #00bcd4;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active:hover {\n  color: #00bcd4;\n}\n.contracting-left-nav-widget .contracting-left-nav-widget-link.is-active:hover:after {\n  background-color: #00bcd4;\n}\n.dashboard-checkbox {\n  margin-top: 16px;\n  margin-left: 16px;\n  float: left;\n  width: 15% !important;\n}\n.dashboard-profile-image {\n  margin-top: 8px !important;\n  height: 40px !important;\n  width: 40px !important;\n}\n.activities-profile-image {\n  height: 40px !important;\n  width: 40px !important;\n}\n.dashboard-parent-row-card {\n  font-size: 13px;\n  line-height: 52px;\n}\n.dashboard-parent-row-card .card-header {\n  padding: 0 !important;\n  height: 44px !important;\n}\n.dashboard-parent-row-card .company-parent-div {\n  width: 15%;\n  float: left;\n}\n.dashboard-parent-row-card .company-parent-right {\n  width: 85%;\n  float: right;\n}\n.dashboard-parent-row-card .company-parent-right span {\n  display: inline-block;\n  color: black;\n}\n.dashboard-parent-row-card .contracting-sign-up-company-parent-div {\n  width: 7%;\n  float: left;\n}\n.dashboard-parent-row-card .contracting-sign-up-company-parent-right {\n  width: 93%;\n  float: right;\n}\n.dashboard-parent-row-card .contracting-sign-up-company-parent-right span {\n  display: inline-block;\n  color: black;\n}\n.assign-folder-dialog {\n  display: flex;\n  flex-direction: row;\n}\n.dashboard-header {\n  display: flex;\n  background-color: #00b3cf;\n  height: 48px;\n  color: white;\n  width: 100.1%;\n}\n.grey-background-on-hover:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.pieChart:hover {\n  cursor: pointer;\n}\n.report {\n  cursor: pointer;\n}\n.report:hover {\n  border-left: 3px solid #ff4081;\n}\n.report:after {\n  display: block;\n  font-weight: bold;\n  height: 1px;\n  color: transparent;\n  overflow: hidden;\n  visibility: hidden;\n  margin-bottom: -1px;\n}\n.report.is-active {\n  cursor: default;\n  border-left: 3px solid #00bcd4;\n}\n.contracting-comment-box {\n  border: none;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  margin-left: 20px;\n  padding: 0;\n  width: 90%;\n  max-with: 90%;\n  float: right;\n  resize: vertical;\n}\n.contracting-comment-box:focus {\n  outline: 0;\n}\n.clickEditCell {\n  background-color: transparent;\n  border: none;\n  width: 48px;\n}\n.clickEditCell:focus {\n  color: #ff4081;\n}\n.rates-table {\n  display: flex;\n  font-size: 12px;\n}\n.rates-table-titles {\n  display: flex;\n  font-size: 12px;\n  padding-top: 4px;\n}\n.right-side-product-flex {\n  display: flex;\n  margin-bottom: 12px;\n}\n.add-item-card-flex {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  max-width: 300px;\n}\n.product-column-flex {\n  display: flex;\n  clear: both;\n}\n.check-in-check-out {\n  display: flex;\n}\n.inclusion-exclusion {\n  display: flex;\n  margin: 24px 0;\n  font-weight: 600;\n  font-size: 12px;\n}\n.contract-window {\n  display: flex;\n}\n.mouse-over-edit {\n  display: flex;\n}\n::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  font-style: italic;\n}\n:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  font-style: italic;\n}\n::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  font-style: italic;\n}\n:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  font-style: italic;\n}\n::-ms-input-placeholder {\n  /* Microsoft Edge */\n  font-style: italic;\n}\n.settings-left-nav {\n  position: fixed;\n  height: 100%;\n  margin-top: -96px;\n}\n.settings-left-nav .settings-left-nav-inner {\n  margin-top: 96px;\n}\n.settings-left-nav .settings-left-nav-heading {\n  font-weight: bold;\n  font-size: 14px;\n  padding-left: 16px;\n  line-height: 48px;\n  text-transform: uppercase;\n  border-bottom: solid 1px #eeeeee;\n}\n.multi-select-input-container,\n.input-container {\n  position: relative;\n  margin: 12px;\n  margin-left: 0px;\n  display: inline-block;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n}\n.multi-select-input-container .multi-select-input,\n.input-container .multi-select-input,\n.multi-select-input-container input,\n.input-container input {\n  margin: 0;\n  width: 100%;\n  outline: 0;\n  tap-highlight-color: rgba(255, 255, 255, 0);\n  text-align: left;\n  line-height: 1.2142em;\n  padding: .67861em 1em;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  color: rgba(0, 0, 0, 0.8);\n  border-radius: .2857rem;\n  text-overflow: ellipsis;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  box-shadow: none;\n}\n.form-container {\n  position: relative;\n  max-width: 72%;\n  margin: 0px auto;\n  display: block;\n}\n.form-container .error-message {\n  display: none;\n}\n.form-container .tc-section-heading {\n  padding: 32px 0px;\n}\n.form-container .form-header {\n  padding-bottom: .25rem;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  font-weight: 700;\n  line-height: 1.33em;\n  text-transform: none;\n  color: rgba(0, 0, 0, 0.8);\n}\n.form-container.is-disabled-form .is-not-valid-multiselect {\n  border-color: #dbb1b1;\n  border-radius: 0 .2857rem .2857rem 0;\n  background: #fff0f0;\n}\n.form-container.is-disabled-form .is-not-valid-multiselect .multi-select-input {\n  background: #fff0f0;\n  color: #d95c5c;\n}\n.form-container.is-disabled-form .is-not-valid-multiselect ~ .error-message {\n  color: #d95c5c;\n  opacity: .7;\n  display: block;\n}\n.form-container.is-disabled-form :required:invalid {\n  background: #fff0f0;\n  border-color: #dbb1b1;\n  color: #d95c5c;\n  border-radius: 0 .2857rem .2857rem 0;\n}\n.form-container.is-disabled-form :required:invalid ~ .error-message {\n  color: #d95c5c;\n  opacity: .7;\n  display: block;\n}\n.form-container.is-disabled-form :required:invalid:focus {\n  box-shadow: 2px 0 0 0 #d95c5c inset;\n}\n.field {\n  display: block;\n  clear: both;\n  margin: 0 0 1em;\n}\n.field .form-label {\n  display: block;\n  float: right;\n  margin: 0 0 .2857rem;\n  color: rgba(0, 0, 0, 0.8);\n  font-size: .9285em;\n  font-weight: 700;\n  text-transform: none;\n}\n.field textarea {\n  height: 64px;\n  min-height: 64px;\n}\ntextarea {\n  vertical-align: top;\n  width: 100%;\n  overflow: auto;\n  margin: 0;\n  padding: .78571em 1em;\n  background: #fff;\n  border: 1px solid rgba(39, 41, 43, 0.15);\n  outline: 0;\n  color: rgba(0, 0, 0, 0.8);\n  border-radius: .2857rem;\n  box-shadow: 0 0 transparent inset;\n  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  font-size: 1em;\n  max-width: 100%;\n}\ntextarea:required.is-invalid {\n  background: #fff0f0;\n  border-color: #dbb1b1;\n  color: #d95c5c;\n  border-radius: 0 .2857rem .2857rem 0;\n}\ntextarea:required.is-invalid:focus {\n  box-shadow: 2px 0 0 0 #d95c5c inset;\n}\n.form-line {\n  position: relative;\n  width: 100%;\n}\n.form-line .form-line-three {\n  display: inline-block;\n  position: relative;\n  width: calc(100% / 3 - 8px);\n}\n.form-line .form-line-three:nth-child(2) {\n  margin: 0px 12px;\n}\n.form-line .form-line-four {\n  display: inline-block;\n  position: relative;\n  margin: 0px 12px 0px 0px;\n  width: calc(100% / 4 - 9px);\n}\n.form-line .form-line-four:last-child {\n  margin: 0;\n}\n.form-line .form-line-two {\n  display: inline-block;\n  position: relative;\n  width: calc(100%/2 - 6px);\n  vertical-align: middle;\n  clear: both;\n}\n.form-line .form-line-two:first-child {\n  margin-right: 12px;\n}\n.form-dialog {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.inline-error {\n  color: #FF5E5C;\n  line-height: 18px;\n  margin-bottom: 12px;\n  border-radius: 4px;\n  opacity: 0;\n  padding: 20px 40px;\n  background: none repeat scroll 0 0 #FFF5F5;\n  transition: opacity 0.15s linear;\n  padding: 16px 23px 16px 16px;\n  font-size: 12px;\n}\n.inline-error.opacity {\n  opacity: 1;\n}\n.inline-error .close {\n  font-size: 19px;\n  cursor: pointer;\n  float: right;\n  opacity: .2;\n  margin-top: -5px;\n  margin-right: -8px;\n}\n.inline-error .close:hover {\n  opacity: .6;\n}\n.multi-select-input-container,\n.input-container {\n  position: relative;\n  margin: 12px;\n  margin-left: 0px;\n  display: inline-block;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n}\n.multi-select-input-container .multi-select-input,\n.input-container .multi-select-input,\n.multi-select-input-container input,\n.input-container input {\n  margin: 0;\n  width: 100%;\n  outline: 0;\n  tap-highlight-color: rgba(255, 255, 255, 0);\n  text-align: left;\n  line-height: 1.2142em;\n  padding: .67861em 1em;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  color: rgba(0, 0, 0, 0.8);\n  border-radius: .2857rem;\n  text-overflow: ellipsis;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  box-shadow: none;\n}\n.legacy-frame {\n  overflow: hidden;\n}\n.legacy-frame,\n.legacy-frame iframe {\n  height: 100%;\n  width: 100%;\n  border: none;\n}\n.legacy-frame .spinny-gif {\n  display: block;\n  position: fixed;\n  top: calc(50% - 64px);\n  left: calc(50% - 42px);\n}\n.legacy-frame .spinny-gif.hidden {\n  display: none;\n}\n@keyframes loader {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.dimmer {\n  z-index: 2;\n  border-radius: inherit;\n  display: block;\n  opacity: 1;\n  position: fixed;\n  top: 64px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  vertical-align: middle;\n  background: rgba(0, 0, 0, 0.85);\n  line-height: 1;\n  animation-fill-mode: both;\n  animation-duration: .5s;\n  transition: background-color 0.5s linear;\n  user-select: none;\n  will-change: opacity;\n}\n.dimmer:after {\n  box-sizing: inherit;\n}\n.dimmer .loader {\n  color: #ffffff;\n  display: block;\n  min-width: 64px;\n  min-height: 64px;\n  font-size: 1em;\n  position: fixed;\n  top: calc(50% - 64px);\n  left: calc(50% - 48px);\n  margin: 0px;\n  text-align: center;\n  z-index: 2;\n  transform: translateX(-50%), translateY(-50%);\n}\n.dimmer .loader:before {\n  border-color: rgba(255, 255, 255, 0.15);\n  width: 64px;\n  height: 64px;\n  margin: 0em 0em 0em -1.12925em;\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  border-radius: 500rem;\n}\n.dimmer .loader:after {\n  position: absolute;\n  content: '';\n  top: 0%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  animation: loader 0.6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #aaaaaa transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n.dimmer.hidden {\n  display: none;\n}\n.l-app-content .l-left-nav {\n  background-color: #fff;\n  box-shadow: none;\n}\n.l-app-content .l-left-nav .location-head {\n  margin-top: 96px;\n}\n.l-app-content .l-left-nav .location-head .addbutton {\n  margin-bottom: 30px;\n}\n.l-app-content .l-left-nav .location-head .segment-content {\n  text-align: center;\n}\n.l-app-content .l-left-nav .location-head .segment-content h4 {\n  padding-top: 0;\n  margin-bottom: 0;\n  font-size: 18px;\n}\n.l-app-content .l-left-nav .location-head .segment-content .l-paper-split-segment {\n  padding: 0 12px;\n}\n.l-app-content .l-left-nav .location-head .type-content {\n  text-align: center;\n}\n.l-app-content .l-left-nav .location-head .type-content h4 {\n  padding-top: 0;\n  margin-bottom: 0;\n  font-size: 18px;\n}\n.l-app-content .l-left-nav .location-head .type-content .l-paper-split-type {\n  padding: 0 12px;\n}\n.l-app-content .l-left-nav .location-head .profile-link-image {\n  /*position: absolute;\n        top: 30px;\n        left: 66px;*/\n  height: 128px;\n  width: 128px;\n  margin: 20px auto;\n}\n.l-app-content .l-left-nav .location-head .profile-link-image .profile-image-letter {\n  line-height: 128px;\n  font-size: 35px;\n}\n.l-app-content .l-left-nav-content .location-description {\n  margin-bottom: 10px;\n}\n.l-app-content .l-left-nav-content .location-description .short-info {\n  height: 126px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.l-app-content .l-left-nav-content .location-description .location-card {\n  margin-bottom: 30px;\n  position: relative;\n}\n.l-app-content .l-left-nav-content .location-description .location-card .tc-card-image-header {\n  height: 320px;\n  width: 100%;\n}\n.l-app-content .l-left-nav-content .location-description .location-card .tc-card-contents .load-more {\n  position: absolute;\n  right: 15px;\n  bottom: 10px;\n}\n.l-app-content .l-left-nav-content .location-description .location-card .cardGradient {\n  bottom: 21px;\n}\n.l-app-content .l-left-nav-content .location-product .short-product {\n  height: 150px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.l-app-content .l-left-nav-content .location-product .location-card {\n  margin-bottom: 30px;\n  position: relative;\n}\n.l-app-content .l-left-nav-content .location-product .location-card .tc-card-contents .product-box {\n  display: block;\n  margin-bottom: 12px;\n  clear: both;\n}\n.l-app-content .l-left-nav-content .location-product .location-card .tc-card-contents .product-box img {\n  float: left;\n  width: 48px;\n  height: 48px;\n}\n.l-app-content .l-left-nav-content .location-product .location-card .tc-card-contents .product-box .product-info {\n  margin-left: 70px;\n}\n.l-app-content .l-left-nav-content .location-product .location-card .tc-card-contents .product-box .product-info p {\n  padding-top: 0;\n  margin-bottom: 8px;\n}\n.l-app-content .l-left-nav-content .location-product .location-card .tc-card-contents .load-more {\n  position: absolute;\n  right: 15px;\n  bottom: 10px;\n}\n.l-app-content .l-left-nav-content .location-map {\n  position: relative;\n  height: 300px;\n  margin-bottom: 20px;\n}\n.l-app-content .l-left-nav-content .location-map .gmap {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.l-app-content .l-left-nav-content .location-contacts {\n  margin-bottom: 20px;\n}\n.l-app-content .l-left-nav-content .location-contacts .contact-details {\n  margin-bottom: 20px;\n}\n.l-app-content .l-left-nav-content .location-contacts .contact-details .contact h5 {\n  width: 172px;\n  display: inline-block;\n  font-size: 14px;\n  margin-bottom: 3px;\n  line-height: 20px;\n}\n.l-app-content .l-left-nav-content .location-contacts .contact-details .contact-info h6 {\n  width: 172px;\n  display: inline-block;\n  margin-bottom: 0px;\n  font-size: 13px;\n  line-height: 20px;\n}\n.l-app-content .l-left-nav-content .location-contacts .contact-details hr {\n  margin-bottom: 0px;\n}\n.location-address {\n  margin-bottom: 30px;\n  font-size: 14px;\n}\n.location-address .location-address-header {\n  font-size: 16px;\n}\n.location-address p {\n  padding-top: 0px;\n}\n.multi-select {\n  position: relative;\n  user-select: none;\n}\n.multi-select .multi-select-dropdown {\n  position: absolute;\n  visibility: hidden;\n  height: auto;\n  width: 100%;\n  z-index: 2;\n  transform: translate3d(0, -36px, 0);\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.multi-select .multi-select-dropdown.is-vert-drop-down {\n  width: 250px;\n  left: -16px;\n  top: 12px;\n}\n.multi-select .multi-select-dropdown .mui-paper {\n  margin-top: 0px;\n  margin-bottom: 6.25px;\n}\n.multi-select .multi-select-dropdown .multi-select-search-bar {\n  position: relative;\n  visibility: hidden;\n  line-height: 36px;\n  opacity: 0;\n}\n.multi-select .multi-select-dropdown .multi-select-search-bar .tc-icon-search {\n  vertical-align: middle;\n  padding-left: 6.25px;\n}\n.multi-select .multi-select-dropdown .multi-select-search-bar .multi-select-search-input {\n  width: calc(100% - 30.25px);\n  position: relative;\n  float: right;\n  display: inline-block;\n  min-height: 24px;\n  height: 36px;\n  border-color: transparent;\n}\n.multi-select .multi-select-dropdown .multi-select-search-bar .multi-select-search-input:focus {\n  outline: 0;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container {\n  z-index: 2;\n  position: relative;\n  visibility: hidden;\n  opacity: 0;\n  cursor: pointer;\n  max-height: 300px;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container.is-scrollable {\n  overflow: scroll;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container.overflow-hidden {\n  overflow: hidden;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container .multi-select-option-container {\n  z-index: 2;\n  padding: 6.25px;\n  width: 50%;\n  display: inline-block;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container .multi-select-option-container.is-smaller-select {\n  width: 100%;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container .multi-select-option-container .multi-select-option-checkbox {\n  z-index: 2;\n  width: 10%;\n  height: 100%;\n  display: inline-block;\n  visibility: hidden;\n}\n.multi-select .multi-select-dropdown .multi-select-options-container .multi-select-option-container .multi-select-option {\n  z-index: 2;\n  color: rgba(0, 0, 0, 0.54);\n  width: 90%;\n  float: right;\n  display: inline-block;\n  min-height: 1.2em;\n}\n.multi-select .multi-select-dropdown.is-open {\n  visibility: visible;\n  transform: translate3d(0, 0px, 0);\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.multi-select .multi-select-dropdown.is-open .multi-select-options-container {\n  height: auto;\n  background-color: white;\n  z-index: 2;\n  max-height: 300px;\n  visibility: visible;\n  opacity: 1;\n}\n.multi-select .multi-select-dropdown.is-open .multi-select-options-container .is-checked .multi-select-option-checkbox {\n  color: #4caf50;\n  visibility: visible;\n}\n.multi-select .multi-select-dropdown.is-open .multi-select-options-container .is-checked .multi-select-option {\n  color: #4caf50;\n}\n.multi-select .multi-select-dropdown.is-open .multi-select-search-bar {\n  visibility: visible;\n  background-color: white;\n  opacity: 1;\n  z-index: 2;\n}\n.multi-select .multi-select-input-container {\n  margin-bottom: 6.25px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: .2857rem;\n}\n.multi-select .multi-select-input-container .multi-select-input {\n  border: none;\n  width: calc(100% - 24px);\n  cursor: pointer;\n}\n.multi-select .multi-select-input-container .multi-select-input-dropdown {\n  cursor: pointer;\n  display: inline-block;\n  width: 24px;\n  line-height: 40px;\n  float: right;\n  background-color: #f5f5f5;\n}\n.multi-select .multi-select-input-container .multi-select-input-dropdown-arrow {\n  display: inline-block;\n  vertical-align: middle;\n}\n.onboarding-image-background {\n  position: absolute;\n  top: 0;\n  left: auto;\n  opacity: 0.3;\n  display: inline-block;\n  vertical-align: bottom;\n  overflow: hidden;\n  background-color: #cacccd;\n  backface-visibility: hidden;\n  width: 225px;\n  height: 225px;\n}\n.onboarding-image-container {\n  border-width: 0;\n  backface-visibility: hidden;\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  overflow: hidden;\n  background-color: #cacccd;\n  width: 225px;\n  height: 225px;\n  border-radius: 50%;\n}\n.onboarding-image-container.loader {\n  transition: all 0s linear;\n}\n.onboarding-image-container.loader:before {\n  position: absolute;\n  content: '';\n  top: calc(50% - 25px);\n  left: calc(50% - 25px);\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  border: 3px solid rgba(202, 204, 205, 0.15);\n}\n.onboarding-image-container.loader:after {\n  position: absolute;\n  content: '';\n  top: calc(50% - 25px);\n  left: calc(50% - 25px);\n  width: 50px;\n  height: 50px;\n  animation: loader .6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 100%;\n  border-color: #fff transparent transparent;\n  border-style: solid;\n  border-width: 3px;\n  box-shadow: 0 0 0 1px transparent;\n}\n.onboarding-image-container .profileViewImage {\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n}\n.tc-icon-office {\n  font-size: 100px;\n  margin: 0px 60.5px;\n  color: white;\n  line-height: 225px;\n}\n.tc-icon-office.normal-height {\n  line-height: 0px;\n}\n.submit-button {\n  width: 33%;\n}\n.on-boarding-card {\n  margin: 24px 0;\n}\n.on-boarding-card .onboarding-short-description-reminder {\n  margin-top: 0px;\n}\n.address-dialog-info {\n  white-space: pre;\n}\n.tc-icon-delete.onboarding-delete {\n  visibility: hidden;\n  z-index: -1;\n  position: absolute;\n  left: 201px;\n}\n.mui-dialog .mui-dialog-title,\n.mui-dialog h3 {\n  background-color: #f5f5f5;\n  padding: 0 24px;\n  border-radius: 2px 2px 0 0;\n  margin: 0;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 20px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n  line-height: 48px;\n}\n.mui-dialog .mui-dialog-content {\n  font-size: 13px;\n  line-height: 20px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.87);\n  font: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.standard-modal {\n  font-size: 13px !important;\n  line-height: 20px !important;\n  font-weight: 400 !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;\n}\n.standard-modal h3 {\n  background-color: #f5f5f5 !important;\n  padding: 0 24px !important;\n  border-radius: 2px 2px 0 0 !important;\n  margin: 0 !important;\n  font-size: 20px !important;\n  font-weight: 500 !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n  line-height: 48px !important;\n}\n.profile-image {\n  border-radius: 50%;\n  height: 44px;\n  width: 44px;\n  text-align: center;\n  overflow: hidden;\n}\n.profile-image .profile-image-image {\n  height: 44px;\n  width: 44px;\n  vertical-align: inherit;\n}\n.profile-image .profile-image-letter {\n  line-height: 44px;\n  font-size: 24px;\n  font-weight: 300;\n  border: solid 1px rgba(0, 0, 0, 0.12);\n}\n.profile-image .profile-image-letter {\n  border: solid 1px rgba(0, 0, 0, 0.12);\n  color: white;\n}\n.profile-image .profile-image-letter.is-grey {\n  background-color: darkgray;\n}\n.profile-image .profile-image-letter.is-red {\n  background-color: #f44336;\n}\n.profile-image .profile-image-letter.is-pink {\n  background-color: #e91e63;\n}\n.profile-image .profile-image-letter.is-purple {\n  background-color: #9c27b0;\n}\n.profile-image .profile-image-letter.is-deep-purple {\n  background-color: #673ab7;\n}\n.profile-image .profile-image-letter.is-indigo {\n  background-color: #3f51b5;\n}\n.profile-image .profile-image-letter.is-blue {\n  background-color: #2196f3;\n}\n.profile-image .profile-image-letter.is-light-blue {\n  background-color: #03a9f4;\n}\n.profile-image .profile-image-letter.is-cyan {\n  background-color: #00bcd4;\n}\n.profile-image .profile-image-letter.is-teal {\n  background-color: #009688;\n}\n.profile-image .profile-image-letter.is-green {\n  background-color: #4caf50;\n}\n.profile-image .profile-image-letter.is-deep-orange {\n  background-color: #ff5722;\n}\n.profile-link {\n  z-index: 1100;\n}\n.profile-link .profile-link-target {\n  cursor: pointer;\n}\n.profile-link .profile-link-dropdown-arrow {\n  float: right;\n  color: rgba(0, 0, 0, 0.54);\n  line-height: 48px;\n  margin-top: 8px;\n}\n.profile-link .profile-link-image {\n  float: left;\n  margin-top: 10px;\n  margin-left: 24px;\n}\n.profile-link .profile-link-container {\n  position: absolute;\n  top: 56px;\n  right: 0;\n  background-color: #ffffff;\n  width: 150px;\n  margin-top: 4px;\n  text-align: left;\n  opacity: 1;\n  transform: translate3d(0, 0, 0) scale(1);\n  transform-origin: top right;\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.profile-link .profile-link-container-contents {\n  padding: 8px 16px;\n}\n.profile-link .profile-link-support-link {\n  cursor: pointer;\n}\n.profile-link .profile-link-container-link {\n  display: block;\n  line-height: 36px;\n  margin-left: 0;\n  color: rgba(0, 0, 0, 0.54);\n  cursor: pointer;\n}\n.profile-link .profile-link-container-link:hover,\n.profile-link .profile-link-container-link.active {\n  color: #ff4081;\n}\n.profile-link .profile-link-container-link.profile-link-admin-link {\n  display: none;\n}\n.profile-link .profile-link-container-link.profile-link-billing-link {\n  display: none;\n}\n.profile-link.is-closed .profile-link-container {\n  top: -500px;\n  opacity: 0;\n  transform: translate3d(0, -20px, 0) scale(0);\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.profile-link.is-an-admin .profile-link-admin-link.profile-link-container-link {\n  display: block;\n}\n.profile-link.is-a-supplier .profile-link-billing-link.profile-link-container-link {\n  display: block;\n}\n.submit-button {\n  width: 33%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 24px;\n}\n.submit-button.loader {\n  position: relative;\n  transition: all 0s linear;\n  background-color: #00bcd4;\n  z-index: -1;\n}\n.submit-button.loader:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.15);\n}\n.submit-button.loader:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  animation: loader .6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #fff transparent transparent;\n  border-style: solid;\n  border-width: .2em;\n  box-shadow: 0 0 0 1px transparent;\n}\n.temp-connection-next-button.loader,\n.billing-button.loader {\n  position: relative;\n  transition: all 0s linear;\n  background-color: #e6e6e6;\n  z-index: -1;\n}\n.temp-connection-next-button.loader:before,\n.billing-button.loader:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.15);\n}\n.temp-connection-next-button.loader:after,\n.billing-button.loader:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  animation: loader .6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #fff transparent transparent;\n  border-style: solid;\n  border-width: .2em;\n  box-shadow: 0 0 0 1px transparent;\n}\n.image-input {\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  width: 100%;\n  opacity: 0;\n}\n.user_login {\n  /* width: 372px; */\n  height: 460px;\n  width: 372px;\n  position: relative;\n  left: 50%;\n  top: 96px;\n  margin: 0 0 0 -186px;\n  float: left;\n}\n.user_login .signin_form {\n  margin: 16px 0 0;\n  float: none;\n  padding: 16px 50px;\n  background: #ffffff;\n  border: 1px solid #d0d0d0;\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);\n  border-radius: 3px;\n  display: block;\n}\n.user_login .signin_form a.signin-link {\n  font-size: 12px;\n  color: #617189;\n}\n.user_login .signin_form a.signin-link:hover {\n  color: #005580;\n}\n.user_login .signin_form form {\n  margin-bottom: 18px;\n}\n.user_login .signin_form fieldset.control-group label.checkbox {\n  display: block;\n  font-size: 13px;\n  font-weight: normal;\n  line-height: 14px;\n  margin-bottom: 20px !important;\n  color: #5E7080;\n  cursor: pointer;\n  padding-left: 24px;\n}\n.user_login .signin_form fieldset.control-group label.checkbox input[type=checkbox] {\n  float: left;\n  margin: 0 0 0 -19px;\n  clear: both;\n  cursor: pointer;\n}\n.user_login .signin_form fieldset.control-group input[type=email],\n.user_login .signin_form fieldset.control-group input[type=password] {\n  box-sizing: content-box;\n  width: 330px;\n  height: 25px;\n  padding: 3px 5px;\n  margin-bottom: 9px;\n  font-size: 13px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n}\n.user_login .signin_form fieldset.control-group label.control-label {\n  color: #5E7080;\n  font-size: 16px;\n  line-height: 18px;\n  font-weight: bold;\n  display: block;\n  margin-bottom: 5px;\n}\n.signin-button {\n  border-style: none;\n  padding: 7px 14px;\n  font-size: 15px;\n  line-height: normal;\n  border-radius: 5px;\n  color: #ffffff;\n  background-color: #28B0DF;\n  cursor: pointer;\n  font-weight: 600;\n  outline: none;\n}\n.signin-button:hover {\n  border: none;\n}\n.signin-button.loader {\n  color: #28B0DF;\n  background-color: #28B0DF;\n  position: relative;\n  transition: all 0s linear;\n}\n.signin-button.loader:hover {\n  border: none;\n}\n.signin-button.loader:before {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  border-radius: 500rem;\n  border: 0.2em solid rgba(0, 0, 0, 0.15);\n}\n.signin-button.loader:after {\n  position: absolute;\n  content: '';\n  top: 50%;\n  left: 50%;\n  margin: -0.64285em 0 0 -0.64285em;\n  width: 1.2857em;\n  height: 1.2857em;\n  animation: loader .6s linear;\n  animation-iteration-count: infinite;\n  border-radius: 500rem;\n  border-color: #fff transparent transparent;\n  border-style: solid;\n  border-width: .2em;\n  box-shadow: 0 0 0 1px transparent;\n}\n.signin-header {\n  text-align: center;\n  padding-bottom: 10px;\n  margin-bottom: -10px;\n  line-height: 26px;\n  font-size: 24px;\n  color: #5E7080;\n}\n.type-ahead-options-container {\n  height: auto !important;\n  position: absolute;\n  z-index: 2;\n  display: block;\n  background-color: white;\n  max-height: 300px;\n  opacity: 1;\n  width: 95%;\n  cursor: pointer;\n}\n.type-ahead-options-container .type-ahead-option-container {\n  z-index: 2;\n  position: relative;\n  padding-left: 6.25px;\n  width: 100%;\n  height: 24px;\n  margin: 8px 0px;\n  display: block;\n}\n.type-ahead-options-container .type-ahead-option {\n  z-index: 2;\n  position: relative;\n  color: rgba(0, 0, 0, 0.54);\n  width: 100%;\n  display: inline-block;\n  min-height: 1.2em;\n}\n.integration-refresh {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  pointer: cursor;\n  cursor: pointer;\n  padding: 10px;\n  font-size: 18px;\n}\n.integration-contract-title {\n  font-size: 38px;\n}\n.integration-contract-label {\n  font-weight: 600;\n  font-size: 18px;\n}\n.integration-contract-detail {\n  font-size: 18px;\n}\n.integration-export {\n  margin-left: 14px;\n}\n.integration-left-nav {\n  position: fixed;\n  height: 100%;\n  margin-top: -96px;\n}\n.integration-left-nav .integration-left-nav-inner {\n  margin-top: 96px;\n}\n.integration-left-nav .integration-left-nav-heading {\n  font-size: 14px;\n  padding-left: 16px;\n  line-height: 48px;\n  text-transform: uppercase;\n  border-bottom: solid 1px #eeeeee;\n}\n.plan-graph .plan-graph-li-white {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  border-left: 1px solid #efefef;\n  color: #888;\n  padding: 10px 0px 10px 32px;\n  text-align: left;\n  line-height: 24px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-grey {\n  background-color: #fbfbfb;\n  border-bottom: 1px solid #efefef;\n  border-left: 1px solid #efefef;\n  color: #888;\n  padding: 10px 0px 10px 32px;\n  text-align: left;\n  line-height: 24px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-grey-less-padding {\n  background-color: #fbfbfb;\n  border-bottom: 1px solid #efefef;\n  border-left: 1px solid #efefef;\n  color: #888;\n  padding: 10px 0px 10px 16px;\n  text-align: left;\n  line-height: 24px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-white-less-padding {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  border-left: 1px solid #efefef;\n  color: #888;\n  padding: 10px 0px 10px 16px;\n  text-align: left;\n  line-height: 24px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-grey-less-line-height {\n  background-color: #fbfbfb;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 18px;\n}\n.plan-graph .plan-graph-li-grey-less-font-size {\n  background-color: #fbfbfb;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 24px;\n  font-size: 16px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-white-less-font-size {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 24px;\n  font-size: 16px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-white-less-line-height {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 18px;\n}\n.plan-graph .dollar-sign {\n  font-size: 22px;\n  line-height: 22px;\n  top: -14px;\n  right: -6px;\n  position: relative;\n}\n.plan-graph .pricing-column.no-highlight.accent-color {\n  width: 24%;\n  display: inline-block;\n  background-color: #fff;\n  border-left: 1px solid #e4e4e4;\n  overflow: hidden;\n  text-align: center;\n  vertical-align: top;\n  padding: 0px;\n  tranisition: box-shadow 0.2px linear;\n}\n.plan-graph .plan-graph-li-empty-grey-box {\n  background-color: #fbfbfb;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 18px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-empty-white-box {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 18px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-empty-grey-box-border-bottom-only {\n  background-color: #fbfbfb;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 18px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-empty-white-box-border-bottom-only {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 18px;\n  height: 47px;\n}\n.plan-graph .plan-graph-li-unique-white-box {\n  background-color: #fff;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 24px;\n  font-size: 16px;\n  height: 24px;\n}\n.plan-graph .plan-graph-li-contract-header {\n  background-color: #fff;\n  border-bottom: 1px solid #efefef;\n  color: #888;\n  padding: 10px 25px;\n  line-height: 24px;\n  font-size: 16px;\n  height: 47px;\n}\n.plan-graph .interval {\n  color: #999;\n  min-height: 38px;\n  display: block;\n  padding-bottom: 17px;\n}\n.plan-graph .pricing-column-content {\n  padding: 0px;\n}\n.plan-graph .blank-interval {\n  color: #999;\n  min-height: 38px;\n  display: block;\n  height: 46px;\n  padding-bottom: 17px;\n}\n.plan-graph ul.features {\n  margin-bottom: 0px;\n}\n.plan-graph .connect-and-communicate {\n  background-color: #fbfbfb;\n  border-top: 1px solid #efefef;\n  border-bottom: 1px solid #efefef;\n  border-left: 1px solid #efefef;\n  color: #888;\n  padding: 10px 0px 10px 16px;\n  text-align: left;\n  line-height: 24px;\n  height: 47px;\n}\n.plan-graph .pricing-column-content {\n  border: none;\n}\n.plan-graph .pricing-column-content-header {\n  margin-bottom: 8px;\n  margin-left: -22px;\n  padding: 20px 30px 6px 30px;\n  font-size: 54px;\n  line-height: 42px;\n  color: #333;\n  letter-spacing: -0.5px;\n}\n.plan-graph h3.pricing-column-content-h3 {\n  font-size: 20px;\n  letter-spacing: 2px;\n  color: #21cdec;\n  background-color: #fff;\n  line-height: 28px;\n  border-right: 1px solid #e4e4e4;\n  border-bottom: 1px solid #efefef;\n  border-top: 1px solid #e4e4e4;\n  padding: 18px 0px 18px 0px;\n  margin-bottom: 0px;\n}\n.plan-graph h3.pricing-column-content-h3.right {\n  border-right: none;\n}\n.plan-graph h3.pricing-column-header.left {\n  letter-spacing: 2px;\n  color: #21cdec;\n  line-height: 28px;\n  height: 66px;\n  padding: 18px 0px 18px 0px;\n  margin-bottom: 0px;\n  border: none;\n}\n.plan-graph h4.pricing-column-content-h4.left {\n  margin-bottom: 0px;\n  margin-left: -22px;\n  padding: 20px 30px 6px 30px;\n  font-size: 54px;\n  line-height: 42px;\n  height: 70px;\n  color: #333;\n  letter-spacing: -0.5px;\n}\n.plan-graph .pricing-column-right {\n  border-right: 1px solid #e4e4e4;\n  float: none;\n}\n.plan-graph .pricing-column-right.pricing-column-content-h3 {\n  border-right: none;\n}\n.plan-graph .unlimited-plan-h3 {\n  font-size: 20px;\n  letter-spacing: 2px;\n  background-color: #21cdec;\n  color: #fff;\n  line-height: 56px;\n  vertical-align: middle;\n  height: 86px;\n  padding: 15px 0px;\n  margin-bottom: 0px;\n}\n.plan-graph .unlimited-plan-container {\n  width: 24%;\n  display: inline-block;\n  position: relative;\n  z-index: 100;\n  margin: -20px -1px 0px -1px;\n  background-color: #fff;\n  box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.09);\n  overflow: hidden;\n  text-align: center;\n  padding: 0px;\n  tranisition: box-shadow 0.2px linear;\n}\n.plan-graph .unlimited-plan-container ul li {\n  list-style: none;\n  list-style-position: none;\n}\n.plan-graph .unlimited-plan-container ul {\n  margin-left: 0px;\n  margin-bottom: 0px;\n}\n.view-link {\n  z-index: 1100;\n  height: 100px;\n}\n.view-link .view-link-container {\n  position: relative;\n  z-index: 1;\n  top: -56px;\n  right: 0;\n  background-color: #ffffff;\n  width: 150px;\n  margin-top: 4px;\n  text-align: left;\n  opacity: 1;\n  transform: translate3d(0, 0, 0) scale(1);\n  transform-origin: top right;\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.view-link.is-closed .view-link-container {\n  top: -500px;\n  opacity: 0;\n  transform: translate3d(0, -20px, 0) scale(0);\n  transition: top 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.transformation {\n  -moz-transition: transform 1s;\n  -webkit-transition: transform 1s;\n  -ms-transition: transform 1s;\n  -o-transition: transform 1s;\n  transition: transform 1s;\n}\n.upgrade-and-save-container {\n  margin-top: 150px;\n}\n.textfield-container {\n  margin-top: 16px;\n  padding-bottom: 8px;\n  margin-bottom: 8px;\n}\n.field-label-container {\n  height: 24px;\n  margin-bottom: 15px;\n}\n.label-text-initial {\n  font-size: 16px;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.label-text-left-nav {\n  display: inline-block;\n  font-size: 14px;\n  color: black;\n  margin: 10px 0 10px 15px;\n  height: 22px;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.select-field-container-initial {\n  padding: 15px;\n  margin-top: 10px;\n}\n.select-field-container-left-nav {\n  padding-bottom: 8px;\n  margin-top: 16px;\n}\n/* DayPicker styles */\n.DayPicker {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  position: relative;\n  padding: 1rem 0;\n  user-select: none;\n}\n.DayPicker-Month {\n  display: table;\n  border-collapse: collapse;\n  border-spacing: 0;\n  user-select: none;\n  margin: 0 0.5rem;\n}\n.DayPicker-NavBar {\n  position: absolute;\n  left: 0;\n  right: 0;\n  padding: 0 .5rem;\n}\n.DayPicker-NavButton {\n  position: absolute;\n  width: 1rem;\n  height: 1rem;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  cursor: pointer;\n}\n.DayPicker-NavButton--prev {\n  left: 1rem;\n  background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5wcmV2PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9InByZXYiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjM5MzE5MywgMjUuMDAwMDAwKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC0xMy4zOTMxOTMsIC0yNS4wMDAwMDApIHRyYW5zbGF0ZSgwLjg5MzE5MywgMC4wMDAwMDApIiBmaWxsPSIjNTY1QTVDIj4KICAgICAgICAgICAgPHBhdGggZD0iTTAsNDkuMTIzNzMzMSBMMCw0NS4zNjc0MzQ1IEwyMC4xMzE4NDU5LDI0LjcyMzA2MTIgTDAsNC4yMzEzODMxNCBMMCwwLjQ3NTA4NDQ1OSBMMjUsMjQuNzIzMDYxMiBMMCw0OS4xMjM3MzMxIEwwLDQ5LjEyMzczMzEgWiIgaWQ9InJpZ2h0IiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K\");\n}\n.DayPicker-NavButton--next {\n  right: 1rem;\n  width: 10px;\n  background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2cHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDI2IDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy4zLjIgKDEyMDQzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5uZXh0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc2tldGNoOnR5cGU9Ik1TUGFnZSI+CiAgICAgICAgPGcgaWQ9Im5leHQiIHNrZXRjaDp0eXBlPSJNU0xheWVyR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuOTUxNDUxLCAwLjAwMDAwMCkiIGZpbGw9IiM1NjVBNUMiPgogICAgICAgICAgICA8cGF0aCBkPSJNMCw0OS4xMjM3MzMxIEwwLDQ1LjM2NzQzNDUgTDIwLjEzMTg0NTksMjQuNzIzMDYxMiBMMCw0LjIzMTM4MzE0IEwwLDAuNDc1MDg0NDU5IEwyNSwyNC43MjMwNjEyIEwwLDQ5LjEyMzczMzEgTDAsNDkuMTIzNzMzMSBaIiBpZD0icmlnaHQiIHNrZXRjaDp0eXBlPSJNU1NoYXBlR3JvdXAiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=\");\n}\n.DayPicker-Caption {\n  display: table-caption;\n  height: 1rem;\n  font-size: 0.8em;\n  text-align: center;\n}\n.DayPicker-Weekdays {\n  display: table-header-group;\n}\n.DayPicker-WeekdaysRow {\n  display: table-row;\n}\n.DayPicker-Weekday {\n  display: table-cell;\n  padding: .3rem;\n  font-size: .7em;\n  text-align: center;\n  color: #8b9898;\n}\n.DayPicker-Body {\n  display: table-row-group;\n}\n.DayPicker-Week {\n  display: table-row;\n}\n.DayPicker-Day {\n  display: table-cell;\n  padding: .15rem;\n  border: 1px solid #eaecec;\n  text-align: center;\n  cursor: pointer;\n  vertical-align: middle;\n  font-size: 14px;\n}\n.DayPicker--interactionDisabled .DayPicker-Day {\n  cursor: default;\n}\n/* Default modifiers */\n.DayPicker-Day--today {\n  color: #d0021b;\n  font-weight: 500;\n}\n.DayPicker-Day--disabled {\n  color: #dce0e0;\n  cursor: default;\n  background-color: #eff1f1;\n}\n.DayPicker-Day--outside {\n  cursor: default;\n  color: #dce0e0;\n}\n/* Example modifiers */\n.DayPicker-Day--sunday {\n  color: #dce0e0;\n  background-color: #f7f8f8;\n}\n.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n  color: #FFF;\n  background-color: rgba(74, 144, 255, 0.78);\n}\n.remove-hover-color:hover {\n  background-color: transparent !important;\n}\n@media only screen and (max-width: 590px) {\n  .company-type-checkboxes {\n    width: 100% !important;\n  }\n}\n.nav-add-hover {\n  padding: 8px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.nav-add-hover:hover {\n  background-color: #e7e8ea;\n}\n@media (max-width: 768px) {\n  .left-nav-mobile-breakpoint {\n    display: none;\n  }\n  .right-side-mobile-breakpoint {\n    display: none;\n  }\n  .main-feed {\n    width: 90%;\n    margin: 0 auto;\n  }\n  .news-feed-avatar {\n    display: none !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 1000px) {\n  .newsfeed-container {\n    display: flex;\n  }\n  .main-feed {\n    width: 70%;\n    margin: 0 5%;\n  }\n  .news-feed-avatar {\n    display: none !important;\n  }\n  .right-side-mobile-breakpoint {\n    display: none;\n  }\n}\n@media (min-width: 1000px) {\n  .newsfeed-container {\n    display: flex;\n    justify-content: space-between;\n  }\n  .left-nav-mobile-breakpoint {\n    width: 20%;\n  }\n  .main-feed {\n    width: 50%;\n    margin: 0 auto;\n  }\n  .right-side-mobile-breakpoint {\n    width: 25%;\n  }\n  .news-feed-avatar {\n    border: 0px solid #E0E0E0;\n    height: 50px !important;\n    position: relative;\n    width: 50px !important;\n  }\n}\n@media screen and (max-width: 692px) {\n  .hide-float-center {\n    width: 100% !important;\n    float: none !important;\n    text-align: center;\n  }\n}\n@media screen and (max-width: 342px) {\n  .share-icons-outer-div {\n    margin-left: 0 !important;\n    overflow: hidden;\n  }\n}\n@media screen and (max-width: 342px) {\n  .share-icons {\n    display: none !important;\n  }\n}\n.outer-div-hide-scroll {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n.inner-div-allow-scroll {\n  width: 100%;\n  height: 100%;\n  overflow-y: scroll;\n}\n.file-preview-close:hover {\n  opacity: 1 !important;\n  font-weight: 600;\n}\n.padded-border-container {\n  border-color: #e0e0e0;\n  border-radius: .2857rem;\n  box-sizing: border-box;\n  color: #ffffff;\n  display: inline-block;\n  float: right;\n  font-weight: 700;\n  line-height: 1;\n  padding: .3em .6em;\n  text-align: center;\n}\n.l-app-content {\n  max-width: 1232px;\n  margin: 0 auto;\n  padding-top: 96px;\n  z-index: 0;\n}\n.l-app-content.l-app-profile-content {\n  padding: 0px 16px 0px 16px;\n}\n.l-left-nav-with-content {\n  width: 100%;\n  height: 100%;\n}\n.l-left-nav-with-content .l-left-nav {\n  background-color: #ffffff;\n  width: 256px;\n  height: 100%;\n  float: left;\n  clear: both;\n  display: inline-block;\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);\n  position: fixed;\n  margin-top: -96px;\n}\n.l-left-nav-with-content .l-left-nav-content {\n  width: calc(100% - 256px);\n  padding-left: 32px;\n  float: right;\n  display: inline-block;\n}\n.l-paper-left {\n  position: relative;\n  width: 25%;\n  padding-right: 6.25px;\n  float: left;\n  clear: both;\n  display: inline-block;\n}\n.l-paper-left:hover .tc-icon-delete {\n  visibility: visible;\n  z-index: 5;\n  opacity: 1;\n}\n.l-paper-left .short-description {\n  line-height: 12px;\n}\n.l-paper-right {\n  position: relative;\n  width: calc(100% - 25%);\n  padding-left: 6.25px;\n  clear: both;\n  display: inline-block;\n}\n.l-paper-right p {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.l-paper-right .multi-select-paragraph {\n  margin-top: -6.25px;\n}\n.l-paper-split-form {\n  width: 100%;\n  position: relative;\n}\n.l-paper-split-form.textarea {\n  padding: 20px 0px;\n}\n.l-paper-split-form .l-paper-left {\n  line-height: 64px;\n  max-height: 64px;\n}\n.l-paper-split-form.image .l-paper-left {\n  width: 35%;\n  float: inherit;\n  max-height: inherit;\n  line-height: inherit;\n}\n.l-paper-split-form.image .l-paper-right {\n  width: 65%;\n  vertical-align: top;\n}\n.Grid {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.Grid-cell {\n  flex: 1;\n}\n.Grid--flexCells > .Grid-cell {\n  display: flex;\n}\n.Grid--top {\n  align-items: flex-start;\n}\n.Grid--bottom {\n  align-items: flex-end;\n}\n.Grid--center {\n  align-items: center;\n}\n.Grid--justifyCenter {\n  justify-content: center;\n}\n.Grid-cell--top {\n  align-self: flex-start;\n}\n.Grid-cell--bottom {\n  align-self: flex-end;\n}\n.Grid-cell--center {\n  align-self: center;\n}\n.Grid-cell--autoSize {\n  flex: none;\n}\n.Grid--fit > .Grid-cell {\n  flex: 1;\n}\n.Grid--full > .Grid-cell {\n  flex: 0 0 100%;\n}\n.Grid--1of2 > .Grid-cell {\n  flex: 0 0 50%;\n}\n.Grid--1of3 > .Grid-cell {\n  flex: 0 0 33.3333%;\n}\n.Grid--1of4 > .Grid-cell {\n  flex: 0 0 25%;\n}\n@media (--break-sm) {\n  .small-Grid--fit > .Grid-cell {\n    flex: 1;\n  }\n  .small-Grid--full > .Grid-cell {\n    flex: 0 0 100%;\n  }\n  .small-Grid--1of2 > .Grid-cell {\n    flex: 0 0 50%;\n  }\n  .small-Grid--1of3 > .Grid-cell {\n    flex: 0 0 33.3333%;\n  }\n  .small-Grid--1of4 > .Grid-cell {\n    flex: 0 0 25%;\n  }\n}\n@media (--break-md) {\n  .med-Grid--fit > .Grid-cell {\n    flex: 1;\n  }\n  .med-Grid--full > .Grid-cell {\n    flex: 0 0 100%;\n  }\n  .med-Grid--1of2 > .Grid-cell {\n    flex: 0 0 50%;\n  }\n  .med-Grid--1of3 > .Grid-cell {\n    flex: 0 0 33.3333%;\n  }\n  .med-Grid--1of4 > .Grid-cell {\n    flex: 0 0 25%;\n  }\n}\n@media (--break-lg) {\n  .large-Grid--fit > .Grid-cell {\n    flex: 1;\n  }\n  .large-Grid--full > .Grid-cell {\n    flex: 0 0 100%;\n  }\n  .large-Grid--1of2 > .Grid-cell {\n    flex: 0 0 50%;\n  }\n  .large-Grid--1of3 > .Grid-cell {\n    flex: 0 0 33.3333%;\n  }\n  .large-Grid--1of4 > .Grid-cell {\n    flex: 0 0 25%;\n  }\n}\n.Grid--gutters {\n  margin: -1em 0 1em -1em;\n}\n.Grid--gutters > .Grid-cell {\n  padding: 1em 0 0 1em;\n}\n.Grid--guttersLg {\n  margin: -1.5em 0 1.5em -1.5em;\n}\n.Grid--guttersLg > .Grid-cell {\n  padding: 1.5em 0 0 1.5em;\n}\n.Grid--guttersXl {\n  margin: -2em 0 2em -2em;\n}\n.Grid--guttersXl > .Grid-cell {\n  padding: 2em 0 0 2em;\n}\n@media (--break-sm) {\n  .small-Grid--gutters {\n    margin: -1em 0 1em -1em;\n  }\n  .small-Grid--gutters > .Grid-cell {\n    padding: 1em 0 0 1em;\n  }\n  .small-Grid--guttersLg {\n    margin: -1.5em 0 1.5em -1.5em;\n  }\n  .small-Grid--guttersLg > .Grid-cell {\n    padding: 1.5em 0 0 1.5em;\n  }\n  .small-Grid--guttersXl {\n    margin: -2em 0 2em -2em;\n  }\n  .small-Grid--guttersXl > .Grid-cell {\n    padding: 2em 0 0 2em;\n  }\n}\n@media (--break-md) {\n  .med-Grid--gutters {\n    margin: -1em 0 1em -1em;\n  }\n  .med-Grid--gutters > .Grid-cell {\n    padding: 1em 0 0 1em;\n  }\n  .med-Grid--guttersLg {\n    margin: -1.5em 0 1.5em -1.5em;\n  }\n  .med-Grid--guttersLg > .Grid-cell {\n    padding: 1.5em 0 0 1.5em;\n  }\n  .med-Grid--guttersXl {\n    margin: -2em 0 2em -2em;\n  }\n  .med-Grid--guttersXl > .Grid-cell {\n    padding: 2em 0 0 2em;\n  }\n}\n@media (--break-lg) {\n  .large-Grid--gutters {\n    margin: -1em 0 1em -1em;\n  }\n  .large-Grid--gutters > .Grid-cell {\n    padding: 1em 0 0 1em;\n  }\n  .large-Grid--guttersLg {\n    margin: -1.5em 0 1.5em -1.5em;\n  }\n  .large-Grid--guttersLg > .Grid-cell {\n    padding: 1.5em 0 0 1.5em;\n  }\n  .large-Grid--guttersXl {\n    margin: -2em 0 2em -2em;\n  }\n  .large-Grid--guttersXl > .Grid-cell {\n    padding: 2em 0 0 2em;\n  }\n}\ndiv.filepicker {\n  background-color: #E1E1E1;\n  border-radius: 5px;\n  border: 2px dashed #C7C7C7;\n  min-height: 60px;\n  padding: 5px;\n  text-align: center;\n}\n.filepicker-file-icon {\n  color: black;\n  display: inline-block;\n  margin: 1.5em 0 2.5em 0;\n  padding-left: 45px;\n  position: relative;\n}\n.filepicker-file-icon::before {\n  border-radius: 2px;\n  border: solid 2px #7F7F7F;\n  content: '';\n  height: 34px;\n  left: 0;\n  position: absolute;\n  top: -7px;\n  width: 29px;\n}\n.filepicker-file-icon::after {\n  background-color: #000000;\n  color: #ffffff;\n  content: 'file';\n  content: attr(data-filetype);\n  font-size: 11px;\n  left: -4px;\n  letter-spacing: 1px;\n  line-height: 1.3;\n  padding: 0 2px;\n  position: absolute;\n  text-align: right;\n  text-transform: uppercase;\n  top: 9px;\n}\n.filepicker-file-icon .fileCorner {\n  border-color: white transparent transparent #920035;\n  border-style: solid;\n  border-width: 11px 0 0 11px;\n  height: 0;\n  left: 22px;\n  position: absolute;\n  top: -7px;\n  width: 0;\n}\n.dz-error-mark {\n  display: none;\n  visibility: hidden;\n}\n.dz-error-message {\n  display: none;\n  visibility: hidden;\n}\n@-webkit-keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n  }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n  }\n  70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n  }\n}\n@keyframes passing-through {\n  0% {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  10% {\n    transform: scale(1.1);\n  }\n  20% {\n    transform: scale(1);\n  }\n}\n@-webkit-keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n  }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n  }\n  70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n  }\n}\n@keyframes slide-in {\n  0% {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  10% {\n    transform: scale(1.1);\n  }\n  20% {\n    transform: scale(1);\n  }\n}\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n  }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n  }\n  70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n  }\n}\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  10% {\n    transform: scale(1.1);\n  }\n  20% {\n    transform: scale(1);\n  }\n}\n.dropzone {\n  background: white;\n  border: 2px solid rgba(0, 0, 0, 0.3);\n  box-sizing: border-box;\n  min-height: 150px;\n  padding: 20px 20px;\n}\n.dropzone * {\n  box-sizing: border-box;\n}\n.dropzone .dz-message {\n  margin: 2em 0;\n  text-align: center;\n}\n.dropzone .dz-preview {\n  display: inline-block;\n  margin: 16px;\n  min-height: 100px;\n  position: relative;\n  vertical-align: top;\n}\n.dropzone .dz-preview:hover {\n  z-index: 1000;\n}\n.dropzone .dz-preview:hover .dz-details {\n  opacity: 1;\n}\n.dropzone .dz-preview:hover .dz-image img {\n  -moz-transform: scale(1.05, 1.05);\n  -ms-transform: scale(1.05, 1.05);\n  -o-transform: scale(1.05, 1.05);\n  -webkit-filter: blur(8px);\n  -webkit-transform: scale(1.05, 1.05);\n  filter: blur(8px);\n  transform: scale(1.05, 1.05);\n}\n.dropzone .dz-preview .dz-remove {\n  border: none;\n  cursor: pointer;\n  display: block;\n  font-size: 14px;\n  text-align: center;\n}\n.dropzone .dz-preview .dz-remove:hover {\n  text-decoration: underline;\n}\n.dropzone .dz-preview .dz-details {\n  color: rgba(0, 0, 0, 0.9);\n  font-size: 13px;\n  left: 0;\n  line-height: 150%;\n  max-width: 100%;\n  min-width: 100%;\n  opacity: 0;\n  padding: 2em 1em;\n  position: absolute;\n  text-align: center;\n  top: 0;\n  z-index: 20;\n}\n.dropzone .dz-preview .dz-details .dz-size {\n  font-size: 16px;\n  margin-bottom: 1em;\n}\n.dropzone .dz-preview .dz-details .dz-size span {\n  background-color: rgba(255, 255, 255, 0.4);\n  border-radius: 3px;\n  padding: 0 0.4em;\n}\n.dropzone .dz-preview .dz-details .dz-filename {\n  white-space: nowrap;\n}\n.dropzone .dz-preview .dz-details .dz-filename:hover span {\n  background-color: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(200, 200, 200, 0.8);\n}\n.dropzone .dz-preview .dz-details .dz-filename:not(hover) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dropzone .dz-preview .dz-details .dz-filename:not(hover) span {\n  border: 1px solid transparent;\n}\n.dropzone .dz-preview .dz-details .dz-filename span {\n  background-color: rgba(255, 255, 255, 0.4);\n  border-radius: 3px;\n  padding: 0 0.4em;\n}\n.dropzone .dz-preview .dz-image {\n  border-radius: 20px;\n  display: block;\n  height: 120px;\n  overflow: hidden;\n  position: relative;\n  width: 120px;\n  z-index: 10;\n}\n.dropzone .dz-preview .dz-image img {\n  display: block;\n}\n.dropzone .dz-preview .dz-success-mark {\n  display: block;\n  left: 50%;\n  margin-left: -27px;\n  margin-top: -27px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  z-index: 500;\n}\n.dropzone .dz-preview .dz-success-mark svg {\n  display: block;\n  height: 54px;\n  width: 54px;\n}\n.dropzone .dz-preview .dz-error-mark {\n  display: block;\n  left: 50%;\n  margin-left: -27px;\n  margin-top: -27px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  z-index: 500;\n}\n.dropzone .dz-preview .dz-error-mark svg {\n  display: block;\n  height: 54px;\n  width: 54px;\n}\n.dropzone .dz-preview:not(.dz-processing) .dz-progress {\n  -moz-animation: pulse 6s ease infinite;\n  -ms-animation: pulse 6s ease infinite;\n  -o-animation: pulse 6s ease infinite;\n  -webkit-animation: pulse 6s ease infinite;\n  animation: pulse 6s ease infinite;\n}\n.dropzone .dz-preview .dz-progress {\n  -webkit-transform: scale(1);\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 8px;\n  height: 16px;\n  left: 50%;\n  margin-left: -40px;\n  margin-top: -8px;\n  opacity: 1;\n  overflow: hidden;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  width: 80px;\n  z-index: 1000;\n}\n.dropzone .dz-preview .dz-progress .dz-upload {\n  -moz-transition: width 300ms ease-in-out;\n  -ms-transition: width 300ms ease-in-out;\n  -o-transition: width 300ms ease-in-out;\n  -webkit-transition: width 300ms ease-in-out;\n  background: #333333;\n  background: linear-gradient(to bottom, #666666, #444444);\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  top: 0;\n  transition: width 300ms ease-in-out;\n  width: 0;\n}\n.dropzone .dz-preview .dz-error-message {\n  -moz-transition: opacity 0.3s ease;\n  -ms-transition: opacity 0.3s ease;\n  -o-transition: opacity 0.3s ease;\n  -webkit-transition: opacity 0.3s ease;\n  background: #be2626;\n  background: linear-gradient(to bottom, #be2626, #a92222);\n  border-radius: 8px;\n  color: white;\n  display: block;\n  display: none;\n  font-size: 13px;\n  left: -10px;\n  opacity: 0;\n  padding: 0.5em 1.2em;\n  pointer-events: none;\n  position: absolute;\n  top: 130px;\n  transition: opacity 0.3s ease;\n  width: 140px;\n  z-index: 1000;\n}\n.dropzone .dz-preview .dz-error-message:after {\n  border-bottom: 6px solid #be2626;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  content: '';\n  height: 0;\n  left: 64px;\n  position: absolute;\n  top: -6px;\n  width: 0;\n}\n.dropzone .dz-preview.dz-file-preview .dz-image {\n  background: #999999;\n  background: linear-gradient(to bottom, #eeeeee, #dddddd);\n  border-radius: 20px;\n}\n.dropzone .dz-preview.dz-file-preview .dz-details {\n  opacity: 1;\n}\n.dropzone .dz-preview.dz-image-preview {\n  background: white;\n}\n.dropzone .dz-preview.dz-image-preview .dz-details {\n  -moz-transition: opacity 0.2s linear;\n  -ms-transition: opacity 0.2s linear;\n  -o-transition: opacity 0.2s linear;\n  -webkit-transition: opacity 0.2s linear;\n  transition: opacity 0.2s linear;\n}\n.dropzone .dz-preview.dz-success .dz-success-mark {\n  -moz-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -ms-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n}\n.dropzone .dz-preview.dz-error .dz-error-mark {\n  -moz-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -ms-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -webkit-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  opacity: 1;\n}\n.dropzone .dz-preview.dz-error .dz-error-message {\n  display: block;\n}\n.dropzone .dz-preview.dz-error:hover .dz-error-message {\n  opacity: 1;\n  pointer-events: auto;\n}\n.dropzone .dz-preview.dz-processing .dz-progress {\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  -webkit-transition: all 0.2s linear;\n  opacity: 1;\n  transition: all 0.2s linear;\n}\n.dropzone .dz-preview.dz-complete .dz-progress {\n  -moz-transition: opacity 0.4s ease-in;\n  -ms-transition: opacity 0.4s ease-in;\n  -o-transition: opacity 0.4s ease-in;\n  -webkit-transition: opacity 0.4s ease-in;\n  opacity: 0;\n  transition: opacity 0.4s ease-in;\n}\n.dropzone.dz-clickable {\n  cursor: pointer;\n}\n.dropzone.dz-clickable * {\n  cursor: default;\n}\n.dropzone.dz-clickable .dz-message {\n  cursor: pointer;\n}\n.dropzone.dz-clickable .dz-message * {\n  cursor: pointer;\n}\n.dropzone.dz-started .dz-message {\n  display: none;\n}\n.dropzone.dz-drag-hover {\n  border-style: solid;\n}\n.dropzone.dz-drag-hover .dz-message {\n  opacity: 0.5;\n}\n.full-screen-page {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  z-index: 4;\n  top: 0;\n  left: 0;\n  background-color: white;\n  overflow-x: hidden;\n}\n.Select-placeholder {\n  font-size: 12px;\n  padding: 0 5px;\n}\n.with-tooltip {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n.with-tooltip .tooltiptext {\n  visibility: hidden;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  top: 120%;\n  left: 100%;\n  margin-left: -50px;\n}\n.with-tooltip .tooltiptext::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 30px;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent rgba(0, 0, 0, 0.5) transparent;\n}\n.with-tooltip:hover .tooltiptext {\n  visibility: visible;\n  -moz-transition: all 500ms ease-in-out;\n  -ms-transition: all 500ms ease-in-out;\n  -o-transition: all 500ms ease-in-out;\n  -webkit-transition: all 500ms ease-in-out;\n  transition: all 500ms ease-in-out;\n}\n.left-arrow-bubble {\n  position: relative;\n  width: 100%;\n  padding: 0px;\n  background: #FFFFFF;\n  border: #d5dee3 solid 0.5px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n}\n.left-arrow-bubble:after {\n  content: \"\";\n  position: absolute;\n  top: 9px;\n  right: 99.9%;\n  border-style: solid;\n  border-width: 6px;\n  border-color: transparent #FFFFFF transparent transparent;\n  display: block;\n  width: 0;\n  z-index: 1;\n}\n.message-div p {\n  margin-bottom: 8px;\n  padding-top: 1px;\n}\n.left-arrow-bubble:before {\n  content: \"\";\n  position: absolute;\n  top: 8px;\n  right: 100%;\n  border-style: solid;\n  border-width: 7px;\n  border-color: transparent #d5dee3 transparent transparent ;\n  display: block;\n  width: 0;\n  z-index: 0;\n}\n.right-arrow-bubble {\n  position: relative;\n  width: 100%;\n  padding: 0px;\n  background: #edf9ff;\n  border: #c7dce7 solid 0.5px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n}\n.right-arrow-bubble:after {\n  content: \"\";\n  position: absolute;\n  top: 9px;\n  left: 99.9%;\n  border-style: solid;\n  border-width: 6px;\n  border-color: transparent transparent transparent #edf9ff;\n  display: block;\n  width: 0;\n  z-index: 1;\n}\n.right-arrow-bubble:before {\n  content: \"\";\n  position: absolute;\n  top: 8px;\n  left: 100%;\n  border-style: solid;\n  border-width: 7px;\n  border-color: transparent transparent transparent #c7dce7;\n  display: block;\n  width: 0;\n}\n.right-arrow-box {\n  position: relative;\n  width: 100%;\n  padding: 0px;\n  border-left: #e0e0e0 solid 0.5px;\n}\n.right-arrow-box:after {\n  content: \"\";\n  position: absolute;\n  top: 43.5%;\n  left: 99.9%;\n  border-style: solid;\n  border-width: 6px;\n  border-color: transparent transparent transparent white;\n  display: block;\n  width: 0;\n  z-index: 1;\n}\n.right-arrow-box:before {\n  content: \"\";\n  position: absolute;\n  top: 43%;\n  left: 100%;\n  border-style: solid;\n  border-width: 7px;\n  border-color: transparent transparent transparent #e0e0e0;\n  display: block;\n  width: 0;\n}\n.supplier-step-done {\n  border-bottom: 4px solid #00897b !important;\n}\n.buyer-step-done {\n  border-bottom: 4px solid #ff6f00 !important;\n}\n.loaded-step-done {\n  background-color: #ff6f00 !important;\n  color: white;\n}\n.flag-across-progress-bar {\n  font-size: 9px;\n  font-weight: bold;\n  height: 14px;\n  line-height: 14px;\n  text-align: center;\n  padding: 0 8px;\n  text-transform: uppercase;\n  color: white;\n}\n", ""]);

// exports


/***/ }),
/* 479 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "357860c5ec857a9ecfb5b19cf27bd204.ttf";

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "51cb4a6f77048ff7f54bba6d754fe419.woff";

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b08cfa2e5e2b0238f94b35749e53493a.svg";

/***/ }),
/* 483 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0;

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function createStyleElement() {
	var styleElement = document.createElement("style");
	var head = getHeadElement();
	styleElement.type = "text/css";
	head.appendChild(styleElement);
	return styleElement;
}

function createLinkElement() {
	var linkElement = document.createElement("link");
	var head = getHeadElement();
	linkElement.rel = "stylesheet";
	head.appendChild(linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement());
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement();
		update = updateLink.bind(null, styleElement);
		remove = function() {
			styleElement.parentNode.removeChild(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement();
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			styleElement.parentNode.removeChild(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;
	var sourceMap = obj.sourceMap;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var media = obj.media;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 484 */,
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestAccessFromAdmin = exports.triggerError = exports.clearStore = undefined;

var _globalErrorsDisplayConstants = __webpack_require__(861);

var constants = _interopRequireWildcard(_globalErrorsDisplayConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var clearStore = exports.clearStore = function clearStore() {
  return {
    type: constants.CLEAR_STORE
  };
};

// payload is an object, and it has to include errorMessage in it
var triggerError = exports.triggerError = function triggerError(payload) {
  return {
    type: constants.ERROR_TRIGGERED,
    payload: payload
  };
};

var requestAccessFromAdmin = exports.requestAccessFromAdmin = function requestAccessFromAdmin(payload) {
  return function (dispatch) {
    dispatch({ type: constants.REQUEST_ACCESS_STARTED });
    return fetch('/proxy/userManagement/requestAccess', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.error) return dispatch({ type: constants.REQUEST_ACCESS_FAILED, payload: response.error });
      return dispatch({ type: constants.REQUESTED_ACCESS });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.REQUEST_ACCESS_FAILED });
    });
  };
};

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(592)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var external = __webpack_require__(218);
var DataWorker = __webpack_require__(596);
var DataLengthProbe = __webpack_require__(597);
var Crc32Probe = __webpack_require__(598);
var DataLengthProbe = __webpack_require__(597);

/**
 * Represent a compressed object, with everything needed to decompress it.
 * @constructor
 * @param {number} compressedSize the size of the data compressed.
 * @param {number} uncompressedSize the size of the data after decompression.
 * @param {number} crc32 the crc32 of the decompressed file.
 * @param {object} compression the type of compression, see lib/compressions.js.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
 */
function CompressedObject(compressedSize, uncompressedSize, crc32, compression, data) {
    this.compressedSize = compressedSize;
    this.uncompressedSize = uncompressedSize;
    this.crc32 = crc32;
    this.compression = compression;
    this.compressedContent = data;
}

CompressedObject.prototype = {
    /**
     * Create a worker to get the uncompressed content.
     * @return {GenericWorker} the worker.
     */
    getContentWorker : function () {
        var worker = new DataWorker(external.Promise.resolve(this.compressedContent))
        .pipe(this.compression.uncompressWorker())
        .pipe(new DataLengthProbe("data_length"));

        var that = this;
        worker.on("end", function () {
            if(this.streamInfo['data_length'] !== that.uncompressedSize) {
                throw new Error("Bug : uncompressed data size mismatch");
            }
        });
        return worker;
    },
    /**
     * Create a worker to get the compressed content.
     * @return {GenericWorker} the worker.
     */
    getCompressedWorker : function () {
        return new DataWorker(external.Promise.resolve(this.compressedContent))
        .withStreamInfo("compressedSize", this.compressedSize)
        .withStreamInfo("uncompressedSize", this.uncompressedSize)
        .withStreamInfo("crc32", this.crc32)
        .withStreamInfo("compression", this.compression)
        ;
    }
};

/**
 * Chain the given worker with other workers to compress the content with the
 * given compresion.
 * @param {GenericWorker} uncompressedWorker the worker to pipe.
 * @param {Object} compression the compression object.
 * @param {Object} compressionOptions the options to use when compressing.
 * @return {GenericWorker} the new worker compressing the content.
 */
CompressedObject.createWorkerFrom = function (uncompressedWorker, compression, compressionOptions) {
    return uncompressedWorker
    .pipe(new Crc32Probe())
    .pipe(new DataLengthProbe("uncompressedSize"))
    .pipe(compression.compressWorker(compressionOptions))
    .pipe(new DataLengthProbe("compressedSize"))
    .withStreamInfo("compression", compression);
};

module.exports = CompressedObject;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

/**
 * The following functions come from pako, from pako/lib/zlib/crc32.js
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Use ordinary array, since untyped makes no boost here
function makeTable() {
    var c, table = [];

    for(var n =0; n < 256; n++){
        c = n;
        for(var k =0; k < 8; k++){
            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
        }
        table[n] = c;
    }

    return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

// That's all for the pako functions.

/**
 * Compute the crc32 of a string.
 * This is almost the same as the function crc32, but for strings. Using the
 * same function for the two use cases leads to horrible performances.
 * @param {Number} crc the starting value of the crc.
 * @param {String} str the string to use.
 * @param {Number} len the length of the string.
 * @param {Number} pos the starting position for the crc32 computation.
 * @return {Number} the computed crc32.
 */
function crc32str(crc, str, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

module.exports = function crc32wrapper(input, crc) {
    if (typeof input === "undefined" || !input.length) {
        return 0;
    }

    var isArray = utils.getTypeOf(input) !== "string";

    if(isArray) {
        return crc32(crc|0, input, input.length, 0);
    } else {
        return crc32str(crc|0, input, input.length, 0);
    }
};
// vim: set shiftwidth=4 softtabstop=4:


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roundDownToNearest = exports.roundUpToNearest = exports.roundToNearest = undefined;

var _roundTo = __webpack_require__(610);

var _roundTo2 = _interopRequireDefault(_roundTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var roundToNearest = function roundToNearest(num) {
  var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var newNum = Number(num);
  var incre = 100 / cents;
  return Math.round(newNum * incre) / incre;
};

var roundUpToNearest = function roundUpToNearest(num) {
  var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var newNum = Number(num);
  var incre = 100 / cents;
  return Math.ceil(newNum * incre) / incre;
};

var roundDownToNearest = function roundDownToNearest(num) {
  var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var newNum = Number(num);
  var incre = 100 / cents;
  return Math.floor(newNum * incre) / incre;
};

exports.roundToNearest = roundToNearest;
exports.roundUpToNearest = roundUpToNearest;
exports.roundDownToNearest = roundDownToNearest;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(3019);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onCheckSyncSection = exports.discardEditedDraft = exports.downloadContractPdf = exports.deleteProductFromContract = exports.getHistoryFeeds = exports.reloadContentInBg = exports.getProductDetails = exports.getContractDetails = exports.getContractLeftNav = exports.modifyFileFromContractInDB = exports.deleteFileFromContractInDB = exports.addFileToContractFromMessage = exports.linkToContractFromHistoryFeedId = exports.addFileToContractInDB = exports.toggleShowChangesPopover = exports.toggleDraftErrorsDialog = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createDraft = createDraft;
exports.clearStore = clearStore;
exports.openImportFromOtherProductsDialog = openImportFromOtherProductsDialog;
exports.updatePartnerForSentDoc = updatePartnerForSentDoc;
exports.doResendContract = doResendContract;
exports.sortingProducts = sortingProducts;
exports.checkContractReadiness = checkContractReadiness;

var _graphqlQueries = __webpack_require__(864);

var queries = _interopRequireWildcard(_graphqlQueries);

var _http = __webpack_require__(118);

var _bluebird = __webpack_require__(1114);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _api = __webpack_require__(37);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _accessCheckHelperFns = __webpack_require__(631);

var _reactRouterRedux = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toggleDraftErrorsDialog = exports.toggleDraftErrorsDialog = function toggleDraftErrorsDialog() {
  return { type: 'TOGGLE_DRAFT_ERRORS_DIALOG' };
};
var toggleShowChangesPopover = exports.toggleShowChangesPopover = function toggleShowChangesPopover(open, event) {
  return { type: 'TOGGLE_SHOW_DRAFT_CHANGES_POPOVER', payload: { anchorEl: event.currentTarget, open: open } };
};

var addFileToContractInDB = exports.addFileToContractInDB = function addFileToContractInDB(contractId, files) {
  return function (dispatch) {
    dispatch({ type: 'ADD_CONTRACT_FILES', payload: { files: files.map(function (o) {
          return _extends({}, o, { source: 'directUpload' });
        }) } });
    return (0, _http.post)('/proxy/contracting/contract/files', { contractId: contractId, files: files }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (filesSaved) {
      dispatch({ type: 'CONTRACT_FILES_MODIFIED', payload: { files: filesSaved } });
      return filesSaved;
    });
  };
};

var linkToContractFromHistoryFeedId = exports.linkToContractFromHistoryFeedId = function linkToContractFromHistoryFeedId(payload) {
  return { type: 'CONTRACT_FROM_HF', payload: payload };
};

var addFileToContractFromMessage = exports.addFileToContractFromMessage = function addFileToContractFromMessage(messageId, files) {
  return function (dispatch, getState) {
    var leftNav = getState().contracting.contractActivitiesProducts.get('leftNav').toJS();
    var contractId = leftNav.contractId;
    return (0, _http.post)('/proxy/contracting/contract/files', { contractId: contractId, messageId: messageId, files: files }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function () {
      dispatch(getHistoryFeeds('contract', contractId));
      dispatch(getContractLeftNav('contract', contractId, true));
    });
  };
};

var deleteFileFromContractInDB = exports.deleteFileFromContractInDB = function deleteFileFromContractInDB(contractId, fileId) {
  return function (dispatch) {
    return (0, _http.del)('/proxy/contracting/contract/file', { contractId: contractId, fileId: fileId }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (filesSaved) {
      dispatch({ type: 'CONTRACT_FILES_MODIFIED', payload: { files: filesSaved } });
    });
  };
};
var modifyFileFromContractInDB = exports.modifyFileFromContractInDB = function modifyFileFromContractInDB(contractId, fileId, updater) {
  return function (dispatch) {
    return (0, _http.put)('/proxy/contracting/contract/file', { contractId: contractId, fileId: fileId, updater: updater }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (filesSaved) {
      dispatch({ type: 'CONTRACT_FILES_MODIFIED', payload: { files: filesSaved } });
    });
  };
};
function createDraft(contractId, templateId, templateEdit) {
  return (0, _http.post)('/proxy/contracting/draft/' + contractId, {
    templateId: templateId,
    templateEdit: templateEdit
  }).then(_checkStatus2.default).then(function (res) {
    return res.json();
  });
}

function clearStore() {
  return { type: 'CLEAR_CONTRACT_ACTIVITY_PRODUCT_REDUCER' };
}
var catchLoadContentError = _ramda2.default.curry(function (dispatch, collection, err) {
  console.log(err);
  dispatch({
    type: 'GET_CONTRACT_INFO_ERROR',
    payload: {
      errorOccurs: _ramda2.default.call(_ramda2.default.cond([[function () {
        return (err.message || '').toLowerCase() === 'not found';
      }, function () {
        if (window.location.href.indexOf("https://sec.tourconnect.com") > -1) {
          return 'In order to protect the security and integrity of rate data, you can only have one rate sheet open at a time.';
        }
        return '' + (collection === 'draft' ? 'This draft no longer exists.' : 'This document does not exist.');
      }], [function () {
        return err.message === 'Forbidden';
      }, _ramda2.default.always('You don\'t have permission to view this document.')], [_ramda2.default.T, _ramda2.default.always('An Error Occurred')]]))
    }
  });
});
var getContractLeftNav = exports.getContractLeftNav = function getContractLeftNav(collection, contractId, backgroundRefresh) {
  return function (dispatch, getState) {
    if (!backgroundRefresh) dispatch({ type: 'CONTRACT_LEFT_NAV_LOADING' });
    if (collection === 'draft') dispatch(checkContractReadiness(contractId));
    return (0, _api.callApiJWT)('/contracting/getContractInfo/' + contractId, 'post', {
      query: collection === 'contract' || collection === 'workspace' ? queries.getLeftNavQuery : queries.draftTemplateLeftNav,
      contractId: contractId,
      collection: collection === 'workspace' ? 'contract' : collection
    }).then(function (_ref) {
      var res = _ref.response;

      dispatch({ type: 'GET_CONTRACT_LEFT_NAV', payload: _extends({}, res, _defineProperty({ contractId: contractId, collection: collection }, contractId + 'Loaded', true)) });
      return { payload: _extends({}, res, _defineProperty({ contractId: contractId, collection: collection }, contractId + 'Loaded', true)) };
    }).catch(catchLoadContentError(dispatch, collection));
  };
};

var getContractDetails = exports.getContractDetails = function getContractDetails(collection, contractId, backgroundRefresh) {
  return function (dispatch, getState) {
    if (!backgroundRefresh) dispatch({ type: 'CONTRACT_CONTENT_LOADING' });
    return (0, _api.callApiJWT)('/contracting/getContractInfo/' + contractId, 'post', {
      query: collection === 'contract' || collection === 'workspace' ? queries.getContractDetailsQuery : queries.draftTemplateContractDetails,
      contractId: contractId,
      collection: collection === 'workspace' ? 'contract' : collection
    }).then(function (_ref2) {
      var res = _ref2.response;

      dispatch({ type: 'GET_CONTRACT_DETAILS', payload: _extends({}, res, _defineProperty({ contractId: contractId, collection: collection }, contractId + 'Loaded', true)) });
    }).catch(catchLoadContentError(dispatch, collection));
  };
};
function openImportFromOtherProductsDialog(noShowIfEmpty) {
  return function (dispatch, getState) {
    return dispatch({
      type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE', payload: {
        type: 'copyDataFromAnotherProduct',
        title: 'Copy data from another product',
        data: {
          noShowIfEmpty: noShowIfEmpty
        }
      }
    });
  };
}
var getProductDetails = exports.getProductDetails = function getProductDetails(collection, contractId, productId, ratePackage, backgroundRefresh) {
  return function (dispatch, getState) {
    if (!productId || productId === 'undefined') return dispatch({ type: 'GET_PRODUCT_DETAILS', payload: { product: {} } });
    if (!backgroundRefresh) dispatch({ type: 'CONTRACT_CONTENT_LOADING' });
    return (0, _api.callApiJWT)('/contracting/getProductInfo/' + contractId + '/' + productId + '/' + ratePackage, 'post', {
      query: collection === 'contract' ? queries.getProductDetailsQuery : queries.draftTemplateProductQuery,
      contractId: contractId,
      productId: productId,
      collection: collection
    }).then(function (_ref3) {
      var res = _ref3.response;

      return dispatch({ type: 'GET_PRODUCT_DETAILS', payload: _extends({}, res, {
          contractId: contractId,
          collection: collection,
          product: _extends({}, res.product, _defineProperty({}, contractId + 'Loaded', true)) })
      });
    });
    // .catch(catchLoadContentError(dispatch, collection));
  };
};

var reloadContentInBg = exports.reloadContentInBg = function reloadContentInBg(_ref4) {
  var collection = _ref4.collection,
      contractId = _ref4.contractId,
      productId = _ref4.productId,
      ratePackage = _ref4.ratePackage;
  return function (dispatch) {
    dispatch(getContractLeftNav(collection, contractId, true));
    if (productId) dispatch(getProductDetails(collection, contractId, productId, ratePackage, true));else dispatch(getContractDetails(collection, contractId, true));
  };
};

var getHistoryFeeds = exports.getHistoryFeeds = function getHistoryFeeds(collection, contractId) {
  return function (dispatch, getState) {
    dispatch({ type: 'LOADING_HISTORY_FEEDS' });
    return (0, _api.callApiJWT)('/contracting/getHistoryFeed/' + contractId + '/' + collection, 'get').then(function (_ref5) {
      var response = _ref5.response;

      return dispatch({ type: 'GET_HISTORY_FEEDS', payload: { response: response, contractId: contractId } });
    });
  };
};

var deleteProductFromContract = exports.deleteProductFromContract = function deleteProductFromContract(payload) {
  return function (dispatch, getState) {
    var locationId = getState().contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId']);
    var hasAccess = (0, _accessCheckHelperFns.checkLocAccess)(getState(), locationId, 'contracting', 'write');
    if (!hasAccess) return dispatch((0, _accessCheckHelperFns.triggerNoAccessWarning)({ featureName: 'contracting' }));

    var composedUrl = '/proxy/contracting/deleteProductFromContract';
    var onOk = function onOk() {
      dispatch({ type: 'DELETE_PRODUCT_FROM_CONTRACT_START' });
      return (0, _http.del)(composedUrl, payload).then(_checkStatus2.default).then(function (res) {
        return res.json();
      }).then(function (response) {
        dispatch(getContractLeftNav('draft', payload.contractId));
        return dispatch({ type: 'DELETE_PRODUCT_FROM_CONTRACT', payload: _extends({}, payload, response) });
      }).catch(function (err) {
        return console.log(err.stack);
      });
    };
    dispatch({ type: 'open_global_alert', payload: {
        text: 'Are you sure you want to remove this product from this contract?',
        onOk: onOk
      } });
  };
};
function updatePartnerForSentDoc() {
  return { type: 'UPDATE_CONTRACT_PARTNER_INFO' };
}
function doResendContract() {
  return function (dispatch, getState) {
    var _getState$contracting = getState().contracting.resendContractDialog.toJS(),
        contractId = _getState$contracting.contractId,
        customizedMessage = _getState$contracting.customizedMessage,
        resendToEmails = _getState$contracting.resendToEmails,
        _getState$contracting2 = _getState$contracting.newRecipients,
        newRecipients = _getState$contracting2 === undefined ? [] : _getState$contracting2,
        partner = _getState$contracting.partner,
        subject = _getState$contracting.subject,
        deadlineDate = _getState$contracting.deadlineDate;

    dispatch({ type: 'RESEND_CONTRACT_STARTING', payload: true });
    return fetch('/proxy/contracting/resendContract/' + contractId, {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        deadlineDate: deadlineDate,
        customizedMessage: customizedMessage,
        resendToEmails: resendToEmails,
        newRecipients: newRecipients.filter(function (obj) {
          return obj.email && obj.email.trim();
        }).map(function (obj) {
          return _extends({}, obj, { email: obj.email.trim().toLowerCase() });
        }),
        partner: partner,
        subject: subject
      })
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      if (newRecipients && newRecipients.length) reloadContentInBg({ collection: 'contract', contractId: contractId })(dispatch);
      return dispatch({ type: 'RESEND_CONTRACT_FINISHED' });
    });
  };
}

var downloadContractPdf = exports.downloadContractPdf = function downloadContractPdf(contractId, state, anchorEl) {
  return function (dispatch) {
    return dispatch({
      type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
      payload: {
        docId: contractId,
        collection: _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.isNil, _ramda2.default.always('template')], [_ramda2.default.equals('publish-ready'), _ramda2.default.always('draft')], [_ramda2.default.equals('draft'), _ramda2.default.always('draft')], [_ramda2.default.equals('template'), _ramda2.default.always('template')], [_ramda2.default.T, _ramda2.default.always('contract')]]), state),
        anchorEl: anchorEl
      }
    });
  };
};

var discardEditedDraft = exports.discardEditedDraft = function discardEditedDraft(contractId) {
  return function (dispatch, getState) {
    var locationId = getState().contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId']);
    var hasAccess = (0, _accessCheckHelperFns.checkLocAccess)(getState(), locationId, 'contracting', 'write');
    if (!hasAccess) return dispatch((0, _accessCheckHelperFns.triggerNoAccessWarning)({ featureName: 'contracting' }));

    var confirmed = window.confirm('Are you sure you want to discard all changes you made with this draft?');
    if (confirmed) {
      dispatch({ type: 'DISCARD_EDITED_CONTRACT_DRAFT_STARTING', payload: { contractId: contractId } });
      return fetch('/proxy/contracting/discardEditedDraft/' + contractId, {
        method: 'delete',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
      }).then(function (res) {
        if (res.status !== 200) throw new Error(res.status);
        return _bluebird2.default.resolve({});
      }).then(function () {
        dispatch((0, _reactRouterRedux.replace)('/contracting/template/' + contractId + '/details'));
      }).catch(function (err) {
        return dispatch({ type: 'DISCARD_EDITED_CONTRACT_DRAFT_FAILED', payload: { contractId: contractId } });
      });
    }
  };
};

function sortingProducts(contractId, products) {
  return function (dispatch, getState) {
    return fetch('/proxy/contracting/sortingProducts', {
      method: 'put',
      credentials: 'same-origin',
      body: JSON.stringify({
        contractId: contractId,
        products: products
      }),
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      var productId = getState().contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productId']);
      var ratePackage = getState().contracting.contractActivitiesProducts.getIn(['rightSideContent', 'ratePackageName']) || 'Primary';
      reloadContentInBg({ collection: 'draft', contractId: contractId, productId: productId, ratePackage: ratePackage })(dispatch);
      return dispatch({ type: 'PRODUCTS_SORTED_IN_CONTRACT', payload: { contractId: contractId, products: products } });
    });
  };
}

function checkContractReadiness(draftId) {
  var composedUrl = '/contracting/checkContractReadiness/' + draftId;
  return function (dispatch) {
    return (0, _api.callApiJWT)(composedUrl, 'put').then(function (_ref6) {
      var response = _ref6.response;

      dispatch({ type: '[template-draft]CHECK_COMPLETENESS_FOR_TEMPLATE_DRAFT', payload: { errors: response.errors } });
    });
  };
}

var onCheckSyncSection = exports.onCheckSyncSection = function onCheckSyncSection(sectionInEdit, checked) {
  return { type: 'ON_CHECK_SYNC_SECTION_IN_CONTRACT_TEMPLATE_DRAFT', payload: { sectionInEdit: sectionInEdit, checked: checked } };
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _react.PropTypes.any,
  value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  buttonStyleProps: _react.PropTypes.object,
  button: _react.PropTypes.node,
  menuProps: _react.PropTypes.object,
  useList: _react.PropTypes.bool
};

var FlatDropDownMenu = function (_React$Component) {
  _inherits(FlatDropDownMenu, _React$Component);

  function FlatDropDownMenu() {
    _classCallCheck(this, FlatDropDownMenu);

    var _this = _possibleConstructorReturn(this, (FlatDropDownMenu.__proto__ || Object.getPrototypeOf(FlatDropDownMenu)).call(this));

    _this.handleButtonClick = function (e) {
      if (e) _this.setState({ menuOpen: true, anchorEl: e.currentTarget });
    };

    _this.dismissMenu = function () {
      _this.setState({ menuOpen: false });
    };

    _this.state = { menuOpen: false };
    return _this;
  }

  _createClass(FlatDropDownMenu, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          button = _props.button,
          _props$menuProps = _props.menuProps,
          menuProps = _props$menuProps === undefined ? {} : _props$menuProps,
          useList = _props.useList,
          children = _props.children;
      var _state = this.state,
          menuOpen = _state.menuOpen,
          anchorEl = _state.anchorEl;

      return _react2.default.createElement(
        'div',
        null,
        (0, _react.cloneElement)(button, { onTouchTap: this.handleButtonClick, onClick: this.handleButtonClick }),
        _react2.default.createElement(
          _materialUi.Popover,
          {
            open: menuOpen,
            onRequestClose: this.dismissMenu,
            anchorEl: anchorEl,
            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
            targetOrigin: { horizontal: 'left', vertical: 'top' }
          },
          useList ? _react2.default.createElement(
            _materialUi.List,
            _extends({
              onClick: this.dismissLis
            }, menuProps),
            children
          ) : _react2.default.createElement(
            _materialUi.Menu,
            _extends({
              onItemTouchTap: this.dismissMenu,
              desktop: true
            }, menuProps),
            children
          )
        )
      );
    }
  }]);

  return FlatDropDownMenu;
}(_react2.default.Component);

FlatDropDownMenu.propTypes = propTypes;
exports.default = FlatDropDownMenu;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _autorenew = __webpack_require__(3379);

var _autorenew2 = _interopRequireDefault(_autorenew);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _errorCheckIndicatorIcon = __webpack_require__(1138);

var _errorCheckIndicatorIcon2 = _interopRequireDefault(_errorCheckIndicatorIcon);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _dialogConstants = __webpack_require__(616);

var _sameAsCheckbox = __webpack_require__(3380);

var _sameAsCheckbox2 = _interopRequireDefault(_sameAsCheckbox);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var propTypes = {
  justLabel: _react2.default.PropTypes.bool,
  labelStyle: _react2.default.PropTypes.object,
  labelText: _react2.default.PropTypes.string,
  contractId: _react2.default.PropTypes.string,
  productId: _react2.default.PropTypes.string,
  editable: _react2.default.PropTypes.bool,
  showSync: _react2.default.PropTypes.bool,
  value: _react2.default.PropTypes.oneOf(['seasons', 'offers', 'extras', 'blackouts', 'pickup', 'dropoff', 'allocation', 'checkinout', 'infant', 'cancellation', 'child', 'family', 'freeOfCharge', 'group', 'marketInfo', 'termsAndConditions', 'submissionCriteria', 'billingInfo', 'insuranceInfo']).isRequired,
  syncDataToOtherProducts: _react2.default.PropTypes.func,
  children: _react2.default.PropTypes.node,
  errors: _react2.default.PropTypes.array,
  isADraft: _react2.default.PropTypes.bool,
  ratePackageNames: _react2.default.PropTypes.array,
  syncProductInfo: _react2.default.PropTypes.func,
  onCheckSyncSection: _react2.default.PropTypes.func,
  showMasterToggle: _react2.default.PropTypes.bool,
  masterTemplateApplied: _react2.default.PropTypes.bool,
  openEditDialog: _react2.default.PropTypes.func,
  actions: _react2.default.PropTypes.array
};

var HelperLink = function (_React$Component) {
  _inherits(HelperLink, _React$Component);

  function HelperLink(props) {
    _classCallCheck(this, HelperLink);

    var _this = _possibleConstructorReturn(this, (HelperLink.__proto__ || Object.getPrototypeOf(HelperLink)).call(this, props));

    _this.onConfirm = function () {
      var _this$props = _this.props,
          productId = _this$props.productId,
          value = _this$props.value,
          contractId = _this$props.contractId,
          syncProductInfo = _this$props.syncProductInfo;
      var _this$state = _this.state,
          dialogContentType = _this$state.dialogContentType,
          syncRatesToo = _this$state.syncRatesToo;

      if (dialogContentType === 'sync') {
        syncProductInfo({ contractId: contractId, productId: productId, sectionInEdit: value, syncRatesToo: syncRatesToo }).then(function () {
          return _this.setState({ loading: false, dialogOpen: false });
        });
      }
    };

    _this.getDialogContent = function () {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          labelText = _this$props2.labelText;
      var _this$state2 = _this.state,
          syncRatesToo = _this$state2.syncRatesToo,
          dialogContentType = _this$state2.dialogContentType;

      if (dialogContentType === 'sync') {
        if (value === 'seasons') {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'label',
              null,
              'Please select what you would like to sync to other products:'
            ),
            _react2.default.createElement(_materialUi.RadioButton, {
              label: 'Seasons',
              checked: !syncRatesToo,
              onCheck: function onCheck() {
                return _this.setState({ syncRatesToo: false });
              }
            }),
            _react2.default.createElement(_materialUi.RadioButton, {
              label: 'Seasons with Rates',
              checked: syncRatesToo,
              onCheck: function onCheck() {
                return _this.setState({ syncRatesToo: true });
              }
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'i',
              null,
              'Please note that existing ',
              !syncRatesToo ? 'SEASON' : 'SEASON & RATES',
              ' in other products will be overwritten.'
            )
          );
        }
        return _react2.default.createElement(
          'i',
          null,
          'Please note that existing ',
          labelText,
          ' in other products will be overwritten.'
        );
      }

      return _react2.default.createElement('input', null);
    };

    _this.openPopover = function (dialogContentType) {
      return function () {
        return _this.setState({ dialogOpen: true, dialogContentType: dialogContentType });
      };
    };

    _this.state = {
      dialogOpen: false,
      loading: false,
      syncRatesToo: false
    };
    return _this;
  }

  _createClass(HelperLink, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes);
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          justLabel = _props.justLabel,
          contractId = _props.contractId,
          value = _props.value,
          labelStyle = _props.labelStyle,
          children = _props.children,
          labelText = _props.labelText,
          editable = _props.editable,
          showSync = _props.showSync,
          showMasterToggle = _props.showMasterToggle,
          masterTemplateApplied = _props.masterTemplateApplied,
          errors = _props.errors,
          _props$actions = _props.actions,
          actions = _props$actions === undefined ? [] : _props$actions;
      var dialogOpen = this.state.dialogOpen;

      var loading = this.state.loading;
      if (justLabel) {
        return _react2.default.createElement(
          'div',
          {
            style: _ramda2.default.merge({ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }, labelStyle)
          },
          _react2.default.createElement(
            'b',
            null,
            children || labelText
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'flex-tc-sb' },
        _react2.default.createElement(
          'div',
          {
            style: _ramda2.default.merge({ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }, labelStyle)
          },
          _react2.default.createElement(
            'b',
            null,
            children || labelText
          ),
          errors.map(function (err, index) {
            return _react2.default.createElement(
              'div',
              { key: index, style: { display: 'flex', alignItems: 'center', color: '#f44336' } },
              '\xA0 ',
              _react2.default.createElement(_errorCheckIndicatorIcon2.default, { showError: true }),
              ' \xA0',
              err
            );
          })
        ),
        showMasterToggle && _react2.default.createElement(_sameAsCheckbox2.default, {
          editable: editable,
          sectionValue: value,
          templateDraftId: contractId,
          masterTemplateApplied: masterTemplateApplied
        }),
        editable && (showSync || actions.length > 1) && _react2.default.createElement(
          _materialUi.IconMenu,
          { desktop: true, iconButtonElement: _react2.default.createElement(_materialUi.IconButton, { iconClassName: 'tc-icon-more-vert' }) },
          _react2.default.createElement(_materialUi.MenuItem, {
            disabled: !showSync,
            primaryText: 'Sync to Other Product',
            desktop: true,
            onTouchTap: this.openPopover('sync')
          }),
          actions.map(function (obj) {
            return _react2.default.createElement(_materialUi.MenuItem, {
              key: obj.label,
              primaryText: obj.label,
              desktop: true,
              onTouchTap: obj.onTouchTap
            });
          })
        ),
        showSync && _react2.default.createElement(
          _materialUi.Dialog,
          {
            open: dialogOpen,
            contentStyle: { width: '450px' },
            onRequestClose: function onRequestClose() {
              return _this2.setState({ dialogOpen: false });
            },
            actions: [_react2.default.createElement(_flatButtonWithLoader2.default, {
              label: 'cancel',
              primary: true,
              disabled: loading,
              onTouchTap: function onTouchTap() {
                return _this2.setState({ dialogOpen: false });
              }
            }), _react2.default.createElement(_flatButtonWithLoader2.default, {
              label: 'confirm',
              secondary: true,
              onTouchTap: this.onConfirm,
              loader: loading
            })]
          },
          this.getDialogContent()
        )
      );
    }
  }]);

  return HelperLink;
}(_react2.default.Component);

HelperLink.propTypes = propTypes;
exports.default = (0, _reactRedux.connect)(function (_ref, _ref2) {
  var contracting = _ref.contracting;
  var value = _ref2.value;

  var contract = contracting.contractActivitiesProducts.toJS();
  var leftNav = contract.leftNav;
  var rightContent = contract.rightSideContent;
  var productId = rightContent.productId;
  var ratePackageIndex = rightContent.ratePackageIndex;
  var draftErrors = contract.draftErrors;
  var isADraft = leftNav.contractState === 'draft' || leftNav.contractState === 'publish-ready';
  var masterTemplateApplied = _ramda2.default.contains(value, rightContent.sameAsCorporatePolicyNotes || []);
  var showMasterToggle = Boolean(rightContent.policyNotesTemplateId);
  var errors = [];
  if (isADraft) {
    if (productId && !isNilOrEmpty(draftErrors)) {
      var productError = draftErrors.products.find(_ramda2.default.propEq('ratePackageIndex', ratePackageIndex)) || {};

      if (value === 'seasons') {
        if (_ramda2.default.path(['rates', 'seasonsCoveringWholePeriod'], productError) > 0) {
          errors.push('Required');
        }
        if (_ramda2.default.path(['rates', 'overlappedSeasonRates'], productError) < 0) {
          errors.push('Overlapping Dates');
        }
        if (_ramda2.default.path(['rates', 'datesOutside'], productError)) {
          errors.push('-- Your seasons are not within your contract validity period.');
        }
        // if (R.path(['rates', 'emptySeasonDates'], productError))
        // errors.push('-- One or more seasons have missing dates'); // HANDLED
      }
      if (value === 'offers' && _ramda2.default.path(['offers', 'showOffer'], productError)) {
        if (_ramda2.default.path(['offers', 'emptyDates'], productError)) {
          errors.push('-- Missing Dates');
        } // HANDLED
        if (_ramda2.default.path(['offers', 'datesOutside'], productError)) {
          errors.push('-- Dates fall outside of contracting period');
        }
      }
      if (value === 'allocation') {
        if (_ramda2.default.path(['allocation', 'allocationMissing'], productError)) {
          errors.push('Required');
        }
        if (_ramda2.default.path(['allocation', 'incompleteAllocation'], productError)) {
          errors.push('Incomplete');
        }
        if (_ramda2.default.path(['allocation', 'datesOutside'], productError)) {
          errors.push('-- Dates fall outside of contracting period');
        }
      }
      if (value === 'blackouts' && _ramda2.default.path(['blackouts', 'showBlackout'], productError)) {
        if (_ramda2.default.path(['blackouts', 'emptyDates'], productError)) {
          errors.push('-- Missing Dates');
        } // HANDLED
        if (_ramda2.default.path(['blackouts', 'datesOutside'], productError)) {
          errors.push('-- Dates fall outside of contracting period');
        }
      }
      if (value === 'pickup') {
        if (_ramda2.default.path(['pickup', 'pickupMissing'], productError)) {
          errors.push('Required');
        }
        if (_ramda2.default.path(['pickup', 'incompletePickup'], productError)) {
          errors.push('Incomplete');
        }
        if (_ramda2.default.path(['pickup', 'datesOutside'], productError)) {
          errors.push('-- Dates fall outside of contracting period');
        }
      }
      if (value === 'dropoff') {
        if (_ramda2.default.path(['dropoff', 'dropoffMissing'], productError)) {
          errors.push('Required');
        }
        if (_ramda2.default.path(['dropoff', 'incompleteDropoff'], productError)) {
          errors.push('Incomplete');
        }
        if (_ramda2.default.path(['dropoff', 'datesOutside'], productError)) {
          errors.push('-- Dates fall outside of contracting period');
        }
      }
      if (value === 'cancellation' && _ramda2.default.path(['cancellation', 'showCancellation'], productError)) {
        if (_ramda2.default.path(['cancellation', 'incompleteCancellation'], productError)) {
          errors.push('Incomplete');
        }
        if (_ramda2.default.path(['cancellation', 'datesOutside'], productError)) {
          errors.push('-- Dates fall outside of contracting period');
        }
      }
    } else {
      if (value === 'checkinout' && _ramda2.default.propOr([], 'checkInCheckOutMissing', draftErrors).length) {
        errors.push('Required');
      }
      if (value === 'cancellation') {
        if (_ramda2.default.contains('cancellation', draftErrors.policyMissing || [])) {
          errors.push('Required');
        }
        if (draftErrors.incompleteCancellation) {
          errors.push('Incomplete');
        }
      }
      if (value === 'child' && _ramda2.default.contains('child', draftErrors.policyMissing || [])) {
        errors.push('Required');
      }
      // if (value === 'infant' && R.contains('infant', draftErrors.policyMissing))
      // errors.push('Required');
    }
  }
  return {
    productId: productId,
    ratePackageNames: rightContent.ratePackageNames,
    contractId: leftNav.contractId,
    isADraft: isADraft,
    editable: contracting.contractActivitiesProducts.getIn(['leftNav', 'supplierEditable']),
    errors: errors,
    showMasterToggle: showMasterToggle,
    masterTemplateApplied: masterTemplateApplied
  };
}, { syncProductInfo: _dialogConstants.syncProductInfo })(HelperLink);

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
// ==============================
// THEME
// ==============================

var theme = {};

// container
theme.container = {
	background: 'rgba(0, 0, 0, 0.8)',
	gutter: {
		horizontal: 10,
		vertical: 10
	},
	zIndex: 2001
};

// header
theme.header = {
	height: 40
};
theme.close = {
	fill: 'white'
};

// footer
theme.footer = {
	color: 'white',
	count: {
		color: 'rgba(255, 255, 255, 0.75)',
		fontSize: '0.85em'
	},
	height: 40,
	gutter: {
		horizontal: 0,
		vertical: 5
	}
};

// thumbnails
theme.thumbnail = {
	activeBorderColor: 'white',
	size: 50,
	gutter: 2
};

// arrow
theme.arrow = {
	background: 'none',
	fill: 'white',
	height: 120
};

exports.default = theme;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1578);


/***/ }),
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var updateProps = exports.updateProps = function updateProps(type) {
  return 'UPDATE_PROPS_IN_MESSAGING_' + type.toUpperCase();
};

var LOADING_LIST = exports.LOADING_LIST = '[inbox]LOADING_CONVERSATION_LIST';
var LIST_LOADED = exports.LIST_LOADED = '[inbox]CONVERSATION_LIST_LOADED';

var LOADING_MSGS = exports.LOADING_MSGS = '[inbox]LOADING_MSGS_IN_MESSAGING';
var MSGS_LOADED_INITIALLY = exports.MSGS_LOADED_INITIALLY = '[inbox]MSGS_LOADED_INITIALLY_IN_MESSAGING';

var CREATING_CONTRACT = exports.CREATING_CONTRACT = '[inbox]CREATING_CONTRACT_IN_MESSAGING';
var CONTRACT_CREATED = exports.CONTRACT_CREATED = '[inbox]CONTRACT_CREATED_IN_MESSAGING';
var CREATE_CONTRACT_FAILED = exports.CREATE_CONTRACT_FAILED = '[inbox]CREATE_CONTRACT_FAILED_IN_MESSAGING';

var TOGGLE_CONV_DONESS = exports.TOGGLE_CONV_DONESS = '[inbox]TOGGLE_CONV_DONESS_IN_MESSAGING';
var TOGGLE_CONV_DONESS_SUCCESS = exports.TOGGLE_CONV_DONESS_SUCCESS = '[inbox]TOGGLE_CONV_DONESS_IN_MESSAGING_SUCCESS';

var GET_PARTNERS = exports.GET_PARTNERS = '[inbox]GET_PARTNERS';

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(10).Buffer
var Transform = __webpack_require__(229).Transform
var inherits = __webpack_require__(8)

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(8)
var Hash = __webpack_require__(122)
var Buffer = __webpack_require__(10).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8)
var Hash = __webpack_require__(122)
var Buffer = __webpack_require__(10).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(8)
var Legacy = __webpack_require__(664)
var Base = __webpack_require__(87)
var Buffer = __webpack_require__(10).Buffer
var md5 = __webpack_require__(511)
var RIPEMD160 = __webpack_require__(241)

var sha = __webpack_require__(242)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(240)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(666)
exports.pbkdf2Sync = __webpack_require__(516)


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(511)
var RIPEMD160 = __webpack_require__(241)
var sha = __webpack_require__(242)

var checkParameters = __webpack_require__(514)
var defaultEncoding = __webpack_require__(515)
var Buffer = __webpack_require__(10).Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(136)
var Buffer = __webpack_require__(10).Buffer
var incr32 = __webpack_require__(518)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),
/* 518 */
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(212)
var Buffer = __webpack_require__(10).Buffer
var Transform = __webpack_require__(87)
var inherits = __webpack_require__(8)
var GHASH = __webpack_require__(681)
var xor = __webpack_require__(136)
var incr32 = __webpack_require__(518)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(212)
var Buffer = __webpack_require__(10).Buffer
var Transform = __webpack_require__(87)
var inherits = __webpack_require__(8)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(121);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(22);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(523);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(22);
var brorand = __webpack_require__(524);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(686);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var common = __webpack_require__(137);
var shaCommon = __webpack_require__(526);
var assert = __webpack_require__(48);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var common = __webpack_require__(137);
var assert = __webpack_require__(48);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8);
var Reporter = __webpack_require__(139).Reporter;
var Buffer = __webpack_require__(24).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(718);


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8);

var asn1 = __webpack_require__(138);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8);
var Buffer = __webpack_require__(24).Buffer;

var asn1 = __webpack_require__(138);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__(135)
var Buffer = __webpack_require__(10).Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__(22)
var Buffer = __webpack_require__(10).Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUsers = exports.loadPartners = exports.bulkDownloadS3File = exports.downloadFromUrl = exports.deleteFileFromS3 = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getContractingYears = getContractingYears;

var _http = __webpack_require__(118);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _jszip = __webpack_require__(587);

var _jszip2 = _interopRequireDefault(_jszip);

var _jszipUtils = __webpack_require__(606);

var _jszipUtils2 = _interopRequireDefault(_jszipUtils);

var _fileSaver = __webpack_require__(607);

var _docCookie = __webpack_require__(142);

var _docCookie2 = _interopRequireDefault(_docCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deleteFileFromS3 = exports.deleteFileFromS3 = function deleteFileFromS3(path) {
  return (0, _http.del)('/proxy/s3/file', { path: path }).then(_checkStatus2.default);
};
var downloadFromUrl = exports.downloadFromUrl = function downloadFromUrl(file) {
  return function () {
    // return window.open(`${apiUrl}/s3/file?key=${path}`);
    var a = document.createElement('a');
    a.download = file.fileName || file.name || '';
    a.target = '_blank';
    a.setAttribute('download', file.fileName || file.name);
    a.href = '/proxy/s3/file?key=' + encodeURIComponent(file.url || file.path);
    // firefox doesn't support `a.click()`...
    a.dispatchEvent(new MouseEvent('click'));
  };
};

var bulkDownloadS3File = exports.bulkDownloadS3File = function bulkDownloadS3File(files, zipName) {
  // IMPORTANT: file.path here does not include s3 url and s3bucket
  var zip = new _jszip2.default();
  var count = 0;
  files.forEach(function (file, fileIndex) {
    _jszipUtils2.default.getBinaryContent('/proxy/s3/file?key=' + encodeURIComponent(file.path || file.url), function (err, data) {
      if (!err) zip.file(fileIndex + 1 + '-' + (file.name || file.fileName), data, { binary: true });
      count++;
      if (count === files.length) {
        zip.generateAsync({ type: 'blob' }).then(function (content) {
          (0, _fileSaver.saveAs)(content, (zipName || 'TCFiles') + '.zip');
        });
      }
    });
  });
};

var loadPartners = exports.loadPartners = function loadPartners(loadingConstant, doneConstant) {
  return function (dispatch, getState) {
    if (loadingConstant) dispatch({ type: loadingConstant });
    return (0, _http.get)('/proxy/partners').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: doneConstant, payload: response });
    });
  };
};

var getUsers = exports.getUsers = function getUsers(companyId, constant) {
  return function (dispatch, getState) {
    return (0, _http.get)('/proxy/company/' + companyId + '/users').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({ type: constant, payload: res });
    });
  };
};

function getContractingYears() {
  return function (dispatch) {
    dispatch({ type: 'GETTING_CONTRACTING_YEARS' });
    return fetch('/proxy/contracting/contractingYears', {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      dispatch({ type: 'GOT_CONTRACTING_YEARS', payload: response });
      if (response && response.length) {
        var startInCookie = _docCookie2.default.getItem('contractYearStartDate');
        var endInCookie = _docCookie2.default.getItem('contractYearEndDate');
        if (!(startInCookie && endInCookie)) {
          _docCookie2.default.setItem('contractYearStartDate', response[0].startDate, Infinity, '/');
          _docCookie2.default.setItem('contractYearEndDate', response[0].endDate, Infinity, '/');
          dispatch({ type: '[contracting]INIT_SELECTED_YEAR_FOR_CONTRACTING', payload: _extends({}, response[0], { firstLoad: true }) });
        } else {
          dispatch({ type: '[contracting]INIT_SELECTED_YEAR_FOR_CONTRACTING', payload: { startDate: startInCookie, endDate: endInCookie, firstLoad: true } });
        }
      } else {
        dispatch({ type: '[contracting]INIT_SELECTED_YEAR_FOR_CONTRACTING', payload: { startDate: '2018-04-01 00:00:00.000Z', endDate: '2019-03-31 00:00:00.000Z', firstLoad: true } });
      }
    });
  };
}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1915);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MAP = exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;

var MARKER = exports.MARKER = "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var RECTANGLE = exports.RECTANGLE = "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var POLYLINE = exports.POLYLINE = "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var POLYGON = exports.POLYGON = "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var CIRCLE = exports.CIRCLE = "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var KML_LAYER = exports.KML_LAYER = "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var DIRECTIONS_RENDERER = exports.DIRECTIONS_RENDERER = "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var HEATMAP_LAYER = exports.HEATMAP_LAYER = "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var FUSION_TABLES_LAYER = exports.FUSION_TABLES_LAYER = "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var ANCHOR = exports.ANCHOR = "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var INFO_WINDOW = exports.INFO_WINDOW = "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var OVERLAY_VIEW = exports.OVERLAY_VIEW = "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var DRAWING_MANAGER = exports.DRAWING_MANAGER = "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var SEARCH_BOX = exports.SEARCH_BOX = "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var MARKER_CLUSTERER = exports.MARKER_CLUSTERER = "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var INFO_BOX = exports.INFO_BOX = "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var TRAFFIC_LAYER = exports.TRAFFIC_LAYER = "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(3022);

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;


/***/ }),
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(89);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(906);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(643);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // It's a getter.
      if (value === undefined) return this.style[name];

      // Don't do anything if the value has not changed.
      if (this.style[name] === value) return this;

      value = this.options.jss.plugins.onChangeValue(value, name, this);

      var isEmpty = value == null || value === false;
      var isDefined = name in this.style;

      // Value is empty and wasn't defined before.
      if (isEmpty && !isDefined) return this;

      // We are going to remove this value.
      var remove = isEmpty && isDefined;

      if (remove) delete this.style[name];else this.style[name] = value;

      // Renderable is defined if StyleSheet option `link` is true.
      if (this.renderable) {
        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
        return this;
      }

      var sheet = this.options.sheet;

      if (sheet && sheet.attached) {
        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
      }
      return this;
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setProperty(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (!this.renderable) return;

      var hasChanged = this.renderer.setSelector(this.renderable, selector);

      // If selector setter is not implemented, rerender the rule.
      if (!hasChanged && this.renderable) {
        var renderable = this.renderer.replaceRule(this.renderable, this);
        if (renderable) this.renderable = renderable;
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reorderProducts = exports.reorderLocations = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.updateSuppProfileProps = updateSuppProfileProps;
exports.getProfile = getProfile;
exports.updateGroup = updateGroup;
exports.deleteGroup = deleteGroup;
exports.deleteCoverImageFromProfile = deleteCoverImageFromProfile;
exports.removeLocation = removeLocation;
exports.importLocData = importLocData;
exports.addLocation = addLocation;
exports.editProfileField = editProfileField;

var _soFetch = __webpack_require__(254);

var _profileConstants = __webpack_require__(646);

var constants = _interopRequireWildcard(_profileConstants);

var _profileGraphqlQuery = __webpack_require__(863);

var queries = _interopRequireWildcard(_profileGraphqlQuery);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _http = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function updateSuppProfileProps(payload) {
  return { type: constants.UPDATE_SUPP_PROFILE_PROP, payload: payload };
}

function getProfile() {
  return (0, _soFetch.soFetch)('/proxy/profile?query=' + queries.profileQuery, {
    method: 'get',
    actionType: constants.GET_PROFILE,
    responseBinding: 'profile'
  });
}

function updateGroup(payload) {
  return { type: constants.UPDATE_GROUP, payload: payload };
}

function deleteGroup(group) {
  return { type: constants.DELETE_GROUP, payload: group };
}

function deleteCoverImageFromProfile(filename, id) {
  return function (dispatch) {
    return fetch('/proxy/profile/delete_cover_photos', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: filename })
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      return dispatch({
        type: constants.DELETE_COVER_IMAGE_FROM_PROFILE,
        payload: { id: id }
      });
    }).catch(function (err) {
      return console.log('err in deleting profile cover photo', err);
    });
  };
}

function removeLocation(locationId) {
  return function (dispatch) {
    dispatch({
      type: constants.REMOVE_LOCATION_STARTING,
      payload: { locationId: locationId }
    });
    return (0, _http.del)('/proxy/profile/locations/' + locationId).then(_checkStatus2.default).then(function () {
      return dispatch({ type: constants.REMOVE_LOCATION, payload: { locationId: locationId } });
    }).catch(function (err) {
      dispatch({ type: constants.REMOVE_LOCATION_FAILED });
      throw new Error(err);
    });
  };
}

function importLocData(payload) {
  return function (dispatch) {
    dispatch({ type: constants.IMPORTING_LOC });
    return fetch('/proxy/profile/createLocFromData', {
      method: 'post',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(_extends({}, payload))
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: constants.IMPORTED_LOC, payload: response });
    }).catch(function (err) {
      return console.log('err in adding loc through importing', err);
    });
  };
}

function addLocation(propertyName) {
  return (0, _soFetch.soFetch)('/proxy/profile/locations?mutation=' + queries.addLocationMutation, {
    body: { propertyName: propertyName },
    method: 'post',
    actionType: constants.ADD_LOCATION,
    responseBinding: 'payload'
  });
}

var reorderLocations = exports.reorderLocations = function reorderLocations(locations) {
  var locationIds = locations.map(function (loc) {
    return loc.id;
  });
  return {
    type: constants.REORDER_LOCATIONS,
    payload: { locationIds: locationIds }
  };
};

var reorderProducts = exports.reorderProducts = function reorderProducts(products) {
  var productIds = products.map(function (obj) {
    return obj.id;
  });
  return {
    type: constants.REORDER_PRODUCTS,
    payload: { productIds: productIds }
  };
};

function editProfileField(_ref) {
  var updateField = _ref.updateField,
      updateBody = _ref.updateBody;

  return function (dispatch) {
    var body = updateBody;
    if ((updateField === 'coverImageUrl' || updateField === 'profileImageUrl') && updateBody) {
      body += '?' + Date.now();
      if (updateField === 'profileImageUrl') {
        dispatch({ type: constants.PROFILE_IMAGE_CHANGED, payload: body });
      }
    }
    dispatch({
      type: constants.EDIT_PROFILE_FIELD_STARTING,
      payload: {
        updateField: updateField,
        updateBody: body
      }
    });
    return (0, _soFetch.soFetch)('/proxy/profile?mutation=' + queries.editCompanyMutation, {
      method: 'put',
      body: _defineProperty({}, updateField, body),
      actionType: constants.EDIT_PROFILE_FIELD,
      responseBinding: 'payload'
    })(dispatch);
  };
}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationClose = function NavigationClose(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
  );
};
NavigationClose = (0, _pure2.default)(NavigationClose);
NavigationClose.displayName = 'NavigationClose';
NavigationClose.muiName = 'SvgIcon';

exports.default = NavigationClose;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _jquery = __webpack_require__(251);

var _jquery2 = _interopRequireDefault(_jquery);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Dependencies
var ProfileLink = (0, _react.createClass)({

  propTypes: {
    imageUrl: _react.PropTypes.string,
    companySlugName: _react.PropTypes.string,
    largeImage: _react.PropTypes.bool,
    email: _react.PropTypes.string,
    className: _react.PropTypes.string,
    onClick: _react.PropTypes.func,
    style: _react.PropTypes.object,
    innerStyle: _react.PropTypes.object,
    isLoading: _react.PropTypes.bool,
    alwaysGrey: _react.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    var colors = ['is-red', 'is-pink', 'is-purple', 'is-deep-purple', 'is-indigo', 'is-blue', 'is-light-blue', 'is-cyan', 'is-teal', 'is-green', 'is-deep-orange'];

    var assignRandomColorClass = function assignRandomColorClass() {
      return colors[Math.floor(Math.random() * colors.length)];
    };

    var colorClass = 'profile-image-letter ' + (this.props.alwaysGrey ? 'is-grey' : assignRandomColorClass());

    return { colorClass: colorClass };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    var resizeCss = function resizeCss(wrapper) {
      var margin = void 0;
      if (_this.width > _this.height) {
        wrapper.css({ width: '100%', height: 'auto' });
        margin = (128 - _this.height) / 2;
        wrapper.css({ 'margin-top': margin, 'margin-bottom': margin });
      } else {
        wrapper.css({ width: 'auto', height: '100%' });
        margin = (128 - _this.width) / 2;
        wrapper.css({ 'margin-left': margin, 'margin-right': margin });
      }
    };
    if (this.props.imageUrl && this.props.largeImage) {
      (0, _jquery2.default)('#largeImage').load(function () {
        resizeCss.call(_this, (0, _jquery2.default)('#largeImage'));
      });
    }
  },
  render: function render() {
    var slugOrEmail = this.props.companySlugName || this.props.email;
    var classes = (0, _classnames2.default)('profile-image', this.props.className);
    var image = void 0;
    if (this.props.imageUrl) {
      if (this.props.largeImage) {
        image = _react2.default.createElement('img', { id: 'largeImage', className: 'profile-image-image', src: this.props.imageUrl });
      } else {
        image = _react2.default.createElement('img', { className: 'profile-image-image', src: this.props.imageUrl });
      }
    } else if (slugOrEmail) {
      var companyLetter = slugOrEmail.charAt(0).toUpperCase();
      image = _react2.default.createElement(
        'div',
        { className: this.state.colorClass, style: this.props.innerStyle },
        companyLetter
      );
    }

    /* jshint ignore:start */
    return this.props.isLoading ? _react2.default.createElement(_materialUi.CircularProgress, { size: 20 }) : _react2.default.createElement(
      'div',
      { className: classes, style: this.props.style, onClick: this.props.onClick },
      image
    );
    /* jshint ignore:end */
  }
});

exports.default = ProfileLink;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * To Title Case 2.1 – http://individed.com/code/to-title-case/
 * Copyright © 2008–2013 David Gouch. Licensed under the MIT License.
 *
 * modifications by @rvagg Apr-2014
 */

//String.prototype.toTitleCase = function(){


var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;


module.exports = function toTitleCase(str){
  return titleCase(str, smallWords)
}


module.exports.toTitleCase = module.exports


var laxWords = __webpack_require__(1463).concat(__webpack_require__(1464)).concat(__webpack_require__(1465))
      .concat(smallWords.source.replace(/(^\^\(|\)\$$)/g, '').split('|'))
      .concat(['is']) // a personal preference
  , laxWordsRe = new RegExp('^(' + laxWords.join('|') + ')$', 'i')


module.exports.toLaxTitleCase = function toLaxTitleCase(str){
  return titleCase(str, laxWordsRe)
}


function titleCase (str, smallWords) {
  if (!str)
    return str
  return str.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title){
    if (index > 0 && index + match.length !== title.length &&
      match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' &&
      (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
      title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1882);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _curry2 = __webpack_require__(3028);

var _curry3 = _interopRequireDefault(_curry2);

var _noop2 = __webpack_require__(1242);

var _noop3 = _interopRequireDefault(_noop2);

var _forEach2 = __webpack_require__(3040);

var _forEach3 = _interopRequireDefault(_forEach2);

var _bind2 = __webpack_require__(3047);

var _bind3 = _interopRequireDefault(_bind2);

var _has2 = __webpack_require__(3048);

var _has3 = _interopRequireDefault(_has2);

var _reduce2 = __webpack_require__(3054);

var _reduce3 = _interopRequireDefault(_reduce2);

var _identity2 = __webpack_require__(1052);

var _identity3 = _interopRequireDefault(_identity2);

var _mapKeys2 = __webpack_require__(3085);

var _mapKeys3 = _interopRequireDefault(_mapKeys2);

exports.addDefaultPrefixToPropTypes = addDefaultPrefixToPropTypes;
exports.collectUncontrolledAndControlledProps = collectUncontrolledAndControlledProps;
exports.default = enhanceElement;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
function addDefaultPrefixToPropTypes(propTypes /*: Object*/) {
  return (0, _mapKeys3.default)(propTypes, function (value, key) {
    return "default" + key.substr(0, 1).toUpperCase() + key.substr(1);
  });
}

function removeDefaultPrefix(defaultKey) {
  // default = 7
  var key = defaultKey.substr(7);
  return "" + key.substr(0, 1).toLowerCase() + key.substr(1);
}

function collectProps(propTypes /*: Object*/, props /*: Object*/) {
  var keyTransform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity3.default;

  return (0, _reduce3.default)(propTypes, function (acc, value, key) {
    if ((0, _has3.default)(props, key)) {
      var nextKey = keyTransform(key);
      // eslint-disable-next-line no-param-reassign
      acc[nextKey] = props[key];
    }
    return acc;
  }, {});
}

function collectUncontrolledAndControlledProps(defaultUncontrolledPropTypes /*: Object*/, controlledPropTypes /*: Object*/, props /*: Object*/) {
  return (0, _extends3.default)({}, collectProps(defaultUncontrolledPropTypes, props, removeDefaultPrefix), collectProps(controlledPropTypes, props));
}

function registerGoogleEventsFromReactProps(instance /*: Object*/, props /*: Object*/, eventMap /*: Object*/) {
  var registered = (0, _reduce3.default)(eventMap, function (acc, googleEventName, onEventName) {
    if ((0, _has3.default)(props, onEventName)) {
      acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
    }
    return acc;
  }, []);

  return (0, _bind3.default)(_forEach3.default, null, registered, function (event) {
    return google.maps.event.removeListener(event);
  });
}

function registerEventsFromComponent(component, getInstanceFromComponent, eventMap) {
  var instance = getInstanceFromComponent(component);
  // eslint-disable-next-line no-param-reassign
  component._unregisterEvents = registerGoogleEventsFromReactProps(instance, component.props, eventMap);
}

function unregisterEventsFromComponent(component, getInstanceFromComponent) {
  // eslint-disable-next-line no-param-reassign
  component._unregisterEvents();
  // eslint-disable-next-line no-param-reassign
  component._unregisterEvents = _noop3.default;
}

var enhanceWithPropTypes = (0, _curry3.default)(function (getInstanceFromComponent, controlledPropUpdaterMap, componentSpec) {
  var _componentSpec$compon = componentSpec.componentDidUpdate,
      _componentDidUpdate = _componentSpec$compon === undefined ? _noop3.default : _componentSpec$compon;

  return (0, _extends3.default)({}, componentSpec, {
    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
      var _this = this;

      (0, _forEach3.default)(controlledPropUpdaterMap, function (fn, key) {
        var nextValue = _this.props[key];
        if (nextValue !== prevProps[key]) {
          fn(getInstanceFromComponent(_this), nextValue, _this);
        }
      });
      _componentDidUpdate.call(this, prevProps, prevState);
    }
  });
});

var enhanceWithEventMap = (0, _curry3.default)(function (getInstanceFromComponent, eventMap, componentSpec) {
  var _componentSpec$compon2 = componentSpec.componentDidMount,
      _componentDidMount = _componentSpec$compon2 === undefined ? _noop3.default : _componentSpec$compon2,
      _componentSpec$compon3 = componentSpec.componentDidUpdate,
      _componentDidUpdate2 = _componentSpec$compon3 === undefined ? _noop3.default : _componentSpec$compon3,
      _componentSpec$compon4 = componentSpec.componentWillUnmount,
      _componentWillUnmount = _componentSpec$compon4 === undefined ? _noop3.default : _componentSpec$compon4;

  return (0, _extends3.default)({}, componentSpec, {

    _unregisterEvents: _noop3.default,

    componentDidMount: function componentDidMount() {
      _componentDidMount.call(this);
      registerEventsFromComponent(this, getInstanceFromComponent, eventMap);
    },
    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
      unregisterEventsFromComponent(this, getInstanceFromComponent);
      _componentDidUpdate2.call(this, prevProps, prevState);
      registerEventsFromComponent(this, getInstanceFromComponent, eventMap);
    },
    componentWillUnmount: function componentWillUnmount() {
      unregisterEventsFromComponent(this, getInstanceFromComponent);
      _componentWillUnmount.call(this);
    }
  });
});

var enhanceWithPublicMethod = (0, _curry3.default)(function (getInstanceFromComponent, publicMethodMap, componentSpec) {
  return (0, _reduce3.default)(publicMethodMap, function (acc, fn, publicMethodName) {
    // eslint-disable-next-line no-param-reassign
    acc[publicMethodName] = function publicMethod() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return fn(getInstanceFromComponent(this), args, /* Use with caution */this);
    };
    return acc;
  }, (0, _extends3.default)({}, componentSpec));
});

function enhanceElement(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap) {
  return (0, _flowRight3.default)(enhanceWithPublicMethod(getInstanceFromComponent, publicMethodMap), enhanceWithEventMap(getInstanceFromComponent, eventMap), enhanceWithPropTypes(getInstanceFromComponent, controlledPropUpdaterMap));
}

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function deepMerge(target) {
	var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var extended = _extends({}, target);

	Object.keys(source).forEach(function (key) {
		if (_typeof(source[key]) !== 'object' || !source[key]) {
			extended[key] = source[key];
		} else {
			if (!target[key]) {
				extended[key] = source[key];
			} else {
				extended[key] = deepMerge(target[key], source[key]);
			}
		}
	});

	return extended;
}

exports.default = deepMerge;

/***/ }),
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOADING_LIST = exports.LOADING_LIST = 'LOADING_CONTRACT_LIST_FROM_BACKEND';
var LOAD_LIST = exports.LOAD_LIST = 'LOAD_CONTRACT_LIST_FROM_BACKEND';
var UPDATE_PROPS = exports.UPDATE_PROPS = 'UPDATE_PROPS_IN_CONTRACT_LISTING';
var UPDATE_FOLDER_NAME = exports.UPDATE_FOLDER_NAME = '[contract-list]UPDATE_FOLDER_NAME';
var UPDATE_PARAMS = exports.UPDATE_PARAMS = '[contract-list]UPDATE_SEARCH_PARAMS';
var RESET_PARAMS = exports.RESET_PARAMS = '[contract-list]RESET_SEARCH_PARAMS';
var SHOW_FREE_CONTRACT_DIALOG = exports.SHOW_FREE_CONTRACT_DIALOG = 'SHOW_FREE_CONTRACT_DIALOG';
var SELECT_ONE_CONTRACT = exports.SELECT_ONE_CONTRACT = 'SELECT_ONE_CONTRACT_CONTRACT_LIST';
var MASS_ASSIGN_FOLDER = exports.MASS_ASSIGN_FOLDER = 'MASS_ASSIGN_FOLDER_CONTRACT_LIST';
var DELETE_FOLDER = exports.DELETE_FOLDER = 'DELETE_FOLDER_CONTRACT_LIST';
var CREATE_FOLDER = exports.CREATE_FOLDER = 'CREATE_FOLDER_CONTRACT_LIST';
var STATE_CHANGE = exports.STATE_CHANGE = 'STATE_CHANGE_CONTRACT_LIST';
var MARK_AS_RECEIVED = exports.MARK_AS_RECEIVED = 'MARK_AS_RECEIVED_CONTRACT_LIST';
var SELECT_CURRENT_ALL = exports.SELECT_CURRENT_ALL = 'SELECT_CURRENT_ALL_CONTRACT_LIST';
var MASS_DELETE_RESTORE = exports.MASS_DELETE_RESTORE = 'MASS_DELETE_RESTORE_CONTRACT_LIST';
var MASS_ARCHIVE_OR_RESTORE = exports.MASS_ARCHIVE_OR_RESTORE = '[contract-list] MASS_ARCHIVE_OR_RESTORE';
var DOWNLOADING_PDF_ZIP = exports.DOWNLOADING_PDF_ZIP = 'DOWNLOADING_PDF_ZIP_CONTRACT_LIST';
var PDF_ZIP_DOWNLOADED = exports.PDF_ZIP_DOWNLOADED = 'PDF_ZIP_DOWNLOADED_CONTRACT_LIST';
var TOGGLE_BULK_RESEND_DIALOG = exports.TOGGLE_BULK_RESEND_DIALOG = 'TOGGLE_BULK_RESEND_DIALOG_CONTRACT_LIST';
var POPULATE_BULK_RESEND = exports.POPULATE_BULK_RESEND = 'POPULATE_BULK_RESEND_DIALOG_CONTRACT_LIST';
var BULK_SENDING = exports.BULK_SENDING = 'BULK_SENDING_CONTRACTS_IN_CONTRACT_LIST';
var BULK_SEND_FINISHED = exports.BULK_SEND_FINISHED = 'BULK_SEND_FINISHED_IN_CONTRACT_LIST';
var UPDATE_BULK_RESEND_PROPS = exports.UPDATE_BULK_RESEND_PROPS = 'UPDATE_BULK_RESEND_PROPS_IN_CONTRACT_LIST';
var GET_CONTRACT_EMAIL = exports.GET_CONTRACT_EMAIL = '[contract-list]GET_CONTRACT_FORWARDING_EMAIL';
var LOAD_CONTRACT_LIST = exports.LOAD_CONTRACT_LIST = '[contract-list]LOAD_CONTRACT_LIST';
var GET_MORE_CONTRACT_INFO = exports.GET_MORE_CONTRACT_INFO = '[contract-list] GET_MORE_CONTRACT_INFO';

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDescription = function ActionDescription(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z' })
  );
};
ActionDescription = (0, _pure2.default)(ActionDescription);
ActionDescription.displayName = 'ActionDescription';
ActionDescription.muiName = 'SvgIcon';

exports.default = ActionDescription;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleConvDone = exports.loadConvList = exports.initialLoadAMsg = exports.searchContractRequest = exports.addFilesToRequestsInDialog = exports.createContractWithFiles = exports.getPartners = exports.downloadFromUrl = exports.updateProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _http = __webpack_require__(118);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _messagingConstants = __webpack_require__(506);

var constants = _interopRequireWildcard(_messagingConstants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateProps = exports.updateProps = function updateProps(type, payload) {
  return {
    type: constants.updateProps(type),
    payload: payload
  };
};
var downloadFromUrl = exports.downloadFromUrl = function downloadFromUrl(path) {
  return function (dispatch, getState) {
    var apiUrl = getState().config.get('apiUrl');
    return window.open(apiUrl + '/s3/file?key=' + encodeURIComponent(path));
  };
};

var getPartners = exports.getPartners = function getPartners(payload) {
  return function (dispatch) {
    dispatch({ type: constants.GET_PARTNERS + '_START' });
    return (0, _http.post)('/proxy/partner-management/partners', payload).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({ type: constants.GET_PARTNERS + '_SUCCESS', payload: res });
    });
  };
};

var createContractWithFiles = exports.createContractWithFiles = function createContractWithFiles(payload) {
  return function (dispatch, getState) {
    dispatch({ type: constants.CREATING_CONTRACT });
    var messageId = getState().messaging.actionDialog.getIn(['msg', 'messageId']);
    return (0, _http.post)('/proxy/contracting/contractWithFiles', _ramda2.default.merge(payload, { messageId: messageId })).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({ type: constants.CONTRACT_CREATED, payload: _ramda2.default.merge({ messageId: messageId }, res) });
      dispatch(initialLoadAMsg(messageId));
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.CREATE_CONTRACT_FAILED });
    });
  };
};

var addFilesToRequestsInDialog = exports.addFilesToRequestsInDialog = function addFilesToRequestsInDialog(request, files) {
  return function (dispatch, getState) {
    var messageId = getState().messaging.actionDialog.toJS().msg.messageId;

    return (0, _http.post)('/proxy/contracting/contract/files', {
      contractId: request._id,
      files: files,
      messageId: messageId
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function () {
      dispatch({
        type: constants.CONTRACT_CREATED,
        payload: _ramda2.default.merge(request, { messageId: messageId, files: files })
      });
      dispatch(initialLoadAMsg(messageId));
    });
  };
};

var searchContractRequest = exports.searchContractRequest = function searchContractRequest(payload) {
  return function (dispatch, getState) {
    dispatch(updateProps('ACTION_DIALOG', { searchingRequests: true }));
    return (0, _http.get)('/proxy/contracting/requests?' + _queryString2.default.stringify(_ramda2.default.merge(payload, {
      emails: JSON.stringify(payload.emails)
    }))).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({
        type: 'GOT_MATCHED_REQUESTS_FOR_ADD_FILE_TO_CONTRACT',
        payload: { requests: res, searchByInput: payload.searchInput }
      });
    }).catch(function (err) {
      console.log(err);
      dispatch(updateProps('ACTION_DIALOG', { searchingRequests: false }));
    });
  };
};

var initialLoadAMsg = exports.initialLoadAMsg = function initialLoadAMsg(messageId) {
  return function (dispatch) {
    dispatch({ type: constants.LOADING_MSGS, payload: true });
    return (0, _http.get)('/proxy/asset-activity/' + messageId).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({
        type: constants.MSGS_LOADED_INITIALLY,
        payload: {
          conv: res,
          messages: [res],
          messagesLoaded: true,
          loadingMessages: false
        }
      });
      // mark read
      dispatch({
        type: '[workspace] CONVERSATIONS_READ_WITH_PARAMS',
        payload: {
          assetId: 'inbox',
          assetType: 'unassigned',
          messageId: res.messageId
        }
      });
    }).catch(function (err) {
      console.log('loadConvList', err);
      dispatch({ type: constants.LOADING_MSGS, payload: false });
    });
  };
};

var loadConvList = exports.loadConvList = function loadConvList(filter, loadFirstConv) {
  return function (dispatch) {
    dispatch({ type: constants.LOADING_LIST });
    dispatch(updateProps('CONVS', { selectedConv: {} }));
    return (0, _http.get)('/proxy/asset-activities/inbox?assetType=unassigned').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({ type: constants.LIST_LOADED, payload: res });
      if (res && res[0] && loadFirstConv) {
        // since now this area is only for self forwarding
        // one conv is one message from workspacemessages
        dispatch({
          type: constants.MSGS_LOADED_INITIALLY,
          payload: {
            conv: res[0],
            messages: [res[0]],
            messagesLoaded: true,
            loadingMessages: false
          }
        });
        dispatch({
          type: '[workspace] CONVERSATIONS_READ_WITH_PARAMS',
          payload: {
            assetId: 'inbox',
            assetType: 'unassigned',
            messageId: res[0].messageId
          }
        });
      }
    }).catch(function (err) {
      console.log('loadConvList', err);
      dispatch({ type: constants.LOADING_LIST });
    });
  };
};

var toggleConvDone = exports.toggleConvDone = function toggleConvDone(messageId, done) {
  return function (dispatch, getState) {
    dispatch({ type: constants.TOGGLE_CONV_DONESS, payload: { messageId: messageId, done: done } });
    return (0, _http.put)('/proxy/asset-activity/' + messageId, { assetId: 'inbox' }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({
        type: constants.TOGGLE_CONV_DONESS_SUCCESS,
        payload: _extends({}, res, { messageId: messageId })
      });
    }).catch(function (err) {
      dispatch({ type: constants.TOGGLE_CONV_DONESS, payload: { messageId: messageId, done: !done } });
    });
  };
};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContractForwardingEmail = exports.openResendContractDialog = exports.selectAContract = exports.resetSearchParams = exports.updateSearchParams = exports.updateProps = exports.updateBulkResendDialogProps = exports.bulkResend = exports.openBulkResendDialog = exports.closeBulkResendDialog = exports.moveToArchiveOrRestore = exports.moveToTrashOrRestore = exports.manageFolders = exports.getContractFolders = exports.stateChange = exports.selectCurrentAll = exports.getContractList = exports.markAsViewed = exports.downloadPdfZip = exports.downloadContractPdf = undefined;
exports.saveNewFolder = saveNewFolder;
exports.changeRoute = changeRoute;
exports.updateFolders = updateFolders;
exports.deleteFolder = deleteFolder;
exports.showFreeContractDialogAction = showFreeContractDialogAction;

var _contractListConstants = __webpack_require__(560);

var constants = _interopRequireWildcard(_contractListConstants);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _actions = __webpack_require__(537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var callApiGet = function callApiGet(url) {
  return fetch(url, {
    method: 'get',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
  }).then(_checkStatus2.default);
};
var callApiPut = function callApiPut(url, body) {
  return fetch(url, {
    method: 'put',
    body: body,
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
  }).then(_checkStatus2.default);
};
var callApiPost = function callApiPost(url, body) {
  return fetch(url, {
    method: 'post',
    body: body,
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
  }).then(_checkStatus2.default);
};
var callApiDelete = function callApiDelete(url, body) {
  return fetch(url, {
    method: 'delete',
    body: body,
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
  }).then(_checkStatus2.default);
};
var downloadContractPdf = exports.downloadContractPdf = function downloadContractPdf(_ref) {
  var docId = _ref.docId,
      contractIds = _ref.contractIds,
      files = _ref.files,
      zipFileName = _ref.zipFileName,
      zipNameWhenFileExists = _ref.zipNameWhenFileExists,
      anchorEl = _ref.anchorEl;
  return function (dispatch, getState) {
    if (files && files.length) {
      (0, _actions.bulkDownloadS3File)(files, zipNameWhenFileExists);
    } else {
      dispatch({
        type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
        payload: {
          docId: docId,
          contractIds: contractIds,
          zipFileName: zipFileName,
          collection: 'contract',
          anchorEl: anchorEl
        }
      });
    }
  };
};

var downloadPdfZip = exports.downloadPdfZip = function downloadPdfZip(event) {
  return function (dispatch, getState) {
    var contractIds = getState().contracting.contractList.get('selectedContracts').toJS();
    dispatch({
      type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
      payload: {
        contractIds: contractIds,
        collection: 'contract',
        anchorEl: event.currentTarget,
        isBulk: true
      }
    });
  };
};
var markAsViewed = exports.markAsViewed = function markAsViewed(contractId) {
  return callApiPut('/proxy/contracting/contractViewed/' + contractId, JSON.stringify({}));
};
var getContractList = exports.getContractList = function getContractList(doNotShowLoadingOverlay) {
  return {
    type: constants.LOAD_LIST,
    payload: !doNotShowLoadingOverlay
  };
};

var selectCurrentAll = exports.selectCurrentAll = function selectCurrentAll(payload) {
  return function (dispatch) {
    dispatch({ type: constants.LOADING_LIST, payload: true });
    return callApiPost('/proxy/contracting/contracts', JSON.stringify(_ramda2.default.merge(payload, { getContractIds: true }))).then(function (res) {
      return res.json();
    }).then(function (contractIds) {
      dispatch({ type: constants.SELECT_CURRENT_ALL, payload: { allContractIds: contractIds } });
      dispatch({ type: constants.LOADING_LIST, payload: false });
    }).catch(function (err) {
      dispatch({ type: constants.LOADING_LIST, payload: false });
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true } : { errorMessage: 'Select all failed' }
      });
    });
  };
};
var stateChange = exports.stateChange = function stateChange(contractIds, newState) {
  return function (dispatch) {
    dispatch({ type: constants.LOADING_LIST, payload: true });
    return callApiPut('/proxy/contracting/updateContractStatus', JSON.stringify({ contractIds: contractIds, state: newState })).then(function () {
      dispatch({ type: constants.STATE_CHANGE, payload: { contractIds: contractIds, newState: newState } });
      dispatch({ type: constants.LOADING_LIST, payload: false });
    }).catch(function (err) {
      dispatch({ type: constants.LOADING_LIST, payload: false });
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to change contract status.' } : { errorMessage: 'Update status failed' }
      });
    });
  };
};

var getContractFolders = exports.getContractFolders = function getContractFolders() {
  return function (dispatch) {
    dispatch({ type: constants.UPDATE_PROPS, payload: { folderLoading: true } });
    return callApiGet('/proxy/contracting/contract-list/folder').then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({
        type: constants.UPDATE_PROPS,
        payload: {
          folders: res.folders,
          hideContractInFolder: res.hideContractInFolder,
          folderLoading: false
        }
      });
    }).catch(function (err) {
      console.log(err.stack);
      dispatch({ type: constants.UPDATE_PROPS, payload: { folderLoading: false } });
    });
  };
};

var manageFolders = exports.manageFolders = function manageFolders(payload) {
  return function (dispatch) {
    return callApiPut('/proxy/contracting/old-assignFolder', JSON.stringify(payload)).then(function () {
      return dispatch({ type: constants.MASS_ASSIGN_FOLDER, payload: payload });
    }).catch(function (err) {
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to move contracts to folders.' } : { errorMessage: 'Move to folder failed.' }
      });
    });
  };
};

/*
 toTrash: Boolean
 */
var moveToTrashOrRestore = exports.moveToTrashOrRestore = function moveToTrashOrRestore(toTrash, contractIds) {
  return function (dispatch) {
    return callApiPut('/proxy/contracting/deleteOrUndelete', JSON.stringify({ contractIds: contractIds, state: toTrash })).then(function () {
      return dispatch({ type: constants.MASS_DELETE_RESTORE, payload: { contractIds: contractIds, state: toTrash } });
    }).catch(function (err) {
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to perform this action.' } : { errorMessage: toTrash ? 'Move to trash failed.' : 'Restore failed' }
      });
    });
  };
};

var moveToArchiveOrRestore = exports.moveToArchiveOrRestore = function moveToArchiveOrRestore(toArchived, contractIds) {
  return function (dispatch) {
    return callApiPut('/proxy/contracting/archiveOrUnarchive', JSON.stringify({ contractIds: contractIds, state: toArchived })).then(function () {
      return dispatch({ type: constants.MASS_ARCHIVE_OR_RESTORE, payload: { contractIds: contractIds, state: toArchived } });
    }).catch(function (err) {
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to perform this action.' } : { errorMessage: toArchived ? 'Move to archived failed.' : 'Restore failed' }
      });
    });
  };
};

function saveNewFolder(folderName) {
  return function (dispatch) {
    return callApiPost('/proxy/contracting/contract-list/folder', JSON.stringify({ folderName: folderName })).then(function () {
      return dispatch({ type: constants.CREATE_FOLDER, payload: folderName });
    }).catch(function (err) {
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true } : { errorMessage: 'Create folder failed.' }
      });
    });
  };
}
function changeRoute(routeName, isFolder) {
  return { type: '[contract-list]CHANGE_ROUTE', payload: { routeName: routeName, isFolder: isFolder } };
}
function updateFolders(_ref2) {
  var folders = _ref2.folders,
      originalFolder = _ref2.originalFolder,
      newFolderName = _ref2.newFolderName;

  return { type: constants.UPDATE_FOLDER_NAME, payload: { folders: folders, originalFolder: originalFolder, newFolderName: newFolderName } };
}

function deleteFolder(folderName) {
  return function (dispatch) {
    return callApiDelete('/proxy/contracting/contract-list/folder', JSON.stringify({ folderName: folderName })).then(function () {
      return dispatch({ type: constants.DELETE_FOLDER, payload: folderName });
    }).catch(function (err) {
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true } : { errorMessage: 'Delete folder failed.' }
      });
    });
  };
};

function showFreeContractDialogAction(activiesOrDetails, contractId) {
  var url = '/contracting/contract/' + contractId + '/' + activiesOrDetails;
  return {
    type: constants.SHOW_FREE_CONTRACT_DIALOG,
    payload: {
      url: url,
      contractId: contractId
    }
  };
}
var toggleBulkResendDialog = function toggleBulkResendDialog(open) {
  return { type: constants.TOGGLE_BULK_RESEND_DIALOG, payload: open };
};
var closeBulkResendDialog = exports.closeBulkResendDialog = function closeBulkResendDialog() {
  return toggleBulkResendDialog(false);
};
var openBulkResendDialog = exports.openBulkResendDialog = function openBulkResendDialog() {
  return function (dispatch, getState) {
    var contractIds = getState().contracting.contractList.get('selectedContracts').toJS();
    var companyType = getState().user.getIn(['user', 'type']);
    var companyName = getState().user.getIn(['company', 'companyName']);
    dispatch(toggleBulkResendDialog(true));
    return callApiPost('/proxy/contracting/groupContractsForBulkResend', JSON.stringify({ contractIds: contractIds })).then(function (res) {
      return res.json();
    }).then(function (result) {
      dispatch({ type: constants.POPULATE_BULK_RESEND, payload: {
          partners: result,
          subject: 'Rates Reminder: ' + companyName,
          customizedMessage: companyType === 'Supplier' ? 'For your convenience, I\'m resending rates for ' + companyName + ' via TourConnect.' : 'If you have not done so already, this is a friendly reminder that we need your rates.  Using TourConnect will make it easier for us to load your rates. More importantly, it will help us sell more of your products.'
        } });
    }).catch(function (err) {
      var permissionDenied = _ramda2.default.pathOr(0, ['response', 'status'], err) === 403;
      dispatch({
        type: 'GLOBAL_ERROR_TRIGGERED',
        payload: permissionDenied ? { noAccessDialog: true, message: 'You will need write access in order to resend contracts.' } : { errorMessage: 'Failed to get data for bulk resending.' }
      });
    });
  };
};
var bulkResend = exports.bulkResend = function bulkResend() {
  return function (dispatch, getState) {
    var _getState$contracting = getState().contracting.contractList.get('bulkResendDialog').toJS(),
        partners = _getState$contracting.partners,
        customizedMessage = _getState$contracting.customizedMessage,
        BCCToSelf = _getState$contracting.BCCToSelf;

    dispatch({ type: constants.BULK_SENDING });
    return callApiPut('/proxy/contracting/bulkResendContracts', JSON.stringify({ partners: partners, customizedMessage: customizedMessage, BCCToSelf: BCCToSelf })).then(function () {
      return dispatch({ type: constants.BULK_SEND_FINISHED });
    }).catch(function (err) {
      console.log(err.stack);
      dispatch({ type: constants.BULK_SEND_FINISHED });
      dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload: { errorMessage: 'Failed to resend contracts in bulk.' } });
    });
  };
};
var updateBulkResendDialogProps = exports.updateBulkResendDialogProps = function updateBulkResendDialogProps(payload) {
  return { type: constants.UPDATE_BULK_RESEND_PROPS, payload: payload };
};
var updateProps = exports.updateProps = function updateProps(payload) {
  return { type: constants.UPDATE_PROPS, payload: payload };
};
var updateSearchParams = exports.updateSearchParams = function updateSearchParams(payload) {
  return { type: constants.UPDATE_PARAMS, payload: payload };
};
var resetSearchParams = exports.resetSearchParams = function resetSearchParams() {
  return { type: constants.RESET_PARAMS };
};

var selectAContract = exports.selectAContract = function selectAContract(id) {
  return { type: constants.SELECT_ONE_CONTRACT, payload: id };
};
var openResendContractDialog = exports.openResendContractDialog = function openResendContractDialog(payload) {
  return { type: 'CHANGE_RESEND_CONTRACT_DIALOG_STATE', payload: payload };
};
var getContractForwardingEmail = exports.getContractForwardingEmail = function getContractForwardingEmail(payload) {
  return { type: constants.GET_CONTRACT_EMAIL, payload: payload };
};

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentFromFile = undefined;

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contentFromFile = exports.contentFromFile = function contentFromFile(file) {
  if (file.type) return file.type;
  var extension = ((file.name || '').split('.').pop() || '').toLowerCase();
  if (extension === 'xlsx') return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  if (extension === 'xls') return 'application/vnd.ms-excel';
  if (extension === 'pdf') return 'application/pdf';
  if (extension === 'txt') return 'text/plain';
  if (extension === 'csv') return 'text/csv';
  if (extension === 'doc') return 'application/msword';
  if (extension === 'docx') return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  return undefined;
}; // Original source: https://github.com/flyingsparx/s3upload-coffee-javascript/blob/master/s3upload.js
// Modified to match our needs
exports.default = {

  s3_sign_put_url: '/proxy/s3/sign',

  s3uploadPromise: function s3uploadPromise(file) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      _this.s3upload({
        file_to_upload: file,
        file_name: file.name,
        ACL: 'private',
        onFinishS3Put: function onFinishS3Put(path) {
          resolve({
            path: path,
            downloadUrl: path, // for insurance file
            name: file.name,
            fileName: file.name, // for insurance file
            type: file.type,
            size: file.size
          });
        },
        onProgress: function onProgress() {},
        onError: function onError(status) {
          reject(status);
        }
      });
    });
  },
  s3upload: function s3upload(options) {
    var _this2 = this;

    var file = options.file_to_upload;
    var fileName = options.file_name;
    return this.executeOnSignedUrl(file, fileName, options, function (signedURL, publicURL) {
      return _this2.uploadToS3(file, signedURL, publicURL, fileName, options);
    });
  },
  executeOnSignedUrl: function executeOnSignedUrl(file, fileName, options, callback) {
    var onError = options.onError;
    var xhr = new XMLHttpRequest();
    var contentType = contentFromFile(file);
    xhr.open('GET', this.s3_sign_put_url + '?s3_object_type=' + contentType + '&s3_file_name=' + _nodeUuid2.default.v1() + (options.ACL ? '&ACL=' + options.ACL : ''), true);
    xhr.overrideMimeType('text/plain; charset=x-user-defined');
    xhr.onreadystatechange = function () {
      var result = void 0;
      if (this.readyState === 4 && this.status === 200) {
        try {
          result = JSON.parse(this.responseText);
        } catch (error) {
          console.log(error);
          return false;
        }
        return callback(result.signedUrl, result.url);
      } else if (this.readyState === 4 && this.status !== 200) {
        return onError('Could not contact request signing server. Status = ' + this.status);
      }
    };
    return xhr.send();
  },
  uploadToS3: function uploadToS3(file, url, publicUrl, fileName, options) {
    var onFinishS3Put = options.onFinishS3Put;
    var onProgress = options.onProgress;
    var onError = options.onError;

    var xhr = this.createCORSRequest('PUT', url);
    if (!xhr) {
      onError('CORS not supported');
    } else {
      xhr.onload = function () {
        if (xhr.status === 200) return onFinishS3Put(publicUrl, fileName);
        return onError('Upload error: ' + xhr.status);
      };
      xhr.onerror = function () {
        return onError('XHR error.');
      };
      xhr.upload.onprogress = function (e) {
        var percentLoaded = void 0;
        if (e.lengthComputable) {
          percentLoaded = Math.round(e.loaded / e.total * 100);
          return onProgress(percentLoaded);
        }
      };
    }
    var contentType = contentFromFile(file);
    xhr.setRequestHeader('Content-Type', contentType);
    // xhr.setRequestHeader('x-amz-acl', 'public-read');
    return xhr.send(file);
  },
  createCORSRequest: function createCORSRequest(method, url) {
    var xhr = new XMLHttpRequest();
    if (xhr.withCredentials !== null) {
      xhr.open(method, url, true);
    } else if (typeof XDomainRequest !== 'undefined') {
      xhr = new XDomainRequest();
      xhr.open(method, url);
    } else {
      xhr = null;
    }
    return xhr;
  },
  resizeCoverImage: function resizeCoverImage(image, dimensions, context, type) {
    var maxWidth = 1440;
    var maxHeight = 350;
    var imageWidth = image.width;
    var imageHeight = image.height;
    if (imageWidth > imageHeight) {
      if (imageWidth > maxWidth) {
        imageHeight *= maxWidth / imageWidth;
        imageWidth = maxWidth;
      }
    } else {
      if (imageHeight > maxHeight) {
        imageWidth *= maxHeight / imageHeight;
        imageHeight = maxHeight;
      }
    }

    var canvasWidth = imageWidth;
    var canvasHeight = maxHeight;
    if (imageHeight < maxHeight) canvasHeight = imageHeight;

    var canvas = document.createElement('canvas');
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    var ctx = canvas.getContext('2d');
    ctx.drawImage(context, 0, 0, imageWidth, imageHeight);
    return canvas.toDataURL(type);
  },
  resizeImage: function resizeImage(image, dimensions, context, type) {
    var maxWidth = dimensions;
    var maxHeight = dimensions;
    var imageWidth = image.width;
    var imageHeight = image.height;

    if (imageWidth > imageHeight) {
      if (imageWidth > maxWidth) {
        imageHeight *= maxWidth / imageWidth;
        imageWidth = maxWidth;
      }
    } else {
      if (imageHeight > maxHeight) {
        imageWidth *= maxHeight / imageHeight;
        imageHeight = maxHeight;
      }
    }

    var canvas = document.createElement('canvas');
    canvas.width = imageWidth;
    canvas.height = imageHeight;

    var ctx = canvas.getContext('2d');
    ctx.drawImage(context, 0, 0, imageWidth, imageHeight);
    return canvas.toDataURL(type);
  },
  dataURItoBlob: function dataURItoBlob(dataURI, imageType) {
    var binary = atob(dataURI.split(',')[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: imageType
    });
  }
};

/***/ }),
/* 565 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(644);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(1095);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(545);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(1381);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    var _this = this;

    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.update = function (name, data) {
      var _options = _this.options,
          plugins = _options.jss.plugins,
          sheet = _options.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, _this.get(name), sheet);
      } else {
        for (var index = 0; index < _this.index.length; index++) {
          plugins.onUpdate(name, _this.index[index], sheet);
        }
      }
    };

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options2 = this.options,
          parent = _options2.parent,
          sheet = _options2.sheet,
          jss = _options2.jss,
          Renderer = _options2.Renderer,
          generateClassName = _options2.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'link',


    /**
     * Link renderable rules with CSSRuleList.
     */
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentSend = function ContentSend(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2.01 21L23 12 2.01 3 2 10l15 2-15 2z' })
  );
};
ContentSend = (0, _pure2.default)(ContentSend);
ContentSend.displayName = 'ContentSend';
ContentSend.muiName = 'SvgIcon';

exports.default = ContentSend;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLock = function ActionLock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' })
  );
};
ActionLock = (0, _pure2.default)(ActionLock);
ActionLock.displayName = 'ActionLock';
ActionLock.muiName = 'SvgIcon';

exports.default = ActionLock;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_DOC = exports.GET_DOC = '{master-template} GET_DOC';
var CREATE_EDITED_DRAFT = exports.CREATE_EDITED_DRAFT = '{master-template} CREATE_EDITED_DRAFT';
var GET_DIFF_SUMMARY = exports.GET_DIFF_SUMMARY = '{master-template} GET_DIFF_SUMMARY';
var INITIATE_EDIT_WITH_TYPE = exports.INITIATE_EDIT_WITH_TYPE = '{master-template} INITIATE_EDIT_WITH_TYPE';
var POPULATE_EDIT_DIALOG_DATA = exports.POPULATE_EDIT_DIALOG_DATA = '{master-template} POPULATE_EDIT_DIALOG_DATA';
var CANCEL_EDIT = exports.CANCEL_EDIT = '{master-template} CANCEL_EDIT';
var CLICK_FINALISE = exports.CLICK_FINALISE = '{master-template} CLICK_FINALISE_BUTTON';
var FINALISE = exports.FINALISE = '{master-template} FINALISE_BUTTON';
var OPEN_FINALISE_DIALOG = exports.OPEN_FINALISE_DIALOG = '{master-template} OPEN_FINALISE_DIALOG';
var CLOSE_FINALISE_DIALOG = exports.CLOSE_FINALISE_DIALOG = '{master-template} CLOSE_FINALISE_DIALOG';
var SEND_UPDATES = exports.SEND_UPDATES = '{master-template} SEND_UPDATES';
var DISCARD_DRAFT = exports.DISCARD_DRAFT = '{master-template} DISCARD_DRAFT';
var GET_ASSOCIATED_TEMPLATES = exports.GET_ASSOCIATED_TEMPLATES = '{master-template} GET_ASSOCIATED_TEMPLATES';
var TOGGLE_ASSOCIATED_TEMPLATES = exports.TOGGLE_ASSOCIATED_TEMPLATES = '{master-template} TOGGLE_ASSOCIATED_TEMPLATES';
var GET_AFFECTED_BUYERS = exports.GET_AFFECTED_BUYERS = '{master-template} GET_AFFECTED_BUYERS';

var SAVE_EDITS = exports.SAVE_EDITS = '{edit-dialog} SAVE_EDITS';
var TEXT_FIELD_CHANGE = exports.TEXT_FIELD_CHANGE = '{edit-dialog} TEXT_FIELD_CHANGE';
var ATTACH_INS_FILE = exports.ATTACH_INS_FILE = '{edit-dialog} ATTACH_INS_FILE';
var REMOVE_INSURANCE_FILE = exports.REMOVE_INSURANCE_FILE = '{edit-dialog} REMOVE_INSURANCE_FILE';

var apply = exports.apply = {
  INIT: '{apply-master-to-template} INIT',
  GET_TEMPLATES: '{apply-master-to-template} GET_TEMPLATES',
  SELECT_UNSELECT_TEMPLATE: '{apply-master-to-template} SELECT_UNSELECT_TEMPLATE',
  APPLY_TO_TEMPLATES: '{apply-master-to-template} APPLY_TO_TEMPLATES_TO_TEMPLATE_DRAFTS',
  CLICK_OK_SUCCESS: '{apply-master-to-template} CLICK_OK_SUCCESS',
  CHECK_SAME_AS: '{apply-master-to-template} CHECK_SAME_AS',
  SELECT_MASTER: '{apply-master-to-template} SELECT_MASTER',
  GET_MASTERS: '{apply-master-to-template} GET_MASTERS',
  CLEAR_STORE: '{apply-master-to-template} CLEAR_STORE',
  CHECK_HONOR_PRELOAD: '{apply-master-to-template} CHECK_HONOR_PRELOAD'
};

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = '[sidebarHelp] ';

var SIDEBARHELP_INIT = exports.SIDEBARHELP_INIT = prefix + 'INIT';
var LOAD_HELPFILES = exports.LOAD_HELPFILES = prefix + 'LOAD_INDEX';
var LOAD_HELP_ARTICLE = exports.LOAD_HELP_ARTICLE = prefix + 'LOAD_HELP';
var OPEN_WIDGET = exports.OPEN_WIDGET = 'HELPWIDGET_OPEN';

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(585);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["y" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["b" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["A" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL_END; });
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["b"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(237);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["z" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["f" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["y" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["d" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["v" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["l" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["v" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return takeEvery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return takeLatest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return throttle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Representation a of zip file in js
 * @constructor
 */
function JSZip() {
    // if this constructor is used without `new`, it adds `new` before itself:
    if(!(this instanceof JSZip)) {
        return new JSZip();
    }

    if(arguments.length) {
        throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
    }

    // object containing the files :
    // {
    //   "folder/" : {...},
    //   "folder/data.txt" : {...}
    // }
    this.files = {};

    this.comment = null;

    // Where we are in the hierarchy
    this.root = "";
    this.clone = function() {
        var newObj = new JSZip();
        for (var i in this) {
            if (typeof this[i] !== "function") {
                newObj[i] = this[i];
            }
        }
        return newObj;
    };
}
JSZip.prototype = __webpack_require__(920);
JSZip.prototype.loadAsync = __webpack_require__(948);
JSZip.support = __webpack_require__(117);
JSZip.defaults = __webpack_require__(595);

// TODO find a better way to handle this version,
// a require('package.json').version doesn't work with webpack, see #327
JSZip.version = "3.1.3";

JSZip.loadAsync = function (content, options) {
    return new JSZip().loadAsync(content, options);
};

JSZip.external = __webpack_require__(218);
module.exports = JSZip;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * This file is used by module bundlers (browserify/webpack/etc) when
 * including a stream implementation. We use "readable-stream" to get a
 * consistent behavior between nodejs versions but bundlers often have a shim
 * for "stream". Using this shim greatly improve the compatibility and greatly
 * reduce the final size of the bundle (only one stream implementation, not
 * two).
 */
module.exports = __webpack_require__(229);


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utils = __webpack_require__(35);
var support = __webpack_require__(117);
// private property
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";


// public method for encoding
exports.encode = function(input) {
    var output = [];
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0, len = input.length, remainingBytes = len;

    var isArray = utils.getTypeOf(input) !== "string";
    while (i < input.length) {
        remainingBytes = len - i;

        if (!isArray) {
            chr1 = input.charCodeAt(i++);
            chr2 = i < len ? input.charCodeAt(i++) : 0;
            chr3 = i < len ? input.charCodeAt(i++) : 0;
        } else {
            chr1 = input[i++];
            chr2 = i < len ? input[i++] : 0;
            chr3 = i < len ? input[i++] : 0;
        }

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = remainingBytes > 1 ? (((chr2 & 15) << 2) | (chr3 >> 6)) : 64;
        enc4 = remainingBytes > 2 ? (chr3 & 63) : 64;

        output.push(_keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4));

    }

    return output.join("");
};

// public method for decoding
exports.decode = function(input) {
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0, resultIndex = 0;

    var dataUrlPrefix = "data:";

    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) {
        // This is a common error: people give a data url
        // (data:image/png;base64,iVBOR...) with a {base64: true} and
        // wonders why things don't work.
        // We can detect that the string input looks like a data url but we
        // *can't* be sure it is one: removing everything up to the comma would
        // be too dangerous.
        throw new Error("Invalid base64 input, it looks like a data url.");
    }

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    var totalLength = input.length * 3 / 4;
    if(input.charAt(input.length - 1) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if(input.charAt(input.length - 2) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if (totalLength % 1 !== 0) {
        // totalLength is not an integer, the length does not match a valid
        // base64 content. That can happen if:
        // - the input is not a base64 content
        // - the input is *almost* a base64 content, with a extra chars at the
        //   beginning or at the end
        // - the input uses a base64 variant (base64url for example)
        throw new Error("Invalid base64 input, bad content length.");
    }
    var output;
    if (support.uint8array) {
        output = new Uint8Array(totalLength|0);
    } else {
        output = new Array(totalLength|0);
    }

    while (i < input.length) {

        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output[resultIndex++] = chr1;

        if (enc3 !== 64) {
            output[resultIndex++] = chr2;
        }
        if (enc4 !== 64) {
            output[resultIndex++] = chr3;
        }

    }

    return output;
};


/***/ }),
/* 590 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.3.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(924);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(487)
  , document = __webpack_require__(239).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var utils = __webpack_require__(35);
var ConvertWorker = __webpack_require__(937);
var GenericWorker = __webpack_require__(65);
var base64 = __webpack_require__(589);
var support = __webpack_require__(117);
var external = __webpack_require__(218);

var NodejsStreamOutputAdapter = null;
if (support.nodestream) {
    try {
        NodejsStreamOutputAdapter = __webpack_require__(938);
    } catch(e) {}
}

/**
 * Apply the final transformation of the data. If the user wants a Blob for
 * example, it's easier to work with an U8intArray and finally do the
 * ArrayBuffer/Blob conversion.
 * @param {String} resultType the name of the final type
 * @param {String} chunkType the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @param {String|Uint8Array|Buffer} content the content to transform
 * @param {String} mimeType the mime type of the content, if applicable.
 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
 */
function transformZipOutput(resultType, chunkType, dataArray, mimeType) {
    var content = null;
    switch(resultType) {
        case "blob" :
            return utils.newBlob(dataArray, mimeType);
        case "base64" :
            content = concat(chunkType, dataArray);
            return base64.encode(content);
        default :
            content = concat(chunkType, dataArray);
            return utils.transformTo(resultType, content);
    }
}

/**
 * Concatenate an array of data of the given type.
 * @param {String} type the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @return {String|Uint8Array|Buffer} the concatenated data
 * @throws Error if the asked type is unsupported
 */
function concat (type, dataArray) {
    var i, index = 0, res = null, totalLength = 0;
    for(i = 0; i < dataArray.length; i++) {
        totalLength += dataArray[i].length;
    }
    switch(type) {
        case "string":
            return dataArray.join("");
          case "array":
            return Array.prototype.concat.apply([], dataArray);
        case "uint8array":
            res = new Uint8Array(totalLength);
            for(i = 0; i < dataArray.length; i++) {
                res.set(dataArray[i], index);
                index += dataArray[i].length;
            }
            return res;
        case "nodebuffer":
            return Buffer.concat(dataArray);
        default:
            throw new Error("concat : unsupported type '"  + type + "'");
    }
}

/**
 * Listen a StreamHelper, accumulate its content and concatenate it into a
 * complete block.
 * @param {StreamHelper} helper the helper to use.
 * @param {Function} updateCallback a callback called on each update. Called
 * with one arg :
 * - the metadata linked to the update received.
 * @return Promise the promise for the accumulation.
 */
function accumulate(helper, updateCallback) {
    return new external.Promise(function (resolve, reject){
        var dataArray = [];
        var chunkType = helper._internalType,
            resultType = helper._outputType,
            mimeType = helper._mimeType;
        helper
        .on('data', function (data, meta) {
            dataArray.push(data);
            if(updateCallback) {
                updateCallback(meta);
            }
        })
        .on('error', function(err) {
            dataArray = [];
            reject(err);
        })
        .on('end', function (){
            try {
                var result = transformZipOutput(resultType, chunkType, dataArray, mimeType);
                resolve(result);
            } catch (e) {
                reject(e);
            }
            dataArray = [];
        })
        .resume();
    });
}

/**
 * An helper to easily use workers outside of JSZip.
 * @constructor
 * @param {Worker} worker the worker to wrap
 * @param {String} outputType the type of data expected by the use
 * @param {String} mimeType the mime type of the content, if applicable.
 */
function StreamHelper(worker, outputType, mimeType) {
    var internalType = outputType;
    switch(outputType) {
        case "blob":
            internalType = "arraybuffer";
        break;
        case "arraybuffer":
            internalType = "uint8array";
        break;
        case "base64":
            internalType = "string";
        break;
    }

    try {
        // the type used internally
        this._internalType = internalType;
        // the type used to output results
        this._outputType = outputType;
        // the mime type
        this._mimeType = mimeType;
        utils.checkSupport(internalType);
        this._worker = worker.pipe(new ConvertWorker(internalType));
        // the last workers can be rewired without issues but we need to
        // prevent any updates on previous workers.
        worker.lock();
    } catch(e) {
        this._worker = new GenericWorker("error");
        this._worker.error(e);
    }
}

StreamHelper.prototype = {
    /**
     * Listen a StreamHelper, accumulate its content and concatenate it into a
     * complete block.
     * @param {Function} updateCb the update callback.
     * @return Promise the promise for the accumulation.
     */
    accumulate : function (updateCb) {
        return accumulate(this, updateCb);
    },
    /**
     * Add a listener on an event triggered on a stream.
     * @param {String} evt the name of the event
     * @param {Function} fn the listener
     * @return {StreamHelper} the current helper.
     */
    on : function (evt, fn) {
        var self = this;

        if(evt === "data") {
            this._worker.on(evt, function (chunk) {
                fn.call(self, chunk.data, chunk.meta);
            });
        } else {
            this._worker.on(evt, function () {
                utils.delay(fn, arguments, self);
            });
        }
        return this;
    },
    /**
     * Resume the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    resume : function () {
        utils.delay(this._worker.resume, [], this._worker);
        return this;
    },
    /**
     * Pause the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    pause : function () {
        this._worker.pause();
        return this;
    },
    /**
     * Return a nodejs stream for this helper.
     * @param {Function} updateCb the update callback.
     * @return {NodejsStreamOutputAdapter} the nodejs stream.
     */
    toNodejsStream : function (updateCb) {
        utils.checkSupport("nodestream");
        if (this._outputType !== "nodebuffer") {
            // an object stream containing blob/arraybuffer/uint8array/string
            // is strange and I don't know if it would be useful.
            // I you find this comment and have a good usecase, please open a
            // bug report !
            throw new Error(this._outputType + " is not supported by this method");
        }

        return new NodejsStreamOutputAdapter(this, {
            objectMode : this._outputType !== "nodebuffer"
        }, updateCb);
    }
};


module.exports = StreamHelper;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = true;
exports.date = null;
exports.compression = null;
exports.compressionOptions = null;
exports.comment = null;
exports.unixPermissions = null;
exports.dosPermissions = null;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var GenericWorker = __webpack_require__(65);

// the size of the generated chunks
// TODO expose this as a public variable
var DEFAULT_BLOCK_SIZE = 16 * 1024;

/**
 * A worker that reads a content and emits chunks.
 * @constructor
 * @param {Promise} dataP the promise of the data to split
 */
function DataWorker(dataP) {
    GenericWorker.call(this, "DataWorker");
    var self = this;
    this.dataIsReady = false;
    this.index = 0;
    this.max = 0;
    this.data = null;
    this.type = "";

    this._tickScheduled = false;

    dataP.then(function (data) {
        self.dataIsReady = true;
        self.data = data;
        self.max = data && data.length || 0;
        self.type = utils.getTypeOf(data);
        if(!self.isPaused) {
            self._tickAndRepeat();
        }
    }, function (e) {
        self.error(e);
    });
}

utils.inherits(DataWorker, GenericWorker);

/**
 * @see GenericWorker.cleanUp
 */
DataWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this.data = null;
};

/**
 * @see GenericWorker.resume
 */
DataWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this._tickScheduled && this.dataIsReady) {
        this._tickScheduled = true;
        utils.delay(this._tickAndRepeat, [], this);
    }
    return true;
};

/**
 * Trigger a tick a schedule an other call to this function.
 */
DataWorker.prototype._tickAndRepeat = function() {
    this._tickScheduled = false;
    if(this.isPaused || this.isFinished) {
        return;
    }
    this._tick();
    if(!this.isFinished) {
        utils.delay(this._tickAndRepeat, [], this);
        this._tickScheduled = true;
    }
};

/**
 * Read and push a chunk.
 */
DataWorker.prototype._tick = function() {

    if(this.isPaused || this.isFinished) {
        return false;
    }

    var size = DEFAULT_BLOCK_SIZE;
    var data = null, nextIndex = Math.min(this.max, this.index + size);
    if (this.index >= this.max) {
        // EOF
        return this.end();
    } else {
        switch(this.type) {
            case "string":
                data = this.data.substring(this.index, nextIndex);
            break;
            case "uint8array":
                data = this.data.subarray(this.index, nextIndex);
            break;
            case "array":
            case "nodebuffer":
                data = this.data.slice(this.index, nextIndex);
            break;
        }
        this.index = nextIndex;
        return this.push({
            data : data,
            meta : {
                percent : this.max ? this.index / this.max * 100 : 0
            }
        });
    }
};

module.exports = DataWorker;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var GenericWorker = __webpack_require__(65);

/**
 * A worker which calculate the total length of the data flowing through.
 * @constructor
 * @param {String} propName the name used to expose the length
 */
function DataLengthProbe(propName) {
    GenericWorker.call(this, "DataLengthProbe for " + propName);
    this.propName = propName;
    this.withStreamInfo(propName, 0);
}
utils.inherits(DataLengthProbe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
DataLengthProbe.prototype.processChunk = function (chunk) {
    if(chunk) {
        var length = this.streamInfo[this.propName] || 0;
        this.streamInfo[this.propName] = length + chunk.data.length;
    }
    GenericWorker.prototype.processChunk.call(this, chunk);
};
module.exports = DataLengthProbe;



/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GenericWorker = __webpack_require__(65);
var crc32 = __webpack_require__(490);
var utils = __webpack_require__(35);

/**
 * A worker which calculate the crc32 of the data flowing through.
 * @constructor
 */
function Crc32Probe() {
    GenericWorker.call(this, "Crc32Probe");
    this.withStreamInfo("crc32", 0);
}
utils.inherits(Crc32Probe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Crc32Probe.prototype.processChunk = function (chunk) {
    this.streamInfo.crc32 = crc32(chunk.data, this.streamInfo.crc32 || 0);
    this.push(chunk);
};
module.exports = Crc32Probe;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GenericWorker = __webpack_require__(65);

exports.STORE = {
    magic: "\x00\x00",
    compressWorker : function (compressionOptions) {
        return new GenericWorker("STORE compression");
    },
    uncompressWorker : function () {
        return new GenericWorker("STORE decompression");
    }
};
exports.DEFLATE = __webpack_require__(941);


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// String encode/decode helpers



var utils = __webpack_require__(230);


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function (buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function (str) {
  var buf = new utils.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function (buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.LOCAL_FILE_HEADER = "PK\x03\x04";
exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
exports.DATA_DESCRIPTOR = "PK\x07\x08";


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var support = __webpack_require__(117);
var ArrayReader = __webpack_require__(603);
var StringReader = __webpack_require__(950);
var NodeBufferReader = __webpack_require__(951);
var Uint8ArrayReader = __webpack_require__(605);

/**
 * Create a reader adapted to the data.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
 * @return {DataReader} the data reader.
 */
module.exports = function (data) {
    var type = utils.getTypeOf(data);
    utils.checkSupport(type);
    if (type === "string" && !support.uint8array) {
        return new StringReader(data);
    }
    if (type === "nodebuffer") {
        return new NodeBufferReader(data);
    }
    if (support.uint8array) {
        return new Uint8ArrayReader(utils.transformTo("uint8array", data));
    }
    return new ArrayReader(utils.transformTo("array", data));
};

// vim: set shiftwidth=4 softtabstop=4:


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DataReader = __webpack_require__(604);
var utils = __webpack_require__(35);

function ArrayReader(data) {
    DataReader.call(this, data);
	for(var i = 0; i < this.data.length; i++) {
		data[i] = data[i] & 0xFF;
	}
}
utils.inherits(ArrayReader, DataReader);
/**
 * @see DataReader.byteAt
 */
ArrayReader.prototype.byteAt = function(i) {
    return this.data[this.zero + i];
};
/**
 * @see DataReader.lastIndexOfSignature
 */
ArrayReader.prototype.lastIndexOfSignature = function(sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3);
    for (var i = this.length - 4; i >= 0; --i) {
        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i - this.zero;
        }
    }

    return -1;
};
/**
 * @see DataReader.readAndCheckSignature
 */
ArrayReader.prototype.readAndCheckSignature = function (sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3),
        data = this.readData(4);
    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
};
/**
 * @see DataReader.readData
 */
ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        return [];
    }
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = ArrayReader;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utils = __webpack_require__(35);

function DataReader(data) {
    this.data = data; // type : see implementation
    this.length = data.length;
    this.index = 0;
    this.zero = 0;
}
DataReader.prototype = {
    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */
    checkOffset: function(offset) {
        this.checkIndex(this.index + offset);
    },
    /**
     * Check that the specifed index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */
    checkIndex: function(newIndex) {
        if (this.length < this.zero + newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
        }
    },
    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */
    setIndex: function(newIndex) {
        this.checkIndex(newIndex);
        this.index = newIndex;
    },
    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */
    skip: function(n) {
        this.setIndex(this.index + n);
    },
    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */
    byteAt: function(i) {
        // see implementations
    },
    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */
    readInt: function(size) {
        var result = 0,
            i;
        this.checkOffset(size);
        for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
        }
        this.index += size;
        return result;
    },
    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */
    readString: function(size) {
        return utils.transformTo("string", this.readData(size));
    },
    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */
    readData: function(size) {
        // see implementations
    },
    /**
     * Find the last occurence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurence, -1 if not found.
     */
    lastIndexOfSignature: function(sig) {
        // see implementations
    },
    /**
     * Read the signature (4 bytes) at the current position and compare it with sig.
     * @param {string} sig the expected signature
     * @return {boolean} true if the signature matches, false otherwise.
     */
    readAndCheckSignature: function(sig) {
        // see implementations
    },
    /**
     * Get the next date.
     * @return {Date} the date.
     */
    readDate: function() {
        var dostime = this.readInt(4);
        return new Date(Date.UTC(
        ((dostime >> 25) & 0x7f) + 1980, // year
        ((dostime >> 21) & 0x0f) - 1, // month
        (dostime >> 16) & 0x1f, // day
        (dostime >> 11) & 0x1f, // hour
        (dostime >> 5) & 0x3f, // minute
        (dostime & 0x1f) << 1)); // second
    }
};
module.exports = DataReader;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayReader = __webpack_require__(603);
var utils = __webpack_require__(35);

function Uint8ArrayReader(data) {
    ArrayReader.call(this, data);
}
utils.inherits(Uint8ArrayReader, ArrayReader);
/**
 * @see DataReader.readData
 */
Uint8ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
        return new Uint8Array(0);
    }
    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = Uint8ArrayReader;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var JSZipUtils = {};
// just use the responseText with xhr1, response with xhr2.
// The transformation doesn't throw away high-order byte (with responseText)
// because JSZip handles that case. If not used with JSZip, you may need to
// do it, see https://developer.mozilla.org/En/Using_XMLHttpRequest#Handling_binary_data
JSZipUtils._getBinaryFromXHR = function (xhr) {
    // for xhr.responseText, the 0xFF mask is applied by JSZip
    return xhr.response || xhr.responseText;
};

// taken from jQuery
function createStandardXHR() {
    try {
        return new window.XMLHttpRequest();
    } catch( e ) {}
}

function createActiveXHR() {
    try {
        return new window.ActiveXObject("Microsoft.XMLHTTP");
    } catch( e ) {}
}

// Create the request object
var createXHR = window.ActiveXObject ?
    /* Microsoft failed to properly
     * implement the XMLHttpRequest in IE7 (can't request local files),
     * so we use the ActiveXObject when it is available
     * Additionally XMLHttpRequest can be disabled in IE7/IE8 so
     * we need a fallback.
     */
    function() {
    return createStandardXHR() || createActiveXHR();
} :
    // For all other browsers, use the standard XMLHttpRequest object
    createStandardXHR;



JSZipUtils.getBinaryContent = function(path, callback) {
    /*
     * Here is the tricky part : getting the data.
     * In firefox/chrome/opera/... setting the mimeType to 'text/plain; charset=x-user-defined'
     * is enough, the result is in the standard xhr.responseText.
     * cf https://developer.mozilla.org/En/XMLHttpRequest/Using_XMLHttpRequest#Receiving_binary_data_in_older_browsers
     * In IE <= 9, we must use (the IE only) attribute responseBody
     * (for binary data, its content is different from responseText).
     * In IE 10, the 'charset=x-user-defined' trick doesn't work, only the
     * responseType will work :
     * http://msdn.microsoft.com/en-us/library/ie/hh673569%28v=vs.85%29.aspx#Binary_Object_upload_and_download
     *
     * I'd like to use jQuery to avoid this XHR madness, but it doesn't support
     * the responseType attribute : http://bugs.jquery.com/ticket/11461
     */
    try {

        var xhr = createXHR();

        xhr.open('GET', path, true);

        // recent browsers
        if ("responseType" in xhr) {
            xhr.responseType = "arraybuffer";
        }

        // older browser
        if(xhr.overrideMimeType) {
            xhr.overrideMimeType("text/plain; charset=x-user-defined");
        }

        xhr.onreadystatechange = function(evt) {
            var file, err;
            // use `xhr` and not `this`... thanks IE
            if (xhr.readyState === 4) {
                if (xhr.status === 200 || xhr.status === 0) {
                    file = null;
                    err = null;
                    try {
                        file = JSZipUtils._getBinaryFromXHR(xhr);
                    } catch(e) {
                        err = new Error(e);
                    }
                    callback(err, file);
                } else {
                    callback(new Error("Ajax error for " + path + " : " + this.status + " " + this.statusText), null);
                }
            }
        };

        xhr.send();

    } catch (e) {
        callback(new Error(e), null);
    }
};

// export
module.exports = JSZipUtils;

// enforcing Stuk's coding style
// vim: set shiftwidth=4 softtabstop=4:


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if (("function" !== "undefined" && __webpack_require__(1082) !== null) && (__webpack_require__(953) !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
    return saveAs;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeForPolicyNotes = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var checkIfArrayVaryBySeason = function checkIfArrayVaryBySeason(array) {
  return array && array.length && (array.length > 1 || _ramda2.default.path([0, 'dateRanges', 'length'], array) > 1);
};

var composeForPolicyNotes = exports.composeForPolicyNotes = function composeForPolicyNotes(dialog, draftContentInView) {
  var editType = dialog.type,
      policyType = dialog.policyType,
      data = dialog.data;

  return _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('billingInfo'), function () {
    // billing-info-node.jsx
    var billingInformation = draftContentInView.billingInformation;

    return _extends({}, billingInformation, {
      insuranceFiles: billingInformation.insuranceFiles || []
    });
  }], [_ramda2.default.equals('checkInOut'), function () {
    // checkinout.jsx
    var checkInOutInfo = _ramda2.default.pick(['checkIn', 'checkOut', 'earlyCheckIn', 'earlyCheckInFee', 'earlyCheckInCostType', 'earlyCheckInPercentageType', 'lateCheckOut', 'lateCheckOutFee', 'lateCheckOutCostType', 'lateCheckOutPercentageType'], draftContentInView);
    return _extends({}, checkInOutInfo, {
      lateCheckOutChecked: Boolean(checkInOutInfo.lateCheckOut),
      earlyCheckInChecked: Boolean(checkInOutInfo.earlyCheckIn),
      earlyCheckInCostType: checkInOutInfo.earlyCheckInCostType || '$',
      lateCheckOutCostType: checkInOutInfo.lateCheckOutCostType || '$'
    });
  }], [_ramda2.default.equals('policy'), function () {
    var locationPolicy = draftContentInView.locationPolicy;

    var getLocationPolicyEditInfo = function getLocationPolicyEditInfo() {
      var _filter = (locationPolicy || []).filter(function (policy) {
        return policy.policyType === policyType;
      }),
          _filter2 = _slicedToArray(_filter, 1),
          policyInfo = _filter2[0];

      var _ref = function () {
        switch (policyType) {
          case 'cancellation':
            return { note: 'Your cancellation policy tells your partners when, and how much, they will be charged for cancelling a booking.' };
          case 'group':
            return { note: 'Please note any special conditions or policies that apply for group bookings.' };
          case 'freeOfCharge':
            return { note: 'On occasion, your partners will have tour leaders, escorts, or guides accompany a group. Please note any conditions in which they will not be charged as part of the booking.' };
          case 'family':
            return { note: 'How many adults and children are included in your family rates?' };
          case 'child':
            return { note: 'What ages are included in your Child Policy?' };
          case 'infant':
            return { note: 'What ages are included in your Infant Policy?' };
          default:
            return {};
        }
      }(),
          note = _ref.note;

      return _extends({
        note: note,
        cancelHoursDays: 'hours',
        focChildrenAllowed: Boolean(policyInfo && policyInfo.focChildrenCount),
        policyType: policyType
      }, _ramda2.default.omit(['applicable'], policyInfo));
    };
    return getLocationPolicyEditInfo();
  }], [function () {
    return _ramda2.default.contains(editType, ['corporateIdentificationNumber', 'termsAndConditions', 'submissionCriteria', 'marketInfo']);
  }, function () {
    // terms-criteria-node.jsx
    var forSupplier = data.forSupplier;

    var info = draftContentInView[forSupplier ? 'supplierInfo' : 'buyerInfo'];
    return {
      fieldName: editType,
      value: info[editType]
    };
  }]]), editType);
};

exports.default = function (dialog, contractActivitiesProducts) {
  var draftContentInView = contractActivitiesProducts.rightSideContent,
      metaDataForDraft = contractActivitiesProducts.leftNav,
      draftErrors = contractActivitiesProducts.draftErrors;
  var allContractingReadyProducts = metaDataForDraft.allContractingReadyProducts,
      productsArray = metaDataForDraft.productsArray,
      startDate = metaDataForDraft.startDate,
      endDate = metaDataForDraft.endDate,
      _metaDataForDraft$pro = metaDataForDraft.productSharedData;
  _metaDataForDraft$pro = _metaDataForDraft$pro === undefined ? {} : _metaDataForDraft$pro;
  var allExtras = _metaDataForDraft$pro.allExtras,
      allOffers = _metaDataForDraft$pro.allOffers,
      contractId = metaDataForDraft.contractId,
      locationId = metaDataForDraft.locationId,
      supplierId = metaDataForDraft.supplierId;
  var editType = dialog.type,
      policyType = dialog.policyType,
      data = dialog.data,
      offersOrExtras = dialog.offersOrExtras;
  var ratePackageId = draftContentInView._id,
      productName = draftContentInView.productName,
      ratePackageName = draftContentInView.ratePackageName,
      seasons = draftContentInView.seasons,
      seasonRates = draftContentInView.seasonRates,
      productType = draftContentInView.productType;

  var existingSeasons = (seasonRates || []).length > (seasons || []).length ? seasonRates : seasons || [];
  var isSingleSeason = _ramda2.default.path([0, 'dateRanges', 0, 'seasonStartDate'], existingSeasons) === new Date(startDate).toISOString() && _ramda2.default.path([0, 'dateRanges', 0, 'seasonEndDate'], existingSeasons) === new Date(endDate).toISOString();

  var checkIfSeasonalSectionsIsIncomplete = function checkIfSeasonalSectionsIsIncomplete(array) {
    var varyBySeason = checkIfArrayVaryBySeason(array);
    return varyBySeason && array.length < existingSeasons.length;
  };
  return _ramda2.default.call(_ramda2.default.cond([[function () {
    return _ramda2.default.contains(editType, ['corporateIdentificationNumber', 'termsAndConditions', 'submissionCriteria', 'marketInfo', 'policy', 'checkInOut', 'billingInfo']);
  }, function () {
    return composeForPolicyNotes(dialog, draftContentInView);
  }], [_ramda2.default.equals('addRates'), _ramda2.default.always({})], // left-three-rates.jsx
  [_ramda2.default.equals('addProducts'), function () {
    // add-product-button.jsx
    return {
      products: [].concat(_toConsumableArray(allContractingReadyProducts), [{
        productName: '',
        added: false,
        checked: false,
        bedsAndSofas: { isApartment: false, rooms: [] }
      }])
    };
  }], [_ramda2.default.equals('manageRatePackage'), function () {
    // rate-set-infor-template.jsx
    // three-dots-menuItems.jsx
    var existingPackagesForProduct = productsArray.filter(function (prod) {
      return prod.productId === data.productId;
    }).map(function (prod) {
      return _extends({}, prod, { ratePackageName: prod.ratePackageName || 'Primary', oldRatePackageName: prod.ratePackageName || 'Primary' });
    });
    return {
      title: ratePackageName ? 'Manage Rate Packages for ' + productName : 'Create Rate Package for ' + productName,
      existingPackagesForProduct: existingPackagesForProduct
    };
  }], [_ramda2.default.equals('allocation'), function () {
    // right-one.jsx
    var allocation = draftContentInView.allocation;

    var allocationEmpty = !(allocation && allocation.length);
    if (allocationEmpty) {
      return {
        allocation: isSingleSeason ? existingSeasons.map(function (season) {
          return {
            allotments: [{}],
            releaseBackDays: '',
            dateRanges: season.dateRanges
          };
        }) : [{
          allotments: [{}],
          releaseBackDays: ''
        }]
      };
    }
    var varyBySeason = checkIfArrayVaryBySeason(allocation);
    var incomplete = checkIfSeasonalSectionsIsIncomplete(allocation);
    return {
      title: 'Edit Allocation',
      varyBySeason: varyBySeason,
      allocation: incomplete ? _dateUtils2.default.matchAllocationOrPolicyWithSeasons(existingSeasons, allocation) : allocation
    };
  }], [_ramda2.default.equals('addProductPolicy'), function () {
    var productPolicy = draftContentInView.productPolicy;

    return {
      productPolicy: productPolicy,
      selectedPolicy: {}
    };
  }], [_ramda2.default.equals('editProductPolicy'), function () {
    var productPolicy = draftContentInView.productPolicy;

    var policyObject = (productPolicy || []).reduce(function (result, policy) {
      if (policy.policyType === 'child') {
        result.child = _extends({}, policy, { focChildrenAllowed: Boolean(policy.focChildrenCount) });
      } else result[policy.policyType] = policy;
      return result;
    }, {});
    return {
      productPolicy: productPolicy,
      selectedPolicy: policyObject[policyType]
    };
  }], [_ramda2.default.equals('seasonalCancelPolicies'), function () {
    var productPolicy = draftContentInView.productPolicy;

    var _filter3 = (productPolicy || []).filter(function (policy) {
      return policy.policyType === 'cancellation';
    }),
        _filter4 = _slicedToArray(_filter3, 1),
        policyInfo = _filter4[0];

    var contentLength = _ramda2.default.path(['cancellations', 'length'], policyInfo);
    if (contentLength) {
      var _varyBySeason = checkIfArrayVaryBySeason(policyInfo.cancellations);
      var incomplete = checkIfSeasonalSectionsIsIncomplete(policyInfo.cancellations);
      return _extends({
        varyBySeason: _varyBySeason
      }, policyInfo, {
        cancellations: incomplete ? _dateUtils2.default.matchAllocationOrPolicyWithSeasons(existingSeasons, policyInfo.cancellations) : policyInfo.cancellations
      });
    }
    var varyBySeason = productType === 'Non-Accommodation' ? false : !isSingleSeason;
    return {
      varyBySeason: varyBySeason,
      policyType: 'cancellation',
      conditions: '',
      cancellations: varyBySeason ? existingSeasons.map(function (season) {
        return { dateRanges: season.dateRanges };
      }) : [{ dateRanges: [{ seasonStartDate: startDate, seasonEndDate: endDate }] }]
    };
  }], [_ramda2.default.equals('blackouts'), function () {
    var blackouts = draftContentInView.blackouts;

    return {
      blackouts: blackouts ? [].concat(_toConsumableArray(blackouts.map(function (obj) {
        return _ramda2.default.assoc('dataKey', _nodeUuid2.default.v1(), obj);
      })), [{ dataKey: _nodeUuid2.default.v1() }]) : [{}]
    };
  }], [_ramda2.default.equals('addExtra'), _ramda2.default.always({})], [_ramda2.default.equals('editExtra'), function () {
    // left-extras.jsx
    var extras = draftContentInView.extras;

    return { extras: extras };
  }], [_ramda2.default.equals('pickupDropoff'), function () {
    // right-four-pickup-dropoff.jsx
    var pickupOrDropoff = data.pickupOrDropoff;

    var infoArray = draftContentInView[pickupOrDropoff];
    if (infoArray && infoArray.length) {
      var useSeasons = infoArray.length > 1 && infoArray.length === existingSeasons.length;
      var varyBySeason = checkIfArrayVaryBySeason(infoArray);
      // const incomplete = checkIfSeasonalSectionsIsIncomplete(infoArray);
      return _defineProperty({
        varyBySeason: useSeasons || varyBySeason,
        useSeasons: useSeasons
      }, pickupOrDropoff, useSeasons ? _dateUtils2.default.matchAllocationOrPolicyWithSeasons(existingSeasons, infoArray) : infoArray.map(function (obj) {
        return obj && _ramda2.default.isEmpty(obj.dateRanges) ? _ramda2.default.merge(obj, { dateRanges: [{}] }) : obj;
      }));
    }
    return _defineProperty({
      varyBySeason: false,
      useSeasons: false
    }, pickupOrDropoff, [{
      notes: '',
      timeLocArray: [{}],
      dateRanges: [{ seasonStartDate: startDate, seasonEndDate: endDate }]
    }]);
  }], [_ramda2.default.equals('importFromTemplate'), _ramda2.default.always({ step: 1 })], [_ramda2.default.equals('omniImport'), _ramda2.default.always({
    showCC: true,
    templates: data.templates || [],
    importPoliciesNotes: true,
    targetTemplate: {
      docId: contractId,
      locationId: locationId,
      supplierId: supplierId,
      products: allContractingReadyProducts
    }
  })], [_ramda2.default.equals('copyDataFromAnotherProduct'), function () {
    var noShowIfEmpty = dialog.data.noShowIfEmpty;

    var currentProductId = draftContentInView.productId;
    var currentRatePackage = draftContentInView.ratePackageName || '';
    var notEmptyRatePackages = (draftErrors.products || []).filter(function (prod) {
      var notEmpty = prod.productCompletionScore > 0;
      var notSameProductId = prod.productId !== currentProductId;
      var notSamePackageName = (prod.ratePackageName || '') !== currentRatePackage;
      return notEmpty && (notSameProductId || notSamePackageName);
    });
    var availableFields = productType === 'Accommodation' ? ['seasonRates', 'extras', 'offers', 'allocation', 'blackouts', 'productPolicy'] : ['seasonRates', 'extras', 'offers', 'allocation', 'blackouts', 'pickup', 'dropoff', 'productPolicy'];
    return {
      addedProducts: notEmptyRatePackages,
      withoutRates: true,
      productSelectedToBeCopied: notEmptyRatePackages.length === 1 ? 0 : -1,
      availableFields: availableFields.map(function (field) {
        return { field: field, checked: true };
      }),
      thisProductType: productType,
      noShowIfEmpty: noShowIfEmpty
    };
  }], [_ramda2.default.equals('editSeason'), _ramda2.default.always({
    existingSeasons: existingSeasons
  })], [_ramda2.default.equals('manageExtrasOffers'), function () {
    var list = offersOrExtras.type === 'offers' ? allOffers.map(function (obj) {
      return _ramda2.default.merge(obj, {
        validDatesOfSale: function () {
          if (obj.isStayPay) return [{ fromDate: new Date().toISOString(), toDate: endDate }];
          if (obj.validDatesOfSale.length) return obj.validDatesOfSale;
          return [{}];
        }(),
        validDatesOfTravel: obj.validDatesOfTravel.length ? obj.validDatesOfTravel : [{}]
      });
    }) : allExtras;
    var retVal = {
      offersOrExtras: {
        selectedId: offersOrExtras.selectedId || _ramda2.default.path([0, '_id'], list),
        toDelete: offersOrExtras.toDelete ? ratePackageId : null,
        productsArray: productsArray,
        productType: productType,
        list: list
      }
    };
    if (offersOrExtras.createNew) {
      if (offersOrExtras.type === 'offers') {
        retVal.data = {
          title: data.title,
          offerName: '',
          offerDetail: '',
          specialConditions: '',
          allowCombination: false,
          validDatesOfSale: [{ fromDate: (0, _moment2.default)(new Date()).isAfter(endDate) ? startDate : _moment2.default.utc().startOf('day').toISOString(), toDate: endDate }],
          validDatesOfTravel: [{}],
          ratePackages: productsArray.map(function (p) {
            return p._id;
          })
        };
      } else {
        retVal.data = {
          title: data.title,
          ratePackages: productsArray.map(function (p) {
            return p._id;
          })
        };
      }
    }
    if (offersOrExtras.toDelete) {
      retVal.offersOrExtras.list = retVal.offersOrExtras.list.map(function (o) {
        if (o._id === retVal.offersOrExtras.selectedId) return _extends({}, o, { ratePackages: o.ratePackages.filter(function (x) {
            return x !== ratePackageId;
          }) });
        return o;
      });
    }
    return retVal;
  }], [_ramda2.default.equals('updateBeddingConfig'), function () {
    var foundProd = allContractingReadyProducts.find(function (p) {
      return p.productId === draftContentInView.productId;
    });
    return {
      title: 'Update Bedding Configuration',
      bedsAndSofas: foundProd ? foundProd.bedsAndSofas : { rooms: [[]], isApartment: false }
    };
  }]]), editType);
};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.importSuccess = importSuccess;
exports.refreshContractDoc = refreshContractDoc;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _effects = __webpack_require__(36);

var _reduxSaga = __webpack_require__(92);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRouterRedux = __webpack_require__(27);

var _string = __webpack_require__(959);

var _api = __webpack_require__(37);

var _composeDraftEditDataByType = __webpack_require__(608);

var _composeDraftEditDataByType2 = _interopRequireDefault(_composeDraftEditDataByType);

var _sagas = __webpack_require__(43);

var _contractListConstants = __webpack_require__(560);

var conListConst = _interopRequireWildcard(_contractListConstants);

var _constants = __webpack_require__(252);

var cnt = _interopRequireWildcard(_constants);

var _constants2 = __webpack_require__(233);

var wpCnts = _interopRequireWildcard(_constants2);

var _globalErrorsDisplayActions = __webpack_require__(486);

var _contractListActions = __webpack_require__(563);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchContracts),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(archiveSelectedContracts),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(populateEditDialog),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(createProductOrImport),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getRespondedContractsForRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(getContractNotes),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(deleteContractNote),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(afterGettingMetaData),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(triggerLoadContractList),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(getContractList),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(doUpdateFolders),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(doChangeContractListRoute),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(getRequestForSupplierWizard),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(downloadContractingDocs),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(downloadContractingDocsSuccess),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(shouldAskToAccept),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(acceptRatesAfterDownload),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(exportExcel),
    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(handleExportExcel),
    _marked20 = /*#__PURE__*/regeneratorRuntime.mark(handleExportExcelError),
    _marked21 = /*#__PURE__*/regeneratorRuntime.mark(handleArchiveUnarchiveTemplate),
    _marked22 = /*#__PURE__*/regeneratorRuntime.mark(updateContractRequestPartner),
    _marked23 = /*#__PURE__*/regeneratorRuntime.mark(submitContractingComment),
    _marked24 = /*#__PURE__*/regeneratorRuntime.mark(getContractForwardingEmail),
    _marked25 = /*#__PURE__*/regeneratorRuntime.mark(getDiffReport),
    _marked26 = /*#__PURE__*/regeneratorRuntime.mark(getDiffReportForDraft),
    _marked27 = /*#__PURE__*/regeneratorRuntime.mark(getAvailDocsForDiffReport),
    _marked28 = /*#__PURE__*/regeneratorRuntime.mark(getDiffReportForViewChanges),
    _marked29 = /*#__PURE__*/regeneratorRuntime.mark(doSendReviewRatesEmail),
    _marked30 = /*#__PURE__*/regeneratorRuntime.mark(updateTemplateListUrl),
    _marked31 = /*#__PURE__*/regeneratorRuntime.mark(manageExtrasOffers),
    _marked32 = /*#__PURE__*/regeneratorRuntime.mark(importSuccess),
    _marked33 = /*#__PURE__*/regeneratorRuntime.mark(refreshContractDoc),
    _marked34 = /*#__PURE__*/regeneratorRuntime.mark(afterUpdateContractPartnerInfoSuccess),
    _marked35 = /*#__PURE__*/regeneratorRuntime.mark(updateSameAsCorporate),
    _marked36 = /*#__PURE__*/regeneratorRuntime.mark(removeMasterTemplate),
    _marked37 = /*#__PURE__*/regeneratorRuntime.mark(refreshTemplateList),
    _marked38 = /*#__PURE__*/regeneratorRuntime.mark(afterRemoveDraftFromQueue),
    _marked39 = /*#__PURE__*/regeneratorRuntime.mark(sendTourWriter),
    _marked40 = /*#__PURE__*/regeneratorRuntime.mark(tourWriterStart),
    _marked41 = /*#__PURE__*/regeneratorRuntime.mark(tourWriterError),
    _marked42 = /*#__PURE__*/regeneratorRuntime.mark(removeSingleFeedByTCAdmin),
    _marked43 = /*#__PURE__*/regeneratorRuntime.mark(markHistoryFeedAsRead),
    _marked44 = /*#__PURE__*/regeneratorRuntime.mark(updateContractActivities),
    _marked45 = /*#__PURE__*/regeneratorRuntime.mark(getTemplateChangeLogs),
    _marked46 = /*#__PURE__*/regeneratorRuntime.mark(onRouteChange),
    _marked47 = /*#__PURE__*/regeneratorRuntime.mark(fileContractForRequest),
    _marked48 = /*#__PURE__*/regeneratorRuntime.mark(fileContractForRequestSuccess),
    _marked49 = /*#__PURE__*/regeneratorRuntime.mark(removeContractsFromRequests),
    _marked50 = /*#__PURE__*/regeneratorRuntime.mark(removeContractsFromRequestsSuccess),
    _marked51 = /*#__PURE__*/regeneratorRuntime.mark(handleOpenReSendContractDialog),
    _marked52 = /*#__PURE__*/regeneratorRuntime.mark(handleAfterMadeACopyOfATemplate),
    _marked53 = /*#__PURE__*/regeneratorRuntime.mark(makeACopyForBuyer),
    _marked54 = /*#__PURE__*/regeneratorRuntime.mark(updateWorkspaceContract),
    _marked55 = /*#__PURE__*/regeneratorRuntime.mark(requestDL),
    _marked56 = /*#__PURE__*/regeneratorRuntime.mark(afterRequestDLSuccess),
    _marked57 = /*#__PURE__*/regeneratorRuntime.mark(searchCCTemplates),
    _marked58 = /*#__PURE__*/regeneratorRuntime.mark(getProductsForOmniImport),
    _marked59 = /*#__PURE__*/regeneratorRuntime.mark(doOmniImport),
    _marked60 = /*#__PURE__*/regeneratorRuntime.mark(editProductProfile),
    _marked61 = /*#__PURE__*/regeneratorRuntime.mark(editProductProfileSuccess); /* global window */


function fetchContracts() {
  var contractPeriod, searchCompanyName, searchDomain;
  return regeneratorRuntime.wrap(function fetchContracts$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'requestsWithSameNameOrDomainDialog', 'contractPeriod']));

        case 2:
          contractPeriod = _context.sent;
          _context.next = 5;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'requestsWithSameNameOrDomainDialog', 'searchCompanyName']));

        case 5:
          searchCompanyName = _context.sent;
          _context.next = 8;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'requestsWithSameNameOrDomainDialog', 'searchDomain']));

        case 8:
          searchDomain = _context.sent;
          return _context.delegateYield((0, _sagas.apiSaga)('GET_CONTRACT_REQUESTS_BY_COMPANY', _api.contracting.getContractList, [{
            currentYear: contractPeriod,
            listType: 'search',
            searchCategory: 'sent',
            searchingAllYears: false,
            page: 1,
            searchInput: searchCompanyName || searchDomain
          }]), 't0', 10);

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function archiveSelectedContracts() {
  var selectedIds;
  return regeneratorRuntime.wrap(function archiveSelectedContracts$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'requestsWithSameNameOrDomainDialog', 'selectedIds']));

        case 2:
          selectedIds = _context2.sent;
          return _context2.delegateYield((0, _sagas.apiSaga)('DISCARD_SELECTED_IN_REQUESTS_WITH_SAME_NAME_DIALOG', _api.contracting.deleteOrUndelete, [{ contractIds: selectedIds, state: true }]), 't0', 4);

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function populateEditDialog() {
  var dialogForEdit, ratePackageIndexForEdit, productIdForEdit, ratePackageNameForEdit, ratePackageIdForEdit, policiesNotesPage, type, contractActivitiesProducts, draftContentInView, draftMetaData, draftId, ratePackageIndexInView, productId, needToGoToNewProduct, needToGoToNotesPolicies, rpId, composedData;
  return regeneratorRuntime.wrap(function populateEditDialog$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.addEditContractDialog.toJS();
          });

        case 2:
          dialogForEdit = _context3.sent;
          ratePackageIndexForEdit = dialogForEdit.ratePackageIndex, productIdForEdit = dialogForEdit.productId, ratePackageNameForEdit = dialogForEdit.ratePackageName, ratePackageIdForEdit = dialogForEdit.ratePackageId, policiesNotesPage = dialogForEdit.policiesNotesPage, type = dialogForEdit.type;

          if (!type) {
            _context3.next = 38;
            break;
          }

          _context3.next = 7;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 7:
          contractActivitiesProducts = _context3.sent;
          draftContentInView = contractActivitiesProducts.rightSideContent, draftMetaData = contractActivitiesProducts.leftNav;
          draftId = draftMetaData.contractId;
          ratePackageIndexInView = draftContentInView.ratePackageIndex, productId = draftContentInView.productId;
          // the edit happens while user is in policies and notes page

          needToGoToNewProduct = !isNaN(ratePackageIndexForEdit) && ratePackageIndexForEdit !== ratePackageIndexInView;
          // the edit happens while user is in product page

          needToGoToNotesPolicies = policiesNotesPage && productId;

          if (!(needToGoToNewProduct || needToGoToNotesPolicies)) {
            _context3.next = 23;
            break;
          }

          if (!needToGoToNewProduct) {
            _context3.next = 18;
            break;
          }

          rpId = function () {
            if (ratePackageIdForEdit) return ratePackageIdForEdit;
            return ratePackageNameForEdit ? encodeURIComponent(ratePackageNameForEdit) : 'Primary';
          }();

          _context3.next = 18;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/draft/' + draftId + '/product/' + productIdForEdit + '/' + rpId));

        case 18:
          if (!needToGoToNotesPolicies) {
            _context3.next = 21;
            break;
          }

          _context3.next = 21;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/draft/' + draftId + '/policies'));

        case 21:
          _context3.next = 38;
          break;

        case 23:
          composedData = (0, _composeDraftEditDataByType2.default)(dialogForEdit, contractActivitiesProducts);

          if (!(type === 'copyDataFromAnotherProduct')) {
            _context3.next = 36;
            break;
          }

          if (!(composedData.noShowIfEmpty && _ramda2.default.isEmpty(composedData.addedProducts))) {
            _context3.next = 30;
            break;
          }

          _context3.next = 28;
          return (0, _effects.put)({ type: 'CLOSE_ADD_EDIT_CONTRACT_DIALOG' });

        case 28:
          _context3.next = 34;
          break;

        case 30:
          _context3.next = 32;
          return (0, _effects.call)(_reduxSaga.delay, 300);

        case 32:
          _context3.next = 34;
          return (0, _effects.put)({
            type: 'OPEN_AND_POPULATE_ADD_EDIT_CONTRACT_DIALOG',
            payload: composedData.offersOrExtras ? composedData : { data: composedData }
          });

        case 34:
          _context3.next = 38;
          break;

        case 36:
          _context3.next = 38;
          return (0, _effects.put)({
            type: 'OPEN_AND_POPULATE_ADD_EDIT_CONTRACT_DIALOG',
            payload: composedData && composedData.offersOrExtras ? composedData : { data: composedData }
          });

        case 38:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function createProductOrImport(payload) {
  var _ref, type, isDummyAccount, isTrueSupplier;

  return regeneratorRuntime.wrap(function createProductOrImport$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(function (state) {
            return state.user.toJS();
          });

        case 2:
          _ref = _context4.sent;
          type = _ref.user.type;
          isDummyAccount = _ref.isDummyAccount;
          isTrueSupplier = type === 'Supplier' && !isDummyAccount;
          // show import dialog when user hasn't edited the draft

          if (!(payload.hasSeenResponseWizard === false && (!isTrueSupplier || payload.templates && payload.templates.length))) {
            _context4.next = 11;
            break;
          }

          _context4.next = 9;
          return (0, _effects.put)({
            type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
            payload: {
              type: 'importFromTemplate',
              data: { forNewDraft: true }
            }
          });

        case 9:
          _context4.next = 14;
          break;

        case 11:
          if (!_ramda2.default.isEmpty(payload.productsArray)) {
            _context4.next = 14;
            break;
          }

          _context4.next = 14;
          return (0, _effects.put)({
            type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
            payload: {
              type: 'addProducts',
              data: { isFirstProduct: true }
            }
          });

        case 14:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function getRespondedContractsForRequest(type, requestId) {
  return regeneratorRuntime.wrap(function getRespondedContractsForRequest$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.getRespondedContractList, [{ requestId: requestId }]), 't0', 1);

        case 1:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

// for notes page in contract
function getContractNotes() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      payload = _ref2.payload;

  var historyFeedId;
  return regeneratorRuntime.wrap(function getContractNotes$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (!(payload && payload.historyFeedId)) {
            _context6.next = 4;
            break;
          }

          _context6.t0 = payload.historyFeedId;
          _context6.next = 7;
          break;

        case 4:
          _context6.next = 6;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.getIn(['leftNav', 'historyFeedId']);
          });

        case 6:
          _context6.t0 = _context6.sent;

        case 7:
          historyFeedId = _context6.t0;
          return _context6.delegateYield((0, _sagas.apiSaga)(cnt.GET_NOTES, _api.workspace.getActivities, [{ assetId: historyFeedId, activityType: 'note' }]), 't1', 9);

        case 9:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function deleteContractNote(_ref3) {
  var payload = _ref3.payload,
      type = _ref3.type;
  return regeneratorRuntime.wrap(function deleteContractNote$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.delegateYield((0, _sagas.apiSaga)(type, _api.workspace.deleteMessage, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function afterGettingMetaData() {
  var dialogForEdit, _ref4, leftNav, isInitialDraft, isContractRequest, isInNotes, docId;

  return regeneratorRuntime.wrap(function afterGettingMetaData$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.addEditContractDialog.toJS();
          });

        case 2:
          dialogForEdit = _context8.sent;
          _context8.next = 5;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 5:
          _ref4 = _context8.sent;
          leftNav = _ref4.leftNav;

          if (!dialogForEdit.type) {
            _context8.next = 9;
            break;
          }

          return _context8.abrupt('return');

        case 9:
          isInitialDraft = leftNav.contractState === 'draft' && leftNav.originFrom === 'initial';
          isContractRequest = !leftNav.locationId;
          isInNotes = window.location.pathname.indexOf('notes') > -1;

          if (!isInitialDraft) {
            _context8.next = 15;
            break;
          }

          _context8.next = 15;
          return createProductOrImport(leftNav);

        case 15:
          docId = leftNav.contractId;

          if (!isContractRequest) {
            _context8.next = 19;
            break;
          }

          _context8.next = 19;
          return getRespondedContractsForRequest('[contract-request]GET_RESPONDED_CONTRACT_LIST', docId);

        case 19:
          if (!isInNotes) {
            _context8.next = 22;
            break;
          }

          _context8.next = 22;
          return getContractNotes();

        case 22:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function triggerLoadContractList() {
  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var payload, type, notTogglingAdvanceSearch, _ref5, currentRoute, _ref6, leftNav;

  return regeneratorRuntime.wrap(function triggerLoadContractList$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          if (!(window.location.pathname.indexOf('contract-list') > -1)) {
            _context9.next = 13;
            break;
          }

          payload = action.payload, type = action.type;
          notTogglingAdvanceSearch = !Boolean(type === '[contract-list]UPDATE_SEARCH_PARAMS' && _ramda2.default.keys(payload).length === 1 && _ramda2.default.has('openAdvanceSearch', payload));

          if (!notTogglingAdvanceSearch) {
            _context9.next = 11;
            break;
          }

          _context9.next = 6;
          return (0, _effects.select)(_ramda2.default.path(['routing', 'locationBeforeTransitions']));

        case 6:
          _ref5 = _context9.sent;
          currentRoute = _ref5.pathname;

          if (!(currentRoute.indexOf('contract-list') > -1)) {
            _context9.next = 11;
            break;
          }

          _context9.next = 11;
          return (0, _effects.put)({ type: 'LOAD_CONTRACT_LIST_FROM_BACKEND', payload: true });

        case 11:
          _context9.next = 19;
          break;

        case 13:
          _context9.next = 15;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 15:
          _ref6 = _context9.sent;
          leftNav = _ref6.leftNav;
          _context9.next = 19;
          return getRespondedContractsForRequest('[contract-request]GET_RESPONDED_CONTRACT_LIST', leftNav.contractId);

        case 19:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function getContractList() {
  var currentYear, _ref7, list, searchParams, params;

  return regeneratorRuntime.wrap(function getContractList$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'currentYear']));

        case 2:
          currentYear = _context10.sent;
          _context10.next = 5;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractList.toJS();
          });

        case 5:
          _ref7 = _context10.sent;
          list = _ref7.list;
          searchParams = _ref7.searchParams;
          params = _extends({
            listType: list.listType || searchParams.searchCategory || 'recent',
            page: list.page || 1,
            currentYear: currentYear
          }, searchParams);
          return _context10.delegateYield((0, _sagas.apiSaga)(conListConst.LOAD_CONTRACT_LIST, _api.contracting.getContractList, [params]), 't0', 10);

        case 10:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function doUpdateFolders() {
  var _ref8, folders, originalFolder, newFolderName;

  return regeneratorRuntime.wrap(function doUpdateFolders$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractList.toJS();
          });

        case 2:
          _ref8 = _context11.sent;
          folders = _ref8.folders;
          originalFolder = _ref8.originalFolder;
          newFolderName = _ref8.newFolderName;
          return _context11.delegateYield((0, _sagas.apiSaga)('[contract-list]UPDATE_FOLDER_NAME', _api.contracting.updateFolders, [{ folders: folders, originalFolder: originalFolder, newFolderName: newFolderName }]), 't0', 7);

        case 7:
          _context11.next = 9;
          return (0, _effects.put)({ type: '[contract-list]CHANGE_ROUTE', payload: { routeName: newFolderName, isFolder: true } });

        case 9:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function doChangeContractListRoute() {
  var _ref9, searchParams, list, uriEncoded;

  return regeneratorRuntime.wrap(function doChangeContractListRoute$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractList.toJS();
          });

        case 2:
          _ref9 = _context12.sent;
          searchParams = _ref9.searchParams;
          list = _ref9.list;
          uriEncoded = encodeURIComponent(list.listType || '');
          _context12.next = 8;
          return (0, _effects.put)((0, _reactRouterRedux.replace)({
            pathname: '/contracting/contract-list/' + uriEncoded,
            query: { isFolder: searchParams.isFolder }
          }));

        case 8:
          _context12.next = 10;
          return triggerLoadContractList();

        case 10:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function getRequestForSupplierWizard() {
  var requestId;
  return regeneratorRuntime.wrap(function getRequestForSupplierWizard$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.supplierWizard.toJS().contractRequest.contractId;
          });

        case 2:
          requestId = _context13.sent;

          if (!requestId) {
            _context13.next = 5;
            break;
          }

          return _context13.delegateYield((0, _sagas.apiSaga)('[supplier-wizard]GET_CONTRACT_REQUEST_INFO_SUPPLIER_WIZARD', _api.contracting.getContractRequestInfo, [{ requestId: requestId }]), 't0', 5);

        case 5:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function downloadContractingDocs() {
  var payload, payload2, docIds;
  return regeneratorRuntime.wrap(function downloadContractingDocs$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'downloadDocs']));

        case 2:
          payload = _context14.sent;

          if (payload) {
            _context14.next = 5;
            break;
          }

          return _context14.abrupt('return');

        case 5:
          payload2 = _ramda2.default.pick(['collection', 'locale', 'ratesOnly', 'downloadRateFormat', 'forAL'], payload);

          docIds = function () {
            if (!_ramda2.default.isEmpty(payload.contractIds || [])) {
              return payload.contractIds;
            }
            if (!_ramda2.default.isEmpty(payload.templates || [])) {
              return payload.templates.map(function (_ref10) {
                var _id = _ref10._id;
                return _id;
              });
            }
            if (payload.docId) {
              return [payload.docId];
            }
            return []; // ?? nothing to do
          }();

          if (docIds.length === 1 && _ramda2.default.last(payload2.downloadRateFormat.split('_')) === 'singlefile') {
            // should not be single file if it is a single doc
            payload2.downloadRateFormat = payload2.downloadRateFormat.split('_').splice(0, 2).join('_');
          }
          // return R.isEmpty(payload.contractIds) ? [payload.docId] : payload.contractIds;
          // });
          _context14.next = 10;
          return (0, _sagas.apiSaga)('[contracting-download] downloadGroup', _api.fileUrls.downloadGroup, [_extends({}, payload2, {
            docIds: docIds
          })]);

        case 10:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function downloadContractingDocsSuccess(_ref11) {
  var type = _ref11.type,
      payload = _ref11.payload;

  var _ref12, forAL, url;

  return regeneratorRuntime.wrap(function downloadContractingDocsSuccess$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'downloadDocs']));

        case 2:
          _ref12 = _context15.sent;
          forAL = _ref12.forAL;

          if (!(payload.status === 'processed' && payload.returnValue)) {
            _context15.next = 10;
            break;
          }

          url = _ramda2.default.path(['url'], (0, _string.jsonParseFn)(payload.returnValue));
          // check if w ehave a return value URL or product an error

          if (!url) {
            _context15.next = 10;
            break;
          }

          _context15.next = 9;
          return (0, _effects.put)({
            type: type + '_SUCCESS',
            payload: { url: url }
          });

        case 9:
          return _context15.abrupt('return', _context15.sent);

        case 10:
          if (!(payload.status === 'pending' && payload.jobUrl)) {
            _context15.next = 16;
            break;
          }

          _context15.next = 13;
          return (0, _effects.call)(_reduxSaga.delay, 3e3);

        case 13:
          _context15.next = 15;
          return (0, _sagas.apiSaga)('[contracting-download] downloadGroup', _api.fileUrls.checkJobUrl, [_extends({}, payload, {
            forAL: forAL
          })]);

        case 15:
          return _context15.abrupt('return', _context15.sent);

        case 16:
          _context15.next = 18;
          return (0, _effects.put)({
            type: type + '_ERROR'
          });

        case 18:
          return _context15.abrupt('return', _context15.sent);

        case 19:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function downloadContractingUrl(_ref13) {
  var payload = _ref13.payload;

  var a = document.createElement('a');
  a.download = true;
  a.target = '_blank';
  a.setAttribute('download', true);
  a.href = payload.url;
  a.dispatchEvent(new MouseEvent('click'));
  // window.open(payload.url, '_blank');
}

function shouldAskToAccept(_ref14) {
  var type = _ref14.type;

  var _ref15, contractIds, docId, _ref16, rates, viewAs, singleContractIsPending, someBulkDownloadedContractsArePending, currentState, _viewAs;

  return regeneratorRuntime.wrap(function shouldAskToAccept$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.downloadDocs;
          });

        case 2:
          _ref15 = _context16.sent;
          contractIds = _ref15.contractIds;
          docId = _ref15.docId;

          if (!(window.location.pathname.indexOf('assets-landing') > -1)) {
            _context16.next = 23;
            break;
          }

          _context16.next = 8;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 8:
          _ref16 = _context16.sent;
          rates = _ref16.rates;
          viewAs = _ref16.viewAs;
          singleContractIsPending = docId && rates.find(function (o) {
            return o._id === docId && o.state === 'pending';
          });
          someBulkDownloadedContractsArePending = contractIds && contractIds.length && contractIds.some(function (id) {
            return rates.find(function (o) {
              return o._id === id && o.state === 'pending';
            });
          });

          if (!(viewAs === 'Contractor' && (singleContractIsPending || someBulkDownloadedContractsArePending))) {
            _context16.next = 18;
            break;
          }

          _context16.next = 16;
          return (0, _effects.put)({ type: '[contracting-download]ASK_ACCEPT_AFTER_DOWNLOAD' });

        case 16:
          _context16.next = 21;
          break;

        case 18:
          if (!(type === '[contracting-download]DOWNLOAD_SINGLE_CONTRACT_DOC_SUCCESS')) {
            _context16.next = 21;
            break;
          }

          _context16.next = 21;
          return (0, _effects.put)({ type: '[contracting-download]CLOSE_DOWNLOAD_POPOVER' });

        case 21:
          _context16.next = 43;
          break;

        case 23:
          if (!(window.location.pathname.indexOf('/contracting/contract/') > -1)) {
            _context16.next = 40;
            break;
          }

          _context16.next = 26;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.getIn(['leftNav', 'state']);
          });

        case 26:
          currentState = _context16.sent;
          _context16.next = 29;
          return (0, _effects.select)(function (state) {
            return state.user.getIn(['company', 'companyType']);
          });

        case 29:
          _viewAs = _context16.sent;

          if (!(currentState === 'pending' && _viewAs === 'Contractor')) {
            _context16.next = 35;
            break;
          }

          _context16.next = 33;
          return (0, _effects.put)({ type: '[contracting-download]ASK_ACCEPT_AFTER_DOWNLOAD' });

        case 33:
          _context16.next = 38;
          break;

        case 35:
          if (!(type === '[contracting-download]DOWNLOAD_SINGLE_CONTRACT_DOC_SUCCESS')) {
            _context16.next = 38;
            break;
          }

          _context16.next = 38;
          return (0, _effects.put)({ type: '[contracting-download]CLOSE_DOWNLOAD_POPOVER' });

        case 38:
          _context16.next = 43;
          break;

        case 40:
          if (!(type === '[contracting-download]DOWNLOAD_SINGLE_CONTRACT_DOC_SUCCESS')) {
            _context16.next = 43;
            break;
          }

          _context16.next = 43;
          return (0, _effects.put)({ type: '[contracting-download]CLOSE_DOWNLOAD_POPOVER' });

        case 43:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function acceptRatesAfterDownload(_ref17) {
  var type = _ref17.type;

  var _ref18, contractIds, docId, forAL;

  return regeneratorRuntime.wrap(function acceptRatesAfterDownload$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.downloadDocs;
          });

        case 2:
          _ref18 = _context17.sent;
          contractIds = _ref18.contractIds;
          docId = _ref18.docId;
          forAL = _ref18.forAL;
          _context17.next = 8;
          return (0, _sagas.apiSaga)(type, _api.contracting.updateContractStatus, [{
            contractIds: contractIds && contractIds.length ? contractIds : [docId],
            state: 'accepted',
            forAL: forAL
          }]);

        case 8:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

function exportExcel(_ref19) {
  var type = _ref19.type,
      exportType = _ref19.payload.exportType;

  var _ref20, docId, collection;

  return regeneratorRuntime.wrap(function exportExcel$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'downloadDocs']));

        case 2:
          _ref20 = _context18.sent;
          docId = _ref20.docId;
          collection = _ref20.collection;

          if (!docId) {
            _context18.next = 8;
            break;
          }

          _context18.next = 8;
          return (0, _sagas.apiSaga)(type, _api.downloads.getXls, [collection, docId, exportType]);

        case 8:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function handleExportExcel(_ref21) {
  var location = _ref21.payload.location;
  return regeneratorRuntime.wrap(function handleExportExcel$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.put)({ type: '[contracting-download]CLOSE_DOWNLOAD_POPOVER' });

        case 2:
          _context19.next = 4;
          return (0, _effects.put)((0, _globalErrorsDisplayActions.triggerError)({ errorMessageObj: _react2.default.createElement(
              'a',
              { href: location, target: '_blank', rel: 'noopener noreferrer' },
              'Click to Download'
            ) }));

        case 4:
          window.open(location);

        case 5:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked19, this);
}

function handleExportExcelError() {
  return regeneratorRuntime.wrap(function handleExportExcelError$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return (0, _effects.put)({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Unable to generate quickview file' });

        case 2:
          return _context20.delegateYield((0, _effects.put)({ type: '[contracting-download]CLOSE_DOWNLOAD_POPOVER' }), 't0', 3);

        case 3:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked20, this);
}

function handleArchiveUnarchiveTemplate(_ref22) {
  var payload = _ref22.payload;
  return regeneratorRuntime.wrap(function handleArchiveUnarchiveTemplate$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          return _context21.delegateYield((0, _sagas.apiSaga)('ARCHIVE_UNARCHIVE_TEMPLATE', _api.contracting.archiveUnarchiveTemplate, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked21, this);
}

function updateContractRequestPartner() {
  var _ref23, updatePartnerForAllContracts, contractId, newEmails, updatedEmails, removedEmails, newPartnerName, removeContactFromPartner;

  return regeneratorRuntime.wrap(function updateContractRequestPartner$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.resendContractDialog.toJS();
          });

        case 2:
          _ref23 = _context22.sent;
          updatePartnerForAllContracts = _ref23.updatePartnerForAllContracts;
          contractId = _ref23.contractId;
          newEmails = _ref23.newEmails;
          updatedEmails = _ref23.updatedEmails;
          removedEmails = _ref23.removedEmails;
          newPartnerName = _ref23.newPartnerName;
          removeContactFromPartner = _ref23.removeContactFromPartner;
          return _context22.delegateYield((0, _sagas.apiSaga)('UPDATE_CONTRACT_PARTNER_INFO', _api.contracting.updatePartnerForSentDoc, [{
            contractId: contractId,
            newEmails: newEmails.filter(function (s) {
              return s && s.trim();
            }).map(function (s) {
              return s.toLowerCase();
            }),
            updatedEmails: updatedEmails,
            newPartnerName: (newPartnerName || '').trim(),
            removedEmails: removedEmails,
            updatePartnerForAllContracts: updatePartnerForAllContracts,
            removeContactFromPartner: removeContactFromPartner
          }]), 't0', 11);

        case 11:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked22, this);
}

function submitContractingComment(_ref24) {
  var type = _ref24.type,
      payload = _ref24.payload;
  var files, message, contractId, historyFeedId;
  return regeneratorRuntime.wrap(function submitContractingComment$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          files = payload.files, message = payload.message, contractId = payload.contractId, historyFeedId = payload.historyFeedId;
          return _context23.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.submitContractingComment, [{
            files: files,
            message: message,
            contractId: contractId,
            historyFeedId: historyFeedId
          }]), 't0', 2);

        case 2:
        case 'end':
          return _context23.stop();
      }
    }
  }, _marked23, this);
}

function getContractForwardingEmail(_ref25) {
  var type = _ref25.type,
      payload = _ref25.payload;
  return regeneratorRuntime.wrap(function getContractForwardingEmail$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          return _context24.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.getContractForwardingEmail, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context24.stop();
      }
    }
  }, _marked24, this);
}

function getDiffReport(_ref26) {
  var type = _ref26.type,
      payload = _ref26.payload;
  return regeneratorRuntime.wrap(function getDiffReport$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          return _context25.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.getDiffReport, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context25.stop();
      }
    }
  }, _marked25, this);
}
function getDiffReportForDraft() {
  var contractActivitiesProducts, draftMetaData, draftId;
  return regeneratorRuntime.wrap(function getDiffReportForDraft$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          _context26.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 2:
          contractActivitiesProducts = _context26.sent;
          draftMetaData = contractActivitiesProducts.leftNav;
          draftId = draftMetaData.contractId;
          return _context26.delegateYield((0, _sagas.apiSaga)('GET_DIFF_SUMMARY_FOR_DRAFT', _api.contracting.getDiffReport, [{ docs: 'draft:' + draftId + ':' + draftId, onlyGetSummary: true }]), 't0', 6);

        case 6:
        case 'end':
          return _context26.stop();
      }
    }
  }, _marked26, this);
}
function getAvailDocsForDiffReport(_ref27) {
  var type = _ref27.type,
      payload = _ref27.payload;
  return regeneratorRuntime.wrap(function getAvailDocsForDiffReport$(_context27) {
    while (1) {
      switch (_context27.prev = _context27.next) {
        case 0:
          if (!(payload.collection === 'template')) {
            _context27.next = 4;
            break;
          }

          return _context27.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.getTemplates, [{ query: { locationId: payload.locationId } }]), 't0', 2);

        case 2:
          _context27.next = 5;
          break;

        case 4:
          return _context27.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.getContracts, [{
            query: _extends({}, { locationId: payload.locationId }, payload.buyerId ? { ownerIds: payload.buyerId } : {}, payload.email ? { toEmails: payload.email } : {})
          }]), 't1', 5);

        case 5:
        case 'end':
          return _context27.stop();
      }
    }
  }, _marked27, this);
}
function getDiffReportForViewChanges(_ref28) {
  var type = _ref28.type,
      payload = _ref28.payload;
  return regeneratorRuntime.wrap(function getDiffReportForViewChanges$(_context28) {
    while (1) {
      switch (_context28.prev = _context28.next) {
        case 0:
          if (!payload.open) {
            _context28.next = 2;
            break;
          }

          return _context28.delegateYield(getDiffReportForDraft(), 't0', 2);

        case 2:
        case 'end':
          return _context28.stop();
      }
    }
  }, _marked28, this);
}

function doSendReviewRatesEmail(_ref29) {
  var type = _ref29.type;

  var _ref30, leftNav, _ref31, _ref31$company, companyId, companyName;

  return regeneratorRuntime.wrap(function doSendReviewRatesEmail$(_context29) {
    while (1) {
      switch (_context29.prev = _context29.next) {
        case 0:
          _context29.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 2:
          _ref30 = _context29.sent;
          leftNav = _ref30.leftNav;
          _context29.next = 6;
          return (0, _effects.select)(function (state) {
            return state.user.toJS();
          });

        case 6:
          _ref31 = _context29.sent;
          _ref31$company = _ref31.company;
          companyId = _ref31$company.companyId;
          companyName = _ref31$company.companyName;
          return _context29.delegateYield((0, _sagas.apiSaga)(type, _api.account.sendInternalEmail, [{
            type: 'reviewByExpert',
            company: {
              companyId: companyId,
              companyName: companyName
            },
            draft: {
              draftId: leftNav.contractId,
              name: leftNav.templateName
            }
          }]), 't0', 11);

        case 11:
        case 'end':
          return _context29.stop();
      }
    }
  }, _marked29, this);
}

function updateTemplateListUrl(_ref32) {
  var payload = _ref32.payload;
  return regeneratorRuntime.wrap(function updateTemplateListUrl$(_context30) {
    while (1) {
      switch (_context30.prev = _context30.next) {
        case 0:
          if (!(window.location.pathname.indexOf('template-list') > -1 && window.location.pathname.indexOf('showType') === -1)) {
            _context30.next = 3;
            break;
          }

          _context30.next = 3;
          return (0, _effects.put)((0, _reactRouterRedux.replace)({
            pathname: '/contracting/template-list',
            query: {
              showType: payload.locations.length > 1 ? 'location' : ''
            }
          }));

        case 3:
        case 'end':
          return _context30.stop();
      }
    }
  }, _marked30, this);
}

function manageExtrasOffers(_ref33) {
  var type = _ref33.type,
      _ref33$payload = _ref33.payload,
      payload = _ref33$payload === undefined ? {} : _ref33$payload;

  var _ref34, addEditContractDialog, contractActivitiesProducts, _addEditContractDialo, offersOrExtras;

  return regeneratorRuntime.wrap(function manageExtrasOffers$(_context31) {
    while (1) {
      switch (_context31.prev = _context31.next) {
        case 0:
          _context31.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting;
          });

        case 2:
          _ref34 = _context31.sent;
          addEditContractDialog = _ref34.addEditContractDialog;
          contractActivitiesProducts = _ref34.contractActivitiesProducts;
          _addEditContractDialo = addEditContractDialog.toJS(), offersOrExtras = _addEditContractDialo.offersOrExtras;
          return _context31.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.manageExtrasOffers, [{
            type: offersOrExtras.type,
            list: payload.list || offersOrExtras.list,
            draftId: contractActivitiesProducts.getIn(['leftNav', 'contractId'])
          }]), 't0', 7);

        case 7:
        case 'end':
          return _context31.stop();
      }
    }
  }, _marked31, this);
}

function importSuccess() {
  var pathname, splited, collection, docId;
  return regeneratorRuntime.wrap(function importSuccess$(_context32) {
    while (1) {
      switch (_context32.prev = _context32.next) {
        case 0:
          pathname = window.location.pathname;
          splited = pathname.split('/');
          collection = splited[2];
          docId = splited[3];

          window.location = window.location.protocol + '//' + window.location.host + '/contracting/' + collection + '/' + docId + '/details';

        case 5:
        case 'end':
          return _context32.stop();
      }
    }
  }, _marked32, this);
}

function refreshContractDoc() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var bgRefresh, pathname, splited, collection, docId, isProduct, refreshLeftNav, refreshCompletionCheck, refreshProduct, refreshPolicyNotes;
  return regeneratorRuntime.wrap(function refreshContractDoc$(_context33) {
    while (1) {
      switch (_context33.prev = _context33.next) {
        case 0:
          bgRefresh = options.bgRefresh;
          pathname = window.location.pathname;
          splited = pathname.split('/');
          collection = splited[2] === 'workspace' ? 'contract' : splited[2];
          docId = splited[3];
          isProduct = splited[4] === 'product';

          if (bgRefresh) {
            _context33.next = 9;
            break;
          }

          _context33.next = 9;
          return (0, _effects.put)({ type: cnt.REFRESH_STARTED });

        case 9:
          refreshLeftNav = (0, _sagas.apiSaga)(cnt.REFRESH_LEFT_NAV, _api.contracting.getContractInfo, [{
            collection: collection,
            docId: docId,
            type: 'leftNav'
          }]);
          refreshCompletionCheck = (0, _sagas.apiSaga)(cnt.REFRESH_COMPLETION_CHECK, _api.contracting.checkContractReadiness, [docId]);
          refreshProduct = (0, _sagas.apiSaga)(cnt.REFRESH_PRODUCT_DETAILS, _api.contracting.getContractProductInfo, [{
            collection: collection,
            docId: docId,
            productId: splited[5],
            ratePackage: decodeURIComponent(splited[6] || '')
          }]);
          refreshPolicyNotes = (0, _sagas.apiSaga)(cnt.REFRESH_POLICIES_NOTES, _api.contracting.getContractInfo, [{
            collection: collection,
            docId: docId,
            type: 'policyNotes'
          }]);
          // const items = [];

          if (!isProduct) {
            _context33.next = 18;
            break;
          }

          _context33.next = 16;
          return refreshProduct;

        case 16:
          _context33.next = 20;
          break;

        case 18:
          _context33.next = 20;
          return refreshPolicyNotes;

        case 20:
          _context33.next = 22;
          return (0, _effects.put)({ type: cnt.REFRESH_FINISHED });

        case 22:
          _context33.next = 24;
          return refreshLeftNav;

        case 24:
          if (!(collection === 'draft')) {
            _context33.next = 27;
            break;
          }

          _context33.next = 27;
          return refreshCompletionCheck;

        case 27:
        case 'end':
          return _context33.stop();
      }
    }
  }, _marked33, this);
}

function afterUpdateContractPartnerInfoSuccess() {
  return regeneratorRuntime.wrap(function afterUpdateContractPartnerInfoSuccess$(_context34) {
    while (1) {
      switch (_context34.prev = _context34.next) {
        case 0:
          if (!(window.location.pathname.indexOf('/contracting/contract/') > -1)) {
            _context34.next = 5;
            break;
          }

          _context34.next = 3;
          return refreshContractDoc();

        case 3:
          _context34.next = 7;
          break;

        case 5:
          _context34.next = 7;
          return triggerLoadContractList();

        case 7:
        case 'end':
          return _context34.stop();
      }
    }
  }, _marked34, this);
}

function updateSameAsCorporate(_ref35) {
  var type = _ref35.type,
      payload = _ref35.payload;

  var _ref36, sameAsCorporatePolicyNotes, updated;

  return regeneratorRuntime.wrap(function updateSameAsCorporate$(_context35) {
    while (1) {
      switch (_context35.prev = _context35.next) {
        case 0:
          _context35.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 2:
          _ref36 = _context35.sent;
          sameAsCorporatePolicyNotes = _ref36.rightSideContent.sameAsCorporatePolicyNotes;
          updated = payload.checked ? [].concat(_toConsumableArray(sameAsCorporatePolicyNotes), [payload.sectionValue]) : sameAsCorporatePolicyNotes.filter(function (str) {
            return str !== payload.sectionValue;
          });
          return _context35.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.updateSameAsCorporatePolicyNotes, [{
            templateDraftId: payload.templateDraftId,
            sameAsCorporatePolicyNotes: updated
          }]), 't0', 6);

        case 6:
        case 'end':
          return _context35.stop();
      }
    }
  }, _marked35, this);
}

function removeMasterTemplate(_ref37) {
  var type = _ref37.type;

  var _ref38, templateDraftId;

  return regeneratorRuntime.wrap(function removeMasterTemplate$(_context36) {
    while (1) {
      switch (_context36.prev = _context36.next) {
        case 0:
          _context36.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractActivitiesProducts.toJS();
          });

        case 2:
          _ref38 = _context36.sent;
          templateDraftId = _ref38.leftNav.contractId;
          return _context36.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.removePolicyNotesTemplate, [templateDraftId]), 't0', 5);

        case 5:
        case 'end':
          return _context36.stop();
      }
    }
  }, _marked36, this);
}

function refreshTemplateList() {
  return regeneratorRuntime.wrap(function refreshTemplateList$(_context37) {
    while (1) {
      switch (_context37.prev = _context37.next) {
        case 0:
          return _context37.delegateYield((0, _sagas.apiSaga)(cnt.REFRESH_TEMPLATE_LIST, _api.contracting.getTemplateList, []), 't0', 1);

        case 1:
        case 'end':
          return _context37.stop();
      }
    }
  }, _marked37, this);
}

function afterRemoveDraftFromQueue(_ref39) {
  var args = _ref39.args;
  return regeneratorRuntime.wrap(function afterRemoveDraftFromQueue$(_context38) {
    while (1) {
      switch (_context38.prev = _context38.next) {
        case 0:
          if (!(args[0].refreshSection === 'doc')) {
            _context38.next = 3;
            break;
          }

          _context38.next = 3;
          return refreshContractDoc();

        case 3:
          if (!(args[0].refreshSection === 'list')) {
            _context38.next = 6;
            break;
          }

          _context38.next = 6;
          return refreshTemplateList();

        case 6:
        case 'end':
          return _context38.stop();
      }
    }
  }, _marked38, this);
}
function sendTourWriter(_ref40) {
  var _ref40$payload = _ref40.payload;
  _ref40$payload = _ref40$payload === undefined ? {} : _ref40$payload;
  var contractId = _ref40$payload.contractId,
      blackout = _ref40$payload.blackout;

  var selectedContracts, _ref41, docId, collection, tourwriterType;

  return regeneratorRuntime.wrap(function sendTourWriter$(_context39) {
    while (1) {
      switch (_context39.prev = _context39.next) {
        case 0:
          if (!contractId) {
            _context39.next = 4;
            break;
          }

          _context39.t0 = [contractId];
          _context39.next = 7;
          break;

        case 4:
          _context39.next = 6;
          return (0, _effects.select)(function (state) {
            return state.contracting.contractList.get('selectedContracts').toJS();
          });

        case 6:
          _context39.t0 = _context39.sent;

        case 7:
          selectedContracts = _context39.t0;
          _context39.next = 10;
          return (0, _effects.select)(_ramda2.default.path(['contracting', 'downloadDocs']));

        case 10:
          _ref41 = _context39.sent;
          docId = _ref41.docId;
          collection = _ref41.collection;
          tourwriterType = blackout ? 'tourwriterblackout' : 'tourwriter';

          if (!(selectedContracts.length > 0)) {
            _context39.next = 21;
            break;
          }

          _context39.next = 17;
          return (0, _sagas.apiSaga)(cnt.SEND_TOURWRITER, _api.downloads.getXls, ['contract', selectedContracts.join('|'), tourwriterType]);

        case 17:
          _context39.next = 19;
          return (0, _effects.put)((0, _contractListActions.updateProps)({ selectedContracts: [], allContractIds: [] }));

        case 19:
          _context39.next = 24;
          break;

        case 21:
          if (!docId) {
            _context39.next = 24;
            break;
          }

          _context39.next = 24;
          return (0, _sagas.apiSaga)(cnt.SEND_TOURWRITER, _api.downloads.getXls, [collection, docId, tourwriterType]);

        case 24:
        case 'end':
          return _context39.stop();
      }
    }
  }, _marked39, this);
}
function tourWriterStart() {
  return regeneratorRuntime.wrap(function tourWriterStart$(_context40) {
    while (1) {
      switch (_context40.prev = _context40.next) {
        case 0:
          _context40.next = 2;
          return (0, _effects.put)((0, _globalErrorsDisplayActions.triggerError)({ errorMessage: 'Generating File' }));

        case 2:
        case 'end':
          return _context40.stop();
      }
    }
  }, _marked40, this);
}
function tourWriterError() {
  return regeneratorRuntime.wrap(function tourWriterError$(_context41) {
    while (1) {
      switch (_context41.prev = _context41.next) {
        case 0:
          _context41.next = 2;
          return (0, _effects.put)((0, _globalErrorsDisplayActions.triggerError)({ errorMessage: 'Cound not generate the file' }));

        case 2:
        case 'end':
          return _context41.stop();
      }
    }
  }, _marked41, this);
}

function removeSingleFeedByTCAdmin(_ref42) {
  var type = _ref42.type,
      payload = _ref42.payload;
  var confirmed;
  return regeneratorRuntime.wrap(function removeSingleFeedByTCAdmin$(_context42) {
    while (1) {
      switch (_context42.prev = _context42.next) {
        case 0:
          confirmed = window.confirm('Are you sure?');

          if (!confirmed) {
            _context42.next = 4;
            break;
          }

          _context42.next = 4;
          return (0, _sagas.apiSaga)(type, _api.contracting.removeSingleFeedByTCAdmin, [payload]);

        case 4:
        case 'end':
          return _context42.stop();
      }
    }
  }, _marked42, this);
}
function markHistoryFeedAsRead(_ref43) {
  var _ref43$payload$respon = _ref43.payload.response,
      historyFeedId = _ref43$payload$respon.historyFeedId,
      messageArray = _ref43$payload$respon.messageArray;
  var currentRoute;
  return regeneratorRuntime.wrap(function markHistoryFeedAsRead$(_context43) {
    while (1) {
      switch (_context43.prev = _context43.next) {
        case 0:
          _context43.next = 2;
          return (0, _effects.select)(_ramda2.default.path(['routing', 'locationBeforeTransitions', 'pathname']));

        case 2:
          currentRoute = _context43.sent.split('/');

          if (!(currentRoute[1] === 'contracting' && currentRoute[2] === 'contract' && currentRoute[currentRoute.length - 1] === 'activities' && messageArray.length > 0)) {
            _context43.next = 6;
            break;
          }

          _context43.next = 6;
          return (0, _sagas.apiSaga)('[contracting] CONVERSATIONS_READ_WITH_PARAMS', _api.workspace.conversationsRead, [{
            assetId: historyFeedId,
            assetType: 'contract'
          }]);

        case 6:
        case 'end':
          return _context43.stop();
      }
    }
  }, _marked43, this);
}
function updateContractActivities(contractId) {
  return regeneratorRuntime.wrap(function updateContractActivities$(_context44) {
    while (1) {
      switch (_context44.prev = _context44.next) {
        case 0:
          _context44.next = 2;
          return (0, _sagas.apiSaga)('LOADING_HISTORY_FEEDS', _api.historyFeed.getHistory, [contractId]);

        case 2:
        case 'end':
          return _context44.stop();
      }
    }
  }, _marked44, this);
}

function getTemplateChangeLogs(threadId, search) {
  return regeneratorRuntime.wrap(function getTemplateChangeLogs$(_context45) {
    while (1) {
      switch (_context45.prev = _context45.next) {
        case 0:
          _context45.next = 2;
          return (0, _sagas.apiSaga)('[contract-template]GET_CHANGE_LOGS', _api.contracting.getTemplateChangeLog, [threadId, search]);

        case 2:
        case 'end':
          return _context45.stop();
      }
    }
  }, _marked45, this);
}

function onRouteChange(_ref44) {
  var _ref44$payload = _ref44.payload,
      pathname = _ref44$payload.pathname,
      search = _ref44$payload.search;
  var contractIdForActivitiesPage, threadIdForChangeLogs;
  return regeneratorRuntime.wrap(function onRouteChange$(_context46) {
    while (1) {
      switch (_context46.prev = _context46.next) {
        case 0:
          contractIdForActivitiesPage = (pathname.match(/^\/contracting\/contract\/([a-f\d]{24})\/activities/) || [])[1];

          if (!contractIdForActivitiesPage) {
            _context46.next = 4;
            break;
          }

          _context46.next = 4;
          return updateContractActivities(contractIdForActivitiesPage);

        case 4:
          threadIdForChangeLogs = (pathname.match(/^\/contracting\/template\/([a-f\d]{24})\/logs/) || [])[1];

          if (!threadIdForChangeLogs) {
            _context46.next = 8;
            break;
          }

          _context46.next = 8;
          return getTemplateChangeLogs(threadIdForChangeLogs, search);

        case 8:
        case 'end':
          return _context46.stop();
      }
    }
  }, _marked46, this);
}

function fileContractForRequest(_ref45) {
  var type = _ref45.type,
      payload = _ref45.payload;
  return regeneratorRuntime.wrap(function fileContractForRequest$(_context47) {
    while (1) {
      switch (_context47.prev = _context47.next) {
        case 0:
          _context47.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.fileContractForRequest, [payload]);

        case 2:
        case 'end':
          return _context47.stop();
      }
    }
  }, _marked47, this);
}
function fileContractForRequestSuccess() {
  var pathname, splited, docId;
  return regeneratorRuntime.wrap(function fileContractForRequestSuccess$(_context48) {
    while (1) {
      switch (_context48.prev = _context48.next) {
        case 0:
          pathname = window.location.pathname;
          splited = pathname.split('/');
          docId = splited[3];
          _context48.next = 5;
          return getRespondedContractsForRequest('[contract-request]GET_RESPONDED_CONTRACT_LIST', docId);

        case 5:
        case 'end':
          return _context48.stop();
      }
    }
  }, _marked48, this);
}
function removeContractsFromRequests(_ref46) {
  var type = _ref46.type,
      payload = _ref46.payload;
  return regeneratorRuntime.wrap(function removeContractsFromRequests$(_context49) {
    while (1) {
      switch (_context49.prev = _context49.next) {
        case 0:
          _context49.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.removeContractsFromRequests, [payload]);

        case 2:
        case 'end':
          return _context49.stop();
      }
    }
  }, _marked49, this);
}
function removeContractsFromRequestsSuccess(_ref47) {
  var requestId = _ref47.payload.requestId;
  return regeneratorRuntime.wrap(function removeContractsFromRequestsSuccess$(_context50) {
    while (1) {
      switch (_context50.prev = _context50.next) {
        case 0:
          _context50.next = 2;
          return getRespondedContractsForRequest('[contract-request]GET_RESPONDED_CONTRACT_LIST', requestId);

        case 2:
        case 'end':
          return _context50.stop();
      }
    }
  }, _marked50, this);
}
function handleOpenReSendContractDialog(_ref48) {
  var contractId = _ref48.payload.contractId;
  return regeneratorRuntime.wrap(function handleOpenReSendContractDialog$(_context51) {
    while (1) {
      switch (_context51.prev = _context51.next) {
        case 0:
          _context51.next = 2;
          return (0, _sagas.apiSaga)('GET_PARTNER_FOR_RESEND_DIALOG', _api.contracting.getContractPartners, [{ contractId: contractId }]);

        case 2:
        case 'end':
          return _context51.stop();
      }
    }
  }, _marked51, this);
}
function handleAfterMadeACopyOfATemplate() {
  return regeneratorRuntime.wrap(function handleAfterMadeACopyOfATemplate$(_context52) {
    while (1) {
      switch (_context52.prev = _context52.next) {
        case 0:
          if (!(window.location.href.indexOf('template-list') > -1)) {
            _context52.next = 3;
            break;
          }

          _context52.next = 3;
          return refreshTemplateList();

        case 3:
        case 'end':
          return _context52.stop();
      }
    }
  }, _marked52, this);
}

function makeACopyForBuyer(_ref49) {
  var type = _ref49.type,
      payload = _ref49.payload;
  return regeneratorRuntime.wrap(function makeACopyForBuyer$(_context53) {
    while (1) {
      switch (_context53.prev = _context53.next) {
        case 0:
          _context53.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.makeACopyForBuyer, [payload]);

        case 2:
        case 'end':
          return _context53.stop();
      }
    }
  }, _marked53, this);
}

function updateWorkspaceContract(_ref50) {
  var type = _ref50.type,
      payload = _ref50.payload;
  return regeneratorRuntime.wrap(function updateWorkspaceContract$(_context54) {
    while (1) {
      switch (_context54.prev = _context54.next) {
        case 0:
          _context54.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.updateWorkspaceContract, [payload]);

        case 2:
        case 'end':
          return _context54.stop();
      }
    }
  }, _marked54, this);
}

function requestDL() {
  var _ref51, contractId, rateConversionSetting, messageForDL, priority;

  return regeneratorRuntime.wrap(function requestDL$(_context55) {
    while (1) {
      switch (_context55.prev = _context55.next) {
        case 0:
          _context55.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.requestDL;
          });

        case 2:
          _ref51 = _context55.sent;
          contractId = _ref51.contractId;
          rateConversionSetting = _ref51.rateConversionSetting;
          messageForDL = _ref51.messageForDL;
          priority = _ref51.priority;
          _context55.next = 9;
          return (0, _sagas.apiSaga)('REQUEST_DL', _api.contracting.requestDL, [{ contractId: contractId, rateConversionSetting: rateConversionSetting, messageForDL: messageForDL, priority: priority }]);

        case 9:
        case 'end':
          return _context55.stop();
      }
    }
  }, _marked55, this);
}

function afterRequestDLSuccess() {
  return regeneratorRuntime.wrap(function afterRequestDLSuccess$(_context56) {
    while (1) {
      switch (_context56.prev = _context56.next) {
        case 0:
          if (!(window.location.href.indexOf('contract-list') > -1)) {
            _context56.next = 5;
            break;
          }

          _context56.next = 3;
          return triggerLoadContractList();

        case 3:
          _context56.next = 7;
          break;

        case 5:
          _context56.next = 7;
          return refreshContractDoc();

        case 7:
        case 'end':
          return _context56.stop();
      }
    }
  }, _marked56, this);
}

function searchCCTemplates(_ref52) {
  var type = _ref52.type,
      payload = _ref52.payload;
  return regeneratorRuntime.wrap(function searchCCTemplates$(_context57) {
    while (1) {
      switch (_context57.prev = _context57.next) {
        case 0:
          _context57.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.getTemplatesForLocOrCC, [payload]);

        case 2:
        case 'end':
          return _context57.stop();
      }
    }
  }, _marked57, this);
}

function getProductsForOmniImport(_ref53) {
  var type = _ref53.type,
      payload = _ref53.payload;
  return regeneratorRuntime.wrap(function getProductsForOmniImport$(_context58) {
    while (1) {
      switch (_context58.prev = _context58.next) {
        case 0:
          _context58.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.getContractInfo, [{
            collection: payload.template.collection,
            docId: payload.template.idFromTCAdmin,
            type: 'leftNav'
          }]);

        case 2:
        case 'end':
          return _context58.stop();
      }
    }
  }, _marked58, this);
}

function doOmniImport(_ref54) {
  var type = _ref54.type,
      payload = _ref54.payload;
  return regeneratorRuntime.wrap(function doOmniImport$(_context59) {
    while (1) {
      switch (_context59.prev = _context59.next) {
        case 0:
          _context59.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.omniImport, [payload]);

        case 2:
        case 'end':
          return _context59.stop();
      }
    }
  }, _marked59, this);
}

function editProductProfile(_ref55) {
  var type = _ref55.type,
      payload = _ref55.payload;
  return regeneratorRuntime.wrap(function editProductProfile$(_context60) {
    while (1) {
      switch (_context60.prev = _context60.next) {
        case 0:
          _context60.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.updateProductNameBeddingConfig, [payload]);

        case 2:
        case 'end':
          return _context60.stop();
      }
    }
  }, _marked60, this);
}

function editProductProfileSuccess(_ref56) {
  var payload = _ref56.payload,
      args = _ref56.args;
  return regeneratorRuntime.wrap(function editProductProfileSuccess$(_context61) {
    while (1) {
      switch (_context61.prev = _context61.next) {
        case 0:
          if (!(args[0].productId !== payload.productId)) {
            _context61.next = 3;
            break;
          }

          _context61.next = 3;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/draft/' + args[0].contractId + '/product/' + payload.productId + '/' + payload.ratePackageId));

        case 3:
          _context61.next = 5;
          return refreshContractDoc({ bgRefresh: true });

        case 5:
        case 'end':
          return _context61.stop();
      }
    }
  }, _marked61, this);
}

// UPDATE_NEW_EMAIL_IN_CONTRACT
exports.default = [(0, _effects.takeLatest)('[supplier-wizard]GET_CONTRACT_REQUEST_INFO_SUPPLIER_WIZARD', getRequestForSupplierWizard), (0, _effects.takeLatest)('OPEN_DIALOG_SHOW_REQUESTS_WITH_SAME_NAME', fetchContracts), (0, _effects.takeLatest)('DISCARD_SELECTED_IN_REQUESTS_WITH_SAME_NAME_DIALOG', archiveSelectedContracts), (0, _effects.takeLatest)('INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE', populateEditDialog), (0, _effects.takeLatest)('PRODUCTS_SAVED_UPDATE_REDUX', populateEditDialog), (0, _effects.takeLatest)('GET_PRODUCT_DETAILS', populateEditDialog), (0, _effects.takeLatest)('GET_CONTRACT_DETAILS', populateEditDialog), (0, _effects.takeLatest)('GET_CONTRACT_LEFT_NAV', afterGettingMetaData), (0, _effects.takeLatest)('[contract-list]UPDATE_SEARCH_PARAMS', triggerLoadContractList), // trigger
(0, _effects.takeLatest)('[contracting]SELECTED_YEAR_FOR_CONTRACTING', triggerLoadContractList), // trigger
(0, _effects.takeLatest)('[contract-list]RESET_SEARCH_PARAMS', triggerLoadContractList), // trigger
(0, _effects.takeLatest)('MASS_ASSIGN_FOLDER_CONTRACT_LIST', triggerLoadContractList), // trigger
(0, _effects.takeLatest)('MASS_DELETE_RESTORE_CONTRACT_LIST', triggerLoadContractList), // trigger
(0, _effects.takeLatest)('[contract-list] MASS_ARCHIVE_OR_RESTORE', triggerLoadContractList), // trigger
(0, _effects.takeLatest)('[contract-list]UPDATE_FOLDER_NAME', doUpdateFolders), (0, _effects.takeLatest)('[contract-list]CHANGE_ROUTE', doChangeContractListRoute), (0, _effects.takeLatest)('LOAD_CONTRACT_LIST_FROM_BACKEND', getContractList), (0, _effects.takeLatest)('[contracting-download]DOWLOAD_CONTRACTING_DOCS', downloadContractingDocs), (0, _effects.takeEvery)('[contracting-download] downloadGroup_SUCCESS', downloadContractingDocsSuccess), (0, _effects.takeEvery)('[contracting-download] downloadGroup_SUCCESS_SUCCESS', downloadContractingUrl), (0, _effects.takeLatest)('[contracting-download]ACCEPT_RATES', acceptRatesAfterDownload), (0, _effects.takeLatest)('[contracting-download]DOWNLOAD_SINGLE_CONTRACT_DOC_SUCCESS', shouldAskToAccept), (0, _effects.takeLatest)('[contracting-download]BULK_DOWNLOAD_SUCCESS', shouldAskToAccept), (0, _effects.takeLatest)('[contracting-download]downloadGroup_SUCCESS_SUCCESS', shouldAskToAccept), (0, _effects.takeLatest)('[contracting-download]EXPORT_EXCEL', exportExcel), (0, _effects.takeEvery)('[contracting-download]EXPORT_EXCEL_SUCCESS', handleExportExcel), (0, _effects.takeEvery)('[contracting-download]EXPORT_EXCEL_ERROR', handleExportExcelError), (0, _effects.takeLatest)('ARCHIVE_UNARCHIVE_TEMPLATE', handleArchiveUnarchiveTemplate), (0, _effects.takeLatest)('UPDATE_CONTRACT_PARTNER_INFO', updateContractRequestPartner), (0, _effects.takeLatest)('UPDATE_CONTRACT_PARTNER_INFO_SUCCESS', afterUpdateContractPartnerInfoSuccess), // trigger
(0, _effects.takeLatest)('SUBMIT_CONTRACTING_COMMENT', submitContractingComment), (0, _effects.takeEvery)(conListConst.GET_CONTRACT_EMAIL, getContractForwardingEmail), (0, _effects.takeLatest)('GET_CONTRACTING_DIFF_REPORT', getDiffReport), (0, _effects.takeLatest)('GET_AVAIL_DOCS_FOR_DIFF_REPORTS', getAvailDocsForDiffReport), (0, _effects.takeLatest)('SEND_UPDATES_IN_PUBLISH_DRAFT_DIALOG', getDiffReportForDraft), (0, _effects.takeLatest)('TOGGLE_SHOW_DRAFT_CHANGES_POPOVER', getDiffReportForViewChanges), (0, _effects.takeLatest)(cnt.REVIEW_MY_RATES_DRAFT, doSendReviewRatesEmail), (0, _effects.takeLatest)('GET_SUPPLIER_LOCATIONS_LIST_IN_TEMPLATE_LIST', updateTemplateListUrl), (0, _effects.takeLatest)(cnt.MANAGE_EXTRAS_OFFERS, manageExtrasOffers), (0, _effects.takeLatest)(cnt.MANAGE_EXTRAS_OFFERS + '_SUCCESS', function () {
  return refreshContractDoc({ bgRefresh: true });
}), (0, _effects.takeLatest)('CONTRACT_PRODUCT_UPDATED', function () {
  return refreshContractDoc({ bgRefresh: true });
}), (0, _effects.takeLatest)(cnt.UPDATE_SAME_AS_CORPORATE_POLICY_NOTES, updateSameAsCorporate), (0, _effects.takeLatest)(cnt.UPDATE_SAME_AS_CORPORATE_POLICY_NOTES + '_SUCCESS', refreshContractDoc), (0, _effects.takeLatest)(cnt.REMOVE_MASTER_TEMPLATE, removeMasterTemplate), (0, _effects.takeLatest)(cnt.REMOVE_MASTER_TEMPLATE + '_SUCCESS', refreshContractDoc), (0, _effects.takeLatest)(cnt.REMOVE_DRAFT_FROM_QUEUE + '_SUCCESS', afterRemoveDraftFromQueue), (0, _effects.takeLatest)(cnt.ADD_DRAFT_TO_QUEUE + '_SUCCESS', refreshContractDoc), (0, _effects.takeLatest)('UPDATE_CONTRACT_PARTNER_INFO_SUCCESS', refreshContractDoc), (0, _effects.takeLatest)('RESEND_CONTRACT_FINISHED', refreshContractDoc), (0, _effects.takeLatest)(cnt.SEND_UPDATES_FROM_QUEUE + '_SUCCESS', refreshTemplateList), (0, _effects.takeLatest)(cnt.SEND_TOURWRITER, sendTourWriter), (0, _effects.takeEvery)(cnt.SEND_TOURWRITER + '_SUCCESS', handleExportExcel), (0, _effects.takeEvery)(cnt.SEND_TOURWRITER + '_STARTED', tourWriterStart), (0, _effects.takeEvery)(cnt.SEND_TOURWRITER + '_ERROR', tourWriterError), (0, _effects.takeLatest)(cnt.REMOVE_SINGLE_FEED_BY_TC_ADMIN, removeSingleFeedByTCAdmin), (0, _effects.takeLatest)(wpCnts.MESSAGE_CREATE + '_SUCCESS', getContractNotes), (0, _effects.takeLatest)('GET_HISTORY_FEEDS', markHistoryFeedAsRead), (0, _effects.takeLatest)('@@router/LOCATION_CHANGE', onRouteChange), (0, _effects.takeLatest)(cnt.FILE_CONTRACT_FOR_REQUEST, fileContractForRequest), (0, _effects.takeLatest)(cnt.FILE_CONTRACT_FOR_REQUEST + '_SUCCESS', fileContractForRequestSuccess), (0, _effects.takeLatest)(cnt.REMOVE_CONTRACT_FROM_REQUEST, removeContractsFromRequests), (0, _effects.takeLatest)(cnt.REMOVE_CONTRACT_FROM_REQUEST + '_SUCCESS', removeContractsFromRequestsSuccess), (0, _effects.takeLatest)('SEARCH_CC_RATES_TEMPLATES', searchCCTemplates), (0, _effects.takeLatest)('LOAD_PRODUCTS_FOR_OMNI_IMPORT_SOURCE_TEMPLATE', getProductsForOmniImport), (0, _effects.takeLatest)('OMNI_IMPORT', doOmniImport), (0, _effects.takeLatest)('OMNI_IMPORT_SUCCESS', importSuccess), (0, _effects.takeLatest)('IMPORT_DATA_FROM_ANOTHER_TEMPLATE_SUCCESS', importSuccess), (0, _effects.takeLatest)('CHANGE_RESEND_CONTRACT_DIALOG_STATE', handleOpenReSendContractDialog), (0, _effects.takeLatest)('SAVED_TEMPLATE_AFTER_DRAFT_PUBLISHED', handleAfterMadeACopyOfATemplate), (0, _effects.takeLatest)('{dummy_account} makeACopyForBuyer', makeACopyForBuyer), (0, _effects.takeLatest)('REQUEST_DL', requestDL), (0, _effects.takeLatest)('REQUEST_DL_SUCCESS', afterRequestDLSuccess), (0, _effects.takeLatest)('[contract] UPDATE_CONTRACT_ASSIGNEE', updateWorkspaceContract), (0, _effects.takeLatest)('[contract] UPDATE_CONTRACT_ASSIGNEE_SUCCESS', afterRequestDLSuccess), (0, _effects.takeLatest)('{draft}EDIT_PRODUCT_PROFILE_INFO', editProductProfile), (0, _effects.takeLatest)('{draft}EDIT_PRODUCT_PROFILE_INFO_SUCCESS', editProductProfileSuccess), (0, _effects.takeLatest)('{contract} DELETE_CONTRACT_NOTE', deleteContractNote), (0, _effects.takeLatest)(['{contract} DELETE_CONTRACT_NOTE_SUCCESS', cnt.GET_NOTES], getContractNotes)];

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function round(fn, val, precision) {
	if (typeof val !== 'number') {
		throw new TypeError('Expected value to be a number');
	}

	if (!Number.isInteger(precision)) {
		throw new TypeError('Expected precision to be an integer');
	}

	var exponent = precision > 0 ? 'e' : 'e-';
	var exponentNeg = precision > 0 ? 'e-' : 'e';
	precision = Math.abs(precision);

	if (fn === 'round') {
		return Number(Math.sign(val) * (Math.round(Math.abs(val) + exponent + precision) + exponentNeg + precision));
	}

	return Number(Math[fn](val + exponent + precision) + exponentNeg + precision);
}

module.exports = round.bind(null, 'round');
module.exports.up = round.bind(null, 'ceil');
module.exports.down = round.bind(null, 'floor');

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upgradeResetAndClose = exports.openUpgradeFrom = exports.closeUpgrade = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _upgradeConstants = __webpack_require__(1048);

var constants = _interopRequireWildcard(_upgradeConstants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var openUpgrade = function openUpgrade() {
  return {
    type: constants.OPEN
  };
};

var closeUpgrade = exports.closeUpgrade = function closeUpgrade() {
  return {
    type: constants.CLOSE
  };
};

var resetUpgrade = function resetUpgrade() {
  return {
    type: constants.RESET
  };
};

var syncUpgrade = function syncUpgrade() {
  return {
    type: constants.SYNC
  };
};

var openUpgradeFrom = exports.openUpgradeFrom = function openUpgradeFrom(from, obj) {
  return function (dispatch, getState) {
    var partnerFinder = getState().partnerFinder.toJS();

    var _ref = function () {
      if (from === 'profileViews') {
        return {
          type: constants.WHO_VIEW_MY_PROFILE,
          nameForIntercom: '[Profile]Who viewed my profile',
          eventAction: 'Click from profile views',
          payload: {}
        };
      }
      if (from === 'pfListConnectBtn') {
        return {
          type: constants.PARTNER_FINDER_CONNECT,
          nameForIntercom: '[Partner Finder] Upgrade Button Click',
          eventAction: 'Click from PF',
          payload: {
            clickedCompany: obj.clickedCompany,
            searchCountry: _ramda2.default.path(['searchParams', 'destinationsSold', 0], partnerFinder),
            searchResults: partnerFinder.total || 0
          }
        };
      }
      if (from === 'profileConnectBtn') {
        return {
          nameForIntercom: '[Profile] Upgrade to Connect',
          eventAction: 'Click from profile connect Btn',
          payload: {}
        };
      }
      if (from === 'contractListSentFilters') {
        return {
          type: constants.CONTRACT_LIST_SENT_TRACKING,
          nameForIntercom: '[Contract List] Upgrade to Filter Sent Filters',
          eventAction: 'Click from contract list sent filters',
          payload: {}
        };
      }
      if (from === 'contractListSentStatus') {
        return {
          type: constants.CONTRACT_LIST_SENT_TRACKING,
          nameForIntercom: '[Contract List] Upgrade to See Email Tracking',
          eventAction: 'Click from contract list sent icon',
          payload: {}
        };
      }
      if (from === 'contractListBounced') {
        return {
          type: constants.CONTRACTING_BOUNCED,
          nameForIntercom: '[Contract List] Upgrade to See who bounced',
          eventAction: 'Click from contract list Outbox',
          payload: {}
        };
      }
      if (from === 'downloadContractingReportBtn') {
        return {
          type: constants.CONTRACTING_REPORTS,
          nameForIntercom: '[Contract Reports] Upgrade to download contracting reports',
          eventAction: 'Click from contracting report download',
          payload: {}
        };
      }
      if (from === 'contractListBulkActions') {
        return {
          type: constants.CONTRACT_LIST_BULK_ACTIONS,
          nameForIntercom: '[Contract Reports] Upgrade to bulk action',
          eventAction: 'Click from contract list bulk action',
          eventValue: obj.bulkAction,
          payload: {
            bulkAction: obj.bulkAction // accept, reject, download, load, folders, trash
          }
        };
      }
      if (from === 'ratesOnlyPDF') {
        return {
          type: '',
          nameForIntercom: '[Contract PDF Download] Upgrade to download rates-only version',
          eventAction: 'Click from rates-only PDF download'
        };
      }
      if (from === 'massMessaging') {
        return {
          type: '',
          nameForIntercom: '[Mass Messaging] Upgrade to add more destinations',
          eventAction: 'Click from adding more destinations'
        };
      }
      return {};
    }(),
        type = _ref.type,
        nameForIntercom = _ref.nameForIntercom,
        eventAction = _ref.eventAction,
        eventValue = _ref.eventValue,
        payload = _ref.payload;

    dispatch({
      type: 'TRACK_EVENT',
      payload: {
        name: nameForIntercom,
        ga: {
          hitType: 'event',
          eventCategory: 'upgrade point click',
          eventAction: eventAction,
          eventValue: eventValue,
          eventLabel: getState().user.toJS().company.companyName + ' - ' + getState().user.toJS().user.name
        }
      }
    });

    return dispatch({ type: constants.REASON, payload: _extends({}, payload, { upgradeReason: type }) }).then(dispatch(openUpgrade()));
  };
};

var upgradeResetAndClose = exports.upgradeResetAndClose = function upgradeResetAndClose() {
  return function (dispatch) {
    dispatch(resetUpgrade());
    dispatch(closeUpgrade());
  };
};

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5f363f11047168d126b14465a2703e21.svg";

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _stripDiacritics = __webpack_require__(614);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function filterOptions(options, filterValue, excludeOptions, props) {
	var _this = this;

	if (props.ignoreAccents) {
		filterValue = (0, _stripDiacritics2['default'])(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
		if (!filterValue) return true;
		var valueTest = String(option[props.valueKey]);
		var labelTest = String(option[props.labelKey]);
		if (props.ignoreAccents) {
			if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2['default'])(valueTest);
			if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2['default'])(labelTest);
		}
		if (props.ignoreCase) {
			if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}
		return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
}

module.exports = filterOptions;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

module.exports = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _classnames = __webpack_require__(249);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption;
	var instancePrefix = _ref.instancePrefix;
	var labelKey = _ref.labelKey;
	var onFocus = _ref.onFocus;
	var onSelect = _ref.onSelect;
	var optionClassName = _ref.optionClassName;
	var optionComponent = _ref.optionComponent;
	var optionRenderer = _ref.optionRenderer;
	var options = _ref.options;
	var valueArray = _ref.valueArray;
	var valueKey = _ref.valueKey;
	var onOptionRef = _ref.onOptionRef;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.indexOf(option) > -1;
		var isFocused = option === focusedOption;
		var optionClass = (0, _classnames2['default'])(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return _react2['default'].createElement(
			Option,
			{
				className: optionClass,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function (ref) {
					onOptionRef(ref, isFocused);
				}
			},
			optionRenderer(option, i)
		);
	});
}

module.exports = menuRenderer;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyDataFromAnotherProduct = exports.saveAsANewTemplate = exports.saveProductInfoChanges = exports.syncProductInfo = exports.saveProductsToContract = exports.manageRatePackage = exports.saveSupplierInfoChanges = exports.publishDraft = exports.saveBillingInfoChanges = exports.updateBuyerInfo = exports.deleteInsFile = exports.updatePropsInResendContractReducer = exports.resendContractActions = exports.publishDraftDialogActions = exports.addEditContractDialogActions = exports.openOrCloseDialogsActions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.importContractFromTemplate = importContractFromTemplate;

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _s3ContractingFilesUpload = __webpack_require__(1534);

var _s3ContractingFilesUpload2 = _interopRequireDefault(_s3ContractingFilesUpload);

var _editProduct = __webpack_require__(3218);

var _editProduct2 = _interopRequireDefault(_editProduct);

var _editContractDetails = __webpack_require__(866);

var _editContractDetails2 = _interopRequireDefault(_editContractDetails);

var _contractActivitiesProductsActions = __webpack_require__(493);

var _http = __webpack_require__(118);

var _api = __webpack_require__(37);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _accessCheckHelperFns = __webpack_require__(631);

var _reactRouterRedux = __webpack_require__(27);

var _contractingUtils = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var openOrCloseDialogsActions = exports.openOrCloseDialogsActions = {
  freeContractDialog: 'CLOSE_FREE_CONTRACT_DIALOG'
};

var addEditContractDialogActions = exports.addEditContractDialogActions = {
  openAddEditContractDialog: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
  closeAddEditContractDialog: 'CLOSE_ADD_EDIT_CONTRACT_DIALOG',
  removeInsFile: 'REMOVE_INSURANCE_FILE'
};

var publishDraftDialogActions = exports.publishDraftDialogActions = {
  closePublishDraftDialog: 'CLOSE_PUBLISH_DRAFT_DIALOG',
  onTextFieldChangePublishDraftDialog: 'ON_TEXTFIELD_CHANGE_PUBLISH_DRAFT_DIALOG',
  notEnoughFreeContracts: 'NOT_ENOUGH_FREE_CONTRACTS',
  onBCCSelfCheck: 'ON_BCC_SELF_CHECK',
  includeNotesCheck: 'INCLUDE_NOTES_CHECK',
  includeMultiLocNotesCheck: 'INCLUDE_MULTI_LOC_NOTES_CHECK',
  includeGeneralNoteCheck: 'INCLUDE_GENERAL_NOTE_CHECK'
};

var resendContractActions = exports.resendContractActions = {
  closeResendContractDialog: 'CLOSE_RESEND_CONTRACT_DIALOG',
  onBCCSelfCheck: 'ON_BCC_SELF_CHECK'
};
var updatePropsInResendContractReducer = exports.updatePropsInResendContractReducer = function updatePropsInResendContractReducer(payload) {
  return {
    type: 'UPDATE_PROPS_RESEND_CONTRACT_REDUCER',
    payload: payload
  };
};

var deleteInsFile = exports.deleteInsFile = function deleteInsFile(payload) {
  return function (dispatch, getState) {
    var draftId = getState().contracting.contractActivitiesProducts.getIn(['leftNav', 'contractId']);
    return fetch('/proxy/contracting/deleteInsFile', {
      method: 'delete',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(_ramda2.default.merge(payload, { draftId: draftId }))
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      return dispatch({ type: 'REMOVE_INSURANCE_FILE', payload: payload });
    });
  };
};

var updateBuyerInfo = exports.updateBuyerInfo = function updateBuyerInfo(payload) {
  return function (dispatch) {
    var url = '/proxy/contracting/contract/buyer';
    dispatch({ type: 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG' });
    return (0, _http.put)(url, payload).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (_ref) {
      var contractId = _ref.contractId;

      if (contractId === payload.contractId) dispatch({ type: 'UPDATE_BUYER_INFO', payload: payload });else window.location = window.location.protocol + '//' + window.location.host + '/contracting/contract/' + contractId + '/details';
    }).catch(function () {
      return dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Update Failed.' });
    });
  };
};

var saveBillingInfoChanges = exports.saveBillingInfoChanges = function saveBillingInfoChanges(payload) {
  return function (dispatch, getState) {
    var insuranceFiles = _ramda2.default.pathOr([], ['data', 'insuranceFiles'], payload);
    payload.data.insuranceFiles = _ramda2.default.pathOr([], ['data', 'insuranceFiles'], payload).map(function (_ref2) {
      var downloadUrl = _ref2.downloadUrl,
          fileName = _ref2.fileName,
          _id = _ref2._id,
          name = _ref2.name,
          type = _ref2.type;
      return { downloadUrl: downloadUrl, fileName: fileName, _id: _id, name: name, type: type };
    });
    payload.sameAsCorporatePolicyNotes = (getState().contracting.contractActivitiesProducts.get('rightSideContent').toJS().sameAsCorporatePolicyNotes || []).filter(function (str) {
      return str !== payload.type;
    });
    dispatch({ type: 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG' });
    return (0, _http.put)('/proxy/contracting/contract/billing', payload).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (_ref3) {
      var files = _ref3.files,
          errors = _ref3.errors;

      var fileMap = insuranceFiles.length ? insuranceFiles.reduce(function (map, file) {
        return _extends({}, map, _defineProperty({}, file.name || file.fileName, file));
      }, {}) : [];
      Promise.all(files.length ? files.filter(_ramda2.default.prop('signedUrl')).map(function (_ref4) {
        var fileName = _ref4.fileName,
            signedUrl = _ref4.signedUrl,
            downloadUrl = _ref4.downloadUrl;
        return _s3ContractingFilesUpload2.default.uploadToS3(fileMap[fileName], signedUrl, downloadUrl, fileName);
      }) : []);
      return dispatch({ type: 'SAVE_BILLING_INFO_ADD_EDIT', payload: _ramda2.default.merge(payload, { errors: errors }) });
    });
  };
};

var publishDraft = exports.publishDraft = function publishDraft(payload) {
  return function (dispatch, getState) {
    var goToSend = payload.goToSend;

    var _getState$contracting = getState().contracting.contractActivitiesProducts.get('leftNav').toJS(),
        contractId = _getState$contracting.contractId,
        locationId = _getState$contracting.locationId,
        draftType = _getState$contracting.draftType,
        originFrom = _getState$contracting.originFrom,
        editHistory = _getState$contracting.editHistory,
        productsArray = _getState$contracting.productsArray,
        startDate = _getState$contracting.startDate,
        endDate = _getState$contracting.endDate,
        diffSummary = _getState$contracting.diffSummary,
        createdAt = _getState$contracting.createdAt;

    var _getState$contracting2 = getState().contracting.publishDraftDialog.toJS(),
        sendUpdatesSubject = _getState$contracting2.sendUpdatesSubject,
        doNotIssueUpdate = _getState$contracting2.doNotIssueUpdate,
        sendUpdatesMessage = _getState$contracting2.sendUpdatesMessage;

    var readOnly = !(0, _accessCheckHelperFns.checkLocAccess)(getState(), locationId, 'contracting', 'write');
    if (readOnly) return dispatch((0, _accessCheckHelperFns.triggerNoAccessWarning)({ featureName: 'contracting' }));

    dispatch({ type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG', payload: { publishingDraft: true } });

    return (0, _http.put)('/proxy/contracting/draft/publish/' + contractId, {
      draftType: draftType,
      message: sendUpdatesMessage,
      originFrom: originFrom,
      subject: sendUpdatesSubject,
      editHistory: (0, _contractingUtils.processEditHistories)(editHistory, productsArray),
      startDate: startDate,
      endDate: endDate,
      doNotIssueUpdate: doNotIssueUpdate,
      diffSummary: diffSummary
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      dispatch({
        type: 'PUBLISH_TEMPLATE_DRAFT_SUCCESS',
        payload: {
          originFrom: originFrom
        }
      });
      return res.json();
    }).then(function (publishedContract) {
      if (publishedContract && publishedContract.id) {
        if (goToSend) {
          dispatch((0, _reactRouterRedux.replace)('/contracting/template/' + publishedContract.id + '/partners'));
        } else dispatch((0, _reactRouterRedux.replace)('/contracting/' + (draftType === 'template' || originFrom !== 'edited' ? 'template' : 'contract') + '/' + publishedContract.id + '/details'));
      }
    }).catch(function (err) {
      console.log(err.stack);
      dispatch({ type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG', payload: { publishingDraft: false } });
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Publish Draft Failed' });
    });
  };
};

var saveSupplierInfoChanges = exports.saveSupplierInfoChanges = function saveSupplierInfoChanges(payload) {
  return function (dispatch, getState) {
    var initialContractDetails = getState().contracting.contractActivitiesProducts.get('rightSideContent');
    dispatch({ type: 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG' });
    var newContractDetailsAndEditHistory = (0, _editContractDetails2.default)(initialContractDetails, payload);
    var newPayload = {
      contractId: payload.contractId,
      collection: window.location.pathname.indexOf('/workspace/') > -1 ? 'workspace' : 'draft',
      contractDetails: newContractDetailsAndEditHistory.contractDetails.toJS(),
      editHistory: newContractDetailsAndEditHistory.editHistory
    };
    return (0, _http.put)('/proxy/contracting/contract/supplier', newPayload).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({ type: 'CONTRACT_SUPPLIER_DETAIL_UPDATED', payload: _ramda2.default.merge(newPayload, { errors: res.errors }) });
    }).catch(function (err) {
      console.log(err.stack);
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Saving changes failed' });
    });
  };
};

var manageRatePackage = exports.manageRatePackage = function manageRatePackage(contractId, productId, data) {
  return function (dispatch, getState) {
    dispatch({ type: '[contract-product]CREATE_RATE_PACKAGE_START' });
    return (0, _api.callApiJWT)('/contracting/contract/product/ratepackage', 'post', _extends({}, data, { contractId: contractId, productId: productId })).then(function (_ref5) {
      var res = _ref5.response;

      dispatch((0, _contractActivitiesProductsActions.getContractLeftNav)('draft', contractId));
      /*
      res = { errors: errorChecking(newDraft), contractId, newRatePackage }
       */
      return dispatch({
        type: '[contract-product]CREATE_RATE_PACKAGE_SUCCESS',
        payload: res
      });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'create rate package failed' });
    });
  };
};

var saveProductsToContract = exports.saveProductsToContract = function saveProductsToContract(contractId, locationId, products) {
  return function (dispatch, getState) {
    dispatch({ type: 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG' });
    var composedUrl = '/proxy/contracting/saveProductsToContract';
    return (0, _http.put)(composedUrl, {
      contractId: contractId,
      locationId: locationId,
      products: products
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch((0, _contractActivitiesProductsActions.getContractLeftNav)('draft', contractId));
      return dispatch({ type: 'PRODUCTS_SAVED_UPDATE_REDUX', payload: { contractId: contractId, errors: res.errors, firstProduct: _ramda2.default.pathOr({}, ['products', 0], res) } });
    }).catch(function (err) {
      return console.log(err);
    });
  };
};

var syncProductInfo = exports.syncProductInfo = function syncProductInfo(payload) {
  return function (dispatch, getState) {
    dispatch({
      type: 'ON_CHECK_SYNC_SECTION_IN_CONTRACT_TEMPLATE_DRAFT',
      payload: {
        sectionInEdit: payload.sectionInEdit,
        checked: typeof payload.syncSection === 'boolean' ? payload.syncSection : true
      }
    });
    var newPayload = {
      contractId: payload.contractId,
      productId: payload.productId,
      syncSection: typeof payload.syncSection === 'boolean' ? payload.syncSection : true,
      syncRatesToo: payload.syncRatesToo,
      sectionInEdit: payload.sectionInEdit,
      product: getState().contracting.contractActivitiesProducts.get('rightSideContent')
    };
    return (0, _api.callApiJWT)('/contracting/contract/product', 'put', newPayload).catch(function (err) {
      console.log(err.stack);
      return dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Syncing product failed' });
    });
  };
};

var saveProductInfoChanges = exports.saveProductInfoChanges = function saveProductInfoChanges(payload) {
  return function (dispatch, getState) {
    var syncedSectionsImmutable = getState().contracting.contractActivitiesProducts.getIn(['leftNav', 'syncedSections']);
    var initialProduct = getState().contracting.contractActivitiesProducts.get('rightSideContent');
    dispatch({ type: 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG' });
    var newProductAndEditHistory = (0, _editProduct2.default)(initialProduct, payload);
    var sectionInEdit = newProductAndEditHistory.section;
    var syncSection = syncedSectionsImmutable ? _ramda2.default.contains(sectionInEdit, syncedSectionsImmutable.toJS()) : false;
    var newPayload = {
      contractId: payload.contractId,
      productId: payload.productId,
      syncSection: syncSection,
      sectionInEdit: sectionInEdit,
      hash: newProductAndEditHistory.hash,
      product: newProductAndEditHistory.product.toJS(),
      editHistory: _extends({}, newProductAndEditHistory.editHistory, {
        productId: payload.productId,
        contractId: payload.contractId,
        ratePackageName: initialProduct.get('ratePackageName')
      })
    };
    return (0, _api.callApiJWT)('/contracting/contract/product', 'put', newPayload).then(function (_ref6) {
      var res = _ref6.response;

      dispatch({ type: 'CONTRACT_PRODUCT_UPDATED', payload: (0, _ramda.merge)(newPayload, { product: res.product, errors: res.errors }) });
    }).catch(function (err) {
      console.log(err.stack);
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Saving product changes failed' });
    });
  };
};

var savedOrHandleDuplicates = function savedOrHandleDuplicates(dispatch) {
  return (0, _ramda.ifElse)((0, _ramda.prop)('duplicateExists'), function () {
    return dispatch({ type: 'SAVING_NEW_TEMPLATE_FAILED_BECAUSE_DUPLICATES' });
  }, function (payload) {
    return dispatch({ type: 'SAVED_TEMPLATE_AFTER_DRAFT_PUBLISHED', payload: payload });
  });
};

var saveAsANewTemplate = exports.saveAsANewTemplate = function saveAsANewTemplate(payload) {
  return function (dispatch) {
    dispatch({ type: 'SAVING_TEMPLATE_AFTER_DRAFT_PUBLISHED' });
    return (0, _http.put)('/proxy/contracting/saveAsANewTemplate', payload).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(savedOrHandleDuplicates(dispatch)).catch(function () {
      return dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Saving new template failed' });
    });
  };
};

var copyDataFromAnotherProduct = exports.copyDataFromAnotherProduct = function copyDataFromAnotherProduct(payload) {
  return function (dispatch, getState) {
    dispatch({ type: 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG' });
    var _getState$contracting3 = getState().contracting.contractActivitiesProducts.toJS().rightSideContent,
        productId = _getState$contracting3.productId,
        ratePackage = _getState$contracting3.ratePackageName;

    return (0, _http.put)('/proxy/contracting/copyContractDataFromAnotherProduct', payload).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      dispatch({ type: 'DATA_FROM_ANOTHER_PRODUCT_IS_COPIED', payload: response });
      dispatch((0, _contractActivitiesProductsActions.reloadContentInBg)({
        collection: 'draft',
        contractId: payload.contractId,
        productId: productId,
        ratePackage: ratePackage || 'Primary'
      }));
    }).catch(function (err) {
      var selectedSeasonRates = (0, _ramda.call)((0, _ramda.compose)((0, _ramda.contains)('seasonRates'), (0, _ramda.propOr)([], 'dataFieldsToImport')), payload);
      var seasonError = err.message === 'Bad Request' && selectedSeasonRates;
      return dispatch({
        type: 'COPY_DATA_FROM_ANOTHER_PRODUCT_IN_CONTRACT_IS_FAILED',
        payload: {
          error: seasonError ? 'Please make sure this product has the same number of seasons as the product you intended to copy from.' : 'An error occurred. Please try again or contact our customer support.' }
      });
    });
  };
};

function importContractFromTemplate(payload) {
  return function (dispatch) {
    return (0, _http.put)('/proxy/contracting/importContractFromTemplate', payload).then(function () {
      return dispatch({ type: 'IMPORT_DATA_FROM_ANOTHER_TEMPLATE_SUCCESS' });
    }).catch(function () {
      return dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Import data failed.' });
    });
  };
}
exports.default = _extends({}, addEditContractDialogActions, openOrCloseDialogsActions, publishDraftDialogActions, resendContractActions);

/***/ }),
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_USER_LOCATION_PROFILE = exports.GET_USER_LOCATION_PROFILE = 'GET_USER_LOCATION_PROFILE';
var GET_USER_LOCATION_PROFILE_FAILED = exports.GET_USER_LOCATION_PROFILE_FAILED = 'GET_USER_LOCATION_PROFILE_FAILED';
var EDIT_USER_LOCATION_PROFILE_FIELD_STARTING = exports.EDIT_USER_LOCATION_PROFILE_FIELD_STARTING = 'EDIT_USER_LOCATION_PROFILE_FIELD_STARTING';
var EDIT_USER_LOCATION_PROFILE_FIELD = exports.EDIT_USER_LOCATION_PROFILE_FIELD = 'EDIT_USER_LOCATION_PROFILE_FIELD';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';
var CLEAR_USER_LOCATION_STORE = exports.CLEAR_USER_LOCATION_STORE = 'CLEAR_USER_LOCATION_STORE';
var REMOVE_PRODUCT = exports.REMOVE_PRODUCT = 'REMOVE_PRODUCT_FROM_PROFILE';
var REMOVE_PRODUCT_FAILED = exports.REMOVE_PRODUCT_FAILED = 'REMOVE_PRODUCT_FAILED';
var ADD_PRODUCT = exports.ADD_PRODUCT = 'ADD_PRODUCT';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';
var PROFILE_IMAGE_CHANGED = exports.PROFILE_IMAGE_CHANGED = 'PROFILE_IMAGE_CHANGED';
var DELETE_COVER_IMAGE_FROM_LOCATION = exports.DELETE_COVER_IMAGE_FROM_LOCATION = 'DELETE_COVER_IMAGE_FROM_LOCATION';
var IMPORTING_PROD = exports.IMPORTING_PROD = 'IMPORTING_PROD';
var FINISHED_IMPORTING_PROD = exports.FINISHED_IMPORTING_PROD = '{profile}FINISHED_IMPORTING_PROD';

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var prefixA = '{create-master-template}';

var INIT = exports.INIT = prefixA + ' INIT';
var CREATE = exports.CREATE = prefixA + ' CREATE';
var TYPE_NAME = exports.TYPE_NAME = prefixA + ' TYPE_NAME';

var prefixB = 'master-template-list';
var GET_LIST = exports.GET_LIST = prefixB + ' GET_LIST';
var UPDATE_TEMPLATE_PROPS = exports.UPDATE_TEMPLATE_PROPS = prefixB + ' UPDATE_TEMPLATE_PROPS';
var GET_ASSOCIATED_TEMPLATES = exports.GET_ASSOCIATED_TEMPLATES = prefixB + ' GET_ASSOCIATED_TEMPLATES';
var DELETE_TEMPLATE = exports.DELETE_TEMPLATE = prefixB + ' DELETE TEMPLATE';
var RENAME_TEMPLATE = exports.RENAME_TEMPLATE = prefixB + ' RENAME_TEMPLATE';

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkCorporateAccess = exports.checkLocAccess = exports.getFeatureAccess = exports.triggerNoAccessWarning = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _globalErrorsDisplayActions = __webpack_require__(486);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var triggerNoAccessWarning = exports.triggerNoAccessWarning = function triggerNoAccessWarning(additionalPayload) {
  return (0, _globalErrorsDisplayActions.triggerError)(_extends({ noAccessDialog: true }, additionalPayload));
};

var getFeatureAccess = exports.getFeatureAccess = function getFeatureAccess(state, locId, featureName) {
  var user = state.user;

  var locAccess = user.toJS ? user.toJS().locAccess : user.locAccess;
  var companyType = user.toJS ? user.toJS().user.type : user.user.type;
  var email = user.toJS ? user.toJS().user.email : user.user.email;
  var corporateContractingAccess = user.toJS ? user.toJS().corporateContractingAccess : user.corporateContractingAccess;
  var corporateAdminAccess = user.toJS ? user.toJS().corporateAdminAccess : user.corporateAdminAccess;
  if (locId && companyType === 'Supplier' && email.indexOf('dl+') === -1) {
    var accessForLoc = _ramda2.default.find(_ramda2.default.propEq('locId', locId), locAccess);
    return _ramda2.default.propOr([], featureName, accessForLoc);
  }
  if (featureName === 'contracting') return _ramda2.default.chain(_ramda2.default.prop(featureName), locAccess).concat(corporateContractingAccess);
  if (featureName === 'admin') return _ramda2.default.chain(_ramda2.default.prop('admin'), locAccess).concat(corporateAdminAccess);
  return _ramda2.default.chain(_ramda2.default.prop(featureName), locAccess);
};

var checkLocAccess = exports.checkLocAccess = function checkLocAccess(state, locId, featureName, access) {
  var featureAccess = getFeatureAccess(state, locId, featureName);
  return featureAccess && _ramda2.default.contains(access, featureAccess);
};

// export const checkCorporateAccess = (state, featureName, access) => {
//   const { user } = state;
//   const corporateAccess = user.toJS ? user.toJS().corporateAccess : user.corporateAccess;
//   return corporateAccess[featureName] && R.contains(access, corporateAccess[featureName]);
// };

var checkCorporateAccess = exports.checkCorporateAccess = function checkCorporateAccess(state) {
  var user = state.user;

  var corporateAccess = user.toJS ? user.toJS().corporateAccess : user.corporateAccess;
  return !isNilOrEmpty(corporateAccess);
};

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _nonAccommodation_rate_table = __webpack_require__(3286);

var _nonAccommodation_rate_table2 = _interopRequireDefault(_nonAccommodation_rate_table);

var _accommodation_rate_table = __webpack_require__(3293);

var _accommodation_rate_table2 = _interopRequireDefault(_accommodation_rate_table);

var _contractingPresetNamesCodes = __webpack_require__(464);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var RateTableTemplateContainer = function RateTableTemplateContainer(props) {
  var productType = props.productType,
      rateSet = props.rateSet,
      updateTableCell = props.updateTableCell,
      showHeader = props.showHeader,
      withEditableCell = props.withEditableCell,
      forOffer = props.forOffer,
      supplierEditable = props.supplierEditable,
      onEdit = props.onEdit,
      contractState = props.contractState,
      classes = props.classes,
      addRateDetails = props.addRateDetails,
      deleteFromProduct = props.deleteFromProduct;

  var RateTemplate = productType === 'Non-Accommodation' ? _nonAccommodation_rate_table2.default : _accommodation_rate_table2.default;
  var isApartmentRate = rateSet.rates.some(function (r) {
    return r.description.indexOf('Guest') > -1;
  });
  var isPriceBreak = rateSet.nonStandardTemplateType === 'priceBreak';
  var isprivateTransfer = rateSet.nonStandardTemplateType === 'privateTransfer';
  var missingPresetDescrs = function () {
    if (isPriceBreak || isprivateTransfer || isApartmentRate) return [];
    if (productType === 'Accommodation') {
      return _contractingPresetNamesCodes.standardAccomDescr.filter(function (d) {
        return rateSet.rates.every(function (r) {
          return r.description !== d;
        });
      });
    }
    if (rateSet.nonStandardTemplateType === 'multiDayTour') {
      return _contractingPresetNamesCodes.multiDayTourDescrs.filter(function (d) {
        return rateSet.rates.every(function (r) {
          return r.description !== d;
        });
      });
    }
    return _contractingPresetNamesCodes.standardNonAccomDescrs.filter(function (d) {
      return rateSet.rates.every(function (r) {
        return r.description !== d;
      });
    });
  }();
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(RateTemplate, {
      showHeader: showHeader,
      rateSet: rateSet,
      withEditableCell: withEditableCell,
      updateTableCell: updateTableCell,
      forOffer: forOffer,
      supplierEditable: supplierEditable,
      onEdit: onEdit,
      contractState: contractState,
      classes: classes,
      deleteFromProduct: deleteFromProduct
    }),
    Boolean(withEditableCell && (missingPresetDescrs.length || isApartmentRate || isPriceBreak || isprivateTransfer) && addRateDetails) && _react2.default.createElement(
      'div',
      {
        style: { marginTop: '8px', color: '#00bcd4', cursor: 'pointer' },
        onClick: function onClick() {
          if (missingPresetDescrs.length) {
            addRateDetails([].concat(_toConsumableArray(rateSet.rates), _toConsumableArray(missingPresetDescrs.map(function (d) {
              return {
                description: d,
                nettRate: 0,
                retailRate: 0,
                notApplicable: true
              };
            }))));
          } else {
            addRateDetails([].concat(_toConsumableArray(rateSet.rates), [{
              description: '',
              nettRate: 0,
              retailRate: 0,
              notApplicable: true
            }]));
          }
        }
      },
      missingPresetDescrs.length ? '+ add missing rate detail(s)' : '+ Add another rate detail'
    )
  );
};

exports.default = RateTableTemplateContainer;

/***/ }),
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(89);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(545);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(1380);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_PROFILE = exports.GET_PROFILE = 'GET_PROFILE';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';
var ADD_LOCATION = exports.ADD_LOCATION = 'ADD_LOCATION';
var GET_PROFILE_FAILED = exports.GET_PROFILE_FAILED = 'GET_PROFILE_FAILED';
var EDIT_PROFILE_FIELD_STARTING = exports.EDIT_PROFILE_FIELD_STARTING = 'EDIT_PROFILE_FIELD_STARTING';
var EDIT_PROFILE_FIELD = exports.EDIT_PROFILE_FIELD = 'EDIT_PROFILE_FIELD';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';
var CLEAR_PROFILE_STORE = exports.CLEAR_PROFILE_STORE = 'CLEAR_PROFILE_STORE';
var REMOVE_LOCATION_STARTING = exports.REMOVE_LOCATION_STARTING = 'REMOVE_LOCATION_STARTING';
var REMOVE_LOCATION_FAILED = exports.REMOVE_LOCATION_FAILED = 'REMOVE_LOCATION_FAILED';
var REMOVE_LOCATION = exports.REMOVE_LOCATION = 'REMOVE_LOCATION';
var SEND_INVITATION_VIEWS = exports.SEND_INVITATION_VIEWS = 'SEND_INVITATION_VIEWS';
var PROFILE_IMAGE_CHANGED = exports.PROFILE_IMAGE_CHANGED = 'PROFILE_IMAGE_CHANGED';
var DELETE_COVER_IMAGE_FROM_PROFILE = exports.DELETE_COVER_IMAGE_FROM_PROFILE = 'DELETE_COVER_IMAGE_FROM_PROFILE';
var UPDATE_SUPP_PROFILE_PROP = exports.UPDATE_SUPP_PROFILE_PROP = 'UPDATE_SUPP_PROFILE_PROP';
var IMPORTING_LOC = exports.IMPORTING_LOC = '{profile}IMPORTING_LOC';
var IMPORTED_LOC = exports.IMPORTED_LOC = '{profile}IMPORTED_LOC';

var UPDATE_GROUP = exports.UPDATE_GROUP = '{profile} UPDATE_GROUP';
var DELETE_GROUP = exports.DELETE_GROUP = '{profile} DELETE_GROUP';

var REORDER_LOCATIONS = exports.REORDER_LOCATIONS = '{profile} REORDER_LOCATIONS';
var REORDER_PRODUCTS = exports.REORDER_PRODUCTS = '{profile} REORDER_PRODUCTS';

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_CONNECTION_AS_PARTNER = exports.ADD_CONNECTION_AS_PARTNER = '{connection-list}ADD_CONNECTION_AS_PARTNER';

var addConnectionAsPartner = exports.addConnectionAsPartner = function addConnectionAsPartner(connectionId, targetCompanyId) {
  return {
    type: ADD_CONNECTION_AS_PARTNER,
    payload: {
      connectionId: connectionId,
      targetCompanyId: targetCompanyId
    }
  };
};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_PROPS = exports.UPDATE_PROPS = 'UPDATE_PROPS_IN_SUPPLIER_SEND_TEMPLATE_WIZARD';
var LOADING_TEMPLATES = exports.LOADING_TEMPLATES = 'LOADING_TEMPLATES_SUPPLIER_SEND_TEMPLATE_WIZARD';
var TEMPLATES_LOADED = exports.TEMPLATES_LOADED = 'LOADED_TEMPLATES_SUPPLIER_SEND_TEMPLATE_WIZARD';
var LOCATIONS_LOADED = exports.LOCATIONS_LOADED = 'LOCATIONS_LOADED_SUPPLIER_SEND_TEMPLATE_WIZARD';
var PROCESSING_PARTNERS = exports.PROCESSING_PARTNERS = 'PROCESSING_PARTNERS_SUPPLIER_SEND_TEMPLATE_WIZARD';
var PARTNERS_PROCESSED = exports.PARTNERS_PROCESSED = 'PARTNERS_PROCESSED_SUPPLIER_SEND_TEMPLATE_WIZARD';
var SENDING_CONTRACTS = exports.SENDING_CONTRACTS = 'SENDING_CONTRACTS_SUPPLIER_SEND_TEMPLATE_WIZARD';
var CONTRACTS_CREATED = exports.CONTRACTS_CREATED = 'CONTRACTS_CREATED_SUPPLIER_SEND_TEMPLATE_WIZARD';
var GET_CONTRACT_REQUEST_INFO = exports.GET_CONTRACT_REQUEST_INFO = '[supplier-wizard]GET_CONTRACT_REQUEST_INFO_SUPPLIER_WIZARD';
var CLEAR_STORE = exports.CLEAR_STORE = 'CLEAR_STORE_SUPPLIER_SEND_TEMPLATE_WIZARD';

var RESET_TEMPLATE_SELECTION = exports.RESET_TEMPLATE_SELECTION = '[supplier-wizard]RESET_TEMPLATE_SELECTION';
var RESET_LOCATION_SELECTION = exports.RESET_LOCATION_SELECTION = '[supplier-wizard]RESET_LOCATION_SELECTION';

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GETTING_TEMPLATES = exports.GETTING_TEMPLATES = 'LOADING_TEMPLATES_IN_SMALL_TEMPLATES_LIST';
var POPULATE_REDUCER = exports.POPULATE_REDUCER = 'POPULATE_SMALL_TEMPLATE_LIST';
var CALLING_API = exports.CALLING_API = 'ASYNC_ACTION_STARTING_IN_SMALL_TEMPLATE_LIST';
var CLEAR_STORE = exports.CLEAR_STORE = 'CLEAR_SMALL_TEMPLATE_LIST_STORE';

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ('__THEMING__');

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1436)();
}


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_CD_PROP = exports.UPDATE_CD_PROP = 'UPDATE_CONTRACTING_DASHBOARD_PROP';

var GETTING_CONTRACTING_DASHBOARD = exports.GETTING_CONTRACTING_DASHBOARD = 'GETTING_CONTRACTING_DASHBOARD';
var GOT_CONTRACTING_DASHBOARD = exports.GOT_CONTRACTING_DASHBOARD = 'GOT_CONTRACTING_DASHBOARD';

var GETTING_CONTRACTING_YEARS = exports.GETTING_CONTRACTING_YEARS = 'GETTING_CONTRACTING_YEARS';
var GOT_CONTRACTING_YEARS = exports.GOT_CONTRACTING_YEARS = 'GOT_CONTRACTING_YEARS';

var INIT_DASHBOARD = exports.INIT_DASHBOARD = '{contracting} INIT_DASHBOARD';
var LOAD_DASHBOARD = exports.LOAD_DASHBOARD = '{contracting} LOAD_DASHBOARD';
var UPDATE_WIDGET_DATA = exports.UPDATE_WIDGET_DATA = '{contracting} UPDATE_DASHBOARD_WIDGET_DATA';

var UPDATE_GLOBAL_LIST_FILTER = exports.UPDATE_GLOBAL_LIST_FILTER = '{contracting} UPDATE_GLOBAL_LIST_FILTER';
var CLEAR_GLOBAL_LIST_FILTER = exports.CLEAR_GLOBAL_LIST_FILTER = '{contracting} CLEAR_GLOBAL_LIST_FILTER';

var RESET_GLOBAL_DASHBOARD_FILTER = exports.RESET_GLOBAL_DASHBOARD_FILTER = '{contracting} RESET_GLOBAL_DASHBOARD_FILTER';
var LOAD_FOLDERS = exports.LOAD_FOLDERS = '{contracting} LOAD_FOLDERS_FOR_DASHBOARD_FILTER';

var UPDATE_GLOBAL_FILTER = exports.UPDATE_GLOBAL_FILTER = '{contracting} UPDATE_GLOBAL_FILTER';

var UPDATE_WIDGET_FILTER = exports.UPDATE_WIDGET_FILTER = '{contracting} UPDATE_DASHBOARD_WIDGET_FILTER';

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SEARCH = exports.SEARCH = 'SEARCH';
var SEARCH_STARTING = exports.SEARCH_STARTING = 'SEARCH_STARTING';
var SEARCH_FAILED = exports.SEARCH_FAILED = 'SEARCH_FAILED';
var SEARCH_COUNT_ONLY = exports.SEARCH_COUNT_ONLY = 'SEARCH_COUNT_ONLY';

var LOAD_MORE = exports.LOAD_MORE = 'LOAD_MORE';
var MODIFY_PARAMS = exports.MODIFY_PARAMS = 'MODIFY_PARAMS';
var FILTER = exports.FILTER = 'FILTER';

var FAKE_RESEND = exports.FAKE_RESEND = 'FAKE_RESEND';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';

var SEND_INVITATION_PF = exports.SEND_INVITATION_PF = 'SEND_INVITATION_PF';
var RESEND_INVITATION_PF = exports.RESEND_INVITATION_PF = 'RESEND_INVITATION_PF';
var IGNORE_CONNECTION_PF = exports.IGNORE_CONNECTION_PF = 'IGNORE_CONNECTION_PF';
var ACCEPT_CONNECTION_PF = exports.ACCEPT_CONNECTION_PF = 'ACCEPT_CONNECTION_PF';
var FLIP_LOADER_STATUS = exports.FLIP_LOADER_STATUS = 'FLIP_LOADER_STATUS';
var ADD_SEARCH_COUNT = exports.ADD_SEARCH_COUNT = 'ADD_SEARCH_COUNT';
var UPDATE_SEARCH_COUNT_DB = exports.UPDATE_SEARCH_COUNT_DB = 'UPDATE_SEARCH_COUNT_DB';

var OPEN_PF_CUSTOM_MSG_POPOVER = exports.OPEN_PF_CUSTOM_MSG_POPOVER = 'OPEN_PF_CUSTOM_MSG_POPOVER';
var CLOSE_PF_CUSTOM_MSG_POPOVER = exports.CLOSE_PF_CUSTOM_MSG_POPOVER = 'CLOSE_PF_CUSTOM_MSG_POPOVER';
var UPDATE_CUSTOM_MSG = exports.UPDATE_CUSTOM_MSG = 'UPDATE_CUSTOM_MSG_IN_PARTNER_FINDER';

var GETTING_RESPONSE_TIME = exports.GETTING_RESPONSE_TIME = 'GETTING_RESPONSE_TIME';
var GOT_RESPONSE_TIME = exports.GOT_RESPONSE_TIME = 'GOT_RESPONSE_TIME';

// FOR ADDING MM TO PF
// export const GETTING_MARKETING_MATERIALS = 'GETTING_MARKETING_MATERIALS';
// export const GOT_MARKETING_MATERIALS = 'GOT_MARKETING_MATERIALS';

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = '[massmessaging] ';

// modal
var OPENMODAL = exports.OPENMODAL = prefix + 'OPEN_MODAL';
var CLOSEMODAL = exports.CLOSEMODAL = prefix + 'CLOSE_MODAL';
var SENDMESSAGE = exports.SENDMESSAGE = prefix + 'SEND_MESSAGE';
var GETPARTNERS = exports.GETPARTNERS = prefix + 'GETPARTNERS';

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_PROPS = exports.UPDATE_PROPS = '[asset-consolidation]UPDATE_PROPS';
var PROCESS_HASHTOKEN = exports.PROCESS_HASHTOKEN = '[asset-consolidation]PROCESS_HASHTOKEN';
var GET_ASSETS = exports.GET_ASSETS = '[asset-consolidation]GET_ASSETS';
var CONSOLIDATE_ASSETS = exports.CONSOLIDATE_ASSETS = '[asset-consolidation]CONSOLIDATE_ASSETS';
var CLEAR_STORE = exports.CLEAR_STORE = '[asset-landing]CLEAR_STORE';

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = '[partner details] ';

var CHANGE_PARTNER = exports.CHANGE_PARTNER = prefix + 'CHANGE_PARTNER';

// new-activity
var RESET_SELECTED_RATE = exports.RESET_SELECTED_RATE = prefix + 'RESET_SELECTED_RATE';
var RESET_SELECTED_LOCATION = exports.RESET_SELECTED_LOCATION = prefix + 'RESET_SELECTED_LOCATION';
var RESET_SELECTED_ALL = exports.RESET_SELECTED_ALL = prefix + 'RESET_SELECTED_RATE_ALL';
var SEND_RATES = exports.SEND_RATES = prefix + 'SEND_RATES';
var SEND_RATE_REQUESTS = exports.SEND_RATE_REQUESTS = prefix + 'SEND_RATE_REQUEST';
var SEND_MESSAGE = exports.SEND_MESSAGE = prefix + 'SEND_MESSAGE';
var RESET_CONTRACTING_REQUEST = exports.RESET_CONTRACTING_REQUEST = prefix + 'RESET_CONTRACTING_REQUEST';

// activities
var GET_ACTIVITY = exports.GET_ACTIVITY = prefix + 'GET_ACTIVITY';

// files
var GET_FILES = exports.GET_FILES = prefix + 'GET_FILES';

// PartnerInfo
var GET_PARTNER_INFO = exports.GET_PARTNER_INFO = prefix + 'GET_PARTNER_INFO';

var CLEAR_STORE = exports.CLEAR_STORE = prefix + 'CLEAR_STORE';

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = '[settings]';

var GET_SETTINGS = exports.GET_SETTINGS = prefix + ' GET_SETTINGS';
var SAVE_SETTINGS = exports.SAVE_SETTINGS = prefix + ' SAVE_SETTINGS';

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INIT = exports.INIT = '[asset-landing]INIT';
var AUTH_BY_TOKEN = exports.AUTH_BY_TOKEN = '[asset-landing]AUTH_BY_TOKEN';
var GET_LOGGED_IN_SESSION = exports.GET_LOGGED_IN_SESSION = '[asset-landing]GET_LOGGED_IN_SESSION';
var DOWNLOAD_RATES_CONTRACT = exports.DOWNLOAD_RATES_CONTRACT = '[asset-landing]DOWNLOAD_RATES_CONTRACT';
var GET_ASSETS = exports.GET_ASSETS = '[asset-landing]GET_ASSET';
var GET_MORE_CONTRACT_INFO = exports.GET_MORE_CONTRACT_INFO = '[asset-landing]GET_MORE_CONTRACT_INFO';
var CHANGE_CONTRACT_STATUS = exports.CHANGE_CONTRACT_STATUS = '[asset-landing]CHANGE_CONTRACT_STATUS';
var OPEN_DIALOG = exports.OPEN_DIALOG = '[asset-landing]OPEN_DIALOG';
var CLOSE_DIALOG = exports.CLOSE_DIALOG = '[asset-landing]CLOSE_DIALOG';
var UPDATE_PROPS_DIALOG = exports.UPDATE_PROPS_DIALOG = '[asset-landing]UPDATE_PROPS_DIALOG';
var LOG_IN = exports.LOG_IN = '[asset-landing]LOG_IN';
var SIGN_UP = exports.SIGN_UP = '[asset-landing]SIGN_UP';
var AUTO_LOGIN = exports.AUTO_LOGIN = '[asset-landing]AUTO_LOGIN';
var SCHEDULE_DEMO = exports.SCHEDULE_DEMO = '[asset-landing]SCHEDULE_DEMO';
var REQUEST_EZ_LOAD = exports.REQUEST_EZ_LOAD = '[asset-landing]REQUEST_EZ_LOAD';
var SEND_RATES = exports.SEND_RATES = '[asset-landing]SEND_RATES';
var SEND_RATES_FOR_ONE_REQUEST = exports.SEND_RATES_FOR_ONE_REQUEST = '[asset-landing]SEND_RATES_FOR_ONE_REQUEST';
var GET_XLS = exports.GET_XLS = '[asset-landing]GET_XLS';
var DOWNLOAD_ALL_CURRENT = exports.DOWNLOAD_ALL_CURRENT = '[asset-landing] DOWNLOAD_ALL_CURRENT';
var DOWNLOAD_ALL = exports.DOWNLOAD_ALL = '[asset-landing] DOWNLOAD_ALL';
var DOWNLOAD_ALL_OUTDATED = exports.DOWNLOAD_ALL_OUTDATED = '[asset-landing] DOWNLOAD_ALL_OUTDATED';

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(121)
exports.createHash = exports.Hash = __webpack_require__(135)
exports.createHmac = exports.Hmac = __webpack_require__(510)

var algos = __webpack_require__(665)
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(513)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(667)

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(684)

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(689)

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(727)

var publicEncrypt = __webpack_require__(728)

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__(731)

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(8)
var Hash = __webpack_require__(122)
var Buffer = __webpack_require__(10).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(8)
var Hash = __webpack_require__(122)
var Buffer = __webpack_require__(10).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(8)
var Sha256 = __webpack_require__(508)
var Hash = __webpack_require__(122)
var Buffer = __webpack_require__(10).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8)
var SHA512 = __webpack_require__(509)
var Hash = __webpack_require__(122)
var Buffer = __webpack_require__(10).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(8)
var Buffer = __webpack_require__(10).Buffer

var Base = __webpack_require__(87)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(512)


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__(514)
var defaultEncoding = __webpack_require__(515)
var sync = __webpack_require__(516)
var Buffer = __webpack_require__(10).Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(93)))

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(668)
var aes = __webpack_require__(244)
var aesModes = __webpack_require__(245)
var desModes = __webpack_require__(683)
var ebtk = __webpack_require__(213)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(87)
var des = __webpack_require__(243)
var inherits = __webpack_require__(8)
var Buffer = __webpack_require__(10).Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(48);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(48);
var inherits = __webpack_require__(8);

var des = __webpack_require__(243);
var utils = des.utils;
var Cipher = des.Cipher;

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(48);
var inherits = __webpack_require__(8);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(48);
var inherits = __webpack_require__(8);

var des = __webpack_require__(243);
var Cipher = des.Cipher;
var DES = des.DES;

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(245)
var AuthCipher = __webpack_require__(520)
var Buffer = __webpack_require__(10).Buffer
var StreamCipher = __webpack_require__(521)
var Transform = __webpack_require__(87)
var aes = __webpack_require__(212)
var ebtk = __webpack_require__(213)
var inherits = __webpack_require__(8)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),
/* 675 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(136)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer
var xor = __webpack_require__(136)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(136)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(520)
var Buffer = __webpack_require__(10).Buffer
var MODES = __webpack_require__(245)
var StreamCipher = __webpack_require__(521)
var Transform = __webpack_require__(87)
var aes = __webpack_require__(212)
var ebtk = __webpack_require__(213)
var inherits = __webpack_require__(8)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),
/* 683 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(522)
var primes = __webpack_require__(687)

var DH = __webpack_require__(688)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 685 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 686 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(22);
var MillerRabin = __webpack_require__(523);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(522);
var randomBytes = __webpack_require__(121);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(135)
var stream = __webpack_require__(229)
var inherits = __webpack_require__(8)
var sign = __webpack_require__(690)
var verify = __webpack_require__(726)

var algorithms = __webpack_require__(512)
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(510)
var crt = __webpack_require__(246)
var EC = __webpack_require__(44).ec
var BN = __webpack_require__(22)
var parseKeys = __webpack_require__(215)
var curves = __webpack_require__(533)

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.4.1","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"}}

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(22);
var minAssert = __webpack_require__(48);
var minUtils = __webpack_require__(525);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w) {
  var naf = [];
  var ws = 1 << (w + 1);
  var k = num.clone();
  while (k.cmpn(1) >= 0) {
    var z;
    if (k.isOdd()) {
      var mod = k.andln(ws - 1);
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }
    naf.push(z);

    // Optimization, shift by word if possible
    var shift = (k.cmpn(0) !== 0 && k.andln(ws - 1) === 0) ? (w + 1) : 1;
    for (var i = 1; i < shift; i++)
      naf.push(0);
    k.iushrn(shift);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(22);
var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a]);
      naf[b] = getNAF(coeffs[b], wndWidth[b]);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(214);
var elliptic = __webpack_require__(44);
var BN = __webpack_require__(22);
var inherits = __webpack_require__(8);
var Base = curve.base;

var assert = elliptic.utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);

  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(214);
var BN = __webpack_require__(22);
var inherits = __webpack_require__(8);
var Base = curve.base;

var elliptic = __webpack_require__(44);
var utils = elliptic.utils;

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(214);
var elliptic = __webpack_require__(44);
var BN = __webpack_require__(22);
var inherits = __webpack_require__(8);
var Base = curve.base;

var assert = elliptic.utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(247);
var elliptic = __webpack_require__(44);

var assert = elliptic.utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new elliptic.curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new elliptic.curve.edwards(options);
  else
    this.curve = new elliptic.curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__(704);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__(699);
exports.sha224 = __webpack_require__(700);
exports.sha256 = __webpack_require__(527);
exports.sha384 = __webpack_require__(701);
exports.sha512 = __webpack_require__(528);


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var common = __webpack_require__(137);
var shaCommon = __webpack_require__(526);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var SHA256 = __webpack_require__(527);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

var SHA512 = __webpack_require__(528);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var common = __webpack_require__(137);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var assert = __webpack_require__(48);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(22);
var HmacDRBG = __webpack_require__(706);
var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var assert = utils.assert;

var KeyPair = __webpack_require__(707);
var Signature = __webpack_require__(708);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(elliptic.curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = elliptic.curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof elliptic.curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || elliptic.rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(247);
var utils = __webpack_require__(525);
var assert = __webpack_require__(48);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(22);
var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(22);

var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(247);
var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(710);
var Signature = __webpack_require__(711);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = elliptic.curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(22);
var elliptic = __webpack_require__(44);
var utils = elliptic.utils;
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(138)

exports.certificate = __webpack_require__(723)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(138);
var inherits = __webpack_require__(8);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(714).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__(715);

var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    forEach(Object_keys(ctx), function (key) {
        context[key] = ctx[key];
    });

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 715 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(139).Reporter;
var EncoderBuffer = __webpack_require__(139).EncoderBuffer;
var DecoderBuffer = __webpack_require__(139).DecoderBuffer;
var assert = __webpack_require__(48);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(530);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(531);
decoders.pem = __webpack_require__(720);


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8);
var Buffer = __webpack_require__(24).Buffer;

var DERDecoder = __webpack_require__(531);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(532);
encoders.pem = __webpack_require__(722);


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(8);

var DEREncoder = __webpack_require__(532);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(138)

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = __webpack_require__(213)
var ciphers = __webpack_require__(244)
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = new Buffer(match[2], 'hex')
    var cipherText = new Buffer(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__(22)
var EC = __webpack_require__(44).ec
var parseKeys = __webpack_require__(215)
var curves = __webpack_require__(533)

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(44)
var BN = __webpack_require__(22)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24).Buffer))

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(729)
exports.privateDecrypt = __webpack_require__(730)

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(215)
var randomBytes = __webpack_require__(121)
var createHash = __webpack_require__(135)
var mgf = __webpack_require__(534)
var xor = __webpack_require__(535)
var BN = __webpack_require__(22)
var withPublic = __webpack_require__(536)
var crt = __webpack_require__(246)
var Buffer = __webpack_require__(10).Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(215)
var mgf = __webpack_require__(534)
var xor = __webpack_require__(535)
var BN = __webpack_require__(22)
var crt = __webpack_require__(246)
var createHash = __webpack_require__(135)
var withPublic = __webpack_require__(536)
var Buffer = __webpack_require__(10).Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(10)
var randombytes = __webpack_require__(121)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(93)))

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionHeading = function SectionHeading(props) {
  var classes = (0, _classnames2.default)('tc-section-heading', props.className);

  var subtitle = props.subtitle ? _react2.default.createElement(
    'h2',
    { className: 'tc-section-heading-subtitle' },
    props.subtitle
  ) : null;

  return _react2.default.createElement(
    'div',
    { className: classes, style: props.style },
    _react2.default.createElement(
      'h1',
      { className: 'tc-section-heading-title' },
      props.title
    ),
    _react2.default.createElement('hr', { className: 'tc-section-heading-underline' }),
    subtitle
  );
};

SectionHeading.propTypes = {
  title: _react.PropTypes.string.isRequired,
  subtitle: _react.PropTypes.any,
  className: _react.PropTypes.string,
  style: _react.PropTypes.object
};

exports.default = SectionHeading;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEPRECATED_CONFIG_PROPS = exports.defaultProps = exports.propTypes = undefined;

var _propTypes = __webpack_require__(1472);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var string = _propTypes2['default'].string,
    bool = _propTypes2['default'].bool,
    number = _propTypes2['default'].number,
    array = _propTypes2['default'].array,
    oneOfType = _propTypes2['default'].oneOfType,
    shape = _propTypes2['default'].shape,
    object = _propTypes2['default'].object,
    func = _propTypes2['default'].func;
var propTypes = exports.propTypes = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  pip: bool,
  wrapper: oneOfType([string, func]),
  config: shape({
    soundcloud: shape({
      options: object
    }),
    youtube: shape({
      playerVars: object,
      preload: bool
    }),
    facebook: shape({
      appId: string
    }),
    dailymotion: shape({
      params: object,
      preload: bool
    }),
    vimeo: shape({
      playerOptions: object,
      preload: bool
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceDASH: bool,
      hlsOptions: object,
      hlsVersion: string,
      dashVersion: string
    }),
    wistia: shape({
      options: object
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onProgress: func,
  onEnablePIP: func,
  onDisablePIP: func
};

var defaultProps = exports.defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: '640px',
  height: '360px',
  style: {},
  progressInterval: 1000,
  playsinline: false,
  pip: false,
  wrapper: 'div',
  config: {
    soundcloud: {
      options: {
        visual: true, // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      preload: false
    },
    facebook: {
      appId: '1309697205772819'
    },
    dailymotion: {
      params: {
        api: 1,
        'endscreen-enable': false
      },
      preload: false
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      },
      preload: false
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      hlsOptions: {},
      hlsVersion: '0.10.1',
      dashVersion: '2.9.2'
    },
    wistia: {
      options: {}
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {}
    }
  },
  onReady: function onReady() {},
  onStart: function onStart() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onBuffer: function onBuffer() {},
  onEnded: function onEnded() {},
  onError: function onError() {},
  onDuration: function onDuration() {},
  onSeek: function onSeek() {},
  onProgress: function onProgress() {},
  onEnablePIP: function onEnablePIP() {},
  onDisablePIP: function onDisablePIP() {}
};

var DEPRECATED_CONFIG_PROPS = exports.DEPRECATED_CONFIG_PROPS = ['soundcloudConfig', 'youtubeConfig', 'facebookConfig', 'dailymotionConfig', 'vimeoConfig', 'fileConfig', 'wistiaConfig'];

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// returns a style object with a single concated prefixed value string

exports.default = function (property, value) {
  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
    return prefix + value;
  } : arguments[2];
  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
    return replacer(prefix, value);
  }));
};

module.exports = exports['default'];

/***/ }),
/* 735 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeftBarDetail = function (_Component) {
  _inherits(LeftBarDetail, _Component);

  function LeftBarDetail() {
    _classCallCheck(this, LeftBarDetail);

    return _possibleConstructorReturn(this, (LeftBarDetail.__proto__ || Object.getPrototypeOf(LeftBarDetail)).apply(this, arguments));
  }

  _createClass(LeftBarDetail, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          infoToDisplay = _props.infoToDisplay,
          isEditable = _props.isEditable,
          classification = _props.classification,
          noMargin = _props.noMargin,
          infoArray = _props.infoArray,
          itemName = _props.itemName,
          inline = _props.inline,
          editField = _props.editField;


      var edit = void 0;
      var detailToDisplay = void 0;
      var noInfoToDisplay = void 0;

      if (infoToDisplay !== undefined) {
        detailToDisplay = infoToDisplay;
      }if (title === 'Destinations Sold' && infoArray.some(function (destination) {
        return destination === 'All';
      })) {
        detailToDisplay = 'All';
      } else if (infoArray && infoArray.length) {
        detailToDisplay = _react2.default.createElement(
          'ul',
          { style: { 'listStyle': 'none' } },
          infoArray.map(function (info, index) {
            return _react2.default.createElement(
              'li',
              { key: index },
              info
            );
          })
        );
      }

      if (isEditable) {
        if (!detailToDisplay && detailToDisplay !== 0) {
          noInfoToDisplay = true;
          detailToDisplay = _react2.default.createElement(
            'div',
            { onClick: editField, className: 'description-segments-add' },
            _react2.default.createElement(_icon2.default, { className: 'tc-icon-add description-segments-add-icon' }),
            _react2.default.createElement(
              'span',
              { className: 'description-segments-add-label' },
              'Add ',
              itemName
            )
          );
        } else {
          edit = _react2.default.createElement(
            'span',
            { onClick: editField, className: 'description-segments-edit' },
            _react2.default.createElement(_icon2.default, { style: { fontSize: '14px', marginRight: '4px' }, className: 'tc-icon-mode_edit' }),
            'Edit'
          );
        }
      }

      var header = inline ? undefined : _react2.default.createElement(
        'div',
        { className: 'description-segments' },
        _react2.default.createElement(
          'span',
          { style: this.props.headerStyle, className: 'description-segments-title' },
          title
        ),
        edit
      );

      var inlineNodeStyle = {
        fontSize: '24px',
        fontWeight: '600',
        display: 'inline-block',
        marginRight: '8px'
      };
      if (itemName === 'Interconnecting Rooms') {
        detailToDisplay = function () {
          if (infoToDisplay) return 'INTERCONNECTING ROOMS AVAILABLE';
          if (infoToDisplay === false && isEditable) return 'NO INTERCONNECTING ROOMS';
        }();
        inlineNodeStyle.fontSize = '14px';
        inlineNodeStyle.fontWeight = '400';
      }

      var margin1 = noMargin ? undefined : { marginTop: '16px' };
      var margin2 = noMargin ? undefined : { marginTop: '32px' };

      var information = inline ? _react2.default.createElement(
        'div',
        { style: margin1 },
        _react2.default.createElement(
          'div',
          { style: inlineNodeStyle },
          detailToDisplay
        ),
        classification && !noInfoToDisplay ? classification.toUpperCase() : undefined,
        edit
      ) : _react2.default.createElement(
        'div',
        { className: 'l-paper-split-segment', style: { maxHeight: '300px', overflowY: 'scroll' } },
        detailToDisplay
      );

      if (!detailToDisplay && !isEditable) return false;
      return _react2.default.createElement(
        'div',
        { style: margin2 },
        header,
        information
      );
    }
  }]);

  return LeftBarDetail;
}(_react.Component);

LeftBarDetail.propTypes = {
  title: _react.PropTypes.string,
  infoToDisplay: _react.PropTypes.any,
  isEditable: _react.PropTypes.bool,
  classification: _react.PropTypes.string,
  noMargin: _react.PropTypes.bool,
  infoArray: _react.PropTypes.array,
  itemName: _react.PropTypes.string,
  inline: _react.PropTypes.bool,
  editField: _react.PropTypes.func
};

exports.default = LeftBarDetail;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeContractFromRequest = exports.fileContractForRequest = exports.getNotes = exports.removeSingleFeedByTCAdmin = exports.manageExtrasOffers = exports.sendReviewRatesEmail = undefined;
exports.updateSameAsCorporatePolicyNotes = updateSameAsCorporatePolicyNotes;
exports.removeMasterTemplate = removeMasterTemplate;

var _constants = __webpack_require__(252);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function updateSameAsCorporatePolicyNotes(templateDraftId, sectionValue, checked) {
  return {
    type: cnt.UPDATE_SAME_AS_CORPORATE_POLICY_NOTES,
    payload: {
      templateDraftId: templateDraftId,
      sectionValue: sectionValue,
      checked: checked
    }
  };
}

function removeMasterTemplate() {
  return {
    type: cnt.REMOVE_MASTER_TEMPLATE
  };
}

var sendReviewRatesEmail = exports.sendReviewRatesEmail = function sendReviewRatesEmail(payload) {
  return { type: cnt.REVIEW_MY_RATES_DRAFT, payload: payload };
};

var manageExtrasOffers = exports.manageExtrasOffers = function manageExtrasOffers(payload) {
  return { type: cnt.MANAGE_EXTRAS_OFFERS, payload: payload };
};

var removeSingleFeedByTCAdmin = exports.removeSingleFeedByTCAdmin = function removeSingleFeedByTCAdmin(_ref) {
  var historyFeedId = _ref.historyFeedId,
      messageId = _ref.messageId;
  return {
    type: cnt.REMOVE_SINGLE_FEED_BY_TC_ADMIN,
    payload: {
      historyFeedId: historyFeedId,
      messageId: messageId
    }
  };
};

var getNotes = exports.getNotes = function getNotes(payload) {
  return { type: cnt.GET_NOTES, payload: payload };
};

var fileContractForRequest = exports.fileContractForRequest = function fileContractForRequest(payload) {
  return { type: cnt.FILE_CONTRACT_FOR_REQUEST, payload: payload };
};

var removeContractFromRequest = exports.removeContractFromRequest = function removeContractFromRequest(payload) {
  return { type: cnt.REMOVE_CONTRACT_FROM_REQUEST, payload: payload };
};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDelete = function ActionDelete(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' })
  );
};
ActionDelete = (0, _pure2.default)(ActionDelete);
ActionDelete.displayName = 'ActionDelete';
ActionDelete.muiName = 'SvgIcon';

exports.default = ActionDelete;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RemoveFile = function RemoveFile(props) {
  var removeFile = props.removeFile,
      top = props.top,
      left = props.left;


  return _react2.default.createElement(
    'div',
    { style: {
        cursor: 'pointer',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        opacity: '0.7',
        fontSize: '14px',
        backgroundColor: '#FFFFFF',
        borderRadius: '50%',
        height: '20px',
        width: '20px',
        position: 'absolute',
        color: 'rgb(255, 64, 129)',
        border: '1px solid #bdbdbd',
        top: top || '77%',
        left: left || '80%'
      },
      className: 'file-preview-close',
      onTouchTap: removeFile
    },
    _react2.default.createElement(
      'span',
      { style: { marginTop: '-1px' } },
      'X'
    )
  );
};

RemoveFile.propTypes = {
  removeFile: _react.PropTypes.func,
  top: _react.PropTypes.string,
  left: _react.PropTypes.string
};

exports.default = RemoveFile;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileName = function FileName(props) {
  var fileName = props.fileName,
      vertical = props.vertical,
      width = props.width,
      fileNameStyle = props.fileNameStyle;


  return _react2.default.createElement(
    'div',
    { style: {
        height: '24px',
        width: width || '145px',
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        marginLeft: vertical ? '' : '3px'
      }
    },
    _react2.default.createElement(
      'span',
      { style: _ramda2.default.merge({ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }, fileNameStyle) },
      fileName
    )
  );
};

FileName.propTypes = {
  fileName: _react.PropTypes.string,
  width: _react.PropTypes.string,
  vertical: _react.PropTypes.bool,
  fileNameStyle: _react.PropTypes.object
};

exports.default = FileName;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNGoToDraft = createNGoToDraft;
exports.saveSupplierInfoChanges = saveSupplierInfoChanges;
exports.openEditDialog = openEditDialog;
exports.cancelEdit = cancelEdit;
exports.clickFinalise = clickFinalise;
exports.finalise = finalise;
exports.closeFinaliseDialog = closeFinaliseDialog;
exports.discardDraft = discardDraft;
exports.toggleAssoicatedTemplates = toggleAssoicatedTemplates;
exports.onTextFieldChange = onTextFieldChange;
exports.attachInsFile = attachInsFile;
exports.removeInsFile = removeInsFile;
exports.saveBillingInfoChanges = saveBillingInfoChanges;
exports.selectUnselectDraft = selectUnselectDraft;
exports.applyToTemplates = applyToTemplates;
exports.clickOk = clickOk;
exports.checkSameAsCorporate = checkSameAsCorporate;
exports.checkHonor = checkHonor;
exports.selectMaster = selectMaster;

var _constants = __webpack_require__(579);

var cnt = _interopRequireWildcard(_constants);

var _constants2 = __webpack_require__(630);

var cnts = _interopRequireWildcard(_constants2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function createNGoToDraft(payload) {
  return { type: cnt.CREATE_EDITED_DRAFT, payload: payload };
}

function saveSupplierInfoChanges(payload) {
  return { type: cnt.SAVE_EDITS, payload: payload };
}

function openEditDialog(payload) {
  return { type: cnt.INITIATE_EDIT_WITH_TYPE, payload: payload };
}

function cancelEdit() {
  return { type: cnt.CANCEL_EDIT };
}

function clickFinalise() {
  return { type: cnt.CLICK_FINALISE };
}

function finalise() {
  return { type: cnt.FINALISE };
}

function closeFinaliseDialog() {
  return { type: cnt.CLOSE_FINALISE_DIALOG };
}

function discardDraft() {
  return { type: cnt.DISCARD_DRAFT };
}

function toggleAssoicatedTemplates() {
  return { type: cnt.TOGGLE_ASSOCIATED_TEMPLATES };
}

/* for editDialog */
function onTextFieldChange(payload) {
  return { type: cnt.TEXT_FIELD_CHANGE, payload: payload };
}

// for billing only
// in order to reuse the same edit component, need to supply the same functions
function attachInsFile(payload) {
  return { type: cnt.ATTACH_INS_FILE, payload: payload };
}

function removeInsFile() {
  return { type: cnt.REMOVE_INSURANCE_FILE };
}

function saveBillingInfoChanges() {
  return { type: cnt.SAVE_EDITS, payload: { updateType: 'SAVE_BILLING_INFO_ADD_EDIT' } };
}

/*
  for associate master template wizard
  One master - to - Many templates
*/

function selectUnselectDraft(payload) {
  return { type: cnt.apply.SELECT_UNSELECT_TEMPLATE, payload: payload };
}

function applyToTemplates() {
  return { type: cnt.apply.APPLY_TO_TEMPLATES };
}

function clickOk() {
  return { type: cnt.apply.CLICK_OK_SUCCESS };
}

function checkSameAsCorporate(payload) {
  return { type: cnt.apply.CHECK_SAME_AS, payload: payload };
}

function checkHonor(honorPreloadContent) {
  return { type: cnt.apply.CHECK_HONOR_PRELOAD, payload: honorPreloadContent };
}

/*
  for pick master template wizard
  One template - to - Many master
  for policyNotes it's one-to-one
  for product spacific it's one-to-many
*/
function selectMaster(payload) {
  return { type: cnt.apply.SELECT_MASTER, payload: payload };
}

/***/ }),
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_UM_PROP = exports.UPDATE_UM_PROP = 'UPDATE_UM_PROP';

var ADD_USER_STARTING = exports.ADD_USER_STARTING = 'ADD_USER_STARTING';
var ADD_USER_FAILED = exports.ADD_USER_FAILED = 'ADD_USER_FAILED';
var ADDED_USER = exports.ADDED_USER = 'ADDED_USER';

var UPDATE_USER_STARTING = exports.UPDATE_USER_STARTING = 'UPDATE_USER_STARTING';
var UPDATED_USER = exports.UPDATED_USER = 'UPDATED_USER';
var UPDATE_USER_FAILED = exports.UPDATE_USER_FAILED = 'UPDATE_USER_FAILED';

var DELETE_USER_STARTING = exports.DELETE_USER_STARTING = 'DELETE_USER_STARTING';
var DELETED_USER = exports.DELETED_USER = 'DELETED_USER';
var DELETE_USER_FAILED = exports.DELETE_USER_FAILED = 'DELETE_USER_FAILED';

var GETTING_USERS_BY_FILTER = exports.GETTING_USERS_BY_FILTER = 'GETTING_USERS_BY_FILTER';
var GOT_USERS_BY_FILTER = exports.GOT_USERS_BY_FILTER = 'GOT_USERS_BY_FILTER';
var GETTING_USERS_BY_FILTER_FAILED = exports.GETTING_USERS_BY_FILTER_FAILED = 'GETTING_USERS_BY_FILTER_FAILED';

var GETTING_COMP_ADMIN = exports.GETTING_COMP_ADMIN = 'GETTING_COMP_ADMIN';
var GOT_COMP_ADMIN = exports.GOT_COMP_ADMIN = 'GOT_COMP_ADMIN';
var GETTING_COMP_ADMIN_FAILED = exports.GETTING_COMP_ADMIN_FAILED = 'GETTING_COMP_ADMIN_FAILED';

var APPROVE_REJECT_USER_STARTED = exports.APPROVE_REJECT_USER_STARTED = 'APPROVE_REJECT_USER_STARTED';
var APPROVE_REJECT_USER_DONE = exports.APPROVE_REJECT_USER_DONE = 'APPROVE_REJECT_USER_DONE';
var APPROVE_REJECT_USER_FAILED = exports.APPROVE_REJECT_USER_FAILED = 'APPROVE_REJECT_USER_FAILED';

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var scroll = __webpack_require__(1417);

function calculateScrollOffset(elem, additionalOffset, alignment) {
  var body = document.body,
      html = document.documentElement;

  var elemRect = elem.getBoundingClientRect();
  var clientHeight = html.clientHeight;
  var documentHeight = Math.max( body.scrollHeight, body.offsetHeight, 
                                 html.clientHeight, html.scrollHeight, html.offsetHeight );

  additionalOffset = additionalOffset || 0;

  var scrollPosition;
  if (alignment === 'bottom') {
    scrollPosition = elemRect.bottom - clientHeight;
  } else if (alignment === 'middle') {
    scrollPosition = elemRect.bottom - clientHeight / 2 - elemRect.height / 2;
  } else { // top and default
    scrollPosition = elemRect.top;
  }

  var maxScrollPosition = documentHeight - clientHeight;
  return Math.min(scrollPosition + additionalOffset + window.pageYOffset,
                  maxScrollPosition);
}

module.exports = function (elem, options) {
  options = options || {};
  if (typeof elem === 'string') elem = document.querySelector(elem);
  if (elem) return scroll(0, calculateScrollOffset(elem, options.offset, options.align), options);
};


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIfUpdatesExist = exports.repairAllProducts = exports.getAvailableSubMenu = exports.checkIfProductWithNothingToShow = exports.transformAllKindsOfRates = undefined;

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 transformAllProducts
 */
var checkIfIsCommissionRates = _ramda2.default.compose(function (rates) {
  return rates.some(function (o) {
    return o.retailRate;
  });
}, _ramda2.default.propOr([], 'rates'));

var checkIfIsNettRates = _ramda2.default.complement(checkIfIsCommissionRates);

var getCheckIfOfferIsNettOrCommissionFn = function getCheckIfOfferIsNettOrCommissionFn(rateType) {
  return _ramda2.default.both(_ramda2.default.propEq('rate', 'rateAmount'), _ramda2.default.equals(rateType, 'nett') ? checkIfIsNettRates : checkIfIsCommissionRates);
};

var checkIfOfferIsDiscount = _ramda2.default.propEq('rate', 'discount');

var groupByFnForRateSetsOrExtras = function groupByFnForRateSetsOrExtras(object) {
  if (checkIfIsCommissionRates(object)) return 'commission';
  return 'nett';
};

var groupByFnForOffers = function groupByFnForOffers(offer) {
  if (checkIfOfferIsDiscount(offer)) return 'discount';
  if (getCheckIfOfferIsNettOrCommissionFn('nett')(offer)) return 'nett';
  if (getCheckIfOfferIsNettOrCommissionFn('commission')(offer)) return 'commission';
  return 'free';
};

var calCommission = function calCommission(rateSetOfferExtra) {
  if (_ramda2.default.prop('commissionPercentage', rateSetOfferExtra)) return _ramda2.default.prop('commissionPercentage', rateSetOfferExtra);
  var anyRateDetail = _ramda2.default.find(function (rate) {
    return _ramda2.default.prop('retailRate', rate);
  })(_ramda2.default.prop('rates', rateSetOfferExtra));
  var retailRate = _ramda2.default.propOr(0, 'retailRate', anyRateDetail);
  var nettRate = _ramda2.default.propOr(0, 'nettRate', anyRateDetail);
  return Math.round((retailRate - nettRate) * 100 / retailRate);
};

var calSetCommissionIfNotExists = function calSetCommissionIfNotExists(rateSetOfferExtra) {
  if (checkIfIsCommissionRates(rateSetOfferExtra)) {
    return _ramda2.default.merge(rateSetOfferExtra, {
      commissionPercentage: calCommission(rateSetOfferExtra)
    });
  }
  return rateSetOfferExtra;
};

var groupByForOffersOrExtras = function groupByForOffersOrExtras(updateType) {
  return _ramda2.default.compose(_ramda2.default.groupBy(_ramda2.default.equals(updateType, 'offers') ? groupByFnForOffers : groupByFnForRateSetsOrExtras), _ramda2.default.map(calSetCommissionIfNotExists), _ramda2.default.propOr([], updateType));
};

var mapForSeasonRate = function mapForSeasonRate(seasonRate) {
  return _ramda2.default.merge(seasonRate, {
    rateSets: _ramda2.default.compose(_ramda2.default.groupBy(groupByFnForRateSetsOrExtras), _ramda2.default.map(calSetCommissionIfNotExists), _ramda2.default.propOr([], 'rateSets'))(seasonRate)
  });
};

var transformUpdateType = _ramda2.default.curry(function (updateType, product) {
  return _ramda2.default.merge(product, _defineProperty({}, updateType, _ramda2.default.equals(updateType, 'seasonRates') ? _ramda2.default.map(mapForSeasonRate, _ramda2.default.propOr([], 'seasonRates')(product)) : groupByForOffersOrExtras(updateType)(product)));
});

var transformAllProducts = function transformAllProducts(updateType) {
  return _ramda2.default.map(transformUpdateType(updateType));
};

var transformAllKindsOfRates = function transformAllKindsOfRates(allKindsOfRates) {
  var mapObjFn = function mapObjFn(val, typeAsKey) {
    var products = transformAllProducts(typeAsKey)(val);
    var subMenus = getAvailableSubMenu(typeAsKey)(products);
    return {
      products: products,
      subMenus: subMenus,
      retailDiffForAll: '',
      nettDiffForAll: '',
      discountDiffForAll: '',
      commissionForAll: '',
      nettMeasure: 'dollar',
      commissionMeasure: 'dollar',
      discountMeasure: 'dollar'
    };
  };
  return _ramda2.default.mapObjIndexed(mapObjFn, allKindsOfRates);
};

/*
end transformAllProducts
 */
var checkIfProductWithNothingToShow = _ramda2.default.curry(function (updateType, rateType, product) {
  if (_ramda2.default.equals(updateType, 'seasonRates')) {
    return _ramda2.default.all(_ramda2.default.compose(function (rateTypeArray) {
      return _ramda2.default.or(_ramda2.default.isEmpty(rateTypeArray), _ramda2.default.isNil(rateTypeArray));
    }, _ramda2.default.prop(rateType), _ramda2.default.propOr({}, 'rateSets')))(_ramda2.default.propOr({}, 'seasonRates')(product));
  }
  return _ramda2.default.compose(function (rateTypeArray) {
    return _ramda2.default.or(_ramda2.default.isEmpty(rateTypeArray), _ramda2.default.isNil(rateTypeArray));
  }, _ramda2.default.prop(rateType), _ramda2.default.propOr({}, updateType))(product);
});
/*
 getAvailableSubMenu
 */
var getAvailableSubMenuForSeasonRates = _ramda2.default.compose(_ramda2.default.uniq, _ramda2.default.flatten, _ramda2.default.map(_ramda2.default.keys), _ramda2.default.map(_ramda2.default.propOr({}, 'rateSets')), _ramda2.default.flatten, _ramda2.default.map(_ramda2.default.propOr([], 'seasonRates')));

var getAvailableSubMenuForExtrasOrOffers = function getAvailableSubMenuForExtrasOrOffers(updateType) {
  return _ramda2.default.compose(_ramda2.default.uniq, _ramda2.default.flatten, _ramda2.default.map(_ramda2.default.keys), _ramda2.default.map(_ramda2.default.propOr({}, updateType)));
};
var getAvailableSubMenu = function getAvailableSubMenu(updateType) {
  return _ramda2.default.equals(updateType, 'seasonRates') ? getAvailableSubMenuForSeasonRates : getAvailableSubMenuForExtrasOrOffers(updateType);
};
/*
 end getAvailableSubMenu
 */

/*
end udpate rates
 */

var repairAllProducts = function repairAllProducts(updateType, products) {
  return _ramda2.default.map(function (product) {
    return _ramda2.default.merge(product, _defineProperty({}, updateType, _ramda2.default.equals(updateType, 'seasonRates') ? _ramda2.default.map(function (seasonRate) {
      return _ramda2.default.merge(seasonRate, {
        rateSets: _ramda2.default.compose(_ramda2.default.flatten, _ramda2.default.values, _ramda2.default.propOr({}, 'rateSets'))(seasonRate)
      });
    }, _ramda2.default.propOr([], 'seasonRates')(product)) : _ramda2.default.compose(_ramda2.default.flatten, _ramda2.default.values, _ramda2.default.propOr({}, updateType))(product)));
  })(products);
};

var existsAndNotEqualsToZero = function existsAndNotEqualsToZero(key) {
  return _ramda2.default.compose(_ramda2.default.allPass([function (val) {
    return _ramda2.default.complement(_ramda2.default.isNil)(val);
  }, function (val) {
    return _ramda2.default.complement(_ramda2.default.equals(0))(val);
  }, function (val) {
    return _ramda2.default.complement(_ramda2.default.equals('0'))(val);
  }, function (val) {
    return _ramda2.default.complement(_ramda2.default.equals(''))(val);
  }]), _ramda2.default.prop(key));
};

var checkIfUpdatesExist = function checkIfUpdatesExist(rateType) {
  return _ramda2.default.any(_ramda2.default.anyPass(_ramda2.default.cond([[_ramda2.default.equals('nett'), _ramda2.default.always([existsAndNotEqualsToZero('nettDiff')])], [_ramda2.default.equals('discount'), _ramda2.default.always([existsAndNotEqualsToZero('discountDiff')])], [_ramda2.default.equals('commission'), _ramda2.default.always([existsAndNotEqualsToZero('retailDiff'), existsAndNotEqualsToZero('commission')])], [_ramda2.default.T, _ramda2.default.always([existsAndNotEqualsToZero('nettDiff'), existsAndNotEqualsToZero('discountDiff'), existsAndNotEqualsToZero('retailDiff'), existsAndNotEqualsToZero('commission')])]])(rateType)));
};

exports.transformAllKindsOfRates = transformAllKindsOfRates;
exports.checkIfProductWithNothingToShow = checkIfProductWithNothingToShow;
exports.getAvailableSubMenu = getAvailableSubMenu;
exports.repairAllProducts = repairAllProducts;
exports.checkIfUpdatesExist = checkIfUpdatesExist;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ERROR_TRIGGERED = exports.ERROR_TRIGGERED = 'GLOBAL_ERROR_TRIGGERED';
var CLEAR_STORE = exports.CLEAR_STORE = 'CLEAR_STORE_FOR_GLOBAL_ERROR_CONTAINER';

var REQUEST_ACCESS_STARTED = exports.REQUEST_ACCESS_STARTED = 'REQUEST_ACCESS_STARTED';
var REQUESTED_ACCESS = exports.REQUESTED_ACCESS = 'REQUESTED_ACCESS';
var REQUEST_ACCESS_FAILED = exports.REQUEST_ACCESS_FAILED = 'REQUEST_ACCESS_FAILED';

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var myLocationProfileQuery = exports.myLocationProfileQuery = "query getMyLocationProfile ($locationId: ID!) {\n      locationProfile  (id: $locationId) {\n        companyName\n        locationName\n        id\n        companyId\n        isMarketingReady\n        name\n        coverImageUrl\n        marketSegments\n        companyTypes\n        website\n        phone\n        productType\n        amenities\n        locationId\n        roomCount\n        isProductMarketingReady\n        rating {\n          value\n          type\n        }\n        profileImageUrl\n        imageUrls\n        profileViews {\n          timeViewed\n          profileImageUrl\n          companyId\n          companyName\n        }\n        address {\n          addressOne\n          addressTwo\n          city\n          state\n          country\n          postalCode\n          formattedAddress\n        }\n        type\n        notes\n        description\n        contacts {\n          firstName\n          lastName\n          name\n          type\n          phone\n          fax\n          email\n        }\n        groups {\n          _id\n          tag\n          items\n        }\n        products {\n          name\n          id\n          images\n          isMarketingReady\n          updatedAt\n        }\n      }\n    }";

var addProductMutation = exports.addProductMutation = "mutation addProduct($supplierId:ID!, $locationId: ID!, $name: String!) {\n  addProduct (locationId: $locationId, supplierId: $supplierId, name: $name) {\n    name\n    productId\n    locationId\n  }\n}";

var editLocationMutation = exports.editLocationMutation = "mutation editLocation($locationId: ID!, $supplierId: ID!, $update: LocationProfileInputType) {\n  editLocation (locationId: $locationId, supplierId: $supplierId, update: $update) {\n    isMarketingReady\n    isProductMarketingReady\n    locationId\n  }\n}";

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var profileQuery = exports.profileQuery = 'query getMyProfile ($companyId: ID!, $email: String) {\n      companyProfile  (id: $companyId) {\n        companyName\n        id\n        companyId\n        isMarketingReady\n        productType\n        name\n        coverImageUrl\n        marketSegments\n        marketServed\n        companyTypes\n        website\n        phone\n        profileImageUrl\n        imageUrls\n        media {\n          url\n          mediaType\n          created_at\n          name\n          size\n          storageProvider\n          username\n          password\n          tags\n        }\n        profileViews {\n          timeViewed\n          profileImageUrl\n          companyId\n          companyName\n        }\n        address {\n          addressOne\n          addressTwo\n          city\n          state\n          country\n          postalCode\n          formattedAddress\n        }\n        quickResponder\n        onBoardingStatus\n        destinationsSold\n        corporateIdentifier\n        type\n        description\n        acctCreationReason\n        contacts (email: $email) {\n          firstName\n          lastName\n          name\n          type\n          phone\n          fax\n          email\n        }\n        groups {\n          _id\n          tag\n          items\n        }\n        locations {\n          name\n          id\n          city\n          state\n          country\n          images\n          isMarketingReady\n          numOfProducts\n          updatedAt\n          products {\n            name\n            id\n            updatedAt\n          }\n        }\n        companyBadges {\n          membershipId\n          verifiedStatus\n          name\n          badgeId\n          logo\n          companyBadgeId\n          acronym\n          website\n        }\n        isLocationMarketingReady\n      }\n    }'.replace(/ +(?= )/g, '');

var addLocationMutation = exports.addLocationMutation = 'mutation addLocation($supplierId:ID!, $propertyName: String!, $userFirstName: String!, $userLastName: String!, $userEmail: String!, $userId: ID!) {\n  addLocation (supplierId: $supplierId, propertyName: $propertyName, userFirstName: $userFirstName, userLastName: $userLastName, userEmail: $userEmail, userId: $userId) {\n    locationName\n    locationId\n  }\n}'.replace(/ +(?= )/g, '');

var editCompanyMutation = exports.editCompanyMutation = 'mutation editCompany($companyId: ID!, $update: CompanyInputType, $companyType: String!) {\n  editCompany (companyId: $companyId, update: $update, companyType: $companyType) {\n    isMarketingReady\n    isLocationMarketingReady\n  }\n}'.replace(/ +(?= )/g, '');

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var supplierProductFields = "\n      supplierId\n      product (productId: $productId, ratePackage: $ratePackage) {\n        _id\n        productType\n        ratePackageIndex\n        productId\n        productName\n        ratePackageName\n        bedsAndSofas {\n          isApartment\n          rooms {\n            count\n            bedType\n            other\n          }\n        }\n        seasons {\n          _id\n          seasonName\n          dateRanges {\n            eventName\n            seasonStartDate\n            seasonEndDate\n          }\n        }\n        extras {\n          _id\n          extraType\n          extraCode\n          description\n          taxInclusion\n          currency\n          taxType\n          nonStandardTemplateType\n          commissionPercentage\n          nettCommission\n          rateType\n          rates { ...rateFragment }\n        }\n        offers (hideOffers: $hideOffers) {\n          _id\n          rates { ...rateFragment }\n          offerName\n          bookingCode\n          offerDetail\n          specialConditions\n          allowCombination\n          offerType\n          numberOfGuests\n          rate\n          discountType\n          amount\n          nonStandardTemplateType\n          commissionPercentage\n          nettCommission\n          rateType\n          validDatesOfSale {\n            fromDate\n            toDate\n          }\n          validDatesOfTravel {\n            fromDate\n            toDate\n          }\n          isStayPay\n          stayPays {\n            stayDays\n            payDays\n            maxFOC\n          }\n          daysOfWeek\n        }\n        allocation (hideAllocation: $hideAllocation) {\n          dateRanges { ...seasonDatesFragment }\n          allocationType\n          releaseBackDays\n          numberOfRooms\n          allotments {\n            releaseBackDays\n            numberOfRooms\n          }\n        }\n        blackouts {\n          name\n          startDate\n          endDate\n        }\n        pickup { ...pickupDropoff }\n        dropoff { ...pickupDropoff }\n        productPolicy (hideCancellation: $hideCancellation) {\n          policyType\n          ageFrom\n          ageTo\n          adultCount\n          childrenCount\n          focChildrenCount\n          infantAsOccupant\n          conditions\n          cancellations {\n            dateRanges { ...seasonDatesFragment }\n            conditions\n            cancelNum\n            cancelHoursDays\n            additionalRules {\n              cancelNum\n              cancelHoursDays\n              arrivalDeparture\n              cancelFee\n              feeDollarPercent\n              feeBase\n            }\n          }\n        }\n        seasonRates {\n          _id\n          seasonName\n          dateRanges { ...seasonDatesFragment }\n          rateSets {\n            ratePackageName\n            rates { ...rateFragment },\n            rateSetName\n            rateSetCode\n            daysOfWeek\n            commissionPercentage\n            nettCommission\n            includedGuestsinBaseRate\n            rateType\n            minStay\n            maxStay\n            taxInclusion\n            currency\n            taxType\n            nonStandardTemplateType\n          }\n        }\n      }\n    }\n  }\n  fragment pickupDropoff on pickupDropoffType {\n    dateRanges { ...seasonDatesFragment }\n    time\n    location\n    notes\n    timeLocArray {\n      time\n      location\n    }\n  }\n  fragment seasonDatesFragment on seasonDateRangesType {\n    eventName\n    seasonStartDate\n    seasonEndDate\n  }\n  fragment rateFragment on ratesType {\n    priceCode\n    notApplicable\n    description\n    minGuests\n    maxAdults\n    maxAdultsPlusChild\n    retailRate (hideRates: $hideRates)\n    nettRate (hideRates: $hideRates)\n    extraAdult\n    extraChild\n  }\n";
var contractDetailsQuery = "\n      contractId\n      supplierId\n      supplierProfileImageUrl\n      supplierName\n      locationId\n      locationName\n      propertyName\n      productType\n      supplierInfo {\n        termsAndConditions\n        submissionCriteria\n        marketInfo\n      }\n      checkIn\n      checkOut\n      earlyCheckIn\n      earlyCheckInCostType\n      earlyCheckInFee\n      earlyCheckInPercentageType\n      lateCheckOut\n      lateCheckOutFee\n      lateCheckOutCostType\n      lateCheckOutPercentageType\n      locationPolicy (hideCancellation: $hideCancellation) {\n        policyType\n        conditions\n        cancelNum\n        cancelHoursDays\n        additionalRules {\n          cancelNum\n          cancelHoursDays\n          arrivalDeparture\n          cancelFee\n          feeDollarPercent\n          feeBase\n        }\n        ageFrom\n        ageTo\n        adultCount\n        childrenCount\n        focChildrenCount\n        infantAsOccupant\n      }\n      billingInformation {\n        terms\n        financialInstitution\n        branch\n        accountName\n        accountNumber\n        bsbRoutingNumber\n        ibanSwiftCode\n        currency\n        insuranceExpirationYear\n        insuranceExpirationMonth\n        insuranceFiles {\n          fileName\n          downloadUrl\n          hash\n        }\n      }\n    }\n  }";
var leftNavFields = "\n      contractId\n      templateId\n      isLatest\n      supplierId\n      supplierProfileImageUrl\n      locationId\n      locationName\n      startDate\n      endDate\n      supplierEditable\n      contractState\n      supplierInfo {\n        termsAndConditions\n        submissionCriteria\n        marketInfo\n      }\n      productsArray {\n        _id\n        ratePackageIndex\n        productId\n        productName\n        ratePackageName\n        productType\n      }\n    }\n  }\n";

var getMoreContractInfoForContractList = exports.getMoreContractInfoForContractList = "\n  query getContract ($contractId: ID!, $viewerId: ID!, $viewBy: String!) {\n    Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy) {\n      partners {\n        id\n        name\n        avatar\n        tags {\n          id\n          name\n        }\n        contacts {\n          firstName\n          lastName\n          email\n          id\n        }\n      }\n      contacts {\n        id\n        firstName\n        lastName\n        email\n      }\n      from {\n        avatar\n        name\n        email\n      }\n      to {\n        avatar\n        name\n        partnerId\n        contactIds\n      }\n      toEmails\n      supplierInfo {\n        termsAndConditions\n        submissionCriteria\n        marketInfo\n      }\n      hasNewComments\n    }\n  }\n";
var getContractDetailsQuery = exports.getContractDetailsQuery = "\n  query getContract ($contractId: ID!, $viewerId: ID, $viewBy: String!, $email: String, $realActorEmail: String,\n    $hideCancellation: Boolean) {\n    Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy, email: $email) {\n      buyerName\n      email\n      startDate\n      endDate\n      buyerId\n      buyerProfileImageUrl\n      buyerInfo {\n        termsAndConditions\n        submissionCriteria\n        corporateIdentificationNumber\n      }\n      buyerChecked\n      files {\n        _id\n        name\n        path\n        createdAt\n        source\n        category\n      }\n      deadlineDate\n      createdAt\n      shouldSendReminders\n      rateConversionSetting\n      rateConversionStatus\n      priority\n      assignee {\n        userId\n        name\n        email\n      }\n      partners {\n        id\n        name\n        avatar\n        tags {\n          id\n          name\n        }\n        contacts {\n          firstName\n          lastName\n          email\n          id\n        }\n      }\n      contacts {\n        id\n        firstName\n        lastName\n        email\n      }\n      from {\n        avatar\n        name\n        email\n      }\n      to {\n        avatar\n        name\n        partnerId\n        contactIds\n      }\n      toEmails\n      dummySupplierForCR {\n         accountId\n         productType\n         oneOrMulti\n         locations {\n            locationId\n            name\n            products {\n               productId\n               productType\n               name\n            }\n         }\n         templates (realActorEmail: $realActorEmail) {\n            _id\n            threadId\n            originalContractId\n            templateName\n            status\n            magicLink\n            magicLinkForDiffing\n            buyerCreatedFrom\n            startDate\n            endDate\n            locationName\n            createdAt\n            updatedAt\n            completionPercent\n            templateVersions\n            originFrom\n            activities {\n               actor\n               action\n               createdAt\n            }\n            acceptedBy\n         }\n      }\n      " + contractDetailsQuery + "\n";

var draftTemplateContractDetails = exports.draftTemplateContractDetails = "\n  query getContract ($contractId: ID!, $collection: String!, $viewerId: ID!, $viewBy: String!,\n    $hideCancellation: Boolean, $viewOnly: Boolean) {\n    DraftnTemplate (id: $contractId, collection: $collection, viewerId: $viewerId, viewBy: $viewBy, viewOnly: $viewOnly) {\n      draftId\n      policyNotesTemplateId\n      policyNotesTemplateName\n      sameAsCorporatePolicyNotes\n      " + contractDetailsQuery + "\n";

var getLeftNavQuery = exports.getLeftNavQuery = "\n  query getContract ($contractId: ID!, $viewerId: ID!, $realActorEmail: String, $viewBy: String!) {\n    Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy) {\n      lastSent\n      buyerId\n      buyerProfileImageUrl\n      buyerName\n      companyName\n      email\n      forGroupQuote\n      rateContainer {\n        id\n        year\n        partnerName\n      }\n      rateConversionSetting\n      rateConversionStatus\n      priority\n      assignee {\n        userId\n        name\n        email\n      }\n      signatures {\n        signatureText\n        signedBy\n        signedAt\n      }\n      templateFromDummy\n      templateHasDraft\n      buyerHasDraftId\n      buyerCreatedFrom\n      buyerInfo {\n        termsAndConditions\n        submissionCriteria\n        corporateIdentificationNumber\n      }\n      state\n      buyerHasNewComments\n      supplierHasNewComments\n      oldContractId\n      buyerDownloaded\n      productType\n      amended\n      amendedFrom\n      amendmentInfo {\n        amendedFromId\n        isInitialAmendmentDraft\n        amended\n        amendmentId\n      }\n      respondedContracts\n      hasDraft\n      draftMagicLink (realActorEmail: $realActorEmail)\n      buyerChecked\n      supplierChecked\n      emailStatus\n      versions\n      allVersions\n      buyerChecked\n      files {\n        _id\n        name\n        path\n        createdAt\n        source\n      }\n      privateDomain\n      domain\n      historyFeedId\n      senderCompanyId\n      viewedBy\n      isViewed\n      isSender\n      isRequest\n      viewingAs\n      partners {\n        id\n        name\n        avatar\n        tags {\n          id\n          name\n        }\n        contacts {\n          firstName\n          lastName\n          email\n          id\n        }\n      }\n      contacts {\n        id\n        firstName\n        lastName\n        email\n      }\n      from {\n        avatar\n        name\n        email\n      }\n      to {\n        avatar\n        name\n        partnerId\n        contactIds\n      }\n      toEmails\n      hasNewComments\n      " + leftNavFields + "\n";
var draftTemplateLeftNav = exports.draftTemplateLeftNav = "\n  query getContract ($contractId: ID!, $collection: String!, $viewerId: ID!, $viewBy: String!, $realActorEmail: String, $email: String, $hideRates: Boolean, $viewOnly: Boolean) {\n    DraftnTemplate (id: $contractId, collection: $collection, viewerId: $viewerId, viewBy: $viewBy, viewOnly: $viewOnly) {\n      originFrom\n      draftId\n      originalContractId\n      productType\n      templateName\n      templateHasDraft\n      defaultInvitees\n      signatures {\n         invitee\n         inviteSentAt\n         inviteSentBy\n      }\n      acceptedBy\n      draftType\n      threadId\n      state\n      supplierName\n      hasSeenResponseWizard\n      templateVersions\n      allTemplateVersions\n      allContractingReadyProducts {\n        productId\n        productName\n        productType\n        bedsAndSofasComplete\n        bedsAndSofas {\n          isApartment\n          rooms {\n            count\n            bedType\n            other\n          }\n        }\n        added\n      }\n      partnersCount\n      sentPartners {\n        _id\n        from {\n          avatar\n          name\n          email\n        }\n        to {\n          avatar\n          name\n          partnerId\n          contactIds\n        }\n        toEmails\n        locationId\n        email\n        companyName\n        locationName\n        state\n        versions\n        startDate\n        endDate\n        updatedAt\n      }\n      stagedUpdates {\n        source\n        sourceId\n        message\n      }\n      templates (realActorEmail: $realActorEmail, accountUserEmail: $email) {\n        _id\n        templateName\n        startDate\n        endDate\n        locationId\n        createdAt\n      }\n      editHistory {\n        detail\n        productId\n        ratePackageName\n      }\n      syncedSections\n      createdAt\n      productSharedData {\n        allExtras {\n          _id\n          extraType\n          extraCode\n          description\n          taxInclusion\n          currency\n          taxType\n          nonStandardTemplateType\n          commissionPercentage\n          nettCommission\n          rateType\n          rates { ...rateFragment }\n          ratePackages\n        }\n        allOffers {\n          _id\n          rates { ...rateFragment }\n          offerName\n          bookingCode\n          offerDetail\n          specialConditions\n          allowCombination\n          offerType\n          numberOfGuests\n          rate\n          discountType\n          amount\n          nonStandardTemplateType\n          commissionPercentage\n          nettCommission\n          rateType\n          validDatesOfSale {\n            fromDate\n            toDate\n          }\n          validDatesOfTravel {\n            fromDate\n            toDate\n          }\n          isStayPay\n          stayPays {\n            stayDays\n            payDays\n            maxFOC\n          }\n          daysOfWeek\n          ratePackages\n        }\n      }\n      " + leftNavFields + "\n  fragment rateFragment on ratesType {\n    priceCode\n    notApplicable\n    description\n    minGuests\n    maxAdults\n    maxAdultsPlusChild\n    retailRate (hideRates: $hideRates)\n    nettRate (hideRates: $hideRates)\n    extraAdult\n    extraChild\n  }\n";
var getProductDetailsQuery = exports.getProductDetailsQuery = "\n  query getProduct(\n    $contractId: ID!,\n    $productId: ID!,\n    $viewerId: ID!,\n    $viewBy: String!,\n    $ratePackage: String,\n    $hideRates: Boolean,\n    $hideCancellation: Boolean,\n    $hideOffers: Boolean,\n    $hideAllocation: Boolean,\n    ) {\n    Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy) {\n      buyerId\n      " + supplierProductFields;

var draftTemplateProductQuery = exports.draftTemplateProductQuery = "\n  query getProduct(\n    $contractId: ID!,\n    $collection: String!,\n    $productId: ID!,\n    $viewerId: ID!,\n    $viewBy: String!,\n    $ratePackage: String,\n    $hideRates: Boolean,\n    $hideCancellation: Boolean,\n    $hideOffers: Boolean,\n    $hideAllocation: Boolean,\n    $viewOnly: Boolean,\n    ) {\n    DraftnTemplate (id: $contractId, collection: $collection, viewerId: $viewerId, viewBy: $viewBy, viewOnly: $viewOnly) {\n    draftId\n    productType\n    formData (productId: $productId){\n      currency\n      rateType\n      taxType\n      taxInclusion\n      commissionPercentage\n      nettCommission\n      includedGuestsinBaseRate\n      maxAdultsChildren\n      maxAdults\n      additionalAdult\n      additionalAdultRetail\n      additionalChild\n      additionalChildRetail\n      paxMax\n      twinBedsAvail\n    }\n    " + supplierProductFields;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var myProductMutation = exports.myProductMutation = "mutation mutate ($productId: ID!, $supplierId: ID!, $update: ProfileProductInputType! ){\n  editProduct (\n    productId: $productId,\n    supplierId: $supplierId,\n    update:$update,\n  ) {\n    locationId\n    productId\n    isMarketingReady\n  }\n}";

var myProductProfileQuery = exports.myProductProfileQuery = "query getMyProductProfile ($productId: ID!) {\n      productProfile  (id: $productId) {\n        id\n        name\n        productId\n        amenities\n        bedsAndSofas {\n          isApartment\n          rooms {\n            count\n            bedType\n            other\n          }\n        }\n        checkIn\n        checkOut\n        description\n        imageUrls\n        isMarketingReady\n        interconnectingRooms\n        locationName\n        locationId\n        productCode\n        notes\n        totalMaxPassengers\n        totalMinPassengers\n        productName\n        companyId\n        companyName\n        profileImageUrl\n        coverImageUrl\n        tourDuration {\n          value\n          unit\n        }\n        tourDurationDoesNotApply\n        roomCountInfo {\n          value\n          unit\n        }\n        roomSizeInfo {\n          value\n          unit\n        }\n        productInfo {\n          include\n          exclude\n          whatToBring\n        }\n        roomSize\n        productType\n        type\n      }\n    }";

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(26);

var policiesInCaps = {
  cancellation: 'Cancellation',
  group: 'Group',
  freeOfCharge: 'Free of Charge',
  family: 'Family',
  child: 'Child',
  infant: 'Infant'
};
var editSupplierContract = function editSupplierContract(contractDetails, payload) {
  var initialContractDetails = (0, _immutable.fromJS)(contractDetails);
  switch (payload.updateType) {
    case 'SAVED_CHECKIN_AND_CHECKOUT':
      return {
        contractDetails: (0, _immutable.fromJS)({
          checkIn: payload.data.checkIn,
          checkOut: payload.data.checkOut,
          earlyCheckIn: payload.data.earlyCheckInChecked ? payload.data.earlyCheckIn : undefined,
          earlyCheckInFee: payload.data.earlyCheckInChecked ? payload.data.earlyCheckInFee : undefined,
          earlyCheckInCostType: payload.data.earlyCheckInChecked ? payload.data.earlyCheckInCostType : undefined,
          earlyCheckInPercentageType: payload.data.earlyCheckInChecked ? payload.data.earlyCheckInPercentageType : undefined,
          lateCheckOut: payload.data.lateCheckOutChecked ? payload.data.lateCheckOut : undefined,
          lateCheckOutFee: payload.data.lateCheckOutChecked ? payload.data.lateCheckOutFee : undefined,
          lateCheckOutCostType: payload.data.lateCheckOutChecked ? payload.data.lateCheckOutCostType : undefined,
          lateCheckOutPercentageType: payload.data.lateCheckOutChecked ? payload.data.lateCheckOutPercentageType : undefined,
          sameAsCorporatePolicyNotes: !initialContractDetails.get('sameAsCorporatePolicyNotes') ? [] : initialContractDetails.get('sameAsCorporatePolicyNotes').filter(function (str) {
            return str !== 'checkinout';
          })
        }),
        editHistory: {
          detail: 'Updated Check-in & Check-out information',
          contractId: payload.contractId
        }
      };
    case 'SAVE_POLICY_ADD_EDIT':
      var updateCxl = (initialContractDetails.toJS().locationPolicy || []).some(function (policy) {
        return policy.policyType === payload.data.policyType;
      });
      return {
        contractDetails: (0, _immutable.fromJS)({
          locationPolicy: initialContractDetails.get('locationPolicy'),
          sameAsCorporatePolicyNotes: !initialContractDetails.get('sameAsCorporatePolicyNotes') ? [] : initialContractDetails.get('sameAsCorporatePolicyNotes').filter(function (str) {
            return str !== payload.data.policyType;
          })
        }).update('locationPolicy', function (locationPolicy) {
          if (locationPolicy && locationPolicy.every(function (policy) {
            return policy.get('policyType') !== payload.data.policyType;
          })) {
            return locationPolicy.push((0, _immutable.fromJS)(payload.data));
          }
          return locationPolicy.map(function (policy) {
            if (policy.get('policyType') === payload.data.policyType) {
              return policy.merge((0, _immutable.fromJS)(payload.data));
            }
            return policy;
          });
        }),
        editHistory: {
          detail: (updateCxl ? 'Updated' : 'Added') + ' ' + policiesInCaps[payload.data.policyType] + ' Policy Info',
          contractId: payload.contractId
        }
      };
    case 'DELETE_LOCATION_POLICY':
      return {
        contractDetails: (0, _immutable.fromJS)({
          locationPolicy: initialContractDetails.get('locationPolicy').filter(function (policy) {
            return policy.get('policyType') !== payload.data.policyType;
          }),
          sameAsCorporatePolicyNotes: !initialContractDetails.get('sameAsCorporatePolicyNotes') ? [] : initialContractDetails.get('sameAsCorporatePolicyNotes').filter(function (str) {
            return str !== payload.data.policyType;
          })
        }),
        editHistory: {
          detail: 'Deleted ' + policiesInCaps[payload.data.policyType] + ' Policy Info',
          contractId: payload.contractId
        }
      };
    case 'UPDATE_SUPPLIER_INFO_TERMS_NOTES':
      return {
        contractDetails: (0, _immutable.fromJS)({
          supplierInfo: initialContractDetails.get('supplierInfo'),
          sameAsCorporatePolicyNotes: !initialContractDetails.get('sameAsCorporatePolicyNotes') ? [] : initialContractDetails.get('sameAsCorporatePolicyNotes').filter(function (str) {
            return str !== payload.data.fieldName;
          })
        }).setIn(['supplierInfo', payload.data.fieldName], payload.data.value),
        editHistory: { detail: 'Updated Terms and Notes', contractId: payload.contractId }
      };
    case 'UPDATE_MARKET_INFO':
      return {
        contractDetails: (0, _immutable.fromJS)({
          supplierInfo: initialContractDetails.get('supplierInfo'),
          sameAsCorporatePolicyNotes: !initialContractDetails.get('sameAsCorporatePolicyNotes') ? [] : initialContractDetails.get('sameAsCorporatePolicyNotes').filter(function (str) {
            return str !== 'marketInfo';
          })
        }).setIn(['supplierInfo', payload.data.fieldName], payload.data.value),
        editHistory: { detail: 'Updated Market Information', contractId: payload.contractId }
      };
    case 'SAVE_BILLING_INFO_ADD_EDIT':
      return {
        contractDetails: (0, _immutable.fromJS)({
          billingInformation: payload.data,
          sameAsCorporatePolicyNotes: !initialContractDetails.get('sameAsCorporatePolicyNotes') ? [] : initialContractDetails.get('sameAsCorporatePolicyNotes').filter(function (str) {
            return str !== payload.type;
          })
        }),
        editHistory: { detail: 'Updated Billing Information', contractId: payload.contractId }
      };
    case 'SAVE_CONTRACT_PERIOD':
      // for workspace or template draft
      return {
        contractDetails: (0, _immutable.fromJS)({
          startDate: payload.data.newStartDate,
          endDate: payload.data.newEndDate
        }),
        editHistory: { detail: 'Update Contract Period', contractId: payload.contractId }
      };
    case 'SAVE_LOCATION_NAME':
      // only for buyer's dummy rate sheet
      return {
        contractDetails: (0, _immutable.fromJS)({
          locationName: payload.data.newLocationName
        }),
        editHistory: { detail: 'Update Location Name', contractId: payload.contractId }
      };
    default:
      return {
        contractDetails: initialContractDetails
      };
  }
};

exports.default = editSupplierContract;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACCEPT_CONNECTION = exports.ACCEPT_CONNECTION = 'ACCEPT_CONNECTION';
var ACCEPT_CONNECTION_STARTING = exports.ACCEPT_CONNECTION_STARTING = 'ACCEPT_CONNECTION_STARTING';
var ADD_TAG = exports.ADD_TAG = 'ADD_TAG';
var ADD_TAG_STARTING = exports.ADD_TAG_STARTING = 'ADD_TAG_STARTING';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';
var FILTER_CONNECTIONS = exports.FILTER_CONNECTIONS = 'FILTER_CONNECTIONS';
var FILTER_CONNECTIONS_BY_COUNTRY = exports.FILTER_CONNECTIONS_BY_COUNTRY = 'FILTER_CONNECTIONS_BY_COUNTRY';
var GET_COUNTRIES = exports.GET_COUNTRIES = 'GET_COUNTRIES';
var IGNORE_CONNECTION = exports.IGNORE_CONNECTION = 'IGNORE_CONNECTION';
var IGNORE_CONNECTION_STARTING = exports.IGNORE_CONNECTION_STARTING = 'IGNORE_CONNECTION_STARTING';
var LOAD_MORE_CONNECTIONS = exports.LOAD_MORE_CONNECTIONS = 'LOAD_MORE_CONNECTIONS';
var RESEND_CONNECTION_STARTING = exports.RESEND_CONNECTION_STARTING = 'RESEND_CONNECTION_STARTING';
var RESEND_CONNECTION = exports.RESEND_CONNECTION = 'RESEND_CONNECTION';
var REMOVE_COUNTRY_FILTER = exports.REMOVE_COUNTRY_FILTER = 'REMOVE_COUNTRY_FILTER';
var REMOVE_TAG_STARTING = exports.REMOVE_TAG_STARTING = 'REMOVE_TAG_STARTING';
var REMOVE_CONNECTION = exports.REMOVE_CONNECTION = 'REMOVE_CONNECTION';
var REMOVE_TAG = exports.REMOVE_TAG = 'REMOVE_TAG';
var REMOVE_CONNECTION_STARTING = exports.REMOVE_CONNECTION_STARTING = 'REMOVE_CONNECTION_STARTING';
var SEARCH_CONTACTS_BY_COMPANY_NAME = exports.SEARCH_CONTACTS_BY_COMPANY_NAME = 'SEARCH_CONTACTS_BY_COMPANY_NAME';
var CONNECTIONS_IS_SYNCING = exports.CONNECTIONS_IS_SYNCING = 'CONNECTIONS_IS_SYNCING';
var UNDO_CONNECTION_CHANGE = exports.UNDO_CONNECTION_CHANGE = 'UNDO_CONNECTION_CHANGE';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editNotificationSettings = undefined;
exports.updateUserProps = updateUserProps;
exports.clearStores = clearStores;
exports.getUser = getUser;
exports.planUpdate = planUpdate;
exports.updateUpgradeSource = updateUpgradeSource;
exports.logUpgradeClick = logUpgradeClick;
exports.authReceived = authReceived;
exports.setMarketingReadinessForUser = setMarketingReadinessForUser;
exports.onBoardingComplete = onBoardingComplete;

var _userConstants = __webpack_require__(1098);

var constants = _interopRequireWildcard(_userConstants);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _docCookie = __webpack_require__(142);

var _docCookie2 = _interopRequireDefault(_docCookie);

var _api = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function updateUserProps(payload) {
  return { type: constants.UPDATE_USER_PROP, payload: payload };
}

var editNotificationSettings = exports.editNotificationSettings = function editNotificationSettings(payload) {
  return function (dispatch) {
    dispatch({ type: constants.EDIT_NOTIFICATION_STARTING });
    return fetch('/proxy/settings/notifications', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.error) return dispatch({ type: constants.EDIT_NOTIFICATION_FAILED, payload: response.error });
      return dispatch({ type: constants.EDIT_NOTIFICATION_FINISHED, payload: response });
    }).catch(function (err) {
      console.log(err);
      dispatch({ type: constants.EDIT_NOTIFICATION_FAILED });
    });
  };
};

function deleteAllCookies() {
  // document.cookie.replace(
  //   /(?<=^|;).+?(?=\=|;|$)/g,
  //   name => location.hostname
  //   .split(/\.(?=[^\.]+\.)/)
  //   .reduceRight((acc, val, i, arr) => i ? arr[i] = `.${val}${acc}` : (arr[i] = '', arr), '')
  //   .map(domain => document.cookie = `${name}=;max-age=0;path=/;domain=${domain}`)
  // );
  // avoid using "lookbehind" regex as it breaks safari
  document.cookie.split(';').forEach(function (cookie) {
    var cookieName = cookie.trim().split('=')[0];
    var subdomains = location.hostname.split(/\.(?=[^\.]+\.)/);

    subdomains.reduceRight(function (acc, val, i, arr) {
      if (i) {
        arr[i] = '.' + val + acc;
      } else {
        arr[i] = '';
      }
      return acc;
    }, '');

    subdomains.forEach(function (domain) {
      if (domain) {
        document.cookie = cookieName + '=;max-age=0;path=/;domain=' + domain;
      }
    });
  });
}

var logout = function logout() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var token, res, res2;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              token = localStorage.getItem('jwt');

              if (_docCookie2.default.hasItem('isAnAdmin')) _docCookie2.default.removeItem('isAnAdmin', '/', window.location.host.split('.')[1] + '.com');
              localStorage.clear();
              deleteAllCookies();
              // logout the middleware
              _context.next = 6;
              return fetch('/logout', {
                method: 'post',
                credentials: 'same-origin',
                body: JSON.stringify({}),
                headers: { 'Accept': 'text/html', 'Content-Type': 'application/json' }
              });

            case 6:
              res = _context.sent;
              _context.next = 9;
              return fetch((undefined || "https://rest.tourconnect.com") + '/logout', {
                method: 'post',
                credentials: 'same-origin',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + token
                }
              });

            case 9:
              _context.next = 11;
              return (0, _checkStatus2.default)(res);

            case 11:
              res2 = _context.sent;

              // remove the localStorage key from the new app
              window.location = "https://app.tourconnect.com" + '?logout=true';
              return _context.abrupt('return', dispatch({ type: constants.LOG_OUT, user: res2 }));

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
module.exports.logout = logout;

function clearStores(isForAdmin, authToken) {
  return {
    type: constants.CLEAR_STORES,
    payload: { isForAdmin: isForAdmin, authToken: authToken }
  };
}

function getUser(refresh) {
  return function (dispatch) {
    return (0, _api.callApiJWT)('/users', 'get').then(function (_ref2) {
      var res = _ref2.response;
      return dispatch({ type: constants.GET_USER, user: res, refresh: refresh });
    }).catch(function (err) {
      if (err.message === 'Unauthorized') {
        return dispatch(logout()).then(function () {
          window.location.reload();
        });
      }
    });
  };
}

function planUpdate(plan) {
  return {
    type: constants.USER_STORE_PLAN_UPDATE,
    payload: plan
  };
}

function updateUpgradeSource(source) {
  return {
    type: constants.UPDATE_UPGRADE_SOURCE,
    payload: source
  };
}

function logUpgradeClick(source, type) {
  return function (dispatch) {
    return fetch('/proxy/logupgradeclick', {
      method: 'put',
      credentials: 'same-origin',
      body: JSON.stringify({ source: source, type: type }),
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function () {
      return dispatch({ type: constants.LOG_UPGRADE_CLICK });
    }).catch(function (err) {
      return console.log('err in logupgradeclick', err);
    });
  };
}

function authReceived(cookieInfo) {
  return {
    type: constants.AUTH_RECEIVED,
    payload: cookieInfo
  };
}

function setMarketingReadinessForUser() {
  return {
    type: constants.SET_MARKET_READINESS_FOR_USER_STORE
  };
}

function onBoardingComplete() {
  return {
    type: constants.ONBOARDING_COMPLETE
  };
}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactDom = __webpack_require__(47);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dropzone = (0, _react.createClass)({

  propTypes: {
    onDrop: _react.PropTypes.func.isRequired,
    size: _react.PropTypes.number,
    style: _react.PropTypes.object,
    disableClick: _react.PropTypes.bool,
    className: _react.PropTypes.string,
    children: _react.PropTypes.any
  },

  getInitialState: function getInitialState() {
    return {
      isDragActive: false
    };
  },
  onDragLeave: function onDragLeave() {
    this.setState({
      isDragActive: false
    });
  },
  onDragOver: function onDragOver(e) {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';

    this.setState({
      isDragActive: true
    });
  },
  onDrop: function onDrop(e) {
    e.preventDefault();

    this.setState({
      isDragActive: false
    });

    var files = void 0;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }

    if (this.props.onDrop) {
      files = Array.prototype.slice.call(files);
      this.props.onDrop(files);
    }
  },
  _click: function _click() {
    if ((0, _reactDom.findDOMNode)(this.refs.fileInput).value) (0, _reactDom.findDOMNode)(this.refs.fileInput).value = null;
    if (!this.props.disableClick) {
      this._triggerClick();
    }
  },
  openFileBox: function openFileBox() {
    this._triggerClick();
  },
  _triggerClick: function _triggerClick() {
    (0, _reactDom.findDOMNode)(this.refs.fileInput).click();
  },
  render: function render() {
    var className = this.props.className || 'dropzone';
    if (this.state.isDragActive) {
      className += ' active';
    }
    var style = _extends({
      minHeight: '',
      border: 'none'
    }, this.props.style);

    return _react2.default.createElement(
      'div',
      { className: className, style: style, onClick: this._click, onDragLeave: this.onDragLeave, onDragOver: this.onDragOver, onDrop: this.onDrop },
      _react2.default.createElement('input', { style: { display: 'none' }, type: 'file', multiple: true, ref: 'fileInput', onChange: this.onDrop }),
      this.props.children
    );
  }
});

exports.default = Dropzone;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var activeColor = 'rgba(0, 0, 0, 0.64)';
var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages,
      goToPage = _ref.goToPage,
      noOfPagesToShow = _ref.noOfPagesToShow,
      style = _ref.style;

  var pages = new Array(totalPages).fill(1).reduce(function (result, _, index) {
    result.push(index + 1);
    return result;
  }, []);
  var start = (0, _ramda.cond)([[(0, _ramda.gt)(0), (0, _ramda.always)(0)], [(0, _ramda.lt)(totalPages - noOfPagesToShow), (0, _ramda.always)(totalPages - noOfPagesToShow)], [_ramda.T, _ramda.identity]])(currentPage - (noOfPagesToShow + 1) / 2);
  return _react2.default.createElement(
    'div',
    { style: (0, _ramda.merge)({ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }, style) },
    _react2.default.createElement(
      _materialUi.IconButton,
      { onTouchTap: function onTouchTap() {
          return goToPage(currentPage - 1);
        }, disabled: currentPage === 1 },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-chevron-left', color: currentPage === 1 ? '' : activeColor })
    ),
    (0, _ramda.slice)(start < 0 ? 0 : start, start + noOfPagesToShow, pages).map(function (pageNo) {
      return _react2.default.createElement(_materialUi.FlatButton, {
        onTouchTap: function onTouchTap() {
          return goToPage(pageNo);
        },
        key: pageNo,
        label: pageNo,
        secondary: pageNo === currentPage
      });
    }),
    _react2.default.createElement(
      _materialUi.IconButton,
      { onTouchTap: function onTouchTap() {
          return goToPage(currentPage + 1);
        }, disabled: currentPage === totalPages },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-chevron-right', color: currentPage === totalPages ? '' : activeColor })
    )
  );
};

exports.default = Pagination;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.isValidEmail = function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

exports.isValidTime = function () {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var reg = new RegExp('(^([0-9]|[0-1][0-9]|[2][0-3]):([0-5][0-9])(\\s{0,1})(AM|PM|am|pm|aM|Am|pM|Pm{2,2})$)|(^([0-9]|[1][0-9]|[2][0-3])(\\s{0,1})(AM|PM|am|pm|aM|Am|pM|Pm{2,2})$)');
  return reg.test(str.trim());
};

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indexedMap = exports.isValidArray = exports.isNonArrayObject = exports.isValidObject = exports.isValidNumber = exports.makePlural = exports.neither = exports.nand = exports.notEqual = exports.removeAtIndex = exports.getIn = undefined;

var _ramda = __webpack_require__(2);

var getIn = exports.getIn = (0, _ramda.curry)(function (keyMap, obj) {
  return (0, _ramda.view)((0, _ramda.lensPath)(keyMap), obj);
});
var removeAtIndex = exports.removeAtIndex = (0, _ramda.remove)(_ramda.__, 1);
var notEqual = exports.notEqual = (0, _ramda.complement)(_ramda.equals);
var nand = exports.nand = (0, _ramda.complement)(_ramda.and);
var neither = exports.neither = (0, _ramda.complement)(_ramda.or);
var makePlural = exports.makePlural = (0, _ramda.curry)(function (str, num) {
  return (0, _ramda.call)((0, _ramda.compose)((0, _ramda.concat)(str), (0, _ramda.ifElse)(_ramda.identity, (0, _ramda.always)(''), (0, _ramda.always)('s')), (0, _ramda.equals)(1)), num);
});
var isValidNumber = exports.isValidNumber = (0, _ramda.both)((0, _ramda.is)(Number), (0, _ramda.complement)((0, _ramda.equals)(NaN)));

var isValidObject = exports.isValidObject = (0, _ramda.both)((0, _ramda.complement)(_ramda.isNil), (0, _ramda.is)(Object));
var isNonArrayObject = exports.isNonArrayObject = (0, _ramda.both)(isValidObject, (0, _ramda.complement)(Array.isArray));
var isValidArray = exports.isValidArray = (0, _ramda.both)(isValidObject, Array.isArray);
var indexedMap = exports.indexedMap = (0, _ramda.addIndex)(_ramda.map);

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _materialUi = __webpack_require__(3);

var _connectionsSearch = __webpack_require__(2828);

var _connectionsSearch2 = _interopRequireDefault(_connectionsSearch);

var _carousel = __webpack_require__(1226);

var _carousel2 = _interopRequireDefault(_carousel);

var _jquery = __webpack_require__(251);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = (0, _react.createClass)({

  propTypes: {
    title: _react.PropTypes.string,
    subtitle: _react.PropTypes.string,
    padded: _react.PropTypes.bool,
    className: _react.PropTypes.string,
    isFixed: _react.PropTypes.bool,
    isSticky: _react.PropTypes.bool,
    listCard: _react.PropTypes.any,
    children: _react.PropTypes.any,
    locationData: _react.PropTypes.any,
    companyData: _react.PropTypes.any,
    productData: _react.PropTypes.any,
    search: _react.PropTypes.any,
    titleBarExtra: _react.PropTypes.any,
    searchHeader: _react.PropTypes.any,
    headerImages: _react.PropTypes.array,
    style: _react.PropTypes.object,
    contentsStyle: _react.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      padded: true
    };
  },
  componentDidMount: function componentDidMount() {
    var resizeCss = function resizeCss(wrapper) {
      var wRatio = 744 / this.naturalWidth;
      var hRatio = 320 / this.naturalHeight;
      var ratio = Math.min(wRatio, hRatio);

      if (this.naturalWidth > this.naturalHeight) {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto'
        });
      } else {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto'
        });
      }
    };

    var $image = (0, _jquery2.default)('.tc-card-header-image');
    $image.load(function () {
      resizeCss.call(this, $image);
    });
  },
  render: function render() {
    var outerChildren = void 0;
    var innerChildren = void 0;
    var classes = (0, _classnames2.default)('tc-card', this.props.className, {
      'is-padded': this.props.padded,
      'is-fixed': this.props.isFixed,
      'is-sticky': this.props.isSticky
    });

    if (this.props.children.length === 2 && this.props.listCard) {
      outerChildren = _react2.default.createElement(
        'div',
        { className: 'tc-card-header-tags' },
        this.props.children[0]
      );
      innerChildren = this.props.children[1];
    } else {
      innerChildren = this.props.children;
    }

    if (this.props.locationData || this.props.companyData || this.props.productData) {
      innerChildren = this.props.children;
    }
    var titleElement = this.props.title ? _react2.default.createElement(
      'h4',
      { className: 'tc-card-header-title' },
      this.props.title
    ) : outerChildren;

    var subTitleElement = this.props.subtitle ? _react2.default.createElement(
      'h6',
      { className: 'tc-card-header-subtitle' },
      this.props.subtitle
    ) : null;
    var cardHeaderElement = (titleElement || subTitleElement) && !this.props.search ? _react2.default.createElement(
      'div',
      { className: 'tc-card-header' },
      titleElement,
      subTitleElement,
      this.props.titleBarExtra
    ) : null;

    var width = void 0;
    if (this.props.isFixed && document.getElementsByClassName('connections-list').length) {
      width = { width: window.getComputedStyle(document.getElementsByClassName('connections-list')[0]).getPropertyValue('width') };
    }
    var searchHeader = titleElement && this.props.searchHeader ? _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'tc-card-header search-header' },
        _react2.default.createElement(_connectionsSearch2.default, _extends({ className: 'search-header-search-bar' }, this.props))
      ),
      _react2.default.createElement(
        'div',
        { className: 'tc-card-header search-header' },
        titleElement,
        _react2.default.createElement(_connectionsSearch2.default, _extends({
          className: 'search-header-tool-bar'
        }, this.props, {
          connectionsToolbar: true
        }))
      )
    ) : null;

    var header = void 0;
    if (this.props.headerImages && this.props.headerImages.length) {
      if (this.props.headerImages.length > 1) header = _react2.default.createElement(_carousel2.default, { photos: this.props.headerImages });else {
        header = _react2.default.createElement(
          'div',
          { style: { backgroundColor: 'black' } },
          _react2.default.createElement('img', { className: 'tc-card-header-image', src: this.props.headerImages })
        );
      }
    } else {
      header = _react2.default.createElement(
        'div',
        { style: width, className: 'tc-header-container' },
        cardHeaderElement || searchHeader
      );
    }

    return _react2.default.createElement(
      _materialUi.Paper,
      { className: classes, style: this.props.style },
      header,
      _react2.default.createElement(
        'div',
        { className: 'tc-card-contents', style: this.props.contentsStyle },
        innerChildren
      )
    );
  }
});

exports.default = Card;

/***/ }),
/* 874 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(1052),
    overRest = __webpack_require__(1889),
    setToString = __webpack_require__(1506);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationMoreVert = function NavigationMoreVert(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
  );
};
NavigationMoreVert = (0, _pure2.default)(NavigationMoreVert);
NavigationMoreVert.displayName = 'NavigationMoreVert';
NavigationMoreVert.muiName = 'SvgIcon';

exports.default = NavigationMoreVert;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocationsAndProducts = exports.getTemplatesForGroupWizard = exports.getTemplates = exports.getContractsCount = exports.editTemplateGroup = exports.createTemplateGroup = exports.createDraft = exports.saveNewTemplateName = exports.deleteDraft = exports.deleteTemplate = exports.downloadPdfZip = exports.downloadContractPdf = exports.archiveUnarchive = exports.updateDraftProps = exports.updateTemplateProps = exports.updateFilters = exports.updateProps = exports.updateLocationProps = undefined;

var _templateListConstants = __webpack_require__(1845);

var constants = _interopRequireWildcard(_templateListConstants);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _bluebird = __webpack_require__(1114);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _contractingUtils = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var updateLocationProps = exports.updateLocationProps = function updateLocationProps(payload) {
  return { type: constants.UPDATE_LOC_PROPS, payload: payload };
};
var updateProps = exports.updateProps = function updateProps(payload) {
  return { type: constants.UPDATE_PROPS, payload: payload };
};
var updateFilters = exports.updateFilters = function updateFilters(payload) {
  return { type: constants.UPDATE_FILTERS, payload: payload };
};
var updateTemplateProps = exports.updateTemplateProps = function updateTemplateProps(templateId, data) {
  return { type: constants.UPDATE_TEMPLATE_PROPS, payload: { templateId: templateId, data: data } };
};
var updateDraftProps = exports.updateDraftProps = function updateDraftProps(draftId, data) {
  return { type: constants.UPDATE_DRAFT_PROPS, payload: { draftId: draftId, data: data } };
};
var archiveUnarchive = exports.archiveUnarchive = function archiveUnarchive(payload) {
  return { type: 'ARCHIVE_UNARCHIVE_TEMPLATE', payload: payload };
};
var credentialsAndHeaders = {
  credentials: 'same-origin',
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
};
var put = function put(body) {
  return _ramda2.default.merge({ method: 'put', body: JSON.stringify(body) }, credentialsAndHeaders);
};
var getFetch = _ramda2.default.merge({ method: 'get' }, credentialsAndHeaders);
var post = function post(body) {
  return _ramda2.default.merge({ method: 'post', body: JSON.stringify(body) }, credentialsAndHeaders);
};
var del = function del(body) {
  return _ramda2.default.merge({ method: 'delete', body: JSON.stringify(body) }, credentialsAndHeaders);
};
var callApiGet = function callApiGet(url) {
  return fetch(url, getFetch).then(_checkStatus2.default);
};
var callApiPost = function callApiPost(url, body) {
  return fetch(url, post(body)).then(_checkStatus2.default);
};
var getDownloadPdfLink = function getDownloadPdfLink(templateId) {
  var url = '/proxy/download-pdf';
  var qs = _queryString2.default.stringify({
    contractIds: JSON.stringify([templateId]),
    locale: (0, _moment2.default)().utcOffset(),
    collection: 'template'
  });
  return url + '?' + qs;
};
var downloadContractPdf = exports.downloadContractPdf = function downloadContractPdf(templateId, anchorEl) {
  return function (dispatch) {
    dispatch({
      type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
      payload: {
        docId: templateId,
        collection: 'template',
        anchorEl: anchorEl
      }
    });
  };
};

var downloadPdfZip = exports.downloadPdfZip = function downloadPdfZip(templates, templateGroupName) {
  return function (dispatch) {
    dispatch({
      type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
      payload: {
        templates: templates,
        collection: 'template',
        templateGroupName: templateGroupName,
        isBulk: true
      }
    });
    // dispatch({ type: constants.DOWNLOADING_PDF_ZIP });
    // if (R.isEmpty(templates)) return dispatch({ type: constants.PDF_ZIP_DOWNLOADED });
  };
};
var deleteTemplate = exports.deleteTemplate = function deleteTemplate(templateId) {
  return function (dispatch) {
    return fetch('/proxy/contracting/template', del({ templateId: templateId })).then(_checkStatus2.default).then(function () {
      return dispatch({ type: constants.TEMPLATE_DELETED, payload: { templateId: templateId } });
    }).catch(function () {
      return dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Delete template failed' });
    });
  };
};
var deleteDraft = exports.deleteDraft = function deleteDraft(editedDraft, originalContractId) {
  return function (dispatch) {
    return fetch(editedDraft ? '/proxy/contracting/discardEditedDraft/' + originalContractId : '/proxy/contracting/template/draft', del({ originalContractId: originalContractId })).then(_checkStatus2.default).then(function () {
      return dispatch({ type: constants.DRAFT_DELETED, payload: { draftId: originalContractId } });
    }).catch(function () {
      return dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Delete draft failed' });
    });
  };
};
var saveNewTemplateName = exports.saveNewTemplateName = function saveNewTemplateName(templateOrDraft, id, newName) {
  return function (dispatch) {
    dispatch({ type: constants.UPDATING_TEMPLATE_NAME, payload: { templateId: id, templateOrDraft: templateOrDraft } });
    return fetch('/proxy/contracting/template/templateName', put({ newName: newName, templateId: id, templateOrDraft: templateOrDraft })).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      if (res.duplicateExists) {
        dispatch({ type: constants.TEMPLATE_NAME_UPDATED_DUPLICATED, payload: { templateId: id, templateOrDraft: templateOrDraft, newName: newName } });
      } else dispatch({ type: constants.TEMPLATE_NAME_UPDATED, payload: { templateId: id, templateOrDraft: templateOrDraft, newName: newName } });
    }).catch(function () {
      dispatch({ type: constants.UPDATING_TEMPLATE_NAME, payload: { templateId: id, templateOrDraft: templateOrDraft } });
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Saving new template name failed' });
    });
  };
};
var createDraft = exports.createDraft = function createDraft(payload) {
  return function (dispatch) {
    dispatch({ type: constants.STARTING_DRAFT_CREATE, payload: payload });
    return callApiPost('/proxy/contracting/draft/initialDraft', payload).then(function (res) {
      return res.json();
    }).then(function (res) {
      var createNewLoc = _ramda2.default.find(function (loc) {
        return loc.checked && !loc.locationId;
      }, payload.locations);
      if (createNewLoc) {
        dispatch({ type: '[user]UPDATE_USER_LOC_ACCESS_WHEN_NEW_LOC_CREATED', payload: res.drafts.map(_ramda2.default.prop('locationId')) });
      }
      dispatch(getLocationsAndProducts());
      dispatch(getTemplates());
      return dispatch({ type: constants.DRAFT_CREATED, payload: res });
    }).catch(function (err) {
      console.log(err.stack);
      dispatch({ type: constants.STARTING_DRAFT_CREATE, payload: payload });
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Create Template Draft Failed' });
    });
  };
};
var createTemplateGroup = exports.createTemplateGroup = function createTemplateGroup(payload) {
  return function (dispatch) {
    dispatch({ type: constants.STARTING_TEMPLATE_GROUP_CREATION });
    return callApiPost('/proxy/contracting/template-group', payload).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({ type: constants.TEMPLATE_GROUP_CREATED, payload: _ramda2.default.merge(payload, { groupId: res._id }) });
    }).catch(function (err) {
      console.log(err.stack);
      dispatch({ type: constants.STARTING_TEMPLATE_GROUP_CREATION });
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Template Group Creation Failed' });
    });
  };
};
var editTemplateGroup = exports.editTemplateGroup = function editTemplateGroup(payload) {
  return function (dispatch) {
    dispatch({ type: constants.STARTING_TEMPLATE_GROUP_CREATION });
    return fetch('/proxy/contracting/template-group', put(payload)).then(function () {
      dispatch({ type: constants.TEMPLATE_GROUP_UPDATED });
      dispatch(getTemplates());
    }).catch(function (err) {
      console.log(err.stack);
      dispatch({ type: constants.STARTING_TEMPLATE_GROUP_CREATION });
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Template Group Edit Failed' });
    });
  };
};
var getContractsCount = exports.getContractsCount = function getContractsCount(templateIds) {
  return function (dispatch) {
    return _bluebird2.default.each(templateIds, function (templateId) {
      return callApiGet('/proxy/contracting/template/contracts/' + templateId).then(function (res) {
        return res.json();
      }).then(function (res) {
        return dispatch({ type: constants.POPULATE_CONTRACTS_COUNT, payload: { templateId: templateId, partnersCount: res.count } });
      });
    });
  };
};
var getTemplates = exports.getTemplates = function getTemplates() {
  return function (dispatch) {
    dispatch({ type: constants.LOADING_TEMPLATES });
    return callApiGet('/proxy/contracting/template-list').then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({
        type: constants.TEMPLATES_LOADED,
        payload: _ramda2.default.merge(res, {
          listRefreshing: false
        })
      });
    }) // res = { templates, templateGroups }
    .catch(function () {
      dispatch({ type: constants.LOADING_TEMPLATES });
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Loading Templates Failed' });
    });
  };
};
var getTemplatesForGroupWizard = exports.getTemplatesForGroupWizard = function getTemplatesForGroupWizard(query) {
  return function (dispatch, getState) {
    var locAccess = getState().user.toJS().locAccess;
    var locationIds = _ramda2.default.pluck('locId', locAccess.filter(function (loc) {
      return _ramda2.default.contains('write', loc.contracting);
    }));
    dispatch({ type: constants.LOADING_TEMPLATES_FOR_WIZARD });
    var qs = query ? _queryString2.default.stringify({ additionalQuery: JSON.stringify(_ramda2.default.merge(query, { locationId: { $in: locationIds } })) }) : '';
    return callApiGet('/proxy/contracting/templates?' + qs).then(function (res) {
      return res.json();
    }).then(function (res) {
      dispatch({ type: constants.TEMPLATES_LOADED_FOR_WIZARD, payload: _ramda2.default.merge(res, { listRefreshing: false }) });
    }) // res = { templates, templateGroups }
    .catch(function () {
      dispatch({ type: constants.LOADING_TEMPLATES_FOR_WIZARD });
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Loading Templates Failed' });
    });
  };
};

var getLocationsAndProducts = exports.getLocationsAndProducts = function getLocationsAndProducts(locationId) {
  return function (dispatch) {
    return callApiGet('/proxy/contracting/getSupplierLocationsList').then(function (res) {
      return res.json();
    }).then(function (payload) {
      return dispatch({ type: constants.GET_SUPPLIER_LOCATIONS_LIST, payload: _ramda2.default.merge(payload, { locationId: locationId }) });
    }).catch(function () {
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Get location list failed' });
    });
  };
};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifierPropType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3225);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrimitiveTypes = _extends({
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  range: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  }),
  after: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date)
  }),
  before: _propTypes2.default.shape({
    before: _propTypes2.default.instanceOf(Date)
  })
}, _propTypes2.default);

var ModifierPropType = exports.ModifierPropType = _propTypes2.default.oneOfType([PrimitiveTypes.after, PrimitiveTypes.before, PrimitiveTypes.range, _propTypes2.default.func, _propTypes2.default.array]);

exports.default = PrimitiveTypes;
//# sourceMappingURL=PropTypes.js.map

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClickEditCell = function (_Component) {
  _inherits(ClickEditCell, _Component);

  function ClickEditCell(props) {
    _classCallCheck(this, ClickEditCell);

    var _this = _possibleConstructorReturn(this, (ClickEditCell.__proto__ || Object.getPrototypeOf(ClickEditCell)).call(this, props));

    _this._handleMouseOver = function () {
      _this.setState({ mouseOver: true });
    };

    _this._handleMouseLeave = function () {
      _this.setState({ mouseOver: false });
    };

    _this._handleOnChange = function (e) {
      if (!_this.props.stringAllowed && isNaN(e.target.value)) window.alert('Please enter numbers only.');
      _this.props.onChange(e.target.value);
    };

    _this._handleOnBlur = function (e) {
      if (_this.state.value && !_this.props.stringAllowed) _this.setState({ value: Number(_this.state.value).toFixed(_this.props.decimalNumber) }, function () {
        if (_this.props.onBlur) _this.props.onBlur(e);
      });
    };

    _this.state = {
      mouseOver: false,
      value: props.stringAllowed ? props.children : transformNumber(props.children, undefined, props.decimalNumber)
    };
    return _this;
  }

  _createClass(ClickEditCell, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.children !== nextProps.children) this.setState({ value: nextProps.children });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          editable = _props.editable,
          children = _props.children,
          inputAlignRight = _props.inputAlignRight,
          fullWidthInput = _props.fullWidthInput,
          multiLine = _props.multiLine,
          showBorder = _props.showBorder,
          stringAllowed = _props.stringAllowed,
          decimalNumber = _props.decimalNumber,
          defaultValue = _props.defaultValue,
          className = _props.className;

      if (editable) return _react2.default.createElement(
        'div',
        { style: style },
        multiLine ? _react2.default.createElement('textarea', {
          style: { border: '1px solid #00BCD4', textAlign: inputAlignRight ? 'right' : 'left', width: fullWidthInput ? '100%' : '' },
          className: 'clickEditCell ' + className,
          rows: multiLine,
          value: this.state.value || '',
          onBlur: this._handleOnBlur,
          onChange: this._handleOnChange,
          onMouseOver: this._handleMouseOver,
          onMouseLeave: this._handleMouseLeave
        }) : _react2.default.createElement('input', {
          style: { border: '1px solid #00BCD4', textAlign: inputAlignRight ? 'right' : 'left', width: fullWidthInput ? '100%' : '' },
          className: 'clickEditCell ' + className,
          value: this.state.value || '',
          onBlur: this._handleOnBlur,
          onChange: this._handleOnChange,
          onMouseOver: this._handleMouseOver,
          onMouseLeave: this._handleMouseLeave
        })
      );
      var nonEditableContent = function () {
        if (stringAllowed) return children;
        return transformNumber(children, defaultValue, decimalNumber);
      }();
      return _react2.default.createElement(
        'div',
        { style: style },
        _react2.default.createElement(
          'span',
          { className: className },
          nonEditableContent
        )
      );
    }
  }]);

  return ClickEditCell;
}(_react.Component);

;

var transformNumber = function transformNumber(value, defaultValue, decimalNumber) {
  if (isNaN(value) || !value) {
    return defaultValue;
  }
  return Number(value).toFixed(decimalNumber);
};

ClickEditCell.propTypes = {
  style: _react.PropTypes.object,
  editable: _react.PropTypes.bool,
  inputAlignRight: _react.PropTypes.bool,
  children: _react.PropTypes.node,
  onChange: _react.PropTypes.func,
  onClick: _react.PropTypes.func,
  updateTableCell: _react.PropTypes.func,
  cellRow: _react.PropTypes.number,
  cellColumn: _react.PropTypes.string,
  stringAllowed: _react.PropTypes.bool,
  decimalNumber: _react.PropTypes.number,
  onBlur: _react.PropTypes.func,
  className: _react.PropTypes.string
};

exports.default = ClickEditCell;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _contractingUtils = __webpack_require__(124);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Miscellaneous = function Miscellaneous(_ref) {
  var ratePackageName = _ref.ratePackageName,
      nettCommission = _ref.nettCommission,
      rateType = _ref.rateType,
      minStay = _ref.minStay,
      maxStay = _ref.maxStay,
      daysOfWeek = _ref.daysOfWeek,
      currency = _ref.currency,
      taxInclusion = _ref.taxInclusion,
      taxType = _ref.taxType,
      stayPays = _ref.stayPays,
      commissionPercentage = _ref.commissionPercentage,
      maxAdultsPlusChild = _ref.maxAdultsPlusChild,
      _ref$classes = _ref.classes,
      classes = _ref$classes === undefined ? {} : _ref$classes;

  var commission = commissionPercentage ? _react2.default.createElement(
    'span',
    { className: classes['commissionPercentage'] },
    'COMMISSION: ' + commissionPercentage + '%\n'
  ) : '';
  var basedCommission = nettCommission ? _react2.default.createElement(
    'span',
    { className: classes['nettCommission'] },
    'NETT RATE BASED ON ' + nettCommission + '% COMMISSION\n'
  ) : '';
  var nightStay = function () {
    if (minStay && maxStay) {
      return minStay + ' to ' + maxStay + ' NIGHT' + (maxStay > 1 ? 'S' : '') + ' STAY';
    } else if (minStay) {
      return 'MIN ' + minStay + ' NIGHT' + (minStay > 1 ? 'S' : '') + ' STAY';
    } else if (maxStay) {
      return 'MAX ' + maxStay + ' NIGHT' + (maxStay > 1 ? 'S' : '') + ' STAY';
    }
    return '';
  }();
  var taxText = function () {
    if (taxInclusion === 'exempt') return 'are tax exempt';
    if (taxInclusion === 'exclusive') return 'are exclusive of tax';
    if (!taxType) return '';
    if (taxType === 'No sales tax') return 'there is no sales tax';
    return 'are inclusive of ' + taxType;
  }();
  if (nightStay || daysOfWeek || currency || taxText || ratePackageName) {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { style: { display: 'flex', justifyContent: 'space-between', marginTop: '6px', fontSize: '12px', alignItems: 'flex-end' } },
        _react2.default.createElement(
          'div',
          { style: { width: '38%', textAlign: 'left', whiteSpace: 'pre', paddingLeft: '4px', lineHeight: '14px' } },
          ratePackageName ? 'Rate Package: ' + ratePackageName + '\n' : '',
          rateType === 'includeCommission' ? commission : basedCommission,
          _react2.default.createElement(
            'div',
            { className: classes['minStay'] || classes['maxStay'] },
            nightStay
          ),
          daysOfWeek && daysOfWeek.length && (0, _contractingUtils.prettifyDays)(daysOfWeek) ? _react2.default.createElement(
            'div',
            {
              className: classes[_ramda2.default.keys(classes).find(function (str) {
                return str.indexOf('daysOfWeek') > -1;
              })]
            },
            (0, _contractingUtils.prettifyDays)(daysOfWeek).toUpperCase()
          ) : '',
          maxAdultsPlusChild ? _react2.default.createElement(
            'div',
            null,
            'Max Occupancy (Adults + Children): ',
            _react2.default.createElement(
              'span',
              { className: classes['maxAdultsPlusChild'] },
              maxAdultsPlusChild
            )
          ) : '',
          currency && taxText ? _react2.default.createElement(
            'div',
            null,
            'Rates are in ',
            _react2.default.createElement(
              'span',
              { className: classes['currency'] },
              currency
            ),
            ' and ',
            _react2.default.createElement(
              'span',
              { className: classes['taxInclusion'] || classes['taxType'] },
              taxText
            )
          ) : ''
        ),
        _react2.default.createElement('div', { style: { textAlign: 'right', paddingRight: '4px', lineHeight: '14px' } })
      ),
      _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '4px' } })
    );
  }
  return _react2.default.createElement('div', null);
};

exports.default = Miscellaneous;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(221)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(221)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(221)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(221)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIe = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;

})));


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(221)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIl = moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;

})));


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(221)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enNz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;

})));


/***/ }),
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(643);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(1093);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(645);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.route = route;

var _immutable = __webpack_require__(26);

var initialState = {
  currentRoute: '',
  previousRoute: ''
};

function route() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case '@@router/LOCATION_CHANGE':
      if (payload.action === 'REPLACE') {
        return {
          currentRoute: payload.pathname,
          previousRoute: state.previousRoute
        };
      }
      return {
        currentRoute: payload.pathname,
        previousRoute: state.currentRoute
      };
    case 'CLEAR_STORES':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGenerateClassNameDefault = exports.SheetsManager = exports.getDynamicStyles = exports.SheetsRegistry = undefined;

var _jss = __webpack_require__(1047);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _jss.SheetsRegistry;
  }
});
Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _jss.getDynamicStyles;
  }
});
Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _jss.SheetsManager;
  }
});
Object.defineProperty(exports, 'createGenerateClassNameDefault', {
  enumerable: true,
  get: function get() {
    return _jss.createGenerateClassName;
  }
});

var _jssPresetDefault = __webpack_require__(1211);

var _jssPresetDefault2 = _interopRequireDefault(_jssPresetDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = (0, _jss.create)((0, _jssPresetDefault2['default'])());

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Namespaces to avoid conflicts on the context.
 */
var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
var managers = exports.managers = 'b768b78919504fba9de2c03545c5cd3a';
var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(580);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(581);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(584);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["c" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["v" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(143);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["s" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(143);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["s" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["f" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(64);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["s" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["k" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["m" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony export (immutable) */ __webpack_exports__["b"] = takeLatest;
/* harmony export (immutable) */ __webpack_exports__["c"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__io__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(586);



function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["k" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["k" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["d" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["k" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["f" /* throttleHelper */], ms, pattern, worker].concat(args));
}

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TASK", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SAGA_ACTION", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deferred", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arrayOfDeffered", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMockTask", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cloneableGenerator", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "asEffect", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(585);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CHANNEL_END", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_proc__["a"]; });




/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utf8 = __webpack_require__(144);
var utils = __webpack_require__(35);
var GenericWorker = __webpack_require__(65);
var StreamHelper = __webpack_require__(594);
var defaults = __webpack_require__(595);
var CompressedObject = __webpack_require__(489);
var ZipObject = __webpack_require__(939);
var generate = __webpack_require__(940);
var nodejsUtils = __webpack_require__(238);
var NodejsStreamInputAdapter = __webpack_require__(947);


/**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} originalOptions the options of the file
 * @return {Object} the new file.
 */
var fileAdd = function(name, data, originalOptions) {
    // be sure sub folders exist
    var dataType = utils.getTypeOf(data),
        parent;


    /*
     * Correct options.
     */

    var o = utils.extend(originalOptions || {}, defaults);
    o.date = o.date || new Date();
    if (o.compression !== null) {
        o.compression = o.compression.toUpperCase();
    }

    if (typeof o.unixPermissions === "string") {
        o.unixPermissions = parseInt(o.unixPermissions, 8);
    }

    // UNX_IFDIR  0040000 see zipinfo.c
    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
        o.dir = true;
    }
    // Bit 4    Directory
    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
        o.dir = true;
    }

    if (o.dir) {
        name = forceTrailingSlash(name);
    }
    if (o.createFolders && (parent = parentFolder(name))) {
        folderAdd.call(this, parent, true);
    }

    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
    if (!originalOptions || typeof originalOptions.binary === "undefined") {
        o.binary = !isUnicodeString;
    }


    var isCompressedEmpty = (data instanceof CompressedObject) && data.uncompressedSize === 0;

    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
        o.base64 = false;
        o.binary = true;
        data = "";
        o.compression = "STORE";
        dataType = "string";
    }

    /*
     * Convert content to fit.
     */

    var zipObjectContent = null;
    if (data instanceof CompressedObject || data instanceof GenericWorker) {
        zipObjectContent = data;
    } else if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        zipObjectContent = new NodejsStreamInputAdapter(name, data);
    } else {
        zipObjectContent = utils.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
    }

    var object = new ZipObject(name, zipObjectContent, o);
    this.files[name] = object;
    /*
    TODO: we can't throw an exception because we have async promises
    (we can have a promise of a Date() for example) but returning a
    promise is useless because file(name, data) returns the JSZip
    object for chaining. Should we break that to allow the user
    to catch the error ?

    return external.Promise.resolve(zipObjectContent)
    .then(function () {
        return object;
    });
    */
};

/**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */
var parentFolder = function (path) {
    if (path.slice(-1) === '/') {
        path = path.substring(0, path.length - 1);
    }
    var lastSlash = path.lastIndexOf('/');
    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
};

/**
 * Returns the path with a slash at the end.
 * @private
 * @param {String} path the path to check.
 * @return {String} the path with a trailing slash.
 */
var forceTrailingSlash = function(path) {
    // Check the name ends with a /
    if (path.slice(-1) !== "/") {
        path += "/"; // IE doesn't like substr(-1)
    }
    return path;
};

/**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */
var folderAdd = function(name, createFolders) {
    createFolders = (typeof createFolders !== 'undefined') ? createFolders : defaults.createFolders;

    name = forceTrailingSlash(name);

    // Does this folder already exist?
    if (!this.files[name]) {
        fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
        });
    }
    return this.files[name];
};

/**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/
function isRegExp(object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
}

// return the actual prototype of JSZip
var out = {
    /**
     * @see loadAsync
     */
    load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },


    /**
     * Call a callback function for each entry at this folder level.
     * @param {Function} cb the callback function:
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     */
    forEach: function(cb) {
        var filename, relativePath, file;
        for (filename in this.files) {
            if (!this.files.hasOwnProperty(filename)) {
                continue;
            }
            file = this.files[filename];
            relativePath = filename.slice(this.root.length, filename.length);
            if (relativePath && filename.slice(0, this.root.length) === this.root) { // the file is in the current root
                cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
            }
        }
    },

    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */
    filter: function(search) {
        var result = [];
        this.forEach(function (relativePath, entry) {
            if (search(relativePath, entry)) { // the file matches the function
                result.push(entry);
            }

        });
        return result;
    },

    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */
    file: function(name, data, o) {
        if (arguments.length === 1) {
            if (isRegExp(name)) {
                var regexp = name;
                return this.filter(function(relativePath, file) {
                    return !file.dir && regexp.test(relativePath);
                });
            }
            else { // text
                var obj = this.files[this.root + name];
                if (obj && !obj.dir) {
                    return obj;
                } else {
                    return null;
                }
            }
        }
        else { // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
        }
        return this;
    },

    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */
    folder: function(arg) {
        if (!arg) {
            return this;
        }

        if (isRegExp(arg)) {
            return this.filter(function(relativePath, file) {
                return file.dir && arg.test(relativePath);
            });
        }

        // else, name is a new folder
        var name = this.root + arg;
        var newFolder = folderAdd.call(this, name);

        // Allow chaining by returning a new object with this folder as the root
        var ret = this.clone();
        ret.root = newFolder.name;
        return ret;
    },

    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */
    remove: function(name) {
        name = this.root + name;
        var file = this.files[name];
        if (!file) {
            // Look for any folders
            if (name.slice(-1) !== "/") {
                name += "/";
            }
            file = this.files[name];
        }

        if (file && !file.dir) {
            // file
            delete this.files[name];
        } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function(relativePath, file) {
                return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
                delete this.files[kids[i].name];
            }
        }

        return this;
    },

    /**
     * Generate the complete zip file
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
     */
    generate: function(options) {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },

    /**
     * Generate the complete zip file as an internal stream.
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {StreamHelper} the streamed zip file.
     */
    generateInternalStream: function(options) {
      var worker, opts = {};
      try {
          opts = utils.extend(options || {}, {
              streamFiles: false,
              compression: "STORE",
              compressionOptions : null,
              type: "",
              platform: "DOS",
              comment: null,
              mimeType: 'application/zip',
              encodeFileName: utf8.utf8encode
          });

          opts.type = opts.type.toLowerCase();
          opts.compression = opts.compression.toUpperCase();

          // "binarystring" is prefered but the internals use "string".
          if(opts.type === "binarystring") {
            opts.type = "string";
          }

          if (!opts.type) {
            throw new Error("No output type specified.");
          }

          utils.checkSupport(opts.type);

          // accept nodejs `process.platform`
          if(
              opts.platform === 'darwin' ||
              opts.platform === 'freebsd' ||
              opts.platform === 'linux' ||
              opts.platform === 'sunos'
          ) {
              opts.platform = "UNIX";
          }
          if (opts.platform === 'win32') {
              opts.platform = "DOS";
          }

          var comment = opts.comment || this.comment || "";
          worker = generate.generateWorker(this, opts, comment);
      } catch (e) {
        worker = new GenericWorker("error");
        worker.error(e);
      }
      return new StreamHelper(worker, opts.type || "string", opts.mimeType);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateAsync: function(options, onUpdate) {
        return this.generateInternalStream(options).accumulate(onUpdate);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateNodeStream: function(options, onUpdate) {
        options = options || {};
        if (!options.type) {
            options.type = "nodebuffer";
        }
        return this.generateInternalStream(options).toNodejsStream(onUpdate);
    }
};
module.exports = out;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(922);
module.exports = __webpack_require__(590).setImmediate;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(923)
  , $task   = __webpack_require__(931);
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(239)
  , core      = __webpack_require__(590)
  , ctx       = __webpack_require__(591)
  , hide      = __webpack_require__(925)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(926)
  , createDesc = __webpack_require__(930);
module.exports = __webpack_require__(488) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(927)
  , IE8_DOM_DEFINE = __webpack_require__(928)
  , toPrimitive    = __webpack_require__(929)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(488) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(487);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(488) && !__webpack_require__(592)(function(){
  return Object.defineProperty(__webpack_require__(593)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(487);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(591)
  , invoke             = __webpack_require__(932)
  , html               = __webpack_require__(933)
  , cel                = __webpack_require__(593)
  , global             = __webpack_require__(239)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(934)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 932 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(239).document && document.documentElement;

/***/ }),
/* 934 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var immediate = __webpack_require__(936);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GenericWorker = __webpack_require__(65);
var utils = __webpack_require__(35);

/**
 * A worker which convert chunks to a specified type.
 * @constructor
 * @param {String} destType the destination type.
 */
function ConvertWorker(destType) {
    GenericWorker.call(this, "ConvertWorker to " + destType);
    this.destType = destType;
}
utils.inherits(ConvertWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
ConvertWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : utils.transformTo(this.destType, chunk.data),
        meta : chunk.meta
    });
};
module.exports = ConvertWorker;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Readable = __webpack_require__(588).Readable;

var util = __webpack_require__(1046);
util.inherits(NodejsStreamOutputAdapter, Readable);

/**
* A nodejs stream using a worker as source.
* @see the SourceWrapper in http://nodejs.org/api/stream.html
* @constructor
* @param {StreamHelper} helper the helper wrapping the worker
* @param {Object} options the nodejs stream options
* @param {Function} updateCb the update callback.
*/
function NodejsStreamOutputAdapter(helper, options, updateCb) {
    Readable.call(this, options);
    this._helper = helper;

    var self = this;
    helper.on("data", function (data, meta) {
        if (!self.push(data)) {
            self._helper.pause();
        }
        if(updateCb) {
            updateCb(meta);
        }
    })
    .on("error", function(e) {
        self.emit('error', e);
    })
    .on("end", function () {
        self.push(null);
    });
}


NodejsStreamOutputAdapter.prototype._read = function() {
    this._helper.resume();
};

module.exports = NodejsStreamOutputAdapter;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StreamHelper = __webpack_require__(594);
var DataWorker = __webpack_require__(596);
var utf8 = __webpack_require__(144);
var CompressedObject = __webpack_require__(489);
var GenericWorker = __webpack_require__(65);

/**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */
var ZipObject = function(name, data, options) {
    this.name = name;
    this.dir = options.dir;
    this.date = options.date;
    this.comment = options.comment;
    this.unixPermissions = options.unixPermissions;
    this.dosPermissions = options.dosPermissions;

    this._data = data;
    this._dataBinary = options.binary;
    // keep only the compression
    this.options = {
        compression : options.compression,
        compressionOptions : options.compressionOptions
    };
};

ZipObject.prototype = {
    /**
     * Create an internal stream for the content of this object.
     * @param {String} type the type of each chunk.
     * @return StreamHelper the stream.
     */
    internalStream: function (type) {
        var outputType = type.toLowerCase();
        var askUnicodeString = outputType === "string" || outputType === "text";
        if (outputType === "binarystring" || outputType === "text") {
            outputType = "string";
        }
        var result = this._decompressWorker();

        var isUnicodeString = !this._dataBinary;

        if (isUnicodeString && !askUnicodeString) {
            result = result.pipe(new utf8.Utf8EncodeWorker());
        }
        if (!isUnicodeString && askUnicodeString) {
            result = result.pipe(new utf8.Utf8DecodeWorker());
        }

        return new StreamHelper(result, outputType, "");
    },

    /**
     * Prepare the content in the asked type.
     * @param {String} type the type of the result.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Promise the promise of the result.
     */
    async: function (type, onUpdate) {
        return this.internalStream(type).accumulate(onUpdate);
    },

    /**
     * Prepare the content as a nodejs stream.
     * @param {String} type the type of each chunk.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Stream the stream.
     */
    nodeStream: function (type, onUpdate) {
        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
    },

    /**
     * Return a worker for the compressed content.
     * @private
     * @param {Object} compression the compression object to use.
     * @param {Object} compressionOptions the options to use when compressing.
     * @return Worker the worker.
     */
    _compressWorker: function (compression, compressionOptions) {
        if (
            this._data instanceof CompressedObject &&
            this._data.compression.magic === compression.magic
        ) {
            return this._data.getCompressedWorker();
        } else {
            var result = this._decompressWorker();
            if(!this._dataBinary) {
                result = result.pipe(new utf8.Utf8EncodeWorker());
            }
            return CompressedObject.createWorkerFrom(result, compression, compressionOptions);
        }
    },
    /**
     * Return a worker for the decompressed content.
     * @private
     * @return Worker the worker.
     */
    _decompressWorker : function () {
        if (this._data instanceof CompressedObject) {
            return this._data.getContentWorker();
        } else if (this._data instanceof GenericWorker) {
            return this._data;
        } else {
            return new DataWorker(this._data);
        }
    }
};

var removedMethods = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"];
var removedFn = function () {
    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};

for(var i = 0; i < removedMethods.length; i++) {
    ZipObject.prototype[removedMethods[i]] = removedFn;
}
module.exports = ZipObject;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compressions = __webpack_require__(599);
var ZipFileWorker = __webpack_require__(946);

/**
 * Find the compression to use.
 * @param {String} fileCompression the compression defined at the file level, if any.
 * @param {String} zipCompression the compression defined at the load() level.
 * @return {Object} the compression object to use.
 */
var getCompression = function (fileCompression, zipCompression) {

    var compressionName = fileCompression || zipCompression;
    var compression = compressions[compressionName];
    if (!compression) {
        throw new Error(compressionName + " is not a valid compression method !");
    }
    return compression;
};

/**
 * Create a worker to generate a zip file.
 * @param {JSZip} zip the JSZip instance at the right root level.
 * @param {Object} options to generate the zip file.
 * @param {String} comment the comment to use.
 */
exports.generateWorker = function (zip, options, comment) {

    var zipFileWorker = new ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
    var entriesCount = 0;
    try {

        zip.forEach(function (relativePath, file) {
            entriesCount++;
            var compression = getCompression(file.options.compression, options.compression);
            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
            var dir = file.dir, date = file.date;

            file._compressWorker(compression, compressionOptions)
            .withStreamInfo("file", {
                name : relativePath,
                dir : dir,
                date : date,
                comment : file.comment || "",
                unixPermissions : file.unixPermissions,
                dosPermissions : file.dosPermissions
            })
            .pipe(zipFileWorker);
        });
        zipFileWorker.entriesCount = entriesCount;
    } catch (e) {
        zipFileWorker.error(e);
    }

    return zipFileWorker;
};


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');

var pako = __webpack_require__(942);
var utils = __webpack_require__(35);
var GenericWorker = __webpack_require__(65);

var ARRAY_TYPE = USE_TYPEDARRAY ? "uint8array" : "array";

exports.magic = "\x08\x00";

/**
 * Create a worker that uses pako to inflate/deflate.
 * @constructor
 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
 * @param {Object} options the options to use when (de)compressing.
 */
function FlateWorker(action, options) {
    GenericWorker.call(this, "FlateWorker/" + action);

    this._pako = new pako[action]({
        raw:true,
        level : options.level || -1 // default compression
    });
    // the `meta` object from the last chunk received
    // this allow this worker to pass around metadata
    this.meta = {};

    var self = this;
    this._pako.onData = function(data) {
        self.push({
            data : data,
            meta : self.meta
        });
    };
}

utils.inherits(FlateWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
FlateWorker.prototype.processChunk = function (chunk) {
    this.meta = chunk.meta;
    this._pako.push(utils.transformTo(ARRAY_TYPE, chunk.data), false);
};

/**
 * @see GenericWorker.flush
 */
FlateWorker.prototype.flush = function () {
    GenericWorker.prototype.flush.call(this);
    this._pako.push([], true);
};
/**
 * @see GenericWorker.cleanUp
 */
FlateWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this._pako = null;
};

exports.compressWorker = function (compressionOptions) {
    return new FlateWorker("Deflate", compressionOptions);
};
exports.uncompressWorker = function () {
    return new FlateWorker("Inflate", {});
};


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Top level file is just a mixin of submodules & constants


var assign    = __webpack_require__(230).assign;

var deflate   = __webpack_require__(943);
var inflate   = __webpack_require__(944);
var constants = __webpack_require__(642);

var pako = {};

assign(pako, deflate, inflate, constants);

module.exports = pako;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var zlib_deflate = __webpack_require__(1091);
var utils        = __webpack_require__(230);
var strings      = __webpack_require__(600);
var msg          = __webpack_require__(641);
var ZStream      = __webpack_require__(640);

var toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_SYNC_FLUSH    = 2;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new ZStream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    var dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK) {
      throw new Error(msg[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var zlib_inflate = __webpack_require__(1092);
var utils        = __webpack_require__(230);
var strings      = __webpack_require__(600);
var c            = __webpack_require__(642);
var msg          = __webpack_require__(641);
var ZStream      = __webpack_require__(640);
var GZheader     = __webpack_require__(945);

var toString = Object.prototype.toString;

/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate(options) {
  if (!(this instanceof Inflate)) return new Inflate(options);

  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new ZStream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new GZheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);
}

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var dictionary = this.options.dictionary;
  var status, _mode;
  var next_out_utf8, tail, utf8str;
  var dict;

  // Flag to properly process Z_BUF_ERROR on testing inflate call
  // when we check that all output data was flushed.
  var allowBufError = false;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

    if (status === c.Z_NEED_DICT && dictionary) {
      // Convert data if needed
      if (typeof dictionary === 'string') {
        dict = strings.string2buf(dictionary);
      } else if (toString.call(dictionary) === '[object ArrayBuffer]') {
        dict = new Uint8Array(dictionary);
      } else {
        dict = dictionary;
      }

      status = zlib_inflate.inflateSetDictionary(this.strm, dict);

    }

    if (status === c.Z_BUF_ERROR && allowBufError === true) {
      status = c.Z_OK;
      allowBufError = false;
    }

    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }

    // When no more input data, we should check that internal inflate buffers
    // are flushed. The only way to do it when avail_out = 0 - run one more
    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
    // Here we set flag to process this error properly.
    //
    // NOTE. Deflate does not return error in this case and does not needs such
    // logic.
    if (strm.avail_in === 0 && strm.avail_out === 0) {
      allowBufError = true;
    }

  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);

  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }

  // Finalize on the last chunk.
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === c.Z_SYNC_FLUSH) {
    this.onEnd(c.Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === c.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 aligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


exports.Inflate = Inflate;
exports.inflate = inflate;
exports.inflateRaw = inflateRaw;
exports.ungzip  = inflate;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

module.exports = GZheader;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var GenericWorker = __webpack_require__(65);
var utf8 = __webpack_require__(144);
var crc32 = __webpack_require__(490);
var signature = __webpack_require__(601);

/**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */
var decToHex = function(dec, bytes) {
    var hex = "", i;
    for (i = 0; i < bytes; i++) {
        hex += String.fromCharCode(dec & 0xff);
        dec = dec >>> 8;
    }
    return hex;
};

/**
 * Generate the UNIX part of the external file attributes.
 * @param {Object} unixPermissions the unix permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
 *
 * TTTTsstrwxrwxrwx0000000000ADVSHR
 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
 *     ^^^_________________________ setuid, setgid, sticky
 *        ^^^^^^^^^________________ permissions
 *                 ^^^^^^^^^^______ not used ?
 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
 */
var generateUnixExternalFileAttr = function (unixPermissions, isDir) {

    var result = unixPermissions;
    if (!unixPermissions) {
        // I can't use octal values in strict mode, hence the hexa.
        //  040775 => 0x41fd
        // 0100664 => 0x81b4
        result = isDir ? 0x41fd : 0x81b4;
    }
    return (result & 0xFFFF) << 16;
};

/**
 * Generate the DOS part of the external file attributes.
 * @param {Object} dosPermissions the dos permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * Bit 0     Read-Only
 * Bit 1     Hidden
 * Bit 2     System
 * Bit 3     Volume Label
 * Bit 4     Directory
 * Bit 5     Archive
 */
var generateDosExternalFileAttr = function (dosPermissions, isDir) {

    // the dir flag is already set for compatibility
    return (dosPermissions || 0)  & 0x3F;
};

/**
 * Generate the various parts used in the construction of the final zip file.
 * @param {Object} streamInfo the hash with informations about the compressed file.
 * @param {Boolean} streamedContent is the content streamed ?
 * @param {Boolean} streamingEnded is the stream finished ?
 * @param {number} offset the current offset from the start of the zip file.
 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
 * @param {Function} encodeFileName the function to encode the file name / comment.
 * @return {Object} the zip parts.
 */
var generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
    var file = streamInfo['file'],
    compression = streamInfo['compression'],
    useCustomEncoding = encodeFileName !== utf8.utf8encode,
    encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
    utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
    comment = file.comment,
    encodedComment = utils.transformTo("string", encodeFileName(comment)),
    utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
    useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
    useUTF8ForComment = utfEncodedComment.length !== comment.length,
    dosTime,
    dosDate,
    extraFields = "",
    unicodePathExtraField = "",
    unicodeCommentExtraField = "",
    dir = file.dir,
    date = file.date;


    var dataInfo = {
        crc32 : 0,
        compressedSize : 0,
        uncompressedSize : 0
    };

    // if the content is streamed, the sizes/crc32 are only available AFTER
    // the end of the stream.
    if (!streamedContent || streamingEnded) {
        dataInfo.crc32 = streamInfo['crc32'];
        dataInfo.compressedSize = streamInfo['compressedSize'];
        dataInfo.uncompressedSize = streamInfo['uncompressedSize'];
    }

    var bitflag = 0;
    if (streamedContent) {
        // Bit 3: the sizes/crc32 are set to zero in the local header.
        // The correct values are put in the data descriptor immediately
        // following the compressed data.
        bitflag |= 0x0008;
    }
    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) {
        // Bit 11: Language encoding flag (EFS).
        bitflag |= 0x0800;
    }


    var extFileAttr = 0;
    var versionMadeBy = 0;
    if (dir) {
        // dos or unix, we set the dos dir flag
        extFileAttr |= 0x00010;
    }
    if(platform === "UNIX") {
        versionMadeBy = 0x031E; // UNIX, version 3.0
        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
    } else { // DOS or other, fallback to DOS
        versionMadeBy = 0x0014; // DOS, version 2.0
        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
    }

    // date
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html

    dosTime = date.getUTCHours();
    dosTime = dosTime << 6;
    dosTime = dosTime | date.getUTCMinutes();
    dosTime = dosTime << 5;
    dosTime = dosTime | date.getUTCSeconds() / 2;

    dosDate = date.getUTCFullYear() - 1980;
    dosDate = dosDate << 4;
    dosDate = dosDate | (date.getUTCMonth() + 1);
    dosDate = dosDate << 5;
    dosDate = dosDate | date.getUTCDate();

    if (useUTF8ForFileName) {
        // set the unicode path extra field. unzip needs at least one extra
        // field to correctly handle unicode path, so using the path is as good
        // as any other information. This could improve the situation with
        // other archive managers too.
        // This field is usually used without the utf8 flag, with a non
        // unicode path in the header (winrar, winzip). This helps (a bit)
        // with the messy Windows' default compressed folders feature but
        // breaks on p7zip which doesn't seek the unicode path extra field.
        // So for now, UTF-8 everywhere !
        unicodePathExtraField =
            // Version
            decToHex(1, 1) +
            // NameCRC32
            decToHex(crc32(encodedFileName), 4) +
            // UnicodeName
            utfEncodedFileName;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x70" +
            // size
            decToHex(unicodePathExtraField.length, 2) +
            // content
            unicodePathExtraField;
    }

    if(useUTF8ForComment) {

        unicodeCommentExtraField =
            // Version
            decToHex(1, 1) +
            // CommentCRC32
            decToHex(crc32(encodedComment), 4) +
            // UnicodeName
            utfEncodedComment;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x63" +
            // size
            decToHex(unicodeCommentExtraField.length, 2) +
            // content
            unicodeCommentExtraField;
    }

    var header = "";

    // version needed to extract
    header += "\x0A\x00";
    // general purpose bit flag
    header += decToHex(bitflag, 2);
    // compression method
    header += compression.magic;
    // last mod file time
    header += decToHex(dosTime, 2);
    // last mod file date
    header += decToHex(dosDate, 2);
    // crc-32
    header += decToHex(dataInfo.crc32, 4);
    // compressed size
    header += decToHex(dataInfo.compressedSize, 4);
    // uncompressed size
    header += decToHex(dataInfo.uncompressedSize, 4);
    // file name length
    header += decToHex(encodedFileName.length, 2);
    // extra field length
    header += decToHex(extraFields.length, 2);


    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;

    var dirRecord = signature.CENTRAL_FILE_HEADER +
        // version made by (00: DOS)
        decToHex(versionMadeBy, 2) +
        // file header (common to file and central directory)
        header +
        // file comment length
        decToHex(encodedComment.length, 2) +
        // disk number start
        "\x00\x00" +
        // internal file attributes TODO
        "\x00\x00" +
        // external file attributes
        decToHex(extFileAttr, 4) +
        // relative offset of local header
        decToHex(offset, 4) +
        // file name
        encodedFileName +
        // extra field
        extraFields +
        // file comment
        encodedComment;

    return {
        fileRecord: fileRecord,
        dirRecord: dirRecord
    };
};

/**
 * Generate the EOCD record.
 * @param {Number} entriesCount the number of entries in the zip file.
 * @param {Number} centralDirLength the length (in bytes) of the central dir.
 * @param {Number} localDirLength the length (in bytes) of the local dir.
 * @param {String} comment the zip file comment as a binary string.
 * @param {Function} encodeFileName the function to encode the comment.
 * @return {String} the EOCD record.
 */
var generateCentralDirectoryEnd = function (entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
    var dirEnd = "";
    var encodedComment = utils.transformTo("string", encodeFileName(comment));

    // end of central dir signature
    dirEnd = signature.CENTRAL_DIRECTORY_END +
        // number of this disk
        "\x00\x00" +
        // number of the disk with the start of the central directory
        "\x00\x00" +
        // total number of entries in the central directory on this disk
        decToHex(entriesCount, 2) +
        // total number of entries in the central directory
        decToHex(entriesCount, 2) +
        // size of the central directory   4 bytes
        decToHex(centralDirLength, 4) +
        // offset of start of central directory with respect to the starting disk number
        decToHex(localDirLength, 4) +
        // .ZIP file comment length
        decToHex(encodedComment.length, 2) +
        // .ZIP file comment
        encodedComment;

    return dirEnd;
};

/**
 * Generate data descriptors for a file entry.
 * @param {Object} streamInfo the hash generated by a worker, containing informations
 * on the file entry.
 * @return {String} the data descriptors.
 */
var generateDataDescriptors = function (streamInfo) {
    var descriptor = "";
    descriptor = signature.DATA_DESCRIPTOR +
        // crc-32                          4 bytes
        decToHex(streamInfo['crc32'], 4) +
        // compressed size                 4 bytes
        decToHex(streamInfo['compressedSize'], 4) +
        // uncompressed size               4 bytes
        decToHex(streamInfo['uncompressedSize'], 4);

    return descriptor;
};


/**
 * A worker to concatenate other workers to create a zip file.
 * @param {Boolean} streamFiles `true` to stream the content of the files,
 * `false` to accumulate it.
 * @param {String} comment the comment to use.
 * @param {String} platform the platform to use, "UNIX" or "DOS".
 * @param {Function} encodeFileName the function to encode file names and comments.
 */
function ZipFileWorker(streamFiles, comment, platform, encodeFileName) {
    GenericWorker.call(this, "ZipFileWorker");
    // The number of bytes written so far. This doesn't count accumulated chunks.
    this.bytesWritten = 0;
    // The comment of the zip file
    this.zipComment = comment;
    // The platform "generating" the zip file.
    this.zipPlatform = platform;
    // the function to encode file names and comments.
    this.encodeFileName = encodeFileName;
    // Should we stream the content of the files ?
    this.streamFiles = streamFiles;
    // If `streamFiles` is false, we will need to accumulate the content of the
    // files to calculate sizes / crc32 (and write them *before* the content).
    // This boolean indicates if we are accumulating chunks (it will change a lot
    // during the lifetime of this worker).
    this.accumulate = false;
    // The buffer receiving chunks when accumulating content.
    this.contentBuffer = [];
    // The list of generated directory records.
    this.dirRecords = [];
    // The offset (in bytes) from the beginning of the zip file for the current source.
    this.currentSourceOffset = 0;
    // The total number of entries in this zip file.
    this.entriesCount = 0;
    // the name of the file currently being added, null when handling the end of the zip file.
    // Used for the emited metadata.
    this.currentFile = null;



    this._sources = [];
}
utils.inherits(ZipFileWorker, GenericWorker);

/**
 * @see GenericWorker.push
 */
ZipFileWorker.prototype.push = function (chunk) {

    var currentFilePercent = chunk.meta.percent || 0;
    var entriesCount = this.entriesCount;
    var remainingFiles = this._sources.length;

    if(this.accumulate) {
        this.contentBuffer.push(chunk);
    } else {
        this.bytesWritten += chunk.data.length;

        GenericWorker.prototype.push.call(this, {
            data : chunk.data,
            meta : {
                currentFile : this.currentFile,
                percent : entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
            }
        });
    }
};

/**
 * The worker started a new source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the new source.
 */
ZipFileWorker.prototype.openedSource = function (streamInfo) {
    this.currentSourceOffset = this.bytesWritten;
    this.currentFile = streamInfo['file'].name;

    var streamedContent = this.streamFiles && !streamInfo['file'].dir;

    // don't stream folders (because they don't have any content)
    if(streamedContent) {
        var record = generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
    } else {
        // we need to wait for the whole file before pushing anything
        this.accumulate = true;
    }
};

/**
 * The worker finished a source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the finished source.
 */
ZipFileWorker.prototype.closedSource = function (streamInfo) {
    this.accumulate = false;
    var streamedContent = this.streamFiles && !streamInfo['file'].dir;
    var record = generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);

    this.dirRecords.push(record.dirRecord);
    if(streamedContent) {
        // after the streamed file, we put data descriptors
        this.push({
            data : generateDataDescriptors(streamInfo),
            meta : {percent:100}
        });
    } else {
        // the content wasn't streamed, we need to push everything now
        // first the file record, then the content
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
        while(this.contentBuffer.length) {
            this.push(this.contentBuffer.shift());
        }
    }
    this.currentFile = null;
};

/**
 * @see GenericWorker.flush
 */
ZipFileWorker.prototype.flush = function () {

    var localDirLength = this.bytesWritten;
    for(var i = 0; i < this.dirRecords.length; i++) {
        this.push({
            data : this.dirRecords[i],
            meta : {percent:100}
        });
    }
    var centralDirLength = this.bytesWritten - localDirLength;

    var dirEnd = generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);

    this.push({
        data : dirEnd,
        meta : {percent:100}
    });
};

/**
 * Prepare the next source to be read.
 */
ZipFileWorker.prototype.prepareNextSource = function () {
    this.previous = this._sources.shift();
    this.openedSource(this.previous.streamInfo);
    if (this.isPaused) {
        this.previous.pause();
    } else {
        this.previous.resume();
    }
};

/**
 * @see GenericWorker.registerPrevious
 */
ZipFileWorker.prototype.registerPrevious = function (previous) {
    this._sources.push(previous);
    var self = this;

    previous.on('data', function (chunk) {
        self.processChunk(chunk);
    });
    previous.on('end', function () {
        self.closedSource(self.previous.streamInfo);
        if(self._sources.length) {
            self.prepareNextSource();
        } else {
            self.end();
        }
    });
    previous.on('error', function (e) {
        self.error(e);
    });
    return this;
};

/**
 * @see GenericWorker.resume
 */
ZipFileWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this.previous && this._sources.length) {
        this.prepareNextSource();
        return true;
    }
    if (!this.previous && !this._sources.length && !this.generatedError) {
        this.end();
        return true;
    }
};

/**
 * @see GenericWorker.error
 */
ZipFileWorker.prototype.error = function (e) {
    var sources = this._sources;
    if(!GenericWorker.prototype.error.call(this, e)) {
        return false;
    }
    for(var i = 0; i < sources.length; i++) {
        try {
            sources[i].error(e);
        } catch(e) {
            // the `error` exploded, nothing to do
        }
    }
    return true;
};

/**
 * @see GenericWorker.lock
 */
ZipFileWorker.prototype.lock = function () {
    GenericWorker.prototype.lock.call(this);
    var sources = this._sources;
    for(var i = 0; i < sources.length; i++) {
        sources[i].lock();
    }
};

module.exports = ZipFileWorker;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var GenericWorker = __webpack_require__(65);

/**
 * A worker that use a nodejs stream as source.
 * @constructor
 * @param {String} filename the name of the file entry for this stream.
 * @param {Readable} stream the nodejs stream.
 */
function NodejsStreamInputAdapter(filename, stream) {
    GenericWorker.call(this, "Nodejs stream input adapter for " + filename);
    this._upstreamEnded = false;
    this._bindStream(stream);
}

utils.inherits(NodejsStreamInputAdapter, GenericWorker);

/**
 * Prepare the stream and bind the callbacks on it.
 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
 * @param {Stream} stream the nodejs stream to use.
 */
NodejsStreamInputAdapter.prototype._bindStream = function (stream) {
    var self = this;
    this._stream = stream;
    stream.pause();
    stream
    .on("data", function (chunk) {
        self.push({
            data: chunk,
            meta : {
                percent : 0
            }
        });
    })
    .on("error", function (e) {
        if(self.isPaused) {
            this.generatedError = e;
        } else {
            self.error(e);
        }
    })
    .on("end", function () {
        if(self.isPaused) {
            self._upstreamEnded = true;
        } else {
            self.end();
        }
    });
};
NodejsStreamInputAdapter.prototype.pause = function () {
    if(!GenericWorker.prototype.pause.call(this)) {
        return false;
    }
    this._stream.pause();
    return true;
};
NodejsStreamInputAdapter.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if(this._upstreamEnded) {
        this.end();
    } else {
        this._stream.resume();
    }

    return true;
};

module.exports = NodejsStreamInputAdapter;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var utils = __webpack_require__(35);
var external = __webpack_require__(218);
var utf8 = __webpack_require__(144);
var utils = __webpack_require__(35);
var ZipEntries = __webpack_require__(949);
var Crc32Probe = __webpack_require__(598);
var nodejsUtils = __webpack_require__(238);

/**
 * Check the CRC32 of an entry.
 * @param {ZipEntry} zipEntry the zip entry to check.
 * @return {Promise} the result.
 */
function checkEntryCRC32(zipEntry) {
    return new external.Promise(function (resolve, reject) {
        var worker = zipEntry.decompressed.getContentWorker().pipe(new Crc32Probe());
        worker.on("error", function (e) {
            reject(e);
        })
        .on("end", function () {
            if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) {
                reject(new Error("Corrupted zip : CRC32 mismatch"));
            } else {
                resolve();
            }
        })
        .resume();
    });
}

module.exports = function(data, options) {
    var zip = this;
    options = utils.extend(options || {}, {
        base64: false,
        checkCRC32: false,
        optimizedBinaryString: false,
        createFolders: false,
        decodeFileName: utf8.utf8decode
    });

    if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        return external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
    }

    return utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64)
    .then(function(data) {
        var zipEntries = new ZipEntries(options);
        zipEntries.load(data);
        return zipEntries;
    }).then(function checkCRC32(zipEntries) {
        var promises = [external.Promise.resolve(zipEntries)];
        var files = zipEntries.files;
        if (options.checkCRC32) {
            for (var i = 0; i < files.length; i++) {
                promises.push(checkEntryCRC32(files[i]));
            }
        }
        return external.Promise.all(promises);
    }).then(function addFiles(results) {
        var zipEntries = results.shift();
        var files = zipEntries.files;
        for (var i = 0; i < files.length; i++) {
            var input = files[i];
            zip.file(input.fileNameStr, input.decompressed, {
                binary: true,
                optimizedBinaryString: true,
                date: input.date,
                dir: input.dir,
                comment : input.fileCommentStr.length ? input.fileCommentStr : null,
                unixPermissions : input.unixPermissions,
                dosPermissions : input.dosPermissions,
                createFolders: options.createFolders
            });
        }
        if (zipEntries.zipComment.length) {
            zip.comment = zipEntries.zipComment;
        }

        return zip;
    });
};


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var readerFor = __webpack_require__(602);
var utils = __webpack_require__(35);
var sig = __webpack_require__(601);
var ZipEntry = __webpack_require__(952);
var utf8 = __webpack_require__(144);
var support = __webpack_require__(117);
//  class ZipEntries {{{
/**
 * All the entries in the zip file.
 * @constructor
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntries(loadOptions) {
    this.files = [];
    this.loadOptions = loadOptions;
}
ZipEntries.prototype = {
    /**
     * Check that the reader is on the speficied signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */
    checkSignature: function(expectedSignature) {
        if (!this.reader.readAndCheckSignature(expectedSignature)) {
            this.reader.index -= 4;
            var signature = this.reader.readString(4);
            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
        }
    },
    /**
     * Check if the given signature is at the given index.
     * @param {number} askedIndex the index to check.
     * @param {string} expectedSignature the signature to expect.
     * @return {boolean} true if the signature is here, false otherwise.
     */
    isSignature: function(askedIndex, expectedSignature) {
        var currentIndex = this.reader.index;
        this.reader.setIndex(askedIndex);
        var signature = this.reader.readString(4);
        var result = signature === expectedSignature;
        this.reader.setIndex(currentIndex);
        return result;
    },
    /**
     * Read the end of the central directory.
     */
    readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2);
        this.diskWithCentralDirStart = this.reader.readInt(2);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
        this.centralDirRecords = this.reader.readInt(2);
        this.centralDirSize = this.reader.readInt(4);
        this.centralDirOffset = this.reader.readInt(4);

        this.zipCommentLength = this.reader.readInt(2);
        // warning : the encoding depends of the system locale
        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
        // On a windows machine, this field is encoded with the localized windows code page.
        var zipComment = this.reader.readData(this.zipCommentLength);
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        // To get consistent behavior with the generation part, we will assume that
        // this is utf8 encoded unless specified otherwise.
        var decodeContent = utils.transformTo(decodeParamType, zipComment);
        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
    },
    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */
    readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8);
        this.reader.skip(4);
        // this.versionMadeBy = this.reader.readString(2);
        // this.versionNeeded = this.reader.readInt(2);
        this.diskNumber = this.reader.readInt(4);
        this.diskWithCentralDirStart = this.reader.readInt(4);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
        this.centralDirRecords = this.reader.readInt(8);
        this.centralDirSize = this.reader.readInt(8);
        this.centralDirOffset = this.reader.readInt(8);

        this.zip64ExtensibleData = {};
        var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
        while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readData(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Read the end of the Zip 64 central directory locator.
     */
    readBlockZip64EndOfCentralLocator: function() {
        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
        this.disksCount = this.reader.readInt(4);
        if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
        }
    },
    /**
     * Read the local files, based on the offset read in the central part.
     */
    readLocalFiles: function() {
        var i, file;
        for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
            file.processAttributes();
        }
    },
    /**
     * Read the central directory.
     */
    readCentralDir: function() {
        var file;

        this.reader.setIndex(this.centralDirOffset);
        while (this.reader.readAndCheckSignature(sig.CENTRAL_FILE_HEADER)) {
            file = new ZipEntry({
                zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
        }

        if (this.centralDirRecords !== this.files.length) {
            if (this.centralDirRecords !== 0 && this.files.length === 0) {
                // We expected some records but couldn't find ANY.
                // This is really suspicious, as if something went wrong.
                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
            } else {
                // We found some records but not all.
                // Something is wrong but we got something for the user: no error here.
                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
            }
        }
    },
    /**
     * Read the end of central directory.
     */
    readEndOfCentral: function() {
        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
        if (offset < 0) {
            // Check if the content is a truncated zip or complete garbage.
            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
            // extractible zip for example) but it can give a good hint.
            // If an ajax request was used without responseType, we will also
            // get unreadable data.
            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);

            if (isGarbage) {
                throw new Error("Can't find end of central directory : is this a zip file ? " +
                                "If it is, see http://stuk.github.io/jszip/documentation/howto/read_zip.html");
            } else {
                throw new Error("Corrupted zip : can't find end of central directory");
            }

        }
        this.reader.setIndex(offset);
        var endOfCentralDirOffset = offset;
        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
        this.readBlockEndOfCentral();


        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */
        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset < 0) {
                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
                // console.warn("ZIP64 end of central directory not where expected.");
                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
                    throw new Error("Corrupted zip : can't find the ZIP64 end of central directory");
                }
            }
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
        }

        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
        if (this.zip64) {
            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
        }

        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;

        if (extraBytes > 0) {
            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
                // The offsets seem wrong, but we have something at the specified offset.
                // So… we keep it.
            } else {
                // the offset is wrong, update the "zero" of the reader
                // this happens if data has been prepended (crx files for example)
                this.reader.zero = extraBytes;
            }
        } else if (extraBytes < 0) {
            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
        }
    },
    prepareReader: function(data) {
        this.reader = readerFor(data);
    },
    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */
    load: function(data) {
        this.prepareReader(data);
        this.readEndOfCentral();
        this.readCentralDir();
        this.readLocalFiles();
    }
};
// }}} end of ZipEntries
module.exports = ZipEntries;


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DataReader = __webpack_require__(604);
var utils = __webpack_require__(35);

function StringReader(data) {
    DataReader.call(this, data);
}
utils.inherits(StringReader, DataReader);
/**
 * @see DataReader.byteAt
 */
StringReader.prototype.byteAt = function(i) {
    return this.data.charCodeAt(this.zero + i);
};
/**
 * @see DataReader.lastIndexOfSignature
 */
StringReader.prototype.lastIndexOfSignature = function(sig) {
    return this.data.lastIndexOf(sig) - this.zero;
};
/**
 * @see DataReader.readAndCheckSignature
 */
StringReader.prototype.readAndCheckSignature = function (sig) {
    var data = this.readData(4);
    return sig === data;
};
/**
 * @see DataReader.readData
 */
StringReader.prototype.readData = function(size) {
    this.checkOffset(size);
    // this will work because the constructor applied the "& 0xff" mask.
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = StringReader;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Uint8ArrayReader = __webpack_require__(605);
var utils = __webpack_require__(35);

function NodeBufferReader(data) {
    Uint8ArrayReader.call(this, data);
}
utils.inherits(NodeBufferReader, Uint8ArrayReader);

/**
 * @see DataReader.readData
 */
NodeBufferReader.prototype.readData = function(size) {
    this.checkOffset(size);
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = NodeBufferReader;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var readerFor = __webpack_require__(602);
var utils = __webpack_require__(35);
var CompressedObject = __webpack_require__(489);
var crc32fn = __webpack_require__(490);
var utf8 = __webpack_require__(144);
var compressions = __webpack_require__(599);
var support = __webpack_require__(117);

var MADE_BY_DOS = 0x00;
var MADE_BY_UNIX = 0x03;

/**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */
var findCompression = function(compressionMethod) {
    for (var method in compressions) {
        if (!compressions.hasOwnProperty(method)) {
            continue;
        }
        if (compressions[method].magic === compressionMethod) {
            return compressions[method];
        }
    }
    return null;
};

// class ZipEntry {{{
/**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntry(options, loadOptions) {
    this.options = options;
    this.loadOptions = loadOptions;
}
ZipEntry.prototype = {
    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */
    isEncrypted: function() {
        // bit 1 is set
        return (this.bitFlag & 0x0001) === 0x0001;
    },
    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */
    useUTF8: function() {
        // bit 11 is set
        return (this.bitFlag & 0x0800) === 0x0800;
    },
    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readLocalPart: function(reader) {
        var compression, localExtraFieldsLength;

        // we already know everything from the central dir !
        // If the central dir data are false, we are doomed.
        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
        // The less data we get here, the more reliable this should be.
        // Let's skip the whole header and dash to the data !
        reader.skip(22);
        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
        // Strangely, the filename here is OK.
        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
        // the internet.
        //
        // I think I see the logic here : the central directory is used to display
        // content and the local directory is used to extract the files. Mixing / and \
        // may be used to display \ to windows users and use / when extracting the files.
        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
        this.fileNameLength = reader.readInt(2);
        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
        this.fileName = reader.readData(this.fileNameLength);
        reader.skip(localExtraFieldsLength);

        if (this.compressedSize === -1 || this.uncompressedSize === -1) {
            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize === -1 || uncompressedSize === -1)");
        }

        compression = findCompression(this.compressionMethod);
        if (compression === null) { // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + utils.transformTo("string", this.fileName) + ")");
        }
        this.decompressed = new CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
    },

    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readCentralPart: function(reader) {
        this.versionMadeBy = reader.readInt(2);
        reader.skip(2);
        // this.versionNeeded = reader.readInt(2);
        this.bitFlag = reader.readInt(2);
        this.compressionMethod = reader.readString(2);
        this.date = reader.readDate();
        this.crc32 = reader.readInt(4);
        this.compressedSize = reader.readInt(4);
        this.uncompressedSize = reader.readInt(4);
        var fileNameLength = reader.readInt(2);
        this.extraFieldsLength = reader.readInt(2);
        this.fileCommentLength = reader.readInt(2);
        this.diskNumberStart = reader.readInt(2);
        this.internalFileAttributes = reader.readInt(2);
        this.externalFileAttributes = reader.readInt(4);
        this.localHeaderOffset = reader.readInt(4);

        if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
        }

        // will be read in the local part, see the comments there
        reader.skip(fileNameLength);
        this.readExtraFields(reader);
        this.parseZIP64ExtraField(reader);
        this.fileComment = reader.readData(this.fileCommentLength);
    },

    /**
     * Parse the external file attributes and get the unix/dos permissions.
     */
    processAttributes: function () {
        this.unixPermissions = null;
        this.dosPermissions = null;
        var madeBy = this.versionMadeBy >> 8;

        // Check if we have the DOS directory flag set.
        // We look for it in the DOS and UNIX permissions
        // but some unknown platform could set it as a compatibility flag.
        this.dir = this.externalFileAttributes & 0x0010 ? true : false;

        if(madeBy === MADE_BY_DOS) {
            // first 6 bits (0 to 5)
            this.dosPermissions = this.externalFileAttributes & 0x3F;
        }

        if(madeBy === MADE_BY_UNIX) {
            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
        }

        // fail safe : if the name ends with a / it probably means a folder
        if (!this.dir && this.fileNameStr.slice(-1) === '/') {
            this.dir = true;
        }
    },

    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */
    parseZIP64ExtraField: function(reader) {

        if (!this.extraFields[0x0001]) {
            return;
        }

        // should be something, preparing the extra reader
        var extraReader = readerFor(this.extraFields[0x0001].value);

        // I really hope that these 64bits integer can fit in 32 bits integer, because js
        // won't let us have more.
        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
        }
        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
        }
        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
        }
        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
        }
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readExtraFields: function(reader) {
        var end = reader.index + this.extraFieldsLength,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;

        if (!this.extraFields) {
            this.extraFields = {};
        }

        while (reader.index < end) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readData(extraFieldLength);

            this.extraFields[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Apply an UTF8 transformation if needed.
     */
    handleUTF8: function() {
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        if (this.useUTF8()) {
            this.fileNameStr = utf8.utf8decode(this.fileName);
            this.fileCommentStr = utf8.utf8decode(this.fileComment);
        } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
                this.fileNameStr = upath;
            } else {
                // ASCII text or unsupported code page
                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
            }

            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
                this.fileCommentStr = ucomment;
            } else {
                // ASCII text or unsupported code page
                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
            }
        }
    },

    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */
    findExtraFieldUnicodePath: function() {
        var upathField = this.extraFields[0x7075];
        if (upathField) {
            var extraReader = readerFor(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (crc32fn(this.fileName) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(upathField.length - 5));
        }
        return null;
    },

    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */
    findExtraFieldUnicodeComment: function() {
        var ucommentField = this.extraFields[0x6375];
        if (ucommentField) {
            var extraReader = readerFor(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (crc32fn(this.fileComment) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(ucommentField.length - 5));
        }
        return null;
    }
};
module.exports = ZipEntry;


/***/ }),
/* 953 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = __webpack_require__(36);

var _reactRouterRedux = __webpack_require__(27);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _constants = __webpack_require__(658);

var cnt = _interopRequireWildcard(_constants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getAssets),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(downloadContractingDocs),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(handleTracking),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(rerouteOrDownload),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(onVerifyTokenSuccess),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(updateContractStatus),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(login),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(routeToAppAfterLogin),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(signUp),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(autoLogin),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(scheduleDemo),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(requestEzLoad),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(handleAfterSignup),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(sendExternalRates),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(downloadAll),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(sendExternalRatesForOneRequest),
    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(routeAfterCheckForDummy),
    _marked20 = /*#__PURE__*/regeneratorRuntime.mark(handleAutoLoginError),
    _marked21 = /*#__PURE__*/regeneratorRuntime.mark(doSignRateDocs),
    _marked22 = /*#__PURE__*/regeneratorRuntime.mark(markDummyTemplateAsViewed); /* global window */


function getAssets() {
  var _ref, senderId;

  return regeneratorRuntime.wrap(function getAssets$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref = _context.sent;
          senderId = _ref.senderId;
          return _context.delegateYield((0, _sagas.apiSaga)(cnt.GET_ASSETS, _api.assetLanding.getAssets, [senderId]), 't0', 5);

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function downloadContractingDocs(_ref2) {
  var docId = _ref2.payload.docId;
  return regeneratorRuntime.wrap(function downloadContractingDocs$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!docId) {
            _context2.next = 3;
            break;
          }

          _context2.next = 3;
          return (0, _effects.put)({
            type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
            payload: {
              docId: docId,
              collection: 'contract',
              isBulk: true,
              forAL: true
            }
          });

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}
function openXls(_ref3) {
  var location = _ref3.payload.location;

  window.open(location);
}

function init(_ref4) {
  var payload = _ref4.payload;
  var hashToken, oldUrlPayload;
  return regeneratorRuntime.wrap(function init$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          hashToken = payload.hashToken || 'oldUrl';
          oldUrlPayload = payload.hashToken ? null : payload;
          // Important, we use this to retrieve the logged in session
          // we want to do this before verify token (retrieving info in the token from the backend)
          // so that after VERIFY_TOKEN, we can handle reroute first

          _context3.next = 4;
          return (0, _sagas.apiSaga)(cnt.GET_LOGGED_IN_SESSION, _api.admin.getSessionInfo, []);

        case 4:
          _context3.next = 6;
          return (0, _sagas.apiSaga)('VERIFY_TOKEN', _api.assetLanding.verifyToken, [hashToken, oldUrlPayload]);

        case 6:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function handleTracking(_ref5) {
  var payload = _ref5.payload;

  var _ref6, email, viewAs, userId;

  return regeneratorRuntime.wrap(function handleTracking$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref6 = _context4.sent;
          email = _ref6.email;
          viewAs = _ref6.viewAs;
          userId = _ref6.userId;
          _context4.next = 8;
          return (0, _effects.put)({
            type: 'TRACK_EVENT',
            payload: {
              ga: {
                eventCategory: 'assetLanding',
                eventAction: payload.eventAction || 'click ' + payload.type + ' - ' + viewAs,
                eventLabel: email + '-' + userId
              }
            }
          });

        case 8:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function getRequest(_ref7) {
  var crId = _ref7.payload.crId;
  return regeneratorRuntime.wrap(function getRequest$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _sagas.apiSaga)('[asset-landing]GET_REQUEST', _api.contracting.getContractInfo, [{
            collection: 'contract',
            type: 'policyNotes',
            docId: crId,
            forAL: true
          }]);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function rerouteOrDownload() {
  var _ref8, _ref8$loggedInSession, loggedInSession, contractId, contractIds, DL, shortid, hashToken, fromHash, userId, companyType, viewerLoggedInAndCorrectAcctType, downloadPayload;

  return regeneratorRuntime.wrap(function rerouteOrDownload$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref8 = _context6.sent;
          _ref8$loggedInSession = _ref8.loggedInSession;
          loggedInSession = _ref8$loggedInSession === undefined ? {} : _ref8$loggedInSession;
          contractId = _ref8.contractId;
          contractIds = _ref8.contractIds;
          DL = _ref8.DL;
          shortid = _ref8.shortid;
          hashToken = _ref8.hashToken;
          fromHash = _objectWithoutProperties(_ref8, ['loggedInSession', 'contractId', 'contractIds', 'DL', 'shortid', 'hashToken']);
          userId = loggedInSession.userId, companyType = loggedInSession.companyType;
          viewerLoggedInAndCorrectAcctType = userId && fromHash.userId && userId === fromHash.userId && companyType === fromHash.viewAs;
          // if viewer is the sender of the contract/request
          // OR if the receiver of the contract/request and is logged in to the correct account
          // route them to contract or contract list

          if (!(fromHash.viewerIsContractSender || viewerLoggedInAndCorrectAcctType)) {
            _context6.next = 17;
            break;
          }

          if (contractId || contractIds && contractIds.length === 1) {
            window.location = window.location.protocol + '//' + window.location.host + '/contracting/contract/' + (contractId || contractIds[0]) + '/details';
          } else {
            window.location = window.location.protocol + '//' + window.location.host + '/contracting/contract-list/recent?contractIds=' + contractIds;
          }
          _context6.next = 41;
          break;

        case 17:
          if (!(fromHash.viewAs === 'Contractor')) {
            _context6.next = 24;
            break;
          }

          downloadPayload = {
            collection: 'contract',
            isBulk: true,
            forAL: true
          };

          if (contractId) {
            downloadPayload.docId = contractId;
          } else if (contractIds && contractIds.length === 1) {
            downloadPayload.docId = contractIds[0];
          } else if (contractIds && contractIds.length > 1) {
            downloadPayload.contractIds = contractIds;
          }
          _context6.next = 22;
          return (0, _effects.put)({
            type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
            payload: downloadPayload
          });

        case 22:
          _context6.next = 41;
          break;

        case 24:
          if (!(fromHash.viewAs === 'Supplier' && (contractId || contractIds && contractIds.length === 1))) {
            _context6.next = 41;
            break;
          }

          if (!DL) {
            _context6.next = 30;
            break;
          }

          _context6.next = 28;
          return (0, _sagas.apiSaga)('[asset-landing]CHECK_DUMMY_ACCOUNT', _api.assetLanding.checkDummyAccount, [{ shortid: shortid, contractId: contractId || contractIds[0] }]);

        case 28:
          _context6.next = 41;
          break;

        case 30:
          _context6.t0 = _effects.put;
          _context6.t1 = _reactRouterRedux.push;
          _context6.next = 34;
          return (0, _effects.select)(function (state) {
            return state.routing.locationBeforeTransitions.query;
          });

        case 34:
          _context6.t2 = _context6.sent;
          _context6.t3 = {
            pathname: '/assets-landing-request',
            query: _context6.t2
          };
          _context6.t4 = (0, _context6.t1)(_context6.t3);
          _context6.next = 39;
          return (0, _context6.t0)(_context6.t4);

        case 39:
          _context6.next = 41;
          return getRequest({
            payload: {
              crId: contractId || contractIds[0]
            }
          });

        case 41:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function onVerifyTokenSuccess(_ref9) {
  var payload = _ref9.payload;
  var hashToken, encryptedEmail;
  return regeneratorRuntime.wrap(function onVerifyTokenSuccess$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          hashToken = payload.hashToken;

          if (!(payload.autosignin && payload.userId)) {
            _context7.next = 4;
            break;
          }

          return _context7.delegateYield((0, _sagas.apiSaga)(cnt.AUTO_LOGIN, _api.account.loginAsUser, [_extends({
            hashToken: hashToken,
            email: payload.realActorEmail
          }, payload)]), 't0', 3);

        case 3:
          return _context7.abrupt('return');

        case 4:
          encryptedEmail = payload.encryptedEmail || 'newUrl';
          // this is to add hashtoken to req.headers for requests sending from AL page

          _context7.next = 7;
          return (0, _sagas.apiSaga)(cnt.AUTH_BY_TOKEN, _api.assetLanding.authByToken, [hashToken, encryptedEmail]);

        case 7:
          sessionStorage.setItem('hashtoken', hashToken);
          sessionStorage.setItem('encryptedemail', encryptedEmail);

          if (!(window.location.pathname.indexOf('/assets-landing-signing') > -1)) {
            _context7.next = 14;
            break;
          }

          _context7.next = 12;
          return getRequest({
            payload: payload
          });

        case 12:
          _context7.next = 18;
          break;

        case 14:
          _context7.next = 16;
          return rerouteOrDownload();

        case 16:
          _context7.next = 18;
          return (0, _effects.all)([getAssets(), handleTracking({
            payload: {
              eventAction: 'page load - ' + (payload.userId ? 'Internal' : 'External') + ' ' + payload.viewAs
            }
          })]);

        case 18:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function updateContractStatus(_ref10) {
  var type = _ref10.type,
      payload = _ref10.payload;
  return regeneratorRuntime.wrap(function updateContractStatus$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.delegateYield(handleTracking({ payload: { type: payload.state } }), 't0', 1);

        case 1:
          return _context8.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.updateContractStatus, [{
            contractIds: payload.contractIds,
            state: payload.state
          }]), 't1', 2);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function login(_ref11) {
  var type = _ref11.type,
      payload = _ref11.payload;
  return regeneratorRuntime.wrap(function login$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.delegateYield((0, _sagas.apiSaga)(type, _api.account.login, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function routeToAppAfterLogin(_ref12) {
  var payload = _ref12.payload;

  var _ref13, hashToken, dialog, routeToUrl, jumpBackTo, userId;

  return regeneratorRuntime.wrap(function routeToAppAfterLogin$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          localStorage.setItem('jwt', payload.user.jwt);
          _context10.next = 3;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 3:
          _ref13 = _context10.sent;
          hashToken = _ref13.hashToken;
          dialog = _ref13.dialog;
          routeToUrl = _ref13.routeToUrl;
          jumpBackTo = _ref13.jumpBackTo;
          userId = _ref13.userId;

          if (dialog.associateEmail || dialog.routeToConsolidation) {
            window.location = window.location.protocol + '//' + window.location.host + '/assets-consolidation/' + hashToken + '?associateEmail=' + dialog.associateEmail;
          } else if (routeToUrl) {
            window.location = '' + routeToUrl + (routeToUrl.indexOf('?') > -1 ? '&' : '?') + 'jumpBackTo=' + jumpBackTo + '&magicLinkHashToken=' + hashToken;
          } else {
            window.location = window.location.protocol + '//' + window.location.host + '/contracting/contract-list/recent';
          }

        case 10:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function signUp() {
  var signup;
  return regeneratorRuntime.wrap(function signUp$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contractingSignUp.toJS();
          });

        case 2:
          signup = _context11.sent;
          return _context11.delegateYield((0, _sagas.apiSaga)(cnt.SIGN_UP, _api.account.shellSignUp, [signup]), 't0', 4);

        case 4:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function autoLogin() {
  var _ref14, hashToken, _ref15, userId, email, companyType;

  return regeneratorRuntime.wrap(function autoLogin$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref14 = _context12.sent;
          hashToken = _ref14.hashToken;
          _context12.next = 6;
          return (0, _effects.select)(function (state) {
            return _ramda2.default.path(['assetsLandingReducer', 'dialog', 'newUserInfo'], state);
          });

        case 6:
          _ref15 = _context12.sent;
          userId = _ref15.userId;
          email = _ref15.email;
          companyType = _ref15.companyType;
          return _context12.delegateYield((0, _sagas.apiSaga)(cnt.AUTO_LOGIN, _api.account.loginAsUser, [{ userId: userId, email: email, companyType: companyType, hashToken: hashToken }]), 't0', 11);

        case 11:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function scheduleDemo() {
  var _ref16, email, viewAs, userId;

  return regeneratorRuntime.wrap(function scheduleDemo$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          window.open('https://app.hubspot.com/meetings/andrew157');
          _context13.next = 3;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 3:
          _ref16 = _context13.sent;
          email = _ref16.email;
          viewAs = _ref16.viewAs;
          userId = _ref16.userId;
          _context13.next = 9;
          return (0, _effects.put)({
            type: 'TRACK_EVENT',
            payload: {
              ga: {
                eventCategory: 'assetLanding',
                eventAction: 'scheduleDemo - ' + viewAs,
                eventLabel: email + '-' + userId
              }
            }
          });

        case 9:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function requestEzLoad(_ref17) {
  var afterSignUp = _ref17.afterSignUp;

  var _ref18, _ref18$dialog, files, allRequests, newUserInfo, companyId, thisEmail, supplierId, email, requests;

  return regeneratorRuntime.wrap(function requestEzLoad$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref18 = _context14.sent;
          _ref18$dialog = _ref18.dialog;
          files = _ref18$dialog.files;
          allRequests = _ref18$dialog.allRequests;
          newUserInfo = _ref18$dialog.newUserInfo;
          companyId = _ref18.companyId;
          thisEmail = _ref18.email;
          supplierId = afterSignUp ? newUserInfo.companyId : companyId;
          email = afterSignUp ? newUserInfo.email : thisEmail;
          requests = allRequests.filter(function (obj) {
            return obj.checked;
          });
          return _context14.delegateYield((0, _sagas.apiSaga)(cnt.REQUEST_EZ_LOAD, _api.assetLanding.ezLoadRequest, [{ supplierId: supplierId, files: files, requests: requests, email: email }]), 't0', 13);

        case 13:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function handleAfterSignup() {
  var _ref19, dialogType, newUserInfo;

  return regeneratorRuntime.wrap(function handleAfterSignup$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer.dialog;
          });

        case 2:
          _ref19 = _context15.sent;
          dialogType = _ref19.type;
          newUserInfo = _ref19.newUserInfo;

          if (!(dialogType === 'dl-wizard')) {
            _context15.next = 9;
            break;
          }

          return _context15.delegateYield(requestEzLoad({ afterSignUp: true }), 't0', 7);

        case 7:
          _context15.next = 10;
          break;

        case 9:
          if (newUserInfo.email.indexOf('dl+') > -1) {
            window.location = window.location.protocol + '//' + window.location.host + '/admin/company-details/' + newUserInfo.companyId;
          }

        case 10:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function sendExternalRates(_ref20) {
  var type = _ref20.type,
      payload = _ref20.payload;

  var subject, message, _ref21, _ref21$dialog, files, allRequests, fromEmail, userId, companyId, requests;

  return regeneratorRuntime.wrap(function sendExternalRates$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          subject = payload.subject, message = payload.message;
          _context16.next = 3;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 3:
          _ref21 = _context16.sent;
          _ref21$dialog = _ref21.dialog;
          files = _ref21$dialog.files;
          allRequests = _ref21$dialog.allRequests;
          fromEmail = _ref21.email;
          userId = _ref21.userId;
          companyId = _ref21.companyId;
          requests = allRequests.filter(function (obj) {
            return obj.checked;
          });
          return _context16.delegateYield((0, _sagas.apiSaga)(type, _api.assetLanding.sendExternalRates, [{ subject: subject, message: message, files: files, requests: requests, fromEmail: fromEmail, userId: userId, supplierId: companyId }]), 't0', 12);

        case 12:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function downloadAll(what) {
  var _ref22, rates;

  return regeneratorRuntime.wrap(function downloadAll$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref22 = _context17.sent;
          rates = _ref22.rates;
          _context17.next = 6;
          return (0, _effects.put)({
            type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
            payload: {
              contractIds: rates.filter(function (obj) {
                if (what === 'all') return true;
                if (what === 'current') return obj.endDate >= new Date().toISOString();
                return obj.endDate < new Date().toISOString();
              }).map(function (obj) {
                return obj._id;
              }),
              collection: 'contract',
              isBulk: true,
              forAL: true
            }
          });

        case 6:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}
function sendExternalRatesForOneRequest(_ref23) {
  var payload = _ref23.payload;

  var _ref24, fromEmail, userId;

  return regeneratorRuntime.wrap(function sendExternalRatesForOneRequest$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer;
          });

        case 2:
          _ref24 = _context18.sent;
          fromEmail = _ref24.email;
          userId = _ref24.userId;
          return _context18.delegateYield((0, _sagas.apiSaga)(cnt.SEND_RATES_FOR_ONE_REQUEST, _api.assetLanding.sendExternalRates, [_extends({}, payload, {
            fromEmail: fromEmail,
            userId: userId
          })]), 't0', 6);

        case 6:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function routeAfterCheckForDummy(_ref25) {
  var payload = _ref25.payload;
  return regeneratorRuntime.wrap(function routeAfterCheckForDummy$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          window.location = payload.url;

        case 1:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked19, this);
}

function handleAutoLoginError(_ref26) {
  var payload = _ref26.payload;
  return regeneratorRuntime.wrap(function handleAutoLoginError$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          window.alert(payload);
          window.location = window.location.protocol + '//' + window.location.host + '/' + (payload.indexOf('TC admin') > -1 ? 'admin-signin' : 'signin');

        case 2:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked20, this);
}

function doSignRateDocs(_ref27) {
  var type = _ref27.type,
      payload = _ref27.payload;
  return regeneratorRuntime.wrap(function doSignRateDocs$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return (0, _sagas.apiSaga)(type, _api.assetLanding.signRateDocs, [payload]);

        case 2:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked21, this);
}

function markDummyTemplateAsViewed(_ref28) {
  var type = _ref28.type,
      payload = _ref28.payload;
  return regeneratorRuntime.wrap(function markDummyTemplateAsViewed$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return (0, _sagas.apiSaga)(type, _api.assetLanding.markDummyTemplateAsViewed, [_extends({}, payload, {
            from: 'al-signing'
          })]);

        case 2:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked22, this);
}

exports.default = [(0, _effects.takeLatest)(cnt.DOWNLOAD_RATES_CONTRACT, downloadContractingDocs), (0, _effects.takeLatest)(cnt.INIT, init), (0, _effects.takeLatest)('VERIFY_TOKEN_SUCCESS', onVerifyTokenSuccess), (0, _effects.takeLatest)(cnt.CHANGE_CONTRACT_STATUS, updateContractStatus), (0, _effects.takeLatest)(cnt.LOG_IN, login), (0, _effects.takeLatest)(cnt.LOG_IN + '_SUCCESS', routeToAppAfterLogin), (0, _effects.takeLatest)(cnt.SIGN_UP, signUp), (0, _effects.takeLatest)(cnt.SIGN_UP + '_SUCCESS', handleAfterSignup), (0, _effects.takeLatest)(cnt.AUTO_LOGIN, autoLogin), (0, _effects.takeLatest)(cnt.AUTO_LOGIN + '_SUCCESS', routeToAppAfterLogin), (0, _effects.takeLatest)(cnt.AUTO_LOGIN + '_ERROR', handleAutoLoginError), (0, _effects.takeLatest)(cnt.OPEN_DIALOG, handleTracking), (0, _effects.takeLatest)(cnt.SCHEDULE_DEMO, scheduleDemo), (0, _effects.takeLatest)(cnt.REQUEST_EZ_LOAD, requestEzLoad), (0, _effects.takeLatest)(cnt.SEND_RATES, sendExternalRates), (0, _effects.takeLatest)(cnt.SEND_RATES_FOR_ONE_REQUEST, sendExternalRatesForOneRequest), (0, _effects.takeEvery)(cnt.GET_XLS + '_SUCCESS', openXls), (0, _effects.takeLatest)(cnt.DOWNLOAD_ALL_CURRENT, /*#__PURE__*/regeneratorRuntime.mark(function download() {
  return regeneratorRuntime.wrap(function download$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return downloadAll('current');

        case 2:
        case 'end':
          return _context23.stop();
      }
    }
  }, download, this);
})), (0, _effects.takeLatest)(cnt.DOWNLOAD_ALL, /*#__PURE__*/regeneratorRuntime.mark(function download() {
  return regeneratorRuntime.wrap(function download$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _context24.next = 2;
          return downloadAll('all');

        case 2:
        case 'end':
          return _context24.stop();
      }
    }
  }, download, this);
})), (0, _effects.takeLatest)(cnt.DOWNLOAD_ALL_OUTDATED, /*#__PURE__*/regeneratorRuntime.mark(function download() {
  return regeneratorRuntime.wrap(function download$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return downloadAll('outdated');

        case 2:
        case 'end':
          return _context25.stop();
      }
    }
  }, download, this);
})), (0, _effects.takeLatest)('[asset-landing]CHECK_DUMMY_ACCOUNT_SUCCESS', routeAfterCheckForDummy), (0, _effects.takeLatest)('[asset-landing]SIGN_RATE_DOCS', doSignRateDocs), (0, _effects.takeLatest)('[asset-landing] RELOAD_CONTRACT_REQUEST', getRequest), (0, _effects.takeLatest)('[asset-landing] MARK_DUMMY_TEMPLATE_AS_VIEWED', markDummyTemplateAsViewed)];

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _constants = __webpack_require__(630);

var cnt = _interopRequireWildcard(_constants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _reactRouterRedux = __webpack_require__(27);

var _reduxSaga = __webpack_require__(92);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getAssociatedTemplates),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(deleteTemplate),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(renameTemplate),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(createSecondaryTemplate),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(routeToTemplate);

function init(_ref) {
  var _ref$payload = _ref.payload,
      pathname = _ref$payload.pathname,
      query = _ref$payload.query;
  return regeneratorRuntime.wrap(function init$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(pathname.indexOf('master-template-list') > -1)) {
            _context.next = 2;
            break;
          }

          return _context.delegateYield((0, _sagas.apiSaga)(cnt.GET_LIST, _api.masterTemplates.getAll, [query.type]), 't0', 2);

        case 2:
          if (!(pathname.indexOf('create-master-template') > -1)) {
            _context.next = 5;
            break;
          }

          _context.next = 5;
          return (0, _effects.put)({ type: cnt.INIT, payload: { templateType: query.type || 'policyNotes' } });

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getAssociatedTemplates(_ref2) {
  var payload = _ref2.payload;

  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, doc, id, type;

  return regeneratorRuntime.wrap(function getAssociatedTemplates$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context2.prev = 3;
          _iterator = payload[Symbol.iterator]();

        case 5:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context2.next = 12;
            break;
          }

          doc = _step.value;
          id = doc._id, type = doc.type;
          return _context2.delegateYield((0, _sagas.apiSaga)(cnt.GET_ASSOCIATED_TEMPLATES, _api.masterTemplates.getAssociatedTemplates, [{ id: id, type: type }]), 't0', 9);

        case 9:
          _iteratorNormalCompletion = true;
          _context2.next = 5;
          break;

        case 12:
          _context2.next = 18;
          break;

        case 14:
          _context2.prev = 14;
          _context2.t1 = _context2['catch'](3);
          _didIteratorError = true;
          _iteratorError = _context2.t1;

        case 18:
          _context2.prev = 18;
          _context2.prev = 19;

          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }

        case 21:
          _context2.prev = 21;

          if (!_didIteratorError) {
            _context2.next = 24;
            break;
          }

          throw _iteratorError;

        case 24:
          return _context2.finish(21);

        case 25:
          return _context2.finish(18);

        case 26:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[3, 14, 18, 26], [19,, 21, 25]]);
}

function deleteTemplate(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  return regeneratorRuntime.wrap(function deleteTemplate$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.deleteTemplate, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function renameTemplate(_ref4) {
  var type = _ref4.type,
      payload = _ref4.payload;
  return regeneratorRuntime.wrap(function renameTemplate$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.renameTemplate, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function createSecondaryTemplate(_ref5) {
  var type = _ref5.type;

  var _ref6, templateType, templateName;

  return regeneratorRuntime.wrap(function createSecondaryTemplate$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.masterTemplate.createNew;
          });

        case 2:
          _ref6 = _context5.sent;
          templateType = _ref6.templateType;
          templateName = _ref6.templateName;
          return _context5.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.createInitial, [{ type: templateType, templateName: templateName }]), 't0', 6);

        case 6:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function routeToTemplate(_ref7) {
  var payload = _ref7.payload;
  return regeneratorRuntime.wrap(function routeToTemplate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/master-template/draft:' + payload.newId));

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

exports.default = [(0, _effects.takeLatest)('@@router/LOCATION_CHANGE', init), (0, _effects.takeLatest)(cnt.GET_LIST + '_SUCCESS', getAssociatedTemplates), (0, _effects.takeLatest)(cnt.DELETE_TEMPLATE, deleteTemplate), (0, _effects.takeLatest)(cnt.RENAME_TEMPLATE, renameTemplate), (0, _effects.takeLatest)(cnt.CREATE, createSecondaryTemplate), (0, _effects.takeLatest)(cnt.CREATE + '_SUCCESS', routeToTemplate)];

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _effects = __webpack_require__(36);

var _constants = __webpack_require__(579);

var cnt = _interopRequireWildcard(_constants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _reactRouterRedux = __webpack_require__(27);

var _composeDraftEditDataByType = __webpack_require__(608);

var _editContractDetails = __webpack_require__(866);

var _editContractDetails2 = _interopRequireDefault(_editContractDetails);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getDocData),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getMasters),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(loadDoc),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getTemplateDrafts),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(loadDiff),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(doCreateEditedDraft),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(routeToDraft),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(populateEditDialog),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(getAssociatedTemplates),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(saveEdits),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(discardDraft),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(routeToTemplate),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(finalise),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(handleClickFinalise),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(getAffectedBuyers),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(handleFinaliseSuccess),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(applyToTemplates),
    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(handleApplySuccess);

function getDocData() {
  var _ref, docs, currentId;

  return regeneratorRuntime.wrap(function getDocData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(function (_ref2) {
            var contracting = _ref2.contracting;
            return contracting.masterTemplate;
          });

        case 2:
          _ref = _context.sent;
          docs = _ref.docs;
          currentId = docs.currentId;
          return _context.abrupt('return', {
            currentId: currentId,
            docData: docs[currentId]
          });

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getMasters() {
  var _ref3, policyType;

  return regeneratorRuntime.wrap(function getMasters$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.masterTemplate.applyMasterToTemplatesReducer;
          });

        case 2:
          _ref3 = _context2.sent;
          policyType = _ref3.type;
          return _context2.delegateYield((0, _sagas.apiSaga)(cnt.apply.GET_MASTERS, _api.masterTemplates.getAll, [policyType]), 't0', 5);

        case 5:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function loadDoc() {
  var _ref4, pathname, _pathname$split$slice, _pathname$split$slice2, id;

  return regeneratorRuntime.wrap(function loadDoc$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(function (state) {
            return state.route;
          });

        case 2:
          _ref4 = _context3.sent;
          pathname = _ref4.currentRoute;
          _pathname$split$slice = pathname.split('/').slice(3, 4), _pathname$split$slice2 = _slicedToArray(_pathname$split$slice, 1), id = _pathname$split$slice2[0];

          if (!id) {
            _context3.next = 7;
            break;
          }

          return _context3.delegateYield((0, _sagas.apiSaga)(cnt.GET_DOC, _api.masterTemplates.getOne, [id]), 't0', 7);

        case 7:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function getTemplateDrafts() {
  return regeneratorRuntime.wrap(function getTemplateDrafts$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.delegateYield((0, _sagas.apiSaga)(cnt.apply.GET_TEMPLATES, _api.contracting.getTemplateList, []), 't0', 1);

        case 1:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function init(_ref5) {
  var _ref5$payload = _ref5.payload,
      pathname = _ref5$payload.pathname,
      query = _ref5$payload.query;

  var _pathname$split$slice3, _pathname$split$slice4, masterId, _pathname$split$slice5, _pathname$split$slice6, templateDraftId;

  return regeneratorRuntime.wrap(function init$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (!(pathname.indexOf('/master-template/') > -1)) {
            _context5.next = 3;
            break;
          }

          _context5.next = 3;
          return loadDoc();

        case 3:
          if (!(pathname.indexOf('/associate') > -1)) {
            _context5.next = 9;
            break;
          }

          _pathname$split$slice3 = pathname.split('/').slice(3, 4), _pathname$split$slice4 = _slicedToArray(_pathname$split$slice3, 1), masterId = _pathname$split$slice4[0];
          _context5.next = 7;
          return getTemplateDrafts();

        case 7:
          _context5.next = 9;
          return (0, _effects.put)({
            type: cnt.apply.INIT,
            payload: {
              type: query.type,
              knownMasterId: masterId
            }
          });

        case 9:
          if (!(pathname.indexOf('pick-master-template') > -1)) {
            _context5.next = 15;
            break;
          }

          _pathname$split$slice5 = pathname.split('/').slice(3, 4), _pathname$split$slice6 = _slicedToArray(_pathname$split$slice5, 1), templateDraftId = _pathname$split$slice6[0];
          _context5.next = 13;
          return (0, _effects.put)({
            type: cnt.apply.INIT,
            payload: {
              type: query.type,
              knownTemplateDraftId: templateDraftId
            }
          });

        case 13:
          _context5.next = 15;
          return getMasters();

        case 15:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function loadDiff(_ref6) {
  var payload = _ref6.payload;
  return regeneratorRuntime.wrap(function loadDiff$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (!(payload.data.status === 'draft' && payload.data.originFrom === 'edited')) {
            _context6.next = 2;
            break;
          }

          return _context6.delegateYield((0, _sagas.apiSaga)(cnt.GET_DIFF_SUMMARY, _api.masterTemplates.getDiff, [{
            lhsDocId: payload.data.draftId,
            rhsDocId: 'draft:' + payload.data.draftId,
            onlyGetSummary: true
          }]), 't0', 2);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function doCreateEditedDraft(_ref7) {
  var type = _ref7.type;

  var _ref8, currentId;

  return regeneratorRuntime.wrap(function doCreateEditedDraft$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.select)(function (_ref9) {
            var contracting = _ref9.contracting;
            return contracting.masterTemplate.docs;
          });

        case 2:
          _ref8 = _context7.sent;
          currentId = _ref8.currentId;
          return _context7.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.createEditedDraft, [currentId]), 't0', 5);

        case 5:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function routeToDraft(_ref10) {
  var args = _ref10.args;
  return regeneratorRuntime.wrap(function routeToDraft$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/master-template/draft:' + args[0]));

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function populateEditDialog() {
  var _ref11, docs, editDialog, currentId, composedData;

  return regeneratorRuntime.wrap(function populateEditDialog$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(function (_ref12) {
            var contracting = _ref12.contracting;
            return contracting.masterTemplate;
          });

        case 2:
          _ref11 = _context9.sent;
          docs = _ref11.docs;
          editDialog = _ref11.editDialog;
          currentId = docs.currentId;
          composedData = (0, _composeDraftEditDataByType.composeForPolicyNotes)(editDialog, docs[currentId]);
          _context9.next = 9;
          return (0, _effects.put)({ type: cnt.POPULATE_EDIT_DIALOG_DATA, payload: composedData });

        case 9:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function getAssociatedTemplates() {
  var _ref13, docData, currentId, id;

  return regeneratorRuntime.wrap(function getAssociatedTemplates$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return getDocData();

        case 2:
          _ref13 = _context10.sent;
          docData = _ref13.docData;
          currentId = _ref13.currentId;
          id = docData.status === 'draft' ? currentId.split(':')[1] : currentId;
          return _context10.delegateYield((0, _sagas.apiSaga)(cnt.GET_ASSOCIATED_TEMPLATES, _api.masterTemplates.getAssociatedTemplates, [{ id: id, type: docData.type }]), 't0', 7);

        case 7:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function saveEdits(_ref14) {
  var type = _ref14.type,
      payload = _ref14.payload;

  var _ref15, docs, editDialog, currentId, doc, composePayload, nuFiles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, val, uploaded, processed, updates;

  return regeneratorRuntime.wrap(function saveEdits$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.select)(function (_ref16) {
            var contracting = _ref16.contracting;
            return contracting.masterTemplate;
          });

        case 2:
          _ref15 = _context11.sent;
          docs = _ref15.docs;
          editDialog = _ref15.editDialog;
          currentId = docs.currentId;
          doc = docs[currentId];
          composePayload = { data: editDialog.data, updateType: payload.updateType };

          if (!(payload.updateType === 'SAVE_BILLING_INFO_ADD_EDIT' && editDialog.data.insuranceFiles.length)) {
            _context11.next = 39;
            break;
          }

          nuFiles = [];
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context11.prev = 13;
          _iterator = editDialog.data.insuranceFiles[Symbol.iterator]();

        case 15:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context11.next = 24;
            break;
          }

          val = _step.value;
          _context11.next = 19;
          return (0, _sagas.checkUpload)(val, type);

        case 19:
          uploaded = _context11.sent;

          nuFiles.push(uploaded);

        case 21:
          _iteratorNormalCompletion = true;
          _context11.next = 15;
          break;

        case 24:
          _context11.next = 30;
          break;

        case 26:
          _context11.prev = 26;
          _context11.t0 = _context11['catch'](13);
          _didIteratorError = true;
          _iteratorError = _context11.t0;

        case 30:
          _context11.prev = 30;
          _context11.prev = 31;

          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }

        case 33:
          _context11.prev = 33;

          if (!_didIteratorError) {
            _context11.next = 36;
            break;
          }

          throw _iteratorError;

        case 36:
          return _context11.finish(33);

        case 37:
          return _context11.finish(30);

        case 38:
          composePayload.data.insuranceFiles = nuFiles;

        case 39:
          processed = (0, _editContractDetails2.default)(doc, composePayload).contractDetails.toJS();
          updates = _ramda2.default.keys(processed).reduce(function (result, key) {
            return _extends({}, result, _defineProperty({}, doc.type + '.' + key, processed[key]));
          }, {});
          return _context11.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.edit, [currentId.split(':')[1], updates]), 't1', 42);

        case 42:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this, [[13, 26, 30, 38], [31,, 33, 37]]);
}

function discardDraft(_ref17) {
  var type = _ref17.type;

  var confirm, _ref18, currentId;

  return regeneratorRuntime.wrap(function discardDraft$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          confirm = window.confirm('Are you sure you want to discard this draft?');

          if (!confirm) {
            _context12.next = 7;
            break;
          }

          _context12.next = 4;
          return (0, _effects.select)(function (_ref19) {
            var contracting = _ref19.contracting;
            return contracting.masterTemplate;
          });

        case 4:
          _ref18 = _context12.sent;
          currentId = _ref18.docs.currentId;
          return _context12.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.discardDraft, [currentId.split(':')[1]]), 't0', 7);

        case 7:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function routeToTemplate(id) {
  return regeneratorRuntime.wrap(function routeToTemplate$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/master-template/' + id));

        case 2:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function finalise() {
  var _ref20, docData;

  return regeneratorRuntime.wrap(function finalise$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return getDocData();

        case 2:
          _ref20 = _context14.sent;
          docData = _ref20.docData;
          return _context14.delegateYield((0, _sagas.apiSaga)(cnt.FINALISE, _api.masterTemplates.finalise, [docData.draftId]), 't0', 5);

        case 5:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function handleClickFinalise() {
  var _ref21, docData, templates;

  return regeneratorRuntime.wrap(function handleClickFinalise$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return getDocData();

        case 2:
          _ref21 = _context15.sent;
          docData = _ref21.docData;
          templates = docData.templates;

          if (!(templates && templates.length)) {
            _context15.next = 10;
            break;
          }

          _context15.next = 8;
          return (0, _effects.put)({ type: cnt.OPEN_FINALISE_DIALOG });

        case 8:
          _context15.next = 12;
          break;

        case 10:
          _context15.next = 12;
          return finalise();

        case 12:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function getAffectedBuyers() {
  var _ref22, docData, draftId;

  return regeneratorRuntime.wrap(function getAffectedBuyers$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return getDocData();

        case 2:
          _ref22 = _context16.sent;
          docData = _ref22.docData;
          draftId = docData.draftId;
          return _context16.delegateYield((0, _sagas.apiSaga)(cnt.GET_AFFECTED_BUYERS, _api.masterTemplates.getAffectedBuyers, [draftId]), 't0', 6);

        case 6:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

/*
 payload = {
  newId,
  oldId: draftId,
  templateName,
  type,
  nStagedTemplates,
  buyers,
};
*/
function handleFinaliseSuccess(_ref23) {
  var payload = _ref23.payload;
  return regeneratorRuntime.wrap(function handleFinaliseSuccess$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return routeToTemplate(payload.newId);

        case 2:
          if (!payload.nStagedTemplates) {
            _context17.next = 4;
            break;
          }

          return _context17.delegateYield((0, _sagas.apiSaga)(cnt.SEND_UPDATES, _api.contracting.supplierSendUpdates, [{}]), 't0', 4);

        case 4:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

function applyToTemplates(_ref24) {
  var type = _ref24.type;

  var _ref25, _ref25$applyMasterToT, allTemplatesDrafts, sameAsCorporatePolicyNotes, knownMasterId, knownTemplateDraftId, masterType, masterList, honorPreloadContent;

  return regeneratorRuntime.wrap(function applyToTemplates$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.select)(function (_ref26) {
            var contracting = _ref26.contracting;
            return contracting.masterTemplate;
          });

        case 2:
          _ref25 = _context18.sent;
          _ref25$applyMasterToT = _ref25.applyMasterToTemplatesReducer;
          allTemplatesDrafts = _ref25$applyMasterToT.allTemplatesDrafts;
          sameAsCorporatePolicyNotes = _ref25$applyMasterToT.sameAsCorporatePolicyNotes;
          knownMasterId = _ref25$applyMasterToT.knownMasterId;
          knownTemplateDraftId = _ref25$applyMasterToT.knownTemplateDraftId;
          masterType = _ref25$applyMasterToT.type;
          masterList = _ref25$applyMasterToT.masterList;
          honorPreloadContent = _ref25$applyMasterToT.honorPreloadContent;
          return _context18.delegateYield((0, _sagas.apiSaga)(type, _api.masterTemplates.applyMasterToTemplates, [{
            masterTemplateId: knownMasterId || masterList.find(function (obj) {
              return obj.checked;
            })._id,
            type: masterType,
            templateDraftIds: knownTemplateDraftId ? [knownTemplateDraftId] : allTemplatesDrafts.filter(function (obj) {
              return obj.checked;
            }).map(function (obj) {
              return obj.originalContractId || obj._id;
            }),
            sameAsCorporatePolicyNotes: sameAsCorporatePolicyNotes,
            honorPreloadContent: honorPreloadContent
          }]), 't0', 12);

        case 12:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function handleApplySuccess() {
  var _ref27, knownTemplateDraftId;

  return regeneratorRuntime.wrap(function handleApplySuccess$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.select)(function (_ref28) {
            var contracting = _ref28.contracting;
            return contracting.masterTemplate.applyMasterToTemplatesReducer;
          });

        case 2:
          _ref27 = _context19.sent;
          knownTemplateDraftId = _ref27.knownTemplateDraftId;

          if (!knownTemplateDraftId) {
            _context19.next = 11;
            break;
          }

          _context19.next = 7;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/contracting/draft/' + knownTemplateDraftId + '/policies'));

        case 7:
          _context19.next = 9;
          return (0, _effects.put)({ type: cnt.apply.CLEAR_STORE });

        case 9:
          _context19.next = 15;
          break;

        case 11:
          _context19.next = 13;
          return getTemplateDrafts();

        case 13:
          _context19.next = 15;
          return getAssociatedTemplates();

        case 15:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked19, this);
}
exports.default = [(0, _effects.takeLatest)('@@router/LOCATION_CHANGE', init), (0, _effects.takeLatest)(cnt.GET_DOC + '_SUCCESS', loadDiff), (0, _effects.takeLatest)(cnt.GET_DOC + '_SUCCESS', getAssociatedTemplates), (0, _effects.takeLatest)(cnt.CREATE_EDITED_DRAFT, doCreateEditedDraft), (0, _effects.takeLatest)(cnt.CREATE_EDITED_DRAFT + '_SUCCESS', routeToDraft), (0, _effects.takeLatest)(cnt.INITIATE_EDIT_WITH_TYPE, populateEditDialog), (0, _effects.takeLatest)(cnt.SAVE_EDITS, saveEdits), (0, _effects.takeLatest)(cnt.SAVE_EDITS + '_SUCCESS', loadDoc), (0, _effects.takeLatest)(cnt.DISCARD_DRAFT, discardDraft), (0, _effects.takeLatest)(cnt.DISCARD_DRAFT + '_SUCCESS', /*#__PURE__*/regeneratorRuntime.mark(function fn(_ref29) {
  var args = _ref29.args;
  return regeneratorRuntime.wrap(function fn$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return routeToTemplate(args[0]);

        case 2:
        case 'end':
          return _context20.stop();
      }
    }
  }, fn, this);
})), (0, _effects.takeLatest)(cnt.CLICK_FINALISE, handleClickFinalise), (0, _effects.takeLatest)(cnt.FINALISE + '_SUCCESS', handleFinaliseSuccess), (0, _effects.takeLatest)(cnt.OPEN_FINALISE_DIALOG, getAffectedBuyers), (0, _effects.takeLatest)(cnt.FINALISE, finalise), (0, _effects.takeLatest)(cnt.apply.GET_TEMPLATES, getTemplateDrafts), (0, _effects.takeLatest)(cnt.apply.GET_MASTERS, getMasters), (0, _effects.takeLatest)(cnt.apply.APPLY_TO_TEMPLATES, applyToTemplates), (0, _effects.takeLatest)(cnt.apply.APPLY_TO_TEMPLATES + '_SUCCESS', handleApplySuccess)];

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.workspaceSagas = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = __webpack_require__(36);

var _api = __webpack_require__(37);

var _actions = __webpack_require__(476);

var _reactRouterRedux = __webpack_require__(27);

var _messagingActions = __webpack_require__(562);

var _constants = __webpack_require__(233);

var wkspConst = _interopRequireWildcard(_constants);

var _messagingConstants = __webpack_require__(506);

var inboxConst = _interopRequireWildcard(_messagingConstants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _sagas = __webpack_require__(43);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchConnections),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(deleteMessage),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(addFilesToContract),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(fetchChannels),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchContractConversations),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchConversations),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(saveSelectedChannel),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(archiveConnection),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(archiveConversation),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(loadLastSelectedChannel),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(createMessage),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(markConversationRead),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(refreshStatusMessages),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(fetchChanges),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(contractConversationsRefresh),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(inboxCountLeft),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(markAcceptedRead);

var getRoute = function getRoute(state) {
  return state.routing.locationBeforeTransitions.pathname;
};
var getConnection = function getConnection(state) {
  return state.workspace.selectedConnection;
};
var getChannel = function getChannel(state) {
  return state.workspace.selectedChannel;
};
var getContract = function getContract(state) {
  return state.workspace.selectedContract;
};
var getChannels = function getChannels(state) {
  return state.workspace.channels;
};
var getConversations = function getConversations(state) {
  return state.workspace.conversations;
};
var routePath = '/workspace';

function fetchConnections() {
  var selectedConnection;
  return regeneratorRuntime.wrap(function fetchConnections$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          selectedConnection = _context.sent;
          return _context.delegateYield((0, _sagas.apiSaga)(wkspConst.CONNECTIONS_FETCH, _api.workspace.getConnections, [selectedConnection]), 't0', 4);

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}
function deleteMessage(_ref) {
  var payload = _ref.payload,
      type = _ref.type;
  return regeneratorRuntime.wrap(function deleteMessage$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)({ type: wkspConst.MESSAGE_DISABLE, payload: payload });

        case 2:
          return _context2.delegateYield((0, _sagas.apiSaga)(type, _api.workspace.deleteMessage, [payload]), 't0', 3);

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function addFilesToContract(_ref2) {
  var payload = _ref2.payload;
  var contractId, files;
  return regeneratorRuntime.wrap(function addFilesToContract$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(getContract);

        case 2:
          contractId = _context3.sent;
          _context3.next = 5;
          return (0, _effects.select)(getConversations);

        case 5:
          _context3.t0 = function (e) {
            return e.key === payload;
          };

          files = _context3.sent.filter(_context3.t0)[0].attachments;
          _context3.next = 9;
          return (0, _effects.put)({ type: wkspConst.MESSAGE_DISABLE, payload: payload });

        case 9:
          return _context3.delegateYield((0, _sagas.apiSaga)(wkspConst.MESSAGE_ADD_FILES_TO_CONTRACT, _api.contracting.addFilesToContract, [{ contractId: contractId, files: files, msgId: payload }]), 't1', 10);

        case 10:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function fetchChannels() {
  var connection, channel, contract;
  return regeneratorRuntime.wrap(function fetchChannels$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          connection = _context4.sent;
          _context4.next = 5;
          return (0, _effects.select)(getChannel);

        case 5:
          channel = _context4.sent;
          _context4.next = 8;
          return (0, _effects.select)(getContract);

        case 8:
          contract = _context4.sent;

          if (!connection) {
            _context4.next = 11;
            break;
          }

          return _context4.delegateYield((0, _sagas.apiSaga)(wkspConst.CHANNELS_FETCH, _api.workspace.getChannels, [connection, channel, contract]), 't0', 11);

        case 11:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function fetchContractConversations() {
  var route, getContractFromContracting, _selectedContract, connection, selectedContract;

  return regeneratorRuntime.wrap(function fetchContractConversations$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(getRoute);

        case 2:
          route = _context5.sent;

          if (!(route.substring(0, routePath.length) !== routePath)) {
            _context5.next = 12;
            break;
          }

          // component is in contacting area
          getContractFromContracting = function getContractFromContracting(state) {
            return state.contracting.contractActivitiesProducts.getIn(['leftNav', 'contractId']);
          };

          _context5.next = 7;
          return (0, _effects.select)(getContractFromContracting);

        case 7:
          _selectedContract = _context5.sent;
          _context5.next = 10;
          return (0, _effects.put)({ type: 'LOADING_HISTORY_FEEDS' });

        case 10:
          return _context5.delegateYield((0, _sagas.apiSaga)('LOADING_HISTORY_FEEDS', _api.historyFeed.getHistory, [_selectedContract]), 't0', 11);

        case 11:
          return _context5.abrupt('return');

        case 12:
          _context5.next = 14;
          return (0, _effects.select)(getConnection);

        case 14:
          connection = _context5.sent;
          _context5.next = 17;
          return (0, _effects.select)(getContract);

        case 17:
          selectedContract = _context5.sent;
          return _context5.delegateYield((0, _sagas.apiSaga)(wkspConst.CONVERSATIONS_FETCH, _api.workspace.getConversations, [connection, selectedContract]), 't1', 19);

        case 19:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function fetchConversations() {
  var connection, channel, contract;
  return regeneratorRuntime.wrap(function fetchConversations$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          connection = _context6.sent;
          _context6.next = 5;
          return (0, _effects.select)(getChannel);

        case 5:
          channel = _context6.sent;
          _context6.next = 8;
          return (0, _effects.select)(getContract);

        case 8:
          contract = _context6.sent;

          if (!(connection && channel)) {
            _context6.next = 15;
            break;
          }

          if (!(contract && channel === 'contracting')) {
            _context6.next = 14;
            break;
          }

          return _context6.delegateYield(fetchContractConversations(), 't0', 12);

        case 12:
          _context6.next = 15;
          break;

        case 14:
          return _context6.delegateYield((0, _sagas.apiSaga)(wkspConst.CONVERSATIONS_FETCH, _api.workspace.getConversations, [connection, channel]), 't1', 15);

        case 15:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function saveSelectedChannel() {
  var selectedConnection, selectedChannel;
  return regeneratorRuntime.wrap(function saveSelectedChannel$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          selectedConnection = _context7.sent;
          _context7.next = 5;
          return (0, _effects.select)(getChannel);

        case 5:
          selectedChannel = _context7.sent;

          if (!(selectedConnection && selectedChannel)) {
            _context7.next = 8;
            break;
          }

          return _context7.delegateYield((0, _sagas.apiSaga)(wkspConst.CHANNELS_SELECT_SAVE, _api.workspace.saveSelectedChannel, [selectedConnection, selectedChannel]), 't0', 8);

        case 8:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function archiveConnection(action) {
  var selectedConnection;
  return regeneratorRuntime.wrap(function archiveConnection$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          selectedConnection = _context8.sent;

          if (!(selectedConnection === action.payload)) {
            _context8.next = 6;
            break;
          }

          _context8.next = 6;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/workspace'));

        case 6:
          return _context8.delegateYield((0, _sagas.apiSaga)(wkspConst.CONNECTIONS_ARCHIVE, _api.workspace.archiveConnection, [action.payload]), 't0', 7);

        case 7:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function archiveConversation(action) {
  var connection, channel, contract;
  return regeneratorRuntime.wrap(function archiveConversation$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          connection = _context9.sent;
          _context9.next = 5;
          return (0, _effects.select)(getChannel);

        case 5:
          channel = _context9.sent;
          _context9.next = 8;
          return (0, _effects.select)(getContract);

        case 8:
          contract = _context9.sent;

          if (!(channel === action.payload.channel && contract === action.payload.contract)) {
            _context9.next = 17;
            break;
          }

          if (!connection) {
            _context9.next = 15;
            break;
          }

          _context9.next = 13;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/workspace/' + connection + '/contracting'));

        case 13:
          _context9.next = 17;
          break;

        case 15:
          _context9.next = 17;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/workspace/' + connection + '/general'));

        case 17:
          return _context9.delegateYield((0, _sagas.apiSaga)(wkspConst.CHANNELS_ARCHIVE, _api.workspace.archiveConversation, [connection, action.payload.channel, action.payload.contract]), 't0', 18);

        case 18:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function loadLastSelectedChannel() {
  var getSelectedConnection, selectedConnection, getConnections, selectedConnectionData, getSelectedChannel, selectedChannel;
  return regeneratorRuntime.wrap(function loadLastSelectedChannel$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          // open the last selected channel, server side
          getSelectedConnection = function getSelectedConnection(state) {
            return state.workspace.selectedConnection;
          };

          _context10.next = 3;
          return (0, _effects.select)(getSelectedConnection);

        case 3:
          selectedConnection = _context10.sent;

          getConnections = function getConnections(state) {
            return state.workspace.connections;
          };

          _context10.next = 7;
          return (0, _effects.select)(getConnections);

        case 7:
          _context10.t0 = function (e) {
            return e.id === selectedConnection;
          };

          selectedConnectionData = _context10.sent.filter(_context10.t0)[0];

          getSelectedChannel = function getSelectedChannel(state) {
            return state.workspace.selectedChannel;
          };

          _context10.next = 12;
          return (0, _effects.select)(getSelectedChannel);

        case 12:
          selectedChannel = _context10.sent;

          if (!(!selectedChannel && selectedConnectionData && selectedConnectionData.lastChannel)) {
            _context10.next = 21;
            break;
          }

          if (!selectedConnectionData.lastContract) {
            _context10.next = 19;
            break;
          }

          _context10.next = 17;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/workspace/' + selectedConnection + '/' + selectedConnectionData.lastChannel + '/' + selectedConnectionData.lastContract));

        case 17:
          _context10.next = 21;
          break;

        case 19:
          _context10.next = 21;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/workspace/' + selectedConnection + '/' + selectedConnectionData.lastChannel));

        case 21:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function createMessage(action) {
  var selectedConnection, selectedChannel, convos;
  return regeneratorRuntime.wrap(function createMessage$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.select)(getConnection);

        case 2:
          selectedConnection = _context11.sent;
          _context11.next = 5;
          return (0, _effects.select)(getChannel);

        case 5:
          selectedChannel = _context11.sent;
          _context11.next = 8;
          return (0, _effects.select)(getConversations);

        case 8:
          convos = _context11.sent;
          return _context11.delegateYield((0, _sagas.apiSaga)(wkspConst.MESSAGE_CREATE, _api.workspace.newMessage, [_extends({
            type: selectedChannel === 'notes' ? 'note' : 'message',
            contractHFIds: selectedChannel && selectedChannel !== 'general' ? [selectedChannel] : [],
            partnerIds: selectedConnection ? [selectedConnection] : [],
            mostRecentIncomingMsg: _ramda2.default.call(_ramda2.default.compose(_ramda2.default.head, _ramda2.default.sortBy(_ramda2.default.descend(_ramda2.default.prop('timestamp'))), _ramda2.default.filter(function (obj) {
              return !obj.isSender;
            })), convos)
          }, action.payload)]), 't0', 10);

        case 10:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function markConversationRead(_ref3) {
  var payload = _ref3.payload;

  var assetType, assetId, messageId, route, getLeftNav, _ref4, historyFeedId, selectedConnection, selectedChannel;

  return regeneratorRuntime.wrap(function markConversationRead$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          if (!payload) {
            _context12.next = 4;
            break;
          }

          assetType = payload.assetType, assetId = payload.assetId, messageId = payload.messageId;
          return _context12.delegateYield((0, _sagas.apiSaga)(wkspConst.CONVERSATIONS_READ, _api.workspace.conversationsRead, [{
            assetType: assetType,
            assetId: assetId,
            messageId: messageId
          }]), 't0', 3);

        case 3:
          return _context12.abrupt('return');

        case 4:
          _context12.next = 6;
          return (0, _effects.select)(getRoute);

        case 6:
          route = _context12.sent;

          if (!(route.substring(0, routePath.length) !== routePath)) {
            _context12.next = 17;
            break;
          }

          // component is in contacting area
          getLeftNav = function getLeftNav(state) {
            return state.contracting.contractActivitiesProducts.get('leftNav').toJS();
          };

          _context12.next = 11;
          return (0, _effects.select)(getLeftNav);

        case 11:
          _ref4 = _context12.sent;
          historyFeedId = _ref4.historyFeedId;

          if (historyFeedId) {
            _context12.next = 15;
            break;
          }

          return _context12.abrupt('return');

        case 15:
          return _context12.delegateYield((0, _sagas.apiSaga)(wkspConst.CONVERSATIONS_READ, _api.workspace.conversationsRead, [{ assetId: historyFeedId, assetType: 'contract' }]), 't1', 16);

        case 16:
          return _context12.abrupt('return');

        case 17:
          _context12.next = 19;
          return (0, _effects.select)(getConnection);

        case 19:
          selectedConnection = _context12.sent;
          _context12.next = 22;
          return (0, _effects.select)(getChannel);

        case 22:
          selectedChannel = _context12.sent;

          if (selectedConnection && selectedChannel) {
            _context12.next = 25;
            break;
          }

          return _context12.abrupt('return');

        case 25:
          return _context12.delegateYield((0, _sagas.apiSaga)(wkspConst.CONVERSATIONS_READ, _api.workspace.conversationsRead, [{
            assetId: selectedConnection,
            assetType: 'partner'
            // Commented this because right now the frontend doesn't handle channels other than contracting
            // history feed "channel" which is taken care of by the "if (payload)" block above
            // triggered by markReadWithParams, which is called in comments.jsx
            // channelId: selectedChannel,
          }]), 't2', 26);

        case 26:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function refreshStatusMessages() {
  return regeneratorRuntime.wrap(function refreshStatusMessages$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          return _context13.delegateYield((0, _sagas.apiSaga)(wkspConst.STATUS_MESSAGES, _api.workspace.statusMessages, []), 't0', 1);

        case 1:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

// function* clearSelectedContract() {
//   yield put(selectContract(null));
// }
//
// function* clearSelectedChannel() {
//   yield put(selectChannel(null));
// }

// TODO: This function should be made global for frontend error handling
var logError = function logError(payload) {
  console.error(payload);
};

function fetchChanges(_ref5) {
  var payload = _ref5.payload;
  var channels;
  return regeneratorRuntime.wrap(function fetchChanges$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          if (!(payload.before.connection !== payload.connection)) {
            _context14.next = 7;
            break;
          }

          _context14.next = 3;
          return (0, _effects.put)((0, _actions.resetChannels)());

        case 3:
          _context14.next = 5;
          return (0, _effects.fork)(fetchChannels);

        case 5:
          _context14.next = 13;
          break;

        case 7:
          _context14.next = 9;
          return (0, _effects.select)(getChannels);

        case 9:
          channels = _context14.sent;

          if (!(channels.filter(function (e) {
            return e.channelId === payload.channel;
          }).length === 0)) {
            _context14.next = 13;
            break;
          }

          _context14.next = 13;
          return (0, _effects.fork)(fetchChannels);

        case 13:
          if (!(payload.before.connection !== payload.connection || payload.before.channel !== payload.channel)) {
            _context14.next = 20;
            break;
          }

          _context14.next = 16;
          return (0, _effects.put)((0, _actions.resetConversations)());

        case 16:
          _context14.next = 18;
          return (0, _effects.fork)(fetchConversations);

        case 18:
          _context14.next = 20;
          return (0, _effects.fork)(saveSelectedChannel);

        case 20:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function contractConversationsRefresh(action) {
  return regeneratorRuntime.wrap(function contractConversationsRefresh$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.put)({ type: 'GET_HISTORY_FEEDS', payload: { response: action.payload } });

        case 2:
          return _context15.delegateYield(markConversationRead({}), 't0', 3);

        case 3:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function inboxCountLeft(action) {
  var selectedChannel;
  return regeneratorRuntime.wrap(function inboxCountLeft$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.select)(getChannel);

        case 2:
          selectedChannel = _context16.sent;

          if (!(selectedChannel !== action.payload.messageId)) {
            _context16.next = 5;
            break;
          }

          return _context16.abrupt('return');

        case 5:
          _context16.next = 7;
          return (0, _effects.put)((0, _messagingActions.updateProps)('convs', { selectedConv: {}, messages: [] }));

        case 7:
          _context16.next = 9;
          return (0, _effects.put)({ type: inboxConst.MSGS_LOADED_INITIALLY, payload: {
              conv: {},
              messages: [],
              lastMsgId: '',
              messagesLoaded: true,
              loadingMessages: false
            } });

        case 9:
          _context16.next = 11;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/workspace/inbox'));

        case 11:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function markAcceptedRead(_ref6) {
  var payload = _ref6.payload;
  return regeneratorRuntime.wrap(function markAcceptedRead$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          return _context17.delegateYield((0, _sagas.apiSaga)(wkspConst.STATUS_CONNECTIONS_MARK_READ, _api.workspace.unreadAcceptedRead, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

var workspaceSagas = exports.workspaceSagas = [(0, _effects.takeLatest)(wkspConst.CONNECTIONS_FETCH, fetchConnections), (0, _effects.takeLatest)(wkspConst.CHANNELS_FETCH, fetchChannels), (0, _effects.takeLatest)(wkspConst.CHANGE_SELECTION, fetchChanges), (0, _effects.takeLatest)(wkspConst.CONVERSATIONS_FETCH, fetchConversations), (0, _effects.takeLatest)(wkspConst.CONNECTIONS_ARCHIVE, archiveConnection), (0, _effects.takeLatest)(wkspConst.CONNECTIONS_ARCHIVE + '_SUCCESS', fetchConnections), (0, _effects.takeLatest)(wkspConst.CHANNELS_ARCHIVE, archiveConversation), (0, _effects.takeLatest)(wkspConst.CHANNELS_ARCHIVE + '_SUCCESS', fetchChannels), (0, _effects.takeLatest)(wkspConst.CHANNELS_FETCH + '_SUCCESS', loadLastSelectedChannel), (0, _effects.takeLatest)('' + wkspConst.CONVERSATIONS_READ, markConversationRead), (0, _effects.takeLatest)(wkspConst.CONVERSATIONS_READ_WITH_PARAMS, markConversationRead), (0, _effects.takeLatest)(wkspConst.MESSAGE_CREATE, createMessage), (0, _effects.takeLatest)(wkspConst.MESSAGE_CREATE + '_SUCCESS', fetchConversations), // refresh the conversation list
(0, _effects.takeLatest)(wkspConst.STATUS_MESSAGES, refreshStatusMessages), (0, _effects.takeEvery)(wkspConst.CONNECTIONS_FETCH + '_ERROR', logError), (0, _effects.takeEvery)(wkspConst.CONVERSATIONS_FETCH + '_ERROR', logError), (0, _effects.takeLatest)('SUBMIT_CONTRACTING_COMMENT_SUCCESS', fetchContractConversations), (0, _effects.takeLatest)('LOADING_HISTORY_FEEDS_SUCCESS', contractConversationsRefresh), (0, _effects.takeEvery)(wkspConst.MESSAGE_DELETE, deleteMessage), (0, _effects.takeLatest)(wkspConst.MESSAGE_DELETE + '_SUCCESS', fetchConversations), (0, _effects.takeLatest)(inboxConst.TOGGLE_CONV_DONESS_SUCCESS, inboxCountLeft), (0, _effects.takeEvery)(wkspConst.MESSAGE_ADD_FILES_TO_CONTRACT, addFilesToContract), (0, _effects.takeEvery)(wkspConst.MESSAGE_ADD_FILES_TO_CONTRACT + '_SUCCESS', fetchConversations), (0, _effects.takeEvery)(wkspConst.STATUS_CONNECTIONS_MARK_READ, markAcceptedRead)];

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.massMessageSagas = undefined;

var _effects = __webpack_require__(36);

var _api = __webpack_require__(37);

var _sagas = __webpack_require__(43);

var _constants = __webpack_require__(654);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(createMessage),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getPartners),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(resendBulkMessage);

function createMessage(action) {
  return regeneratorRuntime.wrap(function createMessage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield((0, _sagas.apiSaga)(cnt.SENDMESSAGE, _api.massMessage.newMessage, [action.payload]), 't0', 1);

        case 1:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}
function getPartners() {
  return regeneratorRuntime.wrap(function getPartners$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.delegateYield((0, _sagas.apiSaga)(cnt.GETPARTNERS, _api.massMessage.getPartners, []), 't0', 1);

        case 1:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function resendBulkMessage(_ref) {
  var type = _ref.type,
      payload = _ref.payload;
  return regeneratorRuntime.wrap(function resendBulkMessage$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.delegateYield((0, _sagas.apiSaga)(type, _api.admin.resendBulkMessage, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

var massMessageSagas = exports.massMessageSagas = [(0, _effects.takeLatest)(cnt.SENDMESSAGE, createMessage), (0, _effects.takeLatest)(cnt.OPENMODAL, getPartners), (0, _effects.takeLatest)('ADMIN_RESEND_BULK_MESSAGE', resendBulkMessage)];

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
  Truncates a string to a number of characters, option to pass word consideration
  returns the truncate string + an ellipsis
*/
function truncate(n, useWordBoundary) {
  if (this.length <= n) {
    return this;
  }
  var subString = this.substr(0, n - 1);
  return (useWordBoundary && subString.indexOf(' ') > -1 ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '\u2026';
}

var truncateFn = function truncateFn(str, n, useWordBoundary) {
  if (str.length <= n) {
    return str;
  }
  var subString = str.substr(0, n - 1);
  return (useWordBoundary && subString.indexOf(' ') > -1 ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '\u2026';
};

var jsonParseFn = function jsonParseFn(str) {
  if ((typeof str === 'undefined' ? 'undefined' : _typeof(str)) === 'object') return str;
  var result = {};
  try {
    // if plain js
    result = JSON.parse(str);
  } catch (e) {
    // forget about it :)
  }
  return result;
};

module.exports = {
  truncate: truncate,
  truncateFn: truncateFn,
  jsonParseFn: jsonParseFn
};

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _reactRouterRedux = __webpack_require__(27);

var _api = __webpack_require__(37);

var _sagas = __webpack_require__(43);

var _constants = __webpack_require__(252);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(removeDraftOutOfQueue),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(addDraftToQueue),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(sendUpdatesFromQueue); /* global window */


function removeDraftOutOfQueue(_ref) {
  var type = _ref.type,
      payload = _ref.payload;
  return regeneratorRuntime.wrap(function removeDraftOutOfQueue$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.removeDraftOutOfQueue, [{
            templateId: payload.draftId,
            sourceId: payload.draftId,
            refreshSection: payload.refreshSection
          }]), 't0', 1);

        case 1:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function addDraftToQueue(_ref2) {
  var type = _ref2.type,
      payload = _ref2.payload;
  return regeneratorRuntime.wrap(function addDraftToQueue$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.addDraftToQueue, [{
            templateId: payload.draftId,
            sourceId: payload.draftId,
            source: 'draft',
            message: payload.message
          }]), 't0', 1);

        case 1:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function sendUpdatesFromQueue(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  return regeneratorRuntime.wrap(function sendUpdatesFromQueue$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.supplierSendUpdates, [{ templateIds: payload.templateIds, subject: payload.subject }]), 't0', 1);

        case 1:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = [(0, _effects.takeLatest)(cnt.REMOVE_DRAFT_FROM_QUEUE, removeDraftOutOfQueue), (0, _effects.takeLatest)(cnt.ADD_DRAFT_TO_QUEUE, addDraftToQueue), (0, _effects.takeLatest)(cnt.SEND_UPDATES_FROM_QUEUE, sendUpdatesFromQueue)];

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _effects = __webpack_require__(36);

var _constants = __webpack_require__(582);

var cnt = _interopRequireWildcard(_constants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(init),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchHelp),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(trackOpen),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(closeHelp);

var getPath = function getPath(state) {
  return (state.routing.locationBeforeTransitions || {}).pathname;
};
var getLoadingIndex = function getLoadingIndex(state) {
  return state.sidebarHelp.helpIndex;
};
var getCurrentHelp = function getCurrentHelp(state) {
  return state.sidebarHelp.helpArticle;
};
var getCompanyType = function getCompanyType(state) {
  return state.assetsLandingReducer ? state.assetsLandingReducer.viewAs : state.user.getIn(['user', 'type']);
};
var getSupplierType = function getSupplierType(state) {
  return state.assetsLandingReducer ? '' : state.user.getIn(['company', 'productType']);
};

function init() {
  return regeneratorRuntime.wrap(function init$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield((0, _sagas.apiSaga)(cnt.LOAD_HELPFILES, _api.contentful.sidebarHelp.getAllEntries, []), 't0', 1);

        case 1:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function fetchHelp() {
  var path, companyType, supplierType, fullIndex, helpIndex, helpArticle, currentHelp, entryId, _ref2, currentEntryId, title;

  return regeneratorRuntime.wrap(function fetchHelp$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(getPath);

        case 2:
          path = _context2.sent;
          _context2.next = 5;
          return (0, _effects.select)(getCompanyType);

        case 5:
          companyType = _context2.sent;

          if (!(companyType === 'Supplier')) {
            _context2.next = 12;
            break;
          }

          _context2.next = 9;
          return (0, _effects.select)(getSupplierType);

        case 9:
          _context2.t0 = _context2.sent;
          _context2.next = 13;
          break;

        case 12:
          _context2.t0 = '';

        case 13:
          supplierType = _context2.t0.replace(/-/gi, ' ');
          _context2.next = 16;
          return (0, _effects.select)(getLoadingIndex);

        case 16:
          fullIndex = _context2.sent;
          helpIndex = fullIndex.filter(function (_ref) {
            var matchingRole = _ref.matchingRole;
            return matchingRole.indexOf('Everyone') > -1 || companyType === 'Contractor' && matchingRole.indexOf(companyType) > -1 || companyType === 'Supplier' && matchingRole.indexOf(companyType) > -1 && matchingRole.indexOf(supplierType) > -1;
          });

          if (!(helpIndex.length > 0)) {
            _context2.next = 32;
            break;
          }

          helpArticle = function () {
            var indexFound = helpIndex.findIndex(function (article) {
              return article.expressions.some(function (expression) {
                return expression.test(path);
              });
            });
            if (indexFound > -1) return indexFound;
            return helpIndex.findIndex(function (article) {
              return article.expressions.some(function (expression) {
                return expression.test('404');
              });
            });
          }();

          _context2.next = 22;
          return (0, _effects.select)(getCurrentHelp);

        case 22:
          currentHelp = _context2.sent;

          if (!helpIndex[helpArticle]) {
            _context2.next = 32;
            break;
          }

          entryId = helpIndex[helpArticle].entryId;
          _ref2 = currentHelp || { entryId: null }, currentEntryId = _ref2.entryId, title = _ref2.title;

          if (!(currentEntryId !== entryId)) {
            _context2.next = 30;
            break;
          }

          return _context2.delegateYield((0, _sagas.apiSaga)(cnt.LOAD_HELP_ARTICLE, _api.contentful.sidebarHelp.getHelp, [entryId]), 't1', 28);

        case 28:
          _context2.next = 32;
          break;

        case 30:
          _context2.next = 32;
          return (0, _effects.put)({
            type: 'TRACK_EVENT',
            payload: {
              ga: {
                eventCategory: 'sidebarhelp',
                eventAction: 'open',
                eventLabel: title,
                eventValue: entryId
              }
            }
          });

        case 32:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function trackOpen(_ref3) {
  var _ref3$payload$items = _slicedToArray(_ref3.payload.items, 1),
      _ref3$payload$items$ = _ref3$payload$items[0],
      title = _ref3$payload$items$.fields.title,
      id = _ref3$payload$items$.sys.id;

  return regeneratorRuntime.wrap(function trackOpen$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)({
            type: 'TRACK_EVENT',
            payload: {
              ga: {
                eventCategory: 'sidebarhelp',
                eventValue: id,
                eventAction: 'open',
                eventLabel: title
              }
            }
          });

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function closeHelp() {
  return regeneratorRuntime.wrap(function closeHelp$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)({ type: 'HELPWIDGET_CLOSE' });

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

exports.default = [(0, _effects.takeLatest)(cnt.OPEN_WIDGET, fetchHelp), (0, _effects.takeLatest)(cnt.SIDEBARHELP_INIT, init), (0, _effects.takeLatest)('@@router/LOCATION_CHANGE', closeHelp), (0, _effects.takeEvery)(cnt.LOAD_HELP_ARTICLE + '_SUCCESS', trackOpen)];

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _constants = __webpack_require__(655);

var cnt = _interopRequireWildcard(_constants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _reduxSaga = __webpack_require__(92);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(consolidate),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getAssets),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(processHashtoken);

function consolidate() {
  var _ref, email, associateEmail, _ref2, companyId;

  return regeneratorRuntime.wrap(function consolidate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(function (state) {
            return state.assetsConsolidation;
          });

        case 2:
          _ref = _context.sent;
          email = _ref.email;
          associateEmail = _ref.associateEmail;
          _context.next = 7;
          return (0, _effects.select)(function (state) {
            return state.user.toJS().company;
          });

        case 7:
          _ref2 = _context.sent;
          companyId = _ref2.companyId;
          return _context.delegateYield((0, _sagas.apiSaga)(cnt.CONSOLIDATE_ASSETS, _api.admin.consolidateAccount, [email, companyId, associateEmail]), 't0', 10);

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getAssets() {
  return regeneratorRuntime.wrap(function getAssets$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.delegateYield((0, _sagas.apiSaga)(cnt.GET_ASSETS, _api.assetLanding.getAssets, []), 't0', 1);

        case 1:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function processHashtoken(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  var hashToken;
  return regeneratorRuntime.wrap(function processHashtoken$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          hashToken = payload.hashToken;
          return _context3.delegateYield((0, _sagas.apiSaga)(cnt.PROCESS_HASHTOKEN, _api.assetLanding.verifyToken, [hashToken]), 't0', 2);

        case 2:
          _context3.next = 4;
          return (0, _effects.call)(_reduxSaga.delay, 300);

        case 4:
          return _context3.delegateYield(getAssets(), 't1', 5);

        case 5:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = [(0, _effects.takeLatest)(cnt.PROCESS_HASHTOKEN, processHashtoken), (0, _effects.takeLatest)(cnt.GET_ASSETS + '_SUCCESS', consolidate)];

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _profileConstants = __webpack_require__(646);

var cnt = _interopRequireWildcard(_profileConstants);

var _locationConstants = __webpack_require__(629);

var locCnt = _interopRequireWildcard(_locationConstants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _reduxSaga = __webpack_require__(92);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(doUpdateGroup),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(refreshProfile),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(doDeleteGroup),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(reorderLocations),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(reorderProducts),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(doGetVerified),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(doNotifyUpgrade);

function doUpdateGroup(_ref) {
  var type = _ref.type,
      payload = _ref.payload;
  return regeneratorRuntime.wrap(function doUpdateGroup$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield((0, _sagas.apiSaga)(type, _api.profile.updateGroup, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function refreshProfile() {
  var pathname, locationId;
  return regeneratorRuntime.wrap(function refreshProfile$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          pathname = window.location.pathname;

          if (!(pathname === '/profile')) {
            _context2.next = 5;
            break;
          }

          return _context2.delegateYield((0, _sagas.apiSaga)(cnt.GET_PROFILE, _api.profile.getCompanyProfile, []), 't0', 3);

        case 3:
          _context2.next = 8;
          break;

        case 5:
          if (!(pathname.indexOf('/profile/locations') > -1)) {
            _context2.next = 8;
            break;
          }

          locationId = _ramda2.default.last(_ramda2.default.split('/', pathname));
          return _context2.delegateYield((0, _sagas.apiSaga)('GET_USER_LOCATION_PROFILE', _api.profile.getUserLocationProfile, [{ locationId: locationId }]), 't1', 8);

        case 8:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doDeleteGroup(_ref2) {
  var type = _ref2.type,
      payload = _ref2.payload;
  var confirmed;
  return regeneratorRuntime.wrap(function doDeleteGroup$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          confirmed = window.confirm('Are you sure you want to delete this group? Note: items won\'t be deleted.');

          if (!confirmed) {
            _context3.next = 3;
            break;
          }

          return _context3.delegateYield((0, _sagas.apiSaga)(type, _api.profile.deleteGroup, [payload]), 't0', 3);

        case 3:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function reorderLocations(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  return regeneratorRuntime.wrap(function reorderLocations$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.delegateYield((0, _sagas.apiSaga)(type, _api.profile.reorderLocations, [payload.locationIds]), 't0', 1);

        case 1:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function reorderProducts(_ref4) {
  var type = _ref4.type,
      payload = _ref4.payload;
  return regeneratorRuntime.wrap(function reorderProducts$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.delegateYield((0, _sagas.apiSaga)(type, _api.profile.reorderProducts, [payload.productIds]), 't0', 1);

        case 1:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function doGetVerified(_ref5) {
  var type = _ref5.type;
  return regeneratorRuntime.wrap(function doGetVerified$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          window.open('https://www.tourconnect.com/tc-verified/');
          return _context6.delegateYield((0, _sagas.apiSaga)(type, _api.account.sendNotification, [{ action: 'getVerified' }]), 't0', 2);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function doNotifyUpgrade(_ref6) {
  var type = _ref6.type,
      payload = _ref6.payload;
  var name;
  return regeneratorRuntime.wrap(function doNotifyUpgrade$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          name = (0, _ramda.pathOr)('', ['name'], payload);

          if (!/(.+)Upgrade Click$/.test(name)) {
            _context7.next = 3;
            break;
          }

          return _context7.delegateYield((0, _sagas.apiSaga)(type, _api.account.sendNotification, [{ action: 'clickedUpgrade' }]), 't0', 3);

        case 3:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

exports.default = [(0, _effects.takeLatest)(cnt.UPDATE_GROUP, doUpdateGroup), (0, _effects.takeLatest)(cnt.UPDATE_GROUP + '_SUCCESS', refreshProfile), (0, _effects.takeLatest)(cnt.DELETE_GROUP, doDeleteGroup), (0, _effects.takeLatest)(cnt.DELETE_GROUP + '_SUCCESS', refreshProfile), (0, _effects.takeLatest)(cnt.REORDER_LOCATIONS, reorderLocations), (0, _effects.takeLatest)(cnt.REORDER_LOCATIONS + '_SUCCESS', refreshProfile), (0, _effects.takeLatest)(cnt.REORDER_PRODUCTS, reorderProducts), (0, _effects.takeLatest)(cnt.REORDER_PRODUCTS + '_SUCCESS', refreshProfile), (0, _effects.takeLatest)(cnt.IMPORTED_LOC, refreshProfile), (0, _effects.takeLatest)(locCnt.FINISHED_IMPORTING_PROD, refreshProfile), (0, _effects.takeLatest)('{profile} getVerified', doGetVerified), (0, _effects.takeLatest)('TRACK_EVENT', doNotifyUpgrade)];

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _effects = __webpack_require__(36);

var _constants = __webpack_require__(652);

var cnt = _interopRequireWildcard(_constants);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _reduxSaga = __webpack_require__(92);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _docCookie = __webpack_require__(142);

var _docCookie2 = _interopRequireDefault(_docCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(loadWidgetData),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(loadDashboard),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(handleYearChange),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(handleInit),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(loadFolders),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(handleWidgetFilterUpdate);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function loadWidgetData(widgetState) {
  var globalFiltersState, currentYear, startInCookie, endInCookie, globalFilters, id, url, filters, filterObj, query;
  return regeneratorRuntime.wrap(function loadWidgetData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contractingDashboard.globalFilters;
          });

        case 2:
          globalFiltersState = _context.sent;
          _context.next = 5;
          return (0, _effects.select)(function (state) {
            return state.contracting.currentYear;
          });

        case 5:
          currentYear = _context.sent;
          startInCookie = _docCookie2.default.getItem('contractYearStartDate');
          endInCookie = _docCookie2.default.getItem('contractYearEndDate');
          globalFilters = Object.entries(globalFiltersState).map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            if (value.key === 'locations') {
              return { locations: value.list.filter(function (obj) {
                  return obj.checked;
                }).map(_ramda2.default.prop('locId')) };
            }
            if (value.key === 'folder') {
              return { folder: value.list.filter(function (obj) {
                  return obj.checked;
                }).map(_ramda2.default.prop('value')) };
            }
            return _defineProperty({}, key, value.selectedValue);
          }).reduce(function (obj, item) {
            return _extends({
              contractingPeriod: (currentYear.startDate || startInCookie) + '|' + (currentYear.endDate || endInCookie)
            }, _extends({}, item), obj);
          });
          id = widgetState.id, url = widgetState.url, filters = widgetState.filters;
          filterObj = {};

          Object.values(filters || {}).forEach(function (_ref4) {
            var filterValue = _ref4.filterValue,
                filterBy = _ref4.filterBy;

            if (filterValue) {
              filterObj[filterBy] = filterValue;
            }
          });
          query = _queryString2.default.stringify(_extends({}, globalFilters, filterObj));
          return _context.delegateYield((0, _sagas.apiSaga)(cnt.UPDATE_WIDGET_DATA, function () {
            return (0, _api.callApi)('/proxy' + url + '?' + query);
          }, [{ widgetId: id }]), 't0', 14);

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function loadDashboard() {
  var items;
  return regeneratorRuntime.wrap(function loadDashboard$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contractingDashboard.items;
          });

        case 2:
          items = _context2.sent;
          _context2.next = 5;
          return (0, _effects.all)(items.map(loadWidgetData));

        case 5:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function handleYearChange() {
  return regeneratorRuntime.wrap(function handleYearChange$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!(window.location.pathname.indexOf('dashboard') > -1)) {
            _context3.next = 2;
            break;
          }

          return _context3.delegateYield(loadDashboard(), 't0', 2);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function handleInit() {
  var currentYear, startInCookie;
  return regeneratorRuntime.wrap(function handleInit$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contracting.currentYear;
          });

        case 2:
          currentYear = _context4.sent;
          startInCookie = _docCookie2.default.getItem('contractYearStartDate');

          if (!(currentYear.startDate || startInCookie)) {
            _context4.next = 6;
            break;
          }

          return _context4.delegateYield(loadDashboard(), 't0', 6);

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function loadFolders(_ref5) {
  var type = _ref5.type;
  return regeneratorRuntime.wrap(function loadFolders$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.getFolders, []), 't0', 1);

        case 1:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function handleWidgetFilterUpdate(_ref6) {
  var payload = _ref6.payload;
  var widgetState;
  return regeneratorRuntime.wrap(function handleWidgetFilterUpdate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.select)(function (state) {
            return state.contractingDashboard.items.find(function (item) {
              return item.id === payload.id;
            });
          });

        case 2:
          widgetState = _context6.sent;
          return _context6.delegateYield(loadWidgetData(widgetState), 't0', 4);

        case 4:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

exports.default = [(0, _effects.takeLatest)('[contracting]SELECTED_YEAR_FOR_CONTRACTING', handleYearChange), (0, _effects.takeLatest)(cnt.INIT_DASHBOARD, handleInit), (0, _effects.takeLatest)(cnt.LOAD_DASHBOARD, loadDashboard), (0, _effects.takeLatest)(cnt.RESET_GLOBAL_DASHBOARD_FILTER, loadDashboard), (0, _effects.takeLatest)(cnt.LOAD_FOLDERS, loadFolders), (0, _effects.takeLatest)(cnt.UPDATE_WIDGET_FILTER, handleWidgetFilterUpdate)];

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _sagas = __webpack_require__(43);

var _reduxSaga = __webpack_require__(92);

var _updateCommissionRates = __webpack_require__(966);

var _updateNettRates = __webpack_require__(967);

var _updateDiscountRates = __webpack_require__(968);

var _updateDiscountRates2 = _interopRequireDefault(_updateDiscountRates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(updateRates);

function updateRates() {
  var state, updateType, rateType, retailNettMeasure, notApplyToExtraChild, roundingSetting, settings, newState;
  return regeneratorRuntime.wrap(function updateRates$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(function (mainState) {
            return mainState.contracting.massRateChange;
          });

        case 2:
          state = _context.sent;
          updateType = state.get('updateType');
          rateType = state.get('rateType');
          retailNettMeasure = state.getIn([updateType, rateType + 'Measure']);
          notApplyToExtraChild = state.getIn([updateType, 'notApplyToExtraChildFor' + rateType]);
          roundingSetting = state.getIn([updateType, 'roundingSetting']) ? state.getIn([updateType, 'roundingSetting']).toJS() : { roundType: 'normal', cents: 1 };
          settings = {
            updateType: updateType,
            retailNettMeasure: retailNettMeasure,
            notApplyToExtraChild: notApplyToExtraChild,
            roundingSetting: roundingSetting
          };
          newState = state.updateIn([updateType, 'products'], function (products) {
            return products.map(function (product) {
              if (rateType === 'discount') {
                return (0, _updateDiscountRates2.default)(settings, product);
              }
              var newNums = {
                updatedCommission: product.get('commission'),
                retailDiff: product.get('retailDiff'),
                nettDiff: product.get('nettDiff')
              };
              var updateRateSetsOrExtrasOrOffers = function () {
                if (rateType === 'commission') return _updateCommissionRates.updateRateSetsOrExtrasOrOffers;
                if (rateType === 'nett') return _updateNettRates.updateRateSetsOrExtrasOrOffers;
              }();
              if (updateType === 'seasonRates') {
                return product.update('seasonRates', function (seasonRates) {
                  if (!seasonRates) return seasonRates;
                  return seasonRates.map(function (seasonRate) {
                    return seasonRate.updateIn(['rateSets', rateType], function (rateSets) {
                      return updateRateSetsOrExtrasOrOffers(newNums, settings, rateSets);
                    });
                  });
                });
              }
              return product.updateIn([updateType, rateType], function (extrasOrOffers) {
                return updateRateSetsOrExtrasOrOffers(newNums, settings, extrasOrOffers);
              });
            });
          });
          _context.next = 12;
          return (0, _effects.put)({
            type: 'UPDATE_MASS_RATE_CHANGE_CALCULATION',
            payload: newState
          });

        case 12:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

exports.default = [(0, _effects.takeLatest)('CHANGE_WIDGET_VALUE_FOR_APPLY_ALL', updateRates), (0, _effects.takeLatest)('CHANGE_WIDGET_VALUE_FOR_PRODUCT', updateRates), (0, _effects.takeLatest)('CHANGE_MASS_RATE_CHANGE_MEASURE', updateRates), (0, _effects.takeLatest)('CHANGE_ROUNDING_SETTINGS_IN_MASS_RATE_CHANGE', updateRates), (0, _effects.takeLatest)('ON_CHANGE_NOT_APPLY_MASS_RATE_CHANGE_TO_EXTRA_CHILD', updateRates)];

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRateSetsOrExtrasOrOffers = undefined;

var _ramda = __webpack_require__(2);

var _immutable = __webpack_require__(26);

var _roundTo = __webpack_require__(610);

var _roundTo2 = _interopRequireDefault(_roundTo);

var _roundingHelpers = __webpack_require__(491);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var roundNumber = function roundNumber(_ref, num) {
  var roundType = _ref.roundType,
      cents = _ref.cents;

  var newNum = Number(num);
  if (roundType === 'alwaysUp') return (0, _roundingHelpers.roundUpToNearest)(newNum, cents);
  if (roundType === 'alwaysDown') return (0, _roundingHelpers.roundDownToNearest)(newNum, cents);
  return (0, _roundingHelpers.roundToNearest)(newNum, cents);
};
var calRatesWithNewCommission = function calRatesWithNewCommission(commission, _ref2, rates) {
  var notApplyToExtraChild = _ref2.notApplyToExtraChild,
      roundingSetting = _ref2.roundingSetting;

  if (!rates) return rates;
  return rates.map(function (rate) {
    if (rate.get('notApplicable')) return rate;
    var initialNettRate = (0, _ramda.isNil)(rate.get('initialNettRate')) ? // Check isNil because rate may be 0
    (0, _ramda.isNil)(rate.get('nettRate')) ? 0 : rate.get('nettRate') : // if no nettRate then 0 else nettRate
    rate.get('initialNettRate');
    var nettRate = (0, _ramda.multiply)(rate.get('retailRate'))(100 - commission) / 100;
    // console.log('calRatesWithNewCommission', { nettRate, commission });
    if (notApplyToExtraChild && (rate.get('description') === 'Extra Child' || rate.get('description') === 'Extra Adult')) return rate.set('nettRate', initialNettRate);
    return rate.merge((0, _immutable.fromJS)({
      initialNettRate: initialNettRate,
      nettRate: roundNumber(roundingSetting, nettRate).toFixed(2)
    }));
  });
};

var calRatesWithNewRetailDiff = function calRatesWithNewRetailDiff(retailDiff, commissionPercentage, _ref3, rates) {
  var retailNettMeasure = _ref3.retailNettMeasure,
      notApplyToExtraChild = _ref3.notApplyToExtraChild,
      roundingSetting = _ref3.roundingSetting;

  if (!rates) return rates;
  return rates.map(function (rate) {
    if (rate.get('notApplicable')) return rate;
    var initialRetailRate = (0, _ramda.isNil)(rate.get('initialRetailRate')) ? // Check isNil because rate may be 0
    (0, _ramda.isNil)(rate.get('retailRate')) ? 0 : rate.get('retailRate') : // if no retailRate then 0 else retailRate
    rate.get('initialRetailRate');
    var initialNettRate = (0, _ramda.isNil)(rate.get('initialNettRate')) ? // Check isNil because rate may be 0
    (0, _ramda.isNil)(rate.get('nettRate')) ? 0 : rate.get('nettRate') : // if no nettRate then 0 else nettRate
    rate.get('initialNettRate');
    var numberedRetailChange = Number(retailDiff);
    var retailDiffAmount = retailNettMeasure === 'percentage' ? (0, _ramda.multiply)(initialRetailRate, (0, _ramda.divide)(numberedRetailChange, 100)) : numberedRetailChange;
    var retailRate = (0, _ramda.add)(initialRetailRate, retailDiffAmount);
    var nettRate = (0, _ramda.multiply)(retailRate, (0, _ramda.subtract)(100, commissionPercentage)) / 100;
    // console.log('calRatesWithNewRetailDiff', { retailDiffAmount, retailNettMeasure });
    if (notApplyToExtraChild && (rate.get('description') === 'Extra Child' || rate.get('description') === 'Extra Adult')) return rate.merge((0, _immutable.fromJS)({ nettRate: initialNettRate, retailRate: initialRetailRate }));
    return rate.merge((0, _immutable.fromJS)({
      initialRetailRate: initialRetailRate,
      initialNettRate: initialNettRate,
      retailRate: roundNumber(roundingSetting, retailRate).toFixed(2),
      nettRate: roundNumber(roundingSetting, nettRate).toFixed(2)
    }));
  });
};

var updateRateSetsOrExtrasOrOffers = exports.updateRateSetsOrExtrasOrOffers = function updateRateSetsOrExtrasOrOffers(_ref4, settings, rateSetsOrExtrasOrOffers) {
  var updatedCommission = _ref4.updatedCommission,
      retailDiff = _ref4.retailDiff;

  if (!rateSetsOrExtrasOrOffers) return rateSetsOrExtrasOrOffers;
  return rateSetsOrExtrasOrOffers.map(function (rateSet) {
    var initialCommissionPercentage = Number(rateSet.get('initialCommissionPercentage') ? rateSet.get('initialCommissionPercentage') : rateSet.get('commissionPercentage'));
    var commissionPercentage = !updatedCommission ? initialCommissionPercentage : Number(updatedCommission);
    // console.log({ updatedCommission, retailDiff });
    // if nothing changed, use initial rate
    if (!updatedCommission && !retailDiff) {
      return rateSet.set('commissionPercentage', commissionPercentage).set('retailDiff', retailDiff).update('rates', function (rates) {
        return rates.map(function (rate) {
          if (rate.get('notApplicable')) return rate;
          return rate.merge((0, _immutable.fromJS)({
            // when user toggling settings without any number updated, intial values weren't there yet
            retailRate: rate.get('initialRetailRate') || rate.get('retailRate'),
            nettRate: rate.get('initialNettRate') || rate.get('nettRate')
          }));
        });
      });
    }
    var ratesAfterCommission = commissionPercentage && !isNaN(commissionPercentage) ? calRatesWithNewCommission(Number(commissionPercentage), settings, rateSet.get('rates')) : rateSet.get('rates');
    var ratesAfterRetailDiff = !(0, _ramda.isNil)(retailDiff) && !isNaN(retailDiff) ? calRatesWithNewRetailDiff(retailDiff, commissionPercentage, settings, ratesAfterCommission) : ratesAfterCommission;
    var updateObject = {
      initialCommissionPercentage: initialCommissionPercentage,
      rates: ratesAfterRetailDiff,
      commissionPercentage: commissionPercentage
    };
    return rateSet.merge((0, _immutable.fromJS)(updateObject));
  });
};

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateRateSetsOrExtrasOrOffers = undefined;

var _ramda = __webpack_require__(2);

var _immutable = __webpack_require__(26);

var _roundingHelpers = __webpack_require__(491);

var roundNumber = function roundNumber(_ref, num) {
  var roundType = _ref.roundType,
      cents = _ref.cents;

  var newNum = Number(num);
  if (roundType === 'alwaysUp') return (0, _roundingHelpers.roundUpToNearest)(newNum, cents);
  if (roundType === 'alwaysDown') return (0, _roundingHelpers.roundDownToNearest)(newNum, cents);
  return (0, _roundingHelpers.roundToNearest)(newNum, cents);
};

var calNettByDiff = (0, _ramda.curry)(function (nettDiff, _ref2, rates) {
  var retailNettMeasure = _ref2.retailNettMeasure,
      notApplyToExtraChild = _ref2.notApplyToExtraChild,
      roundingSetting = _ref2.roundingSetting;
  return rates.map(function (rate) {
    var initialNettRate = (0, _ramda.isNil)(rate.get('initialNettRate')) ? // Check isNil because rate may be 0
    (0, _ramda.isNil)(rate.get('nettRate')) ? 0 : rate.get('nettRate') : // if no nettRate then 0 else nettRate
    rate.get('initialNettRate');
    var nettRate = retailNettMeasure === 'percentage' ? (0, _ramda.multiply)(initialNettRate, (0, _ramda.divide)((0, _ramda.add)(Number(nettDiff), 100), 100)) : (0, _ramda.add)(initialNettRate, Number(nettDiff));
    if (notApplyToExtraChild && (rate.get('description') === 'Extra Child' || rate.get('description') === 'Extra Adult')) return rate.set('nettRate', initialNettRate);
    return rate.get('notApplicable') ? rate : rate.merge((0, _immutable.fromJS)({
      initialNettRate: initialNettRate,
      nettRate: nettDiff ? roundNumber(roundingSetting, nettRate).toFixed(2) : initialNettRate
    }));
  });
});

var updateRateSetsOrExtrasOrOffers = exports.updateRateSetsOrExtrasOrOffers = (0, _ramda.curry)(function (_ref3, settings, rateSetsOrExtrasOrOffers) {
  var nettDiff = _ref3.nettDiff;

  if (!rateSetsOrExtrasOrOffers) return rateSetsOrExtrasOrOffers;
  return rateSetsOrExtrasOrOffers.map(function (rateSet) {
    if (!rateSet) return rateSet;
    return rateSet.update('rates', calNettByDiff(nettDiff, settings));
  });
});

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(26);

var _ramda = __webpack_require__(2);

var _roundingHelpers = __webpack_require__(491);

var roundNumber = function roundNumber(_ref, num) {
  var roundType = _ref.roundType,
      cents = _ref.cents;

  var newNum = Number(num);
  if (roundType === 'alwaysUp') return (0, _roundingHelpers.roundUpToNearest)(newNum, cents);
  if (roundType === 'alwaysDown') return (0, _roundingHelpers.roundDownToNearest)(newNum, cents);
  return (0, _roundingHelpers.roundToNearest)(newNum, cents);
};

var updateDiscountRates = function updateDiscountRates(_ref2, product) {
  var measure = _ref2.retailNettMeasure,
      roundingSetting = _ref2.roundingSetting;

  var discountDiff = product.get('discountDiff');
  return product.updateIn(['offers', 'discount'], function (discountOffers) {
    return !discountOffers ? discountOffers : discountOffers.map(function (offer) {
      var initialAmount = (0, _ramda.isNil)(offer.get('initialAmount')) ? // Check isNil because offer may be 0
      (0, _ramda.isNil)(offer.get('amount')) ? 0 : offer.get('amount') : // if no amount then 0 else amount
      offer.get('initialAmount');
      var amount = measure === 'percentage' ? (0, _ramda.multiply)(initialAmount, (0, _ramda.divide)((0, _ramda.add)(Number(discountDiff), 100), 100)) : (0, _ramda.add)(Number(initialAmount), Number(discountDiff));
      return offer.get('notApplicable') ? offer : offer.merge((0, _immutable.fromJS)({
        initialAmount: initialAmount,
        amount: discountDiff ? roundNumber(roundingSetting, amount) : initialAmount
      }));
    });
  });
};

exports.default = updateDiscountRates;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = __webpack_require__(36);

var _reactRouterRedux = __webpack_require__(27);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _constants = __webpack_require__(656);

var cnt = _interopRequireWildcard(_constants);

var _constants2 = __webpack_require__(233);

var wkspConst = _interopRequireWildcard(_constants2);

var _constants3 = __webpack_require__(648);

var _smallTemplateListConstants = __webpack_require__(649);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(resetSelectedTemplate),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(resetSelectedLocation),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(resetRateSelections),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(resetContractRequest),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(sendRates),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(sendRateRequest),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(sendMessage),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(getPartnerDetails),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(refreshActivities),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(_getActivities),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(_getFiles),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(refreshFiles),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(contractFromHistoryFeed),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(contractFromHistoryFeedSuccess),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(markAsRead);

var getRoute = function getRoute(state) {
  return state.routing.locationBeforeTransitions.pathname;
};
var getTaxId = function getTaxId(state) {
  return state.profile.get('corporateIdentifier');
};

// de-select the selected template
function resetSelectedTemplate() {
  return regeneratorRuntime.wrap(function resetSelectedTemplate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)({
            type: _constants3.UPDATE_PROPS,
            payload: {
              templateSelected: {}
            }
          });

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

// de-select the selected location
function resetSelectedLocation() {
  return regeneratorRuntime.wrap(function resetSelectedLocation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)({
            type: _constants3.RESET_LOCATION_SELECTION,
            payload: {
              locationId: ''
            }
          });

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function resetRateSelections() {
  return regeneratorRuntime.wrap(function resetRateSelections$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)({
            type: _constants3.RESET_TEMPLATE_SELECTION
          });

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function resetContractRequest() {
  var taxId;
  return regeneratorRuntime.wrap(function resetContractRequest$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(getTaxId);

        case 2:
          taxId = _context4.sent;
          _context4.next = 5;
          return (0, _effects.put)({ type: 'CLEAR_CONTRACTOR_CONTRACTING_WIZARD', payload: { taxId: taxId } });

        case 5:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function sendRates(payload) {
  return regeneratorRuntime.wrap(function sendRates$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.delegateYield((0, _sagas.apiSaga)(cnt.SEND_RATES, _api.contracting.sendContract, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function sendRateRequest(payload) {
  return regeneratorRuntime.wrap(function sendRateRequest$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.delegateYield((0, _sagas.apiSaga)(cnt.SEND_RATE_REQUESTS, _api.contracting.sendContractRequest, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function sendMessage(_ref) {
  var _ref$payload = _ref.payload,
      partnerId = _ref$payload.partnerId,
      channel = _ref$payload.channel,
      message = _ref$payload.message;
  return regeneratorRuntime.wrap(function sendMessage$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.delegateYield((0, _sagas.apiSaga)(cnt.SEND_MESSAGE, _api.workspace.newMessage, [_extends({
            type: channel === 'notes' ? 'note' : 'message'
          }, message, {
            partnerIds: [partnerId]
          })]), 't0', 1);

        case 1:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function getPartnerDetails(_ref2) {
  var pathname = _ref2.payload.pathname;
  var partnerId;
  return regeneratorRuntime.wrap(function getPartnerDetails$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          if (!(pathname.split('/')[1] === 'partnerDetails')) {
            _context8.next = 6;
            break;
          }

          partnerId = pathname.split('/')[2];
          _context8.next = 4;
          return (0, _effects.put)({ type: cnt.CLEAR_STORE });

        case 4:
          _context8.next = 6;
          return (0, _effects.all)([(0, _sagas.apiSaga)(cnt.GET_PARTNER_INFO, _api.partner.getCompanyInfo, [{ partnerId: partnerId }]), _getFiles(partnerId), _getActivities(partnerId)]);

        case 6:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function refreshActivities() {
  var pathname, companyId;
  return regeneratorRuntime.wrap(function refreshActivities$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(getRoute);

        case 2:
          pathname = _context9.sent;

          if (!(pathname.split('/')[1] === 'partnerDetails')) {
            _context9.next = 6;
            break;
          }

          companyId = pathname.split('/')[2];
          return _context9.delegateYield((0, _sagas.apiSaga)(cnt.GET_ACTIVITY, _api.partner.getActivities, [{ assetId: companyId }]), 't0', 6);

        case 6:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function _getActivities(partnerId) {
  return regeneratorRuntime.wrap(function _getActivities$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.delegateYield((0, _sagas.apiSaga)(cnt.GET_ACTIVITY, _api.partner.getActivities, [{ assetId: partnerId }]), 't0', 1);

        case 1:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function _getFiles(partnerId) {
  return regeneratorRuntime.wrap(function _getFiles$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.delegateYield((0, _sagas.apiSaga)(cnt.GET_FILES, _api.contracting.getContracts, [{
            query: { partnerIds: partnerId },
            includeTemplateNames: true
          }]), 't0', 1);

        case 1:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function refreshFiles() {
  var pathname, partnerId;
  return regeneratorRuntime.wrap(function refreshFiles$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.select)(getRoute);

        case 2:
          pathname = _context12.sent;

          if (!(pathname.split('/')[1] === 'partnerDetails')) {
            _context12.next = 7;
            break;
          }

          partnerId = pathname.split('/')[2];
          _context12.next = 7;
          return (0, _effects.all)([_getFiles(partnerId), _getActivities(partnerId)]);

        case 7:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function contractFromHistoryFeed(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  return regeneratorRuntime.wrap(function contractFromHistoryFeed$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.contractFromHF, [payload]);

        case 2:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function contractFromHistoryFeedSuccess(_ref4) {
  var payload = _ref4.payload;
  return regeneratorRuntime.wrap(function contractFromHistoryFeedSuccess$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.put)((0, _reactRouterRedux.push)(payload.path.replace('#contractId#', payload.contractId)));

        case 2:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function markAsRead() {
  var pathname, partnerId;
  return regeneratorRuntime.wrap(function markAsRead$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.select)(getRoute);

        case 2:
          pathname = _context15.sent;

          if (!(pathname.split('/')[1] === 'partnerDetails')) {
            _context15.next = 7;
            break;
          }

          partnerId = pathname.split('/')[2];
          _context15.next = 7;
          return (0, _sagas.apiSaga)(wkspConst.CONVERSATIONS_READ, _api.workspace.conversationsRead, [{ assetId: partnerId, assetType: 'partner' }]);

        case 7:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

exports.default = [(0, _effects.takeLatest)('@@router/LOCATION_CHANGE', getPartnerDetails), (0, _effects.takeLatest)(cnt.RESET_SELECTED_ALL, resetRateSelections), (0, _effects.takeLatest)(cnt.RESET_SELECTED_LOCATION, resetSelectedLocation), (0, _effects.takeLatest)(cnt.RESET_SELECTED_RATE, resetSelectedTemplate), (0, _effects.takeLatest)(cnt.RESET_CONTRACTING_REQUEST, resetContractRequest), (0, _effects.takeLatest)(cnt.SEND_MESSAGE, sendMessage), (0, _effects.takeLatest)(cnt.SEND_RATES, sendRates), (0, _effects.takeLatest)(cnt.SEND_RATE_REQUESTS, sendRateRequest), (0, _effects.takeLatest)(_smallTemplateListConstants.POPULATE_REDUCER, resetSelectedTemplate), (0, _effects.takeLatest)(cnt.SEND_MESSAGE + '_SUCCESS', refreshActivities), (0, _effects.takeLatest)(cnt.SEND_RATES + '_SUCCESS', refreshFiles), (0, _effects.takeLatest)(cnt.SEND_RATES + '_SUCCESS', refreshActivities), (0, _effects.takeLatest)(cnt.SEND_RATE_REQUESTS + '_SUCCESS', refreshFiles), (0, _effects.takeLatest)(cnt.SEND_RATE_REQUESTS + '_SUCCESS', refreshActivities), (0, _effects.takeLatest)('CONTRACT_FROM_HF', contractFromHistoryFeed), (0, _effects.takeLatest)('CONTRACT_FROM_HF_SUCCESS', contractFromHistoryFeedSuccess), (0, _effects.takeLatest)(cnt.GET_ACTIVITY + '_SUCCESS', markAsRead)];

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = __webpack_require__(36);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _partnerFinderConstants = __webpack_require__(653);

var constPF = _interopRequireWildcard(_partnerFinderConstants);

var _connectionsConstants = __webpack_require__(867);

var constCO = _interopRequireWildcard(_connectionsConstants);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(tagAsAdmin),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(rollbarConfigure),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(trackEvent),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(pageView),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(sendUserDataToTag),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(gaEvent),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(intercomEvent),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(gaChangeStatus),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(invitationsEvent),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(intercomLocationFieldUpdate),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(intercomMMUpdate),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(upgradeEvent),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(signUpEvent);

/*
	Middleware to use for 3rd Party Tracking Scripts
*/

var getUserId = function getUserId(state) {
  return state.user.get('id');
};
var getUserEmail = function getUserEmail(state) {
  return state.user.get('user').get('email');
};
var getisAdmin = function getisAdmin(state) {
  return state.user.get('isAnAdmin');
};
var getInvitationsSent = function getInvitationsSent(state) {
  return state.tempConnections.get('emailStatuses').sent;
};
var getSignUp = function getSignUp(state) {
  return state.signup.toJS();
};
var getAssetsLandingReducer = function getAssetsLandingReducer(state) {
  return state.assetsLandingReducer;
};

var sendIntercom = function sendIntercom() {
  if (window.Intercom) {
    var _window;

    (_window = window).Intercom.apply(_window, arguments); // eslint-disable-line new-cap
  }
};

/*
	Loop through all Google Analytics trackers and send event
*/
var gaSendEvent = function gaSendEvent(_ref) {
  var eventCategory = _ref.eventCategory,
      eventValue = _ref.eventValue,
      eventAction = _ref.eventAction,
      eventLabel = _ref.eventLabel;

  window.dataLayer.push({
    event: 'TRACK_EVENT',
    ev: {
      category: eventCategory,
      action: eventAction,
      label: eventLabel,
      value: eventValue
    }
  });
};

window.dataLayer = window.dataLayer || [];

function tagAsAdmin() {
  return regeneratorRuntime.wrap(function tagAsAdmin$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(getisAdmin);

        case 2:
          if (!_context.sent) {
            _context.next = 4;
            break;
          }

          window.dataLayer.push({ isTCAdminSession: true });

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function rollbarConfigure() {
  return regeneratorRuntime.wrap(function rollbarConfigure$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!window.Rollbar) {
            _context2.next = 12;
            break;
          }

          _context2.t0 = window.Rollbar;
          _context2.next = 4;
          return (0, _effects.select)(getUserId);

        case 4:
          _context2.t1 = _context2.sent;
          _context2.next = 7;
          return (0, _effects.select)(getUserEmail);

        case 7:
          _context2.t2 = _context2.sent;
          _context2.t3 = {
            id: _context2.t1,
            email: _context2.t2
          };
          _context2.t4 = {
            person: _context2.t3
          };
          _context2.t5 = {
            payload: _context2.t4
          };

          _context2.t0.configure.call(_context2.t0, _context2.t5);

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function trackEvent(_ref2) {
  var payload = _ref2.payload;
  return regeneratorRuntime.wrap(function trackEvent$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (payload.name) {
            sendIntercom('trackEvent', payload.name, _extends({}, payload.values));
          }
          if (payload.ga) {
            gaSendEvent(payload.ga);
          }

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function pageView(_ref3) {
  var payload = _ref3.payload;
  return regeneratorRuntime.wrap(function pageView$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          window.dataLayer.push({
            event: 'PAGE_VIEW',
            document: {
              pagePath: payload.path,
              pageTitle: payload.title
            }
          });

        case 1:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function sendUserDataToTag(_ref4) {
  var user = _ref4.user;

  var userId, _user$user, name, email, createdAt, intercomApp, intercomUserHash, isMarketingReady, _user$company, companyId, companyName, companyType, plan, productType, websiteUrl, phone, acctCreationReason, companyCreatedAt, bookingSystem, emailClient, affiliateURL, payload;

  return regeneratorRuntime.wrap(function sendUserDataToTag$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          userId = user.id, _user$user = user.user, name = _user$user.name, email = _user$user.email, createdAt = _user$user.createdAt, intercomApp = _user$user.intercomApp, intercomUserHash = _user$user.intercomUserHash, isMarketingReady = user.isMarketingReady, _user$company = user.company, companyId = _user$company.companyId, companyName = _user$company.companyName, companyType = _user$company.companyType, plan = _user$company.plan, productType = _user$company.productType, websiteUrl = _user$company.websiteUrl, phone = _user$company.phone, acctCreationReason = _user$company.acctCreationReason, companyCreatedAt = _user$company.createdAt, bookingSystem = user.bookingSystem, emailClient = user.emailClient, affiliateURL = user.affiliateURL;
          payload = {
            event: 'GET_USER',
            user: {
              id: userId,
              name: name || '',
              email: email,
              createdAt: new Date(createdAt).getTime() / 1000,
              app_id: intercomApp,
              user_hash: intercomUserHash
            },
            company: {
              id: companyId,
              createdAt: new Date(companyCreatedAt).getTime() / 1000,
              accountAge: (0, _moment2.default)().diff(companyCreatedAt, 'days'),
              creationReason: acctCreationReason,
              type: companyType,
              plan: plan,
              name: companyName,
              website: websiteUrl,
              phone: phone,
              isMarketingReady: isMarketingReady,
              productType: productType,
              bookingSystem: bookingSystem,
              emailClient: emailClient,
              affiliateURL: affiliateURL
            }
          };

          window.dataLayer.push(payload);

        case 3:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function sendUserDataToIntercom(_ref5) {
  var user = _ref5.user;
  var _user$user2 = user.user,
      name = _user$user2.name,
      email = _user$user2.email,
      intercomApp = _user$user2.intercomApp,
      intercomUserHash = _user$user2.intercomUserHash,
      _user$company2 = user.company,
      companyId = _user$company2.companyId,
      companyName = _user$company2.companyName,
      companyType = _user$company2.companyType,
      plan = _user$company2.plan,
      websiteUrl = _user$company2.websiteUrl,
      phone = _user$company2.phone,
      acctCreationReason = _user$company2.acctCreationReason,
      bookingSystem = user.bookingSystem,
      emailClient = user.emailClient,
      affiliateURL = user.affiliateURL;

  setTimeout(function () {
    sendIntercom('boot', {
      app_id: intercomApp,
      // user_id: userId // DO NOT SEND USER ID as we are using user_hash base on email
      name: name || '',
      email: email,
      user_hash: intercomUserHash,
      company: {
        id: companyId,
        creation_reason: acctCreationReason,
        plan: plan,
        company_type: companyType,
        name: companyName,
        website: websiteUrl,
        phone: phone,
        booking_system: bookingSystem,
        email_platform: emailClient,
        affiliateURL: affiliateURL
      }
    });
  }, 3e3);
}

function sendTokenDataToTag(_ref6) {
  var payload = _ref6.payload;
  var userId = payload.userId,
      email = payload.email,
      companyName = payload.companyName,
      companyId = payload.companyId,
      viewAs = payload.viewAs,
      intercomUserHash = payload.intercomUserHash;

  window.dataLayer.push({ event: 'GET_USER',
    user: {
      id: userId || email,
      email: email,
      user_hash: intercomUserHash
    },
    company: {
      id: companyId,
      name: companyName,
      type: viewAs
    }
  });
}
function gaEvent(_ref7) {
  var _STARTING_DRAFT_CREAT;

  var type = _ref7.type,
      _ref7$payload = _ref7.payload,
      payload = _ref7$payload === undefined ? {} : _ref7$payload;
  var event;
  return regeneratorRuntime.wrap(function gaEvent$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          event = (_STARTING_DRAFT_CREAT = {
            STARTING_DRAFT_CREATE_IN_TEMPLATE_LIST: { // Click on 'Created Template' button or clicked on request from Contract List
              eventCategory: 'template',
              eventAction: 'start_template'
            },
            LOADED_TEMPLATES_SUPPLIER_SEND_TEMPLATE_WIZARD: {
              eventCategory: 'template',
              eventAction: 'start_template'
            },
            PUBLISH_TEMPLATE_DRAFT_SUCCESS: { // Clicked to Enter e-Signature
              eventCategory: 'template',
              eventAction: payload.originFrom === 'initial' ? 'complete_initial_template' : 'complete_edited_template'
            },
            CREATE_CONTRACT_FINISHED: { // Buyer sent a contract request
              eventCategory: 'contract',
              eventAction: 'send_request'
            },
            CONTRACTS_CREATED_SUPPLIER_SEND_TEMPLATE_WIZARD: { // Supplier Sent Rates
              eventCategory: 'template',
              eventAction: 'send_rates'
            },
            SEARCH: {
              eventCategory: 'partner-finder',
              eventAction: 'search'
            }
          }, _defineProperty(_STARTING_DRAFT_CREAT, constPF.SEND_INVITATION_PF, {
            eventCategory: 'partner-finder',
            eventAction: 'send-invitation'
          }), _defineProperty(_STARTING_DRAFT_CREAT, constPF.ACCEPT_CONNECTION_PF, {
            eventCategory: 'connection',
            eventAction: 'accept'
          }), _defineProperty(_STARTING_DRAFT_CREAT, constPF.IGNORE_CONNECTION_PF, {
            eventCategory: 'connection',
            eventAction: 'reject'
          }), _defineProperty(_STARTING_DRAFT_CREAT, constCO.IGNORE_CONNECTION, {
            eventCategory: 'connection',
            eventAction: 'reject'
          }), _STARTING_DRAFT_CREAT)[type];

          if (event) gaSendEvent(event);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function intercomEvent(_ref8) {
  var _CREATE_CONTRACT_FINI;

  var type = _ref8.type;
  var message;
  return regeneratorRuntime.wrap(function intercomEvent$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          message = (_CREATE_CONTRACT_FINI = {
            CREATE_CONTRACT_FINISHED: '[Contract] Send Request',
            STATE_CHANGE_CONTRACT_LIST: '[Contract] Change Status',
            ONBOARDING_COMPLETE: '[Account] Completed Onboarding',
            ADD_PRODUCT: '[Location] Added Product',
            SENT_MARKETING_MATERIALS: '[Marketing Material] Share',
            ADD_LOCATION: 'Added Location',
            ADD_NEW_USERS: '[Settings] Added New User',
            SEARCH: '[Partner Finder] Search'
          }, _defineProperty(_CREATE_CONTRACT_FINI, constPF.SEND_INVITATION_PF, '[Partner Finder] Send Invitation'), _defineProperty(_CREATE_CONTRACT_FINI, constPF.RESEND_INVITATION_PF, '[Partner Finder] Re-Send Invitation'), _defineProperty(_CREATE_CONTRACT_FINI, constPF.ACCEPT_CONNECTION_PF, '[Connection] Accepted Connection'), _defineProperty(_CREATE_CONTRACT_FINI, constPF.IGNORE_CONNECTION_PF, '[Connection] Rejected Connection'), _defineProperty(_CREATE_CONTRACT_FINI, constCO.IGNORE_CONNECTION, '[Connection] Rejected Connection'), _defineProperty(_CREATE_CONTRACT_FINI, 'HELPWIDGET_OPEN', '[Support] Widget Open'), _defineProperty(_CREATE_CONTRACT_FINI, 'SIGN_UP_USER_FINISHED', '[Sign Up] Create Account'), _defineProperty(_CREATE_CONTRACT_FINI, '[asset-landing]SIGN_UP_SUCCESS', '[Sign Up] Create Account'), _defineProperty(_CREATE_CONTRACT_FINI, 'AITools_Clicked', 'AITools_Clicked'), _CREATE_CONTRACT_FINI)[type];

          if (message) sendIntercom('trackEvent', message);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

// Buyer changed the status of a contract
function gaChangeStatus(_ref9) {
  var newState = _ref9.payload.newState;
  return regeneratorRuntime.wrap(function gaChangeStatus$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          gaSendEvent({
            eventCategory: 'contract',
            eventAction: 'change_status',
            eventLabel: newState
          });

        case 1:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function invitationsEvent() {
  var count;
  return regeneratorRuntime.wrap(function invitationsEvent$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(getInvitationsSent);

        case 2:
          count = _context9.sent;

          sendIntercom('trackEvent', '[Connections] Invitation', {
            count: count
          });
          gaSendEvent({
            eventCategory: 'connection',
            eventValue: count,
            eventAction: 'sent connection'
          });

        case 5:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function intercomLocationFieldUpdate(_ref10) {
  var updateField = _ref10.payload.updateField;
  var event;
  return regeneratorRuntime.wrap(function intercomLocationFieldUpdate$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          event = {
            contacts: '[Location] Contact',
            description: '[Location] Description',
            amenities: '[Location] Amenities',
            rating: '[Location] Star Rating',
            address: '[Location] Address',
            website: '[Location] Website',
            phone: '[Location] Phone',
            marketSegments: '[Location] Market Segments',
            companyTypes: '[Location] Company Types'
          }[updateField];

          if (event) {
            sendIntercom('trackEvent', event);
          }

        case 2:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function intercomMMUpdate(_ref11) {
  var _ref11$payload = _ref11.payload;
  _ref11$payload = _ref11$payload === undefined ? {} : _ref11$payload;
  var uploadingFile = _ref11$payload.uploadingFile;
  return regeneratorRuntime.wrap(function intercomMMUpdate$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          if (uploadingFile) {
            sendIntercom('trackEvent', '[Location] Marketing Material');
          }

        case 1:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function upgradeEvent(_ref12) {
  var _ref12$payload = _ref12.payload;
  _ref12$payload = _ref12$payload === undefined ? {} : _ref12$payload;
  var plan = _ref12$payload.plan;
  return regeneratorRuntime.wrap(function upgradeEvent$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          sendIntercom('trackEvent', '[Billing] Upgrade Plan', { plan: plan });
          gaSendEvent({
            eventCategory: 'account',
            eventAction: 'upgrade'
          });
          if (window.fbq) window.fbq('track', 'Purchase');

        case 3:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function signUpEvent(_ref13) {
  var type = _ref13.type;
  var shellSignup, signUpObj;
  return regeneratorRuntime.wrap(function signUpEvent$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          shellSignup = type === '[asset-landing]SIGN_UP_SUCCESS';

          if (!shellSignup) {
            _context13.next = 11;
            break;
          }

          _context13.t1 = _ramda2.default;
          _context13.t2 = {};
          _context13.t3 = ['dialog', 'newUserInfo'];
          _context13.next = 7;
          return (0, _effects.select)(getAssetsLandingReducer);

        case 7:
          _context13.t4 = _context13.sent;
          _context13.t0 = _context13.t1.pathOr.call(_context13.t1, _context13.t2, _context13.t3, _context13.t4);
          _context13.next = 14;
          break;

        case 11:
          _context13.next = 13;
          return (0, _effects.select)(getSignUp);

        case 13:
          _context13.t0 = _context13.sent;

        case 14:
          signUpObj = _context13.t0;

          window.dataLayer.push({
            event: 'ACCOUNT_SIGN_UP',
            signUpType: shellSignup ? 'shell' : 'full',
            user: {
              email: signUpObj.email
            },
            company: {
              creationReason: shellSignup ? 'shell' : signUpObj.acctCreationReason,
              name: signUpObj.companyName,
              companyType: signUpObj.companyType
            }
          });

        case 16:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

exports.default = [(0, _effects.takeLatest)('GET_USER', tagAsAdmin), (0, _effects.takeLatest)('GET_USER', rollbarConfigure), (0, _effects.takeLatest)('TRACK_EVENT', trackEvent), (0, _effects.takeEvery)('PAGE_VIEW', pageView), (0, _effects.takeLatest)('GET_USER', sendUserDataToTag), (0, _effects.takeLatest)('GET_USER', sendUserDataToIntercom), (0, _effects.takeLatest)('VERIFY_TOKEN_SUCCESS', sendTokenDataToTag), (0, _effects.takeLatest)('STARTING_DRAFT_CREATE_IN_TEMPLATE_LIST', gaEvent), (0, _effects.takeLatest)('LOADED_TEMPLATES_SUPPLIER_SEND_TEMPLATE_WIZARD', gaEvent), (0, _effects.takeLatest)('PUBLISH_TEMPLATE_DRAFT_SUCCESS', gaEvent), (0, _effects.takeLatest)('CONTRACTS_CREATED_SUPPLIER_SEND_TEMPLATE_WIZARD', gaEvent), (0, _effects.takeLatest)('CREATE_CONTRACT_FINISHED', gaEvent), (0, _effects.takeLatest)('CREATE_CONTRACT_FINISHED', intercomEvent), (0, _effects.takeLatest)('STATE_CHANGE_CONTRACT_LIST', gaChangeStatus), (0, _effects.takeLatest)('STATE_CHANGE_CONTRACT_LIST', intercomEvent), (0, _effects.takeLatest)('SEND_EMAIL_TO_TEMP_CONNECTIONS', invitationsEvent), (0, _effects.takeLatest)('ONBOARDING_COMPLETE', intercomEvent), (0, _effects.takeEvery)('EDIT_USER_LOCATION_PROFILE_FIELD_STARTING', intercomLocationFieldUpdate), (0, _effects.takeLatest)('ADD_PRODUCT', intercomEvent), (0, _effects.takeLatest)('UPDATE_MM_PROP', intercomMMUpdate), (0, _effects.takeLatest)('SENT_MARKETING_MATERIALS', intercomEvent), (0, _effects.takeLatest)('ADD_LOCATION', intercomEvent), (0, _effects.takeLatest)('ADD_NEW_USERS', intercomEvent), (0, _effects.takeEvery)('SEARCH', intercomEvent), (0, _effects.takeEvery)('SEARCH', gaEvent), (0, _effects.takeLatest)(constPF.SEND_INVITATION_PF, intercomEvent), (0, _effects.takeLatest)(constPF.RESEND_INVITATION_PF, intercomEvent), (0, _effects.takeEvery)('USER_STORE_PLAN_UPDATE', upgradeEvent), (0, _effects.takeEvery)('UPGRADE_PLAN', upgradeEvent), (0, _effects.takeEvery)('SELECT_PLAN', upgradeEvent), (0, _effects.takeEvery)(constPF.ACCEPT_CONNECTION_PF, intercomEvent), (0, _effects.takeEvery)(constPF.ACCEPT_CONNECTION_PF, gaEvent), (0, _effects.takeEvery)(constPF.IGNORE_CONNECTION_PF, intercomEvent), (0, _effects.takeEvery)(constPF.IGNORE_CONNECTION_PF, gaEvent), (0, _effects.takeEvery)('[asset-landing]SIGN_UP_SUCCESS', signUpEvent), (0, _effects.takeEvery)('SIGN_UP_USER_FINISHED', signUpEvent), (0, _effects.takeEvery)('[asset-landing]SIGN_UP_SUCCESS', intercomEvent), (0, _effects.takeEvery)('SIGN_UP_USER_FINISHED', intercomEvent), (0, _effects.takeEvery)('HELPWIDGET_OPEN', intercomEvent), (0, _effects.takeEvery)('AITools_Clicked', intercomEvent)];

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _globalErrorsDisplayActions = __webpack_require__(486);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _actions = __webpack_require__(253);

var _constants = __webpack_require__(657);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getSettings),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(saveSettings),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(cantAddUser),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(couldAddUser);

function getSettings(_ref) {
  var pathname = _ref.payload.pathname;
  return regeneratorRuntime.wrap(function getSettings$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(pathname.split('/')[1] === 'settings')) {
            _context.next = 3;
            break;
          }

          _context.next = 3;
          return (0, _sagas.apiSaga)(cnt.GET_SETTINGS, _api.settings.getSettings, []);

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function saveSettings(_ref2) {
  var payload = _ref2.payload;
  return regeneratorRuntime.wrap(function saveSettings$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _sagas.apiSaga)(cnt.SAVE_SETTINGS, _api.settings.saveSettings, [payload]);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function cantAddUser(_ref3) {
  var payload = _ref3.payload;
  var errorMessage;
  return regeneratorRuntime.wrap(function cantAddUser$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          errorMessage = 'This user cannot be added.';

          if (!payload.message) {
            _context3.next = 6;
            break;
          }

          _context3.next = 4;
          return (0, _effects.put)((0, _globalErrorsDisplayActions.triggerError)({ errorMessage: errorMessage + ' ' + payload.message + '.' }));

        case 4:
          _context3.next = 8;
          break;

        case 6:
          _context3.next = 8;
          return (0, _effects.put)((0, _globalErrorsDisplayActions.triggerError)({ errorMessage: errorMessage }));

        case 8:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}
function couldAddUser() {
  return regeneratorRuntime.wrap(function couldAddUser$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)({ type: 'UPDATE_UM_PROP', payload: { addingNewUserDialog: false } });

        case 2:
          _context4.next = 4;
          return (0, _effects.put)((0, _actions.getUsersByFilter)('user'));

        case 4:
          _context4.next = 6;
          return (0, _effects.put)((0, _actions.getUsersByFilter)('team'));

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

exports.default = [(0, _effects.takeLatest)('@@router/LOCATION_CHANGE', getSettings), (0, _effects.takeLatest)('ADD_USER_FAILED', cantAddUser), (0, _effects.takeLatest)('ADDED_USER', couldAddUser), (0, _effects.takeLatest)(cnt.SAVE_SETTINGS, saveSettings)];

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(647);

var cnt = _interopRequireWildcard(_actions);

var _effects = __webpack_require__(36);

var _api = __webpack_require__(37);

var _sagas = __webpack_require__(43);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(doAddConnectAsPartner);

function doAddConnectAsPartner(_ref) {
  var payload = _ref.payload;
  return regeneratorRuntime.wrap(function doAddConnectAsPartner$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield((0, _sagas.apiSaga)(cnt.ADD_CONNECTION_AS_PARTNER, _api.partner.addConnectionAsPartner, [payload]), 't0', 1);

        case 1:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

exports.default = [(0, _effects.takeLatest)(cnt.ADD_CONNECTION_AS_PARTNER, doAddConnectAsPartner)];

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.refreshPolicyNotes = refreshPolicyNotes;

var _effects = __webpack_require__(36);

var _reduxSaga = __webpack_require__(92);

var _sagas = __webpack_require__(43);

var _reactRouterRedux = __webpack_require__(27);

var _api = __webpack_require__(37);

var _sagas2 = __webpack_require__(609);

var _marked = /*#__PURE__*/regeneratorRuntime.mark(refreshPolicyNotes),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(refreshActivities),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(createTemplatesInDummyAcct),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(afterCreateTemplatesInDummyAcctSuccess),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(acceptDummyTemplate),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(afterAcceptDummyTemplate),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(doRequestSignature),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(updateWorkspaceContract),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(handleSendMessage),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(submitRates),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(afterSubmitRatesAsDLSuccess),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(createDummyTemplateDraftForBuyer),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(afterCreateDummyTemplateDraftForBuyerSuccess),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(deleteRateSheet),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(loadDataForIframe),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(checkIfRateComplete),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(onCloseIframe),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(discardEditedDraft),
    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(loadDraftDiff);

function refreshPolicyNotes(_ref) {
  var args = _ref.args;

  var _args$, crId, contractId, inActivityFeed, isRateContract;

  return regeneratorRuntime.wrap(function refreshPolicyNotes$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _args$ = args[0], crId = _args$.crId, contractId = _args$.contractId, inActivityFeed = _args$.inActivityFeed, isRateContract = _args$.isRateContract;

          if (!(window.location.href.indexOf('/assets-landing') > -1)) {
            _context.next = 6;
            break;
          }

          _context.next = 4;
          return (0, _sagas.apiSaga)('[asset-landing]GET_REQUEST', _api.contracting.getContractInfo, [{
            collection: 'contract',
            type: 'policyNotes',
            docId: crId || contractId,
            forAL: true
          }]);

        case 4:
          _context.next = 8;
          break;

        case 6:
          _context.next = 8;
          return (0, _effects.all)([inActivityFeed ? Promise.resolve() : (0, _sagas.apiSaga)('{rates-draft} REFRESH_POLICIES_NOTES', _api.contracting.getContractInfo, [{
            collection: 'contract',
            docId: crId || contractId,
            type: 'policyNotes'
          }]), (0, _sagas.apiSaga)('{rates-draft} REFRESH_LEFT_NAV', _api.contracting.getContractInfo, [{
            collection: 'contract',
            docId: isRateContract ? contractId : crId || contractId,
            type: 'leftNav'
          }])]);

        case 8:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function refreshActivities(_ref2) {
  var args = _ref2.args;
  return regeneratorRuntime.wrap(function refreshActivities$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!(args[0].contractId || args[0].crId)) {
            _context2.next = 3;
            break;
          }

          _context2.next = 3;
          return (0, _sagas.apiSaga)('LOADING_HISTORY_FEEDS', _api.historyFeed.getHistory, [args[0].contractId || args[0].crId]);

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function createTemplatesInDummyAcct(_ref3) {
  var type = _ref3.type,
      payload = _ref3.payload;
  return regeneratorRuntime.wrap(function createTemplatesInDummyAcct$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.createTemplatesInDummyAcct, [payload]);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function afterCreateTemplatesInDummyAcctSuccess(_ref4) {
  var args = _ref4.args;

  var _ref5, _ref5$rateConversionS, rateConversionStatus, crId;

  return regeneratorRuntime.wrap(function afterCreateTemplatesInDummyAcctSuccess$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(function (state) {
            return state.dummyAcct.inCR;
          });

        case 2:
          _ref5 = _context4.sent;
          _ref5$rateConversionS = _ref5.rateConversionStatus;
          rateConversionStatus = _ref5$rateConversionS === undefined ? '' : _ref5$rateConversionS;
          crId = _ref5.crId;

          if (!(rateConversionStatus.toLowerCase() === 'awaiting supplier rates' || rateConversionStatus.toLowerCase() === 'in queue')) {
            _context4.next = 11;
            break;
          }

          _context4.next = 9;
          return updateWorkspaceContract({
            type: '[contract-request] UPDATE_RATE_LOADING_STATUS',
            payload: { contractId: crId, updater: { rateConversionStatus: 'In Progress' } }
          });

        case 9:
          _context4.next = 13;
          break;

        case 11:
          _context4.next = 13;
          return refreshPolicyNotes({ args: args });

        case 13:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function acceptDummyTemplate(_ref6) {
  var type = _ref6.type,
      payload = _ref6.payload;
  var confirm;
  return regeneratorRuntime.wrap(function acceptDummyTemplate$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          confirm = window.confirm('Please be informed that by accepting this rate sheet, you will no longer be able to request a signature from your supplier.');

          if (!confirm) {
            _context5.next = 4;
            break;
          }

          _context5.next = 4;
          return (0, _sagas.apiSaga)(type, _api.contracting.acceptDummyTemplate, [{
            rateDocId: payload.rateDocId,
            from: 'buyer-acct-cr'
          }]);

        case 4:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}
function afterAcceptDummyTemplate(_ref7) {
  var payload = _ref7.payload;
  return regeneratorRuntime.wrap(function afterAcceptDummyTemplate$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (!payload.contractId) {
            _context6.next = 5;
            break;
          }

          _context6.next = 3;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/contracting/contract/' + payload.contractId + '/details'));

        case 3:
          _context6.next = 12;
          break;

        case 5:
          if (!payload.templateId) {
            _context6.next = 10;
            break;
          }

          _context6.next = 8;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/contracting/template/' + payload.templateId + '/details'));

        case 8:
          _context6.next = 12;
          break;

        case 10:
          _context6.next = 12;
          return (0, _sagas2.refreshContractDoc)();

        case 12:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function doRequestSignature(_ref8) {
  var type = _ref8.type,
      payload = _ref8.payload;
  return regeneratorRuntime.wrap(function doRequestSignature$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.sendRCMsg, [_extends({}, payload, { who: 'Supplier' })]);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function updateWorkspaceContract(_ref9) {
  var type = _ref9.type,
      payload = _ref9.payload;
  return regeneratorRuntime.wrap(function updateWorkspaceContract$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.updateWorkspaceContract, [payload]);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function handleSendMessage(_ref10) {
  var type = _ref10.type,
      payload = _ref10.payload;
  return regeneratorRuntime.wrap(function handleSendMessage$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          if (!(payload.who === 'Supplier' && !payload.rateDocIds.length)) {
            _context9.next = 4;
            break;
          }

          return _context9.delegateYield((0, _sagas.apiSaga)(type, _api.contracting.submitContractingComment, [{
            files: payload.leanFiles || [],
            message: payload.message,
            historyFeedId: payload.historyFeedId,
            emails: payload.emails,
            subject: payload.subject,
            crId: payload.crId
          }]), 't0', 2);

        case 2:
          _context9.next = 6;
          break;

        case 4:
          _context9.next = 6;
          return (0, _sagas.apiSaga)(type, _api.contracting.sendRCMsg, [payload]);

        case 6:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function submitRates(_ref11) {
  var type = _ref11.type,
      payload = _ref11.payload;
  return regeneratorRuntime.wrap(function submitRates$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.submitRCRates, [payload]);

        case 2:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function afterSubmitRatesAsDLSuccess(_ref12) {
  var args = _ref12.args;
  return regeneratorRuntime.wrap(function afterSubmitRatesAsDLSuccess$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.delegateYield([(0, _sagas.apiSaga)('[contract-request]GET_RESPONDED_CONTRACT_LIST', _api.contracting.getRespondedContractList, [{ requestId: args[0].crId }]), refreshPolicyNotes({ args: args })], 't0', 1);

        case 1:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function createDummyTemplateDraftForBuyer(_ref13) {
  var type = _ref13.type,
      payload = _ref13.payload;
  return regeneratorRuntime.wrap(function createDummyTemplateDraftForBuyer$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.createEditedDraftForBuyer, [payload]);

        case 2:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function afterCreateDummyTemplateDraftForBuyerSuccess(_ref14) {
  var payload = _ref14.payload;
  return regeneratorRuntime.wrap(function afterCreateDummyTemplateDraftForBuyerSuccess$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.put)({ type: '[contractTemplate]TOGGLE_CREATE_DRAFT_DIALOG' });

        case 2:
          _context13.next = 4;
          return (0, _effects.put)({
            type: '{dummy-account} RateDocIframe_open',
            payload: {
              url: payload.magicLink + '&jumpBackTo=' + window.location.href,
              collection: 'draft',
              rateDocId: payload.docId,
              isInSigning: false
            }
          });

        case 4:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function deleteRateSheet(_ref15) {
  var type = _ref15.type,
      payload = _ref15.payload;
  return regeneratorRuntime.wrap(function deleteRateSheet$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _sagas.apiSaga)(type, _api.contracting.deleteTemplateDraft, [payload]);

        case 2:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function loadDataForIframe() {
  var _ref16, rateDocId, collection, forImport;

  return regeneratorRuntime.wrap(function loadDataForIframe$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.select)(function (state) {
            return state.dummyAcct.rateDocIframe;
          });

        case 2:
          _ref16 = _context15.sent;
          rateDocId = _ref16.rateDocId;
          collection = _ref16.collection;
          forImport = _ref16.forImport;

          if (!(rateDocId && collection && window.location.href.indexOf('/assets-landing') === -1 && !forImport)) {
            _context15.next = 9;
            break;
          }

          _context15.next = 9;
          return (0, _sagas.apiSaga)('{dummy-account} loadDataForIframe', _api.contracting.loadDataForIframe, [{ rateDocId: rateDocId, collection: collection }]);

        case 9:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}
function checkIfRateComplete(_ref17) {
  var type = _ref17.type,
      payload = _ref17.payload,
      next = _ref17.next,
      shouldBlock = _ref17.shouldBlock;

  var _ref18, rateDocId, collection, originFrom, _ref19, completionPercent, rawDiffData, isADraft, rateInfoComplete, confirmed;

  return regeneratorRuntime.wrap(function checkIfRateComplete$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.select)(function (state) {
            return state.dummyAcct.rateDocIframe;
          });

        case 2:
          _ref18 = _context16.sent;
          rateDocId = _ref18.rateDocId;
          collection = _ref18.collection;
          originFrom = _ref18.originFrom;
          _context16.next = 8;
          return (0, _effects.all)([(0, _sagas.apiSaga)(type, _api.contracting.loadDataForIframe, [{ rateDocId: rateDocId, collection: collection }]), loadDraftDiff()]);

        case 8:
          _context16.next = 10;
          return (0, _effects.select)(function (state) {
            return state.dummyAcct.rateDocIframe;
          });

        case 10:
          _ref19 = _context16.sent;
          completionPercent = _ref19.completionPercent;
          rawDiffData = _ref19.rawDiffData;
          isADraft = collection === 'draft';

          rateInfoComplete = function () {
            if (!isADraft) return true;
            if (originFrom === 'initial') {
              return completionPercent === 100;
            }
            return Boolean(completionPercent === 100 && rawDiffData.length);
          }();

          if (!rateInfoComplete) {
            _context16.next = 20;
            break;
          }

          _context16.next = 18;
          return (0, _effects.put)({ type: next, payload: payload });

        case 18:
          _context16.next = 28;
          break;

        case 20:
          if (!(shouldBlock || !rawDiffData.length && originFrom === 'edited')) {
            _context16.next = 24;
            break;
          }

          // if the draft does not contain any changes, we need to block because backend won't process
          if (!rawDiffData.length && originFrom === 'edited') window.alert('You haven\'t made any changes yet.');else window.alert('Please complete the rate sheet before continuing');
          _context16.next = 28;
          break;

        case 24:
          confirmed = window.confirm('This rate sheet is not complete, are you sure that you want to continue?');

          if (!confirmed) {
            _context16.next = 28;
            break;
          }

          _context16.next = 28;
          return (0, _effects.put)({ type: next, payload: payload });

        case 28:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function onCloseIframe() {
  var contractId, _ref20, crId;

  return regeneratorRuntime.wrap(function onCloseIframe$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          // TODO: UPDATE when old view is deprecated
          contractId = void 0;

          if (window.location.pathname.indexOf('/workspace/')) {
            contractId = (window.location.pathname.match(/^\/contracting\/workspace\/([a-f\d]{24})\//) || [])[1];
          } else {
            contractId = (window.location.pathname.match(/^\/contracting\/contract\/([a-f\d]{24})\//) || [])[1];
          }

          if (!contractId) {
            _context17.next = 7;
            break;
          }

          _context17.next = 5;
          return refreshPolicyNotes({ args: [{ contractId: contractId }] });

        case 5:
          _context17.next = 14;
          break;

        case 7:
          if (!(window.location.href.indexOf('/assets-landing') > -1)) {
            _context17.next = 14;
            break;
          }

          _context17.next = 10;
          return (0, _effects.select)(function (state) {
            return state.assetsLandingReducer.request;
          });

        case 10:
          _ref20 = _context17.sent;
          crId = _ref20.contractId;
          _context17.next = 14;
          return refreshPolicyNotes({ args: [{ crId: crId }] });

        case 14:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

function discardEditedDraft(_ref21) {
  var type = _ref21.type;

  var confirmed, _ref22, rateDocId;

  return regeneratorRuntime.wrap(function discardEditedDraft$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          confirmed = window.confirm('Are you sure you want to discard this draft?');

          if (!confirmed) {
            _context18.next = 8;
            break;
          }

          _context18.next = 4;
          return (0, _effects.select)(function (state) {
            return state.dummyAcct.rateDocIframe;
          });

        case 4:
          _ref22 = _context18.sent;
          rateDocId = _ref22.rateDocId;
          _context18.next = 8;
          return (0, _sagas.apiSaga)(type, _api.contracting.deleteEditedDraft, [rateDocId]);

        case 8:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function loadDraftDiff() {
  var _ref23, rateDocId, originFrom;

  return regeneratorRuntime.wrap(function loadDraftDiff$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _effects.select)(function (state) {
            return state.dummyAcct.rateDocIframe;
          });

        case 2:
          _ref23 = _context19.sent;
          rateDocId = _ref23.rateDocId;
          originFrom = _ref23.originFrom;

          if (!(originFrom === 'edited')) {
            _context19.next = 10;
            break;
          }

          _context19.next = 8;
          return (0, _effects.call)(_reduxSaga.delay, 500);

        case 8:
          _context19.next = 10;
          return (0, _sagas.apiSaga)('{dummy-account} loadDraftDiff', _api.contracting.getDiffReport, [{ docs: 'draft:' + rateDocId + ':' + rateDocId, onlyGetSummary: true }]);

        case 10:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked19, this);
}
exports.default = [(0, _effects.takeLatest)('[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR', createTemplatesInDummyAcct), (0, _effects.takeLatest)('[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR_SUCCESS', afterCreateTemplatesInDummyAcctSuccess), (0, _effects.takeLatest)('{dummy-account} ACCEPT_DUMMY_TEMPLATE', acceptDummyTemplate), (0, _effects.takeLatest)('{dummy-account} ACCEPT_DUMMY_TEMPLATE_SUCCESS', afterAcceptDummyTemplate), (0, _effects.takeLatest)('{dummy-account} REQUEST_SIGNATURE', doRequestSignature), (0, _effects.takeLatest)('{dummy-account} REQUEST_SIGNATURE_SUCCESS', loadDataForIframe), (0, _effects.takeLatest)(['[contract-request] UPDATE_RATE_LOADING_STATUS', '[contract-request] UPDATE_RATE_CONVERSION_SETTING', '[contract-request] UPDATE_RATE_CONVERSION_PRIORITY', '[contract-request] UPDATE_CONTRACTING_WORKSPACE'], updateWorkspaceContract), (0, _effects.takeLatest)(['[contract-request] UPDATE_RATE_LOADING_STATUS_SUCCESS', '[contract-request] UPDATE_RATE_CONVERSION_SETTING_SUCCESS', '[contract-request] UPDATE_RATE_CONVERSION_PRIORITY_SUCCESS', '[contract-request] UPDATE_CONTRACTING_WORKSPACE_SUCCESS'], refreshPolicyNotes), (0, _effects.takeLatest)('{rl-send-message} SEND_MESSAGE', handleSendMessage), (0, _effects.takeLatest)('{rl-send-message} SUBMIT_RATES_AS_DL', submitRates), (0, _effects.takeLatest)('{rl-send-message} SUBMIT_RATES_AS_DL_SUCCESS', afterSubmitRatesAsDLSuccess), (0, _effects.takeLatest)('{rl-send-message} SEND_MESSAGE_SUCCESS', refreshPolicyNotes), (0, _effects.takeLatest)('{rl-send-message} SEND_MESSAGE_SUCCESS', refreshActivities), (0, _effects.takeLatest)('{dummy-account} CREATE_DUMMY_TEMPLATE_DRAFT', createDummyTemplateDraftForBuyer), (0, _effects.takeLatest)('{dummy-account} CREATE_DUMMY_TEMPLATE_DRAFT_SUCCESS', afterCreateDummyTemplateDraftForBuyerSuccess), (0, _effects.takeLatest)('[contract-request] DELETE_RATE_SHEET', deleteRateSheet), (0, _effects.takeLatest)('{dummy-account} RateDocIframe_open', loadDataForIframe), (0, _effects.takeLatest)('{dummy-account} RateDocIframe_checkIfRateComplete', checkIfRateComplete), (0, _effects.takeLatest)('{dummy-account} RateDocIframe_close', onCloseIframe), (0, _effects.takeLatest)('{dummy-account} DISCARD_DUMMY_TEMPLATE_DRAFT', discardEditedDraft), (0, _effects.takeLatest)('{dummy-account} loadDataForIframe_SUCCESS', loadDraftDiff)];

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _reduxSaga = __webpack_require__(92);

var _api = __webpack_require__(37);

var _sagas = __webpack_require__(43);

var _ramda = __webpack_require__(2);

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(checkJobStatus),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(startPolling);

function checkJobStatus(payload) {
  var jobSucceeded, pollingAction;
  return regeneratorRuntime.wrap(function checkJobStatus$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          jobSucceeded = false;

        case 1:
          if (jobSucceeded) {
            _context.next = 23;
            break;
          }

          _context.next = 4;
          return (0, _effects.call)(_reduxSaga.delay, 4000);

        case 4:
          _context.next = 6;
          return (0, _effects.put)({ type: '{integration-export}POLLING_ACTION_REQUEST' });

        case 6:
          _context.next = 8;
          return (0, _effects.call)(_api.integration.getJobStatus, { jobId: payload.jobId });

        case 8:
          pollingAction = _context.sent;
          _context.t0 = pollingAction.response.state;
          _context.next = _context.t0 === 'succeded' ? 12 : _context.t0 === 'failed' ? 16 : 20;
          break;

        case 12:
          jobSucceeded = true;
          _context.next = 15;
          return (0, _effects.put)({ type: '{integration-export} GET_PROCESSED_RESPONSE', payload: pollingAction.response.callbackResult });

        case 15:
          return _context.abrupt('break', 21);

        case 16:
          jobSucceeded = true;
          _context.next = 19;
          return (0, _effects.put)({ type: '{integration-export} HANDLE_POLLING_FAILURE' });

        case 19:
          return _context.abrupt('break', 21);

        case 20:
          return _context.abrupt('break', 21);

        case 21:
          _context.next = 1;
          break;

        case 23:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function startPolling(_ref) {
  var payload = _ref.payload;

  var _ref2, timeout;

  return regeneratorRuntime.wrap(function startPolling$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.race)({
            response: (0, _effects.call)(function () {
              return checkJobStatus(payload);
            }),
            timeout: (0, _effects.call)(_reduxSaga.delay, 60e3)
          });

        case 2:
          _ref2 = _context2.sent;
          timeout = _ref2.timeout;

          if (!timeout) {
            _context2.next = 7;
            break;
          }

          _context2.next = 7;
          return (0, _effects.put)({ type: '{integration-export} HANDLE_POLLING_FAILURE', error: 'TOOOOO LOOOOOG' });

        case 7:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

exports.default = [(0, _effects.takeLatest)('{integration-export} POLLING_ACTION_RESPONSE', startPolling)];

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = __webpack_require__(36);

var _sagas = __webpack_require__(43);

var _api = __webpack_require__(37);

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getInvoices);

function getInvoices(_ref) {
  var type = _ref.type,
      payload = _ref.payload;
  return regeneratorRuntime.wrap(function getInvoices$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _sagas.apiSaga)(type, _api.billing.getInvoices, [payload || {}]);

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}
exports.default = [(0, _effects.takeLatest)('{billing} getInvoices', getInvoices)];

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSettingsProps = updateSettingsProps;
exports.resetPassword = resetPassword;
exports.passwordInputModified = passwordInputModified;
exports.passwordResetError = passwordResetError;
exports.toggleConnectionNotifications = toggleConnectionNotifications;
exports.hydrateFromServer = hydrateFromServer;
exports.addTempUser = addTempUser;
exports.deleteTempUser = deleteTempUser;
exports.tempUserPropModified = tempUserPropModified;
exports.addNewUsers = addNewUsers;
exports.clearAddUserMessage = clearAddUserMessage;
exports.clearEditUserMessage = clearEditUserMessage;
exports.disableUser = disableUser;
exports.updateUserBeingEdited = updateUserBeingEdited;
exports.editUserPropModified = editUserPropModified;
exports.saveUserBeingEdited = saveUserBeingEdited;
exports.confirmedDisassociateSecondaryEmail = confirmedDisassociateSecondaryEmail;
exports.addSecondaryEmail = addSecondaryEmail;
exports.resendSecondaryEmailConfirmationLink = resendSecondaryEmailConfirmationLink;
exports.resendConfirmationLink = resendConfirmationLink;
exports.clearManageUsersMessage = clearManageUsersMessage;

var _soFetch = __webpack_require__(254);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _settingsConstants = __webpack_require__(1842);

var constants = _interopRequireWildcard(_settingsConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function updateSettingsProps(payload) {
  return { type: constants.UPDATE_SETTINGS_PROP, payload: payload };
}

function resetPassword(oldPassword, newPassword) {
  return (0, _soFetch.soFetch)('/proxy/settings/reset', {
    method: 'put',
    body: { oldPassword: oldPassword, newPassword: newPassword },
    actionType: constants.RESET_PASSWORD
  });
}

function passwordInputModified(passType, newValue) {
  return {
    type: constants.PASSWORD_INPUT_MODIFIED,
    payload: _defineProperty({}, passType, newValue)
  };
}
function passwordResetError(errorMessage, errorFields) {
  return {
    type: constants.RESET_PASSWORD,
    payload: {
      error: true,
      errorFields: errorFields,
      errorMessage: errorMessage
    }
  };
}

function toggleConnectionNotifications(newNotifValue) {
  return (0, _soFetch.soFetch)('/proxy/settings/connectionNotifications', {
    method: 'put',
    body: { newNotifValue: newNotifValue },
    actionType: constants.TOGGLE_CONNECTION_NOTIFICATIONS
  });
}

function hydrateFromServer() {
  return (0, _soFetch.soFetch)('/proxy/settings/hydrate', {
    method: 'get',
    actionType: constants.HYDRATE_FROM_SERVER
  });
}

function addTempUser() {
  return {
    type: constants.ADD_TEMP_USER
  };
}

function deleteTempUser(key) {
  return {
    type: constants.DELETE_TEMP_USER,
    payload: key
  };
}

function tempUserPropModified(key, propName, newValue) {
  return {
    type: constants.TEMP_USER_PROP_MODIFIED,
    payload: { key: key, propName: propName, newValue: newValue }
  };
}

function addNewUsers(clickedButton, newUsersOrderedMap) {
  if (clickedButton === 'add') {
    var newUsersArray = newUsersOrderedMap.valueSeq().map(function (value) {
      return value;
    }).toJS();
    return function (dispatch) {
      dispatch({ type: constants.START_ADDING_NEW_USER });
      return fetch('/proxy/settings/addUsers', {
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html', 'Content-Type': 'application/json' },
        method: 'post',
        body: JSON.stringify({ newUsersArray: newUsersArray })
      }).then(_checkStatus2.default).then(function (res) {
        return res.json();
      }).then(function (res) {
        return dispatch({ type: constants.ADD_NEW_USERS, payload: res });
      });
    };
  }

  return {
    type: constants.CLEAR_TEMP_USERS
  };
}

function clearAddUserMessage() {
  return {
    type: constants.CLEAR_ADD_USER_MESSAGE
  };
}
function clearEditUserMessage() {
  return {
    type: constants.CLEAR_EDIT_USER_MESSAGE
  };
}

function disableUser(user) {
  return (0, _soFetch.soFetch)('/proxy/settings/disableUser', {
    method: 'put',
    body: { user: user },
    actionType: constants.USER_DISABLED
  });
}

function updateUserBeingEdited(user) {
  return {
    type: constants.EDIT_USER_UPDATED,
    payload: user
  };
}

function editUserPropModified(propName, newValue) {
  return {
    type: constants.EDIT_USER_PROP_MODIFIED,
    payload: _defineProperty({}, propName, newValue)
  };
}

function saveUserBeingEdited(user) {
  return (0, _soFetch.soFetch)('/proxy/settings/saveEditedUser', {
    method: 'put',
    body: { user: user },
    actionType: constants.EDIT_USER_SAVED
  });
}

function confirmedDisassociateSecondaryEmail(id) {
  return (0, _soFetch.soFetch)('/proxy/secondary-email/confirmed-disassociate-secondary-email', {
    method: 'put',
    body: { id: id, type: 'settings' },
    actionType: constants.CONFIRMED_DISASSOCIATE_SECONDARY_EMAIL
  });
}

function addSecondaryEmail(email) {
  return (0, _soFetch.soFetch)('/proxy/secondary-email/add-secondary-email', {
    method: 'post',
    body: { email: email },
    actionType: constants.ADD_SECONDARY_EMAIL
  });
}

function resendSecondaryEmailConfirmationLink(email) {
  return (0, _soFetch.soFetch)('/proxy/secondary-email/send-secondary-email-confirmation', {
    method: 'put',
    body: { email: email, type: 'settings' },
    actionType: constants.RESEND_CONFIRMATION_SECONDARY_EMAIL
  });
}

function resendConfirmationLink(email) {
  return (0, _soFetch.soFetch)('/proxy/settings/resendConfirmationLink', {
    method: 'put',
    body: { email: email },
    actionType: constants.RESEND_CONFIRMATION_LINK_USER_SETTINGS
  });
}

function clearManageUsersMessage() {
  return { type: constants.CLEAR_MANAGE_USERS_MESSAGE };
}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLiveChatDisabled = exports.setLiveChatActive = exports.receiveNewFeatures = exports.setNewFeaturesActive = exports.setSupportDeskActive = exports.setSupportDeskLoading = exports.closeHelpWidget = exports.openHelpWidget = undefined;

var _helpwidgetConstants = __webpack_require__(1106);

var constants = _interopRequireWildcard(_helpwidgetConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var openHelpWidget = exports.openHelpWidget = function openHelpWidget() {
  return {
    type: constants.OPEN
  };
};

var closeHelpWidget = exports.closeHelpWidget = function closeHelpWidget() {
  return {
    type: constants.CLOSE
  };
};

var setSupportDeskLoading = exports.setSupportDeskLoading = function setSupportDeskLoading() {
  return {
    type: constants.SUPPORT_DESK_LOADING
  };
};

var setSupportDeskActive = exports.setSupportDeskActive = function setSupportDeskActive() {
  return {
    type: constants.SUPPORT_DESK_ACTIVE
  };
};

var setNewFeaturesActive = exports.setNewFeaturesActive = function setNewFeaturesActive() {
  return {
    type: constants.NEW_FEATURES_ACTIVE
  };
};

var receiveNewFeatures = exports.receiveNewFeatures = function receiveNewFeatures(count) {
  return {
    type: constants.RECEIVE_NEW_FEATURES,
    payload: {
      count: count
    }
  };
};

var setLiveChatActive = exports.setLiveChatActive = function setLiveChatActive() {
  return {
    type: constants.LIVE_CHAT_ACTIVE
  };
};

var setLiveChatDisabled = exports.setLiveChatDisabled = function setLiveChatDisabled() {
  return {
    type: constants.LIVE_CHAT_INACTIVE
  };
};

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YouTube = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(145);

var _singlePlayer = __webpack_require__(227);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_URL = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})/;
var MATCH_PLAYLIST = /list=([a-zA-Z0-9_-]+)/;

function parsePlaylist(url) {
  if (MATCH_PLAYLIST.test(url)) {
    var _url$match = url.match(MATCH_PLAYLIST),
        _url$match2 = _slicedToArray(_url$match, 2),
        playlistId = _url$match2[1];

    console.log(playlistId);
    return {
      listType: 'playlist',
      list: playlistId
    };
  }
  return {};
}

var YouTube = exports.YouTube = function (_Component) {
  _inherits(YouTube, _Component);

  function YouTube() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onStateChange = function (_ref2) {
      var data = _ref2.data;
      var _this$props = _this.props,
          onPlay = _this$props.onPlay,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer,
          onEnded = _this$props.onEnded,
          onReady = _this$props.onReady,
          loop = _this$props.loop;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;

      if (data === PLAYING) onPlay();
      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();
      if (data === ENDED) {
        var isPlaylist = !!_this.callPlayer('getPlaylist');
        if (loop && !isPlaylist) {
          _this.play(); // Only loop manually if not playing a playlist
        }
        onEnded();
      }
      if (data === CUED) onReady();
    }, _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unMute');
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(YouTube, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      var _props = this.props,
          playing = _props.playing,
          muted = _props.muted,
          playsinline = _props.playsinline,
          controls = _props.controls,
          loop = _props.loop,
          config = _props.config,
          _onError = _props.onError;
      var playerVars = config.youtube.playerVars;

      var id = url && url.match(MATCH_URL)[1];
      if (isReady) {
        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
          endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
        });
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
        return YT.loaded;
      }).then(function (YT) {
        if (!_this2.container) return;
        _this2.player = new YT.Player(_this2.container, {
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _extends({
            autoplay: playing ? 1 : 0,
            mute: muted ? 1 : 0,
            controls: controls ? 1 : 0,
            start: (0, _utils.parseStartTime)(url),
            end: (0, _utils.parseEndTime)(url),
            origin: window.location.origin,
            playsinline: playsinline
          }, parsePlaylist(url), playerVars),
          events: {
            onReady: _this2.props.onReady,
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          }
        });
        if (loop) {
          _this2.player.setLoop(true); // Enable playlist looping
        }
      }, _onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('playVideo');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pauseVideo');
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (!document.body.contains(this.callPlayer('getIframe'))) return;
      this.callPlayer('stopVideo');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(amount) {
      this.callPlayer('seekTo', amount);
      if (!this.props.playing) {
        this.pause();
      }
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%'
      }, this.props.style);
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('div', { ref: this.ref })
      );
    }
  }]);

  return YouTube;
}(_react.Component);

YouTube.displayName = 'YouTube';

YouTube.canPlay = function (url) {
  return MATCH_URL.test(url);
};

exports['default'] = (0, _singlePlayer2['default'])(YouTube);

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props2 = __webpack_require__(733);

var _utils = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var Player = function (_Component) {
  _inherits(Player, _Component);

  function Player() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Player);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Player.__proto__ || Object.getPrototypeOf(Player)).call.apply(_ref, [this].concat(args))), _this), _this.mounted = false, _this.isReady = false, _this.isPlaying = false, _this.isLoading = true, _this.loadOnReady = null, _this.startOnPlay = true, _this.seekOnPlay = null, _this.onDurationCalled = false, _this.getInternalPlayer = function (key) {
      if (!_this.player) return null;
      return _this.player[key];
    }, _this.progress = function () {
      if (_this.props.url && _this.player && _this.isReady) {
        var playedSeconds = _this.getCurrentTime() || 0;
        var loadedSeconds = _this.getSecondsLoaded();
        var duration = _this.getDuration();
        if (duration) {
          var progress = {
            playedSeconds: playedSeconds,
            played: playedSeconds / duration
          };
          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          }
          // Only call onProgress if values have changed
          if (progress.played !== _this.prevPlayed || progress.loaded !== _this.prevLoaded) {
            _this.props.onProgress(progress);
          }
          _this.prevPlayed = progress.played;
          _this.prevLoaded = progress.loaded;
        }
      }
      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
    }, _this.onReady = function () {
      if (!_this.mounted) return;
      _this.isReady = true;
      _this.isLoading = false;
      var _this$props = _this.props,
          onReady = _this$props.onReady,
          playing = _this$props.playing,
          volume = _this$props.volume,
          muted = _this$props.muted;

      onReady();
      if (!muted && volume !== null) {
        _this.player.setVolume(volume);
      }
      if (_this.loadOnReady) {
        _this.player.load(_this.loadOnReady, true);
        _this.loadOnReady = null;
      } else if (playing) {
        _this.player.play();
      }
      _this.onDurationCheck();
    }, _this.onPlay = function () {
      _this.isPlaying = true;
      _this.isLoading = false;
      var _this$props2 = _this.props,
          onStart = _this$props2.onStart,
          onPlay = _this$props2.onPlay,
          playbackRate = _this$props2.playbackRate;

      if (_this.startOnPlay) {
        if (_this.player.setPlaybackRate) {
          _this.player.setPlaybackRate(playbackRate);
        }
        onStart();
        _this.startOnPlay = false;
      }
      onPlay();
      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);
        _this.seekOnPlay = null;
      }
      _this.onDurationCheck();
    }, _this.onPause = function (e) {
      _this.isPlaying = false;
      if (!_this.isLoading) {
        _this.props.onPause(e);
      }
    }, _this.onEnded = function () {
      var _this$props3 = _this.props,
          activePlayer = _this$props3.activePlayer,
          loop = _this$props3.loop,
          onEnded = _this$props3.onEnded;

      if (activePlayer.loopOnEnded && loop) {
        _this.seekTo(0);
      }
      if (!loop) {
        _this.isPlaying = false;
        onEnded();
      }
    }, _this.onDurationCheck = function () {
      clearTimeout(_this.durationCheckTimeout);
      var duration = _this.getDuration();
      if (duration) {
        if (!_this.onDurationCalled) {
          _this.props.onDuration(duration);
          _this.onDurationCalled = true;
        }
      } else {
        _this.durationCheckTimeout = setTimeout(_this.onDurationCheck, 100);
      }
    }, _this.onLoaded = function () {
      // Sometimes we know loading has stopped but onReady/onPlay are never called
      // so this provides a way for players to avoid getting stuck
      _this.isLoading = false;
    }, _this.ref = function (player) {
      if (player) {
        _this.player = player;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  } // Track playing state internally to prevent bugs
  // Use isLoading to prevent onPause when switching URL


  _createClass(Player, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      this.player.load(this.props.url);
      this.progress();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
      clearTimeout(this.durationCheckTimeout);
      if (this.isReady) {
        this.player.stop();
      }
      if (this.player.disablePIP) {
        this.player.disablePIP();
      }
      this.mounted = false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      // Invoke player methods based on incoming props
      var _props = this.props,
          url = _props.url,
          playing = _props.playing,
          volume = _props.volume,
          muted = _props.muted,
          playbackRate = _props.playbackRate,
          pip = _props.pip;

      if (!(0, _utils.isEqual)(url, nextProps.url)) {
        if (this.isLoading) {
          console.warn('ReactPlayer: the attempt to load ' + nextProps.url + ' is being deferred until the player has loaded');
          this.loadOnReady = nextProps.url;
          return;
        }
        this.isLoading = true;
        this.startOnPlay = true;
        this.onDurationCalled = false;
        this.player.load(nextProps.url, this.isReady);
      }
      if (!playing && nextProps.playing && !this.isPlaying) {
        this.player.play();
      }
      if (playing && !nextProps.playing && this.isPlaying) {
        this.player.pause();
      }
      if (!pip && nextProps.pip && this.player.enablePIP) {
        this.player.enablePIP();
      } else if (pip && !nextProps.pip && this.player.disablePIP) {
        this.player.disablePIP();
      }
      if (volume !== nextProps.volume && nextProps.volume !== null) {
        this.player.setVolume(nextProps.volume);
      }
      if (muted !== nextProps.muted) {
        if (nextProps.muted) {
          this.player.mute();
        } else {
          this.player.unmute();
          if (nextProps.volume !== null) {
            // Set volume next tick to fix a bug with DailyMotion
            setTimeout(function () {
              return _this2.player.setVolume(nextProps.volume);
            });
          }
        }
      }
      if (playbackRate !== nextProps.playbackRate && this.player.setPlaybackRate) {
        this.player.setPlaybackRate(nextProps.playbackRate);
      }
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.getDuration();
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      if (!this.isReady) return null;
      return this.player.getCurrentTime();
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      if (!this.isReady) return null;
      return this.player.getSecondsLoaded();
    }
  }, {
    key: 'seekTo',
    value: function seekTo(amount) {
      var _this3 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady && amount !== 0) {
        this.seekOnPlay = amount;
        setTimeout(function () {
          _this3.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
        return;
      }
      if (amount > 0 && amount < 1) {
        // Convert fraction to seconds based on duration
        var duration = this.player.getDuration();
        if (!duration) {
          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
          return;
        }
        this.player.seekTo(duration * amount);
        return;
      }
      this.player.seekTo(amount);
    }
  }, {
    key: 'render',
    value: function render() {
      var Player = this.props.activePlayer;
      if (!Player) {
        return null;
      }
      return _react2['default'].createElement(Player, _extends({}, this.props, {
        ref: this.ref,
        onReady: this.onReady,
        onPlay: this.onPlay,
        onPause: this.onPause,
        onEnded: this.onEnded,
        onLoaded: this.onLoaded
      }));
    }
  }]);

  return Player;
}(_react.Component);

Player.displayName = 'Player';
Player.propTypes = _props2.propTypes;
Player.defaultProps = _props2.defaultProps;
exports['default'] = Player;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SoundCloud = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(145);

var _singlePlayer = __webpack_require__(227);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://w.soundcloud.com/player/api.js';
var SDK_GLOBAL = 'SC';
var MATCH_URL = /(soundcloud\.com|snd\.sc)\/.+$/;

var SoundCloud = exports.SoundCloud = function (_Component) {
  _inherits(SoundCloud, _Component);

  function SoundCloud() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SoundCloud);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.fractionLoaded = null, _this.mute = function () {
      _this.setVolume(0);
    }, _this.unmute = function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SoundCloud, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
        if (!_this2.iframe) return;
        var _SC$Widget$Events = SC.Widget.Events,
            PLAY = _SC$Widget$Events.PLAY,
            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
            PAUSE = _SC$Widget$Events.PAUSE,
            FINISH = _SC$Widget$Events.FINISH,
            ERROR = _SC$Widget$Events.ERROR;

        if (!isReady) {
          _this2.player = SC.Widget(_this2.iframe);
          _this2.player.bind(PLAY, _this2.props.onPlay);
          _this2.player.bind(PAUSE, _this2.props.onPause);
          _this2.player.bind(PLAY_PROGRESS, function (e) {
            _this2.currentTime = e.currentPosition / 1000;
            _this2.fractionLoaded = e.loadedProgress;
          });
          _this2.player.bind(FINISH, function () {
            return _this2.props.onEnded();
          });
          _this2.player.bind(ERROR, function (e) {
            return _this2.props.onError(e);
          });
        }
        _this2.player.load(url, _extends({}, _this2.props.config.soundcloud.options, {
          callback: function callback() {
            _this2.player.getDuration(function (duration) {
              _this2.duration = duration / 1000;
              _this2.props.onReady();
            });
          }
        }));
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seekTo', seconds * 1000);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.fractionLoaded * this.duration;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%'
      }, this.props.style);
      return _react2['default'].createElement('iframe', {
        ref: this.ref,
        src: 'https://w.soundcloud.com/player/?url=' + encodeURIComponent(this.props.url),
        style: style,
        frameBorder: 0
      });
    }
  }]);

  return SoundCloud;
}(_react.Component);

SoundCloud.displayName = 'SoundCloud';

SoundCloud.canPlay = function (url) {
  return MATCH_URL.test(url);
};

SoundCloud.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(SoundCloud);

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vimeo = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(145);

var _singlePlayer = __webpack_require__(227);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://player.vimeo.com/api/player.js';
var SDK_GLOBAL = 'Vimeo';
var MATCH_URL = /vimeo\.com\/.+/;
var MATCH_FILE_URL = /vimeo\.com\/external\/.+\.mp4/;

var Vimeo = exports.Vimeo = function (_Component) {
  _inherits(Vimeo, _Component);

  function Vimeo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Vimeo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
      _this.setVolume(0);
    }, _this.unmute = function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Vimeo, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      this.duration = null;
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
        if (!_this2.container) return;
        _this2.player = new Vimeo.Player(_this2.container, _extends({}, _this2.props.config.vimeo.playerOptions, {
          url: url,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          loop: _this2.props.loop
        }));
        _this2.player.ready().then(function () {
          var iframe = _this2.container.querySelector('iframe');
          iframe.style.width = '100%';
          iframe.style.height = '100%';
        })['catch'](_this2.props.onError);
        _this2.player.on('loaded', function () {
          _this2.props.onReady();
          _this2.refreshDuration();
        });
        _this2.player.on('play', function () {
          _this2.props.onPlay();
          _this2.refreshDuration();
        });
        _this2.player.on('pause', _this2.props.onPause);
        _this2.player.on('seeked', function (e) {
          return _this2.props.onSeek(e.seconds);
        });
        _this2.player.on('ended', _this2.props.onEnded);
        _this2.player.on('error', _this2.props.onError);
        _this2.player.on('timeupdate', function (_ref2) {
          var seconds = _ref2.seconds;

          _this2.currentTime = seconds;
        });
        _this2.player.on('progress', function (_ref3) {
          var seconds = _ref3.seconds;

          _this2.secondsLoaded = seconds;
        });
      }, this.props.onError);
    }
  }, {
    key: 'refreshDuration',
    value: function refreshDuration() {
      var _this3 = this;

      this.player.getDuration().then(function (duration) {
        _this3.duration = duration;
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.callPlayer('unload');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: 'black'
      }, this.props.style);
      return _react2['default'].createElement('div', {
        key: this.props.url,
        ref: this.ref,
        style: style
      });
    }
  }]);

  return Vimeo;
}(_react.Component);

Vimeo.displayName = 'Vimeo';

Vimeo.canPlay = function (url) {
  if (MATCH_FILE_URL.test(url)) {
    return false;
  }
  return MATCH_URL.test(url);
};

exports['default'] = (0, _singlePlayer2['default'])(Vimeo);

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DailyMotion = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(145);

var _singlePlayer = __webpack_require__(227);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://api.dmcdn.net/all.js';
var SDK_GLOBAL = 'DM';
var SDK_GLOBAL_READY = 'dmAsyncInit';
var MATCH_URL = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;

var DailyMotion = exports.DailyMotion = function (_Component) {
  _inherits(DailyMotion, _Component);

  function DailyMotion() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DailyMotion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DailyMotion.__proto__ || Object.getPrototypeOf(DailyMotion)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onDurationChange = function () {
      var duration = _this.getDuration();
      _this.props.onDuration(duration);
    }, _this.mute = function () {
      _this.callPlayer('setMuted', true);
    }, _this.unmute = function () {
      _this.callPlayer('setMuted', false);
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DailyMotion, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props = this.props,
          controls = _props.controls,
          config = _props.config,
          onError = _props.onError,
          playing = _props.playing;

      var _url$match = url.match(MATCH_URL),
          _url$match2 = _slicedToArray(_url$match, 2),
          id = _url$match2[1];

      if (this.player) {
        this.player.load(id, {
          start: (0, _utils.parseStartTime)(url),
          autoplay: playing
        });
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
        return DM.player;
      }).then(function (DM) {
        if (!_this2.container) return;
        var Player = DM.player;
        _this2.player = new Player(_this2.container, {
          width: '100%',
          height: '100%',
          video: id,
          params: _extends({
            controls: controls,
            autoplay: _this2.props.playing,
            mute: _this2.props.muted,
            start: (0, _utils.parseStartTime)(url),
            origin: window.location.origin
          }, config.dailymotion.params),
          events: {
            apiready: _this2.props.onReady,
            seeked: function seeked() {
              return _this2.props.onSeek(_this2.player.currentTime);
            },
            video_end: _this2.props.onEnded,
            durationchange: _this2.onDurationChange,
            pause: _this2.props.onPause,
            playing: _this2.props.onPlay,
            waiting: _this2.props.onBuffer,
            error: function error(event) {
              return onError(event);
            }
          }
        });
      }, onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.player.duration || null;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.player.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.player.bufferedTime;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = _extends({
        width: '100%',
        height: '100%',
        backgroundColor: 'black'
      }, this.props.style);
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('div', { ref: this.ref })
      );
    }
  }]);

  return DailyMotion;
}(_react.Component);

DailyMotion.displayName = 'DailyMotion';

DailyMotion.canPlay = function (url) {
  return MATCH_URL.test(url);
};

DailyMotion.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(DailyMotion);

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(985);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(987);
var createClass = __webpack_require__(146);

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var AutosizeInput = createClass({
	propTypes: {
		className: PropTypes.string, // className for the outer element
		defaultValue: PropTypes.any, // default field value
		inputClassName: PropTypes.string, // className for the input element
		inputRef: PropTypes.func, // ref callback for the input element
		inputStyle: PropTypes.object, // css styles for the input element
		minWidth: PropTypes.oneOfType([// minimum width for input element
		PropTypes.number, PropTypes.string]),
		onAutosize: PropTypes.func, // onAutosize handler: function(newWidth) {}
		onChange: PropTypes.func, // onChange handler: function(newValue) {}
		placeholder: PropTypes.string, // placeholder text
		placeholderIsMinWidth: PropTypes.bool, // don't collapse size to less than the placeholder
		style: PropTypes.object, // css styles for the outer element
		value: PropTypes.any },
	// field value
	getDefaultProps: function getDefaultProps() {
		return {
			minWidth: 1
		};
	},
	getInitialState: function getInitialState() {
		return {
			inputWidth: this.props.minWidth,
			inputId: '_' + Math.random().toString(36).substr(2, 12)
		};
	},
	componentDidMount: function componentDidMount() {
		this.mounted = true;
		this.copyInputStyles();
		this.updateInputWidth();
	},
	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		if (prevState.inputWidth !== this.state.inputWidth) {
			if (typeof this.props.onAutosize === 'function') {
				this.props.onAutosize(this.state.inputWidth);
			}
		}
		this.updateInputWidth();
	},
	componentWillUnmount: function componentWillUnmount() {
		this.mounted = false;
	},
	inputRef: function inputRef(el) {
		this.input = el;
		if (typeof this.props.inputRef === 'function') {
			this.props.inputRef(el);
		}
	},
	placeHolderSizerRef: function placeHolderSizerRef(el) {
		this.placeHolderSizer = el;
	},
	sizerRef: function sizerRef(el) {
		this.sizer = el;
	},
	copyInputStyles: function copyInputStyles() {
		if (!this.mounted || !window.getComputedStyle) {
			return;
		}
		var inputStyle = this.input && window.getComputedStyle(this.input);
		if (!inputStyle) {
			return;
		}
		var widthNode = this.sizer;
		widthNode.style.fontSize = inputStyle.fontSize;
		widthNode.style.fontFamily = inputStyle.fontFamily;
		widthNode.style.fontWeight = inputStyle.fontWeight;
		widthNode.style.fontStyle = inputStyle.fontStyle;
		widthNode.style.letterSpacing = inputStyle.letterSpacing;
		widthNode.style.textTransform = inputStyle.textTransform;
		if (this.props.placeholder) {
			var placeholderNode = this.placeHolderSizer;
			placeholderNode.style.fontSize = inputStyle.fontSize;
			placeholderNode.style.fontFamily = inputStyle.fontFamily;
			placeholderNode.style.fontWeight = inputStyle.fontWeight;
			placeholderNode.style.fontStyle = inputStyle.fontStyle;
			placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
			placeholderNode.style.textTransform = inputStyle.textTransform;
		}
	},
	updateInputWidth: function updateInputWidth() {
		if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
			return;
		}
		var newInputWidth = undefined;
		if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
			newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
		} else {
			newInputWidth = this.sizer.scrollWidth + 2;
		}
		if (newInputWidth < this.props.minWidth) {
			newInputWidth = this.props.minWidth;
		}
		if (newInputWidth !== this.state.inputWidth) {
			this.setState({
				inputWidth: newInputWidth
			});
		}
	},
	getInput: function getInput() {
		return this.input;
	},
	focus: function focus() {
		this.input.focus();
	},
	blur: function blur() {
		this.input.blur();
	},
	select: function select() {
		this.input.select();
	},
	render: function render() {
		var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
			if (previousValue !== null && previousValue !== undefined) {
				return previousValue;
			}
			return currentValue;
		});

		var wrapperStyle = this.props.style || {};
		if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
		var inputStyle = _extends({}, this.props.inputStyle);
		inputStyle.width = this.state.inputWidth + 'px';
		inputStyle.boxSizing = 'content-box';
		var inputProps = _extends({}, this.props);
		inputProps.className = this.props.inputClassName;
		inputProps.style = inputStyle;
		// ensure props meant for `AutosizeInput` don't end up on the `input`
		delete inputProps.inputClassName;
		delete inputProps.inputStyle;
		delete inputProps.minWidth;
		delete inputProps.onAutosize;
		delete inputProps.placeholderIsMinWidth;
		delete inputProps.inputRef;
		return React.createElement(
			'div',
			{ className: this.props.className, style: wrapperStyle },
			React.createElement('style', { dangerouslySetInnerHTML: {
					__html: ['input#' + this.state.id + '::-ms-clear {display: none;}'].join('\n')
				} }),
			React.createElement('input', _extends({ id: this.state.id }, inputProps, { ref: this.inputRef })),
			React.createElement(
				'div',
				{ ref: this.sizerRef, style: sizerStyle },
				sizerValue
			),
			this.props.placeholder ? React.createElement(
				'div',
				{ ref: this.placeHolderSizerRef, style: sizerStyle },
				this.props.placeholder
			) : null
		);
	}
});

module.exports = AutosizeInput;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(988)();
}


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(989);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports["default"] = arrowRenderer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return _react2["default"].createElement("span", {
		className: "Select-arrow",
		onMouseDown: onMouseDown
	});
}

;
module.exports = exports["default"];

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = clearRenderer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function clearRenderer() {
	return _react2['default'].createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
}

;
module.exports = exports['default'];

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(220);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(52);

var _Select2 = _interopRequireDefault(_Select);

var _utilsStripDiacritics = __webpack_require__(614);

var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);

var propTypes = {
	autoload: _propTypes2['default'].bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: _propTypes2['default'].any, // object to use to cache results; set to null/false to disable caching
	children: _propTypes2['default'].func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: _propTypes2['default'].bool, // strip diacritics when filtering; defaults to true
	ignoreCase: _propTypes2['default'].bool, // perform case-insensitive filtering; defaults to true
	loadingPlaceholder: _propTypes2['default'].oneOfType([// replaces the placeholder while options are loading
	_propTypes2['default'].string, _propTypes2['default'].node]),
	loadOptions: _propTypes2['default'].func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	multi: _propTypes2['default'].bool, // multi-value input
	options: _propTypes2['default'].array.isRequired, // array of options
	placeholder: _propTypes2['default'].oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	_propTypes2['default'].string, _propTypes2['default'].node]),
	noResultsText: _propTypes2['default'].oneOfType([// field noResultsText, displayed when no options come back from the server
	_propTypes2['default'].string, _propTypes2['default'].node]),
	onChange: _propTypes2['default'].func, // onChange handler: function (newValue) {}
	searchPromptText: _propTypes2['default'].oneOfType([// label to prompt for search input
	_propTypes2['default'].string, _propTypes2['default'].node]),
	onInputChange: _propTypes2['default'].func, // optional for keeping track of what is being typed
	value: _propTypes2['default'].any };

// initial field value
var defaultCache = {};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = (function (_Component) {
	_inherits(Async, _Component);

	function Async(props, context) {
		_classCallCheck(this, Async);

		_get(Object.getPrototypeOf(Async.prototype), 'constructor', this).call(this, props, context);

		this._cache = props.cache === defaultCache ? {} : props.cache;

		this.state = {
			isLoading: false,
			options: props.options
		};

		this._onInputChange = this._onInputChange.bind(this);
	}

	_createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;

			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps, nextState) {
			var _this = this;

			var propertiesToSync = ['options'];
			propertiesToSync.forEach(function (prop) {
				if (_this.props[prop] !== nextProps[prop]) {
					_this.setState(_defineProperty({}, prop, nextProps[prop]));
				}
			});
		}
	}, {
		key: 'clearOptions',
		value: function clearOptions() {
			this.setState({ options: [] });
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && cache.hasOwnProperty(inputValue)) {
				this.setState({
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				if (callback === _this2._callback) {
					_this2._callback = null;

					var options = data && data.options || [];

					if (cache) {
						cache[inputValue] = options;
					}

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}

			return inputValue;
		}
	}, {
		key: '_onInputChange',
		value: function _onInputChange(inputValue) {
			var _props = this.props;
			var ignoreAccents = _props.ignoreAccents;
			var ignoreCase = _props.ignoreCase;
			var onInputChange = _props.onInputChange;

			if (ignoreAccents) {
				inputValue = (0, _utilsStripDiacritics2['default'])(inputValue);
			}

			if (ignoreCase) {
				inputValue = inputValue.toLowerCase();
			}

			if (onInputChange) {
				onInputChange(inputValue);
			}

			return this.loadOptions(inputValue);
		}
	}, {
		key: 'inputValue',
		value: function inputValue() {
			if (this.select) {
				return this.select.state.inputValue;
			}
			return '';
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props;
			var loadingPlaceholder = _props2.loadingPlaceholder;
			var noResultsText = _props2.noResultsText;
			var searchPromptText = _props2.searchPromptText;
			var isLoading = this.state.isLoading;

			var inputValue = this.inputValue();

			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props;
			var children = _props3.children;
			var loadingPlaceholder = _props3.loadingPlaceholder;
			var placeholder = _props3.placeholder;
			var _state = this.state;
			var isLoading = _state.isLoading;
			var options = _state.options;

			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				},
				onChange: function onChange(newValues) {
					if (_this3.props.multi && _this3.props.value && newValues.length > _this3.props.value.length) {
						_this3.clearOptions();
					}
					_this3.props.onChange(newValues);
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this._onInputChange
			}));
		}
	}]);

	return Async;
})(_react.Component);

exports['default'] = Async;

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

function defaultChildren(props) {
	return _react2['default'].createElement(_Select2['default'], props);
}
module.exports = exports['default'];

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(146);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _Select = __webpack_require__(52);

var _Select2 = _interopRequireDefault(_Select);

function reduce(obj) {
	var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	return Object.keys(obj).reduce(function (props, key) {
		var value = obj[key];
		if (value !== undefined) props[key] = value;
		return props;
	}, props);
}

var AsyncCreatable = (0, _createReactClass2['default'])({
	displayName: 'AsyncCreatableSelect',

	focus: function focus() {
		this.select.focus();
	},

	render: function render() {
		var _this = this;

		return _react2['default'].createElement(
			_Select2['default'].Async,
			this.props,
			function (asyncProps) {
				return _react2['default'].createElement(
					_Select2['default'].Creatable,
					_this.props,
					function (creatableProps) {
						return _react2['default'].createElement(_Select2['default'], _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
							onInputChange: function (input) {
								creatableProps.onInputChange(input);
								return asyncProps.onInputChange(input);
							},
							ref: function (ref) {
								_this.select = ref;
								creatableProps.ref(ref);
								asyncProps.ref(ref);
							}
						}));
					}
				);
			}
		);
	}
});

module.exports = AsyncCreatable;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(146);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(220);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(52);

var _Select2 = _interopRequireDefault(_Select);

var _utilsDefaultFilterOptions = __webpack_require__(613);

var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);

var _utilsDefaultMenuRenderer = __webpack_require__(615);

var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);

var Creatable = (0, _createReactClass2['default'])({
	displayName: 'CreatableSelect',

	propTypes: {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2['default'].func,

		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2['default'].any,

		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2['default'].func,

		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2['default'].func,

		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2['default'].any,

		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2['default'].func,

		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2['default'].func,

		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2['default'].func,

		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2['default'].func,

		// See Select.propTypes.options
		options: _propTypes2['default'].array,

		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2['default'].func,

		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2['default'].func
	},

	// Default prop methods
	statics: {
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	},

	getDefaultProps: function getDefaultProps() {
		return {
			filterOptions: _utilsDefaultFilterOptions2['default'],
			isOptionUnique: isOptionUnique,
			isValidNewOption: isValidNewOption,
			menuRenderer: _utilsDefaultMenuRenderer2['default'],
			newOptionCreator: newOptionCreator,
			promptTextCreator: promptTextCreator,
			shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
		};
	},

	createNewOption: function createNewOption() {
		var _props = this.props;
		var isValidNewOption = _props.isValidNewOption;
		var newOptionCreator = _props.newOptionCreator;
		var onNewOptionClick = _props.onNewOptionClick;
		var _props$options = _props.options;
		var options = _props$options === undefined ? [] : _props$options;
		var shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;

		if (isValidNewOption({ label: this.inputValue })) {
			var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
			var _isOptionUnique = this.isOptionUnique({ option: option });

			// Don't add the same option twice.
			if (_isOptionUnique) {
				if (onNewOptionClick) {
					onNewOptionClick(option);
				} else {
					options.unshift(option);

					this.select.selectValue(option);
				}
			}
		}
	},

	filterOptions: function filterOptions() {
		var _props2 = this.props;
		var filterOptions = _props2.filterOptions;
		var isValidNewOption = _props2.isValidNewOption;
		var options = _props2.options;
		var promptTextCreator = _props2.promptTextCreator;

		// TRICKY Check currently selected options as well.
		// Don't display a create-prompt for a value that's selected.
		// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
		var excludeOptions = arguments[2] || [];

		var filteredOptions = filterOptions.apply(undefined, arguments) || [];

		if (isValidNewOption({ label: this.inputValue })) {
			var _newOptionCreator = this.props.newOptionCreator;

			var option = _newOptionCreator({
				label: this.inputValue,
				labelKey: this.labelKey,
				valueKey: this.valueKey
			});

			// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
			// For multi-selects, this would remove it from the filtered list.
			var _isOptionUnique2 = this.isOptionUnique({
				option: option,
				options: excludeOptions.concat(filteredOptions)
			});

			if (_isOptionUnique2) {
				var _prompt = promptTextCreator(this.inputValue);

				this._createPlaceholderOption = _newOptionCreator({
					label: _prompt,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				filteredOptions.unshift(this._createPlaceholderOption);
			}
		}

		return filteredOptions;
	},

	isOptionUnique: function isOptionUnique(_ref2) {
		var option = _ref2.option;
		var options = _ref2.options;
		var isOptionUnique = this.props.isOptionUnique;

		options = options || this.select.filterOptions();

		return isOptionUnique({
			labelKey: this.labelKey,
			option: option,
			options: options,
			valueKey: this.valueKey
		});
	},

	menuRenderer: function menuRenderer(params) {
		var menuRenderer = this.props.menuRenderer;

		return menuRenderer(_extends({}, params, {
			onSelect: this.onOptionSelect,
			selectValue: this.onOptionSelect
		}));
	},

	onInputChange: function onInputChange(input) {
		var onInputChange = this.props.onInputChange;

		if (onInputChange) {
			onInputChange(input);
		}

		// This value may be needed in between Select mounts (when this.select is null)
		this.inputValue = input;
	},

	onInputKeyDown: function onInputKeyDown(event) {
		var _props3 = this.props;
		var shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption;
		var onInputKeyDown = _props3.onInputKeyDown;

		var focusedOption = this.select.getFocusedOption();

		if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
			this.createNewOption();

			// Prevent decorated Select from doing anything additional with this keyDown event
			event.preventDefault();
		} else if (onInputKeyDown) {
			onInputKeyDown(event);
		}
	},

	onOptionSelect: function onOptionSelect(option, event) {
		if (option === this._createPlaceholderOption) {
			this.createNewOption();
		} else {
			this.select.selectValue(option);
		}
	},

	focus: function focus() {
		this.select.focus();
	},

	render: function render() {
		var _this = this;

		var _props4 = this.props;
		var newOptionCreator = _props4.newOptionCreator;
		var shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption;

		var restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);

		var children = this.props.children;

		// We can't use destructuring default values to set the children,
		// because it won't apply work if `children` is null. A falsy check is
		// more reliable in real world use-cases.
		if (!children) {
			children = defaultChildren;
		}

		var props = _extends({}, restProps, {
			allowCreate: true,
			filterOptions: this.filterOptions,
			menuRenderer: this.menuRenderer,
			onInputChange: this.onInputChange,
			onInputKeyDown: this.onInputKeyDown,
			ref: function ref(_ref) {
				_this.select = _ref;

				// These values may be needed in between Select mounts (when this.select is null)
				if (_ref) {
					_this.labelKey = _ref.props.labelKey;
					_this.valueKey = _ref.props.valueKey;
				}
			}
		});

		return children(props);
	}
});

function defaultChildren(props) {
	return _react2['default'].createElement(_Select2['default'], props);
};

function isOptionUnique(_ref3) {
	var option = _ref3.option;
	var options = _ref3.options;
	var labelKey = _ref3.labelKey;
	var valueKey = _ref3.valueKey;

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

function isValidNewOption(_ref4) {
	var label = _ref4.label;

	return !!label;
};

function newOptionCreator(_ref5) {
	var label = _ref5.label;
	var labelKey = _ref5.labelKey;
	var valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';
	return option;
};

function promptTextCreator(label) {
	return 'Create option "' + label + '"';
}

function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
	}

	return false;
};

module.exports = Creatable;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(146);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(220);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(249);

var _classnames2 = _interopRequireDefault(_classnames);

var Option = (0, _createReactClass2['default'])({
	propTypes: {
		children: _propTypes2['default'].node,
		className: _propTypes2['default'].string, // className (based on mouse position)
		instancePrefix: _propTypes2['default'].string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2['default'].bool, // the option is disabled
		isFocused: _propTypes2['default'].bool, // the option is focused
		isSelected: _propTypes2['default'].bool, // the option is selected
		onFocus: _propTypes2['default'].func, // method to handle mouseEnter on option element
		onSelect: _propTypes2['default'].func, // method to handle click on option element
		onUnfocus: _propTypes2['default'].func, // method to handle mouseLeave on option element
		option: _propTypes2['default'].object.isRequired, // object that is base for that option
		optionIndex: _propTypes2['default'].number },
	// index of the option, used to generate unique ids for aria
	blockEvent: function blockEvent(event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	},

	handleMouseDown: function handleMouseDown(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
	},

	handleMouseEnter: function handleMouseEnter(event) {
		this.onFocus(event);
	},

	handleMouseMove: function handleMouseMove(event) {
		this.onFocus(event);
	},

	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		this.handleMouseDown(event);
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	onFocus: function onFocus(event) {
		if (!this.props.isFocused) {
			this.props.onFocus(this.props.option, event);
		}
	},
	render: function render() {
		var _props = this.props;
		var option = _props.option;
		var instancePrefix = _props.instancePrefix;
		var optionIndex = _props.optionIndex;

		var className = (0, _classnames2['default'])(this.props.className, option.className);

		return option.disabled ? _react2['default'].createElement(
			'div',
			{ className: className,
				onMouseDown: this.blockEvent,
				onClick: this.blockEvent },
			this.props.children
		) : _react2['default'].createElement(
			'div',
			{ className: className,
				style: option.style,
				role: 'option',
				onMouseDown: this.handleMouseDown,
				onMouseEnter: this.handleMouseEnter,
				onMouseMove: this.handleMouseMove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEnd,
				id: instancePrefix + '-option-' + optionIndex,
				title: option.title },
			this.props.children
		);
	}
});

module.exports = Option;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(146);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(220);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(249);

var _classnames2 = _interopRequireDefault(_classnames);

var Value = (0, _createReactClass2['default'])({

	displayName: 'Value',

	propTypes: {
		children: _propTypes2['default'].node,
		disabled: _propTypes2['default'].bool, // disabled prop passed to ReactSelect
		id: _propTypes2['default'].string, // Unique id for the value - used for aria
		onClick: _propTypes2['default'].func, // method to handle click on value label
		onRemove: _propTypes2['default'].func, // method to handle removal of the value
		value: _propTypes2['default'].object.isRequired },

	// the option object for this value
	handleMouseDown: function handleMouseDown(event) {
		if (event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		if (this.props.onClick) {
			event.stopPropagation();
			this.props.onClick(this.props.value, event);
			return;
		}
		if (this.props.value.href) {
			event.stopPropagation();
		}
	},

	onRemove: function onRemove(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onRemove(this.props.value);
	},

	handleTouchEndRemove: function handleTouchEndRemove(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.onRemove(event);
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	renderRemoveIcon: function renderRemoveIcon() {
		if (this.props.disabled || !this.props.onRemove) return;
		return _react2['default'].createElement(
			'span',
			{ className: 'Select-value-icon',
				'aria-hidden': 'true',
				onMouseDown: this.onRemove,
				onTouchEnd: this.handleTouchEndRemove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove },
			'×'
		);
	},

	renderLabel: function renderLabel() {
		var className = 'Select-value-label';
		return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
			'a',
			{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
			this.props.children
		) : _react2['default'].createElement(
			'span',
			{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
			this.props.children
		);
	},

	render: function render() {
		return _react2['default'].createElement(
			'div',
			{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
				style: this.props.value.style,
				title: this.props.value.title
			},
			this.renderRemoveIcon(),
			this.renderLabel()
		);
	}

});

module.exports = Value;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// {K1: V1, K2: V2, ...} -> [[K1, V1], [K2, V2]]


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var objectToPairs = function objectToPairs(obj) {
    return Object.keys(obj).map(function (key) {
        return [key, obj[key]];
    });
};

exports.objectToPairs = objectToPairs;
// [[K1, V1], [K2, V2]] -> {K1: V1, K2: V2, ...}
var pairsToObject = function pairsToObject(pairs) {
    var result = {};
    pairs.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2);

        var key = _ref2[0];
        var val = _ref2[1];

        result[key] = val;
    });
    return result;
};

var mapObj = function mapObj(obj, fn) {
    return pairsToObject(objectToPairs(obj).map(fn));
};

exports.mapObj = mapObj;
// Flattens an array one level
// [[A], [B, C, [D]]] -> [A, B, C, [D]]
var flatten = function flatten(list) {
    return list.reduce(function (memo, x) {
        return memo.concat(x);
    }, []);
};

exports.flatten = flatten;
var UPPERCASE_RE = /([A-Z])/g;
var MS_RE = /^ms-/;

var kebabify = function kebabify(string) {
    return string.replace(UPPERCASE_RE, '-$1').toLowerCase();
};
var kebabifyStyleName = function kebabifyStyleName(string) {
    return kebabify(string).replace(MS_RE, '-ms-');
};

exports.kebabifyStyleName = kebabifyStyleName;
var recursiveMerge = function recursiveMerge(a, b) {
    // TODO(jlfwong): Handle malformed input where a and b are not the same
    // type.

    if (typeof a !== 'object') {
        return b;
    }

    var ret = _extends({}, a);

    Object.keys(b).forEach(function (key) {
        if (ret.hasOwnProperty(key)) {
            ret[key] = recursiveMerge(a[key], b[key]);
        } else {
            ret[key] = b[key];
        }
    });

    return ret;
};

exports.recursiveMerge = recursiveMerge;
/**
 * CSS properties which accept numbers but are not in units of "px".
 * Taken from React's CSSProperty.js
 */
var isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridColumn: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,

    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};

/**
 * Taken from React's CSSProperty.js
 *
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 * Taken from React's CSSProperty.js
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
// Taken from React's CSSProperty.js
Object.keys(isUnitlessNumber).forEach(function (prop) {
    prefixes.forEach(function (prefix) {
        isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
    });
});

var stringifyValue = function stringifyValue(key, prop) {
    if (typeof prop === "number") {
        if (isUnitlessNumber[key]) {
            return "" + prop;
        } else {
            return prop + "px";
        }
    } else {
        return prop;
    }
};

exports.stringifyValue = stringifyValue;
/**
 * JS Implementation of MurmurHash2
 *
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/murmurhash-js
 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
 * @see http://sites.google.com/site/murmurhash/
 *
 * @param {string} str ASCII only
 * @return {string} Base 36 encoded hash result
 */
function murmurhash2_32_gc(str) {
    var l = str.length;
    var h = l;
    var i = 0;
    var k = undefined;

    while (l >= 4) {
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

        l -= 4;
        ++i;
    }

    switch (l) {
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }

    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;

    return (h >>> 0).toString(36);
}

// Hash a javascript object using JSON.stringify. This is very fast, about 3
// microseconds on my computer for a sample object:
// http://jsperf.com/test-hashfnv32a-hash/5
//
// Note that this uses JSON.stringify to stringify the objects so in order for
// this to produce consistent hashes browsers need to have a consistent
// ordering of objects. Ben Alpert says that Facebook depends on this, so we
// can probably depend on this too.
var hashObject = function hashObject(object) {
    return murmurhash2_32_gc(JSON.stringify(object));
};

exports.hashObject = hashObject;
var IMPORTANT_RE = /^([^:]+:.*?)( !important)?;$/;

// Given a single style rule string like "a: b;", adds !important to generate
// "a: b !important;".
var importantify = function importantify(string) {
    return string.replace(IMPORTANT_RE, function (_, base, important) {
        return base + " !important;";
    });
};
exports.importantify = importantify;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  if (Array.isArray(value)) value = value.join(',');

  return value.match(/-webkit-|-moz-|-ms-/) !== null;
};

module.exports = exports['default'];

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(1051),
    getPrototype = __webpack_require__(2861),
    isObjectLike = __webpack_require__(874);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(2867),
    getValue = __webpack_require__(2870);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * Bowser - a browser detector
  * https://github.com/ded/bowser
  * MIT License | (c) Dustin Diaz 2014
  */

!function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports['browser'] = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
}('bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , result

    if (/opera|opr/i.test(ua)) {
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/windows phone/i.test(ua)) {
      result = {
        name: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    }
    else if (/chrome.+? edge/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (/sailfish/i.test(ua)) {
      result = {
        name: 'Sailfish'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
      }
    }
    else if (/silk/i.test(ua)) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
      , version: versionIdentifier
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/(web|hpw)os/i.test(ua)) {
      result = {
        name: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (/tizen/i.test(ua)) {
      result = {
        name: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/safari/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      , version: versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      result.name = result.name || "Webkit"
      result.webkit = t
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.msedge && (android || result.silk)) {
      result.android = t
    } else if (iosdevice) {
      result[iosdevice] = t
      result.ios = t
    }

    // OS version extraction
    var osVersion = '';
    if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = osVersion.split('.')[0];
    if (tablet || iosdevice == 'ipad' || (android && (osMajorVersion == 3 || (osMajorVersion == 4 && !mobile))) || result.silk) {
      result.tablet = t
    } else if (mobile || iosdevice == 'iphone' || iosdevice == 'ipod' || android || result.blackberry || result.webos || result.bada) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.chrome && result.version >= 20) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  return bowser
});


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
                                    value: true
});
exports.onUserInput = undefined;

var _redux = __webpack_require__(131);

var _actionCreatorFactory = __webpack_require__(1256);

var _ramda = __webpack_require__(2);

var giveInputToReducerOnChange = (0, _ramda.curry)(function (component, actions, input) {
                                    return (0, _actionCreatorFactory.actionCreatorFactory)(actions[component], input);
});

var onUserInput = exports.onUserInput = (0, _ramda.curry)(function (dispatch, actions, component) {
                                    return (0, _redux.compose)(dispatch, giveInputToReducerOnChange(component, actions));
});

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _materialUi = __webpack_require__(3);

var _reactDayPicker = __webpack_require__(1954);

var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);

var _reactRedux = __webpack_require__(6);

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  errorText: _react.PropTypes.string,
  hintText: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  textFieldStyle: _react.PropTypes.object,
  containerStyle: _react.PropTypes.object,
  closeOnSelect: _react.PropTypes.bool,
  id: _react.PropTypes.string,
  'data-cy': _react.PropTypes.string,
  floatingLabelText: _react.PropTypes.string,
  initialMonth: _react.PropTypes.any,
  renderDay: _react.PropTypes.func,
  value: _react.PropTypes.any,
  locale: _react.PropTypes.string,
  disabledRanges: _react.PropTypes.array,
  enableFrom: _react.PropTypes.any,
  enableTo: _react.PropTypes.any,
  disabled: _react.PropTypes.bool
};

var DatePicker = function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker(props) {
    _classCallCheck(this, DatePicker);

    var _this2 = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

    _initialiseProps.call(_this2);

    _moment2.default.locale(props.locale);
    var dateFormat = props.locale && props.locale.toLowerCase() === 'en-us' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
    _this2.state = {
      open: false,
      dateFormat: dateFormat,
      id: props.id || _nodeUuid2.default.v1(),
      value: props.value ? _moment2.default.utc(props.value).format(dateFormat) : ''
    };
    return _this2;
  }

  _createClass(DatePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.locale !== nextProps.locale || this.props.value !== nextProps.value) {
        _moment2.default.locale(nextProps.locale);
        var dateFormat = nextProps.locale === 'en-US' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
        this.setState({
          open: false,
          dateFormat: dateFormat,
          value: nextProps.value ? _moment2.default.utc(nextProps.value).format(dateFormat) : ''
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          errorText = _props.errorText,
          hintText = _props.hintText,
          floatingLabelText = _props.floatingLabelText,
          textFieldStyle = _props.textFieldStyle,
          underlineStyle = _props.underlineStyle,
          containerStyle = _props.containerStyle,
          initialMonth = _props.initialMonth,
          id = _props.id,
          disabled = _props.disabled;
      var _state = this.state,
          value = _state.value,
          open = _state.open,
          anchorEl = _state.anchorEl,
          dateFormat = _state.dateFormat;

      var selectedDay = this._getDateObject(value);
      return _react2.default.createElement(
        'div',
        { style: containerStyle },
        _react2.default.createElement(
          'div',
          { style: { display: 'inline-block', width: '70%' } },
          _react2.default.createElement(_materialUi.TextField, {
            id: this.state.id,
            disabled: disabled,
            'data-cy': this.props['data-cy'],
            style: _extends({ height: '48px' }, textFieldStyle),
            hintStyle: { top: '15px' },
            floatingLabelStyle: { top: '15px' },
            inputStyle: { top: '-12px' },
            errorText: errorText || this.state.errorText,
            value: value,
            hintText: hintText ? hintText : dateFormat,
            floatingLabelShrinkStyle: { color: 'rgba(0, 0, 0, 0.64)' },
            floatingLabelText: floatingLabelText,
            onChange: this.handleInputChange,
            onBlur: this._handleOnBlur,
            underlineStyle: underlineStyle
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { display: 'inline-block', height: '48px', verticalAlign: 'top' } },
          _react2.default.createElement(_materialUi.FontIcon, {
            style: { fontSize: '20px', cursor: disabled ? 'not-allowed' : 'pointer', position: 'relative', top: floatingLabelText ? '22px' : '0' },
            onClick: this._popDayPicker,
            color: disabled ? '#e0e0e0' : '',
            className: 'tc-icon-date_range'
          })
        ),
        _react2.default.createElement(
          _materialUi.Popover,
          {
            open: open,
            onRequestClose: function onRequestClose() {
              return _this3.setState({ open: false });
            },
            anchorEl: anchorEl,
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' }
          },
          _react2.default.createElement(_reactDayPicker2.default, {
            ref: 'daypicker',
            initialMonth: initialMonth ? new Date(this._getDateFromUTC(initialMonth)) : new Date(),
            modifiers: {
              selected: function selected(day) {
                return (0, _moment2.default)(selectedDay).isSame(day, 'day');
              },
              disabled: function disabled(day) {
                return _this3._checkIfDisabled(day);
              }
            },
            renderDay: this.props.renderDay,
            onDayClick: this.handleDayClick
          })
        )
      );
    }
  }]);

  return DatePicker;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleDayClick = function (day) {
    var utcDay = _this4._getUTCDay(day);
    if (_this4._checkIfDisabled(day)) {
      alert('This date is not available.');
    } else {
      _this4.setState({
        value: _moment2.default.utc(utcDay).format(_this4.state.dateFormat),
        open: !_this4.props.closeOnSelect,
        errorText: ''
      });
      _this4.props.onChange(_moment2.default.utc(utcDay).format());
    }
  };

  this._popDayPicker = function (e) {
    var _this = _this4;
    if (!_this.props.disabled) {
      _this.setState({
        open: true,
        anchorEl: e.currentTarget
      });
    }
  };

  this._getDateObject = function (string) {
    var dateFormat = _this4.state.dateFormat;

    var monthDayYear = {};
    if (!string) return string;
    var splitArray = string.split('/');
    if (splitArray.length < 3) return string;
    if (!(splitArray[2] && (splitArray[2].length === 2 || splitArray[2].length === 4))) return string;
    if (dateFormat === 'MM/DD/YYYY') {
      monthDayYear = {
        month: parseInt(splitArray[0], 10) - 1,
        day: splitArray[1],
        year: splitArray[2] && splitArray[2].length === 2 ? '20' + splitArray[2] : splitArray[2]
      };
    }
    if (dateFormat === 'DD/MM/YYYY') {
      monthDayYear = {
        day: splitArray[0],
        month: parseInt(splitArray[1], 10) - 1,
        year: splitArray[2] && splitArray[2].length === 2 ? '20' + splitArray[2] : splitArray[2]
      };
    }
    if (monthDayYear.day > 31 || monthDayYear.month > 11) return undefined;
    var newDate = new Date(monthDayYear.year, monthDayYear.month, monthDayYear.day);
    return newDate;
  };

  this.handleInputChange = function (e) {
    var value = e.target.value;

    _this4.setState({
      value: value,
      errorText: ''
    });
  };

  this._handleOnBlur = function (e) {
    var value = e.target.value;

    var updatedValue = _this4._getDateObject(value);
    if (!value) {
      _this4.setState({
        value: value,
        errorText: ''
      });
      _this4.props.onChange('');
    } else if (updatedValue && _moment2.default.isDate(updatedValue) && (0, _moment2.default)(updatedValue).isValid() && !_this4._checkIfDisabled(updatedValue)) {
      var utcDay = _moment2.default.utc(_this4._getUTCDay(updatedValue)).format();
      _this4.setState({
        value: (0, _moment2.default)(updatedValue).format(_this4.state.dateFormat),
        errorText: ''
      });
      _this4.props.onChange(utcDay);
    } else {
      _this4.setState({ errorText: 'Invalid date.' });
    }
  };

  this._isDayInRange = function (day, range, inclusive) {
    if (range.from && range.to) return (0, _moment2.default)(day).isBetween(range.from, range.to, 'day', inclusive ? '[]' : '()');
    if (range.from) return (0, _moment2.default)(day).isSame(_this4._getDateFromUTC(range.from), 'day');
    return false;
  };

  this._checkIfDisabled = function (day) {
    var _props2 = _this4.props,
        disabledRanges = _props2.disabledRanges,
        enableFrom = _props2.enableFrom,
        enableTo = _props2.enableTo;

    return (disabledRanges || []).some(function (range) {
      if (range.from && range.to) return _this4._isDayInRange(day, range, true);
      return (0, _moment2.default)(day).isSame(range, 'day');
    }) || (0, _moment2.default)(day).isBefore(_this4._getDateFromUTC(enableFrom) || new Date('1000-01-31'), 'day') || (0, _moment2.default)(day).isAfter(_this4._getDateFromUTC(enableTo) || new Date('11000-01-31'), 'day');
  };

  this._getDateFromUTC = function (date) {
    var dateObject = new Date(date);
    return new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate());
  };

  this._getUTCDay = function (day) {
    return new Date(Date.UTC(day.getFullYear(), day.getMonth(), day.getDate()));
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var config = _ref.config;

  return {
    locale: config.toJS().locale
  };
};

DatePicker.propTypes = propTypes;

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DatePicker);

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _contractActivitiesProductsActions = __webpack_require__(493);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SyncSectionCheckbox = function SyncSectionCheckbox(_ref) {
  var sectionInEdit = _ref.sectionInEdit,
      label = _ref.label,
      style = _ref.style,
      labelStyle = _ref.labelStyle,
      _onCheck = _ref.onCheck,
      syncedSectionsImmu = _ref.syncedSectionsImmu;

  var syncedSections = syncedSectionsImmu ? syncedSectionsImmu.toJS() : [];
  return _react2.default.createElement(_materialUi.Checkbox, {
    label: label || 'Sync to Other Products',
    style: style,
    labelStyle: labelStyle,
    checked: _ramda2.default.contains(sectionInEdit, syncedSections),
    onCheck: function onCheck(_, inputChecked) {
      return _onCheck(sectionInEdit, inputChecked);
    }
  });
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    syncedSectionsImmu: contracting.contractActivitiesProducts.getIn(['leftNav', 'syncedSections'])
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onCheck: function onCheck() {
      return dispatch(_contractActivitiesProductsActions.onCheckSyncSection.apply(undefined, arguments));
    }
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SyncSectionCheckbox);

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCReportProps = updateCReportProps;
exports.submitReportSugg = submitReportSugg;
exports.getAvailDocsForDiffReport = getAvailDocsForDiffReport;
exports.getDiffReport = getDiffReport;
exports.clearStore = clearStore;

var _constants = __webpack_require__(1847);

var constants = _interopRequireWildcard(_constants);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function updateCReportProps(payload) {
  return { type: constants.UPDATE_CREPORTS_PROP, payload: payload };
}

function submitReportSugg(payload, companyName) {
  return function (dispatch) {
    dispatch({ type: constants.SENDING_REPORT_SUGG });
    return fetch('/proxy/contracting/reportSugg', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ suggestion: payload, companyName: companyName })
    }).then(_checkStatus2.default).then(function () {
      return dispatch({ type: constants.SENT_REPORT_SUGG });
    }).catch(function (err) {
      return console.log('err in sending report suggestion', err);
    });
  };
}

function getAvailDocsForDiffReport(_ref) {
  var collection = _ref.collection,
      locationId = _ref.locationId,
      buyerId = _ref.buyerId,
      email = _ref.email;

  return { type: 'GET_AVAIL_DOCS_FOR_DIFF_REPORTS', payload: { collection: collection, locationId: locationId, buyerId: buyerId, email: email } };
}

function getDiffReport(docs) {
  return { type: constants.GET_CONTRACTING_DIFF_REPORT, payload: { docs: docs } };
}

function clearStore() {
  return { type: constants.CLEAR_STORE };
}

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var teams = exports.teams = ['admin', 'contracting'];

var permissionTypes = exports.permissionTypes = [{
  label: 'Profile',
  value: 'profile',
  hintTextMultiLoc: 'Gives the user profile access to the selected locations.',
  hintTextSingleLoc: 'Gives the user access to the profile.'
}, {
  label: 'User Management',
  value: 'admin',
  hintTextMultiLoc: 'Gives the user access to the selected locations.',
  hintTextSingleLoc: 'Gives the user access to user management.'
}, {
  label: 'Contracting',
  value: 'contracting',
  hintTextMultiLoc: 'Gives the user contracting access to the selected locations.',
  hintTextSingleLoc: 'Gives the user contracting access.'
}];

var availableAccess = exports.availableAccess = [{
  label: 'Read and Write',
  value: ['read', 'write']
}, {
  label: 'Read Only',
  value: ['read']
}, {
  label: 'No Access',
  value: []
}];

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPost = undefined;
exports.updateProps = updateProps;

var _constants = __webpack_require__(1105);

var constants = _interopRequireWildcard(_constants);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _http = __webpack_require__(118);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function updateProps(payload) {
  return { type: constants.UPDATE_POST_PAGE_PROP, payload: payload };
}

var getPost = exports.getPost = function getPost(postId) {
  return function (dispatch, getState) {
    var userId = getState().user && getState().user.get('id') ? getState().user.get('id') : undefined;
    dispatch({ type: constants.GET_POST_STARTED });
    return (0, _http.get)('/proxy/post/' + postId).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.error) return dispatch({ type: constants.GET_POST_FAILED, payload: response });
      return dispatch({ type: constants.GOT_POST, payload: _ramda2.default.merge(response, { didUserLike: _ramda2.default.contains(userId, response.userIdsOfLikes || []) }) });
    }).catch(function (err) {
      console.log(err.stack);
      dispatch({ type: constants.GET_POST_FAILED });
    });
  };
};

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _aphrodite = __webpack_require__(123);

var _aphrodite2 = _interopRequireDefault(_aphrodite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classNames = _aphrodite2.default.StyleSheet.create({
  container: { border: '1px solid #d5d5d5', borderRadius: '2px', margin: '15px 0 5px 0' },
  imageContainer: {
    height: 0,
    paddingTop: '52.3%',
    overflow: 'hidden',
    maxWidth: '100%',
    position: 'relative',
    margin: 0
  },
  imageDisplay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  }
});

var LinkPreview = function (_Component) {
  _inherits(LinkPreview, _Component);

  function LinkPreview() {
    _classCallCheck(this, LinkPreview);

    return _possibleConstructorReturn(this, (LinkPreview.__proto__ || Object.getPrototypeOf(LinkPreview)).apply(this, arguments));
  }

  _createClass(LinkPreview, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          description = _props.description,
          imageUrl = _props.imageUrl,
          title = _props.title,
          url = _props.url,
          children = _props.children;

      // remove http / https / www - oh lala

      var stripUrl = url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];

      return _react2.default.createElement(
        'div',
        { className: _aphrodite2.default.css(classNames.container) },
        imageUrl && _react2.default.createElement(
          'div',
          { className: _aphrodite2.default.css(classNames.imageContainer) },
          _react2.default.createElement(
            'a',
            { href: url, target: '_blank', style: { color: 'inherit', textDecoration: 'none' } },
            _react2.default.createElement('div', { className: _aphrodite2.default.css(classNames.imageDisplay), style: { backgroundImage: 'url(' + imageUrl + ')' } })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: 'block', padding: '3px 5px' } },
          _react2.default.createElement(
            'div',
            { style: { fontWeight: 600, fontSize: '14px', cursor: 'pointer' } },
            _react2.default.createElement(
              'a',
              { href: url, target: '_blank', style: { color: 'inherit', textDecoration: 'none' } },
              title
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { fontSize: '12px', marginTop: '3px' } },
            description
          ),
          _react2.default.createElement(
            'div',
            { style: { fontSize: '10px', marginTop: '3px', cursor: 'pointer' } },
            _react2.default.createElement(
              'a',
              { href: url, target: '_blank', style: { color: 'inherit', textDecoration: 'none' } },
              (stripUrl || '').toUpperCase()
            )
          ),
          children
        )
      );
    }
  }]);

  return LinkPreview;
}(_react.Component);

LinkPreview.propTypes = {
  description: _react.PropTypes.string,
  imageUrl: _react.PropTypes.string,
  title: _react.PropTypes.string,
  type: _react.PropTypes.string,
  url: _react.PropTypes.string,
  siteName: _react.PropTypes.string,
  children: _react.PropTypes.node
};

exports.default = LinkPreview;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(1155);
moment.tz.load(__webpack_require__(1157));


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1618);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1619)();
}


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1624);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1625);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPromise = undefined;

var _typeof2 = __webpack_require__(1012);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(1163);

var _keys2 = _interopRequireDefault(_keys);

exports.objectToGetParams = objectToGetParams;
exports.windowOpen = windowOpen;

var _platform = __webpack_require__(1166);

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function objectToGetParams(object) {
  return '?' + (0, _keys2.default)(object).filter(function (key) {
    return !!object[key];
  }).map(function (key) {
    return key + '=' + encodeURIComponent(object[key]);
  }).join('&');
} /* eslint-disable prefer-template */
function windowOpen(url, _ref, onShareWindowClose) {
  var name = _ref.name,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 400 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 550 : _ref$width;

  var left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
  var top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;

  var config = {
    height: height,
    width: width,
    left: left,
    top: top,
    location: 'no',
    toolbar: 'no',
    status: 'no',
    directories: 'no',
    menubar: 'no',
    scrollbars: 'yes',
    resizable: 'no',
    centerscreen: 'yes',
    chrome: 'yes'
  };

  var shareDialog = window.open(url, _platform2.default.name === 'IE' && parseInt(_platform2.default.version, 10) < 10 ? '' : name, (0, _keys2.default)(config).map(function (key) {
    return key + '=' + config[key];
  }).join(', '));

  if (onShareWindowClose) {
    (function () {
      var interval = window.setInterval(function () {
        try {
          if (shareDialog === null || shareDialog.closed) {
            window.clearInterval(interval);
            onShareWindowClose(shareDialog);
          }
        } catch (e) {
          /* eslint-disable no-console */
          console.error(e);
          /* eslint-enable no-console */
        }
      }, 1000);
    })();
  }

  return shareDialog;
}

var isPromise = exports.isPromise = function isPromise(obj) {
  return !!obj && ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};

/***/ }),
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(1378);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(643);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(1093);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(1379);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(576);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(907);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(1096);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(1383);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var OPEN = exports.OPEN = 'UPGRADE_OPEN';
var CLOSE = exports.CLOSE = 'UPGRADE_CLOSE';
var RESET = exports.RESET = 'UPGRADE_RESET';
var SYNC = exports.SYNC = 'UPGRADE_SYNC_DATA';
var REASON = exports.REASON = 'UPGRADE_REASON';
var PARTNER_FINDER_CONNECT = exports.PARTNER_FINDER_CONNECT = 'PARTNER_FINDER_CONNECT';
var PARTNER_FINDER_SEARCH = exports.PARTNER_FINDER_SEARCH = 'PARTNER_FINDER_SEARCH';
var CONTRACT_LIST_SENT_TRACKING = exports.CONTRACT_LIST_SENT_TRACKING = 'UPGRADE_CONTRACT_LIST_SENT_TRACKING';
var WHO_VIEW_MY_PROFILE = exports.WHO_VIEW_MY_PROFILE = 'UPGRDE_TO_SEE_WHO_VIEW_MY_PROFILE';
var CONTRACTING_BOUNCED = exports.CONTRACTING_BOUNCED = 'UPGRDE_TO_SEE_BOUNCED_CONTRACT_OR_REQUEST';
var CONTRACTING_REPORTS = exports.CONTRACTING_REPORTS = 'UPGRADE_TO_DOWNLOAD_CONTRACTING_REPORTS';
var CONTRACT_LIST_BULK_ACTIONS = exports.CONTRACT_LIST_BULK_ACTIONS = 'CONTRACT_LIST_BULK_ACTIONS';

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRouter = __webpack_require__(67);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRouterRedux = __webpack_require__(27);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavLink = (0, _react.createClass)({
  propTypes: {
    routeName: _react.PropTypes.string,
    activeRoutes: _react.PropTypes.array,
    className: _react.PropTypes.string,
    filterResults: _react.PropTypes.func,
    history: _react.PropTypes.object,
    location: _react.PropTypes.object,
    name: _react.PropTypes.string,
    classes: _react.PropTypes.string,
    searchInput: _react.PropTypes.any,
    children: _react.PropTypes.any,
    style: _react.PropTypes.object,
    push: _react.PropTypes.func,
    onClick: _react.PropTypes.func
  },

  onClick: function onClick() {
    this.props.push(this.props.routeName);
    if (this.props.onClick) this.props.onClick();else this.filterResults();
  },
  isInternal: function isInternal(to) {
    // If it's a relative url such as '/path', 'path' and does not contain a protocol we can assume it is internal.
    if (to.indexOf('://') === -1) return true;

    var toLocation = this.parseTo(to);
    return window.location.hostname === toLocation.hostname;
  },
  parseTo: function parseTo(to) {
    var parser = document.createElement('a');
    parser.href = to;
    return parser;
  },
  filterResults: function filterResults() {
    var _this = this;

    var routeName = function () {
      // Removes /connections/ from routename
      if (_this.props.routeName.indexOf('connections')) return _this.props.routeName.slice(13);
      return _this.props.routeName;
    }();
    if (this.props.filterResults) this.props.filterResults(routeName);
  },
  render: function render() {
    var _props = this.props,
        location = _props.location,
        routeName = _props.routeName,
        _props$style = _props.style,
        style = _props$style === undefined ? {} : _props$style,
        _props$activeRoutes = _props.activeRoutes,
        activeRoutes = _props$activeRoutes === undefined ? [] : _props$activeRoutes;

    var currentPath = (location || {}).pathname;
    var routeMatch = _ramda2.default.any(function (route) {
      return route && currentPath && currentPath.indexOf(route) === 0;
    }, activeRoutes);
    var classes = (0, _classnames2.default)('nav-link', this.props.classes, {
      active: routeMatch
    });
    if (!routeName) {
      return _react2.default.createElement(
        'div',
        { style: _extends({ cursor: 'pointer' }, style), onClick: this.props.onClick, className: classes },
        this.props.children
      );
    }
    var isInternal = this.isInternal(routeName);
    if (isInternal) {
      return _react2.default.createElement(
        'div',
        {
          style: _extends({ cursor: 'pointer' }, style),
          onClick: this.onClick,
          className: classes
        },
        this.props.children
      );
    }
    return _react2.default.createElement(
      'a',
      {
        href: routeName,
        style: style,
        className: classes,
        onClick: this.props.onClick,
        target: '_blank'
      },
      this.props.children
    );
    /* jshint ignore:end */
  }
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    push: function push() {
      return dispatch(_reactRouterRedux.push.apply(undefined, arguments));
    }
  };
};
exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(NavLink);

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextArea = (0, _react.createClass)({

  propTypes: {
    onChange: _react.PropTypes.func,
    style: _react.PropTypes.object,
    name: _react.PropTypes.string,
    id: _react.PropTypes.string,
    value: _react.PropTypes.string,
    defaultValue: _react.PropTypes.string,
    required: _react.PropTypes.bool,
    error: _react.PropTypes.string,
    rows: _react.PropTypes.number
  },

  handleChange: function handleChange(event) {
    if (this.props.onChange) this.props.onChange(event);
  },
  render: function render() {
    return _react2.default.createElement(
      "div",
      { className: "textarea-container" },
      _react2.default.createElement("textarea", {
        style: this.props.style,
        name: this.props.name,
        id: this.props.id,
        value: this.props.value,
        defaultValue: this.props.defaultValue,
        onChange: this.handleChange,
        rows: this.props.rows,
        required: this.props.required
      }),
      this.props.error ? _react2.default.createElement(
        "div",
        { className: "error-message" },
        this.props.error
      ) : undefined
    );
  }
});

exports.default = TextArea;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1132),
    getRawTag = __webpack_require__(2859),
    objectToString = __webpack_require__(2860);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 1052 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(1501),
    isLength = __webpack_require__(1507);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getUserLocationProfile = getUserLocationProfile;
exports.deleteCoverImageFromLocation = deleteCoverImageFromLocation;
exports.removeProduct = removeProduct;
exports.importProdData = importProdData;
exports.addProduct = addProduct;
exports.editLocationField = editLocationField;

var _soFetch = __webpack_require__(254);

var _locationConstants = __webpack_require__(629);

var constants = _interopRequireWildcard(_locationConstants);

var _locationGraphqlQuery = __webpack_require__(862);

var queries = _interopRequireWildcard(_locationGraphqlQuery);

var _http = __webpack_require__(118);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getUserLocationProfile(locationId) {
  return (0, _soFetch.soFetch)('/proxy/profile/locations/' + locationId + '?query=' + queries.myLocationProfileQuery, {
    method: 'get',
    actionType: constants.GET_USER_LOCATION_PROFILE,
    responseBinding: 'location'
  });
}

function deleteCoverImageFromLocation(filename, id) {
  return function (dispatch) {
    return fetch('/proxy/profile/delete_cover_photos', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: filename + id })
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      return dispatch({
        type: constants.DELETE_COVER_IMAGE_FROM_LOCATION,
        payload: { id: id }
      });
    }).catch(function (err) {
      return console.log('err in deleting location cover photo', err);
    });
  };
}

function removeProduct(productId, locationId) {
  return function (dispatch) {
    return (0, _http.del)('/proxy/profile/products/' + productId).then(_checkStatus2.default).then(function () {
      return dispatch({ type: constants.REMOVE_PRODUCT, payload: { productId: productId, locationId: locationId } });
    }).catch(function () {
      return dispatch({ type: constants.REMOVE_PRODUCT_FAILED, payload: { locationId: locationId } });
    });
  };
}

function importProdData(payload) {
  return function (dispatch) {
    dispatch({ type: constants.IMPORTING_PROD });
    return fetch('/proxy/profile/locations/' + payload.locId + '/createProdFromData', {
      method: 'post',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(_extends({}, payload))
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: constants.FINISHED_IMPORTING_PROD, payload: { locationId: payload.locId, productId: payload.prodIdToImportTo } });
    }).catch(function (err) {
      return console.log('err in adding prod through import', err);
    });
  };
}

function addProduct(name, id) {
  return (0, _soFetch.soFetch)('/proxy/profile/locations/' + id + '/products?mutation=' + queries.addProductMutation, {
    body: { name: name },
    method: 'post',
    actionType: constants.ADD_PRODUCT,
    responseBinding: 'payload'
  });
}

function editLocationField(_ref) {
  var updateField = _ref.updateField,
      updateBody = _ref.updateBody,
      id = _ref.id;

  return function (dispatch) {
    var body = updateBody;
    if ((updateField === 'coverImageUrl' || updateField === 'profileImageUrl') && updateBody) {
      body += '?' + Date.now();
      if (updateField === 'profileImageUrl') {
        dispatch({ type: constants.PROFILE_IMAGE_CHANGED, payload: body });
      }
    }
    dispatch({
      type: constants.EDIT_USER_LOCATION_PROFILE_FIELD_STARTING,
      payload: {
        id: id,
        updateField: updateField,
        updateBody: body
      }
    });
    return (0, _soFetch.soFetch)('/proxy/profile/locations/' + id + '?mutation=' + queries.editLocationMutation, {
      method: 'put',
      body: _defineProperty({}, updateField, body),
      actionType: constants.EDIT_USER_LOCATION_PROFILE_FIELD,
      responseBinding: 'location'
    })(dispatch);
  };
}

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _contactList = __webpack_require__(3250);

var _contactList2 = _interopRequireDefault(_contactList);

var _smallButtons = __webpack_require__(94);

var _openInNew = __webpack_require__(1962);

var _openInNew2 = _interopRequireDefault(_openInNew);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PartnerNode = function PartnerNode(_ref) {
  var style = _ref.style,
      _ref$partners = _ref.partners,
      partners = _ref$partners === undefined ? [] : _ref$partners,
      _ref$contacts = _ref.contacts,
      contacts = _ref$contacts === undefined ? [] : _ref$contacts,
      payloadForResend = _ref.payloadForResend,
      openResendContractDialog = _ref.openResendContractDialog,
      isReceiver = _ref.isReceiver,
      forLeftNav = _ref.forLeftNav,
      forWS = _ref.forWS;

  var resendContract = function resendContract() {
    return openResendContractDialog(payloadForResend);
  };
  // for contracting workspace(previously contract request, aka rate container) left nav
  // only show the associated partner
  return _react2.default.createElement(
    'div',
    { style: _extends({ display: 'flex', flexDirection: 'column', marginBottom: '16px' }, style) },
    function () {
      if (forWS || forLeftNav) return '';
      if (isReceiver) {
        return _react2.default.createElement(
          'div',
          null,
          'Sent to Contacts',
          _react2.default.createElement(_contactList2.default, {
            users: contacts,
            listItemStyle: {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block'
            }
          })
        );
      }
    }(),
    function () {
      if (forWS || forLeftNav) return _react2.default.createElement(
        'b',
        null,
        'Associated Partner'
      );
      if (isReceiver) return 'Sent to Partner';
    }(),
    partners.map(function (partner) {
      return _react2.default.createElement(
        'div',
        { key: partner.id },
        _react2.default.createElement(
          'div',
          { className: 'flex-tc-sb' },
          _react2.default.createElement(
            'a',
            {
              href: "https://app.tourconnect.com" + '/partner-management/partner-details/' + partner.id + '?jwt=' + localStorage.getItem('jwt'),
              style: {
                fontSize: '14px',
                whiteSpace: 'prewrap',
                fontWeight: 'bold',
                width: 'calc(100%-25px)',
                lineHeight: '24px'
              },
              target: '_blank'
            },
            partner.name
          ),
          _react2.default.createElement(_openInNew2.default, {
            style: { color: 'rgba(0, 0, 0, 0.54)', height: '22px', width: '22px', cursor: 'pointer' },
            onClick: function onClick() {
              return window.open("https://app.tourconnect.com" + '/partner-management/partner-details/' + partner.id + '?jwt=' + localStorage.getItem('jwt'));
            }
          })
        ),
        partner.tags && partner.tags.length > 0 && _react2.default.createElement(
          'div',
          { style: { display: 'flex', flexFlow: 'wrap', columnGap: '4px', rowGap: '4px' } },
          partner.tags.map(function (tag, i) {
            return _react2.default.createElement(
              _materialUi.Chip,
              { key: i, labelStyle: { fontSize: '12px' } },
              tag.name
            );
          })
        )
      );
    }),
    function () {
      if (forLeftNav) return '';
      return _react2.default.createElement(
        'div',
        null,
        isReceiver && _react2.default.createElement(_smallButtons.JiraFlatButton, {
          style: { width: '90%', margin: '8px auto 0' },
          labelStyle: { padding: '0 4px' },
          label: forWS ? 'Send Request' : 'Resend Contract',
          onClick: resendContract
        })
      );
    }()
  );
};

PartnerNode.propTypes = {
  partners: _react.PropTypes.array,
  contacts: _react.PropTypes.array,
  payloadForResend: _react.PropTypes.object,
  openResendContractDialog: _react.PropTypes.func,
  forLeftNav: _react.PropTypes.bool
};

var mapState = function mapState(_ref2) {
  var contractActivitiesProducts = _ref2.contracting.contractActivitiesProducts;

  var leftNav = contractActivitiesProducts.get('leftNav').toJS();
  var rightSideContent = contractActivitiesProducts.get('rightSideContent').toJS();
  return {
    partners: leftNav.partners,
    contacts: leftNav.contacts,
    payloadForResend: {
      contractId: leftNav.contractId,
      // this function is only available for the sender
      // for whom partners length should only be one
      partner: _ramda2.default.pathOr({}, ['partners', 0], leftNav),
      to: leftNav.to,
      toEmails: leftNav.toEmails,
      resendToEmails: leftNav.toEmails,
      deadlineDate: rightSideContent.deadlineDate
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapState, {
  openResendContractDialog: function openResendContractDialog(payload) {
    return { type: 'CHANGE_RESEND_CONTRACT_DIALOG_STATE', payload: payload };
  }
})(PartnerNode);

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var color = _ref.color,
      style = _ref.style;
  return _react2.default.createElement('div', {
    style: _extends({
      color: 'white',
      position: 'relative',
      width: '8px',
      height: '8px',
      paddingLeft: '0.3em',
      borderRadius: '8px',
      top: '-14px',
      left: '-6px',
      backgroundColor: color || '#ff4081',
      display: 'inline-block'
    }, style)
  });
};

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f516495d37e1dabf9e862fb370289056.svg";

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _contractingPresetNamesCodes = __webpack_require__(464);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function (desc, isMultiDayTour) {
  if (desc.indexOf('Up to') > -1) return true;
  var validGuestCountForNewContract = (0, _ramda.test)(/^[0-9]+ Guests$/gm);

  var acceptedNewDescriptions = !isMultiDayTour ? [].concat(_toConsumableArray(_contractingPresetNamesCodes.standardNonAccomDescrs), ['Single', 'Double', 'Twin', 'Triple', 'Quad', '1 Guest', 'Up to', 'Extra Adult', 'Extra Child', 'Extra Infant', 'Per Person']) : _contractingPresetNamesCodes.multiDayTourDescrs;

  var descriptionInValidDescriptions = function descriptionInValidDescriptions(str) {
    return _ramda2.default.contains(str, acceptedNewDescriptions);
  };
  return _ramda2.default.call((0, _ramda.either)(descriptionInValidDescriptions, validGuestCountForNewContract), desc);
};

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentFlag = function ContentFlag(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z' })
  );
};
ContentFlag = (0, _pure2.default)(ContentFlag);
ContentFlag.displayName = 'ContentFlag';
ContentFlag.muiName = 'SvgIcon';

exports.default = ContentFlag;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(1184);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(89);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(1097);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(1382);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var maxRules = 1e10;


var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(1095);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(576);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable-next-line no-use-before-define */
var StyleSheet = function () {
  function StyleSheet(styles, options) {
    var _this = this;

    _classCallCheck(this, StyleSheet);

    this.update = function (name, data) {
      if (typeof name === 'string') {
        _this.rules.update(name, data);
      } else {
        _this.rules.update(name);
      }
      return _this;
    };

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var _name in styles) {
      this.rules.add(_name, styles[_name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var _name2 in styles) {
        added.push(this.addRule(_name2, styles[_name2], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'toString',


    /**
     * Convert rules to a CSS string.
     */
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_MARKET_READINESS_FOR_USER_STORE = exports.SET_MARKET_READINESS_FOR_USER_STORE = 'SET_MARKET_READINESS_FOR_USER_STORE';
var AUTH_RECEIVED = exports.AUTH_RECEIVED = 'AUTH_RECEIVED';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';
var GET_USER = exports.GET_USER = 'GET_USER';
var GET_USER_FOR_ADMIN = exports.GET_USER_FOR_ADMIN = 'GET_USER_FOR_ADMIN';
var PROFILE_IMAGE_CHANGED = exports.PROFILE_IMAGE_CHANGED = 'PROFILE_IMAGE_CHANGED';
var USER_STORE_PLAN_UPDATE = exports.USER_STORE_PLAN_UPDATE = 'USER_STORE_PLAN_UPDATE';
var ONBOARDING_COMPLETE = exports.ONBOARDING_COMPLETE = 'ONBOARDING_COMPLETE';
var ADMIN_LOGOUT = exports.ADMIN_LOGOUT = 'ADMIN_LOGOUT';
var UPDATE_UPGRADE_SOURCE = exports.UPDATE_UPGRADE_SOURCE = 'UPDATE_UPGRADE_SOURCE';
var LOG_UPGRADE_CLICK = exports.LOG_UPGRADE_CLICK = 'LOG_UPGRADE_CLICK';

// notifications
var EDIT_NOTIFICATION_STARTING = exports.EDIT_NOTIFICATION_STARTING = 'EDIT_NOTIFICATION_STARTING';
var EDIT_NOTIFICATION_FINISHED = exports.EDIT_NOTIFICATION_FINISHED = 'EDIT_NOTIFICATION_FINISHED';
var EDIT_NOTIFICATION_FAILED = exports.EDIT_NOTIFICATION_FAILED = 'EDIT_NOTIFICATION_FAILED';

var UPDATE_USER_PROP = exports.UPDATE_USER_PROP = 'UPDATE_USER_PROP';

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

/**
 * toString ref.
 */

var toString = Object.prototype.toString;

/**
 * Return the type of `val`.
 *
 * @param {Mixed} val
 * @return {String}
 * @api public
 */

module.exports = function(val){
  switch (toString.call(val)) {
    case '[object Date]': return 'date';
    case '[object RegExp]': return 'regexp';
    case '[object Arguments]': return 'arguments';
    case '[object Array]': return 'array';
    case '[object Error]': return 'error';
  }

  if (val === null) return 'null';
  if (val === undefined) return 'undefined';
  if (val !== val) return 'nan';
  if (val && val.nodeType === 1) return 'element';

  if (isBuffer(val)) return 'buffer';

  val = val.valueOf
    ? val.valueOf()
    : Object.prototype.valueOf.apply(val);

  return typeof val;
};

// code borrowed from https://github.com/feross/is-buffer/blob/master/index.js
function isBuffer(obj) {
  return !!(obj != null &&
    (obj._isBuffer || // For Safari 5-7 (missing Object.prototype.constructor)
      (obj.constructor &&
      typeof obj.constructor.isBuffer === 'function' &&
      obj.constructor.isBuffer(obj))
    ))
}


/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "channel", function() { return channel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return withTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "themeListener", function() { return themeListener; });
/* harmony export (immutable) */ __webpack_exports__["createTheming"] = createTheming;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_theme_provider__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_with_theme__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_theme_listener__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(650);





var channel = __WEBPACK_IMPORTED_MODULE_3__channel__["a" /* default */];
var withTheme = Object(__WEBPACK_IMPORTED_MODULE_1__create_with_theme__["a" /* default */])();
var ThemeProvider = Object(__WEBPACK_IMPORTED_MODULE_0__create_theme_provider__["a" /* default */])();
var themeListener = Object(__WEBPACK_IMPORTED_MODULE_2__create_theme_listener__["a" /* default */])();
function createTheming() {
  var customChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_3__channel__["a" /* default */];

  return {
    channel: customChannel,
    withTheme: Object(__WEBPACK_IMPORTED_MODULE_1__create_with_theme__["a" /* default */])(customChannel),
    ThemeProvider: Object(__WEBPACK_IMPORTED_MODULE_0__create_theme_provider__["a" /* default */])(customChannel),
    themeListener: Object(__WEBPACK_IMPORTED_MODULE_2__create_theme_listener__["a" /* default */])(customChannel)
  };
}

/* harmony default export */ __webpack_exports__["default"] = ({
  channel: __WEBPACK_IMPORTED_MODULE_3__channel__["a" /* default */],
  withTheme: withTheme,
  ThemeProvider: ThemeProvider,
  themeListener: themeListener,
  createTheming: createTheming
});

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1428)();
}


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createThemeListener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(650);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function createThemeListener() {
  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__channel__["a" /* default */];

  var contextTypes = _defineProperty({}, CHANNEL, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired);

  function initial(context) {
    if (!context[CHANNEL]) {
      throw new Error('[' + this.displayName + '] Please use ThemeProvider to be able to use WithTheme');
    }

    return context[CHANNEL].getState();
  }

  function subscribe(context, cb) {
    if (context[CHANNEL]) {
      return context[CHANNEL].subscribe(cb);
    }
  }

  function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }

  return {
    contextTypes: contextTypes,
    initial: initial,
    subscribe: subscribe,
    unsubscribe: unsubscribe
  };
}

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ns$jss$ns$sheetOptio;

var _propTypes = __webpack_require__(651);

var _ns = __webpack_require__(911);

var ns = _interopRequireWildcard(_ns);

var _propTypes2 = __webpack_require__(1104);

var _propTypes3 = _interopRequireDefault(_propTypes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, _propTypes3['default'].jss), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, _propTypes3['default'].registry), _defineProperty(_ns$jss$ns$sheetOptio, ns.managers, _propTypes.object), _ns$jss$ns$sheetOptio);

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(651);

exports['default'] = {
  jss: (0, _propTypes.shape)({
    options: (0, _propTypes.shape)({
      createGenerateClassName: _propTypes.func.isRequired
    }).isRequired,
    createStyleSheet: _propTypes.func.isRequired,
    removeStyleSheet: _propTypes.func.isRequired
  }),
  registry: (0, _propTypes.shape)({
    add: _propTypes.func.isRequired,
    toString: _propTypes.func.isRequired
  })
};

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_POST_PAGE_PROP = exports.UPDATE_POST_PAGE_PROP = 'UPDATE_POST_PAGE_PROP';

// get post
var GET_POST_STARTED = exports.GET_POST_STARTED = 'GET_POST_STARTED';
var GOT_POST = exports.GOT_POST = 'GOT_POST';
var GET_POST_FAILED = exports.GET_POST_FAILED = 'GET_POST_FAILED';

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var OPEN = exports.OPEN = 'HELPWIDGET_OPEN';
var CLOSE = exports.CLOSE = 'HELPWIDGET_CLOSE';
var RESET = exports.RESET = 'HELPWIDGET_RESET';
var SUPPORT_DESK_ACTIVE = exports.SUPPORT_DESK_ACTIVE = 'SUPPORT_DESK_ACTIVE';
var NEW_FEATURES_ACTIVE = exports.NEW_FEATURES_ACTIVE = 'NEW_FEATURES_ACTIVE';
var RECEIVE_NEW_FEATURES = exports.RECEIVE_NEW_FEATURES = 'NEW_FEATURES_ACTIVE'; // TODO: is this a bug ?
var LIVE_CHAT_ACTIVE = exports.LIVE_CHAT_ACTIVE = 'LIVE_CHAT_ACTIVE';
var LIVE_CHAT_INACTIVE = exports.LIVE_CHAT_INACTIVE = 'LIVE_CHAT_INACTIVE';

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var OPEN = exports.OPEN = 'WALKTHRU_OPEN';
var CLOSE = exports.CLOSE = 'WALKTHRU_CLOSE';
var RESET = exports.RESET = 'WALKTHRU_RESET';
var SET_STEPS = exports.SET_STEPS = 'WALKTHRU_SET_STEPS';

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBilling = exports.getCoupon = exports.updatePaymentSource = exports.cancelSubscription = exports.addSubscription = exports.resetBillingError = undefined;

var _http = __webpack_require__(118);

var _billingConstants = __webpack_require__(1839);

var constants = _interopRequireWildcard(_billingConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getCompanyURL = function getCompanyURL(getState) {
  var _getState$user$toJS = getState().user.toJS(),
      companyId = _getState$user$toJS.company.companyId;

  return '/proxy/company/' + companyId;
};

var isLoading = function isLoading() {
  var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    type: 'BILLING_LOADING',
    loading: loading
  };
};

var billingError = function billingError(message) {
  return {
    type: 'BILLING_ERROR',
    payload: {
      message: message
    }
  };
};

var addSubscriptionFail = function addSubscriptionFail(_ref) {
  var message = _ref.message;
  return function (dispatch) {
    dispatch(billingError(message));
  };
};

var updatePaymentSourceFail = function updatePaymentSourceFail(_ref2) {
  var message = _ref2.message;
  return function (dispatch) {
    dispatch(billingError(message));
  };
};

var addSubscriptionSuccess = function addSubscriptionSuccess(data) {
  return function (dispatch) {
    dispatch({ type: 'USER_STORE_PLAN_UPDATE', payload: { plan: data.plan } });
    dispatch({ type: 'GET_BILLING', payload: data });
  };
};

var deleteSubscriptionSuccess = function deleteSubscriptionSuccess() {
  return {
    type: 'CANCEL_SUBSCRIPTION',
    payload: {}
  };
};

var resetBillingError = exports.resetBillingError = function resetBillingError() {
  return {
    type: 'RESET_BILLING_ERROR'
  };
};

var addSubscription = exports.addSubscription = function addSubscription(planId, tokenId, card) {
  return function (dispatch, getState) {
    var body = {
      planId: planId,
      tokenId: tokenId,
      card: card
    };
    var billing = getState().billing.toJS();
    if (billing && billing.coupon && billing.coupon.name) {
      body.coupon = billing.coupon.name;
    }

    dispatch(isLoading(true));
    return (0, _http.post)(getCompanyURL(getState) + '/subscription', body).then(function (response) {
      return response.json().then(function (data) {
        return { data: data, response: response };
      });
    }).then(function (_ref3) {
      var data = _ref3.data,
          response = _ref3.response;

      dispatch(isLoading(false));
      if (!response.ok) {
        dispatch(addSubscriptionFail(data));
        return Promise.reject();
      }
      dispatch(addSubscriptionSuccess(data));
      return Promise.resolve();
    });
  };
};

var cancelSubscription = exports.cancelSubscription = function cancelSubscription(reason, addtionalDetail) {
  return function (dispatch, getState) {
    dispatch(isLoading(true));
    (0, _http.post)(getCompanyURL(getState) + '/subscription/delete', { reason: reason, addtionalDetail: addtionalDetail }).then(function (response) {
      if (!response.ok) {
        dispatch(isLoading(false));
        dispatch(billingError(response.error));
      } else {
        dispatch(isLoading(false));
        dispatch(deleteSubscriptionSuccess());
      }
    }).catch(function (err) {
      return console.log('Error: ', err);
    } // eslint-disable-line no-console
    );
  };
};

var updatePaymentSource = exports.updatePaymentSource = function updatePaymentSource(token) {
  return function (dispatch, getState) {
    dispatch(isLoading(true));
    return (0, _http.put)(getCompanyURL(getState) + '/billing/source', { token: token }).then(function (response) {
      return response.json().then(function (data) {
        return { data: data, response: response };
      });
    }).then(function (_ref4) {
      var data = _ref4.data,
          response = _ref4.response;

      dispatch(isLoading(false));
      if (!response.ok) {
        dispatch(updatePaymentSourceFail(data));
        return Promise.reject(new Error(data));
      } else {
        dispatch({ type: constants.GET_BILLING, payload: data });
        return Promise.resolve();
      }
    });
  };
};

var getCoupon = exports.getCoupon = function getCoupon(couponName) {
  return function (dispatch, getState) {
    return (0, _http.get)('/proxy/coupon/' + couponName).then(function (response) {
      return response.json().then(function (data) {
        return { data: data, response: response };
      });
    }).then(function (_ref5) {
      var data = _ref5.data,
          response = _ref5.response;

      dispatch(isLoading(false));
      if (!response.ok) Promise.reject();

      return dispatch({ type: constants.GET_COUPON, payload: data });
    });
  };
};

var getBilling = exports.getBilling = function getBilling() {
  return function (dispatch, getState) {
    dispatch(isLoading(true));
    return (0, _http.get)(getCompanyURL(getState) + '/billing').then(function (response) {
      return response.json().then(function (data) {
        return { data: data, response: response };
      });
    }).then(function (_ref6) {
      var data = _ref6.data,
          response = _ref6.response;

      dispatch(isLoading(false));
      if (!response.ok) {
        dispatch({ type: 'BILLING_ERROR', payload: data });
      } else {
        dispatch({ type: constants.GET_BILLING, payload: data });
      }
    });
  };
};

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(498);
var invariant = __webpack_require__(56);
var ReactPropTypesSecret = __webpack_require__(1110);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendMessage = exports.closeModal = exports.openModal = undefined;

var _constants = __webpack_require__(654);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// export const openModal = () => { return { type: cnt.OPENMODAL }; };
var openModal = exports.openModal = function openModal() {
  return function () {
    window.location = "https://app.tourconnect.com" + '/partner-management/send-assets?jwt=' + localStorage.getItem('jwt') + '&go_back_to=' + window.location.href;
  };
};
var closeModal = exports.closeModal = function closeModal() {
  return { type: cnt.CLOSEMODAL };
};
var sendMessage = exports.sendMessage = function sendMessage(payload) {
  return { type: cnt.SENDMESSAGE, payload: payload };
};

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRedux = __webpack_require__(6);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _materialUi = __webpack_require__(3);

var _attachment = __webpack_require__(2737);

var _attachment2 = _interopRequireDefault(_attachment);

var _dropzone = __webpack_require__(869);

var _dropzone2 = _interopRequireDefault(_dropzone);

var _uploadFromMM = __webpack_require__(1855);

var _uploadFromMM2 = _interopRequireDefault(_uploadFromMM);

var _actions = __webpack_require__(1455);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  inputContainer: function inputContainer(_ref) {
    var borderless = _ref.borderless;
    return {
      border: borderless ? 'none' : '1px solid #bfbfbf',
      position: 'relative',
      '&.focused': {
        borderColor: '#00b3cf'
      }
    };
  },
  yellowBack: {
    backgroundColor: '#FFF5EA'
  },
  fileList: {
    paddingBottom: '1em',
    color: '#bfbfbf',
    fontSize: '12px',
    '&.hide': {
      visibility: 'hidden'
    },
    '& > .element': {
      backgroundColor: 'rgba(0, 126, 255, 0.6)',
      borderRadius: '2px',
      border: '1px solid rgba(0, 126, 255, 0.24)',
      color: '#fff',
      display: 'inline-block',
      fontSize: '0.9em',
      lineHeight: '1.4',
      marginLeft: '5px',
      marginTop: '5px',
      verticalAlign: 'top',
      '& > .remove': {
        cursor: 'pointer',
        borderBottomLeftRadius: '2px',
        borderTopLeftRadius: '2px',
        borderRight: '1px solid rgba(0, 126, 255, 0.24)',
        padding: '1px 5px 3px',
        display: 'inline-block',
        verticalAlign: 'middle'
      },
      '& > .text': {
        color: '#fff',
        textDecoration: 'none',
        borderBottomRightRadius: '2px',
        borderTopRightRadius: '2px',
        cursor: 'default',
        padding: '2px 5px',
        display: 'inline-block',
        verticalAlign: 'middle'
      }
    }
  },
  dropZone: {
    padding: '0 8px 0',
    color: '#bfbfbf',
    fontSize: '12px',
    clear: 'both'
  },
  inputZone: {
    display: 'flex',
    justifyContent: 'flex-start',
    minHeight: '80px',
    overflow: 'hidden',
    padding: '0 0 4px 12px'
  },
  dropZone2: {
    borderTop: '1px dotted #bfbfbf',
    clear: 'both',
    color: '#bfbfbf',
    fontSize: '12px',
    minHeight: '60px',
    padding: '12px 8px'
  },
  actionSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end'
  },
  attachmentButtons: {
    flex: '1 1 auto'
  },
  attachmentCard: {
    backgroundColor: 'transparent',
    borderBottom: '1px solid #e0e0e0',
    boxShadow: 'none'
  },
  attachmentHeaderText: {
    display: 'inline-block',
    overflow: 'hidden',
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.54)',
    marginLeft: '15px'
  },
  actionButtons: {
    textAlign: 'right',
    marginBottom: '10px',
    '&.hide': {
      display: 'none'
    }
  },
  inputIcon: {
    top: '12px',
    flex: '0 0 auto'
  },
  textField: function textField(_ref2) {
    var hideMesageBoxIcon = _ref2.hideMesageBoxIcon;
    return {
      flex: '1 1 auto',
      marginLeft: hideMesageBoxIcon ? '' : '10px',
      marginRight: '12px',
      maxHeight: '40vh',
      overflowY: 'auto'
    };
  },
  selectTemplate: {
    marginLeft: '2em'
  },
  sendContractButton: {
    margin: '2em'
  },
  rateSendBar: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  rateSendError: {
    color: '#ff4081'
  }
};

var defaultState = {
  attachmentExpanded: false,
  filesMM: [],
  filesUploaded: [],
  MMExpanded: false,
  rates: [],
  rateErrorMessage: '',
  rateValid: false
};

// const isOverlapping = (startDate1, endDate1, startDate2, endDate2) => {
//   return moment(startDate1).isSameOrBefore(endDate2)
//   && moment(startDate2).isSameOrBefore(endDate1);
// };

var CommentBox = function (_Component) {
  _inherits(CommentBox, _Component);

  function CommentBox(props) {
    _classCallCheck(this, CommentBox);

    var _this = _possibleConstructorReturn(this, (CommentBox.__proto__ || Object.getPrototypeOf(CommentBox)).call(this, props));

    _this.clearAttachments = function () {
      _this.setState(defaultState);
      _this.clearMM();
    };

    _this.updateFileList = function (type) {
      return function (files) {
        // filesUploaded only returns the files to attach
        var newFiles = type === 'filesUploaded' ? _this.state[type].concat(files) : files.map(function (_ref3) {
          var name = _ref3.name,
              url = _ref3.url,
              size = _ref3.size,
              mediaType = _ref3.mediaType;
          return {
            fileName: name,
            name: name,
            url: url,
            path: url,
            size: ~~(parseFloat(size) * 1024),
            type: mediaType
          };
        });
        _this.setState(_defineProperty({}, type, newFiles), function () {
          var _this$state = _this.state,
              filesUploaded = _this$state.filesUploaded,
              filesMM = _this$state.filesMM;

          _this.props.attachFile([].concat(_toConsumableArray(filesUploaded), _toConsumableArray(filesMM)));
          if (filesUploaded.length + filesMM.length > 0) {}
        });
      };
    };

    _this.removeAfile = function (type) {
      return function (fileIndex) {
        var nuArray = [].concat(_toConsumableArray(_this.state.filesUploaded));
        nuArray.splice(fileIndex, 1);
        _this.setState(_defineProperty({}, type, nuArray), function () {
          var _this$state2 = _this.state,
              filesUploaded = _this$state2.filesUploaded,
              filesMM = _this$state2.filesMM;

          _this.props.attachFile([].concat(_toConsumableArray(filesUploaded), _toConsumableArray(filesMM)));
        });
      };
    };

    _this.state = defaultState;
    return _this;
  }

  _createClass(CommentBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.setClear(this.clearAttachments);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          cancelComment = _props.cancelComment,
          classes = _props.classes,
          className = _props.className,
          comment = _props.comment,
          disableSend = _props.disableSend,
          focused = _props.focused,
          handleInput = _props.handleInput,
          hideActions = _props.hideActions,
          hideMesageBoxIcon = _props.hideMesageBoxIcon,
          hintText = _props.hintText,
          internal = _props.internal,
          setFocus = _props.setFocus,
          submitComment = _props.submitComment;
      var _state = this.state,
          attachmentExpanded = _state.attachmentExpanded,
          filesMM = _state.filesMM,
          filesUploaded = _state.filesUploaded;

      var addYellow = function addYellow() {
        return internal ? ' ' + classes.yellowBack : '';
      };
      var allFilesCount = filesUploaded.concat(filesMM).length;
      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'div',
          { className: '' + classes.inputContainer + (focused ? ' focused' : '') + addYellow() },
          _react2.default.createElement(
            'label',
            { htmlFor: 'commentBoxTextField' },
            _react2.default.createElement(
              _dropzone2.default,
              {
                className: '' + classes.dropZone + addYellow(),
                onDrop: this.updateFileList('filesUploaded'),
                disableClick: true
              },
              _react2.default.createElement(
                'div',
                { className: classes.inputZone },
                !hideMesageBoxIcon && _react2.default.createElement(_materialUi.FontIcon, { className: '' + classes.inputIcon + (internal ? ' tc-icon-note_add' : ' tc-icon-question_answer'), color: '#bfbfbf' }),
                _react2.default.createElement(_materialUi.TextField, {
                  id: 'commentBoxTextField',
                  hintText: hintText || (internal ? 'Add an Internal Note' : 'Type a Message'),
                  hintStyle: { fontSize: '14px' },
                  underlineShow: false,
                  value: comment || '',
                  onInput: function onInput(_ref4) {
                    var value = _ref4.target.value;
                    return handleInput(value);
                  },
                  onFocus: function onFocus() {
                    return setFocus(true);
                  },
                  onBlur: function onBlur() {
                    return setFocus(false);
                  },
                  multiLine: true,
                  disabled: disableSend,
                  className: classes.textField
                })
              )
            )
          ),
          !hideActions && _react2.default.createElement(
            'div',
            { className: '' + classes.actionButtons + (Boolean(comment || allFilesCount > 0) ? '' : ' hide') },
            _react2.default.createElement(_materialUi.FlatButton, { label: 'cancel', primary: true, style: { marginRight: '12px' }, onTouchTap: function onTouchTap() {
                return cancelComment('');
              }, disabled: disableSend }),
            _react2.default.createElement(_materialUi.FlatButton, { label: internal ? 'add' : 'send', disabled: disableSend, labelStyle: disableSend ? {} : { color: '#00b3cf' }, onTouchTap: function onTouchTap() {
                return submitComment();
              } })
          ),
          _react2.default.createElement(
            'div',
            { className: classes.attachmentButtons },
            _react2.default.createElement(
              _materialUi.Card,
              {
                expanded: attachmentExpanded,
                onExpandChange: function onExpandChange(newExpadedState) {
                  return _this2.setState({ attachmentExpanded: newExpadedState });
                },
                style: styles.attachmentCard
              },
              _react2.default.createElement(
                _materialUi.CardHeader,
                _extends({
                  textStyle: { display: 'none' }
                }, { showExpandableButton: true, actAsExpander: true }),
                _react2.default.createElement(
                  _materialUi.FontIcon,
                  null,
                  _react2.default.createElement(_attachment2.default, { color: 'rgba(0, 0, 0, 0.54)', style: { verticalAlign: 'bottom', transform: 'rotate(-90deg)' } }),
                  _react2.default.createElement(
                    'div',
                    { className: classes.attachmentHeaderText },
                    'Attachments',
                    !attachmentExpanded && filesUploaded.length > 0 ? _react2.default.createElement(
                      'span',
                      { style: { color: '#00bcd4' } },
                      ' - ' + filesUploaded.length + ' ' + (0, _pluralize2.default)('files', filesUploaded.length)
                    ) : undefined
                  )
                )
              ),
              _react2.default.createElement(
                _materialUi.CardText,
                { expandable: true, style: { padding: '0' } },
                _react2.default.createElement(
                  'div',
                  { className: '' + classes.fileList + (Boolean(filesUploaded && filesUploaded.length) ? '' : ' hide') + addYellow() },
                  filesUploaded.map(function (file, index) {
                    return _react2.default.createElement(
                      'div',
                      {
                        key: index,
                        className: 'element'
                      },
                      _react2.default.createElement(
                        'span',
                        {
                          onClick: function onClick() {
                            return _this2.removeAfile('filesUploaded')(index);
                          },
                          className: 'remove'
                        },
                        'x'
                      ),
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'text'
                        },
                        file.name
                      )
                    );
                  })
                ),
                _react2.default.createElement(
                  _dropzone2.default,
                  {
                    className: 'dropzone ' + classes.dropZone2 + addYellow(),
                    onDrop: this.updateFileList('filesUploaded')
                  },
                  _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-attach_file', color: '#bfbfbf', style: { fontSize: '14px', top: '2px', marginRight: '5px' } }),
                  'Attach files by dragging & dropping, ',
                  _react2.default.createElement(
                    'span',
                    { style: { color: '#00b3cf', cursor: 'pointer' } },
                    'selecting them'
                  )
                )
              )
            ),
            _react2.default.createElement(_uploadFromMM2.default, {
              onChangeSelection: this.updateFileList('filesMM'),
              setClear: function setClear(clear) {
                return _this2.clearMM = clear;
              },
              onCardExpand: function onCardExpand(MMExpanded) {
                return _this2.setState({ MMExpanded: MMExpanded });
              },
              style: _extends({}, styles.attachmentCard, { borderBottom: 'none' })
            })
          )
        )
      );
    }
  }]);

  return CommentBox;
}(_react.Component);

CommentBox.propTypes = {
  attachFile: _react.PropTypes.func,
  borderless: _react.PropTypes.bool,
  cancelComment: _react.PropTypes.func,
  classes: _react.PropTypes.object,
  className: _react.PropTypes.string,
  comment: _react.PropTypes.string,
  contractRequestWizard: _react.PropTypes.object,
  disableSend: _react.PropTypes.bool,
  focused: _react.PropTypes.bool,
  handleInput: _react.PropTypes.func,
  hideActions: _react.PropTypes.bool,
  hideMesageBoxIcon: _react.PropTypes.bool,
  hintText: _react.PropTypes.string,
  internal: _react.PropTypes.bool,
  isSupplier: _react.PropTypes.bool,
  resetSelectedContractRequest: _react.PropTypes.func,
  resetSelectedLocation: _react.PropTypes.func,
  resetSelectedRate: _react.PropTypes.func,
  setClear: _react.PropTypes.func.isRequired,
  setFocus: _react.PropTypes.func,
  setRates: _react.PropTypes.func,
  submitComment: _react.PropTypes.func,
  templateGroupSelected: _react.PropTypes.object,
  templateOrGroup: _react.PropTypes.string,
  templateSelected: _react.PropTypes.object,
  receiverCompanyType: _react.PropTypes.string
};

CommentBox.defaultProps = {
  borderless: false,
  cancelComment: function cancelComment() {},
  disableSend: false,
  hideActions: false,
  hideMesageBoxIcon: false,
  hintText: undefined,
  internal: false,
  setClear: function setClear() {},
  setFocus: function setFocus() {},
  setRates: function setRates() {}
};

// export default CommentBox;
var select = function select(_ref5) {
  var user = _ref5.user,
      _ref5$contracting = _ref5.contracting,
      supplierWizard = _ref5$contracting.supplierWizard,
      wizard = _ref5$contracting.wizard,
      currentRates = _ref5.partnerDetails.files;
  return {
    isSupplier: user.getIn(['user', 'type']) === 'Supplier',
    templateSelected: supplierWizard.get('templateSelected').toJS(),
    templateGroupSelected: supplierWizard.get('templateGroupSelected').toJS(),
    templateOrGroup: supplierWizard.get('sendTemplateOrGroup'),
    contractRequestWizard: wizard.toJS(),
    currentRates: currentRates
  };
};

exports.default = (0, _reactRedux.connect)(select, {
  resetSelectedRate: _actions.resetSelectedRate,
  resetSelectedLocation: _actions.resetSelectedLocation,
  resetSelectedContractRequest: _actions.resetSelectedContractRequest
})((0, _reactJss2.default)(styles)(CommentBox));

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFollows = exports.getFollowers = exports.getPosts = exports.updateProps = exports.getMetadata = undefined;

var _metaDataConstants = __webpack_require__(1215);

var constants = _interopRequireWildcard(_metaDataConstants);

var _bluebird = __webpack_require__(1114);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _http = __webpack_require__(118);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getMetadata = exports.getMetadata = function getMetadata() {
  return function (dispatch, getState) {
    return _bluebird2.default.all([(0, _http.get)('/proxy/newsfeed/followers?type=count').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }), (0, _http.get)('/proxy/newsfeed/follows?type=count').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }), (0, _http.get)('/proxy/newsfeed/posts?type=count').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }), (0, _http.get)('/proxy/user/newsfeed/likes').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }), (0, _http.get)('/proxy/user/newsfeed/comments').then(_checkStatus2.default).then(function (res) {
      return res.json();
    })]).spread(function (followersCount, followsCount, postsCount, likesCount, commentCount) {
      dispatch({
        type: constants.GOT_META_DATA_COUNT,
        payload: {
          gotMetaDataCount: true,
          followersCount: followersCount,
          followsCount: followsCount,
          postsCount: postsCount,
          likesCount: likesCount,
          commentCount: commentCount
        }
      });
    }).catch(function (err) {
      return console.log('getMetaData ERROR::', err.stack);
    });
  };
};
var updateProps = exports.updateProps = function updateProps(payload) {
  return { type: constants.UPDATE_PROPS, payload: payload };
};
var getPosts = exports.getPosts = function getPosts() {
  return function (dispatch) {
    dispatch(updateProps({ loading: true }));
    return (0, _http.get)('/proxy/newsfeed/posts?type=list').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({ type: 'GOT_INITIAL_LOAD_NEWSFEED', payload: { list: res.posts } });
    }).catch(function (err) {
      console.log(err.stack);
      dispatch(updateProps({ loading: false }));
      dispatch({ type: 'GET_NEWSFEED_POSTS_FAILED' });
    });
  };
};

var getFollowers = exports.getFollowers = function getFollowers() {
  return function (dispatch) {
    dispatch(updateProps({ loading: true }));
    return (0, _http.get)('/proxy/newsfeed/followers?type=list').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (followers) {
      return dispatch(updateProps({ followers: followers, loading: false }));
    }).catch(function (err) {
      console.log(err.stack);
      dispatch(updateProps({ loading: false }));
      dispatch({ type: 'GET_NEWSFEED_FOLLOWERS_FAILED' });
    });
  };
};

var getFollows = exports.getFollows = function getFollows() {
  return function (dispatch) {
    dispatch(updateProps({ loading: true }));
    return (0, _http.get)('/proxy/newsfeed/follows?type=list').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (follows) {
      return dispatch(updateProps({ follows: follows, loading: false }));
    }).catch(function (err) {
      console.log(err.stack);
      dispatch(updateProps({ loading: false }));
      dispatch({ type: 'GET_NEWSFEED_FOLLOWERS_FAILED' });
    });
  };
};

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2017 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.5.0
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule");
var Queue = _dereq_("./queue");
var util = _dereq_("./util");

function Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._haveDrainedQueues = false;
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule = schedule;
}

Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};

Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};

Async.prototype.enableTrampoline = function() {
    this._trampolineEnabled = true;
};

Async.prototype.disableTrampolineIfNecessary = function() {
    if (util.hasDevTools) {
        this._trampolineEnabled = false;
    }
};

Async.prototype.haveItemsQueued = function () {
    return this._isTickUsed || this._haveDrainedQueues;
};


Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
            "\n");
        process.exit(2);
    } else {
        this.throwLater(e);
    }
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

if (!util.hasDevTools) {
    Async.prototype.invokeLater = AsyncInvokeLater;
    Async.prototype.invoke = AsyncInvoke;
    Async.prototype.settlePromises = AsyncSettlePromises;
} else {
    Async.prototype.invokeLater = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvokeLater.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                setTimeout(function() {
                    fn.call(receiver, arg);
                }, 100);
            });
        }
    };

    Async.prototype.invoke = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvoke.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                fn.call(receiver, arg);
            });
        }
    };

    Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) {
            AsyncSettlePromises.call(this, promise);
        } else {
            this._schedule(function() {
                promise._settlePromises();
            });
        }
    };
}

Async.prototype._drainQueue = function(queue) {
    while (queue.length() > 0) {
        var fn = queue.shift();
        if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
        }
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
};

Async.prototype._drainQueues = function () {
    this._drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    this._drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = Async;
module.exports.firstLineError = firstLineError;

},{"./queue":26,"./schedule":29,"./util":36}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
var calledBind = false;
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (((this._bitField & 50397184) === 0)) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
    }
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~2097152);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 2097152) === 2097152;
};

Promise.bind = function (thisArg, value) {
    return Promise.resolve(value).bind(thisArg);
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise":22}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (false) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var args = [].slice.call(arguments, 1);;
    if (false) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util":36}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

Promise.prototype["break"] = Promise.prototype.cancel = function() {
    if (!debug.cancellation()) return this._warn("cancellation is disabled");

    var promise = this;
    var child = promise;
    while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
            if (child._isFollowing()) {
                child._followee().cancel();
            } else {
                child._cancelBranched();
            }
            break;
        }

        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
            if (promise._isFollowing()) {
                promise._followee().cancel();
            } else {
                promise._cancelBranched();
            }
            break;
        } else {
            if (promise._isFollowing()) promise._followee().cancel();
            promise._setWillBeCancelled();
            child = promise;
            promise = parent;
        }
    }
};

Promise.prototype._branchHasCancelled = function() {
    this._branchesRemainingToCancel--;
};

Promise.prototype._enoughBranchesHaveCancelled = function() {
    return this._branchesRemainingToCancel === undefined ||
           this._branchesRemainingToCancel <= 0;
};

Promise.prototype._cancelBy = function(canceller) {
    if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
    } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
            this._invokeOnCancel();
            return true;
        }
    }
    return false;
};

Promise.prototype._cancelBranched = function() {
    if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
    }
};

Promise.prototype._cancel = function() {
    if (!this._isCancellable()) return;
    this._setCancelled();
    async.invoke(this._cancelPromises, this, undefined);
};

Promise.prototype._cancelPromises = function() {
    if (this._length() > 0) this._settlePromises();
};

Promise.prototype._unsetOnCancel = function() {
    this._onCancelField = undefined;
};

Promise.prototype._isCancellable = function() {
    return this.isPending() && !this._isCancelled();
};

Promise.prototype.isCancellable = function() {
    return this.isPending() && !this.isCancelled();
};

Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
    if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
    } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
            if (!internalOnly) {
                var e = tryCatch(onCancelCallback).call(this._boundValue());
                if (e === errorObj) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                }
            }
        } else {
            onCancelCallback._resultCancelled(this);
        }
    }
};

Promise.prototype._invokeOnCancel = function() {
    var onCancelCallback = this._onCancel();
    this._unsetOnCancel();
    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
};

Promise.prototype._invokeInternalOnCancel = function() {
    if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
    }
};

Promise.prototype._resultCancelled = function() {
    this.cancel();
};

};

},{"./util":36}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util");
var getKeys = _dereq_("./es5").keys;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function catchFilter(instances, cb, promise) {
    return function(e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
            var item = instances[i];

            if (item === Error ||
                (item != null && item.prototype instanceof Error)) {
                if (e instanceof item) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (typeof item === "function") {
                var matchesPredicate = tryCatch(item).call(boundTo, e);
                if (matchesPredicate === errorObj) {
                    return matchesPredicate;
                } else if (matchesPredicate) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (util.isObject(e)) {
                var keys = getKeys(item);
                for (var j = 0; j < keys.length; ++j) {
                    var key = keys[j];
                    if (item[key] != e[key]) {
                        continue predicateLoop;
                    }
                }
                return tryCatch(cb).call(boundTo, e);
            }
        }
        return NEXT_FILTER;
    };
}

return catchFilter;
};

},{"./es5":13,"./util":36}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var longStackTraces = false;
var contextStack = [];

Promise.prototype._promiseCreated = function() {};
Promise.prototype._pushContext = function() {};
Promise.prototype._popContext = function() {return null;};
Promise._peekContext = Promise.prototype._peekContext = function() {};

function Context() {
    this._trace = new Context.CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
    }
    return null;
};

function createContext() {
    if (longStackTraces) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}
Context.CapturedTrace = null;
Context.create = createContext;
Context.deactivateLongStackTraces = function() {};
Context.activateLongStackTraces = function() {
    var Promise_pushContext = Promise.prototype._pushContext;
    var Promise_popContext = Promise.prototype._popContext;
    var Promise_PeekContext = Promise._peekContext;
    var Promise_peekContext = Promise.prototype._peekContext;
    var Promise_promiseCreated = Promise.prototype._promiseCreated;
    Context.deactivateLongStackTraces = function() {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
    };
    longStackTraces = true;
    Promise.prototype._pushContext = Context.prototype._pushContext;
    Promise.prototype._popContext = Context.prototype._popContext;
    Promise._peekContext = Promise.prototype._peekContext = peekContext;
    Promise.prototype._promiseCreated = function() {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
    };
};
return Context;
};

},{}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, Context) {
var getDomain = Promise._getDomain;
var async = Promise._async;
var Warning = _dereq_("./errors").Warning;
var util = _dereq_("./util");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var printWarning;
var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
                        (true ||
                         util.env("BLUEBIRD_DEBUG") ||
                         util.env("NODE_ENV") === "development"));

var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
    (debugging || util.env("BLUEBIRD_WARNINGS")));

var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));

var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

Promise.prototype.suppressUnhandledRejections = function() {
    var target = this._target();
    target._bitField = ((target._bitField & (~1048576)) |
                      524288);
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 524288) !== 0) return;
    this._setRejectionIsUnhandled();
    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._setReturnedNonUndefined = function() {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._returnedNonUndefined = function() {
    return (this._bitField & 268435456) !== 0;
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._settledValue();
        this._setUnhandledRejectionIsNotified();
        fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 262144;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~262144);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 262144) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 1048576;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~1048576);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
    return warn(message, shouldUseOwnTrace, promise || this);
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var domain = getDomain();
    possiblyUnhandledRejection =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var domain = getDomain();
    unhandledRejectionHandled =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

var disableLongStackTraces = function() {};
Promise.longStackTraces = function () {
    if (async.haveItemsQueued() && !config.longStackTraces) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (!config.longStackTraces && longStackTracesIsSupported()) {
        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
        config.longStackTraces = true;
        disableLongStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Context.deactivateLongStackTraces();
            async.enableTrampoline();
            config.longStackTraces = false;
        };
        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
        Context.activateLongStackTraces();
        async.disableTrampolineIfNecessary();
    }
};

Promise.hasLongStackTraces = function () {
    return config.longStackTraces && longStackTracesIsSupported();
};

var fireDomEvent = (function() {
    try {
        if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new CustomEvent(name.toLowerCase(), {
                    detail: event,
                    cancelable: true
                });
                return !util.global.dispatchEvent(domEvent);
            };
        } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new Event(name.toLowerCase(), {
                    cancelable: true
                });
                domEvent.detail = event;
                return !util.global.dispatchEvent(domEvent);
            };
        } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = document.createEvent("CustomEvent");
                domEvent.initCustomEvent(name.toLowerCase(), false, true,
                    event);
                return !util.global.dispatchEvent(domEvent);
            };
        }
    } catch (e) {}
    return function() {
        return false;
    };
})();

var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function() {
            return process.emit.apply(process, arguments);
        };
    } else {
        if (!util.global) {
            return function() {
                return false;
            };
        }
        return function(name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
        };
    }
})();

function generatePromiseLifecycleEventObject(name, promise) {
    return {promise: promise};
}

var eventToObjectGenerator = {
    promiseCreated: generatePromiseLifecycleEventObject,
    promiseFulfilled: generatePromiseLifecycleEventObject,
    promiseRejected: generatePromiseLifecycleEventObject,
    promiseResolved: generatePromiseLifecycleEventObject,
    promiseCancelled: generatePromiseLifecycleEventObject,
    promiseChained: function(name, promise, child) {
        return {promise: promise, child: child};
    },
    warning: function(name, warning) {
        return {warning: warning};
    },
    unhandledRejection: function (name, reason, promise) {
        return {reason: reason, promise: promise};
    },
    rejectionHandled: generatePromiseLifecycleEventObject
};

var activeFireEvent = function (name) {
    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent.apply(null, arguments);
    } catch (e) {
        async.throwLater(e);
        globalEventFired = true;
    }

    var domEventFired = false;
    try {
        domEventFired = fireDomEvent(name,
                    eventToObjectGenerator[name].apply(null, arguments));
    } catch (e) {
        async.throwLater(e);
        domEventFired = true;
    }

    return domEventFired || globalEventFired;
};

Promise.config = function(opts) {
    opts = Object(opts);
    if ("longStackTraces" in opts) {
        if (opts.longStackTraces) {
            Promise.longStackTraces();
        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
        }
    }
    if ("warnings" in opts) {
        var warningsOption = opts.warnings;
        config.warnings = !!warningsOption;
        wForgottenReturn = config.warnings;

        if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
                wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
    }
    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
        if (async.haveItemsQueued()) {
            throw new Error(
                "cannot enable cancellation after promises are in use");
        }
        Promise.prototype._clearCancellationData =
            cancellationClearCancellationData;
        Promise.prototype._propagateFrom = cancellationPropagateFrom;
        Promise.prototype._onCancel = cancellationOnCancel;
        Promise.prototype._setOnCancel = cancellationSetOnCancel;
        Promise.prototype._attachCancellationCallback =
            cancellationAttachCancellationCallback;
        Promise.prototype._execute = cancellationExecute;
        propagateFromFunction = cancellationPropagateFrom;
        config.cancellation = true;
    }
    if ("monitoring" in opts) {
        if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
        } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
        }
    }
    return Promise;
};

function defaultFireEvent() { return false; }

Promise.prototype._fireEvent = defaultFireEvent;
Promise.prototype._execute = function(executor, resolve, reject) {
    try {
        executor(resolve, reject);
    } catch (e) {
        return e;
    }
};
Promise.prototype._onCancel = function () {};
Promise.prototype._setOnCancel = function (handler) { ; };
Promise.prototype._attachCancellationCallback = function(onCancel) {
    ;
};
Promise.prototype._captureStackTrace = function () {};
Promise.prototype._attachExtraTrace = function () {};
Promise.prototype._clearCancellationData = function() {};
Promise.prototype._propagateFrom = function (parent, flags) {
    ;
    ;
};

function cancellationExecute(executor, resolve, reject) {
    var promise = this;
    try {
        executor(resolve, reject, function(onCancel) {
            if (typeof onCancel !== "function") {
                throw new TypeError("onCancel must be a function, got: " +
                                    util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
        });
    } catch (e) {
        return e;
    }
}

function cancellationAttachCancellationCallback(onCancel) {
    if (!this._isCancellable()) return this;

    var previousOnCancel = this._onCancel();
    if (previousOnCancel !== undefined) {
        if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
        } else {
            this._setOnCancel([previousOnCancel, onCancel]);
        }
    } else {
        this._setOnCancel(onCancel);
    }
}

function cancellationOnCancel() {
    return this._onCancelField;
}

function cancellationSetOnCancel(onCancel) {
    this._onCancelField = onCancel;
}

function cancellationClearCancellationData() {
    this._cancellationParent = undefined;
    this._onCancelField = undefined;
}

function cancellationPropagateFrom(parent, flags) {
    if ((flags & 1) !== 0) {
        this._cancellationParent = parent;
        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
        if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
        }
        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
    }
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}

function bindingPropagateFrom(parent, flags) {
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}
var propagateFromFunction = bindingPropagateFrom;

function boundValueFunction() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
}

function longStackTracesCaptureStackTrace() {
    this._trace = new CapturedTrace(this._peekContext());
}

function longStackTracesAttachExtraTrace(error, ignoreSelf) {
    if (canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
}

function checkForgottenReturns(returnValue, promiseCreated, name, promise,
                               parent) {
    if (returnValue === undefined && promiseCreated !== null &&
        wForgottenReturn) {
        if (parent !== undefined && parent._returnedNonUndefined()) return;
        if ((promise._bitField & 65535) === 0) return;

        if (name) name = name + " ";
        var handlerLine = "";
        var creatorLine = "";
        if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
                var line = stack[i];
                if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                        handlerLine  = "at " + lineMatches[1] +
                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                }
            }

            if (stack.length > 0) {
                var firstUserLine = stack[0];
                for (var i = 0; i < traceLines.length; ++i) {

                    if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                            creatorLine = "\n" + traceLines[i - 1];
                        }
                        break;
                    }
                }

            }
        }
        var msg = "a promise was created in a " + name +
            "handler " + handlerLine + "but was not returned from it, " +
            "see http://goo.gl/rRqMUw" +
            creatorLine;
        promise._warn(msg, true, promiseCreated);
    }
}

function deprecated(name, replacement) {
    var message = name +
        " is deprecated and will be removed in a future version.";
    if (replacement) message += " Use " + replacement + " instead.";
    return warn(message);
}

function warn(message, shouldUseOwnTrace, promise) {
    if (!config.warnings) return;
    var warning = new Warning(message);
    var ctx;
    if (shouldUseOwnTrace) {
        promise._attachExtraTrace(warning);
    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }

    if (!activeFireEvent("warning", warning)) {
        formatAndLogError(warning, "", true);
    }
}

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = "    (No stack trace)" === line ||
            stackFramePattern.test(line);
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0 && error.name != "SyntaxError") {
        stack = stack.slice(i);
    }
    return stack;
}

function parseStackAndMessage(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
    };
}

function formatAndLogError(error, title, isSoft) {
    if (typeof console !== "undefined") {
        var message;
        if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof printWarning === "function") {
            printWarning(message, isSoft);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
}

function fireRejectionEvent(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    if (name === "unhandledRejection") {
        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
        }
    } else {
        activeFireEvent(name, promise);
    }
}

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj && typeof obj.toString === "function"
            ? obj.toString() : util.toString(obj);
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

function longStackTracesIsSupported() {
    return typeof captureStackTrace === "function";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}

function setBounds(firstLineError, lastLineError) {
    if (!longStackTracesIsSupported()) return;
    var firstStackLines = firstLineError.stack.split("\n");
    var lastStackLines = lastLineError.stack.split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
}

function CapturedTrace(parent) {
    this._parent = parent;
    this._promisesCreated = 0;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);
Context.CapturedTrace = CapturedTrace;

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit += 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit -= 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    printWarning = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        printWarning = function(message, isSoft) {
            console.warn("%c" + message,
                        isSoft ? "color: darkorange" : "color: red");
        };
    }
}

var config = {
    warnings: warnings,
    longStackTraces: false,
    cancellation: false,
    monitoring: false
};

if (longStackTraces) Promise.longStackTraces();

return {
    longStackTraces: function() {
        return config.longStackTraces;
    },
    warnings: function() {
        return config.warnings;
    },
    cancellation: function() {
        return config.cancellation;
    },
    monitoring: function() {
        return config.monitoring;
    },
    propagateFromFunction: function() {
        return propagateFromFunction;
    },
    boundValueFunction: function() {
        return boundValueFunction;
    },
    checkForgottenReturns: checkForgottenReturns,
    setBounds: setBounds,
    warn: warn,
    deprecated: deprecated,
    CapturedTrace: CapturedTrace,
    fireDomEvent: fireDomEvent,
    fireGlobalEvent: fireGlobalEvent
};
};

},{"./errors":12,"./util":36}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function returner() {
    return this.value;
}
function thrower() {
    throw this.reason;
}

Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value instanceof Promise) value.suppressUnhandledRejections();
    return this._then(
        returner, undefined, undefined, {value: value}, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    return this._then(
        thrower, undefined, undefined, {reason: reason}, undefined);
};

Promise.prototype.catchThrow = function (reason) {
    if (arguments.length <= 1) {
        return this._then(
            undefined, thrower, undefined, {reason: reason}, undefined);
    } else {
        var _reason = arguments[1];
        var handler = function() {throw _reason;};
        return this.caught(reason, handler);
    }
};

Promise.prototype.catchReturn = function (value) {
    if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(
            undefined, returner, undefined, {value: value}, undefined);
    } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function() {return _value;};
        return this.caught(value, handler);
    }
};
};

},{}],11:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;
var PromiseAll = Promise.all;

function promiseAllThis() {
    return PromiseAll(this);
}

function PromiseMapSeries(promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
}

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, this, undefined);
};

Promise.prototype.mapSeries = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, promises, undefined);
};

Promise.mapSeries = PromiseMapSeries;
};


},{}],12:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5":13,"./util":36}],13:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],14:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
var util = _dereq_("./util");
var CancellationError = Promise.CancellationError;
var errorObj = util.errorObj;
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);

function PassThroughHandlerContext(promise, type, handler) {
    this.promise = promise;
    this.type = type;
    this.handler = handler;
    this.called = false;
    this.cancelPromise = null;
}

PassThroughHandlerContext.prototype.isFinallyHandler = function() {
    return this.type === 0;
};

function FinallyHandlerCancelReaction(finallyHandler) {
    this.finallyHandler = finallyHandler;
}

FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
    checkCancel(this.finallyHandler);
};

function checkCancel(ctx, reason) {
    if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
            ctx.cancelPromise._reject(reason);
        } else {
            ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
    }
    return false;
}

function succeed() {
    return finallyHandler.call(this, this.promise._target()._settledValue());
}
function fail(reason) {
    if (checkCancel(this, reason)) return;
    errorObj.e = reason;
    return errorObj;
}
function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler()
            ? handler.call(promise._boundValue())
            : handler.call(promise._boundValue(), reasonOrValue);
        if (ret === NEXT_FILTER) {
            return ret;
        } else if (ret !== undefined) {
            promise._setReturnedNonUndefined();
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
                if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                        var reason =
                            new CancellationError("late cancellation observer");
                        promise._attachExtraTrace(reason);
                        errorObj.e = reason;
                        return errorObj;
                    } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(
                            new FinallyHandlerCancelReaction(this));
                    }
                }
                return maybePromise._then(
                    succeed, fail, undefined, this, undefined);
            }
        }
    }

    if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
    } else {
        checkCancel(this);
        return reasonOrValue;
    }
}

Promise.prototype._passThrough = function(handler, type, success, fail) {
    if (typeof handler !== "function") return this.then();
    return this._then(success,
                      fail,
                      undefined,
                      new PassThroughHandlerContext(this, type, handler),
                      undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThrough(handler,
                             0,
                             finallyHandler,
                             finallyHandler);
};


Promise.prototype.tap = function (handler) {
    return this._passThrough(handler, 1, finallyHandler);
};

Promise.prototype.tapCatch = function (handlerOrPredicate) {
    var len = arguments.length;
    if(len === 1) {
        return this._passThrough(handlerOrPredicate,
                                 1,
                                 undefined,
                                 finallyHandler);
    } else {
         var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(new TypeError(
                    "tapCatch statement predicate: "
                    + "expecting an object but got " + util.classString(item)
                ));
            }
        }
        catchInstances.length = j;
        var handler = arguments[i];
        return this._passThrough(catchFilter(catchInstances, handler, this),
                                 1,
                                 undefined,
                                 finallyHandler);
    }

};

return PassThroughHandlerContext;
};

},{"./catch_filter":7,"./util":36}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise,
                          Proxyable,
                          debug) {
var errors = _dereq_("./errors");
var TypeError = errors.TypeError;
var util = _dereq_("./util");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function() {
            return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
    } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
    }
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
    this._yieldedPromise = null;
    this._cancellationPhase = false;
}
util.inherits(PromiseSpawn, Proxyable);

PromiseSpawn.prototype._isResolved = function() {
    return this._promise === null;
};

PromiseSpawn.prototype._cleanup = function() {
    this._promise = this._generator = null;
    if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
    }
};

PromiseSpawn.prototype._promiseCancelled = function() {
    if (this._isResolved()) return;
    var implementsReturn = typeof this._generator["return"] !== "undefined";

    var result;
    if (!implementsReturn) {
        var reason = new Promise.CancellationError(
            "generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator,
                                                         reason);
        this._promise._popContext();
    } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator,
                                                          undefined);
        this._promise._popContext();
    }
    this._cancellationPhase = true;
    this._yieldedPromise = null;
    this._continue(result);
};

PromiseSpawn.prototype._promiseFulfilled = function(value) {
    this._yieldedPromise = null;
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._promiseRejected = function(reason) {
    this._yieldedPromise = null;
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._resultCancelled = function() {
    if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
    }
};

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._promiseFulfilled(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    var promise = this._promise;
    if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._rejectCallback(result.e, false);
        }
    }

    var value = result.value;
    if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._resolveCallback(value);
        }
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._promiseRejected(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if (((bitField & 50397184) === 0)) {
            this._yieldedPromise = maybePromise;
            maybePromise._proxy(this, null);
        } else if (((bitField & 33554432) !== 0)) {
            Promise._async.invoke(
                this._promiseFulfilled, this, maybePromise._value()
            );
        } else if (((bitField & 16777216) !== 0)) {
            Promise._async.invoke(
                this._promiseRejected, this, maybePromise._reason()
            );
        } else {
            this._promiseCancelled();
        }
    }
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors":12,"./util":36}],17:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
         getDomain) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (false) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var promiseSetter = function(i) {
        return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
    };

    var generateHolderClass = function(total) {
        var props = new Array(total);
        for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i+1);
        }
        var assignment = props.join(" = ") + " = null;";
        var cancellationCode= "var promise;\n" + props.map(function(prop) {
            return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
        }).join("\n");
        var passedArguments = props.join(", ");
        var name = "Holder$" + total;


        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";

        code = code.replace(/\[TheName\]/g, name)
            .replace(/\[TheTotal\]/g, total)
            .replace(/\[ThePassedArguments\]/g, passedArguments)
            .replace(/\[TheProperties\]/g, assignment)
            .replace(/\[CancellationCode\]/g, cancellationCode);

        return new Function("tryCatch", "errorObj", "Promise", "async", code)
                           (tryCatch, errorObj, Promise, async);
    };

    var holderClasses = [];
    var thenCallbacks = [];
    var promiseSetters = [];

    for (var i = 0; i < 8; ++i) {
        holderClasses.push(generateHolderClass(i + 1));
        thenCallbacks.push(thenCallback(i + 1));
        promiseSetters.push(promiseSetter(i + 1));
    }

    reject = function (reason) {
        this._reject(reason);
    };
}}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (false) {
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;

                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;
                        if (((bitField & 50397184) === 0)) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if (((bitField & 33554432) !== 0)) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else if (((bitField & 16777216) !== 0)) {
                            ret._reject(maybePromise._reason());
                        } else {
                            ret._cancel();
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }

                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var domain = getDomain();
                        if (domain !== null) {
                            holder.fn = util.domainBind(domain, holder.fn);
                        }
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
    }
    var args = [].slice.call(arguments);;
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util":36}],18:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var domain = getDomain();
    this._callback = domain === null ? fn : util.domainBind(domain, fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = [];
    async.invoke(this._asyncInit, this, undefined);
}
util.inherits(MappingPromiseArray, PromiseArray);

MappingPromiseArray.prototype._asyncInit = function() {
    this._init$(undefined, -2);
};

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;

    if (index < 0) {
        index = (index * -1) - 1;
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return true;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(
            ret,
            promiseCreated,
            preservedValues !== null ? "Promise.filter" : "Promise.map",
            promise
        );
        if (ret === errorObj) {
            this._reject(ret.e);
            return true;
        }

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            ;
            if (((bitField & 50397184) === 0)) {
                if (limit >= 1) this._inFlight++;
                values[index] = maybePromise;
                maybePromise._proxy(this, (index + 1) * -1);
                return false;
            } else if (((bitField & 33554432) !== 0)) {
                ret = maybePromise._value();
            } else if (((bitField & 16777216) !== 0)) {
                this._reject(maybePromise._reason());
                return true;
            } else {
                this._cancel();
                return true;
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }
        return true;
    }
    return false;
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }

    var limit = 0;
    if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
            if (typeof options.concurrency !== "number") {
                return Promise.reject(
                    new TypeError("'concurrency' must be a number but it is " +
                                    util.classString(options.concurrency)));
            }
            limit = options.concurrency;
        } else {
            return Promise.reject(new TypeError(
                            "options argument must be an object but it is " +
                             util.classString(options)));
        }
    }
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
}

Promise.prototype.map = function (fn, options) {
    return map(this, fn, options, null);
};

Promise.map = function (promises, fn, options, _filter) {
    return map(promises, fn, options, _filter);
};


};

},{"./util":36}],19:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(
            value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value;
    if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
                                  : tryCatch(fn).call(ctx, arg);
    } else {
        value = tryCatch(fn)();
    }
    var promiseCreated = ret._popContext();
    debug.checkForgottenReturns(
        value, promiseCreated, "Promise.try", ret);
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util":36}],20:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors");
var OperationalError = errors.OperationalError;
var es5 = _dereq_("./es5");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) {
            promise._fulfill(value);
        } else {
            var args = [].slice.call(arguments, 1);;
            promise._fulfill(args);
        }
        promise = null;
    };
}

module.exports = nodebackForPromise;

},{"./errors":12,"./es5":13,"./util":36}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util");
var async = Promise._async;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
                                                                     options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./util":36}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var reflectHandler = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
function Proxyable() {}
var UNDEFINED_BINDING = {};
var util = _dereq_("./util");

var getDomain;
if (util.isNode) {
    getDomain = function() {
        var ret = process.domain;
        if (ret === undefined) ret = null;
        return ret;
    };
} else {
    getDomain = function() {
        return null;
    };
}
util.notEnumerableProp(Promise, "_getDomain", getDomain);

var es5 = _dereq_("./es5");
var Async = _dereq_("./async");
var async = new Async();
es5.defineProperty(Promise, "_async", {value: async});
var errors = _dereq_("./errors");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
var CancellationError = Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {};
var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array")(Promise, INTERNAL,
                               tryConvertToPromise, apiRejection, Proxyable);
var Context = _dereq_("./context")(Promise);
 /*jshint unused:false*/
var createContext = Context.create;
var debug = _dereq_("./debuggability")(Promise, Context);
var CapturedTrace = debug.CapturedTrace;
var PassThroughHandlerContext =
    _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
var nodebackForPromise = _dereq_("./nodeback");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function check(self, executor) {
    if (self == null || self.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (typeof executor !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(executor));
    }

}

function Promise(executor) {
    if (executor !== INTERNAL) {
        check(this, executor);
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._resolveFromExecutor(executor);
    this._promiseCreated();
    this._fireEvent("promiseCreated", this);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return apiRejection("Catch statement predicate: " +
                    "expecting an object but got " + util.classString(item));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];
        return this.then(undefined, catchFilter(catchInstances, fn, this));
    }
    return this.then(undefined, fn);
};

Promise.prototype.reflect = function () {
    return this._then(reflectHandler,
        reflectHandler, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject) {
    if (debug.warnings() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, undefined, undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject) {
    var promise =
        this._then(didFulfill, didReject, undefined, undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    if (arguments.length > 0) {
        this._warn(".all() was passed arguments but it does not take any");
    }
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = Promise.fromCallback = function(fn) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
                                         : false;
    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true);
    }
    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._setFulfilled();
        ret._rejectionHandler0 = obj;
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    return async.setScheduler(fn);
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    _,    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
    var target = this._target();
    var bitField = target._bitField;

    if (!haveInternalData) {
        promise._propagateFrom(this, 3);
        promise._captureStackTrace();
        if (receiver === undefined &&
            ((this._bitField & 2097152) !== 0)) {
            if (!((bitField & 50397184) === 0)) {
                receiver = this._boundValue();
            } else {
                receiver = target === this ? undefined : this._boundTo;
            }
        }
        this._fireEvent("promiseChained", this, promise);
    }

    var domain = getDomain();
    if (!((bitField & 50397184) === 0)) {
        var handler, value, settler = target._settlePromiseCtx;
        if (((bitField & 33554432) !== 0)) {
            value = target._rejectionHandler0;
            handler = didFulfill;
        } else if (((bitField & 16777216) !== 0)) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
        } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
        }

        async.invoke(settler, target, {
            handler: domain === null ? handler
                : (typeof handler === "function" &&
                    util.domainBind(domain, handler)),
            promise: promise,
            receiver: receiver,
            value: value
        });
    } else {
        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
    }

    return promise;
};

Promise.prototype._length = function () {
    return this._bitField & 65535;
};

Promise.prototype._isFateSealed = function () {
    return (this._bitField & 117506048) !== 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 67108864) === 67108864;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -65536) |
        (len & 65535);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 33554432;
    this._fireEvent("promiseFulfilled", this);
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 16777216;
    this._fireEvent("promiseRejected", this);
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 67108864;
    this._fireEvent("promiseResolved", this);
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._unsetCancelled = function() {
    this._bitField = this._bitField & (~65536);
};

Promise.prototype._setCancelled = function() {
    this._bitField = this._bitField | 65536;
    this._fireEvent("promiseCancelled", this);
};

Promise.prototype._setWillBeCancelled = function() {
    this._bitField = this._bitField | 8388608;
};

Promise.prototype._setAsyncGuaranteed = function() {
    if (async.hasCustomScheduler()) return;
    this._bitField = this._bitField | 134217728;
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0 ? this._receiver0 : this[
            index * 4 - 4 + 3];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return this[
            index * 4 - 4 + 2];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 1];
};

Promise.prototype._boundValue = function() {};

Promise.prototype._migrateCallback0 = function (follower) {
    var bitField = follower._bitField;
    var fulfill = follower._fulfillmentHandler0;
    var reject = follower._rejectionHandler0;
    var promise = follower._promise0;
    var receiver = follower._receiverAt(0);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._migrateCallbackAt = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    promise,
    receiver,
    domain
) {
    var index = this._length();

    if (index >= 65535 - 4) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        this._receiver0 = receiver;
        if (typeof fulfill === "function") {
            this._fulfillmentHandler0 =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    } else {
        var base = index * 4 - 4;
        this[base + 2] = promise;
        this[base + 3] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._proxy = function (proxyable, arg) {
    this._addCallbacks(undefined, undefined, arg, proxyable, null);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (((this._bitField & 117506048) !== 0)) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    if (shouldBind) this._propagateFrom(maybePromise, 2);

    var promise = maybePromise._target();

    if (promise === this) {
        this._reject(makeSelfResolutionError());
        return;
    }

    var bitField = promise._bitField;
    if (((bitField & 50397184) === 0)) {
        var len = this._length();
        if (len > 0) promise._migrateCallback0(this);
        for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(promise);
    } else if (((bitField & 33554432) !== 0)) {
        this._fulfill(promise._value());
    } else if (((bitField & 16777216) !== 0)) {
        this._reject(promise._reason());
    } else {
        var reason = new CancellationError("late cancellation observer");
        promise._attachExtraTrace(reason);
        this._reject(reason);
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, ignoreNonErrorWarnings) {
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
        var message = "a promise was rejected with a non-error: " +
            util.classString(reason);
        this._warn(message, true);
    }
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason);
};

Promise.prototype._resolveFromExecutor = function (executor) {
    if (executor === INTERNAL) return;
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = this._execute(executor, function(value) {
        promise._resolveCallback(value);
    }, function (reason) {
        promise._rejectCallback(reason, synchronous);
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined) {
        promise._rejectCallback(r, true);
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    var bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY) {
        if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " +
                                    util.classString(value));
        } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
        }
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    var promiseCreated = promise._popContext();
    bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;

    if (x === NEXT_FILTER) {
        promise._reject(value);
    } else if (x === errorObj) {
        promise._rejectCallback(x.e, false);
    } else {
        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
    var isPromise = promise instanceof Promise;
    var bitField = this._bitField;
    var asyncGuaranteed = ((bitField & 134217728) !== 0);
    if (((bitField & 65536) !== 0)) {
        if (isPromise) promise._invokeInternalOnCancel();

        if (receiver instanceof PassThroughHandlerContext &&
            receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
                promise._reject(errorObj.e);
            }
        } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
        } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
        } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
        } else {
            receiver.cancel();
        }
    } else if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof Proxyable) {
        if (!receiver._isResolved()) {
            if (((bitField & 33554432) !== 0)) {
                receiver._promiseFulfilled(value, promise);
            } else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (asyncGuaranteed) promise._setAsyncGuaranteed();
        if (((bitField & 33554432) !== 0)) {
            promise._fulfill(value);
        } else {
            promise._reject(value);
        }
    }
};

Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
    var handler = ctx.handler;
    var promise = ctx.promise;
    var receiver = ctx.receiver;
    var value = ctx.value;
    if (typeof handler === "function") {
        if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (promise instanceof Promise) {
        promise._reject(value);
    }
};

Promise.prototype._settlePromiseCtx = function(ctx) {
    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
};

Promise.prototype._settlePromise0 = function(handler, value, bitField) {
    var promise = this._promise0;
    var receiver = this._receiverAt(0);
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settlePromise(promise, handler, receiver, value);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    var base = index * 4 - 4;
    this[base + 2] =
    this[base + 3] =
    this[base + 0] =
    this[base + 1] = undefined;
};

Promise.prototype._fulfill = function (value) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._reject(err);
    }
    this._setFulfilled();
    this._rejectionHandler0 = value;

    if ((bitField & 65535) > 0) {
        if (((bitField & 134217728) !== 0)) {
            this._settlePromises();
        } else {
            async.settlePromises(this);
        }
    }
};

Promise.prototype._reject = function (reason) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    this._setRejected();
    this._fulfillmentHandler0 = reason;

    if (this._isFinal()) {
        return async.fatalError(reason, util.isNode);
    }

    if ((bitField & 65535) > 0) {
        async.settlePromises(this);
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._fulfillPromises = function (len, value) {
    for (var i = 1; i < len; i++) {
        var handler = this._fulfillmentHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, value);
    }
};

Promise.prototype._rejectPromises = function (len, reason) {
    for (var i = 1; i < len; i++) {
        var handler = this._rejectionHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, reason);
    }
};

Promise.prototype._settlePromises = function () {
    var bitField = this._bitField;
    var len = (bitField & 65535);

    if (len > 0) {
        if (((bitField & 16842752) !== 0)) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
        } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
        }
        this._setLength(0);
    }
    this._clearCancellationData();
};

Promise.prototype._settledValue = function() {
    var bitField = this._bitField;
    if (((bitField & 33554432) !== 0)) {
        return this._rejectionHandler0;
    } else if (((bitField & 16777216) !== 0)) {
        return this._fulfillmentHandler0;
    }
};

function deferResolve(v) {this.promise._resolveCallback(v);}
function deferReject(v) {this.promise._rejectCallback(v, false);}

Promise.defer = Promise.pending = function() {
    debug.deprecated("Promise.defer", "new Promise");
    var promise = new Promise(INTERNAL);
    return {
        promise: promise,
        resolve: deferResolve,
        reject: deferReject
    };
};

util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
    debug);
_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
_dereq_("./direct_resolve")(Promise);
_dereq_("./synchronous_inspection")(Promise);
_dereq_("./join")(
    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
Promise.Promise = Promise;
Promise.version = "3.5.0";
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./call_get.js')(Promise);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
_dereq_('./timers.js')(Promise, INTERNAL, debug);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
_dereq_('./nodeify.js')(Promise);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./settle.js')(Promise, PromiseArray, debug);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./filter.js')(Promise, INTERNAL);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./any.js')(Promise);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    debug.setBounds(Async.firstLineError, util.lastLineError);               
    return Promise;                                                          

};

},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection, Proxyable) {
var util = _dereq_("./util");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    case -6: return new Map();
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
    }
    promise._setOnCancel(this);
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
util.inherits(PromiseArray, Proxyable);

PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;

        if (((bitField & 50397184) === 0)) {
            this._promise._setAsyncGuaranteed();
            return values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
        } else if (((bitField & 33554432) !== 0)) {
            values = values._value();
        } else if (((bitField & 16777216) !== 0)) {
            return this._reject(values._reason());
        } else {
            return this._cancel();
        }
    }
    values = util.asArray(values);
    if (values === null) {
        var err = apiRejection(
            "expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    this._iterate(values);
};

PromiseArray.prototype._iterate = function(values) {
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var result = this._promise;
    var isResolved = false;
    var bitField = null;
    for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);

        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            bitField = maybePromise._bitField;
        } else {
            bitField = null;
        }

        if (isResolved) {
            if (bitField !== null) {
                maybePromise.suppressUnhandledRejections();
            }
        } else if (bitField !== null) {
            if (((bitField & 50397184) === 0)) {
                maybePromise._proxy(this, i);
                this._values[i] = maybePromise;
            } else if (((bitField & 33554432) !== 0)) {
                isResolved = this._promiseFulfilled(maybePromise._value(), i);
            } else if (((bitField & 16777216) !== 0)) {
                isResolved = this._promiseRejected(maybePromise._reason(), i);
            } else {
                isResolved = this._promiseCancelled(i);
            }
        } else {
            isResolved = this._promiseFulfilled(maybePromise, i);
        }
    }
    if (!isResolved) result._setAsyncGuaranteed();
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype._cancel = function() {
    if (this._isResolved() || !this._promise._isCancellable()) return;
    this._values = null;
    this._promise._cancel();
};

PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false);
};

PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

PromiseArray.prototype._promiseCancelled = function() {
    this._cancel();
    return true;
};

PromiseArray.prototype._promiseRejected = function (reason) {
    this._totalResolved++;
    this._reject(reason);
    return true;
};

PromiseArray.prototype._resultCancelled = function() {
    if (this._isResolved()) return;
    var values = this._values;
    this._cancel();
    if (values instanceof Promise) {
        values.cancel();
    } else {
        for (var i = 0; i < values.length; ++i) {
            if (values[i] instanceof Promise) {
                values[i].cancel();
            }
        }
    }
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util":36}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util");
var nodebackForPromise = _dereq_("./nodeback");
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (false) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn, _, multiArgs) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";
    var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode);
    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL",
                        body)(
                    Promise,
                    fn,
                    receiver,
                    withAppended,
                    maybeWrapAsError,
                    nodebackForPromise,
                    util.tryCatch,
                    util.errorObj,
                    util.notEnumerableProp,
                    INTERNAL);
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key,
                                           fn, suffix, multiArgs);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver, multiArgs) {
    return makeNodePromisified(callback, receiver, undefined,
                                callback, null, multiArgs);
}

Promise.promisify = function (fn, options) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    if (isPromisified(fn)) {
        return fn;
    }
    options = Object(options);
    var receiver = options.context === undefined ? THIS : options.context;
    var multiArgs = !!options.multiArgs;
    var ret = promisify(fn, receiver, multiArgs);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    options = Object(options);
    var multiArgs = !!options.multiArgs;
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier,
                multiArgs);
            promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
};
};


},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");
var isObject = util.isObject;
var es5 = _dereq_("./es5");
var Es6Map;
if (typeof Map === "function") Es6Map = Map;

var mapToEntries = (function() {
    var index = 0;
    var size = 0;

    function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
    }

    return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
    };
})();

var entriesToMap = function(entries) {
    var ret = new Es6Map();
    var length = entries.length / 2 | 0;
    for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
    }
    return ret;
};

function PropertiesPromiseArray(obj) {
    var isMap = false;
    var entries;
    if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
    } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
            var key = keys[i];
            entries[i] = obj[key];
            entries[i + len] = key;
        }
    }
    this.constructor$(entries);
    this._isMap = isMap;
    this._init$(undefined, isMap ? -6 : -3);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
            val = entriesToMap(this._values);
        } else {
            val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
                val[this._values[i + keyOffset]] = this._values[i];
            }
        }
        this._resolve(val);
        return true;
    }
    return false;
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5":13,"./util":36}],26:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else {
        promises = util.asArray(promises);
        if (promises === null)
            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util":36}],28:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

function ReductionPromiseArray(promises, fn, initialValue, _each) {
    this.constructor$(promises);
    var domain = getDomain();
    this._fn = domain === null ? fn : util.domainBind(domain, fn);
    if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
    }
    this._initialValue = initialValue;
    this._currentCancellable = null;
    if(_each === INTERNAL) {
        this._eachValues = Array(this._length);
    } else if (_each === 0) {
        this._eachValues = null;
    } else {
        this._eachValues = undefined;
    }
    this._promise._captureStackTrace();
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._gotAccum = function(accum) {
    if (this._eachValues !== undefined && 
        this._eachValues !== null && 
        accum !== INTERNAL) {
        this._eachValues.push(accum);
    }
};

ReductionPromiseArray.prototype._eachComplete = function(value) {
    if (this._eachValues !== null) {
        this._eachValues.push(value);
    }
    return this._eachValues;
};

ReductionPromiseArray.prototype._init = function() {};

ReductionPromiseArray.prototype._resolveEmptyArray = function() {
    this._resolve(this._eachValues !== undefined ? this._eachValues
                                                 : this._initialValue);
};

ReductionPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

ReductionPromiseArray.prototype._resolve = function(value) {
    this._promise._resolveCallback(value);
    this._values = null;
};

ReductionPromiseArray.prototype._resultCancelled = function(sender) {
    if (sender === this._initialValue) return this._cancel();
    if (this._isResolved()) return;
    this._resultCancelled$();
    if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
    }
    if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
    }
};

ReductionPromiseArray.prototype._iterate = function (values) {
    this._values = values;
    var value;
    var i;
    var length = values.length;
    if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
    } else {
        value = Promise.resolve(values[0]);
        i = 1;
    }

    this._currentCancellable = value;

    if (!value.isRejected()) {
        for (; i < length; ++i) {
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };
            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
        }
    }

    if (this._eachValues !== undefined) {
        value = value
            ._then(this._eachComplete, undefined, undefined, this, undefined);
    }
    value._then(completed, completed, undefined, value, this);
};

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};

function completed(valueOrReason, array) {
    if (this.isFulfilled()) {
        array._resolve(valueOrReason);
    } else {
        array._reject(valueOrReason);
    }
}

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

function gotAccum(accum) {
    this.accum = accum;
    this.array._gotAccum(accum);
    var value = tryConvertToPromise(this.value, this.array._promise);
    if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
    } else {
        return gotValue.call(this, value);
    }
}

function gotValue(value) {
    var array = this.array;
    var promise = array._promise;
    var fn = tryCatch(array._fn);
    promise._pushContext();
    var ret;
    if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
    } else {
        ret = fn.call(promise._boundValue(),
                              this.accum, value, this.index, this.length);
    }
    if (ret instanceof Promise) {
        array._currentCancellable = ret;
    }
    var promiseCreated = promise._popContext();
    debug.checkForgottenReturns(
        ret,
        promiseCreated,
        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
        promise
    );
    return ret;
}
};

},{"./util":36}],29:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var NativePromise = util.getNativePromise();
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if (typeof NativePromise === "function" &&
           typeof NativePromise.resolve === "function") {
    var nativePromise = NativePromise.resolve();
    schedule = function(fn) {
        nativePromise.then(fn);
    };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            (window.navigator.standalone || window.cordova))) {
    schedule = (function() {
        var div = document.createElement("div");
        var opts = {attributes: true};
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function() {
            div.classList.toggle("foo");
            toggleScheduled = false;
        });
        o2.observe(div2, opts);

        var scheduleToggle = function() {
            if (toggleScheduled) return;
            toggleScheduled = true;
            div2.classList.toggle("foo");
        };

        return function schedule(fn) {
            var o = new MutationObserver(function() {
                o.disconnect();
                fn();
            });
            o.observe(div, opts);
            scheduleToggle();
        };
    })();
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util":36}],30:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray, debug) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 33554432;
    ret._settledValueField = value;
    return this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 16777216;
    ret._settledValueField = reason;
    return this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    debug.deprecated(".settle()", ".reflect()");
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return Promise.settle(this);
};
};

},{"./util":36}],31:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util");
var RangeError = _dereq_("./errors").RangeError;
var AggregateError = _dereq_("./errors").AggregateError;
var isArray = util.isArray;
var CANCELLATION = {};


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
        return true;
    }
    return false;

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    return this._checkOutcome();
};

SomePromiseArray.prototype._promiseCancelled = function () {
    if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
    }
    this._addRejected(CANCELLATION);
    return this._checkOutcome();
};

SomePromiseArray.prototype._checkOutcome = function() {
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            if (this._values[i] !== CANCELLATION) {
                e.push(this._values[i]);
            }
        }
        if (e.length > 0) {
            this._reject(e);
        } else {
            this._cancel();
        }
        return true;
    }
    return false;
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors":12,"./util":36}],32:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed()
            ? promise._settledValue() : undefined;
    }
    else {
        this._bitField = 0;
        this._settledValueField = undefined;
    }
}

PromiseInspection.prototype._settledValue = function() {
    return this._settledValueField;
};

var value = PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var reason = PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
    return (this._bitField & 33554432) !== 0;
};

var isRejected = PromiseInspection.prototype.isRejected = function () {
    return (this._bitField & 16777216) !== 0;
};

var isPending = PromiseInspection.prototype.isPending = function () {
    return (this._bitField & 50397184) === 0;
};

var isResolved = PromiseInspection.prototype.isResolved = function () {
    return (this._bitField & 50331648) !== 0;
};

PromiseInspection.prototype.isCancelled = function() {
    return (this._bitField & 8454144) !== 0;
};

Promise.prototype.__isCancelled = function() {
    return (this._bitField & 65536) === 65536;
};

Promise.prototype._isCancelled = function() {
    return this._target().__isCancelled();
};

Promise.prototype.isCancelled = function() {
    return (this._target()._bitField & 8454144) !== 0;
};

Promise.prototype.isPending = function() {
    return isPending.call(this._target());
};

Promise.prototype.isRejected = function() {
    return isRejected.call(this._target());
};

Promise.prototype.isFulfilled = function() {
    return isFulfilled.call(this._target());
};

Promise.prototype.isResolved = function() {
    return isResolved.call(this._target());
};

Promise.prototype.value = function() {
    return value.call(this._target());
};

Promise.prototype.reason = function() {
    var target = this._target();
    target._unsetRejectionIsUnhandled();
    return reason.call(target);
};

Promise.prototype._value = function() {
    return this._settledValue();
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue();
};

Promise.PromiseInspection = PromiseInspection;
};

},{}],33:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            if (isAnyBluebirdPromise(obj)) {
                var ret = new Promise(INTERNAL);
                obj._then(
                    ret._fulfill,
                    ret._reject,
                    undefined,
                    ret,
                    null
                );
                return ret;
            }
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function doGetThen(obj) {
    return obj.then;
}

function getThen(obj) {
    try {
        return doGetThen(obj);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    try {
        return hasProp.call(obj, "_promise0");
    } catch (e) {
        return false;
    }
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x, resolve, reject);
    synchronous = false;

    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util":36}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, debug) {
var util = _dereq_("./util");
var TimeoutError = Promise.TimeoutError;

function HandleWrapper(handle)  {
    this.handle = handle;
}

HandleWrapper.prototype._resultCancelled = function() {
    clearTimeout(this.handle);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (ms, value) {
    var ret;
    var handle;
    if (value !== undefined) {
        ret = Promise.resolve(value)
                ._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
            ret._setOnCancel(value);
        }
    } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function() { ret._fulfill(); }, +ms);
        if (debug.cancellation()) {
            ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
    }
    ret._setAsyncGuaranteed();
    return ret;
};

Promise.prototype.delay = function (ms) {
    return delay(ms, this);
};

var afterTimeout = function (promise, message, parent) {
    var err;
    if (typeof message !== "string") {
        if (message instanceof Error) {
            err = message;
        } else {
            err = new TimeoutError("operation timed out");
        }
    } else {
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._reject(err);

    if (parent != null) {
        parent.cancel();
    }
};

function successClear(value) {
    clearTimeout(this.handle);
    return value;
}

function failureClear(reason) {
    clearTimeout(this.handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret, parent;

    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
            afterTimeout(ret, message, parent);
        }
    }, ms));

    if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
    } else {
        ret = this._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
    }

    return ret;
};

};

},{"./util":36}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext, INTERNAL, debug) {
    var util = _dereq_("./util");
    var TypeError = _dereq_("./errors").TypeError;
    var inherits = _dereq_("./util").inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret;
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return NULL;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length-1] = null;
    }

    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for (var i = 0; i < len; ++i) {
            var item = this[i];
            if (item instanceof Promise) {
                item.cancel();
            }
        }
    };

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") {
            return apiRejection("expecting a function but got " + util.classString(fn));
        }
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var reflectedResources = new Array(resources.length);
        for (var i = 0; i < reflectedResources.length; ++i) {
            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        }

        var resultPromise = Promise.all(reflectedResources)
            .then(function(inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                    var inspection = inspections[i];
                    if (inspection.isRejected()) {
                        errorObj.e = inspection.error();
                        return errorObj;
                    } else if (!inspection.isFulfilled()) {
                        resultPromise.cancel();
                        return;
                    }
                    inspections[i] = inspection.value();
                }
                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs
                    ? fn.apply(undefined, inspections) : fn(inspections);
                var promiseCreated = promise._popContext();
                debug.checkForgottenReturns(
                    ret, promiseCreated, "Promise.using", promise);
                return ret;
            });

        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 131072) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~131072);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors":12,"./util":36}],36:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var canEvaluate = typeof navigator == "undefined";

var errorObj = {e: {}};
var tryCatchTarget;
var globalObject = typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    this !== undefined ? this : null;

function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return typeof value === "function" ||
           typeof value === "object" && value !== null;
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var l = 8;
    while (l--) new FakeConstructor();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function isError(obj) {
    return obj !== null &&
           typeof obj === "object" &&
           typeof obj.message === "string" &&
           typeof obj.name === "string";
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return isError(obj) && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var asArray = function(v) {
    if (es5.isArray(v)) {
        return v;
    }
    return null;
};

if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!((itResult = it.next()).done)) {
            ret.push(itResult.value);
        }
        return ret;
    };

    asArray = function(v) {
        if (es5.isArray(v)) {
            return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
            return ArrayFrom(v);
        }
        return null;
    };
}

var isNode = typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]";

var hasEnvVariables = typeof process !== "undefined" &&
    "object" !== "undefined";

function env(key) {
    return hasEnvVariables ? Object({"STRIPE_PUBLIC_KEY":"pk_live_3DIaCH9RC6TUHFN58h8Rr0LW","ROLLBAR_CLIENT_KEY":"fc1e0ac7f2ac4f5c8b3bfa42270fe680","NODE_ENV":"production","GA_CODE":"UA-27853143-1","CONTENTFUL_HELPSIDEBAR":"5829e984567fa554706e6cfed3a025cfcf1df1d9a1495ef9b32962299e4400ac","API_URL":"https://rest.tourconnect.com","API_AUTH_TOKEN":"Basic cHJvZC1jb250cmFjdGluZzpVa2lyMFA1dHNi","REAL_API_URL":undefined,"NEW_SYSTEM_URL":"https://app.tourconnect.com","ADD_IN_URL":"https://outlook.tourconnect.com","SYSTEM_URL":"https://contracting.tourconnect.com","SECONDARY_SYSTEM_URL":"https://sec.tourconnect.com","INTERCOM_APP":"jfwd6pzo"})[key] : undefined;
}

function getNativePromise() {
    if (typeof Promise === "function") {
        try {
            var promise = new Promise(function(){});
            if ({}.toString.call(promise) === "[object Promise]") {
                return Promise;
            }
        } catch (e) {}
    }
}

function domainBind(self, cb) {
    return self.bind(cb);
}

var ret = {
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    asArray: asArray,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    isError: isError,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome &&
                 typeof chrome.loadTimes === "function",
    isNode: isNode,
    hasEnvVariables: hasEnvVariables,
    env: env,
    global: globalObject,
    getNativePromise: getNativePromise,
    domainBind: domainBind
};
ret.isRecentNode = ret.isNode && (function() {
    var version = process.versions.node.split(".").map(Number);
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5":13}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93), __webpack_require__(51), __webpack_require__(1376).setImmediate))

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPartnersForMM = undefined;
exports.updateMMProps = updateMMProps;
exports.updateMMPartnerProps = updateMMPartnerProps;
exports.checkConnection = checkConnection;
exports.uncheckConnection = uncheckConnection;
exports.clearStore = clearStore;
exports.getMarketingMaterials = getMarketingMaterials;
exports.editMMField = editMMField;
exports.sendMM = sendMM;
exports.updateMMSignUpProps = updateMMSignUpProps;

var _constants = __webpack_require__(1444);

var constants = _interopRequireWildcard(_constants);

var _marketingMaterialsGraphqlQuery = __webpack_require__(2738);

var queries = _interopRequireWildcard(_marketingMaterialsGraphqlQuery);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _actions = __webpack_require__(537);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getPartnersForMM = exports.getPartnersForMM = function getPartnersForMM() {
  return (0, _actions.loadPartners)(constants.GETTING_PARTNERS, constants.GOT_PARTNERS);
};

function updateMMProps(payload) {
  return { type: constants.UPDATE_MM_PROP, payload: payload };
}

function updateMMPartnerProps(payload) {
  return { type: constants.UPDATE_MM_PARTNER_PROP, payload: payload };
}

function checkConnection(payload) {
  return { type: constants.CHECK_CONNECTION, payload: payload };
}

function uncheckConnection(payload) {
  return { type: constants.UNCHECK_CONNECTION, payload: payload };
}

function clearStore() {
  return { type: constants.CLEAR_STORE };
}

function getMarketingMaterials(companyId) {
  return function (dispatch) {
    dispatch({ type: constants.GETTING_MARKETING_MATERIALS });
    return fetch('/proxy/company/' + companyId + '?query=' + queries.MMQuery, {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: constants.GOT_MARKETING_MATERIALS, payload: response });
    });
  };
}

function editMMField(_ref) {
  var updateField = _ref.updateField,
      updateBody = _ref.updateBody;

  return function (dispatch) {
    dispatch({ type: constants.EDIT_MM_STARTING, payload: { updateField: updateField, updateBody: updateBody } });
    return fetch('/proxy/profile?mutation=' + queries.editMMMutation, {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(_defineProperty({}, updateField, updateBody))
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: constants.EDIT_MM_FINISHED, payload: response });
    }).catch(function (err) {
      return console.log('err in saving mm', err);
    });
  };
}

function sendMM(payload) {
  return function (dispatch) {
    dispatch({ type: constants.SENDING_MARKETING_MATERIALS });
    return fetch('/proxy/profile/sendMarketingMaterials', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(_checkStatus2.default).then(function () {
      return dispatch({ type: constants.SENT_MARKETING_MATERIALS });
    }).catch(function (err) {
      return console.log('err in sending mm', err);
    });
  };
}

var getCompanies = (0, _lodash2.default)(function (companyName, dispatch) {
  return fetch('/proxy/contractingSignUp/getCompanies/' + companyName).then(function (res) {
    return res.json();
  }).then(function (res) {
    return dispatch({ type: constants.UPDATE_TYPE_AHEAD_COMPANIES_FOR_MM, payload: res });
  }).catch(function (res) {
    throw new Error(res.message);
  });
}, 400);

// SIGN UP ACTIONS

function updateMMSignUpProps(payload) {
  return { type: constants.UPDATE_MM_SIGN_UP_PROP, payload: payload };
}

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validEmail = exports.convertCSV = undefined;

var _papaparse = __webpack_require__(1459);

var _papaparse2 = _interopRequireDefault(_papaparse);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var validEmail = function validEmail(email) {
  var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
  return String(email).search(filter) !== -1;
};

var toLowerCase = function toLowerCase(string) {
  return string.toLowerCase();
};
var lowerCaseHeaders = function lowerCaseHeaders(headers) {
  return _ramda2.default.call(_ramda2.default.compose(_ramda2.default.map(toLowerCase), _ramda2.default.pluck('headerTitle')), headers);
};

var checkIfHeaderRowExists = _ramda2.default.curry(function (headers, parsedCSV) {
  var firstRowOfCSV = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.map(toLowerCase), _ramda2.default.head), parsedCSV);
  var isFirstRowHeaders = _ramda2.default.not(isNilOrEmpty(_ramda2.default.intersection(firstRowOfCSV, lowerCaseHeaders(headers))));
  var info = {
    headers: headers,
    headerRemoved: isFirstRowHeaders
  };
  return isFirstRowHeaders ? _ramda2.default.merge(info, { csv: _ramda2.default.tail(parsedCSV) }) : _ramda2.default.merge(info, { csv: parsedCSV });
});

var doesAColumnOfEmailsExist = function doesAColumnOfEmailsExist(headers) {
  return _ramda2.default.call(_ramda2.default.compose(_ramda2.default.contains('email'), _ramda2.default.map(toLowerCase), _ramda2.default.pluck('headerTitle')), headers);
};

// this is based on a row of email existing
var checkIfCSVHeaderMatchesHeaderRequirement = function checkIfCSVHeaderMatchesHeaderRequirement(_ref) {
  var headers = _ref.headers,
      headerRemoved = _ref.headerRemoved,
      csv = _ref.csv;

  var checkIfAColOfEmailsExists = doesAColumnOfEmailsExist(headers);
  if (checkIfAColOfEmailsExists) {
    var headerIndexOfEmails = _ramda2.default.indexOf('email', lowerCaseHeaders(headers));
    var arrayOfEmails = _ramda2.default.pluck(headerIndexOfEmails)(csv);
    var anyEmailExistsInExpectedRow = _ramda2.default.any(validEmail, _ramda2.default.reject(isNilOrEmpty, arrayOfEmails));
    return anyEmailExistsInExpectedRow ? { headers: headers, headerRemoved: headerRemoved, csv: csv } : { CSVFileError: 'header mismatch' };
  }
  return { headers: headers, headerRemoved: headerRemoved, csv: csv };
};

var findInvalidRowIndex = function findInvalidRowIndex(csv, invalidRow) {
  return _ramda2.default.map(function (row) {
    return _ramda2.default.indexOf(row, csv);
  }, invalidRow);
};

var checkRequiredFields = function checkRequiredFields(_ref2) {
  var headers = _ref2.headers,
      headerRemoved = _ref2.headerRemoved,
      csv = _ref2.csv;

  var remainingRowsToCheck = void 0;
  var failedRows = [];
  var checkIfAColOfEmailsExists = doesAColumnOfEmailsExist(headers);
  headers.forEach(function (header, headerIndex) {
    if (header.required) {
      var findMissingRows = _ramda2.default.filter(function (arr) {
        return isNilOrEmpty(_ramda2.default.prop(headerIndex, arr));
      }, remainingRowsToCheck || csv);
      var findMissingRowsIndex = findInvalidRowIndex(csv, findMissingRows);
      findMissingRowsIndex.forEach(function (index) {
        var error = 'Missing ' + header.headerTitle;
        failedRows.push({ line: headerRemoved ? index + 2 : index + 1, error: error });
      });
      remainingRowsToCheck = _ramda2.default.reject(function (arr) {
        return _ramda2.default.contains(arr, findMissingRows);
      }, remainingRowsToCheck || csv);
    }
    if (checkIfAColOfEmailsExists) {
      var headerIndexOfEmails = _ramda2.default.indexOf('email', lowerCaseHeaders(headers));
      var findInvalidEmailRows = _ramda2.default.filter(function (arr) {
        return _ramda2.default.not(isNilOrEmpty(_ramda2.default.prop(headerIndexOfEmails, arr))) && !validEmail(_ramda2.default.prop(headerIndexOfEmails, arr));
      }, remainingRowsToCheck || csv);
      var findInvalidEmailRowsIndex = findInvalidRowIndex(csv, findInvalidEmailRows);
      findInvalidEmailRowsIndex.forEach(function (index) {
        var error = 'Invalid email';
        failedRows.push({ line: headerRemoved ? index + 2 : index + 1, error: error });
      });
      remainingRowsToCheck = _ramda2.default.reject(function (arr) {
        return _ramda2.default.contains(arr, findInvalidEmailRows);
      }, remainingRowsToCheck || csv);
    }
  });
  return {
    successfulRows: remainingRowsToCheck,
    failedRows: failedRows
  };
};

var convertRowsToObjects = _ramda2.default.curry(function (headers, csv, _ref3) {
  var successfulRows = _ref3.successfulRows,
      failedRows = _ref3.failedRows;

  var covertSuccessfulRowsToObj = (successfulRows || []).map(function (row) {
    var obj = {};
    headers.forEach(function (header, headerIndex) {
      obj[header.headerTitle] = row[headerIndex];
    });
    return obj;
  });
  var convertFailedRowsToObject = (failedRows || []).map(function (row) {
    var updatedRow = _ramda2.default.merge(row, {});
    headers.forEach(function (header, headerIndex) {
      updatedRow[header.headerTitle] = csv[row.line - 1][headerIndex];
    });
    return updatedRow;
  });
  return {
    successfulRows: covertSuccessfulRowsToObj,
    failedRows: convertFailedRowsToObject
  };
});

var handleCSVMisMatch = function handleCSVMisMatch() {
  return { CSVHeaderMismatch: true };
};

// headers is an array of objects with headerTitle and required Boolean
// For ex: [
// {
//   headerTitle: 'Email',
//   required: true,
// },
// {
//   headerTitle: 'Company Name',
//   required: false,
// },
// ]
var convertCSV = function convertCSV(csv, headers) {
  var parsedCSV = _papaparse2.default.parse(csv, { skipEmptyLines: true });
  return _ramda2.default.call(_ramda2.default.compose(_ramda2.default.ifElse(_ramda2.default.prop('CSVFileError'), function () {
    return handleCSVMisMatch();
  }, _ramda2.default.compose(convertRowsToObjects(headers, parsedCSV.data), checkRequiredFields)), checkIfCSVHeaderMatchesHeaderRequirement, checkIfHeaderRowExists(headers)), parsedCSV.data);
};

exports.convertCSV = convertCSV;
exports.validEmail = validEmail;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHelpOutline = function ActionHelpOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z' })
  );
};
ActionHelpOutline = (0, _pure2.default)(ActionHelpOutline);
ActionHelpOutline.displayName = 'ActionHelpOutline';
ActionHelpOutline.muiName = 'SvgIcon';

exports.default = ActionHelpOutline;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Facebook = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(145);

var _singlePlayer = __webpack_require__(227);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//connect.facebook.net/en_US/sdk.js';
var SDK_GLOBAL = 'FB';
var SDK_GLOBAL_READY = 'fbAsyncInit';
var MATCH_URL = /facebook\.com\/([^/?].+\/)?video(s|\.php)[/?].*$/;
var PLAYER_ID_PREFIX = 'facebook-player-';

var Facebook = exports.Facebook = function (_Component) {
  _inherits(Facebook, _Component);

  function Facebook() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Facebook);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Facebook.__proto__ || Object.getPrototypeOf(Facebook)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unmute');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Facebook, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      if (isReady) {
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
          return FB.XFBML.parse();
        });
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
        FB.init({
          appId: _this2.props.config.facebook.appId,
          xfbml: true,
          version: 'v2.5'
        });
        FB.Event.subscribe('xfbml.render', function (msg) {
          // Here we know the SDK has loaded, even if onReady/onPlay
          // is not called due to a video that cannot be embedded
          _this2.props.onLoaded();
        });
        FB.Event.subscribe('xfbml.ready', function (msg) {
          if (msg.type === 'video' && msg.id === _this2.playerID) {
            _this2.player = msg.instance;
            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);
            _this2.player.subscribe('paused', _this2.props.onPause);
            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);
            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);
            _this2.player.subscribe('error', _this2.props.onError);
            if (!_this2.props.muted) {
              // Player is muted by default
              _this2.callPlayer('unmute');
            }
            _this2.props.onReady();

            // For some reason Facebook have added `visibility: hidden`
            // to the iframe when autoplay fails, so here we set it back
            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
          }
        });
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentPosition');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        width: '100%',
        height: '100%',
        backgroundColor: 'black'
      };
      return _react2['default'].createElement('div', {
        style: style,
        id: this.playerID,
        className: 'fb-video',
        'data-href': this.props.url,
        'data-autoplay': this.props.playing ? 'true' : 'false',
        'data-allowfullscreen': 'true',
        'data-controls': this.props.controls ? 'true' : 'false'
      });
    }
  }]);

  return Facebook;
}(_react.Component);

Facebook.displayName = 'Facebook';

Facebook.canPlay = function (url) {
  return MATCH_URL.test(url);
};

Facebook.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Facebook);

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Streamable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(145);

var _singlePlayer = __webpack_require__(227);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';
var MATCH_URL = /streamable\.com\/([a-z0-9]+)$/;

var Streamable = exports.Streamable = function (_Component) {
  _inherits(Streamable, _Component);

  function Streamable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Streamable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Streamable.__proto__ || Object.getPrototypeOf(Streamable)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unmute');
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Streamable, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
        if (!_this2.iframe) return;
        _this2.player = new playerjs.Player(_this2.iframe);
        _this2.player.setLoop(_this2.props.loop);
        _this2.player.on('ready', _this2.props.onReady);
        _this2.player.on('play', _this2.props.onPlay);
        _this2.player.on('pause', _this2.props.onPause);
        _this2.player.on('seeked', _this2.props.onSeek);
        _this2.player.on('ended', _this2.props.onEnded);
        _this2.player.on('error', _this2.props.onError);
        _this2.player.on('timeupdate', function (_ref2) {
          var duration = _ref2.duration,
              seconds = _ref2.seconds;

          _this2.duration = duration;
          _this2.currentTime = seconds;
        });
        _this2.player.on('buffered', function (_ref3) {
          var percent = _ref3.percent;

          if (_this2.duration) {
            _this2.secondsLoaded = _this2.duration * percent;
          }
        });
        if (_this2.props.muted) {
          _this2.player.mute();
        }
      }, this.props.onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: 'render',
    value: function render() {
      var id = this.props.url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('iframe', {
        ref: this.ref,
        src: 'https://streamable.com/o/' + id,
        frameBorder: '0',
        scrolling: 'no',
        style: style,
        allowFullScreen: true
      });
    }
  }]);

  return Streamable;
}(_react.Component);

Streamable.displayName = 'Streamable';

Streamable.canPlay = function (url) {
  return MATCH_URL.test(url);
};

exports['default'] = (0, _singlePlayer2['default'])(Streamable);

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wistia = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(145);

var _singlePlayer = __webpack_require__(227);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//fast.wistia.com/assets/external/E-v1.js';
var SDK_GLOBAL = 'Wistia';
var MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;

var Wistia = exports.Wistia = function (_Component) {
  _inherits(Wistia, _Component);

  function Wistia() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Wistia);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Wistia.__proto__ || Object.getPrototypeOf(Wistia)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.mute = function () {
      _this.callPlayer('mute');
    }, _this.unmute = function () {
      _this.callPlayer('unmute');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Wistia, [{
    key: 'getID',
    value: function getID(url) {
      return url && url.match(MATCH_URL)[1];
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props = this.props,
          playing = _props.playing,
          muted = _props.muted,
          controls = _props.controls,
          _onReady = _props.onReady,
          onPlay = _props.onPlay,
          onPause = _props.onPause,
          onSeek = _props.onSeek,
          onEnded = _props.onEnded,
          config = _props.config;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function () {
        window._wq = window._wq || [];
        window._wq.push({
          id: _this2.getID(url),
          options: _extends({
            autoPlay: playing,
            silentAutoPlay: 'allow',
            muted: muted,
            controlsVisibleOnLoad: controls
          }, config.wistia.options),
          onReady: function onReady(player) {
            _this2.player = player;
            _this2.player.bind('play', onPlay);
            _this2.player.bind('pause', onPause);
            _this2.player.bind('seek', onSeek);
            _this2.player.bind('end', onEnded);
            _onReady();
          }
        });
      });
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.callPlayer('remove');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('time', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('volume', fraction);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.callPlayer('playbackRate', rate);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('duration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('time');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var id = this.getID(this.props.url);
      var className = 'wistia_embed wistia_async_' + id;
      var style = {
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('div', { key: id, className: className, style: style });
    }
  }]);

  return Wistia;
}(_react.Component);

Wistia.displayName = 'Wistia';

Wistia.canPlay = function (url) {
  return MATCH_URL.test(url);
};

Wistia.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Wistia);

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(145);

var _singlePlayer = __webpack_require__(227);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
var SDK_GLOBAL = 'Twitch';
var MATCH_VIDEO_URL = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
var MATCH_CHANNEL_URL = /(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
var PLAYER_ID_PREFIX = 'twitch-player-';

var Twitch = exports.Twitch = function (_Component) {
  _inherits(Twitch, _Component);

  function Twitch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Twitch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Twitch.__proto__ || Object.getPrototypeOf(Twitch)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
      _this.callPlayer('setMuted', true);
    }, _this.unmute = function () {
      _this.callPlayer('setMuted', false);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Twitch, [{
    key: 'load',
    value: function load(url, isReady) {
      var _this2 = this;

      var _props = this.props,
          playsinline = _props.playsinline,
          onError = _props.onError,
          config = _props.config;

      var isChannel = MATCH_CHANNEL_URL.test(url);
      var id = isChannel ? url.match(MATCH_CHANNEL_URL)[1] : url.match(MATCH_VIDEO_URL)[1];
      if (isReady) {
        if (isChannel) {
          this.player.setChannel(id);
        } else {
          this.player.setVideo('v' + id);
        }
        return;
      }
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
        _this2.player = new Twitch.Player(_this2.playerID, _extends({
          video: isChannel ? '' : id,
          channel: isChannel ? id : '',
          height: '100%',
          width: '100%',
          playsinline: playsinline,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted
        }, config.twitch.options));
        var _Twitch$Player = Twitch.Player,
            READY = _Twitch$Player.READY,
            PLAYING = _Twitch$Player.PLAYING,
            PAUSE = _Twitch$Player.PAUSE,
            ENDED = _Twitch$Player.ENDED;

        _this2.player.addEventListener(READY, _this2.props.onReady);
        _this2.player.addEventListener(PLAYING, _this2.props.onPlay);
        _this2.player.addEventListener(PAUSE, _this2.props.onPause);
        _this2.player.addEventListener(ENDED, _this2.props.onEnded);
      }, onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.callPlayer('pause');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('div', { style: style, id: this.playerID });
    }
  }]);

  return Twitch;
}(_react.Component);

Twitch.displayName = 'Twitch';

Twitch.canPlay = function (url) {
  return MATCH_VIDEO_URL.test(url) || MATCH_CHANNEL_URL.test(url);
};

Twitch.loopOnEnded = true;
exports['default'] = (0, _singlePlayer2['default'])(Twitch);

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mixcloud = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(145);

var _singlePlayer = __webpack_require__(227);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = '//widget.mixcloud.com/media/js/widgetApi.js';
var SDK_GLOBAL = 'Mixcloud';
var MATCH_URL = /mixcloud\.com\/([^/]+\/[^/]+)/;

var Mixcloud = exports.Mixcloud = function (_Component) {
  _inherits(Mixcloud, _Component);

  function Mixcloud() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Mixcloud);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Mixcloud.__proto__ || Object.getPrototypeOf(Mixcloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
      // No volume support
    }, _this.unmute = function () {
      // No volume support
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Mixcloud, [{
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);
        _this2.player.ready.then(function () {
          _this2.player.events.play.on(_this2.props.onPlay);
          _this2.player.events.pause.on(_this2.props.onPause);
          _this2.player.events.ended.on(_this2.props.onEnded);
          _this2.player.events.error.on(_this2.props.error);
          _this2.player.events.progress.on(function (seconds, duration) {
            _this2.currentTime = seconds;
            _this2.duration = duration;
          });
          _this2.props.onReady();
        });
      }, this.props.onError);
    }
  }, {
    key: 'play',
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      // Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      // No volume support
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          config = _props.config;

      var id = url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      var query = (0, _utils.queryString)(_extends({}, config.mixcloud.options, {
        feed: '/' + id + '/'
      }));
      // We have to give the iframe a key here to prevent a
      // weird dialog appearing when loading a new track
      return _react2['default'].createElement('iframe', {
        key: id,
        ref: this.ref,
        style: style,
        src: 'https://www.mixcloud.com/widget/iframe/?' + query,
        frameBorder: '0'
      });
    }
  }]);

  return Mixcloud;
}(_react.Component);

Mixcloud.displayName = 'Mixcloud';

Mixcloud.canPlay = function (url) {
  return MATCH_URL.test(url);
};

exports['default'] = (0, _singlePlayer2['default'])(Mixcloud);

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilePlayer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(145);

var _singlePlayer = __webpack_require__(227);

var _singlePlayer2 = _interopRequireDefault(_singlePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
var HLS_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/VERSION/hls.min.js';
var HLS_GLOBAL = 'Hls';
var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
var DASH_GLOBAL = 'dashjs';
var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;

function canPlay(url) {
  if (url instanceof Array) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = url[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        if (typeof item === 'string' && canPlay(item)) {
          return true;
        }
        if (canPlay(item.src)) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return false;
  }
  if ((0, _utils.isMediaStream)(url)) {
    return true;
  }
  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url);
}

function canEnablePIP(url) {
  return canPlay(url) && !!document.pictureInPictureEnabled && !AUDIO_EXTENSIONS.test(url);
}

var FilePlayer = exports.FilePlayer = function (_Component) {
  _inherits(FilePlayer, _Component);

  function FilePlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.onDisablePIP = function (e) {
      var _this$props = _this.props,
          onDisablePIP = _this$props.onDisablePIP,
          playing = _this$props.playing;

      onDisablePIP(e);
      if (playing) {
        _this.play();
      }
    }, _this.onSeek = function (e) {
      _this.props.onSeek(e.target.currentTime);
    }, _this.mute = function () {
      _this.player.muted = true;
    }, _this.unmute = function () {
      _this.player.muted = false;
    }, _this.renderSourceElement = function (source, index) {
      if (typeof source === 'string') {
        return _react2['default'].createElement('source', { key: index, src: source });
      }
      return _react2['default'].createElement('source', _extends({ key: index }, source));
    }, _this.renderTrack = function (track, index) {
      return _react2['default'].createElement('track', _extends({ key: index }, track));
    }, _this.ref = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilePlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addListeners();
      if (IOS) {
        this.player.load();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(nextProps)) {
        this.removeListeners();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
        this.addListeners();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      var _props = this.props,
          onReady = _props.onReady,
          onPlay = _props.onPlay,
          onPause = _props.onPause,
          onEnded = _props.onEnded,
          onError = _props.onError,
          playsinline = _props.playsinline,
          onEnablePIP = _props.onEnablePIP;

      this.player.addEventListener('canplay', onReady);
      this.player.addEventListener('play', onPlay);
      this.player.addEventListener('pause', onPause);
      this.player.addEventListener('seeked', this.onSeek);
      this.player.addEventListener('ended', onEnded);
      this.player.addEventListener('error', onError);
      this.player.addEventListener('enterpictureinpicture', onEnablePIP);
      this.player.addEventListener('leavepictureinpicture', this.onDisablePIP);
      if (playsinline) {
        this.player.setAttribute('playsinline', '');
        this.player.setAttribute('webkit-playsinline', '');
      }
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      var _props2 = this.props,
          onReady = _props2.onReady,
          onPlay = _props2.onPlay,
          onPause = _props2.onPause,
          onEnded = _props2.onEnded,
          onError = _props2.onError,
          onEnablePIP = _props2.onEnablePIP;

      this.player.removeEventListener('canplay', onReady);
      this.player.removeEventListener('play', onPlay);
      this.player.removeEventListener('pause', onPause);
      this.player.removeEventListener('seeked', this.onSeek);
      this.player.removeEventListener('ended', onEnded);
      this.player.removeEventListener('error', onError);
      this.player.removeEventListener('enterpictureinpicture', onEnablePIP);
      this.player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
    }
  }, {
    key: 'shouldUseAudio',
    value: function shouldUseAudio(props) {
      if (props.config.file.forceVideo) {
        return false;
      }
      if (props.config.file.attributes.poster) {
        return false; // Use <video> so that poster is shown
      }
      return AUDIO_EXTENSIONS.test(props.url) || props.config.file.forceAudio;
    }
  }, {
    key: 'shouldUseHLS',
    value: function shouldUseHLS(url) {
      return HLS_EXTENSIONS.test(url) && !IOS || this.props.config.file.forceHLS;
    }
  }, {
    key: 'shouldUseDASH',
    value: function shouldUseDASH(url) {
      return DASH_EXTENSIONS.test(url) || this.props.config.file.forceDASH;
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props$config$file = this.props.config.file,
          hlsVersion = _props$config$file.hlsVersion,
          dashVersion = _props$config$file.dashVersion;

      if (this.shouldUseHLS(url)) {
        (0, _utils.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
          _this2.hls = new Hls(_this2.props.config.file.hlsOptions);
          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
            _this2.props.onError(e, data, _this2.hls, Hls);
          });
          _this2.hls.loadSource(url);
          _this2.hls.attachMedia(_this2.player);
        });
      }
      if (this.shouldUseDASH(url)) {
        (0, _utils.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
          _this2.dash = dashjs.MediaPlayer().create();
          _this2.dash.initialize(_this2.player, url, _this2.props.playing);
          _this2.dash.getDebug().setLogToBrowserConsole(false);
        });
      }

      if (url instanceof Array) {
        // When setting new urls (<source>) on an already loaded video,
        // HTMLMediaElement.load() is needed to reset the media element
        // and restart the media resource. Just replacing children source
        // dom nodes is not enough
        this.player.load();
      } else if ((0, _utils.isMediaStream)(url)) {
        try {
          this.player.srcObject = url;
        } catch (e) {
          this.player.src = window.URL.createObjectURL(url);
        }
      }
    }
  }, {
    key: 'play',
    value: function play() {
      var promise = this.player.play();
      if (promise) {
        promise['catch'](this.props.onError);
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.player.removeAttribute('src');
      if (this.hls) {
        this.hls.destroy();
      }
      if (this.dash) {
        this.dash.reset();
      }
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {
      this.player.currentTime = seconds;
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: 'enablePIP',
    value: function enablePIP() {
      if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
        this.player.requestPictureInPicture();
      }
    }
  }, {
    key: 'disablePIP',
    value: function disablePIP() {
      if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
        document.exitPictureInPicture();
      }
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.player.playbackRate = rate;
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.player) return null;
      var _player = this.player,
          duration = _player.duration,
          seekable = _player.seekable;
      // on iOS, live streams return Infinity for the duration
      // so instead we use the end of the seekable timerange

      if (duration === Infinity && seekable.length > 0) {
        return seekable.end(seekable.length - 1);
      }
      return duration;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      if (!this.player) return null;
      return this.player.currentTime;
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      if (!this.player) return null;
      var buffered = this.player.buffered;

      if (buffered.length === 0) {
        return 0;
      }
      var end = buffered.end(buffered.length - 1);
      var duration = this.getDuration();
      if (end > duration) {
        return duration;
      }
      return end;
    }
  }, {
    key: 'getSource',
    value: function getSource(url) {
      var useHLS = this.shouldUseHLS(url);
      var useDASH = this.shouldUseDASH(url);
      if (url instanceof Array || (0, _utils.isMediaStream)(url) || useHLS || useDASH) {
        return undefined;
      }
      if (MATCH_DROPBOX_URL.test(url)) {
        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
      }
      return url;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          url = _props3.url,
          playing = _props3.playing,
          loop = _props3.loop,
          controls = _props3.controls,
          muted = _props3.muted,
          config = _props3.config,
          width = _props3.width,
          height = _props3.height;

      var useAudio = this.shouldUseAudio(this.props);
      var Element = useAudio ? 'audio' : 'video';
      var style = {
        width: width === 'auto' ? width : '100%',
        height: height === 'auto' ? height : '100%'
      };
      return _react2['default'].createElement(
        Element,
        _extends({
          ref: this.ref,
          src: this.getSource(url),
          style: style,
          preload: 'auto',
          autoPlay: playing || undefined,
          controls: controls,
          muted: muted,
          loop: loop
        }, config.file.attributes),
        url instanceof Array && url.map(this.renderSourceElement),
        config.file.tracks.map(this.renderTrack)
      );
    }
  }]);

  return FilePlayer;
}(_react.Component);

FilePlayer.displayName = 'FilePlayer';
FilePlayer.canPlay = canPlay;
FilePlayer.canEnablePIP = canEnablePIP;
exports['default'] = (0, _singlePlayer2['default'])(FilePlayer);

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowBack = function NavigationArrowBack(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
  );
};
NavigationArrowBack = (0, _pure2.default)(NavigationArrowBack);
NavigationArrowBack.displayName = 'NavigationArrowBack';
NavigationArrowBack.muiName = 'SvgIcon';

exports.default = NavigationArrowBack;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flipLoaderstatus = exports.updateCustomizedMsg = exports.openPopover = exports.closePopover = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.connectionResponseTime = connectionResponseTime;
exports.search = search;
exports.searchCountOnly = searchCountOnly;
exports.sendInvitation = sendInvitation;
exports.resendInvitation = resendInvitation;
exports.fakeResendInvitation = fakeResendInvitation;
exports.acceptConnection = acceptConnection;
exports.ignoreConnection = ignoreConnection;

var _soFetch = __webpack_require__(254);

var _partnerFinderConstants = __webpack_require__(653);

var constants = _interopRequireWildcard(_partnerFinderConstants);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// import * as queries from './partnerFinder-graphql-query';

var credentialsAndHeaders = {
  credentials: 'same-origin',
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
};

var put = _extends({ method: 'put' }, credentialsAndHeaders);

var closePopover = exports.closePopover = function closePopover() {
  return { type: constants.CLOSE_PF_CUSTOM_MSG_POPOVER };
};
var openPopover = exports.openPopover = function openPopover(payload) {
  return { type: constants.OPEN_PF_CUSTOM_MSG_POPOVER, payload: payload };
};
var updateCustomizedMsg = exports.updateCustomizedMsg = function updateCustomizedMsg(payload) {
  return { type: constants.UPDATE_CUSTOM_MSG, payload: payload };
};

function connectionResponseTime(companyId) {
  return function (dispatch) {
    dispatch({ type: constants.GETTING_RESPONSE_TIME });
    return fetch('/proxy/connections/' + companyId + '/responseTime', {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: constants.GOT_RESPONSE_TIME, payload: { companyId: companyId, response: response } });
    });
  };
}

function search(params, pagination, noCount) {
  return function (dispatch) {
    var qs = params;
    dispatch({ type: constants.MODIFY_PARAMS, params: params });
    if (!noCount && !pagination) {
      qs = _extends({}, params, {
        log: true
      });
      dispatch({ type: constants.ADD_SEARCH_COUNT });
    }
    if (!pagination) dispatch({ type: constants.SEARCH_STARTING });
    return (0, _soFetch.soFetch)('/proxy/partnerfinder', {
      qs: qs,
      method: 'get',
      actionType: constants.SEARCH
    })(dispatch).catch(function (err) {
      return dispatch({ type: constants.SEARCH_FAILED, err: err });
    });
  };
}

function searchCountOnly(params) {
  return function (dispatch) {
    var qs = _extends({}, params, { log: false });
    dispatch({ type: constants.MODIFY_PARAMS, params: params });
    dispatch({ type: constants.SEARCH_STARTING });
    return (0, _soFetch.soFetch)('/proxy/partnerfinder', {
      qs: qs,
      method: 'get',
      actionType: constants.SEARCH_COUNT_ONLY
    })(dispatch).catch(function (err) {
      return dispatch({ type: constants.SEARCH_FAILED, err: err });
    });
  };
}

var flipLoaderstatus = exports.flipLoaderstatus = function flipLoaderstatus(payload) {
  return { type: constants.FLIP_LOADER_STATUS, payload: payload };
};

function sendInvitation(customMsg, _ref) {
  var companyId = _ref.companyId,
      locationId = _ref.locationId,
      productId = _ref.productId;

  return function (dispatch) {
    dispatch(closePopover());
    dispatch(flipLoaderstatus({ companyId: companyId }));
    return fetch('/proxy/connections/' + companyId, {
      method: 'post',
      body: JSON.stringify({ customMsg: customMsg }),
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      return res.json();
    }).then(function (res) {
      return dispatch({
        connectionId: res._id,
        companyId: companyId,
        locationId: locationId,
        productId: productId,
        type: constants.SEND_INVITATION_PF,
        payload: res
      });
    }).catch(function (err) {
      console.log('sendInvitation error: ', err);
      dispatch(flipLoaderstatus({ companyId: companyId }));
      throw new Error(err);
    });
  };
}

function resendInvitation(connectionId, companyId, locationId, productId) {
  return function (dispatch) {
    dispatch(flipLoaderstatus({ connectionId: connectionId }));
    return fetch('/proxy/connections/' + connectionId + '/resend', put).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      return res.json();
    }).then(function (res) {
      return dispatch({
        companyId: companyId,
        locationId: locationId,
        productId: productId,
        connectionId: connectionId,
        type: constants.RESEND_INVITATION_PF,
        payload: res
      });
    }).catch(function (err) {
      console.log('resendInvitation error: ', err);
      dispatch(flipLoaderstatus({ connectionId: connectionId }));
      throw new Error(err);
    });
  };
}

function fakeResendInvitation(connectionId, companyId, locationId, productId) {
  return function (dispatch) {
    dispatch(flipLoaderstatus({ connectionId: connectionId }));

    return fetch('/proxy/connections/' + connectionId + '/fakeResend', put).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);else return res.json();
    }).then(function (res) {
      return dispatch({
        connectionId: connectionId,
        companyId: companyId,
        locationId: locationId,
        productId: productId,
        type: constants.FAKE_RESEND,
        payload: res
      });
    }).catch(function (err) {
      console.log('fResendInvitation error: ', err);
      dispatch(flipLoaderstatus({ connectionId: connectionId }));
      throw new Error(err);
    });
  };
}

function acceptConnection(connectionId, companyId, locationId, productId) {
  return function (dispatch) {
    dispatch(flipLoaderstatus({ connectionId: connectionId }));

    return fetch('/proxy/connections/' + connectionId + '/accepted', put).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);else return res.json();
    }).then(function (res) {
      return dispatch({
        connectionId: connectionId,
        companyId: companyId,
        locationId: locationId,
        productId: productId,
        type: constants.ACCEPT_CONNECTION_PF,
        payload: res
      });
    }).catch(function (err) {
      console.log('acceptConnection error', err);
      dispatch(flipLoaderstatus({ connectionId: connectionId }));
      throw new Error(err);
    });
  };
}

function ignoreConnection(connectionId, companyId, locationId, productId) {
  return function (dispatch) {
    dispatch(flipLoaderstatus({ connectionId: connectionId }));
    return fetch('/proxy/connections/' + connectionId + '/rejected', put).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      return res.json();
    }).then(function (res) {
      return dispatch({
        connectionId: connectionId,
        companyId: companyId,
        locationId: locationId,
        productId: productId,
        type: constants.IGNORE_CONNECTION_PF,
        payload: res
      });
    }).catch(function (err) {
      console.log('ignoreConnection', err);
      dispatch(flipLoaderstatus({ connectionId: connectionId }));
      throw new Error(err);
    });
  };
}

// FOR ADDING MM TO PF
// export function getMarketingMaterials(companyId, locationId) {
//   return dispatch => {
//     dispatch({ type: constants.GETTING_MARKETING_MATERIALS });
//     return fetch(`/proxy/company/${companyId}?query=${queries.MMQuery}`, {
//       method: 'get',
//       credentials: 'same-origin',
//       headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
//     })
//     .then(res => res.json())
//     .then(response => dispatch({ type: constants.GOT_MARKETING_MATERIALS, payload: {
//       companyId,
//       media: response.media,
//       locationId,
//     } }));
//   };
// }

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _materialUi = __webpack_require__(3);

var _searchBar = __webpack_require__(1484);

var _searchBar2 = _interopRequireDefault(_searchBar);

var _carousel = __webpack_require__(1226);

var _carousel2 = _interopRequireDefault(_carousel);

var _jquery = __webpack_require__(251);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = (0, _react.createClass)({

  propTypes: {
    title: _react.PropTypes.string,
    subtitle: _react.PropTypes.string,
    padded: _react.PropTypes.bool,
    isFixed: _react.PropTypes.bool,
    searchHeader: _react.PropTypes.any,
    className: _react.PropTypes.string,
    headerImages: _react.PropTypes.array,
    style: _react.PropTypes.object,
    children: _react.PropTypes.any,
    listCard: _react.PropTypes.any,
    locationData: _react.PropTypes.any,
    companyData: _react.PropTypes.any,
    productData: _react.PropTypes.any,
    titleBarExtra: _react.PropTypes.any,
    contentsStyle: _react.PropTypes.object,
    isSticky: _react.PropTypes.bool,
    defaultValue: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      padded: true
    };
  },
  componentDidMount: function componentDidMount() {
    var resizeCss = function resizeCss(wrapper) {
      var wRatio = 744 / this.naturalWidth;
      var hRatio = 320 / this.naturalHeight;
      var ratio = Math.min(wRatio, hRatio);

      if (this.naturalWidth > this.naturalHeight) {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto'
        });
      } else {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto'
        });
      }
    };

    var $image = (0, _jquery2.default)('.tc-card-header-image');
    $image.load(function () {
      resizeCss.call(this, $image);
    });
  },
  render: function render() {
    var outerChildren = void 0;
    var innerChildren = void 0;
    var classes = (0, _classnames2.default)('tc-card', this.props.className, {
      'is-padded': this.props.padded,
      'is-fixed': this.props.isFixed,
      'is-sticky': this.props.isSticky
    });

    if (this.props.children.length === 2 && this.props.listCard) {
      outerChildren = _react2.default.createElement(
        'div',
        { className: 'tc-card-header-tags' },
        this.props.children[0]
      );
      innerChildren = this.props.children[1];
    } else {
      innerChildren = this.props.children;
    }

    if (this.props.locationData || this.props.companyData || this.props.productData) {
      innerChildren = this.props.children;
    }
    var titleElement = this.props.title ? _react2.default.createElement(
      'h4',
      { className: 'tc-card-header-title' },
      this.props.title
    ) : outerChildren;

    var subTitleElement = this.props.subtitle ? _react2.default.createElement(
      'div',
      { style: { clear: 'left' } },
      this.props.subtitle
    ) : null;
    var width = void 0;
    if (this.props.isFixed && document.getElementsByClassName('connections-list').length) {
      width = { width: window.getComputedStyle(document.getElementsByClassName('connections-list')[0]).getPropertyValue('width') };
    }
    var searchHeader = titleElement && this.props.searchHeader ? _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'tc-card-header search-header' },
        _react2.default.createElement(_searchBar2.default, _extends({ className: 'search-header-search-bar' }, this.props, { defaultValue: this.props.defaultValue }))
      ),
      _react2.default.createElement(
        'div',
        { className: 'tc-card-header search-header' },
        titleElement,
        this.props.titleBarExtra,
        subTitleElement
      )
    ) : null;

    var header = void 0;
    if (this.props.headerImages && this.props.headerImages.length) {
      if (this.props.headerImages.length > 1) header = _react2.default.createElement(_carousel2.default, { photos: this.props.headerImages });else {
        header = _react2.default.createElement(
          'div',
          { style: { backgroundColor: 'black' } },
          _react2.default.createElement('img', { className: 'tc-card-header-image', src: this.props.headerImages })
        );
      }
    } else {
      header = _react2.default.createElement(
        'div',
        { style: width, className: 'tc-header-container' },
        searchHeader
      );
    }

    return _react2.default.createElement(
      _materialUi.Paper,
      { className: classes, style: this.props.style },
      header,
      _react2.default.createElement(
        'div',
        { className: 'tc-card-contents', style: this.props.contentsStyle },
        innerChildren
      )
    );
  }
});

exports.default = Card;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _asap = __webpack_require__(1229);

var _asap2 = _interopRequireDefault(_asap);

var _generate = __webpack_require__(1486);

var _util = __webpack_require__(997);

// The current <style> tag we are inserting into, or null if we haven't
// inserted anything yet. We could find this each time using
// `document.querySelector("style[data-aphrodite"])`, but holding onto it is
// faster.
var styleTag = null;

// Inject a string of styles into a <style> tag in the head of the document. This
// will automatically create a style tag and then continue to use it for
// multiple injections. It will also use a style tag with the `data-aphrodite`
// tag on it if that exists in the DOM. This could be used for e.g. reusing the
// same style tag that server-side rendering inserts.
var injectStyleTag = function injectStyleTag(cssContents) {
    if (styleTag == null) {
        // Try to find a style tag with the `data-aphrodite` attribute first.
        styleTag = document.querySelector("style[data-aphrodite]");

        // If that doesn't work, generate a new style tag.
        if (styleTag == null) {
            // Taken from
            // http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
            var head = document.head || document.getElementsByTagName('head')[0];
            styleTag = document.createElement('style');

            styleTag.type = 'text/css';
            styleTag.setAttribute("data-aphrodite", "");
            head.appendChild(styleTag);
        }
    }

    if (styleTag.styleSheet) {
        styleTag.styleSheet.cssText += cssContents;
    } else {
        styleTag.appendChild(document.createTextNode(cssContents));
    }
};

// Custom handlers for stringifying CSS values that have side effects
// (such as fontFamily, which can cause @font-face rules to be injected)
var stringHandlers = {
    // With fontFamily we look for objects that are passed in and interpret
    // them as @font-face rules that we need to inject. The value of fontFamily
    // can either be a string (as normal), an object (a single font face), or
    // an array of objects and strings.
    fontFamily: function fontFamily(val) {
        if (Array.isArray(val)) {
            return val.map(fontFamily).join(",");
        } else if (typeof val === "object") {
            injectStyleOnce(val.fontFamily, "@font-face", [val], false);
            return '"' + val.fontFamily + '"';
        } else {
            return val;
        }
    },

    // With animationName we look for an object that contains keyframes and
    // inject them as an `@keyframes` block, returning a uniquely generated
    // name. The keyframes object should look like
    //  animationName: {
    //    from: {
    //      left: 0,
    //      top: 0,
    //    },
    //    '50%': {
    //      left: 15,
    //      top: 5,
    //    },
    //    to: {
    //      left: 20,
    //      top: 20,
    //    }
    //  }
    // TODO(emily): `stringHandlers` doesn't let us rename the key, so I have
    // to use `animationName` here. Improve that so we can call this
    // `animation` instead of `animationName`.
    animationName: function animationName(val) {
        if (typeof val !== "object") {
            return val;
        }

        // Generate a unique name based on the hash of the object. We can't
        // just use the hash because the name can't start with a number.
        // TODO(emily): this probably makes debugging hard, allow a custom
        // name?
        var name = 'keyframe_' + (0, _util.hashObject)(val);

        // Since keyframes need 3 layers of nesting, we use `generateCSS` to
        // build the inner layers and wrap it in `@keyframes` ourselves.
        var finalVal = '@keyframes ' + name + '{';
        Object.keys(val).forEach(function (key) {
            finalVal += (0, _generate.generateCSS)(key, [val[key]], stringHandlers, false);
        });
        finalVal += '}';

        injectGeneratedCSSOnce(name, finalVal);

        return name;
    }
};

// This is a map from Aphrodite's generated class names to `true` (acting as a
// set of class names)
var alreadyInjected = {};

// This is the buffer of styles which have not yet been flushed.
var injectionBuffer = "";

// A flag to tell if we are already buffering styles. This could happen either
// because we scheduled a flush call already, so newly added styles will
// already be flushed, or because we are statically buffering on the server.
var isBuffering = false;

var injectGeneratedCSSOnce = function injectGeneratedCSSOnce(key, generatedCSS) {
    if (!alreadyInjected[key]) {
        if (!isBuffering) {
            // We should never be automatically buffering on the server (or any
            // place without a document), so guard against that.
            if (typeof document === "undefined") {
                throw new Error("Cannot automatically buffer without a document");
            }

            // If we're not already buffering, schedule a call to flush the
            // current styles.
            isBuffering = true;
            (0, _asap2['default'])(flushToStyleTag);
        }

        injectionBuffer += generatedCSS;
        alreadyInjected[key] = true;
    }
};

var injectStyleOnce = function injectStyleOnce(key, selector, definitions, useImportant) {
    if (!alreadyInjected[key]) {
        var generated = (0, _generate.generateCSS)(selector, definitions, stringHandlers, useImportant);

        injectGeneratedCSSOnce(key, generated);
    }
};

exports.injectStyleOnce = injectStyleOnce;
var reset = function reset() {
    injectionBuffer = "";
    alreadyInjected = {};
    isBuffering = false;
    styleTag = null;
};

exports.reset = reset;
var startBuffering = function startBuffering() {
    if (isBuffering) {
        throw new Error("Cannot buffer while already buffering");
    }
    isBuffering = true;
};

exports.startBuffering = startBuffering;
var flushToString = function flushToString() {
    isBuffering = false;
    var ret = injectionBuffer;
    injectionBuffer = "";
    return ret;
};

exports.flushToString = flushToString;
var flushToStyleTag = function flushToStyleTag() {
    var cssContent = flushToString();
    if (cssContent.length > 0) {
        injectStyleTag(cssContent);
    }
};

exports.flushToStyleTag = flushToStyleTag;
var getRenderedClassNames = function getRenderedClassNames() {
    return Object.keys(alreadyInjected);
};

exports.getRenderedClassNames = getRenderedClassNames;
var addRenderedClassNames = function addRenderedClassNames(classNames) {
    classNames.forEach(function (className) {
        alreadyInjected[className] = true;
    });
};

exports.addRenderedClassNames = addRenderedClassNames;
/**
 * Inject styles associated with the passed style definition objects, and return
 * an associated CSS class name.
 *
 * @param {boolean} useImportant If true, will append !important to generated
 *     CSS output. e.g. {color: red} -> "color: red !important".
 * @param {Object[]} styleDefinitions style definition objects as returned as
 *     properties of the return value of StyleSheet.create().
 */
var injectAndGetClassName = function injectAndGetClassName(useImportant, styleDefinitions) {
    // Filter out falsy values from the input, to allow for
    // `css(a, test && c)`
    var validDefinitions = styleDefinitions.filter(function (def) {
        return def;
    });

    // Break if there aren't any valid styles.
    if (validDefinitions.length === 0) {
        return "";
    }

    var className = validDefinitions.map(function (s) {
        return s._name;
    }).join("-o_O-");
    injectStyleOnce(className, '.' + className, validDefinitions.map(function (d) {
        return d._definition;
    }), useImportant);

    return className;
};
exports.injectAndGetClassName = injectAndGetClassName;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
module.exports = exports["default"];

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// helper to capitalize strings

exports.default = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

module.exports = exports["default"];

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _update = __webpack_require__(2853);

var _update2 = _interopRequireDefault(_update);

var _reactDnd = __webpack_require__(1131);

var _reactDndHtml5Backend = __webpack_require__(1902);

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SortableList = function (_Component) {
  _inherits(SortableList, _Component);

  function SortableList(props) {
    _classCallCheck(this, SortableList);

    var _this = _possibleConstructorReturn(this, (SortableList.__proto__ || Object.getPrototypeOf(SortableList)).call(this, props));

    _this.moveCard = function (dragIndex, hoverIndex) {
      var _this$state = _this.state,
          arrayOfNodes = _this$state.arrayOfNodes,
          arrayOfData = _this$state.arrayOfData;

      var dragCard = arrayOfNodes[dragIndex];
      var dragData = arrayOfData[dragIndex];
      _this.setState((0, _update2.default)(_this.state, {
        arrayOfNodes: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]]
        },
        arrayOfData: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragData]]
        }
      }));
    };

    _this.dragEnds = function () {
      return _this.props.dragEnds(_this.state.arrayOfData);
    };

    _this.state = {
      arrayOfNodes: (0, _ramda.addIndex)(_ramda.map)(function (singleNode, id) {
        return { singleNode: singleNode, id: id };
      }, (0, _ramda.propOr)([], 'children', props)),
      arrayOfData: (0, _ramda.propOr)([], 'arrayOfData', props)
    };
    return _this;
  }

  _createClass(SortableList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        arrayOfNodes: (0, _ramda.addIndex)(_ramda.map)(function (singleNode, id) {
          return { singleNode: singleNode, id: id };
        }, (0, _ramda.propOr)([], 'children', nextProps)),
        arrayOfData: (0, _ramda.propOr)([], 'arrayOfData', nextProps)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var arrayOfNodes = this.state.arrayOfNodes;
      var _props = this.props,
          style = _props.style,
          className = _props.className;

      return _react2.default.createElement(
        'div',
        { style: style, className: className },
        arrayOfNodes.map(function (singleNode, i) {
          return (0, _react.cloneElement)(singleNode.singleNode, {
            key: singleNode.id,
            index: i,
            dragEnds: _this2.dragEnds,
            moveCard: _this2.moveCard
          });
        })
      );
    }
  }]);

  return SortableList;
}(_react.Component);

SortableList.propTypes = {
  style: _react.PropTypes.object,
  cardStyle: _react.PropTypes.object,
  className: _react.PropTypes.string,
  children: _react.PropTypes.array.isRequired,
  arrayOfData: _react.PropTypes.array.isRequired,
  dragEnds: _react.PropTypes.func.isRequired
};

exports.default = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default)(SortableList);

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragDropContext = __webpack_require__(1881);

Object.defineProperty(exports, 'DragDropContext', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropContext).default;
  }
});

var _DragDropContextProvider = __webpack_require__(2909);

Object.defineProperty(exports, 'DragDropContextProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropContextProvider).default;
  }
});

var _DragLayer = __webpack_require__(2910);

Object.defineProperty(exports, 'DragLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragLayer).default;
  }
});

var _DragSource = __webpack_require__(2911);

Object.defineProperty(exports, 'DragSource', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragSource).default;
  }
});

var _DropTarget = __webpack_require__(2921);

Object.defineProperty(exports, 'DropTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropTarget).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(550);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 1133 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(47);

var _reactDnd = __webpack_require__(1131);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemTypes = {
  CARD: 'card'
};

var cardSource = {
  beginDrag: function beginDrag(props) {
    return (0, _ramda.pick)(['index'], props);
  },
  endDrag: function endDrag(props, monitor) {
    var dragIndex = monitor.getItem().index;
    props.dragEnds(dragIndex);
  }
};

var cardTarget = {
  hover: function hover(props, monitor, component) {
    var dragIndex = monitor.getItem().index;
    var hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    var hoverBoundingRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();

    // Get vertical middle
    var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    var clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    var hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    // if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
    //   return;
    // }
    //
    // // Dragging upwards
    // if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
    //   return;
    // }

    // Time to actually perform the action
    props.moveCard(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  }
};

var dropTargetFn = (0, _reactDnd.DropTarget)(ItemTypes.CARD, cardTarget, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
});
var dragSourceFn = (0, _reactDnd.DragSource)(ItemTypes.CARD, cardSource, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
});

var DraggaleCard = function (_Component) {
  _inherits(DraggaleCard, _Component);

  function DraggaleCard() {
    _classCallCheck(this, DraggaleCard);

    return _possibleConstructorReturn(this, (DraggaleCard.__proto__ || Object.getPrototypeOf(DraggaleCard)).apply(this, arguments));
  }

  _createClass(DraggaleCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isDragging = _props.isDragging,
          connectDragSource = _props.connectDragSource,
          connectDropTarget = _props.connectDropTarget,
          isDragSource = _props.isDragSource,
          isDropTarget = _props.isDropTarget,
          style = _props.style,
          className = _props.className;

      var opacity = isDragging ? 0.2 : 1;
      var newStyle = (0, _ramda.merge)(isDragging ? { border: '1px dashed gray', backgroundColor: 'white' } : { cursor: isDragSource ? 'move' : 'cursor' }, style);
      var content = _react2.default.createElement(
        'div',
        { style: _extends({}, newStyle, { opacity: opacity }), className: className },
        children
      );
      if (isDragSource && isDropTarget) return connectDragSource(connectDropTarget(content));
      if (isDropTarget) return connectDropTarget(content);
      if (isDragSource) return connectDragSource(content);
      return content;
    }
  }]);

  return DraggaleCard;
}(_react.Component);

DraggaleCard.propTypes = {
  connectDragSource: _react.PropTypes.func.isRequired,
  connectDropTarget: _react.PropTypes.func.isRequired,
  index: _react.PropTypes.number.isRequired,
  isDragging: _react.PropTypes.bool.isRequired,
  children: _react.PropTypes.node.isRequired,
  moveCard: _react.PropTypes.func.isRequired,
  isDragSource: _react.PropTypes.bool.isRequired,
  isDropTarget: _react.PropTypes.bool.isRequired,
  style: _react.PropTypes.object,
  className: _react.PropTypes.string
};

exports.default = (0, _ramda.compose)(dropTargetFn, dragSourceFn)(DraggaleCard);

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dialogConstants = __webpack_require__(616);

var _dialogConstants2 = _interopRequireDefault(_dialogConstants);

var _wizardConstants = __webpack_require__(3219);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  clearContractingErrorString: 'CLEAR_CONTRACTING_ERROR_STRING',
  showContractingErrorString: 'SHOW_CONTRACTING_ERROR_STRING'
}, _wizardConstants.wizardMappedActions, _dialogConstants2.default);

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.addMonths = addMonths;
exports.isSameDay = isSameDay;
exports.isDayBefore = isDayBefore;
exports.isDayAfter = isDayAfter;
exports.isPastDay = isPastDay;
exports.isFutureDay = isFutureDay;
exports.isDayBetween = isDayBetween;
exports.addDayToRange = addDayToRange;
exports.isDayInRange = isDayInRange;
exports.getWeekNumber = getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */
function clone(d) {
  return new Date(d.getTime());
}

/**
 * Return `d` as a new date with `n` months added.
 * 
 * @export
 * @param {[type]} d
 * @param {[type]} n
 */
function addMonths(d, n) {
  var newDate = clone(d);
  newDate.setMonth(d.getMonth() + n);
  return newDate;
}

/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameDay(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Returns `true` if the first day is before the second day.
 * 
 * @export
 * @param {Date} d1 
 * @param {Date} d2 
 * @returns {Boolean}
 */
function isDayBefore(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 < day2;
}

/**
 * Returns `true` if the first day is after the second day.
 * 
 * @export
 * @param {Date} d1 
 * @param {Date} d2 
 * @returns {Boolean}
 */
function isDayAfter(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 > day2;
}

/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isPastDay(d) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return isDayBefore(d, today);
}

/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isFutureDay(d) {
  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  tomorrow.setHours(0, 0, 0, 0);
  return d >= tomorrow;
}

/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isDayBetween(d, d1, d2) {
  var date = clone(d);
  date.setHours(0, 0, 0, 0);
  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
}

/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */
function addDayToRange(day) {
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
  var from = range.from,
      to = range.to;

  if (!from) {
    from = day;
  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
    from = null;
    to = null;
  } else if (to && isDayBefore(day, from)) {
    from = day;
  } else if (to && isSameDay(day, to)) {
    from = day;
    to = day;
  } else {
    to = day;
    if (isDayBefore(to, from)) {
      to = from;
      from = day;
    }
  }

  return { from: from, to: to };
}

/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */
function isDayInRange(day, range) {
  var from = range.from,
      to = range.to;

  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
}

/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 * 
 * @export
 * @param {Date} day 
 * @returns {Number}
 */
function getWeekNumber(day) {
  var date = clone(day);
  date.setHours(0, 0, 0);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}

exports.default = {
  addDayToRange: addDayToRange,
  addMonths: addMonths,
  clone: clone,
  getWeekNumber: getWeekNumber,
  isDayAfter: isDayAfter,
  isDayBefore: isDayBefore,
  isDayBetween: isDayBetween,
  isDayInRange: isDayInRange,
  isFutureDay: isFutureDay,
  isPastDay: isPastDay,
  isSameDay: isSameDay
};
//# sourceMappingURL=DateUtils.js.map

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var minRow = function minRow() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var charLength = arguments[1];

  var numberOfLineBreaks = (value.match(/\n/g) || []).length;
  var rowNum = (value || '').length / (charLength || 70) + numberOfLineBreaks;
  if (rowNum < 5) return 5;
  return Math.floor(rowNum);
};

exports.default = function (_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      style = _ref.style,
      charLength = _ref.charLength,
      placeholder = _ref.placeholder;
  return _react2.default.createElement(
    'div',
    { style: _ramda2.default.merge({ padding: '12px 12px 0 12px', overflow: 'auto', minHeight: '120px', border: '1px solid #00BCD4' }, style) },
    _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-email', color: '#bfbfbf', style: { top: '12px' } }),
    _react2.default.createElement('textarea', {
      placeholder: placeholder || 'Add a note...',
      value: value,
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      },
      style: {
        float: 'right',
        width: '90%',
        marginRight: '5%',
        marginBottom: '2px',
        fontSize: '14px',
        lineHeight: '18px',
        border: 'none',
        resize: 'none',
        overflow: 'hidden'
      },
      rows: minRow(value, charLength)
    })
  );
};

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _errorOutline = __webpack_require__(1515);

var _errorOutline2 = _interopRequireDefault(_errorOutline);

var _checkCircle = __webpack_require__(1044);

var _checkCircle2 = _interopRequireDefault(_checkCircle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var showError = _ref.showError;
  return showError ? _react2.default.createElement(_errorOutline2.default, { color: '#f44336', style: { flex: 'none', marginRight: '2px' } }) : _react2.default.createElement(_checkCircle2.default, { color: '#4caf50', style: { flex: 'none', marginRight: '2px' } });
};

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StepperWizard = function (_Component) {
	_inherits(StepperWizard, _Component);

	function StepperWizard(props) {
		_classCallCheck(this, StepperWizard);

		var _this = _possibleConstructorReturn(this, (StepperWizard.__proto__ || Object.getPrototypeOf(StepperWizard)).call(this, props));

		_this.state = _this._populateState(props);
		return _this;
	}

	_createClass(StepperWizard, [{
		key: '_populateState',
		value: function _populateState(props) {
			var steps = props.steps || [];
			var componentIndex = props.componentIndex || 0;
			return {
				componentIndex: componentIndex,
				stepperState: steps.map(function (step, index) {
					return {
						name: step,
						selected: index === componentIndex,
						finished: index < componentIndex
					};
				})
			};
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (this.props.componentIndex !== nextProps.componentIndex) {
				this.setState(this._populateState(nextProps));
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var getPossibleState = function getPossibleState(selected, finished) {
				if (finished) return 'done';
				if (selected) return 'doing';
				return 'todo';
			};
			var _state = this.state,
			    stepperState = _state.stepperState,
			    componentIndex = _state.componentIndex;
			var _props = this.props,
			    children = _props.children,
			    steps = _props.steps,
			    showStepsBar = _props.showStepsBar;

			return _react2.default.createElement(
				'div',
				{ className: 'stepper-container', style: { boxShadow: 'none', padding: showStepsBar ? '17px' : '0px' } },
				showStepsBar ? _react2.default.createElement(
					'div',
					{ className: 'stepper-body' },
					stepperState.map(function (_ref, index) {
						var finished = _ref.finished,
						    name = _ref.name,
						    selected = _ref.selected;

						var _ref2 = function () {
							if (stepperState.length === 3) {
								if (stepperState.length === index + 1) return ['20%', '0', '5%'];
								return ['35%', '40%', '5%'];
							}
							if (stepperState.length === 4) {
								if (stepperState.length === index + 1) return ['25%', '0', '2%'];
								return ['28%', '20%', '2%'];
							}
							if (stepperState.length === index + 1) return ['35%', '60%', '5%'];
							return ['85%', '60%', '5%'];
						}(),
						    _ref3 = _slicedToArray(_ref2, 3),
						    containerWidth = _ref3[0],
						    lineWidth = _ref3[1],
						    margin = _ref3[2];

						var firstMarginLeft = function () {
							if (index > 0) return margin;
							if (stepperState.length === 2) return '10%';
							return '0';
						}();
						return _react2.default.createElement(
							'div',
							{ className: 'step-container', key: index, style: { width: containerWidth, marginLeft: firstMarginLeft } },
							_react2.default.createElement(
								'div',
								{ className: 'stepper-body' },
								_react2.default.createElement(
									'div',
									{ style: { width: '24px', height: '24px', borderRadius: '50%', textAlign: 'center', lineHeight: '20px', display: 'inline-block', float: 'left',
											backgroundColor: getPossibleState(selected, finished) !== 'todo' ? '#00BCD4' : '#BDBDBD' }
									},
									finished ? _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-check', color: 'white', style: { fontSize: '14px', fontWeight: 'bold', top: '2px' } }) : _react2.default.createElement(
										'span',
										{ style: { color: 'white', fontSize: '15px', lineHeight: '24px' } },
										index + 1
									)
								),
								_react2.default.createElement(
									'span',
									{ className: 'step-title' },
									name
								),
								stepperState.length !== index + 1 ? _react2.default.createElement('span', { className: 'step-grey-line', style: { width: lineWidth } }) : undefined
							)
						);
					})
				) : !steps[componentIndex] ? undefined : _react2.default.createElement(
					'div',
					{
						style: {
							backgroundColor: '#00BCD4',
							color: 'white',
							fontSize: '18px',
							padding: '2%'
						}
					},
					steps[componentIndex]
				),
				showStepsBar ? _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '20px' } }) : undefined,
				_react2.default.createElement(
					'div',
					{ className: 'contracting-paper-body' },
					children[componentIndex]
				)
			);
		}
	}]);

	return StepperWizard;
}(_react.Component);

;

StepperWizard.propTypes = {
	componentIndex: _react.PropTypes.number.isRequired,
	steps: _react.PropTypes.array
};

exports.default = StepperWizard;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _datePicker = __webpack_require__(1003);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePickerSet = function DatePickerSet(_ref) {
  var disabledRanges = _ref.disabledRanges,
      style = _ref.style,
      showTextField = _ref.showTextField,
      textFieldStyle = _ref.textFieldStyle,
      textFieldOnChange = _ref.textFieldOnChange,
      textFieldValue = _ref.textFieldValue,
      textFieldFloatingText = _ref.textFieldFloatingText,
      startDateContainerStyle = _ref.startDateContainerStyle,
      startDateTextFieldStyle = _ref.startDateTextFieldStyle,
      onChangeStartDate = _ref.onChangeStartDate,
      initialStartDateMonth = _ref.initialStartDateMonth,
      startDateFloatingText = _ref.startDateFloatingText,
      startDateHintText = _ref.startDateHintText,
      startDate = _ref.startDate,
      startDateErrorText = _ref.startDateErrorText,
      startDateCloseOnSelect = _ref.startDateCloseOnSelect,
      startDateEnableFrom = _ref.startDateEnableFrom,
      startDateEnableTo = _ref.startDateEnableTo,
      disableDeleteButton = _ref.disableDeleteButton,
      addButtonStyle = _ref.addButtonStyle,
      deleteButtonStyle = _ref.deleteButtonStyle,
      onDelete = _ref.onDelete,
      onAdd = _ref.onAdd,
      endDateContainerStyle = _ref.endDateContainerStyle,
      endDateTextFieldStyle = _ref.endDateTextFieldStyle,
      onChangeEndDate = _ref.onChangeEndDate,
      initialEndDateMonth = _ref.initialEndDateMonth,
      endDateFloatingText = _ref.endDateFloatingText,
      endDateHintText = _ref.endDateHintText,
      endDate = _ref.endDate,
      endDateErrorText = _ref.endDateErrorText,
      endDateCloseOnSelect = _ref.endDateCloseOnSelect,
      endDateEnableFrom = _ref.endDateEnableFrom,
      endDateEnableTo = _ref.endDateEnableTo,
      renderDay = _ref.renderDay,
      startDateDisabled = _ref.startDateDisabled,
      endDateDisabled = _ref.endDateDisabled,
      startDateUnderlineStyle = _ref.startDateUnderlineStyle,
      endDateUnderlineStyle = _ref.endDateUnderlineStyle;

  return _react2.default.createElement(
    'div',
    { style: { display: 'flex', alignItems: 'baseline' } },
    showTextField ? _react2.default.createElement(_materialUi.TextField, {
      style: _extends({ height: '48px' }, textFieldStyle),
      hintStyle: { top: '15px' },
      floatingLabelStyle: { top: '15px' },
      inputStyle: { top: '-12px' },
      onChange: textFieldOnChange,
      value: textFieldValue || '',
      floatingLabelText: textFieldFloatingText
    }) : undefined,
    _react2.default.createElement(_datePicker2.default, {
      disabled: startDateDisabled,
      containerStyle: startDateContainerStyle,
      textFieldStyle: startDateTextFieldStyle,
      onChange: onChangeStartDate,
      floatingLabelText: startDateFloatingText,
      hintText: startDateHintText,
      initialMonth: initialStartDateMonth,
      value: startDate,
      errorText: startDateErrorText,
      closeOnSelect: startDateCloseOnSelect,
      enableFrom: startDateEnableFrom,
      enableTo: startDateEnableTo,
      disabledRanges: disabledRanges,
      renderDay: renderDay,
      underlineStyle: startDateUnderlineStyle
    }),
    _react2.default.createElement(_datePicker2.default, {
      disabled: endDateDisabled,
      containerStyle: endDateContainerStyle,
      textFieldStyle: endDateTextFieldStyle,
      onChange: onChangeEndDate,
      floatingLabelText: endDateFloatingText,
      hintText: endDateHintText,
      initialMonth: initialEndDateMonth,
      value: endDate,
      errorText: endDateErrorText,
      closeOnSelect: endDateCloseOnSelect,
      enableFrom: endDateEnableFrom,
      enableTo: endDateEnableTo,
      disabledRanges: disabledRanges,
      renderDay: renderDay,
      underlineStyle: endDateUnderlineStyle
    }),
    _react2.default.createElement(_icon2.default, {
      className: 'tc-icon-close',
      style: _extends({
        color: disableDeleteButton ? 'grey' : '#ff4081',
        cursor: disableDeleteButton ? 'normal' : 'pointer'
      }, deleteButtonStyle),
      onClick: disableDeleteButton ? undefined : onDelete
    }),
    _react2.default.createElement(_icon2.default, {
      className: 'tc-icon-add',
      style: _extends({
        border: '2px solid green',
        borderRadius: '50%',
        cursor: 'pointer'
      }, addButtonStyle),
      onClick: onAdd
    })
  );
};

DatePickerSet.propTypes = {
  style: _react.PropTypes.object,
  showTextField: _react.PropTypes.bool,
  textFieldStyle: _react.PropTypes.object,
  textFieldOnChange: _react.PropTypes.func,
  textFieldValue: _react.PropTypes.any,
  textFieldFloatingText: _react.PropTypes.string,
  startDateContainerStyle: _react.PropTypes.object,
  startDateTextFieldStyle: _react.PropTypes.object,
  onChangeStartDate: _react.PropTypes.func,
  initialStartDateMonth: _react.PropTypes.any,
  startDateFloatingText: _react.PropTypes.string,
  startDate: _react.PropTypes.any,
  startDateErrorText: _react.PropTypes.string,
  startDateCloseOnSelect: _react.PropTypes.bool,
  disableDeleteButton: _react.PropTypes.bool,
  addButtonStyle: _react.PropTypes.object,
  deleteButtonStyle: _react.PropTypes.object,
  onDelete: _react.PropTypes.func,
  onAdd: _react.PropTypes.func,
  endDateContainerStyle: _react.PropTypes.object,
  endDateTextFieldStyle: _react.PropTypes.object,
  onChangeEndDate: _react.PropTypes.func,
  initialEndDateMonth: _react.PropTypes.any,
  endDateFloatingText: _react.PropTypes.string,
  endDate: _react.PropTypes.any,
  endDateErrorText: _react.PropTypes.string,
  endDateCloseOnSelect: _react.PropTypes.bool
};

exports.default = DatePickerSet;

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ResendContract = __webpack_require__(3346);

var _ResendContract2 = _interopRequireDefault(_ResendContract);

var _reactRedux = __webpack_require__(6);

var _userInputActions = __webpack_require__(1002);

var _rootActionsMap = __webpack_require__(1135);

var _rootActionsMap2 = _interopRequireDefault(_rootActionsMap);

var _contractActivitiesProductsActions = __webpack_require__(493);

var _dialogConstants = __webpack_require__(616);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResendContractUpdaatePartnerContainer = function ResendContractUpdaatePartnerContainer(props) {
  return _react2.default.createElement(_ResendContract2.default, props);
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user;
  return _extends({
    companyType: user.getIn(['user', 'type'])
  }, contracting.resendContractDialog.toJS());
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeResendContractDialog: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default, 'closeResendContractDialog'),
    dispatchResendContract: function dispatchResendContract() {
      return dispatch(_contractActivitiesProductsActions.doResendContract.apply(undefined, arguments));
    },
    updatePartnerForSentDoc: function updatePartnerForSentDoc() {
      return dispatch(_contractActivitiesProductsActions.updatePartnerForSentDoc.apply(undefined, arguments));
    },
    onBCCSelfCheck: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default, 'onBCCSelfCheck'),
    includeGeneralNoteCheck: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default, 'includeGeneralNoteCheck'),
    updateProps: function updateProps() {
      return dispatch(_dialogConstants.updatePropsInResendContractReducer.apply(undefined, arguments));
    },
    includeMultiLocNotesCheck: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default, 'includeMultiLocNotesCheck')
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResendContractUpdaatePartnerContainer);

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentArchive = function ContentArchive(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z' })
  );
};
ContentArchive = (0, _pure2.default)(ContentArchive);
ContentArchive.displayName = 'ContentArchive';
ContentArchive.muiName = 'SvgIcon';

exports.default = ContentArchive;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ListRow = __webpack_require__(3503);

var _ListRow2 = _interopRequireDefault(_ListRow);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleLocTemplates = function SingleLocTemplates(_ref) {
  var docs = _ref.docs,
      deleteTemplate = _ref.deleteTemplate,
      _archiveUnarchive = _ref.archiveUnarchive,
      updateTemplateProps = _ref.updateTemplateProps,
      deleteDraft = _ref.deleteDraft,
      updateDraftProps = _ref.updateDraftProps,
      getContractsCount = _ref.getContractsCount,
      saveNewTemplateName = _ref.saveNewTemplateName,
      updateProps = _ref.updateProps,
      showLocName = _ref.showLocName,
      router = _ref.router,
      doNotShowActionButtons = _ref.doNotShowActionButtons;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _materialUi.Table,
      { bodyStyle: { overflow: 'visible' }, style: { overflow: 'visible' }, wrapperStyle: { overflow: 'visible' } },
      _react2.default.createElement(
        _materialUi.TableHeader,
        { displaySelectAll: false, adjustForCheckbox: false },
        _react2.default.createElement(
          _materialUi.TableRow,
          null,
          _react2.default.createElement(
            _materialUi.TableHeaderColumn,
            { colSpan: '20', style: { height: '40px' } },
            'Template'
          ),
          _react2.default.createElement(
            _materialUi.TableHeaderColumn,
            { colSpan: '3', style: { padding: 0, textAlign: 'center', height: '40px' } },
            'Partners'
          ),
          _react2.default.createElement(
            _materialUi.TableHeaderColumn,
            { colSpan: '3', style: { padding: 0, textAlign: 'center', height: '40px' } },
            'Status'
          ),
          _react2.default.createElement(
            _materialUi.TableHeaderColumn,
            { colSpan: '3', style: { padding: 0, textAlign: 'center', height: '40px' } },
            'Periods'
          ),
          _react2.default.createElement(
            _materialUi.TableHeaderColumn,
            { colSpan: '3', style: { padding: 0, textAlign: 'center', height: '40px' } },
            'Modified'
          ),
          _react2.default.createElement(
            _materialUi.TableHeaderColumn,
            { colSpan: '4', style: { padding: 0, textAlign: 'center', height: '40px', display: doNotShowActionButtons ? 'none' : '' } },
            'Actions'
          )
        )
      ),
      _react2.default.createElement(
        _materialUi.TableBody,
        { style: { overflow: 'visible' } },
        docs.map(function (doc, i) {
          var isTemplate = !doc.state;
          var basicUrl = '/contracting/' + (isTemplate ? 'template' : 'draft') + '/' + (isTemplate ? doc._id : doc.originalContractId) + '/';
          var updateDocProps = isTemplate ? function (data) {
            return updateTemplateProps(doc._id, data);
          } : function (data) {
            return updateDraftProps(doc.originalContractId, data);
          };
          var deleteDoc = isTemplate ? function () {
            return deleteTemplate(doc._id);
          } : function () {
            return deleteDraft(doc.originFrom === 'edited', doc.originalContractId);
          };
          var saveNewName = isTemplate ? function (newName) {
            return saveNewTemplateName('template', doc._id, newName);
          } : function (newName) {
            return saveNewTemplateName('draft', doc.originalContractId, newName);
          };
          return _react2.default.createElement(_ListRow2.default, {
            key: '' + doc.templateName + doc.updatedAt + doc.state + i,
            template: doc,
            isTemplate: isTemplate,
            showLocName: showLocName,
            getContractsCount: getContractsCount,
            deleteTemplate: deleteDoc,
            archiveUnarchive: function archiveUnarchive() {
              return _archiveUnarchive({ isArchived: !doc.isArchived, templateId: doc._id });
            },
            updateTemplateProps: updateDocProps,
            saveNewTemplateName: saveNewName,
            updateProps: updateProps,
            viewTemplate: doc.showEditNameConfirmButton ? function () {} : function () {
              return router.push(basicUrl + 'details');
            },
            viewPartners: function viewPartners() {
              return router.push(basicUrl + 'partners');
            },
            doNotShowActionButtons: doNotShowActionButtons
          });
        })
      )
    )
  );
};
exports.default = SingleLocTemplates;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// create defaults
var defaultProps = exports.defaultProps = {
  attributes: {},
  styles: {}
};

var PropToggle = function (_PureComponent) {
  _inherits(PropToggle, _PureComponent);

  function PropToggle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PropToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PropToggle.__proto__ || Object.getPrototypeOf(PropToggle)).call.apply(_ref, [this].concat(args))), _this), _this.originalAttributes = {}, _this.originalStyles = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PropToggle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          attributes = _props.attributes,
          styles = _props.styles,
          _props$target = _props.target,
          target = _props$target === undefined ? document.body : _props$target;

      if (!target) return;

      this.attributeKeys = Object.keys(attributes);
      this.styleKeys = Object.keys(styles);

      // styles
      if (this.styleKeys.length) {
        this.styleKeys.forEach(function (k) {
          _this2.originalStyles[k] = target.style.getPropertyValue(k);
          target.style.setProperty(k, styles[k]);
        });
      }

      // attributes
      if (this.attributeKeys.length) {
        this.attributeKeys.forEach(function (k) {
          _this2.originalAttributes[k] = target.getAttribute(k) || '';
          target.setAttribute(k, attributes[k]);
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      var _props$target2 = this.props.target,
          target = _props$target2 === undefined ? document.body : _props$target2;

      if (!target) return;

      // styles
      if (this.styleKeys.length) {
        this.styleKeys.forEach(function (k) {
          target.style.setProperty(k, _this3.originalStyles[k]);
        });
      }

      // attributes
      if (this.attributeKeys.length) {
        this.attributeKeys.forEach(function (k) {
          if (_this3.originalAttributes[k]) {
            target.setAttribute(k, _this3.originalAttributes[k]);
          } else {
            target.removeAttribute(k);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return PropToggle;
}(_react.PureComponent);

PropToggle.defaultProps = defaultProps;
exports.default = PropToggle;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preventTouchMove = preventTouchMove;
exports.allowTouchMove = allowTouchMove;
exports.preventInertiaScroll = preventInertiaScroll;
exports.isTouchDevice = isTouchDevice;
exports.getPadding = getPadding;
exports.camelToKebab = camelToKebab;
exports.getWindowHeight = getWindowHeight;
exports.getDocumentHeight = getDocumentHeight;
exports.parse = parse;
function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  if (!window) return false;
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

function getPadding() {
  if (!document || !window) return 0;

  var currentPadding = parseInt(document.body.paddingRight, 10) || 0;
  var clientWidth = document.body ? document.body.clientWidth : 0;
  var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;

  return adjustedPadding;
}

function camelToKebab(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

function getWindowHeight() {
  var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  if (window && window.innerHeight) {
    return window.innerHeight * multiplier;
  }
}

function getDocumentHeight() {
  if (document && document.body) {
    return document.body.clientHeight;
  }
}

function parse(val) {
  return isNaN(val) ? val : val + 'px';
}

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(126);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(497);

var _theme = __webpack_require__(496);

var _theme2 = _interopRequireDefault(_theme);

var _deepMerge = __webpack_require__(552);

var _deepMerge2 = _interopRequireDefault(_deepMerge);

var _Icon = __webpack_require__(1147);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Arrow(_ref, _ref2) {
	var theme = _ref2.theme;

	var direction = _ref.direction,
	    icon = _ref.icon,
	    onClick = _ref.onClick,
	    size = _ref.size,
	    props = _objectWithoutProperties(_ref, ['direction', 'icon', 'onClick', 'size']);

	var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));

	return _react2.default.createElement(
		'button',
		_extends({
			type: 'button',
			className: (0, _noImportant.css)(classes.arrow, classes['arrow__direction__' + direction], size && classes['arrow__size__' + size]),
			onClick: onClick,
			onTouchEnd: onClick
		}, props),
		_react2.default.createElement(_Icon2.default, { fill: !!theme.arrow && theme.arrow.fill || _theme2.default.arrow.fill, type: icon })
	);
}

Arrow.propTypes = {
	direction: _propTypes2.default.oneOf(['left', 'right']),
	icon: _propTypes2.default.string,
	onClick: _propTypes2.default.func.isRequired,
	size: _propTypes2.default.oneOf(['medium', 'small']).isRequired
};
Arrow.defaultProps = {
	size: 'medium'
};
Arrow.contextTypes = {
	theme: _propTypes2.default.object.isRequired
};

var defaultStyles = {
	arrow: {
		background: 'none',
		border: 'none',
		borderRadius: 4,
		cursor: 'pointer',
		outline: 'none',
		padding: 10, // increase hit area
		position: 'absolute',
		top: '50%',

		// disable user select
		WebkitTouchCallout: 'none',
		userSelect: 'none'
	},

	// sizes
	arrow__size__medium: {
		height: _theme2.default.arrow.height,
		marginTop: _theme2.default.arrow.height / -2,
		width: 40,

		'@media (min-width: 768px)': {
			width: 70
		}
	},
	arrow__size__small: {
		height: _theme2.default.thumbnail.size,
		marginTop: _theme2.default.thumbnail.size / -2,
		width: 30,

		'@media (min-width: 500px)': {
			width: 40
		}
	},

	// direction
	arrow__direction__right: {
		right: _theme2.default.container.gutter.horizontal
	},
	arrow__direction__left: {
		left: _theme2.default.container.gutter.horizontal
	}
};

exports.default = Arrow;

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(126);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _arrowLeft = __webpack_require__(1579);

var _arrowLeft2 = _interopRequireDefault(_arrowLeft);

var _arrowRight = __webpack_require__(1580);

var _arrowRight2 = _interopRequireDefault(_arrowRight);

var _close = __webpack_require__(1581);

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var icons = { arrowLeft: _arrowLeft2.default, arrowRight: _arrowRight2.default, close: _close2.default };

var Icon = function Icon(_ref) {
	var fill = _ref.fill,
	    type = _ref.type,
	    props = _objectWithoutProperties(_ref, ['fill', 'type']);

	var icon = icons[type];

	return _react2.default.createElement('span', _extends({
		dangerouslySetInnerHTML: { __html: icon(fill) }
	}, props));
};

Icon.propTypes = {
	fill: _propTypes2.default.string,
	type: _propTypes2.default.oneOf(Object.keys(icons))
};
Icon.defaultProps = {
	fill: 'white'
};

exports.default = Icon;

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(126));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(47));

var _reactLifecyclesCompat = __webpack_require__(1149);

var _PropTypes = __webpack_require__(1150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.transitionTimeout = transitionTimeout;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;
  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]);

exports.timeoutsShape = timeoutsShape;

var classNamesShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]);

exports.classNamesShape = classNamesShape;

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(126));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(1149);

var _ChildMapping = __webpack_require__(1595);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};;
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _entry = __webpack_require__(1255);

var _removeFile2 = __webpack_require__(739);

var _removeFile3 = _interopRequireDefault(_removeFile2);

var _fileName = __webpack_require__(740);

var _fileName2 = _interopRequireDefault(_fileName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PDFPreview = function PDFPreview(props) {
  var url = props.url,
      _removeFile = props.removeFile,
      fileName = props.fileName,
      showFileName = props.showFileName,
      openGallery = props.openGallery,
      showGallery = props.showGallery,
      fullSize = props.fullSize;


  return _react2.default.createElement(
    'div',
    { style: { width: '100px', position: 'relative', display: 'inline-block' } },
    _react2.default.createElement(
      'div',
      { style: { height: '100%' }, onTouchTap: showGallery && openGallery },
      _react2.default.createElement(
        'div',
        { style: { cursor: showGallery ? 'pointer' : 'default', border: fullSize ? '' : '2px solid #D3D3D3', width: '100%', display: 'flex', justifyContent: 'center' } },
        _react2.default.createElement(
          _entry.Document,
          { file: url },
          _react2.default.createElement(_entry.Page, { pageNumber: 1, width: fullSize ? 450 : 85 })
        )
      ),
      showFileName && _react2.default.createElement(_fileName2.default, { fileName: fileName, width: '100px', vertical: true })
    ),
    _removeFile && _react2.default.createElement(_removeFile3.default, {
      top: '67%',
      left: '75%',
      removeFile: function removeFile() {
        return _removeFile(url);
      }
    })
  );
};

PDFPreview.propTypes = {
  url: _react.PropTypes.string,
  removeFile: _react.PropTypes.func,
  fileName: _react.PropTypes.string,
  showFileName: _react.PropTypes.bool,
  openGallery: _react.PropTypes.func,
  showGallery: _react.PropTypes.bool,
  fullSize: _react.PropTypes.bool
};

exports.default = PDFPreview;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _removeFile2 = __webpack_require__(739);

var _removeFile3 = _interopRequireDefault(_removeFile2);

var _fileName = __webpack_require__(740);

var _fileName2 = _interopRequireDefault(_fileName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoPreview = function VideoPreview(props) {
  var url = props.url,
      _removeFile = props.removeFile,
      fileName = props.fileName,
      showFileName = props.showFileName,
      openGallery = props.openGallery,
      showGallery = props.showGallery,
      fullSize = props.fullSize;


  return _react2.default.createElement(
    'div',
    { style: { display: 'inline-block', width: fullSize ? '100%' : '150px', maxHeight: fullSize && '550px', height: fullSize ? '' : '100px', position: 'relative', zIndex: '1' } },
    _react2.default.createElement(
      'div',
      { style: { height: '100%', width: '100%' }, onTouchTap: showGallery && openGallery },
      _react2.default.createElement(
        'video',
        { width: fullSize ? '' : '150', height: fullSize ? '550px' : '100', style: { cursor: showGallery ? 'pointer' : 'default' }, controls: fullSize },
        _react2.default.createElement('source', {
          src: url,
          type: 'video/mp4'
        })
      ),
      showFileName && _react2.default.createElement(_fileName2.default, { fileName: fileName, width: '150px' })
    ),
    _removeFile && _react2.default.createElement(_removeFile3.default, {
      removeFile: function removeFile() {
        return _removeFile(url);
      },
      top: '80%',
      left: '85%'
    })
  );
};

VideoPreview.propTypes = {
  url: _react.PropTypes.string,
  removeFile: _react.PropTypes.func,
  fileName: _react.PropTypes.string,
  showFileName: _react.PropTypes.bool,
  openGallery: _react.PropTypes.func,
  showGallery: _react.PropTypes.bool,
  fullSize: _react.PropTypes.bool
};

exports.default = VideoPreview;

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactDom = __webpack_require__(47);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _general = __webpack_require__(1604);

var _general2 = _interopRequireDefault(_general);

var _membership = __webpack_require__(1605);

var _membership2 = _interopRequireDefault(_membership);

var _newProdPublished = __webpack_require__(1606);

var _newProdPublished2 = _interopRequireDefault(_newProdPublished);

var _newLocPublished = __webpack_require__(1607);

var _newLocPublished2 = _interopRequireDefault(_newLocPublished);

var _compNameLoc = __webpack_require__(1608);

var _compNameLoc2 = _interopRequireDefault(_compNameLoc);

var _timestamp = __webpack_require__(1610);

var _timestamp2 = _interopRequireDefault(_timestamp);

var _container = __webpack_require__(1613);

var _container2 = _interopRequireDefault(_container);

var _tCSignUp = __webpack_require__(1640);

var _tCSignUp2 = _interopRequireDefault(_tCSignUp);

var _actions = __webpack_require__(226);

var _reactLinkify = __webpack_require__(1641);

var _reactLinkify2 = _interopRequireDefault(_reactLinkify);

var _helperFuncs = __webpack_require__(1652);

var _cloud = __webpack_require__(1653);

var _cloud2 = _interopRequireDefault(_cloud);

var _loadingBox = __webpack_require__(1274);

var _loadingBox2 = _interopRequireDefault(_loadingBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  displayType: _react.PropTypes.string, // internalPostPage, publicPostPage, empty means it's in the list
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  postId: _react.PropTypes.string,
  getPostForList: _react.PropTypes.func,
  deleteAPost: _react.PropTypes.func,
  filterByHashTag: _react.PropTypes.func,
  reportAPost: _react.PropTypes.func,
  body: _react.PropTypes.object,
  viewingCompanyId: _react.PropTypes.string,
  updateAPost: _react.PropTypes.func
};

var SinglePostContainer = function (_Component) {
  _inherits(SinglePostContainer, _Component);

  function SinglePostContainer(props) {
    _classCallCheck(this, SinglePostContainer);

    var _this = _possibleConstructorReturn(this, (SinglePostContainer.__proto__ || Object.getPrototypeOf(SinglePostContainer)).call(this, props));

    _this.showMoreText = function () {
      _this.setState({ showMoreText: true });
    };

    _this.reportPost = function () {
      var _this$props = _this.props,
          reportAPost = _this$props.reportAPost,
          postId = _this$props.postId;

      var confirm = window.confirm('Are you sure you want to report this post?');
      if (confirm) {
        reportAPost(postId);
      }
    };

    _this.changeRoute = function (route) {
      var displayType = _this.props.displayType;

      var publicPostPage = displayType === 'publicPostPage';
      if (publicPostPage) {
        window.open(window.location.protocol + '//' + window.location.host + '/signin?' + route);
        return;
      }
      _this.context.router.push(route);
    };

    _this.state = {
      showMoreText: false
    };
    return _this;
  }

  _createClass(SinglePostContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          loaded = _props.loaded,
          postId = _props.postId,
          getPostForList = _props.getPostForList;

      if (!loaded && postId) getPostForList(postId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var loaded = nextProps.loaded,
          loading = nextProps.loading,
          getPostForList = nextProps.getPostForList,
          postId = nextProps.postId;

      if (!loaded && !loading && postId) getPostForList(postId);
      if (loaded) {
        if (!this.refs.messageDiv || !this.refs.messageOuterDiv) return;
        var messageOuterDiv = (0, _reactDom.findDOMNode)(this.refs.messageOuterDiv).offsetHeight;
        var messageDiv = (0, _reactDom.findDOMNode)(this.refs.messageDiv).offsetHeight;
        if (messageDiv > messageOuterDiv) {
          this.showMoreText();
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          loaded = _props2.loaded,
          body = _props2.body,
          postId = _props2.postId,
          _deleteAPost = _props2.deleteAPost,
          viewingCompanyId = _props2.viewingCompanyId,
          filterByHashTag = _props2.filterByHashTag,
          displayType = _props2.displayType,
          updateAPost = _props2.updateAPost;

      if (!loaded) return _react2.default.createElement(_loadingBox2.default, null);
      var parsedMsg = (0, _helperFuncs.parseMessage)(_ramda2.default.pathOr('', ['post', 'message'], body));
      var PostBodyComponent = _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('general'), _ramda2.default.always(_general2.default)], [_ramda2.default.equals('new_product'), _ramda2.default.always(_newProdPublished2.default)], [_ramda2.default.equals('new_location'), _ramda2.default.always(_newLocPublished2.default)], [_ramda2.default.equals('new_membership'), _ramda2.default.always(_membership2.default)], [_ramda2.default.equals('tc_new_signup'), _ramda2.default.always(_tCSignUp2.default)], [_ramda2.default.T, _ramda2.default.always(_general2.default)]]), (body.template || '').toLowerCase());

      var avatarProps = _extends({}, body.profileImg ? { src: body.profileImg } : { icon: _react2.default.createElement(_cloud2.default, { style: { color: '#E0E0E0', fill: '#E0E0E0' } }) });

      return _react2.default.createElement(
        'div',
        { style: { padding: '0 1px' } },
        _react2.default.createElement(
          'div',
          { style: { display: 'inline-block', verticalAlign: 'top', padding: '0 5px', width: '11%' } },
          _react2.default.createElement(_materialUi.Avatar, _extends({
            className: 'news-feed-avatar',
            backgroundColor: '#ffffff',
            style: { marginTop: '10px' }
          }, avatarProps))
        ),
        _react2.default.createElement(
          _materialUi.Card,
          { style: { display: 'inline-block', width: '89%', margin: '10px 0', color: 'rgba(0, 0, 0, 0.54)' } },
          _react2.default.createElement(_compNameLoc2.default, {
            body: body,
            isOwner: Boolean(viewingCompanyId && body.companyId === viewingCompanyId),
            displayType: displayType,
            changeRoute: this.changeRoute,
            deleteAPost: function deleteAPost() {
              return _deleteAPost(postId, body.locations);
            },
            reportAPost: this.reportPost
          }),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '4px', padding: '0 2%' } },
            _react2.default.createElement(
              'span',
              { style: { whiteSpace: 'pre-wrap' } },
              _react2.default.createElement(
                'div',
                { ref: 'messageOuterDiv', style: { maxHeight: displayType === 'internalPostPage' ? '' : '450px', overflowY: 'hidden' } },
                _react2.default.createElement(
                  'div',
                  { ref: 'messageDiv' },
                  parsedMsg.map(function (_ref, i) {
                    var type = _ref.type,
                        value = _ref.value;

                    if (type === 'string') return _react2.default.createElement(
                      _reactLinkify2.default,
                      { properties: { target: '_blank' }, key: i },
                      value
                    );
                    // FOR HASHTAGS
                    // return <a style={{ cursor: 'pointer' }} key={i} onClick={() => filterByHashTag(value.toLowerCase())}>{value}</a>;
                    return value;
                  })
                )
              ),
              this.state.showMoreText && _react2.default.createElement(
                'div',
                {
                  style: {
                    minHeight: '35px',
                    display: 'block',
                    position: 'relative',
                    background: 'linear-gradient(to top, rgba(255,255,255, 1) 20%, rgba(255,255,255, 0) 80% )'
                  },
                  onClick: function onClick() {
                    return _this2.changeRoute('/post/' + postId);
                  }
                },
                _react2.default.createElement(
                  'span',
                  { style: { color: '#00bcd4', cursor: 'pointer', fontSize: '12px', bottom: 0, position: 'absolute' } },
                  _react2.default.createElement(
                    'b',
                    null,
                    '+'
                  ),
                  ' SEE MORE'
                )
              )
            ),
            _react2.default.createElement(PostBodyComponent, _extends({}, body, { changeRoute: this.changeRoute, displayType: displayType }))
          ),
          _react2.default.createElement(_timestamp2.default, { timestamp: body.timestamp }),
          _react2.default.createElement(
            'div',
            { style: { borderTop: '1px solid #ededed', marginTop: '10px' } },
            _react2.default.createElement(_container2.default, {
              postId: postId,
              shareableLink: window.location.protocol + '//' + window.location.host + '/post/' + postId,
              companyName: body.companyName,
              message: _ramda2.default.pathOr('', ['post', 'message'], body),
              updatePost: function updatePost(updateType) {
                if (updateType === 'like') {
                  updateAPost(postId, updateType, { numOfLikes: _ramda2.default.inc(_ramda2.default.propOr(0, 'numOfLikes', body)), didUserLike: true });
                } else if (updateType === 'unlike') {
                  updateAPost(postId, updateType, { numOfLikes: _ramda2.default.dec(_ramda2.default.propOr(0, 'numOfLikes', body)), didUserLike: false });
                }
              },
              numOfLikes: _ramda2.default.propOr(0, 'numOfLikes', body),
              comments: _ramda2.default.propOr([], 'comments', body),
              numOfComments: _ramda2.default.propOr(0, 'numOfComments', body),
              liked: body.didUserLike,
              displayType: displayType,
              changeRoute: this.changeRoute,
              viewingCompanyId: viewingCompanyId
            })
          )
        )
      );
    }
  }]);

  return SinglePostContainer;
}(_react.Component);

SinglePostContainer.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref2) {
  var user = _ref2.user;
  return {
    viewingCompanyId: user ? user.getIn(['company', 'companyId']) : ''
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getPostForList: function getPostForList() {
      return dispatch(_actions.getPostForList.apply(undefined, arguments));
    },
    deleteAPost: function deleteAPost() {
      return dispatch(_actions.deletePost.apply(undefined, arguments));
    },
    updateAPost: function updateAPost() {
      return dispatch(_actions.updatePost.apply(undefined, arguments));
    },
    reportAPost: function reportAPost(postId) {
      return dispatch((0, _actions.reportPost)(postId));
    }
  };
};

SinglePostContainer.contextTypes = {
  router: _react.PropTypes.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SinglePostContainer);

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.13
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(221)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.13",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess,

		momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.offset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		return b.zone.population - a.zone.population;
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName){
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			if (split[5]) {
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	}

	function getZone (name, caller) {
		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		return !!(m._a && (m._tzm === undefined));
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.offset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				mom.utcOffset(-offset, keepTime);
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name) {
		if (name) {
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc      = resetZoneWrap(fn.utc);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-au": 881,
	"./en-au.js": 881,
	"./en-ca": 882,
	"./en-ca.js": 882,
	"./en-gb": 883,
	"./en-gb.js": 883,
	"./en-ie": 884,
	"./en-ie.js": 884,
	"./en-il": 885,
	"./en-il.js": 885,
	"./en-nz": 886,
	"./en-nz.js": 886
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1156;

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

module.exports = {"version":"2017b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|HMT +0630 IST|-5R.k -6u -5u|01212|-18LFR.k 1unn.k HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.E -6u -90|0121|-21Jio.E SmnS.E 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Etc/GMT+0|GMT|0|0|","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Khartoum|Africa/Juba","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/East-Saskatchewan","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT+0|Etc/GMT","Etc/GMT+0|Etc/GMT-0","Etc/GMT+0|Etc/GMT0","Etc/GMT+0|Etc/Greenwich","Etc/GMT+0|GMT","Etc/GMT+0|GMT+0","Etc/GMT+0|GMT-0","Etc/GMT+0|GMT0","Etc/GMT+0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1032), __esModule: true };

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1623);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(1012);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1626);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1627);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(1012);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1198), __esModule: true };

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.email = email;
exports.twitter = twitter;
exports.telegram = telegram;
exports.whatsapp = whatsapp;
exports.facebook = facebook;
exports.googlePlus = googlePlus;
exports.linkedin = linkedin;
exports.pinterest = pinterest;
exports.vk = vk;
exports.ok = ok;
exports.reddit = reddit;

var _assert = __webpack_require__(1210);

var _assert2 = _interopRequireDefault(_assert);

var _utils = __webpack_require__(1013);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-template */
function email(url, _ref) {
  var subject = _ref.subject,
      body = _ref.body;

  return 'mailto:' + (0, _utils.objectToGetParams)({ subject: subject, body: body || email });
}

function twitter(url, _ref2) {
  var title = _ref2.title,
      via = _ref2.via,
      _ref2$hashtags = _ref2.hashtags,
      hashtags = _ref2$hashtags === undefined ? [] : _ref2$hashtags;

  (0, _assert2.default)(url, 'twitter.url');
  (0, _assert2.default)(Array.isArray(hashtags), 'twitter.hashtags is not an array');

  return 'https://twitter.com/share' + (0, _utils.objectToGetParams)({
    url: url,
    text: title,
    via: via,
    hashtags: hashtags.join(',')
  });
}

function telegram(url, _ref3) {
  var title = _ref3.title;

  (0, _assert2.default)(url, 'telegram.url');
  return 'https://telegram.me/share/' + (0, _utils.objectToGetParams)({
    url: url,
    text: title
  });
}

function whatsapp(url, _ref4) {
  var title = _ref4.title,
      separator = _ref4.separator;

  (0, _assert2.default)(url, 'whatsapp.url');
  return 'https://api.whatsapp.com/send' + (0, _utils.objectToGetParams)({
    text: title + separator + url
  });
}

function facebook(url, _ref5) {
  var quote = _ref5.quote,
      hashtag = _ref5.hashtag;

  (0, _assert2.default)(url, 'facebook.url');

  return 'https://www.facebook.com/sharer/sharer.php' + (0, _utils.objectToGetParams)({
    u: url,
    quote: quote,
    hashtag: hashtag
  });
}

function googlePlus(url) {
  (0, _assert2.default)(url, 'googlePlus.url');

  return 'https://plus.google.com/share' + (0, _utils.objectToGetParams)({ url: url });
}

function linkedin(url, _ref6) {
  var title = _ref6.title,
      description = _ref6.description;

  (0, _assert2.default)(url, 'linkedin.url');

  return 'https://linkedin.com/shareArticle' + (0, _utils.objectToGetParams)({
    url: url,
    title: title,
    summary: description
  });
}

function pinterest(url, _ref7) {
  var media = _ref7.media,
      description = _ref7.description;

  (0, _assert2.default)(url, 'pinterest.url');
  (0, _assert2.default)(media, 'pinterest.media');

  return 'https://pinterest.com/pin/create/button/' + (0, _utils.objectToGetParams)({
    url: url,
    media: media,
    description: description
  });
}

function vk(url, _ref8) {
  var title = _ref8.title,
      description = _ref8.description,
      image = _ref8.image;

  (0, _assert2.default)(url, 'vk.url');

  return 'https://vk.com/share.php' + (0, _utils.objectToGetParams)({
    url: url,
    title: title,
    description: description,
    image: image
  });
}

function ok(url, _ref9) {
  var title = _ref9.title,
      description = _ref9.description,
      image = _ref9.image;

  (0, _assert2.default)(url, 'ok.url');

  return 'https://connect.ok.ru/offer' + (0, _utils.objectToGetParams)({
    url: url,
    title: title,
    description: description,
    imageUrl: image
  });
}

function reddit(url, _ref10) {
  var title = _ref10.title;

  (0, _assert2.default)(url, 'reddit.url');

  return 'https://www.reddit.com/submit' + (0, _utils.objectToGetParams)({
    url: url,
    title: title
  });
}

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Platform.js <https://mths.be/platform>
 * Copyright 2014-2018 Benjamin Tan <https://bnjmnt4n.now.sh/>
 * Copyright 2011-2013 John-David Dalton <http://allyoucanleet.com/>
 * Available under MIT license <https://mths.be/mit>
 */
;(function() {
  'use strict';

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used as a reference to the global object. */
  var root = (objectTypes[typeof window] && window) || this;

  /** Backup possible global object. */
  var oldRoot = root;

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
    root = freeGlobal;
  }

  /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */
  var maxSafeInteger = Math.pow(2, 53) - 1;

  /** Regular expression to detect Opera. */
  var reOpera = /\bOpera/;

  /** Possible global object. */
  var thisBinding = this;

  /** Used for native method references. */
  var objectProto = Object.prototype;

  /** Used to check for own properties of an object. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to resolve the internal `[[Class]]` of values. */
  var toString = objectProto.toString;

  /*--------------------------------------------------------------------------*/

  /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */
  function capitalize(string) {
    string = String(string);
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */
  function cleanupOS(os, pattern, label) {
    // Platform tokens are defined at:
    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    var data = {
      '10.0': '10',
      '6.4':  '10 Technical Preview',
      '6.3':  '8.1',
      '6.2':  '8',
      '6.1':  'Server 2008 R2 / 7',
      '6.0':  'Server 2008 / Vista',
      '5.2':  'Server 2003 / XP 64-bit',
      '5.1':  'XP',
      '5.01': '2000 SP1',
      '5.0':  '2000',
      '4.0':  'NT',
      '4.90': 'ME'
    };
    // Detect Windows version from platform tokens.
    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
        (data = data[/[\d.]+$/.exec(os)])) {
      os = 'Windows ' + data;
    }
    // Correct character case and cleanup string.
    os = String(os);

    if (pattern && label) {
      os = os.replace(RegExp(pattern, 'i'), label);
    }

    os = format(
      os.replace(/ ce$/i, ' CE')
        .replace(/\bhpw/i, 'web')
        .replace(/\bMacintosh\b/, 'Mac OS')
        .replace(/_PowerPC\b/i, ' OS')
        .replace(/\b(OS X) [^ \d]+/i, '$1')
        .replace(/\bMac (OS X)\b/, '$1')
        .replace(/\/(\d)/, ' $1')
        .replace(/_/g, '.')
        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
        .replace(/\bx86\.64\b/gi, 'x86_64')
        .replace(/\b(Windows Phone) OS\b/, '$1')
        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
        .split(' on ')[0]
    );

    return os;
  }

  /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */
  function each(object, callback) {
    var index = -1,
        length = object ? object.length : 0;

    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
      while (++index < length) {
        callback(object[index], index, object);
      }
    } else {
      forOwn(object, callback);
    }
  }

  /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */
  function format(string) {
    string = trim(string);
    return /^(?:webOS|i(?:OS|P))/.test(string)
      ? string
      : capitalize(string);
  }

  /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */
  function forOwn(object, callback) {
    for (var key in object) {
      if (hasOwnProperty.call(object, key)) {
        callback(object[key], key, object);
      }
    }
  }

  /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */
  function getClassOf(value) {
    return value == null
      ? capitalize(value)
      : toString.call(value).slice(8, -1);
  }

  /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */
  function isHostType(object, property) {
    var type = object != null ? typeof object[property] : 'number';
    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
      (type == 'object' ? !!object[property] : true);
  }

  /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */
  function qualify(string) {
    return String(string).replace(/([ -])(?!$)/g, '$1?');
  }

  /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */
  function reduce(array, callback) {
    var accumulator = null;
    each(array, function(value, index) {
      accumulator = callback(accumulator, value, index, array);
    });
    return accumulator;
  }

  /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */
  function trim(string) {
    return String(string).replace(/^ +| +$/g, '');
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */
  function parse(ua) {

    /** The environment context object. */
    var context = root;

    /** Used to flag when a custom context is provided. */
    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';

    // Juggle arguments.
    if (isCustomContext) {
      context = ua;
      ua = null;
    }

    /** Browser navigator object. */
    var nav = context.navigator || {};

    /** Browser user agent string. */
    var userAgent = nav.userAgent || '';

    ua || (ua = userAgent);

    /** Used to flag when `thisBinding` is the [ModuleScope]. */
    var isModuleScope = isCustomContext || thisBinding == oldRoot;

    /** Used to detect if browser is like Chrome. */
    var likeChrome = isCustomContext
      ? !!nav.likeChrome
      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());

    /** Internal `[[Class]]` value shortcuts. */
    var objectClass = 'Object',
        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
        enviroClass = isCustomContext ? objectClass : 'Environment',
        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';

    /** Detect Java environments. */
    var java = /\bJava/.test(javaClass) && context.java;

    /** Detect Rhino. */
    var rhino = java && getClassOf(context.environment) == enviroClass;

    /** A character to represent alpha. */
    var alpha = java ? 'a' : '\u03b1';

    /** A character to represent beta. */
    var beta = java ? 'b' : '\u03b2';

    /** Browser document object. */
    var doc = context.document || {};

    /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */
    var opera = context.operamini || context.opera;

    /** Opera `[[Class]]`. */
    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
      ? operaClass
      : (opera = null);

    /*------------------------------------------------------------------------*/

    /** Temporary variable used over the script's lifetime. */
    var data;

    /** The CPU architecture. */
    var arch = ua;

    /** Platform description array. */
    var description = [];

    /** Platform alpha/beta indicator. */
    var prerelease = null;

    /** A flag to indicate that environment features should be used to resolve the platform. */
    var useFeatures = ua == userAgent;

    /** The browser/environment version. */
    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();

    /** A flag to indicate if the OS ends with "/ Version" */
    var isSpecialCasedOS;

    /* Detectable layout engines (order is important). */
    var layout = getLayout([
      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
      'Trident',
      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
      'iCab',
      'Presto',
      'NetFront',
      'Tasman',
      'KHTML',
      'Gecko'
    ]);

    /* Detectable browser names (order is important). */
    var name = getName([
      'Adobe AIR',
      'Arora',
      'Avant Browser',
      'Breach',
      'Camino',
      'Electron',
      'Epiphany',
      'Fennec',
      'Flock',
      'Galeon',
      'GreenBrowser',
      'iCab',
      'Iceweasel',
      'K-Meleon',
      'Konqueror',
      'Lunascape',
      'Maxthon',
      { 'label': 'Microsoft Edge', 'pattern': 'Edge' },
      'Midori',
      'Nook Browser',
      'PaleMoon',
      'PhantomJS',
      'Raven',
      'Rekonq',
      'RockMelt',
      { 'label': 'Samsung Internet', 'pattern': 'SamsungBrowser' },
      'SeaMonkey',
      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Sleipnir',
      'SlimBrowser',
      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
      'Sunrise',
      'Swiftfox',
      'Waterfox',
      'WebPositive',
      'Opera Mini',
      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
      'Opera',
      { 'label': 'Opera', 'pattern': 'OPR' },
      'Chrome',
      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
      { 'label': 'IE', 'pattern': 'IEMobile' },
      { 'label': 'IE', 'pattern': 'MSIE' },
      'Safari'
    ]);

    /* Detectable products (order is important). */
    var product = getProduct([
      { 'label': 'BlackBerry', 'pattern': 'BB10' },
      'BlackBerry',
      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
      { 'label': 'Galaxy S5', 'pattern': 'SM-G900' },
      { 'label': 'Galaxy S6', 'pattern': 'SM-G920' },
      { 'label': 'Galaxy S6 Edge', 'pattern': 'SM-G925' },
      { 'label': 'Galaxy S7', 'pattern': 'SM-G930' },
      { 'label': 'Galaxy S7 Edge', 'pattern': 'SM-G935' },
      'Google TV',
      'Lumia',
      'iPad',
      'iPod',
      'iPhone',
      'Kindle',
      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Nexus',
      'Nook',
      'PlayBook',
      'PlayStation Vita',
      'PlayStation',
      'TouchPad',
      'Transformer',
      { 'label': 'Wii U', 'pattern': 'WiiU' },
      'Wii',
      'Xbox One',
      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
      'Xoom'
    ]);

    /* Detectable manufacturers. */
    var manufacturer = getManufacturer({
      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
      'Archos': {},
      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
      'Asus': { 'Transformer': 1 },
      'Barnes & Noble': { 'Nook': 1 },
      'BlackBerry': { 'PlayBook': 1 },
      'Google': { 'Google TV': 1, 'Nexus': 1 },
      'HP': { 'TouchPad': 1 },
      'HTC': {},
      'LG': {},
      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
      'Motorola': { 'Xoom': 1 },
      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
      'Nokia': { 'Lumia': 1 },
      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
      'Sony': { 'PlayStation': 1, 'PlayStation Vita': 1 }
    });

    /* Detectable operating systems (order is important). */
    var os = getOS([
      'Windows Phone',
      'Android',
      'CentOS',
      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
      'Debian',
      'Fedora',
      'FreeBSD',
      'Gentoo',
      'Haiku',
      'Kubuntu',
      'Linux Mint',
      'OpenBSD',
      'Red Hat',
      'SuSE',
      'Ubuntu',
      'Xubuntu',
      'Cygwin',
      'Symbian OS',
      'hpwOS',
      'webOS ',
      'webOS',
      'Tablet OS',
      'Tizen',
      'Linux',
      'Mac OS X',
      'Macintosh',
      'Mac',
      'Windows 98;',
      'Windows '
    ]);

    /*------------------------------------------------------------------------*/

    /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */
    function getLayout(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */
    function getManufacturer(guesses) {
      return reduce(guesses, function(result, value, key) {
        // Lookup the manufacturer by product or scan the UA for the manufacturer.
        return result || (
          value[product] ||
          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
        ) && key;
      });
    }

    /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */
    function getName(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */
    function getOS(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
            )) {
          result = cleanupOS(result, pattern, guess.label || guess);
        }
        return result;
      });
    }

    /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */
    function getProduct(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + ' *\\w+-[\\w]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
            )) {
          // Split by forward slash and append product version if needed.
          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
            result[0] += ' ' + result[1];
          }
          // Correct character case and cleanup string.
          guess = guess.label || guess;
          result = format(result[0]
            .replace(RegExp(pattern, 'i'), guess)
            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
        }
        return result;
      });
    }

    /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */
    function getVersion(patterns) {
      return reduce(patterns, function(result, pattern) {
        return result || (RegExp(pattern +
          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
      });
    }

    /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */
    function toStringPlatform() {
      return this.description || '';
    }

    /*------------------------------------------------------------------------*/

    // Convert layout to an array so we can add extra details.
    layout && (layout = [layout]);

    // Detect product names that contain their manufacturer's name.
    if (manufacturer && !product) {
      product = getProduct([manufacturer]);
    }
    // Clean up Google TV.
    if ((data = /\bGoogle TV\b/.exec(product))) {
      product = data[0];
    }
    // Detect simulators.
    if (/\bSimulator\b/i.test(ua)) {
      product = (product ? product + ' ' : '') + 'Simulator';
    }
    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
      description.push('running in Turbo/Uncompressed mode');
    }
    // Detect IE Mobile 11.
    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
      data = parse(ua.replace(/like iPhone OS/, ''));
      manufacturer = data.manufacturer;
      product = data.product;
    }
    // Detect iOS.
    else if (/^iP/.test(product)) {
      name || (name = 'Safari');
      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
        ? ' ' + data[1].replace(/_/g, '.')
        : '');
    }
    // Detect Kubuntu.
    else if (name == 'Konqueror' && !/buntu/i.test(os)) {
      os = 'Kubuntu';
    }
    // Detect Android browsers.
    else if ((manufacturer && manufacturer != 'Google' &&
        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
      name = 'Android Browser';
      os = /\bAndroid\b/.test(os) ? os : 'Android';
    }
    // Detect Silk desktop/accelerated modes.
    else if (name == 'Silk') {
      if (!/\bMobi/i.test(ua)) {
        os = 'Android';
        description.unshift('desktop mode');
      }
      if (/Accelerated *= *true/i.test(ua)) {
        description.unshift('accelerated');
      }
    }
    // Detect PaleMoon identifying as Firefox.
    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
      description.push('identifying as Firefox ' + data[1]);
    }
    // Detect Firefox OS and products running Firefox.
    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
      os || (os = 'Firefox OS');
      product || (product = data[1]);
    }
    // Detect false positives for Firefox/Safari.
    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
      // Escape the `/` for Firefox 1.
      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
        // Clear name of false positives.
        name = null;
      }
      // Reassign a generic name.
      if ((data = product || manufacturer || os) &&
          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
      }
    }
    // Add Chrome version to description for Electron.
    else if (name == 'Electron' && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) {
      description.push('Chromium ' + data);
    }
    // Detect non-Opera (Presto-based) versions (order is important).
    if (!version) {
      version = getVersion([
        '(?:Cloud9|CriOS|CrMo|Edge|FxiOS|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$))',
        'Version',
        qualify(name),
        '(?:Firefox|Minefield|NetFront)'
      ]);
    }
    // Detect stubborn layout engines.
    if ((data =
          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
        )) {
      layout = [data];
    }
    // Detect Windows Phone 7 desktop mode.
    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
      name += ' Mobile';
      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
      description.unshift('desktop mode');
    }
    // Detect Windows Phone 8.x desktop mode.
    else if (/\bWPDesktop\b/i.test(ua)) {
      name = 'IE Mobile';
      os = 'Windows Phone 8.x';
      description.unshift('desktop mode');
      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
    }
    // Detect IE 11 identifying as other browsers.
    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
      if (name) {
        description.push('identifying as ' + name + (version ? ' ' + version : ''));
      }
      name = 'IE';
      version = data[1];
    }
    // Leverage environment features.
    if (useFeatures) {
      // Detect server-side environments.
      // Rhino has a global function while others have a global object.
      if (isHostType(context, 'global')) {
        if (java) {
          data = java.lang.System;
          arch = data.getProperty('os.arch');
          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
        }
        if (rhino) {
          try {
            version = context.require('ringo/engine').version.join('.');
            name = 'RingoJS';
          } catch(e) {
            if ((data = context.system) && data.global.system == context.system) {
              name = 'Narwhal';
              os || (os = data[0].os || null);
            }
          }
          if (!name) {
            name = 'Rhino';
          }
        }
        else if (
          typeof context.process == 'object' && !context.process.browser &&
          (data = context.process)
        ) {
          if (typeof data.versions == 'object') {
            if (typeof data.versions.electron == 'string') {
              description.push('Node ' + data.versions.node);
              name = 'Electron';
              version = data.versions.electron;
            } else if (typeof data.versions.nw == 'string') {
              description.push('Chromium ' + version, 'Node ' + data.versions.node);
              name = 'NW.js';
              version = data.versions.nw;
            }
          }
          if (!name) {
            name = 'Node.js';
            arch = data.arch;
            os = data.platform;
            version = /[\d.]+/.exec(data.version);
            version = version ? version[0] : null;
          }
        }
      }
      // Detect Adobe AIR.
      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
        name = 'Adobe AIR';
        os = data.flash.system.Capabilities.os;
      }
      // Detect PhantomJS.
      else if (getClassOf((data = context.phantom)) == phantomClass) {
        name = 'PhantomJS';
        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
      }
      // Detect IE compatibility modes.
      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
        // We're in compatibility mode when the Trident version + 4 doesn't
        // equal the document mode.
        version = [version, doc.documentMode];
        if ((data = +data[1] + 4) != version[1]) {
          description.push('IE ' + version[1] + ' mode');
          layout && (layout[1] = '');
          version[1] = data;
        }
        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
      }
      // Detect IE 11 masking as other browsers.
      else if (typeof doc.documentMode == 'number' && /^(?:Chrome|Firefox)\b/.test(name)) {
        description.push('masking as ' + name + ' ' + version);
        name = 'IE';
        version = '11.0';
        layout = ['Trident'];
        os = 'Windows';
      }
      os = os && format(os);
    }
    // Detect prerelease phases.
    if (version && (data =
          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
          /\bMinefield\b/i.test(ua) && 'a'
        )) {
      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
      version = version.replace(RegExp(data + '\\+?$'), '') +
        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
    }
    // Detect Firefox Mobile.
    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS)\b/.test(os)) {
      name = 'Firefox Mobile';
    }
    // Obscure Maxthon's unreliable version.
    else if (name == 'Maxthon' && version) {
      version = version.replace(/\.[\d.]+/, '.x');
    }
    // Detect Xbox 360 and Xbox One.
    else if (/\bXbox\b/i.test(product)) {
      if (product == 'Xbox 360') {
        os = null;
      }
      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
        description.unshift('mobile mode');
      }
    }
    // Add mobile postfix.
    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
        (os == 'Windows CE' || /Mobi/i.test(ua))) {
      name += ' Mobile';
    }
    // Detect IE platform preview.
    else if (name == 'IE' && useFeatures) {
      try {
        if (context.external === null) {
          description.unshift('platform preview');
        }
      } catch(e) {
        description.unshift('embedded');
      }
    }
    // Detect BlackBerry OS version.
    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
          version
        )) {
      data = [data, /BB10/.test(ua)];
      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
      version = null;
    }
    // Detect Opera identifying/masking itself as another browser.
    // http://www.opera.com/support/kb/view/843/
    else if (this != forOwn && product != 'Wii' && (
          (useFeatures && opera) ||
          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
          (name == 'IE' && (
            (os && !/^Win/.test(os) && version > 5.5) ||
            /\bWindows XP\b/.test(os) && version > 8 ||
            version == 8 && !/\bTrident\b/.test(ua)
          ))
        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
      // When "identifying", the UA contains both Opera and the other browser's name.
      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
      if (reOpera.test(name)) {
        if (/\bIE\b/.test(data) && os == 'Mac OS') {
          os = null;
        }
        data = 'identify' + data;
      }
      // When "masking", the UA contains only the other browser's name.
      else {
        data = 'mask' + data;
        if (operaClass) {
          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
        } else {
          name = 'Opera';
        }
        if (/\bIE\b/.test(data)) {
          os = null;
        }
        if (!useFeatures) {
          version = null;
        }
      }
      layout = ['Presto'];
      description.push(data);
    }
    // Detect WebKit Nightly and approximate Chrome/Safari versions.
    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
      // Correct build number for numeric comparison.
      // (e.g. "532.5" becomes "532.05")
      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
      // Nightly builds are postfixed with a "+".
      if (name == 'Safari' && data[1].slice(-1) == '+') {
        name = 'WebKit Nightly';
        prerelease = 'alpha';
        version = data[1].slice(0, -1);
      }
      // Clear incorrect browser versions.
      else if (version == data[1] ||
          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
        version = null;
      }
      // Use the full Chrome version when available.
      data[1] = (/\bChrome\/([\d.]+)/i.exec(ua) || 0)[1];
      // Detect Blink layout engine.
      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
        layout = ['Blink'];
      }
      // Detect JavaScriptCore.
      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
      if (!useFeatures || (!likeChrome && !data[1])) {
        layout && (layout[1] = 'like Safari');
        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : '8');
      } else {
        layout && (layout[1] = 'like Chrome');
        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
      }
      // Add the postfix of ".x" or "+" for approximate versions.
      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
      // Obscure version for some Safari 1-2 releases.
      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
        version = data;
      }
    }
    // Detect Opera desktop modes.
    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
      name += ' ';
      description.unshift('desktop mode');
      if (data == 'zvav') {
        name += 'Mini';
        version = null;
      } else {
        name += 'Mobile';
      }
      os = os.replace(RegExp(' *' + data + '$'), '');
    }
    // Detect Chrome desktop mode.
    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
      description.unshift('desktop mode');
      name = 'Chrome Mobile';
      version = null;

      if (/\bOS X\b/.test(os)) {
        manufacturer = 'Apple';
        os = 'iOS 4.3+';
      } else {
        os = null;
      }
    }
    // Strip incorrect OS versions.
    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
        ua.indexOf('/' + data + '-') > -1) {
      os = trim(os.replace(data, ''));
    }
    // Add layout engine.
    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
        /Browser|Lunascape|Maxthon/.test(name) ||
        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|Web)/.test(name) && layout[1])) {
      // Don't add layout details to description if they are falsey.
      (data = layout[layout.length - 1]) && description.push(data);
    }
    // Combine contextual information.
    if (description.length) {
      description = ['(' + description.join('; ') + ')'];
    }
    // Append manufacturer to description.
    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
      description.push('on ' + manufacturer);
    }
    // Append product to description.
    if (product) {
      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
    }
    // Parse the OS into an object.
    if (os) {
      data = / ([\d.+]+)$/.exec(os);
      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
      os = {
        'architecture': 32,
        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
        'version': data ? data[1] : null,
        'toString': function() {
          var version = this.version;
          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
        }
      };
    }
    // Add browser/OS architecture.
    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
      if (os) {
        os.architecture = 64;
        os.family = os.family.replace(RegExp(' *' + data), '');
      }
      if (
          name && (/\bWOW64\b/i.test(ua) ||
          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
      ) {
        description.unshift('32-bit');
      }
    }
    // Chrome 39 and above on OS X is always 64-bit.
    else if (
        os && /^OS X/.test(os.family) &&
        name == 'Chrome' && parseFloat(version) >= 39
    ) {
      os.architecture = 64;
    }

    ua || (ua = null);

    /*------------------------------------------------------------------------*/

    /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */
    var platform = {};

    /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.description = ua;

    /**
     * The name of the browser's layout engine.
     *
     * The list of common layout engines include:
     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.layout = layout && layout[0];

    /**
     * The name of the product's manufacturer.
     *
     * The list of manufacturers include:
     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
     * "Nokia", "Samsung" and "Sony"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.manufacturer = manufacturer;

    /**
     * The name of the browser/environment.
     *
     * The list of common browser names include:
     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
     * "Opera Mini" and "Opera"
     *
     * Mobile versions of some browsers have "Mobile" appended to their name:
     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.name = name;

    /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.prerelease = prerelease;

    /**
     * The name of the product hosting the browser.
     *
     * The list of common products include:
     *
     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.product = product;

    /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.ua = ua;

    /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.version = name && version;

    /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */
    platform.os = os || {

      /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */
      'architecture': null,

      /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Ubuntu", "Debian", "Fedora", "Red Hat", "SuSE",
       * "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */
      'family': null,

      /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */
      'version': null,

      /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */
      'toString': function() { return 'null'; }
    };

    platform.parse = parse;
    platform.toString = toStringPlatform;

    if (platform.version) {
      description.unshift(version);
    }
    if (platform.name) {
      description.unshift(name);
    }
    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
      description.push(product ? '(' + os + ')' : 'on ' + os);
    }
    if (description.length) {
      platform.description = description.join(' ');
    }
    return platform;
  }

  /*--------------------------------------------------------------------------*/

  // Export platform.
  var platform = parse();

  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
  if (true) {
    // Expose platform on the global object to prevent errors when platform is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    root.platform = platform;

    // Define as an anonymous module so platform can be aliased through path mapping.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return platform;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for CommonJS support.
    forOwn(platform, function(value, key) {
      freeExports[key] = value;
    });
  }
  else {
    // Export to the global object.
    root.platform = platform;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)(module), __webpack_require__(51)))

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVKShareCount = undefined;

var _stringify = __webpack_require__(1629);

var _stringify2 = _interopRequireDefault(_stringify);

exports.getFacebookShareCount = getFacebookShareCount;
exports.getGooglePlusShareCount = getGooglePlusShareCount;
exports.getLinkedinShareCount = getLinkedinShareCount;
exports.getPinterestShareCount = getPinterestShareCount;
exports.getOKShareCount = getOKShareCount;
exports.getRedditShareCount = getRedditShareCount;

var _jsonp = __webpack_require__(1631);

var _jsonp2 = _interopRequireDefault(_jsonp);

var _platform = __webpack_require__(1166);

var _platform2 = _interopRequireDefault(_platform);

var _utils = __webpack_require__(1013);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFacebookShareCount(shareUrl, callback) {
  var endpoint = 'https://graph.facebook.com/?id=' + shareUrl;

  (0, _jsonp2.default)(endpoint, function (err, data) {
    callback(!err && data && data.share && data.share.share_count ? data.share.share_count : undefined);
  });
}

function getGooglePlusShareCount(shareUrl, callback) {
  if (_platform2.default.name === 'IE' && parseInt(_platform2.default.version, 10) < 11) {
    /* eslint-disable no-console */
    console.error('Google plus share count is not supported in <=IE10!');
    /* eslint-enable no-console */
    return;
  }

  var xhr = new XMLHttpRequest();

  xhr.open('POST', 'https://clients6.google.com/rpc');
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');

  xhr.send((0, _stringify2.default)({
    method: 'pos.plusones.get',
    id: 'p',
    params: {
      nolog: true,
      id: shareUrl,
      source: 'widget',
      userId: '@viewer',
      groupId: '@self'
    },
    jsonrpc: '2.0',
    key: 'p',
    apiVersion: 'v1'
  }));

  xhr.onload = function onSuccessdata() {
    var data = JSON.parse(this.responseText);
    callback(!!data ? data.result.metadata.globalCounts.count : undefined);
  };

  xhr.onerror = function onErrordata() {};
}

function getLinkedinShareCount(shareUrl, callback) {
  var url = 'https://www.linkedin.com/countserv/count/share';

  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
    url: shareUrl,
    format: 'jsonp'
  }), function (err, data) {
    callback(!!data ? data.count : undefined);
  });
}

function getPinterestShareCount(shareUrl, callback) {
  var url = 'https://api.pinterest.com/v1/urls/count.json';

  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
    url: shareUrl
  }), function (err, data) {
    callback(!!data ? data.count : undefined);
  });
}

function getVKShareCount(shareUrl, callback) {
  if (!window.VK) {
    window.VK = {
      Share: {
        count: function count(index, _count2) {
          return window.VK.callbacks[index](_count2);
        }
      },
      callbacks: []
    };
  }

  var url = 'https://vk.com/share.php';
  var index = window.VK.callbacks.length;

  window.VK.callbacks.push(callback);

  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
    act: 'count',
    index: index,
    url: shareUrl
  }));
}

exports.getVKShareCount = getVKShareCount;
function getOKShareCount(shareUrl, callback) {
  if (!window.OK) {
    window.OK = {
      Share: {
        count: function count(index, _count) {
          return window.OK.callbacks[index](_count);
        }
      },
      callbacks: []
    };
  }

  var url = 'https://connect.ok.ru/dk';
  var index = window.OK.callbacks.length;

  window.ODKL = {
    updateCount: function updateCount(a, b) {
      window.OK.callbacks[index](b);
    }
  };
  window.OK.callbacks.push(callback);

  return (0, _jsonp2.default)(url + (0, _utils.objectToGetParams)({
    'st.cmd': 'extLike',
    uid: 'odklcnt0',
    ref: shareUrl
  }));
}

function getRedditShareCount(shareUrl, callback) {
  var endpoint = 'https://www.reddit.com/api/info.json?limit=1&url=' + shareUrl;

  (0, _jsonp2.default)(endpoint, { param: 'jsonp' }, function (err, response) {
    callback(!err && response && response.data && response.data.children.length > 0 && response.data.children[0].data.score ? response.data.children[0].data.score : undefined);
  });
}

/***/ }),
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jssTemplate = __webpack_require__(1395);

var _jssTemplate2 = _interopRequireDefault(_jssTemplate);

var _jssGlobal = __webpack_require__(1397);

var _jssGlobal2 = _interopRequireDefault(_jssGlobal);

var _jssExtend = __webpack_require__(1398);

var _jssExtend2 = _interopRequireDefault(_jssExtend);

var _jssNested = __webpack_require__(1399);

var _jssNested2 = _interopRequireDefault(_jssNested);

var _jssCompose = __webpack_require__(1400);

var _jssCompose2 = _interopRequireDefault(_jssCompose);

var _jssCamelCase = __webpack_require__(1401);

var _jssCamelCase2 = _interopRequireDefault(_jssCamelCase);

var _jssDefaultUnit = __webpack_require__(1402);

var _jssDefaultUnit2 = _interopRequireDefault(_jssDefaultUnit);

var _jssExpand = __webpack_require__(1404);

var _jssExpand2 = _interopRequireDefault(_jssExpand);

var _jssVendorPrefixer = __webpack_require__(1406);

var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);

var _jssPropsSort = __webpack_require__(1411);

var _jssPropsSort2 = _interopRequireDefault(_jssPropsSort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    plugins: [(0, _jssTemplate2.default)(options.template), (0, _jssGlobal2.default)(options.global), (0, _jssExtend2.default)(options.extend), (0, _jssNested2.default)(options.nested), (0, _jssCompose2.default)(options.compose), (0, _jssCamelCase2.default)(options.camelCase), (0, _jssDefaultUnit2.default)(options.defaultUnit), (0, _jssExpand2.default)(options.expand), (0, _jssVendorPrefixer2.default)(options.vendorPrefixer), (0, _jssPropsSort2.default)(options.propsSort)]
  };
};

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_PUBLIC_NOTIFICATION_PROP = exports.UPDATE_PUBLIC_NOTIFICATION_PROP = 'UPDATE_PUBLIC_NOTIFICATION_PROP';

var GET_PS_STARTING = exports.GET_PS_STARTING = 'GET_PS_STARTING';
var GET_PS_FINISHED = exports.GET_PS_FINISHED = 'GET_PS_FINISHED';
var GET_PS_FAILED = exports.GET_PS_FAILED = 'GET_PS_FAILED';

var EDIT_NOTI_STARTING = exports.EDIT_NOTI_STARTING = 'EDIT_NOTI_STARTING';
var EDIT_NOTI_FINISHED = exports.EDIT_NOTI_FINISHED = 'EDIT_NOTI_FINISHED';
var EDIT_NOTI_FAILED = exports.EDIT_NOTI_FAILED = 'EDIT_NOTI_FAILED';

var SUBMIT_UNSUBSCRIBE_STARTING = exports.SUBMIT_UNSUBSCRIBE_STARTING = 'SUBMIT_UNSUBSCRIBE_STARTING';
var SUBMIT_UNSUBSCRIBE_FINISHED = exports.SUBMIT_UNSUBSCRIBE_FINISHED = 'SUBMIT_UNSUBSCRIBE_FINISHED';
var SUBMIT_UNSUBSCRIBE_FAILED = exports.SUBMIT_UNSUBSCRIBE_FAILED = 'SUBMIT_UNSUBSCRIBE_FAILED';

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorHighlight = function EditorHighlight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 14l3 3v5h6v-5l3-3V9H6zm5-12h2v3h-2zM3.5 5.875L4.914 4.46l2.12 2.122L5.62 7.997zm13.46.71l2.123-2.12 1.414 1.414L18.375 8z' })
  );
};
EditorHighlight = (0, _pure2.default)(EditorHighlight);
EditorHighlight.displayName = 'EditorHighlight';
EditorHighlight.muiName = 'SvgIcon';

exports.default = EditorHighlight;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_NEWSFEED_PROP = exports.UPDATE_NEWSFEED_PROP = 'UPDATE_NEWSFEED_PROP';

// submitting a new post
var SUBMIT_POST = exports.SUBMIT_POST = 'SUBMIT_POST';
var SUBMIT_POST_FAILED = exports.SUBMIT_POST_FAILED = 'SUBMIT_NEWSFEED_POST_FAILED';
var POST_SUBMITTED = exports.POST_SUBMITTED = 'POST_SUBMITTED';

// deleting a post
var DELETE_POST_STARTED = exports.DELETE_POST_STARTED = 'DELETE_POST_STARTED';
var DELETED_POST = exports.DELETED_POST = 'DELETED_POST';
var DELETE_POST_FAILED = exports.DELETE_POST_FAILED = 'DELETE_POST_FAILED';

// getting newsfeed
var GET_NEWSFEED_STARTED = exports.GET_NEWSFEED_STARTED = 'GET_NEWSFEED_STARTED';
var GOT_INITIAL_LOAD_NEWSFEED = exports.GOT_INITIAL_LOAD_NEWSFEED = 'GOT_INITIAL_LOAD_NEWSFEED';
var LOADED_MORE_NEWSFEED = exports.LOADED_MORE_NEWSFEED = 'LOADED_MORE_NEWSFEED';
var GET_NEWSFEED_FAILED = exports.GET_NEWSFEED_FAILED = 'GET_NEWSFEED_FAILED';
var GET_SINGLE_POST_FAILED = exports.GET_SINGLE_POST_FAILED = 'GET_SINGLE_POST_FOR_LIST_FAILED';
var GET_SINGLE_POST_STARTING = exports.GET_SINGLE_POST_STARTING = 'GET_SINGLE_POST_STARTING';
var GOT_SINGLE_POST = exports.GOT_SINGLE_POST = 'GOT_SINGLE_POST_FOR_LIST';

// getting hashtags
var GET_HASHTAGS_STARTED = exports.GET_HASHTAGS_STARTED = 'GET_HASHTAGS_STARTED';
var GOT_HASHTAGS = exports.GOT_HASHTAGS = 'GOT_HASHTAGS';
var GET_HASHTAGS_FAILED = exports.GET_HASHTAGS_FAILED = 'GET_HASHTAGS_FAILED';

// reporting a post
var REPORT_POST_STARTED = exports.REPORT_POST_STARTED = 'REPORT_POST_STARTED';
var REPORTED_POST = exports.REPORTED_POST = 'REPORTED_POST';
var REPORT_POST_FAILED = exports.REPORT_POST_FAILED = 'REPORT_POST_FAILED';

// comments
var REPORT_COMMENT_STARTED = exports.REPORT_COMMENT_STARTED = 'REPORT_COMMENT_STARTED';
var REPORT_COMMENT_FAILED = exports.REPORT_COMMENT_FAILED = 'REPORT_COMMENT_FAILED';
var REPORTED_COMMENT = exports.REPORTED_COMMENT = 'REPORTED_COMMENT';
var LOAD_MORE_COMMENTS_STARTED = exports.LOAD_MORE_COMMENTS_STARTED = 'LOAD_MORE_COMMENTS_STARTED';
var LOAD_MORE_COMMENTS_FAILED = exports.LOAD_MORE_COMMENTS_FAILED = 'LOAD_MORE_COMMENTS_FAILED';
var LOADED_MORE_COMMENTS = exports.LOADED_MORE_COMMENTS = 'LOADED_MORE_COMMENTS';

// updating a post
var START_UPDATING_A_POST = exports.START_UPDATING_A_POST = 'START_UPDATING_A_POST_NEWSFEED';
var UPDATED_POST = exports.UPDATED_POST = 'UPDATED_POST';
var UPDATE_POST_FAILED = exports.UPDATE_POST_FAILED = 'UPDATE_POST_FAILED';

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GOT_META_DATA_COUNT = exports.GOT_META_DATA_COUNT = 'GOT_META_DATA_COUNT_FOR_NEWSFEED_META_DATA';
var UPDATE_PROPS = exports.UPDATE_PROPS = 'UPDATE_PROPS_NEWSFEED_META_DATA';

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationChat = function CommunicationChat(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z' })
  );
};
CommunicationChat = (0, _pure2.default)(CommunicationChat);
CommunicationChat.displayName = 'CommunicationChat';
CommunicationChat.muiName = 'SvgIcon';

exports.default = CommunicationChat;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialSchool = function SocialSchool(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z' })
  );
};
SocialSchool = (0, _pure2.default)(SocialSchool);
SocialSchool.displayName = 'SocialSchool';
SocialSchool.muiName = 'SvgIcon';

exports.default = SocialSchool;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsDirections = function MapsDirections(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z' })
  );
};
MapsDirections = (0, _pure2.default)(MapsDirections);
MapsDirections.displayName = 'MapsDirections';
MapsDirections.muiName = 'SvgIcon';

exports.default = MapsDirections;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialWhatshot = function SocialWhatshot(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z' })
  );
};
SocialWhatshot = (0, _pure2.default)(SocialWhatshot);
SocialWhatshot.displayName = 'SocialWhatshot';
SocialWhatshot.muiName = 'SvgIcon';

exports.default = SocialWhatshot;

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationChatBubbleOutline = function CommunicationChatBubbleOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z' })
  );
};
CommunicationChatBubbleOutline = (0, _pure2.default)(CommunicationChatBubbleOutline);
CommunicationChatBubbleOutline.displayName = 'CommunicationChatBubbleOutline';
CommunicationChatBubbleOutline.muiName = 'SvgIcon';

exports.default = CommunicationChatBubbleOutline;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acceptConnection = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isSyncing = isSyncing;
exports.filterConnections = filterConnections;
exports.filterConnectionsByCountry = filterConnectionsByCountry;
exports.getCountries = getCountries;
exports.undoConnectionChange = undoConnectionChange;
exports.ignoreConnection = ignoreConnection;
exports.removeConnection = removeConnection;
exports.resendConnection = resendConnection;
exports.removeTag = removeTag;
exports.addTag = addTag;

var _soFetch = __webpack_require__(254);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _connectionsConstants = __webpack_require__(867);

var constants = _interopRequireWildcard(_connectionsConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var credentialsAndHeaders = {
  credentials: 'same-origin',
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
};

var baseUrl = '/proxy/connections';
var put = _extends({ method: 'put' }, credentialsAndHeaders);
var del = _extends({ method: 'delete' }, credentialsAndHeaders);

function ignoreConnectionStarting(connectionId) {
  return {
    type: constants.IGNORE_CONNECTION_STARTING,
    payload: connectionId
  };
}

function acceptConnectionStarting(connectionId) {
  return {
    type: constants.ACCEPT_CONNECTION_STARTING,
    payload: connectionId
  };
}

function resendConnectionStarting(connectionId) {
  return {
    type: constants.RESEND_CONNECTION_STARTING,
    payload: connectionId
  };
}

function removeConnectionStarting(connectionId) {
  return {
    type: constants.REMOVE_CONNECTION_STARTING,
    payload: connectionId
  };
}

function addTagStarting(connectionId, tagName) {
  return {
    type: constants.ADD_TAG_STARTING,
    payload: {
      tagName: tagName,
      connectionId: connectionId
    }
  };
}

function removeTagStarting(connectionId, tagName) {
  return {
    type: constants.REMOVE_TAG_STARTING,
    payload: {
      tagName: tagName,
      connectionId: connectionId
    }
  };
}

function isSyncing() {
  return {
    type: constants.CONNECTIONS_IS_SYNCING
  };
}

function filterConnections(options, pagination) {
  return function (dispatch) {
    dispatch(isSyncing());
    return (0, _soFetch.soFetch)(baseUrl, {
      actionType: pagination ? constants.LOAD_MORE_CONNECTIONS : constants.FILTER_CONNECTIONS,
      responseBinding: 'payload',
      qs: options
    })(dispatch);
  };
}

function filterConnectionsByCountry(options) {
  return function (dispatch) {
    dispatch(isSyncing());
    return (0, _soFetch.soFetch)(baseUrl, {
      actionType: constants.FILTER_CONNECTIONS_BY_COUNTRY,
      responseBinding: 'payload',
      qs: options
    })(dispatch);
  };
}

function getCountries() {
  return (0, _soFetch.soFetch)(baseUrl + '/countries', {
    actionType: constants.GET_COUNTRIES,
    responseBinding: 'payload'
  });
}

function undoConnectionChange(isToUndoRemoveConnection) {
  return function (dispatch) {
    if (isToUndoRemoveConnection) {
      return fetch(baseUrl, put).then(_checkStatus2.default).then(function (res) {
        return res.json();
      }).then(function () {
        return dispatch({
          type: constants.UNDO_CONNECTION_CHANGE
        });
      }).catch(function (err) {
        throw new Error(err);
      });
    }
    return {
      type: constants.UNDO_CONNECTION_CHANGE
    };
  };
}

function ignoreConnection(connectionId) {
  return function (dispatch) {
    dispatch(ignoreConnectionStarting(connectionId));
    return fetch('/proxy/connections/' + connectionId + '/rejected', put).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({
        type: constants.IGNORE_CONNECTION,
        payload: res
      });
    }).catch(function (err) {
      console.log(err);
      return dispatch(undoConnectionChange());
    });
  };
}

function removeConnection(connectionId) {
  return function (dispatch) {
    dispatch(removeConnectionStarting(connectionId));
    return fetch('/proxy/connections/' + connectionId + '/archive', put).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({
        type: constants.REMOVE_CONNECTION,
        payload: res
      });
    }).catch(function (err) {
      console.log(err);
      return dispatch(undoConnectionChange());
    });
  };
}

var acceptConnection = exports.acceptConnection = function acceptConnection(connectionId) {
  return function (dispatch) {
    dispatch(acceptConnectionStarting(connectionId));
    return fetch('/proxy/connections/' + connectionId + '/accepted', put).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({
        type: constants.ACCEPT_CONNECTION,
        payload: res
      });
    }).catch(function (err) {
      console.log(err);
      return dispatch(undoConnectionChange());
    });
  };
};

function resendConnection(connectionId) {
  return function (dispatch) {
    dispatch(resendConnectionStarting(connectionId));
    return fetch('/proxy/connections/' + connectionId + '/resend', put).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({
        type: constants.RESEND_CONNECTION,
        payload: res
      });
    }).catch(function (err) {
      console.log(err);
      throw new Error(err);
    });
  };
}

function removeTag(connectionId, tagName) {
  return function (dispatch) {
    dispatch(removeTagStarting(connectionId, tagName));
    return fetch('/proxy/connections/' + connectionId + '/tag/' + encodeURIComponent(tagName), del).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({
        type: constants.REMOVE_TAG,
        payload: res
      });
    }).catch(function (err) {
      console.log(err);
      throw new Error(err);
    });
  };
}

function addTag(connectionId, tagName) {
  return function (dispatch) {
    dispatch(addTagStarting(connectionId, tagName));
    return fetch('/proxy/connections/' + connectionId + '/tag/' + encodeURIComponent(tagName), put).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({
        type: constants.ADD_TAG,
        payload: res
      });
    }).catch(function (err) {
      console.log(err);
      throw new Error(err);
    });
  };
}

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setProductTourSteps = exports.openWalkThru = exports.closeWalkThru = exports.resetWalkThru = undefined;

var _walkthruConstants = __webpack_require__(1107);

var constants = _interopRequireWildcard(_walkthruConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var resetWalkThru = exports.resetWalkThru = function resetWalkThru() {
  return {
    type: constants.RESET
  };
};

var closeWalkThru = exports.closeWalkThru = function closeWalkThru() {
  return {
    type: constants.CLOSE
  };
};
var openWalkThru = exports.openWalkThru = function openWalkThru() {
  return {
    type: constants.OPEN
  };
};

var setProductTourSteps = exports.setProductTourSteps = function setProductTourSteps(steps, eventName) {
  return {
    type: constants.SET_STEPS,
    payload: {
      steps: steps,
      eventName: eventName
    }
  };
};

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSearch = function ActionSearch(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' })
  );
};
ActionSearch = (0, _pure2.default)(ActionSearch);
ActionSearch.displayName = 'ActionSearch';
ActionSearch.muiName = 'SvgIcon';

exports.default = ActionSearch;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SmallPreviewTile = function SmallPreviewTile(props) {
  var _props$sharedProps = props.sharedProps,
      downloadType = _props$sharedProps.downloadType,
      updateDownloadType = _props$sharedProps.updateDownloadType,
      hoverOver = _props$sharedProps.hoverOver,
      openBigPreview = _props$sharedProps.openBigPreview,
      hover = _props$sharedProps.hover,
      type = props.type,
      url = props.url,
      width = props.width;

  return _react2.default.createElement(
    'div',
    {
      style: {
        cursor: 'pointer',
        border: downloadType === type ? '2px solid #00bcd4' : '2px solid #e0e0e0',
        position: 'relative'
      },
      onClick: updateDownloadType(type),
      'data-cy': 'format-' + type,
      onMouseEnter: hoverOver(type),
      onMouseLeave: hoverOver('')
    },
    _react2.default.createElement('img', {
      width: width || '150px',
      src: url
    }),
    _react2.default.createElement(
      'div',
      {
        className: 'flex-center',
        style: {
          display: hover === type ? 'flex' : 'none',
          position: 'absolute',
          top: 0,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.7) 20%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 90%)',
          color: '#fff',
          width: '100%',
          padding: '4px 8px 16px',
          flexDirection: 'row-reverse'
        },
        onClick: openBigPreview(url)
      },
      _react2.default.createElement(
        'small',
        null,
        'Zoom'
      ),
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-zoom_in', color: '#fff', style: { fontSize: '28px' } })
    )
  );
};

var RateFormatSelection = function (_Component) {
  _inherits(RateFormatSelection, _Component);

  function RateFormatSelection() {
    _classCallCheck(this, RateFormatSelection);

    var _this = _possibleConstructorReturn(this, (RateFormatSelection.__proto__ || Object.getPrototypeOf(RateFormatSelection)).call(this));

    _this.state = {
      showBigPreview: '',
      hover: ''
    };
    return _this;
  }

  _createClass(RateFormatSelection, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState({ showBigPreview: '' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          updateDownloadTypeProp = _props.updateDownloadType,
          multi = _props.multi,
          downloadType = _props.downloadType;

      var updateDownloadType = function updateDownloadType(type) {
        return function () {
          return updateDownloadTypeProp(type);
        };
      };
      var openBigPreview = function openBigPreview(url) {
        return function () {
          return _this2.setState({ showBigPreview: url });
        };
      };
      var closeBigPreview = function closeBigPreview() {
        return _this2.setState({ showBigPreview: '' });
      };
      var hoverOver = function hoverOver(type) {
        return function () {
          return _this2.setState({ hover: type });
        };
      };
      var sharedProps = {
        downloadType: downloadType,
        updateDownloadType: updateDownloadType,
        hoverOver: hoverOver,
        openBigPreview: openBigPreview,
        hover: this.state.hover
      };
      var summarizedChecked = function () {
        var type = sharedProps.downloadType || '';
        return type.split('_').splice(0, 2).join('_') === 'quickview_summarized';
      }();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', flexDirection: 'column', textAlign: 'center' } },
          _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb' },
            _react2.default.createElement(SmallPreviewTile, {
              sharedProps: sharedProps,
              type: 'full',
              url: 'https://tourconnect-production-public.s3.amazonaws.com/contract-download-preview/Full+PDF.png'
            }),
            _react2.default.createElement(SmallPreviewTile, {
              sharedProps: sharedProps,
              type: 'condensed',
              url: 'https://tourconnect-production-public.s3.amazonaws.com/contract-download-preview/Condensed+PDF.png'
            }),
            _react2.default.createElement(SmallPreviewTile, {
              sharedProps: sharedProps,
              type: 'quickview_desummarized',
              width: '200px',
              url: 'https://tourconnect-production-public.s3.amazonaws.com/contract-download-preview/Quickview+Excel.png'
            }),
            _react2.default.createElement(SmallPreviewTile, {
              sharedProps: sharedProps,
              type: 'quickview_summarized',
              width: '200px',
              url: 'https://tourconnect-production-public.s3.amazonaws.com/contract-download-preview/Quickview+with+Summary+Excel.png'
            })
          ),
          _react2.default.createElement(
            'div',
            {
              style: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }
            },
            _react2.default.createElement(
              'div',
              {
                style: {
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                  width: '150px'
                }
              },
              _react2.default.createElement(_materialUi.RadioButton, {
                label: 'Full PDF',
                checked: sharedProps.downloadType === 'full',
                style: { margin: '16px auto 8px' },
                labelStyle: { fontSize: '12px', color: 'rgba(0, 0, 0, 0.87)' },
                onCheck: updateDownloadType('full')
              }),
              _react2.default.createElement(
                'small',
                { style: { fontSize: '10px' } },
                '- Contains descriptions'
              )
            ),
            _react2.default.createElement(
              'div',
              {
                style: {
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                  width: '150px'
                }
              },
              _react2.default.createElement(_materialUi.RadioButton, {
                label: 'Condensed PDF',
                checked: sharedProps.downloadType === 'condensed',
                style: { margin: '16px auto 8px' },
                labelStyle: { fontSize: '12px', color: 'rgba(0, 0, 0, 0.87)' },
                onCheck: updateDownloadType('condensed')
              }),
              _react2.default.createElement(
                'small',
                { style: { fontSize: '10px' } },
                '- Only contains rate related information'
              )
            ),
            _react2.default.createElement(
              'div',
              {
                style: {
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                  width: '200px'
                }
              },
              _react2.default.createElement(_materialUi.RadioButton, {
                label: 'Quickview Excel',
                checked: sharedProps.downloadType === 'quickview_desummarized',
                style: { margin: '16px auto 8px' },
                labelStyle: { fontSize: '12px', color: 'rgba(0, 0, 0, 0.87)' },
                onCheck: updateDownloadType('quickview_desummarized')
              }),
              _react2.default.createElement(
                'small',
                { style: { fontSize: '10px' } },
                '- All products/seasons/rates appear in a separate row'
              )
            ),
            _react2.default.createElement(
              'div',
              {
                style: {
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                  width: '223px'
                }
              },
              _react2.default.createElement(_materialUi.RadioButton, {
                label: 'Quickview w/ Summary Excel',
                checked: summarizedChecked,
                style: { margin: '16px auto 8px' },
                labelStyle: { fontSize: '12px', color: 'rgba(0, 0, 0, 0.87)' },
                onCheck: updateDownloadType('quickview_summarized')
              }),
              multi && _react2.default.createElement(_materialUi.Checkbox, {
                style: { margin: '0 auto 8px' },
                label: 'Merge into a single sheet',
                labelStyle: { fontSize: '12px', color: 'rgba(0, 0, 0, 0.87)' },
                onCheck: function onCheck(_event, isChecked) {
                  if (isChecked) {
                    updateDownloadType('quickview_summarized_singlefile')();
                  } else {
                    updateDownloadType('quickview_summarized')();
                  }
                },

                checked: sharedProps.downloadType === 'quickview_summarized_singlefile'
              }),
              _react2.default.createElement(
                'small',
                { style: { fontSize: '10px' } },
                '- All products/seasons/rates are merged where possible'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          {
            style: {
              display: this.state.showBigPreview ? 'block' : 'none',
              height: '100%',
              width: '100%',
              position: 'fixed',
              zIndex: 1501,
              top: 0,
              left: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              overflow: 'hidden',
              transition: '0.5s',
              textAlign: 'center',
              paddingTop: '32px'
            }
          },
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'right' } },
            _react2.default.createElement(_materialUi.FontIcon, {
              className: 'tc-icon-close22',
              style: { color: 'white', marginRight: '48px', cursor: 'pointer', fontSize: '50px' },
              onClick: closeBigPreview
            })
          ),
          _react2.default.createElement(
            'div',
            { style: { overflow: 'scroll', width: '80%', margin: 'auto', height: '80%' } },
            _react2.default.createElement('img', { src: this.state.showBigPreview })
          )
        )
      );
    }
  }]);

  return RateFormatSelection;
}(_react.Component);

exports.default = RateFormatSelection;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(565),
    isArguments = __webpack_require__(1872),
    isArray = __webpack_require__(977);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keys;


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _jquery = __webpack_require__(251);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Carousel = (0, _react.createClass)({

  propTypes: {
    photos: _react.PropTypes.array
  },

  getInitialState: function getInitialState() {
    return {
      index: 0
    };
  },
  componentDidMount: function componentDidMount() {
    var resizeCss = function resizeCss(wrapper) {
      var wRatio = 744 / this.naturalWidth;
      var hRatio = 320 / this.naturalHeight;
      var ratio = Math.min(wRatio, hRatio);

      if (this.naturalWidth > this.naturalHeight) {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto'
        });
      } else {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto'
        });
      }
    };
    (0, _jquery2.default)('.carouselImage').each(function (index, image) {
      var $image = (0, _jquery2.default)(image);
      $image.load(function () {
        resizeCss.call(this, $image);
      });
    });
  },
  componentWillUpdate: function componentWillUpdate() {
    var resizeCss = function resizeCss(wrapper) {
      var wRatio = 744 / this.naturalWidth;
      var hRatio = 320 / this.naturalHeight;
      var ratio = Math.min(wRatio, hRatio);

      if (this.naturalWidth > this.naturalHeight) {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto'
        });
      } else {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto'
        });
      }
    };
    (0, _jquery2.default)('.carouselImage').each(function (index, image) {
      var $image = (0, _jquery2.default)(image);
      $image.load(function () {
        resizeCss.call(this, $image);
      });
    });
  },
  setIndex: function setIndex(index) {
    this.setState({ index: index });
  },
  moveRight: function moveRight() {
    if (this.state.index === this.props.photos.length - 1) {
      this.setState({
        index: 0
      });
    } else {
      this.setState({
        index: this.state.index + 1
      });
    }
  },
  moveLeft: function moveLeft() {
    if (this.state.index === 0) {
      this.setState({
        index: this.props.photos.length - 1
      });
    } else {
      this.setState({
        index: this.state.index - 1
      });
    }
  },
  render: function render() {
    var photos = (this.props.photos || []).map(function (photo, index) {
      return _react2.default.createElement(
        'li',
        { key: index },
        _react2.default.createElement(
          'div',
          { className: 'carouselBackground' },
          _react2.default.createElement('img', { className: 'carouselImage', src: photo, key: index })
        )
      );
    });

    var ulStyle = {
      width: photos.length * 125 + '%',
      left: 744 * -this.state.index + 'px'
    };

    return _react2.default.createElement(
      'div',
      { className: 'carousel' },
      _react2.default.createElement(
        'div',
        { className: 'carousel-info-left', onClick: this.moveLeft },
        _react2.default.createElement(_icon2.default, { className: 'tc-icon-chevron-left' })
      ),
      _react2.default.createElement(
        'div',
        { className: 'carousel-inner' },
        _react2.default.createElement(
          'ul',
          { style: ulStyle },
          photos
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'carousel-info-right', onClick: this.moveRight },
        _react2.default.createElement(_icon2.default, { className: 'tc-icon-chevron-right' })
      )
    );
  }
});

exports.default = Carousel;

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _s3Upload = __webpack_require__(564);

var _s3Upload2 = _interopRequireDefault(_s3Upload);

var _reactDom = __webpack_require__(47);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _imageCrop = __webpack_require__(2829);

var _imageCrop2 = _interopRequireDefault(_imageCrop);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageCropDialog = function (_Component) {
  _inherits(ImageCropDialog, _Component);

  function ImageCropDialog(props) {
    _classCallCheck(this, ImageCropDialog);

    var _this2 = _possibleConstructorReturn(this, (ImageCropDialog.__proto__ || Object.getPrototypeOf(ImageCropDialog)).call(this, props));

    _this2.handleFileChange = function (dataURI) {
      _this2.setState({
        img: dataURI,
        croppedImg: _this2.state.croppedImg,
        cropperOpen: true
      });
    };

    _this2.handleCrop = function (dataURI) {
      _this2.setState({
        cropperOpen: false,
        img: null,
        croppedImg: dataURI
      });
      if (typeof _this2.props.uploadStartFn === 'function') _this2.props.uploadStartFn();
      // upload to s3
      var file = _s3Upload2.default.dataURItoBlob(dataURI);
      var _this = _this2;
      _s3Upload2.default.s3upload({
        file_to_upload: file,
        file_name: _this2.props.imageName,
        onProgress: function onProgress(percent) {
          if (percent === 100) return;
        },
        onFinishS3Put: function onFinishS3Put(publicUrl) {
          _this.props.confirmCroppedFn(publicUrl);
        },
        onError: function onError(status) {
          console.log(status);
        }
      });
    };

    _this2.handleRequestHide = function () {
      _this2.setState({
        cropperOpen: false
      });
    };

    _this2.handleFile = function (e) {
      var reader = new FileReader();
      var file = e.target.files[0];
      if (!file) return;
      reader.onload = function (img) {
        _reactDom2.default.findDOMNode(this.refs.in).value = '';
        this.handleFileChange(img.target.result);
      }.bind(_this2);
      reader.readAsDataURL(file);
    };

    _this2.state = {
      cropperOpen: false,
      img: '',
      croppedImg: ''
    };
    return _this2;
  }

  _createClass(ImageCropDialog, [{
    key: 'render',
    value: function render() {
      var setDialogWidth = _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('1200px'), _ramda2.default.always('90%')], // supplier cover photo
      [_ramda2.default.equals('800px'), _ramda2.default.always('75%')], // contractor cover photo
      [_ramda2.default.equals('400px'), _ramda2.default.always('35%')], // circular logo
      [_ramda2.default.T, _ramda2.default.always(this.props.dialogWidth)]]), this.props.dialogWidth);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('input', { ref: 'in', style: {
            position: 'absolute',
            top: '0',
            cursor: 'pointer',
            bottom: '0',
            right: '0',
            opacity: '0',
            zIndex: this.props.style ? this.props.style.zIndex : '1'
          }, type: 'file', accept: 'image/*', onChange: this.handleFile
        }),
        this.props.children,
        this.state.cropperOpen ? _react2.default.createElement(
          _materialUi.Dialog,
          {
            modal: true,
            open: this.state.cropperOpen,
            onRequestClose: this.handleRequestHide,
            contentStyle: { width: '100%', maxWidth: setDialogWidth },
            autoScrollBodyContent: true
          },
          _react2.default.createElement(_imageCrop2.default, {
            onRequestHide: this.handleRequestHide,
            onCrop: this.handleCrop,
            image: this.state.img,
            width: this.props.cropWidth,
            height: this.props.cropHeight,
            round: this.props.round
          })
        ) : _react2.default.createElement('span', null)
      );
    }
  }]);

  return ImageCropDialog;
}(_react.Component);

ImageCropDialog.propTypes = {
  imageName: _react.PropTypes.string.isRequired,
  cropWidth: _react.PropTypes.number,
  cropHeight: _react.PropTypes.number,
  dialogWidth: _react.PropTypes.string,
  children: _react.PropTypes.any,
  confirmCroppedFn: _react.PropTypes.func.isRequired,
  uploadStartFn: _react.PropTypes.func,
  style: _react.PropTypes.object,
  round: _react.PropTypes.bool
};

exports.default = ImageCropDialog;

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TourplanLogIn = function (_Component) {
  _inherits(TourplanLogIn, _Component);

  function TourplanLogIn(props) {
    _classCallCheck(this, TourplanLogIn);

    var _this = _possibleConstructorReturn(this, (TourplanLogIn.__proto__ || Object.getPrototypeOf(TourplanLogIn)).call(this, props));

    _this.setuserNameValue = function (_ref) {
      var value = _ref.target.value;

      _this.setState({ userName: value });
    };

    _this.setPasswordValue = function (_ref2) {
      var value = _ref2.target.value;

      _this.setState({ password: value });
    };

    _this.setUrlValue = function (_ref3) {
      var value = _ref3.target.value;

      _this.setState({ url: value });
    };

    _this.state = {
      userName: '',
      password: '',
      url: '',
      spinner: 'hide'
    };
    _this.populateState(props);
    return _this;
  }

  _createClass(TourplanLogIn, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          integration = _props.integration,
          getAuth = _props.getAuth;

      if (!integration.auth) getAuth();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (_ramda2.default.equals(this.props.integration, nextProps.integration)) return;
      this.populateState(nextProps);
    }
  }, {
    key: 'populateState',
    value: function populateState(props) {
      if (props.integration.auth && !_ramda2.default.isEmpty(props.integration.auth) && !(this.state.userName || this.state.password || this.state.url)) {
        // only popluate state url password and username if they are not already set
        var _props$integration$au = props.integration.auth,
            user_name = _props$integration$au.user_name,
            password = _props$integration$au.password,
            url = _props$integration$au.url;

        this.state = {
          userName: user_name,
          password: password,
          url: url,
          spinner: 'hide'
        };
      }
      if (props.integration.loginResponse) {
        if (props.integration.loginResponse === 'success') document.location.reload(true);else if (props.integration.loginResponse === 'starting') {
          this.setState({ spinner: 'loading' });
        } else {
          this.setState({
            spinner: 'ready',
            error: 'Invalid Username or Password'
          });
        }
      }
    }
  }, {
    key: '_login',
    value: function _login() {
      var _state = this.state,
          userName = _state.userName,
          password = _state.password,
          url = _state.url;

      this.props.login(userName, password, url);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.props.integration.auth) return false;

      var _ref4 = function () {
        if (_this2.props.type === 'login') {
          return {
            titleText: 'Setup your Tourplan integration by entering your credentials',
            subTitleText: 'This will allow us to export your TourConnect Contracts directly into your Tourplan account',
            buttonText: 'Save'
          };
        } else if (_this2.props.type === 'update') {
          return {
            titleText: 'Update Your Tourplan Credentials',
            subTitleText: 'This will allow us to export your TourConnect Contracts directly into your Tourplan account',
            buttonText: 'Update'
          };
        } else if (_this2.props.type === 'validate') {
          return {
            titleText: 'Update Your Tourplan Credentials',
            subTitleText: 'The Tourplan username and password you submitted were out of date, please provide correct credentials and try again',
            buttonText: 'Save'
          };
        }
      }(),
          titleText = _ref4.titleText,
          subTitleText = _ref4.subTitleText,
          buttonText = _ref4.buttonText;

      return _react2.default.createElement(
        'div',
        {
          style: {
            margin: 'auto',
            width: '80%',
            textAlign: 'center'
          }
        },
        _react2.default.createElement(
          'div',
          { style: { fontSize: '17px', marginBottom: '15px' } },
          titleText
        ),
        _react2.default.createElement(
          'div',
          { style: { fontSize: '12px' } },
          subTitleText
        ),
        _react2.default.createElement(_materialUi.TextField, {
          style: { left: '25px' },
          type: 'text',
          hintText: 'Enter Your Tourplan Url',
          value: this.state.url || '',
          floatingLabelText: 'Tourplan Url',
          onChange: this.setUrlValue
        }),
        _react2.default.createElement(
          _materialUi.IconButton,
          { tooltip: 'Please contact Tourplan to get your Url', style: { left: '22px' } },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-info', color: '#00bcd4' })
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_materialUi.TextField, {
          ref: 'userName',
          type: 'text',
          hintText: 'Enter Your Tourplan Username',
          value: this.state.userName || '',
          errorText: this.state.error,
          floatingLabelText: 'Tourplan Username',
          onChange: this.setuserNameValue
        }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_materialUi.TextField, {
          ref: 'password',
          type: 'password',
          hintText: 'Enter Your Tourplan Password',
          value: this.state.password || '',
          errorText: this.state.error,
          floatingLabelText: 'Tourplan Password',
          onChange: this.setPasswordValue
        }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          { style: { position: 'relative' } },
          _react2.default.createElement(_materialUi.RefreshIndicator, { status: this.state.spinner, percentage: 60, left: 190, top: 22 }),
          _react2.default.createElement(_materialUi.RaisedButton, {
            style: { margin: '25px auto 15px' },
            label: buttonText,
            onTouchTap: this._login.bind(this),
            secondary: true
          })
        )
      );
    }
  }]);

  return TourplanLogIn;
}(_react.Component);

TourplanLogIn.propTypes = {
  login: _react.PropTypes.func,
  integration: _react.PropTypes.object,
  type: _react.PropTypes.string
};

exports.default = TourplanLogIn;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// rawAsap provides everything we need except exception management.
var rawAsap = __webpack_require__(1485);
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2854)();
}


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.beginDrag = beginDrag;
exports.publishDragSource = publishDragSource;
exports.hover = hover;
exports.drop = drop;
exports.endDrag = endDrag;

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(255);

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = __webpack_require__(735);

var _isObject2 = _interopRequireDefault(_isObject);

var _matchesType = __webpack_require__(1885);

var _matchesType2 = _interopRequireDefault(_matchesType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
var HOVER = exports.HOVER = 'dnd-core/HOVER';
var DROP = exports.DROP = 'dnd-core/DROP';
var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';

function beginDrag(sourceIds) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { publishSource: true, clientOffset: null };
	var publishSource = options.publishSource,
	    clientOffset = options.clientOffset,
	    getSourceClientOffset = options.getSourceClientOffset;

	(0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');

	for (var i = 0; i < sourceIds.length; i++) {
		(0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
	}

	var sourceId = null;
	for (var _i = sourceIds.length - 1; _i >= 0; _i--) {
		if (monitor.canDragSource(sourceIds[_i])) {
			sourceId = sourceIds[_i];
			break;
		}
	}
	if (sourceId === null) {
		return;
	}

	var sourceClientOffset = null;
	if (clientOffset) {
		(0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
		sourceClientOffset = getSourceClientOffset(sourceId);
	}

	var source = registry.getSource(sourceId);
	var item = source.beginDrag(monitor, sourceId);
	(0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');

	registry.pinSource(sourceId);

	var itemType = registry.getSourceType(sourceId);
	return {
		type: BEGIN_DRAG,
		itemType: itemType,
		item: item,
		sourceId: sourceId,
		clientOffset: clientOffset,
		sourceClientOffset: sourceClientOffset,
		isSourcePublic: publishSource
	};
}

function publishDragSource() {
	var monitor = this.getMonitor();
	if (!monitor.isDragging()) {
		return;
	}

	return { type: PUBLISH_DRAG_SOURCE };
}

function hover(targetIdsArg) {
	var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	    _ref$clientOffset = _ref.clientOffset,
	    clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;

	(0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
	var targetIds = targetIdsArg.slice(0);

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
	(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');

	// First check invariants.
	for (var i = 0; i < targetIds.length; i++) {
		var targetId = targetIds[i];
		(0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');

		var target = registry.getTarget(targetId);
		(0, _invariant2.default)(target, 'Expected targetIds to be registered.');
	}

	var draggedItemType = monitor.getItemType();

	// Remove those targetIds that don't match the targetType.  This
	// fixes shallow isOver which would only be non-shallow because of
	// non-matching targets.
	for (var _i2 = targetIds.length - 1; _i2 >= 0; _i2--) {
		var _targetId = targetIds[_i2];
		var targetType = registry.getTargetType(_targetId);
		if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
			targetIds.splice(_i2, 1);
		}
	}

	// Finally call hover on all matching targets.
	for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
		var _targetId2 = targetIds[_i3];
		var _target = registry.getTarget(_targetId2);
		_target.hover(monitor, _targetId2);
	}

	return {
		type: HOVER,
		targetIds: targetIds,
		clientOffset: clientOffset
	};
}

function drop() {
	var _this = this;

	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
	(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');

	var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);

	targetIds.reverse();
	targetIds.forEach(function (targetId, index) {
		var target = registry.getTarget(targetId);

		var dropResult = target.drop(monitor, targetId);
		(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
		if (typeof dropResult === 'undefined') {
			dropResult = index === 0 ? {} : monitor.getDropResult();
		}

		_this.store.dispatch({
			type: DROP,
			dropResult: _extends({}, options, dropResult)
		});
	});
}

function endDrag() {
	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');

	var sourceId = monitor.getSourceId();
	var source = registry.getSource(sourceId, true);
	source.endDrag(monitor, sourceId);

	registry.unpinSource();

	return { type: END_DRAG };
}

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(1500),
    setCacheAdd = __webpack_require__(2885),
    setCacheHas = __webpack_require__(2886);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(1000);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(2875),
    listCacheDelete = __webpack_require__(2876),
    listCacheGet = __webpack_require__(2877),
    listCacheHas = __webpack_require__(2878),
    listCacheSet = __webpack_require__(2879);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(1133);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(2881);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(2887);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1238 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1239 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(1053),
    isObjectLike = __webpack_require__(874);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.addSource = addSource;
exports.addTarget = addTarget;
exports.removeSource = removeSource;
exports.removeTarget = removeTarget;
var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';

function addSource(sourceId) {
	return {
		type: ADD_SOURCE,
		sourceId: sourceId
	};
}

function addTarget(targetId) {
	return {
		type: ADD_TARGET,
		targetId: targetId
	};
}

function removeSource(sourceId) {
	return {
		type: REMOVE_SOURCE,
		sourceId: sourceId
	};
}

function removeTarget(targetId) {
	return {
		type: REMOVE_TARGET,
		targetId: targetId
	};
}

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = checkDecoratorArguments;
function checkDecoratorArguments(functionName, signature) {
  if (false) {
    for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i += 1) {
      var arg = arguments.length <= i + 2 ? undefined : arguments[i + 2];
      if (arg && arg.prototype && arg.prototype.render) {
        console.error( // eslint-disable-line no-console
        'You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
        return;
      }
    }
  }
}

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddItemCard = function AddItemCard(_ref) {
  var onClick = _ref.onClick,
      text = _ref.text,
      color = _ref.color;

  return _react2.default.createElement(
    'div',
    {
      className: 'add-item-card-flex',
      onClick: onClick
    },
    _react2.default.createElement(
      'div',
      { style: { border: '1px dashed ' + color, height: '32px', width: '32px', display: 'inline-block' } },
      _react2.default.createElement(_materialUi.FontIcon, { style: { verticalAlign: 'middle', color: color, fontSize: '26px', marginTop: '2px', marginLeft: '2px' }, className: 'tc-icon-add' })
    ),
    _react2.default.createElement(
      'span',
      { style: { margin: '0px 0px 0px 24px', color: color, display: 'inline-block', verticalAlign: 'middle' } },
      text
    )
  );
};

AddItemCard.propTypes = {
  onClick: _react.PropTypes.func,
  text: _react.PropTypes.string,
  color: _react.PropTypes.string
};

exports.default = AddItemCard;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowForward = function NavigationArrowForward(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z' })
  );
};
NavigationArrowForward = (0, _pure2.default)(NavigationArrowForward);
NavigationArrowForward.displayName = 'NavigationArrowForward';
NavigationArrowForward.muiName = 'SvgIcon';

exports.default = NavigationArrowForward;

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateProps = updateProps;
exports.deleteOrganizationInProfile = deleteOrganizationInProfile;
exports.getBadges = getBadges;
exports.updateProfileBadges = updateProfileBadges;

var _constants = __webpack_require__(1843);

var constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function updateProps(payload) {
  return { type: constants.UPDATE_PROPS, payload: payload };
}

function deleteOrganizationInProfile(payload) {
  return { type: constants.DELETE_ORGANIZATION_IN_PROFILE, payload: payload };
}

var badgeQuery = 'query {\n  badges {\n    name\n    logo\n    website\n    acronym\n    badgeId\n  }\n}';

function getBadges() {
  return function (dispatch) {
    dispatch({ type: constants.GETTING_BADGES_STARTED });
    return fetch('/proxy/badges?query=' + badgeQuery, {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: constants.GOT_BADGES, payload: response });
    }).catch(function (err) {
      return console.log('err in getting badges', err);
    });
  };
}

function updateProfileBadges(companyId, memberships) {
  return function (dispatch) {
    dispatch({ type: constants.EDIT_PROFILE_BADGE_STARTING });
    return fetch('/proxy/profile/companyBadges/' + companyId, {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(memberships)
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: constants.EDIT_PROFILE_BADGE_FINISHED, payload: response });
    }).catch(function (err) {
      return console.log('err in editing profile badge', err);
    });
  };
}

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1520),
    isObject = __webpack_require__(735);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 1249 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(1051),
    isObjectLike = __webpack_require__(874);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1904),
    baseKeys = __webpack_require__(3043),
    isArrayLike = __webpack_require__(1053);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(1250);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddItemCard = function (_Component) {
  _inherits(AddItemCard, _Component);

  function AddItemCard() {
    _classCallCheck(this, AddItemCard);

    return _possibleConstructorReturn(this, (AddItemCard.__proto__ || Object.getPrototypeOf(AddItemCard)).apply(this, arguments));
  }

  _createClass(AddItemCard, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          onClick: this.props.onClick,
          className: 'add-item-card',
          id: this.props.id
        },
        _react2.default.createElement(_icon2.default, { style: {
            verticalAlign: 'middle',
            textAlign: 'center',
            fontSize: '49px' }, className: 'tc-icon-add'
        }),
        _react2.default.createElement(
          'span',
          { style: { verticalAlign: 'middle', lineHeight: '24px', fontSize: '42px' } },
          this.props.text
        )
      );
    }
  }]);

  return AddItemCard;
}(_react.Component);

AddItemCard.propTypes = {
  onClick: _react.PropTypes.func,
  text: _react.PropTypes.string,
  id: _react.PropTypes.string
};

exports.default = AddItemCard;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentLink = function ContentLink(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
  );
};
ContentLink = (0, _pure2.default)(ContentLink);
ContentLink.displayName = 'ContentLink';
ContentLink.muiName = 'SvgIcon';

exports.default = ContentLink;

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = exports.Outline = exports.Document = undefined;

var _Document = __webpack_require__(1364);

var _Document2 = _interopRequireDefault(_Document);

var _Outline = __webpack_require__(1370);

var _Outline2 = _interopRequireDefault(_Outline);

var _Page = __webpack_require__(1371);

var _Page2 = _interopRequireDefault(_Page);

var _util = __webpack_require__(857);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (_util.isLocalFileSystem) {
  // eslint-disable-next-line no-console
  (0, _util.warnOnDev)('You are running React-PDF from your local file system. PDF.js Worker may fail to load due to browser\'s security policies. If you\'re on Google Chrome, you can use --allow-file-access-from-files flag for debugging purposes.');
}

__webpack_require__(1530);
__webpack_require__(1377);

exports.Document = _Document2.default;
exports.Outline = _Outline2.default;
exports.Page = _Page2.default;

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionCreatorFactoryWithOpts = exports.actionCreatorFactory = undefined;

var _ramda = __webpack_require__(2);

var actionCreatorFactory = exports.actionCreatorFactory = (0, _ramda.curry)(function (type, payload) {
  return { type: type, payload: payload };
});
var actionCreatorFactoryWithOpts = exports.actionCreatorFactoryWithOpts = (0, _ramda.curry)(function (type, payload, opts) {
  return { type: type, payload: payload, opts: opts };
});

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RateType = function RateType(_ref) {
  var rateType = _ref.rateType,
      commissionPercentage = _ref.commissionPercentage,
      nettCommission = _ref.nettCommission,
      updateRateType = _ref.updateRateType,
      updateCommission = _ref.updateCommission,
      updateNettCommission = _ref.updateNettCommission;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _materialUi.RadioButtonGroup,
      {
        style: { display: 'inline-block', width: '65%' },
        name: 'rateType',
        valueSelected: rateType,
        onChange: function onChange(_, value) {
          return updateRateType(value);
        }
      },
      _react2.default.createElement(_materialUi.RadioButton, {
        value: 'nett',
        label: 'Nett',
        labelStyle: { color: 'rgba(0, 0, 0, 0.54)' },
        style: { display: 'inline-block', width: '50%' }
      }),
      _react2.default.createElement(_materialUi.RadioButton, {
        value: 'includeCommission',
        'data-cy': 'includeCommission',
        label: 'Commission' + (rateType === 'includeCommission' ? ':' : ''),
        labelStyle: { color: 'rgba(0, 0, 0, 0.54)' },
        style: { display: 'inline-block', width: '50%' }
      })
    ),
    rateType === 'nett' || rateType === 'includeCommission' ? _react2.default.createElement(
      'div',
      { style: { width: '80%', display: 'flex', height: '48px', alignItems: 'center' } },
      'Based on \xA0',
      _react2.default.createElement(_typeControlledTextfield2.default, {
        style: { display: 'inline-block', width: '67px' },
        hintStyle: { fontSize: '12px' },
        inputStyle: { fontSize: '14px' },
        errorStyle: { fontSize: '10px' },
        hintText: 'Percentage',
        'data-cy': 'percentage',
        controlledType: 'number',
        value: rateType === 'includeCommission' ? commissionPercentage : nettCommission,
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;

          if (rateType === 'includeCommission') updateCommission(value);else updateNettCommission(value);
        }
      }),
      '% commission'
    ) : undefined
  );
};

exports.default = RateType;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _flatDropDownMenu = __webpack_require__(494);

var _flatDropDownMenu2 = _interopRequireDefault(_flatDropDownMenu);

var _arrowDropDown = __webpack_require__(559);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _smallButtons = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpdateContractAssignee = function (_Component) {
  _inherits(UpdateContractAssignee, _Component);

  function UpdateContractAssignee() {
    _classCallCheck(this, UpdateContractAssignee);

    var _this = _possibleConstructorReturn(this, (UpdateContractAssignee.__proto__ || Object.getPrototypeOf(UpdateContractAssignee)).call(this));

    _this.updateContractAssignee = function (user) {
      return function () {
        var _this$props = _this.props,
            contractId = _this$props.contractId,
            updateContractAssignee = _this$props.updateContractAssignee;

        updateContractAssignee({
          contractId: contractId,
          updater: {
            assignee: user ? {
              userId: user.userId,
              name: user.name,
              email: user.email
            } : null
          }
        });
      };
    };

    return _this;
  }

  _createClass(UpdateContractAssignee, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          Button = _props.Button,
          usersArray = _props.usersArray;

      var assignee = this.props.assignee || {};
      var assigneeLabel = function () {
        if (assignee && assignee.userId) {
          // if (assignee.userId === 'dl@tourconnect.com') return assignee.userId;
          var match = usersArray.find(function (user) {
            return user.userId === assignee.userId;
          });
          if (match) return match.name || match.email;
        }
        return 'Unassigned';
      }();
      return _react2.default.createElement(
        _flatDropDownMenu2.default,
        {
          button: Button ? _react2.default.createElement(Button, { assigneeLabel: assigneeLabel }) : _react2.default.createElement(_smallButtons.JiraFlatButton, {
            labelStyle: { fontSize: '10px' },
            icon: _react2.default.createElement(_arrowDropDown2.default, { style: { fill: 'rgba(0, 0, 0, 0.54)', margin: 0 } }),
            labelPosition: 'before',
            label: assigneeLabel
          })
        },
        _react2.default.createElement(_materialUi.MenuItem, {
          primaryText: 'Unassigned',
          disabled: !assignee,
          onClick: this.updateContractAssignee(null)
        }),
        usersArray.map(function (user) {
          return _react2.default.createElement(_materialUi.MenuItem, {
            key: user.userId,
            primaryText: user.name || user.email,
            disabled: user.userId === assignee.userId,
            onClick: _this2.updateContractAssignee(user)
          });
        })
      );
    }
  }]);

  return UpdateContractAssignee;
}(_react.Component);

UpdateContractAssignee.propTypes = {
  updateContractAssignee: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  assignee: _react.PropTypes.object,
  Button: _react.PropTypes.any,
  usersArray: _react.PropTypes.array,
  isContainer: _react.PropTypes.bool,
  requestDataLoading: _react.PropTypes.func,
  files: _react.PropTypes.array
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    usersArray: state.settings.get('allActiveUsers').toJS ? state.settings.get('allActiveUsers').toJS() : state.settings.get('allActiveUsers')
  };
}, {
  updateContractAssignee: function updateContractAssignee(payload) {
    return { type: '[contract] UPDATE_CONTRACT_ASSIGNEE', payload: payload };
  },
  requestDataLoading: function requestDataLoading(payload) {
    return { type: 'OPEN_REQUEST_DL', payload: payload };
  }
})(UpdateContractAssignee);

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentAddCircleOutline = function ContentAddCircleOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
ContentAddCircleOutline = (0, _pure2.default)(ContentAddCircleOutline);
ContentAddCircleOutline.displayName = 'ContentAddCircleOutline';
ContentAddCircleOutline.muiName = 'SvgIcon';

exports.default = ContentAddCircleOutline;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _dialogConstants = __webpack_require__(616);

var _contractActivitiesProductsActions = __webpack_require__(493);

var _actions = __webpack_require__(737);

var _rootActionsMap = __webpack_require__(1135);

var _rootActionsMap2 = _interopRequireDefault(_rootActionsMap);

var _userInputActions = __webpack_require__(1002);

var _saveAsTemplate = __webpack_require__(1989);

var _saveAsTemplate2 = _interopRequireDefault(_saveAsTemplate);

var _downloadPDFAsDraft = __webpack_require__(3348);

var _downloadPDFAsDraft2 = _interopRequireDefault(_downloadPDFAsDraft);

var _draftComplete = __webpack_require__(3349);

var _draftComplete2 = _interopRequireDefault(_draftComplete);

var _sendUpdates = __webpack_require__(3350);

var _sendUpdates2 = _interopRequireDefault(_sendUpdates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PublishDraftDialog = function PublishDraftDialog(props) {
  var publishDraftDialog = props.publishDraftDialog,
      onRequestClose = props.onRequestClose,
      contractId = props.contractId,
      saveAsANewTemplateWithDispatch = props.saveAsANewTemplateWithDispatch,
      makeACopyForBuyer = props.makeACopyForBuyer,
      _downloadContractPdf = props.downloadContractPdf,
      forBuyer = props.forBuyer,
      extraProps = _objectWithoutProperties(props, ['publishDraftDialog', 'onRequestClose', 'contractId', 'saveAsANewTemplateWithDispatch', 'makeACopyForBuyer', 'downloadContractPdf', 'forBuyer']);

  var open = publishDraftDialog.open,
      title = publishDraftDialog.title,
      newDraftStartDate = publishDraftDialog.newDraftStartDate,
      newDraftEndDate = publishDraftDialog.newDraftEndDate;

  var ContentNode = function () {
    switch (title) {
      case 'Save Template':
        return _saveAsTemplate2.default;
      case 'Finalise Template':
        return _draftComplete2.default;
      case 'Send Updates':
        return _sendUpdates2.default;
      case 'Download PDF':
      default:
        return _downloadPDFAsDraft2.default;
    }
  }();
  var activeDraft = Boolean(extraProps.sentPartners && extraProps.sentPartners.length);
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      autoScrollBodyContent: true,
      modal: true,
      bodyStyle: { padding: '0', paddingBottom: '12px' },
      contentStyle: { maxWidth: '880px', width: '700px' },
      open: open,
      onRequestClose: onRequestClose,
      title: _react2.default.createElement(
        'div',
        { className: 'flex-tc-sb', style: { backgroundColor: '#00BCD4', color: 'white', fontSize: '18px', padding: '2%' } },
        function () {
          if (title === 'Finalise Template' && !publishDraftDialog.draftApproved && !activeDraft) {
            return 'Want an expert to review your rates?';
          }
          if (title === 'Save Template') {
            if (forBuyer) return 'Make a copy of this rate sheet';
            return 'Make a copy of this template';
          }
          return title;
        }(),
        _react2.default.createElement(_materialUi.IconButton, {
          iconClassName: 'tc-icon-close',
          style: { padding: '4px', width: '30px', height: '30px' },
          iconStyle: { color: 'white', fontSize: '20px' },
          onTouchTap: onRequestClose
        })
      )
    },
    _react2.default.createElement(ContentNode, _extends({}, extraProps, {
      forBuyer: forBuyer,
      onRequestClose: onRequestClose,
      downloadContractPdf: function downloadContractPdf(anchorEl) {
        _downloadContractPdf(contractId, 'publish-ready', anchorEl);
      },
      saveAsANewTemplate: function saveAsANewTemplate() {
        if (forBuyer) {
          makeACopyForBuyer({
            contractId: contractId,
            startDate: newDraftStartDate,
            endDate: newDraftEndDate,
            templateId: publishDraftDialog.templateId,
            isDummyTemplate: publishDraftDialog.isDummyTemplate
          });
        } else {
          saveAsANewTemplateWithDispatch({
            contractId: contractId,
            templateName: publishDraftDialog.templateName || extraProps.currentTemplateName,
            startDate: newDraftStartDate,
            endDate: newDraftEndDate,
            shouldClearDates: publishDraftDialog.shouldClearDates
          });
        }
      },
      contractId: contractId
    }, publishDraftDialog))
  );
};

PublishDraftDialog.propTypes = {
  publishDraftDialog: _react.PropTypes.object,
  onRequestClose: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  draftErrors: _react.PropTypes.object,
  downloadContractPdf: _react.PropTypes.func,
  saveAsANewTemplateWithDispatch: _react.PropTypes.func,
  sendReviewRatesEmail: _react.PropTypes.func,
  forBuyer: _react.PropTypes.bool,
  makeACopyForBuyer: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var contracting = _ref.contracting,
      config = _ref.config,
      user = _ref.user;
  var reducerName = _ref2.reducerName;
  return {
    draftErrors: reducerName ? contracting[reducerName].get('draftErrors').toJS() : {},
    publishDraftDialog: contracting.publishDraftDialog.toJS(),
    leftNav: reducerName ? contracting[reducerName].get('leftNav').toJS() : {},
    apiUrl: config.get('apiUrl'),
    contractId: reducerName ? contracting[reducerName].getIn(['leftNav', 'contractId']) : contracting.publishDraftDialog.get('contractId'),
    productType: reducerName ? contracting[reducerName].getIn(['rightSideContent', 'productType']) : '',
    locationId: reducerName ? contracting[reducerName].getIn(['leftNav', 'locationId']) : '',
    freeContractsLeft: user.get('freeContractsLeft'),
    billingPlan: user.get('billingPlan')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onRequestClose: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default, 'closePublishDraftDialog'),
    onFieldChange: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default, 'onTextFieldChangePublishDraftDialog'),
    onBCCSelfCheck: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default, 'onBCCSelfCheck'),
    includeNotesCheck: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default, 'includeNotesCheck'),
    includeMultiLocNotesCheck: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default, 'includeMultiLocNotesCheck'),
    includeGeneralNoteCheck: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default, 'includeGeneralNoteCheck'),
    notEnoughFreeContractsError: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default, 'notEnoughFreeContracts'),
    goToSendUpdates: function goToSendUpdates() {
      return dispatch({ type: 'SEND_UPDATES_IN_PUBLISH_DRAFT_DIALOG' });
    },
    updateProps: function updateProps(payload) {
      return dispatch({ type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG', payload: payload });
    },
    makeACopyForBuyer: function makeACopyForBuyer(payload) {
      return dispatch({ type: '{dummy_account} makeACopyForBuyer', payload: payload });
    },
    saveAsANewTemplateWithDispatch: function saveAsANewTemplateWithDispatch(payload) {
      return dispatch((0, _dialogConstants.saveAsANewTemplate)(payload));
    },
    publishDraft: function publishDraft() {
      return dispatch(_dialogConstants.publishDraft.apply(undefined, arguments));
    },
    downloadContractPdf: function downloadContractPdf() {
      return dispatch(_contractActivitiesProductsActions.downloadContractPdf.apply(undefined, arguments));
    },
    sendReviewRatesEmail: function sendReviewRatesEmail() {
      return dispatch(_actions.sendReviewRatesEmail.apply(undefined, arguments));
    },
    push: function push() {
      return dispatch(_reactRouterRedux.push.apply(undefined, arguments));
    }
  };
};
PublishDraftDialog.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PublishDraftDialog);

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _contractingUtils = __webpack_require__(124);

var _sectionUpdateSummary = __webpack_require__(1262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditHistories = function EditHistories(_ref) {
  var editHistory = _ref.editHistory,
      productsArray = _ref.productsArray,
      diffSummary = _ref.diffSummary;

  if (diffSummary) {
    return _react2.default.createElement(
      'div',
      null,
      (diffSummary.summaryByPage || []).length ? diffSummary.summaryByPage.map(function (_ref2, index) {
        var header = _ref2.header,
            pageSections = _ref2.pageSections;

        return _react2.default.createElement(
          'div',
          { key: header, style: { marginTop: index ? '8px' : '0' } },
          _react2.default.createElement(
            'div',
            { style: { fontSize: '16px', fontWeight: 'bold' } },
            header
          ),
          _react2.default.createElement(
            'div',
            null,
            pageSections.map(function (_ref3) {
              var label = _ref3.label,
                  _ref3$updateSummary = _ref3.updateSummary,
                  updateSummary = _ref3$updateSummary === undefined ? [] : _ref3$updateSummary;

              return _react2.default.createElement(
                'div',
                {
                  key: label
                },
                _react2.default.createElement(
                  'span',
                  null,
                  label,
                  Boolean(updateSummary.length) && _react2.default.createElement(_sectionUpdateSummary.UpdateSummary, {
                    updateSummary: updateSummary
                  })
                )
              );
            })
          )
        );
      }) : _react2.default.createElement(
        'span',
        null,
        'You haven\'t made any changes yet.'
      )
    );
  }
  if (editHistory && editHistory.length) {
    var processed = (0, _contractingUtils.processEditHistories)(editHistory, productsArray);
    return _react2.default.createElement(
      'div',
      null,
      processed.map(function (_ref4, index) {
        var name = _ref4.name,
            details = _ref4.details;

        return _react2.default.createElement(
          'div',
          { key: index },
          name ? _react2.default.createElement(
            'label',
            { style: { fontWeight: 'bold' } },
            name
          ) : _react2.default.createElement('label', null),
          details.split('|').map(function (detail, detailIndex, array) {
            if ((array[0] === 'Add product' || array[0] === 'Add new rate package') && detailIndex) return null;
            return _react2.default.createElement(
              'li',
              { key: detailIndex },
              detail
            );
          })
        );
      })
    );
  }
  return _react2.default.createElement('div', null);
};

exports.default = (0, _reactRedux.connect)(function (_ref5) {
  var contracting = _ref5.contracting;

  var productsArray = contracting.contractActivitiesProducts.getIn(['leftNav', 'productsArray']);
  return {
    productsArray: productsArray ? productsArray.toJS() : []
  };
})(EditHistories);

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateSummary = exports.getPricingChangesComponent = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPricingChangesComponent = exports.getPricingChangesComponent = function getPricingChangesComponent(amountChanges, percentChanges) {
  return amountChanges || percentChanges ? _react2.default.createElement(
    'span',
    null,
    '\xA0Average',
    percentChanges ? ' ' + percentChanges + '% ' : '',
    amountChanges ? '(' + amountChanges.slice(0, 1) + '$' + amountChanges.slice(1) + ')' : ''
  ) : '';
};
var getAverage = function getAverage(arrOfNum) {
  return arrOfNum.length ? (_ramda2.default.sum(arrOfNum) / arrOfNum.length).toFixed(2) : 0;
};
var UpdateSummary = exports.UpdateSummary = function UpdateSummary(_ref) {
  var updateSummary = _ref.updateSummary;

  return _react2.default.createElement(
    'ul',
    { style: { marginLeft: '20px', lineHeight: '24px', fontSize: '14px', fontWeight: '400' } },
    updateSummary.map(function (summary) {
      return _react2.default.createElement(
        'li',
        { key: summary.text },
        summary.text,
        Boolean(summary.subLabels && summary.subLabels.length) && _react2.default.createElement(
          'ul',
          { style: { marginLeft: '20px' } },
          summary.subLabels.map(function (_ref2, subLabelIndex) {
            var text = _ref2.text,
                nettRate = _ref2.nettRate,
                retailRate = _ref2.retailRate;

            var rate = nettRate || retailRate;
            return _react2.default.createElement(
              'li',
              { key: subLabelIndex },
              text,
              _react2.default.createElement(
                'div',
                { style: { fontWeight: 'bold', fontSize: '12px' } },
                Boolean(rate) && getPricingChangesComponent(rate.amountDiff, rate.percentDiff)
              )
            );
          })
        )
      );
    })
  );
};

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearState = exports.sendUpdatesFromQueue = exports.removeDraftFromQueue = exports.addDraftToQueue = undefined;

var _constants = __webpack_require__(252);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var addDraftToQueue = exports.addDraftToQueue = function addDraftToQueue(draftId, message) {
  return {
    type: cnt.ADD_DRAFT_TO_QUEUE,
    payload: { draftId: draftId, message: message }
  };
};

var removeDraftFromQueue = exports.removeDraftFromQueue = function removeDraftFromQueue(draftId, refreshSection) {
  return {
    type: cnt.REMOVE_DRAFT_FROM_QUEUE,
    payload: { draftId: draftId, refreshSection: refreshSection }
  };
};

var sendUpdatesFromQueue = exports.sendUpdatesFromQueue = function sendUpdatesFromQueue(templateIds, subject) {
  return {
    type: cnt.SEND_UPDATES_FROM_QUEUE,
    payload: { templateIds: templateIds, subject: subject }
  };
};

var clearState = exports.clearState = function clearState() {
  return { type: cnt.CLEAR_QUEUE_STATE };
};

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _expandableTextBlock = __webpack_require__(1560);

var _expandableTextBlock2 = _interopRequireDefault(_expandableTextBlock);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TermsCriteria = function TermsCriteria(_ref) {
  var corporateIdentificationNumber = _ref.corporateIdentificationNumber,
      deadlineDate = _ref.deadlineDate,
      editable = _ref.editable,
      forSupplier = _ref.forSupplier,
      inMaster = _ref.inMaster,
      marketInfo = _ref.marketInfo,
      openAddEditContractDialog = _ref.openAddEditContractDialog,
      style = _ref.style,
      submissionCriteria = _ref.submissionCriteria,
      termsAndConditions = _ref.termsAndConditions;

  var editNotes = function editNotes(action) {
    return function () {
      return openAddEditContractDialog({
        type: 'submissionCriteria',
        title: action + ' notes',
        policiesNotesPage: true,
        data: { forSupplier: forSupplier }
      });
    };
  };
  var editTerms = function editTerms(action) {
    return function () {
      return openAddEditContractDialog({
        type: 'termsAndConditions',
        title: action + ' terms and conditions',
        policiesNotesPage: true,
        data: { forSupplier: forSupplier }
      });
    };
  };
  var editMarketInfo = function editMarketInfo(action) {
    return function () {
      return openAddEditContractDialog({
        type: 'marketInfo',
        title: action + ' market information',
        policiesNotesPage: true,
        data: { forSupplier: forSupplier }
      });
    };
  };
  var termsNode = function () {
    if (termsAndConditions) return termsAndConditions;
    return _react2.default.createElement(_addItemCard2.default, {
      text: 'Add terms and conditions',
      onClick: editTerms('Add'),
      editable: editable
    });
  }();
  var submissionNode = function () {
    if (submissionCriteria) return submissionCriteria;
    return _react2.default.createElement(_addItemCard2.default, {
      text: 'Add notes',
      onClick: editNotes('Add'),
      editable: editable
    });
  }();
  var marketInfoNode = function () {
    if (marketInfo) return marketInfo;
    return _react2.default.createElement(_addItemCard2.default, {
      text: 'Add market information',
      onClick: editMarketInfo('Add'),
      editable: editable
    });
  }();
  return _react2.default.createElement(
    'div',
    { style: _extends({ marginLeft: '15%', marginBottom: '24px', width: '80%', paddingTop: '24px', whiteSpace: 'pre-wrap' }, style) },
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '12px', fontSize: '16px' } },
      'GENERAL CONTRACT NOTES'
    ),
    _react2.default.createElement(
      'div',
      { style: { marginLeft: '32px' } },
      deadlineDate && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { fontWeight: 'bolder' } },
          'Rate Submission Deadline'
        ),
        _react2.default.createElement(
          'div',
          { style: { margin: '1em 0 1em 0' } },
          _moment2.default.utc(new Date(deadlineDate)).format('MMMM DD, YYYY')
        )
      ),
      _react2.default.createElement(_helperLink2.default, {
        openEditDialog: editNotes('Edit'),
        value: 'submissionCriteria',
        labelText: 'Notes',
        justLabel: inMaster
      }),
      _react2.default.createElement(
        _mouseOverEditDiv2.default,
        {
          editable: editable && Boolean(submissionCriteria),
          actionButtons: _react2.default.createElement(_editButton2.default, {
            onEdit: editNotes('Edit')
          }),
          singleLineTitle: true
        },
        Boolean(submissionCriteria) && _react2.default.createElement('br', null),
        _react2.default.createElement(
          _expandableTextBlock2.default,
          {
            style: { whiteSpace: 'pre-wrap', wordWrap: 'break-word' }
          },
          submissionNode
        ),
        _react2.default.createElement('br', null)
      ),
      _react2.default.createElement(_helperLink2.default, {
        openEditDialog: editTerms('Edit'),
        value: 'termsAndConditions',
        labelText: 'Terms & conditions',
        justLabel: inMaster
      }),
      _react2.default.createElement(
        _mouseOverEditDiv2.default,
        {
          editable: editable && Boolean(termsAndConditions),
          actionButtons: _react2.default.createElement(_editButton2.default, { onEdit: editTerms('Edit') }),
          singleLineTitle: true
        },
        Boolean(termsAndConditions) && _react2.default.createElement('br', null),
        _react2.default.createElement(
          _expandableTextBlock2.default,
          {
            style: { whiteSpace: 'pre-wrap', wordWrap: 'break-word' }
          },
          termsNode
        ),
        _react2.default.createElement('br', null)
      ),
      forSupplier ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_helperLink2.default, {
          openEditDialog: editMarketInfo('Edit'),
          value: 'marketInfo',
          labelText: 'Market Information (FIT, Group, Markets, etc.)',
          justLabel: inMaster
        }),
        _react2.default.createElement(
          _mouseOverEditDiv2.default,
          {
            editable: editable && Boolean(marketInfo),
            actionButtons: _react2.default.createElement(_editButton2.default, { onEdit: editMarketInfo('Edit') }),
            singleLineTitle: true
          },
          Boolean(marketInfo) && _react2.default.createElement('br', null),
          _react2.default.createElement(
            'div',
            null,
            marketInfoNode
          ),
          _react2.default.createElement('br', null)
        )
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { fontWeight: 'bolder' } },
          'Corporate identifier/tax id'
        ),
        _react2.default.createElement(
          _mouseOverEditDiv2.default,
          {
            editable: editable,
            actionButtons: _react2.default.createElement(_editButton2.default, { onEdit: function onEdit() {
                return openAddEditContractDialog({ type: 'corporateIdentificationNumber', title: 'Update corporate identification number', data: { forSupplier: forSupplier } });
              } }),
            singleLineTitle: true
          },
          Boolean(corporateIdentificationNumber) ? _react2.default.createElement(
            'div',
            { style: { marginTop: '1em' } },
            corporateIdentificationNumber
          ) : _react2.default.createElement(
            'div',
            { style: { color: 'rgba(0, 0, 0, 0.34)' } },
            'NA'
          ),
          _react2.default.createElement('br', null)
        )
      )
    )
  );
};

TermsCriteria.propTypes = {
  contractState: _propTypes2.default.string,
  corporateIdentificationNumber: _propTypes2.default.string,
  deadlineDate: _propTypes2.default.string,
  editable: _propTypes2.default.bool,
  forSupplier: _propTypes2.default.bool,
  inMaster: _propTypes2.default.bool,
  marketInfo: _propTypes2.default.string,
  openAddEditContractDialog: _propTypes2.default.func,
  style: _propTypes2.default.object,
  submissionCriteria: _propTypes2.default.string,
  termsAndConditions: _propTypes2.default.string
};

exports.default = TermsCriteria;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InsuranceInfoDisplay = exports.BillingInfoDisplay = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _activityWithIcon = __webpack_require__(1266);

var _activityWithIcon2 = _interopRequireDefault(_activityWithIcon);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BillingInfoDisplay = function BillingInfoDisplay(props) {
  var inMaster = props.inMaster,
      hideLabel = props.hideLabel,
      supplierEditable = props.supplierEditable,
      openAddEditContractDialog = props.openAddEditContractDialog,
      _props$classes = props.classes,
      classes = _props$classes === undefined ? {} : _props$classes,
      billingInfo = _objectWithoutProperties(props, ['inMaster', 'hideLabel', 'supplierEditable', 'openAddEditContractDialog', 'classes']);

  var terms = billingInfo.terms,
      financialInstitution = billingInfo.financialInstitution,
      branch = billingInfo.branch,
      accountName = billingInfo.accountName,
      accountNumber = billingInfo.accountNumber,
      bsbRoutingNumber = billingInfo.bsbRoutingNumber,
      ibanSwiftCode = billingInfo.ibanSwiftCode,
      currency = billingInfo.currency;

  var editBillingInfo = function editBillingInfo() {
    return openAddEditContractDialog({
      type: 'billingInfo',
      title: 'Edit billing information'
    });
  };
  return _react2.default.createElement(
    'div',
    { id: 'billingInfo' },
    _react2.default.createElement(_helperLink2.default, {
      value: 'billingInfo',
      labelText: !hideLabel && 'Billing Information',
      openEditDialog: editBillingInfo,
      justLabel: inMaster
    }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        extendPadding: true,
        editable: supplierEditable,
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: editBillingInfo
        })
      },
      _react2.default.createElement(
        'div',
        {
          style: { marginBottom: '20px', display: terms ? 'block' : 'none', whiteSpace: 'pre-wrap' },
          className: classes['terms-textblock'] ? '' : classes['terms']
        },
        classes['terms-textblock'] || terms
      ),
      _react2.default.createElement(_twoColumnRow2.default, {
        hide: !(financialInstitution && branch),
        outerContainerStyle: { marginBottom: '12px', maxWidth: '500px' },
        leftColumnStyle: { width: '60%' },
        leftColumnContent: 'Financial institution',
        rightColumnStyle: { textAlign: 'right' },
        rightColumnContent: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { className: classes['financialInstitution'] },
            financialInstitution
          ),
          ' - ',
          _react2.default.createElement(
            'span',
            { className: classes['branch'] },
            branch
          )
        )
      }),
      _react2.default.createElement(_twoColumnRow2.default, {
        hide: !accountName,
        outerContainerStyle: { marginBottom: '0', maxWidth: '500px' },
        leftColumnStyle: { width: '60%' },
        leftColumnContent: 'Account Name',
        rightColumnStyle: { textAlign: 'right' },
        rightColumnClassName: classes['accountName'],
        rightColumnContent: accountName
      }),
      _react2.default.createElement(_twoColumnRow2.default, {
        hide: !accountNumber,
        outerContainerStyle: { marginBottom: '0', maxWidth: '500px' },
        leftColumnStyle: { width: '60%' },
        leftColumnContent: 'Account Number',
        rightColumnStyle: { textAlign: 'right' },
        rightColumnClassName: classes['accountNumber'],
        rightColumnContent: accountNumber
      }),
      _react2.default.createElement(_twoColumnRow2.default, {
        hide: !bsbRoutingNumber,
        outerContainerStyle: { marginBottom: '0', maxWidth: '500px' },
        leftColumnStyle: { width: '60%' },
        leftColumnContent: 'BSB/Routing number',
        rightColumnStyle: { textAlign: 'right' },
        rightColumnClassName: classes['bsbRoutingNumber'],
        rightColumnContent: bsbRoutingNumber
      }),
      _react2.default.createElement(_twoColumnRow2.default, {
        hide: !ibanSwiftCode,
        outerContainerStyle: { marginBottom: '0', maxWidth: '500px' },
        leftColumnStyle: { width: '60%' },
        leftColumnContent: 'Iban/Swift code',
        rightColumnStyle: { textAlign: 'right' },
        rightColumnClassName: classes['ibanSwiftCode'],
        rightColumnContent: ibanSwiftCode
      }),
      _react2.default.createElement(_twoColumnRow2.default, {
        hide: !currency,
        leftColumnStyle: { width: '60%', maxWidth: '500px' },
        leftColumnContent: 'Currency',
        rightColumnStyle: { textAlign: 'right' },
        rightColumnClassName: classes['currency'],
        rightColumnContent: currency
      })
    )
  );
};

exports.BillingInfoDisplay = BillingInfoDisplay;
var InsuranceInfoDisplay = function InsuranceInfoDisplay(props) {
  var inMaster = props.inMaster,
      hideLabel = props.hideLabel,
      supplierEditable = props.supplierEditable,
      openAddEditContractDialog = props.openAddEditContractDialog,
      _props$classes2 = props.classes,
      classes = _props$classes2 === undefined ? {} : _props$classes2,
      insuranceInfo = _objectWithoutProperties(props, ['inMaster', 'hideLabel', 'supplierEditable', 'openAddEditContractDialog', 'classes']);

  var insuranceExpirationYear = insuranceInfo.insuranceExpirationYear,
      insuranceExpirationMonth = insuranceInfo.insuranceExpirationMonth,
      insuranceFiles = insuranceInfo.insuranceFiles;

  var editInsurance = function editInsurance() {
    return openAddEditContractDialog({
      type: 'billingInfo',
      title: 'Edit insurance information'
    });
  };
  return _react2.default.createElement(
    'div',
    { id: 'insuranceInfo' },
    _react2.default.createElement('br', null),
    _react2.default.createElement('br', null),
    _react2.default.createElement(_helperLink2.default, {
      value: 'insuranceInfo',
      labelText: !hideLabel && 'Insurance Information',
      openEditDialog: editInsurance,
      justLabel: inMaster
    }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        extendPadding: true,
        editable: supplierEditable,
        style: { marginTop: '16px' },
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: editInsurance
        })
      },
      _react2.default.createElement(_twoColumnRow2.default, {
        hide: !insuranceExpirationYear && !insuranceExpirationMonth,
        outerContainerStyle: { marginBottom: '0', maxWidth: '500px' },
        leftColumnStyle: { width: '60%' },
        leftColumnContent: 'Expiration',
        rightColumnStyle: { textAlign: 'right' },
        rightColumnClassName: classes.insuranceExpirationYear || classes.insuranceExpirationMonth,
        rightColumnContent: (0, _moment2.default)(new Date(insuranceExpirationYear, insuranceExpirationMonth - 1, 1)).format('MMM YYYY')
      }),
      _react2.default.createElement(_twoColumnRow2.default, {
        hide: !(insuranceFiles && insuranceFiles.length && insuranceFiles[0].fileName),
        outerContainerStyle: { marginBottom: '0', display: 'flex', flexWrap: 'wrap', maxWidth: '500px' },
        leftColumnStyle: { width: '40%' },
        leftColumnContent: 'Uploaded document',
        rightColumnContent: insuranceFiles && insuranceFiles.length && insuranceFiles[0].fileName ? insuranceFiles.map(function (file, key) {
          return _react2.default.createElement(
            'div',
            {
              key: key,
              style: { float: 'right', width: '100%' },
              className: classes['insuranceFiles-' + key] || classes['insuranceFiles-' + key + '-fileName'] || classes['insuranceFiles-' + key + '-downloadUrl']
            },
            _react2.default.createElement(_activityWithIcon2.default, { file: file })
          );
        }) : _react2.default.createElement('div', null),
        rightColumnStyle: { width: '60%' }
      })
    )
  );
};

exports.InsuranceInfoDisplay = InsuranceInfoDisplay;
var BillingInfo = function BillingInfo(props) {
  var supplierEditable = props.supplierEditable,
      openAddEditContractDialog = props.openAddEditContractDialog,
      inMaster = props.inMaster,
      billingInfo = _objectWithoutProperties(props, ['supplierEditable', 'openAddEditContractDialog', 'inMaster']);

  var terms = billingInfo.terms,
      financialInstitution = billingInfo.financialInstitution,
      branch = billingInfo.branch,
      accountName = billingInfo.accountName,
      accountNumber = billingInfo.accountNumber,
      bsbRoutingNumber = billingInfo.bsbRoutingNumber,
      ibanSwiftCode = billingInfo.ibanSwiftCode,
      currency = billingInfo.currency,
      insuranceExpirationYear = billingInfo.insuranceExpirationYear,
      insuranceExpirationMonth = billingInfo.insuranceExpirationMonth,
      insuranceFiles = billingInfo.insuranceFiles;

  var billingEmpty = !terms && !financialInstitution && !branch && !accountName && !accountNumber && !bsbRoutingNumber && !ibanSwiftCode && !currency;
  var insuranceEmpty = !insuranceExpirationYear && !insuranceExpirationMonth && !(insuranceFiles && insuranceFiles.length);
  return _react2.default.createElement(
    'div',
    { style: { marginLeft: '15%', width: '80%', paddingTop: '24px', paddingBottom: '24px', borderTop: '1px solid #efefef' }, id: 'billingInfo' },
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '12px', fontSize: '16px' } },
      'BILLING & INSURANCE'
    ),
    _react2.default.createElement(
      'div',
      { style: { marginLeft: '32px' } },
      billingEmpty ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_helperLink2.default, {
          value: 'billingInfo',
          labelText: 'Billing Information',
          justLabel: inMaster
        }),
        _react2.default.createElement(_addItemCard2.default, {
          text: 'Add billing information',
          onClick: function onClick() {
            return openAddEditContractDialog({
              type: 'billingInfo',
              title: 'Add billing information'
            });
          },
          editable: supplierEditable
        })
      ) : _react2.default.createElement(BillingInfoDisplay, props),
      insuranceEmpty ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_helperLink2.default, {
          value: 'insuranceInfo',
          labelText: 'Insurance Information',
          justLabel: inMaster
        }),
        _react2.default.createElement(_addItemCard2.default, {
          text: 'Add insurance information',
          onClick: function onClick() {
            return openAddEditContractDialog({
              type: 'billingInfo',
              title: 'Add insurance information'
            });
          },
          editable: supplierEditable
        })
      ) : _react2.default.createElement(InsuranceInfoDisplay, props)
    )
  );
};

BillingInfo.propTypes = {
  insuranceFiles: _react.PropTypes.array,
  terms: _react.PropTypes.string,
  financialInstitution: _react.PropTypes.string,
  branch: _react.PropTypes.string,
  accountName: _react.PropTypes.string,
  accountNumber: _react.PropTypes.string,
  bsbRoutingNumber: _react.PropTypes.string,
  ibanSwiftCode: _react.PropTypes.string,
  currency: _react.PropTypes.string,
  insuranceExpirationYear: _react.PropTypes.number,
  insuranceExpirationMonth: _react.PropTypes.number,
  addBillingInformation: _react.PropTypes.func,
  editBillingInformation: _react.PropTypes.func,
  openAddEditContractDialog: _react.PropTypes.func,
  supplierEditable: _react.PropTypes.bool,
  contractState: _react.PropTypes.string
};

exports.default = BillingInfo;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRouter = __webpack_require__(67);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _importFieldsActivityFeed = __webpack_require__(3382);

var _importFieldsActivityFeed2 = _interopRequireDefault(_importFieldsActivityFeed);

var _contractingUtils = __webpack_require__(124);

var _editHistories = __webpack_require__(1261);

var _editHistories2 = _interopRequireDefault(_editHistories);

var _api = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import FieldNamesToFormalNames from '../../../utils/contracting-fieldName-to-formalNames';
// import R from 'ramda';
var ActivityWithIcon = function ActivityWithIcon(_ref) {
  var action = _ref.action,
      statusChanged = _ref.statusChanged,
      file = _ref.file,
      version = _ref.version,
      amendment = _ref.amendment,
      editHistory = _ref.editHistory,
      diffSummary = _ref.diffSummary,
      lastVersionId = _ref.lastVersionId,
      currentVersionId = _ref.currentVersionId,
      importedFields = _ref.importedFields,
      className = _ref.className,
      diff = _ref.diff;

  var isForAnUpdates = action === 'Contract Updated' || diffSummary && diffSummary.summaryByPage.length;
  if (!statusChanged && !file && !amendment && !isForAnUpdates && !importedFields && !diff) {
    return _react2.default.createElement('span', null);
  }

  var _ref2 = function () {
    if (statusChanged) {
      var newStatus = statusChanged === 'received externally' ? 'received' : statusChanged;
      return {
        icon: (0, _contractingUtils.getStatusIcon)(newStatus),
        bgColor: 'white',
        color: (0, _contractingUtils.getStatusColor)(newStatus)
      };
    } else if (amendment) {
      return {
        icon: 'tc-icon-receipt',
        bgColor: '#e6e6e6',
        color: '#616061'
      };
    } else if (isForAnUpdates) {
      return {
        icon: 'tc-icon-change_history',
        bgColor: '#e6e6e6',
        color: '#616061'
      };
    } else if (file) {
      return {
        icon: 'tc-icon-attach_file',
        bgColor: '#e6e6e6',
        color: '#616061'
      };
    }
    return {};
  }(),
      icon = _ref2.icon,
      bgColor = _ref2.bgColor,
      color = _ref2.color;

  var diffMap = {
    priority: {
      label: 'Priority',
      getValue: function getValue(val) {
        return val || 'Medium';
      }
    },
    rateConversionStatus: {
      label: 'Status',
      getValue: function getValue(val) {
        return val;
      }
    },
    rateConversionSetting: {
      label: 'Require Supplier Signature',
      getValue: function getValue(val) {
        return val === 'opt-in' ? 'Yes' : 'No';
      }
    },
    shouldSendReminders: {
      label: 'Auto Reminders',
      getValue: function getValue(val) {
        return val ? 'ON' : 'OFF';
      }
    },
    assignee: {
      label: 'Assignee',
      getValue: function getValue(val) {
        return val ? val.name || val.email || 'Unassigned' : 'Unassigned';
      }
    },
    state: {
      label: 'Status',
      getValue: function getValue(val) {
        return val;
      }
    },
    'Contract Period': {
      label: 'Contract Period',
      getValue: function getValue(val) {
        return val;
      }
    }
  };
  var textNode = function () {
    if (file) {
      var downloadUrl = _api.fileUrls.getDownloadUrlSync(file.hash || file.downloadUrl || file.path);
      return _react2.default.createElement(
        'a',
        { href: downloadUrl, download: file.fileName || file.name },
        _react2.default.createElement(
          'small',
          { style: { marginLeft: '5px', color: '#616061' } },
          file.fileName || file.name
        )
      );
    }
    if (statusChanged) {
      if (statusChanged === 'received externally') {
        return _react2.default.createElement(
          'small',
          { style: { marginLeft: '5px' } },
          'marked as ',
          _react2.default.createElement(
            'span',
            { style: { color: color } },
            'received'
          )
        );
      }
      return _react2.default.createElement(
        'small',
        { style: { marginLeft: '5px' } },
        'status changed to ',
        _react2.default.createElement(
          'span',
          { style: { color: color } },
          statusChanged
        )
      );
    }
    if (amendment) return _react2.default.createElement(
      'small',
      { style: { marginLeft: '5px' } },
      'added ',
      _react2.default.createElement(
        'a',
        { href: amendment.downloadUrl },
        _react2.default.createElement(
          'span',
          { style: { color: '#00b3cf' } },
          'amendment'
        )
      )
    );
    if (isForAnUpdates) return _react2.default.createElement(
      'small',
      { style: { marginLeft: '5px' } },
      'modified the contract ',
      _react2.default.createElement(
        'span',
        { style: { color: '#00b3cf' } },
        'Learn more'
      )
    );
    if (diff && diff.key && diffMap[diff.key]) return _react2.default.createElement(
      'div',
      null,
      'Changed ',
      _react2.default.createElement(
        'b',
        null,
        diffMap[diff.key].label
      ),
      ' from ',
      _react2.default.createElement(
        'i',
        null,
        diffMap[diff.key].getValue(diff.oldValue)
      ),
      ' to ',
      _react2.default.createElement(
        'b',
        null,
        diffMap[diff.key].getValue(diff.newValue)
      )
    );
    return _react2.default.createElement('div', null);
  }();

  // const anchorSwitch = (sectionName) => {
  //   const route = `/contracting/contract/${contractId}/details`;
  //   if (sectionName === 'Edit Billing Info') return <a href={`${route}#billingInfo`}>{sectionName}</a>;
  //   if (sectionName === 'Edit Policy Info') return <a href={`${route}#cancellationPolicy`}>{sectionName}</a>;
  // if (sectionName === 'Edit Policy Info') return <Link to={{ pathname: route, hash: '#cancellationPolicy' }}>{sectionName}</Link>;
  // if (sectionName === 'Edit Policy Info') return <FlatButton label={sectionName} onTouchTap={jumpToSection}/>;
  // };

  if (isForAnUpdates) {
    return _react2.default.createElement(
      _materialUi.Card,
      { style: { boxShadow: 'none' } },
      _react2.default.createElement(_materialUi.CardHeader, {
        style: { height: '24px', padding: '0' },
        title: _react2.default.createElement(
          'div',
          { style: { lineHeight: '20px', marginBottom: '12px' } },
          _react2.default.createElement(
            'div',
            { style: { width: '22px', height: '22px', borderRadius: '50%', backgroundColor: bgColor, lineHeight: '20px', display: 'inline-block' } },
            _react2.default.createElement(_materialUi.FontIcon, { className: icon, color: color, style: { fontSize: '16px', left: '3px', top: '2px' } })
          ),
          _react2.default.createElement(
            'small',
            { style: { marginLeft: '5px', color: 'rgba(0, 0, 0, 0.54)' } },
            'This contract has been updated ',
            version ? _react2.default.createElement(
              'span',
              null,
              'to ',
              _react2.default.createElement(
                'b',
                null,
                'version ',
                version
              ),
              ' '
            ) : '',
            _react2.default.createElement(
              'span',
              { style: { color: '#00b3cf' } },
              'View all updates'
            )
          )
        ),
        actAsExpander: true
      }),
      _react2.default.createElement(
        _materialUi.CardText,
        { expandable: true, style: { padding: '0 0 0 12px', marginBottom: '12px' } },
        _react2.default.createElement(_editHistories2.default, {
          editHistory: editHistory,
          diffSummary: diffSummary
        }),
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/contracting/reports/diff/contract/' + currentVersionId + '/' + lastVersionId, style: { color: '#00b3cf' } },
          'View side by side comparison'
        )
      )
    );
  }
  if (importedFields) return _react2.default.createElement(_importFieldsActivityFeed2.default, { importedFields: importedFields, contractId: currentVersionId });
  return _react2.default.createElement(
    'div',
    { style: { lineHeight: '20px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }, className: className },
    icon ? _react2.default.createElement(
      'div',
      { style: { width: '22px', height: '22px', borderRadius: '50%', backgroundColor: bgColor, lineHeight: '20px', display: 'inline-block' } },
      _react2.default.createElement(_materialUi.FontIcon, { className: icon, color: color, style: { fontSize: '16px', left: '3px', top: '2px' } })
    ) : undefined,
    textNode
  );
};

ActivityWithIcon.propTypes = {
  className: _react.PropTypes.string,
  diff: _react.PropTypes.object,
  editHistory: _react.PropTypes.array,
  file: _react.PropTypes.object,
  statusChanged: _react.PropTypes.string,
  type: _react.PropTypes.string
};

exports.default = ActivityWithIcon;

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CheckinCheckout = function CheckinCheckout(_ref) {
  var inMaster = _ref.inMaster,
      openAddEditContractDialog = _ref.openAddEditContractDialog,
      supplierEditable = _ref.supplierEditable,
      _ref$classes = _ref.classes,
      classes = _ref$classes === undefined ? {} : _ref$classes,
      inDiffing = _ref.inDiffing,
      data = _objectWithoutProperties(_ref, ['inMaster', 'openAddEditContractDialog', 'supplierEditable', 'classes', 'inDiffing']);

  var checkIn = data.checkIn,
      checkOut = data.checkOut,
      earlyCheckIn = data.earlyCheckIn,
      earlyCheckInFee = data.earlyCheckInFee,
      earlyCheckInCostType = data.earlyCheckInCostType,
      earlyCheckInPercentageType = data.earlyCheckInPercentageType,
      lateCheckOut = data.lateCheckOut,
      lateCheckOutFee = data.lateCheckOutFee,
      lateCheckOutCostType = data.lateCheckOutCostType,
      lateCheckOutPercentageType = data.lateCheckOutPercentageType;

  if (!checkIn && !checkOut && !earlyCheckIn && !earlyCheckInFee && !lateCheckOut && !lateCheckOutFee) {
    return _react2.default.createElement(
      'div',
      {
        style: { marginLeft: 'calc(15% + 32px)', width: 'calc(80% - 32px)', marginBottom: '24px' },
        id: 'checkInCheckOut'
      },
      _react2.default.createElement(
        _helperLink2.default,
        { value: 'checkinout', justLabel: inMaster },
        'Check-in and Check-out Policy'
      ),
      _react2.default.createElement(_addItemCard2.default, { text: 'Add check-in and check-out\npolicy', onClick: function onClick() {
          return openAddEditContractDialog({
            type: 'checkInOut',
            title: 'Edit Check-in & Check-out Policy'
          });
        }, editable: supplierEditable
      })
    );
  }
  return _react2.default.createElement(
    'div',
    {
      style: {
        margin: inDiffing ? 0 : '0 0 0 calc(15% + 32px)',
        whiteSpace: 'pre-wrap',
        width: 'calc(80% - 32px)'
      },
      id: 'checkInCheckOut'
    },
    _react2.default.createElement(_helperLink2.default, {
      value: 'checkinout',
      labelText: 'Check-in and Check-out Policy',
      justLabel: inMaster
    }),
    supplierEditable && _react2.default.createElement('br', null),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        editable: supplierEditable,
        actionButtons: _react2.default.createElement(_editButton2.default, { onEdit: function onEdit() {
            return openAddEditContractDialog({
              type: 'checkInOut',
              title: 'Edit Check-in & Check-out policy'
            });
          }
        })
      },
      _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { width: '100%', marginBottom: '12px', display: 'flex' },
        leftColumnStyle: { width: '50%', float: 'none' },
        leftColumnContent: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { fontWeight: 'bold' } },
            'Check-in policy'
          ),
          _react2.default.createElement(
            'div',
            {
              style: { fontWeight: 'bold', fontSize: '18px', margin: '8px auto', color: 'black' },
              className: classes['checkIn']
            },
            checkIn
          ),
          earlyCheckIn ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'small',
              null,
              'EARLY CHECK-IN'
            ),
            _react2.default.createElement(
              'div',
              null,
              'Available'
            ),
            _react2.default.createElement(
              'div',
              { className: classes['earlyCheckIn'] },
              'From ',
              earlyCheckIn
            ),
            _react2.default.createElement(
              'div',
              { className: classes['earlyCheckInFee'] || classes['earlyCheckInCostType'] || classes['earlyCheckInPercentageType'] },
              earlyCheckInFee ? 'For ' + (earlyCheckInCostType === '%' ? '' + earlyCheckInFee + earlyCheckInCostType : '' + (earlyCheckInCostType || '$') + earlyCheckInFee) + ' ' + (earlyCheckInCostType === '%' ? earlyCheckInPercentageType : '') : undefined
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'small',
              null,
              'EARLY CHECK-IN'
            ),
            _react2.default.createElement(
              'div',
              { className: classes['earlyCheckIn'] },
              'Not Available'
            )
          )
        ),
        rightColumnStyle: { marginLeft: '10%', width: '50%', float: 'none' },
        rightColumnContent: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { fontWeight: 'bold' } },
            'Check-out policy'
          ),
          _react2.default.createElement(
            'div',
            {
              style: { fontWeight: 'bold', fontSize: '18px', margin: '8px auto', color: 'black' },
              className: classes['checkOut']
            },
            checkOut
          ),
          lateCheckOut ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'small',
              null,
              'LATE CHECK-OUT'
            ),
            _react2.default.createElement(
              'div',
              null,
              'Available'
            ),
            _react2.default.createElement(
              'div',
              { className: classes['lateCheckOut'] },
              'Until ',
              lateCheckOut
            ),
            _react2.default.createElement(
              'div',
              { className: classes['lateCheckOutFee'] || classes['lateCheckOutCostType'] || classes['lateCheckOutPercentageType'] },
              lateCheckOutFee ? 'For ' + (lateCheckOutCostType === '%' ? '' + lateCheckOutFee + lateCheckOutCostType : '' + (lateCheckOutCostType || '$') + lateCheckOutFee) + ' ' + (lateCheckOutCostType === '%' ? lateCheckOutPercentageType : '') : undefined
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'small',
              null,
              'LATE CHECK-OUT'
            ),
            _react2.default.createElement(
              'div',
              { className: classes['lateCheckOut'] },
              'Not Available'
            )
          )
        )
      })
    )
  );
};

CheckinCheckout.propTypes = {
  checkIn: _react.PropTypes.any,
  checkOut: _react.PropTypes.any,
  earlyCheckIn: _react.PropTypes.any,
  earlyCheckInFee: _react.PropTypes.any,
  lateCheckOut: _react.PropTypes.any,
  lateCheckOutFee: _react.PropTypes.any,
  openAddEditContractDialog: _react.PropTypes.func
};

exports.default = CheckinCheckout;

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorModeEdit = function EditorModeEdit(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
  );
};
EditorModeEdit = (0, _pure2.default)(EditorModeEdit);
EditorModeEdit.displayName = 'EditorModeEdit';
EditorModeEdit.muiName = 'SvgIcon';

exports.default = EditorModeEdit;

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStatus = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(67);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStatus = exports.getStatus = function getStatus(template) {
  // workaround for draft created from "make a copy" feature
  if (template.completionPercent === 99.9) return 'new';
  if (!template.originalContractId) return 'Signed';
  if (!isNaN(template.completionPercent) && template.completionPercent !== null && template.completionPercent !== 100) {
    return template.completionPercent + '% completed';
  }
  // if (template.signatures && template.signatures.length) {
  //   if (template.signatures.some(o => o.signedBy)) return 'Signed';
  //   return 'Awaiting Supplier Signature';
  // }
  if (!isNaN(template.completionPercent) && template.completionPercent !== null) {
    return template.completionPercent + '% completed';
  }
  return template.status;
};

var TemplateListForRC = function TemplateListForRC(props) {
  var title = props.title,
      _props$templates = props.templates,
      templates = _props$templates === undefined ? [] : _props$templates,
      _props$inSigning = props.inSigning;
  _props$inSigning = _props$inSigning === undefined ? {} : _props$inSigning;
  var onClickFunc = _props$inSigning.onClickFunc,
      onCheckFunc = _props$inSigning.onCheckFunc,
      checkedMap = _props$inSigning.checkedMap,
      buyerLogo = _props$inSigning.buyerLogo,
      buyerName = _props$inSigning.buyerName,
      deleteRateSheet = props.deleteRateSheet,
      openRateDoc = props.openRateDoc;

  var isInSigning = Boolean(onCheckFunc);
  var deleteRateSheetFunc = function deleteRateSheetFunc(originalContractId) {
    return function () {
      var confirm = window.confirm('Are you sure you want to delete this rate sheet?');
      if (confirm) deleteRateSheet({ originalContractId: originalContractId });
    };
  };
  var onClickOpen = function onClickOpen(template) {
    return function () {
      if (onClickFunc) onClickFunc(template.originalContractId || template._id);
      openRateDoc({
        url: template.magicLink + '&jumpBackTo=' + window.location.href,
        collection: template.originalContractId ? 'draft' : 'template',
        rateDocId: template.originalContractId || template._id,
        isInSigning: isInSigning,
        buyerLogo: buyerLogo,
        buyerName: buyerName
      });
    };
  };
  var onClickOpenDiffing = function onClickOpenDiffing(template) {
    return function () {
      if (onClickFunc) onClickFunc(template.originalContractId || template._id);
      openRateDoc({
        url: template.magicLinkForDiffing + '&forDiffing=true',
        isInSigning: isInSigning,
        buyerLogo: buyerLogo,
        buyerName: buyerName
      });
    };
  };
  return _react2.default.createElement(
    'div',
    { style: { marginTop: '1em', display: templates.length ? 'block' : 'none', textAlign: 'left' } },
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '4px', fontSize: '16px' } },
      title || 'RATE SHEETS'
    ),
    templates
    // .sort((a, b) => (new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()))
    .map(function (template) {
      return _react2.default.createElement(
        'div',
        {
          key: template._id,
          style: { width: '100%', borderBottom: '1px solid #e0e0e0', padding: '4px' }
        },
        _react2.default.createElement(
          'div',
          { className: 'flex-tc-sb' },
          isInSigning && _react2.default.createElement(_materialUi.Checkbox, {
            style: { width: '40px' },
            checked: checkedMap[template._id] ? checkedMap[template._id].checked : false,
            disabled: checkedMap[template._id] ? checkedMap[template._id].disabled : false,
            onCheck: function onCheck(_, value) {
              return onCheckFunc(value, template._id);
            }
          }),
          _react2.default.createElement(
            'div',
            { style: { width: 'calc(50% - 100px)', overflowX: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } },
            _react2.default.createElement(
              'div',
              { className: 'flex-center' },
              _react2.default.createElement(_materialUi.FontIcon, {
                className: 'tc-icon-description',
                color: 'rgba(0, 0, 0, 0.54)',
                style: { fontSize: '14px' }
              }),
              '\xA0\xA0',
              template.locationName,
              ' ',
              template.originFrom === 'edited' ? _react2.default.createElement(
                'small',
                null,
                '\xA0(new version)'
              ) : ''
            ),
            template.buyerCreatedFrom ? _react2.default.createElement(
              'small',
              null,
              '\xA0This rate sheet was a copy created from a ',
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/contracting/contract/' + template.buyerCreatedFrom.split('|')[0] + '/details' },
                'contract sent by supplier'
              ),
              '.'
            ) : ''
          ),
          _react2.default.createElement(
            'div',
            { style: { width: 'calc(50% + 50px)', marginLeft: '16px' }, className: 'flex-tc-sb' },
            _react2.default.createElement(
              'div',
              { className: 'flex-center' },
              _react2.default.createElement(
                'small',
                null,
                _moment2.default.utc(template.startDate).format('DD MMM YYYY'),
                ' - ',
                _moment2.default.utc(template.endDate).format('DD MMM YYYY')
              ),
              _react2.default.createElement(
                'small',
                {
                  style: { marginLeft: '16px', minWidth: '100px', color: getStatus(template) === 'new' ? 'red' : 'initial' }
                },
                getStatus(template)
              )
            ),
            function () {
              if (!isInSigning) {
                if (template.activities.length) {
                  return _react2.default.createElement(
                    'div',
                    {
                      style: { textAlign: 'center' }
                    },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      {
                        to: '/contracting/template/' + template.threadId + '/logs?msgOnly=true'
                      },
                      _react2.default.createElement(_materialUi.FlatButton, {
                        label: 'View Msgs',
                        style: { border: '1px solid #00bcd4' },
                        secondary: true
                      })
                    )
                  );
                }
              }
              if (template.magicLinkForDiffing) {
                return _react2.default.createElement(_materialUi.FlatButton, {
                  label: 'View Changes',
                  labelStyle: { textTransform: 'none', padding: '2px', fontSize: '12px' },
                  style: { border: '1px solid #00bcd4', marginLeft: '16px' },
                  secondary: true,
                  onClick: onClickOpenDiffing(template)
                });
              }
              return _react2.default.createElement('span', null);
            }(),
            _react2.default.createElement(_materialUi.FlatButton, {
              label: 'Open',
              style: { border: '1px solid #00bcd4', marginLeft: '16px' },
              secondary: true,
              onClick: onClickOpen(template)
            }),
            Boolean(deleteRateSheet) && _react2.default.createElement(
              _materialUi.IconMenu,
              {
                iconButtonElement: _react2.default.createElement(_materialUi.IconButton, { iconClassName: 'tc-icon-more-vert', style: { paddingLeft: 0, width: '28px' }, iconStyle: { color: '#616061' } }),
                anchorOrigin: { horizontal: 'right', vertical: 'top' },
                targetOrigin: { horizontal: 'right', vertical: 'top' },
                desktop: true
              },
              _react2.default.createElement(_materialUi.MenuItem, {
                primaryText: 'Delete Rate Sheet',
                onClick: deleteRateSheetFunc(template.originalContractId)
              })
            )
          )
        )
      );
    })
  );
};

TemplateListForRC.propTypes = {
  title: _react.PropTypes.string,
  inSigning: _react.PropTypes.object,
  templates: _react.PropTypes.array,
  deleteRateSheet: _react.PropTypes.func,
  openRateDoc: _react.PropTypes.func
};

exports.default = (0, _reactRedux.connect)(null, {
  openRateDoc: function openRateDoc(payload) {
    return {
      type: '{dummy-account} RateDocIframe_open',
      payload: payload
    };
  }
})(TemplateListForRC);

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorAttachFile = function EditorAttachFile(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z' })
  );
};
EditorAttachFile = (0, _pure2.default)(EditorAttachFile);
EditorAttachFile.displayName = 'EditorAttachFile';
EditorAttachFile.muiName = 'SvgIcon';

exports.default = EditorAttachFile;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _description = __webpack_require__(561);

var _description2 = _interopRequireDefault(_description);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MsgAvatar = function MsgAvatar(_ref) {
  var type = _ref.type,
      avatarUrl = _ref.avatarUrl,
      name = _ref.name,
      tooltipPosition = _ref.tooltipPosition,
      link = _ref.link;

  var avatarComponent = function () {
    // if (type === 'email') return <Avatar backgroundColor="rgba(0, 0, 0, 0.1)" ><span style={{ fontSize: '9px', color: 'rgba(0, 0, 0, 0.67)' }}>offline</span></Avatar>;
    if (type === 'contract') return _react2.default.createElement(_materialUi.Avatar, { size: 30, icon: _react2.default.createElement(_description2.default, null) });
    if (avatarUrl) return _react2.default.createElement(_materialUi.Avatar, { size: 30, src: avatarUrl });
    return _react2.default.createElement(
      _materialUi.Avatar,
      { size: 30, backgroundColor: 'rgba(0, 0, 0, 0.1)' },
      _ramda2.default.head(name || 'MEN').toUpperCase()
    );
  }();

  if (tooltipPosition) {
    return _react2.default.createElement(
      'div',
      _extends({ className: 'with-tooltip' }, link ? {
        style: {
          pointer: 'cursor'
        },
        onTouchTap: link
      } : {}),
      avatarComponent,
      _react2.default.createElement(
        'span',
        { className: 'tooltiptext' },
        name
      )
    );
  }
  return avatarComponent;
};

exports.default = MsgAvatar;

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCreateLocIcon = exports.getAccessIcons = exports.noAccessIcon = exports.writeAccessIcon = exports.readAccessIcon = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var readAccessIcon = exports.readAccessIcon = _react2.default.createElement(_materialUi.IconButton, { tooltip: 'Read Access', iconClassName: 'tc-icon-remove_red_eye', iconStyle: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', padding: 0, marginTop: '5px' }, style: { width: '50%' } });
var writeAccessIcon = exports.writeAccessIcon = _react2.default.createElement(_materialUi.IconButton, { tooltip: 'Write Access', iconClassName: 'tc-icon-mode_edit', iconStyle: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', padding: 0, marginTop: '5px' }, style: { width: '50%' } });
var noAccessIcon = exports.noAccessIcon = _react2.default.createElement(_materialUi.IconButton, { tooltip: 'No Access', iconClassName: 'tc-icon-block', iconStyle: { color: 'rgba(255, 64, 129, 0.8)', fontSize: '14px', padding: 0, marginTop: '5px' } });

var getAccessIcons = exports.getAccessIcons = _ramda2.default.cond([[_ramda2.default.contains('write'), _ramda2.default.always(_react2.default.createElement(
  'span',
  { style: { width: '100%' } },
  readAccessIcon,
  writeAccessIcon
))], [_ramda2.default.contains('read'), _ramda2.default.always(_react2.default.createElement(
  'span',
  null,
  readAccessIcon
))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(
  'span',
  null,
  noAccessIcon
))]]);

var getCreateLocIcon = exports.getCreateLocIcon = _ramda2.default.ifElse(_ramda2.default.contains('createLocation'), _ramda2.default.always(writeAccessIcon), _ramda2.default.always(noAccessIcon));

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(226);

var _actions2 = __webpack_require__(1007);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _imagePreview = __webpack_require__(1568);

var _imagePreview2 = _interopRequireDefault(_imagePreview);

var _pdfPreview = __webpack_require__(1152);

var _pdfPreview2 = _interopRequireDefault(_pdfPreview);

var _pptPreview = __webpack_require__(1602);

var _pptPreview2 = _interopRequireDefault(_pptPreview);

var _videoPreview = __webpack_require__(1153);

var _videoPreview2 = _interopRequireDefault(_videoPreview);

var _lightbox = __webpack_require__(1603);

var _lightbox2 = _interopRequireDefault(_lightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilePreview = function FilePreview(props) {
  var files = props.files,
      removeFile = props.removeFile,
      showGallery = props.showGallery,
      showFileName = props.showFileName,
      updateProp = props.updateProp,
      viewingFiles = props.viewingFiles,
      fileToView = props.fileToView,
      displayType = props.displayType,
      updatePostPageProp = props.updatePostPageProp,
      postFilePreview = props.postFilePreview,
      postPreviewFiles = props.postPreviewFiles;


  var previewFile = displayType === 'publicPostPage' ? postFilePreview : fileToView;
  var postFiles = displayType === 'publicPostPage' ? postPreviewFiles : viewingFiles;
  var onlyOneImageToDisplay = showGallery && _ramda2.default.propOr(0, 'length', files) === 1; // if only 1 image, display larger

  return _react2.default.createElement(
    'div',
    { style: { marginTop: '5px', display: 'flex', width: '100%', overflowY: onlyOneImageToDisplay ? 'hidden' : 'scroll', maxHeight: showGallery && '400px', flexWrap: 'wrap', overflowX: 'hidden' } },
    files.map(function (file, i) {
      var sharedProps = {
        url: file.url,
        removeFile: removeFile,
        fileName: file.name,
        showFileName: showFileName,
        showGallery: showGallery,
        openGallery: function openGallery() {
          if (displayType === 'publicPostPage') {
            updatePostPageProp({ postFilePreview: _ramda2.default.merge(file, { index: i }) });
          } else {
            updateProp({ viewingFile: _ramda2.default.merge(file, { index: i }), viewingFiles: files });
          }
          document.getElementById('file-preview-modal').style.display = 'block';
          document.getElementById('file-preview-modal-overlay').style.display = 'block';
        },
        onlyOneImage: onlyOneImageToDisplay
      };
      return _react2.default.createElement(
        'div',
        { key: i, style: { display: 'inline-block', margin: onlyOneImageToDisplay ? '10px 15px' : '10px' } },
        _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.either(_ramda2.default.equals('image/png'), _ramda2.default.equals('image/jpeg')), _ramda2.default.always(_react2.default.createElement(_imagePreview2.default, _extends({
          src: file.url,
          thumbnail: file.url,
          thumbnailWidth: onlyOneImageToDisplay ? 420 : 200,
          thumbnailHeight: onlyOneImageToDisplay ? 150 : 120
        }, sharedProps)))], [_ramda2.default.equals('application/pdf'), _ramda2.default.always(_react2.default.createElement(_pdfPreview2.default, sharedProps))], [_ramda2.default.either(_ramda2.default.equals('video/mp4'), _ramda2.default.equals('video/quicktime')), _ramda2.default.always(_react2.default.createElement(_videoPreview2.default, sharedProps))], [_ramda2.default.either(_ramda2.default.equals('application/vnd.ms-powerpoint'), _ramda2.default.equals('application/vnd.openxmlformats-officedocument.presentationml.presentation')), _ramda2.default.always(_react2.default.createElement(_pptPreview2.default, sharedProps))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement('span', null))]]), file.mediaType)
      );
    }),
    showGallery && _react2.default.createElement(_lightbox2.default, {
      viewingFileIndex: _ramda2.default.propOr(0, 'index', previewFile),
      changePage: function changePage(newIndex) {
        if (displayType === 'publicPostPage') {
          updatePostPageProp({ postFilePreview: _ramda2.default.merge(postFiles[newIndex], { index: newIndex }) });
        } else {
          updateProp({ viewingFile: _ramda2.default.merge(postFiles[newIndex], { index: newIndex }) });
        }
      },
      filesLength: postFiles.length,
      viewingFile: previewFile,
      closeLightbox: function closeLightbox() {
        if (displayType === 'publicPostPage') {
          updatePostPageProp({ postFilePreview: {} });
        } else {
          updateProp({ viewingFile: {}, viewingFiles: [] });
        }
        document.getElementById('file-preview-modal').style.display = 'none';
        document.getElementById('file-preview-modal-overlay').style.display = 'none';
      }
    })
  );
};

FilePreview.propTypes = {
  files: _react.PropTypes.array,
  removeFile: _react.PropTypes.func,
  showGallery: _react.PropTypes.bool,
  showFileName: _react.PropTypes.bool,
  updateProp: _react.PropTypes.func,
  fileToView: _react.PropTypes.object,
  viewingFiles: _react.PropTypes.array,
  displayType: _react.PropTypes.string,
  updatePostPageProp: _react.PropTypes.func,
  postFilePreview: _react.PropTypes.object,
  postPreviewFiles: _react.PropTypes.array
};

var mapStateToProps = function mapStateToProps(_ref) {
  var newsfeed = _ref.newsfeed;
  return {
    fileToView: newsfeed ? newsfeed.get('viewingFile').toJS() : {},
    viewingFiles: newsfeed ? newsfeed.get('viewingFiles').toJS() : []
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateProps.apply(undefined, arguments));
    },
    updatePostPageProp: function updatePostPageProp() {
      return dispatch(_actions2.updateProps.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FilePreview);

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingBox = function LoadingBox() {
  return _react2.default.createElement(
    'div',
    { style: { padding: '0 1px' } },
    _react2.default.createElement(
      'div',
      { style: { display: 'inline-block', verticalAlign: 'top', padding: '0 10px', width: '11%' } },
      _react2.default.createElement(_materialUi.Avatar, {
        backgroundColor: '#E0E0E0',
        style: {
          border: '0px solid #E0E0E0',
          height: '40px',
          marginTop: '10px',
          position: 'relative',
          width: '40px'
        }
      })
    ),
    _react2.default.createElement(
      _materialUi.Card,
      { style: { display: 'inline-block', width: '89%', padding: '2%', margin: '10px 0', color: 'rgba(0, 0, 0, 0.54)' } },
      _react2.default.createElement(
        'div',
        { style: { display: 'flex', alignItems: 'center' } },
        _react2.default.createElement(
          'div',
          { style: { width: '80%', display: 'flex', flexDirection: 'column' } },
          _react2.default.createElement(
            'div',
            { style: { flexGrow: 1, width: '40%', height: '24px' } },
            _react2.default.createElement(_materialUi.LinearProgress, { style: { height: '8px' }, color: '#aeaeae' })
          ),
          _react2.default.createElement(_materialUi.LinearProgress, { style: { flexGrow: 1, height: '8px' }, color: '#aeaeae', mode: 'determinate', max: 100, min: 0, value: 80 })
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { margin: '24px 0', display: 'flex', flexDirection: 'column' } },
        _react2.default.createElement(
          'div',
          { style: { flexGrow: 1, height: '24px' } },
          _react2.default.createElement(_materialUi.LinearProgress, { style: { height: '8px' }, color: '#aeaeae', mode: 'determinate', max: 100, min: 0, value: 70 })
        ),
        _react2.default.createElement(
          'div',
          { style: { flexGrow: 1, height: '24px' } },
          _react2.default.createElement(_materialUi.LinearProgress, { style: { height: '8px' }, color: '#aeaeae', mode: 'determinate', max: 100, min: 0, value: 40 })
        ),
        _react2.default.createElement(_materialUi.LinearProgress, { style: { flexGrow: 1, height: '8px', width: '80%' }, color: '#aeaeae' })
      )
    )
  );
};

exports.default = LoadingBox;

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _contractingUtils = __webpack_require__(124);

var _reactRouterRedux = __webpack_require__(27);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRouter = __webpack_require__(67);

var _templateStagedUpdatesTextFlag = __webpack_require__(1559);

var _templateStagedUpdatesTextFlag2 = _interopRequireDefault(_templateStagedUpdatesTextFlag);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleTemplate = function SingleTemplate(props) {
  var template = props.template,
      selectOrUnselect = props.selectOrUnselect,
      style = props.style,
      makeItShorter = props.makeItShorter,
      push = props.push;

  var state = template.state ? 'draft' : 'completed';
  return _react2.default.createElement(
    'div',
    {
      style: _extends({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }, style)
    },
    selectOrUnselect && _react2.default.createElement(_materialUi.Checkbox, {
      style: { width: '50px' },
      checked: Boolean(template.checked),
      onCheck: function onCheck() {
        return selectOrUnselect({ id: template._id });
      }
    }),
    _react2.default.createElement(
      'div',
      {
        style: {
          width: '55%',
          fontSize: '14px'
        }
      },
      _react2.default.createElement(
        'div',
        {
          style: { display: 'flex', alignItems: 'flex-center', cursor: 'pointer' },
          onClick: function onClick() {
            return push('/contracting/' + (template.originalContractId ? 'draft' : 'template') + '/' + (template.originalContractId || template._id) + '/details');
          }
        },
        _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-description', color: 'rgba(0, 0, 0, 0.54)' }),
        template.templateName
      ),
      function () {
        if (template.stagedUpdates && template.stagedUpdates.length) {
          return _react2.default.createElement(_templateStagedUpdatesTextFlag2.default, {
            style: { fontSize: '12px' },
            stagedUpdates: template.stagedUpdates,
            updateInitiated: template.updateInitiated,
            isEditedTemplate: template.templateHasDraft,
            refreshSection: 'list'
          });
        }
        if (template.templateHasDraft) {
          return _react2.default.createElement(
            'span',
            { style: { marginLeft: '12px', color: 'red', zIndex: '200' } },
            'This template has a',
            ' ',
            _react2.default.createElement(
              _reactRouter.Link,
              {
                onClick: function onClick(e) {
                  return e.stopPropagation();
                },
                to: '/contracting/draft/' + template._id + '/details'
              },
              'draft'
            ),
            '.'
          );
        }
      }()
    ),
    !_ramda2.default.isNil(template.partnersCount) && _react2.default.createElement(
      'div',
      {
        style: {
          width: '70px',
          fontSize: '10px'
        }
      },
      template.partnersCount,
      ' ',
      (0, _pluralize2.default)('partner', template.partnersCount)
    ),
    _react2.default.createElement(
      'div',
      {
        style: {
          width: '130px',
          fontSize: '10px'
        }
      },
      _moment2.default.utc(template.startDate).format('DD MMM YYYY'),
      ' - ',
      _moment2.default.utc(template.endDate).format('DD MMM YYYY')
    ),
    _react2.default.createElement(
      'div',
      {
        style: {
          width: '65px',
          fontSize: '12px',
          textAlign: 'center',
          color: (0, _contractingUtils.getTemplateStatusColor)(state)
        }
      },
      state
    ),
    !makeItShorter && _react2.default.createElement(
      'div',
      {
        style: {
          fontSize: '12px',
          width: '65px',
          textAlign: 'right'
        }
      },
      (0, _moment2.default)(template.updatedAt).format('l')
    )
  );
};

var SimpleTemplateList = function SimpleTemplateList(props) {
  var templates = props.templates,
      selectOrUnselect = props.selectOrUnselect,
      isSingleLoc = props.isSingleLoc,
      makeItShorter = props.makeItShorter,
      push = props.push;

  if (!(templates && templates.length)) {
    return _react2.default.createElement(
      'div',
      null,
      'You don\'t have templates available.'
    );
  }
  if (isSingleLoc) {
    return _react2.default.createElement(
      'div',
      null,
      templates.map(function (template, templateIndex) {
        return _react2.default.createElement(SingleTemplate, {
          key: templateIndex,
          template: template,
          selectOrUnselect: selectOrUnselect,
          makeItShorter: makeItShorter,
          style: {
            padding: '16px',
            borderBottom: '1px solid #e0e0e0'
          }
        });
      })
    );
  }
  var groupByLocations = _ramda2.default.groupBy(_ramda2.default.prop('locationName'), templates);
  var allLocNames = _ramda2.default.keys(groupByLocations);
  return _react2.default.createElement(
    'div',
    null,
    allLocNames.map(function (locName, locIndex) {
      return _react2.default.createElement(
        _materialUi.Card,
        {
          key: '' + locIndex + locName,
          initiallyExpanded: true,
          style: { boxShadow: 'none', borderBottom: '1px solid #e0e0e0' }
        },
        _react2.default.createElement(_materialUi.CardHeader, {
          actAsExpander: true,
          style: { padding: '6px' },
          showExpandableButton: true,
          title: _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-location_on', color: 'rgba(0, 0, 0, 0.54)' }),
            locName || ''
          )
        }),
        _react2.default.createElement(
          _materialUi.CardText,
          { expandable: true },
          groupByLocations[locName].map(function (obj, templateIndex) {
            return _react2.default.createElement(SingleTemplate, {
              key: templateIndex,
              template: obj,
              push: push,
              selectOrUnselect: selectOrUnselect,
              makeItShorter: makeItShorter,
              style: { marginBottom: '8px' }
            });
          })
        )
      );
    })
  );
};

SimpleTemplateList.propTypes = {
  templates: _react2.default.PropTypes.array,
  selectOrUnselect: _react2.default.PropTypes.func,
  isSingleLoc: _react2.default.PropTypes.bool,
  makeItShorter: _react2.default.PropTypes.bool,
  push: _react2.default.PropTypes.func
};

exports.default = (0, _reactRedux.connect)(function (_ref) {
  var user = _ref.user;

  return {
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop'
  };
}, { push: _reactRouterRedux.push })(SimpleTemplateList);

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  topbar: {
    position: 'fixed',
    top: 0,
    width: '100%',
    backgroundColor: function backgroundColor(props) {
      if (props.doc) {
        if (props.doc.status === 'draft' || !props.doc.isLatest) {
          return '#455a64';
        }
      }
      return '#00838f';
    },
    color: '#fff',
    fontSize: '16px',
    lineHeight: '56px',
    height: '56px',
    padding: '0 32px',
    zIndex: 19
  },
  topBarTitle: {
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: 18
  },
  body: {
    padding: '60px 0'
  },
  subTitle: {
    padding: '0 10%',
    margin: '8px 12px',
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center'
  },
  content: {
    color: 'rgba(0, 0, 0, 0.74)',
    padding: '0 10%',
    borderTop: '1px solid #efefef'
  },
  topbarActions: function topbarActions(props) {
    var width = '52px';
    if (props.doc) {
      if (!props.doc.isLatest) {
        width = '52px';
      } else if (props.doc.status === 'draft') {
        width = '365px';
      } else {
        width = '550px';
      }
    }
    return {
      position: 'fixed',
      top: 10,
      right: 16,
      zIndex: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: width
    };
  },
  closeBtn: { cursor: 'pointer', marginLeft: '8px' },
  bottomBar: {
    position: 'fixed',
    left: 0,
    bottom: 0,
    width: '100%',
    color: '#fff',
    fontSize: '16px',
    height: '56px',
    padding: '0 30%',
    zIndex: 19,
    backgroundColor: '#78909c',
    '&.is-active': {
      backgroundColor: '#00838f'
    },
    justifyContent: 'center'
  },
  flatBtnLabelStyle: {
    textTransform: 'none',
    lineHeight: '30px',
    height: '30px',
    padding: '4px',
    verticalAlign: '',
    top: '-2px'
  },
  applyStepperLabel: {
    color: 'rgba(0, 0, 0, 0.74)',
    marginBottom: '24px',
    fontWeight: 'bold'
  }
};

/***/ }),
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = getDynamicStyles;
/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(89);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(1094);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isInBrowser = __webpack_require__(645);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(1097);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(1384);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(1385);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(1391);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(1392);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(907);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(545);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(1096);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(644);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(1393);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(1394);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.8.7";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(89);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(1386);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(1387);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(1388);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(1389);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(1390);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
var plugins = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var RuleClass = classes[key];
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new RuleClass(name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

exports['default'] = plugins;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(576);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(576);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(906);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(906);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(545);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(644);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(1094);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(576);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(545);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(644);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// A symbol replacement.
var now = Date.now();

var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[prop] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(89);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(907);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(545);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(643);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value = void 0;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
function getPropertyValue(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Remove a style property.
 */
function removeProperty(cssRule, prop) {
  try {
    cssRule.style.removeProperty(prop);
  } catch (err) {
    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
  }
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

/**
 * Read jss nonce setting from the page if the user has set it.
 */
var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setProperty',
    value: function setProperty() {
      return true;
    }
  }, {
    key: 'getPropertyValue',
    value: function getPropertyValue() {
      return '';
    }
  }, {
    key: 'removeProperty',
    value: function removeProperty() {}
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parse = __webpack_require__(1396);

var _parse2 = _interopRequireDefault(_parse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var onProcessRule = function onProcessRule(rule) {
  if (typeof rule.style === 'string') {
    rule.style = (0, _parse2['default'])(rule.style);
  }
};

exports['default'] = function () {
  return { onProcessRule: onProcessRule };
};

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(89);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var semiWithNl = /;\n/;

/**
 * Naive CSS parser.
 * - Supports only rule body (no selectors)
 * - Requires semicolon and new line after the value (except of last line)
 * - No nested rules support
 */

exports['default'] = function (cssText) {
  var style = {};
  var split = cssText.split(semiWithNl);
  for (var i = 0; i < split.length; i++) {
    var decl = (split[i] || '').trim();

    if (!decl) continue;
    var colonIndex = decl.indexOf(':');
    if (colonIndex === -1) {
      (0, _warning2['default'])(false, 'Malformed CSS string "%s"', decl);
      continue;
    }
    var prop = decl.substr(0, colonIndex).trim();
    var value = decl.substr(colonIndex + 1).trim();
    style[prop] = value;
  }
  return style;
};

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(1047);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = jssExtend;

var _warning = __webpack_require__(89);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isObject = function isObject(obj) {
  return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !Array.isArray(obj);
};
var valueNs = 'extendCurrValue' + Date.now();

function mergeExtend(style, rule, sheet, newStyle) {
  var extendType = _typeof(style.extend);
  // Extend using a rule name.
  if (extendType === 'string') {
    if (!sheet) return;
    var refRule = sheet.getRule(style.extend);
    if (!refRule) return;
    if (refRule === rule) {
      (0, _warning2['default'])(false, '[JSS] A rule tries to extend itself \r\n%s', rule);
      return;
    }
    var parent = refRule.options.parent;

    if (parent) {
      var originalStyle = parent.rules.raw[style.extend];
      extend(originalStyle, rule, sheet, newStyle);
    }
    return;
  }

  // Extend using an array of objects.
  if (Array.isArray(style.extend)) {
    for (var index = 0; index < style.extend.length; index++) {
      extend(style.extend[index], rule, sheet, newStyle);
    }
    return;
  }

  // Extend is a style object.
  for (var prop in style.extend) {
    if (prop === 'extend') {
      extend(style.extend.extend, rule, sheet, newStyle);
      continue;
    }
    if (isObject(style.extend[prop])) {
      if (!(prop in newStyle)) newStyle[prop] = {};
      extend(style.extend[prop], rule, sheet, newStyle[prop]);
      continue;
    }
    newStyle[prop] = style.extend[prop];
  }
}

function mergeRest(style, rule, sheet, newStyle) {
  // Copy base style.
  for (var prop in style) {
    if (prop === 'extend') continue;
    if (isObject(newStyle[prop]) && isObject(style[prop])) {
      extend(style[prop], rule, sheet, newStyle[prop]);
      continue;
    }

    if (isObject(style[prop])) {
      newStyle[prop] = extend(style[prop], rule, sheet);
      continue;
    }

    newStyle[prop] = style[prop];
  }
}

/**
 * Recursively extend styles.
 */
function extend(style, rule, sheet) {
  var newStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  mergeExtend(style, rule, sheet, newStyle);
  mergeRest(style, rule, sheet, newStyle);
  return newStyle;
}

/**
 * Handle `extend` property.
 *
 * @param {Rule} rule
 * @api public
 */
function jssExtend() {
  function onProcessStyle(style, rule, sheet) {
    if ('extend' in style) return extend(style, rule, sheet);
    return style;
  }

  function onChangeValue(value, prop, rule) {
    if (prop !== 'extend') return value;

    // Value is empty, remove properties set previously.
    if (value == null || value === false) {
      for (var key in rule[valueNs]) {
        rule.prop(key, null);
      }
      rule[valueNs] = null;
      return null;
    }

    for (var _key in value) {
      rule.prop(_key, value[_key]);
    }
    rule[valueNs] = value;

    // Make sure we don't set the value in the core.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(89);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = jssCompose;

var _warning = __webpack_require__(89);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Set selector.
 *
 * @param {Object} original rule
 * @param {String} className class string
 * @return {Boolean} flag, indicating function was successfull or not
 */
function registerClass(rule, className) {
  // Skip falsy values
  if (!className) return true;

  // Support array of class names `{composes: ['foo', 'bar']}`
  if (Array.isArray(className)) {
    for (var index = 0; index < className.length; index++) {
      var isSetted = registerClass(rule, className[index]);
      if (!isSetted) return false;
    }

    return true;
  }

  // Support space separated class names `{composes: 'foo bar'}`
  if (className.indexOf(' ') > -1) {
    return registerClass(rule, className.split(' '));
  }

  var parent = rule.options.parent;

  // It is a ref to a local rule.

  if (className[0] === '$') {
    var refRule = parent.getRule(className.substr(1));

    if (!refRule) {
      (0, _warning2.default)(false, '[JSS] Referenced rule is not defined. \r\n%s', rule);
      return false;
    }

    if (refRule === rule) {
      (0, _warning2.default)(false, '[JSS] Cyclic composition detected. \r\n%s', rule);
      return false;
    }

    parent.classes[rule.key] += ' ' + parent.classes[refRule.key];

    return true;
  }

  rule.options.parent.classes[rule.key] += ' ' + className;

  return true;
}

/**
 * Convert compose property to additional class, remove property from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssCompose() {
  function onProcessStyle(style, rule) {
    if (!style.composes) return style;
    registerClass(rule, style.composes);
    // Remove composes property to prevent infinite loop.
    delete style.composes;
    return style;
  }
  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelCase;

var _hyphenateStyleName = __webpack_require__(1083);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);

    // There was no camel case in place
    if (prop === hyphenatedProp) return value;

    rule.prop(hyphenatedProp, value);

    // Core will ignore that property value we set the proper one above.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(1403);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = jssExpand;

var _props = __webpack_require__(1405);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Map values by given prop.
 *
 * @param {Array} array of values
 * @param {String} original property
 * @param {String} original rule
 * @return {String} mapped values
 */
function mapValuesByProp(value, prop, rule) {
  return value.map(function (item) {
    return objectToArray(item, prop, rule, false, true);
  });
}

/**
 * Convert array to nested array, if needed
 *
 * @param {Array} array of values
 * @param {String} original property
 * @param {Object} sheme, for converting arrays in strings
 * @param {Object} original rule
 * @return {String} converted string
 */
function processArray(value, prop, scheme, rule) {
  if (scheme[prop] == null) return value;
  if (value.length === 0) return [];
  if (Array.isArray(value[0])) return processArray(value[0], prop, scheme);
  if (_typeof(value[0]) === 'object') {
    return mapValuesByProp(value, prop, rule);
  }

  return [value];
}

/**
 * Convert object to array.
 *
 * @param {Object} object of values
 * @param {String} original property
 * @param {Object} original rule
 * @param {Boolean} is fallback prop
 * @param {Boolean} object is inside array
 * @return {String} converted string
 */
function objectToArray(value, prop, rule, isFallback, isInArray) {
  if (!(_props.propObj[prop] || _props.customPropObj[prop])) return [];

  var result = [];

  // Check if exists any non-standart property
  if (_props.customPropObj[prop]) {
    value = customPropsToStyle(value, rule, _props.customPropObj[prop], isFallback);
  }

  // Pass throught all standart props
  if (Object.keys(value).length) {
    for (var baseProp in _props.propObj[prop]) {
      if (value[baseProp]) {
        if (Array.isArray(value[baseProp])) {
          result.push(_props.propArrayInObj[baseProp] === null ? value[baseProp] : value[baseProp].join(' '));
        } else result.push(value[baseProp]);
        continue;
      }

      // Add default value from props config.
      if (_props.propObj[prop][baseProp] != null) {
        result.push(_props.propObj[prop][baseProp]);
      }
    }
  }

  if (!result.length || isInArray) return result;
  return [result];
}

/**
 * Convert custom properties values to styles adding them to rule directly
 *
 * @param {Object} object of values
 * @param {Object} original rule
 * @param {String} property, that contain partial custom properties
 * @param {Boolean} is fallback prop
 * @return {Object} value without custom properties, that was already added to rule
 */
function customPropsToStyle(value, rule, customProps, isFallback) {
  for (var prop in customProps) {
    var propName = customProps[prop];

    // If current property doesn't exist already in rule - add new one
    if (typeof value[prop] !== 'undefined' && (isFallback || !rule.prop(propName))) {
      var appendedValue = styleDetector(_defineProperty({}, propName, value[prop]), rule)[propName];

      // Add style directly in rule
      if (isFallback) rule.style.fallbacks[propName] = appendedValue;else rule.style[propName] = appendedValue;
    }
    // Delete converted property to avoid double converting
    delete value[prop];
  }

  return value;
}

/**
 * Detect if a style needs to be converted.
 *
 * @param {Object} style
 * @param {Object} rule
 * @param {Boolean} is fallback prop
 * @return {Object} convertedStyle
 */
function styleDetector(style, rule, isFallback) {
  for (var prop in style) {
    var value = style[prop];

    if (Array.isArray(value)) {
      // Check double arrays to avoid recursion.
      if (!Array.isArray(value[0])) {
        if (prop === 'fallbacks') {
          for (var index = 0; index < style.fallbacks.length; index++) {
            style.fallbacks[index] = styleDetector(style.fallbacks[index], rule, true);
          }
          continue;
        }

        style[prop] = processArray(value, prop, _props.propArray);
        // Avoid creating properties with empty values
        if (!style[prop].length) delete style[prop];
      }
    } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      if (prop === 'fallbacks') {
        style.fallbacks = styleDetector(style.fallbacks, rule, true);
        continue;
      }

      style[prop] = objectToArray(value, prop, rule, isFallback);
      // Avoid creating properties with empty values
      if (!style[prop].length) delete style[prop];
    }

    // Maybe a computed value resulting in an empty string
    else if (style[prop] === '') delete style[prop];
  }

  return style;
}

/**
 * Adds possibility to write expanded styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssExpand() {
  function onProcessStyle(style, rule) {
    if (!style || rule.type !== 'style') return style;

    if (Array.isArray(style)) {
      // Pass rules one by one and reformat them
      for (var index = 0; index < style.length; index++) {
        style[index] = styleDetector(style[index], rule);
      }
      return style;
    }

    return styleDetector(style, rule);
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A scheme for converting properties from array to regular style.
 * All properties listed below will be transformed to a string separated by space.
 */
var propArray = exports.propArray = {
  'background-size': true,
  'background-position': true,
  border: true,
  'border-bottom': true,
  'border-left': true,
  'border-top': true,
  'border-right': true,
  'border-radius': true,
  'border-image': true,
  'border-width': true,
  'border-style': true,
  'border-color': true,
  'box-shadow': true,
  flex: true,
  margin: true,
  padding: true,
  outline: true,
  'transform-origin': true,
  transform: true,
  transition: true

  /**
   * A scheme for converting arrays to regular styles inside of objects.
   * For e.g.: "{position: [0, 0]}" => "background-position: 0 0;".
   */
};var propArrayInObj = exports.propArrayInObj = {
  position: true, // background-position
  size: true // background-size


  /**
   * A scheme for parsing and building correct styles from passed objects.
   */
};var propObj = exports.propObj = {
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  background: {
    attachment: null,
    color: null,
    image: null,
    position: null,
    repeat: null
  },
  border: {
    width: null,
    style: null,
    color: null
  },
  'border-top': {
    width: null,
    style: null,
    color: null
  },
  'border-right': {
    width: null,
    style: null,
    color: null
  },
  'border-bottom': {
    width: null,
    style: null,
    color: null
  },
  'border-left': {
    width: null,
    style: null,
    color: null
  },
  outline: {
    width: null,
    style: null,
    color: null
  },
  'list-style': {
    type: null,
    position: null,
    image: null
  },
  transition: {
    property: null,
    duration: null,
    'timing-function': null,
    timingFunction: null, // Needed for avoiding comilation issues with jss-camel-case
    delay: null
  },
  animation: {
    name: null,
    duration: null,
    'timing-function': null,
    timingFunction: null, // Needed to avoid compilation issues with jss-camel-case
    delay: null,
    'iteration-count': null,
    iterationCount: null, // Needed to avoid compilation issues with jss-camel-case
    direction: null,
    'fill-mode': null,
    fillMode: null, // Needed to avoid compilation issues with jss-camel-case
    'play-state': null,
    playState: null // Needed to avoid compilation issues with jss-camel-case
  },
  'box-shadow': {
    x: 0,
    y: 0,
    blur: 0,
    spread: 0,
    color: null,
    inset: null
  },
  'text-shadow': {
    x: 0,
    y: 0,
    blur: null,
    color: null
  }

  /**
   * A scheme for converting non-standart properties inside object.
   * For e.g.: include 'border-radius' property inside 'border' object.
   */
};var customPropObj = exports.customPropObj = {
  border: {
    radius: 'border-radius',
    image: 'border-image',
    width: 'border-width',
    style: 'border-style',
    color: 'border-color'
  },
  background: {
    size: 'background-size',
    image: 'background-image'
  },
  font: {
    style: 'font-style',
    variant: 'font-variant',
    weight: 'font-weight',
    stretch: 'font-stretch',
    size: 'font-size',
    family: 'font-family',
    lineHeight: 'line-height', // Needed to avoid compilation issues with jss-camel-case
    'line-height': 'line-height'
  },
  flex: {
    grow: 'flex-grow',
    basis: 'flex-basis',
    direction: 'flex-direction',
    wrap: 'flex-wrap',
    flow: 'flex-flow',
    shrink: 'flex-shrink'
  },
  align: {
    self: 'align-self',
    items: 'align-items',
    content: 'align-content'
  },
  grid: {
    'template-columns': 'grid-template-columns',
    templateColumns: 'grid-template-columns',

    'template-rows': 'grid-template-rows',
    templateRows: 'grid-template-rows',

    'template-areas': 'grid-template-areas',
    templateAreas: 'grid-template-areas',

    template: 'grid-template',

    'auto-columns': 'grid-auto-columns',
    autoColumns: 'grid-auto-columns',

    'auto-rows': 'grid-auto-rows',
    autoRows: 'grid-auto-rows',

    'auto-flow': 'grid-auto-flow',
    autoFlow: 'grid-auto-flow',

    row: 'grid-row',
    column: 'grid-column',

    'row-start': 'grid-row-start',
    rowStart: 'grid-row-start',
    'row-end': 'grid-row-end',
    rowEnd: 'grid-row-end',

    'column-start': 'grid-column-start',
    columnStart: 'grid-column-start',
    'column-end': 'grid-column-end',
    columnEnd: 'grid-column-end',

    area: 'grid-area',
    gap: 'grid-gap',

    'row-gap': 'grid-row-gap',
    rowGap: 'grid-row-gap',

    'column-gap': 'grid-column-gap',
    columnGap: 'grid-column-gap'
  }
};

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(1407);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(908);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(1408);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(1410);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(645);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(908);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(1409);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(645);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(908);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.user = user;

var _immutable = __webpack_require__(26);

var _userConstants = __webpack_require__(1098);

var constants = _interopRequireWildcard(_userConstants);

var _docCookie = __webpack_require__(142);

var _docCookie2 = _interopRequireDefault(_docCookie);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = (0, _immutable.Map)({
  user: {
    type: undefined,
    userID: undefined
  },
  company: {
    companySlugName: undefined,
    companyName: undefined,
    productType: undefined,
    phone: undefined,
    profileImageUrl: undefined,
    address: {},
    contactInformation: {},
    description: undefined,
    websiteUrl: undefined,
    companyTypes: [],
    countriesServed: [],
    segments: [],
    currency: '',
    taxInclusion: '',
    taxType: ''
  },
  locAccess: [],
  billingPlan: undefined,
  freeContractsUsedIds: [],
  upgradeSource: 'billingLink',
  firstName: undefined,
  lastName: undefined,
  userCountry: undefined,
  onBoardingStatus: undefined,
  isAnAdmin: false,
  isMarketingReady: false,
  pfSearches: 0,
  freeContractsLeft: 5,
  hasViewedContract: false,
  // notifications
  updatingNotification: false
});

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'ADD_LOCATION':
      return state.update('locAccess', function (locAccess) {
        return [].concat(_toConsumableArray(locAccess), [{
          locId: action.payload.locationId,
          admin: ['read', 'write'],
          contracting: ['read', 'write'],
          teams: ['admin', 'contracting'],
          property_name: action.payload.locationName
        }]);
      });
    case constants.UPDATE_USER_PROP:
      return state.merge((0, _immutable.Map)(action.payload));
    case constants.EDIT_NOTIFICATION_STARTING:
      return state.set('updatingNotification', true);
    case constants.EDIT_NOTIFICATION_FINISHED:
      return state.set('updatingNotification', false).set('notifications', action.payload.notifications);
    case constants.EDIT_NOTIFICATION_FAILED:
      return state.set('updatingNotification', false);
    case '[user]UPDATE_USER_LOC_ACCESS_WHEN_NEW_LOC_CREATED':
      return state.update('locAccess', function (locAccess) {
        var currentLocIds = locAccess.map(_ramda2.default.prop('locId'));
        var newIds = action.payload.filter(function (id) {
          return !_ramda2.default.contains(id, currentLocIds);
        });
        return _ramda2.default.concat(locAccess, newIds.map(function (id) {
          return { locId: id, admin: ['read', 'write'], contracting: ['read', 'write'], teams: ['admin', 'contracting'] };
        }));
      });
    case 'ADD_CREDIT_CARD':
      return state.setIn(['company', 'authorizeNet'], !state.getIn(['company', 'authorizeNet']));
    case 'UPDATE_ADD_RATES_FIELD':
      if (['currency', 'taxInclusion', 'taxType'].indexOf(action.payload.fieldName) === -1) return state;
      return state.update('company', function (company) {
        return company.merge((0, _immutable.fromJS)(_defineProperty({}, action.payload.fieldName, action.payload.value)));
      });
    case 'SET_MARKET_READINESS_FOR_USER_STORE':
      if (!state.get('isMarketingReady')) {
        return state.merge({ 'isMarketingReady': true });
      }
      return state;
    case 'LOG_OUT':
    case 'CLEAR_STORES':
      if (action.payload && action.payload.isForAdmin) return state.set('authToken', action.payload.authToken);
      return initialState;
    case 'PROFILE_IMAGE_CHANGED':
      return state.setIn(['company', 'profileImageUrl'], action.payload);
    case 'USER_STORE_PLAN_UPDATE':
      return state.set('billingPlan', action.payload.plan).setIn(['company', 'plan'], action.payload.plan);
    case 'ONBOARDING_COMPLETE':
      return state.set('onBoardingStatus', 'complete');
    case 'UPDATE_UPGRADE_SOURCE':
      return state.set('upgradeSource', action.payload);
    case 'GET_COMPANY':
      return state.set('billingPlan', action.payload.plan).set('company', action.payload);
    case 'GET_USER':
      var payload = action.user || {};
      return state.merge((0, _immutable.Map)(payload)).set('billingPlan', payload.company.plan).set('user', (0, _immutable.Map)(payload.user)).set('company', (0, _immutable.Map)(payload.company)).set('isAnAdmin', payload.isAnAdmin || _docCookie2.default.getItem('isAnAdmin') === 'true');
    case 'ADD_SEARCH_COUNT':
      var pfSearches = state.get('pfSearches') + 1;
      return state.set('pfSearches', pfSearches);
    case 'UPDATE_SEARCH_COUNT_DB':
      return state.set('pfSearches', 0);
    case 'USED_AS_FREE_BY_CONTRACTOR':
      return state.update('freeContractsLeft', _ramda.dec).update('freeContractsUsedIds', (0, _ramda.append)(action.payload.contractId));
    case 'CONTRACT_DRAFT_PUSHLISHED':
      return state.update('freeContractsLeft', (0, _ramda.subtract)(_ramda.__, action.payload.freeContractsToDecrement));
    case 'DOWNLOAD_CONTRACT_PDF_FOR_SHELL':
      return state.set('hasViewedContract', true);
    case 'UPDATE_PROFILE_PROP':
      var onBoardingStatus = (0, _ramda.path)(['payload', 'onBoardingStatus'], action);
      if (onBoardingStatus) return state.set('onBoardingStatus', onBoardingStatus);
      return state;
    case '{admin} toggleTCVerified_SUCCESS':
      return state.set('company', _extends({}, state.get('company'), {
        tourConnectVerified: action.payload.newStatus
      }));
    case 'updateUIpreferences_SUCCESS':
      return state.setIn(['user', 'UIpreferences'], action.args[0]);
    default:
      return state;
  }
}

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.publicNotifications = publicNotifications;

var _constants = __webpack_require__(1212);

var constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
  activity: { sharedMM: [] },
  connections: { request: [] },
  contracting: { newMessage: [], updates: [] },
  workspaceNotifications: { message: [], bulkmessage: [] },
  weekly: {},
  email: '',
  unsubscribeAllChecked: false,
  showUnsubscribeFeedback: false,
  unsubscribeRadioSelected: '',
  unsubscribeReason: '',
  showThankYouForFeedback: false,

  // loaders
  loadingNotifications: false,
  savingNotifications: false,
  savingUnsubscribeReason: false
};

function publicNotifications() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case constants.UPDATE_PUBLIC_NOTIFICATION_PROP:
      return _extends({}, state, payload);
    case constants.GET_PS_STARTING:
      return _extends({}, state, { loadingNotifications: true });
    case constants.GET_PS_FINISHED:
      return _extends({}, state, payload, { loadingNotifications: false });
    case constants.GET_PS_FAILED:
      return _extends({}, state, { loadingNotifications: false });
    case constants.EDIT_NOTI_STARTING:
      return _extends({}, state, { savingNotifications: true });
    case constants.EDIT_NOTI_FINISHED:
      return _extends({}, state, payload, {
        showUnsubscribeFeedback: state.unsubscribeAllChecked,
        savingNotifications: false
      });
    case constants.EDIT_NOTI_FAILED:
      return _extends({}, state, { savingNotifications: false });
    case constants.SUBMIT_UNSUBSCRIBE_STARTING:
      return _extends({}, state, { savingUnsubscribeReason: false });
    case constants.SUBMIT_UNSUBSCRIBE_FINISHED:
      return _extends({}, state, {
        savingUnsubscribeReason: false,
        showUnsubscribeFeedback: false,
        showThankYouForFeedback: false
      });
    case constants.SUBMIT_UNSUBSCRIBE_FAILED:
      return _extends({}, state, {
        savingUnsubscribeReason: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (modelName, model) {
  return (0, _validator2.default)(model, conditions[modelName], modelName);
};

var _validator = __webpack_require__(2658);

var _validator2 = _interopRequireDefault(_validator);

var _location = __webpack_require__(2659);

var _location2 = _interopRequireDefault(_location);

var _product = __webpack_require__(2660);

var _product2 = _interopRequireDefault(_product);

var _profile = __webpack_require__(2661);

var _profile2 = _interopRequireDefault(_profile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var conditions = {
  location: _location2.default,
  product: _product2.default,
  profile: _profile2.default
};

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ramda = __webpack_require__(2);

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isValidNumber = R.both(R.is(Number), R.complement(R.equals(NaN)));

var validateContacts = function validateContacts(contacts, types) {
  contacts.forEach(function (contact) {
    if (contact.firstName && contact.lastName && contact.email && contact.phone && contact.type) {
      types[contact.type] = true;
    }
  });
  return Object.keys(types).filter(function (key) {
    return !types[key];
  }).map(function (key) {
    return {
      value: 1,
      warning: 'Add a ' + key + ' contact.',
      scrollTo: function (_scrollTo) {
        function scrollTo() {
          return _scrollTo.apply(this, arguments);
        }

        scrollTo.toString = function () {
          return _scrollTo.toString();
        };

        return scrollTo;
      }(function () {
        var scrollToAnchor = function scrollToAnchor() {
          var element = document.querySelector('#contactsNode');
          if (element) scrollTo('#contactsNode', { offset: -70 });
        };
        scrollToAnchor();
      })
    };
  });
};

exports.default = {
  String: function String(value) {
    if (typeof value !== 'string' || value === '') return false;
  },
  Number: function Number(value) {
    if (typeof value !== 'number') return false;
  },
  Contact: function Contact(contacts) {
    if (contacts && contacts.length) return true;
    return false;
  },
  LocationContact: function LocationContact(contacts) {
    if (contacts && contacts.length) return true;
    return false;
  },
  Address: function Address(address) {
    if ((typeof address === 'undefined' ? 'undefined' : _typeof(address)) !== 'object' || !address.addressOne) return false;
  },
  BeddingConfig: function BeddingConfig(_ref) {
    var rooms = _ref.rooms;

    return !R.isNil(rooms) && !R.isEmpty(rooms) && R.call(R.compose(R.all(R.allPass([R.has('bedType'), R.has('count')])), R.flatten), rooms);
  },
  Rating: function Rating(rating, model) {
    if (model.productType !== 'accommodation') return undefined;else if ((typeof rating === 'undefined' ? 'undefined' : _typeof(rating)) !== 'object' || typeof rating.value !== 'number' || typeof rating.type !== 'string') return false;
  },
  Exact: function Exact(expected, value) {
    if (expected !== value) return false;
  },
  Array: function (_Array) {
    function Array(_x) {
      return _Array.apply(this, arguments);
    }

    Array.toString = function () {
      return _Array.toString();
    };

    return Array;
  }(function (value) {
    if (!Array.isArray(value) || !value.length) return false;
  }),
  roomCountInfo: function roomCountInfo(_roomCountInfo) {
    if ((typeof _roomCountInfo === 'undefined' ? 'undefined' : _typeof(_roomCountInfo)) !== 'object' || !_roomCountInfo.unit) return false;
  },
  tourDuration: function tourDuration(_tourDuration, model) {
    if ((typeof _tourDuration === 'undefined' ? 'undefined' : _typeof(_tourDuration)) !== 'object') return false;
    if (model.tourDurationDoesNotApply) return true;
    if (_tourDuration.unit !== undefined && _tourDuration.value !== undefined && _tourDuration.value !== 0) return true;
    if (_tourDuration.value === 0) return false;
    if ((typeof _tourDuration === 'undefined' ? 'undefined' : _typeof(_tourDuration)) !== 'object' || !_tourDuration.unit) return false;
    return false;
  },
  productInfo: function productInfo(_productInfo) {
    if ((typeof _productInfo === 'undefined' ? 'undefined' : _typeof(_productInfo)) !== 'object' || typeof _productInfo.include !== 'string' || _productInfo.include === '' || typeof _productInfo.exclude !== 'string' || _productInfo.exclude === '' || typeof _productInfo.whatToBring !== 'string' || _productInfo.whatToBring === '') {
      return false;
    }
  },
  totalMaxPassengers: function totalMaxPassengers(val) {
    return isValidNumber(parseInt(val, 10));
  },
  totalMinPassengers: function totalMinPassengers(val) {
    return isValidNumber(parseInt(val, 10));
  }
};

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scrollToElement = __webpack_require__(859);

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  scrollToFunc: function scrollToFunc(hash) {
    var scrollToAnchor = function scrollToAnchor() {
      var element = document.querySelector(hash);
      if (element) (0, _scrollToElement2.default)(hash, { offset: -70 });
    };
    scrollToAnchor();
  }
};

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Tween = __webpack_require__(1418);
var raf = __webpack_require__(1423);

/**
 * Expose `scrollTo`.
 */

module.exports = scrollTo;

/**
 * Scroll to `(x, y)`.
 *
 * @param {Number} x
 * @param {Number} y
 * @api public
 */

function scrollTo(x, y, options) {
  options = options || {};

  // start position
  var start = scroll();

  // setup tween
  var tween = Tween(start)
    .ease(options.ease || 'out-circ')
    .to({ top: y, left: x })
    .duration(options.duration || 1000);

  // scroll
  tween.update(function(o){
    window.scrollTo(o.left | 0, o.top | 0);
  });

  // handle end
  tween.on('end', function(){
    animate = function(){};
  });

  // animate
  function animate() {
    raf(animate);
    tween.update();
  }

  animate();
  
  return tween;
}

/**
 * Return scroll position.
 *
 * @return {Object}
 * @api private
 */

function scroll() {
  var y = window.pageYOffset || document.documentElement.scrollTop;
  var x = window.pageXOffset || document.documentElement.scrollLeft;
  return { top: y, left: x };
}


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var Emitter = __webpack_require__(1419);
var clone = __webpack_require__(1420);
var type = __webpack_require__(1421);
var ease = __webpack_require__(1422);

/**
 * Expose `Tween`.
 */

module.exports = Tween;

/**
 * Initialize a new `Tween` with `obj`.
 *
 * @param {Object|Array} obj
 * @api public
 */

function Tween(obj) {
  if (!(this instanceof Tween)) return new Tween(obj);
  this._from = obj;
  this.ease('linear');
  this.duration(500);
}

/**
 * Mixin emitter.
 */

Emitter(Tween.prototype);

/**
 * Reset the tween.
 *
 * @api public
 */

Tween.prototype.reset = function(){
  this.isArray = 'array' === type(this._from);
  this._curr = clone(this._from);
  this._done = false;
  this._start = Date.now();
  return this;
};

/**
 * Tween to `obj` and reset internal state.
 *
 *    tween.to({ x: 50, y: 100 })
 *
 * @param {Object|Array} obj
 * @return {Tween} self
 * @api public
 */

Tween.prototype.to = function(obj){
  this.reset();
  this._to = obj;
  return this;
};

/**
 * Set duration to `ms` [500].
 *
 * @param {Number} ms
 * @return {Tween} self
 * @api public
 */

Tween.prototype.duration = function(ms){
  this._duration = ms;
  return this;
};

/**
 * Set easing function to `fn`.
 *
 *    tween.ease('in-out-sine')
 *
 * @param {String|Function} fn
 * @return {Tween}
 * @api public
 */

Tween.prototype.ease = function(fn){
  fn = 'function' == typeof fn ? fn : ease[fn];
  if (!fn) throw new TypeError('invalid easing function');
  this._ease = fn;
  return this;
};

/**
 * Stop the tween and immediately emit "stop" and "end".
 *
 * @return {Tween}
 * @api public
 */

Tween.prototype.stop = function(){
  this.stopped = true;
  this._done = true;
  this.emit('stop');
  this.emit('end');
  return this;
};

/**
 * Perform a step.
 *
 * @return {Tween} self
 * @api private
 */

Tween.prototype.step = function(){
  if (this._done) return;

  // duration
  var duration = this._duration;
  var now = Date.now();
  var delta = now - this._start;
  var done = delta >= duration;

  // complete
  if (done) {
    this._from = this._to;
    this._update(this._to);
    this._done = true;
    this.emit('end');
    return this;
  }

  // tween
  var from = this._from;
  var to = this._to;
  var curr = this._curr;
  var fn = this._ease;
  var p = (now - this._start) / duration;
  var n = fn(p);

  // array
  if (this.isArray) {
    for (var i = 0; i < from.length; ++i) {
      curr[i] = from[i] + (to[i] - from[i]) * n;
    }

    this._update(curr);
    return this;
  }

  // objech
  for (var k in from) {
    curr[k] = from[k] + (to[k] - from[k]) * n;
  }

  this._update(curr);
  return this;
};

/**
 * Set update function to `fn` or
 * when no argument is given this performs
 * a "step".
 *
 * @param {Function} fn
 * @return {Tween} self
 * @api public
 */

Tween.prototype.update = function(fn){
  if (0 == arguments.length) return this.step();
  this._update = fn;
  return this;
};

/***/ }),
/* 1419 */
/***/ (function(module, exports) {


/**
 * Expose `Emitter`.
 */

module.exports = Emitter;

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var type;
try {
  type = __webpack_require__(1099);
} catch (_) {
  type = __webpack_require__(1099);
}

/**
 * Module exports.
 */

module.exports = clone;

/**
 * Clones objects.
 *
 * @param {Mixed} any object
 * @api public
 */

function clone(obj){
  switch (type(obj)) {
    case 'object':
      var copy = {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          copy[key] = clone(obj[key]);
        }
      }
      return copy;

    case 'array':
      var copy = new Array(obj.length);
      for (var i = 0, l = obj.length; i < l; i++) {
        copy[i] = clone(obj[i]);
      }
      return copy;

    case 'regexp':
      // from millermedeiros/amd-utils - MIT
      var flags = '';
      flags += obj.multiline ? 'm' : '';
      flags += obj.global ? 'g' : '';
      flags += obj.ignoreCase ? 'i' : '';
      return new RegExp(obj.source, flags);

    case 'date':
      return new Date(obj.getTime());

    default: // string, number, boolean, …
      return obj;
  }
}


/***/ }),
/* 1421 */
/***/ (function(module, exports) {

/**
 * toString ref.
 */

var toString = Object.prototype.toString;

/**
 * Return the type of `val`.
 *
 * @param {Mixed} val
 * @return {String}
 * @api public
 */

module.exports = function(val){
  switch (toString.call(val)) {
    case '[object Date]': return 'date';
    case '[object RegExp]': return 'regexp';
    case '[object Arguments]': return 'arguments';
    case '[object Array]': return 'array';
    case '[object Error]': return 'error';
  }

  if (val === null) return 'null';
  if (val === undefined) return 'undefined';
  if (val !== val) return 'nan';
  if (val && val.nodeType === 1) return 'element';

  val = val.valueOf
    ? val.valueOf()
    : Object.prototype.valueOf.apply(val)

  return typeof val;
};


/***/ }),
/* 1422 */
/***/ (function(module, exports) {


// easing functions from "Tween.js"

exports.linear = function(n){
  return n;
};

exports.inQuad = function(n){
  return n * n;
};

exports.outQuad = function(n){
  return n * (2 - n);
};

exports.inOutQuad = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n;
  return - 0.5 * (--n * (n - 2) - 1);
};

exports.inCube = function(n){
  return n * n * n;
};

exports.outCube = function(n){
  return --n * n * n + 1;
};

exports.inOutCube = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n * n;
  return 0.5 * ((n -= 2 ) * n * n + 2);
};

exports.inQuart = function(n){
  return n * n * n * n;
};

exports.outQuart = function(n){
  return 1 - (--n * n * n * n);
};

exports.inOutQuart = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n * n * n;
  return -0.5 * ((n -= 2) * n * n * n - 2);
};

exports.inQuint = function(n){
  return n * n * n * n * n;
}

exports.outQuint = function(n){
  return --n * n * n * n * n + 1;
}

exports.inOutQuint = function(n){
  n *= 2;
  if (n < 1) return 0.5 * n * n * n * n * n;
  return 0.5 * ((n -= 2) * n * n * n * n + 2);
};

exports.inSine = function(n){
  return 1 - Math.cos(n * Math.PI / 2 );
};

exports.outSine = function(n){
  return Math.sin(n * Math.PI / 2);
};

exports.inOutSine = function(n){
  return .5 * (1 - Math.cos(Math.PI * n));
};

exports.inExpo = function(n){
  return 0 == n ? 0 : Math.pow(1024, n - 1);
};

exports.outExpo = function(n){
  return 1 == n ? n : 1 - Math.pow(2, -10 * n);
};

exports.inOutExpo = function(n){
  if (0 == n) return 0;
  if (1 == n) return 1;
  if ((n *= 2) < 1) return .5 * Math.pow(1024, n - 1);
  return .5 * (-Math.pow(2, -10 * (n - 1)) + 2);
};

exports.inCirc = function(n){
  return 1 - Math.sqrt(1 - n * n);
};

exports.outCirc = function(n){
  return Math.sqrt(1 - (--n * n));
};

exports.inOutCirc = function(n){
  n *= 2
  if (n < 1) return -0.5 * (Math.sqrt(1 - n * n) - 1);
  return 0.5 * (Math.sqrt(1 - (n -= 2) * n) + 1);
};

exports.inBack = function(n){
  var s = 1.70158;
  return n * n * (( s + 1 ) * n - s);
};

exports.outBack = function(n){
  var s = 1.70158;
  return --n * n * ((s + 1) * n + s) + 1;
};

exports.inOutBack = function(n){
  var s = 1.70158 * 1.525;
  if ( ( n *= 2 ) < 1 ) return 0.5 * ( n * n * ( ( s + 1 ) * n - s ) );
  return 0.5 * ( ( n -= 2 ) * n * ( ( s + 1 ) * n + s ) + 2 );
};

exports.inBounce = function(n){
  return 1 - exports.outBounce(1 - n);
};

exports.outBounce = function(n){
  if ( n < ( 1 / 2.75 ) ) {
    return 7.5625 * n * n;
  } else if ( n < ( 2 / 2.75 ) ) {
    return 7.5625 * ( n -= ( 1.5 / 2.75 ) ) * n + 0.75;
  } else if ( n < ( 2.5 / 2.75 ) ) {
    return 7.5625 * ( n -= ( 2.25 / 2.75 ) ) * n + 0.9375;
  } else {
    return 7.5625 * ( n -= ( 2.625 / 2.75 ) ) * n + 0.984375;
  }
};

exports.inOutBounce = function(n){
  if (n < .5) return exports.inBounce(n * 2) * .5;
  return exports.outBounce(n * 2 - 1) * .5 + .5;
};

// aliases

exports['in-quad'] = exports.inQuad;
exports['out-quad'] = exports.outQuad;
exports['in-out-quad'] = exports.inOutQuad;
exports['in-cube'] = exports.inCube;
exports['out-cube'] = exports.outCube;
exports['in-out-cube'] = exports.inOutCube;
exports['in-quart'] = exports.inQuart;
exports['out-quart'] = exports.outQuart;
exports['in-out-quart'] = exports.inOutQuart;
exports['in-quint'] = exports.inQuint;
exports['out-quint'] = exports.outQuint;
exports['in-out-quint'] = exports.inOutQuint;
exports['in-sine'] = exports.inSine;
exports['out-sine'] = exports.outSine;
exports['in-out-sine'] = exports.inOutSine;
exports['in-expo'] = exports.inExpo;
exports['out-expo'] = exports.outExpo;
exports['in-out-expo'] = exports.inOutExpo;
exports['in-circ'] = exports.inCirc;
exports['out-circ'] = exports.outCirc;
exports['in-out-circ'] = exports.inOutCirc;
exports['in-back'] = exports.inBack;
exports['out-back'] = exports.outBack;
exports['in-out-back'] = exports.inOutBack;
exports['in-bounce'] = exports.inBounce;
exports['out-bounce'] = exports.outBounce;
exports['in-out-bounce'] = exports.inOutBounce;


/***/ }),
/* 1423 */
/***/ (function(module, exports) {

/**
 * Expose `requestAnimationFrame()`.
 */

exports = module.exports = window.requestAnimationFrame
  || window.webkitRequestAnimationFrame
  || window.mozRequestAnimationFrame
  || fallback;

/**
 * Fallback implementation.
 */

var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime();
  var ms = Math.max(0, 16 - (curr - prev));
  var req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

/**
 * Cancel.
 */

var cancel = window.cancelAnimationFrame
  || window.webkitCancelAnimationFrame
  || window.mozCancelAnimationFrame
  || window.clearTimeout;

exports.cancel = function(id){
  cancel.call(window, id);
};


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentContentPaste = function ContentContentPaste(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z' })
  );
};
ContentContentPaste = (0, _pure2.default)(ContentContentPaste);
ContentContentPaste.displayName = 'ContentContentPaste';
ContentContentPaste.muiName = 'SvgIcon';

exports.default = ContentContentPaste;

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowUpward = function NavigationArrowUpward(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z' })
  );
};
NavigationArrowUpward = (0, _pure2.default)(NavigationArrowUpward);
NavigationArrowUpward.displayName = 'NavigationArrowUpward';
NavigationArrowUpward.muiName = 'SvgIcon';

exports.default = NavigationArrowUpward;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowDownward = function NavigationArrowDownward(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z' })
  );
};
NavigationArrowDownward = (0, _pure2.default)(NavigationArrowDownward);
NavigationArrowDownward.displayName = 'NavigationArrowDownward';
NavigationArrowDownward.muiName = 'SvgIcon';

exports.default = NavigationArrowDownward;

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createThemeProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_function__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_function___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_is_function__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_is_plain_object__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_is_plain_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_is_plain_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__channel__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brcast__ = __webpack_require__(1433);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * Provide a theme to an entire react component tree via context
 * and event listeners (have to do both context
 * and event emitter as pure components block context updates)
 */

function createThemeProvider() {
  var _class, _temp2;

  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__channel__["a" /* default */];

  return _temp2 = _class = function (_React$Component) {
    _inherits(ThemeProvider, _React$Component);

    function ThemeProvider() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ThemeProvider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThemeProvider.__proto__ || Object.getPrototypeOf(ThemeProvider)).call.apply(_ref, [this].concat(args))), _this), _this.broadcast = Object(__WEBPACK_IMPORTED_MODULE_5_brcast__["a" /* default */])(_this.getTheme()), _this.setOuterTheme = function (theme) {
        _this.outerTheme = theme;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ThemeProvider, [{
      key: 'getTheme',


      // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
      value: function getTheme(passedTheme) {
        var theme = passedTheme || this.props.theme;
        if (__WEBPACK_IMPORTED_MODULE_2_is_function___default()(theme)) {
          var mergedTheme = theme(this.outerTheme);
          if (!__WEBPACK_IMPORTED_MODULE_3_is_plain_object___default()(mergedTheme)) {
            throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
          }
          return mergedTheme;
        }
        if (!__WEBPACK_IMPORTED_MODULE_3_is_plain_object___default()(theme)) {
          throw new Error('[ThemeProvider] Please make your theme prop a plain object');
        }

        if (!this.outerTheme) {
          return theme;
        }

        return _extends({}, this.outerTheme, theme);
      }
    }, {
      key: 'getChildContext',
      value: function getChildContext() {
        return _defineProperty({}, CHANNEL, this.broadcast);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        // create a new subscription for keeping track of outer theme, if present
        if (this.context[CHANNEL]) {
          this.subscriptionId = this.context[CHANNEL].subscribe(this.setOuterTheme);
        }
      }

      // set broadcast state by merging outer theme with own

    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        if (this.context[CHANNEL]) {
          this.setOuterTheme(this.context[CHANNEL].getState());
          this.broadcast.setState(this.getTheme());
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.theme !== nextProps.theme) {
          this.broadcast.setState(this.getTheme(nextProps.theme));
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.subscriptionId !== undefined) {
          this.context[CHANNEL].unsubscribe(this.subscriptionId);
          delete this.subscriptionId;
        }
      }
    }, {
      key: 'render',
      value: function render() {
        if (!this.props.children) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(this.props.children);
      }
    }]);

    return ThemeProvider;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
    theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]).isRequired
  }, _class.childContextTypes = _defineProperty({}, CHANNEL, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired), _class.contextTypes = _defineProperty({}, CHANNEL, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object), _temp2;
}

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1429);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1430 */
/***/ (function(module, exports) {

module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(1432);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createBroadcast (initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState () {
    return _state
  }

  function setState (state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) { listeners[keys[i]](state); }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe (listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.')
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId
  }

  // remove subscription by removing the listener function
  function unsubscribe (id) {
    listeners[id] = undefined;
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
}

/* harmony default export */ __webpack_exports__["a"] = (createBroadcast);


/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWithTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_theme_listener__ = __webpack_require__(1102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
};

function createWithTheme() {
  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__channel__["a" /* default */];

  var themeListener = Object(__WEBPACK_IMPORTED_MODULE_2__create_theme_listener__["a" /* default */])(CHANNEL);
  return function (Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
      _inherits(WithTheme, _React$Component);

      function WithTheme(props, context) {
        _classCallCheck(this, WithTheme);

        var _this = _possibleConstructorReturn(this, (WithTheme.__proto__ || Object.getPrototypeOf(WithTheme)).call(this, props, context));

        _this.state = { theme: themeListener.initial(context) };
        _this.setTheme = function (theme) {
          return _this.setState({ theme: theme });
        };
        return _this;
      }

      _createClass(WithTheme, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.unsubscribe = themeListener.subscribe(this.context, this.setTheme);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof this.unsubscribe === 'function') {
            this.unsubscribe();
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var theme = this.state.theme;


          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({ theme: theme }, this.props));
        }
      }]);

      return WithTheme;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'WithTheme(' + getDisplayName(Component) + ')', _class.contextTypes = themeListener.contextTypes, _temp;
  };
}

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(651);

var _jss = __webpack_require__(910);

var _ns = __webpack_require__(911);

var ns = _interopRequireWildcard(_ns);

var _contextTypes = __webpack_require__(1103);

var _contextTypes2 = _interopRequireDefault(_contextTypes);

var _propTypes2 = __webpack_require__(1104);

var _propTypes3 = _interopRequireDefault(_propTypes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JssProvider = function (_Component) {
  _inherits(JssProvider, _Component);

  function JssProvider() {
    _classCallCheck(this, JssProvider);

    return _possibleConstructorReturn(this, (JssProvider.__proto__ || Object.getPrototypeOf(JssProvider)).apply(this, arguments));
  }

  _createClass(JssProvider, [{
    key: 'getChildContext',


    // JssProvider can be nested. We allow to overwrite any context prop at any level.
    // 1. Check if there is a value passed over props.
    // 2. If value was passed, we set it on the child context.
    // 3. If value was not passed, we proxy parent context (default context behaviour).
    value: function getChildContext() {
      var _props = this.props,
          registry = _props.registry,
          classNamePrefix = _props.classNamePrefix,
          localJss = _props.jss,
          generateClassName = _props.generateClassName,
          disableStylesGeneration = _props.disableStylesGeneration;

      var sheetOptions = this.context[ns.sheetOptions] || {};
      var context = _defineProperty({}, ns.sheetOptions, sheetOptions);

      if (registry) {
        context[ns.sheetsRegistry] = registry;
        // This way we identify a new request on the server, because user will create
        // a new Registry instance for each.
        if (registry !== this.registry) {
          // We reset managers because we have to regenerate all sheets for the new request.
          this.managers = {};
          this.registry = registry;
        }
      }

      // Make sure we don't loose managers when JssProvider is used inside of a stateful
      // component which decides to rerender.
      context[ns.managers] = this.managers;

      if (generateClassName) {
        sheetOptions.generateClassName = generateClassName;
      } else if (!sheetOptions.generateClassName) {
        if (!this.generateClassName) {
          var createGenerateClassName = _jss.createGenerateClassNameDefault;
          if (localJss && localJss.options.createGenerateClassName) {
            createGenerateClassName = localJss.options.createGenerateClassName;
          }
          // Make sure we don't loose the generator when JssProvider is used inside of a stateful
          // component which decides to rerender.
          this.generateClassName = createGenerateClassName();
        }

        sheetOptions.generateClassName = this.generateClassName;
      }

      if (classNamePrefix) sheetOptions.classNamePrefix = classNamePrefix;
      if (localJss) context[ns.jss] = localJss;
      if (disableStylesGeneration !== undefined) {
        sheetOptions.disableStylesGeneration = disableStylesGeneration;
      }

      return context;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return JssProvider;
}(_react.Component);

JssProvider.propTypes = _extends({}, _propTypes3['default'], {
  generateClassName: _propTypes.func,
  classNamePrefix: _propTypes.string,
  disableStylesGeneration: _propTypes.bool,
  children: _propTypes.node.isRequired
});
JssProvider.childContextTypes = _contextTypes2['default'];
JssProvider.contextTypes = _contextTypes2['default'];
exports['default'] = JssProvider;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1437);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = injectSheet;

var _hoistNonReactStatics = __webpack_require__(1439);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _createHoc = __webpack_require__(1440);

var _createHoc2 = _interopRequireDefault(_createHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Global index counter to preserve source order.
 * As we create the style sheet during componentWillMount lifecycle,
 * children are handled after the parents, so the order of style elements would
 * be parent->child. It is a problem though when a parent passes a className
 * which needs to override any childs styles. StyleSheet of the child has a higher
 * specificity, because of the source order.
 * So our solution is to render sheets them in the reverse order child->sheet, so
 * that parent has a higher specificity.
 *
 * @type {Number}
 */
var indexCounter = -100000;

var NoRenderer = function NoRenderer(_ref) {
  var children = _ref.children;
  return children || null;
};

/**
 * HOC creator function that wrapps the user component.
 *
 * `injectSheet(styles, [options])(Component)`
 *
 * @api public
 */
function injectSheet(stylesOrSheet) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (options.index === undefined) {
    options.index = indexCounter++;
  }
  return function () {
    var InnerComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NoRenderer;

    var Jss = (0, _createHoc2['default'])(stylesOrSheet, InnerComponent, options);
    return (0, _hoistNonReactStatics2['default'])(Jss, InnerComponent, { inner: true });
  };
}

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(651);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _theming = __webpack_require__(1100);

var _theming2 = _interopRequireDefault(_theming);

var _jss = __webpack_require__(910);

var _jss2 = _interopRequireDefault(_jss);

var _compose = __webpack_require__(1441);

var _compose2 = _interopRequireDefault(_compose);

var _getDisplayName = __webpack_require__(1442);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _ns = __webpack_require__(911);

var ns = _interopRequireWildcard(_ns);

var _contextTypes = __webpack_require__(1103);

var _contextTypes2 = _interopRequireDefault(_contextTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var env = "production";

// Like a Symbol
var dynamicStylesNs = Math.random();

/*
 * # Use cases
 *
 * - Unthemed component accepts styles object
 * - Themed component accepts styles creator function which takes theme as a single argument
 * - Multiple instances will re-use the same static sheet via sheets manager
 * - Sheet manager identifies static sheets by theme as a key
 * - For unthemed components theme is an empty object
 * - The very first instance will add static sheet to sheets manager
 * - Every further instances will get that static sheet from sheet manager
 * - Every mount of every instance will call method `sheetsManager.manage`,
 * thus incrementing reference counter.
 * - Every unmount of every instance will call method `sheetsManager.unmanage`,
 * thus decrementing reference counter.
 * - `sheetsManager.unmanage` under the hood will detach static sheet once reference
 * counter is zero.
 * - Dynamic styles are not shared between instances
 *
 */

var getStyles = function getStyles(stylesOrCreator, theme) {
  if (typeof stylesOrCreator !== 'function') {
    return stylesOrCreator;
  }
  return stylesOrCreator(theme);
};

// Returns an object with array property as a key and true as a value.
var toMap = function toMap(arr) {
  return arr.reduce(function (map, prop) {
    map[prop] = true;
    return map;
  }, {});
};

var defaultInjectProps = {
  sheet: false,
  classes: true,
  theme: true
};

var managersCounter = 0;

/**
 * Wrap a Component into a JSS Container Component.
 *
 * @param {Object|Function} stylesOrCreator
 * @param {Component} InnerComponent
 * @param {Object} [options]
 * @return {Component}
 */

exports['default'] = function (stylesOrCreator, InnerComponent) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var isThemingEnabled = typeof stylesOrCreator === 'function';

  var _options$theming = options.theming,
      theming = _options$theming === undefined ? _theming2['default'] : _options$theming,
      inject = options.inject,
      optionsJss = options.jss,
      sheetOptions = _objectWithoutProperties(options, ['theming', 'inject', 'jss']);

  var injectMap = inject ? toMap(inject) : defaultInjectProps;
  var themeListener = theming.themeListener;

  var displayName = (0, _getDisplayName2['default'])(InnerComponent);
  var defaultClassNamePrefix = env === 'production' ? undefined : displayName + '-';
  var noTheme = {};
  var managerId = managersCounter++;
  var manager = new _jss.SheetsManager();
  var defaultProps = _extends({}, InnerComponent.defaultProps);
  delete defaultProps.classes;

  var Jss = function (_Component) {
    _inherits(Jss, _Component);

    function Jss(props, context) {
      _classCallCheck(this, Jss);

      var _this = _possibleConstructorReturn(this, (Jss.__proto__ || Object.getPrototypeOf(Jss)).call(this, props, context));

      _initialiseProps.call(_this);

      var theme = isThemingEnabled ? themeListener.initial(context) : noTheme;

      _this.state = _this.createState({ theme: theme }, props);
      return _this;
    }

    _createClass(Jss, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.manage(this.state);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (isThemingEnabled) {
          this.unsubscribeId = themeListener.subscribe(this.context, this.setTheme);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        this.context = nextContext;
        var dynamicSheet = this.state.dynamicSheet;

        if (dynamicSheet) dynamicSheet.update(nextProps);
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        if (isThemingEnabled && this.state.theme !== nextState.theme) {
          var newState = this.createState(nextState, nextProps);
          this.manage(newState);
          this.manager.unmanage(this.state.theme);
          this.setState(newState);
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        // We remove previous dynamicSheet only after new one was created to avoid FOUC.
        if (prevState.dynamicSheet !== this.state.dynamicSheet) {
          this.jss.removeStyleSheet(prevState.dynamicSheet);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.unsubscribeId) {
          themeListener.unsubscribe(this.context, this.unsubscribeId);
        }

        this.manager.unmanage(this.state.theme);
        if (this.state.dynamicSheet) {
          this.state.dynamicSheet.detach();
        }
      }
    }, {
      key: 'createState',
      value: function createState(_ref, _ref2) {
        var theme = _ref.theme,
            dynamicSheet = _ref.dynamicSheet;
        var userClasses = _ref2.classes;

        var contextSheetOptions = this.context[ns.sheetOptions];
        if (contextSheetOptions && contextSheetOptions.disableStylesGeneration) {
          return { theme: theme, dynamicSheet: dynamicSheet, classes: {} };
        }

        var classNamePrefix = defaultClassNamePrefix;
        var staticSheet = this.manager.get(theme);

        if (contextSheetOptions && contextSheetOptions.classNamePrefix) {
          classNamePrefix = contextSheetOptions.classNamePrefix + classNamePrefix;
        }

        if (!staticSheet) {
          var styles = getStyles(stylesOrCreator, theme);
          staticSheet = this.jss.createStyleSheet(styles, _extends({}, sheetOptions, contextSheetOptions, {
            meta: displayName + ', ' + (isThemingEnabled ? 'Themed' : 'Unthemed') + ', Static',
            classNamePrefix: classNamePrefix
          }));
          this.manager.add(theme, staticSheet);
          staticSheet[dynamicStylesNs] = (0, _jss.getDynamicStyles)(styles);
        }

        var dynamicStyles = staticSheet[dynamicStylesNs];

        if (dynamicStyles) {
          dynamicSheet = this.jss.createStyleSheet(dynamicStyles, _extends({}, sheetOptions, contextSheetOptions, {
            meta: displayName + ', ' + (isThemingEnabled ? 'Themed' : 'Unthemed') + ', Dynamic',
            classNamePrefix: classNamePrefix,
            link: true
          }));
        }

        var defaultClasses = InnerComponent.defaultProps ? InnerComponent.defaultProps.classes : {};
        var jssClasses = dynamicSheet ? (0, _compose2['default'])(staticSheet.classes, dynamicSheet.classes) : staticSheet.classes;
        var classes = _extends({}, defaultClasses, jssClasses, userClasses);

        return { theme: theme, dynamicSheet: dynamicSheet, classes: classes };
      }
    }, {
      key: 'manage',
      value: function manage(_ref3) {
        var theme = _ref3.theme,
            dynamicSheet = _ref3.dynamicSheet;

        var contextSheetOptions = this.context[ns.sheetOptions];
        if (contextSheetOptions && contextSheetOptions.disableStylesGeneration) {
          return;
        }
        var registry = this.context[ns.sheetsRegistry];

        var staticSheet = this.manager.manage(theme);
        if (registry) registry.add(staticSheet);

        if (dynamicSheet) {
          dynamicSheet.update(this.props).attach();
          if (registry) registry.add(dynamicSheet);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            theme = _state.theme,
            dynamicSheet = _state.dynamicSheet,
            classes = _state.classes;

        var _props = this.props,
            innerRef = _props.innerRef,
            props = _objectWithoutProperties(_props, ['innerRef']);

        var sheet = dynamicSheet || this.manager.get(theme);

        if (injectMap.sheet && !props.sheet) props.sheet = sheet;
        if (isThemingEnabled && injectMap.theme && !props.theme) props.theme = theme;

        // We have merged classes already.
        if (injectMap.classes) props.classes = classes;

        return _react2['default'].createElement(InnerComponent, _extends({ ref: innerRef }, props));
      }
    }, {
      key: 'jss',
      get: function get() {
        return this.context[ns.jss] || optionsJss || _jss2['default'];
      }
    }, {
      key: 'manager',
      get: function get() {
        var managers = this.context[ns.managers];

        // If `managers` map is present in the context, we use it in order to
        // let JssProvider reset them when new response has to render server-side.
        if (managers) {
          if (!managers[managerId]) {
            managers[managerId] = new _jss.SheetsManager();
          }
          return managers[managerId];
        }

        return manager;
      }
    }]);

    return Jss;
  }(_react.Component);

  Jss.displayName = 'Jss(' + displayName + ')';
  Jss.InnerComponent = InnerComponent;
  Jss.contextTypes = _extends({}, _contextTypes2['default'], isThemingEnabled && themeListener.contextTypes);
  Jss.propTypes = {
    innerRef: _propTypes2['default'].func
  };
  Jss.defaultProps = defaultProps;

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.setTheme = function (theme) {
      return _this2.setState({ theme: theme });
    };
  };

  return Jss;
};

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Adds `composes` property to each top level rule
 * in order to have a composed class name for dynamic style sheets.
 *
 * It relies on jss-compose and jss-extend plugins.
 *
 * Example:
 * classes:  {left: 'a', button: 'b'}
 * styles:   {button: {height: () => { ... }}}
 * composed: {
 *   button: {
 *     composes: 'b',
 *     height: () => { ... }
 *   },
 *   left: {
 *     composes: 'a'
 *   }
 * }
 *
 * @param {Object} classes static classes map
 * @param {Object} styles dynamic styles object without static properties
 * @return {Object|null}
 */
exports["default"] = function (staticClasses, dynamicClasses) {
  var combinedClasses = _extends({}, staticClasses);

  for (var name in dynamicClasses) {
    combinedClasses[name] = staticClasses[name] ? staticClasses[name] + " " + dynamicClasses[name] : dynamicClasses[name];
  }

  return combinedClasses;
};

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports['default'] = function (Component) {
  return Component.displayName || Component.name || 'Component';
};

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.contractPeriods = contractPeriods;
exports.currentYear = currentYear;
exports.downloadDocs = downloadDocs;

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _docCookie = __webpack_require__(142);

var _docCookie2 = _interopRequireDefault(_docCookie);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function contractPeriods() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'GOT_CONTRACTING_YEARS':
      if (payload && payload.length) return payload;
      return [{ startDate: '2018-04-01 00:00:00.000Z', endDate: '2019-03-31 00:00:00.000Z' }];
    case 'STARTING_DRAFT_CREATE_IN_TEMPLATE_LIST':
    case 'CREATE_CONTRACT_FINISHED':
      if (!state.some(function (period) {
        return period.startDate === payload.startDate && period.endDate === payload.endDate;
      })) {
        return [{ startDate: payload.startDate, endDate: payload.endDate }].concat(_toConsumableArray(state));
      }
      return state;
    default:
      return state;
  }
}
function currentYear() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { startDate: '', endDate: '' };
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case '[contracting]INIT_SELECTED_YEAR_FOR_CONTRACTING':
    case '[contracting]SELECTED_YEAR_FOR_CONTRACTING':
    case 'STARTING_DRAFT_CREATE_IN_TEMPLATE_LIST':
    case 'CREATE_CONTRACT_FINISHED':
      _docCookie2.default.removeItem('contractYearStartDate', '/');
      _docCookie2.default.removeItem('contractYearEndDate', '/');
      _docCookie2.default.setItem('contractYearStartDate', payload.startDate, Infinity, '/');
      _docCookie2.default.setItem('contractYearEndDate', payload.endDate, Infinity, '/');
      return { startDate: payload.startDate, endDate: payload.endDate };
    default:
      return state;
  }
}

var initialStateForDownloadDocs = {
  docId: '',
  downloadRateFormat: '',
  contractIds: [], // for zip download contracts only
  templates: [], // for zip download template group only
  templateGroupName: '', // for zip download template group only
  collection: '', // draft, template, contract
  locale: (0, _moment2.default)().utcOffset(),
  open: false,
  anchorEl: null,
  validLengthForBulkDownload: 0,
  downloadedCount: 0,
  loading: false,
  success: false,
  error: false,
  forAL: false,
  fromEmail: false,
  wouldYouAcceptDialog: false,
  downloadUrl: null
};
function downloadDocs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateForDownloadDocs;
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER':
      return _extends({}, state, payload, {
        downloadRateFormat: function () {
          if (payload.downloadRateFormat) return payload.downloadRateFormat;
          if (state.downloadRateFormat) return state.downloadRateFormat;
          if (localStorage && localStorage.getItem('rateFormat')) return localStorage.getItem('rateFormat');
          return 'condensed';
        }(),
        open: true
      });
    case '[contracting-download]UPDATE_PROPS':
      return _extends({}, state, payload);
    case '[contracting-download]ASK_ACCEPT_AFTER_DOWNLOAD':
      return _extends({}, state, {
        wouldYouAcceptDialog: true
      });
    case '[contracting-download]DOWNLOAD_SINGLE_CONTRACT_DOC_START':
    case '[contracting-download]BULK_DOWNLOAD_STARTED':
    case '[contracting-download] downloadGroup_STARTED':
      return _extends({}, state, {
        loading: true,
        downloadUrl: null
      });
    case '[contracting-download] downloadGroup_RETRY':
      return _extends({}, state, {
        loading: false,
        success: false,
        error: false
      });
    case '[contracting-download]DOWNLOAD_SINGLE_CONTRACT_DOC_SUCCESS':
    case '[contracting-download]BULK_DOWNLOAD_SUCCESS':
    case '[contracting-download] downloadGroup_SUCCESS_SUCCESS':
      return _extends({}, state, {
        loading: false,
        success: true,
        downloadUrl: payload.url
      });
    case '[contracting-download]BULK_DOWNLOAD_ERROR':
    case '[contracting-download] downloadGroup_ERROR':
    case '[contracting-download] downloadGroup_SUCCESS_ERROR':
      return _extends({}, state, {
        loading: false,
        error: true
      });
    case '[contracting-download]EXPORT_EXCEL_STARTED':
      return _extends({}, state, {
        loading: true
      });
    case '[contracting-download]EXPORT_EXCEL_ERROR':
    case '[contracting-download]EXPORT_EXCEL_SUCCESS':
      return _extends({}, state, {
        loading: false
      });
    case '[contracting-download]ACCEPT_RATES_STARTED':
    case '[contracting-download]ACCEPT_RATES_SUCCESS':
    case '[contracting-download]CLOSE_DOWNLOAD_POPOVER':
      return _extends({}, initialStateForDownloadDocs, {
        downloadRateFormat: state.downloadRateFormat
      });
    default:
      return state;
  }
}

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GETTING_MARKETING_MATERIALS = exports.GETTING_MARKETING_MATERIALS = 'GETTING_MARKETING_MATERIALS';
var GOT_MARKETING_MATERIALS = exports.GOT_MARKETING_MATERIALS = 'GOT_MARKETING_MATERIALS';
var UPDATE_MM_PROP = exports.UPDATE_MM_PROP = 'UPDATE_MM_PROP';
var UPDATE_MM_PARTNER_PROP = exports.UPDATE_MM_PARTNER_PROP = 'UPDATE_MM_PARTNER_PROP';
var EDIT_MM_STARTING = exports.EDIT_MM_STARTING = 'EDIT_MM_STARTING';
var EDIT_MM_FINISHED = exports.EDIT_MM_FINISHED = 'EDIT_MM_FINISHED';
var CHECK_CONNECTION = exports.CHECK_CONNECTION = 'CHECK_CONNECTION';
var UNCHECK_CONNECTION = exports.UNCHECK_CONNECTION = 'UNCHECK_CONNECTION';
var SENDING_MARKETING_MATERIALS = exports.SENDING_MARKETING_MATERIALS = 'SENDING_MARKETING_MATERIALS';
var SENT_MARKETING_MATERIALS = exports.SENT_MARKETING_MATERIALS = 'SENT_MARKETING_MATERIALS';
var GETTING_PARTNERS = exports.GETTING_PARTNERS = '[share-MM]GETTING_PARTNERS';
var GOT_PARTNERS = exports.GOT_PARTNERS = '[share-MM]GOT_PARTNERS';
var UPDATE_PROP_MM_SIGNUP = exports.UPDATE_PROP_MM_SIGNUP = 'UPDATE_PROP_MM_SIGNUP';
var UPDATE_MM_SIGN_UP_PROP = exports.UPDATE_MM_SIGN_UP_PROP = 'UPDATE_MM_SIGN_UP_PROP';
var UPDATE_MM_SIGN_UP_COMPANY = exports.UPDATE_MM_SIGN_UP_COMPANY = 'UPDATE_MM_SIGN_UP_COMPANY';
var MM_SIGNUP_FAILED = exports.MM_SIGNUP_FAILED = 'MM_SIGNUP_FAILED';
var MM_SIGNUP_SUCCESS = exports.MM_SIGNUP_SUCCESS = 'MM_SIGNUP_SUCCESS';
var UPDATE_TYPE_AHEAD_COMPANIES_FOR_MM = exports.UPDATE_TYPE_AHEAD_COMPANIES_FOR_MM = 'UPDATE_TYPE_AHEAD_COMPANIES_FOR_MM';
var MM_SIGN_UP_IN_PROCESS = exports.MM_SIGN_UP_IN_PROCESS = 'MM_SIGN_UP_IN_PROCESS';
var CLEAR_STORE = exports.CLEAR_STORE = 'CLEAR_STORE';

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publicPost = publicPost;

var _immutable = __webpack_require__(26);

var _constants = __webpack_require__(1105);

var constants = _interopRequireWildcard(_constants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({
  showPublicSignUpDialog: false,

  companyName: '',
  comments: [],
  hasMoreComments: true,
  postComment: {
    comment: '',
    postId: '',
    lastCommentId: ''
  },

  // file preview
  postFilePreview: {},
  postFiles: [],

  // loaders
  gettingPost: false,
  loadingComments: false
});

function publicPost() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case constants.UPDATE_POST_PAGE_PROP:
      return state.merge((0, _immutable.fromJS)(payload));
    case constants.GET_POST_STARTED:
      return state.set('gettingPost', true);
    case constants.GOT_POST:
      return state.merge((0, _immutable.fromJS)(payload)).set('hasMoreComments', payload.numOfComments > _ramda2.default.pathOr(0, ['comments', 'length'], payload)).set('postFiles', _ramda2.default.pathOr([], ['post', 'files'], payload)).set('gettingPost', false);
    case constants.GET_POST_FAILED:
      return state.set('gettingPost', false);
    case 'START_UPDATING_A_POST_NEWSFEED':
      if (payload.updateType === 'comment') {
        return state.update('comments', function (comments) {
          return comments.push((0, _immutable.fromJS)(_ramda2.default.merge(payload.updater.comment, { temporaryUuid: payload.temporaryUuid })));
        }).update('numOfComments', function (numOfComments) {
          return numOfComments + 1;
        });
      }
      if (payload.updateType === 'deleteComment') {
        return state.update('comments', function (comments) {
          return comments.filter(function (comment) {
            return comment.get('_id') !== _ramda2.default.path(['updater', 'commentId'], payload);
          });
        }).update('numOfComments', function (numOfComments) {
          return numOfComments - 1;
        });
      }
      return state.merge((0, _immutable.fromJS)(payload.updater));
    case 'UPDATED_POST':
      if (payload.updateType === 'comment') {
        return state.update('comments', function (comments) {
          return comments.map(function (comment) {
            if (comment.get('temporaryUuid') === payload.temporaryUuid) return comment.set('_id', payload.response._id);
            return comment;
          });
        });
      }
      return state;
    case 'LOAD_MORE_COMMENTS_STARTED':
      return state.set('loadingComments', true);
    case 'LOAD_MORE_COMMENTS_FAILED':
      return state.set('loadingComments', false);
    case 'LOADED_MORE_COMMENTS':
      if (_ramda2.default.isEmpty(payload.comments)) {
        return state.set('loadingComments', false).set('hasMoreComments', false);
      }
      return state.set('loadingComments', false).update('comments', function (comments) {
        return (0, _immutable.fromJS)(comments.toJS().concat(payload.comments));
      });
    case 'UPDATE_NEWSFEED_PROP':
      return state.merge((0, _immutable.fromJS)(payload));
    default:
      return state;
  }
}

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(131);

var _uiEnhancer = __webpack_require__(1447);

var _uiEnhancer2 = _interopRequireDefault(_uiEnhancer);

var _upgradeReducer = __webpack_require__(1448);

var _helpwidgetReducer = __webpack_require__(1449);

var _walkthruReducer = __webpack_require__(1450);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var upgrade = (0, _uiEnhancer2.default)(_upgradeReducer.upgrade, 'UPGRADE');
var helpwidget = (0, _uiEnhancer2.default)(_helpwidgetReducer.helpwidget, 'HELPWIDGET');
var walkthru = (0, _uiEnhancer2.default)(_walkthruReducer.walkthru, 'WALKTHRU');

exports.default = (0, _redux.combineReducers)({ helpwidget: helpwidget, upgrade: upgrade, walkthru: walkthru });

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = __webpack_require__(26);

var uiRootReducer = function uiRootReducer(reducer, type) {
  var initialState = (0, _immutable.Map)({
    isOpen: false,
    isSyncing: false,
    message: ''
  });

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var OPEN = type + '_OPEN';
    var CLOSE = type + '_CLOSE';
    var SYNC_DATA = type + '_SYNC_DATA';
    var SYNC_SUCCESS = type + '_SYNC_SUCCESS';
    var SYNC_FAILURE = type + '_SYNC_FAILURE';

    switch (action.type) {
      case OPEN:
        return state.merge((0, _immutable.Map)({ isOpen: true }));
      case SYNC_DATA:
        return state.merge((0, _immutable.Map)({ isSyncing: true }));
      case SYNC_SUCCESS:
        return state.merge((0, _immutable.Map)(_extends({ isSyncing: false }, action.payload)));
      case SYNC_FAILURE:
        return state.merge((0, _immutable.Map)(_extends({ isSyncing: false }, action.payload)));
      case CLOSE:
        return state.merge((0, _immutable.Map)({ isOpen: false }));
      default:
        return reducer(state, action);
    }
  };
};

exports.default = uiRootReducer;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upgrade = upgrade;

var _immutable = __webpack_require__(26);

var _upgradeConstants = __webpack_require__(1048);

var constants = _interopRequireWildcard(_upgradeConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({
  upgradeReason: 'generic'
});

function upgrade() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case constants.REASON:
      return state.merge((0, _immutable.fromJS)(action.payload));
    default:
      return initialState.merge(state);
  }
}

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.helpwidget = helpwidget;

var _immutable = __webpack_require__(26);

var _helpwidgetConstants = __webpack_require__(1106);

var constants = _interopRequireWildcard(_helpwidgetConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({
  isKnowledgeBaseActive: true,
  isLiveChatActive: false,
  isSupportDeskActive: false,
  isNewFeaturesActive: false,
  newFeaturesCount: 0,
  isTourActive: false
});

function helpwidget() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case constants.LIVE_CHAT_ACTIVE:
      return state.set('isLiveChatActive', true);
    case constants.LIVE_CHAT_INACTIVE:
      return state.set('isLiveChatActive', false);
    case constants.SUPPORT_DESK_ACTIVE:
      return state.set('isSupportDeskActive', true);
    case constants.NEW_FEATURES_ACTIVE:
      return state.set('isNewFeaturesActive', true);
    case constants.RECEIVE_NEW_FEATURES:
      return state.set('newFeaturesCount', action.payload.count);
    default:
      return initialState.merge(state);
  }
}

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.walkthru = walkthru;

var _immutable = __webpack_require__(26);

var _walkthruConstants = __webpack_require__(1107);

var constants = _interopRequireWildcard(_walkthruConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({
  isTourReady: false,
  eventName: null,
  steps: []
});

function walkthru() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case constants.SET_STEPS:
      return state.merge((0, _immutable.fromJS)({
        steps: payload.steps,
        eventName: payload.eventName,
        isTourReady: true
      }));
    case constants.RESET:
      return state.merge((0, _immutable.fromJS)({
        steps: [],
        eventName: null,
        isTourReady: false,
        isOpen: false
      }));
    default:
      return initialState.merge(state);
  }
}

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(582);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var R = __webpack_require__(2);


var initialState = {
  indexLoading: false,
  indexError: false,
  helpIndex: [],
  contentLoading: false,
  contentError: false,
  helpArticle: undefined
};

var regExpEscape = function regExpEscape(s) {
  return s.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
};
var wildcardToRegExp = function wildcardToRegExp(s) {
  return new RegExp('^' + s.split(/\*+/).map(regExpEscape).join('.*') + '$');
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case cnt.LOAD_HELPFILES + '_STARTED':
      {
        return _extends({}, state, { indexLoading: true });
      }
    case cnt.LOAD_HELPFILES + '_ERROR':
      {
        return _extends({}, state, { indexError: false, indexLoading: false });
      }
    case cnt.LOAD_HELPFILES + '_SUCCESS':
      {
        var helpIndex = (payload.items || []).map(function (e) {
          return {
            expressions: (e.fields.matchingUrls || []).map(wildcardToRegExp),
            entryId: e.sys.id,
            matchingRole: (e.fields.matchingRole || []).map(function (role) {
              return role.replace('Buyer', 'Contractor');
            }),
            title: e.fields.title
          };
        });
        return _extends({}, state, { indexError: false, indexLoading: false, helpIndex: helpIndex });
      }
    case cnt.LOAD_HELP_ARTICLE + '_STARTED':
      {
        return _extends({}, state, { contentLoading: true });
      }
    case cnt.LOAD_HELP_ARTICLE + '_ERROR':
      {
        return _extends({}, state, { contentLoading: false, contentError: true });
      }
    case cnt.LOAD_HELP_ARTICLE + '_SUCCESS':
      {
        var Entry = R.pathOr([], ['includes', 'Entry'], payload);

        var _payload$items = _slicedToArray(payload.items, 1),
            _payload$items$ = _payload$items[0],
            entryId = _payload$items$.sys.id,
            fields = _payload$items$.fields;

        return _extends({}, state, {
          contentLoading: false,
          contentError: false,
          helpArticle: _extends({
            entryId: entryId
          }, fields, {
            onThisPage: (fields.onThisPage || []).map(function (e) {
              return _extends({
                id: e.sys.id
              }, Entry.find(function (include) {
                return include.sys.id === e.sys.id;
              }).fields || {});
            })
          })
        });
      }
    default:
      return state;
  }
};

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.dummyAcctInCR = dummyAcctInCR;
exports.dummyTemplate = dummyTemplate;
exports.requestSigs = requestSigs;
exports.sendMsg = sendMsg;

var _redux = __webpack_require__(131);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _populateLocs = function _populateLocs(locations) {
  return [].concat(_toConsumableArray(locations.map(function (loc) {
    return _extends({}, loc, {
      checked: true,
      access: ['write'],
      products: loc.products.map(function (prod) {
        return _extends({}, prod, { checked: true });
      })
    });
  })), [{
    name: '',
    products: []
  }]);
};

var initialState = {
  loading: false,
  creatingTemplates: false,
  dummySupplierForCR: {
    templates: [],
    locations: []
  },
  rateLoadingWizard: {}
};
function dummyAcctInCR() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload,
      args = _ref.args;

  switch (type) {
    case '[asset-landing]GET_REQUEST':
    case 'CONTRACT_CONTENT_LOADING':
    case '{rates-draft} REFRESH_POLICIES_NOTES':
      return _extends({}, state, {
        loading: true
      });
    case '[asset-landing]GET_REQUEST_SUCCESS':
    case 'GET_CONTRACT_DETAILS':
    case '{rates-draft} REFRESH_POLICIES_NOTES_SUCCESS':
      if (payload.dummySupplierForCR) {
        return _extends({}, state, {
          crId: payload.contractId,
          startDate: payload.startDate,
          endDate: payload.endDate,
          rateConversionStatus: payload.rateConversionStatus,
          rateConversionSetting: payload.rateConversionSetting,
          priority: payload.priority,
          assignee: payload.assignee,
          buyerCompanyName: payload.from ? payload.from.name : '',
          supplierCompanyName: payload.from ? payload.from.name + ' (RC)' : '',
          buyerEmail: payload.from ? payload.from.emailAlias || payload.from.email : '',
          supplierEmails: payload.toEmails.filter(function (x) {
            return x.indexOf('dl+') === -1;
          }),
          dummySupplierForCR: payload.dummySupplierForCR,
          rateLoadingWizard: {
            partnerId: payload.to ? payload.to.partnerId : '',
            newDraftStartDate: payload.startDate,
            newDraftEndDate: payload.endDate,
            templateName: (payload.to && payload.to.name ? payload.to.name : '') + ' ' + _moment2.default.utc(new Date(payload.startDate)).format('MMM DD YYYY') + ' - ' + _moment2.default.utc(new Date(payload.endDate)).format('MMM DD YYYY') + ' Rates\n            ',
            productType: _ramda2.default.path(['dummySupplierForCR', 'productType'], payload) || 'Accommodation',
            oneOrMulti: _ramda2.default.path(['dummySupplierForCR', 'oneOrMulti'], payload) || 'multi',
            locations: _ramda2.default.path(['dummySupplierForCR', 'locations', 'length'], payload) ? _populateLocs(_ramda2.default.path(['dummySupplierForCR', 'locations'], payload)) : [{
              name: payload.to ? payload.to.name : '',
              checked: payload.to ? Boolean(payload.to.name) : false,
              products: []
            }]
          },
          loading: false
        });
      }
      return state;
    case '[contract-request] DELETE_RATE_SHEET_SUCCESS':
      return _extends({}, state, {
        dummySupplierForCR: _extends({}, state.dummySupplierForCR, {
          templates: (state.dummySupplierForCR.templates || []).filter(function (o) {
            return o.originalContractId !== args[0].originalContractId;
          })
        })
      });
    case '[contract-request] UPDATE_RL_WIZARD_DATA':
      return _extends({}, state, {
        rateLoadingWizard: _extends({}, state.rateLoadingWizard, payload)
      });
    case '[contract-request] UPDATE_RATE_LOADING_STATUS':
      return _extends({}, state, {
        rateConversionStatus: payload.newStatus
      });
    case '[asset-landing]GET_REQUEST_ERROR':
    case '{rates-draft} REFRESH_POLICIES_NOTES_ERROR':
      return _extends({}, state, {
        loading: false
      });
    case '[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR':
      return _extends({}, state, {
        creatingTemplates: true
      });
    case '[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR_SUCCESS':
    case '[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR_ERROR':
      return _extends({}, state, {
        creatingTemplates: false
      });
    default:
      return state;
  }
}

function dummyTemplate() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    crId: '',
    magicLinkHashToken: ''
  };
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  switch (type) {
    case '@@router/LOCATION_CHANGE':
      var contractId = (window.location.pathname.match(/^\/contracting\/draft\/([a-f\d]{24})\//) || [])[1];
      if (window.location.href.indexOf("https://sec.tourconnect.com") > -1 && contractId) {
        if (payload.query && payload.query.magicLinkHashToken) {
          localStorage.setItem(contractId, payload.query.magicLinkHashToken);
          return _extends({}, state, {
            magicLinkHashToken: payload.query.magicLinkHashToken
          });
        } else if (localStorage.getItem(contractId)) {
          return _extends({}, state, {
            magicLinkHashToken: localStorage.getItem(contractId)
          });
        }
      }
      return state;
    default:
      return state;
  }
}

var requestSigsIntial = {
  open: false,
  invitees: [],
  rateDocId: '',
  signatures: [],
  message: '',
  subject: ''
};

function requestSigs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requestSigsIntial;
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case '{dummy-account}OPEN_REQUEST_SIGNATURE':
      return _extends({}, state, {
        open: true
      }, payload);
    case '{dummy-account} REQUEST_SIGNATURE_SUCCESS':
    case '{dummy-account}CANCEL_REQUEST_SIGNATURE':
      return requestSigsIntial;
    case '{dummy-account}UPDATE_PROPS':
      return _extends({}, state, payload);
    case '{dummy-account} REQUEST_SIGNATURE':
      return _extends({}, state, {
        sending: true
      });
    case '{dummy-account} REQUEST_SIGNATURE_ERROR':
      return _extends({}, state, {
        sending: false
      });
    default:
      return state;
  }
}

var sendMsgIntial = {
  open: false,
  emails: [],
  rateDocIds: [],
  signatures: [],
  leanFiles: [],
  message: '',
  subject: '',
  who: 'Supplier',
  submitRatesChecked: false,
  defaultSubject: '',
  defaultMessage: ''
};

function sendMsg() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sendMsgIntial;
  var _ref4 = arguments[1];
  var type = _ref4.type,
      payload = _ref4.payload;

  switch (type) {
    case '{rl-send-message}OPEN_SEND_MESSAGE':
      return _extends({}, state, payload, {
        open: true
      });
    case 'GET_CONTRACT_DETAILS':
    case '{rates-draft} REFRESH_POLICIES_NOTES_SUCCESS':
      var year = _moment2.default.utc(payload.startDate).get('year') === _moment2.default.utc(payload.endDate).get('year') ? _moment2.default.utc(payload.startDate).get('year') : _moment2.default.utc(payload.startDate).get('year') + ' - ' + _moment2.default.utc(payload.endDate).get('year');
      var defaultSub = payload.to ? payload.to.name + ' ' + year + ' Rates' : '';
      var defaultMsg = payload.to ? 'Hi,\n\nPlease find ' + payload.to.name + ' ' + year + ' rates below.\n\nIf you have any questions please let us know and thank you for your support.\n\nThanks,\n\nTourConnect Data Conversion Team\n      ' : '';
      return _extends({}, state, {
        defaultSubject: defaultSub,
        defaultMessage: defaultMsg
      });
    case '{rl-send-message} OPEN_SEND_MESSAGE_AS_SUBMIT_RATES_AS_DL':
      return _extends({}, state, {
        open: true,
        who: 'Buyer',
        submitRatesChecked: true,
        subject: state.subject || state.defaultSubject,
        message: state.message || state.defaultMessage
      }, payload);
    case '{rl-send-message} CANCEL_SEND_MESSAGE':
      return _extends({}, sendMsgIntial, {
        defaultSubject: state.defaultSubject,
        defaultMessage: state.defaultMessage
      });
    case '{rl-send-message} UPDATE_PROPS':
      return _extends({}, state, payload);
    case '{rl-send-message} SEND_MESSAGE':
    case '{rl-send-message} SUBMIT_RATES_AS_DL':
      return _extends({}, state, {
        sending: true
      });
    case '{rl-send-message} SEND_MESSAGE_ERROR':
    case '{rl-send-message} SUBMIT_RATES_AS_DL_ERROR':
      return _extends({}, state, {
        sending: false
      });
    case '{rl-send-message} SEND_MESSAGE_SUCCESS':
    case '{rl-send-message} SUBMIT_RATES_AS_DL_SUCCESS':
      return _extends({}, state, {
        sending: false,
        sent: true
      });
    default:
      return state;
  }
}

var initialIframe = {
  url: '',
  rateDocId: '',
  collection: '',
  open: false,
  acceptingDummyTemplate: false,
  isInSigning: false,
  buyerLogo: '',
  buyerName: '',
  loading: false,
  deletingDraft: false,
  rawDiffData: [],
  ratesSummary: {}
};

function rateDocIframe() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialIframe;
  var _ref5 = arguments[1];
  var type = _ref5.type,
      payload = _ref5.payload;

  switch (type) {
    case '{dummy-account} RateDocIframe_open':
      // this could be an iframe within iframe (buyer loading rates in their dummy account and previewing rates from another account)
      if (window.location.href.indexOf("https://sec.tourconnect.com") > -1) {
        localStorage.setItem('prevJwt', localStorage.getItem('jwt'));
      }
      return _extends({}, state, {
        open: true
      }, payload);
    case '{dummy-account} loadDataForIframe':
      return _extends({}, state, {
        loading: true
      });
    case '{dummy-account} RateDocIframe_checkIfRateComplete':
      return _extends({}, state, {
        loading: true
      });
    case '{dummy-account} RateDocIframe_checkIfRateComplete_SUCCESS':
    case '{dummy-account} loadDataForIframe_SUCCESS':
    case '{dummy-account} loadDraftDiff_SUCCESS':
      return _extends({}, state, payload, {
        loading: false
      });
    case '{dummy-account} DISCARD_DUMMY_TEMPLATE_DRAFT':
      return _extends({}, state, {
        deletingDraft: true
      });
    case '{dummy-account} DISCARD_DUMMY_TEMPLATE_DRAFT_SUCCESS':
    case '{dummy-account} ACCEPT_DUMMY_TEMPLATE_SUCCESS':
    case 'RateDocIframe_selectImportTemplate':
    case '{dummy-account} RateDocIframe_close':
      // this could be an iframe within iframe (buyer loading rates in their dummy account and previewing rates from another account)
      if (window.location.href.indexOf("https://sec.tourconnect.com") > -1 && localStorage.getItem('prevJwt')) {
        localStorage.setItem('jwt', localStorage.getItem('prevJwt'));
        localStorage.removeItem('prevJwt');
      }
      return initialIframe;
    case '{dummy-account} ACCEPT_DUMMY_TEMPLATE':
      return _extends({}, state, {
        acceptingDummyTemplate: true
      });
    default:
      return state;
  }
}
exports.default = (0, _redux.combineReducers)({
  inCR: dummyAcctInCR,
  dummyTemplate: dummyTemplate,
  requestSigs: requestSigs,
  sendMsg: sendMsg,
  rateDocIframe: rateDocIframe
});

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Paper = __webpack_require__(228);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconWithCount = function IconWithCount(_ref) {
  var count = _ref.count,
      style = _ref.style,
      onTouchTap = _ref.onTouchTap,
      icon = _ref.icon;

  var digits = ('' + count).length;
  return _react2.default.createElement(
    'div',
    {
      style: _extends({}, style, { cursor: Boolean(onTouchTap) ? 'pointer' : 'inherit' }),
      onTouchTap: onTouchTap
    },
    _react2.default.cloneElement(icon, {
      style: { fill: 'rgba(0, 0, 0, 0.54)', height: '28px', width: '28px' }
    }),
    _react2.default.createElement(
      _Paper2.default,
      {
        style: {
          display: count ? 'inline-block' : 'none',
          width: digits > 1 ? '25px' : '18px',
          height: '18px',
          color: 'white',
          borderRadius: digits > 1 ? '2px' : '9px',
          backgroundColor: 'red',
          lineHeight: '17px',
          textAlign: 'center',
          position: 'relative',
          top: '-10px',
          left: '-5px'
        }
      },
      count > 99 ? '99+' : count
    )
  );
};

IconWithCount.propTypes = {
  style: _react.PropTypes.object,
  count: _react.PropTypes.number,
  icon: _react.PropTypes.node,
  showRedDot: _react.PropTypes.bool,
  onTouchTap: _react.PropTypes.func
};

IconWithCount.defaultProps = {
  onTouchTap: function onTouchTap() {}
};

exports.default = IconWithCount;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertPhoto = function EditorInsertPhoto(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
  );
};
EditorInsertPhoto = (0, _pure2.default)(EditorInsertPhoto);
EditorInsertPhoto.displayName = 'EditorInsertPhoto';
EditorInsertPhoto.muiName = 'SvgIcon';

exports.default = EditorInsertPhoto;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetSelectedContractRequest = exports.sendMessage = exports.sendRateRequest = exports.sendRates = exports.resetRateOptions = exports.resetSelectedLocation = exports.resetSelectedRate = undefined;

var _constants = __webpack_require__(656);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// export const sendRates = (payload) => { return { type: cnt.ADD_RATE, payload }; };
var resetSelectedRate = exports.resetSelectedRate = function resetSelectedRate() {
  return { type: cnt.RESET_SELECTED_RATE };
};
var resetSelectedLocation = exports.resetSelectedLocation = function resetSelectedLocation() {
  return { type: cnt.RESET_SELECTED_LOCATION };
};
var resetRateOptions = exports.resetRateOptions = function resetRateOptions() {
  return { type: cnt.RESET_SELECTED_ALL };
};
var sendRates = exports.sendRates = function sendRates(payload) {
  return { type: cnt.SEND_RATES, payload: payload };
};
var sendRateRequest = exports.sendRateRequest = function sendRateRequest(payload) {
  return { type: cnt.SEND_RATE_REQUESTS, payload: payload };
};
var sendMessage = exports.sendMessage = function sendMessage(payload) {
  return { type: cnt.SEND_MESSAGE, payload: payload };
};
var resetSelectedContractRequest = exports.resetSelectedContractRequest = function resetSelectedContractRequest() {
  return { type: cnt.RESET_CONTRACTING_REQUEST };
};

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _cloudsponge = __webpack_require__(2741);

var _cloudsponge2 = _interopRequireDefault(_cloudsponge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TCContactImport = function TCContactImport(_ref) {
  var parentStyle = _ref.parentStyle,
      buttonStyle = _ref.buttonStyle,
      afterSubmitContacts = _ref.afterSubmitContacts,
      other = _objectWithoutProperties(_ref, ['parentStyle', 'buttonStyle', 'afterSubmitContacts']);

  var sources = [{ value: 'gmail', name: 'Gmail' }, { value: 'yahoo', name: 'Yahoo' }, { value: 'windowslive', name: 'Outlook' }, { value: 'linkedin', name: 'LinkedIn' }].map(function (_ref2, key) {
    var value = _ref2.value,
        name = _ref2.name;

    var sourceButton = {};
    switch (value) {
      case 'gmail':
        sourceButton.class = 'google';
        sourceButton.backgroundColor = '#e04c40';
        break;
      case 'yahoo':
        sourceButton.class = 'yahoo';
        sourceButton.backgroundColor = '#400090';
        break;
      case 'windowslive':
        sourceButton.class = 'windows8';
        sourceButton.backgroundColor = '#34b2e4';
        break;
      case 'linkedin':
        sourceButton.class = 'linkedin';
        sourceButton.backgroundColor = '#0077b5';
        break;
      default:
        sourceButton.backgroundColor = 'none';
        break;
    }
    return _react2.default.createElement(_materialUi.FlatButton, {
      key: key,
      icon: _react2.default.createElement(_materialUi.FontIcon, {
        className: sourceButton.class ? 'tc-icon-' + sourceButton.class : '',
        style: {
          fontSize: '18px',
          marginLeft: '12px',
          marginRight: '20%'
        }
      }),
      style: {
        backgroundColor: sourceButton.backgroundColor,
        color: '#ffffff',
        textAlign: 'left',
        width: '100%'
      },
      label: name
    });
  });

  return _react2.default.createElement(
    _cloudsponge2.default,
    _extends({
      afterSubmitContacts: afterSubmitContacts,
      browserContactCacheMin: 0,
      displaySelectAllNone: true,
      ignoreMultipleEmails: true,
      initiallySelectedContacts: true,
      inlineOauth: false,
      include: ['name', 'email'],
      skipSourceMenu: true,
      sources: ['gmail', 'yahoo', 'windowslive', 'icloud', 'linkedin'],
      style: _extends({}, { textAlign: 'left', listStyle: 'none' }, parentStyle),
      childStyle: _extends({}, { padding: '2px 50px', textAlign: 'center' }, buttonStyle)
    }, other),
    sources
  );
};

TCContactImport.propTypes = {
  afterSubmitContacts: _react.PropTypes.func.isRequired,
  buttonStyle: _react.PropTypes.object,
  parentStyle: _react.PropTypes.object
};

exports.default = TCContactImport;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.startLoadingScripts = startLoadingScripts;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(503);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _utils = __webpack_require__(2742);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var loadedScript = [];
var pendingScripts = {};
var failedScript = [];

function startLoadingScripts(scripts) {
  var onComplete = arguments.length <= 1 || arguments[1] === undefined ? _utils.noop : arguments[1];

  // sequence load
  var loadNewScript = function loadNewScript(src) {
    if (loadedScript.indexOf(src) < 0) {
      return function (taskComplete) {
        var callbacks = pendingScripts[src] || [];
        callbacks.push(taskComplete);
        pendingScripts[src] = callbacks;
        if (callbacks.length === 1) {
          return (0, _utils.newScript)(src)(function (err) {
            pendingScripts[src].forEach(function (cb) {
              return cb(err, src);
            });
            delete pendingScripts[src];
          });
        }
      };
    }
  };
  var tasks = scripts.map(function (src) {
    if (Array.isArray(src)) {
      return src.map(loadNewScript);
    } else return loadNewScript(src);
  });

  _utils.series.apply(undefined, _toConsumableArray(tasks))(function (err, src) {
    if (err) {
      failedScript.push(src);
    } else {
      if (Array.isArray(src)) {
        src.forEach(addCache);
      } else addCache(src);
    }
  })(function (err) {
    removeFailedScript();
    onComplete(err);
  });
}

var addCache = function addCache(entry) {
  if (loadedScript.indexOf(entry) < 0) {
    loadedScript.push(entry);
  }
};

var removeFailedScript = function removeFailedScript() {
  if (failedScript.length > 0) {
    failedScript.forEach(function (script) {
      var node = document.querySelector('script[src=\'' + script + '\']');
      if (node != null) {
        node.parentNode.removeChild(node);
      }
    });

    failedScript = [];
  }
};

var scriptLoader = function scriptLoader() {
  for (var _len = arguments.length, scripts = Array(_len), _key = 0; _key < _len; _key++) {
    scripts[_key] = arguments[_key];
  }

  return function (WrappedComponent) {
    var ScriptLoader = function (_Component) {
      _inherits(ScriptLoader, _Component);

      function ScriptLoader(props, context) {
        _classCallCheck(this, ScriptLoader);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ScriptLoader).call(this, props, context));

        _this.state = {
          isScriptLoaded: false,
          isScriptLoadSucceed: false
        };

        _this._isMounted = false;
        return _this;
      }

      _createClass(ScriptLoader, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          this._isMounted = true;
          startLoadingScripts(scripts, function (err) {
            if (_this2._isMounted) {
              _this2.setState({
                isScriptLoaded: true,
                isScriptLoadSucceed: !err
              }, function () {
                if (!err) {
                  _this2.props.onScriptLoaded();
                }
              });
            }
          });
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this._isMounted = false;
        }
      }, {
        key: 'render',
        value: function render() {
          var props = _extends({}, this.props, this.state);

          return _react2.default.createElement(WrappedComponent, props);
        }
      }]);

      return ScriptLoader;
    }(_react.Component);

    ScriptLoader.propTypes = {
      onScriptLoaded: _react.PropTypes.func
    };
    ScriptLoader.defaultProps = {
      onScriptLoaded: _utils.noop
    };


    return (0, _hoistNonReactStatics2.default)(ScriptLoader, WrappedComponent);
  };
};

exports.default = scriptLoader;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _helperFunctions = __webpack_require__(1116);

var _uploadModal = __webpack_require__(2743);

var _uploadModal2 = _interopRequireDefault(_uploadModal);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var XLSX = window.XLSX;


var isNilOrEmpty = (0, _ramda.either)(_ramda.isEmpty, _ramda.isNil);

var CSVUploadContainer = function (_Component) {
  _inherits(CSVUploadContainer, _Component);

  function CSVUploadContainer(props) {
    _classCallCheck(this, CSVUploadContainer);

    var _this = _possibleConstructorReturn(this, (CSVUploadContainer.__proto__ || Object.getPrototypeOf(CSVUploadContainer)).call(this, props));

    _this.onDrop = function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          file = _ref2[0];

      if (!file) return;
      if (_this.state.CSVHeaderMismatch) _this.setState({ CSVHeaderMismatch: false });
      if (file.type.indexOf('.csv') > -1 || file.type.indexOf('/csv') > -1 || file.type === 'application/vnd.ms-excel' && file.name.indexOf('.csv') > -1) {
        // third check is for csv files on excel
        _this.setState({
          processing: true
        });
        var reader = new FileReader();
        reader.onload = function (e) {
          var fileContents = e.target.result;
          var processedRows = (0, _helperFunctions.convertCSV)(fileContents, _this.props.headers);
          if (processedRows.CSVHeaderMismatch) _this.setState({ CSVHeaderMismatch: true });
          if (_this.props.showFailedSection) {
            if ((0, _ramda.not)(isNilOrEmpty(processedRows.failedRows))) _this.setState({ successfulContacts: processedRows.successfulRows, contactsWithErrors: processedRows.failedRows });else _this.props.onCompleteFunc(processedRows.successfulRows, processedRows.failedRows);
          }
          if (!_this.props.showFailedSection && !_this.state.CSVHeaderMismatch) _this.props.onCompleteFunc(processedRows.successfulRows, processedRows.failedRows);
          _this.setState({
            processing: false
          });
        };
        reader.readAsText(file);
      } else if (file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        _this.setState({
          processing: true
        });
        var _reader = new FileReader();
        _reader.onload = function (e) {
          var binary = '';
          var data = e.target.result;
          var bytes = new Uint8Array(data);
          var length = bytes.byteLength;

          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }

          var workbook = XLSX.read(binary, { type: 'binary' });
          var csv = XLSX.utils.sheet_to_csv(workbook.Sheets[workbook.SheetNames[0]]);
          var processedRows = (0, _helperFunctions.convertCSV)(csv, _this.props.headers);
          if (processedRows.CSVHeaderMismatch) _this.setState({ CSVHeaderMismatch: true });
          if (_this.props.showFailedSection) {
            if ((0, _ramda.not)(isNilOrEmpty(processedRows.failedRows))) _this.setState({ successfulContacts: processedRows.successfulRows, contactsWithErrors: processedRows.failedRows });else _this.props.onCompleteFunc(processedRows.successfulRows, processedRows.failedRows);
          }
          if (!_this.props.showFailedSection && !_this.state.CSVHeaderMismatch) _this.props.onCompleteFunc(processedRows.successfulRows, processedRows.failedRows);
          _this.setState({
            processing: false
          });
        };
        _reader.readAsArrayBuffer(file);
      } else {
        alert('Please upload a valid excel or csv file!');
      }
    };

    _this.state = {
      successfulContacts: [],
      contactsWithErrors: [],
      processing: false,
      CSVHeaderMismatch: false
    };
    return _this;
  }

  _createClass(CSVUploadContainer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          open = _props.open,
          _onRequestClose = _props.onRequestClose,
          dialogTitle = _props.dialogTitle,
          note = _props.note,
          dropzoneText = _props.dropzoneText,
          _onCompleteFunc = _props.onCompleteFunc,
          showFailedSection = _props.showFailedSection,
          additFixErrorsFunc = _props.additFixErrorsFunc;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_uploadModal2.default, {
          open: open,
          onRequestClose: function onRequestClose() {
            _this2.setState({
              successfulContacts: [],
              contactsWithErrors: [],
              processing: false
            });
            _onRequestClose();
          },
          onDrop: this.onDrop,
          dialogTitle: dialogTitle,
          note: note,
          dropzoneText: dropzoneText,
          showFailedSection: showFailedSection,
          failedRows: this.state.contactsWithErrors,
          numOfSuccessfulRows: (0, _ramda.path)(['successfulContacts', 'length'], this.state),
          onCompleteFunc: function onCompleteFunc() {
            return _onCompleteFunc(_this2.state.successfulContacts);
          },
          CSVHeaderMismatch: this.state.CSVHeaderMismatch,
          processing: this.state.processing,
          additFixErrorsFunc: additFixErrorsFunc
        })
      );
    }
  }]);

  return CSVUploadContainer;
}(_react.Component);

CSVUploadContainer.propTypes = {
  open: _react.PropTypes.bool,
  onRequestClose: _react.PropTypes.func,
  dialogTitle: _react.PropTypes.string,
  note: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
  dropzoneText: _react.PropTypes.string,
  onCompleteFunc: _react.PropTypes.func, // if showFailedSection and user clicks upload successful contacts, this will only receive successfulrows
  headers: _react.PropTypes.array,
  additFixErrorsFunc: _react.PropTypes.func, // any additional funcs needed for fix errors
  showFailedSection: _react.PropTypes.bool // if true && there are failed rows, user will see which rows failed. if false, onCompleteFunc will run
};

exports.default = CSVUploadContainer;

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Papa Parse
	v4.3.3
	https://github.com/mholt/PapaParse
	License: MIT
*/
(function(root, factory)
{
	if (true)
	{
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module === 'object' && typeof exports !== 'undefined')
	{
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	}
	else
	{
		// Browser globals (root is window)
		root.Papa = factory();
	}
}(this, function()
{
	'use strict';

	var global = (function () {
		// alternative method, similar to `Function('return this')()`
		// but without using `eval` (which is disabled when
		// using Content Security Policy).

		if (typeof self !== 'undefined') { return self; }
		if (typeof window !== 'undefined') { return window; }
		if (typeof global !== 'undefined') { return global; }

		// When running tests none of the above have been defined
		return {};
	})();


	var IS_WORKER = !global.document && !!global.postMessage,
		IS_PAPA_WORKER = IS_WORKER && /(\?|&)papaworker(=|&|$)/.test(global.location.search),
		LOADED_SYNC = false, AUTO_SCRIPT_PATH;
	var workers = {}, workerIdCounter = 0;

	var Papa = {};

	Papa.parse = CsvToJson;
	Papa.unparse = JsonToCsv;

	Papa.RECORD_SEP = String.fromCharCode(30);
	Papa.UNIT_SEP = String.fromCharCode(31);
	Papa.BYTE_ORDER_MARK = '\ufeff';
	Papa.BAD_DELIMITERS = ['\r', '\n', '"', Papa.BYTE_ORDER_MARK];
	Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
	Papa.SCRIPT_PATH = null;	// Must be set by your code if you use workers and this lib is loaded asynchronously

	// Configurable chunk sizes for local and remote files, respectively
	Papa.LocalChunkSize = 1024 * 1024 * 10;	// 10 MB
	Papa.RemoteChunkSize = 1024 * 1024 * 5;	// 5 MB
	Papa.DefaultDelimiter = ',';			// Used if not specified and detection fails

	// Exposed for testing and development only
	Papa.Parser = Parser;
	Papa.ParserHandle = ParserHandle;
	Papa.NetworkStreamer = NetworkStreamer;
	Papa.FileStreamer = FileStreamer;
	Papa.StringStreamer = StringStreamer;
	Papa.ReadableStreamStreamer = ReadableStreamStreamer;

	if (global.jQuery)
	{
		var $ = global.jQuery;
		$.fn.parse = function(options)
		{
			var config = options.config || {};
			var queue = [];

			this.each(function(idx)
			{
				var supported = $(this).prop('tagName').toUpperCase() === 'INPUT'
								&& $(this).attr('type').toLowerCase() === 'file'
								&& global.FileReader;

				if (!supported || !this.files || this.files.length === 0)
					return true;	// continue to next input element

				for (var i = 0; i < this.files.length; i++)
				{
					queue.push({
						file: this.files[i],
						inputElem: this,
						instanceConfig: $.extend({}, config)
					});
				}
			});

			parseNextFile();	// begin parsing
			return this;		// maintains chainability


			function parseNextFile()
			{
				if (queue.length === 0)
				{
					if (isFunction(options.complete))
						options.complete();
					return;
				}

				var f = queue[0];

				if (isFunction(options.before))
				{
					var returned = options.before(f.file, f.inputElem);

					if (typeof returned === 'object')
					{
						if (returned.action === 'abort')
						{
							error('AbortError', f.file, f.inputElem, returned.reason);
							return;	// Aborts all queued files immediately
						}
						else if (returned.action === 'skip')
						{
							fileComplete();	// parse the next file in the queue, if any
							return;
						}
						else if (typeof returned.config === 'object')
							f.instanceConfig = $.extend(f.instanceConfig, returned.config);
					}
					else if (returned === 'skip')
					{
						fileComplete();	// parse the next file in the queue, if any
						return;
					}
				}

				// Wrap up the user's complete callback, if any, so that ours also gets executed
				var userCompleteFunc = f.instanceConfig.complete;
				f.instanceConfig.complete = function(results)
				{
					if (isFunction(userCompleteFunc))
						userCompleteFunc(results, f.file, f.inputElem);
					fileComplete();
				};

				Papa.parse(f.file, f.instanceConfig);
			}

			function error(name, file, elem, reason)
			{
				if (isFunction(options.error))
					options.error({name: name}, file, elem, reason);
			}

			function fileComplete()
			{
				queue.splice(0, 1);
				parseNextFile();
			}
		}
	}


	if (IS_PAPA_WORKER)
	{
		global.onmessage = workerThreadReceivedMessage;
	}
	else if (Papa.WORKERS_SUPPORTED)
	{
		AUTO_SCRIPT_PATH = getScriptPath();

		// Check if the script was loaded synchronously
		if (!document.body)
		{
			// Body doesn't exist yet, must be synchronous
			LOADED_SYNC = true;
		}
		else
		{
			document.addEventListener('DOMContentLoaded', function () {
				LOADED_SYNC = true;
			}, true);
		}
	}




	function CsvToJson(_input, _config)
	{
		_config = _config || {};
		var dynamicTyping = _config.dynamicTyping || false;
		if (isFunction(dynamicTyping)) {
			_config.dynamicTypingFunction = dynamicTyping;
			// Will be filled on first row call
			dynamicTyping = {};
		}
		_config.dynamicTyping = dynamicTyping;

		if (_config.worker && Papa.WORKERS_SUPPORTED)
		{
			var w = newWorker();

			w.userStep = _config.step;
			w.userChunk = _config.chunk;
			w.userComplete = _config.complete;
			w.userError = _config.error;

			_config.step = isFunction(_config.step);
			_config.chunk = isFunction(_config.chunk);
			_config.complete = isFunction(_config.complete);
			_config.error = isFunction(_config.error);
			delete _config.worker;	// prevent infinite loop

			w.postMessage({
				input: _input,
				config: _config,
				workerId: w.id
			});

			return;
		}

		var streamer = null;
		if (typeof _input === 'string')
		{
			if (_config.download)
				streamer = new NetworkStreamer(_config);
			else
				streamer = new StringStreamer(_config);
		}
		else if (_input.readable === true && isFunction(_input.read) && isFunction(_input.on))
		{
			streamer = new ReadableStreamStreamer(_config);
		}
		else if ((global.File && _input instanceof File) || _input instanceof Object)	// ...Safari. (see issue #106)
			streamer = new FileStreamer(_config);

		return streamer.stream(_input);
	}






	function JsonToCsv(_input, _config)
	{
		var _output = '';
		var _fields = [];

		// Default configuration

		/** whether to surround every datum with quotes */
		var _quotes = false;

		/** whether to write headers */
		var _writeHeader = true;

		/** delimiting character */
		var _delimiter = ',';

		/** newline character(s) */
		var _newline = '\r\n';

		/** quote character */
		var _quoteChar = '"';

		unpackConfig();

		var quoteCharRegex = new RegExp(_quoteChar, 'g');

		if (typeof _input === 'string')
			_input = JSON.parse(_input);

		if (_input instanceof Array)
		{
			if (!_input.length || _input[0] instanceof Array)
				return serialize(null, _input);
			else if (typeof _input[0] === 'object')
				return serialize(objectKeys(_input[0]), _input);
		}
		else if (typeof _input === 'object')
		{
			if (typeof _input.data === 'string')
				_input.data = JSON.parse(_input.data);

			if (_input.data instanceof Array)
			{
				if (!_input.fields)
					_input.fields =  _input.meta && _input.meta.fields;

				if (!_input.fields)
					_input.fields =  _input.data[0] instanceof Array
									? _input.fields
									: objectKeys(_input.data[0]);

				if (!(_input.data[0] instanceof Array) && typeof _input.data[0] !== 'object')
					_input.data = [_input.data];	// handles input like [1,2,3] or ['asdf']
			}

			return serialize(_input.fields || [], _input.data || []);
		}

		// Default (any valid paths should return before this)
		throw 'exception: Unable to serialize unrecognized input';


		function unpackConfig()
		{
			if (typeof _config !== 'object')
				return;

			if (typeof _config.delimiter === 'string'
				&& _config.delimiter.length === 1
				&& Papa.BAD_DELIMITERS.indexOf(_config.delimiter) === -1)
			{
				_delimiter = _config.delimiter;
			}

			if (typeof _config.quotes === 'boolean'
				|| _config.quotes instanceof Array)
				_quotes = _config.quotes;

			if (typeof _config.newline === 'string')
				_newline = _config.newline;

			if (typeof _config.quoteChar === 'string')
				_quoteChar = _config.quoteChar;

			if (typeof _config.header === 'boolean')
				_writeHeader = _config.header;
		}


		/** Turns an object's keys into an array */
		function objectKeys(obj)
		{
			if (typeof obj !== 'object')
				return [];
			var keys = [];
			for (var key in obj)
				keys.push(key);
			return keys;
		}

		/** The double for loop that iterates the data and writes out a CSV string including header row */
		function serialize(fields, data)
		{
			var csv = '';

			if (typeof fields === 'string')
				fields = JSON.parse(fields);
			if (typeof data === 'string')
				data = JSON.parse(data);

			var hasHeader = fields instanceof Array && fields.length > 0;
			var dataKeyedByField = !(data[0] instanceof Array);

			// If there a header row, write it first
			if (hasHeader && _writeHeader)
			{
				for (var i = 0; i < fields.length; i++)
				{
					if (i > 0)
						csv += _delimiter;
					csv += safe(fields[i], i);
				}
				if (data.length > 0)
					csv += _newline;
			}

			// Then write out the data
			for (var row = 0; row < data.length; row++)
			{
				var maxCol = hasHeader ? fields.length : data[row].length;

				for (var col = 0; col < maxCol; col++)
				{
					if (col > 0)
						csv += _delimiter;
					var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
					csv += safe(data[row][colIdx], col);
				}

				if (row < data.length - 1)
					csv += _newline;
			}

			return csv;
		}

		/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
		function safe(str, col)
		{
			if (typeof str === 'undefined' || str === null)
				return '';

			str = str.toString().replace(quoteCharRegex, _quoteChar+_quoteChar);

			var needsQuotes = (typeof _quotes === 'boolean' && _quotes)
							|| (_quotes instanceof Array && _quotes[col])
							|| hasAny(str, Papa.BAD_DELIMITERS)
							|| str.indexOf(_delimiter) > -1
							|| str.charAt(0) === ' '
							|| str.charAt(str.length - 1) === ' ';

			return needsQuotes ? _quoteChar + str + _quoteChar : str;
		}

		function hasAny(str, substrings)
		{
			for (var i = 0; i < substrings.length; i++)
				if (str.indexOf(substrings[i]) > -1)
					return true;
			return false;
		}
	}

	/** ChunkStreamer is the base prototype for various streamer implementations. */
	function ChunkStreamer(config)
	{
		this._handle = null;
		this._paused = false;
		this._finished = false;
		this._input = null;
		this._baseIndex = 0;
		this._partialLine = '';
		this._rowCount = 0;
		this._start = 0;
		this._nextChunk = null;
		this.isFirstChunk = true;
		this._completeResults = {
			data: [],
			errors: [],
			meta: {}
		};
		replaceConfig.call(this, config);

		this.parseChunk = function(chunk)
		{
			// First chunk pre-processing
			if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk))
			{
				var modifiedChunk = this._config.beforeFirstChunk(chunk);
				if (modifiedChunk !== undefined)
					chunk = modifiedChunk;
			}
			this.isFirstChunk = false;

			// Rejoin the line we likely just split in two by chunking the file
			var aggregate = this._partialLine + chunk;
			this._partialLine = '';

			var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);

			if (this._handle.paused() || this._handle.aborted())
				return;

			var lastIndex = results.meta.cursor;

			if (!this._finished)
			{
				this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
				this._baseIndex = lastIndex;
			}

			if (results && results.data)
				this._rowCount += results.data.length;

			var finishedIncludingPreview = this._finished || (this._config.preview && this._rowCount >= this._config.preview);

			if (IS_PAPA_WORKER)
			{
				global.postMessage({
					results: results,
					workerId: Papa.WORKER_ID,
					finished: finishedIncludingPreview
				});
			}
			else if (isFunction(this._config.chunk))
			{
				this._config.chunk(results, this._handle);
				if (this._paused)
					return;
				results = undefined;
				this._completeResults = undefined;
			}

			if (!this._config.step && !this._config.chunk) {
				this._completeResults.data = this._completeResults.data.concat(results.data);
				this._completeResults.errors = this._completeResults.errors.concat(results.errors);
				this._completeResults.meta = results.meta;
			}

			if (finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted))
				this._config.complete(this._completeResults, this._input);

			if (!finishedIncludingPreview && (!results || !results.meta.paused))
				this._nextChunk();

			return results;
		};

		this._sendError = function(error)
		{
			if (isFunction(this._config.error))
				this._config.error(error);
			else if (IS_PAPA_WORKER && this._config.error)
			{
				global.postMessage({
					workerId: Papa.WORKER_ID,
					error: error,
					finished: false
				});
			}
		};

		function replaceConfig(config)
		{
			// Deep-copy the config so we can edit it
			var configCopy = copy(config);
			configCopy.chunkSize = parseInt(configCopy.chunkSize);	// parseInt VERY important so we don't concatenate strings!
			if (!config.step && !config.chunk)
				configCopy.chunkSize = null;  // disable Range header if not streaming; bad values break IIS - see issue #196
			this._handle = new ParserHandle(configCopy);
			this._handle.streamer = this;
			this._config = configCopy;	// persist the copy to the caller
		}
	}


	function NetworkStreamer(config)
	{
		config = config || {};
		if (!config.chunkSize)
			config.chunkSize = Papa.RemoteChunkSize;
		ChunkStreamer.call(this, config);

		var xhr;

		if (IS_WORKER)
		{
			this._nextChunk = function()
			{
				this._readChunk();
				this._chunkLoaded();
			};
		}
		else
		{
			this._nextChunk = function()
			{
				this._readChunk();
			};
		}

		this.stream = function(url)
		{
			this._input = url;
			this._nextChunk();	// Starts streaming
		};

		this._readChunk = function()
		{
			if (this._finished)
			{
				this._chunkLoaded();
				return;
			}

			xhr = new XMLHttpRequest();

			if (this._config.withCredentials)
			{
				xhr.withCredentials = this._config.withCredentials;
			}

			if (!IS_WORKER)
			{
				xhr.onload = bindFunction(this._chunkLoaded, this);
				xhr.onerror = bindFunction(this._chunkError, this);
			}

			xhr.open('GET', this._input, !IS_WORKER);
			// Headers can only be set when once the request state is OPENED
			if (this._config.downloadRequestHeaders)
			{
				var headers = this._config.downloadRequestHeaders;

				for (var headerName in headers)
				{
					xhr.setRequestHeader(headerName, headers[headerName]);
				}
			}

			if (this._config.chunkSize)
			{
				var end = this._start + this._config.chunkSize - 1;	// minus one because byte range is inclusive
				xhr.setRequestHeader('Range', 'bytes='+this._start+'-'+end);
				xhr.setRequestHeader('If-None-Match', 'webkit-no-cache'); // https://bugs.webkit.org/show_bug.cgi?id=82672
			}

			try {
				xhr.send();
			}
			catch (err) {
				this._chunkError(err.message);
			}

			if (IS_WORKER && xhr.status === 0)
				this._chunkError();
			else
				this._start += this._config.chunkSize;
		}

		this._chunkLoaded = function()
		{
			if (xhr.readyState != 4)
				return;

			if (xhr.status < 200 || xhr.status >= 400)
			{
				this._chunkError();
				return;
			}

			this._finished = !this._config.chunkSize || this._start > getFileSize(xhr);
			this.parseChunk(xhr.responseText);
		}

		this._chunkError = function(errorMessage)
		{
			var errorText = xhr.statusText || errorMessage;
			this._sendError(errorText);
		}

		function getFileSize(xhr)
		{
			var contentRange = xhr.getResponseHeader('Content-Range');
			if (contentRange === null) { // no content range, then finish!
					return -1;
					}
			return parseInt(contentRange.substr(contentRange.lastIndexOf('/') + 1));
		}
	}
	NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
	NetworkStreamer.prototype.constructor = NetworkStreamer;


	function FileStreamer(config)
	{
		config = config || {};
		if (!config.chunkSize)
			config.chunkSize = Papa.LocalChunkSize;
		ChunkStreamer.call(this, config);

		var reader, slice;

		// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
		// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
		var usingAsyncReader = typeof FileReader !== 'undefined';	// Safari doesn't consider it a function - see issue #105

		this.stream = function(file)
		{
			this._input = file;
			slice = file.slice || file.webkitSlice || file.mozSlice;

			if (usingAsyncReader)
			{
				reader = new FileReader();		// Preferred method of reading files, even in workers
				reader.onload = bindFunction(this._chunkLoaded, this);
				reader.onerror = bindFunction(this._chunkError, this);
			}
			else
				reader = new FileReaderSync();	// Hack for running in a web worker in Firefox

			this._nextChunk();	// Starts streaming
		};

		this._nextChunk = function()
		{
			if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview))
				this._readChunk();
		}

		this._readChunk = function()
		{
			var input = this._input;
			if (this._config.chunkSize)
			{
				var end = Math.min(this._start + this._config.chunkSize, this._input.size);
				input = slice.call(input, this._start, end);
			}
			var txt = reader.readAsText(input, this._config.encoding);
			if (!usingAsyncReader)
				this._chunkLoaded({ target: { result: txt } });	// mimic the async signature
		}

		this._chunkLoaded = function(event)
		{
			// Very important to increment start each time before handling results
			this._start += this._config.chunkSize;
			this._finished = !this._config.chunkSize || this._start >= this._input.size;
			this.parseChunk(event.target.result);
		}

		this._chunkError = function()
		{
			this._sendError(reader.error);
		}

	}
	FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
	FileStreamer.prototype.constructor = FileStreamer;


	function StringStreamer(config)
	{
		config = config || {};
		ChunkStreamer.call(this, config);

		var string;
		var remaining;
		this.stream = function(s)
		{
			string = s;
			remaining = s;
			return this._nextChunk();
		}
		this._nextChunk = function()
		{
			if (this._finished) return;
			var size = this._config.chunkSize;
			var chunk = size ? remaining.substr(0, size) : remaining;
			remaining = size ? remaining.substr(size) : '';
			this._finished = !remaining;
			return this.parseChunk(chunk);
		}
	}
	StringStreamer.prototype = Object.create(StringStreamer.prototype);
	StringStreamer.prototype.constructor = StringStreamer;


	function ReadableStreamStreamer(config)
	{
		config = config || {};

		ChunkStreamer.call(this, config);

		var queue = [];
		var parseOnData = true;

		this.stream = function(stream)
		{
			this._input = stream;

			this._input.on('data', this._streamData);
			this._input.on('end', this._streamEnd);
			this._input.on('error', this._streamError);
		}

		this._nextChunk = function()
		{
			if (queue.length)
			{
				this.parseChunk(queue.shift());
			}
			else
			{
				parseOnData = true;
			}
		}

		this._streamData = bindFunction(function(chunk)
		{
			try
			{
				queue.push(typeof chunk === 'string' ? chunk : chunk.toString(this._config.encoding));

				if (parseOnData)
				{
					parseOnData = false;
					this.parseChunk(queue.shift());
				}
			}
			catch (error)
			{
				this._streamError(error);
			}
		}, this);

		this._streamError = bindFunction(function(error)
		{
			this._streamCleanUp();
			this._sendError(error.message);
		}, this);

		this._streamEnd = bindFunction(function()
		{
			this._streamCleanUp();
			this._finished = true;
			this._streamData('');
		}, this);

		this._streamCleanUp = bindFunction(function()
		{
			this._input.removeListener('data', this._streamData);
			this._input.removeListener('end', this._streamEnd);
			this._input.removeListener('error', this._streamError);
		}, this);
	}
	ReadableStreamStreamer.prototype = Object.create(ChunkStreamer.prototype);
	ReadableStreamStreamer.prototype.constructor = ReadableStreamStreamer;


	// Use one ParserHandle per entire CSV file or string
	function ParserHandle(_config)
	{
		// One goal is to minimize the use of regular expressions...
		var FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;

		var self = this;
		var _stepCounter = 0;	// Number of times step was called (number of rows parsed)
		var _input;				// The input being parsed
		var _parser;			// The core parser being used
		var _paused = false;	// Whether we are paused or not
		var _aborted = false;	// Whether the parser has aborted or not
		var _delimiterError;	// Temporary state between delimiter detection and processing results
		var _fields = [];		// Fields are from the header row of the input, if there is one
		var _results = {		// The last results returned from the parser
			data: [],
			errors: [],
			meta: {}
		};

		if (isFunction(_config.step))
		{
			var userStep = _config.step;
			_config.step = function(results)
			{
				_results = results;

				if (needsHeaderRow())
					processResults();
				else	// only call user's step function after header row
				{
					processResults();

					// It's possbile that this line was empty and there's no row here after all
					if (_results.data.length === 0)
						return;

					_stepCounter += results.data.length;
					if (_config.preview && _stepCounter > _config.preview)
						_parser.abort();
					else
						userStep(_results, self);
				}
			};
		}

		/**
		 * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
		 * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
		 * when an input comes in multiple chunks, like from a file.
		 */
		this.parse = function(input, baseIndex, ignoreLastRow)
		{
			if (!_config.newline)
				_config.newline = guessLineEndings(input);

			_delimiterError = false;
			if (!_config.delimiter)
			{
				var delimGuess = guessDelimiter(input, _config.newline);
				if (delimGuess.successful)
					_config.delimiter = delimGuess.bestDelimiter;
				else
				{
					_delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
					_config.delimiter = Papa.DefaultDelimiter;
				}
				_results.meta.delimiter = _config.delimiter;
			}
			else if(isFunction(_config.delimiter))
			{
				_config.delimiter = _config.delimiter(input);
				_results.meta.delimiter = _config.delimiter;
			}

			var parserConfig = copy(_config);
			if (_config.preview && _config.header)
				parserConfig.preview++;	// to compensate for header row

			_input = input;
			_parser = new Parser(parserConfig);
			_results = _parser.parse(_input, baseIndex, ignoreLastRow);
			processResults();
			return _paused ? { meta: { paused: true } } : (_results || { meta: { paused: false } });
		};

		this.paused = function()
		{
			return _paused;
		};

		this.pause = function()
		{
			_paused = true;
			_parser.abort();
			_input = _input.substr(_parser.getCharIndex());
		};

		this.resume = function()
		{
			_paused = false;
			self.streamer.parseChunk(_input);
		};

		this.aborted = function ()
		{
			return _aborted;
		};

		this.abort = function()
		{
			_aborted = true;
			_parser.abort();
			_results.meta.aborted = true;
			if (isFunction(_config.complete))
				_config.complete(_results);
			_input = '';
		};

		function processResults()
		{
			if (_results && _delimiterError)
			{
				addError('Delimiter', 'UndetectableDelimiter', 'Unable to auto-detect delimiting character; defaulted to \''+Papa.DefaultDelimiter+'\'');
				_delimiterError = false;
			}

			if (_config.skipEmptyLines)
			{
				for (var i = 0; i < _results.data.length; i++)
					if (_results.data[i].length === 1 && _results.data[i][0] === '')
						_results.data.splice(i--, 1);
			}

			if (needsHeaderRow())
				fillHeaderFields();

			return applyHeaderAndDynamicTyping();
		}

		function needsHeaderRow()
		{
			return _config.header && _fields.length === 0;
		}

		function fillHeaderFields()
		{
			if (!_results)
				return;
			for (var i = 0; needsHeaderRow() && i < _results.data.length; i++)
				for (var j = 0; j < _results.data[i].length; j++)
					_fields.push(_results.data[i][j]);
			_results.data.splice(0, 1);
		}

		function shouldApplyDynamicTyping(field) {
			// Cache function values to avoid calling it for each row
			if (_config.dynamicTypingFunction && _config.dynamicTyping[field] === undefined) {
				_config.dynamicTyping[field] = _config.dynamicTypingFunction(field);
			}
			return (_config.dynamicTyping[field] || _config.dynamicTyping) === true
		}

		function parseDynamic(field, value)
		{
			if (shouldApplyDynamicTyping(field))
			{
				if (value === 'true' || value === 'TRUE')
					return true;
				else if (value === 'false' || value === 'FALSE')
					return false;
				else
					return tryParseFloat(value);
			}
			return value;
		}

		function applyHeaderAndDynamicTyping()
		{
			if (!_results || (!_config.header && !_config.dynamicTyping))
				return _results;

			for (var i = 0; i < _results.data.length; i++)
			{
				var row = _config.header ? {} : [];

				for (var j = 0; j < _results.data[i].length; j++)
				{
					var field = j;
					var value = _results.data[i][j];

					if (_config.header)
						field = j >= _fields.length ? '__parsed_extra' : _fields[j];

					value = parseDynamic(field, value);

					if (field === '__parsed_extra')
					{
						row[field] = row[field] || [];
						row[field].push(value);
					}
					else
						row[field] = value;
				}

				_results.data[i] = row;

				if (_config.header)
				{
					if (j > _fields.length)
						addError('FieldMismatch', 'TooManyFields', 'Too many fields: expected ' + _fields.length + ' fields but parsed ' + j, i);
					else if (j < _fields.length)
						addError('FieldMismatch', 'TooFewFields', 'Too few fields: expected ' + _fields.length + ' fields but parsed ' + j, i);
				}
			}

			if (_config.header && _results.meta)
				_results.meta.fields = _fields;
			return _results;
		}

		function guessDelimiter(input, newline)
		{
			var delimChoices = [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP];
			var bestDelim, bestDelta, fieldCountPrevRow;

			for (var i = 0; i < delimChoices.length; i++)
			{
				var delim = delimChoices[i];
				var delta = 0, avgFieldCount = 0;
				fieldCountPrevRow = undefined;

				var preview = new Parser({
					delimiter: delim,
					newline: newline,
					preview: 10
				}).parse(input);

				for (var j = 0; j < preview.data.length; j++)
				{
					var fieldCount = preview.data[j].length;
					avgFieldCount += fieldCount;

					if (typeof fieldCountPrevRow === 'undefined')
					{
						fieldCountPrevRow = fieldCount;
						continue;
					}
					else if (fieldCount > 1)
					{
						delta += Math.abs(fieldCount - fieldCountPrevRow);
						fieldCountPrevRow = fieldCount;
					}
				}

				if (preview.data.length > 0)
					avgFieldCount /= preview.data.length;

				if ((typeof bestDelta === 'undefined' || delta < bestDelta)
					&& avgFieldCount > 1.99)
				{
					bestDelta = delta;
					bestDelim = delim;
				}
			}

			_config.delimiter = bestDelim;

			return {
				successful: !!bestDelim,
				bestDelimiter: bestDelim
			}
		}

		function guessLineEndings(input)
		{
			input = input.substr(0, 1024*1024);	// max length 1 MB

			var r = input.split('\r');

			var n = input.split('\n');

			var nAppearsFirst = (n.length > 1 && n[0].length < r[0].length);

			if (r.length === 1 || nAppearsFirst)
				return '\n';

			var numWithN = 0;
			for (var i = 0; i < r.length; i++)
			{
				if (r[i][0] === '\n')
					numWithN++;
			}

			return numWithN >= r.length / 2 ? '\r\n' : '\r';
		}

		function tryParseFloat(val)
		{
			var isNumber = FLOAT.test(val);
			return isNumber ? parseFloat(val) : val;
		}

		function addError(type, code, msg, row)
		{
			_results.errors.push({
				type: type,
				code: code,
				message: msg,
				row: row
			});
		}
	}





	/** The core parser implements speedy and correct CSV parsing */
	function Parser(config)
	{
		// Unpack the config object
		config = config || {};
		var delim = config.delimiter;
		var newline = config.newline;
		var comments = config.comments;
		var step = config.step;
		var preview = config.preview;
		var fastMode = config.fastMode;
		var quoteChar = config.quoteChar || '"';

		// Delimiter must be valid
		if (typeof delim !== 'string'
			|| Papa.BAD_DELIMITERS.indexOf(delim) > -1)
			delim = ',';

		// Comment character must be valid
		if (comments === delim)
			throw 'Comment character same as delimiter';
		else if (comments === true)
			comments = '#';
		else if (typeof comments !== 'string'
			|| Papa.BAD_DELIMITERS.indexOf(comments) > -1)
			comments = false;

		// Newline must be valid: \r, \n, or \r\n
		if (newline != '\n' && newline != '\r' && newline != '\r\n')
			newline = '\n';

		// We're gonna need these at the Parser scope
		var cursor = 0;
		var aborted = false;

		this.parse = function(input, baseIndex, ignoreLastRow)
		{
			// For some reason, in Chrome, this speeds things up (!?)
			if (typeof input !== 'string')
				throw 'Input must be a string';

			// We don't need to compute some of these every time parse() is called,
			// but having them in a more local scope seems to perform better
			var inputLen = input.length,
				delimLen = delim.length,
				newlineLen = newline.length,
				commentsLen = comments.length;
			var stepIsFunction = isFunction(step);

			// Establish starting state
			cursor = 0;
			var data = [], errors = [], row = [], lastCursor = 0;

			if (!input)
				return returnable();

			if (fastMode || (fastMode !== false && input.indexOf(quoteChar) === -1))
			{
				var rows = input.split(newline);
				for (var i = 0; i < rows.length; i++)
				{
					var row = rows[i];
					cursor += row.length;
					if (i !== rows.length - 1)
						cursor += newline.length;
					else if (ignoreLastRow)
						return returnable();
					if (comments && row.substr(0, commentsLen) === comments)
						continue;
					if (stepIsFunction)
					{
						data = [];
						pushRow(row.split(delim));
						doStep();
						if (aborted)
							return returnable();
					}
					else
						pushRow(row.split(delim));
					if (preview && i >= preview)
					{
						data = data.slice(0, preview);
						return returnable(true);
					}
				}
				return returnable();
			}

			var nextDelim = input.indexOf(delim, cursor);
			var nextNewline = input.indexOf(newline, cursor);
			var quoteCharRegex = new RegExp(quoteChar+quoteChar, 'g');

			// Parser loop
			for (;;)
			{
				// Field has opening quote
				if (input[cursor] === quoteChar)
				{
					// Start our search for the closing quote where the cursor is
					var quoteSearch = cursor;

					// Skip the opening quote
					cursor++;

					for (;;)
					{
						// Find closing quote
						var quoteSearch = input.indexOf(quoteChar, quoteSearch+1);

						if (quoteSearch === -1)
						{
							if (!ignoreLastRow) {
								// No closing quote... what a pity
								errors.push({
									type: 'Quotes',
									code: 'MissingQuotes',
									message: 'Quoted field unterminated',
									row: data.length,	// row has yet to be inserted
									index: cursor
								});
							}
							return finish();
						}

						if (quoteSearch === inputLen-1)
						{
							// Closing quote at EOF
							var value = input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar);
							return finish(value);
						}

						// If this quote is escaped, it's part of the data; skip it
						if (input[quoteSearch+1] === quoteChar)
						{
							quoteSearch++;
							continue;
						}

						if (input[quoteSearch+1] === delim)
						{
							// Closing quote followed by delimiter
							row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
							cursor = quoteSearch + 1 + delimLen;
							nextDelim = input.indexOf(delim, cursor);
							nextNewline = input.indexOf(newline, cursor);
							break;
						}

						if (input.substr(quoteSearch+1, newlineLen) === newline)
						{
							// Closing quote followed by newline
							row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
							saveRow(quoteSearch + 1 + newlineLen);
							nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field

							if (stepIsFunction)
							{
								doStep();
								if (aborted)
									return returnable();
							}

							if (preview && data.length >= preview)
								return returnable(true);

							break;
						}
					}

					continue;
				}

				// Comment found at start of new line
				if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments)
				{
					if (nextNewline === -1)	// Comment ends at EOF
						return returnable();
					cursor = nextNewline + newlineLen;
					nextNewline = input.indexOf(newline, cursor);
					nextDelim = input.indexOf(delim, cursor);
					continue;
				}

				// Next delimiter comes before next newline, so we've reached end of field
				if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1))
				{
					row.push(input.substring(cursor, nextDelim));
					cursor = nextDelim + delimLen;
					nextDelim = input.indexOf(delim, cursor);
					continue;
				}

				// End of row
				if (nextNewline !== -1)
				{
					row.push(input.substring(cursor, nextNewline));
					saveRow(nextNewline + newlineLen);

					if (stepIsFunction)
					{
						doStep();
						if (aborted)
							return returnable();
					}

					if (preview && data.length >= preview)
						return returnable(true);

					continue;
				}

				break;
			}


			return finish();


			function pushRow(row)
			{
				data.push(row);
				lastCursor = cursor;
			}

			/**
			 * Appends the remaining input from cursor to the end into
			 * row, saves the row, calls step, and returns the results.
			 */
			function finish(value)
			{
				if (ignoreLastRow)
					return returnable();
				if (typeof value === 'undefined')
					value = input.substr(cursor);
				row.push(value);
				cursor = inputLen;	// important in case parsing is paused
				pushRow(row);
				if (stepIsFunction)
					doStep();
				return returnable();
			}

			/**
			 * Appends the current row to the results. It sets the cursor
			 * to newCursor and finds the nextNewline. The caller should
			 * take care to execute user's step function and check for
			 * preview and end parsing if necessary.
			 */
			function saveRow(newCursor)
			{
				cursor = newCursor;
				pushRow(row);
				row = [];
				nextNewline = input.indexOf(newline, cursor);
			}

			/** Returns an object with the results, errors, and meta. */
			function returnable(stopped)
			{
				return {
					data: data,
					errors: errors,
					meta: {
						delimiter: delim,
						linebreak: newline,
						aborted: aborted,
						truncated: !!stopped,
						cursor: lastCursor + (baseIndex || 0)
					}
				};
			}

			/** Executes the user's step function and resets data & errors. */
			function doStep()
			{
				step(returnable());
				data = [], errors = [];
			}
		};

		/** Sets the abort flag */
		this.abort = function()
		{
			aborted = true;
		};

		/** Gets the cursor position */
		this.getCharIndex = function()
		{
			return cursor;
		};
	}


	// If you need to load Papa Parse asynchronously and you also need worker threads, hard-code
	// the script path here. See: https://github.com/mholt/PapaParse/issues/87#issuecomment-57885358
	function getScriptPath()
	{
		var scripts = document.getElementsByTagName('script');
		return scripts.length ? scripts[scripts.length - 1].src : '';
	}

	function newWorker()
	{
		if (!Papa.WORKERS_SUPPORTED)
			return false;
		if (!LOADED_SYNC && Papa.SCRIPT_PATH === null)
			throw new Error(
				'Script path cannot be determined automatically when Papa Parse is loaded asynchronously. ' +
				'You need to set Papa.SCRIPT_PATH manually.'
			);
		var workerUrl = Papa.SCRIPT_PATH || AUTO_SCRIPT_PATH;
		// Append 'papaworker' to the search string to tell papaparse that this is our worker.
		workerUrl += (workerUrl.indexOf('?') !== -1 ? '&' : '?') + 'papaworker';
		var w = new global.Worker(workerUrl);
		w.onmessage = mainThreadReceivedMessage;
		w.id = workerIdCounter++;
		workers[w.id] = w;
		return w;
	}

	/** Callback when main thread receives a message */
	function mainThreadReceivedMessage(e)
	{
		var msg = e.data;
		var worker = workers[msg.workerId];
		var aborted = false;

		if (msg.error)
			worker.userError(msg.error, msg.file);
		else if (msg.results && msg.results.data)
		{
			var abort = function() {
				aborted = true;
				completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
			};

			var handle = {
				abort: abort,
				pause: notImplemented,
				resume: notImplemented
			};

			if (isFunction(worker.userStep))
			{
				for (var i = 0; i < msg.results.data.length; i++)
				{
					worker.userStep({
						data: [msg.results.data[i]],
						errors: msg.results.errors,
						meta: msg.results.meta
					}, handle);
					if (aborted)
						break;
				}
				delete msg.results;	// free memory ASAP
			}
			else if (isFunction(worker.userChunk))
			{
				worker.userChunk(msg.results, handle, msg.file);
				delete msg.results;
			}
		}

		if (msg.finished && !aborted)
			completeWorker(msg.workerId, msg.results);
	}

	function completeWorker(workerId, results) {
		var worker = workers[workerId];
		if (isFunction(worker.userComplete))
			worker.userComplete(results);
		worker.terminate();
		delete workers[workerId];
	}

	function notImplemented() {
		throw 'Not implemented.';
	}

	/** Callback when worker thread receives a message */
	function workerThreadReceivedMessage(e)
	{
		var msg = e.data;

		if (typeof Papa.WORKER_ID === 'undefined' && msg)
			Papa.WORKER_ID = msg.workerId;

		if (typeof msg.input === 'string')
		{
			global.postMessage({
				workerId: Papa.WORKER_ID,
				results: Papa.parse(msg.input, msg.config),
				finished: true
			});
		}
		else if ((global.File && msg.input instanceof File) || msg.input instanceof Object)	// thank you, Safari (see issue #106)
		{
			var results = Papa.parse(msg.input, msg.config);
			if (results)
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: results,
					finished: true
				});
		}
	}

	/** Makes a deep copy of an array or object (mostly) */
	function copy(obj)
	{
		if (typeof obj !== 'object')
			return obj;
		var cpy = obj instanceof Array ? [] : {};
		for (var key in obj)
			cpy[key] = copy(obj[key]);
		return cpy;
	}

	function bindFunction(f, self)
	{
		return function() { f.apply(self, arguments); };
	}

	function isFunction(func)
	{
		return typeof func === 'function';
	}

	return Papa;
}));


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPerson = function SocialPerson(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' })
  );
};
SocialPerson = (0, _pure2.default)(SocialPerson);
SocialPerson.displayName = 'SocialPerson';
SocialPerson.muiName = 'SvgIcon';

exports.default = SocialPerson;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionChromeReaderMode = function ActionChromeReaderMode(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z' })
  );
};
ActionChromeReaderMode = (0, _pure2.default)(ActionChromeReaderMode);
ActionChromeReaderMode.displayName = 'ActionChromeReaderMode';
ActionChromeReaderMode.muiName = 'SvgIcon';

exports.default = ActionChromeReaderMode;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _rateFormatSelection = __webpack_require__(1224);

var _rateFormatSelection2 = _interopRequireDefault(_rateFormatSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorMessage = function ErrorMessage(_ref) {
  var retryFn = _ref.retryFn,
      onRequestClose = _ref.onRequestClose;
  return _react2.default.createElement(
    'div',
    null,
    'Could not generate the report',
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'a',
      { href: 'javascript:void(0)', onClick: onRequestClose },
      'cancel'
    ),
    ', ',
    _react2.default.createElement(
      'a',
      { href: 'javascript:void(0);', onClick: function onClick() {
          retryFn();
        } },
      'retry'
    ),
    '\xA0or ',
    _react2.default.createElement(
      'a',
      { href: 'javascript:void(0);', onClick: function onClick() {
          window.Intercom('show');
        } },
      'contact support.'
    )
  );
};

var DownloadPopover = function (_Component) {
  _inherits(DownloadPopover, _Component);

  function DownloadPopover() {
    _classCallCheck(this, DownloadPopover);

    return _possibleConstructorReturn(this, (DownloadPopover.__proto__ || Object.getPrototypeOf(DownloadPopover)).call(this));
  }

  _createClass(DownloadPopover, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.open && nextProps.open) {
        if (window.location.href.indexOf('assets-landing') === -1 && (localStorage.getItem('doNotShowRateFormatPop') === 'true' || localStorage.getItem('doNotShowRateFormatPop') === true)) {
          this.props.download({});
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          download = _props.download,
          downloadedCount = _props.downloadedCount,
          error = _props.error,
          loading = _props.loading,
          onRequestClose = _props.onRequestClose,
          open = _props.open,
          success = _props.success,
          updateProps = _props.updateProps,
          validLengthForBulkDownload = _props.validLengthForBulkDownload,
          wouldYouAcceptDialog = _props.wouldYouAcceptDialog,
          acceptRates = _props.acceptRates,
          retryFn = _props.retryFn,
          downloadUrl = _props.downloadUrl,
          contractIds = _props.contractIds,
          templateIds = _props.templateIds,
          templates = _props.templates,
          _props$alContractIds = _props.alContractIds,
          alContractIds = _props$alContractIds === undefined ? [] : _props$alContractIds,
          downloadRateFormat = _props.downloadRateFormat;

      var multi = function () {
        // if (!isAdmin) return false; // lock down to only admins
        if (templates && templates.length > 1) return true;
        if (contractIds && contractIds.length > 1) return true;
        if (templateIds && templateIds.length > 1) return true;
        return false;
      }();
      var updateDownloadType = function updateDownloadType(type) {
        updateProps({ downloadRateFormat: type });
        if (localStorage) localStorage.setItem('rateFormat', type);
      };
      var onCheck = function onCheck(_, checked) {
        return localStorage.setItem('doNotShowRateFormatPop', checked);
      };
      var downloadAllInOne = function downloadAllInOne() {
        updateProps({ downloadRateFormat: 'quickview_summarized_singlefile' });
        download();
      };
      return _react2.default.createElement(
        'div',
        {
          style: {
            display: open ? 'flex' : 'none',
            height: '100%',
            width: '100%',
            position: 'fixed',
            zIndex: 15,
            top: 0,
            left: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.67)',
            overflow: 'hidden',
            transition: '0.5s',
            textAlign: 'center',
            alignItems: 'center'
          },
          'data-cy': 'download-pop-over'
        },
        _react2.default.createElement(
          'div',
          {
            style: {
              maxWidth: '1000px',
              background: '#fff',
              margin: '80px auto',
              borderRadius: '5px'
            }
          },
          function () {
            if (loading || error) {
              return _react2.default.createElement(
                'div',
                {
                  style: {
                    textAlign: 'center',
                    height: '200px',
                    width: '500px',
                    paddingTop: '48px'
                  }
                },
                _react2.default.createElement(_materialUi.CircularProgress, null),
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null),
                error ? _react2.default.createElement(ErrorMessage, { retryFn: retryFn, onRequestClose: onRequestClose }) : 'Generating File ' + (validLengthForBulkDownload ? downloadedCount + '/' + validLengthForBulkDownload : '') + '...'
              );
            }
            if (wouldYouAcceptDialog) {
              return _react2.default.createElement(
                'div',
                {
                  style: {
                    textAlign: 'center',
                    height: success && validLengthForBulkDownload ? '300px' : '250px',
                    width: '500px'
                  }
                },
                _react2.default.createElement(
                  'div',
                  { style: { display: 'flex', flexDirection: 'row-reverse', padding: '24px 24px 0' } },
                  _react2.default.createElement(_materialUi.FontIcon, {
                    className: 'tc-icon-close',
                    color: 'rgba(0, 0, 0, 0.84)',
                    style: { fontSize: '32px', cursor: 'pointer' },
                    onClick: onRequestClose
                  })
                ),
                Boolean(success && validLengthForBulkDownload) && _react2.default.createElement(
                  'div',
                  { style: { margin: '16px auto', fontSize: '16px' } },
                  validLengthForBulkDownload + ' files have been downloaded!'
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  'Would you like to accept these rates?'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'flex-center', style: { margin: '48px auto 16px', width: '200px' } },
                  _react2.default.createElement(_materialUi.RaisedButton, {
                    primary: true,
                    label: 'No',
                    onClick: onRequestClose
                  }),
                  '\xA0\xA0\xA0',
                  _react2.default.createElement(_materialUi.RaisedButton, {
                    secondary: true,
                    label: 'Yes',
                    onClick: acceptRates
                  })
                )
              );
            }
            if (success) {
              return _react2.default.createElement(
                'div',
                {
                  style: {
                    textAlign: 'center',
                    height: '280px',
                    width: '500px'
                  }
                },
                _react2.default.createElement(
                  'div',
                  { style: { display: 'flex', flexDirection: 'row-reverse', padding: '24px 24px 0' } },
                  _react2.default.createElement(_materialUi.FontIcon, {
                    className: 'tc-icon-close',
                    color: 'rgba(0, 0, 0, 0.84)',
                    style: { fontSize: '32px', cursor: 'pointer' },
                    onClick: onRequestClose
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { style: { fontSize: '18px' } },
                  'File(s) were successfully generated!!'
                ),
                '(If your download doesn\'t start immediately, ',
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'a',
                  { href: downloadUrl, target: '_blank', rel: 'noreferrer', style: { color: '#00bcd4' } },
                  'click here'
                ),
                ' to download.)',
                _react2.default.createElement('br', null),
                _react2.default.createElement(_materialUi.FontIcon, {
                  color: 'green',
                  className: 'tc-icon-check_circle',
                  style: { fontSize: '56px', marginTop: '16px' }
                }),
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null),
                _react2.default.createElement(_materialUi.RaisedButton, {
                  label: 'OK',
                  secondary: true,
                  onClick: onRequestClose
                })
              );
            }
            return _react2.default.createElement(
              'div',
              {
                style: {
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                  width: '1000px',
                  height: '550px',
                  overflowY: 'scroll',
                  padding: '32px'
                }
              },
              _react2.default.createElement(
                'h4',
                null,
                'Choose your rate format'
              ),
              _react2.default.createElement(_rateFormatSelection2.default, {
                updateDownloadType: updateDownloadType,
                multi: multi,
                downloadType: downloadRateFormat
              }),
              _react2.default.createElement(
                'div',
                { style: { marginTop: '32px' }, className: 'flex-tc-sb' },
                _react2.default.createElement(
                  'div',
                  { style: { width: '60%', textAlign: 'left' } },
                  alContractIds && alContractIds.length > 1 && _react2.default.createElement(_materialUi.FlatButton, {
                    label: 'Download All in a Single Excel File',
                    style: { border: '1px solid #00bcd4' },
                    secondary: true,
                    onClick: downloadAllInOne,
                    disabled: loading
                  }),
                  window.location.href.indexOf('assets-landing') === -1 && _react2.default.createElement(_materialUi.Checkbox, {
                    label: 'Save my preference and do not show this preview again',
                    defaultChecked: localStorage.getItem('doNotShowRateFormatPop') === 'true' || localStorage.getItem('doNotShowRateFormatPop') === true,
                    onCheck: onCheck
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'flex-center' },
                  _react2.default.createElement(_materialUi.RaisedButton, { 'data-cy': 'cancel-download', label: 'Cancel', primary: true, onTouchTap: onRequestClose, disabled: loading }),
                  '\xA0\xA0',
                  _react2.default.createElement(_materialUi.RaisedButton, {
                    label: 'Download',
                    secondary: true,
                    onTouchTap: download,
                    disabled: loading,
                    'data-cy': 'download'
                  })
                )
              )
            );
          }()
        )
      );
    }
  }]);

  return DownloadPopover;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting,
      user = _ref2.user;
  return _extends({}, contracting.downloadDocs, {
    isAdmin: user ? user.get('isAnAdmin') : false
  });
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  updateProps: function updateProps(payload) {
    return { type: '[contracting-download]UPDATE_PROPS', payload: payload };
  },
  onRequestClose: function onRequestClose() {
    return { type: '[contracting-download]CLOSE_DOWNLOAD_POPOVER' };
  },
  download: function download(payload) {
    return { type: '[contracting-download]DOWLOAD_CONTRACTING_DOCS', payload: payload };
  },
  acceptRates: function acceptRates() {
    return { type: '[contracting-download]ACCEPT_RATES' };
  },
  downloadXls: function downloadXls(payload) {
    return { type: '[contracting-download]EXPORT_EXCEL', payload: payload };
  },
  retryFn: function retryFn() {
    return { type: '[contracting-download] downloadGroup_RETRY' };
  }
})(DownloadPopover);

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

module.exports = [ 'the', 'a', 'an', 'some' ]


/***/ }),
/* 1464 */
/***/ (function(module, exports) {

module.exports = [
    'a'
  , 'abaft'
  , 'aboard'
  , 'about'
  , 'above'
  , 'absent'
  , 'across'
  , 'afore'
  , 'after'
  , 'against'
  , 'along'
  , 'alongside'
  , 'amid'
  , 'amidst'
  , 'among'
  , 'amongst'
  , 'an'
  , 'apropos'
  , 'apud'
  , 'around'
  , 'as'
  , 'aside'
  , 'astride'
  , 'at'
  , 'athwart'
  , 'atop'
  , 'barring'
  , 'before'
  , 'behind'
  , 'below'
  , 'beneath'
  , 'beside'
  , 'besides'
  , 'between'
  , 'beyond'
  , 'but'
  , 'by'
  , 'circa'
  , 'concerning'
  , 'despite'
  , 'down'
  , 'during'
  , 'except'
  , 'excluding'
  , 'failing'
  , 'following'
  , 'for'
  , 'forenenst'
  , 'from'
  , 'given'
  , 'in'
  , 'including'
  , 'inside'
  , 'into'
  , 'like'
  , 'mid'
  , 'midst'
  , 'minus'
  , 'modulo'
  , 'near'
  , 'next'
  , 'notwithstanding'
  , 'o\''
  , 'of'
  , 'off'
  , 'on'
  , 'onto'
  , 'opposite'
  , 'out'
  , 'outside'
  , 'over'
  , 'pace'
  , 'past'
  , 'per'
  , 'plus'
  , 'pro'
  , 'qua'
  , 'regarding'
  , 'round'
  , 'sans'
  , 'save'
  , 'since'
  , 'than'
  , 'through'
  , 'throughout'
  , 'thru'
  , 'thruout'
  , 'till'
  , 'times'
  , 'to'
  , 'toward'
  , 'towards'
  , 'under'
  , 'underneath'
  , 'unlike'
  , 'until'
  , 'unto'
  , 'up'
  , 'upon'
  , 'versus'
  , 'via'
  , 'vice'
  , 'vis-à-vis'
  , 'with'
  , 'within'
  , 'without'
  , 'worth'
]


/***/ }),
/* 1465 */
/***/ (function(module, exports) {

module.exports = [
    'as'
  , 'because'
  , 'for'
  , 'and'
  , 'nor'
  , 'but'
  , 'or'
  , 'yet'
  , 'so'
]


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _FloatingActionButton = __webpack_require__(1081);

var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);

var _helpOutline = __webpack_require__(1117);

var _helpOutline2 = _interopRequireDefault(_helpOutline);

var _close = __webpack_require__(547);

var _close2 = _interopRequireDefault(_close);

var _chat = __webpack_require__(1216);

var _chat2 = _interopRequireDefault(_chat);

var _school = __webpack_require__(1217);

var _school2 = _interopRequireDefault(_school);

var _directions = __webpack_require__(1218);

var _directions2 = _interopRequireDefault(_directions);

var _whatshot = __webpack_require__(1219);

var _whatshot2 = _interopRequireDefault(_whatshot);

var _helpDrawer = __webpack_require__(1467);

var _helpDrawer2 = _interopRequireDefault(_helpDrawer);

var _helpwidgetActions = __webpack_require__(978);

var _walkthruActions = __webpack_require__(1222);

var _actions = __webpack_require__(1477);

var _helpWidgetOption = __webpack_require__(1478);

var _helpWidgetOption2 = _interopRequireDefault(_helpWidgetOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  floatingHelpIcon: {
    bottom: '25px',
    right: '25px',
    position: 'fixed',
    zIndex: 10001,
    transition: 'transform 455ms',
    transform: 'rotate(0)',
    '&.open': {
      transform: 'rotate(90deg)',
      right: '400px'
    }
  },
  floatingHelpIcons: {
    bottom: '90px',
    opacity: 0,
    position: 'fixed',
    right: '-9999px',
    zIndex: 1e4,
    '&.open': {
      right: '448px',
      opacity: '1',
      '&>div': {
        opacity: '1'
      }
    },
    '&>div': {
      display: 'block',
      position: 'absolute',
      opacity: '0',
      zIndex: 10001
    },
    '&>div:nth-child(1)': {
      bottom: '0',
      transition: 'all 455ms cubic-bezier(0.06,.93,.77,1) !important',
      transitionDelay: '255ms !important'
    },
    '&>div:nth-child(2)': {
      bottom: '50px',
      transition: 'all 455ms cubic-bezier(0.06,.93,.77,1) !important',
      transitionDelay: '285ms !important'
    },
    '&>div:nth-child(3)': {
      bottom: '100px',
      transition: 'all 455ms cubic-bezier(0.06,.93,.77,1) !important',
      transitionDelay: '315ms !important'
    },
    '&>div:nth-child(4)': {
      bottom: '150px',
      transition: 'all 455ms cubic-bezier(0.06,.93,.77,1) !important',
      transitionDelay: '345ms !important'
    }
  }
};

var HelpWidget = function (_Component) {
  _inherits(HelpWidget, _Component);

  function HelpWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HelpWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HelpWidget.__proto__ || Object.getPrototypeOf(HelpWidget)).call.apply(_ref, [this].concat(args))), _this), _this.onTouchTap = function () {
      var isOpen = _this.props.isOpen;

      if (isOpen) {
        _this.props.closeHelpWidget();
      } else {
        _this.props.openHelpWidget();
      }
    }, _this.onKnowledgeBaseClick = function () {
      return _this.clickAndClose(function () {
        return window.open('http://support.tourconnect.com');
      });
    }, _this.onChatClick = function () {
      return _this.clickAndClose(function () {
        return window.Intercom('show');
      });
    }, _this.onWalkThruClick = function (tourId) {
      window.HelpHero.startTour(tourId);
      _this.clickAndClose();
    }, _this.onNewReleasesClick = function () {
      return _this.clickAndClose(window.Beamer.show);
    }, _this.clickAndClose = function (fn) {
      _this.props.closeHelpWidget();
      if (typeof fn === 'function') fn();
    }, _this.isUrlMatch = function (str) {
      return window.location.pathname.indexOf(str) > -1;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HelpWidget, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.loadHelpSideBarPages();
    } // eslint-disable-line new-cap

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classes = _props.classes,
          isOpen = _props.isOpen,
          isKnowledgeBaseActive = _props.isKnowledgeBaseActive,
          isTourActive = _props.isTourActive,
          isNewFeaturesActive = _props.isNewFeaturesActive,
          _props$acctCreationRe = _props.acctCreationReason,
          acctCreationReason = _props$acctCreationRe === undefined ? '' : _props$acctCreationRe,
          companyType = _props.companyType;

      var isBuyer = companyType === 'Contractor';
      var isForPF = acctCreationReason.indexOf('find-new') > -1;
      var isPFBuyer = isBuyer && isForPF;
      var allTours = [{
        tourId: 'mkV3FeRHYhp',
        match: this.isUrlMatch('/dashboard') && isPFBuyer
      }, {
        tourId: 'Znrl7zI0riI',
        match: this.isUrlMatch('/profile') && isPFBuyer
      }, {
        tourId: 'jO8080xVkoC',
        match: this.isUrlMatch('/partner-finder/results') && isPFBuyer
      }, {
        tourId: 'e4yz805kLVq',
        match: this.isUrlMatch('/connections/requests') && isPFBuyer
      }, {
        tourId: 'Mtbrtk68zoc',
        match: this.isUrlMatch('/assets-landing') && isBuyer
      }, {
        tourId: 'OF9wW2uSoZ6',
        match: this.isUrlMatch('/dashboard') && isBuyer && !isForPF
      }, {
        tourId: 'AAGbLUfcFp1',
        match: this.isUrlMatch('/onboarding') && !isBuyer
      }, {
        tourId: 'Y7wNi93TDEj',
        match: this.isUrlMatch('/profile') && isBuyer && !isForPF
      }, {
        tourId: '8BbgfvvQKN2',
        match: this.isUrlMatch('/profile') && !isBuyer
      }, {
        tourId: 'WPkGk9xn7aH',
        match: this.isUrlMatch('/partner-finder/results') && !isPFBuyer
      }, {
        tourId: 'kI2w9OAMv7C',
        match: this.isUrlMatch('/connections/requests') && !isPFBuyer
      }, {
        tourId: 'b2Gqu6LyLie',
        match: this.isUrlMatch('/contracting/supplier-dashboard') && !isBuyer
      }, {
        tourId: 'T52TdHb44se',
        match: this.isUrlMatch('/contracting/buyer-dashboard') && isBuyer
      }, {
        tourId: 'Ku845gQzC3h',
        match: this.isUrlMatch('/contracting/template-list') && !isBuyer
      }, {
        tourId: 'BuRYzPvENJt',
        match: this.isUrlMatch('/contracting/contract-list') && !isBuyer
      }];
      var findTour = allTours.find(function (obj) {
        return obj.match;
      });
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _FloatingActionButton2.default,
          {
            secondary: isOpen,
            className: '' + classes.floatingHelpIcon + (isOpen ? ' open' : ''),
            backgroundColor: '#F6653C',
            onTouchTap: this.onTouchTap
          },
          isOpen ? _react2.default.createElement(_close2.default, null) : _react2.default.createElement(_helpOutline2.default, null)
        ),
        _react2.default.createElement(_helpDrawer2.default, null),
        _react2.default.createElement(
          'div',
          { className: '' + classes.floatingHelpIcons + (isOpen ? ' open' : '') },
          _react2.default.createElement(_helpWidgetOption2.default, {
            icon: _react2.default.createElement(_school2.default, null),
            onTouchTap: this.onKnowledgeBaseClick,
            isActive: isKnowledgeBaseActive,
            hintText: 'Support Articles and Videos'
          }),
          _react2.default.createElement(_helpWidgetOption2.default, {
            icon: _react2.default.createElement(_chat2.default, null),
            onTouchTap: this.onChatClick,
            isActive: true,
            hintText: 'Live Chat Support'
          }),
          _react2.default.createElement(_helpWidgetOption2.default, {
            icon: _react2.default.createElement(_directions2.default, null),
            isActive: Boolean(findTour),
            onTouchTap: function onTouchTap() {
              return _this2.onWalkThruClick(findTour.tourId);
            },
            hintText: 'Walkthrough'
          }),
          _react2.default.createElement(_helpWidgetOption2.default, {
            icon: _react2.default.createElement(_whatshot2.default, { color: 'rgb(255, 0, 0)', style: { fill: 'rgb(255, 0, 0)' } }),
            onTouchTap: this.onNewReleasesClick,
            isActive: isNewFeaturesActive,
            backgroundColor: '#ffffff',
            hintText: 'New Releases !'
          })
        )
      );
    }
  }]);

  return HelpWidget;
}(_react.Component);

HelpWidget.propTypes = {
  classes: _react.PropTypes.object,
  closeHelpWidget: _react.PropTypes.func,
  isKnowledgeBaseActive: _react.PropTypes.bool,
  isLiveChatActive: _react.PropTypes.bool,
  isNewFeaturesActive: _react.PropTypes.bool,
  isOpen: _react.PropTypes.bool,
  isSupportDeskActive: _react.PropTypes.bool,
  isTourActive: _react.PropTypes.bool,
  loadHelpSideBarPages: _react.PropTypes.func,
  onTouchTap: _react.PropTypes.func,
  openHelpWidget: _react.PropTypes.func,
  openWalkThruFn: _react.PropTypes.func,
  acctCreationReason: _react.PropTypes.string,
  companyType: _react.PropTypes.string
};

exports.default = (0, _reactRedux.connect)(function (_ref2) {
  var ui = _ref2.ui,
      user = _ref2.user;
  return {
    isKnowledgeBaseActive: ui.helpwidget.get('isKnowledgeBaseActive'),
    isLiveChatActive: ui.helpwidget.get('isLiveChatActive'),
    isNewFeaturesActive: ui.helpwidget.get('isNewFeaturesActive'),
    isOpen: ui.helpwidget.get('isOpen'),
    isSupportDeskActive: ui.helpwidget.get('isSupportDeskActive'),
    isTourActive: ui.walkthru.get('isTourReady')
  };
}, {
  closeHelpWidget: _helpwidgetActions.closeHelpWidget,
  loadHelpSideBarPages: _actions.loadHelpSideBarPages,
  openHelpWidget: _helpwidgetActions.openHelpWidget,
  openWalkThruFn: _walkthruActions.openWalkThru
})((0, _reactJss2.default)(styles)(HelpWidget));

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _Drawer = __webpack_require__(1355);

var _Drawer2 = _interopRequireDefault(_Drawer);

var _AppBar = __webpack_require__(1328);

var _AppBar2 = _interopRequireDefault(_AppBar);

var _IconButton = __webpack_require__(638);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _close = __webpack_require__(547);

var _close2 = _interopRequireDefault(_close);

var _CircularProgress = __webpack_require__(856);

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _marked = __webpack_require__(1468);

var _marked2 = _interopRequireDefault(_marked);

var _reactPlayer = __webpack_require__(1469);

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _helpwidgetActions = __webpack_require__(978);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  title: {
    '&>h1': {
      fontSize: '18px !important'
    }
  },
  content: {
    padding: '20px',
    '&>span>h4': {
      fontSize: '16px !important'
    },
    '&>p>*, &>span>*': {
      color: '#616061 !important',
      '&>li': {
        fontSize: '13px'
      }
    },
    '&>span>p>ul, &>span>p>ol': {
      paddingLeft: '20px !important'
    }
  },
  loading: {
    opacity: '0.3',
    filter: 'blur(5px)'
  },
  circularProgress: {
    left: '142px',
    position: 'absolute !important',
    top: '200px'
  }
};

var HelpDrawer = function (_Component) {
  _inherits(HelpDrawer, _Component);

  function HelpDrawer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HelpDrawer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HelpDrawer.__proto__ || Object.getPrototypeOf(HelpDrawer)).call.apply(_ref, [this].concat(args))), _this), _this.closeSidebar = function () {
      _this.props.closeHelpWidget();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HelpDrawer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          _props$help = _props.help,
          description = _props$help.description,
          onThisPage = _props$help.onThisPage,
          title = _props$help.title,
          terminology = _props$help.terminology,
          suggestedActions = _props$help.suggestedActions,
          videoUrl = _props$help.videoUrl,
          isOpen = _props.isOpen,
          loading = _props.loading;


      return _react2.default.createElement(
        _Drawer2.default,
        { width: 394, openSecondary: true, open: isOpen, containerStyle: { zIndex: '3300' } },
        loading ? _react2.default.createElement(_CircularProgress2.default, { size: 80, thickness: 5, className: classes.circularProgress }) : undefined,
        _react2.default.createElement(_AppBar2.default, {
          className: classes.title,
          title: loading ? '...' : title,
          showMenuIconButton: false,
          iconElementRight: _react2.default.createElement(
            _IconButton2.default,
            null,
            _react2.default.createElement(_close2.default, null)
          ),
          onRightIconButtonTouchTap: this.closeSidebar
        }),
        _react2.default.createElement(
          'div',
          { className: '' + classes.content + (loading ? ' ' + classes.loading : '') },
          _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(description) } }),
          videoUrl ? _react2.default.createElement(_reactPlayer2.default, {
            url: videoUrl,
            width: '339px',
            height: '188px'
          }) : null,
          onThisPage.length > 0 ? _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'h4',
              null,
              'On this page'
            ),
            onThisPage.map(function (_ref2) {
              var id = _ref2.id,
                  displayText = _ref2.displayText,
                  url = _ref2.url;
              return _react2.default.createElement(
                'li',
                { key: id },
                _react2.default.createElement(
                  'a',
                  { href: url, target: '_blank', style: { textDecoration: 'none' } },
                  displayText
                )
              );
            })
          ) : null,
          terminology ? _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'h4',
              null,
              'Terminology'
            ),
            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(terminology) } })
          ) : null,
          suggestedActions ? _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'h4',
              null,
              'Suggested Actions'
            ),
            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(suggestedActions) } })
          ) : null
        )
      );
    }
  }]);

  return HelpDrawer;
}(_react.Component);

HelpDrawer.defaultProps = {
  help: {
    title: '',
    description: '',
    onThisPage: [],
    terminology: undefined,
    videoUrl: undefined
  },
  loading: true,
  isOpen: false
};

HelpDrawer.propTypes = {
  classes: _react.PropTypes.object,
  help: _react.PropTypes.object.isRequired,
  isOpen: _react.PropTypes.bool.isRequired,
  loading: _react.PropTypes.bool.isRequired,
  closeHelpWidget: _react.PropTypes.func
};

exports.default = (0, _reactRedux.connect)(function (_ref3) {
  var ui = _ref3.ui,
      sidebarHelp = _ref3.sidebarHelp;
  return {
    loading: sidebarHelp.contentLoading,
    help: sidebarHelp.helpArticle,
    isOpen: ui.helpwidget.get('isOpen')
  };
}, {
  closeHelpWidget: _helpwidgetActions.closeHelpWidget
})((0, _reactJss2.default)(styles)(HelpDrawer));

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * marked - a markdown parser
 * Copyright (c) 2011-2018, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

;(function(root) {
'use strict';

/**
 * Block-Level Grammar
 */

var block = {
  newline: /^\n+/,
  code: /^( {4}[^\n]+\n*)+/,
  fences: noop,
  hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
  heading: /^ *(#{1,6}) *([^\n]+?) *(?:#+ *)?(?:\n+|$)/,
  nptable: noop,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
  html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?\\?>\\n*' // (3)
    + '|<![A-Z][\\s\\S]*?>\\n*' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?\\]\\]>\\n*' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:\\n{2,}|$)' // (6)
    + '|<(?!script|pre|style)([a-z][\\w-]*)(?:attribute)*? */?>(?=\\h*\\n)[\\s\\S]*?(?:\\n{2,}|$)' // (7) open tag
    + '|</(?!script|pre|style)[a-z][\\w-]*\\s*>(?=\\h*\\n)[\\s\\S]*?(?:\\n{2,}|$)' // (7) closing tag
    + ')',
  def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
  table: noop,
  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
  paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading| {0,3}>|<\/?(?:tag)(?: +|\n|\/?>)|<(?:script|pre|style|!--))[^\n]+)*)/,
  text: /^[^\n]+/
};

block._label = /(?!\s*\])(?:\\[\[\]]|[^\[\]])+/;
block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
block.def = edit(block.def)
  .replace('label', block._label)
  .replace('title', block._title)
  .getRegex();

block.bullet = /(?:[*+-]|\d+\.)/;
block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
block.item = edit(block.item, 'gm')
  .replace(/bull/g, block.bullet)
  .getRegex();

block.list = edit(block.list)
  .replace(/bull/g, block.bullet)
  .replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))')
  .replace('def', '\\n+(?=' + block.def.source + ')')
  .getRegex();

block._tag = 'address|article|aside|base|basefont|blockquote|body|caption'
  + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption'
  + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe'
  + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option'
  + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr'
  + '|track|ul';
block._comment = /<!--(?!-?>)[\s\S]*?-->/;
block.html = edit(block.html, 'i')
  .replace('comment', block._comment)
  .replace('tag', block._tag)
  .replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/)
  .getRegex();

block.paragraph = edit(block.paragraph)
  .replace('hr', block.hr)
  .replace('heading', block.heading)
  .replace('lheading', block.lheading)
  .replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();

block.blockquote = edit(block.blockquote)
  .replace('paragraph', block.paragraph)
  .getRegex();

/**
 * Normal Block Grammar
 */

block.normal = merge({}, block);

/**
 * GFM Block Grammar
 */

block.gfm = merge({}, block.normal, {
  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\n? *\1 *(?:\n+|$)/,
  paragraph: /^/,
  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
});

block.gfm.paragraph = edit(block.paragraph)
  .replace('(?!', '(?!'
    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
    + block.list.source.replace('\\1', '\\3') + '|')
  .getRegex();

/**
 * GFM + Tables Block Grammar
 */

block.tables = merge({}, block.gfm, {
  nptable: /^ *([^|\n ].*\|.*)\n *([-:]+ *\|[-| :]*)(?:\n((?:.*[^>\n ].*(?:\n|$))*)\n*|$)/,
  table: /^ *\|(.+)\n *\|?( *[-:]+[-| :]*)(?:\n((?: *[^>\n ].*(?:\n|$))*)\n*|$)/
});

/**
 * Pedantic grammar
 */

block.pedantic = merge({}, block.normal, {
  html: edit(
    '^ *(?:comment *(?:\\n|\\s*$)'
    + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))')
    .replace('comment', block._comment)
    .replace(/tag/g, '(?!(?:'
      + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub'
      + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)'
      + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b')
    .getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/
});

/**
 * Block Lexer
 */

function Lexer(options) {
  this.tokens = [];
  this.tokens.links = Object.create(null);
  this.options = options || marked.defaults;
  this.rules = block.normal;

  if (this.options.pedantic) {
    this.rules = block.pedantic;
  } else if (this.options.gfm) {
    if (this.options.tables) {
      this.rules = block.tables;
    } else {
      this.rules = block.gfm;
    }
  }
}

/**
 * Expose Block Rules
 */

Lexer.rules = block;

/**
 * Static Lex Method
 */

Lexer.lex = function(src, options) {
  var lexer = new Lexer(options);
  return lexer.lex(src);
};

/**
 * Preprocessing
 */

Lexer.prototype.lex = function(src) {
  src = src
    .replace(/\r\n|\r/g, '\n')
    .replace(/\t/g, '    ')
    .replace(/\u00a0/g, ' ')
    .replace(/\u2424/g, '\n');

  return this.token(src, true);
};

/**
 * Lexing
 */

Lexer.prototype.token = function(src, top) {
  src = src.replace(/^ +$/gm, '');
  var next,
      loose,
      cap,
      bull,
      b,
      item,
      listStart,
      listItems,
      t,
      space,
      i,
      tag,
      l,
      isordered,
      istask,
      ischecked;

  while (src) {
    // newline
    if (cap = this.rules.newline.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[0].length > 1) {
        this.tokens.push({
          type: 'space'
        });
      }
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      cap = cap[0].replace(/^ {4}/gm, '');
      this.tokens.push({
        type: 'code',
        text: !this.options.pedantic
          ? rtrim(cap, '\n')
          : cap
      });
      continue;
    }

    // fences (gfm)
    if (cap = this.rules.fences.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'code',
        lang: cap[2],
        text: cap[3] || ''
      });
      continue;
    }

    // heading
    if (cap = this.rules.heading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[1].length,
        text: cap[2]
      });
      continue;
    }

    // table no leading pipe (gfm)
    if (top && (cap = this.rules.nptable.exec(src))) {
      item = {
        type: 'table',
        header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3] ? cap[3].replace(/\n$/, '').split('\n') : []
      };

      if (item.header.length === item.align.length) {
        src = src.substring(cap[0].length);

        for (i = 0; i < item.align.length; i++) {
          if (/^ *-+: *$/.test(item.align[i])) {
            item.align[i] = 'right';
          } else if (/^ *:-+: *$/.test(item.align[i])) {
            item.align[i] = 'center';
          } else if (/^ *:-+ *$/.test(item.align[i])) {
            item.align[i] = 'left';
          } else {
            item.align[i] = null;
          }
        }

        for (i = 0; i < item.cells.length; i++) {
          item.cells[i] = splitCells(item.cells[i], item.header.length);
        }

        this.tokens.push(item);

        continue;
      }
    }

    // hr
    if (cap = this.rules.hr.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'hr'
      });
      continue;
    }

    // blockquote
    if (cap = this.rules.blockquote.exec(src)) {
      src = src.substring(cap[0].length);

      this.tokens.push({
        type: 'blockquote_start'
      });

      cap = cap[0].replace(/^ *> ?/gm, '');

      // Pass `top` to keep the current
      // "toplevel" state. This is exactly
      // how markdown.pl works.
      this.token(cap, top);

      this.tokens.push({
        type: 'blockquote_end'
      });

      continue;
    }

    // list
    if (cap = this.rules.list.exec(src)) {
      src = src.substring(cap[0].length);
      bull = cap[2];
      isordered = bull.length > 1;

      listStart = {
        type: 'list_start',
        ordered: isordered,
        start: isordered ? +bull : '',
        loose: false
      };

      this.tokens.push(listStart);

      // Get each top-level item.
      cap = cap[0].match(this.rules.item);

      listItems = [];
      next = false;
      l = cap.length;
      i = 0;

      for (; i < l; i++) {
        item = cap[i];

        // Remove the list item's bullet
        // so it is seen as the next token.
        space = item.length;
        item = item.replace(/^ *([*+-]|\d+\.) +/, '');

        // Outdent whatever the
        // list item contains. Hacky.
        if (~item.indexOf('\n ')) {
          space -= item.length;
          item = !this.options.pedantic
            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
            : item.replace(/^ {1,4}/gm, '');
        }

        // Determine whether the next list item belongs here.
        // Backpedal if it does not belong in this list.
        if (this.options.smartLists && i !== l - 1) {
          b = block.bullet.exec(cap[i + 1])[0];
          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
            src = cap.slice(i + 1).join('\n') + src;
            i = l - 1;
          }
        }

        // Determine whether item is loose or not.
        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
        // for discount behavior.
        loose = next || /\n\n(?!\s*$)/.test(item);
        if (i !== l - 1) {
          next = item.charAt(item.length - 1) === '\n';
          if (!loose) loose = next;
        }

        if (loose) {
          listStart.loose = true;
        }

        // Check for task list items
        istask = /^\[[ xX]\] /.test(item);
        ischecked = undefined;
        if (istask) {
          ischecked = item[1] !== ' ';
          item = item.replace(/^\[[ xX]\] +/, '');
        }

        t = {
          type: 'list_item_start',
          task: istask,
          checked: ischecked,
          loose: loose
        };

        listItems.push(t);
        this.tokens.push(t);

        // Recurse.
        this.token(item, false);

        this.tokens.push({
          type: 'list_item_end'
        });
      }

      if (listStart.loose) {
        l = listItems.length;
        i = 0;
        for (; i < l; i++) {
          listItems[i].loose = true;
        }
      }

      this.tokens.push({
        type: 'list_end'
      });

      continue;
    }

    // html
    if (cap = this.rules.html.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: this.options.sanitize
          ? 'paragraph'
          : 'html',
        pre: !this.options.sanitizer
          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
        text: cap[0]
      });
      continue;
    }

    // def
    if (top && (cap = this.rules.def.exec(src))) {
      src = src.substring(cap[0].length);
      if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
      tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
      if (!this.tokens.links[tag]) {
        this.tokens.links[tag] = {
          href: cap[2],
          title: cap[3]
        };
      }
      continue;
    }

    // table (gfm)
    if (top && (cap = this.rules.table.exec(src))) {
      item = {
        type: 'table',
        header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3] ? cap[3].replace(/(?: *\| *)?\n$/, '').split('\n') : []
      };

      if (item.header.length === item.align.length) {
        src = src.substring(cap[0].length);

        for (i = 0; i < item.align.length; i++) {
          if (/^ *-+: *$/.test(item.align[i])) {
            item.align[i] = 'right';
          } else if (/^ *:-+: *$/.test(item.align[i])) {
            item.align[i] = 'center';
          } else if (/^ *:-+ *$/.test(item.align[i])) {
            item.align[i] = 'left';
          } else {
            item.align[i] = null;
          }
        }

        for (i = 0; i < item.cells.length; i++) {
          item.cells[i] = splitCells(
            item.cells[i].replace(/^ *\| *| *\| *$/g, ''),
            item.header.length);
        }

        this.tokens.push(item);

        continue;
      }
    }

    // lheading
    if (cap = this.rules.lheading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[2] === '=' ? 1 : 2,
        text: cap[1]
      });
      continue;
    }

    // top-level paragraph
    if (top && (cap = this.rules.paragraph.exec(src))) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'paragraph',
        text: cap[1].charAt(cap[1].length - 1) === '\n'
          ? cap[1].slice(0, -1)
          : cap[1]
      });
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      // Top-level should never reach here.
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'text',
        text: cap[0]
      });
      continue;
    }

    if (src) {
      throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return this.tokens;
};

/**
 * Inline-Level Grammar
 */

var inline = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: noop,
  tag: '^comment'
    + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>', // CDATA section
  link: /^!?\[(label)\]\(href(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(?!\s*\])((?:\\[\[\]]?|[^\[\]\\])+)\]/,
  nolink: /^!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?/,
  strong: /^__([^\s])__(?!_)|^\*\*([^\s])\*\*(?!\*)|^__([^\s][\s\S]*?[^\s])__(?!_)|^\*\*([^\s][\s\S]*?[^\s])\*\*(?!\*)/,
  em: /^_([^\s_])_(?!_)|^\*([^\s*"<\[])\*(?!\*)|^_([^\s][\s\S]*?[^\s_])_(?!_|[^\s.])|^_([^\s_][\s\S]*?[^\s])_(?!_|[^\s.])|^\*([^\s"<\[][\s\S]*?[^\s*])\*(?!\*)|^\*([^\s*"<\[][\s\S]*?[^\s])\*(?!\*)/,
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: noop,
  text: /^(`+|[^`])[\s\S]*?(?=[\\<!\[`*]|\b_| {2,}\n|$)/
};

inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;

inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
inline.autolink = edit(inline.autolink)
  .replace('scheme', inline._scheme)
  .replace('email', inline._email)
  .getRegex();

inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;

inline.tag = edit(inline.tag)
  .replace('comment', block._comment)
  .replace('attribute', inline._attribute)
  .getRegex();

inline._label = /(?:\[[^\[\]]*\]|\\[\[\]]?|`[^`]*`|[^\[\]\\])*?/;
inline._href = /\s*(<(?:\\[<>]?|[^\s<>\\])*>|(?:\\[()]?|\([^\s\x00-\x1f\\]*\)|[^\s\x00-\x1f()\\])*?)/;
inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;

inline.link = edit(inline.link)
  .replace('label', inline._label)
  .replace('href', inline._href)
  .replace('title', inline._title)
  .getRegex();

inline.reflink = edit(inline.reflink)
  .replace('label', inline._label)
  .getRegex();

/**
 * Normal Inline Grammar
 */

inline.normal = merge({}, inline);

/**
 * Pedantic Inline Grammar
 */

inline.pedantic = merge({}, inline.normal, {
  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/,
  link: edit(/^!?\[(label)\]\((.*?)\)/)
    .replace('label', inline._label)
    .getRegex(),
  reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/)
    .replace('label', inline._label)
    .getRegex()
});

/**
 * GFM Inline Grammar
 */

inline.gfm = merge({}, inline.normal, {
  escape: edit(inline.escape).replace('])', '~|])').getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
  del: /^~+(?=\S)([\s\S]*?\S)~+/,
  text: edit(inline.text)
    .replace(']|', '~]|')
    .replace('|$', '|https?://|ftp://|www\\.|[a-zA-Z0-9.!#$%&\'*+/=?^_`{\\|}~-]+@|$')
    .getRegex()
});

inline.gfm.url = edit(inline.gfm.url)
  .replace('email', inline.gfm._extended_email)
  .getRegex();
/**
 * GFM + Line Breaks Inline Grammar
 */

inline.breaks = merge({}, inline.gfm, {
  br: edit(inline.br).replace('{2,}', '*').getRegex(),
  text: edit(inline.gfm.text).replace('{2,}', '*').getRegex()
});

/**
 * Inline Lexer & Compiler
 */

function InlineLexer(links, options) {
  this.options = options || marked.defaults;
  this.links = links;
  this.rules = inline.normal;
  this.renderer = this.options.renderer || new Renderer();
  this.renderer.options = this.options;

  if (!this.links) {
    throw new Error('Tokens array requires a `links` property.');
  }

  if (this.options.pedantic) {
    this.rules = inline.pedantic;
  } else if (this.options.gfm) {
    if (this.options.breaks) {
      this.rules = inline.breaks;
    } else {
      this.rules = inline.gfm;
    }
  }
}

/**
 * Expose Inline Rules
 */

InlineLexer.rules = inline;

/**
 * Static Lexing/Compiling Method
 */

InlineLexer.output = function(src, links, options) {
  var inline = new InlineLexer(links, options);
  return inline.output(src);
};

/**
 * Lexing/Compiling
 */

InlineLexer.prototype.output = function(src) {
  var out = '',
      link,
      text,
      href,
      title,
      cap,
      prevCapZero;

  while (src) {
    // escape
    if (cap = this.rules.escape.exec(src)) {
      src = src.substring(cap[0].length);
      out += cap[1];
      continue;
    }

    // autolink
    if (cap = this.rules.autolink.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[2] === '@') {
        text = escape(this.mangle(cap[1]));
        href = 'mailto:' + text;
      } else {
        text = escape(cap[1]);
        href = text;
      }
      out += this.renderer.link(href, null, text);
      continue;
    }

    // url (gfm)
    if (!this.inLink && (cap = this.rules.url.exec(src))) {
      if (cap[2] === '@') {
        text = escape(cap[0]);
        href = 'mailto:' + text;
      } else {
        // do extended autolink path validation
        do {
          prevCapZero = cap[0];
          cap[0] = this.rules._backpedal.exec(cap[0])[0];
        } while (prevCapZero !== cap[0]);
        text = escape(cap[0]);
        if (cap[1] === 'www.') {
          href = 'http://' + text;
        } else {
          href = text;
        }
      }
      src = src.substring(cap[0].length);
      out += this.renderer.link(href, null, text);
      continue;
    }

    // tag
    if (cap = this.rules.tag.exec(src)) {
      if (!this.inLink && /^<a /i.test(cap[0])) {
        this.inLink = true;
      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
        this.inLink = false;
      }
      if (!this.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.inRawBlock = true;
      } else if (this.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.inRawBlock = false;
      }

      src = src.substring(cap[0].length);
      out += this.options.sanitize
        ? this.options.sanitizer
          ? this.options.sanitizer(cap[0])
          : escape(cap[0])
        : cap[0];
      continue;
    }

    // link
    if (cap = this.rules.link.exec(src)) {
      src = src.substring(cap[0].length);
      this.inLink = true;
      href = cap[2];
      if (this.options.pedantic) {
        link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);

        if (link) {
          href = link[1];
          title = link[3];
        } else {
          title = '';
        }
      } else {
        title = cap[3] ? cap[3].slice(1, -1) : '';
      }
      href = href.trim().replace(/^<([\s\S]*)>$/, '$1');
      out += this.outputLink(cap, {
        href: InlineLexer.escapes(href),
        title: InlineLexer.escapes(title)
      });
      this.inLink = false;
      continue;
    }

    // reflink, nolink
    if ((cap = this.rules.reflink.exec(src))
        || (cap = this.rules.nolink.exec(src))) {
      src = src.substring(cap[0].length);
      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
      link = this.links[link.toLowerCase()];
      if (!link || !link.href) {
        out += cap[0].charAt(0);
        src = cap[0].substring(1) + src;
        continue;
      }
      this.inLink = true;
      out += this.outputLink(cap, link);
      this.inLink = false;
      continue;
    }

    // strong
    if (cap = this.rules.strong.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.strong(this.output(cap[4] || cap[3] || cap[2] || cap[1]));
      continue;
    }

    // em
    if (cap = this.rules.em.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.em(this.output(cap[6] || cap[5] || cap[4] || cap[3] || cap[2] || cap[1]));
      continue;
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.codespan(escape(cap[2].trim(), true));
      continue;
    }

    // br
    if (cap = this.rules.br.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.br();
      continue;
    }

    // del (gfm)
    if (cap = this.rules.del.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.del(this.output(cap[1]));
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      src = src.substring(cap[0].length);
      if (this.inRawBlock) {
        out += this.renderer.text(cap[0]);
      } else {
        out += this.renderer.text(escape(this.smartypants(cap[0])));
      }
      continue;
    }

    if (src) {
      throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return out;
};

InlineLexer.escapes = function(text) {
  return text ? text.replace(InlineLexer.rules._escapes, '$1') : text;
};

/**
 * Compile Link
 */

InlineLexer.prototype.outputLink = function(cap, link) {
  var href = link.href,
      title = link.title ? escape(link.title) : null;

  return cap[0].charAt(0) !== '!'
    ? this.renderer.link(href, title, this.output(cap[1]))
    : this.renderer.image(href, title, escape(cap[1]));
};

/**
 * Smartypants Transformations
 */

InlineLexer.prototype.smartypants = function(text) {
  if (!this.options.smartypants) return text;
  return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
    // closing doubles
    .replace(/"/g, '\u201d')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
};

/**
 * Mangle Links
 */

InlineLexer.prototype.mangle = function(text) {
  if (!this.options.mangle) return text;
  var out = '',
      l = text.length,
      i = 0,
      ch;

  for (; i < l; i++) {
    ch = text.charCodeAt(i);
    if (Math.random() > 0.5) {
      ch = 'x' + ch.toString(16);
    }
    out += '&#' + ch + ';';
  }

  return out;
};

/**
 * Renderer
 */

function Renderer(options) {
  this.options = options || marked.defaults;
}

Renderer.prototype.code = function(code, lang, escaped) {
  if (this.options.highlight) {
    var out = this.options.highlight(code, lang);
    if (out != null && out !== code) {
      escaped = true;
      code = out;
    }
  }

  if (!lang) {
    return '<pre><code>'
      + (escaped ? code : escape(code, true))
      + '</code></pre>';
  }

  return '<pre><code class="'
    + this.options.langPrefix
    + escape(lang, true)
    + '">'
    + (escaped ? code : escape(code, true))
    + '</code></pre>\n';
};

Renderer.prototype.blockquote = function(quote) {
  return '<blockquote>\n' + quote + '</blockquote>\n';
};

Renderer.prototype.html = function(html) {
  return html;
};

Renderer.prototype.heading = function(text, level, raw) {
  if (this.options.headerIds) {
    return '<h'
      + level
      + ' id="'
      + this.options.headerPrefix
      + raw.toLowerCase().replace(/[^\w]+/g, '-')
      + '">'
      + text
      + '</h'
      + level
      + '>\n';
  }
  // ignore IDs
  return '<h' + level + '>' + text + '</h' + level + '>\n';
};

Renderer.prototype.hr = function() {
  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
};

Renderer.prototype.list = function(body, ordered, start) {
  var type = ordered ? 'ol' : 'ul',
      startatt = (ordered && start !== 1) ? (' start="' + start + '"') : '';
  return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
};

Renderer.prototype.listitem = function(text) {
  return '<li>' + text + '</li>\n';
};

Renderer.prototype.checkbox = function(checked) {
  return '<input '
    + (checked ? 'checked="" ' : '')
    + 'disabled="" type="checkbox"'
    + (this.options.xhtml ? ' /' : '')
    + '> ';
};

Renderer.prototype.paragraph = function(text) {
  return '<p>' + text + '</p>\n';
};

Renderer.prototype.table = function(header, body) {
  if (body) body = '<tbody>' + body + '</tbody>';

  return '<table>\n'
    + '<thead>\n'
    + header
    + '</thead>\n'
    + body
    + '</table>\n';
};

Renderer.prototype.tablerow = function(content) {
  return '<tr>\n' + content + '</tr>\n';
};

Renderer.prototype.tablecell = function(content, flags) {
  var type = flags.header ? 'th' : 'td';
  var tag = flags.align
    ? '<' + type + ' align="' + flags.align + '">'
    : '<' + type + '>';
  return tag + content + '</' + type + '>\n';
};

// span level renderer
Renderer.prototype.strong = function(text) {
  return '<strong>' + text + '</strong>';
};

Renderer.prototype.em = function(text) {
  return '<em>' + text + '</em>';
};

Renderer.prototype.codespan = function(text) {
  return '<code>' + text + '</code>';
};

Renderer.prototype.br = function() {
  return this.options.xhtml ? '<br/>' : '<br>';
};

Renderer.prototype.del = function(text) {
  return '<del>' + text + '</del>';
};

Renderer.prototype.link = function(href, title, text) {
  href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
  if (href === null) {
    return text;
  }
  var out = '<a href="' + escape(href) + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += '>' + text + '</a>';
  return out;
};

Renderer.prototype.image = function(href, title, text) {
  href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
  if (href === null) {
    return text;
  }

  var out = '<img src="' + href + '" alt="' + text + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += this.options.xhtml ? '/>' : '>';
  return out;
};

Renderer.prototype.text = function(text) {
  return text;
};

/**
 * TextRenderer
 * returns only the textual part of the token
 */

function TextRenderer() {}

// no need for block level renderers

TextRenderer.prototype.strong =
TextRenderer.prototype.em =
TextRenderer.prototype.codespan =
TextRenderer.prototype.del =
TextRenderer.prototype.text = function (text) {
  return text;
};

TextRenderer.prototype.link =
TextRenderer.prototype.image = function(href, title, text) {
  return '' + text;
};

TextRenderer.prototype.br = function() {
  return '';
};

/**
 * Parsing & Compiling
 */

function Parser(options) {
  this.tokens = [];
  this.token = null;
  this.options = options || marked.defaults;
  this.options.renderer = this.options.renderer || new Renderer();
  this.renderer = this.options.renderer;
  this.renderer.options = this.options;
}

/**
 * Static Parse Method
 */

Parser.parse = function(src, options) {
  var parser = new Parser(options);
  return parser.parse(src);
};

/**
 * Parse Loop
 */

Parser.prototype.parse = function(src) {
  this.inline = new InlineLexer(src.links, this.options);
  // use an InlineLexer with a TextRenderer to extract pure text
  this.inlineText = new InlineLexer(
    src.links,
    merge({}, this.options, {renderer: new TextRenderer()})
  );
  this.tokens = src.reverse();

  var out = '';
  while (this.next()) {
    out += this.tok();
  }

  return out;
};

/**
 * Next Token
 */

Parser.prototype.next = function() {
  return this.token = this.tokens.pop();
};

/**
 * Preview Next Token
 */

Parser.prototype.peek = function() {
  return this.tokens[this.tokens.length - 1] || 0;
};

/**
 * Parse Text Tokens
 */

Parser.prototype.parseText = function() {
  var body = this.token.text;

  while (this.peek().type === 'text') {
    body += '\n' + this.next().text;
  }

  return this.inline.output(body);
};

/**
 * Parse Current Token
 */

Parser.prototype.tok = function() {
  switch (this.token.type) {
    case 'space': {
      return '';
    }
    case 'hr': {
      return this.renderer.hr();
    }
    case 'heading': {
      return this.renderer.heading(
        this.inline.output(this.token.text),
        this.token.depth,
        unescape(this.inlineText.output(this.token.text)));
    }
    case 'code': {
      return this.renderer.code(this.token.text,
        this.token.lang,
        this.token.escaped);
    }
    case 'table': {
      var header = '',
          body = '',
          i,
          row,
          cell,
          j;

      // header
      cell = '';
      for (i = 0; i < this.token.header.length; i++) {
        cell += this.renderer.tablecell(
          this.inline.output(this.token.header[i]),
          { header: true, align: this.token.align[i] }
        );
      }
      header += this.renderer.tablerow(cell);

      for (i = 0; i < this.token.cells.length; i++) {
        row = this.token.cells[i];

        cell = '';
        for (j = 0; j < row.length; j++) {
          cell += this.renderer.tablecell(
            this.inline.output(row[j]),
            { header: false, align: this.token.align[j] }
          );
        }

        body += this.renderer.tablerow(cell);
      }
      return this.renderer.table(header, body);
    }
    case 'blockquote_start': {
      body = '';

      while (this.next().type !== 'blockquote_end') {
        body += this.tok();
      }

      return this.renderer.blockquote(body);
    }
    case 'list_start': {
      body = '';
      var ordered = this.token.ordered,
          start = this.token.start;

      while (this.next().type !== 'list_end') {
        body += this.tok();
      }

      return this.renderer.list(body, ordered, start);
    }
    case 'list_item_start': {
      body = '';
      var loose = this.token.loose;

      if (this.token.task) {
        body += this.renderer.checkbox(this.token.checked);
      }

      while (this.next().type !== 'list_item_end') {
        body += !loose && this.token.type === 'text'
          ? this.parseText()
          : this.tok();
      }

      return this.renderer.listitem(body);
    }
    case 'html': {
      // TODO parse inline content if parameter markdown=1
      return this.renderer.html(this.token.text);
    }
    case 'paragraph': {
      return this.renderer.paragraph(this.inline.output(this.token.text));
    }
    case 'text': {
      return this.renderer.paragraph(this.parseText());
    }
  }
};

/**
 * Helpers
 */

function escape(html, encode) {
  if (encode) {
    if (escape.escapeTest.test(html)) {
      return html.replace(escape.escapeReplace, function (ch) { return escape.replacements[ch]; });
    }
  } else {
    if (escape.escapeTestNoEncode.test(html)) {
      return html.replace(escape.escapeReplaceNoEncode, function (ch) { return escape.replacements[ch]; });
    }
  }

  return html;
}

escape.escapeTest = /[&<>"']/;
escape.escapeReplace = /[&<>"']/g;
escape.replacements = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

escape.escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
escape.escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;

function unescape(html) {
  // explicitly match decimal, hex, and named HTML entities
  return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function(_, n) {
    n = n.toLowerCase();
    if (n === 'colon') return ':';
    if (n.charAt(0) === '#') {
      return n.charAt(1) === 'x'
        ? String.fromCharCode(parseInt(n.substring(2), 16))
        : String.fromCharCode(+n.substring(1));
    }
    return '';
  });
}

function edit(regex, opt) {
  regex = regex.source || regex;
  opt = opt || '';
  return {
    replace: function(name, val) {
      val = val.source || val;
      val = val.replace(/(^|[^\[])\^/g, '$1');
      regex = regex.replace(name, val);
      return this;
    },
    getRegex: function() {
      return new RegExp(regex, opt);
    }
  };
}

function cleanUrl(sanitize, base, href) {
  if (sanitize) {
    try {
      var prot = decodeURIComponent(unescape(href))
        .replace(/[^\w:]/g, '')
        .toLowerCase();
    } catch (e) {
      return null;
    }
    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
      return null;
    }
  }
  if (base && !originIndependentUrl.test(href)) {
    href = resolveUrl(base, href);
  }
  try {
    href = encodeURI(href).replace(/%25/g, '%');
  } catch (e) {
    return null;
  }
  return href;
}

function resolveUrl(base, href) {
  if (!baseUrls[' ' + base]) {
    // we can ignore everything in base after the last slash of its path component,
    // but we might need to add _that_
    // https://tools.ietf.org/html/rfc3986#section-3
    if (/^[^:]+:\/*[^/]*$/.test(base)) {
      baseUrls[' ' + base] = base + '/';
    } else {
      baseUrls[' ' + base] = rtrim(base, '/', true);
    }
  }
  base = baseUrls[' ' + base];

  if (href.slice(0, 2) === '//') {
    return base.replace(/:[\s\S]*/, ':') + href;
  } else if (href.charAt(0) === '/') {
    return base.replace(/(:\/*[^/]*)[\s\S]*/, '$1') + href;
  } else {
    return base + href;
  }
}
var baseUrls = {};
var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

function noop() {}
noop.exec = noop;

function merge(obj) {
  var i = 1,
      target,
      key;

  for (; i < arguments.length; i++) {
    target = arguments[i];
    for (key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        obj[key] = target[key];
      }
    }
  }

  return obj;
}

function splitCells(tableRow, count) {
  // ensure that every cell-delimiting pipe has a space
  // before it to distinguish it from an escaped pipe
  var row = tableRow.replace(/\|/g, function (match, offset, str) {
        var escaped = false,
            curr = offset;
        while (--curr >= 0 && str[curr] === '\\') escaped = !escaped;
        if (escaped) {
          // odd number of slashes means | is escaped
          // so we leave it alone
          return '|';
        } else {
          // add space before unescaped |
          return ' |';
        }
      }),
      cells = row.split(/ \|/),
      i = 0;

  if (cells.length > count) {
    cells.splice(count);
  } else {
    while (cells.length < count) cells.push('');
  }

  for (; i < cells.length; i++) {
    // leading or trailing whitespace is ignored per the gfm spec
    cells[i] = cells[i].trim().replace(/\\\|/g, '|');
  }
  return cells;
}

// Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
// /c*$/ is vulnerable to REDOS.
// invert: Remove suffix of non-c chars instead. Default falsey.
function rtrim(str, c, invert) {
  if (str.length === 0) {
    return '';
  }

  // Length of suffix matching the invert condition.
  var suffLen = 0;

  // Step left until we fail to match the invert condition.
  while (suffLen < str.length) {
    var currChar = str.charAt(str.length - suffLen - 1);
    if (currChar === c && !invert) {
      suffLen++;
    } else if (currChar !== c && invert) {
      suffLen++;
    } else {
      break;
    }
  }

  return str.substr(0, str.length - suffLen);
}

/**
 * Marked
 */

function marked(src, opt, callback) {
  // throw error in case of non string input
  if (typeof src === 'undefined' || src === null) {
    throw new Error('marked(): input parameter is undefined or null');
  }
  if (typeof src !== 'string') {
    throw new Error('marked(): input parameter is of type '
      + Object.prototype.toString.call(src) + ', string expected');
  }

  if (callback || typeof opt === 'function') {
    if (!callback) {
      callback = opt;
      opt = null;
    }

    opt = merge({}, marked.defaults, opt || {});

    var highlight = opt.highlight,
        tokens,
        pending,
        i = 0;

    try {
      tokens = Lexer.lex(src, opt);
    } catch (e) {
      return callback(e);
    }

    pending = tokens.length;

    var done = function(err) {
      if (err) {
        opt.highlight = highlight;
        return callback(err);
      }

      var out;

      try {
        out = Parser.parse(tokens, opt);
      } catch (e) {
        err = e;
      }

      opt.highlight = highlight;

      return err
        ? callback(err)
        : callback(null, out);
    };

    if (!highlight || highlight.length < 3) {
      return done();
    }

    delete opt.highlight;

    if (!pending) return done();

    for (; i < tokens.length; i++) {
      (function(token) {
        if (token.type !== 'code') {
          return --pending || done();
        }
        return highlight(token.text, token.lang, function(err, code) {
          if (err) return done(err);
          if (code == null || code === token.text) {
            return --pending || done();
          }
          token.text = code;
          token.escaped = true;
          --pending || done();
        });
      })(tokens[i]);
    }

    return;
  }
  try {
    if (opt) opt = merge({}, marked.defaults, opt);
    return Parser.parse(Lexer.lex(src, opt), opt);
  } catch (e) {
    e.message += '\nPlease report this to https://github.com/markedjs/marked.';
    if ((opt || marked.defaults).silent) {
      return '<p>An error occurred:</p><pre>'
        + escape(e.message + '', true)
        + '</pre>';
    }
    throw e;
  }
}

/**
 * Options
 */

marked.options =
marked.setOptions = function(opt) {
  merge(marked.defaults, opt);
  return marked;
};

marked.getDefaults = function () {
  return {
    baseUrl: null,
    breaks: false,
    gfm: true,
    headerIds: true,
    headerPrefix: '',
    highlight: null,
    langPrefix: 'language-',
    mangle: true,
    pedantic: false,
    renderer: new Renderer(),
    sanitize: false,
    sanitizer: null,
    silent: false,
    smartLists: false,
    smartypants: false,
    tables: true,
    xhtml: false
  };
};

marked.defaults = marked.getDefaults();

/**
 * Expose
 */

marked.Parser = Parser;
marked.parser = Parser.parse;

marked.Renderer = Renderer;
marked.TextRenderer = TextRenderer;

marked.Lexer = Lexer;
marked.lexer = Lexer.lex;

marked.InlineLexer = InlineLexer;
marked.inlineLexer = InlineLexer.output;

marked.parse = marked;

if (true) {
  module.exports = marked;
} else if (typeof define === 'function' && define.amd) {
  define(function() { return marked; });
} else {
  root.marked = marked;
}
})(this || (typeof window !== 'undefined' ? window : global));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilePlayer = exports.Mixcloud = exports.DailyMotion = exports.Twitch = exports.Wistia = exports.Streamable = exports.Facebook = exports.Vimeo = exports.SoundCloud = exports.YouTube = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _YouTube = __webpack_require__(979);

Object.defineProperty(exports, 'YouTube', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_YouTube)['default'];
  }
});

var _SoundCloud = __webpack_require__(981);

Object.defineProperty(exports, 'SoundCloud', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SoundCloud)['default'];
  }
});

var _Vimeo = __webpack_require__(982);

Object.defineProperty(exports, 'Vimeo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Vimeo)['default'];
  }
});

var _Facebook = __webpack_require__(1118);

Object.defineProperty(exports, 'Facebook', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Facebook)['default'];
  }
});

var _Streamable = __webpack_require__(1119);

Object.defineProperty(exports, 'Streamable', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Streamable)['default'];
  }
});

var _Wistia = __webpack_require__(1120);

Object.defineProperty(exports, 'Wistia', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Wistia)['default'];
  }
});

var _Twitch = __webpack_require__(1121);

Object.defineProperty(exports, 'Twitch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Twitch)['default'];
  }
});

var _DailyMotion = __webpack_require__(983);

Object.defineProperty(exports, 'DailyMotion', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DailyMotion)['default'];
  }
});

var _Mixcloud = __webpack_require__(1122);

Object.defineProperty(exports, 'Mixcloud', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Mixcloud)['default'];
  }
});

var _FilePlayer = __webpack_require__(1123);

Object.defineProperty(exports, 'FilePlayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FilePlayer)['default'];
  }
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _props2 = __webpack_require__(733);

var _utils = __webpack_require__(145);

var _players = __webpack_require__(1475);

var _players2 = _interopRequireDefault(_players);

var _Player4 = __webpack_require__(980);

var _Player5 = _interopRequireDefault(_Player4);

var _preload = __webpack_require__(1476);

var _preload2 = _interopRequireDefault(_preload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SUPPORTED_PROPS = Object.keys(_props2.propTypes);

var customPlayers = [];

var ReactPlayer = function (_Component) {
  _inherits(ReactPlayer, _Component);

  function ReactPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.getDuration = function () {
      if (!_this.player) return null;
      return _this.player.getDuration();
    }, _this.getCurrentTime = function () {
      if (!_this.player) return null;
      return _this.player.getCurrentTime();
    }, _this.getSecondsLoaded = function () {
      if (!_this.player) return null;
      return _this.player.getSecondsLoaded();
    }, _this.getInternalPlayer = function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';

      if (!_this.player) return null;
      return _this.player.getInternalPlayer(key);
    }, _this.seekTo = function (fraction) {
      if (!_this.player) return null;
      _this.player.seekTo(fraction);
    }, _this.onReady = function () {
      _this.props.onReady(_this);
    }, _this.wrapperRef = function (wrapper) {
      _this.wrapper = wrapper;
    }, _this.activePlayerRef = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.progressFrequency) {
        var message = 'ReactPlayer: %cprogressFrequency%c is deprecated, please use %cprogressInterval%c instead';
        console.warn(message, 'font-weight: bold', '', 'font-weight: bold', '');
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _utils.isEqual)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
    }
  }, {
    key: 'getActivePlayer',
    value: function getActivePlayer(url) {
      var _arr = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));

      for (var _i = 0; _i < _arr.length; _i++) {
        var _Player = _arr[_i];
        if (_Player.canPlay(url)) {
          return _Player;
        }
      }
      // Fall back to FilePlayer if nothing else can play the URL
      return _FilePlayer.FilePlayer;
    }
  }, {
    key: 'renderActivePlayer',
    value: function renderActivePlayer(url) {
      if (!url) return null;
      var activePlayer = this.getActivePlayer(url);
      return _react2['default'].createElement(_Player5['default'], _extends({}, this.props, {
        key: activePlayer.displayName,
        ref: this.activePlayerRef,
        config: this.config,
        activePlayer: activePlayer,
        onReady: this.onReady
      }));
    }
  }, {
    key: 'sortPlayers',
    value: function sortPlayers(a, b) {
      // Retain player order to prevent weird iframe behaviour when switching players
      if (a && b) {
        return a.key < b.key ? -1 : 1;
      }
      return 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          style = _props.style,
          width = _props.width,
          height = _props.height,
          Wrapper = _props.wrapper;

      var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
      var activePlayer = this.renderActivePlayer(url);
      var preloadPlayers = (0, _preload2['default'])(url, this.config);
      var players = [activePlayer].concat(_toConsumableArray(preloadPlayers)).sort(this.sortPlayers);
      return _react2['default'].createElement(
        Wrapper,
        _extends({ ref: this.wrapperRef, style: _extends({}, style, { width: width, height: height }) }, otherProps),
        players
      );
    }
  }]);

  return ReactPlayer;
}(_react.Component);

ReactPlayer.addCustomPlayer = function (player) {
  customPlayers.push(player);
};

ReactPlayer.removeCustomPlayers = function () {
  customPlayers = [];
};

ReactPlayer.displayName = 'ReactPlayer';
ReactPlayer.propTypes = _props2.propTypes;
ReactPlayer.defaultProps = _props2.defaultProps;

ReactPlayer.canPlay = function (url) {
  var _arr2 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));

  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var _Player2 = _arr2[_i2];
    if (_Player2.canPlay(url)) {
      return true;
    }
  }
  return false;
};

ReactPlayer.canEnablePIP = function (url) {
  var _arr3 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));

  for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
    var _Player3 = _arr3[_i3];
    if (_Player3.canEnablePIP && _Player3.canEnablePIP(url)) {
      return true;
    }
  }
  return false;
};

exports['default'] = ReactPlayer;

/***/ }),
/* 1470 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1473)();
}


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1474);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _YouTube = __webpack_require__(979);

var _SoundCloud = __webpack_require__(981);

var _Vimeo = __webpack_require__(982);

var _Facebook = __webpack_require__(1118);

var _Streamable = __webpack_require__(1119);

var _Wistia = __webpack_require__(1120);

var _Twitch = __webpack_require__(1121);

var _DailyMotion = __webpack_require__(983);

var _Mixcloud = __webpack_require__(1122);

var _FilePlayer = __webpack_require__(1123);

exports['default'] = [_YouTube.YouTube, _SoundCloud.SoundCloud, _Vimeo.Vimeo, _Facebook.Facebook, _Streamable.Streamable, _Wistia.Wistia, _Twitch.Twitch, _DailyMotion.DailyMotion, _Mixcloud.Mixcloud, _FilePlayer.FilePlayer];

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = renderPreloadPlayers;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Player = __webpack_require__(980);

var _Player2 = _interopRequireDefault(_Player);

var _YouTube = __webpack_require__(979);

var _SoundCloud = __webpack_require__(981);

var _Vimeo = __webpack_require__(982);

var _DailyMotion = __webpack_require__(983);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PRELOAD_PLAYERS = [{
  Player: _YouTube.YouTube,
  configKey: 'youtube',
  url: 'https://www.youtube.com/watch?v=GlCmAC4MHek'
}, {
  Player: _SoundCloud.SoundCloud,
  configKey: 'soundcloud',
  url: 'https://soundcloud.com/seucheu/john-cage-433-8-bit-version'
}, {
  Player: _Vimeo.Vimeo,
  configKey: 'vimeo',
  url: 'https://vimeo.com/300970506'
}, {
  Player: _DailyMotion.DailyMotion,
  configKey: 'dailymotion',
  url: 'http://www.dailymotion.com/video/xqdpyk'
}];

function renderPreloadPlayers(url, config) {
  var players = [];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = PRELOAD_PLAYERS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var player = _step.value;

      if (!player.Player.canPlay(url) && config[player.configKey].preload) {
        players.push(_react2['default'].createElement(_Player2['default'], {
          key: player.Player.displayName,
          activePlayer: player.Player,
          url: player.url,
          playing: true,
          muted: true,
          style: { display: 'none' }
        }));
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return players;
}

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadHelpSideBarPages = undefined;

var _constants = __webpack_require__(582);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var loadHelpSideBarPages = exports.loadHelpSideBarPages = function loadHelpSideBarPages() {
  return { type: cnt.SIDEBARHELP_INIT };
};

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FloatingActionButton = __webpack_require__(1081);

var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var HelpWidgetOption = function HelpWidgetOption(_ref) {
  var icon = _ref.icon,
      hintText = _ref.hintText,
      isActive = _ref.isActive,
      onTouchTap = _ref.onTouchTap,
      props = _objectWithoutProperties(_ref, ['icon', 'hintText', 'isActive', 'onTouchTap']);

  var Icon = _react2.default.createElement(
    _FloatingActionButton2.default,
    _extends({ zDepth: 1,
      onTouchTap: onTouchTap,
      mini: true,
      disabled: !isActive
    }, props),
    icon
  );
  return hintText ? _react2.default.createElement(
    'div',
    { 'aria-label': hintText, className: 'hint--left' },
    Icon
  ) : Icon;
};

exports.default = HelpWidgetOption;

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _arrowBack = __webpack_require__(1124);

var _arrowBack2 = _interopRequireDefault(_arrowBack);

var _close = __webpack_require__(547);

var _close2 = _interopRequireDefault(_close);

var _check = __webpack_require__(854);

var _check2 = _interopRequireDefault(_check);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRouterRedux = __webpack_require__(27);

var _forContractRequest = __webpack_require__(1480);

var _forContractRequest2 = _interopRequireDefault(_forContractRequest);

var _requestSigsDialog = __webpack_require__(1481);

var _requestSigsDialog2 = _interopRequireDefault(_requestSigsDialog);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  dialogContent: {
    width: '100% !important',
    maxWidth: 'none !important',
    transform: 'none !important'
  },
  dialogBody: {
    height: 'calc(100vh - 64px)',
    padding: '0 !important',
    maxHeight: 'none !important'
    // height: '100%',
  },
  dialogRoot: {
    paddingTop: '0 !important'
  }
};

var RateDocIframe = function RateDocIframe(_ref) {
  var open = _ref.open,
      url = _ref.url,
      buyerLogo = _ref.buyerLogo,
      buyerName = _ref.buyerName,
      isInSigning = _ref.isInSigning,
      forImport = _ref.forImport,
      forCCImport = _ref.forCCImport,
      css = _ref.classes,
      onClose = _ref.onClose,
      acceptingDummyTemplate = _ref.acceptingDummyTemplate,
      loading = _ref.loading,
      _ref$crIds = _ref.crIds,
      crIds = _ref$crIds === undefined ? [] : _ref$crIds,
      rateDocId = _ref.rateDocId,
      selectTemplateForImport = _ref.selectTemplateForImport;

  if (!open) return null;
  var inSigning = isInSigning || window.location.href.indexOf('assets-landing') > -1;
  var handleClose = function handleClose() {
    return onClose(crIds[0]);
  };
  var handleSelectImportTemplate = function handleSelectImportTemplate() {
    return selectTemplateForImport(rateDocId, forCCImport);
  };
  var handleFrameLoad = function handleFrameLoad() {
    // trackEvent({ name: `[Wall] Opened ${slug}`, ga: {
    //   eventCategory: 'account',
    //   eventAction: 'wallOpen',
    //   eventValue: slug,
    // }});
  };
  var title = forImport ? _react2.default.createElement(
    'div',
    { style: { height: '64px', lineHeight: 'none', padding: '0 16px', color: '#fff', backgroundColor: '#00bcd4', fontSize: '14px' }, className: 'flex-tc-sb' },
    _react2.default.createElement(
      'span',
      null,
      forCCImport ? 'PRIVACY NOTE: Rates and sensitive data has been hidden for privacy purposes.  You can add rates after you complete this import.' : ''
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_materialUi.FlatButton, {
        labelStyle: { fontWeight: 'bold', color: '#fff' },
        label: 'Close Preview',
        icon: _react2.default.createElement(_close2.default, { color: '#fff' }),
        onClick: handleClose
      }),
      '\xA0\xA0\xA0',
      _react2.default.createElement(_materialUi.RaisedButton, {
        labelStyle: { fontWeight: 'bold', color: '#00bcd4' },
        label: 'Select this rate sheet',
        icon: _react2.default.createElement(_check2.default, { color: '#00bcd4' }),
        onClick: handleSelectImportTemplate
      })
    )
  ) : _react2.default.createElement(
    'div',
    { style: { height: '64px', backgroundColor: '#fff', lineHeight: 'none', padding: '0 8px', color: '#000' } },
    _react2.default.createElement(
      'div',
      { className: 'flex-tc-sb', style: { height: '62px' } },
      _react2.default.createElement(_materialUi.FlatButton, {
        labelStyle: { fontWeight: 'bold' },
        label: inSigning ? 'Go Back & Sign' : 'Back',
        icon: _react2.default.createElement(_arrowBack2.default, null),
        onClick: handleClose
      }),
      function () {
        if (inSigning) {
          return _react2.default.createElement(
            'div',
            { className: 'flex-center' },
            buyerLogo ? _react2.default.createElement(_materialUi.Avatar, { src: buyerLogo }) : _react2.default.createElement(
              _materialUi.Avatar,
              null,
              _ramda2.default.first(buyerName || '')
            ),
            '\xA0\xA0',
            buyerName
          );
        }
        if (url.indexOf('forDiffing') > -1) return _react2.default.createElement('span', null);
        return _react2.default.createElement(_forContractRequest2.default, null);
      }()
    ),
    loading && _react2.default.createElement(_materialUi.LinearProgress, { style: { flexGrow: 1, height: '12px', borderRadius: '5px', width: '50%', margin: '16px auto' } })
  );
  var iframeInIframe = window.location.href.indexOf("https://sec.tourconnect.com") > -1 && forCCImport;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _materialUi.Dialog,
      {
        style: _extends({
          zIndex: 2101
        }, iframeInIframe ? { left: '10%', width: '80%', top: '16px' } : {}),
        className: css.dialogRoot,
        open: open,
        onRequestClose: handleClose,
        title: title,
        contentClassName: css.dialogContent,
        bodyClassName: css.dialogBody
      },
      _react2.default.createElement('iframe', { src: url, style: forImport ? { border: 'none' } : {}, width: '100%', height: '100%', title: 'Rates Iframe', onLoad: handleFrameLoad })
    ),
    !inSigning && _react2.default.createElement(_requestSigsDialog2.default, null),
    _react2.default.createElement(_loadingOverlay2.default, {
      loading: acceptingDummyTemplate
    })
  );
};
/*
*onClick={handleCose} />
*/
/*
      <div style={{ backgroundColor: 'rgb(250, 250, 250)', position: 'fixed', top: 0, left: 0, height: '100%', width: '100%', zIndex: 1350 }}>
        <iframe src={ url } width='100%' height='100%' title="Upgrade Promo"/>
      </div>
*/
exports.default = (0, _reactRedux.connect)(function (_ref2) {
  var rateDocIframe = _ref2.dummyAcct.rateDocIframe;
  return rateDocIframe;
}, {
  onClose: function onClose(crId) {
    return { type: '{dummy-account} RateDocIframe_close', payload: { crId: crId } };
  },
  trackEvent: function trackEvent(payload) {
    return {
      type: 'TRACK_EVENT',
      payload: payload
    };
  },
  push: _reactRouterRedux.push,
  selectTemplateForImport: function selectTemplateForImport(docId, forCCImport) {
    return { type: 'RateDocIframe_selectImportTemplate', payload: { docId: docId, forCCImport: forCCImport } };
  }
})((0, _reactJss2.default)(styles)(RateDocIframe));

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _smallButtons = __webpack_require__(94);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForContractRequestStepper = function ForContractRequestStepper(props) {
  var collection = props.collection,
      rateDocId = props.rateDocId,
      _props$defaultInvitee = props.defaultInvitees,
      defaultInvitees = _props$defaultInvitee === undefined ? [] : _props$defaultInvitee,
      _props$signatures = props.signatures,
      signatures = _props$signatures === undefined ? [] : _props$signatures,
      originFrom = props.originFrom,
      realActorEmail = props.realActorEmail,
      acceptingDummyTemplate = props.acceptingDummyTemplate,
      deletingDraft = props.deletingDraft,
      openRequestSig = props.openRequestSig,
      acceptDummyTemplate = props.acceptDummyTemplate,
      discardDraft = props.discardDraft,
      loading = props.loading,
      draftType = props.draftType;

  var shouldDisableButtons = acceptingDummyTemplate || deletingDraft || loading;
  var isADraft = collection === 'draft';
  var accepted = !isADraft || signatures.some(function (obj) {
    return obj.signedAt;
  });
  if (originFrom === 'edited' || draftType === 'buyerCopy') {
    return _react2.default.createElement(
      _materialUi.Stepper,
      { style: { width: 'calc(100% - 200px)' } },
      _react2.default.createElement(
        _materialUi.Step,
        null,
        _react2.default.createElement(
          _materialUi.StepLabel,
          { style: { height: '32px', paddingLeft: 0 } },
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'center' } },
            'Make Changes'
          )
        )
      ),
      _react2.default.createElement(
        _materialUi.Step,
        null,
        _react2.default.createElement(
          _materialUi.StepLabel,
          { style: { height: '32px', paddingLeft: 0 } },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', flexDirection: 'column' } },
            _react2.default.createElement(
              'div',
              { style: { textAlign: 'center' }, className: 'flex-center' },
              _react2.default.createElement(_smallButtons.SmallRaisedButton, {
                label: 'Discard Changes',
                primary: true,
                labelStyle: { padding: '0 4px', textTransform: 'none' },
                onClick: discardDraft,
                disabled: shouldDisableButtons
              }),
              '\xA0\xA0Or\xA0\xA0',
              _react2.default.createElement(_smallButtons.SmallRaisedButton, {
                label: 'Request Signatures',
                secondary: true,
                labelStyle: { padding: '0 4px', textTransform: 'none' },
                disabled: shouldDisableButtons,
                onClick: function onClick() {
                  return openRequestSig({
                    invitees: defaultInvitees,
                    rateDocId: rateDocId,
                    signatures: signatures
                  });
                }
              }),
              '\xA0\xA0Or\xA0\xA0',
              _react2.default.createElement(_smallButtons.SmallRaisedButton, {
                label: 'Accept Changes',
                secondary: true,
                labelStyle: { padding: '0 4px', textTransform: 'none' },
                onClick: function onClick() {
                  if (realActorEmail === 'admin@tourconnect.com') {
                    window.alert('Mike!!!! We talked about this 100 times, don\'t click on this button!!!!');
                    return;
                  }
                  acceptDummyTemplate({
                    rateDocId: rateDocId
                  });
                },
                disabled: shouldDisableButtons
              })
            ),
            Boolean(signatures.length) && _react2.default.createElement(
              'small',
              {
                style: { display: 'block', marginLeft: '150px' }
              },
              'Last requested on ',
              (0, _moment2.default)(_ramda2.default.last(signatures).inviteSentAt).format('l')
            )
          )
        )
      )
    );
  }
  return _react2.default.createElement(
    _materialUi.Stepper,
    { style: { width: 'calc(100% - 200px)' } },
    _react2.default.createElement(
      _materialUi.Step,
      null,
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px', paddingLeft: 0 } },
        _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          'Create Rate Sheet'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.Step,
      null,
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px', paddingLeft: 0 } },
        _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          'Enter Rates & Required Information'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.Step,
      null,
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px' } },
        function () {
          if (accepted || originFrom !== 'initial') {
            return _react2.default.createElement(
              'div',
              { style: { textAlign: 'center', width: '100%', display: 'flex', alignItems: 'center' } },
              'Review'
            );
          }
          if (signatures.length) {
            return _react2.default.createElement(
              'div',
              { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '16px' } },
              _react2.default.createElement(_smallButtons.SmallRaisedButton, {
                label: 'Resend Signature Request',
                secondary: true,
                labelStyle: { padding: '0 4px', textTransform: 'none' },
                disabled: shouldDisableButtons,
                onClick: function onClick() {
                  return openRequestSig({
                    invitees: defaultInvitees,
                    rateDocId: rateDocId,
                    signatures: signatures
                  });
                }
              }),
              _react2.default.createElement(
                'small',
                null,
                'Last requested on ',
                (0, _moment2.default)(_ramda2.default.last(signatures).inviteSentAt).format('l')
              )
            );
          }
          return _react2.default.createElement(
            'div',
            { style: { textAlign: 'center', width: '100%', display: 'flex', alignItems: 'center' } },
            'Review or\xA0',
            _react2.default.createElement(_smallButtons.SmallRaisedButton, {
              label: 'Request Signatures',
              secondary: true,
              labelStyle: { padding: '0 4px', textTransform: 'none' },
              disabled: shouldDisableButtons,
              onClick: function onClick() {
                return openRequestSig({
                  invitees: defaultInvitees,
                  rateDocId: rateDocId,
                  signatures: signatures
                });
              }
            })
          );
        }()
      )
    ),
    _react2.default.createElement(
      _materialUi.Step,
      null,
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px', paddingRight: 0 } },
        _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          function () {
            if (accepted) {
              return 'Accepted';
            }
            return _react2.default.createElement(
              'div',
              { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '16px' } },
              _react2.default.createElement(_smallButtons.SmallRaisedButton, {
                label: 'Accept',
                secondary: true,
                disabled: shouldDisableButtons,
                labelStyle: { padding: '0 4px', textTransform: 'none' },
                style: { marginRight: '4px', width: '140px' },
                onClick: function onClick() {
                  if (realActorEmail === 'admin@tourconnect.com') {
                    window.alert('Mike!!!! We talked about this 100 times, don\'t click on this button!!!!');
                    return;
                  }
                  acceptDummyTemplate({
                    rateDocId: rateDocId
                  });
                }
              }),
              _react2.default.createElement(
                'small',
                null,
                'By ',
                realActorEmail
              )
            );
          }()
        )
      )
    )
  );
};

ForContractRequestStepper.propTypes = {
  completionPercent: _react2.default.PropTypes.number,
  collection: _react2.default.PropTypes.string,
  acceptedBy: _react2.default.PropTypes.array,
  rateDocId: _react2.default.PropTypes.string,
  defaultInvitees: _react2.default.PropTypes.array,
  signatures: _react2.default.PropTypes.array,
  originFrom: _react2.default.PropTypes.string,
  draftType: _react2.default.PropTypes.string,
  editHistory: _react2.default.PropTypes.array,
  realActorEmail: _react2.default.PropTypes.string,
  openRequestSig: _react2.default.PropTypes.func,
  acceptDummyTemplate: _react2.default.PropTypes.func,
  acceptingDummyTemplate: _react2.default.PropTypes.bool,
  discardDraft: _react2.default.PropTypes.func,
  deletingDraft: _react2.default.PropTypes.bool,
  loading: _react2.default.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(function (_ref) {
  var dummyAcct = _ref.dummyAcct,
      user = _ref.user;
  return _extends({}, dummyAcct.rateDocIframe, {
    realActorEmail: user.get('realActorEmail')
  });
}, {
  acceptDummyTemplate: function acceptDummyTemplate(payload) {
    return {
      type: '{dummy-account} RateDocIframe_checkIfRateComplete',
      next: '{dummy-account} ACCEPT_DUMMY_TEMPLATE',
      payload: payload,
      shouldBlock: true
    };
  },
  discardDraft: function discardDraft() {
    return {
      type: '{dummy-account} DISCARD_DUMMY_TEMPLATE_DRAFT'
    };
  },
  openRequestSig: function openRequestSig(payload) {
    return { type: '{dummy-account} RateDocIframe_checkIfRateComplete', next: '{dummy-account}OPEN_REQUEST_SIGNATURE', payload: payload };
  }
})(ForContractRequestStepper);

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _materialUi = __webpack_require__(3);

var _textarea = __webpack_require__(1050);

var _textarea2 = _interopRequireDefault(_textarea);

var _helperFunctions = __webpack_require__(1116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RequestSigDialog = function RequestSigDialog(props) {
  var cancel = props.cancel,
      open = props.open,
      subject = props.subject,
      message = props.message,
      invitees = props.invitees,
      rateDocId = props.rateDocId,
      _props$signatures = props.signatures,
      signatures = _props$signatures === undefined ? [] : _props$signatures,
      updateProps = props.updateProps,
      sending = props.sending,
      realActorEmail = props.realActorEmail,
      requestSigsFunc = props.requestSigsFunc,
      crId = props.crId;

  var send = function send() {
    return requestSigsFunc({
      rateDocIds: [rateDocId],
      emails: invitees,
      subject: subject,
      message: message,
      sentBy: realActorEmail,
      requestSigsChecked: true,
      crId: crId
    });
  };
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      style: { zIndex: 2102 },
      open: open,
      onRequestClose: cancel,
      autoScrollBodyContent: true,
      title: 'Request Signatures',
      actions: [_react2.default.createElement(_materialUi.FlatButton, {
        key: 'cancel',
        label: 'cancel',
        primary: true,
        onClick: cancel
      }), _react2.default.createElement(_materialUi.FlatButton, {
        key: 'send',
        label: signatures.length ? 'resend' : 'send',
        secondary: true,
        disabled: sending || !invitees.length,
        onClick: send
      })]
    },
    Boolean(signatures && signatures.length) && _react2.default.createElement(
      'div',
      { style: { marginBottom: '32px' } },
      _react2.default.createElement(
        'label',
        null,
        'Requests sent:'
      ),
      signatures.map(function (sig, i) {
        return _react2.default.createElement(
          'div',
          { key: i, className: 'flex-tc-sb' },
          _react2.default.createElement(
            'div',
            null,
            sig.invitee
          ),
          _react2.default.createElement(
            'small',
            null,
            (0, _moment2.default)(sig.inviteSentAt).format('DD MMM YYYY')
          ),
          _react2.default.createElement(
            'small',
            null,
            sig.inviteSentBy
          )
        );
      })
    ),
    _react2.default.createElement(
      'label',
      null,
      'Please separate invitees with a semicolon;'
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(_textarea2.default, {
      value: invitees.join(';'),
      onChange: function onChange(e) {
        return updateProps({ invitees: e.target.value.split(';') });
      },
      rows: 2,
      error: invitees.some(function (str) {
        return str && !(0, _helperFunctions.validEmail)(str);
      }) ? 'Please enter valid email addresses' : ''
    }),
    _react2.default.createElement(
      'label',
      null,
      'Please enter a subject here:'
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(_textarea2.default, {
      value: subject || '',
      onChange: function onChange(e) {
        return updateProps({ subject: e.target.value });
      },
      rows: 1
    }),
    _react2.default.createElement(
      'label',
      null,
      'Optional message:'
    ),
    _react2.default.createElement(_textarea2.default, {
      value: message || '',
      onChange: function onChange(e) {
        return updateProps({ message: e.target.value });
      },
      rows: 4
    }),
    _react2.default.createElement(
      'label',
      null,
      'Sent By: ',
      realActorEmail
    )
  );
};

RequestSigDialog.propTypes = {
  cancel: _react.PropTypes.func,
  updateProps: _react.PropTypes.func,
  open: _react.PropTypes.bool,
  subject: _react.PropTypes.string,
  message: _react.PropTypes.string,
  invitees: _react.PropTypes.array,
  rateDocId: _react.PropTypes.string,
  signatures: _react.PropTypes.array,
  realActorEmail: _react.PropTypes.string,
  sending: _react.PropTypes.bool,
  requestSigsFunc: _react.PropTypes.func
};

exports.default = (0, _reactRedux.connect)(function (_ref) {
  var dummyAcct = _ref.dummyAcct,
      user = _ref.user;
  return _extends({}, dummyAcct.requestSigs, {
    realActorEmail: user.get('realActorEmail')
  });
}, {
  cancel: function cancel() {
    return { type: '{dummy-account}CANCEL_REQUEST_SIGNATURE' };
  },
  updateProps: function updateProps(payload) {
    return { type: '{dummy-account}UPDATE_PROPS', payload: payload };
  },
  requestSigsFunc: function requestSigsFunc(payload) {
    return { type: '{dummy-account} REQUEST_SIGNATURE', payload: payload };
  }
})(RequestSigDialog);

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitOnboarding = submitOnboarding;
exports.setOnboardingFields = setOnboardingFields;

var _soFetch = __webpack_require__(254);

var _onboardingConstants = __webpack_require__(2825);

var constants = _interopRequireWildcard(_onboardingConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function submitOnboarding(onboardingInfo) {
  return (0, _soFetch.soFetch)('/proxy/onboarding', {
    method: 'post',
    body: onboardingInfo,
    actionType: constants.ONBOARDING_SUBMIT,
    responseBinding: 'payload'
  });
}

function setOnboardingFields(fieldAndValue) {
  return {
    type: constants.SET_ONBOADING_FIELDS,
    payload: fieldAndValue
  };
}

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _jquery = __webpack_require__(251);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = (0, _react.createClass)({

  propTypes: {
    title: _react.PropTypes.string,
    subtitle: _react.PropTypes.string,
    padded: _react.PropTypes.bool,
    isFixed: _react.PropTypes.bool,
    isSticky: _react.PropTypes.bool,
    children: _react.PropTypes.any,
    contentStyle: _react.PropTypes.object,
    className: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      padded: true
    };
  },
  componentDidMount: function componentDidMount() {
    var resizeCss = function resizeCss(wrapper) {
      var wRatio = 744 / this.naturalWidth;
      var hRatio = 320 / this.naturalHeight;
      var ratio = Math.min(wRatio, hRatio);

      if (this.naturalWidth > this.naturalHeight) {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto'
        });
      } else {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto'
        });
      }
    };

    var $image = (0, _jquery2.default)('.tc-card-header-image');
    $image.load(function () {
      resizeCss.call(this, $image);
    });
  },
  render: function render() {
    var _this = this;

    var classes = (0, _classnames2.default)('tc-card', this.props.className, {
      'is-padded': this.props.padded,
      'is-fixed': this.props.isFixed,
      'is-sticky': this.props.isSticky
    });

    var headers = [];

    this.props.children.forEach(function (child, index) {
      if (index !== _this.props.children.length - 1) {
        headers.push(_react2.default.createElement(
          'div',
          { key: index, className: 'tc-card-header', style: child.props.headerStyle },
          child
        ));
      }
    });

    var content = this.props.children[this.props.children.length - 1];

    return _react2.default.createElement(
      _materialUi.Paper,
      { className: classes },
      headers,
      _react2.default.createElement(
        'div',
        { style: this.props.contentStyle, className: 'tc-card-contents' },
        content
      )
    );
  }
});

exports.default = Card;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _materialUi = __webpack_require__(3);

var _reactDom = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConnectionsSearchBar = (0, _react.createClass)({

  propTypes: {
    searchWithInput: _react.PropTypes.func,
    searchBarHintText: _react.PropTypes.string,
    className: _react.PropTypes.string,
    defaultValue: _react.PropTypes.string
  },

  getInitialState: function getInitialState() {
    return {
      open: true,
      input: this.props.defaultValue || ''
    };
  },
  onClick: function onClick() {
    var _this = this;

    document.getElementById('searchBar').focus();
    this.setState({ open: !this.state.open }, function () {
      if (_this.state.open) document.getElementById('searchBar').focus();else document.getElementById('searchBar').blur();
    });
  },
  preventTabAndEnter: function preventTabAndEnter(event) {
    if (event.keyCode === 13) {
      this.props.searchWithInput(this.state.input);
    }
    if (event.which === 9) {
      event.preventDefault();
    }
  },
  searchContent: function searchContent(event) {
    this.setState({ input: event.target.value });
  },
  clearInput: function clearInput() {
    (0, _reactDom.findDOMNode)(this.refs.searchBar).value = '';
    this.props.searchWithInput('');
    this.setState({ input: '' });
  },
  render: function render() {
    var _this2 = this;

    var classes = (0, _classnames2.default)('connections-search-input', this.props.className, {
      'is-closed': !this.state.open
    });

    return _react2.default.createElement(
      'div',
      {
        className: 'connections-search-bar ' + this.props.className,
        style: { border: '1px solid #00bcd4', borderRadius: '2px', height: '37px', position: 'relative', justifyContent: 'space-between', backgroundColor: 'white', display: 'flex' }
      },
      _react2.default.createElement(_materialUi.TextField, {
        hintText: this.props.searchBarHintText,
        value: this.state.input,
        inputStyle: { bottom: '2px' },
        style: { width: '85%', height: '35px', marginLeft: '4px' },
        hintStyle: { bottom: '6px', fontSize: '13px' },
        onKeyDown: this.preventTabAndEnter,
        underlineShow: false,
        ref: 'searchBar',
        onChange: this.searchContent
      }),
      _react2.default.createElement(_materialUi.IconButton, {
        iconClassName: 'tc-icon-close',
        iconStyle: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' },
        style: { padding: '0', top: '-2px', height: '37px', display: this.state.input ? 'inline-block' : 'none' },
        onTouchTap: function onTouchTap() {
          return _this2.setState({ input: '' }, function () {
            return _this2.props.searchWithInput(_this2.state.input);
          });
        }
      }),
      _react2.default.createElement(_materialUi.RaisedButton, {
        label: 'Search',
        style: { minWidth: '82px', width: '82px' },
        secondary: true,
        onTouchTap: function onTouchTap() {
          return _this2.props.searchWithInput(_this2.state.input);
        }
      })
    );
  }
});

exports.default = ConnectionsSearchBar;

/* jshint ignore:end */

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _inlineStylePrefixerStatic = __webpack_require__(1487);

var _inlineStylePrefixerStatic2 = _interopRequireDefault(_inlineStylePrefixerStatic);

var _util = __webpack_require__(997);

/**
 * Generate CSS for a selector and some styles.
 *
 * This function handles the media queries, pseudo selectors, and descendant
 * styles that can be used in aphrodite styles.
 *
 * @param {string} selector: A base CSS selector for the styles to be generated
 *     with.
 * @param {Object} styleTypes: A list of properties of the return type of
 *     StyleSheet.create, e.g. [styles.red, styles.blue].
 * @param stringHandlers: See `generateCSSRuleset`
 * @param useImportant: See `generateCSSRuleset`
 *
 * To actually generate the CSS special-construct-less styles are passed to
 * `generateCSSRuleset`.
 *
 * For instance, a call to
 *
 *     generateCSSInner(".foo", {
 *       color: "red",
 *       "@media screen": {
 *         height: 20,
 *         ":hover": {
 *           backgroundColor: "black"
 *         }
 *       },
 *       ":active": {
 *         fontWeight: "bold",
 *         ">>bar": {
 *           _names: { "foo_bar": true },
 *           height: 10,
 *         }
 *       }
 *     });
 *
 * will make 5 calls to `generateCSSRuleset`:
 *
 *     generateCSSRuleset(".foo", { color: "red" }, ...)
 *     generateCSSRuleset(".foo:active", { fontWeight: "bold" }, ...)
 *     generateCSSRuleset(".foo:active .foo_bar", { height: 10 }, ...)
 *     // These 2 will be wrapped in @media screen {}
 *     generateCSSRuleset(".foo", { height: 20 }, ...)
 *     generateCSSRuleset(".foo:hover", { backgroundColor: "black" }, ...)
 */
var generateCSS = function generateCSS(selector, styleTypes, stringHandlers, useImportant) {
    var merged = styleTypes.reduce(_util.recursiveMerge);

    var declarations = {};
    var mediaQueries = {};
    var pseudoStyles = {};

    Object.keys(merged).forEach(function (key) {
        if (key[0] === ':') {
            pseudoStyles[key] = merged[key];
        } else if (key[0] === '@') {
            mediaQueries[key] = merged[key];
        } else {
            declarations[key] = merged[key];
        }
    });

    return generateCSSRuleset(selector, declarations, stringHandlers, useImportant) + Object.keys(pseudoStyles).map(function (pseudoSelector) {
        return generateCSSRuleset(selector + pseudoSelector, pseudoStyles[pseudoSelector], stringHandlers, useImportant);
    }).join("") + Object.keys(mediaQueries).map(function (mediaQuery) {
        var ruleset = generateCSS(selector, [mediaQueries[mediaQuery]], stringHandlers, useImportant);
        return mediaQuery + '{' + ruleset + '}';
    }).join("");
};

exports.generateCSS = generateCSS;
/**
 * Helper method of generateCSSRuleset to facilitate custom handling of certain
 * CSS properties. Used for e.g. font families.
 *
 * See generateCSSRuleset for usage and documentation of paramater types.
 */
var runStringHandlers = function runStringHandlers(declarations, stringHandlers) {
    var result = {};

    Object.keys(declarations).forEach(function (key) {
        // If a handler exists for this particular key, let it interpret
        // that value first before continuing
        if (stringHandlers && stringHandlers.hasOwnProperty(key)) {
            result[key] = stringHandlers[key](declarations[key]);
        } else {
            result[key] = declarations[key];
        }
    });

    return result;
};

/**
 * Generate a CSS ruleset with the selector and containing the declarations.
 *
 * This function assumes that the given declarations don't contain any special
 * children (such as media queries, pseudo-selectors, or descendant styles).
 *
 * Note that this method does not deal with nesting used for e.g.
 * psuedo-selectors or media queries. That responsibility is left to  the
 * `generateCSS` function.
 *
 * @param {string} selector: the selector associated with the ruleset
 * @param {Object} declarations: a map from camelCased CSS property name to CSS
 *     property value.
 * @param {Object.<string, function>} stringHandlers: a map from camelCased CSS
 *     property name to a function which will map the given value to the value
 *     that is output.
 * @param {bool} useImportant: A boolean saying whether to append "!important"
 *     to each of the CSS declarations.
 * @returns {string} A string of raw CSS.
 *
 * Examples:
 *
 *    generateCSSRuleset(".blah", { color: "red" })
 *    -> ".blah{color: red !important;}"
 *    generateCSSRuleset(".blah", { color: "red" }, {}, false)
 *    -> ".blah{color: red}"
 *    generateCSSRuleset(".blah", { color: "red" }, {color: c => c.toUpperCase})
 *    -> ".blah{color: RED}"
 *    generateCSSRuleset(".blah:hover", { color: "red" })
 *    -> ".blah:hover{color: red}"
 */
var generateCSSRuleset = function generateCSSRuleset(selector, declarations, stringHandlers, useImportant) {
    var handledDeclarations = runStringHandlers(declarations, stringHandlers);

    var prefixedDeclarations = (0, _inlineStylePrefixerStatic2['default'])(handledDeclarations);

    var prefixedRules = (0, _util.flatten)((0, _util.objectToPairs)(prefixedDeclarations).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2);

        var key = _ref2[0];
        var value = _ref2[1];

        if (Array.isArray(value)) {
            var _ret = (function () {
                // inline-style-prefix-all returns an array when there should be
                // multiple rules, we will flatten to single rules

                var prefixedValues = [];
                var unprefixedValues = [];

                value.forEach(function (v) {
                    if (v.indexOf('-') === 0) {
                        prefixedValues.push(v);
                    } else {
                        unprefixedValues.push(v);
                    }
                });

                prefixedValues.sort();
                unprefixedValues.sort();

                return {
                    v: prefixedValues.concat(unprefixedValues).map(function (v) {
                        return [key, v];
                    })
                };
            })();

            if (typeof _ret === 'object') return _ret.v;
        }
        return [[key, value]];
    }));

    var rules = prefixedRules.map(function (_ref3) {
        var _ref32 = _slicedToArray(_ref3, 2);

        var key = _ref32[0];
        var value = _ref32[1];

        var stringValue = (0, _util.stringifyValue)(key, value);
        var ret = (0, _util.kebabifyStyleName)(key) + ':' + stringValue + ';';
        return useImportant === false ? ret : (0, _util.importantify)(ret);
    }).join("");

    if (rules) {
        return selector + '{' + rules + '}';
    } else {
        return "";
    }
};
exports.generateCSSRuleset = generateCSSRuleset;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1488)


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixAll;

var _prefixProps = __webpack_require__(1128);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

var _capitalizeString = __webpack_require__(1129);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _sortPrefixedStyle = __webpack_require__(1489);

var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);

var _position = __webpack_require__(1491);

var _position2 = _interopRequireDefault(_position);

var _calc = __webpack_require__(1492);

var _calc2 = _interopRequireDefault(_calc);

var _cursor = __webpack_require__(1493);

var _cursor2 = _interopRequireDefault(_cursor);

var _flex = __webpack_require__(1494);

var _flex2 = _interopRequireDefault(_flex);

var _sizing = __webpack_require__(1495);

var _sizing2 = _interopRequireDefault(_sizing);

var _gradient = __webpack_require__(1496);

var _gradient2 = _interopRequireDefault(_gradient);

var _transition = __webpack_require__(1497);

var _transition2 = _interopRequireDefault(_transition);

var _flexboxIE = __webpack_require__(1498);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(1499);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// special flexbox specifications


var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];

/**
 * Returns a prefixed version of the style object using all vendor prefixes
 * @param {Object} styles - Style object that gets prefixed properties added
 * @returns {Object} - Style object with prefixed properties and values
 */
function prefixAll(styles) {
  Object.keys(styles).forEach(function (property) {
    var value = styles[property];
    if (value instanceof Object && !Array.isArray(value)) {
      // recurse through nested style objects
      styles[property] = prefixAll(value);
    } else {
      Object.keys(_prefixProps2.default).forEach(function (prefix) {
        var properties = _prefixProps2.default[prefix];
        // add prefixes if needed
        if (properties[property]) {
          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
        }
      });
    }
  });

  Object.keys(styles).forEach(function (property) {
    [].concat(styles[property]).forEach(function (value, index) {
      // resolve every special plugins
      plugins.forEach(function (plugin) {
        return assignStyles(styles, plugin(property, value));
      });
    });
  });

  return (0, _sortPrefixedStyle2.default)(styles);
}

function assignStyles(base) {
  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  Object.keys(extend).forEach(function (property) {
    var baseValue = base[property];
    if (Array.isArray(baseValue)) {
      [].concat(extend[property]).forEach(function (value) {
        var valueIndex = baseValue.indexOf(value);
        if (valueIndex > -1) {
          base[property].splice(valueIndex, 1);
        }
        base[property].push(value);
      });
    } else {
      base[property] = extend[property];
    }
  });
}
module.exports = exports['default'];

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sortPrefixedStyle;

var _isPrefixedProperty = __webpack_require__(1490);

var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sortPrefixedStyle(style) {
  return Object.keys(style).sort(function (left, right) {
    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
      return -1;
    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
      return 1;
    }
    return 0;
  }).reduce(function (sortedStyle, prop) {
    sortedStyle[prop] = style[prop];
    return sortedStyle;
  }, {});
}
module.exports = exports['default'];

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (property) {
  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
};

module.exports = exports["default"];

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return { position: ['-webkit-sticky', 'sticky'] };
  }
}
module.exports = exports['default'];

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _joinPrefixedValue = __webpack_require__(734);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

var _isPrefixedValue = __webpack_require__(998);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;

var _joinPrefixedValue = __webpack_require__(734);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values[value]) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = { flex: true, 'inline-flex': true };

function flex(property, value) {
  if (property === 'display' && values[value]) {
    return {
      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _joinPrefixedValue = __webpack_require__(734);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties[property] && values[value]) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _joinPrefixedValue = __webpack_require__(734);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

var _isPrefixedValue = __webpack_require__(998);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateStyleName = __webpack_require__(1083);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _capitalizeString = __webpack_require__(1129);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _isPrefixedValue = __webpack_require__(998);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _prefixProps = __webpack_require__(1128);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true
};

function transition(property, value) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties[property]) {
    var _ref2;

    var outputValue = prefixValue(value);
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
      return value.match(/-moz-|-ms-/) === null;
    }).join(',');

    // if the property is already prefixed
    if (property.indexOf('Webkit') > -1) {
      return _defineProperty({}, property, webkitOutput);
    }

    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
  }
}

function prefixValue(value) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  // iterate each single value and check for transitioned properties
  // that need to be prefixed as well
  multipleValues.forEach(function (val, index) {
    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';

      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);

        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
          // join all prefixes and create a new value
          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
        }
      });
      return out;
    }, val);
  });

  return multipleValues.join(',');
}
module.exports = exports['default'];

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msPreferredSize'
};

function flexboxIE(property, value) {
  if (alternativeProps[property]) {
    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value) {
  if (property === 'flexDirection' && typeof value === 'string') {
    return {
      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
    };
  }
  if (alternativeProps[property]) {
    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(2864),
    mapCacheDelete = __webpack_require__(2880),
    mapCacheGet = __webpack_require__(2882),
    mapCacheHas = __webpack_require__(2883),
    mapCacheSet = __webpack_require__(2884);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(1051),
    isObject = __webpack_require__(735);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(1000),
    root = __webpack_require__(550);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 1503 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1504 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1505 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(2891),
    shortOut = __webpack_require__(1891);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 1507 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1894),
    isFlattenable = __webpack_require__(2896);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(2897),
    isObjectLike = __webpack_require__(874);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 1510 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shallowEqual;
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i += 1) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }

    var valA = objA[keysA[i]];
    var valB = objB[keysA[i]];

    if (valA !== valB) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = isDisposable;

function isDisposable(obj) {
  return Boolean(obj && typeof obj.dispose === 'function');
}

module.exports = exports['default'];

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILE = exports.FILE = '__NATIVE_FILE__';
var URL = exports.URL = '__NATIVE_URL__';
var TEXT = exports.TEXT = '__NATIVE_TEXT__';

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertErrorOutline = function AlertErrorOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
  );
};
AlertErrorOutline = (0, _pure2.default)(AlertErrorOutline);
AlertErrorOutline.displayName = 'AlertErrorOutline';
AlertErrorOutline.muiName = 'SvgIcon';

exports.default = AlertErrorOutline;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var _assign = __webpack_require__(127);
var invariant = __webpack_require__(56);
var hasOwnProperty = {}.hasOwnProperty;

function shallowCopy(x) {
  if (Array.isArray(x)) {
    return x.concat();
  } else if (x && typeof x === 'object') {
    return _assign(new x.constructor(), x);
  } else {
    return x;
  }
}

var COMMAND_PUSH = '$push';
var COMMAND_UNSHIFT = '$unshift';
var COMMAND_SPLICE = '$splice';
var COMMAND_SET = '$set';
var COMMAND_MERGE = '$merge';
var COMMAND_APPLY = '$apply';

var ALL_COMMANDS_LIST = [
  COMMAND_PUSH,
  COMMAND_UNSHIFT,
  COMMAND_SPLICE,
  COMMAND_SET,
  COMMAND_MERGE,
  COMMAND_APPLY
];

var ALL_COMMANDS_SET = {};

ALL_COMMANDS_LIST.forEach(function(command) {
  ALL_COMMANDS_SET[command] = true;
});

function invariantArrayCase(value, spec, command) {
  invariant(
    Array.isArray(value),
    'update(): expected target of %s to be an array; got %s.',
    command,
    value
  );
  var specValue = spec[command];
  invariant(
    Array.isArray(specValue),
    'update(): expected spec of %s to be an array; got %s. ' +
      'Did you forget to wrap your parameter in an array?',
    command,
    specValue
  );
}

/**
 * Returns a updated shallow copy of an object without mutating the original.
 * See https://facebook.github.io/react/docs/update.html for details.
 */
function update(value, spec) {
  invariant(
    typeof spec === 'object',
    'update(): You provided a key path to update() that did not contain one ' +
      'of %s. Did you forget to include {%s: ...}?',
    ALL_COMMANDS_LIST.join(', '),
    COMMAND_SET
  );

  if (hasOwnProperty.call(spec, COMMAND_SET)) {
    invariant(
      Object.keys(spec).length === 1,
      'Cannot have more than one key in an object with %s',
      COMMAND_SET
    );

    return spec[COMMAND_SET];
  }

  var nextValue = shallowCopy(value);

  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
    var mergeObj = spec[COMMAND_MERGE];
    invariant(
      mergeObj && typeof mergeObj === 'object',
      "update(): %s expects a spec of type 'object'; got %s",
      COMMAND_MERGE,
      mergeObj
    );
    invariant(
      nextValue && typeof nextValue === 'object',
      "update(): %s expects a target of type 'object'; got %s",
      COMMAND_MERGE,
      nextValue
    );
    _assign(nextValue, spec[COMMAND_MERGE]);
  }

  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
    invariantArrayCase(value, spec, COMMAND_PUSH);
    spec[COMMAND_PUSH].forEach(function(item) {
      nextValue.push(item);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
    spec[COMMAND_UNSHIFT].forEach(function(item) {
      nextValue.unshift(item);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
    invariant(
      Array.isArray(value),
      'Expected %s target to be an array; got %s',
      COMMAND_SPLICE,
      value
    );
    invariant(
      Array.isArray(spec[COMMAND_SPLICE]),
      'update(): expected spec of %s to be an array of arrays; got %s. ' +
        'Did you forget to wrap your parameters in an array?',
      COMMAND_SPLICE,
      spec[COMMAND_SPLICE]
    );
    spec[COMMAND_SPLICE].forEach(function(args) {
      invariant(
        Array.isArray(args),
        'update(): expected spec of %s to be an array of arrays; got %s. ' +
          'Did you forget to wrap your parameters in an array?',
        COMMAND_SPLICE,
        spec[COMMAND_SPLICE]
      );
      nextValue.splice.apply(nextValue, args);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
    invariant(
      typeof spec[COMMAND_APPLY] === 'function',
      'update(): expected spec of %s to be a function; got %s.',
      COMMAND_APPLY,
      spec[COMMAND_APPLY]
    );
    nextValue = spec[COMMAND_APPLY](nextValue);
  }

  for (var k in spec) {
    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
      nextValue[k] = update(value[k], spec[k]);
    }
  }

  return nextValue;
}

module.exports = update;


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Counter = function (_Component) {
  _inherits(Counter, _Component);

  function Counter() {
    _classCallCheck(this, Counter);

    return _possibleConstructorReturn(this, (Counter.__proto__ || Object.getPrototypeOf(Counter)).apply(this, arguments));
  }

  _createClass(Counter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          _props$style = _props.style,
          style = _props$style === undefined ? {} : _props$style;


      var dataClasses = (0, _classnames2.default)('counter', {
        'is-zero': data === 0
      });

      return _react2.default.createElement(
        'div',
        { style: style, className: dataClasses },
        data
      );
    }
  }]);

  return Counter;
}(_react.Component);

Counter.propTypes = {
  data: _react.PropTypes.number,
  style: _react.PropTypes.object
};

exports.default = Counter;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editProductField = editProductField;
exports.getUserProductProfile = getUserProductProfile;
exports.deleteCoverImageFromProduct = deleteCoverImageFromProduct;

var _soFetch = __webpack_require__(254);

var _http = __webpack_require__(118);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _productConstants = __webpack_require__(2992);

var constants = _interopRequireWildcard(_productConstants);

var _productGraphqlQuery = __webpack_require__(865);

var queries = _interopRequireWildcard(_productGraphqlQuery);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function editProductField(_ref) {
  var updateField = _ref.updateField,
      updateBody = _ref.updateBody,
      id = _ref.id,
      locationId = _ref.locationId;

  return function (dispatch) {
    var body = updateBody;
    if ((updateField === 'coverImageUrl' || updateField === 'profileImageUrl') && updateBody) {
      body += '?' + Date.now();
    }
    dispatch({
      type: constants.EDIT_USER_PRODUCT_PROFILE_FIELD_STARTING,
      payload: {
        id: id,
        updateField: updateField,
        locationId: locationId,
        updateBody: body
      }
    });
    return (0, _http.put)('/proxy/profile/products/' + id + '?mutation=' + queries.myProductMutation, {
      locationId: locationId,
      update: _defineProperty({}, updateField, body)
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({ type: constants.EDIT_USER_PRODUCT_PROFILE_FIELD, payload: res });
    });
  };
}

function getUserProductProfile(productId) {
  return (0, _soFetch.soFetch)('/proxy/profile/products/' + productId + '?query=' + queries.myProductProfileQuery, {
    method: 'get',
    actionType: constants.GET_USER_PRODUCT_PROFILE,
    responseBinding: 'product'
  });
}

function deleteCoverImageFromProduct(filename, id) {
  return function (dispatch) {
    return fetch('/proxy/profile/delete_cover_photos', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: filename + id })
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      return dispatch({
        type: constants.DELETE_COVER_IMAGE_FROM_PRODUCT,
        payload: { id: id }
      });
    }).catch(function (err) {
      return console.log('err in deleting product cover photo', err);
    });
  };
}

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1520),
    baseLodash = __webpack_require__(1521);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(735);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1521 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(1917),
    noop = __webpack_require__(1242);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1520),
    baseLodash = __webpack_require__(1521);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 1524 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(255),
    isSymbol = __webpack_require__(1250);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1890);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var getGeoLocation = exports.getGeoLocation = function getGeoLocation(address, fn) {
  var addressString = '';
  var addressFields = ['addressOne', 'addressTwo', 'city', 'state', 'country', 'zip'];

  addressFields.forEach(function (field) {
    if (address[field]) {
      addressString += address[field];
    }
  });
  if (!addressString) return fn({}, {});
  var geocoder = new window.google.maps.Geocoder();
  geocoder.geocode({
    'address': addressString,
    'region': 'US'
  }, function (response) {
    var _ref = response || [],
        _ref2 = _slicedToArray(_ref, 1),
        results = _ref2[0];

    var addressToReturn = {};
    var geometry = {};
    if (results) {
      geometry = results.geometry;
      addressToReturn.formattedAddress = results.formatted_address;
      var coordinates = [results.geometry.location.lng(), results.geometry.location.lat()];
      addressToReturn.coordinates = coordinates;
      addressToReturn.loc = { coordinates: coordinates };
      results.address_components.forEach(function (component) {
        if (component.types.indexOf('locality') > -1) addressToReturn.city = component.long_name;
        if (component.types.indexOf('administrative_area_level_1') > -1) addressToReturn.state = component.long_name;
        if (component.types.indexOf('postal_code') > -1) addressToReturn.postalCode = component.long_name;
      });
    }
    fn(addressToReturn, geometry);
  });
};

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _singleRoom = __webpack_require__(3108);

var _singleRoom2 = _interopRequireDefault(_singleRoom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BeddingConfigEdit = function BeddingConfigEdit(_ref) {
  var beddingConfig = _ref.beddingConfig,
      sendEditToReducer = _ref.sendEditToReducer,
      style = _ref.style;

  var setState = function setState(state) {
    var rooms = state.rooms;

    var flattenedBeds = rooms ? (0, _ramda.flatten)(rooms) : [];
    // R.all does not handle empty array
    var isValid = !(0, _ramda.isEmpty)(flattenedBeds) && (0, _ramda.all)((0, _ramda.allPass)([(0, _ramda.has)('bedType'), (0, _ramda.has)('count'), (0, _ramda.prop)('bedType'), (0, _ramda.prop)('count')]), flattenedBeds);
    sendEditToReducer({ value: state, isBeddingConfigInvalid: !isValid });
  };
  var isApartment = beddingConfig.isApartment,
      rooms = beddingConfig.rooms;

  return _react2.default.createElement(
    'div',
    { style: _ramda2.default.merge({ maxHeight: '500px', overflowY: 'scroll' }, style) },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { style: { padding: '24px 0 0 32px', marginBottom: '8px', color: 'black' } },
        'What type of room is this? '
      ),
      _react2.default.createElement(_materialUi.RadioButton, {
        checked: (0, _ramda.equals)(isApartment, false) && !(0, _ramda.isEmpty)(rooms),
        label: 'Individual Bedroom (One Room)',
        onCheck: function onCheck() {
          return setState({ isApartment: false, rooms: [[[{ count: 1 }]]] });
        },
        labelStyle: { color: isApartment ? 'grey' : 'black' },
        style: { paddingLeft: '32px' }
      }),
      _react2.default.createElement(_materialUi.RadioButton, {
        checked: (0, _ramda.equals)(isApartment, true),
        label: 'Apartment (Multiple rooms)',
        onCheck: function onCheck() {
          return setState({ isApartment: true, rooms: [[[{ count: 1 }]]] });
        },
        labelStyle: { color: (0, _ramda.equals)(isApartment, false) ? 'grey' : 'black' },
        style: { paddingLeft: '32px' }
      })
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'div',
      { style: { display: rooms ? 'block' : 'none' } },
      _react2.default.createElement(
        'div',
        { style: { minHeight: '100px' } },
        rooms ? rooms.map(function (beddingConfigs, index) {
          return _react2.default.createElement(_singleRoom2.default, {
            key: index,
            forSingleRoom: (0, _ramda.equals)(isApartment, false),
            removeARoom: function removeARoom() {
              return setState({ isApartment: isApartment, rooms: (0, _ramda.remove)(index, 1, rooms) });
            },
            beddingConfigs: beddingConfigs,
            roomName: (0, _ramda.equals)(isApartment, true) ? 'Room ' + (index + 1) : '',
            updateBeddingConfigs: function updateBeddingConfigs(newConfigs) {
              return setState({ isApartment: isApartment, rooms: (0, _ramda.update)(index, newConfigs, rooms) });
            }
          });
        }) : _react2.default.createElement('div', null),
        _react2.default.createElement(
          'div',
          {
            style: {
              display: isApartment ? 'block' : 'none',
              borderBottom: '1px solid #ededed',
              borderTop: '1px solid #ededed',
              backgroundColor: '#fafafa',
              height: '62px',
              lineHeight: '62px',
              textAlign: 'center',
              color: '#21c4d8',
              cursor: 'pointer'
            },
            onClick: function onClick() {
              return setState({ isApartment: isApartment, rooms: (0, _ramda.append)([[{ count: 1 }]], rooms) });
            }
          },
          _react2.default.createElement(
            'div',
            {
              className: 'description-segments-add',
              style: { color: '#00bcd4', cursor: 'pointer', margin: '0 0 16px 32px' }
            },
            _react2.default.createElement(_icon2.default, { className: 'tc-icon-add description-segments-add-icon' }),
            _react2.default.createElement(
              'span',
              { className: 'description-segments-add-label' },
              'Add Another Room for This Apartment'
            )
          )
        )
      )
    )
  );
};

BeddingConfigEdit.propTypes = {
  beddingConfig: _react.PropTypes.object,
  sendEditToReducer: _react.PropTypes.func
};

exports.default = BeddingConfigEdit;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3f93e1f724536e3d921e96d34fab6e84.svg";

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var pdfjs = __webpack_require__(1372);
var PdfjsWorker = __webpack_require__(1531);

if (typeof window !== 'undefined' && 'Worker' in window) {
  pdfjs.PDFJS.workerPort = new PdfjsWorker();
} else {
  pdfjs.PDFJS.disableWorker = true;
}

module.exports = pdfjs;


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
  return new Worker(__webpack_require__.p + "be6e628269aba8fa96b1.worker.js");
};

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0c44371cb0a9aa4de3e8d7a244169b6f.svg";

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b88f14d15c8385788fbc0f22341fbd3d.svg";

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Original source: https://github.com/flyingsparx/s3upload-coffee-javascript/blob/master/s3upload.js
// Modified to match our needs

var _s3Upload = __webpack_require__(564);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {

  s3_sign_put_url: '/proxy/contracting/saveComment/',

  s3uploadAndOrSaveComent: function s3uploadAndOrSaveComent(_ref) {
    var _this = this;

    var contractId = _ref.contractId,
        files = _ref.files,
        historyFeedId = _ref.historyFeedId,
        message = _ref.message;

    return this.executeOnSignedUrl(contractId, files, historyFeedId, message).then(function (res) {
      var fileMap = files.length ? files.reduce(function (map, file) {
        return _extends({}, map, _defineProperty({}, file.name, file));
      }, {}) : [];
      return Promise.all(files.length ? res.files.map(function (_ref2) {
        var fileName = _ref2.fileName,
            signedUrl = _ref2.signedUrl,
            downloadUrl = _ref2.downloadUrl;
        return _this.uploadToS3(fileMap[fileName], signedUrl, downloadUrl, fileName);
      }) : []).then(function (uploadedFiles) {
        return { files: uploadedFiles, comment: res.comment };
      });
    });
  },
  executeOnSignedUrl: function executeOnSignedUrl(contractId, files, historyFeedId, message) {
    return fetch('/proxy/contracting/saveComment/' + historyFeedId, {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        files: files.map(function (_ref3) {
          var type = _ref3.type,
              name = _ref3.name,
              size = _ref3.size;
          return { type: type, name: name, size: size };
        }),
        message: message,
        contractId: contractId
      })
    }).then(function (res) {
      return res.json();
    }).catch(function (err) {
      return console.log(err);
    });
  },
  uploadToS3: function uploadToS3(file, url, publicUrl, fileName) {
    var _this2 = this;

    if (!url) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var xhr = _this2.createCORSRequest('PUT', url);
      xhr.onload = function () {
        if (xhr.status === 200) resolve({ downloadUrl: publicUrl, fileName: fileName });
        return reject('Upload error: ' + xhr.status);
      };
      xhr.onerror = function () {
        reject('XHR error.');
      };
      var contentType = (0, _s3Upload.contentFromFile)(file);
      if (contentType) xhr.setRequestHeader('Content-Type', contentType);
      // xhr.setRequestHeader('x-amz-acl', 'public-read');
      xhr.send(file);
    });
  },
  createCORSRequest: function createCORSRequest(method, url) {
    var xhr = new XMLHttpRequest();
    if (xhr.withCredentials !== null) {
      xhr.open(method, url, true);
    } else if (typeof XDomainRequest !== 'undefined') {
      xhr = new XDomainRequest();
      xhr.open(method, url);
    } else {
      xhr = null;
    }
    return xhr;
  }
};

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "58dd1bf0d5ebb078b6d74c86e24a81b0.png";

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Proxy object to map classnames when css modules are not used

exports.default = {
  container: 'DayPicker',
  interactionDisabled: 'DayPicker--interactionDisabled',
  month: 'DayPicker-Month',
  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  day: 'DayPicker-Day',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'today',
  selected: 'selected',
  disabled: 'disabled',
  outside: 'outside'
};
//# sourceMappingURL=classNames.js.map

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.cancelEvent = cancelEvent;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getDaysInMonth = getDaysInMonth;
exports.getModifiersFromProps = getModifiersFromProps;
exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
exports.isRangeOfDates = isRangeOfDates;
exports.getMonthsDiff = getMonthsDiff;
exports.getWeekArray = getWeekArray;
exports.startOfMonth = startOfMonth;

var _DateUtils = __webpack_require__(1136);

var _LocaleUtils = __webpack_require__(1538);

function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getModifiersFromProps(props) {
  var modifiers = _extends({}, props.modifiers);
  if (props.selectedDays) {
    modifiers[props.classNames.selected] = props.selectedDays;
  }
  if (props.disabledDays) {
    modifiers[props.classNames.disabled] = props.disabledDays;
  }
  return modifiers;
}

function getFirstDayOfWeekFromProps(props) {
  var firstDayOfWeek = props.firstDayOfWeek,
      _props$locale = props.locale,
      locale = _props$locale === undefined ? 'en' : _props$locale,
      _props$localeUtils = props.localeUtils,
      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;

  if (!isNaN(firstDayOfWeek)) {
    return firstDayOfWeek;
  }
  if (localeUtils.getFirstDayOfWeek) {
    return localeUtils.getFirstDayOfWeek(locale);
  }
  return 0;
}

function isRangeOfDates(value) {
  return !!(value && value.from && value.to);
}

function getMonthsDiff(d1, d2) {
  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}

function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _LocaleUtils.getFirstDayOfWeek)();
  var fixedWeeks = arguments[2];

  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];

  var week = [];
  var weekArray = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
  }

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  });

  // unshift days to start the first week
  var firstWeek = weekArray[0];
  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
    outsideDate.setDate(firstWeek[0].getDate() - 1);
    firstWeek.unshift(outsideDate);
  }

  // push days until the end of the last week
  var lastWeek = weekArray[weekArray.length - 1];
  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
    lastWeek.push(_outsideDate);
  }

  // add extra weeks to reach 6 weeks
  if (fixedWeeks && weekArray.length < 6) {
    var lastExtraWeek = void 0;

    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
      lastExtraWeek = weekArray[weekArray.length - 1];
      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
      var extraWeek = [];

      for (var j = 0; j < 7; j += 1) {
        var _outsideDate2 = (0, _DateUtils.clone)(lastDay);
        _outsideDate2.setDate(lastDay.getDate() + j + 1);
        extraWeek.push(_outsideDate2);
      }

      weekArray.push(extraWeek);
    }
  }

  return weekArray;
}

function startOfMonth(d) {
  var newDate = (0, _DateUtils.clone)(d);
  newDate.setDate(1);
  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
  return newDate;
}
//# sourceMappingURL=Helpers.js.map

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function formatDay(day) {
  return day.toDateString();
}

function formatMonthTitle(d) {
  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function formatWeekdayShort(i) {
  return WEEKDAYS_SHORT[i];
}

function formatWeekdayLong(i) {
  return WEEKDAYS_LONG[i];
}

function getFirstDayOfWeek() {
  return 0;
}

function getMonths() {
  return MONTHS;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};
//# sourceMappingURL=LocaleUtils.js.map

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _contractingPeriodsSelection = __webpack_require__(1961);

var _contractingPeriodsSelection2 = _interopRequireDefault(_contractingPeriodsSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractingYear = function ContractingYear(_ref) {
  var _onChange = _ref.onChange,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      label = _ref.label,
      required = _ref.required;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'label',
      null,
      _react2.default.createElement(
        'b',
        null,
        label || 'What dates would you like the rates to be valid for? '
      )
    ),
    _react2.default.createElement(
      'span',
      { style: { color: 'red', display: required ? 'inline-block' : 'none' } },
      '* Required'
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(_contractingPeriodsSelection2.default, {
      onChange: function onChange(period) {
        _onChange('startDate', period.startDate);
        _onChange('endDate', period.endDate);
      },
      startDate: startDate,
      endDate: endDate,
      style: { width: '90%', marginTop: '4px' }
    })
  );
};

ContractingYear.propTypes = {
  onChange: _react.PropTypes.func,
  startDateError: _react.PropTypes.string,
  endDateError: _react.PropTypes.string,
  startDate: _react.PropTypes.string,
  endDate: _react.PropTypes.string
};

exports.default = ContractingYear;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  defaultShowNumOfPartners: _react2.default.PropTypes.number,
  partners: _react2.default.PropTypes.array.isRequired,
  justPartners: _react2.default.PropTypes.bool
};

var EmailToPartners = function (_React$Component) {
  _inherits(EmailToPartners, _React$Component);

  function EmailToPartners() {
    _classCallCheck(this, EmailToPartners);

    var _this = _possibleConstructorReturn(this, (EmailToPartners.__proto__ || Object.getPrototypeOf(EmailToPartners)).call(this));

    _this.state = { showAllPartners: false };
    return _this;
  }

  _createClass(EmailToPartners, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react2.default.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          partners = _props.partners,
          defaultShowNumOfPartners = _props.defaultShowNumOfPartners,
          justPartners = _props.justPartners;

      var showAllPartners = this.state.showAllPartners;
      return _react2.default.createElement(
        'div',
        { style: { display: 'flex', alignItems: 'flex-start', marginBottom: '8px' } },
        !justPartners && _react2.default.createElement(
          'b',
          { style: { marginRight: '8px', fontSize: '20px' } },
          'TO: '
        ),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', flexWrap: 'wrap' } },
          partners.slice(0, showAllPartners ? partners.length : defaultShowNumOfPartners).map(function (partner, i) {
            var displayName = function () {
              var companyName = partner.company_name || partner.companyName;
              if (companyName) return companyName;
              if (partner.email && partner.email !== 'via TourConnect') return partner.email;
              return 'Unknown';
            }();
            return _react2.default.createElement(
              _materialUi.Chip,
              { key: i, style: { margin: '0 2px 2px 0', border: '1px solid #e0e0e0' } },
              partner.profileImageUrl ? _react2.default.createElement(_materialUi.Avatar, { src: partner.profileImageUrl }) : _react2.default.createElement(
                _materialUi.Avatar,
                null,
                _ramda2.default.head(displayName)
              ),
              displayName,
              ' ',
              partner.subText
            );
          }),
          partners.length > defaultShowNumOfPartners ? _react2.default.createElement(
            _materialUi.FlatButton,
            {
              secondary: true,
              hoverColor: 'none',
              style: { fontSize: '12px', marginLeft: '8px' },
              label: showAllPartners ? 'show less' : 'show ' + (partners.length - 5) + '  more',
              labelStyle: { paddingLeft: '3px' },
              labelPosition: 'after',
              onTouchTap: function onTouchTap() {
                return _this2.setState({ showAllPartners: !showAllPartners });
              }
            },
            _react2.default.createElement(_materialUi.FontIcon, { style: { fontSize: '16px', color: '#00BCD4', top: '2px' }, className: showAllPartners ? 'tc-icon-keyboard_arrow_up2' : 'tc-icon-keyboard_arrow_down2' })
          ) : _react2.default.createElement('div', null)
        )
      );
    }
  }]);

  return EmailToPartners;
}(_react2.default.Component);

EmailToPartners.propTypes = propTypes;
exports.default = EmailToPartners;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsHotel = function MapsHotel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z' })
  );
};
MapsHotel = (0, _pure2.default)(MapsHotel);
MapsHotel.displayName = 'MapsHotel';
MapsHotel.muiName = 'SvgIcon';

exports.default = MapsHotel;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.priorities = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _contractingUtils = __webpack_require__(124);

var _flatDropDownMenu = __webpack_require__(494);

var _flatDropDownMenu2 = _interopRequireDefault(_flatDropDownMenu);

var _arrowDropDown = __webpack_require__(559);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _smallButtons = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var priorities = exports.priorities = ['Highest', 'High', 'Medium', 'Low', 'Lowest'];

var UpdateRateConversionPriority = function (_Component) {
  _inherits(UpdateRateConversionPriority, _Component);

  function UpdateRateConversionPriority() {
    _classCallCheck(this, UpdateRateConversionPriority);

    var _this = _possibleConstructorReturn(this, (UpdateRateConversionPriority.__proto__ || Object.getPrototypeOf(UpdateRateConversionPriority)).call(this));

    _this.updateRCPriority = function (newPriority) {
      return function () {
        var _this$props = _this.props,
            contractId = _this$props.contractId,
            updateRCPriority = _this$props.updateRCPriority;

        updateRCPriority({ contractId: contractId, updater: { priority: newPriority } });
      };
    };

    return _this;
  }

  _createClass(UpdateRateConversionPriority, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          priority = _props.priority,
          button = _props.button;

      return _react2.default.createElement(
        _flatDropDownMenu2.default,
        {
          button: button || _react2.default.createElement(
            'div',
            { className: 'flex-center' },
            (0, _contractingUtils.getPriorityIcon)(priority || 'Medium'),
            '\xA0',
            _react2.default.createElement(_smallButtons.JiraFlatButton, {
              labelStyle: { fontSize: '10px' },
              icon: _react2.default.createElement(_arrowDropDown2.default, { style: { fill: 'rgba(0, 0, 0, 0.54)', margin: 0 } }),
              labelPosition: 'before',
              label: priority || 'Medium'
            })
          )
        },
        priorities.map(function (str) {
          return _react2.default.createElement(_materialUi.MenuItem, {
            key: str,
            primaryText: str,
            disabled: str === priority,
            leftIcon: (0, _contractingUtils.getPriorityIcon)(str),
            onClick: _this2.updateRCPriority(str)
          });
        })
      );
    }
  }]);

  return UpdateRateConversionPriority;
}(_react.Component);

UpdateRateConversionPriority.propTypes = {
  updateRCPriority: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  priority: _react.PropTypes.string,
  button: _react.PropTypes.node
};

exports.default = (0, _reactRedux.connect)(null, {
  updateRCPriority: function updateRCPriority(payload) {
    return { type: '[contract-request] UPDATE_RATE_CONVERSION_PRIORITY', payload: payload };
  }
})(UpdateRateConversionPriority);

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _counter = __webpack_require__(1517);

var _counter2 = _interopRequireDefault(_counter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeftNavWidget = function LeftNavWidget(_ref) {
  var data = _ref.data,
      name = _ref.name,
      iconClassName = _ref.iconClassName,
      routeName = _ref.routeName,
      onTouchTap = _ref.onTouchTap,
      filteredState = _ref.filteredState,
      counterStyle = _ref.counterStyle,
      style = _ref.style;

  var classes = (0, _classnames2.default)('nav-link', 'contracting-left-nav-widget-link', {
    'is-active': name === filteredState || routeName === (window.location || {}).pathname
  });
  var iconNode = iconClassName ? _react2.default.createElement(_materialUi.FontIcon, { className: iconClassName, color: 'none' }) : undefined;
  var nameNodeClass = iconClassName ? 'content-with-icon' : 'content-without-icon';
  var counterNode = !isNaN(data) ? _react2.default.createElement(_counter2.default, { style: counterStyle, data: data }) : undefined;
  return _react2.default.createElement(
    'div',
    { className: 'contracting-left-nav-widget' },
    onTouchTap ? _react2.default.createElement(
      'div',
      {
        className: classes,
        onClick: onTouchTap,
        style: style
      },
      iconNode,
      _react2.default.createElement(
        'span',
        { className: nameNodeClass },
        name
      ),
      counterNode
    ) : _react2.default.createElement(
      'div',
      { className: 'contracting-left-nav-title' },
      name
    )
  );
};
LeftNavWidget.propTypes = {
  routeName: _react2.default.PropTypes.string,
  name: _react2.default.PropTypes.any,
  iconClassName: _react2.default.PropTypes.string,
  data: _react2.default.PropTypes.number,
  onTouchTap: _react2.default.PropTypes.func,
  filteredState: _react2.default.PropTypes.string,
  counterStyle: _react2.default.PropTypes.object
};
exports.default = LeftNavWidget;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(1545);

var defaultMessage = 'Copy to clipboard: #{key}, Enter';

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug, message, reselectPrevious, range, selection, mark, success = false;
  if (!options) { options = {}; }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement('span');
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = 'unset';
    // prevents scrolling to the end of the page
    mark.style.position = 'fixed';
    mark.style.top = 0;
    mark.style.clip = 'rect(0, 0, 0, 0)';
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = 'pre';
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = 'text';
    mark.style.MozUserSelect = 'text';
    mark.style.msUserSelect = 'text';
    mark.style.userSelect = 'text';

    document.body.appendChild(mark);

    range.selectNode(mark);
    selection.addRange(range);

    var successful = document.execCommand('copy');
    if (!successful) {
      throw new Error('copy command was unsuccessful');
    }
    success = true;
  } catch (err) {
    debug && console.error('unable to copy using execCommand: ', err);
    debug && console.warn('trying IE specific stuff');
    try {
      window.clipboardData.setData('text', text);
      success = true;
    } catch (err) {
      debug && console.error('unable to copy using clipboardData: ', err);
      debug && console.error('falling back to prompt');
      message = format('message' in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == 'function') {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),
/* 1545 */
/***/ (function(module, exports) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _send = __webpack_require__(577);

var _send2 = _interopRequireDefault(_send);

var _constants = __webpack_require__(252);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportTourWriter = function (_Component) {
  _inherits(ExportTourWriter, _Component);

  function ExportTourWriter() {
    _classCallCheck(this, ExportTourWriter);

    return _possibleConstructorReturn(this, (ExportTourWriter.__proto__ || Object.getPrototypeOf(ExportTourWriter)).apply(this, arguments));
  }

  _createClass(ExportTourWriter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          contractId = _props.contractId,
          tourWriter = _props.tourWriter,
          sendTourWriter = _props.sendTourWriter,
          blackout = _props.blackout;

      if (!tourWriter) return _react2.default.createElement('div', null);
      var caption = blackout ? 'Tourwriter Export (Excludes Blackouts)' : 'Tourwriter Export';
      return _react2.default.createElement(_materialUi.MenuItem, {
        style: { fontSize: '15px', minHeight: '32px', lineHeight: '32px' },
        innerDivStyle: { padding: '0px 24px 0px 64px' },
        leftIcon: _react2.default.createElement(_send2.default, {
          color: 'rgba(0, 0, 0, 0.84)',
          style: {
            top: '4px',
            margin: '0',
            left: '24px',
            fill: 'rgb(117, 117, 117)'
          }
        }),
        primaryText: caption,
        onTouchTap: function onTouchTap() {
          sendTourWriter({ contractId: contractId, blackout: blackout });
        }
      });
    }
  }]);

  return ExportTourWriter;
}(_react.Component);

ExportTourWriter.defaultProps = {
  contractId: undefined,
  tourWriter: false,
  sendTourWriter: function sendTourWriter() {},
  blackout: false
};

ExportTourWriter.propTypes = {
  contractId: _propTypes2.default.string,
  tourWriter: _propTypes2.default.bool,
  sendTourWriter: _propTypes2.default.func,
  blackout: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user;
  return {
    tourWriter: user.getIn(['company', 'tourWriter'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  sendTourWriter: function sendTourWriter(payload) {
    return { type: _constants.SEND_TOURWRITER, payload: payload };
  }
})(ExportTourWriter);

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Watermark = function Watermark(_ref) {
  var texts = _ref.texts;

  var basicTextStyle = {
    color: 'rgba(211, 211, 211, 0.45)',
    fontSize: '100px',
    lineHeight: '100px',
    transform: 'rotate(30deg)',
    'WebkitTransform': 'rotate(30deg)',
    marginBottom: '250px'
  };
  return _react2.default.createElement(
    'div',
    { style: {
        position: 'absolute',
        zIndex: '2',
        background: 'none',
        display: 'block',
        minHeight: '50%',
        minWidth: '40%'
      }
    },
    texts.map(function (text, i) {
      if (i > 0) return _react2.default.createElement(
        'p',
        { style: _ramda2.default.merge(basicTextStyle, { marginLeft: 40 + 60 * i + 'px' }), key: i },
        text
      );
      return _react2.default.createElement(
        'p',
        { style: _ramda2.default.merge(basicTextStyle, { marginTop: '160px' }), key: i },
        text
      );
    })
  );
};

exports.default = Watermark;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _helpOutline = __webpack_require__(1117);

var _helpOutline2 = _interopRequireDefault(_helpOutline);

var _reactRedux = __webpack_require__(6);

var _dialogConstants = __webpack_require__(616);

var _actions = __webpack_require__(737);

var _ratesWizardActions = __webpack_require__(1549);

var _addMoreRates = __webpack_require__(3276);

var _addMoreRates2 = _interopRequireDefault(_addMoreRates);

var _addProducts = __webpack_require__(3297);

var _addProducts2 = _interopRequireDefault(_addProducts);

var _createRatePackages = __webpack_require__(3298);

var _createRatePackages2 = _interopRequireDefault(_createRatePackages);

var _billingInfo = __webpack_require__(1975);

var _billingInfo2 = _interopRequireDefault(_billingInfo);

var _allocation = __webpack_require__(3301);

var _allocation2 = _interopRequireDefault(_allocation);

var _dialogContainer = __webpack_require__(3304);

var _dialogContainer2 = _interopRequireDefault(_dialogContainer);

var _editRatesContainer = __webpack_require__(3308);

var _editRatesContainer2 = _interopRequireDefault(_editRatesContainer);

var _editCheckinCheckout = __webpack_require__(1977);

var _editCheckinCheckout2 = _interopRequireDefault(_editCheckinCheckout);

var _extraPolicyDivs = __webpack_require__(1978);

var _extraPolicyDivs2 = _interopRequireDefault(_extraPolicyDivs);

var _cancellationPolicies = __webpack_require__(1980);

var _cancellationPolicies2 = _interopRequireDefault(_cancellationPolicies);

var _addProductPolicy = __webpack_require__(3313);

var _addProductPolicy2 = _interopRequireDefault(_addProductPolicy);

var _blackouts = __webpack_require__(3314);

var _blackouts2 = _interopRequireDefault(_blackouts);

var _termsCriteria = __webpack_require__(1981);

var _termsCriteria2 = _interopRequireDefault(_termsCriteria);

var _pickupDropoff = __webpack_require__(3315);

var _pickupDropoff2 = _interopRequireDefault(_pickupDropoff);

var _importFromTemplate = __webpack_require__(3317);

var _importFromTemplate2 = _interopRequireDefault(_importFromTemplate);

var _copyDataFromAnotherProduct2 = __webpack_require__(3322);

var _copyDataFromAnotherProduct3 = _interopRequireDefault(_copyDataFromAnotherProduct2);

var _omniImport = __webpack_require__(3323);

var _omniImport2 = _interopRequireDefault(_omniImport);

var _manageExtrasOffers2 = __webpack_require__(3324);

var _manageExtrasOffers3 = _interopRequireDefault(_manageExtrasOffers2);

var _updateProductName = __webpack_require__(3338);

var _updateProductName2 = _interopRequireDefault(_updateProductName);

var _updateBeddingConfig = __webpack_require__(3339);

var _updateBeddingConfig2 = _interopRequireDefault(_updateBeddingConfig);

var _updateContractingPeriod = __webpack_require__(3340);

var _updateContractingPeriod2 = _interopRequireDefault(_updateContractingPeriod);

var _updateLocationName = __webpack_require__(3341);

var _updateLocationName2 = _interopRequireDefault(_updateLocationName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  addEditContractDialog: _react.PropTypes.object,
  onRequestClose: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  productId: _react.PropTypes.string,
  type: _react.PropTypes.string,
  takenDateRanges: _react.PropTypes.array,
  saveProductInfoChangesDispatched: _react.PropTypes.func,
  saveSupplierInfoChangesDispatched: _react.PropTypes.func,
  importContractFromTemplateDispatched: _react.PropTypes.func,
  reloadContent: _react.PropTypes.func,
  openGlobalAlert: _react.PropTypes.func,
  rightSideContent: _react.PropTypes.object,
  productsArray: _react.PropTypes.array,
  existingSeasons: _react.PropTypes.array,
  allContractingReadyProducts: _react.PropTypes.array,
  locationName: _react.PropTypes.string,
  contractState: _react.PropTypes.string,
  productsMap: _react.PropTypes.object,
  contractingPeriod: _react.PropTypes.object,
  specialOffersStepper: _react.PropTypes.number,
  addExtraStepper: _react.PropTypes.number,
  RatesFormAndTable: _react.PropTypes.object
};

var AddEditDialog = function (_Component) {
  _inherits(AddEditDialog, _Component);

  function AddEditDialog() {
    _classCallCheck(this, AddEditDialog);

    return _possibleConstructorReturn(this, (AddEditDialog.__proto__ || Object.getPrototypeOf(AddEditDialog)).apply(this, arguments));
  }

  _createClass(AddEditDialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          addEditContractDialog = _props.addEditContractDialog,
          saveProductInfoChangesDispatched = _props.saveProductInfoChangesDispatched,
          saveSupplierInfoChangesDispatched = _props.saveSupplierInfoChangesDispatched,
          importContractFromTemplateDispatched = _props.importContractFromTemplateDispatched,
          reloadContent = _props.reloadContent,
          openGlobalAlert = _props.openGlobalAlert,
          extraProps = _objectWithoutProperties(_props, ['addEditContractDialog', 'saveProductInfoChangesDispatched', 'saveSupplierInfoChangesDispatched', 'importContractFromTemplateDispatched', 'reloadContent', 'openGlobalAlert']);

      var open = addEditContractDialog.open,
          note = addEditContractDialog.note,
          type = addEditContractDialog.type,
          data = addEditContractDialog.data,
          saving = addEditContractDialog.saving,
          example = addEditContractDialog.example,
          offersOrExtras = addEditContractDialog.offersOrExtras;

      var ContentNode = function () {
        switch (type) {
          case 'addRates':
            return _addMoreRates2.default;
          case 'addProducts':
            return _addProducts2.default;
          case 'manageRatePackage':
            return _createRatePackages2.default;
          case 'billingInfo':
            return _billingInfo2.default;
          case 'allocation':
            return _allocation2.default;
          case 'checkInOut':
            return _editCheckinCheckout2.default;
          case 'policy':
            return _extraPolicyDivs2.default;
          case 'addProductPolicy':
          case 'editProductPolicy':
            return _addProductPolicy2.default;
          case 'seasonalCancelPolicies':
            return _cancellationPolicies2.default;
          case 'blackouts':
            return _blackouts2.default;
          case 'corporateIdentificationNumber':
          case 'termsAndConditions':
          case 'submissionCriteria':
          case 'marketInfo':
            return _termsCriteria2.default;
          case 'pickupDropoff':
            return _pickupDropoff2.default;
          case 'importFromTemplate':
            return _importFromTemplate2.default;
          case 'copyDataFromAnotherProduct':
            return _copyDataFromAnotherProduct3.default;
          case 'manageExtrasOffers':
            return _manageExtrasOffers3.default;
          case 'updateProductName':
            return _updateProductName2.default;
          case 'updateBeddingConfig':
            return _updateBeddingConfig2.default;
          case 'UpdateContractPeriod':
            return _updateContractingPeriod2.default;
          case 'UpdateLocationName':
            return _updateLocationName2.default;
          default:
            return 'div';
        }
      }();
      var px600 = {
        addProducts: 'addProducts',
        manageRatePackage: true
      };
      var px700 = {
        importFromTemplate: 'importFromTemplate',
        updateBeddingConfig: true
      };
      var px550 = {
        blackouts: 'blackouts',
        billingInfo: 'billingInfo',
        policy: data.policyType !== 'cancellation',
        addProductPolicy: 'addProductPolicy',
        editProductPolicy: 'editProductPolicy'
      };
      var percent80 = {
        manageExtrasOffers: 'manageExtrasOffers',
        pickupDropoff: 'pickupDropoff',
        submissionCriteria: 'submissionCriteria',
        termsAndConditions: 'termsConditions'
      };
      var percent45 = {
        checkInOut: 'checkInOut',
        copyDataFromAnotherProduct: 'copyDataFromAnotherProduct'
      };
      var percent30 = {
        addRateSet: 'addRateSet',
        allocation: 'allocation',
        seasonalCancelPolicies: true,
        policy: data.policyType === 'cancellation'
      };

      var width = function () {
        if (px600[type]) return '600px';
        if (px700[type]) return '700px';
        if (px550[type]) return '550px';
        if (percent80[type]) return '80%';
        if (percent45[type]) return '45%';
        if (!percent30[type]) return '30%';
        return '100%';
      }();
      var importTemplate = function importTemplate(_ref) {
        var templateId = _ref.templateId,
            contractId = _ref.contractId,
            fieldsToImport = _ref.fieldsToImport;

        var onOk = function onOk() {
          return importContractFromTemplateDispatched({ templateId: templateId, contractId: contractId, fieldsToImport: fieldsToImport });
        };
        if (data.forNewDraft) {
          onOk();
        } else {
          openGlobalAlert({
            text: 'This action will overwrite the data you currently have, do you want to proceed?',
            onOk: onOk
          });
        }
      };
      var propsForContent = _extends({
        data: data,
        saving: saving,
        note: note,
        example: example,
        offersOrExtras: offersOrExtras,
        importTemplate: importTemplate,
        saveProductInfoChanges: saveProductInfoChangesDispatched,
        saveSupplierInfoChanges: function saveSupplierInfoChanges(payload) {
          return saveSupplierInfoChangesDispatched(payload);
        },
        openGlobalAlert: openGlobalAlert
      }, extraProps);
      if (type === 'editSeason') return _react2.default.createElement(_dialogContainer2.default, propsForContent);
      if (type === 'editRates') return _react2.default.createElement(_editRatesContainer2.default, propsForContent);
      if (type === 'omniImport') return _react2.default.createElement(_omniImport2.default, propsForContent);
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          autoScrollBodyContent: true,
          bodyStyle: { padding: '0', paddingBottom: '12px' },
          contentStyle: function () {
            if (type === 'manageExtrasOffers') return { maxWidth: '1500px', width: '100%' };
            if (type === 'addRates') return { maxWidth: '1000px', width: '100%' };
            return { maxWidth: '880px', width: width };
          }(),
          open: open,
          title: data.title ? _react2.default.createElement(
            'div',
            {
              className: 'flex-tc-sb',
              style: { backgroundColor: '#00BCD4', color: 'white', fontSize: '18px', padding: '16px 2%' }
            },
            data.title,
            extraProps.productId && window.location.pathname.indexOf('product') > -1 ? ' - ' + extraProps.productName + ' ' + (extraProps.ratePackageName ? '(' + extraProps.ratePackageName + ')' : '') : '',
            type === 'allocation' ? _react2.default.createElement(
              'a',
              {
                style: { height: '30px' },
                href: 'http://support.tourconnect.com/en/articles/1140869-what-is-an-allocation-type-what-does-freesale-or-on-request-mean',
                target: '__blank'
              },
              _react2.default.createElement(_helpOutline2.default, { color: '#fff', style: { height: '30px', width: '30px' } })
            ) : _react2.default.createElement('span', null)
          ) : undefined
        },
        _react2.default.createElement(ContentNode, propsForContent)
      );
    }
  }]);

  return AddEditDialog;
}(_react.Component);

AddEditDialog.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
  var contracting = _ref2.contracting;
  var reducerName = _ref3.reducerName;

  var leftNav = contracting[reducerName].get('leftNav').toJS();
  var rightSideContent = contracting[reducerName].get('rightSideContent').toJS();
  var seasons = rightSideContent.seasons,
      seasonRates = rightSideContent.seasonRates;

  return {
    rightSideContent: rightSideContent,
    productId: rightSideContent.productId,
    ratePackageIndex: rightSideContent.ratePackageIndex,
    ratePackageName: rightSideContent.ratePackageName,
    productName: rightSideContent.productName,
    productsArray: leftNav.productsArray,
    existingSeasons: (seasonRates || []).length > (seasons || []).length ? seasonRates : seasons || [],
    allContractingReadyProducts: leftNav.allContractingReadyProducts || [],
    productType: rightSideContent.productType,
    contractId: leftNav.contractId,
    locationId: leftNav.locationId,
    locationName: leftNav.locationName,
    contractState: leftNav.contractState,
    productsMap: (leftNav.productsArray || []).reduce(function (result, product) {
      result[product.productId] = product.productName;
      return result;
    }, {}),
    contractingPeriod: { startDate: new Date(leftNav.startDate), endDate: new Date(leftNav.endDate) },
    specialOffersStepper: contracting.steppers.get('specialOffersStepper'),
    addExtraStepper: contracting.steppers.get('addExtraStepper'),
    addEditContractDialog: contracting.addEditContractDialog.toJS(),
    RatesFormAndTable: _extends({}, contracting.addRateSetWizard.toJS())
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    goToStep: function goToStep(payload) {
      return dispatch({ type: 'CHANGE_STEPPER_WIZARD_STEP', payload: payload });
    },
    onRequestClose: function onRequestClose() {
      return dispatch({ type: 'CLOSE_ADD_EDIT_CONTRACT_DIALOG' });
    },
    onTextFieldChange: function onTextFieldChange(payload) {
      return dispatch({ type: 'ON_CHANGE_TEXTFIELD_IN_ADD_EDIT_DIALOG', payload: payload });
    },
    onTextFieldChangeWithKeyPath: function onTextFieldChangeWithKeyPath(payload) {
      return dispatch({ type: 'ON_CHANGE_TEXTFIELD_WITH_KEYPATH_IN_ADD_EDIT_DIALOG', payload: payload });
    },
    addOneElementWithKeyPath: function addOneElementWithKeyPath(payload) {
      return dispatch({ type: 'ADD_ONE_ELEMENT_WITH_KEYPATH_ADD_EDIT_DIALOG', payload: payload });
    },
    deleteOneElementWithKeyPath: function deleteOneElementWithKeyPath(payload) {
      return dispatch({ type: 'DELETE_ONE_ELEMENT_WITH_KEYPATH_ADD_EDIT_DIALOG', payload: payload });
    },
    updateDaysOfWeek: function updateDaysOfWeek(payload) {
      return dispatch({ type: 'UPDATE_DAYS_OF_WEEK_ADD_EDIT', payload: payload });
    },
    updateTableCell: function updateTableCell(payload) {
      return dispatch({ type: 'UPDATE_TABLE_CELL_ADD_EDIT', payload: payload });
    },
    attachInsFile: function attachInsFile(payload) {
      return dispatch({ type: 'ADD_INSURANCE_FILE', payload: payload });
    },
    removeInsFile: function removeInsFile(payload) {
      return dispatch((0, _dialogConstants.deleteInsFile)(payload));
    },

    saveProductsToContract: function saveProductsToContract() {
      return dispatch(_dialogConstants.saveProductsToContract.apply(undefined, arguments));
    },
    manageRatePackage: function manageRatePackage() {
      return dispatch(_dialogConstants.manageRatePackage.apply(undefined, arguments));
    },
    saveSupplierInfoChangesDispatched: function saveSupplierInfoChangesDispatched() {
      return dispatch(_dialogConstants.saveSupplierInfoChanges.apply(undefined, arguments));
    },
    saveBillingInfoChanges: function saveBillingInfoChanges() {
      return dispatch(_dialogConstants.saveBillingInfoChanges.apply(undefined, arguments));
    },
    importContractFromTemplateDispatched: function importContractFromTemplateDispatched() {
      return dispatch(_dialogConstants.importContractFromTemplate.apply(undefined, arguments));
    },
    saveProductInfoChangesDispatched: function saveProductInfoChangesDispatched() {
      return dispatch(_dialogConstants.saveProductInfoChanges.apply(undefined, arguments));
    },
    addOneMoreBlackout: function addOneMoreBlackout(payload) {
      return dispatch({ type: 'ADD_ONE_MORE_BLACKOUT', payload: payload });
    },
    deleteBlackoutDay: function deleteBlackoutDay(payload) {
      return dispatch({ type: 'DELETE_ONE_BLACKOUT_DAY', payload: payload });
    },

    deleteOneAllotment: function deleteOneAllotment(payload) {
      return dispatch({ type: 'DELETE_ONE_ALLOTMENT', payload: payload });
    },
    addOneMoreAllotment: function addOneMoreAllotment(payload) {
      return dispatch({ type: 'ADD_ONE_MORE_ALLOTMENT', payload: payload });
    },

    updateFormData: function updateFormData() {
      return dispatch(_ratesWizardActions.updateFormData.apply(undefined, arguments));
    },

    updateBuyerInfo: function updateBuyerInfo(payload) {
      return dispatch((0, _dialogConstants.updateBuyerInfo)(payload));
    },

    updateFieldForOfferRates: function updateFieldForOfferRates(payload) {
      return dispatch({ type: 'UPDATE_ADD_RATES_FIELD', payload: payload });
    },
    updateFieldWithKeyPathForOfferRates: function updateFieldWithKeyPathForOfferRates(payload) {
      return dispatch({ type: 'UPDATE_ADD_RATES_FIELD_WITH_KEYPATH', payload: payload });
    },
    updateCellValueForOfferRates: function updateCellValueForOfferRates(payload) {
      return dispatch({ type: 'UPDATE_ADD_RATES_RATES_TABLE_CELL_VALUE', payload: payload });
    },
    calculateAccomRatesTable: function calculateAccomRatesTable() {
      return dispatch({ type: 'CALCULATE_RATES_TABLE' });
    },
    calculateStandardNonAccomRatesTable: function calculateStandardNonAccomRatesTable() {
      return dispatch({ type: 'CALCULATE_STANDARD_NON_ACCOM_RATES_TABLE' });
    },
    copyDataFromAnotherProduct: function copyDataFromAnotherProduct(payload) {
      return dispatch((0, _dialogConstants.copyDataFromAnotherProduct)(payload));
    },
    manageExtrasOffers: function manageExtrasOffers() {
      return dispatch(_actions.manageExtrasOffers.apply(undefined, arguments));
    },
    clearAddRateSetWizard: function clearAddRateSetWizard() {
      return dispatch({ type: 'CLEAR_ADD_RATE_SET_WIZARD' });
    },
    editProductProfile: function editProductProfile(payload) {
      return dispatch({ type: '{draft}EDIT_PRODUCT_PROFILE_INFO', payload: payload });
    },
    openGlobalAlert: function openGlobalAlert(payload) {
      return dispatch({
        type: 'open_global_alert',
        payload: payload
      });
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddEditDialog);

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateFormData = undefined;

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var updateFormData = exports.updateFormData = function updateFormData(payload, actionType, collection) {
  return function (dispatch, getState) {
    var productId = getState().contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productId']);
    var locationId = getState().contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId']);
    if (actionType === 'ON_CHANGE_TEXTFIELD_IN_ADD_EDIT_DIALOG') dispatch({ type: actionType, payload: { keyPath: payload.keyPath, value: payload.value } });else dispatch({ type: actionType, payload: payload });
    var composedUrl = '/proxy/contracting/formData/' + collection;
    return fetch(composedUrl, {
      method: 'put',
      credentials: 'same-origin',
      body: JSON.stringify(_ramda2.default.merge(payload, { locationId: locationId, productId: productId })),
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(_checkStatus2.default).then(function () {
      return dispatch({ type: 'UPDATE_FORM_DATA_SUCCESS', payload: _defineProperty({}, payload.fieldName, payload.value) });
    }).catch(function (err) {
      return console.log(err);
    });
  };
};

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isStayPaysNotEmpty = function isStayPaysNotEmpty(stayPays) {
  return _ramda2.default.any(function (stayPay) {
    return stayPay && stayPay.stayDays && stayPay.payDays;
  }, stayPays);
};
var StayPay = function StayPay(_ref) {
  var defaultYes = _ref.defaultYes,
      staypayApplicable = _ref.staypayApplicable,
      stayPays = _ref.stayPays,
      stayPayError = _ref.stayPayError,
      updateFieldValue = _ref.updateFieldValue;

  return _react2.default.createElement(
    'div',
    { style: { marginTop: '8px' } },
    _react2.default.createElement(
      'div',
      { style: { display: defaultYes ? 'none' : 'block' } },
      _react2.default.createElement(
        'label',
        { style: { width: '50%' } },
        'Would you like to add a stay pay?'
      ),
      _react2.default.createElement(
        _materialUi.RadioButtonGroup,
        {
          name: 'staypay',
          valueSelected: staypayApplicable === 'yes' || isStayPaysNotEmpty(stayPays) ? 'yes' : 'no',
          style: { display: 'inline-block', marginLeft: '12px', top: '10px', position: 'relative' },
          onChange: function onChange(_, value) {
            updateFieldValue('staypayApplicable', value);
            if (value === 'no') updateFieldValue('stayPays', [{}]);
          }
        },
        _react2.default.createElement(_materialUi.RadioButton, { label: 'Yes', value: 'yes', style: { display: 'inline-block', width: '80px' } }),
        _react2.default.createElement(_materialUi.RadioButton, { label: 'No', value: 'no', style: { display: 'inline-block', width: '50px' } })
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { color: 'red', marginLeft: '2px', fontSize: '12px', verticalAlign: 'bottom' } },
      stayPayError
    ),
    staypayApplicable === 'yes' || isStayPaysNotEmpty(stayPays) ? stayPays.map(function (stayPay, stayPayIndex) {
      return _react2.default.createElement(
        'div',
        { key: stayPayIndex },
        _react2.default.createElement(_typeControlledTextfield2.default, {
          controlledType: 'number',
          style: { display: 'inline-block', width: '18%', zIndex: '0' },
          hintStyle: { fontSize: '12px' },
          inputStyle: { fontSize: '14px' },
          floatingLabelShrinkStyle: { color: 'rgba(0, 0, 0, 0.64)' },
          floatingLabelText: '# of Stay Days',
          hintText: '# of Stay Days',
          value: stayPay.stayDays || '',
          onChange: function onChange(_ref2) {
            var value = _ref2.target.value;
            return updateFieldValue('stayPays', _ramda2.default.update(stayPayIndex, _ramda2.default.merge(stayPay, { stayDays: value }), stayPays));
          }
        }),
        _react2.default.createElement(
          'span',
          { style: { color: 'red', marginLeft: '2px', fontSize: '24px', verticalAlign: 'bottom', width: '13px', display: 'inline-block' } },
          stayPay.stayDays ? '' : ' *'
        ),
        _react2.default.createElement(_typeControlledTextfield2.default, {
          controlledType: 'number',
          style: { display: 'inline-block', width: '18%', marginLeft: '3%', zIndex: '0' },
          hintStyle: { fontSize: '12px' },
          inputStyle: { fontSize: '14px' },
          floatingLabelShrinkStyle: { color: 'rgba(0, 0, 0, 0.64)' },
          floatingLabelText: '# of Pay Days',
          hintText: '# of Pay Days',
          value: stayPay.payDays || '',
          onChange: function onChange(_ref3) {
            var value = _ref3.target.value;
            return updateFieldValue('stayPays', _ramda2.default.update(stayPayIndex, _ramda2.default.merge(stayPay, { payDays: value }), stayPays));
          }
        }),
        _react2.default.createElement(
          'span',
          { style: { color: 'red', marginLeft: '2px', fontSize: '24px', verticalAlign: 'bottom', width: '13px', display: 'inline-block' } },
          stayPay.payDays ? '' : ' *'
        ),
        _react2.default.createElement(_typeControlledTextfield2.default, {
          controlledType: 'number',
          style: { display: 'inline-block', width: '25%', minWidth: '200px', marginLeft: '3%', zIndex: '0' },
          hintStyle: { fontSize: '12px' },
          inputStyle: { fontSize: '14px' },
          floatingLabelShrinkStyle: { color: 'rgba(0, 0, 0, 0.64)' },
          floatingLabelText: 'Maximum FOC Nights',
          hintText: 'Maximum FOC Nights',
          value: stayPay.maxFOC || '',
          onChange: function onChange(_ref4) {
            var value = _ref4.target.value;
            return updateFieldValue('stayPays', _ramda2.default.update(stayPayIndex, _ramda2.default.merge(stayPay, { maxFOC: value }), stayPays));
          }
        }),
        _react2.default.createElement(
          'span',
          { style: { color: 'red', marginLeft: '2px', fontSize: '24px', verticalAlign: 'bottom', width: '13px', display: 'inline-block' } },
          stayPay.maxFOC ? '' : ' *'
        ),
        _react2.default.createElement(_icon2.default, {
          className: 'tc-icon-close',
          style: {
            color: stayPays.length === 1 ? 'grey' : '#ff4081',
            cursor: stayPays.length === 1 ? 'normal' : 'pointer',
            marginLeft: '2%',
            top: '5px'
          },
          onClick: stayPays.length === 1 ? undefined : function () {
            return updateFieldValue('stayPays', _ramda2.default.remove(stayPayIndex, 1, stayPays));
          }
        }),
        _react2.default.createElement(_icon2.default, {
          className: 'tc-icon-add',
          style: {
            border: '2px solid green',
            borderRadius: '50%',
            cursor: 'pointer',
            marginLeft: '2%',
            top: '5px'
          },
          onClick: function onClick() {
            return updateFieldValue('stayPays', _ramda2.default.insert(stayPayIndex + 1, { stayDays: null, payDays: null }, stayPays));
          }
        })
      );
    }) : _react2.default.createElement('div', null)
  );
};

exports.default = StayPay;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DaysOfWeek = function DaysOfWeek(_ref) {
  var daysOfWeek = _ref.daysOfWeek,
      updateDaysOfWeek = _ref.updateDaysOfWeek;

  return _react2.default.createElement(
    'div',
    { style: { width: '350px', display: 'inline-block', zIndex: '0' } },
    _react2.default.createElement(
      'div',
      { style: { float: 'left', width: '170px', zIndex: '0' } },
      ['All', 'Monday', 'Tuesday', 'Wednesday'].map(function (day, index) {
        var dayIndexInReducer = _ramda2.default.findIndex(_ramda2.default.equals(day), daysOfWeek);
        var checked = _ramda2.default.propEq('length', 7, daysOfWeek) || dayIndexInReducer > -1;
        return _react2.default.createElement(_materialUi.Checkbox, {
          checked: checked,
          onCheck: function onCheck() {
            return updateDaysOfWeek(!checked, day, dayIndexInReducer);
          },
          label: day,
          key: index,
          labelStyle: { color: 'rgba(0, 0, 0, 0.54)' }
        });
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { float: 'left', width: '170px' } },
      ['Thursday', 'Friday', 'Saturday', 'Sunday'].map(function (day, index) {
        var dayIndexInReducer = _ramda2.default.findIndex(_ramda2.default.equals(day), daysOfWeek);
        var checked = _ramda2.default.propEq('length', 7, daysOfWeek) || dayIndexInReducer > -1;
        return _react2.default.createElement(_materialUi.Checkbox, {
          checked: checked,
          onCheck: function onCheck() {
            return updateDaysOfWeek(!checked, day, dayIndexInReducer);
          },
          label: day,
          key: index,
          labelStyle: { color: 'rgba(0, 0, 0, 0.54)' }
        });
      })
    )
  );
};

exports.default = DaysOfWeek;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _RateType = __webpack_require__(1257);

var _RateType2 = _interopRequireDefault(_RateType);

var _selectFields = __webpack_require__(141);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Rates = function Rates(_ref) {
  var showTaxCurrency = _ref.showTaxCurrency,
      updateFieldValue = _ref.updateFieldValue,
      updateFormData = _ref.updateFormData,
      locationId = _ref.locationId,
      productId = _ref.productId,
      fieldValues = _objectWithoutProperties(_ref, ['showTaxCurrency', 'updateFieldValue', 'updateFormData', 'locationId', 'productId']);

  var taxInclusion = fieldValues.taxInclusion,
      rateType = fieldValues.rateType,
      commissionPercentage = fieldValues.commissionPercentage,
      baseRate = fieldValues.baseRate,
      retailRate = fieldValues.retailRate,
      taxType = fieldValues.taxType,
      currency = fieldValues.currency,
      additionalChild = fieldValues.additionalChild,
      additionalChildRetail = fieldValues.additionalChildRetail,
      additionalAdult = fieldValues.additionalAdult,
      additionalAdultRetail = fieldValues.additionalAdultRetail,
      includedGuestsinBaseRate = fieldValues.includedGuestsinBaseRate,
      includedGuestsError = fieldValues.includedGuestsError,
      maxAdultsChildren = fieldValues.maxAdultsChildren,
      maxAdults = fieldValues.maxAdults,
      maxGuestsError = fieldValues.maxGuestsError,
      maxAdultsError = fieldValues.maxAdultsError;

  var fontFamily = "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif";
  var leftColumnStyle = { width: '40%', textAlign: 'left', fontSize: '15px', fontFamily: fontFamily };
  var rightColumnStyle = { width: '60%', textAlign: 'left', paddingRight: '6%', fontFamily: fontFamily };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { marginBottom: '0' },
      leftColumnStyle: leftColumnStyle,
      rightColumnStyle: rightColumnStyle,
      leftColumnContent: _react2.default.createElement(
        'div',
        null,
        'Rate type',
        _react2.default.createElement(
          'div',
          { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
          '* Required'
        )
      ),
      rightColumnContent: _react2.default.createElement(_RateType2.default, {
        rateType: rateType,
        commissionPercentage: commissionPercentage,
        nettCommission: fieldValues.nettCommission,
        updateRateType: function updateRateType(value) {
          return updateFormData({ fieldName: 'rateType', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location', locationId, productId);
        },
        updateCommission: function updateCommission(value) {
          return updateFormData({ fieldName: 'commissionPercentage', value: value }, 'UPDATE_ADD_RATES_FIELD', 'location', locationId, productId);
        },
        updateNettCommission: function updateNettCommission(value) {
          return updateFormData({ fieldName: 'nettCommission', value: value }, 'UPDATE_ADD_RATES_FIELD', 'location', locationId, productId);
        }
      })
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      hide: !showTaxCurrency,
      leftColumnStyle: leftColumnStyle,
      rightColumnStyle: rightColumnStyle,
      outerContainerStyle: { marginBottom: '', overflow: '' },
      leftColumnContent: _react2.default.createElement(
        'div',
        null,
        'Tax information',
        _react2.default.createElement(
          'div',
          { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
          '* Required'
        )
      ),
      rightColumnContent: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { width: '40%', display: 'inline-block' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'taxInclusion',
            options: [{ value: 'inclusive', label: 'Tax inclusive' }, { value: 'exclusive', label: 'Tax exclusive' }, { value: 'exempt', label: 'Tax exempt' }],
            value: taxInclusion,
            onChange: function onChange(_ref2) {
              var value = _ref2.value;
              return updateFormData({ fieldName: 'taxInclusion', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location');
            },
            placeholder: 'Tax Inclusion',
            clearable: false,
            scrollMenuIntoView: false
          })
        ),
        taxInclusion !== 'exempt' ? _react2.default.createElement(
          'div',
          { style: { width: '50%', marginLeft: '5%', display: 'inline-block' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'taxType',
            options: _selectFields.taxTypes,
            value: taxType,
            onChange: function onChange(_ref3) {
              var value = _ref3.value;
              return updateFormData({ fieldName: 'taxType', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location');
            },
            placeholder: 'Tax Type',
            clearable: false,
            scrollMenuIntoView: false
          })
        ) : undefined
      )
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      hide: !showTaxCurrency,
      leftColumnStyle: leftColumnStyle,
      rightColumnStyle: rightColumnStyle,
      outerContainerStyle: { overflow: 'inherit', clear: 'both', height: '42px', marginBottom: '0' },
      leftColumnContent: _react2.default.createElement(
        'div',
        { style: { marginTop: '12px' } },
        'Currency',
        _react2.default.createElement(
          'div',
          { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
          '* Required'
        )
      ),
      rightColumnContent: _react2.default.createElement(
        'div',
        { style: { width: '135px', position: 'relative', top: '10px', display: 'inline-block' } },
        _react2.default.createElement(_reactSelect2.default, {
          name: 'currency',
          options: _selectFields.currencies,
          value: currency,
          onChange: function onChange(_ref4) {
            var value = _ref4.value;
            return updateFormData({ fieldName: 'currency', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location');
          },
          placeholder: 'Currency',
          clearable: false,
          scrollMenuIntoView: false
        })
      )
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      leftColumnStyle: leftColumnStyle,
      rightColumnStyle: rightColumnStyle,
      outerContainerStyle: { overflow: 'inherit', marginBottom: '0', clear: 'both' },
      leftColumnContent: _react2.default.createElement(
        'div',
        { style: { marginTop: '20px' } },
        'Base rates information',
        _react2.default.createElement(
          'div',
          { style: { color: '#999', fontSize: '12px', fontWeight: '400', width: '200px' } },
          '* Please enter your base room rates.'
        ),
        _react2.default.createElement(
          'div',
          { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
          '* All fields are required'
        )
      ),
      rightColumnContent: _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { overflow: 'inherit', marginBottom: '0' },
        leftColumnStyle: { display: rateType === 'nett' ? 'none' : 'inline-block', width: rateType === 'nett' ? '0' : '60%' },
        rightColumnStyle: { float: rateType === 'includeCommission' ? 'right' : '', width: rateType === 'nett' ? '100%' : '40%', display: 'inline-block' },
        leftColumnContent: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { style: { width: '40%', display: rateType === 'includeCommission' ? 'inline-block' : 'none' } },
            'Base rate'
          ),
          _react2.default.createElement(_typeControlledTextfield2.default, {
            id: 'base-nett',
            controlledType: 'number',
            style: { width: '50%', marginLeft: '1%', marginBottom: '12px' },
            hintStyle: { fontSize: '12px' },
            inputStyle: { fontSize: '14px' },
            hintText: 'Enter retail rate here',
            value: retailRate,
            onChange: function onChange(_ref5) {
              var value = _ref5.target.value;
              return updateFieldValue({ fieldName: 'retailRate', value: value });
            }
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'span',
            { style: { width: '40%', display: rateType === 'includeCommission' ? 'inline-block' : 'none' } },
            'Extra adult'
          ),
          _react2.default.createElement(_typeControlledTextfield2.default, {
            controlledType: 'number',
            style: { width: '50%', marginLeft: '1%', marginBottom: '12px' },
            hintStyle: { fontSize: '12px' },
            inputStyle: { fontSize: '14px' },
            hintText: 'Enter retail rate here',
            value: additionalAdultRetail,
            onChange: function onChange(_ref6) {
              var value = _ref6.target.value;
              return updateFormData({ fieldName: 'additionalAdultRetail', value: value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId);
            }
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'span',
            { style: { width: '40%', display: rateType === 'includeCommission' ? 'inline-block' : 'none' } },
            'Extra child'
          ),
          _react2.default.createElement(_typeControlledTextfield2.default, {
            controlledType: 'number',
            style: { width: '50%', marginLeft: '1%', marginBottom: '12px' },
            hintStyle: { fontSize: '12px' },
            inputStyle: { fontSize: '14px' },
            hintText: 'Enter retail rate here',
            value: additionalChildRetail,
            onChange: function onChange(_ref7) {
              var value = _ref7.target.value;
              return updateFormData({ fieldName: 'additionalChildRetail', value: value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId);
            }
          })
        ),
        rightColumnContent: _react2.default.createElement(
          'div',
          { style: { width: '100%' } },
          _react2.default.createElement(
            'span',
            { style: { width: '24%', display: rateType === 'nett' ? 'inline-block' : 'none' } },
            'Base rate'
          ),
          _react2.default.createElement(_typeControlledTextfield2.default, {
            controlledType: 'number',
            style: { width: '75%', marginBottom: '12px' },
            hintStyle: { fontSize: '12px', zIndex: '0' },
            inputStyle: { fontSize: '14px' },
            disabled: rateType === 'includeCommission',
            hintText: rateType === 'includeCommission' ? 'Auto calculated' : 'Enter nett rate here',
            value: baseRate,
            onChange: function onChange(_ref8) {
              var value = _ref8.target.value;
              return updateFieldValue({ fieldName: 'baseRate', value: value });
            }
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'span',
            { style: { width: '24%', display: rateType === 'nett' ? 'inline-block' : 'none' } },
            'Extra adult'
          ),
          _react2.default.createElement(_typeControlledTextfield2.default, {
            controlledType: 'number',
            style: { width: '75%', marginBottom: '12px' },
            hintStyle: { fontSize: '12px' },
            inputStyle: { fontSize: '14px' },
            disabled: rateType === 'includeCommission',
            hintText: rateType === 'includeCommission' ? 'Auto calculated' : 'Enter nett rate here',
            value: additionalAdult,
            onChange: function onChange(_ref9) {
              var value = _ref9.target.value;
              return updateFormData({ fieldName: 'additionalAdult', value: value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId);
            }
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'span',
            { style: { width: '24%', display: rateType === 'nett' ? 'inline-block' : 'none' } },
            'Extra child'
          ),
          _react2.default.createElement(_typeControlledTextfield2.default, {
            controlledType: 'number',
            style: { width: '75%', marginBottom: '12px' },
            hintStyle: { fontSize: '12px' },
            inputStyle: { fontSize: '14px' },
            disabled: rateType === 'includeCommission',
            hintText: rateType === 'includeCommission' ? 'Auto calculated' : 'Enter nett rate here',
            value: additionalChild,
            onChange: function onChange(_ref10) {
              var value = _ref10.target.value;
              return updateFormData({ fieldName: 'additionalChild', value: value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId);
            }
          })
        )
      })
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      leftColumnStyle: leftColumnStyle,
      rightColumnStyle: rightColumnStyle,
      outerContainerStyle: { overflowY: 'hidden', clear: 'both' },
      leftColumnContent: _react2.default.createElement(
        'div',
        { style: { marginTop: '42px' } },
        'Room occupancy',
        _react2.default.createElement(
          'div',
          { style: { color: '#999', fontSize: '12px', fontWeight: '400', width: '200px' } },
          '* Please enter the number of guests included in the base rate, as well as the maximum number of guests the room can hold.'
        ),
        _react2.default.createElement(
          'div',
          { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
          '* All fields are required'
        )
      ),
      rightColumnContent: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_typeControlledTextfield2.default, {
          controlledType: 'number',
          style: { display: 'block', width: '85%' },
          hintStyle: { fontSize: '14px' },
          floatingLabelShrinkStyle: { color: 'rgba(0, 0, 0, 0.64)' },
          inputStyle: { fontSize: '14px' },
          hintText: 'Whole number only',
          floatingLabelText: 'Included guests in base rate',
          value: includedGuestsinBaseRate,
          errorText: includedGuestsError,
          onChange: function onChange(_ref11) {
            var value = _ref11.target.value;
            return updateFormData({ fieldName: 'includedGuestsinBaseRate', value: value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId);
          }
        }),
        _react2.default.createElement(_typeControlledTextfield2.default, {
          controlledType: 'number',
          style: { display: 'block', width: '85%' },
          hintStyle: { fontSize: '14px' },
          floatingLabelShrinkStyle: { color: 'rgba(0, 0, 0, 0.64)' },
          inputStyle: { fontSize: '14px' },
          hintText: 'Whole number only',
          floatingLabelText: 'Maximum adults',
          value: maxAdults,
          errorText: maxAdultsError,
          onChange: function onChange(_ref12) {
            var value = _ref12.target.value;
            return updateFormData({ fieldName: 'maxAdults', value: value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId);
          }
        }),
        _react2.default.createElement(_typeControlledTextfield2.default, {
          controlledType: 'number',
          style: { display: 'block', width: '85%' },
          hintStyle: { fontSize: '14px' },
          floatingLabelShrinkStyle: { color: 'rgba(0, 0, 0, 0.64)' },
          inputStyle: { fontSize: '14px' },
          hintText: 'Whole number only',
          floatingLabelText: 'Max Occupancy (Adults + Children)',
          value: maxAdultsChildren,
          errorText: maxGuestsError,
          onChange: function onChange(_ref13) {
            var value = _ref13.target.value;
            return updateFormData({ fieldName: 'maxAdultsChildren', value: value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId);
          }
        })
      )
    })
  );
};

exports.default = Rates;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _RateType = __webpack_require__(1257);

var _RateType2 = _interopRequireDefault(_RateType);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _selectFields = __webpack_require__(141);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _standardTemplate = __webpack_require__(3281);

var _standardTemplate2 = _interopRequireDefault(_standardTemplate);

var _multiDayTour = __webpack_require__(3282);

var _multiDayTour2 = _interopRequireDefault(_multiDayTour);

var _privateTourTransfersTemplate = __webpack_require__(3283);

var _privateTourTransfersTemplate2 = _interopRequireDefault(_privateTourTransfersTemplate);

var _priceBreakTemplate = __webpack_require__(3284);

var _priceBreakTemplate2 = _interopRequireDefault(_priceBreakTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NonAccomRates = function NonAccomRates(_ref) {
  var definedRateTemplate = _ref.definedRateTemplate,
      showTaxCurrency = _ref.showTaxCurrency,
      updateFieldValue = _ref.updateFieldValue,
      updateFieldWithKeyPath = _ref.updateFieldWithKeyPath,
      updateFormData = _ref.updateFormData,
      locationId = _ref.locationId,
      productId = _ref.productId,
      fieldValues = _objectWithoutProperties(_ref, ['definedRateTemplate', 'showTaxCurrency', 'updateFieldValue', 'updateFieldWithKeyPath', 'updateFormData', 'locationId', 'productId']);

  var leftColumnStyle = { width: '30%', textAlign: 'left', fontSize: '15px' };
  var rightColumnStyle = { width: '70%', textAlign: 'left', paddingRight: '30px' };
  var nonStandardTemplateType = fieldValues.nonStandardTemplateType || definedRateTemplate;
  var RatesFormTemplate = function () {
    switch (nonStandardTemplateType) {
      case 'multiDayTour':
        return _multiDayTour2.default;
      case 'privateTransfer':
        return _privateTourTransfersTemplate2.default;
      case 'priceBreak':
        return _priceBreakTemplate2.default;
      case 'standard':
      default:
        return _standardTemplate2.default;
    }
  }();
  return _react2.default.createElement(
    'div',
    { style: { margin: '3% 0 9% 0' } },
    _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { marginBottom: '0' },
      leftColumnStyle: leftColumnStyle,
      rightColumnStyle: rightColumnStyle,
      leftColumnContent: _react2.default.createElement(
        'div',
        { style: { padding: '4px 0 4px 0' } },
        'Rates type',
        _react2.default.createElement(
          'div',
          { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
          '* Required'
        )
      ),
      rightColumnContent: _react2.default.createElement(
        'div',
        { style: { padding: '4px 0 4px 0' } },
        _react2.default.createElement(_RateType2.default, {
          rateType: fieldValues.rateType,
          commissionPercentage: fieldValues.commissionPercentage,
          nettCommission: fieldValues.nettCommission,
          updateRateType: function updateRateType(value) {
            return updateFormData({ fieldName: 'rateType', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location', locationId, productId);
          },
          updateCommission: function updateCommission(value) {
            return updateFormData({ fieldName: 'commissionPercentage', value: value }, 'UPDATE_ADD_RATES_FIELD', 'location', locationId, productId);
          },
          updateNettCommission: function updateNettCommission(value) {
            return updateFormData({ fieldName: 'nettCommission', value: value }, 'UPDATE_ADD_RATES_FIELD', 'location', locationId, productId);
          }
        })
      )
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      hide: !showTaxCurrency,
      leftColumnStyle: leftColumnStyle,
      rightColumnStyle: rightColumnStyle,
      outerContainerStyle: { overflow: 'inherit', marginTop: '12px', marginBottom: '12px' },
      leftColumnContent: _react2.default.createElement(
        'div',
        null,
        'Tax information',
        _react2.default.createElement(
          'div',
          { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
          '* Required'
        )
      ),
      rightColumnContent: _react2.default.createElement(
        'div',
        { style: { width: '300px' } },
        _react2.default.createElement(
          'div',
          { style: { width: '45%', display: 'inline-block' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'taxInclusion',
            options: [{ value: 'inclusive', label: 'Tax inclusive' }, { value: 'exclusive', label: 'Tax exclusive' }, { value: 'exempt', label: 'Tax exempt' }],
            value: fieldValues.taxInclusion,
            onChange: function onChange(_ref2) {
              var value = _ref2.value;
              return updateFormData({ fieldName: 'taxInclusion', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location');
            },
            placeholder: 'Tax Inclusion',
            clearable: false,
            scrollMenuIntoView: false
          })
        ),
        fieldValues.taxInclusion !== 'exempt' ? _react2.default.createElement(
          'div',
          { style: { width: '50%', marginLeft: '5%', display: 'inline-block' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'taxType',
            options: _selectFields.taxTypes,
            value: fieldValues.taxType,
            onChange: function onChange(_ref3) {
              var value = _ref3.value;
              return updateFormData({ fieldName: 'taxType', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location');
            },
            placeholder: 'Tax Type',
            clearable: false,
            scrollMenuIntoView: false
          })
        ) : undefined
      )
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      hide: !showTaxCurrency,
      leftColumnStyle: leftColumnStyle,
      rightColumnStyle: rightColumnStyle,
      outerContainerStyle: { overflow: 'inherit', clear: 'both', height: '42px', marginBottom: '0' },
      leftColumnContent: _react2.default.createElement(
        'div',
        { style: { marginTop: '12px' } },
        'Currency',
        _react2.default.createElement(
          'div',
          { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
          '* Required'
        )
      ),
      rightColumnContent: _react2.default.createElement(
        'div',
        { style: { width: '135px', position: 'relative', top: '10px', display: 'inline-block' } },
        _react2.default.createElement(_reactSelect2.default, {
          name: 'currency',
          options: _selectFields.currencies,
          value: fieldValues.currency,
          onChange: function onChange(_ref4) {
            var value = _ref4.value;
            return updateFormData({ fieldName: 'currency', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location');
          },
          placeholder: 'Currency',
          clearable: false,
          scrollMenuIntoView: false
        })
      )
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      hide: Boolean(definedRateTemplate),
      leftColumnStyle: leftColumnStyle,
      rightColumnStyle: rightColumnStyle,
      outerContainerStyle: { overflow: 'inherit', clear: 'both', height: '54px', marginBottom: '0', marginTop: '12px' },
      leftColumnContent: _react2.default.createElement(
        'div',
        { style: { marginTop: '12px' } },
        'Rate template',
        _react2.default.createElement(
          'div',
          { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
          '* Required'
        )
      ),
      rightColumnContent: _react2.default.createElement(
        'div',
        { style: { width: '300px', position: 'relative', top: '10px', display: 'inline-block' } },
        _react2.default.createElement(_reactSelect2.default, {
          name: 'rateLogic',
          options: [{ value: 'standard', label: 'Standard Rates (Adult/Child...)' }, { value: 'multiDayTour', label: 'Multi-Day (Single/Double...)' }, { value: 'priceBreak', label: 'Price Breaks/Per Person (From/To...)' }, { value: 'privateTransfer', label: 'Private/Transfers (Up to...)' }],
          value: fieldValues.nonStandardTemplateType || 'standard',
          onChange: function onChange(_ref5) {
            var value = _ref5.value;
            return updateFieldValue({ fieldName: 'nonStandardTemplateType', value: value });
          },
          placeholder: 'Rate template',
          clearable: false,
          scrollMenuIntoView: false
        })
      )
    }),
    _react2.default.createElement(RatesFormTemplate, _extends({
      nonStandardTemplateType: nonStandardTemplateType,
      updateFieldValue: updateFieldValue,
      updateFieldWithKeyPath: updateFieldWithKeyPath
    }, fieldValues))
  );
};

exports.default = NonAccomRates;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _contractingPresetNamesCodes = __webpack_require__(464);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var SelectSeasonName = function SelectSeasonName(_ref) {
  var labelNode = _ref.labelNode,
      style = _ref.style,
      _onChange = _ref.onChange,
      selectedSeasonName = _ref.selectedSeasonName,
      contractingPeriod = _ref.contractingPeriod,
      existingSeasons = _ref.existingSeasons;

  var existingSeasonNames = existingSeasons.map(function (season) {
    return season.seasonName;
  });
  var hasExistingSeason = Boolean(existingSeasons && existingSeasons.length);
  var contractingPeriodString = _moment2.default.utc(contractingPeriod.startDate).format('D MMM YYYY') + ' - ' + _moment2.default.utc(contractingPeriod.endDate).format('D MMM YYYY');
  var systemSeasons = [].concat(_toConsumableArray(Object.keys(_contractingPresetNamesCodes.seasonNamesMap))).filter(function (x) {
    return x;
  }).map(function (name) {
    return {
      seasonName: name,
      dateRanges: name === contractingPeriodString || 'All Year' && !hasExistingSeason ? [{ seasonStartDate: contractingPeriod.startDate, seasonEndDate: contractingPeriod.endDate }] : []
    };
  });
  var returnOption = function returnOption(season) {
    return {
      color: function () {
        if (season.seasonName === selectedSeasonName) return '#ff4081';
        return 'black';
      }(),
      label: season.seasonName,
      value: season.seasonName,
      disabled: function () {
        if (season.seasonName === 'Special Event') return false; // always enable Special Event option
        return season.seasonName && existingSeasonNames.indexOf(season.seasonName) > -1;
      }()
    };
  };
  var menuOptions = [].concat(_toConsumableArray(systemSeasons.map(returnOption))).filter(function (x) {
    return x;
  });
  return _react2.default.createElement(
    'div',
    { style: style },
    labelNode || _react2.default.createElement(
      'label',
      { style: { display: 'block', margin: '0 0 8px 4px' } },
      'Season Name'
    ),
    _react2.default.createElement(_reactSelect2.default, {
      clearable: false,
      options: menuOptions,
      value: selectedSeasonName,
      placeholder: selectedSeasonName,
      optionRenderer: function optionRenderer(option) {
        return _react2.default.createElement(
          'span',
          { style: { color: option.disabled ? 'rgba(0, 0, 0, 0.33)' : option.color, fontWeight: option.bold ? 'bold' : 'normal' } },
          option.label
        );
      },
      onChange: function onChange(_ref2) {
        var value = _ref2.value;
        return _onChange(value);
      }
    })
  );
};

exports.default = SelectSeasonName;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _singleSection = __webpack_require__(3302);

var _singleSection2 = _interopRequireDefault(_singleSection);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _seasonErrors = __webpack_require__(1976);

var _seasonErrors2 = _interopRequireDefault(_seasonErrors);

var _askIfVaryBySeason = __webpack_require__(1965);

var _askIfVaryBySeason2 = _interopRequireDefault(_askIfVaryBySeason);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var notNil = (0, _ramda.complement)(_ramda.isNil);
var singlePluralMap = {
  allocations: 'allocation information',
  'cancellation policies': 'cancellation policy',
  'pickup information': 'pickup information',
  'dropoff information': 'dropoff information'
};

var SeasonSection = function (_Component) {
  _inherits(SeasonSection, _Component);

  function SeasonSection(props) {
    _classCallCheck(this, SeasonSection);

    var _this = _possibleConstructorReturn(this, (SeasonSection.__proto__ || Object.getPrototypeOf(SeasonSection)).call(this, props));

    _initialiseProps.call(_this);

    var varyBySeason = props.varyBySeason,
        useSeasons = props.useSeasons;

    _this.state = { varyBySeason: varyBySeason, useSeasons: useSeasons };
    return _this;
  }

  _createClass(SeasonSection, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          enableManualDatesEntry = _props.enableManualDatesEntry,
          contractingPeriod = _props.contractingPeriod,
          emptyInitialContent = _props.emptyInitialContent,
          onFieldChange = _props.onFieldChange,
          contentActions = _props.contentActions,
          contentsData = _props.contentsData,
          ContentNode = _props.ContentNode,
          seasons = _props.seasons,
          showError = _props.showError;
      var _state = this.state,
          varyBySeason = _state.varyBySeason,
          useSeasons = _state.useSeasons;

      var _ref = contractingPeriod || {},
          startDate = _ref.startDate,
          endDate = _ref.endDate;

      var onChangeDate = (0, _ramda.curry)(function (index, dateIndex, dateField, value) {
        return onFieldChange([index, 'dateRanges', dateIndex, dateField], value);
      });
      var dateRangeActions = {
        onChangeDate: onChangeDate,
        removeADateRange: (0, _ramda.curry)(function (index, dateIndex) {
          return onFieldChange([index, 'dateRanges'], (0, _ramda.call)((0, _ramda.compose)((0, _ramda.remove)(dateIndex, 1), (0, _ramda.pathOr)([], [index, 'dateRanges'])), contentsData));
        }),
        addADateRange: (0, _ramda.curry)(function (index, dateIndex) {
          return onFieldChange([index, 'dateRanges'], (0, _ramda.call)((0, _ramda.compose)((0, _ramda.insert)(dateIndex + 1, {}), (0, _ramda.pathOr)([], [index, 'dateRanges'])), contentsData));
        })
      };
      var userMadeSelection = (0, _ramda.all)(notNil, [varyBySeason, useSeasons]);
      var datesEditable = (0, _ramda.and)((0, _ramda.not)(useSeasons), varyBySeason);
      var allDateRanges = _dateUtils2.default.getFlattenedUnEmptyDates(contentsData);
      var contractingPeriodCovered = _dateUtils2.default.checkIfFullSeasonCoveredForAProduct(startDate, endDate, allDateRanges);
      var allDateRangesFromSeasons = _dateUtils2.default.getFlattenedUnEmptyDates(seasons);
      var seasonDoNotCoverContractingPeriod = _dateUtils2.default.checkIfFullSeasonCoveredForAProduct(startDate, endDate, allDateRangesFromSeasons) > 0;
      var isSingleSeason = allDateRangesFromSeasons && allDateRangesFromSeasons.length === 1 && allDateRangesFromSeasons[0].seasonStartDate === new Date(contractingPeriod.startDate).toISOString() && allDateRangesFromSeasons[0].seasonEndDate === new Date(contractingPeriod.endDate).toISOString();

      return _react2.default.createElement(
        'div',
        null,
        !isSingleSeason || enableManualDatesEntry ? _react2.default.createElement(_askIfVaryBySeason2.default, {
          enableManualDatesEntry: enableManualDatesEntry,
          name: name,
          varyBySeason: varyBySeason,
          useSeasons: useSeasons,
          selectIfVaryBySeason: this.selectIfVaryBySeason,
          selectIfUseSeasons: this.selectIfUseSeasons
        }) : _react2.default.createElement('span', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          { style: { textAlign: 'center', color: '#f44336' } },
          useSeasons && (0, _ramda.isEmpty)(seasons) ? 'You don\'t have seasons created yet.' : '',
          useSeasons && !(0, _ramda.isEmpty)(seasons) && seasonDoNotCoverContractingPeriod ? 'Please make sure you have season dates for the entire contracting period.' : ''
        ),
        _react2.default.createElement(
          'div',
          {
            style: {
              display: function () {
                if (isSingleSeason) return 'block';
                return !userMadeSelection || useSeasons && !(seasons && seasons.length) ? 'none' : 'block';
              }()
            }
          },
          _react2.default.createElement(
            'div',
            {
              style: {
                paddingLeft: '32px',
                paddingRight: '32px',
                marginBottom: '12px',
                display: varyBySeason && !useSeasons ? 'block' : 'none'
              }
            },
            _react2.default.createElement(_seasonErrors2.default, {
              startDate: startDate,
              endDate: endDate,
              seasonDateRanges: allDateRanges
            })
          ),
          isSingleSeason ? _react2.default.createElement('div', null) : _react2.default.createElement(_twoColumnRow2.default, {
            outerContainerStyle: { paddingLeft: '32px', marginBottom: '14px' },
            leftColumnStyle: { width: '20%', fontSize: '12px' },
            rightColumnStyle: { width: '80%' },
            leftColumnContent: 'Dates',
            rightColumnContent: ''
          }),
          _react2.default.createElement(
            'div',
            { style: { minHeight: '100px' } },
            contentsData.map(function (contentData, index) {
              return _react2.default.createElement(_singleSection2.default, _extends({
                key: index,
                index: index,
                seasons: seasons,
                datesEditable: datesEditable,
                contractingPeriod: contractingPeriod,
                ContentNode: ContentNode,
                showError: showError,
                removeOneSeasonSet: function removeOneSeasonSet() {
                  return onFieldChange([], (0, _ramda.remove)(index, 1, contentsData));
                },
                useCorrectSeason: function useCorrectSeason() {
                  return onFieldChange([index], (0, _ramda.call)((0, _ramda.compose)((0, _ramda.omit)(['correctSeasonName', 'correctDateRanges']), function (dateRanges) {
                    return (0, _ramda.merge)(contentData, { dateRanges: dateRanges });
                  }, (0, _ramda.prop)('correctDateRanges')), contentData));
                },
                dateRangeActions: dateRangeActions,
                contentActions: contentActions,
                takenDateRanges: (0, _ramda.call)((0, _ramda.compose)(_dateUtils2.default.transformDateRanges, (0, _ramda.chain)((0, _ramda.propOr)([], 'dateRanges')), (0, _ramda.addIndex)(_ramda.reject)((0, _ramda.compose)((0, _ramda.equals)(index), (0, _ramda.nthArg)(1)))), contentsData)
              }, contentData));
            }),
            _react2.default.createElement(
              'div',
              {
                style: {
                  display: datesEditable && contractingPeriodCovered > 0 ? 'block' : 'none',
                  borderBottom: '1px solid #ededed',
                  borderTop: '1px solid #ededed',
                  backgroundColor: '#fafafa',
                  height: '62px',
                  lineHeight: '62px',
                  textAlign: 'center',
                  color: '#21c4d8',
                  cursor: 'pointer'
                },
                onClick: function onClick() {
                  return onFieldChange([], (0, _ramda.append)((0, _ramda.merge)(emptyInitialContent, { dateRanges: [{}] }), contentsData));
                }
              },
              '+ Add more ',
              name
            )
          )
        )
      );
    }
  }]);

  return SeasonSection;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.populateInitialContent = function () {
    var _state2 = _this2.state,
        varyBySeason = _state2.varyBySeason,
        useSeasons = _state2.useSeasons;
    var _props2 = _this2.props,
        emptyInitialContent = _props2.emptyInitialContent,
        onFieldChange = _props2.onFieldChange,
        seasons = _props2.seasons,
        contractingPeriod = _props2.contractingPeriod;

    var addDatesIfUseSeasons = (0, _ramda.compose)((0, _ramda.merge)(emptyInitialContent), (0, _ramda.pick)(['dateRanges']));
    var addDatesIfNotUseSeasons = (0, _ramda.ifElse)((0, _ramda.equals)(true), (0, _ramda.always)({ dateRanges: [{}] }), (0, _ramda.always)({ dateRanges: [{ seasonStartDate: contractingPeriod.startDate, seasonEndDate: contractingPeriod.endDate }] }));
    var initialContentWithDates = (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), function () {
      return (0, _ramda.map)(addDatesIfUseSeasons, seasons);
    }, function () {
      return [(0, _ramda.merge)(emptyInitialContent, addDatesIfNotUseSeasons(varyBySeason))];
    }), useSeasons);
    onFieldChange([], initialContentWithDates);
  };

  this.selectIfVaryBySeason = function (value) {
    _this2.setState({ varyBySeason: value, useSeasons: value || false }, _this2.populateInitialContent);
    if (_this2.props.onVaryBySeasonChange) _this2.props.onVaryBySeasonChange(value);
  };

  this.selectIfUseSeasons = function (value) {
    return _this2.setState({ useSeasons: value }, _this2.populateInitialContent);
  };
};

SeasonSection.propTypes = {
  name: _react.PropTypes.string,
  contractingPeriod: _react.PropTypes.object,
  removeOneSeasonSet: _react.PropTypes.func,
  addOneSeasonSet: _react.PropTypes.func,
  emptyInitialContent: _react.PropTypes.object,
  onFieldChange: _react.PropTypes.func,
  contentActions: _react.PropTypes.object,
  contentsData: _react.PropTypes.array,
  ContentNode: _react.PropTypes.any,
  seasons: _react.PropTypes.array,
  enableManualDatesEntry: _react.PropTypes.bool,
  onVaryBySeasonChange: _react.PropTypes.func,
  showError: _react.PropTypes.bool
};

exports.default = SeasonSection;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _selectFields = __webpack_require__(141);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaxCurrencyCommissionForm = function TaxCurrencyCommissionForm(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { margin: '24px auto', display: props.hideCurrencyTax ? 'none' : 'block' } },
      _react2.default.createElement(
        'span',
        { style: { position: 'relative', top: '-12px' } },
        'Tax information ',
        _react2.default.createElement(
          'small',
          { style: { color: 'red', display: !props.taxInclusion && !props.taxType ? 'block' : 'none' } },
          ' * Required'
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', marginLeft: '12px' } },
        _react2.default.createElement(
          'div',
          { style: { width: '140px', display: 'inline-block' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'taxInclusion',
            options: [{ value: 'inclusive', label: 'Tax inclusive' }, { value: 'exclusive', label: 'Tax exclusive' }, { value: 'exempt', label: 'Tax exempt' }],
            value: props.taxInclusion,
            onChange: function onChange(_ref) {
              var value = _ref.value;
              return props.updateFunc('taxInclusion', value.trim());
            },
            placeholder: 'Tax Inclusion',
            clearable: false,
            scrollMenuIntoView: false
          })
        ),
        props.taxInclusion !== 'exempt' ? _react2.default.createElement(
          'div',
          { style: { width: '160px', marginLeft: '50px', display: props.hideCurrencyTax ? 'none' : 'inline-block' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'taxType',
            options: _selectFields.taxTypes,
            value: props.taxType,
            onChange: function onChange(_ref2) {
              var value = _ref2.value;
              return props.updateFunc('taxType', value.trim());
            },
            placeholder: 'Tax Type',
            clearable: false,
            scrollMenuIntoView: false
          })
        ) : undefined
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { margin: '24px auto', display: props.hideCurrencyTax ? 'none' : 'block' } },
      _react2.default.createElement(
        'span',
        { style: { position: 'relative', top: '-12px' } },
        'Currency ',
        _react2.default.createElement(
          'small',
          { style: { color: 'red', display: !props.currency ? 'block' : 'none' } },
          ' * Required'
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '160px', marginLeft: '48px', display: 'inline-block' } },
        _react2.default.createElement(_reactSelect2.default, {
          name: 'currency',
          options: _selectFields.currencies,
          value: props.currency,
          onChange: function onChange(_ref3) {
            var value = _ref3.value;
            return props.updateFunc('currency', value.trim());
          },
          placeholder: 'Currency',
          clearable: false,
          scrollMenuIntoView: false
        })
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_typeControlledTextfield2.default, {
        id: 'commission',
        controlledType: 'number',
        style: { display: 'inline-block', width: '50%' },
        hintStyle: { fontSize: '14px' },
        floatingLabelShrinkStyle: { color: 'rgba(0, 0, 0, 0.64)' },
        inputStyle: { fontSize: '14px' },
        floatingLabelText: props.rateType === 'includeCommission' || !props.rateType && props.commissionPercentage ? 'COMMISSION: ' : 'NETT RATE BASED ON COMMISSION: ',
        value: props.rateType === 'includeCommission' || !props.rateType && props.commissionPercentage ? props.commissionPercentage : props.nettCommission,
        onChange: function onChange(_ref4) {
          var value = _ref4.target.value;

          props.updateFunc(props.rateType === 'includeCommission' || !props.rateType && props.commissionPercentage ? 'commissionPercentage' : 'nettCommission', value);
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { margin: '24px auto' } },
      'If you need to fine tune these rates, just edit the table below.'
    )
  );
};

exports.default = TaxCurrencyCommissionForm;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _table = __webpack_require__(3328);

var _table2 = _interopRequireDefault(_table);

var _tableInEdit = __webpack_require__(3329);

var _tableInEdit2 = _interopRequireDefault(_tableInEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SpecialOfferTable = function SpecialOfferTable(props) {
  var inEdit = props.inEdit,
      extraProps = _objectWithoutProperties(props, ['inEdit']);

  if (inEdit) return _react2.default.createElement(_tableInEdit2.default, extraProps);
  return _react2.default.createElement(_table2.default, extraProps);
};

exports.default = SpecialOfferTable;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionGetApp = function ActionGetApp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' })
  );
};
ActionGetApp = (0, _pure2.default)(ActionGetApp);
ActionGetApp.displayName = 'ActionGetApp';
ActionGetApp.muiName = 'SvgIcon';

exports.default = ActionGetApp;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(1263);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextFlag = function TextFlag(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      _ref$stagedUpdates = _ref.stagedUpdates,
      stagedUpdates = _ref$stagedUpdates === undefined ? [] : _ref$stagedUpdates,
      updateInitiated = _ref.updateInitiated,
      removeDraftFromQueue = _ref.removeDraftFromQueue,
      isEditedTemplate = _ref.isEditedTemplate,
      isEditedDraft = _ref.isEditedDraft,
      refreshSection = _ref.refreshSection;

  var stagedDraft = stagedUpdates.find(function (obj) {
    return obj.source === 'draft';
  });
  var stagedPolicyNotes = stagedUpdates.find(function (obj) {
    return obj.source === 'policyNotes';
  });
  if (updateInitiated) {
    return _react2.default.createElement(
      'div',
      { style: style },
      'We are processing updates for this template.'
    );
  }
  return _react2.default.createElement(
    'div',
    { style: _extends({ color: refreshSection === 'list' ? 'red' : 'rgba(0, 0, 0, 0.67)' }, style) },
    stagedDraft && isEditedTemplate && _react2.default.createElement(
      'div',
      null,
      'This template has a',
      ' ',
      _react2.default.createElement(
        'a',
        {
          style: { cursor: 'pointer' },
          href: '/contracting/draft/' + stagedDraft.sourceId + '/details'
        },
        'draft'
      ),
      ' ',
      'queued for updates.\xA0',
      _react2.default.createElement(
        'span',
        {
          style: { textDecoration: 'underline', cursor: 'pointer', color: 'rgba(0, 0, 0, 0.57)' },
          onClick: function onClick(e) {
            e.stopPropagation();
            removeDraftFromQueue(stagedDraft.sourceId, refreshSection);
          }
        },
        'Remove draft from queue ',
        refreshSection === 'list' ? '' : 'to continue editing'
      )
    ),
    stagedDraft && isEditedDraft && _react2.default.createElement(
      'div',
      null,
      'This draft has been queued for updates for this',
      ' ',
      _react2.default.createElement(
        'a',
        {
          style: { cursor: 'pointer' },
          href: '/contracting/template/' + stagedDraft.sourceId + '/details'
        },
        'template'
      ),
      '.'
    ),
    stagedPolicyNotes && isEditedTemplate && _react2.default.createElement(
      'div',
      null,
      'This template has a',
      ' ',
      _react2.default.createElement(
        'a',
        {
          style: { cursor: 'pointer' },
          href: '/contracting/master-template/' + stagedPolicyNotes.sourceId
        },
        'Corporate Policies & Notes template'
      ),
      ' ',
      'queued for updates.'
    )
  );
};

exports.default = (0, _reactRedux.connect)(null, { removeDraftFromQueue: _actions.removeDraftFromQueue })(TextFlag);

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExpandableTextBlock = function (_React$Component) {
  _inherits(ExpandableTextBlock, _React$Component);

  function ExpandableTextBlock() {
    _classCallCheck(this, ExpandableTextBlock);

    var _this = _possibleConstructorReturn(this, (ExpandableTextBlock.__proto__ || Object.getPrototypeOf(ExpandableTextBlock)).call(this));

    _this._toggle = function () {
      _this.setState({ expanded: !_this.state.expanded });
    };

    _this.state = {
      expanded: false
    };
    return _this;
  }

  _createClass(ExpandableTextBlock, [{
    key: 'render',
    value: function render() {
      var isString = _ramda2.default.is(String, this.props.children);
      if (!isString || !this.props.children) return this.props.children || _react2.default.createElement('span', null);
      var textLength = this.props.children ? this.props.children.length : 0;
      var tooLong = textLength > 500;
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'span',
          { className: this.props.className, style: this.props.style },
          !this.state.expanded ? (this.props.children || '').slice(0, 500) : this.props.children
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'a',
            { style: { cursor: 'pointer' }, onClick: this._toggle },
            !this.state.expanded && tooLong && ' + Show All',
            this.state.expanded && tooLong && ' - Show Less'
          )
        )
      );
    }
  }]);

  return ExpandableTextBlock;
}(_react2.default.Component);

ExpandableTextBlock.propTypes = {
  children: _react2.default.PropTypes.any,
  className: _react2.default.PropTypes.string,
  style: _react2.default.PropTypes.object
};

exports.default = ExpandableTextBlock;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _policyMain = __webpack_require__(1562);

var _policyMain2 = _interopRequireDefault(_policyMain);

var _titlecase = __webpack_require__(549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Policies = function Policies(props) {
  if (!props.locationPolicy) return _react2.default.createElement('span', null);
  var getEditStateInfo = function getEditStateInfo(policyType, label, action) {
    return {
      type: 'policy',
      title: action + ' ' + label + ' Policy',
      policyType: policyType,
      policiesNotesPage: true
    };
  };

  var getProps = function getProps(type) {
    var _extends2;

    var _props$locationPolicy = props.locationPolicy.filter(function (policy) {
      return policy.policyType === type;
    }),
        _props$locationPolicy2 = _slicedToArray(_props$locationPolicy, 1),
        info = _props$locationPolicy2[0];

    var titleCase = type === 'freeOfCharge' ? 'Free of Charge' : (0, _titlecase.toLaxTitleCase)(type);
    return _extends((_extends2 = {
      inMaster: props.inMaster
    }, _defineProperty(_extends2, type + 'Info', info), _defineProperty(_extends2, 'deletePolicy', props.deleteLocationPolicy && props.deleteLocationPolicy(type)), _defineProperty(_extends2, 'add' + (type === 'freeOfCharge' ? 'FreeOfCharge' : titleCase), function undefined() {
      return props.openAddEditContractDialog(getEditStateInfo(type, titleCase, 'Add'));
    }), _defineProperty(_extends2, 'edit' + (type === 'freeOfCharge' ? 'FreeOfCharge' : titleCase), function undefined() {
      return props.openAddEditContractDialog(getEditStateInfo(type, titleCase, 'Edit'));
    }), _defineProperty(_extends2, 'supplierEditable', props.supplierEditable), _extends2), type === 'cancellation' ? { label: 'Cancellation Policy' } : {});
  };
  var policyTypes = ['cancellation', 'child', 'infant', 'group', 'freeOfCharge', 'family'];
  return _react2.default.createElement(
    'div',
    { style: { marginLeft: '15%', width: '80%', paddingTop: '24px', borderTop: '1px solid #efefef', whiteSpace: 'pre-wrap' } },
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '12px', fontSize: '16px' } },
      'POLICIES'
    ),
    _react2.default.createElement(
      'div',
      { style: { marginLeft: '32px' } },
      policyTypes.map(function (type) {
        return _react2.default.createElement(
          'div',
          { key: type },
          _react2.default.createElement(_policyMain2.default, {
            policyType: type,
            policyProps: getProps(type)
          }),
          _react2.default.createElement('br', null)
        );
      })
    )
  );
};

Policies.propTypes = {
  openAddEditContractDialog: _react.PropTypes.func,
  supplierEditable: _react.PropTypes.bool,
  locationPolicy: _react.PropTypes.array,
  deleteLocationPolicy: _react.PropTypes.func,
  inMaster: _react.PropTypes.bool
};

exports.default = Policies;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cancellation = __webpack_require__(1990);

var _cancellation2 = _interopRequireDefault(_cancellation);

var _group = __webpack_require__(1991);

var _group2 = _interopRequireDefault(_group);

var _freeofcharge = __webpack_require__(1992);

var _freeofcharge2 = _interopRequireDefault(_freeofcharge);

var _family = __webpack_require__(1993);

var _family2 = _interopRequireDefault(_family);

var _child = __webpack_require__(1994);

var _child2 = _interopRequireDefault(_child);

var _infant = __webpack_require__(1995);

var _infant2 = _interopRequireDefault(_infant);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Policy = function Policy(props) {
  var policyType = props.policyType,
      policyProps = props.policyProps;

  return _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('cancellation'), _ramda2.default.always(_react2.default.createElement(_cancellation2.default, policyProps))], [_ramda2.default.equals('child'), _ramda2.default.always(_react2.default.createElement(_child2.default, policyProps))], [_ramda2.default.equals('infant'), _ramda2.default.always(_react2.default.createElement(_infant2.default, policyProps))], [_ramda2.default.equals('group'), _ramda2.default.always(_react2.default.createElement(_group2.default, policyProps))], [_ramda2.default.equals('freeOfCharge'), _ramda2.default.always(_react2.default.createElement(_freeofcharge2.default, policyProps))], [_ramda2.default.equals('family'), _ramda2.default.always(_react2.default.createElement(_family2.default, policyProps))]]), policyType);
};

Policy.propTypes = {
  policyType: _react.PropTypes.string,
  policyProps: _react.PropTypes.object
};

exports.default = Policy;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var showSubStringIfLongThan = function showSubStringIfLongThan(str, num) {
  return '' + str.substring(0, num) + (str.length > num ? '...' : '');
};
var EditSeasonButton = function EditSeasonButton(_ref) {
  var openAddEditContractDialog = _ref.openAddEditContractDialog,
      seasonRatesIndex = _ref.seasonRatesIndex,
      seasonName = _ref.seasonName,
      dateRanges = _ref.dateRanges,
      className = _ref.className,
      style = _ref.style,
      existingSeasons = _ref.existingSeasons;

  var openEditSeasonModal = function openEditSeasonModal() {
    return openAddEditContractDialog({
      type: 'editSeason',
      data: {
        seasonIndex: seasonRatesIndex,
        title: 'Edit Season'
      }
    });
  };
  return _react2.default.createElement(
    'div',
    {
      className: className,
      style: _extends({ cursor: 'pointer', color: '#f44336' }, style),
      onClick: openEditSeasonModal
    },
    'Update Season Dates'
  );
};

exports.default = EditSeasonButton;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MeasureToggle = function MeasureToggle(_ref) {
  var retailNettMeasure = _ref.retailNettMeasure,
      changeMeasure = _ref.changeMeasure;

  var getStyle = function getStyle(value) {
    return (0, _ramda.merge)({
      width: '50%',
      borderRadius: '3px',
      display: 'inline-block',
      cursor: 'pointer'
    }, {
      backgroundColor: (0, _ramda.equals)(value, retailNettMeasure) ? '#009688' : '#dddddd',
      color: (0, _ramda.equals)(value, retailNettMeasure) ? 'white' : 'rgba(0, 0, 0, 0.3)'
    });
  };
  return _react2.default.createElement(
    'div',
    { style: { width: '100%', display: 'inline-block', lineHeight: '24px', textAlign: 'center', fontSize: '12px' } },
    _react2.default.createElement(
      'div',
      { style: getStyle('percentage'), onClick: function onClick() {
          return changeMeasure('percentage');
        } },
      '%'
    ),
    _react2.default.createElement(
      'div',
      { style: getStyle('dollar'), onClick: function onClick() {
          return changeMeasure('dollar');
        } },
      '$'
    )
  );
};

exports.default = MeasureToggle;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _expandableTextBlock = __webpack_require__(1560);

var _expandableTextBlock2 = _interopRequireDefault(_expandableTextBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var diffWords = _ref.diffWords,
      lhs = _ref.lhs,
      rhs = _ref.rhs,
      isLeft = _ref.isLeft;

  var text = isLeft ? lhs : rhs;
  if (diffWords && !_ramda2.default.isEmpty(diffWords)) {
    return _react2.default.createElement(
      'span',
      null,
      diffWords.filter(function (word) {
        return !word.added && isLeft || !word.removed && !isLeft;
      }).map(function (word, wordIndex) {
        var className = function () {
          if (word.removed && isLeft) return 'diff-deleted';
          if (word.added && !isLeft) return 'diff-added';
        }();
        return _react2.default.createElement(
          'span',
          { key: wordIndex, className: className },
          word.value
        );
      })
    );
  }
  return _react2.default.createElement(
    _expandableTextBlock2.default,
    { className: isLeft ? 'diff-deleted' : 'diff-added' },
    text
  );
};

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Template = function Template(props) {
  var updateNotification = props.updateNotification,
      _props$notifications = props.notifications,
      notifications = _props$notifications === undefined ? {} : _props$notifications,
      settings = props.settings,
      label = props.label,
      isSubmenu = props.isSubmenu,
      assetReceiving = props.assetReceiving,
      allDirectChecked = props.allDirectChecked,
      allIndirectChecked = props.allIndirectChecked,
      toggleAllDirect = props.toggleAllDirect,
      toggleAllIndirect = props.toggleAllIndirect;

  return _react2.default.createElement(
    'div',
    { style: { marginTop: isSubmenu ? '10px' : '20px' } },
    _react2.default.createElement(
      'div',
      { className: 'flex-tc-sb', style: { fontSize: isSubmenu ? '14px' : '20px', fontWeight: 400, margin: '4px 0 0 10px', paddingBottom: '12px' } },
      isSubmenu ? label : label + ' Settings',
      Boolean(assetReceiving && !isSubmenu) && _react2.default.createElement(
        'div',
        { className: 'flex-tc-sb', style: { minWidth: '286px', marginRight: '40px' } },
        _react2.default.createElement(
          'div',
          {
            className: 'hint--top',
            'aria-label': 'Direct messages are communications sent to your email address'
          },
          _react2.default.createElement(_materialUi.Checkbox, {
            label: 'Direct Messages',
            labelPosition: 'left',
            checked: allDirectChecked,
            labelStyle: { fontSize: '12px', width: '100px' },
            onCheck: toggleAllDirect
          })
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'hint--top',
            'aria-label': 'Indirect Messages are notifications that are sent as another user on your account has received a direct message'
          },
          _react2.default.createElement(_materialUi.Checkbox, {
            label: 'Indirect Messages',
            labelPosition: 'left',
            checked: allIndirectChecked,
            labelStyle: { fontSize: '12px', width: '110px' },
            style: { marginLeft: '12px' },
            trackStyle: allIndirectChecked ? {} : { backgroundColor: '#ff9d9d' },
            onCheck: toggleAllIndirect
          })
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { style: isSubmenu ? { marginLeft: '30px', borderTop: '1px solid #e6e9ec' } : { margin: '0 30px' } },
      settings.map(function (setting, i) {
        // some fields' values are array: ['email'], weekly fields' value will be boolean
        if (setting.settings) {
          return _react2.default.createElement(Template, {
            key: i,
            updateNotification: updateNotification,
            notifications: notifications,
            settings: setting.settings,
            label: setting.label,
            assetReceiving: setting.assetReceiving,
            isSubmenu: true
          });
        }
        var value = _ramda2.default.path([setting.type, setting.key], notifications);
        var arrayValue = value || [];
        var isDirectChecked = !_ramda2.default.contains('noDirect', value || []);
        var isChecked = setting.isBool ? Boolean(value) : _ramda2.default.contains('email', arrayValue);
        return _react2.default.createElement(
          'div',
          { key: i, style: { borderBottom: '1px solid #e6e9ec', padding: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' } },
          _react2.default.createElement(
            'div',
            { style: setting.disabled ? { color: 'rgba(0, 0, 0, 0.24)' } : {} },
            setting.text
          ),
          _react2.default.createElement(
            'div',
            { className: 'hint--top', 'aria-label': function () {
                if (setting.disabled) return 'This setting is disabled';
                return isChecked ? 'Turn off email notification' : 'Turn on email notification';
              }() },
            _ramda2.default.call(_ramda2.default.cond([[function () {
              return Boolean(setting.disabled);
            }, _ramda2.default.always(_react2.default.createElement(_materialUi.Toggle, { disabled: true }))], [function () {
              return assetReceiving;
            }, _ramda2.default.always(_react2.default.createElement(
              'div',
              { className: 'flex-center' },
              _react2.default.createElement(_materialUi.Toggle, {
                label: 'Direct Messages',
                labelStyle: { fontSize: '12px', width: '100px', visibility: 'hidden' },
                toggled: isDirectChecked,
                thumbStyle: isDirectChecked ? {} : { backgroundColor: '#ffcccc' },
                trackStyle: isDirectChecked ? {} : { backgroundColor: '#ff9d9d' },
                onToggle: function onToggle() {
                  if (setting.isBool) updateNotification(setting.type, _defineProperty({}, setting.key, !isDirectChecked));else {
                    updateNotification(setting.type, _defineProperty({}, setting.key, isDirectChecked ? [].concat(_toConsumableArray(arrayValue), ['noDirect']) : arrayValue.filter(function (x) {
                      return x !== 'noDirect';
                    })));
                  }
                }
              }),
              _react2.default.createElement(_materialUi.Toggle, {
                label: 'Indirect Messages',
                labelStyle: { fontSize: '12px', width: '110px', visibility: 'hidden' },
                style: { marginLeft: '12px' },
                toggled: isChecked,
                thumbStyle: isChecked ? {} : { backgroundColor: '#ffcccc' },
                trackStyle: isChecked ? {} : { backgroundColor: '#ff9d9d' },
                onToggle: function onToggle() {
                  if (setting.isBool) updateNotification(setting.type, _defineProperty({}, setting.key, !isChecked));else {
                    updateNotification(setting.type, _defineProperty({}, setting.key, isChecked ? arrayValue.filter(function (x) {
                      return x !== 'email';
                    }) : [].concat(_toConsumableArray(arrayValue), ['email'])));
                  }
                }
              })
            ))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(_materialUi.Toggle, {
              toggled: isChecked,
              thumbStyle: isChecked ? {} : { backgroundColor: '#ffcccc' },
              trackStyle: isChecked ? {} : { backgroundColor: '#ff9d9d' },
              onToggle: function onToggle() {
                if (setting.isBool) updateNotification(setting.type, _defineProperty({}, setting.key, !isChecked));else updateNotification(setting.type, _defineProperty({}, setting.key, isChecked ? [] : ['email']));
              }
            }))]]))
          )
        );
      })
    )
  );
};

Template.propTypes = {
  updateNotification: _react.PropTypes.func,
  notifications: _react.PropTypes.object,
  label: _react.PropTypes.string,
  settings: _react.PropTypes.array,
  type: _react.PropTypes.string,
  isSubmenu: _react.PropTypes.bool,
  assetReceiving: _react.PropTypes.bool,
  allDirectChecked: _react.PropTypes.bool,
  allIndirectChecked: _react.PropTypes.bool,
  toggleAllDirect: _react.PropTypes.func,
  toggleAllIndirect: _react.PropTypes.func
};

exports.default = Template;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var acctSettings = {
  type: 'accountSettingsNotifications',
  label: 'Account',
  settings: [{ text: 'Confirm Associated Email', key: 'confirmSecondaryEmail', disabled: true }, { text: 'Reset Password', key: 'resetPassword', disabled: true }, { text: 'New User Request', key: 'newUserRequest', disabled: true }]
};

var activity = {
  type: 'activityNotifications',
  label: 'Activity',
  settings: [{ text: 'Shared Marketing Materials', key: 'sharedMM' }]
};

var onlineNotifications = {
  label: 'Online/Offline',
  settings: [{
    text: 'Receive email notifications when my company is online',
    key: 'alwaysOffline',
    disabled: false,
    isBool: true,
    type: 'emailNotifications'
  }, {
    text: 'Receive out of office reply notifications',
    key: 'outOfOfficeReplies',
    disabled: false,
    isBool: true,
    type: 'outOfOffice'
  }]
};

var opts = function opts(isPaidUser, companyType, hasContractingAccess) {
  var system = {
    label: 'System Generated Email Notifications',
    settings: [{
      text: 'Monthly Digest',
      key: 'digest',
      isBool: true,
      type: 'weekly'
    }, {
      text: 'Weekly Partner Request Reminder',
      key: 'connectionReminder',
      isBool: true,
      type: 'weekly'
    }, { text: 'New Company Sign Ups', key: 'newCompLocReady', disabled: !isPaidUser, type: 'connectionsNotifications' }, { text: 'Accepted Partner Request', key: 'accepted', type: 'connectionsNotifications' }, { text: 'New Partner Request', key: 'request', type: 'connectionsNotifications' }]
  };

  var contractingSupplier = [{ text: 'New Contract Request', key: 'request', disabled: !hasContractingAccess, type: 'contractingNotifications' }, { text: 'Contract Status Changes', key: 'statusChange', disabled: !hasContractingAccess, type: 'contractingNotifications' }, { text: 'New Messages', key: 'newMessage', disabled: !hasContractingAccess, type: 'contractingNotifications' }];
  var contractingBuyer = [{ text: 'New Contract', key: 'request', disabled: !hasContractingAccess, type: 'contractingNotifications' }, { text: 'Contract Updates', key: 'updates', disabled: !hasContractingAccess, type: 'contractingNotifications' }, { text: 'New Messages', key: 'newMessage', disabled: !hasContractingAccess, type: 'contractingNotifications' }];

  var assetReceiving = {
    label: 'Email Message',
    assetReceiving: true,
    settings: [{ text: 'General message', key: 'message', disabled: false, type: 'workspaceNotifications' }, { text: 'Marketing Materials', key: 'sharedMM', disabled: false, type: 'activityNotifications' }, {
      label: 'Contracting',
      assetReceiving: true,
      settings: companyType === 'Supplier' ? contractingSupplier : contractingBuyer
    }]
  };
  return [onlineNotifications, system, assetReceiving];
};

// pass in T || F for all fields
// export const options = (onTc, isPaidUser, hasContractingAccess) =>
// onTc ? R.prepend(acctSettings, opts(onTc, isPaidUser, hasContractingAccess)) : opts(onTc);
var options = exports.options = function options(onTc, isPaidUser, companyType, hasContractingAccess) {
  return onTc ? opts(isPaidUser, companyType, hasContractingAccess) : [workspace, {
    type: 'connections',
    label: 'Connections',
    settings: [{ text: 'New Connection Request', key: 'request' }]
  }];
};

// external notifications
var defaultAllChecked = exports.defaultAllChecked = {
  activity: { sharedMM: ['email'] },
  connections: { request: ['email'] },
  workspace: { mesage: ['email'], bulkmessage: ['email'] },
  contracting: { newMessage: ['email'], updates: ['email'] }
};

var unsubscribeAll = exports.unsubscribeAll = {
  activity: { sharedMM: [] },
  connections: { request: [] },
  workspace: { message: [], bulkmessage: [] },
  contracting: { newMessage: [], updates: [] }
};

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactGridGallery = __webpack_require__(1569);

var _reactGridGallery2 = _interopRequireDefault(_reactGridGallery);

var _removeFile2 = __webpack_require__(739);

var _removeFile3 = _interopRequireDefault(_removeFile2);

var _fileName = __webpack_require__(740);

var _fileName2 = _interopRequireDefault(_fileName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePreview = function ImagePreview(props) {
  var src = props.src,
      thumbnail = props.thumbnail,
      thumbnailWidth = props.thumbnailWidth,
      thumbnailHeight = props.thumbnailHeight,
      _removeFile = props.removeFile,
      fileName = props.fileName,
      showFileName = props.showFileName,
      openGallery = props.openGallery,
      showGallery = props.showGallery,
      onlyOneImage = props.onlyOneImage;


  return _react2.default.createElement(
    'div',
    { style: { overflow: 'hidden', display: 'inline-block', width: onlyOneImage ? '475px' : '200px', height: '100%', position: 'relative' } },
    _react2.default.createElement(
      'div',
      { onTouchTap: showGallery && openGallery },
      _react2.default.createElement(_reactGridGallery2.default, {
        images: [{
          src: src,
          thumbnail: thumbnail,
          thumbnailWidth: thumbnailWidth,
          thumbnailHeight: thumbnailHeight
        }],
        enableImageSelection: false,
        rowHeight: onlyOneImage ? 300 : 120,
        backdropClosesModal: true,
        enableLightbox: false,
        thumbnailStyle: function thumbnailStyle() {
          return { cursor: showGallery ? 'pointer' : 'default', width: '100%', height: null, marginLeft: 0 };
        }
      }),
      showFileName && _react2.default.createElement(_fileName2.default, { fileName: fileName })
    ),
    _removeFile && _react2.default.createElement(_removeFile3.default, { removeFile: function removeFile() {
        return _removeFile(src);
      } })
  );
};

ImagePreview.propTypes = {
  thumbnailWidth: _react.PropTypes.number,
  thumbnailHeight: _react.PropTypes.number,
  src: _react.PropTypes.string,
  removeFile: _react.PropTypes.func,
  thumbnail: _react.PropTypes.string,
  fileName: _react.PropTypes.string,
  showFileName: _react.PropTypes.bool,
  openGallery: _react.PropTypes.func,
  showGallery: _react.PropTypes.bool,
  onlyOneImage: _react.PropTypes.bool
};

exports.default = ImagePreview;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactImages = __webpack_require__(1570);

var _reactImages2 = _interopRequireDefault(_reactImages);

var _Image = __webpack_require__(1600);

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Gallery = function (_Component) {
    _inherits(Gallery, _Component);

    function Gallery(props) {
        _classCallCheck(this, Gallery);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Gallery).call(this, props));

        _this.state = {
            images: _this.props.images,
            thumbnails: [],
            lightboxIsOpen: _this.props.isOpen,
            currentImage: _this.props.currentImage,
            containerWidth: 0
        };

        _this.onResize = _this.onResize.bind(_this);
        _this.closeLightbox = _this.closeLightbox.bind(_this);
        _this.gotoImage = _this.gotoImage.bind(_this);
        _this.gotoNext = _this.gotoNext.bind(_this);
        _this.gotoPrevious = _this.gotoPrevious.bind(_this);
        _this.onClickImage = _this.onClickImage.bind(_this);
        _this.openLightbox = _this.openLightbox.bind(_this);
        _this.onSelectImage = _this.onSelectImage.bind(_this);
        return _this;
    }

    _createClass(Gallery, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.onResize();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(np) {
            if (this.state.images != np.images || this.props.maxRows != np.maxRows) {
                this.setState({
                    images: np.images,
                    thumbnails: this.renderThumbs(this._gallery.clientWidth, np.images)
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!this._gallery) return;
            if (this._gallery.clientWidth !== this.state.containerWidth) {
                this.onResize();
            }
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            if (!this._gallery) return;
            this.setState({
                containerWidth: Math.floor(this._gallery.clientWidth),
                thumbnails: this.renderThumbs(this._gallery.clientWidth)
            });
        }
    }, {
        key: 'openLightbox',
        value: function openLightbox(index, event) {
            if (event) {
                event.preventDefault();
            }
            if (this.props.lightboxWillOpen) {
                this.props.lightboxWillOpen.call(this, index);
            }

            this.setState({
                currentImage: index,
                lightboxIsOpen: true
            });
        }
    }, {
        key: 'closeLightbox',
        value: function closeLightbox() {
            if (this.props.lightboxWillClose) {
                this.props.lightboxWillClose.call(this);
            }

            this.setState({
                currentImage: 0,
                lightboxIsOpen: false
            });
        }
    }, {
        key: 'gotoPrevious',
        value: function gotoPrevious() {
            this.setState({
                currentImage: this.state.currentImage - 1
            });
        }
    }, {
        key: 'gotoNext',
        value: function gotoNext() {
            this.setState({
                currentImage: this.state.currentImage + 1
            });
        }
    }, {
        key: 'onClickImage',
        value: function onClickImage() {
            if (this.state.currentImage === this.props.images.length - 1) return;
            this.gotoNext();
        }
    }, {
        key: 'onSelectImage',
        value: function onSelectImage(index, event) {
            event.preventDefault();
            if (this.props.onSelectImage) this.props.onSelectImage.call(this, index, this.state.images[index]);
        }
    }, {
        key: 'gotoImage',
        value: function gotoImage(index) {
            this.setState({
                currentImage: index
            });
        }
    }, {
        key: 'getOnClickThumbnailFn',
        value: function getOnClickThumbnailFn() {
            if (!this.props.onClickThumbnail && this.props.enableLightbox) return this.openLightbox;
            if (this.props.onClickThumbnail) return this.props.onClickThumbnail;
            return null;
        }
    }, {
        key: 'getOnClickLightboxThumbnailFn',
        value: function getOnClickLightboxThumbnailFn() {
            if (!this.props.onClickLightboxThumbnail && this.props.showLightboxThumbnails) return this.gotoImage;
            if (this.props.onClickLightboxThumbnail && this.props.showLightboxThumbnails) return this.props.onClickLightboxThumbnail;
            return null;
        }
    }, {
        key: 'getOnClickImageFn',
        value: function getOnClickImageFn() {
            if (this.props.onClickImage) return this.props.onClickImage;
            return this.onClickImage;
        }
    }, {
        key: 'getOnClickPrevFn',
        value: function getOnClickPrevFn() {
            if (this.props.onClickPrev) return this.props.onClickPrev;
            return this.gotoPrevious;
        }
    }, {
        key: 'getOnClickNextFn',
        value: function getOnClickNextFn() {
            if (this.props.onClickNext) return this.props.onClickNext;
            return this.gotoNext;
        }
    }, {
        key: 'calculateCutOff',
        value: function calculateCutOff(len, delta, items) {
            var cutoff = [];
            var cutsum = 0;
            for (var i in items) {
                var item = items[i];
                var fractOfLen = item.scaletwidth / len;
                cutoff[i] = Math.floor(fractOfLen * delta);
                cutsum += cutoff[i];
            }

            var stillToCutOff = delta - cutsum;
            while (stillToCutOff > 0) {
                for (i in cutoff) {
                    cutoff[i]++;
                    stillToCutOff--;
                    if (stillToCutOff < 0) break;
                }
            }
            return cutoff;
        }
    }, {
        key: 'buildImageRow',
        value: function buildImageRow(items, containerWidth) {
            var row = [];
            var len = 0;
            var imgMargin = 2 * this.props.margin;
            while (items.length > 0 && len < containerWidth) {
                var item = items.shift();
                row.push(item);
                len += item.scaletwidth + imgMargin;
            }

            var delta = len - containerWidth;
            if (row.length > 0 && delta > 0) {
                var cutoff = this.calculateCutOff(len, delta, row);
                for (var i in row) {
                    var pixelsToRemove = cutoff[i];
                    item = row[i];
                    item.marginLeft = -Math.abs(Math.floor(pixelsToRemove / 2));
                    item.vwidth = item.scaletwidth - pixelsToRemove;
                }
            } else {
                for (var j in row) {
                    item = row[j];
                    item.marginLeft = 0;
                    item.vwidth = item.scaletwidth;
                }
            }
            return row;
        }
    }, {
        key: 'setThumbScale',
        value: function setThumbScale(item) {
            item.scaletwidth = Math.floor(this.props.rowHeight * (item.thumbnailWidth / item.thumbnailHeight));
        }
    }, {
        key: 'renderThumbs',
        value: function renderThumbs(containerWidth) {
            var images = arguments.length <= 1 || arguments[1] === undefined ? this.state.images : arguments[1];

            if (!images) return [];
            if (containerWidth == 0) return [];

            var items = images.slice();
            for (var t in items) {
                this.setThumbScale(items[t]);
            }

            var thumbs = [];
            var rows = [];
            while (items.length > 0) {
                rows.push(this.buildImageRow(items, containerWidth));
            }

            for (var r in rows) {
                for (var i in rows[r]) {
                    var item = rows[r][i];
                    if (this.props.maxRows) {
                        if (r < this.props.maxRows) {
                            thumbs.push(item);
                        }
                    } else {
                        thumbs.push(item);
                    }
                }
            }
            return thumbs;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var images = this.state.thumbnails.map(function (item, idx) {
                return _react2.default.createElement(_Image2.default, {
                    key: "Image-" + idx + "-" + item.src,
                    item: item,
                    index: idx,
                    margin: _this2.props.margin,
                    height: _this2.props.rowHeight,
                    isSelectable: _this2.props.enableImageSelection,
                    onClick: _this2.getOnClickThumbnailFn(),
                    onSelectImage: _this2.onSelectImage,
                    tagStyle: _this2.props.tagStyle,
                    tileViewportStyle: _this2.props.tileViewportStyle,
                    thumbnailStyle: _this2.props.thumbnailStyle
                });
            });
            var resizeIframeStyles = {
                height: 0,
                margin: 0,
                padding: 0,
                overflow: "hidden",
                borderWidth: 0,
                position: "fixed",
                backgroundColor: "transparent",
                width: "100%"
            };
            return _react2.default.createElement(
                'div',
                { id: this.props.id, className: 'ReactGridGallery', ref: function ref(c) {
                        return _this2._gallery = c;
                    } },
                _react2.default.createElement('iframe', { style: resizeIframeStyles, ref: function ref(c) {
                        return c && c.contentWindow.addEventListener('resize', _this2.onResize);
                    } }),
                images,
                _react2.default.createElement(_reactImages2.default, {
                    images: this.props.images,
                    backdropClosesModal: this.props.backdropClosesModal,
                    currentImage: this.state.currentImage,
                    customControls: this.props.customControls,
                    enableKeyboardInput: this.props.enableKeyboardInput,
                    imageCountSeparator: this.props.imageCountSeparator,
                    isOpen: this.state.lightboxIsOpen,
                    onClickImage: this.getOnClickImageFn(),
                    onClickNext: this.getOnClickNextFn(),
                    onClickPrev: this.getOnClickPrevFn(),
                    showCloseButton: this.props.showCloseButton,
                    showImageCount: this.props.showImageCount,
                    onClose: this.closeLightbox,
                    width: this.props.lightboxWidth,
                    theme: this.props.theme,
                    onClickThumbnail: this.getOnClickLightboxThumbnailFn(),
                    showThumbnails: this.props.showLightboxThumbnails
                })
            );
        }
    }]);

    return Gallery;
}(_react.Component);

Gallery.displayName = 'Gallery';

Gallery.propTypes = {
    images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        src: _propTypes2.default.string.isRequired,
        thumbnail: _propTypes2.default.string.isRequired,
        srcset: _propTypes2.default.array,
        caption: _propTypes2.default.string,
        tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            value: _propTypes2.default.string.isRequired,
            title: _propTypes2.default.string.isRequired
        })),
        thumbnailWidth: _propTypes2.default.number.isRequired,
        thumbnailHeight: _propTypes2.default.number.isRequired,
        isSelected: _propTypes2.default.bool
    })).isRequired,
    id: _propTypes2.default.string,
    enableImageSelection: _propTypes2.default.bool,
    onSelectImage: _propTypes2.default.func,
    rowHeight: _propTypes2.default.number,
    maxRows: _propTypes2.default.number,
    margin: _propTypes2.default.number,
    onClickThumbnail: _propTypes2.default.func,
    lightboxWillOpen: _propTypes2.default.func,
    lightboxWillClose: _propTypes2.default.func,
    enableLightbox: _propTypes2.default.bool,
    backdropClosesModal: _propTypes2.default.bool,
    currentImage: _propTypes2.default.number,
    preloadNextImage: _propTypes2.default.bool,
    customControls: _propTypes2.default.arrayOf(_propTypes2.default.node),
    enableKeyboardInput: _propTypes2.default.bool,
    imageCountSeparator: _propTypes2.default.string,
    isOpen: _propTypes2.default.bool,
    onClickImage: _propTypes2.default.func,
    onClickNext: _propTypes2.default.func,
    onClickPrev: _propTypes2.default.func,
    onClose: _propTypes2.default.func,
    showCloseButton: _propTypes2.default.bool,
    showImageCount: _propTypes2.default.bool,
    lightboxWidth: _propTypes2.default.number,
    tileViewportStyle: _propTypes2.default.func,
    thumbnailStyle: _propTypes2.default.func,
    showLightboxThumbnails: _propTypes2.default.bool,
    onClickLightboxThumbnail: _propTypes2.default.func,
    tagStyle: _propTypes2.default.object
};

Gallery.defaultProps = {
    id: "ReactGridGallery",
    enableImageSelection: true,
    rowHeight: 180,
    margin: 2,
    enableLightbox: true,
    backdropClosesModal: false,
    currentImage: 0,
    preloadNextImage: true,
    enableKeyboardInput: true,
    imageCountSeparator: ' of ',
    isOpen: false,
    showCloseButton: true,
    showImageCount: true,
    lightboxWidth: 1024,
    showLightboxThumbnails: false
};

module.exports = Gallery;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(126);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _aphrodite = __webpack_require__(123);

var _reactScrolllock = __webpack_require__(1573);

var _reactScrolllock2 = _interopRequireDefault(_reactScrolllock);

var _theme = __webpack_require__(496);

var _theme2 = _interopRequireDefault(_theme);

var _Arrow = __webpack_require__(1146);

var _Arrow2 = _interopRequireDefault(_Arrow);

var _Container = __webpack_require__(1582);

var _Container2 = _interopRequireDefault(_Container);

var _Footer = __webpack_require__(1583);

var _Footer2 = _interopRequireDefault(_Footer);

var _Header = __webpack_require__(1584);

var _Header2 = _interopRequireDefault(_Header);

var _PaginatedThumbnails = __webpack_require__(1585);

var _PaginatedThumbnails2 = _interopRequireDefault(_PaginatedThumbnails);

var _Portal = __webpack_require__(1587);

var _Portal2 = _interopRequireDefault(_Portal);

var _Spinner = __webpack_require__(1597);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _bindFunctions = __webpack_require__(1598);

var _bindFunctions2 = _interopRequireDefault(_bindFunctions);

var _canUseDom = __webpack_require__(1599);

var _canUseDom2 = _interopRequireDefault(_canUseDom);

var _deepMerge = __webpack_require__(552);

var _deepMerge2 = _interopRequireDefault(_deepMerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// consumers sometimes provide incorrect type or casing
function normalizeSourceSet(data) {
	var sourceSet = data.srcSet || data.srcset;

	if (Array.isArray(sourceSet)) {
		return sourceSet.join();
	}

	return sourceSet;
}

var Lightbox = function (_Component) {
	_inherits(Lightbox, _Component);

	function Lightbox(props) {
		_classCallCheck(this, Lightbox);

		var _this = _possibleConstructorReturn(this, (Lightbox.__proto__ || Object.getPrototypeOf(Lightbox)).call(this, props));

		_this.theme = (0, _deepMerge2.default)(_theme2.default, props.theme);
		_this.classes = _aphrodite.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, _this.theme));
		_this.state = { imageLoaded: false };

		_bindFunctions2.default.call(_this, ['gotoNext', 'gotoPrev', 'closeBackdrop', 'handleKeyboardInput', 'handleImageLoaded']);
		return _this;
	}

	_createClass(Lightbox, [{
		key: 'getChildContext',
		value: function getChildContext() {
			return {
				theme: this.theme
			};
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.isOpen) {
				if (this.props.enableKeyboardInput) {
					window.addEventListener('keydown', this.handleKeyboardInput);
				}
				if (typeof this.props.currentImage === 'number') {
					this.preloadImage(this.props.currentImage, this.handleImageLoaded);
				}
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (!_canUseDom2.default) return;

			// preload images
			if (nextProps.preloadNextImage) {
				var currentIndex = this.props.currentImage;
				var nextIndex = nextProps.currentImage + 1;
				var prevIndex = nextProps.currentImage - 1;
				var preloadIndex = void 0;

				if (currentIndex && nextProps.currentImage > currentIndex) {
					preloadIndex = nextIndex;
				} else if (currentIndex && nextProps.currentImage < currentIndex) {
					preloadIndex = prevIndex;
				}

				// if we know the user's direction just get one image
				// otherwise, to be safe, we need to grab one in each direction
				if (preloadIndex) {
					this.preloadImage(preloadIndex);
				} else {
					this.preloadImage(prevIndex);
					this.preloadImage(nextIndex);
				}
			}

			// preload current image
			if (this.props.currentImage !== nextProps.currentImage || !this.props.isOpen && nextProps.isOpen) {
				var img = this.preloadImageData(nextProps.images[nextProps.currentImage], this.handleImageLoaded);
				if (img) this.setState({ imageLoaded: img.complete });
			}

			// add/remove event listeners
			if (!this.props.isOpen && nextProps.isOpen && nextProps.enableKeyboardInput) {
				window.addEventListener('keydown', this.handleKeyboardInput);
			}
			if (!nextProps.isOpen && nextProps.enableKeyboardInput) {
				window.removeEventListener('keydown', this.handleKeyboardInput);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.props.enableKeyboardInput) {
				window.removeEventListener('keydown', this.handleKeyboardInput);
			}
		}

		// ==============================
		// METHODS
		// ==============================

	}, {
		key: 'preloadImage',
		value: function preloadImage(idx, onload) {
			return this.preloadImageData(this.props.images[idx], onload);
		}
	}, {
		key: 'preloadImageData',
		value: function preloadImageData(data, onload) {
			if (!data) return;
			var img = new Image();
			var sourceSet = normalizeSourceSet(data);

			// TODO: add error handling for missing images
			img.onerror = onload;
			img.onload = onload;
			img.src = data.src;

			if (sourceSet) img.srcset = sourceSet;

			return img;
		}
	}, {
		key: 'gotoNext',
		value: function gotoNext(event) {
			var _props = this.props,
			    currentImage = _props.currentImage,
			    images = _props.images;
			var imageLoaded = this.state.imageLoaded;


			if (!imageLoaded || currentImage === images.length - 1) return;

			if (event) {
				event.preventDefault();
				event.stopPropagation();
			}

			this.props.onClickNext();
		}
	}, {
		key: 'gotoPrev',
		value: function gotoPrev(event) {
			var currentImage = this.props.currentImage;
			var imageLoaded = this.state.imageLoaded;


			if (!imageLoaded || currentImage === 0) return;

			if (event) {
				event.preventDefault();
				event.stopPropagation();
			}

			this.props.onClickPrev();
		}
	}, {
		key: 'closeBackdrop',
		value: function closeBackdrop(event) {
			// make sure event only happens if they click the backdrop
			// and if the caption is widening the figure element let that respond too
			if (event.target.id === 'lightboxBackdrop' || event.target.tagName === 'FIGURE') {
				this.props.onClose();
			}
		}
	}, {
		key: 'handleKeyboardInput',
		value: function handleKeyboardInput(event) {
			if (event.keyCode === 37) {
				// left
				this.gotoPrev(event);
				return true;
			} else if (event.keyCode === 39) {
				// right
				this.gotoNext(event);
				return true;
			} else if (event.keyCode === 27) {
				// esc
				this.props.onClose();
				return true;
			}
			return false;
		}
	}, {
		key: 'handleImageLoaded',
		value: function handleImageLoaded() {
			this.setState({ imageLoaded: true });
		}

		// ==============================
		// RENDERERS
		// ==============================

	}, {
		key: 'renderArrowPrev',
		value: function renderArrowPrev() {
			if (this.props.currentImage === 0) return null;

			return _react2.default.createElement(_Arrow2.default, {
				direction: 'left',
				icon: 'arrowLeft',
				onClick: this.gotoPrev,
				title: this.props.leftArrowTitle,
				type: 'button'
			});
		}
	}, {
		key: 'renderArrowNext',
		value: function renderArrowNext() {
			if (this.props.currentImage === this.props.images.length - 1) return null;

			return _react2.default.createElement(_Arrow2.default, {
				direction: 'right',
				icon: 'arrowRight',
				onClick: this.gotoNext,
				title: this.props.rightArrowTitle,
				type: 'button'
			});
		}
	}, {
		key: 'renderDialog',
		value: function renderDialog() {
			var _props2 = this.props,
			    backdropClosesModal = _props2.backdropClosesModal,
			    isOpen = _props2.isOpen,
			    showThumbnails = _props2.showThumbnails,
			    width = _props2.width;
			var imageLoaded = this.state.imageLoaded;


			if (!isOpen) return _react2.default.createElement('span', { key: 'closed' });

			var offsetThumbnails = 0;
			if (showThumbnails) {
				offsetThumbnails = this.theme.thumbnail.size + this.theme.container.gutter.vertical;
			}

			return _react2.default.createElement(
				_Container2.default,
				{
					key: 'open',
					onClick: backdropClosesModal && this.closeBackdrop,
					onTouchEnd: backdropClosesModal && this.closeBackdrop
				},
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: (0, _aphrodite.css)(this.classes.content), style: { marginBottom: offsetThumbnails, maxWidth: width } },
						imageLoaded && this.renderHeader(),
						this.renderImages(),
						this.renderSpinner(),
						imageLoaded && this.renderFooter()
					),
					imageLoaded && this.renderThumbnails(),
					imageLoaded && this.renderArrowPrev(),
					imageLoaded && this.renderArrowNext(),
					this.props.preventScroll && _react2.default.createElement(_reactScrolllock2.default, null)
				)
			);
		}
	}, {
		key: 'renderImages',
		value: function renderImages() {
			var _props3 = this.props,
			    currentImage = _props3.currentImage,
			    images = _props3.images,
			    onClickImage = _props3.onClickImage,
			    showThumbnails = _props3.showThumbnails;
			var imageLoaded = this.state.imageLoaded;


			if (!images || !images.length) return null;

			var image = images[currentImage];
			var sourceSet = normalizeSourceSet(image);
			var sizes = sourceSet ? '100vw' : null;

			var thumbnailsSize = showThumbnails ? this.theme.thumbnail.size : 0;
			var heightOffset = this.theme.header.height + this.theme.footer.height + thumbnailsSize + this.theme.container.gutter.vertical + 'px';

			return _react2.default.createElement(
				'figure',
				{ className: (0, _aphrodite.css)(this.classes.figure) },
				_react2.default.createElement('img', {
					className: (0, _aphrodite.css)(this.classes.image, imageLoaded && this.classes.imageLoaded),
					onClick: onClickImage,
					sizes: sizes,
					alt: image.alt,
					src: image.src,
					srcSet: sourceSet,
					style: {
						cursor: onClickImage ? 'pointer' : 'auto',
						maxHeight: 'calc(100vh - ' + heightOffset + ')'
					}
				})
			);
		}
	}, {
		key: 'renderThumbnails',
		value: function renderThumbnails() {
			var _props4 = this.props,
			    images = _props4.images,
			    currentImage = _props4.currentImage,
			    onClickThumbnail = _props4.onClickThumbnail,
			    showThumbnails = _props4.showThumbnails,
			    thumbnailOffset = _props4.thumbnailOffset;


			if (!showThumbnails) return;

			return _react2.default.createElement(_PaginatedThumbnails2.default, {
				currentImage: currentImage,
				images: images,
				offset: thumbnailOffset,
				onClickThumbnail: onClickThumbnail
			});
		}
	}, {
		key: 'renderHeader',
		value: function renderHeader() {
			var _props5 = this.props,
			    closeButtonTitle = _props5.closeButtonTitle,
			    customControls = _props5.customControls,
			    onClose = _props5.onClose,
			    showCloseButton = _props5.showCloseButton;


			return _react2.default.createElement(_Header2.default, {
				customControls: customControls,
				onClose: onClose,
				showCloseButton: showCloseButton,
				closeButtonTitle: closeButtonTitle
			});
		}
	}, {
		key: 'renderFooter',
		value: function renderFooter() {
			var _props6 = this.props,
			    currentImage = _props6.currentImage,
			    images = _props6.images,
			    imageCountSeparator = _props6.imageCountSeparator,
			    showImageCount = _props6.showImageCount;


			if (!images || !images.length) return null;

			return _react2.default.createElement(_Footer2.default, {
				caption: images[currentImage].caption,
				countCurrent: currentImage + 1,
				countSeparator: imageCountSeparator,
				countTotal: images.length,
				showCount: showImageCount
			});
		}
	}, {
		key: 'renderSpinner',
		value: function renderSpinner() {
			var _props7 = this.props,
			    spinner = _props7.spinner,
			    spinnerColor = _props7.spinnerColor,
			    spinnerSize = _props7.spinnerSize;
			var imageLoaded = this.state.imageLoaded;

			var Spinner = spinner;

			return _react2.default.createElement(
				'div',
				{ className: (0, _aphrodite.css)(this.classes.spinner, !imageLoaded && this.classes.spinnerActive) },
				_react2.default.createElement(Spinner, {
					color: spinnerColor,
					size: spinnerSize
				})
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				_Portal2.default,
				null,
				this.renderDialog()
			);
		}
	}]);

	return Lightbox;
}(_react.Component);

Lightbox.propTypes = {
	backdropClosesModal: _propTypes2.default.bool,
	closeButtonTitle: _propTypes2.default.string,
	currentImage: _propTypes2.default.number,
	customControls: _propTypes2.default.arrayOf(_propTypes2.default.node),
	enableKeyboardInput: _propTypes2.default.bool,
	imageCountSeparator: _propTypes2.default.string,
	images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		src: _propTypes2.default.string.isRequired,
		srcSet: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
		caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
		thumbnail: _propTypes2.default.string
	})).isRequired,
	isOpen: _propTypes2.default.bool,
	leftArrowTitle: _propTypes2.default.string,
	onClickImage: _propTypes2.default.func,
	onClickNext: _propTypes2.default.func,
	onClickPrev: _propTypes2.default.func,
	onClose: _propTypes2.default.func.isRequired,
	preloadNextImage: _propTypes2.default.bool,
	preventScroll: _propTypes2.default.bool,
	rightArrowTitle: _propTypes2.default.string,
	showCloseButton: _propTypes2.default.bool,
	showImageCount: _propTypes2.default.bool,
	showThumbnails: _propTypes2.default.bool,
	spinner: _propTypes2.default.func,
	spinnerColor: _propTypes2.default.string,
	spinnerSize: _propTypes2.default.number,
	theme: _propTypes2.default.object,
	thumbnailOffset: _propTypes2.default.number,
	width: _propTypes2.default.number
};
Lightbox.defaultProps = {
	closeButtonTitle: 'Close (Esc)',
	currentImage: 0,
	enableKeyboardInput: true,
	imageCountSeparator: ' of ',
	leftArrowTitle: 'Previous (Left arrow key)',
	onClickShowNextImage: true,
	preloadNextImage: true,
	preventScroll: true,
	rightArrowTitle: 'Next (Right arrow key)',
	showCloseButton: true,
	showImageCount: true,
	spinner: _Spinner2.default,
	spinnerColor: 'white',
	spinnerSize: 100,
	theme: {},
	thumbnailOffset: 2,
	width: 1024
};
Lightbox.childContextTypes = {
	theme: _propTypes2.default.object.isRequired
};

var defaultStyles = {
	content: {
		position: 'relative'
	},
	figure: {
		margin: 0 // remove browser default
	},
	image: {
		display: 'block', // removes browser default gutter
		height: 'auto',
		margin: '0 auto', // maintain center on very short screens OR very narrow image
		maxWidth: '100%',

		// disable user select
		WebkitTouchCallout: 'none',
		userSelect: 'none',

		// opacity animation on image load
		opacity: 0,
		transition: 'opacity 0.3s'
	},
	imageLoaded: {
		opacity: 1
	},
	spinner: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',

		// opacity animation to make spinner appear with delay
		opacity: 0,
		transition: 'opacity 0.3s',
		pointerEvents: 'none'
	},
	spinnerActive: {
		opacity: 1
	}
};

exports.default = Lightbox;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1572);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollLock = __webpack_require__(1574);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScrollLock).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(1060);

var _reactPropToggle = __webpack_require__(1575);

var _utils = __webpack_require__(1145);

var _withTouchListeners = __webpack_require__(1577);

var _withTouchListeners2 = _interopRequireDefault(_withTouchListeners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LOCK_COUNT = 0;

var ScrollLock = function (_PureComponent) {
  _inherits(ScrollLock, _PureComponent);

  function ScrollLock() {
    _classCallCheck(this, ScrollLock);

    return _possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
  }

  _createClass(ScrollLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      LOCK_COUNT++;
      if (_exenv.canUseDOM) {
        this.initialHeight = window.innerHeight;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      LOCK_COUNT = Math.max(LOCK_COUNT - 1, 0);

      if (_exenv.canUseDOM) {
        var offset = window.innerHeight - this.initialHeight;

        // adjust scroll if the window has been resized since the lock was engaged
        if (offset) {
          window.scrollTo(0, window.pageYOffset + offset);
        }
      }

      // reset the initial height in case this scroll lock is used again
      this.initialHeight = window.innerHeight;
    }
  }, {
    key: 'render',
    value: function render() {
      var accountForScrollbars = this.props.accountForScrollbars;

      // avoid overly incrementing padding

      var scrollbarSpacer = accountForScrollbars && LOCK_COUNT < 1 ? { 'padding-right': (0, _utils.getPadding)() + 'px' } : {};

      var height = (0, _utils.getDocumentHeight)() + 'px';

      return _react2.default.createElement(_reactPropToggle.SimpleToggle, {
        styles: _extends({
          'box-sizing': 'border-box', // account for possible declaration `width: 100%;` on body
          overflow: 'hidden',
          position: 'relative',
          height: height
        }, scrollbarSpacer)
      });
    }
  }]);

  return ScrollLock;
}(_react.PureComponent);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};
exports.default = (0, _withTouchListeners2.default)(ScrollLock);

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LifeCycleProvider = __webpack_require__(1576);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LifeCycleProvider).default;
  }
});

var _PropToggle = __webpack_require__(1144);

Object.defineProperty(exports, 'SimpleToggle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PropToggle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropToggle = __webpack_require__(1144);

var _PropToggle2 = _interopRequireDefault(_PropToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LifeCycleProvider = function LifeCycleProvider(_ref) {
  var isActive = _ref.isActive,
      props = _objectWithoutProperties(_ref, ['isActive']);

  return isActive ? _react2.default.createElement(_PropToggle2.default, props) : null;
};

LifeCycleProvider.defaultProps = _PropToggle.defaultProps;

exports.default = LifeCycleProvider;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withTouchListeners;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(1060);

var _utils = __webpack_require__(1145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withTouchListeners(WrappedComponent) {
  return function (_PureComponent) {
    _inherits(TouchProvider, _PureComponent);

    function TouchProvider() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, TouchProvider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).call.apply(_ref, [this].concat(args))), _this), _this.listenerOptions = {
        capture: false,
        passive: false
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TouchProvider, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!_exenv.canUseDOM) return;

        var touchScrollTarget = this.props.touchScrollTarget;

        var target = document.body;

        // account for touch devices
        if (target && (0, _utils.isTouchDevice)()) {
          // Mobile Safari ignores { overflow: hidden } declaration on the body.
          target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

          // Allow scroll on provided target
          if (touchScrollTarget) {
            touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (!_exenv.canUseDOM) return;

        var touchScrollTarget = this.props.touchScrollTarget;

        var target = document.body;

        // remove touch listeners
        if (target && (0, _utils.isTouchDevice)()) {
          target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

          if (touchScrollTarget) {
            touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      }
    }]);

    return TouchProvider;
  }(_react.PureComponent);
}

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Module with the same interface as the core aphrodite module,
// except that styles injected do not automatically have !important
// appended to them.
//


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _inject = __webpack_require__(1127);

var _indexJs = __webpack_require__(123);

var css = function css() {
    for (var _len = arguments.length, styleDefinitions = Array(_len), _key = 0; _key < _len; _key++) {
        styleDefinitions[_key] = arguments[_key];
    }

    var useImportant = false; // Don't append !important to style definitions
    return (0, _inject.injectAndGetClassName)(useImportant, styleDefinitions);
};

exports.StyleSheet = _indexJs.StyleSheet;
exports.StyleSheetServer = _indexJs.StyleSheetServer;
exports.StyleSheetTestUtils = _indexJs.StyleSheetTestUtils;
exports.css = css;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (fill) {
	return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" xml:space=\"preserve\">\n\t\t<path d=\"M213.7,256L213.7,256L213.7,256L380.9,81.9c4.2-4.3,4.1-11.4-0.2-15.8l-29.9-30.6c-4.3-4.4-11.3-4.5-15.5-0.2L131.1,247.9 c-2.2,2.2-3.2,5.2-3,8.1c-0.1,3,0.9,5.9,3,8.1l204.2,212.7c4.2,4.3,11.2,4.2,15.5-0.2l29.9-30.6c4.3-4.4,4.4-11.5,0.2-15.8 L213.7,256z\"/>\n\t</svg>";
};

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (fill) {
	return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" xml:space=\"preserve\">\n\t\t<path d=\"M298.3,256L298.3,256L298.3,256L131.1,81.9c-4.2-4.3-4.1-11.4,0.2-15.8l29.9-30.6c4.3-4.4,11.3-4.5,15.5-0.2l204.2,212.7 c2.2,2.2,3.2,5.2,3,8.1c0.1,3-0.9,5.9-3,8.1L176.7,476.8c-4.2,4.3-11.2,4.2-15.5-0.2L131.3,446c-4.3-4.4-4.4-11.5-0.2-15.8 L298.3,256z\"/>\n\t</svg>";
};

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (fill) {
	return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\">\n\t\t<path d=\"M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z\"/>\n\t</svg>";
};

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(126);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(497);

var _theme = __webpack_require__(496);

var _theme2 = _interopRequireDefault(_theme);

var _deepMerge = __webpack_require__(552);

var _deepMerge2 = _interopRequireDefault(_deepMerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Container(_ref, _ref2) {
	var theme = _ref2.theme;

	var props = _objectWithoutProperties(_ref, []);

	var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));

	return _react2.default.createElement('div', _extends({ id: 'lightboxBackdrop',
		className: (0, _noImportant.css)(classes.container)
	}, props));
}

Container.contextTypes = {
	theme: _propTypes2.default.object.isRequired
};

var defaultStyles = {
	container: {
		alignItems: 'center',
		backgroundColor: _theme2.default.container.background,
		boxSizing: 'border-box',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		left: 0,
		paddingBottom: _theme2.default.container.gutter.vertical,
		paddingLeft: _theme2.default.container.gutter.horizontal,
		paddingRight: _theme2.default.container.gutter.horizontal,
		paddingTop: _theme2.default.container.gutter.vertical,
		position: 'fixed',
		top: 0,
		width: '100%',
		zIndex: _theme2.default.container.zIndex
	}
};

exports.default = Container;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(126);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(497);

var _theme = __webpack_require__(496);

var _theme2 = _interopRequireDefault(_theme);

var _deepMerge = __webpack_require__(552);

var _deepMerge2 = _interopRequireDefault(_deepMerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Footer(_ref, _ref2) {
	var theme = _ref2.theme;

	var caption = _ref.caption,
	    countCurrent = _ref.countCurrent,
	    countSeparator = _ref.countSeparator,
	    countTotal = _ref.countTotal,
	    showCount = _ref.showCount,
	    props = _objectWithoutProperties(_ref, ['caption', 'countCurrent', 'countSeparator', 'countTotal', 'showCount']);

	if (!caption && !showCount) return null;

	var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));

	var imageCount = showCount ? _react2.default.createElement(
		'div',
		{ className: (0, _noImportant.css)(classes.footerCount) },
		countCurrent,
		countSeparator,
		countTotal
	) : _react2.default.createElement('span', null);

	return _react2.default.createElement(
		'div',
		_extends({ className: (0, _noImportant.css)(classes.footer) }, props),
		caption ? _react2.default.createElement(
			'figcaption',
			{ className: (0, _noImportant.css)(classes.footerCaption) },
			caption
		) : _react2.default.createElement('span', null),
		imageCount
	);
}

Footer.propTypes = {
	caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	countCurrent: _propTypes2.default.number,
	countSeparator: _propTypes2.default.string,
	countTotal: _propTypes2.default.number,
	showCount: _propTypes2.default.bool
};
Footer.contextTypes = {
	theme: _propTypes2.default.object.isRequired
};

var defaultStyles = {
	footer: {
		boxSizing: 'border-box',
		color: _theme2.default.footer.color,
		cursor: 'auto',
		display: 'flex',
		justifyContent: 'space-between',
		left: 0,
		lineHeight: 1.3,
		paddingBottom: _theme2.default.footer.gutter.vertical,
		paddingLeft: _theme2.default.footer.gutter.horizontal,
		paddingRight: _theme2.default.footer.gutter.horizontal,
		paddingTop: _theme2.default.footer.gutter.vertical
	},
	footerCount: {
		color: _theme2.default.footer.count.color,
		fontSize: _theme2.default.footer.count.fontSize,
		paddingLeft: '1em' // add a small gutter for the caption
	},
	footerCaption: {
		flex: '1 1 0'
	}
};

exports.default = Footer;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(126);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(497);

var _theme = __webpack_require__(496);

var _theme2 = _interopRequireDefault(_theme);

var _deepMerge = __webpack_require__(552);

var _deepMerge2 = _interopRequireDefault(_deepMerge);

var _Icon = __webpack_require__(1147);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Header(_ref, _ref2) {
	var theme = _ref2.theme;

	var customControls = _ref.customControls,
	    onClose = _ref.onClose,
	    showCloseButton = _ref.showCloseButton,
	    closeButtonTitle = _ref.closeButtonTitle,
	    props = _objectWithoutProperties(_ref, ['customControls', 'onClose', 'showCloseButton', 'closeButtonTitle']);

	var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));

	return _react2.default.createElement(
		'div',
		_extends({ className: (0, _noImportant.css)(classes.header) }, props),
		customControls ? customControls : _react2.default.createElement('span', null),
		!!showCloseButton && _react2.default.createElement(
			'button',
			{
				title: closeButtonTitle,
				className: (0, _noImportant.css)(classes.close),
				onClick: onClose
			},
			_react2.default.createElement(_Icon2.default, { fill: !!theme.close && theme.close.fill || _theme2.default.close.fill, type: 'close' })
		)
	);
}

Header.propTypes = {
	customControls: _propTypes2.default.array,
	onClose: _propTypes2.default.func.isRequired,
	showCloseButton: _propTypes2.default.bool
};
Header.contextTypes = {
	theme: _propTypes2.default.object.isRequired
};

var defaultStyles = {
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		height: _theme2.default.header.height
	},
	close: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		outline: 'none',
		position: 'relative',
		top: 0,
		verticalAlign: 'bottom',
		zIndex: 1,

		// increase hit area
		height: 40,
		marginRight: -10,
		padding: 10,
		width: 40
	}
};

exports.default = Header;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(126);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(497);

var _Thumbnail = __webpack_require__(1586);

var _Thumbnail2 = _interopRequireDefault(_Thumbnail);

var _Arrow = __webpack_require__(1146);

var _Arrow2 = _interopRequireDefault(_Arrow);

var _theme = __webpack_require__(496);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classes = _noImportant.StyleSheet.create({
	paginatedThumbnails: {
		bottom: _theme2.default.container.gutter.vertical,
		height: _theme2.default.thumbnail.size,
		padding: '0 50px',
		position: 'absolute',
		textAlign: 'center',
		whiteSpace: 'nowrap',
		left: '50%',
		transform: 'translateX(-50%)'
	}
});

var arrowStyles = {
	height: _theme2.default.thumbnail.size + _theme2.default.thumbnail.gutter * 2,
	width: 40
};

var PaginatedThumbnails = function (_Component) {
	_inherits(PaginatedThumbnails, _Component);

	function PaginatedThumbnails(props) {
		_classCallCheck(this, PaginatedThumbnails);

		var _this = _possibleConstructorReturn(this, (PaginatedThumbnails.__proto__ || Object.getPrototypeOf(PaginatedThumbnails)).call(this, props));

		_this.state = {
			hasCustomPage: false
		};

		_this.gotoPrev = _this.gotoPrev.bind(_this);
		_this.gotoNext = _this.gotoNext.bind(_this);
		return _this;
	}

	_createClass(PaginatedThumbnails, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			// Component should be controlled, flush state when currentImage changes
			if (nextProps.currentImage !== this.props.currentImage) {
				this.setState({
					hasCustomPage: false
				});
			}
		}

		// ==============================
		// METHODS
		// ==============================

	}, {
		key: 'getFirst',
		value: function getFirst() {
			var _props = this.props,
			    currentImage = _props.currentImage,
			    offset = _props.offset;

			if (this.state.hasCustomPage) {
				return this.clampFirst(this.state.first);
			}
			return this.clampFirst(currentImage - offset);
		}
	}, {
		key: 'setFirst',
		value: function setFirst(event, newFirst) {
			var first = this.state.first;


			if (event) {
				event.preventDefault();
				event.stopPropagation();
			}

			if (first === newFirst) return;

			this.setState({
				hasCustomPage: true,
				first: newFirst
			});
		}
	}, {
		key: 'gotoPrev',
		value: function gotoPrev(event) {
			this.setFirst(event, this.getFirst() - this.props.offset);
		}
	}, {
		key: 'gotoNext',
		value: function gotoNext(event) {
			this.setFirst(event, this.getFirst() + this.props.offset);
		}
	}, {
		key: 'clampFirst',
		value: function clampFirst(value) {
			var _props2 = this.props,
			    images = _props2.images,
			    offset = _props2.offset;


			var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side

			if (value < 0) {
				return 0;
			} else if (value + totalCount > images.length) {
				// Too far
				return images.length - totalCount;
			} else {
				return value;
			}
		}

		// ==============================
		// RENDERERS
		// ==============================

	}, {
		key: 'renderArrowPrev',
		value: function renderArrowPrev() {
			if (this.getFirst() <= 0) return null;

			return _react2.default.createElement(_Arrow2.default, {
				direction: 'left',
				size: 'small',
				icon: 'arrowLeft',
				onClick: this.gotoPrev,
				style: arrowStyles,
				title: 'Previous (Left arrow key)',
				type: 'button'
			});
		}
	}, {
		key: 'renderArrowNext',
		value: function renderArrowNext() {
			var _props3 = this.props,
			    offset = _props3.offset,
			    images = _props3.images;

			var totalCount = 2 * offset + 1;
			if (this.getFirst() + totalCount >= images.length) return null;

			return _react2.default.createElement(_Arrow2.default, {
				direction: 'right',
				size: 'small',
				icon: 'arrowRight',
				onClick: this.gotoNext,
				style: arrowStyles,
				title: 'Next (Right arrow key)',
				type: 'button'
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _props4 = this.props,
			    images = _props4.images,
			    currentImage = _props4.currentImage,
			    onClickThumbnail = _props4.onClickThumbnail,
			    offset = _props4.offset;


			var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side
			var thumbnails = [];
			var baseOffset = 0;
			if (images.length <= totalCount) {
				thumbnails = images;
			} else {
				// Try to center current image in list
				baseOffset = this.getFirst();
				thumbnails = images.slice(baseOffset, baseOffset + totalCount);
			}

			return _react2.default.createElement(
				'div',
				{ className: (0, _noImportant.css)(classes.paginatedThumbnails) },
				this.renderArrowPrev(),
				thumbnails.map(function (img, idx) {
					return _react2.default.createElement(_Thumbnail2.default, _extends({ key: baseOffset + idx
					}, img, {
						index: baseOffset + idx,
						onClick: onClickThumbnail,
						active: baseOffset + idx === currentImage }));
				}),
				this.renderArrowNext()
			);
		}
	}]);

	return PaginatedThumbnails;
}(_react.Component);

exports.default = PaginatedThumbnails;


PaginatedThumbnails.propTypes = {
	currentImage: _propTypes2.default.number,
	images: _propTypes2.default.array,
	offset: _propTypes2.default.number,
	onClickThumbnail: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = __webpack_require__(126);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(497);

var _theme = __webpack_require__(496);

var _theme2 = _interopRequireDefault(_theme);

var _deepMerge = __webpack_require__(552);

var _deepMerge2 = _interopRequireDefault(_deepMerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Thumbnail(_ref, _ref2) {
	var index = _ref.index,
	    src = _ref.src,
	    thumbnail = _ref.thumbnail,
	    active = _ref.active,
	    _onClick = _ref.onClick;
	var theme = _ref2.theme;

	var url = thumbnail ? thumbnail : src;
	var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));

	return _react2.default.createElement('div', {
		className: (0, _noImportant.css)(classes.thumbnail, active && classes.thumbnail__active),
		onClick: function onClick(e) {
			e.preventDefault();
			e.stopPropagation();
			_onClick(index);
		},
		style: { backgroundImage: 'url("' + url + '")' }
	});
}

Thumbnail.propTypes = {
	active: _propTypes2.default.bool,
	index: _propTypes2.default.number,
	onClick: _propTypes2.default.func.isRequired,
	src: _propTypes2.default.string,
	thumbnail: _propTypes2.default.string
};

Thumbnail.contextTypes = {
	theme: _propTypes2.default.object.isRequired
};

var defaultStyles = {
	thumbnail: {
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		borderRadius: 2,
		boxShadow: 'inset 0 0 0 1px hsla(0,0%,100%,.2)',
		cursor: 'pointer',
		display: 'inline-block',
		height: _theme2.default.thumbnail.size,
		margin: _theme2.default.thumbnail.gutter,
		overflow: 'hidden',
		width: _theme2.default.thumbnail.size
	},
	thumbnail__active: {
		boxShadow: 'inset 0 0 0 2px ' + _theme2.default.thumbnail.activeBorderColor
	}
};

exports.default = Thumbnail;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(126);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(1588);

var _reactDom = __webpack_require__(47);

var _PassContext = __webpack_require__(1596);

var _PassContext2 = _interopRequireDefault(_PassContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal = function (_Component) {
	_inherits(Portal, _Component);

	function Portal() {
		_classCallCheck(this, Portal);

		var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));

		_this.portalElement = null;
		return _this;
	}

	_createClass(Portal, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var p = document.createElement('div');
			document.body.appendChild(p);
			this.portalElement = p;
			this.componentDidUpdate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			// Animate fade on mount/unmount
			var duration = 200;
			var styles = '\n\t\t\t\t.fade-enter { opacity: 0.01; }\n\t\t\t\t.fade-enter.fade-enter-active { opacity: 1; transition: opacity ' + duration + 'ms; }\n\t\t\t\t.fade-leave { opacity: 1; }\n\t\t\t\t.fade-leave.fade-leave-active { opacity: 0.01; transition: opacity ' + duration + 'ms; }\n\t\t';

			(0, _reactDom.render)(_react2.default.createElement(
				_PassContext2.default,
				{ context: this.context },
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'style',
						null,
						styles
					),
					_react2.default.createElement(
						_reactTransitionGroup.TransitionGroup,
						this.props,
						_react2.default.createElement(
							_reactTransitionGroup.CSSTransition,
							{ timeout: { enter: duration, exit: duration }, classNames: 'fade' },
							this.props.children
						)
					)
				)
			), this.portalElement);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			(0, _reactDom.unmountComponentAtNode)(this.portalElement);
			document.body.removeChild(this.portalElement);
		}
	}, {
		key: 'render',
		value: function render() {
			return null;
		}
	}]);

	return Portal;
}(_react.Component);

exports.default = Portal;


Portal.contextTypes = {
	theme: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(1589));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1594));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(1151));

var _Transition = _interopRequireDefault(__webpack_require__(1148));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(126));

var _addClass = _interopRequireDefault(__webpack_require__(1590));

var _removeClass = _interopRequireDefault(__webpack_require__(1593));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(1148));

var _PropTypes = __webpack_require__(1150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};

var propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};;
/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 */

var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    };

    _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames7 = this.getClassNames(type),
        className = _this$getClassNames7.className,
        activeClassName = _this$getClassNames7.activeClassName,
        doneClassName = _this$getClassNames7.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1591);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(1592));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(126));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(47);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(1151));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};;
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? propTypes : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(126);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Pass the Lightbox context through to the Portal's descendents
// StackOverflow discussion http://goo.gl/oclrJ9

var PassContext = function (_Component) {
	_inherits(PassContext, _Component);

	function PassContext() {
		_classCallCheck(this, PassContext);

		return _possibleConstructorReturn(this, (PassContext.__proto__ || Object.getPrototypeOf(PassContext)).apply(this, arguments));
	}

	_createClass(PassContext, [{
		key: 'getChildContext',
		value: function getChildContext() {
			return this.props.context;
		}
	}, {
		key: 'render',
		value: function render() {
			return _react.Children.only(this.props.children);
		}
	}]);

	return PassContext;
}(_react.Component);

PassContext.propTypes = {
	context: _propTypes2.default.object.isRequired
};
PassContext.childContextTypes = {
	theme: _propTypes2.default.object
};

exports.default = PassContext;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = __webpack_require__(126);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(497);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner(props) {
	var classes = _noImportant.StyleSheet.create(styles(props));

	return _react2.default.createElement(
		'div',
		{ className: (0, _noImportant.css)(classes.spinner) },
		_react2.default.createElement('div', { className: (0, _noImportant.css)(classes.ripple) })
	);
};

Spinner.propTypes = {
	color: _propTypes2.default.string,
	size: _propTypes2.default.number
};

var rippleKeyframes = {
	'0%': {
		top: '50%',
		left: '50%',
		width: 0,
		height: 0,
		opacity: 1
	},
	'100%': {
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		opacity: 0
	}
};

var styles = function styles(_ref) {
	var color = _ref.color,
	    size = _ref.size;
	return {
		spinner: {
			display: 'inline-block',
			position: 'relative',
			width: size,
			height: size
		},
		ripple: {
			position: 'absolute',
			border: '4px solid ' + color,
			opacity: 1,
			borderRadius: '50%',
			animationName: rippleKeyframes,
			animationDuration: '1s',
			animationTimingFunction: 'cubic-bezier(0, 0.2, 0.8, 1)',
			animationIterationCount: 'infinite'
		}
	};
};

exports.default = Spinner;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = bindFunctions;
/**
	Bind multiple component methods:

	* @param {this} context
	* @param {Array} functions

	constructor() {
		...
		bindFunctions.call(this, ['handleClick', 'handleOther']);
	}
*/

function bindFunctions(functions) {
	var _this = this;

	functions.forEach(function (f) {
		return _this[f] = _this[f].bind(_this);
	});
};

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
// Return true if window + document

exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CheckButton = __webpack_require__(1601);

var _CheckButton2 = _interopRequireDefault(_CheckButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Image = function (_Component) {
    _inherits(Image, _Component);

    function Image(props) {
        _classCallCheck(this, Image);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Image).call(this, props));

        _this.state = {
            hover: false
        };
        return _this;
    }

    _createClass(Image, [{
        key: 'tagStyle',
        value: function tagStyle() {
            if (this.props.tagStyle) return this.props.tagStyle;
            return {
                display: "inline",
                padding: ".2em .6em .3em",
                fontSize: "75%",
                fontWeight: "600",
                lineHeight: "1",
                color: "yellow",
                background: "rgba(0,0,0,0.65)",
                textAlign: "center",
                whiteSpace: "nowrap",
                verticalAlign: "baseline",
                borderRadius: ".25em"
            };
        }
    }, {
        key: 'tileViewportStyle',
        value: function tileViewportStyle() {
            if (this.props.tileViewportStyle) return this.props.tileViewportStyle.call(this);
            if (this.props.item.isSelected) return {
                width: this.props.item.vwidth - 32,
                height: this.props.height - 32,
                margin: 16,
                overflow: "hidden"
            };
            return {
                width: this.props.item.vwidth,
                height: this.props.height,
                overflow: "hidden"
            };
        }
    }, {
        key: 'thumbnailStyle',
        value: function thumbnailStyle() {
            if (this.props.thumbnailStyle) return this.props.thumbnailStyle.call(this);
            if (this.props.item.isSelected) {
                var ratio = this.props.item.scaletwidth / this.props.height;
                var height = 0;
                var width = 0;
                var viewportHeight = this.props.height - 32;
                var viewportWidth = this.props.item.vwidth - 32;

                if (this.props.item.scaletwidth > this.props.height) {
                    width = this.props.item.scaletwidth - 32;
                    height = Math.floor(width / ratio);
                } else {
                    height = this.props.height - 32;
                    width = Math.floor(height * ratio);
                }

                var marginTop = -Math.abs(Math.floor((viewportHeight - height) / 2));
                var marginLeft = -Math.abs(Math.floor((viewportWidth - width) / 2));
                return {
                    cursor: 'pointer',
                    width: width,
                    height: height,
                    marginLeft: marginLeft,
                    marginTop: marginTop
                };
            }
            return {
                cursor: 'pointer',
                width: this.props.item.scaletwidth,
                height: this.props.height,
                marginLeft: this.props.item.marginLeft,
                marginTop: 0
            };
        }
    }, {
        key: 'renderCheckButton',
        value: function renderCheckButton() {
            return _react2.default.createElement(_CheckButton2.default, { key: 'Select',
                index: this.props.index,
                color: "rgba(255, 255, 255, 0.7)",
                selectedColor: "#4285f4",
                hoverColor: "rgba(255, 255, 255, 1)",
                isSelected: this.props.item.isSelected,
                isSelectable: this.props.isSelectable,
                onClick: this.props.isSelectable ? this.props.onSelectImage : null,
                parentHover: this.state.hover });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var tags = typeof this.props.item.tags === 'undefined' ? _react2.default.createElement('noscript', null) : this.props.item.tags.map(function (tag) {
                return _react2.default.createElement(
                    'div',
                    { title: tag.title,
                        key: "tag-" + tag.value,
                        style: { display: "inline-block",
                            cursor: 'pointer',
                            pointerEvents: 'visible',
                            margin: "2px" } },
                    _react2.default.createElement(
                        'span',
                        { style: _this2.tagStyle() },
                        tag.value
                    )
                );
            });

            var customOverlay = typeof this.props.item.customOverlay === 'undefined' ? _react2.default.createElement('noscript', null) : _react2.default.createElement(
                'div',
                { style: {
                        pointerEvents: "none",
                        opacity: this.state.hover ? 1 : 0,
                        position: "absolute",
                        height: "100%",
                        width: "100%" } },
                this.props.item.customOverlay
            );

            return _react2.default.createElement(
                'div',
                { className: 'tile',
                    key: "tile-" + this.props.index,
                    onMouseEnter: function onMouseEnter(e) {
                        return _this2.setState({ hover: true });
                    },
                    onMouseLeave: function onMouseLeave(e) {
                        return _this2.setState({ hover: false });
                    },
                    style: {
                        margin: this.props.margin,
                        WebkitUserSelect: "none",
                        position: "relative",
                        float: "left",
                        background: "#eee",
                        padding: "0px" } },
                _react2.default.createElement(
                    'div',
                    { className: 'tile-icon-bar',
                        key: "tile-icon-bar-" + this.props.index,
                        style: {
                            pointerEvents: "none",
                            opacity: 1,
                            position: "absolute",
                            height: "36px",
                            width: "100%" } },
                    this.renderCheckButton()
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'tile-bottom-bar',
                        key: "tile-bottom-bar-" + this.props.index,
                        style: {
                            padding: "2px",
                            pointerEvents: "none",
                            position: "absolute",
                            minHeight: "0px",
                            maxHeight: "160px",
                            width: "100%",
                            bottom: "0px"
                        } },
                    tags
                ),
                customOverlay,
                _react2.default.createElement('div', { className: 'tile-overlay',
                    key: "tile-overlay-" + this.props.index,
                    style: {
                        pointerEvents: "none",
                        opacity: 1,
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        background: this.state.hover && !this.props.item.isSelected && this.props.isSelectable ? 'linear-gradient(to bottom,rgba(0,0,0,0.26),transparent 56px,transparent)' : 'none' } }),
                _react2.default.createElement(
                    'div',
                    { className: 'tile-viewport',
                        style: this.tileViewportStyle(),
                        key: "tile-viewport-" + this.props.index,
                        onClick: this.props.onClick ? function (e) {
                            return _this2.props.onClick.call(_this2, _this2.props.index, e);
                        } : null },
                    _react2.default.createElement('img', {
                        key: "img-" + this.props.index,
                        src: this.props.item.thumbnail, title: this.props.item.caption,
                        style: this.thumbnailStyle() })
                )
            );
        }
    }]);

    return Image;
}(_react.Component);

Image.propTypes = {
    item: _propTypes2.default.object,
    index: _propTypes2.default.number,
    margin: _propTypes2.default.number,
    height: _propTypes2.default.number,
    isSelectable: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,
    onSelectImage: _propTypes2.default.func,
    tileViewportStyle: _propTypes2.default.func,
    thumbnailStyle: _propTypes2.default.func,
    tagStyle: _propTypes2.default.object,
    customOverlay: _propTypes2.default.element
};

Image.defaultProps = {
    isSelectable: true,
    hover: false
};

exports.default = Image;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckButton = function (_Component) {
    _inherits(CheckButton, _Component);

    function CheckButton(props) {
        _classCallCheck(this, CheckButton);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CheckButton).call(this, props));

        _this.state = {
            hover: _this.props.hover
        };

        _this.fill = _this.fill.bind(_this);
        _this.visibility = _this.visibility.bind(_this);
        return _this;
    }

    _createClass(CheckButton, [{
        key: 'fill',
        value: function fill() {
            if (this.props.isSelected) return this.props.selectedColor;else if (this.state.hover) return this.props.hoverColor;
            return this.props.color;
        }
    }, {
        key: 'visibility',
        value: function visibility() {
            if (this.props.isSelected || this.props.isSelectable && this.props.parentHover) return 'visible';
            return 'hidden';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var circleStyle = {
                display: this.props.isSelected ? "block" : "none"
            };

            return _react2.default.createElement(
                'div',
                {
                    title: 'Select',
                    style: {
                        visibility: this.visibility(),
                        background: 'none',
                        float: 'left',
                        width: '36px',
                        height: '36px',
                        border: 'none',
                        padding: '6px',
                        cursor: 'pointer',
                        pointerEvents: 'visible'
                    },
                    onClick: this.props.onClick ? function (e) {
                        return _this2.props.onClick(_this2.props.index, e);
                    } : null,
                    onMouseOver: function onMouseOver(e) {
                        return _this2.setState({ hover: true });
                    },
                    onMouseOut: function onMouseOut(e) {
                        return _this2.setState({ hover: false });
                    } },
                _react2.default.createElement(
                    'svg',
                    {
                        fill: this.fill(),
                        height: '24', viewBox: '0 0 24 24',
                        width: '24',
                        xmlns: 'http://www.w3.org/2000/svg' },
                    _react2.default.createElement(
                        'radialGradient',
                        {
                            id: 'shadow',
                            cx: '38',
                            cy: '95.488',
                            r: '10.488',
                            gradientTransform: 'matrix(1 0 0 -1 -26 109)',
                            gradientUnits: 'userSpaceOnUse' },
                        _react2.default.createElement('stop', {
                            offset: '.832',
                            stopColor: '#010101' }),
                        _react2.default.createElement('stop', {
                            offset: '1',
                            stopColor: '#010101',
                            stopOpacity: '0' })
                    ),
                    _react2.default.createElement('circle', {
                        style: circleStyle,
                        opacity: '.26',
                        fill: 'url(#shadow)',
                        cx: '12', cy: '13.512',
                        r: '10.488' }),
                    _react2.default.createElement('circle', {
                        style: circleStyle,
                        fill: '#FFF',
                        cx: '12',
                        cy: '12.2',
                        r: '8.292' }),
                    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
                    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
                )
            );
        }
    }]);

    return CheckButton;
}(_react.Component);

CheckButton.propTypes = { index: _propTypes2.default.number,
    color: _propTypes2.default.string,
    isSelectable: _propTypes2.default.bool,
    isSelected: _propTypes2.default.bool,
    selectedColor: _propTypes2.default.string,
    parentHover: _propTypes2.default.bool,
    hover: _propTypes2.default.bool,
    hoverColor: _propTypes2.default.string,
    onClick: _propTypes2.default.func };

CheckButton.defaultProps = { isSelectable: true,
    isSelected: false,
    parentHover: false,
    hover: false };

module.exports = CheckButton;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _removeFile2 = __webpack_require__(739);

var _removeFile3 = _interopRequireDefault(_removeFile2);

var _fileName = __webpack_require__(740);

var _fileName2 = _interopRequireDefault(_fileName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PowerPointPreview = function PowerPointPreview(props) {
  var _removeFile = props.removeFile,
      url = props.url,
      fileName = props.fileName,
      showCaption = props.showCaption,
      openGallery = props.openGallery,
      showGallery = props.showGallery,
      fullSize = props.fullSize;


  return _react2.default.createElement(
    'div',
    { style: { display: 'inline-block', maxHeight: fullSize && '550px', width: fullSize ? '100%' : '150px', height: fullSize ? '' : '100px', position: 'relative' } },
    _react2.default.createElement(
      'div',
      { style: { height: '100%', width: '100%' }, onTouchTap: showGallery && openGallery },
      _react2.default.createElement(
        'div',
        { style: { cursor: showGallery ? 'pointer' : 'default', border: fullSize ? '' : '2px solid #D3D3D3', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' } },
        _react2.default.createElement(_materialUi.FontIcon, {
          className: 'tc-icon-subscriptions',
          style: { color: fullSize ? '#FFFFFF' : 'rgba(138,138,138,.5)', verticalAlign: 'middle', fontSize: fullSize ? '150px' : '40px' },
          hoverColor: '#00bcd4'
        })
      ),
      (showCaption || fullSize) && _react2.default.createElement(_fileName2.default, { fileName: fileName, fileNameStyle: { color: '#FFFFFF', fontSize: '16px' } })
    ),
    _removeFile && _react2.default.createElement(_removeFile3.default, {
      removeFile: function removeFile() {
        return _removeFile(url);
      },
      left: '84%'
    })
  );
};

PowerPointPreview.propTypes = {
  url: _react.PropTypes.string,
  removeFile: _react.PropTypes.func,
  fileName: _react.PropTypes.string,
  openGallery: _react.PropTypes.func,
  showGallery: _react.PropTypes.bool,
  fullSize: _react.PropTypes.bool,
  showCaption: _react.PropTypes.bool
};

exports.default = PowerPointPreview;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _pdfPreview = __webpack_require__(1152);

var _pdfPreview2 = _interopRequireDefault(_pdfPreview);

var _videoPreview = __webpack_require__(1153);

var _videoPreview2 = _interopRequireDefault(_videoPreview);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import PowerPointPreview from './pptPreview';
var Lightbox = function Lightbox(props) {
  var viewingFileIndex = props.viewingFileIndex,
      changePage = props.changePage,
      filesLength = props.filesLength,
      closeLightbox = props.closeLightbox,
      viewingFile = props.viewingFile;


  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement('div', {
      id: 'file-preview-modal-overlay',
      style: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 50,
        background: 'rgba(0, 0, 0, 0.6)',
        display: 'none'
      }
    }),
    _react2.default.createElement(
      'div',
      {
        id: 'file-preview-modal',
        style: {
          display: 'none',
          width: '100%',
          maxWidth: '100%',
          maxHeight: '100%',
          height: '100%',
          position: 'fixed',
          zIndex: 100,
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          boxShadow: '0 0 60px 10px rgba(0, 0, 0, 0.9)'
        }
      },
      _react2.default.createElement(
        'div',
        { style: { position: 'absolute', zIndex: 1, top: '2%', right: '2%', backgroundColor: 'transparent' } },
        _react2.default.createElement(
          _materialUi.IconButton,
          { onTouchTap: closeLightbox },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-close', color: '#FFFFFF', style: { fontSize: '16px' } })
        )
      ),
      _react2.default.createElement(
        'div',
        { style: {
            display: 'flex',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '100%',
            alignItems: 'center', alignContent: 'center', justifyContent: 'space-between',
            height: '100%',
            overflow: 'hidden' }
        },
        _react2.default.createElement(
          _materialUi.IconButton,
          {
            onTouchTap: function onTouchTap() {
              return changePage(viewingFileIndex - 1);
            },
            disableTouchRipple: true,
            disabled: viewingFileIndex === 0,
            iconStyle: { fontSize: '75px', cursor: 'pointer' },
            style: { padding: 0, margin: 0 }
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-navigate_before', color: '#FFFFFF' })
        ),
        _react2.default.createElement(
          'div',
          { style: { maxWidth: '75%', maxHeight: '650px', marginLeft: '25px' } },
          _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.either(_ramda2.default.equals('image/png'), _ramda2.default.equals('image/jpeg')), _ramda2.default.always(_react2.default.createElement('img', { src: _ramda2.default.propOr('', 'url', viewingFile), style: { maxWidth: '100%', maxHeight: '550px' } }))], [_ramda2.default.equals('application/pdf'), _ramda2.default.always(_react2.default.createElement(_pdfPreview2.default, { fileName: _ramda2.default.propOr('', 'name', viewingFile), url: _ramda2.default.propOr('', 'url', viewingFile), fullSize: true }))], [_ramda2.default.either(_ramda2.default.equals('video/mp4'), _ramda2.default.equals('video/quicktime')), _ramda2.default.always(_react2.default.createElement(_videoPreview2.default, { fileName: _ramda2.default.propOr('', 'name', viewingFile), url: _ramda2.default.propOr('', 'url', viewingFile), fullSize: true }))],
          // [R.either(R.equals('application/vnd.ms-powerpoint'), R.equals('application/vnd.openxmlformats-officedocument.presentationml.presentation')), R.always(
          // <PowerPointPreview fileName={R.propOr('', 'name', viewingFile)} url={R.propOr('', 'url', viewingFile)} fullSize />)],
          [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement('span', null))]]), _ramda2.default.propOr('', 'mediaType', viewingFile))
        ),
        _react2.default.createElement(
          _materialUi.IconButton,
          {
            onTouchTap: function onTouchTap() {
              return changePage(viewingFileIndex + 1);
            },
            disableTouchRipple: true,
            disabled: viewingFileIndex === filesLength - 1,
            iconStyle: { fontSize: '75px', cursor: 'pointer' },
            style: { marginRight: '25px', padding: 0, margin: 0 }
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-navigate_next', color: '#FFFFFF' })
        )
      )
    )
  );
};

Lightbox.propTypes = {
  changePage: _react.PropTypes.func,
  filesLength: _react.PropTypes.number,
  viewingFile: _react.PropTypes.object,
  viewingFileIndex: _react.PropTypes.number,
  closeLightbox: _react.PropTypes.func
};

exports.default = Lightbox;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _linkPreview = __webpack_require__(1008);

var _linkPreview2 = _interopRequireDefault(_linkPreview);

var _container = __webpack_require__(1273);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GeneralPost = function GeneralPost(props) {
  var post = props.post,
      metadata = props.metadata,
      displayType = props.displayType,
      postFilePreview = props.postFilePreview,
      postFiles = props.postFiles;


  var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

  var metaForFirstLink = function metaForFirstLink() {
    if (!isNilOrEmpty(metadata)) {
      var firstLinkMetadata = _ramda2.default.path([0, 'metadata'], metadata);
      if (firstLinkMetadata) {
        // const firstLinkTwitter = R.propOr({}, 'twitter', firstLinkMetadata);
        var firstLinkOG = _ramda2.default.propOr({}, 'og', firstLinkMetadata);
        return {
          title: firstLinkOG.title || '',
          description: firstLinkOG.description || '',
          imageUrl: _ramda2.default.pathOr('', ['image', 'url'], firstLinkOG),
          url: firstLinkOG.url || '',
          type: firstLinkOG.type || '',
          siteName: firstLinkOG.siteName || ''
        };
      }
    }
  };

  return _react2.default.createElement(
    'div',
    { style: { clear: 'both' } },
    !isNilOrEmpty(metaForFirstLink()) && _react2.default.createElement(_linkPreview2.default, metaForFirstLink()),
    !isNilOrEmpty(post.files) && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_container2.default, { files: post.files, showCaption: false, showGallery: true, displayType: displayType, postFilePreview: postFilePreview, postPreviewFiles: postFiles })
    )
  );
};

GeneralPost.propTypes = {
  post: _react.PropTypes.object,
  metadata: _react.PropTypes.array,
  displayType: _react.PropTypes.string,
  postFilePreview: _react.PropTypes.object,
  postFiles: _react.PropTypes.array
};

exports.default = GeneralPost;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MembershipPost = function MembershipPost(props) {
  var post = props.post;


  return _react2.default.createElement(
    'div',
    { style: { clear: 'both' } },
    _react2.default.createElement(
      'div',
      { style: { marginTop: '10px' } },
      _react2.default.createElement(
        'a',
        { href: post.link, target: '_blank' },
        _react2.default.createElement('img', { src: post.images, width: '100' })
      )
    )
  );
};

MembershipPost.propTypes = {
  post: _react.PropTypes.object
};

exports.default = MembershipPost;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _linkPreview = __webpack_require__(1008);

var _linkPreview2 = _interopRequireDefault(_linkPreview);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewProdPublishedPost = function NewProdPublishedPost(props) {
  var post = props.post,
      changeRoute = props.changeRoute;


  var foundPhoto = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.find(function (file) {
    return file.mediaType === 'image/jpeg' || file.mediaType === 'image/png';
  }), _ramda2.default.propOr([], 'files')), post);

  return _react2.default.createElement(
    'div',
    { style: { clear: 'both' } },
    foundPhoto && _react2.default.createElement(
      _linkPreview2.default,
      {
        imageUrl: foundPhoto.url,
        url: '/product/' + post.productId
      },
      _react2.default.createElement(
        'div',
        { style: { color: 'rgb(0, 188, 212)', cursor: 'pointer', fontSize: '20px', fontWeight: 'bold', margin: '16px 0' }, onTouchTap: function onTouchTap() {
            return changeRoute('/product/' + post.productId);
          } },
        post.productName
      )
    )
  );
};

NewProdPublishedPost.propTypes = {
  post: _react.PropTypes.object,
  changeRoute: _react.PropTypes.func
};

exports.default = NewProdPublishedPost;

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _linkPreview = __webpack_require__(1008);

var _linkPreview2 = _interopRequireDefault(_linkPreview);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewLocPublishedPost = function NewLocPublishedPost(props) {
  var post = props.post,
      changeRoute = props.changeRoute;


  var foundPhoto = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.find(function (file) {
    return file.mediaType === 'image/jpeg' || file.mediaType === 'image/png';
  }), _ramda2.default.propOr([], 'files')), post);

  return _react2.default.createElement(
    'div',
    { style: { clear: 'both' } },
    foundPhoto && _react2.default.createElement(
      _linkPreview2.default,
      {
        imageUrl: foundPhoto.url,
        url: '/locations/' + post.locationId
      },
      _react2.default.createElement(
        'div',
        {
          style: { cursor: 'pointer', fontSize: '20px', fontWeight: 'bold', margin: '16px 0', color: 'rgb(0, 188, 212)' },
          onTouchTap: function onTouchTap() {
            return changeRoute('/locations/' + post.locationId);
          }
        },
        post.locationName
      )
    )
  );
};

NewLocPublishedPost.propTypes = {
  post: _react.PropTypes.object,
  changeRoute: _react.PropTypes.func
};

exports.default = NewLocPublishedPost;

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _delete = __webpack_require__(738);

var _delete2 = _interopRequireDefault(_delete);

var _flag = __webpack_require__(1059);

var _flag2 = _interopRequireDefault(_flag);

var _domain = __webpack_require__(1609);

var _domain2 = _interopRequireDefault(_domain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import EditIcon from 'material-ui/svg-icons/editor/mode-edit';

var IconCompNameLoc = function (_Component) {
  _inherits(IconCompNameLoc, _Component);

  function IconCompNameLoc() {
    _classCallCheck(this, IconCompNameLoc);

    var _this = _possibleConstructorReturn(this, (IconCompNameLoc.__proto__ || Object.getPrototypeOf(IconCompNameLoc)).call(this));

    _this.state = {
      showSeeMoreLocs: false
    };
    return _this;
  }

  _createClass(IconCompNameLoc, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          body = _props.body,
          compNameDivStyle = _props.compNameDivStyle,
          isOwner = _props.isOwner,
          displayType = _props.displayType,
          changeRoute = _props.changeRoute,
          deleteAPost = _props.deleteAPost,
          reportAPost = _props.reportAPost;
      var companyName = body.companyName,
          companyId = body.companyId,
          locations = body.locations,
          sendAsCorporate = body.sendAsCorporate;


      var compNameStyle = { fontSize: '16px', color: 'rgb(0, 188, 212)' };
      var showLocations = Boolean(locations && !sendAsCorporate);
      var longLocNames = _ramda2.default.pluck('name')(locations).join(', ').length > 40;

      return _react2.default.createElement(
        'div',
        { style: { display: 'flex', flexDirection: 'row', padding: '2% 2% 0 2%' } },
        _react2.default.createElement(
          'div',
          {
            style: _ramda2.default.merge({
              display: 'flex',
              flexDirection: 'column',
              width: displayType ? '100%' : '95%',
              fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif"
            }, compNameDivStyle || {})
          },
          _react2.default.createElement(
            'span',
            { style: compNameStyle },
            companyName
          ),
          showLocations && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { style: this.state.showSeeMoreLocs ? { overflow: 'visible', maxWidth: '95%' } : { float: 'left', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: '425px', width: '85%' }
              },
              locations.map(function (loc, i) {
                return _react2.default.createElement(
                  _materialUi.FontIcon,
                  {
                    key: i,
                    onTouchTap: function onTouchTap() {
                      return changeRoute('/locations/' + loc.locationId);
                    },
                    className: 'tc-icon-location_on',
                    style: { cursor: 'pointer', fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)', marginRight: '5px' }
                  },
                  _react2.default.createElement(
                    'span',
                    { style: { fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" } },
                    loc.name
                  )
                );
              })
            ),
            longLocNames && _react2.default.createElement(
              'span',
              {
                style: { fontSize: '10px', color: '#00bcd4', cursor: 'pointer', display: 'flex', float: 'right', lineHeight: '25px' },
                onTouchTap: function onTouchTap() {
                  return _this2.setState({ showSeeMoreLocs: !_this2.state.showSeeMoreLocs });
                }
              },
              this.state.showSeeMoreLocs ? '- See Less' : '+ See More'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          !displayType && _react2.default.createElement(
            'div',
            { style: { width: '3%' } },
            _react2.default.createElement(
              _materialUi.IconMenu,
              {
                style: { padding: 0 },
                iconButtonElement: _react2.default.createElement(_materialUi.IconButton, {
                  style: { height: '100%', padding: 0, width: '100%' },
                  iconStyle: { color: 'rgba(0, 0, 0, 0.54)', padding: 0 },
                  iconClassName: 'tc-icon-more_horiz'
                }),
                anchorOrigin: { horizontal: 'left', vertical: 'top' },
                targetOrigin: { horizontal: 'left', vertical: 'top' },
                desktop: true
              },
              !isOwner && _react2.default.createElement(_materialUi.MenuItem, {
                primaryText: 'Company Profile',
                leftIcon: _react2.default.createElement(_domain2.default, { color: 'rgb(0, 188, 212)' }),
                onTouchTap: function onTouchTap() {
                  return changeRoute('/company/' + companyId);
                }
              }),
              isOwner && _react2.default.createElement(_materialUi.MenuItem, {
                primaryText: 'Delete',
                leftIcon: _react2.default.createElement(_delete2.default, { color: 'rgb(255, 64, 129)' }),
                onTouchTap: function onTouchTap() {
                  var confirm = window.confirm('Are you sure you want to delete this post?');
                  if (confirm) {
                    deleteAPost();
                  }
                }
              }),
              !isOwner && _react2.default.createElement(_materialUi.MenuItem, {
                primaryText: _ramda2.default.propOr(false, 'reported', body) ? 'Thanks for reporting!' : 'Report',
                leftIcon: _react2.default.createElement(_flag2.default, { color: 'rgb(255, 64, 129)' }),
                onTouchTap: reportAPost,
                disabled: _ramda2.default.propOr(false, 'reported', body)
              })
            )
          )
        )
      );
    }
  }]);

  return IconCompNameLoc;
}(_react.Component);

IconCompNameLoc.propTypes = {
  companyName: _react.PropTypes.string,
  companyId: _react.PropTypes.string,
  compNameDivStyle: _react.PropTypes.object,
  locations: _react.PropTypes.array,
  sendAsCorporate: _react.PropTypes.bool,
  displayType: _react.PropTypes.string,
  isOwner: _react.PropTypes.bool,
  deleteAPost: _react.PropTypes.func,
  reportAPost: _react.PropTypes.func,
  changeRoute: _react.PropTypes.func,
  body: _react.PropTypes.object
};

exports.default = IconCompNameLoc;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialDomain = function SocialDomain(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' })
  );
};
SocialDomain = (0, _pure2.default)(SocialDomain);
SocialDomain.displayName = 'SocialDomain';
SocialDomain.muiName = 'SvgIcon';

exports.default = SocialDomain;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _momentTimezone = __webpack_require__(1009);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _queryBuilder = __webpack_require__(1611);

var _queryBuilder2 = _interopRequireDefault(_queryBuilder);

var _language = __webpack_require__(1612);

var _language2 = _interopRequireDefault(_language);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Timestamp = function Timestamp(props) {
  var timestamp = props.timestamp;


  var timeFromNow = (0, _momentTimezone2.default)(timestamp).from((0, _momentTimezone2.default)());

  return _react2.default.createElement(
    'div',
    { style: { clear: 'both', padding: '0 2%', margin: '3px 0 0 -5px', fontSize: '12px' } },
    _react2.default.createElement(
      'span',
      null,
      _react2.default.createElement(_queryBuilder2.default, { color: 'rgba(0, 0, 0, 0.54)', style: { height: '12px', verticalAlign: 'middle', marginTop: '-2px' } }),
      timeFromNow
    )
  );
};

Timestamp.propTypes = {
  timestamp: _react.PropTypes.string
};

exports.default = Timestamp;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionQueryBuilder = function ActionQueryBuilder(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
  );
};
ActionQueryBuilder = (0, _pure2.default)(ActionQueryBuilder);
ActionQueryBuilder.displayName = 'ActionQueryBuilder';
ActionQueryBuilder.muiName = 'SvgIcon';

exports.default = ActionQueryBuilder;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLanguage = function ActionLanguage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z' })
  );
};
ActionLanguage = (0, _pure2.default)(ActionLanguage);
ActionLanguage.displayName = 'ActionLanguage';
ActionLanguage.muiName = 'SvgIcon';

exports.default = ActionLanguage;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(226);

var _chatBubbleOutline = __webpack_require__(1220);

var _chatBubbleOutline2 = _interopRequireDefault(_chatBubbleOutline);

var _thumbUp = __webpack_require__(1614);

var _thumbUp2 = _interopRequireDefault(_thumbUp);

var _materialUi = __webpack_require__(3);

var _sharePost = __webpack_require__(1615);

var _sharePost2 = _interopRequireDefault(_sharePost);

var _comments = __webpack_require__(1637);

var _comments2 = _interopRequireDefault(_comments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActionBar = function (_Component) {
  _inherits(ActionBar, _Component);

  function ActionBar(props) {
    _classCallCheck(this, ActionBar);

    var _this = _possibleConstructorReturn(this, (ActionBar.__proto__ || Object.getPrototypeOf(ActionBar)).call(this, props));

    _this.state = {
      shareLinksOpen: false,
      viewingComments: !!props.displayType
    };
    return _this;
  }

  _createClass(ActionBar, [{
    key: 'trackShareClicks',
    value: function trackShareClicks(source) {
      this.props.trackEvent({ name: '[newsfeed] shared to ' + source });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          shareableLink = _props.shareableLink,
          companyName = _props.companyName,
          message = _props.message,
          postId = _props.postId,
          updatePost = _props.updatePost,
          numOfLikes = _props.numOfLikes,
          liked = _props.liked,
          displayType = _props.displayType,
          changeRoute = _props.changeRoute,
          viewingCompanyId = _props.viewingCompanyId,
          comments = _props.comments,
          updateProp = _props.updateProp,
          numOfComments = _props.numOfComments,
          trackEvent = _props.trackEvent;
      var _state = this.state,
          shareLinksOpen = _state.shareLinksOpen,
          viewingComments = _state.viewingComments;


      return _react2.default.createElement(
        'div',
        { style: { paddingBottom: viewingComments ? '0' : '2%', marginTop: '8px', display: 'flex', alignItems: 'flex-end', width: '100%', flexWrap: 'wrap' } },
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', cursor: 'pointer', height: '18px', padding: '0 2%' } },
          _react2.default.createElement(
            'span',
            { style: { display: 'flex', marginTop: '3px' } },
            _react2.default.createElement(
              _materialUi.IconButton,
              {
                style: { padding: 0, margin: 0, height: '20px', width: '20px', display: 'inline-block' },
                onTouchTap: function onTouchTap() {
                  if (displayType === 'publicPostPage' && !viewingCompanyId) changeRoute('/post/' + postId);else if (liked) updatePost('unlike');else updatePost('like');
                }
              },
              _react2.default.createElement(
                'span',
                { style: { height: '14px', width: '14px' } },
                _react2.default.createElement(_thumbUp2.default, {
                  color: liked ? 'rgb(0, 188, 212)' : 'rgba(0, 0, 0, 0.54)',
                  style: { height: '14px', width: '14px' }
                })
              )
            ),
            numOfLikes > 0 && _react2.default.createElement(
              'span',
              { style: { marginTop: '-3px', fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)', cursor: 'default' } },
              numOfLikes
            )
          ),
          _react2.default.createElement(
            'span',
            { style: { marginLeft: '5px', display: 'flex', marginTop: '3px' } },
            _react2.default.createElement(
              _materialUi.IconButton,
              {
                style: { padding: 0, margin: 0, height: '20px', width: '20px', display: 'inline-block' },
                onTouchTap: function onTouchTap() {
                  if (displayType === 'publicPostPage' && !viewingCompanyId) changeRoute('/post/' + postId);else {
                    _this2.setState({ viewingComments: !viewingComments });
                    updateProp({ postComment: {
                        comment: '',
                        postId: postId,
                        lastCommentId: '',
                        hasMoreComments: numOfComments > comments.length,
                        loading: false
                      } });
                  }
                }
              },
              _react2.default.createElement(
                'span',
                { style: { height: '14px', width: '14px' } },
                _react2.default.createElement(_chatBubbleOutline2.default, {
                  color: 'rgba(0, 0, 0, 0.54)',
                  style: { height: '14px', width: '14px' }
                })
              )
            ),
            comments.length > 0 && _react2.default.createElement(
              'span',
              { style: { marginTop: '-3px', fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)', cursor: 'default' } },
              numOfComments
            )
          ),
          _react2.default.createElement(
            'span',
            { style: { marginLeft: '5px', display: 'flex' } },
            _react2.default.createElement(_sharePost2.default, {
              shareLinksOpen: shareLinksOpen,
              companyName: companyName,
              shareableLink: shareableLink,
              postId: postId,
              message: message,
              openShareLinks: function openShareLinks() {
                if (!shareLinksOpen) {
                  trackEvent({ name: '[newsfeed] click share button' });
                }
                _this2.setState({ shareLinksOpen: !shareLinksOpen });
              },
              trackShareClicks: function trackShareClicks(socialMediaType) {
                return _this2.trackShareClicks(socialMediaType);
              }
            })
          )
        ),
        _react2.default.createElement(_comments2.default, {
          open: viewingComments,
          changeRoute: changeRoute,
          postId: postId,
          comments: comments,
          displayType: displayType,
          numOfComments: numOfComments
        })
      );
    }
  }]);

  return ActionBar;
}(_react.Component);

ActionBar.propTypes = {
  shareableLink: _react.PropTypes.string,
  isEditable: _react.PropTypes.bool,
  metadata: _react.PropTypes.array,
  companyName: _react.PropTypes.string,
  message: _react.PropTypes.string,
  postId: _react.PropTypes.string,
  updatePost: _react.PropTypes.func,
  numOfLikes: _react.PropTypes.number,
  liked: _react.PropTypes.bool,
  displayType: _react.PropTypes.string,
  changeRoute: _react.PropTypes.func,
  viewingCompanyId: _react.PropTypes.string,
  comments: _react.PropTypes.array,
  updateProp: _react.PropTypes.func,
  numOfComments: _react.PropTypes.number,
  trackEvent: _react.PropTypes.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateProps.apply(undefined, arguments));
    },
    trackEvent: function trackEvent(payload) {
      return dispatch({
        type: 'TRACK_EVENT',
        payload: payload
      });
    }
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ActionBar);

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionThumbUp = function ActionThumbUp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z' })
  );
};
ActionThumbUp = (0, _pure2.default)(ActionThumbUp);
ActionThumbUp.displayName = 'ActionThumbUp';
ActionThumbUp.muiName = 'SvgIcon';

exports.default = ActionThumbUp;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__(251);

var _jquery2 = _interopRequireDefault(_jquery);

var _materialUi = __webpack_require__(3);

var _reactShare = __webpack_require__(1616);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _insertLink = __webpack_require__(1635);

var _insertLink2 = _interopRequireDefault(_insertLink);

var _share = __webpack_require__(1636);

var _share2 = _interopRequireDefault(_share);

var _close = __webpack_require__(547);

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookShareButton = _reactShare.ShareButtons.FacebookShareButton,
    LinkedinShareButton = _reactShare.ShareButtons.LinkedinShareButton,
    TwitterShareButton = _reactShare.ShareButtons.TwitterShareButton;

var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');
var TwitterIcon = (0, _reactShare.generateShareIcon)('twitter');
var LinkedinIcon = (0, _reactShare.generateShareIcon)('linkedin');

var SharePost = function SharePost(props) {
  var shareLinksOpen = props.shareLinksOpen,
      companyName = props.companyName,
      shareableLink = props.shareableLink,
      postId = props.postId,
      message = props.message,
      openShareLinks = props.openShareLinks,
      trackShareClicks = props.trackShareClicks;


  var ShareLinksIcon = shareLinksOpen ? _close2.default : _share2.default;
  var shareButtonStyle = { display: 'inline-block', position: 'relative', left: '-10px', cursor: 'pointer', opacity: 0, transition: 'all 250ms cubic-bezier(0.06,.93,.77,1)' };
  var copyLink = function copyLink(element) {
    var $temp = (0, _jquery2.default)('<input>');
    (0, _jquery2.default)('body').append($temp);
    $temp.val((0, _jquery2.default)(element).text()).select();
    document.execCommand('copy');
    $temp.remove();
  };

  return _react2.default.createElement(
    'div',
    { className: shareLinksOpen ? 'share-icons-outer-div' : '', style: { display: 'flex' } },
    _react2.default.createElement(
      'div',
      { className: shareLinksOpen ? 'share-icons' : '', style: { display: 'flex', alignItems: 'center', cursor: 'pointer' },
        onClick: openShareLinks
      },
      _react2.default.createElement(
        'span',
        {
          style: _extends({ transition: 'transform 455ms', transform: 'rotate(0)', position: 'relative', top: '2px' }, shareLinksOpen ? { transform: 'rotate(90deg)', top: '0' } : {})
        },
        _react2.default.createElement(ShareLinksIcon, { style: { fill: '#999', height: '16px', width: '16px' } })
      ),
      _react2.default.createElement(
        'span',
        {
          style: _extends({ display: 'inline-block', opacity: 1, transition: 'all 455ms ease-out', postion: 'relative', top: 0 }, shareLinksOpen ? { display: 'none', opacity: 0, top: '10px' } : {})
        },
        '\xA0Share'
      )
    ),
    _react2.default.createElement(
      'div',
      {
        style: _extends({ display: 'flex', opacity: 0, marginLeft: '10px', transition: 'all 455ms ease-in-out' }, shareLinksOpen ? { opacity: 1 } : {})
      },
      _react2.default.createElement(
        'span',
        { style: _ramda2.default.merge(shareButtonStyle, shareLinksOpen ? { opacity: 1, left: '5px' } : {}) },
        _react2.default.createElement(
          FacebookShareButton,
          { url: shareableLink, quote: companyName + ' via TourConnect: ' + message, hashtag: '#TourConnect', onClick: function onClick() {
              return trackShareClicks('facebook');
            } },
          _react2.default.createElement(FacebookIcon, { round: true, size: 20 })
        )
      ),
      _react2.default.createElement(
        'span',
        { style: _ramda2.default.merge(shareButtonStyle, shareLinksOpen ? { opacity: 1, left: '10px' } : {}) },
        _react2.default.createElement(
          TwitterShareButton,
          { url: shareableLink, title: companyName, via: 'TourConnect', onClick: function onClick() {
              return trackShareClicks('twitter');
            } },
          _react2.default.createElement(TwitterIcon, { round: true, size: 20 })
        )
      ),
      _react2.default.createElement(
        'span',
        { style: _ramda2.default.merge(shareButtonStyle, shareLinksOpen ? { opacity: 1, left: '15px' } : {}) },
        _react2.default.createElement(
          LinkedinShareButton,
          { url: shareableLink, title: companyName + ' via TourConnect', description: message, onClick: function onClick() {
              return trackShareClicks('linkedin');
            } },
          _react2.default.createElement(LinkedinIcon, { round: true, size: 20 })
        )
      ),
      _react2.default.createElement(
        'span',
        {
          style: _ramda2.default.merge({ display: 'flex', alignItems: 'center', cursor: 'pointer', position: 'relative', left: '-10px', top: '-2px', opacity: 0, transition: 'all 250ms cubic-bezier(0.06,.93,.77,1)' }, shareLinksOpen ? { opacity: 1, left: '10px' } : {})
        },
        _react2.default.createElement(
          'span',
          { id: postId, style: { display: 'none' } },
          shareableLink
        ),
        _react2.default.createElement(
          _materialUi.IconButton,
          {
            tooltip: 'Copy Link',
            onTouchTap: function onTouchTap() {
              copyLink('#' + postId);
              window.alert('Link successfully copied!');
              trackShareClicks('clipboard');
            },
            style: {
              backgroundColor: 'rgb(0, 188, 212)',
              left: '10px',
              top: '2px',
              display: 'inline-block',
              height: '20px',
              width: '20px',
              padding: 0,
              margin: 0,
              border: '1px solid rgb(0, 188, 212)',
              borderRadius: '50%' }
          },
          _react2.default.createElement(
            'span',
            { style: { height: '14px', width: '14px' } },
            _react2.default.createElement(_insertLink2.default, { color: '#FFFFFF', style: { width: '14px', height: '14px', marginTop: '2px' } })
          )
        )
      )
    )
  );
};

SharePost.propTypes = {
  shareLinksOpen: _react.PropTypes.bool,
  companyName: _react.PropTypes.string,
  shareableLink: _react.PropTypes.string,
  postId: _react.PropTypes.string,
  message: _react.PropTypes.string,
  openShareLinks: _react.PropTypes.func,
  trackShareClicks: _react.PropTypes.func
};

exports.default = SharePost;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shareCountGetters = exports.shareLinks = exports.ShareCounts = exports.ShareButtons = exports.generateShareIcon = undefined;

var _generateIcon = __webpack_require__(1617);

var _shareButtons = __webpack_require__(1622);

var ShareButtons = _interopRequireWildcard(_shareButtons);

var _shareCounts = __webpack_require__(1628);

var ShareCounts = _interopRequireWildcard(_shareCounts);

var _socialMediaShareLinks = __webpack_require__(1165);

var shareLinks = _interopRequireWildcard(_socialMediaShareLinks);

var _shareCountGetters = __webpack_require__(1167);

var shareCountGetters = _interopRequireWildcard(_shareCountGetters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.generateShareIcon = _generateIcon.generateIcon;
exports.ShareButtons = ShareButtons;
exports.ShareCounts = ShareCounts;
exports.shareLinks = shareLinks;
exports.shareCountGetters = shareCountGetters;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(1010);

var _extends3 = _interopRequireDefault(_extends2);

exports.generateIcon = generateIcon;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1011);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icons = __webpack_require__(1621);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateIcon(network) {
  if (!_icons2.default[network.toLowerCase()]) {
    throw new Error('invalid network name for a social icon');
  }

  var iconConfig = _icons2.default[network.toLowerCase()];

  var Icon = function Icon(props) {
    var className = props.className,
        iconBgStyle = props.iconBgStyle,
        logoFillColor = props.logoFillColor,
        round = props.round,
        size = props.size;


    var baseStyle = {
      width: size,
      height: size
    };

    var classes = 'social-icon social-icon--' + network + ' ' + className;

    var finalIconBgStyle = (0, _extends3.default)({}, iconBgStyle);

    return _react2.default.createElement(
      'div',
      { style: baseStyle },
      _react2.default.createElement(
        'svg',
        {
          viewBox: '0 0 64 64',
          fill: logoFillColor,
          width: size,
          height: size,
          className: classes },
        _react2.default.createElement(
          'g',
          null,
          !round ? _react2.default.createElement('rect', {
            width: '64',
            height: '64',
            fill: iconConfig.color,
            style: finalIconBgStyle }) : _react2.default.createElement('circle', {
            cx: '32',
            cy: '32',
            r: '31',
            fill: iconConfig.color,
            style: finalIconBgStyle })
        ),
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { d: iconConfig.icon })
        )
      )
    );
  };

  Icon.propTypes = {
    className: _propTypes2.default.string,
    iconBgStyle: _propTypes2.default.object,
    logoFillColor: _propTypes2.default.string,
    round: _propTypes2.default.bool,
    size: _propTypes2.default.number
  };

  Icon.defaultProps = {
    className: '',
    logoFillColor: 'white',
    size: 64
  };

  return Icon;
}

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1028), __esModule: true };

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1620);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable max-len */
exports.default = {
  facebook: {
    icon: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
    mask: 'M0,0v64h64V0H0z M39.6,22l-2.8,0c-2.2,0-2.6,1.1-2.6,2.6V28h5.3l-0.7,5.3h-4.6V47h-5.5V33.3H24V28h4.6V24 c0-4.6,2.8-7,6.9-7c2,0,3.6,0.1,4.1,0.2V22z',
    color: '#3b5998'
  },
  google: {
    icon: 'M25.3,30.1v3.8h6.3c-0.3,1.6-1.9,4.8-6.3,4.8c-3.8,0-6.9-3.1-6.9-7s3.1-7,6.9-7c2.2,0,3.6,0.9,4.4,1.7l3-2.9c-1.9-1.8-4.4-2.9-7.4-2.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.4,0,10.7-4.5,10.7-10.9c0-0.7-0.1-1.3-0.2-1.8H25.3L25.3,30.1z M49.8,28.9h-3.2v-3.2h-3.2v3.2h-3.2v3.2h3.2v3.2h3.2v-3.2h3.2',
    mask: 'M0,0v64h64V0H0z M31.3,19.1c0.3,0.3,0.6,0.7,0.9,1.2c0.3,0.4,0.5,0.9,0.7,1.5c0.2,0.6,0.3,1.3,0.3,2.1 c0,1.4-0.3,2.6-0.9,3.4c-0.3,0.4-0.6,0.8-0.9,1.2c-0.4,0.4-0.8,0.7-1.2,1.1c-0.2,0.2-0.5,0.5-0.7,0.8c-0.2,0.3-0.4,0.7-0.4,1.1 c0,0.4,0.1,0.8,0.4,1c0.2,0.3,0.4,0.5,0.6,0.7l1.4,1.1c0.8,0.7,1.6,1.5,2.2,2.3c0.6,0.8,0.9,2,0.9,3.3c0,1.9-0.9,3.7-2.6,5.2 c-1.8,1.6-4.3,2.4-7.7,2.4c-2.8,0-4.9-0.6-6.3-1.8c-1.4-1.1-2.1-2.4-2.1-3.9c0-0.7,0.2-1.6,0.7-2.5c0.4-0.9,1.2-1.7,2.4-2.4 c1.3-0.7,2.7-1.2,4.1-1.5c1.4-0.2,2.6-0.3,3.5-0.4c-0.3-0.4-0.5-0.8-0.8-1.2c-0.3-0.4-0.4-0.9-0.4-1.5c0-0.4,0-0.6,0.2-0.9 c0.1-0.2,0.2-0.5,0.2-0.7c-0.5,0.1-0.9,0.1-1.3,0.1c-2.1,0-3.8-0.7-4.9-2c-1.2-1.2-1.8-2.7-1.8-4.3c0-2,0.8-3.8,2.5-5.4 c1.1-0.9,2.3-1.6,3.5-1.8c1.2-0.2,2.3-0.4,3.4-0.4h8L33,18.4h-2.5C30.7,18.6,31,18.8,31.3,19.1z M48,32h-4.3v4.2h-2.5V32H37v-2.5 h4.2v-4.3h2.5v4.3H48V32z M27.1,19.1c-0.6-0.5-1.4-0.7-2.2-0.7c-1.1,0-2,0.5-2.7,1.3c-0.6,0.9-0.9,1.9-0.9,3c0,1.5,0.4,3,1.3,4.5 c0.4,0.7,0.9,1.4,1.6,1.9c0.6,0.5,1.4,0.8,2.2,0.8c1.1,0,1.9-0.4,2.6-1.1c0.3-0.5,0.6-1,0.7-1.6c0.1-0.5,0.1-1,0.1-1.4 c0-1.6-0.4-3.2-1.2-4.8C28.2,20.2,27.7,19.5,27.1,19.1z M26.9,36.2c-0.2,0-0.7,0-1.6,0.1c-0.8,0.1-1.7,0.3-2.5,0.6 c-0.2,0.1-0.5,0.2-0.9,0.4c-0.4,0.2-0.7,0.4-1.1,0.7c-0.4,0.3-0.7,0.7-0.9,1.2c-0.3,0.5-0.4,1.1-0.4,1.8c0,1.4,0.6,2.6,1.9,3.5 c1.2,0.9,2.9,1.4,5,1.4c1.9,0,3.3-0.4,4.3-1.3c1-0.8,1.5-1.8,1.5-3.1c0-1-0.3-1.9-1-2.7c-0.7-0.7-1.8-1.6-3.3-2.6 C27.5,36.2,27.2,36.2,26.9,36.2z',
    color: '#dd4b39'
  },
  linkedin: {
    icon: 'M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z',
    mask: 'M0,0v64h64V0H0z M25.8,44h-5.4V26.6h5.4V44z M23.1,24.3c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 c1.7,0,3.1,1.4,3.1,3.1C26.2,22.9,24.8,24.3,23.1,24.3z M46,44h-5.4v-8.4c0-2,0-4.6-2.8-4.6c-2.8,0-3.2,2.2-3.2,4.5V44h-5.4V26.6 h5.2V29h0.1c0.7-1.4,2.5-2.8,5.1-2.8c5.5,0,6.5,3.6,6.5,8.3V44z',
    color: '#007fb1'
  },
  email: {
    icon: 'M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z',
    mask: 'M41.1,25H22.9l9.1,7.1L41.1,25z M44,26.6l-12,9.3l-12-9.3V39h24V26.6z M0,0v64h64V0H0z M47,42H17V22h30V42z',
    color: '#7f7f7f'
  },
  twitter: {
    icon: 'M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z',
    mask: 'M0,0v64h64V0H0z M44.7,25.5c0,0.3,0,0.6,0,0.8C44.7,35,38.1,45,26.1,45c-3.7,0-7.2-1.1-10.1-2.9 c0.5,0.1,1,0.1,1.6,0.1c3.1,0,5.9-1,8.2-2.8c-2.9-0.1-5.3-2-6.1-4.6c0.4,0.1,0.8,0.1,1.2,0.1c0.6,0,1.2-0.1,1.7-0.2 c-3-0.6-5.3-3.3-5.3-6.4c0,0,0-0.1,0-0.1c0.9,0.5,1.9,0.8,3,0.8c-1.8-1.2-2.9-3.2-2.9-5.5c0-1.2,0.3-2.3,0.9-3.3 c3.2,4,8.1,6.6,13.5,6.9c-0.1-0.5-0.2-1-0.2-1.5c0-3.6,2.9-6.6,6.6-6.6c1.9,0,3.6,0.8,4.8,2.1c1.5-0.3,2.9-0.8,4.2-1.6 c-0.5,1.5-1.5,2.8-2.9,3.6c1.3-0.2,2.6-0.5,3.8-1C47.1,23.4,46,24.5,44.7,25.5z',
    color: '#00aced'
  },
  pinterest: {
    icon: 'M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z',
    mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
    color: '#cb2128'
  },
  vk: {
    icon: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
    mask: 'M0,0v64h64V0H0z M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
    color: '#45668e'
  },
  ok: {
    icon: 'M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z ',
    mask: 'M45,1H5C2.8,1,1,2.8,1,5v40c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4V5C49,2.8,47.2,1,45,1z',
    color: '#f2720c'
  },
  telegram: {
    icon: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
    mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
    color: '#37aee2'
  },
  whatsapp: {
    icon: 'm42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915',
    mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
    color: '#2cb742'
  },
  reddit: {
    icon: 'm 52.8165,31.942362 c 0,-2.4803 -2.0264,-4.4965 -4.5169,-4.4965 -1.2155,0 -2.3171,0.4862 -3.128,1.2682 -3.077,-2.0247 -7.2403,-3.3133 -11.8507,-3.4782 l 2.5211,-7.9373 6.8272,1.5997 -0.0102,0.0986 c 0,2.0281 1.6575,3.6771 3.6958,3.6771 2.0366,0 3.6924,-1.649 3.6924,-3.6771 0,-2.0281 -1.6575,-3.6788 -3.6924,-3.6788 -1.564,0 -2.8968,0.9758 -3.4357,2.3443 l -7.3593,-1.7255 c -0.3213,-0.0782 -0.6477,0.1071 -0.748,0.4233 L 32,25.212062 c -4.8246,0.0578 -9.1953,1.3566 -12.41,3.4425 -0.8058,-0.7446 -1.8751,-1.2104 -3.0583,-1.2104 -2.4905,0 -4.5152,2.0179 -4.5152,4.4982 0,1.649 0.9061,3.0787 2.2389,3.8607 -0.0884,0.4794 -0.1462,0.9639 -0.1462,1.4569 0,6.6487 8.1736,12.0581 18.2223,12.0581 10.0487,0 18.224,-5.4094 18.224,-12.0581 0,-0.4658 -0.0493,-0.9248 -0.1275,-1.377 1.4144,-0.7599 2.3885,-2.2304 2.3885,-3.9406 z m -29.2808,3.0872 c 0,-1.4756 1.207,-2.6775 2.6894,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 -1.4824,0 -2.6894,-1.2002 -2.6894,-2.6758 z m 15.4037,7.9373 c -1.3549,1.3481 -3.4816,2.0043 -6.5008,2.0043 l -0.0221,-0.0051 -0.0221,0.0051 c -3.0209,0 -5.1476,-0.6562 -6.5008,-2.0043 -0.2465,-0.2448 -0.2465,-0.6443 0,-0.8891 0.2465,-0.2465 0.6477,-0.2465 0.8942,0 1.105,1.0999 2.9393,1.6337 5.6066,1.6337 l 0.0221,0.0051 0.0221,-0.0051 c 2.6673,0 4.5016,-0.5355 5.6066,-1.6354 0.2465,-0.2465 0.6477,-0.2448 0.8942,0 0.2465,0.2465 0.2465,0.6443 0,0.8908 z m -0.3213,-5.2615 c -1.4824,0 -2.6877,-1.2002 -2.6877,-2.6758 0,-1.4756 1.2053,-2.6775 2.6877,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 z',
    color: '#5f99cf'
  }
};
/* eslint-enable max-len */

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedditShareButton = exports.OKShareButton = exports.VKShareButton = exports.PinterestShareButton = exports.LinkedinShareButton = exports.GooglePlusShareButton = exports.EmailShareButton = exports.WhatsappShareButton = exports.TelegramShareButton = exports.TwitterShareButton = exports.FacebookShareButton = undefined;

var _extends2 = __webpack_require__(1010);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1158);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1159);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1160);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1161);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(1162);

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = __webpack_require__(1163);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1011);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(1164);

var _classnames2 = _interopRequireDefault(_classnames);

var _socialMediaShareLinks = __webpack_require__(1165);

var links = _interopRequireWildcard(_socialMediaShareLinks);

var _utils = __webpack_require__(1013);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var supportedNetworks = (0, _keys2.default)(links); /* eslint-disable react/no-multi-comp */

var ShareButton = function (_Component) {
  (0, _inherits3.default)(ShareButton, _Component);

  function ShareButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ShareButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ShareButton.__proto__ || (0, _getPrototypeOf2.default)(ShareButton)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          openWindow = _this$props.openWindow;


      if (disabled) {
        return;
      }

      e.preventDefault();

      var link = _this.link();

      if (openWindow) {
        _this.openWindow(link);
      }

      if (onClick) {
        onClick(link);
      }
    }, _this.onKeyPress = function (e) {
      if (e.key === 'Enter' || e.key === 13) {
        _this.onClick(e);
      }
    }, _this.openWindow = function (link) {
      var _this$props2 = _this.props,
          beforeOnClick = _this$props2.beforeOnClick,
          onShareWindowClose = _this$props2.onShareWindowClose,
          windowWidth = _this$props2.windowWidth,
          windowHeight = _this$props2.windowHeight;


      var windowOptions = {
        height: windowHeight,
        width: windowWidth
      };

      var windowOpenBound = function windowOpenBound() {
        return (0, _utils.windowOpen)(link, windowOptions, onShareWindowClose);
      };

      if (beforeOnClick) {
        var returnVal = beforeOnClick();

        if ((0, _utils.isPromise)(returnVal)) {
          returnVal.then(windowOpenBound);
        } else {
          windowOpenBound();
        }
      } else {
        windowOpenBound();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ShareButton, [{
    key: 'link',
    value: function link() {
      var _props = this.props,
          url = _props.url,
          opts = _props.opts,
          network = _props.network;

      return links[network](url, opts);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          disabled = _props2.disabled,
          disabledStyle = _props2.disabledStyle,
          network = _props2.network,
          style = _props2.style;


      var classes = (0, _classnames2.default)('SocialMediaShareButton', 'SocialMediaShareButton--' + network, {
        'SocialMediaShareButton--disabled': !!disabled,
        disabled: !!disabled
      }, className);

      return _react2.default.createElement(
        'div',
        {
          role: 'button',
          tabIndex: '0',
          onClick: this.onClick,
          onKeyPress: this.onKeyPress,
          className: classes,
          style: (0, _extends3.default)({}, style, disabled ? disabledStyle : {}) },
        children
      );
    }
  }]);
  return ShareButton;
}(_react.Component);

/* HOC to ease migration from v1 to v2.
 * To-be-removed in v2.
 */


ShareButton.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  disabledStyle: _propTypes2.default.object,
  network: _propTypes2.default.oneOf(supportedNetworks),
  onClick: _propTypes2.default.func,
  opts: _propTypes2.default.object,
  openWindow: _propTypes2.default.bool,
  url: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object,
  windowWidth: _propTypes2.default.number,
  windowHeight: _propTypes2.default.number,
  beforeOnClick: _propTypes2.default.func,
  onShareWindowClose: _propTypes2.default.func
};
ShareButton.defaultProps = {
  disabledStyle: {
    opacity: 0.6
  },
  openWindow: true
};
exports.default = ShareButton;
function createShareButton(network) {
  var optsMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return {};
  };
  var propTypes = arguments[2];
  var defaultProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var CreatedButton = function CreatedButton(props) {
    return _react2.default.createElement(ShareButton, (0, _extends3.default)({}, props, {
      network: network,
      opts: optsMap(props) }));
  };

  CreatedButton.propTypes = propTypes;
  CreatedButton.defaultProps = defaultProps;

  return CreatedButton;
}

var FacebookShareButton = exports.FacebookShareButton = createShareButton('facebook', function (props) {
  /* eslint-disable no-console */
  if (props.picture) {
    console.warn('FacebookShareButton warning: picture is a deprecated prop.');
  }

  if (props.title) {
    console.warn('FacebookShareButton warning: title is a deprecated prop. Use "quote" instead.');
  }

  if (props.description) {
    console.warn('FacebookShareButton warning: description is a deprecated prop.\n      Use "quote" instead.');
  }
  /* eslint-enable no-console */

  return {
    quote: props.quote,
    hashtag: props.hashtag
  };
}, {
  quote: _propTypes2.default.string,
  hashtag: _propTypes2.default.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

var TwitterShareButton = exports.TwitterShareButton = createShareButton('twitter', function (props) {
  return {
    hashtags: props.hashtags,
    title: props.title,
    via: props.via
  };
}, {
  hashtags: _propTypes2.default.arrayOf(_propTypes2.default.string),
  title: _propTypes2.default.string,
  via: _propTypes2.default.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

var TelegramShareButton = exports.TelegramShareButton = createShareButton('telegram', function (props) {
  return {
    title: props.title,
    via: props.via
  };
}, {
  title: _propTypes2.default.string,
  via: _propTypes2.default.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

var WhatsappShareButton = exports.WhatsappShareButton = createShareButton('whatsapp', function (props) {
  return {
    title: props.title,
    separator: props.separator
  };
}, {
  title: _propTypes2.default.string,
  separator: _propTypes2.default.string
}, {
  separator: ' ',
  windowWidth: 550,
  windowHeight: 400
});

var EmailShareButton = exports.EmailShareButton = createShareButton('email', function (props) {
  return {
    subject: props.subject,
    body: props.body
  };
}, {
  subject: _propTypes2.default.string,
  body: _propTypes2.default.string
}, {
  openWindow: false,
  onClick: function onClick(link) {
    window.location.href = link;
  }
});

var GooglePlusShareButton = exports.GooglePlusShareButton = createShareButton('googlePlus', undefined, undefined, {
  windowWidth: 550,
  windowHeight: 400
});

var LinkedinShareButton = exports.LinkedinShareButton = createShareButton('linkedin', function (props) {
  return {
    title: props.title,
    description: props.description
  };
}, {
  title: _propTypes2.default.string,
  description: _propTypes2.default.string
}, {
  windowWidth: 750,
  windowHeight: 600
});

var PinterestShareButton = exports.PinterestShareButton = createShareButton('pinterest', function (props) {
  return {
    media: props.media,
    description: props.description
  };
}, {
  media: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.string
}, {
  windowWidth: 1000,
  windowHeight: 730
});

var VKShareButton = exports.VKShareButton = createShareButton('vk', function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: _propTypes2.default.string,
  description: _propTypes2.default.string,
  image: _propTypes2.default.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

var OKShareButton = exports.OKShareButton = createShareButton('ok', function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: _propTypes2.default.string,
  description: _propTypes2.default.string,
  image: _propTypes2.default.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

var RedditShareButton = exports.RedditShareButton = createShareButton('reddit', function (props) {
  return {
    title: props.title
  };
}, {
  title: _propTypes2.default.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1033), __esModule: true };

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1034), __esModule: true };

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1036), __esModule: true };

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1037), __esModule: true };

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1038), __esModule: true };

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwitterShareCount = exports.RedditShareCount = exports.OKShareCount = exports.VKShareCount = exports.PinterestShareCount = exports.GooglePlusShareCount = exports.LinkedinShareCount = exports.FacebookShareCount = undefined;

var _extends2 = __webpack_require__(1010);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1158);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1159);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1160);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1161);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(1162);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1011);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(1164);

var _classnames2 = _interopRequireDefault(_classnames);

var _shareCountGetters = __webpack_require__(1167);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var SocialMediaShareCount = function (_Component) {
  (0, _inherits3.default)(SocialMediaShareCount, _Component);

  function SocialMediaShareCount(props) {
    (0, _classCallCheck3.default)(this, SocialMediaShareCount);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SocialMediaShareCount.__proto__ || (0, _getPrototypeOf2.default)(SocialMediaShareCount)).call(this, props));

    _this._isMounted = false;
    _this.state = { count: 0 };
    return _this;
  }

  (0, _createClass3.default)(SocialMediaShareCount, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      this.updateCount(this.props.url);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.url !== this.props.url) {
        this.updateCount(nextProps.url);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: 'updateCount',
    value: function updateCount(url) {
      var _this2 = this;

      if (this.props.getCount) {
        this.setState({
          isLoading: true
        });

        this.props.getCount(url, function (count) {
          if (_this2._isMounted) {
            _this2.setState({
              count: count,
              isLoading: false
            });
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          count = _state.count,
          isLoading = _state.isLoading;
      var _props = this.props,
          children = _props.children,
          className = _props.className;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('SocialMediaShareCount', className) },
        !isLoading && children(count || 0)
      );
    }
  }]);
  return SocialMediaShareCount;
}(_react.Component);

SocialMediaShareCount.propTypes = {
  children: _propTypes2.default.func,
  className: _propTypes2.default.string,
  getCount: _propTypes2.default.func,
  url: _propTypes2.default.string.isRequired
};

SocialMediaShareCount.defaultProps = {
  children: function children(shareCount) {
    return shareCount;
  }
};

function shareCountFactory(getCount) {
  return function (props) {
    return _react2.default.createElement(SocialMediaShareCount, (0, _extends3.default)({ getCount: getCount }, props));
  };
}

var FacebookShareCount = exports.FacebookShareCount = shareCountFactory(_shareCountGetters.getFacebookShareCount);
var LinkedinShareCount = exports.LinkedinShareCount = shareCountFactory(_shareCountGetters.getLinkedinShareCount);
var GooglePlusShareCount = exports.GooglePlusShareCount = shareCountFactory(_shareCountGetters.getGooglePlusShareCount);
var PinterestShareCount = exports.PinterestShareCount = shareCountFactory(_shareCountGetters.getPinterestShareCount);
var VKShareCount = exports.VKShareCount = shareCountFactory(_shareCountGetters.getVKShareCount);
var OKShareCount = exports.OKShareCount = shareCountFactory(_shareCountGetters.getOKShareCount);
var RedditShareCount = exports.RedditShareCount = shareCountFactory(_shareCountGetters.getRedditShareCount);
var TwitterShareCount = exports.TwitterShareCount = function TwitterShareCount() {
  throw new Error('TwitterShareCount was removed in version 1.3.0 because' + 'the Twitter API was shut down and there is no replacement. Please ' + 'remove it from your code.');
};

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1630), __esModule: true };

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(225);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__(1632)('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(1633);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"STRIPE_PUBLIC_KEY":"pk_live_3DIaCH9RC6TUHFN58h8Rr0LW","ROLLBAR_CLIENT_KEY":"fc1e0ac7f2ac4f5c8b3bfa42270fe680","NODE_ENV":"production","GA_CODE":"UA-27853143-1","CONTENTFUL_HELPSIDEBAR":"5829e984567fa554706e6cfed3a025cfcf1df1d9a1495ef9b32962299e4400ac","API_URL":"https://rest.tourconnect.com","API_AUTH_TOKEN":"Basic cHJvZC1jb250cmFjdGluZzpVa2lyMFA1dHNi","REAL_API_URL":undefined,"NEW_SYSTEM_URL":"https://app.tourconnect.com","ADD_IN_URL":"https://outlook.tourconnect.com","SYSTEM_URL":"https://contracting.tourconnect.com","SECONDARY_SYSTEM_URL":"https://sec.tourconnect.com","INTERCOM_APP":"jfwd6pzo"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(1634);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 1634 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertLink = function EditorInsertLink(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
  );
};
EditorInsertLink = (0, _pure2.default)(EditorInsertLink);
EditorInsertLink.displayName = 'EditorInsertLink';
EditorInsertLink.muiName = 'SvgIcon';

exports.default = EditorInsertLink;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialShare = function SocialShare(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z' })
  );
};
SocialShare = (0, _pure2.default)(SocialShare);
SocialShare.displayName = 'SocialShare';
SocialShare.muiName = 'SvgIcon';

exports.default = SocialShare;

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(226);

var _materialUi = __webpack_require__(3);

var _comment = __webpack_require__(1638);

var _comment2 = _interopRequireDefault(_comment);

var _newComment = __webpack_require__(1639);

var _newComment2 = _interopRequireDefault(_newComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Comments = function Comments(props) {
  var open = props.open,
      changeRoute = props.changeRoute,
      postId = props.postId,
      comments = props.comments,
      displayType = props.displayType,
      loadMore = props.loadMore,
      numOfComments = props.numOfComments;


  return _react2.default.createElement(
    'div',
    { style: { display: 'flex', width: '100%' } },
    open && _react2.default.createElement(
      'div',
      { style: { width: '100%', marginTop: '10px', paddingBottom: '10px', backgroundColor: '#f6f6f6' } },
      displayType !== 'publicPostPage' && _react2.default.createElement(_newComment2.default, { postId: postId }),
      _react2.default.createElement(
        'div',
        null,
        comments.map(function (comment, i) {
          return _react2.default.createElement(_comment2.default, _extends({
            key: i,
            changeRoute: changeRoute,
            postId: postId
          }, comment));
        })
      ),
      numOfComments > comments.length && _react2.default.createElement(_materialUi.FlatButton, {
        secondary: true,
        label: 'Load more comments',
        onTouchTap: function onTouchTap() {
          return loadMore(postId, displayType);
        },
        hoverColor: '#f6f6f6'
      })
    )
  );
};

Comments.propTypes = {
  open: _react.PropTypes.bool,
  changeRoute: _react.PropTypes.func,
  postId: _react.PropTypes.string,
  comments: _react.PropTypes.array,
  displayType: _react.PropTypes.string,
  loadMore: _react.PropTypes.func,
  numOfComments: _react.PropTypes.number
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadMore: function loadMore() {
      return dispatch(_actions.loadMoreComments.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(Comments);

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _actions = __webpack_require__(226);

var _delete = __webpack_require__(738);

var _delete2 = _interopRequireDefault(_delete);

var _flag = __webpack_require__(1059);

var _flag2 = _interopRequireDefault(_flag);

var _momentTimezone = __webpack_require__(1009);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var Comment = function (_Component) {
  _inherits(Comment, _Component);

  function Comment() {
    _classCallCheck(this, Comment);

    var _this = _possibleConstructorReturn(this, (Comment.__proto__ || Object.getPrototypeOf(Comment)).call(this));

    _this.state = {
      viewFullPost: false
    };
    return _this;
  }

  _createClass(Comment, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          profileImageUrl = _props.profileImageUrl,
          companyId = _props.companyId,
          companyName = _props.companyName,
          changeRoute = _props.changeRoute,
          userName = _props.userName,
          timestamp = _props.timestamp,
          userId = _props.userId,
          ownUserId = _props.ownUserId,
          reportAComment = _props.reportAComment,
          updateAPost = _props.updateAPost,
          postId = _props.postId,
          reported = _props.reported,
          _id = _props._id,
          comment = _props.comment;


      var isLongPost = _ramda2.default.propOr(0, 'length', comment) > 350;

      return _react2.default.createElement(
        'div',
        { style: { padding: '5px 10px' } },
        _react2.default.createElement(
          'div',
          { style: { width: '100%', display: 'flex', justifyContent: 'space-between' } },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center' } },
            !isNilOrEmpty(profileImageUrl) ? _react2.default.createElement(_materialUi.Avatar, {
              backgroundColor: '#ffffff',
              src: profileImageUrl,
              size: 25,
              onTouchTap: function onTouchTap() {
                return changeRoute('/company/' + companyId);
              },
              style: { cursor: 'pointer' }
            }) : _react2.default.createElement(
              _materialUi.Avatar,
              {
                size: 25,
                onTouchTap: function onTouchTap() {
                  return changeRoute('/company/' + companyId);
                },
                style: { cursor: 'pointer' }
              },
              _ramda2.default.head(companyName)
            ),
            _react2.default.createElement(
              'span',
              { style: { marginLeft: '10px', fontSize: '12px' } },
              userName,
              ', ',
              _react2.default.createElement(
                'a',
                { href: '/company/' + companyId },
                companyName
              ),
              ' - ',
              (0, _momentTimezone2.default)(timestamp).from((0, _momentTimezone2.default)())
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '5px' } },
            _react2.default.createElement(
              _materialUi.IconMenu,
              {
                style: { padding: 0 },
                iconButtonElement: _react2.default.createElement(_materialUi.IconButton, {
                  style: { height: '100%', padding: 0, width: '100%' },
                  iconStyle: { color: '#D3D3D3', padding: 0 },
                  iconClassName: 'tc-icon-more-vert'
                }),
                anchorOrigin: { horizontal: 'left', vertical: 'top' },
                targetOrigin: { horizontal: 'left', vertical: 'top' },
                desktop: true
              },
              userId === ownUserId && _react2.default.createElement(_materialUi.MenuItem, {
                primaryText: 'Delete',
                leftIcon: _react2.default.createElement(_delete2.default, { color: 'rgb(255, 64, 129)' }),
                onTouchTap: function onTouchTap() {
                  var confirm = window.confirm('Are you sure you want to delete this comment?');
                  if (confirm) {
                    updateAPost(postId, 'deleteComment', { commentId: _id });
                  }
                }
              }),
              userId !== ownUserId && _react2.default.createElement(_materialUi.MenuItem, {
                primaryText: reported || false ? 'Thanks for reporting!' : 'Report Comment',
                leftIcon: _react2.default.createElement(_flag2.default, { color: 'rgb(255, 64, 129)' }),
                onTouchTap: function onTouchTap() {
                  return reportAComment(postId, _id);
                },
                disabled: reported || false
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '100%', padding: '0 20px 0 35px' } },
          _react2.default.createElement(
            'div',
            { style: { maxHeight: !this.state.viewFullPost ? '150px' : '', overflowY: !this.state.viewFullPost ? 'hidden' : '', fontSize: '12px', whiteSpace: 'pre-wrap' } },
            comment
          ),
          isLongPost && !this.state.viewFullPost && _react2.default.createElement(
            'div',
            {
              style: {
                position: 'relative',
                margin: '15px 10px 0 0',
                display: 'flex',
                flexDirection: 'row-reverse'
              },
              onTouchTap: function onTouchTap() {
                return _this2.setState({ viewFullPost: true });
              }
            },
            _react2.default.createElement(
              'span',
              { style: { color: '#00bcd4', cursor: 'pointer', fontSize: '12px', bottom: 0, position: 'absolute' } },
              _react2.default.createElement(
                'b',
                null,
                '+'
              ),
              ' SEE MORE'
            )
          )
        )
      );
    }
  }]);

  return Comment;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user,
      newsfeed = _ref.newsfeed;
  return {
    ownUserId: user ? user.get('id') : undefined,
    hasMoreComments: newsfeed ? newsfeed.getIn(['postComment', 'hasMoreComments']) : undefined
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    reportAComment: function reportAComment(postId, commentId) {
      return dispatch((0, _actions.reportComment)(postId, commentId));
    },
    updateAPost: function updateAPost() {
      return dispatch(_actions.updatePost.apply(undefined, arguments));
    }
  };
};

Comment.propTypes = {
  profileImageUrl: _react.PropTypes.string,
  companyId: _react.PropTypes.string,
  companyName: _react.PropTypes.string,
  changeRoute: _react.PropTypes.func,
  userName: _react.PropTypes.string,
  timestamp: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
  userId: _react.PropTypes.string,
  ownUserId: _react.PropTypes.string,
  reportAComment: _react.PropTypes.func,
  updateAPost: _react.PropTypes.func,
  postId: _react.PropTypes.string,
  reported: _react.PropTypes.bool,
  _id: _react.PropTypes.string,
  comment: _react.PropTypes.string
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Comment);

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(226);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var NewComment = function NewComment(props) {
  var profileImageUrl = props.profileImageUrl,
      companyName = props.companyName,
      userEnteredComment = props.userEnteredComment,
      companyId = props.companyId,
      userId = props.userId,
      userFirstName = props.userFirstName,
      userLastName = props.userLastName,
      userEmail = props.userEmail,
      updatingPost = props.updatingPost,
      commentPostId = props.commentPostId,
      updateProp = props.updateProp,
      postId = props.postId,
      updateAPost = props.updateAPost;


  var autoExpand = function autoExpand() {
    document.getElementById('newCommentArea').style.height = '5px';
    document.getElementById('newCommentArea').style.height = document.getElementById('newCommentArea').scrollHeight + 'px';
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', alignItems: 'center', padding: '10px' } },
      _react2.default.createElement(
        'div',
        { style: { marginTop: '5px' } },
        !isNilOrEmpty(profileImageUrl) ? _react2.default.createElement(_materialUi.Avatar, {
          backgroundColor: '#ffffff',
          src: profileImageUrl,
          size: 25
        }) : _react2.default.createElement(
          _materialUi.Avatar,
          { size: 25 },
          _ramda2.default.head(companyName)
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { marginLeft: '10px', width: '97%' } },
        _react2.default.createElement('textarea', {
          style: { resize: 'none', border: '1px solid rgb(202,202,202)', width: '97%', borderRadius: '3px', backgroundColor: '#FFFFFF', minHeight: '35px', maxHeight: '100px' },
          value: _ramda2.default.equals(commentPostId, postId) ? userEnteredComment : '',
          onChange: function onChange(_ref) {
            var value = _ref.target.value;
            return updateProp({ postComment: { comment: value, postId: postId } });
          },
          placeholder: 'Add a comment',
          disabled: updatingPost,
          rows: userEnteredComment ? '' : 1,
          onKeyUp: function onKeyUp() {
            return autoExpand();
          },
          id: 'newCommentArea'
        })
      )
    ),
    !isNilOrEmpty(userEnteredComment) && commentPostId === postId && _react2.default.createElement(
      'div',
      { style: { display: 'flex', flexDirection: 'row-reverse', marginRight: '25px' } },
      _react2.default.createElement(_materialUi.FlatButton, {
        label: 'SUBMIT',
        secondary: true,
        onTouchTap: function onTouchTap() {
          updateAPost(postId, 'comment', { comment: {
              comment: userEnteredComment.trim(),
              profileImageUrl: profileImageUrl,
              timestamp: new Date(),
              companyName: companyName,
              companyId: companyId,
              userName: isNilOrEmpty(userFirstName) || isNilOrEmpty(userLastName) ? userEmail : userFirstName + ' ' + _ramda2.default.head(userLastName),
              userId: userId
            } });
          updateProp({ postComment: { comment: '', postId: '' } });
        },
        disabled: isNilOrEmpty(userEnteredComment)
      }),
      _react2.default.createElement(_materialUi.FlatButton, { label: 'CANCEL', primary: true, onTouchTap: function onTouchTap() {
          return updateProp({ postComment: { comment: '', postId: '' } });
        } })
    )
  );
};

NewComment.propTypes = {
  profileImageUrl: _react.PropTypes.string,
  companyName: _react.PropTypes.string,
  userEnteredComment: _react.PropTypes.string,
  companyId: _react.PropTypes.string,
  userId: _react.PropTypes.string,
  userFirstName: _react.PropTypes.string,
  userLastName: _react.PropTypes.string,
  userEmail: _react.PropTypes.string,
  updatingPost: _react.PropTypes.bool,
  commentPostId: _react.PropTypes.string,
  updateProp: _react.PropTypes.func,
  postId: _react.PropTypes.string,
  updateAPost: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var newsfeed = _ref2.newsfeed,
      user = _ref2.user;
  return {
    profileImageUrl: user ? user.getIn(['company', 'profileImageUrl']) : undefined,
    companyName: user ? user.getIn(['company', 'companyName']) : undefined,
    userEnteredComment: newsfeed ? newsfeed.getIn(['postComment', 'comment']) : undefined,
    companyId: user ? user.getIn(['company', 'companyId']) : undefined,
    userId: user ? user.get('id') : undefined,
    userFirstName: user ? user.getIn(['user', 'firstName']) : undefined,
    userLastName: user ? user.getIn(['user', 'lastName']) : undefined,
    userEmail: user ? user.getIn(['user', 'email']) : undefined,
    updatingPost: newsfeed ? newsfeed.get('updatingPost') : undefined,
    commentPostId: newsfeed ? newsfeed.getIn(['postComment', 'postId']) : undefined
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateProps.apply(undefined, arguments));
    },
    updateAPost: function updateAPost() {
      return dispatch(_actions.updatePost.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NewComment);

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _profileImage = __webpack_require__(548);

var _profileImage2 = _interopRequireDefault(_profileImage);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TCNewSignUpPost = function TCNewSignUpPost(props, context) {
  var post = props.post,
      changeRoute = props.changeRoute;


  return _react2.default.createElement(
    'div',
    { style: { clear: 'both', border: '1px solid #d3d3d3', padding: '10px', borderRadius: '3px', marginTop: '10px' } },
    _react2.default.createElement(
      'div',
      { style: { display: 'inline-block', width: '50px', cursor: 'pointer' }, onTouchTap: function onTouchTap() {
          return context.router.push('/company/' + post.newCompId);
        } },
      _react2.default.createElement(_profileImage2.default, {
        className: 'profile-link-image',
        companySlugName: 'TourConnect',
        imageUrl: _ramda2.default.propOr('', 'newProfileImg', post),
        style: { border: '0.5px solid #D3D3D3' }
      })
    ),
    _react2.default.createElement(
      'div',
      {
        style: {
          display: 'inline-block',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          maxWidth: 'calc(100% - 50px)',
          padding: '0 1%',
          fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif"
        }
      },
      _react2.default.createElement(
        'span',
        { style: { cursor: 'pointer', fontSize: '14px', color: 'rgb(0, 188, 212)' }, onTouchTap: function onTouchTap() {
            return context.router.push('/company/' + post.newCompId);
          } },
        post.newCompName
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _materialUi.FontIcon,
          {
            className: 'tc-icon-location_on',
            style: { margin: '0 5px 0 -4px', fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)' }
          },
          _react2.default.createElement(
            'span',
            { style: { fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" } },
            post.newCompCountry
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      'A new ' + (_ramda2.default.propEq('newCompType', 'Contractor', post) ? 'Buyer' : 'Supplier') + ' just signed up! Would you like to connect with them?',
      _react2.default.createElement('br', null),
      _react2.default.createElement(_materialUi.RaisedButton, { onTouchTap: function onTouchTap() {
          return changeRoute('/company/' + post.newCompId);
        }, style: { marginTop: '7px' }, label: 'View Profile', primary: true })
    )
  );
};

TCNewSignUpPost.propTypes = {
  post: _react.PropTypes.object,
  changeRoute: _react.PropTypes.func
};

TCNewSignUpPost.contextTypes = {
  router: _react.PropTypes.object.isRequired
};

exports.default = TCNewSignUpPost;

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkify = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _linkifyIt = __webpack_require__(1642);

var _linkifyIt2 = _interopRequireDefault(_linkifyIt);

var _tlds = __webpack_require__(1648);

var _tlds2 = _interopRequireDefault(_tlds);

var _propTypes = __webpack_require__(1649);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var linkify = exports.linkify = new _linkifyIt2.default();
linkify.tlds(_tlds2.default);

var Linkify = function (_React$Component) {
  _inherits(Linkify, _React$Component);

  function Linkify() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Linkify);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Linkify.__proto__ || Object.getPrototypeOf(Linkify)).call.apply(_ref, [this].concat(args))), _this), _this.parseCounter = 0, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Linkify, [{
    key: 'getMatches',
    value: function getMatches(string) {
      return linkify.match(string);
    }
  }, {
    key: 'parseString',
    value: function parseString(string) {
      var _this2 = this;

      var elements = [];
      if (string === '') {
        return elements;
      }

      var matches = this.getMatches(string);
      if (!matches) {
        return string;
      }

      var lastIndex = 0;
      matches.forEach(function (match, idx) {
        // Push the preceding text if there is any
        if (match.index > lastIndex) {
          elements.push(string.substring(lastIndex, match.index));
        }
        // Shallow update values that specified the match
        var props = { href: match.url, key: 'parse' + _this2.parseCounter + 'match' + idx };
        for (var key in _this2.props.properties) {
          var val = _this2.props.properties[key];
          if (val === Linkify.MATCH) {
            val = match.url;
          }

          props[key] = val;
        }
        elements.push(_react2.default.createElement(_this2.props.component, props, match.text));
        lastIndex = match.lastIndex;
      });

      if (lastIndex < string.length) {
        elements.push(string.substring(lastIndex));
      }

      return elements.length === 1 ? elements[0] : elements;
    }
  }, {
    key: 'parse',
    value: function parse(children) {
      var _this3 = this;

      var parsed = children;

      if (typeof children === 'string') {
        parsed = this.parseString(children);
      } else if (_react2.default.isValidElement(children) && children.type !== 'a' && children.type !== 'button') {
        parsed = _react2.default.cloneElement(children, { key: 'parse' + ++this.parseCounter }, this.parse(children.props.children));
      } else if (children instanceof Array) {
        parsed = children.map(function (child) {
          return _this3.parse(child);
        });
      }

      return parsed;
    }
  }, {
    key: 'render',
    value: function render() {
      this.parseCounter = 0;
      var parsedChildren = this.parse(this.props.children);

      return _react2.default.createElement(
        'span',
        { className: this.props.className },
        parsedChildren
      );
    }
  }]);

  return Linkify;
}(_react2.default.Component);

Linkify.MATCH = 'LINKIFY_MATCH';
Linkify.propTypes = {
  className: _propTypes2.default.string,
  component: _propTypes2.default.any,
  properties: _propTypes2.default.object,
  urlRegex: _propTypes2.default.object,
  emailRegex: _propTypes2.default.object
};
Linkify.defaultProps = {
  className: 'Linkify',
  component: 'a',
  properties: {}
};
exports.default = Linkify;


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



////////////////////////////////////////////////////////////////////////////////
// Helpers

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

function _class(obj) { return Object.prototype.toString.call(obj); }
function isString(obj) { return _class(obj) === '[object String]'; }
function isObject(obj) { return _class(obj) === '[object Object]'; }
function isRegExp(obj) { return _class(obj) === '[object RegExp]'; }
function isFunction(obj) { return _class(obj) === '[object Function]'; }


function escapeRE(str) { return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); }

////////////////////////////////////////////////////////////////////////////////


var defaultOptions = {
  fuzzyLink: true,
  fuzzyEmail: true,
  fuzzyIP: false
};


function isOptionsObj(obj) {
  return Object.keys(obj || {}).reduce(function (acc, k) {
    return acc || defaultOptions.hasOwnProperty(k);
  }, false);
}


var defaultSchemas = {
  'http:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.http) {
        // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.http =  new RegExp(
          '^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i'
        );
      }
      if (self.re.http.test(tail)) {
        return tail.match(self.re.http)[0].length;
      }
      return 0;
    }
  },
  'https:':  'http:',
  'ftp:':    'http:',
  '//':      {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.no_http) {
      // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.no_http =  new RegExp(
          '^' +
          self.re.src_auth +
          // Don't allow single-level domains, because of false positives like '//test'
          // with code comments
          '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' +
          self.re.src_port +
          self.re.src_host_terminator +
          self.re.src_path,

          'i'
        );
      }

      if (self.re.no_http.test(tail)) {
        // should not be `://` & `///`, that protects from errors in protocol name
        if (pos >= 3 && text[pos - 3] === ':') { return 0; }
        if (pos >= 3 && text[pos - 3] === '/') { return 0; }
        return tail.match(self.re.no_http)[0].length;
      }
      return 0;
    }
  },
  'mailto:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.mailto) {
        self.re.mailto =  new RegExp(
          '^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i'
        );
      }
      if (self.re.mailto.test(tail)) {
        return tail.match(self.re.mailto)[0].length;
      }
      return 0;
    }
  }
};

/*eslint-disable max-len*/

// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';

// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');

/*eslint-enable max-len*/

////////////////////////////////////////////////////////////////////////////////

function resetScanCache(self) {
  self.__index__ = -1;
  self.__text_cache__   = '';
}

function createValidator(re) {
  return function (text, pos) {
    var tail = text.slice(pos);

    if (re.test(tail)) {
      return tail.match(re)[0].length;
    }
    return 0;
  };
}

function createNormalizer() {
  return function (match, self) {
    self.normalize(match);
  };
}

// Schemas compiler. Build regexps.
//
function compile(self) {

  // Load & clone RE patterns.
  var re = self.re = assign({}, __webpack_require__(1643));

  // Define dynamic patterns
  var tlds = self.__tlds__.slice();

  if (!self.__tlds_replaced__) {
    tlds.push(tlds_2ch_src_re);
  }
  tlds.push(re.src_xn);

  re.src_tlds = tlds.join('|');

  function untpl(tpl) { return tpl.replace('%TLDS%', re.src_tlds); }

  re.email_fuzzy      = RegExp(untpl(re.tpl_email_fuzzy), 'i');
  re.link_fuzzy       = RegExp(untpl(re.tpl_link_fuzzy), 'i');
  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
  re.host_fuzzy_test  = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');

  //
  // Compile each schema
  //

  var aliases = [];

  self.__compiled__ = {}; // Reset compiled data

  function schemaError(name, val) {
    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
  }

  Object.keys(self.__schemas__).forEach(function (name) {
    var val = self.__schemas__[name];

    // skip disabled methods
    if (val === null) { return; }

    var compiled = { validate: null, link: null };

    self.__compiled__[name] = compiled;

    if (isObject(val)) {
      if (isRegExp(val.validate)) {
        compiled.validate = createValidator(val.validate);
      } else if (isFunction(val.validate)) {
        compiled.validate = val.validate;
      } else {
        schemaError(name, val);
      }

      if (isFunction(val.normalize)) {
        compiled.normalize = val.normalize;
      } else if (!val.normalize) {
        compiled.normalize = createNormalizer();
      } else {
        schemaError(name, val);
      }

      return;
    }

    if (isString(val)) {
      aliases.push(name);
      return;
    }

    schemaError(name, val);
  });

  //
  // Compile postponed aliases
  //

  aliases.forEach(function (alias) {
    if (!self.__compiled__[self.__schemas__[alias]]) {
      // Silently fail on missed schemas to avoid errons on disable.
      // schemaError(alias, self.__schemas__[alias]);
      return;
    }

    self.__compiled__[alias].validate =
      self.__compiled__[self.__schemas__[alias]].validate;
    self.__compiled__[alias].normalize =
      self.__compiled__[self.__schemas__[alias]].normalize;
  });

  //
  // Fake record for guessed links
  //
  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };

  //
  // Build schema condition
  //
  var slist = Object.keys(self.__compiled__)
                      .filter(function (name) {
                        // Filter disabled & fake schemas
                        return name.length > 0 && self.__compiled__[name];
                      })
                      .map(escapeRE)
                      .join('|');
  // (?!_) cause 1.5x slowdown
  self.re.schema_test   = RegExp('(^|(?!_)(?:[><]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
  self.re.schema_search = RegExp('(^|(?!_)(?:[><]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');

  self.re.pretest       = RegExp(
                            '(' + self.re.schema_test.source + ')|' +
                            '(' + self.re.host_fuzzy_test.source + ')|' +
                            '@',
                            'i');

  //
  // Cleanup
  //

  resetScanCache(self);
}

/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/
function Match(self, shift) {
  var start = self.__index__,
      end   = self.__last_index__,
      text  = self.__text_cache__.slice(start, end);

  /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/
  this.schema    = self.__schema__.toLowerCase();
  /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/
  this.index     = start + shift;
  /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/
  this.lastIndex = end + shift;
  /**
   * Match#raw -> String
   *
   * Matched string.
   **/
  this.raw       = text;
  /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/
  this.text      = text;
  /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/
  this.url       = text;
}

function createMatch(self, shift) {
  var match = new Match(self, shift);

  self.__compiled__[match.schema].normalize(match, self);

  return match;
}


/**
 * class LinkifyIt
 **/

/**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/
function LinkifyIt(schemas, options) {
  if (!(this instanceof LinkifyIt)) {
    return new LinkifyIt(schemas, options);
  }

  if (!options) {
    if (isOptionsObj(schemas)) {
      options = schemas;
      schemas = {};
    }
  }

  this.__opts__           = assign({}, defaultOptions, options);

  // Cache last tested result. Used to skip repeating steps on next `match` call.
  this.__index__          = -1;
  this.__last_index__     = -1; // Next scan position
  this.__schema__         = '';
  this.__text_cache__     = '';

  this.__schemas__        = assign({}, defaultSchemas, schemas);
  this.__compiled__       = {};

  this.__tlds__           = tlds_default;
  this.__tlds_replaced__  = false;

  this.re = {};

  compile(this);
}


/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/
LinkifyIt.prototype.add = function add(schema, definition) {
  this.__schemas__[schema] = definition;
  compile(this);
  return this;
};


/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/
LinkifyIt.prototype.set = function set(options) {
  this.__opts__ = assign(this.__opts__, options);
  return this;
};


/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/
LinkifyIt.prototype.test = function test(text) {
  // Reset scan cache
  this.__text_cache__ = text;
  this.__index__      = -1;

  if (!text.length) { return false; }

  var m, ml, me, len, shift, next, re, tld_pos, at_pos;

  // try to scan for link with schema - that's the most simple rule
  if (this.re.schema_test.test(text)) {
    re = this.re.schema_search;
    re.lastIndex = 0;
    while ((m = re.exec(text)) !== null) {
      len = this.testSchemaAt(text, m[2], re.lastIndex);
      if (len) {
        this.__schema__     = m[2];
        this.__index__      = m.index + m[1].length;
        this.__last_index__ = m.index + m[0].length + len;
        break;
      }
    }
  }

  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
    // guess schemaless links
    tld_pos = text.search(this.re.host_fuzzy_test);
    if (tld_pos >= 0) {
      // if tld is located after found link - no need to check fuzzy pattern
      if (this.__index__ < 0 || tld_pos < this.__index__) {
        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {

          shift = ml.index + ml[1].length;

          if (this.__index__ < 0 || shift < this.__index__) {
            this.__schema__     = '';
            this.__index__      = shift;
            this.__last_index__ = ml.index + ml[0].length;
          }
        }
      }
    }
  }

  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
    // guess schemaless emails
    at_pos = text.indexOf('@');
    if (at_pos >= 0) {
      // We can't skip this check, because this cases are possible:
      // 192.168.1.1@gmail.com, my.in@example.com
      if ((me = text.match(this.re.email_fuzzy)) !== null) {

        shift = me.index + me[1].length;
        next  = me.index + me[0].length;

        if (this.__index__ < 0 || shift < this.__index__ ||
            (shift === this.__index__ && next > this.__last_index__)) {
          this.__schema__     = 'mailto:';
          this.__index__      = shift;
          this.__last_index__ = next;
        }
      }
    }
  }

  return this.__index__ >= 0;
};


/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/
LinkifyIt.prototype.pretest = function pretest(text) {
  return this.re.pretest.test(text);
};


/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/
LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
  // If not supported schema check requested - terminate
  if (!this.__compiled__[schema.toLowerCase()]) {
    return 0;
  }
  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};


/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/
LinkifyIt.prototype.match = function match(text) {
  var shift = 0, result = [];

  // Try to take previous element from cache, if .test() called before
  if (this.__index__ >= 0 && this.__text_cache__ === text) {
    result.push(createMatch(this, shift));
    shift = this.__last_index__;
  }

  // Cut head if cache was used
  var tail = shift ? text.slice(shift) : text;

  // Scan string until end reached
  while (this.test(tail)) {
    result.push(createMatch(this, shift));

    tail = tail.slice(this.__last_index__);
    shift += this.__last_index__;
  }

  if (result.length) {
    return result;
  }

  return null;
};


/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/
LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
  list = Array.isArray(list) ? list : [ list ];

  if (!keepOld) {
    this.__tlds__ = list.slice();
    this.__tlds_replaced__ = true;
    compile(this);
    return this;
  }

  this.__tlds__ = this.__tlds__.concat(list)
                                  .sort()
                                  .filter(function (el, idx, arr) {
                                    return el !== arr[idx - 1];
                                  })
                                  .reverse();

  compile(this);
  return this;
};

/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/
LinkifyIt.prototype.normalize = function normalize(match) {

  // Do minimal possible changes by default. Need to collect feedback prior
  // to move forward https://github.com/markdown-it/linkify-it/issues/1

  if (!match.schema) { match.url = 'http://' + match.url; }

  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
    match.url = 'mailto:' + match.url;
  }
};


module.exports = LinkifyIt;


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Use direct extract instead of `regenerate` to reduse browserified size
var src_Any = exports.src_Any = __webpack_require__(1644).source;
var src_Cc  = exports.src_Cc = __webpack_require__(1645).source;
var src_Z   = exports.src_Z  = __webpack_require__(1646).source;
var src_P   = exports.src_P  = __webpack_require__(1647).source;

// \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
var src_ZPCc = exports.src_ZPCc = [ src_Z, src_P, src_Cc ].join('|');

// \p{\Z\Cc} (white spaces + control)
var src_ZCc = exports.src_ZCc = [ src_Z, src_Cc ].join('|');

// All possible word characters (everything without punctuation, spaces & controls)
// Defined via punctuation & spaces to save space
// Should be something like \p{\L\N\S\M} (\w but without `_`)
var src_pseudo_letter       = '(?:(?!>|<|' + src_ZPCc + ')' + src_Any + ')';
// The same as abothe but without [0-9]
// var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';

////////////////////////////////////////////////////////////////////////////////

var src_ip4 = exports.src_ip4 =

  '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';

// Prohibit [@/] in user/pass to avoid wrong domain fetch.
exports.src_auth    = '(?:(?:(?!' + src_ZCc + '|[@/]).)+@)?';

var src_port = exports.src_port =

  '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';

var src_host_terminator = exports.src_host_terminator =

  '(?=$|>|<|' + src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + src_ZPCc + '))';

var src_path = exports.src_path =

  '(?:' +
    '[/?#]' +
      '(?:' +
        '(?!' + src_ZCc + '|[()[\\]{}.,"\'?!\\-<>]).|' +
        '\\[(?:(?!' + src_ZCc + '|\\]).)*\\]|' +
        '\\((?:(?!' + src_ZCc + '|[)]).)*\\)|' +
        '\\{(?:(?!' + src_ZCc + '|[}]).)*\\}|' +
        '\\"(?:(?!' + src_ZCc + '|["]).)+\\"|' +
        "\\'(?:(?!" + src_ZCc + "|[']).)+\\'|" +
        "\\'(?=" + src_pseudo_letter + ').|' +  // allow `I'm_king` if no pair found
        '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
                                   // - english
                                   // - percent-encoded
                                   // - parts of file path
                                   // until more examples found.
        '\\.(?!' + src_ZCc + '|[.]).|' +
        '\\-(?!--(?:[^-]|$))(?:-*)|' +  // `---` => long dash, terminate
        '\\,(?!' + src_ZCc + ').|' +      // allow `,,,` in paths
        '\\!(?!' + src_ZCc + '|[!]).|' +
        '\\?(?!' + src_ZCc + '|[?]).' +
      ')+' +
    '|\\/' +
  ')?';

var src_email_name = exports.src_email_name =

  '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';

var src_xn = exports.src_xn =

  'xn--[a-z0-9\\-]{1,59}';

// More to read about domain names
// http://serverfault.com/questions/638260/

var src_domain_root = exports.src_domain_root =

  // Allow letters & digits (http://test1)
  '(?:' +
    src_xn +
    '|' +
    src_pseudo_letter + '{1,63}' +
  ')';

var src_domain = exports.src_domain =

  '(?:' +
    src_xn +
    '|' +
    '(?:' + src_pseudo_letter + ')' +
    '|' +
    // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + src_pseudo_letter + '(?:-(?!-)|' + src_pseudo_letter + '){0,61}' + src_pseudo_letter + ')' +
  ')';

var src_host = exports.src_host =

  '(?:' +
  // Don't need IP check, because digits are already allowed in normal domain names
  //   src_ip4 +
  // '|' +
    '(?:(?:(?:' + src_domain + ')\\.)*' + src_domain_root + ')' +
  ')';

var tpl_host_fuzzy = exports.tpl_host_fuzzy =

  '(?:' +
    src_ip4 +
  '|' +
    '(?:(?:(?:' + src_domain + ')\\.)+(?:%TLDS%))' +
  ')';

var tpl_host_no_ip_fuzzy = exports.tpl_host_no_ip_fuzzy =

  '(?:(?:(?:' + src_domain + ')\\.)+(?:%TLDS%))';

exports.src_host_strict =

  src_host + src_host_terminator;

var tpl_host_fuzzy_strict = exports.tpl_host_fuzzy_strict =

  tpl_host_fuzzy + src_host_terminator;

exports.src_host_port_strict =

  src_host + src_port + src_host_terminator;

var tpl_host_port_fuzzy_strict = exports.tpl_host_port_fuzzy_strict =

  tpl_host_fuzzy + src_port + src_host_terminator;

var tpl_host_port_no_ip_fuzzy_strict = exports.tpl_host_port_no_ip_fuzzy_strict =

  tpl_host_no_ip_fuzzy + src_port + src_host_terminator;


////////////////////////////////////////////////////////////////////////////////
// Main rules

// Rude test fuzzy links by host, for quick deny
exports.tpl_host_fuzzy_test =

  'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + src_ZPCc + '|>|$))';

exports.tpl_email_fuzzy =

    '(^|<|>|\\(|' + src_ZCc + ')(' + src_email_name + '@' + tpl_host_fuzzy_strict + ')';

exports.tpl_link_fuzzy =
    // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|]|' + src_ZPCc + '))' +
    '((?![$+<=>^`|])' + tpl_host_port_fuzzy_strict + src_path + ')';

exports.tpl_link_no_ip_fuzzy =
    // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|]|' + src_ZPCc + '))' +
    '((?![$+<=>^`|])' + tpl_host_port_no_ip_fuzzy_strict + src_path + ')';


/***/ }),
/* 1644 */
/***/ (function(module, exports) {

module.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/

/***/ }),
/* 1645 */
/***/ (function(module, exports) {

module.exports=/[\0-\x1F\x7F-\x9F]/

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

module.exports=/[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

module.exports=/[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

module.exports = [
  "aaa",
  "aarp",
  "abarth",
  "abb",
  "abbott",
  "abbvie",
  "abc",
  "able",
  "abogado",
  "abudhabi",
  "ac",
  "academy",
  "accenture",
  "accountant",
  "accountants",
  "aco",
  "active",
  "actor",
  "ad",
  "adac",
  "ads",
  "adult",
  "ae",
  "aeg",
  "aero",
  "aetna",
  "af",
  "afamilycompany",
  "afl",
  "africa",
  "ag",
  "agakhan",
  "agency",
  "ai",
  "aig",
  "aigo",
  "airbus",
  "airforce",
  "airtel",
  "akdn",
  "al",
  "alfaromeo",
  "alibaba",
  "alipay",
  "allfinanz",
  "allstate",
  "ally",
  "alsace",
  "alstom",
  "am",
  "americanexpress",
  "americanfamily",
  "amex",
  "amfam",
  "amica",
  "amsterdam",
  "analytics",
  "android",
  "anquan",
  "anz",
  "ao",
  "aol",
  "apartments",
  "app",
  "apple",
  "aq",
  "aquarelle",
  "ar",
  "arab",
  "aramco",
  "archi",
  "army",
  "arpa",
  "art",
  "arte",
  "as",
  "asda",
  "asia",
  "associates",
  "at",
  "athleta",
  "attorney",
  "au",
  "auction",
  "audi",
  "audible",
  "audio",
  "auspost",
  "author",
  "auto",
  "autos",
  "avianca",
  "aw",
  "aws",
  "ax",
  "axa",
  "az",
  "azure",
  "ba",
  "baby",
  "baidu",
  "banamex",
  "bananarepublic",
  "band",
  "bank",
  "bar",
  "barcelona",
  "barclaycard",
  "barclays",
  "barefoot",
  "bargains",
  "baseball",
  "basketball",
  "bauhaus",
  "bayern",
  "bb",
  "bbc",
  "bbt",
  "bbva",
  "bcg",
  "bcn",
  "bd",
  "be",
  "beats",
  "beauty",
  "beer",
  "bentley",
  "berlin",
  "best",
  "bestbuy",
  "bet",
  "bf",
  "bg",
  "bh",
  "bharti",
  "bi",
  "bible",
  "bid",
  "bike",
  "bing",
  "bingo",
  "bio",
  "biz",
  "bj",
  "black",
  "blackfriday",
  "blanco",
  "blockbuster",
  "blog",
  "bloomberg",
  "blue",
  "bm",
  "bms",
  "bmw",
  "bn",
  "bnl",
  "bnpparibas",
  "bo",
  "boats",
  "boehringer",
  "bofa",
  "bom",
  "bond",
  "boo",
  "book",
  "booking",
  "bosch",
  "bostik",
  "boston",
  "bot",
  "boutique",
  "box",
  "br",
  "bradesco",
  "bridgestone",
  "broadway",
  "broker",
  "brother",
  "brussels",
  "bs",
  "bt",
  "budapest",
  "bugatti",
  "build",
  "builders",
  "business",
  "buy",
  "buzz",
  "bv",
  "bw",
  "by",
  "bz",
  "bzh",
  "ca",
  "cab",
  "cafe",
  "cal",
  "call",
  "calvinklein",
  "cam",
  "camera",
  "camp",
  "cancerresearch",
  "canon",
  "capetown",
  "capital",
  "capitalone",
  "car",
  "caravan",
  "cards",
  "care",
  "career",
  "careers",
  "cars",
  "cartier",
  "casa",
  "case",
  "caseih",
  "cash",
  "casino",
  "cat",
  "catering",
  "catholic",
  "cba",
  "cbn",
  "cbre",
  "cbs",
  "cc",
  "cd",
  "ceb",
  "center",
  "ceo",
  "cern",
  "cf",
  "cfa",
  "cfd",
  "cg",
  "ch",
  "chanel",
  "channel",
  "chase",
  "chat",
  "cheap",
  "chintai",
  "christmas",
  "chrome",
  "chrysler",
  "church",
  "ci",
  "cipriani",
  "circle",
  "cisco",
  "citadel",
  "citi",
  "citic",
  "city",
  "cityeats",
  "ck",
  "cl",
  "claims",
  "cleaning",
  "click",
  "clinic",
  "clinique",
  "clothing",
  "cloud",
  "club",
  "clubmed",
  "cm",
  "cn",
  "co",
  "coach",
  "codes",
  "coffee",
  "college",
  "cologne",
  "com",
  "comcast",
  "commbank",
  "community",
  "company",
  "compare",
  "computer",
  "comsec",
  "condos",
  "construction",
  "consulting",
  "contact",
  "contractors",
  "cooking",
  "cookingchannel",
  "cool",
  "coop",
  "corsica",
  "country",
  "coupon",
  "coupons",
  "courses",
  "cr",
  "credit",
  "creditcard",
  "creditunion",
  "cricket",
  "crown",
  "crs",
  "cruise",
  "cruises",
  "csc",
  "cu",
  "cuisinella",
  "cv",
  "cw",
  "cx",
  "cy",
  "cymru",
  "cyou",
  "cz",
  "dabur",
  "dad",
  "dance",
  "data",
  "date",
  "dating",
  "datsun",
  "day",
  "dclk",
  "dds",
  "de",
  "deal",
  "dealer",
  "deals",
  "degree",
  "delivery",
  "dell",
  "deloitte",
  "delta",
  "democrat",
  "dental",
  "dentist",
  "desi",
  "design",
  "dev",
  "dhl",
  "diamonds",
  "diet",
  "digital",
  "direct",
  "directory",
  "discount",
  "discover",
  "dish",
  "diy",
  "dj",
  "dk",
  "dm",
  "dnp",
  "do",
  "docs",
  "doctor",
  "dodge",
  "dog",
  "doha",
  "domains",
  "dot",
  "download",
  "drive",
  "dtv",
  "dubai",
  "duck",
  "dunlop",
  "duns",
  "dupont",
  "durban",
  "dvag",
  "dvr",
  "dz",
  "earth",
  "eat",
  "ec",
  "eco",
  "edeka",
  "edu",
  "education",
  "ee",
  "eg",
  "email",
  "emerck",
  "energy",
  "engineer",
  "engineering",
  "enterprises",
  "epost",
  "epson",
  "equipment",
  "er",
  "ericsson",
  "erni",
  "es",
  "esq",
  "estate",
  "esurance",
  "et",
  "etisalat",
  "eu",
  "eurovision",
  "eus",
  "events",
  "everbank",
  "exchange",
  "expert",
  "exposed",
  "express",
  "extraspace",
  "fage",
  "fail",
  "fairwinds",
  "faith",
  "family",
  "fan",
  "fans",
  "farm",
  "farmers",
  "fashion",
  "fast",
  "fedex",
  "feedback",
  "ferrari",
  "ferrero",
  "fi",
  "fiat",
  "fidelity",
  "fido",
  "film",
  "final",
  "finance",
  "financial",
  "fire",
  "firestone",
  "firmdale",
  "fish",
  "fishing",
  "fit",
  "fitness",
  "fj",
  "fk",
  "flickr",
  "flights",
  "flir",
  "florist",
  "flowers",
  "fly",
  "fm",
  "fo",
  "foo",
  "food",
  "foodnetwork",
  "football",
  "ford",
  "forex",
  "forsale",
  "forum",
  "foundation",
  "fox",
  "fr",
  "free",
  "fresenius",
  "frl",
  "frogans",
  "frontdoor",
  "frontier",
  "ftr",
  "fujitsu",
  "fujixerox",
  "fun",
  "fund",
  "furniture",
  "futbol",
  "fyi",
  "ga",
  "gal",
  "gallery",
  "gallo",
  "gallup",
  "game",
  "games",
  "gap",
  "garden",
  "gb",
  "gbiz",
  "gd",
  "gdn",
  "ge",
  "gea",
  "gent",
  "genting",
  "george",
  "gf",
  "gg",
  "ggee",
  "gh",
  "gi",
  "gift",
  "gifts",
  "gives",
  "giving",
  "gl",
  "glade",
  "glass",
  "gle",
  "global",
  "globo",
  "gm",
  "gmail",
  "gmbh",
  "gmo",
  "gmx",
  "gn",
  "godaddy",
  "gold",
  "goldpoint",
  "golf",
  "goo",
  "goodhands",
  "goodyear",
  "goog",
  "google",
  "gop",
  "got",
  "gov",
  "gp",
  "gq",
  "gr",
  "grainger",
  "graphics",
  "gratis",
  "green",
  "gripe",
  "grocery",
  "group",
  "gs",
  "gt",
  "gu",
  "guardian",
  "gucci",
  "guge",
  "guide",
  "guitars",
  "guru",
  "gw",
  "gy",
  "hair",
  "hamburg",
  "hangout",
  "haus",
  "hbo",
  "hdfc",
  "hdfcbank",
  "health",
  "healthcare",
  "help",
  "helsinki",
  "here",
  "hermes",
  "hgtv",
  "hiphop",
  "hisamitsu",
  "hitachi",
  "hiv",
  "hk",
  "hkt",
  "hm",
  "hn",
  "hockey",
  "holdings",
  "holiday",
  "homedepot",
  "homegoods",
  "homes",
  "homesense",
  "honda",
  "honeywell",
  "horse",
  "hospital",
  "host",
  "hosting",
  "hot",
  "hoteles",
  "hotels",
  "hotmail",
  "house",
  "how",
  "hr",
  "hsbc",
  "ht",
  "hu",
  "hughes",
  "hyatt",
  "hyundai",
  "ibm",
  "icbc",
  "ice",
  "icu",
  "id",
  "ie",
  "ieee",
  "ifm",
  "ikano",
  "il",
  "im",
  "imamat",
  "imdb",
  "immo",
  "immobilien",
  "in",
  "industries",
  "infiniti",
  "info",
  "ing",
  "ink",
  "institute",
  "insurance",
  "insure",
  "int",
  "intel",
  "international",
  "intuit",
  "investments",
  "io",
  "ipiranga",
  "iq",
  "ir",
  "irish",
  "is",
  "iselect",
  "ismaili",
  "ist",
  "istanbul",
  "it",
  "itau",
  "itv",
  "iveco",
  "iwc",
  "jaguar",
  "java",
  "jcb",
  "jcp",
  "je",
  "jeep",
  "jetzt",
  "jewelry",
  "jio",
  "jlc",
  "jll",
  "jm",
  "jmp",
  "jnj",
  "jo",
  "jobs",
  "joburg",
  "jot",
  "joy",
  "jp",
  "jpmorgan",
  "jprs",
  "juegos",
  "juniper",
  "kaufen",
  "kddi",
  "ke",
  "kerryhotels",
  "kerrylogistics",
  "kerryproperties",
  "kfh",
  "kg",
  "kh",
  "ki",
  "kia",
  "kim",
  "kinder",
  "kindle",
  "kitchen",
  "kiwi",
  "km",
  "kn",
  "koeln",
  "komatsu",
  "kosher",
  "kp",
  "kpmg",
  "kpn",
  "kr",
  "krd",
  "kred",
  "kuokgroup",
  "kw",
  "ky",
  "kyoto",
  "kz",
  "la",
  "lacaixa",
  "ladbrokes",
  "lamborghini",
  "lamer",
  "lancaster",
  "lancia",
  "lancome",
  "land",
  "landrover",
  "lanxess",
  "lasalle",
  "lat",
  "latino",
  "latrobe",
  "law",
  "lawyer",
  "lb",
  "lc",
  "lds",
  "lease",
  "leclerc",
  "lefrak",
  "legal",
  "lego",
  "lexus",
  "lgbt",
  "li",
  "liaison",
  "lidl",
  "life",
  "lifeinsurance",
  "lifestyle",
  "lighting",
  "like",
  "lilly",
  "limited",
  "limo",
  "lincoln",
  "linde",
  "link",
  "lipsy",
  "live",
  "living",
  "lixil",
  "lk",
  "llc",
  "loan",
  "loans",
  "locker",
  "locus",
  "loft",
  "lol",
  "london",
  "lotte",
  "lotto",
  "love",
  "lpl",
  "lplfinancial",
  "lr",
  "ls",
  "lt",
  "ltd",
  "ltda",
  "lu",
  "lundbeck",
  "lupin",
  "luxe",
  "luxury",
  "lv",
  "ly",
  "ma",
  "macys",
  "madrid",
  "maif",
  "maison",
  "makeup",
  "man",
  "management",
  "mango",
  "map",
  "market",
  "marketing",
  "markets",
  "marriott",
  "marshalls",
  "maserati",
  "mattel",
  "mba",
  "mc",
  "mckinsey",
  "md",
  "me",
  "med",
  "media",
  "meet",
  "melbourne",
  "meme",
  "memorial",
  "men",
  "menu",
  "meo",
  "merckmsd",
  "metlife",
  "mg",
  "mh",
  "miami",
  "microsoft",
  "mil",
  "mini",
  "mint",
  "mit",
  "mitsubishi",
  "mk",
  "ml",
  "mlb",
  "mls",
  "mm",
  "mma",
  "mn",
  "mo",
  "mobi",
  "mobile",
  "mobily",
  "moda",
  "moe",
  "moi",
  "mom",
  "monash",
  "money",
  "monster",
  "mopar",
  "mormon",
  "mortgage",
  "moscow",
  "moto",
  "motorcycles",
  "mov",
  "movie",
  "movistar",
  "mp",
  "mq",
  "mr",
  "ms",
  "msd",
  "mt",
  "mtn",
  "mtr",
  "mu",
  "museum",
  "mutual",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nab",
  "nadex",
  "nagoya",
  "name",
  "nationwide",
  "natura",
  "navy",
  "nba",
  "nc",
  "ne",
  "nec",
  "net",
  "netbank",
  "netflix",
  "network",
  "neustar",
  "new",
  "newholland",
  "news",
  "next",
  "nextdirect",
  "nexus",
  "nf",
  "nfl",
  "ng",
  "ngo",
  "nhk",
  "ni",
  "nico",
  "nike",
  "nikon",
  "ninja",
  "nissan",
  "nissay",
  "nl",
  "no",
  "nokia",
  "northwesternmutual",
  "norton",
  "now",
  "nowruz",
  "nowtv",
  "np",
  "nr",
  "nra",
  "nrw",
  "ntt",
  "nu",
  "nyc",
  "nz",
  "obi",
  "observer",
  "off",
  "office",
  "okinawa",
  "olayan",
  "olayangroup",
  "oldnavy",
  "ollo",
  "om",
  "omega",
  "one",
  "ong",
  "onl",
  "online",
  "onyourside",
  "ooo",
  "open",
  "oracle",
  "orange",
  "org",
  "organic",
  "origins",
  "osaka",
  "otsuka",
  "ott",
  "ovh",
  "pa",
  "page",
  "panasonic",
  "panerai",
  "paris",
  "pars",
  "partners",
  "parts",
  "party",
  "passagens",
  "pay",
  "pccw",
  "pe",
  "pet",
  "pf",
  "pfizer",
  "pg",
  "ph",
  "pharmacy",
  "phd",
  "philips",
  "phone",
  "photo",
  "photography",
  "photos",
  "physio",
  "piaget",
  "pics",
  "pictet",
  "pictures",
  "pid",
  "pin",
  "ping",
  "pink",
  "pioneer",
  "pizza",
  "pk",
  "pl",
  "place",
  "play",
  "playstation",
  "plumbing",
  "plus",
  "pm",
  "pn",
  "pnc",
  "pohl",
  "poker",
  "politie",
  "porn",
  "post",
  "pr",
  "pramerica",
  "praxi",
  "press",
  "prime",
  "pro",
  "prod",
  "productions",
  "prof",
  "progressive",
  "promo",
  "properties",
  "property",
  "protection",
  "pru",
  "prudential",
  "ps",
  "pt",
  "pub",
  "pw",
  "pwc",
  "py",
  "qa",
  "qpon",
  "quebec",
  "quest",
  "qvc",
  "racing",
  "radio",
  "raid",
  "re",
  "read",
  "realestate",
  "realtor",
  "realty",
  "recipes",
  "red",
  "redstone",
  "redumbrella",
  "rehab",
  "reise",
  "reisen",
  "reit",
  "reliance",
  "ren",
  "rent",
  "rentals",
  "repair",
  "report",
  "republican",
  "rest",
  "restaurant",
  "review",
  "reviews",
  "rexroth",
  "rich",
  "richardli",
  "ricoh",
  "rightathome",
  "ril",
  "rio",
  "rip",
  "rmit",
  "ro",
  "rocher",
  "rocks",
  "rodeo",
  "rogers",
  "room",
  "rs",
  "rsvp",
  "ru",
  "rugby",
  "ruhr",
  "run",
  "rw",
  "rwe",
  "ryukyu",
  "sa",
  "saarland",
  "safe",
  "safety",
  "sakura",
  "sale",
  "salon",
  "samsclub",
  "samsung",
  "sandvik",
  "sandvikcoromant",
  "sanofi",
  "sap",
  "sapo",
  "sarl",
  "sas",
  "save",
  "saxo",
  "sb",
  "sbi",
  "sbs",
  "sc",
  "sca",
  "scb",
  "schaeffler",
  "schmidt",
  "scholarships",
  "school",
  "schule",
  "schwarz",
  "science",
  "scjohnson",
  "scor",
  "scot",
  "sd",
  "se",
  "search",
  "seat",
  "secure",
  "security",
  "seek",
  "select",
  "sener",
  "services",
  "ses",
  "seven",
  "sew",
  "sex",
  "sexy",
  "sfr",
  "sg",
  "sh",
  "shangrila",
  "sharp",
  "shaw",
  "shell",
  "shia",
  "shiksha",
  "shoes",
  "shop",
  "shopping",
  "shouji",
  "show",
  "showtime",
  "shriram",
  "si",
  "silk",
  "sina",
  "singles",
  "site",
  "sj",
  "sk",
  "ski",
  "skin",
  "sky",
  "skype",
  "sl",
  "sling",
  "sm",
  "smart",
  "smile",
  "sn",
  "sncf",
  "so",
  "soccer",
  "social",
  "softbank",
  "software",
  "sohu",
  "solar",
  "solutions",
  "song",
  "sony",
  "soy",
  "space",
  "spiegel",
  "sport",
  "spot",
  "spreadbetting",
  "sr",
  "srl",
  "srt",
  "st",
  "stada",
  "staples",
  "star",
  "starhub",
  "statebank",
  "statefarm",
  "statoil",
  "stc",
  "stcgroup",
  "stockholm",
  "storage",
  "store",
  "stream",
  "studio",
  "study",
  "style",
  "su",
  "sucks",
  "supplies",
  "supply",
  "support",
  "surf",
  "surgery",
  "suzuki",
  "sv",
  "swatch",
  "swiftcover",
  "swiss",
  "sx",
  "sy",
  "sydney",
  "symantec",
  "systems",
  "sz",
  "tab",
  "taipei",
  "talk",
  "taobao",
  "target",
  "tatamotors",
  "tatar",
  "tattoo",
  "tax",
  "taxi",
  "tc",
  "tci",
  "td",
  "tdk",
  "team",
  "tech",
  "technology",
  "tel",
  "telecity",
  "telefonica",
  "temasek",
  "tennis",
  "teva",
  "tf",
  "tg",
  "th",
  "thd",
  "theater",
  "theatre",
  "tiaa",
  "tickets",
  "tienda",
  "tiffany",
  "tips",
  "tires",
  "tirol",
  "tj",
  "tjmaxx",
  "tjx",
  "tk",
  "tkmaxx",
  "tl",
  "tm",
  "tmall",
  "tn",
  "to",
  "today",
  "tokyo",
  "tools",
  "top",
  "toray",
  "toshiba",
  "total",
  "tours",
  "town",
  "toyota",
  "toys",
  "tr",
  "trade",
  "trading",
  "training",
  "travel",
  "travelchannel",
  "travelers",
  "travelersinsurance",
  "trust",
  "trv",
  "tt",
  "tube",
  "tui",
  "tunes",
  "tushu",
  "tv",
  "tvs",
  "tw",
  "tz",
  "ua",
  "ubank",
  "ubs",
  "uconnect",
  "ug",
  "uk",
  "unicom",
  "university",
  "uno",
  "uol",
  "ups",
  "us",
  "uy",
  "uz",
  "va",
  "vacations",
  "vana",
  "vanguard",
  "vc",
  "ve",
  "vegas",
  "ventures",
  "verisign",
  "versicherung",
  "vet",
  "vg",
  "vi",
  "viajes",
  "video",
  "vig",
  "viking",
  "villas",
  "vin",
  "vip",
  "virgin",
  "visa",
  "vision",
  "vista",
  "vistaprint",
  "viva",
  "vivo",
  "vlaanderen",
  "vn",
  "vodka",
  "volkswagen",
  "volvo",
  "vote",
  "voting",
  "voto",
  "voyage",
  "vu",
  "vuelos",
  "wales",
  "walmart",
  "walter",
  "wang",
  "wanggou",
  "warman",
  "watch",
  "watches",
  "weather",
  "weatherchannel",
  "webcam",
  "weber",
  "website",
  "wed",
  "wedding",
  "weibo",
  "weir",
  "wf",
  "whoswho",
  "wien",
  "wiki",
  "williamhill",
  "win",
  "windows",
  "wine",
  "winners",
  "wme",
  "wolterskluwer",
  "woodside",
  "work",
  "works",
  "world",
  "wow",
  "ws",
  "wtc",
  "wtf",
  "xbox",
  "xerox",
  "xfinity",
  "xihuan",
  "xin",
  "कॉम", // xn--11b4c3d
  "セール", // xn--1ck2e1b
  "佛山", // xn--1qqw23a
  "ಭಾರತ", // xn--2scrj9c
  "慈善", // xn--30rr7y
  "集团", // xn--3bst00m
  "在线", // xn--3ds443g
  "한국", // xn--3e0b707e
  "ଭାରତ", // xn--3hcrj9c
  "大众汽车", // xn--3oq18vl8pn36a
  "点看", // xn--3pxu8k
  "คอม", // xn--42c2d9a
  "ভাৰত", // xn--45br5cyl
  "ভারত", // xn--45brj9c
  "八卦", // xn--45q11c
  "موقع", // xn--4gbrim
  "বাংলা", // xn--54b7fta0cc
  "公益", // xn--55qw42g
  "公司", // xn--55qx5d
  "香格里拉", // xn--5su34j936bgsg
  "网站", // xn--5tzm5g
  "移动", // xn--6frz82g
  "我爱你", // xn--6qq986b3xl
  "москва", // xn--80adxhks
  "қаз", // xn--80ao21a
  "католик", // xn--80aqecdr1a
  "онлайн", // xn--80asehdb
  "сайт", // xn--80aswg
  "联通", // xn--8y0a063a
  "срб", // xn--90a3ac
  "бг", // xn--90ae
  "бел", // xn--90ais
  "קום", // xn--9dbq2a
  "时尚", // xn--9et52u
  "微博", // xn--9krt00a
  "淡马锡", // xn--b4w605ferd
  "ファッション", // xn--bck1b9a5dre4c
  "орг", // xn--c1avg
  "नेट", // xn--c2br7g
  "ストア", // xn--cck2b3b
  "삼성", // xn--cg4bki
  "சிங்கப்பூர்", // xn--clchc0ea0b2g2a9gcd
  "商标", // xn--czr694b
  "商店", // xn--czrs0t
  "商城", // xn--czru2d
  "дети", // xn--d1acj3b
  "мкд", // xn--d1alf
  "ею", // xn--e1a4c
  "ポイント", // xn--eckvdtc9d
  "新闻", // xn--efvy88h
  "工行", // xn--estv75g
  "家電", // xn--fct429k
  "كوم", // xn--fhbei
  "中文网", // xn--fiq228c5hs
  "中信", // xn--fiq64b
  "中国", // xn--fiqs8s
  "中國", // xn--fiqz9s
  "娱乐", // xn--fjq720a
  "谷歌", // xn--flw351e
  "భారత్", // xn--fpcrj9c3d
  "ලංකා", // xn--fzc2c9e2c
  "電訊盈科", // xn--fzys8d69uvgm
  "购物", // xn--g2xx48c
  "クラウド", // xn--gckr3f0f
  "ભારત", // xn--gecrj9c
  "通販", // xn--gk3at1e
  "भारतम्", // xn--h2breg3eve
  "भारत", // xn--h2brj9c
  "भारोत", // xn--h2brj9c8c
  "网店", // xn--hxt814e
  "संगठन", // xn--i1b6b1a6a2e
  "餐厅", // xn--imr513n
  "网络", // xn--io0a7i
  "ком", // xn--j1aef
  "укр", // xn--j1amh
  "香港", // xn--j6w193g
  "诺基亚", // xn--jlq61u9w7b
  "食品", // xn--jvr189m
  "飞利浦", // xn--kcrx77d1x4a
  "台湾", // xn--kprw13d
  "台灣", // xn--kpry57d
  "手表", // xn--kpu716f
  "手机", // xn--kput3i
  "мон", // xn--l1acc
  "الجزائر", // xn--lgbbat1ad8j
  "عمان", // xn--mgb9awbf
  "ارامكو", // xn--mgba3a3ejt
  "ایران", // xn--mgba3a4f16a
  "العليان", // xn--mgba7c0bbn0a
  "اتصالات", // xn--mgbaakc7dvf
  "امارات", // xn--mgbaam7a8h
  "بازار", // xn--mgbab2bd
  "پاکستان", // xn--mgbai9azgqp6j
  "الاردن", // xn--mgbayh7gpa
  "موبايلي", // xn--mgbb9fbpob
  "بارت", // xn--mgbbh1a
  "بھارت", // xn--mgbbh1a71e
  "المغرب", // xn--mgbc0a9azcg
  "ابوظبي", // xn--mgbca7dzdo
  "السعودية", // xn--mgberp4a5d4ar
  "ڀارت", // xn--mgbgu82a
  "كاثوليك", // xn--mgbi4ecexp
  "سودان", // xn--mgbpl2fh
  "همراه", // xn--mgbt3dhd
  "عراق", // xn--mgbtx2b
  "مليسيا", // xn--mgbx4cd0ab
  "澳門", // xn--mix891f
  "닷컴", // xn--mk1bu44c
  "政府", // xn--mxtq1m
  "شبكة", // xn--ngbc5azd
  "بيتك", // xn--ngbe9e0a
  "عرب", // xn--ngbrx
  "გე", // xn--node
  "机构", // xn--nqv7f
  "组织机构", // xn--nqv7fs00ema
  "健康", // xn--nyqy26a
  "ไทย", // xn--o3cw4h
  "سورية", // xn--ogbpf8fl
  "招聘", // xn--otu796d
  "рус", // xn--p1acf
  "рф", // xn--p1ai
  "珠宝", // xn--pbt977c
  "تونس", // xn--pgbs0dh
  "大拿", // xn--pssy2u
  "みんな", // xn--q9jyb4c
  "グーグル", // xn--qcka1pmc
  "ελ", // xn--qxam
  "世界", // xn--rhqv96g
  "書籍", // xn--rovu88b
  "ഭാരതം", // xn--rvc1e0am3e
  "ਭਾਰਤ", // xn--s9brj9c
  "网址", // xn--ses554g
  "닷넷", // xn--t60b56a
  "コム", // xn--tckwe
  "天主教", // xn--tiq49xqyj
  "游戏", // xn--unup4y
  "vermögensberater", // xn--vermgensberater-ctb
  "vermögensberatung", // xn--vermgensberatung-pwb
  "企业", // xn--vhquv
  "信息", // xn--vuq861b
  "嘉里大酒店", // xn--w4r85el8fhu5dnra
  "嘉里", // xn--w4rs40l
  "مصر", // xn--wgbh1c
  "قطر", // xn--wgbl6a
  "广东", // xn--xhq521b
  "இலங்கை", // xn--xkc2al3hye2a
  "இந்தியா", // xn--xkc2dl3a5ee0h
  "հայ", // xn--y9a3aq
  "新加坡", // xn--yfro4i67o
  "فلسطين", // xn--ygbi2ammx
  "政务", // xn--zfr164b
  "xperia",
  "xxx",
  "xyz",
  "yachts",
  "yahoo",
  "yamaxun",
  "yandex",
  "ye",
  "yodobashi",
  "yoga",
  "yokohama",
  "you",
  "youtube",
  "yt",
  "yun",
  "za",
  "zappos",
  "zara",
  "zero",
  "zip",
  "zippo",
  "zm",
  "zone",
  "zuerich",
  "zw"
];


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1650)();
}


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1651);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseMessage = exports.getHashTagsFromString = undefined;

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getHashTagsFromString = exports.getHashTagsFromString = _ramda2.default.compose(_ramda2.default.map(function (str) {
  return str.toLowerCase();
}), _ramda2.default.uniq, _ramda2.default.match(/#\w+/g));

var parseMessage = exports.parseMessage = function parseMessage(str) {
  var splitted = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.filter(_ramda2.default.prop('value')), _ramda2.default.flatten, _ramda2.default.addIndex(_ramda2.default.map)(function (subStr, i) {
    if (i) {
      var addedBackHash = '#' + subStr;
      var tag = _ramda2.default.match(/#\w+/g)(addedBackHash)[0];
      return [{
        value: tag,
        type: 'hashtag'
      }, {
        value: addedBackHash.replace(tag, ''),
        type: 'string'
      }];
    }
    return {
      value: subStr,
      type: 'string'
    };
  }), _ramda2.default.split('#')), str);
  return splitted;
};

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileCloud = function FileCloud(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z' })
  );
};
FileCloud = (0, _pure2.default)(FileCloud);
FileCloud.displayName = 'FileCloud';
FileCloud.muiName = 'SvgIcon';

exports.default = FileCloud;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _actions = __webpack_require__(1007);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _signup = __webpack_require__(1655);

var _signup2 = _interopRequireDefault(_signup);

var _singlePostContainer = __webpack_require__(1154);

var _singlePostContainer2 = _interopRequireDefault(_singlePostContainer);

var _internalExtraAction = __webpack_require__(1656);

var _internalExtraAction2 = _interopRequireDefault(_internalExtraAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PublicPost = function PublicPost(props, context) {
  var publicPostReducer = props.publicPostReducer,
      companyName = props.companyName,
      updateProp = props.updateProp,
      displayType = props.displayType,
      postId = props.postId;


  var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);
  var isTCUser = !isNilOrEmpty(companyName);
  var pluralPostCompanyName = _ramda2.default.equals('s', _ramda2.default.last(publicPostReducer.companyName)) ? publicPostReducer.companyName + '\'' : publicPostReducer.companyName + '\'s';

  return _react2.default.createElement(
    'div',
    { style: { top: '75px', position: 'relative', paddingBottom: '100px', width: '70%', margin: 'auto' } },
    publicPostReducer.gettingPost ? _react2.default.createElement(
      'div',
      { style: { textAlign: 'center', display: 'block' } },
      _react2.default.createElement(_materialUi.CircularProgress, { size: 100, style: { marginTop: '100px' } })
    ) : _react2.default.createElement(
      'div',
      { className: 'Grid' },
      _react2.default.createElement(
        'div',
        { className: 'Grid-cell Grid--center' },
        _react2.default.createElement(
          'div',
          { style: { width: '70%', margin: '10px auto', color: 'rgba(0, 0, 0, 0.54)' } },
          _react2.default.createElement(_singlePostContainer2.default, { loaded: true, body: publicPostReducer, displayType: displayType, postId: postId })
        ),
        isTCUser ? _react2.default.createElement(_internalExtraAction2.default, { postCompName: pluralPostCompanyName, goToPostCompProfile: function goToPostCompProfile() {
            return context.router.push('/company/' + publicPostReducer.companyId);
          } }) : _react2.default.createElement(_signup2.default, { postCompName: pluralPostCompanyName })
      )
    ),
    _react2.default.createElement(
      _materialUi.Dialog,
      {
        title: 'Want to view ' + pluralPostCompanyName + ' profile?',
        actions: [_react2.default.createElement(_materialUi.FlatButton, {
          label: 'Close',
          primary: true,
          onTouchTap: function onTouchTap() {
            return updateProp({ showPublicSignUpDialog: false });
          }
        })],
        modal: true,
        open: publicPostReducer.showPublicSignUpDialog
      },
      'In order to view their profile, please',
      _react2.default.createElement(
        'a',
        {
          onTouchTap: function onTouchTap() {
            return updateProp({ showPublicSignUpDialog: false });
          },
          href: window.location.protocol + '//' + window.location.host + '/signup',
          rel: 'external',
          style: { backgroundColor: 'rgb(0, 188, 212)', borderRadius: '2px', color: 'white', padding: '7px', marginLeft: '5px', lineHeight: '36px', fontWeight: '400', fontSize: '14px' }
        },
        'SIGN IN / SIGN UP'
      )
    )
  );
};

PublicPost.propTypes = {
  publicPostReducer: _react.PropTypes.object,
  companyName: _react.PropTypes.string,
  displayType: _react.PropTypes.string,
  updateProp: _react.PropTypes.func,
  postId: _react.PropTypes.string
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateProps.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var publicPost = _ref.publicPost,
      user = _ref.user;
  return {
    publicPostReducer: publicPost.toJS(),
    companyName: user ? user.getIn(['company', 'companyName']) : undefined
  };
};

PublicPost.contextTypes = {
  router: _react.PropTypes.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PublicPost);

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUp = function SignUp(props) {
  var postCompName = props.postCompName;


  return _react2.default.createElement(
    _materialUi.Card,
    { style: { width: '62%', margin: '10px 0 0 23%', padding: '1% 2%', color: 'rgba(0, 0, 0, 0.54)' } },
    _react2.default.createElement(
      'div',
      { style: { fontSize: '16px' } },
      'To view ',
      _react2.default.createElement(
        'b',
        null,
        postCompName
      ),
      ' profile, ',
      _react2.default.createElement(
        'a',
        {
          href: window.location.protocol + '//' + window.location.host + '/signin',
          target: '_blank'
        },
        'Sign In'
      ),
      ' or ',
      _react2.default.createElement(
        'a',
        {
          href: window.location.protocol + '//' + window.location.host + '/signup',
          target: '_blank'
        },
        'Sign Up'
      ),
      ' for an account on TourConnect!'
    )
  );
};

SignUp.propTypes = {
  postCompName: _react.PropTypes.string
};

exports.default = SignUp;

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InternalExtraActions = function InternalExtraActions(props) {
  var firstName = props.firstName,
      postCompName = props.postCompName,
      goToPostCompProfile = props.goToPostCompProfile;


  return _react2.default.createElement(
    _materialUi.Card,
    { style: { width: '62%', margin: '10px 0 0 23%', padding: '1% 2%', color: 'rgba(0, 0, 0, 0.54)' } },
    _react2.default.createElement(
      'div',
      { style: { minHeight: '35px', overflow: 'hidden' } },
      _react2.default.createElement(
        'div',
        { className: 'hide-float-center', style: { float: 'left', marginTop: '5px', fontSize: '16px', display: 'inline-block' } },
        'Welcome back',
        firstName ? ', ' + firstName : '',
        '!'
      ),
      _react2.default.createElement(
        'div',
        { className: 'hide-float-center', style: { float: 'right', display: 'inline-block' } },
        _react2.default.createElement(_materialUi.RaisedButton, { label: 'View Company Details', secondary: true, onTouchTap: goToPostCompProfile })
      )
    )
  );
};

InternalExtraActions.propTypes = {
  firstName: _react.PropTypes.string,
  postCompName: _react.PropTypes.string,
  goToPostCompProfile: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user;
  return {
    firstName: user.getIn(['user', 'firstName'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(InternalExtraActions);

/***/ }),
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SELECT_PLAN = exports.SELECT_PLAN = 'SELECT_PLAN';
var GET_BILLING = exports.GET_BILLING = 'GET_BILLING';
var GET_COUPON = exports.GET_COUPON = 'GET_COUPON';
var ADD_CREDIT_CARD = exports.ADD_CREDIT_CARD = 'ADD_CREDIT_CARD';
var UPGRADE_PLAN = exports.UPGRADE_PLAN = 'UPGRADE_PLAN';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';
var BILLING_ERROR = exports.BILLING_ERROR = 'BILLING_ERROR';
var BILLING_LOADING = exports.BILLING_LOADING = 'BILLING_LOADING';
var CANCEL_SUBSCRIPTION = exports.CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DASHBOARD_INITIALIZE = exports.DASHBOARD_INITIALIZE = 'DASHBOARD_INITIALIZE';
var DASHBOARD_INITIALIZE_SUCCESS = exports.DASHBOARD_INITIALIZE_SUCCESS = 'DASHBOARD_INITIALIZE_SUCCESS';
var DASHBOARD_INITIALIZED = exports.DASHBOARD_INITIALIZED = 'DASHBOARD_INITIALIZED';
var DASHBOARD_CLOSE_ONBOARDING_DIALOG = exports.DASHBOARD_CLOSE_ONBOARDING_DIALOG = 'DASHBOARD_CLOSE_ONBOARDING_DIALOG';
var DASHBOARD_SHOW_ONBOARDING_DIALOG = exports.DASHBOARD_SHOW_ONBOARDING_DIALOG = 'DASHBOARD_INITIALIZED';

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACCEPTED_CSV_SELECTION = exports.ACCEPTED_CSV_SELECTION = 'ACCEPTED_CSV_SELECTION';
var CANCELED_CSV_SELECTION = exports.CANCELED_CSV_SELECTION = 'CANCELED_CSV_SELECTION';
var CHANGE_EMAIL_VALUE = exports.CHANGE_EMAIL_VALUE = 'CHANGE_EMAIL_VALUE';
var CHANGE_NEW_CONNECTION_VALUE = exports.CHANGE_NEW_CONNECTION_VALUE = 'CHANGE_NEW_CONNECTION_VALUE';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';
var CONVERT_FROM_CSV = exports.CONVERT_FROM_CSV = 'CONVERT_FROM_CSV';
var CANCEL_CSV_HEADER_SELECTION = exports.CANCEL_CSV_HEADER_SELECTION = 'CANCEL_CSV_HEADER_SELECTION';
var CHANGE_CSV_HEADER = exports.CHANGE_CSV_HEADER = 'CHANGE_CSV_HEADER';
var DELETED_TEMP_CONNECTIONS = exports.DELETED_TEMP_CONNECTIONS = 'DELETED_TEMP_CONNECTIONS';
var FINISH_CSV_HEADER_SELECTION = exports.FINISH_CSV_HEADER_SELECTION = 'FINISH_CSV_HEADER_SELECTION';
var IS_PERSISTED_FROM_SERVER = exports.IS_PERSISTED_FROM_SERVER = 'IS_PERSISTED_FROM_SERVER';
var NEW_ADD_CONNECTIONS = exports.NEW_ADD_CONNECTIONS = 'NEW_ADD_CONNECTIONS';
var RECEIVE_ADD_CONNECTIONS = exports.RECEIVE_ADD_CONNECTIONS = 'RECEIVE_ADD_CONNECTIONS';
var REMOVE_ADD_INVITATION = exports.REMOVE_ADD_INVITATION = 'REMOVE_ADD_INVITATION';
var SEND_EMAIL_TO_TEMP_CONNECTIONS = exports.SEND_EMAIL_TO_TEMP_CONNECTIONS = 'SEND_EMAIL_TO_TEMP_CONNECTIONS';
var SEND_EMAIL_TO_TEMP_CONNECTIONS_STARTING = exports.SEND_EMAIL_TO_TEMP_CONNECTIONS_STARTING = 'SEND_EMAIL_TO_TEMP_CONNECTIONS_STARTING';
var SEND_TEMP_CONNECTIONS = exports.SEND_TEMP_CONNECTIONS = 'SEND_TEMP_CONNECTIONS';
var SEND_EMAIL_TO_TEMP_CONNECTIONS_FAILED = exports.SEND_EMAIL_TO_TEMP_CONNECTIONS_FAILED = 'SEND_EMAIL_TO_TEMP_CONNECTIONS_FAILED';
var UPDATE_TEMP_CONN_PROP = exports.UPDATE_TEMP_CONN_PROP = 'UPDATE_TEMP_CONN_PROP';

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RESET_PASSWORD = exports.RESET_PASSWORD = 'RESET_PASSWORD';
var PASSWORD_INPUT_MODIFIED = exports.PASSWORD_INPUT_MODIFIED = 'PASSWORD_INPUT_MODIFIED';
var TOGGLE_CONNECTION_NOTIFICATIONS = exports.TOGGLE_CONNECTION_NOTIFICATIONS = 'TOGGLE_CONNECTION_NOTIFICATIONS';
var HYDRATE_FROM_SERVER = exports.HYDRATE_FROM_SERVER = 'HYDRATE_FROM_SERVER';
var ADD_TEMP_USER = exports.ADD_TEMP_USER = 'ADD_TEMP_USER';
var DELETE_TEMP_USER = exports.DELETE_TEMP_USER = 'DELETE_TEMP_USER';
var TEMP_USER_PROP_MODIFIED = exports.TEMP_USER_PROP_MODIFIED = 'TEMP_USER_PROP_MODIFIED';
var ADD_NEW_USERS = exports.ADD_NEW_USERS = 'ADD_NEW_USERS';
var CLEAR_TEMP_USERS = exports.CLEAR_TEMP_USERS = 'CLEAR_TEMP_USERS';
var CLEAR_ADD_USER_MESSAGE = exports.CLEAR_ADD_USER_MESSAGE = 'CLEAR_ADD_USER_MESSAGE';
var USER_APPROVED_OR_REJECTED = exports.USER_APPROVED_OR_REJECTED = 'USER_APPROVED_OR_REJECTED';
var USER_DISABLED = exports.USER_DISABLED = 'USER_DISABLED';
var USER_DELETED = exports.USER_DELETED = 'USER_DELETED';
var EDIT_USER_UPDATED = exports.EDIT_USER_UPDATED = 'EDIT_USER_UPDATED';
var EDIT_USER_PROP_MODIFIED = exports.EDIT_USER_PROP_MODIFIED = 'EDIT_USER_PROP_MODIFIED';
var EDIT_USER_SAVED = exports.EDIT_USER_SAVED = 'EDIT_USER_SAVED';
var CLEAR_EDIT_USER_MESSAGE = exports.CLEAR_EDIT_USER_MESSAGE = 'CLEAR_EDIT_USER_MESSAGE';
var CONFIRMED_DISASSOCIATE_SECONDARY_EMAIL = exports.CONFIRMED_DISASSOCIATE_SECONDARY_EMAIL = 'CONFIRMED_DISASSOCIATE_SECONDARY_EMAIL';
var ADD_SECONDARY_EMAIL = exports.ADD_SECONDARY_EMAIL = 'ADD_SECONDARY_EMAIL';
var RESEND_CONFIRMATION_SECONDARY_EMAIL = exports.RESEND_CONFIRMATION_SECONDARY_EMAIL = 'RESEND_CONFIRMATION_SECONDARY_EMAIL';
var RESEND_CONFIRMATION_LINK_USER_SETTINGS = exports.RESEND_CONFIRMATION_LINK_USER_SETTINGS = 'RESEND_CONFIRMATION_LINK_USER_SETTINGS';
var CLEAR_MANAGE_USERS_MESSAGE = exports.CLEAR_MANAGE_USERS_MESSAGE = 'CLEAR_MANAGE_USERS_MESSAGE';
var START_ADDING_NEW_USER = exports.START_ADDING_NEW_USER = 'START_ADDING_NEW_USER';
var UPDATE_SETTINGS_PROP = exports.UPDATE_SETTINGS_PROP = 'UPDATE_SETTINGS_PROP';

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_PROPS = exports.UPDATE_PROPS = '{memberships}UPDATE_PROPS';
var DELETE_ORGANIZATION_IN_PROFILE = exports.DELETE_ORGANIZATION_IN_PROFILE = '{memberships}DELETE_ORGANIZATION_IN_PROFILE';
var EDIT_PROFILE_BADGE_STARTING = exports.EDIT_PROFILE_BADGE_STARTING = '{memberships}EDIT_PROFILE_BADGE_STARTING';
var EDIT_PROFILE_BADGE_FINISHED = exports.EDIT_PROFILE_BADGE_FINISHED = '{memberships}EDIT_PROFILE_BADGE_FINISHED';
var GETTING_BADGES_STARTED = exports.GETTING_BADGES_STARTED = '{memberships}GETTING_BADGES_STARTED';
var GOT_BADGES = exports.GOT_BADGES = '{memberships}GOT_BADGES';

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_CONTRACT = exports.GET_CONTRACT = 'GET_CONTRACT_IN_TOURPLAN_INTEGRATION';
var GET_CONTRACT_STARTING = exports.GET_CONTRACT_STARTING = 'GET_CONTRACT_STARTING_IN_TOURPLAN_INTEGRATION';
var GET_CONTRACT_FAILED = exports.GET_CONTRACT_FAILED = 'GET_CONTRACT_FAILED_IN_TOURPLAN_INTEGRATION';

var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES_IN_TOURPLAN_INTEGRATION';
var CLEAR_EXPORT_STATE = exports.CLEAR_EXPORT_STATE = 'CLEAR_EXPORT_STATE_IN_TOURPLAN_INTEGRATION';
var LOGIN = exports.LOGIN = 'LOGIN_IN_TOURPLAN_INTEGRATION';

var GET_CONTRACTS = exports.GET_CONTRACTS = 'GET_CONTRACTS_IN_TOURPLAN_INTEGRATION';
var GET_CONTRACTS_STARTING = exports.GET_CONTRACTS_STARTING = 'GET_CONTRACTS_STARTING_IN_TOURPLAN_INTEGRATION';
var GET_CONTRACTS_FAILED = exports.GET_CONTRACTS_FAILED = 'GET_CONTRACTS_FAILED_IN_TOURPLAN_INTEGRATION';

var ADD_MAPPING = exports.ADD_MAPPING = 'ADD_MAPPING_IN_TOURPLAN_INTEGRATION';
var ADD_MAPPING_STARTING = exports.ADD_MAPPING_STARTING = 'ADD_MAPPING_STARTING_IN_TOURPLAN_INTEGRATION';
var ADD_MAPPING_FAILED = exports.ADD_MAPPING_FAILED = 'ADD_MAPPING_FAILED_IN_TOURPLAN_INTEGRATION';

var VALIDATE_MAPPING = exports.VALIDATE_MAPPING = 'VALIDATE_MAPPING_IN_TOURPLAN_INTEGRATION';
var VALIDATE_MAPPING_STATUS = exports.VALIDATE_MAPPING_STATUS = 'VALIDATE_MAPPING_STATUS_IN_TOURPLAN_INTEGRATION';
var CHECK_RATES_STARTING = exports.CHECK_RATES_STARTING = 'CHECK_RATES_STARTING_IN_TOURPLAN_INTEGRATION';
var CHECK_IF_HAS_RATES = exports.CHECK_IF_HAS_RATES = 'CHECK_IF_HAS_RATES_IN_TOURPLAN_INTEGRATION';
var CHECK_IF_HAS_RATES_FAILED = exports.CHECK_IF_HAS_RATES_FAILED = 'CHECK_IF_HAS_RATES_FAILED_IN_TOURPLAN_INTEGRATION';

var GET_AUTH = exports.GET_AUTH = 'GET_AUTH_IN_TOURPLAN_INTEGRATION';
var GET_AUTH_FAILED = exports.GET_AUTH_FAILED = 'GET_AUTH_FAILED_IN_TOURPLAN_INTEGRATION';
var CLEAR_INTEGRATION_STORE = exports.CLEAR_INTEGRATION_STORE = 'CLEAR_INTEGRATION_STORE_IN_TOURPLAN_INTEGRATION';

var CHANGE_INTEGRATION_EXPORT_TYPE = exports.CHANGE_INTEGRATION_EXPORT_TYPE = 'CHANGE_INTEGRATION_EXPORT_TYPE_IN_TOURPLAN_INTEGRATION';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT_IN_TOURPLAN_INTEGRATION';

var UPDATE_SETTINS = exports.UPDATE_SETTINS = 'UPDATE_EXPORT_SETTINGS_IN_INTEGRATION';

var GETTING_CONVERTED_CONTRACT = exports.GETTING_CONVERTED_CONTRACT = 'GETTING_CONVERTED_CONTRACT_IN_INTEGRATION';
var GET_CONVERTED_CONTRACT = exports.GET_CONVERTED_CONTRACT = 'GET_CONVERTED_CONTRACT_IN_INTEGRATION';
var GETTING_CONVERTED_CONTRACT_FAILED = exports.GETTING_CONVERTED_CONTRACT_FAILED = 'GETTING_CONVERTED_CONTRACT_FAILED_IN_INTEGRATION';

var UPDATE_WITH_KEYPATH = exports.UPDATE_WITH_KEYPATH = 'UPDATE_WITH_KEYPATH_IN_INTEGRATION';

var UPDATE_PRODUCT = exports.UPDATE_PRODUCT = 'UPDATE_PRODUCT_IN_INTEGRATION';

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOADING_TEMPLATES = exports.LOADING_TEMPLATES = 'LOADING_TEMPLATES_IN_TEMPLATE_LIST';
var LOADING_TEMPLATES_FOR_WIZARD = exports.LOADING_TEMPLATES_FOR_WIZARD = 'LOADING_TEMPLATES_FOR_TEMPLATE_GROUP_WIZARD';
var TEMPLATES_LOADED = exports.TEMPLATES_LOADED = 'TEMPLATES_LOADED_IN_TEMPLATE_LIST';
var TEMPLATES_LOADED_FOR_WIZARD = exports.TEMPLATES_LOADED_FOR_WIZARD = 'TEMPLATES_LOADED_FOR_TEMPLATE_GROUP_WIZARD';
var LOADING_DRAFTS = exports.LOADING_DRAFTS = 'LOADING_DRAFTS_IN_TEMPLATE_LIST';
var DRAFTS_LOADED = exports.DRAFTS_LOADED = 'DRAFTS_LOADED_IN_TEMPLATE_LIST';
var UPDATE_PROPS = exports.UPDATE_PROPS = '[template-list]UPDATE_PROPS_IN_TEMPLATE_LIST';
var DRAFT_CREATED = exports.DRAFT_CREATED = 'DRAFT_CREATED_IN_TEMPLATE_LIST';
var TEMPLATE_DELETED = exports.TEMPLATE_DELETED = 'TEMPLATE_DELETED_IN_TEMPLATE_LIST';
var DRAFT_DELETED = exports.DRAFT_DELETED = 'DRAFT_DELETED_IN_TEMPLATE_LIST';
var UPDATE_TEMPLATE_PROPS = exports.UPDATE_TEMPLATE_PROPS = 'UPDATE_TEMPLATE_PROPS_IN_TEMPLATE_LIST';
var UPDATE_DRAFT_PROPS = exports.UPDATE_DRAFT_PROPS = 'UPDATE_DRAFT_PROPS_IN_TEMPLATE_LIST';
var STARTING_DRAFT_CREATE = exports.STARTING_DRAFT_CREATE = 'STARTING_DRAFT_CREATE_IN_TEMPLATE_LIST';
var GET_SUPPLIER_LOCATIONS_LIST = exports.GET_SUPPLIER_LOCATIONS_LIST = 'GET_SUPPLIER_LOCATIONS_LIST_IN_TEMPLATE_LIST';
var POPULATE_CONTRACTS_COUNT = exports.POPULATE_CONTRACTS_COUNT = 'POPULATE_CONTRACTS_COUNT_IN_TEPLATE_LIST';
var UPDATE_LOC_PROPS = exports.UPDATE_LOC_PROPS = 'UPDATE_LOC_PROPS_IN_TEMPLATE_LIST';
var GOT_ALL_CONTRACT_PERIODS = exports.GOT_ALL_CONTRACT_PERIODS = 'GOT_ALL_CONTRACT_PERIODS_FOR_TEMPLATE_GROUP_WIZARD';
var UPDATING_TEMPLATE_NAME = exports.UPDATING_TEMPLATE_NAME = 'UPDATING_TEMPLATE_NAME_IN_TEMPLATE_LIST';
var TEMPLATE_NAME_UPDATED = exports.TEMPLATE_NAME_UPDATED = 'TEMPLATE_NAME_UPDATED_IN_TEMPLATE_LIST';
var TEMPLATE_NAME_UPDATED_DUPLICATED = exports.TEMPLATE_NAME_UPDATED_DUPLICATED = 'TEMPLATE_NAME_UPDATED_DUPLICATED_IN_TEMPLATE_LIST';
var STARTING_TEMPLATE_GROUP_CREATION = exports.STARTING_TEMPLATE_GROUP_CREATION = 'STARTING_TEMPLATE_GROUP_CREATION_IN_TEMPLATE_LIST';
var TEMPLATE_GROUP_CREATED = exports.TEMPLATE_GROUP_CREATED = 'TEMPLATE_GROUP_CREATED_IN_TEMPLATE_LIST';
var TEMPLATE_GROUP_UPDATED = exports.TEMPLATE_GROUP_UPDATED = 'TEMPLATE_GROUP_UPDATED_IN_TEMPLATE_LIST';
var DOWNLOADING_PDF_ZIP = exports.DOWNLOADING_PDF_ZIP = 'DOWNLOADING_PDF_ZIP_IN_TEMPLATE_LIST';
var PDF_ZIP_DOWNLOADED = exports.PDF_ZIP_DOWNLOADED = 'PDF_ZIP_DOWNLOADED_IN_TEMPLATE_LIST';
var UPDATE_FILTERS = exports.UPDATE_FILTERS = '{template-list} UPDATE_FILTERS';

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = '[send-to-partners] ';

var UPDATE_PROPS = exports.UPDATE_PROPS = 'UPDATE_PROPS_IN_SEND_TO_PARTNERS_REDUCER';
var LOADING_EXISTING_CONNECTIONS = exports.LOADING_EXISTING_CONNECTIONS = 'LOADING_EXISTING_CONNECTIONS_IN_SEND_TO_PARTNERS_REDUCER';
var GOT_EXISTING_CONNECTIONS = exports.GOT_EXISTING_CONNECTIONS = 'GOT_EXISTING_CONNECTIONS_IN_SEND_TO_PARTNERS_REDUCER';
var CHECK_CONNECTION = exports.CHECK_CONNECTION = 'CHECK_CONNECTION_IN_SEND_TO_PARTNERS_REDUCER';
var UNCHECK_CONNECTION = exports.UNCHECK_CONNECTION = 'UNCHECK_CONNECTION_IN_SEND_TO_PARTNERS_REDUCER';
var PROCESSING_PARTNERS = exports.PROCESSING_PARTNERS = 'PROCESSING_PARTNERS_IN_SEND_TO_PARTNERS_REDUCER';
var PARTNERS_PROCESSED = exports.PARTNERS_PROCESSED = 'PARTNERS_PROCESSED_IN_SEND_TO_PARTNERS_REDUCER';
var CLEAR_STORE = exports.CLEAR_STORE = 'CLEAR_STORE_IN_SEND_TO_PARTNERS_REDUCER';
var GOT_CONTRACTING_PARTNERS = exports.GOT_CONTRACTING_PARTNERS = 'GOT_CONTRACTING_PARTNERS_IN_SEND_TO_PARTNERS_REDUCER';
var GOT_REQUESTS = exports.GOT_REQUESTS = 'GOT_MATCHED_REQUESTS_FOR_SUPPLIER_SENDING_RATES';

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_CREPORTS_PROP = exports.UPDATE_CREPORTS_PROP = 'UPDATE_CREPORTS_PROP';
var SENDING_REPORT_SUGG = exports.SENDING_REPORT_SUGG = 'SENDING_REPORT_SUGG';
var SENT_REPORT_SUGG = exports.SENT_REPORT_SUGG = 'SENT_REPORT_SUGG';
var GET_CONTRACTING_DIFF_REPORT = exports.GET_CONTRACTING_DIFF_REPORT = 'GET_CONTRACTING_DIFF_REPORT';
var CLEAR_STORE = exports.CLEAR_STORE = '[contracting-report]CLEAR_STORE';

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_PROPS = exports.UPDATE_PROPS = 'UPDATE_PROPS_IN_NOTIFICATIONS';
var GOT_NOTIFICATIONS = exports.GOT_NOTIFICATIONS = 'GOT_NOTIFICATIONS_FOR_USER';
var MARKED_READ = exports.MARKED_READ = 'MARKED_READ_NOTIFICATIONS';

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var EDIT_FIELD_FOR_MODAL = exports.EDIT_FIELD_FOR_MODAL = 'EDIT_FIELD_FOR_MODAL';
var CLEAR_EDIT_MODAL_STATE = exports.CLEAR_EDIT_MODAL_STATE = 'CLEAR_EDIT_MODAL_STATE';
var START_EDIT = exports.START_EDIT = 'START_MODAL_EDIT_IN_PROFILE';
var START_INLINE_EDIT = exports.START_INLINE_EDIT = 'START_INLINE_EDIT_IN_PROFILE';

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshConnectionsStats = refreshConnectionsStats;

var _http = __webpack_require__(118);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _connectionsStatsConstants = __webpack_require__(2726);

var constants = _interopRequireWildcard(_connectionsStatsConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function refreshConnectionsStats() {
  return function (dispatch) {
    dispatch({ type: constants.REFRESH_CONNECTIONS_STATS_STARTING });
    return (0, _http.get)('/proxy/connections/stats').then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({ type: constants.REFRESH_CONNECTIONS_STATS, payload: res });
    });
  };
}

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _navLink = __webpack_require__(1049);

var _navLink2 = _interopRequireDefault(_navLink);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HoverableMenuItem = function (_Component) {
  _inherits(HoverableMenuItem, _Component);

  function HoverableMenuItem(props) {
    _classCallCheck(this, HoverableMenuItem);

    var _this = _possibleConstructorReturn(this, (HoverableMenuItem.__proto__ || Object.getPrototypeOf(HoverableMenuItem)).call(this, props));

    _this.handleTouchTap = function (event) {
      _this.setState({
        open: true,
        anchorEl: event.currentTarget
      });
    };

    _this.handleRequestClose = function () {
      _this.setState({
        open: false
      });
    };

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(HoverableMenuItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          activeRoutes = _props.activeRoutes,
          routeName = _props.routeName,
          subMenuItems = _props.subMenuItems,
          location = _props.location,
          showSubMenu = _props.showSubMenu;

      return _react2.default.createElement(
        'div',
        { onClick: this.handleTouchTap },
        _react2.default.createElement(
          _navLink2.default,
          {
            className: 'nav-link',
            activeRoutes: activeRoutes,
            location: location
          },
          children
        ),
        showSubMenu ? _react2.default.createElement(
          _materialUi.IconMenu,
          {
            open: this.state.open,
            iconButtonElement: _react2.default.createElement(_materialUi.IconButton, {
              iconClassName: this.state.open ? 'tc-icon-arrow-drop-up' : 'tc-icon-arrow-drop-down',
              iconStyle: { color: 'rgba(0, 0, 0, 0.54)' },
              style: { padding: '12px 0px', width: '24px' }
            }),
            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
            targetOrigin: { horizontal: 'left', vertical: 'top' },
            onRequestChange: this.handleRequestClose
          },
          subMenuItems.map(function (menuItem, index) {
            if (menuItem.type === 'divider') {
              return _react2.default.createElement(_materialUi.Divider, { key: index });
            }
            if (menuItem.type === 'subheader') {
              return _react2.default.createElement(
                _materialUi.Subheader,
                { key: index },
                menuItem.text
              );
            }
            return _react2.default.createElement(_materialUi.MenuItem, {
              desktop: true,
              key: index,
              primaryText: menuItem.text,
              onTouchTap: _ramda2.default.compose(_this2.handleRequestClose, menuItem.onTouchTap),
              innerDivStyle: { color: 'rgba(0, 0, 0, 0.54)' },
              leftIcon: typeof menuItem.icon === 'string' ? _react2.default.createElement(_materialUi.FontIcon, { className: menuItem.icon, color: 'rgba(0, 0, 0, 0.54)' }) : menuItem.icon
            });
          })
        ) : _react2.default.createElement('span', null)
      );
    }
  }]);

  return HoverableMenuItem;
}(_react.Component);

exports.default = HoverableMenuItem;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _materialUi = __webpack_require__(3);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _radioButtonUnchecked = __webpack_require__(1359);

var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);

var _brightness = __webpack_require__(2733);

var _brightness2 = _interopRequireDefault(_brightness);

var _chatBubbleOutline = __webpack_require__(1220);

var _chatBubbleOutline2 = _interopRequireDefault(_chatBubbleOutline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  wrapper: { width: '450px', overflowY: 'hidden' },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 12px 6px'
  },
  popoverDiv: {
    maxHeight: 'calc(100vh)',
    overflow: 'hidden'
  },
  list: {
    maxHeight: 'calc(100vh - 70px)',
    overflowY: 'scroll'
  },
  secondaryText: {
    fontSize: '12px',
    marginTop: '4px',
    display: 'flex',
    alignItems: 'center',
    height: 'inherit !important',
    minHeight: '16px',
    '& p': {
      paddingTop: 0,
      marginBottom: 1
    }
  },
  unreadIconStyle: {
    color: '#ff4081 !important'
  },
  iconStyle: {
    color: 'rgba(0, 0, 0, 0.44) !important'
  },
  onlineStatusIcon: {
    color: '#529A1D !important',
    width: '0.7em !important',
    height: '0.7em !important',
    marginLeft: '0.4em'
  },
  messageRow: {
    '&.unread': {
      backgroundColor: 'rgb(244, 246, 250) !important'
    },
    '&.unread:hover': {
      backgroundColor: 'rgb(221, 223, 227) !important'
    }
  },
  rightSide: {
    display: 'flex',
    flexDirection: 'rows',
    textAlign: 'right',
    marginRight: '0.5em'
  },
  topRightSecondary: {
    cursor: 'pointer',
    color: '#e65100',
    marginRight: '16px',
    fontSize: '10px',
    '&:hover': {
      color: '#ff9800'
    }
  },
  rightSideText: {
    fontSize: '0.7em',
    color: 'rgb(0,0,0,0.4)'
  },
  rightSideIcon: {
    width: '0.7em !important',
    height: '0.7em !important'
  },
  pointerCursor: {
    cursor: 'pointer'
  },
  footer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 12px 6px'
  }
};

var PopoverList = function (_React$Component) {
  _inherits(PopoverList, _React$Component);

  function PopoverList(props) {
    _classCallCheck(this, PopoverList);

    var _this = _possibleConstructorReturn(this, (PopoverList.__proto__ || Object.getPrototypeOf(PopoverList)).call(this, props));

    _this.formatDate = function (timestamp) {
      // const daysDiff = moment().diff(moment(timestamp), 'days');
      // if (daysDiff < 1) return moment(timestamp).format('h:mm  a');
      // if (daysDiff < 7) return moment(timestamp).format('Last dddd');
      // return moment(timestamp).format('MMM D');
      // return moment(`${R.slice(0, -3, timestamp)}Z`).from(moment());
      return (0, _moment2.default)(timestamp).calendar(null, {
        sameDay: 'h:mm a',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'D MMM YY'
      });
    };

    _this.actionClose = function (laterDo) {
      return function () {
        _this.setState({ open: false });
        laterDo();
      };
    };

    _this.closeList = function () {
      return _this.state.open && _this.setState({ open: false });
    };

    _this.state = {
      anchorEl: null,
      open: false
    };
    return _this;
  }

  _createClass(PopoverList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          open = _state.open,
          anchorEl = _state.anchorEl;
      var _props = this.props,
          bottomLeftAction = _props.bottomLeftAction,
          bottomLeftText = _props.bottomLeftText,
          bottomRightAction = _props.bottomRightAction,
          bottomRightText = _props.bottomRightText,
          children = _props.children,
          css = _props.classes,
          clickItem = _props.clickItem,
          list = _props.list,
          title = _props.title,
          topRightAction = _props.topRightAction,
          topRightText = _props.topRightText,
          topRightSecondaryText = _props.topRightSecondaryText,
          topRightSecondaryAction = _props.topRightSecondaryAction;

      return _react2.default.createElement(
        'div',
        null,
        children ? _react2.default.cloneElement(children, {
          onTouchTap: function onTouchTap(event) {
            if (!_this2.state.anchorEl) {
              _this2.setState({ anchorEl: event.currentTarget, open: !_this2.state.open });
            } else {
              _this2.setState({ open: !_this2.state.open });
            }
          }
        }) : undefined,
        _react2.default.createElement(
          _materialUi.Popover,
          {
            open: open,
            anchorEl: anchorEl,
            onRequestClose: this.closeList,
            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
            targetOrigin: { horizontal: 'right', vertical: 'top' },
            className: css.wrapper
          },
          _react2.default.createElement(
            'div',
            { className: css.popoverDiv },
            _react2.default.createElement(
              'div',
              { className: css.header },
              _react2.default.createElement(
                'b',
                null,
                title
              ),
              _react2.default.createElement(
                'div',
                { className: 'flex-center' },
                topRightSecondaryAction ? _react2.default.createElement(
                  'a',
                  {
                    className: css.topRightSecondary,
                    onClick: topRightSecondaryAction
                  },
                  topRightSecondaryText
                ) : _react2.default.createElement('span', null),
                topRightText && _react2.default.createElement(
                  'a',
                  { className: css.pointerCursor, onClick: this.actionClose(topRightAction) },
                  topRightText
                )
              )
            ),
            _react2.default.createElement(_materialUi.Divider, null),
            _ramda2.default.isEmpty(list) && _react2.default.createElement(
              'div',
              { style: { textAlign: 'center', height: '100px', paddingTop: '40px' } },
              'You don\'t have any ',
              (0, _pluralize2.default)(title).toLowerCase(),
              '.'
            ),
            _react2.default.createElement(
              'div',
              { className: css.list },
              list.map(function (_ref) {
                var id = _ref.id,
                    _ref$itemActions = _ref.itemActions,
                    itemActions = _ref$itemActions === undefined ? [] : _ref$itemActions,
                    unread = _ref.unread,
                    leftIcon = _ref.leftIcon,
                    isOnline = _ref.isOnline,
                    otherSideName = _ref.otherSideName,
                    subject = _ref.subject,
                    timestamp = _ref.timestamp,
                    text = _ref.text,
                    firstRowAction = _ref.firstRowAction,
                    elClickItem = _ref.clickItem;
                return _react2.default.createElement(
                  'div',
                  { key: id },
                  _react2.default.createElement(_materialUi.ListItem, _extends({
                    className: '' + css.messageRow + (unread ? ' unread' : ''),
                    leftIcon: leftIcon || _react2.default.createElement(_chatBubbleOutline2.default, { className: css.iconStyle }),
                    primaryText: _react2.default.createElement(
                      'div',
                      _extends({
                        style: {
                          fontSize: '13px',
                          cursor: firstRowAction ? 'pointer' : 'inherit'
                        }
                      }, firstRowAction ? { onTouchTap: _this2.actionClose(firstRowAction) } : {}),
                      otherSideName || 'Unnamed Company',
                      isOnline && _react2.default.createElement(_brightness2.default, { className: css.onlineStatusIcon })
                    ),
                    secondaryText: _react2.default.createElement(
                      'div',
                      { className: css.secondaryText },
                      itemActions.length > 0 && itemActions.map(function (Button) {
                        return Button;
                      }),
                      !text && subject ? _react2.default.createElement(
                        'b',
                        null,
                        subject
                      ) : '',
                      text && (text.indexOf('<p') > -1 || text.indexOf('<br/>') > -1 || text.indexOf('<div>') > -1) ? _react2.default.createElement('span', {
                        dangerouslySetInnerHTML: { __html: text }
                      }) : text
                    ),
                    rightIconButton: _react2.default.createElement(
                      'div',
                      { className: css.rightSide },
                      _react2.default.createElement(
                        'div',
                        { className: css.rightSideText },
                        _this2.formatDate(timestamp)
                      ),
                      unread ? _react2.default.createElement(_brightness2.default, { className: css.unreadIconStyle + ' ' + css.rightSideIcon }) : _react2.default.createElement(_radioButtonUnchecked2.default, { className: css.iconStyle + ' ' + css.rightSideIcon })
                    )
                  }, clickItem && !elClickItem ? {
                    onTouchTap: _this2.actionClose(function () {
                      clickItem(id);
                    })
                  } : {}, elClickItem ? {
                    onTouchTap: _this2.actionClose(elClickItem)
                  } : {}, !clickItem && !elClickItem ? { disabled: true } : {})),
                  _react2.default.createElement(_materialUi.Divider, null)
                );
              })
            ),
            (bottomRightText || bottomLeftText) && _react2.default.createElement(
              'div',
              { className: css.footer },
              bottomLeftText && _react2.default.createElement(
                'a',
                {
                  className: css.pointerCursor,
                  onTouchTap: this.actionClose(bottomLeftAction)
                },
                bottomLeftText
              ),
              bottomRightText && _react2.default.createElement(
                'a',
                {
                  className: css.pointerCursor,
                  onTouchTap: this.actionClose(bottomRightAction)
                },
                bottomRightText
              )
            )
          )
        )
      );
    }
  }]);

  return PopoverList;
}(_react2.default.Component);

PopoverList.defaultProps = {
  bottomLeftAction: function bottomLeftAction() {},
  bottomRightAction: function bottomRightAction() {},
  topRightAction: function topRightAction() {}
};

PopoverList.propTypes = {
  anchorEl: _propTypes2.default.object,
  bottomLeftAction: _propTypes2.default.func,
  bottomLeftText: _propTypes2.default.string,
  bottomRightAction: _propTypes2.default.func,
  bottomRightText: _propTypes2.default.string,
  children: _propTypes2.default.object,
  classes: _propTypes2.default.object,
  clickItem: _propTypes2.default.func,
  list: _propTypes2.default.array,
  markAsRead: _propTypes2.default.func,
  title: _propTypes2.default.string,
  topRightAction: _propTypes2.default.func,
  topRightText: _propTypes2.default.string,
  topRightSecondaryText: _propTypes2.default.string,
  topRightSecondaryAction: _propTypes2.default.func
};

exports.default = (0, _reactJss2.default)(styles)(PopoverList);

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationForum = function CommunicationForum(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
  );
};
CommunicationForum = (0, _pure2.default)(CommunicationForum);
CommunicationForum.displayName = 'CommunicationForum';
CommunicationForum.muiName = 'SvgIcon';

exports.default = CommunicationForum;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationLiveHelp = function CommunicationLiveHelp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z' })
  );
};
CommunicationLiveHelp = (0, _pure2.default)(CommunicationLiveHelp);
CommunicationLiveHelp.displayName = 'CommunicationLiveHelp';
CommunicationLiveHelp.muiName = 'SvgIcon';

exports.default = CommunicationLiveHelp;

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(226);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _insertPhoto = __webpack_require__(1454);

var _insertPhoto2 = _interopRequireDefault(_insertPhoto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadFromMM = function (_Component) {
  _inherits(UploadFromMM, _Component);

  function UploadFromMM(props) {
    _classCallCheck(this, UploadFromMM);

    var _this = _possibleConstructorReturn(this, (UploadFromMM.__proto__ || Object.getPrototypeOf(UploadFromMM)).call(this, props));

    _this.clearSelections = function () {
      _this.setState({ selectedFiles: [], expanded: false });
    };

    _this.state = {
      expanded: false,
      selectedFiles: []
    };
    return _this;
  }

  _createClass(UploadFromMM, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.setClear(this.clearSelections);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          disableOpen = _props.disableOpen,
          extraTitle = _props.extraTitle,
          loadingFiles = _props.loadingFiles,
          MMFiles = _props.MMFiles,
          onCardExpand = _props.onCardExpand,
          onChangeSelection = _props.onChangeSelection,
          savingPost = _props.savingPost,
          style = _props.style;
      var _state = this.state,
          selectedFiles = _state.selectedFiles,
          expanded = _state.expanded;


      return _react2.default.createElement(
        _materialUi.Card,
        {
          expanded: expanded,
          onExpandChange: function onExpandChange(newExpadedState) {
            if (!savingPost) {
              _this2.setState({
                expanded: newExpadedState
              }, function () {
                return onCardExpand(newExpadedState);
              });
            }
          },
          style: _extends({ boxShadow: 'none', borderBottom: '1px solid #e0e0e0' }, style)
        },
        _react2.default.createElement(
          _materialUi.CardHeader,
          _extends({
            textStyle: { display: 'none' }
          }, disableOpen ? {} : { showExpandableButton: true, actAsExpander: true }),
          _react2.default.createElement(
            _materialUi.FontIcon,
            { style: { width: '100%' } },
            _react2.default.createElement(_insertPhoto2.default, { color: 'rgba(0, 0, 0, 0.54)', style: { verticalAlign: 'bottom' } }),
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', width: '80%', overflow: 'hidden', fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)', marginLeft: '15px' } },
              'Marketing Materials',
              selectedFiles.length > 0 && !expanded && _react2.default.createElement(
                'span',
                null,
                ' - ',
                _react2.default.createElement(
                  'span',
                  { style: { color: '#00bcd4' } },
                  _ramda2.default.propOr(0, 'length', selectedFiles),
                  ' of ',
                  _ramda2.default.propOr(0, 'length', MMFiles),
                  ' selected'
                )
              ),
              extraTitle ? ' ' + extraTitle : undefined
            )
          )
        ),
        _react2.default.createElement(
          _materialUi.CardText,
          { expandable: true, style: { padding: '0' } },
          _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals(true), _ramda2.default.always(_react2.default.createElement(
            'div',
            null,
            'Loading Marketing Material Photos...',
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_materialUi.CircularProgress, { size: 30 })
          ))], [_ramda2.default.equals(false), _ramda2.default.always(_react2.default.createElement(
            'div',
            { style: { clear: 'both', padding: '8px 0 0 4px', maxHeight: '250px', overflowY: 'scroll' } },
            MMFiles.map(function (file, i) {
              var isSelected = _ramda2.default.contains(file.url, _ramda2.default.pluck('url')(selectedFiles));
              var imgStyle = { border: isSelected ? '' : '1px solid #D3D3D3', borderRadius: '3px', cursor: 'pointer', marginRight: '10px' };
              return _react2.default.createElement(
                'div',
                {
                  key: i,
                  onTouchTap: _ramda2.default.ifElse(function () {
                    return _ramda2.default.contains(file.url, _ramda2.default.pluck('url')(selectedFiles));
                  }, function () {
                    _this2.setState({ selectedFiles: selectedFiles.filter(function (object) {
                        return object.url !== file.url;
                      }) }, function () {
                      onChangeSelection(_this2.state.selectedFiles);
                    });
                  }, function () {
                    _this2.setState({ selectedFiles: _ramda2.default.prepend(file, selectedFiles) }, function () {
                      onChangeSelection(_this2.state.selectedFiles);
                    });
                  }),
                  style: { display: 'inline-block' }
                },
                _react2.default.createElement('img', {
                  src: file.url,
                  height: '75',
                  style: isSelected ? _ramda2.default.merge(imgStyle, { outline: '2px solid #00bcd4' }) : imgStyle,
                  title: _ramda2.default.propOr('', 'name', file)
                })
              );
            })
          ))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement('span', null))]]), loadingFiles)
        )
      );
    }
  }]);

  return UploadFromMM;
}(_react.Component);

UploadFromMM.propTypes = {
  disableOpen: _react.PropTypes.bool.isRequired,
  extraTitle: _react.PropTypes.string,
  loadingFiles: _react.PropTypes.bool,
  MMFiles: _react.PropTypes.array,
  onCardExpand: _react.PropTypes.func.isRequired,
  onChangeSelection: _react.PropTypes.func.isRequired,
  savingPost: _react.PropTypes.bool.isRequired,
  setClear: _react.PropTypes.func,
  style: _react.PropTypes.object.isRequired,
  updateProp: _react.PropTypes.func
};

UploadFromMM.defaultProps = {
  disableOpen: false,
  extraTitle: '',
  onCardExpand: function onCardExpand() {},
  onChangeSelection: function onChangeSelection() {},
  savingPost: false,
  setClear: function setClear() {},
  style: {}
};

var mapStateToProps = function mapStateToProps(_ref) {
  var profile = _ref.profile;
  return {
    MMFiles: profile.get('media') ? profile.get('media').toJS() : [],
    loadingFiles: !profile.get('media')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateProps.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UploadFromMM);

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _actions = __webpack_require__(1115);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewPartners = function ReviewPartners(props) {
  var updateMMPartnerProp = props.updateMMPartnerProp,
      sendMarketingMaterials = props.sendMarketingMaterials,
      actionItems = props.actionItems,
      clearReducer = props.clearReducer,
      isSupplier = props.isSupplier,
      showActions = props.showActions;

  var MMPartnerReducer = (0, _ramda.isEmpty)(props.MMPartnerReducer2) ? props.MMPartnerReducer : props.MMPartnerReducer2; // fallback to reducer
  // workaround for dropdown menu not closing
  var hideDropdownMenu = Boolean(MMPartnerReducer.showAddIndividuallyDialog || MMPartnerReducer.showSelectFromPartnersDialog || MMPartnerReducer.showUploadFileDialog || MMPartnerReducer.showEmailImportDialog);

  return _react2.default.createElement(
    'div',
    { style: { marginTop: isSupplier ? '15px' : '' } },
    _react2.default.createElement(
      'div',
      null,
      hideDropdownMenu ? _react2.default.createElement('span', null) : _react2.default.createElement(
        _materialUi.DropDownMenu,
        {
          value: 3,
          labelStyle: { color: '#00bcd4' },
          underlineStyle: { border: 'none' },
          menuStyle: { overflowY: 'hidden', overflowX: 'hidden' },
          style: { overflowY: 'hidden', overflowX: 'hidden', overflow: 'hidden' }
        },
        actionItems.map(function (actionItem, index) {
          return _react2.default.createElement(
            'div',
            { key: index },
            _react2.default.createElement(_materialUi.MenuItem, {
              onClick: actionItem.func,
              value: index,
              key: index,
              primaryText: actionItem.text,
              leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: actionItem.icon, style: { color: '#757575' } })
            })
          );
        }),
        _react2.default.createElement(_materialUi.MenuItem, { value: 3, label: 'ADD PARTNERS' })
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { maxHeight: '500px', overflowY: 'scroll' } },
      _react2.default.createElement(
        _materialUi.Table,
        null,
        _react2.default.createElement(
          _materialUi.TableHeader,
          { adjustForCheckbox: false, displaySelectAll: false },
          _react2.default.createElement(
            _materialUi.TableRow,
            null,
            _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              null,
              'Company Name'
            ),
            _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              null,
              'Email'
            ),
            _react2.default.createElement(_materialUi.TableHeaderColumn, null)
          )
        ),
        _react2.default.createElement(
          _materialUi.TableBody,
          { displayRowCheckbox: false },
          (0, _ramda.propOr)([], 'partnersToSendTo', MMPartnerReducer).map(function (obj, i) {
            return _react2.default.createElement(
              _materialUi.TableRow,
              { key: i, style: { height: '32px' } },
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                { style: { height: '32px', fontSize: '14px' } },
                obj.companyName
              ),
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                { style: { height: '32px', fontSize: '14px' } },
                obj.email
              ),
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                { style: { height: '32px', fontSize: '14px', textAlign: 'right' } },
                _react2.default.createElement(_materialUi.IconButton, {
                  iconClassName: 'tc-icon-delete2',
                  iconStyle: { color: 'rgb(255, 64, 129)' },
                  onTouchTap: function onTouchTap() {
                    return updateMMPartnerProp({
                      partnersToSendTo: (0, _ramda.without)([obj], MMPartnerReducer.partnersToSendTo)
                    });
                  }
                })
              )
            );
          })
        )
      )
    ),
    showActions ? _react2.default.createElement(
      'div',
      { style: { marginTop: '20px' } },
      _react2.default.createElement(_materialUi.FlatButton, {
        label: 'exit',
        primary: true,
        labelStyle: { fontWeight: '600' },
        onTouchTap: function onTouchTap() {
          return clearReducer();
        },
        style: { float: 'left' }
      }),
      _react2.default.createElement(_materialUi.FlatButton, {
        label: 'send marketing materials',
        labelStyle: { fontWeight: '600' },
        secondary: true,
        onTouchTap: function onTouchTap() {
          sendMarketingMaterials(MMPartnerReducer.partnersToSendTo);
          clearReducer();
        },
        style: { float: 'right' }
      })
    ) : _react2.default.createElement('span', null)
  );
};

ReviewPartners.propTypes = {
  updateMMPartnerProp: _react.PropTypes.func,
  MMPartnerReducer: _react.PropTypes.object,
  MMPartnerReducer2: _react.PropTypes.object,
  sendMarketingMaterials: _react.PropTypes.func,
  actionItems: _react.PropTypes.array,
  clearReducer: _react.PropTypes.func,
  isSupplier: _react.PropTypes.bool,
  showActions: _react.PropTypes.bool
};

ReviewPartners.defaultProps = {
  showActions: true,
  MMPartnerReducer2: {}
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    sendMarketingMaterials: function sendMarketingMaterials() {
      return dispatch(_actions.sendMM.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var marketingMaterials = _ref.marketingMaterials;
  return {
    MMPartnerReducer: marketingMaterials.partnerReducer.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReviewPartners);

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _search = __webpack_require__(2739);

var _search2 = _interopRequireDefault(_search);

var _table = __webpack_require__(2740);

var _table2 = _interopRequireDefault(_table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var ExistingConnections = function ExistingConnections(props) {
  var updateMMPartnerProp = props.updateMMPartnerProp;

  var MMPartnerReducer = (0, _ramda.isEmpty)(props.MMPartnerReducer2) ? props.MMPartnerReducer : props.MMPartnerReducer2; // fallback to reducer
  var cancelButton = _react2.default.createElement(_materialUi.FlatButton, {
    label: 'Cancel',
    primary: true,
    labelStyle: { fontWeight: '600' },
    onTouchTap: function onTouchTap() {
      return updateMMPartnerProp({
        showSelectFromPartnersDialog: false,
        addPartnersMethod: '',
        filteredConnections: [],
        searchField: '',
        selectedExistingPartners: []
      });
    }
  });

  var addButton = _react2.default.createElement(_materialUi.FlatButton, {
    label: (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), function () {
      return (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), (0, _ramda.always)('Add 1 partner'), (0, _ramda.always)('Add ' + (0, _ramda.path)(['selectedExistingPartners', 'length'], MMPartnerReducer) + ' partners')), (0, _ramda.equals)((0, _ramda.path)(['selectedExistingPartners', 'length'], MMPartnerReducer), 1));
    }, (0, _ramda.always)('Add')), (0, _ramda.not)(isNilOrEmpty(MMPartnerReducer.selectedExistingPartners))),
    secondary: true,
    labelStyle: { fontWeight: '600' },
    onTouchTap: function onTouchTap() {
      return updateMMPartnerProp({
        showSelectFromPartnersDialog: false,
        showSelectMethod: false,
        showReview: true,
        filteredConnections: [],
        searchField: '',
        addPartnersMethod: '',
        partnersToSendTo: MMPartnerReducer.partnersToSendTo.concat(MMPartnerReducer.selectedExistingPartners),
        selectedExistingPartners: []
      });
    },
    disabled: isNilOrEmpty(MMPartnerReducer.selectedExistingPartners)
  });

  var numberOfSelected = _react2.default.createElement(_materialUi.FlatButton, {
    label: (0, _ramda.equals)((0, _ramda.path)(['selectedExistingPartners', 'length'], MMPartnerReducer), 1) ? '1 partner selected' : (0, _ramda.path)(['selectedExistingPartners', 'length'], MMPartnerReducer) + ' partners selected',
    disabled: true,
    style: { float: 'left' },
    labelStyle: { fontWeight: '600', color: 'rgba(0, 0, 0, 0.54)' }
  });

  var actions = [cancelButton, addButton];
  // console.log('filteredConnections', MMPartnerReducer.filteredConnections, props.check2, props.uncheck2);
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: MMPartnerReducer.showSelectFromPartnersDialog,
      autoScrollBodyContent: true,
      actions: (0, _ramda.not)(isNilOrEmpty(MMPartnerReducer.selectedExistingPartners)) ? (0, _ramda.append)(numberOfSelected, actions) : actions,
      titleStyle: { padding: '0' },
      title: _react2.default.createElement(
        'div',
        null,
        (0, _ramda.not)(isNilOrEmpty(MMPartnerReducer.filteredConnections)) || (0, _ramda.not)(isNilOrEmpty(MMPartnerReducer.searchField)) ? _react2.default.createElement(
          'div',
          { style: { display: 'block', backgroundColor: '#00bcd4', color: '#ffffff', height: '50px' } },
          _react2.default.createElement(
            'div',
            { style: { padding: '2% 3%', float: 'left', fontSize: '20px', fontWeight: '600' } },
            'Add From Connections'
          ),
          _react2.default.createElement(
            'div',
            { style: { padding: '2% 3%', float: 'right', fontSize: '14px' } },
            (0, _ramda.equals)((0, _ramda.path)(['filteredConnections', 'length'], MMPartnerReducer), 1) ? '1 result found' : (0, _ramda.path)(['filteredConnections', 'length'], MMPartnerReducer) + ' results found'
          )
        ) : _react2.default.createElement(
          'h4',
          { style: { color: '#ffffff', backgroundColor: '#00bcd4', padding: '2% 3%' } },
          'Add From Connections'
        ),
        _react2.default.createElement(
          'div',
          { style: { clear: 'both' } },
          _react2.default.createElement(_search2.default, {
            updateMMPartnerProp: updateMMPartnerProp,
            MMPartnerReducer2: props.MMPartnerReducer2
          })
        )
      ),
      contentStyle: { width: '640px' },
      bodyStyle: { paddingTop: '0' }
    },
    _react2.default.createElement(_table2.default, {
      MMPartnerReducer2: props.MMPartnerReducer2
    })
  );
};

ExistingConnections.propTypes = {
  updateMMPartnerProp: _react.PropTypes.func,
  check2: _react.PropTypes.func,
  uncheck2: _react.PropTypes.func,
  MMPartnerReducer: _react.PropTypes.object,
  MMPartnerReducer2: _react.PropTypes.object
};

ExistingConnections.defaultProps = {
  MMPartnerReducer2: {}
};

var mapStateToProps = function mapStateToProps(_ref) {
  var marketingMaterials = _ref.marketingMaterials;
  return {
    MMPartnerReducer: marketingMaterials.partnerReducer.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ExistingConnections);

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _tcContactImport = __webpack_require__(1456);

var _tcContactImport2 = _interopRequireDefault(_tcContactImport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportFromEmail = function ImportFromEmail(props) {
  var updateMMPartnerProp = props.updateMMPartnerProp;

  var MMPartnerReducer = (0, _ramda.isEmpty)(props.MMPartnerReducer2) ? props.MMPartnerReducer : props.MMPartnerReducer2; // fallback to reducer
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: MMPartnerReducer.showEmailImportDialog,
      actions: [_react2.default.createElement(_materialUi.FlatButton, {
        label: 'Cancel',
        primary: true,
        labelStyle: { fontWeight: '600' },
        onTouchTap: function onTouchTap() {
          return updateMMPartnerProp({
            showEmailImportDialog: false,
            addPartnersMethod: ''
          });
        }
      })],
      title: 'Import From Email',
      contentStyle: { width: '512px' },
      bodyStyle: { paddingTop: '0' }
    },
    _react2.default.createElement(
      'div',
      { style: { marginTop: '15px' } },
      _react2.default.createElement(
        'div',
        { style: { marginBottom: '15px' } },
        'Select which email provider you would like to import your contacts from.'
      ),
      _react2.default.createElement(_tcContactImport2.default, {
        afterSubmitContacts: function afterSubmitContacts(contacts) {
          var pullEmail = contacts.map(function (contact) {
            return {
              email: (0, _ramda.prop)('__selectedMail__', contact)
            };
          });
          updateMMPartnerProp({
            showEmailImportDialog: false,
            showReview: true,
            addPartnersMethod: '',
            partnersToSendTo: MMPartnerReducer.partnersToSendTo.concat(pullEmail),
            showSelectMethod: false
          });
        }
      })
    )
  );
};

ImportFromEmail.propTypes = {
  updateMMPartnerProp: _react.PropTypes.func,
  MMPartnerReducer: _react.PropTypes.object,
  MMPartnerReducer2: _react.PropTypes.object
};

ImportFromEmail.defaultProps = {
  MMPartnerReducer2: {}
};

var mapStateToProps = function mapStateToProps(_ref) {
  var marketingMaterials = _ref.marketingMaterials;
  return {
    MMPartnerReducer: marketingMaterials.partnerReducer.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ImportFromEmail);

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _csvUploadContainer = __webpack_require__(1458);

var _csvUploadContainer2 = _interopRequireDefault(_csvUploadContainer);

var _exCsvUploadContracting = __webpack_require__(1860);

var _exCsvUploadContracting2 = _interopRequireDefault(_exCsvUploadContracting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UploadFile = function UploadFile(props) {
  var updateMMPartnerProp = props.updateMMPartnerProp;

  var MMPartnerReducer = (0, _ramda.isEmpty)(props.MMPartnerReducer2) ? props.MMPartnerReducer : props.MMPartnerReducer2; // fallback to reducer
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_csvUploadContainer2.default, {
      onCompleteFunc: function onCompleteFunc(successfulRows) {
        updateMMPartnerProp({
          showUploadFileDialog: false,
          partnersToSendTo: MMPartnerReducer.partnersToSendTo.concat(successfulRows),
          showSelectMethod: false,
          showReview: true
        });
      },
      showFailedSection: true,
      open: MMPartnerReducer.showUploadFileDialog,
      onRequestClose: function onRequestClose() {
        return updateMMPartnerProp({ showUploadFileDialog: false });
      },
      dialogTitle: 'Upload A File',
      note: _react2.default.createElement(
        'div',
        null,
        'The CSV or Excel file must have the following layout: ',
        _react2.default.createElement(
          'b',
          null,
          'Company Name (optional), Email (required)'
        ),
        '. Example format:',
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('img', { src: _exCsvUploadContracting2.default, width: 500 })
      ),
      dropzoneText: 'Drag and drop your CSV or Excel file here or click inside to choose a file from your computer.',
      headers: [{
        headerTitle: 'companyName',
        required: false
      }, {
        headerTitle: 'email',
        required: true
      }]
    })
  );
};

UploadFile.propTypes = {
  updateMMPartnerProp: _react.PropTypes.func,
  MMPartnerReducer: _react.PropTypes.object,
  MMPartnerReducer2: _react.PropTypes.object
};

UploadFile.defaultProps = {
  MMPartnerReducer2: {}
};

var mapStateToProps = function mapStateToProps(_ref) {
  var marketingMaterials = _ref.marketingMaterials;
  return {
    MMPartnerReducer: marketingMaterials.partnerReducer.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(UploadFile);

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "57124bba512141ddea869ce6b30fb7c6.png";

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _validations = __webpack_require__(871);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var AddIndividually = function AddIndividually(props) {
  var updateMMPartnerProp = props.updateMMPartnerProp;

  var MMPartnerReducer = (0, _ramda.isEmpty)(props.MMPartnerReducer2) ? props.MMPartnerReducer : props.MMPartnerReducer2; // fallback to reducer
  var textFields = [{
    icon: 'tc-icon-office',
    iconStyle: { color: '#757575', lineHeight: '1', margin: '0px 28px 0px 7px' },
    label: 'Company Name (optional)',
    func: function func(_ref) {
      var value = _ref.target.value;
      return updateMMPartnerProp({ individualCompanyName: value });
    }
  }, {
    icon: 'tc-icon-email',
    iconStyle: { color: '#757575', margin: '0px 28px 0px 10px', fontSize: '20px' },
    label: 'Email',
    func: function func(_ref2) {
      var value = _ref2.target.value;
      return updateMMPartnerProp({ individualEmail: value });
    }
  }];
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: MMPartnerReducer.showAddIndividuallyDialog,
      actions: [_react2.default.createElement(_materialUi.FlatButton, {
        label: 'Cancel',
        primary: true,
        labelStyle: { fontWeight: '600' },
        onTouchTap: function onTouchTap() {
          return updateMMPartnerProp({
            showAddIndividuallyDialog: false,
            addPartnersMethod: ''
          });
        }
      }), _react2.default.createElement(_materialUi.FlatButton, {
        label: 'ADD',
        secondary: true,
        labelStyle: { fontWeight: '600' },
        onTouchTap: function onTouchTap() {
          return updateMMPartnerProp({
            showAddIndividuallyDialog: false,
            partnersToSendTo: (0, _ramda.not)(isNilOrEmpty(MMPartnerReducer.individualCompanyName)) ? (0, _ramda.append)({
              companyName: MMPartnerReducer.individualCompanyName,
              email: MMPartnerReducer.individualEmail
            }, MMPartnerReducer.partnersToSendTo) : (0, _ramda.append)({
              email: MMPartnerReducer.individualEmail
            }, MMPartnerReducer.partnersToSendTo),
            showSelectMethod: false,
            showReview: true,
            individualCompanyName: '',
            individualEmail: ''
          });
        },
        disabled: (0, _ramda.isEmpty)(MMPartnerReducer.individualEmail) || !(0, _validations.isValidEmail)(MMPartnerReducer.individualEmail)
      })],
      title: 'Add Individually',
      contentStyle: { width: '512px' },
      bodyStyle: { paddingTop: '0' }
    },
    textFields.map(function (field, i) {
      return _react2.default.createElement(
        'div',
        { className: 'add-individ-connection-dialog', key: i },
        _react2.default.createElement(_materialUi.FontIcon, {
          className: field.icon,
          style: field.iconStyle
        }),
        _react2.default.createElement(_materialUi.TextField, {
          hintText: 'Required',
          floatingLabelText: field.label,
          floatingLabelStyle: { fontSize: '1.1vw' },
          style: { width: '85%', marginBottom: '20px' },
          onChange: field.func
        })
      );
    })
  );
};

AddIndividually.propTypes = {
  updateMMPartnerProp: _react.PropTypes.func,
  MMPartnerReducer: _react.PropTypes.object,
  MMPartnerReducer2: _react.PropTypes.object
};

AddIndividually.defaultProps = {
  MMPartnerReducer2: {}
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var marketingMaterials = _ref3.marketingMaterials;
  return {
    MMPartnerReducer: marketingMaterials.partnerReducer.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddIndividually);

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GetVerified = function GetVerified(_ref) {
  var getVerified = _ref.getVerified,
      tcVerified = _ref.tcVerified;

  if (tcVerified) return null;
  return _react2.default.createElement(_materialUi.RaisedButton, {
    label: 'Get Verified',
    backgroundColor: '#F881B2',
    labelStyle: {
      color: 'white',
      fontSize: '1em',
      textTransform: 'none',
      fontWeight: 'bold'
    },
    onTouchTap: function onTouchTap() {
      getVerified();
    }
  });
};

module.exports = (0, _reactRedux.connect)(function (_ref2) {
  var user = _ref2.user;
  return {
    tcVerified: user.getIn(['company', 'tcVerified'])
  };
}, {
  getVerified: function getVerified() {
    return function (dispatch) {
      return dispatch({ type: '{profile} getVerified' });
    };
  }

})(GetVerified);

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionInfo = function ActionInfo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z' })
  );
};
ActionInfo = (0, _pure2.default)(ActionInfo);
ActionInfo.displayName = 'ActionInfo';
ActionInfo.muiName = 'SvgIcon';

exports.default = ActionInfo;

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDashboard = function ActionDashboard(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z' })
  );
};
ActionDashboard = (0, _pure2.default)(ActionDashboard);
ActionDashboard.displayName = 'ActionDashboard';
ActionDashboard.muiName = 'SvgIcon';

exports.default = ActionDashboard;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAssessment = function ActionAssessment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
  );
};
ActionAssessment = (0, _pure2.default)(ActionAssessment);
ActionAssessment.displayName = 'ActionAssessment';
ActionAssessment.muiName = 'SvgIcon';

exports.default = ActionAssessment;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _close = __webpack_require__(547);

var _close2 = _interopRequireDefault(_close);

var _lockOutline = __webpack_require__(1867);

var _lockOutline2 = _interopRequireDefault(_lockOutline);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _ramda = __webpack_require__(2);

var _PlanItems = __webpack_require__(2758);

var _PlanItems2 = _interopRequireDefault(_PlanItems);

var _PlanSelector = __webpack_require__(2765);

var _PlanSelector2 = _interopRequireDefault(_PlanSelector);

var _PlanDetails = __webpack_require__(2766);

var _PlanDetails2 = _interopRequireDefault(_PlanDetails);

var _CreditCardForm = __webpack_require__(1868);

var _CreditCardForm2 = _interopRequireDefault(_CreditCardForm);

var _sectionHeading = __webpack_require__(732);

var _sectionHeading2 = _interopRequireDefault(_sectionHeading);

var _billingActions = __webpack_require__(1108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Upgrade = function (_Component) {
  _inherits(Upgrade, _Component);

  function Upgrade(props) {
    _classCallCheck(this, Upgrade);

    var _this = _possibleConstructorReturn(this, (Upgrade.__proto__ || Object.getPrototypeOf(Upgrade)).call(this, props));

    _this.onPlanClick = function (i) {
      _this.setState({ selectedPlanIndex: i });
    };

    _this.onTermClick = function () {
      _this.setState({ isAnnualPlan: !_this.state.isAnnualPlan });
    };

    _this.onUpgradeClick = function () {
      _this.setState({ showCreditCardForm: true });
    };

    _this.getDisplayPrice = function (price, coupon) {
      if (!coupon) return price;
      switch (coupon.discount_type) {
        case 'percentage':
          return price - coupon.value / 100 * price;
        case 'amount':
          var discountedPrice = price - coupon.value;
          return discountedPrice > 0 ? discountedPrice : 0;
        default:
          return price;
      }
    };

    _this.filterPlan = function (planTerm) {
      var isAnnualPlan = _this.state.isAnnualPlan;

      return (isAnnualPlan ? 'year' : 'month') === planTerm;
    };

    _this.handleCouponDialogState = function () {
      _this.setState({
        couponCode: '',
        couponError: '',
        showCouponDialog: !_this.state.showCouponDialog
      });
    };

    _this.handleCouponCodeChange = function (e) {
      _this.setState({
        couponCode: e.target.value
      });
    };

    _this.handleCouponSubmit = function () {
      var dispatch = _this.props.dispatch;

      if (_this.state.couponCode) {
        dispatch((0, _billingActions.getCoupon)(_this.state.couponCode)).then(_this.handleCouponDialogState).catch(function () {
          _this.setState({ couponError: '"' + _this.state.couponCode + '" is an invalid promo code. If you believe this is in error, please email support@tourconnect.com.' });
        });
      } else {
        _this.setState({ couponError: 'Please enter a promo code.' });
      }
    };

    _this.getUniquePlans = function (plans) {
      return plans.filter(function (plan, index, array) {
        return array.findIndex(function (t) {
          return t.name === plan.name;
        }) === index;
      });
    };

    _this.state = {
      selectedPlanIndex: props.selectedPlanIndex || 0,
      isAnnualPlan: props.isAnnualPlan,
      showCreditCardForm: true, // switch to false to return to old upgrade page behavior
      showCouponDialog: props.showCouponDialog || false,
      couponCode: '',
      couponError: ''
    };
    return _this;
  }

  _createClass(Upgrade, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          billing = _props.billing,
          coupon = _props.billing.coupon,
          header = _props.header,
          isProcessing = _props.isProcessing,
          onClose = _props.onClose,
          profile = _props.profile,
          stripePublicKey = _props.stripePublicKey,
          user = _props.user,
          _state = this.state,
          isAnnualPlan = _state.isAnnualPlan,
          selectedPlanIndex = _state.selectedPlanIndex,
          showCouponDialog = _state.showCouponDialog,
          couponError = _state.couponError;

      var companyType = user.user.type;
      var productType = user.company.productType;

      var isSupplier = companyType !== 'Contractor';
      var plans = [{
        name: 'Connected',
        planId: 'b2b_platform_monthly',
        price: this.getDisplayPrice(120, coupon),
        additional: this.getDisplayPrice(30, coupon),
        term: 'month',
        planItems: ['Unlimited Connection Requests', 'Priority Listing in Search Results', 'See Who has Viewed Your Profile', 'Partner Match Notifications', !isSupplier ? 'Send Up To 200 Rates Requests' : 'Unlimited Marketing Materials']
      }, {
        name: 'Connected',
        planId: 'b2b_platform_annual',
        price: this.getDisplayPrice(1200, coupon),
        additional: this.getDisplayPrice(300, coupon),
        term: 'year',
        planItems: ['Unlimited Connection Requests', 'Priority Listing in Search Results', 'See Who has Viewed Your Profile', 'Partner Match Notifications', !isSupplier ? 'Send Up To 200 Rates Requests' : 'Unlimited Marketing Materials'],
        ccDescription: {
          name: 'Connected Plan',
          type: 'Annual (12-months)',
          renewal: 'Automatic'
        }
      }, {
        name: 'Enterprise',
        price: 'Custom',
        planItems: ['Unlimited Connection Requests', 'Priority Listing in Search Results', 'See Who has Viewed Your Profile', 'Partner Match Notifications', 'Unlimited Contracts & Rates', 'API Access & Integrations']
      }];

      var selectedPlan = plans.filter(function (plan) {
        return !plan.term || _this2.filterPlan(plan.term);
      })[!isSupplier ? selectedPlanIndex : 0];

      var marketingReadyLocations = (0, _ramda.pathOr)([], ['locations'], profile).filter(function (location) {
        return location.isMarketingReady;
      });
      var creditCardForm = function creditCardForm() {
        var supplierProductInfo = function supplierProductInfo() {
          if (marketingReadyLocations.length < 1) return undefined;
          return _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', verticalAlign: 'top', width: '50%' } },
            _react2.default.createElement(_sectionHeading2.default, {
              title: marketingReadyLocations.length + ' Marketing Ready ' + (0, _pluralize2.default)(productType === 'Non-Accommodation' ? 'Location' : 'Property', marketingReadyLocations.length),
              style: { whiteSpace: 'pre-wrap' }
            }),
            _react2.default.createElement(
              'div',
              { style: { maxHeight: '100px', overflowY: 'scroll' } },
              marketingReadyLocations.map(function (location, i) {
                return _react2.default.createElement(
                  'div',
                  { key: i, className: 'flex-tc-sb' },
                  _react2.default.createElement(
                    'div',
                    { style: { padding: '4px' } },
                    '' + location.name
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: { padding: '4px' } },
                    '$' + (i ? selectedPlan.additional : selectedPlan.price)
                  )
                );
              })
            )
          );
        };
        return _react2.default.createElement(
          'div',
          { style: { margin: '0 auto', maxWidth: '1232px', paddingTop: '50px' } },
          _react2.default.createElement(
            'div',
            { style: { width: '75%', margin: '0 auto' } },
            supplierProductInfo(),
            _react2.default.createElement(
              'div',
              {
                style: {
                  display: 'inline-block',
                  padding: '15px',
                  verticalAlign: 'top',
                  width: isSupplier && marketingReadyLocations.length ? '50%' : '100%',
                  textAlign: 'center'
                }
              },
              marketingReadyLocations.length > 0 && _react2.default.createElement(
                'p',
                { style: { fontSize: '14px' } },
                'Your subscription will be for ' + marketingReadyLocations.length + ' marketing ready ' + (0, _pluralize2.default)(productType === 'Non-Accommodation' ? 'location' : 'property', marketingReadyLocations.length) + '\n                  on the Connected Plan and will renew on ' + (0, _moment2.default)().clone().add(1, selectedPlan.term).format('ll') + '.'
              ),
              (marketingReadyLocations.length === 0 || !isSupplier) && _react2.default.createElement(
                'p',
                { style: { fontSize: '14px' } },
                'Your account will be upgraded to the Connected Plan and will renew on ',
                (0, _moment2.default)().clone().add(1, selectedPlan.term).format('ll'),
                '.'
              )
            ),
            _react2.default.createElement(
              'h4',
              { style: { textAlign: 'right' } },
              'Total Charged Today',
              isSupplier && ' (' + (marketingReadyLocations.length || 1) + ' ' + (0, _pluralize2.default)(productType === 'Non-Accommodation' ? 'Location' : 'Property', marketingReadyLocations.length) + ')',
              ' - ',
              selectedPlan.price + ((marketingReadyLocations.length || 1) - 1) * selectedPlan.additional,
              _react2.default.createElement(
                'span',
                { style: { fontSize: '12px' } },
                'USD'
              )
            )
          ),
          _react2.default.createElement(
            _materialUi.Paper,
            { style: { width: '75%', margin: '0 auto' } },
            _react2.default.createElement(
              'div',
              { style: { backgroundColor: 'rgb(0, 188, 212)', borderRadius: '2px 2px 0 0', padding: '10px', textAlign: 'left', width: '100%' } },
              _react2.default.createElement(_lockOutline2.default, { style: { color: '#fff', width: '30px', height: '30px' } })
            ),
            _react2.default.createElement(
              'div',
              { style: { padding: '25px' } },
              billing.errorMessage && _react2.default.createElement(
                'p',
                {
                  style: {
                    color: '#ff5e5c',
                    lineHeight: '18px',
                    marginBottom: '12px',
                    borderRadius: '4px',
                    background: '#fff5f5',
                    padding: '16px 23px 16px 16px',
                    fontSize: '12px'
                  }
                },
                billing.errorMessage
              ),
              _react2.default.createElement(_CreditCardForm2.default, {
                stripePublicKey: stripePublicKey,
                buttonStyle: { display: 'block', margin: '40px auto 25px auto' },
                containerStyle: { width: '100%' }, inputFieldStyle: { verticalAlign: 'top' },
                submitDisabled: isProcessing,
                isProcessing: isProcessing,
                onCreateToken: function onCreateToken(status, response) {
                  if (status === 200) _this2.props.onUpgrade(selectedPlan, response);
                }
              })
            )
          ),
          !coupon && _react2.default.createElement(
            'div',
            { style: { display: 'block', textAlign: 'right', margin: '1em auto', width: '75%' } },
            _react2.default.createElement(
              'a',
              { href: '', onClick: function onClick(e) {
                  e.preventDefault();_this2.handleCouponDialogState();
                } },
              'Promo Code?'
            )
          )
        );
      };

      var planDetails = function planDetails() {
        return _react2.default.createElement(
          'div',
          { style: { margin: '0 auto', maxWidth: '1232px' } },
          header && _react2.default.createElement(
            'div',
            { style: { width: '75%', padding: '0', margin: '0 auto 25px auto' } },
            (0, _react.isValidElement)(header) ? (0, _react.cloneElement)(header) : _react2.default.createElement(
              'h1',
              { style: { fontSize: '21px', fontWeight: 300, lineHeight: '36px', margin: 0, textAlign: 'center', paddingTop: '25px' } },
              header
            )
          ),
          _react2.default.createElement(_PlanDetails2.default, {
            companyType: companyType,
            productType: productType,
            onTermClick: _this2.onTermClick,
            onUpgradeClick: _this2.onUpgradeClick,
            plan: selectedPlan,
            isAnnualPlan: isAnnualPlan
          })
        );
      };

      return _react2.default.createElement(
        'div',
        { style: { backgroundColor: 'rgb(250, 250, 250)', position: 'fixed', top: 0, left: 0, height: '100%', width: '100%', overflowY: 'scroll', zIndex: '100' } },
        _react2.default.createElement(_close2.default, { onClick: onClose, style: { position: 'absolute', right: '10px', top: '10px', height: '36px', width: '36px', cursor: 'pointer' } }),
        planDetails(),
        creditCardForm(),
        _react2.default.createElement(
          _materialUi.Dialog,
          { actions: [_react2.default.createElement(_materialUi.FlatButton, {
              label: 'Cancel',
              primary: true,
              onTouchTap: this.handleCouponDialogState
            }), _react2.default.createElement(_materialUi.FlatButton, {
              label: 'Add',
              secondary: true,
              onTouchTap: this.handleCouponSubmit
            })],
            contentStyle: { maxWidth: '500px' },
            onRequestClose: this.handleCouponDialogState,
            open: showCouponDialog,
            title: 'Promo Code'
          },
          couponError && _react2.default.createElement(
            'p',
            { style: {
                color: '#ff5e5c',
                lineHeight: '18px',
                marginBottom: '12px',
                borderRadius: '4px',
                background: '#fff5f5',
                padding: '16px 23px 16px 16px',
                fontSize: '12px'
              }
            },
            couponError
          ),
          _react2.default.createElement(_materialUi.TextField, {
            name: 'couponCode',
            fullWidth: true,
            onChange: this.handleCouponCodeChange,
            hintText: 'Enter Promo Code'
          })
        )
      );
    }
  }]);

  return Upgrade;
}(_react.Component);

Upgrade.propTypes = {
  children: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  history: _react.PropTypes.object,
  onClose: _react.PropTypes.func,
  profile: _react.PropTypes.object,
  user: _react.PropTypes.object,
  header: _react.PropTypes.node
};

exports.default = Upgrade;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLockOutline = function ActionLockOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z' })
  );
};
ActionLockOutline = (0, _pure2.default)(ActionLockOutline);
ActionLockOutline.displayName = 'ActionLockOutline';
ActionLockOutline.muiName = 'SvgIcon';

exports.default = ActionLockOutline;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _joiBrowser = __webpack_require__(1869);

var _joiBrowser2 = _interopRequireDefault(_joiBrowser);

var _reactAsyncScriptLoader = __webpack_require__(1457);

var _reactAsyncScriptLoader2 = _interopRequireDefault(_reactAsyncScriptLoader);

var _joiValidationStrategy = __webpack_require__(2767);

var _joiValidationStrategy2 = _interopRequireDefault(_joiValidationStrategy);

var _reactValidationMixin = __webpack_require__(2789);

var _reactValidationMixin2 = _interopRequireDefault(_reactValidationMixin);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreditCardForm = function (_Component) {
  _inherits(CreditCardForm, _Component);

  function CreditCardForm(props) {
    _classCallCheck(this, CreditCardForm);

    var _this = _possibleConstructorReturn(this, (CreditCardForm.__proto__ || Object.getPrototypeOf(CreditCardForm)).call(this, props));

    _this.onScriptError = function () {
      console.error('There was an issue loading the script');
    };

    _this.onScriptLoaded = function () {
      _this.Stripe = window.Stripe;
      _this.Stripe.setPublishableKey(_this.props.stripePublicKey);

      _this.setState({ disabledButton: false });
    };

    _this.onValidate = function (error) {
      if (!error) {
        var _this$refs = _this.refs,
            cardName = _this$refs.cardName,
            cardNumber = _this$refs.cardNumber,
            cardExpirationMonth = _this$refs.cardExpirationMonth,
            cardExpirationYear = _this$refs.cardExpirationYear,
            cardCVC = _this$refs.cardCVC;


        _this.Stripe.card.createToken({
          name: cardName.getValue().trim(),
          number: cardNumber.getValue().trim(),
          cvc: cardCVC.getValue().trim(),
          exp_month: cardExpirationMonth.getValue().trim(),
          exp_year: cardExpirationYear.getValue().trim()
        }, function (status, response) {
          if (status === 200) {
            _this.billingProviderCallback(status, response);
          } else {
            _this.setState({ disabledButton: false });
          }
        });
      } else {
        _this.setState({ disabledButton: false });
        console.log(error);
      }
    };

    _this.getValidatorData = function () {
      var _this$refs2 = _this.refs,
          cardName = _this$refs2.cardName,
          cardNumber = _this$refs2.cardNumber,
          cardExpirationMonth = _this$refs2.cardExpirationMonth,
          cardExpirationYear = _this$refs2.cardExpirationYear,
          cardCVC = _this$refs2.cardCVC;


      return {
        cardName: cardName.getValue().trim(),
        cardNumber: cardNumber.getValue().trim(),
        cardExpirationMonth: cardExpirationMonth.getValue().trim(),
        cardExpirationYear: cardExpirationYear.getValue().trim(),
        cardCVC: cardCVC.getValue().trim()
      };
    };

    _this.billingProviderCallback = function (status, response) {
      _this.props.onCreateToken(status, response);
      _this.setState({ disabledButton: false });
    };

    _this.handleOnClick = function (e) {
      e.preventDefault();
      _this.setState({ disabledButton: true });
      _this.props.validate(_this.onValidate);
    };

    _this.state = {
      disabledButton: true,
      stripeLoaded: false
    };

    _this.validatorTypes = {
      cardName: _joiBrowser2.default.string().required().label('Name on Card'),
      cardNumber: _joiBrowser2.default.string().creditCard().required().label('Credit Card').options({
        language: {
          string: {
            creditCard: '!!Please check your credit card number is correct.'
          }
        }
      }),
      cardExpirationMonth: _joiBrowser2.default.number().required().max(12).label('Expiration Month'),
      cardExpirationYear: _joiBrowser2.default.string().regex(/^(\d{2}|\d{4})$/).required().label('Expiration Year').options({
        language: {
          any: {
            empty: 'is not allowed to be empty',
            required: 'is required'
          },
          string: {
            regex: {
              base: '!!Please enter a 2 or 4 digit card expiration year'
            }
          }
        }
      }),
      cardCVC: _joiBrowser2.default.string().regex(/^\d{3,4}$/).required().label('Card Verification Number').options({
        language: {
          any: {
            empty: 'is not allowed to be empty',
            required: 'is required'
          },
          string: {
            regex: {
              base: '!!Please enter a 3 or 4 digit card verification number'
            }
          }
        }
      })
    };
    return _this;
  }

  _createClass(CreditCardForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          isScriptLoaded = _props.isScriptLoaded,
          isScriptLoadSucceed = _props.isScriptLoadSucceed;

      if (isScriptLoaded && isScriptLoadSucceed) {
        this.onScriptLoaded();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var isScriptLoaded = _ref.isScriptLoaded,
          isScriptLoadSucceed = _ref.isScriptLoadSucceed;

      if (isScriptLoaded && !this.props.isScriptLoaded) {
        // load finished
        if (isScriptLoadSucceed) {
          this.onScriptLoaded();
        } else {
          this.onScriptError();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          buttonText = _props2.buttonText,
          buttonStyle = _props2.buttonStyle,
          containerStyle = _props2.containerStyle,
          inputFieldStyle = _props2.inputFieldStyle,
          submitDisabled = _props2.submitDisabled;


      return _react2.default.createElement(
        'div',
        { style: _extends({}, { width: '300px' }, containerStyle) },
        _react2.default.createElement(_materialUi.TextField, {
          floatingLabelText: 'Name On Card',
          fullWidth: true,
          name: 'cardName',
          ref: 'cardName',
          errorText: this.props.getValidationMessages('cardName').length > 0 ? this.props.getValidationMessages('cardName')[0] : null,
          tabIndex: 1,
          style: _extends({}, inputFieldStyle)
        }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_materialUi.TextField, {
          floatingLabelText: 'Card Number',
          fullWidth: true,
          name: 'cardNumber',
          ref: 'cardNumber',
          errorText: this.props.getValidationMessages('cardNumber').length > 0 ? this.props.getValidationMessages('cardNumber')[0] : null,
          maxLength: '16',
          tabIndex: 2,
          style: _extends({}, inputFieldStyle)
        }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_materialUi.TextField, {
          floatingLabelText: 'CVN / CVC',
          fullWidth: true,
          name: 'cardCVC',
          ref: 'cardCVC',
          errorText: this.props.getValidationMessages('cardCVC').length > 0 ? this.props.getValidationMessages('cardCVC')[0] : null,
          style: _extends({}, { width: '40%', marginRight: '9%' }, inputFieldStyle),
          tabIndex: 3
        }),
        _react2.default.createElement(_materialUi.TextField, {
          floatingLabelText: 'Expiration Month',
          fullWidth: true,
          name: 'cardExpirationMonth',
          ref: 'cardExpirationMonth',
          errorText: this.props.getValidationMessages('cardExpirationMonth').length > 0 ? this.props.getValidationMessages('cardExpirationMonth')[0] : null,
          style: _extends({}, { width: '25%', marginRight: '5px' }, inputFieldStyle),
          tabIndex: 4
        }),
        _react2.default.createElement(_materialUi.TextField, {
          floatingLabelText: 'Expiration Year',
          fullWidth: true,
          name: 'cardExpirationYear',
          ref: 'cardExpirationYear',
          errorText: this.props.getValidationMessages('cardExpirationYear').length > 0 ? this.props.getValidationMessages('cardExpirationYear')[0] : null,
          style: _extends({}, { width: '25%' }, inputFieldStyle),
          tabIndex: 5
        }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_materialUi.RaisedButton, {
          label: this.props.isProcessing ? 'Processing' : buttonText,
          primary: true,
          disabled: submitDisabled || this.state.disabledButton,
          onClick: this.handleOnClick,
          tabIndex: 6,
          style: _extends({}, { textAlign: 'center', width: '256px', marginTop: '40px' }, buttonStyle)
        })
      );
    }
  }]);

  return CreditCardForm;
}(_react.Component);

CreditCardForm.defaultProps = {
  buttonText: 'Start Subscription'
};

CreditCardForm.propTypes = {
  // Customize the value of form button
  buttonText: _react.PropTypes.string,

  // Represent whether the form is submitable yet.
  submitDisabled: _react.PropTypes.bool,

  // A function that is called with the response of stripe.js create token request
  getValidationMessages: _react.PropTypes.func,

  // Represent whether the form is processing
  isProcessing: _react.PropTypes.bool,

  // Represent scripts loading process is over or not, maybe part of scripts load failed.
  isScriptLoaded: _react.PropTypes.bool,

  // Represent all scripts load successfully or not.
  isScriptLoadSucceed: _react.PropTypes.bool,

  // Triggered when all scripts load successfully.
  onScriptLoaded: _react.PropTypes.func,

  // A function that is called with the response of stripe.js create token request (status, response)
  onCreateToken: _react.PropTypes.func,

  // A function that is called with the response of stripe.js create token request
  validate: _react.PropTypes.func
};

exports.default = (0, _reactAsyncScriptLoader2.default)('https://js.stripe.com/v2/')((0, _reactValidationMixin2.default)(_joiValidationStrategy2.default)(CreditCardForm));

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Joi", [], factory);
	else if(typeof exports === 'object')
		exports["Joi"] = factory();
	else
		root["Joi"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, process) {

// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Crypto = __webpack_require__(14);
var Path = __webpack_require__(34);
var Util = __webpack_require__(38);
var Escape = __webpack_require__(15);

// Declare internals

var internals = {};

// Clone object or array

exports.clone = function (obj, seen) {

    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) {

        return obj;
    }

    seen = seen || new Map();

    var lookup = seen.get(obj);
    if (lookup) {
        return lookup;
    }

    var newObj = void 0;
    var cloneDeep = false;

    if (!Array.isArray(obj)) {
        if (Buffer.isBuffer(obj)) {
            newObj = new Buffer(obj);
        } else if (obj instanceof Date) {
            newObj = new Date(obj.getTime());
        } else if (obj instanceof RegExp) {
            newObj = new RegExp(obj);
        } else {
            var proto = Object.getPrototypeOf(obj);
            if (proto && proto.isImmutable) {

                newObj = obj;
            } else {
                newObj = Object.create(proto);
                cloneDeep = true;
            }
        }
    } else {
        newObj = [];
        cloneDeep = true;
    }

    seen.set(obj, newObj);

    if (cloneDeep) {
        var keys = Object.getOwnPropertyNames(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            var descriptor = Object.getOwnPropertyDescriptor(obj, key);
            if (descriptor && (descriptor.get || descriptor.set)) {

                Object.defineProperty(newObj, key, descriptor);
            } else {
                newObj[key] = exports.clone(obj[key], seen);
            }
        }
    }

    return newObj;
};

// Merge all the properties of source into target, source wins in conflict, and by default null and undefined from source are applied

/*eslint-disable */
exports.merge = function (target, source, isNullOverride /* = true */, isMergeArrays /* = true */) {
    /*eslint-enable */

    exports.assert(target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object', 'Invalid target value: must be an object');
    exports.assert(source === null || source === undefined || (typeof source === 'undefined' ? 'undefined' : _typeof(source)) === 'object', 'Invalid source value: must be null, undefined, or an object');

    if (!source) {
        return target;
    }

    if (Array.isArray(source)) {
        exports.assert(Array.isArray(target), 'Cannot merge array onto an object');
        if (isMergeArrays === false) {
            // isMergeArrays defaults to true
            target.length = 0; // Must not change target assignment
        }

        for (var i = 0; i < source.length; ++i) {
            target.push(exports.clone(source[i]));
        }

        return target;
    }

    var keys = Object.keys(source);
    for (var _i = 0; _i < keys.length; ++_i) {
        var key = keys[_i];
        var value = source[key];
        if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {

            if (!target[key] || _typeof(target[key]) !== 'object' || Array.isArray(target[key]) !== Array.isArray(value) || value instanceof Date || Buffer.isBuffer(value) || value instanceof RegExp) {

                target[key] = exports.clone(value);
            } else {
                exports.merge(target[key], value, isNullOverride, isMergeArrays);
            }
        } else {
            if (value !== null && value !== undefined) {
                // Explicit to preserve empty strings

                target[key] = value;
            } else if (isNullOverride !== false) {
                // Defaults to true
                target[key] = value;
            }
        }
    }

    return target;
};

// Apply options to a copy of the defaults

exports.applyToDefaults = function (defaults, options, isNullOverride) {

    exports.assert(defaults && (typeof defaults === 'undefined' ? 'undefined' : _typeof(defaults)) === 'object', 'Invalid defaults value: must be an object');
    exports.assert(!options || options === true || (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object', 'Invalid options value: must be true, falsy or an object');

    if (!options) {
        // If no options, return null
        return null;
    }

    var copy = exports.clone(defaults);

    if (options === true) {
        // If options is set to true, use defaults
        return copy;
    }

    return exports.merge(copy, options, isNullOverride === true, false);
};

// Clone an object except for the listed keys which are shallow copied

exports.cloneWithShallow = function (source, keys) {

    if (!source || (typeof source === 'undefined' ? 'undefined' : _typeof(source)) !== 'object') {

        return source;
    }

    var storage = internals.store(source, keys); // Move shallow copy items to storage
    var copy = exports.clone(source); // Deep copy the rest
    internals.restore(copy, source, storage); // Shallow copy the stored items and restore
    return copy;
};

internals.store = function (source, keys) {

    var storage = {};
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = exports.reach(source, key);
        if (value !== undefined) {
            storage[key] = value;
            internals.reachSet(source, key, undefined);
        }
    }

    return storage;
};

internals.restore = function (copy, source, storage) {

    var keys = Object.keys(storage);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        internals.reachSet(copy, key, storage[key]);
        internals.reachSet(source, key, storage[key]);
    }
};

internals.reachSet = function (obj, key, value) {

    var path = key.split('.');
    var ref = obj;
    for (var i = 0; i < path.length; ++i) {
        var segment = path[i];
        if (i + 1 === path.length) {
            ref[segment] = value;
        }

        ref = ref[segment];
    }
};

// Apply options to defaults except for the listed keys which are shallow copied from option without merging

exports.applyToDefaultsWithShallow = function (defaults, options, keys) {

    exports.assert(defaults && (typeof defaults === 'undefined' ? 'undefined' : _typeof(defaults)) === 'object', 'Invalid defaults value: must be an object');
    exports.assert(!options || options === true || (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object', 'Invalid options value: must be true, falsy or an object');
    exports.assert(keys && Array.isArray(keys), 'Invalid keys');

    if (!options) {
        // If no options, return null
        return null;
    }

    var copy = exports.cloneWithShallow(defaults, keys);

    if (options === true) {
        // If options is set to true, use defaults
        return copy;
    }

    var storage = internals.store(options, keys); // Move shallow copy items to storage
    exports.merge(copy, options, false, false); // Deep copy the rest
    internals.restore(copy, options, storage); // Shallow copy the stored items and restore
    return copy;
};

// Deep object or array comparison

exports.deepEqual = function (obj, ref, options, seen) {

    options = options || { prototype: true };

    var type = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);

    if (type !== (typeof ref === 'undefined' ? 'undefined' : _typeof(ref))) {
        return false;
    }

    if (type !== 'object' || obj === null || ref === null) {

        if (obj === ref) {
            // Copied from Deep-eql, copyright(c) 2013 Jake Luer, jake@alogicalparadox.com, MIT Licensed, https://github.com/chaijs/deep-eql
            return obj !== 0 || 1 / obj === 1 / ref; // -0 / +0
        }

        return obj !== obj && ref !== ref; // NaN
    }

    seen = seen || [];
    if (seen.indexOf(obj) !== -1) {
        return true; // If previous comparison failed, it would have stopped execution
    }

    seen.push(obj);

    if (Array.isArray(obj)) {
        if (!Array.isArray(ref)) {
            return false;
        }

        if (!options.part && obj.length !== ref.length) {
            return false;
        }

        for (var i = 0; i < obj.length; ++i) {
            if (options.part) {
                var found = false;
                for (var j = 0; j < ref.length; ++j) {
                    if (exports.deepEqual(obj[i], ref[j], options)) {
                        found = true;
                        break;
                    }
                }

                return found;
            }

            if (!exports.deepEqual(obj[i], ref[i], options)) {
                return false;
            }
        }

        return true;
    }

    if (Buffer.isBuffer(obj)) {
        if (!Buffer.isBuffer(ref)) {
            return false;
        }

        if (obj.length !== ref.length) {
            return false;
        }

        for (var _i2 = 0; _i2 < obj.length; ++_i2) {
            if (obj[_i2] !== ref[_i2]) {
                return false;
            }
        }

        return true;
    }

    if (obj instanceof Date) {
        return ref instanceof Date && obj.getTime() === ref.getTime();
    }

    if (obj instanceof RegExp) {
        return ref instanceof RegExp && obj.toString() === ref.toString();
    }

    if (options.prototype) {
        if (Object.getPrototypeOf(obj) !== Object.getPrototypeOf(ref)) {
            return false;
        }
    }

    var keys = Object.getOwnPropertyNames(obj);

    if (!options.part && keys.length !== Object.getOwnPropertyNames(ref).length) {
        return false;
    }

    for (var _i3 = 0; _i3 < keys.length; ++_i3) {
        var key = keys[_i3];
        var descriptor = Object.getOwnPropertyDescriptor(obj, key);
        if (descriptor.get) {
            if (!exports.deepEqual(descriptor, Object.getOwnPropertyDescriptor(ref, key), options, seen)) {
                return false;
            }
        } else if (!exports.deepEqual(obj[key], ref[key], options, seen)) {
            return false;
        }
    }

    return true;
};

// Remove duplicate items from array

exports.unique = function (array, key) {

    var result = void 0;
    if (key) {
        result = [];
        var index = new Set();
        array.forEach(function (item) {

            var identifier = item[key];
            if (!index.has(identifier)) {
                index.add(identifier);
                result.push(item);
            }
        });
    } else {
        result = Array.from(new Set(array));
    }

    return result;
};

// Convert array into object

exports.mapToObject = function (array, key) {

    if (!array) {
        return null;
    }

    var obj = {};
    for (var i = 0; i < array.length; ++i) {
        if (key) {
            if (array[i][key]) {
                obj[array[i][key]] = true;
            }
        } else {
            obj[array[i]] = true;
        }
    }

    return obj;
};

// Find the common unique items in two arrays

exports.intersect = function (array1, array2, justFirst) {

    if (!array1 || !array2) {
        return [];
    }

    var common = [];
    var hash = Array.isArray(array1) ? exports.mapToObject(array1) : array1;
    var found = {};
    for (var i = 0; i < array2.length; ++i) {
        if (hash[array2[i]] && !found[array2[i]]) {
            if (justFirst) {
                return array2[i];
            }

            common.push(array2[i]);
            found[array2[i]] = true;
        }
    }

    return justFirst ? null : common;
};

// Test if the reference contains the values

exports.contain = function (ref, values, options) {

    /*
        string -> string(s)
        array -> item(s)
        object -> key(s)
        object -> object (key:value)
    */

    var valuePairs = null;
    if ((typeof ref === 'undefined' ? 'undefined' : _typeof(ref)) === 'object' && (typeof values === 'undefined' ? 'undefined' : _typeof(values)) === 'object' && !Array.isArray(ref) && !Array.isArray(values)) {

        valuePairs = values;
        values = Object.keys(values);
    } else {
        values = [].concat(values);
    }

    options = options || {}; // deep, once, only, part

    exports.assert(typeof ref === 'string' || (typeof ref === 'undefined' ? 'undefined' : _typeof(ref)) === 'object', 'Reference must be string or an object');
    exports.assert(values.length, 'Values array cannot be empty');

    var compare = void 0;
    var compareFlags = void 0;
    if (options.deep) {
        compare = exports.deepEqual;

        var hasOnly = options.hasOwnProperty('only');
        var hasPart = options.hasOwnProperty('part');

        compareFlags = {
            prototype: hasOnly ? options.only : hasPart ? !options.part : false,
            part: hasOnly ? !options.only : hasPart ? options.part : true
        };
    } else {
        compare = function compare(a, b) {
            return a === b;
        };
    }

    var misses = false;
    var matches = new Array(values.length);
    for (var i = 0; i < matches.length; ++i) {
        matches[i] = 0;
    }

    if (typeof ref === 'string') {
        var pattern = '(';
        for (var _i4 = 0; _i4 < values.length; ++_i4) {
            var value = values[_i4];
            exports.assert(typeof value === 'string', 'Cannot compare string reference to non-string value');
            pattern += (_i4 ? '|' : '') + exports.escapeRegex(value);
        }

        var regex = new RegExp(pattern + ')', 'g');
        var leftovers = ref.replace(regex, function ($0, $1) {

            var index = values.indexOf($1);
            ++matches[index];
            return ''; // Remove from string
        });

        misses = !!leftovers;
    } else if (Array.isArray(ref)) {
        for (var _i5 = 0; _i5 < ref.length; ++_i5) {
            var matched = false;
            for (var j = 0; j < values.length && matched === false; ++j) {
                matched = compare(values[j], ref[_i5], compareFlags) && j;
            }

            if (matched !== false) {
                ++matches[matched];
            } else {
                misses = true;
            }
        }
    } else {
        var keys = Object.getOwnPropertyNames(ref);
        for (var _i6 = 0; _i6 < keys.length; ++_i6) {
            var key = keys[_i6];
            var pos = values.indexOf(key);
            if (pos !== -1) {
                if (valuePairs && !compare(valuePairs[key], ref[key], compareFlags)) {

                    return false;
                }

                ++matches[pos];
            } else {
                misses = true;
            }
        }
    }

    var result = false;
    for (var _i7 = 0; _i7 < matches.length; ++_i7) {
        result = result || !!matches[_i7];
        if (options.once && matches[_i7] > 1 || !options.part && !matches[_i7]) {

            return false;
        }
    }

    if (options.only && misses) {

        return false;
    }

    return result;
};

// Flatten array

exports.flatten = function (array, target) {

    var result = target || [];

    for (var i = 0; i < array.length; ++i) {
        if (Array.isArray(array[i])) {
            exports.flatten(array[i], result);
        } else {
            result.push(array[i]);
        }
    }

    return result;
};

// Convert an object key chain string ('a.b.c') to reference (object[a][b][c])

exports.reach = function (obj, chain, options) {

    if (chain === false || chain === null || typeof chain === 'undefined') {

        return obj;
    }

    options = options || {};
    if (typeof options === 'string') {
        options = { separator: options };
    }

    var path = chain.split(options.separator || '.');
    var ref = obj;
    for (var i = 0; i < path.length; ++i) {
        var key = path[i];
        if (key[0] === '-' && Array.isArray(ref)) {
            key = key.slice(1, key.length);
            key = ref.length - key;
        }

        if (!ref || !(((typeof ref === 'undefined' ? 'undefined' : _typeof(ref)) === 'object' || typeof ref === 'function') && key in ref) || (typeof ref === 'undefined' ? 'undefined' : _typeof(ref)) !== 'object' && options.functions === false) {
            // Only object and function can have properties

            exports.assert(!options.strict || i + 1 === path.length, 'Missing segment', key, 'in reach path ', chain);
            exports.assert((typeof ref === 'undefined' ? 'undefined' : _typeof(ref)) === 'object' || options.functions === true || typeof ref !== 'function', 'Invalid segment', key, 'in reach path ', chain);
            ref = options.default;
            break;
        }

        ref = ref[key];
    }

    return ref;
};

exports.reachTemplate = function (obj, template, options) {

    return template.replace(/{([^}]+)}/g, function ($0, chain) {

        var value = exports.reach(obj, chain, options);
        return value === undefined || value === null ? '' : value;
    });
};

exports.formatStack = function (stack) {

    var trace = [];
    for (var i = 0; i < stack.length; ++i) {
        var item = stack[i];
        trace.push([item.getFileName(), item.getLineNumber(), item.getColumnNumber(), item.getFunctionName(), item.isConstructor()]);
    }

    return trace;
};

exports.formatTrace = function (trace) {

    var display = [];

    for (var i = 0; i < trace.length; ++i) {
        var row = trace[i];
        display.push((row[4] ? 'new ' : '') + row[3] + ' (' + row[0] + ':' + row[1] + ':' + row[2] + ')');
    }

    return display;
};

exports.callStack = function (slice) {

    // http://code.google.com/p/v8/wiki/JavaScriptStackTraceApi

    var v8 = Error.prepareStackTrace;
    Error.prepareStackTrace = function (_, stack) {

        return stack;
    };

    var capture = {};
    Error.captureStackTrace(capture, this);
    var stack = capture.stack;

    Error.prepareStackTrace = v8;

    var trace = exports.formatStack(stack);

    return trace.slice(1 + slice);
};

exports.displayStack = function (slice) {

    var trace = exports.callStack(slice === undefined ? 1 : slice + 1);

    return exports.formatTrace(trace);
};

exports.abortThrow = false;

exports.abort = function (message, hideStack) {

    if (process.env.NODE_ENV === 'test' || exports.abortThrow === true) {
        throw new Error(message || 'Unknown error');
    }

    var stack = '';
    if (!hideStack) {
        stack = exports.displayStack(1).join('\n\t');
    }
    console.log('ABORT: ' + message + '\n\t' + stack);
    process.exit(1);
};

exports.assert = function (condition) {

    if (condition) {
        return;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    if (args.length === 1 && args[0] instanceof Error) {
        throw args[0];
    }

    var msgs = args.filter(function (arg) {
        return arg !== '';
    }).map(function (arg) {

        return typeof arg === 'string' ? arg : arg instanceof Error ? arg.message : exports.stringify(arg);
    });

    throw new Error(msgs.join(' ') || 'Unknown error');
};

exports.Bench = function () {

    this.ts = 0;
    this.reset();
};

exports.Bench.prototype.reset = function () {

    this.ts = exports.Bench.now();
};

exports.Bench.prototype.elapsed = function () {

    return exports.Bench.now() - this.ts;
};

exports.Bench.now = function () {

    var ts = process.hrtime();
    return ts[0] * 1e3 + ts[1] / 1e6;
};

// Escape string for Regex construction

exports.escapeRegex = function (string) {

    // Escape ^$.*+-?=!:|\/()[]{},
    return string.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, '\\$&');
};

// Base64url (RFC 4648) encode

exports.base64urlEncode = function (value, encoding) {

    exports.assert(typeof value === 'string' || Buffer.isBuffer(value), 'value must be string or buffer');
    var buf = Buffer.isBuffer(value) ? value : new Buffer(value, encoding || 'binary');
    return buf.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/\=/g, '');
};

// Base64url (RFC 4648) decode

exports.base64urlDecode = function (value, encoding) {

    if (typeof value !== 'string') {

        throw new Error('Value not a string');
    }

    if (!/^[\w\-]*$/.test(value)) {

        throw new Error('Invalid character');
    }

    var buf = new Buffer(value, 'base64');
    return encoding === 'buffer' ? buf : buf.toString(encoding || 'binary');
};

// Escape attribute value for use in HTTP header

exports.escapeHeaderAttribute = function (attribute) {

    // Allowed value characters: !#$%&'()*+,-./:;<=>?@[]^_`{|}~ and space, a-z, A-Z, 0-9, \, "

    exports.assert(/^[ \w\!#\$%&'\(\)\*\+,\-\.\/\:;<\=>\?@\[\]\^`\{\|\}~\"\\]*$/.test(attribute), 'Bad attribute value (' + attribute + ')');

    return attribute.replace(/\\/g, '\\\\').replace(/\"/g, '\\"'); // Escape quotes and slash
};

exports.escapeHtml = function (string) {

    return Escape.escapeHtml(string);
};

exports.escapeJavaScript = function (string) {

    return Escape.escapeJavaScript(string);
};

exports.escapeJson = function (string) {

    return Escape.escapeJson(string);
};

exports.once = function (method) {

    if (method._hoekOnce) {
        return method;
    }

    var once = false;
    var wrapped = function wrapped() {

        if (!once) {
            once = true;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            method.apply(null, args);
        }
    };

    wrapped._hoekOnce = true;
    return wrapped;
};

exports.isInteger = Number.isSafeInteger;

exports.ignore = function () {};

exports.inherits = Util.inherits;

exports.format = Util.format;

exports.transform = function (source, transform, options) {

    exports.assert(source === null || source === undefined || (typeof source === 'undefined' ? 'undefined' : _typeof(source)) === 'object' || Array.isArray(source), 'Invalid source object: must be null, undefined, an object, or an array');
    var separator = (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object' && options !== null ? options.separator || '.' : '.';

    if (Array.isArray(source)) {
        var results = [];
        for (var i = 0; i < source.length; ++i) {
            results.push(exports.transform(source[i], transform, options));
        }
        return results;
    }

    var result = {};
    var keys = Object.keys(transform);

    for (var _i8 = 0; _i8 < keys.length; ++_i8) {
        var key = keys[_i8];
        var path = key.split(separator);
        var sourcePath = transform[key];

        exports.assert(typeof sourcePath === 'string', 'All mappings must be "." delineated strings');

        var segment = void 0;
        var res = result;

        while (path.length > 1) {
            segment = path.shift();
            if (!res[segment]) {
                res[segment] = {};
            }
            res = res[segment];
        }
        segment = path.shift();
        res[segment] = exports.reach(source, sourcePath, options);
    }

    return result;
};

exports.uniqueFilename = function (path, extension) {

    if (extension) {
        extension = extension[0] !== '.' ? '.' + extension : extension;
    } else {
        extension = '';
    }

    path = Path.resolve(path);
    var name = [Date.now(), process.pid, Crypto.randomBytes(8).toString('hex')].join('-') + extension;
    return Path.join(path, name);
};

exports.stringify = function () {

    try {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return JSON.stringify.apply(null, args);
    } catch (err) {
        return '[Cannot display object: ' + err.message + ']';
    }
};

exports.shallow = function (source) {

    var target = {};
    var keys = Object.keys(source);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        target[key] = source[key];
    }

    return target;
};

exports.wait = function (timeout) {

    return new Promise(function (resolve) {
        return setTimeout(resolve, timeout);
    });
};

exports.block = function () {

    return new Promise(exports.ignore);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer, __webpack_require__(5)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var Hoek = __webpack_require__(0);

// Declare internals

var internals = {};

exports.create = function (key, options) {

    Hoek.assert(typeof key === 'string', 'Invalid reference key:', key);

    var settings = Hoek.clone(options); // options can be reused and modified

    var ref = function ref(value, validationOptions) {

        return Hoek.reach(ref.isContext ? validationOptions.context : value, ref.key, settings);
    };

    ref.isContext = key[0] === (settings && settings.contextPrefix || '$');
    ref.key = ref.isContext ? key.slice(1) : key;
    ref.path = ref.key.split(settings && settings.separator || '.');
    ref.depth = ref.path.length;
    ref.root = ref.path[0];
    ref.isJoi = true;

    ref.toString = function () {

        return (ref.isContext ? 'context:' : 'ref:') + ref.key;
    };

    return ref;
};

exports.isRef = function (ref) {

    return typeof ref === 'function' && ref.isJoi;
};

exports.push = function (array, ref) {

    if (exports.isRef(ref) && !ref.isContext) {

        array.push(ref.root);
    }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Hoek = __webpack_require__(0);
var Ref = __webpack_require__(1);
var Errors = __webpack_require__(6);
var Alternatives = null; // Delay-loaded to prevent circular dependencies
var Cast = null;

// Declare internals

var internals = {
    Set: __webpack_require__(9)
};

internals.defaults = {
    abortEarly: true,
    convert: true,
    allowUnknown: false,
    skipFunctions: false,
    stripUnknown: false,
    language: {},
    presence: 'optional',
    strip: false,
    noDefaults: false,
    escapeHtml: false

    // context: null
};

module.exports = internals.Any = function () {
    function _class() {
        _classCallCheck(this, _class);

        Cast = Cast || __webpack_require__(4);

        this.isJoi = true;
        this._type = 'any';
        this._settings = null;
        this._valids = new internals.Set();
        this._invalids = new internals.Set();
        this._tests = [];
        this._refs = [];
        this._flags = {
            /*
             presence: 'optional',                   // optional, required, forbidden, ignore
             allowOnly: false,
             allowUnknown: undefined,
             default: undefined,
             forbidden: false,
             encoding: undefined,
             insensitive: false,
             trim: false,
             normalize: undefined,                   // NFC, NFD, NFKC, NFKD
             case: undefined,                        // upper, lower
             empty: undefined,
             func: false,
             raw: false
             */
        };

        this._description = null;
        this._unit = null;
        this._notes = [];
        this._tags = [];
        this._examples = [];
        this._meta = [];

        this._inner = {}; // Hash of arrays of immutable objects
    }

    _class.prototype.createError = function createError(type, context, state, options) {
        var flags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this._flags;


        return Errors.create(type, context, state, options, flags);
    };

    _class.prototype.createOverrideError = function createOverrideError(type, context, state, options, message, template) {

        return Errors.create(type, context, state, options, this._flags, message, template);
    };

    _class.prototype.checkOptions = function checkOptions(options) {

        var Schemas = __webpack_require__(18);
        var result = Schemas.options.validate(options);
        if (result.error) {
            throw new Error(result.error.details[0].message);
        }
    };

    _class.prototype.clone = function clone() {

        var obj = Object.create(Object.getPrototypeOf(this));

        obj.isJoi = true;
        obj._currentJoi = this._currentJoi;
        obj._type = this._type;
        obj._settings = internals.concatSettings(this._settings);
        obj._baseType = this._baseType;
        obj._valids = Hoek.clone(this._valids);
        obj._invalids = Hoek.clone(this._invalids);
        obj._tests = this._tests.slice();
        obj._refs = this._refs.slice();
        obj._flags = Hoek.clone(this._flags);

        obj._description = this._description;
        obj._unit = this._unit;
        obj._notes = this._notes.slice();
        obj._tags = this._tags.slice();
        obj._examples = this._examples.slice();
        obj._meta = this._meta.slice();

        obj._inner = {};
        var inners = Object.keys(this._inner);
        for (var i = 0; i < inners.length; ++i) {
            var key = inners[i];
            obj._inner[key] = this._inner[key] ? this._inner[key].slice() : null;
        }

        return obj;
    };

    _class.prototype.concat = function concat(schema) {

        Hoek.assert(schema instanceof internals.Any, 'Invalid schema object');
        Hoek.assert(this._type === 'any' || schema._type === 'any' || schema._type === this._type, 'Cannot merge type', this._type, 'with another type:', schema._type);

        var obj = this.clone();

        if (this._type === 'any' && schema._type !== 'any') {

            // Reset values as if we were "this"
            var tmpObj = schema.clone();
            var keysToRestore = ['_settings', '_valids', '_invalids', '_tests', '_refs', '_flags', '_description', '_unit', '_notes', '_tags', '_examples', '_meta', '_inner'];

            for (var i = 0; i < keysToRestore.length; ++i) {
                tmpObj[keysToRestore[i]] = obj[keysToRestore[i]];
            }

            obj = tmpObj;
        }

        obj._settings = obj._settings ? internals.concatSettings(obj._settings, schema._settings) : schema._settings;
        obj._valids.merge(schema._valids, schema._invalids);
        obj._invalids.merge(schema._invalids, schema._valids);
        obj._tests = obj._tests.concat(schema._tests);
        obj._refs = obj._refs.concat(schema._refs);
        Hoek.merge(obj._flags, schema._flags);

        obj._description = schema._description || obj._description;
        obj._unit = schema._unit || obj._unit;
        obj._notes = obj._notes.concat(schema._notes);
        obj._tags = obj._tags.concat(schema._tags);
        obj._examples = obj._examples.concat(schema._examples);
        obj._meta = obj._meta.concat(schema._meta);

        var inners = Object.keys(schema._inner);
        var isObject = obj._type === 'object';
        for (var _i = 0; _i < inners.length; ++_i) {
            var key = inners[_i];
            var source = schema._inner[key];
            if (source) {
                var target = obj._inner[key];
                if (target) {
                    if (isObject && key === 'children') {
                        var keys = {};

                        for (var j = 0; j < target.length; ++j) {
                            keys[target[j].key] = j;
                        }

                        for (var _j = 0; _j < source.length; ++_j) {
                            var sourceKey = source[_j].key;
                            if (keys[sourceKey] >= 0) {
                                target[keys[sourceKey]] = {
                                    key: sourceKey,
                                    schema: target[keys[sourceKey]].schema.concat(source[_j].schema)
                                };
                            } else {
                                target.push(source[_j]);
                            }
                        }
                    } else {
                        obj._inner[key] = obj._inner[key].concat(source);
                    }
                } else {
                    obj._inner[key] = source.slice();
                }
            }
        }

        return obj;
    };

    _class.prototype._test = function _test(name, arg, func, options) {

        var obj = this.clone();
        obj._tests.push({ func: func, name: name, arg: arg, options: options });
        return obj;
    };

    _class.prototype.options = function options(_options) {

        Hoek.assert(!_options.context, 'Cannot override context');
        this.checkOptions(_options);

        var obj = this.clone();
        obj._settings = internals.concatSettings(obj._settings, _options);
        return obj;
    };

    _class.prototype.strict = function strict(isStrict) {

        var obj = this.clone();
        obj._settings = obj._settings || {};
        obj._settings.convert = isStrict === undefined ? false : !isStrict;
        return obj;
    };

    _class.prototype.raw = function raw(isRaw) {

        var value = isRaw === undefined ? true : isRaw;

        if (this._flags.raw === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.raw = value;
        return obj;
    };

    _class.prototype.error = function error(err) {

        Hoek.assert(err && (err instanceof Error || typeof err === 'function'), 'Must provide a valid Error object or a function');

        var obj = this.clone();
        obj._flags.error = err;
        return obj;
    };

    _class.prototype.allow = function allow() {
        for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
            values[_key] = arguments[_key];
        }

        var obj = this.clone();
        values = Hoek.flatten(values);
        for (var i = 0; i < values.length; ++i) {
            var value = values[i];

            Hoek.assert(value !== undefined, 'Cannot call allow/valid/invalid with undefined');
            obj._invalids.remove(value);
            obj._valids.add(value, obj._refs);
        }
        return obj;
    };

    _class.prototype.valid = function valid() {

        var obj = this.allow.apply(this, arguments);
        obj._flags.allowOnly = true;
        return obj;
    };

    _class.prototype.invalid = function invalid() {
        for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            values[_key2] = arguments[_key2];
        }

        var obj = this.clone();
        values = Hoek.flatten(values);
        for (var i = 0; i < values.length; ++i) {
            var value = values[i];

            Hoek.assert(value !== undefined, 'Cannot call allow/valid/invalid with undefined');
            obj._valids.remove(value);
            obj._invalids.add(value, obj._refs);
        }

        return obj;
    };

    _class.prototype.required = function required() {

        if (this._flags.presence === 'required') {
            return this;
        }

        var obj = this.clone();
        obj._flags.presence = 'required';
        return obj;
    };

    _class.prototype.optional = function optional() {

        if (this._flags.presence === 'optional') {
            return this;
        }

        var obj = this.clone();
        obj._flags.presence = 'optional';
        return obj;
    };

    _class.prototype.forbidden = function forbidden() {

        if (this._flags.presence === 'forbidden') {
            return this;
        }

        var obj = this.clone();
        obj._flags.presence = 'forbidden';
        return obj;
    };

    _class.prototype.strip = function strip() {

        if (this._flags.strip) {
            return this;
        }

        var obj = this.clone();
        obj._flags.strip = true;
        return obj;
    };

    _class.prototype.applyFunctionToChildren = function applyFunctionToChildren(children, fn, args, root) {

        children = [].concat(children);

        if (children.length !== 1 || children[0] !== '') {
            root = root ? root + '.' : '';

            var extraChildren = (children[0] === '' ? children.slice(1) : children).map(function (child) {

                return root + child;
            });

            throw new Error('unknown key(s) ' + extraChildren.join(', '));
        }

        return this[fn].apply(this, args);
    };

    _class.prototype.default = function _default(value, description) {

        if (typeof value === 'function' && !Ref.isRef(value)) {

            if (!value.description && description) {

                value.description = description;
            }

            if (!this._flags.func) {
                Hoek.assert(typeof value.description === 'string' && value.description.length > 0, 'description must be provided when default value is a function');
            }
        }

        var obj = this.clone();
        obj._flags.default = value;
        Ref.push(obj._refs, value);
        return obj;
    };

    _class.prototype.empty = function empty(schema) {

        var obj = this.clone();
        if (schema === undefined) {
            delete obj._flags.empty;
        } else {
            obj._flags.empty = Cast.schema(this._currentJoi, schema);
        }
        return obj;
    };

    _class.prototype.when = function when(condition, options) {

        Hoek.assert(options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object', 'Invalid options');
        Hoek.assert(options.then !== undefined || options.otherwise !== undefined, 'options must have at least one of "then" or "otherwise"');

        var then = options.hasOwnProperty('then') ? this.concat(Cast.schema(this._currentJoi, options.then)) : undefined;
        var otherwise = options.hasOwnProperty('otherwise') ? this.concat(Cast.schema(this._currentJoi, options.otherwise)) : undefined;

        Alternatives = Alternatives || __webpack_require__(10);

        var alternativeOptions = { then: then, otherwise: otherwise };
        if (Object.prototype.hasOwnProperty.call(options, 'is')) {
            alternativeOptions.is = options.is;
        }
        var obj = Alternatives.when(condition, alternativeOptions);
        obj._flags.presence = 'ignore';
        obj._baseType = this;

        return obj;
    };

    _class.prototype.description = function description(desc) {

        Hoek.assert(desc && typeof desc === 'string', 'Description must be a non-empty string');

        var obj = this.clone();
        obj._description = desc;
        return obj;
    };

    _class.prototype.notes = function notes(_notes) {

        Hoek.assert(_notes && (typeof _notes === 'string' || Array.isArray(_notes)), 'Notes must be a non-empty string or array');

        var obj = this.clone();
        obj._notes = obj._notes.concat(_notes);
        return obj;
    };

    _class.prototype.tags = function tags(_tags) {

        Hoek.assert(_tags && (typeof _tags === 'string' || Array.isArray(_tags)), 'Tags must be a non-empty string or array');

        var obj = this.clone();
        obj._tags = obj._tags.concat(_tags);
        return obj;
    };

    _class.prototype.meta = function meta(_meta) {

        Hoek.assert(_meta !== undefined, 'Meta cannot be undefined');

        var obj = this.clone();
        obj._meta = obj._meta.concat(_meta);
        return obj;
    };

    _class.prototype.example = function example() {

        Hoek.assert(arguments.length === 1, 'Missing example');
        var value = arguments.length <= 0 ? undefined : arguments[0];
        var result = this._validate(value, null, internals.defaults);
        Hoek.assert(!result.errors, 'Bad example:', result.errors && Errors.process(result.errors, value));

        var obj = this.clone();
        obj._examples.push(value);
        return obj;
    };

    _class.prototype.unit = function unit(name) {

        Hoek.assert(name && typeof name === 'string', 'Unit name must be a non-empty string');

        var obj = this.clone();
        obj._unit = name;
        return obj;
    };

    _class.prototype._prepareEmptyValue = function _prepareEmptyValue(value) {

        if (typeof value === 'string' && this._flags.trim) {
            return value.trim();
        }

        return value;
    };

    _class.prototype._validate = function _validate(value, state, options, reference) {
        var _this = this;

        var originalValue = value;

        // Setup state and settings

        state = state || { key: '', path: [], parent: null, reference: reference };

        if (this._settings) {
            options = internals.concatSettings(options, this._settings);
        }

        var errors = [];
        var finish = function finish() {

            var finalValue = void 0;

            if (value !== undefined) {
                finalValue = _this._flags.raw ? originalValue : value;
            } else if (options.noDefaults) {
                finalValue = value;
            } else if (Ref.isRef(_this._flags.default)) {
                finalValue = _this._flags.default(state.parent, options);
            } else if (typeof _this._flags.default === 'function' && !(_this._flags.func && !_this._flags.default.description)) {

                var args = void 0;

                if (state.parent !== null && _this._flags.default.length > 0) {

                    args = [Hoek.clone(state.parent), options];
                }

                var defaultValue = internals._try(_this._flags.default, args);
                finalValue = defaultValue.value;
                if (defaultValue.error) {
                    errors.push(_this.createError('any.default', { error: defaultValue.error }, state, options));
                }
            } else {
                finalValue = Hoek.clone(_this._flags.default);
            }

            if (errors.length && typeof _this._flags.error === 'function') {
                var change = _this._flags.error.call(_this, errors);

                if (typeof change === 'string') {
                    errors = [_this.createOverrideError('override', { reason: errors }, state, options, change)];
                } else {
                    errors = [].concat(change).map(function (err) {

                        return err instanceof Error ? err : _this.createOverrideError(err.type || 'override', err.context, state, options, err.message, err.template);
                    });
                }
            }

            return {
                value: _this._flags.strip ? undefined : finalValue,
                finalValue: finalValue,
                errors: errors.length ? errors : null
            };
        };

        if (this._coerce) {
            var coerced = this._coerce.call(this, value, state, options);
            if (coerced.errors) {
                value = coerced.value;
                errors = errors.concat(coerced.errors);
                return finish(); // Coerced error always aborts early
            }

            value = coerced.value;
        }

        if (this._flags.empty && !this._flags.empty._validate(this._prepareEmptyValue(value), null, internals.defaults).errors) {
            value = undefined;
        }

        // Check presence requirements

        var presence = this._flags.presence || options.presence;
        if (presence === 'optional') {
            if (value === undefined) {
                var isDeepDefault = this._flags.hasOwnProperty('default') && this._flags.default === undefined;
                if (isDeepDefault && this._type === 'object') {
                    value = {};
                } else {
                    return finish();
                }
            }
        } else if (presence === 'required' && value === undefined) {

            errors.push(this.createError('any.required', null, state, options));
            return finish();
        } else if (presence === 'forbidden') {
            if (value === undefined) {
                return finish();
            }

            errors.push(this.createError('any.unknown', null, state, options));
            return finish();
        }

        // Check allowed and denied values using the original value

        if (this._valids.has(value, state, options, this._flags.insensitive)) {
            return finish();
        }

        if (this._invalids.has(value, state, options, this._flags.insensitive)) {
            errors.push(this.createError(value === '' ? 'any.empty' : 'any.invalid', null, state, options));
            if (options.abortEarly || value === undefined) {
                // No reason to keep validating missing value

                return finish();
            }
        }

        // Convert value and validate type

        if (this._base) {
            var base = this._base.call(this, value, state, options);
            if (base.errors) {
                value = base.value;
                errors = errors.concat(base.errors);
                return finish(); // Base error always aborts early
            }

            if (base.value !== value) {
                value = base.value;

                // Check allowed and denied values using the converted value

                if (this._valids.has(value, state, options, this._flags.insensitive)) {
                    return finish();
                }

                if (this._invalids.has(value, state, options, this._flags.insensitive)) {
                    errors.push(this.createError(value === '' ? 'any.empty' : 'any.invalid', null, state, options));
                    if (options.abortEarly) {
                        return finish();
                    }
                }
            }
        }

        // Required values did not match

        if (this._flags.allowOnly) {
            errors.push(this.createError('any.allowOnly', { valids: this._valids.values({ stripUndefined: true }) }, state, options));
            if (options.abortEarly) {
                return finish();
            }
        }

        // Helper.validate tests

        for (var i = 0; i < this._tests.length; ++i) {
            var test = this._tests[i];
            var ret = test.func.call(this, value, state, options);
            if (ret instanceof Errors.Err) {
                errors.push(ret);
                if (options.abortEarly) {
                    return finish();
                }
            } else {
                value = ret;
            }
        }

        return finish();
    };

    _class.prototype._validateWithOptions = function _validateWithOptions(value, options, callback) {

        if (options) {
            this.checkOptions(options);
        }

        var settings = internals.concatSettings(internals.defaults, options);
        var result = this._validate(value, null, settings);
        var errors = Errors.process(result.errors, value);

        if (callback) {
            return callback(errors, result.value);
        }

        return {
            error: errors,
            value: result.value,
            then: function then(resolve, reject) {

                if (errors) {
                    return Promise.reject(errors).catch(reject);
                }

                return Promise.resolve(result.value).then(resolve);
            },
            catch: function _catch(reject) {

                if (errors) {
                    return Promise.reject(errors).catch(reject);
                }

                return Promise.resolve(result.value);
            }
        };
    };

    _class.prototype.validate = function validate(value, options, callback) {

        if (typeof options === 'function') {
            return this._validateWithOptions(value, null, options);
        }

        return this._validateWithOptions(value, options, callback);
    };

    _class.prototype.describe = function describe() {
        var _this2 = this;

        var description = {
            type: this._type
        };

        var flags = Object.keys(this._flags);
        if (flags.length) {
            if (['empty', 'default', 'lazy', 'label'].some(function (flag) {
                return _this2._flags.hasOwnProperty(flag);
            })) {
                description.flags = {};
                for (var i = 0; i < flags.length; ++i) {
                    var flag = flags[i];
                    if (flag === 'empty') {
                        description.flags[flag] = this._flags[flag].describe();
                    } else if (flag === 'default') {
                        if (Ref.isRef(this._flags[flag])) {
                            description.flags[flag] = this._flags[flag].toString();
                        } else if (typeof this._flags[flag] === 'function') {
                            description.flags[flag] = {
                                description: this._flags[flag].description,
                                function: this._flags[flag]
                            };
                        } else {
                            description.flags[flag] = this._flags[flag];
                        }
                    } else if (flag === 'lazy' || flag === 'label') {
                        // We don't want it in the description
                    } else {
                        description.flags[flag] = this._flags[flag];
                    }
                }
            } else {
                description.flags = this._flags;
            }
        }

        if (this._settings) {
            description.options = Hoek.clone(this._settings);
        }

        if (this._baseType) {
            description.base = this._baseType.describe();
        }

        if (this._description) {
            description.description = this._description;
        }

        if (this._notes.length) {
            description.notes = this._notes;
        }

        if (this._tags.length) {
            description.tags = this._tags;
        }

        if (this._meta.length) {
            description.meta = this._meta;
        }

        if (this._examples.length) {
            description.examples = this._examples;
        }

        if (this._unit) {
            description.unit = this._unit;
        }

        var valids = this._valids.values();
        if (valids.length) {
            description.valids = valids.map(function (v) {

                return Ref.isRef(v) ? v.toString() : v;
            });
        }

        var invalids = this._invalids.values();
        if (invalids.length) {
            description.invalids = invalids.map(function (v) {

                return Ref.isRef(v) ? v.toString() : v;
            });
        }

        description.rules = [];

        for (var _i2 = 0; _i2 < this._tests.length; ++_i2) {
            var validator = this._tests[_i2];
            var item = { name: validator.name };

            if (validator.arg !== void 0) {
                item.arg = Ref.isRef(validator.arg) ? validator.arg.toString() : validator.arg;
            }

            var options = validator.options;
            if (options) {
                if (options.hasRef) {
                    item.arg = {};
                    var keys = Object.keys(validator.arg);
                    for (var j = 0; j < keys.length; ++j) {
                        var key = keys[j];
                        var value = validator.arg[key];
                        item.arg[key] = Ref.isRef(value) ? value.toString() : value;
                    }
                }

                if (typeof options.description === 'string') {
                    item.description = options.description;
                } else if (typeof options.description === 'function') {
                    item.description = options.description(item.arg);
                }
            }

            description.rules.push(item);
        }

        if (!description.rules.length) {
            delete description.rules;
        }

        var label = this._getLabel();
        if (label) {
            description.label = label;
        }

        return description;
    };

    _class.prototype.label = function label(name) {

        Hoek.assert(name && typeof name === 'string', 'Label name must be a non-empty string');

        var obj = this.clone();
        obj._flags.label = name;
        return obj;
    };

    _class.prototype._getLabel = function _getLabel(def) {

        return this._flags.label || def;
    };

    _createClass(_class, [{
        key: 'schemaType',
        get: function get() {

            return this._type;
        }
    }]);

    return _class;
}();

internals.Any.prototype.isImmutable = true; // Prevents Hoek from deep cloning schema objects

// Aliases

internals.Any.prototype.only = internals.Any.prototype.equal = internals.Any.prototype.valid;
internals.Any.prototype.disallow = internals.Any.prototype.not = internals.Any.prototype.invalid;
internals.Any.prototype.exist = internals.Any.prototype.required;

internals._try = function (fn, args) {

    var err = void 0;
    var result = void 0;

    try {
        result = fn.apply(null, args);
    } catch (e) {
        err = e;
    }

    return {
        value: result,
        error: err
    };
};

internals.concatSettings = function (target, source) {

    // Used to avoid cloning context

    if (!target && !source) {

        return null;
    }

    var obj = _extends({}, target);

    if (source) {
        var sKeys = Object.keys(source);
        for (var i = 0; i < sKeys.length; ++i) {
            var key = sKeys[i];
            if (key !== 'language' || !obj.hasOwnProperty(key)) {

                obj[key] = source[key];
            } else {
                obj[key] = Hoek.applyToDefaults(obj[key], source[key]);
            }
        }
    }

    return obj;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(30)
var ieee754 = __webpack_require__(31)
var isArray = __webpack_require__(32)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Hoek = __webpack_require__(0);
var Ref = __webpack_require__(1);

// Type modules are delay-loaded to prevent circular dependencies


// Declare internals

var internals = {};

exports.schema = function (Joi, config) {

    if (config !== undefined && config !== null && (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {

        if (config.isJoi) {
            return config;
        }

        if (Array.isArray(config)) {
            return Joi.alternatives().try(config);
        }

        if (config instanceof RegExp) {
            return Joi.string().regex(config);
        }

        if (config instanceof Date) {
            return Joi.date().valid(config);
        }

        return Joi.object().keys(config);
    }

    if (typeof config === 'string') {
        return Joi.string().valid(config);
    }

    if (typeof config === 'number') {
        return Joi.number().valid(config);
    }

    if (typeof config === 'boolean') {
        return Joi.boolean().valid(config);
    }

    if (Ref.isRef(config)) {
        return Joi.valid(config);
    }

    Hoek.assert(config === null, 'Invalid schema content:', config);

    return Joi.valid(null);
};

exports.ref = function (id) {

    return Ref.isRef(id) ? id : Ref.create(id);
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Hoek = __webpack_require__(0);
var Language = __webpack_require__(17);

// Declare internals

var internals = {
    annotations: Symbol('joi-annotations')
};

internals.stringify = function (value, wrapArrays) {

    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (value === null) {
        return 'null';
    }

    if (type === 'string') {
        return value;
    }

    if (value instanceof exports.Err || type === 'function' || type === 'symbol') {
        return value.toString();
    }

    if (type === 'object') {
        if (Array.isArray(value)) {
            var partial = '';

            for (var i = 0; i < value.length; ++i) {
                partial = partial + (partial.length ? ', ' : '') + internals.stringify(value[i], wrapArrays);
            }

            return wrapArrays ? '[' + partial + ']' : partial;
        }

        return value.toString();
    }

    return JSON.stringify(value);
};

exports.Err = function () {
    function _class(type, context, state, options, flags, message, template) {
        _classCallCheck(this, _class);

        this.isJoi = true;
        this.type = type;
        this.context = context || {};
        this.context.key = state.path[state.path.length - 1];
        this.context.label = state.key;
        this.path = state.path;
        this.options = options;
        this.flags = flags;
        this.message = message;
        this.template = template;

        var localized = this.options.language;

        if (this.flags.label) {
            this.context.label = this.flags.label;
        } else if (localized && ( // language can be null for arrays exclusion check
        this.context.label === '' || this.context.label === null)) {
            this.context.label = localized.root || Language.errors.root;
        }
    }

    _class.prototype.toString = function toString() {
        var _this = this;

        if (this.message) {
            return this.message;
        }

        var format = void 0;

        if (this.template) {
            format = this.template;
        }

        var localized = this.options.language;

        format = format || Hoek.reach(localized, this.type) || Hoek.reach(Language.errors, this.type);

        if (format === undefined) {
            return 'Error code "' + this.type + '" is not defined, your custom type is missing the correct language definition';
        }

        var wrapArrays = Hoek.reach(localized, 'messages.wrapArrays');
        if (typeof wrapArrays !== 'boolean') {
            wrapArrays = Language.errors.messages.wrapArrays;
        }

        if (format === null) {
            var childrenString = internals.stringify(this.context.reason, wrapArrays);
            if (wrapArrays) {
                return childrenString.slice(1, -1);
            }
            return childrenString;
        }

        var hasKey = /\{\{\!?label\}\}/.test(format);
        var skipKey = format.length > 2 && format[0] === '!' && format[1] === '!';

        if (skipKey) {
            format = format.slice(2);
        }

        if (!hasKey && !skipKey) {
            var localizedKey = Hoek.reach(localized, 'key');
            if (typeof localizedKey === 'string') {
                format = localizedKey + format;
            } else {
                format = Hoek.reach(Language.errors, 'key') + format;
            }
        }

        return format.replace(/\{\{(\!?)([^}]+)\}\}/g, function ($0, isSecure, name) {

            var value = Hoek.reach(_this.context, name);
            var normalized = internals.stringify(value, wrapArrays);
            return isSecure && _this.options.escapeHtml ? Hoek.escapeHtml(normalized) : normalized;
        });
    };

    return _class;
}();

exports.create = function (type, context, state, options, flags, message, template) {

    return new exports.Err(type, context, state, options, flags, message, template);
};

exports.process = function (errors, object) {

    if (!errors || !errors.length) {
        return null;
    }

    // Construct error

    var message = '';
    var details = [];

    var processErrors = function processErrors(localErrors, parent) {

        for (var i = 0; i < localErrors.length; ++i) {
            var item = localErrors[i];

            if (item instanceof Error) {
                return item;
            }

            if (item.flags.error && typeof item.flags.error !== 'function') {
                return item.flags.error;
            }

            var itemMessage = void 0;
            if (parent === undefined) {
                itemMessage = item.toString();
                message = message + (message ? '. ' : '') + itemMessage;
            }

            // Do not push intermediate errors, we're only interested in leafs

            if (item.context.reason && item.context.reason.length) {
                var _override = processErrors(item.context.reason, item.path);
                if (_override) {
                    return _override;
                }
            } else {
                details.push({
                    message: itemMessage || item.toString(),
                    path: item.path,
                    type: item.type,
                    context: item.context
                });
            }
        }
    };

    var override = processErrors(errors);
    if (override) {
        return override;
    }

    var error = new Error(message);
    error.isJoi = true;
    error.name = 'ValidationError';
    error.details = details;
    error._object = object;
    error.annotate = internals.annotate;
    return error;
};

// Inspired by json-stringify-safe
internals.safeStringify = function (obj, spaces) {

    return JSON.stringify(obj, internals.serializer(), spaces);
};

internals.serializer = function () {

    var keys = [];
    var stack = [];

    var cycleReplacer = function cycleReplacer(key, value) {

        if (stack[0] === value) {
            return '[Circular ~]';
        }

        return '[Circular ~.' + keys.slice(0, stack.indexOf(value)).join('.') + ']';
    };

    return function (key, value) {

        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            if (~thisPos) {
                stack.length = thisPos + 1;
                keys.length = thisPos + 1;
                keys[thisPos] = key;
            } else {
                stack.push(this);
                keys.push(key);
            }

            if (~stack.indexOf(value)) {
                value = cycleReplacer.call(this, key, value);
            }
        } else {
            stack.push(value);
        }

        if (value) {
            var annotations = value[internals.annotations];
            if (annotations) {
                if (Array.isArray(value)) {
                    var annotated = [];

                    for (var i = 0; i < value.length; ++i) {
                        if (annotations.errors[i]) {
                            annotated.push('_$idx$_' + annotations.errors[i].sort().join(', ') + '_$end$_');
                        }
                        annotated.push(value[i]);
                    }

                    value = annotated;
                } else {
                    var errorKeys = Object.keys(annotations.errors);
                    for (var _i = 0; _i < errorKeys.length; ++_i) {
                        var errorKey = errorKeys[_i];
                        value[errorKey + '_$key$_' + annotations.errors[errorKey].sort().join(', ') + '_$end$_'] = value[errorKey];
                        value[errorKey] = undefined;
                    }

                    var missingKeys = Object.keys(annotations.missing);
                    for (var _i2 = 0; _i2 < missingKeys.length; ++_i2) {
                        var missingKey = missingKeys[_i2];
                        value['_$miss$_' + missingKey + '|' + annotations.missing[missingKey] + '_$end$_'] = '__missing__';
                    }
                }

                return value;
            }
        }

        if (value === Infinity || value === -Infinity || Number.isNaN(value) || typeof value === 'function' || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol') {
            return '[' + value.toString() + ']';
        }

        return value;
    };
};

internals.annotate = function (stripColorCodes) {

    var redFgEscape = stripColorCodes ? '' : '\x1B[31m';
    var redBgEscape = stripColorCodes ? '' : '\x1B[41m';
    var endColor = stripColorCodes ? '' : '\x1B[0m';

    if (_typeof(this._object) !== 'object') {
        return this.details[0].message;
    }

    var obj = Hoek.clone(this._object || {});

    for (var i = this.details.length - 1; i >= 0; --i) {
        // Reverse order to process deepest child first
        var pos = i + 1;
        var error = this.details[i];
        var path = error.path;
        var ref = obj;
        for (var j = 0;; ++j) {
            var seg = path[j];

            if (ref.isImmutable) {
                ref = ref.clone(); // joi schemas are not cloned by hoek, we have to take this extra step
            }

            if (j + 1 < path.length && ref[seg] && typeof ref[seg] !== 'string') {

                ref = ref[seg];
            } else {
                var refAnnotations = ref[internals.annotations] = ref[internals.annotations] || { errors: {}, missing: {} };
                var value = ref[seg];
                var cacheKey = seg || error.context.label;

                if (value !== undefined) {
                    refAnnotations.errors[cacheKey] = refAnnotations.errors[cacheKey] || [];
                    refAnnotations.errors[cacheKey].push(pos);
                } else {
                    refAnnotations.missing[cacheKey] = pos;
                }

                break;
            }
        }
    }

    var replacers = {
        key: /_\$key\$_([, \d]+)_\$end\$_\"/g,
        missing: /\"_\$miss\$_([^\|]+)\|(\d+)_\$end\$_\"\: \"__missing__\"/g,
        arrayIndex: /\s*\"_\$idx\$_([, \d]+)_\$end\$_\",?\n(.*)/g,
        specials: /"\[(NaN|Symbol.*|-?Infinity|function.*|\(.*)\]"/g
    };

    var message = internals.safeStringify(obj, 2).replace(replacers.key, function ($0, $1) {
        return '" ' + redFgEscape + '[' + $1 + ']' + endColor;
    }).replace(replacers.missing, function ($0, $1, $2) {
        return redBgEscape + '"' + $1 + '"' + endColor + redFgEscape + ' [' + $2 + ']: -- missing --' + endColor;
    }).replace(replacers.arrayIndex, function ($0, $1, $2) {
        return '\n' + $2 + ' ' + redFgEscape + '[' + $1 + ']' + endColor;
    }).replace(replacers.specials, function ($0, $1) {
        return $1;
    });

    message = message + '\n' + redFgEscape;

    for (var _i3 = 0; _i3 < this.details.length; ++_i3) {
        var _pos = _i3 + 1;
        message = message + '\n[' + _pos + '] ' + this.details[_i3].message;
    }

    message = message + endColor;

    return message;
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Hoek = __webpack_require__(0);
var Any = __webpack_require__(2);
var Cast = __webpack_require__(4);
var Errors = __webpack_require__(6);
var Lazy = __webpack_require__(23);
var Ref = __webpack_require__(1);

// Declare internals

var internals = {
    alternatives: __webpack_require__(10),
    array: __webpack_require__(19),
    boolean: __webpack_require__(21),
    binary: __webpack_require__(20),
    date: __webpack_require__(11),
    func: __webpack_require__(22),
    number: __webpack_require__(24),
    object: __webpack_require__(12),
    string: __webpack_require__(25)
};

internals.applyDefaults = function (schema) {

    Hoek.assert(this, 'Must be invoked on a Joi instance.');

    if (this._defaults) {
        schema = this._defaults(schema);
    }

    schema._currentJoi = this;

    return schema;
};

internals.root = function () {

    var any = new Any();

    var root = any.clone();
    Any.prototype._currentJoi = root;
    root._currentJoi = root;

    root.any = function () {

        Hoek.assert(arguments.length === 0, 'Joi.any() does not allow arguments.');

        return internals.applyDefaults.call(this, any);
    };

    root.alternatives = root.alt = function () {

        var alternatives = internals.applyDefaults.call(this, internals.alternatives);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return args.length ? alternatives.try.apply(alternatives, args) : alternatives;
    };

    root.array = function () {

        Hoek.assert(arguments.length === 0, 'Joi.array() does not allow arguments.');

        return internals.applyDefaults.call(this, internals.array);
    };

    root.boolean = root.bool = function () {

        Hoek.assert(arguments.length === 0, 'Joi.boolean() does not allow arguments.');

        return internals.applyDefaults.call(this, internals.boolean);
    };

    root.binary = function () {

        Hoek.assert(arguments.length === 0, 'Joi.binary() does not allow arguments.');

        return internals.applyDefaults.call(this, internals.binary);
    };

    root.date = function () {

        Hoek.assert(arguments.length === 0, 'Joi.date() does not allow arguments.');

        return internals.applyDefaults.call(this, internals.date);
    };

    root.func = function () {

        Hoek.assert(arguments.length === 0, 'Joi.func() does not allow arguments.');

        return internals.applyDefaults.call(this, internals.func);
    };

    root.number = function () {

        Hoek.assert(arguments.length === 0, 'Joi.number() does not allow arguments.');

        return internals.applyDefaults.call(this, internals.number);
    };

    root.object = function () {

        var object = internals.applyDefaults.call(this, internals.object);
        return arguments.length ? object.keys.apply(object, arguments) : object;
    };

    root.string = function () {

        Hoek.assert(arguments.length === 0, 'Joi.string() does not allow arguments.');

        return internals.applyDefaults.call(this, internals.string);
    };

    root.ref = function () {

        return Ref.create.apply(Ref, arguments);
    };

    root.isRef = function (ref) {

        return Ref.isRef(ref);
    };

    root.validate = function (value) /*, [schema], [options], callback */{
        var _ref;

        var last = (_ref = (arguments.length <= 1 ? 0 : arguments.length - 1) - 1 + 1, arguments.length <= _ref ? undefined : arguments[_ref]);
        var callback = typeof last === 'function' ? last : null;

        var count = (arguments.length <= 1 ? 0 : arguments.length - 1) - (callback ? 1 : 0);
        if (count === 0) {
            return any.validate(value, callback);
        }

        var options = count === 2 ? arguments.length <= 2 ? undefined : arguments[2] : {};
        var schema = root.compile(arguments.length <= 1 ? undefined : arguments[1]);

        return schema._validateWithOptions(value, options, callback);
    };

    root.describe = function () {

        var schema = arguments.length ? root.compile(arguments.length <= 0 ? undefined : arguments[0]) : any;
        return schema.describe();
    };

    root.compile = function (schema) {

        try {
            return Cast.schema(this, schema);
        } catch (err) {
            if (err.hasOwnProperty('path')) {
                err.message = err.message + '(' + err.path + ')';
            }
            throw err;
        }
    };

    root.assert = function (value, schema, message) {

        root.attempt(value, schema, message);
    };

    root.attempt = function (value, schema, message) {

        var result = root.validate(value, schema);
        var error = result.error;
        if (error) {
            if (!message) {
                if (typeof error.annotate === 'function') {
                    error.message = error.annotate();
                }
                throw error;
            }

            if (!(message instanceof Error)) {
                if (typeof error.annotate === 'function') {
                    error.message = message + ' ' + error.annotate();
                }
                throw error;
            }

            throw message;
        }

        return result.value;
    };

    root.reach = function (schema, path) {

        Hoek.assert(schema && schema instanceof Any, 'you must provide a joi schema');
        Hoek.assert(typeof path === 'string', 'path must be a string');

        if (path === '') {
            return schema;
        }

        var parts = path.split('.');
        var children = schema._inner.children;
        if (!children) {
            return;
        }

        var key = parts[0];
        for (var i = 0; i < children.length; ++i) {
            var child = children[i];
            if (child.key === key) {
                return this.reach(child.schema, path.substr(key.length + 1));
            }
        }
    };

    root.lazy = function (fn) {

        return Lazy.set(fn);
    };

    root.defaults = function (fn) {
        var _this = this;

        Hoek.assert(typeof fn === 'function', 'Defaults must be a function');

        var joi = Object.create(this.any());
        joi = fn(joi);

        Hoek.assert(joi && joi instanceof this.constructor, 'defaults() must return a schema');

        _extends(joi, this, joi.clone()); // Re-add the types from `this` but also keep the settings from joi's potential new defaults

        joi._defaults = function (schema) {

            if (_this._defaults) {
                schema = _this._defaults(schema);
                Hoek.assert(schema instanceof _this.constructor, 'defaults() must return a schema');
            }

            schema = fn(schema);
            Hoek.assert(schema instanceof _this.constructor, 'defaults() must return a schema');
            return schema;
        };

        return joi;
    };

    root.extend = function () {
        var _this2 = this;

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        var extensions = Hoek.flatten(args);
        Hoek.assert(extensions.length > 0, 'You need to provide at least one extension');

        this.assert(extensions, root.extensionsSchema);

        var joi = Object.create(this.any());
        _extends(joi, this);

        var _loop = function _loop(i) {
            var extension = extensions[i];

            if (typeof extension === 'function') {
                extension = extension(joi);
            }

            _this2.assert(extension, root.extensionSchema);

            var base = (extension.base || _this2.any()).clone(); // Cloning because we're going to override language afterwards
            var ctor = base.constructor;
            var type = function (_ctor) {
                _inherits(type, _ctor);

                // eslint-disable-line no-loop-func

                function type() {
                    _classCallCheck(this, type);

                    var _this3 = _possibleConstructorReturn(this, _ctor.call(this));

                    if (extension.base) {
                        _extends(_this3, base);
                    }

                    _this3._type = extension.name;

                    if (extension.language) {
                        _this3._settings = _this3._settings || { language: {} };
                        _this3._settings.language = Hoek.applyToDefaults(_this3._settings.language, _defineProperty({}, extension.name, extension.language));
                    }
                    return _this3;
                }

                return type;
            }(ctor);

            if (extension.coerce) {
                type.prototype._coerce = function (value, state, options) {

                    if (ctor.prototype._coerce) {
                        var baseRet = ctor.prototype._coerce.call(this, value, state, options);

                        if (baseRet.errors) {
                            return baseRet;
                        }

                        value = baseRet.value;
                    }

                    var ret = extension.coerce.call(this, value, state, options);
                    if (ret instanceof Errors.Err) {
                        return { value: value, errors: ret };
                    }

                    return { value: ret };
                };
            }
            if (extension.pre) {
                type.prototype._base = function (value, state, options) {

                    if (ctor.prototype._base) {
                        var baseRet = ctor.prototype._base.call(this, value, state, options);

                        if (baseRet.errors) {
                            return baseRet;
                        }

                        value = baseRet.value;
                    }

                    var ret = extension.pre.call(this, value, state, options);
                    if (ret instanceof Errors.Err) {
                        return { value: value, errors: ret };
                    }

                    return { value: ret };
                };
            }

            if (extension.rules) {
                var _loop2 = function _loop2(j) {
                    var rule = extension.rules[j];
                    var ruleArgs = rule.params ? rule.params instanceof Any ? rule.params._inner.children.map(function (k) {
                        return k.key;
                    }) : Object.keys(rule.params) : [];
                    var validateArgs = rule.params ? Cast.schema(_this2, rule.params) : null;

                    type.prototype[rule.name] = function () {
                        for (var _len3 = arguments.length, rArgs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                            rArgs[_key3] = arguments[_key3];
                        }

                        // eslint-disable-line no-loop-func

                        if (rArgs.length > ruleArgs.length) {
                            throw new Error('Unexpected number of arguments');
                        }

                        var hasRef = false;
                        var arg = {};

                        for (var k = 0; k < ruleArgs.length; ++k) {
                            arg[ruleArgs[k]] = rArgs[k];
                            if (!hasRef && Ref.isRef(rArgs[k])) {
                                hasRef = true;
                            }
                        }

                        if (validateArgs) {
                            arg = joi.attempt(arg, validateArgs);
                        }

                        var schema = void 0;
                        if (rule.validate) {
                            var validate = function validate(value, state, options) {

                                return rule.validate.call(this, arg, value, state, options);
                            };

                            schema = this._test(rule.name, arg, validate, {
                                description: rule.description,
                                hasRef: hasRef
                            });
                        } else {
                            schema = this.clone();
                        }

                        if (rule.setup) {
                            var newSchema = rule.setup.call(schema, arg);
                            if (newSchema !== undefined) {
                                Hoek.assert(newSchema instanceof Any, 'Setup of extension Joi.' + this._type + '().' + rule.name + '() must return undefined or a Joi object');
                                schema = newSchema;
                            }
                        }

                        return schema;
                    };
                };

                for (var j = 0; j < extension.rules.length; ++j) {
                    _loop2(j);
                }
            }

            if (extension.describe) {
                type.prototype.describe = function () {

                    var description = ctor.prototype.describe.call(this);
                    return extension.describe.call(this, description);
                };
            }

            var instance = new type();
            joi[extension.name] = function () {

                return internals.applyDefaults.call(this, instance);
            };
        };

        for (var i = 0; i < extensions.length; ++i) {
            _loop(i);
        }

        return joi;
    };

    root.extensionSchema = internals.object.keys({
        base: internals.object.type(Any, 'Joi object'),
        name: internals.string.required(),
        coerce: internals.func.arity(3),
        pre: internals.func.arity(3),
        language: internals.object,
        describe: internals.func.arity(1),
        rules: internals.array.items(internals.object.keys({
            name: internals.string.required(),
            setup: internals.func.arity(1),
            validate: internals.func.arity(4),
            params: [internals.object.pattern(/.*/, internals.object.type(Any, 'Joi object')), internals.object.type(internals.object.constructor, 'Joi object')],
            description: [internals.string, internals.func.arity(1)]
        }).or('setup', 'validate'))
    }).strict();

    root.extensionsSchema = internals.array.items([internals.object, internals.func.arity(1)]).strict();

    root.version = __webpack_require__(33).version;

    return root;
};

module.exports = internals.root();

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Ref = __webpack_require__(1);

module.exports = function () {
    function Set() {
        _classCallCheck(this, Set);

        this._set = [];
    }

    Set.prototype.add = function add(value, refs) {

        if (!Ref.isRef(value) && this.has(value, null, null, false)) {

            return;
        }

        if (refs !== undefined) {
            // If it's a merge, we don't have any refs
            Ref.push(refs, value);
        }

        this._set.push(value);
        return this;
    };

    Set.prototype.merge = function merge(add, remove) {

        for (var i = 0; i < add._set.length; ++i) {
            this.add(add._set[i]);
        }

        for (var _i = 0; _i < remove._set.length; ++_i) {
            this.remove(remove._set[_i]);
        }

        return this;
    };

    Set.prototype.remove = function remove(value) {

        this._set = this._set.filter(function (item) {
            return value !== item;
        });
        return this;
    };

    Set.prototype.has = function has(value, state, options, insensitive) {

        for (var i = 0; i < this._set.length; ++i) {
            var items = this._set[i];

            if (state && Ref.isRef(items)) {
                // Only resolve references if there is a state, otherwise it's a merge
                items = items(state.reference || state.parent, options);
            }

            if (!Array.isArray(items)) {
                items = [items];
            }

            for (var j = 0; j < items.length; ++j) {
                var item = items[j];
                if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== (typeof item === 'undefined' ? 'undefined' : _typeof(item))) {
                    continue;
                }

                if (value === item || value instanceof Date && item instanceof Date && value.getTime() === item.getTime() || insensitive && typeof value === 'string' && value.toLowerCase() === item.toLowerCase() || Buffer.isBuffer(value) && Buffer.isBuffer(item) && value.length === item.length && value.toString('binary') === item.toString('binary')) {

                    return true;
                }
            }
        }

        return false;
    };

    Set.prototype.values = function values(options) {

        if (options && options.stripUndefined) {
            var values = [];

            for (var i = 0; i < this._set.length; ++i) {
                var item = this._set[i];
                if (item !== undefined) {
                    values.push(item);
                }
            }

            return values;
        }

        return this._set.slice();
    };

    Set.prototype.slice = function slice() {

        var newSet = new Set();
        newSet._set = this._set.slice();

        return newSet;
    };

    Set.prototype.concat = function concat(source) {

        var newSet = new Set();
        newSet._set = this._set.concat(source._set);

        return newSet;
    };

    return Set;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Hoek = __webpack_require__(0);
var Any = __webpack_require__(2);
var Cast = __webpack_require__(4);
var Ref = __webpack_require__(1);

// Declare internals

var internals = {};

internals.Alternatives = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'alternatives';
        _this._invalids.remove(null);
        _this._inner.matches = [];
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var errors = [];
        var il = this._inner.matches.length;
        var baseType = this._baseType;

        for (var i = 0; i < il; ++i) {
            var item = this._inner.matches[i];
            if (!item.schema) {
                var schema = item.peek || item.is;
                var input = item.is ? item.ref(state.reference || state.parent, options) : value;
                var failed = schema._validate(input, null, options, state.parent).errors;

                if (failed) {
                    if (item.otherwise) {
                        return item.otherwise._validate(value, state, options);
                    }
                } else if (item.then) {
                    return item.then._validate(value, state, options);
                }

                if (i === il - 1 && baseType) {
                    return baseType._validate(value, state, options);
                }

                continue;
            }

            var result = item.schema._validate(value, state, options);
            if (!result.errors) {
                // Found a valid match
                return result;
            }

            errors = errors.concat(result.errors);
        }

        if (errors.length) {
            return { errors: this.createError('alternatives.child', { reason: errors }, state, options) };
        }

        return { errors: this.createError('alternatives.base', null, state, options) };
    };

    _class.prototype.try = function _try() {
        for (var _len = arguments.length, schemas = Array(_len), _key = 0; _key < _len; _key++) {
            schemas[_key] = arguments[_key];
        }

        schemas = Hoek.flatten(schemas);
        Hoek.assert(schemas.length, 'Cannot add other alternatives without at least one schema');

        var obj = this.clone();

        for (var i = 0; i < schemas.length; ++i) {
            var cast = Cast.schema(this._currentJoi, schemas[i]);
            if (cast._refs.length) {
                obj._refs = obj._refs.concat(cast._refs);
            }
            obj._inner.matches.push({ schema: cast });
        }

        return obj;
    };

    _class.prototype.when = function when(condition, options) {

        var schemaCondition = false;
        Hoek.assert(Ref.isRef(condition) || typeof condition === 'string' || (schemaCondition = condition instanceof Any), 'Invalid condition:', condition);
        Hoek.assert(options, 'Missing options');
        Hoek.assert((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object', 'Invalid options');
        if (schemaCondition) {
            Hoek.assert(!options.hasOwnProperty('is'), '"is" can not be used with a schema condition');
        } else {
            Hoek.assert(options.hasOwnProperty('is'), 'Missing "is" directive');
        }
        Hoek.assert(options.then !== undefined || options.otherwise !== undefined, 'options must have at least one of "then" or "otherwise"');

        var obj = this.clone();
        var is = void 0;
        if (!schemaCondition) {
            is = Cast.schema(this._currentJoi, options.is);

            if (options.is === null || !(Ref.isRef(options.is) || options.is instanceof Any)) {

                // Only apply required if this wasn't already a schema or a ref, we'll suppose people know what they're doing
                is = is.required();
            }
        }

        var item = {
            ref: schemaCondition ? null : Cast.ref(condition),
            peek: schemaCondition ? condition : null,
            is: is,
            then: options.then !== undefined ? Cast.schema(this._currentJoi, options.then) : undefined,
            otherwise: options.otherwise !== undefined ? Cast.schema(this._currentJoi, options.otherwise) : undefined
        };

        if (obj._baseType) {

            item.then = item.then && obj._baseType.concat(item.then);
            item.otherwise = item.otherwise && obj._baseType.concat(item.otherwise);
        }

        if (!schemaCondition) {
            Ref.push(obj._refs, item.ref);
            obj._refs = obj._refs.concat(item.is._refs);
        }

        if (item.then && item.then._refs) {
            obj._refs = obj._refs.concat(item.then._refs);
        }

        if (item.otherwise && item.otherwise._refs) {
            obj._refs = obj._refs.concat(item.otherwise._refs);
        }

        obj._inner.matches.push(item);

        return obj;
    };

    _class.prototype.describe = function describe() {

        var description = Any.prototype.describe.call(this);
        var alternatives = [];
        for (var i = 0; i < this._inner.matches.length; ++i) {
            var item = this._inner.matches[i];
            if (item.schema) {

                // try()

                alternatives.push(item.schema.describe());
            } else {

                // when()

                var when = item.is ? {
                    ref: item.ref.toString(),
                    is: item.is.describe()
                } : {
                    peek: item.peek.describe()
                };

                if (item.then) {
                    when.then = item.then.describe();
                }

                if (item.otherwise) {
                    when.otherwise = item.otherwise.describe();
                }

                alternatives.push(when);
            }
        }

        description.alternatives = alternatives;
        return description;
    };

    return _class;
}(Any);

module.exports = new internals.Alternatives();

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Any = __webpack_require__(2);
var Ref = __webpack_require__(1);
var Hoek = __webpack_require__(0);

// Declare internals

var internals = {};

internals.isoDate = /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/;
internals.invalidDate = new Date('');
internals.isIsoDate = function () {

    var isoString = internals.isoDate.toString();

    return function (date) {

        return date && date.toString() === isoString;
    };
}();

internals.Date = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'date';
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            value: options.convert && internals.Date.toDate(value, this._flags.format, this._flags.timestamp, this._flags.multiplier) || value
        };

        if (result.value instanceof Date && !isNaN(result.value.getTime())) {
            result.errors = null;
        } else if (!options.convert) {
            result.errors = this.createError('date.strict', null, state, options);
        } else {
            var type = void 0;
            if (internals.isIsoDate(this._flags.format)) {
                type = 'isoDate';
            } else if (this._flags.timestamp) {
                type = 'timestamp.' + this._flags.timestamp;
            } else {
                type = 'base';
            }

            result.errors = this.createError('date.' + type, null, state, options);
        }

        return result;
    };

    _class.toDate = function toDate(value, format, timestamp, multiplier) {

        if (value instanceof Date) {
            return value;
        }

        if (typeof value === 'string' || typeof value === 'number' && !isNaN(value) && isFinite(value)) {

            if (typeof value === 'string' && /^[+-]?\d+(\.\d+)?$/.test(value)) {

                value = parseFloat(value);
            }

            var date = void 0;
            if (format && internals.isIsoDate(format)) {
                date = format.test(value) ? new Date(value) : internals.invalidDate;
            } else if (timestamp && multiplier) {
                date = /^\s*$/.test(value) ? internals.invalidDate : new Date(value * multiplier);
            } else {
                date = new Date(value);
            }

            if (!isNaN(date.getTime())) {
                return date;
            }
        }

        return null;
    };

    _class.prototype.iso = function iso() {

        if (this._flags.format === internals.isoDate) {
            return this;
        }

        var obj = this.clone();
        obj._flags.format = internals.isoDate;
        return obj;
    };

    _class.prototype.timestamp = function timestamp() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'javascript';


        var allowed = ['javascript', 'unix'];
        Hoek.assert(allowed.includes(type), '"type" must be one of "' + allowed.join('", "') + '"');

        if (this._flags.timestamp === type) {
            return this;
        }

        var obj = this.clone();
        obj._flags.timestamp = type;
        obj._flags.multiplier = type === 'unix' ? 1000 : 1;
        return obj;
    };

    _class.prototype._isIsoDate = function _isIsoDate(value) {

        return internals.isoDate.test(value);
    };

    return _class;
}(Any);

internals.compare = function (type, compare) {

    return function (date) {

        var isNow = date === 'now';
        var isRef = Ref.isRef(date);

        if (!isNow && !isRef) {
            date = internals.Date.toDate(date);
        }

        Hoek.assert(date, 'Invalid date format');

        return this._test(type, date, function (value, state, options) {

            var compareTo = void 0;
            if (isNow) {
                compareTo = Date.now();
            } else if (isRef) {
                compareTo = internals.Date.toDate(date(state.reference || state.parent, options));

                if (!compareTo) {
                    return this.createError('date.ref', { ref: date.key }, state, options);
                }

                compareTo = compareTo.getTime();
            } else {
                compareTo = date.getTime();
            }

            if (compare(value.getTime(), compareTo)) {
                return value;
            }

            return this.createError('date.' + type, { limit: new Date(compareTo) }, state, options);
        });
    };
};
internals.Date.prototype.min = internals.compare('min', function (value, date) {
    return value >= date;
});
internals.Date.prototype.max = internals.compare('max', function (value, date) {
    return value <= date;
});

module.exports = new internals.Date();

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Hoek = __webpack_require__(0);
var Topo = __webpack_require__(28);
var Any = __webpack_require__(2);
var Errors = __webpack_require__(6);
var Cast = __webpack_require__(4);

// Declare internals

var internals = {};

internals.Object = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'object';
        _this._inner.children = null;
        _this._inner.renames = [];
        _this._inner.dependencies = [];
        _this._inner.patterns = [];
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var target = value;
        var errors = [];
        var finish = function finish() {

            return {
                value: target,
                errors: errors.length ? errors : null
            };
        };

        if (typeof value === 'string' && options.convert) {

            value = internals.safeParse(value);
        }

        var type = this._flags.func ? 'function' : 'object';
        if (!value || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== type || Array.isArray(value)) {

            errors.push(this.createError(type + '.base', null, state, options));
            return finish();
        }

        // Skip if there are no other rules to test

        if (!this._inner.renames.length && !this._inner.dependencies.length && !this._inner.children && // null allows any keys
        !this._inner.patterns.length) {

            target = value;
            return finish();
        }

        // Ensure target is a local copy (parsed) or shallow copy

        if (target === value) {
            if (type === 'object') {
                target = Object.create(Object.getPrototypeOf(value));
            } else {
                target = function target() {
                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    return value.apply(this, args);
                };

                target.prototype = Hoek.clone(value.prototype);
            }

            var valueKeys = Object.keys(value);
            for (var i = 0; i < valueKeys.length; ++i) {
                target[valueKeys[i]] = value[valueKeys[i]];
            }
        } else {
            target = value;
        }

        // Rename keys

        var renamed = {};
        for (var _i = 0; _i < this._inner.renames.length; ++_i) {
            var rename = this._inner.renames[_i];

            if (rename.isRegExp) {
                var targetKeys = Object.keys(target);
                var matchedTargetKeys = [];

                for (var j = 0; j < targetKeys.length; ++j) {
                    if (rename.from.test(targetKeys[j])) {
                        matchedTargetKeys.push(targetKeys[j]);
                    }
                }

                var allUndefined = matchedTargetKeys.every(function (key) {
                    return target[key] === undefined;
                });
                if (rename.options.ignoreUndefined && allUndefined) {
                    continue;
                }

                if (!rename.options.multiple && renamed[rename.to]) {

                    errors.push(this.createError('object.rename.regex.multiple', { from: matchedTargetKeys, to: rename.to }, state, options));
                    if (options.abortEarly) {
                        return finish();
                    }
                }

                if (Object.prototype.hasOwnProperty.call(target, rename.to) && !rename.options.override && !renamed[rename.to]) {

                    errors.push(this.createError('object.rename.regex.override', { from: matchedTargetKeys, to: rename.to }, state, options));
                    if (options.abortEarly) {
                        return finish();
                    }
                }

                if (allUndefined) {
                    delete target[rename.to];
                } else {
                    target[rename.to] = target[matchedTargetKeys[matchedTargetKeys.length - 1]];
                }

                renamed[rename.to] = true;

                if (!rename.options.alias) {
                    for (var _j = 0; _j < matchedTargetKeys.length; ++_j) {
                        delete target[matchedTargetKeys[_j]];
                    }
                }
            } else {
                if (rename.options.ignoreUndefined && target[rename.from] === undefined) {
                    continue;
                }

                if (!rename.options.multiple && renamed[rename.to]) {

                    errors.push(this.createError('object.rename.multiple', { from: rename.from, to: rename.to }, state, options));
                    if (options.abortEarly) {
                        return finish();
                    }
                }

                if (Object.prototype.hasOwnProperty.call(target, rename.to) && !rename.options.override && !renamed[rename.to]) {

                    errors.push(this.createError('object.rename.override', { from: rename.from, to: rename.to }, state, options));
                    if (options.abortEarly) {
                        return finish();
                    }
                }

                if (target[rename.from] === undefined) {
                    delete target[rename.to];
                } else {
                    target[rename.to] = target[rename.from];
                }

                renamed[rename.to] = true;

                if (!rename.options.alias) {
                    delete target[rename.from];
                }
            }
        }

        // Validate schema

        if (!this._inner.children && // null allows any keys
        !this._inner.patterns.length && !this._inner.dependencies.length) {

            return finish();
        }

        var unprocessed = Hoek.mapToObject(Object.keys(target));

        if (this._inner.children) {
            var stripProps = [];

            for (var _i2 = 0; _i2 < this._inner.children.length; ++_i2) {
                var child = this._inner.children[_i2];
                var key = child.key;
                var item = target[key];

                delete unprocessed[key];

                var localState = { key: key, path: state.path.concat(key), parent: target, reference: state.reference };
                var result = child.schema._validate(item, localState, options);
                if (result.errors) {
                    errors.push(this.createError('object.child', { key: key, child: child.schema._getLabel(key), reason: result.errors }, localState, options));

                    if (options.abortEarly) {
                        return finish();
                    }
                } else {
                    if (child.schema._flags.strip || result.value === undefined && result.value !== item) {
                        stripProps.push(key);
                        target[key] = result.finalValue;
                    } else if (result.value !== undefined) {
                        target[key] = result.value;
                    }
                }
            }

            for (var _i3 = 0; _i3 < stripProps.length; ++_i3) {
                delete target[stripProps[_i3]];
            }
        }

        // Unknown keys

        var unprocessedKeys = Object.keys(unprocessed);
        if (unprocessedKeys.length && this._inner.patterns.length) {

            for (var _i4 = 0; _i4 < unprocessedKeys.length; ++_i4) {
                var _key2 = unprocessedKeys[_i4];
                var _localState = { key: _key2, path: state.path.concat(_key2), parent: target, reference: state.reference };
                var _item = target[_key2];

                for (var _j2 = 0; _j2 < this._inner.patterns.length; ++_j2) {
                    var pattern = this._inner.patterns[_j2];

                    if (pattern.regex.test(_key2)) {
                        delete unprocessed[_key2];

                        var _result = pattern.rule._validate(_item, _localState, options);
                        if (_result.errors) {
                            errors.push(this.createError('object.child', { key: _key2, child: pattern.rule._getLabel(_key2), reason: _result.errors }, _localState, options));

                            if (options.abortEarly) {
                                return finish();
                            }
                        }

                        if (_result.value !== undefined) {
                            target[_key2] = _result.value;
                        }
                    }
                }
            }

            unprocessedKeys = Object.keys(unprocessed);
        }

        if ((this._inner.children || this._inner.patterns.length) && unprocessedKeys.length) {
            if (options.stripUnknown && this._flags.allowUnknown !== true || options.skipFunctions) {

                var stripUnknown = options.stripUnknown ? options.stripUnknown === true ? true : !!options.stripUnknown.objects : false;

                for (var _i5 = 0; _i5 < unprocessedKeys.length; ++_i5) {
                    var _key3 = unprocessedKeys[_i5];

                    if (stripUnknown) {
                        delete target[_key3];
                        delete unprocessed[_key3];
                    } else if (typeof target[_key3] === 'function') {
                        delete unprocessed[_key3];
                    }
                }

                unprocessedKeys = Object.keys(unprocessed);
            }

            if (unprocessedKeys.length && (this._flags.allowUnknown !== undefined ? !this._flags.allowUnknown : !options.allowUnknown)) {

                for (var _i6 = 0; _i6 < unprocessedKeys.length; ++_i6) {
                    var unprocessedKey = unprocessedKeys[_i6];
                    errors.push(this.createError('object.allowUnknown', { child: unprocessedKey }, { key: unprocessedKey, path: state.path.concat(unprocessedKey) }, options, {}));
                }
            }
        }

        // Validate dependencies

        for (var _i7 = 0; _i7 < this._inner.dependencies.length; ++_i7) {
            var dep = this._inner.dependencies[_i7];
            var err = internals[dep.type].call(this, dep.key !== null && target[dep.key], dep.peers, target, { key: dep.key, path: dep.key === null ? state.path : state.path.concat(dep.key) }, options);
            if (err instanceof Errors.Err) {
                errors.push(err);
                if (options.abortEarly) {
                    return finish();
                }
            }
        }

        return finish();
    };

    _class.prototype.keys = function keys(schema) {

        Hoek.assert(schema === null || schema === undefined || (typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) === 'object', 'Object schema must be a valid object');
        Hoek.assert(!schema || !(schema instanceof Any), 'Object schema cannot be a joi schema');

        var obj = this.clone();

        if (!schema) {
            obj._inner.children = null;
            return obj;
        }

        var children = Object.keys(schema);

        if (!children.length) {
            obj._inner.children = [];
            return obj;
        }

        var topo = new Topo();
        if (obj._inner.children) {
            for (var i = 0; i < obj._inner.children.length; ++i) {
                var child = obj._inner.children[i];

                // Only add the key if we are not going to replace it later
                if (!children.includes(child.key)) {
                    topo.add(child, { after: child._refs, group: child.key });
                }
            }
        }

        for (var _i8 = 0; _i8 < children.length; ++_i8) {
            var key = children[_i8];
            var _child = schema[key];
            try {
                var cast = Cast.schema(this._currentJoi, _child);
                topo.add({ key: key, schema: cast }, { after: cast._refs, group: key });
            } catch (castErr) {
                if (castErr.hasOwnProperty('path')) {
                    castErr.path = key + '.' + castErr.path;
                } else {
                    castErr.path = key;
                }
                throw castErr;
            }
        }

        obj._inner.children = topo.nodes;

        return obj;
    };

    _class.prototype.unknown = function unknown(allow) {

        var value = allow !== false;

        if (this._flags.allowUnknown === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.allowUnknown = value;
        return obj;
    };

    _class.prototype.length = function length(limit) {

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('length', limit, function (value, state, options) {

            if (Object.keys(value).length === limit) {
                return value;
            }

            return this.createError('object.length', { limit: limit }, state, options);
        });
    };

    _class.prototype.min = function min(limit) {

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('min', limit, function (value, state, options) {

            if (Object.keys(value).length >= limit) {
                return value;
            }

            return this.createError('object.min', { limit: limit }, state, options);
        });
    };

    _class.prototype.max = function max(limit) {

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('max', limit, function (value, state, options) {

            if (Object.keys(value).length <= limit) {
                return value;
            }

            return this.createError('object.max', { limit: limit }, state, options);
        });
    };

    _class.prototype.pattern = function pattern(_pattern, schema) {

        Hoek.assert(_pattern instanceof RegExp, 'Invalid regular expression');
        Hoek.assert(schema !== undefined, 'Invalid rule');

        _pattern = new RegExp(_pattern.source, _pattern.ignoreCase ? 'i' : undefined); // Future version should break this and forbid unsupported regex flags

        try {
            schema = Cast.schema(this._currentJoi, schema);
        } catch (castErr) {
            if (castErr.hasOwnProperty('path')) {
                castErr.message = castErr.message + '(' + castErr.path + ')';
            }

            throw castErr;
        }

        var obj = this.clone();
        obj._inner.patterns.push({ regex: _pattern, rule: schema });
        return obj;
    };

    _class.prototype.schema = function schema() {

        return this._test('schema', null, function (value, state, options) {

            if (value instanceof Any) {
                return value;
            }

            return this.createError('object.schema', null, state, options);
        });
    };

    _class.prototype.with = function _with(key, peers) {

        return this._dependency('with', key, peers);
    };

    _class.prototype.without = function without(key, peers) {

        return this._dependency('without', key, peers);
    };

    _class.prototype.xor = function xor() {
        for (var _len2 = arguments.length, peers = Array(_len2), _key4 = 0; _key4 < _len2; _key4++) {
            peers[_key4] = arguments[_key4];
        }

        peers = Hoek.flatten(peers);
        return this._dependency('xor', null, peers);
    };

    _class.prototype.or = function or() {
        for (var _len3 = arguments.length, peers = Array(_len3), _key5 = 0; _key5 < _len3; _key5++) {
            peers[_key5] = arguments[_key5];
        }

        peers = Hoek.flatten(peers);
        return this._dependency('or', null, peers);
    };

    _class.prototype.and = function and() {
        for (var _len4 = arguments.length, peers = Array(_len4), _key6 = 0; _key6 < _len4; _key6++) {
            peers[_key6] = arguments[_key6];
        }

        peers = Hoek.flatten(peers);
        return this._dependency('and', null, peers);
    };

    _class.prototype.nand = function nand() {
        for (var _len5 = arguments.length, peers = Array(_len5), _key7 = 0; _key7 < _len5; _key7++) {
            peers[_key7] = arguments[_key7];
        }

        peers = Hoek.flatten(peers);
        return this._dependency('nand', null, peers);
    };

    _class.prototype.requiredKeys = function requiredKeys() {
        for (var _len6 = arguments.length, children = Array(_len6), _key8 = 0; _key8 < _len6; _key8++) {
            children[_key8] = arguments[_key8];
        }

        children = Hoek.flatten(children);
        return this.applyFunctionToChildren(children, 'required');
    };

    _class.prototype.optionalKeys = function optionalKeys() {
        for (var _len7 = arguments.length, children = Array(_len7), _key9 = 0; _key9 < _len7; _key9++) {
            children[_key9] = arguments[_key9];
        }

        children = Hoek.flatten(children);
        return this.applyFunctionToChildren(children, 'optional');
    };

    _class.prototype.forbiddenKeys = function forbiddenKeys() {
        for (var _len8 = arguments.length, children = Array(_len8), _key10 = 0; _key10 < _len8; _key10++) {
            children[_key10] = arguments[_key10];
        }

        children = Hoek.flatten(children);
        return this.applyFunctionToChildren(children, 'forbidden');
    };

    _class.prototype.rename = function rename(from, to, options) {

        Hoek.assert(typeof from === 'string' || from instanceof RegExp, 'Rename missing the from argument');
        Hoek.assert(typeof to === 'string', 'Rename missing the to argument');
        Hoek.assert(to !== from, 'Cannot rename key to same name:', from);

        for (var i = 0; i < this._inner.renames.length; ++i) {
            Hoek.assert(this._inner.renames[i].from !== from, 'Cannot rename the same key multiple times');
        }

        var obj = this.clone();

        obj._inner.renames.push({
            from: from,
            to: to,
            options: Hoek.applyToDefaults(internals.renameDefaults, options || {}),
            isRegExp: from instanceof RegExp
        });

        return obj;
    };

    _class.prototype.applyFunctionToChildren = function applyFunctionToChildren(children, fn, args, root) {

        children = [].concat(children);
        Hoek.assert(children.length > 0, 'expected at least one children');

        var groupedChildren = internals.groupChildren(children);
        var obj = void 0;

        if ('' in groupedChildren) {
            obj = this[fn].apply(this, args);
            delete groupedChildren[''];
        } else {
            obj = this.clone();
        }

        if (obj._inner.children) {
            root = root ? root + '.' : '';

            for (var i = 0; i < obj._inner.children.length; ++i) {
                var child = obj._inner.children[i];
                var group = groupedChildren[child.key];

                if (group) {
                    obj._inner.children[i] = {
                        key: child.key,
                        _refs: child._refs,
                        schema: child.schema.applyFunctionToChildren(group, fn, args, root + child.key)
                    };

                    delete groupedChildren[child.key];
                }
            }
        }

        var remaining = Object.keys(groupedChildren);
        Hoek.assert(remaining.length === 0, 'unknown key(s)', remaining.join(', '));

        return obj;
    };

    _class.prototype._dependency = function _dependency(type, key, peers) {

        peers = [].concat(peers);
        for (var i = 0; i < peers.length; ++i) {
            Hoek.assert(typeof peers[i] === 'string', type, 'peers must be a string or array of strings');
        }

        var obj = this.clone();
        obj._inner.dependencies.push({ type: type, key: key, peers: peers });
        return obj;
    };

    _class.prototype.describe = function describe(shallow) {

        var description = Any.prototype.describe.call(this);

        if (description.rules) {
            for (var i = 0; i < description.rules.length; ++i) {
                var rule = description.rules[i];
                // Coverage off for future-proof descriptions, only object().assert() is use right now
                if ( /* $lab:coverage:off$ */rule.arg && _typeof(rule.arg) === 'object' && rule.arg.schema && rule.arg.ref /* $lab:coverage:on$ */) {
                        rule.arg = {
                            schema: rule.arg.schema.describe(),
                            ref: rule.arg.ref.toString()
                        };
                    }
            }
        }

        if (this._inner.children && !shallow) {

            description.children = {};
            for (var _i9 = 0; _i9 < this._inner.children.length; ++_i9) {
                var child = this._inner.children[_i9];
                description.children[child.key] = child.schema.describe();
            }
        }

        if (this._inner.dependencies.length) {
            description.dependencies = Hoek.clone(this._inner.dependencies);
        }

        if (this._inner.patterns.length) {
            description.patterns = [];

            for (var _i10 = 0; _i10 < this._inner.patterns.length; ++_i10) {
                var pattern = this._inner.patterns[_i10];
                description.patterns.push({ regex: pattern.regex.toString(), rule: pattern.rule.describe() });
            }
        }

        if (this._inner.renames.length > 0) {
            description.renames = Hoek.clone(this._inner.renames);
        }

        return description;
    };

    _class.prototype.assert = function assert(ref, schema, message) {

        ref = Cast.ref(ref);
        Hoek.assert(ref.isContext || ref.depth > 1, 'Cannot use assertions for root level references - use direct key rules instead');
        message = message || 'pass the assertion test';

        try {
            schema = Cast.schema(this._currentJoi, schema);
        } catch (castErr) {
            if (castErr.hasOwnProperty('path')) {
                castErr.message = castErr.message + '(' + castErr.path + ')';
            }

            throw castErr;
        }

        var key = ref.path[ref.path.length - 1];
        var path = ref.path.join('.');

        return this._test('assert', { schema: schema, ref: ref }, function (value, state, options) {

            var result = schema._validate(ref(value), null, options, value);
            if (!result.errors) {
                return value;
            }

            var localState = Hoek.merge({}, state);
            localState.key = key;
            localState.path = ref.path;
            return this.createError('object.assert', { ref: path, message: message }, localState, options);
        });
    };

    _class.prototype.type = function type(constructor) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constructor.name;


        Hoek.assert(typeof constructor === 'function', 'type must be a constructor function');
        var typeData = {
            name: name,
            ctor: constructor
        };

        return this._test('type', typeData, function (value, state, options) {

            if (value instanceof constructor) {
                return value;
            }

            return this.createError('object.type', { type: typeData.name }, state, options);
        });
    };

    return _class;
}(Any);

internals.safeParse = function (value) {

    try {
        return JSON.parse(value);
    } catch (parseErr) {}

    return value;
};

internals.renameDefaults = {
    alias: false, // Keep old value in place
    multiple: false, // Allow renaming multiple keys into the same target
    override: false // Overrides an existing key
};

internals.groupChildren = function (children) {

    children.sort();

    var grouped = {};

    for (var i = 0; i < children.length; ++i) {
        var child = children[i];
        Hoek.assert(typeof child === 'string', 'children must be strings');
        var group = child.split('.')[0];
        var childGroup = grouped[group] = grouped[group] || [];
        childGroup.push(child.substring(group.length + 1));
    }

    return grouped;
};

internals.keysToLabels = function (schema, keys) {

    var children = schema._inner.children;

    if (!children) {
        return keys;
    }

    var findLabel = function findLabel(key) {

        var matchingChild = children.find(function (child) {
            return child.key === key;
        });
        return matchingChild ? matchingChild.schema._getLabel(key) : key;
    };

    if (Array.isArray(keys)) {
        return keys.map(findLabel);
    }

    return findLabel(keys);
};

internals.with = function (value, peers, parent, state, options) {

    if (value === undefined) {
        return value;
    }

    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (!Object.prototype.hasOwnProperty.call(parent, peer) || parent[peer] === undefined) {

            return this.createError('object.with', {
                main: state.key,
                mainWithLabel: internals.keysToLabels(this, state.key),
                peer: peer,
                peerWithLabel: internals.keysToLabels(this, peer)
            }, state, options);
        }
    }

    return value;
};

internals.without = function (value, peers, parent, state, options) {

    if (value === undefined) {
        return value;
    }

    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (Object.prototype.hasOwnProperty.call(parent, peer) && parent[peer] !== undefined) {

            return this.createError('object.without', {
                main: state.key,
                mainWithLabel: internals.keysToLabels(this, state.key),
                peer: peer,
                peerWithLabel: internals.keysToLabels(this, peer)
            }, state, options);
        }
    }

    return value;
};

internals.xor = function (value, peers, parent, state, options) {

    var present = [];
    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (Object.prototype.hasOwnProperty.call(parent, peer) && parent[peer] !== undefined) {

            present.push(peer);
        }
    }

    if (present.length === 1) {
        return value;
    }

    var context = { peers: peers, peersWithLabels: internals.keysToLabels(this, peers) };

    if (present.length === 0) {
        return this.createError('object.missing', context, state, options);
    }

    return this.createError('object.xor', context, state, options);
};

internals.or = function (value, peers, parent, state, options) {

    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (Object.prototype.hasOwnProperty.call(parent, peer) && parent[peer] !== undefined) {
            return value;
        }
    }

    return this.createError('object.missing', {
        peers: peers,
        peersWithLabels: internals.keysToLabels(this, peers)
    }, state, options);
};

internals.and = function (value, peers, parent, state, options) {

    var missing = [];
    var present = [];
    var count = peers.length;
    for (var i = 0; i < count; ++i) {
        var peer = peers[i];
        if (!Object.prototype.hasOwnProperty.call(parent, peer) || parent[peer] === undefined) {

            missing.push(peer);
        } else {
            present.push(peer);
        }
    }

    var aon = missing.length === count || present.length === count;

    if (!aon) {

        return this.createError('object.and', {
            present: present,
            presentWithLabels: internals.keysToLabels(this, present),
            missing: missing,
            missingWithLabels: internals.keysToLabels(this, missing)
        }, state, options);
    }
};

internals.nand = function (value, peers, parent, state, options) {

    var present = [];
    for (var i = 0; i < peers.length; ++i) {
        var peer = peers[i];
        if (Object.prototype.hasOwnProperty.call(parent, peer) && parent[peer] !== undefined) {

            present.push(peer);
        }
    }

    var values = Hoek.clone(peers);
    var main = values.splice(0, 1)[0];
    var allPresent = present.length === peers.length;
    return allPresent ? this.createError('object.nand', {
        main: main,
        mainWithLabel: internals.keysToLabels(this, main),
        peers: values,
        peersWithLabels: internals.keysToLabels(this, values)
    }, state, options) : null;
};

module.exports = new internals.Object();

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules


// Delcare internals

var internals = {
  rfc3986: {}
};

internals.generate = function () {

  /**
   * elements separated by forward slash ("/") are alternatives.
   */
  var or = '|';

  /**
   * Rule to support zero-padded addresses.
   */
  var zeroPad = '0?';

  /**
   * DIGIT = %x30-39 ; 0-9
   */
  var digit = '0-9';
  var digitOnly = '[' + digit + ']';

  /**
   * ALPHA = %x41-5A / %x61-7A   ; A-Z / a-z
   */
  var alpha = 'a-zA-Z';
  var alphaOnly = '[' + alpha + ']';

  /**
   * IPv4
   * cidr       = DIGIT                ; 0-9
   *            / %x31-32 DIGIT         ; 10-29
   *            / "3" %x30-32           ; 30-32
   */
  internals.rfc3986.ipv4Cidr = digitOnly + or + '[1-2]' + digitOnly + or + '3' + '[0-2]';

  /**
   * IPv6
   * cidr       = DIGIT                 ; 0-9
   *            / %x31-39 DIGIT         ; 10-99
   *            / "1" %x0-1 DIGIT       ; 100-119
   *            / "12" %x0-8            ; 120-128
   */
  internals.rfc3986.ipv6Cidr = '(?:' + zeroPad + zeroPad + digitOnly + or + zeroPad + '[1-9]' + digitOnly + or + '1' + '[01]' + digitOnly + or + '12[0-8])';

  /**
   * HEXDIG = DIGIT / "A" / "B" / "C" / "D" / "E" / "F"
   */
  var hexDigit = digit + 'A-Fa-f';
  var hexDigitOnly = '[' + hexDigit + ']';

  /**
   * unreserved = ALPHA / DIGIT / "-" / "." / "_" / "~"
   */
  var unreserved = alpha + digit + '-\\._~';

  /**
   * sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
   */
  var subDelims = '!\\$&\'\\(\\)\\*\\+,;=';

  /**
   * pct-encoded = "%" HEXDIG HEXDIG
   */
  var pctEncoded = '%' + hexDigit;

  /**
   * pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
   */
  var pchar = unreserved + pctEncoded + subDelims + ':@';
  var pcharOnly = '[' + pchar + ']';

  /**
   * dec-octet   = DIGIT                 ; 0-9
   *            / %x31-39 DIGIT         ; 10-99
   *            / "1" 2DIGIT            ; 100-199
   *            / "2" %x30-34 DIGIT     ; 200-249
   *            / "25" %x30-35          ; 250-255
   */
  var decOctect = '(?:' + zeroPad + zeroPad + digitOnly + or + zeroPad + '[1-9]' + digitOnly + or + '1' + digitOnly + digitOnly + or + '2' + '[0-4]' + digitOnly + or + '25' + '[0-5])';

  /**
   * IPv4address = dec-octet "." dec-octet "." dec-octet "." dec-octet
   */
  internals.rfc3986.IPv4address = '(?:' + decOctect + '\\.){3}' + decOctect;

  /**
   * h16 = 1*4HEXDIG ; 16 bits of address represented in hexadecimal
   * ls32 = ( h16 ":" h16 ) / IPv4address ; least-significant 32 bits of address
   * IPv6address =                            6( h16 ":" ) ls32
   *             /                       "::" 5( h16 ":" ) ls32
   *             / [               h16 ] "::" 4( h16 ":" ) ls32
   *             / [ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
   *             / [ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
   *             / [ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
   *             / [ *4( h16 ":" ) h16 ] "::"              ls32
   *             / [ *5( h16 ":" ) h16 ] "::"              h16
   *             / [ *6( h16 ":" ) h16 ] "::"
   */
  var h16 = hexDigitOnly + '{1,4}';
  var ls32 = '(?:' + h16 + ':' + h16 + '|' + internals.rfc3986.IPv4address + ')';
  var IPv6SixHex = '(?:' + h16 + ':){6}' + ls32;
  var IPv6FiveHex = '::(?:' + h16 + ':){5}' + ls32;
  var IPv6FourHex = '(?:' + h16 + ')?::(?:' + h16 + ':){4}' + ls32;
  var IPv6ThreeHex = '(?:(?:' + h16 + ':){0,1}' + h16 + ')?::(?:' + h16 + ':){3}' + ls32;
  var IPv6TwoHex = '(?:(?:' + h16 + ':){0,2}' + h16 + ')?::(?:' + h16 + ':){2}' + ls32;
  var IPv6OneHex = '(?:(?:' + h16 + ':){0,3}' + h16 + ')?::' + h16 + ':' + ls32;
  var IPv6NoneHex = '(?:(?:' + h16 + ':){0,4}' + h16 + ')?::' + ls32;
  var IPv6NoneHex2 = '(?:(?:' + h16 + ':){0,5}' + h16 + ')?::' + h16;
  var IPv6NoneHex3 = '(?:(?:' + h16 + ':){0,6}' + h16 + ')?::';
  internals.rfc3986.IPv6address = '(?:' + IPv6SixHex + or + IPv6FiveHex + or + IPv6FourHex + or + IPv6ThreeHex + or + IPv6TwoHex + or + IPv6OneHex + or + IPv6NoneHex + or + IPv6NoneHex2 + or + IPv6NoneHex3 + ')';

  /**
   * IPvFuture = "v" 1*HEXDIG "." 1*( unreserved / sub-delims / ":" )
   */
  internals.rfc3986.IPvFuture = 'v' + hexDigitOnly + '+\\.[' + unreserved + subDelims + ':]+';

  /**
   * scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
   */
  internals.rfc3986.scheme = alphaOnly + '[' + alpha + digit + '+-\\.]*';

  /**
   * userinfo = *( unreserved / pct-encoded / sub-delims / ":" )
   */
  var userinfo = '[' + unreserved + pctEncoded + subDelims + ':]*';

  /**
   * IP-literal = "[" ( IPv6address / IPvFuture  ) "]"
   */
  var IPLiteral = '\\[(?:' + internals.rfc3986.IPv6address + or + internals.rfc3986.IPvFuture + ')\\]';

  /**
   * reg-name = *( unreserved / pct-encoded / sub-delims )
   */
  var regName = '[' + unreserved + pctEncoded + subDelims + ']{0,255}';

  /**
   * host = IP-literal / IPv4address / reg-name
   */
  var host = '(?:' + IPLiteral + or + internals.rfc3986.IPv4address + or + regName + ')';

  /**
   * port = *DIGIT
   */
  var port = digitOnly + '*';

  /**
   * authority   = [ userinfo "@" ] host [ ":" port ]
   */
  var authority = '(?:' + userinfo + '@)?' + host + '(?::' + port + ')?';

  /**
   * segment       = *pchar
   * segment-nz    = 1*pchar
   * path          = path-abempty    ; begins with "/" or is empty
   *               / path-absolute   ; begins with "/" but not "//"
   *               / path-noscheme   ; begins with a non-colon segment
   *               / path-rootless   ; begins with a segment
   *               / path-empty      ; zero characters
   * path-abempty  = *( "/" segment )
   * path-absolute = "/" [ segment-nz *( "/" segment ) ]
   * path-rootless = segment-nz *( "/" segment )
   */
  var segment = pcharOnly + '*';
  var segmentNz = pcharOnly + '+';
  var segmentNzNc = '[' + unreserved + pctEncoded + subDelims + '@' + ']+';
  var pathEmpty = '';
  var pathAbEmpty = '(?:\\/' + segment + ')*';
  var pathAbsolute = '\\/(?:' + segmentNz + pathAbEmpty + ')?';
  var pathRootless = segmentNz + pathAbEmpty;
  var pathNoScheme = segmentNzNc + pathAbEmpty;

  /**
   * hier-part = "//" authority path
   */
  internals.rfc3986.hierPart = '(?:' + '(?:\\/\\/' + authority + pathAbEmpty + ')' + or + pathAbsolute + or + pathRootless + ')';

  /**
   * relative-part = "//" authority path-abempty
   *                 / path-absolute
   *                 / path-noscheme
   *                 / path-empty
   */
  internals.rfc3986.relativeRef = '(?:' + '(?:\\/\\/' + authority + pathAbEmpty + ')' + or + pathAbsolute + or + pathNoScheme + or + pathEmpty + ')';

  /**
   * query = *( pchar / "/" / "?" )
   */
  internals.rfc3986.query = '[' + pchar + '\\/\\?]*(?=#|$)'; //Finish matching either at the fragment part or end of the line.

  /**
   * fragment = *( pchar / "/" / "?" )
   */
  internals.rfc3986.fragment = '[' + pchar + '\\/\\?]*';
};

internals.generate();

module.exports = internals.rfc3986;

/***/ }),
/* 14 */
/***/ (function(module, exports) {



/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

// Declare internals

var internals = {};

exports.escapeJavaScript = function (input) {

    if (!input) {
        return '';
    }

    var escaped = '';

    for (var i = 0; i < input.length; ++i) {

        var charCode = input.charCodeAt(i);

        if (internals.isSafe(charCode)) {
            escaped += input[i];
        } else {
            escaped += internals.escapeJavaScriptChar(charCode);
        }
    }

    return escaped;
};

exports.escapeHtml = function (input) {

    if (!input) {
        return '';
    }

    var escaped = '';

    for (var i = 0; i < input.length; ++i) {

        var charCode = input.charCodeAt(i);

        if (internals.isSafe(charCode)) {
            escaped += input[i];
        } else {
            escaped += internals.escapeHtmlChar(charCode);
        }
    }

    return escaped;
};

exports.escapeJson = function (input) {

    if (!input) {
        return '';
    }

    var lessThan = 0x3C;
    var greaterThan = 0x3E;
    var andSymbol = 0x26;
    var lineSeperator = 0x2028;

    // replace method
    var charCode = void 0;
    return input.replace(/[<>&\u2028\u2029]/g, function (match) {

        charCode = match.charCodeAt(0);

        if (charCode === lessThan) {
            return '\\u003c';
        } else if (charCode === greaterThan) {
            return '\\u003e';
        } else if (charCode === andSymbol) {
            return '\\u0026';
        } else if (charCode === lineSeperator) {
            return '\\u2028';
        }
        return '\\u2029';
    });
};

internals.escapeJavaScriptChar = function (charCode) {

    if (charCode >= 256) {
        return '\\u' + internals.padLeft('' + charCode, 4);
    }

    var hexValue = new Buffer(String.fromCharCode(charCode), 'ascii').toString('hex');
    return '\\x' + internals.padLeft(hexValue, 2);
};

internals.escapeHtmlChar = function (charCode) {

    var namedEscape = internals.namedHtml[charCode];
    if (typeof namedEscape !== 'undefined') {
        return namedEscape;
    }

    if (charCode >= 256) {
        return '&#' + charCode + ';';
    }

    var hexValue = new Buffer(String.fromCharCode(charCode), 'ascii').toString('hex');
    return '&#x' + internals.padLeft(hexValue, 2) + ';';
};

internals.padLeft = function (str, len) {

    while (str.length < len) {
        str = '0' + str;
    }

    return str;
};

internals.isSafe = function (charCode) {

    return typeof internals.safeCharCodes[charCode] !== 'undefined';
};

internals.namedHtml = {
    '38': '&amp;',
    '60': '&lt;',
    '62': '&gt;',
    '34': '&quot;',
    '160': '&nbsp;',
    '162': '&cent;',
    '163': '&pound;',
    '164': '&curren;',
    '169': '&copy;',
    '174': '&reg;'
};

internals.safeCharCodes = function () {

    var safe = {};

    for (var i = 32; i < 123; ++i) {

        if (i >= 97 || // a-z
        i >= 65 && i <= 90 || // A-Z
        i >= 48 && i <= 57 || // 0-9
        i === 32 || // space
        i === 46 || // .
        i === 44 || // ,
        i === 45 || // -
        i === 58 || // :
        i === 95) {
            // _

            safe[i] = null;
        }
    }

    return safe;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, process) {

// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Punycode = __webpack_require__(35);

// Declare internals

var internals = {
    hasOwn: Object.prototype.hasOwnProperty,
    indexOf: Array.prototype.indexOf,
    defaultThreshold: 16,
    maxIPv6Groups: 8,

    categories: {
        valid: 1,
        dnsWarn: 7,
        rfc5321: 15,
        cfws: 31,
        deprecated: 63,
        rfc5322: 127,
        error: 255
    },

    diagnoses: {

        // Address is valid

        valid: 0,

        // Address is valid for SMTP but has unusual elements

        rfc5321TLD: 9,
        rfc5321TLDNumeric: 10,
        rfc5321QuotedString: 11,
        rfc5321AddressLiteral: 12,

        // Address is valid for message, but must be modified for envelope

        cfwsComment: 17,
        cfwsFWS: 18,

        // Address contains deprecated elements, but may still be valid in some contexts

        deprecatedLocalPart: 33,
        deprecatedFWS: 34,
        deprecatedQTEXT: 35,
        deprecatedQP: 36,
        deprecatedComment: 37,
        deprecatedCTEXT: 38,
        deprecatedIPv6: 39,
        deprecatedCFWSNearAt: 49,

        // Address is only valid according to broad definition in RFC 5322, but is otherwise invalid

        rfc5322Domain: 65,
        rfc5322TooLong: 66,
        rfc5322LocalTooLong: 67,
        rfc5322DomainTooLong: 68,
        rfc5322LabelTooLong: 69,
        rfc5322DomainLiteral: 70,
        rfc5322DomainLiteralOBSDText: 71,
        rfc5322IPv6GroupCount: 72,
        rfc5322IPv62x2xColon: 73,
        rfc5322IPv6BadCharacter: 74,
        rfc5322IPv6MaxGroups: 75,
        rfc5322IPv6ColonStart: 76,
        rfc5322IPv6ColonEnd: 77,

        // Address is invalid for any purpose

        errExpectingDTEXT: 129,
        errNoLocalPart: 130,
        errNoDomain: 131,
        errConsecutiveDots: 132,
        errATEXTAfterCFWS: 133,
        errATEXTAfterQS: 134,
        errATEXTAfterDomainLiteral: 135,
        errExpectingQPair: 136,
        errExpectingATEXT: 137,
        errExpectingQTEXT: 138,
        errExpectingCTEXT: 139,
        errBackslashEnd: 140,
        errDotStart: 141,
        errDotEnd: 142,
        errDomainHyphenStart: 143,
        errDomainHyphenEnd: 144,
        errUnclosedQuotedString: 145,
        errUnclosedComment: 146,
        errUnclosedDomainLiteral: 147,
        errFWSCRLFx2: 148,
        errFWSCRLFEnd: 149,
        errCRNoLF: 150,
        errUnknownTLD: 160,
        errDomainTooShort: 161
    },

    components: {
        localpart: 0,
        domain: 1,
        literal: 2,
        contextComment: 3,
        contextFWS: 4,
        contextQuotedString: 5,
        contextQuotedPair: 6
    }
};

internals.specials = function () {

    var specials = '()<>[]:;@\\,."'; // US-ASCII visible characters not valid for atext (http://tools.ietf.org/html/rfc5322#section-3.2.3)
    var lookup = new Array(0x100);
    lookup.fill(false);

    for (var i = 0; i < specials.length; ++i) {
        lookup[specials.codePointAt(i)] = true;
    }

    return function (code) {

        return lookup[code];
    };
}();

internals.c0Controls = function () {

    var lookup = new Array(0x100);
    lookup.fill(false);

    // add C0 control characters

    for (var i = 0; i < 33; ++i) {
        lookup[i] = true;
    }

    return function (code) {

        return lookup[code];
    };
}();

internals.c1Controls = function () {

    var lookup = new Array(0x100);
    lookup.fill(false);

    // add C1 control characters

    for (var i = 127; i < 160; ++i) {
        lookup[i] = true;
    }

    return function (code) {

        return lookup[code];
    };
}();

internals.regex = {
    ipV4: /\b(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipV6: /^[a-fA-F\d]{0,4}$/
};

// $lab:coverage:off$
internals.nulNormalize = function (email) {

    var emailPieces = email.split('\0');
    emailPieces = emailPieces.map(function (string) {

        return string.normalize('NFC');
    });

    return emailPieces.join('\0');
};
// $lab:coverage:on$


internals.checkIpV6 = function (items) {

    return items.every(function (value) {
        return internals.regex.ipV6.test(value);
    });
};

internals.validDomain = function (tldAtom, options) {

    if (options.tldBlacklist) {
        if (Array.isArray(options.tldBlacklist)) {
            return internals.indexOf.call(options.tldBlacklist, tldAtom) === -1;
        }

        return !internals.hasOwn.call(options.tldBlacklist, tldAtom);
    }

    if (Array.isArray(options.tldWhitelist)) {
        return internals.indexOf.call(options.tldWhitelist, tldAtom) !== -1;
    }

    return internals.hasOwn.call(options.tldWhitelist, tldAtom);
};

/**
 * Check that an email address conforms to RFCs 5321, 5322, 6530 and others
 *
 * We distinguish clearly between a Mailbox as defined by RFC 5321 and an
 * addr-spec as defined by RFC 5322. Depending on the context, either can be
 * regarded as a valid email address. The RFC 5321 Mailbox specification is
 * more restrictive (comments, white space and obsolete forms are not allowed).
 *
 * @param {string} email The email address to check. See README for specifics.
 * @param {Object} options The (optional) options:
 *   {*} errorLevel Determines the boundary between valid and invalid
 *     addresses.
 *   {*} tldBlacklist The set of domains to consider invalid.
 *   {*} tldWhitelist The set of domains to consider valid.
 *   {*} minDomainAtoms The minimum number of domain atoms which must be present
 *     for the address to be valid.
 * @param {function(number|boolean)} callback The (optional) callback handler.
 * @return {*}
 */

exports.validate = internals.validate = function (email, options, callback) {

    options = options || {};
    email = internals.normalize(email);

    if (typeof options === 'function') {
        callback = options;
        options = {};
    }

    if (typeof callback !== 'function') {
        callback = null;
    }

    var diagnose = void 0;
    var threshold = void 0;

    if (typeof options.errorLevel === 'number') {
        diagnose = true;
        threshold = options.errorLevel;
    } else {
        diagnose = !!options.errorLevel;
        threshold = internals.diagnoses.valid;
    }

    if (options.tldWhitelist) {
        if (typeof options.tldWhitelist === 'string') {
            options.tldWhitelist = [options.tldWhitelist];
        } else if (_typeof(options.tldWhitelist) !== 'object') {
            throw new TypeError('expected array or object tldWhitelist');
        }
    }

    if (options.tldBlacklist) {
        if (typeof options.tldBlacklist === 'string') {
            options.tldBlacklist = [options.tldBlacklist];
        } else if (_typeof(options.tldBlacklist) !== 'object') {
            throw new TypeError('expected array or object tldBlacklist');
        }
    }

    if (options.minDomainAtoms && (options.minDomainAtoms !== (+options.minDomainAtoms | 0) || options.minDomainAtoms < 0)) {
        throw new TypeError('expected positive integer minDomainAtoms');
    }

    var maxResult = internals.diagnoses.valid;
    var updateResult = function updateResult(value) {

        if (value > maxResult) {
            maxResult = value;
        }
    };

    var context = {
        now: internals.components.localpart,
        prev: internals.components.localpart,
        stack: [internals.components.localpart]
    };

    var prevToken = '';

    var parseData = {
        local: '',
        domain: ''
    };
    var atomData = {
        locals: [''],
        domains: ['']
    };

    var elementCount = 0;
    var elementLength = 0;
    var crlfCount = 0;
    var charCode = void 0;

    var hyphenFlag = false;
    var assertEnd = false;

    var emailLength = email.length;

    var token = void 0; // Token is used outside the loop, must declare similarly
    for (var i = 0; i < emailLength; i += token.length) {
        // Utilize codepoints to account for Unicode surrogate pairs
        token = String.fromCodePoint(email.codePointAt(i));

        switch (context.now) {
            // Local-part
            case internals.components.localpart:
                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //   local-part      =   dot-atom / quoted-string / obs-local-part
                //
                //   dot-atom        =   [CFWS] dot-atom-text [CFWS]
                //
                //   dot-atom-text   =   1*atext *("." 1*atext)
                //
                //   quoted-string   =   [CFWS]
                //                       DQUOTE *([FWS] qcontent) [FWS] DQUOTE
                //                       [CFWS]
                //
                //   obs-local-part  =   word *("." word)
                //
                //   word            =   atom / quoted-string
                //
                //   atom            =   [CFWS] 1*atext [CFWS]
                switch (token) {
                    // Comment
                    case '(':
                        if (elementLength === 0) {
                            // Comments are OK at the beginning of an element
                            updateResult(elementCount === 0 ? internals.diagnoses.cfwsComment : internals.diagnoses.deprecatedComment);
                        } else {
                            updateResult(internals.diagnoses.cfwsComment);
                            // Cannot start a comment in an element, should be end
                            assertEnd = true;
                        }

                        context.stack.push(context.now);
                        context.now = internals.components.contextComment;
                        break;

                    // Next dot-atom element
                    case '.':
                        if (elementLength === 0) {
                            // Another dot, already?
                            updateResult(elementCount === 0 ? internals.diagnoses.errDotStart : internals.diagnoses.errConsecutiveDots);
                        } else {
                            // The entire local-part can be a quoted string for RFC 5321; if one atom is quoted it's an RFC 5322 obsolete form
                            if (assertEnd) {
                                updateResult(internals.diagnoses.deprecatedLocalPart);
                            }

                            // CFWS & quoted strings are OK again now we're at the beginning of an element (although they are obsolete forms)
                            assertEnd = false;
                            elementLength = 0;
                            ++elementCount;
                            parseData.local += token;
                            atomData.locals[elementCount] = '';
                        }

                        break;

                    // Quoted string
                    case '"':
                        if (elementLength === 0) {
                            // The entire local-part can be a quoted string for RFC 5321; if one atom is quoted it's an RFC 5322 obsolete form
                            updateResult(elementCount === 0 ? internals.diagnoses.rfc5321QuotedString : internals.diagnoses.deprecatedLocalPart);

                            parseData.local += token;
                            atomData.locals[elementCount] += token;
                            elementLength += Buffer.byteLength(token, 'utf8');

                            // Quoted string must be the entire element
                            assertEnd = true;
                            context.stack.push(context.now);
                            context.now = internals.components.contextQuotedString;
                        } else {
                            updateResult(internals.diagnoses.errExpectingATEXT);
                        }

                        break;

                    // Folding white space
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case ' ':
                    case '\t':
                        if (elementLength === 0) {
                            updateResult(elementCount === 0 ? internals.diagnoses.cfwsFWS : internals.diagnoses.deprecatedFWS);
                        } else {
                            // We can't start FWS in the middle of an element, better be end
                            assertEnd = true;
                        }

                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    case '@':
                        // At this point we should have a valid local-part
                        // $lab:coverage:off$
                        if (context.stack.length !== 1) {
                            throw new Error('unexpected item on context stack');
                        }
                        // $lab:coverage:on$

                        if (parseData.local.length === 0) {
                            // Fatal error
                            updateResult(internals.diagnoses.errNoLocalPart);
                        } else if (elementLength === 0) {
                            // Fatal error
                            updateResult(internals.diagnoses.errDotEnd);
                        }
                        // http://tools.ietf.org/html/rfc5321#section-4.5.3.1.1 the maximum total length of a user name or other local-part is 64
                        //    octets
                        else if (Buffer.byteLength(parseData.local, 'utf8') > 64) {
                                updateResult(internals.diagnoses.rfc5322LocalTooLong);
                            }
                            // http://tools.ietf.org/html/rfc5322#section-3.4.1 comments and folding white space SHOULD NOT be used around "@" in the
                            //    addr-spec
                            //
                            // http://tools.ietf.org/html/rfc2119
                            // 4. SHOULD NOT this phrase, or the phrase "NOT RECOMMENDED" mean that there may exist valid reasons in particular
                            //    circumstances when the particular behavior is acceptable or even useful, but the full implications should be understood
                            //    and the case carefully weighed before implementing any behavior described with this label.
                            else if (context.prev === internals.components.contextComment || context.prev === internals.components.contextFWS) {
                                    updateResult(internals.diagnoses.deprecatedCFWSNearAt);
                                }

                        // Clear everything down for the domain parsing
                        context.now = internals.components.domain;
                        context.stack[0] = internals.components.domain;
                        elementCount = 0;
                        elementLength = 0;
                        assertEnd = false; // CFWS can only appear at the end of the element
                        break;

                    // ATEXT
                    default:
                        // http://tools.ietf.org/html/rfc5322#section-3.2.3
                        //    atext = ALPHA / DIGIT / ; Printable US-ASCII
                        //            "!" / "#" /     ;  characters not including
                        //            "$" / "%" /     ;  specials.  Used for atoms.
                        //            "&" / "'" /
                        //            "*" / "+" /
                        //            "-" / "/" /
                        //            "=" / "?" /
                        //            "^" / "_" /
                        //            "`" / "{" /
                        //            "|" / "}" /
                        //            "~"
                        if (assertEnd) {
                            // We have encountered atext where it is no longer valid
                            switch (context.prev) {
                                case internals.components.contextComment:
                                case internals.components.contextFWS:
                                    updateResult(internals.diagnoses.errATEXTAfterCFWS);
                                    break;

                                case internals.components.contextQuotedString:
                                    updateResult(internals.diagnoses.errATEXTAfterQS);
                                    break;

                                // $lab:coverage:off$
                                default:
                                    throw new Error('more atext found where none is allowed, but unrecognized prev context: ' + context.prev);
                                // $lab:coverage:on$
                            }
                        } else {
                            context.prev = context.now;
                            charCode = token.codePointAt(0);

                            // Especially if charCode == 10
                            if (internals.specials(charCode) || internals.c0Controls(charCode) || internals.c1Controls(charCode)) {

                                // Fatal error
                                updateResult(internals.diagnoses.errExpectingATEXT);
                            }

                            parseData.local += token;
                            atomData.locals[elementCount] += token;
                            elementLength += Buffer.byteLength(token, 'utf8');
                        }
                }

                break;

            case internals.components.domain:
                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //   domain          =   dot-atom / domain-literal / obs-domain
                //
                //   dot-atom        =   [CFWS] dot-atom-text [CFWS]
                //
                //   dot-atom-text   =   1*atext *("." 1*atext)
                //
                //   domain-literal  =   [CFWS] "[" *([FWS] dtext) [FWS] "]" [CFWS]
                //
                //   dtext           =   %d33-90 /          ; Printable US-ASCII
                //                       %d94-126 /         ;  characters not including
                //                       obs-dtext          ;  "[", "]", or "\"
                //
                //   obs-domain      =   atom *("." atom)
                //
                //   atom            =   [CFWS] 1*atext [CFWS]

                // http://tools.ietf.org/html/rfc5321#section-4.1.2
                //   Mailbox        = Local-part "@" ( Domain / address-literal )
                //
                //   Domain         = sub-domain *("." sub-domain)
                //
                //   address-literal  = "[" ( IPv4-address-literal /
                //                    IPv6-address-literal /
                //                    General-address-literal ) "]"
                //                    ; See Section 4.1.3

                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //      Note: A liberal syntax for the domain portion of addr-spec is
                //      given here.  However, the domain portion contains addressing
                //      information specified by and used in other protocols (e.g.,
                //      [RFC1034], [RFC1035], [RFC1123], [RFC5321]).  It is therefore
                //      incumbent upon implementations to conform to the syntax of
                //      addresses for the context in which they are used.
                //
                // is_email() author's note: it's not clear how to interpret this in
                // he context of a general email address validator. The conclusion I
                // have reached is this: "addressing information" must comply with
                // RFC 5321 (and in turn RFC 1035), anything that is "semantically
                // invisible" must comply only with RFC 5322.
                switch (token) {
                    // Comment
                    case '(':
                        if (elementLength === 0) {
                            // Comments at the start of the domain are deprecated in the text, comments at the start of a subdomain are obs-domain
                            // http://tools.ietf.org/html/rfc5322#section-3.4.1
                            updateResult(elementCount === 0 ? internals.diagnoses.deprecatedCFWSNearAt : internals.diagnoses.deprecatedComment);
                        } else {
                            // We can't start a comment mid-element, better be at the end
                            assertEnd = true;
                            updateResult(internals.diagnoses.cfwsComment);
                        }

                        context.stack.push(context.now);
                        context.now = internals.components.contextComment;
                        break;

                    // Next dot-atom element
                    case '.':
                        var punycodeLength = Punycode.encode(atomData.domains[elementCount]).length;
                        if (elementLength === 0) {
                            // Another dot, already? Fatal error.
                            updateResult(elementCount === 0 ? internals.diagnoses.errDotStart : internals.diagnoses.errConsecutiveDots);
                        } else if (hyphenFlag) {
                            // Previous subdomain ended in a hyphen. Fatal error.
                            updateResult(internals.diagnoses.errDomainHyphenEnd);
                        } else if (punycodeLength > 63) {
                            // RFC 5890 specifies that domain labels that are encoded using the Punycode algorithm
                            // must adhere to the <= 63 octet requirement.
                            // This includes string prefixes from the Punycode algorithm.
                            //
                            // https://tools.ietf.org/html/rfc5890#section-2.3.2.1
                            // labels          63 octets or less

                            updateResult(internals.diagnoses.rfc5322LabelTooLong);
                        }

                        // CFWS is OK again now we're at the beginning of an element (although
                        // it may be obsolete CFWS)
                        assertEnd = false;
                        elementLength = 0;
                        ++elementCount;
                        atomData.domains[elementCount] = '';
                        parseData.domain += token;

                        break;

                    // Domain literal
                    case '[':
                        if (parseData.domain.length === 0) {
                            // Domain literal must be the only component
                            assertEnd = true;
                            elementLength += Buffer.byteLength(token, 'utf8');
                            context.stack.push(context.now);
                            context.now = internals.components.literal;
                            parseData.domain += token;
                            atomData.domains[elementCount] += token;
                            parseData.literal = '';
                        } else {
                            // Fatal error
                            updateResult(internals.diagnoses.errExpectingATEXT);
                        }

                        break;

                    // Folding white space
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case ' ':
                    case '\t':
                        if (elementLength === 0) {
                            updateResult(elementCount === 0 ? internals.diagnoses.deprecatedCFWSNearAt : internals.diagnoses.deprecatedFWS);
                        } else {
                            // We can't start FWS in the middle of an element, so this better be the end
                            updateResult(internals.diagnoses.cfwsFWS);
                            assertEnd = true;
                        }

                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    // This must be ATEXT
                    default:
                        // RFC 5322 allows any atext...
                        // http://tools.ietf.org/html/rfc5322#section-3.2.3
                        //    atext = ALPHA / DIGIT / ; Printable US-ASCII
                        //            "!" / "#" /     ;  characters not including
                        //            "$" / "%" /     ;  specials.  Used for atoms.
                        //            "&" / "'" /
                        //            "*" / "+" /
                        //            "-" / "/" /
                        //            "=" / "?" /
                        //            "^" / "_" /
                        //            "`" / "{" /
                        //            "|" / "}" /
                        //            "~"

                        // But RFC 5321 only allows letter-digit-hyphen to comply with DNS rules
                        //   (RFCs 1034 & 1123)
                        // http://tools.ietf.org/html/rfc5321#section-4.1.2
                        //   sub-domain     = Let-dig [Ldh-str]
                        //
                        //   Let-dig        = ALPHA / DIGIT
                        //
                        //   Ldh-str        = *( ALPHA / DIGIT / "-" ) Let-dig
                        //
                        if (assertEnd) {
                            // We have encountered ATEXT where it is no longer valid
                            switch (context.prev) {
                                case internals.components.contextComment:
                                case internals.components.contextFWS:
                                    updateResult(internals.diagnoses.errATEXTAfterCFWS);
                                    break;

                                case internals.components.literal:
                                    updateResult(internals.diagnoses.errATEXTAfterDomainLiteral);
                                    break;

                                // $lab:coverage:off$
                                default:
                                    throw new Error('more atext found where none is allowed, but unrecognized prev context: ' + context.prev);
                                // $lab:coverage:on$
                            }
                        }

                        charCode = token.codePointAt(0);
                        // Assume this token isn't a hyphen unless we discover it is
                        hyphenFlag = false;

                        if (internals.specials(charCode) || internals.c0Controls(charCode) || internals.c1Controls(charCode)) {
                            // Fatal error
                            updateResult(internals.diagnoses.errExpectingATEXT);
                        } else if (token === '-') {
                            if (elementLength === 0) {
                                // Hyphens cannot be at the beginning of a subdomain, fatal error
                                updateResult(internals.diagnoses.errDomainHyphenStart);
                            }

                            hyphenFlag = true;
                        }
                        // Check if it's a neither a number nor a latin/unicode letter
                        else if (charCode < 48 || charCode > 122 && charCode < 192 || charCode > 57 && charCode < 65 || charCode > 90 && charCode < 97) {
                                // This is not an RFC 5321 subdomain, but still OK by RFC 5322
                                updateResult(internals.diagnoses.rfc5322Domain);
                            }

                        parseData.domain += token;
                        atomData.domains[elementCount] += token;
                        elementLength += Buffer.byteLength(token, 'utf8');
                }

                break;

            // Domain literal
            case internals.components.literal:
                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //   domain-literal  =   [CFWS] "[" *([FWS] dtext) [FWS] "]" [CFWS]
                //
                //   dtext           =   %d33-90 /          ; Printable US-ASCII
                //                       %d94-126 /         ;  characters not including
                //                       obs-dtext          ;  "[", "]", or "\"
                //
                //   obs-dtext       =   obs-NO-WS-CTL / quoted-pair
                switch (token) {
                    // End of domain literal
                    case ']':
                        if (maxResult < internals.categories.deprecated) {
                            // Could be a valid RFC 5321 address literal, so let's check

                            // http://tools.ietf.org/html/rfc5321#section-4.1.2
                            //   address-literal  = "[" ( IPv4-address-literal /
                            //                    IPv6-address-literal /
                            //                    General-address-literal ) "]"
                            //                    ; See Section 4.1.3
                            //
                            // http://tools.ietf.org/html/rfc5321#section-4.1.3
                            //   IPv4-address-literal  = Snum 3("."  Snum)
                            //
                            //   IPv6-address-literal  = "IPv6:" IPv6-addr
                            //
                            //   General-address-literal  = Standardized-tag ":" 1*dcontent
                            //
                            //   Standardized-tag  = Ldh-str
                            //                     ; Standardized-tag MUST be specified in a
                            //                     ; Standards-Track RFC and registered with IANA
                            //
                            //   dcontent      = %d33-90 / ; Printable US-ASCII
                            //                 %d94-126 ; excl. "[", "\", "]"
                            //
                            //   Snum          = 1*3DIGIT
                            //                 ; representing a decimal integer
                            //                 ; value in the range 0 through 255
                            //
                            //   IPv6-addr     = IPv6-full / IPv6-comp / IPv6v4-full / IPv6v4-comp
                            //
                            //   IPv6-hex      = 1*4HEXDIG
                            //
                            //   IPv6-full     = IPv6-hex 7(":" IPv6-hex)
                            //
                            //   IPv6-comp     = [IPv6-hex *5(":" IPv6-hex)] "::"
                            //                 [IPv6-hex *5(":" IPv6-hex)]
                            //                 ; The "::" represents at least 2 16-bit groups of
                            //                 ; zeros.  No more than 6 groups in addition to the
                            //                 ; "::" may be present.
                            //
                            //   IPv6v4-full   = IPv6-hex 5(":" IPv6-hex) ":" IPv4-address-literal
                            //
                            //   IPv6v4-comp   = [IPv6-hex *3(":" IPv6-hex)] "::"
                            //                 [IPv6-hex *3(":" IPv6-hex) ":"]
                            //                 IPv4-address-literal
                            //                 ; The "::" represents at least 2 16-bit groups of
                            //                 ; zeros.  No more than 4 groups in addition to the
                            //                 ; "::" and IPv4-address-literal may be present.

                            var index = -1;
                            var addressLiteral = parseData.literal;
                            var matchesIP = internals.regex.ipV4.exec(addressLiteral);

                            // Maybe extract IPv4 part from the end of the address-literal
                            if (matchesIP) {
                                index = matchesIP.index;
                                if (index !== 0) {
                                    // Convert IPv4 part to IPv6 format for futher testing
                                    addressLiteral = addressLiteral.slice(0, index) + '0:0';
                                }
                            }

                            if (index === 0) {
                                // Nothing there except a valid IPv4 address, so...
                                updateResult(internals.diagnoses.rfc5321AddressLiteral);
                            } else if (addressLiteral.slice(0, 5).toLowerCase() !== 'ipv6:') {
                                updateResult(internals.diagnoses.rfc5322DomainLiteral);
                            } else {
                                var match = addressLiteral.slice(5);
                                var maxGroups = internals.maxIPv6Groups;
                                var groups = match.split(':');
                                index = match.indexOf('::');

                                if (!~index) {
                                    // Need exactly the right number of groups
                                    if (groups.length !== maxGroups) {
                                        updateResult(internals.diagnoses.rfc5322IPv6GroupCount);
                                    }
                                } else if (index !== match.lastIndexOf('::')) {
                                    updateResult(internals.diagnoses.rfc5322IPv62x2xColon);
                                } else {
                                    if (index === 0 || index === match.length - 2) {
                                        // RFC 4291 allows :: at the start or end of an address with 7 other groups in addition
                                        ++maxGroups;
                                    }

                                    if (groups.length > maxGroups) {
                                        updateResult(internals.diagnoses.rfc5322IPv6MaxGroups);
                                    } else if (groups.length === maxGroups) {
                                        // Eliding a single "::"
                                        updateResult(internals.diagnoses.deprecatedIPv6);
                                    }
                                }

                                // IPv6 testing strategy
                                if (match[0] === ':' && match[1] !== ':') {
                                    updateResult(internals.diagnoses.rfc5322IPv6ColonStart);
                                } else if (match[match.length - 1] === ':' && match[match.length - 2] !== ':') {
                                    updateResult(internals.diagnoses.rfc5322IPv6ColonEnd);
                                } else if (internals.checkIpV6(groups)) {
                                    updateResult(internals.diagnoses.rfc5321AddressLiteral);
                                } else {
                                    updateResult(internals.diagnoses.rfc5322IPv6BadCharacter);
                                }
                            }
                        } else {
                            updateResult(internals.diagnoses.rfc5322DomainLiteral);
                        }

                        parseData.domain += token;
                        atomData.domains[elementCount] += token;
                        elementLength += Buffer.byteLength(token, 'utf8');
                        context.prev = context.now;
                        context.now = context.stack.pop();
                        break;

                    case '\\':
                        updateResult(internals.diagnoses.rfc5322DomainLiteralOBSDText);
                        context.stack.push(context.now);
                        context.now = internals.components.contextQuotedPair;
                        break;

                    // Folding white space
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case ' ':
                    case '\t':
                        updateResult(internals.diagnoses.cfwsFWS);

                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    // DTEXT
                    default:
                        // http://tools.ietf.org/html/rfc5322#section-3.4.1
                        //   dtext         =   %d33-90 /  ; Printable US-ASCII
                        //                     %d94-126 / ;  characters not including
                        //                     obs-dtext  ;  "[", "]", or "\"
                        //
                        //   obs-dtext     =   obs-NO-WS-CTL / quoted-pair
                        //
                        //   obs-NO-WS-CTL =   %d1-8 /    ; US-ASCII control
                        //                     %d11 /     ;  characters that do not
                        //                     %d12 /     ;  include the carriage
                        //                     %d14-31 /  ;  return, line feed, and
                        //                     %d127      ;  white space characters
                        charCode = token.codePointAt(0);

                        // '\r', '\n', ' ', and '\t' have already been parsed above
                        if (charCode !== 127 && internals.c1Controls(charCode) || charCode === 0 || token === '[') {
                            // Fatal error
                            updateResult(internals.diagnoses.errExpectingDTEXT);
                            break;
                        } else if (internals.c0Controls(charCode) || charCode === 127) {
                            updateResult(internals.diagnoses.rfc5322DomainLiteralOBSDText);
                        }

                        parseData.literal += token;
                        parseData.domain += token;
                        atomData.domains[elementCount] += token;
                        elementLength += Buffer.byteLength(token, 'utf8');
                }

                break;

            // Quoted string
            case internals.components.contextQuotedString:
                // http://tools.ietf.org/html/rfc5322#section-3.2.4
                //   quoted-string = [CFWS]
                //                   DQUOTE *([FWS] qcontent) [FWS] DQUOTE
                //                   [CFWS]
                //
                //   qcontent      = qtext / quoted-pair
                switch (token) {
                    // Quoted pair
                    case '\\':
                        context.stack.push(context.now);
                        context.now = internals.components.contextQuotedPair;
                        break;

                    // Folding white space. Spaces are allowed as regular characters inside a quoted string - it's only FWS if we include '\t' or '\r\n'
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case '\t':
                        // http://tools.ietf.org/html/rfc5322#section-3.2.2
                        //   Runs of FWS, comment, or CFWS that occur between lexical tokens in
                        //   a structured header field are semantically interpreted as a single
                        //   space character.

                        // http://tools.ietf.org/html/rfc5322#section-3.2.4
                        //   the CRLF in any FWS/CFWS that appears within the quoted-string [is]
                        //   semantically "invisible" and therefore not part of the
                        //   quoted-string

                        parseData.local += ' ';
                        atomData.locals[elementCount] += ' ';
                        elementLength += Buffer.byteLength(token, 'utf8');

                        updateResult(internals.diagnoses.cfwsFWS);
                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    // End of quoted string
                    case '"':
                        parseData.local += token;
                        atomData.locals[elementCount] += token;
                        elementLength += Buffer.byteLength(token, 'utf8');
                        context.prev = context.now;
                        context.now = context.stack.pop();
                        break;

                    // QTEXT
                    default:
                        // http://tools.ietf.org/html/rfc5322#section-3.2.4
                        //   qtext          =   %d33 /             ; Printable US-ASCII
                        //                      %d35-91 /          ;  characters not including
                        //                      %d93-126 /         ;  "\" or the quote character
                        //                      obs-qtext
                        //
                        //   obs-qtext      =   obs-NO-WS-CTL
                        //
                        //   obs-NO-WS-CTL  =   %d1-8 /            ; US-ASCII control
                        //                      %d11 /             ;  characters that do not
                        //                      %d12 /             ;  include the carriage
                        //                      %d14-31 /          ;  return, line feed, and
                        //                      %d127              ;  white space characters
                        charCode = token.codePointAt(0);

                        if (charCode !== 127 && internals.c1Controls(charCode) || charCode === 0 || charCode === 10) {
                            updateResult(internals.diagnoses.errExpectingQTEXT);
                        } else if (internals.c0Controls(charCode) || charCode === 127) {
                            updateResult(internals.diagnoses.deprecatedQTEXT);
                        }

                        parseData.local += token;
                        atomData.locals[elementCount] += token;
                        elementLength += Buffer.byteLength(token, 'utf8');
                }

                // http://tools.ietf.org/html/rfc5322#section-3.4.1
                //   If the string can be represented as a dot-atom (that is, it contains
                //   no characters other than atext characters or "." surrounded by atext
                //   characters), then the dot-atom form SHOULD be used and the quoted-
                //   string form SHOULD NOT be used.

                break;
            // Quoted pair
            case internals.components.contextQuotedPair:
                // http://tools.ietf.org/html/rfc5322#section-3.2.1
                //   quoted-pair     =   ("\" (VCHAR / WSP)) / obs-qp
                //
                //   VCHAR           =  %d33-126   ; visible (printing) characters
                //   WSP             =  SP / HTAB  ; white space
                //
                //   obs-qp          =   "\" (%d0 / obs-NO-WS-CTL / LF / CR)
                //
                //   obs-NO-WS-CTL   =   %d1-8 /   ; US-ASCII control
                //                       %d11 /    ;  characters that do not
                //                       %d12 /    ;  include the carriage
                //                       %d14-31 / ;  return, line feed, and
                //                       %d127     ;  white space characters
                //
                // i.e. obs-qp       =  "\" (%d0-8, %d10-31 / %d127)
                charCode = token.codePointAt(0);

                if (charCode !== 127 && internals.c1Controls(charCode)) {
                    // Fatal error
                    updateResult(internals.diagnoses.errExpectingQPair);
                } else if (charCode < 31 && charCode !== 9 || charCode === 127) {
                    // ' ' and '\t' are allowed
                    updateResult(internals.diagnoses.deprecatedQP);
                }

                // At this point we know where this qpair occurred so we could check to see if the character actually needed to be quoted at all.
                // http://tools.ietf.org/html/rfc5321#section-4.1.2
                //   the sending system SHOULD transmit the form that uses the minimum quoting possible.

                context.prev = context.now;
                // End of qpair
                context.now = context.stack.pop();
                var escapeToken = '\\' + token;

                switch (context.now) {
                    case internals.components.contextComment:
                        break;

                    case internals.components.contextQuotedString:
                        parseData.local += escapeToken;
                        atomData.locals[elementCount] += escapeToken;

                        // The maximum sizes specified by RFC 5321 are octet counts, so we must include the backslash
                        elementLength += 2;
                        break;

                    case internals.components.literal:
                        parseData.domain += escapeToken;
                        atomData.domains[elementCount] += escapeToken;

                        // The maximum sizes specified by RFC 5321 are octet counts, so we must include the backslash
                        elementLength += 2;
                        break;

                    // $lab:coverage:off$
                    default:
                        throw new Error('quoted pair logic invoked in an invalid context: ' + context.now);
                    // $lab:coverage:on$
                }
                break;

            // Comment
            case internals.components.contextComment:
                // http://tools.ietf.org/html/rfc5322#section-3.2.2
                //   comment  = "(" *([FWS] ccontent) [FWS] ")"
                //
                //   ccontent = ctext / quoted-pair / comment
                switch (token) {
                    // Nested comment
                    case '(':
                        // Nested comments are ok
                        context.stack.push(context.now);
                        context.now = internals.components.contextComment;
                        break;

                    // End of comment
                    case ')':
                        context.prev = context.now;
                        context.now = context.stack.pop();
                        break;

                    // Quoted pair
                    case '\\':
                        context.stack.push(context.now);
                        context.now = internals.components.contextQuotedPair;
                        break;

                    // Folding white space
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                            break;
                        }

                    // Fallthrough

                    case ' ':
                    case '\t':
                        updateResult(internals.diagnoses.cfwsFWS);

                        context.stack.push(context.now);
                        context.now = internals.components.contextFWS;
                        prevToken = token;
                        break;

                    // CTEXT
                    default:
                        // http://tools.ietf.org/html/rfc5322#section-3.2.3
                        //   ctext         = %d33-39 /  ; Printable US-ASCII
                        //                   %d42-91 /  ;  characters not including
                        //                   %d93-126 / ;  "(", ")", or "\"
                        //                   obs-ctext
                        //
                        //   obs-ctext     = obs-NO-WS-CTL
                        //
                        //   obs-NO-WS-CTL = %d1-8 /    ; US-ASCII control
                        //                   %d11 /     ;  characters that do not
                        //                   %d12 /     ;  include the carriage
                        //                   %d14-31 /  ;  return, line feed, and
                        //                   %d127      ;  white space characters
                        charCode = token.codePointAt(0);

                        if (charCode === 0 || charCode === 10 || charCode !== 127 && internals.c1Controls(charCode)) {
                            // Fatal error
                            updateResult(internals.diagnoses.errExpectingCTEXT);
                            break;
                        } else if (internals.c0Controls(charCode) || charCode === 127) {
                            updateResult(internals.diagnoses.deprecatedCTEXT);
                        }
                }

                break;

            // Folding white space
            case internals.components.contextFWS:
                // http://tools.ietf.org/html/rfc5322#section-3.2.2
                //   FWS     =   ([*WSP CRLF] 1*WSP) /  obs-FWS
                //                                   ; Folding white space

                // But note the erratum:
                // http://www.rfc-editor.org/errata_search.php?rfc=5322&eid=1908:
                //   In the obsolete syntax, any amount of folding white space MAY be
                //   inserted where the obs-FWS rule is allowed.  This creates the
                //   possibility of having two consecutive "folds" in a line, and
                //   therefore the possibility that a line which makes up a folded header
                //   field could be composed entirely of white space.
                //
                //   obs-FWS =   1*([CRLF] WSP)

                if (prevToken === '\r') {
                    if (token === '\r') {
                        // Fatal error
                        updateResult(internals.diagnoses.errFWSCRLFx2);
                        break;
                    }

                    if (++crlfCount > 1) {
                        // Multiple folds => obsolete FWS
                        updateResult(internals.diagnoses.deprecatedFWS);
                    } else {
                        crlfCount = 1;
                    }
                }

                switch (token) {
                    case '\r':
                        if (emailLength === ++i || email[i] !== '\n') {
                            // Fatal error
                            updateResult(internals.diagnoses.errCRNoLF);
                        }

                        break;

                    case ' ':
                    case '\t':
                        break;

                    default:
                        if (prevToken === '\r') {
                            // Fatal error
                            updateResult(internals.diagnoses.errFWSCRLFEnd);
                        }

                        crlfCount = 0;

                        // End of FWS
                        context.prev = context.now;
                        context.now = context.stack.pop();

                        // Look at this token again in the parent context
                        --i;
                }

                prevToken = token;
                break;

            // Unexpected context
            // $lab:coverage:off$
            default:
                throw new Error('unknown context: ' + context.now);
            // $lab:coverage:on$
        } // Primary state machine

        if (maxResult > internals.categories.rfc5322) {
            // Fatal error, no point continuing
            break;
        }
    } // Token loop

    // Check for errors
    if (maxResult < internals.categories.rfc5322) {
        var _punycodeLength = Punycode.encode(parseData.domain).length;
        // Fatal errors
        if (context.now === internals.components.contextQuotedString) {
            updateResult(internals.diagnoses.errUnclosedQuotedString);
        } else if (context.now === internals.components.contextQuotedPair) {
            updateResult(internals.diagnoses.errBackslashEnd);
        } else if (context.now === internals.components.contextComment) {
            updateResult(internals.diagnoses.errUnclosedComment);
        } else if (context.now === internals.components.literal) {
            updateResult(internals.diagnoses.errUnclosedDomainLiteral);
        } else if (token === '\r') {
            updateResult(internals.diagnoses.errFWSCRLFEnd);
        } else if (parseData.domain.length === 0) {
            updateResult(internals.diagnoses.errNoDomain);
        } else if (elementLength === 0) {
            updateResult(internals.diagnoses.errDotEnd);
        } else if (hyphenFlag) {
            updateResult(internals.diagnoses.errDomainHyphenEnd);
        }

        // Other errors
        else if (_punycodeLength > 255) {
                // http://tools.ietf.org/html/rfc5321#section-4.5.3.1.2
                //   The maximum total length of a domain name or number is 255 octets.
                updateResult(internals.diagnoses.rfc5322DomainTooLong);
            } else if (Buffer.byteLength(parseData.local, 'utf8') + _punycodeLength + /* '@' */1 > 254) {
                // http://tools.ietf.org/html/rfc5321#section-4.1.2
                //   Forward-path   = Path
                //
                //   Path           = "<" [ A-d-l ":" ] Mailbox ">"
                //
                // http://tools.ietf.org/html/rfc5321#section-4.5.3.1.3
                //   The maximum total length of a reverse-path or forward-path is 256 octets (including the punctuation and element separators).
                //
                // Thus, even without (obsolete) routing information, the Mailbox can only be 254 characters long. This is confirmed by this verified
                // erratum to RFC 3696:
                //
                // http://www.rfc-editor.org/errata_search.php?rfc=3696&eid=1690
                //   However, there is a restriction in RFC 2821 on the length of an address in MAIL and RCPT commands of 254 characters.  Since
                //   addresses that do not fit in those fields are not normally useful, the upper limit on address lengths should normally be considered
                //   to be 254.
                updateResult(internals.diagnoses.rfc5322TooLong);
            } else if (elementLength > 63) {
                // http://tools.ietf.org/html/rfc1035#section-2.3.4
                // labels   63 octets or less
                updateResult(internals.diagnoses.rfc5322LabelTooLong);
            } else if (options.minDomainAtoms && atomData.domains.length < options.minDomainAtoms) {
                updateResult(internals.diagnoses.errDomainTooShort);
            } else if (options.tldWhitelist || options.tldBlacklist) {
                var tldAtom = atomData.domains[elementCount];

                if (!internals.validDomain(tldAtom, options)) {
                    updateResult(internals.diagnoses.errUnknownTLD);
                }
            }
    } // Check for errors

    // Finish
    if (maxResult < internals.categories.dnsWarn) {
        // Per RFC 5321, domain atoms are limited to letter-digit-hyphen, so we only need to check code <= 57 to check for a digit
        var code = atomData.domains[elementCount].codePointAt(0);

        if (code <= 57) {
            updateResult(internals.diagnoses.rfc5321TLDNumeric);
        }
    }

    if (maxResult < threshold) {
        maxResult = internals.diagnoses.valid;
    }

    var finishResult = diagnose ? maxResult : maxResult < internals.defaultThreshold;

    if (callback) {
        callback(finishResult);
    }

    return finishResult;
};

exports.diagnoses = internals.validate.diagnoses = function () {

    var diag = {};
    var keys = Object.keys(internals.diagnoses);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        diag[key] = internals.diagnoses[key];
    }

    return diag;
}();

exports.normalize = internals.normalize = function (email) {

    // $lab:coverage:off$
    if (process.version[1] === '4' && email.indexOf('\0') >= 0) {
        return internals.nulNormalize(email);
    }
    // $lab:coverage:on$


    return email.normalize('NFC');
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer, __webpack_require__(5)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules


// Declare internals

var internals = {};

exports.errors = {
    root: 'value',
    key: '"{{!label}}" ',
    messages: {
        wrapArrays: true
    },
    any: {
        unknown: 'is not allowed',
        invalid: 'contains an invalid value',
        empty: 'is not allowed to be empty',
        required: 'is required',
        allowOnly: 'must be one of {{valids}}',
        default: 'threw an error when running default method'
    },
    alternatives: {
        base: 'not matching any of the allowed alternatives',
        child: null
    },
    array: {
        base: 'must be an array',
        includes: 'at position {{pos}} does not match any of the allowed types',
        includesSingle: 'single value of "{{!label}}" does not match any of the allowed types',
        includesOne: 'at position {{pos}} fails because {{reason}}',
        includesOneSingle: 'single value of "{{!label}}" fails because {{reason}}',
        includesRequiredUnknowns: 'does not contain {{unknownMisses}} required value(s)',
        includesRequiredKnowns: 'does not contain {{knownMisses}}',
        includesRequiredBoth: 'does not contain {{knownMisses}} and {{unknownMisses}} other required value(s)',
        excludes: 'at position {{pos}} contains an excluded value',
        excludesSingle: 'single value of "{{!label}}" contains an excluded value',
        min: 'must contain at least {{limit}} items',
        max: 'must contain less than or equal to {{limit}} items',
        length: 'must contain {{limit}} items',
        ordered: 'at position {{pos}} fails because {{reason}}',
        orderedLength: 'at position {{pos}} fails because array must contain at most {{limit}} items',
        ref: 'references "{{ref}}" which is not a positive integer',
        sparse: 'must not be a sparse array',
        unique: 'position {{pos}} contains a duplicate value'
    },
    boolean: {
        base: 'must be a boolean'
    },
    binary: {
        base: 'must be a buffer or a string',
        min: 'must be at least {{limit}} bytes',
        max: 'must be less than or equal to {{limit}} bytes',
        length: 'must be {{limit}} bytes'
    },
    date: {
        base: 'must be a number of milliseconds or valid date string',
        format: 'must be a string with one of the following formats {{format}}',
        strict: 'must be a valid date',
        min: 'must be larger than or equal to "{{limit}}"',
        max: 'must be less than or equal to "{{limit}}"',
        isoDate: 'must be a valid ISO 8601 date',
        timestamp: {
            javascript: 'must be a valid timestamp or number of milliseconds',
            unix: 'must be a valid timestamp or number of seconds'
        },
        ref: 'references "{{ref}}" which is not a date'
    },
    function: {
        base: 'must be a Function',
        arity: 'must have an arity of {{n}}',
        minArity: 'must have an arity greater or equal to {{n}}',
        maxArity: 'must have an arity lesser or equal to {{n}}',
        ref: 'must be a Joi reference',
        class: 'must be a class'
    },
    lazy: {
        base: '!!schema error: lazy schema must be set',
        schema: '!!schema error: lazy schema function must return a schema'
    },
    object: {
        base: 'must be an object',
        child: '!!child "{{!child}}" fails because {{reason}}',
        min: 'must have at least {{limit}} children',
        max: 'must have less than or equal to {{limit}} children',
        length: 'must have {{limit}} children',
        allowUnknown: '!!"{{!child}}" is not allowed',
        with: '!!"{{mainWithLabel}}" missing required peer "{{peerWithLabel}}"',
        without: '!!"{{mainWithLabel}}" conflict with forbidden peer "{{peerWithLabel}}"',
        missing: 'must contain at least one of {{peersWithLabels}}',
        xor: 'contains a conflict between exclusive peers {{peersWithLabels}}',
        or: 'must contain at least one of {{peersWithLabels}}',
        and: 'contains {{presentWithLabels}} without its required peers {{missingWithLabels}}',
        nand: '!!"{{mainWithLabel}}" must not exist simultaneously with {{peersWithLabels}}',
        assert: '!!"{{ref}}" validation failed because "{{ref}}" failed to {{message}}',
        rename: {
            multiple: 'cannot rename child "{{from}}" because multiple renames are disabled and another key was already renamed to "{{to}}"',
            override: 'cannot rename child "{{from}}" because override is disabled and target "{{to}}" exists',
            regex: {
                multiple: 'cannot rename children {{from}} because multiple renames are disabled and another key was already renamed to "{{to}}"',
                override: 'cannot rename children {{from}} because override is disabled and target "{{to}}" exists'
            }
        },
        type: 'must be an instance of "{{type}}"',
        schema: 'must be a Joi instance'
    },
    number: {
        base: 'must be a number',
        min: 'must be larger than or equal to {{limit}}',
        max: 'must be less than or equal to {{limit}}',
        less: 'must be less than {{limit}}',
        greater: 'must be greater than {{limit}}',
        float: 'must be a float or double',
        integer: 'must be an integer',
        negative: 'must be a negative number',
        positive: 'must be a positive number',
        precision: 'must have no more than {{limit}} decimal places',
        ref: 'references "{{ref}}" which is not a number',
        multiple: 'must be a multiple of {{multiple}}'
    },
    string: {
        base: 'must be a string',
        min: 'length must be at least {{limit}} characters long',
        max: 'length must be less than or equal to {{limit}} characters long',
        length: 'length must be {{limit}} characters long',
        alphanum: 'must only contain alpha-numeric characters',
        token: 'must only contain alpha-numeric and underscore characters',
        regex: {
            base: 'with value "{{!value}}" fails to match the required pattern: {{pattern}}',
            name: 'with value "{{!value}}" fails to match the {{name}} pattern',
            invert: {
                base: 'with value "{{!value}}" matches the inverted pattern: {{pattern}}',
                name: 'with value "{{!value}}" matches the inverted {{name}} pattern'
            }
        },
        email: 'must be a valid email',
        uri: 'must be a valid uri',
        uriRelativeOnly: 'must be a valid relative uri',
        uriCustomScheme: 'must be a valid uri with a scheme matching the {{scheme}} pattern',
        isoDate: 'must be a valid ISO 8601 date',
        guid: 'must be a valid GUID',
        hex: 'must only contain hexadecimal characters',
        base64: 'must be a valid base64 string',
        hostname: 'must be a valid hostname',
        normalize: 'must be unicode normalized in the {{form}} form',
        lowercase: 'must only contain lowercase characters',
        uppercase: 'must only contain uppercase characters',
        trim: 'must not have leading or trailing whitespace',
        creditCard: 'must be a credit card',
        ref: 'references "{{ref}}" which is not a number',
        ip: 'must be a valid ip address with a {{cidr}} CIDR',
        ipVersion: 'must be a valid ip address of one of the following versions {{version}} with a {{cidr}} CIDR'
    }
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var Joi = __webpack_require__(8);

// Declare internals

var internals = {};

exports.options = Joi.object({
    abortEarly: Joi.boolean(),
    convert: Joi.boolean(),
    allowUnknown: Joi.boolean(),
    skipFunctions: Joi.boolean(),
    stripUnknown: [Joi.boolean(), Joi.object({ arrays: Joi.boolean(), objects: Joi.boolean() }).or('arrays', 'objects')],
    language: Joi.object(),
    presence: Joi.string().only('required', 'optional', 'forbidden', 'ignore'),
    raw: Joi.boolean(),
    context: Joi.object(),
    strip: Joi.boolean(),
    noDefaults: Joi.boolean(),
    escapeHtml: Joi.boolean()
}).strict();

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Any = __webpack_require__(2);
var Cast = __webpack_require__(4);
var Ref = __webpack_require__(1);
var Hoek = __webpack_require__(0);

// Declare internals

var internals = {};

internals.fastSplice = function (arr, i) {

    var pos = i;
    while (pos < arr.length) {
        arr[pos++] = arr[pos];
    }

    --arr.length;
};

internals.Array = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'array';
        _this._inner.items = [];
        _this._inner.ordereds = [];
        _this._inner.inclusions = [];
        _this._inner.exclusions = [];
        _this._inner.requireds = [];
        _this._flags.sparse = false;
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            value: value
        };

        if (typeof value === 'string' && options.convert) {

            internals.safeParse(value, result);
        }

        var isArray = Array.isArray(result.value);
        var wasArray = isArray;
        if (options.convert && this._flags.single && !isArray) {
            result.value = [result.value];
            isArray = true;
        }

        if (!isArray) {
            result.errors = this.createError('array.base', null, state, options);
            return result;
        }

        if (this._inner.inclusions.length || this._inner.exclusions.length || this._inner.requireds.length || this._inner.ordereds.length || !this._flags.sparse) {

            // Clone the array so that we don't modify the original
            if (wasArray) {
                result.value = result.value.slice(0);
            }

            result.errors = this._checkItems.call(this, result.value, wasArray, state, options);

            if (result.errors && wasArray && options.convert && this._flags.single) {

                // Attempt a 2nd pass by putting the array inside one.
                var previousErrors = result.errors;

                result.value = [result.value];
                result.errors = this._checkItems.call(this, result.value, wasArray, state, options);

                if (result.errors) {

                    // Restore previous errors and value since this didn't validate either.
                    result.errors = previousErrors;
                    result.value = result.value[0];
                }
            }
        }

        return result;
    };

    _class.prototype._checkItems = function _checkItems(items, wasArray, state, options) {

        var errors = [];
        var errored = void 0;

        var requireds = this._inner.requireds.slice();
        var ordereds = this._inner.ordereds.slice();
        var inclusions = this._inner.inclusions.concat(requireds);

        var il = items.length;
        for (var i = 0; i < il; ++i) {
            errored = false;
            var item = items[i];
            var isValid = false;
            var key = wasArray ? i : state.key;
            var path = wasArray ? state.path.concat(i) : state.path;
            var localState = { key: key, path: path, parent: state.parent, reference: state.reference };
            var res = void 0;

            // Sparse

            if (!this._flags.sparse && item === undefined) {
                errors.push(this.createError('array.sparse', null, { key: state.key, path: localState.path, pos: i }, options));

                if (options.abortEarly) {
                    return errors;
                }

                continue;
            }

            // Exclusions

            for (var j = 0; j < this._inner.exclusions.length; ++j) {
                res = this._inner.exclusions[j]._validate(item, localState, {}); // Not passing options to use defaults

                if (!res.errors) {
                    errors.push(this.createError(wasArray ? 'array.excludes' : 'array.excludesSingle', { pos: i, value: item }, { key: state.key, path: localState.path }, options));
                    errored = true;

                    if (options.abortEarly) {
                        return errors;
                    }

                    break;
                }
            }

            if (errored) {
                continue;
            }

            // Ordered
            if (this._inner.ordereds.length) {
                if (ordereds.length > 0) {
                    var ordered = ordereds.shift();
                    res = ordered._validate(item, localState, options);
                    if (!res.errors) {
                        if (ordered._flags.strip) {
                            internals.fastSplice(items, i);
                            --i;
                            --il;
                        } else if (!this._flags.sparse && res.value === undefined) {
                            errors.push(this.createError('array.sparse', null, { key: state.key, path: localState.path, pos: i }, options));

                            if (options.abortEarly) {
                                return errors;
                            }

                            continue;
                        } else {
                            items[i] = res.value;
                        }
                    } else {
                        errors.push(this.createError('array.ordered', { pos: i, reason: res.errors, value: item }, { key: state.key, path: localState.path }, options));
                        if (options.abortEarly) {
                            return errors;
                        }
                    }
                    continue;
                } else if (!this._inner.items.length) {
                    errors.push(this.createError('array.orderedLength', { pos: i, limit: this._inner.ordereds.length }, { key: state.key, path: localState.path }, options));
                    if (options.abortEarly) {
                        return errors;
                    }
                    continue;
                }
            }

            // Requireds

            var requiredChecks = [];
            var jl = requireds.length;
            for (var _j = 0; _j < jl; ++_j) {
                res = requiredChecks[_j] = requireds[_j]._validate(item, localState, options);
                if (!res.errors) {
                    items[i] = res.value;
                    isValid = true;
                    internals.fastSplice(requireds, _j);
                    --_j;
                    --jl;

                    if (!this._flags.sparse && res.value === undefined) {
                        errors.push(this.createError('array.sparse', null, { key: state.key, path: localState.path, pos: i }, options));

                        if (options.abortEarly) {
                            return errors;
                        }
                    }

                    break;
                }
            }

            if (isValid) {
                continue;
            }

            // Inclusions

            var stripUnknown = options.stripUnknown ? options.stripUnknown === true ? true : !!options.stripUnknown.arrays : false;

            jl = inclusions.length;
            for (var _j2 = 0; _j2 < jl; ++_j2) {
                var inclusion = inclusions[_j2];

                // Avoid re-running requireds that already didn't match in the previous loop
                var previousCheck = requireds.indexOf(inclusion);
                if (previousCheck !== -1) {
                    res = requiredChecks[previousCheck];
                } else {
                    res = inclusion._validate(item, localState, options);

                    if (!res.errors) {
                        if (inclusion._flags.strip) {
                            internals.fastSplice(items, i);
                            --i;
                            --il;
                        } else if (!this._flags.sparse && res.value === undefined) {
                            errors.push(this.createError('array.sparse', null, { key: state.key, path: localState.path, pos: i }, options));
                            errored = true;
                        } else {
                            items[i] = res.value;
                        }
                        isValid = true;
                        break;
                    }
                }

                // Return the actual error if only one inclusion defined
                if (jl === 1) {
                    if (stripUnknown) {
                        internals.fastSplice(items, i);
                        --i;
                        --il;
                        isValid = true;
                        break;
                    }

                    errors.push(this.createError(wasArray ? 'array.includesOne' : 'array.includesOneSingle', { pos: i, reason: res.errors, value: item }, { key: state.key, path: localState.path }, options));
                    errored = true;

                    if (options.abortEarly) {
                        return errors;
                    }

                    break;
                }
            }

            if (errored) {
                continue;
            }

            if (this._inner.inclusions.length && !isValid) {
                if (stripUnknown) {
                    internals.fastSplice(items, i);
                    --i;
                    --il;
                    continue;
                }

                errors.push(this.createError(wasArray ? 'array.includes' : 'array.includesSingle', { pos: i, value: item }, { key: state.key, path: localState.path }, options));

                if (options.abortEarly) {
                    return errors;
                }
            }
        }

        if (requireds.length) {
            this._fillMissedErrors.call(this, errors, requireds, state, options);
        }

        if (ordereds.length) {
            this._fillOrderedErrors.call(this, errors, ordereds, state, options);
        }

        return errors.length ? errors : null;
    };

    _class.prototype.describe = function describe() {

        var description = Any.prototype.describe.call(this);

        if (this._inner.ordereds.length) {
            description.orderedItems = [];

            for (var i = 0; i < this._inner.ordereds.length; ++i) {
                description.orderedItems.push(this._inner.ordereds[i].describe());
            }
        }

        if (this._inner.items.length) {
            description.items = [];

            for (var _i = 0; _i < this._inner.items.length; ++_i) {
                description.items.push(this._inner.items[_i].describe());
            }
        }

        return description;
    };

    _class.prototype.items = function items() {
        var _this2 = this;

        var obj = this.clone();

        for (var _len = arguments.length, schemas = Array(_len), _key = 0; _key < _len; _key++) {
            schemas[_key] = arguments[_key];
        }

        Hoek.flatten(schemas).forEach(function (type, index) {

            try {
                type = Cast.schema(_this2._currentJoi, type);
            } catch (castErr) {
                if (castErr.hasOwnProperty('path')) {
                    castErr.path = index + '.' + castErr.path;
                } else {
                    castErr.path = index;
                }
                castErr.message = castErr.message + '(' + castErr.path + ')';
                throw castErr;
            }

            obj._inner.items.push(type);

            if (type._flags.presence === 'required') {
                obj._inner.requireds.push(type);
            } else if (type._flags.presence === 'forbidden') {
                obj._inner.exclusions.push(type.optional());
            } else {
                obj._inner.inclusions.push(type);
            }
        });

        return obj;
    };

    _class.prototype.ordered = function ordered() {
        var _this3 = this;

        var obj = this.clone();

        for (var _len2 = arguments.length, schemas = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            schemas[_key2] = arguments[_key2];
        }

        Hoek.flatten(schemas).forEach(function (type, index) {

            try {
                type = Cast.schema(_this3._currentJoi, type);
            } catch (castErr) {
                if (castErr.hasOwnProperty('path')) {
                    castErr.path = index + '.' + castErr.path;
                } else {
                    castErr.path = index;
                }
                castErr.message = castErr.message + '(' + castErr.path + ')';
                throw castErr;
            }
            obj._inner.ordereds.push(type);
        });

        return obj;
    };

    _class.prototype.min = function min(limit) {

        var isRef = Ref.isRef(limit);

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0 || isRef, 'limit must be a positive integer or reference');

        return this._test('min', limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!(Number.isSafeInteger(compareTo) && compareTo >= 0)) {
                    return this.createError('array.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (value.length >= compareTo) {
                return value;
            }

            return this.createError('array.min', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.max = function max(limit) {

        var isRef = Ref.isRef(limit);

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0 || isRef, 'limit must be a positive integer or reference');

        return this._test('max', limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!(Number.isSafeInteger(compareTo) && compareTo >= 0)) {
                    return this.createError('array.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (value.length <= compareTo) {
                return value;
            }

            return this.createError('array.max', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.length = function length(limit) {

        var isRef = Ref.isRef(limit);

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0 || isRef, 'limit must be a positive integer or reference');

        return this._test('length', limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!(Number.isSafeInteger(compareTo) && compareTo >= 0)) {
                    return this.createError('array.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (value.length === compareTo) {
                return value;
            }

            return this.createError('array.length', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.unique = function unique(comparator) {

        Hoek.assert(comparator === undefined || typeof comparator === 'function' || typeof comparator === 'string', 'comparator must be a function or a string');

        var settings = {};

        if (typeof comparator === 'string') {
            settings.path = comparator;
        } else if (typeof comparator === 'function') {
            settings.comparator = comparator;
        }

        return this._test('unique', settings, function (value, state, options) {

            var found = {
                string: {},
                number: {},
                undefined: {},
                boolean: {},
                object: new Map(),
                function: new Map(),
                custom: new Map()
            };

            var compare = settings.comparator || Hoek.deepEqual;

            for (var i = 0; i < value.length; ++i) {
                var item = settings.path ? Hoek.reach(value[i], settings.path) : value[i];
                var records = settings.comparator ? found.custom : found[typeof item === 'undefined' ? 'undefined' : _typeof(item)];

                // All available types are supported, so it's not possible to reach 100% coverage without ignoring this line.
                // I still want to keep the test for future js versions with new types (eg. Symbol).
                if ( /* $lab:coverage:off$ */records /* $lab:coverage:on$ */) {
                        if (records instanceof Map) {
                            var entries = records.entries();
                            var current = void 0;
                            while (!(current = entries.next()).done) {
                                if (compare(current.value[0], item)) {
                                    var localState = {
                                        key: state.key,
                                        path: state.path.concat(i),
                                        parent: state.parent,
                                        reference: state.reference
                                    };

                                    var context = {
                                        pos: i,
                                        value: value[i],
                                        dupePos: current.value[1],
                                        dupeValue: value[current.value[1]]
                                    };

                                    if (settings.path) {
                                        context.path = settings.path;
                                    }

                                    return this.createError('array.unique', context, localState, options);
                                }
                            }

                            records.set(item, i);
                        } else {
                            if (records[item] !== undefined) {
                                var _localState = {
                                    key: state.key,
                                    path: state.path.concat(i),
                                    parent: state.parent,
                                    reference: state.reference
                                };

                                var _context = {
                                    pos: i,
                                    value: value[i],
                                    dupePos: records[item],
                                    dupeValue: value[records[item]]
                                };

                                if (settings.path) {
                                    _context.path = settings.path;
                                }

                                return this.createError('array.unique', _context, _localState, options);
                            }

                            records[item] = i;
                        }
                    }
            }

            return value;
        });
    };

    _class.prototype.sparse = function sparse(enabled) {

        var value = enabled === undefined ? true : !!enabled;

        if (this._flags.sparse === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.sparse = value;
        return obj;
    };

    _class.prototype.single = function single(enabled) {

        var value = enabled === undefined ? true : !!enabled;

        if (this._flags.single === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.single = value;
        return obj;
    };

    _class.prototype._fillMissedErrors = function _fillMissedErrors(errors, requireds, state, options) {

        var knownMisses = [];
        var unknownMisses = 0;
        for (var i = 0; i < requireds.length; ++i) {
            var label = requireds[i]._getLabel();
            if (label) {
                knownMisses.push(label);
            } else {
                ++unknownMisses;
            }
        }

        if (knownMisses.length) {
            if (unknownMisses) {
                errors.push(this.createError('array.includesRequiredBoth', { knownMisses: knownMisses, unknownMisses: unknownMisses }, { key: state.key, path: state.path }, options));
            } else {
                errors.push(this.createError('array.includesRequiredKnowns', { knownMisses: knownMisses }, { key: state.key, path: state.path }, options));
            }
        } else {
            errors.push(this.createError('array.includesRequiredUnknowns', { unknownMisses: unknownMisses }, { key: state.key, path: state.path }, options));
        }
    };

    _class.prototype._fillOrderedErrors = function _fillOrderedErrors(errors, ordereds, state, options) {

        var requiredOrdereds = [];

        for (var i = 0; i < ordereds.length; ++i) {
            var presence = Hoek.reach(ordereds[i], '_flags.presence');
            if (presence === 'required') {
                requiredOrdereds.push(ordereds[i]);
            }
        }

        if (requiredOrdereds.length) {
            this._fillMissedErrors.call(this, errors, requiredOrdereds, state, options);
        }
    };

    return _class;
}(Any);

internals.safeParse = function (value, result) {

    try {
        var converted = JSON.parse(value);
        if (Array.isArray(converted)) {
            result.value = converted;
        }
    } catch (e) {}
};

module.exports = new internals.Array();

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

// Load modules

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Any = __webpack_require__(2);
var Hoek = __webpack_require__(0);

// Declare internals

var internals = {};

internals.Binary = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'binary';
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            value: value
        };

        if (typeof value === 'string' && options.convert) {

            try {
                result.value = new Buffer(value, this._flags.encoding);
            } catch (e) {}
        }

        result.errors = Buffer.isBuffer(result.value) ? null : this.createError('binary.base', null, state, options);
        return result;
    };

    _class.prototype.encoding = function encoding(_encoding) {

        Hoek.assert(Buffer.isEncoding(_encoding), 'Invalid encoding:', _encoding);

        if (this._flags.encoding === _encoding) {
            return this;
        }

        var obj = this.clone();
        obj._flags.encoding = _encoding;
        return obj;
    };

    _class.prototype.min = function min(limit) {

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('min', limit, function (value, state, options) {

            if (value.length >= limit) {
                return value;
            }

            return this.createError('binary.min', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.max = function max(limit) {

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('max', limit, function (value, state, options) {

            if (value.length <= limit) {
                return value;
            }

            return this.createError('binary.max', { limit: limit, value: value }, state, options);
        });
    };

    _class.prototype.length = function length(limit) {

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');

        return this._test('length', limit, function (value, state, options) {

            if (value.length === limit) {
                return value;
            }

            return this.createError('binary.length', { limit: limit, value: value }, state, options);
        });
    };

    return _class;
}(Any);

module.exports = new internals.Binary();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Any = __webpack_require__(2);
var Hoek = __webpack_require__(0);

// Declare internals

var internals = {
    Set: __webpack_require__(9)
};

internals.Boolean = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'boolean';
        _this._flags.insensitive = true;
        _this._inner.truthySet = new internals.Set();
        _this._inner.falsySet = new internals.Set();
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            value: value
        };

        if (typeof value === 'string' && options.convert) {

            var normalized = this._flags.insensitive ? value.toLowerCase() : value;
            result.value = normalized === 'true' ? true : normalized === 'false' ? false : value;
        }

        if (typeof result.value !== 'boolean') {
            result.value = this._inner.truthySet.has(value, null, null, this._flags.insensitive) ? true : this._inner.falsySet.has(value, null, null, this._flags.insensitive) ? false : value;
        }

        result.errors = typeof result.value === 'boolean' ? null : this.createError('boolean.base', null, state, options);
        return result;
    };

    _class.prototype.truthy = function truthy() {
        for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
            values[_key] = arguments[_key];
        }

        var obj = this.clone();
        values = Hoek.flatten(values);
        for (var i = 0; i < values.length; ++i) {
            var value = values[i];

            Hoek.assert(value !== undefined, 'Cannot call truthy with undefined');
            obj._inner.truthySet.add(value);
        }
        return obj;
    };

    _class.prototype.falsy = function falsy() {
        for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            values[_key2] = arguments[_key2];
        }

        var obj = this.clone();
        values = Hoek.flatten(values);
        for (var i = 0; i < values.length; ++i) {
            var value = values[i];

            Hoek.assert(value !== undefined, 'Cannot call falsy with undefined');
            obj._inner.falsySet.add(value);
        }
        return obj;
    };

    _class.prototype.insensitive = function insensitive(enabled) {

        var insensitive = enabled === undefined ? true : !!enabled;

        if (this._flags.insensitive === insensitive) {
            return this;
        }

        var obj = this.clone();
        obj._flags.insensitive = insensitive;
        return obj;
    };

    _class.prototype.describe = function describe() {

        var description = Any.prototype.describe.call(this);
        description.truthy = [true].concat(this._inner.truthySet.values());
        description.falsy = [false].concat(this._inner.falsySet.values());
        return description;
    };

    return _class;
}(Any);

module.exports = new internals.Boolean();

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Hoek = __webpack_require__(0);
var ObjectType = __webpack_require__(12);
var Ref = __webpack_require__(1);

// Declare internals

var internals = {};

internals.Func = function (_ObjectType$construct) {
    _inherits(_class, _ObjectType$construct);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _ObjectType$construct.call(this));

        _this._flags.func = true;
        return _this;
    }

    _class.prototype.arity = function arity(n) {

        Hoek.assert(Number.isSafeInteger(n) && n >= 0, 'n must be a positive integer');

        return this._test('arity', n, function (value, state, options) {

            if (value.length === n) {
                return value;
            }

            return this.createError('function.arity', { n: n }, state, options);
        });
    };

    _class.prototype.minArity = function minArity(n) {

        Hoek.assert(Number.isSafeInteger(n) && n > 0, 'n must be a strict positive integer');

        return this._test('minArity', n, function (value, state, options) {

            if (value.length >= n) {
                return value;
            }

            return this.createError('function.minArity', { n: n }, state, options);
        });
    };

    _class.prototype.maxArity = function maxArity(n) {

        Hoek.assert(Number.isSafeInteger(n) && n >= 0, 'n must be a positive integer');

        return this._test('maxArity', n, function (value, state, options) {

            if (value.length <= n) {
                return value;
            }

            return this.createError('function.maxArity', { n: n }, state, options);
        });
    };

    _class.prototype.ref = function ref() {

        return this._test('ref', null, function (value, state, options) {

            if (Ref.isRef(value)) {
                return value;
            }

            return this.createError('function.ref', null, state, options);
        });
    };

    _class.prototype.class = function _class() {

        return this._test('class', null, function (value, state, options) {

            if (/^\s*class\s/.test(value.toString())) {
                return value;
            }

            return this.createError('function.class', null, state, options);
        });
    };

    return _class;
}(ObjectType.constructor);

module.exports = new internals.Func();

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Any = __webpack_require__(2);
var Hoek = __webpack_require__(0);

// Declare internals

var internals = {};

internals.Lazy = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'lazy';
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = { value: value };
        var lazy = this._flags.lazy;

        if (!lazy) {
            result.errors = this.createError('lazy.base', null, state, options);
            return result;
        }

        var schema = lazy();

        if (!(schema instanceof Any)) {
            result.errors = this.createError('lazy.schema', null, state, options);
            return result;
        }

        return schema._validate(value, state, options);
    };

    _class.prototype.set = function set(fn) {

        Hoek.assert(typeof fn === 'function', 'You must provide a function as first argument');

        var obj = this.clone();
        obj._flags.lazy = fn;
        return obj;
    };

    return _class;
}(Any);

module.exports = new internals.Lazy();

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Any = __webpack_require__(2);
var Ref = __webpack_require__(1);
var Hoek = __webpack_require__(0);

// Declare internals

var internals = {
    precisionRx: /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/
};

internals.Number = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'number';
        _this._invalids.add(Infinity);
        _this._invalids.add(-Infinity);
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        var result = {
            errors: null,
            value: value
        };

        if (typeof value === 'string' && options.convert) {

            var number = parseFloat(value);
            result.value = isNaN(number) || !isFinite(value) ? NaN : number;
        }

        var isNumber = typeof result.value === 'number' && !isNaN(result.value);

        if (options.convert && 'precision' in this._flags && isNumber) {

            // This is conceptually equivalent to using toFixed but it should be much faster
            var precision = Math.pow(10, this._flags.precision);
            result.value = Math.round(result.value * precision) / precision;
        }

        result.errors = isNumber ? null : this.createError('number.base', null, state, options);
        return result;
    };

    _class.prototype.multiple = function multiple(base) {

        var isRef = Ref.isRef(base);

        if (!isRef) {
            Hoek.assert(typeof base === 'number' && isFinite(base), 'multiple must be a number');
            Hoek.assert(base > 0, 'multiple must be greater than 0');
        }

        return this._test('multiple', base, function (value, state, options) {

            var divisor = isRef ? base(state.reference || state.parent, options) : base;

            if (isRef && (typeof divisor !== 'number' || !isFinite(divisor))) {
                return this.createError('number.ref', { ref: base.key }, state, options);
            }

            if (value % divisor === 0) {
                return value;
            }

            return this.createError('number.multiple', { multiple: base, value: value }, state, options);
        });
    };

    _class.prototype.integer = function integer() {

        return this._test('integer', undefined, function (value, state, options) {

            return Number.isSafeInteger(value) ? value : this.createError('number.integer', { value: value }, state, options);
        });
    };

    _class.prototype.negative = function negative() {

        return this._test('negative', undefined, function (value, state, options) {

            if (value < 0) {
                return value;
            }

            return this.createError('number.negative', { value: value }, state, options);
        });
    };

    _class.prototype.positive = function positive() {

        return this._test('positive', undefined, function (value, state, options) {

            if (value > 0) {
                return value;
            }

            return this.createError('number.positive', { value: value }, state, options);
        });
    };

    _class.prototype.precision = function precision(limit) {

        Hoek.assert(Number.isSafeInteger(limit), 'limit must be an integer');
        Hoek.assert(!('precision' in this._flags), 'precision already set');

        var obj = this._test('precision', limit, function (value, state, options) {

            var places = value.toString().match(internals.precisionRx);
            var decimals = Math.max((places[1] ? places[1].length : 0) - (places[2] ? parseInt(places[2], 10) : 0), 0);
            if (decimals <= limit) {
                return value;
            }

            return this.createError('number.precision', { limit: limit, value: value }, state, options);
        });

        obj._flags.precision = limit;
        return obj;
    };

    return _class;
}(Any);

internals.compare = function (type, compare) {

    return function (limit) {

        var isRef = Ref.isRef(limit);
        var isNumber = typeof limit === 'number' && !isNaN(limit);

        Hoek.assert(isNumber || isRef, 'limit must be a number or reference');

        return this._test(type, limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!(typeof compareTo === 'number' && !isNaN(compareTo))) {
                    return this.createError('number.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (compare(value, compareTo)) {
                return value;
            }

            return this.createError('number.' + type, { limit: compareTo, value: value }, state, options);
        });
    };
};

internals.Number.prototype.min = internals.compare('min', function (value, limit) {
    return value >= limit;
});
internals.Number.prototype.max = internals.compare('max', function (value, limit) {
    return value <= limit;
});
internals.Number.prototype.greater = internals.compare('greater', function (value, limit) {
    return value > limit;
});
internals.Number.prototype.less = internals.compare('less', function (value, limit) {
    return value < limit;
});

module.exports = new internals.Number();

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

// Load modules

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Net = __webpack_require__(14);
var Hoek = __webpack_require__(0);
var Isemail = void 0; // Loaded on demand
var Any = __webpack_require__(2);
var Ref = __webpack_require__(1);
var JoiDate = __webpack_require__(11);
var Uri = __webpack_require__(27);
var Ip = __webpack_require__(26);

// Declare internals

var internals = {
    uriRegex: Uri.createUriRegex(),
    ipRegex: Ip.createIpRegex(['ipv4', 'ipv6', 'ipvfuture'], 'optional'),
    guidBrackets: {
        '{': '}', '[': ']', '(': ')', '': ''
    },
    guidVersions: {
        uuidv1: '1',
        uuidv2: '2',
        uuidv3: '3',
        uuidv4: '4',
        uuidv5: '5'
    },
    cidrPresences: ['required', 'optional', 'forbidden'],
    normalizationForms: ['NFC', 'NFD', 'NFKC', 'NFKD']
};

internals.String = function (_Any) {
    _inherits(_class, _Any);

    function _class() {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _Any.call(this));

        _this._type = 'string';
        _this._invalids.add('');
        return _this;
    }

    _class.prototype._base = function _base(value, state, options) {

        if (typeof value === 'string' && options.convert) {

            if (this._flags.normalize) {
                value = value.normalize(this._flags.normalize);
            }

            if (this._flags.case) {
                value = this._flags.case === 'upper' ? value.toLocaleUpperCase() : value.toLocaleLowerCase();
            }

            if (this._flags.trim) {
                value = value.trim();
            }

            if (this._inner.replacements) {

                for (var i = 0; i < this._inner.replacements.length; ++i) {
                    var replacement = this._inner.replacements[i];
                    value = value.replace(replacement.pattern, replacement.replacement);
                }
            }

            if (this._flags.truncate) {
                for (var _i = 0; _i < this._tests.length; ++_i) {
                    var test = this._tests[_i];
                    if (test.name === 'max') {
                        value = value.slice(0, test.arg);
                        break;
                    }
                }
            }
        }

        return {
            value: value,
            errors: typeof value === 'string' ? null : this.createError('string.base', { value: value }, state, options)
        };
    };

    _class.prototype.insensitive = function insensitive() {

        if (this._flags.insensitive) {
            return this;
        }

        var obj = this.clone();
        obj._flags.insensitive = true;
        return obj;
    };

    _class.prototype.creditCard = function creditCard() {

        return this._test('creditCard', undefined, function (value, state, options) {

            var i = value.length;
            var sum = 0;
            var mul = 1;

            while (i--) {
                var char = value.charAt(i) * mul;
                sum = sum + (char - (char > 9) * 9);
                mul = mul ^ 3;
            }

            var check = sum % 10 === 0 && sum > 0;
            return check ? value : this.createError('string.creditCard', { value: value }, state, options);
        });
    };

    _class.prototype.regex = function regex(pattern, patternOptions) {

        Hoek.assert(pattern instanceof RegExp, 'pattern must be a RegExp');

        var patternObject = {
            pattern: new RegExp(pattern.source, pattern.ignoreCase ? 'i' : undefined) // Future version should break this and forbid unsupported regex flags
        };

        if (typeof patternOptions === 'string') {
            patternObject.name = patternOptions;
        } else if ((typeof patternOptions === 'undefined' ? 'undefined' : _typeof(patternOptions)) === 'object') {
            patternObject.invert = !!patternOptions.invert;

            if (patternOptions.name) {
                patternObject.name = patternOptions.name;
            }
        }

        var errorCode = ['string.regex', patternObject.invert ? '.invert' : '', patternObject.name ? '.name' : '.base'].join('');

        return this._test('regex', patternObject, function (value, state, options) {

            var patternMatch = patternObject.pattern.test(value);

            if (patternMatch ^ patternObject.invert) {
                return value;
            }

            return this.createError(errorCode, { name: patternObject.name, pattern: patternObject.pattern, value: value }, state, options);
        });
    };

    _class.prototype.alphanum = function alphanum() {

        return this._test('alphanum', undefined, function (value, state, options) {

            if (/^[a-zA-Z0-9]+$/.test(value)) {
                return value;
            }

            return this.createError('string.alphanum', { value: value }, state, options);
        });
    };

    _class.prototype.token = function token() {

        return this._test('token', undefined, function (value, state, options) {

            if (/^\w+$/.test(value)) {
                return value;
            }

            return this.createError('string.token', { value: value }, state, options);
        });
    };

    _class.prototype.email = function email(isEmailOptions) {

        if (isEmailOptions) {
            Hoek.assert((typeof isEmailOptions === 'undefined' ? 'undefined' : _typeof(isEmailOptions)) === 'object', 'email options must be an object');
            Hoek.assert(typeof isEmailOptions.checkDNS === 'undefined', 'checkDNS option is not supported');
            Hoek.assert(typeof isEmailOptions.tldWhitelist === 'undefined' || _typeof(isEmailOptions.tldWhitelist) === 'object', 'tldWhitelist must be an array or object');
            Hoek.assert(typeof isEmailOptions.minDomainAtoms === 'undefined' || Number.isSafeInteger(isEmailOptions.minDomainAtoms) && isEmailOptions.minDomainAtoms > 0, 'minDomainAtoms must be a positive integer');
            Hoek.assert(typeof isEmailOptions.errorLevel === 'undefined' || typeof isEmailOptions.errorLevel === 'boolean' || Number.isSafeInteger(isEmailOptions.errorLevel) && isEmailOptions.errorLevel >= 0, 'errorLevel must be a non-negative integer or boolean');
        }

        return this._test('email', isEmailOptions, function (value, state, options) {

            Isemail = Isemail || __webpack_require__(16);

            try {
                var result = Isemail.validate(value, isEmailOptions);
                if (result === true || result === 0) {
                    return value;
                }
            } catch (e) {}

            return this.createError('string.email', { value: value }, state, options);
        });
    };

    _class.prototype.ip = function ip() {
        var ipOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


        var regex = internals.ipRegex;
        Hoek.assert((typeof ipOptions === 'undefined' ? 'undefined' : _typeof(ipOptions)) === 'object', 'options must be an object');

        if (ipOptions.cidr) {
            Hoek.assert(typeof ipOptions.cidr === 'string', 'cidr must be a string');
            ipOptions.cidr = ipOptions.cidr.toLowerCase();

            Hoek.assert(Hoek.contain(internals.cidrPresences, ipOptions.cidr), 'cidr must be one of ' + internals.cidrPresences.join(', '));

            // If we only received a `cidr` setting, create a regex for it. But we don't need to create one if `cidr` is "optional" since that is the default
            if (!ipOptions.version && ipOptions.cidr !== 'optional') {
                regex = Ip.createIpRegex(['ipv4', 'ipv6', 'ipvfuture'], ipOptions.cidr);
            }
        } else {

            // Set our default cidr strategy
            ipOptions.cidr = 'optional';
        }

        var versions = void 0;
        if (ipOptions.version) {
            if (!Array.isArray(ipOptions.version)) {
                ipOptions.version = [ipOptions.version];
            }

            Hoek.assert(ipOptions.version.length >= 1, 'version must have at least 1 version specified');

            versions = [];
            for (var i = 0; i < ipOptions.version.length; ++i) {
                var version = ipOptions.version[i];
                Hoek.assert(typeof version === 'string', 'version at position ' + i + ' must be a string');
                version = version.toLowerCase();
                Hoek.assert(Ip.versions[version], 'version at position ' + i + ' must be one of ' + Object.keys(Ip.versions).join(', '));
                versions.push(version);
            }

            // Make sure we have a set of versions
            versions = Hoek.unique(versions);

            regex = Ip.createIpRegex(versions, ipOptions.cidr);
        }

        return this._test('ip', ipOptions, function (value, state, options) {

            if (regex.test(value)) {
                return value;
            }

            if (versions) {
                return this.createError('string.ipVersion', { value: value, cidr: ipOptions.cidr, version: versions }, state, options);
            }

            return this.createError('string.ip', { value: value, cidr: ipOptions.cidr }, state, options);
        });
    };

    _class.prototype.uri = function uri(uriOptions) {

        var customScheme = '';
        var allowRelative = false;
        var relativeOnly = false;
        var regex = internals.uriRegex;

        if (uriOptions) {
            Hoek.assert((typeof uriOptions === 'undefined' ? 'undefined' : _typeof(uriOptions)) === 'object', 'options must be an object');

            if (uriOptions.scheme) {
                Hoek.assert(uriOptions.scheme instanceof RegExp || typeof uriOptions.scheme === 'string' || Array.isArray(uriOptions.scheme), 'scheme must be a RegExp, String, or Array');

                if (!Array.isArray(uriOptions.scheme)) {
                    uriOptions.scheme = [uriOptions.scheme];
                }

                Hoek.assert(uriOptions.scheme.length >= 1, 'scheme must have at least 1 scheme specified');

                // Flatten the array into a string to be used to match the schemes.
                for (var i = 0; i < uriOptions.scheme.length; ++i) {
                    var scheme = uriOptions.scheme[i];
                    Hoek.assert(scheme instanceof RegExp || typeof scheme === 'string', 'scheme at position ' + i + ' must be a RegExp or String');

                    // Add OR separators if a value already exists
                    customScheme = customScheme + (customScheme ? '|' : '');

                    // If someone wants to match HTTP or HTTPS for example then we need to support both RegExp and String so we don't escape their pattern unknowingly.
                    if (scheme instanceof RegExp) {
                        customScheme = customScheme + scheme.source;
                    } else {
                        Hoek.assert(/[a-zA-Z][a-zA-Z0-9+-\.]*/.test(scheme), 'scheme at position ' + i + ' must be a valid scheme');
                        customScheme = customScheme + Hoek.escapeRegex(scheme);
                    }
                }
            }

            if (uriOptions.allowRelative) {
                allowRelative = true;
            }

            if (uriOptions.relativeOnly) {
                relativeOnly = true;
            }
        }

        if (customScheme || allowRelative || relativeOnly) {
            regex = Uri.createUriRegex(customScheme, allowRelative, relativeOnly);
        }

        return this._test('uri', uriOptions, function (value, state, options) {

            if (regex.test(value)) {
                return value;
            }

            if (relativeOnly) {
                return this.createError('string.uriRelativeOnly', { value: value }, state, options);
            }

            if (customScheme) {
                return this.createError('string.uriCustomScheme', { scheme: customScheme, value: value }, state, options);
            }

            return this.createError('string.uri', { value: value }, state, options);
        });
    };

    _class.prototype.isoDate = function isoDate() {

        return this._test('isoDate', undefined, function (value, state, options) {

            if (JoiDate._isIsoDate(value)) {
                if (!options.convert) {
                    return value;
                }

                var d = new Date(value);
                if (!isNaN(d.getTime())) {
                    return d.toISOString();
                }
            }

            return this.createError('string.isoDate', { value: value }, state, options);
        });
    };

    _class.prototype.guid = function guid(guidOptions) {

        var versionNumbers = '';

        if (guidOptions && guidOptions.version) {
            if (!Array.isArray(guidOptions.version)) {
                guidOptions.version = [guidOptions.version];
            }

            Hoek.assert(guidOptions.version.length >= 1, 'version must have at least 1 valid version specified');
            var versions = new Set();

            for (var i = 0; i < guidOptions.version.length; ++i) {
                var version = guidOptions.version[i];
                Hoek.assert(typeof version === 'string', 'version at position ' + i + ' must be a string');
                version = version.toLowerCase();
                var versionNumber = internals.guidVersions[version];
                Hoek.assert(versionNumber, 'version at position ' + i + ' must be one of ' + Object.keys(internals.guidVersions).join(', '));
                Hoek.assert(!versions.has(versionNumber), 'version at position ' + i + ' must not be a duplicate.');

                versionNumbers += versionNumber;
                versions.add(versionNumber);
            }
        }

        var guidRegex = new RegExp('^([\\[{\\(]?)[0-9A-F]{8}([:-]?)[0-9A-F]{4}\\2?[' + (versionNumbers || '0-9A-F') + '][0-9A-F]{3}\\2?[' + (versionNumbers ? '89AB' : '0-9A-F') + '][0-9A-F]{3}\\2?[0-9A-F]{12}([\\]}\\)]?)$', 'i');

        return this._test('guid', guidOptions, function (value, state, options) {

            var results = guidRegex.exec(value);

            if (!results) {
                return this.createError('string.guid', { value: value }, state, options);
            }

            // Matching braces
            if (internals.guidBrackets[results[1]] !== results[results.length - 1]) {
                return this.createError('string.guid', { value: value }, state, options);
            }

            return value;
        });
    };

    _class.prototype.hex = function hex() {

        var regex = /^[a-f0-9]+$/i;

        return this._test('hex', regex, function (value, state, options) {

            if (regex.test(value)) {
                return value;
            }

            return this.createError('string.hex', { value: value }, state, options);
        });
    };

    _class.prototype.base64 = function base64() {
        var base64Options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


        // Validation.
        Hoek.assert((typeof base64Options === 'undefined' ? 'undefined' : _typeof(base64Options)) === 'object', 'base64 options must be an object');
        Hoek.assert(typeof base64Options.paddingRequired === 'undefined' || typeof base64Options.paddingRequired === 'boolean', 'paddingRequired must be boolean');

        // Determine if padding is required.
        var paddingRequired = base64Options.paddingRequired === false ? base64Options.paddingRequired : base64Options.paddingRequired || true;

        // Set validation based on preference.
        var regex = paddingRequired ?
        // Padding is required.
        /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/
        // Padding is optional.
        : /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}(==)?|[A-Za-z0-9+\/]{3}=?)?$/;

        return this._test('base64', regex, function (value, state, options) {

            if (regex.test(value)) {
                return value;
            }

            return this.createError('string.base64', { value: value }, state, options);
        });
    };

    _class.prototype.hostname = function hostname() {

        var regex = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/;

        return this._test('hostname', undefined, function (value, state, options) {

            if (value.length <= 255 && regex.test(value) || Net.isIPv6(value)) {

                return value;
            }

            return this.createError('string.hostname', { value: value }, state, options);
        });
    };

    _class.prototype.normalize = function normalize() {
        var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'NFC';


        Hoek.assert(Hoek.contain(internals.normalizationForms, form), 'normalization form must be one of ' + internals.normalizationForms.join(', '));

        var obj = this._test('normalize', form, function (value, state, options) {

            if (options.convert || value === value.normalize(form)) {

                return value;
            }

            return this.createError('string.normalize', { value: value, form: form }, state, options);
        });

        obj._flags.normalize = form;
        return obj;
    };

    _class.prototype.lowercase = function lowercase() {

        var obj = this._test('lowercase', undefined, function (value, state, options) {

            if (options.convert || value === value.toLocaleLowerCase()) {

                return value;
            }

            return this.createError('string.lowercase', { value: value }, state, options);
        });

        obj._flags.case = 'lower';
        return obj;
    };

    _class.prototype.uppercase = function uppercase() {

        var obj = this._test('uppercase', undefined, function (value, state, options) {

            if (options.convert || value === value.toLocaleUpperCase()) {

                return value;
            }

            return this.createError('string.uppercase', { value: value }, state, options);
        });

        obj._flags.case = 'upper';
        return obj;
    };

    _class.prototype.trim = function trim() {

        var obj = this._test('trim', undefined, function (value, state, options) {

            if (options.convert || value === value.trim()) {

                return value;
            }

            return this.createError('string.trim', { value: value }, state, options);
        });

        obj._flags.trim = true;
        return obj;
    };

    _class.prototype.replace = function replace(pattern, replacement) {

        if (typeof pattern === 'string') {
            pattern = new RegExp(Hoek.escapeRegex(pattern), 'g');
        }

        Hoek.assert(pattern instanceof RegExp, 'pattern must be a RegExp');
        Hoek.assert(typeof replacement === 'string', 'replacement must be a String');

        // This can not be considere a test like trim, we can't "reject"
        // anything from this rule, so just clone the current object
        var obj = this.clone();

        if (!obj._inner.replacements) {
            obj._inner.replacements = [];
        }

        obj._inner.replacements.push({
            pattern: pattern,
            replacement: replacement
        });

        return obj;
    };

    _class.prototype.truncate = function truncate(enabled) {

        var value = enabled === undefined ? true : !!enabled;

        if (this._flags.truncate === value) {
            return this;
        }

        var obj = this.clone();
        obj._flags.truncate = value;
        return obj;
    };

    return _class;
}(Any);

internals.compare = function (type, compare) {

    return function (limit, encoding) {

        var isRef = Ref.isRef(limit);

        Hoek.assert(Number.isSafeInteger(limit) && limit >= 0 || isRef, 'limit must be a positive integer or reference');
        Hoek.assert(!encoding || Buffer.isEncoding(encoding), 'Invalid encoding:', encoding);

        return this._test(type, limit, function (value, state, options) {

            var compareTo = void 0;
            if (isRef) {
                compareTo = limit(state.reference || state.parent, options);

                if (!Number.isSafeInteger(compareTo)) {
                    return this.createError('string.ref', { ref: limit.key }, state, options);
                }
            } else {
                compareTo = limit;
            }

            if (compare(value, compareTo, encoding)) {
                return value;
            }

            return this.createError('string.' + type, { limit: compareTo, value: value, encoding: encoding }, state, options);
        });
    };
};

internals.String.prototype.min = internals.compare('min', function (value, limit, encoding) {

    var length = encoding ? Buffer.byteLength(value, encoding) : value.length;
    return length >= limit;
});

internals.String.prototype.max = internals.compare('max', function (value, limit, encoding) {

    var length = encoding ? Buffer.byteLength(value, encoding) : value.length;
    return length <= limit;
});

internals.String.prototype.length = internals.compare('length', function (value, limit, encoding) {

    var length = encoding ? Buffer.byteLength(value, encoding) : value.length;
    return length === limit;
});

// Aliases

internals.String.prototype.uuid = internals.String.prototype.guid;

module.exports = new internals.String();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var RFC3986 = __webpack_require__(13);

// Declare internals

var internals = {
    Ip: {
        cidrs: {
            ipv4: {
                required: '\\/(?:' + RFC3986.ipv4Cidr + ')',
                optional: '(?:\\/(?:' + RFC3986.ipv4Cidr + '))?',
                forbidden: ''
            },
            ipv6: {
                required: '\\/' + RFC3986.ipv6Cidr,
                optional: '(?:\\/' + RFC3986.ipv6Cidr + ')?',
                forbidden: ''
            },
            ipvfuture: {
                required: '\\/' + RFC3986.ipv6Cidr,
                optional: '(?:\\/' + RFC3986.ipv6Cidr + ')?',
                forbidden: ''
            }
        },
        versions: {
            ipv4: RFC3986.IPv4address,
            ipv6: RFC3986.IPv6address,
            ipvfuture: RFC3986.IPvFuture
        }
    }
};

internals.Ip.createIpRegex = function (versions, cidr) {

    var regex = void 0;
    for (var i = 0; i < versions.length; ++i) {
        var version = versions[i];
        if (!regex) {
            regex = '^(?:' + internals.Ip.versions[version] + internals.Ip.cidrs[version][cidr];
        } else {
            regex += '|' + internals.Ip.versions[version] + internals.Ip.cidrs[version][cidr];
        }
    }

    return new RegExp(regex + ')$');
};

module.exports = internals.Ip;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load Modules

var RFC3986 = __webpack_require__(13);

// Declare internals

var internals = {
    Uri: {
        createUriRegex: function createUriRegex(optionalScheme, allowRelative, relativeOnly) {

            var scheme = RFC3986.scheme;
            var prefix = void 0;

            if (relativeOnly) {
                prefix = '(?:' + RFC3986.relativeRef + ')';
            } else {
                // If we were passed a scheme, use it instead of the generic one
                if (optionalScheme) {

                    // Have to put this in a non-capturing group to handle the OR statements
                    scheme = '(?:' + optionalScheme + ')';
                }

                var withScheme = '(?:' + scheme + ':' + RFC3986.hierPart + ')';

                prefix = allowRelative ? '(?:' + withScheme + '|' + RFC3986.relativeRef + ')' : withScheme;
            }

            /**
             * URI = scheme ":" hier-part [ "?" query ] [ "#" fragment ]
             *
             * OR
             *
             * relative-ref = relative-part [ "?" query ] [ "#" fragment ]
             */
            return new RegExp('^' + prefix + '(?:\\?' + RFC3986.query + ')?' + '(?:#' + RFC3986.fragment + ')?$');
        }
    }
};

module.exports = internals.Uri;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load modules

var Hoek = __webpack_require__(0);

// Declare internals

var internals = {};

exports = module.exports = internals.Topo = function () {

    this._items = [];
    this.nodes = [];
};

internals.Topo.prototype.add = function (nodes, options) {
    var _this = this;

    options = options || {};

    // Validate rules

    var before = [].concat(options.before || []);
    var after = [].concat(options.after || []);
    var group = options.group || '?';
    var sort = options.sort || 0; // Used for merging only

    Hoek.assert(before.indexOf(group) === -1, 'Item cannot come before itself:', group);
    Hoek.assert(before.indexOf('?') === -1, 'Item cannot come before unassociated items');
    Hoek.assert(after.indexOf(group) === -1, 'Item cannot come after itself:', group);
    Hoek.assert(after.indexOf('?') === -1, 'Item cannot come after unassociated items');

    [].concat(nodes).forEach(function (node, i) {

        var item = {
            seq: _this._items.length,
            sort: sort,
            before: before,
            after: after,
            group: group,
            node: node
        };

        _this._items.push(item);
    });

    // Insert event

    var error = this._sort();
    Hoek.assert(!error, 'item', group !== '?' ? 'added into group ' + group : '', 'created a dependencies error');

    return this.nodes;
};

internals.Topo.prototype.merge = function (others) {

    others = [].concat(others);
    for (var i = 0; i < others.length; ++i) {
        var other = others[i];
        if (other) {
            for (var j = 0; j < other._items.length; ++j) {
                var item = Hoek.shallow(other._items[j]);
                this._items.push(item);
            }
        }
    }

    // Sort items

    this._items.sort(internals.mergeSort);
    for (var _i = 0; _i < this._items.length; ++_i) {
        this._items[_i].seq = _i;
    }

    var error = this._sort();
    Hoek.assert(!error, 'merge created a dependencies error');

    return this.nodes;
};

internals.mergeSort = function (a, b) {

    return a.sort === b.sort ? 0 : a.sort < b.sort ? -1 : 1;
};

internals.Topo.prototype._sort = function () {

    // Construct graph

    var graph = {};
    var graphAfters = Object.create(null); // A prototype can bungle lookups w/ false positives
    var groups = Object.create(null);

    for (var i = 0; i < this._items.length; ++i) {
        var item = this._items[i];
        var seq = item.seq; // Unique across all items
        var group = item.group;

        // Determine Groups

        groups[group] = groups[group] || [];
        groups[group].push(seq);

        // Build intermediary graph using 'before'

        graph[seq] = item.before;

        // Build second intermediary graph with 'after'

        var after = item.after;
        for (var j = 0; j < after.length; ++j) {
            graphAfters[after[j]] = (graphAfters[after[j]] || []).concat(seq);
        }
    }

    // Expand intermediary graph

    var graphNodes = Object.keys(graph);
    for (var _i2 = 0; _i2 < graphNodes.length; ++_i2) {
        var node = graphNodes[_i2];
        var expandedGroups = [];

        var graphNodeItems = Object.keys(graph[node]);
        for (var _j = 0; _j < graphNodeItems.length; ++_j) {
            var _group = graph[node][graphNodeItems[_j]];
            groups[_group] = groups[_group] || [];

            for (var k = 0; k < groups[_group].length; ++k) {
                expandedGroups.push(groups[_group][k]);
            }
        }
        graph[node] = expandedGroups;
    }

    // Merge intermediary graph using graphAfters into final graph

    var afterNodes = Object.keys(graphAfters);
    for (var _i3 = 0; _i3 < afterNodes.length; ++_i3) {
        var _group2 = afterNodes[_i3];

        if (groups[_group2]) {
            for (var _j2 = 0; _j2 < groups[_group2].length; ++_j2) {
                var _node = groups[_group2][_j2];
                graph[_node] = graph[_node].concat(graphAfters[_group2]);
            }
        }
    }

    // Compile ancestors

    var children = void 0;
    var ancestors = {};
    graphNodes = Object.keys(graph);
    for (var _i4 = 0; _i4 < graphNodes.length; ++_i4) {
        var _node2 = graphNodes[_i4];
        children = graph[_node2];

        for (var _j3 = 0; _j3 < children.length; ++_j3) {
            ancestors[children[_j3]] = (ancestors[children[_j3]] || []).concat(_node2);
        }
    }

    // Topo sort

    var visited = {};
    var sorted = [];

    for (var _i5 = 0; _i5 < this._items.length; ++_i5) {
        // Really looping thru item.seq values out of order
        var next = _i5;

        if (ancestors[_i5]) {
            next = null;
            for (var _j4 = 0; _j4 < this._items.length; ++_j4) {
                // As above, these are item.seq values
                if (visited[_j4] === true) {
                    continue;
                }

                if (!ancestors[_j4]) {
                    ancestors[_j4] = [];
                }

                var shouldSeeCount = ancestors[_j4].length;
                var seenCount = 0;
                for (var _k = 0; _k < shouldSeeCount; ++_k) {
                    if (visited[ancestors[_j4][_k]]) {
                        ++seenCount;
                    }
                }

                if (seenCount === shouldSeeCount) {
                    next = _j4;
                    break;
                }
            }
        }

        if (next !== null) {
            visited[next] = true;
            sorted.push(next);
        }
    }

    if (sorted.length !== this._items.length) {
        return new Error('Invalid dependencies');
    }

    var seqIndex = {};
    for (var _i6 = 0; _i6 < this._items.length; ++_i6) {
        var _item = this._items[_i6];
        seqIndex[_item.seq] = _item;
    }

    var sortedNodes = [];
    this._items = sorted.map(function (value) {

        var sortedItem = seqIndex[value];
        sortedNodes.push(sortedItem.node);
        return sortedItem;
    });

    this.nodes = sortedNodes;
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Joi = __webpack_require__(8);

module.exports = Joi;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 31 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = {"_args":[["joi@13.0.1","/Users/jeff/projects/joi-browser"]],"_development":true,"_from":"joi@13.0.1","_id":"joi@13.0.1","_inBundle":false,"_integrity":"sha512-ChTMfmbIg5yrN9pUdeaLL8vzylMQhUteXiXa1MWINsMUs3jTQ8I87lUZwR5GdfCLJlpK04U7UgrxgmU8Zp7PhQ==","_location":"/joi","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"joi@13.0.1","name":"joi","escapedName":"joi","rawSpec":"13.0.1","saveSpec":null,"fetchSpec":"13.0.1"},"_requiredBy":["#DEV:/"],"_resolved":"https://registry.npmjs.org/joi/-/joi-13.0.1.tgz","_spec":"13.0.1","_where":"/Users/jeff/projects/joi-browser","bugs":{"url":"https://github.com/hapijs/joi/issues"},"dependencies":{"hoek":"5.x.x","isemail":"3.x.x","topo":"3.x.x"},"description":"Object schema validation","devDependencies":{"hapitoc":"1.x.x","lab":"14.x.x"},"engines":{"node":">=8.3.0"},"homepage":"https://github.com/hapijs/joi","keywords":["hapi","schema","validation"],"license":"BSD-3-Clause","main":"lib/index.js","name":"joi","repository":{"type":"git","url":"git://github.com/hapijs/joi.git"},"scripts":{"test":"lab -t 100 -a code -L","test-cov-html":"lab -r html -o coverage.html -a code","test-debug":"lab -a code","toc":"hapitoc","version":"npm run toc && git add API.md README.md"},"version":"13.0.1"}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


exports.basename = function(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


exports.extname = function(path) {
  return splitPath(path)[3];
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module), __webpack_require__(7)))

/***/ }),
/* 36 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(37);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(36);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(5)))

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ })
/******/ ]);
});

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.7.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var toPath = __webpack_require__(1871),
    isArray = __webpack_require__(977);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  var type = typeof value;
  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
    return true;
  }
  if (isArray(value)) {
    return false;
  }
  var result = !reIsDeepProp.test(value);
  return result || (object != null && value in toObject(object));
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Sets the property value of `path` on `object`. If a portion of `path`
 * does not exist it is created.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to augment.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, 'x[0].y.z', 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  if (object == null) {
    return object;
  }
  var pathKey = (path + '');
  path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = path[index];
    if (isObject(nested)) {
      if (index == lastIndex) {
        nested[key] = value;
      } else if (nested[key] == null) {
        nested[key] = isIndex(path[index + 1]) ? [] : {};
      }
    }
    nested = nested[key];
  }
  return object;
}

module.exports = set;


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.8.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArray = __webpack_require__(977);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  return value == null ? '' : (value + '');
}

/**
 * Converts `value` to property path array if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */
function toPath(value) {
  if (isArray(value)) {
    return value;
  }
  var result = [];
  baseToString(value).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

module.exports = toPath;


/***/ }),
/* 1872 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defined = __webpack_require__(2794);

var _defined2 = _interopRequireDefault(_defined);

var _isSome = __webpack_require__(1875);

var _isSome2 = _interopRequireDefault(_isSome);

var _flattenErrorsObject = __webpack_require__(2795);

var _flattenErrorsObject2 = _interopRequireDefault(_flattenErrorsObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  defined: _defined2.default,
  isSome: _isSome2.default,
  flattenErrorsObject: _flattenErrorsObject2.default
};

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isSome;
function isSome(item) {
  for (var _len = arguments.length, tests = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    tests[_key - 1] = arguments[_key];
  }

  if (Array.isArray(tests)) {
    return tests.some(function (test) {
      return item === test;
    });
  }
  return false;
}

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array ? array.length : 0;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = flatten;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initDashboard = exports.closeOnboardingDialog = exports.showOnboardingDialog = exports.appInitSuccess = undefined;

var _userActions = __webpack_require__(868);

var _actions = __webpack_require__(1115);

var _settingsActions = __webpack_require__(976);

var _constants = __webpack_require__(1840);

var appInitSuccess = exports.appInitSuccess = function appInitSuccess() {
  return {
    type: _constants.DASHBOARD_INITIALIZE_SUCCESS
  };
};

var showOnboardingDialog = exports.showOnboardingDialog = function showOnboardingDialog() {
  return {
    type: _constants.DASHBOARD_SHOW_ONBOARDING_DIALOG
  };
};

var closeOnboardingDialog = exports.closeOnboardingDialog = function closeOnboardingDialog() {
  return {
    type: _constants.DASHBOARD_CLOSE_ONBOARDING_DIALOG
  };
};

var initDashboard = exports.initDashboard = function initDashboard() {
  return function (dispatch) {
    return dispatch((0, _userActions.getUser)()).then(function (res) {
      [_actions.getMarketingMaterials.bind(undefined, res.user.user.userID), _settingsActions.hydrateFromServer].forEach(function (fn) {
        return dispatch(fn());
      });
    }).then(function () {
      return dispatch(appInitSuccess());
    });
  };
};

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Dependenceis

// Components


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _materialUi = __webpack_require__(3);

var _ClickAwayListener = __webpack_require__(853);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropDown = (0, _react.createClass)({
  propTypes: {
    toggleZIndex: _react.PropTypes.func,
    payload: _react.PropTypes.string,
    acceptConnection: _react.PropTypes.func,
    ignoreConnection: _react.PropTypes.func,
    iconClassName: _react.PropTypes.string,
    tooltip: _react.PropTypes.bool,
    options: _react.PropTypes.array,
    className: _react.PropTypes.string,
    isRequest: _react.PropTypes.bool,
    label: _react.PropTypes.string,
    componentClassName: _react.PropTypes.string,
    style: _react.PropTypes.object
  },

  getInitialState: function getInitialState() {
    return {
      showDropDown: false,
      isOnNestedMultiselect: false,
      menuMap: []
    };
  },
  _toggleZIndex: function _toggleZIndex() {
    if (this.props.toggleZIndex) this.props.toggleZIndex();
  },
  componentClickAway: function componentClickAway() {
    if (this.state.showDropDown) {
      this._toggleZIndex();
    }
    this._resetState();
  },
  _resetState: function _resetState() {
    this.setState(this.getInitialState());
  },
  actionButtonClicked: function actionButtonClicked() {
    var _this = this;

    this.setState({
      showDropDown: !this.state.showDropDown
    }, function () {
      return _this._toggleZIndex();
    });
  },
  optionClicked: function optionClicked(option, index) {
    switch (option.type) {
      case 'nestedmenu':
        // show the other menu
        this.state.menuMap.push(index);
        this.setState({
          menuMap: this.state.menuMap,
          isOnNestedMultiselect: option.isOnNestedMultiselect
        });
        break;

      default:
        if (option.action) {
          option.action.call(this, this.props.payload);
        }
        if (!option.leaveMenuOpen) {
          this._toggleZIndex();
          this._resetState();
        }
        break;
    }
  },
  acceptConnection: function acceptConnection() {
    this.props.acceptConnection(this.props.payload);
  },
  ignoreConnection: function ignoreConnection() {
    this.props.ignoreConnection(this.props.payload);
  },
  _showPrevious: function _showPrevious() {
    this.state.menuMap.pop();
    this.setState({
      menuMap: this.state.menuMap,
      isOnNestedMultiselect: false
    });
  },
  render: function render() {
    var _this2 = this;

    var acceptButton = void 0;
    var rejectButton = void 0;
    var iconClassName = this.props.iconClassName || 'tc-icon-more-vert';
    var tooltip = this.props.tooltip === false ? undefined : 'More Actions';

    var menuToDisplay = this.props.options;
    var menuText = void 0;
    var filterIcon = void 0;
    this.state.menuMap.forEach(function (index) {
      menuText = menuToDisplay[index].text;
      menuToDisplay = menuToDisplay[index].subOptions;
    });

    var menu = menuToDisplay.map(function (option, index) {
      return _react2.default.createElement(
        'div',
        {
          onClick: function onClick() {
            return _this2.optionClicked(option, index);
          },
          className: 'connections-action-drop-down-link',
          key: index
        },
        ' ',
        option.text,
        ' ',
        option.icon,
        ' '
      );
    });
    var classes = (0, _classnames2.default)('connections-action-drop-down', this.props.className, {
      'is-closed': !this.state.showDropDown,
      'is-vert-multi-select': this.state.isOnNestedMultiselect
    });
    var previousButton = this.state.menuMap.length ? _react2.default.createElement(
      'div',
      { onClick: this._showPrevious, className: 'connections-action-drop-down-link' },
      ' ',
      _react2.default.createElement(_icon2.default, { className: 'tc-icon-chevron-left' }),
      menuText
    ) : null;

    if (this.props.isRequest) {
      acceptButton = _react2.default.createElement(_materialUi.RaisedButton, {
        backgroundColor: 'green',
        labelStyle: { color: 'white' },
        onTouchTap: this.acceptConnection,
        label: 'Add Partner'
      });
      rejectButton = _react2.default.createElement(_materialUi.RaisedButton, { primary: true, onTouchTap: this.ignoreConnection, label: 'Reject' });
    }

    if (this.props.label) {
      filterIcon = _react2.default.createElement(
        'div',
        { className: 'more-vert-label', onClick: this.actionButtonClicked },
        this.props.label
      );
    } else {
      filterIcon = _react2.default.createElement(_materialUi.IconButton, {
        iconClassName: iconClassName,
        style: { zIndex: 0 },
        onTouchTap: this.actionButtonClicked,
        tooltip: tooltip
      });
    }
    return _react2.default.createElement(
      _ClickAwayListener2.default,
      { onClickAway: this.componentClickAway },
      _react2.default.createElement(
        'div',
        {
          className: this.props.componentClassName,
          style: _extends({}, this.props.style, { display: 'flex', position: 'relative', zIndex: 0 })
        },
        _react2.default.createElement(
          'div',
          { style: { marginTop: '6px' } },
          rejectButton,
          '\xA0\xA0',
          acceptButton
        ),
        _react2.default.createElement(
          'div',
          { className: classes },
          _react2.default.createElement(
            _materialUi.Paper,
            { style: { padding: '8px 16px' } },
            _react2.default.createElement(
              'div',
              { className: 'connections-action-container' },
              previousButton,
              menu
            )
          )
        ),
        filterIcon
      )
    );
  }
});

exports.default = DropDown;

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  _createClass(Input, [{
    key: "onClick",
    value: function onClick() {
      if (this.props.onClick) this.props.onClick();
    }
  }, {
    key: "render",
    value: function render() {
      var error = this.props.error ? _react2.default.createElement(
        "div",
        { className: "error-message" },
        this.props.error
      ) : undefined;
      return _react2.default.createElement(
        "div",
        { className: "input-container" },
        _react2.default.createElement("input", this.props),
        error
      );
    }
  }]);

  return Input;
}(_react.Component);

Input.propTypes = {
  error: _react.PropTypes.string,
  onClick: _react.PropTypes.func
};

exports.default = Input;

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTempConnectionsProps = updateTempConnectionsProps;
exports.getTempConnections = getTempConnections;
exports.sendTempConnections = sendTempConnections;
exports.sendEmailToTempConnectionsStarting = sendEmailToTempConnectionsStarting;
exports.sendEmailToTempConnections = sendEmailToTempConnections;
exports.deleteTempConnections = deleteTempConnections;
exports.cancelCSVHeaderSelection = cancelCSVHeaderSelection;
exports.convertFromCSV = convertFromCSV;
exports.cancelCurrentCSVSelection = cancelCurrentCSVSelection;
exports.acceptCurrentCSVSelection = acceptCurrentCSVSelection;
exports.isPersistedFromServer = isPersistedFromServer;
exports.addAnotherConnection = addAnotherConnection;
exports.removeInvitation = removeInvitation;
exports.changeCollectionItemValue = changeCollectionItemValue;
exports.changeEmailValue = changeEmailValue;

var _soFetch = __webpack_require__(254);

var _tempConnectionsConstants = __webpack_require__(1841);

var constants = _interopRequireWildcard(_tempConnectionsConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function updateTempConnectionsProps(payload) {
  return { type: constants.UPDATE_TEMP_CONN_PROP, payload: payload };
}

function getTempConnections() {
  return (0, _soFetch.soFetch)('/proxy/temp-invitation', {
    actionType: constants.RECEIVE_ADD_CONNECTIONS,
    responseBinding: 'payload'
  });
}

function sendTempConnections(connections) {
  return (0, _soFetch.soFetch)('/proxy/temp-invitation', {
    method: 'post',
    body: { invitations: connections },
    actionType: constants.SEND_TEMP_CONNECTIONS,
    responseBinding: 'payload'
  });
}

function sendEmailToTempConnectionsStarting() {
  return { type: constants.SEND_EMAIL_TO_TEMP_CONNECTIONS_STARTING };
}

function sendEmailToTempConnections(message) {
  return (0, _soFetch.soFetch)('/proxy/temp-invitation/send', {
    method: 'put',
    body: { message: message },
    actionType: constants.SEND_EMAIL_TO_TEMP_CONNECTIONS,
    responseBinding: 'payload'
  });
}

function deleteTempConnections() {
  return (0, _soFetch.soFetch)('/proxy/temp-invitation/delete', {
    method: 'delete',
    actionType: constants.DELETED_TEMP_CONNECTIONS,
    responseBinding: 'connections'
  });
}

function cancelCSVHeaderSelection() {
  return {
    type: constants.CANCEL_CSV_HEADER_SELECTION
  };
}

function convertFromCSV(fileContents) {
  return {
    type: constants.CONVERT_FROM_CSV,
    payload: fileContents
  };
}

function cancelCurrentCSVSelection() {
  return {
    type: constants.CANCELED_CSV_SELECTION
  };
}

function acceptCurrentCSVSelection() {
  return {
    type: constants.ACCEPTED_CSV_SELECTION
  };
}

function isPersistedFromServer() {
  return {
    type: constants.IS_PERSISTED_FROM_SERVER
  };
}

function addAnotherConnection() {
  return {
    type: constants.NEW_ADD_CONNECTIONS
  };
}

function removeInvitation(mapKey) {
  return {
    type: constants.REMOVE_ADD_INVITATION,
    payload: mapKey
  };
}

function changeCollectionItemValue(mapKey, valueKey, value) {
  return {
    type: constants.CHANGE_NEW_CONNECTION_VALUE,
    payload: {
      mapKey: mapKey,
      valueKey: valueKey,
      value: value
    }
  };
}

function changeEmailValue(value) {
  return {
    type: constants.CHANGE_EMAIL_VALUE,
    payload: value
  };
}

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = DragDropContext;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1230);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dndCore = __webpack_require__(2856);

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _hoistNonReactStatics = __webpack_require__(503);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _checkDecoratorArguments = __webpack_require__(1243);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
  dragDropManager: _propTypes2.default.object.isRequired
};

var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
  return {
    dragDropManager: new _dndCore.DragDropManager(backend, context)
  };
};

var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
  // Auto-detect ES6 default export for people still using ES5
  var backend = backendOrModule;
  if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') {
    backend = backend.default;
  }
  (0, _invariant2.default)(typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html');
  return backend;
};

function DragDropContext(backendOrModule) {
  _checkDecoratorArguments2.default.apply(undefined, ['DragDropContext', 'backend'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params

  var backend = unpackBackendForEs5Users(backendOrModule);
  var childContext = createChildContext(backend);

  return function decorateContext(DecoratedComponent) {
    var _class, _temp;

    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

    var DragDropContextContainer = (_temp = _class = function (_Component) {
      _inherits(DragDropContextContainer, _Component);

      function DragDropContextContainer() {
        _classCallCheck(this, DragDropContextContainer);

        return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
      }

      _createClass(DragDropContextContainer, [{
        key: 'getDecoratedComponentInstance',
        value: function getDecoratedComponentInstance() {
          (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can ' + 'not be a stateless component.');
          return this.child;
        }
      }, {
        key: 'getManager',
        value: function getManager() {
          return childContext.dragDropManager;
        }
      }, {
        key: 'getChildContext',
        value: function getChildContext() {
          return childContext;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
            ref: function ref(child) {
              return _this2.child = child;
            }
          }));
        }
      }]);

      return DragDropContextContainer;
    }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);


    return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
  };
}

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1883 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = dragOffset;
exports.getSourceClientOffset = getSourceClientOffset;
exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;

var _dragDrop = __webpack_require__(1231);

var initialState = {
	initialSourceClientOffset: null,
	initialClientOffset: null,
	clientOffset: null
};

function areOffsetsEqual(offsetA, offsetB) {
	if (offsetA === offsetB) {
		return true;
	}
	return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}

function dragOffset() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case _dragDrop.BEGIN_DRAG:
			return {
				initialSourceClientOffset: action.sourceClientOffset,
				initialClientOffset: action.clientOffset,
				clientOffset: action.clientOffset
			};
		case _dragDrop.HOVER:
			if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
				return state;
			}
			return _extends({}, state, {
				clientOffset: action.clientOffset
			});
		case _dragDrop.END_DRAG:
		case _dragDrop.DROP:
			return initialState;
		default:
			return state;
	}
}

function getSourceClientOffset(state) {
	var clientOffset = state.clientOffset,
	    initialClientOffset = state.initialClientOffset,
	    initialSourceClientOffset = state.initialSourceClientOffset;

	if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
		return null;
	}
	return {
		x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
		y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
	};
}

function getDifferenceFromInitialOffset(state) {
	var clientOffset = state.clientOffset,
	    initialClientOffset = state.initialClientOffset;

	if (!clientOffset || !initialClientOffset) {
		return null;
	}
	return {
		x: clientOffset.x - initialClientOffset.x,
		y: clientOffset.y - initialClientOffset.y
	};
}

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = matchesType;

var _isArray = __webpack_require__(255);

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matchesType(targetType, draggedItemType) {
	if ((0, _isArray2.default)(targetType)) {
		return targetType.some(function (t) {
			return t === draggedItemType;
		});
	} else {
		return targetType === draggedItemType;
	}
}

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(1887),
    baseRest = __webpack_require__(875),
    isArrayLikeObject = __webpack_require__(1240);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1232),
    arrayIncludes = __webpack_require__(1237),
    arrayIncludesWith = __webpack_require__(1503),
    arrayMap = __webpack_require__(1238),
    baseUnary = __webpack_require__(1504),
    cacheHas = __webpack_require__(1239);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 1888 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1505);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(1000);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 1891 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = dirtyHandlerIds;
exports.areDirty = areDirty;

var _xor = __webpack_require__(2894);

var _xor2 = _interopRequireDefault(_xor);

var _intersection = __webpack_require__(2899);

var _intersection2 = _interopRequireDefault(_intersection);

var _dragDrop = __webpack_require__(1231);

var _registry = __webpack_require__(1241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NONE = [];
var ALL = [];

function dirtyHandlerIds() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
	var action = arguments[1];
	var dragOperation = arguments[2];

	switch (action.type) {
		case _dragDrop.HOVER:
			break;
		case _registry.ADD_SOURCE:
		case _registry.ADD_TARGET:
		case _registry.REMOVE_TARGET:
		case _registry.REMOVE_SOURCE:
			return NONE;
		case _dragDrop.BEGIN_DRAG:
		case _dragDrop.PUBLISH_DRAG_SOURCE:
		case _dragDrop.END_DRAG:
		case _dragDrop.DROP:
		default:
			return ALL;
	}

	var targetIds = action.targetIds;
	var prevTargetIds = dragOperation.targetIds;

	var result = (0, _xor2.default)(targetIds, prevTargetIds);

	var didChange = false;
	if (result.length === 0) {
		for (var i = 0; i < targetIds.length; i++) {
			if (targetIds[i] !== prevTargetIds[i]) {
				didChange = true;
				break;
			}
		}
	} else {
		didChange = true;
	}

	if (!didChange) {
		return NONE;
	}

	var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
	var innermostTargetId = targetIds[targetIds.length - 1];

	if (prevInnermostTargetId !== innermostTargetId) {
		if (prevInnermostTargetId) {
			result.push(prevInnermostTargetId);
		}
		if (innermostTargetId) {
			result.push(innermostTargetId);
		}
	}

	return result;
}

function areDirty(state, handlerIds) {
	if (state === NONE) {
		return false;
	}

	if (state === ALL || typeof handlerIds === 'undefined') {
		return true;
	}

	return (0, _intersection2.default)(handlerIds, state).length > 0;
}

/***/ }),
/* 1893 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1894 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1232),
    arrayIncludes = __webpack_require__(1237),
    arrayIncludesWith = __webpack_require__(1503),
    cacheHas = __webpack_require__(1239),
    createSet = __webpack_require__(2898),
    setToArray = __webpack_require__(1510);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(1000),
    root = __webpack_require__(550);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = shallowEqualScalar;
function shallowEqualScalar(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i += 1) {
    if (!hasOwn.call(objB, keysA[i])) {
      return false;
    }

    var valA = objA[keysA[i]];
    var valB = objB[keysA[i]];

    if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = decorateHandler;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1230);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _disposables = __webpack_require__(2912);

var _isPlainObject = __webpack_require__(999);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _hoistNonReactStatics = __webpack_require__(503);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _shallowEqual = __webpack_require__(1511);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _shallowEqualScalar = __webpack_require__(1897);

var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function decorateHandler(_ref) {
  var _class, _temp;

  var DecoratedComponent = _ref.DecoratedComponent,
      createHandler = _ref.createHandler,
      createMonitor = _ref.createMonitor,
      createConnector = _ref.createConnector,
      registerHandler = _ref.registerHandler,
      containerDisplayName = _ref.containerDisplayName,
      getType = _ref.getType,
      collect = _ref.collect,
      options = _ref.options;
  var _options$arePropsEqua = options.arePropsEqual,
      arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;

  var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

  var DragDropContainer = (_temp = _class = function (_Component) {
    _inherits(DragDropContainer, _Component);

    _createClass(DragDropContainer, [{
      key: 'getHandlerId',
      value: function getHandlerId() {
        return this.handlerId;
      }
    }, {
      key: 'getDecoratedComponentInstance',
      value: function getDecoratedComponentInstance() {
        return this.decoratedComponentInstance;
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
      }
    }]);

    function DragDropContainer(props, context) {
      _classCallCheck(this, DragDropContainer);

      var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));

      _this.handleChange = _this.handleChange.bind(_this);
      _this.handleChildRef = _this.handleChildRef.bind(_this);

      (0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);

      _this.manager = _this.context.dragDropManager;
      _this.handlerMonitor = createMonitor(_this.manager);
      _this.handlerConnector = createConnector(_this.manager.getBackend());
      _this.handler = createHandler(_this.handlerMonitor);

      _this.disposable = new _disposables.SerialDisposable();
      _this.receiveProps(props);
      _this.state = _this.getCurrentState();
      _this.dispose();
      return _this;
    }

    _createClass(DragDropContainer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.isCurrentlyMounted = true;
        this.disposable = new _disposables.SerialDisposable();
        this.currentType = null;
        this.receiveProps(this.props);
        this.handleChange();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!arePropsEqual(nextProps, this.props)) {
          this.receiveProps(nextProps);
          this.handleChange();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.dispose();
        this.isCurrentlyMounted = false;
      }
    }, {
      key: 'receiveProps',
      value: function receiveProps(props) {
        this.handler.receiveProps(props);
        this.receiveType(getType(props));
      }
    }, {
      key: 'receiveType',
      value: function receiveType(type) {
        if (type === this.currentType) {
          return;
        }

        this.currentType = type;

        var _registerHandler = registerHandler(type, this.handler, this.manager),
            handlerId = _registerHandler.handlerId,
            unregister = _registerHandler.unregister;

        this.handlerId = handlerId;
        this.handlerMonitor.receiveHandlerId(handlerId);
        this.handlerConnector.receiveHandlerId(handlerId);

        var globalMonitor = this.manager.getMonitor();
        var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });

        this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
      }
    }, {
      key: 'handleChange',
      value: function handleChange() {
        if (!this.isCurrentlyMounted) {
          return;
        }

        var nextState = this.getCurrentState();
        if (!(0, _shallowEqual2.default)(nextState, this.state)) {
          this.setState(nextState);
        }
      }
    }, {
      key: 'dispose',
      value: function dispose() {
        this.disposable.dispose();
        this.handlerConnector.receiveHandlerId(null);
      }
    }, {
      key: 'handleChildRef',
      value: function handleChildRef(component) {
        this.decoratedComponentInstance = component;
        this.handler.receiveComponent(component);
      }
    }, {
      key: 'getCurrentState',
      value: function getCurrentState() {
        var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);

        if (false) {
          (0, _invariant2.default)((0, _isPlainObject2.default)(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
        }

        return nextState;
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
          ref: this.handleChildRef
        }));
      }
    }]);

    return DragDropContainer;
  }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
    dragDropManager: _propTypes2.default.object.isRequired
  }, _temp);


  return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
}

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = wrapConnectorHooks;

var _react = __webpack_require__(0);

var _cloneWithRef = __webpack_require__(2920);

var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function throwIfCompositeComponentElement(element) {
  // Custom components can no longer be wrapped directly in React DnD 2.0
  // so that we don't need to depend on findDOMNode() from react-dom.
  if (typeof element.type === 'string') {
    return;
  }

  var displayName = element.type.displayName || element.type.name || 'the component';

  throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
}

function wrapHookToRecognizeElement(hook) {
  return function () {
    var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    // When passed a node, call the hook straight away.
    if (!(0, _react.isValidElement)(elementOrNode)) {
      var node = elementOrNode;
      hook(node, options);
      return undefined;
    }

    // If passed a ReactElement, clone it and attach this function as a ref.
    // This helps us achieve a neat API where user doesn't even know that refs
    // are being used under the hood.
    var element = elementOrNode;
    throwIfCompositeComponentElement(element);

    // When no options are passed, use the hook directly
    var ref = options ? function (node) {
      return hook(node, options);
    } : hook;

    return (0, _cloneWithRef2.default)(element, ref);
  };
}

function wrapConnectorHooks(hooks) {
  var wrappedHooks = {};

  Object.keys(hooks).forEach(function (key) {
    var hook = hooks[key];
    var wrappedHook = wrapHookToRecognizeElement(hook);
    wrappedHooks[key] = function () {
      return wrappedHook;
    };
  });

  return wrappedHooks;
}

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = areOptionsEqual;

var _shallowEqual = __webpack_require__(1511);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function areOptionsEqual(nextOptions, currentOptions) {
  if (currentOptions === nextOptions) {
    return true;
  }

  return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
}

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
       value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isValidType;

var _isArray = __webpack_require__(255);

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidType(type, allowArray) {
       return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function (t) {
              return isValidType(t, false);
       });
}

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmptyImage = exports.NativeTypes = undefined;
exports.default = createHTML5Backend;

var _HTML5Backend = __webpack_require__(2926);

var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);

var _getEmptyImage = __webpack_require__(2941);

var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);

var _NativeTypes = __webpack_require__(1514);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.NativeTypes = NativeTypes;
exports.getEmptyImage = _getEmptyImage2.default;
function createHTML5Backend(manager) {
  return new _HTML5Backend2.default(manager);
}

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(1133),
    isArrayLike = __webpack_require__(1053),
    isIndex = __webpack_require__(1244),
    isObject = __webpack_require__(735);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(2929),
    isArguments = __webpack_require__(1509),
    isArray = __webpack_require__(255),
    isBuffer = __webpack_require__(1905),
    isIndex = __webpack_require__(1244),
    isTypedArray = __webpack_require__(1906);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(550),
    stubFalse = __webpack_require__(2930);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)(module)))

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(2931),
    baseUnary = __webpack_require__(1504),
    nodeUtil = __webpack_require__(2932);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSafari = exports.isFirefox = undefined;

var _memoize = __webpack_require__(1908);

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
  return (/firefox/i.test(navigator.userAgent)
  );
});
var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
  return Boolean(window.safari);
});

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(1500);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _arrowForward = __webpack_require__(1246);

var _arrowForward2 = _interopRequireDefault(_arrowForward);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductStatus = function ProductStatus(props) {
  var mapping = props.mapping,
      exportResponses = props.exportResponses;

  var productName = props.product_name;
  var tourplanName = props.tourplan_name;
  var groupedByPriceCodes = function () {
    if (!exportResponses) return null;
    var gropuedByDateRange = {};
    Object.keys(exportResponses).forEach(function (k) {
      if (k.indexOf('Price Code') > -1 && exportResponses[k] === 200) {
        var dateRangeStr = k.split(', Price Code: ')[0];
        var priceCode = k.split(', Price Code: ')[1];
        if (gropuedByDateRange[dateRangeStr] && gropuedByDateRange[dateRangeStr].priceCodes) {
          gropuedByDateRange[dateRangeStr].priceCodes.push(priceCode);
        } else {
          gropuedByDateRange[dateRangeStr] = { priceCodes: [priceCode], status: 200 };
        }
      } else {
        gropuedByDateRange[k] = exportResponses[k];
      }
    });
    var result = {};
    Object.keys(gropuedByDateRange).forEach(function (k) {
      var obj = gropuedByDateRange[k];
      if (obj.status === 200) {
        if (obj.priceCodes.length) {
          result[k + ', Price Code(s): ' + obj.priceCodes.join(',')] = 200;
        } else result[k] = 200;
      } else {
        result[k] = obj;
      }
    });
    return result;
  }();
  return _react2.default.createElement(
    'span',
    { style: { display: 'block', margin: '5px 0' } },
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', alignItems: 'center' } },
      Array.isArray(productName) ? _react2.default.createElement(
        'div',
        { style: { whiteSpace: 'pre-wrap' } },
        productName.join('\n')
      ) : productName,
      _react2.default.createElement(_arrowForward2.default, { style: { fontSize: '15px', margin: '0 5px', top: '2px' }, color: "#c8c8c8" }),
      ' ' + tourplanName + ' (' + mapping + ')'
    ),
    _react2.default.createElement(
      'div',
      { style: { marginLeft: '12px', overflow: 'auto' } },
      groupedByPriceCodes ? Object.keys(groupedByPriceCodes).map(function (dateRangeAndPriceCodes, index) {
        var ok = groupedByPriceCodes[dateRangeAndPriceCodes] === 200;
        return _react2.default.createElement(
          'div',
          { key: index },
          _react2.default.createElement(_materialUi.FontIcon, { className: ok ? 'tc-icon-check' : 'tc-icon-close', color: ok ? '#00BCD4' : '#ff4081', style: { fontSize: '18px', top: '2px', marginRight: '5px' } }),
          dateRangeAndPriceCodes.indexOf('Notes') > -1 ? dateRangeAndPriceCodes : 'Date Range: ' + dateRangeAndPriceCodes + ' ',
          ok ? undefined : _react2.default.createElement(
            'span',
            { style: { color: '#ff4081' } },
            groupedByPriceCodes[dateRangeAndPriceCodes]
          )
        );
      }) : undefined
    )
  );
};

ProductStatus.propTypes = {
  product_name: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array]),
  tourplan_name: _react.PropTypes.string,
  mapping: _react.PropTypes.string,
  exportResponses: _react.PropTypes.object
};

module.exports = ProductStatus;

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDnd = __webpack_require__(1131);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var boxTarget = {
  drop: function drop(props) {
    return { position: props.position };
  }
};

var dragSourceFn = (0, _reactDnd.DropTarget)('DRAG_SOURCE', boxTarget, function (connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  };
});
var Target = function Target(props) {
  var canDrop = props.canDrop,
      isOver = props.isOver,
      connectDropTarget = props.connectDropTarget,
      inactiveStyle = props.inactiveStyle,
      inactiveClassName = props.inactiveClassName,
      activeStyle = props.activeStyle,
      activeClassName = props.activeClassName,
      canDropStyle = props.canDropStyle,
      canDropClassName = props.canDropClassName;

  var isActive = canDrop && isOver;

  var _ref = function () {
    if (isActive) return { style: activeStyle, className: activeClassName };
    if (canDrop) return { style: canDropStyle, className: canDropClassName };
    return { style: inactiveStyle, className: inactiveClassName };
  }(),
      style = _ref.style,
      className = _ref.className;

  return connectDropTarget(_react2.default.createElement(
    'div',
    { style: style, className: className },
    isActive ? 'Release to drop' : 'Drop here'
  ));
};

Target.propTypes = {
  connectDropTarget: _react.PropTypes.func.isRequired,
  isOver: _react.PropTypes.bool.isRequired,
  canDrop: _react.PropTypes.bool.isRequired,
  inactiveStyle: _react.PropTypes.object,
  inactiveClassName: _react.PropTypes.string,
  position: _react.PropTypes.any,
  activeStyle: _react.PropTypes.object,
  activeClassName: _react.PropTypes.string,
  canDropStyle: _react.PropTypes.object,
  canDropClassName: _react.PropTypes.string
};

exports.default = (0, _ramda.compose)(dragSourceFn)(Target);

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var border = '1px solid #e0e0e0';

exports.default = function (_ref) {
  var bedsAndSofas = _ref.bedsAndSofas,
      style = _ref.style;
  return _react2.default.createElement(
    'div',
    { style: _ramda2.default.merge({ backgroundColor: 'white', border: border, marginBottom: '4px' }, style) },
    (bedsAndSofas.rooms || []).map(function () {
      var room = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var roomIndex = arguments[1];
      return _react2.default.createElement(
        'div',
        { key: roomIndex },
        _react2.default.createElement(
          'div',
          { style: { display: bedsAndSofas.isApartment ? 'block' : 'none', height: '30px', backgroundColor: '#fafafa', lineHeight: '30px', paddingLeft: '8px', borderBottom: border, borderTop: roomIndex ? border : '' } },
          'Room ',
          roomIndex + 1
        ),
        _react2.default.createElement(
          'div',
          { style: { padding: '8px' } },
          room.map(function () {
            var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var configIndex = arguments[1];
            return _react2.default.createElement(
              'div',
              { key: configIndex },
              _react2.default.createElement(
                'div',
                { style: { display: configIndex > 0 ? 'block' : 'none', fontSize: '12px', padding: '4px 20px' } },
                '- OR -'
              ),
              _react2.default.createElement(
                'div',
                { style: { display: !bedsAndSofas.isApartment && room.length < 2 ? 'none' : 'block' } },
                _react2.default.createElement(_icon2.default, { className: 'tc-icon-hotel', style: { top: '1px', fontSize: '16px', marginRight: '4px' } }),
                'Configuration ',
                room.length > 1 ? configIndex + 1 : ''
              ),
              config.map(function () {
                var beddingInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var beddingIndex = arguments[1];
                return _react2.default.createElement(
                  'div',
                  { key: beddingIndex, style: { paddingLeft: '20px' } },
                  _react2.default.createElement(
                    'span',
                    { style: { color: 'rgba(0, 0, 0, 0.87)' } },
                    (beddingInfo || {}).count
                  ),
                  ' X ',
                  _react2.default.createElement(
                    'span',
                    { style: { color: 'rgba(0, 0, 0, 0.87)' } },
                    (beddingInfo || {}).bedType === 'Other' ? (beddingInfo || {}).other : (beddingInfo || {}).bedType
                  )
                );
              })
            );
          })
        )
      );
    })
  );
};

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMapping = exports.saveSettingsAction = exports.getSettings = exports.updateSettingsAction = exports.changeExportType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.checkIfHasRates = checkIfHasRates;
exports.validateMapping = validateMapping;
exports.getContract = getContract;
exports.clearExportState = clearExportState;
exports.getContracts = getContracts;
exports.exportContract = exportContract;
exports.sendHistoryFeedMsg = sendHistoryFeedMsg;
exports.getAuth = getAuth;
exports.updateWithKeyPath = updateWithKeyPath;
exports.getConvertedContract = getConvertedContract;
exports.login = login;
exports.markContractAsLoaded = markContractAsLoaded;

var _soFetch = __webpack_require__(254);

var _integrationConstants = __webpack_require__(1844);

var constants = _interopRequireWildcard(_integrationConstants);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _ramda = __webpack_require__(2);

var _immutable = __webpack_require__(26);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function callApi(tourPlanOptionID, startDate, endDate, contractWithMapping) {
  var url = '/proxy/integration/option';
  return fetch(url, {
    method: 'put',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({
      tourPlanOptionID: tourPlanOptionID,
      startDate: startDate,
      endDate: endDate,
      contractWithMapping: (0, _ramda.omit)(['locationLogs'], contractWithMapping)
    })
  }).then(_checkStatus2.default).then(function (res) {
    return res.json();
  });
}

function actionsForValidateMapping(key, status, payload, error) {
  return { type: constants.VALIDATE_MAPPING, status: status, key: key, payload: payload, error: error };
}

function actionsForUpdateMappingStatus(key, status, error) {
  return { type: constants.VALIDATE_MAPPING_STATUS, status: status, key: key, error: error };
}

var changeExportType = exports.changeExportType = function changeExportType(payload) {
  return { type: constants.CHANGE_INTEGRATION_EXPORT_TYPE, payload: payload };
};

var updateSettingsAction = exports.updateSettingsAction = function updateSettingsAction(payload) {
  return { type: constants.UPDATE_SETTINS, payload: payload };
};

var getSettings = exports.getSettings = function getSettings() {
  return function (dispatch) {
    dispatch(updateSettingsAction({ loadingSettings: true }));
    return fetch('/proxy/integration/settings', {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch(updateSettingsAction((0, _ramda.merge)(res, { loadingSettings: false })));
    }).catch(function () {
      return dispatch(updateSettingsAction({ loadingSettings: false }));
    });
  };
};

var saveSettingsAction = exports.saveSettingsAction = function saveSettingsAction(payload, successFlags) {
  return function (dispatch) {
    dispatch(updateSettingsAction({ savingSettings: true }));
    return fetch('/proxy/integration/settings', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(_checkStatus2.default).then(function () {
      return dispatch(updateSettingsAction((0, _ramda.merge)(_extends({ savingSettings: false }, payload), successFlags)));
    });
  };
};

var updateMapping = exports.updateMapping = function updateMapping(index, payload, updater) {
  return function (dispatch) {
    dispatch(actionsForUpdateMappingStatus(index, 'validating'));
    return fetch('/proxy/integration/mapping', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function () {
      dispatch({
        type: constants.UPDATE_PRODUCT,
        payload: {
          index: index,
          updater: updater
        }
      });
      dispatch(actionsForUpdateMappingStatus(index, 'ready'));
    }).catch(function (err) {
      console.log(err.stack);
      dispatch(actionsForUpdateMappingStatus(index, 'failed', err.message));
    });
  };
};

function checkIfHasRates(key, tourPlanOptionID, startDate, endDate, contract) {
  return function (dispatch) {
    dispatch({ type: constants.CHECK_RATES_STARTING });
    dispatch(actionsForUpdateMappingStatus(key, 'validating'));
    return callApi(tourPlanOptionID, startDate, endDate, contract).then(function (res) {
      dispatch(actionsForUpdateMappingStatus(key, 'ready'));
      dispatch({
        type: constants.CHECK_IF_HAS_RATES,
        key: key,
        hasRates: res ? res.hasRates : false
      });
    }).catch(function (err) {
      dispatch({
        type: constants.CHECK_IF_HAS_RATES_FAILED,
        key: key,
        hasRates: false
      });
    });
  };
}

function validateMapping(key, tourPlanOptionID, startDate, endDate, contract, productId) {
  return function (dispatch) {
    dispatch(actionsForUpdateMappingStatus(key, 'validating'));
    var response = void 0;
    return callApi(tourPlanOptionID, startDate, endDate, contract).then(function (res) {
      response = res;
      if (res) dispatch(actionsForValidateMapping(key, 'ready', _extends({}, response, { productId: productId })));else dispatch(actionsForUpdateMappingStatus(key, 'failed'));
    }).catch(function (err) {
      console.log(err.stack);
      dispatch(actionsForUpdateMappingStatus(key, 'failed', err.message));
    });
  };
}

function getContract(contractID) {
  return function (dispatch) {
    dispatch({ type: constants.GET_CONTRACT_STARTING });
    return (0, _soFetch.soFetch)('/proxy/integration/contract/' + contractID, {
      method: 'get',
      actionType: constants.GET_CONTRACT,
      responseBinding: 'integration'
    })(dispatch);
  };
}

function clearExportState() {
  return { type: constants.CLEAR_EXPORT_STATE };
}

function getContracts() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { page: 1 };

  return function (dispatch) {
    dispatch({ type: constants.GET_CONTRACTS_STARTING });
    return (0, _soFetch.soFetch)('/proxy/integration/contracts?page=' + (payload.page || 1) + '&sorKey=' + (payload.sortKey || '') + '&sort=' + (payload.sort || '') + '&searchInput=' + (payload.searchInput || ''), {
      method: 'get',
      actionType: constants.GET_CONTRACTS,
      responseBinding: 'integration'
    })(dispatch).catch(function (err) {
      console.log(err.stack);
      dispatch({ type: constants.GET_CONTRACTS_FAILED });
    });
  };
}

function exportContract(contractWithMapping, convertedContract) {
  return function (dispatch) {
    dispatch({ type: '{integration-export} START' });

    return fetch('/integrationproxy/contractsJob', {
      method: 'post',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        // contractWithMapping: omit(['locationLogs'], contractWithMapping),
        contractId: contractWithMapping.contractId,
        contractWithMapping: contractWithMapping,
        convertedContract: convertedContract,
        callbackUrl: "https://rest.tourconnect.com" + '/integration/saveExportResponse',
        callbackHeaders: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('jwt')
        }
      })
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      return res.json();
    }).then(function (res) {
      return dispatch({
        type: '{integration-export} POLLING_ACTION_RESPONSE',
        payload: res
      });
    }).catch(function (err) {
      return dispatch({ type: constants.ADD_MAPPING_FAILED, error: err.message });
    });
  };
}
function sendHistoryFeedMsg(path, historyFeedId, message) {
  return function (dispatch) {
    dispatch({ type: constants.UPDATE_WITH_KEYPATH, payload: { keyPath: (0, _ramda.append)('msgFlags', path), immutableValue: (0, _immutable.fromJS)({ sendingMsg: true }) } });
    return fetch('/proxy/contracting/saveComment/' + historyFeedId, {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: message })
    }).then(_checkStatus2.default).then(function () {
      return dispatch({ type: constants.UPDATE_WITH_KEYPATH, payload: { keyPath: (0, _ramda.append)('msgFlags', path), immutableValue: (0, _immutable.fromJS)({ sendingMsg: false, msgSent: true }) } });
    }).catch(function (err) {
      return console.log(err);
    });
  };
}
function getAuth() {
  return function (dispatch) {
    return (0, _soFetch.soFetch)('/proxy/integration/get-auth', {
      method: 'get',
      actionType: constants.GET_AUTH,
      responseBinding: 'auth'
    })(dispatch).catch(function (err) {
      return dispatch({ type: constants.GET_AUTH_FAILED, payload: err });
    });
  };
}
function updateWithKeyPath(keyPath, immutableValue) {
  return { type: constants.UPDATE_WITH_KEYPATH, payload: { keyPath: keyPath, immutableValue: immutableValue } };
}

function getConvertedContract(contractId, ratePackageIds) {
  return function (dispatch) {
    dispatch({ type: constants.GETTING_CONVERTED_CONTRACT });
    return fetch('/integrationproxy/converted-contract/' + contractId + '?' + _queryString2.default.stringify({
      ratePackageIds: ratePackageIds
    }), {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({ type: constants.GET_CONVERTED_CONTRACT, payload: res });
    }).catch(function (err) {
      console.log('ERROR', err);
      dispatch({ type: constants.GETTING_CONVERTED_CONTRACT_FAILED });
    });
  };
}

function login(userName, password, url) {
  return function (dispatch) {
    dispatch({ type: constants.LOGIN, payload: 'starting' });

    return fetch('/integrationproxy/user/login', {
      method: 'post',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userName: userName,
        password: password,
        url: url
      })
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      return res.json();
    }).then(function () {
      dispatch({ type: constants.LOGIN, payload: 'success' });
    }).catch(function (err) {
      return dispatch({ type: constants.LOGIN, payload: err.message });
    });
  };
}

function markContractAsLoaded(contractId) {
  return function (dispatch) {
    dispatch({ type: '{TP_Integration}CHANGE_CONTRACT_STATE_STARTING' });
    return fetch('/proxy/contracting/updateContractStatus', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        contractIds: [contractId],
        state: 'loaded'
      })
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      return dispatch({ type: '{TP_Integration}CHANGE_CONTRACT_STATE_SUCCESS' });
    }).catch(function (err) {
      console.log(err);
      return dispatch({ type: '{TP_Integration}CHANGE_CONTRACT_STATE_ERROR' });
    });
  };
}

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _reactDom = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components

var ConnectionsTag = (0, _react.createClass)({

  propTypes: {
    tag: _react.PropTypes.string,
    addOrRemoveTag: _react.PropTypes.func,
    isTagModal: _react.PropTypes.bool,
    className: _react.PropTypes.string
  },

  componentWillEnter: function componentWillEnter(cb) {
    var style = (0, _reactDom.findDOMNode)(this).style;
    style.opacity = '0';
    style.color = 'green';
    setTimeout(cb, 50);
  },
  componentDidEnter: function componentDidEnter() {
    var style = (0, _reactDom.findDOMNode)(this).style;
    style.transition = 'all .3s ease-in';
    style.color = 'rgba(0, 0, 0, 0.870588)';
    style.opacity = '1';
  },
  componentWillLeave: function componentWillLeave(cb) {
    var style = (0, _reactDom.findDOMNode)(this).style;
    style.transition = 'all .3s ease-in';
    style.opacity = '0';
    setTimeout(cb, 300);
  },
  sendTagToParent: function sendTagToParent() {
    this.props.addOrRemoveTag(this.props.tag);
  },
  removeTag: function removeTag() {
    this.props.addOrRemoveTag(this.props.tag, 'remove');
  },
  render: function render() {
    var _this = this;

    var _ref = function () {
      if (_this.props.isTagModal) {
        return {
          className: 'individual-tag',
          icon: _react2.default.createElement(_icon2.default, { className: 'tc-icon-close', onClick: _this.removeTag })
        };
      }
      return {
        clickEvent: _this.sendTagToParent,
        className: _this.props.className
      };
    }(),
        clickEvent = _ref.clickEvent,
        className = _ref.className,
        icon = _ref.icon;

    return _react2.default.createElement(
      'div',
      { className: className, onClick: clickEvent },
      this.props.tag,
      icon
    );
  }
}); // Dependencies
exports.default = ConnectionsTag;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withGoogleMap = __webpack_require__(3006);

Object.defineProperty(exports, "withGoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withGoogleMap).default;
  }
});

var _GoogleMap = __webpack_require__(3018);

Object.defineProperty(exports, "GoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GoogleMap).default;
  }
});

var _Marker = __webpack_require__(3086);

Object.defineProperty(exports, "Marker", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Marker).default;
  }
});

var _Rectangle = __webpack_require__(3087);

Object.defineProperty(exports, "Rectangle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rectangle).default;
  }
});

var _Polyline = __webpack_require__(3088);

Object.defineProperty(exports, "Polyline", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polyline).default;
  }
});

var _Polygon = __webpack_require__(3089);

Object.defineProperty(exports, "Polygon", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polygon).default;
  }
});

var _Circle = __webpack_require__(3090);

Object.defineProperty(exports, "Circle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default;
  }
});

var _KmlLayer = __webpack_require__(3091);

Object.defineProperty(exports, "KmlLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_KmlLayer).default;
  }
});

var _FusionTablesLayer = __webpack_require__(3092);

Object.defineProperty(exports, "FusionTablesLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FusionTablesLayer).default;
  }
});

var _TrafficLayer = __webpack_require__(3093);

Object.defineProperty(exports, "TrafficLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrafficLayer).default;
  }
});

var _DirectionsRenderer = __webpack_require__(3094);

Object.defineProperty(exports, "DirectionsRenderer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DirectionsRenderer).default;
  }
});

var _HeatmapLayer = __webpack_require__(3095);

Object.defineProperty(exports, "HeatmapLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HeatmapLayer).default;
  }
});

var _InfoWindow = __webpack_require__(3096);

Object.defineProperty(exports, "InfoWindow", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InfoWindow).default;
  }
});

var _OverlayView = __webpack_require__(3097);

Object.defineProperty(exports, "OverlayView", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OverlayView).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1033), __esModule: true };

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(3012);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(3013);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(1918);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(1000),
    root = __webpack_require__(550);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(3025);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(1523),
    getData = __webpack_require__(1522),
    getFuncName = __webpack_require__(1919),
    lodash = __webpack_require__(3026);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 1921 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(1923),
    createBind = __webpack_require__(3029),
    createCurry = __webpack_require__(3030),
    createHybrid = __webpack_require__(1924),
    createPartial = __webpack_require__(3036),
    getData = __webpack_require__(1522),
    mergeData = __webpack_require__(3037),
    setData = __webpack_require__(1928),
    setWrapToString = __webpack_require__(1929),
    toInteger = __webpack_require__(3038);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(1052),
    metaMap = __webpack_require__(1917);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(1925),
    composeArgsRight = __webpack_require__(1926),
    countHolders = __webpack_require__(3031),
    createCtor = __webpack_require__(1248),
    createRecurry = __webpack_require__(1927),
    getHolder = __webpack_require__(1524),
    reorder = __webpack_require__(3035),
    replaceHolders = __webpack_require__(1249),
    root = __webpack_require__(550);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 1925 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 1926 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(1920),
    setData = __webpack_require__(1928),
    setWrapToString = __webpack_require__(1929);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(1923),
    shortOut = __webpack_require__(1891);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(3032),
    insertWrapDetails = __webpack_require__(3033),
    setToString = __webpack_require__(1506),
    updateWrapDetails = __webpack_require__(3034);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 1930 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(735),
    isSymbol = __webpack_require__(1250);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1933),
    createBaseEach = __webpack_require__(3045);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(3041),
    keys = __webpack_require__(1251);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(1935),
    isArguments = __webpack_require__(1509),
    isArray = __webpack_require__(255),
    isIndex = __webpack_require__(1244),
    isLength = __webpack_require__(1507),
    toKey = __webpack_require__(1252);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(255),
    isKey = __webpack_require__(1525),
    stringToPath = __webpack_require__(3050),
    toString = __webpack_require__(3052);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(3056),
    baseMatchesProperty = __webpack_require__(3077),
    identity = __webpack_require__(1052),
    isArray = __webpack_require__(255),
    property = __webpack_require__(3081);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(1234),
    stackClear = __webpack_require__(3058),
    stackDelete = __webpack_require__(3059),
    stackGet = __webpack_require__(3060),
    stackHas = __webpack_require__(3061),
    stackSet = __webpack_require__(3062);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(3063),
    isObjectLike = __webpack_require__(874);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1232),
    arraySome = __webpack_require__(3064),
    cacheHas = __webpack_require__(1239);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(735);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 1941 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(1935),
    toKey = __webpack_require__(1252);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(1526),
    eq = __webpack_require__(1133);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isLeft = function isLeft(evt) {
  var width = evt.target.offsetWidth;
  var el = evt.target;
  var x = 0;

  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    x += el.offsetLeft - el.scrollLeft;
    el = el.offsetParent;
  }

  x = evt.clientX - x;

  return width / 2 > x;
};

var Rating = function (_Component) {
  _inherits(Rating, _Component);

  function Rating(props) {
    _classCallCheck(this, Rating);

    var _this = _possibleConstructorReturn(this, (Rating.__proto__ || Object.getPrototypeOf(Rating)).call(this, props));

    _this._updateStars = function (startValue, event) {
      if (!_this.props.isEditing) return;
      var value = isLeft(event) ? startValue - 0.5 : startValue;
      _this.props._updateSubField('value', value);
    };

    _this._startHover = function (hoverIndex, event) {
      if (!_this.props.isEditing) return;
      var value = isLeft(event) ? hoverIndex - 0.5 : hoverIndex;
      _this.setState({
        hoverIndex: value
      });
    };

    _this._clearStarHover = function () {
      if (!_this.props.isEditing) return;
      _this.setState({
        hoverIndex: _this.props.rating.value
      });
    };

    _this._toggleType = function () {
      var type = _this.props.rating.type === 'Self-Assessed' ? 'Certified Official Rating (ie Australian STAR Rating, New Zealand Qualmark Rating, etc.)' : 'Self-Assessed';
      _this.props._updateSubField('type', type);
    };

    var rating = props.rating || {};
    _this.state = {
      hoverIndex: rating.value
    };
    _this._toggleType = _this._toggleType.bind(_this);
    return _this;
  }

  _createClass(Rating, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var stars = [];
      var certifiedLongText = 'Certified Official Rating (ie Australian STAR Rating, New Zealand Qualmark Rating, etc.)';
      var value = void 0;
      var type = void 0;
      var inlineStyleWithMargin = void 0;
      var inlineStyle = {};
      if (this.props.isEditing) {
        value = this.state.hoverIndex;
        type = _react2.default.createElement(_materialUi.Toggle, {
          checked: this.props.rating.type !== 'Self-Assessed',
          label: certifiedLongText,
          labelPosition: 'right',
          style: {
            cursor: 'pointer',
            overflow: 'visible',
            width: '100%',
            verticalAlign: 'middle'
          },
          onToggle: this._toggleType,
          name: 'toggleName1',
          value: 'toggleValue1'
        });
      } else {
        inlineStyle = { display: 'inline-block' };
        inlineStyleWithMargin = { display: 'inline-block', marginRight: '8px' };
        value = this.props.rating ? this.props.rating.value : undefined;
        type = function () {
          if (_this2.props.rating) {
            if (_this2.props.rating.type === certifiedLongText) return 'Certified Rating';
            return _this2.props.rating.type;
          }
        }();
      }
      var i = 1;
      while (i < 6) {
        var starClass = '';
        if (i <= value) {
          starClass = 'tc-icon-star';
        } else if (value > i - 1) {
          starClass = 'tc-icon-star-half';
        } else if (this.props.isEditing) {
          starClass = 'tc-icon-star-empty';
        } else {
          break;
        }
        stars.push(_react2.default.createElement(_icon2.default, { key: i, className: starClass, onClick: this._updateStars.bind(this, i), onMouseMove: this._startHover.bind(this, i), onMouseOut: this._clearStarHover }));
        i++;
      }

      return _react2.default.createElement(
        'div',
        { style: _extends(inlineStyle, this.props.style) },
        _react2.default.createElement(
          'div',
          { style: inlineStyleWithMargin },
          stars
        ),
        _react2.default.createElement(
          'div',
          { style: inlineStyle },
          type
        )
      );
    }
  }]);

  return Rating;
}(_react.Component);

Rating.propTypes = {
  rating: _react.PropTypes.object,
  isEditing: _react.PropTypes.bool,
  style: _react.PropTypes.object,
  _updateSubField: _react.PropTypes.func
};

exports.default = Rating;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationImportExport = function CommunicationImportExport(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z' })
  );
};
CommunicationImportExport = (0, _pure2.default)(CommunicationImportExport);
CommunicationImportExport.displayName = 'CommunicationImportExport';
CommunicationImportExport.muiName = 'SvgIcon';

exports.default = CommunicationImportExport;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDropzoneComponent = __webpack_require__(3130);

var _reactDropzoneComponent2 = _interopRequireDefault(_reactDropzoneComponent);

var _s3Upload = __webpack_require__(564);

var _s3Upload2 = _interopRequireDefault(_s3Upload);

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _fileError = __webpack_require__(3134);

var _fileError2 = _interopRequireDefault(_fileError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropzoneWithPreview = function (_Component) {
  _inherits(DropzoneWithPreview, _Component);

  function DropzoneWithPreview(props) {
    _classCallCheck(this, DropzoneWithPreview);

    var _this = _possibleConstructorReturn(this, (DropzoneWithPreview.__proto__ || Object.getPrototypeOf(DropzoneWithPreview)).call(this, props));

    _this.state = {
      files: _this.props.allFiles,
      showErrorDialog: false,
      errorDialogType: '',
      problemFiles: [],
      uploadingFiles: false,
      percent: 0
    };
    return _this;
  }

  _createClass(DropzoneWithPreview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('beforeunload', function (e) {
        return _this2.handleWindowClose(e);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.handleWindowClose());
    }
  }, {
    key: 'handleWindowClose',
    value: function handleWindowClose(e) {
      if (this.state.uploadingFiles) {
        var location = window.location.pathname;
        if (location === '/profile') {
          e.preventDefault();
          e.returnValue = ''; // doesn't matter what this string is, the browser will show it's own
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var componentConfig = {
        showFiletypeIcon: this.props.showFiletypeIcon,
        postUrl: 'no-url' // this is required and will return a 404
      };

      var djsConfig = {
        dictDefaultMessage: this.props.addFilesMessage,
        dictFileTooBig: 'File is too big ({{filesize}}MB). Max filesize: ' + this.props.maxFileSize + 'MB.',
        addRemoveLinks: this.props.addRemoveLinks,
        acceptedFiles: this.props.acceptedFileTypes
      };

      var onDrop = function onDrop(file) {
        var callback = _this3.props.finishedFileUploadCB;
        var showThumbnailPreviews = _this3.props.showThumbnailPreviews;
        var dropzone = _this3.dropzone;
        var flipLoadingPhotosState = function flipLoadingPhotosState(state) {
          return _this3.setState({
            uploadingFiles: state,
            percent: 0
          });
        };
        if (file) {
          if (!(0, _ramda.contains)(file.type, _this3.props.arrayOfAcceptedFileTypes)) {
            _this3.state.problemFiles.push(file);
            _this3.setState({
              showErrorDialog: true,
              errorDialogType: 'fileTypeError'
            });
            dropzone.removeFile(dropzone.files[0]);
          } else if (_this3.props.arrayOfPhotoTypes.indexOf(file.type) > -1 && Number(file.size.toFixed(3)) < Number(_this3.props.suggestedMinFileSize * 1000).toFixed(3)) {
            _this3.state.problemFiles.push(file);
            _this3.setState({
              showErrorDialog: true,
              errorDialogType: 'lowResAlert'
            });
            dropzone.removeFile(dropzone.files[0]);
          } else if (Number(file.size) > Number(_this3.props.maxFileSize * 1000)) {
            _this3.state.problemFiles.push(file);
            _this3.setState({
              showErrorDialog: true,
              errorDialogType: 'fileTooBig'
            });
            dropzone.removeFile(dropzone.files[0]);
          } else {
            _this3.setState({ uploadingFiles: true });
            return _s3Upload2.default.s3upload({
              file_to_upload: file,
              file_name: 'general-photos/' + _nodeUuid2.default.v1(),
              onProgress: function onProgress(percent) {
                if (percent === 100) return flipLoadingPhotosState(false);
              },
              onFinishS3Put: function onFinishS3Put(publicUrl) {
                if (!showThumbnailPreviews && dropzone.files.length > 0) {
                  dropzone.removeFile(dropzone.files[0]);
                }
                if (callback) return callback(publicUrl, file.type, file.name, (file.size / (1000 * 1000)).toFixed(3));
              },
              onError: function onError(status) {
                console.log(status);
              }
            });
          }
        }
      };

      var closeErrorDialog = function closeErrorDialog() {
        return _this3.setState({
          showErrorDialog: false,
          errorDialogType: '',
          problemFiles: []
        });
      };

      var getErrorMessage = function getErrorMessage() {
        return (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('lowResAlert'), function () {
          return _react2.default.createElement(_fileError2.default, {
            showDialog: true,
            title: 'Low Resolution Alert',
            confirmButtonFunc: closeErrorDialog,
            topText: _react2.default.createElement(
              'h5',
              null,
              'The resolution of your photo is too low and may appear grainy or pixelated when printed. The suggested minimum file size is ',
              _this3.props.suggestedMinFileSize / 1000,
              'MB / ',
              _this3.props.suggestedMinFileSize,
              'KB. Please consider uploading ',
              _this3.state.problemFiles.length === 1 ? 'a higher resolution file' : 'higher resolution files',
              ' for the following:'
            ),
            problemFiles: _this3.state.problemFiles
          });
        }], [(0, _ramda.equals)('fileTooBig'), function () {
          return _react2.default.createElement(_fileError2.default, {
            showDialog: true,
            title: 'File Size Error',
            confirmButtonFunc: closeErrorDialog,
            topText: _react2.default.createElement(
              'h5',
              null,
              'The max file size is ',
              _this3.props.maxFileSize,
              'MB. The following ',
              _this3.state.problemFiles.length === 1 ? 'file is' : 'files are',
              ' too large:'
            ),
            problemFiles: _this3.state.problemFiles,
            subtext: _react2.default.createElement(
              'h5',
              { style: { marginTop: '5px' } },
              'Please compress ',
              _this3.state.problemFiles.length === 1 ? 'this file' : 'these files',
              ' or upload an alternative.'
            )
          });
        }], [(0, _ramda.equals)('fileTypeError'), function () {
          return _react2.default.createElement(_fileError2.default, {
            showDialog: true,
            title: 'Unsupported File Type Error',
            confirmButtonFunc: closeErrorDialog,
            topText: _react2.default.createElement(
              'h5',
              null,
              'Supported file types include: ',
              _this3.props.acceptedFileTypes,
              '.',
              _react2.default.createElement('br', null),
              'The following ',
              _this3.state.problemFiles.length === 1 ? 'file is' : 'files are',
              ' unsupported:'
            ),
            problemFiles: _this3.state.problemFiles
          });
        }], [_ramda.T, function () {
          return _react2.default.createElement(_fileError2.default, {
            showDialog: true,
            title: 'File Upload Error',
            confirmButtonFunc: closeErrorDialog,
            topText: _react2.default.createElement(
              'h5',
              null,
              'Unable to upload the following ',
              _this3.state.problemFiles.length === 1 ? 'file' : 'files',
              ':'
            ),
            problemFiles: _this3.state.problemFiles,
            subtext: _react2.default.createElement(
              'h5',
              { style: { marginTop: '5px' } },
              'Please try again.'
            )
          });
        }]]), _this3.state.errorDialogType);
      };

      var setDropzone = function setDropzone(dropzone) {
        return _this3.dropzone = dropzone;
      };

      var eventHandlers = {
        init: function init(passedDropzone) {
          return setDropzone(passedDropzone);
        },
        // All of these receive the event as first parameter:
        drop: null,
        dragstart: null,
        dragend: null,
        dragenter: null,
        dragover: null,
        dragleave: null,
        // All of these receive the file as first parameter:
        addedfile: onDrop,
        removedfile: null,
        thumbnail: null,
        error: null,
        processing: function processing() {
          return _this3.props.uploadingFile();
        },
        uploadprogress: null,
        sending: null,
        success: null,
        complete: null,
        canceled: null,
        maxfilesreached: null,
        maxfilesexceeded: null,
        // All of these receive a list of files as first parameter
        // and are only called if the uploadMultiple option
        // in djsConfig is true:
        processingmultiple: null,
        sendingmultiple: null,
        successmultiple: null,
        completemultiple: null,
        canceledmultiple: null,
        // Special Events
        totaluploadprogress: function totaluploadprogress(p) {
          return _this3.setState({ percent: Math.floor(p) });
        },
        reset: null,
        queuecompleted: null
      };

      return _react2.default.createElement(
        'div',
        { style: { pointerEvents: this.state.uploadingFiles ? 'none' : '' } },
        _react2.default.createElement(_reactDropzoneComponent2.default, {
          config: componentConfig,
          eventHandlers: eventHandlers,
          djsConfig: djsConfig
        }),
        this.state.uploadingFiles ? _react2.default.createElement(_materialUi.LinearProgress, { mode: 'determinate', value: this.state.percent }) : _react2.default.createElement('span', null),
        this.state.showErrorDialog ? getErrorMessage() : _react2.default.createElement('span', null)
      );
    }
  }]);

  return DropzoneWithPreview;
}(_react.Component);

DropzoneWithPreview.propTypes = {
  addRemoveLinks: _react.PropTypes.bool, // show remove link under thumbnail
  acceptedFileTypes: _react.PropTypes.string, // string of accepted file types like '.jpg, .png'
  showFiletypeIcon: _react.PropTypes.bool, // show image of file types
  finishedFileUploadCB: _react.PropTypes.func,
  allFiles: _react.PropTypes.array,
  maxFileSize: _react.PropTypes.number, // in MB
  showThumbnailPreviews: _react.PropTypes.bool, // show thumbnails after upload complete
  uploadingFile: _react.PropTypes.func,
  addFilesMessage: _react.PropTypes.string,
  suggestedMinFileSize: _react.PropTypes.string, // in KB
  arrayOfAcceptedFileTypes: _react.PropTypes.array, // ['image/jpeg', 'image/png'] need this because file.accepted doesn't always work
  arrayOfPhotoTypes: _react.PropTypes.array
};

exports.default = DropzoneWithPreview;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _materialUi = __webpack_require__(3);

var _bowser = __webpack_require__(1001);

var _entry = __webpack_require__(1255);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dropbox = __webpack_require__(3137);
var GoogleDrive = __webpack_require__(3138);
var OneDrive = __webpack_require__(3139);
var Box = __webpack_require__(3140);


var notEqual = function notEqual(first, second) {
  return (0, _ramda.not)((0, _ramda.equals)(first, second));
};

var propTypes = {
  index: _react.PropTypes.number,
  onThumbnailSelect: _react.PropTypes.func,
  file: _react.PropTypes.object,
  isSelected: _react.PropTypes.bool,
  selectedBorderStyle: _react.PropTypes.object,
  onPreviewClick: _react.PropTypes.func,
  updateUserHovering: _react.PropTypes.func,
  isUserHovering: _react.PropTypes.bool,
  hoverEffect: _react.PropTypes.bool,
  showVideoControls: _react.PropTypes.bool,
  downloadOneFile: _react.PropTypes.func,
  isUploadingFile: _react.PropTypes.bool,
  minHeight: _react.PropTypes.string, // eg 40px
  maxHeight: _react.PropTypes.string,
  inDialog: _react.PropTypes.bool
};

var Thumbnail = function (_Component) {
  _inherits(Thumbnail, _Component);

  function Thumbnail(props) {
    _classCallCheck(this, Thumbnail);

    var _this = _possibleConstructorReturn(this, (Thumbnail.__proto__ || Object.getPrototypeOf(Thumbnail)).call(this, props));

    _this.state = {
      videoPlaying: false,
      fullScreen: false,
      muted: false,
      numOfPDFPages: null
    };
    return _this;
  }

  _createClass(Thumbnail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('fullscreenchange', this.onFullScreenChange, false);
      window.addEventListener('webkitfullscreenchange', this.onFullScreenChange, false);
      window.addEventListener('mozfullscreenchange', this.onFullScreenChange, false);
    }
  }, {
    key: 'onFullScreenChange',
    value: function onFullScreenChange() {
      var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
      this.setState({ fullScreen: !(0, _ramda.isNil)(fullscreenElement) });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          file = _props.file,
          index = _props.index,
          onThumbnailSelect = _props.onThumbnailSelect,
          isSelected = _props.isSelected,
          selectedBorderStyle = _props.selectedBorderStyle,
          onPreviewClick = _props.onPreviewClick,
          updateUserHovering = _props.updateUserHovering,
          isUserHovering = _props.isUserHovering,
          hoverEffect = _props.hoverEffect,
          showVideoControls = _props.showVideoControls,
          downloadOneFile = _props.downloadOneFile,
          isUploadingFile = _props.isUploadingFile,
          minHeight = _props.minHeight,
          maxHeight = _props.maxHeight,
          inDialog = _props.inDialog;


      var PDFHeight = file.mediaType === 'application/pdf' ? '440px' : '';
      var outerDivStyle = { height: hoverEffect ? '128px' : PDFHeight, pointerEvents: isUploadingFile ? 'none' : '', overflowY: file.mediaType === 'application/pdf' ? 'scroll' : '' };
      var genericStyle = { maxWidth: '100%', maxHeight: maxHeight || '100%', verticalAlign: 'middle', minHeight: minHeight || '' };
      var videoButtonStyle = { cursor: 'pointer', color: 'rgba(0, 0, 0, 0.54)' };
      var isVideo = (0, _ramda.either)((0, _ramda.equals)('video/mp4'), (0, _ramda.equals)('video/quicktime'));
      var onThumbnailClick = (0, _lodash2.default)(function () {
        return isUserHovering ? onPreviewClick(index) : onThumbnailSelect((0, _ramda.merge)(file, { index: index }), 200);
      });

      var videoControls = function videoControls(action) {
        (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('play'), function () {
          _this2.setState({ videoPlaying: true });
          _this2.refs.videoRef.play();
        }], [(0, _ramda.equals)('pause'), function () {
          _this2.setState({ videoPlaying: false });
          _this2.refs.videoRef.pause();
        }], [(0, _ramda.equals)('fullScreen'), function () {
          _this2.setState({ fullScreen: true });
          if ((0, _ramda.equals)(_bowser.browser.name, 'Chrome') || (0, _ramda.equals)(_bowser.browser.name, 'Safari') || (0, _ramda.equals)(_bowser.browser.name, 'Internet Explorer')) return _this2.refs.videoRef.webkitRequestFullScreen();
          if ((0, _ramda.equals)(_bowser.browser.name, 'Firefox')) return _this2.refs.videoRef.mozRequestFullScreen();
          if ((0, _ramda.equals)(_bowser.browser.name, 'Internet Explorer')) return _this2.refs.videoRef.msRequestFullscreen();
          return _this2.refs.videoRef.requestFullscreen();
        }]]), action);
      };

      var generateIconForCloudDrive = function generateIconForCloudDrive(imageSrc, imageSize) {
        return _react2.default.createElement(
          'a',
          { href: file.url, target: '_blank' },
          _react2.default.createElement('img', {
            src: imageSrc,
            style: {
              width: hoverEffect && notEqual(imageSrc, Dropbox) ? '70px' : imageSize,
              verticalAlign: 'middle'
            }
          })
        );
      };

      var getIconForCloudDrive = function getIconForCloudDrive(storageProvider) {
        return (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('Dropbox'), (0, _ramda.always)(generateIconForCloudDrive(Dropbox, '55px'))], [(0, _ramda.equals)('Google Drive'), (0, _ramda.always)(generateIconForCloudDrive(GoogleDrive, '100px'))], [(0, _ramda.equals)('OneDrive'), (0, _ramda.always)(generateIconForCloudDrive(OneDrive, '100px'))], [(0, _ramda.equals)('Box'), (0, _ramda.always)(generateIconForCloudDrive(Box, '100px'))], [_ramda.T, (0, _ramda.always)(_react2.default.createElement(
          'a',
          { href: file.url, target: '_blank' },
          _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-cloud_circle',
            style: { color: 'rgba(138,138,138,.5)', verticalAlign: 'middle', fontSize: '40px' },
            hoverColor: '#00bcd4'
          })
        ))]]), storageProvider);
      };

      var getVideoPlayerButtons = function getVideoPlayerButtons(button) {
        return (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('play'), function () {
          return _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-play_arrow',
            onClick: function onClick() {
              return videoControls('play');
            },
            style: videoButtonStyle
          });
        }], [(0, _ramda.equals)('pause'), function () {
          return _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-pause',
            onClick: function onClick() {
              return videoControls('pause');
            },
            style: videoButtonStyle
          });
        }], [(0, _ramda.equals)('fullScreen'), function () {
          return _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-fullscreen',
            onClick: function onClick() {
              return videoControls('fullScreen');
            },
            style: videoButtonStyle
          });
        }], [(0, _ramda.equals)('mute'), function () {
          return _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-volume_up',
            onClick: function onClick() {
              return _this2.setState({ muted: true });
            },
            style: videoButtonStyle
          });
        }], [(0, _ramda.equals)('unmute'), function () {
          return _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-volume_off',
            onClick: function onClick() {
              return _this2.setState({ muted: false });
            },
            style: videoButtonStyle
          });
        }]]), button);
      };

      return _react2.default.createElement(
        'div',
        {
          className: hoverEffect ? 'image-container effect' : '',
          onClick: hoverEffect ? onThumbnailClick : undefined,
          style: isSelected ? (0, _ramda.merge)(outerDivStyle, selectedBorderStyle) : outerDivStyle
        },
        (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.either)((0, _ramda.equals)('image/png'), (0, _ramda.equals)('image/jpeg')), (0, _ramda.always)(_react2.default.createElement('img', {
          id: 'locationImage' + index,
          src: Number(file.size) > 10 && !inDialog ? '' : file.url,
          style: isSelected ? (0, _ramda.merge)({ marginTop: '-2px' }, genericStyle) : genericStyle
        }))], [isVideo, (0, _ramda.always)(_react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'video',
            { style: genericStyle, ref: 'videoRef', muted: this.state.muted },
            _react2.default.createElement('source', {
              id: 'locationImage' + index,
              src: Number(file.size) > 2 && !inDialog ? '' : file.url,
              type: 'video/mp4'
            })
          ),
          showVideoControls ? _react2.default.createElement(
            'div',
            { style: { border: '1px solid #BDBDBD', height: '25px', verticalAlign: 'middle' } },
            _react2.default.createElement(
              'span',
              { style: { float: 'left' } },
              this.state.videoPlaying ? getVideoPlayerButtons('pause') : getVideoPlayerButtons('play'),
              this.state.fullScreen ? getVideoPlayerButtons('exitFullScreen') : getVideoPlayerButtons('fullScreen')
            ),
            _react2.default.createElement(
              'span',
              { style: { float: 'right', marginRight: '3px' } },
              this.state.muted ? getVideoPlayerButtons('unmute') : getVideoPlayerButtons('mute')
            )
          ) : _react2.default.createElement('span', null)
        ))], [(0, _ramda.equals)('application/pdf'), (0, _ramda.always)(_react2.default.createElement(
          'div',
          { style: { border: '2px solid #D3D3D3', width: '100%', display: 'flex', justifyContent: 'center', paddingTop: hoverEffect ? '3px' : '' } },
          _react2.default.createElement(
            _entry.Document,
            { file: file.url, onLoadSuccess: function onLoadSuccess(_ref) {
                var numPages = _ref.numPages;
                return _this2.setState({ numOfPDFPages: numPages });
              } },
            hoverEffect ? _react2.default.createElement(_entry.Page, { pageNumber: 1, width: 85 }) : Array.from(new Array(this.state.numOfPDFPages), function (el, i) {
              return _react2.default.createElement(_entry.Page, {
                key: 'page_' + (i + 1),
                pageNumber: i + 1,
                scale: 0.95
              });
            })
          )
        ))], [(0, _ramda.either)((0, _ramda.equals)('application/vnd.ms-powerpoint'), (0, _ramda.equals)('application/vnd.openxmlformats-officedocument.presentationml.presentation')), (0, _ramda.always)(_react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-subscriptions',
            style: { color: 'rgba(138,138,138,.5)', verticalAlign: 'middle', fontSize: '40px', cursor: 'pointer' },
            hoverColor: '#00bcd4',
            onClick: function onClick() {
              return downloadOneFile();
            }
          })
        ))], [(0, _ramda.equals)('CloudDrive'), (0, _ramda.always)(getIconForCloudDrive(file.storageProvider))], [_ramda.T, (0, _ramda.always)('')]]), file.mediaType),
        hoverEffect ? _react2.default.createElement(
          'div',
          { className: 'video-playbutton-mask' },
          _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-zoom_in',
            style: { color: '#ffffff', verticalAlign: 'middle', fontSize: '50px' },
            onClick: onThumbnailClick,
            onMouseEnter: function onMouseEnter() {
              return updateUserHovering(true);
            },
            onMouseLeave: function onMouseLeave() {
              return updateUserHovering(false);
            }
          })
        ) : _react2.default.createElement('span', null)
      );
    }
  }]);

  return Thumbnail;
}(_react.Component);

Thumbnail.propTypes = propTypes;

exports.default = Thumbnail;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveCancelButtons = function SaveCancelButtons(props) {
  var outerDivStyle = props.outerDivStyle,
      objectInfoToMap = props.objectInfoToMap;


  return _react2.default.createElement(
    'div',
    { style: outerDivStyle },
    objectInfoToMap.map(function (buttonInfo, index) {
      return _react2.default.createElement(_materialUi.RaisedButton, {
        key: index,
        label: buttonInfo.labelText,
        labelStyle: buttonInfo.labelStyle,
        style: buttonInfo.style,
        onTouchTap: buttonInfo.onTouchTap,
        secondary: (0, _ramda.propEq)('labelText', 'Save', buttonInfo),
        disabled: (0, _ramda.propEq)('labelText', 'Save', buttonInfo) ? buttonInfo.disableSave : false
      });
    })
  );
};

SaveCancelButtons.propTypes = {
  outerDivStyle: _react.PropTypes.object,
  objectInfoToMap: _react.PropTypes.array
};

exports.default = SaveCancelButtons;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GenericDialog = function GenericDialog(props) {
  var dialogTitle = props.dialogTitle,
      actions = props.actions,
      subContent = props.subContent,
      hiddenErrorChecking = props.hiddenErrorChecking,
      mainContent = props.mainContent;


  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _materialUi.Dialog,
      {
        title: dialogTitle,
        actions: actions,
        modal: true,
        open: true
      },
      _react2.default.createElement(
        'div',
        null,
        mainContent,
        subContent
      )
    ),
    hiddenErrorChecking
  );
};

GenericDialog.propTypes = {
  dialogTitle: _react.PropTypes.string,
  actions: _react.PropTypes.array,
  subContent: _react.PropTypes.object,
  hiddenErrorChecking: _react.PropTypes.object,
  mainContent: _react.PropTypes.object
};

exports.default = GenericDialog;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _saveCancelButtons = __webpack_require__(1948);

var _saveCancelButtons2 = _interopRequireDefault(_saveCancelButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GenericRightSideLayout = function GenericRightSideLayout(props) {
  var leftColumnContentText = props.leftColumnContentText,
      rightColumnContentText = props.rightColumnContentText,
      mainContent = props.mainContent,
      subContent = props.subContent,
      shouldSaveCancelButtonsShow = props.shouldSaveCancelButtonsShow,
      saveCancelOuterDivStyle = props.saveCancelOuterDivStyle,
      cancelOnTouchTapFunc = props.cancelOnTouchTapFunc,
      saveOnTouchTapFunc = props.saveOnTouchTapFunc,
      shouldSaveButtonBeDisabled = props.shouldSaveButtonBeDisabled,
      isSupplier = props.isSupplier;


  return _react2.default.createElement(
    'div',
    { style: { overflow: 'visible' } },
    _react2.default.createElement(
      _materialUi.Paper,
      {
        rounded: false,
        zDepth: 1,
        style: isSupplier ? { marginTop: '3%' } : { marginTop: '3%', padding: '3% 5%' }
      },
      _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { overflow: 'hidden' },
        leftColumnClassName: 'full-width-block-label',
        leftColumnContent: leftColumnContentText,
        leftColumnStyle: isSupplier ? {
          height: '48px',
          fontSize: '20px',
          color: 'rgba(0, 0, 0, 0.87)',
          backgroundColor: '#f5f5f5',
          padding: '2%',
          width: '100%'
        } : {
          color: 'rgba(0, 0, 0, 0.87)',
          fontSize: 'calc(12px + 0.5vw)',
          fontWeight: '600',
          padding: '2px'
        },
        rightColumnContent: rightColumnContentText,
        rightColumnClassName: isSupplier ? 'two-column-row-right-button div-link' : 'two-column-row-right-button',
        rightColumnStyle: isSupplier ? { marginTop: '-35px', cursor: 'pointer' } : { height: '32px', top: '1px', position: 'relative', marginRight: '1px' }
      }),
      mainContent,
      subContent ? _react2.default.createElement(
        'div',
        { style: { marginBottom: '50px' } },
        subContent
      ) : _react2.default.createElement('span', null),
      shouldSaveCancelButtonsShow ? _react2.default.createElement(_saveCancelButtons2.default, {
        outerDivStyle: saveCancelOuterDivStyle,
        objectInfoToMap: [{
          labelText: 'Cancel',
          labelStyle: { color: 'rgba(0, 0, 0, 0.54)', fontWeight: '600', top: '4px' },
          style: { backgroundColor: '#d8d8d8', height: '32px', width: '80px', borderRadius: '3px', lineHeight: '1.5', marginRight: '20px' },
          onTouchTap: cancelOnTouchTapFunc
        }, {
          labelText: 'Save',
          labelStyle: { fontWeight: '600', top: '4px' },
          style: { height: '32px', width: '80px', borderRadius: '3px', lineHeight: '1.5' },
          onTouchTap: saveOnTouchTapFunc,
          disableSave: shouldSaveButtonBeDisabled
        }]
      }) : _react2.default.createElement('span', null)
    )
  );
};

GenericRightSideLayout.propTypes = {
  leftColumnContentText: _react.PropTypes.string,
  shouldSaveCancelButtonsShow: _react.PropTypes.bool,
  saveCancelOuterDivStyle: _react.PropTypes.object,
  cancelOnTouchTapFunc: _react.PropTypes.func,
  saveOnTouchTapFunc: _react.PropTypes.func,
  shouldSaveButtonBeDisabled: _react.PropTypes.bool,
  subContent: _react.PropTypes.object,
  rightColumnContentText: _react.PropTypes.object,
  mainContent: _react.PropTypes.any,
  isSupplier: _react.PropTypes.bool
};

exports.default = GenericRightSideLayout;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__(3);

var _Popover = __webpack_require__(1358);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRouter = __webpack_require__(67);

var _partnerFinderActions = __webpack_require__(1125);

var _stopSign = __webpack_require__(3186);

var _stopSign2 = _interopRequireDefault(_stopSign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global document */
var styles = {
  popOver: {
    padding: '1em',
    width: '400px'
  },
  popOver2: {
    padding: '1em',
    width: '500px'
  },
  header: {
    fontSize: '1.3em',
    fontWeight: 'bolder',
    marginBottom: '0.8em'
  },
  paragraph1: {
    marginTop: '0.8em',
    fontSize: '1em'
  },
  inputWrap: {
    overflow: 'auto',
    minHeight: '80px',
    border: '1px solid #00BCD4',
    margin: '0.8em 0 0.8em 0',
    paddingLeft: '0.8em'
  },
  paragraph2: {
    fontSize: '0.8em',
    fontStyle: 'italic',
    marginBottom: '0.8em'
  },
  paragraph_profile1: {
    marginTop: '0.8em',
    fontSize: '1em',
    textAlign: 'center',
    '& p': {
      fontWeight: 'bold'
    }
  },
  paragraph_profile2: {
    fontSize: '0.8em',
    fontStyle: 'italic',
    marginBottom: '0.8em',
    textAlign: 'center'
  }
};
var SendCustomMsg = function SendCustomMsg(_ref) {
  var companyName = _ref.companyName,
      getRespTime = _ref.getRespTime,
      onRequestClose = _ref.onRequestClose,
      sendCustomMsg = _ref.sendCustomMsg,
      sendInvitation = _ref.sendInvitation,
      css = _ref.classes,
      updateCustomizedMsg = _ref.updateCustomizedMsg,
      isMarketingReady = _ref.isMarketingReady,
      marketingReadinessPercentage = _ref.marketingReadinessPercentage;
  var open = sendCustomMsg.open,
      popOverAnchorEl = sendCustomMsg.popOverAnchorEl,
      customizedMessage = sendCustomMsg.customizedMessage,
      receiverInfo = sendCustomMsg.receiverInfo;

  var text = customizedMessage || companyName + ' would like to connect with ' + (0, _ramda.propOr)('you', 'companyName', receiverInfo) + ' on TourConnect.';
  if (!isMarketingReady || marketingReadinessPercentage < 100) {
    return _react2.default.createElement(
      _materialUi.Popover,
      {
        open: open,
        anchorEl: document.getElementById(popOverAnchorEl),
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
        targetOrigin: { horizontal: 'middle', vertical: 'top' },
        animation: _Popover.PopoverAnimationFromTop,
        onRequestClose: onRequestClose,
        className: css.popOver2
      },
      _react2.default.createElement(
        'div',
        { className: css.header },
        'Marketing Profile'
      ),
      _react2.default.createElement(
        'div',
        { className: css.paragraph_profile1 },
        _react2.default.createElement(
          'div',
          { style: { marginBottom: '1em' } },
          _react2.default.createElement('img', { src: _stopSign2.default, style: { width: '150px', height: '150px' } })
        ),
        _react2.default.createElement(
          'p',
          null,
          'Please complete your Marketing Profile',
          _react2.default.createElement('br', null),
          'before sending a Partner Request.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'This helps us maintain the quality of the TourConnect network.'
        )
      ),
      _react2.default.createElement(_materialUi.Divider, null),
      _react2.default.createElement(
        'div',
        { className: css.paragraph_profile2 },
        'If you need help completing your ',
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/profile' },
          'profile'
        ),
        ', ',
        _react2.default.createElement('br', null),
        'please reference our ',
        _react2.default.createElement(
          'a',
          { href: 'https://support.tourconnect.com/en/collections/613143-sales-marketing-marketing-profile', target: '_blank' },
          'help articles and videos'
        ),
        ' or ',
        _react2.default.createElement(
          'a',
          { href: 'support@tourconnect.com' },
          'contact us'
        ),
        '.'
      )
    );
  }
  return _react2.default.createElement(
    _materialUi.Popover,
    {
      open: open,
      anchorEl: document.getElementById(popOverAnchorEl),
      anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      targetOrigin: { horizontal: 'middle', vertical: 'top' },
      animation: _Popover.PopoverAnimationFromTop,
      onRequestClose: onRequestClose,
      className: css.popOver
    },
    _react2.default.createElement(
      'div',
      { className: css.header },
      'Customize your connection request'
    ),
    _react2.default.createElement(_materialUi.Divider, null),
    _react2.default.createElement(
      'div',
      { className: css.paragraph1 },
      'Companies are much more likely to accept your connection \
        request if you send a personal note.'
    ),
    _react2.default.createElement(
      'div',
      { className: css.inputWrap },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-email', color: '#bfbfbf', style: { top: '12px' } }),
      _react2.default.createElement(_materialUi.TextField, {
        id: 'commentBoxTextField',
        hintStyle: { fontSize: '14px' },
        underlineShow: false,
        value: text,
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          return updateCustomizedMsg({ customizedMessage: value });
        },
        style: {
          float: 'right', width: '85%', marginRight: '5%', fontSize: '14px', lineHeight: '18px'
        },
        multiLine: true,
        rowsMax: 5,
        maxLength: '400'
      })
    ),
    _react2.default.createElement(
      'div',
      { className: css.paragraph2 },
      "* Remember, these are B2B connections, so responses may take longer \
          than you expect. Don't be afraid to follow up in a week or two."
    ),
    _react2.default.createElement(_materialUi.RaisedButton, {
      secondary: true,
      style: { float: 'right' },
      label: 'send',
      onTouchTap: function onTouchTap() {
        getRespTime((0, _ramda.prop)('companyId', receiverInfo));
        sendInvitation(customizedMessage, receiverInfo);
      }
    })
  );
};

SendCustomMsg.propTypes = {
  classes: _propTypes2.default.object.isRequired,
  companyName: _propTypes2.default.string.isRequired,
  getRespTime: _propTypes2.default.func.isRequired,
  onRequestClose: _propTypes2.default.func.isRequired,
  sendCustomMsg: _propTypes2.default.object.isRequired,
  sendInvitation: _propTypes2.default.func.isRequired,
  updateCustomizedMsg: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var partnerFinder = _ref3.partnerFinder,
      user = _ref3.user,
      profile = _ref3.profile;
  return {
    isMarketingReady: profile.get('isMarketingReady'),
    marketingReadinessPercentage: profile.get('marketingReadinessPercentage'),
    sendCustomMsg: partnerFinder.get('sendCustomMsg').toJS(),
    userName: user.getIn(['user', 'name']),
    companyName: user.getIn(['company', 'companyName'])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getRespTime: function getRespTime(companyId) {
      return dispatch((0, _partnerFinderActions.connectionResponseTime)(companyId));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(SendCustomMsg));

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var smooth = __webpack_require__(3193);

var easing = smooth.defaultEasing;

var cancelEvents = __webpack_require__(3194);

var events = __webpack_require__(1953);

/*
 * Sets the cancel trigger
 */

cancelEvents.register(function () {
  __cancel = true;
});

/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrame = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var __currentPositionY = 0;
var __startPositionY = 0;
var __targetPositionY = 0;
var __progress = 0;
var __duration = 0;
var __cancel = false;

var __target;
var __to;
var __start;
var __deltaTop;
var __percent;

var currentPositionY = function currentPositionY() {
  var supportPageOffset = window.pageXOffset !== undefined;
  var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
  return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
};

var animateTopScroll = function animateTopScroll(timestamp) {
  // Cancel on specific events
  if (__cancel) {
    return;
  };

  __deltaTop = Math.round(__targetPositionY - __startPositionY);

  if (__start === null) {
    __start = timestamp;
  }

  __progress = timestamp - __start;

  __percent = __progress >= __duration ? 1 : easing(__progress / __duration);

  __currentPositionY = __startPositionY + Math.ceil(__deltaTop * __percent);

  window.scrollTo(0, __currentPositionY);

  if (__percent < 1) {
    requestAnimationFrame(animateTopScroll);
    return;
  }

  if (events.registered['end']) {
    events.registered['end'](__to, __target);
  }
};

var startAnimateTopScroll = function startAnimateTopScroll(y, options, to, target) {
  __start = null;
  __cancel = false;
  __startPositionY = currentPositionY();
  __targetPositionY = y + __startPositionY;
  __duration = options.duration || 1000;
  __to = to;
  __target = target;

  requestAnimationFrame(animateTopScroll);
};

module.exports = {
  animateTopScroll: startAnimateTopScroll
};

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

module.exports = Events;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-var */
/* eslint-env node */

var DayPicker = __webpack_require__(3223);
var DateUtils = __webpack_require__(1136);
var LocaleUtils = __webpack_require__(1538);
var ModifiersUtils = __webpack_require__(1957);
var Weekday = __webpack_require__(1956);
var Navbar = __webpack_require__(1955);
var PropTypes = __webpack_require__(878);

module.exports = DayPicker.default || DayPicker;
module.exports.DateUtils = DateUtils.default || DateUtils;
module.exports.LocaleUtils = LocaleUtils.default || LocaleUtils;
module.exports.ModifiersUtils = ModifiersUtils.default || ModifiersUtils;
module.exports.WeekdayPropTypes = Weekday.WeekdayPropTypes;
module.exports.NavbarPropTypes = Navbar.NavbarPropTypes;
module.exports.PropTypes = PropTypes;


/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavbarPropTypes = undefined;
exports.default = Navbar;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(878);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classNames = __webpack_require__(1536);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Navbar(_ref) {
  var classNames = _ref.classNames,
      className = _ref.className,
      showPreviousButton = _ref.showPreviousButton,
      showNextButton = _ref.showNextButton,
      onPreviousClick = _ref.onPreviousClick,
      onNextClick = _ref.onNextClick,
      labels = _ref.labels,
      dir = _ref.dir;

  var previousClickHandler = dir === 'rtl' ? onNextClick : onPreviousClick;
  var nextClickHandler = dir === 'rtl' ? onPreviousClick : onNextClick;

  var previousButton = showPreviousButton && _react2.default.createElement('span', {
    role: 'button',
    'aria-label': labels.previousMonth,
    key: 'previous',
    className: classNames.navButtonPrev,
    onClick: function onClick() {
      return previousClickHandler();
    }
  });

  var nextButton = showNextButton && _react2.default.createElement('span', {
    role: 'button',
    'aria-label': labels.nextMonth,
    key: 'right',
    className: classNames.navButtonNext,
    onClick: function onClick() {
      return nextClickHandler();
    }
  });

  return _react2.default.createElement(
    'div',
    { className: className || classNames.navBar },
    dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]
  );
}

var NavbarPropTypes = exports.NavbarPropTypes = {
  classNames: _PropTypes2.default.shape({
    navBar: _PropTypes2.default.string.isRequired,
    navButtonPrev: _PropTypes2.default.string.isRequired,
    navButtonNext: _PropTypes2.default.string.isRequired
  }),
  className: _PropTypes2.default.string,
  showPreviousButton: _PropTypes2.default.bool,
  showNextButton: _PropTypes2.default.bool,
  onPreviousClick: _PropTypes2.default.func,
  onNextClick: _PropTypes2.default.func,
  dir: _PropTypes2.default.string,
  labels: _PropTypes2.default.shape({
    previousMonth: _PropTypes2.default.string.isRequired,
    nextMonth: _PropTypes2.default.string.isRequired
  })
};

Navbar.propTypes = NavbarPropTypes;

Navbar.defaultProps = {
  classNames: _classNames2.default,
  dir: 'ltr',
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  showPreviousButton: true,
  showNextButton: true
};
//# sourceMappingURL=Navbar.js.map

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WeekdayPropTypes = undefined;
exports.default = Weekday;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(878);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Weekday(_ref) {
  var weekday = _ref.weekday,
      className = _ref.className,
      weekdaysLong = _ref.weekdaysLong,
      weekdaysShort = _ref.weekdaysShort,
      localeUtils = _ref.localeUtils,
      locale = _ref.locale;

  var title = void 0;
  if (weekdaysLong) {
    title = weekdaysLong[weekday];
  } else {
    title = localeUtils.formatWeekdayLong(weekday, locale);
  }
  var content = void 0;
  if (weekdaysShort) {
    content = weekdaysShort[weekday];
  } else {
    content = localeUtils.formatWeekdayShort(weekday, locale);
  }

  return _react2.default.createElement(
    'div',
    { className: className, role: 'columnheader' },
    _react2.default.createElement(
      'abbr',
      { title: title },
      content
    )
  );
}

var WeekdayPropTypes = exports.WeekdayPropTypes = {
  weekday: _PropTypes2.default.number,
  className: _PropTypes2.default.string,
  locale: _PropTypes2.default.string,
  localeUtils: _PropTypes2.default.localeUtils,

  weekdaysLong: _PropTypes2.default.arrayOf(_PropTypes2.default.string),
  weekdaysShort: _PropTypes2.default.arrayOf(_PropTypes2.default.string)
};

Weekday.propTypes = WeekdayPropTypes;
//# sourceMappingURL=Weekday.js.map

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dayMatchesModifier = dayMatchesModifier;
exports.getModifiersForDay = getModifiersForDay;

var _DateUtils = __webpack_require__(1136);

var _Helpers = __webpack_require__(1537);

/**
 * Return `true` if a date matches the specified modifier.
 * 
 * @export
 * @param {Date} day
 * @param {Any} modifier 
 * @return {Boolean}
 */
function dayMatchesModifier(day, modifier) {
  if (!modifier) {
    return false;
  }
  var arr = Array.isArray(modifier) ? modifier : [modifier];
  return arr.some(function (mod) {
    if (!mod) {
      return false;
    }
    if (mod instanceof Date) {
      return (0, _DateUtils.isSameDay)(day, mod);
    }
    if ((0, _Helpers.isRangeOfDates)(mod)) {
      return (0, _DateUtils.isDayInRange)(day, mod);
    }
    if (mod.after) {
      return (0, _DateUtils.isDayAfter)(day, mod.after);
    }
    if (mod.before) {
      return (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.daysOfWeek) {
      return mod.daysOfWeek.some(function (dayOfWeek) {
        return day.getDay() === dayOfWeek;
      });
    }
    if (typeof mod === 'function') {
      return mod(day);
    }
    return false;
  });
}

/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 * 
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}] 
 * @return {Array}
 */
function getModifiersForDay(day) {
  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
    var value = modifiersObj[modifierName];
    if (dayMatchesModifier(day, value)) {
      modifiers.push(modifierName);
    }
    return modifiers;
  }, []);
}

exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };
//# sourceMappingURL=ModifiersUtils.js.map

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTemplates = exports.clearStore = exports.updateProps = exports.getLocations = undefined;
exports.getContractRequestInfo = getContractRequestInfo;

var _constants = __webpack_require__(648);

var constants = _interopRequireWildcard(_constants);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _actions = __webpack_require__(537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var callApiGet = function callApiGet(url) {
  return fetch(url, {
    method: 'get',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
  }).then(_checkStatus2.default);
};
var callApiPost = function callApiPost(url, body) {
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(body),
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
  }).then(_checkStatus2.default);
};
var query = 'query getLocations ($companyId: ID!) {\n  companyProfile  (id: $companyId){\n        locations {\n          name\n          id\n          isMarketingReady\n        }\n  }\n}';
var getLocations = exports.getLocations = function getLocations() {
  return function (dispatch) {
    dispatch({ type: constants.UPDATE_PROPS, payload: { loadingLocations: true } });
    return callApiGet('/proxy/profile?query=' + query).then(function (res) {
      return res.json();
    }).then(function (payload) {
      return dispatch({ type: constants.LOCATIONS_LOADED, payload: payload });
    }).catch(function () {
      dispatch({ type: constants.UPDATE_PROPS, payload: { loadingLocations: false } });
    });
  };
};
var updateProps = exports.updateProps = function updateProps(payload) {
  return { type: constants.UPDATE_PROPS, payload: payload };
};
var clearStore = exports.clearStore = function clearStore() {
  return { type: constants.CLEAR_STORE };
};
var getTemplates = exports.getTemplates = function getTemplates() {
  return function (dispatch) {
    dispatch({ type: constants.LOADING_TEMPLATES });
    var qs = _queryString2.default.stringify({ additionalProjection: JSON.stringify({ products: 1 }) });
    return callApiGet('/proxy/contracting/templates?' + qs).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({ type: constants.TEMPLATES_LOADED, payload: _ramda2.default.merge(res, { loading: false }) });
    }) // res = { templates, templateGroups }
    .catch(function () {
      dispatch({ type: constants.LOADING_TEMPLATES });
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Loading Templates Failed' });
    });
  };
};

function getContractRequestInfo(contractId) {
  return {
    type: constants.GET_CONTRACT_REQUEST_INFO,
    payload: contractId
  };
}

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _templateListActions = __webpack_require__(877);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _createDraftForm = __webpack_require__(1960);

var _createDraftForm2 = _interopRequireDefault(_createDraftForm);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  creatingDraft: _react2.default.PropTypes.bool,
  updateProps: _react2.default.PropTypes.func,
  createDraft: _react2.default.PropTypes.func,
  getLocationsAndProducts: _react2.default.PropTypes.func,
  createDraftError: _react2.default.PropTypes.string,
  locations: _react2.default.PropTypes.array,
  startDate: _react2.default.PropTypes.string,
  endDate: _react2.default.PropTypes.string,
  templateName: _react2.default.PropTypes.string,
  style: _react2.default.PropTypes.object,
  prefillData: _react2.default.PropTypes.object,
  getTemplates: _react2.default.PropTypes.func,
  draftRateType: _react2.default.PropTypes.string,
  draftCommissionPercentage: _react2.default.PropTypes.number,
  draftNettCommission: _react2.default.PropTypes.number
};

var CreateTemplateDraftFormAndButtons = function (_React$Component) {
  _inherits(CreateTemplateDraftFormAndButtons, _React$Component);

  function CreateTemplateDraftFormAndButtons() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CreateTemplateDraftFormAndButtons);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreateTemplateDraftFormAndButtons.__proto__ || Object.getPrototypeOf(CreateTemplateDraftFormAndButtons)).call.apply(_ref, [this].concat(args))), _this), _this.createDraft = function () {
      var _this$props = _this.props,
          startDate = _this$props.startDate,
          endDate = _this$props.endDate,
          locations = _this$props.locations,
          templateName = _this$props.templateName,
          updateProps = _this$props.updateProps,
          createDraft = _this$props.createDraft,
          draftRateType = _this$props.draftRateType,
          draftCommissionPercentage = _this$props.draftCommissionPercentage,
          draftNettCommission = _this$props.draftNettCommission,
          copyDataFromTemplate = _this$props.copyDataFromTemplate;

      var updatedContactInfoComplete = function updatedContactInfoComplete(contactInfo) {
        return contactInfo.address && (contactInfo.address.address_1 || contactInfo.formattedAddress) && contactInfo.phone && contactInfo.firstName && contactInfo.lastName;
      };
      var locationsValid = locations.filter(_ramda2.default.propEq('checked', true)).every(function (loc) {
        return loc.contactInfoComplete || updatedContactInfoComplete(loc.contactInfo);
      });
      var dataValid = _ramda2.default.call(_ramda2.default.allPass([function () {
        return startDate;
      }, function () {
        return endDate;
      }, function () {
        return _ramda2.default.any(_ramda2.default.propEq('checked', true), locations);
      }, function () {
        return templateName;
      }, function () {
        return locationsValid;
      }]));
      if (dataValid) {
        createDraft({
          startDate: startDate,
          endDate: endDate,
          locations: locations,
          templateName: templateName,
          draftRateType: draftRateType,
          draftCommissionPercentage: draftCommissionPercentage,
          draftNettCommission: draftNettCommission,
          copyDataFromTemplate: copyDataFromTemplate
        }).then(function (res) {
          var draftsLength = _ramda2.default.pathOr(0, ['payload', 'drafts', 'length'], res);
          var firstDraft = _ramda2.default.pathOr({}, ['payload', 'drafts', 0], res);
          if (draftsLength > 1) _this.context.router.replace('/contracting/template-list');
          if (draftsLength === 1) _this.context.router.replace('/contracting/draft/' + firstDraft.originalContractId + '/details');
        });
      } else updateProps({ createDraftError: 'Please fill all required fields' });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CreateTemplateDraftFormAndButtons, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          prefillData = _props.prefillData,
          updateProps = _props.updateProps,
          getLocationsAndProducts = _props.getLocationsAndProducts;

      var _ref2 = prefillData || {},
          startDate = _ref2.startDate,
          endDate = _ref2.endDate,
          locationId = _ref2.locationId;

      updateProps({
        newDraftStartDate: startDate || undefined,
        newDraftEndDate: endDate || undefined,
        newDraftName: function () {
          if (startDate && endDate) {
            var startFormatted = _moment2.default.utc(startDate).format('DD MMM YYYY');
            var endFormatted = _moment2.default.utc(endDate).format('DD MMM YYYY');
            if (startFormatted === endFormatted) return startFormatted + ' Rates Template';
            return startFormatted + ' - ' + endFormatted + ' Rates Template';
          }
          return 'Rates Template';
        }()
      });
      getLocationsAndProducts(locationId);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react2.default.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          creatingDraft = _props2.creatingDraft,
          updateProps = _props2.updateProps,
          createDraftError = _props2.createDraftError,
          locations = _props2.locations,
          style = _props2.style,
          prefillData = _props2.prefillData,
          copyDataFromTemplate = _props2.copyDataFromTemplate;

      return _react2.default.createElement(
        'div',
        { style: style },
        _react2.default.createElement(_createDraftForm2.default, {
          updateProps: updateProps,
          hideDates: Boolean(prefillData && prefillData.startDate && prefillData.endDate)
        }),
        _react2.default.createElement(_raisedButtonWithLoader2.default, {
          'data-cy': 'createTemplateDraftButton',
          style: { marginTop: '24px' },
          label: 'start',
          disabled: !_ramda2.default.any(_ramda2.default.propEq('checked', true), locations),
          loader: creatingDraft,
          secondary: true,
          onTouchTap: this.createDraft
        }),
        _react2.default.createElement(
          'span',
          { style: { color: 'red', paddingLeft: '16px' } },
          createDraftError
        )
      );
    }
  }]);

  return CreateTemplateDraftFormAndButtons;
}(_react2.default.Component);

CreateTemplateDraftFormAndButtons.propTypes = propTypes;
CreateTemplateDraftFormAndButtons.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
var mapStateToProps = function mapStateToProps(_ref3) {
  var contracting = _ref3.contracting;
  return {
    createDraftError: contracting.templateList.get('createDraftError'),
    locations: contracting.templateList.get('locations').toJS(),
    startDate: contracting.templateList.get('newDraftStartDate'),
    endDate: contracting.templateList.get('newDraftEndDate'),
    templateName: contracting.templateList.get('newDraftName'),
    draftRateType: contracting.templateList.get('draftRateType'),
    draftCommissionPercentage: contracting.templateList.get('draftCommissionPercentage'),
    draftNettCommission: contracting.templateList.get('draftNettCommission')
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProps: function updateProps(payload) {
      return dispatch((0, _templateListActions.updateProps)(payload));
    },
    createDraft: function createDraft() {
      return dispatch(_templateListActions.createDraft.apply(undefined, arguments));
    },
    getLocationsAndProducts: function getLocationsAndProducts() {
      return dispatch(_templateListActions.getLocationsAndProducts.apply(undefined, arguments));
    }
  };
};
CreateTemplateDraftFormAndButtons.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CreateTemplateDraftFormAndButtons);

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _immutable = __webpack_require__(26);

var _selectLocationsProducts = __webpack_require__(3237);

var _selectLocationsProducts2 = _interopRequireDefault(_selectLocationsProducts);

var _contractingYear = __webpack_require__(1539);

var _contractingYear2 = _interopRequireDefault(_contractingYear);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _RateType = __webpack_require__(1257);

var _RateType2 = _interopRequireDefault(_RateType);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var currentYear = new Date().getFullYear();
var getDatesByCountry = function getDatesByCountry(country) {
  if (country === 'United States' || country === 'United Kingdom') {
    return {
      dateLabel: country === 'United States' ? 'Jan 01 ' + (currentYear + 1) + ' - Dec 31 ' + (currentYear + 1) : '01 Jan ' + (currentYear + 1) + ' - 31 Dec ' + (currentYear + 1),
      startDate: currentYear + 1 + '-01-01 00:00:00.000Z',
      endDate: currentYear + 1 + '-12-31 00:00:00.000Z'
    };
  }
  return {
    dateLabel: '01 Apr ' + (currentYear + 1) + ' - 31 Mar ' + (currentYear + 2),
    startDate: currentYear + 1 + '-04-01 00:00:00.000Z',
    endDate: currentYear + 2 + '-03-31 00:00:00.000Z'
  };
};

var CreateTemplateDraft = function (_Component) {
  _inherits(CreateTemplateDraft, _Component);

  function CreateTemplateDraft() {
    _classCallCheck(this, CreateTemplateDraft);

    return _possibleConstructorReturn(this, (CreateTemplateDraft.__proto__ || Object.getPrototypeOf(CreateTemplateDraft)).call(this));
  }
  // handleQuickStartClick = obj => () => {
  //   this.props.updateProps({
  //     quickStartSelected: obj,
  //     newDraftName: `${obj.dateLabel} ${obj.rateType === 'nett' ? 'Nett' : `${obj.commissionPercentage}%`} Rate Template`,
  //     draftRateType: obj.rateType,
  //     draftCommissionPercentage: obj.commissionPercentage,
  //     draftNettCommission: obj.nettCommission,
  //     newDraftStartDate: obj.startDate,
  //     newDraftEndDate: obj.endDate,
  //   });
  // };
  // handleCustomClick = () => {
  //   this.props.updateProps(this.props.hideDates ? {
  //     quickStartSelected: { type: 'custom' },
  //     newDraftName: `Rate Template`,
  //     draftRateType: '',
  //     draftCommissionPercentage: '',
  //   } : {
  //     quickStartSelected: { type: 'custom' },
  //     newDraftName: `Rate Template`,
  //     draftRateType: '',
  //     draftCommissionPercentage: '',
  //     newDraftStartDate: '',
  //     newDraftEndDate: '',
  //   });
  // };


  _createClass(CreateTemplateDraft, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          updateProps = _props.updateProps,
          newDraftStartDate = _props.newDraftStartDate,
          newDraftEndDate = _props.newDraftEndDate,
          newDraftName = _props.newDraftName,
          locations = _props.locations,
          hideDates = _props.hideDates,
          hasAccessToCreateLoc = _props.hasAccessToCreateLoc,
          isSingleLoc = _props.isSingleLoc,
          country = _props.country,
          draftRateType = _props.draftRateType,
          draftCommissionPercentage = _props.draftCommissionPercentage,
          draftNettCommission = _props.draftNettCommission,
          quickStartSelected = _props.quickStartSelected;

      var nextStep = Boolean(quickStartSelected.type);
      // const format = country === 'United States' ? 'MMM DD YYYY' : 'DD MMM YYYY';
      // const quickStartPeriod = hideDates ? {
      //   dateLabel: `${moment.utc(newDraftStartDate).format(format)} - ${moment.utc(newDraftEndDate).format(format)}`,
      //   startDate: newDraftStartDate,
      //   endDate: newDraftEndDate,
      // } : getDatesByCountry(country);
      // const quickStarts = [{
      //   type: 25,
      //   rateType: 'includeCommission',
      //   commissionPercentage: 25,
      //   ...quickStartPeriod,
      // },{
      //   type: 20,
      //   rateType: 'includeCommission',
      //   commissionPercentage: 20,
      //   ...quickStartPeriod,
      // }, {
      //   type: '0',
      //   rateType: 'nett',
      //   nettCommission: 0,
      //   ...quickStartPeriod,
      // }];
      return _react2.default.createElement(
        'div',
        { style: { maxWidth: '800px', margin: 'auto', paddingTop: '12px' } },
        nextStep && _react2.default.createElement(
          'div',
          { style: { marginTop: '16px' } },
          quickStartSelected.type && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Please enter a name for the template:'
              )
            ),
            ' ',
            _react2.default.createElement(
              'span',
              { style: { color: 'red' } },
              '* Required'
            ),
            _react2.default.createElement(_materialUi.TextField, {
              'data-cy': 'templateNameField',
              style: { display: 'block', width: '400px' },
              inputStyle: { fontSize: '13px' },
              hintText: 'Name the new template',
              value: newDraftName,
              onChange: function onChange(_, value) {
                return updateProps({ newDraftName: value, createDraftError: '' });
              }
            }),
            !hideDates && _react2.default.createElement(_contractingYear2.default, {
              required: true,
              startDate: newDraftStartDate,
              endDate: newDraftEndDate,
              onChange: function onChange(key, val) {
                var _updateProps;

                return updateProps((_updateProps = {}, _defineProperty(_updateProps, 'newDraft' + (key === 'startDate' ? 'StartDate' : 'EndDate'), val), _defineProperty(_updateProps, 'createDraftError', ''), _updateProps));
              }
            }),
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Please select a rate type:'
              )
            ),
            _react2.default.createElement(_RateType2.default, {
              rateType: draftRateType,
              commissionPercentage: draftCommissionPercentage,
              nettCommission: draftNettCommission,
              updateRateType: function updateRateType(value) {
                return updateProps({ draftRateType: value });
              },
              updateCommission: function updateCommission(value) {
                return updateProps({ draftCommissionPercentage: value });
              },
              updateNettCommission: function updateNettCommission(value) {
                return updateProps({ draftNettCommission: value });
              }
            })
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '16px', display: nextStep ? 'block' : 'none' } },
            _react2.default.createElement(_selectLocationsProducts2.default, {
              style: { width: '80%' },
              isSingleLoc: isSingleLoc,
              hasAccessToCreateLoc: hasAccessToCreateLoc,
              locations: locations,
              updateProps: updateProps,
              checkAllLocations: function checkAllLocations(checked) {
                var updatedLocations = locations.map(function (loc) {
                  return _ramda2.default.merge(loc, {
                    checked: checked,
                    products: loc.products.map(_ramda2.default.merge(_ramda2.default.__, { checked: checked }))
                  });
                });
                updateProps({ locations: updatedLocations, createDraftError: '' });
              },
              checkLocation: function checkLocation(locationIndex, checked) {
                var updatedLocations = (0, _immutable.fromJS)(locations).setIn([locationIndex, 'checked'], checked).updateIn([locationIndex, 'products'], function (products) {
                  return products.map(function (product) {
                    return product.set('checked', checked);
                  });
                });
                updateProps({ locations: updatedLocations, createDraftError: '' });
              },
              checkProduct: function checkProduct(locationIndex, productIndex, checked) {
                var updatedLocations = (0, _immutable.fromJS)(locations).setIn([locationIndex, 'products', productIndex, 'checked'], checked);
                updateProps({ locations: updatedLocations, createDraftError: '' });
              }
            })
          )
        )
      );
    }
  }]);

  return CreateTemplateDraft;
}(_react.Component);

CreateTemplateDraft.propTypes = {
  updateProps: _react.PropTypes.func,
  newDraftStartDate: _react.PropTypes.string,
  newDraftEndDate: _react.PropTypes.string,
  newDraftName: _react.PropTypes.string,
  locations: _react.PropTypes.array,
  hideDates: _react.PropTypes.bool,
  hasAccessToCreateLoc: _react.PropTypes.bool,
  isSingleLoc: _react.PropTypes.bool,
  country: _react.PropTypes.string,
  draftRateType: _react.PropTypes.string,
  draftCommissionPercentage: _react.PropTypes.number,
  draftNettCommission: _react.PropTypes.number,
  quickStartSelected: _react.PropTypes.object
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user;

  return {
    quickStartSelected: contracting.templateList.get('quickStartSelected') ? contracting.templateList.get('quickStartSelected').toJS() : {},
    newDraftStartDate: contracting.templateList.get('newDraftStartDate'),
    newDraftEndDate: contracting.templateList.get('newDraftEndDate'),
    newDraftName: contracting.templateList.get('newDraftName'),
    draftRateType: contracting.templateList.get('draftRateType'),
    draftCommissionPercentage: contracting.templateList.get('draftCommissionPercentage'),
    draftNettCommission: contracting.templateList.get('draftNettCommission'),
    locations: contracting.templateList.get('locations').toJS(),
    hasAccessToCreateLoc: _ramda2.default.contains('createLocation', user.get('corporateAccess') || []),
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
    country: user.getIn(['company', 'address']).country
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CreateTemplateDraft);

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _datePicker = __webpack_require__(1003);

var _datePicker2 = _interopRequireDefault(_datePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var currentYear = new Date().getFullYear();
var subOptionsMap = {
  calendarYear: [{
    label: '01 Jan ' + currentYear + ' - 31 Dec ' + currentYear,
    value: currentYear + '-01-01T00:00:00.000Z|' + currentYear + '-12-31T00:00:00.000Z',
    period: {
      startDate: currentYear + '-01-01T00:00:00.000Z',
      endDate: currentYear + '-12-31T00:00:00.000Z'
    }
  }, {
    label: '01 Jan ' + (currentYear + 1) + ' - 31 Dec ' + (currentYear + 1),
    value: currentYear + 1 + '-01-01T00:00:00.000Z|' + (currentYear + 1) + '-12-31T00:00:00.000Z',
    period: {
      startDate: currentYear + 1 + '-01-01T00:00:00.000Z',
      endDate: currentYear + 1 + '-12-31T00:00:00.000Z'
    }
  }, {
    label: '01 Jan ' + (currentYear + 2) + ' - 31 Dec ' + (currentYear + 2),
    value: currentYear + 2 + '-01-01T00:00:00.000Z|' + (currentYear + 2) + '-12-31T00:00:00.000Z',
    period: {
      startDate: currentYear + 2 + '-01-01T00:00:00.000Z',
      endDate: currentYear + 2 + '-12-31T00:00:00.000Z'
    }
  }],
  firstHalf: [{
    label: '01 Jan ' + currentYear + ' - 30 Jun ' + currentYear,
    value: currentYear + '-01-01T00:00:00.000Z|' + currentYear + '-06-30T00:00:00.000Z',
    period: {
      startDate: currentYear + '-01-01T00:00:00.000Z',
      endDate: currentYear + '-06-30T00:00:00.000Z'
    }
  }, {
    label: '01 Jan ' + (currentYear + 1) + ' - 30 Jun ' + (currentYear + 1),
    value: currentYear + 1 + '-01-01T00:00:00.000Z|' + (currentYear + 1) + '-06-30T00:00:00.000Z',
    period: {
      startDate: currentYear + 1 + '-01-01T00:00:00.000Z',
      endDate: currentYear + 1 + '-06-30T00:00:00.000Z'
    }
  }, {
    label: '01 Jan ' + (currentYear + 2) + ' - 30 Jun ' + (currentYear + 2),
    value: currentYear + 2 + '-01-01T00:00:00.000Z|' + (currentYear + 2) + '-06-30T00:00:00.000Z',
    period: {
      startDate: currentYear + 2 + '-01-01T00:00:00.000Z',
      endDate: currentYear + 2 + '-06-30T00:00:00.000Z'
    }
  }],
  secondHalf: [{
    label: '01 Jul ' + currentYear + ' - 31 Dec ' + currentYear,
    value: currentYear + '-07-01T00:00:00.000Z|' + currentYear + '-12-31T00:00:00.000Z',
    period: {
      startDate: currentYear + '-07-01T00:00:00.000Z',
      endDate: currentYear + '-12-31T00:00:00.000Z'
    }
  }, {
    label: '01 Jul ' + (currentYear + 1) + ' - 31 Dec ' + (currentYear + 1),
    value: currentYear + 1 + '-07-01T00:00:00.000Z|' + (currentYear + 1) + '-12-31T00:00:00.000Z',
    period: {
      startDate: currentYear + 1 + '-07-01T00:00:00.000Z',
      endDate: currentYear + 1 + '-12-31T00:00:00.000Z'
    }
  }, {
    label: '01 Jul ' + (currentYear + 2) + ' - 31 Dec ' + (currentYear + 2),
    value: currentYear + 2 + '-07-01T00:00:00.000Z|' + (currentYear + 2) + '-12-31T00:00:00.000Z',
    period: {
      startDate: currentYear + 2 + '-07-01T00:00:00.000Z',
      endDate: currentYear + 2 + '-12-31T00:00:00.000Z'
    }
  }],
  aprMar: [{
    label: '01 Apr ' + currentYear + ' - 31 Mar ' + (currentYear + 1),
    value: currentYear + '-04-01T00:00:00.000Z|' + (currentYear + 1) + '-03-31T00:00:00.000Z',
    period: {
      startDate: currentYear + '-04-01T00:00:00.000Z',
      endDate: currentYear + 1 + '-03-31T00:00:00.000Z'
    }
  }, {
    label: '01 Apr ' + (currentYear + 1) + ' - 31 Mar ' + (currentYear + 2),
    value: currentYear + 1 + '-04-01T00:00:00.000Z|' + (currentYear + 2) + '-03-31T00:00:00.000Z',
    period: {
      startDate: currentYear + 1 + '-04-01T00:00:00.000Z',
      endDate: currentYear + 2 + '-03-31T00:00:00.000Z'
    }
  }, {
    label: '01 Apr ' + (currentYear + 2) + ' - 31 Mar ' + (currentYear + 3),
    value: currentYear + 2 + '-04-01T00:00:00.000Z|' + (currentYear + 3) + '-03-31T00:00:00.000Z',
    period: {
      startDate: currentYear + 2 + '-04-01T00:00:00.000Z',
      endDate: currentYear + 3 + '-03-31T00:00:00.000Z'
    }
  }],
  octSep: [{
    label: '01 Oct ' + currentYear + ' - 30 Sep ' + (currentYear + 1),
    value: currentYear + '-10-01T00:00:00.000Z|' + (currentYear + 1) + '-09-30T00:00:00.000Z',
    period: {
      startDate: currentYear + '-10-01T00:00:00.000Z',
      endDate: currentYear + 1 + '-09-30T00:00:00.000Z'
    }
  }, {
    label: '01 Oct ' + (currentYear + 1) + ' - 30 Sep ' + (currentYear + 2),
    value: currentYear + 1 + '-10-01T00:00:00.000Z|' + (currentYear + 2) + '-09-30T00:00:00.000Z',
    period: {
      startDate: currentYear + 1 + '-10-01T00:00:00.000Z',
      endDate: currentYear + 2 + '-09-30T00:00:00.000Z'
    }
  }, {
    label: '01 Oct ' + (currentYear + 2) + ' - 30 Sep ' + (currentYear + 3),
    value: currentYear + 2 + '-10-01T00:00:00.000Z|' + (currentYear + 3) + '-09-30T00:00:00.000Z',
    period: {
      startDate: currentYear + 2 + '-10-01T00:00:00.000Z',
      endDate: currentYear + 3 + '-09-30T00:00:00.000Z'
    }
  }]
};
var options = [{ label: 'Calendar Year', value: 'calendarYear' }, { label: '1st Half of Year', value: 'firstHalf' }, { label: '2nd Half of Year', value: 'secondHalf' }, { label: '01 Apr - 31 Mar', value: 'aprMar' }, { label: '01 Oct - 30 Sep', value: 'octSep' }, { label: 'Custom date range', value: 'other' }];

var getOptionFromDate = function getOptionFromDate(startDate, endDate) {
  if (_moment2.default.utc(startDate).toISOString().indexOf('-01-01') > -1 && _moment2.default.utc(endDate).toISOString().indexOf('-12-31') > -1) {
    return 'calendarYear';
  }
  if (_moment2.default.utc(startDate).toISOString().indexOf('-01-01') > -1 && _moment2.default.utc(endDate).toISOString().indexOf('-06-30') > -1) {
    return 'firstHalf';
  }
  if (_moment2.default.utc(startDate).toISOString().indexOf('-07-01') > -1 && _moment2.default.utc(endDate).toISOString().indexOf('-12-31') > -1) {
    return 'secondHalf';
  }
  if (_moment2.default.utc(startDate).toISOString().indexOf('-04-01') > -1 && _moment2.default.utc(endDate).toISOString().indexOf('-03-31') > -1) {
    return 'aprMar';
  }
  if (_moment2.default.utc(startDate).toISOString().indexOf('-10-01') > -1 && _moment2.default.utc(endDate).toISOString().indexOf('-09-30') > -1) {
    return 'octSep';
  }
  return 'other';
};

var ContractingPeriodSelection = function (_Component) {
  _inherits(ContractingPeriodSelection, _Component);

  function ContractingPeriodSelection(props) {
    _classCallCheck(this, ContractingPeriodSelection);

    var _this = _possibleConstructorReturn(this, (ContractingPeriodSelection.__proto__ || Object.getPrototypeOf(ContractingPeriodSelection)).call(this, props));

    _initialiseProps.call(_this);

    var period = { startDate: props.startDate, endDate: props.endDate };
    var stringValue = props.startDate ? _moment2.default.utc(props.startDate).toISOString() + '|' + _moment2.default.utc(props.endDate).toISOString() : '';
    var mainOptionValue = props.startDate ? getOptionFromDate(props.startDate, props.endDate) : '';
    _this.state = {
      fromProps: {
        period: period,
        stringValue: stringValue,
        mainOptionValue: mainOptionValue
      },
      period: period,
      stringValue: stringValue,
      mainOptionValue: mainOptionValue
    };
    return _this;
  }

  _createClass(ContractingPeriodSelection, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          fromProps = _state.fromProps,
          period = _state.period,
          stringValue = _state.stringValue,
          mainOptionValue = _state.mainOptionValue;
      var startDate = period.startDate,
          endDate = period.endDate;

      var subOptions = subOptionsMap[mainOptionValue] || [];
      var isInTheHardCodedList = fromProps.mainOptionValue === 'other' || subOptions.find(function (obj) {
        return obj.value === fromProps.stringValue;
      });
      if (!isInTheHardCodedList && fromProps.mainOptionValue === mainOptionValue) {
        subOptions = [{
          label: _moment2.default.utc(fromProps.period.startDate).format('DD MMM YYYY') + ' - ' + _moment2.default.utc(fromProps.period.endDate).format('DD MMM YYYY'),
          value: fromProps.stringValue,
          period: fromProps.period
        }].concat(_toConsumableArray(subOptions));
      }
      subOptions = _ramda2.default.uniqBy(_ramda2.default.prop('value'), subOptions);
      return _react2.default.createElement(
        'div',
        { style: this.props.style },
        _react2.default.createElement(
          _materialUi.SelectField,
          {
            hintText: 'Click to Pick An Option',
            'data-cy': 'dateRangeSelection',
            value: mainOptionValue,
            onChange: this.onMainOptionSelectionChange
          },
          options.map(function (option) {
            return _react2.default.createElement(_materialUi.MenuItem, {
              key: option.value,
              'data-cy': option.label,
              primaryText: option.label,
              value: option.value
            });
          })
        ),
        mainOptionValue && mainOptionValue !== 'other' && _react2.default.createElement(
          'div',
          { style: { marginBottom: '16px' } },
          'Select A Date Range',
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            _materialUi.RadioButtonGroup,
            {
              name: 'dateRangeSelection',
              valueSelected: stringValue,
              onChange: this.onSelectionChange
            },
            subOptions.map(function (option, i) {
              return _react2.default.createElement(_materialUi.RadioButton, {
                key: option.label,
                label: option.label,
                value: option.value
              });
            })
          )
        ),
        mainOptionValue === 'other' && _react2.default.createElement(
          'div',
          { style: { marginBottom: '16px' } },
          _react2.default.createElement(_datePicker2.default, {
            'data-cy': 'templateStartDateField',
            containerStyle: { display: 'inline-block', verticalAlign: 'top' },
            textFieldStyle: { width: '100%', fontSize: '12px' },
            onChange: this.onStartDateTFChange,
            initialMonth: startDate || endDate,
            value: startDate,
            floatingLabelText: 'Start Date',
            closeOnSelect: true
          }),
          _react2.default.createElement(_datePicker2.default, {
            'data-cy': 'templateEndDateField',
            containerStyle: { display: 'inline-block', marginLeft: '32px', verticalAlign: 'top' },
            textFieldStyle: { width: '100%', fontSize: '12px' },
            onChange: this.onEndDateTFChange,
            initialMonth: endDate || startDate,
            value: endDate,
            floatingLabelText: 'End Date',
            closeOnSelect: true
          })
        )
      );
    }
  }]);

  return ContractingPeriodSelection;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onMainOptionSelectionChange = function (e, i, value) {
    _this2.setState({ mainOptionValue: value, period: {}, stringValue: '' }, function () {
      _this2.props.onChange({});
    });
  };

  this.onSelectionChange = function (_, value) {
    var period = {
      startDate: value.split('|')[0],
      endDate: value.split('|')[1]
    };
    _this2.setState({ period: period, stringValue: value });
    _this2.props.onChange(period);
  };

  this.onStartDateTFChange = function (date) {
    var endDate = _this2.state.period.endDate;

    if (endDate) _this2.props.onChange({ startDate: date, endDate: endDate });
    _this2.setState({ period: { startDate: date, endDate: endDate } });
  };

  this.onEndDateTFChange = function (date) {
    var startDate = _this2.state.period.startDate;

    if (startDate) _this2.props.onChange({ startDate: startDate, endDate: date });
    _this2.setState({ period: { startDate: startDate, endDate: date } });
  };
};

ContractingPeriodSelection.propTypes = {
  onChange: _react.PropTypes.func,
  value: _react.PropTypes.string,
  style: _react.PropTypes.object,
  startDate: _react.PropTypes.string,
  endDate: _react.PropTypes.string
};
exports.default = ContractingPeriodSelection;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionOpenInNew = function ActionOpenInNew(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
  );
};
ActionOpenInNew = (0, _pure2.default)(ActionOpenInNew);
ActionOpenInNew.displayName = 'ActionOpenInNew';
ActionOpenInNew.muiName = 'SvgIcon';

exports.default = ActionOpenInNew;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadExistingConnections = exports.getContractRequest = exports.clearStore = undefined;
exports.updateProps = updateProps;
exports.processPartners = processPartners;
exports.checkConnection = checkConnection;
exports.getContractingPartners = getContractingPartners;
exports.uncheckConnection = uncheckConnection;

var _constants = __webpack_require__(1846);

var constants = _interopRequireWildcard(_constants);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _http = __webpack_require__(118);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _querystring = __webpack_require__(1831);

var _querystring2 = _interopRequireDefault(_querystring);

var _actions = __webpack_require__(537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var callApiPost = function callApiPost(url, body) {
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(body),
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
  }).then(_checkStatus2.default);
};
var callApiGet = function callApiGet(url) {
  return fetch(url, {
    method: 'get',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
  }).then(_checkStatus2.default);
};
var clearStore = exports.clearStore = function clearStore() {
  return { type: constants.CLEAR_STORE };
};
function updateProps(payload) {
  return { type: constants.UPDATE_PROPS, payload: payload };
};

var getContractRequest = exports.getContractRequest = function getContractRequest(payload) {
  return function (dispatch, getState) {
    dispatch(updateProps({ gettingRequests: true }));
    return (0, _http.get)('/proxy/contracting/requests?' + _querystring2.default.stringify(_ramda2.default.merge(payload, {
      emails: JSON.stringify(payload.emails)
    }))).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({ type: 'GOT_MATCHED_REQUESTS_FOR_SUPPLIER_SENDING_RATES', payload: res });
    }).catch(function (err) {
      console.log(err);
      dispatch(updateProps({ gettingRequests: false }));
    });
  };
};
function processPartners(payload, startDate, endDate) {
  return function (dispatch) {
    dispatch(updateProps(payload));
    dispatch({ type: constants.PROCESSING_PARTNERS });
    return callApiPost('/proxy/contracting/processingPartners', { partners: payload.partnersToSendTo, startDate: startDate, endDate: endDate }).then(function (res) {
      return res.json();
    }).then(function (_ref) {
      var processedPartners = _ref.processedPartners;
      return dispatch({
        type: constants.PARTNERS_PROCESSED,
        payload: _ramda2.default.merge(payload || {}, { partnersToSendTo: processedPartners, processingPartners: false }) });
    }).catch(function () {
      dispatch({ type: constants.PROCESSING_PARTNERS });
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Processing Partners Failed' });
    });
  };
}

function checkConnection(payload) {
  return { type: constants.CHECK_CONNECTION, payload: payload };
}

function getContractingPartners(startDate, endDate) {
  return function (dispatch) {
    return callApiGet('/proxy/contracting/partners?startDate=' + startDate + '&endDate=' + endDate).then(function (res) {
      return res.json();
    }).then(function (res) {
      return dispatch({ type: constants.GOT_CONTRACTING_PARTNERS, payload: res });
    });
  };
}
function uncheckConnection(payload) {
  return { type: constants.UNCHECK_CONNECTION, payload: payload };
}
var loadExistingConnections = exports.loadExistingConnections = function loadExistingConnections() {
  return (0, _actions.loadPartners)(constants.LOADING_EXISTING_CONNECTIONS, constants.GOT_EXISTING_CONNECTIONS);
};

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fontFamily = "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif";

var SingleAllocation = function SingleAllocation(_ref) {
  var style = _ref.style,
      index = _ref.index,
      allocationType = _ref.allocationType,
      allotments = _ref.allotments,
      releaseBackDays = _ref.releaseBackDays,
      numberOfRooms = _ref.numberOfRooms,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      addOneElementWithKeyPath = _ref.addOneElementWithKeyPath,
      deleteOneElementWithKeyPath = _ref.deleteOneElementWithKeyPath,
      showError = _ref.showError;

  return _react2.default.createElement(
    'div',
    { style: _extends({ width: '50%', marginLeft: '25%' }, style) },
    _react2.default.createElement(
      _materialUi.SelectField,
      {
        hintText: 'Please select',
        hintStyle: { fontSize: '14px', fontFamily: fontFamily },
        style: { width: '40%' },
        labelStyle: { fontSize: '14px', fontFamily: fontFamily, paddingLeft: '0', textAlign: 'center' },
        underlineStyle: { marginLeft: '0px' },
        value: allocationType,
        onChange: function onChange(event, _, value) {
          onTextFieldChangeWithKeyPath({ keyPath: [index, 'allocationType'], value: value });
          if (value === 'allotment') onTextFieldChangeWithKeyPath({ keyPath: [index, 'allotments'], value: [{}] });
        }
      },
      _react2.default.createElement(_materialUi.MenuItem, { value: 'onRequest', primaryText: 'On request' }),
      _react2.default.createElement(_materialUi.MenuItem, { value: 'freesale', primaryText: 'Freesale' }),
      _react2.default.createElement(_materialUi.MenuItem, { value: 'allotment', primaryText: 'Allotment' })
    ),
    _react2.default.createElement(
      'div',
      { style: { position: 'relative' } },
      allocationType === 'allotment' && allotments && allotments.length ? allotments.map(function (allotment, allotmentIndex) {
        return _react2.default.createElement(
          'div',
          { key: allotmentIndex, style: { display: 'flex' } },
          _react2.default.createElement(_typeControlledTextfield2.default, {
            controlledType: 'number',
            floatingLabelText: '# of passengers/rooms',
            hintText: 'Number only',
            hintStyle: { fontSize: '12px' },
            inputStyle: { fontSize: '14px', marginTop: '0' },
            floatingLabelStyle: { fontSize: '12px', top: '18px' },
            style: { width: '40%', marginRight: '18px', height: '48px', fontFamily: fontFamily },
            errorStyle: { fontSize: '10px', bottom: '10px' },
            errorText: showError && !allotment.numberOfRooms ? 'Required' : '',
            underlineStyle: { bottom: '10px' },
            value: allotment.numberOfRooms,
            onChange: function onChange(_ref2) {
              var value = _ref2.target.value;
              return onTextFieldChangeWithKeyPath({ keyPath: [index, 'allotments', allotmentIndex, 'numberOfRooms'], value: value });
            }
          }),
          _react2.default.createElement(_typeControlledTextfield2.default, {
            controlledType: 'number',
            floatingLabelText: 'Release back days',
            hintText: 'Number only',
            hintStyle: { fontSize: '12px' },
            inputStyle: { fontSize: '14px', marginTop: '0' },
            floatingLabelStyle: { fontSize: '12px', top: '18px' },
            style: { width: '35%', height: '48px', fontFamily: fontFamily },
            errorStyle: { fontSize: '10px', bottom: '10px' },
            errorText: showError && !allotment.releaseBackDays ? 'Required' : '',
            underlineStyle: { bottom: '10px' },
            value: allotment.releaseBackDays,
            onChange: function onChange(_ref3) {
              var value = _ref3.target.value;
              return onTextFieldChangeWithKeyPath({ keyPath: [index, 'allotments', allotmentIndex, 'releaseBackDays'], value: value });
            }
          }),
          allotmentIndex === allotments.length - 1 ? _react2.default.createElement(_icon2.default, {
            className: 'tc-icon-add',
            style: {
              marginLeft: '16px',
              height: '28px',
              lineHeight: '24px',
              verticalAlign: 'middle',
              border: '2px solid green',
              borderRadius: '50%',
              cursor: 'pointer',
              alignSelf: 'center'
            },
            onClick: function onClick() {
              return addOneElementWithKeyPath({ keyPath: [index, 'allotments'], element: {} });
            }
          }) : _react2.default.createElement(_icon2.default, {
            className: 'tc-icon-close',
            style: {
              marginLeft: '16px',
              height: '28px',
              lineHeight: '24px',
              verticalAlign: 'middle',
              color: '#ff4081',
              cursor: 'pointer',
              alignSelf: 'center'
            },
            onClick: function onClick() {
              return deleteOneElementWithKeyPath({ keyPath: [index, 'allotments', allotmentIndex] });
            }
          })
        );
      }) : undefined,
      allocationType === 'freesale' ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_typeControlledTextfield2.default, {
          controlledType: 'number',
          floatingLabelText: '# of passengers/rooms',
          hintText: 'Number only',
          hintStyle: { fontSize: '12px' },
          inputStyle: { fontSize: '14px', marginTop: '0' },
          floatingLabelStyle: { fontSize: '12px', top: '18px' },
          style: { height: '48px', fontFamily: fontFamily, top: '-10px', width: '150px' },
          errorStyle: { fontSize: '10px', bottom: '10px' },
          errorText: showError && !numberOfRooms ? 'Required' : '',
          underlineStyle: { bottom: '10px' },
          value: numberOfRooms,
          onChange: function onChange(_ref4) {
            var value = _ref4.target.value;
            return onTextFieldChangeWithKeyPath({ keyPath: [index, 'numberOfRooms'], value: value });
          }
        }),
        _react2.default.createElement(_typeControlledTextfield2.default, {
          controlledType: 'number',
          floatingLabelText: 'Release back days',
          hintText: 'Number only',
          hintStyle: { fontSize: '12px' },
          inputStyle: { fontSize: '14px', marginTop: '0' },
          floatingLabelStyle: { fontSize: '12px', top: '18px' },
          style: { height: '48px', fontFamily: fontFamily, top: '-10px', width: '35%', marginLeft: '8px' },
          errorStyle: { fontSize: '10px', bottom: '10px' },
          errorText: showError && !releaseBackDays ? 'Required' : '',
          underlineStyle: { bottom: '10px' },
          value: releaseBackDays,
          onChange: function onChange(_ref5) {
            var value = _ref5.target.value;
            return onTextFieldChangeWithKeyPath({ keyPath: [index, 'releaseBackDays'], value: value });
          }
        })
      ) : undefined
    )
  );
};

exports.default = SingleAllocation;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AskIfVary = function AskIfVary(_ref) {
  var name = _ref.name,
      enableManualDatesEntry = _ref.enableManualDatesEntry,
      varyBySeason = _ref.varyBySeason,
      useSeasons = _ref.useSeasons,
      selectIfVaryBySeason = _ref.selectIfVaryBySeason,
      selectIfUseSeasons = _ref.selectIfUseSeasons;
  return _react2.default.createElement(
    'div',
    null,
    name === 'allocations' ? _react2.default.createElement(
      'div',
      { style: { paddingLeft: '32px', paddingTop: '16px' } },
      'Let your partners know how they can book your rooms/products by adding an allocation.'
    ) : null,
    _react2.default.createElement(
      'div',
      { style: { paddingLeft: '32px', paddingTop: '16px', marginBottom: '8px', color: 'black' } },
      'Do your ',
      name,
      ' vary by season? '
    ),
    _react2.default.createElement(_materialUi.RadioButton, {
      checked: (0, _ramda.equals)(varyBySeason, true),
      label: 'Yes, we have different ' + name + ', depending on the season.',
      onCheck: function onCheck() {
        return selectIfVaryBySeason(true);
      },
      labelStyle: { color: (0, _ramda.equals)(varyBySeason, true) ? 'black' : 'grey' },
      style: { paddingLeft: '32px' }
    }),
    varyBySeason && enableManualDatesEntry ? _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_materialUi.RadioButton, {
        label: 'Use existing seasons',
        checked: (0, _ramda.equals)(useSeasons, true),
        onCheck: function onCheck() {
          return selectIfUseSeasons(true);
        },
        labelStyle: { color: useSeasons ? 'black' : 'grey' },
        style: { paddingLeft: '64px' }
      }),
      _react2.default.createElement(_materialUi.RadioButton, {
        label: 'Enter dates manually',
        checked: (0, _ramda.equals)(useSeasons, false),
        onCheck: function onCheck() {
          return selectIfUseSeasons(false);
        },
        labelStyle: { color: (0, _ramda.equals)(useSeasons, false) ? 'black' : 'grey' },
        style: { paddingLeft: '64px' }
      })
    ) : _react2.default.createElement('div', null),
    _react2.default.createElement(_materialUi.RadioButton, {
      checked: (0, _ramda.equals)(varyBySeason, false),
      label: name === 'cancellation policies' ? 'No, all cancellation policies are the same throughout the year, but vary by room type/product.' : 'No, all ' + name + ' are the same throughout the year.',
      onCheck: function onCheck() {
        return selectIfVaryBySeason(false);
      },
      labelStyle: { color: (0, _ramda.equals)(varyBySeason, false) ? 'black' : 'grey' },
      style: { paddingLeft: '32px' }
    })
  );
};

exports.default = AskIfVary;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractingWindow = function ContractingWindow(props) {
  var leftNavNode = props.leftNavNode,
      title = props.title,
      subtitle = props.subtitle,
      titleBarRightWidgets = props.titleBarRightWidgets,
      rightHeader = props.rightHeader,
      headerBgColor = props.headerBgColor,
      headerStyle = props.headerStyle,
      toolbarNode = props.toolbarNode,
      children = props.children;

  var rightContentTitle = title ? _react2.default.createElement(
    'div',
    {
      style: {
        flex: '1 1 auto',
        fontSize: '17px',
        marginLeft: '16px',
        float: 'left',
        display: 'inline-block',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        paddingTop: '2px'
      }
    },
    title
  ) : undefined;
  var headerButtons = titleBarRightWidgets ? _react2.default.createElement(
    'div',
    { style: { flex: '1 0 auto', minWidth: '350px', display: 'flex', alignItems: 'center', marginRight: '4px', flexDirection: 'row-reverse' } },
    titleBarRightWidgets
  ) : undefined;
  var rightHeaderNode = function () {
    if (rightHeader) return rightHeader;
    if (rightContentTitle || headerButtons) return _react2.default.createElement(
      'div',
      { style: _extends({ backgroundColor: headerBgColor, height: '48px', color: '#fff', width: '100.1%', display: 'flex', justifyContent: 'space-between' }, headerStyle) },
      rightContentTitle,
      headerButtons
    );
  }();
  var subtitleNode = subtitle ? _react2.default.createElement(
    'div',
    { style: { height: '36px', borderBottom: subtitle.hideBottomBorder ? 'none' : '1px solid #efefef', margin: '0 2%', paddingRight: '4px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
    _react2.default.createElement(
      'span',
      { style: { fontSize: '16px', color: 'black', fontWeight: '600', display: 'flex', alignItems: 'center' } },
      subtitle.name
    ),
    _react2.default.createElement(
      'div',
      { style: { lineHeight: '36px', fontSize: '12px', height: '36px', display: 'flex', flexDirection: 'row-reverse' } },
      _react2.default.createElement(
        'span',
        { style: { verticalAlign: 'text-bottom', display: 'flex', float: 'right' } },
        subtitle.dateRange,
        subtitle.versions
      ),
      subtitle.subTitleWidgets
    )
  ) : undefined;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _materialUi.Paper,
      { style: { overflow: 'hidden', marginBottom: '70px', backgroundColor: '#f4f6fa' } },
      _react2.default.createElement(
        'div',
        { className: 'contract-window', style: { minHeight: 'calc(100vh - 199px)' } },
        leftNavNode,
        _react2.default.createElement(
          'div',
          { style: { width: leftNavNode ? '78%' : '100%', backgroundColor: 'white' } },
          rightHeaderNode,
          toolbarNode,
          subtitle ? subtitle.secondLineSubtitle : null,
          subtitleNode,
          children
        )
      )
    ),
    _react2.default.createElement('div', { style: { height: '20px', width: '100%', background: 'transparent' } })
  );
};

ContractingWindow.propTypes = {
  toolbarNode: _react.PropTypes.node,
  rightHeader: _react.PropTypes.node,
  title: _react.PropTypes.any,
  titleBarRightWidgets: _react.PropTypes.node,
  subtitle: _react.PropTypes.object,
  leftNavNode: _react.PropTypes.node,
  children: _react.PropTypes.node,
  supplierChecked: _react.PropTypes.bool,
  buyerChecked: _react.PropTypes.bool,
  supplierCheckboxDisabled: _react.PropTypes.bool,
  amendmentMessage: _react.PropTypes.string,
  isAmendmentADraft: _react.PropTypes.bool,
  buyerCheckboxDisabled: _react.PropTypes.bool,
  disableCheckBoxes: _react.PropTypes.bool,
  companyType: _react.PropTypes.string,
  headerBgColor: _react.PropTypes.string,
  headerStyle: _react.PropTypes.object
};
var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user;
  return {
    companyType: user.getIn(['user', 'type'])
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ContractingWindow);

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionExplore = function ActionExplore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z' })
  );
};
ActionExplore = (0, _pure2.default)(ActionExplore);
ActionExplore.displayName = 'ActionExplore';
ActionExplore.muiName = 'SvgIcon';

exports.default = ActionExplore;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSpeakerNotes = function ActionSpeakerNotes(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z' })
  );
};
ActionSpeakerNotes = (0, _pure2.default)(ActionSpeakerNotes);
ActionSpeakerNotes.displayName = 'ActionSpeakerNotes';
ActionSpeakerNotes.muiName = 'SvgIcon';

exports.default = ActionSpeakerNotes;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRouter = __webpack_require__(67);

var _reactRedux = __webpack_require__(6);

var _leftNavStatus = __webpack_require__(3269);

var _leftNavStatus2 = _interopRequireDefault(_leftNavStatus);

var _updateAssignee = __webpack_require__(1258);

var _updateAssignee2 = _interopRequireDefault(_updateAssignee);

var _updateRateConversionPriority = __webpack_require__(1542);

var _updateRateConversionPriority2 = _interopRequireDefault(_updateRateConversionPriority);

var _supplierWizardComplete = __webpack_require__(1057);

var _supplierWizardComplete2 = _interopRequireDefault(_supplierWizardComplete);

var _leftNavWidget = __webpack_require__(1543);

var _leftNavWidget2 = _interopRequireDefault(_leftNavWidget);

var _errorCheckIndicatorIcon = __webpack_require__(1138);

var _errorCheckIndicatorIcon2 = _interopRequireDefault(_errorCheckIndicatorIcon);

var _leftNavProducts = __webpack_require__(3271);

var _leftNavProducts2 = _interopRequireDefault(_leftNavProducts);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _partnerNode = __webpack_require__(1055);

var _partnerNode2 = _interopRequireDefault(_partnerNode);

var _contractingUtils = __webpack_require__(124);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssigneeLabelButton = function AssigneeLabelButton(_ref) {
  var assigneeLabel = _ref.assigneeLabel,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    { className: 'flex-tc-sb', onClick: onClick, style: { borderBottom: '1px solid #d9d9d9', height: '48px', paddingLeft: '16px' } },
    _react2.default.createElement(
      'div',
      { className: 'flex-center', style: { width: '80%' } },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-person', style: { color: 'rgba(0, 0, 0, 0.54)' } }),
      ' \xA0\xA0',
      _react2.default.createElement(
        'div',
        { style: { width: '80%', overflowX: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' } },
        assigneeLabel
      )
    ),
    _react2.default.createElement(
      _materialUi.IconButton,
      { onClick: onClick },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-arrow-drop-down' })
    )
  );
};
var PriorityLabelButton = function PriorityLabelButton(_ref2) {
  var priority = _ref2.priority,
      onClick = _ref2.onClick;
  return _react2.default.createElement(
    'div',
    { className: 'flex-tc-sb', onClick: onClick, style: { borderBottom: '1px solid #d9d9d9', height: '48px', paddingLeft: '16px' } },
    _react2.default.createElement(
      'div',
      { className: 'flex-center', style: { width: '80%' } },
      (0, _contractingUtils.getPriorityIcon)(priority),
      ' \xA0\xA0',
      _react2.default.createElement(
        'div',
        { style: { width: '80%', overflowX: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', color: (0, _contractingUtils.getPriorityColor)(priority) } },
        priority
      )
    ),
    _react2.default.createElement(
      _materialUi.IconButton,
      { onClick: onClick },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-arrow-drop-down' })
    )
  );
};
var ContractDetailsLeftNav = function ContractDetailsLeftNav(_ref3) {
  var goToDashboard = _ref3.goToDashboard,
      changeLeftNavRoute = _ref3.changeLeftNavRoute,
      changeContractStateTo = _ref3.changeContractStateTo,
      openAddEditContractDialog = _ref3.openAddEditContractDialog,
      sortingProducts = _ref3.sortingProducts,
      location = _ref3.location,
      leftNav = _ref3.leftNav,
      companyType = _ref3.companyType,
      appBarBgColor = _ref3.appBarBgColor,
      textColor = _ref3.textColor,
      headerStyle = _ref3.headerStyle,
      leftNavTitle = _ref3.leftNavTitle,
      leftNavLoading = _ref3.leftNavLoading,
      draftErrors = _ref3.draftErrors,
      toggleDraftErrorsDialog = _ref3.toggleDraftErrorsDialog,
      isDummyAccount = _ref3.isDummyAccount,
      pureDocView = _ref3.pureDocView,
      companyName = _ref3.companyName;
  var collection = leftNav.collection,
      locationId = leftNav.locationId,
      contractId = leftNav.contractId;

  var isRequest = !locationId && !leftNav.buyerChecked;
  var isRequestForBuyer = isRequest && companyType === 'Contractor';
  var isRequestForSupplier = isRequest && companyType === 'Supplier';
  var externallyReceived = !locationId && leftNav.buyerChecked;
  var isExternallyReceivedForBuyer = externallyReceived && companyType === 'Contractor';
  var isExternallyReceivedForSupplier = externallyReceived && companyType === 'Supplier';
  return _react2.default.createElement(
    'div',
    {
      style: { width: '22%', backgroundColor: '#f4f6fa', borderRight: '1px solid #e0e0e0' }
    },
    _react2.default.createElement(
      'div',
      { className: 'flex-tc-sb', style: _extends({ backgroundColor: appBarBgColor, height: '48px', color: '#fff', justifyContent: 'initial' }, headerStyle) },
      Boolean(!isDummyAccount && !pureDocView) && _react2.default.createElement(_materialUi.IconButton, {
        iconClassName: 'tc-icon-arrow_back',
        iconStyle: { color: textColor || '#fff' },
        onClick: goToDashboard
      }),
      _react2.default.createElement(
        'div',
        { style: { fontSize: '20px', marginLeft: '8px' } },
        isDummyAccount || pureDocView ? 'Rate Sheet' : leftNavTitle
      )
    ),
    _ramda2.default.call(_ramda2.default.cond([[function () {
      return collection === 'draft' && !draftErrors.errorExist;
    }, _ramda2.default.always(_react2.default.createElement(
      'div',
      { className: 'flex-tc-sb', style: { width: '100%', textAlign: 'center', height: '32px', lineHeight: '32px', borderBottom: '1px solid #e0e0e0', padding: '0 8px' } },
      _react2.default.createElement('img', { src: _supplierWizardComplete2.default, style: { width: '24px', marginRight: '4px' } }),
      _react2.default.createElement(
        'span',
        null,
        ' Information Is Complete'
      ),
      _react2.default.createElement('img', { src: _supplierWizardComplete2.default, style: { width: '24px', marginLeft: '4px' } })
    ))], [function () {
      return collection === 'draft' && draftErrors.errorExist;
    }, _ramda2.default.always(_react2.default.createElement(
      'div',
      { style: { width: '100%', height: '36px', position: 'relative', backgroundColor: '#9e9e9e' } },
      _react2.default.createElement('div', { style: { height: '36px', backgroundColor: '#4caf50', width: draftErrors.percent + '%' } }),
      _react2.default.createElement(
        'div',
        { style: { position: 'absolute', top: 0, left: 0, width: '100%', lineHeight: '36px', textAlign: 'center', color: 'white' } },
        _react2.default.createElement(
          'span',
          null,
          draftErrors.percent,
          '% completed',
          _react2.default.createElement(
            'small',
            { onClick: toggleDraftErrorsDialog, style: { cursor: 'pointer', paddingLeft: '8px', textDecoration: 'underline' } },
            'What\'s missing?'
          )
        )
      )
    ))], [_ramda2.default.T, _ramda2.default.always('')]])),
    !Boolean(isExternallyReceivedForBuyer || isRequestForBuyer) && _react2.default.createElement(_leftNavStatus2.default, _extends({
      changeContractStateTo: changeContractStateTo,
      companyType: companyType,
      files: leftNav.files
    }, _ramda2.default.pick(['contractState', 'contractId', 'supplierChecked', 'locationId', 'originFrom', 'buyerChecked', 'buyerDownloaded'], leftNav))),
    companyType === 'Contractor' && Boolean(locationId) && _react2.default.createElement(
      'div',
      {
        style: {
          borderBottom: '1px solid #d9d9d9'
        }
      },
      _react2.default.createElement(
        _materialUi.Paper,
        {
          style: {
            width: '90%',
            fontSize: '12px',
            margin: '12px auto',
            padding: '12px',
            border: '1px solid #e0e0e0',
            borderRadius: '5px'
          }
        },
        _react2.default.createElement(
          'div',
          null,
          leftNav.templateFromDummy ? 'Creator: ' + companyName : 'Creator: ' + (_ramda2.default.path(['left', 'from', 'name'], leftNav) || 'Supplier')
        ),
        Boolean(leftNav.rateContainer && leftNav.rateContainer.id) && _react2.default.createElement(
          'span',
          null,
          'This contract belongs to the ',
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/contracting/workspace/' + leftNav.rateContainer.id + '/documents' },
            leftNav.rateContainer.partnerName,
            ' ',
            leftNav.rateContainer.year,
            ' contracting workspace'
          ),
          '.'
        )
      )
    ),
    companyType === 'Contractor' && !locationId && _react2.default.createElement(_updateAssignee2.default, {
      isContainer: !Boolean(leftNav.locationId),
      assignee: leftNav.assignee,
      contractId: leftNav.contractId,
      files: leftNav.files,
      Button: AssigneeLabelButton
    }),
    Boolean(companyType === 'Contractor' && (leftNav.assignee && leftNav.assignee.userId === 'dl@tourconnect.com' || leftNav.rateConversionStatus !== 'Awaiting Supplier Rates')) && _react2.default.createElement(_updateRateConversionPriority2.default, {
      priority: leftNav.priority,
      contractId: leftNav.contractId,
      button: _react2.default.createElement(PriorityLabelButton, { priority: leftNav.priority })
    }),
    Boolean(companyType === 'Contractor' && leftNav.signatures && leftNav.signatures.length) && _react2.default.createElement(
      _materialUi.Paper,
      {
        style: {
          width: '90%',
          fontSize: '12px',
          margin: '12px auto',
          padding: '12px',
          border: '1px solid #e0e0e0',
          borderRadius: '5px'
        }
      },
      _react2.default.createElement(
        'div',
        { style: { width: '100%', whiteSpace: 'nowrap', overflowX: 'hidden', textOverflow: 'ellipsis' } },
        'Signature: ',
        leftNav.signatures[0].signatureText
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '100%', whiteSpace: 'nowrap', overflowX: 'hidden', textOverflow: 'ellipsis' } },
        'Signed by: ',
        leftNav.signatures[0].signedBy
      ),
      _react2.default.createElement(
        'small',
        null,
        (0, _moment2.default)(leftNav.signatures[0].signedAt).format('l')
      )
    ),
    _ramda2.default.call(_ramda2.default.cond([[function () {
      return isRequestForBuyer || isExternallyReceivedForBuyer;
    }, _ramda2.default.always(_react2.default.createElement(_leftNavWidget2.default, {
      routeName: '/contracting/' + collection + '/' + contractId + '/policies',
      name: 'WORKSPACE',
      location: location,
      onTouchTap: function onTouchTap() {
        return changeLeftNavRoute('/contracting/' + collection + '/' + contractId + '/policies');
      }
    }))], [function () {
      return isRequestForSupplier;
    }, _ramda2.default.always(_react2.default.createElement(_leftNavWidget2.default, {
      routeName: '/contracting/' + collection + '/' + contractId + '/policies',
      name: 'Send Rates',
      location: location,
      onTouchTap: function onTouchTap() {
        return changeLeftNavRoute('/contracting/supplier-wizard/' + contractId);
      }
    }))], [function () {
      return isExternallyReceivedForSupplier;
    }, _ramda2.default.always(_react2.default.createElement(_leftNavWidget2.default, {
      routeName: '/contracting/' + collection + '/' + contractId + '/policies',
      name: 'Notes',
      location: location,
      onTouchTap: function onTouchTap() {
        return changeLeftNavRoute('/contracting/' + collection + '/' + contractId + '/policies');
      }
    }))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(_leftNavWidget2.default, {
      style: { margin: '3px 0 4px' },
      routeName: '/contracting/' + collection + '/' + contractId + '/policies',
      name: _react2.default.createElement(
        'div',
        { style: { display: 'flex', alignItems: 'center' } },
        leftNav.state === 'draft' && _react2.default.createElement(_errorCheckIndicatorIcon2.default, { showError: draftErrors.locationPercent !== 100 }),
        ' \xA0 Policies & Notes'
      ),
      location: location,
      onTouchTap: function onTouchTap() {
        return changeLeftNavRoute('/contracting/' + collection + '/' + contractId + '/policies');
      }
    }))]])),
    _react2.default.createElement(_materialUi.Divider, null),
    Boolean(isRequestForBuyer || isExternallyReceivedForBuyer) && _react2.default.createElement(
      _materialUi.Paper,
      {
        style: {
          width: '90%',
          margin: '12px auto',
          padding: '24px',
          border: '1px solid #e0e0e0',
          borderRadius: '5px'
        }
      },
      _react2.default.createElement(_partnerNode2.default, {
        forLeftNav: true,
        isReceiver: true,
        forSupplier: true,
        partners: leftNav.partners,
        contacts: leftNav.contacts
      })
    ),
    Boolean(leftNav.collection) && _react2.default.createElement(_leftNavProducts2.default, _extends({
      location: location,
      changeLeftNavRoute: changeLeftNavRoute,
      sortingProducts: sortingProducts,
      openAddEditContractDialog: openAddEditContractDialog
    }, _ramda2.default.pick(['contractState', 'contractId', 'locationId', 'collection', 'supplierEditable', 'companyName', 'allContractingReadyProducts', 'productsArray'], leftNav))),
    leftNavLoading && _react2.default.createElement(
      'div',
      { style: { margin: '16px 0', textAlign: 'center' } },
      _react2.default.createElement(_materialUi.CircularProgress, null)
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  var user = state.user,
      contracting = state.contracting;

  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  var companyType = user.getIn(['user', 'type']);
  return {
    companyType: companyType,
    leftNav: leftNav,
    leftNavLoading: contracting.contractActivitiesProducts.get('leftNavLoading'),
    draftErrors: contracting.contractActivitiesProducts.get('draftErrors').toJS(),
    isDummyAccount: user.get('isDummyAccount'),
    pureDocView: user.get('pureDocView'),
    companyName: user.getIn(['company', 'companyName'])
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ContractDetailsLeftNav);

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(6);

var _copyToClipboard = __webpack_require__(1544);

var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);

var _materialUi = __webpack_require__(3);

var _email = __webpack_require__(3275);

var _email2 = _interopRequireDefault(_email);

var _contractListActions = __webpack_require__(563);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractMailbox = function (_Component) {
  _inherits(ContractMailbox, _Component);

  function ContractMailbox() {
    _classCallCheck(this, ContractMailbox);

    return _possibleConstructorReturn(this, (ContractMailbox.__proto__ || Object.getPrototypeOf(ContractMailbox)).apply(this, arguments));
  }

  _createClass(ContractMailbox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // copy to clipboard if the address is loaded
      if (newProps.contractMailboxMailbox && this.props.contractMailboxLoding && !newProps.contractMailboxLoding) {
        (0, _copyToClipboard2.default)(newProps.contractMailboxMailbox);
        this.props.showMessage('Email address copied to the clipboard');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var contractId = this.props.contractId;

      return _react2.default.createElement(
        _wrapper2.default,
        { slug: 'upgrade-page-contracting-workflow-fwd', amazonOrange: true },
        _react2.default.createElement(_materialUi.MenuItem, {
          style: { fontSize: '15px', minHeight: '32px', lineHeight: '32px' },
          innerDivStyle: { padding: '0px 24px 0px 64px' },
          leftIcon: _react2.default.createElement(_email2.default, {
            color: 'rgba(0, 0, 0, 0.84)',
            style: {
              top: '4px',
              margin: '0',
              left: '24px',
              fill: 'rgb(117, 117, 117)'
            }
          }),
          primaryText: 'Get forwarding email address for this workspace',
          onTouchTap: function onTouchTap() {
            _this2.props.getContractForwardingEmail(contractId);
          }
        })
      );
    }
  }]);

  return ContractMailbox;
}(_react.Component);

ContractMailbox.propTypes = {
  contractId: _propTypes2.default.string,
  contractMailboxLoding: _propTypes2.default.bool,
  contractMailboxMailbox: _propTypes2.default.string,
  getContractForwardingEmail: _propTypes2.default.func,
  showMessage: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(_ref, ownProps) {
  var contracting = _ref.contracting,
      user = _ref.user;
  return {
    contractMailboxLoding: contracting.contractList.getIn(['contractMailboxes', ownProps.contractId, 'loading']),
    contractMailboxMailbox: contracting.contractList.getIn(['contractMailboxes', ownProps.contractId, 'mailbox'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  showMessage: function showMessage(payload) {
    return { type: 'SHOW_CONTRACTING_ERROR_STRING', payload: payload };
  },
  getContractForwardingEmail: _contractListActions.getContractForwardingEmail
})(ContractMailbox);

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionMarkunreadMailbox = function ActionMarkunreadMailbox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z' })
  );
};
ActionMarkunreadMailbox = (0, _pure2.default)(ActionMarkunreadMailbox);
ActionMarkunreadMailbox.displayName = 'ActionMarkunreadMailbox';
ActionMarkunreadMailbox.muiName = 'SvgIcon';

exports.default = ActionMarkunreadMailbox;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rateSetInfo = __webpack_require__(3278);

var _rateSetInfo2 = _interopRequireDefault(_rateSetInfo);

var _rates = __webpack_require__(3279);

var _rates2 = _interopRequireDefault(_rates);

var _nonAccomRates = __webpack_require__(3280);

var _nonAccomRates2 = _interopRequireDefault(_nonAccomRates);

var _reviewAdd = __webpack_require__(3285);

var _reviewAdd2 = _interopRequireDefault(_reviewAdd);

var _seasonDates = __webpack_require__(3296);

var _seasonDates2 = _interopRequireDefault(_seasonDates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddRate3Steps = function AddRate3Steps(props) {
  var index = props.index,
      fieldValues = props.fieldValues,
      updateFieldValue = props.updateFieldValue,
      updateFieldWithKeyPath = props.updateFieldWithKeyPath,
      updateDaysOfWeek = props.updateDaysOfWeek,
      updateRatesTableCell = props.updateRatesTableCell,
      calculateRatesTable = props.calculateRatesTable,
      calculateStandardNonAccomRateTable = props.calculateStandardNonAccomRateTable,
      goToNextStep = props.goToNextStep,
      goToPreviousStep = props.goToPreviousStep,
      updateFormData = props.updateFormData,
      productName = props.productName,
      cancelText = props.cancelText,
      onFinish = props.onFinish,
      cancelFunc = props.cancelFunc,
      step3ContinueText = props.step3ContinueText,
      productType = props.productType,
      usedRateSetNamesAndCodes = props.usedRateSetNamesAndCodes,
      seasonInfo = props.seasonInfo,
      addDateRanges = props.addDateRanges,
      existingSeasons = props.existingSeasons,
      selectExistingSeason = props.selectExistingSeason,
      updateSeasonWizardWithKeyPath = props.updateSeasonWizardWithKeyPath,
      saveProductInfoChanges = props.saveProductInfoChanges,
      contractingPeriod = props.contractingPeriod,
      removeRateSetFromSeasonWhenGoBack = props.removeRateSetFromSeasonWhenGoBack,
      getOverlappingDaysError = props.getOverlappingDaysError;

  var RatesForm = productType === 'Non-Accommodation' ? _nonAccomRates2.default : _rates2.default;
  var sharedProps = _extends({}, fieldValues, {
    updateFieldValue: updateFieldValue,
    updateFieldWithKeyPath: updateFieldWithKeyPath,
    updateDaysOfWeek: updateDaysOfWeek,
    goToNextStep: goToNextStep,
    goToPreviousStep: goToPreviousStep,
    cancelFunc: cancelFunc,
    cancelText: cancelText
  });
  var propsForRateSetInfo = _extends({
    componentIndex: 0,
    productName: productName,
    productType: productType,
    usedRateSetNamesAndCodes: usedRateSetNamesAndCodes,
    getOverlappingDaysError: getOverlappingDaysError
  }, sharedProps);
  var propsForRates = _extends({
    componentIndex: 1,
    calculateRatesTable: calculateRatesTable,
    calculateStandardNonAccomRateTable: calculateStandardNonAccomRateTable,
    updateFormData: updateFormData
  }, sharedProps);
  var propsForReviewAdd = _extends({
    componentIndex: 2,
    updateRatesTableCell: updateRatesTableCell,
    step3ContinueText: step3ContinueText,
    onFinish: onFinish,
    cancelFunc: cancelFunc,
    cancelText: cancelText,
    productType: productType
  }, sharedProps);
  var propsForAddSeasonDates = {
    componentIndex: 3,
    updateFieldValue: updateFieldValue,
    seasonInfo: seasonInfo,
    addDateRanges: addDateRanges,
    existingSeasons: existingSeasons || [],
    selectExistingSeason: selectExistingSeason,
    cancelText: cancelText,
    cancelFunc: cancelFunc,
    saveProductInfoChanges: saveProductInfoChanges,
    continueText: 'Save',
    contractingPeriod: contractingPeriod,
    updateSeasonWizardWithKeyPath: updateSeasonWizardWithKeyPath,
    backFunc: removeRateSetFromSeasonWhenGoBack
  };
  if (index === 0) return _react2.default.createElement(_rateSetInfo2.default, _extends({ key: 'RateSetInfo' }, propsForRateSetInfo));
  if (index === 1) return _react2.default.createElement(RatesForm, _extends({ key: 'Rates' }, propsForRates));
  if (index === 2) return _react2.default.createElement(_reviewAdd2.default, _extends({ key: 'ReviewAdd' }, propsForReviewAdd));
  if (index === 3) return _react2.default.createElement(_seasonDates2.default, propsForAddSeasonDates);
};

AddRate3Steps.propTypes = {
  index: _react.PropTypes.number,
  fieldValues: _react.PropTypes.object,
  updateFieldValue: _react.PropTypes.func,
  updateDaysOfWeek: _react.PropTypes.func,
  updateRatesTableCell: _react.PropTypes.func,
  calculateRatesTable: _react.PropTypes.func,
  goToPreviousStep: _react.PropTypes.func,
  goToNextStep: _react.PropTypes.func,
  onFinish: _react.PropTypes.func,
  cancelFunc: _react.PropTypes.func,
  showStepOneBack: _react.PropTypes.bool,
  stepOneBackFunc: _react.PropTypes.func,
  step3ContinueText: _react.PropTypes.string,
  cancelText: _react.PropTypes.string,
  productType: _react.PropTypes.string,
  usedRateSetNamesAndCodes: _react.PropTypes.array
};

exports.default = AddRate3Steps;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _staypay = __webpack_require__(1550);

var _staypay2 = _interopRequireDefault(_staypay);

var _daysOfWeek = __webpack_require__(1551);

var _daysOfWeek2 = _interopRequireDefault(_daysOfWeek);

var _contractingPresetNamesCodes = __webpack_require__(464);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RateSetInfo = function RateSetInfo(props) {
  var updateFieldValue = props.updateFieldValue,
      updateDaysOfWeek = props.updateDaysOfWeek,
      productType = props.productType,
      productName = props.productName,
      rateSetName = props.rateSetName,
      rateSetCode = props.rateSetCode,
      maxFOC = props.maxFOC,
      stayPays = props.stayPays,
      stayDays = props.stayDays,
      payDays = props.payDays,
      stayPayError = props.stayPayError,
      staypayApplicable = props.staypayApplicable,
      rateSetNameAndCodeError = props.rateSetNameAndCodeError,
      overlappingDaysError = props.overlappingDaysError,
      openAddEditContractDialog = props.openAddEditContractDialog,
      rateSetsIndex = props.rateSetsIndex;

  var openDialogForCreatingNewRatePackage = function openDialogForCreatingNewRatePackage() {
    return openAddEditContractDialog({ type: 'manageRatePackage', title: 'Create Rate Package for ' + productName });
  };
  var rateSetNamesMap = productType === 'Accommodation' ? _contractingPresetNamesCodes.rateSetNamesMapAccommo : _contractingPresetNamesCodes.rateSetNamesMapNonAccommo;
  var updatedRateSetNamesMap = _extends({}, productType === 'Accommodation' ? {} : { Standard: 'ie STANDARD' }, _defineProperty({}, productName, productType === 'Accommodation' ? 'ie DBLSTNDRD' : 'ie HRBCRS1HR'), rateSetNamesMap);
  var rateSetNames = Object.keys(updatedRateSetNamesMap);
  var rateSetNamesOptions = rateSetNames.map(function (name) {
    return { label: name, value: name };
  });

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'label',
      { style: { width: '80%' } },
      'Please select a rate set name to help agents quickly identify the applicable rate for a booking.'
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'span',
      { style: { color: 'red', display: 'block', width: '95%' } },
      rateSetNameAndCodeError
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { style: { float: 'left', width: '32%', marginTop: '30px', zIndex: '1' } },
        _react2.default.createElement(_reactSelect2.default, {
          name: 'rateSetName',
          options: rateSetNamesOptions,
          value: rateSetName,
          onChange: function onChange(_ref) {
            var value = _ref.value;

            updateFieldValue('rateSetName', value);
          },
          placeholder: 'Rate set name',
          clearable: false,
          scrollMenuIntoView: false
        })
      ),
      _react2.default.createElement(
        'span',
        { style: { color: 'red', marginLeft: '10px', fontSize: '24px', verticalAlign: 'bottom' } },
        ' *'
      ),
      _react2.default.createElement(_typeControlledTextfield2.default, {
        limitLength: 11,
        id: 'rateSetCode' + rateSetsIndex,
        style: { marginLeft: '24px' },
        floatingLabelText: 'Rate set code / Description',
        floatingLabelShrinkStyle: { color: 'rgba(0, 0, 0, 0.64)' },
        hintText: updatedRateSetNamesMap[props.rateSetName] || 'ie Weekly Rates or Weekend Rates',
        value: rateSetCode || '',
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;

          updateFieldValue('rateSetCode', value);
        }
      })
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'div',
      { style: { color: 'red', marginBottom: '16px' } },
      overlappingDaysError
    ),
    overlappingDaysError ? _react2.default.createElement(
      'div',
      { style: { marginBottom: '16px', color: 'red', fontSize: '13px' } },
      productType === 'Accommodation' ? 'In order to have two types of rates for the same days of the week, please either adjust the min/max night stays (so they aren\'t overlapping), or use a rate package.' : 'Please either adjust the days of the week (so they aren\'t overlapping), or use a rate package.',
      '\xA0 Click ',
      _react2.default.createElement(
        'a',
        { onClick: openDialogForCreatingNewRatePackage, style: { cursor: 'pointer' } },
        'here'
      ),
      ' to create a rate package for this ',
      productType === 'Accommodation' ? 'room' : 'product',
      '.'
    ) : _react2.default.createElement('div', null),
    productType === 'Accommodation' ? _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'label',
        { style: { zIndex: '0' } },
        'Please note the minimum or maximum night restrictions, if any, for a booking to be eligible for these rates.'
      ),
      _react2.default.createElement(
        'span',
        { style: { color: 'red', display: 'block', width: '95%' } },
        props.maxStay && props.minStay && Number(props.maxStay) < Number(props.minStay) && 'Max night stay should be greater than min night stay.'
      ),
      _react2.default.createElement(_typeControlledTextfield2.default, {
        controlledType: 'number',
        id: 'minStay' + rateSetsIndex,
        style: { display: 'inline-block', width: '160px', zIndex: '0' },
        hintStyle: { fontSize: '12px' },
        inputStyle: { fontSize: '14px' },
        floatingLabelShrinkStyle: { color: 'rgba(0, 0, 0, 0.64)' },
        floatingLabelText: 'Min night stay',
        hintText: 'Min night stay',
        value: props.minStay,
        onChange: function onChange(_ref3) {
          var value = _ref3.target.value;
          return updateFieldValue('minStay', value);
        }
      }),
      _react2.default.createElement(_typeControlledTextfield2.default, {
        controlledType: 'number',
        id: 'maxStay' + rateSetsIndex,
        style: { display: 'inline-block', width: '160px', marginLeft: '30px', zIndex: '0' },
        hintStyle: { fontSize: '12px' },
        inputStyle: { fontSize: '14px' },
        floatingLabelShrinkStyle: { color: 'rgba(0, 0, 0, 0.64)' },
        floatingLabelText: 'Max night stay',
        hintText: 'Max night stay',
        value: props.maxStay,
        onChange: function onChange(_ref4) {
          var value = _ref4.target.value;
          return updateFieldValue('maxStay', value);
        }
      }),
      _react2.default.createElement('br', null)
    ) : undefined,
    productType === 'Accommodation' && stayPays && stayPays.filter(_ramda2.default.both(_ramda2.default.prop('stayDays'), _ramda2.default.prop('payDays'))).length ? _react2.default.createElement(_staypay2.default, {
      staypayApplicable: staypayApplicable,
      stayPayError: stayPayError,
      stayPays: stayPays,
      stayDays: stayDays,
      payDays: payDays,
      maxFOC: maxFOC,
      updateFieldValue: updateFieldValue
    }) : _react2.default.createElement('div', null),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'label',
      null,
      'Which day(s) of the week do these rates apply to?'
    ),
    _react2.default.createElement(
      'span',
      { style: { color: 'red', zIndex: '0', fontSize: '24px', verticalAlign: 'bottom' } },
      ' *'
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement('br', null),
    _react2.default.createElement(_daysOfWeek2.default, {
      daysOfWeek: props.daysOfWeek,
      updateDaysOfWeek: updateDaysOfWeek
    })
  );
};

RateSetInfo.propTypes = {
  updateFieldValue: _react.PropTypes.func,
  updateDaysOfWeek: _react.PropTypes.func,
  minStay: _react.PropTypes.node,
  maxStay: _react.PropTypes.node,
  rateSetName: _react.PropTypes.string,
  daysOfWeek: _react.PropTypes.array,
  productType: _react.PropTypes.string,
  productName: _react.PropTypes.string,
  rateSetCode: _react.PropTypes.string,
  openAddEditContractDialog: _react.PropTypes.func

};

exports.default = (0, _reactRedux.connect)(null, {
  openAddEditContractDialog: function openAddEditContractDialog(payload) {
    return { type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE', payload: payload };
  }
})(RateSetInfo);

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDayPicker = __webpack_require__(1954);

var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);

var _materialUi = __webpack_require__(3);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  numberOfMonths: _react.PropTypes.number,
  onConfirmClick: _react.PropTypes.func,
  deleteSelectedRange: _react.PropTypes.func,
  disabledRanges: _react.PropTypes.array,
  selectedRanges: _react.PropTypes.array,
  config: _react.PropTypes.object,
  initialMonth: _react.PropTypes.any,
  startDate: _react.PropTypes.any,
  endDate: _react.PropTypes.any,
  removeADateRange: _react.PropTypes.func,
  noShowSelected: _react.PropTypes.bool,
  renderDay: _react.PropTypes.func
};

var DateRangePicker = function (_Component) {
  _inherits(DateRangePicker, _Component);

  function DateRangePicker(props) {
    _classCallCheck(this, DateRangePicker);

    var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));

    _this._handleClick = function (day) {
      var from = _this.state.currentRange.from;

      if (from && (0, _moment2.default)(day).isBefore(from)) window.alert('Please select a date after the first day.');
      // we are adding a date range object to the array after user selected the from date
      else if (_this.props.selectedRanges.some(function (range) {
          return range.to && _this._isDayInRange(day, range, true);
        })) return;else if (_this._checkIfDisabled(day)) {
          window.alert('This day is not available.');
        } else if (from && day >= from) {
          if (_this._checkIfIncludeDisabled(from, day)) window.alert('The range you want to select includes disabled dates.');else {
            _this.setState({
              currentRange: {
                from: undefined
              }
            }, function () {
              return _this.props.onConfirmClick(_this._convertSelectedRangeToUTCWhenSend({ from: from, to: day }));
            });
          }
        } else {
          var currentRange = _reactDayPicker.DateUtils.addDayToRange(day, _this.state.currentRange);
          _this.setState({
            currentRange: currentRange
          }, function () {
            return _this.props.onConfirmClick(_this._convertSelectedRangeToUTCWhenSend(currentRange));
          });
        }
    };

    _this._handleMonthChange = function (month) {
      var year = month.getFullYear();
      var currentMonth = month.getMonth();
      var day = month.getDate();
      var adjustment = _this.props.numberOfMonths - 1;
      _this.setState({
        currentInitialMonth: new Date(year, (0, _moment2.default)(month).isAfter(_this.state.currentInitialMonth) ? currentMonth + adjustment : currentMonth - adjustment, day)
      });
    };

    _this.handleResetClick = function (e) {
      e.preventDefault();
      _this.setState({
        currentRange: {
          from: undefined
        }
      });
    };

    _this._handleRemove = function (index) {
      return _this.props.removeADateRange(index);
    };

    _this._getDateFromUTC = function (date) {
      var dateObject = new Date(date);
      return new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate());
    };

    _this._getUTCDay = function (day) {
      return day ? new Date(Date.UTC(day.getFullYear(), day.getMonth(), day.getDate())) : day;
    };

    _this._convertSelectedRangeToUTCWhenSend = function (range) {
      return {
        from: range.from ? _this._getUTCDay(range.from) : range.from,
        to: range.to ? _this._getUTCDay(range.to) : range.to
      };
    };

    _this._isDayInRange = function (day, range, inclusive) {
      if (range.from && range.to) return (0, _moment2.default)(day).isBetween(range.from, range.to, 'day', inclusive ? '[]' : '()');
      if (range.from) return (0, _moment2.default)(day).isSame(_this._getDateFromUTC(range.from), 'day');
      return false;
    };

    _this._checkIfDisabled = function (day) {
      var _this$props = _this.props,
          disabledRanges = _this$props.disabledRanges,
          startDate = _this$props.startDate,
          endDate = _this$props.endDate;

      var outsideRange = (0, _moment2.default)(day).isBefore(_this._getDateFromUTC(startDate) || new Date('1000-01-31'), 'day') || (0, _moment2.default)(day).isAfter(_this._getDateFromUTC(endDate) || new Date('11000-01-31'), 'day');
      if (!disabledRanges) return outsideRange;
      return disabledRanges.some(function (range) {
        if (range.from && range.to) return _this._isDayInRange(day, range, true);
        return (0, _moment2.default)(day).isSame(range, 'day');
      }) || outsideRange;
    };

    _this._checkIfIncludeDisabled = function (from, to) {
      return (_this.props.disabledRanges || []).some(function (range) {
        return range.from > from && range.to < to;
      });
    };

    _moment2.default.locale(props.config.locale);
    _this.state = {
      currentRange: {
        from: undefined
      },
      currentInitialMonth: props.initialMonth || _this._getDateFromUTC(props.startDate)
    };
    return _this;
  }

  _createClass(DateRangePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.initialMonth !== nextProps.initialMonth) {
        this.setState({ currentInitialMonth: nextProps.initialMonth });
      }
      // THis is a very messy solution. Because external components also want to control the internal state
      // I don't have time to move the external text fields into this component, so... will do if it starts
      // to cause issue
      if (nextProps.selectedRanges.length && !((0, _moment2.default)(_ramda2.default.last(nextProps.selectedRanges).from).isSame(this.state.currentRange.from) && (0, _moment2.default)(_ramda2.default.last(nextProps.selectedRanges).to).isSame(this.state.currentRange.to))) {
        this.setState({
          currentRange: _ramda2.default.last(nextProps.selectedRanges).to ? {} : _ramda2.default.last(nextProps.selectedRanges)
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.state = {};
    }

    // use this function to reset date to the same time

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          numberOfMonths = _props.numberOfMonths,
          noShowSelected = _props.noShowSelected,
          selectedRanges = _props.selectedRanges;
      var _state = this.state,
          currentRange = _state.currentRange,
          currentInitialMonth = _state.currentInitialMonth;

      var selectedFunc = function () {
        if (!selectedRanges.length) return function (day) {
          return _this2._isDayInRange(day, currentRange, true);
        };
        return function (day) {
          return selectedRanges.some(function (selectedRange) {
            return _this2._isDayInRange(day, selectedRange, true);
          });
        };
      }();
      var modifiers = {
        disabled: function disabled(day) {
          return _this2._checkIfDisabled(day);
        },
        selected: selectedFunc
      };
      return _react2.default.createElement(
        'div',
        {
          style: noShowSelected ? { display: 'flex', flexDirection: 'column-reverse' } : { display: 'flex', alignItems: 'flex-start' }
        },
        _react2.default.createElement(
          'div',
          { style: { maxWidth: '550px', marginTop: noShowSelected ? '0' : '12px' } },
          _react2.default.createElement(_reactDayPicker2.default, {
            initialMonth: currentInitialMonth,
            month: currentInitialMonth,
            onMonthChange: this._handleMonthChange,
            numberOfMonths: numberOfMonths,
            modifiers: modifiers,
            renderDay: this.props.renderDay,
            onDayClick: this._handleClick
          })
        ),
        !noShowSelected ? _react2.default.createElement(
          'div',
          { style: { paddingTop: '12px', width: '180px', marginLeft: '16px' } },
          _react2.default.createElement(
            'div',
            { style: { fontSize: '12px', visibility: currentRange.from ? 'visible' : 'hidden' } },
            'From ',
            (0, _moment2.default)(currentRange.from).format('D MMM YYYY'),
            _react2.default.createElement(
              'a',
              {
                href: '#',
                style: { color: '#ff4081', display: 'inline-block', marginLeft: '6px' },
                onClick: this.handleResetClick
              },
              'Reset'
            )
          ),
          !currentRange.from && _react2.default.createElement(
            'div',
            { style: { fontSize: '12px' } },
            'Please select the ',
            _react2.default.createElement(
              'strong',
              null,
              'first day'
            ),
            '.'
          ),
          currentRange.from && _react2.default.createElement(
            'div',
            { style: { fontSize: '12px' } },
            'Please select the ',
            _react2.default.createElement(
              'strong',
              null,
              'last day'
            ),
            '.'
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e0e0e0' } },
            selectedRanges && selectedRanges.length ? selectedRanges.map(function (selectedRange, index) {
              var from = selectedRange.from,
                  to = selectedRange.to;

              return _react2.default.createElement(
                'div',
                {
                  key: index,
                  className: 'flex-tc-sb',
                  style: { fontSize: '12px', color: 'rgba(0, 0, 0, 0.87)' }
                },
                (0, _moment2.default)(from).isSame(to, 'day') ? (0, _moment2.default)(from).format('D MMM YYYY') : (0, _moment2.default)(from).format('D MMM YYYY') + ' - ' + (to ? (0, _moment2.default)(to).format('D MMM YYYY') : ''),
                _react2.default.createElement(_materialUi.IconButton, {
                  iconClassName: 'tc-icon-delete2',
                  iconStyle: { color: '#ff4081', top: '4px', fontSize: '20px' },
                  style: { padding: '0', height: '24px', width: '24px' },
                  onClick: function onClick() {
                    return _this2._handleRemove(index);
                  }
                })
              );
            }) : _react2.default.createElement('span', null)
          )
        ) : _react2.default.createElement(
          'div',
          { style: { width: '380px', display: 'flex' } },
          _react2.default.createElement(
            'div',
            { style: { fontSize: '12px', visibility: currentRange.from ? 'visible' : 'hidden' } },
            'From ',
            (0, _moment2.default)(currentRange.from).format('D MMM YYYY'),
            _react2.default.createElement(
              'a',
              {
                href: '#',
                style: { color: '#ff4081', display: 'inline-block', marginLeft: '6px' },
                onClick: this.handleResetClick
              },
              'Reset'
            )
          ),
          !currentRange.from && _react2.default.createElement(
            'div',
            { style: { fontSize: '12px' } },
            'Please select the ',
            _react2.default.createElement(
              'strong',
              null,
              'first day'
            ),
            '.'
          ),
          currentRange.from && _react2.default.createElement(
            'div',
            { style: { fontSize: '12px', marginLeft: '16px' } },
            'Please select the ',
            _react2.default.createElement(
              'strong',
              null,
              'last day'
            ),
            '.'
          )
        )
      );
    }
  }]);

  return DateRangePicker;
}(_react.Component);

DateRangePicker.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref) {
  var config = _ref.config;

  return {
    config: config.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DateRangePicker);

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _bankInfo = __webpack_require__(3299);

var _bankInfo2 = _interopRequireDefault(_bankInfo);

var _insuranceExp = __webpack_require__(3300);

var _insuranceExp2 = _interopRequireDefault(_insuranceExp);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var checkIfShouldDisable = function checkIfShouldDisable(data) {
  if (_ramda2.default.contains('billing', data.title)) {
    return !Boolean(data.terms && data.financialInstitution && data.branch && data.accountName && data.accountNumber && data.bsbRoutingNumber);
  }
  return !Boolean(data.insuranceExpirationMonth && data.insuranceExpirationYear && data.insuranceFiles && data.insuranceFiles.length > 0 && (data.insuranceFiles[0].fileName || data.insuranceFiles[0].name));
};

var BillingInfo = function BillingInfo(_ref) {
  var onRequestClose = _ref.onRequestClose,
      contractId = _ref.contractId,
      onTextFieldChange = _ref.onTextFieldChange,
      saveBillingInfoChanges = _ref.saveBillingInfoChanges,
      attachInsFile = _ref.attachInsFile,
      removeInsFile = _ref.removeInsFile,
      data = _ref.data,
      saving = _ref.saving;

  var insuranceExpirationMonth = data.insuranceExpirationMonth,
      insuranceExpirationYear = data.insuranceExpirationYear,
      insuranceFiles = data.insuranceFiles,
      forBankInfo = _objectWithoutProperties(data, ['insuranceExpirationMonth', 'insuranceExpirationYear', 'insuranceFiles']);

  var shouldDisable = checkIfShouldDisable(data);
  var termsError = data.terms === '' ? 'Payment terms required.' : '';
  var financialInstitutionError = data.financialInstitution === '' ? 'Financial instituation required.' : '';
  var branchError = data.branch === '' ? 'Branch required.' : '';
  var accountNameError = data.accountName === '' ? 'Account name required.' : '';
  var accountNumberError = data.accountNumber === '' ? 'Account number required.' : '';
  var bsbRoutingNumberError = data.bsbRoutingNumber === '' ? 'BSB/Routing number required.' : '';
  var currencyError = data.currency === '' ? 'Currency type required.' : '';
  var insExpMonthError = data.insuranceExpirationMonth === '' ? 'Valid insurance expiration month required.' : '';
  var insExpYearError = data.insuranceExpirationYear === '' ? 'Valid insurance expiration year required.' : '';

  return _react2.default.createElement(
    'div',
    null,
    _ramda2.default.contains('billing', data.title) ? _react2.default.createElement(
      'div',
      { style: { marginLeft: '20px', width: '90%', padding: '2% 0%' } },
      _react2.default.createElement(
        'p',
        { style: { color: '#757575', fontSize: '14px' } },
        'Please enter your bank and payment information. Buyers will use this infromation to send payment for products that they\u2019ve sold for you.'
      ),
      _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { display: 'flex', alignItems: 'center' },
        leftColumnContent: 'Payment terms',
        leftColumnStyle: { width: '35%', color: 'rbga(0, 0, 0, 0.77)' },
        rightColumnStyle: { width: '65%', overflowY: 'hidden' },
        rightColumnContent: _react2.default.createElement('textarea', {
          style: { overflowX: 'hidden', width: '100%' },
          defaultValue: forBankInfo.terms,
          rows: 4,
          onChange: function onChange(e) {
            return onTextFieldChange({ key: 'terms', value: e.target.value });
          }
        })
      }),
      _react2.default.createElement(_bankInfo2.default, _extends({}, forBankInfo, {
        onChange: onTextFieldChange,
        financialInstitutionError: financialInstitutionError,
        branchError: branchError,
        accountNameError: accountNameError,
        accountNumberError: accountNumberError,
        bsbRoutingNumberError: bsbRoutingNumberError,
        currencyError: currencyError
      }))
    ) : _react2.default.createElement(
      'div',
      { style: { marginLeft: '20px' } },
      _react2.default.createElement(_insuranceExp2.default, _extends({}, forBankInfo, {
        insExpMonthError: insExpMonthError,
        insExpYearError: insExpYearError,
        insuranceExpirationMonth: insuranceExpirationMonth,
        insuranceExpirationYear: insuranceExpirationYear,
        attachFile: attachInsFile,
        removeFile: removeInsFile,
        attachedFiles: insuranceFiles,
        onChange: onTextFieldChange
      }))
    ),
    _react2.default.createElement(_stepperActions2.default, { rightButtons: _react2.default.createElement(
        'div',
        { style: { marginTop: '5%' } },
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Cancel',
          hoverColor: 'none',
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onTouchTap: onRequestClose
        }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Save',
          hoverColor: 'none',
          labelStyle: { fontWeight: '600' },
          onTouchTap: function onTouchTap() {
            return saveBillingInfoChanges({
              contractId: contractId,
              data: _ramda2.default.omit(['title'], data),
              type: _ramda2.default.contains('billing', data.title) ? 'billingInfo' : 'insuranceInfo'
            });
          },
          loader: saving,
          secondary: true,
          disabled: shouldDisable
        })
      )
    })
  );
};

BillingInfo.propTypes = {
  onRequestClose: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  data: _react.PropTypes.object,
  onTextFieldChange: _react.PropTypes.func
};

exports.default = BillingInfo;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notEmpty = (0, _ramda.complement)(_ramda.isEmpty);

var SeasonErrors = function SeasonErrors(_ref) {
  var seasonDateRanges = _ref.seasonDateRanges,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      openAddEditContractDialog = _ref.openAddEditContractDialog,
      existingSeasons = _ref.existingSeasons,
      editable = _ref.editable;

  if ((0, _ramda.isEmpty)(seasonDateRanges)) return _react2.default.createElement('div', null);
  var notInContractingPeriodString = _dateUtils2.default.notInContractingPeriod(seasonDateRanges, startDate, endDate);
  if (notInContractingPeriodString) {
    // this error is handled in helper-link.jsx
    return _react2.default.createElement('div', null);
    // return (
    //   <div style={{ marginTop: '12px', color: '#f44336' }}>
    //     <FontIcon className="tc-icon-warning" style={{ fontSize: '16px', color: '#f44336' }} /> {notInContractingPeriodString}
    //   </div>
    // );
  }
  var missingRanges = _dateUtils2.default.getMissingRanges(seasonDateRanges, { startDate: startDate, endDate: endDate });
  if (notEmpty(missingRanges)) {
    return _react2.default.createElement(
      'div',
      { style: { marginTop: '12px', color: '#f44336' } },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-warning2', style: { fontSize: '16px', color: '#f44336' } }),
      ' ',
      _react2.default.createElement(
        'b',
        null,
        'Missing Dates:'
      ),
      _react2.default.createElement(
        _mouseOverEditDiv2.default,
        {
          actionButtons: _react2.default.createElement(_editButton2.default, {
            editLabel: 'Assign Dates to A Season',
            onEdit: function onEdit() {
              return openAddEditContractDialog({
                type: 'editSeason',
                data: {
                  seasonIndex: -1,
                  missingDatesIndexSelected: missingRanges.map(function (_, i) {
                    return i;
                  }),
                  assignToSeasonIndex: -1,
                  title: 'Edit Season'
                }
              });
            }
          }),
          editable: editable
        },
        missingRanges.map(function (range, index) {
          return _react2.default.createElement(
            'div',
            { key: index, style: { marginLeft: '20px', color: 'rgba(0, 0, 0, 0.54)' } },
            (0, _moment2.default)(range.from).isSame(range.to, 'day') ? _dateUtils2.default.dateToString(range.from) : _dateUtils2.default.dateToString(range.from) + ' - ' + _dateUtils2.default.dateToString(range.to)
          );
        })
      )
    );
  }
  return _react2.default.createElement('div', null);
};

SeasonErrors.propTypes = {
  seasonDateRanges: _react.PropTypes.array.isRequired,
  startDate: _react.PropTypes.any,
  endDate: _react.PropTypes.any
};

exports.default = SeasonErrors;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _selectFields = __webpack_require__(141);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditCheckInOut = function EditCheckInOut(_ref) {
  var onRequestClose = _ref.onRequestClose,
      onTextFieldChange = _ref.onTextFieldChange,
      contractId = _ref.contractId,
      saveSupplierInfoChanges = _ref.saveSupplierInfoChanges,
      data = _ref.data,
      saving = _ref.saving;

  return _react2.default.createElement(
    'div',
    { style: { padding: '12px 8% 0 12%' } },
    _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { overflow: '', minHeight: '200px' },
      leftColumnStyle: { width: '50%' },
      rightColumnStyle: { width: '50%', display: 'inline-block' },
      leftColumnContent: _react2.default.createElement(
        'div',
        { style: { marginBottom: '30px' } },
        'CHECK-IN',
        _react2.default.createElement(_reactSelect2.default, {
          style: { fontSize: '14px', margin: '10px 0 12px 0', width: '75%', zIndex: '0' },
          name: 'checkIn',
          options: _selectFields.timeSelect15MinsInterval.map(function (time) {
            return { label: time.label, value: time.label };
          }),
          value: data.checkIn,
          onChange: function onChange(_ref2) {
            var value = _ref2.value;
            return onTextFieldChange({ key: 'checkIn', value: value });
          },
          placeholder: 'Check-in',
          clearable: false,
          scrollMenuIntoView: false
        }),
        _react2.default.createElement(_materialUi.Checkbox, {
          label: _react2.default.createElement(
            'small',
            null,
            'EARLY CHECK-IN'
          ),
          defaultChecked: data.earlyCheckInChecked,
          onCheck: function onCheck() {
            return onTextFieldChange({ key: 'earlyCheckInChecked', value: !data.earlyCheckInChecked });
          }
        }),
        data.earlyCheckInChecked ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { marginTop: '12px', width: '75%' } },
            _react2.default.createElement(
              'span',
              { style: { position: 'relative', top: '20px' } },
              'From:'
            ),
            _react2.default.createElement(_reactSelect2.default, {
              style: { fontSize: '14px', width: '70%', float: 'right', zIndex: '1' },
              name: 'earlyCheckIn',
              options: _selectFields.timeSelect15MinsInterval.map(function (time) {
                return { label: time.label, value: time.label };
              }),
              value: data.earlyCheckIn,
              onChange: function onChange(_ref3) {
                var value = _ref3.value;
                return onTextFieldChange({ key: 'earlyCheckIn', value: value });
              },
              placeholder: 'Early Check-in',
              clearable: false,
              scrollMenuIntoView: false
            })
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '12px', width: '75%' } },
            _react2.default.createElement(
              'span',
              { style: { position: 'relative', top: '40px' } },
              'Cost Type:'
            ),
            _react2.default.createElement(_reactSelect2.default, {
              style: { fontSize: '14px', width: '70%', zIndex: '0', float: 'right' },
              name: 'earlyCheckInCostType',
              options: [{ value: '$', label: 'Fixed Cost' }, { value: '%', label: 'Percentage' }],
              value: data.earlyCheckInCostType || '$',
              onChange: function onChange(_ref4) {
                var value = _ref4.value;
                return onTextFieldChange({ key: 'earlyCheckInCostType', value: value });
              },
              clearable: false,
              scrollMenuIntoView: false
            })
          ),
          _react2.default.createElement(_typeControlledTextfield2.default, {
            controlledType: 'number',
            style: { width: '75%', zIndex: '0' },
            floatingLabelText: data.earlyCheckInCostType || '$',
            floatingLabelStyle: { fontSize: '14px' },
            value: data.earlyCheckInFee,
            onChange: function onChange(_ref5) {
              var value = _ref5.target.value;
              return onTextFieldChange({ key: 'earlyCheckInFee', value: value });
            }
          }),
          data.earlyCheckInCostType === '%' ? _react2.default.createElement(_reactSelect2.default, {
            style: { fontSize: '11px', width: '75%', marginTop: '15px' },
            name: 'earlyCheckInPercentageType',
            options: [{ value: 'of Nightly Rate', label: 'of Nightly Rate' }, { value: 'of Total Booking', label: 'of Total Booking' }],
            value: data.earlyCheckInPercentageType || 'of Nightly Rate',
            onChange: function onChange(_ref6) {
              var value = _ref6.value;
              return onTextFieldChange({ key: 'earlyCheckInPercentageType', value: value });
            },
            clearable: false,
            scrollMenuIntoView: false
          }) : undefined
        ) : undefined
      ),
      rightColumnContent: _react2.default.createElement(
        'div',
        { style: { marginBottom: '30px' } },
        'CHECK-OUT',
        _react2.default.createElement(_reactSelect2.default, {
          style: { fontSize: '14px', width: '75%', zIndex: '0', margin: '10px 0 12px 0' },
          name: 'checkOut',
          options: _selectFields.timeSelect15MinsInterval.map(function (time) {
            return { label: time.label, value: time.label };
          }),
          value: data.checkOut,
          onChange: function onChange(_ref7) {
            var value = _ref7.value;
            return onTextFieldChange({ key: 'checkOut', value: value });
          },
          placeholder: 'Check-out',
          clearable: false,
          scrollMenuIntoView: false
        }),
        _react2.default.createElement(_materialUi.Checkbox, {
          label: _react2.default.createElement(
            'small',
            null,
            'LATE CHECK-OUT'
          ),
          defaultChecked: data.lateCheckOutChecked,
          onCheck: function onCheck() {
            return onTextFieldChange({ key: 'lateCheckOutChecked', value: !data.lateCheckOutChecked });
          }
        }),
        data.lateCheckOutChecked ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { marginTop: '12px', width: '75%' } },
            _react2.default.createElement(
              'span',
              { style: { position: 'relative', top: '20px' } },
              'Until:'
            ),
            _react2.default.createElement(_reactSelect2.default, {
              style: { fontSize: '14px', width: '70%', float: 'right', zIndex: '1' },
              name: 'lateCheckOut',
              options: _selectFields.timeSelect15MinsInterval.map(function (time) {
                return { label: time.label, value: time.label };
              }),
              value: data.lateCheckOut,
              onChange: function onChange(_ref8) {
                var value = _ref8.value;
                return onTextFieldChange({ key: 'lateCheckOut', value: value });
              },
              placeholder: 'Late Check-out',
              clearable: false,
              scrollMenuIntoView: false
            })
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '12px', width: '75%' } },
            _react2.default.createElement(
              'span',
              { style: { position: 'relative', top: '40px' } },
              'Cost Type:'
            ),
            _react2.default.createElement(_reactSelect2.default, {
              style: { fontSize: '14px', width: '70%', zIndex: '0', float: 'right' },
              name: 'lateCheckOutCostType',
              options: [{ value: '$', label: 'Fixed Cost' }, { value: '%', label: 'Percentage' }],
              value: data.lateCheckOutCostType || '$',
              onChange: function onChange(_ref9) {
                var value = _ref9.value;
                return onTextFieldChange({ key: 'lateCheckOutCostType', value: value });
              },
              clearable: false,
              scrollMenuIntoView: false
            })
          ),
          _react2.default.createElement(_typeControlledTextfield2.default, {
            controlledType: 'number',
            style: { width: '75%' },
            floatingLabelText: data.lateCheckOutCostType || '$',
            floatingLabelStyle: { fontSize: '14px', zIndex: '0' },
            value: data.lateCheckOutFee,
            onChange: function onChange(_ref10) {
              var value = _ref10.target.value;
              return onTextFieldChange({ key: 'lateCheckOutFee', value: value });
            }
          }),
          data.lateCheckOutCostType === '%' ? _react2.default.createElement(_reactSelect2.default, {
            style: { fontSize: '11px', width: '75%', marginTop: '15px' },
            name: 'lateCheckOutPercentageType',
            options: [{ value: 'of Nightly Rate', label: 'of Nightly Rate' }, { value: 'of Total Booking', label: 'of Total Booking' }],
            value: data.lateCheckOutPercentageType || 'of Nightly Rate',
            onChange: function onChange(_ref11) {
              var value = _ref11.value;
              return onTextFieldChange({ key: 'lateCheckOutPercentageType', value: value });
            },
            clearable: false,
            scrollMenuIntoView: false
          }) : undefined
        ) : undefined
      )
    }),
    _react2.default.createElement(_stepperActions2.default, {
      style: { overflow: 'auto', marginTop: '12px' },
      rightButtons: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Cancel',
          hoverColor: 'none',
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onTouchTap: onRequestClose
        }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Save',
          loader: saving,
          hoverColor: 'none',
          labelStyle: { fontWeight: '600' },
          onTouchTap: function onTouchTap() {
            return saveSupplierInfoChanges({ contractId: contractId, data: data, updateType: 'SAVED_CHECKIN_AND_CHECKOUT' });
          },
          secondary: true
        })
      )
    })
  );
};

var convertDateToTime = function convertDateToTime(dateObj) {
  var hours = dateObj.getHours();
  var minutes = dateObj.getMinutes();

  var _ref12 = function () {
    if (hours === 0) return { amOrPm: 'am', lessThan12Hour: 12 };
    if (hours > 12) return { amOrPm: 'pm', lessThan12Hour: hours - 12 };
    return { amOrPm: 'am', lessThan12Hour: hours };
  }(),
      amOrPm = _ref12.amOrPm,
      lessThan12Hour = _ref12.lessThan12Hour;

  var twoDigitsMinutes = ('' + minutes).length > 1 ? minutes : '0' + minutes;
  return lessThan12Hour + ':' + twoDigitsMinutes + amOrPm;
};

var convertTimeToDate = function convertTimeToDate(timeString) {
  if (!timeString) return timeString;
  var hours = timeString.split(':')[0];
  var minutes = timeString.split(':')[1].slice(0, 1) === '0' ? timeString.split(':')[1].slice(1, 2) : timeString.split(':')[1].slice(0, 2);
  var amOrPm = timeString.slice(-2);
  var hourIn23 = function () {
    if (amOrPm === 'am') {
      if (hours === 12) return 0;
      return hours;
    }
    return hours + 12;
  }();
  return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), hourIn23, minutes);
};

EditCheckInOut.propTypes = {
  onRequestClose: _react.PropTypes.func,
  onTextFieldChange: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  productId: _react.PropTypes.string,
  saveSupplierInfoChanges: _react.PropTypes.func,
  data: _react.PropTypes.object,
  saving: _react.PropTypes.bool
};

exports.default = EditCheckInOut;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _rules = __webpack_require__(1979);

var _rules2 = _interopRequireDefault(_rules);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var invalidNum = function invalidNum(value) {
  return isNaN(value) || isNaN(parseInt(value, 10)) ? 'Numbers only' : '';
};

var cancellationsNotValid = function cancellationsNotValid(data) {
  return !_ramda2.default.call(_ramda2.default.allPass([_ramda2.default.prop('cancelNum'), _ramda2.default.prop('cancelHoursDays'), _ramda2.default.prop('conditions')]), data);
};

var checkIfShouldDisable = function checkIfShouldDisable(data) {
  var adultCount = data.adultCount,
      childrenCount = data.childrenCount,
      ageFrom = data.ageFrom,
      ageTo = data.ageTo,
      focChildrenAllowed = data.focChildrenAllowed,
      focChildrenCount = data.focChildrenCount,
      conditions = data.conditions,
      policyType = data.policyType;

  var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
  var familyPolicyNotValid = function familyPolicyNotValid() {
    return _ramda2.default.any(isNilOrEmpty, [adultCount, childrenCount]);
  };
  var infantPolicyNotValid = function infantPolicyNotValid() {
    return _ramda2.default.any(isNilOrEmpty, [ageFrom, ageTo]);
  };
  var childPolicyNotValid = function childPolicyNotValid() {
    return _ramda2.default.call(_ramda2.default.anyPass([function () {
      return isNaN(ageFrom) || isNaN(ageTo);
    }, function () {
      return focChildrenAllowed && !focChildrenCount;
    }]));
  };
  return _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('family'), familyPolicyNotValid], [_ramda2.default.equals('child'), childPolicyNotValid], [_ramda2.default.equals('infant'), infantPolicyNotValid], [_ramda2.default.T, function () {
    return !conditions;
  }]]), policyType);
};

var EditLocationPolicy = function EditLocationPolicy(_ref) {
  var onRequestClose = _ref.onRequestClose,
      onTextFieldChange = _ref.onTextFieldChange,
      contractId = _ref.contractId,
      saveSupplierInfoChanges = _ref.saveSupplierInfoChanges,
      data = _ref.data,
      saving = _ref.saving;

  var ages = [];
  for (var i = 0; i < 22; i++) {
    ages.push({ label: i, value: i });
  }
  var agesForInfantAndChild = _react2.default.createElement(
    'div',
    { style: { marginLeft: '5%', width: '90%', display: 'flex', alignItems: 'center' } },
    _react2.default.createElement(
      'p',
      { style: { fontSize: '14px' } },
      'From'
    ),
    _react2.default.createElement(
      'div',
      { style: { margin: '4px 0px 20px 10px', width: '23%' } },
      _react2.default.createElement(_reactSelect2.default, {
        name: 'ageFrom',
        options: ages,
        value: data.ageFrom,
        onChange: function onChange(_ref2) {
          var value = _ref2.value;
          return onTextFieldChange({ key: 'ageFrom', value: value });
        },
        placeholder: data.policyType === 'child' ? '2' : '0',
        clearable: false,
        scrollMenuIntoView: false
      })
    ),
    _react2.default.createElement(
      'p',
      { style: { fontSize: '14px', marginLeft: '8px' } },
      'To'
    ),
    _react2.default.createElement(
      'div',
      { style: { margin: '4px 0px 20px 10px', width: '23%' } },
      _react2.default.createElement(_reactSelect2.default, {
        name: 'ageTo',
        options: ages,
        value: data.ageTo,
        onChange: function onChange(_ref3) {
          var value = _ref3.value;
          return onTextFieldChange({ key: 'ageTo', value: value });
        },
        placeholder: data.policyType === 'child' ? '15' : '1',
        clearable: false,
        scrollMenuIntoView: false
      })
    ),
    _react2.default.createElement(
      'p',
      { style: { fontSize: '14px', marginLeft: '8px' } },
      '(inclusive)'
    )
  );

  var shouldDisable = checkIfShouldDisable(data);

  var additionalDiv = function () {
    switch (data.policyType) {
      case 'group':
        return _react2.default.createElement(
          'small',
          null,
          _react2.default.createElement('i', null)
        );
      case 'freeOfCharge':
        return _react2.default.createElement('div', null);
      case 'family':
        return {
          middleDiv: _react2.default.createElement(
            'div',
            { style: { marginLeft: '5%', width: '90%' } },
            _react2.default.createElement(_materialUi.TextField, {
              style: { marginLeft: '20px', width: '27%', marginBottom: '20px', float: 'left' },
              floatingLabelText: 'Number of Adults',
              floatingLabelStyle: { fontSize: '12px' },
              value: data.adultCount || '',
              errorText: data.adultCount ? invalidNum(data.adultCount) : '',
              onChange: function onChange(_ref4) {
                var value = _ref4.target.value;
                return onTextFieldChange({ key: 'adultCount', value: value });
              }
            }),
            _react2.default.createElement(
              'p',
              { style: { float: 'left', lineHeight: '90px', fontSize: '14px' } },
              'Adults'
            ),
            _react2.default.createElement(_materialUi.TextField, {
              style: { marginLeft: '10px', width: '30%', marginBottom: '20px', float: 'left' },
              floatingLabelText: 'Number of Children',
              floatingLabelStyle: { fontSize: '12px' },
              value: data.childrenCount || '',
              errorText: data.childrenCount ? invalidNum(data.childrenCount) : '',
              onChange: function onChange(_ref5) {
                var value = _ref5.target.value;
                return onTextFieldChange({ key: 'childrenCount', value: value });
              }
            }),
            _react2.default.createElement(
              'p',
              { style: { float: 'left', lineHeight: '90px', fontSize: '14px' } },
              'Children'
            )
          ),
          textAboveTextField: 'Please note any other conditions related to your Family Policy.'
        };
      case 'child':
        return {
          middleDiv: _react2.default.createElement(
            'div',
            { style: { display: 'flex', flexDirection: 'column' } },
            agesForInfantAndChild,
            _react2.default.createElement(
              'div',
              { style: { marginBottom: '8px', marginLeft: '5%', width: '90%' } },
              _react2.default.createElement(_materialUi.Checkbox, {
                checked: Boolean(data.focChildrenAllowed),
                onCheck: function onCheck() {
                  return onTextFieldChange({ key: 'focChildrenAllowed', value: !data.focChildrenAllowed });
                },
                label: 'Children Free of Charge (FOC) when sharing existing bedding with adults'
              }),
              _react2.default.createElement(
                'div',
                { style: { display: Boolean(data.focChildrenAllowed) ? 'flex' : 'none', alignItems: 'center', marginLeft: '36px' } },
                _react2.default.createElement(_materialUi.TextField, { type: 'number', hintText: 'Number', value: data.focChildrenCount || '', id: 'focChildrenCount', style: { width: '100px' }, onChange: function onChange(_ref6) {
                    var value = _ref6.target.value;
                    return onTextFieldChange({ key: 'focChildrenCount', value: value });
                  } }),
                '\xA0 free children ',
                _react2.default.createElement(
                  'span',
                  { style: { color: 'red' } },
                  ' * Required'
                )
              )
            ),
            _react2.default.createElement(_materialUi.Checkbox, {
              checked: Boolean(data.childrenNotAccepted),
              onCheck: function onCheck() {
                return onTextFieldChange({ key: 'childrenNotAccepted', value: !data.childrenNotAccepted });
              },
              style: { marginLeft: '5%', width: '90%' },
              label: 'Children not accepted'
            })
          ),
          textAboveTextField: 'Please note any other conditions related to your Child Policy. For example, if a cot or rollaway is required, you will be charged for the additional bedding.'
        };
      case 'infant':
        return {
          middleDiv: _react2.default.createElement(
            'div',
            { style: { display: 'flex', flexDirection: 'column' } },
            agesForInfantAndChild,
            _react2.default.createElement(_materialUi.Checkbox, {
              checked: Boolean(data.infantAsOccupant),
              style: { marginLeft: '5%', width: '90%' },
              onCheck: function onCheck() {
                return onTextFieldChange({ key: 'infantAsOccupant', value: !data.infantAsOccupant });
              },
              label: 'Infant counts as an occupant'
            })
          ),
          textAboveTextField: 'Please note any other conditions related to your Infant Policy. For example, infants are free if they are sharing existing bedding. If a crib is required, you will be charged for the additional bedding.'
        };
      default:
        return _react2.default.createElement('div', null);
    }
  }();
  var bottomDiv = _react2.default.createElement(
    'div',
    { className: 'flex-tc-sb', style: { padding: '8px 8px 0px 12px' } },
    data.policyType === 'cancellation' ? _react2.default.createElement(
      'div',
      { style: { color: data.showError ? 'red' : 'initial' } },
      data.showError ? 'Please make sure you have filled out all missing information' : 'NOTE: Seasonal cancellation policies can be added in the room type/product rates pages.'
    ) : _react2.default.createElement('div', null),
    _react2.default.createElement(
      'div',
      { style: { width: '200px' } },
      _react2.default.createElement(_flatButtonWithLoader2.default, {
        label: 'Cancel',
        hoverColor: 'none',
        labelStyle: { fontWeight: '600', marginRight: '15px' },
        primary: true,
        onTouchTap: onRequestClose
      }),
      _react2.default.createElement(_flatButtonWithLoader2.default, {
        label: 'Save',
        loader: saving,
        hoverColor: 'none',
        labelStyle: { fontWeight: '600' },
        onTouchTap: function onTouchTap() {
          if (data.policyType === 'cancellation') {
            var shoudShowError = cancellationsNotValid(data);
            if (shoudShowError) {
              return onTextFieldChange({ key: 'showError', value: true });
            }
          }
          saveSupplierInfoChanges({ contractId: contractId, data: data, updateType: 'SAVE_POLICY_ADD_EDIT' });
        },
        secondary: true,
        disabled: shouldDisable
      })
    )
  );
  if (data.policyType === 'cancellation') {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { style: { width: '90%', margin: '20px 0px 12px 5%' } },
        _react2.default.createElement(_rules2.default, _extends({}, data, {
          onChange: function onChange(key, value) {
            return onTextFieldChange({ key: key, value: value });
          }
        }))
      ),
      bottomDiv
    );
  }
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { width: '90%', margin: '20px 0px 12px 5%', whiteSpace: 'pre-wrap' } },
      data.note
    ),
    additionalDiv.middleDiv,
    _react2.default.createElement(
      'div',
      { style: { marginLeft: '5%', width: '90%', fontStyle: 'italic', fontSize: '14px', clear: 'both' } },
      additionalDiv.textAboveTextField
    ),
    _react2.default.createElement('textarea', {
      style: { marginLeft: '5%', width: '90%', marginBottom: '8px' },
      rows: 8,
      placeholder: 'Enter here...',
      defaultValue: data.conditions,
      autoFocus: true,
      onChange: function onChange(_ref7) {
        var value = _ref7.target.value;
        return onTextFieldChange({ key: 'conditions', value: value });
      }
    }),
    _react2.default.createElement(
      'div',
      { style: { color: 'red', marginLeft: '20px', marginBottom: '16px', fontSize: '12px' } },
      '* Required'
    ),
    bottomDiv
  );
};

EditLocationPolicy.propTypes = {
  onRequestClose: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  productId: _react.PropTypes.string,
  data: _react.PropTypes.object,
  saveText: _react.PropTypes.func,
  onTextFieldChange: _react.PropTypes.func,
  saving: _react.PropTypes.bool
};

exports.default = EditLocationPolicy;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _addCircleOutline = __webpack_require__(1259);

var _addCircleOutline2 = _interopRequireDefault(_addCircleOutline);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CancellationRules = function CancellationRules(_ref) {
  var cancelNum = _ref.cancelNum,
      cancelHoursDays = _ref.cancelHoursDays,
      conditions = _ref.conditions,
      additionalRules = _ref.additionalRules,
      _onChange = _ref.onChange,
      showError = _ref.showError;

  var updateInAdditionalRules = function updateInAdditionalRules(ruleIndex, key, value) {
    var updatedRules = additionalRules.map(function (thisRule, thisIndex) {
      return thisIndex === ruleIndex ? _extends({}, thisRule, _defineProperty({}, key, value)) : thisRule;
    });
    return _onChange('additionalRules', updatedRules);
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { marginTop: '16px', fontWeight: 'bold', fontSize: '13px' } },
      'Basic Cancellation Rule:',
      _react2.default.createElement(
        'small',
        { style: { color: 'red', fontWeight: showError ? 'bold' : 'initial', fontSize: showError ? '14px' : '10px' } },
        '\xA0',
        showError ? 'Missing Information' : '* All fields required'
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { fontSize: '13px' } },
      'Cancel at least',
      _react2.default.createElement(_typeControlledTextfield2.default, {
        id: 'cancelNum',
        hintText: 'Number',
        controlledType: 'number',
        hintStyle: { fontSize: '13px' },
        inputStyle: { fontSize: '13px', marginTop: '0', textAlign: 'right' },
        style: { width: '55px', marginLeft: '5px', height: '48px', display: 'inline-block' },
        errorStyle: { fontSize: '10px' },
        underlineStyle: { bottom: '10px' },
        value: cancelNum || '',
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          return _onChange('cancelNum', value);
        }
      }),
      _react2.default.createElement(
        'div',
        { style: { marginLeft: '10px', marginRight: '5px', width: '95px', display: 'inline-block', position: 'relative', top: '12px' } },
        _react2.default.createElement(_reactSelect2.default, {
          name: 'cancelHoursDays',
          options: [{ value: 'hours', label: 'Hours' }, { value: 'days', label: 'Days' }],
          value: cancelHoursDays,
          onChange: function onChange(_ref3) {
            var value = _ref3.value;
            return _onChange('cancelHoursDays', value);
          },
          placeholder: 'Hours/Days',
          clearable: false,
          scrollMenuIntoView: false
        })
      ),
      'prior to the date of travel to avoid any cancellation fees.'
    ),
    additionalRules && additionalRules.length ? _react2.default.createElement(
      'div',
      { style: { marginTop: '16px', fontWeight: 'bold', fontSize: '12px' } },
      'Additional Cancellation Rules'
    ) : _react2.default.createElement('div', null),
    additionalRules ? additionalRules.map(function (rule, ruleIndex) {
      return _react2.default.createElement(
        'div',
        { key: ruleIndex, style: { marginBottom: '16px', fontSize: '12px' } },
        ruleIndex + 1,
        '. If cancelled within',
        _react2.default.createElement(_typeControlledTextfield2.default, {
          id: ruleIndex + 'cancelNum',
          hintText: 'Number',
          controlledType: 'number',
          hintStyle: { fontSize: '12px' },
          inputStyle: { fontSize: '14px', marginTop: '0', textAlign: 'right' },
          style: { width: '55px', marginLeft: '5px', height: '48px', display: 'inline-block' },
          errorStyle: { fontSize: '10px' },
          underlineStyle: { bottom: '10px' },
          value: rule.cancelNum || '',
          onChange: function onChange(_ref4) {
            var value = _ref4.target.value;
            return updateInAdditionalRules(ruleIndex, 'cancelNum', value);
          }
        }),
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '10px', marginRight: '5px', width: '95px', display: 'inline-block', position: 'relative', top: '12px' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'cancelHoursDays',
            options: [{ value: 'hours', label: 'hours' }, { value: 'days', label: 'days' }],
            value: rule.cancelHoursDays,
            onChange: function onChange(_ref5) {
              var value = _ref5.value;
              return updateInAdditionalRules(ruleIndex, 'cancelHoursDays', value);
            },
            placeholder: 'hours/days',
            clearable: false,
            scrollMenuIntoView: false
          })
        ),
        'of the date of',
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '10px', marginRight: '5px', width: '135px', display: 'inline-block', position: 'relative', top: '12px' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'arrivalDeparture',
            options: [{ value: 'arrival', label: 'arrival' }, { value: 'departure', label: 'departure' }],
            value: rule.arrivalDeparture,
            onChange: function onChange(_ref6) {
              var value = _ref6.value;
              return updateInAdditionalRules(ruleIndex, 'arrivalDeparture', value);
            },
            placeholder: 'arrival/departure',
            clearable: false,
            scrollMenuIntoView: false
          })
        ),
        ', a fee equivalent to',
        _react2.default.createElement(_typeControlledTextfield2.default, {
          id: ruleIndex + 'cancelFee',
          hintText: 'Number',
          controlledType: 'number',
          hintStyle: { fontSize: '12px' },
          inputStyle: { fontSize: '14px', marginTop: '0', textAlign: 'right' },
          style: { width: '55px', marginLeft: '5px', height: '48px', display: 'inline-block' },
          errorStyle: { fontSize: '10px' },
          underlineStyle: { bottom: '10px' },
          value: rule.cancelFee || '',
          onChange: function onChange(_ref7) {
            var value = _ref7.target.value;
            return updateInAdditionalRules(ruleIndex, 'cancelFee', value);
          }
        }),
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '10px', marginRight: '5px', width: '220px', display: 'inline-block', position: 'relative', top: '12px' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'dollarPercent',
            options: [{ value: '(in the booking currency)', label: '(in the booking currency)' }, { value: 'percent', label: 'percent' }],
            value: rule.feeDollarPercent,
            onChange: function onChange(_ref8) {
              var value = _ref8.value;
              return updateInAdditionalRules(ruleIndex, 'feeDollarPercent', value);
            },
            placeholder: 'amount/percent',
            clearable: false,
            scrollMenuIntoView: false
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '250px', marginLeft: '5px', display: rule.feeDollarPercent === 'percent' ? 'inline-block' : 'none', position: 'relative', top: '12px' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: ruleIndex + 'feeBase',
            options: [{ value: 'of the cost of the first night', label: 'of the cost of the first night' }, { value: 'of the cost of the last night', label: 'of the cost of the last night' }, { value: 'of the average cost of a night during the stay', label: 'of the average cost of a night during the stay' }, { value: 'of the total value of the booking', label: 'of the total value of the booking' }, { value: 'of the minimum night stay for the rate booked', label: 'of the minimum night stay for the rate booked' }],
            value: rule.feeBase,
            onChange: function onChange(_ref9) {
              var value = _ref9.value;
              return updateInAdditionalRules(ruleIndex, 'feeBase', value);
            },
            placeholder: 'Click to select...',
            clearable: false,
            scrollMenuIntoView: false
          })
        ),
        '\xA0 will be charged.',
        _react2.default.createElement(
          'span',
          {
            className: 'hint--top',
            'aria-label': 'Remove this rule',
            style: { cursor: 'pointer', position: 'relative', top: '6px', marginLeft: '52px' },
            onClick: function onClick() {
              return _onChange('additionalRules', additionalRules.filter(function (_, thisIndex) {
                return thisIndex !== ruleIndex;
              }));
            }
          },
          _react2.default.createElement(_addCircleOutline2.default, { style: { color: 'red', transform: 'rotate(45deg)' } })
        )
      );
    }) : _react2.default.createElement('div', null),
    _react2.default.createElement(
      'div',
      { style: { margin: '12px 0' } },
      _react2.default.createElement(_addItemCard2.default, { editable: true, text: 'Add another cancellation rule', onClick: function onClick() {
          return _onChange('additionalRules', _ramda2.default.append({}, additionalRules));
        } })
    ),
    _react2.default.createElement(
      'div',
      { style: { marginTop: '8px', fontWeight: 'bold', fontSize: '13px' } },
      'Other condition:',
      _react2.default.createElement(
        'small',
        { style: { color: 'red', fontWeight: showError ? 'bold' : 'initial', fontSize: showError ? '14px' : '10px' } },
        '\xA0',
        showError ? 'Missing Information' : '* Required'
      )
    ),
    _react2.default.createElement(
      'small',
      null,
      'Please enter NA if not applicable'
    ),
    _react2.default.createElement('textarea', {
      rows: 2,
      style: { fontSize: '13px', margin: '8px 0' },
      placeholder: 'Please enter other conditions here...',
      value: conditions || '',
      autoFocus: true,
      onChange: function onChange(_ref10) {
        var value = _ref10.target.value;
        return _onChange('conditions', value);
      }
    })
  );
};

exports.default = CancellationRules;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _singleCancellationPolicy = __webpack_require__(3312);

var _singleCancellationPolicy2 = _interopRequireDefault(_singleCancellationPolicy);

var _syncSectionCheckbox = __webpack_require__(1004);

var _syncSectionCheckbox2 = _interopRequireDefault(_syncSectionCheckbox);

var _seasonalSections = __webpack_require__(1555);

var _seasonalSections2 = _interopRequireDefault(_seasonalSections);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancellationPolicies = function CancellationPolicies(_ref) {
  var contractingPeriod = _ref.contractingPeriod,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      existingSeasons = _ref.existingSeasons,
      productType = _ref.productType,
      contractId = _ref.contractId,
      productId = _ref.productId,
      onRequestClose = _ref.onRequestClose,
      saveProductInfoChanges = _ref.saveProductInfoChanges,
      saving = _ref.saving,
      data = _ref.data;

  var shouldDisable = function () {
    return !(data.cancellations.length && data.cancellations.every(function (obj) {
      if (obj.conditions === 'Same as location cancellation policy') return true;
      return !_ramda2.default.isNil(obj.cancelNum) && obj.cancelHoursDays && obj.conditions;
    }));
  }();
  var contentActions = { productType: productType, onTextFieldChange: function onTextFieldChange(index, key, value) {
      return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'cancellations', index, key], value: value });
    } };
  var onFieldChange = (0, _ramda.curry)(function (extraPaths, value) {
    return onTextFieldChangeWithKeyPath({ keyPath: (0, _ramda.concat)(['data', 'cancellations'], extraPaths), value: value });
  });
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { margin: '8px 0 0 24px' } },
      'Note: Cancellation Policies that apply to all room types/product can be added in the Policies & Notes page.'
    ),
    _react2.default.createElement(_seasonalSections2.default, {
      name: 'cancellation policies',
      seasons: existingSeasons,
      contractingPeriod: contractingPeriod,
      varyBySeason: data.varyBySeason,
      useSeasons: data.varyBySeason,
      contentsData: data.cancellations,
      emptyInitialContent: { conditions: '' },
      onFieldChange: onFieldChange,
      contentActions: contentActions,
      showError: data.showError,
      ContentNode: _singleCancellationPolicy2.default
    }),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', justifyContent: 'space-between', padding: '8px 8px 0px 12px', marginTop: data.cancellations && data.cancellations.length ? '' : '150px' } },
      _react2.default.createElement(_syncSectionCheckbox2.default, {
        sectionInEdit: 'cancellations',
        labelStyle: { width: '70%' },
        style: { width: '55%', top: '6px' }
      }),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Cancel',
          hoverColor: 'none',
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onTouchTap: onRequestClose
        }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Save',
          loader: saving,
          hoverColor: 'none',
          labelStyle: { fontWeight: '600' },
          onClick: function onClick() {
            if (shouldDisable) {
              return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'showError'], value: true });
            }
            saveProductInfoChanges({
              contractId: contractId,
              productId: productId,
              data: data,
              updateType: 'SAVE_SEASONAL_CANCELLATION_POLICIES'
            });
          },
          secondary: true
        })
      )
    )
  );
};

CancellationPolicies.propTypes = {};

exports.default = CancellationPolicies;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextContent = function TextContent(_ref) {
  var onRequestClose = _ref.onRequestClose,
      onTextFieldChange = _ref.onTextFieldChange,
      contractId = _ref.contractId,
      saveSupplierInfoChanges = _ref.saveSupplierInfoChanges,
      updateBuyerInfo = _ref.updateBuyerInfo,
      data = _ref.data,
      saving = _ref.saving;

  var termsCriteriaInfo = function termsCriteriaInfo(title) {
    switch (title) {
      case 'Add terms and conditions':
      case 'Edit terms and conditions':
        return {
          note: _react2.default.createElement(
            'p',
            null,
            'If your partner will need to agree to any terms and conditions, please enter them below. ',
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            ' For example, "We are not liable for any damages caused throughout the duration of travel."'
          )
        };
      case 'Add notes':
      case 'Edit notes':
        return {
          note: _react2.default.createElement(
            'p',
            null,
            'If you have any notes you\'d like to include for your partner, please enter them below. ',
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            ' For example, "Please include the special cancellation policy we spoke about."'
          )
        };
      case 'Add market information':
      case 'Edit market information':
        return {
          note: _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'If you would like to describe the types of customers these rates apply to, please make your note below.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'For example, "Asia & Middle East excl. Japan."'
            )
          )
        };
      default:
        return _react2.default.createElement('div', null);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: { width: '95%', margin: 'auto' } },
    _react2.default.createElement(
      'div',
      { style: { marginLeft: '20px', marginTop: '20px', marginBottom: '12px' } },
      termsCriteriaInfo(data.title).note
    ),
    _react2.default.createElement(
      'div',
      {
        style: { overflowX: 'hidden', marginBottom: '20px' }
      },
      data.fieldName === 'marketInfo' || data.fieldName === 'corporateIdentificationNumber' ? _react2.default.createElement(_materialUi.TextField, {
        id: 'marketInfo',
        autoFocus: true,
        defaultValue: data.value,
        errorText: data.value && data.value.length > 30 ? '30 character limit' : '',
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          return onTextFieldChange({ key: data.fieldName, value: value, forTermsAndNotes: true });
        }
      }) : _react2.default.createElement('textarea', {
        style: { overflowX: 'hidden', width: '100%' },
        rows: 8,
        placeholder: 'Enter here...',
        defaultValue: data.value,
        onChange: function onChange(_ref3) {
          var value = _ref3.target.value;
          return onTextFieldChange({ key: data.fieldName, value: value, forTermsAndNotes: true });
        }
      })
    ),
    _react2.default.createElement(_stepperActions2.default, { rightButtons: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Cancel',
          hoverColor: 'none',
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onTouchTap: onRequestClose
        }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Save',
          loader: saving,
          hoverColor: 'none',
          disabled: Boolean(data.fieldName === 'marketInfo' && data.value && data.value.length > 30),
          labelStyle: { fontWeight: '600' },
          onTouchTap: data.forSupplier ? function () {
            return saveSupplierInfoChanges({ contractId: contractId, data: data, updateType: data.fieldName === 'marketInfo' ? 'UPDATE_MARKET_INFO' : 'UPDATE_SUPPLIER_INFO_TERMS_NOTES' });
          } : function () {
            return updateBuyerInfo({ contractId: contractId, data: data });
          },
          secondary: true
        })
      )
    })
  );
};

TextContent.propTypes = {
  onRequestClose: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  productId: _react.PropTypes.string,
  data: _react.PropTypes.object,
  saveText: _react.PropTypes.func,
  onTextFieldChange: _react.PropTypes.func,
  createAmendment: _react.PropTypes.func
};

exports.default = TextContent;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _smallButtons = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleTemplate = function SingleTemplate(_ref) {
  var t = _ref.template,
      selected = _ref.selected,
      onSelect = _ref.onSelect,
      onUnselect = _ref.onUnselect,
      openRateDocIframe = _ref.openRateDocIframe,
      forCCImport = _ref.forCCImport;

  var previewCCRateDoc = function previewCCRateDoc() {
    return openRateDocIframe({
      url: t.magicLink + '&jumpBackTo=' + window.location.href,
      collection: t.originalContractId ? 'draft' : 'template',
      rateDocId: t.originalContractId || t._id,
      forCCImport: forCCImport,
      forImport: true
    });
  };
  return _react2.default.createElement(
    'div',
    { className: 'flex-tc-sb', style: { marginTop: '8px' } },
    _react2.default.createElement(
      'small',
      { style: { width: t.completionPercent === 100 ? '430px' : '350px', overflowX: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } },
      function () {
        if (!forCCImport && t.templateName) {
          return t.templateName;
        }
        if (t.locationName === t.supplierCompanyName || t.supplierCompanyName.indexOf('(RC)') > -1) {
          return t.locationName;
        }
        return t.supplierCompanyName + ' - ' + t.locationName;
      }(),
      Boolean(t.supplierInfo && t.supplierInfo.marketInfo) && _react2.default.createElement(
        'small',
        null,
        '\xA0\xA0(',
        t.supplierInfo.marketInfo,
        ')'
      )
    ),
    _react2.default.createElement(
      'small',
      { style: { width: '80px', fontSize: '10px', textAlign: 'right', display: t.completionPercent === 100 ? 'none' : 'block' } },
      (t.completionPercent || 80) + '% complete'
    ),
    _react2.default.createElement(
      'small',
      null,
      _moment2.default.utc(t.startDate).format('l'),
      ' - ',
      _moment2.default.utc(t.endDate).format('l')
    ),
    _react2.default.createElement(
      'div',
      { className: 'flex-center' },
      selected ? _react2.default.createElement(_smallButtons.SmallRaisedButton, {
        label: 'Unselect',
        primary: true,
        onClick: onUnselect
      }) : _react2.default.createElement(_smallButtons.SmallRaisedButton, {
        label: 'Select',
        secondary: true,
        onClick: onSelect
      }),
      '\xA0\xA0',
      _react2.default.createElement(_smallButtons.SmallFlatButton, {
        label: 'Preview',
        secondary: true,
        style: { border: '1px solid #00bcd4' },
        labelStyle: { bottom: '2px' },
        onClick: previewCCRateDoc
      })
    )
  );
};

exports.default = (0, _reactRedux.connect)(null, {
  openRateDocIframe: function openRateDocIframe(payload) {
    return {
      type: '{dummy-account} RateDocIframe_open',
      payload: payload
    };
  }
})(SingleTemplate);

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _datePickerSet = __webpack_require__(1140);

var _datePickerSet2 = _interopRequireDefault(_datePickerSet);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var dates = _ref.dates,
      contractingPeriod = _ref.contractingPeriod,
      onChange = _ref.onChange,
      forSaleDates = _ref.forSaleDates,
      disabled = _ref.disabled;
  return _react2.default.createElement(
    'div',
    null,
    dates.map(function (dateRange, index) {
      var currentFromDate = _ramda2.default.prop('fromDate', dateRange);
      var currentToDate = _ramda2.default.prop('toDate', dateRange);
      var initialStartDateMonth = function () {
        if (dateRange.fromDate) return dateRange.fromDate;
        if (dateRange.toDate) return dateRange.toDate;
        if (forSaleDates) return new Date();
        if (dates.length > 1 && index) return _ramda2.default.path([index - 1, 'toDate'], dates) || _ramda2.default.path([index - 1, 'fromDate'], dates);
        return contractingPeriod.startDate;
      }();
      var initialEndDateMonth = function () {
        if (dateRange.toDate) return dateRange.toDate;
        if (dateRange.fromDate) return dateRange.fromDate;
        if (dates.length > 1 && index) return _ramda2.default.path([index - 1, 'toDate'], dates) || _ramda2.default.path([index - 1, 'fromDate'], dates);
        return contractingPeriod.startDate;
      }();
      var startDateEnableFrom = function () {
        if (forSaleDates) {
          if (new Date() < new Date(initialStartDateMonth)) return new Date();
          return initialStartDateMonth;
        }
        return contractingPeriod.startDate;
      }();
      return _react2.default.createElement(
        'div',
        { key: index },
        _react2.default.createElement(_datePickerSet2.default, {
          endDateCloseOnSelect: true,
          startDateCloseOnSelect: true,
          startDateDisabled: disabled,
          endDateDisabled: disabled,
          disableDeleteButton: dates.length === 1,
          style: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' },
          startDateContainerStyle: { display: 'inline-block', width: '45%' },
          startDateTextFieldStyle: { width: '100%', fontSize: '12px' },
          endDateContainerStyle: { display: 'inline-block', width: '45%' },
          endDateTextFieldStyle: { width: '100%', fontSize: '12px' },
          addButtonStyle: { position: 'relative', marginLeft: '4%', visibility: disabled ? 'hidden' : 'visible' },
          deleteButtonStyle: { position: 'relative' },
          startDateFloatingText: 'From',
          endDateFloatingText: 'To',
          initialStartDateMonth: initialStartDateMonth,
          startDateEnableFrom: startDateEnableFrom,
          startDateEnableTo: contractingPeriod.endDate,
          initialEndDateMonth: initialEndDateMonth,
          endDateEnableFrom: dateRange.fromDate || contractingPeriod.startDate,
          endDateEnableTo: contractingPeriod.endDate,
          startDate: currentFromDate,
          endDate: currentToDate,
          onChangeStartDate: function onChangeStartDate(date) {
            return onChange([index, 'fromDate'], date);
          },
          onChangeEndDate: function onChangeEndDate(date) {
            return onChange([index, 'toDate'], date);
          },
          onDelete: function onDelete() {
            return onChange([], _ramda2.default.remove(index, 1, dates));
          },
          onAdd: function onAdd() {
            return onChange([], _ramda2.default.insert(index + 1, {}, dates));
          }
        }),
        dateRange.fromDate && dateRange.toDate && !disabled && !forSaleDates && _dateUtils2.default.notInContractingPeriod([dateRange], contractingPeriod.startDate, contractingPeriod.endDate) ? _react2.default.createElement(
          'div',
          { style: { color: '#f44336', fontSize: '12px', display: 'flex', width: '80%', alignItems: 'center', marginBottom: '12px' } },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-report', style: { color: '#f44336', marginRight: '4px' } }),
          'Not in contracting period, please UPDATE or REMOVE'
        ) : _react2.default.createElement('span', null),
        forSaleDates && disabled && _react2.default.createElement(
          'small',
          null,
          'We do not allow customized sale dates for stay pay offers at the moment.'
        )
      );
    })
  );
};

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _travelSalesDatesPickers = __webpack_require__(1983);

var _travelSalesDatesPickers2 = _interopRequireDefault(_travelSalesDatesPickers);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var data = _ref.data,
      contractingPeriod = _ref.contractingPeriod,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      disableSalesDates = _ref.disableSalesDates;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { height: data.validDatesOfSale.length * 48 + 'px', overflow: '' },
      leftColumnStyle: { position: 'relative', top: '8px', fontSize: '16px', width: '45%' },
      leftColumnContent: _react2.default.createElement(
        'div',
        null,
        'Please enter the dates that agents can sell this offer.',
        _react2.default.createElement(
          'span',
          { style: { fontSize: '12px', color: '#ff4081' } },
          '* Required'
        )
      ),
      rightColumnStyle: { width: '48%' },
      rightColumnContent: _react2.default.createElement(
        'div',
        { style: { width: '100%', position: 'relative', top: '-10px' } },
        _react2.default.createElement(_travelSalesDatesPickers2.default, {
          forSaleDates: true,
          disabled: disableSalesDates,
          contractingPeriod: contractingPeriod,
          dates: data.validDatesOfSale,
          onChange: function onChange(keyPath, value) {
            return onTextFieldChangeWithKeyPath({
              keyPath: _ramda2.default.concat(['data', 'validDatesOfSale'], keyPath),
              value: value
            });
          }
        })
      )
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { height: data.validDatesOfTravel.length * 48 + 'px', overflow: '' },
      leftColumnStyle: { position: 'relative', top: '8px', fontSize: '16px', width: '45%' },
      leftColumnContent: _react2.default.createElement(
        'div',
        null,
        'Please enter the dates of travel when this offer can be used.',
        _react2.default.createElement(
          'span',
          { style: { fontSize: '12px', color: '#ff4081' } },
          '* Required'
        )
      ),
      rightColumnStyle: { width: '48%' },
      rightColumnContent: _react2.default.createElement(
        'div',
        { style: { width: '100%', position: 'relative', top: '-10px' } },
        _react2.default.createElement(_travelSalesDatesPickers2.default, {
          contractingPeriod: contractingPeriod,
          dates: data.validDatesOfTravel,
          onChange: function onChange(keyPath, value) {
            return onTextFieldChangeWithKeyPath({
              keyPath: _ramda2.default.concat(['data', 'validDatesOfTravel'], keyPath),
              value: value
            });
          }
        })
      )
    })
  );
};

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _accomRatesForm = __webpack_require__(1552);

var _accomRatesForm2 = _interopRequireDefault(_accomRatesForm);

var _nonAccomRatesForm = __webpack_require__(1553);

var _nonAccomRatesForm2 = _interopRequireDefault(_nonAccomRatesForm);

var _rateTableTemplateContainer = __webpack_require__(632);

var _rateTableTemplateContainer2 = _interopRequireDefault(_rateTableTemplateContainer);

var _ramda = __webpack_require__(2);

var _materialUi = __webpack_require__(3);

var _functional = __webpack_require__(872);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkIfShouldDisable = function checkIfShouldDisable(data, offerRates, productType) {
  var checkDiscountRate = data.rate === 'discount' ? Boolean(data.discountType && data.amount) : true;
  var checkRateAmount = function checkRateAmount() {
    if (data.rate === 'rateAmount') {
      if (data.rates && data.rates.length) {
        if (data.rates.every(function (rate) {
          return rate.notApplicable;
        })) return true;
      } else {
        if (productType === 'Non-Accommodation') {
          var standardIsEmpty = (0, _ramda.isEmpty)((0, _functional.getIn)(['nonAccomStandard', 'nett'], offerRates), (0, _functional.getIn)(['nonAccomStandard', 'retail'], offerRates));
          var multiDayTourIsEmpty = !(0, _ramda.any)(function (value) {
            return value;
          })([offerRates.baseRate, (0, _ramda.or)(offerRates.rateType === 'includeCommission' && offerRates.retailRate, offerRates.rateType === 'nett'), offerRates.singleSupplement, offerRates.maxAdults]);
          var transfersOrPriceBreakIsEmpty = function () {
            var checkForSingleDetail = function checkForSingleDetail(detail) {
              return detail.maxAdultsPlusChild && detail.baseRate && (offerRates.rateType === 'includeCommission' ? detail.retailRate : true);
            };
            var filteredArray = (offerRates.transfersOrPriceBreak || []).filter(checkForSingleDetail);
            return !Boolean(filteredArray.length);
          }();
          return !(standardIsEmpty && multiDayTourIsEmpty && transfersOrPriceBreakIsEmpty);
        }
        if (productType === 'Accommodation') {
          if (offerRates.rateType === 'nett') return Boolean(offerRates.baseRate && offerRates.additionalAdult && offerRates.additionalChild && offerRates.includedGuestsinBaseRate && offerRates.maxAdults && offerRates.maxAdultsChildren);
          if (offerRates.rateType === 'includeCommission') return Boolean(offerRates.retailRate && offerRates.additionalAdult && offerRates.additionalChild && offerRates.includedGuestsinBaseRate && offerRates.maxAdults && offerRates.maxAdultsChildren);
        }
      }
    }
    return true;
  };
  return !Boolean((data.rate || data.isStayPay) && checkDiscountRate && checkRateAmount());
};

var StepTwo = function StepTwo(_ref) {
  var data = _ref.data,
      onRequestClose = _ref.onRequestClose,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      updateFieldForOfferRates = _ref.updateFieldForOfferRates,
      updateFieldWithKeyPathForOfferRates = _ref.updateFieldWithKeyPathForOfferRates,
      calculateAccomRatesTable = _ref.calculateAccomRatesTable,
      calculateStandardNonAccomRatesTable = _ref.calculateStandardNonAccomRatesTable,
      goToStep = _ref.goToStep,
      productType = _ref.productType,
      offerRates = _ref.offerRates,
      updateTableCell = _ref.updateTableCell,
      updateFormData = _ref.updateFormData;

  var shouldDisable = checkIfShouldDisable(data, offerRates, productType);
  var RateForm = productType === 'Accommodation' ? _accomRatesForm2.default : _nonAccomRatesForm2.default;
  var continueFunc = productType === 'Accommodation' ? calculateAccomRatesTable : calculateStandardNonAccomRatesTable;
  return _react2.default.createElement(
    'div',
    { style: { padding: '36px', paddingTop: '8px', fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" } },
    Boolean(data.isStayPay) ? _react2.default.createElement(
      'div',
      { style: { marginBottom: '24px' } },
      _react2.default.createElement(
        'div',
        { style: { paddingTop: '16px', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.74)' } },
        'Do your season rates apply to your Stay Pay Offer '
      ),
      _react2.default.createElement(_materialUi.RadioButton, {
        checked: !data.rate,
        label: 'Yes',
        onCheck: function onCheck() {
          return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'rate'], value: null });
        },
        labelStyle: { color: !data.rate ? 'rgba(0, 0, 0, 0.74)' : 'grey' }
      }),
      _react2.default.createElement(_materialUi.RadioButton, {
        checked: data.rate === 'rateAmount',
        label: 'No, I\'d like to enter a different rate for the Stay Pay offer',
        onCheck: function onCheck() {
          return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'rate'], value: 'rateAmount' });
        },
        labelStyle: { color: data.rate === 'rateAmount' ? 'rgba(0, 0, 0, 0.74)' : 'grey' }
      })
    ) : _react2.default.createElement(
      'div',
      { style: { minHeight: '180px' } },
      _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { height: '72px', marginBottom: '0', overflow: 'inherit' },
        leftColumnStyle: { position: 'relative', top: '34px', width: '40%' },
        leftColumnContent: 'Offer type',
        rightColumnStyle: { width: '60%' },
        rightColumnContent: _react2.default.createElement(
          'div',
          { style: { width: '100%', height: '72px' } },
          _react2.default.createElement(
            'div',
            { style: { width: '45%', display: 'inline-block', top: data.offerType === 'Per number of guests' ? '10px' : '34px', position: 'relative' } },
            _react2.default.createElement(_reactSelect2.default, {
              name: 'offerType',
              options: [{ value: 'Per night', label: 'Per night' }, { value: 'Per package', label: 'Per package' }, { value: 'Per person', label: 'Per person' }, { value: 'Per number of guests', label: 'Per number of guests' }],
              value: data.offerType,
              onChange: function onChange(_ref2) {
                var value = _ref2.value;
                return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'offerType'], value: value });
              },
              placeholder: 'Offer Type',
              clearable: false,
              scrollMenuIntoView: false
            })
          ),
          data.offerType === 'Per number of guests' ? _react2.default.createElement(_typeControlledTextfield2.default, {
            floatingLabelText: 'Number',
            controlledType: 'number',
            value: data.numberOfGuests,
            onChange: function onChange(_ref3) {
              var value = _ref3.target.value;
              return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'numberOfGuests'], value: value });
            },
            style: { width: '45%', display: 'inline-block', marginLeft: '5%', position: 'relative' }
          }) : undefined
        )
      }),
      _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { height: '72px', overflow: 'inherit', clear: 'both' },
        leftColumnStyle: { width: '40%' },
        leftColumnContent: _react2.default.createElement(
          'div',
          { style: { padding: '20px 0 4px 0' } },
          'Offer rate',
          _react2.default.createElement(
            'div',
            { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
            '* Required'
          )
        ),
        rightColumnStyle: { width: '60%' },
        rightColumnContent: _react2.default.createElement(
          'div',
          { style: { width: '100%', height: '72px' } },
          _react2.default.createElement(
            'div',
            { style: { width: '35%', float: 'left', padding: data.rate === 'discount' ? '30px 0 4px 0' : '20px 0 4px 0' } },
            _react2.default.createElement(_reactSelect2.default, {
              name: 'rate',
              options: [{ value: 'freeOfCharge', label: 'Free of charge' }, data.isStayPay ? null : { value: 'discount', label: 'Discount' }, { value: 'rateAmount', label: 'Rate Amount' }].filter(function (x) {
                return x;
              }),
              value: data.rate,
              onChange: function onChange(_ref4) {
                var value = _ref4.value;
                return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'rate'], value: value });
              },
              placeholder: 'Rate',
              clearable: false,
              scrollMenuIntoView: false
            })
          ),
          data.rate === 'discount' ? _react2.default.createElement(
            'div',
            { style: { width: '28%', marginLeft: '5%', padding: data.rate === 'discount' ? '30px 0 4px 0' : '20px 0 4px 0', display: 'inline-block' } },
            _react2.default.createElement(_reactSelect2.default, {
              name: 'rate',
              options: [{ value: 'percentage', label: 'Percentage' }, { value: 'flatRate', label: 'Flat fee' }],
              value: data.discountType,
              onChange: function onChange(_ref5) {
                var value = _ref5.value;
                return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'discountType'], value: value });
              },
              placeholder: 'Discount Type',
              clearable: false,
              scrollMenuIntoView: false
            })
          ) : undefined,
          data.rate === 'discount' ? _react2.default.createElement(
            'div',
            { style: { width: '28%', float: 'right', display: 'inline-block' } },
            _react2.default.createElement(_typeControlledTextfield2.default, {
              floatingLabelText: 'Amount', style: { display: 'inline-block', width: '70%' },
              value: data.amount,
              controlledType: 'number',
              onChange: function onChange(_ref6) {
                var value = _ref6.target.value;
                return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'amount'], value: value });
              }
            }),
            _react2.default.createElement(
              'span',
              { style: { lineHeight: '48px', fontSize: '16px' } },
              data.discountType === 'percentage' ? '%' : '$'
            )
          ) : undefined
        )
      })
    ),
    function () {
      if (data.rate === 'rateAmount') {
        if (data.rates && data.rates.length) {
          return _react2.default.createElement(_rateTableTemplateContainer2.default, {
            productType: productType,
            withEditableCell: true,
            rateSet: { rates: data.rates, nonStandardTemplateType: data.nonStandardTemplateType },
            updateTableCell: updateTableCell,
            forOffer: true,
            showHeader: true
          });
        }
        return _react2.default.createElement(RateForm, _extends({}, offerRates, {
          showTaxCurrency: false,
          updateFormData: updateFormData,
          updateFieldWithKeyPath: updateFieldWithKeyPathForOfferRates,
          updateFieldValue: updateFieldForOfferRates
        }));
      }
    }(),
    _react2.default.createElement(_stepperActions2.default, {
      style: { clear: 'both', top: '12px', position: 'relative' },
      showBackButton: true,
      backButtonFunc: function backButtonFunc() {
        return goToStep({ stepperWizardName: 'specialOffersStepper', componentIndex: 0 });
      },
      rightButtons: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          secondary: true,
          label: data.rate === 'rateAmount' ? 'Generate Rate Table' : 'Continue',
          onTouchTap: function onTouchTap() {
            if (!(data.rates && data.rates.length) && data.rate === 'rateAmount') continueFunc();
            goToStep({ stepperWizardName: 'specialOffersStepper', componentIndex: 2 });
          },
          labelStyle: { fontWeight: '600' },
          disabled: shouldDisable
        })
      )
    })
  );
};

exports.default = StepTwo;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _specialOfferTable = __webpack_require__(1557);

var _specialOfferTable2 = _interopRequireDefault(_specialOfferTable);

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var StepThree = function StepThree(_ref) {
  var data = _ref.data,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      updateTableCell = _ref.updateTableCell,
      productType = _ref.productType,
      rates = _ref.rates,
      nonStandardTemplateType = _ref.nonStandardTemplateType,
      goToStep = _ref.goToStep,
      commissionPercentage = _ref.commissionPercentage,
      nettCommission = _ref.nettCommission,
      rateType = _ref.rateType,
      contractingPeriod = _ref.contractingPeriod,
      addAnotherNewOffer = _ref.addAnotherNewOffer;

  var validDatesOfTravel = data.validDatesOfTravel.filter(function (dateSet) {
    return dateSet.fromDate || dateSet.toDate;
  });
  var validDatesOfSale = data.validDatesOfSale.filter(function (dateSet) {
    return dateSet.fromDate || dateSet.toDate;
  });
  var dataToSave = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.merge(_ramda2.default.__, { validDatesOfSale: validDatesOfSale, validDatesOfTravel: validDatesOfTravel }), _ramda2.default.omit(['title', !validDatesOfTravel.length ? 'validDatesOfTravel' : '', !validDatesOfSale.length ? 'validDatesOfSale' : ''])), data);
  dataToSave._id = 'new-' + _nodeUuid2.default.v1();
  if (data.rate === 'rateAmount') {
    dataToSave.rates = rates;
    dataToSave.commissionPercentage = commissionPercentage;
    dataToSave.nettCommission = nettCommission;
    dataToSave.rateType = rateType;
    dataToSave.nonStandardTemplateType = nonStandardTemplateType;
  }
  return _react2.default.createElement(
    'div',
    { style: { overflow: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' } },
    _react2.default.createElement(
      'div',
      { style: { padding: '36px' } },
      _react2.default.createElement(_specialOfferTable2.default, _extends({}, _ramda2.default.merge(data, { validDatesOfSale: validDatesOfSale, validDatesOfTravel: validDatesOfTravel }), {
        withEditableRateTable: true,
        style: { width: '100%' },
        rates: rates,
        nonStandardTemplateType: nonStandardTemplateType,
        productType: productType,
        contractingPeriod: contractingPeriod,
        updateTableCell: updateTableCell,
        updateFieldValue: function updateFieldValue(keyPath, value) {
          return onTextFieldChangeWithKeyPath({ keyPath: ['data'].concat(_toConsumableArray(keyPath)), value: value });
        }
      }))
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', justifyContent: 'space-between', marginTop: '16px', alignItems: 'center' } },
      _react2.default.createElement(_flatButtonWithLoader2.default, {
        label: 'back',
        secondary: true,
        onTouchTap: function onTouchTap() {
          return goToStep({ stepperWizardName: 'specialOffersStepper', componentIndex: 1 });
        }
      }),
      _react2.default.createElement(
        'div',
        { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          secondary: true,
          label: 'Add Another',
          onTouchTap: function onTouchTap() {
            return addAnotherNewOffer(dataToSave);
          },
          labelStyle: { fontWeight: '600' }
        })
      )
    )
  );
};

exports.default = StepThree;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIfShouldDisable = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _materialUi = __webpack_require__(3);

var _contractingPresetNamesCodes = __webpack_require__(464);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _accomRatesForm = __webpack_require__(1552);

var _accomRatesForm2 = _interopRequireDefault(_accomRatesForm);

var _nonAccomRatesForm = __webpack_require__(1553);

var _nonAccomRatesForm2 = _interopRequireDefault(_nonAccomRatesForm);

var _ramda = __webpack_require__(2);

var _functional = __webpack_require__(872);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkIfShouldDisable = exports.checkIfShouldDisable = function checkIfShouldDisable(data, extraRates) {
  var templateType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Non-Accommodation';

  var checkRateAmount = function checkRateAmount() {
    if (templateType === 'Non-Accommodation') {
      var standardIsEmpty = (0, _ramda.isEmpty)((0, _functional.getIn)(['nonAccomStandard', 'nett'], extraRates), (0, _functional.getIn)(['nonAccomStandard', 'retail'], extraRates));
      var multiDayTourIsEmpty = !(0, _ramda.any)(function (value) {
        return value;
      })([extraRates.baseRate, (0, _ramda.or)(extraRates.rateType === 'includeCommission' && extraRates.retailRate, extraRates.rateType === 'nett'), extraRates.singleSupplement, extraRates.maxAdults]);
      var transfersOrPriceBreakIsEmpty = function () {
        var checkForSingleDetail = function checkForSingleDetail(detail) {
          return detail.maxAdultsPlusChild && detail.baseRate && (extraRates.rateType === 'includeCommission' ? detail.retailRate : true);
        };
        var filteredArray = (extraRates.transfersOrPriceBreak || []).filter(checkForSingleDetail);
        return !Boolean(filteredArray.length);
      }();
      return !standardIsEmpty || !multiDayTourIsEmpty || !transfersOrPriceBreakIsEmpty;
    }
    if (templateType === 'Accommodation') {
      if (extraRates.rateType === 'nett') return Boolean(extraRates.baseRate && extraRates.additionalAdult && extraRates.additionalChild && extraRates.includedGuestsinBaseRate && extraRates.maxAdults && extraRates.maxAdultsChildren);
      if (extraRates.rateType === 'includeCommission') return Boolean(extraRates.retailRate && extraRates.additionalAdult && extraRates.additionalChild && extraRates.includedGuestsinBaseRate && extraRates.maxAdults && extraRates.maxAdultsChildren);
    }
  };
  return !Boolean(data.extraType && extraRates.currency && extraRates.taxInclusion && (extraRates.taxInclusion === 'exempt' || extraRates.taxType) && checkRateAmount());
};
var OneStep = function OneStep(_ref) {
  var data = _ref.data,
      extraRates = _ref.extraRates,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      updateFieldForOfferRates = _ref.updateFieldForOfferRates,
      updateFieldWithKeyPathForOfferRates = _ref.updateFieldWithKeyPathForOfferRates,
      goToStep = _ref.goToStep,
      onRequestClose = _ref.onRequestClose,
      updateFormData = _ref.updateFormData,
      calculateStandardNonAccomRatesTable = _ref.calculateStandardNonAccomRatesTable;
  var extraType = data.extraType,
      extraCode = data.extraCode,
      description = data.description;

  var shouldDisable = checkIfShouldDisable(data, extraRates);
  var extraNameSelectFields = Object.keys(_contractingPresetNamesCodes.extraNameAndCode).map(function (nameAndCode) {
    return { label: nameAndCode, value: nameAndCode };
  });
  var fontFamily = "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif";
  var leftColumnStyle = { width: '30%', textAlign: 'left', fontSize: '15px', fontFamily: fontFamily };
  var rightColumnStyle = { width: '70%', textAlign: 'left', paddingRight: '80px', fontFamily: fontFamily };
  var continueFunc = calculateStandardNonAccomRatesTable;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { padding: '24px 0 24px 12%' } },
      _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { marginBottom: '12px', overflow: 'inherit' },
        leftColumnStyle: leftColumnStyle,
        rightColumnStyle: rightColumnStyle,
        leftColumnContent: _react2.default.createElement(
          'div',
          null,
          'Extra type',
          _react2.default.createElement(
            'div',
            { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
            '* Required'
          )
        ),
        rightColumnContent: _react2.default.createElement(
          'div',
          { style: { width: '100%', display: 'inline-block' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'extraType',
            options: extraNameSelectFields,
            value: extraType,
            onChange: function onChange(_ref2) {
              var value = _ref2.value;
              return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'extraType'], value: value });
            },
            placeholder: 'Please select extra type',
            clearable: false,
            scrollMenuIntoView: false
          })
        )
      }),
      _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { marginBottom: '12px', clear: 'both' },
        leftColumnStyle: leftColumnStyle,
        rightColumnStyle: rightColumnStyle,
        leftColumnContent: _react2.default.createElement(
          'div',
          { style: { position: 'relative', top: '20px' } },
          'Extra code'
        ),
        rightColumnContent: _react2.default.createElement(_typeControlledTextfield2.default, {
          id: 'extra code',
          style: { width: '100%' },
          hintText: _contractingPresetNamesCodes.extraNameAndCode[extraType],
          value: extraCode,
          onChange: function onChange(_ref3) {
            var value = _ref3.target.value;
            return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'extraCode'], value: value });
          }
        })
      }),
      _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { marginBottom: '24px' },
        leftColumnStyle: leftColumnStyle,
        rightColumnStyle: rightColumnStyle,
        leftColumnContent: _react2.default.createElement(
          'div',
          { style: { position: 'relative', top: '20px' } },
          'Description'
        ),
        rightColumnContent: _react2.default.createElement(
          'div',
          { style: { width: '100%' } },
          _react2.default.createElement('textarea', {
            id: 'description',
            rows: 8,
            defaultValue: description,
            onChange: function onChange(_ref4) {
              var value = _ref4.target.value;
              return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'description'], value: value });
            }
          })
        )
      }),
      extraType ? _react2.default.createElement(_nonAccomRatesForm2.default, _extends({
        definedRateTemplate: 'standard'
      }, extraRates, {
        showTaxCurrency: true,
        updateFieldWithKeyPath: updateFieldWithKeyPathForOfferRates,
        updateFieldValue: updateFieldForOfferRates,
        updateFormData: updateFormData
      })) : undefined
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(_stepperActions2.default, {
      style: { clear: 'both' },
      rightButtons: _react2.default.createElement(
        'div',
        { style: { marginRight: '66px' } },
        _react2.default.createElement(_materialUi.FlatButton, {
          label: 'Generate Rate Table',
          hoverColor: 'none',
          labelStyle: { fontWeight: '600' },
          onTouchTap: function onTouchTap() {
            continueFunc();
            goToStep({ stepperWizardName: 'addExtraStepper', componentIndex: 1 });
          },
          secondary: true,
          disabled: shouldDisable
        })
      )
    })
  );
};

exports.default = OneStep;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.changeContractState = changeContractState;

var _dashboardConstants = __webpack_require__(3345);

var constants = _interopRequireWildcard(_dashboardConstants);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _s3ContractingFilesUpload = __webpack_require__(1534);

var _s3ContractingFilesUpload2 = _interopRequireDefault(_s3ContractingFilesUpload);

var _functional = __webpack_require__(872);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var credentialsAndHeaders = {
  credentials: 'same-origin',
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
};

var put = function put(body) {
  return _extends({ method: 'put', body: body }, credentialsAndHeaders);
};
function callApiGet(url, type) {
  return function (dispatch) {
    return fetch('/proxy/contracting/' + url, {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      return res.json();
    }).then(function (response) {
      dispatch({ type: constants[type], payload: response });
    });
  };
}

function callApiPut(url, type, body) {
  return function (dispatch) {
    return fetch('/proxy/contracting/' + url, {
      method: 'put',
      body: JSON.stringify(body),
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      if (res.body && res.json) return res.json();
      return {};
    }).then(function (response) {
      return dispatch({ type: type, payload: body });
    });
  };
}

function changeContractState(state, contractIds) {
  return function (dispatch) {
    var payload = {
      contractIds: contractIds,
      state: state
    };
    dispatch({ type: 'CHANGE_CONTRACT_STATE_STARTING', payload: payload });
    return fetch('/proxy/contracting/updateContractStatus', put(JSON.stringify({
      contractIds: Object.keys(contractIds),
      state: state
    }))).then(_checkStatus2.default).catch(function (err) {
      return console.log(err);
    });
  };
}

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _contractingYear = __webpack_require__(1539);

var _contractingYear2 = _interopRequireDefault(_contractingYear);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveAsTemplate = function SaveAsTemplate(props, _ref) {
  var router = _ref.router;
  var templateName = props.templateName,
      onFieldChange = props.onFieldChange,
      saveAsANewTemplate = props.saveAsANewTemplate,
      saving = props.saving,
      onRequestClose = props.onRequestClose,
      duplicateTemplateName = props.duplicateTemplateName,
      newDraftStartDate = props.newDraftStartDate,
      newDraftEndDate = props.newDraftEndDate,
      saveAsNewTemplateFinished = props.saveAsNewTemplateFinished,
      newDraft = props.newDraft,
      sourceTemplatePeriod = props.sourceTemplatePeriod,
      shouldClearDates = props.shouldClearDates,
      forBuyer = props.forBuyer,
      _props$makeACopySucce = props.makeACopySuccessPayload,
      makeACopySuccessPayload = _props$makeACopySucce === undefined ? {} : _props$makeACopySucce,
      push = props.push;

  var differentYear = newDraftStartDate && newDraftEndDate && sourceTemplatePeriod.startDate && sourceTemplatePeriod.endDate && new Date(newDraftStartDate).toISOString() !== new Date(sourceTemplatePeriod.startDate).toISOString() && new Date(newDraftEndDate).toISOString() !== new Date(sourceTemplatePeriod.endDate).toISOString();
  var sameMonthDay = newDraftStartDate && newDraftEndDate && sourceTemplatePeriod.startDate && sourceTemplatePeriod.endDate && new Date(newDraftStartDate).getUTCMonth() === new Date(sourceTemplatePeriod.startDate).getUTCMonth() && new Date(newDraftStartDate).getUTCDate() === new Date(sourceTemplatePeriod.startDate).getUTCDate() && new Date(newDraftEndDate).getUTCMonth() === new Date(sourceTemplatePeriod.endDate).getUTCMonth() && new Date(newDraftEndDate).getUTCDate() === new Date(sourceTemplatePeriod.endDate).getUTCDate();

  return _react2.default.createElement(
    'div',
    { style: { padding: '0 12px 12px 12px' } },
    function () {
      if (forBuyer) {
        if (makeACopySuccessPayload.wsId) {
          return _react2.default.createElement(
            'div',
            { style: { padding: '20px', textAlign: 'center' } },
            _react2.default.createElement(
              'ul',
              { style: { width: '80%', margin: 'auto', fontSize: '12px', textAlign: 'left' } },
              _react2.default.createElement(
                'li',
                null,
                'A new rate sheet is generated with the content of this rate sheet and dates justified accordingly.'
              ),
              _react2.default.createElement(
                'li',
                null,
                'New rate sheet will be in a new workspace based on the date selected.'
              ),
              _react2.default.createElement(
                'li',
                null,
                'You can send the rate sheet to supplier to complete the rate sheet and/or sign the rate sheet whenever you are ready.'
              )
            ),
            _react2.default.createElement(_materialUi.RaisedButton, {
              label: 'Go to Workspace',
              secondary: true,
              onClick: function onClick() {
                push('/contracting/contract/' + makeACopySuccessPayload.wsId + '/policies');
                onRequestClose('');
              }
            })
          );
        }
        return _react2.default.createElement(
          'div',
          { style: { padding: '20px' } },
          _react2.default.createElement(_contractingYear2.default, {
            required: true,
            startDate: newDraftStartDate,
            endDate: newDraftEndDate,
            onChange: function onChange(key, value) {
              return onFieldChange({ key: 'newDraft' + (key === 'startDate' ? 'StartDate' : 'EndDate'), value: value });
            }
          })
        );
      }
      if (saveAsNewTemplateFinished) {
        return _react2.default.createElement(
          'div',
          { style: { margin: '20px', textAlign: 'center' } },
          'A new template has been created.',
          _react2.default.createElement(_flatButtonWithLoader2.default, {
            secondary: true,
            label: 'Go To The New Template.',
            onClick: function onClick() {
              onRequestClose('');
              router.push('/contracting/draft/' + newDraft.originalContractId + '/details');
            }
          })
        );
      }
      return _react2.default.createElement(
        'div',
        { style: { margin: '20px' } },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Please enter a name for the new template:'
          )
        ),
        ' ',
        _react2.default.createElement(
          'span',
          { style: { color: 'red' } },
          '* Required'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_materialUi.TextField, {
          style: { width: '400px' },
          floatingLabelText: 'Name the new template',
          defaultValue: templateName,
          errorText: duplicateTemplateName ? 'There is already a template named "' + templateName + '" for this contracting period.' : '',
          onChange: function onChange(_ref2) {
            var value = _ref2.target.value;
            return onFieldChange({ key: 'templateName', value: value });
          }
        }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_contractingYear2.default, {
          required: true,
          startDate: newDraftStartDate,
          endDate: newDraftEndDate,
          onChange: function onChange(key, value) {
            return onFieldChange({ key: 'newDraft' + (key === 'startDate' ? 'StartDate' : 'EndDate'), value: value });
          }
        }),
        function () {
          // different year
          if (differentYear) {
            // same month day
            if (sameMonthDay) {
              return _react2.default.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center', textAlign: 'left', overflow: 'auto', marginTop: '12px', height: '64px' } },
                _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-warning2', color: 'grey' }),
                _react2.default.createElement(
                  'div',
                  { style: { display: 'inline-block', marginLeft: '8px' } },
                  'The dates in your new template will be updated for the selected year. Please review your dates carefully before finalising your template.'
                )
              );
            }
            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  'Would you like to keep the dates from this template?'
                )
              ),
              _react2.default.createElement(
                'span',
                { style: { color: 'red' } },
                '* Required'
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(_materialUi.RadioButton, {
                label: 'Yes, I will review and modify the dates accordingly',
                checked: shouldClearDates === false,
                onCheck: function onCheck() {
                  return onFieldChange({ key: 'shouldClearDates', value: false });
                }
              }),
              _react2.default.createElement(_materialUi.RadioButton, {
                label: 'No, please clear the dates',
                checked: shouldClearDates,
                onCheck: function onCheck() {
                  return onFieldChange({ key: 'shouldClearDates', value: true });
                }
              })
            );
          }
        }(),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'small',
          { style: { paddingLeft: '38px' } },
          _react2.default.createElement(
            'i',
            null,
            'Note: A separate template will be created.'
          )
        )
      );
    }(),
    _react2.default.createElement(_stepperActions2.default, {
      rightButtons: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Dismiss',
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onClick: onRequestClose
        }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Confirm',
          loader: saving,
          disabled: forBuyer ? Boolean(!newDraftEndDate || !newDraftStartDate || makeACopySuccessPayload.wsId) : Boolean(!templateName || !newDraftEndDate || !newDraftStartDate || saveAsNewTemplateFinished || differentYear && !sameMonthDay && typeof shouldClearDates !== 'boolean'),
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          secondary: true,
          onClick: saveAsANewTemplate
        })
      )
    })
  );
};

SaveAsTemplate.propTypes = {
  templateName: _react.PropTypes.string,
  saveAsTemplateBool: _react.PropTypes.bool,
  onFieldChange: _react.PropTypes.func,
  saveAsANewTemplate: _react.PropTypes.func,
  saving: _react.PropTypes.bool,
  onRequestClose: _react.PropTypes.func,
  checkingContractReadiness: _react.PropTypes.bool,
  errors: _react.PropTypes.object,
  locationId: _react.PropTypes.string,
  duplicateTemplateName: _react.PropTypes.bool,
  newDraftStartDate: _react.PropTypes.string,
  newDraftEndDate: _react.PropTypes.string,
  saveAsNewTemplateFinished: _react.PropTypes.bool,
  newDraft: _react.PropTypes.object,
  sourceTemplatePeriod: _react.PropTypes.object,
  shouldClearDates: _react.PropTypes.bool
};

SaveAsTemplate.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = SaveAsTemplate;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _singleCancellation = __webpack_require__(3383);

var _singleCancellation2 = _interopRequireDefault(_singleCancellation);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _expandableTextBlock = __webpack_require__(1560);

var _expandableTextBlock2 = _interopRequireDefault(_expandableTextBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var notNil = (0, _ramda.complement)(_ramda.isNil);
var existsAndNotEmpty = (0, _ramda.complement)((0, _ramda.either)(_ramda.isEmpty, _ramda.isNil));

var CancellationPolicy = function (_Component) {
  _inherits(CancellationPolicy, _Component);

  function CancellationPolicy() {
    _classCallCheck(this, CancellationPolicy);

    return _possibleConstructorReturn(this, (CancellationPolicy.__proto__ || Object.getPrototypeOf(CancellationPolicy)).apply(this, arguments));
  }

  _createClass(CancellationPolicy, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cancellationInfo = _props.cancellationInfo,
          editCancellation = _props.editCancellation,
          addCancellation = _props.addCancellation,
          supplierEditable = _props.supplierEditable,
          deletePolicy = _props.deletePolicy,
          openAddEditContractDialog = _props.openAddEditContractDialog,
          _props$existingSeason = _props.existingSeasons,
          existingSeasons = _props$existingSeason === undefined ? [] : _props$existingSeason,
          _props$label = _props.label,
          label = _props$label === undefined ? '' : _props$label,
          _props$classes = _props.classes,
          classes = _props$classes === undefined ? {} : _props$classes,
          inMaster = _props.inMaster;

      if (!(cancellationInfo && Object.keys(cancellationInfo).length)) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { id: 'cancellationPolicy', style: { marginBottom: '12px' } },
            _react2.default.createElement(
              _helperLink2.default,
              {
                value: 'cancellation',
                justLabel: inMaster
              },
              label
            )
          ),
          _react2.default.createElement(_addItemCard2.default, {
            onClick: addCancellation,
            text: 'Add ' + label.toLowerCase(),
            editable: supplierEditable
          })
        );
      }
      var cancellations = (0, _ramda.propOr)([], 'cancellations', cancellationInfo);
      var additionalRules = cancellationInfo.additionalRules || [];
      var varyBySeason = cancellations && cancellations.length && (cancellations.length > 1 || _ramda2.default.path([0, 'dateRanges', 'length'], cancellations) > 1);
      var basicRuleExist = notNil(cancellationInfo.cancelNum) && notNil(cancellationInfo.cancelHoursDays);
      // if (!(cancellations.length || basicRuleExist)) return <div/>;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { id: 'cancellationPolicy' },
          _react2.default.createElement(
            _helperLink2.default,
            {
              showSync: existsAndNotEmpty(cancellations),
              value: 'cancellation',
              openEditDialog: editCancellation,
              justLabel: inMaster
            },
            _react2.default.createElement(
              'b',
              null,
              label
            )
          )
        ),
        _react2.default.createElement(
          _mouseOverEditDiv2.default,
          {
            editable: supplierEditable,
            extendPadding: true,
            regularDiv: cancellations && cancellations.length > 1 && _ramda2.default.any(_ramda2.default.compose(_ramda2.default.isEmpty, _ramda2.default.prop('dateRanges')), existingSeasons),
            hintOnRight: existsAndNotEmpty(cancellations),
            actionButtons: _react2.default.createElement(_editButton2.default, { onEdit: editCancellation, deleteButton: Boolean(deletePolicy), onDelete: deletePolicy })
          },
          _react2.default.createElement(
            'div',
            { style: { whiteSpace: 'pre-wrap', wordWrap: 'break-word' }, className: classes.main },
            existsAndNotEmpty(cancellations) ? _react2.default.createElement(
              'div',
              null,
              cancellations.map(function (cancellation, index) {
                var _ref = cancellations.length > 1 ? existingSeasons[index] || cancellation : cancellation,
                    dateRanges = _ref.dateRanges;

                return _react2.default.createElement(_singleCancellation2.default, _extends({
                  key: index,
                  index: index,
                  classes: classes
                }, (0, _ramda.merge)(cancellation, { dateRanges: dateRanges }), {
                  varyBySeason: varyBySeason,
                  existingSeasons: existingSeasons,
                  openAddEditContractDialog: openAddEditContractDialog
                }));
              })
            ) : _react2.default.createElement(
              'div',
              null,
              basicRuleExist ? _react2.default.createElement(
                'div',
                null,
                'Cancel at least ',
                _react2.default.createElement(
                  'b',
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: classes.cancelNum },
                    cancellationInfo.cancelNum
                  ),
                  ' ',
                  _react2.default.createElement(
                    'span',
                    { className: classes.cancelHoursDays },
                    cancellationInfo.cancelHoursDays
                  )
                ),
                ' prior to the date of travel to avoid any cancellation fees.'
              ) : _react2.default.createElement('span', null),
              additionalRules && additionalRules.length ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'b',
                  { style: { display: 'inline-block', margin: '8px 0' } },
                  'Additional Cancellation Rules'
                ),
                additionalRules.map(function (rule, ruleIndex) {
                  return _react2.default.createElement(
                    'div',
                    { key: ruleIndex },
                    ruleIndex + 1,
                    '. If cancelled within ',
                    _react2.default.createElement(
                      'b',
                      null,
                      rule.cancelNum
                    ),
                    ' ',
                    _react2.default.createElement(
                      'b',
                      null,
                      rule.cancelHoursDays
                    ),
                    ' of the date of ',
                    _react2.default.createElement(
                      'b',
                      null,
                      rule.arrivalDeparture
                    ),
                    ', a fee equivalent to ',
                    _react2.default.createElement(
                      'b',
                      null,
                      rule.cancelFee
                    ),
                    ' ',
                    _react2.default.createElement(
                      'b',
                      null,
                      rule.feeDollarPercent
                    ),
                    ' ',
                    _react2.default.createElement(
                      'b',
                      null,
                      rule.feeBase
                    ),
                    ' will be charged.'
                  );
                })
              ) : _react2.default.createElement('div', null),
              _react2.default.createElement(
                _expandableTextBlock2.default,
                {
                  className: classes['conditions-textblock'] ? '' : classes['conditions'],
                  style: { whiteSpace: 'pre-wrap', wordWrap: 'break-word' }
                },
                classes['conditions-textblock'] || ((0, _ramda.propOr)('', 'conditions', cancellationInfo).toLowerCase() === 'na' ? '' : (0, _ramda.propOr)('', 'conditions', cancellationInfo))
              )
            )
          )
        )
      );
    }
  }]);

  return CancellationPolicy;
}(_react.Component);

CancellationPolicy.propTypes = {
  cancellationInfo: _react.PropTypes.object,
  editCancellation: _react.PropTypes.func,
  addCancellation: _react.PropTypes.func,
  deletePolicy: _react.PropTypes.func,
  supplierEditable: _react.PropTypes.bool,
  contractingPeriod: _react.PropTypes.object,
  openAddEditContractDialog: _react.PropTypes.func,
  existingSeasons: _react.PropTypes.array,
  label: _react.PropTypes.string,
  classes: _react.PropTypes.object,
  inMaster: _react.PropTypes.bool
};

exports.default = CancellationPolicy;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupPolicy = function GroupPolicy(_ref) {
  var groupInfo = _ref.groupInfo,
      editGroup = _ref.editGroup,
      addGroup = _ref.addGroup,
      supplierEditable = _ref.supplierEditable,
      deletePolicy = _ref.deletePolicy,
      hideLabel = _ref.hideLabel,
      _ref$classes = _ref.classes,
      classes = _ref$classes === undefined ? {} : _ref$classes,
      inMaster = _ref.inMaster;

  if (!(groupInfo && Object.keys(groupInfo).length)) {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { id: 'groupPolicy' },
        _react2.default.createElement(
          _helperLink2.default,
          { value: 'group', justLabel: inMaster },
          'Group Policy'
        )
      ),
      _react2.default.createElement(_addItemCard2.default, { onClick: addGroup, text: 'Add group policy', editable: supplierEditable })
    );
  }
  return _react2.default.createElement(
    'div',
    { id: 'groupPolicy' },
    _react2.default.createElement(_helperLink2.default, {
      value: 'group',
      openEditDialog: editGroup,
      labelText: !hideLabel && 'Group Policy',
      justLabel: inMaster
    }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        className: classes.main,
        editable: supplierEditable,
        extendPadding: true,
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: editGroup,
          deleteButton: Boolean(deletePolicy),
          onDelete: deletePolicy
        })
      },
      _react2.default.createElement(
        'div',
        { style: { whiteSpace: 'pre-wrap', wordWrap: 'break-word' } },
        classes['conditions-textblock'] || groupInfo.conditions
      )
    )
  );
};

GroupPolicy.propTypes = {
  groupInfo: _react.PropTypes.object,
  editGroup: _react.PropTypes.func,
  addGroup: _react.PropTypes.func,
  supplierEditable: _react.PropTypes.bool,
  inMaster: _react.PropTypes.bool
};

exports.default = GroupPolicy;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FreeOfChargePolicy = function FreeOfChargePolicy(_ref) {
  var freeOfChargeInfo = _ref.freeOfChargeInfo,
      editFreeOfCharge = _ref.editFreeOfCharge,
      addFreeOfCharge = _ref.addFreeOfCharge,
      supplierEditable = _ref.supplierEditable,
      deletePolicy = _ref.deletePolicy,
      hideLabel = _ref.hideLabel,
      _ref$classes = _ref.classes,
      classes = _ref$classes === undefined ? {} : _ref$classes,
      inMaster = _ref.inMaster;

  if (!(freeOfChargeInfo && Object.keys(freeOfChargeInfo).length)) {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { id: 'freeOfChargePolicy' },
        _react2.default.createElement(
          _helperLink2.default,
          { value: 'freeOfCharge', justLabel: inMaster },
          'Free of Charge Policy'
        )
      ),
      _react2.default.createElement(_addItemCard2.default, {
        onClick: addFreeOfCharge,
        text: 'Add free of charge policy',
        editable: supplierEditable
      })
    );
  }
  return _react2.default.createElement(
    'div',
    { id: 'freeOfChargePolicy' },
    _react2.default.createElement(_helperLink2.default, {
      value: 'freeOfCharge',
      openEditDialog: editFreeOfCharge,
      labelText: !hideLabel && 'Free of Charge Policy',
      justLabel: inMaster
    }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        className: classes.main,
        editable: supplierEditable,
        extendPadding: true,
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: editFreeOfCharge,
          deleteButton: Boolean(deletePolicy),
          onDelete: deletePolicy
        })
      },
      _react2.default.createElement(
        'div',
        { style: { whiteSpace: 'pre-wrap', wordWrap: 'break-word' } },
        classes['conditions-textblock'] || freeOfChargeInfo.conditions
      )
    )
  );
};

FreeOfChargePolicy.propTypes = {
  freeOfChargeInfo: _react.PropTypes.object,
  editFreeOfCharge: _react.PropTypes.func,
  addFreeOfCharge: _react.PropTypes.func,
  supplierEditable: _react.PropTypes.bool,
  inMaster: _react.PropTypes.bool
};

exports.default = FreeOfChargePolicy;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FamilyChildPolicy = function FamilyChildPolicy(_ref) {
  var familyInfo = _ref.familyInfo,
      editFamily = _ref.editFamily,
      addFamily = _ref.addFamily,
      supplierEditable = _ref.supplierEditable,
      deletePolicy = _ref.deletePolicy,
      hideLabel = _ref.hideLabel,
      _ref$classes = _ref.classes,
      classes = _ref$classes === undefined ? {} : _ref$classes,
      inMaster = _ref.inMaster;

  if (!(familyInfo && Object.keys(familyInfo).length)) {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { id: 'familyPolicy' },
        _react2.default.createElement(
          _helperLink2.default,
          { value: 'family', justLabel: inMaster },
          'Family Policy'
        )
      ),
      _react2.default.createElement(_addItemCard2.default, { onClick: addFamily, text: 'Add family policy', editable: supplierEditable })
    );
  }

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_helperLink2.default, {
      value: 'family',
      openEditDialog: editFamily,
      labelText: !hideLabel && 'Family Policy',
      justLabel: inMaster
    }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        className: classes.main,
        editable: supplierEditable,
        extendPadding: true,
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: editFamily,
          deleteButton: Boolean(deletePolicy),
          onDelete: deletePolicy
        })
      },
      familyInfo.adultCount > 0 && _react2.default.createElement(
        'span',
        { className: classes.adultCount },
        familyInfo.adultCount,
        ' ',
        (0, _pluralize2.default)('Adult', familyInfo.adultCount),
        ' and',
        ' '
      ),
      familyInfo.childrenCount > 0 && _react2.default.createElement(
        'span',
        { className: classes.childrenCount },
        familyInfo.childrenCount,
        ' ',
        (0, _pluralize2.default)('Child', familyInfo.childrenCount),
        ' '
      ),
      _react2.default.createElement(
        'div',
        { style: { whiteSpace: 'pre-wrap', wordWrap: 'break-word' } },
        classes['conditions-textblock'] || familyInfo.conditions
      )
    )
  );
};

FamilyChildPolicy.propTypes = {
  familyInfo: _react.PropTypes.object,
  editFamilyChild: _react.PropTypes.func,
  addFamilyChild: _react.PropTypes.func,
  supplierEditable: _react.PropTypes.bool,
  inMaster: _react.PropTypes.bool
};

exports.default = FamilyChildPolicy;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FamilyChildPolicy = function FamilyChildPolicy(_ref) {
  var childInfo = _ref.childInfo,
      editChild = _ref.editChild,
      addChild = _ref.addChild,
      supplierEditable = _ref.supplierEditable,
      deletePolicy = _ref.deletePolicy,
      inMaster = _ref.inMaster,
      _ref$classes = _ref.classes,
      classes = _ref$classes === undefined ? {} : _ref$classes;

  if (!(childInfo && Object.keys(childInfo).length)) {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { id: 'childPolicy' },
        _react2.default.createElement(
          _helperLink2.default,
          { value: 'child', justLabel: inMaster },
          'Child Policy'
        )
      ),
      _react2.default.createElement(_addItemCard2.default, {
        onClick: addChild,
        text: 'Add child policy',
        editable: supplierEditable
      })
    );
  }
  return _react2.default.createElement(
    'div',
    { id: 'childPolicy' },
    _react2.default.createElement(_helperLink2.default, {
      value: 'child',
      openEditDialog: editChild,
      labelText: 'Child Policy',
      justLabel: inMaster
    }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        className: classes.main,
        editable: supplierEditable,
        extendPadding: true,
        actionButtons: _react2.default.createElement(_editButton2.default, { onEdit: editChild, deleteButton: Boolean(deletePolicy), onDelete: deletePolicy })
      },
      childInfo.ageFrom >= 0 ? _react2.default.createElement(
        'span',
        { className: classes['ageFrom'] },
        'From ',
        childInfo.ageFrom,
        ' to '
      ) : null,
      childInfo.ageTo > 0 ? _react2.default.createElement(
        'span',
        { className: classes['ageTo'] },
        childInfo.ageTo,
        ' (inclusive)'
      ) : null,
      childInfo.focChildrenCount > 0 && _react2.default.createElement(
        'div',
        null,
        '* ',
        _react2.default.createElement(
          'span',
          { className: classes['focChildrenCount'] },
          childInfo.focChildrenCount
        ),
        ' ',
        (0, _pluralize2.default)('child', childInfo.focChildrenCount),
        ' ',
        (0, _pluralize2.default)('is', childInfo.focChildrenCount),
        ' Free of Charge when sharing existing bedding with adults. *'
      ),
      childInfo.childrenNotAccepted ? _react2.default.createElement(
        'div',
        { className: classes.childrenNotAccepted },
        '* Children not accepted *'
      ) : null,
      _react2.default.createElement(
        'div',
        { style: { whiteSpace: 'pre-wrap', wordWrap: 'break-word', display: (childInfo.conditions || '').trim().toLowerCase() !== 'na' ? 'block' : 'none' } },
        classes['conditions-textblock'] || childInfo.conditions
      )
    )
  );
};

FamilyChildPolicy.propTypes = {
  hideLabel: _react.PropTypes.bool,
  childInfo: _react.PropTypes.object,
  editFamilyChild: _react.PropTypes.func,
  addFamilyChild: _react.PropTypes.func,
  supplierEditable: _react.PropTypes.bool,
  inMaster: _react.PropTypes.bool
};

exports.default = FamilyChildPolicy;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FamilyChildPolicy = function FamilyChildPolicy(_ref) {
  var infantInfo = _ref.infantInfo,
      editInfant = _ref.editInfant,
      addInfant = _ref.addInfant,
      supplierEditable = _ref.supplierEditable,
      deletePolicy = _ref.deletePolicy,
      hideLabel = _ref.hideLabel,
      _ref$classes = _ref.classes,
      classes = _ref$classes === undefined ? {} : _ref$classes,
      inMaster = _ref.inMaster;

  if (!(infantInfo && Object.keys(infantInfo).length)) {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { id: 'infantPolicy' },
        _react2.default.createElement(
          _helperLink2.default,
          { value: 'infant', justLabel: inMaster },
          'Infant Policy'
        )
      ),
      _react2.default.createElement(_addItemCard2.default, { onClick: addInfant, text: 'Add infant policy', editable: supplierEditable })
    );
  }
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_helperLink2.default, {
      value: 'infant',
      openEditDialog: editInfant,
      labelText: !hideLabel && 'Infant Policy',
      justLabel: inMaster
    }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        className: classes.main,
        editable: supplierEditable,
        extendPadding: true,
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: editInfant,
          deleteButton: Boolean(deletePolicy),
          onDelete: deletePolicy
        })
      },
      infantInfo.ageFrom >= 0 ? _react2.default.createElement(
        'span',
        { className: classes.ageFrom },
        'From ',
        infantInfo.ageFrom,
        ' to '
      ) : null,
      infantInfo.ageTo > 0 ? _react2.default.createElement(
        'span',
        { className: classes.ageTo },
        infantInfo.ageTo,
        ' (inclusive)'
      ) : null,
      infantInfo.infantAsOccupant ? _react2.default.createElement(
        'div',
        { className: classes.infantAsOccupant },
        '* Infant counts as an occupant *'
      ) : null,
      _react2.default.createElement(
        'div',
        { style: { whiteSpace: 'pre-wrap', wordWrap: 'break-word', display: (infantInfo.conditions || '').trim().toLowerCase() !== 'na' ? 'block' : 'none' } },
        classes['conditions-textblock'] || infantInfo.conditions
      )
    )
  );
};

FamilyChildPolicy.propTypes = {
  infantInfo: _react.PropTypes.object,
  editFamilyChild: _react.PropTypes.func,
  addFamilyChild: _react.PropTypes.func,
  supplierEditable: _react.PropTypes.bool,
  inMaster: _react.PropTypes.bool
};

exports.default = FamilyChildPolicy;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _aphrodite = __webpack_require__(123);

var _aphrodite2 = _interopRequireDefault(_aphrodite);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _fileDownload = __webpack_require__(1997);

var _fileDownload2 = _interopRequireDefault(_fileDownload);

var _delete = __webpack_require__(738);

var _delete2 = _interopRequireDefault(_delete);

var _moreVert = __webpack_require__(876);

var _moreVert2 = _interopRequireDefault(_moreVert);

var _modeEdit = __webpack_require__(1268);

var _modeEdit2 = _interopRequireDefault(_modeEdit);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _actions = __webpack_require__(537);

var _contractActivitiesProductsActions = __webpack_require__(493);

var _dropzone = __webpack_require__(869);

var _dropzone2 = _interopRequireDefault(_dropzone);

var _s3Upload = __webpack_require__(564);

var _s3Upload2 = _interopRequireDefault(_s3Upload);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _TextField = __webpack_require__(626);

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = _aphrodite2.default.StyleSheet.create({
  uploadArea: { border: '4px dashed rgb(239, 239, 239)', padding: '12px 8px', clear: 'both', minHeight: '150px' }
});
var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var propTypes = {
  contractId: _react.PropTypes.string,
  files: _react.PropTypes.array,
  downloadFromUrl: _react.PropTypes.func,
  addFileToContractInDB: _react.PropTypes.func,
  deleteFileFromContractInDB: _react.PropTypes.func,
  modifyFileFromContractInDB: _react.PropTypes.func,
  isLatest: _react.PropTypes.bool,
  to: _react.PropTypes.object,
  from: _react.PropTypes.object
};

var CATEGORIES = ['All', 'Rates', 'Allotment', 'Special Event Dates and Close Outs', 'Dynamic', 'General'];

var NotesAndFilesExternalFiles = function (_React$Component) {
  _inherits(NotesAndFilesExternalFiles, _React$Component);

  function NotesAndFilesExternalFiles(props) {
    _classCallCheck(this, NotesAndFilesExternalFiles);

    var _this2 = _possibleConstructorReturn(this, (NotesAndFilesExternalFiles.__proto__ || Object.getPrototypeOf(NotesAndFilesExternalFiles)).call(this, props));

    _this2.dropFiles = function (droppedFiles) {
      var _this2$props = _this2.props,
          addFileToContractInDB = _this2$props.addFileToContractInDB,
          contractId = _this2$props.contractId;

      var _this = _this2;
      _this2.setState({
        filesUploading: droppedFiles.map(function (file) {
          return { name: file.name, percent: 0 };
        }),
        filesUploaded: []
      }, function () {
        droppedFiles.forEach(function (file, fileIndex) {
          return _s3Upload2.default.s3upload({
            file_to_upload: file,
            file_name: file.name,
            ACL: 'private',
            onFinishS3Put: function onFinishS3Put(path) {
              var _this$state = _this.state,
                  filesUploaded = _this$state.filesUploaded,
                  filesUploading = _this$state.filesUploading;

              var uploadedFileInfo = {
                path: path,
                name: file.name,
                type: file.type,
                size: file.size
              };
              var allUploaded = [].concat(_toConsumableArray(filesUploaded), [uploadedFileInfo]);
              _this.setState({ filesUploaded: allUploaded }, function () {
                if (allUploaded.length === filesUploading.length) {
                  _this.setState({
                    filesUploading: [],
                    filesUploaded: []
                  }, function () {
                    addFileToContractInDB(contractId, allUploaded);
                  });
                }
              });
            },
            onProgress: function onProgress(percent) {
              _this.setState({
                filesUploading: _this.state.filesUploading.map(function (fileInState, i) {
                  if (i === fileIndex) return _ramda2.default.merge(fileInState, { percent: percent });
                  return fileInState;
                })
              });
            },
            onError: function onError(status) {
              console.log(status);
            }
          });
        });
      });
    };

    _this2.handleEdit = function (file) {
      _this2.setState({
        editingFile: file._id,
        editValues: _defineProperty({}, file._id, {
          name: file.name,
          category: file.category || ''
        })
      });
    };

    _this2.handleSave = function () {
      var _this2$props2 = _this2.props,
          contractId = _this2$props2.contractId,
          modifyFileFromContractInDB = _this2$props2.modifyFileFromContractInDB;
      var _this2$state = _this2.state,
          editingFile = _this2$state.editingFile,
          editValues = _this2$state.editValues;

      var editedValues = editValues[editingFile];
      var updates = {
        'files.$.name': editedValues.name,
        'files.$.category': editedValues.category
      };

      _this2.setState({ saving: true });
      modifyFileFromContractInDB(contractId, editingFile, updates).then(function () {
        return _this2.setState({
          saving: false,
          editingFile: null,
          editValues: {}
        });
      });
    };

    _this2.state = {
      filesUploading: [],
      filesUploaded: [],
      removing: [],
      filingContractId: '',
      allCheckedIds: [],
      selectedCategory: 'All',
      editingFile: null,
      editValues: {},
      saving: false
    };
    return _this2;
  }

  _createClass(NotesAndFilesExternalFiles, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          filesUploading = _state.filesUploading,
          removing = _state.removing;
      var _props = this.props,
          contractId = _props.contractId,
          deleteFileFromContractInDB = _props.deleteFileFromContractInDB,
          downloadFromUrl = _props.downloadFromUrl,
          files = _props.files,
          isLatest = _props.isLatest,
          to = _props.to,
          from = _props.from;

      var hasExternalFiles = Boolean(files && files.length);
      return _react2.default.createElement(
        'div',
        null,
        hasExternalFiles && _react2.default.createElement(
          'div',
          { className: 'flex-tc-sb', style: { marginBottom: '16px' } },
          _react2.default.createElement(
            'h4',
            null,
            'External Files'
          ),
          _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb' },
            _react2.default.createElement(
              'select',
              {
                value: this.state.selectedCategory,
                onChange: function onChange(e) {
                  return _this3.setState({ selectedCategory: e.target.value });
                },
                style: { marginRight: '16px' }
              },
              CATEGORIES.map(function (category) {
                return _react2.default.createElement(
                  'option',
                  { key: category, value: category },
                  category
                );
              })
            ),
            _react2.default.createElement(_raisedButtonWithLoader2.default, {
              label: 'Download All',
              secondary: true,
              onTouchTap: function onTouchTap() {
                return (0, _actions.bulkDownloadS3File)(_this3.props.files, to.name + ' Rates');
              },
              icon: _react2.default.createElement(_fileDownload2.default, null)
            })
          )
        ),
        !hasExternalFiles && _react2.default.createElement(
          'div',
          { style: { padding: '16px 0', fontSize: '18px', color: 'rgba(0, 0, 0, 0.44)' } },
          'You haven\'t received any rate files. Or you can upload files as well.'
        ),
        Boolean(files && files.length) && _react2.default.createElement(
          'div',
          { style: { borderBottom: '1px solid #e0e0e0', marginBottom: '16px', paddingBottom: '4px' } },
          files.filter(function (file) {
            return _this3.state.selectedCategory === 'All' || file.category === _this3.state.selectedCategory;
          }).map(function (file, fileIndex) {
            var addedByBuyer = ['directUpload', 'emailScrape'].indexOf(file.source) > -1 || file.source.indexOf('emailId') > -1;
            // const addedBySupplier = file.source === 'supplierSent';
            // const enableEditOptions = (
            //   (companyType === 'Contractor' && addedByBuyer)
            //   || (companyType === 'Supplier' && addedBySupplier)
            // ) && isLatest;
            return _react2.default.createElement(
              'div',
              {
                key: '' + file._id + fileIndex,
                style: removing.indexOf(file._id) > -1 ? { filter: 'blur(2px) ' } : {}
              },
              _react2.default.createElement(_materialUi.ListItem, {
                onTouchTap: function onTouchTap() {
                  return downloadFromUrl(file);
                },
                disabled: _this3.state.editingFile === file._id,
                secondaryText: (addedByBuyer ? 'Added By ' + from.name : 'Sent By ' + to.name) + ' on ' + (0, _moment2.default)(file.createdAt).format('l'),
                primaryText: _this3.state.editingFile === file._id ? _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'flex-tc-sb', style: { display: 'flex', flexWrap: 'wrap', gap: '5%', marginBottom: '8px' } },
                    _react2.default.createElement(_TextField2.default, {
                      style: { width: '75%' },
                      autoFocus: true,
                      variant: 'outlined',
                      value: _this3.state.editValues[file._id].name,
                      onChange: function onChange(e) {
                        return _this3.setState({
                          editValues: _extends({}, _this3.state.editValues, _defineProperty({}, file._id, _extends({}, _this3.state.editValues[file._id], {
                            name: e.target.value
                          })))
                        });
                      },
                      floatingLabelText: 'File Name'
                    }),
                    _react2.default.createElement(
                      'div',
                      { style: { width: '20%' } },
                      _react2.default.createElement(
                        'select',
                        {
                          value: _this3.state.editValues[file._id].category,
                          onChange: function onChange(e) {
                            return _this3.setState({
                              editValues: _extends({}, _this3.state.editValues, _defineProperty({}, file._id, _extends({}, _this3.state.editValues[file._id], {
                                category: e.target.value
                              })))
                            });
                          },
                          style: { width: '100%', height: 'auto', padding: '10px', margin: '0', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }
                        },
                        _react2.default.createElement(
                          'option',
                          { value: '' },
                          'Select Category'
                        ),
                        CATEGORIES.filter(function (cat) {
                          return cat !== 'All';
                        }).map(function (category) {
                          return _react2.default.createElement(
                            'option',
                            { key: category, value: category },
                            category
                          );
                        })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'flex-tc-sb', style: { marginTop: '8px' } },
                    _react2.default.createElement(_raisedButtonWithLoader2.default, {
                      primary: true,
                      label: 'Cancel',
                      loader: _this3.state.saving,
                      onTouchTap: function onTouchTap() {
                        return _this3.setState({
                          editingFile: null,
                          editValues: {}
                        });
                      }
                    }),
                    _react2.default.createElement(_raisedButtonWithLoader2.default, {
                      secondary: true,
                      label: 'Save',
                      loader: _this3.state.saving,
                      disabled: file.name === _this3.state.editValues[file._id].name && file.category === _this3.state.editValues[file._id].category,
                      onTouchTap: _this3.handleSave
                    })
                  )
                ) : _react2.default.createElement(
                  'span',
                  null,
                  file.name,
                  file.category && ' (' + file.category + ')'
                ),
                rightIconButton: _react2.default.createElement(
                  _materialUi.IconMenu,
                  {
                    desktop: true,
                    iconButtonElement: _react2.default.createElement(
                      _materialUi.IconButton,
                      {
                        touch: true,
                        tooltip: 'More Actions',
                        tooltipPosition: 'bottom-left'
                      },
                      _react2.default.createElement(_moreVert2.default, { color: 'grey' })
                    )
                  },
                  _react2.default.createElement(_materialUi.MenuItem, { leftIcon: _react2.default.createElement(_fileDownload2.default, null), primaryText: 'Download', onTouchTap: function onTouchTap() {
                      return downloadFromUrl(file);
                    } }),
                  _react2.default.createElement(_materialUi.MenuItem, {
                    leftIcon: _react2.default.createElement(_delete2.default, null),
                    primaryText: 'Remove',
                    onTouchTap: function onTouchTap() {
                      _this3.setState({ removing: [].concat(_toConsumableArray(removing), [file._id]) }, function () {
                        deleteFileFromContractInDB(contractId, file._id).then(function () {
                          if (file.source === 'directUpload') (0, _actions.deleteFileFromS3)(file.path);
                        });
                      });
                    }
                  }),
                  _react2.default.createElement(_materialUi.MenuItem, {
                    leftIcon: _react2.default.createElement(_modeEdit2.default, null),
                    primaryText: 'Edit',
                    onTouchTap: function onTouchTap() {
                      return _this3.handleEdit(file);
                    }
                  })
                )
              }),
              fileIndex !== files.length - 1 && _react2.default.createElement(_materialUi.Divider, null)
            );
          })
        ),
        _react2.default.createElement(
          _dropzone2.default,
          {
            className: _aphrodite2.default.css(styles.uploadArea),
            style: { display: isNilOrEmpty(filesUploading) ? 'flex' : 'none', alignItems: 'center', fontSize: '16px', color: 'rgba(0, 0, 0, 0.44)' },
            onDrop: this.dropFiles
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-add', color: '#bfbfbf', style: { fontSize: '100px', marginRight: '16px' } }),
          'Attach files by dragging & dropping or\xA0',
          _react2.default.createElement(
            'span',
            { style: { color: '#00b3cf', cursor: 'pointer' } },
            'selecting them'
          )
        ),
        !isNilOrEmpty(filesUploading) && _react2.default.createElement(
          'div',
          { className: _aphrodite2.default.css(styles.uploadArea) },
          filesUploading.map(function (file, index) {
            return _react2.default.createElement(
              'div',
              {
                key: '' + index + file.name,
                style: { color: 'rgba(0, 0, 0, 0.54)', lineHeight: '54px' }
              },
              _react2.default.createElement(
                'div',
                null,
                file.name
              ),
              _react2.default.createElement(_materialUi.LinearProgress, { mode: 'determinate', value: file.percent, style: { width: '50%', height: '8px', borderRadius: '8px' } })
            );
          })
        )
      );
    }
  }]);

  return NotesAndFilesExternalFiles;
}(_react2.default.Component);

NotesAndFilesExternalFiles.propTypes = propTypes;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    downloadFromUrl: function downloadFromUrl() {
      return dispatch(_actions.downloadFromUrl.apply(undefined, arguments));
    },
    addFileToContractInDB: function addFileToContractInDB(contractId, files) {
      return dispatch((0, _contractActivitiesProductsActions.addFileToContractInDB)(contractId, files, 'contract'));
    },
    deleteFileFromContractInDB: function deleteFileFromContractInDB() {
      return dispatch(_contractActivitiesProductsActions.deleteFileFromContractInDB.apply(undefined, arguments));
    },
    modifyFileFromContractInDB: function modifyFileFromContractInDB() {
      return dispatch(_contractActivitiesProductsActions.modifyFileFromContractInDB.apply(undefined, arguments));
    }
  };
};
exports.default = (0, _reactRedux.connect)(function (_ref) {
  var contracting = _ref.contracting;

  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  var rightSideContent = contracting.contractActivitiesProducts.get('rightSideContent').toJS();
  return {
    contractId: leftNav.contractId,
    viewingAs: leftNav.viewingAs,
    partners: leftNav.partners,
    contacts: leftNav.contacts,
    from: leftNav.from,
    to: leftNav.to,
    isLatest: leftNav.isLatest,
    rateConversionStatus: leftNav.rateConversionStatus,
    rateConversionSetting: leftNav.rateConversionSetting,
    files: rightSideContent.files,
    deadlineDate: rightSideContent.deadlineDate,
    buyerInfo: rightSideContent.buyerInfo,
    respondedContractList: leftNav.respondedContractList,
    respondedContracts: leftNav.respondedContracts
  };
}, mapDispatchToProps)(NotesAndFilesExternalFiles);

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileFileDownload = function FileFileDownload(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' })
  );
};
FileFileDownload = (0, _pure2.default)(FileFileDownload);
FileFileDownload.displayName = 'FileFileDownload';
FileFileDownload.muiName = 'SvgIcon';

exports.default = FileFileDownload;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _contractListContainer = __webpack_require__(1999);

var _contractListContainer2 = _interopRequireDefault(_contractListContainer);

var _actions = __webpack_require__(737);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import SimpleContractList from '../../../generic-components/simpleContractList';

var propTypes = {
  contractId: _react.PropTypes.string,
  respondedContractList: _react.PropTypes.array,
  fileContractForRequest: _react.PropTypes.func,
  respondedContracts: _react.PropTypes.array,
  removeContractFromRequest: _react.PropTypes.func,
  hideBtns: _react.PropTypes.bool
};

var RespondedContractList = function (_React$Component) {
  _inherits(RespondedContractList, _React$Component);

  function RespondedContractList(props) {
    _classCallCheck(this, RespondedContractList);

    var _this = _possibleConstructorReturn(this, (RespondedContractList.__proto__ || Object.getPrototypeOf(RespondedContractList)).call(this, props));

    _this.onCheckContract = function (contractId) {
      return function (_, checked) {
        return _this.setState({
          allCheckedIds: checked ? [].concat(_toConsumableArray(_this.state.allCheckedIds), [contractId]) : _this.state.allCheckedIds.filter(function (id) {
            return id !== contractId;
          })
        });
      };
    };

    _this.onCheckAll = function (_, checked) {
      _this.setState({
        allCheckedIds: checked ? _this.props.respondedContracts : []
      });
    };

    _this.fileContractForRequest = function (contractId) {
      return function () {
        _this.setState({
          filingContractId: contractId
        });
        _this.props.fileContractForRequest({
          contractId: contractId,
          requestId: _this.props.contractId
        });
      };
    };

    _this.removeContractFromRequest = function (contractIds) {
      return function () {
        _this.setState({
          removing: contractIds,
          allCheckedIds: []
        });
        _this.props.removeContractFromRequest({
          contractIds: contractIds,
          requestId: _this.props.contractId
        });
      };
    };

    _this.state = {
      removing: [],
      filingContractId: '',
      allCheckedIds: []
    };
    return _this;
  }

  _createClass(RespondedContractList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          respondedContractList = _props.respondedContractList,
          respondedContracts = _props.respondedContracts;

      var hasTCRates = Boolean(respondedContracts && respondedContracts.length);
      var loadedContractFiles = Boolean(respondedContractList && respondedContractList.length);
      if (!hasTCRates) return _react2.default.createElement('div', null);
      return _react2.default.createElement(
        'div',
        { style: { marginBottom: '24px' } },
        hasTCRates && !loadedContractFiles && _react2.default.createElement(
          _materialUi.Paper,
          { style: { padding: '16px' } },
          _react2.default.createElement(
            'h4',
            null,
            'Loading TourConnect format rates...'
          ),
          _react2.default.createElement(_materialUi.LinearProgress, null)
        ),
        loadedContractFiles && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_contractListContainer2.default, {
            inWhere: 'workspace'
          })
        )
      );
    }
  }]);

  return RespondedContractList;
}(_react2.default.Component);

RespondedContractList.propTypes = propTypes;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fileContractForRequest: function fileContractForRequest() {
      return dispatch(_actions.fileContractForRequest.apply(undefined, arguments));
    },
    removeContractFromRequest: function removeContractFromRequest() {
      return dispatch(_actions.removeContractFromRequest.apply(undefined, arguments));
    }
  };
};
exports.default = (0, _reactRedux.connect)(function (_ref) {
  var contracting = _ref.contracting;

  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  return {
    contractId: leftNav.contractId,
    respondedContractList: leftNav.respondedContractList,
    respondedContracts: leftNav.respondedContracts
  };
}, mapDispatchToProps)(RespondedContractList);

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _aphrodite = __webpack_require__(123);

var _aphrodite2 = _interopRequireDefault(_aphrodite);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _listContainer = __webpack_require__(3385);

var _listContainer2 = _interopRequireDefault(_listContainer);

var _leftNav = __webpack_require__(3396);

var _leftNav2 = _interopRequireDefault(_leftNav);

var _topBar = __webpack_require__(3398);

var _topBar2 = _interopRequireDefault(_topBar);

var _send = __webpack_require__(577);

var _send2 = _interopRequireDefault(_send);

var _materialUi = __webpack_require__(3);

var _info = __webpack_require__(1863);

var _info2 = _interopRequireDefault(_info);

var _pagination = __webpack_require__(870);

var _pagination2 = _interopRequireDefault(_pagination);

var _freeContractContractorDialog = __webpack_require__(3405);

var _freeContractContractorDialog2 = _interopRequireDefault(_freeContractContractorDialog);

var _resendOrUpdateDialog = __webpack_require__(1141);

var _resendOrUpdateDialog2 = _interopRequireDefault(_resendOrUpdateDialog);

var _publishDraftDialog = __webpack_require__(1260);

var _publishDraftDialog2 = _interopRequireDefault(_publishDraftDialog);

var _bulkResendDialog = __webpack_require__(3406);

var _bulkResendDialog2 = _interopRequireDefault(_bulkResendDialog);

var _manageFolderDialog = __webpack_require__(3407);

var _manageFolderDialog2 = _interopRequireDefault(_manageFolderDialog);

var _flatDropDownMenu = __webpack_require__(494);

var _flatDropDownMenu2 = _interopRequireDefault(_flatDropDownMenu);

var _reactRouterRedux = __webpack_require__(27);

var _contractListActions = __webpack_require__(563);

var _docCookie = __webpack_require__(142);

var _docCookie2 = _interopRequireDefault(_docCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  params: _react.PropTypes.object,
  getContractList: _react.PropTypes.func,
  getContractFolders: _react.PropTypes.func,
  changeRoute: _react.PropTypes.func,
  location: _react.PropTypes.object,
  list: _react.PropTypes.object,
  searchInput: _react.PropTypes.string,
  updateProps: _react.PropTypes.func,
  showFreeContractDialog: _react.PropTypes.func,
  billingPlan: _react.PropTypes.string,
  resourceType: _react.PropTypes.string,
  freeContractsUsedIds: _react.PropTypes.array,
  unselectAllContracts: _react.PropTypes.func,
  manageFolders: _react.PropTypes.func,
  actionsForContract: _react.PropTypes.object,
  previousSearchParams: _react.PropTypes.object,
  bulkActions: _react.PropTypes.object,
  searchParams: _react.PropTypes.object,
  deleteFolder: _react.PropTypes.func,
  saveNewFolder: _react.PropTypes.func,
  updateFolders: _react.PropTypes.func,
  selectCurrentAll: _react.PropTypes.func,
  isTourReady: _react.PropTypes.bool,
  user: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  isAnAdmin: _react.PropTypes.bool,
  push: _react.PropTypes.func,
  updateSearchParams: _react.PropTypes.func,
  resetSearchParams: _react.PropTypes.func,
  currentYear: _react.PropTypes.object,
  startPolling: _react.PropTypes.bool,
  pathBeforeSearch: _react.PropTypes.string,
  inWhere: _react.PropTypes.string,
  keepOldUI: _react.PropTypes.func
};
// const periodNotEqual = (objA = {}, objB = {}) => objA.startDate !== objB.startDate || objA.endDate !== objB.endDate;

var ContractListContainer = function (_Component) {
  _inherits(ContractListContainer, _Component);

  function ContractListContainer(props) {
    _classCallCheck(this, ContractListContainer);

    var _this2 = _possibleConstructorReturn(this, (ContractListContainer.__proto__ || Object.getPrototypeOf(ContractListContainer)).call(this, props));

    _this2.getQuery = function () {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this2$props = _this2.props,
          list = _this2$props.list,
          searchParams = _this2$props.searchParams,
          currentYear = _this2$props.currentYear;

      return _extends({
        listType: _this2.props.params.type || _this2.props.searchParams.searchCategory || 'recent',
        page: list.page || 1,
        currentYear: currentYear
      }, searchParams, query);
    };

    _this2.populateSearchParamsFromLocationQuery = function () {
      var _this2$props2 = _this2.props,
          location = _this2$props2.location,
          list = _this2$props2.list,
          updateSearchParams = _this2$props2.updateSearchParams,
          params = _this2$props2.params,
          updateProps = _this2$props2.updateProps,
          getContractList = _this2$props2.getContractList;
      var isFolder = location.query.isFolder;

      updateProps({
        isFolder: isFolder === 'true',
        list: _extends({}, list, {
          listType: params.type
        })
      });
      if (params.type === 'search') {
        var searchParamsToBeUpdated = _ramda2.default.mapObjIndexed(function (val, key) {
          if (_ramda2.default.contains('Filter', key) && _ramda2.default.is(String, val)) return [val];
          if (key === 'newActivity' || key === 'isFolder' || key === 'openAdvanceSearch' || key === 'searchingAllYears' || key === 'showRateContainers' || key === 'showArchivedDeleted') {
            return val === 'true';
          }
          if (key === 'sortRule' && val) return parseInt(val, 10);
          if (key === 'ids' && val && _ramda2.default.is(String, val)) {
            return JSON.parse(val);
          }
          return val;
        }, location.query);
        // this will trigger a API call for getting contracts after params are updated
        updateSearchParams(searchParamsToBeUpdated);
      } else {
        getContractList();
      }
    };

    _this2.startPoll = function () {
      // If user is searching, no need to keep fetching data
      _this2.timeout = setTimeout(function () {
        if (_this2.props.list.listType !== 'search') {
          _this2.props.getContractList(true);
        }
      }, 60e3);
    };

    _this2.loadMore = function (page) {
      var updateSearchParams = _this2.props.updateSearchParams;

      updateSearchParams({ page: page });
    };

    _this2.search = function (searchParams) {
      var _this2$props3 = _this2.props,
          updateProps = _this2$props3.updateProps,
          list = _this2$props3.list,
          updateSearchParams = _this2$props3.updateSearchParams;

      _this2.props.push({
        pathname: '/contracting/contract-list/search',
        query: _ramda2.default.call(_ramda2.default.compose(_ramda2.default.pick(_ramda2.default.keys(searchParams)), // remove null KV
        _ramda2.default.omit(['canBulkResend', 'canBulkAccept', 'canBulkReceive', 'currentYear']), _ramda2.default.mapObjIndexed(function (val) {
          if (val) return val;
        })), searchParams)
      });
      updateProps({
        list: _ramda2.default.merge(list, { listType: 'search' }),
        pathBeforeSearch: _this2.props.pathBeforeSearch || _this2.props.list.listType
      });
      updateSearchParams(searchParams);
    };

    _this2.goTo = _ramda2.default.curry(function (activiesOrDetails, collection, contractId) {
      var _this2$props4 = _this2.props,
          resourceType = _this2$props4.resourceType,
          location = _this2$props4.location,
          isAnAdmin = _this2$props4.isAnAdmin;

      if (_this2.props.inWhere !== 'workspace') {
        var pathname = location.pathname,
            query = location.query;

        _docCookie2.default.setItem('pathname', pathname);
        if (_queryString2.default.stringify(query)) _docCookie2.default.setItem('query', _queryString2.default.stringify(query));
      }
      var goToFunc = function goToFunc(id) {
        return _this2.props.push('/contracting/' + collection + '/' + id + '/' + activiesOrDetails);
      };
      if (resourceType === 'Contractor' && !isAnAdmin && activiesOrDetails === 'details') {
        (0, _contractListActions.markAsViewed)(contractId);
      }
      return goToFunc(contractId);
    });

    _this2.goToSupplierWizard = function (id) {
      if (!_this2.props.isAnAdmin) (0, _contractListActions.markAsViewed)(id);
      _this2.props.push('/contracting/supplier-wizard/' + id);
    };

    _this2.createContract = function () {
      window.dataLayer.push({
        event: 'TRACK_EVENT',
        ev: {
          category: 'Contract List Click',
          action: '/partner-management/create-workspace'
        }
      });
      if (_this2.props.resourceType === 'Supplier') {
        window.location = "https://app.tourconnect.com" + '/partner-management/send-assets?go_back_to=' + window.location.href + '&jwt=' + localStorage.getItem('jwt') + '&open_asset_type=rates';
      } else {
        window.location = "https://app.tourconnect.com" + '/partner-management/create-workspace?go_back_to=' + window.location.href + '&jwt=' + localStorage.getItem('jwt') + '&sendRequest=yes';
      }
    };

    _this2.requestRC = function (slug) {
      return function () {
        window.dataLayer.push({
          event: 'TRACK_EVENT',
          ev: {
            category: 'Contract List Click',
            action: '/partner-management/create-rc-container?rateConversionParty=' + slug
          }
        });
        window.location = "https://app.tourconnect.com" + '/partner-management/create-rc-container?rateConversionParty=' + slug + '&go_back_to=' + window.location.href + '&jwt=' + localStorage.getItem('jwt');
      };
    };

    _this2.openHelp = function (url) {
      return function (e) {
        e.stopPropagation();
        window.open(url);
      };
    };

    _this2.state = {
      manageFolderDialogOpen: false,
      leftNavOpen: true
    };
    return _this2;
  }

  _createClass(ContractListContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.title = window.location.pathname.indexOf('contract-list') > 1 ? 'Contract List' : 'Workspace';
      if (this.props.inWhere !== 'workspace') {
        this.populateSearchParamsFromLocationQuery();
      }
      var getContractFolders = this.props.getContractFolders;

      getContractFolders();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this = this;
      var startPolling = _this.props.startPolling;

      if (!_ramda2.default.equals(startPolling, nextProps.startPolling) && this.props.inWhere !== 'workspace') {
        clearTimeout(_this.timeout);
        if (!nextProps.startPolling) _this.startPoll();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      localStorage.setItem('lastContractListHref', window.location.href);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = _aphrodite2.default.StyleSheet.create({
        NavAndList: { display: 'flex', alignItems: 'stretch' },
        list: { width: this.state.leftNavOpen ? '80%' : '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }
      });
      var _props = this.props,
          updateProps = _props.updateProps,
          bulkActions = _props.bulkActions,
          manageFolders = _props.manageFolders,
          actionsForContract = _props.actionsForContract,
          list = _props.list,
          updateSearchParams = _props.updateSearchParams,
          deleteFolder = _props.deleteFolder,
          saveNewFolder = _props.saveNewFolder,
          updateFolders = _props.updateFolders,
          _selectCurrentAll = _props.selectCurrentAll,
          resourceType = _props.resourceType,
          inWhere = _props.inWhere;

      if (inWhere === 'workspace') {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_listContainer2.default, {
            className: 'contractListContainer',
            selectCurrentAll: function selectCurrentAll() {
              return _selectCurrentAll(_this3.getQuery());
            },
            unselectAll: bulkActions.unselectAll,
            showFolder: true,
            updateSearchParams: updateSearchParams,
            actionsForContract: _ramda2.default.merge({
              updateProps: updateProps,
              viewContract: this.goTo('details'),
              viewActivities: this.goTo('activities'),
              viewNotes: this.goTo('notes'),
              goToSupplierWizard: this.goToSupplierWizard
            }, actionsForContract)
          }),
          _react2.default.createElement(_freeContractContractorDialog2.default, null),
          _react2.default.createElement(_resendOrUpdateDialog2.default, null),
          _react2.default.createElement(_publishDraftDialog2.default, null),
          _react2.default.createElement(_bulkResendDialog2.default, null),
          _react2.default.createElement(_manageFolderDialog2.default, {
            createFolderAndAssign: manageFolders,
            updateProps: updateProps
          })
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _materialUi.Paper,
          { style: { marginBottom: '64px' }, zDepth: 1 },
          _react2.default.createElement(
            'div',
            { className: _aphrodite2.default.css(styles.NavAndList) },
            _react2.default.createElement(
              'div',
              {
                style: { display: 'flex', flexDirection: 'column', width: '20%', minWidth: '250px' }
              },
              _react2.default.createElement(
                'div',
                { style: { backgroundColor: 'rgba(0, 0, 0, 0.1)', color: 'white', fontSize: '18px', height: '48px', minHeight: '48px', textAlign: 'center' } },
                resourceType === 'Supplier' ? _react2.default.createElement(_materialUi.RaisedButton, {
                  id: 'appBarContractsButton',
                  primary: true,
                  style: { marginTop: '6px', minWidth: '250px' },
                  onTouchTap: this.createContract,
                  labelStyle: { top: '-1.5px' },
                  label: resourceType === 'Supplier' ? 'Send Contracts' : 'Send Contract Requests',
                  icon: _react2.default.createElement(_send2.default, { style: { position: 'relative', top: '-1.5px' } })
                }) : _react2.default.createElement(
                  _flatDropDownMenu2.default,
                  {
                    button: _react2.default.createElement(_materialUi.RaisedButton, {
                      primary: true,
                      label: 'New Contract',
                      style: { marginTop: '6px', minWidth: '250px' },
                      icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-add' })
                    }),
                    useList: true,
                    menuProps: {
                      style: { width: '320px' }
                    }
                  },
                  _react2.default.createElement(_materialUi.ListItem, {
                    primaryText: 'Send a Supplier Rate Request',
                    onClick: this.createContract,
                    rightIconButton: _react2.default.createElement(
                      _materialUi.IconButton,
                      {
                        onClick: this.openHelp('http://support.tourconnect.com/en/articles/4446790-send-a-supplier-rate-request')
                      },
                      _react2.default.createElement(_info2.default, { color: '#9e9e9e' })
                    )
                  }),
                  _react2.default.createElement(_materialUi.Divider, null),
                  _react2.default.createElement(_materialUi.ListItem, {
                    primaryText: 'Upload/Convert Myself',
                    onClick: this.requestRC('buyer'),
                    rightIconButton: _react2.default.createElement(
                      _materialUi.IconButton,
                      {
                        onClick: this.openHelp('http://support.tourconnect.com/en/articles/4446791-upload-convert-myself')
                      },
                      _react2.default.createElement(_info2.default, { color: '#9e9e9e' })
                    )
                  })
                )
              ),
              _react2.default.createElement(_leftNav2.default, {
                routeName: this.props.params.type || this.props.searchParams.searchCategory || 'recent',
                changeRoute: this.props.changeRoute,
                updateProps: updateProps,
                deleteFolder: deleteFolder,
                saveNewFolder: saveNewFolder,
                updateFolders: updateFolders
              })
            ),
            _react2.default.createElement(
              'div',
              { className: _aphrodite2.default.css(styles.list) },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_topBar2.default, _extends({
                  routeName: this.props.params.type || this.props.searchParams.searchCategory || 'recent',
                  toggleMenu: function toggleMenu() {
                    return _this3.setState({ leftNavOpen: !_this3.state.leftNavOpen });
                  },
                  createContract: this.createContract,
                  updateProps: updateProps
                }, bulkActions, {
                  forFiltersAndSearch: {
                    updateSearchParams: updateSearchParams,
                    updateSearchInput: function updateSearchInput(k, v) {
                      return updateProps(_defineProperty({}, k, v));
                    },
                    search: this.search,
                    changeRoute: this.props.changeRoute
                  }
                })),
                _react2.default.createElement(_listContainer2.default, {
                  className: 'contractListContainer',
                  selectCurrentAll: function selectCurrentAll() {
                    return _selectCurrentAll(_this3.getQuery());
                  },
                  unselectAll: bulkActions.unselectAll,
                  showFolder: true,
                  updateSearchParams: updateSearchParams,
                  actionsForContract: _ramda2.default.merge({
                    updateProps: updateProps,
                    viewContract: this.goTo('details'),
                    viewActivities: this.goTo('activities'),
                    viewNotes: this.goTo('notes'),
                    goToSupplierWizard: this.goToSupplierWizard
                  }, actionsForContract)
                })
              ),
              list.totalPages > 1 ? _react2.default.createElement(_pagination2.default, { style: { backgroundColor: '#fafafa' }, currentPage: list.page, totalPages: list.totalPages, goToPage: this.loadMore, noOfPagesToShow: 7 }) : _react2.default.createElement('span', null)
            )
          )
        ),
        _react2.default.createElement(_freeContractContractorDialog2.default, null),
        _react2.default.createElement(_resendOrUpdateDialog2.default, null),
        _react2.default.createElement(_publishDraftDialog2.default, null),
        _react2.default.createElement(_bulkResendDialog2.default, null),
        _react2.default.createElement(_manageFolderDialog2.default, {
          createFolderAndAssign: manageFolders,
          updateProps: updateProps
        })
      );
    }
  }]);

  return ContractListContainer;
}(_react.Component);

ContractListContainer.propTypes = propTypes;
var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user;
  return {
    currentYear: contracting.currentYear,
    list: contracting.contractList.get('list').toJS(),
    pathBeforeSearch: contracting.contractList.get('pathBeforeSearch'),
    startPolling: contracting.contractList.get('startPolling'),
    searchParams: contracting.contractList.get('searchParams').toJS(),
    previousSearchParams: contracting.contractList.get('previousSearchParams') ? contracting.contractList.get('previousSearchParams').toJS() : {},
    resourceType: user.getIn(['user', 'type']),
    freeContractsUsedIds: user.get('freeContractsUsedIds'),
    billingPlan: user.get('billingPlan'),
    isAnAdmin: user.get('isAnAdmin')
  };
};

var mapDispatchedToActions = function mapDispatchedToActions(dispatch) {
  return {
    getContractList: function getContractList() {
      return dispatch(_contractListActions.getContractList.apply(undefined, arguments));
    },
    getContractFolders: function getContractFolders() {
      return dispatch(_contractListActions.getContractFolders.apply(undefined, arguments));
    },
    changeRoute: function changeRoute() {
      return dispatch(_contractListActions.changeRoute.apply(undefined, arguments));
    },
    updateProps: function updateProps() {
      return dispatch(_contractListActions.updateProps.apply(undefined, arguments));
    },
    updateSearchParams: function updateSearchParams() {
      return dispatch(_contractListActions.updateSearchParams.apply(undefined, arguments));
    },
    resetSearchParams: function resetSearchParams() {
      return dispatch((0, _contractListActions.resetSearchParams)());
    },
    showFreeContractDialog: _ramda2.default.curry(function (activiesOrDetails, contractId) {
      return dispatch((0, _contractListActions.showFreeContractDialogAction)(activiesOrDetails, contractId));
    }),
    deleteFolder: function deleteFolder() {
      return dispatch(_contractListActions.deleteFolder.apply(undefined, arguments));
    },
    saveNewFolder: function saveNewFolder() {
      return dispatch(_contractListActions.saveNewFolder.apply(undefined, arguments));
    },
    updateFolders: function updateFolders() {
      return dispatch(_contractListActions.updateFolders.apply(undefined, arguments));
    },
    selectCurrentAll: function selectCurrentAll() {
      return dispatch(_contractListActions.selectCurrentAll.apply(undefined, arguments));
    },
    bulkActions: {
      unselectAll: function unselectAll() {
        return dispatch((0, _contractListActions.updateProps)({ selectedContracts: [], allContractIds: [] }));
      },
      moveAllToTrash: function moveAllToTrash(contractIds) {
        return dispatch((0, _contractListActions.moveToTrashOrRestore)(true, contractIds));
      },
      restoreAll: function restoreAll(contractIds) {
        return dispatch((0, _contractListActions.moveToTrashOrRestore)(false, contractIds));
      },
      moveAllToArchived: function moveAllToArchived(contractIds) {
        return dispatch((0, _contractListActions.moveToArchiveOrRestore)(true, contractIds));
      },
      restoreAllFromArchived: function restoreAllFromArchived(contractIds) {
        return dispatch((0, _contractListActions.moveToArchiveOrRestore)(false, contractIds));
      },
      stateChange: _ramda2.default.curry(function (contractIds, newStatus) {
        return dispatch((0, _contractListActions.stateChange)(contractIds, newStatus));
      }),
      openBulkResendDialog: function openBulkResendDialog() {
        return dispatch(_contractListActions.openBulkResendDialog.apply(undefined, arguments));
      }
    },
    manageFolders: function manageFolders() {
      return dispatch(_contractListActions.manageFolders.apply(undefined, arguments));
    },
    actionsForContract: {
      moveToTrash: function moveToTrash(contractId) {
        return dispatch((0, _contractListActions.moveToTrashOrRestore)(true, [contractId]));
      },
      restoreContract: function restoreContract(contractId) {
        return dispatch((0, _contractListActions.moveToTrashOrRestore)(false, [contractId]));
      },
      moveToArchived: function moveToArchived(contractId) {
        return dispatch((0, _contractListActions.moveToArchiveOrRestore)(true, [contractId]));
      },
      restoreContractFromArchived: function restoreContractFromArchived(contractId) {
        return dispatch((0, _contractListActions.moveToArchiveOrRestore)(false, [contractId]));
      },
      selectAContract: function selectAContract() {
        return dispatch(_contractListActions.selectAContract.apply(undefined, arguments));
      },
      openResendContractDialog: function openResendContractDialog() {
        return dispatch(_contractListActions.openResendContractDialog.apply(undefined, arguments));
      },
      stateChange: function stateChange(contractId, newStatus) {
        return dispatch((0, _contractListActions.stateChange)([contractId], newStatus));
      },
      downloadContractPdf: function downloadContractPdf() {
        return dispatch(_contractListActions.downloadContractPdf.apply(undefined, arguments));
      }
    },
    push: function push() {
      return dispatch(_reactRouterRedux.push.apply(undefined, arguments));
    }
  };
};
ContractListContainer.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchedToActions)(ContractListContainer);

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderColor = function EditorBorderColor(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z' }),
    _react2.default.createElement('path', { fillOpacity: '.36', d: 'M0 20h24v4H0z' })
  );
};
EditorBorderColor = (0, _pure2.default)(EditorBorderColor);
EditorBorderColor.displayName = 'EditorBorderColor';
EditorBorderColor.muiName = 'SvgIcon';

exports.default = EditorBorderColor;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _flatDropDownMenu = __webpack_require__(494);

var _flatDropDownMenu2 = _interopRequireDefault(_flatDropDownMenu);

var _arrowDropDown = __webpack_require__(559);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _smallButtons = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssigneeFilter = function (_Component) {
  _inherits(AssigneeFilter, _Component);

  function AssigneeFilter() {
    _classCallCheck(this, AssigneeFilter);

    var _this = _possibleConstructorReturn(this, (AssigneeFilter.__proto__ || Object.getPrototypeOf(AssigneeFilter)).call(this));

    _this.onClick = function (userId) {
      return function () {
        var filterByAssignee = _this.props.filterByAssignee;

        filterByAssignee(userId);
      };
    };

    return _this;
  }

  _createClass(AssigneeFilter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          filter = _props.filter,
          button = _props.button,
          usersArray = _props.usersArray,
          isContainer = _props.isContainer;

      var filterLabel = function () {
        if (filter === 'dl@tourconnect.com') return filter;
        if (filter === 'unassigned') return 'Unassigned';
        if (filter) {
          var match = usersArray.find(function (user) {
            return user.userId === filter;
          });
          if (match) return match.name || match.email;
        }
        return 'Assignee';
      }();
      return _react2.default.createElement(
        _flatDropDownMenu2.default,
        {
          button: button || _react2.default.createElement(_smallButtons.JiraFlatButton, {
            labelStyle: { fontSize: '12px', fontWeight: filter ? 'bold' : 'normal', color: filter ? 'black' : 'rgba(0, 0, 0, 0.54)' },
            icon: _react2.default.createElement(_arrowDropDown2.default, { style: { fill: 'rgba(0, 0, 0, 0.54)', margin: 0 } }),
            labelPosition: 'before',
            label: filterLabel
          })
        },
        _react2.default.createElement(_materialUi.MenuItem, {
          primaryText: 'All',
          onClick: this.onClick(null)
        }),
        _react2.default.createElement(_materialUi.MenuItem, {
          primaryText: 'Unassigned',
          onClick: this.onClick('unassigned')
        }),
        _react2.default.createElement(_materialUi.Divider, null),
        usersArray.map(function (user) {
          return _react2.default.createElement(_materialUi.MenuItem, {
            key: user.userId,
            primaryText: user.name || user.email,
            disabled: user.userId === filter,
            onClick: _this2.onClick(user.userId)
          });
        })
      );
    }
  }]);

  return AssigneeFilter;
}(_react.Component);

AssigneeFilter.propTypes = {
  filterByAssignee: _react.PropTypes.func,
  filter: _react.PropTypes.string,
  button: _react.PropTypes.node,
  usersArray: _react.PropTypes.array,
  isContainer: _react.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    usersArray: state.settings.get('allActiveUsers').toJS ? state.settings.get('allActiveUsers').toJS() : state.settings.get('allActiveUsers')
  };
})(AssigneeFilter);

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ondemandVideo = __webpack_require__(3395);

var _ondemandVideo2 = _interopRequireDefault(_ondemandVideo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListZeroState = function ListZeroState(props) {
  var softZero = props.softZero,
      title = props.title,
      buttonTitle = props.buttonTitle,
      buttonList = props.buttonList,
      videoLink = props.videoLink,
      enjoyBenefits = props.enjoyBenefits;

  if (softZero) {
    return _react2.default.createElement(
      'div',
      {
        style: {
          textAlign: 'center',
          margin: '52px auto',
          fontSize: '16px',
          width: '70%'
        }
      },
      'Sorry, we could not find what you are looking for. Please try a different search.'
    );
  }
  var openWhatYouCanDo = function openWhatYouCanDo() {
    window.open(videoLink);
  };
  return _react2.default.createElement(
    'div',
    {
      style: {
        textAlign: 'center',
        margin: '52px auto',
        width: '70%'
      }
    },
    _react2.default.createElement(
      'div',
      {
        style: { fontSize: '16px' }
      },
      title
    ),
    _react2.default.createElement(
      'div',
      {
        style: { marginTop: '16px' }
      },
      _react2.default.createElement(_materialUi.FlatButton, {
        secondary: true,
        icon: _react2.default.createElement(_ondemandVideo2.default, null),
        onClick: openWhatYouCanDo,
        label: 'See What You Can Do'
      })
    ),
    _react2.default.createElement(
      'div',
      {
        style: { marginTop: '16px', fontSize: '16px' }
      },
      buttonTitle
    ),
    _react2.default.createElement(
      'div',
      {
        style: {
          alignItems: 'center',
          display: 'flex',
          marginTop: '8px',
          flexDirection: 'column'
        }
      },
      buttonList.map(function (_ref, i) {
        var label = _ref.label,
            func = _ref.func;
        return _react2.default.createElement(_materialUi.RaisedButton, {
          key: i,
          style: { marginTop: '12px', width: '290px' },
          secondary: true,
          label: label,
          onClick: func
        });
      })
    ),
    Boolean(enjoyBenefits && enjoyBenefits.length) && _react2.default.createElement(
      'div',
      { style: { width: '300px', textAlign: 'center', margin: '24px auto', paddingLeft: '25px', fontSize: '12px' } },
      _react2.default.createElement(
        'div',
        { style: { fontWeight: 'bold' } },
        'Enjoy the Benefits:'
      ),
      enjoyBenefits.map(function (str, i) {
        return _react2.default.createElement(
          'div',
          { key: i },
          '\u2022 ',
          str
        );
      })
    )
  );
};

exports.default = ListZeroState;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentUnarchive = function ContentUnarchive(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z' })
  );
};
ContentUnarchive = (0, _pure2.default)(ContentUnarchive);
ContentUnarchive.displayName = 'ContentUnarchive';
ContentUnarchive.muiName = 'SvgIcon';

exports.default = ContentUnarchive;

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentSelectAll = function ContentSelectAll(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z' })
  );
};
ContentSelectAll = (0, _pure2.default)(ContentSelectAll);
ContentSelectAll.displayName = 'ContentSelectAll';
ContentSelectAll.muiName = 'SvgIcon';

exports.default = ContentSelectAll;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statuses = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _flatDropDownMenu = __webpack_require__(494);

var _flatDropDownMenu2 = _interopRequireDefault(_flatDropDownMenu);

var _arrowDropDown = __webpack_require__(559);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _smallButtons = __webpack_require__(94);

var _contractingUtils = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var statuses = exports.statuses = ['in progress', 'pending', 'in review', 'complete', 'accepted', 'loaded', 'loading', 'rejected'];

var UpdateRateConversionStatus = function (_Component) {
  _inherits(UpdateRateConversionStatus, _Component);

  function UpdateRateConversionStatus() {
    _classCallCheck(this, UpdateRateConversionStatus);

    var _this = _possibleConstructorReturn(this, (UpdateRateConversionStatus.__proto__ || Object.getPrototypeOf(UpdateRateConversionStatus)).call(this));

    _this.updateRCStatus = function (newStatus) {
      return function () {
        var _this$props = _this.props,
            contractId = _this$props.contractId,
            updateRCStatus = _this$props.updateRCStatus;

        updateRCStatus({ contractId: contractId, updater: { rateConversionStatus: newStatus } });
      };
    };

    return _this;
  }

  _createClass(UpdateRateConversionStatus, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$rateConversion = this.props.rateConversionStatus,
          rateConversionStatus = _props$rateConversion === undefined ? '' : _props$rateConversion;

      return _react2.default.createElement(
        _flatDropDownMenu2.default,
        {
          button: _react2.default.createElement(_smallButtons.JiraFlatButton, {
            labelStyle: { fontSize: '10px', color: (0, _contractingUtils.getStatusColor)(rateConversionStatus) },
            icon: _react2.default.createElement(_arrowDropDown2.default, { style: { fill: 'rgba(0, 0, 0, 0.54)', margin: 0 } }),
            labelPosition: 'before',
            label: rateConversionStatus
          })
        },
        statuses.map(function (str) {
          return _react2.default.createElement(_materialUi.MenuItem, {
            key: str,
            primaryText: str,
            disabled: str === rateConversionStatus,
            onClick: _this2.updateRCStatus(str)
          });
        })
      );
    }
  }]);

  return UpdateRateConversionStatus;
}(_react.Component);

UpdateRateConversionStatus.propTypes = {
  updateRCStatus: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  rateConversionStatus: _react.PropTypes.string
};

exports.default = (0, _reactRedux.connect)(null, {
  updateRCStatus: function updateRCStatus(payload) {
    return { type: '[contract-request] UPDATE_RATE_LOADING_STATUS', payload: payload };
  }
})(UpdateRateConversionStatus);

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _templateDraftForm = __webpack_require__(3408);

var _templateDraftForm2 = _interopRequireDefault(_templateDraftForm);

var _updateRateConversionSettings = __webpack_require__(3410);

var _updateRateConversionSettings2 = _interopRequireDefault(_updateRateConversionSettings);

var _sendMessage = __webpack_require__(2007);

var _sendMessage2 = _interopRequireDefault(_sendMessage);

var _templateListForRC = __webpack_require__(1269);

var _templateListForRC2 = _interopRequireDefault(_templateListForRC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  realActorEmail: _react.PropTypes.string,
  crId: _react.PropTypes.string,
  rateConversionSetting: _react.PropTypes.string,
  rateConversionStatus: _react.PropTypes.string,
  priority: _react.PropTypes.string,
  assignee: _react.PropTypes.object,
  dummySupplierForCR: _react.PropTypes.object,
  startDate: _react.PropTypes.string,
  endDate: _react.PropTypes.string,
  createTemplatesInDummyAcct: _react.PropTypes.func,
  buyerCompanyName: _react.PropTypes.string,
  creatingTemplates: _react.PropTypes.bool,
  updateRCStatus: _react.PropTypes.func,
  supplierCompanyName: _react.PropTypes.string,
  rateLoadingWizard: _react.PropTypes.object,
  updateWizardData: _react.PropTypes.func,
  openSendMsg: _react.PropTypes.func,
  sendMsgOpen: _react.PropTypes.bool,
  openSubmitRatesAsDL: _react.PropTypes.func,
  buyerEmail: _react.PropTypes.string,
  deleteRateSheet: _react.PropTypes.func
};

var RateConversion = function (_Component) {
  _inherits(RateConversion, _Component);

  function RateConversion(props) {
    _classCallCheck(this, RateConversion);

    var _this = _possibleConstructorReturn(this, (RateConversion.__proto__ || Object.getPrototypeOf(RateConversion)).call(this, props));

    _this.openWizard = function () {
      return _this.setState({ wizardOpen: true });
    };

    _this.closeWizard = function () {
      return _this.setState({ wizardOpen: false });
    };

    _this.createTemplatesInDummyAcct = function () {
      var _this$props = _this.props,
          crId = _this$props.crId,
          dummySupplierForCR = _this$props.dummySupplierForCR,
          supplierCompanyName = _this$props.supplierCompanyName,
          rateLoadingWizard = _this$props.rateLoadingWizard;

      _this.props.createTemplatesInDummyAcct(_extends({
        crId: crId,
        dummyCompanyId: dummySupplierForCR.accountId,
        supplierCompanyName: supplierCompanyName
      }, rateLoadingWizard));
    };

    _this.selectTemplate = function (draftId) {
      return function () {
        return _this.setState({ draftIds: [].concat(_toConsumableArray(_this.state.draftIds), [draftId]) });
      };
    };

    _this.openSubmitRatesAsDL = function () {
      return _this.props.openSubmitRatesAsDL({ emails: [_this.props.buyerEmail] });
    };

    _this.state = {
      wizardOpen: false,
      draftIds: []
    };
    return _this;
  }

  _createClass(RateConversion, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.creatingTemplates && !nextProps.creatingTemplates) {
        this.setState({ wizardOpen: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          rateConversionSetting = _props.rateConversionSetting,
          _props$dummySupplierF = _props.dummySupplierForCR.templates,
          templateList = _props$dummySupplierF === undefined ? [] : _props$dummySupplierF,
          creatingTemplates = _props.creatingTemplates,
          crId = _props.crId,
          _props$rateLoadingWiz = _props.rateLoadingWizard,
          oneOrMulti = _props$rateLoadingWiz.oneOrMulti,
          newDraftStartDate = _props$rateLoadingWiz.newDraftStartDate,
          newDraftEndDate = _props$rateLoadingWiz.newDraftEndDate,
          templateName = _props$rateLoadingWiz.templateName,
          locations = _props$rateLoadingWiz.locations,
          updateWizardData = _props.updateWizardData,
          openSendMsg = _props.openSendMsg,
          sendMsgOpen = _props.sendMsgOpen,
          realActorEmail = _props.realActorEmail,
          deleteRateSheet = _props.deleteRateSheet;

      var isDL = realActorEmail === 'admin@tourconnect.com' || realActorEmail === 'dl@tourconnect.com';
      var wizardOpen = this.state.wizardOpen;

      var disableBtn = !(oneOrMulti && newDraftStartDate && newDraftEndDate && templateName && locations.some(function (obj) {
        return obj.checked;
      }));
      return _react2.default.createElement(
        'div',
        { style: { marginBottom: '24px' } },
        _react2.default.createElement(
          'div',
          { className: 'flex-center', style: { marginBottom: '1em' } },
          _react2.default.createElement(
            'b',
            null,
            'Require Supplier Signature:\xA0'
          ),
          rateConversionSetting === 'opt-in' ? 'Yes' : 'No',
          ' \xA0\xA0',
          _react2.default.createElement(_updateRateConversionSettings2.default, {
            contractId: crId,
            setting: rateConversionSetting
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'flex-tc-sb', style: { marginTop: '2em' } },
          _react2.default.createElement(_materialUi.RaisedButton, {
            label: 'Create Rate Sheet',
            secondary: true,
            onClick: this.openWizard
          }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_materialUi.FlatButton, {
              style: { marginLeft: '1em', border: '1px solid #00bcd4' },
              label: 'Send Message',
              secondary: true,
              onClick: openSendMsg
            }),
            Boolean(isDL && templateList.filter(function (o) {
              return (0, _templateListForRC.getStatus)(o) === '100% completed';
            }).length) && _react2.default.createElement(_materialUi.RaisedButton, {
              style: { marginLeft: '1em' },
              label: 'Submit Rates',
              secondary: true,
              onClick: this.openSubmitRatesAsDL
            })
          )
        ),
        Boolean(templateList.length) && _react2.default.createElement(_templateListForRC2.default, {
          templates: templateList,
          deleteRateSheet: deleteRateSheet
        }),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            open: wizardOpen,
            onRequestClose: this.closeWizard,
            title: _react2.default.createElement(
              'div',
              { style: { backgroundColor: '#00bcd4', color: '#fff' } },
              templateList.length ? 'Add A Rate Sheet' : 'Create A Rate Sheet'
            ),
            actions: [_react2.default.createElement(_materialUi.FlatButton, {
              key: 'cancel',
              label: 'cancel',
              primary: true,
              onClick: this.closeWizard
            }), _react2.default.createElement(_materialUi.FlatButton, {
              key: 'start',
              label: templateList.length ? 'Create' : 'Start',
              secondary: true,
              onClick: this.createTemplatesInDummyAcct,
              disabled: disableBtn || creatingTemplates
            })],
            autoScrollBodyContent: true
          },
          _react2.default.createElement(_templateDraftForm2.default, _extends({}, this.props.rateLoadingWizard, {
            updateProps: updateWizardData
          }))
        ),
        _react2.default.createElement(_sendMessage2.default, null)
      );
    }
  }]);

  return RateConversion;
}(_react.Component);

RateConversion.propTypes = propTypes;

exports.default = (0, _reactRedux.connect)(function (_ref) {
  var user = _ref.user,
      dummyAcct = _ref.dummyAcct;
  return _extends({}, dummyAcct.inCR, {
    realActorEmail: user.get('realActorEmail'),
    sendMsgOpen: dummyAcct.sendMsg.open
  });
}, {
  openSendMsg: function openSendMsg() {
    return { type: '{rl-send-message}OPEN_SEND_MESSAGE' };
  },
  openSubmitRatesAsDL: function openSubmitRatesAsDL(payload) {
    return { type: '{rl-send-message} OPEN_SEND_MESSAGE_AS_SUBMIT_RATES_AS_DL', payload: payload };
  },
  createTemplatesInDummyAcct: function createTemplatesInDummyAcct(payload) {
    return { type: '[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR', payload: payload };
  },
  updateWizardData: function updateWizardData(payload) {
    return { type: '[contract-request] UPDATE_RL_WIZARD_DATA', payload: payload };
  },
  deleteRateSheet: function deleteRateSheet(payload) {
    return { type: '[contract-request] DELETE_RATE_SHEET', payload: payload };
  }
})(RateConversion);

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _textarea = __webpack_require__(1050);

var _textarea2 = _interopRequireDefault(_textarea);

var _helperFunctions = __webpack_require__(1116);

var _templateListForRC = __webpack_require__(1269);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _dropzone = __webpack_require__(869);

var _dropzone2 = _interopRequireDefault(_dropzone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SendMessageRL = function (_Component) {
  _inherits(SendMessageRL, _Component);

  function SendMessageRL(props) {
    _classCallCheck(this, SendMessageRL);

    var _this = _possibleConstructorReturn(this, (SendMessageRL.__proto__ || Object.getPrototypeOf(SendMessageRL)).call(this, props));

    _this.sendMessage = function () {
      var _this$props = _this.props,
          sendMessage = _this$props.sendMessage,
          rateDocIds = _this$props.rateDocIds,
          requestSigsChecked = _this$props.requestSigsChecked,
          subject = _this$props.subject,
          message = _this$props.message,
          sentByEmail = _this$props.sentByEmail,
          emails = _this$props.emails,
          crId = _this$props.crId,
          contractId = _this$props.contractId,
          historyFeedId = _this$props.historyFeedId,
          who = _this$props.who,
          inActivityFeed = _this$props.inActivityFeed,
          isRateContract = _this$props.isRateContract,
          leanFiles = _this$props.leanFiles;

      sendMessage({
        emails: emails,
        rateDocIds: rateDocIds,
        requestSigsChecked: requestSigsChecked,
        subject: subject,
        message: message,
        sentBy: sentByEmail,
        crId: crId,
        who: who,
        contractId: contractId,
        historyFeedId: historyFeedId,
        inActivityFeed: inActivityFeed,
        isRateContract: isRateContract,
        leanFiles: leanFiles
      });
    };

    _this.submitRates = function () {
      var _this$props2 = _this.props,
          submitRates = _this$props2.submitRates,
          rateDocIds = _this$props2.rateDocIds,
          subject = _this$props2.subject,
          message = _this$props2.message,
          crId = _this$props2.crId,
          who = _this$props2.who;

      submitRates({
        rateDocIds: rateDocIds,
        subject: subject,
        message: message,
        crId: crId,
        who: who
      });
    };

    _this.state = {};
    return _this;
  }

  _createClass(SendMessageRL, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          sentByEmail = _props.sentByEmail,
          emailAlias = _props.emailAlias,
          sending = _props.sending,
          sent = _props.sent,
          cancel = _props.cancel,
          who = _props.who,
          emails = _props.emails,
          subject = _props.subject,
          message = _props.message,
          updateProps = _props.updateProps,
          requestSigsChecked = _props.requestSigsChecked,
          submitRatesChecked = _props.submitRatesChecked,
          templates = _props.templates,
          rateDocIds = _props.rateDocIds,
          open = _props.open,
          leanFiles = _props.leanFiles,
          isRateContract = _props.isRateContract,
          locationName = _props.locationName;

      var templatesToShow = templates.filter(function (t) {
        return submitRatesChecked ? (0, _templateListForRC.getStatus)(t) === '100% completed' : t.originalContractId;
      });
      var isDL = sentByEmail === 'admin@tourconnect.com' || sentByEmail === 'dl@tourconnect.com';
      var attachFile = function attachFile(files) {
        updateProps({
          leanFiles: [].concat(_toConsumableArray(leanFiles), _toConsumableArray(files))
        });
      };
      var deleteFile = function deleteFile(i) {
        return function () {
          return updateProps({
            leanFiles: _ramda2.default.remove(i, 1, leanFiles)
          });
        };
      };
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          open: open,
          title: who === 'DL' ? 'Send Message to TourConnect Data Team' : 'Send Message to Partner',
          onRequestClose: cancel,
          autoScrollBodyContent: true,
          actions: sent ? [_react2.default.createElement(_materialUi.FlatButton, {
            key: 'dismiss',
            label: 'Dismiss',
            secondary: true,
            onClick: cancel
          })] : [isRateContract ? _react2.default.createElement(
            'div',
            { style: { float: 'left', marginTop: '8px' }, key: 'locName' },
            'Regarding Contract: ',
            locationName
          ) : null, _react2.default.createElement(_materialUi.FlatButton, {
            key: 'cancel',
            label: 'cancel',
            primary: true,
            onClick: cancel
          }), _react2.default.createElement(_materialUi.FlatButton, {
            key: 'send',
            label: submitRatesChecked ? 'Submit' : 'Send',
            secondary: true,
            disabled: sending || !emails.filter(function (str) {
              return (0, _helperFunctions.validEmail)(str);
            }).length || !subject || !message || (requestSigsChecked || submitRatesChecked) && !rateDocIds.length,
            onClick: submitRatesChecked ? this.submitRates : this.sendMessage
          })].filter(Boolean)
        },
        function () {
          if (sent) {
            return _react2.default.createElement(
              'div',
              { style: { margin: '1em auto' } },
              submitRatesChecked ? 'Rate Submitted' : 'Message Sent!'
            );
          }
          return _react2.default.createElement(
            'div',
            null,
            Boolean(who) && _react2.default.createElement(
              'div',
              { style: { marginTop: '1em' } },
              who === 'DL' ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'label',
                  null,
                  'To: dl@tourconnect.com'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null)
              ) : _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'label',
                  null,
                  'Please separate recipients with a semicolon:'
                ),
                '\xA0\xA0',
                _react2.default.createElement(
                  'small',
                  { style: { color: '#ff4081' } },
                  'Required'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(_textarea2.default, {
                  value: emails.join(';'),
                  onChange: function onChange(e) {
                    return updateProps({ emails: e.target.value.split(';') });
                  },
                  rows: 2,
                  error: emails.some(function (str) {
                    return str && !(0, _helperFunctions.validEmail)(str);
                  }) ? 'Please enter valid email addresses' : ''
                })
              ),
              _react2.default.createElement(
                'label',
                null,
                'Please enter a subject here:'
              ),
              '\xA0\xA0',
              _react2.default.createElement(
                'small',
                { style: { color: '#ff4081' } },
                'Required'
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(_textarea2.default, {
                value: subject || '',
                onChange: function onChange(e) {
                  return updateProps({ subject: e.target.value });
                },
                rows: 1
              }),
              _react2.default.createElement(
                'label',
                null,
                'Message:'
              ),
              '\xA0\xA0',
              _react2.default.createElement(
                'small',
                { style: { color: '#ff4081' } },
                'Required'
              ),
              _react2.default.createElement(_textarea2.default, {
                value: message || '',
                onChange: function onChange(e) {
                  return updateProps({ message: e.target.value });
                },
                rows: 4
              }),
              _react2.default.createElement(
                'div',
                { style: { margin: '2em 0' } },
                _react2.default.createElement(
                  'label',
                  null,
                  'File Attachments: '
                ),
                leanFiles.map(function (file, i) {
                  return _react2.default.createElement(
                    _materialUi.Chip,
                    {
                      key: i,
                      labelStyle: { lineHeight: '24px', whiteSpace: 'pre-wrap' },
                      style: { marginBottom: '8px' },
                      onRequestDelete: deleteFile(i)
                    },
                    file.name
                  );
                }),
                _react2.default.createElement(
                  _dropzone2.default,
                  {
                    style: { border: '1px dotted #bfbfbf', padding: '12px 8px', color: '#bfbfbf', fontSize: '12px', minHeight: '50px', width: '95%' },
                    onDrop: attachFile
                  },
                  _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-attach_file', color: '#bfbfbf', style: { fontSize: '14px', top: '2px', marginRight: '5px' } }),
                  'Attach files by dragging & dropping or ',
                  _react2.default.createElement(
                    'span',
                    { style: { color: '#00b3cf', cursor: 'pointer' } },
                    'selecting them.'
                  )
                )
              ),
              _react2.default.createElement(
                'label',
                null,
                'Sent By: ',
                sentByEmail
              ),
              Boolean(emailAlias && !isDL) && _react2.default.createElement(
                'label',
                { style: { display: 'block' } },
                'Email Display Name: ',
                emailAlias
              )
            ),
            who === 'Supplier' && Boolean(templatesToShow.length) && _react2.default.createElement(_materialUi.Checkbox, {
              style: { marginTop: '2em' },
              label: 'Request Signature',
              checked: Boolean(requestSigsChecked),
              onCheck: function onCheck(_, checked) {
                return updateProps({ requestSigsChecked: checked });
              }
            }),
            Boolean(who === 'Supplier' || submitRatesChecked) && Boolean(templatesToShow.length) && _react2.default.createElement(
              'div',
              { style: { margin: '1em 0 2em 0' } },
              _react2.default.createElement(
                'label',
                { style: { color: 'rgba(0, 0, 0, 0.77)' } },
                'Please Select Rate Sheets',
                requestSigsChecked || submitRatesChecked ? _react2.default.createElement(
                  'small',
                  { style: { color: '#ff4081' } },
                  '\xA0\xA0Required'
                ) : _react2.default.createElement('span', null)
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement('br', null),
              Boolean(templatesToShow.length) && _react2.default.createElement(_materialUi.Checkbox, {
                checked: rateDocIds.length === templatesToShow.length,
                onCheck: function onCheck(_, checked) {
                  return updateProps({
                    rateDocIds: checked ? templatesToShow.map(function (o) {
                      return o.originalContractId;
                    }) : []
                  });
                },
                label: 'SELECT ALL'
              }),
              templatesToShow.sort(function (a, b) {
                return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
              }).map(function (t) {
                return _react2.default.createElement(
                  'div',
                  {
                    key: t._id,
                    className: 'flex-center',
                    style: { width: '100%', borderBottom: '1px solid #e0e0e0' }
                  },
                  _react2.default.createElement(_materialUi.Checkbox, {
                    checked: rateDocIds.indexOf(t.originalContractId) > -1,
                    onCheck: function onCheck(_, checked) {
                      return updateProps({
                        rateDocIds: _ramda2.default.uniq(checked ? [].concat(_toConsumableArray(rateDocIds), [t.originalContractId]) : rateDocIds.filter(function (id) {
                          return id !== t.originalContractId;
                        }))
                      });
                    },
                    style: { width: '40px' }
                  }),
                  _react2.default.createElement(
                    'div',
                    { style: { width: '50%' } },
                    'Rate Sheet for ',
                    t.locationName
                  ),
                  _react2.default.createElement(
                    'small',
                    { style: { marginLeft: '16px' } },
                    _moment2.default.utc(t.startDate).format('DD MMM YYYY'),
                    ' - ',
                    _moment2.default.utc(t.endDate).format('DD MMM YYYY')
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      style: { marginLeft: '16px', minWidth: '120px', textAlign: 'right' }
                    },
                    (0, _templateListForRC.getStatus)(t)
                  )
                );
              })
            )
          );
        }()
      );
    }
  }]);

  return SendMessageRL;
}(_react.Component);

SendMessageRL.propTypes = {
  inActivityFeed: _react.PropTypes.bool,
  historyFeedId: _react.PropTypes.string,
  open: _react.PropTypes.bool,
  crId: _react.PropTypes.string,
  contractId: _react.PropTypes.string,
  sentByEmail: _react.PropTypes.string,
  emailAlias: _react.PropTypes.string,
  supplierEmails: _react.PropTypes.array,
  buyerEmail: _react.PropTypes.string,
  updateProps: _react.PropTypes.func,
  sending: _react.PropTypes.bool,
  sent: _react.PropTypes.bool,
  cancel: _react.PropTypes.func,
  who: _react.PropTypes.string,
  emails: _react.PropTypes.array,
  subject: _react.PropTypes.string,
  message: _react.PropTypes.string,
  requestSigsChecked: _react.PropTypes.bool,
  submitRatesChecked: _react.PropTypes.bool,
  templates: _react.PropTypes.array,
  rateDocIds: _react.PropTypes.array,
  sendMessage: _react.PropTypes.func,
  submitRates: _react.PropTypes.func,
  defaultSubject: _react.PropTypes.string,
  defaultMessage: _react.PropTypes.string,
  isRateContract: _react.PropTypes.bool,
  locationName: _react.PropTypes.string,
  leanFiles: _react.PropTypes.array
};

exports.default = (0, _reactRedux.connect)(function (_ref, _ref2) {
  var user = _ref.user,
      dummyAcct = _ref.dummyAcct,
      contracting = _ref.contracting;
  var inActivityFeed = _ref2.inActivityFeed;

  var contactsOfThePartner = contracting.contractActivitiesProducts.getIn(['leftNav', 'partners', 0, 'contacts']);
  var isRateContract = Boolean(contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId']));
  return _extends({
    sentByEmail: inActivityFeed ? user.getIn(['user', 'email']) : user.get('realActorEmail') || user.getIn(['user', 'email']),
    emailAlias: user.get('emailAlias'),
    buyerEmail: inActivityFeed ? '' : dummyAcct.inCR.buyerEmail,
    supplierEmails: contactsOfThePartner ? contactsOfThePartner.toJS().map(function (o) {
      return o.email;
    }) : dummyAcct.inCR.supplierEmails,
    templates: isRateContract ? [] : dummyAcct.inCR.dummySupplierForCR.templates,
    crId: isRateContract ? contracting.contractActivitiesProducts.getIn(['leftNav', 'versions', 0]) : dummyAcct.inCR.crId,
    contractId: contracting.contractActivitiesProducts.getIn(['leftNav', 'contractId']),
    historyFeedId: contracting.contractActivitiesProducts.getIn(['leftNav', 'historyFeedId']),
    isRateContract: isRateContract,
    locationName: contracting.contractActivitiesProducts.getIn(['leftNav', 'locationName'])
  }, dummyAcct.sendMsg);
}, {
  cancel: function cancel() {
    return { type: '{rl-send-message} CANCEL_SEND_MESSAGE' };
  },
  updateProps: function updateProps(payload) {
    return { type: '{rl-send-message} UPDATE_PROPS', payload: payload };
  },
  sendMessage: function sendMessage(payload) {
    return { type: '{rl-send-message} SEND_MESSAGE', payload: payload };
  },
  submitRates: function submitRates(payload) {
    return { type: '{rl-send-message} SUBMIT_RATES_AS_DL', payload: payload };
  }
})(SendMessageRL);

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewDay = function ActionViewDay(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z' })
  );
};
ActionViewDay = (0, _pure2.default)(ActionViewDay);
ActionViewDay.displayName = 'ActionViewDay';
ActionViewDay.muiName = 'SvgIcon';

exports.default = ActionViewDay;

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _smallButtons = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailTracking = function EmailTracking(_ref) {
  var recipients = _ref.recipients,
      rawEvents = _ref.rawEvents,
      sentDate = _ref.sentDate,
      showRecipients = _ref.showRecipients,
      clickShowRecipients = _ref.clickShowRecipients,
      isSender = _ref.isSender,
      format = _ref.format,
      inLeftNav = _ref.inLeftNav;

  var events = _ramda2.default.omit([_ramda2.default.keys(rawEvents).find(function (str) {
    return str.indexOf('open') > -1;
  })], rawEvents);
  var blockedType = {
    dropped: true,
    deferred: true,
    bounce: true,
    blocked: true
  };
  var eventTags = {
    click: 'clicked',
    open: 'opened',
    delivered: 'delivered',
    unsubscribe: 'unsubscribed',
    'spam report': 'spam report',
    bounce: 'bounced',
    deferred: 'deferred',
    dropped: 'dropped',
    processed: 'processed',
    redirected: 'redirected'
  };
  var eventSort = _ramda2.default.reverse(Object.keys(eventTags));
  var emails = recipients.map(function (_ref2) {
    var email = _ref2.email;
    return email;
  });
  var emailsInEventNotInOriginal = _ramda2.default.values(events).map(function (e) {
    return e.email;
  }).filter(function (str) {
    return emails.indexOf(str) === -1;
  });
  var eventToDate = function eventToDate(timestamp) {
    if (isNaN(timestamp)) {
      return (0, _moment2.default)(timestamp).format('D MMM YYYY, H:mm');
    }
    return _moment2.default.unix(timestamp).format('D MMM YYYY, H:mm');
  };
  var lastEvents = _ramda2.default.map(function (arrays) {
    return _ramda2.default.sortBy(function (_ref3) {
      var event = _ref3.event,
          timestamp = _ref3.timestamp;

      return -1 * ((eventSort.indexOf(event) || 0) + 1) * timestamp;
    }, arrays)[0];
  }, _ramda2.default.groupBy(function (_ref4) {
    var email = _ref4.email;
    return email;
  }, Object.values(events)
  // .filter(({ email }) => emails.indexOf(email) > -1) // we could have events related to other email addresses
  .map(function (_ref5) {
    var email = _ref5.email,
        event = _ref5.event,
        timestamp = _ref5.timestamp;
    return {
      email: email,
      event: event,
      dateTime: eventToDate(timestamp),
      timestamp: timestamp
    };
  })));
  var eventGroup = _ramda2.default.groupBy(function (_ref6) {
    var event = _ref6.event;
    return event;
  }, Object.values(lastEvents));
  var eventSummary = Object.keys(eventGroup).map(function (event) {
    return eventGroup[event].length + ' ' + eventTags[event];
  });
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      {
        style: inLeftNav ? { display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' } : { display: 'flex', alignItems: 'center' }
      },
      _react2.default.createElement(
        'div',
        { className: inLeftNav ? '' : 'flex-center' },
        _react2.default.createElement(
          'div',
          null,
          sentDate ? (0, _moment2.default)(new Date(sentDate)).format(format || 'MMMM DD, YYYY') : 'NA'
        ),
        eventSummary.length > 0 && _react2.default.createElement(
          'small',
          null,
          '\xA0\xA0(',
          eventSummary.map(function (str, i) {
            return _react2.default.createElement(
              'span',
              {
                key: str,
                style: {
                  color: _ramda2.default.keys(blockedType).some(function (type) {
                    return str.indexOf(type) > -1;
                  }) ? 'red' : 'inherit'
                }
              },
              i ? ', ' : '',
              str
            );
          }),
          ')'
        )
      ),
      ' \xA0\xA0',
      isSender && _react2.default.createElement(_smallButtons.JiraFlatButton, {
        onClick: clickShowRecipients,
        labelStyle: { fontSize: '10px' },
        label: (showRecipients ? 'Hide' : 'Show') + ' Details'
      })
    ),
    _react2.default.createElement(
      'div',
      {
        style: {
          display: showRecipients ? 'block' : 'none',
          backgroundColor: '#fafafa',
          borderRadius: '5px',
          padding: '8px 16px',
          border: '1px solid #e0e0e0',
          marginTop: '4px'
        }
      },
      recipients.map(function (_ref7) {
        var email = _ref7.email;
        return _react2.default.createElement(
          'div',
          { key: email },
          _react2.default.createElement(
            'small',
            null,
            _react2.default.createElement(
              'strong',
              null,
              email
            ),
            lastEvents[email] ? _react2.default.createElement(
              'span',
              { style: inLeftNav ? { display: 'block' } : {} },
              ' ',
              '(email ',
              eventTags[lastEvents[email].event],
              '\xA0on\xA0',
              lastEvents[email].dateTime,
              ')'
            ) : _react2.default.createElement(
              'span',
              { style: inLeftNav ? { display: 'block' } : {} },
              ' (email processing)'
            )
          )
        );
      }),
      emailsInEventNotInOriginal.map(function (email) {
        return _react2.default.createElement(
          'div',
          {
            key: email
          },
          _react2.default.createElement(
            'small',
            null,
            _react2.default.createElement(
              'i',
              null,
              'forwarded address'
            ),
            lastEvents[email] ? _react2.default.createElement(
              'span',
              null,
              ' ',
              '(email ',
              eventTags[lastEvents[email].event],
              '\xA0on\xA0',
              lastEvents[email].dateTime,
              ')'
            ) : _react2.default.createElement(
              'span',
              { style: inLeftNav ? { display: 'block' } : {} },
              ' (notified in system)'
            )
          )
        );
      })
    )
  );
};

exports.default = EmailTracking;

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _planer = __webpack_require__(2011);

var _planer2 = _interopRequireDefault(_planer);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _reactRouterRedux = __webpack_require__(27);

var _materialUi = __webpack_require__(3);

var _flag = __webpack_require__(1059);

var _flag2 = _interopRequireDefault(_flag);

var _modeEdit = __webpack_require__(1268);

var _modeEdit2 = _interopRequireDefault(_modeEdit);

var _insertComment = __webpack_require__(3419);

var _insertComment2 = _interopRequireDefault(_insertComment);

var _chatBubble = __webpack_require__(3420);

var _chatBubble2 = _interopRequireDefault(_chatBubble);

var _regularAttachments = __webpack_require__(2012);

var _regularAttachments2 = _interopRequireDefault(_regularAttachments);

var _commentContract = __webpack_require__(3423);

var _commentContract2 = _interopRequireDefault(_commentContract);

var _messagingAvatar = __webpack_require__(1271);

var _messagingAvatar2 = _interopRequireDefault(_messagingAvatar);

var _emailTracking = __webpack_require__(2009);

var _emailTracking2 = _interopRequireDefault(_emailTracking);

var _contractActivitiesProductsActions = __webpack_require__(493);

var _actions = __webpack_require__(737);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  addFileToContractFromMessageAction: _react.PropTypes.func,
  amendedFrom: _react.PropTypes.string,
  amendmentCreated: _react.PropTypes.string,
  classes: _react.PropTypes.object,
  companyType: _react.PropTypes.string,
  contractIdOfThread: _react.PropTypes.string,
  downloadFromUrl: _react.PropTypes.func,
  filesInContract: _react.PropTypes.array,
  isInMessaging: _react.PropTypes.bool,
  msgObject: _react.PropTypes.object,
  routerPush: _react.PropTypes.func,
  showContactLink: _react.PropTypes.bool.isRequired,
  type: _react.PropTypes.string,
  viewerCompanyId: _react.PropTypes.string,
  isAnAdmin: _react.PropTypes.bool,
  removeSingleFeedByTCAdmin: _react.PropTypes.func,
  historyFeedId: _react.PropTypes.string,
  isContractRequest: _react.PropTypes.bool
};

var styles = {
  paperBox: {
    backgroundColor: '#fafafa',
    display: 'inline-block',
    borderRadius: '10px',
    marginBottom: '24px',
    padding: '16px',
    width: '89%'
  },
  paperBoxNotes: {
    backgroundColor: '#fff5ea'
  },
  paperBoxMsgToDL: {
    backgroundColor: '#e3f2fd'
  },
  messageAvatarContainer: {
    display: 'inline-block',
    verticalAlign: 'top',
    padding: '0 5px',
    width: '11%'
  },
  messageAvatar: {
    marginTop: '10px',
    marginLeft: '15px',
    backgroundColor: '#90a4ae',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
    position: 'relative'
  },
  messageAvatarIcon: {
    color: 'white',
    fill: 'white'
  },
  messageSubject: {
    fontSize: '14px'
  },
  actualSubject: {
    fontWeight: 'bold'
  },
  messageBody: function messageBody(_ref) {
    var bodyText = _ref.msgObject.bodyText;
    return {
      display: bodyText ? 'block' : 'none',
      fontSize: '14px',
      lineHeight: '20px',
      marginBottom: '1em',
      overflowX: 'hidden',
      whiteSpace: 'pre-wrap',
      width: '100%'
    };
  },
  rateSheetsBox: {
    border: '2px solid #e0e0e0',
    borderRadius: '4px'
  },
  rateSheetsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e0e0e0',
    padding: '8px'
  }
};

var Comment = function (_React$Component) {
  _inherits(Comment, _React$Component);

  function Comment() {
    _classCallCheck(this, Comment);

    var _this = _possibleConstructorReturn(this, (Comment.__proto__ || Object.getPrototypeOf(Comment)).call(this));

    _this.removeSingleFeedByTCAdmin = function () {
      var _this$props = _this.props,
          removeSingleFeedByTCAdmin = _this$props.removeSingleFeedByTCAdmin,
          historyFeedId = _this$props.historyFeedId,
          messageId = _this$props.msgObject.messageId;

      removeSingleFeedByTCAdmin({ messageId: messageId, historyFeedId: historyFeedId });
    };

    _this.clickShowRecipients = function () {
      return _this.setState({ showRecipients: !_this.state.showRecipients });
    };

    _this.state = {
      showRecipients: false
    };
    return _this;
  }

  _createClass(Comment, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          addFileToContractFromMessage = _props.addFileToContractFromMessageAction,
          classes = _props.classes,
          companyType = _props.companyType,
          filesInContract = _props.filesInContract,
          isInMessaging = _props.isInMessaging,
          _props$msgObject = _props.msgObject,
          action = _props$msgObject.action,
          attachments = _props$msgObject.attachments,
          bodyText = _props$msgObject.bodyText,
          _props$msgObject$cont = _props$msgObject.contracts,
          contracts = _props$msgObject$cont === undefined ? [] : _props$msgObject$cont,
          createdAt = _props$msgObject.createdAt,
          creator = _props$msgObject.creator,
          creatorEmail = _props$msgObject.creatorEmail,
          creatorMeta = _props$msgObject.creatorMeta,
          isLoading = _props$msgObject.isLoading,
          messageId = _props$msgObject.messageId,
          profileImageUrl = _props$msgObject.profileImageUrl,
          statusChanged = _props$msgObject.statusChanged,
          subject = _props$msgObject.subject,
          _props$msgObject$to = _props$msgObject.to,
          recipients = _props$msgObject$to === undefined ? [] : _props$msgObject$to,
          type = _props$msgObject.type,
          _props$msgObject$body = _props$msgObject.bodyJson,
          bodyJson = _props$msgObject$body === undefined ? {} : _props$msgObject$body,
          contractIdInOfMessage = _props$msgObject.contractId,
          isSender = _props$msgObject.isSender,
          _props$msgObject$even = _props$msgObject.events,
          rawEvents = _props$msgObject$even === undefined ? {} : _props$msgObject$even,
          isAnAdmin = _props.isAnAdmin,
          isContractRequest = _props.isContractRequest,
          contractIdOfThread = _props.contractIdOfThread;
      var _bodyJson$emailBody = bodyJson.emailBody,
          emailBody = _bodyJson$emailBody === undefined ? {} : _bodyJson$emailBody,
          personalizeGreeting = bodyJson.personalizeGreeting,
          greeting = bodyJson.greeting,
          signedBy = bodyJson.signedBy,
          signatureText = bodyJson.signatureText,
          rateDocsMap = bodyJson.rateDocsMap,
          rateDocIds = bodyJson.rateDocIds;

      var allowFilesToBeAddedToContract = companyType === 'Contractor' && isContractRequest;
      var actionCheck = function () {
        if (action === 'Created') return _react2.default.createElement(
          'span',
          null,
          'Initiated Contract'
        );
        if (action === 'Contract Created') return _react2.default.createElement(
          'span',
          null,
          companyType === 'Contractor' ? 'Rates Received' : 'Rates Sent'
        );
        if (action === 'Contract Updated') return _react2.default.createElement(
          'span',
          null,
          'Contract Updated'
        );
        if (action === 'Request Created') return _react2.default.createElement(
          'span',
          null,
          'Request Sent'
        );
        if (action === 'Responded') return _react2.default.createElement(
          'span',
          null,
          'Responded To Contract Request'
        );
        if (action === 'Downloaded') return _react2.default.createElement(
          'span',
          null,
          'Downloaded Contract'
        );
        if (action === 'Viewed') return _react2.default.createElement(
          'span',
          null,
          'Viewed Contract'
        );
        if (action === 'Resent Contract' || action === 'Resent Request') return _react2.default.createElement(
          'span',
          null,
          action
        );
      }();
      var activityType = function () {
        if (type === 'note') return 'note';
        if (actionCheck || statusChanged) return 'action';
        if (action === 'Contract Updated') return 'update';
        return 'message';
      }();

      var Icon = {
        action: function action() {
          return _flag2.default;
        },
        update: function update() {
          return _modeEdit2.default;
        },
        message: function message() {
          return _insertComment2.default;
        },
        note: function note() {
          return _chatBubble2.default;
        }
      }[activityType]();
      var creatorName = function () {
        if (creatorMeta && creatorMeta.realActorEmail) return creatorMeta.realActorEmail;
        return creatorMeta && creatorMeta.name ? creatorMeta.name : creatorEmail;
      }();
      var firstNameLabel = function () {
        var _ref2 = recipients.find(function (r) {
          return Boolean(r.firstName);
        }) || {},
            firstName = _ref2.firstName;

        if (firstName && recipients.length > 1) {
          return ' ' + firstName + ', ...[+' + (recipients.length - 1) + ' ' + (0, _pluralize2.default)('other', recipients.length - 1) + ']';
        }
        if (firstName) return ' ' + firstName + ',';
        return ',';
      }();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: classes.messageAvatarContainer },
          _react2.default.createElement(_materialUi.Avatar, {
            className: classes.messageAvatar,
            icon: _react2.default.createElement(Icon, { className: classes.messageAvatarIcon })
          })
        ),
        _react2.default.createElement(
          _materialUi.Paper,
          {
            style: _extends({}, styles.paperBox, type === 'note' ? styles.paperBoxNotes : {}, recipients && recipients.length && recipients[0].email === 'dl@tourconnect.com' ? styles.paperBoxMsgToDL : {})
          },
          isLoading ? _react2.default.createElement(
            'div',
            { style: { lineHeight: '32px' } },
            'sending...',
            _react2.default.createElement(_materialUi.LinearProgress, null)
          ) : _react2.default.createElement(
            'div',
            { style: { borderBottom: '1px solid #e0e0e0', paddingBottom: '16px' } },
            _react2.default.createElement(
              'div',
              { className: 'flex-tc-sb' },
              _react2.default.createElement(
                'div',
                { className: 'flex-center' },
                _react2.default.createElement(_messagingAvatar2.default, {
                  name: creatorName,
                  type: creator ? 'user' : 'email',
                  tooltipPosition: 'bottom-right',
                  avatarUrl: profileImageUrl
                }),
                _react2.default.createElement(
                  'div',
                  { style: { marginLeft: '16px' } },
                  _react2.default.createElement(
                    'b',
                    null,
                    creatorName
                  ),
                  _react2.default.createElement(_emailTracking2.default, {
                    showRecipients: this.state.showRecipients,
                    clickShowRecipients: this.clickShowRecipients,
                    isSender: isSender,
                    sentDate: createdAt,
                    format: 'D MMM YYYY, H:mm',
                    rawEvents: rawEvents,
                    recipients: recipients
                  })
                )
              ),
              Boolean(isAnAdmin) && _react2.default.createElement(
                'a',
                { onClick: this.removeSingleFeedByTCAdmin, href: '' },
                'Remove'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: '16px', color: isLoading ? 'rgba(0, 0, 0, 0.34)' : 'rgba(0, 0, 0, 0.54)' } },
            _react2.default.createElement(
              'div',
              { style: { fontSize: '16px', fontWeight: 'bold', marginBottom: '16px', display: subject ? 'block' : 'none' } },
              subject
            ),
            Boolean(personalizeGreeting) && _react2.default.createElement(
              'div',
              { style: { marginBottom: '10px', color: 'rgba(0, 0, 0, 0.87)', fontSize: '13px' } },
              greeting,
              firstNameLabel
            ),
            _react2.default.createElement('div', {
              className: 'message-div ' + classes.messageBody,
              dangerouslySetInnerHTML: {
                __html: function () {
                  if (subject && subject.toLowerCase().indexOf('re:') === 0 && bodyText) {
                    return bodyText;
                  }
                  if (emailBody.html) return _planer2.default.extractFromHtml(emailBody.html, window.document);
                  return bodyText;
                }()
              }
            }),
            Boolean(contracts.length) && contracts.map(function (contract) {
              return _react2.default.createElement(_commentContract2.default, {
                key: contract.contractHFId,
                contract: contract
              });
            }),
            Boolean(rateDocIds && rateDocIds.length) && _react2.default.createElement(
              'div',
              { className: classes.rateSheetsBox },
              _react2.default.createElement(
                'div',
                { className: classes.rateSheetsHeader },
                _react2.default.createElement(
                  'div',
                  { style: { fontSize: '16px' } },
                  'Rate Sheets'
                ),
                _react2.default.createElement(_materialUi.FlatButton, {
                  label: 'View Rates',
                  style: { border: '1px solid #e0e0e0' },
                  onClick: function onClick() {
                    return _this2.props.routerPush('/contracting/contract/' + contractIdInOfMessage + '/policies');
                  }
                })
              ),
              _ramda2.default.values(rateDocsMap || {}).map(function (obj) {
                return _react2.default.createElement(
                  'div',
                  { key: obj.threadId, style: { padding: '8px' } },
                  obj.locationName
                );
              })
            ),
            Boolean(attachments && attachments.length) ? _react2.default.createElement(_regularAttachments2.default, {
              isInMessaging: isInMessaging,
              contractIdOfThread: contractIdOfThread,
              allowFilesToBeAddedToContract: allowFilesToBeAddedToContract,
              filesInContract: filesInContract,
              uploads: attachments,
              addToContractFn: function addToContractFn(filesToBeAdded) {
                addFileToContractFromMessage(messageId, _ramda2.default.map(_ramda2.default.merge({ source: 'emailScrape' }), filesToBeAdded));
              }
            }) : _react2.default.createElement('div', null)
          )
        )
      );
    }
  }]);

  return Comment;
}(_react2.default.Component);

Comment.propTypes = propTypes;

Comment.defaultProps = {
  showContactLink: false
};

var mapStateToProps = function mapStateToProps(_ref3, _ref4) {
  var user = _ref3.user,
      contracting = _ref3.contracting;
  var isInMessaging = _ref4.isInMessaging;
  return {
    isAnAdmin: user.get('isAnAdmin'),
    historyFeedId: contracting.contractActivitiesProducts.getIn(['activities', 'historyFeedId']),
    isContractRequest: !isInMessaging && !contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  addFileToContractFromMessageAction: _contractActivitiesProductsActions.addFileToContractFromMessage,
  removeSingleFeedByTCAdmin: _actions.removeSingleFeedByTCAdmin,
  routerPush: _reactRouterRedux.push
})((0, _reactJss2.default)(styles)(Comment));

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  var CONTENT_CHUNK_SIZE, MAX_LINES_COUNT, MAX_LINE_LENGTH, REGEXES, SPLITTER_MAX_LINES, _CRLF_to_LF, _restore_CRLF, getDelimiter, htmlPlaner, isSplitter, postprocess, preprocess, setReturnFlags;

  htmlPlaner = __webpack_require__(3417);

  REGEXES = __webpack_require__(3418);

  SPLITTER_MAX_LINES = 4;

  MAX_LINES_COUNT = 1000;

  MAX_LINE_LENGTH = 200000;

  exports.extractFrom = function(msgBody, contentType, dom) {
    if (contentType == null) {
      contentType = 'text/plain';
    }
    if (dom == null) {
      dom = null;
    }
    if (contentType === 'text/plain') {
      return exports.extractFromPlain(msgBody);
    } else if (contentType === 'text/html') {
      return exports.extractFromHtml(msgBody, dom);
    } else {
      console.warn('Unknown contentType', contentType);
    }
    return msgBody;
  };

  exports.extractFromPlain = function(msgBody) {
    var delimiter, lines, markers;
    delimiter = getDelimiter(msgBody);
    msgBody = preprocess(msgBody, delimiter);
    lines = msgBody.split(delimiter, MAX_LINES_COUNT);
    markers = exports.markMessageLines(lines);
    lines = exports.processMarkedLines(lines, markers);
    msgBody = lines.join(delimiter);
    msgBody = postprocess(msgBody);
    return msgBody;
  };

  exports.extractFromHtml = function(msgBody, dom) {
    var checkpoint, crlfReplaced, emailDocument, emailDocumentCopy, haveCutQuotations, i, index, k, l, len, len1, line, lineCheckpoints, lines, m, markers, matches, numberOfCheckpoints, plainTextMsg, quotationCheckpoints, ref, ref1, ref2, ref3, returnFlags;
    if (dom == null) {
      console.error("No dom provided to parse html.");
      return msgBody;
    }
    if (msgBody.trim() === '') {
      return msgBody;
    }
    ref = _CRLF_to_LF(msgBody), msgBody = ref[0], crlfReplaced = ref[1];
    emailDocument = htmlPlaner.createEmailDocument(msgBody, dom);
    haveCutQuotations = htmlPlaner.cutGmailQuote(emailDocument) || htmlPlaner.cutBlockQuote(emailDocument) || htmlPlaner.cutMicrosoftQuote(emailDocument) || htmlPlaner.cutById(emailDocument) || htmlPlaner.cutFromBlock(emailDocument);
    emailDocumentCopy = htmlPlaner.createEmailDocument(emailDocument.documentElement.outerHTML, dom);
    numberOfCheckpoints = htmlPlaner.addCheckpoints(emailDocument.body, 0);
    quotationCheckpoints = Array.apply(null, Array(numberOfCheckpoints)).map(function() {
      return false;
    });
    htmlPlaner.replaceBreakTagsWithLineFeeds(emailDocument);
    plainTextMsg = emailDocument.body.textContent;
    plainTextMsg = preprocess(plainTextMsg, "\n", 'text/html');
    lines = plainTextMsg.split('\n');
    if (lines.length > MAX_LINES_COUNT) {
      return msgBody;
    }
    lineCheckpoints = new Array(lines.length);
    for (index = k = 0, len = lines.length; k < len; index = ++k) {
      line = lines[index];
      matches = line.match(htmlPlaner.CHECKPOINT_PATTERN) || [];
      lineCheckpoints[index] = matches.map(function(match) {
        return parseInt(match.slice(4, -4));
      });
    }
    lines = lines.map(function(line) {
      return line.replace(htmlPlaner.CHECKPOINT_PATTERN, '');
    });
    markers = exports.markMessageLines(lines);
    returnFlags = {};
    exports.processMarkedLines(lines, markers, returnFlags);
    if (!returnFlags.wereLinesDeleted) {
      if (haveCutQuotations) {
        return _restore_CRLF(emailDocumentCopy.documentElement.outerHTML, crlfReplaced);
      } else {
        return msgBody;
      }
    }
    for (i = l = ref1 = returnFlags.firstLine, ref2 = returnFlags.lastLine; ref1 <= ref2 ? l <= ref2 : l >= ref2; i = ref1 <= ref2 ? ++l : --l) {
      if (!lineCheckpoints[i]) {
        continue;
      }
      ref3 = lineCheckpoints[i];
      for (m = 0, len1 = ref3.length; m < len1; m++) {
        checkpoint = ref3[m];
        quotationCheckpoints[checkpoint] = true;
      }
    }
    htmlPlaner.deleteQuotationTags(emailDocumentCopy.body, 0, quotationCheckpoints);
    return emailDocumentCopy.documentElement.outerHTML;
  };

  exports.markMessageLines = function(lines) {
    var i, j, k, markers, ref, splitter, splitterLines;
    markers = [];
    i = 0;
    while (i < lines.length) {
      if (lines[i].trim() === '') {
        markers[i] = 'e';
      } else if (REGEXES.QUOT_PATTERN.test(lines[i])) {
        markers[i] = 'm';
      } else if (REGEXES.FWD.test(lines[i])) {
        markers[i] = 'f';
      } else {
        splitter = isSplitter(lines.slice(i, i + SPLITTER_MAX_LINES).join("\n"));
        if (splitter) {
          splitterLines = splitter[0].split("\n");
          for (j = k = 0, ref = splitterLines.length; 0 <= ref ? k <= ref : k >= ref; j = 0 <= ref ? ++k : --k) {
            markers[i + j] = 's';
          }
          i += splitterLines.length - 1;
        } else {
          markers[i] = 't';
        }
      }
      i++;
    }
    return markers.join('');
  };

  isSplitter = function(line) {
    var k, len, matchArray, pattern, ref;
    if (line.length > MAX_LINE_LENGTH) {
      return null;
    }
    ref = REGEXES.SPLITTER_PATTERNS;
    for (k = 0, len = ref.length; k < len; k++) {
      pattern = ref[k];
      matchArray = pattern.exec(line);
      if (matchArray && matchArray.index === 0) {
        return matchArray;
      }
    }
    return null;
  };

  exports.processMarkedLines = function(lines, markers, returnFlags) {
    var inlineMatchRegex, inlineReplyIndex, inlineReplyMatch, isInlineReplyLink, quotationEnd, quotationMatch;
    if (returnFlags == null) {
      returnFlags = {};
    }
    if (markers.indexOf('s') < 0 && !/(me*){3}/.test(markers)) {
      markers = markers.replace(/m/g, 't');
    }
    if (/^[te]*f/.test(markers)) {
      setReturnFlags(returnFlags, false, -1, -1);
      return lines;
    }
    inlineMatchRegex = new RegExp('m(?=e*((?:t+e*)+)m)', 'g');
    while (inlineReplyMatch = inlineMatchRegex.exec(lines)) {
      inlineReplyIndex = markers.indexOf(inlineReplyMatch[1], inlineReplyMatch.index);
      isInlineReplyLink = false;
      if (inlineReplyIndex > -1) {
        isInlineReplyLink = REGEXES.PARENTHESIS_LINK.test(lines[inlineReplyIndex - 1]) || lines[inlineReplyIndex].trim().search(REGEXES.PARENTHESIS_LINK) === 0;
      }
      if (!isInlineReplyLink) {
        setReturnFlags(returnFlags, false, -1, -1);
        return lines;
      }
    }
    quotationMatch = new RegExp('(se*)+((t|f)+e*)+', 'g').exec(markers);
    if (quotationMatch) {
      setReturnFlags(returnFlags, true, quotationMatch.index, lines.length);
      return lines.slice(0, quotationMatch.index);
    }
    quotationMatch = REGEXES.QUOTATION.exec(markers) || REGEXES.EMPTY_QUOTATION.exec(markers);
    if (quotationMatch) {
      quotationEnd = quotationMatch.index + quotationMatch[1].length;
      setReturnFlags(returnFlags, true, quotationMatch.index, quotationEnd);
      return lines.slice(0, quotationMatch.index).concat(lines.slice(quotationEnd));
    }
    setReturnFlags(returnFlags, false, -1, -1);
    return lines;
  };

  setReturnFlags = function(returnFlags, wereLinesDeleted, firstLine, lastLine) {
    returnFlags.wereLinesDeleted = wereLinesDeleted;
    returnFlags.firstLine = firstLine;
    return returnFlags.lastLine = lastLine;
  };

  preprocess = function(msgBody, delimiter, contentType) {
    if (contentType == null) {
      contentType = 'text/plain';
    }
    msgBody = msgBody.replace(REGEXES.LINK, function(entireMatch, groupMatch1, matchIndex) {
      var newLineIndex;
      newLineIndex = msgBody.lastIndexOf("\n", matchIndex);
      if (newLineIndex > 0 && msgBody[newLineIndex + 1] === '>') {
        return entireMatch;
      } else {
        return "@@" + groupMatch1 + "@@";
      }
    });
    if (contentType === 'text/plain' && msgBody.length < MAX_LINE_LENGTH) {
      msgBody = msgBody.replace(REGEXES.ON_DATE_SMB_WROTE, function(entireMatch, groupMatch1, groupMatch2, groupMatch3, groupMatch4, matchIndex) {
        if (matchIndex && msgBody[matchIndex - 1] !== "\n") {
          return "" + delimiter + entireMatch;
        } else {
          return entireMatch;
        }
      });
    }
    return msgBody;
  };

  postprocess = function(msgBody) {
    return msgBody.replace(REGEXES.NORMALIZED_LINK, '<$1>').trim();
  };

  CONTENT_CHUNK_SIZE = 100;

  getDelimiter = function(msgBody) {
    var bodyChunk, contentLength, currentIndex, delimiterMatch;
    contentLength = msgBody.length;
    currentIndex = 0;
    bodyChunk = msgBody.substr(currentIndex, CONTENT_CHUNK_SIZE);
    while (!(delimiterMatch = REGEXES.DELIMITER.exec(bodyChunk)) && currentIndex < contentLength) {
      currentIndex += CONTENT_CHUNK_SIZE;
      bodyChunk = msgBody.substr(currentIndex, CONTENT_CHUNK_SIZE);
    }
    if (delimiterMatch) {
      return delimiterMatch[0];
    } else {
      return "\n";
    }
  };

  _CRLF_to_LF = function(msgBody) {
    var delimiter;
    delimiter = getDelimiter(msgBody);
    if (delimiter === '\r\n') {
      return [msgBody.replace(new RegExp(delimiter, 'g'), '\n'), true];
    }
    return [msgBody, false];
  };

  _restore_CRLF = function(msgBody, replaced) {
    if (replaced == null) {
      replaced = true;
    }
    if (replaced) {
      return msgBody.replace(new RegExp('\n', 'g'), '\r\n');
    }
    return msgBody;
  };

}).call(this);


/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _attachmentActionWidgets = __webpack_require__(3421);

var _attachmentActionWidgets2 = _interopRequireDefault(_attachmentActionWidgets);

var _actions = __webpack_require__(537);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _aphrodite = __webpack_require__(123);

var _aphrodite2 = _interopRequireDefault(_aphrodite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var propTypes = {
  uploads: _react.PropTypes.array,
  addToContractFn: _react.PropTypes.func,
  downloadFromUrl: _react.PropTypes.func,
  isInMessaging: _react.PropTypes.bool,
  filesInContract: _react.PropTypes.array,
  allowFilesToBeAddedToContract: _react.PropTypes.bool,
  contractIdOfThread: _react.PropTypes.string
};

var Attachments = function (_React$Component) {
  _inherits(Attachments, _React$Component);

  function Attachments(props) {
    _classCallCheck(this, Attachments);

    var _this = _possibleConstructorReturn(this, (Attachments.__proto__ || Object.getPrototypeOf(Attachments)).call(this, props));

    _this.state = {
      selected: {}
    };
    return _this;
  }

  _createClass(Attachments, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          uploads = _props.uploads,
          downloadFromUrl = _props.downloadFromUrl,
          _addToContractFn = _props.addToContractFn,
          filesInContract = _props.filesInContract,
          allowFilesToBeAddedToContract = _props.allowFilesToBeAddedToContract,
          contractIdOfThread = _props.contractIdOfThread;

      if (!uploads || !uploads.length) return null;
      var styleSheets = _aphrodite2.default.StyleSheet.create({
        container: { display: _ramda2.default.isEmpty(uploads) ? 'none' : 'block', border: '2px solid #e0e0e0', margin: '16px', with: '95%' },
        header: { textAlign: 'center', fontSize: '16px', lineHeight: '52px', height: '52px' },
        subHeader: { display: uploads.length > 1 ? 'flex' : 'none', alignItems: 'center', justifyContent: 'space-between', height: '52px', borderTop: '1px solid #e0e0e0', padding: '0 8px 0 4px' },
        filenameStyle: { overflowWrap: 'break-word', wordWrap: 'break-word', wordBreak: 'break-all', hyphens: 'auto' }
      });
      return _react2.default.createElement(
        'div',
        { className: _aphrodite2.default.css(styleSheets.container) },
        _react2.default.createElement(
          'div',
          { className: _aphrodite2.default.css(styleSheets.header) },
          'Message Attachments'
        ),
        _react2.default.createElement(
          'div',
          { className: _aphrodite2.default.css(styleSheets.subHeader) },
          _react2.default.createElement(_materialUi.Checkbox, {
            style: { width: '175px' },
            label: 'SELECT ALL',
            checked: _ramda2.default.keys(this.state.selected).length === uploads.length,
            onCheck: function onCheck(_, checked) {
              _this2.setState({ selected: checked ? uploads.reduce(function (result, file) {
                  return _ramda2.default.assoc(file._id || file.url || file.path, file, result);
                }, {}) : {} });
            }
          }),
          _react2.default.createElement(_attachmentActionWidgets2.default, {
            allowFilesToBeAddedToContract: allowFilesToBeAddedToContract,
            hide: isNilOrEmpty(this.state.selected),
            downloadFn: function downloadFn() {
              return (0, _actions.bulkDownloadS3File)(_ramda2.default.values(_this2.state.selected), 'Attachments');
            },
            addToContractFn: function addToContractFn() {
              return _addToContractFn(_ramda2.default.values(_this2.state.selected));
            }
          })
        ),
        uploads.filter(function (x) {
          return x;
        }).map(function (file, i) {
          return _react2.default.createElement(
            'div',
            { key: i, style: { color: 'rgba(0, 0, 0, 0.84)' } },
            _react2.default.createElement(_materialUi.Divider, null),
            _react2.default.createElement(
              'div',
              { className: 'flex-center', style: { lineHeight: '32px' } },
              _react2.default.createElement(_materialUi.Checkbox, {
                checked: Boolean(_this2.state.selected[file._id || file.url || file.path]),
                disabled: uploads.length < 2,
                style: { width: '24px', marginLeft: '4px' },
                onCheck: function onCheck(_, checked) {
                  return _this2.setState({ selected: checked ? _ramda2.default.assoc(file._id || file.url || file.path, file, _this2.state.selected) : _ramda2.default.omit([file._id], _this2.state.selected) });
                }
              }),
              _react2.default.createElement(
                'div',
                { className: 'flex-tc-sb', style: { width: '93%', padding: '0 8px', lineHeight: '20px' } },
                _react2.default.createElement(
                  'span',
                  { className: _aphrodite2.default.css(styleSheets.filenameStyle) },
                  file.name
                ),
                _react2.default.createElement(_attachmentActionWidgets2.default, {
                  allowFilesToBeAddedToContract: allowFilesToBeAddedToContract,
                  addedToContractId: _ramda2.default.call(_ramda2.default.compose(_ramda2.default.replace('contract:', ''), _ramda2.default.pathOr('', ['logs', 0, 'foreignIds', 0])), file),
                  downloadFn: function downloadFn() {
                    return downloadFromUrl(file);
                  },
                  addToContractFn: function addToContractFn() {
                    return _addToContractFn([file]);
                  },
                  inContractThread: Boolean(filesInContract && filesInContract.length),
                  addedToCurrentContract: (file.logs || []).some(function (obj) {
                    return obj.foreignIds.indexOf('contract:' + contractIdOfThread) > -1;
                  })
                })
              )
            )
          );
        })
      );
    }
  }]);

  return Attachments;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  _objectDestructuringEmpty(_ref);

  return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    downloadFromUrl: function downloadFromUrl() {
      return dispatch(_actions.downloadFromUrl.apply(undefined, arguments));
    }
  };
};
Attachments.propTypes = propTypes;
Attachments.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Attachments);

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentAdd = function ContentAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' })
  );
};
ContentAdd = (0, _pure2.default)(ContentAdd);
ContentAdd.displayName = 'ContentAdd';
ContentAdd.muiName = 'SvgIcon';

exports.default = ContentAdd;

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Paper = __webpack_require__(228);

var _Paper2 = _interopRequireDefault(_Paper);

var _IconMenu = __webpack_require__(1789);

var _IconMenu2 = _interopRequireDefault(_IconMenu);

var _MenuItem = __webpack_require__(1203);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _IconButton = __webpack_require__(638);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _moreVert = __webpack_require__(876);

var _moreVert2 = _interopRequireDefault(_moreVert);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(37);

var _activityWithIcon = __webpack_require__(1266);

var _activityWithIcon2 = _interopRequireDefault(_activityWithIcon);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  note: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    '&.disabled': {
      pointerEvents: 'none',
      opacity: '0.4',
      cursor: 'progress'
    }
  },
  menuAndMessage: {
    flexGrow: '1',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  iconMenu: {
    '& > button': {
      padding: '0 !important',
      width: 'auto !important'
    }
  },
  moreVertIcon: {
    width: '20px !important',
    height: '20px !important',
    color: 'rgba(0, 0, 0, 0.54) !important'
  },
  menutText: {
    fontSize: '0.9em !important',
    lineHeight: '2em !important',
    minHeight: '2em !important'
  },
  item: {
    overflowX: 'hidden',
    overflowY: 'auto',
    margin: '0.5em',
    padding: '0.5em',
    backgroundColor: '#FFF5EA !important',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    '-webkit-hyphens': 'auto',
    '-ms-hyphens': 'auto',
    '-moz-hyphens': 'auto',
    hyphens: 'auto'
  },
  noteFooter: {
    width: '100%',
    textAlign: 'right',
    margin: '0 0.5em 1em',
    color: 'rgba(0, 0, 0, 0.54) !important',
    fontSize: '12px'
  },
  fileAttachment: {
    marginTop: '10px'
  },
  noteContent: {
    fontSize: '14px',
    whiteSpace: 'pre-wrap'
  }
};

var NoteContent = function (_Component) {
  _inherits(NoteContent, _Component);

  function NoteContent() {
    _classCallCheck(this, NoteContent);

    return _possibleConstructorReturn(this, (NoteContent.__proto__ || Object.getPrototypeOf(NoteContent)).apply(this, arguments));
  }

  _createClass(NoteContent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classes = _props.classes,
          itemId = _props.itemId,
          bodyText = _props.bodyText,
          bodyJson = _props.bodyJson,
          attachments = _props.attachments,
          authorname = _props.authorname,
          timestamp = _props.timestamp,
          handleRemove = _props.handleRemove,
          handleAddToContract = _props.handleAddToContract,
          disallowAddToContract = _props.disallowAddToContract,
          disabled = _props.disabled;

      return _react2.default.createElement(
        'div',
        { className: '' + classes.note + (disabled ? ' disabled' : ''), key: itemId },
        _react2.default.createElement(
          'div',
          { className: classes.menuAndMessage },
          _react2.default.createElement(
            _IconMenu2.default,
            {
              className: classes.iconMenu,
              iconButtonElement: _react2.default.createElement(
                _IconButton2.default,
                null,
                _react2.default.createElement(_moreVert2.default, { className: classes.moreVertIcon })
              ),
              anchorOrigin: { horizontal: 'left', vertical: 'top' },
              targetOrigin: { horizontal: 'left', vertical: 'top' }
            },
            _react2.default.createElement(_MenuItem2.default, { primaryText: 'Remove', className: classes.menutText, onTouchTap: function onTouchTap() {
                return handleRemove(_this2.props.itemId);
              } }),
            attachments.length > 0 && !disallowAddToContract ? _react2.default.createElement(_MenuItem2.default, { primaryText: 'Add files to contract', className: classes.menutText, onTouchTap: function onTouchTap() {
                return handleAddToContract(_this2.props.itemId);
              } }) : undefined
          ),
          _react2.default.createElement(
            _Paper2.default,
            { className: classes.item },
            _react2.default.createElement(
              'span',
              { className: classes.noteContent },
              bodyText,
              (attachments || []).map(function (file, ix) {
                return _react2.default.createElement(_activityWithIcon2.default, {
                  className: classes.fileAttachment,
                  file: { downloadUrl: file.downloadUrl || _api.fileUrls.getDownloadUrlSync(file.path), fileName: file.name },
                  key: ix
                });
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: classes.noteFooter },
          'by ',
          authorname,
          ' ',
          (0, _moment2.default)(new Date(timestamp)).fromNow(),
          bodyJson && bodyJson.addedToContract ? ', files added to Contract' : ''
        )
      );
    }
  }]);

  return NoteContent;
}(_react.Component);

NoteContent.propTypes = {
  attachments: _react.PropTypes.array,
  authorname: _react.PropTypes.string,
  bodyJson: _react.PropTypes.object,
  bodyText: _react.PropTypes.string,
  classes: _react.PropTypes.object,
  handleAddToContract: _react.PropTypes.func,
  handleRemove: _react.PropTypes.func,
  itemId: _react.PropTypes.string,
  timestamp: _react.PropTypes.string,
  disallowAddToContract: _react.PropTypes.bool,
  disabled: _react.PropTypes.bool
};

NoteContent.defaultProps = {
  handleAddToContract: function handleAddToContract(key) {
    return console.log(key);
  },
  bodyJson: {},
  disallowAddToContract: false,
  disabled: false
};

exports.default = (0, _reactJss2.default)(styles)(NoteContent);

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _editSeasonButton = __webpack_require__(1563);

var _editSeasonButton2 = _interopRequireDefault(_editSeasonButton);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _arrowForward = __webpack_require__(1246);

var _arrowForward2 = _interopRequireDefault(_arrowForward);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _aphrodite = __webpack_require__(123);

var _aphrodite2 = _interopRequireDefault(_aphrodite);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = _aphrodite2.default.StyleSheet.create({
  addSeason: { textAlign: 'right', paddingRight: '4px' }
});

var _getDateFromUTC = function _getDateFromUTC(date) {
  var dateObject = new Date(date);
  return new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate());
};
var formatDate = function formatDate(date) {
  return (0, _moment2.default)(_getDateFromUTC(date)).format('D MMM YYYY');
};
var SeasonForSeasonRates = function SeasonForSeasonRates(_ref) {
  var isNotContractingPeriod = _ref.isNotContractingPeriod,
      _ref$existingSeasons = _ref.existingSeasons,
      existingSeasons = _ref$existingSeasons === undefined ? [] : _ref$existingSeasons,
      _ref$dateRanges = _ref.dateRanges,
      dateRanges = _ref$dateRanges === undefined ? [] : _ref$dateRanges,
      seasonName = _ref.seasonName,
      seasonRatesIndex = _ref.seasonRatesIndex,
      deleteFromProduct = _ref.deleteFromProduct,
      openAddEditContractDialog = _ref.openAddEditContractDialog,
      supplierEditable = _ref.supplierEditable,
      contractingPeriod = _ref.contractingPeriod,
      _ref$classes = _ref.classes,
      classes = _ref$classes === undefined ? {} : _ref$classes,
      openGlobalAlert = _ref.openGlobalAlert;

  var openEditSeasonModal = function openEditSeasonModal() {
    return openAddEditContractDialog({
      type: 'editSeason',
      data: {
        seasonIndex: seasonRatesIndex,
        title: 'Edit Season'
      }
    });
  };
  var isSpecialEventWithoutSingleEventName = !dateRanges.filter(function (dateRange) {
    return dateRange.eventName && (dateRange.seasonStartDate || dateRange.seasonEndDate);
  }).length;
  var otherSeasons = _ramda2.default.remove(seasonRatesIndex, 1, existingSeasons);

  var formatSeasonStartAndEndDates = function formatSeasonStartAndEndDates(_ref2, dateRangeIndex) {
    var seasonStartDate = _ref2.seasonStartDate,
        seasonEndDate = _ref2.seasonEndDate;

    var startClass = classes[dateRangeIndex + '-seasonStartDate'];
    var endClass = classes[dateRangeIndex + '-seasonEndDate'];
    var start = formatDate(seasonStartDate);
    var end = formatDate(seasonEndDate);
    if (seasonStartDate && seasonEndDate) {
      if ((0, _moment2.default)(seasonStartDate).isSame(seasonEndDate)) {
        return _react2.default.createElement(
          'div',
          {
            key: dateRangeIndex,
            className: startClass
          },
          start
        );
      }
      return _react2.default.createElement(
        'div',
        { key: dateRangeIndex },
        _react2.default.createElement(
          'span',
          { className: startClass },
          start
        ),
        ' - ',
        _react2.default.createElement(
          'span',
          { className: endClass },
          end
        )
      );
    }
    if (seasonStartDate) return _react2.default.createElement(
      'span',
      { className: startClass },
      start
    );
    if (seasonEndDate) return _react2.default.createElement(
      'span',
      { className: endClass },
      end
    );
  };
  return _react2.default.createElement(
    _mouseOverEditDiv2.default,
    {
      extendPadding: true,
      actionButtons: _react2.default.createElement(_editButton2.default, {
        onEdit: openEditSeasonModal,
        onDelete: function onDelete() {
          openGlobalAlert({
            text: 'Deleting this season will remove all rate sets and allocations associated with this season, are you sure you want to proceed?',
            onOk: function onOk() {
              return deleteFromProduct({ seasonRatesIndex: seasonRatesIndex, contractingPeriod: contractingPeriod, updateType: 'DELETE_SEASON_FROM_PRODUCT' });
            }
          });
        },
        deleteButton: true
      }),
      editable: supplierEditable,
      className: classes.main
    },
    seasonName === 'Special Event' && dateRanges.some(function (range) {
      return range.eventName;
    }) ? dateRanges.map(function (range, rangeIndex) {
      var overlapped = supplierEditable && _dateUtils2.default.overlapExisting({ from: range.seasonStartDate, to: range.seasonEndDate }, otherSeasons);
      return _react2.default.createElement(
        'div',
        {
          className: 'season-start-and-end-dates ' + classes[rangeIndex + '-dateRange'],
          style: { marginBottom: rangeIndex === dateRanges.length - 1 ? '12px' : '0px' },
          key: rangeIndex
        },
        _react2.default.createElement(_twoColumnRow2.default, {
          outerContainerStyle: { width: '100%', marginBottom: '0' },
          leftColumnStyle: { fontSize: '15px', color: 'black' },
          leftColumnClassName: classes[rangeIndex + '-eventName'],
          leftColumnContent: isSpecialEventWithoutSingleEventName && !rangeIndex ? 'Special Event' : (range.eventName || '').toUpperCase(),
          rightColumnStyle: { fontSize: '15px', color: 'black', marginLeft: 'auto' },
          rightColumnContent: range.seasonStartDate || range.seasonEndDate ? _react2.default.createElement(
            'div',
            {
              style: {
                display: 'flex',
                flexDirection: 'row-reverse',
                alignItems: 'center',
                whiteSpace: 'pre',
                textAlign: 'right',
                color: overlapped ? 'red' : ''
              }
            },
            formatSeasonStartAndEndDates(range, rangeIndex),
            overlapped ? _react2.default.createElement(_arrowForward2.default, { style: { color: 'red' } }) : _react2.default.createElement('span', null)
          ) : _react2.default.createElement(_editSeasonButton2.default, {
            existingSeasons: existingSeasons,
            className: _aphrodite2.default.css(styles.addSeason),
            openAddEditContractDialog: openAddEditContractDialog,
            seasonRatesIndex: seasonRatesIndex,
            seasonName: seasonName,
            dateRanges: dateRanges
          })
        })
      );
    }) : _react2.default.createElement(
      'div',
      { className: 'season-start-and-end-dates' },
      _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { width: '100%', marginBottom: '0' },
        leftColumnStyle: { fontSize: '15px', color: 'black' },
        leftColumnContent: isNotContractingPeriod ? seasonName.toUpperCase() : '',
        rightColumnStyle: { fontSize: '15px', color: 'black', marginLeft: 'auto' },
        rightColumnContent: _react2.default.createElement(
          'div',
          { style: { whiteSpace: 'pre', textAlign: 'right' } },
          !(dateRanges && dateRanges.length && dateRanges.some(function (range) {
            return range.seasonStartDate;
          })) ? _react2.default.createElement(
            'div',
            { className: _aphrodite2.default.css(styles.addSeason), style: { color: '#f44336' } },
            'Update Season Dates'
          ) : dateRanges.map(function (range, rangeIndex) {
            var overlapped = supplierEditable && _dateUtils2.default.overlapExisting({ from: range.seasonStartDate, to: range.seasonEndDate }, otherSeasons);
            return _react2.default.createElement(
              'div',
              {
                key: rangeIndex,
                className: classes[rangeIndex + '-dateRange'],
                style: {
                  display: 'flex',
                  flexDirection: 'row-reverse',
                  alignItems: 'center',
                  whiteSpace: 'pre',
                  textAlign: 'right',
                  color: overlapped ? 'red' : ''
                }
              },
              formatSeasonStartAndEndDates(range, rangeIndex),
              overlapped ? _react2.default.createElement(_arrowForward2.default, { style: { color: 'red' } }) : _react2.default.createElement('span', null)
            );
          })
        )
      })
    )
  );
};

var mapActions = {
  openGlobalAlert: function openGlobalAlert(payload) {
    return {
      type: 'open_global_alert',
      payload: payload
    };
  }
};
exports.default = (0, _reactRedux.connect)(null, mapActions)(SeasonForSeasonRates);

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _specialOfferTable = __webpack_require__(1557);

var _specialOfferTable2 = _interopRequireDefault(_specialOfferTable);

var _materialUi = __webpack_require__(3);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _reactRedux = __webpack_require__(6);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  supplierEditable: _react.PropTypes.bool,
  offers: _react.PropTypes.array,
  openAddEditContractDialog: _react.PropTypes.func,
  productType: _react.PropTypes.string,
  inDiffing: _react.PropTypes.bool,
  contractState: _react.PropTypes.string,
  classes: _react.PropTypes.object
};

var LeftFour = function (_Component) {
  _inherits(LeftFour, _Component);

  function LeftFour() {
    _classCallCheck(this, LeftFour);

    return _possibleConstructorReturn(this, (LeftFour.__proto__ || Object.getPrototypeOf(LeftFour)).apply(this, arguments));
  }

  _createClass(LeftFour, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          offers = _props.offers,
          openAddEditContractDialog = _props.openAddEditContractDialog,
          supplierEditable = _props.supplierEditable,
          productType = _props.productType,
          contractState = _props.contractState,
          inDiffing = _props.inDiffing,
          _props$classes = _props.classes,
          classes = _props$classes === undefined ? {} : _props$classes;


      var addNewOffer = function addNewOffer() {
        return openAddEditContractDialog({
          type: 'manageExtrasOffers',
          title: 'Manage Special Offers',
          offersOrExtras: { type: 'offers', createNew: true }
        });
      };
      return _react2.default.createElement(
        'div',
        { id: 'offers', className: classes['main'] },
        !inDiffing && _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '24px', marginBottom: '24px' } }),
        _react2.default.createElement(_helperLink2.default, {
          labelText: 'SPECIAL OFFERS',
          value: 'offers',
          showSync: Boolean(offers && offers.length),
          actions: [{
            label: 'Manage Special Offers (Beta)',
            onTouchTap: function onTouchTap() {
              return openAddEditContractDialog({
                type: 'manageExtrasOffers',
                title: 'Manage Special Offers',
                offersOrExtras: { type: 'offers' }
              });
            }
          }]
        }),
        offers && offers.length ? _react2.default.createElement(
          'div',
          null,
          offers.map(function (offer, index) {
            var openEditModal = function openEditModal(toDelete) {
              return function () {
                return openAddEditContractDialog({
                  type: 'manageExtrasOffers',
                  title: 'Manage Special Offers',
                  offersOrExtras: {
                    type: 'offers',
                    selectedId: offer._id,
                    toDelete: toDelete
                  }
                });
              };
            };
            return _react2.default.createElement(
              _mouseOverEditDiv2.default,
              {
                extendPadding: true,
                key: index,
                editable: supplierEditable,
                actionButtons: _react2.default.createElement(_editButton2.default, {
                  onEdit: openEditModal(),
                  onDelete: openEditModal(true),
                  deleteButton: true
                })
              },
              _react2.default.createElement(_specialOfferTable2.default, _extends({}, offer, {
                productType: productType,
                contractState: contractState,
                openEditModal: openEditModal(),
                classes: classes,
                offerIndex: index
              })),
              index === offers.length - 1 ? undefined : _react2.default.createElement('br', null)
            );
          }),
          _react2.default.createElement(
            'div',
            {
              style: {
                marginTop: '12px',
                marginBottom: '24px',
                display: supplierEditable ? 'block' : 'none'
              }
            },
            _react2.default.createElement(_addItemCard2.default, {
              text: 'Add another special offer',
              onClick: addNewOffer,
              editable: supplierEditable
            })
          )
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_addItemCard2.default, {
            text: 'Add special offers',
            onClick: addNewOffer,
            editable: supplierEditable
          })
        )
      );
    }
  }]);

  return LeftFour;
}(_react.Component);

LeftFour.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var contracting = _ref.contracting;
  var reducerName = _ref2.reducerName,
      offers = _ref2.offers;

  if (offers) return { offers: offers };
  return {
    offers: contracting[reducerName].getIn(['rightSideContent', 'offers']) ? contracting[reducerName].getIn(['rightSideContent', 'offers']).toJS() : [],
    supplierEditable: contracting[reducerName].getIn(['leftNav', 'supplierEditable']),
    contractState: contracting[reducerName].getIn(['leftNav', 'contractState']),
    productType: contracting[reducerName].getIn(['rightSideContent', 'productType'])
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(LeftFour);

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _materialUi = __webpack_require__(3);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

var _rateTableTemplateContainer = __webpack_require__(632);

var _rateTableTemplateContainer2 = _interopRequireDefault(_rateTableTemplateContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  extras: _react.PropTypes.array,
  supplierEditable: _react.PropTypes.bool,
  contractState: _react.PropTypes.string,
  hideHeader: _react.PropTypes.bool,
  showBorder: _react.PropTypes.bool,
  openAddEditContractDialog: _react.PropTypes.func,
  classes: _react.PropTypes.object
};

var Extras = function (_Component) {
  _inherits(Extras, _Component);

  function Extras() {
    _classCallCheck(this, Extras);

    return _possibleConstructorReturn(this, (Extras.__proto__ || Object.getPrototypeOf(Extras)).apply(this, arguments));
  }

  _createClass(Extras, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          extras = _props.extras,
          supplierEditable = _props.supplierEditable,
          contractState = _props.contractState,
          hideHeader = _props.hideHeader,
          showBorder = _props.showBorder,
          openAddEditContractDialog = _props.openAddEditContractDialog,
          _props$classes = _props.classes,
          classes = _props$classes === undefined ? {} : _props$classes;


      var addAnExtra = function addAnExtra() {
        return openAddEditContractDialog({
          type: 'manageExtrasOffers',
          data: { title: 'Add Extra' },
          offersOrExtras: { type: 'extras', createNew: true }
        });
      };
      return _react2.default.createElement(
        'div',
        { className: classes.main },
        !hideHeader && _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '24px', marginBottom: '24px' } }),
        !hideHeader && _react2.default.createElement(_helperLink2.default, {
          labelText: 'EXTRAS',
          value: 'extras',
          showSync: Boolean(extras && extras.length),
          actions: [{
            label: 'Manage Extras (Beta)',
            onTouchTap: function onTouchTap() {
              return openAddEditContractDialog({
                type: 'manageExtrasOffers',
                title: 'Manage Extras',
                offersOrExtras: { type: 'extras' }
              });
            }
          }]
        }),
        !(extras && extras.length) ? _react2.default.createElement(_addItemCard2.default, { text: 'Add extras', onClick: addAnExtra, editable: supplierEditable }) : extras.map(function (extra, index) {
          return _react2.default.createElement(
            _mouseOverEditDiv2.default,
            {
              key: index,
              editable: supplierEditable,
              actionButtons: _react2.default.createElement(_editButton2.default, {
                onEdit: function onEdit() {
                  return openAddEditContractDialog({
                    type: 'manageExtrasOffers',
                    title: 'Manage Extras',
                    offersOrExtras: {
                      type: 'extras',
                      selectedId: extra._id
                    }
                  });
                },
                onDelete: function onDelete() {
                  return openAddEditContractDialog({
                    type: 'manageExtrasOffers',
                    title: 'Manage Extras',
                    offersOrExtras: {
                      type: 'extras',
                      selectedId: extra._id,
                      toDelete: true
                    }
                  });
                },
                deleteButton: true
              })
            },
            _react2.default.createElement(
              'div',
              {
                style: showBorder ? { border: '1px solid rgba(0, 0, 0, 0.1)', marginTop: '8px' } : { marginBottom: '16px' },
                className: classes[index + '-extra']
              },
              _react2.default.createElement(
                'div',
                { style: { borderBottom: '1px solid rgba(0, 0, 0, 0.1)' } },
                _react2.default.createElement(
                  'b',
                  { className: classes[index + '-extraType'] },
                  extra.extraType
                ),
                extra.extraCode ? _react2.default.createElement(
                  'div',
                  { style: { color: '#878787' }, className: classes[index + '-extraCode'] },
                  'Code: ',
                  _react2.default.createElement(
                    'b',
                    null,
                    extra.extraCode
                  )
                ) : undefined
              ),
              _react2.default.createElement(_rateTableTemplateContainer2.default, {
                productType: 'Non-Accommodation',
                rateSet: _extends({}, extra),
                contractState: contractState,
                editable: false,
                forOffer: true,
                classes: classes[index + '-ratesClasses']
              }),
              _react2.default.createElement(
                'div',
                { className: classes[index + '-description'], style: { whiteSpace: 'pre-wrap' } },
                extra.description
              )
            )
          );
        }),
        extras && extras.length && supplierEditable ? _react2.default.createElement(_addItemCard2.default, {
          text: 'Add another extra',
          onClick: addAnExtra,
          editable: supplierEditable,
          hide: !supplierEditable
        }) : undefined
      );
    }
  }]);

  return Extras;
}(_react.Component);

Extras.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var contracting = _ref.contracting;
  var reducerName = _ref2.reducerName,
      extras = _ref2.extras;

  if (extras) return { extras: extras };
  return {
    extras: contracting[reducerName].getIn(['rightSideContent', 'extras']) ? contracting[reducerName].getIn(['rightSideContent', 'extras']).toJS() : [],
    supplierEditable: contracting[reducerName].getIn(['leftNav', 'supplierEditable']),
    contractState: contracting[reducerName].getIn(['leftNav', 'contractState'])
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Extras);

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

var _editSeasonButton = __webpack_require__(1563);

var _editSeasonButton2 = _interopRequireDefault(_editSeasonButton);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  allocation: _react.PropTypes.array,
  productType: _react.PropTypes.string,
  existingSeasons: _react.PropTypes.array,
  openAddEditContractDialog: _react.PropTypes.func,
  supplierEditable: _react.PropTypes.bool,
  classes: _react.PropTypes.object
};

var RightOne = function (_Component) {
  _inherits(RightOne, _Component);

  function RightOne() {
    _classCallCheck(this, RightOne);

    return _possibleConstructorReturn(this, (RightOne.__proto__ || Object.getPrototypeOf(RightOne)).apply(this, arguments));
  }

  _createClass(RightOne, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          allocation = _props.allocation,
          productType = _props.productType,
          openAddEditContractDialog = _props.openAddEditContractDialog,
          supplierEditable = _props.supplierEditable,
          _props$existingSeason = _props.existingSeasons,
          existingSeasons = _props$existingSeason === undefined ? [] : _props$existingSeason,
          _props$classes = _props.classes,
          classes = _props$classes === undefined ? {} : _props$classes;


      var getAllocation = {
        onRequest: 'On Request',
        freesale: 'Freesale',
        allotment: 'Allotment'
      };
      if (!(allocation && allocation.length)) {
        return _react2.default.createElement(
          'div',
          { style: { marginBottom: '12px' }, id: 'allocation' },
          _react2.default.createElement(
            _helperLink2.default,
            { value: 'allocation', labelStyle: { marginBottom: '12px' } },
            'ALLOCATION'
          ),
          _react2.default.createElement(_addItemCard2.default, {
            text: 'Add allocation information',
            onClick: function onClick() {
              return openAddEditContractDialog({ type: 'allocation', title: 'Add Allocation' });
            },
            editable: supplierEditable
          })
        );
      }
      var varyBySeason = allocation && allocation.length && (allocation.length > 1 || _ramda2.default.path([0, 'dateRanges', 'length'], allocation) > 1);
      var editAllocationFn = function editAllocationFn() {
        return openAddEditContractDialog({ type: 'allocation', title: 'Edit Allocation' });
      };
      return _react2.default.createElement(
        'div',
        { id: 'allocation', className: classes['main'] },
        _react2.default.createElement(
          _mouseOverEditDiv2.default,
          {
            editable: supplierEditable,
            hintOnRight: true,
            singleLineTitle: true,
            regularDiv: allocation.length > 1 && _ramda2.default.any(_ramda2.default.compose(_ramda2.default.isEmpty, _ramda2.default.prop('dateRanges')), existingSeasons),
            actionButtons: _react2.default.createElement(_editButton2.default, { onEdit: editAllocationFn })
          },
          _react2.default.createElement(
            _helperLink2.default,
            { value: 'allocation', labelStyle: { marginBottom: '12px' } },
            _react2.default.createElement(
              'b',
              null,
              'ALLOCATION'
            )
          ),
          allocation.map(function (_ref, index) {
            var allocationType = _ref.allocationType,
                allotments = _ref.allotments,
                releaseBackDays = _ref.releaseBackDays,
                numberOfRooms = _ref.numberOfRooms,
                extraAlloProps = _objectWithoutProperties(_ref, ['allocationType', 'allotments', 'releaseBackDays', 'numberOfRooms']);

            var _ref2 = (allocation.length > 1 && existingSeasons.length ? existingSeasons[index] : extraAlloProps) || { dateRanges: [] },
                dateRanges = _ref2.dateRanges;

            return _react2.default.createElement(
              'div',
              { key: index, className: classes[index + '-allocation'] },
              _react2.default.createElement(_twoColumnRow2.default, {
                outerContainerStyle: {
                  marginBottom: '0',
                  backgroundColor: 'rgba(0, 0, 0, 0.1)',
                  borderLeft: '1px solid #bababa',
                  borderBottom: '1px solid #bababa',
                  borderRight: '1px solid #bababa',
                  borderTop: !index ? '1px solid #bababa' : ''
                },
                leftColumnStyle: { color: '#262626', padding: '4px 8px' },
                rightColumnStyle: { color: '#262626', padding: '4px 8px' },
                rightColumnClassName: classes[index + '-allocationType'],
                leftColumnContent: _react2.default.createElement(
                  'div',
                  { style: { fontSize: '12px' } },
                  _react2.default.createElement(
                    'div',
                    { style: { color: '#f44336' } },
                    varyBySeason && existingSeasons.length && !_dateUtils2.default.getSeasonNameIfMatch(existingSeasons, dateRanges || []) ? 'These dates don\'t match any seasons.' : ''
                  ),
                  _ramda2.default.isEmpty(dateRanges) && _ramda2.default.length(allocation) > 1 && supplierEditable ? _react2.default.createElement(_editSeasonButton2.default, {
                    existingSeasons: existingSeasons,
                    openAddEditContractDialog: openAddEditContractDialog,
                    seasonRatesIndex: index,
                    seasonName: _ramda2.default.path([index, 'seasonName'], existingSeasons),
                    dateRanges: dateRanges
                  }) : _react2.default.createElement(
                    'div',
                    null,
                    (dateRanges || []).map(function (range, rangeIndex) {
                      return _react2.default.createElement(
                        'div',
                        {
                          key: rangeIndex,
                          className: classes[index + '-dateRanges-' + rangeIndex]
                        },
                        _dateUtils2.default.displayRange(range, {
                          start: classes[index + '-dateRanges-' + rangeIndex + '-seasonStartDate'],
                          end: classes[index + '-dateRanges-' + rangeIndex + '-seasonEndDate']
                        })
                      );
                    })
                  )
                ),
                rightColumnContent: getAllocation[allocationType]
              }),
              allocationType === 'allotment' ? _react2.default.createElement(
                'div',
                {
                  style: {
                    borderLeft: '1px solid #bababa',
                    borderBottom: '1px solid #bababa',
                    borderRight: '1px solid #bababa'
                  }
                },
                _react2.default.createElement(
                  _materialUi.Table,
                  null,
                  _react2.default.createElement(
                    _materialUi.TableHeader,
                    {
                      displaySelectAll: false,
                      adjustForCheckbox: false,
                      style: { borderBottom: '' }
                    },
                    _react2.default.createElement(
                      _materialUi.TableRow,
                      { displayBorder: false, style: { height: '32px' } },
                      _react2.default.createElement(
                        _materialUi.TableHeaderColumn,
                        {
                          style: { paddingLeft: '8px', height: '32px', textAlign: 'center' }
                        },
                        productType && productType === 'Non-Accommodation' ? 'Number of Passengers' : 'Number of Rooms'
                      ),
                      _react2.default.createElement(
                        _materialUi.TableHeaderColumn,
                        {
                          style: { paddingLeft: '16px', height: '32px', textAlign: 'center' }
                        },
                        'Release Back Days'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _materialUi.TableBody,
                    { displayRowCheckbox: false },
                    allotments.map(function (allotment, i) {
                      return _react2.default.createElement(
                        _materialUi.TableRow,
                        {
                          key: i,
                          style: { height: '32px' },
                          displayBorder: false,
                          className: classes[index + '-allotments-' + i]
                        },
                        _react2.default.createElement(
                          _materialUi.TableRowColumn,
                          {
                            style: {
                              textAlign: 'center',
                              paddingLeft: '0',
                              height: '32px',
                              fontWeight: 'bold',
                              fontSize: '14px'
                            },
                            className: classes[index + '-allotments-' + i + '-numberOfRooms']
                          },
                          allotment.numberOfRooms
                        ),
                        _react2.default.createElement(
                          _materialUi.TableRowColumn,
                          {
                            style: {
                              textAlign: 'center',
                              height: '32px',
                              fontWeight: 'bold',
                              fontSize: '14px'
                            },
                            className: classes[index + '-allotments-' + i + '-releaseBackDays']
                          },
                          allotment.releaseBackDays
                        )
                      );
                    })
                  )
                )
              ) : undefined,
              allocationType === 'freesale' && !numberOfRooms ? _react2.default.createElement(
                'div',
                {
                  style: {
                    borderLeft: '1px solid #bababa',
                    borderBottom: '1px solid #bababa',
                    borderRight: '1px solid #bababa'
                  }
                },
                _react2.default.createElement(_twoColumnRow2.default, {
                  key: index,
                  outerContainerStyle: { marginBottom: '8px', paddingTop: '8px' },
                  leftColumnStyle: {
                    float: 'left',
                    fontSize: '12px',
                    color: '#9e9e9e',
                    paddingLeft: '8px'
                  },
                  leftColumnContent: 'Release Back Days',
                  rightColumnStyle: {
                    float: 'right',
                    paddingRight: '26px',
                    fontWeight: 'bold',
                    color: 'black'
                  },
                  rightColumnClassName: classes[index + '-releaseBackDays'],
                  rightColumnContent: releaseBackDays
                })
              ) : undefined,
              allocationType === 'freesale' && numberOfRooms ? _react2.default.createElement(
                'div',
                {
                  style: {
                    borderLeft: '1px solid #bababa',
                    borderBottom: '1px solid #bababa',
                    borderRight: '1px solid #bababa'
                  }
                },
                _react2.default.createElement(
                  _materialUi.Table,
                  null,
                  _react2.default.createElement(
                    _materialUi.TableHeader,
                    {
                      displaySelectAll: false,
                      adjustForCheckbox: false,
                      style: { borderBottom: '' }
                    },
                    _react2.default.createElement(
                      _materialUi.TableRow,
                      { displayBorder: false, style: { height: '32px' } },
                      _react2.default.createElement(
                        _materialUi.TableHeaderColumn,
                        {
                          style: { paddingLeft: '8px', height: '32px', textAlign: 'center' }
                        },
                        productType && productType === 'Non-Accommodation' ? 'Number of Passengers' : 'Number of Rooms'
                      ),
                      _react2.default.createElement(
                        _materialUi.TableHeaderColumn,
                        {
                          style: { paddingLeft: '16px', height: '32px', textAlign: 'center' }
                        },
                        'Release Back Days'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _materialUi.TableBody,
                    { displayRowCheckbox: false },
                    _react2.default.createElement(
                      _materialUi.TableRow,
                      {
                        style: { height: '32px' },
                        displayBorder: false,
                        className: classes[index + '-freesale']
                      },
                      _react2.default.createElement(
                        _materialUi.TableRowColumn,
                        {
                          style: {
                            textAlign: 'center',
                            paddingLeft: '0',
                            height: '32px',
                            fontWeight: 'bold',
                            fontSize: '14px'
                          },
                          className: classes[index + '-numberOfRooms']
                        },
                        numberOfRooms
                      ),
                      _react2.default.createElement(
                        _materialUi.TableRowColumn,
                        {
                          style: {
                            textAlign: 'center',
                            height: '32px',
                            fontWeight: 'bold',
                            fontSize: '14px'
                          },
                          className: classes[index + '-releaseBackDays']
                        },
                        releaseBackDays
                      )
                    )
                  )
                )
              ) : undefined
            );
          })
        ),
        _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '24px', marginBottom: '24px' } })
      );
    }
  }]);

  return RightOne;
}(_react.Component);

RightOne.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref3, _ref4) {
  var contracting = _ref3.contracting;
  var allocation = _ref4.allocation;

  if (allocation) return { allocation: allocation };
  return {
    allocation: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'allocation']) ? contracting.contractActivitiesProducts.getIn(['rightSideContent', 'allocation']).toJS() : []
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(RightOne);

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  supplierEditable: _react.PropTypes.bool,
  blackouts: _react.PropTypes.array,
  openAddEditContractDialog: _react.PropTypes.func,
  classes: _react.PropTypes.object
};

var RightTwoBlackouts = function (_Component) {
  _inherits(RightTwoBlackouts, _Component);

  function RightTwoBlackouts() {
    _classCallCheck(this, RightTwoBlackouts);

    return _possibleConstructorReturn(this, (RightTwoBlackouts.__proto__ || Object.getPrototypeOf(RightTwoBlackouts)).apply(this, arguments));
  }

  _createClass(RightTwoBlackouts, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          blackouts = _props.blackouts,
          supplierEditable = _props.supplierEditable,
          openAddEditContractDialog = _props.openAddEditContractDialog,
          _props$classes = _props.classes,
          classes = _props$classes === undefined ? {} : _props$classes;

      var startDate = function startDate(_ref) {
        var date = _ref.startDate;
        return date ? new Date(date) : '';
      };
      var endDate = function endDate(_ref2) {
        var date = _ref2.endDate;
        return date ? new Date(date) : '';
      };
      var format = function format(date) {
        return date ? _moment2.default.utc(date).format('D MMM YYYY') : '';
      };
      var editBlackoutsFn = function editBlackoutsFn() {
        return openAddEditContractDialog({
          type: 'blackouts',
          title: 'Edit Blackout Days'
        });
      };
      return _react2.default.createElement(
        'div',
        { id: 'blackouts', className: classes.main },
        _react2.default.createElement(_helperLink2.default, {
          labelText: 'BLACKOUT DAYS',
          value: 'blackouts',
          showSync: Boolean(blackouts && blackouts.length),
          labelStyle: { marginBottom: '12px', display: 'block' }
        }),
        blackouts && blackouts.length ? _react2.default.createElement(
          _mouseOverEditDiv2.default,
          {
            editable: supplierEditable,
            hintOnRight: true,
            singleLineTitle: true,
            regularDiv: !_ramda2.default.all(_ramda2.default.prop('startDate'), blackouts),
            actionButtons: blackouts && blackouts.length ? _react2.default.createElement(_editButton2.default, { onEdit: editBlackoutsFn }) : undefined,
            className: classes['main']
          },
          blackouts
          // .sort((a, b) => (startDate(a) > startDate(b)) ? 1 : -1) COMMENT OUT because need to use the correct classes
          .map(function (blackout, index) {
            var dates = format(startDate(blackout)) === format(endDate(blackout)) ? _react2.default.createElement(
              'span',
              { className: classes[index + '-endDate'] },
              format(startDate(blackout))
            ) : _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { className: classes[index + '-startDate'] },
                format(startDate(blackout))
              ),
              _react2.default.createElement(
                'span',
                { className: classes[index + '-endDate'] },
                blackout.endDate ? '- ' + format(endDate(blackout)) : ''
              )
            );
            return _react2.default.createElement(
              'div',
              {
                style: { marginBottom: '12px' },
                key: index,
                className: classes[index + '-blackout']
              },
              _react2.default.createElement(
                'small',
                { className: classes[index + '-name'] },
                blackout.name ? blackout.name.toUpperCase() : ''
              ),
              dates ? _react2.default.createElement(
                'div',
                null,
                dates
              ) : _react2.default.createElement(
                'div',
                {
                  style: { color: '#f44336', cursor: 'pointer' },
                  onClick: editBlackoutsFn
                },
                'Complete Blackout Dates'
              )
            );
          })
        ) : _react2.default.createElement(_addItemCard2.default, {
          text: 'Add blackout days',
          onClick: function onClick() {
            return openAddEditContractDialog({
              type: 'blackouts',
              title: 'Add Blackout Days'
            });
          },
          editable: supplierEditable
        })
      );
    }
  }]);

  return RightTwoBlackouts;
}(_react.Component);

RightTwoBlackouts.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref3, _ref4) {
  var contracting = _ref3.contracting;
  var reducerName = _ref4.reducerName,
      blackouts = _ref4.blackouts;

  if (blackouts) return { blackouts: blackouts };
  return {
    blackouts: contracting[reducerName].getIn(['rightSideContent', 'blackouts']) ? contracting[reducerName].getIn(['rightSideContent', 'blackouts']).toJS() : []
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(RightTwoBlackouts);

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PickupDropoffDisplay = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _materialUi = __webpack_require__(3);

var _singlePickupDropoff = __webpack_require__(3431);

var _singlePickupDropoff2 = _interopRequireDefault(_singlePickupDropoff);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  pickup: _react.PropTypes.array,
  dropoff: _react.PropTypes.array,
  openAddEditContractDialog: _react.PropTypes.func,
  productType: _react.PropTypes.string,
  supplierEditable: _react.PropTypes.bool,
  contractState: _react.PropTypes.string,
  existingSeasons: _react.PropTypes.array,
  hideHeader: _react.PropTypes.bool,
  classes: _react.PropTypes.object,

  arrayData: _react.PropTypes.array,
  pickupOrDropoff: _react.PropTypes.string
};
var PickupDropoffDisplay = exports.PickupDropoffDisplay = function PickupDropoffDisplay(props) {
  var hideHeader = props.hideHeader,
      _props$classes = props.classes,
      classes = _props$classes === undefined ? {} : _props$classes,
      openAddEditContractDialog = props.openAddEditContractDialog,
      supplierEditable = props.supplierEditable,
      _props$arrayData = props.arrayData,
      arrayData = _props$arrayData === undefined ? [] : _props$arrayData,
      _props$existingSeason = props.existingSeasons,
      existingSeasons = _props$existingSeason === undefined ? [] : _props$existingSeason,
      pickupOrDropoff = props.pickupOrDropoff;

  if (!arrayData.length) return _react2.default.createElement('div', null);
  return _react2.default.createElement(
    _mouseOverEditDiv2.default,
    {
      className: classes.main,
      regularDiv: arrayData.length > 1 && _ramda2.default.any(_ramda2.default.compose(_ramda2.default.isEmpty, _ramda2.default.prop('dateRanges')), existingSeasons),
      hintOnRight: true,
      editable: supplierEditable,
      singleLineTitle: true,
      actionButtons: _react2.default.createElement(_editButton2.default, {
        onEdit: function onEdit() {
          openAddEditContractDialog({
            type: 'pickupDropoff',
            title: pickupOrDropoff === 'pickup' ? 'Edit Pick-up / Opening Information' : 'Edit Drop-off / Closing Information',
            data: {
              pickupOrDropoff: pickupOrDropoff
            }
          });
        }
      })
    },
    !hideHeader && _react2.default.createElement(
      _helperLink2.default,
      { value: pickupOrDropoff },
      pickupOrDropoff === 'pickup' ? 'Pick Up / Opening' : 'Drop Off / Closing'
    ),
    !hideHeader && _react2.default.createElement('br', null),
    arrayData.map(function (ele, index) {
      var data = arrayData.length === existingSeasons.length && arrayData.length > 1 ? existingSeasons[index] : ele;

      var _ref = data || ele,
          dateRanges = _ref.dateRanges;

      return _react2.default.createElement(_singlePickupDropoff2.default, _extends({ key: index, index: index }, (0, _ramda.merge)(ele, { dateRanges: dateRanges, classes: classes })));
    })
  );
};
PickupDropoffDisplay.propTypes = propTypes;

var RightFourPickUpDropOff = function (_Component) {
  _inherits(RightFourPickUpDropOff, _Component);

  function RightFourPickUpDropOff() {
    _classCallCheck(this, RightFourPickUpDropOff);

    return _possibleConstructorReturn(this, (RightFourPickUpDropOff.__proto__ || Object.getPrototypeOf(RightFourPickUpDropOff)).apply(this, arguments));
  }

  _createClass(RightFourPickUpDropOff, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          openAddEditContractDialog = _props.openAddEditContractDialog,
          supplierEditable = _props.supplierEditable,
          _props$pickup = _props.pickup,
          pickup = _props$pickup === undefined ? [] : _props$pickup,
          _props$dropoff = _props.dropoff,
          dropoff = _props$dropoff === undefined ? [] : _props$dropoff,
          productType = _props.productType;

      if (productType === 'Accommodation') return _react2.default.createElement('div', null);
      var fontFamily = "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif";
      return _react2.default.createElement(
        'div',
        { style: { fontFamily: fontFamily }, id: 'pickupDropoff' },
        _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '24px', marginBottom: '16px' } }),
        pickup && pickup.length ? _react2.default.createElement(PickupDropoffDisplay, _extends({}, this.props, { pickupOrDropoff: 'pickup', arrayData: pickup })) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _helperLink2.default,
            { value: 'pickup', labelStyle: { marginBottom: '12px' } },
            'Pick Up / Opening'
          ),
          _react2.default.createElement(_addItemCard2.default, {
            onClick: function onClick() {
              return openAddEditContractDialog({
                type: 'pickupDropoff',
                title: 'Add Pick-up / Opening Information',
                data: {
                  pickupOrDropoff: 'pickup'
                }
              });
            },
            text: 'Add pick-up / opening information',
            editable: supplierEditable
          })
        ),
        _react2.default.createElement('br', null),
        dropoff && dropoff.length ? _react2.default.createElement(PickupDropoffDisplay, _extends({}, this.props, { pickupOrDropoff: 'dropoff', arrayData: dropoff })) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _helperLink2.default,
            { value: 'dropoff', labelStyle: { marginBottom: '12px' } },
            'Drop Off / Closing'
          ),
          _react2.default.createElement(_addItemCard2.default, {
            onClick: function onClick() {
              return openAddEditContractDialog({
                type: 'pickupDropoff',
                title: 'Add Drop-off / Closing Information',
                data: {
                  pickupOrDropoff: 'dropoff'
                }
              });
            },
            text: 'Add drop-off / closing information',
            editable: supplierEditable
          })
        )
      );
    }
  }]);

  return RightFourPickUpDropOff;
}(_react.Component);

RightFourPickUpDropOff.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
  var contracting = _ref2.contracting;
  var reducerName = _ref3.reducerName,
      pickup = _ref3.pickup,
      dropoff = _ref3.dropoff;

  if (pickup) return { pickup: pickup };
  if (dropoff) return { dropoff: dropoff };
  return {
    pickup: contracting[reducerName].getIn(['rightSideContent', 'pickup']) ? contracting[reducerName].getIn(['rightSideContent', 'pickup']).toJS() : [],
    dropoff: contracting[reducerName].getIn(['rightSideContent', 'dropoff']) ? contracting[reducerName].getIn(['rightSideContent', 'dropoff']).toJS() : []
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(RightFourPickUpDropOff);

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _filterList = __webpack_require__(2022);

var _filterList2 = _interopRequireDefault(_filterList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var array = _propTypes2.default.array,
    bool = _propTypes2.default.bool,
    element = _propTypes2.default.element,
    func = _propTypes2.default.func,
    instanceOf = _propTypes2.default.instanceOf,
    object = _propTypes2.default.object,
    oneOfType = _propTypes2.default.oneOfType,
    string = _propTypes2.default.string;

var FilterButton = function (_Component) {
  _inherits(FilterButton, _Component);

  function FilterButton(props) {
    _classCallCheck(this, FilterButton);

    var _this = _possibleConstructorReturn(this, (FilterButton.__proto__ || Object.getPrototypeOf(FilterButton)).call(this, props));

    _this.handleClick = function (event) {
      _this.props.onButtonClick();

      _this.setState({
        anchorEl: event.currentTarget,
        isOpen: true
      });
    };

    _this.handleRequestClose = function () {
      _this.props.onButtonClick();
      _this.setState({ isOpen: false });
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(FilterButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          items = _props.items,
          onFilterChange = _props.onFilterChange,
          controlOpenStateFromProps = _props.controlOpenStateFromProps;

      var _ref = controlOpenStateFromProps ? this.props : this.state,
          isOpen = _ref.isOpen;

      return _react2.default.createElement(
        'div',
        { style: _extends({}, this.props.style) },
        _react2.default.createElement(_materialUi.FlatButton, {
          backgroundColor: 'rgba(0,0,0,0.04)',
          icon: _react2.default.createElement(_filterList2.default, null),
          label: this.props.filterLabel || 'Filter',
          labelPosition: 'after',
          onClick: this.handleClick
        }),
        _react2.default.createElement(
          _materialUi.Popover,
          {
            open: isOpen,
            anchorEl: this.state.anchorEl,
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            targetOrigin: { horizontal: 'right', vertical: 'top' },
            onRequestClose: this.handleRequestClose
          },
          children ? children : _react2.default.createElement(
            _materialUi.List,
            null,
            items.map(function (item, i) {
              return _react2.default.createElement(_materialUi.ListItem, {
                key: i,
                onClick: function onClick() {
                  return onFilterChange(i, item);
                },
                primaryTogglesNestedList: true,
                primaryText: item.label
              });
            })
          )
        )
      );
    }
  }]);

  return FilterButton;
}(_react.Component);

FilterButton.propTypes = {
  children: oneOfType([instanceOf(_materialUi.List), object]),
  filterLabel: oneOfType([element, string]),
  isOpen: bool,
  items: array,
  onButtonClick: func,
  onFilterChange: func,
  onItemSelect: func,
  style: object,
  controlOpenStateFromProps: bool
};

exports.default = FilterButton;

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentFilterList = function ContentFilterList(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z' })
  );
};
ContentFilterList = (0, _pure2.default)(ContentFilterList);
ContentFilterList.displayName = 'ContentFilterList';
ContentFilterList.muiName = 'SvgIcon';

exports.default = ContentFilterList;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _textDff = __webpack_require__(1565);

var _textDff2 = _interopRequireDefault(_textDff);

var _policyNotesElements = __webpack_require__(3498);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  typeContainer: {
    marginTop: '32px'
  },
  subHeader: {
    fontSize: '24px',
    fontWeight: 400,
    marginTop: '4px',
    paddingBottom: '12px',
    borderBottom: '1px solid #e6e9ec'
  },
  singleDiffContainer: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  lhsContainer: {
    width: '45%',
    padding: '16px 4px'
  },
  rhsContainer: {
    marginLeft: '5%',
    width: '45%',
    padding: '16px 4px'
  }
};
var propTypes = {
  diffBlock: _react2.default.PropTypes.object,
  classes: _react2.default.PropTypes.object,
  label: _react2.default.PropTypes.string,
  type: _react2.default.PropTypes.string
};

var PoliciesNotesDiffing = function (_React$Component) {
  _inherits(PoliciesNotesDiffing, _React$Component);

  function PoliciesNotesDiffing() {
    _classCallCheck(this, PoliciesNotesDiffing);

    return _possibleConstructorReturn(this, (PoliciesNotesDiffing.__proto__ || Object.getPrototypeOf(PoliciesNotesDiffing)).apply(this, arguments));
  }

  _createClass(PoliciesNotesDiffing, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react2.default.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          diffBlock = _props.diffBlock,
          classes = _props.classes,
          label = _props.label,
          type = _props.type;
      var singleDiffContainer = classes.singleDiffContainer,
          lhsContainer = classes.lhsContainer,
          rhsContainer = classes.rhsContainer,
          typeContainer = classes.typeContainer,
          subHeader = classes.subHeader;

      if (type !== 'checkInCheckOut') {
        return _react2.default.createElement(
          'div',
          { id: 'policyNotes' + type, className: typeContainer },
          _react2.default.createElement(
            'div',
            { className: subHeader },
            ' ',
            label
          ),
          _ramda2.default.keys(diffBlock).map(function (subType) {
            var lhsData = _ramda2.default.path([subType, 'originalData', 'lhs'], diffBlock);
            var rhsData = _ramda2.default.path([subType, 'originalData', 'rhs'], diffBlock);
            var diffData = _ramda2.default.path([subType, 'diff'], diffBlock);
            var isString = _ramda2.default.is(String, lhsData) || _ramda2.default.is(String, rhsData);
            return _react2.default.createElement(
              'div',
              { key: subType },
              _react2.default.createElement(
                'div',
                { style: { fontSize: '16px', margin: '16px 0', fontWeight: 'bold' } },
                _ramda2.default.path([subType, 'label'], diffBlock)
              ),
              _react2.default.createElement(
                'div',
                { className: singleDiffContainer },
                _react2.default.createElement(
                  'div',
                  { className: lhsContainer },
                  _ramda2.default.call(_ramda2.default.cond([[function () {
                    return isString;
                  }, _ramda2.default.always(_react2.default.createElement(_textDff2.default, _extends({ isLeft: true }, diffData[0])))], [function () {
                    return type === 'policies';
                  }, _ramda2.default.always(_react2.default.createElement(_policyNotesElements.LocPolicyDiff, _extends({ isLeft: true, policyType: subType }, diffBlock[subType])))], [function () {
                    return subType === 'billing';
                  }, _ramda2.default.always(_react2.default.createElement(_policyNotesElements.BillingDiff, _extends({ isLeft: true }, diffBlock[subType])))], [function () {
                    return subType === 'insurance';
                  }, _ramda2.default.always(_react2.default.createElement(_policyNotesElements.InsuranceDiff, _extends({ isLeft: true }, diffBlock[subType])))]]))
                ),
                _react2.default.createElement(
                  'div',
                  { className: rhsContainer },
                  _ramda2.default.call(_ramda2.default.cond([[function () {
                    return isString;
                  }, _ramda2.default.always(_react2.default.createElement(_textDff2.default, _extends({ isLeft: false }, diffData[0])))], [function () {
                    return type === 'policies';
                  }, _ramda2.default.always(_react2.default.createElement(_policyNotesElements.LocPolicyDiff, _extends({ isLeft: false, policyType: subType }, diffBlock[subType])))], [function () {
                    return subType === 'billing';
                  }, _ramda2.default.always(_react2.default.createElement(_policyNotesElements.BillingDiff, _extends({ isLeft: false }, diffBlock[subType])))], [function () {
                    return subType === 'insurance';
                  }, _ramda2.default.always(_react2.default.createElement(_policyNotesElements.InsuranceDiff, _extends({ isLeft: false }, diffBlock[subType])))]]))
                )
              )
            );
          })
        );
      }
      return _react2.default.createElement(
        'section',
        { id: 'policyNotes' + type, className: typeContainer },
        _react2.default.createElement(
          'div',
          { className: subHeader },
          ' ',
          label
        ),
        _react2.default.createElement(
          'div',
          { className: singleDiffContainer },
          _react2.default.createElement(
            'div',
            { className: lhsContainer },
            _react2.default.createElement(_policyNotesElements.CheckInCheckOutDiff, _extends({ isLeft: true }, diffBlock))
          ),
          _react2.default.createElement(
            'div',
            { className: rhsContainer },
            _react2.default.createElement(_policyNotesElements.CheckInCheckOutDiff, _extends({ isLeft: false }, diffBlock))
          )
        )
      );
    }
  }]);

  return PoliciesNotesDiffing;
}(_react2.default.Component);

PoliciesNotesDiffing.propTypes = propTypes;
exports.default = (0, _reactJss2.default)(styles)(PoliciesNotesDiffing);

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClassesForType2 = exports.ProductPolicyDiff = exports.PickupDropoffDiff = exports.ExtrasDiff = exports.OffersDiff = exports.SeasonRatesDiff = exports.BlackoutsDiff = exports.AllocationDiff = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _textDff = __webpack_require__(1565);

var _textDff2 = _interopRequireDefault(_textDff);

var _rightOne = __webpack_require__(2018);

var _rightOne2 = _interopRequireDefault(_rightOne);

var _rightTwoBlackouts = __webpack_require__(2019);

var _rightTwoBlackouts2 = _interopRequireDefault(_rightTwoBlackouts);

var _seasonForSeasonRates = __webpack_require__(2015);

var _seasonForSeasonRates2 = _interopRequireDefault(_seasonForSeasonRates);

var _rateTableTemplateContainer = __webpack_require__(632);

var _rateTableTemplateContainer2 = _interopRequireDefault(_rateTableTemplateContainer);

var _leftFourOffers = __webpack_require__(2016);

var _leftFourOffers2 = _interopRequireDefault(_leftFourOffers);

var _leftExtras = __webpack_require__(2017);

var _leftExtras2 = _interopRequireDefault(_leftExtras);

var _rightFourPickupDropoff = __webpack_require__(2020);

var _policyMain = __webpack_require__(1562);

var _policyMain2 = _interopRequireDefault(_policyMain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var AllocationDiff = exports.AllocationDiff = function AllocationDiff(_ref) {
  var diff = _ref.diff,
      isLeft = _ref.isLeft,
      originalData = _ref.originalData;

  var data = isLeft ? originalData.lhs : originalData.rhs;
  var classes = getClassesForType2(isLeft, diff, originalData, 'allocation', ['allotments', 'dateRanges']);
  return _react2.default.createElement(_rightOne2.default, {
    classes: classes,
    allocation: data
  });
};

var BlackoutsDiff = exports.BlackoutsDiff = function BlackoutsDiff(_ref2) {
  var diff = _ref2.diff,
      isLeft = _ref2.isLeft,
      originalData = _ref2.originalData;

  var data = isLeft ? originalData.lhs : originalData.rhs;
  return _react2.default.createElement(_rightTwoBlackouts2.default, {
    classes: getClassesForType2(isLeft, diff, originalData, 'blackout', []),
    blackouts: data
  });
};

var SeasonRatesDiff = function SeasonRatesDiff(_ref3) {
  var isLeft = _ref3.isLeft,
      season = _ref3.season,
      seasonName = _ref3.seasonName,
      rateSets = _ref3.rateSets,
      productType = _ref3.productType,
      kind = _ref3.kind;

  var thisRateSets = _ramda2.default.pathOr([], ['originalData', isLeft ? 'lhs' : 'rhs'], rateSets);
  var thisDateRanges = _ramda2.default.pathOr([], ['originalData', isLeft ? 'lhs' : 'rhs'], season);
  if (kind === 'D' && !isLeft) return _react2.default.createElement('div', null);
  if (kind === 'N' && isLeft) return _react2.default.createElement('div', null);
  var mainClass = function () {
    if (kind === 'D' || kind === 'N') return isLeft ? 'diff-block-deleted' : 'diff-block-added';
  }();
  var seasonClasses = function () {
    return _ramda2.default.propOr([], 'diff', season).reduce(function (classes, _ref4) {
      var path = _ref4.path,
          index = _ref4.index,
          kind = _ref4.kind,
          item = _ref4.item,
          extra = _objectWithoutProperties(_ref4, ['path', 'index', 'kind', 'item']);

      if (!path) {
        if (!item) console.log(_extends({ kind: kind }, extra), season);
        if (item && item.kind === 'D' && isLeft) classes[index + '-dateRange'] = 'diff-deleted';
        if (item && item.kind === 'N' && !isLeft) classes[index + '-dateRange'] = 'diff-added';
      } else {
        classes[path.join('-')] = isLeft ? 'diff-deleted' : 'diff-added';
      }
      return classes;
    }, {});
  }();
  var rateSetsClasses = function () {
    return getClassesForRatesEntities(isLeft, rateSets.diff, rateSets.originalData, 'rateSet', []);
  }();
  return _react2.default.createElement(
    'div',
    {
      className: mainClass,
      style: { marginTop: '16px', paddingTop: '8px' }
    },
    !isNilOrEmpty(thisDateRanges) && _react2.default.createElement(_seasonForSeasonRates2.default, { seasonName: seasonName, dateRanges: thisDateRanges, classes: seasonClasses }),
    thisRateSets.map(function (rateSet, rateSetsIndex) {
      return _react2.default.createElement(_rateTableTemplateContainer2.default, {
        productType: productType,
        key: rateSetsIndex,
        classes: _ramda2.default.merge(rateSetsClasses[rateSetsIndex + '-ratesClasses'], { main: rateSetsClasses[rateSetsIndex + '-rateSet'] }),
        rateSet: rateSet,
        rateSetsIndex: rateSetsIndex
      });
    })
  );
};

exports.SeasonRatesDiff = SeasonRatesDiff;
var OffersDiff = exports.OffersDiff = function OffersDiff(_ref5) {
  var diff = _ref5.diff,
      isLeft = _ref5.isLeft,
      originalData = _ref5.originalData;

  var thisClasses = function () {
    var nonRateTableKeys = ['offerName', 'bookingCode', 'offerDetail', 'specialConditions', 'allowCombination', 'offerType', 'isStayPay', 'stayPays', 'numberOfGuests', 'rate', 'discountType', 'amount', 'validDatesOfSale', 'validDatesOfTravel'];
    return getClassesForRatesEntities(isLeft, diff, originalData, 'offer', nonRateTableKeys);
  }();
  var data = isLeft ? originalData.lhs : originalData.rhs;
  return _react2.default.createElement(_leftFourOffers2.default, {
    inDiffing: true,
    offers: data,
    classes: thisClasses
  });
};

var ExtrasDiff = exports.ExtrasDiff = function ExtrasDiff(_ref6) {
  var diff = _ref6.diff,
      isLeft = _ref6.isLeft,
      originalData = _ref6.originalData;

  var extrasClasses = function () {
    return getClassesForRatesEntities(isLeft, diff, originalData, 'extra', ['extraType', 'extraCode', 'description']);
  }();
  var data = isLeft ? originalData.lhs : originalData.rhs;
  return _react2.default.createElement(_leftExtras2.default, {
    hideHeader: true,
    showBorder: true,
    extras: data,
    classes: extrasClasses
  });
};

var PickupDropoffDiff = exports.PickupDropoffDiff = function PickupDropoffDiff(_ref7) {
  var diff = _ref7.diff,
      isLeft = _ref7.isLeft,
      originalData = _ref7.originalData;

  var data = isLeft ? originalData.lhs : originalData.rhs;
  var classes = getClassesForType2(isLeft, diff, originalData, 'pickupdropoff', ['timeLocArray', 'dateRanges']);
  return _react2.default.createElement(_rightFourPickupDropoff.PickupDropoffDisplay, {
    arrayData: data,
    hideHeader: true,
    classes: classes
  });
};

var ProductPolicyDiff = exports.ProductPolicyDiff = function ProductPolicyDiff(_ref8) {
  var diff = _ref8.diff,
      isLeft = _ref8.isLeft,
      originalData = _ref8.originalData,
      type = _ref8.type;

  var thisClasses = getClassesForType2(isLeft, diff, originalData, 'prod-cancellation', ['dateRanges']);
  var data = isLeft ? originalData.lhs : originalData.rhs;
  return _react2.default.createElement(_policyMain2.default, {
    policyType: type,
    policyProps: _defineProperty({
      hideLabel: true,
      classes: thisClasses
    }, type + 'Info', type === 'cancellation' ? { cancellations: data } : _extends({}, data))
  });
};

// Type 1: rateSets, offers, extras
var getClassesForRatesEntities = function getClassesForRatesEntities(isLeft) {
  var diff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var originalData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var type = arguments[3];
  var nonRateTableKeys = arguments[4];

  if (isNilOrEmpty(originalData.rhs) || isNilOrEmpty(originalData.lhs)) {
    if (isLeft) return { main: 'diff-block-deleted' };
    if (!isLeft) return { main: 'diff-block-added' };
  }
  return diff.reduce(function (classes, _ref10) {
    var path = _ref10.path,
        index = _ref10.index,
        kind = _ref10.kind,
        item = _ref10.item,
        diffWords = _ref10.diffWords,
        extraArgs = _objectWithoutProperties(_ref10, ['path', 'index', 'kind', 'item', 'diffWords']);

    if (diffWords && diffWords.length) {
      classes[path.join('-') + '-textblock'] = _react2.default.createElement(_textDff2.default, _extends({ isLeft: isLeft, diffWords: diffWords }, extraArgs));
    }
    if (!path) {
      if (item.kind === 'D' && isLeft) classes[index + '-' + type] = 'diff-block-deleted';
      if (item.kind === 'N' && !isLeft) classes[index + '-' + type] = 'diff-block-added';
    } else {
      var typeIndex = path[0];
      var subKey = path[1];
      if (nonRateTableKeys.indexOf(subKey) > -1) {
        classes[path.join('-')] = isLeft ? 'diff-deleted' : 'diff-added';
      } else {
        if (!classes[typeIndex + '-ratesClasses']) classes[typeIndex + '-ratesClasses'] = {};
        if (subKey === 'rates') {
          if (item) {
            if (item.kind === 'D' && isLeft) classes[typeIndex + '-ratesClasses'][index + '-rate'] = 'diff-deleted';
            if (item.kind === 'N' && !isLeft) classes[typeIndex + '-ratesClasses'][index + '-rate'] = 'diff-added';
          } else {
            classes[typeIndex + '-ratesClasses'][path.slice(2, 8).join('-')] = isLeft ? 'diff-deleted' : 'diff-added';
          }
        } else {
          classes[typeIndex + '-ratesClasses'][path.slice(1, 8).join('-')] = isLeft ? 'diff-deleted' : 'diff-added';
        }
      }
    }
    return classes;
  }, {});
};

// Type 2: allocation, pickup, dropoff, blackouts
var getClassesForType2 = function getClassesForType2(isLeft) {
  var diff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var originalData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var type = arguments[3];
  var nestedArrayKeys = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  if (isNilOrEmpty(originalData.rhs) || isNilOrEmpty(originalData.lhs)) {
    if (isLeft) return { main: 'diff-block-deleted' };
    if (!isLeft) return { main: 'diff-block-added' };
  }
  return diff.reduce(function (classes, _ref11) {
    var path = _ref11.path,
        index = _ref11.index,
        kind = _ref11.kind,
        item = _ref11.item,
        diffWords = _ref11.diffWords,
        extraArgs = _objectWithoutProperties(_ref11, ['path', 'index', 'kind', 'item', 'diffWords']);

    if (diffWords && diffWords.length) {
      classes[path.join('-') + '-textblock'] = _react2.default.createElement(_textDff2.default, _extends({ isLeft: isLeft, diffWords: diffWords }, extraArgs));
    }
    if (!path && item) {
      if (item.kind === 'D' && isLeft) classes[index + '-' + type] = 'diff-block-deleted';
      if (item.kind === 'N' && !isLeft) classes[index + '-' + type] = 'diff-block-added';
    } else {
      var firstKey = path[0];
      var subKey = _ramda2.default.is(Number, firstKey) ? path[1] : path[0];
      if (nestedArrayKeys.indexOf(subKey) > -1 && item) {
        if (item.kind === 'D' && isLeft) classes[path.join('-') + '-' + index] = 'diff-deleted';
        if (item.kind === 'N' && !isLeft) classes[path.join('-') + '-' + index] = 'diff-added';
      } else {
        classes[path.join('-')] = isLeft ? 'diff-deleted' : 'diff-added';
      }
    }
    return classes;
  }, {});
};
exports.getClassesForType2 = getClassesForType2;

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _ratePackageElements = __webpack_require__(2024);

var _sectionUpdateSummary = __webpack_require__(1262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  typeContainer: {
    marginTop: '32px'
  },
  subHeader: {
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 400,
    marginTop: '4px',
    paddingBottom: '12px',
    width: '90%',
    borderBottom: '1px solid #e6e9ec'
  },
  singleDiffContainer: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  lhsContainer: {
    width: '45%'
    // padding: '16px 4px',
  },
  rhsContainer: {
    marginLeft: '5%',
    width: '45%'
    // padding: '16px 4px',
  },
  subLabelsClass: {
    margin: '16px 0 0 20px'
  }
};

var propTypes = {
  diffBlock: _react2.default.PropTypes.object,
  classes: _react2.default.PropTypes.object,
  label: _react2.default.PropTypes.string,
  type: _react2.default.PropTypes.string,
  updateSummary: _react2.default.PropTypes.array,
  ratePackageId: _react2.default.PropTypes.string
};

var RatePackageDiffing = function (_React$Component) {
  _inherits(RatePackageDiffing, _React$Component);

  function RatePackageDiffing() {
    _classCallCheck(this, RatePackageDiffing);

    return _possibleConstructorReturn(this, (RatePackageDiffing.__proto__ || Object.getPrototypeOf(RatePackageDiffing)).apply(this, arguments));
  }

  _createClass(RatePackageDiffing, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react2.default.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          diffBlock = _props.diffBlock,
          classes = _props.classes,
          label = _props.label,
          type = _props.type,
          updateSummary = _props.updateSummary,
          ratePackageId = _props.ratePackageId;
      var singleDiffContainer = classes.singleDiffContainer,
          lhsContainer = classes.lhsContainer,
          rhsContainer = classes.rhsContainer,
          typeContainer = classes.typeContainer,
          subHeader = classes.subHeader;

      var policies = ['cancellation', 'child', 'infant', 'family', 'freeOfCharge', 'group'];
      var ComponentBlock = _ramda2.default.call(_ramda2.default.cond([[function () {
        return type === 'allocation';
      }, _ramda2.default.always(_ratePackageElements.AllocationDiff)], [function () {
        return type === 'extras';
      }, _ramda2.default.always(_ratePackageElements.ExtrasDiff)], [function () {
        return type === 'blackouts';
      }, _ramda2.default.always(_ratePackageElements.BlackoutsDiff)], [function () {
        return type === 'pickup' || type === 'dropoff';
      }, _ramda2.default.always(_ratePackageElements.PickupDropoffDiff)], [function () {
        return type === 'offers';
      }, _ramda2.default.always(_ratePackageElements.OffersDiff)], [function () {
        return policies.indexOf(type) > -1;
      }, _ramda2.default.always(_ratePackageElements.ProductPolicyDiff)], [function () {
        return diffBlock.season || diffBlock.rateSets;
      }, _ramda2.default.always(_ratePackageElements.SeasonRatesDiff)], [_ramda2.default.T, _ramda2.default.always(null)]]));
      return _react2.default.createElement(
        'section',
        { id: '' + ratePackageId + type, className: typeContainer },
        _react2.default.createElement(
          'div',
          { className: subHeader },
          label
        ),
        Boolean(ComponentBlock) && _react2.default.createElement(
          'div',
          { className: singleDiffContainer },
          _react2.default.createElement(
            'div',
            { className: lhsContainer },
            _react2.default.createElement(ComponentBlock, _extends({ isLeft: true }, diffBlock, { type: type }))
          ),
          _react2.default.createElement(
            'div',
            { className: rhsContainer },
            _react2.default.createElement(ComponentBlock, _extends({ isLeft: false }, diffBlock, { type: type }))
          )
        )
      );
    }
  }]);

  return RatePackageDiffing;
}(_react2.default.Component);

exports.default = (0, _reactJss2.default)(styles)(RatePackageDiffing);

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRouterRedux = __webpack_require__(27);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  initialBaseDocId: _react.PropTypes.string,
  initialCompareDocId: _react.PropTypes.string,
  collection: _react.PropTypes.string,
  replace: _react.PropTypes.func,
  params: _react.PropTypes.object,
  availDocs: _react.PropTypes.array,
  inHeader: _react.PropTypes.bool,
  loadingDocs: _react.PropTypes.bool
};
var styles = {
  container: { margin: '16px auto' },
  selectionContainer: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  compareDocContainer: {
    width: '48%'
  },
  baseDocContainer: {
    width: '48%',
    marginLeft: '4%'
  },
  flexEnd: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
};

var DocSelector = function (_React$Component) {
  _inherits(DocSelector, _React$Component);

  function DocSelector(props) {
    _classCallCheck(this, DocSelector);

    var _this2 = _possibleConstructorReturn(this, (DocSelector.__proto__ || Object.getPrototypeOf(DocSelector)).call(this, props));

    _initialiseProps.call(_this2);

    _this2.state = _this2.getInitialState(props);
    return _this2;
  }

  _createClass(DocSelector, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(this.state.baseData && this.state.baseData.doc)) {
        this.setState(this.getInitialState(nextProps));
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          classes = _props.classes,
          replace = _props.replace,
          _props$availDocs = _props.availDocs,
          availDocs = _props$availDocs === undefined ? [] : _props$availDocs,
          collection = _props.collection,
          inHeader = _props.inHeader,
          loadingDocs = _props.loadingDocs;

      if (loadingDocs) return _react2.default.createElement(_materialUi.CircularProgress, { size: 40, style: { marginLeft: '50%' } });

      var _ref = this.state || {},
          _ref$baseData = _ref.baseData,
          baseData = _ref$baseData === undefined ? {} : _ref$baseData,
          _ref$compareData = _ref.compareData,
          compareData = _ref$compareData === undefined ? {} : _ref$compareData;

      var sortByStartDateDsc = _ramda2.default.sort(_ramda2.default.descend(_ramda2.default.prop('startDate')), availDocs);
      var compareDocId = _ramda2.default.path(['compareData', 'docId'], this.state);
      var baseDocId = _ramda2.default.path(['baseData', 'docId'], this.state);
      var locationId = _ramda2.default.path(['baseData', 'doc', 'locationId'], this.state);
      var allContractingYears = _ramda2.default.uniq(sortByStartDateDsc.map(this.getYearString));
      var container = classes.container,
          selectionContainer = classes.selectionContainer,
          compareDocContainer = classes.compareDocContainer,
          baseDocContainer = classes.baseDocContainer;

      var versionsKey = collection === 'template' ? 'templateVersions' : 'versions';
      var types = [{
        stateKey: 'compareData',
        className: compareDocContainer,
        stateData: compareData
      }, {
        stateKey: 'baseData',
        className: baseDocContainer,
        stateData: baseData
      }];
      var isForContract = collection === 'contract';
      return _react2.default.createElement(
        'div',
        { className: container, style: { width: inHeader ? '90%' : '80%', marginLeft: inHeader ? '1%' : 'auto', fontSize: inHeader ? '12px' : '14px' } },
        _react2.default.createElement(
          'div',
          { className: selectionContainer },
          types.map(function (_ref2, i) {
            var stateKey = _ref2.stateKey,
                className = _ref2.className,
                stateData = _ref2.stateData;
            var docYear = stateData.docYear,
                _stateData$doc = stateData.doc,
                doc = _stateData$doc === undefined ? {} : _stateData$doc,
                docId = stateData.docId,
                docVersion = stateData.docVersion;

            return _react2.default.createElement(
              'div',
              { className: className, key: i, style: { display: isForContract ? 'flex' : 'block' } },
              isForContract ? _react2.default.createElement(_reactSelect2.default, {
                wrapperStyle: { width: '70%' },
                options: sortByStartDateDsc.map(function (obj) {
                  return { value: _this3.getYearValue(obj), doc: obj, label: _this3.getYearString(obj) };
                }),
                optionRenderer: function optionRenderer(option) {
                  return _react2.default.createElement(
                    'span',
                    null,
                    option.label,
                    ' ',
                    _react2.default.createElement(
                      'small',
                      null,
                      '\xA0\xA0Last updated on: ',
                      (0, _moment2.default)(option.doc.updatedAt).format('l')
                    )
                  );
                },
                value: docYear,
                onChange: function onChange(optionItem) {
                  _this3.update(stateKey, {
                    docYear: optionItem.value,
                    docId: optionItem.doc._id,
                    doc: optionItem.doc,
                    docVersion: -1
                  });
                },
                placeholder: 'Please select a contracting period',
                clearable: false
              }) : _react2.default.createElement(_reactSelect2.default, {
                wrapperStyle: { width: '100%' },
                options: allContractingYears.map(function (str) {
                  return { value: str, label: str };
                }),
                value: docYear,
                onChange: function onChange(_ref3) {
                  var value = _ref3.value;
                  return _this3.update(stateKey, { docYear: value, doc: {}, docId: null, docVersion: null });
                },
                placeholder: 'Please select a contracting period',
                clearable: false
              }),
              _react2.default.createElement(
                'div',
                { style: { width: isForContract ? '30%' : '100%', display: 'flex' } },
                Boolean(docYear) && !isForContract && _react2.default.createElement(_reactSelect2.default, {
                  wrapperStyle: { width: '65%' },
                  options: _this3.getDocsByYear(docYear).map(function (obj) {
                    return { value: obj.templateName, doc: obj, label: obj.templateName };
                  }),
                  value: doc.templateName,
                  onChange: function onChange(optionItem) {
                    _this3.update(stateKey, {
                      docId: optionItem.doc._id,
                      doc: optionItem.doc,
                      docVersion: -1
                    });
                  },
                  placeholder: 'Please select a ' + collection,
                  clearable: false
                }),
                Boolean(docId) && _react2.default.createElement(_reactSelect2.default, {
                  wrapperStyle: { width: isForContract ? '100%' : '35%' },
                  options: _ramda2.default.prepend({ value: -1, label: 'Version ' + ((doc[versionsKey] || []).length + 1) + ' (Latest)', versionId: doc._id }, _ramda2.default.reverse(doc[versionsKey] || []).map(function (versionId, i, arr) {
                    return { value: arr.length - i - 1, versionId: versionId, label: 'Version ' + (arr.length - i) };
                  })),
                  value: docVersion,
                  onChange: function onChange(_ref4) {
                    var value = _ref4.value,
                        versionId = _ref4.versionId;
                    return _this3.update(stateKey, { docVersion: value, docId: versionId });
                  },
                  placeholder: 'Version',
                  clearable: false
                })
              )
            );
          })
        ),
        inHeader ? _react2.default.createElement(
          'div',
          { style: { display: this.state.updated ? 'block' : 'none', margin: '8px auto', float: 'right' } },
          _react2.default.createElement(_materialUi.RaisedButton, {
            label: 'Cancel',
            onTouchTap: function onTouchTap() {
              return _this3.setState(_extends({}, _this3.state.initialData, { updated: false }));
            }
          }),
          _react2.default.createElement(_materialUi.RaisedButton, {
            label: 'Update',
            disabled: !(compareDocId && baseDocId),
            style: { marginLeft: '8px' },
            secondary: true,
            onTouchTap: function onTouchTap() {
              _this3.setState({ updated: false });
              replace('/contracting/reports/diff/' + collection + '/' + baseDocId + '/' + compareDocId + '?locationId=' + locationId);
            }
          })
        ) : _react2.default.createElement(_materialUi.RaisedButton, {
          label: 'Generate Diff Report',
          disabled: !(compareDocId && baseDocId),
          style: { marginLeft: '43%', marginTop: '24px' },
          secondary: true,
          onTouchTap: function onTouchTap() {
            return replace('/contracting/reports/diff/' + collection + '/' + baseDocId + '/' + compareDocId + '?locationId=' + locationId);
          }
        })
      );
    }
  }]);

  return DocSelector;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getInitialState = function (props) {
    var availDocs = props.availDocs,
        initialBaseDocId = props.initialBaseDocId,
        initialCompareDocId = props.initialCompareDocId,
        collection = props.collection;

    var versionsKey = collection === 'template' ? 'templateVersions' : 'versions';
    if (availDocs && availDocs.length) {
      var getDocById = function getDocById(id) {
        if (!id) return {};
        return availDocs.find(function (obj) {
          if (obj._id === id) return true;
          return obj[versionsKey] && obj[versionsKey].indexOf(id) > -1;
        });
      };
      var initialBaseDoc = getDocById(initialBaseDocId) || {};
      var initialCompareDoc = getDocById(initialCompareDocId) || {};
      var baseData = {
        docYear: _this4.getYearValue(initialBaseDoc),
        doc: initialBaseDoc,
        docId: initialBaseDocId,
        docVersion: initialBaseDocId === initialBaseDoc._id ? -1 : (initialBaseDoc[versionsKey] || []).findIndex(function (str) {
          return str === initialBaseDocId;
        })
      };
      var compareData = initialCompareDocId ? {
        docYear: _this4.getYearValue(initialCompareDoc),
        doc: initialCompareDoc,
        docId: initialCompareDocId,
        docVersion: initialCompareDocId === initialCompareDoc._id ? -1 : (initialCompareDoc[versionsKey] || []).findIndex(function (str) {
          return str === initialCompareDocId;
        })
      } : {};
      var data = {
        baseData: baseData,
        compareData: compareData
      };
      return _extends({
        initialData: data
      }, data);
    }
    return {};
  };

  this.getYearString = function () {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var dateFormat = function dateFormat(date) {
      return _moment2.default.utc(date).format('D MMM YYYY');
    };
    if (_this4.props.collection === 'contract') {
      var marketInfo = _ramda2.default.path(['supplierInfo', 'marketInfo'], obj);
      return dateFormat(obj.startDate) + ' - ' + dateFormat(obj.endDate) + (marketInfo ? ' (' + marketInfo + ')' : '') + ' ';
    }
    return dateFormat(obj.startDate) + ' - ' + dateFormat(obj.endDate);
  };

  this.getYearValue = function () {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (_this4.props.collection === 'contract') return obj._id;
    return _this4.getYearString(obj);
  };

  this.getDocsByYear = function (yearString) {
    return _this4.props.availDocs.filter(function (obj) {
      return _this4.getYearString(obj) === yearString;
    });
  };

  this.update = function (stateKey, obj) {
    var _this$setState;

    var _this = _this4;
    _this.setState((_this$setState = {}, _defineProperty(_this$setState, stateKey, _extends({}, _this.state[stateKey], obj)), _defineProperty(_this$setState, 'updated', true), _this$setState));
  };
};

var mapDispatchToProps = {
  replace: _reactRouterRedux.replace
};
DocSelector.propTypes = propTypes;
DocSelector.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _reactJss2.default)(styles)(DocSelector));

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionExtension = function ActionExtension(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z' })
  );
};
ActionExtension = (0, _pure2.default)(ActionExtension);
ActionExtension.displayName = 'ActionExtension';
ActionExtension.muiName = 'SvgIcon';

exports.default = ActionExtension;

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _delete = __webpack_require__(738);

var _delete2 = _interopRequireDefault(_delete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancelOrConfirm = function CancelOrConfirm(_ref) {
  var callingApi = _ref.callingApi,
      confirmFn = _ref.confirmFn,
      cancelFn = _ref.cancelFn,
      disableConfirmBtn = _ref.disableConfirmBtn,
      cancelLabel = _ref.cancelLabel,
      confirmLabel = _ref.confirmLabel,
      forDelete = _ref.forDelete;
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex', flexDirection: 'row-reverse', position: 'relative' } },
    _react2.default.createElement(_materialUi.FlatButton, {
      style: { minWidth: '68px', marginLeft: '8px' },
      label: cancelLabel || 'cancel',
      onTouchTap: cancelFn
    }),
    _react2.default.createElement(_raisedButtonWithLoader2.default, {
      style: { minWidth: '68px' },
      label: confirmLabel || 'confirm',
      disabled: disableConfirmBtn,
      icon: forDelete && _react2.default.createElement(_delete2.default, null),
      secondary: !forDelete,
      primary: forDelete,
      onTouchTap: confirmFn,
      loader: callingApi
    })
  );
};

CancelOrConfirm.propTypes = {
  callingApi: _react.PropTypes.bool,
  confirmFn: _react.PropTypes.func,
  cancelFn: _react.PropTypes.func
};

exports.default = CancelOrConfirm;

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionToday = function ActionToday(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z' })
  );
};
ActionToday = (0, _pure2.default)(ActionToday);
ActionToday.displayName = 'ActionToday';
ActionToday.muiName = 'SvgIcon';

exports.default = ActionToday;

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentFontDownload = function ContentFontDownload(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z' })
  );
};
ContentFontDownload = (0, _pure2.default)(ContentFontDownload);
ContentFontDownload.displayName = 'ContentFontDownload';
ContentFontDownload.muiName = 'SvgIcon';

exports.default = ContentFontDownload;

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _selectTemplate = __webpack_require__(2032);

var _selectTemplate2 = _interopRequireDefault(_selectTemplate);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TemplatesByLocationsForGroupWizard = function TemplatesByLocationsForGroupWizard(_ref) {
  var templates = _ref.templates,
      updateProps = _ref.updateProps,
      selectedTemplatesForGroup = _ref.selectedTemplatesForGroup,
      loadingForGroupWizard = _ref.loadingForGroupWizard;

  if (loadingForGroupWizard) {
    return _react2.default.createElement(
      'div',
      { style: { margin: '16px 0', paddingBottom: '8px', borderBottom: '1px solid #e0e0e0' } },
      _react2.default.createElement(_materialUi.CircularProgress, { style: { margin: 'auto' } })
    );
  }
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { margin: '16px 0', paddingBottom: '8px', borderBottom: '1px solid #e0e0e0' } },
      !selectedTemplatesForGroup.length ? _react2.default.createElement(
        'b',
        { style: { marginBottom: '16px' } },
        'Please select templates: '
      ) : _react2.default.createElement(
        'div',
        { style: { marginBottom: '16px', fontWeight: 'bold' } },
        'Templates included in this group:'
      ),
      selectedTemplatesForGroup.map(function (_ref2, i) {
        var _id = _ref2._id,
            templateName = _ref2.templateName,
            locationName = _ref2.locationName;
        return _react2.default.createElement(
          'div',
          { key: '' + i + templateName, style: { display: 'flex', alignItems: 'center', color: 'rgba(0, 0, 0, 0.54)', justifyContent: 'space-between' } },
          _react2.default.createElement(
            'div',
            { style: { height: '40px', display: 'flex', alignItems: 'center' } },
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-description', color: 'rgba(0, 0, 0, 0.54)' }),
            _react2.default.createElement(
              'div',
              null,
              locationName,
              _react2.default.createElement(
                'small',
                { style: { paddingLeft: '2px' } },
                '(',
                templateName,
                ')'
              )
            )
          ),
          _react2.default.createElement(_materialUi.RaisedButton, {
            style: { marginRight: '2px' },
            label: 'remove',
            labelStyle: { color: '#ff4081' },
            onTouchTap: function onTouchTap() {
              return updateProps({ selectedTemplatesForGroup: _ramda2.default.reject(_ramda2.default.propEq('_id', _id), selectedTemplatesForGroup) });
            }
          })
        );
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '16px', fontWeight: 'bold' } },
      templates.length && selectedTemplatesForGroup.length ? 'Additional templates you can add to the group:' : ''
    ),
    !templates.length ? 'You don\'t have templates available for this period.' : _react2.default.createElement(_selectTemplate2.default, {
      templates: templates,
      selectedTemplates: selectedTemplatesForGroup,
      label: 'Add To Group',
      selectedComponent: _react2.default.createElement(
        'div',
        { style: { width: '68px' } },
        'Added'
      ),
      onConfirm: function onConfirm(template) {
        return updateProps({ selectedTemplatesForGroup: _ramda2.default.append(template, selectedTemplatesForGroup) });
      }
    })
  );
};

exports.default = TemplatesByLocationsForGroupWizard;

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectTemplates = function (_Component) {
  _inherits(SelectTemplates, _Component);

  function SelectTemplates() {
    _classCallCheck(this, SelectTemplates);

    var _this = _possibleConstructorReturn(this, (SelectTemplates.__proto__ || Object.getPrototypeOf(SelectTemplates)).call(this));

    _this.onSelect = function (template) {
      return function () {
        _this.props.onConfirm(template);
      };
    };

    _this.onSearch = function (e) {
      return _this.setState({ searchInput: e.target.value });
    };

    _this.state = {
      searchInput: ''
    };
    return _this;
  }

  _createClass(SelectTemplates, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          templatesBeforeFilter = _props.templates,
          _props$selectedTempla = _props.selectedTemplates,
          selectedTemplates = _props$selectedTempla === undefined ? [] : _props$selectedTempla,
          label = _props.label,
          selectedComponent = _props.selectedComponent,
          style = _props.style;
      var searchInput = this.state.searchInput;

      var templates = searchInput ? templatesBeforeFilter.filter(function (obj) {
        return new RegExp(searchInput, 'i').test(obj.templateName) || new RegExp(searchInput, 'i').test(obj.locationName);
      }) : templatesBeforeFilter;
      var groupByLocations = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.groupBy(_ramda2.default.prop('locationId'))
      // R.reject(template => R.any(R.eqProps('locationId', template), selectedTemplates))
      ), templates);
      var locations = {};
      templates.forEach(function (_ref) {
        var locationId = _ref.locationId,
            locationName = _ref.locationName;

        if (!locations[locationId]) locations[locationId] = locationName;
      });
      return _react2.default.createElement(
        'div',
        { style: style },
        _react2.default.createElement('input', {
          placeholder: 'Search by template name or location name...',
          value: searchInput,
          onChange: this.onSearch,
          style: { width: '100%', marginBottom: '12px', padding: '8px' }
        }),
        Object.keys(locations).map(function (locId, locIndex) {
          return _react2.default.createElement(
            _materialUi.Card,
            {
              key: '' + locIndex + locId,
              initiallyExpanded: true,
              style: { boxShadow: 'none', borderBottom: '1px solid #e0e0e0' }
            },
            _react2.default.createElement(_materialUi.CardHeader, {
              actAsExpander: true,
              style: { padding: '6px' },
              showExpandableButton: true,
              title: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-location_on', color: 'rgba(0, 0, 0, 0.54)' }),
                locations[locId]
              )
            }),
            _react2.default.createElement(
              _materialUi.CardText,
              { expandable: true },
              groupByLocations[locId].map(function (template, templateIndex) {
                return _react2.default.createElement(
                  'div',
                  { key: templateIndex, style: { display: 'flex', marginLeft: '40px', justifyContent: 'space-between', alignItems: 'flex-start' } },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'flex-start', width: '60%', height: '48px', fontSize: '14px' } },
                    _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-description', color: 'rgba(0, 0, 0, 0.54)' }),
                    template.templateName
                  ),
                  (0, _moment2.default)(template.updatedAt).format('l'),
                  _ramda2.default.call(_ramda2.default.cond([[function () {
                    return selectedTemplates.some(function (obj) {
                      return obj._id === template._id;
                    });
                  }, _ramda2.default.always(selectedComponent)], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(_materialUi.RaisedButton, {
                    secondary: true,
                    style: { position: 'relative', top: '-8px' },
                    label: label,
                    onTouchTap: _this2.onSelect(template)
                  }))]]))
                );
              })
            )
          );
        })
      );
    }
  }]);

  return SelectTemplates;
}(_react.Component);

exports.default = SelectTemplates;

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _templateListActions = __webpack_require__(877);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _supplierWizardComplete = __webpack_require__(1057);

var _supplierWizardComplete2 = _interopRequireDefault(_supplierWizardComplete);

var _stepTwoTemplates = __webpack_require__(2031);

var _stepTwoTemplates2 = _interopRequireDefault(_stepTwoTemplates);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _materialUi = __webpack_require__(3);

var _stepOneNameDates = __webpack_require__(3512);

var _stepOneNameDates2 = _interopRequireDefault(_stepOneNameDates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var convertToYY = function convertToYY(_ref) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate;
  return _moment2.default.utc(startDate).format('MMM DD YYYY') + ' - ' + _moment2.default.utc(endDate).format('MMM DD YYYY');
};

var GroupWizard = function (_React$Component) {
  _inherits(GroupWizard, _React$Component);

  function GroupWizard() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, GroupWizard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = GroupWizard.__proto__ || Object.getPrototypeOf(GroupWizard)).call.apply(_ref2, [this].concat(args))), _this), _this.selectContractYear = function (_ref3) {
      var startDate = _ref3.startDate,
          endDate = _ref3.endDate;
      var _this$props = _this.props,
          updateProps = _this$props.updateProps,
          getTemplatesForGroupWizard = _this$props.getTemplatesForGroupWizard;

      updateProps({ newGroupStartDate: startDate, newGroupEndDate: endDate });
      getTemplatesForGroupWizard({ startDate: startDate, endDate: endDate });
    }, _this.goToStepTwo = function () {
      var _this$props2 = _this.props,
          updateProps = _this$props2.updateProps,
          newGroupName = _this$props2.newGroupName,
          newGroupStartDate = _this$props2.newGroupStartDate,
          newGroupEndDate = _this$props2.newGroupEndDate;

      var dataValid = _ramda2.default.call(_ramda2.default.allPass([function () {
        return newGroupStartDate;
      }, function () {
        return newGroupEndDate;
      }, function () {
        return newGroupName;
      }]));
      if (dataValid) updateProps({ groupWizardStep: 1 });else {
        updateProps({ createGroupError: 'Please fill out all required fields.' });
        (0, _lodash2.default)(function () {
          return updateProps({ createGroupError: '' });
        }, 4000)();
      }
    }, _this.createTemplateGroup = function () {
      var _this$props3 = _this.props,
          selectedTemplatesForGroup = _this$props3.selectedTemplatesForGroup,
          updateProps = _this$props3.updateProps,
          createTemplateGroup = _this$props3.createTemplateGroup,
          newGroupName = _this$props3.newGroupName,
          newGroupStartDate = _this$props3.newGroupStartDate,
          newGroupEndDate = _this$props3.newGroupEndDate;

      if (selectedTemplatesForGroup.length) {
        createTemplateGroup({ templates: selectedTemplatesForGroup, newGroupName: newGroupName, startDate: newGroupStartDate, endDate: newGroupEndDate });
      } else {
        updateProps({ createGroupError: 'Please select templates.' });
        (0, _lodash2.default)(function () {
          return updateProps({ createGroupError: '' });
        }, 4000)();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GroupWizard, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearGroupWizard();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          groupWizardStep = _props.groupWizardStep,
          createGroupError = _props.createGroupError,
          groupWizardTemplates = _props.groupWizardTemplates,
          updateTemplateProps = _props.updateTemplateProps,
          templateGroups = _props.templateGroups,
          updateProps = _props.updateProps,
          newGroupName = _props.newGroupName,
          newGroupStartDate = _props.newGroupStartDate,
          newGroupEndDate = _props.newGroupEndDate,
          allContractPeriods = _props.allContractPeriods,
          selectedTemplatesForGroup = _props.selectedTemplatesForGroup,
          loadingForGroupWizard = _props.loadingForGroupWizard,
          groupCreated = _props.groupCreated,
          afterCreationFn = _props.afterCreationFn;

      var selectedLength = selectedTemplatesForGroup.length;
      if (groupCreated) {
        return _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          _react2.default.createElement('img', {
            src: _supplierWizardComplete2.default,
            style: { width: '25%', display: 'block', margin: 'auto' }
          }),
          _react2.default.createElement(
            'h4',
            null,
            'Congratulations! You have successfully created a template group!'
          ),
          _react2.default.createElement(_raisedButtonWithLoader2.default, { label: 'View Template Groups', secondary: true, onTouchTap: afterCreationFn
          })
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'small',
          { style: { margin: '12px 20px 0', display: 'block' } },
          'Template Groups are similar to folders, and are only used to allow you to send multiple templates to your partners at once, similar to a bulk send.'
        ),
        _react2.default.createElement(
          _materialUi.Stepper,
          { activeStep: groupWizardStep, orientation: 'vertical' },
          _react2.default.createElement(
            _materialUi.Step,
            null,
            _react2.default.createElement(
              _materialUi.StepLabel,
              null,
              groupWizardStep === 0 ? 'Name & Dates' : _react2.default.createElement(
                _materialUi.StepButton,
                { onTouchTap: function onTouchTap() {
                    return updateProps({ groupWizardStep: 0 });
                  } },
                'Group Name: ' + newGroupName + ' (' + convertToYY({ startDate: newGroupStartDate, endDate: newGroupEndDate }) + ')'
              )
            ),
            _react2.default.createElement(
              _materialUi.StepContent,
              null,
              _react2.default.createElement(_stepOneNameDates2.default, {
                newGroupName: newGroupName,
                allContractPeriods: allContractPeriods,
                selectContractYear: this.selectContractYear,
                updateProps: updateProps,
                newGroupStartDate: newGroupStartDate,
                newGroupEndDate: newGroupEndDate
              }),
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center' } },
                _react2.default.createElement(_raisedButtonWithLoader2.default, {
                  label: 'next',
                  secondary: true,
                  onTouchTap: this.goToStepTwo
                }),
                _react2.default.createElement(
                  'div',
                  { style: { marginLeft: '32px', color: 'red' } },
                  createGroupError
                )
              )
            )
          ),
          _react2.default.createElement(
            _materialUi.Step,
            null,
            _react2.default.createElement(
              _materialUi.StepLabel,
              null,
              'Select Templates',
              selectedLength ? ' (' + selectedLength + ' ' + (0, _pluralize2.default)('template', selectedLength) + ' selected)' : ''
            ),
            _react2.default.createElement(
              _materialUi.StepContent,
              null,
              _react2.default.createElement(_stepTwoTemplates2.default, {
                templates: groupWizardTemplates,
                updateProps: updateProps,
                selectedTemplatesForGroup: selectedTemplatesForGroup,
                loadingForGroupWizard: loadingForGroupWizard
              }),
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', marginTop: '24px', alignItems: 'center' } },
                _react2.default.createElement(_materialUi.FlatButton, {
                  label: 'Back',
                  onTouchTap: function onTouchTap() {
                    return updateProps({ groupWizardStep: 0 });
                  }
                }),
                _react2.default.createElement(_raisedButtonWithLoader2.default, {
                  label: groupWizardStep ? 'Create Group' : 'Next',
                  style: { marginLeft: '8px' },
                  secondary: true,
                  onTouchTap: this.createTemplateGroup
                }),
                _react2.default.createElement(
                  'div',
                  { style: { marginLeft: '32px', color: 'red' } },
                  createGroupError
                )
              )
            )
          )
        )
      );
    }
  }]);

  return GroupWizard;
}(_react2.default.Component);

;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProps: function updateProps(payload) {
      return dispatch((0, _templateListActions.updateProps)(payload));
    },
    getTemplatesForGroupWizard: function getTemplatesForGroupWizard() {
      return dispatch(_templateListActions.getTemplatesForGroupWizard.apply(undefined, arguments));
    },
    createTemplateGroup: function createTemplateGroup() {
      return dispatch(_templateListActions.createTemplateGroup.apply(undefined, arguments));
    },
    clearGroupWizard: function clearGroupWizard() {
      return dispatch({ type: 'TEMPLATE_GROUP_CREATION_UNMOUNT' });
    }
  };
};
var mapStateToProps = function mapStateToProps(_ref4) {
  var contracting = _ref4.contracting;
  return _extends({}, contracting.templateList.toJS(), {
    allContractPeriods: contracting.contractPeriods
  });
};
GroupWizard.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GroupWizard);

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialLocationCity = function SocialLocationCity(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z' })
  );
};
SocialLocationCity = (0, _pure2.default)(SocialLocationCity);
SocialLocationCity.displayName = 'SocialLocationCity';
SocialLocationCity.muiName = 'SvgIcon';

exports.default = SocialLocationCity;

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCreditCard = function ActionCreditCard(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' })
  );
};
ActionCreditCard = (0, _pure2.default)(ActionCreditCard);
ActionCreditCard.displayName = 'ActionCreditCard';
ActionCreditCard.muiName = 'SvgIcon';

exports.default = ActionCreditCard;

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UserInfo = function UserInfo(props) {
  var editUserInfo = props.editUserInfo,
      firstName = props.firstName,
      lastName = props.lastName,
      email = props.email;


  var fields = [{
    label: 'First Name',
    value: 'firstName'
  }, {
    label: 'Last Name',
    value: 'lastName'
  }, {
    label: 'Email',
    value: 'email'
  }];

  return _react2.default.createElement(
    'div',
    null,
    fields.map(function (field, i) {
      return _react2.default.createElement(
        'div',
        { key: i, style: { width: '100%' } },
        _react2.default.createElement(
          'div',
          { style: { display: 'inline-block', width: '20%' } },
          field.label,
          ':'
        ),
        _react2.default.createElement(
          'div',
          { style: { display: 'inline-block', width: '70%' } },
          _react2.default.createElement(_materialUi.TextField, {
            id: field.value,
            fullWidth: true,
            value: _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('firstName'), _ramda2.default.always(firstName)], [_ramda2.default.equals('lastName'), _ramda2.default.always(lastName)], [_ramda2.default.equals('email'), _ramda2.default.always(email)], [_ramda2.default.T, _ramda2.default.always('')]]), field.value),
            onChange: function onChange(_ref) {
              var value = _ref.target.value;
              return editUserInfo(_defineProperty({}, field.value, value.trim()));
            }
          })
        )
      );
    })
  );
};

UserInfo.propTypes = {
  editUserInfo: _react.PropTypes.func,
  userInfo: _react.PropTypes.object,
  firstName: _react.PropTypes.string,
  lastName: _react.PropTypes.string,
  email: _react.PropTypes.string
};

exports.default = UserInfo;

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _teamPermissionOptions = __webpack_require__(1006);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var MultiLocPermissions = function (_Component) {
  _inherits(MultiLocPermissions, _Component);

  function MultiLocPermissions(props) {
    _classCallCheck(this, MultiLocPermissions);

    var _this = _possibleConstructorReturn(this, (MultiLocPermissions.__proto__ || Object.getPrototypeOf(MultiLocPermissions)).call(this, props));

    _this.state = {
      allLocsAccess: false,
      allLocsSameTeamAndLocs: props.allLocsSameTeamAndLocs
    };
    return _this;
  }

  _createClass(MultiLocPermissions, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (_ramda2.default.isNil(this.state.allLocsSameTeamAndLocs) && !_ramda2.default.isNil(nextProps.allLocsSameTeamAndLocs)) {
        this.setState({ allLocsSameTeamAndLocs: nextProps.allLocsSameTeamAndLocs });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          userName = _props.userName,
          locations = _props.locations,
          onLocSelection = _props.onLocSelection,
          selectedLocs = _props.selectedLocs,
          onCorporateLocCheck = _props.onCorporateLocCheck,
          showCorporateProfileRadioButtons = _props.showCorporateProfileRadioButtons,
          isAccom = _props.isAccom,
          corporateProfileAccess = _props.corporateProfileAccess,
          isSingleLoc = _props.isSingleLoc;
      var _state = this.state,
          allLocsSameTeamAndLocs = _state.allLocsSameTeamAndLocs,
          allLocsAccess = _state.allLocsAccess;

      var options = function () {
        var locList = locations.map(function (loc) {
          return {
            value: loc._id,
            label: loc.property_name,
            locId: loc._id,
            disabled: loc.disabled
          };
        });
        return _ramda2.default.prepend({ value: 'allLocs', label: 'All ' + (isAccom ? 'Properties' : 'Locations') }, locList);
      }();
      var removeAllLocsField = _ramda2.default.without([{ value: 'allLocs', label: 'All ' + (isAccom ? 'Properties' : 'Locations') }], options);
      var allLocsSelected = selectedLocs.length === locations.length;
      var showAllTextOrNumOrLocs = allLocsSelected ? 'all' : '' + selectedLocs.length;
      var teamCheckboxes = function teamCheckboxes(_ref) {
        var allLocsSameTeam = _ref.allLocsSameTeam,
            _ref$locObj = _ref.locObj,
            locObj = _ref$locObj === undefined ? {} : _ref$locObj,
            outerDivStyle = _ref.outerDivStyle;

        var findLoc = allLocsSameTeam ? selectedLocs[0] : selectedLocs.filter(function (loc) {
          return loc.locId === locObj.locId;
        })[0];
        return _react2.default.createElement(
          'div',
          { style: _ramda2.default.merge({ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }, outerDivStyle) },
          _teamPermissionOptions.teams.map(function (team, i) {
            return _react2.default.createElement(
              'div',
              { key: i, style: { marginTop: i === _ramda2.default.dec(_teamPermissionOptions.teams.length) ? '15px' : '' } },
              _react2.default.createElement(_materialUi.Checkbox, {
                label: team,
                style: { display: 'flex', width: '50%' },
                checked: _ramda2.default.contains(team, findLoc.teams),
                disabled: locObj.disabled,
                onCheck: function onCheck() {
                  if (allLocsSameTeam) {
                    onLocSelection(selectedLocs.map(function (loc) {
                      return _ramda2.default.merge(loc, { teams: _ramda2.default.contains(team, loc.teams) ? _ramda2.default.without([team], loc.teams) : _ramda2.default.append(team, loc.teams) });
                    }));
                  } else {
                    var updateTeams = _ramda2.default.contains(team, findLoc.teams) ? _ramda2.default.without([team], findLoc.teams) : _ramda2.default.append(team, findLoc.teams);
                    var updateLoc = _ramda2.default.merge(findLoc, { teams: updateTeams });
                    onLocSelection(selectedLocs.map(function (loc) {
                      if (loc.locId === locObj.locId) return updateLoc;
                      return loc;
                    }));
                  }
                }
              })
            );
          })
        );
      };

      var accessDropdown = function accessDropdown(_ref2) {
        var allLocsSameAccess = _ref2.allLocsSameAccess,
            _ref2$locObj = _ref2.locObj,
            locObj = _ref2$locObj === undefined ? {} : _ref2$locObj,
            borderTopColor = _ref2.borderTopColor,
            outerDivStyle = _ref2.outerDivStyle,
            outerTableStyle = _ref2.outerTableStyle;
        return _react2.default.createElement(
          'div',
          { style: _ramda2.default.merge(outerDivStyle, { marginBottom: '15px', display: 'flex', width: '100%' }) },
          _teamPermissionOptions.permissionTypes.map(function (type, k) {
            var findLoc = allLocsSameAccess ? selectedLocs[0] : selectedLocs.filter(function (lc) {
              return lc.locId === locObj.locId;
            })[0];
            var hideLastBorder = k === _ramda2.default.dec(_teamPermissionOptions.permissionTypes.length) ? 'transparent' : '#d8d8d8';
            return _react2.default.createElement(
              'div',
              { key: k, style: _ramda2.default.merge({ display: 'flex', alignItems: 'center' }, outerTableStyle) },
              _react2.default.createElement(
                'div',
                { style: _ramda2.default.merge(outerTableStyle, { width: '45%' }) },
                _react2.default.createElement(
                  'span',
                  { className: k === _ramda2.default.dec(_teamPermissionOptions.permissionTypes.length) ? 'hint--top' : 'hint--bottom', 'aria-label': type.hintTextMultiLoc },
                  type.label,
                  ':'
                )
              ),
              _react2.default.createElement(
                _materialUi.DropDownMenu,
                {
                  value: function () {
                    if (findLoc[type.value]) {
                      if (findLoc[type.value].indexOf('write') > -1) return 'Read and Write';
                      if (findLoc[type.value].indexOf('read') > -1) return 'Read Only';
                    }
                    return 'No Access';
                  }(),
                  underlineStyle: { borderTopColor: borderTopColor ? '#d8d8d8' : hideLastBorder },
                  labelStyle: { paddingRight: 0 },
                  style: { display: 'flex', marginTop: '-10px', width: '55%' }
                },
                _teamPermissionOptions.availableAccess.map(function (access, i) {
                  return _react2.default.createElement(_materialUi.MenuItem, {
                    key: i,
                    value: access.label,
                    primaryText: access.label,
                    label: access.label,
                    disabled: locObj.disabled,
                    onTouchTap: function onTouchTap() {
                      onLocSelection(selectedLocs.map(function (location) {
                        if (allLocsSameAccess || location.locId === locObj.locId) {
                          return _ramda2.default.merge(location, {
                            profile: type.value === 'profile' ? access.value : location.profile,
                            contracting: type.value === 'contracting' ? access.value : location.contracting,
                            admin: type.value === 'admin' ? access.value : location.admin
                          });
                        }
                        return location;
                      }));
                    }
                  });
                })
              )
            );
          })
        );
      };

      return _react2.default.createElement(
        'div',
        null,
        showCorporateProfileRadioButtons && _react2.default.createElement(
          'div',
          { style: { marginTop: '15px', display: 'inline-block', width: '100%' } },
          _react2.default.createElement(
            'div',
            { style: { float: 'left', width: '65%' } },
            _react2.default.createElement(
              'span',
              { className: 'hint--bottom', 'aria-label': 'Gives the user access to edit the corporate profile and create new ' + (isAccom ? 'properties' : 'locations') + '.' },
              'Would you like ',
              _react2.default.createElement(
                'b',
                null,
                userName
              ),
              ' to have access to edit corporate profile?'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { float: 'left', width: '35%', display: 'inline-block' } },
            _react2.default.createElement(
              _materialUi.RadioButtonGroup,
              {
                name: 'corporateProfile',
                defaultSelected: corporateProfileAccess ? 'yes' : 'no',
                onChange: onCorporateLocCheck,
                style: { display: 'inline-block', width: '100%' }
              },
              _react2.default.createElement(_materialUi.RadioButton, { value: 'no', label: 'No', style: { width: '50%', display: 'inline-block' } }),
              _react2.default.createElement(_materialUi.RadioButton, { value: 'yes', label: 'Yes', style: { width: '50%', display: 'inline-block' } })
            )
          )
        ),
        !isSingleLoc && _react2.default.createElement(
          'div',
          { style: { margin: '20px 0 30px 0' } },
          _react2.default.createElement(
            'div',
            { style: { marginTop: '10px' } },
            'Select which ',
            isAccom ? 'property' : 'location',
            '(s) ',
            _react2.default.createElement(
              'b',
              null,
              userName
            ),
            ' has access to:',
            allLocsSelected ? _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', marginLeft: '5px' } },
              'All ',
              locations.length,
              ' ',
              isAccom ? 'Properties' : 'Locations',
              _react2.default.createElement(_materialUi.IconButton, {
                iconClassName: 'tc-icon-close',
                iconStyle: { color: 'rgb(255, 64, 129)', padding: 0, fontSize: '14px', marginLeft: '-10px' },
                onTouchTap: function onTouchTap() {
                  _this2.setState({ allLocsAccess: false, allLocsSameTeamAndLocs: null });
                  onLocSelection([]);
                }
              })
            ) : _react2.default.createElement(_reactSelect2.default, {
              multi: true,
              name: "selectedLocs",
              onChange: function onChange(selections) {
                var isAllLocsSelected = _ramda2.default.contains('allLocs', _ramda2.default.pluck('value')(selections));
                _this2.setState({ allLocsAccess: isAllLocsSelected });
                var newSelectedLocs = isAllLocsSelected ? removeAllLocsField : selections;
                var processedLocsSelected = [].concat(_toConsumableArray(selectedLocs.filter(function (obj) {
                  return newSelectedLocs.some(function (newSelected) {
                    return newSelected.locId === obj.locId;
                  });
                })), _toConsumableArray(newSelectedLocs.filter(function (newSelected) {
                  return selectedLocs.every(function (loc) {
                    return loc.locId !== newSelected.locId;
                  });
                }).map(function (loc) {
                  return {
                    locId: loc.locId,
                    property_name: loc.label,
                    teams: [],
                    contracting: [],
                    profile: [],
                    admin: [],
                    value: loc.value,
                    label: loc.label
                  };
                })));
                onLocSelection(processedLocsSelected);
              },
              placeholder: 'Search for a ' + (isAccom ? 'property' : 'location') + '...',
              options: allLocsAccess ? _ramda2.default.without(selectedLocs, removeAllLocsField) : _ramda2.default.without(selectedLocs, options),
              value: selectedLocs,
              scrollMenuIntoView: false
            })
          ),
          !isNilOrEmpty(selectedLocs) && selectedLocs.length > 1 && _react2.default.createElement(
            'div',
            { style: { marginTop: allLocsAccess ? '10px' : '15px' } },
            'Do you want ',
            userName,
            ' to be assigned to the same team(s) and have the same access levels for all ',
            showAllTextOrNumOrLocs,
            ' ',
            isAccom ? 'properties' : 'locations',
            '?',
            _react2.default.createElement(
              _materialUi.RadioButtonGroup,
              {
                name: 'allLocsSameTeamAndLocs',
                valueSelected: allLocsSameTeamAndLocs,
                onChange: function onChange(_, selected) {
                  _this2.setState({ allLocsSameTeamAndLocs: selected });
                  onLocSelection(selectedLocs.map(function (loc) {
                    return _ramda2.default.merge(loc, { teams: [], profile: [], contracting: [], admin: [] });
                  }));
                }
              },
              _react2.default.createElement(_materialUi.RadioButton, { value: true, label: 'Yes, ' + userName + ' should have the same team(s) and access across all ' + (isAccom ? 'properties' : 'locations') + '.' }),
              _react2.default.createElement(_materialUi.RadioButton, { value: false, label: 'No, I want to assign the teams and access levels for each ' + (isAccom ? 'property' : 'location') + '.' })
            )
          )
        ),
        (!isNilOrEmpty(allLocsSameTeamAndLocs) || selectedLocs.length === 1) && _react2.default.createElement(
          'div',
          null,
          !allLocsSameTeamAndLocs ? _react2.default.createElement(
            'div',
            { style: { marginTop: '-10px' } },
            _react2.default.createElement(
              _materialUi.Table,
              null,
              _react2.default.createElement(
                _materialUi.TableHeader,
                { adjustForCheckbox: false, displaySelectAll: false },
                _react2.default.createElement(
                  _materialUi.TableRow,
                  null,
                  _react2.default.createElement(
                    _materialUi.TableHeaderColumn,
                    { style: { width: '30%' } },
                    'Location'
                  ),
                  _react2.default.createElement(
                    _materialUi.TableHeaderColumn,
                    { style: { width: '30%' } },
                    'Team(s)'
                  ),
                  _react2.default.createElement(
                    _materialUi.TableHeaderColumn,
                    null,
                    'Access'
                  )
                )
              ),
              _react2.default.createElement(
                _materialUi.TableBody,
                { displayRowCheckbox: false },
                selectedLocs.map(function (loc, i) {
                  var locObj = { locId: loc.locId, disabled: loc.disabled };
                  return _react2.default.createElement(
                    _materialUi.TableRow,
                    { key: loc.locId, selectable: false },
                    _react2.default.createElement(
                      _materialUi.TableRowColumn,
                      { style: { width: '30%' } },
                      loc.label
                    ),
                    _react2.default.createElement(
                      _materialUi.TableRowColumn,
                      { style: { width: '25%' } },
                      teamCheckboxes({ locObj: locObj, outerDivStyle: { marginTop: '-15px' } })
                    ),
                    _react2.default.createElement(
                      _materialUi.TableRowColumn,
                      { style: { overflow: 'visible' } },
                      accessDropdown({ locObj: locObj, borderTopColor: false, outerDivStyle: { flexWrap: 'wrap' }, outerTableStyle: { width: '100%' } })
                    )
                  );
                })
              )
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              null,
              'Would you like to add ',
              userName,
              ' to a team? Teams can be used to manage user permissions for different departments at your company.',
              teamCheckboxes({ allLocsSameTeam: true, outerDivStyle: { marginTop: '5px' } })
            ),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '30px', display: 'flex', flexWrap: 'wrap', flexDirection: 'row' } },
              'Set what access level ',
              userName,
              ' should have:',
              accessDropdown({ allLocsSameAccess: true, borderTopColor: true, outerDivStyle: { marginTop: '5px', flexDirection: 'column' }, outerTableStyle: { width: '50%' } })
            )
          )
        )
      );
    }
  }]);

  return MultiLocPermissions;
}(_react.Component);

MultiLocPermissions.propTypes = {
  teams: _react.PropTypes.array,
  userName: _react.PropTypes.string,
  locations: _react.PropTypes.array,
  onLocSelection: _react.PropTypes.func,
  selectedLocs: _react.PropTypes.array,
  onCorporateLocCheck: _react.PropTypes.func,
  showCorporateProfileRadioButtons: _react.PropTypes.bool,
  onlyHasAccessToOneLoc: _react.PropTypes.bool,
  isAccom: _react.PropTypes.bool,
  allLocsSameTeamAndLocs: _react.PropTypes.bool,
  corporateProfileAccess: _react.PropTypes.bool,
  isSingleLoc: _react.PropTypes.bool
};

exports.default = MultiLocPermissions;

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _teamPermissionOptions = __webpack_require__(1006);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleLocPermissions = function SingleLocPermissions(props) {
  var isAccom = props.isAccom,
      userName = props.userName,
      selectedLocs = props.selectedLocs,
      onLocSelection = props.onLocSelection,
      showCorporateProfileRadioButtons = props.showCorporateProfileRadioButtons,
      onCorporateLocCheck = props.onCorporateLocCheck,
      corporateProfileAccess = props.corporateProfileAccess;

  return _react2.default.createElement(
    'div',
    { style: { marginTop: '15px' } },
    _react2.default.createElement(
      'div',
      { style: { marginTop: '-10px', maxHeight: '300px' } },
      showCorporateProfileRadioButtons && _react2.default.createElement(
        'div',
        { style: { marginTop: '15px', display: 'inline-block', width: '100%' } },
        _react2.default.createElement(
          'div',
          { style: { float: 'left', width: '65%' } },
          _react2.default.createElement(
            'span',
            { className: 'hint--bottom', 'aria-label': 'Gives the user access to edit profile.' },
            'Would you like ',
            _react2.default.createElement(
              'b',
              null,
              userName
            ),
            ' to have access to edit profile?'
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { float: 'left', width: '35%', display: 'inline-block' } },
          _react2.default.createElement(
            _materialUi.RadioButtonGroup,
            {
              name: 'corporateProfile',
              defaultSelected: corporateProfileAccess ? 'yes' : 'no',
              onChange: function onChange() {
                return onCorporateLocCheck();
              }, style: { display: 'inline-block', width: '100%' }
            },
            _react2.default.createElement(_materialUi.RadioButton, { value: 'no', label: 'No', style: { width: '50%', display: 'inline-block' } }),
            _react2.default.createElement(_materialUi.RadioButton, { value: 'yes', label: 'Yes', style: { width: '50%', display: 'inline-block' } })
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { margin: '5px 0' } },
        'Add ',
        userName,
        ' to an optional team and set their access level below. Teams can be used to manage user permissions for different departments at your company.'
      ),
      _react2.default.createElement(
        _materialUi.Table,
        { bodyStyle: { maxHeight: '250px', overflowY: 'scroll' } },
        _react2.default.createElement(
          _materialUi.TableHeader,
          { adjustForCheckbox: false, displaySelectAll: false },
          _react2.default.createElement(
            _materialUi.TableRow,
            null,
            _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              { style: { width: '50%' } },
              'Team(s)'
            ),
            _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              null,
              'Access'
            )
          )
        ),
        _react2.default.createElement(
          _materialUi.TableBody,
          { displayRowCheckbox: false },
          _react2.default.createElement(
            _materialUi.TableRow,
            { selectable: false },
            _react2.default.createElement(
              _materialUi.TableRowColumn,
              { style: { width: '50%' } },
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', flexWrap: 'wrap', flexDirection: 'column' } },
                _teamPermissionOptions.teams.map(function (team, i) {
                  return _react2.default.createElement(_materialUi.Checkbox, {
                    label: team,
                    key: i,
                    style: { display: 'flex', width: '50%', marginTop: i === _ramda2.default.dec(_teamPermissionOptions.teams.length) ? '15px' : '' },
                    checked: _ramda2.default.contains(team, _ramda2.default.path([0, 'teams'], selectedLocs)),
                    onCheck: function onCheck() {
                      var locTeams = _ramda2.default.path([0, 'teams'], selectedLocs);
                      onLocSelection([_ramda2.default.merge(selectedLocs[0], { teams: _ramda2.default.contains(team, locTeams) ? _ramda2.default.without([team], locTeams) : _ramda2.default.append(team, locTeams) })]);
                    }
                  });
                })
              )
            ),
            _react2.default.createElement(
              _materialUi.TableRowColumn,
              { style: { overflow: 'visible' } },
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', width: '100%', flexWrap: 'wrap' } },
                _teamPermissionOptions.permissionTypes.filter(function (type) {
                  return type.value !== 'profile';
                }).map(function (type, k) {
                  var loc = selectedLocs[0];
                  return _react2.default.createElement(
                    'div',
                    { key: k, style: { display: 'flex', alignItems: 'center', width: '100%' } },
                    _react2.default.createElement(
                      'div',
                      { style: { width: '30%', marginLeft: '5px' } },
                      _react2.default.createElement(
                        'span',
                        { className: k === _ramda2.default.dec(_teamPermissionOptions.permissionTypes.length) ? 'hint--top' : 'hint--bottom', 'aria-label': type.hintTextSingleLoc },
                        type.label,
                        ':'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { style: { marginLeft: '8px' } },
                      _react2.default.createElement(
                        _materialUi.DropDownMenu,
                        {
                          value: _ramda2.default.path([0, 'value'], _teamPermissionOptions.availableAccess.filter(function (obj) {
                            return _ramda2.default.equals(obj.value, loc[type.value]);
                          })),
                          underlineStyle: { borderTopColor: k === _ramda2.default.dec(_teamPermissionOptions.permissionTypes.length) ? 'transparent' : '#d8d8d8' },
                          style: { display: 'flex', marginTop: '-10px' }
                        },
                        _teamPermissionOptions.availableAccess.map(function (access, i) {
                          return _react2.default.createElement(_materialUi.MenuItem, {
                            key: i,
                            value: access.value,
                            primaryText: access.label,
                            label: access.label,
                            onTouchTap: function onTouchTap() {
                              onLocSelection([_ramda2.default.merge(selectedLocs[0], {
                                contracting: type.value === 'contracting' ? access.value : _ramda2.default.path([0, 'contracting'], selectedLocs),
                                admin: type.value === 'admin' ? access.value : _ramda2.default.path([0, 'admin'], selectedLocs)
                              })]);
                            }
                          });
                        })
                      )
                    )
                  );
                })
              )
            )
          )
        )
      )
    )
  );
};

SingleLocPermissions.propTypes = {
  userName: _react.PropTypes.string,
  location: _react.PropTypes.object,
  selectedLocs: _react.PropTypes.array,
  onLocSelection: _react.PropTypes.func,
  showCorporateProfileRadioButtons: _react.PropTypes.bool,
  onCorporateLocCheck: _react.PropTypes.func,
  corporateProfileAccess: _react.PropTypes.bool
};

exports.default = SingleLocPermissions;

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _close = __webpack_require__(547);

var _close2 = _interopRequireDefault(_close);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _CreditCard = __webpack_require__(3540);

var _CreditCard2 = _interopRequireDefault(_CreditCard);

var _cancelReason = __webpack_require__(3541);

var _cancelReason2 = _interopRequireDefault(_cancelReason);

var _CreditCardForm = __webpack_require__(1868);

var _CreditCardForm2 = _interopRequireDefault(_CreditCardForm);

var _invoiceTable = __webpack_require__(3542);

var _invoiceTable2 = _interopRequireDefault(_invoiceTable);

var _billingActions = __webpack_require__(1108);

var _chevronLeft = __webpack_require__(1784);

var _chevronLeft2 = _interopRequireDefault(_chevronLeft);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Billing = function (_Component) {
  _inherits(Billing, _Component);

  function Billing(props) {
    _classCallCheck(this, Billing);

    var _this = _possibleConstructorReturn(this, (Billing.__proto__ || Object.getPrototypeOf(Billing)).call(this, props));

    _this.handleCloseCancelDialog = function () {
      _this.setState({ cancelDialogOpen: false });
    };

    _this.handleOpenCancelDialog = function () {
      _this.setState({ cancelDialogOpen: true });
    };

    _this.handleCancelReasonChange = function (e, key, payload) {
      return _this.setState({ cancellationReason: payload });
    };

    _this.handleAdditionalDetailsChange = function (event, value) {
      return _this.setState({ addtionalDetail: value });
    };

    _this.handleCancelSubscription = function () {
      return _this.props.cancelSubscription(_this.state.cancellationReason, _this.state.addtionalDetail);
    };

    _this.toggleInvoiceDialog = function () {
      _this.setState({
        invoicesDialogOpen: !_this.state.invoicesDialogOpen
      });
    };

    _this.openOneInvoice = function (inv) {
      return function () {
        return _this.setState({ singleInvoice: inv });
      };
    };

    _this.backToInvoiceList = function () {
      return _this.setState({ singleInvoice: null });
    };

    _this.state = {
      creditCardDialogOpen: false,
      cancelDialogOpen: false,
      cancellationReason: null,
      addtionalDetail: '',
      invoicesDialogOpen: false,
      singleInvoice: null
    };
    return _this;
  }

  _createClass(Billing, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      dispatch((0, _billingActions.getBilling)());
      dispatch({ type: '{billing} getInvoices' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          billing = _props.billing,
          plan = _props.user.company.plan;

      var dateFormat = 'DD MMM YYYY';
      var currentPeriodEnd = (0, _moment2.default)(billing.currentPeriodEnd).format(dateFormat);
      var billingSubscriptions = _ramda2.default.propOr([], 'billingSubscriptions', billing);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _materialUi.Paper,
          {
            style: {
              display: 'flex',
              alignItems: 'flex-start',
              padding: '24px',
              marginBottom: '16px'
            }
          },
          _react2.default.createElement(
            'div',
            { style: { verticalAlign: 'top', width: 'calc(100% - 300px)' } },
            function () {
              if (billing && billing.billingSubscriptions && billing.billingSubscriptions.length) {
                return billing.billingSubscriptions.reduce(function (result, sub) {
                  return [].concat(_toConsumableArray(result), _toConsumableArray(sub.items.map(function (item) {
                    return _extends({}, sub, item);
                  })));
                }, []).map(function (obj, i) {
                  return _react2.default.createElement(
                    'p',
                    { key: i },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        obj.plan.nickname || obj.plan.name
                      )
                    ),
                    _react2.default.createElement(
                      'small',
                      null,
                      'Current billing cycle started on ',
                      (0, _moment2.default)(obj.currentPeriodEnd).subtract(obj.plan.interval_count, obj.plan.interval).format(dateFormat)
                    )
                  );
                });
              }
              return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h4',
                  { style: { fontWeight: 300, margin: 0, padding: 0, textTransform: 'uppercase' } },
                  plan,
                  ' Plan'
                ),
                (billing.status === 'trialing' || !billing.cancelAtPeriodEnd) && _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    (billing.status === 'trialing' ? 'Your trial expires' : 'Renews') + ' on ' + currentPeriodEnd
                  )
                ),
                billing.cancelAtPeriodEnd && _react2.default.createElement(
                  'p',
                  null,
                  'Your plan will not auto-renew and will end on ',
                  currentPeriodEnd
                ),
                _react2.default.createElement(
                  'span',
                  { style: { fontSize: '12px' } },
                  'Note: All users on the admin team will receive billing emails.'
                )
              );
            }()
          ),
          _react2.default.createElement(
            'div',
            { style: { verticalAlign: 'top', padding: '0 10px' } },
            billing && billing.cardNumber && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_CreditCard2.default, {
                cardType: billing.cardBrand,
                cardNumber: billing.cardNumber,
                cardExpYear: billing.cardExpYear,
                cardExpMonth: billing.cardExpMonth,
                nameOnCard: billing.nameOnCard
              }),
              _react2.default.createElement(
                'p',
                { style: { textAlign: 'center' } },
                _react2.default.createElement(
                  'a',
                  { href: '#', onClick: function onClick(e) {
                      e.preventDefault();
                      _this2.setState({
                        creditCardDialogOpen: !_this2.state.creditCardDialogOpen
                      });
                    }
                  },
                  'Update Credit Card'
                )
              )
            ),
            !billing || !billing.cardNumber && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h4',
                { style: { fontWeight: 300, margin: 0, padding: 0, textTransform: 'uppercase' } },
                'Payment Method'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'a',
                  { href: '#', onClick: function onClick(e) {
                      e.preventDefault();
                      _this2.props.dispatch((0, _billingActions.resetBillingError)());
                      _this2.setState({
                        creditCardDialogOpen: !_this2.state.creditCardDialogOpen
                      });
                    }
                  },
                  'Add Payment Information'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _materialUi.Paper,
          {
            style: {
              padding: '24px',
              marginBottom: '16px',
              display: billing && billing.billingSubscriptions && billingSubscriptions.length ? 'block' : 'none'
            }
          },
          _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb' },
            _react2.default.createElement(
              'h4',
              { style: { fontWeight: 300, margin: 0, padding: 0, textTransform: 'uppercase' } },
              'Upcoming Invoice'
            ),
            Boolean(billing.invoices && billing.invoices.length) && _react2.default.createElement(_materialUi.FlatButton, {
              label: 'Invoice History',
              secondary: true,
              labelStyle: { textTransform: 'none' },
              onClick: this.toggleInvoiceDialog
            })
          ),
          function () {
            if (billing && billing.nextInvoice) {
              return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { style: { margin: '16px 0' } },
                  'This is a preview of the invoice that will be billed on ',
                  currentPeriodEnd,
                  '. It may change if the subscription is updated.'
                ),
                _react2.default.createElement(_invoiceTable2.default, { invoice: billing.nextInvoice })
              );
            }
            return _react2.default.createElement(
              'p',
              null,
              'No Upcoming Invoice'
            );
          }()
        ),
        billing.status !== 'trialing' && !billing.cancelAtPeriodEnd && _react2.default.createElement(
          _materialUi.Paper,
          { style: { padding: '25px', marginBottom: '15px', textAlign: 'center' } },
          _react2.default.createElement(
            'p',
            null,
            'You are able to cancel your subscription at any time. When you cancel, your subscription will not renew and will end on ',
            currentPeriodEnd,
            '.',
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              _materialUi.FlatButton,
              {
                secondary: true,
                onClick: this.handleOpenCancelDialog
              },
              'Cancel Subscription'
            ),
            _react2.default.createElement(_cancelReason2.default, {
              cancellationReason: this.state.cancellationReason,
              cancellationError: billing.errorMessage,
              submitDisabled: billing.isLoading,
              isOpen: this.state.cancelDialogOpen,
              onAdditionalDetailsChange: this.handleAdditionalDetailsChange,
              onSubmitClick: this.handleCancelSubscription,
              onCloseClick: this.handleCloseCancelDialog,
              onCancelReasonChange: this.handleCancelReasonChange
            })
          )
        ),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            contentStyle: { borderRadius: '20px' },
            titleStye: { borderBottom: '50px solid #000000' },
            modal: true,
            open: this.state.creditCardDialogOpen,
            onRequestClose: function onRequestClose() {
              _this2.setState({
                creditCardDialogOpen: !_this2.state.creditCardDialogOpen
              });
            }
          },
          this.props.billing.errorMessage && _react2.default.createElement(
            'p',
            { style: {
                color: '#ff5e5c',
                lineHeight: '18px',
                marginBottom: '12px',
                borderRadius: '4px',
                background: '#fff5f5',
                padding: '16px 23px 16px 16px',
                fontSize: '12px'
              }
            },
            this.props.billing.errorMessage
          ),
          _react2.default.createElement(_CreditCardForm2.default, {
            buttonText: 'Update Card',
            stripePublicKey: "pk_live_3DIaCH9RC6TUHFN58h8Rr0LW",
            buttonStyle: { display: 'block', margin: '40px auto 25px auto' },
            containerStyle: { width: '100%' }, inputFieldStyle: { verticalAlign: 'top' },
            submitDisabled: billing.isLoading,
            isProcessing: billing.isLoading,
            onCreateToken: function onCreateToken(status, response) {
              if (status === 200) {
                _this2.props.dispatch((0, _billingActions.updatePaymentSource)(response.id)).then(function () {
                  _this2.setState({
                    creditCardDialogOpen: false
                  });
                  _this2.props.dispatch((0, _billingActions.resetBillingError)());
                }).catch(function (err) {
                  console.log('err', err);
                });
              } else {
                console.log('onCreateTokenStatus', status);
                console.log('Response', response);
              }
            }
          }),
          !billing.isLoading && _react2.default.createElement(
            'a',
            {
              style: { display: 'block', textAlign: 'center' },
              href: '#',
              onClick: function onClick(e) {
                e.preventDefault();
                _this2.setState({ creditCardDialogOpen: false });
              }
            },
            'Cancel'
          )
        ),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            contentStyle: { borderRadius: '20px' },
            open: this.state.invoicesDialogOpen,
            onRequestClose: this.toggleInvoiceDialog,
            title: _react2.default.createElement(
              'div',
              { className: 'flex-tc-sb' },
              this.state.singleInvoice ? _react2.default.createElement(_materialUi.FlatButton, {
                icon: _react2.default.createElement(_chevronLeft2.default, null),
                label: 'Back To List',
                onClick: this.backToInvoiceList
              }) : _react2.default.createElement(
                'div',
                { style: { fontSize: '20px' } },
                'Invoice History'
              ),
              _react2.default.createElement(
                _materialUi.IconButton,
                { onClick: this.toggleInvoiceDialog },
                _react2.default.createElement(_close2.default, { style: { fontSize: '16px' } })
              )
            )
          },
          this.state.singleInvoice ? _react2.default.createElement(
            'div',
            { style: { fontSize: '14px' } },
            _react2.default.createElement(_invoiceTable2.default, { invoice: this.state.singleInvoice }),
            Boolean(this.state.singleInvoice.invoice_pdf) && _react2.default.createElement(
              'div',
              {
                style: { textAlign: 'center', cursor: 'pointer', color: '#00bcd4', marginTop: '8px' },
                onClick: function onClick() {
                  if (_this2.state.singleInvoice.invoice_pdf) window.open(_this2.state.singleInvoice.invoice_pdf);else window.alert('Only finalized invoices have PDF.');
                }
              },
              'Download'
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              {
                style: {
                  display: 'flex',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  padding: '4px',
                  borderBottom: '1px solid #e0e0e0'
                }
              },
              _react2.default.createElement(
                'div',
                { style: { width: '100px', textAlign: 'right' } },
                'AMOUNT'
              ),
              _react2.default.createElement('div', { style: { width: '72px' } }),
              _react2.default.createElement(
                'div',
                { style: { flex: 1, textAlign: 'center' } },
                'INVOICE NUMBER'
              ),
              _react2.default.createElement(
                'div',
                { style: { flex: 1, textAlign: 'center' } },
                'FINALIZED DATE'
              ),
              _react2.default.createElement('div', { style: { flex: 1 } })
            ),
            billing.invoices.map(function (inv, i) {
              return _react2.default.createElement(
                'div',
                {
                  key: i,
                  style: {
                    display: 'flex',
                    borderBottom: '1px solid #e0e0e0',
                    fontSize: '12px',
                    padding: '4px',
                    cursor: 'pointer'
                  },
                  onClick: _this2.openOneInvoice(inv)
                },
                _react2.default.createElement(
                  'div',
                  { style: { width: '100px', paddingRight: '4px', textAlign: 'right' } },
                  '$',
                  (inv.total / 100).toFixed(2)
                ),
                _react2.default.createElement(
                  'div',
                  { style: { width: '72px' } },
                  inv.currency.toUpperCase()
                ),
                _react2.default.createElement(
                  'div',
                  { style: { flex: 1, textAlign: 'center' } },
                  inv.number
                ),
                _react2.default.createElement(
                  'div',
                  { style: { flex: 1, textAlign: 'center' } },
                  inv.finalized_at ? (0, _moment2.default)(inv.finalized_at * 1000).format(dateFormat) : 'pending'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    style: { flex: 1, textAlign: 'center', cursor: 'pointer', color: '#00bcd4' },
                    onClick: function onClick() {
                      if (inv.invoice_pdf) window.open(inv.invoice_pdf);else window.alert('Only finalized invoices have PDF.');
                    }
                  },
                  'Download'
                )
              );
            }),
            Boolean(billing.hasMoreInvoices) && _react2.default.createElement(
              'small',
              null,
              'Showing the most recent 25 invoices only.'
            )
          )
        )
      );
    }
  }]);

  return Billing;
}(_react.Component);

Billing.propTypes = {
  billing: _react.PropTypes.object,
  cancelSubscription: _react.PropTypes.func,
  children: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  history: _react.PropTypes.object,
  user: _react.PropTypes.object
};

var mapDispatchToProps = {
  cancelSubscription: _billingActions.cancelSubscription
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(Billing);

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _forum = __webpack_require__(1853);

var _forum2 = _interopRequireDefault(_forum);

var _titlecase = __webpack_require__(549);

var _reactRouterRedux = __webpack_require__(27);

var _messagingActions = __webpack_require__(562);

var _messagingAvatar = __webpack_require__(1271);

var _messagingAvatar2 = _interopRequireDefault(_messagingAvatar);

var _timeNWidget = __webpack_require__(3548);

var _timeNWidget2 = _interopRequireDefault(_timeNWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  classes: _react.PropTypes.object,
  className: _react.PropTypes.string,
  convList: _react.PropTypes.array,
  decrementUnreadCount: _react.PropTypes.func,
  hoveredConv: _react.PropTypes.object,
  initialLoadAMsg: _react.PropTypes.func,
  loadConvList: _react.PropTypes.func,
  loadingConvList: _react.PropTypes.bool,
  params: _react.PropTypes.object,
  push: _react.PropTypes.func,
  selectedChannel: _react.PropTypes.string,
  selectedContract: _react.PropTypes.string,
  selectedConv: _react.PropTypes.object,
  toggleConvDone: _react.PropTypes.func,
  updateProps: _react.PropTypes.func,
  viewerCompany: _react.PropTypes.object
};

var styles = {
  main: {
    width: '334px !important',
    marginTop: '0',
    '& > div': {
      position: 'relative',
      top: 0,
      height: '85%',
      overflowY: 'scroll'
    }
  },
  participanName: {
    flexGrow: '2',
    color: 'rgba(0, 0, 0, 0.74)',
    paddingLeft: '4px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    fontWeight: '600',
    '&.hasSeen': {
      fontWeight: '500'
    }
  },
  emptyConvs: {
    textAlign: 'center',
    marginTop: '50%'
  },
  forumIcon: {
    color: 'rgba(0, 0, 0, 0.24)',
    height: '48px',
    width: '48px'
  },
  aConv: {
    cursor: 'pointer',
    padding: '8px 16px',
    '&.selected': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)'
    }
  },
  latestMessage: {
    fontWeight: '600',
    fontSize: '12px',
    margin: '8px 0 0 4px',
    lineHeight: '17px',
    maxHeight: '34px',
    minHeight: '17px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&.seen': {
      fontWeight: '500'
    }
  },
  channelsTitle: {
    color: 'white',
    fontSize: '18px',
    flex: '1 0 auto',
    lineHeight: '48px',
    paddingLeft: '10px',
    backgroundColor: 'rgb(0, 179, 207)',
    height: '48px !important'
  }
};

var ConversationList = function (_Component) {
  _inherits(ConversationList, _Component);

  function ConversationList(props) {
    _classCallCheck(this, ConversationList);

    var _this = _possibleConstructorReturn(this, (ConversationList.__proto__ || Object.getPrototypeOf(ConversationList)).call(this, props));

    _this.timer = null;

    _this.timedUpdate = function () {
      var _this$props = _this.props,
          loadingConvList = _this$props.loadingConvList,
          selectedChannel = _this$props.selectedChannel;

      if (!localStorage.stopAutoReload && !loadingConvList) _this.props.loadConvList('notdone', !Boolean(selectedChannel));
    };

    _this.openAConv = function (conv) {
      var decrementUnreadCount = _this.props.decrementUnreadCount;

      if (!conv.hasSeen) decrementUnreadCount();
      // since now this area is only for self forwarding
      // one conv is one message from workspacemessages
      _this.props.updateProps('convs', { selectedConv: conv, messages: [conv] });
      _this.props.updateProps('messages', { conv: conv, list: [conv], messagesLoaded: true });
      _this.props.push('/workspace/inbox/' + conv.messageId);
    };

    _this.state = {
      hoveredConv: {}
    };
    return _this;
  }

  _createClass(ConversationList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var selectedChannel = this.props.selectedChannel;

      this.props.loadConvList('notdone', !Boolean(selectedChannel));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.timer) this.timer = setInterval(this.timedUpdate, 4e3);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classes = _props.classes,
          className = _props.className,
          convList = _props.convList,
          loadingConvList = _props.loadingConvList,
          params = _props.params,
          selectedChannel = _props.selectedChannel,
          selectedContract = _props.selectedContract,
          viewerCompany = _props.viewerCompany;
      var hoveredConv = this.state.hoveredConv;

      var emptyConvs = Boolean(!loadingConvList && _ramda2.default.isEmpty(convList));
      var paramsFilter = params.filter || 'notdone';
      return _react2.default.createElement(
        'div',
        { className: 'l-left-nav ' + className + ' ' + classes.main },
        _react2.default.createElement(
          'div',
          { className: classes.channelsTitle },
          'Unassigned'
        ),
        _react2.default.createElement(
          'div',
          null,
          emptyConvs && _react2.default.createElement(
            'div',
            { className: classes.emptyConvs },
            _react2.default.createElement(_forum2.default, { className: classes.forumIcon }),
            _react2.default.createElement(
              'h4',
              { style: { color: 'rbga(0, 0, 0, 0.44)' } },
              'No ',
              paramsFilter === 'notdone' ? '' : (0, _titlecase.toTitleCase)(paramsFilter),
              ' Conversations'
            )
          ),
          !_ramda2.default.isEmpty(convList) && _ramda2.default.sort(_ramda2.default.descend(_ramda2.default.prop('updatedAt')), convList).map(function (conv, convIndex) {
            // if both participant are viewers, they sent msg to themselves
            // const participant = (() => {
            //   if (conv.contractId) return { name: conv.contractName, type: 'contract' };
            //   const recipients = R.reject(R.propEq('isViewer', true), conv.participants);
            //   return recipients[0] || viewerCompany;
            // })();
            var isSelected = conv.messageId === selectedChannel || selectedContract && conv.contractId === selectedContract;
            var isHovered = conv.messageId === hoveredConv.messageId;
            return _react2.default.createElement(
              'div',
              { key: conv.messageId, style: convIndex === convList.length - 1 ? { marginBottom: '44px' } : {} },
              _react2.default.createElement(
                'div',
                {
                  className: '' + classes.aConv + (isSelected ? ' selected' : ''),
                  onClick: isSelected ? function () {} : function () {
                    return _this2.openAConv(conv);
                  },
                  onMouseEnter: function onMouseEnter() {
                    return _this2.setState({ hoveredConv: conv });
                  },
                  onMouseLeave: function onMouseLeave() {
                    return _this2.setState({ hoveredConv: {} });
                  }
                },
                _react2.default.createElement(
                  'div',
                  { className: 'flex-tc-sb' },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'center', width: '70%' } },
                    _react2.default.createElement(
                      'span',
                      { className: '' + classes.participanName },
                      conv.creatorEmail
                    )
                  ),
                  _react2.default.createElement(_timeNWidget2.default, {
                    toggleDone: function toggleDone(val) {
                      return _this2.setState({ hoveredDone: val });
                    },
                    isHovered: isHovered,
                    hoveredDone: _this2.state.hoveredDone,
                    conv: conv,
                    markAsDone: _this2.props.toggleConvDone,
                    classes: classes
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: '' + classes.latestMessage + (conv.hasSeen ? ' seen' : '') },
                  conv.subject
                )
              ),
              _react2.default.createElement(_materialUi.Divider, null)
            );
          })
        )
      );
    }
  }]);

  return ConversationList;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var messaging = _ref.messaging,
      user = _ref.user,
      workspace = _ref.workspace;
  return _extends({}, messaging.conversations.toJS(), {
    viewerCompany: {
      id: user.toJS().company.companyId,
      name: user.toJS().company.companyName,
      avatarUrl: user.toJS().company.profileImageUrl,
      type: 'account'
    },
    selectedChannel: workspace.selectedChannel,
    selectedContract: workspace.selectedContract
  });
};

ConversationList.propTypes = propTypes;
exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  decrementUnreadCount: function decrementUnreadCount() {
    return { type: 'DECREMENT_UNREAD_MESSAGES_COUNT' };
  },
  initialLoadAMsg: _messagingActions.initialLoadAMsg,
  loadConvList: _messagingActions.loadConvList,
  push: _reactRouterRedux.push,
  toggleConvDone: _messagingActions.toggleConvDone,
  updateProps: _messagingActions.updateProps
})((0, _reactJss2.default)(styles)(ConversationList));

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationComment = function CommunicationComment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
  );
};
CommunicationComment = (0, _pure2.default)(CommunicationComment);
CommunicationComment.displayName = 'CommunicationComment';
CommunicationComment.muiName = 'SvgIcon';

exports.default = CommunicationComment;

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _messages = __webpack_require__(3550);

var _messages2 = _interopRequireDefault(_messages);

var _comment = __webpack_require__(2041);

var _comment2 = _interopRequireDefault(_comment);

var _messagingActions = __webpack_require__(562);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  channelId: _react.PropTypes.string,
  classes: _react.PropTypes.object,
  className: _react.PropTypes.string,
  initialLoadAMsg: _react.PropTypes.func,
  loadingMessages: _react.PropTypes.bool,
  messages: _react.PropTypes.array,
  messagesLoaded: _react.PropTypes.bool,
  params: _react.PropTypes.object
};

var styles = {
  title: {
    color: 'white',
    fontSize: '18px',
    flex: '1 0 auto',
    lineHeight: '48px',
    paddingLeft: '10px',
    backgroundColor: 'rgb(0, 164, 186)',
    height: '48px !important'
  }
};

var RightMsgsRouter = function (_React$Component) {
  _inherits(RightMsgsRouter, _React$Component);

  function RightMsgsRouter() {
    _classCallCheck(this, RightMsgsRouter);

    return _possibleConstructorReturn(this, (RightMsgsRouter.__proto__ || Object.getPrototypeOf(RightMsgsRouter)).apply(this, arguments));
  }

  _createClass(RightMsgsRouter, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          params = _props.params,
          initialLoadAMsg = _props.initialLoadAMsg;

      var convIdFromUrl = (params || {}).channelId;
      // const convIdFromUrl = (params || {}).convId;
      if (convIdFromUrl) initialLoadAMsg(convIdFromUrl);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var currentChannelIdFromParams = _ramda2.default.path(['params', 'channelId'], this.props);
      var nextChannelIdFromParams = _ramda2.default.path(['params', 'channelId'], nextProps);
      if (currentChannelIdFromParams && currentChannelIdFromParams !== nextChannelIdFromParams && nextChannelIdFromParams) {
        this.props.initialLoadAMsg(nextChannelIdFromParams);
      }
      if (!currentChannelIdFromParams && nextProps.channelId) {
        this.context.router.push('/workspace/inbox/' + nextProps.channelId);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react2.default.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          messagesLoaded = _props2.messagesLoaded,
          className = _props2.className,
          classes = _props2.classes,
          messages = _props2.messages;

      return _react2.default.createElement(
        'div',
        { className: 'l-left-nav-content ' + className, style: { width: 'calc(100% - 628px)', overflowY: 'scroll' } },
        messages.length > 0 ? _react2.default.createElement(
          'div',
          { className: classes.title },
          messages[0].subject || ''
        ) : undefined,
        messages.length < 1 && !messagesLoaded ? _react2.default.createElement(
          'div',
          { style: { textAlign: 'center', marginTop: '200px' } },
          _react2.default.createElement(_comment2.default, { style: { color: 'rgba(0, 0, 0, 0.24)', height: '56px', width: '56px' } })
        ) : _react2.default.createElement(_messages2.default, this.props)
      );
    }
  }]);

  return RightMsgsRouter;
}(_react2.default.Component);

RightMsgsRouter.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref) {
  var messaging = _ref.messaging;
  return {
    loadingMessages: messaging.messages.get('loadingMessages'),
    messagesLoaded: messaging.messages.get('messagesLoaded'),
    channelId: messaging.messages.getIn(['conv', '_id']),
    messages: messaging.messages.toJS().list
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    initialLoadAMsg: function initialLoadAMsg() {
      return dispatch(_messagingActions.initialLoadAMsg.apply(undefined, arguments));
    }
  };
};
RightMsgsRouter.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(RightMsgsRouter));

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _messagingAvatar = __webpack_require__(1271);

var _messagingAvatar2 = _interopRequireDefault(_messagingAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageWrapper = function MessageWrapper(_ref) {
  var children = _ref.children,
      avatarInfo = _ref.avatarInfo,
      timestamp = _ref.timestamp,
      isSender = _ref.isSender;

  var time = (0, _moment2.default)(new Date(timestamp)).format('D MMM YYYY, H:mm');
  return _react2.default.createElement(
    'div',
    {
      style: {
        display: 'flex',
        marginBottom: '24px',
        flexDirection: isSender ? 'row-reverse' : 'row',
        alignItems: 'flex-start'
      }
    },
    _react2.default.createElement(
      'div',
      { style: { width: '40px', textAlign: isSender ? 'right' : 'left' } },
      _react2.default.createElement(_messagingAvatar2.default, _extends({}, avatarInfo, {
        tooltipPosition: isSender ? 'bottom-left' : 'bottom-right'
      }))
    ),
    _react2.default.createElement(
      'div',
      { style: { maxWidth: 'calc(88% - 44px)', textAlign: isSender ? 'right' : 'left' } },
      _react2.default.createElement(
        'div',
        {
          className: isSender ? 'right-arrow-bubble' : 'left-arrow-bubble'
        },
        _react2.default.createElement(
          'div',
          {
            style: { width: '100%', minHeight: '40px', textAlign: 'left', display: 'inline-block', padding: '16px' }
          },
          children
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)', marginBottom: '8px', textAlign: isSender ? 'right' : 'left' } },
        time
      )
    )
  );
};

MessageWrapper.propTypes = {
  children: _react.PropTypes.node,
  avatarInfo: _react.PropTypes.object,
  timestamp: _react.PropTypes.string,
  isSender: _react.PropTypes.bool
};

exports.default = MessageWrapper;

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanyWithLocs = function CompanyWithLocs(_ref) {
  var profileImageUrl = _ref.profileImageUrl,
      companyName = _ref.companyName,
      locations = _ref.locations;

  return _react2.default.createElement(_materialUi.ListItem, {
    leftAvatar: profileImageUrl ? _react2.default.createElement(_materialUi.Avatar, { src: profileImageUrl }) : _react2.default.createElement(
      _materialUi.Avatar,
      null,
      _ramda2.default.head(companyName || '')
    ),
    primaryText: companyName + ' : ' + _ramda2.default.length(locations) + ' ' + (0, _pluralize2.default)('location', _ramda2.default.length(locations)),
    nestedItems: locations.map(function (_ref2) {
      var name = _ref2.name,
          locationId = _ref2.locationId;
      return _react2.default.createElement(_materialUi.ListItem, {
        key: locationId,
        primaryText: name,
        leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-location_on' })
      });
    })
  });
};

exports.default = CompanyWithLocs;

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSecondaryTemplateProps = updateSecondaryTemplateProps;
exports.renameTemplate = renameTemplate;
exports.deleteTemplate = deleteTemplate;
exports.createTemplate = createTemplate;
exports.typeName = typeName;

var _constants = __webpack_require__(630);

var cnts = _interopRequireWildcard(_constants);

var _constants2 = __webpack_require__(579);

var cnt = _interopRequireWildcard(_constants2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function updateSecondaryTemplateProps(payload) {
  return { type: cnts.UPDATE_TEMPLATE_PROPS, payload: payload };
}

function renameTemplate(payload) {
  return { type: cnts.RENAME_TEMPLATE, payload: payload };
}

function deleteTemplate(payload) {
  return { type: cnts.DELETE_TEMPLATE, payload: payload };
}

function createTemplate() {
  return { type: cnts.CREATE };
}

function typeName(_ref) {
  var value = _ref.target.value;

  return { type: cnts.TYPE_NAME, payload: value };
}

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareDeviceHub = function HardwareDeviceHub(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z' })
  );
};
HardwareDeviceHub = (0, _pure2.default)(HardwareDeviceHub);
HardwareDeviceHub.displayName = 'HardwareDeviceHub';
HardwareDeviceHub.muiName = 'SvgIcon';

exports.default = HardwareDeviceHub;

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _actions = __webpack_require__(741);

var _contractingPresetNamesCodes = __webpack_require__(464);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var OverwriteRules = function OverwriteRules(props) {
  var style = props.style,
      honorPreloadContent = props.honorPreloadContent,
      checkHonor = props.checkHonor,
      sameAsCorporatePolicyNotes = props.sameAsCorporatePolicyNotes,
      checkSameAsCorporate = props.checkSameAsCorporate,
      _props$classes = props.classes,
      classes = _props$classes === undefined ? {} : _props$classes;

  var availableSections = Object.keys(_contractingPresetNamesCodes.policyNotesSections);
  return _react2.default.createElement(
    'div',
    {
      style: _extends({
        width: '30%',
        borderLeft: '1px solid #efefef',
        padding: '16px'
      }, style)
    },
    _react2.default.createElement(
      'div',
      { className: classes.applyStepperLabel },
      'Step 2: Select the sections that should be applied to your templates'
    ),
    _react2.default.createElement(_materialUi.Checkbox, {
      checked: availableSections.length === sameAsCorporatePolicyNotes.length,
      label: 'Select All',
      style: { margin: '16px 0' },
      onCheck: function onCheck() {
        return checkSameAsCorporate(availableSections.length === sameAsCorporatePolicyNotes.length ? [] : availableSections);
      }
    }),
    availableSections.map(function (key) {
      var checked = _ramda2.default.contains(key, sameAsCorporatePolicyNotes);
      return _react2.default.createElement(_materialUi.Checkbox, {
        key: key,
        checked: checked,
        label: _contractingPresetNamesCodes.policyNotesSections[key],
        onCheck: function onCheck() {
          return checkSameAsCorporate(checked ? sameAsCorporatePolicyNotes.filter(function (str) {
            return str !== key;
          }) : [].concat(_toConsumableArray(sameAsCorporatePolicyNotes), [key]));
        }
      });
    }),
    _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '16px', marginBottom: '16px' } }),
    _react2.default.createElement(
      'div',
      {
        className: classes.applyStepperLabel
      },
      'Step 3: In the event that there are already policies or notes loaded in these sections'
    ),
    _react2.default.createElement(_materialUi.RadioButton, {
      checked: !honorPreloadContent,
      label: 'Replace all sections with the Corporate Policies & Notes',
      style: { margin: '16px 0' },
      onCheck: function onCheck() {
        return checkHonor(false);
      }
    }),
    _react2.default.createElement(_materialUi.RadioButton, {
      checked: honorPreloadContent,
      label: 'Do not replace the pre-loaded information',
      style: { margin: '16px 0' },
      onCheck: function onCheck() {
        return checkHonor(true);
      }
    })
  );
};

OverwriteRules.propTypes = {
  style: _react2.default.PropTypes.object,
  honorPreloadContent: _react2.default.PropTypes.bool,
  checkHonor: _react2.default.PropTypes.func,
  classes: _react2.default.PropTypes.object,
  sameAsCorporatePolicyNotes: _react.PropTypes.array,
  checkSameAsCorporate: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var applyMasterToTemplatesReducer = _ref.contracting.masterTemplate.applyMasterToTemplatesReducer;

  return _extends({}, applyMasterToTemplatesReducer);
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  checkSameAsCorporate: _actions.checkSameAsCorporate,
  checkHonor: _actions.checkHonor
})(OverwriteRules);

/***/ }),
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */,
/* 2471 */,
/* 2472 */,
/* 2473 */,
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */,
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */,
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */,
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */,
/* 2598 */,
/* 2599 */,
/* 2600 */,
/* 2601 */,
/* 2602 */,
/* 2603 */,
/* 2604 */,
/* 2605 */,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */,
/* 2611 */,
/* 2612 */,
/* 2613 */,
/* 2614 */,
/* 2615 */,
/* 2616 */,
/* 2617 */,
/* 2618 */,
/* 2619 */,
/* 2620 */,
/* 2621 */,
/* 2622 */,
/* 2623 */,
/* 2624 */,
/* 2625 */,
/* 2626 */,
/* 2627 */,
/* 2628 */,
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */,
/* 2633 */,
/* 2634 */,
/* 2635 */,
/* 2636 */,
/* 2637 */,
/* 2638 */,
/* 2639 */,
/* 2640 */,
/* 2641 */,
/* 2642 */,
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(47);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactTapEventPlugin = __webpack_require__(260);

var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);

var _jss = __webpack_require__(1047);

var _jss2 = _interopRequireDefault(_jss);

var _jssPresetDefault = __webpack_require__(1211);

var _jssPresetDefault2 = _interopRequireDefault(_jssPresetDefault);

var _configureStore = __webpack_require__(2644);

var _configureStore2 = _interopRequireDefault(_configureStore);

var _root = __webpack_require__(2718);

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(250); // FOR WEBPACK


_jss2.default.setup((0, _jssPresetDefault2.default)());

var store = (0, _configureStore2.default)();
(0, _reactTapEventPlugin2.default)();

_reactDom2.default.render(_react2.default.createElement(_root2.default, { store: store }), document.getElementById('app'));

/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Use DefinePlugin (Webpack) or loose-envify (Browserify)
// together with Uglify to strip the dev branch in prod build.
if (true) {
  module.exports = __webpack_require__(2645);
} else {
  module.exports = require('./configureStore.dev');
}

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = __webpack_require__(131);

var _reducers = __webpack_require__(2646);

var _reducers2 = _interopRequireDefault(_reducers);

var _reduxThunk = __webpack_require__(622);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxSaga = __webpack_require__(92);

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _controlledRouteChange = __webpack_require__(2716);

var _controlledRouteChange2 = _interopRequireDefault(_controlledRouteChange);

var _accessCheck = __webpack_require__(2717);

var _accessCheck2 = _interopRequireDefault(_accessCheck);

var _sagas = __webpack_require__(43);

var _sagas2 = _interopRequireDefault(_sagas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sagaMiddleware = (0, _reduxSaga2.default)();

var finalCreateStore = (0, _redux.compose)(
// Middleware you want to use in production:
(0, _redux.applyMiddleware)(_reduxThunk2.default, sagaMiddleware, _controlledRouteChange2.default, _accessCheck2.default)
// Other store enhancers if you use any
)(_redux.createStore);

function configureStore(initialState) {
  var store = finalCreateStore(_reducers2.default, initialState);
  sagaMiddleware.run(_sagas2.default);
  return store;
}

/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.globalAlert = globalAlert;

var _redux = __webpack_require__(131);

var _billingReducer = __webpack_require__(2647);

var _reducer = __webpack_require__(2648);

var _tempConnectionsReducer = __webpack_require__(2649);

var _configReducer = __webpack_require__(2650);

var _routeReducer = __webpack_require__(909);

var _tagsReducer = __webpack_require__(2651);

var _userReducer = __webpack_require__(1412);

var _settingsReducer = __webpack_require__(2652);

var _reducer2 = __webpack_require__(1413);

var _reducer3 = __webpack_require__(2653);

var _reducer4 = _interopRequireDefault(_reducer3);

var _companyReducer = __webpack_require__(2654);

var _locationReducer = __webpack_require__(2655);

var _productReducer = __webpack_require__(2656);

var _profileReducer = __webpack_require__(2657);

var _reducer5 = __webpack_require__(2662);

var _reducer6 = _interopRequireDefault(_reducer5);

var _locationReducer2 = __webpack_require__(2663);

var _productReducer2 = __webpack_require__(2664);

var _connectionsReducer = __webpack_require__(2665);

var _connectionsStatsReducer = __webpack_require__(2666);

var _onboardingReducer = __webpack_require__(2667);

var _integrationReducer = __webpack_require__(2668);

var _contractingReducer = __webpack_require__(2669);

var _contractingReducer2 = _interopRequireDefault(_contractingReducer);

var _reducer7 = __webpack_require__(2694);

var _reducer8 = __webpack_require__(2695);

var _messagingReducer = __webpack_require__(2696);

var _messagingReducer2 = _interopRequireDefault(_messagingReducer);

var _reducer9 = __webpack_require__(2700);

var _reducer10 = _interopRequireDefault(_reducer9);

var _partnerFinderReducer = __webpack_require__(2701);

var _profileEditModalReducer = __webpack_require__(2702);

var _copyPasteReducer = __webpack_require__(2703);

var _reducer11 = __webpack_require__(2704);

var _reducer12 = _interopRequireDefault(_reducer11);

var _reducer13 = __webpack_require__(2707);

var _reducer14 = _interopRequireDefault(_reducer13);

var _metaDataReducer = __webpack_require__(2708);

var _metaDataReducer2 = _interopRequireDefault(_metaDataReducer);

var _reducer15 = __webpack_require__(1445);

var _globalErrorsDisplayReducer = __webpack_require__(2709);

var _uiReducer = __webpack_require__(1446);

var _uiReducer2 = _interopRequireDefault(_uiReducer);

var _reactRouterRedux = __webpack_require__(27);

var _reducer16 = __webpack_require__(2710);

var _reducer17 = __webpack_require__(2711);

var _reducer18 = __webpack_require__(1451);

var _reducer19 = _interopRequireDefault(_reducer18);

var _reducer20 = __webpack_require__(2712);

var _reducer21 = _interopRequireDefault(_reducer20);

var _reducer22 = __webpack_require__(2713);

var _reducer23 = _interopRequireDefault(_reducer22);

var _reducer24 = __webpack_require__(2714);

var _reducer25 = _interopRequireDefault(_reducer24);

var _reducers = __webpack_require__(1452);

var _reducers2 = _interopRequireDefault(_reducers);

var _reducer26 = __webpack_require__(2715);

var _reducer27 = _interopRequireDefault(_reducer26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  text: '',
  open: false,
  onOk: null
};

function globalAlert() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'open_global_alert':
      return _extends({}, state, {
        open: true,
        text: payload.text,
        onOk: payload.onOk
      });
    case 'close_global_alert':
      return initialState;
    default:
      return state;
  }
}

exports.default = (0, _redux.combineReducers)({
  ui: _uiReducer2.default,
  messaging: _messagingReducer2.default,
  notification: _reducer10.default,
  billing: _billingReducer.billing,
  contracting: _contractingReducer2.default,
  dashboard: _reducer.dashboard,
  tempConnections: _tempConnectionsReducer.tempConnections,
  editFieldModal: _profileEditModalReducer.editFieldModal,
  config: _configReducer.config,
  route: _routeReducer.route,
  routing: _reactRouterRedux.routerReducer,
  tags: _tagsReducer.tags,
  user: _userReducer.user,
  companyProfile: _companyReducer.companyProfile,
  companyLocation: _locationReducer.companyLocation,
  companyProduct: _productReducer.companyProduct,
  profile: _profileReducer.profile,
  membershipsReducer: _reducer6.default,
  profileLocation: _locationReducer2.profileLocation,
  profileProduct: _productReducer2.profileProduct,
  connections: _connectionsReducer.connections,
  connectionsStats: _connectionsStatsReducer.connectionsStats,
  onboarding: _onboardingReducer.onboarding,
  integration: _integrationReducer.integration,
  partnerFinder: _partnerFinderReducer.partnerFinder,
  settings: _settingsReducer.settings,
  copyPaste: _copyPasteReducer.copyPaste,
  marketingMaterials: _reducer12.default,
  contractingDashboard: _reducer7.contractingDashboard,
  contractingReports: _reducer8.contractingReports,
  newsfeed: _reducer14.default,
  newsfeedMetaData: _metaDataReducer2.default,
  publicPost: _reducer15.publicPost,
  globalErrors: _globalErrorsDisplayReducer.globalErrors,
  userManagement: _reducer4.default,
  publicNotifications: _reducer2.publicNotifications,
  workspace: _reducer16.workspace,
  massmessaging: _reducer17.massmessaging,
  sidebarHelp: _reducer19.default,
  assetsConsolidation: _reducer21.default,
  partnerDetails: _reducer23.default,
  settingsReducer: _reducer25.default,
  dummyAcct: _reducers2.default,
  walls: _reducer27.default,
  globalAlert: globalAlert
});

/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billing = billing;

var _immutable = __webpack_require__(26);

var _billingConstants = __webpack_require__(1839);

var constants = _interopRequireWildcard(_billingConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({
  isInitial: true,
  errorMessage: '',
  invoices: [],
  hasMoreInvoices: false
});

var defaultErrorMessage = 'An unknown error has happened. Please try again or contact support@tourconnect.com';

function billing() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case constants.BILLING_ERROR:
      {
        return state.merge({ errorMessage: action.payload.message || defaultErrorMessage });
      }
    case constants.RESET_BILLING_ERROR:
      {
        return state.merge({ errorMessage: '' });
      }
    case constants.BILLING_LOADING:
      {
        return state.merge({ isLoading: action.loading });
      }
    case constants.CANCEL_SUBSCRIPTION:
      {
        return state.merge({ cancelAtPeriodEnd: true });
      }
    case constants.GET_COUPON:
      {
        return state.merge({ coupon: action.payload });
      }
    case '{billing} getInvoices_SUCCESS':
      return state.merge({
        invoices: action.payload.data,
        hasMoreInvoices: action.payload.has_more
      });
    case 'SELECT_PLAN':
    case 'GET_BILLING':
    case 'ADD_CREDIT_CARD':
    case 'UPGRADE_PLAN':
      if (state === initialState) return (0, _immutable.Map)(action.payload);
      return state.merge((0, _immutable.Map)(action.payload));
    case 'CLEAR_STORES':
    case 'LOG_OUT':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.dashboard = dashboard;

var _constants = __webpack_require__(1840);

var initialState = {
  isFetching: true,
  showOnboardingDialog: false
};

function dashboard() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _constants.DASHBOARD_INITIALIZE_SUCCESS:
      {
        return _extends({}, state, { isFetching: false });
      }
    case _constants.DASHBOARD_SHOW_ONBOARDING_DIALOG:
      {
        return _extends({}, state, { showOnboardingDialog: true });
      }
    case _constants.DASHBOARD_CLOSE_ONBOARDING_DIALOG:
      {
        return _extends({}, state, { showOnboardingDialog: false });
      }
    default:
      return state;
  }
}

/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tempConnections = tempConnections;

var _immutable = __webpack_require__(26);

var _tempConnectionsConstants = __webpack_require__(1841);

var constants = _interopRequireWildcard(_tempConnectionsConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createEmptyConnection = function createEmptyConnection() {
  return (0, _immutable.Map)({
    recordValid: false,
    companyName: '',
    email: '',
    firstName: '',
    lastName: ''
  });
};
var initialState = (0, _immutable.Map)({
  allRecordsValid: false,
  persistedFromServer: false,
  processed: false,
  emailValidLength: true,
  connections: (0, _immutable.OrderedMap)(_defineProperty({}, new Date() + Math.random(), createEmptyConnection()))
});

var validEmail = function validEmail(email) {
  var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
  return String(email).search(filter) !== -1;
};

var checkIfValidRecord = function checkIfValidRecord(state, mapKey, valueKey, value) {
  if (state.getIn(['connections', mapKey, 'email']) && validEmail(state.getIn(['connections', mapKey, 'email'])) || value && valueKey === 'email' && validEmail(value) || valueKey !== 'email' && state.getIn(['connections', mapKey, 'email'])) {
    return true;
  }
  return false;
};

var checkIfAllRecordsValid = function checkIfAllRecordsValid(state) {
  return state.get('connections').every(function (record) {
    return record.get('recordValid');
  });
};

var changeValue = function changeValue(state, payload) {
  var mapKey = payload.mapKey,
      valueKey = payload.valueKey,
      value = payload.value;

  var focusValue = void 0;
  var recordValid = checkIfValidRecord(state, mapKey, valueKey, value);
  if (valueKey === 'companyName') focusValue = 'hasFocusedCompanyName';
  if (valueKey === 'email') focusValue = 'hasFocusedEmail';
  var newState = state.setIn(['connections', mapKey, valueKey], value).setIn(['connections', mapKey, 'recordValid'], recordValid);
  if (focusValue) newState = newState.setIn(['connections', mapKey, focusValue], true);
  return newState.set('allRecordsValid', checkIfAllRecordsValid(newState));
};

var resetConnectionsToDefaults = function resetConnectionsToDefaults() {
  return initialState.set('isUsingInputs', false).set('allInvitationsProcessed', false).set('emailValue', '').set('allRecordsValid', false);
};

var isEmptyConnection = function isEmptyConnection(connection) {
  return !(Boolean(connection.get('companyName')) || Boolean(connection.get('email')) || Boolean(connection.get('firstName')) || Boolean(connection.get('lastName')));
};

var setRowToSave = function setRowToSave(state, row, index) {
  var newState = void 0;
  if (state.get('connections').size === 1 && state.get('connections').every(function (connection) {
    return isEmptyConnection(connection);
  })) {
    newState = state.set('connections', (0, _immutable.OrderedMap)(_defineProperty({}, new Date() + Math.random() + index, row)));
  } else {
    newState = state.setIn(['connections', new Date() + Math.random() + index], row);
  }
  return newState;
};

var convertFromCSV = function convertFromCSV(state, csv) {
  var oldState = (0, _immutable.Map)(state);
  var newState = void 0;
  newState = state.set('previousState', oldState);
  var rows = (0, _immutable.List)(csv.split(/\r\n|\n|\r/));
  var headers = ['companyName', 'email', 'firstName', 'lastName'];
  var invalidRecords = (0, _immutable.List)();
  rows.forEach(function (row, rowIndex) {
    var content = row.split(',');
    var rowToSave = (0, _immutable.Map)();
    var invalidRecord = (0, _immutable.List)();
    var errors = (0, _immutable.Map)();
    var allBlank = true;
    headers.forEach(function (item, columnIndex) {
      var value = content[columnIndex] ? content[columnIndex].replace(/["]/g, '').trim() : '';
      if (value) allBlank = false;
      if (columnIndex === 1 && !validEmail(value)) {
        invalidRecord = rowToSave.size ? rowToSave.toList().push(value) : invalidRecord.push(value);
        errors = errors.set('line', rowIndex + 1).set('invalidEmail', true);
      } else if (invalidRecord.size) {
        invalidRecord = invalidRecord.push(value);
      } else {
        rowToSave = rowToSave.set(headers[columnIndex], value);
      }
    });
    if (!allBlank) {
      if (errors.size) invalidRecord = invalidRecord.push(errors);
      if (invalidRecord.size) {
        invalidRecords = invalidRecords.push(invalidRecord);
      } else {
        rowToSave = rowToSave.set('recordValid', true);
        newState = setRowToSave(newState, rowToSave, rowIndex);
      }
    }
  });
  if (invalidRecords.size) newState = newState.set('invalidRecords', invalidRecords);
  return newState.set('processed', true).set('allRecordsValid', checkIfAllRecordsValid(newState));
};

var checkIfAllProcessed = function checkIfAllProcessed(state, invitations, allProccessed) {
  // !! for type casting to a Bool
  var returnState = state.set('sendingEmails', false);
  if (allProccessed) return returnState.set('allInvitationsProcessed', true).set('processing', false);
  return returnState.set('allInvitationsProcessed', false).set('processing', false);
};

var setReceivedConnections = function setReceivedConnections(state, payload) {
  var newState = state.set('connections', (0, _immutable.OrderedMap)());

  var connectionInfo = (0, _immutable.Map)({
    recordValid: false
  });

  var allInvitationsProcessed = true;

  if (!payload.invitations || !Array.isArray(payload.invitations)) {
    newState = newState.setIn(['connections', new Date() + Math.random()], connectionInfo).set('allRecordsValid', false).set('allInvitationsProcessed', false);
  } else {
    payload.invitations.forEach(function (invitation, index) {
      if (allInvitationsProcessed) {
        allInvitationsProcessed = invitation && !!invitation.status && invitation.status.newState === 'processed';
      }
      newState = newState.setIn(['connections', new Date() + Math.random() + index], (0, _immutable.Map)({ // probably overkill on randomization but just in case;
        companyName: invitation.companyName,
        email: invitation.email,
        firstName: invitation.firstName,
        lastName: invitation.lastName,
        recordValid: Boolean(invitation.companyName) && Boolean(invitation.email)
      }));
    });
    newState = newState.set('processed', true).set('allInvitationsProcessed', allInvitationsProcessed).set('persistedFromServer', true).set('allRecordsValid', checkIfAllRecordsValid(newState));
  }
  return newState;
};

function tempConnections() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'CANCEL_CSV_HEADER_SELECTION':
      return resetConnectionsToDefaults();
    case 'CHANGE_EMAIL_VALUE':
      return state.set('emailValue', action.payload).set('emailValidLength', action.payload.length <= 500);
    case 'CHANGE_NEW_CONNECTION_VALUE':
      return changeValue(state, action.payload);
    case 'SEND_TEMP_CONNECTIONS':
      return checkIfAllProcessed(state, action.payload.invitations, action.payload.allProcessed);
    case 'IS_PERSISTED_FROM_SERVER':
      return state.set('persistedFromServer', true);
    case 'CONVERT_FROM_CSV':
      return convertFromCSV(state, action.payload);
    case 'DELETED_TEMP_CONNECTIONS':
      return state.set('persistedFromServer', false);
    case 'ACCEPTED_CSV_SELECTION':
      return state.delete('previousState').delete('invalidRecords');
    case 'CANCELED_CSV_SELECTION':
      return state.get('previousState').delete('previousState');
    case 'SEND_TEMP_CONNECTIONS_STARTING':
      return state.set('processing', true);
    case 'SEND_EMAIL_TO_TEMP_CONNECTIONS_STARTING':
      return state.set('sendingEmails', true);
    case 'RECEIVE_ADD_CONNECTIONS':
      return setReceivedConnections(state, action.payload);
    case 'REMOVE_ADD_INVITATION':
      var newState = state.deleteIn(['connections', action.payload]);
      return newState.set('allRecordsValid', checkIfAllRecordsValid(newState));
    case 'NEW_ADD_CONNECTIONS':
      return state.setIn(['connections', new Date() + Math.random()], createEmptyConnection()).set('allRecordsValid', false).set('processed', false);
    case 'SEND_EMAIL_TO_TEMP_CONNECTIONS':
      return resetConnectionsToDefaults().set('report', action.payload.report).set('emailStatuses', (0, _immutable.Map)(action.payload.statuses)).set('sendingEmails', false);
    case constants.UPDATE_TEMP_CONN_PROP:
      return state.merge((0, _immutable.fromJS)(action.payload));
    case 'CLEAR_STORES':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = config;

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.Map)({
  apiUrl: null,
  domainUrl: null,
  version: null,
  locale: 'en-US',
  firstFrameLoad: false
});

function config() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'FIRST_FRAME_LOAD':
      return state.set('firstFrameLoad', true);
    case 'CLEAR_STORES':
    case 'LOG_OUT':
      return state.set('firstFrameLoad', false);
    case 'GET_CONFIG':
      return state.merge(action.config);
    default:
      return state;
  }
}

/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tags = tags;

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.List)([]);

function tags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'ADD_TAG_STARTING':
      var mappedTags = state.toJS().length ? state.toJS().map(function (tagObj) {
        return tagObj.tag;
      }) : [];
      if (mappedTags.indexOf(action.payload.tagName) === -1) return state.push({ _id: undefined, tag: action.payload.tagName });
      return state;
    case 'GET_TAGS':
      return (0, _immutable.List)(action.payload.tags);
    case 'DELETED_TAG':
      var removeTag = state.toJS().filter(function (tag) {
        return tag._id !== action.payload.tadId;
      });
      return (0, _immutable.fromJS)(removeTag);
    case 'CLEAR_STORES':
    case 'LOG_OUT':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settings = settings;

var _settingsConstants = __webpack_require__(1842);

var constants = _interopRequireWildcard(_settingsConstants);

var _immutable = __webpack_require__(26);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createEmptyTempUser = function createEmptyTempUser(currentUserRole) {
  var userRole = '';

  if (currentUserRole && currentUserRole.toString().indexOf('supplier') > -1) {
    userRole = 'supplier admin';
  } else if (currentUserRole && currentUserRole.toString().indexOf('contractor') > -1) {
    userRole = 'contractor admin';
  }

  return (0, _immutable.Map)({
    first_name: '',
    last_name: '',
    role: userRole,
    email: ''
  });
};

var initialState = (0, _immutable.fromJS)({
  oldPassword: '',
  newPassword: '',
  confNewPassword: '',
  passResetMessage: {},
  connectionNotificationsEnabled: false,
  currentUserRole: '',
  currentUserEmail: '',
  secondaryEmails: [],
  secondaryEmailsInfo: undefined,
  usersArray: [],
  isHydratedFromServer: false,
  tempUsers: (0, _immutable.OrderedMap)(_defineProperty({}, 0, createEmptyTempUser())),
  addUserMessage: {},
  editUserMessage: {},
  userBeingEdited: {},
  emailLinkProcessed: {},
  manageUsersMessage: undefined,
  allActiveUsers: []
});

function settings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case constants.UPDATE_SETTINGS_PROP:
      return state.merge((0, _immutable.fromJS)(action.payload));
    case 'PASSWORD_INPUT_MODIFIED':
      return state.merge((0, _immutable.Map)(action.payload));
    case 'RESET_PASSWORD':
      if (!action.payload.error) return state.merge((0, _immutable.Map)({ oldPassword: '', newPassword: '', confNewPassword: '', passResetMessage: action.payload }));
      return state.set('passResetMessage', action.payload);
    case 'TOGGLE_CONNECTION_NOTIFICATIONS':
      return state.merge((0, _immutable.Map)({ connectionNotificationsEnabled: JSON.parse(action.payload) }));
    case 'HYDRATE_FROM_SERVER':
      return state.merge((0, _immutable.Map)({
        isHydratedFromServer: true,
        connectionNotificationsEnabled: action.payload.connectionNotificationsEnabled,
        currentUserRole: action.payload.currentUserRole,
        currentUserEmail: action.payload.currentUserEmail,
        allActiveUsers: action.payload.allActiveUsers,
        usersArray: action.payload.usersArray,
        secondaryEmails: action.payload.secondaryEmails,
        tempUsers: state.get('tempUsers').merge((0, _immutable.OrderedMap)(_defineProperty({}, 0, createEmptyTempUser(action.payload.currentUserRole))))
      }));
    case 'ADDED_USER':
      if (action.payload.usersArray) return state.merge((0, _immutable.Map)({ usersArray: action.payload.usersArray }));
      return state;
    case constants.START_ADDING_NEW_USER:
      return state.set('addingNewUser', true);
    case 'ADD_TEMP_USER':
      return state.merge((0, _immutable.Map)({
        tempUsers: state.get('tempUsers').merge((0, _immutable.OrderedMap)(_defineProperty({}, state.get('tempUsers').size.toString(), createEmptyTempUser(state.get('currentUserRole')))))
      }));

    case 'DELETE_TEMP_USER':
      return state.merge((0, _immutable.Map)({
        tempUsers: state.get('tempUsers').delete(action.payload)
      }));

    case 'TEMP_USER_PROP_MODIFIED':
      return state.merge((0, _immutable.Map)({
        tempUsers: state.get('tempUsers').merge((0, _immutable.OrderedMap)(_defineProperty({}, action.payload.key, state.get('tempUsers').get(action.payload.key).merge((0, _immutable.Map)(_defineProperty({}, action.payload.propName, action.payload.newValue))))))
      }));

    case 'ADD_NEW_USERS':
      if (action.payload.emailExists === true) {
        return state.merge((0, _immutable.Map)({
          // usersArray: action.payload.usersArray,
          addingNewUser: false,
          addUserMessage: {
            emailExists: action.payload.emailExists,
            message: action.payload.message
          }
        }));
      }

      return state.merge((0, _immutable.Map)({
        addingNewUser: false,
        usersArray: action.payload.usersArray,
        tempUsers: (0, _immutable.OrderedMap)(_defineProperty({}, 0, createEmptyTempUser(state.get('currentUserRole')))),
        addUserMessage: {
          emailExists: action.payload.emailExists,
          message: action.payload.message
        }
      }));

    case 'CLEAR_TEMP_USERS':
      return state.merge((0, _immutable.Map)({
        tempUsers: (0, _immutable.OrderedMap)(_defineProperty({}, 0, createEmptyTempUser(state.get('currentUserRole')))),
        addUserMessage: {}
      }));

    case 'CLEAR_ADD_USER_MESSAGE':
      return state.merge((0, _immutable.Map)({
        addUserMessage: {}
      }));
    case 'CLEAR_EDIT_USER_MESSAGE':
      return state.merge((0, _immutable.Map)({
        editUserMessage: {}
      }));
    case 'USER_APPROVED_OR_REJECTED':
    case 'USER_DISABLED':
    case 'USER_DELETED':
      return state.merge((0, _immutable.Map)({
        usersArray: action.payload
      }));

    case 'EDIT_USER_UPDATED':
      return state.merge((0, _immutable.Map)({
        userBeingEdited: action.payload
      }));

    case 'EDIT_USER_PROP_MODIFIED':
      return state.merge((0, _immutable.Map)({
        userBeingEdited: (0, _immutable.fromJS)(state.get('userBeingEdited')).merge((0, _immutable.Map)(action.payload)).toJS()
      }));

    case 'EDIT_USER_SAVED':
      if (action.payload.emailExists === true) {
        return state.merge((0, _immutable.Map)({
          editUserMessage: {
            emailExists: action.payload.emailExists,
            message: action.payload.message
          }
        }));
      }
      return state.merge((0, _immutable.Map)({
        usersArray: action.payload.usersArray,
        currentUserEmail: action.payload.currentUserEmail,
        editUserMessage: {
          emailExists: action.payload.emailExists,
          message: action.payload.message
        }
      }));
    case 'CONFIRM_SECONDARY_EMAIL':
    case 'CONFIRMED_DISASSOCIATE_SECONDARY_EMAIL':
    case 'ADD_SECONDARY_EMAIL':
      if (action.payload.secondaryEmails) {
        return state.set('secondaryEmails', action.payload.secondaryEmails).set('secondaryEmailsInfo', (0, _immutable.Map)({ error: action.payload.error,
          emailExists: action.payload.emailExists,
          message: action.payload.message
        }));
      }
      return state.set('secondaryEmailsInfo', (0, _immutable.Map)({ error: action.payload.error,
        emailExists: action.payload.emailExists,
        message: action.payload.message
      }));
    case 'RESEND_CONFIRMATION_SECONDARY_EMAIL':
      return state.set('secondaryEmailsInfo', (0, _immutable.Map)({ error: action.payload.error,
        emailExists: action.payload.emailExists,
        message: action.payload.message }));
    case 'RESEND_CONFIRMATION_LINK_USER_SETTINGS':
      return state.set('manageUsersMessage', 'Email sent to ' + action.payload);
    case 'CLEAR_MANAGE_USERS_MESSAGE':
      return state.set('manageUsersMessage', undefined);
    default:
      return state;
  }
}

/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = userManagement;

var _immutable = __webpack_require__(26);

var _constants = __webpack_require__(858);

var constants = _interopRequireWildcard(_constants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({
  viewBy: 'user',
  editedUser: {},
  originalUser: {}, // original version of editedUser
  acctAdmin: {},
  locationSort: [],
  updateUserError: '',
  usersArray: [],
  admin: [], // teams
  contracting: [], // teams

  // dialogs
  addingNewUserDialog: false,
  editUserDialog: false,

  // loaders
  addingNewUser: false,
  gettingUsers: false,
  updatingUser: false,
  deletingUser: false,
  gettingAdmin: false,
  approvingRejectingUser: false
});

function userManagement() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case constants.UPDATE_UM_PROP:
      return state.merge((0, _immutable.fromJS)(payload));
    case constants.ADD_USER_STARTING:
      return state.set('addingNewUser', true);
    case constants.ADDED_USER:
      return state.set('addingNewUser', false).merge((0, _immutable.fromJS)(payload));
    case constants.ADD_USER_FAILED:
      return state.set('addingNewUser', false);
    case constants.GETTING_USERS_BY_FILTER:
      return state.set('gettingUsers', true);
    case constants.GOT_USERS_BY_FILTER:
      return state.set('gettingUsers', false).merge((0, _immutable.fromJS)(payload));
    case constants.GETTING_USERS_BY_FILTER_FAILED:
      return state.set('gettingUsers', false);
    case constants.UPDATE_USER_STARTING:
      return state.set('updatingUser', true);
    case constants.UPDATED_USER:
      return state.set('updatingUser', false).merge((0, _immutable.fromJS)(payload));
    case constants.UPDATE_USER_FAILED:
      return state.set('updatingUser', false).set('updateUserError', payload.error);
    case constants.DELETE_USER_STARTING:
      return state.set('deletingUser', true);
    case constants.DELETE_USER_FAILED:
      return state.set('deletingUser', false);
    case constants.DELETED_USER:
      var viewBy = state.get('viewBy');
      var filterForPayload = function filterForPayload(list) {
        return list.filter(function (obj) {
          return obj.get('userId') !== payload;
        });
      };
      if (_ramda2.default.equals(viewBy, 'location')) return state.update('locationSort', filterForPayload).set('deletingUser', false);
      if (_ramda2.default.equals(viewBy, 'user')) return state.update('usersArray', function (list) {
        return list.filter(function (obj) {
          return obj.get('_id') !== payload;
        });
      }).set('deletingUser', false);
      return state.update('admin', filterForPayload).update('contracting', filterForPayload).set('deletingUser', false);
    case constants.GETTING_COMP_ADMIN:
      return state.set('gettingAdmin', true);
    case constants.GOT_COMP_ADMIN:
      return state.set('gettingAdmin', false).set('acctAdmin', (0, _immutable.fromJS)(payload));
    case constants.GETTING_COMP_ADMIN_FAILED:
      return state.set('gettingAdmin', false);
    case constants.APPROVE_REJECT_USER_STARTED:
      return state.set('approvingRejectingUser', true);
    case constants.APPROVE_REJECT_USER_DONE:
      return state.set('approvingRejectingUser', false).set('usersArray', (0, _immutable.fromJS)(payload.usersArray));
    case constants.APPROVE_REJECT_USER_FAILED:
      return state.set('approvingRejectingUser', false);
    default:
      return state;
  }
}

/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyProfile = companyProfile;

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.Map)();

function companyProfile() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'GET_COMPANY_PROFILE':
      return state.set(action.companyProfile.id, (0, _immutable.fromJS)(action.companyProfile));
    case 'CLEAR_STORES':
      return initialState;
    case 'CHANGE_CONNECTION':
    // return state.updateIn([company.id, 'connectionInfo'], connectionInfo => connectionInfo.map())
    case 'RESEND_INVITATION_PF':
    case 'FAKE_RESEND':
      if (state.get(action.companyId)) return state.setIn([action.companyId, 'connectionInfo', 'lastSent'], 'a few seconds ago');
      return state;
    case 'SEND_INVITATION_PF':
      var connectionInfo = action.payload;
      if (state.get(action.companyId)) return state.setIn([action.companyId, 'connectionInfo'], connectionInfo);
      return state;
    case 'IGNORE_CONNECTION_PF':
      if (state.get(action.companyId)) return state.setIn([action.companyId, 'connectionInfo', 'status'], 'rejected');
      return state;
    case 'ACCEPT_CONNECTION_PF':
      if (state.get(action.companyId)) return state.setIn([action.companyId, 'connectionInfo', 'status'], 'accepted');
      return state;
    default:
      return state;
  }
}

/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyLocation = companyLocation;

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.Map)();

function companyLocation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'GET_LOCATION_PROFILE':
      return state.set(action.payload.id, (0, _immutable.fromJS)(action.payload));
    case 'CLEAR_STORES':
      return initialState;
    case 'RESEND_INVITATION_PF':
    case 'FAKE_RESEND':
      if (state.get(action.companyId)) return state.setIn([action.locationId, 'connectionInfo', 'lastSent'], 'a few seconds ago');
      return state;
    case 'SEND_INVITATION_PF':
      var connectionInfo = action.payload;
      if (state.get(action.companyId)) return state.setIn([action.locationId, 'connectionInfo'], connectionInfo);
      return state;
    case 'IGNORE_CONNECTION_PF':
      if (state.get(action.companyId)) return state.setIn([action.locationId, 'connectionInfo', 'status'], 'rejected');
      return state;
    case 'ACCEPT_CONNECTION_PF':
      if (state.get(action.companyId)) return state.setIn([action.locationId, 'connectionInfo', 'status'], 'accepted');
      return state;
    default:
      return state;
  }
}

/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyProduct = companyProduct;

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.Map)({});

function companyProduct() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'GET_PRODUCT_PROFILE':
      return state.set(action.payload.id, (0, _immutable.fromJS)(action.payload));
    case 'CLEAR_STORES':
      return initialState;
    case 'RESEND_INVITATION_PF':
    case 'FAKE_RESEND':
      if (state.get(action.companyId)) return state.setIn([action.productId, 'connectionInfo', 'lastSent'], 'a few seconds ago');
      return state;
    case 'SEND_INVITATION_PF':
      var connectionInfo = action.payload;
      if (state.get(action.companyId)) return state.setIn([action.productId, 'connectionInfo'], connectionInfo);
      return state;
    case 'IGNORE_CONNECTION_PF':
      if (state.get(action.companyId)) return state.setIn([action.productId, 'connectionInfo', 'status'], 'rejected');
      return state;
    case 'ACCEPT_CONNECTION_PF':
      if (state.get(action.companyId)) return state.setIn([action.productId, 'connectionInfo', 'status'], 'accepted');
      return state;
    default:
      return state;
  }
}

/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.profile = profile;

var _immutable = __webpack_require__(26);

var _profileConstants = __webpack_require__(646);

var cnt = _interopRequireWildcard(_profileConstants);

var _index = __webpack_require__(1414);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({
  viewingAs: 'unconnected'
});

var checkMarketReadiness = function checkMarketReadiness(state) {
  var marketReadinessResults = (0, _index2.default)('profile', state.toJS());
  var errors = marketReadinessResults.errors;
  var percentage = state.get('isMarketingReady') === true && errors.length === 0 ? 100 : marketReadinessResults.percentage;
  return state.set('marketingReadinessPercentage', percentage).set('marketingReadinessErrors', errors);
};

function profile() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'ADD_LOCATION':
      return state.update('locations', function (locations) {
        return locations.unshift((0, _immutable.fromJS)({
          id: action.payload.locationId,
          images: [],
          isMarketingReady: false,
          name: action.payload.locationName,
          products: [],
          numOfProducts: 0
        }));
      });
    case 'GET_USER_LOCATION_PROFILE_STARTED':
    case cnt.GET_PROFILE + '_STARTED':
      return state.set('loading', true);
    case 'GET_USER_LOCATION_PROFILE_ERROR':
    case 'GET_USER_LOCATION_PROFILE_SUCCESS':
      return state.set('loading', false);
    case cnt.GET_PROFILE + '_SUCCESS':
      return checkMarketReadiness(state.merge((0, _immutable.fromJS)(action.payload))).set('refresh', false).set('loading', false);
    case 'GET_PROFILE':
      return checkMarketReadiness(state.merge((0, _immutable.fromJS)(action.profile))).set('refresh', false);
    case cnt.UPDATE_GROUP + '_STARTED':
      return state.set('savingGroup', true);
    case cnt.DELETE_GROUP + '_SUCCESS':
    case cnt.UPDATE_GROUP + '_SUCCESS':
      return state.set('manageGroupOpen', false).set('savingGroup', false).set('groupToManage', {});
    case cnt.REORDER_PRODUCTS + '_STARTED':
    case cnt.REORDER_LOCATIONS + '_STARTED':
      return state.set('savingReorderChanges', true);
    case cnt.REORDER_PRODUCTS + '_SUCCESS':
    case cnt.REORDER_LOCATIONS + '_SUCCESS':
      return state.set('savingReorderChanges', false).set('reorderItemsOpen', false);
    case cnt.REORDER_LOCATIONS + '_ERROR':
      return state.set('savingReorderChanges', false);
    case cnt.UPDATE_GROUP + '_ERROR':
      return state.set('savingGroup', false);
    case 'REMOVE_PRODUCT_FROM_PROFILE':
    case 'EDIT_USER_PRODUCT_PROFILE_FIELD':
    case 'REMOVE_LOCATION':
      if (state.isMarketingReady) return state;
      return state.set('refresh', true);
    case 'EDIT_USER_LOCATION_PROFILE_FIELD':
      return state.set('refresh', true);
    case 'PROFILE_IMAGE_CHANGED':
    case 'EDIT_PROFILE_FIELD_STARTING':
      return state.set(action.payload.updateField, action.payload.updateBody);
    case 'DELETE_COVER_IMAGE_FROM_PROFILE':
      return state.set('coverImageUrl', '');
    case 'EDIT_PROFILE_FIELD':
      if (typeof action.payload.isMarketingReady === 'boolean') {
        return checkMarketReadiness(state.set('isMarketingReady', action.payload.isMarketingReady));
      }
      if (typeof action.payload.isLocationMarketingReady === 'boolean') {
        return checkMarketReadiness(state.set('isLocationMarketingReady', action.payload.isLocationMarketingReady));
      }
      return state;
    case 'CLEAR_STORES':
    case 'LOG_OUT':
      return initialState;
    case 'UPDATE_SUPP_PROFILE_PROP':
      return state.merge((0, _immutable.fromJS)(action.payload));
    default:
      return state;
  }
}

/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (state, conditions, modelName) {
  var errors = [];
  var total = 0;
  var negative = 0;

  Object.keys(conditions).forEach(function (key) {
    var condition = conditions[key];
    // check if condition is only for accom / nonaccom  or supplier / contractor
    if (!Array.isArray(condition.only) || condition.only.indexOf(modelName === 'profile' ? state.type : state.productType) !== -1) {
      // pass state value into object-types and check if typeof is correct
      var conditionResults = condition.type(state[key], state);
      // if array is returned (things like contacts), then check each one
      // false means it did not meet the typeof condition in object-types
      // undefined means it passed
      if (Array.isArray(conditionResults)) {
        conditionResults.forEach(function (error) {
          if (error.warning) {
            negative += error.value;
            errors.push({
              warning: error.warning,
              scrollTo: error.scrollTo
            });
          }
        });
        total += conditionResults.length || 1;
      } else {
        total += condition.progressValue || 1;
        if (conditionResults === false) {
          negative += condition.progressValue;
          errors.push({
            warning: condition.warning,
            scrollTo: condition.scrollTo
          });
        }
      }
    }
  });

  return {
    errors: errors,
    percentage: Math.floor((total - negative) / total * 100)
  };
};

/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectTypes = __webpack_require__(1415);

var _objectTypes2 = _interopRequireDefault(_objectTypes);

var _scrollTo2 = __webpack_require__(1416);

var _scrollTo3 = _interopRequireDefault(_scrollTo2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  description: {
    type: _objectTypes2.default.String,
    warning: 'A description is required.',
    progressValue: 1,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#profile-description');
    }
  },
  phone: {
    type: _objectTypes2.default.String,
    warning: 'A phone is required.',
    progressValue: 1,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#phone');
    }
  },
  address: {
    type: _objectTypes2.default.Address,
    warning: 'An address is required.',
    progressValue: 3,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#address');
    }
  },
  rating: {
    type: _objectTypes2.default.Rating,
    warning: 'A rating is required.',
    progressValue: 1,
    only: ['accommodation'],
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#rating');
    }
  },
  contacts: {
    type: _objectTypes2.default.LocationContact,
    warning: 'At least 1 contact is required.',
    progressValue: 1,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#contactsNode');
    }
  },
  isProductMarketingReady: {
    type: _objectTypes2.default.Exact.bind(_objectTypes2.default.Exact, true),
    warning: 'At least 1 complete product is required.',
    progressValue: 3,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#prodAnchor');
    }
  },
  amenities: {
    type: _objectTypes2.default.Array,
    warning: 'You must select at least 1 amenity.',
    progressValue: 1,
    only: ['accommodation'],
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#amenity');
    }
  },
  companyTypes: {
    type: _objectTypes2.default.Array,
    warning: 'You must select at least 1 company type.',
    progressValue: 1,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#companyTypes');
    }
  },
  marketSegments: {
    type: _objectTypes2.default.Array,
    warning: 'At least 1 Market Segment is required.',
    progressValue: 1,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#marketSegments');
    }
  }
};

/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectTypes = __webpack_require__(1415);

var _objectTypes2 = _interopRequireDefault(_objectTypes);

var _scrollTo2 = __webpack_require__(1416);

var _scrollTo3 = _interopRequireDefault(_scrollTo2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  description: {
    type: _objectTypes2.default.String,
    warning: 'A description is required.',
    progressValue: 1,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#profile-description');
    }
  },
  checkIn: {
    type: _objectTypes2.default.String,
    warning: 'A check in time is required.',
    progressValue: 1,
    only: ['accommodation']
  },
  checkOut: {
    type: _objectTypes2.default.String,
    warning: 'A check out time is required.',
    progressValue: 1,
    only: ['accommodation']
  },
  roomCountInfo: {
    type: _objectTypes2.default.roomCountInfo,
    warning: 'Room count is required.',
    progressValue: 1,
    only: ['accommodation'],
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#roomCount');
    }
  },
  bedsAndSofas: {
    type: _objectTypes2.default.BeddingConfig,
    warning: 'At least 1 bedding configuration is required.',
    progressValue: 1,
    only: ['accommodation'],
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#beddingConfig');
    }
  },
  // totalMaxPassengers: {
  //   type: ObjectTypes.totalMaxPassengers,
  //   warning: 'Total max passengers required.',
  //   progressValue: 1,
  //   only: ['nonAccommodation'],
  //   scrollTo: () => scrollTo.scrollToFunc('#passengers'),
  // },
  // totalMinPassengers: {
  //   type: ObjectTypes.totalMinPassengers,
  //   warning: 'Total minimum passengers required.',
  //   progressValue: 1,
  //   only: ['nonAccommodation'],
  //   scrollTo: () => scrollTo.scrollToFunc('#passengers'),
  // },
  tourDuration: {
    type: _objectTypes2.default.tourDuration,
    warning: 'Tour Duration is required or must not show Tour Duration.',
    progressValue: 1,
    only: ['nonAccommodation'],
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#tourDuration');
    }
  },
  productInfo: {
    type: _objectTypes2.default.productInfo,
    warning: 'Product Information is required.',
    progressValue: 3,
    only: ['nonAccommodation'],
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#product-info');
    }
  }
};

/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectTypes = __webpack_require__(1415);

var _objectTypes2 = _interopRequireDefault(_objectTypes);

var _scrollTo2 = __webpack_require__(1416);

var _scrollTo3 = _interopRequireDefault(_scrollTo2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  description: {
    type: _objectTypes2.default.String,
    warning: 'A description is required.',
    progressValue: 1,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#profile-description');
    }
  },
  phone: {
    type: _objectTypes2.default.String,
    warning: 'A phone is required.',
    progressValue: 1,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#phone');
    }
  },
  address: {
    type: _objectTypes2.default.Address,
    warning: 'An address is required.',
    progressValue: 3,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#address');
    }
  },
  contacts: {
    type: _objectTypes2.default.Contact,
    warning: 'At least 1 contact is required.',
    progressValue: 4,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#contactsNode');
    }
  },
  isLocationMarketingReady: {
    type: _objectTypes2.default.Exact.bind(_objectTypes2.default.Exact, true),
    warning: 'At least 1 complete location is required.',
    progressValue: 3,
    only: ['Supplier'],
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#prodAnchor');
    }
  },
  companyTypes: {
    type: _objectTypes2.default.Array,
    warning: 'At least 1 Company Type is required.',
    progressValue: 1,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#companyTypes');
    }
  },
  marketSegments: {
    type: _objectTypes2.default.Array,
    warning: 'At least 1 Market Segment is required.',
    progressValue: 1,
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#marketSegments');
    }
  },
  destinationsSold: {
    type: _objectTypes2.default.Array,
    warning: 'At least 1 Destination Sold is required.',
    progressValue: 1,
    only: ['Contractor'],
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#destinationsSold');
    }
  },
  marketServed: {
    type: _objectTypes2.default.Array,
    warning: 'At least 1 Market Served is required.',
    progressValue: 1,
    only: ['Contractor'],
    scrollTo: function scrollTo() {
      return _scrollTo3.default.scrollToFunc('#marketServed');
    }
  }
};

/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memberships;

var _immutable = __webpack_require__(26);

var _constants = __webpack_require__(1843);

var constants = _interopRequireWildcard(_constants);

var _ramda = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isNotEmpty = function isNotEmpty(item) {
  return (0, _ramda.not)((0, _ramda.isEmpty)(item));
};
var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);
var filterForKey = function filterForKey(obj, keyToFind) {
  return (0, _ramda.filter)(function (item) {
    return (0, _ramda.equals)(item, keyToFind);
  }, (0, _ramda.keys)(obj));
};

var handlePropChecking = function handlePropChecking(payload, state) {
  var jsState = state.toJS();
  var membershipsArray = jsState.memberships;
  var otherMembership = jsState.otherMembership;
  var membership = jsState.membership;
  if (isNotEmpty(filterForKey(payload, 'memberships'))) {
    var isMembershipArrayEmpty = membershipsArray.length < 0;
    return state.set('disableMembershipsSaveButton', isMembershipArrayEmpty);
  }
  if (payload.membership || payload.otherMembership) {
    var memberObj = payload.membership ? membership : otherMembership;
    if (memberObj.name && isNotEmpty(memberObj.name)) {
      var isOrganizationDuplicated = (0, _ramda.contains)((0, _ramda.propOr)('', 'name', otherMembership).toLowerCase(), membershipsArray.map(function (obj) {
        return (0, _ramda.prop)('name', obj).toLowerCase();
      }));
      return state.set(payload.membership ? 'membershipValidated' : 'otherMembershipValidated', true).set('showAddAnotherOrganizationButton', !isOrganizationDuplicated).set('showDuplicateOrganizationError', isOrganizationDuplicated).set('disableMembershipsSaveButton', isOrganizationDuplicated);
    }
  }
  if (payload.resetOtherMembershipObj) {
    if (!(0, _ramda.isEmpty)(otherMembership) || !(0, _ramda.isEmpty)(membership)) {
      var membershipObj = !(0, _ramda.isEmpty)(otherMembership) ? otherMembership : membership;
      if (jsState.membershipValidated || jsState.otherMembershipValidated) {
        return state.set('memberships', (0, _immutable.fromJS)(membershipsArray.concat([membershipObj]))).set('membership', (0, _immutable.fromJS)({})).set('otherMembership', (0, _immutable.fromJS)({})).set('membershipValidated', false).set('otherMembershipValidated', false);
      }
      return state.set('membership', (0, _immutable.fromJS)({})).set('otherMembership', (0, _immutable.fromJS)({}));
    }
    return state.set('otherMembership', (0, _immutable.fromJS)({})).set('membership', (0, _immutable.fromJS)({}));
  }
  return state;
};

var initialState = (0, _immutable.fromJS)({
  membershipsEditState: false,
  originalMemberships: [],
  memberships: [],
  savingMembershipsInfo: false,
  disableMembershipsSaveButton: true,
  otherChecked: false,
  membership: {},
  membershipValidated: false,
  otherMembership: {},
  otherMembershipValidated: false,
  showAddAnotherOrganizationButton: false,
  showDuplicateOrganizationError: false,
  membershipsExistFromDB: false,
  savingMembershipInfo: false,
  listOfAvailableOrganizations: [],
  showListOfOrganizationsDropdown: false
});

function memberships() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload,
      profile = _ref.profile;

  switch (type) {
    case constants.GOT_BADGES:
      return state.set('listOfAvailableOrganizations', (0, _immutable.fromJS)(payload));
    case 'GET_PROFILE':
      return state.set('memberships', (0, _ramda.without)([state.get('otherMembership')], (0, _immutable.fromJS)(profile.companyBadges || []))).set('membershipsExistFromDB', Boolean((0, _ramda.path)(['companyBadges', 'length'], profile)) > 0).set('originalMemberships', (0, _immutable.fromJS)(profile.companyBadges || []));
    case constants.UPDATE_PROPS:
      if (payload.cancelMembershipsClicked) {
        var checkMemberships = state.get('otherMembershipValidated') && isNilOrEmpty(state.get('otherMembership')) ? state.get('memberships') : state.get('originalMemberships');
        return state.set('memberships', (0, _immutable.fromJS)(checkMemberships)).set('otherMembership', (0, _immutable.fromJS)({})).set('otherMembershipValidated', false).set('membershipValidated', false).set('membership', (0, _immutable.fromJS)({})).set('membershipsEditState', false).set('showAddAnotherOrganizationButton', false);
      }
      return handlePropChecking(payload, state.merge((0, _immutable.fromJS)(payload)));
    case constants.DELETE_ORGANIZATION_IN_PROFILE:
      var findOrgToDelete = state.get('memberships').toJS().map(function (obj) {
        if (obj.name === payload && obj.companyBadgeId) return (0, _ramda.merge)(obj, { delete: true });
        if (obj.name === payload) return {};
        return obj;
      });
      return state.set('memberships', (0, _immutable.fromJS)(findOrgToDelete.filter(function (org) {
        return isNotEmpty(org);
      })));
    case constants.EDIT_PROFILE_BADGE_STARTING:
      return state.set('savingMembershipInfo', true);
    case constants.EDIT_PROFILE_BADGE_FINISHED:
      return state.set('savingMembershipInfo', false).set('memberships', (0, _immutable.fromJS)(payload));
    default:
      return state;
  }
}

/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.profileLocation = profileLocation;

var _immutable = __webpack_require__(26);

var _locationConstants = __webpack_require__(629);

var constants = _interopRequireWildcard(_locationConstants);

var _index = __webpack_require__(1414);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({});

var checkMarketReadiness = function checkMarketReadiness(state, locationId) {
  var marketReadinessResults = (0, _index2.default)('location', state.get(locationId).toJS());
  var thisLocation = state.get(locationId);
  var errors = marketReadinessResults.errors;
  var percentage = thisLocation.isMarketingReady === true || errors.length === 0 ? 100 : marketReadinessResults.percentage;
  return state.setIn([locationId, 'marketingReadinessPercentage'], percentage).setIn([locationId, 'marketingReadinessErrors'], errors);
};

function profileLocation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'GET_USER_LOCATION_PROFILE_SUCCESS':
      return checkMarketReadiness(state.set('refresh', false).set(action.payload.locationId, (0, _immutable.fromJS)(action.payload)), action.payload.locationId);
    case 'GET_USER_LOCATION_PROFILE':
      return checkMarketReadiness(state.set('refresh', false).set(action.location.locationId, (0, _immutable.fromJS)(action.location)), action.location.locationId);
    case 'ADD_PRODUCT':
      return checkMarketReadiness(state.updateIn([action.payload.locationId, 'products'], function (products) {
        return products.unshift((0, _immutable.fromJS)({
          id: action.payload.productId,
          isMarketingReady: false,
          images: [],
          name: action.payload.name
        }));
      }), action.payload.locationId);
    case 'REMOVE_PRODUCT_FROM_PROFILE':
    case 'EDIT_USER_PRODUCT_PROFILE_FIELD':
      return state.set('refresh', true);
    case 'DELETE_COVER_IMAGE_FROM_LOCATION':
      return state.setIn([action.payload.id, 'coverImageUrl'], '');
    case 'EDIT_USER_LOCATION_PROFILE_FIELD_STARTING':
      var _action$payload = action.payload,
          id = _action$payload.id,
          updateField = _action$payload.updateField,
          updateBody = _action$payload.updateBody;

      return state.setIn([id, updateField], updateBody);
    case 'EDIT_USER_LOCATION_PROFILE_FIELD':
      if (typeof action.location.isMarketingReady === 'boolean') {
        return checkMarketReadiness(state.setIn([action.location.locationId, 'isMarketingReady'], action.location.isMarketingReady), action.location.locationId);
      }
      if (typeof action.location.isProductMarketingReady === 'boolean') {
        return checkMarketReadiness(state.setIn([action.location.locationId, 'isProductMarketingReady'], action.location.isProductMarketingReady), action.location.locationId);
      }
      return state;
    case 'CLEAR_STORES':
    case 'LOG_OUT':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.profileProduct = profileProduct;

var _immutable = __webpack_require__(26);

var _locationConstants = __webpack_require__(629);

var _index = __webpack_require__(1414);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = (0, _immutable.fromJS)({});

var checkMarketReadiness = function checkMarketReadiness(state, productId) {
  var marketReadinessResults = (0, _index2.default)('product', state.get(productId).toJS());
  var errors = marketReadinessResults.errors;
  var thisProduct = state.get(productId);
  var percentage = thisProduct.isMarketingReady === true || errors.length === 0 ? 100 : marketReadinessResults.percentage;
  return state.setIn([productId, 'marketingReadinessPercentage'], percentage).setIn([productId, 'marketingReadinessErrors'], errors);
};

function profileProduct() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'GET_USER_PRODUCT_PROFILE':
      return checkMarketReadiness(state.set(action.product.productId, (0, _immutable.fromJS)(action.product)), action.product.productId);
    case 'EDIT_USER_PRODUCT_PROFILE_FIELD_STARTING':
      var _action$payload = action.payload,
          id = _action$payload.id,
          updateField = _action$payload.updateField,
          updateBody = _action$payload.updateBody;

      return state.setIn([id, updateField], updateBody);
    case 'EDIT_USER_PRODUCT_PROFILE_FIELD':
      return checkMarketReadiness(state.setIn([action.payload.productId, 'isMarketingReady'], action.payload.isMarketingReady), action.payload.productId);
    case 'DELETE_COVER_IMAGE_FROM_PRODUCT':
      return state.setIn([action.payload.id, 'coverImageUrl'], '');
    case _locationConstants.FINISHED_IMPORTING_PROD:
      return state.remove(action.payload.productId);
    case 'CLEAR_STORES':
    case 'LOG_OUT':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connections = connections;

var _immutable = __webpack_require__(26);

var _ramda = __webpack_require__(2);

var _actions = __webpack_require__(647);

var cnt = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var initialState = (0, _immutable.Map)({
  oldConnections: (0, _immutable.List)(),
  oldConnectionId: undefined,
  resultCount: undefined,
  items: (0, _immutable.List)(),
  searchString: undefined,
  page: 1,
  nextPage: undefined,
  prevPage: undefined,
  countries: (0, _immutable.List)(),
  filteredCountries: (0, _immutable.List)(),
  unfilteredConnections: (0, _immutable.List)()
});

function connections() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case cnt.ADD_CONNECTION_AS_PARTNER + '_SUCCESS':
      return state.update('items', function (items) {
        return items.map(function (item) {
          if (item.get('id') === action.payload.connectionId) return item.set('partner', action.payload.partner);
          return item;
        });
      }).update('unfilteredConnections', function (items) {
        return items.map(function (item) {
          if (item.get('id') === action.payload.connectionId) return item.set('partner', action.payload.partner);
          return item;
        });
      });
    case 'CONNECTIONS_IS_SYNCING':
      return state.set('isSyncing', true);
    case 'GET_COUNTRIES':
      return state.set('countries', (0, _immutable.fromJS)(action.payload));
    case 'FILTER_CONNECTIONS':
      if (isNilOrEmpty(state.get('unfilteredConnections')) || action.payload.status !== 'all') {
        return state.merge((0, _immutable.fromJS)(action.payload)).set('unfilteredConnections', (0, _immutable.fromJS)(action.payload.items));
      }
      return state.merge((0, _immutable.fromJS)(action.payload));
    case 'FILTER_CONNECTIONS_BY_COUNTRY':
      return state.merge((0, _immutable.fromJS)(action.payload)).set('isSyncing', false);
    case 'LOAD_MORE_CONNECTIONS':
      // if (state.get('page') === state.get('nextPage')) return state;
      return state.set('items', (0, _immutable.fromJS)(action.payload.items)).set('isSyncing', false).set('page', action.payload.page).set('nextPage', action.payload.page + 1).set('unfilteredConnections', (0, _immutable.fromJS)(action.payload.items));
    case 'ACCEPT_CONNECTION_STARTING': // accept
    case 'IGNORE_CONNECTION_STARTING': // reject
    case 'REMOVE_CONNECTION_STARTING':
      // archive
      var oldConnectionId = action.payload;
      var oldConnections = state.get('items');
      return state.update('items', function (items) {
        return items.filter(function (item) {
          return item.get('id') !== oldConnectionId;
        });
      }).set('oldConnections', oldConnections).set('oldConnectionId', oldConnectionId);
    case 'RESEND_CONNECTION_STARTING':
      return state.update('items', function (items) {
        return items.map(function (item) {
          if (item.get('id') === action.payload) return item.set('lastSent', 'a few seconds ago');
          return item;
        });
      });
    case 'UNDO_CONNECTION_CHANGE':
      return state.set('items', oldConnections).set('oldConnections', (0, _immutable.List)()).set('oldConnectionId', undefined);
    case 'CLEAR_STORES':
      return initialState;
    case 'ADD_TAG_STARTING':
      var updateItems = function updateItems(items) {
        return items.map(function (item) {
          if (item.get('id') === action.payload.connectionId && item.get('tags').indexOf(action.payload.tagName) === -1) return item.update('tags', function (tags) {
            return tags.unshift(action.payload.tagName);
          });
          return item;
        });
      };
      return state.update('items', function () {
        return updateItems(state.get('items'));
      }).update('unfilteredConnections', function () {
        return updateItems(state.get('items'));
      });
    case 'REMOVE_TAG_STARTING':
      var update = function update(items) {
        return items.map(function (item) {
          if (item.get('id') === action.payload.connectionId) return item.update('tags', function (tags) {
            return tags.filter(function (tag) {
              return tag !== action.payload.tagName;
            });
          });
          return item;
        });
      };
      return state.update('items', function () {
        return update(state.get('items'));
      }).update('unfilteredConnections', function () {
        return update(state.get('items'));
      });
    case 'REMOVE_COUNTRY_FILTER':
      return state.update('filteredCountries', function (countries) {
        return countries.filter(function (country) {
          return country !== action.payload;
        });
      });
    case 'DELETED_TAG':
      return state.update('items', function (items) {
        return items.map(function (item) {
          if ((0, _ramda.contains)(action.payload.tagName, item.get('tags'))) return item.update('tags', function (tags) {
            return tags.filter(function (tag) {
              return tag !== action.payload.tagName;
            });
          });
          return item;
        });
      });
    case 'LOG_OUT':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectionsStats = connectionsStats;

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.Map)({
  isSynced: false,
  totalCount: 0,
  pendingRequestCount: 0,
  pendingInviteCount: 0,
  shouldShow: true
});

function connectionsStats() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'CLEAR_STORES':
      return initialState;
    case 'REFRESH_CONNECTIONS_STATS':
      return state.merge(action.payload).set('isSynced', true);
    // case 'FILTER_CONNECTIONS':
    //   return state.merge(action.payload);
    case 'ACCEPT_CONNECTION_STARTING':
      return state.set('oldState', state).set('totalCount', state.get('totalCount') + 1).set('pendingRequestCount', state.get('pendingRequestCount') - 1);
    case 'IGNORE_CONNECTION_STARTING':
      return state.set('oldState', state).set('pendingRequestCount', state.get('pendingRequestCount') - 1);
    case 'REMOVE_CONNECTION_STARTING':
      return state.set('oldState', state).set('totalCount', state.get('totalCount') - 1);
    case 'UNDO_CONNECTION_CHANGE':
      return state.get('oldState');
    case 'LOG_OUT':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onboarding = onboarding;

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.fromJS)({});

function onboarding() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'ONBOARDING_SUBMIT':
      return state.mergeDeep((0, _immutable.fromJS)(action.payload.companyUpdate));
    case 'CLEAR_STORES':
      return initialState;
    case 'SET_ONBOADING_FIELDS':
      if (state === initialState) return (0, _immutable.fromJS)(action.payload);
      return Object.keys(action.payload).reduce(function (stateToReturn, key) {
        return stateToReturn.set(key, action.payload[key]);
      }, state);
    default:
      return state;
  }
}

/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.integration = integration;

var _immutable = __webpack_require__(26);

var _integrationConstants = __webpack_require__(1844);

var constants = _interopRequireWildcard(_integrationConstants);

var _ramda = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// IMPORTANT NOTE: below hashmaps are not being used in TourplanAPI, even though they are saved in the db
// these are just for explaining purposes
var seasonNameHash = {
  'Peak/High Season': 'Peak',
  'Mid/Shoulder Season': 'Shoulder',
  'Off-Peak/Low Season': 'Low',
  'Special Event': '<Event Name>',
  'Summer': 'Summer',
  'Winter': 'Winter',
  'Spring': 'Spring',
  'Fall/Autumn': 'Fall',
  'Christmas Holidays': 'Xmas',
  'Easter Holidays': 'Easter',
  'New Years Holidays': 'New Years',
  'Chinese/Lunar New Years Holidays': 'Chinese NY',
  'January': 'January',
  'February': 'February',
  'March': 'March',
  'April': 'April',
  'May': 'May',
  'June': 'June',
  'July': 'July',
  'August': 'August',
  'September': 'September',
  'October': 'October',
  'November': 'November',
  'December': 'December',
  '1st Quarter: January - March': 'Q1',
  '2nd Quarter: April - June': 'Q2',
  '3rd Quarter: July - September': 'Q3',
  '4th Quarter: October - December': 'Q4',
  'Standard': 'Standard',
  'Premium': 'Premium'
};

var rateNameHashMap = {
  'Private/Custom': 'Private',
  'Depart/Entry: Morning': 'Morning',
  'Depart/Entry: Afternoon': 'Noon',
  'Depart/Entry: Evening': 'Evening',
  'Depart/Entry: Night': 'Night',
  'Special Event': '<Event Name>',
  'Bed & Breakfast': 'B&B',
  'Bed & Breakfast: Midweek': 'B&BMid',
  'Bed & Breakfast: Weekend': 'B&BWkn',
  'Foreign Language': 'Lang',
  'Nightly': 'Nightly',
  'Nightly: Midweek': 'Midweek',
  'Nightly: Weekend': 'Weekend',
  'Minimum Night Stay': 'Min Night',
  'Extended Stay': 'Extended',
  'Stay Pay': 'SP',
  'Package': 'Package',
  'Group': 'Group',
  'Indicative': 'IND'
};
var rateNameTextInitial = [{
  text: 'Rate Set Name',
  checked: true,
  field: 'rateSetName',
  mappings: rateNameHashMap
}, {
  text: 'Rate Set Code / Description *',
  checked: true,
  field: 'rateSetCode',
  mappings: { '<User Entered>': '<XX>' }
}, {
  text: 'Season Name',
  checked: false,
  field: 'seasonName',
  mappings: seasonNameHash
}, {
  text: 'Days of The Week',
  checked: false,
  field: 'daysOfWeek',
  mappings: {
    'Monday': 'M',
    'Tuesday': 'Tu',
    'Wednesday': 'W',
    'Thursday': 'Th',
    'Friday': 'F',
    'Saturday': 'Sa',
    'Sunday': 'Su',
    'Full Week': '',
    'Multiple': 'M-Th'
  }
}, {
  text: 'Min/Max Stay',
  checked: false,
  field: 'minMaxStay',
  mappings: {
    '<User Entered>': '<XX> Nt'
  }
}, {
  text: 'Stay X Pay Y *',
  checked: false,
  field: 'stayPay',
  mappings: {
    '<User Entered>': 'S<X>P<X>'
  }
}];
var initialExportState = {
  convertedContract: [],
  displayExportPreview: false,
  dialogOpen: false,
  editCarriesTo: 'sameSeasonAcrossProducts',
  exportStatus: '',
  exportStep: 1,
  contract: {},
  ratePackageIds: [],
  updatingContractState: false
};
var initialState = (0, _immutable.fromJS)(_extends({
  settings: {
    rateNameUseCombination: true,
    rateNamePopoverOpen: false,
    rateNamePopoverContent: {},
    rateNameAnchorEl: undefined,
    rateTextUseCombination: false,
    rateTextPopoverOpen: false,
    rateTextPopoverContent: {},
    rateTextAnchorEl: undefined,
    rateNameSetting: rateNameTextInitial,
    rateTextSetting: rateNameTextInitial,
    extra1: { selectedExtras: [] },
    extra2: { selectedExtras: [] },
    extra3: { selectedExtras: [] },
    extra4: { selectedExtras: [] },
    extra5: { selectedExtras: [] },
    priceCodesSetting: {
      defaultCode: '',
      rules: [],
      productRules: []
    }
  }
}, initialExportState));

/*
** ## means currently allow edit in export preview
 convertedContract: [{
 ----** Start forTourplan **---
   forTourplan: [{
      Login:
      Password:
      ----** Start DateRange **---
      DateRange: {
       OptionCode: 'QLDACISMULSISLSUI',
       seasonName: 'Off-Peak/Low Season',
       eventName: null,
       seasonId: 'blackout', // or season index
       Date_From: '2018-04-01',
       Date_To: '2018-04-30',
       Sale_From: '2017-11-16',
       Sale_To: '2049-12-31',
       Buy_Currency: 'AUD',
       Sell_Currency: 'AUD',
       RateSet: [{
 ##Stay_Type: 'Nightly',
 ##Rate_Text: '',
         Min_SCU: 1,
         Max_SCU: 999,
         RateSetStatus: '',
         Apply_Mon: 'Y',
         Apply_Tue: 'Y',
         Apply_Wed: 'Y',
         Apply_Thu: 'Y',
         Apply_Fri: 'Y',
         Apply_Sat: 'Y',
         Apply_Sun: 'Y',
 ##Cancel_Hours: 216,
         GroupCost: { Rates: { RoomRate: {} } },
         FITCost: { Rates: {
           RoomRate: {
             SG: 210,
             TW: 210,
             TR: '0.0000',
             QD: '0.0000',
             AA: '0.0000'
           },
           ChildRate: '0.0000'
         } },
         GroupSell: { Rates: { RoomRate: {} } },
         FITSell: { Rates: { RoomRate: {} } }
       },
      ----** END DateRange **---
   }],
    ----** End forTourplan **---
   mapping,
   productName,
   tourplanName,
   extraLines,
 ##discrepancyMsg
   policies
   historyFeedId
   isAccommodation,
   bedsAndSofas
   productId
 ##pickedExtras
 ##notPickedExtras
 }]
 */
var addOriginalValueInRateSet = function addOriginalValueInRateSet(convertedContract) {
  return convertedContract.map(function (product) {
    return _extends({}, product, {
      forTourplan: product.forTourplan.map(function (obj) {
        return _extends({}, obj, {
          DateRange: _extends({}, obj.DateRange, {
            originalSale_From: obj.DateRange.Sale_From,
            originalSale_To: obj.DateRange.Sale_To,
            originalTaxes: obj.DateRange.Taxes,
            originalPriceCodes: obj.DateRange.PriceCodes,
            RateSet: obj.DateRange.RateSet.map(function (rateSet) {
              return _extends({}, rateSet, {
                originalStay_Type: rateSet.Stay_Type,
                originalRate_Text: rateSet.Rate_Text,
                originalCancel_Hours: rateSet.Cancel_Hours
              });
            })
          })
        });
      })
    });
  });
};
var mergeWithExistingData = function mergeWithExistingData(existingArray, newArray) {
  if (!(newArray && newArray.length)) return existingArray;
  return (0, _immutable.fromJS)(newArray.map(function (newObj) {
    var currentObj = existingArray.toJS().find(function (o) {
      return o.productId === newObj.productId;
    });
    var currentExtraLength = Object.values(currentObj.extraLines).filter(function (x) {
      return x;
    }).length;
    var notEnoughAvailExtras = newObj.extraLines && Object.values(newObj.extraLines).filter(function (x) {
      return x;
    }).length < currentExtraLength;
    return _extends({}, currentObj, {
      extraLines: newObj.extraLines,
      policies: newObj.policies,
      pickedExtras: notEnoughAvailExtras ? (0, _immutable.fromJS)(newObj.pickedExtras) : currentObj.pickedExtras,
      notPickedExtras: notEnoughAvailExtras ? (0, _immutable.fromJS)(newObj.notPickedExtras) : currentObj.notPickedExtras
    });
  }));
};

function integration() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case constants.UPDATE_WITH_KEYPATH:
      return state.setIn(action.payload.keyPath, action.payload.immutableValue);
    case constants.GET_CONTRACT_STARTING:
    case constants.GETTING_CONVERTED_CONTRACT:
      return state.set('exportStatus', 'gettingConvertedContract');
    case constants.GET_CONVERTED_CONTRACT:
      return state.set('exportStatus', 'success').set('exportStep', 2).set('convertedContract', (0, _immutable.fromJS)(addOriginalValueInRateSet(action.payload)));
    case constants.GETTING_CONVERTED_CONTRACT_FAILED:
      return state.set('exportStatus', 'failed').setIn(['contract', 'exportError'], 'We are experiencing difficulties generating the preview, please try again with just one product. If it still doesn\'t work, please reach out to us.').set('dialogOpen', true);
    case constants.GET_CONTRACT:
      return state.set('contract', (0, _immutable.fromJS)(action.integration)).set('ratePackageIds', (0, _immutable.fromJS)(action.integration.products.filter(function (o) {
        return o.tourPlanOptionID;
      }).map(function (o) {
        return o._id;
      }))).set('exportStatus', 'success');
    case constants.CHANGE_INTEGRATION_EXPORT_TYPE:
      return state.updateIn(['contract', 'products'], (0, _ramda.map)(function (product) {
        if (product.get('productId') === action.payload.productId) return product.set('exportAs', action.payload.value);
        return product;
      }));
    case constants.CLEAR_EXPORT_STATE:
      return state.merge((0, _immutable.fromJS)(initialExportState));
    case constants.GET_CONTRACT_FAILED:
      return state.set('getContractError', 500);
    case constants.GET_CONTRACTS_STARTING:
      return state.set('loadingContracts', 'loading');
    case constants.GET_CONTRACTS:
      return state.set('contracts', (0, _immutable.fromJS)(action.integration.contracts)).set('totalContractsNo', action.integration.totalNo).set('loadingContracts', 'success');
    case constants.GET_CONTRACTS_FAILED:
      return state.set('loadingContracts', 'failed');
    case constants.UPDATE_PRODUCT:
      return state.updateIn(['contract', 'products', action.payload.index], function (prod) {
        return prod.merge(action.payload.updater);
      });
    case constants.VALIDATE_MAPPING_STATUS:
      return state.setIn(['contract', 'products', action.key, 'validateMappingStatus'], action.status).setIn(['contract', 'products', action.key, 'validateError'], action.error);
    case constants.VALIDATE_MAPPING:
      return state.setIn(['contract', 'products', action.key, 'tourPlanOptionName'], action.payload.tourPlanOptionName).setIn(['contract', 'products', action.key, 'tourPlanOptionID'], action.payload.tourPlanOptionID).setIn(['contract', 'products', action.key, 'validateMappingStatus'], action.status).setIn(['contract', 'products', action.key, 'hasRates'], action.payload.hasRates).setIn(['contract', 'products', action.key, 'validateError'], '').update('ratePackageIds', function (arr) {
        var rpId = state.getIn(['contract', 'products', action.key, '_id']);
        if (action.payload.tourPlanOptionID && arr.indexOf(rpId) === -1) {
          return arr.push(rpId);
        }
        if (!action.payload.tourPlanOptionID && arr.indexOf(rpId) > -1) {
          return arr.filter(function (id) {
            return id !== rpId;
          });
        }
        return arr;
      }).update('convertedContract', function (convertedArray) {
        if (convertedArray && convertedArray.size && !action.payload.hasRates && !action.error && action.status === 'ready' && action.payload.tourPlanOptionID) {
          return convertedArray.map(function (obj) {
            if (obj.get('productId') === action.payload.productId) {
              return obj.set('mapping', action.payload.tourPlanOptionID).set('tourplanName', action.payload.tourPlanOptionName).update('forTourplan', function (array) {
                return array.map(function (dr) {
                  return dr.setIn(['DateRange', 'OptionCode'], action.payload.tourPlanOptionID);
                });
              });
            }
            return obj;
          });
        }
        return convertedArray;
      });
    case constants.CHECK_RATES_STARTING:
      return state.setIn(['contract', 'products', action.key, 'hasRates'], action.hasRates).set('exportStatus', 'checkingRates');
    case constants.CHECK_IF_HAS_RATES_FAILED:
      return state.set('exportStatus', 'success');
    case constants.CHECK_IF_HAS_RATES:
      return state.setIn(['contract', 'products', action.key, 'hasRates'], action.hasRates).set('exportStatus', 'success');
    case '{integration-export} START':
      return state.set('exportStatus', 'exporting');
    case '{integration-export} GET_PROCESSED_RESPONSE':
    case constants.ADD_MAPPING:
      return state.set('exportStatus', 'success').setIn(['contract', 'exportResponses'], action.payload).set('exportStep', 3);
    case '{integration-export} HANDLE_POLLING_FAILURE':
    case constants.ADD_MAPPING_FAILED:
      return state.set('exportStatus', 'failed').setIn(['contract', 'exportError'], action.error).set('dialogOpen', true);
    case constants.GET_AUTH:
      return state.set('auth', (0, _immutable.fromJS)(action.auth));
    case constants.GET_AUTH_FAILED:
      return state.set('authError', (0, _immutable.fromJS)(action.payload));
    case constants.LOGIN:
      return state.set('loginResponse', (0, _immutable.fromJS)(action.payload));
    case constants.UPDATE_SETTINS:
      return state.update('settings', function (settings) {
        return settings.merge((0, _immutable.fromJS)(action.payload));
      });
    case 'CHECK_ALL_RATE_PACKAGE_FOR_TOURPLAN_EXPORT':
      return state.update('ratePackageIds', function () {
        if (action.payload.checked) return state.getIn(['contract', 'products']).map(function (o) {
          return o.get('_id');
        });
        return (0, _immutable.fromJS)([]);
      });
    case 'CHECK_A_RATE_PACKAGE_FOR_TOURPLAN_EXPORT':
      return state.update('ratePackageIds', function (arr) {
        if (action.payload.checked) {
          if (!action.payload.hasRates || window.confirm('This product already has rates in Tourplan, are you sure you want to overwrite the rates?')) {
            return arr.push(action.payload.ratePackageId);
          }
          return arr;
        }
        return arr.filter(function (str) {
          return str !== action.payload.ratePackageId;
        });
      });
    case '{TP_Integration}CHANGE_CONTRACT_STATE_STARTING':
      return state.set('updatingContractState', true);
    case '{TP_Integration}CHANGE_CONTRACT_STATE_SUCCESS':
      return state.set('updatingContractState', false).setIn(['contract', 'state'], 'loaded');
    case '{TP_Integration}CHANGE_CONTRACT_STATE_ERROR':
      return state.set('updatingContractState', false);
    case constants.CLEAR_INTEGRATION_STORE:
      return initialState;
    case constants.CLEAR_STORES:
    case constants.LOG_OUT:
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dialogReducers = __webpack_require__(2670);

var _dialogReducers2 = _interopRequireDefault(_dialogReducers);

var _steppersReducer = __webpack_require__(2678);

var _steppersReducer2 = _interopRequireDefault(_steppersReducer);

var _wizardReducer = __webpack_require__(2679);

var _wizardReducer2 = _interopRequireDefault(_wizardReducer);

var _reducer = __webpack_require__(2680);

var _reducer2 = _interopRequireDefault(_reducer);

var _addRateSetWizardReducer = __webpack_require__(2681);

var _addRateSetWizardReducer2 = _interopRequireDefault(_addRateSetWizardReducer);

var _addRatesWizardReducer = __webpack_require__(2682);

var _addRatesWizardReducer2 = _interopRequireDefault(_addRatesWizardReducer);

var _commentReducer = __webpack_require__(2683);

var _commentReducer2 = _interopRequireDefault(_commentReducer);

var _contractActivitiesProductsReducer = __webpack_require__(2684);

var _contractActivitiesProductsReducer2 = _interopRequireDefault(_contractActivitiesProductsReducer);

var _errorReducer = __webpack_require__(2685);

var _errorReducer2 = _interopRequireDefault(_errorReducer);

var _massRateChangeReducer = __webpack_require__(2686);

var _massRateChangeReducer2 = _interopRequireDefault(_massRateChangeReducer);

var _smallTemplateListReducer = __webpack_require__(2687);

var _smallTemplateListReducer2 = _interopRequireDefault(_smallTemplateListReducer);

var _contractListReducer = __webpack_require__(2688);

var _contractListReducer2 = _interopRequireDefault(_contractListReducer);

var _templateListReducer = __webpack_require__(2689);

var _templateListReducer2 = _interopRequireDefault(_templateListReducer);

var _reducer3 = __webpack_require__(2690);

var _reducer4 = __webpack_require__(2691);

var _reducer5 = __webpack_require__(2692);

var _reducer6 = __webpack_require__(2693);

var _reducer7 = _interopRequireDefault(_reducer6);

var _redux = __webpack_require__(131);

var _miscReducers = __webpack_require__(1443);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)(_extends({
  templateList: _templateListReducer2.default,
  supplierUpdatesQueue: _reducer3.supplierUpdatesQueue,
  masterTemplate: (0, _redux.combineReducers)({
    docs: _reducer5.masterTemplate,
    editDialog: _reducer5.editDialog,
    applyMasterToTemplatesReducer: _reducer5.applyMasterToTemplatesReducer,
    finaliseDialog: _reducer5.finaliseDialog,
    list: _reducer4.masterTemplateList,
    createNew: _reducer4.createNew
  }),
  contractList: _contractListReducer2.default,
  steppers: _steppersReducer2.default,
  wizard: _wizardReducer2.default,
  supplierWizard: _reducer2.default,
  contractingError: _errorReducer2.default,
  massRateChange: _massRateChangeReducer2.default,
  smallContractTemplateList: _smallTemplateListReducer2.default,
  sendToPartners: _reducer7.default,
  addRateSetWizard: _addRateSetWizardReducer2.default,
  addRatesWizard: _addRatesWizardReducer2.default,
  contractActivitiesProducts: _contractActivitiesProductsReducer2.default,
  commentBox: _commentReducer2.default,
  contractPeriods: _miscReducers.contractPeriods,
  currentYear: _miscReducers.currentYear,
  downloadDocs: _miscReducers.downloadDocs
}, _dialogReducers2.default));

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _addEditContractDialogReducer = __webpack_require__(2671);

var _addEditContractDialogReducer2 = _interopRequireDefault(_addEditContractDialogReducer);

var _addProductToContractDialog = __webpack_require__(2672);

var _addProductToContractDialog2 = _interopRequireDefault(_addProductToContractDialog);

var _publishDraftDialogReducer = __webpack_require__(2673);

var _publishDraftDialogReducer2 = _interopRequireDefault(_publishDraftDialogReducer);

var _freeContractForContractorDialog = __webpack_require__(2674);

var _freeContractForContractorDialog2 = _interopRequireDefault(_freeContractForContractorDialog);

var _resendContractReducer = __webpack_require__(2675);

var _resendContractReducer2 = _interopRequireDefault(_resendContractReducer);

var _requestsWithSameNameOrDomainReducer = __webpack_require__(2676);

var _requestsWithSameNameOrDomainReducer2 = _interopRequireDefault(_requestsWithSameNameOrDomainReducer);

var _requestDataLoading = __webpack_require__(2677);

var _requestDataLoading2 = _interopRequireDefault(_requestDataLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  addEditContractDialog: _addEditContractDialogReducer2.default,
  addProductToContractDialog: _addProductToContractDialog2.default,
  publishDraftDialog: _publishDraftDialogReducer2.default,
  freeContractDialog: _freeContractForContractorDialog2.default,
  resendContractDialog: _resendContractReducer2.default,
  requestsWithSameNameOrDomainDialog: _requestsWithSameNameOrDomainReducer2.default,
  requestDL: _requestDataLoading2.default
};

/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = addEditDialog;

var _immutable = __webpack_require__(26);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _constants = __webpack_require__(252);

var contractingCnts = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = (0, _immutable.fromJS)({
  open: false,
  type: '',
  data: {},
  offersOrExtras: {},
  note: '',
  example: '',
  saving: false
});

var selectCCTemplate = function selectCCTemplate(state, template) {
  var targetProducts = state.getIn(['data', 'targetTemplate', 'products']).toJS();
  var matches = !template ? {} : targetProducts.reduce(function (result, tp) {
    var foundPFromS = template.products.find(function (p) {
      return p.productId === tp.productId || p.productName === tp.productName;
    });
    if (foundPFromS) result[foundPFromS.productId] = { label: tp.productName, value: tp.productId };
    return result;
  }, {});
  var targetTemplate = state.getIn(['data', 'targetTemplate']).toJS();
  return state.setIn(['data', 'sourceTemplate'], !template ? null : (0, _immutable.fromJS)(_extends({}, template, {
    productsToImport: template.products
    // if target products are empty, import all by default
    .filter(function (o) {
      return targetProducts.length ? matches[o.productId] : true;
    }).map(function (o) {
      return o.productId;
    })
  }))).setIn(['data', 'matches'], (0, _immutable.fromJS)(matches))
  // if target has no products at all, or we automatically matched every products, there is no need to confuse user with the product match dropdowns
  .setIn(['data', 'noNeedToMatch'], !template ? false : !(targetTemplate.products && targetTemplate.products.length) || template.products.every(function (p) {
    return matches[p.productId];
  }));
};
function addEditDialog() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE':
      return initialState.set('productId', payload.productId).set('ratePackageIndex', payload.ratePackageIndex).set('ratePackageName', payload.ratePackageName).set('policiesNotesPage', payload.policiesNotesPage).set('type', payload.type).set('policyType', payload.policyType).set('ratePackageId', payload.ratePackageId).setIn(['data', 'title'], payload.title).set('offersOrExtras', payload.offersOrExtras ? (0, _immutable.fromJS)(payload.offersOrExtras) : state.get('offersOrExtras')).update('data', function (data) {
        return data.merge((0, _immutable.fromJS)(payload.data || {}));
      });
    case 'OPEN_AND_POPULATE_ADD_EDIT_CONTRACT_DIALOG':
      return state.set('open', true).update('data', function (data) {
        return data.merge((0, _immutable.fromJS)(payload.data || {}));
      }).update('offersOrExtras', function (offersOrExtras) {
        return offersOrExtras.merge((0, _immutable.fromJS)(payload.offersOrExtras || {}));
      });
    case 'PRODUCTS_SAVED_UPDATE_REDUX':
      return initialState.merge((0, _immutable.fromJS)({
        productId: payload.firstProduct.productId,
        ratePackageIndex: payload.firstProduct.ratePackageIndex,
        ratePackageName: payload.firstProduct.ratePackageName,
        type: 'copyDataFromAnotherProduct',
        data: { title: 'Copy data from another product', noShowIfEmpty: true }
      }));
    case '[contract-product]CREATE_RATE_PACKAGE_SUCCESS':
      if (payload.newRatePackage) {
        return initialState.merge((0, _immutable.fromJS)({
          _id: payload.newRatePackage._id,
          productId: payload.newRatePackage.productId,
          ratePackageIndex: payload.newRatePackage.ratePackageIndex,
          ratePackageName: payload.newRatePackage.ratePackageName,
          type: 'copyDataFromAnotherProduct',
          data: { title: 'Copy data from another product', noShowIfEmpty: true }
        }));
      }
      return initialState;
    case '{draft}EDIT_PRODUCT_PROFILE_INFO':
    case contractingCnts.MANAGE_EXTRAS_OFFERS + '_STARTED':
    case '[contract-product]CREATE_RATE_PACKAGE_START':
    case 'OMNI_IMPORT':
    case 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG':
      return state.set('saving', true);
    case contractingCnts.MANAGE_EXTRAS_OFFERS + '_ERROR':
    case 'OMNI_IMPORT_ERROR':
    case 'COPY_DATA_FROM_ANOTHER_PRODUCT_IN_CONTRACT_IS_FAILED':
      return state.set('saving', false).setIn(['data', 'error'], payload ? payload.error : payload);
    case contractingCnts.MANAGE_EXTRAS_OFFERS + '_SUCCESS':
    case '{draft}EDIT_PRODUCT_PROFILE_INFO_SUCCESS':
    case 'OMNI_IMPORT_SUCCESS':
    case 'IMPORT_DATA_FROM_ANOTHER_TEMPLATE_SUCCESS':
    case 'UPDATE_BUYER_INFO':
    case 'SAVE_BILLING_INFO_ADD_EDIT':
    case 'DATA_FROM_ANOTHER_PRODUCT_IS_COPIED':
    case 'CLOSE_ADD_EDIT_CONTRACT_DIALOG':
    case 'CONTRACT_SUPPLIER_DETAIL_UPDATED':
    case 'CONTRACT_PRODUCT_UPDATED':
      return initialState;
    case 'SHOW_CONTRACTING_ERROR_STRING':
      return state.set('saving', false);
    // case 'SELECT_SEASON_IN_EDITING_SEASON_ADHOC':
    //   return state.update('data', data => data.merge(fromJS(payload))).setIn(['data', 'selectedSeasonName'], payload.seasonName);
    case 'ON_CHANGE_TEXTFIELD_WITH_KEYPATH_IN_ADD_EDIT_DIALOG':
      if (Array.isArray(payload.value)) return state.setIn(payload.keyPath, (0, _immutable.fromJS)(payload.value));
      if (payload.value && _typeof(payload.value) === 'object' && typeof payload.value.getMonth !== 'function') {
        return state.updateIn(payload.keyPath, function (obj) {
          if (!obj) return (0, _immutable.fromJS)(payload.value);
          return obj.merge((0, _immutable.fromJS)(payload.value));
        });
      }
      return state.setIn(payload.keyPath, payload.value);
    case 'ADD_ONE_ELEMENT_WITH_KEYPATH_ADD_EDIT_DIALOG':
      return state.updateIn(payload.keyPath, function (array) {
        if (!array) return (0, _immutable.fromJS)([payload.element]);
        return array.push((0, _immutable.fromJS)(payload.element));
      });
    case 'DELETE_ONE_ELEMENT_WITH_KEYPATH_ADD_EDIT_DIALOG':
      return state.deleteIn(payload.keyPath);
    case 'ON_CHANGE_TEXTFIELD_IN_ADD_EDIT_DIALOG':
      if (payload.key === 'maxAdultsPlusChild') {
        return state.updateIn(['data', 'rates'], (0, _ramda.map)(function (rate) {
          return rate.set('maxAdultsPlusChild', payload.value);
        }));
      }
      if ((payload.key === 'earlyCheckInCostType' || payload.key === 'lateCheckOutCostType') && payload.value === '%') {
        if (payload.key === 'earlyCheckInCostType') return state.setIn(['data', payload.key], payload.value).setIn(['data', 'earlyCheckInPercentageType'], 'of Nightly Rate');
        if (payload.key === 'lateCheckOutCostType') return state.setIn(['data', payload.key], payload.value).setIn(['data', 'lateCheckOutPercentageType'], 'of Nightly Rate');
      }
      if (payload.key === 'eventName') return state.setIn(['data', 'eventName'], payload.value);
      if (payload.updateProductPolicy) {
        if (payload.key === 'policyType') {
          return state.updateIn(['data', 'selectedPolicy'], function (selectedPolicy) {
            return selectedPolicy.merge((0, _immutable.fromJS)({ policyType: payload.value, conditions: '', cancellations: [{}] }));
          });
        }
        return state.setIn(['data', 'selectedPolicy', payload.key], payload.value);
      }
      if (!isNaN(payload.blackoutsIndex)) return state.setIn(['data', 'blackouts', payload.blackoutsIndex, payload.key], payload.value);
      if (payload.forTermsAndNotes) return state.setIn(['data', 'value'], payload.value);
      return state.setIn(['data', payload.key], payload.value);
    case 'UPDATE_DAYS_OF_WEEK_ADD_EDIT':
      var pathToDOW = payload.pathToDOW || ['data'];
      if (payload.day === 'All') {
        if (payload.checked) return state.setIn([].concat(_toConsumableArray(pathToDOW), ['daysOfWeek']), (0, _immutable.fromJS)(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']));
        return state.setIn([].concat(_toConsumableArray(pathToDOW), ['daysOfWeek']), (0, _immutable.fromJS)([]));
      }
      if (payload.checked) return state.updateIn([].concat(_toConsumableArray(pathToDOW), ['daysOfWeek']), function (daysOfWeek) {
        return daysOfWeek.push(payload.day);
      });
      return state.deleteIn([].concat(_toConsumableArray(pathToDOW), ['daysOfWeek', payload.dayIndexInReducer]));
    case 'UPDATE_TABLE_CELL_ADD_EDIT':
      var pathToRates = payload.pathToRates || ['data'];
      if (payload.column === 'maxChild') {
        return state.updateIn([].concat(_toConsumableArray(pathToRates), ['rates', payload.row]), function (rateDetails) {
          return rateDetails.merge((0, _immutable.fromJS)({
            maxChild: payload.value,
            maxAdultsPlusChild: parseInt(state.getIn([].concat(_toConsumableArray(pathToRates), ['rates', payload.row, 'maxAdults'])), 10) + parseInt(payload.value, 10)
          }));
        });
      }
      if (payload.column === 'minGuests' && payload.row) {
        if (Number(payload.value) <= Number(state.getIn([].concat(_toConsumableArray(pathToRates), ['rates', payload.row - 1, 'minGuests'])))) {
          return state.setIn([].concat(_toConsumableArray(pathToRates), ['rates', payload.row, payload.column]), Number(payload.value));
        }
        return state.setIn([].concat(_toConsumableArray(pathToRates), ['rates', payload.row - 1, 'maxAdultsPlusChild']), Number(payload.value) - 1).setIn([].concat(_toConsumableArray(pathToRates), ['rates', payload.row, payload.column]), Number(payload.value));
      }
      if (state.getIn([].concat(_toConsumableArray(pathToRates), ['nonStandardTemplateType'])) === 'priceBreak' && payload.column === 'maxAdultsPlusChild' && payload.row < state.getIn([].concat(_toConsumableArray(pathToRates), ['rates'])).size - 1) {
        return state.setIn([].concat(_toConsumableArray(pathToRates), ['rates', payload.row + 1, 'minGuests']), Number(payload.value) + 1).setIn([].concat(_toConsumableArray(pathToRates), ['rates', payload.row, payload.column]), payload.value);
      }
      if (payload.column === 'retailRate' && state.getIn([].concat(_toConsumableArray(pathToRates), ['rateType'])) === 'includeCommission') {
        return state.setIn([].concat(_toConsumableArray(pathToRates), ['rates', payload.row, 'retailRate']), payload.value).setIn([].concat(_toConsumableArray(pathToRates), ['rates', payload.row, 'nettRate']), Number(payload.value - payload.value * state.getIn([].concat(_toConsumableArray(pathToRates), ['commissionPercentage'])) / 100).toFixed(2));
      }
      return state.setIn([].concat(_toConsumableArray(pathToRates), ['rates', payload.row, payload.column]), payload.value);
    case 'ADD_ONE_MORE_BLACKOUT':
      return state.updateIn(['data', 'blackouts'], function (blackouts) {
        return blackouts.push((0, _immutable.fromJS)({}));
      });
    case 'DELETE_ONE_BLACKOUT_DAY':
      return state.deleteIn(['data', 'blackouts', payload.index]);
    case 'ADD_ONE_MORE_ALLOTMENT':
      return state.updateIn(['data', 'allotments'], function (allotments) {
        return allotments.push((0, _immutable.fromJS)({}));
      });
    case 'DELETE_ONE_ALLOTMENT':
      return state.deleteIn(['data', 'allotments', payload.index]);
    case 'ADD_INSURANCE_FILE':
      return state.setIn(['data', 'insuranceFiles'], (0, _immutable.fromJS)(payload));
    case 'REMOVE_INSURANCE_FILE':
      return state.setIn(['data', 'insuranceFiles'], (0, _immutable.fromJS)([]));
    case 'HANDLE_COPY_TEMPLATE_SELECTION':
      if (payload.fieldName) return state.setIn(['data', 'value'], payload.value);
      return state;
    case 'SEARCH_CC_RATES_TEMPLATES':
      return state.setIn(['data', 'loadingCCTemplates'], true);
    case 'SEARCH_CC_RATES_TEMPLATES_SUCCESS':
      return state.setIn(['data', 'loadingCCTemplates'], false).setIn(['data', 'templates'], (0, _immutable.fromJS)(payload.templates));
    case 'SELECT_OMNI_IMPORT_SOURCE_TEMPLATE':
      return selectCCTemplate(state, payload.template);
    case 'RateDocIframe_selectImportTemplate':
      if (payload.forCCImport) {
        var template = state.getIn(['data', 'templates']).toJS().find(function (o) {
          return o.originalContractId ? payload.docId === o.originalContractId : payload.docId === o._id;
        });
        return selectCCTemplate(state, template);
      }
      return state.setIn(['data', 'templateSelected'], (0, _immutable.fromJS)({ _id: payload.docId }));
    // when DL manually enters id, this is what we do
    case 'LOAD_PRODUCTS_FOR_OMNI_IMPORT_SOURCE_TEMPLATE':
      return state.setIn(['data', 'sourceTemplate'], (0, _immutable.fromJS)(_extends({
        loadingProducts: true
      }, payload.template)));
    case 'LOAD_PRODUCTS_FOR_OMNI_IMPORT_SOURCE_TEMPLATE_SUCCESS':
      return state.setIn(['data', 'sourceTemplate', 'products'], (0, _immutable.fromJS)(payload.productsArray)).setIn(['data', 'sourceTemplate', 'templateId'], payload.templateId).setIn(['data', 'sourceTemplate', 'productsToImport'], (0, _immutable.fromJS)(_ramda2.default.uniq(payload.productsArray.map(function (o) {
        return o.productId;
      })))).setIn(['data', 'matches'], (0, _immutable.fromJS)(state.getIn(['data', 'targetTemplate', 'products']).toJS().reduce(function (result, tp) {
        var foundPFromS = payload.productsArray.find(function (p) {
          return p.productId === tp.productId || p.productName === tp.productName;
        });
        if (foundPFromS) result[foundPFromS.productId] = { label: tp.productName, value: tp.productId };
        return result;
      }, {}))).setIn(['data', 'sourceTemplate', 'loadingProducts'], false);
    case 'LOAD_PRODUCTS_FOR_OMNI_IMPORT_SOURCE_TEMPLATE_ERROR':
      return state.setIn(['data', 'sourceTemplate', 'loadingProducts'], true);
    default:
      return state;
  }
}

/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = addProductToContractDialog;

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.fromJS)({
	open: false
});

function addProductToContractDialog() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var _ref = arguments[1];
	var type = _ref.type,
	    payload = _ref.payload;

	switch (type) {
		case 'CHANGE_ADD_PRODUCT_TO_CONTRACT_DIALOG_STATE':
			return state.set('open', payload);
		default:
			return state;
	}
}

/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = publishDraftDialog;

var _immutable = __webpack_require__(26);

var _constants = __webpack_require__(252);

var cnt = _interopRequireWildcard(_constants);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({
  contractId: '',
  open: false,
  saving: false,
  sendingContracts: false,
  title: '',
  templateName: '',
  newDraftStartDate: '',
  newDraftEndDate: '',
  duplicateTemplateName: false,
  BCCSelf: false,
  includeNotes: false,
  includeGeneralNote: false,
  includeMultiLocNotes: false,
  multiLocNote: '',
  sendUpdatesMessage: '',
  sourceTemplatePeriod: {},
  shouldClearDates: undefined
});

function publishDraftDialog() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'GET_CONTRACT_LEFT_NAV':
      return state.set('contractId', payload.contractId)
      // .set('sendUpdatesMessage', `I’ve made some important changes to ${payload.locationName}'s ${moment(payload.startDate).format('DD MMM YYYY')} - ${moment(payload.endDate).format('DD MMM YYYY')} rates.`)
      .set('defaultSubject', 'Updated: ' + payload.locationName + '\'s ' + (0, _moment2.default)(payload.startDate).get('year') + '-' + (0, _moment2.default)(payload.endDate).get('year') + ' rates');
    case 'SEND_UPDATES_IN_PUBLISH_DRAFT_DIALOG':
      return state.merge((0, _immutable.fromJS)({
        title: 'Send Updates',
        open: true,
        sendUpdatesSubject: state.get('defaultSubject'),
        sendUpdatesMessage: ''
      }));
    case 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG':
      return state.merge((0, _immutable.fromJS)(payload));
    case '{contracting} ADD_DRAFT_TO_QUEUE_SUCCESS':
    case 'PUBLISH_TEMPLATE_DRAFT_SUCCESS':
      return state.merge((0, _immutable.fromJS)({
        publishingDraft: false,
        open: false,
        title: ''
      }));
    case 'OPEN_AS_SAVE_CONTRACT_AS_TEMPLATE':
      return state.merge((0, _immutable.fromJS)({
        contractId: payload.contractId,
        sourceTemplatePeriod: payload.contractYear,
        newDraftStartDate: payload.contractYear.startDate,
        newDraftEndDate: payload.contractYear.endDate,
        templateId: payload.templateId,
        isDummyTemplate: payload.isDummyTemplate,
        title: 'Save Template',
        open: true
      }));
    case 'CHECK_READINESS_BEFORE_DOWNLOADING_DRAFT_PDF':
      return state.merge((0, _immutable.fromJS)({
        contractId: payload.contractId,
        title: 'Download PDF',
        open: true,
        checkingContractReadiness: true
      }));
    case 'NOT_ENOUGH_FREE_CONTRACTS':
      return state.setIn(['errors', 'freeContractError'], true).set('title', 'Errors');
    case 'ON_BCC_SELF_CHECK':
      return state.set('BCCSelf', payload.checked);
    case 'INCLUDE_NOTES_CHECK':
      return state.set('includeNotes', payload.checked);
    case 'INCLUDE_MULTI_LOC_NOTES_CHECK':
      return state.set('includeMultiLocNotes', payload.checked);
    case 'INCLUDE_GENERAL_NOTE_CHECK':
      return state.set('includeGeneralNote', payload.checked);
    case 'ON_TEXTFIELD_CHANGE_PUBLISH_DRAFT_DIALOG':
      return state.set(payload.key, payload.value).set('duplicateTemplateName', false);
    case 'SAVING_TEMPLATE_AFTER_DRAFT_PUBLISHED':
      return state.set('saving', true);
    case 'SHOW_CONTRACTING_ERROR_STRING':
      return state.set('saving', false);
    case 'SAVING_NEW_TEMPLATE_FAILED_BECAUSE_DUPLICATES':
      return state.set('duplicateTemplateName', true).set('saving', false);
    case 'SAVED_TEMPLATE_AFTER_DRAFT_PUBLISHED':
      return state.set('saving', false).set('saveAsNewTemplateFinished', true).set('newDraft', (0, _immutable.fromJS)(payload.newDraft));
    case '{dummy_account} makeACopyForBuyer_SUCCESS':
      return state.set('makeACopySuccessPayload', (0, _immutable.fromJS)(payload));
    case 'CLOSE_PUBLISH_DRAFT_DIALOG':
      return initialState.set('defaultSubject', state.get('defaultSubject'));
    case cnt.REVIEW_MY_RATES_DRAFT + '_SUCCESS':
      return state.set('reviewRateEmailSent', true);
    default:
      return state;
  }
}

/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = freeContractDialog;

var _immutable = __webpack_require__(26);

// Add Folder Dialog
var initialState = (0, _immutable.fromJS)({
  open: false
});

function freeContractDialog() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'SHOW_FREE_CONTRACT_DIALOG':
      return state.set('open', true).set('url', payload.url).set('contractId', payload.contractId).set('freeContractsLeft', payload.freeContractsLeft);
    case 'CLOSE_FREE_CONTRACT_DIALOG':
    case 'USED_AS_FREE_BY_CONTRACTOR':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resendContractDialog;

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.fromJS)({
  open: false,
  customizedMessage: '',
  loading: false,
  finishedSendingEmail: false,
  includeNotes: false,
  contractId: '',
  updatePartnerForAllContracts: false,
  newEmails: [],
  updatedEmails: {},
  removedEmails: [],
  newPartnerName: '',
  removeContactFromPartner: false,
  to: {},
  contacts: [],
  toEmails: [],
  resendToEmails: [],
  partner: {
    contacts: []
  }
});

function resendContractDialog() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'CHANGE_RESEND_CONTRACT_DIALOG_STATE':
      return state.set('open', true).merge((0, _immutable.fromJS)(payload));
    case 'GET_PARTNER_FOR_RESEND_DIALOG_SUCCESS':
      return state.set('partner', (0, _immutable.fromJS)(payload.partners[0]));
    case 'UPDATE_CONTRACT_PARTNER_INFO_SUCCESS':
      return state.set('loading', false).setIn(['to', 'name'], payload.newPartnerName || state.getIn(['to', 'name'])).setIn(['to', 'contactIds'], (0, _immutable.fromJS)(payload.toContactIds)).set('toEmails', (0, _immutable.fromJS)(payload.toEmails)).set('resendToEmails', (0, _immutable.fromJS)(payload.resendToEmails.length ? payload.resendToEmails : payload.toEmails)).set('changesSaved', true);
    case 'CLOSE_RESEND_CONTRACT_DIALOG':
      return initialState;
    case 'ON_BCC_SELF_CHECK':
      return state.set('BCCToSelf', payload.checked);
    case 'INCLUDE_NOTES_CHECK':
      return state.set('includeNotes', payload.checked);
    case 'UPDATE_PROPS_RESEND_CONTRACT_REDUCER':
      return state.merge((0, _immutable.fromJS)(payload));
    case 'UPDATE_CONTRACT_PARTNER_INFO_STARTED':
      return state.set('loading', true);
    case 'UPDATE_CONTRACT_PARTNER_INFO_ERROR':
      return state.set('loading', false);
    case 'RESEND_CONTRACT_STARTING':
      return state.set('loading', payload);
    case 'RESEND_CONTRACT_FINISHED':
      return state.set('loading', false).set('finishedSendingEmail', true);
    default:
      return state;
  }
}

/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = requestsWithSameNameOrDomainDialog;

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  contractPeriod: {},
  searchCompanyName: '',
  searchDomain: '',
  open: false,
  dataLoaded: false,
  loadingData: false,
  requests: [],
  selectedIds: [],
  apiCallStatus: '' // processing, success, error
};

function requestsWithSameNameOrDomainDialog() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case 'OPEN_DIALOG_SHOW_REQUESTS_WITH_SAME_NAME':
      return _extends({}, state, {
        open: true,
        contractPeriod: payload.contractPeriod,
        searchCompanyName: payload.searchCompanyName,
        searchDomain: payload.searchDomain,
        contractIdToExclude: payload.contractIdToExclude
      });
    case 'GET_CONTRACT_REQUESTS_BY_COMPANY_STARTED':
      return _ramda2.default.assoc('loadingData', true, state);
    case 'GET_CONTRACT_REQUESTS_BY_COMPANY_SUCCESS':
      return _extends({}, state, {
        loadingData: false,
        dataLoaded: true,
        requests: payload.list.filter(function (contract) {
          return contract._id !== state.contractIdToExclude;
        }),
        selectedIds: payload.list.filter(function (contract) {
          return contract._id !== state.contractIdToExclude;
        }).map(_ramda2.default.prop('_id'))
      });
    case 'ON_CHECK_IN_REQUESTS_WITH_SAME_NAME_DIALOG':
      if (payload.checked) {
        return _extends({}, state, {
          selectedIds: _ramda2.default.append(payload.id, state.selectedIds)
        });
      }
      return _extends({}, state, {
        selectedIds: state.selectedIds.filter(function (id) {
          return id !== payload.id;
        })
      });
    case 'GET_CONTRACT_REQUESTS_BY_COMPANY_ERROR':
      return _ramda2.default.assoc('loadingData', false, state);
    case 'DISCARD_SELECTED_IN_REQUESTS_WITH_SAME_NAME_DIALOG_STARTED':
      return _extends({}, state, {
        apiCallStatus: 'processing'
      });
    case 'DISCARD_SELECTED_IN_REQUESTS_WITH_SAME_NAME_DIALOG_SUCCESS':
      return _extends({}, state, {
        apiCallStatus: 'success'
      });
    case 'DISCARD_SELECTED_IN_REQUESTS_WITH_SAME_NAME_DIALOG_ERROR':
      return _extends({}, state, {
        apiCallStatus: 'error'
      });
    case 'ON_SELECT_ALL_IN_REQUESTS_WITH_SAME_NAME_DIALOG':
      return _extends({}, state, {
        selectedIds: payload.checked ? state.requests.map(_ramda2.default.prop('_id')) : []
      });
    case 'CLOSE_DIALOG_SHOW_REQUESTS_WITH_SAME_NAME':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = requestDL;


var initialState = {
  open: false,
  requestId: '',
  rateConversionSetting: '',
  loading: false,
  success: false,
  messageForDL: '',
  priority: 'Medium'
};

function requestDL() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'OPEN_REQUEST_DL':
      return _extends({}, state, {
        open: true,
        contractId: payload.contractId,
        files: payload.files
      });
    case 'CHECK_RATE_LOADING_SETTING':
      return _extends({}, state, {
        rateConversionSetting: payload.setting
      });
    case 'CHECK_RATE_LOADING_PRIORITY':
      return _extends({}, state, {
        priority: payload.priority
      });
    case 'ENTER_MESSAGE_FOR_DL_IN_REQUEST_DIALOG':
      return _extends({}, state, {
        messageForDL: payload
      });
    case 'REQUEST_DL_STARTED':
      return _extends({}, state, {
        loading: true
      });
    case 'REQUEST_DL_ERROR':
      return _extends({}, state, {
        loading: false
      });
    case 'REQUEST_DL_SUCCESS':
      return _extends({}, state, {
        loading: false,
        success: true
      });
    case 'CLOSE_REQUEST_RATE_LOADING_DIALOG':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.fromJS)({
  buyAndSupplierWizardStepper: 0,
  addRatesStepper: 0,
  addRateSetStepper: 0,
  addProductsStepper: 0,
  specialOffersStepper: 0,
  ratesWizardForMulitpleProduct: 0,
  addExtraStepper: 0,
  importFromTemplateStepper: 0
});

function steppers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'CHANGE_STEPPER_WIZARD_STEP':
      return state.set(payload.stepperWizardName, payload.componentIndex);
    case 'CHANGE_STEP_STATE':
      if (payload.toClearAddProductW2) return state.set('ratesWizardForMulitpleProduct', 0);
      return state;
    case 'CONTRACT_PRODUCT_UPDATED':
    case 'CLEAR_CONTRACTOR_CONTRACTING_WIZARD':
    case 'CLOSE_ADD_EDIT_CONTRACT_DIALOG':
      return initialState;
    case 'REMOVE_RATE_SET_FROM_SEASON_WHEN_GO_BACK':
      return state.set('addRatesStepper', 2);
    case 'ADD_RATE_SET_TO_SEASON':
      return state.set('addRatesStepper', 3);
    case 'PRODUCTS_SAVED_GO_TO_BILLING':
      return state.set('addProductsStepper', 0).set('addRatesStepper', 0).set('addRateSetStepper', 0);
    case 'ADD_CHECKED_PRODUCTS_TO_ADD_PRODUCT_WIZARD':
      return state.set('addProductsStepper', 2);
    case '{rates-draft} MANAGE_EXTRAS_OFFERS_SUCCESS':
      return state.set('specialOffersStepper', 0).set('addExtraStepper', 0);
    case 'CLEAR_ADD_RATE_SET_WIZARD':
      return state.set('addRateSetStepper', 0);
    default:
      return state;
  }
}

exports.default = steppers;

/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = __webpack_require__(26);

var checkValidity = function checkValidity(state) {
  var fields = ['startDate', 'endDate', 'deadlineDate', 'taxId', 'customizedMessage'];
  return fields.reduce(function (oldState, field) {
    if (oldState.get(field)) return oldState;
    return oldState.setIn(['errors', field, 'show'], true);
  }, state);
};

var updateFieldAndErrors = function updateFieldAndErrors(state, _ref) {
  var key = _ref.key,
      value = _ref.value;

  if (value) {
    if (state.getIn(['errors', key, 'show'])) return state.set(key, value).setIn(['errors', key, 'show'], false);
    return state.set(key, value);
  }
  return state.set(key, value).setIn(['errors', key, 'show'], true);
};

var updateDates = function updateDates(state, _ref2) {
  var key = _ref2.key,
      value = _ref2.value;

  var startDate = state.get('startDate');
  var endDate = state.get('endDate');
  // const deadlineDate = state.get('deadlineDate');
  if (key === 'startDate') {
    if (endDate) {
      if (value > endDate) {
        return state.set(key, value).setIn(['errors', 'startDate', 'show'], true).setIn(['errors', 'endDate', 'show'], true);
      }
      if (value <= endDate) {
        return state.set(key, value).setIn(['errors', 'startDate', 'show'], false).setIn(['errors', 'endDate', 'show'], false);
      }
    }
    // if (deadlineDate) {
    //   console.log('re-check');
    //   return updateDates(newState || state, {
    //     key: 'deadlineDate',
    //     value: deadlineDate,
    //   });
    // }
  }
  if (key === 'endDate') {
    if (startDate) {
      if (value < startDate) {
        return state.set(key, value).setIn(['errors', 'startDate', 'show'], true).setIn(['errors', 'endDate', 'show'], true);
      }
      if (value >= startDate) {
        return state.set(key, value).setIn(['errors', 'startDate', 'show'], false).setIn(['errors', 'endDate', 'show'], false);
      }
    }
  }
  if (key === 'deadlineDate') {
    if (startDate) {
      if (value > startDate) {
        return state.set(key, value).setIn(['errors', 'deadlineDate', 'show'], true);
      }
      return state.set(key, value).setIn(['errors', 'deadlineDate', 'show'], false);
    }
  }

  return state.set(key, value).setIn(['errors', key, 'show'], false);
};

var initialStateObject = {
  creatingContracts: false,
  radioButtonValue: '',
  showAllContractPartners: false,
  submissionCriteria: '',
  notesRadioButtonValue: '',
  termsAndConditions: '',
  termsRadioButtonValue: '',
  submissionCriteriaCopyTemplateValue: 1,
  customizedMessage: '',
  subject: '',
  errors: {
    taxId: { show: false, errorText: 'Corporate identifier / tax id is required.' },
    termsAndConditions: { show: false, errorText: 'Terms & conditions is required.' },
    submissionCriteria: { show: false, errorText: 'This field is required.' },
    startDate: { show: false, errorText: 'Valid date range is required' },
    endDate: { show: false, errorText: 'Valid date range is required' },
    deadlineDate: { show: false, errorText: 'The deadline date must be a date prior to the start of the contracting period' }
  },
  buyerBCCSelf: false,
  includeNotes: false,
  assignTag: false,
  assignFolder: false
};
var initialState = (0, _immutable.fromJS)(initialStateObject);

function wizard() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case 'UPDATE_PROPS_IN_CONTRACT_REQUEAST_WIZARD':
      return state.merge((0, _immutable.fromJS)(payload));
    case 'NOTES_RADIO_BUTTON_CHANGE':
      return state.set('notesRadioButtonValue', payload.value);
    case 'TERMS_RADIO_BUTTON_CHANGE':
      return state.set('termsRadioButtonValue', payload.value);
    case 'CREATE_CONTRACT_STARTING':
      return state.set('creatingContracts', !state.get('creatingContracts'));
    case 'CREATE_CONTRACT':
      return state.set('creatingContracts', false);
    case 'SUBMIT_COPY_SELECTION':
      return state.set(payload.templateType, payload.value);
    case 'SET_RADIO_BUTTON_VALUE':
      return state.set('radioButtonValue', payload);
    case 'ADD_SELECTED_CONNECTIONS':
      return state.setIn(['modals', 'selectFromUploadedConnections'], false).setIn(['modals', 'selectFromExistingConnections'], false);
    case 'SHOW_ALL_CONTRACT_PARTNERS':
      return state.set('showAllContractPartners', payload);
    case 'ADD_CONTRACT_SETTINGS_UPDATE':
      if (new Set(['startDate', 'endDate', 'deadlineDate']).has(payload.key)) {
        if (payload.key === 'startDate' && state.get('deadlineDate')) {
          // console.log('double check');
          return updateDates(updateDates(state, payload), { key: 'deadlineDate', value: state.get('deadlineDate') });
        }
        return updateDates(state, payload);
      }
      return updateFieldAndErrors(state, payload);
    case 'ADD_CUSTOMIZED_MESSAGE':
      return state.set('customizedMessage', payload.value);
    case 'DISABLE_CONTINUE_AND_SHOW_ERRORS':
      return checkValidity(state);
    case 'SET_SUBMISSION_CRITERIA_COPY_TEMPLATE_DROPDOWN_VALUE':
      return state.set('submissionCriteriaCopyTemplateValue', payload);
    case 'CLEAR_CONTRACTOR_CONTRACTING_WIZARD':
      return (0, _immutable.fromJS)(_extends({}, initialStateObject, {
        taxId: state.get('taxId'),
        customizedMessage: state.get('customizedMessage')
      }, payload));
    case 'PROCESSING_ALL_CONTRACTING_PARTNERS':
      return state.set('processingPartners', !state.get('processingPartners'));
    case 'PROCESSED_ALL_CONTRACTING_PARTNERS':
      return state.set('processingPartners', false);
    default:
      return state;
  }
}

exports.default = wizard;

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(26);

var _constants = __webpack_require__(648);

var constants = _interopRequireWildcard(_constants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({
  allContractPartners: [],
  bccSelf: false,
  contractRequest: {},
  contractsSent: false,
  drafts: [],
  loadedLocations: false,
  loadedTemplates: false,
  loadingLocations: false,
  loadingTemplates: false,
  locationId: null,
  locations: [],
  message: '',
  processedPartners: [],
  processingPartners: false,
  productIdNameMap: {},
  sendingContracts: false,
  sendTemplateOrGroup: '',
  stepIndex: 0,
  subject: '',
  templateGroups: [],
  templateGroupSelected: {},
  templates: [],
  templateSelected: {}
});

var supplierWizard = function supplierWizard() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'UPDATE_CONTRACTING_DASHBOARD_PROP':
      if (payload.sendToPFBuyers) return state.set('startDate', payload.startDate).set('endDate', payload.endDate);
      return state;
    case constants.GET_CONTRACT_REQUEST_INFO:
      return state.setIn(['contractRequest', 'contractId'], payload);
    case constants.GET_CONTRACT_REQUEST_INFO + '_SUCCESS':
      return state.set('contractRequest', (0, _immutable.fromJS)(payload)).setIn(['contractRequest', 'contentLoaded'], true).set('startDate', payload.startDate).set('endDate', payload.endDate);
    case '[supplier-wizard]GET_RESPONDED_CONTRACT_LIST_SUCCESS':
      return state.setIn(['contractRequest', 'respondedContractList'], (0, _immutable.fromJS)(payload.list));
    case constants.SENDING_CONTRACTS:
      return state.set('sendingContracts', !state.get('sendingContracts'));
    case constants.CONTRACTS_CREATED:
      return state.set('sendingContracts', false).set('contractsSent', true);
    case constants.UPDATE_PROPS:
      return state.merge((0, _immutable.fromJS)(payload));
    case constants.LOADING_TEMPLATES:
      return state.set('loadingTemplates', !state.get('loadingTemplates'));
    case constants.LOCATIONS_LOADED:
      var filteredLocations = payload.locations || [];
      return state.set('locations', (0, _immutable.fromJS)(filteredLocations)).set('loadingLocations', false).set('loadedLocations', true).set('singleLoc', filteredLocations.length === 1).set('locationId', filteredLocations.length === 1 ? _ramda2.default.path([0, 'id'], filteredLocations) : undefined);
    case constants.PROCESSING_PARTNERS:
      return state.set('processingPartners', !state.get('processingPartners'));
    case constants.PARTNERS_PROCESSED:
      return state.set('processedPartners', (0, _immutable.fromJS)(payload.processedPartners)).set('stepIndex', 2);
    case constants.TEMPLATES_LOADED:
      return state.merge((0, _immutable.fromJS)(payload)).set('loadedTemplates', true);
    case constants.CLEAR_STORE:
      return initialState.merge({
        templateGroups: state.get('templateGroups'),
        locations: state.get('locations'),
        templates: state.get('templates')
      });
    case constants.RESET_TEMPLATE_SELECTION:
      return state.set('locationId', state.get('singleLoc') ? state.get('locationId') : null).set('templateGroupSelected', (0, _immutable.fromJS)({})).set('templateSelected', (0, _immutable.fromJS)({}));
    case constants.RESET_LOCATION_SELECTION:
      return state.set('locationId', state.get('singleLoc') ? state.get('locationId') : null);
    default:
      return state;
  }
};

exports.default = supplierWizard;

/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(26);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _contractingPresetNamesCodes = __webpack_require__(464);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = (0, _immutable.fromJS)({
  rateSetName: '',
  departOnDays: [],
  daysOfWeek: [],
  minStay: '',
  maxStay: '',
  commissionPercentage: undefined,
  rateType: 'includeCommission',
  includedGuestsinBaseRate: undefined,
  maxAdults: undefined,
  maxAdultsChildren: undefined,
  costBasis: '',
  retailRate: 0,
  baseRate: undefined,
  additionalAdult: undefined,
  additionalChild: undefined,
  rates: [],
  nonStandardTemplateType: 'standard',
  transfersOrPriceBreak: [{}],
  nonAccomStandard: { nett: {}, retail: {} },
  formData: {}
});

function addRateSetWizard() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'UPDATE_FORM_DATA_SUCCESS':
      return state.update('formData', function (formData) {
        return formData.merge((0, _immutable.fromJS)(payload));
      });
    case 'GET_PRODUCT_DETAILS':
      if (payload.formData && payload.formData.currency) {
        var _payload$formData = payload.formData,
            rateType = _payload$formData.rateType,
            additionalAdultRetail = _payload$formData.additionalAdultRetail,
            additionalChildRetail = _payload$formData.additionalChildRetail,
            commissionPercentage = _payload$formData.commissionPercentage;

        if (rateType === 'includeCommission') {
          var nettAdult = additionalAdultRetail && commissionPercentage ? Number(additionalAdultRetail - commissionPercentage * additionalAdultRetail / 100).toFixed(2) : undefined;
          var nettChild = additionalChildRetail && commissionPercentage ? Number(additionalChildRetail - commissionPercentage * additionalChildRetail / 100).toFixed(2) : undefined;
          return state.merge((0, _immutable.fromJS)(payload.formData)).set('formData', (0, _immutable.fromJS)(payload.formData)).set('additionalAdult', nettAdult).set('additionalChild', nettChild);
        }
        return state.merge((0, _immutable.fromJS)(payload.formData)).set('formData', (0, _immutable.fromJS)(payload.formData));
      }
      return state;
    case 'UPDATE_ADD_RATES_FIELD_WITH_KEYPATH':
      if (payload.keyPath[0] === 'transfersOrPriceBreak') {
        if ((0, _ramda.last)(payload.keyPath) === 'retailRate') {
          return state.setIn(payload.keyPath, payload.value).setIn(['transfersOrPriceBreak', payload.keyPath[1], 'baseRate'], Number(payload.value - payload.value * (state.get('commissionPercentage') || 100) / 100).toFixed(2));
        }
        if ((0, _ramda.last)(payload.keyPath) === 'minGuests' && payload.keyPath[1]) {
          if (Number(payload.value) <= Number(state.getIn(['transfersOrPriceBreak', payload.keyPath[1] - 1, 'minGuests']))) {
            return state.setIn(payload.keyPath, Number(payload.value));
          }
          return state.setIn(['transfersOrPriceBreak', payload.keyPath[1] - 1, 'maxAdultsPlusChild'], Number(payload.value) - 1).setIn(payload.keyPath, Number(payload.value));
        }
        if (state.get('nonStandardTemplateType') === 'priceBreak' && (0, _ramda.last)(payload.keyPath) === 'maxAdultsPlusChild' && payload.keyPath[1] < state.get('transfersOrPriceBreak').size - 1) {
          return state.setIn(['transfersOrPriceBreak', payload.keyPath[1] + 1, 'minGuests'], Number(payload.value) + 1).setIn(payload.keyPath, Number(payload.value));
        }
      }
      return state.setIn(payload.keyPath, (0, _immutable.fromJS)(payload.value));
    case 'UPDATE_ADD_RATES_FIELD':
      return updateAddRatesField(state, payload);
    case 'UPDATE_ADD_RATES_DAYSOFWEEK':
      if (payload.day === 'All') {
        if (payload.checked) return state.set('daysOfWeek', (0, _immutable.fromJS)(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']));
        return state.set('daysOfWeek', (0, _immutable.fromJS)([]));
      }
      if (payload.checked) return state.update('daysOfWeek', function (daysOfWeek) {
        return daysOfWeek.push(payload.day);
      });
      return state.deleteIn(['daysOfWeek', payload.dayIndexInReducer]);
    case 'UPDATE_ADD_RATES_RATES_TABLE_CELL_VALUE':
      if (payload.column === 'maxChild') {
        return state.updateIn(['rates', payload.row], function (rateDetails) {
          return rateDetails.merge((0, _immutable.fromJS)({
            maxChild: payload.value,
            maxAdultsPlusChild: parseInt(state.getIn(['rates', payload.row, 'maxAdults']), 10) + parseInt(payload.value, 10)
          }));
        });
      }
      if (payload.column === 'minGuests' && payload.row) {
        if (Number(payload.value) <= Number(state.getIn(['rates', payload.row - 1, 'minGuests']))) {
          return state.setIn(['rates', payload.row, payload.column], Number(payload.value));
        }
        return state.setIn(['rates', payload.row - 1, 'maxAdultsPlusChild'], Number(payload.value) - 1).setIn(['rates', payload.row, payload.column], Number(payload.value));
      }
      if (state.get('nonStandardTemplateType') === 'priceBreak' && payload.column === 'maxAdultsPlusChild' && payload.row < state.get('rates').size - 1) {
        return state.setIn(['rates', payload.row + 1, 'minGuests'], Number(payload.value) + 1).setIn(['rates', payload.row, payload.column], payload.value);
      }
      return state.setIn(['rates', payload.row, payload.column], payload.value);

    case 'CALCULATE_RATES_TABLE':
      return calRatesTableForAccommodation(state);
    case 'CALCULATE_STANDARD_NON_ACCOM_RATES_TABLE':
      if (state.get('nonStandardTemplateType') === 'multiDayTour') return calculateMultiDayTourRates(state);
      if (state.get('nonStandardTemplateType') === 'privateTransfer') return calculatePrivateTransfersRates(state);
      if (state.get('nonStandardTemplateType') === 'priceBreak') return calculatePriceBreakRates(state);
      return calculateStandardNonAccomRate(state);

    case 'SAVING_RATE_SET_TO_DB_STARTING':
      return state.set('saving', true);
    case 'CLEAR_ADD_RATE_SET_WIZARD':
    case 'CLOSE_ADD_EDIT_CONTRACT_DIALOG':
    case '{rates-draft} MANAGE_EXTRAS_OFFERS_SUCCESS':
    case 'CONTRACT_PRODUCT_UPDATED':
      return initialState.merge((0, _immutable.fromJS)({
        // location information is persistent through the location, need to update it if user update it once
        currency: state.get('currency'),
        taxInclusion: state.get('taxInclusion'),
        taxType: state.get('taxType'),
        // product information is persistent through the product, need to update it if user update it once
        includedGuestsinBaseRate: state.get('includedGuestsinBaseRate'),
        maxAdults: state.get('maxAdults'),
        maxAdultsChildren: state.get('maxAdultsChildren'),
        additionalAdult: state.get('additionalAdult'),
        additionalChild: state.get('additionalChild'),
        additionalAdultRetail: state.get('additionalAdultRetail'),
        additionalChildRetail: state.get('additionalChildRetail'),
        paxMax: state.get('paxMax'),
        twinBedsAvail: state.get('twinBedsAvail'),
        // rateType information is persistent through the draft no matter user update them in a wizard or not
        rateType: state.getIn(['formData', 'rateType']),
        commissionPercentage: state.getIn(['formData', 'commissionPercentage']),
        nettCommission: state.getIn(['formData', 'nettCommission']),
        formData: state.get('formData')
      }));
    default:
      return state;
  }
}

var calculatePriceBreakRates = function calculatePriceBreakRates(thisState) {
  var transfersOrPriceBreak = thisState.get('transfersOrPriceBreak').toJS().filter(function (rate) {
    return rate.minGuests && rate.baseRate;
  });
  var rates = function () {
    return transfersOrPriceBreak.map(function (priceBreak) {
      return {
        description: 'Per Person',
        maxAdultsPlusChild: priceBreak.maxAdultsPlusChild || 999,
        minGuests: priceBreak.minGuests,
        nettRate: Number(priceBreak.baseRate).toFixed(2),
        retailRate: thisState.get('rateType') === 'nett' ? undefined : Number(priceBreak.retailRate).toFixed(2)
      };
    });
  }();
  return thisState.set('rates', (0, _immutable.fromJS)(rates));
};

var calculatePrivateTransfersRates = function calculatePrivateTransfersRates(thisState) {
  var transfersOrPriceBreak = thisState.get('transfersOrPriceBreak').toJS();
  var sortedTransfer = (0, _ramda.sort)(function (a, b) {
    return Number(a.maxAdultsPlusChild) - Number(b.maxAdultsPlusChild);
  }, transfersOrPriceBreak);
  var rates = function () {
    return sortedTransfer.map(function (transfer) {
      return {
        description: 'Up to',
        priceCode: '',
        maxAdultsPlusChild: Number(transfer.maxAdultsPlusChild),
        nettRate: Number(transfer.baseRate).toFixed(2),
        retailRate: thisState.get('rateType') === 'nett' ? undefined : Number(transfer.retailRate).toFixed(2)
      };
    });
  }();
  return thisState.set('rates', (0, _immutable.fromJS)(rates));
};

var calculateMultiDayTourRates = function calculateMultiDayTourRates(thisState) {
  var rateKeys = _contractingPresetNamesCodes.multiDayTourDescrs;

  var rates = rateKeys.map(function (rateKey) {
    var actualKey = rateKey.toLowerCase();
    var maxAdults = function () {
      if (_contractingPresetNamesCodes.multiDayToursMaxAdultOne.indexOf(rateKey) > -1) return 1;
      return 0;
    }();
    var maxAdultsPlusChild = function () {
      if ([].concat(_toConsumableArray(_contractingPresetNamesCodes.multiDayToursMaxAdultOne), _toConsumableArray(_contractingPresetNamesCodes.multiDayToursMaxChildOne)).indexOf(rateKey) > -1) return 1;
      return 0;
    }();
    var retailRate = !isNaN(thisState.getIn(['nonAccomStandard', 'retail', actualKey])) ? Number(thisState.getIn(['nonAccomStandard', 'retail', actualKey])).toFixed(2) : thisState.getIn(['nonAccomStandard', 'retail', actualKey]);
    var nettRate = Number(thisState.getIn(['nonAccomStandard', 'nett', actualKey])).toFixed(2);
    return {
      description: rateKey,
      maxAdults: maxAdults,
      maxAdultsPlusChild: maxAdultsPlusChild,
      maxChild: _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('extra child'), _ramda2.default.always(1)], [_ramda2.default.T, _ramda2.default.always(0)]]), actualKey),
      retailRate: retailRate,
      nettRate: isNaN(nettRate) ? null : nettRate,
      notApplicable: !(0, _ramda.any)(function (value) {
        return value;
      })([thisState.getIn(['nonAccomStandard', 'retail', actualKey]), thisState.getIn(['nonAccomStandard', 'nett', actualKey])])
    };
  });
  return thisState.set('rates', (0, _immutable.fromJS)(rates)).set('nonStandardTemplateType', 'multiDayTour');
};

var calculateStandardNonAccomRate = function calculateStandardNonAccomRate(state) {
  var rateKeys = ['Adult', 'Child', 'Infant', 'Family', 'Senior/Concession', 'Student', 'General'];

  var rates = rateKeys.map(function (rateKey) {
    var actualKey = rateKey.toLowerCase().indexOf('senior') > -1 ? 'senior' : rateKey.toLowerCase();
    var maxAdults = function () {
      if (['adult', 'senior', 'student', 'general'].indexOf(actualKey) > -1) return 1;
      if (actualKey === 'family') return 2;
      return 0;
    }();
    var maxAdultsPlusChild = function () {
      if (['adult', 'child', 'senior', 'student', 'general'].indexOf(actualKey) > -1) return 1;
      if (actualKey === 'family') return 4;
      return 0;
    }();
    var retailRate = !isNaN(state.getIn(['nonAccomStandard', 'retail', actualKey])) ? Number(state.getIn(['nonAccomStandard', 'retail', actualKey])).toFixed(2) : state.getIn(['nonAccomStandard', 'retail', actualKey]);
    var nettRate = Number(state.getIn(['nonAccomStandard', 'nett', actualKey])).toFixed(2);
    return {
      description: rateKey,
      maxAdults: maxAdults,
      maxChild: _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('child'), _ramda2.default.always(1)], [_ramda2.default.equals('family'), _ramda2.default.always(2)], [_ramda2.default.T, _ramda2.default.always(0)]]), actualKey),
      maxAdultsPlusChild: maxAdultsPlusChild,
      retailRate: retailRate,
      nettRate: isNaN(nettRate) ? null : nettRate,
      notApplicable: !(0, _ramda.any)(function (value) {
        return value;
      })([state.getIn(['nonAccomStandard', 'retail', actualKey]), state.getIn(['nonAccomStandard', 'nett', actualKey])])
    };
  });
  return state.set('rates', (0, _immutable.fromJS)(rates));
};

function getRateDesc(maxAdults) {
  switch (maxAdults) {
    case 1:
      return 'Single';
    case 2:
      return 'Double';
    case 3:
      return 'Triple';
    case 4:
      return 'Quad';
    default:
      return maxAdults;
  }
}

function calRatesTableForAccommodation(thisState) {
  var includedGuestsinBaseRate = parseInt(thisState.get('includedGuestsinBaseRate'), 10);
  var isCommisionRate = thisState.get('rateType') !== 'nett';
  var baseRate = thisState.get('baseRate') ? Number(thisState.get('baseRate')) : 0;
  var additionalAdult = thisState.get('additionalAdult') ? Number(thisState.get('additionalAdult')) : 0;
  var additionalAdultRetail = thisState.get('additionalAdultRetail') ? Number(thisState.get('additionalAdultRetail')) : 0;
  var additionalChild = thisState.get('additionalChild') ? Number(thisState.get('additionalChild')) : 0;
  var additionalChildRetail = thisState.get('additionalChildRetail') ? Number(thisState.get('additionalChildRetail')) : 0;
  var maxAdults = thisState.get('maxAdults') ? parseInt(thisState.get('maxAdults'), 10) : 0;
  var maxAdultsChildren = thisState.get('maxAdultsChildren') ? parseInt(thisState.get('maxAdultsChildren'), 10) : 0;
  var rates = new Array(Math.max(4, maxAdults)).fill(1).map(function (_, index) {
    var i = index + 1;
    var maxAdultsPlusChild = maxAdultsChildren;
    var nettRate = i < includedGuestsinBaseRate ? Number(baseRate).toFixed(2) : Number(baseRate + additionalAdult * (i - includedGuestsinBaseRate)).toFixed(2);
    var retailRate = function () {
      if (!isCommisionRate) return undefined;
      if (i < includedGuestsinBaseRate) return Number(thisState.get('retailRate')).toFixed(2);
      return Number(Number(thisState.get('retailRate')) + additionalAdultRetail * (i - includedGuestsinBaseRate)).toFixed(2);
    }();
    var description = function () {
      if (maxAdults > 4) return i + ' Guest' + (i > 1 ? 's' : '');
      return getRateDesc(i);
    }();
    return {
      description: description,
      maxAdults: i,
      maxAdultsPlusChild: maxAdultsPlusChild,
      nettRate: nettRate,
      retailRate: retailRate,
      priceCode: '',
      notApplicable: index >= maxAdults || i > 2 && thisState.get('paxMax') < i
    };
  });
  var ratesWithExtra = (0, _ramda.concat)(rates, [{
    description: 'Extra Adult',
    maxAdults: undefined,
    maxAdultsPlusChild: undefined,
    nettRate: additionalAdult.toFixed(2),
    retailRate: isCommisionRate ? additionalAdultRetail.toFixed(2) : undefined,
    notApplicable: true,
    priceCode: ''
  }, {
    description: 'Extra Child',
    maxAdults: undefined,
    maxAdultsPlusChild: undefined,
    nettRate: additionalChild.toFixed(2),
    retailRate: isCommisionRate ? additionalChildRetail.toFixed(2) : undefined,
    notApplicable: function () {
      if (additionalChild) {
        if (additionalChild !== additionalAdult) return false;
      }
      if (additionalChildRetail) {
        if (additionalChildRetail !== additionalAdultRetail) return false;
      }
      return maxAdults === maxAdultsChildren;
    }(),
    priceCode: ''
  }, {
    description: 'Extra Infant',
    maxAdults: undefined,
    maxAdultsPlusChild: undefined,
    nettRate: undefined,
    retailRate: undefined,
    notApplicable: true,
    priceCode: ''
  }]);
  var ratesToSave = (0, _immutable.fromJS)((0, _ramda.insert)(2, (0, _ramda.merge)(rates[1], { description: 'Twin', notApplicable: maxAdults > 4 || maxAdults < 2 || thisState.get('paxMax') < 2 || !thisState.get('twinBedsAvail') }), ratesWithExtra));

  return thisState.set('rates', ratesToSave);
}

var updateAddRatesField = function updateAddRatesField(state, payload) {
  if (payload.nonAccomStandard) {
    if (payload.retail) {
      return state.setIn(['nonAccomStandard', 'retail', payload.fieldName], payload.value).setIn(['nonAccomStandard', 'nett', payload.fieldName], Number(payload.value - payload.value * (state.get('commissionPercentage') || 100) / 100).toFixed(2));
    }
    return state.setIn(['nonAccomStandard', 'nett', payload.fieldName], payload.value);
  }
  var retailNettRateMapForAccommo = {
    retailRate: 'baseRate',
    additionalAdultRetail: 'additionalAdult',
    additionalChildRetail: 'additionalChild'
  };
  if (retailNettRateMapForAccommo[payload.fieldName] && payload.value) {
    return state.set(payload.fieldName, payload.value).set(retailNettRateMapForAccommo[payload.fieldName], Number(payload.value - payload.value * (state.get('commissionPercentage') || 100) / 100).toFixed(2));
  }
  if (payload.fieldName === 'commissionPercentage' && payload.value) {
    var retailRates = state.getIn(['nonAccomStandard', 'retail']).toJS();
    var keys = Object.keys(retailRates);
    var nettRates = keys.length ? keys.reduce(function (rates, key) {
      var retailRate = retailRates[key] || 0;
      rates[key] = Number(retailRate - retailRate * payload.value / 100).toFixed(2);
      return rates;
    }, {}) : {};
    var additionalAdultRetail = state.get('additionalAdultRetail') || 0;
    var additionalChildRetail = state.get('additionalChildRetail') || 0;
    return state.set(payload.fieldName, payload.value).set('baseRate', Number(state.get('retailRate') - payload.value * state.get('retailRate') / 100).toFixed(2)).set('additionalAdult', Number(additionalAdultRetail - payload.value * additionalAdultRetail / 100).toFixed(2)).set('additionalChild', Number(additionalChildRetail - payload.value * additionalChildRetail / 100).toFixed(2)).setIn(['nonAccomStandard', 'nett'], (0, _immutable.fromJS)(nettRates)).update('transfersOrPriceBreak', function (transfers) {
      return transfers.map(function (transfer) {
        return transfer.set('baseRate', Number(transfer.get('retailRate') - payload.value * transfer.get('retailRate') / 100).toFixed(2));
      });
    });
  }
  if (payload.fieldName === 'maxAdults') {
    return state.merge((0, _immutable.fromJS)({
      maxAdults: payload.value
      // maxAdultsError: payload.value < state.get('includedGuestsinBaseRate') ? 'This value cannot be less than included guests.' : '',
    }));
  }
  if (payload.fieldName === 'maxAdultsChildren') {
    return state.merge((0, _immutable.fromJS)({
      maxAdultsChildren: payload.value
      // maxGuestsError: payload.value < state.get('maxAdults') ? 'This value cannot be less than maximum adults.' : '',
    }));
  }
  if (payload.fieldName === 'includedGuestsinBaseRate') {
    return state.merge((0, _immutable.fromJS)({
      includedGuestsinBaseRate: payload.value
      // includedGuestsError: payload.value > state.get('maxAdults') ? 'This value cannot be more than maximum adults.' : '',
    }));
  }
  if (payload.fieldName === 'rateType') {
    return state.merge((0, _immutable.fromJS)({
      rateType: payload.value,
      retailRate: '',
      baseRate: '',
      additionalAdult: '',
      additionalAdultRetail: '',
      additionalChild: '',
      additionalChildRetail: '',
      nettCommission: undefined,
      commissionPercentage: undefined,
      nonAccomStandard: { nett: {}, retail: {} }
    })).set('transfersOrPriceBreak', state.get('transfersOrPriceBreak').map(function (transfer) {
      return transfer.set('baseRate', 0).set('retailRate', 0);
    }));
  }
  if (payload.fieldName === 'seasonName') return state;
  if (payload.fieldName === 'stayPays') return state.set('stayPays', (0, _immutable.fromJS)(payload.value));
  return state.set(payload.fieldName, payload.value);
};

exports.default = addRateSetWizard;

/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.fromJS)({
  selectedSeasonName: '',
  seasonName: '',
  dateRanges: [],
  rateSets: []
});

function addRatesWizard() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'UPDATE_SEASON_IN_WIZARD_WITH_KEYPATH':
      return state.setIn(payload.keyPath, (0, _immutable.fromJS)(payload.value));
    case 'ADD_DATE_RANGES_TO_SEASON':
      var dateRanges = payload.ranges.map(function (range) {
        return { seasonStartDate: range.from, seasonEndDate: range.to };
      });
      return state.set('dateRanges', (0, _immutable.fromJS)(dateRanges));
    case 'ADD_RATE_SET_TO_SEASON':
      return state.update('rateSets', function (rateSets) {
        return rateSets.push((0, _immutable.fromJS)(payload));
      });
    case 'SAVING_SEASONRATES_TO_DB_STARTING':
      return state.set('saving', true);
    case 'SELECT_FROM_EXISTING_SEASON':
      return state.merge((0, _immutable.fromJS)(payload)).set('selectedSeasonName', payload.seasonName);
    case 'REMOVE_RATE_SET_FROM_SEASON_WHEN_GO_BACK':
      return state.set('rateSets', (0, _immutable.fromJS)([]));
    case 'CLOSE_ADD_EDIT_CONTRACT_DIALOG':
    case 'PRODUCTS_SAVED_GO_TO_BILLING':
    case 'CONTRACT_PRODUCT_UPDATED':
      return initialState;
    default:
      return state;
  }
}

exports.default = addRatesWizard;

/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  comment: '',
  attachedFiles: [],
  focused: false
};

function commentBox() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'HANDLE_CONTRACTING_COMMENT_INPUT':
      return _extends({}, state, { comment: payload });
    case 'HANDLE_CONTRACTING_COMMENT_FILE_INPUT':
      return _extends({}, state, { attachedFiles: payload });
    case 'SET_CONTRACTING_COMMENT_FOCUS':
      return _extends({}, state, { focused: payload });
    case 'CANCEL_CONTRACTING_COMMENT':
    case 'SUBMIT_CONTRACTING_COMMENT_STARTED':
      return initialState;
    default:
      return state;
  }
}

exports.default = commentBox;

/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = __webpack_require__(26);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _constants = __webpack_require__(252);

var contractingCnts = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var initialState = (0, _immutable.fromJS)({
  leftNav: {
    isLatest: true
  },
  notes: [],
  activities: {},
  rightSideContent: {},
  draftErrors: {},
  changeLogs: [],
  loadingLogs: false,
  showAllDraftErrorsDialog: false,
  showDraftChangesPopover: {
    open: false,
    anchorEl: null
  },
  contentLoading: false,
  leftNavLoading: false,
  createDraftDialogOpen: false
});

function contractActivitiesProducts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload,
      args = _ref.args;

  switch (type) {
    case '[contractTemplate]TOGGLE_CREATE_DRAFT_DIALOG':
      return state.set('createDraftDialogOpen', !state.get('createDraftDialogOpen'));
    case 'TOGGLE_DRAFT_ERRORS_DIALOG':
      return state.set('showAllDraftErrorsDialog', !state.get('showAllDraftErrorsDialog'));
    case 'TOGGLE_SHOW_DRAFT_CHANGES_POPOVER':
      return state.set('showDraftChangesPopover', (0, _immutable.fromJS)(payload));
    case 'GET_DIFF_SUMMARY_FOR_DRAFT' + '_STARTED':
      return state.setIn(['leftNav', 'diffSummary', 'loading'], true);
    case 'GET_DIFF_SUMMARY_FOR_DRAFT' + '_SUCCESS':
      return state.setIn(['leftNav', 'diffSummary'], (0, _immutable.fromJS)({
        ratesSummary: payload.ratesSummary,
        summaryByPage: payload.rawDiffData
      }));
    case '[contracting-download]ACCEPT_RATES_SUCCESS':
      return state.setIn(['leftNav', 'contractState'], 'accepted').setIn(['leftNav', 'state'], 'accepted');
    case 'GET_DIFF_SUMMARY_FOR_DRAFT' + '_ERROR':
      return state.setIn(['leftNav', 'diffSummary', 'loading'], false);
    case contractingCnts.REFRESH_STARTED:
      return state.set('refreshing', true);
    case contractingCnts.REFRESH_FINISHED:
      return state.set('refreshing', false);
    case contractingCnts.REFRESH_COMPLETION_CHECK + '_SUCCESS':
    case '[template-draft]CHECK_COMPLETENESS_FOR_TEMPLATE_DRAFT':
      return state.set('draftErrors', (0, _immutable.fromJS)(payload.errors));
    case 'ADD_CONTRACT_FILES':
      return state.updateIn(['leftNav', 'files'], function (files) {
        return files.concat((0, _immutable.fromJS)(payload.files));
      }).updateIn(['rightSideContent', 'files'], function (files) {
        return files.concat((0, _immutable.fromJS)(payload.files));
      });
    case 'CONTRACT_FILES_MODIFIED':
      return state.setIn(['leftNav', 'files'], (0, _immutable.fromJS)(payload.files)).setIn(['rightSideContent', 'files'], (0, _immutable.fromJS)(payload.files)).setIn(['leftNav', 'buyerChecked'], payload.files.length ? true : state.getIn(['leftNav', 'buyerChecked']));
    case 'REMOVE_INSURANCE_FILE':
      return state.updateIn(['rightSideContent', 'billingInformation', 'insuranceFiles'], function (insuranceFiles) {
        if (!insuranceFiles) return insuranceFiles;
        return (0, _immutable.fromJS)([]);
      });
    case 'PARTNER_CHECK_AFTER_REVIEW':
      return state.update('leftNav', function (leftNav) {
        return leftNav.merge((0, _immutable.fromJS)(payload));
      });
    case 'DELETE_PRODUCT_FROM_CONTRACT_START':
    case 'DISCARD_EDITED_CONTRACT_DRAFT_STARTING':
    case 'CONTRACT_CONTENT_LOADING':
      return state.set('contentLoading', true);
    case 'CONTRACT_LEFT_NAV_LOADING':
      return state.set('leftNavLoading', true);
    case 'GET_CONTRACT_INFO_ERROR':
      return state.set('errorOccurs', payload.errorOccurs).set('contentLoading', false).set('leftNavLoading', false);
    case 'DISCARD_EDITED_CONTRACT_DRAFT_FAILED':
      return state.set('contentLoading', false);
    case contractingCnts.REFRESH_LEFT_NAV + '_SUCCESS':
      return state.update('leftNav', function (leftNav) {
        return leftNav.merge((0, _immutable.fromJS)(_extends({}, payload, {
          contractId: args[0].docId,
          collection: args[0].collection
        })));
      });
    case 'GET_CONTRACT_LEFT_NAV':
      return state.set('leftNav', (0, _immutable.fromJS)(payload)).set('leftNavLoading', false);
    case '[contract-request]GET_RESPONDED_CONTRACT_LIST_SUCCESS':
      return state.update('leftNav', function (leftNav) {
        return leftNav.merge((0, _immutable.fromJS)({
          respondedContractList: payload.list,
          respondedContracts: payload.list.map(function (o) {
            return o._id;
          }),
          respondedLocIds: payload.list.map(function (o) {
            return o.locationId;
          })
        }));
      });
    case '[draft-template]GET_SENT_PARTNERS_SUCCESS':
      return state.setIn(['leftNav', 'sentPartners'], (0, _immutable.fromJS)(payload.list));
    case contractingCnts.REFRESH_POLICIES_NOTES + '_SUCCESS':
      return state.update('rightSideContent', function (content) {
        return content.merge((0, _immutable.fromJS)(payload));
      });
    case 'GET_CONTRACT_DETAILS':
      return state.set('rightSideContent', (0, _immutable.fromJS)(payload)).set('routeName', 'contractDetails').set('contentLoading', false);
    case 'LOADING_HISTORY_FEEDS':
      return state.set('contentLoading', true);
    case 'GET_HISTORY_FEEDS':
      return state.set('activities', (0, _immutable.fromJS)(payload.response)).set('routeName', 'activities').set('contentLoading', false);
    case contractingCnts.GET_NOTES + '_SUCCESS':
      return state.set('notes', (0, _immutable.fromJS)(payload));
    case contractingCnts.REFRESH_PRODUCT_DETAILS + '_SUCCESS':
      return state.update('rightSideContent', function (content) {
        return content.merge((0, _immutable.fromJS)(payload.product));
      });
    case 'GET_PRODUCT_DETAILS':
      return state.set('rightSideContent', (0, _immutable.fromJS)(payload.product)).set('routeName', 'product').set('contentLoading', false);
    case 'CHANGE_CONTRACT_STATE_STARTING':
      if (payload.state === 'accepted' || payload.state === 'loaded') {
        return state.update('leftNav', function (leftNav) {
          if (!leftNav) return leftNav;
          if ((0, _ramda.contains)(leftNav.get('contractId'), Object.keys(payload.contractIds))) {
            return leftNav.merge((0, _immutable.fromJS)({
              contractState: payload.state,
              state: payload.state,
              buyerChecked: true
            }));
          }
          return leftNav;
        });
      }
      if (payload.state === 'received externally' || payload.state === 'received') {
        return state.setIn(['leftNav', 'buyerChecked'], true).setIn(['leftNav', 'state'], 'pending').setIn(['leftNav', 'contractState'], 'pending');
      }
      if (payload.state === 'sent') {
        return state.setIn(['leftNav', 'buyerChecked'], false).setIn(['leftNav', 'state'], 'pending').setIn(['leftNav', 'contractState'], 'pending');
      }
      return state.setIn(['leftNav', 'contractState'], payload.state).setIn(['leftNav', 'state'], payload.state);
    case 'SUBMIT_CONTRACTING_COMMENT':
      return state.updateIn(['activities', 'messageArray'], function (messages) {
        return messages.unshift(_extends({}, payload, { isLoading: true }));
      });
    case 'SUBMIT_CONTRACTING_COMMENT_SUCCESS':
      return state.updateIn(['activities', 'messageArray'], function (messages) {
        return messages.set(messages.size - 1, _extends({}, payload.comment, { isLoading: false }));
      });
    // .updateIn(
    //   ['historyFeedToShow', 'filesArray'],
    //   filesArray => filesArray ? filesArray.concat(payload.files) : filesArray
    // );
    case 'CHECK_ONE_PRODUCT_IN_ADD_PRODUCT_WIZARD':
      if ((0, _ramda.isEmpty)(state.get('rightSideContent').toJS())) return state;
      return state.setIn(['leftNav', 'allContractingReadyProducts', payload.index, 'checked'], payload.checked);
    // case 'HISTORY_FEEDS_VIEWED':
    //   return state.updateIn(['rightSideContent', 'messageArray'], messageArray => {
    //     if (!messageArray) return messageArray;
    //     return messageArray.map(message => {
    //       if (message.get('_id')) return message.merge(fromJS(payload.updatedHistoryFeedsMap[message.get('_id')]));
    //       return message;
    //     });
    //   });
    case 'UPDATE_BUYER_INFO':
      return state.setIn(['rightSideContent', 'buyerInfo', payload.data.fieldName], payload.data.value);
    /*
    * Becoming draft - remember to update contract list too(dashboard-reducer)
    * */
    case 'PRODUCTS_SORTED_IN_CONTRACT':
      return state.setIn(['leftNav', 'productsArray'], (0, _immutable.fromJS)(payload.products));
    case 'DELETE_PRODUCT_FROM_CONTRACT':
      return state.set('rightSideContent', (0, _immutable.fromJS)({ seasons: [] })).set('contentLoading', false).set('draftErrors', isNilOrEmpty(payload.errors) ? state.get('draftErrors') : (0, _immutable.fromJS)(payload.errors));
    case 'PRODUCTS_SAVED_UPDATE_REDUX':
      return state.set('draftErrors', isNilOrEmpty(payload.errors) ? state.get('draftErrors') : (0, _immutable.fromJS)(payload.errors));
    case 'SAVE_BILLING_INFO_ADD_EDIT':
      var updatedData = _extends({}, payload.data, {
        insuranceFiles: payload.data.insuranceFiles.map(function (file) {
          return { fileName: file.name || file.fileName, downloadUrl: file.downloadUrl };
        })
      });
      return state.setIn(['rightSideContent', 'billingInformation'], (0, _immutable.fromJS)(updatedData)).setIn(['rightSideContent', 'sameAsCorporatePolicyNotes'], (0, _immutable.fromJS)(payload.sameAsCorporatePolicyNotes)).updateIn(['leftNav', 'editHistory'], function (histories) {
        return histories.push((0, _immutable.fromJS)({ detail: 'Edit Billing Info' }));
      }).set('draftErrors', isNilOrEmpty(payload.errors) ? state.get('draftErrors') : (0, _immutable.fromJS)(payload.errors));
    case 'CONTRACT_SUPPLIER_DETAIL_UPDATED':
      return state.update('rightSideContent', function (detail) {
        return detail.merge((0, _immutable.fromJS)(payload.contractDetails));
      }).update('leftNav', function (leftNav) {
        return leftNav.merge((0, _immutable.fromJS)(payload.contractDetails));
      }).updateIn(['leftNav', 'editHistory'], function (histories) {
        return histories ? histories.push((0, _immutable.fromJS)({ detail: _ramda2.default.pathOr('', ['editHistory', 'detail'], payload) })) : histories;
      }).set('draftErrors', isNilOrEmpty(payload.errors) ? state.get('draftErrors') : (0, _immutable.fromJS)(payload.errors));
    case '[contract-product]CREATE_RATE_PACKAGE_SUCCESS':
      return state.set('draftErrors', isNilOrEmpty(payload.errors) ? state.get('draftErrors') : (0, _immutable.fromJS)(payload.errors));
    case 'CONTRACT_PRODUCT_UPDATED':
      return state.update('rightSideContent', function (product) {
        return product.merge((0, _immutable.fromJS)(payload.product));
      }).updateIn(['leftNav', 'editHistory'], function (histories) {
        if (payload.syncSection) {
          return histories.concat(state.getIn(['leftNav', 'productsArray']).map(function (product) {
            return (0, _immutable.fromJS)({
              productId: product.get('productId'),
              ratePackageName: product.get('ratePackageName'),
              detail: payload.editHistory.detail
            });
          }));
        }
        return histories.push((0, _immutable.fromJS)(payload.editHistory));
      }).set('draftErrors', isNilOrEmpty(payload.errors) ? state.get('draftErrors') : (0, _immutable.fromJS)(payload.errors));
    case 'ON_CHECK_SYNC_SECTION_IN_CONTRACT_TEMPLATE_DRAFT':
      return state.updateIn(['leftNav', 'syncedSections'], function (syncedSections) {
        if (!syncedSections) return (0, _immutable.fromJS)([payload.sectionInEdit]);
        if (!payload.checked) return syncedSections.filter(function (section) {
          return section !== payload.sectionInEdit;
        });
        return syncedSections.push(payload.sectionInEdit);
      });
    case 'CLEAR_CONTRACT_ACTIVITY_PRODUCT_REDUCER':
      return initialState;
    case '[contract-template]GET_CHANGE_LOGS_STARTED':
      return state.set('loadingLogs', true);
    case '[contract-template]GET_CHANGE_LOGS_SUCCESS':
      return state.set('loadingLogs', false).set('changeLogs', (0, _immutable.fromJS)(payload));
    case '[contract-template]GET_CHANGE_LOGS_ERROR':
      return state.set('loadingLogs', false);
    case '{dummy-account} DISCARD_DUMMY_TEMPLATE_DRAFT_SUCCESS':
      return state.setIn(['leftNav', 'buyerHasDraftId'], null);
    default:
      return state;
  }
}

exports.default = contractActivitiesProducts;

/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.fromJS)({
  errorString: ''
});
var errorReducer = function errorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'CLEAR_CONTRACTING_ERROR_STRING':
      return state.set('errorString', '');
    case 'SHOW_CONTRACTING_ERROR_STRING':
      return state.set('errorString', payload);
    default:
      return state;
  }
};

exports.default = errorReducer;

/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = massRateChangeReducer;

var _immutable = __webpack_require__(26);

var _massRateChangeHelpers = __webpack_require__(860);

/*
 products: [
 {
   productId,
   productName,
   offers: [],
   extras: [],
   seasonRates: [],
 }
]
 */
var initialState = (0, _immutable.fromJS)({
  locationName: 'Airlie Beach Luxury Island Suites',
  updateType: '', // enum: ['extras', 'offers', 'seasonRates']
  rateType: '', // enum: ['nett', 'commission', 'discount']
  seasonRates: {
    nettMeasure: 'dollar',
    commissionMeasure: 'dollar',
    discountMeasure: 'dollar',
    roundingSetting: {
      cents: 50,
      roundType: 'normal' // enum: ['normal', 'alwaysUp', 'alwaysDown']
    },
    retailDiffForAll: '',
    nettDiffForAll: '',
    discountDiffForAll: '',
    commissionForAll: '',
    notApplyToExtraChildForcommission: false,
    notApplyToExtraChildFornett: false,
    products: [],
    subMenus: []
  },
  offers: {
    nettMeasure: 'dollar',
    commissionMeasure: 'dollar',
    discountMeasure: 'dollar',
    roundingSetting: {
      cents: 50,
      roundType: 'normal' // enum: ['normal', 'alwaysUp', 'alwaysDown']
    },
    retailDiffForAll: '',
    nettDiffForAll: '',
    discountDiffForAll: '',
    commissionForAll: '',
    notApplyToExtraChildForcommission: false,
    notApplyToExtraChildFornett: false,
    products: [],
    subMenus: []
  },
  extras: {
    nettMeasure: 'dollar',
    commissionMeasure: 'dollar',
    discountMeasure: 'dollar',
    roundingSetting: {
      cents: 50,
      roundType: 'normal' // enum: ['normal', 'alwaysUp', 'alwaysDown']
    },
    retailDiffForAll: '',
    nettDiffForAll: '',
    discountDiffForAll: '',
    commissionForAll: '',
    notApplyToExtraChildForcommission: false,
    notApplyToExtraChildFornett: false,
    products: [],
    subMenus: []
  },
  gettingData: true,
  saving: false,
  updated: [], // enum: ['extras', 'offers', 'seasonRates']
  popOverOpen: false,
  popOverAnchorEl: {}
});

function massRateChangeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  var updateType = state.get('updateType');
  var rateType = state.get('rateType');
  var notApplyToExtraChild = state.getIn([updateType, 'notApplyToExtraChildFor' + rateType]);

  switch (type) {
    case 'UPDATE_MASS_RATE_CHANGE_CALCULATION':
      return payload;
    case 'ON_CHANGE_NOT_APPLY_MASS_RATE_CHANGE_TO_EXTRA_CHILD':
      return state.setIn([updateType, 'notApplyToExtraChildFor' + rateType], !notApplyToExtraChild);
    case 'CHANGE_WIDGET_VALUE_FOR_APPLY_ALL':
      return state.setIn([updateType, payload.key], payload.value).updateIn([updateType, 'products'], function (products) {
        return products.map(function (product) {
          return product.set(payload.key.slice(0, -6), payload.value);
        });
      });
    case 'CHANGE_WIDGET_VALUE_FOR_PRODUCT':
      return state.updateIn([updateType, 'products'], function (products) {
        return products.map(function (product, index) {
          if (index !== payload.ratePackageIndex) return product;
          return product.set(payload.key, payload.value);
        });
      });
    case 'CHANGE_MASS_RATE_CHANGE_MEASURE':
      return state.setIn([updateType, rateType + 'Measure'], payload.retailNettMeasure);
    case 'CHANGE_MASS_RATE_CHANGE_RATE_TYPE':
      return state.merge((0, _immutable.fromJS)({
        rateType: payload.rateType,
        updateType: payload.updateType
      }));
    case 'CHANGE_MASS_RATE_CHANGE_UPDATE_TYPE':
      return state.merge((0, _immutable.fromJS)({
        updateType: payload.updateType,
        locationName: payload.locationName,
        rateType: state.getIn([payload.updateType, 'subMenus', 0])
      }));
    case 'GETTING_MASS_RATE_CHANGE_DATA':
      return state.merge({ saving: true, gettingData: true });
    case 'GOT_MASS_RATE_CHANGE_DATA':
      var allRatesTransformed = (0, _massRateChangeHelpers.transformAllKindsOfRates)(payload.allKindsOfRates);
      return state.merge((0, _immutable.fromJS)(allRatesTransformed)).set('locationId', payload.locationId).set('gettingData', false).set('saving', false);
    case 'SAVING_MASS_RATE_CHANGE_DATA':
      return state.set('saving', true);
    case 'SAVED_MASS_RATE_CHANGE_DATA':
      return state.merge((0, _massRateChangeHelpers.transformAllKindsOfRates)(payload.allKindsOfRates)).set('saving', false).update('updated', function (updated) {
        return updated.concat((0, _immutable.fromJS)(payload.allUpdated));
      });
    case 'SHOW_CONTRACTING_ERROR_STRING':
      return state.merge((0, _immutable.fromJS)({ gettingData: false, saving: false }));
    case 'CLOSE_POPOVER_IN_MASS_RATE_CHANGE':
      return state.set('popOverOpen', false);
    case 'OPEN_POPOVER_WHEN_LEAVING_MASS_RATE_CHANGE':
      return state.set('popOverOpen', true).set('popOverAnchorEl', payload.popOverAnchorEl);
    case 'CHANGE_ROUNDING_SETTINGS_IN_MASS_RATE_CHANGE':
      return state.updateIn([state.get('updateType'), 'roundingSetting'], function (settings) {
        return settings ? settings.merge((0, _immutable.fromJS)(payload)) : (0, _immutable.fromJS)(payload);
      });
    default:
      return state;
  }
}

/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = smallTemplateList;

var _immutable = __webpack_require__(26);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _smallTemplateListConstants = __webpack_require__(649);

var constants = _interopRequireWildcard(_smallTemplateListConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = (0, _immutable.fromJS)({
  templates: [],
  loadingTemplates: false,
  templatesForCC: []
});

function smallTemplateList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case constants.GETTING_TEMPLATES:
      return state.set('loadingTemplates', true);
    case constants.POPULATE_REDUCER:
      return (0, _immutable.fromJS)(_extends({}, payload, {
        loadingTemplates: false
      }));
    case constants.CALLING_API:
      return state.update('templates', _ramda2.default.map(function (template) {
        if (template.get('_id') !== payload.templateId) return template;
        return template.set('callingApi', true);
      }));
    case 'SHOW_CONTRACTING_ERROR_STRING':
      return state.update('templates', _ramda2.default.map(function (template) {
        return template.set('callingApi', false);
      })).set('loadingTemplates', false);
    case 'CLOSE_ADD_EDIT_CONTRACT_DIALOG':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = __webpack_require__(26);

var _contractListConstants = __webpack_require__(560);

var constants = _interopRequireWildcard(_contractListConstants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = (0, _immutable.fromJS)({
  selectedContracts: [], // ids
  allContractIds: [], // all ids for the search
  list: {
    listType: 'Recent',
    loading: true,
    dataToShow: [],
    page: 1,
    totalPages: 1,
    loadingText: ''
  },
  searchParams: {
    openAdvanceSearch: false,
    isFolder: false,
    stateFilterForBuyer: [], // ['sent', 'received', 'accepted', 'rejected', 'loaded', 'loading'],
    stateFilterForSupplier: [], // ['request', 'sent', 'accepted', 'rejected', 'loaded', 'loading'],
    contractTypeFilter: [], // ['tc', 'external'], // tc, external
    rateConversionStatusFilter: [],
    sentFilter: [], // ['bounced', 'delivered', 'opened'],
    readUnreadFilter: [], // ['read', 'unread'], // read, unread
    searchInput: '',
    newActivity: false,
    companySearchInput: '',
    locationSearchInput: '',
    searchCategory: 'all contracts',
    searchingAllYears: true,
    sortValue: 'updatedAt', // activity, endDate, updatedAt
    sortRule: -1,
    otherSideRead: [],
    showRateContainers: false,
    showArchivedDeleted: false
  },
  folderLoading: false,
  folders: [],
  selectedFolders: [],
  manageFolderDialogOpen: false,
  startPolling: false,
  bulkResendDialog: {
    partners: [],
    open: false,
    customizedMessage: '',
    subject: ''
  },
  getContractEmailStatus: {}
});

function contractList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _ref.payload,
      extraPayload = _objectWithoutProperties(_ref, ['type', 'payload']);

  switch (type) {
    case '[contract-list]CHANGE_ROUTE':
      return state.setIn(['list', 'listType'], payload.routeName).setIn(['list', 'dataToShow'], (0, _immutable.fromJS)([])).set('pathBeforeSearch', '').set('isFolder', payload.isFolder).set('searchParams', initialState.get('searchParams').set('searchingAllYears', state.getIn(['searchParams', 'searchingAllYears'])).set('isFolder', payload.isFolder).set('searchCategory', payload.routeName));
    case '[contracting]SELECTED_YEAR_FOR_CONTRACTING':
      if (extraPayload.currentRoute && extraPayload.currentRoute.indexOf('contract-list') > -1) return state.setIn(['searchParams', 'searchingAllYears'], false);
      return state;
    case constants.UPDATE_PARAMS:
      return state.update('searchParams', function (searchParams) {
        return searchParams.merge((0, _immutable.fromJS)(payload));
      });
    case constants.RESET_PARAMS:
      return state.set('searchParams', initialState.get('searchParams').set('searchingAllYears', state.getIn(['searchParams', 'searchingAllYears'])));
    case constants.DOWNLOADING_PDF_ZIP:
      return state.set('selectedContracts', (0, _immutable.fromJS)([])).setIn(['list', 'loading'], true).setIn(['list', 'loadingText'], 'Please be patient, as this download may take a few minutes.\n\n\nWhile you wait...\n\n\nFun Fact: QANTAS, the name for Australia\u2019s national airline, was originally an acronym for Queensland and Northern Territories Air Service.  It was founded in Winton, Queensland on 16 November 1920.');
    case constants.PDF_ZIP_DOWNLOADED:
      return state.setIn(['list', 'loading'], false).setIn(['list', 'loadingText'], '');
    case constants.LOADING_LIST:
      return state.setIn(['list', 'loading'], payload).set('startPolling', true);
    case constants.LOAD_CONTRACT_LIST + '_STARTED':
      return state.setIn(['list', 'loading'], true).set('startPolling', true);
    case constants.LOAD_CONTRACT_LIST + '_SUCCESS':
      return state.set('outBoxCount', payload.outBoxCount).set('bouncedCount', payload.bouncedCount).set('rcCount', payload.rcCount).update('list', function (list) {
        var toBeMerged = { loading: false, dataToShow: payload.list, page: payload.page, listType: payload.listType };
        if (payload.totalPages) toBeMerged.totalPages = payload.totalPages;
        return list.merge((0, _immutable.fromJS)(toBeMerged));
      }).set('startPolling', false);
    case constants.GET_MORE_CONTRACT_INFO + '_SUCCESS':
      return state.updateIn(['list', 'dataToShow'], function (contracts) {
        return contracts.map(function (contract) {
          if (contract.get('_id') === extraPayload.args[0].docId) {
            return contract.merge((0, _immutable.fromJS)(payload));
          }
          return contract;
        });
      }).set('startPolling', false);
    case constants.SELECT_CURRENT_ALL:
      return state.set('selectedContracts', state.getIn(['list', 'dataToShow']).filter(function (contract) {
        return _ramda2.default.contains('read', contract.get('access'));
      }).map(function (contract) {
        return contract.get('_id');
      })).set('allContractIds', (0, _immutable.fromJS)(payload.allContractIds));
    case constants.STATE_CHANGE:
      return state.updateIn(['list', 'dataToShow'], function (contracts) {
        return contracts.map(function (contract) {
          var stateKey = contract.get('locationId') ? 'state' : 'rateConversionStatus';
          return _ramda2.default.contains(contract.get('_id'), payload.contractIds) ? contract.set(stateKey, payload.newState) : contract;
        });
      });
    case constants.MARK_AS_RECEIVED:
      return state.updateIn(['list', 'dataToShow'], function (contracts) {
        return contracts.map(function (contract) {
          return _ramda2.default.contains(contract.get('_id'), payload.contractIds) ? contract.set('buyerChecked', true) : contract;
        });
      });
    case constants.UPDATE_FOLDER_NAME + '_SUCCESS':
      return state.merge((0, _immutable.fromJS)({
        folderToBeRenamedIndex: undefined,
        renameFolderError: undefined,
        originalFolder: undefined,
        newFolderName: undefined
      }));
    case constants.UPDATE_FOLDER_NAME:
    case constants.UPDATE_PROPS:
      return state.merge((0, _immutable.fromJS)(payload));
    case constants.SELECT_ONE_CONTRACT:
      return state.set('selectedContracts', removeOrAddId(state.get('selectedContracts'), payload));
    case constants.MASS_ASSIGN_FOLDER:
      return state.set('selectedContracts', (0, _immutable.fromJS)([]));
    case constants.MASS_ARCHIVE_OR_RESTORE:
    case constants.MASS_DELETE_RESTORE:
      return state.set('selectedContracts', (0, _immutable.fromJS)([])).setIn(['list', 'dataToShow'], state.getIn(['list', 'dataToShow']).filter(function (contract) {
        return !_ramda2.default.contains(contract.get('_id'), payload.contractIds);
      }));
    case constants.CREATE_FOLDER:
      return state.update('folders', function (folders) {
        return folders.push(payload);
      }).set('newFolderName', '').set('createNewFolder', false);
    case constants.DELETE_FOLDER:
      return state.update('folders', function (folders) {
        return (0, _immutable.fromJS)(folders.filter(function (folder) {
          return folder !== payload;
        }));
      });
    case constants.TOGGLE_BULK_RESEND_DIALOG:
      if (!payload) return state.set('bulkResendDialog', initialState.get('bulkResendDialog'));
      return state.setIn(['bulkResendDialog', 'open'], payload);
    case constants.POPULATE_BULK_RESEND:
      return state.update('bulkResendDialog', function (dialog) {
        return dialog.merge((0, _immutable.fromJS)(payload));
      });
    case constants.BULK_SENDING:
      return state.setIn(['bulkResendDialog', 'sending'], true);
    case constants.BULK_SEND_FINISHED:
      return state.setIn(['bulkResendDialog', 'sending'], false).setIn(['bulkResendDialog', 'sent'], true).set('selectedContracts', (0, _immutable.fromJS)([]));
    case constants.UPDATE_BULK_RESEND_PROPS:
      return state.update('bulkResendDialog', function (bulkResendDialog) {
        return bulkResendDialog.merge((0, _immutable.fromJS)(payload));
      });
    case constants.GET_CONTRACT_EMAIL:
      return state.setIn(['contractMailboxes', payload, 'loading'], true);
    case constants.GET_CONTRACT_EMAIL + '_SUCCESS':
      return state.setIn(['contractMailboxes', payload.contractId], (0, _immutable.fromJS)({ mailbox: payload.mailbox }));
    case '[contract-request]GET_RESPONDED_CONTRACT_LIST_SUCCESS':
      return state.setIn(['list', 'dataToShow'], (0, _immutable.fromJS)([].concat(_toConsumableArray(payload.list.map(function (o) {
        return _extends({}, o, { access: ['read', 'write'] });
      }))))).setIn(['list', 'loading'], false);
    default:
      return state;
  }
}

var removeOrAddId = function removeOrAddId(originalSelectedContracts, id) {
  var originalSelectedContractsJS = originalSelectedContracts.toJS();
  var indexOfId = _ramda2.default.indexOf(id, originalSelectedContractsJS);
  if (indexOfId > -1) return (0, _immutable.fromJS)(_ramda2.default.remove(indexOfId, 1, originalSelectedContractsJS));
  return (0, _immutable.fromJS)(_ramda2.default.append(id, originalSelectedContractsJS));
};

exports.default = contractList;

/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = __webpack_require__(26);

var _templateListConstants = __webpack_require__(1845);

var constants = _interopRequireWildcard(_templateListConstants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _contractingUtils = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var createDraftInitialData = {
  dialogOpen: false,
  openCreateFirstDraft: false,
  newDraftStartDate: undefined,
  newDraftEndDate: undefined,
  newDraftName: '',
  createDraftError: '',
  creatingDraft: false,
  quickStartSelected: { type: 'custom' }
};
var createTemplateGroupInitialDate = {
  selectedContractPeriod: {},
  newGroupName: '',
  createGroupError: '',
  creatingGroup: false,
  newGroupStartDate: '',
  newGroupEndDate: '',
  loadingForGroupWizard: false,
  groupWizardStep: 0,
  groupWizardTemplates: [],
  selectedTemplatesForGroup: [],
  groupCreated: false
};
var editTemplateGroupInitialDate = {
  editGroupName: '',
  editGroupId: '',
  editGroupStartDate: '',
  editGroupEndDate: '',
  selectedTemplatesForGroup: [],
  editDialogOpen: false,
  editGroupError: '',
  updatingGroup: false,
  groupUpdated: false,
  groupWizardTemplates: []
};
var initialState = (0, _immutable.fromJS)(_extends({
  listRefreshing: false,
  templatesLoaded: false,
  showLoadingOverlay: false,
  searchingAllYears: true,
  templateListPage: 1,
  templateGroups: [],
  templates: [],
  allContractPeriods: [],
  statusesFilter: [],
  drafts: [],
  locations: [],
  createTemplateGroupOpen: false,
  sendTemplateDialogOpen: false,
  templateToBeSent: {},
  templateGroupToBeSent: {}
}, createDraftInitialData, createTemplateGroupInitialDate, editTemplateGroupInitialDate));

var templateList = function templateList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      payload = _ref.payload,
      extraPayload = _objectWithoutProperties(_ref, ['type', 'payload']);

  switch (type) {
    case '[contracting]SELECTED_YEAR_FOR_CONTRACTING':
      if (extraPayload.currentRoute && extraPayload.currentRoute.indexOf('template-list') > -1) return state.set('searchingAllYears', false);
      return state;
    case 'ARCHIVE_UNARCHIVE_TEMPLATE_SUCCESS':
      return state.update('templates', function (templates) {
        return templates.map(function (template) {
          if (template.get('_id') === payload.templateId) return template.set('isArchived', payload.isArchived);
          return template;
        });
      });
    case constants.TEMPLATE_DELETED:
      return state.update('templates', function (templates) {
        return templates.filter(function (template) {
          return template.get('_id') !== payload.templateId;
        });
      });
    case constants.UPDATING_TEMPLATE_NAME:
      return state.update(payload.templateOrDraft + 's', function (docs) {
        return docs.map(function (doc) {
          if (doc.get(payload.templateOrDraft === 'draft' ? 'originalContractId' : '_id') !== payload.templateId) return doc;
          return doc.set('savingName', !doc.get('savingName'));
        });
      });
    case constants.TEMPLATE_NAME_UPDATED:
      return state.update(payload.templateOrDraft + 's', function (docs) {
        return docs.map(function (doc) {
          if (doc.get(payload.templateOrDraft === 'draft' ? 'originalContractId' : '_id') !== payload.templateId) return doc;
          return doc.merge((0, _immutable.fromJS)({ templateName: payload.newName, errorText: '', showEditNameConfirmButton: false, savingName: false, showDeleteConfirmButton: false }));
        });
      });
    case constants.TEMPLATE_NAME_UPDATED_DUPLICATED:
      return state.update(payload.templateOrDraft + 's', function (docs) {
        return docs.map(function (doc) {
          if (doc.get(payload.templateOrDraft === 'draft' ? 'originalContractId' : '_id') !== payload.templateId) return doc;
          return doc.merge((0, _immutable.fromJS)({ errorText: 'Duplicate Name', savingName: false, showDeleteConfirmButton: false }));
        });
      });
    case constants.DRAFT_DELETED:
      return state.update('drafts', function (drafts) {
        return drafts.filter(function (draft) {
          return draft.get('originalContractId') !== payload.draftId;
        });
      });
    case constants.UPDATE_DRAFT_PROPS:
      return state.update('drafts', function (drafts) {
        return drafts.map(function (draft) {
          if (draft.get('originalContractId') === payload.draftId) return draft.merge((0, _immutable.fromJS)(payload.data));
          return draft;
        });
      });
    case constants.UPDATE_TEMPLATE_PROPS:
      return state.update('templates', function (templates) {
        return templates.map(function (template) {
          if (template.get('_id') === payload.templateId) return template.merge((0, _immutable.fromJS)(payload.data));
          return template;
        });
      });
    case constants.UPDATE_FILTERS:
      return state.merge((0, _immutable.fromJS)({
        searchInput: payload.searchInput,
        statusesFilter: payload.statusesFilter || [],
        showType: payload.showType,
        searchingAllYears: _ramda2.default.isNil(payload.searchingAllYears) ? true : payload.searchingAllYears
      }));
    case constants.UPDATE_PROPS:
      return state.merge((0, _immutable.fromJS)(payload));
    case constants.LOADING_DRAFTS:
    case constants.LOADING_TEMPLATES:
      return state.merge((0, _immutable.fromJS)({
        listRefreshing: !state.get('listRefreshing'),
        showLoadingOverlay: state.get('templatesLoaded') ? state.get('showLoadingOverlay') : !state.get('showLoadingOverlay')
      }));
    case constants.GET_SUPPLIER_LOCATIONS_LIST:
      return state.set('locations', _ramda2.default.call(_ramda2.default.compose(function (locs) {
        return (0, _immutable.fromJS)(locs);
      }, _ramda2.default.append({
        name: '',
        products: []
      }), _ramda2.default.sortBy(_ramda2.default.compose(_ramda2.default.toLower, _ramda2.default.prop('name'))), _ramda2.default.map(function (loc) {
        return _ramda2.default.merge(loc, {
          checked: payload.locationId ? loc.locationId === payload.locationId : _ramda2.default.contains('write', loc.access),
          products: loc.products.map(_ramda2.default.assoc('checked', payload.locationId ? loc.locationId === payload.locationId : _ramda2.default.contains('write', loc.access)))
        });
      })), payload.locations));
    case constants.UPDATE_LOC_PROPS:
      return state.update('locations', function (locations) {
        return locations.map(function (loc) {
          if (loc.get('locationId') === payload.locationId) return loc.merge((0, _immutable.fromJS)(payload.value));
          return loc;
        });
      });
    case '{template-list} REFRESH_TEMPLATE_LIST_SUCCESS':
    case constants.TEMPLATES_LOADED:
      return state.merge((0, _immutable.fromJS)({
        templates: payload.templates.map(function (obj) {
          return _ramda2.default.merge(obj, { shownStatus: (0, _contractingUtils.getTemplateStatus)(obj) });
        }),
        drafts: payload.drafts.map(function (obj) {
          return _ramda2.default.merge(obj, { shownStatus: (0, _contractingUtils.getTemplateStatus)(obj) });
        }),
        templateGroups: payload.templateGroups,
        listRefreshing: false,
        showLoadingOverlay: false,
        templatesLoaded: true
      }));
    case constants.POPULATE_CONTRACTS_COUNT:
      return state.update('templates', function (templates) {
        return templates.map(function (template) {
          if (template.get('_id') === payload.templateId) return template.merge(payload);
          return template;
        });
      });
    case constants.STARTING_DRAFT_CREATE:
      return state.set('creatingDraft', !state.get('creatingDraft'));
    case constants.DRAFT_CREATED:
      return state.merge((0, _immutable.fromJS)(createDraftInitialData));
    case constants.GOT_ALL_CONTRACT_PERIODS:
      return state.set('allContractPeriods', (0, _immutable.fromJS)(payload.contractPeriods));
    case constants.TEMPLATES_LOADED_FOR_WIZARD:
      return state.set('groupWizardTemplates', (0, _immutable.fromJS)(payload.templates)).set('loadingForGroupWizard', false);
    case constants.LOADING_TEMPLATES_FOR_WIZARD:
      return state.set('loadingForGroupWizard', !state.get('loadingForGroupWizard'));
    case constants.STARTING_TEMPLATE_GROUP_CREATION:
      return state.set('creatingGroup', !state.get('creatingGroup'));
    case constants.TEMPLATE_GROUP_CREATED:
      return state.set('creatingGroup', false).set('groupCreated', true);
    case constants.TEMPLATE_GROUP_UPDATED:
      return state.merge((0, _immutable.fromJS)(editTemplateGroupInitialDate));
    case constants.DOWNLOADING_PDF_ZIP:
      return state.set('showLoadingOverlay', true).set('overlayText', 'Please be patient, as this download may take a few minutes.\n\n\nWhile you wait...\n\n\nFun Fact: Tourism accounts for five percent of the world\u2019s economy.');
    case constants.PDF_ZIP_DOWNLOADED:
      return state.set('showLoadingOverlay', false).set('overlayText', '');
    case 'TEMPLATE_GROUP_CREATION_UNMOUNT':
      return state.merge((0, _immutable.fromJS)(createTemplateGroupInitialDate));
    default:
      return state;
  }
};

exports.default = templateList;

/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.supplierUpdatesQueue = supplierUpdatesQueue;

var _constants = __webpack_require__(252);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
  sendingUpdates: false,
  updateProcessInitiated: false,
  error: null
};
function supplierUpdatesQueue() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case cnt.SEND_UPDATES_FROM_QUEUE + '_STARTED':
      return _extends({}, state, {
        sendingUpdates: true
      });
    case cnt.SEND_UPDATES_FROM_QUEUE + '_SUCCESS':
      return _extends({}, state, {
        sendingUpdates: false,
        updateProcessInitiated: true
      });
    case cnt.SEND_UPDATES_FROM_QUEUE + '_ERROR':
      return _extends({}, state, {
        sendingUpdates: false,
        updateProcessInitiated: false,
        error: 'Uh Oh! There is an error preventing us from issuing your updates. Please send us a message through live chat, we will take care of this.'
      });
    case cnt.CLEAR_QUEUE_STATE:
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.masterTemplateList = masterTemplateList;
exports.createNew = createNew;

var _constants = __webpack_require__(630);

var cnts = _interopRequireWildcard(_constants);

var _constants2 = __webpack_require__(579);

var cnt = _interopRequireWildcard(_constants2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
  loadingList: true,
  list: []
};

var updateTemplateProps = function updateTemplateProps(state, id, payload) {
  return _extends({}, state, {
    list: state.list.map(function (obj) {
      if (obj._id === id) {
        return _extends({}, obj, payload);
      }
      return obj;
    })
  });
};

function masterTemplateList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload,
      args = _ref.args,
      error = _ref.error;

  switch (type) {
    case cnts.GET_LIST + '_SUCCESS':
      return _extends({}, state, {
        list: payload,
        loadingList: false
      });
    case cnts.GET_ASSOCIATED_TEMPLATES + '_SUCCESS':
      return _extends({}, state, {
        list: state.list.map(function (obj) {
          if (obj._id === args[0].id) {
            return _extends({}, obj, { templates: payload });
          }
          return obj;
        })
      });
    case cnts.UPDATE_TEMPLATE_PROPS:
      return updateTemplateProps(state, payload.id, payload);
    case cnts.RENAME_TEMPLATE + '_STARTED':
    case cnts.DELETE_TEMPLATE + '_STARTED':
      return updateTemplateProps(state, args[0].id, { callingApi: true });
    case cnts.RENAME_TEMPLATE + '_SUCCESS':
      return updateTemplateProps(state, args[0].id, {
        callingApi: false,
        showDeleteConfirmButton: false,
        errorText: '',
        showEditNameConfirmButton: false,
        newTemplateName: '',
        templateName: args[0].newName
      });
    case cnts.DELETE_TEMPLATE + '_SUCCESS':
      return _extends({}, state, {
        list: state.list.filter(function (obj) {
          return obj._id !== args[0].id;
        })
      });
    case cnts.RENAME_TEMPLATE + '_ERROR':
      return updateTemplateProps(state, args[0].id, {
        errorText: error && error.duplicateExists ? 'There is already a template named "' + args[0].newName + '".' : 'Oops, something went wrong, please try again.'
      });
    default:
      return state;
  }
}

function createNew() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { templateName: '' };
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload,
      args = _ref2.args,
      error = _ref2.error;

  switch (type) {
    case cnts.INIT:
      return _extends({}, state, payload);
    case cnts.TYPE_NAME:
      return _extends({}, state, {
        templateName: payload
      });
    case cnts.CREATE + '_STARTED':
      return _extends({}, state, {
        creating: true
      });
    case cnts.CREATE + '_SUCCESS':
      return _extends({}, state, {
        creating: false
      });
    case cnts.CREATE + '_ERROR':
      return _extends({}, state, {
        creating: false,
        error: error
      });
    default:
      return state;
  }
}

/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editDialog = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.masterTemplate = masterTemplate;
exports.applyMasterToTemplatesReducer = applyMasterToTemplatesReducer;
exports.finaliseDialog = finaliseDialog;

var _constants = __webpack_require__(579);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialEditDialogState = {
  open: false,
  data: {}
};

var editDialog = exports.editDialog = function editDialog() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialEditDialogState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload,
      args = _ref.args;

  switch (type) {
    case cnt.INITIATE_EDIT_WITH_TYPE:
      return _extends({}, state, {
        type: payload.type,
        policiesNotesPage: payload.policiesNotesPage,
        policyType: payload.policyType,
        data: _extends({}, state.data, {
          title: payload.title
        }, payload.data)
      });
    case cnt.POPULATE_EDIT_DIALOG_DATA:
      return _extends({}, state, {
        open: true,
        data: _extends({}, state.data, payload)
      });
    case cnt.SAVE_EDITS + '_S3UPLOAD_STARTED':
    case cnt.SAVE_EDITS + '_STARTED':
      return _extends({}, state, {
        saving: true
      });
    case cnt.TEXT_FIELD_CHANGE:
      if (payload.forTermsAndNotes) {
        return _extends({}, state, {
          data: _extends({}, state.data, {
            value: payload.value
          })
        });
      }
      return _extends({}, state, {
        data: _extends({}, state.data, _defineProperty({}, payload.key, payload.value))
      });
    case cnt.ATTACH_INS_FILE:
      return _extends({}, state, {
        data: _extends({}, state.data, {
          insuranceFiles: payload
        })
      });
    case cnt.REMOVE_INSURANCE_FILE:
      return _extends({}, state, {
        data: _extends({}, state.data, {
          insuranceFiles: []
        })
      });
    case cnt.SAVE_EDITS + '_SUCCESS':
    case cnt.CANCEL_EDIT:
      return initialEditDialogState;
    default:
      return state;
  }
};

var initialSecondaryTemplateState = {
  // <id>: {}
  showAssociatedTemplates: false,
  currentId: ''
};

function masterTemplate() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialSecondaryTemplateState;
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload,
      args = _ref2.args;

  switch (type) {
    case cnt.GET_DOC + '_STARTED':
      return _extends({}, state, _defineProperty({
        currentId: args[0]
      }, args[0], _extends({}, state[args[0]], {
        loading: true
      })));
    case cnt.GET_DOC + '_SUCCESS':
      return _extends({}, state, _defineProperty({}, state.currentId, _extends({}, state[state.currentId], {
        loading: false
      }, payload.data)));
    case cnt.GET_DIFF_SUMMARY + '_SUCCESS':
      return _extends({}, state, _defineProperty({}, state.currentId, _extends({}, state[state.currentId], payload)));
    case cnt.DISCARD_DRAFT + '_SUCCESS':
      return _extends({}, state, _defineProperty({}, args[0], {}));
    case cnt.GET_ASSOCIATED_TEMPLATES + '_SUCCESS':
      return _extends({}, state, _defineProperty({}, state.currentId, _extends({}, state[state.currentId], {
        templates: payload
      })));
    case cnt.TOGGLE_ASSOCIATED_TEMPLATES:
      return _extends({}, state, {
        showAssociatedTemplates: !state.showAssociatedTemplates
      });
    case cnt.apply.CLICK_OK_SUCCESS:
      return _extends({}, state, {
        showAssociatedTemplates: true
      });
    default:
      return state;
  }
}

var initialAssoicateState = {
  type: 'policyNotes',
  knownMasterId: '',
  knownTemplateDraftId: '',
  allTemplatesDrafts: [],
  masterList: [],
  callingApi: false,
  successDialogOpen: false,
  sameAsCorporatePolicyNotes: [],
  honorPreloadContent: false
};
function applyMasterToTemplatesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialAssoicateState;
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload,
      args = _ref3.args;

  switch (type) {
    case cnt.apply.INIT:
      return _extends({}, state, {
        knownMasterId: payload.knownMasterId,
        knownTemplateDraftId: payload.knownTemplateDraftId,
        type: payload.type
      });
    case cnt.apply.SELECT_UNSELECT_TEMPLATE:
      return _extends({}, state, {
        allTemplatesDrafts: state.allTemplatesDrafts.map(function (obj) {
          if (obj._id === payload.id) return _extends({}, obj, { checked: !obj.checked });
          return obj;
        })
      });
    case cnt.apply.CHECK_SAME_AS:
      return _extends({}, state, {
        sameAsCorporatePolicyNotes: payload
      });
    case cnt.apply.CHECK_HONOR_PRELOAD:
      return _extends({}, state, {
        honorPreloadContent: payload
      });
    case cnt.apply.CLICK_OK_SUCCESS:
      return _extends({}, state, {
        successDialogOpen: false
      });
    case cnt.apply.SELECT_MASTER:
      if (state.type === 'policyNotes') {
        return _extends({}, state, {
          masterList: state.masterList.map(function (obj) {
            if (obj._id === payload.id) return _extends({}, obj, { checked: !obj.checked });
            return obj;
          })
        });
      }
      // TODO: handle other master policy type
      return state;
    case cnt.apply.GET_TEMPLATES + '_SUCCESS':
      return _extends({}, state, {
        callingApi: false,
        allTemplatesDrafts: [].concat(_toConsumableArray(payload.drafts), _toConsumableArray(payload.templates.filter(function (obj) {
          return obj.templateHasDraft;
        }).map(function (obj) {
          return _extends({}, obj, { originalContractId: obj._id, state: 'draft' });
        })))
      });
    case cnt.apply.APPLY_TO_TEMPLATES + '_SUCCESS':
      return _extends({}, state, {
        callingApi: false,
        successDialogOpen: true
      });
    case cnt.apply.GET_MASTERS + '_SUCCESS':
      return _extends({}, state, {
        callingApi: false,
        masterList: payload.filter(function (obj) {
          return obj.status === 'completed';
        })
      });
    case cnt.apply.GET_TEMPLATES + '_STARTED':
    case cnt.apply.APPLY_TO_TEMPLATES + '_STARTED':
    case cnt.apply.GET_MASTERS + '_STARTED':
      return _extends({}, state, {
        callingApi: true
      });
    case cnt.apply.GET_TEMPLATES + '_ERROR':
    case cnt.apply.APPLY_TO_TEMPLATES + '_ERROR':
    case cnt.apply.GET_MASTERS + '_ERROR':
      return _extends({}, state, {
        callingApi: false
      });
    case cnt.apply.CLEAR_STORE:
      return initialAssoicateState;
    default:
      return state;
  }
}

var finaliseDialogState = {
  open: false,
  buyerId: false,
  loadingBuyers: false,
  buyers: []
};
function finaliseDialog() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : finaliseDialogState;
  var _ref4 = arguments[1];
  var type = _ref4.type,
      payload = _ref4.payload,
      args = _ref4.args;

  switch (type) {
    case cnt.OPEN_FINALISE_DIALOG:
      return _extends({}, state, {
        open: true
      });
    case cnt.CLOSE_FINALISE_DIALOG:
      return finaliseDialogState;
    case cnt.SEND_UPDATES + '_STARTED':
    case cnt.FINALISE + '_STARTED':
      return _extends({}, state, {
        callingApi: true
      });
    case cnt.SEND_UPDATES + '_ERROR':
    case cnt.FINALISE + '_ERROR':
      return _extends({}, state, {
        callingApi: false
      });
    case cnt.FINALISE + '_SUCCESS':
      return _extends({}, state, {
        callingApi: false,
        finaliseSuccess: true
      });
    case cnt.SEND_UPDATES + '_SUCCESS':
      return _extends({}, state, {
        callingApi: false,
        sendUpdatesSuccess: true
      });
    case cnt.GET_AFFECTED_BUYERS + '_STARTED':
      return _extends({}, state, {
        loadingBuyers: true
      });
    case cnt.GET_AFFECTED_BUYERS + '_SUCCESS':
      return _extends({}, state, {
        buyers: payload,
        loadingBuyers: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = partnerReducer;

var _immutable = __webpack_require__(26);

var _constants = __webpack_require__(1846);

var constants = _interopRequireWildcard(_constants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({
  contractingPartners: [], // this is contracting partners
  newPartnersSelected: [],
  partnersToSendTo: [],
  loadingExisting: false,
  existingConnections: [],
  filteredConnections: [],
  selectedExistingPartners: [], // this is NOT contracting partners, just partners from connections
  gettingRequests: false,
  sendToPartners: true,
  addPartnersMethod: '',
  showAddIndividuallyDialog: false,
  showSelectFromPartnersDialog: false,
  showUploadFileDialog: false,
  showEmailImportDialog: false,
  individualCompanyName: '',
  individualEmail: '',
  searchField: '',
  finishing: false,
  processingPartners: false
});

function partnerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'UPDATE_CONTRACTING_SEND_TO_PARNTNERS_WITH_KEYPATH':
      return state.setIn(payload.keyPath, payload.immutableValue);
    case constants.LOADING_EXISTING_CONNECTIONS:
      return state.set('loadingExisting', true);
    case constants.GOT_CONTRACTING_PARTNERS:
      return state.set('contractingPartners', payload ? (0, _immutable.fromJS)(payload) : undefined);
    case constants.GOT_EXISTING_CONNECTIONS:
      return state.set('existingConnections', (0, _immutable.fromJS)(payload)).set('loadingExisting', false);
    case constants.PROCESSING_PARTNERS:
      return state.set('processingPartners', !state.get('processingPartners'));
    case constants.UPDATE_PROPS:
    case constants.PARTNERS_PROCESSED:
      var newPartnersSelected = _ramda2.default.differenceWith(_ramda2.default.ifElse(_ramda2.default.prop('companyId'), _ramda2.default.eqProps('companyId'), _ramda2.default.eqProps('email')), payload.partnersToSendTo || state.get('partnersToSendTo').toJS(), state.get('contractingPartners').toJS());
      return state.merge((0, _immutable.fromJS)(payload)).set('newPartnersSelected', (0, _immutable.fromJS)(newPartnersSelected));
    case constants.CHECK_CONNECTION:
      if ((0, _ramda.equals)(payload.checkType, 'checkOne')) return state.update('selectedExistingPartners', function (selected) {
        return selected.push((0, _immutable.fromJS)(payload.partner));
      });
      return state.set('selectedExistingPartners', (0, _ramda.equals)(state.get('filteredConnections').size, 0) ? state.get('existingConnections') : state.get('filteredConnections'));
    case constants.UNCHECK_CONNECTION:
      if ((0, _ramda.equals)(payload.checkType, 'uncheckOne')) return state.update('selectedExistingPartners', function (selected) {
        return selected.filterNot((0, _ramda.equals)((0, _immutable.fromJS)(payload.partner)));
      });
      return state.set('selectedExistingPartners', (0, _immutable.fromJS)([]));
    case constants.GOT_REQUESTS:
      return state.update('partnersToSendTo', function (list) {
        return list.concat((0, _immutable.fromJS)(_ramda2.default.uniqBy(_ramda2.default.prop('buyerId'), payload).map(function (request) {
          return {
            profileImageUrl: request.buyerProfileImageUrl,
            companyName: request.buyerCompanyName,
            company_name: request.buyerCompanyName,
            companyId: request.buyerId,
            _type: 'Contractor',
            email: 'via TourConnect',
            connectionStatus: 'pending',
            contracts: []
          };
        })));
      }).set('requestsLoaded', true).set('gettingRequests', false);
    case 'CLEAR_STORE_SUPPLIER_SEND_TEMPLATE_WIZARD':
    case 'CLEAR_CONTRACTOR_CONTRACTING_WIZARD':
    case constants.CLEAR_STORE:
      return state.merge((0, _immutable.fromJS)({
        selectedExistingPartners: [],
        partnersToSendTo: []
      }));
    default:
      return state;
  }
}

/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.contractingDashboard = contractingDashboard;

var _constants = __webpack_require__(652);

var constants = _interopRequireWildcard(_constants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  globalFilters: {},
  items: []
};
function contractingDashboard() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      user = _ref.user,
      payload = _ref.payload,
      _ref$args = _ref.args,
      args = _ref$args === undefined ? [{}] : _ref$args;

  switch (type) {
    case constants.INIT_DASHBOARD:
      return payload.initialState;
    case constants.LOAD_FOLDERS + '_SUCCESS':
      return _extends({}, state, {
        globalFilters: _extends({}, state.globalFilters, {
          folder: _extends({}, state.globalFilters.folder, {
            list: payload.folders.map(function (str) {
              return { title: str, value: str };
            })
          })
        })
      });
    case constants.UPDATE_GLOBAL_FILTER:
      return _extends({}, state, {
        globalFilters: _extends({}, state.globalFilters, _defineProperty({}, payload.filterItem, _extends({}, state.globalFilters[payload.filterItem], {
          selectedValue: state.globalFilters[payload.filterItem].type === 'checkbox' ? !(payload.value === 'true') : payload.value
        })))
      });
    case constants.UPDATE_GLOBAL_LIST_FILTER:
      var updatedList = state.globalFilters[payload.filterKey].list.map(function (obj, i) {
        if (i === payload.listIndex) return _ramda2.default.assoc('checked', payload.checked, obj);
        return obj;
      });
      return _extends({}, state, {
        globalFilters: _extends({}, state.globalFilters, _defineProperty({}, payload.filterKey, _extends({}, state.globalFilters[payload.filterKey], {
          list: updatedList,
          selectedValue: updatedList.some(function (obj) {
            return obj.checked;
          })
        })))
      });
    case constants.CLEAR_GLOBAL_LIST_FILTER:
      return _extends({}, state, {
        globalFilters: _extends({}, state.globalFilters, _defineProperty({}, payload.filterKey, _extends({}, state.globalFilters[payload.filterKey], {
          selectedValue: null,
          list: state.globalFilters[payload.filterKey].list.map(function (obj, i) {
            return _ramda2.default.assoc('checked', false, obj);
          })
        })))
      });
    case constants.UPDATE_WIDGET_DATA + '_STARTED':
      return _extends({}, state, {
        items: state.items.map(function (item) {
          if (item.id === args[0].widgetId) {
            return _extends({}, item, {
              error: false,
              isLoading: true
            });
          }
          return item;
        })
      });
    case constants.UPDATE_WIDGET_DATA + '_ERROR':
      return _extends({}, state, {
        items: state.items.map(function (item) {
          if (item.id === args[0].widgetId) {
            return _extends({}, item, {
              error: true,
              isLoading: false,
              lastSync: null
            });
          }
          return item;
        })
      });
    case constants.RESET_GLOBAL_DASHBOARD_FILTER:
      return _extends({}, state, {
        globalFilters: Object.entries(state.globalFilters).map(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              key = _ref3[0],
              value = _ref3[1];

          return _defineProperty({}, key, _extends({}, value, value.type === 'list' ? {
            list: value.list.map(function (obj) {
              return _ramda2.default.assoc('checked', false, obj);
            }),
            selectedValue: null
          } : { selectedValue: null }));
        }).reduce(function (obj, item) {
          return _extends({}, _extends({}, item), obj);
        })
      });
    case constants.UPDATE_WIDGET_DATA + '_SUCCESS':
      return _extends({}, state, {
        items: state.items.map(function (item) {
          if (item.id === args[0].widgetId) {
            if (item.chart === 'Callout') {
              return _extends({}, item, {
                isLoading: false,
                error: false,
                data: payload.data.filter(function (d) {
                  return d.label === item.name;
                }).reduce(function (a, b) {
                  return b.value;
                }, 0)
              });
            }
            return _extends({}, item, payload, {
              isLoading: false,
              error: false,
              lastSync: Math.round(new Date().getTime() / 1000)
            });
          }
          return item;
        })
      });
    case constants.UPDATE_WIDGET_FILTER:
      return _extends({}, state, {
        items: state.items.map(function (item) {
          if (item.id === payload.id) {
            var filterBy = payload.filterBy;
            var filtersCopy = _extends({}, item.filters);
            filtersCopy[filterBy] = _extends({}, filtersCopy[filterBy], payload.filterObjSelected);
            return _extends({}, item, {
              filters: filtersCopy
            });
          }
          return item;
        })
      });
    default:
      return state;
  }
}

/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.contractingReports = contractingReports;

var _immutable = __webpack_require__(26);

var _constants = __webpack_require__(1847);

var constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({
  // loaders:
  generatingReport: false,
  submittingSuggestion: false,

  selectedReport: 'progress',
  alloReport: 'detailed',
  blackoutReport: 'newContracts',
  startDate: '2019-04-01 00:00:00.000Z',
  endDate: '2020-03-31 00:00:00.000Z',
  suggestion: '',
  showSuggestionConfirmation: false,
  diff: {
    locationId: null,
    availDocs: [],
    rawDiffData: [],
    diffMetaData: {},
    ratesSummary: {}
  }
});

function contractingReports() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case constants.UPDATE_CREPORTS_PROP:
      return state.merge((0, _immutable.fromJS)(payload));
    case constants.SENDING_REPORT_SUGG:
      return state.set('submittingSuggestion', true);
    case constants.SENT_REPORT_SUGG:
      return state.set('submittingSuggestion', false).set('showSuggestionConfirmation', true);
    case constants.GET_CONTRACTING_DIFF_REPORT + '_STARTED':
      return state.set('generatingReport', true);
    case constants.GET_CONTRACTING_DIFF_REPORT + '_SUCCESS':
      return state.set('generatingReport', false).update('diff', function (diff) {
        return _extends({}, diff, payload);
      });
    case constants.GET_CONTRACTING_DIFF_REPORT + '_ERROR':
      return state.set('generatingReport', false);
    case 'GET_AVAIL_DOCS_FOR_DIFF_REPORTS':
      return state.update('diff', function (diff) {
        return _extends({
          loadingDocs: true
        }, diff, {
          locationId: payload.locationId
        });
      });
    case 'GET_AVAIL_DOCS_FOR_DIFF_REPORTS_SUCCESS':
      return state.update('diff', function (diff) {
        return _extends({}, diff, {
          loadingDocs: false,
          availDocs: payload.contracts || payload.templates
        });
      });
    case constants.CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(131);

var _msgsReducer = __webpack_require__(2697);

var _msgsReducer2 = _interopRequireDefault(_msgsReducer);

var _convsReducer = __webpack_require__(2698);

var _convsReducer2 = _interopRequireDefault(_convsReducer);

var _actionDialogReducer = __webpack_require__(2699);

var _actionDialogReducer2 = _interopRequireDefault(_actionDialogReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({ messages: _msgsReducer2.default, conversations: _convsReducer2.default, actionDialog: _actionDialogReducer2.default });

/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(26);

var _messagingConstants = __webpack_require__(506);

var constants = _interopRequireWildcard(_messagingConstants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialMsgsState = (0, _immutable.fromJS)({
  list: [],
  loadingMessages: false
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialMsgsState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'UPDATE_PROPS_IN_MESSAGING_MESSAGES':
      return state.merge((0, _immutable.fromJS)(payload));
    case constants.LOADING_MSGS:
      return state.set('loadingMessages', payload).set('messagesLoaded', !payload);
    case constants.MSGS_LOADED_INITIALLY:
      return state.merge((0, _immutable.fromJS)({
        conv: payload.conv,
        list: payload.messages,
        lastMsgId: payload.lastMsgId,
        messagesLoaded: true,
        loadingMessages: false
      }));
    default:
      return state;
  }
};

/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(26);

var _messagingConstants = __webpack_require__(506);

var constants = _interopRequireWildcard(_messagingConstants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialConvListState = (0, _immutable.fromJS)({
  convList: [],
  selectedConv: {},
  hoveredConv: {},
  loadingConvList: false
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialConvListState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'UPDATE_PROPS_IN_MESSAGING_CONVS':
      return state.merge((0, _immutable.fromJS)(payload));
    case constants.LOADING_LIST:
      return state.set('loadingConvList', !state.get('loadingConvList'));
    case constants.LIST_LOADED:
      return state.merge((0, _immutable.fromJS)({
        loadingConvList: false,
        convList: payload
      }));
    case constants.MSGS_LOADED_INITIALLY:
      return state.set('selectedConv', (0, _immutable.fromJS)(payload.conv[0])).update('convList', function (convList) {
        return convList.map(function (conv) {
          if (conv.get('messageId') === payload.conv.messageId) return conv.set('hasSeen', true);
          return conv;
        });
      });
    case 'GET_HISTORY_FEEDS':
      var convList = state.get('convList').toJS();
      if (convList && convList.length) {
        var selectedConv = _ramda2.default.find(_ramda2.default.eqProps('contractId', payload), convList);
        if (selectedConv) {
          return state.set('selectedConv', (0, _immutable.fromJS)(selectedConv)).update('convList', function (list) {
            return list.map(function (conv) {
              if (conv.get('contractId') === payload.contractId) return conv.set('hasSeen', true);
              return conv;
            });
          });
        }
      }
      return state;
    case constants.TOGGLE_CONV_DONESS:
      return state.update('convList', function (list) {
        return list.filter(function (conv) {
          return conv.get('messageId') !== payload.messageId;
        });
      });
    default:
      return state;
  }
};

/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(26);

var _messagingConstants = __webpack_require__(506);

var constants = _interopRequireWildcard(_messagingConstants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialDialogState = (0, _immutable.fromJS)({
  open: false,
  files: [],
  msg: {},
  companyNameValue: '',
  newPartner: {},
  selectedPartner: {},
  startDateValue: '',
  endDateValue: '',
  creatingContract: false,
  createdContract: {},
  updatedContract: {},
  matchedRequestsByEmails: [],
  matchedRequestsByInput: [],
  allEmailsFromBody: [],
  searchingRequests: false,
  showRequests: false,
  partners: []
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialDialogState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'UPDATE_PROPS_IN_MESSAGING_ACTION_DIALOG':
      if (_ramda2.default.has('open', payload) && !payload.open) {
        return state.merge((0, _immutable.fromJS)({
          open: false,
          files: [],
          msg: {},
          companyNameValue: '',
          creatingContract: false,
          createdContract: {},
          updatedContract: {},
          matchedRequestsByEmails: [],
          showRequests: false
        }));
      }
      return state.merge((0, _immutable.fromJS)(payload));
    case 'GOT_MATCHED_REQUESTS_FOR_ADD_FILE_TO_CONTRACT':
      return state.merge((0, _immutable.fromJS)({
        matchedRequestsByEmails: payload.searchByInput ? state.get('matchedRequestsByEmails') : payload.requests,
        matchedRequestsByInput: payload.searchByInput ? payload.requests : state.get('matchedRequestsByInput'),
        searchingRequests: false,
        showRequests: Boolean(payload && payload.length)
      }));
    case 'GOT_LATEST_CONTRACTING_YEAR':
      return state.set('startDateValue', payload.startDate).set('endDateValue', payload.endDate);
    case constants.CREATING_CONTRACT:
      return state.set('creatingContract', true);
    case constants.CREATE_CONTRACT_FAILED:
      return state.set('creatingContract', false);
    case constants.CONTRACT_CREATED:
      return state.set('createdContract', (0, _immutable.fromJS)(payload));
    case constants.GET_PARTNERS + '_SUCCESS':
      return state.set('partners', (0, _immutable.fromJS)(payload.partners));
    default:
      return state;
  }
};

/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;

var _immutable = __webpack_require__(26);

var _constants = __webpack_require__(1848);

var constants = _interopRequireWildcard(_constants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({
  newsfeed: {
    list: [],
    unreadCount: null,
    unseenCount: null
  },
  messaging: {
    count: 0
  }
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case constants.GOT_NOTIFICATIONS:
    case constants.UPDATE_PROPS:
      return state.merge((0, _immutable.fromJS)(payload));
    case constants.MARKED_READ:
      return state.updateIn(['newsfeed', 'list'], function (list) {
        return list.filter(function (obj) {
          return !_ramda2.default.contains(obj.get('id'), payload.activityIds);
        });
      });
    case 'DECREMENT_UNREAD_MESSAGES_COUNT':
      return state.setIn(['messaging', 'count'], Math.max(state.getIn(['messaging', 'count']) - 1, 0));
    default:
      return state;
  }
}

/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.partnerFinder = partnerFinder;

var _immutable = __webpack_require__(26);

var _partnerFinderConstants = __webpack_require__(653);

var constants = _interopRequireWildcard(_partnerFinderConstants);

var _ramda = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({
  results: undefined,
  searchParams: {},
  page: 1,
  nextPage: undefined,
  status: undefined,
  total: 0,
  prevPayload: {},
  threeConnectedCustomers: [],
  connectionsWithMM: [], // user clicked on MM [{ companyId, media: [urls] }]
  sendCustomMsg: {
    open: false,
    popOverAnchorEl: undefined,
    customizedMessage: '',
    receiverInfo: {}
  },
  responseTime: []
});

function partnerFinder() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var connectionId = (0, _ramda.propOr)('', 'connectionId', action);
  switch (action.type) {
    case constants.OPEN_PF_CUSTOM_MSG_POPOVER:
      return state.setIn(['sendCustomMsg', 'open'], true).update('sendCustomMsg', function (sendCustomMsg) {
        return sendCustomMsg.merge((0, _ramda.propOr)({}, 'payload', action));
      });
    case constants.CLOSE_PF_CUSTOM_MSG_POPOVER:
      return state.update('sendCustomMsg', function (sendCustomMsg) {
        return sendCustomMsg.merge({
          open: false,
          popOverAnchorEl: undefined,
          customizedMessage: ''
        });
      });
    case constants.UPDATE_CUSTOM_MSG:
      return state.setIn(['sendCustomMsg', 'customizedMessage'], (0, _ramda.pathOr)('', ['payload', 'customizedMessage'], action));
    case 'MODIFY_PARAMS':
      return state.set('searchParams', (0, _immutable.fromJS)(action.params));
    case 'SEARCH_STARTING':
      return state.set('status', 'isSyncing').set('threeConnectedCustomers', '');
    case constants.SEARCH_COUNT_ONLY:
      return state.set('total', action.payload.total);
    case 'SEARCH':
      if (Array.isArray(action.payload) || typeof action.payload === 'string') {
        return state.set('results', action.payload).set('total', Array.isArray(action.payload) ? action.payload.length : action.payload).set('status', 'success');
      }
      if (_typeof(action.payload) === 'object') {
        return state.merge((0, _immutable.fromJS)(action.payload)).set('status', 'success').set('threeConnectedCustomers', (0, _immutable.fromJS)(action.payload.threeConnectedCustomers)).set('fromPFPayload', state.get('prevPayload')) // for returning to PF search results from profile
        .set('prevPFSearch', state.get('searchParams')) // for returning to PF search results from profile
        .set('prevPayload', (0, _immutable.fromJS)(action.payload));
      }
      break;
    case 'SEARCH_FAILED':
      return state.set('results', []).set('status', 'failed');
    case 'LOAD_MORE':
      if (state.get('page') === state.get('nextPage')) return state;
      if (state.getIn(['prevPayload', 'prevPage']) === action.payload.prevPage && state.getIn(['prevPayload', 'nextPage']) === action.payload.nextPage) return state;
      return state.mergeWith(function (prev, next, key) {
        if (key === 'results') return prev.concat(next);
        return next;
      }, (0, _immutable.fromJS)(action.payload)).set('status', 'success').set('page', state.get('nextPage')).set('prevPayload', (0, _immutable.fromJS)(action.payload));
    case 'SEND_INVITATION_PF':
      if (!state.get('results')) return state;
      var compId = (0, _ramda.propOr)('', 'companyId', action);
      return state.update('results', function (companies) {
        return companies.map(function (company) {
          var currentCompanyId = (0, _immutable.fromJS)(company).get('companyId') || (0, _immutable.fromJS)(company).get('supplierId');
          if ((0, _ramda.equals)(compId, currentCompanyId)) {
            return (0, _immutable.fromJS)(company).merge({
              status: 'pending',
              lastSent: 'a few seconds ago',
              isSender: true,
              loader: false
            });
          }
          return company;
        });
      });
    case 'RESEND_INVITATION_PF':
    case 'FAKE_RESEND':
      if (!state.get('results')) return state;
      return state.update('results', function (companies) {
        return companies.map(function (company) {
          var currentConnectionId = (0, _immutable.fromJS)(company).get('connectionId');
          if ((0, _ramda.equals)(connectionId, currentConnectionId)) {
            return (0, _immutable.fromJS)(company).merge({
              lastSent: 'a few seconds ago',
              loader: false
            });
          }
          return company;
        });
      });
    case 'IGNORE_CONNECTION_PF':
      if (!state.get('results')) return state;
      return state.update('results', function (companies) {
        return companies.map(function (company) {
          var currentConnectionId = (0, _immutable.fromJS)(company).get('connectionId');
          if ((0, _ramda.equals)(connectionId, currentConnectionId)) {
            return (0, _immutable.fromJS)(company).merge({
              status: 'rejected',
              isSender: false,
              loader: false
            });
          }
          return company;
        });
      });
    case 'ACCEPT_CONNECTION_PF':
      if (!state.get('results')) return state;
      return state.update('results', function (companies) {
        return companies.map(function (company) {
          var currentConnectionId = (0, _immutable.fromJS)(company).get('connectionId');
          if ((0, _ramda.equals)(connectionId, currentConnectionId)) {
            return (0, _immutable.fromJS)(company).merge({
              status: 'accepted',
              isSender: false,
              loader: false
            });
          }
          return company;
        });
      });
    case 'FLIP_LOADER_STATUS':
      if (!state.get('results')) return state;
      var connId = (0, _ramda.path)(['payload', 'connectionId'], action);
      var companyId = (0, _ramda.path)(['payload', 'companyId'], action);
      return state.update('results', function (companies) {
        return companies.map(function (company) {
          var currentConnectionId = (0, _immutable.fromJS)(company).get('connectionId');
          var currentCompanyId = (0, _immutable.fromJS)(company).get('companyId') || (0, _immutable.fromJS)(company).get('supplierId');
          if (connId && (0, _ramda.equals)(connId, currentConnectionId) || companyId && (0, _ramda.equals)(company, currentCompanyId)) return (0, _immutable.fromJS)(company).set('loader', !(0, _immutable.fromJS)(company).get('loader'));
          return company;
        });
      });
    case 'GOT_RESPONSE_TIME':
      return state.update('responseTime', function (responseTime) {
        return responseTime.push({
          companyId: action.payload.companyId,
          daysToRespond: action.payload.response
        });
      });
    // ADDS MM ON AN ONCLICK FUNC
    // case constants.GOT_MARKETING_MATERIALS:
    //   const connectionsWithMMJS = state.get('connectionsWithMM').toJS();
    //   const isIdInConnectionsWithMM = contains(action.payload.companyId, connectionsWithMMJS.map(item => item.companyId));
    //   if (isIdInConnectionsWithMM) {
    //     return state.update('connectionsWithMM', connectionsWithMM => connectionsWithMM.filter(item => item.companyId !== action.payload.companyId));
    //   }
    //   const filterForImages = action.payload.locationId ?
    //     (action.payload.media || []).filter(file => contains(action.payload.locationId, file.tags) && (file.mediaType === 'image/jpeg' || file.mediaType === 'image/png'))
    //     : (action.payload.media || []).filter(file => file.mediaType === 'image/jpeg' || file.mediaType === 'image/png');
    //   const MMObj = {
    //     companyId: action.payload.companyId,
    //     media: pluck('url')(filterForImages),
    //   };
    //   return state.update('connectionsWithMM', connectionsWithMM => connectionsWithMM.push(
    //     action.payload.locationId ? merge(MMObj, { locationId: action.payload.locationId }) : MMObj));
    case 'CLEAR_STORES':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.editFieldModal = editFieldModal;

var _immutable = __webpack_require__(26);

var _profileEditModalConstants = __webpack_require__(1849);

var constants = _interopRequireWildcard(_profileEditModalConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({
  title: '',
  needsToConfirmAddress: false,
  hasFormattedAddress: false,
  addressToConfirm: {},
  field: '',
  value: '',
  type: '',
  specifiedRoute: '',
  hasTriedToLocate: false,
  isValidAddress: false,
  dialogOpen: false,
  settings: {}
});

function editFieldModal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'EDIT_FIELD_FOR_MODAL':
      return state.merge(action.payload);
    case constants.START_INLINE_EDIT:
      return state.merge(action.payload);
    case constants.START_EDIT:
      return state.merge(_extends({ dialogOpen: true }, action.payload));
    case 'EDIT_PROFILE_FIELD_STARTING':
    case 'EDIT_USER_LOCATION_PROFILE_FIELD_STARTING':
    case 'EDIT_USER_PRODUCT_PROFILE_FIELD_STARTING':
    case 'CLEAR_EDIT_MODAL_STATE':
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyPaste = copyPaste;

var _immutable = __webpack_require__(26);

var initialState = (0, _immutable.fromJS)({});

function copyPaste() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'COPY_GENERIC_ITEM':
      return state.merge((0, _immutable.fromJS)(payload));
    default:
      return state;
  }
}

/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(131);

var _mainReducer = __webpack_require__(2705);

var _mainReducer2 = _interopRequireDefault(_mainReducer);

var _selectPartnerReducer = __webpack_require__(2706);

var _selectPartnerReducer2 = _interopRequireDefault(_selectPartnerReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import signUpReducer from './reducers/signUp-reducer';

exports.default = (0, _redux.combineReducers)({
  mainReducer: _mainReducer2.default,
  partnerReducer: _selectPartnerReducer2.default
  // signUpReducer,
});

/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = marketingMaterials;

var _immutable = __webpack_require__(26);

var _constants = __webpack_require__(1444);

var constants = _interopRequireWildcard(_constants);

var _ramda = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({
  loadingMM: false,
  savingMedia: false,
  uploadMediaDialog: false,
  documentType: '',
  media: [],
  selectedFiles: [],
  previewDialog: false,
  hovering: false,
  filterByMediaType: 'All File Types',
  filteredMedia: [],
  uploadingFile: false,
  selectedFileIndex: 0,
  managingTags: false,
  tagsStep: 1,
  tags: [],
  searchField: ''
});

function marketingMaterials() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case constants.GETTING_MARKETING_MATERIALS:
      return state.set('loadingMM', true);
    case constants.GOT_MARKETING_MATERIALS:
      return state.set('loadingMM', false).set('locations', (0, _immutable.fromJS)(payload.locations)).set('locationTags', (0, _immutable.fromJS)((0, _ramda.propOr)([], 'locations', payload).map(function (loc) {
        return { id: (0, _ramda.prop)('id', loc), name: (0, _ramda.prop)('name', loc) };
      }))).set('productTags', (0, _immutable.fromJS)((0, _ramda.flatten)((0, _ramda.propOr)([], 'locations', payload).map(function (loc) {
        return (0, _ramda.propOr)([], 'products', loc);
      })))).set('media', (0, _immutable.fromJS)(payload.media));
    case constants.UPDATE_MM_PROP:
      return state.merge((0, _immutable.fromJS)(payload));
    default:
      return state;
  }
}

/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = partnerReducer;

var _immutable = __webpack_require__(26);

var _constants = __webpack_require__(1444);

var constants = _interopRequireWildcard(_constants);

var _ramda = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({
  partnersToSendTo: [],
  existingConnections: [],
  filteredConnections: [],
  selectedExistingPartners: [], // holding for existing partners
  sendToPartners: false,
  addPartnersMethod: '',
  showSelectMethod: false,
  showReview: false,
  showAddIndividuallyDialog: false,
  showSelectFromPartnersDialog: false,
  showUploadFileDialog: false,
  showEmailImportDialog: false,
  individualCompanyName: '',
  individualEmail: '',
  searchField: '',
  sendingMM: false
});

function partnerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case constants.GOT_PARTNERS:
      return state.set('existingConnections', (0, _immutable.fromJS)(payload));
    case constants.UPDATE_MM_PARTNER_PROP:
      return state.merge((0, _immutable.fromJS)(payload));
    case constants.CHECK_CONNECTION:
      if ((0, _ramda.equals)(payload.checkType, 'checkOne')) return state.update('selectedExistingPartners', function (selected) {
        return selected.push((0, _immutable.fromJS)(payload.partner));
      });
      return state.set('selectedExistingPartners', (0, _ramda.equals)(state.get('filteredConnections').size, 0) ? state.get('existingConnections') : state.get('filteredConnections'));
    case constants.UNCHECK_CONNECTION:
      if ((0, _ramda.equals)(payload.checkType, 'uncheckOne')) return state.update('selectedExistingPartners', function (selected) {
        return selected.filterNot((0, _ramda.equals)((0, _immutable.fromJS)(payload.partner)));
      });
      return state.set('selectedExistingPartners', (0, _immutable.fromJS)([]));
    case constants.SENDING_MARKETING_MATERIALS:
      return state.set('sendingMM', true);
    case constants.SENT_MARKETING_MATERIALS:
      return state.set('sendingMM', false);
    default:
      return state;
  }
}

/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = newsfeed;

var _immutable = __webpack_require__(26);

var _constants = __webpack_require__(1214);

var constants = _interopRequireWildcard(_constants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialNewPost = {
  selectedLocations: [],
  corporateLocSelected: false,
  postMessage: '',
  selectedFiles: [],
  selectedMainCategory: 'Updates',
  selectedSubCategory: '',
  subCategoryHash: '',
  selectedHashtags: [],
  showNewPostDialog: false,
  savingPost: false,
  uploadingFile: false
};

var initialState = (0, _immutable.fromJS)(_extends({
  MMFiles: [], // existing MM filtered for no powerpoints
  ownerMetaData: {
    // gotMetaData
    // followersCount
    // followsCount
    // postsCount
  },
  newsfeed: [],
  selectedLeftNav: 'News Feed',
  showNewPostDialog: false,
  hasMore: true,
  lastPostId: '',
  filter: {},
  filterType: '',
  // loaders
  savingPost: false,
  loadingNF: false,
  loadingHashtags: false,
  loadingMMFiles: false,
  deletingPost: false,
  reportingPost: false,
  updatingComment: false,
  updatingPost: false,

  hashtags: [],
  postComment: {
    comment: '',
    postId: '',
    lastCommentId: '',
    hasMoreComments: true,
    loading: false
  }
}, initialNewPost, {

  // image preview
  viewingFile: {},
  viewingFiles: []
}));

function newsfeed() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case constants.UPDATE_NEWSFEED_PROP:
      return state.merge((0, _immutable.fromJS)(payload));
    case constants.GET_NEWSFEED_STARTED:
      return state.set('loadingNF', true);
    case constants.GOT_INITIAL_LOAD_NEWSFEED:
      return state.set('newsfeed', (0, _immutable.fromJS)(payload.list)).set('loadingNF', false).set('lastPostId', payload.lastPostId).set('hasMore', !_ramda2.default.isEmpty(payload.list));
    case constants.LOADED_MORE_NEWSFEED:
      return state.update('newsfeed', function (list) {
        var listToJS = list.toJS();
        return (0, _immutable.fromJS)(_ramda2.default.call(_ramda2.default.compose(_ramda2.default.reverse, _ramda2.default.sortBy(_ramda2.default.prop('timestamp')), _ramda2.default.uniqBy(_ramda2.default.prop('postId')), _ramda2.default.concat(listToJS), _ramda2.default.reject(_ramda2.default.propEq('postId', listToJS))), payload.list));
      }).set('loadingNF', false).set('lastPostId', payload.lastPostId).set('hasMore', !_ramda2.default.isEmpty(payload.list));
    case constants.GET_NEWSFEED_FAILED:
      return state.set('loadingNF', false);
    case constants.GET_SINGLE_POST_STARTING:
      return state.update('newsfeed', function (list) {
        if (!list) return list;
        return list.map(function (post) {
          if (post.get('postId') === payload.postId) return post.set('loading', true);
          return post;
        });
      });
    case constants.GOT_SINGLE_POST:
      return state.update('newsfeed', function (list) {
        if (!list) return list;
        return list.map(function (post) {
          if (post.get('postId') === payload.postId) return post.set('body', (0, _immutable.fromJS)(payload.body)).set('loaded', true).set('loading', false);
          return post;
        });
      });
    case constants.GET_SINGLE_POST_FAILED:
      return state.update('newsfeed', function (list) {
        if (!list) return list;
        return list.filter(function (post) {
          return post.get('postId') !== payload.postId;
        });
      });
    case constants.GET_HASHTAGS_STARTED:
      return state.set('loadingHashtags', true);
    case constants.GOT_HASHTAGS:
      return state.set('loadingHashtags', false).set('hashtags', (0, _immutable.fromJS)(payload));
    case constants.GET_HASHTAGS_FAILED:
      return state.set('loadingHashtags', false);
    case constants.SUBMIT_POST_FAILED:
      return state.set('savingPost', false);
    case constants.SUBMIT_POST:
      return state.set('savingPost', true);
    case constants.POST_SUBMITTED:
      if (payload.isSingleLoc) {
        return state.update('newsfeed', function (list) {
          return list.unshift((0, _immutable.fromJS)({ postId: payload.postId, loaded: false, timestamp: new Date() }));
        }).merge(_ramda2.default.omit(['selectedLocations', 'corporateLocSelected'], initialNewPost));
      }
      return state.update('newsfeed', function (list) {
        return list.unshift((0, _immutable.fromJS)({ postId: payload.postId, loaded: false, timestamp: new Date() }));
      }).merge(initialNewPost);
    // load MM for newsfeed
    case 'GETTING_MARKETING_MATERIALS':
      return state.set('loadingMMFiles', true);
    case 'GOT_MARKETING_MATERIALS':
      return state.set('MMFiles', (0, _immutable.fromJS)(_ramda2.default.propOr([], 'media', payload).filter(function (file) {
        return file.mediaType !== 'application/vnd.ms-powerpoint' && file.mediaType !== 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
      }))).set('loadingMMFiles', false);
    // when a user adds / updates MM, get update for newsfeed
    case 'UPDATE_MM_PROP':
      if (!payload.savingMedia && _ramda2.default.contains('media', _ramda2.default.keys(payload))) {
        return state.set('MMFiles', (0, _immutable.fromJS)(_ramda2.default.propOr([], 'media', payload).filter(function (file) {
          return file.mediaType !== 'application/vnd.ms-powerpoint' && file.mediaType !== 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
        })));
      }
      return state;
    case constants.DELETE_POST_STARTED:
      return state.set('deletingPost', true);
    case constants.DELETED_POST:
      return state.set('deletingPost', false).set('newsfeed', (0, _immutable.fromJS)(payload));
    case constants.REPORT_POST_STARTED:
      return state.set('reportingPost', true);
    case constants.REPORTED_POST:
      return state.set('reportingPost', false).update('newsfeed', function (list) {
        if (!list) return list;
        return list.map(function (post) {
          if (post.get('postId') === payload.postId) return post.update('body', function (body) {
            return body.merge((0, _immutable.fromJS)({ reported: true }));
          });
          return post;
        });
      });
    case constants.REPORT_POST_FAILED:
      return state.set('reportingPost', false);
    case constants.START_UPDATING_A_POST:
      if (payload.updateType === 'like' || payload.updateType === 'unlike') {
        return state.update('newsfeed', function (list) {
          if (!list) return list;
          return list.map(function (post) {
            if (post.get('postId') === payload.postId) return post.update('body', function (body) {
              return body.merge((0, _immutable.fromJS)(payload.updater));
            });
            return post;
          });
        });
      }
      if (payload.updateType === 'comment') {
        return state.update('newsfeed', function (list) {
          if (!list) return list;
          return list.map(function (post) {
            if (post.get('postId') === payload.postId) {
              return post.updateIn(['body', 'comments'], function (comments) {
                return comments.push((0, _immutable.fromJS)(_ramda2.default.merge(payload.updater.comment, { temporaryUuid: payload.temporaryUuid })));
              }).setIn(['body', 'numOfComments'], _ramda2.default.inc(post.getIn(['body', 'numOfComments'])));
            }
            return post;
          });
        });
      }
      if (payload.updateType === 'deleteComment') {
        return state.update('newsfeed', function (list) {
          if (!list) return list;
          return list.map(function (post) {
            if (post.get('postId') === payload.postId) {
              return post.updateIn(['body', 'comments'], function (comments) {
                return comments.filter(function (comment) {
                  return comment.get('_id') !== _ramda2.default.path(['updater', 'commentId'], payload);
                });
              }).setIn(['body', 'numOfComments'], _ramda2.default.dec(post.getIn(['body', 'numOfComments'])));
            }
            return post;
          });
        });
      }
      return state;
    case constants.UPDATED_POST:
      if (payload.updateType === 'comment') {
        return state.update('newsfeed', function (list) {
          if (!list) return list;
          return list.map(function (post) {
            if (post.get('postId') === payload.postId) {
              return post.updateIn(['body', 'comments'], function (comments) {
                return comments.map(function (comment) {
                  if (comment.get('temporaryUuid') === payload.temporaryUuid) return comment.set('_id', payload.response._id);
                  return comment;
                });
              });
            }
            return post;
          });
        });
      }
      return state;
    case constants.REPORT_COMMENT_STARTED || constants.DELETE_COMMENT_STARTED:
      return state.set('updatingComment', true);
    case constants.REPORTED_COMMENT:
      return state.set('updatingComment', false).update('newsfeed', function (list) {
        if (!list) return list;
        return list.map(function (post) {
          if (post.get('postId') === payload.postId) {
            return post.updateIn(['body', 'comments'], function (comment) {
              if (comment.get('_id') === payload.commentId) return comment.merge((0, _immutable.fromJS)({ reported: true }));
              return comment;
            });
          }
          return post;
        });
      });
    case constants.REPORT_COMMENT_FAILED || constants.DELETE_COMMENT_FAILED:
      return state.set('updatingComment', false);
    case constants.LOAD_MORE_COMMENTS_STARTED:
      return state.setIn(['postComment', 'loading'], true);
    case constants.LOAD_MORE_COMMENTS_FAILED:
      return state.setIn(['postComment', 'loading'], false);
    case constants.LOADED_MORE_COMMENTS:
      if (_ramda2.default.pathOr(0, ['comments', 'length'], payload) < payload.numOfComments) {
        return state.setIn(['postComment', 'loading'], false).setIn(['postComment', 'hasMoreComments'], false).update('newsfeed', function (list) {
          if (!list) return list;
          return list.map(function (post) {
            if (post.get('postId') === payload.postId) {
              return post.updateIn(['body', 'comments'], function (comments) {
                return (0, _immutable.fromJS)(comments.toJS().concat(payload.comments));
              });
            }
            return post;
          });
        });
      }
      return state.setIn(['postComment', 'loading'], false).update('newsfeed', function (list) {
        if (!list) return list;
        return list.map(function (post) {
          if (post.get('postId') === payload.postId) {
            return post.updateIn(['body', 'comments'], function (comments) {
              return (0, _immutable.fromJS)(comments.toJS().concat(payload.comments));
            });
          }
          return post;
        });
      });
    default:
      return state;
  }
}

/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = metaDataReducer;

var _immutable = __webpack_require__(26);

var _metaDataConstants = __webpack_require__(1215);

var constants = _interopRequireWildcard(_metaDataConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({
  gotMetaDataCount: false,
  followersCount: 0,
  followsCount: 0,
  postsCount: 0,
  likesCount: 0,
  followers: [],
  follows: [],
  posts: [],
  loading: false
});

function metaDataReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case constants.GOT_META_DATA_COUNT:
    case constants.UPDATE_PROPS:
      return state.merge((0, _immutable.fromJS)(payload));
    default:
      return state;
  }
}

/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalErrors = globalErrors;

var _immutable = __webpack_require__(26);

var _globalErrorsDisplayConstants = __webpack_require__(861);

var constants = _interopRequireWildcard(_globalErrorsDisplayConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.fromJS)({
  errorType: '',
  errorMessage: '',
  noAccessDialog: false,
  routeBackOnDismiss: false,
  requestingAccessToFeature: '', // CAPITALIZE FIRST LETTER OF EACH WORD
  requestAccessData: {},
  requestAccessError: '',
  requestingAccess: false
});

function globalErrors() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload,
      errorType = _ref.errorType;

  switch (type) {
    case constants.ERROR_TRIGGERED:
      return state.set('errorType', errorType).merge((0, _immutable.fromJS)(payload));
    case 'SUBMIT_NEWSFEED_POST_FAILED':
      return state.set('errorMessage', 'Submit Post Failed');
    case 'GET_NEWSFEED_FAILED':
      return state.set('errorMessage', 'Get Feeds Failed');
    case 'DELETE_POST_FAILED':
      return state.set('errorMessage', 'Deleting Post Failed');
    case 'GET_POST_FAILED':
      return state.set('errorMessage', 'Unable To Locate Post');
    case 'GET_NEWSFEED_POSTS_FOR_OWNER_FAILED':
      return state.set('errorMessage', 'Unable to Get Posts');
    case 'UPDATE_POST_FAILED':
      return state.set('errorMessage', 'Unable To Update Post');
    case constants.REQUEST_ACCESS_STARTED:
      return state.set('requestingAccess', true);
    case constants.REQUESTED_ACCESS:
      return state.set('requestingAccess', false);
    case constants.REQUEST_ACCESS_FAILED:
      return state.set('requestingAccess', false).set('requestAccessError', payload);
    case constants.CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.workspace = workspace;

var _constants = __webpack_require__(233);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
  channels: [],
  channelsFetching: false,
  channelsTitle: '',
  connections: [],
  connectionsFetching: false,
  conversations: [],
  partnerLocked: false,
  conversationsContractId: null,
  conversationsFetching: false,
  conversationsParticipantName: null,
  conversationsTitle: null,
  latestMessages: [],
  messageCreateError: false,
  messageCreating: false,
  pendingConnections: [],
  selectedChannel: null,
  selectedConnection: null,
  selectedContract: null,
  statusMessagesLoading: false,
  unreadAccepted: []
};

function workspace() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case cnt.CONNECTIONS_FETCH + '_STARTED':
      {
        return _extends({}, state, { connectionsFetching: true });
      }
    case '' + cnt.CHANGE_SELECTION:
      {
        payload.before = {
          connection: state.selectedConnection,
          channel: state.selectedChannel
        };
        // update the lastChannel and lastContract in the store
        var newStore = {};
        if (payload.connection && payload.channel) {
          var selectedConnectionIx = state.connections.map(function (e) {
            return e.id;
          }).indexOf(payload.connection);
          var selectedChannelIx = state.channels.map(function (e) {
            return e.channelId;
          }).indexOf(payload.channel);
          if (selectedConnectionIx > -1 && // connection exists
          selectedChannelIx > -1) {
            // channel exists
            newStore.connections = state.connections;
            newStore.connections[selectedConnectionIx].lastChannel = payload.channel;
          }
        }
        return _extends({}, state, { selectedConnection: payload.connection, selectedChannel: payload.channel }, newStore);
      }
    case cnt.CONNECTIONS_FETCH + '_SUCCESS':
      {
        return _extends({}, state, { connectionsFetching: false, connections: payload.connections });
      }
    case cnt.CONNECTIONS_FETCH + '_ERROR':
      {
        return _extends({}, state, { connectionsFetching: false });
      }
    case cnt.CHANNELS_SELECT_SAVE + '_SUCCESS':
      {
        // we saved a Channel+Contract selection, the reponse should include
        // channel information that could not be included in the channel list
        var _newStore = {};
        if (payload.channel && payload.channel.channelId) {
          if (state.channels.filter(function (e) {
            return e.channelId === payload.channel.channelId;
          }).length === 0) {
            // channel+contractId combo are not on the current channel list store
            _newStore.channels = state.channels.concat([payload.channel]);
          }
          // update the connections with the lastChannel to the saved
          var connectionIx = state.connections.map(function (e) {
            return e.id;
          }).indexOf(state.selectedConnection);
          if (connectionIx > 0) {
            _newStore.connections = state.connections;
            _newStore.connections[connectionIx].lastChannel = payload.channel.channelId;
          }
        }
        return _extends({}, state, _newStore);
      }
    case cnt.CONNECTIONS_ARCHIVE:
      {
        return _extends({}, state, { connections: state.connections.map(function (e) {
            if (e.id === payload) e.disabled = true;
            return e;
          }) });
      }
    case cnt.CHANNELS_FETCH + '_STARTED':
      {
        return _extends({}, state, { channelsFetching: true });
      }
    case cnt.CHANNELS_FETCH + '_SUCCESS':
      {
        var _newStore2 = { channelsFetching: false,
          channels: payload.channels,
          channelsTitle: payload.title || ''
        };
        if (payload.newConnection && state.connections.map(function (e) {
          return e.id;
        }).indexOf(payload.newConnection.id) < 0) {
          // to prevent a race condition where both connections return a new
          // connection on the list and the channe list includes it in the return
          _newStore2.connections = state.connections.concat([payload.newConnection]);
        }
        return _extends({}, state, _newStore2);
      }
    case cnt.CHANNELS_FETCH + '_ERROR':
      {
        return _extends({}, state, { channelsFetching: false });
      }
    case cnt.CHANNELS_SELECT:
      {
        var selectedConnectionIndex = state.connections.map(function (e) {
          return e.id;
        }).indexOf(state.selectedConnection);
        var connections = payload && selectedConnectionIndex > -1 ? state.connections.map(function (e, ix) {
          if (ix === selectedConnectionIndex) e.lastChannel = payload;
          return e;
        }) : state.connections;
        return _extends({}, state, { selectedChannel: payload, connections: connections });
      }
    case cnt.CHANNELS_RESET:
      {
        return _extends({}, state, { channels: [], channelsTitle: '' });
      }
    case cnt.CONVERSATIONS_FETCH + '_STARTED':
      {
        return _extends({}, state, { conversationsFetching: true });
      }
    case cnt.CONVERSATIONS_FETCH + '_SUCCESS':
      {
        return _extends({}, state, {
          conversationsFetching: false,
          partnerLocked: payload.partnerLocked,
          conversations: payload.conversations,
          conversationsTitle: payload.title,
          conversationsParticipantName: payload.recipientName,
          conversationsContractId: payload.contractId
        });
      }
    case cnt.CONVERSATIONS_FETCH + '_ERROR':
      {
        return _extends({}, state, { conversationsFetching: false });
      }
    case cnt.CONVERSATIONS_RESET:
      {
        return _extends({}, state, { conversations: [], conversationsTitle: null });
      }
    case cnt.CHANNELS_ARCHIVE:
      {
        return _extends({}, state, { channels: state.channels.map(function (e) {
            if (e.channelId === payload.channel && e.contractId === payload.contract) e.disabled = true;
            return e;
          }) });
      }
    case cnt.MESSAGE_DISABLE:
      {
        var newConvs = state.conversations.map(function (e) {
          if (e.key === payload) e.disabled = true;
          return e;
        });
        return _extends({}, state, { conversations: newConvs });
      }
    case cnt.MESSAGE_CREATE + '_STARTED':
      {
        return _extends({}, state, { messageCreating: true, messageCreateError: false });
      }
    case cnt.MESSAGE_CREATE + '_SUCCESS':
      {
        return _extends({}, state, { messageCreating: false });
      }
    case cnt.MESSAGE_CREATE + '_ERROR':
      {
        return _extends({}, state, { messageCreating: false, messageCreateError: true });
      }
    case cnt.STATUS_MESSAGES + '_STARTED':
      {
        return _extends({}, state, { statusMessagesLoading: true });
      }
    case cnt.STATUS_MESSAGES + '_ERROR':
      {
        return _extends({}, state, { statusMessagesLoading: false });
      }
    case cnt.STATUS_MESSAGES + '_SUCCESS':
      {
        return _extends({}, state, {
          statusMessagesLoading: false,
          latestMessages: payload.latestMessages,
          pendingConnections: payload.pendingConnections,
          unreadAccepted: payload.unreadAccepted
        });
      }
    case cnt.CONTRACT_SELECT:
      {
        var _selectedConnectionIndex = state.connections.map(function (e) {
          return e.id;
        }).indexOf(state.selectedConnection);
        var _connections = _selectedConnectionIndex > -1 ? state.connections.map(function (e, ix) {
          if (ix === _selectedConnectionIndex) e.lastContract = payload;
          return e;
        }) : state.connections;
        return _extends({}, state, { selectedContract: payload || null, connections: _connections });
      }
    case cnt.STATUS_MESSAGES_REMOVE_CONNECTION:
      {
        return _extends({}, state, {
          pendingConnections: state.pendingConnections.filter(function (_ref2) {
            var id = _ref2._id;
            return id !== payload;
          })
        });
      }
    case cnt.STATUS_CONNECTIONS_MARK_READ:
      {
        return _extends({}, state, {
          unreadAccepted: state.unreadAccepted.filter(function (_ref3) {
            var connectionId = _ref3.connectionId;
            return payload.indexOf(connectionId) === -1;
          })
        });
      }
    default:
      return state;
  }
}

/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.massmessaging = massmessaging;

var _constants = __webpack_require__(654);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
  dialogOpen: false,
  messageCreating: false,
  messageCreateError: false,
  lastCreatedMessage: null,
  singleRecipient: null,
  connections: []
};

function massmessaging() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case cnt.OPENMODAL:
      {
        return _extends({}, state, { dialogOpen: true });
      }
    case cnt.CLOSEMODAL:
      {
        return _extends({}, initialState);
      }
    case cnt.SENDMESSAGE + '_STARTED':
      {
        return _extends({}, state, { messageCreating: true, messageCreateError: false, lastCreatedMessage: null, singleRecipient: null });
      }
    case cnt.SENDMESSAGE + '_SUCCESS':
      {
        var lastCreatedMessage = payload.bulkMessageId,
            singleRecipient = payload.singleRecipient;

        return _extends({}, state, { messageCreating: false, messageCreateError: false, lastCreatedMessage: lastCreatedMessage, singleRecipient: singleRecipient });
      }
    case cnt.SENDMESSAGE + '_ERROR':
      {
        return _extends({}, state, { messageCreating: false, messageCreateError: true });
      }
    case cnt.GETPARTNERS + '_SUCCESS':
      {
        return _extends({}, state, { connections: payload });
      }
    default:
      return state;
  }
}

/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = assetsConsolidation;

var _immutable = __webpack_require__(26);

var _constants = __webpack_require__(655);

var constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
  processingToken: true,
  gettingAssets: true
};

function assetsConsolidation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  // if (type.indexOf('[asset-consolidation]') > -1)  console.log(type, payload);
  switch (type) {
    case constants.UPDATE_PROPS:
      return _extends({}, state, payload);
    case constants.PROCESS_HASHTOKEN + '_SUCCESS':
      return _extends({}, state, {
        processingToken: false
      }, payload.assetsLanding);
    case constants.GET_ASSETS + '_SUCCESS':
      return _extends({}, state, {
        gettingAssets: false
      }, payload);
    case constants.CONSOLIDATE_ASSETS + '_SUCCESS':
      return _extends({}, state, {
        consolidationSuccess: true
      });
    case constants.CONSOLIDATE_ASSETS + '_ERROR':
      return _extends({}, state, {
        consolidationSuccess: false,
        errorText: 'Oops, something went wrong, please contact us!'
      });
    case constants.CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
}

/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(656);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
  activities: [],
  activitiesLoading: false,
  activitiesLoaded: false,
  contacts: [],
  contactsLoading: false,
  contactsLoaded: false,
  files: [],
  filesLoading: false,
  filesLoaded: false,
  partnerInfo: {},
  partnerInfoLoading: false,
  partnerInfoLoaded: false,
  newActivitySending: false,
  newActivitySendingError: false,
  resourceType: null
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case cnt.SEND_RATES + '_STARTED':
    case cnt.SEND_RATE_REQUESTS + '_STARTED':
    case cnt.SEND_MESSAGE + '_STARTED':
      return _extends({}, state, { newActivitySending: true });
    case cnt.SEND_RATES + '_ERROR':
    case cnt.SEND_RATE_REQUESTS + '_ERROR':
    case cnt.SEND_MESSAGE + '_ERROR':
      return _extends({}, state, { newActivitySendingError: true, newActivitySending: false });
    case cnt.SEND_RATES + '_SUCCESS':
    case cnt.SEND_RATE_REQUESTS + '_SUCCESS':
    case cnt.SEND_MESSAGE + '_SUCCESS':
      return _extends({}, state, { newActivitySendingError: false, newActivitySending: false });
    case cnt.GET_PARTNER_INFO + '_STARTED':
      return _extends({}, state, { partnerInfoLoading: true, contactsLoading: true });
    case cnt.GET_PARTNER_INFO + '_ERROR':
      return _extends({}, state, { partnerInfoLoading: false, contactsLoading: false, error: payload });
    case cnt.GET_PARTNER_INFO + '_SUCCESS':
      var companyName = payload.companyName,
          companyId = payload.companyId,
          profileImageUrl = payload.profileImageUrl,
          contacts = payload.contacts;

      return _extends({}, state, {
        contactsLoading: false,
        contactsLoaded: true,
        partnerInfoLoading: false,
        partnerInfoLoaded: true,
        partnerInfo: {
          companyName: companyName,
          companyId: companyId,
          profileImageUrl: profileImageUrl
        },
        contacts: contacts,
        error: ''
      });
    case cnt.GET_FILES + '_STARTED':
      return _extends({}, state, { filesLoading: true });
    case cnt.GET_FILES + '_SUCCESS':
      return _extends({}, state, {
        files: payload.contracts,
        filesLoaded: true,
        filesLoading: false,
        resourceType: payload.resourceType
      });
    case cnt.GET_FILES + '_ERROR':
      return _extends({}, state, { filesLoaded: false, filesLoading: false });
    case cnt.GET_ACTIVITY + '_STARTED':
      return _extends({}, state, { activitiesLoading: true });
    case cnt.GET_ACTIVITY + '_SUCCESS':
      return _extends({}, state, { activitiesLoaded: true, activitiesLoading: false, activities: payload });
    case cnt.GET_ACTIVITY + '_ERROR':
      return _extends({}, state, { activitiesLoaded: false, activitiesLoading: false });
    case cnt.CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
};

exports.initialState = initialState;

/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(657);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
  companySettings: {},
  loading: false,
  loaded: false,
  errored: false
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case cnt.GET_SETTINGS + '_STARTED':
      return _extends({}, state, {
        loading: true,
        errored: false
      });
    case cnt.GET_SETTINGS + '_SUCCESS':
      return _extends({}, state, payload, {
        errored: false,
        loading: false
      });
    case cnt.GET_SETTINGS + '_ERROR':
      return _extends({}, state, {
        loading: false,
        errored: true
      });
    case cnt.SAVE_SETTINGS + '_STARTED':
      return _extends({}, state, {
        loading: true,
        errored: false
      });
    case cnt.SAVE_SETTINGS + '_SUCCESS':
      return _extends({}, state, {
        loading: false,
        errored: false
      }, payload);
    case cnt.SAVE_SETTINGS + '_ERROR':
      return _extends({}, state, {
        loading: false,
        errored: true
      });
    default:
      return state;
  }
};

/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = wallReducer;

var _ramda = __webpack_require__(2);

var walls = function walls(wallType) {
  if (wallType) return { url: '//www.tourconnect.com/' + wallType };
  return { url: '//www.tourconnect.com/upgrade-gen-send-assets/' };
};

var initialState = _extends({
  open: false
}, walls(), {
  blocker: false,
  skipBack: false
});

function wallReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      // URL matches
      var pathname = action.payload.pathname;

      if (pathname.match(/contracting\/master-template-list/)) {
        return _extends({}, state, walls('upgrade-rates-corp'), {
          blocker: true,
          skipBack: false,
          open: true
        });
      }
      if (pathname.match(/contracting\/create-master-template/)) return _extends({}, state, walls('upgrade-rates-corp'), {
        blocker: true,
        skipBack: false,
        open: true
      });
      if (pathname.match(/contracting\/reports\/diff\/template/)) return _extends({}, state, walls('upgrade-rates-temp-compare'), {
        blocker: true,
        skipBack: false,
        open: true
      });
      if (pathname.match(/contracting\/reports\/diff\/contract/)) return _extends({}, state, walls('upgrade-rates-ctrct-compare'), {
        blocker: true,
        skipBack: false,
        open: true
      });
      if (pathname.match(/contracting\/supplier-dashboard/)) return _extends({}, state, walls('upgrade-rates-sup-dash'), {
        open: true,
        skipBack: false,
        blocker: true
      });
      if (pathname.match(/contracting\/buyer-dashboard/)) return _extends({}, state, walls('upgrade-rates-buy-dash'), {
        open: true,
        skipBack: false,
        blocker: true
      });
      if (pathname.match(/workspace\/bulkmessages/)) return _extends({}, state, walls('upgrade-pm-bulk-msg'), {
        open: true,
        blocker: false
      });
      if (pathname.match(/contracting\/contract\/(.+)\/notes/)) return _extends({}, state, walls('upgrade-rates-workflow'), {
        open: true,
        blocker: false
      });
      return state;
    case '[wall] openClose':
      // reducer action maches
      var open = action.payload;

      return _extends({}, state, walls(), {
        open: open,
        blocker: open ? state.blocker : false
      });
    case '[wall] openSlug':
      var payload = action.payload,
          slug = action.payload.slug;

      return _extends({}, state, walls(slug), (0, _ramda.omit)(['slug'], payload), {
        open: true
      });
    case '[contract-list]GET_CONTRACT_FORWARDING_EMAIL':
      return _extends({}, state, walls('upgrade-page-contracting-workflow-fwd'), {
        open: true,
        blocker: false
      });
    case 'UPDATE_PROPS_IN_CONTRACT_LISTING':
      var _action$payload = action.payload,
          folderAction = _action$payload.folderAction,
          createNewFolder = _action$payload.createNewFolder;

      if (folderAction === 'assign' || createNewFolder === true) {
        return _extends({}, state, walls('upgrade-rates-workflow'), {
          open: true,
          blocker: false
        });
      }
      return state;
    case '{contracting} ADD_DRAFT_TO_QUEUE':
      return _extends({}, state, walls('upgrade-rates-updates'), {
        open: true,
        blocker: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouterRedux = __webpack_require__(27);

var _reactRouter = __webpack_require__(67);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _accessCheckHelperFns = __webpack_require__(631);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var controlledRouteChange = function controlledRouteChange(_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return function (next) {
    return function (action) {
      if (action && action.type !== _reactRouterRedux.CALL_HISTORY_METHOD) {
        return next(action);
      }

      var _action$payload = action.payload,
          method = _action$payload.method,
          args = _action$payload.args;

      if (method === 'push' || method === 'replace') {
        var route = args[0];
        var pathname = _ramda2.default.is(Object, route) ? route.pathname : route;
        // BEGIN ACCESS CHECK
        if (_ramda2.default.contains('/contracting', pathname)) {

          var access = (0, _accessCheckHelperFns.getFeatureAccess)(getState(), null, 'contracting');
          if (!_ramda2.default.contains('read', access)) return dispatch((0, _accessCheckHelperFns.triggerNoAccessWarning)({ featureName: 'contracting' }));

          if (_ramda2.default.any(_ramda2.default.contains(_ramda2.default.__, pathname), ['mass-rate-change', 'partners'])) {
            var _getState = getState(),
                contracting = _getState.contracting;

            var locationIdFromLeftNav = _ramda2.default.path(['leftNav', 'locationId'], contracting.contractActivitiesProducts.toJS());
            if (locationIdFromLeftNav && !(0, _accessCheckHelperFns.checkLocAccess)(getState(), locationIdFromLeftNav, 'contracting', 'write')) {
              return dispatch((0, _accessCheckHelperFns.triggerNoAccessWarning)({ featureName: 'contracting' }));
            }
          }
        }

        if (_ramda2.default.contains('/integration/', pathname)) {
          var _access = (0, _accessCheckHelperFns.getFeatureAccess)(getState(), null, 'contracting');
          if (!_ramda2.default.contains('write', _access)) return dispatch((0, _accessCheckHelperFns.triggerNoAccessWarning)({ featureName: 'contracting' }));
        }
        // END ACCESS CHECK
      }

      return _reactRouter.browserHistory[method].apply(_reactRouter.browserHistory, _toConsumableArray(args));
    };
  };
};

exports.default = controlledRouteChange;

/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRouterRedux = __webpack_require__(27);

var _accessCheckHelperFns = __webpack_require__(631);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var accessCheck = function accessCheck(_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      var type = action.type,
          payload = action.payload;

      var _getState = getState(),
          user = _getState.user,
          contracting = _getState.contracting;

      var companyType = user.toJS().user.type;
      var locAccess = user.toJS().locAccess;
      var getContractingAccess = function getContractingAccess(locId) {
        return (0, _accessCheckHelperFns.getFeatureAccess)(getState(), locId, 'contracting');
      };
      var checkLocContractingWriteAccess = function checkLocContractingWriteAccess(locId) {
        return (0, _accessCheckHelperFns.checkLocAccess)(getState(), locId, 'contracting', 'write');
      };
      var checkLocContractingAccess = function checkLocContractingAccess(locId) {
        return (0, _accessCheckHelperFns.checkLocAccess)(getState(), locId, 'contracting', 'read');
      };
      var unApprovedShellAccount = user.toJS().unApprovedShellAccount;
      if (type === 'GETTING_CONTRACTING_YEARS') {
        var noContractingAccess = _ramda2.default.isEmpty(getContractingAccess());
        if (noContractingAccess && !unApprovedShellAccount) return dispatch((0, _accessCheckHelperFns.triggerNoAccessWarning)({ featureName: 'contracting' }));
      }
      var actionsToCheck = {
        'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE': 'edit this document',
        'SEND_UPDATES_IN_PUBLISH_DRAFT_DIALOG': 'send updates',
        'OPEN_AS_SAVE_CONTRACT_AS_TEMPLATE': 'save this document as a template',
        '[contractTemplate]TOGGLE_CREATE_DRAFT_DIALOG': 'edit this document',
        'CHANGE_RESEND_CONTRACT_DIALOG_STATE': 'resend this contract',
        'CHANGE_CONTRACT_STATE_STARTING': 'update the state of this contract',
        'DISCARD_SELECTED_IN_REQUESTS_WITH_SAME_NAME_DIALOG': 'discard contract requests'
      };
      if (actionsToCheck[type]) {
        var locId = contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId']);
        var readOnly = locId && companyType === 'Supplier' ? !checkLocContractingWriteAccess(locId) : !_ramda2.default.contains('write', getContractingAccess());
        if (readOnly) {
          return dispatch((0, _accessCheckHelperFns.triggerNoAccessWarning)({
            featureName: 'contracting',
            message: 'You will need write access in order to ' + actionsToCheck[type] + '.'
          }));
        }
      }
      if (type === 'UPDATE_TEMPLATE_PROPS_IN_TEMPLATE_LIST' || type === 'UPDATE_DRAFT_PROPS_IN_TEMPLATE_LIST') {
        var templateId = payload.templateId,
            draftId = payload.draftId,
            _payload$data = payload.data,
            showEditNameConfirmButton = _payload$data.showEditNameConfirmButton,
            showDeleteConfirmButton = _payload$data.showDeleteConfirmButton;

        if (showEditNameConfirmButton || showDeleteConfirmButton) {
          var docs = contracting.templateList.get(templateId ? 'templates' : 'drafts').toJS();
          var doc = templateId ? _ramda2.default.find(_ramda2.default.propEq('_id', templateId), docs) : _ramda2.default.find(_ramda2.default.propEq('originalContractId', draftId), docs);
          var _locId = _ramda2.default.propOr('', 'locationId', doc);
          var _readOnly = !checkLocContractingWriteAccess(_locId);
          if (_readOnly) {
            return dispatch((0, _accessCheckHelperFns.triggerNoAccessWarning)({
              featureName: 'contracting',
              message: 'You will need write access in order to ' + (showEditNameConfirmButton ? 'edit' : 'delete') + ' this document.'
            }));
          }
        }
      }
      if (type === '[template-list]UPDATE_PROPS_IN_TEMPLATE_LIST' && payload.sendTemplateDialogOpen) {
        var templateToBeSent = payload.templateToBeSent,
            templateGroupToBeSent = payload.templateGroupToBeSent;

        if (templateToBeSent && templateToBeSent.locationId) {
          var _readOnly2 = !checkLocContractingWriteAccess(templateToBeSent.locationId);
          if (_readOnly2) {
            return dispatch((0, _accessCheckHelperFns.triggerNoAccessWarning)({
              featureName: 'contracting',
              message: 'You will need write access in order to send rates.'
            }));
          }
        }
        if (templateGroupToBeSent) {
          var locationIds = _ramda2.default.pluck('locationId', templateGroupToBeSent.templates);
          var noAccess = _ramda2.default.any(function (locId) {
            return !checkLocContractingWriteAccess(locId);
          }, locationIds);
          if (noAccess) return dispatch((0, _accessCheckHelperFns.triggerNoAccessWarning)({ featureName: 'contracting' }));
        }
      }
      // Below blocks are adding access information to documents
      if (type === 'TEMPLATES_LOADED_IN_TEMPLATE_LIST' || type === '{template-list} REFRESH_TEMPLATE_LIST_SUCCESS') {
        var updatedTemplates = payload.templates.map(function (template) {
          return _extends({}, template, { access: getContractingAccess(template.locationId) });
        });
        var updatedDrafts = payload.drafts.map(function (draft) {
          return _extends({}, draft, { access: getContractingAccess(draft.locationId) });
        });
        return next(_extends({}, action, { payload: _extends({}, payload, { templates: updatedTemplates, drafts: updatedDrafts }) }));
      }
      if (type === 'LOADED_TEMPLATES_SUPPLIER_SEND_TEMPLATE_WIZARD') {
        var _updatedTemplates = payload.templates.map(function (template) {
          return _extends({}, template, { access: getContractingAccess(template.locationId) });
        });
        return next(_extends({}, action, { payload: _extends({}, payload, { templates: _updatedTemplates }) }));
      }
      if (type === '[contract-list]LOAD_CONTRACT_LIST_SUCCESS' || type === '[supplier-wizard]GET_RESPONDED_CONTRACT_LIST_SUCCESS') {
        var list = payload.list;

        var updatedList = list.map(function (contract) {
          return _extends({}, contract, {
            access: unApprovedShellAccount ? ['read', 'write'] : getContractingAccess(contract.locationId)
          });
        });
        return next(_extends({}, action, { payload: _extends({}, payload, { list: updatedList }) }));
      }
      var loadLocationsToTemplateList = type === 'GET_SUPPLIER_LOCATIONS_LIST_IN_TEMPLATE_LIST';
      var loadLocationsToSupplierWizard = type === 'LOCATIONS_LOADED_SUPPLIER_SEND_TEMPLATE_WIZARD';
      // FOR CREATE TEMPLATE DRAFT
      if (loadLocationsToTemplateList && !isNilOrEmpty(payload.locations)) {
        var updatedLocations = payload.locations.map(function (loc) {
          return _extends({}, loc, { access: getContractingAccess(loc.locationId) });
        });
        return next(_extends({}, action, { payload: _extends({}, payload, { locations: updatedLocations }) }));
      }
      // FOR SELECTING TEMPLATE IN SUPPLIER SEND RATES WIZARD
      if (loadLocationsToSupplierWizard && !isNilOrEmpty(payload.locations)) {
        var _updatedLocations = payload.locations.map(function (loc) {
          return _extends({}, loc, { access: getContractingAccess(loc.id) });
        });
        return next(_extends({}, action, { payload: _extends({}, payload, { locations: _updatedLocations }) }));
      }

      return next(action);
    };
  };
};

exports.default = accessCheck;

/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(67);

var _reactRouterRedux = __webpack_require__(27);

var _routes = __webpack_require__(2719);

var _intercomAnalytics = __webpack_require__(3614);

var _intercomAnalytics2 = _interopRequireDefault(_intercomAnalytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hidden = null;
var visibilityChange = null;
if (typeof document.hidden !== 'undefined') {
  // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden';
  visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
}

var Root = function (_Component) {
  _inherits(Root, _Component);

  function Root() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Root);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Root.__proto__ || Object.getPrototypeOf(Root)).call.apply(_ref, [this].concat(args))), _this), _this.onUpdate = function () {
      _this.hashLinkScroll();
    }, _this.handleVisibilityChange = function () {
      if (document[hidden]) {
        console.log(hidden, 'hidden');
      } else {
        _this.props.store.dispatch({ type: 'REFRESH_DATA_IN_PAGE_BACKGROUND' });
      }
    }, _this.permissionCheck = function () {
      var _this$props$store = _this.props.store,
          dispatch = _this$props$store.dispatch,
          getState = _this$props$store.getState;
      var pathname = window.location.pathname;
    }, _this.hashLinkScroll = function () {
      var hash = window.location.hash;

      if (hash !== '') {
        // Push onto callback queue so it runs after the DOM is updated,
        // this is required when navigating from a different page so that
        // the element is rendered on the page before trying to getElementById.
        setTimeout(function () {
          var id = hash.replace('#', '');
          var element = document.getElementById(id);
          if (element) element.scrollIntoView();
        }, 0);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Root, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener(visibilityChange, this.handleVisibilityChange, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener(visibilityChange, this.handleVisibilityChange);
    }
  }, {
    key: 'render',
    value: function render() {
      var store = this.props.store;
      // Create an enhanced history that syncs navigation events with the store

      var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
      //     history.listen(() => intercomAnalytics.trackPage()); - Don't send to intercom for now.
      return _react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(
          _reactRouter.Router,
          { history: history, onUpdate: this.onUpdate },
          _routes.routes
        )
      );
    }
  }]);

  return Root;
}(_react.Component);

exports.default = Root;


Root.propTypes = {
  store: _react.PropTypes.object
};

/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(67);

var _appWindow = __webpack_require__(2720);

var _appWindow2 = _interopRequireDefault(_appWindow);

var _dashboard = __webpack_require__(2805);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _onBoarding = __webpack_require__(2824);

var _onBoarding2 = _interopRequireDefault(_onBoarding);

var _tempConnections = __webpack_require__(2833);

var _tempConnections2 = _interopRequireDefault(_tempConnections);

var _tempConnectionsSend = __webpack_require__(2834);

var _tempConnectionsSend2 = _interopRequireDefault(_tempConnectionsSend);

var _tempConnectionsResults = __webpack_require__(2836);

var _tempConnectionsResults2 = _interopRequireDefault(_tempConnectionsResults);

var _tempConnectionsAdd = __webpack_require__(2837);

var _tempConnectionsAdd2 = _interopRequireDefault(_tempConnectionsAdd);

var _integration = __webpack_require__(2847);

var _integration2 = _interopRequireDefault(_integration);

var _exportContainer = __webpack_require__(2949);

var _exportContainer2 = _interopRequireDefault(_exportContainer);

var _integrationContainer = __webpack_require__(2966);

var _integrationContainer2 = _interopRequireDefault(_integrationContainer);

var _connectionsContainer = __webpack_require__(2967);

var _connectionsContainer2 = _interopRequireDefault(_connectionsContainer);

var _connections = __webpack_require__(2973);

var _connections2 = _interopRequireDefault(_connections);

var _profileContainer = __webpack_require__(2991);

var _profileContainer2 = _interopRequireDefault(_profileContainer);

var _profile = __webpack_require__(3002);

var _profile2 = _interopRequireDefault(_profile);

var _profileCompleteSplash = __webpack_require__(3199);

var _profileCompleteSplash2 = _interopRequireDefault(_profileCompleteSplash);

var _containerPartnerFinder = __webpack_require__(3202);

var _containerPartnerFinder2 = _interopRequireDefault(_containerPartnerFinder);

var _optionsPartnerFinder = __webpack_require__(3203);

var _optionsPartnerFinder2 = _interopRequireDefault(_optionsPartnerFinder);

var _resultsPartnerFinder = __webpack_require__(3204);

var _resultsPartnerFinder2 = _interopRequireDefault(_resultsPartnerFinder);

var _contractingContainer = __webpack_require__(3216);

var _contractingContainer2 = _interopRequireDefault(_contractingContainer);

var _pageNotFound = __webpack_require__(3232);

var _pageNotFound2 = _interopRequireDefault(_pageNotFound);

var _cardIntro = __webpack_require__(3233);

var _cardIntro2 = _interopRequireDefault(_cardIntro);

var _container = __webpack_require__(3234);

var _container2 = _interopRequireDefault(_container);

var _container3 = __webpack_require__(3235);

var _container4 = _interopRequireDefault(_container3);

var _containerAllotments = __webpack_require__(3252);

var _containerAllotments2 = _interopRequireDefault(_containerAllotments);

var _contractContainer = __webpack_require__(3266);

var _contractContainer2 = _interopRequireDefault(_contractContainer);

var _draftNTemplateContainer = __webpack_require__(3351);

var _draftNTemplateContainer2 = _interopRequireDefault(_draftNTemplateContainer);

var _contractPolicies = __webpack_require__(3377);

var _contractPolicies2 = _interopRequireDefault(_contractPolicies);

var _contractPolicies3 = __webpack_require__(3411);

var _contractPolicies4 = _interopRequireDefault(_contractPolicies3);

var _router = __webpack_require__(3412);

var _router2 = _interopRequireDefault(_router);

var _mainContent = __webpack_require__(3414);

var _mainContent2 = _interopRequireDefault(_mainContent);

var _router3 = __webpack_require__(3415);

var _router4 = _interopRequireDefault(_router3);

var _notes = __webpack_require__(3426);

var _notes2 = _interopRequireDefault(_notes);

var _product = __webpack_require__(3427);

var _product2 = _interopRequireDefault(_product);

var _massRateChangeContainer = __webpack_require__(3434);

var _massRateChangeContainer2 = _interopRequireDefault(_massRateChangeContainer);

var _contractListContainer = __webpack_require__(1999);

var _contractListContainer2 = _interopRequireDefault(_contractListContainer);

var _container5 = __webpack_require__(3458);

var _container6 = _interopRequireDefault(_container5);

var _container7 = __webpack_require__(3483);

var _container8 = _interopRequireDefault(_container7);

var _router5 = __webpack_require__(3494);

var _router6 = _interopRequireDefault(_router5);

var _diffReportPage = __webpack_require__(3495);

var _diffReportPage2 = _interopRequireDefault(_diffReportPage);

var _selectDocsPage = __webpack_require__(3499);

var _selectDocsPage2 = _interopRequireDefault(_selectDocsPage);

var _templateListContainer = __webpack_require__(3500);

var _templateListContainer2 = _interopRequireDefault(_templateListContainer);

var _container9 = __webpack_require__(3501);

var _container10 = _interopRequireDefault(_container9);

var _createGroupRouter = __webpack_require__(3513);

var _createGroupRouter2 = _interopRequireDefault(_createGroupRouter);

var _routerContainer = __webpack_require__(3514);

var _routerContainer2 = _interopRequireDefault(_routerContainer);

var _partnerList = __webpack_require__(3515);

var _partnerList2 = _interopRequireDefault(_partnerList);

var _changeLogRouter = __webpack_require__(3517);

var _changeLogRouter2 = _interopRequireDefault(_changeLogRouter);

var _settingsContainer = __webpack_require__(3521);

var _settingsContainer2 = _interopRequireDefault(_settingsContainer);

var _upgradeContainer = __webpack_require__(3546);

var _upgradeContainer2 = _interopRequireDefault(_upgradeContainer);

var _upgrade = __webpack_require__(1866);

var _upgrade2 = _interopRequireDefault(_upgrade);

var _messagingContainer = __webpack_require__(3547);

var _messagingContainer2 = _interopRequireDefault(_messagingContainer);

var _rgtMsgsRouter = __webpack_require__(2042);

var _rgtMsgsRouter2 = _interopRequireDefault(_rgtMsgsRouter);

var _newsfeedContainer = __webpack_require__(3556);

var _newsfeedContainer2 = _interopRequireDefault(_newsfeedContainer);

var _post = __webpack_require__(1654);

var _post2 = _interopRequireDefault(_post);

var _internalContainer = __webpack_require__(3571);

var _internalContainer2 = _interopRequireDefault(_internalContainer);

var _mainRouter = __webpack_require__(3572);

var _mainRouter2 = _interopRequireDefault(_mainRouter);

var _posts = __webpack_require__(3573);

var _posts2 = _interopRequireDefault(_posts);

var _followers = __webpack_require__(3574);

var _followers2 = _interopRequireDefault(_followers);

var _follows = __webpack_require__(3575);

var _follows2 = _interopRequireDefault(_follows);

var _container11 = __webpack_require__(3576);

var _container12 = _interopRequireDefault(_container11);

var _router7 = __webpack_require__(3593);

var _router8 = _interopRequireDefault(_router7);

var _partnerDetails = __webpack_require__(3597);

var _partnerDetails2 = _interopRequireDefault(_partnerDetails);

var _createMasterTemplate = __webpack_require__(3604);

var _createMasterTemplate2 = _interopRequireDefault(_createMasterTemplate);

var _list = __webpack_require__(3605);

var _list2 = _interopRequireDefault(_list);

var _router9 = __webpack_require__(3606);

var _router10 = _interopRequireDefault(_router9);

var _router11 = __webpack_require__(3607);

var _router12 = _interopRequireDefault(_router11);

var _wizard = __webpack_require__(3612);

var _wizard2 = _interopRequireDefault(_wizard);

var _wizard3 = __webpack_require__(3613);

var _wizard4 = _interopRequireDefault(_wizard3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Secondary Template*/


/* Asset Consolidation */


/* News Feed */


/* Upgrade Component */
var routes = exports.routes = _react2.default.createElement(
  _reactRouter.Route,
  { component: _appWindow2.default },
  _react2.default.createElement(_reactRouter.Redirect, { from: '/', to: '/dashboard' }),
  _react2.default.createElement(_reactRouter.Redirect, { from: '/settings', to: '/settings/my-settings' }),
  _react2.default.createElement(_reactRouter.Route, { path: '/dashboard', component: _dashboard2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: '/newsfeed', component: _newsfeedContainer2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: '/workspace', component: _container12.default }),
  _react2.default.createElement(_reactRouter.Route, { path: '/workspace/:connectionId', component: _container12.default }),
  _react2.default.createElement(_reactRouter.Route, { path: '/workspace/:connectionId/:channelId', component: _container12.default }),
  _react2.default.createElement(_reactRouter.Route, { path: '/assets-consolidation/:hashToken', component: _router8.default }),
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _mainRouter2.default },
    _react2.default.createElement(_reactRouter.Route, { component: _posts2.default, path: '/newsfeed/meta/posts' }),
    _react2.default.createElement(_reactRouter.Route, { component: _followers2.default, path: '/newsfeed/meta/followers' }),
    _react2.default.createElement(_reactRouter.Route, { component: _follows2.default, path: '/newsfeed/meta/follows' })
  ),
  _react2.default.createElement(_reactRouter.Route, { path: '/partnerdetails/:partner', component: _partnerDetails2.default }),
  _react2.default.createElement(_reactRouter.Route, { component: _settingsContainer2.default, path: '/settings/:activeRoute' }),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: '/upgrade', component: _upgradeContainer2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _upgrade2.default })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _messagingContainer2.default, path: '/messaging/:filter' },
    _react2.default.createElement(_reactRouter.Route, { component: _rgtMsgsRouter2.default, path: '/messaging/:filter/conversation/:convId' }),
    _react2.default.createElement(_reactRouter.Route, { component: _router4.default, path: '/messaging/:filter/contract/:contractId' })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _profileContainer2.default },
    _react2.default.createElement(_reactRouter.Route, { component: _profile2.default, path: '/profile' }),
    _react2.default.createElement(_reactRouter.Route, { component: _profile2.default, path: '/profile/locations/:locationId' }),
    _react2.default.createElement(_reactRouter.Route, { component: _profile2.default, path: '/profile/product/:productId' }),
    _react2.default.createElement(_reactRouter.Route, { component: _profile2.default, path: '/company/:companyId' }),
    _react2.default.createElement(_reactRouter.Route, { component: _profile2.default, path: '/locations/:locationId' }),
    _react2.default.createElement(_reactRouter.Route, { component: _profile2.default, path: '/product/:productId' })
  ),
  _react2.default.createElement(_reactRouter.Route, { component: _onBoarding2.default, path: '/onboarding' }),
  _react2.default.createElement(_reactRouter.Route, { component: _pageNotFound2.default, path: '/notfound' }),
  _react2.default.createElement(_reactRouter.Route, { component: _profileCompleteSplash2.default, path: '/profile-complete-splash' }),
  _react2.default.createElement(_reactRouter.Route, { component: _optionsPartnerFinder2.default, path: '/connections-splash' }),
  _react2.default.createElement(_reactRouter.Redirect, { from: '/connections', to: '/connections/connected' }),
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _connectionsContainer2.default, path: '/connections' },
    _react2.default.createElement(_reactRouter.Route, { path: '/connections/connected', component: _connections2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/connections/requests', component: _connections2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/connections/invitations', component: _connections2.default })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _tempConnections2.default },
    _react2.default.createElement(_reactRouter.Route, { path: '/connections/add-connections', component: _tempConnectionsAdd2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/connections/add-connections/send', component: _tempConnectionsSend2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/connections/add-connections/results', component: _tempConnectionsResults2.default })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: '/integration', component: _integrationContainer2.default },
    _react2.default.createElement(_reactRouter.Route, { component: _exportContainer2.default, path: '/integration/product-mapping/:contractID' }),
    _react2.default.createElement(_reactRouter.Route, { component: _integration2.default, path: '/integration/authentication' }),
    _react2.default.createElement(_reactRouter.Route, { component: _integration2.default, path: '/integration/contracts' }),
    _react2.default.createElement(_reactRouter.Route, { component: _integration2.default, path: '/integration/settings/:settingType' })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: '/partner-finder/search', component: _containerPartnerFinder2.default },
    _react2.default.createElement(_reactRouter.Redirect, { from: '/partner-finder/search', to: '/partner-finder/results' }),
    _react2.default.createElement(_reactRouter.Route, { component: _resultsPartnerFinder2.default, path: '/partner-finder/results' })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: '/post/:postId', component: _internalContainer2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _post2.default })
  ),
  _react2.default.createElement(_reactRouter.Route, { path: '/contracting/create-master-template', component: _createMasterTemplate2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: '/contracting/pick-master-template/:templateDraftId', component: _wizard4.default }),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: '/contracting/master-template/:id', component: _router12.default },
    _react2.default.createElement(_reactRouter.Route, { path: '/contracting/master-template/:id/associate', component: _wizard2.default })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: '/contracting', component: _contractingContainer2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _cardIntro2.default }),
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _router2.default, path: '/contracting/workspace/:contractId' },
      _react2.default.createElement(_reactRouter.Redirect, { from: '/contracting/workspace/:contractId', to: '/contracting/workspace/:contractId/documents' }),
      _react2.default.createElement(_reactRouter.Route, { component: _mainContent2.default, path: '/contracting/workspace/:contractId/documents' }),
      _react2.default.createElement(_reactRouter.Route, { component: _router4.default, path: '/contracting/workspace/:contractId/activities' }),
      _react2.default.createElement(_reactRouter.Route, { component: _notes2.default, path: '/contracting/workspace/:contractId/notes' })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _contractContainer2.default, path: '/contracting/contract/:contractId/details' },
      _react2.default.createElement(_reactRouter.Route, { component: _contractPolicies2.default, path: '/contracting/contract/:contractId/policies' }),
      _react2.default.createElement(_reactRouter.Route, { component: _router4.default, path: '/contracting/contract/:contractId/activities' }),
      _react2.default.createElement(_reactRouter.Route, { component: _notes2.default, path: '/contracting/contract/:contractId/notes' }),
      _react2.default.createElement(_reactRouter.Route, { component: _product2.default, path: '/contracting/contract/:contractId/product/:productId/:ratePackage' })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _draftNTemplateContainer2.default, path: '/contracting/:collection/:contractId/details' },
      _react2.default.createElement(_reactRouter.Route, { component: _contractPolicies4.default, path: '/contracting/:collection/:contractId/policies' }),
      _react2.default.createElement(_reactRouter.Route, { component: _product2.default, path: '/contracting/:collection/:contractId/product/:productId/:ratePackage' }),
      _react2.default.createElement(_reactRouter.Route, { components: _partnerList2.default, path: '/contracting/:collection/:contractId/partners' })
    ),
    _react2.default.createElement(_reactRouter.Route, { components: _changeLogRouter2.default, path: '/contracting/template/:threadId/logs' }),
    _react2.default.createElement(_reactRouter.Route, { path: '/contracting/contract-list', component: _contractListContainer2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/contracting/contract-list/:type', component: _contractListContainer2.default }),
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _templateListContainer2.default },
      _react2.default.createElement(_reactRouter.Route, { path: '/contracting/template-list', component: _container10.default }),
      _react2.default.createElement(_reactRouter.Route, { path: '/contracting/supplier-updates-queue', component: _router10.default }),
      _react2.default.createElement(_reactRouter.Route, { path: '/contracting/master-template-list', component: _list2.default })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: '/contracting/create-template-group', component: _createGroupRouter2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/contracting/create-template-draft', component: _routerContainer2.default }),
    _react2.default.createElement(_reactRouter.Route, { component: _massRateChangeContainer2.default, path: '/contracting/mass-rate-change/:contractId/:updateType' }),
    _react2.default.createElement(_reactRouter.Route, { component: _container6.default, path: '/contracting/supplier-dashboard' }),
    _react2.default.createElement(_reactRouter.Route, { component: _container6.default, path: '/contracting/buyer-dashboard' }),
    _react2.default.createElement(_reactRouter.Route, { component: _container8.default, path: '/contracting/reports' }),
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _router6.default, path: '/contracting/reports/diff' },
      _react2.default.createElement(_reactRouter.Route, { component: _selectDocsPage2.default, path: '/contracting/reports/diff/:collection/:baseId' }),
      _react2.default.createElement(_reactRouter.Route, { component: _diffReportPage2.default, path: '/contracting/reports/diff/:collection/:baseId/:compareId' })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { components: _container2.default },
      _react2.default.createElement(_reactRouter.Route, { component: _container4.default, path: '/contracting/supplier-wizard/:contractId' }),
      _react2.default.createElement(_reactRouter.Route, { component: _containerAllotments2.default, path: '/contracting/supplier-wizard-allotment' })
    )
  ),
  _react2.default.createElement(_reactRouter.Redirect, { from: '*', to: '/dashboard' })
);

/* Partner Details */


/* Workspace */


/* Settings Components */

/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _configActions = __webpack_require__(2721);

var _userActions = __webpack_require__(868);

var _hydrateStores = __webpack_require__(2723);

var _MuiThemeProvider = __webpack_require__(627);

var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);

var _muiTheme = __webpack_require__(477);

var _muiTheme2 = _interopRequireDefault(_muiTheme);

var _appBar = __webpack_require__(2727);

var _appBar2 = _interopRequireDefault(_appBar);

var _snackBarMessage = __webpack_require__(2756);

var _snackBarMessage2 = _interopRequireDefault(_snackBarMessage);

var _downloadPopover = __webpack_require__(1462);

var _downloadPopover2 = _interopRequireDefault(_downloadPopover);

var _globalAlertBox = __webpack_require__(2757);

var _globalAlertBox2 = _interopRequireDefault(_globalAlertBox);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _titlecase = __webpack_require__(549);

var _upgrade = __webpack_require__(1866);

var _upgrade2 = _interopRequireDefault(_upgrade);

var _beamerContainer = __webpack_require__(2798);

var _beamerContainer2 = _interopRequireDefault(_beamerContainer);

var _helpWidget = __webpack_require__(1466);

var _helpWidget2 = _interopRequireDefault(_helpWidget);

var _globalErrorsDisplayContainer = __webpack_require__(2799);

var _globalErrorsDisplayContainer2 = _interopRequireDefault(_globalErrorsDisplayContainer);

var _upgradeConstants = __webpack_require__(1048);

var upgradeConstants = _interopRequireWildcard(_upgradeConstants);

var _upgradeActions = __webpack_require__(611);

var _billingActions = __webpack_require__(1108);

var _rateDocIframe = __webpack_require__(1479);

var _rateDocIframe2 = _interopRequireDefault(_rateDocIframe);

var _index = __webpack_require__(2803);

var _index2 = _interopRequireDefault(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Dependencies


var AppWindow = function (_Component) {
  _inherits(AppWindow, _Component);

  function AppWindow(props) {
    _classCallCheck(this, AppWindow);

    var _this = _possibleConstructorReturn(this, (AppWindow.__proto__ || Object.getPrototypeOf(AppWindow)).call(this, props));

    _this._updateUpgradeSource = function (source) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _userActions.updateUpgradeSource)(source));
    };

    _this._logUpgradeClick = function (source, type) {
      var dispatch = _this.props.dispatch;
      // dispatch(logUpgradeClick(source, type));
    };

    _this.triggerSnackBarMessage = function (options) {
      _this.refs.snackBarMessage.triggerSnackBarMessage(options);
    };

    _this.getUpgradeHeader = function () {
      var _this$props = _this.props,
          upgrade = _this$props.upgrade,
          profile = _this$props.profile;
      var upgradeReason = upgrade.upgradeReason;


      switch (upgradeReason) {
        case upgradeConstants.PARTNER_FINDER_CONNECT:
          var clickedCompany = upgrade.clickedCompany;

          return _react2.default.createElement(
            'span',
            null,
            'Please upgrade your account to connect with ',
            _react2.default.createElement(
              'strong',
              { style: { textDecoration: 'underline' } },
              clickedCompany
            ),
            '.'
          );
        default:
          return _react2.default.createElement(
            'span',
            null,
            'Upgrade to unlock the power of TourConnect.'
          );
      }
    };

    _this.onUpgrade = function (selectedPlan, response) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _billingActions.addSubscription)(selectedPlan.planId, response.id, response.card)).then(function () {
        return dispatch((0, _billingActions.resetBillingError)());
      }).then(function () {
        return dispatch((0, _upgradeActions.closeUpgrade)());
      }).catch(function () {});
    };

    return _this;
  }

  _createClass(AppWindow, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          dispatch = _props.dispatch,
          history = _props.history,
          config = _props.config;

      _moment2.default.locale(config.locale);
      dispatch((0, _configActions.getConfig)());
      (0, _hydrateStores.hydrateStores)(dispatch, history);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          upgrade = _props2.upgrade;

      if (this.props.config.locale !== nextProps.config.locale) {
        _moment2.default.locale(nextProps.config.locale);
      }

      if (upgrade.isOpen !== nextProps.upgrade.isOpen && !nextProps.upgrade.isOpen) dispatch((0, _billingActions.resetBillingError)());
      if (this.props.location.pathname !== nextProps.location.pathname) {
        document.title = (0, _titlecase.toLaxTitleCase)((nextProps.location.pathname || '').split('/').join(' ')) + ' - TourConnect';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.user || !this.props.user.user.userID) return false;

      var _props3 = this.props,
          children = _props3.children,
          helpwidget = _props3.helpwidget,
          upgrade = _props3.upgrade,
          walkthru = _props3.walkthru,
          props = _objectWithoutProperties(_props3, ['children', 'helpwidget', 'upgrade', 'walkthru']);

      var lockedPartners = this.props.user.lockedPartners;

      var lockedPartnersBanner = function () {
        if (lockedPartners < 1) return undefined;
        return _react2.default.createElement(
          _materialUi.Paper,
          {
            style: {
              marginTop: '1em',
              padding: '1em 1em 0.5em',
              textAlign: 'center',
              backgroundColor: 'rgba(255, 193, 7, 0.3)'
            },
            variant: 'outlined'
          },
          _react2.default.createElement(
            'strong',
            null,
            lockedPartners + 3,
            ' partners have accepted your Partner Requests and are ready to work with you!',
            _react2.default.createElement('br', null)
          ),
          _react2.default.createElement(_materialUi.FlatButton, {
            secondary: true,
            label: 'Go to Partner List to start working with them',
            onClick: function onClick() {
              return window.location = "https://app.tourconnect.com" + '/partner-management/partner-list/partner?jwt=' + localStorage.getItem('jwt');
            }
          })
        );
      }();
      var extraProps = _extends({
        triggerSnackBarMessage: this.triggerSnackBarMessage,
        updateUpgradeSource: this._updateUpgradeSource,
        logUpgradeClick: this._logUpgradeClick,
        lockedPartnersBanner: lockedPartnersBanner
      }, props);
      var upgradeHeader = upgrade.isOpen ? _react2.default.createElement(
        'h1',
        { style: { fontWeight: 300, fontSize: '21px', lineHeight: '36px', margin: 0, textAlign: 'center', paddingTop: '25px' } },
        this.getUpgradeHeader()
      ) : null;
      return _react2.default.createElement(
        _MuiThemeProvider2.default,
        { muiTheme: _muiTheme2.default },
        _react2.default.createElement(
          'div',
          { className: 'app-window', style: upgrade.isOpen ? { overflow: 'hidden' } : {} },
          _react2.default.createElement(_appBar2.default, _extends({ ref: 'appBar', walkthru: walkthru, helpwidget: helpwidget }, props)),
          children ? (0, _react.cloneElement)(children, extraProps) : undefined,
          _react2.default.createElement(_snackBarMessage2.default, _extends({}, props, { ref: 'snackBarMessage', open: props.open || false })),
          _react2.default.createElement(_downloadPopover2.default, null),
          _react2.default.createElement(_globalAlertBox2.default, null),
          upgrade.isOpen && _react2.default.createElement(_upgrade2.default, {
            dispatch: props.dispatch,
            stripePublicKey: "pk_live_3DIaCH9RC6TUHFN58h8Rr0LW",
            billing: props.billing,
            onUpgrade: this.onUpgrade,
            onClose: function onClose() {
              return props.dispatch((0, _upgradeActions.upgradeResetAndClose)());
            },
            user: props.user,
            profile: props.profile,
            header: upgradeHeader,
            errorMessage: props.billing.errorMessage,
            isProcessing: props.billing.isLoading,
            upgradeReason: upgrade.upgradeReason
          }),
          _react2.default.createElement(_beamerContainer2.default, { companyType: props.user.user.type === 'Supplier' ? 'supplier' : 'buyer', isActive: helpwidget.isNewFeaturesActive }),
          !props.user.forCC && _react2.default.createElement(_helpWidget2.default, {
            companyType: props.user.user.type,
            acctCreationReason: props.user.company.acctCreationReason
          }),
          _react2.default.createElement(_globalErrorsDisplayContainer2.default, null),
          _react2.default.createElement(_index2.default, null),
          _react2.default.createElement(_rateDocIframe2.default, null)
        )
      );
    }
  }]);

  return AppWindow;
}(_react.Component);

AppWindow.propTypes = {
  config: _react.PropTypes.object,
  user: _react.PropTypes.object,
  children: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  history: _react.PropTypes.object,
  location: _react.PropTypes.object,
  routerState: _react.PropTypes.object,
  profile: _react.PropTypes.object,
  upgrade: _react.PropTypes.object
};

var select = function select(state) {
  return {
    billing: state.billing.toJS(),
    user: state.user.toJS(),
    config: state.config.toJS(),
    connectionsStats: state.connectionsStats.toJS(),
    profile: state.profile.toJS(),
    upgrade: state.ui.upgrade.toJS(),
    helpwidget: state.ui.helpwidget.toJS(),
    walkthru: state.ui.walkthru.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(select)(AppWindow);

/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfig = getConfig;
exports.firstFrameLoad = firstFrameLoad;

var _soFetch = __webpack_require__(254);

var _configConstants = __webpack_require__(2722);

var constants = _interopRequireWildcard(_configConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getConfig() {
  return (0, _soFetch.soFetch)('/env', {
    actionType: constants.GET_CONFIG,
    responseBinding: 'config'
  });
}

function firstFrameLoad() {
  return {
    type: constants.FIRST_FRAME_LOAD
  };
}

/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIRST_FRAME_LOAD = exports.FIRST_FRAME_LOAD = 'FIRST_FRAME_LOAD';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';
var GET_CONFIG = exports.GET_CONFIG = 'GET_CONFIG';

/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hydrateStores = hydrateStores;

var _reactRouterRedux = __webpack_require__(27);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _userActions = __webpack_require__(868);

var _tagsActions = __webpack_require__(2724);

var _profileActions = __webpack_require__(546);

var _billingActions = __webpack_require__(1108);

var _connectionsStatsActions = __webpack_require__(1850);

var _settingsActions = __webpack_require__(976);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hydrateStores(dispatch) {
  var _this = this;

  dispatch((0, _userActions.getUser)()).then(function (res) {
    if (!res) return;
    if (res.user && res.user.pureDocView) return;
    [_tagsActions.getTags.bind(_this, _ramda2.default.pathOr(null, ['user', 'company', 'companyId'], res)), _profileActions.getProfile, _billingActions.getBilling, _connectionsStatsActions.refreshConnectionsStats, _settingsActions.hydrateFromServer].forEach(function (fn) {
      return dispatch(fn());
    });
  });
}

/***/ }),
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTags = getTags;
exports.deleteTag = deleteTag;

var _soFetch = __webpack_require__(254);

var _tagsConstants = __webpack_require__(2725);

var constants = _interopRequireWildcard(_tagsConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getTags(id) {
  return (0, _soFetch.soFetch)('/proxy/company/' + id + '/tags', {
    actionType: constants.GET_TAGS,
    responseBinding: 'payload'
  });
}

function deleteTag(payload) {
  return function (dispatch) {
    dispatch({ type: constants.DELETING_TAG });
    return fetch('/proxy/tags', {
      method: 'delete',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.status !== 200) throw new Error(res.status);
      return dispatch({ type: 'DELETED_TAG', payload: { tagName: payload.tagName, tadId: payload.tagId } });
    });
  };
}

/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_TAG_STARTING = exports.ADD_TAG_STARTING = 'ADD_TAG_STARTING';
var ADD_TAG = exports.ADD_TAG = 'ADD_TAG';
var REMOVE_TAG_STARTING = exports.REMOVE_TAG_STARTING = 'REMOVE_TAG_STARTING';
var REMOVE_TAG = exports.REMOVE_TAG = 'REMOVE_TAG';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';
var GET_TAGS = exports.GET_TAGS = 'GET_TAGS';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';
var DELETING_TAG = exports.DELETING_TAG = 'DELETING_TAG';
var DELETED_TAG = exports.DELETED_TAG = 'DELETED_TAG';

/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';
var REFRESH_CONNECTIONS_STATS = exports.REFRESH_CONNECTIONS_STATS = 'REFRESH_CONNECTIONS_STATS';
var REFRESH_CONNECTIONS_STATS_STARTING = exports.REFRESH_CONNECTIONS_STATS_STARTING = 'REFRESH_CONNECTIONS_STATS_STARTING';
var FILTER_CONNECTIONS = exports.FILTER_CONNECTIONS = 'FILTER_CONNECTIONS';
var ACCEPT_CONNECTION_STARTING = exports.ACCEPT_CONNECTION_STARTING = 'ACCEPT_CONNECTION_STARTING';
var IGNORE_CONNECTION_STARTING = exports.IGNORE_CONNECTION_STARTING = 'IGNORE_CONNECTION_STARTING';
var REMOVE_CONNECTION_STARTING = exports.REMOVE_CONNECTION_STARTING = 'REMOVE_CONNECTION_STARTING';
var UNDO_CONNECTION_CHANGE = exports.UNDO_CONNECTION_CHANGE = 'UNDO_CONNECTION_CHANGE';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';

/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(67);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouterRedux = __webpack_require__(27);

var _reactRedux = __webpack_require__(6);

var _navLink = __webpack_require__(1049);

var _navLink2 = _interopRequireDefault(_navLink);

var _profileLink = __webpack_require__(2728);

var _profileLink2 = _interopRequireDefault(_profileLink);

var _container = __webpack_require__(2729);

var _container2 = _interopRequireDefault(_container);

var _materialUi = __webpack_require__(3);

var _container3 = __webpack_require__(2730);

var _container4 = _interopRequireDefault(_container3);

var _walkthruActions = __webpack_require__(1222);

var _dialog = __webpack_require__(2736);

var _dialog2 = _interopRequireDefault(_dialog);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

var _getVerified = __webpack_require__(1862);

var _getVerified2 = _interopRequireDefault(_getVerified);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _functional = __webpack_require__(872);

var _hoverableMenuItem = __webpack_require__(1851);

var _hoverableMenuItem2 = _interopRequireDefault(_hoverableMenuItem);

var _subMenuItems = __webpack_require__(2749);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Dependencies

// Components


// Stores


var languageSettings = _languages2.default['en-US'];
var logoGlobeSrc = __webpack_require__(231);
var logoNameSrc = __webpack_require__(612);

var AppBar = function (_Component) {
  _inherits(AppBar, _Component);

  function AppBar(props) {
    _classCallCheck(this, AppBar);

    var _this = _possibleConstructorReturn(this, (AppBar.__proto__ || Object.getPrototypeOf(AppBar)).call(this, props));

    _this.shouldRouteToNotFound = function (pathname, user, dispatch) {
      if (user.isDummyAccount && !user.isAnAdmin) {
        // console.log(pathname, pathname !== '/notfound'
        //   , pathname.indexOf('/contracting/draft/') !== 0
        //   , pathname.indexOf('/contracting/template/') !== 0
        //   , pathname.indexOf('/contracting/contract/') !== 0
        //   , pathname.indexOf('/contracting/mass-rate-change/') !== 0);
        if (pathname !== '/notfound' && pathname.indexOf('/contracting/draft/') !== 0 && pathname.indexOf('/contracting/template/') !== 0 && pathname.indexOf('/contracting/contract/') !== 0 && pathname.indexOf('/contracting/mass-rate-change/') !== 0 && pathname.indexOf('/contracting/reports/diff/draft') !== 0) {
          dispatch((0, _reactRouterRedux.push)('/notfound'));
        }
      }
    };

    _this.state = {
      dialogTitle: '',
      profileDialogOpen: false,
      windowWidth: window.innerWidth
    };
    return _this;
  }
  /**
   * Add event listener
   */


  _createClass(AppBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          pathname = _props.location.pathname,
          dispatch = _props.dispatch,
          user = _props.user;

      window.addEventListener('resize', this.updateDimensions.bind(this));
      this.shouldRouteToNotFound(pathname, user, dispatch);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          user = _props2.user;


      if (this.props.location.pathname !== nextProps.location.pathname) {
        this.shouldRouteToNotFound(nextProps.location.pathname, user, dispatch);
      }
    }

    /**
     * Remove event listener
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions.bind(this));
    }
  }, {
    key: 'updateDimensions',
    value: function updateDimensions() {
      this.setState({ windowWidth: window.innerWidth });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          userState = _props3.user,
          contractListSearchParams = _props3.contractListSearchParams,
          templateListSearchParams = _props3.templateListSearchParams,
          contractListType = _props3.contractListType,
          AIToolsClicked = _props3.AIToolsClicked;
      var allApps = userState.allApps;

      var showMobileAppBar = this.state.windowWidth && this.state.windowWidth < 1069;
      var showOnboardingAppBar = userState.unApprovedShellAccount || showMobileAppBar || userState.isDummyAccount && !userState.isAnAdmin;
      var classes = (0, _classnames2.default)('app-bar', this.props.className, {
        'is-not-logged-in': !userState.user.userID,
        'is-on-onboarding': showOnboardingAppBar,
        'is-on-admin': window.location.hash.split('/')[2] === 'admin',
        'is-on-modal': this.state.modal
      });
      var usersAITools = _ramda2.default.intersection(allApps || [], ['bookings', 'emailAssist', 'itineraryAssist', 'stopSales']);

      var openURLInNewTab = function openURLInNewTab() {
        var url = 'https://tourconnect.ai/activate-ai-dmcs';

        if (userState.user.type === 'Supplier') {
          url = 'https://tourconnect.ai/activate-ai-operators';
        }

        var newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;

        AIToolsClicked();
      };

      var links = function () {
        if (userState.user.userID) {
          return _react2.default.createElement(
            'div',
            { style: { maxHeight: '70px' } },
            _react2.default.createElement(_profileLink2.default, _extends({
              ref: 'profileLink',
              className: 'app-bar-profile-link',
              showOnboardingAppBar: showOnboardingAppBar,
              companySlugName: (0, _functional.getIn)(['company', 'companyName'], userState)
            }, _this2.props)),
            !showMobileAppBar && _react2.default.createElement(
              'div',
              { className: 'nav-link-container' },
              _react2.default.createElement(
                'div',
                {
                  style: { display: 'flex', alignItems: 'flex-start', minWidth: '810px', height: '65px' }
                },
                _react2.default.createElement(
                  _hoverableMenuItem2.default,
                  _extends({}, _this2.props, {
                    className: 'nav-link',
                    activeRoutes: ['/workspace', '/connections'],
                    showSubMenu: true,
                    subMenuItems: (0, _subMenuItems.partnersMenu)({ push: _this2.props.push })
                  }),
                  'Partners'
                ),
                allApps && allApps.indexOf('s&m') > -1 && _react2.default.createElement(
                  _hoverableMenuItem2.default,
                  _extends({}, _this2.props, {
                    className: 'nav-link',
                    activeRoutes: ['/profile', '/partner-finder'],
                    showSubMenu: true,
                    subMenuItems: (0, _subMenuItems.salesMarketingMenu)({ push: _this2.props.push })
                  }),
                  'Sales & Marketing'
                ),
                allApps && allApps.indexOf('contracting') > -1 && _react2.default.createElement(
                  _hoverableMenuItem2.default,
                  _extends({}, _this2.props, {
                    className: 'nav-link',
                    activeRoutes: ['/contracting'],
                    routeName: '/contracting/' + (userState.user.type === 'Supplier' ? 'supplier' : 'buyer') + '-dashboard',
                    showSubMenu: true,
                    subMenuItems: userState.user.type === 'Supplier' ? (0, _subMenuItems.supplierContractingMenu)({
                      push: _this2.props.push,
                      rateTemplatesCount: userState.rateTemplatesCount,
                      contractListSearchParams: contractListSearchParams,
                      contractListType: contractListType,
                      templateListSearchParams: templateListSearchParams
                    }) : (0, _subMenuItems.buyerContractingMenu)({ push: _this2.props.push, contractListType: contractListType, contractListSearchParams: contractListSearchParams })
                  }),
                  languageSettings.Contracting
                ),
                _react2.default.createElement(
                  _navLink2.default,
                  _extends({}, _this2.props, {
                    className: 'nav-link',
                    activeRoutes: Boolean(usersAITools.length) ? ["https://app.tourconnect.com" + '/generative-ai/' + usersAITools[0]] : [],
                    onClick: Boolean(usersAITools.length) ? function () {
                      window.location = "https://app.tourconnect.com" + '/generative-ai/' + usersAITools[0] + '?jwt=' + localStorage.getItem('jwt');
                    } : function () {
                      return openURLInNewTab();
                    }
                  }),
                  'AI Tools'
                ),
                _react2.default.createElement(_container2.default, { helpwidget: _this2.props.helpwidget, walkthru: _this2.props.walkthru, openWalkThru: _this2.props.openWalkThru }),
                allApps && allApps.indexOf('s&m') > -1 && _react2.default.createElement(
                  'div',
                  { className: 'nav-link', style: { marginLeft: '1em' } },
                  _react2.default.createElement(_getVerified2.default, null)
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', flex: 1 } },
                _react2.default.createElement(_container4.default, null),
                _react2.default.createElement(
                  _wrapper2.default,
                  { hideOnSkip: true, amazonOrange: true },
                  _react2.default.createElement(_materialUi.RaisedButton, {
                    label: 'Upgrade',
                    labelStyle: { padding: '4px' },
                    secondary: true,
                    style: { lineHeight: 0 }
                  })
                )
              )
            )
          );
        }
      }();

      return _react2.default.createElement(
        'header',
        { className: classes, style: { height: '64px' } },
        _react2.default.createElement(
          'div',
          { className: 'app-bar-content' },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'tourconnect-logo', to: '/', title: 'Dashboard' },
            _react2.default.createElement('img', {
              className: 'tourconnect-logo-globe',
              src: logoGlobeSrc
            }),
            _react2.default.createElement('img', {
              className: 'tourconnect-logo-name',
              src: logoNameSrc,
              alt: 'tourconnect'
            })
          ),
          links
        ),
        _react2.default.createElement(_dialog2.default, null)
      );
    }
  }]);

  return AppBar;
}(_react.Component);

AppBar.propTypes = {
  dispatch: _react.PropTypes.func,
  location: _react.PropTypes.object,
  profile: _react.PropTypes.object,
  user: _react.PropTypes.object,
  className: _react.PropTypes.string,
  connectionsStats: _react.PropTypes.object,
  push: _react.PropTypes.func,
  contractListSearchParams: _react.PropTypes.object,
  templateListSearchParams: _react.PropTypes.object,
  contractListType: _react.PropTypes.string,
  AIToolsClicked: _react.PropTypes.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    push: function push() {
      return dispatch(_reactRouterRedux.push.apply(undefined, arguments));
    },
    openWalkThru: function openWalkThru() {
      return dispatch((0, _walkthruActions.openWalkThru)());
    },
    AIToolsClicked: function AIToolsClicked() {
      return dispatch({ type: 'AITools_Clicked' });
    }
  };
};
exports.default = (0, _reactRedux.connect)(function (_ref) {
  var contracting = _ref.contracting;
  return {
    contractListType: contracting.contractList.getIn(['list', 'listType']),
    contractListSearchParams: contracting.contractList.get('searchParams').toJS(),
    templateListSearchParams: {
      statusesFilter: contracting.templateList.get('statusesFilter').toJS(),
      showType: contracting.templateList.get('showType')
    }
  };
}, mapDispatchToProps)(AppBar);

/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userActions = __webpack_require__(868);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(27);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _docCookie = __webpack_require__(142);

var _docCookie2 = _interopRequireDefault(_docCookie);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Components


var propTypes = {
  companySlugName: _propTypes2.default.string,
  dispatch: _propTypes2.default.func,
  user: _propTypes2.default.object,
  className: _propTypes2.default.string,
  profile: _propTypes2.default.object,
  showOnboardingAppBar: _propTypes2.default.bool
};

var ProfileLink = function (_React$Component) {
  _inherits(ProfileLink, _React$Component);

  function ProfileLink() {
    _classCallCheck(this, ProfileLink);

    var _this = _possibleConstructorReturn(this, (ProfileLink.__proto__ || Object.getPrototypeOf(ProfileLink)).call(this));

    _this.togglePopover = function (e) {
      _this.setState({
        open: e ? !_this.state.open : false,
        anchorEl: e ? e.currentTarget : null
      });
    };

    _this.closePopover = function () {
      _this.setState({ open: false });
    };

    _this._handleLogOut = function () {
      var dispatch = _this.props.dispatch;

      if (_docCookie2.default.hasItem('isAnAdmin')) _docCookie2.default.removeItem('isAnAdmin', '/', window.location.host.split('.')[1] + '.com');
      var actions = [_userActions.clearStores, _userActions.logout].map(function (action) {
        return dispatch(action());
      });
      // actions[1].then(() => {
      // window.location = `${window.location.protocol}//${window.location.host}/signin`;
      // });
    };

    _this.dispatchedPush = function () {
      _this.setState({ open: false });
      _this.props.dispatch(_reactRouterRedux.push.apply(undefined, arguments));
    };

    _this.state = { open: false };
    return _this;
  }

  _createClass(ProfileLink, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var user = this.props.user;
      var allApps = user.allApps;

      var billingEnabled = user.company.billingEnabled;
      var dropdownUrls = {
        accountSettingsUrl: '/settings',
        supportUrl: 'http://support.tourconnect.com',
        communityUrl: 'https://community.tourconnect.com/session/sso',
        logOutUrl: window.location.protocol + '//' + window.location.host + '/signin',
        loginAdminUrl: window.location.protocol + '//' + window.location.host + '/admin/company-details/' + user.user.userID
      };

      var classes = (0, _classnames2.default)('profile-link', this.props.className);

      var loginAdminUrl = dropdownUrls.loginAdminUrl || '/';
      var imageUrl = user.company.profileImageUrl || '';

      var integrationAvailable = Boolean(user.user.type === 'Contractor' && user.company.tourplan);
      if (this.props.showOnboardingAppBar) return _react2.default.createElement(
        'a',
        { href: dropdownUrls.logOutUrl, onClick: this._handleLogOut, style: { float: 'right', position: 'relative', top: '24px' } },
        'Log Out'
      );
      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          'div',
          { className: 'profile-link-target', onClick: this.togglePopover },
          imageUrl ? _react2.default.createElement(_materialUi.Avatar, { style: { top: '10px', position: 'relative' }, src: imageUrl }) : _react2.default.createElement(
            _materialUi.Avatar,
            { style: { top: '10px', position: 'relative' } },
            _ramda2.default.head(user.company.companyName)
          ),
          _react2.default.createElement(_icon2.default, { className: 'profile-link-dropdown-arrow tc-icon-arrow-drop-down' })
        ),
        _react2.default.createElement(
          _materialUi.Popover,
          {
            open: this.state.open,
            anchorEl: this.state.anchorEl,
            onRequestClose: this.closePopover,
            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
            targetOrigin: { horizontal: 'right', vertical: 'top' }
          },
          allApps && allApps.indexOf('s&m') > -1 && _react2.default.createElement(_materialUi.ListItem, {
            style: { padding: '16px' },
            leftAvatar: imageUrl ? _react2.default.createElement(_materialUi.Avatar, { style: { border: '1px solid #e0e0e0' }, src: imageUrl }) : _react2.default.createElement(
              _materialUi.Avatar,
              null,
              _ramda2.default.head(user.company.companyName)
            ),
            primaryText: 'View Profile',
            onTouchTap: function onTouchTap() {
              return _this2.dispatchedPush('/profile');
            }
          }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_materialUi.Divider, null),
            integrationAvailable && _react2.default.createElement(_materialUi.ListItem, {
              desktop: true,
              style: { fontSize: '14px' },
              primaryText: 'Integration',
              onTouchTap: function onTouchTap() {
                return _this2.dispatchedPush(Object.keys(user.company.tourplan).length === 3 ? '/integration/contracts' : '/integration/authentication');
              }
            }),
            integrationAvailable && _react2.default.createElement(_materialUi.Divider, null),
            _react2.default.createElement(_materialUi.ListItem, {
              desktop: true,
              style: { fontSize: '14px' },
              primaryText: 'My Settings',
              onTouchTap: function onTouchTap() {
                return _this2.dispatchedPush('/settings/my-settings');
              }
            }),
            _react2.default.createElement(_materialUi.ListItem, {
              desktop: true,
              style: { fontSize: '14px' },
              primaryText: 'Company Settings',
              onTouchTap: function onTouchTap() {
                return _this2.dispatchedPush('/settings/company-settings');
              }
            }),
            billingEnabled && _react2.default.createElement(_materialUi.ListItem, {
              desktop: true,
              style: { fontSize: '14px' },
              primaryText: 'Billing Settings',
              onTouchTap: function onTouchTap() {
                return _this2.dispatchedPush('/settings/billing');
              }
            }),
            _react2.default.createElement(_materialUi.Divider, null),
            _react2.default.createElement(_materialUi.ListItem, {
              desktop: true,
              style: { fontSize: '14px' },
              primaryText: 'Support',
              onTouchTap: function onTouchTap() {
                return window.location = dropdownUrls.supportUrl;
              }
            }),
            _react2.default.createElement(_materialUi.ListItem, {
              desktop: true,
              style: { fontSize: '14px' },
              primaryText: 'Community',
              onTouchTap: function onTouchTap() {
                return window.location = dropdownUrls.communityUrl;
              }
            }),
            _react2.default.createElement(_materialUi.Divider, null),
            _react2.default.createElement(_materialUi.ListItem, {
              desktop: true,
              style: { fontSize: '14px' },
              primaryText: 'Log Out',
              onTouchTap: this._handleLogOut
            }),
            user.isAnAdmin && _react2.default.createElement(_materialUi.ListItem, {
              desktop: true,
              style: { fontSize: '14px' },
              primaryText: 'Back to Admin',
              onTouchTap: function onTouchTap() {
                return window.location = loginAdminUrl;
              }
            })
          )
        )
      );
    }
  }]);

  return ProfileLink;
}(_react2.default.Component);

ProfileLink.contextTypes = {
  router: _propTypes2.default.object.isRequired
};
ProfileLink.propTypes = propTypes;
exports.default = ProfileLink;

/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _chat = __webpack_require__(1216);

var _chat2 = _interopRequireDefault(_chat);

var _school = __webpack_require__(1217);

var _school2 = _interopRequireDefault(_school);

var _directions = __webpack_require__(1218);

var _directions2 = _interopRequireDefault(_directions);

var _whatshot = __webpack_require__(1219);

var _whatshot2 = _interopRequireDefault(_whatshot);

var _iconWithCounter = __webpack_require__(1453);

var _iconWithCounter2 = _interopRequireDefault(_iconWithCounter);

var _hoverableMenuItem = __webpack_require__(1851);

var _hoverableMenuItem2 = _interopRequireDefault(_hoverableMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SupportContainer = function (_Component) {
  _inherits(SupportContainer, _Component);

  function SupportContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SupportContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SupportContainer.__proto__ || Object.getPrototypeOf(SupportContainer)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      var _this$props = _this.props,
          helpwidget = _this$props.helpwidget,
          openWalkThru = _this$props.openWalkThru,
          walkthru = _this$props.walkthru;


      var menuItems = [{
        text: 'Support Articles & Videos',
        onTouchTap: function onTouchTap() {
          window.open('http://support.tourconnect.com');
        },
        icon: _react2.default.createElement(_school2.default, null)
      }, {
        text: 'Live Chat',
        onTouchTap: function onTouchTap() {
          return window.Intercom('show');
        }, // eslint-disable-line new-cap
        icon: _react2.default.createElement(_chat2.default, null)
      }, {
        text: 'New Releases!',
        onTouchTap: function onTouchTap() {
          return window.Beamer.show();
        },
        icon: _react2.default.createElement(_iconWithCounter2.default, {
          style: { top: '-4px' },
          icon: _react2.default.createElement(_whatshot2.default, { color: 'rgb(255, 0, 0)', style: { fill: 'rgb(255, 0, 0)' } }),
          count: helpwidget.newFeaturesCount
        })
      }];

      if (walkthru.isTourReady) {
        var walkthruMenuItem = {
          text: 'Features Walk Through',
          onTouchTap: openWalkThru,
          icon: _react2.default.createElement(_directions2.default, null)
        };
        menuItems.splice(2, 0, walkthruMenuItem);
      }

      return _react2.default.createElement(
        _hoverableMenuItem2.default,
        _extends({}, _this.props, {
          className: 'nav-link',
          activeRoutes: [],
          routeName: "",
          showSubMenu: true,
          subMenuItems: menuItems
        }),
        'Help & Support'
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return SupportContainer;
}(_react.Component);

exports.default = SupportContainer;

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _connections = __webpack_require__(2731);

var _connections2 = _interopRequireDefault(_connections);

var _messaging = __webpack_require__(2734);

var _messaging2 = _interopRequireDefault(_messaging);

var _Toolbar = __webpack_require__(1812);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _actions = __webpack_require__(2735);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import NewsfeedNotification from './newsfeed';


var propTypes = {
  // getNotifications: PropTypes.func,
  companyType: _react.PropTypes.string,
  unreadCount: _react.PropTypes.number,
  unseenCount: _react.PropTypes.number,
  list: _react.PropTypes.array,
  updateProps: _react.PropTypes.func,
  markAsRead: _react.PropTypes.func,
  connectionsStats: _react.PropTypes.object,
  messaging: _react.PropTypes.object,
  allApps: _react.PropTypes.array
};

var NotificationContainer = function (_React$Component) {
  _inherits(NotificationContainer, _React$Component);

  function NotificationContainer() {
    _classCallCheck(this, NotificationContainer);

    return _possibleConstructorReturn(this, (NotificationContainer.__proto__ || Object.getPrototypeOf(NotificationContainer)).apply(this, arguments));
  }

  _createClass(NotificationContainer, [{
    key: 'shouldComponentUpdate',

    // componentWillMount() {
    //   this.props.getNotifications();
    // }

    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var allApps = this.props.allApps;

      return _react2.default.createElement(
        'div',
        { style: { display: 'flex', alignItems: 'center' } },
        _react2.default.createElement(_Toolbar.ToolbarSeparator, { style: { marginLeft: '20px' } }),
        allApps.indexOf('s&m') > -1 && _react2.default.createElement(_connections2.default, null),
        _react2.default.createElement(_messaging2.default, null),
        _react2.default.createElement(_Toolbar.ToolbarSeparator, { style: { marginLeft: '8px' } })
      );
    }
  }]);

  return NotificationContainer;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var notification = _ref.notification,
      user = _ref.user;
  return _extends({}, notification.toJS(), {
    companyType: user.getIn(['user', 'type']),
    allApps: user.get('allApps')
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    // getNotifications: (...args) => dispatch(getNotificationsAction(...args)),
    updateProps: function updateProps() {
      return dispatch(_actions.updateProps.apply(undefined, arguments));
    },
    markAsRead: function markAsRead() {
      return dispatch(_actions.markAsRead.apply(undefined, arguments));
    }
  };
};
NotificationContainer.propTypes = propTypes;
NotificationContainer.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NotificationContainer);

/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(27);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _iconWithCounter = __webpack_require__(1453);

var _iconWithCounter2 = _interopRequireDefault(_iconWithCounter);

var _Avatar = __webpack_require__(1040);

var _Avatar2 = _interopRequireDefault(_Avatar);

var _FlatButton = __webpack_require__(1041);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _colors = __webpack_require__(259);

var _check = __webpack_require__(854);

var _check2 = _interopRequireDefault(_check);

var _close = __webpack_require__(547);

var _close2 = _interopRequireDefault(_close);

var _people = __webpack_require__(2732);

var _people2 = _interopRequireDefault(_people);

var _popoverList = __webpack_require__(1852);

var _popoverList2 = _interopRequireDefault(_popoverList);

var _actions = __webpack_require__(476);

var _connectionsActions = __webpack_require__(1221);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEW_SYSTEM_URL = "https://app.tourconnect.com";

var ConnectionNotification = function (_React$Component) {
  _inherits(ConnectionNotification, _React$Component);

  function ConnectionNotification() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ConnectionNotification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectionNotification.__proto__ || Object.getPrototypeOf(ConnectionNotification)).call.apply(_ref, [this].concat(args))), _this), _this.setIcon = function (item) {
      var leftIcon = function () {
        '';

        if (item.profileImageUrl) {
          return _react2.default.createElement(_Avatar2.default, { className: _this.props.classes.avatar, src: item.profileImageUrl });
        }
        return _react2.default.createElement(
          _Avatar2.default,
          { className: _this.props.classes.avatar },
          (item.otherSideName || '?')[0].toUpperCase()
        );
      }();
      return _extends({}, item, {
        leftIcon: leftIcon
      });
    }, _this.connectionAction = function (itemId, actionType) {
      return function () {
        _this.props.removeConnectionFromStatus(itemId);
        ({
          accept: function accept() {
            return _this.props.acceptConnection(itemId);
          },
          deny: function deny() {
            return _this.props.ignoreConnection(itemId);
          }
        })[actionType]();
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ConnectionNotification, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          push = _props.routerPush,
          pendingConnections = _props.pendingConnections,
          unreadAccepted = _props.unreadAccepted;

      return _react2.default.createElement(
        _popoverList2.default,
        {
          list: pendingConnections.map(function (_ref2) {
            var id = _ref2._id,
                timestamp = _ref2.created_at,
                text = _ref2.message,
                profileImageUrl = _ref2.profileImageUrl,
                otherSideName = _ref2.sender_company_name,
                senderId = _ref2.sender_id;
            return {
              id: id,
              otherSideName: otherSideName,
              firstRowAction: function firstRowAction() {
                push('/company/' + senderId);
              },
              profileImageUrl: profileImageUrl,
              text: text,
              forSort: (0, _moment2.default)(timestamp).unix(),
              timestamp: timestamp,
              itemActions: [_react2.default.createElement(_FlatButton2.default, {
                key: 'deny-' + id,
                label: 'Reject',
                labelPosition: 'after',
                backgroundColor: _colors.pinkA200,
                hoverColor: _colors.pinkA200,
                icon: _react2.default.createElement(_close2.default, { color: _colors.fullWhite, style: { width: '1.5em', height: '1.5em' } }),
                labelStyle: { fontSize: '1em', textTransform: 'none', color: 'white' },
                onTouchTap: _this2.connectionAction(id, 'deny'),
                style: {
                  lineHeight: '2em',
                  height: '2.5em',
                  marginTop: '0.5em',
                  fontSize: '0.8em',
                  marginRight: '1em'
                }
              }), _react2.default.createElement(_FlatButton2.default, {
                key: 'accept-' + id,
                label: 'Accept',
                labelPosition: 'after',
                icon: _react2.default.createElement(_check2.default, { color: _colors.fullWhite, style: { width: '1.5em', height: '1.5em' } }),
                labelStyle: { fontSize: '1em', textTransform: 'none', color: 'white' },
                onTouchTap: _this2.connectionAction(id, 'accept'),
                backgroundColor: '#008000',
                hoverColor: '#008000',
                style: {
                  lineHeight: '2em',
                  height: '2.5em',
                  marginRight: '1em',
                  marginTop: '0.5em',
                  fontSize: '0.8em'
                }
              })]
            };
          }).concat(unreadAccepted.map(function (_ref3) {
            var id = _ref3.connectionId,
                partnerId = _ref3.partnerId,
                otherSideName = _ref3.companyName,
                profileImageUrl = _ref3.profileImageUrl,
                timestamp = _ref3.timestamp;
            return {
              id: id,
              otherSideName: otherSideName,
              profileImageUrl: profileImageUrl,
              clickItem: function clickItem() {
                _this2.props.markAcceptedRead([id]);
                if (partnerId) {
                  window.location.href = NEW_SYSTEM_URL + '/partner-management/partner-details/' + partnerId + '?jwt=' + localStorage.getItem('jwt');
                } else {
                  push('/connections/connected?id=' + id);
                }
              },
              unread: true,
              text: 'Accepted your partner request.',
              forSort: (0, _moment2.default)(timestamp).unix(),
              timestamp: timestamp
            };
          })).sort(function (a, b) {
            return -a.forSort + b.forSort;
          }).slice(0, 100).map(this.setIcon),
          title: 'Partner Requests',
          bottomRightText: 'Find Partners',
          bottomRightAction: function bottomRightAction() {
            push('/partner-finder/results');
          },
          bottomLeftText: 'Partners',
          bottomLeftAction: function bottomLeftAction() {
            window.location.href = NEW_SYSTEM_URL + '/partner-management/partner-list/partner';
          },
          topRightSecondaryText: 'Clear Accepted Notifications',
          topRightSecondaryAction: unreadAccepted.length ? function () {
            return _this2.props.markAcceptedRead(unreadAccepted.map(function (obj) {
              return obj.connectionId;
            }));
          } : null
        },
        _react2.default.createElement(_iconWithCounter2.default, {
          style: { display: 'flex', marginLeft: '25px', minWidth: '50px' },
          icon: _react2.default.createElement(_people2.default, null),
          count: pendingConnections.length + unreadAccepted.length
        })
      );
    }
  }]);

  return ConnectionNotification;
}(_react2.default.Component);

ConnectionNotification.propTypes = {
  acceptConnection: _propTypes2.default.func,
  classes: _propTypes2.default.object,
  ignoreConnection: _propTypes2.default.func,
  markAcceptedRead: _propTypes2.default.func,
  pendingConnections: _propTypes2.default.array,
  removeConnectionFromStatus: _propTypes2.default.func,
  routerPush: _propTypes2.default.func,
  unreadAccepted: _propTypes2.default.array
};

var mapStateToProps = function mapStateToProps(_ref4) {
  var _ref4$workspace = _ref4.workspace,
      pendingConnections = _ref4$workspace.pendingConnections,
      unreadAccepted = _ref4$workspace.unreadAccepted;
  return {
    pendingConnections: pendingConnections,
    unreadAccepted: unreadAccepted
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  acceptConnection: _connectionsActions.acceptConnection,
  ignoreConnection: _connectionsActions.ignoreConnection,
  removeConnectionFromStatus: _actions.removeConnectionFromStatus,
  routerPush: _reactRouterRedux.push,
  markAcceptedRead: _actions.markAcceptedRead
})((0, _reactJss2.default)({
  avatar: {
    border: 'solid 1px #bbb',
    height: '40px !important',
    lineHeight: '37px',
    marginTop: '6px !important',
    textAlign: 'center',
    width: '40px !important',
    color: 'white !important'
  },
  iconStyle: {
    color: 'rgba(0, 0, 0, 0.44) !important'
  }
})(ConnectionNotification));

/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPeople = function SocialPeople(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' })
  );
};
SocialPeople = (0, _pure2.default)(SocialPeople);
SocialPeople.displayName = 'SocialPeople';
SocialPeople.muiName = 'SvgIcon';

exports.default = SocialPeople;

/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBrightness1 = function ImageBrightness1(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' })
  );
};
ImageBrightness1 = (0, _pure2.default)(ImageBrightness1);
ImageBrightness1.displayName = 'ImageBrightness1';
ImageBrightness1.muiName = 'SvgIcon';

exports.default = ImageBrightness1;

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _Avatar = __webpack_require__(1040);

var _Avatar2 = _interopRequireDefault(_Avatar);

var _forum = __webpack_require__(1853);

var _forum2 = _interopRequireDefault(_forum);

var _liveHelp = __webpack_require__(1854);

var _liveHelp2 = _interopRequireDefault(_liveHelp);

var _description = __webpack_require__(561);

var _description2 = _interopRequireDefault(_description);

var _iconWithCounter = __webpack_require__(1453);

var _iconWithCounter2 = _interopRequireDefault(_iconWithCounter);

var _actions = __webpack_require__(476);

var _popoverList = __webpack_require__(1852);

var _popoverList2 = _interopRequireDefault(_popoverList);

var _actions2 = __webpack_require__(1111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global localStorage */


var MessagingNotification = function (_React$Component) {
  _inherits(MessagingNotification, _React$Component);

  function MessagingNotification() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MessagingNotification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MessagingNotification.__proto__ || Object.getPrototypeOf(MessagingNotification)).call.apply(_ref, [this].concat(args))), _this), _this.setIcon = function (item) {
      var classes = _this.props.classes;

      var primaryIcon = function () {
        if (item.profileImageUrl) {
          return _react2.default.createElement(_Avatar2.default, {
            className: classes.avatar,
            src: item.profileImageUrl
          });
        }
        // item.connectionId === 'inbox', 'contracting' , 'general'
        return _react2.default.createElement(
          _Avatar2.default,
          { className: classes.avatar },
          (item.otherSideName || '?')[0].toUpperCase()
        );
      }();

      var secondaryIcon = ({
        contracting: function contracting() {
          return _react2.default.createElement(_description2.default, { className: classes.secondaryIcon });
        },
        general: function general() {
          return _react2.default.createElement(_forum2.default, { className: classes.secondaryIcon });
        }
      }[item.channelId] || function () {
        return _react2.default.createElement(_liveHelp2.default, { className: classes.secondaryIcon });
      })();
      return _extends({}, item, {
        leftIcon: _react2.default.createElement(
          'div',
          null,
          primaryIcon,
          _react2.default.createElement(_Avatar2.default, { className: classes.secondaryAvatar, icon: secondaryIcon })
        )
      });
    }, _this.timedUpdate = function () {
      var _this$props = _this.props,
          loading = _this$props.loading,
          getMessages = _this$props.getStatusMessages;

      if (!loading) getMessages();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MessagingNotification, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      clearInterval(this.timer);
      this.timedUpdate();
      if (!localStorage.stopAutoReload) {
        this.timer = setInterval(this.timedUpdate, 30e3);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          push = _props.routerPush,
          latestMessages = _props.latestMessages,
          newMessage = _props.openMassDialog,
          companyType = _props.companyType;

      return _react2.default.createElement(
        _popoverList2.default,
        {
          list: latestMessages.slice(0, 100).map(this.setIcon),
          title: 'Messages',
          clickItem: function clickItem(id) {
            var item = latestMessages.find(function (e) {
              return e.id === id;
            });
            if (!item) return;
            if (item.partnerId === 'inbox') {
              // unassigned inbox
              push('/workspace/inbox/' + item.id);
            } else if (item.channelId === 'contracting' && item.contractId) {
              if (item.isWs && companyType === 'Contractor') {
                push('/contracting/workspace/' + item.contractId + '/activities?latest=true');
              } else push('/contracting/contract/' + item.contractId + '/activities?latest=true');
            } else if (item.partnerId) {
              window.location = "https://app.tourconnect.com" + '/partner-management/partner-details/' + item.partnerId + '?jwt=' + localStorage.getItem('jwt');
            }
          },
          topRightText: 'New Message',
          topRightAction: newMessage,
          bottomLeftText: 'Unassigned',
          bottomLeftAction: function bottomLeftAction() {
            push('/workspace/inbox');
          }
        },
        _react2.default.createElement(_iconWithCounter2.default, {
          style: { display: 'flex', minWidth: '50px' },
          icon: _react2.default.createElement(_forum2.default, null),
          count: latestMessages.filter(function (e) {
            return e.unread;
          }).length
          // onTap={() => {
          //   push('/workspace/');
          // }}
        })
      );
    }
  }]);

  return MessagingNotification;
}(_react2.default.Component);

MessagingNotification.propTypes = {
  classes: _propTypes2.default.object,
  latestMessages: _propTypes2.default.array,
  loading: _propTypes2.default.bool,
  openMassDialog: _propTypes2.default.func,
  routerPush: _propTypes2.default.func,
  getStatusMessages: _propTypes2.default.func,
  companyType: _propTypes2.default.string
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var _ref2$workspace = _ref2.workspace,
      latestMessages = _ref2$workspace.latestMessages,
      loading = _ref2$workspace.statusMessagesLoading,
      user = _ref2.user;
  return {
    latestMessages: latestMessages,
    loading: loading,
    companyType: user.getIn(['user', 'type'])
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  getStatusMessages: _actions.getStatusMessages,
  routerPush: _reactRouterRedux.push,
  openMassDialog: _actions2.openModal
})((0, _reactJss2.default)({
  avatar: {
    border: 'solid 1px #bbb',
    color: 'white !important',
    height: '40px !important',
    lineHeight: '37px',
    marginTop: '-9px !important',
    textAlign: 'center',
    width: '40px !important'
  },
  secondaryAvatar: {
    backgroundColor: '#767779 !important',
    height: '20px !important',
    left: '25px',
    position: 'absolute',
    top: '20px',
    width: '20px !important'
  },
  secondaryIcon: {
    margin: '3px !important'
  },
  iconStyle: {
    color: 'rgba(0, 0, 0, 0.44) !important'
  }
})(MessagingNotification));

/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markAsRead = undefined;
exports.updateProps = updateProps;

var _constants = __webpack_require__(1848);

var constants = _interopRequireWildcard(_constants);

var _http = __webpack_require__(118);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

function updateProps(payload) {
  return { type: constants.UPDATE_PROPS, payload: payload };
}

// export const getNotifications = () => (dispatch, getState) => {
//   return get(`/proxy/notifications`)
//   .then(checkStatus)
//   .then(res => res.json())
//   .then(res => dispatch({ type: constants.GOT_NOTIFICATIONS, payload: res }));
// };

var markAsRead = exports.markAsRead = function markAsRead(activityIds) {
  return function (dispatch, getState) {
    dispatch({ type: constants.MARKED_READ, payload: { activityIds: activityIds } });
    return (0, _http.put)('/proxy/notifications', { activityIds: activityIds }).then(_checkStatus2.default);
  };
};

/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _materialUi = __webpack_require__(3);

var _TextField = __webpack_require__(626);

var _TextField2 = _interopRequireDefault(_TextField);

var _reactRouterRedux = __webpack_require__(27);

var _ramda = __webpack_require__(2);

var _actions = __webpack_require__(1111);

var _commentBox = __webpack_require__(1112);

var _commentBox2 = _interopRequireDefault(_commentBox);

var _reviewPartners = __webpack_require__(1856);

var _reviewPartners2 = _interopRequireDefault(_reviewPartners);

var _containerExisting = __webpack_require__(1857);

var _containerExisting2 = _interopRequireDefault(_containerExisting);

var _importFromEmail = __webpack_require__(1858);

var _importFromEmail2 = _interopRequireDefault(_importFromEmail);

var _uploadFile = __webpack_require__(1859);

var _uploadFile2 = _interopRequireDefault(_uploadFile);

var _addIndividually = __webpack_require__(1861);

var _addIndividually2 = _interopRequireDefault(_addIndividually);

var _title = __webpack_require__(2746);

var _title2 = _interopRequireDefault(_title);

var _confirmation = __webpack_require__(2748);

var _confirmation2 = _interopRequireDefault(_confirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  main: {
    //    textAlign: 'center',
  },
  largeText: {
    fontSize: '25px',
    fontWeight: 500,
    margin: 0,
    padding: '50px',
    textAlign: 'center'
  },
  dialogBody: {},
  errorExplain: {
    color: 'rgb(255, 64, 129)',
    float: 'left',
    marginLeft: '150px',
    marginTop: '-5px',
    textAlign: 'center'
  },
  inputBox: {
    height: '35px'
  }
};

var initialState = {
  addPartnersMethod: '',
  attachedFiles: [],
  currentComment: '',
  currentStep: 0,
  filteredConnections: [],
  individualCompanyName: '',
  individualEmail: '',
  partnersToSendTo: [],
  searchField: '',
  selectedExistingPartners: [],
  sendingMM: false,
  sendToPartners: false,
  showAddIndividuallyDialog: false,
  showEmailImportDialog: false,
  showSelectFromPartnersDialog: false,
  showSelectMethod: false,
  showUploadFileDialog: false,
  subject: '',
  testMessageSent: false
  //  existingConnections: [],
};

var MassMessageDialog = function (_Component) {
  _inherits(MassMessageDialog, _Component);

  function MassMessageDialog(props) {
    _classCallCheck(this, MassMessageDialog);

    var _this = _possibleConstructorReturn(this, (MassMessageDialog.__proto__ || Object.getPrototypeOf(MassMessageDialog)).call(this, props));

    _this.handleComment = function (input) {
      _this.setState({ currentComment: input });
    };

    _this.handleAttachFile = function (fileList) {
      _this.setState({ attachedFiles: fileList });
    };

    _this.confirmComment = function () {
      _this._confirmation.handleOpen();
    };

    _this.submitComment = function () {
      _this.nextStep();
      _this.props.sendMessage({
        messageSubject: _this.state.subject,
        messageText: _this.state.currentComment,
        files: _this.state.attachedFiles,
        partners: _this.state.partnersToSendTo
      });
    };

    _this.submitCommentTest = function () {
      _this.props.sendMessage({
        messageSubject: _this.state.subject,
        messageText: _this.state.currentComment,
        files: _this.state.attachedFiles,
        partners: [{
          companyName: _this.props.companyName,
          email: _this.props.userEmail
        }],
        test: true
      });
    };

    _this.handleCancel = function () {
      _this.setState({ currentComment: '', attachedFiles: [] });
    };

    _this.check = function (item) {
      switch (item.checkType) {
        case 'checkOne':
          _this.setState({ selectedExistingPartners: _this.state.selectedExistingPartners.concat([item.partner]) });
          break;
        case 'checkAll':
          var allConnections = _this.state.filteredConnections.length > 0 ? _this.state.filteredConnections : _this.props.connections;
          _this.setState({ selectedExistingPartners: [].concat(allConnections) });
          break;
        default:
          break;
      }
    };

    _this.uncheck = function (item) {
      switch (item.checkType) {
        case 'uncheckOne':
          _this.setState({ selectedExistingPartners: [].concat(_this.state.selectedExistingPartners.filter(function (e) {
              return e.companyId !== item.partner.companyId;
            })) });
          break;
        case 'uncheckAll':
          _this.setState({ selectedExistingPartners: [] });
          break;
        default:
          break;
      }
    };

    _this.state = _extends({}, initialState);
    return _this;
  }

  _createClass(MassMessageDialog, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (Array.isArray(nextProps.connections) && !(0, _ramda.equals)(nextProps.connections, this.props.connections)) {
        this.setState({ filteredConnections: nextProps.connections });
      }
      if (this.props.sending && !nextProps.sending) {
        this.setState({ testMessageSent: true });
      }
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      var step = this.state.currentStep;
      if (this.state.currentStep < 2) step++;
      this.setState({ currentStep: step });
    }
  }, {
    key: 'prevStep',
    value: function prevStep() {
      var step = this.state.currentStep;
      if (this.state.currentStep === 1) step--;
      this.setState({ currentStep: step });
    }
  }, {
    key: 'closeMe',
    value: function closeMe() {
      var _this2 = this;

      this.setState(_extends({}, initialState), function () {
        _this2.props.closeMassDialog();
      });
    }
  }, {
    key: '_updateValue',
    value: function _updateValue(type) {
      this.setState(_defineProperty({}, type, this.refs[type].getValue()));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          isItOpen = _props.isItOpen,
          classes = _props.classes,
          userType = _props.userType;

      var actionItems = [{
        text: 'Select from connections',
        icon: 'tc-icon-user',
        func: function func() {
          return _this3.setState({
            addPartnersMethod: 'fromConnections',
            showSelectFromPartnersDialog: true
          });
        }
      }, {
        text: 'Import from email',
        icon: 'tc-icon-email',
        func: function func() {
          return _this3.setState({
            addPartnersMethod: 'emailImport',
            showEmailImportDialog: true
          });
        }
      }, {
        text: 'Upload a file',
        icon: 'tc-icon-insert-drive-file',
        func: function func() {
          return _this3.setState({
            addPartnersMethod: 'uploadFile',
            showUploadFileDialog: true
          });
        }
      }, {
        text: 'Add individually',
        icon: 'add-circle-icon',
        func: function func() {
          return _this3.setState({
            addPartnersMethod: 'addIndividually',
            showAddIndividuallyDialog: true
          });
        }
      }];
      var sharedProps = {
        updateMMPartnerProp: function updateMMPartnerProp(newState) {
          // unselect all connection if some kind of filter is applied
          // if (!equals(newState.filteredConnections, this.state.filteredConnections)) this.setState({ selectedExistingPartners: [] });
          _this3.setState(newState);
        },
        MMPartnerReducer2: _extends({}, this.state, {
          existingConnections: this.props.connections || [],
          check: function check(item) {
            _this3.check(item);
          },
          uncheck: function uncheck(item) {
            _this3.uncheck(item);
          }
        })
      };
      var getSelectedMethod = function getSelectedMethod() {
        switch (_this3.state.addPartnersMethod) {
          case 'fromConnections':
            return _react2.default.createElement(_containerExisting2.default, sharedProps);
          case 'emailImport':
            return _react2.default.createElement(_importFromEmail2.default, sharedProps);
          case 'uploadFile':
            return _react2.default.createElement(_uploadFile2.default, sharedProps);
          case 'addIndividually':
            return _react2.default.createElement(_addIndividually2.default, sharedProps);
          default:
            return _react2.default.createElement('span', null);
        }
      };
      var maxAllowed = {
        'basic': 20
      }[this.props.companyPlan] || 200;
      var dialogActions = [[_react2.default.createElement(
        'div',
        null,
        this.state.partnersToSendTo.length > maxAllowed ? _react2.default.createElement(
          'div',
          { className: classes.errorExplain },
          'You have selected too many partners (',
          this.state.partnersToSendTo.length,
          ' of ',
          maxAllowed,
          ' max).',
          _react2.default.createElement('br', null),
          'Please delete some to continue.'
        ) : undefined,
        _react2.default.createElement(_materialUi.FlatButton, {
          key: 1,
          label: 'Cancel',
          disableTouchRipple: true,
          primary: true,
          onClick: function onClick() {
            _this3.closeMe();
          }
        }),
        _react2.default.createElement(_materialUi.FlatButton, {
          key: 2,
          label: 'Next',
          disableTouchRipple: true,
          secondary: true,
          onClick: function onClick() {
            _this3.nextStep();
          },
          disabled: this.state.partnersToSendTo.length < 1 || this.state.partnersToSendTo.length > maxAllowed
        })
      )], [_react2.default.createElement(_materialUi.FlatButton, {
        label: this.props.sending ? 'Sending' : this.state.testMessageSent ? 'Sent' : 'Send Test Email',
        style: { float: 'left' },
        disableTouchRipple: true,
        disabled: this.props.sending || this.state.currentComment.trim().length + this.state.attachedFiles.length < 1,
        onClick: function onClick() {
          _this3.submitCommentTest();
        },
        secondary: true,
        key: 3
      }), _react2.default.createElement(_materialUi.FlatButton, {
        key: 1,
        label: 'Back',
        disableTouchRipple: true,
        primary: true,
        onClick: function onClick() {
          _this3.prevStep();
        }
      }), _react2.default.createElement(_materialUi.FlatButton, {
        key: 2,
        label: 'Send Message',
        disableTouchRipple: true,
        secondary: true,
        disabled: this.state.currentComment.trim().length + this.state.attachedFiles.length < 1,
        onClick: function onClick() {
          _this3.confirmComment();
        }
      })], [_react2.default.createElement(_materialUi.FlatButton, {
        key: 2,
        label: 'Ok',
        disableTouchRipple: true,
        secondary: true,
        disabled: this.props.sending,
        onClick: function onClick() {
          _this3.closeMe();
          // redirect to the workspace/message page
          if (_this3.props.lastCreatedMessage) {
            _this3.props.routerPush('/workspace/bulkmessages/' + _this3.props.lastCreatedMessage);
          } else if (_this3.props.singleRecipient) {
            _this3.props.routerPush('/workspace/' + _this3.props.singleRecipient + '/general');
          }
        }
      })]];
      var isSupplier = userType === 'Supplier';
      var content = [_react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          this.state.addPartnersMethod !== '' ? getSelectedMethod() : _react2.default.createElement('span', null),
          _react2.default.createElement(_reviewPartners2.default, _extends({
            actionItems: actionItems,
            isSupplier: isSupplier,
            showActions: false
          }, sharedProps))
        )
      ), _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_TextField2.default, {
          hintText: 'Enter subject here...',
          ref: 'subject',
          onChange: this._updateValue.bind(this, 'subject'),
          fullWidth: true,
          className: classes.inputBox,
          underlineShow: false,
          hintStyle: { marginLeft: '10px' },
          inputStyle: {
            border: '1px solid #bfbfbf',
            bottom: '-10px',
            height: '28px',
            paddingLeft: '10px'
          }
        }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_commentBox2.default, {
          comment: this.state.currentComment,
          handleInput: this.handleComment,
          attachFile: this.handleAttachFile,
          attachedFiles: this.state.attachedFiles,
          submitComment: this.submitComment,
          cancelComment: this.handleCancel,
          disableSend: false,
          hintText: 'Enter message body here...',
          hideActions: true
        })
      ), _react2.default.createElement(
        'h2',
        { className: classes.largeText },
        this.props.sending ? _react2.default.createElement(
          'div',
          { style: { marginTop: '20px', display: 'block', textAlign: 'center' } },
          _react2.default.createElement(_materialUi.CircularProgress, null),
          _react2.default.createElement('br', null),
          'Sending Message'
        ) : _react2.default.createElement('span', null),
        !this.props.sending && this.props.sendingError ? _react2.default.createElement(
          'span',
          null,
          'Unable to send message'
        ) : _react2.default.createElement('span', null),
        !this.props.sending && !this.props.sendingError ? _react2.default.createElement(
          'span',
          null,
          'Message Sent !'
        ) : _react2.default.createElement('span', null)
      )];
      return _react2.default.createElement(
        _materialUi.Dialog
        // className="form-dialog"
        // ref="contractingErrorDialog"
        ,
        { open: isItOpen,
          onRequestClose: function onRequestClose() {
            _this3.closeMe();
          },
          title: _react2.default.createElement(_title2.default, { currentStep: this.state.currentStep }),
          actions: dialogActions[this.state.currentStep]
          // bodyStyle={{ padding: '24px 12px' }}
          // contentStyle={{ maxWidth: '500px' }}
        },
        _react2.default.createElement(
          'div',
          { className: classes.main },
          _react2.default.createElement(
            'div',
            { className: classes.dialogBody },
            content[this.state.currentStep]
          )
        ),
        _react2.default.createElement(_confirmation2.default, {
          ref: function ref(confirmation) {
            _this3._confirmation = confirmation;
          },
          handleConfirm: function handleConfirm() {
            _this3.submitComment();
          },
          howMany: this.state.partnersToSendTo.length
        })
      );
    }
  }]);

  return MassMessageDialog;
}(_react.Component);

MassMessageDialog.propTypes = {
  classes: _react.PropTypes.object,
  closeMassDialog: _react.PropTypes.func,
  companyName: _react.PropTypes.string,
  companyPlan: _react.PropTypes.string,
  connections: _react.PropTypes.array,
  isItOpen: _react.PropTypes.bool,
  lastCreatedMessage: _react.PropTypes.string,
  routerPush: _react.PropTypes.func,
  sending: _react.PropTypes.bool,
  sendingError: _react.PropTypes.bool,
  sendMessage: _react.PropTypes.func,
  singleRecipient: _react.PropTypes.string,
  userEmail: _react.PropTypes.string,
  userType: _react.PropTypes.string
};

var mapStateToProps = function mapStateToProps(_ref) {
  var massmessaging = _ref.massmessaging,
      user = _ref.user;
  return {
    companyName: user.getIn(['company', 'companyName']),
    companyPlan: user.getIn(['company', 'plan']),
    connections: massmessaging.connections,
    isItOpen: massmessaging.dialogOpen,
    lastCreatedMessage: massmessaging.lastCreatedMessage,
    sending: massmessaging.messageCreating,
    sendingError: massmessaging.messageCreateError,
    singleRecipient: massmessaging.singleRecipient,
    userEmail: user.getIn(['user', 'email']),
    userType: user.getIn(['user', 'type'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  closeMassDialog: _actions.closeModal,
  sendMessage: _actions.sendMessage,
  routerPush: _reactRouterRedux.push
})((0, _reactJss2.default)(styles)(MassMessageDialog));

/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileAttachment = function FileAttachment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z' })
  );
};
FileAttachment = (0, _pure2.default)(FileAttachment);
FileAttachment.displayName = 'FileAttachment';
FileAttachment.muiName = 'SvgIcon';

exports.default = FileAttachment;

/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MMQuery = exports.MMQuery = 'query getMM ($vieweeCompanyId: ID!) {\n  companyProfile  (id: $vieweeCompanyId) {\n    media {\n      url\n      mediaType\n      created_at\n      name\n      size\n      storageProvider\n      username\n      password\n      tags\n    }\n    locations {\n      name\n      id\n      products {\n        id\n        name\n      }\n    }\n  }\n}'.replace(/ +(?= )/g, '');

var editMMMutation = exports.editMMMutation = 'mutation editCompany($companyId: ID!, $update: CompanyInputType, $companyType: String!) {\n  editCompany (companyId: $companyId, update: $update, companyType: $companyType) {\n    isMarketingReady\n    isLocationMarketingReady\n  }\n}'.replace(/ +(?= )/g, '');

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function Search(props) {
  var updateMMPartnerProp = props.updateMMPartnerProp;

  var MMPartnerReducer = (0, _ramda.isEmpty)(props.MMPartnerReducer2) ? props.MMPartnerReducer : props.MMPartnerReducer2; // fallback to reducer
  return _react2.default.createElement(
    'div',
    { style: { width: '100%', borderBottom: '1px solid #e0e0e0', marginTop: '-10px' } },
    _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-search', color: 'rgba(0,0,0,0.5)', style: { top: '5px', margin: '0 2% 0 7.5%' } }),
    _react2.default.createElement(_materialUi.TextField, {
      underlineShow: false,
      inputStyle: { fontSize: '14px', whiteSpace: 'pre-wrap', padding: '0px 3px' },
      value: MMPartnerReducer.searchField,
      onChange: function onChange(_ref) {
        var value = _ref.target.value;

        updateMMPartnerProp({
          searchField: value,
          filteredConnections: MMPartnerReducer.existingConnections.filter(function (connection) {
            if (connection.companyName && (0, _ramda.contains)(value.toLowerCase(), connection.companyName.toLowerCase()) || connection.email && connection.email !== 'via TourConnect' && (0, _ramda.contains)(value.toLowerCase(), connection.email.toLowerCase())) {
              return connection;
            }
          }),
          partnersToSendTo: []
        });
      },
      onKeyDown: function onKeyDown(e) {
        return e.which === 13 || e.which === 9 ? e.preventDefault() : undefined;
      },
      hintText: 'Search company name or email',
      hintStyle: { marginLeft: '3px' }
    })
  );
};

Search.propTypes = {
  updateMMPartnerProp: _react.PropTypes.func,
  MMPartnerReducer: _react.PropTypes.object,
  MMPartnerReducer2: _react.PropTypes.object
};

Search.defaultProps = {
  MMPartnerReducer2: {}
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var marketingMaterials = _ref2.marketingMaterials;
  return {
    MMPartnerReducer: marketingMaterials.partnerReducer.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Search);

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _actions = __webpack_require__(1115);

var _profileImage = __webpack_require__(548);

var _profileImage2 = _interopRequireDefault(_profileImage);

var _pagination = __webpack_require__(870);

var _pagination2 = _interopRequireDefault(_pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var TableContainer = function (_React$Component) {
  _inherits(TableContainer, _React$Component);

  function TableContainer(props) {
    _classCallCheck(this, TableContainer);

    var _this = _possibleConstructorReturn(this, (TableContainer.__proto__ || Object.getPrototypeOf(TableContainer)).call(this, props));

    _this.switchPage = function (newPage) {
      _this.setState({ currentPage: newPage });
    };

    _this.state = {
      currentPage: 1,
      filteredConnections: [],
      existingConnections: [],
      selectedExistingPartners: [],
      searchField: ''
    };
    return _this;
  }

  _createClass(TableContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // workaround the component not getting prop upates because being in the background
      this.componentWillReceiveProps(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // sync stated objects (there are two possible sources)
      var _ref = (0, _ramda.isEmpty)(nextProps.MMPartnerReducer2) ? nextProps.MMPartnerReducer : nextProps.MMPartnerReducer2,
          filteredConnections = _ref.filteredConnections,
          existingConnections = _ref.existingConnections,
          selectedExistingPartners = _ref.selectedExistingPartners,
          searchField = _ref.searchField; // fallback to reducer

      if (!(0, _ramda.equals)(this.state.filteredConnections, filteredConnections)) {
        this.setState({ filteredConnections: filteredConnections, currentPage: 1 });
      }
      if (!(0, _ramda.equals)(this.state.existingConnections, existingConnections)) {
        this.setState({ existingConnections: existingConnections, currentPage: 1 });
      }
      if (!(0, _ramda.equals)(this.state.selectedExistingPartners, selectedExistingPartners)) {
        this.setState({ selectedExistingPartners: selectedExistingPartners });
      }
      if (!(0, _ramda.equals)(this.state.searchField, searchField)) {
        this.setState({ searchField: searchField });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _ramda.equals)(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var check = (0, _ramda.isEmpty)(this.props.MMPartnerReducer2) ? this.props.check : this.props.MMPartnerReducer2.check; // fallback to reducer
      var uncheck = (0, _ramda.isEmpty)(this.props.MMPartnerReducer2) ? this.props.uncheck : this.props.MMPartnerReducer2.uncheck; // fallback to reducer
      var _state = this.state,
          selectedExistingPartners = _state.selectedExistingPartners,
          currentPage = _state.currentPage,
          filteredConnections = _state.filteredConnections,
          searchField = _state.searchField,
          existingConnections = _state.existingConnections;


      var selectAllCheck = (0, _ramda.not)(isNilOrEmpty(filteredConnections)) ? (0, _ramda.equals)(selectedExistingPartners.length, filteredConnections.length) : (0, _ramda.equals)(selectedExistingPartners.length, existingConnections.length);

      var rows = (0, _ramda.not)(isNilOrEmpty(filteredConnections)) || (0, _ramda.not)(isNilOrEmpty(searchField)) ? filteredConnections : existingConnections;
      return _react2.default.createElement(
        _materialUi.Table,
        { multiSelectable: true, style: { borderBottom: '1px solid #e0e0e0' }, selectable: false },
        _react2.default.createElement(
          _materialUi.TableHeader,
          { displaySelectAll: false, adjustForCheckbox: false },
          _react2.default.createElement(
            _materialUi.TableRow,
            null,
            _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              { style: { width: '30px' } },
              _react2.default.createElement(_materialUi.Checkbox, {
                onCheck: (0, _ramda.ifElse)(function () {
                  return selectAllCheck;
                }, function () {
                  return uncheck({ checkType: 'uncheckAll' });
                }, function () {
                  return check({ checkType: 'checkAll' });
                }),
                checked: selectAllCheck
              })
            ),
            _react2.default.createElement(_materialUi.TableHeaderColumn, { style: { width: '80px' } }),
            _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              null,
              'Company Name'
            ),
            _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              null,
              'Email'
            )
          )
        ),
        _react2.default.createElement(
          _materialUi.TableBody,
          { displayRowCheckbox: false },
          rows.slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5).map(function (partner, i) {
            return _react2.default.createElement(
              _materialUi.TableRow,
              { key: i, style: { height: '32px' } },
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                { style: { width: '30px' } },
                _react2.default.createElement(_materialUi.Checkbox, {
                  onCheck: (0, _ramda.ifElse)(function () {
                    return (0, _ramda.contains)(partner, selectedExistingPartners);
                  }, function () {
                    return uncheck({ checkType: 'uncheckOne', partner: partner });
                  }, function () {
                    return check({ checkType: 'checkOne', partner: partner });
                  }),
                  checked: (0, _ramda.contains)(partner, selectedExistingPartners)
                })
              ),
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                { style: { height: '32px', fontSize: '14px', width: '80px' } },
                _react2.default.createElement(_profileImage2.default, {
                  className: 'profile-link-image connections-profile-link-image',
                  companySlugName: partner.companyName,
                  email: partner.email,
                  imageUrl: partner.profileImageUrl
                })
              ),
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                { style: { height: '32px', fontSize: '14px' } },
                partner.companyName
              ),
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                { style: { height: '32px', fontSize: '14px' } },
                partner.email
              )
            );
          }),
          _react2.default.createElement(
            _materialUi.TableRow,
            { selectable: false },
            _react2.default.createElement(
              _materialUi.TableRowColumn,
              { colSpan: 4 },
              rows.length > 5 ? _react2.default.createElement(_pagination2.default, {
                currentPage: currentPage,
                totalPages: Math.ceil(rows.length / 5),
                goToPage: this.switchPage,
                noOfPagesToShow: 5
              }) : undefined
            )
          )
        )
      );
    }
  }]);

  return TableContainer;
}(_react2.default.Component);

TableContainer.propTypes = {
  MMPartnerReducer: _react.PropTypes.object,
  MMPartnerReducer2: _react.PropTypes.object,
  check: _react.PropTypes.func,
  uncheck: _react.PropTypes.func,
  check2: _react.PropTypes.func,
  uncheck2: _react.PropTypes.func
};

TableContainer.defaultProps = {
  MMPartnerReducer2: {}
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    check: function check() {
      return dispatch(_actions.checkConnection.apply(undefined, arguments));
    },
    uncheck: function uncheck() {
      return dispatch(_actions.uncheckConnection.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var marketingMaterials = _ref2.marketingMaterials;
  return {
    MMPartnerReducer: marketingMaterials.partnerReducer.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TableContainer);

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactAsyncScriptLoader = __webpack_require__(1457);

var _reactAsyncScriptLoader2 = _interopRequireDefault(_reactAsyncScriptLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CloudSponge = function (_Component) {
  _inherits(CloudSponge, _Component);

  function CloudSponge() {
    _classCallCheck(this, CloudSponge);

    return _possibleConstructorReturn(this, (CloudSponge.__proto__ || Object.getPrototypeOf(CloudSponge)).apply(this, arguments));
  }

  _createClass(CloudSponge, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          isScriptLoaded = _props.isScriptLoaded,
          isScriptLoadSucceed = _props.isScriptLoadSucceed;

      if (isScriptLoaded && isScriptLoadSucceed) {
        this.onScriptLoaded();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var isScriptLoaded = _ref.isScriptLoaded,
          isScriptLoadSucceed = _ref.isScriptLoadSucceed;

      if (isScriptLoaded && !this.props.isScriptLoaded) {
        // load finished
        if (isScriptLoadSucceed) {
          this.onScriptLoaded();
        } else {
          this.onScriptError();
        }
      }
    }
  }, {
    key: 'onScriptError',
    value: function onScriptError() {
      console.error('There was an issue loading the script'); // eslint-disable-line no-console
    }
  }, {
    key: 'onScriptLoaded',
    value: function onScriptLoaded() {
      var _props2 = this.props,
          browserContactCacheMin = _props2.browserContactCacheMin,
          css = _props2.css,
          csvProviders = _props2.csvProviders,
          displaySelectAllNone = _props2.displaySelectAllNone,
          filter = _props2.filter,
          ignoreMultipleEmails = _props2.ignoreMultipleEmails,
          include = _props2.include,
          initiallySelectedContacts = _props2.initiallySelectedContacts,
          inlineOauth = _props2.inlineOauth,
          lazyLoad = _props2.lazyLoad,
          locale = _props2.locale,
          localeData = _props2.localeData,
          onlyGroupedContacts = _props2.onlyGroupedContacts,
          rootNodeSelector = _props2.rootNodeSelector,
          selectAccount = _props2.selectAccount,
          selectionLimit = _props2.selectionLimit,
          selectionLimitMessage = _props2.selectionLimitMessage,
          skipSourceMenu = _props2.skipSourceMenu,
          sources = _props2.sources,
          zIndex = _props2.zIndex,
          afterInit = _props2.afterInit,
          beforeLaunch = _props2.beforeLaunch,
          afterLaunch = _props2.afterLaunch,
          beforeImport = _props2.beforeImport,
          afterImport = _props2.afterImport,
          beforeDisplayContacts = _props2.beforeDisplayContacts,
          afterSubmitContacts = _props2.afterSubmitContacts,
          beforeClosing = _props2.beforeClosing,
          afterClosing = _props2.afterClosing,
          webhook = _props2.webhook;

      // this is where you can configure the behavior and style of the widget
      // http://www.cloudsponge.com/developer/#the-contact-importer-widget

      window.cloudsponge.init({
        browserContactCacheMin: browserContactCacheMin,
        css: css,
        csvProviders: csvProviders,
        displaySelectAllNone: displaySelectAllNone,
        filter: filter,
        ignoreMultipleEmails: ignoreMultipleEmails,
        include: include,
        initiallySelectedContacts: initiallySelectedContacts,
        inlineOauth: inlineOauth,
        lazyLoad: lazyLoad,
        locale: locale,
        localeData: localeData,
        onlyGroupedContacts: onlyGroupedContacts,
        rootNodeSelector: rootNodeSelector,
        selectAccount: selectAccount,
        selectionLimit: selectionLimit,
        selectionLimitMessage: selectionLimitMessage,
        skipSourceMenu: skipSourceMenu,
        sources: sources,
        zIndex: zIndex,
        afterInit: afterInit,
        beforeLaunch: beforeLaunch,
        afterLaunch: afterLaunch,
        beforeImport: beforeImport,
        afterImport: afterImport,
        beforeDisplayContacts: beforeDisplayContacts,
        afterSubmitContacts: afterSubmitContacts,
        beforeClosing: beforeClosing,
        afterClosing: afterClosing,
        webhooks: { afterSubmitContacts: webhook }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          childStyle = _props3.childStyle,
          style = _props3.style;


      if (!children) return _react2.default.createElement(
        'a',
        { className: 'cloudsponge-launch' },
        'Add from Address Book'
      );

      var nestedChildren = _react.Children.map(children, function (child, key) {
        return _react2.default.createElement(
          'li',
          { style: childStyle },
          (0, _react.cloneElement)(child, { key: key,
            className: 'cloudsponge-launch',
            'data-cloudsponge-source': child.props.source
          })
        );
      });

      return _react2.default.createElement(
        'ul',
        { style: style },
        nestedChildren
      );
    }
  }]);

  return CloudSponge;
}(_react.Component);

CloudSponge.defaultProps = {
  browserContactCacheMin: 0,
  css: null,
  csvProviders: {},
  displaySelectAllNone: true,
  ignoreMultipleEmails: false,
  include: ['name', 'email'],
  initiallySelectedContacts: false,
  inlineOauth: true,
  lazyLoad: false,
  onlyGroupedContacts: false,
  rootNodeSelector: 'body',
  selectAccount: false,
  skipSourceMenu: false,
  sources: ['gmail', 'yahoo', 'windowslive', 'aol'],
  zIndex: 90000,
  afterInit: function afterInit() {},
  beforeLaunch: function beforeLaunch() {},
  afterLaunch: function afterLaunch() {},
  beforeImport: function beforeImport() {},
  afterImport: function afterImport() {},
  beforeDisplayContacts: function beforeDisplayContacts() {},
  afterSubmitContacts: function afterSubmitContacts() {},
  beforeClosing: function beforeClosing() {},
  afterClosing: function afterClosing() {}
};


CloudSponge.propTypes = {
  /* Component Props */
  children: _react.PropTypes.node,
  childStyle: _react.PropTypes.object,
  style: _react.PropTypes.object,
  /* CloudSponge Props */
  browserContactCacheMin: _react.PropTypes.number,
  css: _react.PropTypes.string,
  csvProviders: _react.PropTypes.object,
  displaySelectAllNone: _react.PropTypes.bool,
  filter: _react.PropTypes.func,
  ignoreMultipleEmails: _react.PropTypes.bool,
  include: _react.PropTypes.array,
  initiallySelectedContacts: _react.PropTypes.bool,
  inlineOauth: _react.PropTypes.bool,
  lazyLoad: _react.PropTypes.bool,
  locale: _react.PropTypes.string,
  localeData: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
  onlyGroupedContacts: _react.PropTypes.bool,
  rootNodeSelector: _react.PropTypes.string,
  selectAccount: _react.PropTypes.bool,
  selectionLimit: _react.PropTypes.number,
  selectionLimitMessage: _react.PropTypes.string,
  skipSourceMenu: _react.PropTypes.bool,
  sources: _react.PropTypes.array,
  webhook: _react.PropTypes.string,
  zIndex: _react.PropTypes.number,
  /* CloudSponge Callbacks  */
  afterInit: _react.PropTypes.func,
  beforeLaunch: _react.PropTypes.func,
  afterLaunch: _react.PropTypes.func,
  beforeImport: _react.PropTypes.func,
  afterImport: _react.PropTypes.func,
  beforeDisplayContacts: _react.PropTypes.func,
  afterSubmitContacts: _react.PropTypes.func,
  beforeClosing: _react.PropTypes.func,
  afterClosing: _react.PropTypes.func,
  /* ScriptLoader Props */
  isScriptLoaded: _react.PropTypes.bool,
  isScriptLoadSucceed: _react.PropTypes.bool
};

exports.default = (0, _reactAsyncScriptLoader2.default)('https://api.cloudsponge.com/widget/7bbd90a8ef013f3a46ca29f6e764c708a2327446.js')(CloudSponge);

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isDefined = exports.isDefined = function isDefined(val) {
  return val != null;
};
var isFunction = exports.isFunction = function isFunction(val) {
  return typeof val === 'function';
};
var noop = exports.noop = function noop(_) {};

var newScript = exports.newScript = function newScript(src) {
  return function (cb) {
    var script = document.createElement('script');
    script.src = src;
    script.addEventListener('load', function () {
      return cb(null, src);
    });
    script.addEventListener('error', function () {
      return cb(true, src);
    });
    document.body.appendChild(script);
    return script;
  };
};

var keyIterator = function keyIterator(cols) {
  var keys = Object.keys(cols);
  var i = -1;
  return {
    next: function next() {
      i++; // inc
      if (i >= keys.length) return null;else return keys[i];
    }
  };
};

// tasks should be a collection of thunk
var parallel = exports.parallel = function parallel() {
  for (var _len = arguments.length, tasks = Array(_len), _key = 0; _key < _len; _key++) {
    tasks[_key] = arguments[_key];
  }

  return function (each) {
    return function (cb) {
      var hasError = false;
      var successed = 0;
      var ret = [];
      tasks = tasks.filter(isFunction);

      if (tasks.length <= 0) cb(null);else {
        tasks.forEach(function (task, i) {
          var thunk = task;
          thunk(function (err) {
            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            if (err) hasError = true;else {
              // collect result
              if (args.length <= 1) args = args[0];

              ret[i] = args;
              successed++;
            }

            if (isFunction(each)) each.call(null, err, args, i);

            if (hasError) cb(true);else if (tasks.length === successed) {
              cb(null, ret);
            }
          });
        });
      }
    };
  };
};

// tasks should be a collection of thunk
var series = exports.series = function series() {
  for (var _len3 = arguments.length, tasks = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    tasks[_key3] = arguments[_key3];
  }

  return function (each) {
    return function (cb) {
      tasks = tasks.filter(function (val) {
        return val != null;
      });
      var nextKey = keyIterator(tasks);
      var nextThunk = function nextThunk() {
        var key = nextKey.next();
        var thunk = tasks[key];
        if (Array.isArray(thunk)) thunk = parallel.apply(null, thunk).call(null, each);
        return [+key, thunk]; // convert `key` to number
      };
      var key = void 0,
          thunk = void 0;
      var next = nextThunk();
      key = next[0];
      thunk = next[1];
      if (thunk == null) return cb(null);

      var ret = [];
      var iterator = function iterator() {
        thunk(function (err) {
          for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
            args[_key4 - 1] = arguments[_key4];
          }

          if (args.length <= 1) args = args[0];
          if (isFunction(each)) each.call(null, err, args, key);

          if (err) cb(err);else {
            // collect result
            ret.push(args);

            next = nextThunk();
            key = next[0];
            thunk = next[1];
            if (thunk == null) return cb(null, ret); // finished
            else iterator();
          }
        });
      };
      iterator();
    };
  };
};

/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _dropzone = __webpack_require__(2744);

var _dropzone2 = _interopRequireDefault(_dropzone);

var _failedSection = __webpack_require__(2745);

var _failedSection2 = _interopRequireDefault(_failedSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isEmpty, _ramda.isNil);

var UploadModal = function (_Component) {
  _inherits(UploadModal, _Component);

  function UploadModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UploadModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UploadModal.__proto__ || Object.getPrototypeOf(UploadModal)).call.apply(_ref, [this].concat(args))), _this), _this.onDrop = function (file) {
      return _this.props.onDrop(file);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UploadModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var actions = this.props.showFailedSection && (0, _ramda.not)(isNilOrEmpty(this.props.failedRows)) ? [_react2.default.createElement(_materialUi.FlatButton, {
        label: 'Fix Errors and Resubmit',
        primary: true,
        onTouchTap: function onTouchTap() {
          _this2.props.onRequestClose();
          _this2.props.additFixErrorsFunc();
        }
      }), _react2.default.createElement(_materialUi.FlatButton, {
        label: 'Proceed with uploading ' + this.props.numOfSuccessfulRows,
        secondary: true,
        onTouchTap: function onTouchTap() {
          _this2.props.onCompleteFunc();
          _this2.props.onRequestClose();
        }
      })] : [_react2.default.createElement(_materialUi.FlatButton, {
        'data-cy': 'uploadCSVCancel',
        label: 'Cancel',
        secondary: true,
        onTouchTap: function onTouchTap() {
          return _this2.props.onRequestClose();
        },
        disabled: this.props.processing
      })];
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          className: 'form-dialog',
          title: this.props.showFailedSection && (0, _ramda.not)(isNilOrEmpty(this.props.failedRows)) ? this.props.dialogTitle + ' - Error' : this.props.dialogTitle,
          ref: 'uploadModal',
          autoScrollBodyContent: true,
          open: this.props.open,
          actions: actions,
          onRequestClose: function onRequestClose() {
            return _this2.props.onRequestClose();
          }
        },
        this.props.showFailedSection && (0, _ramda.not)(isNilOrEmpty(this.props.failedRows)) ? _react2.default.createElement(_failedSection2.default, {
          failedRows: this.props.failedRows,
          numOfSuccessfulRows: this.props.numOfSuccessfulRows
        }) : _react2.default.createElement(
          'div',
          null,
          this.props.processing ? _react2.default.createElement(
            'div',
            { style: { display: 'block', textAlign: 'center' } },
            _react2.default.createElement(_materialUi.CircularProgress, null),
            _react2.default.createElement('br', null),
            'Please wait. Upload in progress.'
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { style: { display: 'inline' } },
              this.props.note
            ),
            this.props.CSVHeaderMismatch ? _react2.default.createElement(
              'div',
              { style: { color: 'red', marginTop: '7px' } },
              'Your columns do not appear to be in the right order. Please correct this and re-upload.'
            ) : _react2.default.createElement('span', null),
            _react2.default.createElement(_dropzone2.default, {
              onDrop: this.onDrop,
              dropzoneText: this.props.dropzoneText
            })
          )
        )
      );
    }
  }]);

  return UploadModal;
}(_react.Component);

UploadModal.propTypes = {
  dialogTitle: _react.PropTypes.string,
  onDrop: _react.PropTypes.func,
  open: _react.PropTypes.bool,
  onRequestClose: _react.PropTypes.func,
  dropzoneText: _react.PropTypes.string,
  note: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
  showFailedSection: _react.PropTypes.bool,
  failedRows: _react.PropTypes.array,
  numOfSuccessfulRows: _react.PropTypes.number,
  onCompleteFunc: _react.PropTypes.func,
  CSVHeaderMismatch: _react.PropTypes.bool,
  processing: _react.PropTypes.bool,
  additFixErrorsFunc: _react.PropTypes.func
};

exports.default = UploadModal;

/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dropzone = __webpack_require__(869);

var _dropzone2 = _interopRequireDefault(_dropzone);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropzoneContainer = function DropzoneContainer(props) {
  var onDrop = props.onDrop,
      dropzoneText = props.dropzoneText;


  return _react2.default.createElement(
    _dropzone2.default,
    {
      onDrop: onDrop,
      style: {
        height: '200px',
        border: '4px dashed #efefef',
        position: 'relative',
        marginTop: '24px',
        cursor: 'pointer'
      },
      disableClick: false
    },
    _react2.default.createElement(
      'div',
      {
        style: {
          position: 'relative',
          textAlign: 'center',
          lineHeight: '200px',
          fontSize: '16px'
        }
      },
      _react2.default.createElement(_icon2.default, {
        style: {
          float: 'none',
          display: 'inline-block',
          textAlign: 'center',
          lineHeight: '200px',
          color: '#ccc',
          top: '-8px',
          verticalAlign: 'middle',
          width: '25%',
          fontSize: '100px'
        },
        className: 'tc-icon-add'
      }),
      _react2.default.createElement(
        'div',
        {
          style: {
            display: 'inline-block',
            width: '75%',
            wordWrap: 'break-word',
            lineHeight: '24px',
            margin: '0',
            padding: '15px'
          }
        },
        dropzoneText || 'Drag and drop your CSV or Excel file here or click inside to choose a file from your computer'
      )
    )
  );
};

DropzoneContainer.propTypes = {
  onDrop: _react.PropTypes.func,
  dropzoneText: _react.PropTypes.string
};

exports.default = DropzoneContainer;

/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FailedSection = function FailedSection(props) {
  var failedRows = props.failedRows,
      numOfSuccessfulRows = props.numOfSuccessfulRows;


  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '10px' } },
      'The CSV you\'ve uploaded contains ',
      _react2.default.createElement(
        'b',
        null,
        failedRows.length,
        ' ',
        failedRows.length === 1 ? 'error' : 'errors'
      ),
      '. The following rows have errors:'
    ),
    failedRows.map(function (row, i) {
      return _react2.default.createElement(
        'div',
        { key: i },
        'Row ',
        row.line,
        ' - ',
        row.error
      );
    }),
    _react2.default.createElement(
      'div',
      { style: { marginTop: '10px' } },
      'Do you want to fix these rows and reupload the file or proceed with uploading the ',
      numOfSuccessfulRows,
      ' successful rows?'
    )
  );
};

FailedSection.propTypes = {
  failedRows: _react.PropTypes.array,
  numOfSuccessfulRows: _react.PropTypes.number
};

exports.default = FailedSection;

/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _Stepper = __webpack_require__(2747);

var _actions = __webpack_require__(1111);

var _upgradeActions = __webpack_require__(611);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  header: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 16px 0 16px'
  },
  title: {
    flexBasis: '50%'
  },
  stepper: {},
  summaryText: {
    fontSize: '11px',
    lineHeight: '20px',
    '& > a': {
      cursor: 'pointer'
    }
  }
};

var MassMessageDialog = function (_Component) {
  _inherits(MassMessageDialog, _Component);

  function MassMessageDialog(props) {
    _classCallCheck(this, MassMessageDialog);

    var _this = _possibleConstructorReturn(this, (MassMessageDialog.__proto__ || Object.getPrototypeOf(MassMessageDialog)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(MassMessageDialog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          currentStep = _props.currentStep,
          classes = _props.classes,
          companyPlan = _props.companyPlan;

      return _react2.default.createElement(
        'div',
        { className: classes.header },
        _react2.default.createElement(
          'div',
          { className: classes.title },
          _react2.default.createElement(
            'h3',
            null,
            'Compose New Message'
          ),
          companyPlan === 'basic' ? _react2.default.createElement(
            'div',
            { className: classes.summaryText },
            'You can send a bulk message to up to 20 partners on the Basic Plan.',
            _react2.default.createElement('br', null),
            'To message up to 200 partners ',
            _react2.default.createElement(
              'a',
              { onTouchTap: function onTouchTap() {
                  _this2.props.openUpgradeFrom('massMessaging');
                  _this2.props.closeMassDialog();
                  // this.props.dispatch({ type: 'TRACK_EVENT', payload: { name: '[App Bar] Upgrade Click' } });
                }
              },
              ' upgrade to the Connected Plan'
            ),
            '.'
          ) : _react2.default.createElement(
            'div',
            { className: classes.summaryText },
            'You can send a bulk message to up to 200 partners on the Connected Plan.'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: classes.stepper },
          _react2.default.createElement(
            _Stepper.Stepper,
            { activeStep: currentStep },
            _react2.default.createElement(
              _Stepper.Step,
              null,
              _react2.default.createElement(
                _Stepper.StepLabel,
                null,
                'Add Partners'
              )
            ),
            _react2.default.createElement(
              _Stepper.Step,
              null,
              _react2.default.createElement(
                _Stepper.StepLabel,
                null,
                'Subject & Content'
              )
            )
          )
        )
      );
    }
  }]);

  return MassMessageDialog;
}(_react.Component);

MassMessageDialog.propTypes = {
  classes: _react.PropTypes.object,
  closeMassDialog: _react.PropTypes.func,
  companyPlan: _react.PropTypes.string,
  currentStep: _react.PropTypes.number,
  openUpgradeFrom: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user;
  return {
    companyPlan: user.getIn(['company', 'plan'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  closeMassDialog: _actions.closeModal,
  openUpgradeFrom: _upgradeActions.openUpgradeFrom
})((0, _reactJss2.default)(styles)(MassMessageDialog));

/***/ }),
/* 2747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stepper = exports.StepLabel = exports.StepContent = exports.StepButton = exports.Step = undefined;

var _Step2 = __webpack_require__(1801);

var _Step3 = _interopRequireDefault(_Step2);

var _StepButton2 = __webpack_require__(1802);

var _StepButton3 = _interopRequireDefault(_StepButton2);

var _StepContent2 = __webpack_require__(1803);

var _StepContent3 = _interopRequireDefault(_StepContent2);

var _StepLabel2 = __webpack_require__(1361);

var _StepLabel3 = _interopRequireDefault(_StepLabel2);

var _Stepper2 = __webpack_require__(1804);

var _Stepper3 = _interopRequireDefault(_Stepper2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Step = _Step3.default;
exports.StepButton = _StepButton3.default;
exports.StepContent = _StepContent3.default;
exports.StepLabel = _StepLabel3.default;
exports.Stepper = _Stepper3.default;

/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Dialog = __webpack_require__(1205);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _FlatButton = __webpack_require__(1041);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Confirmation = function (_React$Component) {
  _inherits(Confirmation, _React$Component);

  function Confirmation() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Confirmation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Confirmation.__proto__ || Object.getPrototypeOf(Confirmation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.handleOpen = function () {
      _this.setState({ open: true });
    }, _this.handleClose = function () {
      _this.setState({ open: false });
    }, _this.handleConfirm = function () {
      _this.setState({ open: false });
      _this.props.handleConfirm();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Confirmation, [{
    key: 'render',
    value: function render() {
      var actions = [_react2.default.createElement(_FlatButton2.default, {
        label: 'Cancel',
        primary: true,
        onTouchTap: this.handleClose
      }), _react2.default.createElement(_FlatButton2.default, {
        label: 'Confirm',
        secondary: true,
        onTouchTap: this.handleConfirm
      })];

      return _react2.default.createElement(
        _Dialog2.default,
        {
          actions: actions,
          modal: false,
          open: this.state.open,
          onRequestClose: this.handleClose
        },
        'You are about to send a message to ',
        this.props.howMany,
        ' ',
        (0, _pluralize2.default)('partner', this.props.howMany),
        '?'
      );
    }
  }]);

  return Confirmation;
}(_react2.default.Component);

exports.default = Confirmation;


Confirmation.propTypes = {
  handleConfirm: _react.PropTypes.func,
  howMany: _react.PropTypes.number
};

Confirmation.defaultProps = {
  handleConfirm: function handleConfirm() {
    console.log('confirmed');
  },
  howMany: 0
};

/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buyerContractingMenu = exports.supplierContractingMenu = exports.salesMarketingMenu = exports.partnersMenu = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _group = __webpack_require__(2750);

var _group2 = _interopRequireDefault(_group);

var _person = __webpack_require__(1460);

var _person2 = _interopRequireDefault(_person);

var _contactMail = __webpack_require__(2751);

var _contactMail2 = _interopRequireDefault(_contactMail);

var _info = __webpack_require__(1863);

var _info2 = _interopRequireDefault(_info);

var _dns = __webpack_require__(2752);

var _dns2 = _interopRequireDefault(_dns);

var _formatListBulleted = __webpack_require__(2753);

var _formatListBulleted2 = _interopRequireDefault(_formatListBulleted);

var _business = __webpack_require__(2754);

var _business2 = _interopRequireDefault(_business);

var _search = __webpack_require__(1223);

var _search2 = _interopRequireDefault(_search);

var _satellite = __webpack_require__(2755);

var _satellite2 = _interopRequireDefault(_satellite);

var _dashboard = __webpack_require__(1864);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _assessment = __webpack_require__(1865);

var _assessment2 = _interopRequireDefault(_assessment);

var _description = __webpack_require__(561);

var _description2 = _interopRequireDefault(_description);

var _chromeReaderMode = __webpack_require__(1461);

var _chromeReaderMode2 = _interopRequireDefault(_chromeReaderMode);

var _send = __webpack_require__(577);

var _send2 = _interopRequireDefault(_send);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackedPush = function trackedPush(push, payload) {
  window.dataLayer.push({
    event: 'TRACK_EVENT',
    ev: {
      category: 'Top Nav Bar Click',
      action: payload.pathname || payload
    }
  });
  push(payload);
};

var trackedNewApp = function trackedNewApp(path, params) {
  return function () {
    window.dataLayer.push({
      event: 'TRACK_EVENT',
      ev: {
        category: 'Top Nav Bar Click',
        action: path
      }
    });
    window.location = '' + "https://app.tourconnect.com" + path + '?jwt=' + localStorage.getItem('jwt') + (params ? '&' + _queryString2.default.stringify(params) : '');
  };
};
// import ConnectionListIcon from 'material-ui/svg-icons/content/link';
var partnersMenu = exports.partnersMenu = function partnersMenu(_ref) {
  var push = _ref.push;
  return [{
    text: 'Partner List',
    icon: _react2.default.createElement(_group2.default, { color: 'rgba(0, 0, 0, 0.54)' }),
    onTouchTap: trackedNewApp('/partner-management/partner-list/partner')
  }, {
    text: 'Contact List',
    icon: _react2.default.createElement(_person2.default, { color: 'rgba(0, 0, 0, 0.54)' }),
    onTouchTap: trackedNewApp('/partner-management/partner-list/contact')
  }, {
    type: 'divider'
  }, {
    text: 'Messaging Center',
    icon: _react2.default.createElement(_contactMail2.default, { color: 'rgba(0, 0, 0, 0.54)' }),
    onTouchTap: function onTouchTap() {
      trackedPush(push, '/workspace');
    }
  }, {
    text: 'Bounce List',
    icon: _react2.default.createElement(_info2.default, { color: 'rgba(0, 0, 0, 0.54)' }),
    onTouchTap: trackedNewApp('/partner-management/bounce-list')
  }, {
    text: 'Manage Data Properties',
    icon: _react2.default.createElement(_dns2.default, { color: 'rgba(0, 0, 0, 0.54)' }),
    onTouchTap: trackedNewApp('/partner-management/settings/data-properties')
  }, {
    text: 'Message Templates & Signature',
    icon: _react2.default.createElement(_formatListBulleted2.default, { color: 'rgba(0, 0, 0, 0.54)' }),
    onTouchTap: trackedNewApp('/partner-management/settings/message-templates-signature')
  }];
};

var salesMarketingMenu = exports.salesMarketingMenu = function salesMarketingMenu(_ref2) {
  var push = _ref2.push;
  return [{
    text: 'Marketing Profile',
    icon: _react2.default.createElement(_business2.default, { color: 'rgba(0, 0, 0, 0.54)' }),
    onTouchTap: function onTouchTap() {
      trackedPush(push, '/profile');
    }
  }, {
    text: 'PartnerFinder',
    icon: _react2.default.createElement(_search2.default, { color: 'rgba(0, 0, 0, 0.54)' }),
    onTouchTap: function onTouchTap() {
      trackedPush(push, '/partner-finder/results');
    }
  }];
};

var supplierContractingMenu = exports.supplierContractingMenu = function supplierContractingMenu(_ref3) {
  var templateListSearchParams = _ref3.templateListSearchParams,
      contractListType = _ref3.contractListType,
      contractListSearchParams = _ref3.contractListSearchParams,
      push = _ref3.push,
      rateTemplatesCount = _ref3.rateTemplatesCount;
  return [{
    text: 'Dashboard',
    onTouchTap: function onTouchTap() {
      trackedPush(push, '/contracting/supplier-dashboard');
    },
    icon: _react2.default.createElement(_dashboard2.default, { color: 'rgba(0, 0, 0, 0.54)' })
  }, {
    text: 'Reports',
    onTouchTap: function onTouchTap() {
      return trackedPush(push, '/contracting/reports');
    },
    icon: _react2.default.createElement(_assessment2.default, { color: 'rgba(0, 0, 0, 0.54)' })
  }, {
    text: 'Rate Templates',
    onTouchTap: function onTouchTap() {
      return trackedPush(push, {
        pathname: '/contracting/template-list',
        query: templateListSearchParams
      });
    },
    icon: _react2.default.createElement(_description2.default, { color: 'rgba(0, 0, 0, 0.54)' })
  }, {
    text: 'Contract List',
    onTouchTap: function onTouchTap() {
      return trackedPush(push, {
        pathname: '/contracting/contract-list/' + (contractListType || 'recent'),
        query: contractListSearchParams
      });
    },
    icon: _react2.default.createElement(_chromeReaderMode2.default, { color: 'rgba(0, 0, 0, 0.54)' })
  }, {
    type: 'divider'
  }, {
    type: 'subheader',
    text: 'Quick Links'
  }, {
    text: 'Create a Template',
    onTouchTap: function onTouchTap() {
      return trackedPush(push, '/contracting/create-template-draft');
    },
    icon: 'tc-icon-receipt'
  }, rateTemplatesCount ? {
    text: 'Setup Next Year\'s Rates',
    onTouchTap: function onTouchTap() {
      return trackedPush(push, '/contracting/create-template-draft');
    },
    icon: 'tc-icon-receipt'
  } : null, {
    text: 'Send Contracts',
    onTouchTap: trackedNewApp('/partner-management/send-assets', { go_back_to: window.location.href, open_asset_type: 'rates' }),
    icon: _react2.default.createElement(_send2.default, { color: 'rgba(0, 0, 0, 0.54)' })
  }].filter(function (x) {
    return x;
  });
};

var buyerContractingMenu = exports.buyerContractingMenu = function buyerContractingMenu(_ref4) {
  var push = _ref4.push;
  return [{
    text: 'Dashboard',
    onTouchTap: function onTouchTap() {
      return trackedPush(push, '/contracting/buyer-dashboard');
    },
    icon: _react2.default.createElement(_dashboard2.default, { color: 'rgba(0, 0, 0, 0.54)' })
  }, {
    text: 'Reports',
    onTouchTap: function onTouchTap() {
      return trackedPush(push, '/contracting/reports');
    },
    icon: _react2.default.createElement(_assessment2.default, { color: 'rgba(0, 0, 0, 0.54)' })
  }, {
    text: 'Rates & Contracts',
    onTouchTap: function onTouchTap() {
      trackedNewApp('/contracting/workspace-list')();
    },
    icon: _react2.default.createElement(_chromeReaderMode2.default, { color: 'rgba(0, 0, 0, 0.54)' })
  }];
};

/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialGroup = function SocialGroup(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' })
  );
};
SocialGroup = (0, _pure2.default)(SocialGroup);
SocialGroup.displayName = 'SocialGroup';
SocialGroup.muiName = 'SvgIcon';

exports.default = SocialGroup;

/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationContactMail = function CommunicationContactMail(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z' })
  );
};
CommunicationContactMail = (0, _pure2.default)(CommunicationContactMail);
CommunicationContactMail.displayName = 'CommunicationContactMail';
CommunicationContactMail.muiName = 'SvgIcon';

exports.default = CommunicationContactMail;

/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDns = function ActionDns(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
  );
};
ActionDns = (0, _pure2.default)(ActionDns);
ActionDns.displayName = 'ActionDns';
ActionDns.muiName = 'SvgIcon';

exports.default = ActionDns;

/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatListBulleted = function EditorFormatListBulleted(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z' })
  );
};
EditorFormatListBulleted = (0, _pure2.default)(EditorFormatListBulleted);
EditorFormatListBulleted.displayName = 'EditorFormatListBulleted';
EditorFormatListBulleted.muiName = 'SvgIcon';

exports.default = EditorFormatListBulleted;

/***/ }),
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationBusiness = function CommunicationBusiness(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' })
  );
};
CommunicationBusiness = (0, _pure2.default)(CommunicationBusiness);
CommunicationBusiness.displayName = 'CommunicationBusiness';
CommunicationBusiness.muiName = 'SvgIcon';

exports.default = CommunicationBusiness;

/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsSatellite = function MapsSatellite(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z' })
  );
};
MapsSatellite = (0, _pure2.default)(MapsSatellite);
MapsSatellite.displayName = 'MapsSatellite';
MapsSatellite.muiName = 'SvgIcon';

exports.default = MapsSatellite;

/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SnackBarMessage = (0, _react.createClass)({
  propTypes: {
    open: _react.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    return {
      message: '',
      actionText: '',
      showSnackBar: this.props.open || false
    };
  },
  componentWillUnmount: function componentWillUnmount() {
    clearTimeout(this._timer);
  },
  _timeout: function _timeout() {
    var _this = this;

    clearTimeout(this._timer);
    this._timer = setTimeout(function () {
      _this.setState({
        showSnackBar: false
      });
    }, 8000);
  },
  triggerSnackBarMessage: function triggerSnackBarMessage(snackBarOptions) {
    if (!snackBarOptions) return;
    var stateUpdate = typeof snackBarOptions === 'string' ? { message: snackBarOptions } : snackBarOptions;
    this.setState((0, _ramda.merge)(stateUpdate, { showSnackBar: true }));
    this._timeout();
  },
  _snackBarTapped: function _snackBarTapped() {
    if (this.state.actionTap) {
      this.state.actionTap();
    }
    this.setState({
      actionTap: undefined,
      showSnackBar: false
    });
  },
  render: function render() {
    return _react2.default.createElement(_materialUi.Snackbar, {
      message: this.state.message,
      action: this.state.actionText,
      onActionTouchTap: this._snackBarTapped,
      open: this.state.showSnackBar,
      style: { textAlign: 'center' }
    });
  }
});

exports.default = SnackBarMessage;

/***/ }),
/* 2757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalAlertBox = function GlobalAlertBox(props) {
  var text = props.text,
      onClose = props.onClose,
      onOk = props.onOk,
      open = props.open;

  var onClickOk = function onClickOk() {
    onClose();
    if (onOk) onOk();
  };
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      style: { zIndex: 1501 },
      open: open,
      actions: [Boolean(onOk) && _react2.default.createElement(_materialUi.FlatButton, {
        key: 'cancel',
        onClick: onClose,
        label: 'Cancel',
        secondary: true
      }), _react2.default.createElement(_materialUi.RaisedButton, {
        key: 'ok',
        onClick: onClickOk,
        label: 'OK',
        secondary: true
      })]
    },
    _react2.default.createElement(
      'div',
      { style: { whiteSpace: 'pre-wrap' } },
      text
    )
  );
};

var mapState = function mapState(_ref) {
  var globalAlert = _ref.globalAlert;
  return globalAlert;
};

var mapActions = {
  onClose: function onClose() {
    return { type: 'close_global_alert' };
  }
};
exports.default = (0, _reactRedux.connect)(mapState, mapActions)(GlobalAlertBox);

/***/ }),
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _upgradeConstants = __webpack_require__(1048);

var upgradeConstants = _interopRequireWildcard(_upgradeConstants);

var _notificationsActive = __webpack_require__(2759);

var _notificationsActive2 = _interopRequireDefault(_notificationsActive);

var _mood = __webpack_require__(2760);

var _mood2 = _interopRequireDefault(_mood);

var _groupAdd = __webpack_require__(2761);

var _groupAdd2 = _interopRequireDefault(_groupAdd);

var _eventAvailable = __webpack_require__(2762);

var _eventAvailable2 = _interopRequireDefault(_eventAvailable);

var _smartphone = __webpack_require__(2763);

var _smartphone2 = _interopRequireDefault(_smartphone);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _PlanItem = __webpack_require__(2764);

var _PlanItem2 = _interopRequireDefault(_PlanItem);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanItems = function PlanItems(_ref) {
  var companyType = _ref.companyType,
      upgradeReason = _ref.upgradeReason;

  var planItems = [{
    title: 'Year-Round Trade Show',
    content: 'We all know how expensive trade events can be. With TourConnect, have a trade show at your fingertips all day, every day...for a fraction of the cost.',
    icon: _react2.default.createElement(_eventAvailable2.default, null),
    backgroundColor: '#2196F3',
    upgradeReasons: [upgradeConstants.PARTNER_FINDER_CONNECT]
  }, {
    title: 'Getting Maximum Value',
    content: 'While we take pride in helping you connect with great companies, you still need to put the work in to produce bookings. Remember to follow up with new connections, and start building a relationship!',
    icon: _react2.default.createElement(_notificationsActive2.default, null),
    backgroundColor: '#2196F3',
    upgradeReasons: [upgradeConstants.PARTNER_FINDER_CONNECT]
  }, {
    title: 'No Contracts - Cancel Anytime',
    content: 'You can downgrade or cancel your account at any time, and you will not be charged from that point onward. It\'s that simple.',
    icon: _react2.default.createElement(_mood2.default, null),
    backgroundColor: '#2196F3',
    upgradeReasons: [upgradeConstants.PARTNER_FINDER_CONNECT]
  }, {
    title: 'Our Goal for Your Upgrade',
    content: 'Our goal is to get you at least one new partner per year. Business partnerships can last for years, so that one new partner can pay off for years to come.',
    icon: _react2.default.createElement(_groupAdd2.default, null),
    backgroundColor: '#2196F3',
    upgradeReasons: [upgradeConstants.PARTNER_FINDER_CONNECT]
  }, {
    title: 'Mobile App',
    content: _react2.default.createElement(
      'span',
      null,
      'Make following up at trade events a breeze by using the mobile app with business card scanner to instantly send follow ups. ',
      _react2.default.createElement(
        'i',
        null,
        '(Special Offer: Unlimited app users for accounts paying annually)'
      )
    ),
    icon: _react2.default.createElement(_smartphone2.default, null),
    iconStyle: { fontSize: '34px', lineHeight: '76px' },
    backgroundColor: '#2196F3',
    upgradeReasons: [upgradeConstants.PARTNER_FINDER_CONNECT]
  }, {
    title: 'Partner Finder',
    content: 'With PartnerFinder, you\'ll get access to the entire TourConnect network to search for new partners and a priority listing on PartnerFinder.',
    icon: _react2.default.createElement(_icon2.default, { className: 'tc-icon-partner-finder' }),
    iconStyle: { fontSize: '34px', lineHeight: '76px' },
    backgroundColor: 'rgb(255, 138, 11)'
  }, {
    title: 'Partner Management',
    content: 'Manage all of your B2B partners in one place. Ensure everyone on your team knows who your partners are, and your history with them, so you can get more out of your relationships',
    icon: _react2.default.createElement(_icon2.default, { className: 'tc-icon-people' }),
    iconStyle: { fontSize: '34px', lineHeight: '76px' },
    backgroundColor: 'rgb(108, 129, 239)'
  }, {
    title: 'Marketing Manager',
    content: 'Marketing Materials is your marketing asset respository for your partners to access up-to-date brochures, images, or videos.',
    icon: _react2.default.createElement(_icon2.default, { className: 'tc-icon-marketing-materials' }),
    iconStyle: { fontSize: '34px', lineHeight: '76px' },
    backgroundColor: 'rgb(0, 210, 78)'
  }, {
    title: 'Mobile App',
    content: _react2.default.createElement(
      'span',
      null,
      'Make following up at trade events a breeze by using the mobile app with business card scanner to instantly send follow ups. ',
      _react2.default.createElement(
        'i',
        null,
        '(Special Offer: Unlimited app users for accounts paying annually)'
      )
    ),
    icon: _react2.default.createElement(_smartphone2.default, null),
    iconStyle: { fontSize: '34px', lineHeight: '76px' },
    backgroundColor: '#ce93d8'
  }, {
    title: 'And Much More...',
    content: 'Features like message tracking, internal notes, new supplier alerts, and more!',
    icon: _react2.default.createElement(_icon2.default, { className: 'tc-icon-star' }),
    iconStyle: { fontSize: '34px', lineHeight: '76px' },
    backgroundColor: 'rgb(255, 214, 11)'
  }];
  var upgradeReasonsBeingHandled = [upgradeConstants.PARTNER_FINDER_CONNECT];

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h4',
      { style: { fontWeight: 300, textAlign: 'center' } },
      'The Details'
    ),
    _react2.default.createElement(
      'ul',
      { style: { display: 'flex', flexWrap: 'wrap' } },
      planItems.filter(function (plan) {
        if (upgradeReasonsBeingHandled.indexOf(upgradeReason) > -1) return plan.upgradeReasons && plan.upgradeReasons.indexOf(upgradeReason) > -1;
        return !plan.upgradeReasons;
      }).map(function (plan, i, arr) {
        return _react2.default.createElement(_PlanItem2.default, _extends({}, plan, { key: i, style: i === arr.length - 1 ? { display: 'block', margin: 'auto' } : {} }));
      })
    )
  );
};

PlanItems.propTypes = {
  plan: _react.PropTypes.object,
  companyType: _react.PropTypes.string,
  onUpgradeClick: _react.PropTypes.func
};

exports.default = PlanItems;

/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialNotificationsActive = function SocialNotificationsActive(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z' })
  );
};
SocialNotificationsActive = (0, _pure2.default)(SocialNotificationsActive);
SocialNotificationsActive.displayName = 'SocialNotificationsActive';
SocialNotificationsActive.muiName = 'SvgIcon';

exports.default = SocialNotificationsActive;

/***/ }),
/* 2760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialMood = function SocialMood(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
  );
};
SocialMood = (0, _pure2.default)(SocialMood);
SocialMood.displayName = 'SocialMood';
SocialMood.muiName = 'SvgIcon';

exports.default = SocialMood;

/***/ }),
/* 2761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialGroupAdd = function SocialGroupAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z' })
  );
};
SocialGroupAdd = (0, _pure2.default)(SocialGroupAdd);
SocialGroupAdd.displayName = 'SocialGroupAdd';
SocialGroupAdd.muiName = 'SvgIcon';

exports.default = SocialGroupAdd;

/***/ }),
/* 2762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationEventAvailable = function NotificationEventAvailable(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z' })
  );
};
NotificationEventAvailable = (0, _pure2.default)(NotificationEventAvailable);
NotificationEventAvailable.displayName = 'NotificationEventAvailable';
NotificationEventAvailable.muiName = 'SvgIcon';

exports.default = NotificationEventAvailable;

/***/ }),
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareSmartphone = function HardwareSmartphone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
  );
};
HardwareSmartphone = (0, _pure2.default)(HardwareSmartphone);
HardwareSmartphone.displayName = 'HardwareSmartphone';
HardwareSmartphone.muiName = 'SvgIcon';

exports.default = HardwareSmartphone;

/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanItem = function PlanItem(_ref) {
  var style = _ref.style,
      content = _ref.content,
      icon = _ref.icon,
      iconStyle = _ref.iconStyle,
      title = _ref.title,
      backgroundColor = _ref.backgroundColor;

  var iconStyles = _extends({}, iconStyle, {
    display: 'block',
    color: 'rgb(255, 255, 255)',
    fill: 'rgb(255, 255, 255)',
    height: '76px',
    width: '38px',
    margin: '0 auto'
  });
  return _react2.default.createElement(
    'li',
    { style: _extends({ listStyle: 'none', display: 'inline-block', padding: '10px 25px', width: '50%' }, style) },
    _react2.default.createElement(
      'div',
      { style: { display: 'inline-block', verticalAlign: 'top' } },
      _react2.default.createElement(
        'span',
        { style: {
            backgroundColor: backgroundColor || 'rgb(255, 138, 11)',
            borderRadius: '50%',
            width: '76px',
            height: '76px',
            fontSize: '24px',
            color: 'white',
            display: 'inline-block',
            textAlign: 'center',
            lineHeight: '56px'
          }
        },
        (0, _react.cloneElement)(icon, { style: iconStyles })
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'inline-block', marginLeft: '25px', width: '75%' } },
      _react2.default.createElement(
        'h4',
        { style: { fontWeight: 300, margin: 0, padding: 0 } },
        title
      ),
      _react2.default.createElement(
        'p',
        null,
        content
      )
    )
  );
};

PlanItem.propTypes = {
  plan: _react.PropTypes.object,
  companyType: _react.PropTypes.string,
  onUpgradeClick: _react.PropTypes.func
};

exports.default = PlanItem;

/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var array = _react.PropTypes.array,
    func = _react.PropTypes.func,
    number = _react.PropTypes.number,
    string = _react.PropTypes.string;


var PlanSelector = function PlanSelector(_ref) {
  var plans = _ref.plans,
      selectedPlanIndex = _ref.selectedPlanIndex,
      onPlanClick = _ref.onPlanClick;

  return _react2.default.createElement(
    'div',
    { style: { backgroundColor: '#f5f5f5', margin: '0 auto', width: '40%', textAlign: 'center', padding: '5px', border: '1px solid #eeeeee', borderRadius: '3px', marginBottom: '10px' } },
    plans.map(function (plan, i) {
      var selectedStyle = {
        backgroundColor: 'rgba(0,0,0,.1)',
        color: 'rgb(255, 39, 104)',
        fontWeight: 500
      };

      return _react2.default.createElement(
        'a',
        {
          key: i,
          onClick: function onClick() {
            return onPlanClick(i);
          },
          style: _extends({}, {
            display: 'inline-block',
            fontSize: '18px',
            lineHeight: '24px',
            fontVariant: 'small-caps',
            padding: '10px 20px',
            width: '50%',
            borderRadius: '5px',
            cursor: 'pointer'
          }, selectedPlanIndex === i ? selectedStyle : {})
        },
        plan.name
      );
    })
  );
};

PlanSelector.propTypes = {
  plans: array,
  planName: string,
  selectedPlanIndex: number,
  onPlanClick: func
};

exports.default = PlanSelector;

/***/ }),
/* 2766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanDetails = function PlanDetails(_ref) {
  var plan = _ref.plan,
      companyType = _ref.companyType,
      productType = _ref.productType,
      onUpgradeClick = _ref.onUpgradeClick,
      onTermClick = _ref.onTermClick,
      isAnnualPlan = _ref.isAnnualPlan;

  var priceNode = typeof plan.price === 'string' ? _react2.default.createElement(
    'span',
    { style: { display: 'inline-block', fontSize: '50px' } },
    plan.price === 'Custom' ? 'Contact Us' : plan.price
  ) : _react2.default.createElement(
    'span',
    { style: { display: 'inline-block', fontSize: '72px' } },
    plan.price,
    _react2.default.createElement(
      'span',
      { style: { fontSize: '18px', lineHeight: 0, verticalAlign: 'top' } },
      'USD'
    )
  );
  return _react2.default.createElement(
    _materialUi.Card,
    { style: { width: '75%', margin: '0 auto', padding: '20px' } },
    _react2.default.createElement(
      'h2',
      { style: { fontSize: '16px', fontWeight: 600, marginBottom: '0', textTransform: 'uppercase', color: 'rgb(255, 39, 104)', letterSpacing: '2px', textAlign: 'center', padding: 0 } },
      plan.name,
      ' Plan'
    ),
    plan.price !== 'Custom' ? _react2.default.createElement(
      'p',
      { style: { margin: 0, padding: 0, textAlign: 'center', textTransform: 'uppercase', verticalAlign: 'top' } },
      'Billed ',
      plan.term === 'month' ? 'monthly' : 'annually'
    ) : _react2.default.createElement(
      'p',
      { style: { margin: 0, padding: 0, textAlign: 'center', textTransform: 'uppercase', verticalAlign: 'top' } },
      'large volume contracting'
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'div',
      { style: { margin: '0 auto', textAlign: 'center', width: '100%' } },
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', width: '50%', verticalAlign: 'middle' } },
        companyType === 'Supplier' ? _react2.default.createElement(
          'div',
          { style: { display: 'flex', flexDirection: 'column', alignItems: 'center' } },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'baseline' } },
            priceNode,
            _react2.default.createElement(
              'span',
              null,
              'base price (incl. 1 ',
              productType === 'Non-Accommodation' ? 'location' : 'property',
              ')'
            )
          ),
          _react2.default.createElement(
            'span',
            { style: { color: 'rgba(0, 0, 0, 0.54)' } },
            '$',
            plan.additional,
            ' USD per additional ',
            productType === 'Non-Accommodation' ? 'location' : 'property'
          )
        ) : priceNode
      ),
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', margin: '0 auto', verticalAlign: 'middle', width: '50%' } },
        _react2.default.createElement(
          'h1',
          { style: { fontWeight: 400, fontSize: '20px', lineHeight: '36px', margin: 0, textAlign: 'center' } },
          'Get more out of your B2B relationship'
        ),
        _react2.default.createElement(
          'p',
          { style: { fontWeight: 300, fontSize: '12px', lineHeight: '24px', margin: 0, padding: 0, textAlign: 'justify' } },
          'By upgrading your account, you will get full access to search and connect with new partners, partner management tools, marketing materials and more.'
        )
      )
    ),
    plan.price !== 'Custom' && _react2.default.createElement(_materialUi.Toggle, {
      label: _react2.default.createElement(
        'span',
        null,
        'Pay annually and ',
        _react2.default.createElement(
          'strong',
          null,
          'save 17%'
        )
      ),
      labelPosition: 'right',
      labelStyle: { width: 'auto' },
      style: { display: 'inline-block', padding: '0 10px', width: 'auto' },
      toggled: isAnnualPlan,
      onClick: onTermClick
    })
  );
};

PlanDetails.propTypes = {
  plan: _react.PropTypes.object,
  companyType: _react.PropTypes.string,
  onUpgradeClick: _react.PropTypes.func
};

exports.default = PlanDetails;

/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _joi = __webpack_require__(1869);

var _joi2 = _interopRequireDefault(_joi);

var _lodashSet = __webpack_require__(1870);

var _lodashSet2 = _interopRequireDefault(_lodashSet);

var _lodashGet = __webpack_require__(2768);

var _lodashGet2 = _interopRequireDefault(_lodashGet);

var _lodashIsempty = __webpack_require__(2770);

var _lodashIsempty2 = _interopRequireDefault(_lodashIsempty);

var _lodashCompose = __webpack_require__(2773);

var _lodashCompose2 = _interopRequireDefault(_lodashCompose);

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(2775);

exports['default'] = function (joiOptions) {
  return {
    validate: function validate(data, joiSchema, options, callback) {
      if (data === undefined) data = {};
      if (joiSchema === undefined) joiSchema = {};
      if (options === undefined) options = {};

      _invariant2['default'](typeof callback === 'function', 'joi-validation-strategy is asynchronous, a callback is expected: validate(data, schema, options, callback)');
      var key = options.key;
      var _options$prevErrors = options.prevErrors;
      var prevErrors = _options$prevErrors === undefined ? {} : _options$prevErrors;

      var validationOptions = _extends({
        abortEarly: false,
        allowUnknown: true
      }, joiOptions);
      _joi2['default'].validate(data, joiSchema, validationOptions, function (error) {
        var errors = _lodashCompose2['default'](_utils.hydrate, _utils.pickMessages, _utils.collectErrors, _utils.decodeMessages)(error);
        if (key === undefined || key === null || _lodashIsempty2['default'](errors)) {
          return callback(errors);
        }
        return callback(_lodashSet2['default'](prevErrors, key, _lodashGet2['default'](errors, key)));
      });
    }
  };
};

module.exports = exports['default'];

/***/ }),
/* 2768 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.7.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseGet = __webpack_require__(2769),
    toPath = __webpack_require__(1871);

/**
 * Gets the property value of `path` on `object`. If the resolved value is
 * `undefined` the `defaultValue` is used in its place.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 2769 */
/***/ (function(module, exports) {

/**
 * lodash 3.7.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `get` without support for string paths
 * and default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path of the property to get.
 * @param {string} [pathKey] The key representation of path.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path, pathKey) {
  if (object == null) {
    return;
  }
  if (pathKey !== undefined && pathKey in toObject(object)) {
    path = [pathKey];
  }
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = baseGet;


/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArguments = __webpack_require__(1872),
    isArray = __webpack_require__(977),
    isFunction = __webpack_require__(2771),
    isString = __webpack_require__(2772),
    keys = __webpack_require__(1225);

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is empty. A value is considered empty unless it is an
 * `arguments` object, array, string, or jQuery-like collection with a length
 * greater than `0` or an object with own enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {Array|Object|string} value The value to inspect.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
      (isObjectLike(value) && isFunction(value.splice)))) {
    return !value.length;
  }
  return !keys(value).length;
}

module.exports = isEmpty;


/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 2772 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */
var isFunction = __webpack_require__(2774);

/**
 * Creates a function that is the composition of the provided functions,
 * where each function consumes the return value of the function that follows.
 * For example, composing the functions `f()`, `g()`, and `h()` produces `f(g(h()))`.
 * Each function is executed with the `this` binding of the composed function.
 *
 * @static
 * @memberOf _
 * @category Functions
 * @param {...Function} [func] Functions to compose.
 * @returns {Function} Returns the new composed function.
 * @example
 *
 * var realNameMap = {
 *   'pebbles': 'penelope'
 * };
 *
 * var format = function(name) {
 *   name = realNameMap[name.toLowerCase()] || name;
 *   return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
 * };
 *
 * var greet = function(formatted) {
 *   return 'Hiya ' + formatted + '!';
 * };
 *
 * var welcome = _.compose(greet, format);
 * welcome('pebbles');
 * // => 'Hiya Penelope!'
 */
function compose() {
  var funcs = arguments,
      length = funcs.length;

  while (length--) {
    if (!isFunction(funcs[length])) {
      throw new TypeError;
    }
  }
  return function() {
    var args = arguments,
        length = funcs.length;

    while (length--) {
      args = [funcs[length].apply(this, args)];
    }
    return args[0];
  };
}

module.exports = compose;


/***/ }),
/* 2774 */
/***/ (function(module, exports) {

/**
 * Lo-Dash 2.4.1 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * Checks if `value` is a function.
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 */
function isFunction(value) {
  return typeof value == 'function';
}

module.exports = isFunction;


/***/ }),
/* 2775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _hydrate = __webpack_require__(2776);

var _hydrate2 = _interopRequireDefault(_hydrate);

var _decodeMessages = __webpack_require__(2777);

var _decodeMessages2 = _interopRequireDefault(_decodeMessages);

var _collectErrors = __webpack_require__(2779);

var _collectErrors2 = _interopRequireDefault(_collectErrors);

var _pickMessages = __webpack_require__(2788);

var _pickMessages2 = _interopRequireDefault(_pickMessages);

exports['default'] = { hydrate: _hydrate2['default'], decodeMessages: _decodeMessages2['default'], collectErrors: _collectErrors2['default'], pickMessages: _pickMessages2['default'] };
module.exports = exports['default'];

/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = hydrate;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashSet = __webpack_require__(1870);

var _lodashSet2 = _interopRequireDefault(_lodashSet);

function hydrate(flat) {
  return Object.keys(flat).sort().reduce(function (obj, path) {
    return _lodashSet2['default'](obj, path, flat[path]);
  }, {});
}

module.exports = exports['default'];

/***/ }),
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = decodeMessages;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _he = __webpack_require__(2778);

var _he2 = _interopRequireDefault(_he);

function decodeMessages(error) {
  if (error !== null) {
    error.details = error.details.map(function (e) {
      return _extends({}, e, {
        message: _he2['default'].decode(e.message)
      });
    });
    return error;
  }
  return {};
}

module.exports = exports['default'];

/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! http://mths.be/he v0.5.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`.
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`.
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	// All astral symbols.
	var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	// All ASCII symbols (not just printable ASCII) except those listed in the
	// first column of the overrides table.
	// http://whatwg.org/html/tokenization.html#table-charref-overrides
	var regexAsciiWhitelist = /[\x01-\x7F]/g;
	// All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
	// code points listed in the first column of the overrides table on
	// http://whatwg.org/html/tokenization.html#table-charref-overrides.
	var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;

	var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
	var encodeMap = {'\xC1':'Aacute','\xE1':'aacute','\u0102':'Abreve','\u0103':'abreve','\u223E':'ac','\u223F':'acd','\u223E\u0333':'acE','\xC2':'Acirc','\xE2':'acirc','\xB4':'acute','\u0410':'Acy','\u0430':'acy','\xC6':'AElig','\xE6':'aelig','\u2061':'af','\uD835\uDD04':'Afr','\uD835\uDD1E':'afr','\xC0':'Agrave','\xE0':'agrave','\u2135':'aleph','\u0391':'Alpha','\u03B1':'alpha','\u0100':'Amacr','\u0101':'amacr','\u2A3F':'amalg','&':'amp','\u2A55':'andand','\u2A53':'And','\u2227':'and','\u2A5C':'andd','\u2A58':'andslope','\u2A5A':'andv','\u2220':'ang','\u29A4':'ange','\u29A8':'angmsdaa','\u29A9':'angmsdab','\u29AA':'angmsdac','\u29AB':'angmsdad','\u29AC':'angmsdae','\u29AD':'angmsdaf','\u29AE':'angmsdag','\u29AF':'angmsdah','\u2221':'angmsd','\u221F':'angrt','\u22BE':'angrtvb','\u299D':'angrtvbd','\u2222':'angsph','\xC5':'angst','\u237C':'angzarr','\u0104':'Aogon','\u0105':'aogon','\uD835\uDD38':'Aopf','\uD835\uDD52':'aopf','\u2A6F':'apacir','\u2248':'ap','\u2A70':'apE','\u224A':'ape','\u224B':'apid','\'':'apos','\xE5':'aring','\uD835\uDC9C':'Ascr','\uD835\uDCB6':'ascr','\u2254':'colone','*':'ast','\u224D':'CupCap','\xC3':'Atilde','\xE3':'atilde','\xC4':'Auml','\xE4':'auml','\u2233':'awconint','\u2A11':'awint','\u224C':'bcong','\u03F6':'bepsi','\u2035':'bprime','\u223D':'bsim','\u22CD':'bsime','\u2216':'setmn','\u2AE7':'Barv','\u22BD':'barvee','\u2305':'barwed','\u2306':'Barwed','\u23B5':'bbrk','\u23B6':'bbrktbrk','\u0411':'Bcy','\u0431':'bcy','\u201E':'bdquo','\u2235':'becaus','\u29B0':'bemptyv','\u212C':'Bscr','\u0392':'Beta','\u03B2':'beta','\u2136':'beth','\u226C':'twixt','\uD835\uDD05':'Bfr','\uD835\uDD1F':'bfr','\u22C2':'xcap','\u25EF':'xcirc','\u22C3':'xcup','\u2A00':'xodot','\u2A01':'xoplus','\u2A02':'xotime','\u2A06':'xsqcup','\u2605':'starf','\u25BD':'xdtri','\u25B3':'xutri','\u2A04':'xuplus','\u22C1':'Vee','\u22C0':'Wedge','\u290D':'rbarr','\u29EB':'lozf','\u25AA':'squf','\u25B4':'utrif','\u25BE':'dtrif','\u25C2':'ltrif','\u25B8':'rtrif','\u2423':'blank','\u2592':'blk12','\u2591':'blk14','\u2593':'blk34','\u2588':'block','=\u20E5':'bne','\u2261\u20E5':'bnequiv','\u2AED':'bNot','\u2310':'bnot','\uD835\uDD39':'Bopf','\uD835\uDD53':'bopf','\u22A5':'bot','\u22C8':'bowtie','\u29C9':'boxbox','\u2510':'boxdl','\u2555':'boxdL','\u2556':'boxDl','\u2557':'boxDL','\u250C':'boxdr','\u2552':'boxdR','\u2553':'boxDr','\u2554':'boxDR','\u2500':'boxh','\u2550':'boxH','\u252C':'boxhd','\u2564':'boxHd','\u2565':'boxhD','\u2566':'boxHD','\u2534':'boxhu','\u2567':'boxHu','\u2568':'boxhU','\u2569':'boxHU','\u229F':'minusb','\u229E':'plusb','\u22A0':'timesb','\u2518':'boxul','\u255B':'boxuL','\u255C':'boxUl','\u255D':'boxUL','\u2514':'boxur','\u2558':'boxuR','\u2559':'boxUr','\u255A':'boxUR','\u2502':'boxv','\u2551':'boxV','\u253C':'boxvh','\u256A':'boxvH','\u256B':'boxVh','\u256C':'boxVH','\u2524':'boxvl','\u2561':'boxvL','\u2562':'boxVl','\u2563':'boxVL','\u251C':'boxvr','\u255E':'boxvR','\u255F':'boxVr','\u2560':'boxVR','\u02D8':'breve','\xA6':'brvbar','\uD835\uDCB7':'bscr','\u204F':'bsemi','\u29C5':'bsolb','\\':'bsol','\u27C8':'bsolhsub','\u2022':'bull','\u224E':'bump','\u2AAE':'bumpE','\u224F':'bumpe','\u0106':'Cacute','\u0107':'cacute','\u2A44':'capand','\u2A49':'capbrcup','\u2A4B':'capcap','\u2229':'cap','\u22D2':'Cap','\u2A47':'capcup','\u2A40':'capdot','\u2145':'DD','\u2229\uFE00':'caps','\u2041':'caret','\u02C7':'caron','\u212D':'Cfr','\u2A4D':'ccaps','\u010C':'Ccaron','\u010D':'ccaron','\xC7':'Ccedil','\xE7':'ccedil','\u0108':'Ccirc','\u0109':'ccirc','\u2230':'Cconint','\u2A4C':'ccups','\u2A50':'ccupssm','\u010A':'Cdot','\u010B':'cdot','\xB8':'cedil','\u29B2':'cemptyv','\xA2':'cent','\xB7':'middot','\uD835\uDD20':'cfr','\u0427':'CHcy','\u0447':'chcy','\u2713':'check','\u03A7':'Chi','\u03C7':'chi','\u02C6':'circ','\u2257':'cire','\u21BA':'olarr','\u21BB':'orarr','\u229B':'oast','\u229A':'ocir','\u229D':'odash','\u2299':'odot','\xAE':'reg','\u24C8':'oS','\u2296':'ominus','\u2295':'oplus','\u2297':'otimes','\u25CB':'cir','\u29C3':'cirE','\u2A10':'cirfnint','\u2AEF':'cirmid','\u29C2':'cirscir','\u2232':'cwconint','\u201D':'rdquo','\u2019':'rsquo','\u2663':'clubs',':':'colon','\u2237':'Colon','\u2A74':'Colone',',':'comma','@':'commat','\u2201':'comp','\u2218':'compfn','\u2102':'Copf','\u2245':'cong','\u2A6D':'congdot','\u2261':'equiv','\u222E':'oint','\u222F':'Conint','\uD835\uDD54':'copf','\u2210':'coprod','\xA9':'copy','\u2117':'copysr','\u21B5':'crarr','\u2717':'cross','\u2A2F':'Cross','\uD835\uDC9E':'Cscr','\uD835\uDCB8':'cscr','\u2ACF':'csub','\u2AD1':'csube','\u2AD0':'csup','\u2AD2':'csupe','\u22EF':'ctdot','\u2938':'cudarrl','\u2935':'cudarrr','\u22DE':'cuepr','\u22DF':'cuesc','\u21B6':'cularr','\u293D':'cularrp','\u2A48':'cupbrcap','\u2A46':'cupcap','\u222A':'cup','\u22D3':'Cup','\u2A4A':'cupcup','\u228D':'cupdot','\u2A45':'cupor','\u222A\uFE00':'cups','\u21B7':'curarr','\u293C':'curarrm','\u22CE':'cuvee','\u22CF':'cuwed','\xA4':'curren','\u2231':'cwint','\u232D':'cylcty','\u2020':'dagger','\u2021':'Dagger','\u2138':'daleth','\u2193':'darr','\u21A1':'Darr','\u21D3':'dArr','\u2010':'dash','\u2AE4':'Dashv','\u22A3':'dashv','\u290F':'rBarr','\u02DD':'dblac','\u010E':'Dcaron','\u010F':'dcaron','\u0414':'Dcy','\u0434':'dcy','\u21CA':'ddarr','\u2146':'dd','\u2911':'DDotrahd','\u2A77':'eDDot','\xB0':'deg','\u2207':'Del','\u0394':'Delta','\u03B4':'delta','\u29B1':'demptyv','\u297F':'dfisht','\uD835\uDD07':'Dfr','\uD835\uDD21':'dfr','\u2965':'dHar','\u21C3':'dharl','\u21C2':'dharr','\u02D9':'dot','`':'grave','\u02DC':'tilde','\u22C4':'diam','\u2666':'diams','\xA8':'die','\u03DD':'gammad','\u22F2':'disin','\xF7':'div','\u22C7':'divonx','\u0402':'DJcy','\u0452':'djcy','\u231E':'dlcorn','\u230D':'dlcrop','$':'dollar','\uD835\uDD3B':'Dopf','\uD835\uDD55':'dopf','\u20DC':'DotDot','\u2250':'doteq','\u2251':'eDot','\u2238':'minusd','\u2214':'plusdo','\u22A1':'sdotb','\u21D0':'lArr','\u21D4':'iff','\u27F8':'xlArr','\u27FA':'xhArr','\u27F9':'xrArr','\u21D2':'rArr','\u22A8':'vDash','\u21D1':'uArr','\u21D5':'vArr','\u2225':'par','\u2913':'DownArrowBar','\u21F5':'duarr','\u0311':'DownBreve','\u2950':'DownLeftRightVector','\u295E':'DownLeftTeeVector','\u2956':'DownLeftVectorBar','\u21BD':'lhard','\u295F':'DownRightTeeVector','\u2957':'DownRightVectorBar','\u21C1':'rhard','\u21A7':'mapstodown','\u22A4':'top','\u2910':'RBarr','\u231F':'drcorn','\u230C':'drcrop','\uD835\uDC9F':'Dscr','\uD835\uDCB9':'dscr','\u0405':'DScy','\u0455':'dscy','\u29F6':'dsol','\u0110':'Dstrok','\u0111':'dstrok','\u22F1':'dtdot','\u25BF':'dtri','\u296F':'duhar','\u29A6':'dwangle','\u040F':'DZcy','\u045F':'dzcy','\u27FF':'dzigrarr','\xC9':'Eacute','\xE9':'eacute','\u2A6E':'easter','\u011A':'Ecaron','\u011B':'ecaron','\xCA':'Ecirc','\xEA':'ecirc','\u2256':'ecir','\u2255':'ecolon','\u042D':'Ecy','\u044D':'ecy','\u0116':'Edot','\u0117':'edot','\u2147':'ee','\u2252':'efDot','\uD835\uDD08':'Efr','\uD835\uDD22':'efr','\u2A9A':'eg','\xC8':'Egrave','\xE8':'egrave','\u2A96':'egs','\u2A98':'egsdot','\u2A99':'el','\u2208':'in','\u23E7':'elinters','\u2113':'ell','\u2A95':'els','\u2A97':'elsdot','\u0112':'Emacr','\u0113':'emacr','\u2205':'empty','\u25FB':'EmptySmallSquare','\u25AB':'EmptyVerySmallSquare','\u2004':'emsp13','\u2005':'emsp14','\u2003':'emsp','\u014A':'ENG','\u014B':'eng','\u2002':'ensp','\u0118':'Eogon','\u0119':'eogon','\uD835\uDD3C':'Eopf','\uD835\uDD56':'eopf','\u22D5':'epar','\u29E3':'eparsl','\u2A71':'eplus','\u03B5':'epsi','\u0395':'Epsilon','\u03F5':'epsiv','\u2242':'esim','\u2A75':'Equal','=':'equals','\u225F':'equest','\u21CC':'rlhar','\u2A78':'equivDD','\u29E5':'eqvparsl','\u2971':'erarr','\u2253':'erDot','\u212F':'escr','\u2130':'Escr','\u2A73':'Esim','\u0397':'Eta','\u03B7':'eta','\xD0':'ETH','\xF0':'eth','\xCB':'Euml','\xEB':'euml','\u20AC':'euro','!':'excl','\u2203':'exist','\u0424':'Fcy','\u0444':'fcy','\u2640':'female','\uFB03':'ffilig','\uFB00':'fflig','\uFB04':'ffllig','\uD835\uDD09':'Ffr','\uD835\uDD23':'ffr','\uFB01':'filig','\u25FC':'FilledSmallSquare','fj':'fjlig','\u266D':'flat','\uFB02':'fllig','\u25B1':'fltns','\u0192':'fnof','\uD835\uDD3D':'Fopf','\uD835\uDD57':'fopf','\u2200':'forall','\u22D4':'fork','\u2AD9':'forkv','\u2131':'Fscr','\u2A0D':'fpartint','\xBD':'half','\u2153':'frac13','\xBC':'frac14','\u2155':'frac15','\u2159':'frac16','\u215B':'frac18','\u2154':'frac23','\u2156':'frac25','\xBE':'frac34','\u2157':'frac35','\u215C':'frac38','\u2158':'frac45','\u215A':'frac56','\u215D':'frac58','\u215E':'frac78','\u2044':'frasl','\u2322':'frown','\uD835\uDCBB':'fscr','\u01F5':'gacute','\u0393':'Gamma','\u03B3':'gamma','\u03DC':'Gammad','\u2A86':'gap','\u011E':'Gbreve','\u011F':'gbreve','\u0122':'Gcedil','\u011C':'Gcirc','\u011D':'gcirc','\u0413':'Gcy','\u0433':'gcy','\u0120':'Gdot','\u0121':'gdot','\u2265':'ge','\u2267':'gE','\u2A8C':'gEl','\u22DB':'gel','\u2A7E':'ges','\u2AA9':'gescc','\u2A80':'gesdot','\u2A82':'gesdoto','\u2A84':'gesdotol','\u22DB\uFE00':'gesl','\u2A94':'gesles','\uD835\uDD0A':'Gfr','\uD835\uDD24':'gfr','\u226B':'gg','\u22D9':'Gg','\u2137':'gimel','\u0403':'GJcy','\u0453':'gjcy','\u2AA5':'gla','\u2277':'gl','\u2A92':'glE','\u2AA4':'glj','\u2A8A':'gnap','\u2A88':'gne','\u2269':'gnE','\u22E7':'gnsim','\uD835\uDD3E':'Gopf','\uD835\uDD58':'gopf','\u2AA2':'GreaterGreater','\u2273':'gsim','\uD835\uDCA2':'Gscr','\u210A':'gscr','\u2A8E':'gsime','\u2A90':'gsiml','\u2AA7':'gtcc','\u2A7A':'gtcir','>':'gt','\u22D7':'gtdot','\u2995':'gtlPar','\u2A7C':'gtquest','\u2978':'gtrarr','\u2269\uFE00':'gvnE','\u200A':'hairsp','\u210B':'Hscr','\u042A':'HARDcy','\u044A':'hardcy','\u2948':'harrcir','\u2194':'harr','\u21AD':'harrw','^':'Hat','\u210F':'hbar','\u0124':'Hcirc','\u0125':'hcirc','\u2665':'hearts','\u2026':'mldr','\u22B9':'hercon','\uD835\uDD25':'hfr','\u210C':'Hfr','\u2925':'searhk','\u2926':'swarhk','\u21FF':'hoarr','\u223B':'homtht','\u21A9':'larrhk','\u21AA':'rarrhk','\uD835\uDD59':'hopf','\u210D':'Hopf','\u2015':'horbar','\uD835\uDCBD':'hscr','\u0126':'Hstrok','\u0127':'hstrok','\u2043':'hybull','\xCD':'Iacute','\xED':'iacute','\u2063':'ic','\xCE':'Icirc','\xEE':'icirc','\u0418':'Icy','\u0438':'icy','\u0130':'Idot','\u0415':'IEcy','\u0435':'iecy','\xA1':'iexcl','\uD835\uDD26':'ifr','\u2111':'Im','\xCC':'Igrave','\xEC':'igrave','\u2148':'ii','\u2A0C':'qint','\u222D':'tint','\u29DC':'iinfin','\u2129':'iiota','\u0132':'IJlig','\u0133':'ijlig','\u012A':'Imacr','\u012B':'imacr','\u2110':'Iscr','\u0131':'imath','\u22B7':'imof','\u01B5':'imped','\u2105':'incare','\u221E':'infin','\u29DD':'infintie','\u22BA':'intcal','\u222B':'int','\u222C':'Int','\u2124':'Zopf','\u2A17':'intlarhk','\u2A3C':'iprod','\u2062':'it','\u0401':'IOcy','\u0451':'iocy','\u012E':'Iogon','\u012F':'iogon','\uD835\uDD40':'Iopf','\uD835\uDD5A':'iopf','\u0399':'Iota','\u03B9':'iota','\xBF':'iquest','\uD835\uDCBE':'iscr','\u22F5':'isindot','\u22F9':'isinE','\u22F4':'isins','\u22F3':'isinsv','\u0128':'Itilde','\u0129':'itilde','\u0406':'Iukcy','\u0456':'iukcy','\xCF':'Iuml','\xEF':'iuml','\u0134':'Jcirc','\u0135':'jcirc','\u0419':'Jcy','\u0439':'jcy','\uD835\uDD0D':'Jfr','\uD835\uDD27':'jfr','\u0237':'jmath','\uD835\uDD41':'Jopf','\uD835\uDD5B':'jopf','\uD835\uDCA5':'Jscr','\uD835\uDCBF':'jscr','\u0408':'Jsercy','\u0458':'jsercy','\u0404':'Jukcy','\u0454':'jukcy','\u039A':'Kappa','\u03BA':'kappa','\u03F0':'kappav','\u0136':'Kcedil','\u0137':'kcedil','\u041A':'Kcy','\u043A':'kcy','\uD835\uDD0E':'Kfr','\uD835\uDD28':'kfr','\u0138':'kgreen','\u0425':'KHcy','\u0445':'khcy','\u040C':'KJcy','\u045C':'kjcy','\uD835\uDD42':'Kopf','\uD835\uDD5C':'kopf','\uD835\uDCA6':'Kscr','\uD835\uDCC0':'kscr','\u21DA':'lAarr','\u0139':'Lacute','\u013A':'lacute','\u29B4':'laemptyv','\u2112':'Lscr','\u039B':'Lambda','\u03BB':'lambda','\u27E8':'lang','\u27EA':'Lang','\u2991':'langd','\u2A85':'lap','\xAB':'laquo','\u21E4':'larrb','\u291F':'larrbfs','\u2190':'larr','\u219E':'Larr','\u291D':'larrfs','\u21AB':'larrlp','\u2939':'larrpl','\u2973':'larrsim','\u21A2':'larrtl','\u2919':'latail','\u291B':'lAtail','\u2AAB':'lat','\u2AAD':'late','\u2AAD\uFE00':'lates','\u290C':'lbarr','\u290E':'lBarr','\u2772':'lbbrk','{':'lcub','[':'lsqb','\u298B':'lbrke','\u298F':'lbrksld','\u298D':'lbrkslu','\u013D':'Lcaron','\u013E':'lcaron','\u013B':'Lcedil','\u013C':'lcedil','\u2308':'lceil','\u041B':'Lcy','\u043B':'lcy','\u2936':'ldca','\u201C':'ldquo','\u2967':'ldrdhar','\u294B':'ldrushar','\u21B2':'ldsh','\u2264':'le','\u2266':'lE','\u21C6':'lrarr','\u27E6':'lobrk','\u2961':'LeftDownTeeVector','\u2959':'LeftDownVectorBar','\u230A':'lfloor','\u21BC':'lharu','\u21C7':'llarr','\u21CB':'lrhar','\u294E':'LeftRightVector','\u21A4':'mapstoleft','\u295A':'LeftTeeVector','\u22CB':'lthree','\u29CF':'LeftTriangleBar','\u22B2':'vltri','\u22B4':'ltrie','\u2951':'LeftUpDownVector','\u2960':'LeftUpTeeVector','\u2958':'LeftUpVectorBar','\u21BF':'uharl','\u2952':'LeftVectorBar','\u2A8B':'lEg','\u22DA':'leg','\u2A7D':'les','\u2AA8':'lescc','\u2A7F':'lesdot','\u2A81':'lesdoto','\u2A83':'lesdotor','\u22DA\uFE00':'lesg','\u2A93':'lesges','\u22D6':'ltdot','\u2276':'lg','\u2AA1':'LessLess','\u2272':'lsim','\u297C':'lfisht','\uD835\uDD0F':'Lfr','\uD835\uDD29':'lfr','\u2A91':'lgE','\u2962':'lHar','\u296A':'lharul','\u2584':'lhblk','\u0409':'LJcy','\u0459':'ljcy','\u226A':'ll','\u22D8':'Ll','\u296B':'llhard','\u25FA':'lltri','\u013F':'Lmidot','\u0140':'lmidot','\u23B0':'lmoust','\u2A89':'lnap','\u2A87':'lne','\u2268':'lnE','\u22E6':'lnsim','\u27EC':'loang','\u21FD':'loarr','\u27F5':'xlarr','\u27F7':'xharr','\u27FC':'xmap','\u27F6':'xrarr','\u21AC':'rarrlp','\u2985':'lopar','\uD835\uDD43':'Lopf','\uD835\uDD5D':'lopf','\u2A2D':'loplus','\u2A34':'lotimes','\u2217':'lowast','_':'lowbar','\u2199':'swarr','\u2198':'searr','\u25CA':'loz','(':'lpar','\u2993':'lparlt','\u296D':'lrhard','\u200E':'lrm','\u22BF':'lrtri','\u2039':'lsaquo','\uD835\uDCC1':'lscr','\u21B0':'lsh','\u2A8D':'lsime','\u2A8F':'lsimg','\u2018':'lsquo','\u201A':'sbquo','\u0141':'Lstrok','\u0142':'lstrok','\u2AA6':'ltcc','\u2A79':'ltcir','<':'lt','\u22C9':'ltimes','\u2976':'ltlarr','\u2A7B':'ltquest','\u25C3':'ltri','\u2996':'ltrPar','\u294A':'lurdshar','\u2966':'luruhar','\u2268\uFE00':'lvnE','\xAF':'macr','\u2642':'male','\u2720':'malt','\u2905':'Map','\u21A6':'map','\u21A5':'mapstoup','\u25AE':'marker','\u2A29':'mcomma','\u041C':'Mcy','\u043C':'mcy','\u2014':'mdash','\u223A':'mDDot','\u205F':'MediumSpace','\u2133':'Mscr','\uD835\uDD10':'Mfr','\uD835\uDD2A':'mfr','\u2127':'mho','\xB5':'micro','\u2AF0':'midcir','\u2223':'mid','\u2212':'minus','\u2A2A':'minusdu','\u2213':'mp','\u2ADB':'mlcp','\u22A7':'models','\uD835\uDD44':'Mopf','\uD835\uDD5E':'mopf','\uD835\uDCC2':'mscr','\u039C':'Mu','\u03BC':'mu','\u22B8':'mumap','\u0143':'Nacute','\u0144':'nacute','\u2220\u20D2':'nang','\u2249':'nap','\u2A70\u0338':'napE','\u224B\u0338':'napid','\u0149':'napos','\u266E':'natur','\u2115':'Nopf','\xA0':'nbsp','\u224E\u0338':'nbump','\u224F\u0338':'nbumpe','\u2A43':'ncap','\u0147':'Ncaron','\u0148':'ncaron','\u0145':'Ncedil','\u0146':'ncedil','\u2247':'ncong','\u2A6D\u0338':'ncongdot','\u2A42':'ncup','\u041D':'Ncy','\u043D':'ncy','\u2013':'ndash','\u2924':'nearhk','\u2197':'nearr','\u21D7':'neArr','\u2260':'ne','\u2250\u0338':'nedot','\u200B':'ZeroWidthSpace','\u2262':'nequiv','\u2928':'toea','\u2242\u0338':'nesim','\n':'NewLine','\u2204':'nexist','\uD835\uDD11':'Nfr','\uD835\uDD2B':'nfr','\u2267\u0338':'ngE','\u2271':'nge','\u2A7E\u0338':'nges','\u22D9\u0338':'nGg','\u2275':'ngsim','\u226B\u20D2':'nGt','\u226F':'ngt','\u226B\u0338':'nGtv','\u21AE':'nharr','\u21CE':'nhArr','\u2AF2':'nhpar','\u220B':'ni','\u22FC':'nis','\u22FA':'nisd','\u040A':'NJcy','\u045A':'njcy','\u219A':'nlarr','\u21CD':'nlArr','\u2025':'nldr','\u2266\u0338':'nlE','\u2270':'nle','\u2A7D\u0338':'nles','\u226E':'nlt','\u22D8\u0338':'nLl','\u2274':'nlsim','\u226A\u20D2':'nLt','\u22EA':'nltri','\u22EC':'nltrie','\u226A\u0338':'nLtv','\u2224':'nmid','\u2060':'NoBreak','\uD835\uDD5F':'nopf','\u2AEC':'Not','\xAC':'not','\u226D':'NotCupCap','\u2226':'npar','\u2209':'notin','\u2279':'ntgl','\u22F5\u0338':'notindot','\u22F9\u0338':'notinE','\u22F7':'notinvb','\u22F6':'notinvc','\u29CF\u0338':'NotLeftTriangleBar','\u2278':'ntlg','\u2AA2\u0338':'NotNestedGreaterGreater','\u2AA1\u0338':'NotNestedLessLess','\u220C':'notni','\u22FE':'notnivb','\u22FD':'notnivc','\u2280':'npr','\u2AAF\u0338':'npre','\u22E0':'nprcue','\u29D0\u0338':'NotRightTriangleBar','\u22EB':'nrtri','\u22ED':'nrtrie','\u228F\u0338':'NotSquareSubset','\u22E2':'nsqsube','\u2290\u0338':'NotSquareSuperset','\u22E3':'nsqsupe','\u2282\u20D2':'vnsub','\u2288':'nsube','\u2281':'nsc','\u2AB0\u0338':'nsce','\u22E1':'nsccue','\u227F\u0338':'NotSucceedsTilde','\u2283\u20D2':'vnsup','\u2289':'nsupe','\u2241':'nsim','\u2244':'nsime','\u2AFD\u20E5':'nparsl','\u2202\u0338':'npart','\u2A14':'npolint','\u2933\u0338':'nrarrc','\u219B':'nrarr','\u21CF':'nrArr','\u219D\u0338':'nrarrw','\uD835\uDCA9':'Nscr','\uD835\uDCC3':'nscr','\u2284':'nsub','\u2AC5\u0338':'nsubE','\u2285':'nsup','\u2AC6\u0338':'nsupE','\xD1':'Ntilde','\xF1':'ntilde','\u039D':'Nu','\u03BD':'nu','#':'num','\u2116':'numero','\u2007':'numsp','\u224D\u20D2':'nvap','\u22AC':'nvdash','\u22AD':'nvDash','\u22AE':'nVdash','\u22AF':'nVDash','\u2265\u20D2':'nvge','>\u20D2':'nvgt','\u2904':'nvHarr','\u29DE':'nvinfin','\u2902':'nvlArr','\u2264\u20D2':'nvle','<\u20D2':'nvlt','\u22B4\u20D2':'nvltrie','\u2903':'nvrArr','\u22B5\u20D2':'nvrtrie','\u223C\u20D2':'nvsim','\u2923':'nwarhk','\u2196':'nwarr','\u21D6':'nwArr','\u2927':'nwnear','\xD3':'Oacute','\xF3':'oacute','\xD4':'Ocirc','\xF4':'ocirc','\u041E':'Ocy','\u043E':'ocy','\u0150':'Odblac','\u0151':'odblac','\u2A38':'odiv','\u29BC':'odsold','\u0152':'OElig','\u0153':'oelig','\u29BF':'ofcir','\uD835\uDD12':'Ofr','\uD835\uDD2C':'ofr','\u02DB':'ogon','\xD2':'Ograve','\xF2':'ograve','\u29C1':'ogt','\u29B5':'ohbar','\u03A9':'ohm','\u29BE':'olcir','\u29BB':'olcross','\u203E':'oline','\u29C0':'olt','\u014C':'Omacr','\u014D':'omacr','\u03C9':'omega','\u039F':'Omicron','\u03BF':'omicron','\u29B6':'omid','\uD835\uDD46':'Oopf','\uD835\uDD60':'oopf','\u29B7':'opar','\u29B9':'operp','\u2A54':'Or','\u2228':'or','\u2A5D':'ord','\u2134':'oscr','\xAA':'ordf','\xBA':'ordm','\u22B6':'origof','\u2A56':'oror','\u2A57':'orslope','\u2A5B':'orv','\uD835\uDCAA':'Oscr','\xD8':'Oslash','\xF8':'oslash','\u2298':'osol','\xD5':'Otilde','\xF5':'otilde','\u2A36':'otimesas','\u2A37':'Otimes','\xD6':'Ouml','\xF6':'ouml','\u233D':'ovbar','\u23DE':'OverBrace','\u23B4':'tbrk','\u23DC':'OverParenthesis','\xB6':'para','\u2AF3':'parsim','\u2AFD':'parsl','\u2202':'part','\u041F':'Pcy','\u043F':'pcy','%':'percnt','.':'period','\u2030':'permil','\u2031':'pertenk','\uD835\uDD13':'Pfr','\uD835\uDD2D':'pfr','\u03A6':'Phi','\u03C6':'phi','\u03D5':'phiv','\u260E':'phone','\u03A0':'Pi','\u03C0':'pi','\u03D6':'piv','\u210E':'planckh','\u2A23':'plusacir','\u2A22':'pluscir','+':'plus','\u2A25':'plusdu','\u2A72':'pluse','\xB1':'pm','\u2A26':'plussim','\u2A27':'plustwo','\u2A15':'pointint','\uD835\uDD61':'popf','\u2119':'Popf','\xA3':'pound','\u2AB7':'prap','\u2ABB':'Pr','\u227A':'pr','\u227C':'prcue','\u2AAF':'pre','\u227E':'prsim','\u2AB9':'prnap','\u2AB5':'prnE','\u22E8':'prnsim','\u2AB3':'prE','\u2032':'prime','\u2033':'Prime','\u220F':'prod','\u232E':'profalar','\u2312':'profline','\u2313':'profsurf','\u221D':'prop','\u22B0':'prurel','\uD835\uDCAB':'Pscr','\uD835\uDCC5':'pscr','\u03A8':'Psi','\u03C8':'psi','\u2008':'puncsp','\uD835\uDD14':'Qfr','\uD835\uDD2E':'qfr','\uD835\uDD62':'qopf','\u211A':'Qopf','\u2057':'qprime','\uD835\uDCAC':'Qscr','\uD835\uDCC6':'qscr','\u2A16':'quatint','?':'quest','"':'quot','\u21DB':'rAarr','\u223D\u0331':'race','\u0154':'Racute','\u0155':'racute','\u221A':'Sqrt','\u29B3':'raemptyv','\u27E9':'rang','\u27EB':'Rang','\u2992':'rangd','\u29A5':'range','\xBB':'raquo','\u2975':'rarrap','\u21E5':'rarrb','\u2920':'rarrbfs','\u2933':'rarrc','\u2192':'rarr','\u21A0':'Rarr','\u291E':'rarrfs','\u2945':'rarrpl','\u2974':'rarrsim','\u2916':'Rarrtl','\u21A3':'rarrtl','\u219D':'rarrw','\u291A':'ratail','\u291C':'rAtail','\u2236':'ratio','\u2773':'rbbrk','}':'rcub',']':'rsqb','\u298C':'rbrke','\u298E':'rbrksld','\u2990':'rbrkslu','\u0158':'Rcaron','\u0159':'rcaron','\u0156':'Rcedil','\u0157':'rcedil','\u2309':'rceil','\u0420':'Rcy','\u0440':'rcy','\u2937':'rdca','\u2969':'rdldhar','\u21B3':'rdsh','\u211C':'Re','\u211B':'Rscr','\u211D':'Ropf','\u25AD':'rect','\u297D':'rfisht','\u230B':'rfloor','\uD835\uDD2F':'rfr','\u2964':'rHar','\u21C0':'rharu','\u296C':'rharul','\u03A1':'Rho','\u03C1':'rho','\u03F1':'rhov','\u21C4':'rlarr','\u27E7':'robrk','\u295D':'RightDownTeeVector','\u2955':'RightDownVectorBar','\u21C9':'rrarr','\u22A2':'vdash','\u295B':'RightTeeVector','\u22CC':'rthree','\u29D0':'RightTriangleBar','\u22B3':'vrtri','\u22B5':'rtrie','\u294F':'RightUpDownVector','\u295C':'RightUpTeeVector','\u2954':'RightUpVectorBar','\u21BE':'uharr','\u2953':'RightVectorBar','\u02DA':'ring','\u200F':'rlm','\u23B1':'rmoust','\u2AEE':'rnmid','\u27ED':'roang','\u21FE':'roarr','\u2986':'ropar','\uD835\uDD63':'ropf','\u2A2E':'roplus','\u2A35':'rotimes','\u2970':'RoundImplies',')':'rpar','\u2994':'rpargt','\u2A12':'rppolint','\u203A':'rsaquo','\uD835\uDCC7':'rscr','\u21B1':'rsh','\u22CA':'rtimes','\u25B9':'rtri','\u29CE':'rtriltri','\u29F4':'RuleDelayed','\u2968':'ruluhar','\u211E':'rx','\u015A':'Sacute','\u015B':'sacute','\u2AB8':'scap','\u0160':'Scaron','\u0161':'scaron','\u2ABC':'Sc','\u227B':'sc','\u227D':'sccue','\u2AB0':'sce','\u2AB4':'scE','\u015E':'Scedil','\u015F':'scedil','\u015C':'Scirc','\u015D':'scirc','\u2ABA':'scnap','\u2AB6':'scnE','\u22E9':'scnsim','\u2A13':'scpolint','\u227F':'scsim','\u0421':'Scy','\u0441':'scy','\u22C5':'sdot','\u2A66':'sdote','\u21D8':'seArr','\xA7':'sect',';':'semi','\u2929':'tosa','\u2736':'sext','\uD835\uDD16':'Sfr','\uD835\uDD30':'sfr','\u266F':'sharp','\u0429':'SHCHcy','\u0449':'shchcy','\u0428':'SHcy','\u0448':'shcy','\u2191':'uarr','\xAD':'shy','\u03A3':'Sigma','\u03C3':'sigma','\u03C2':'sigmaf','\u223C':'sim','\u2A6A':'simdot','\u2243':'sime','\u2A9E':'simg','\u2AA0':'simgE','\u2A9D':'siml','\u2A9F':'simlE','\u2246':'simne','\u2A24':'simplus','\u2972':'simrarr','\u2A33':'smashp','\u29E4':'smeparsl','\u2323':'smile','\u2AAA':'smt','\u2AAC':'smte','\u2AAC\uFE00':'smtes','\u042C':'SOFTcy','\u044C':'softcy','\u233F':'solbar','\u29C4':'solb','/':'sol','\uD835\uDD4A':'Sopf','\uD835\uDD64':'sopf','\u2660':'spades','\u2293':'sqcap','\u2293\uFE00':'sqcaps','\u2294':'sqcup','\u2294\uFE00':'sqcups','\u228F':'sqsub','\u2291':'sqsube','\u2290':'sqsup','\u2292':'sqsupe','\u25A1':'squ','\uD835\uDCAE':'Sscr','\uD835\uDCC8':'sscr','\u22C6':'Star','\u2606':'star','\u2282':'sub','\u22D0':'Sub','\u2ABD':'subdot','\u2AC5':'subE','\u2286':'sube','\u2AC3':'subedot','\u2AC1':'submult','\u2ACB':'subnE','\u228A':'subne','\u2ABF':'subplus','\u2979':'subrarr','\u2AC7':'subsim','\u2AD5':'subsub','\u2AD3':'subsup','\u2211':'sum','\u266A':'sung','\xB9':'sup1','\xB2':'sup2','\xB3':'sup3','\u2283':'sup','\u22D1':'Sup','\u2ABE':'supdot','\u2AD8':'supdsub','\u2AC6':'supE','\u2287':'supe','\u2AC4':'supedot','\u27C9':'suphsol','\u2AD7':'suphsub','\u297B':'suplarr','\u2AC2':'supmult','\u2ACC':'supnE','\u228B':'supne','\u2AC0':'supplus','\u2AC8':'supsim','\u2AD4':'supsub','\u2AD6':'supsup','\u21D9':'swArr','\u292A':'swnwar','\xDF':'szlig','\t':'Tab','\u2316':'target','\u03A4':'Tau','\u03C4':'tau','\u0164':'Tcaron','\u0165':'tcaron','\u0162':'Tcedil','\u0163':'tcedil','\u0422':'Tcy','\u0442':'tcy','\u20DB':'tdot','\u2315':'telrec','\uD835\uDD17':'Tfr','\uD835\uDD31':'tfr','\u2234':'there4','\u0398':'Theta','\u03B8':'theta','\u03D1':'thetav','\u205F\u200A':'ThickSpace','\u2009':'thinsp','\xDE':'THORN','\xFE':'thorn','\u2A31':'timesbar','\xD7':'times','\u2A30':'timesd','\u2336':'topbot','\u2AF1':'topcir','\uD835\uDD4B':'Topf','\uD835\uDD65':'topf','\u2ADA':'topfork','\u2034':'tprime','\u2122':'trade','\u25B5':'utri','\u225C':'trie','\u25EC':'tridot','\u2A3A':'triminus','\u2A39':'triplus','\u29CD':'trisb','\u2A3B':'tritime','\u23E2':'trpezium','\uD835\uDCAF':'Tscr','\uD835\uDCC9':'tscr','\u0426':'TScy','\u0446':'tscy','\u040B':'TSHcy','\u045B':'tshcy','\u0166':'Tstrok','\u0167':'tstrok','\xDA':'Uacute','\xFA':'uacute','\u219F':'Uarr','\u2949':'Uarrocir','\u040E':'Ubrcy','\u045E':'ubrcy','\u016C':'Ubreve','\u016D':'ubreve','\xDB':'Ucirc','\xFB':'ucirc','\u0423':'Ucy','\u0443':'ucy','\u21C5':'udarr','\u0170':'Udblac','\u0171':'udblac','\u296E':'udhar','\u297E':'ufisht','\uD835\uDD18':'Ufr','\uD835\uDD32':'ufr','\xD9':'Ugrave','\xF9':'ugrave','\u2963':'uHar','\u2580':'uhblk','\u231C':'ulcorn','\u230F':'ulcrop','\u25F8':'ultri','\u016A':'Umacr','\u016B':'umacr','\u23DF':'UnderBrace','\u23DD':'UnderParenthesis','\u228E':'uplus','\u0172':'Uogon','\u0173':'uogon','\uD835\uDD4C':'Uopf','\uD835\uDD66':'uopf','\u2912':'UpArrowBar','\u2195':'varr','\u03C5':'upsi','\u03D2':'Upsi','\u03A5':'Upsilon','\u21C8':'uuarr','\u231D':'urcorn','\u230E':'urcrop','\u016E':'Uring','\u016F':'uring','\u25F9':'urtri','\uD835\uDCB0':'Uscr','\uD835\uDCCA':'uscr','\u22F0':'utdot','\u0168':'Utilde','\u0169':'utilde','\xDC':'Uuml','\xFC':'uuml','\u29A7':'uwangle','\u299C':'vangrt','\u228A\uFE00':'vsubne','\u2ACB\uFE00':'vsubnE','\u228B\uFE00':'vsupne','\u2ACC\uFE00':'vsupnE','\u2AE8':'vBar','\u2AEB':'Vbar','\u2AE9':'vBarv','\u0412':'Vcy','\u0432':'vcy','\u22A9':'Vdash','\u22AB':'VDash','\u2AE6':'Vdashl','\u22BB':'veebar','\u225A':'veeeq','\u22EE':'vellip','|':'vert','\u2016':'Vert','\u2758':'VerticalSeparator','\u2240':'wr','\uD835\uDD19':'Vfr','\uD835\uDD33':'vfr','\uD835\uDD4D':'Vopf','\uD835\uDD67':'vopf','\uD835\uDCB1':'Vscr','\uD835\uDCCB':'vscr','\u22AA':'Vvdash','\u299A':'vzigzag','\u0174':'Wcirc','\u0175':'wcirc','\u2A5F':'wedbar','\u2259':'wedgeq','\u2118':'wp','\uD835\uDD1A':'Wfr','\uD835\uDD34':'wfr','\uD835\uDD4E':'Wopf','\uD835\uDD68':'wopf','\uD835\uDCB2':'Wscr','\uD835\uDCCC':'wscr','\uD835\uDD1B':'Xfr','\uD835\uDD35':'xfr','\u039E':'Xi','\u03BE':'xi','\u22FB':'xnis','\uD835\uDD4F':'Xopf','\uD835\uDD69':'xopf','\uD835\uDCB3':'Xscr','\uD835\uDCCD':'xscr','\xDD':'Yacute','\xFD':'yacute','\u042F':'YAcy','\u044F':'yacy','\u0176':'Ycirc','\u0177':'ycirc','\u042B':'Ycy','\u044B':'ycy','\xA5':'yen','\uD835\uDD1C':'Yfr','\uD835\uDD36':'yfr','\u0407':'YIcy','\u0457':'yicy','\uD835\uDD50':'Yopf','\uD835\uDD6A':'yopf','\uD835\uDCB4':'Yscr','\uD835\uDCCE':'yscr','\u042E':'YUcy','\u044E':'yucy','\xFF':'yuml','\u0178':'Yuml','\u0179':'Zacute','\u017A':'zacute','\u017D':'Zcaron','\u017E':'zcaron','\u0417':'Zcy','\u0437':'zcy','\u017B':'Zdot','\u017C':'zdot','\u2128':'Zfr','\u0396':'Zeta','\u03B6':'zeta','\uD835\uDD37':'zfr','\u0416':'ZHcy','\u0436':'zhcy','\u21DD':'zigrarr','\uD835\uDD6B':'zopf','\uD835\uDCB5':'Zscr','\uD835\uDCCF':'zscr','\u200D':'zwj','\u200C':'zwnj'};

	var regexEscape = /["&'<>`]/g;
	var escapeMap = {
		'"': '&quot;',
		'&': '&amp;',
		'\'': '&#x27;',
		'<': '&lt;',
		// See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
		// following is not strictly necessary unless it’s part of a tag or an
		// unquoted attribute value. We’re only escaping it to support those
		// situations, and for XML support.
		'>': '&gt;',
		// In Internet Explorer ≤ 8, the backtick character can be used
		// to break out of (un)quoted attribute values or HTML comments.
		// See http://html5sec.org/#102, http://html5sec.org/#108, and
		// http://html5sec.org/#133.
		'`': '&#x60;'
	};

	var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
	var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
	var regexDecode = /&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+);|&(Aacute|iacute|Uacute|plusmn|otilde|Otilde|Agrave|agrave|yacute|Yacute|oslash|Oslash|Atilde|atilde|brvbar|Ccedil|ccedil|ograve|curren|divide|Eacute|eacute|Ograve|oacute|Egrave|egrave|ugrave|frac12|frac14|frac34|Ugrave|Oacute|Iacute|ntilde|Ntilde|uacute|middot|Igrave|igrave|iquest|aacute|laquo|THORN|micro|iexcl|icirc|Icirc|Acirc|ucirc|ecirc|Ocirc|ocirc|Ecirc|Ucirc|aring|Aring|aelig|AElig|acute|pound|raquo|acirc|times|thorn|szlig|cedil|COPY|Auml|ordf|ordm|uuml|macr|Uuml|auml|Ouml|ouml|para|nbsp|Euml|quot|QUOT|euml|yuml|cent|sect|copy|sup1|sup2|sup3|Iuml|iuml|shy|eth|reg|not|yen|amp|AMP|REG|uml|ETH|deg|gt|GT|LT|lt)([=a-zA-Z0-9])?/g;
	var decodeMap = {'Aacute':'\xC1','aacute':'\xE1','Abreve':'\u0102','abreve':'\u0103','ac':'\u223E','acd':'\u223F','acE':'\u223E\u0333','Acirc':'\xC2','acirc':'\xE2','acute':'\xB4','Acy':'\u0410','acy':'\u0430','AElig':'\xC6','aelig':'\xE6','af':'\u2061','Afr':'\uD835\uDD04','afr':'\uD835\uDD1E','Agrave':'\xC0','agrave':'\xE0','alefsym':'\u2135','aleph':'\u2135','Alpha':'\u0391','alpha':'\u03B1','Amacr':'\u0100','amacr':'\u0101','amalg':'\u2A3F','amp':'&','AMP':'&','andand':'\u2A55','And':'\u2A53','and':'\u2227','andd':'\u2A5C','andslope':'\u2A58','andv':'\u2A5A','ang':'\u2220','ange':'\u29A4','angle':'\u2220','angmsdaa':'\u29A8','angmsdab':'\u29A9','angmsdac':'\u29AA','angmsdad':'\u29AB','angmsdae':'\u29AC','angmsdaf':'\u29AD','angmsdag':'\u29AE','angmsdah':'\u29AF','angmsd':'\u2221','angrt':'\u221F','angrtvb':'\u22BE','angrtvbd':'\u299D','angsph':'\u2222','angst':'\xC5','angzarr':'\u237C','Aogon':'\u0104','aogon':'\u0105','Aopf':'\uD835\uDD38','aopf':'\uD835\uDD52','apacir':'\u2A6F','ap':'\u2248','apE':'\u2A70','ape':'\u224A','apid':'\u224B','apos':'\'','ApplyFunction':'\u2061','approx':'\u2248','approxeq':'\u224A','Aring':'\xC5','aring':'\xE5','Ascr':'\uD835\uDC9C','ascr':'\uD835\uDCB6','Assign':'\u2254','ast':'*','asymp':'\u2248','asympeq':'\u224D','Atilde':'\xC3','atilde':'\xE3','Auml':'\xC4','auml':'\xE4','awconint':'\u2233','awint':'\u2A11','backcong':'\u224C','backepsilon':'\u03F6','backprime':'\u2035','backsim':'\u223D','backsimeq':'\u22CD','Backslash':'\u2216','Barv':'\u2AE7','barvee':'\u22BD','barwed':'\u2305','Barwed':'\u2306','barwedge':'\u2305','bbrk':'\u23B5','bbrktbrk':'\u23B6','bcong':'\u224C','Bcy':'\u0411','bcy':'\u0431','bdquo':'\u201E','becaus':'\u2235','because':'\u2235','Because':'\u2235','bemptyv':'\u29B0','bepsi':'\u03F6','bernou':'\u212C','Bernoullis':'\u212C','Beta':'\u0392','beta':'\u03B2','beth':'\u2136','between':'\u226C','Bfr':'\uD835\uDD05','bfr':'\uD835\uDD1F','bigcap':'\u22C2','bigcirc':'\u25EF','bigcup':'\u22C3','bigodot':'\u2A00','bigoplus':'\u2A01','bigotimes':'\u2A02','bigsqcup':'\u2A06','bigstar':'\u2605','bigtriangledown':'\u25BD','bigtriangleup':'\u25B3','biguplus':'\u2A04','bigvee':'\u22C1','bigwedge':'\u22C0','bkarow':'\u290D','blacklozenge':'\u29EB','blacksquare':'\u25AA','blacktriangle':'\u25B4','blacktriangledown':'\u25BE','blacktriangleleft':'\u25C2','blacktriangleright':'\u25B8','blank':'\u2423','blk12':'\u2592','blk14':'\u2591','blk34':'\u2593','block':'\u2588','bne':'=\u20E5','bnequiv':'\u2261\u20E5','bNot':'\u2AED','bnot':'\u2310','Bopf':'\uD835\uDD39','bopf':'\uD835\uDD53','bot':'\u22A5','bottom':'\u22A5','bowtie':'\u22C8','boxbox':'\u29C9','boxdl':'\u2510','boxdL':'\u2555','boxDl':'\u2556','boxDL':'\u2557','boxdr':'\u250C','boxdR':'\u2552','boxDr':'\u2553','boxDR':'\u2554','boxh':'\u2500','boxH':'\u2550','boxhd':'\u252C','boxHd':'\u2564','boxhD':'\u2565','boxHD':'\u2566','boxhu':'\u2534','boxHu':'\u2567','boxhU':'\u2568','boxHU':'\u2569','boxminus':'\u229F','boxplus':'\u229E','boxtimes':'\u22A0','boxul':'\u2518','boxuL':'\u255B','boxUl':'\u255C','boxUL':'\u255D','boxur':'\u2514','boxuR':'\u2558','boxUr':'\u2559','boxUR':'\u255A','boxv':'\u2502','boxV':'\u2551','boxvh':'\u253C','boxvH':'\u256A','boxVh':'\u256B','boxVH':'\u256C','boxvl':'\u2524','boxvL':'\u2561','boxVl':'\u2562','boxVL':'\u2563','boxvr':'\u251C','boxvR':'\u255E','boxVr':'\u255F','boxVR':'\u2560','bprime':'\u2035','breve':'\u02D8','Breve':'\u02D8','brvbar':'\xA6','bscr':'\uD835\uDCB7','Bscr':'\u212C','bsemi':'\u204F','bsim':'\u223D','bsime':'\u22CD','bsolb':'\u29C5','bsol':'\\','bsolhsub':'\u27C8','bull':'\u2022','bullet':'\u2022','bump':'\u224E','bumpE':'\u2AAE','bumpe':'\u224F','Bumpeq':'\u224E','bumpeq':'\u224F','Cacute':'\u0106','cacute':'\u0107','capand':'\u2A44','capbrcup':'\u2A49','capcap':'\u2A4B','cap':'\u2229','Cap':'\u22D2','capcup':'\u2A47','capdot':'\u2A40','CapitalDifferentialD':'\u2145','caps':'\u2229\uFE00','caret':'\u2041','caron':'\u02C7','Cayleys':'\u212D','ccaps':'\u2A4D','Ccaron':'\u010C','ccaron':'\u010D','Ccedil':'\xC7','ccedil':'\xE7','Ccirc':'\u0108','ccirc':'\u0109','Cconint':'\u2230','ccups':'\u2A4C','ccupssm':'\u2A50','Cdot':'\u010A','cdot':'\u010B','cedil':'\xB8','Cedilla':'\xB8','cemptyv':'\u29B2','cent':'\xA2','centerdot':'\xB7','CenterDot':'\xB7','cfr':'\uD835\uDD20','Cfr':'\u212D','CHcy':'\u0427','chcy':'\u0447','check':'\u2713','checkmark':'\u2713','Chi':'\u03A7','chi':'\u03C7','circ':'\u02C6','circeq':'\u2257','circlearrowleft':'\u21BA','circlearrowright':'\u21BB','circledast':'\u229B','circledcirc':'\u229A','circleddash':'\u229D','CircleDot':'\u2299','circledR':'\xAE','circledS':'\u24C8','CircleMinus':'\u2296','CirclePlus':'\u2295','CircleTimes':'\u2297','cir':'\u25CB','cirE':'\u29C3','cire':'\u2257','cirfnint':'\u2A10','cirmid':'\u2AEF','cirscir':'\u29C2','ClockwiseContourIntegral':'\u2232','CloseCurlyDoubleQuote':'\u201D','CloseCurlyQuote':'\u2019','clubs':'\u2663','clubsuit':'\u2663','colon':':','Colon':'\u2237','Colone':'\u2A74','colone':'\u2254','coloneq':'\u2254','comma':',','commat':'@','comp':'\u2201','compfn':'\u2218','complement':'\u2201','complexes':'\u2102','cong':'\u2245','congdot':'\u2A6D','Congruent':'\u2261','conint':'\u222E','Conint':'\u222F','ContourIntegral':'\u222E','copf':'\uD835\uDD54','Copf':'\u2102','coprod':'\u2210','Coproduct':'\u2210','copy':'\xA9','COPY':'\xA9','copysr':'\u2117','CounterClockwiseContourIntegral':'\u2233','crarr':'\u21B5','cross':'\u2717','Cross':'\u2A2F','Cscr':'\uD835\uDC9E','cscr':'\uD835\uDCB8','csub':'\u2ACF','csube':'\u2AD1','csup':'\u2AD0','csupe':'\u2AD2','ctdot':'\u22EF','cudarrl':'\u2938','cudarrr':'\u2935','cuepr':'\u22DE','cuesc':'\u22DF','cularr':'\u21B6','cularrp':'\u293D','cupbrcap':'\u2A48','cupcap':'\u2A46','CupCap':'\u224D','cup':'\u222A','Cup':'\u22D3','cupcup':'\u2A4A','cupdot':'\u228D','cupor':'\u2A45','cups':'\u222A\uFE00','curarr':'\u21B7','curarrm':'\u293C','curlyeqprec':'\u22DE','curlyeqsucc':'\u22DF','curlyvee':'\u22CE','curlywedge':'\u22CF','curren':'\xA4','curvearrowleft':'\u21B6','curvearrowright':'\u21B7','cuvee':'\u22CE','cuwed':'\u22CF','cwconint':'\u2232','cwint':'\u2231','cylcty':'\u232D','dagger':'\u2020','Dagger':'\u2021','daleth':'\u2138','darr':'\u2193','Darr':'\u21A1','dArr':'\u21D3','dash':'\u2010','Dashv':'\u2AE4','dashv':'\u22A3','dbkarow':'\u290F','dblac':'\u02DD','Dcaron':'\u010E','dcaron':'\u010F','Dcy':'\u0414','dcy':'\u0434','ddagger':'\u2021','ddarr':'\u21CA','DD':'\u2145','dd':'\u2146','DDotrahd':'\u2911','ddotseq':'\u2A77','deg':'\xB0','Del':'\u2207','Delta':'\u0394','delta':'\u03B4','demptyv':'\u29B1','dfisht':'\u297F','Dfr':'\uD835\uDD07','dfr':'\uD835\uDD21','dHar':'\u2965','dharl':'\u21C3','dharr':'\u21C2','DiacriticalAcute':'\xB4','DiacriticalDot':'\u02D9','DiacriticalDoubleAcute':'\u02DD','DiacriticalGrave':'`','DiacriticalTilde':'\u02DC','diam':'\u22C4','diamond':'\u22C4','Diamond':'\u22C4','diamondsuit':'\u2666','diams':'\u2666','die':'\xA8','DifferentialD':'\u2146','digamma':'\u03DD','disin':'\u22F2','div':'\xF7','divide':'\xF7','divideontimes':'\u22C7','divonx':'\u22C7','DJcy':'\u0402','djcy':'\u0452','dlcorn':'\u231E','dlcrop':'\u230D','dollar':'$','Dopf':'\uD835\uDD3B','dopf':'\uD835\uDD55','Dot':'\xA8','dot':'\u02D9','DotDot':'\u20DC','doteq':'\u2250','doteqdot':'\u2251','DotEqual':'\u2250','dotminus':'\u2238','dotplus':'\u2214','dotsquare':'\u22A1','doublebarwedge':'\u2306','DoubleContourIntegral':'\u222F','DoubleDot':'\xA8','DoubleDownArrow':'\u21D3','DoubleLeftArrow':'\u21D0','DoubleLeftRightArrow':'\u21D4','DoubleLeftTee':'\u2AE4','DoubleLongLeftArrow':'\u27F8','DoubleLongLeftRightArrow':'\u27FA','DoubleLongRightArrow':'\u27F9','DoubleRightArrow':'\u21D2','DoubleRightTee':'\u22A8','DoubleUpArrow':'\u21D1','DoubleUpDownArrow':'\u21D5','DoubleVerticalBar':'\u2225','DownArrowBar':'\u2913','downarrow':'\u2193','DownArrow':'\u2193','Downarrow':'\u21D3','DownArrowUpArrow':'\u21F5','DownBreve':'\u0311','downdownarrows':'\u21CA','downharpoonleft':'\u21C3','downharpoonright':'\u21C2','DownLeftRightVector':'\u2950','DownLeftTeeVector':'\u295E','DownLeftVectorBar':'\u2956','DownLeftVector':'\u21BD','DownRightTeeVector':'\u295F','DownRightVectorBar':'\u2957','DownRightVector':'\u21C1','DownTeeArrow':'\u21A7','DownTee':'\u22A4','drbkarow':'\u2910','drcorn':'\u231F','drcrop':'\u230C','Dscr':'\uD835\uDC9F','dscr':'\uD835\uDCB9','DScy':'\u0405','dscy':'\u0455','dsol':'\u29F6','Dstrok':'\u0110','dstrok':'\u0111','dtdot':'\u22F1','dtri':'\u25BF','dtrif':'\u25BE','duarr':'\u21F5','duhar':'\u296F','dwangle':'\u29A6','DZcy':'\u040F','dzcy':'\u045F','dzigrarr':'\u27FF','Eacute':'\xC9','eacute':'\xE9','easter':'\u2A6E','Ecaron':'\u011A','ecaron':'\u011B','Ecirc':'\xCA','ecirc':'\xEA','ecir':'\u2256','ecolon':'\u2255','Ecy':'\u042D','ecy':'\u044D','eDDot':'\u2A77','Edot':'\u0116','edot':'\u0117','eDot':'\u2251','ee':'\u2147','efDot':'\u2252','Efr':'\uD835\uDD08','efr':'\uD835\uDD22','eg':'\u2A9A','Egrave':'\xC8','egrave':'\xE8','egs':'\u2A96','egsdot':'\u2A98','el':'\u2A99','Element':'\u2208','elinters':'\u23E7','ell':'\u2113','els':'\u2A95','elsdot':'\u2A97','Emacr':'\u0112','emacr':'\u0113','empty':'\u2205','emptyset':'\u2205','EmptySmallSquare':'\u25FB','emptyv':'\u2205','EmptyVerySmallSquare':'\u25AB','emsp13':'\u2004','emsp14':'\u2005','emsp':'\u2003','ENG':'\u014A','eng':'\u014B','ensp':'\u2002','Eogon':'\u0118','eogon':'\u0119','Eopf':'\uD835\uDD3C','eopf':'\uD835\uDD56','epar':'\u22D5','eparsl':'\u29E3','eplus':'\u2A71','epsi':'\u03B5','Epsilon':'\u0395','epsilon':'\u03B5','epsiv':'\u03F5','eqcirc':'\u2256','eqcolon':'\u2255','eqsim':'\u2242','eqslantgtr':'\u2A96','eqslantless':'\u2A95','Equal':'\u2A75','equals':'=','EqualTilde':'\u2242','equest':'\u225F','Equilibrium':'\u21CC','equiv':'\u2261','equivDD':'\u2A78','eqvparsl':'\u29E5','erarr':'\u2971','erDot':'\u2253','escr':'\u212F','Escr':'\u2130','esdot':'\u2250','Esim':'\u2A73','esim':'\u2242','Eta':'\u0397','eta':'\u03B7','ETH':'\xD0','eth':'\xF0','Euml':'\xCB','euml':'\xEB','euro':'\u20AC','excl':'!','exist':'\u2203','Exists':'\u2203','expectation':'\u2130','exponentiale':'\u2147','ExponentialE':'\u2147','fallingdotseq':'\u2252','Fcy':'\u0424','fcy':'\u0444','female':'\u2640','ffilig':'\uFB03','fflig':'\uFB00','ffllig':'\uFB04','Ffr':'\uD835\uDD09','ffr':'\uD835\uDD23','filig':'\uFB01','FilledSmallSquare':'\u25FC','FilledVerySmallSquare':'\u25AA','fjlig':'fj','flat':'\u266D','fllig':'\uFB02','fltns':'\u25B1','fnof':'\u0192','Fopf':'\uD835\uDD3D','fopf':'\uD835\uDD57','forall':'\u2200','ForAll':'\u2200','fork':'\u22D4','forkv':'\u2AD9','Fouriertrf':'\u2131','fpartint':'\u2A0D','frac12':'\xBD','frac13':'\u2153','frac14':'\xBC','frac15':'\u2155','frac16':'\u2159','frac18':'\u215B','frac23':'\u2154','frac25':'\u2156','frac34':'\xBE','frac35':'\u2157','frac38':'\u215C','frac45':'\u2158','frac56':'\u215A','frac58':'\u215D','frac78':'\u215E','frasl':'\u2044','frown':'\u2322','fscr':'\uD835\uDCBB','Fscr':'\u2131','gacute':'\u01F5','Gamma':'\u0393','gamma':'\u03B3','Gammad':'\u03DC','gammad':'\u03DD','gap':'\u2A86','Gbreve':'\u011E','gbreve':'\u011F','Gcedil':'\u0122','Gcirc':'\u011C','gcirc':'\u011D','Gcy':'\u0413','gcy':'\u0433','Gdot':'\u0120','gdot':'\u0121','ge':'\u2265','gE':'\u2267','gEl':'\u2A8C','gel':'\u22DB','geq':'\u2265','geqq':'\u2267','geqslant':'\u2A7E','gescc':'\u2AA9','ges':'\u2A7E','gesdot':'\u2A80','gesdoto':'\u2A82','gesdotol':'\u2A84','gesl':'\u22DB\uFE00','gesles':'\u2A94','Gfr':'\uD835\uDD0A','gfr':'\uD835\uDD24','gg':'\u226B','Gg':'\u22D9','ggg':'\u22D9','gimel':'\u2137','GJcy':'\u0403','gjcy':'\u0453','gla':'\u2AA5','gl':'\u2277','glE':'\u2A92','glj':'\u2AA4','gnap':'\u2A8A','gnapprox':'\u2A8A','gne':'\u2A88','gnE':'\u2269','gneq':'\u2A88','gneqq':'\u2269','gnsim':'\u22E7','Gopf':'\uD835\uDD3E','gopf':'\uD835\uDD58','grave':'`','GreaterEqual':'\u2265','GreaterEqualLess':'\u22DB','GreaterFullEqual':'\u2267','GreaterGreater':'\u2AA2','GreaterLess':'\u2277','GreaterSlantEqual':'\u2A7E','GreaterTilde':'\u2273','Gscr':'\uD835\uDCA2','gscr':'\u210A','gsim':'\u2273','gsime':'\u2A8E','gsiml':'\u2A90','gtcc':'\u2AA7','gtcir':'\u2A7A','gt':'>','GT':'>','Gt':'\u226B','gtdot':'\u22D7','gtlPar':'\u2995','gtquest':'\u2A7C','gtrapprox':'\u2A86','gtrarr':'\u2978','gtrdot':'\u22D7','gtreqless':'\u22DB','gtreqqless':'\u2A8C','gtrless':'\u2277','gtrsim':'\u2273','gvertneqq':'\u2269\uFE00','gvnE':'\u2269\uFE00','Hacek':'\u02C7','hairsp':'\u200A','half':'\xBD','hamilt':'\u210B','HARDcy':'\u042A','hardcy':'\u044A','harrcir':'\u2948','harr':'\u2194','hArr':'\u21D4','harrw':'\u21AD','Hat':'^','hbar':'\u210F','Hcirc':'\u0124','hcirc':'\u0125','hearts':'\u2665','heartsuit':'\u2665','hellip':'\u2026','hercon':'\u22B9','hfr':'\uD835\uDD25','Hfr':'\u210C','HilbertSpace':'\u210B','hksearow':'\u2925','hkswarow':'\u2926','hoarr':'\u21FF','homtht':'\u223B','hookleftarrow':'\u21A9','hookrightarrow':'\u21AA','hopf':'\uD835\uDD59','Hopf':'\u210D','horbar':'\u2015','HorizontalLine':'\u2500','hscr':'\uD835\uDCBD','Hscr':'\u210B','hslash':'\u210F','Hstrok':'\u0126','hstrok':'\u0127','HumpDownHump':'\u224E','HumpEqual':'\u224F','hybull':'\u2043','hyphen':'\u2010','Iacute':'\xCD','iacute':'\xED','ic':'\u2063','Icirc':'\xCE','icirc':'\xEE','Icy':'\u0418','icy':'\u0438','Idot':'\u0130','IEcy':'\u0415','iecy':'\u0435','iexcl':'\xA1','iff':'\u21D4','ifr':'\uD835\uDD26','Ifr':'\u2111','Igrave':'\xCC','igrave':'\xEC','ii':'\u2148','iiiint':'\u2A0C','iiint':'\u222D','iinfin':'\u29DC','iiota':'\u2129','IJlig':'\u0132','ijlig':'\u0133','Imacr':'\u012A','imacr':'\u012B','image':'\u2111','ImaginaryI':'\u2148','imagline':'\u2110','imagpart':'\u2111','imath':'\u0131','Im':'\u2111','imof':'\u22B7','imped':'\u01B5','Implies':'\u21D2','incare':'\u2105','in':'\u2208','infin':'\u221E','infintie':'\u29DD','inodot':'\u0131','intcal':'\u22BA','int':'\u222B','Int':'\u222C','integers':'\u2124','Integral':'\u222B','intercal':'\u22BA','Intersection':'\u22C2','intlarhk':'\u2A17','intprod':'\u2A3C','InvisibleComma':'\u2063','InvisibleTimes':'\u2062','IOcy':'\u0401','iocy':'\u0451','Iogon':'\u012E','iogon':'\u012F','Iopf':'\uD835\uDD40','iopf':'\uD835\uDD5A','Iota':'\u0399','iota':'\u03B9','iprod':'\u2A3C','iquest':'\xBF','iscr':'\uD835\uDCBE','Iscr':'\u2110','isin':'\u2208','isindot':'\u22F5','isinE':'\u22F9','isins':'\u22F4','isinsv':'\u22F3','isinv':'\u2208','it':'\u2062','Itilde':'\u0128','itilde':'\u0129','Iukcy':'\u0406','iukcy':'\u0456','Iuml':'\xCF','iuml':'\xEF','Jcirc':'\u0134','jcirc':'\u0135','Jcy':'\u0419','jcy':'\u0439','Jfr':'\uD835\uDD0D','jfr':'\uD835\uDD27','jmath':'\u0237','Jopf':'\uD835\uDD41','jopf':'\uD835\uDD5B','Jscr':'\uD835\uDCA5','jscr':'\uD835\uDCBF','Jsercy':'\u0408','jsercy':'\u0458','Jukcy':'\u0404','jukcy':'\u0454','Kappa':'\u039A','kappa':'\u03BA','kappav':'\u03F0','Kcedil':'\u0136','kcedil':'\u0137','Kcy':'\u041A','kcy':'\u043A','Kfr':'\uD835\uDD0E','kfr':'\uD835\uDD28','kgreen':'\u0138','KHcy':'\u0425','khcy':'\u0445','KJcy':'\u040C','kjcy':'\u045C','Kopf':'\uD835\uDD42','kopf':'\uD835\uDD5C','Kscr':'\uD835\uDCA6','kscr':'\uD835\uDCC0','lAarr':'\u21DA','Lacute':'\u0139','lacute':'\u013A','laemptyv':'\u29B4','lagran':'\u2112','Lambda':'\u039B','lambda':'\u03BB','lang':'\u27E8','Lang':'\u27EA','langd':'\u2991','langle':'\u27E8','lap':'\u2A85','Laplacetrf':'\u2112','laquo':'\xAB','larrb':'\u21E4','larrbfs':'\u291F','larr':'\u2190','Larr':'\u219E','lArr':'\u21D0','larrfs':'\u291D','larrhk':'\u21A9','larrlp':'\u21AB','larrpl':'\u2939','larrsim':'\u2973','larrtl':'\u21A2','latail':'\u2919','lAtail':'\u291B','lat':'\u2AAB','late':'\u2AAD','lates':'\u2AAD\uFE00','lbarr':'\u290C','lBarr':'\u290E','lbbrk':'\u2772','lbrace':'{','lbrack':'[','lbrke':'\u298B','lbrksld':'\u298F','lbrkslu':'\u298D','Lcaron':'\u013D','lcaron':'\u013E','Lcedil':'\u013B','lcedil':'\u013C','lceil':'\u2308','lcub':'{','Lcy':'\u041B','lcy':'\u043B','ldca':'\u2936','ldquo':'\u201C','ldquor':'\u201E','ldrdhar':'\u2967','ldrushar':'\u294B','ldsh':'\u21B2','le':'\u2264','lE':'\u2266','LeftAngleBracket':'\u27E8','LeftArrowBar':'\u21E4','leftarrow':'\u2190','LeftArrow':'\u2190','Leftarrow':'\u21D0','LeftArrowRightArrow':'\u21C6','leftarrowtail':'\u21A2','LeftCeiling':'\u2308','LeftDoubleBracket':'\u27E6','LeftDownTeeVector':'\u2961','LeftDownVectorBar':'\u2959','LeftDownVector':'\u21C3','LeftFloor':'\u230A','leftharpoondown':'\u21BD','leftharpoonup':'\u21BC','leftleftarrows':'\u21C7','leftrightarrow':'\u2194','LeftRightArrow':'\u2194','Leftrightarrow':'\u21D4','leftrightarrows':'\u21C6','leftrightharpoons':'\u21CB','leftrightsquigarrow':'\u21AD','LeftRightVector':'\u294E','LeftTeeArrow':'\u21A4','LeftTee':'\u22A3','LeftTeeVector':'\u295A','leftthreetimes':'\u22CB','LeftTriangleBar':'\u29CF','LeftTriangle':'\u22B2','LeftTriangleEqual':'\u22B4','LeftUpDownVector':'\u2951','LeftUpTeeVector':'\u2960','LeftUpVectorBar':'\u2958','LeftUpVector':'\u21BF','LeftVectorBar':'\u2952','LeftVector':'\u21BC','lEg':'\u2A8B','leg':'\u22DA','leq':'\u2264','leqq':'\u2266','leqslant':'\u2A7D','lescc':'\u2AA8','les':'\u2A7D','lesdot':'\u2A7F','lesdoto':'\u2A81','lesdotor':'\u2A83','lesg':'\u22DA\uFE00','lesges':'\u2A93','lessapprox':'\u2A85','lessdot':'\u22D6','lesseqgtr':'\u22DA','lesseqqgtr':'\u2A8B','LessEqualGreater':'\u22DA','LessFullEqual':'\u2266','LessGreater':'\u2276','lessgtr':'\u2276','LessLess':'\u2AA1','lesssim':'\u2272','LessSlantEqual':'\u2A7D','LessTilde':'\u2272','lfisht':'\u297C','lfloor':'\u230A','Lfr':'\uD835\uDD0F','lfr':'\uD835\uDD29','lg':'\u2276','lgE':'\u2A91','lHar':'\u2962','lhard':'\u21BD','lharu':'\u21BC','lharul':'\u296A','lhblk':'\u2584','LJcy':'\u0409','ljcy':'\u0459','llarr':'\u21C7','ll':'\u226A','Ll':'\u22D8','llcorner':'\u231E','Lleftarrow':'\u21DA','llhard':'\u296B','lltri':'\u25FA','Lmidot':'\u013F','lmidot':'\u0140','lmoustache':'\u23B0','lmoust':'\u23B0','lnap':'\u2A89','lnapprox':'\u2A89','lne':'\u2A87','lnE':'\u2268','lneq':'\u2A87','lneqq':'\u2268','lnsim':'\u22E6','loang':'\u27EC','loarr':'\u21FD','lobrk':'\u27E6','longleftarrow':'\u27F5','LongLeftArrow':'\u27F5','Longleftarrow':'\u27F8','longleftrightarrow':'\u27F7','LongLeftRightArrow':'\u27F7','Longleftrightarrow':'\u27FA','longmapsto':'\u27FC','longrightarrow':'\u27F6','LongRightArrow':'\u27F6','Longrightarrow':'\u27F9','looparrowleft':'\u21AB','looparrowright':'\u21AC','lopar':'\u2985','Lopf':'\uD835\uDD43','lopf':'\uD835\uDD5D','loplus':'\u2A2D','lotimes':'\u2A34','lowast':'\u2217','lowbar':'_','LowerLeftArrow':'\u2199','LowerRightArrow':'\u2198','loz':'\u25CA','lozenge':'\u25CA','lozf':'\u29EB','lpar':'(','lparlt':'\u2993','lrarr':'\u21C6','lrcorner':'\u231F','lrhar':'\u21CB','lrhard':'\u296D','lrm':'\u200E','lrtri':'\u22BF','lsaquo':'\u2039','lscr':'\uD835\uDCC1','Lscr':'\u2112','lsh':'\u21B0','Lsh':'\u21B0','lsim':'\u2272','lsime':'\u2A8D','lsimg':'\u2A8F','lsqb':'[','lsquo':'\u2018','lsquor':'\u201A','Lstrok':'\u0141','lstrok':'\u0142','ltcc':'\u2AA6','ltcir':'\u2A79','lt':'<','LT':'<','Lt':'\u226A','ltdot':'\u22D6','lthree':'\u22CB','ltimes':'\u22C9','ltlarr':'\u2976','ltquest':'\u2A7B','ltri':'\u25C3','ltrie':'\u22B4','ltrif':'\u25C2','ltrPar':'\u2996','lurdshar':'\u294A','luruhar':'\u2966','lvertneqq':'\u2268\uFE00','lvnE':'\u2268\uFE00','macr':'\xAF','male':'\u2642','malt':'\u2720','maltese':'\u2720','Map':'\u2905','map':'\u21A6','mapsto':'\u21A6','mapstodown':'\u21A7','mapstoleft':'\u21A4','mapstoup':'\u21A5','marker':'\u25AE','mcomma':'\u2A29','Mcy':'\u041C','mcy':'\u043C','mdash':'\u2014','mDDot':'\u223A','measuredangle':'\u2221','MediumSpace':'\u205F','Mellintrf':'\u2133','Mfr':'\uD835\uDD10','mfr':'\uD835\uDD2A','mho':'\u2127','micro':'\xB5','midast':'*','midcir':'\u2AF0','mid':'\u2223','middot':'\xB7','minusb':'\u229F','minus':'\u2212','minusd':'\u2238','minusdu':'\u2A2A','MinusPlus':'\u2213','mlcp':'\u2ADB','mldr':'\u2026','mnplus':'\u2213','models':'\u22A7','Mopf':'\uD835\uDD44','mopf':'\uD835\uDD5E','mp':'\u2213','mscr':'\uD835\uDCC2','Mscr':'\u2133','mstpos':'\u223E','Mu':'\u039C','mu':'\u03BC','multimap':'\u22B8','mumap':'\u22B8','nabla':'\u2207','Nacute':'\u0143','nacute':'\u0144','nang':'\u2220\u20D2','nap':'\u2249','napE':'\u2A70\u0338','napid':'\u224B\u0338','napos':'\u0149','napprox':'\u2249','natural':'\u266E','naturals':'\u2115','natur':'\u266E','nbsp':'\xA0','nbump':'\u224E\u0338','nbumpe':'\u224F\u0338','ncap':'\u2A43','Ncaron':'\u0147','ncaron':'\u0148','Ncedil':'\u0145','ncedil':'\u0146','ncong':'\u2247','ncongdot':'\u2A6D\u0338','ncup':'\u2A42','Ncy':'\u041D','ncy':'\u043D','ndash':'\u2013','nearhk':'\u2924','nearr':'\u2197','neArr':'\u21D7','nearrow':'\u2197','ne':'\u2260','nedot':'\u2250\u0338','NegativeMediumSpace':'\u200B','NegativeThickSpace':'\u200B','NegativeThinSpace':'\u200B','NegativeVeryThinSpace':'\u200B','nequiv':'\u2262','nesear':'\u2928','nesim':'\u2242\u0338','NestedGreaterGreater':'\u226B','NestedLessLess':'\u226A','NewLine':'\n','nexist':'\u2204','nexists':'\u2204','Nfr':'\uD835\uDD11','nfr':'\uD835\uDD2B','ngE':'\u2267\u0338','nge':'\u2271','ngeq':'\u2271','ngeqq':'\u2267\u0338','ngeqslant':'\u2A7E\u0338','nges':'\u2A7E\u0338','nGg':'\u22D9\u0338','ngsim':'\u2275','nGt':'\u226B\u20D2','ngt':'\u226F','ngtr':'\u226F','nGtv':'\u226B\u0338','nharr':'\u21AE','nhArr':'\u21CE','nhpar':'\u2AF2','ni':'\u220B','nis':'\u22FC','nisd':'\u22FA','niv':'\u220B','NJcy':'\u040A','njcy':'\u045A','nlarr':'\u219A','nlArr':'\u21CD','nldr':'\u2025','nlE':'\u2266\u0338','nle':'\u2270','nleftarrow':'\u219A','nLeftarrow':'\u21CD','nleftrightarrow':'\u21AE','nLeftrightarrow':'\u21CE','nleq':'\u2270','nleqq':'\u2266\u0338','nleqslant':'\u2A7D\u0338','nles':'\u2A7D\u0338','nless':'\u226E','nLl':'\u22D8\u0338','nlsim':'\u2274','nLt':'\u226A\u20D2','nlt':'\u226E','nltri':'\u22EA','nltrie':'\u22EC','nLtv':'\u226A\u0338','nmid':'\u2224','NoBreak':'\u2060','NonBreakingSpace':'\xA0','nopf':'\uD835\uDD5F','Nopf':'\u2115','Not':'\u2AEC','not':'\xAC','NotCongruent':'\u2262','NotCupCap':'\u226D','NotDoubleVerticalBar':'\u2226','NotElement':'\u2209','NotEqual':'\u2260','NotEqualTilde':'\u2242\u0338','NotExists':'\u2204','NotGreater':'\u226F','NotGreaterEqual':'\u2271','NotGreaterFullEqual':'\u2267\u0338','NotGreaterGreater':'\u226B\u0338','NotGreaterLess':'\u2279','NotGreaterSlantEqual':'\u2A7E\u0338','NotGreaterTilde':'\u2275','NotHumpDownHump':'\u224E\u0338','NotHumpEqual':'\u224F\u0338','notin':'\u2209','notindot':'\u22F5\u0338','notinE':'\u22F9\u0338','notinva':'\u2209','notinvb':'\u22F7','notinvc':'\u22F6','NotLeftTriangleBar':'\u29CF\u0338','NotLeftTriangle':'\u22EA','NotLeftTriangleEqual':'\u22EC','NotLess':'\u226E','NotLessEqual':'\u2270','NotLessGreater':'\u2278','NotLessLess':'\u226A\u0338','NotLessSlantEqual':'\u2A7D\u0338','NotLessTilde':'\u2274','NotNestedGreaterGreater':'\u2AA2\u0338','NotNestedLessLess':'\u2AA1\u0338','notni':'\u220C','notniva':'\u220C','notnivb':'\u22FE','notnivc':'\u22FD','NotPrecedes':'\u2280','NotPrecedesEqual':'\u2AAF\u0338','NotPrecedesSlantEqual':'\u22E0','NotReverseElement':'\u220C','NotRightTriangleBar':'\u29D0\u0338','NotRightTriangle':'\u22EB','NotRightTriangleEqual':'\u22ED','NotSquareSubset':'\u228F\u0338','NotSquareSubsetEqual':'\u22E2','NotSquareSuperset':'\u2290\u0338','NotSquareSupersetEqual':'\u22E3','NotSubset':'\u2282\u20D2','NotSubsetEqual':'\u2288','NotSucceeds':'\u2281','NotSucceedsEqual':'\u2AB0\u0338','NotSucceedsSlantEqual':'\u22E1','NotSucceedsTilde':'\u227F\u0338','NotSuperset':'\u2283\u20D2','NotSupersetEqual':'\u2289','NotTilde':'\u2241','NotTildeEqual':'\u2244','NotTildeFullEqual':'\u2247','NotTildeTilde':'\u2249','NotVerticalBar':'\u2224','nparallel':'\u2226','npar':'\u2226','nparsl':'\u2AFD\u20E5','npart':'\u2202\u0338','npolint':'\u2A14','npr':'\u2280','nprcue':'\u22E0','nprec':'\u2280','npreceq':'\u2AAF\u0338','npre':'\u2AAF\u0338','nrarrc':'\u2933\u0338','nrarr':'\u219B','nrArr':'\u21CF','nrarrw':'\u219D\u0338','nrightarrow':'\u219B','nRightarrow':'\u21CF','nrtri':'\u22EB','nrtrie':'\u22ED','nsc':'\u2281','nsccue':'\u22E1','nsce':'\u2AB0\u0338','Nscr':'\uD835\uDCA9','nscr':'\uD835\uDCC3','nshortmid':'\u2224','nshortparallel':'\u2226','nsim':'\u2241','nsime':'\u2244','nsimeq':'\u2244','nsmid':'\u2224','nspar':'\u2226','nsqsube':'\u22E2','nsqsupe':'\u22E3','nsub':'\u2284','nsubE':'\u2AC5\u0338','nsube':'\u2288','nsubset':'\u2282\u20D2','nsubseteq':'\u2288','nsubseteqq':'\u2AC5\u0338','nsucc':'\u2281','nsucceq':'\u2AB0\u0338','nsup':'\u2285','nsupE':'\u2AC6\u0338','nsupe':'\u2289','nsupset':'\u2283\u20D2','nsupseteq':'\u2289','nsupseteqq':'\u2AC6\u0338','ntgl':'\u2279','Ntilde':'\xD1','ntilde':'\xF1','ntlg':'\u2278','ntriangleleft':'\u22EA','ntrianglelefteq':'\u22EC','ntriangleright':'\u22EB','ntrianglerighteq':'\u22ED','Nu':'\u039D','nu':'\u03BD','num':'#','numero':'\u2116','numsp':'\u2007','nvap':'\u224D\u20D2','nvdash':'\u22AC','nvDash':'\u22AD','nVdash':'\u22AE','nVDash':'\u22AF','nvge':'\u2265\u20D2','nvgt':'>\u20D2','nvHarr':'\u2904','nvinfin':'\u29DE','nvlArr':'\u2902','nvle':'\u2264\u20D2','nvlt':'<\u20D2','nvltrie':'\u22B4\u20D2','nvrArr':'\u2903','nvrtrie':'\u22B5\u20D2','nvsim':'\u223C\u20D2','nwarhk':'\u2923','nwarr':'\u2196','nwArr':'\u21D6','nwarrow':'\u2196','nwnear':'\u2927','Oacute':'\xD3','oacute':'\xF3','oast':'\u229B','Ocirc':'\xD4','ocirc':'\xF4','ocir':'\u229A','Ocy':'\u041E','ocy':'\u043E','odash':'\u229D','Odblac':'\u0150','odblac':'\u0151','odiv':'\u2A38','odot':'\u2299','odsold':'\u29BC','OElig':'\u0152','oelig':'\u0153','ofcir':'\u29BF','Ofr':'\uD835\uDD12','ofr':'\uD835\uDD2C','ogon':'\u02DB','Ograve':'\xD2','ograve':'\xF2','ogt':'\u29C1','ohbar':'\u29B5','ohm':'\u03A9','oint':'\u222E','olarr':'\u21BA','olcir':'\u29BE','olcross':'\u29BB','oline':'\u203E','olt':'\u29C0','Omacr':'\u014C','omacr':'\u014D','Omega':'\u03A9','omega':'\u03C9','Omicron':'\u039F','omicron':'\u03BF','omid':'\u29B6','ominus':'\u2296','Oopf':'\uD835\uDD46','oopf':'\uD835\uDD60','opar':'\u29B7','OpenCurlyDoubleQuote':'\u201C','OpenCurlyQuote':'\u2018','operp':'\u29B9','oplus':'\u2295','orarr':'\u21BB','Or':'\u2A54','or':'\u2228','ord':'\u2A5D','order':'\u2134','orderof':'\u2134','ordf':'\xAA','ordm':'\xBA','origof':'\u22B6','oror':'\u2A56','orslope':'\u2A57','orv':'\u2A5B','oS':'\u24C8','Oscr':'\uD835\uDCAA','oscr':'\u2134','Oslash':'\xD8','oslash':'\xF8','osol':'\u2298','Otilde':'\xD5','otilde':'\xF5','otimesas':'\u2A36','Otimes':'\u2A37','otimes':'\u2297','Ouml':'\xD6','ouml':'\xF6','ovbar':'\u233D','OverBar':'\u203E','OverBrace':'\u23DE','OverBracket':'\u23B4','OverParenthesis':'\u23DC','para':'\xB6','parallel':'\u2225','par':'\u2225','parsim':'\u2AF3','parsl':'\u2AFD','part':'\u2202','PartialD':'\u2202','Pcy':'\u041F','pcy':'\u043F','percnt':'%','period':'.','permil':'\u2030','perp':'\u22A5','pertenk':'\u2031','Pfr':'\uD835\uDD13','pfr':'\uD835\uDD2D','Phi':'\u03A6','phi':'\u03C6','phiv':'\u03D5','phmmat':'\u2133','phone':'\u260E','Pi':'\u03A0','pi':'\u03C0','pitchfork':'\u22D4','piv':'\u03D6','planck':'\u210F','planckh':'\u210E','plankv':'\u210F','plusacir':'\u2A23','plusb':'\u229E','pluscir':'\u2A22','plus':'+','plusdo':'\u2214','plusdu':'\u2A25','pluse':'\u2A72','PlusMinus':'\xB1','plusmn':'\xB1','plussim':'\u2A26','plustwo':'\u2A27','pm':'\xB1','Poincareplane':'\u210C','pointint':'\u2A15','popf':'\uD835\uDD61','Popf':'\u2119','pound':'\xA3','prap':'\u2AB7','Pr':'\u2ABB','pr':'\u227A','prcue':'\u227C','precapprox':'\u2AB7','prec':'\u227A','preccurlyeq':'\u227C','Precedes':'\u227A','PrecedesEqual':'\u2AAF','PrecedesSlantEqual':'\u227C','PrecedesTilde':'\u227E','preceq':'\u2AAF','precnapprox':'\u2AB9','precneqq':'\u2AB5','precnsim':'\u22E8','pre':'\u2AAF','prE':'\u2AB3','precsim':'\u227E','prime':'\u2032','Prime':'\u2033','primes':'\u2119','prnap':'\u2AB9','prnE':'\u2AB5','prnsim':'\u22E8','prod':'\u220F','Product':'\u220F','profalar':'\u232E','profline':'\u2312','profsurf':'\u2313','prop':'\u221D','Proportional':'\u221D','Proportion':'\u2237','propto':'\u221D','prsim':'\u227E','prurel':'\u22B0','Pscr':'\uD835\uDCAB','pscr':'\uD835\uDCC5','Psi':'\u03A8','psi':'\u03C8','puncsp':'\u2008','Qfr':'\uD835\uDD14','qfr':'\uD835\uDD2E','qint':'\u2A0C','qopf':'\uD835\uDD62','Qopf':'\u211A','qprime':'\u2057','Qscr':'\uD835\uDCAC','qscr':'\uD835\uDCC6','quaternions':'\u210D','quatint':'\u2A16','quest':'?','questeq':'\u225F','quot':'"','QUOT':'"','rAarr':'\u21DB','race':'\u223D\u0331','Racute':'\u0154','racute':'\u0155','radic':'\u221A','raemptyv':'\u29B3','rang':'\u27E9','Rang':'\u27EB','rangd':'\u2992','range':'\u29A5','rangle':'\u27E9','raquo':'\xBB','rarrap':'\u2975','rarrb':'\u21E5','rarrbfs':'\u2920','rarrc':'\u2933','rarr':'\u2192','Rarr':'\u21A0','rArr':'\u21D2','rarrfs':'\u291E','rarrhk':'\u21AA','rarrlp':'\u21AC','rarrpl':'\u2945','rarrsim':'\u2974','Rarrtl':'\u2916','rarrtl':'\u21A3','rarrw':'\u219D','ratail':'\u291A','rAtail':'\u291C','ratio':'\u2236','rationals':'\u211A','rbarr':'\u290D','rBarr':'\u290F','RBarr':'\u2910','rbbrk':'\u2773','rbrace':'}','rbrack':']','rbrke':'\u298C','rbrksld':'\u298E','rbrkslu':'\u2990','Rcaron':'\u0158','rcaron':'\u0159','Rcedil':'\u0156','rcedil':'\u0157','rceil':'\u2309','rcub':'}','Rcy':'\u0420','rcy':'\u0440','rdca':'\u2937','rdldhar':'\u2969','rdquo':'\u201D','rdquor':'\u201D','rdsh':'\u21B3','real':'\u211C','realine':'\u211B','realpart':'\u211C','reals':'\u211D','Re':'\u211C','rect':'\u25AD','reg':'\xAE','REG':'\xAE','ReverseElement':'\u220B','ReverseEquilibrium':'\u21CB','ReverseUpEquilibrium':'\u296F','rfisht':'\u297D','rfloor':'\u230B','rfr':'\uD835\uDD2F','Rfr':'\u211C','rHar':'\u2964','rhard':'\u21C1','rharu':'\u21C0','rharul':'\u296C','Rho':'\u03A1','rho':'\u03C1','rhov':'\u03F1','RightAngleBracket':'\u27E9','RightArrowBar':'\u21E5','rightarrow':'\u2192','RightArrow':'\u2192','Rightarrow':'\u21D2','RightArrowLeftArrow':'\u21C4','rightarrowtail':'\u21A3','RightCeiling':'\u2309','RightDoubleBracket':'\u27E7','RightDownTeeVector':'\u295D','RightDownVectorBar':'\u2955','RightDownVector':'\u21C2','RightFloor':'\u230B','rightharpoondown':'\u21C1','rightharpoonup':'\u21C0','rightleftarrows':'\u21C4','rightleftharpoons':'\u21CC','rightrightarrows':'\u21C9','rightsquigarrow':'\u219D','RightTeeArrow':'\u21A6','RightTee':'\u22A2','RightTeeVector':'\u295B','rightthreetimes':'\u22CC','RightTriangleBar':'\u29D0','RightTriangle':'\u22B3','RightTriangleEqual':'\u22B5','RightUpDownVector':'\u294F','RightUpTeeVector':'\u295C','RightUpVectorBar':'\u2954','RightUpVector':'\u21BE','RightVectorBar':'\u2953','RightVector':'\u21C0','ring':'\u02DA','risingdotseq':'\u2253','rlarr':'\u21C4','rlhar':'\u21CC','rlm':'\u200F','rmoustache':'\u23B1','rmoust':'\u23B1','rnmid':'\u2AEE','roang':'\u27ED','roarr':'\u21FE','robrk':'\u27E7','ropar':'\u2986','ropf':'\uD835\uDD63','Ropf':'\u211D','roplus':'\u2A2E','rotimes':'\u2A35','RoundImplies':'\u2970','rpar':')','rpargt':'\u2994','rppolint':'\u2A12','rrarr':'\u21C9','Rrightarrow':'\u21DB','rsaquo':'\u203A','rscr':'\uD835\uDCC7','Rscr':'\u211B','rsh':'\u21B1','Rsh':'\u21B1','rsqb':']','rsquo':'\u2019','rsquor':'\u2019','rthree':'\u22CC','rtimes':'\u22CA','rtri':'\u25B9','rtrie':'\u22B5','rtrif':'\u25B8','rtriltri':'\u29CE','RuleDelayed':'\u29F4','ruluhar':'\u2968','rx':'\u211E','Sacute':'\u015A','sacute':'\u015B','sbquo':'\u201A','scap':'\u2AB8','Scaron':'\u0160','scaron':'\u0161','Sc':'\u2ABC','sc':'\u227B','sccue':'\u227D','sce':'\u2AB0','scE':'\u2AB4','Scedil':'\u015E','scedil':'\u015F','Scirc':'\u015C','scirc':'\u015D','scnap':'\u2ABA','scnE':'\u2AB6','scnsim':'\u22E9','scpolint':'\u2A13','scsim':'\u227F','Scy':'\u0421','scy':'\u0441','sdotb':'\u22A1','sdot':'\u22C5','sdote':'\u2A66','searhk':'\u2925','searr':'\u2198','seArr':'\u21D8','searrow':'\u2198','sect':'\xA7','semi':';','seswar':'\u2929','setminus':'\u2216','setmn':'\u2216','sext':'\u2736','Sfr':'\uD835\uDD16','sfr':'\uD835\uDD30','sfrown':'\u2322','sharp':'\u266F','SHCHcy':'\u0429','shchcy':'\u0449','SHcy':'\u0428','shcy':'\u0448','ShortDownArrow':'\u2193','ShortLeftArrow':'\u2190','shortmid':'\u2223','shortparallel':'\u2225','ShortRightArrow':'\u2192','ShortUpArrow':'\u2191','shy':'\xAD','Sigma':'\u03A3','sigma':'\u03C3','sigmaf':'\u03C2','sigmav':'\u03C2','sim':'\u223C','simdot':'\u2A6A','sime':'\u2243','simeq':'\u2243','simg':'\u2A9E','simgE':'\u2AA0','siml':'\u2A9D','simlE':'\u2A9F','simne':'\u2246','simplus':'\u2A24','simrarr':'\u2972','slarr':'\u2190','SmallCircle':'\u2218','smallsetminus':'\u2216','smashp':'\u2A33','smeparsl':'\u29E4','smid':'\u2223','smile':'\u2323','smt':'\u2AAA','smte':'\u2AAC','smtes':'\u2AAC\uFE00','SOFTcy':'\u042C','softcy':'\u044C','solbar':'\u233F','solb':'\u29C4','sol':'/','Sopf':'\uD835\uDD4A','sopf':'\uD835\uDD64','spades':'\u2660','spadesuit':'\u2660','spar':'\u2225','sqcap':'\u2293','sqcaps':'\u2293\uFE00','sqcup':'\u2294','sqcups':'\u2294\uFE00','Sqrt':'\u221A','sqsub':'\u228F','sqsube':'\u2291','sqsubset':'\u228F','sqsubseteq':'\u2291','sqsup':'\u2290','sqsupe':'\u2292','sqsupset':'\u2290','sqsupseteq':'\u2292','square':'\u25A1','Square':'\u25A1','SquareIntersection':'\u2293','SquareSubset':'\u228F','SquareSubsetEqual':'\u2291','SquareSuperset':'\u2290','SquareSupersetEqual':'\u2292','SquareUnion':'\u2294','squarf':'\u25AA','squ':'\u25A1','squf':'\u25AA','srarr':'\u2192','Sscr':'\uD835\uDCAE','sscr':'\uD835\uDCC8','ssetmn':'\u2216','ssmile':'\u2323','sstarf':'\u22C6','Star':'\u22C6','star':'\u2606','starf':'\u2605','straightepsilon':'\u03F5','straightphi':'\u03D5','strns':'\xAF','sub':'\u2282','Sub':'\u22D0','subdot':'\u2ABD','subE':'\u2AC5','sube':'\u2286','subedot':'\u2AC3','submult':'\u2AC1','subnE':'\u2ACB','subne':'\u228A','subplus':'\u2ABF','subrarr':'\u2979','subset':'\u2282','Subset':'\u22D0','subseteq':'\u2286','subseteqq':'\u2AC5','SubsetEqual':'\u2286','subsetneq':'\u228A','subsetneqq':'\u2ACB','subsim':'\u2AC7','subsub':'\u2AD5','subsup':'\u2AD3','succapprox':'\u2AB8','succ':'\u227B','succcurlyeq':'\u227D','Succeeds':'\u227B','SucceedsEqual':'\u2AB0','SucceedsSlantEqual':'\u227D','SucceedsTilde':'\u227F','succeq':'\u2AB0','succnapprox':'\u2ABA','succneqq':'\u2AB6','succnsim':'\u22E9','succsim':'\u227F','SuchThat':'\u220B','sum':'\u2211','Sum':'\u2211','sung':'\u266A','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','sup':'\u2283','Sup':'\u22D1','supdot':'\u2ABE','supdsub':'\u2AD8','supE':'\u2AC6','supe':'\u2287','supedot':'\u2AC4','Superset':'\u2283','SupersetEqual':'\u2287','suphsol':'\u27C9','suphsub':'\u2AD7','suplarr':'\u297B','supmult':'\u2AC2','supnE':'\u2ACC','supne':'\u228B','supplus':'\u2AC0','supset':'\u2283','Supset':'\u22D1','supseteq':'\u2287','supseteqq':'\u2AC6','supsetneq':'\u228B','supsetneqq':'\u2ACC','supsim':'\u2AC8','supsub':'\u2AD4','supsup':'\u2AD6','swarhk':'\u2926','swarr':'\u2199','swArr':'\u21D9','swarrow':'\u2199','swnwar':'\u292A','szlig':'\xDF','Tab':'\t','target':'\u2316','Tau':'\u03A4','tau':'\u03C4','tbrk':'\u23B4','Tcaron':'\u0164','tcaron':'\u0165','Tcedil':'\u0162','tcedil':'\u0163','Tcy':'\u0422','tcy':'\u0442','tdot':'\u20DB','telrec':'\u2315','Tfr':'\uD835\uDD17','tfr':'\uD835\uDD31','there4':'\u2234','therefore':'\u2234','Therefore':'\u2234','Theta':'\u0398','theta':'\u03B8','thetasym':'\u03D1','thetav':'\u03D1','thickapprox':'\u2248','thicksim':'\u223C','ThickSpace':'\u205F\u200A','ThinSpace':'\u2009','thinsp':'\u2009','thkap':'\u2248','thksim':'\u223C','THORN':'\xDE','thorn':'\xFE','tilde':'\u02DC','Tilde':'\u223C','TildeEqual':'\u2243','TildeFullEqual':'\u2245','TildeTilde':'\u2248','timesbar':'\u2A31','timesb':'\u22A0','times':'\xD7','timesd':'\u2A30','tint':'\u222D','toea':'\u2928','topbot':'\u2336','topcir':'\u2AF1','top':'\u22A4','Topf':'\uD835\uDD4B','topf':'\uD835\uDD65','topfork':'\u2ADA','tosa':'\u2929','tprime':'\u2034','trade':'\u2122','TRADE':'\u2122','triangle':'\u25B5','triangledown':'\u25BF','triangleleft':'\u25C3','trianglelefteq':'\u22B4','triangleq':'\u225C','triangleright':'\u25B9','trianglerighteq':'\u22B5','tridot':'\u25EC','trie':'\u225C','triminus':'\u2A3A','TripleDot':'\u20DB','triplus':'\u2A39','trisb':'\u29CD','tritime':'\u2A3B','trpezium':'\u23E2','Tscr':'\uD835\uDCAF','tscr':'\uD835\uDCC9','TScy':'\u0426','tscy':'\u0446','TSHcy':'\u040B','tshcy':'\u045B','Tstrok':'\u0166','tstrok':'\u0167','twixt':'\u226C','twoheadleftarrow':'\u219E','twoheadrightarrow':'\u21A0','Uacute':'\xDA','uacute':'\xFA','uarr':'\u2191','Uarr':'\u219F','uArr':'\u21D1','Uarrocir':'\u2949','Ubrcy':'\u040E','ubrcy':'\u045E','Ubreve':'\u016C','ubreve':'\u016D','Ucirc':'\xDB','ucirc':'\xFB','Ucy':'\u0423','ucy':'\u0443','udarr':'\u21C5','Udblac':'\u0170','udblac':'\u0171','udhar':'\u296E','ufisht':'\u297E','Ufr':'\uD835\uDD18','ufr':'\uD835\uDD32','Ugrave':'\xD9','ugrave':'\xF9','uHar':'\u2963','uharl':'\u21BF','uharr':'\u21BE','uhblk':'\u2580','ulcorn':'\u231C','ulcorner':'\u231C','ulcrop':'\u230F','ultri':'\u25F8','Umacr':'\u016A','umacr':'\u016B','uml':'\xA8','UnderBar':'_','UnderBrace':'\u23DF','UnderBracket':'\u23B5','UnderParenthesis':'\u23DD','Union':'\u22C3','UnionPlus':'\u228E','Uogon':'\u0172','uogon':'\u0173','Uopf':'\uD835\uDD4C','uopf':'\uD835\uDD66','UpArrowBar':'\u2912','uparrow':'\u2191','UpArrow':'\u2191','Uparrow':'\u21D1','UpArrowDownArrow':'\u21C5','updownarrow':'\u2195','UpDownArrow':'\u2195','Updownarrow':'\u21D5','UpEquilibrium':'\u296E','upharpoonleft':'\u21BF','upharpoonright':'\u21BE','uplus':'\u228E','UpperLeftArrow':'\u2196','UpperRightArrow':'\u2197','upsi':'\u03C5','Upsi':'\u03D2','upsih':'\u03D2','Upsilon':'\u03A5','upsilon':'\u03C5','UpTeeArrow':'\u21A5','UpTee':'\u22A5','upuparrows':'\u21C8','urcorn':'\u231D','urcorner':'\u231D','urcrop':'\u230E','Uring':'\u016E','uring':'\u016F','urtri':'\u25F9','Uscr':'\uD835\uDCB0','uscr':'\uD835\uDCCA','utdot':'\u22F0','Utilde':'\u0168','utilde':'\u0169','utri':'\u25B5','utrif':'\u25B4','uuarr':'\u21C8','Uuml':'\xDC','uuml':'\xFC','uwangle':'\u29A7','vangrt':'\u299C','varepsilon':'\u03F5','varkappa':'\u03F0','varnothing':'\u2205','varphi':'\u03D5','varpi':'\u03D6','varpropto':'\u221D','varr':'\u2195','vArr':'\u21D5','varrho':'\u03F1','varsigma':'\u03C2','varsubsetneq':'\u228A\uFE00','varsubsetneqq':'\u2ACB\uFE00','varsupsetneq':'\u228B\uFE00','varsupsetneqq':'\u2ACC\uFE00','vartheta':'\u03D1','vartriangleleft':'\u22B2','vartriangleright':'\u22B3','vBar':'\u2AE8','Vbar':'\u2AEB','vBarv':'\u2AE9','Vcy':'\u0412','vcy':'\u0432','vdash':'\u22A2','vDash':'\u22A8','Vdash':'\u22A9','VDash':'\u22AB','Vdashl':'\u2AE6','veebar':'\u22BB','vee':'\u2228','Vee':'\u22C1','veeeq':'\u225A','vellip':'\u22EE','verbar':'|','Verbar':'\u2016','vert':'|','Vert':'\u2016','VerticalBar':'\u2223','VerticalLine':'|','VerticalSeparator':'\u2758','VerticalTilde':'\u2240','VeryThinSpace':'\u200A','Vfr':'\uD835\uDD19','vfr':'\uD835\uDD33','vltri':'\u22B2','vnsub':'\u2282\u20D2','vnsup':'\u2283\u20D2','Vopf':'\uD835\uDD4D','vopf':'\uD835\uDD67','vprop':'\u221D','vrtri':'\u22B3','Vscr':'\uD835\uDCB1','vscr':'\uD835\uDCCB','vsubnE':'\u2ACB\uFE00','vsubne':'\u228A\uFE00','vsupnE':'\u2ACC\uFE00','vsupne':'\u228B\uFE00','Vvdash':'\u22AA','vzigzag':'\u299A','Wcirc':'\u0174','wcirc':'\u0175','wedbar':'\u2A5F','wedge':'\u2227','Wedge':'\u22C0','wedgeq':'\u2259','weierp':'\u2118','Wfr':'\uD835\uDD1A','wfr':'\uD835\uDD34','Wopf':'\uD835\uDD4E','wopf':'\uD835\uDD68','wp':'\u2118','wr':'\u2240','wreath':'\u2240','Wscr':'\uD835\uDCB2','wscr':'\uD835\uDCCC','xcap':'\u22C2','xcirc':'\u25EF','xcup':'\u22C3','xdtri':'\u25BD','Xfr':'\uD835\uDD1B','xfr':'\uD835\uDD35','xharr':'\u27F7','xhArr':'\u27FA','Xi':'\u039E','xi':'\u03BE','xlarr':'\u27F5','xlArr':'\u27F8','xmap':'\u27FC','xnis':'\u22FB','xodot':'\u2A00','Xopf':'\uD835\uDD4F','xopf':'\uD835\uDD69','xoplus':'\u2A01','xotime':'\u2A02','xrarr':'\u27F6','xrArr':'\u27F9','Xscr':'\uD835\uDCB3','xscr':'\uD835\uDCCD','xsqcup':'\u2A06','xuplus':'\u2A04','xutri':'\u25B3','xvee':'\u22C1','xwedge':'\u22C0','Yacute':'\xDD','yacute':'\xFD','YAcy':'\u042F','yacy':'\u044F','Ycirc':'\u0176','ycirc':'\u0177','Ycy':'\u042B','ycy':'\u044B','yen':'\xA5','Yfr':'\uD835\uDD1C','yfr':'\uD835\uDD36','YIcy':'\u0407','yicy':'\u0457','Yopf':'\uD835\uDD50','yopf':'\uD835\uDD6A','Yscr':'\uD835\uDCB4','yscr':'\uD835\uDCCE','YUcy':'\u042E','yucy':'\u044E','yuml':'\xFF','Yuml':'\u0178','Zacute':'\u0179','zacute':'\u017A','Zcaron':'\u017D','zcaron':'\u017E','Zcy':'\u0417','zcy':'\u0437','Zdot':'\u017B','zdot':'\u017C','zeetrf':'\u2128','ZeroWidthSpace':'\u200B','Zeta':'\u0396','zeta':'\u03B6','zfr':'\uD835\uDD37','Zfr':'\u2128','ZHcy':'\u0416','zhcy':'\u0436','zigrarr':'\u21DD','zopf':'\uD835\uDD6B','Zopf':'\u2124','Zscr':'\uD835\uDCB5','zscr':'\uD835\uDCCF','zwj':'\u200D','zwnj':'\u200C'};
	var decodeMapLegacy = {'Aacute':'\xC1','aacute':'\xE1','Acirc':'\xC2','acirc':'\xE2','acute':'\xB4','AElig':'\xC6','aelig':'\xE6','Agrave':'\xC0','agrave':'\xE0','amp':'&','AMP':'&','Aring':'\xC5','aring':'\xE5','Atilde':'\xC3','atilde':'\xE3','Auml':'\xC4','auml':'\xE4','brvbar':'\xA6','Ccedil':'\xC7','ccedil':'\xE7','cedil':'\xB8','cent':'\xA2','copy':'\xA9','COPY':'\xA9','curren':'\xA4','deg':'\xB0','divide':'\xF7','Eacute':'\xC9','eacute':'\xE9','Ecirc':'\xCA','ecirc':'\xEA','Egrave':'\xC8','egrave':'\xE8','ETH':'\xD0','eth':'\xF0','Euml':'\xCB','euml':'\xEB','frac12':'\xBD','frac14':'\xBC','frac34':'\xBE','gt':'>','GT':'>','Iacute':'\xCD','iacute':'\xED','Icirc':'\xCE','icirc':'\xEE','iexcl':'\xA1','Igrave':'\xCC','igrave':'\xEC','iquest':'\xBF','Iuml':'\xCF','iuml':'\xEF','laquo':'\xAB','lt':'<','LT':'<','macr':'\xAF','micro':'\xB5','middot':'\xB7','nbsp':'\xA0','not':'\xAC','Ntilde':'\xD1','ntilde':'\xF1','Oacute':'\xD3','oacute':'\xF3','Ocirc':'\xD4','ocirc':'\xF4','Ograve':'\xD2','ograve':'\xF2','ordf':'\xAA','ordm':'\xBA','Oslash':'\xD8','oslash':'\xF8','Otilde':'\xD5','otilde':'\xF5','Ouml':'\xD6','ouml':'\xF6','para':'\xB6','plusmn':'\xB1','pound':'\xA3','quot':'"','QUOT':'"','raquo':'\xBB','reg':'\xAE','REG':'\xAE','sect':'\xA7','shy':'\xAD','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','szlig':'\xDF','THORN':'\xDE','thorn':'\xFE','times':'\xD7','Uacute':'\xDA','uacute':'\xFA','Ucirc':'\xDB','ucirc':'\xFB','Ugrave':'\xD9','ugrave':'\xF9','uml':'\xA8','Uuml':'\xDC','uuml':'\xFC','Yacute':'\xDD','yacute':'\xFD','yen':'\xA5','yuml':'\xFF'};
	var decodeMapNumeric = {'0':'\uFFFD','128':'\u20AC','130':'\u201A','131':'\u0192','132':'\u201E','133':'\u2026','134':'\u2020','135':'\u2021','136':'\u02C6','137':'\u2030','138':'\u0160','139':'\u2039','140':'\u0152','142':'\u017D','145':'\u2018','146':'\u2019','147':'\u201C','148':'\u201D','149':'\u2022','150':'\u2013','151':'\u2014','152':'\u02DC','153':'\u2122','154':'\u0161','155':'\u203A','156':'\u0153','158':'\u017E','159':'\u0178'};
	var invalidReferenceCodePoints = [1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65000,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111];

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	var object = {};
	var hasOwnProperty = object.hasOwnProperty;
	var has = function(object, propertyName) {
		return hasOwnProperty.call(object, propertyName);
	};

	var contains = function(array, value) {
		var index = -1;
		var length = array.length;
		while (++index < length) {
			if (array[index] == value) {
				return true;
			}
		}
		return false;
	};

	var merge = function(options, defaults) {
		if (!options) {
			return defaults;
		}
		var result = {};
		var key;
		for (key in defaults) {
			// A `hasOwnProperty` check is not needed here, since only recognized
			// option names are used anyway. Any others are ignored.
			result[key] = has(options, key) ? options[key] : defaults[key];
		}
		return result;
	};

	// Modified version of `ucs2encode`; see http://mths.be/punycode.
	var codePointToSymbol = function(codePoint, strict) {
		var output = '';
		if ((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF) {
			// See issue #4:
			// “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
			// greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
			// REPLACEMENT CHARACTER.”
			if (strict) {
				parseError('character reference outside the permissible Unicode range');
			}
			return '\uFFFD';
		}
		if (has(decodeMapNumeric, codePoint)) {
			if (strict) {
				parseError('disallowed character reference');
			}
			return decodeMapNumeric[codePoint];
		}
		if (strict && contains(invalidReferenceCodePoints, codePoint)) {
			parseError('disallowed character reference');
		}
		if (codePoint > 0xFFFF) {
			codePoint -= 0x10000;
			output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
			codePoint = 0xDC00 | codePoint & 0x3FF;
		}
		output += stringFromCharCode(codePoint);
		return output;
	};

	var hexEscape = function(symbol) {
		return '&#x' + symbol.charCodeAt(0).toString(16).toUpperCase() + ';';
	};

	var parseError = function(message) {
		throw Error('Parse error: ' + message);
	};

	/*--------------------------------------------------------------------------*/

	var encode = function(string, options) {
		options = merge(options, encode.options);
		var strict = options.strict;
		if (strict && regexInvalidRawCodePoint.test(string)) {
			parseError('forbidden code point');
		}
		var encodeEverything = options.encodeEverything;
		var useNamedReferences = options.useNamedReferences;
		var allowUnsafeSymbols = options.allowUnsafeSymbols;
		if (encodeEverything) {
			// Encode ASCII symbols.
			string = string.replace(regexAsciiWhitelist, function(symbol) {
				// Use named references if requested & possible.
				if (useNamedReferences && has(encodeMap, symbol)) {
					return '&' + encodeMap[symbol] + ';';
				}
				return hexEscape(symbol);
			});
			// Shorten a few escapes that represent two symbols, of which at least one
			// is within the ASCII range.
			if (useNamedReferences) {
				string = string
					.replace(/&gt;\u20D2/g, '&nvgt;')
					.replace(/&lt;\u20D2/g, '&nvlt;')
					.replace(/&#x66;&#x6A;/g, '&fjlig;');
			}
			// Encode non-ASCII symbols.
			if (useNamedReferences) {
				// Encode non-ASCII symbols that can be replaced with a named reference.
				string = string.replace(regexEncodeNonAscii, function(string) {
					// Note: there is no need to check `has(encodeMap, string)` here.
					return '&' + encodeMap[string] + ';';
				});
			}
			// Note: any remaining non-ASCII symbols are handled outside of the `if`.
		} else if (useNamedReferences) {
			// Apply named character references.
			// Encode `<>"'&` using named character references.
			if (!allowUnsafeSymbols) {
				string = string.replace(regexEscape, function(string) {
					return '&' + encodeMap[string] + ';'; // no need to check `has()` here
				});
			}
			// Shorten escapes that represent two symbols, of which at least one is
			// `<>"'&`.
			string = string
				.replace(/&gt;\u20D2/g, '&nvgt;')
				.replace(/&lt;\u20D2/g, '&nvlt;');
			// Encode non-ASCII symbols that can be replaced with a named reference.
			string = string.replace(regexEncodeNonAscii, function(string) {
				// Note: there is no need to check `has(encodeMap, string)` here.
				return '&' + encodeMap[string] + ';';
			});
		} else if (!allowUnsafeSymbols) {
			// Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
			// using named character references.
			string = string.replace(regexEscape, hexEscape);
		}
		return string
			// Encode astral symbols.
			.replace(regexAstralSymbols, function($0) {
				// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
				var high = $0.charCodeAt(0);
				var low = $0.charCodeAt(1);
				var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
				return '&#x' + codePoint.toString(16).toUpperCase() + ';';
			})
			// Encode any remaining BMP symbols that are not printable ASCII symbols
			// using a hexadecimal escape.
			.replace(regexBmpWhitelist, hexEscape);
	};
	// Expose default options (so they can be overridden globally).
	encode.options = {
		'allowUnsafeSymbols': false,
		'encodeEverything': false,
		'strict': false,
		'useNamedReferences': false
	};

	var decode = function(html, options) {
		options = merge(options, decode.options);
		var strict = options.strict;
		if (strict && regexInvalidEntity.test(html)) {
			parseError('malformed character reference');
		}
		return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7) {
			var codePoint;
			var semicolon;
			var hexDigits;
			var reference;
			var next;
			if ($1) {
				// Decode decimal escapes, e.g. `&#119558;`.
				codePoint = $1;
				semicolon = $2;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				return codePointToSymbol(codePoint, strict);
			}
			if ($3) {
				// Decode hexadecimal escapes, e.g. `&#x1D306;`.
				hexDigits = $3;
				semicolon = $4;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(hexDigits, 16);
				return codePointToSymbol(codePoint, strict);
			}
			if ($5) {
				// Decode named character references with trailing `;`, e.g. `&copy;`.
				reference = $5;
				if (has(decodeMap, reference)) {
					return decodeMap[reference];
				} else {
					// Ambiguous ampersand; see http://mths.be/notes/ambiguous-ampersands.
					if (strict) {
						parseError(
							'named character reference was not terminated by a semicolon'
						);
					}
					return $0;
				}
			}
			// If we’re still here, it’s a legacy reference for sure. No need for an
			// extra `if` check.
			// Decode named character references without trailing `;`, e.g. `&amp`
			// This is only a parse error if it gets converted to `&`, or if it is
			// followed by `=` in an attribute context.
			reference = $6;
			next = $7;
			if (next && options.isAttributeValue) {
				if (strict && next == '=') {
					parseError('`&` did not start a character reference');
				}
				return $0;
			} else {
				if (strict) {
					parseError(
						'named character reference was not terminated by a semicolon'
					);
				}
				// Note: there is no need to check `has(decodeMapLegacy, reference)`.
				return decodeMapLegacy[reference] + (next || '');
			}
		});
	};
	// Expose default options (so they can be overridden globally).
	decode.options = {
		'isAttributeValue': false,
		'strict': false
	};

	var escape = function(string) {
		return string.replace(regexEscape, function($0) {
			// Note: there is no need to check `has(escapeMap, $0)` here.
			return escapeMap[$0];
		});
	};

	/*--------------------------------------------------------------------------*/

	var he = {
		'version': '0.5.0',
		'encode': encode,
		'decode': decode,
		'escape': escape,
		'unescape': decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return he;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = he;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in he) {
				has(he, key) && (freeExports[key] = he[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.he = he;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)(module), __webpack_require__(51)))

/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = collectErrors;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashGroupby = __webpack_require__(2780);

var _lodashGroupby2 = _interopRequireDefault(_lodashGroupby);

function collectErrors(error) {
  if (error !== null) {
    return _lodashGroupby2['default'](error.details, 'path');
  }
  return {};
}

module.exports = exports['default'];

/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var createAggregator = __webpack_require__(2781);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` through `iteratee`. The corresponding value
 * of each key is an array of the elements responsible for generating the key.
 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
 * (value, index|key, collection).
 *
 * If a property name is provided for `iteratee` the created `_.property`
 * style callback returns the property value of the given element.
 *
 * If a value is also provided for `thisArg` the created `_.matchesProperty`
 * style callback returns `true` for elements that have a matching property
 * value, else `false`.
 *
 * If an object is provided for `iteratee` the created `_.matches` style
 * callback returns `true` for elements that have the properties of the given
 * object, else `false`.
 *
 * @static
 * @memberOf _
 * @category Collection
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
 *  per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([4.2, 6.1, 6.4], function(n) {
 *   return Math.floor(n);
 * });
 * // => { '4': [4.2], '6': [6.1, 6.4] }
 *
 * _.groupBy([4.2, 6.1, 6.4], function(n) {
 *   return this.floor(n);
 * }, Math);
 * // => { '4': [4.2], '6': [6.1, 6.4] }
 *
 * // using the `_.property` callback shorthand
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    result[key] = [value];
  }
});

module.exports = groupBy;


/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseCallback = __webpack_require__(2782),
    baseEach = __webpack_require__(2787),
    isArray = __webpack_require__(977);

/**
 * Creates a function that aggregates a collection, creating an accumulator
 * object composed from the results of running each element in the collection
 * through an iteratee. The `setter` sets the keys and values of the accumulator
 * object. If `initializer` is provided initializes the accumulator object.
 *
 * @private
 * @param {Function} setter The function to set keys and values of the accumulator object.
 * @param {Function} [initializer] The function to initialize the accumulator object.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee, thisArg) {
    var result = initializer ? initializer() : {};
    iteratee = baseCallback(iteratee, thisArg, 3);

    if (isArray(collection)) {
      var index = -1,
          length = collection.length;

      while (++index < length) {
        var value = collection[index];
        setter(result, value, iteratee(value, index, collection), collection);
      }
    } else {
      baseEach(collection, function(value, key, collection) {
        setter(result, value, iteratee(value, key, collection), collection);
      });
    }
    return result;
  };
}

module.exports = createAggregator;


/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.3.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseIsEqual = __webpack_require__(2783),
    bindCallback = __webpack_require__(2785),
    isArray = __webpack_require__(977),
    pairs = __webpack_require__(2786);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  return value == null ? '' : (value + '');
}

/**
 * The base implementation of `_.callback` which supports specifying the
 * number of arguments to provide to `func`.
 *
 * @private
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function baseCallback(func, thisArg, argCount) {
  var type = typeof func;
  if (type == 'function') {
    return thisArg === undefined
      ? func
      : bindCallback(func, thisArg, argCount);
  }
  if (func == null) {
    return identity;
  }
  if (type == 'object') {
    return baseMatches(func);
  }
  return thisArg === undefined
    ? property(func)
    : baseMatchesProperty(func, thisArg);
}

/**
 * The base implementation of `get` without support for string paths
 * and default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path of the property to get.
 * @param {string} [pathKey] The key representation of path.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path, pathKey) {
  if (object == null) {
    return;
  }
  if (pathKey !== undefined && pathKey in toObject(object)) {
    path = [pathKey];
  }
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isMatch` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Array} matchData The propery names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparing objects.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = toObject(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.matches` which does not clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    var key = matchData[0][0],
        value = matchData[0][1];

    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === value && (value !== undefined || (key in toObject(object)));
    };
  }
  return function(object) {
    return baseIsMatch(object, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to compare.
 * @returns {Function} Returns the new function.
 */
function baseMatchesProperty(path, srcValue) {
  var isArr = isArray(path),
      isCommon = isKey(path) && isStrictComparable(srcValue),
      pathKey = (path + '');

  path = toPath(path);
  return function(object) {
    if (object == null) {
      return false;
    }
    var key = pathKey;
    object = toObject(object);
    if ((isArr || !isCommon) && !(key in object)) {
      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
      if (object == null) {
        return false;
      }
      key = last(path);
      object = toObject(object);
    }
    return object[key] === srcValue
      ? (srcValue !== undefined || (key in object))
      : baseIsEqual(srcValue, object[key], undefined, true);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 */
function basePropertyDeep(path) {
  var pathKey = (path + '');
  path = toPath(path);
  return function(object) {
    return baseGet(object, path, pathKey);
  };
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  start = start == null ? 0 : (+start || 0);
  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = (end === undefined || end > length) ? length : (+end || 0);
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Gets the propery names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = pairs(object),
      length = result.length;

  while (length--) {
    result[length][2] = isStrictComparable(result[length][1]);
  }
  return result;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  var type = typeof value;
  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
    return true;
  }
  if (isArray(value)) {
    return false;
  }
  var result = !reIsDeepProp.test(value);
  return result || (object != null && value in toObject(object));
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Converts `value` to property path array if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */
function toPath(value) {
  if (isArray(value)) {
    return value;
  }
  var result = [];
  baseToString(value).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array ? array.length : 0;
  return length ? array[length - 1] : undefined;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the property value at `path` on a
 * given object.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': { 'c': 2 } } },
 *   { 'a': { 'b': { 'c': 1 } } }
 * ];
 *
 * _.map(objects, _.property('a.b.c'));
 * // => [2, 1]
 *
 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
}

module.exports = baseCallback;


/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.7 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArray = __webpack_require__(977),
    isTypedArray = __webpack_require__(2784),
    keys = __webpack_require__(1225);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    stringTag = '[object String]';

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * A specialized version of `_.some` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.isEqual` without support for `this` binding
 * `customizer` functions.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing objects.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = objToString.call(object);
    if (objTag == argsTag) {
      objTag = objectTag;
    } else if (objTag != objectTag) {
      objIsArr = isTypedArray(object);
    }
  }
  if (!othIsArr) {
    othTag = objToString.call(other);
    if (othTag == argsTag) {
      othTag = objectTag;
    } else if (othTag != objectTag) {
      othIsArr = isTypedArray(other);
    }
  }
  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && !(objIsArr || objIsObj)) {
    return equalByTag(object, other, objTag);
  }
  if (!isLoose) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
    }
  }
  if (!isSameTag) {
    return false;
  }
  // Assume cyclic values are equal.
  // For more information on detecting circular references see https://es5.github.io/#JO.
  stackA || (stackA = []);
  stackB || (stackB = []);

  var length = stackA.length;
  while (length--) {
    if (stackA[length] == object) {
      return stackB[length] == other;
    }
  }
  // Add `object` and `other` to the stack of traversed objects.
  stackA.push(object);
  stackB.push(other);

  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

  stackA.pop();
  stackB.pop();

  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing arrays.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var index = -1,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
    return false;
  }
  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index],
        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

    if (result !== undefined) {
      if (result) {
        continue;
      }
      return false;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (isLoose) {
      if (!arraySome(other, function(othValue) {
            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
          })) {
        return false;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
      return false;
    }
  }
  return true;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} value The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag) {
  switch (tag) {
    case boolTag:
    case dateTag:
      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
      return +object == +other;

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case numberTag:
      // Treat `NaN` vs. `NaN` as equal.
      return (object != +object)
        ? other != +other
        : object == +other;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings primitives and string
      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
      return object == (other + '');
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isLoose) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  var skipCtor = isLoose;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key],
        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

    // Recursively compare objects (susceptible to call stack limits).
    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
      return false;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (!skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = baseIsEqual;


/***/ }),
/* 2784 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.6 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
function isTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

module.exports = isTypedArray;


/***/ }),
/* 2785 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function bindCallback(func, thisArg, argCount) {
  if (typeof func != 'function') {
    return identity;
  }
  if (thisArg === undefined) {
    return func;
  }
  switch (argCount) {
    case 1: return function(value) {
      return func.call(thisArg, value);
    };
    case 3: return function(value, index, collection) {
      return func.call(thisArg, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(thisArg, accumulator, value, index, collection);
    };
    case 5: return function(value, other, key, object, source) {
      return func.call(thisArg, value, other, key, object, source);
    };
  }
  return function() {
    return func.apply(thisArg, arguments);
  };
}

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = bindCallback;


/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var keys = __webpack_require__(1225);

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates a two dimensional array of the key-value pairs for `object`,
 * e.g. `[[key1, value1], [key2, value2]]`.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the new array of key-value pairs.
 * @example
 *
 * _.pairs({ 'barney': 36, 'fred': 40 });
 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
 */
function pairs(object) {
  object = toObject(object);

  var index = -1,
      props = keys(object),
      length = props.length,
      result = Array(length);

  while (++index < length) {
    var key = props[index];
    result[index] = [key, object[key]];
  }
  return result;
}

module.exports = pairs;


/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var keys = __webpack_require__(1225);

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.forEach` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object|string} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    var length = collection ? getLength(collection) : 0;
    if (!isLength(length)) {
      return eachFunc(collection, iteratee);
    }
    var index = fromRight ? length : -1,
        iterable = toObject(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for `_.forIn` or `_.forInRight`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var iterable = toObject(object),
        props = keysFunc(object),
        length = props.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      var key = props[index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = baseEach;


/***/ }),
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = pickMessages;

function pickMessages(error) {
  if (error !== null) {
    return Object.keys(error).reduce(function (obj, key) {
      obj[key] = error[key].map(function (item) {
        return item.message;
      });
      return obj;
    }, {});
  }
  return {};
}

module.exports = exports["default"];

/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _validationMixin = __webpack_require__(2790);

var _validationMixin2 = _interopRequireDefault(_validationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _validationMixin2.default;

/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = validationMixin;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _lodash = __webpack_require__(2791);

var _lodash2 = _interopRequireDefault(_lodash);

var _validationFactory = __webpack_require__(2792);

var _validationFactory2 = _interopRequireDefault(_validationFactory);

var _reactDisplayName = __webpack_require__(2797);

var _reactDisplayName2 = _interopRequireDefault(_reactDisplayName);

var _utils = __webpack_require__(1874);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function validationMixin(strategy) {
  var validator = (0, _validationFactory2.default)(strategy);
  return function wrappedComponentFn(WrappedComponent) {
    (0, _invariant2.default)((0, _utils.defined)(WrappedComponent), 'Component was not provided to the Validator. Export you Component with "export default validator(strategy)(Component);"');

    var Validation = function (_React$Component) {
      _inherits(Validation, _React$Component);

      function Validation(props, context) {
        _classCallCheck(this, Validation);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

        _this.render = _this.render.bind(_this);
        _this.validate = _this.validate.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        _this.getValidationMessages = _this.getValidationMessages.bind(_this);
        _this.clearValidations = _this.clearValidations.bind(_this);
        _this.handleValidation = _this.handleValidation.bind(_this);
        _this._invokeCallback = _this._invokeCallback.bind(_this);

        _this.state = { errors: {} };
        return _this;
      }

      /* Get current validation messages for a specified key or entire form.
       *
       * @param {?String} key to get messages, or entire form if key is undefined.
       * @return {Array}
       */


      Validation.prototype.getValidationMessages = function getValidationMessages(key) {
        return validator.getValidationMessages(this.state.errors, key) || [];
      };

      /* Convenience method to validate a key via an event handler. Useful for
       * onBlur, onClick, onChange, etc...
       *
       * @param {?String} State key to validate
       * @return {function} validation event handler
       */


      Validation.prototype.handleValidation = function handleValidation(key, callback) {
        var _this2 = this;

        return function () {
          _this2.validate(key, callback);
        };
      };

      /* Method to validate single form key or entire form against the component data.
       *
       * @param {String|Function} key to validate, or error-first containing the validation errors if any.
       * @param {?Function} error-first callback containing the validation errors if any.
       */


      Validation.prototype.validate = function validate() /* [key], callback */{
        var _this3 = this;

        var fallback = arguments.length <= 1 && typeof arguments[0] === 'function' ? arguments[0] : undefined;
        var key = arguments.length <= 1 && typeof arguments[0] === 'function' ? undefined : arguments[0];
        var callback = arguments.length <= 2 && typeof arguments[1] === 'function' ? arguments[1] : fallback;

        var data = (0, _lodash2.default)(this.refs.component, 'getValidatorData');
        var schema = (0, _lodash2.default)(this.refs.component, 'validatorTypes');

        (0, _invariant2.default)((0, _utils.defined)(data), 'Data was not provided to the Validator. Implement "getValidatorData" to return data.');
        (0, _invariant2.default)((0, _utils.defined)(schema), 'A schema was not provided to the Validator. Implement "validatorTypes" to return a validation schema.');

        var options = {
          key: key,
          prevErrors: this.state.errors
        };
        validator.validate(data, schema, options, function (nextErrors) {
          _this3.setState({ errors: _extends({}, nextErrors) }, _this3._invokeCallback.bind(_this3, key, callback));
        });
      };

      /* Clear all previous validations
       *
       * @return {void}
       */


      Validation.prototype.clearValidations = function clearValidations(callback) {
        return this.setState({
          errors: {}
        }, callback);
      };

      /* Check current validity for a specified key or entire form.
       *
       * @param {?String} key to check validity (entire form if undefined).
       * @return {Boolean}.
       */


      Validation.prototype.isValid = function isValid(key) {
        return validator.isValid(this.state.errors, key);
      };

      /* Private method that handles executing users callback on validation
       *
       * @param {Object} errors object keyed on data field names.
       * @param {Function} error-first callback containing the validation errors if any.
       */


      Validation.prototype._invokeCallback = function _invokeCallback(key, callback) {
        if (typeof callback !== 'function') {
          return;
        }
        if (this.isValid(key)) {
          callback();
        } else {
          callback(this.state.errors);
        }
      };

      Validation.prototype.render = function render() {
        return _react2.default.createElement(WrappedComponent, _extends({
          ref: 'component',
          errors: this.state.errors,
          validate: this.validate,
          isValid: this.isValid,
          getValidationMessages: this.getValidationMessages,
          clearValidations: this.clearValidations,
          handleValidation: this.handleValidation
        }, this.props));
      };

      return Validation;
    }(_react2.default.Component);

    Validation.displayName = 'Validation(' + (0, _reactDisplayName2.default)(WrappedComponent) + ')';
    return Validation;
  };
}

/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    object = undefined;
    length = 1;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[toKey(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = isFunction(value) ? value.call(object) : value;
  }
  return object;
}

module.exports = result;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = validationFactory;

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _lodash = __webpack_require__(2793);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(1873);

var _lodash4 = _interopRequireDefault(_lodash3);

var _utils = __webpack_require__(1874);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validationFactory(strategy) {
  var _strategy = typeof strategy === 'function' ? strategy() : strategy;
  (0, _invariant2.default)((0, _utils.defined)(_strategy), 'Validation strategy not provided. A user provided strategy is expected.');
  (0, _invariant2.default)(typeof _strategy !== 'function', 'Validation strategy improperly initialized. Refer to documentation of the provided strategy.');
  return _extends({
    getValidationMessages: function getValidationMessages() {
      var errors = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
      var key = arguments[1];

      if ((0, _lodash2.default)(errors)) {
        return [];
      }
      if (key === undefined) {
        return (0, _utils.flattenErrorsObject)(errors);
      }
      return (0, _lodash4.default)(errors, key);
    },
    isValid: function isValid(errors, key) {
      if (!(0, _utils.defined)(key)) return (0, _lodash2.default)(errors);
      return (0, _lodash2.default)((0, _lodash4.default)(errors, key));
    }
  }, _strategy);
}

/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' ||
        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (nonEnumShadows || isPrototype(value)) {
    return !nativeKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEmpty;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(236)(module)))

/***/ }),
/* 2794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = defined;

var _isSome = __webpack_require__(1875);

var _isSome2 = _interopRequireDefault(_isSome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defined() {
  for (var _len = arguments.length, items = Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }

  if (Array.isArray(items)) {
    return items.every(function (item) {
      return !(0, _isSome2.default)(item, null, undefined);
    });
  }
  return false;
}

/***/ }),
/* 2795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = flattenErrorsObject;

var _lodash = __webpack_require__(2796);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(1876);

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function flattenErrorsObject(obj) {
  if (typeof obj === 'string') {
    return obj;
  }

  return (0, _lodash4.default)((0, _lodash2.default)(obj).map(function (value) {
    if (typeof obj !== 'string') {
      return flattenErrorsObject(value);
    }
    return value;
  }));
}

/***/ }),
/* 2796 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object ? baseValues(object, keys(object)) : [];
}

module.exports = values;


/***/ }),
/* 2797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' ? Component : 'Component');
};

exports.default = getDisplayName;

/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactAsyncScriptLoader = __webpack_require__(1457);

var _reactAsyncScriptLoader2 = _interopRequireDefault(_reactAsyncScriptLoader);

var _helpwidgetActions = __webpack_require__(978);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Beamer = function (_Component) {
  _inherits(Beamer, _Component);

  function Beamer(props) {
    _classCallCheck(this, Beamer);

    var _this = _possibleConstructorReturn(this, (Beamer.__proto__ || Object.getPrototypeOf(Beamer)).call(this, props));

    _this.beamerCallback = function (newFeaturesCount) {
      _this.props.receiveNewFeatures(newFeaturesCount || 0);
    };

    _this.render = function () {
      return null;
    };

    window.beamer_config = {
      // selector: 'app', // REPLACE: Your element Id to position the alert
      product_id: 'gECbgcpP195', // DO NOT CHANGE: This is your product code on Beamer
      top: 64, // Optional: Top position offset
      // right: 0, // Optional: Right position offset
      // language: 'EN' // Optional: Bring news in the language of choice
      lazy: true,
      alert: false,
      role: props.companyType || null,
      callback: _this.beamerCallback
    };
    return _this;
  }

  _createClass(Beamer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          isScriptLoaded = _props.isScriptLoaded,
          isScriptLoadSucceed = _props.isScriptLoadSucceed;

      if (isScriptLoaded && isScriptLoadSucceed) {
        window.Beamer.init();
        this.props.setNewFeaturesActive();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var isActive = _ref.isActive,
          isScriptLoaded = _ref.isScriptLoaded,
          isScriptLoadSucceed = _ref.isScriptLoadSucceed;

      if (isScriptLoaded && !this.props.isScriptLoaded) {
        // load finished
        if (isScriptLoadSucceed && !isActive) {
          window.Beamer.init();
          this.props.setNewFeaturesActive();
        }
      }
    }

    // loadCss = () => {
    //   const linkCss = document.createElement('link');
    //   linkCss.type = 'text/css';
    //   linkCss.rel = 'stylesheet';
    //   linkCss.href = 'https://app.getbeamer.com/styles/beamer-embed.css';
    //   document.head.appendChild(linkCss);
    // }

  }]);

  return Beamer;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(null, { receiveNewFeatures: _helpwidgetActions.receiveNewFeatures, setNewFeaturesActive: _helpwidgetActions.setNewFeaturesActive })((0, _reactAsyncScriptLoader2.default)('https://app.getbeamer.com/js/beamer-embed.js')(Beamer));

/***/ }),
/* 2799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _globalErrorsDisplayActions = __webpack_require__(486);

var _noAccessDialog = __webpack_require__(2800);

var _noAccessDialog2 = _interopRequireDefault(_noAccessDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorsDisplayContainer = function ErrorsDisplayContainer(props) {
  if (!props.errorMessage && !props.errorMessageObj && !props.featureName) return _react2.default.createElement('div', null);
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_materialUi.Snackbar, {
      bodyStyle: { maxWidth: '768px' },
      action: 'Dismiss',
      onActionTouchTap: props.clearStore,
      onRequestClose: props.clearStore,
      autoHideDuration: 6000,
      open: Boolean(props.errorMessage),
      message: props.errorMessage || props.errorMessageObj
    }),
    _react2.default.createElement(_noAccessDialog2.default, {
      clearStore: props.clearStore
    })
  );
};
ErrorsDisplayContainer.propTypes = {
  errorMessage: _react2.default.PropTypes.string,
  errorMessageObj: _react2.default.PropTypes.object,
  clearStore: _react2.default.PropTypes.func
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    clearStore: function clearStore() {
      return dispatch((0, _globalErrorsDisplayActions.clearStore)());
    }
  };
};
var mapStateToProps = function mapStateToProps(_ref) {
  var globalErrors = _ref.globalErrors;
  return _extends({}, globalErrors.toJS());
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ErrorsDisplayContainer);

/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _actions = __webpack_require__(253);

var _globalErrorsDisplayActions = __webpack_require__(486);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractingBackground = __webpack_require__(2801);
var UserManagementBackground = __webpack_require__(2802);


var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var NoAccessDialog = function (_Component) {
  _inherits(NoAccessDialog, _Component);

  function NoAccessDialog() {
    _classCallCheck(this, NoAccessDialog);

    return _possibleConstructorReturn(this, (NoAccessDialog.__proto__ || Object.getPrototypeOf(NoAccessDialog)).apply(this, arguments));
  }

  _createClass(NoAccessDialog, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (isNilOrEmpty(this.props.acctAdmin)) this.props.getAdmin(this.props.companyType);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          gettingAdmin = _props.gettingAdmin,
          acctAdmin = _props.acctAdmin,
          featureName = _props.featureName,
          requestingAccess = _props.requestingAccess,
          requestAccess = _props.requestAccess,
          companyType = _props.companyType,
          firstName = _props.firstName,
          lastName = _props.lastName,
          clearStore = _props.clearStore,
          noAccessDialog = _props.noAccessDialog,
          updateProp = _props.updateProp,
          requestAccessError = _props.requestAccessError,
          requestAccessData = _props.requestAccessData,
          routeBackOnDismiss = _props.routeBackOnDismiss,
          message = _props.message;


      var getBackground = _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('userManagement'), _ramda2.default.always(UserManagementBackground)], [_ramda2.default.equals('contracting'), _ramda2.default.always(ContractingBackground)], [_ramda2.default.T, _ramda2.default.always('')]]), featureName);

      var actions = [_react2.default.createElement(_materialUi.FlatButton, {
        label: 'close',
        primary: true,
        onTouchTap: function onTouchTap() {
          if (routeBackOnDismiss) _this2.context.router.goBack();
          clearStore();
        }
      })];

      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          title: 'No Access',
          modal: true,
          open: noAccessDialog,
          overlayStyle: { backgroundImage: 'url(' + getBackground + ')', backgroundSize: 'cover' },
          overlayClassName: 'blur-photos',
          actions: actions
        },
        requestAccessError && _react2.default.createElement(
          'div',
          { style: { fontWeight: 600, color: 'red', marginBottom: '10px' } },
          requestAccessError
        ),
        gettingAdmin && _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'center' } },
          _react2.default.createElement(_materialUi.CircularProgress, null)
        ),
        Boolean(!isNilOrEmpty(acctAdmin)) && _react2.default.createElement(
          'div',
          null,
          'The administrator for this account has restricted your access.',
          Boolean(message) && _react2.default.createElement(
            'div',
            { style: { marginTop: '32px' } },
            message
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '32px' } },
            'You can request access from the administrator by emailing: ',
            _react2.default.createElement(
              'a',
              { href: 'mailto:' + acctAdmin.email + '?subject=Request For Access' },
              acctAdmin.email
            ),
            '.'
          )
        )
      );
    }
  }]);

  return NoAccessDialog;
}(_react.Component);

NoAccessDialog.propTypes = {
  acctAdmin: _react.PropTypes.object,
  featureName: _react.PropTypes.string,
  getAdmin: _react.PropTypes.func,
  gettingAdmin: _react.PropTypes.bool,
  companyType: _react.PropTypes.string,
  requestingAccess: _react.PropTypes.bool,
  requestAccess: _react.PropTypes.func,
  firstName: _react.PropTypes.string,
  lastName: _react.PropTypes.string,
  noAccessDialog: _react.PropTypes.bool,
  updateProp: _react.PropTypes.func,
  requestAccessError: _react.PropTypes.string,
  requestAccessData: _react.PropTypes.object,
  routeBackOnDismiss: _react.PropTypes.bool,
  clearStore: _react.PropTypes.func,
  message: _react.PropTypes.string
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getAdmin: function getAdmin(companyType) {
      return dispatch((0, _actions.getCompanyAdmin)(companyType));
    },
    requestAccess: function requestAccess(payload) {
      return dispatch((0, _globalErrorsDisplayActions.requestAccessFromAdmin)(payload));
    },
    updateProp: function updateProp() {
      return dispatch(_globalErrorsDisplayActions.triggerError.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var userManagement = _ref.userManagement,
      globalErrors = _ref.globalErrors,
      user = _ref.user;
  return {
    companyType: user.getIn(['user', 'type']),
    firstName: user.get('firstName'),
    lastName: user.get('lastName'),
    acctAdmin: userManagement.get('acctAdmin').toJS(),
    gettingAdmin: userManagement.get('gettingAdmin'),
    requestingAccess: globalErrors.get('requestingAccess'),
    requestAccessError: globalErrors.get('requestAccessError'),
    noAccessDialog: globalErrors.get('noAccessDialog'),
    featureName: globalErrors.get('requestingAccessToFeature'),
    requestAccessData: globalErrors.get('requestAccessData'),
    routeBackOnDismiss: globalErrors.get('routeBackOnDismiss'),
    message: globalErrors.get('message')
  };
};
NoAccessDialog.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NoAccessDialog);

/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fd33cbace4339e6c76996292c8545fbe.png";

/***/ }),
/* 2802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "677ffec2775f8b679b384cfd22a2084d.png";

/***/ }),
/* 2803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _lock = __webpack_require__(578);

var _lock2 = _interopRequireDefault(_lock);

var _lockOpen = __webpack_require__(2804);

var _lockOpen2 = _interopRequireDefault(_lockOpen);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRouterRedux = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  dialogContent: {
    width: '100% !important',
    maxWidth: 'none !important',
    transform: 'none !important'
  },
  dialogBody: {
    height: 'calc(100vh - 64px)',
    padding: '0 !important',
    maxHeight: 'none !important'
    // height: '100%',
  },
  dialogRoot: {
    paddingTop: '0 !important'
  }
};

var Wall = function Wall(_ref) {
  var blocker = _ref.blocker,
      css = _ref.classes,
      open = _ref.open,
      plan = _ref.plan,
      push = _ref.push,
      setOpen = _ref.setOpen,
      skipBack = _ref.skipBack,
      trackEvent = _ref.trackEvent,
      url = _ref.url;

  if (!open || plan !== 'basic') return null;
  var handleClose = function handleClose() {
    if (blocker) {
      if (!skipBack) {
        window.history.back();
        setTimeout(function () {
          setOpen(false);
        }, 1e3);
      } else {
        setOpen(false);
      }
      // wait for the browser to load the prev screen
    } else {
      setOpen(false);
    }
  };
  var slug = url.split('/').pop();
  var handleUpgrade = function handleUpgrade() {
    trackEvent({ name: '[Wall] Upgrade Click', ga: {
        eventCategory: 'account',
        eventAction: 'creditCardOpen',
        eventValue: slug
      } });
    push('/upgrade');
    setTimeout(function () {
      setOpen(false);
    }, 1e3);
  };
  var handleFrameLoad = function handleFrameLoad() {
    trackEvent({ name: '[Wall] Opened ' + slug, ga: {
        eventCategory: 'account',
        eventAction: 'wallOpen',
        eventValue: slug
      } });
  };
  var titleTxt = function () {
    if (slug === 'upgrade-general' || blocker) return _react2.default.createElement(
      'span',
      null,
      'Upgrade today for access to premium features.',
      _react2.default.createElement('br', null),
      'Your contributions help us build great new features. Become a contributor, today!'
    );
    return _react2.default.createElement(
      'span',
      null,
      _react2.default.createElement(
        'strong',
        null,
        'Good news!'
      ),
      ' While this is one of our premium features,\xA0',
      _react2.default.createElement(
        'strong',
        null,
        'we\u2019ve unlocked it for you!'
      ),
      _react2.default.createElement('br', null),
      'Upgrade today to support more features like this.'
    );
  }();
  var LockIcon = blocker ? _lock2.default : _lockOpen2.default;
  var title = _react2.default.createElement(
    'div',
    { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '64px' } },
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', alignItems: 'center', justifyContent: 'flex-start' } },
      _react2.default.createElement(LockIcon, { style: { width: '26px', height: '26px', color: 'white' } }),
      _react2.default.createElement(
        'p',
        { style: { marginLeft: '1em', paddingTop: '0', marginBottom: '0', fontSize: '1rem', color: 'white' } },
        titleTxt
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_materialUi.RaisedButton, {
        backgroundColor: '#FFC107',
        labelColor: 'black',
        label: 'Upgrade Now',
        labelStyle: { fontWeight: 'bold' },
        buttonStyle: { lineHeight: 'none' },
        onTouchTap: handleUpgrade,
        style: { marginRight: '1em' }
      }),
      _react2.default.createElement(_materialUi.RaisedButton, {
        label: 'No, thank you',
        buttonStyle: { lineHeight: 'none' },
        onTouchTap: handleClose
      })
    )
  );
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      style: { zIndex: 2101 },
      className: css.dialogRoot,
      open: open,
      onRequestClose: handleClose,
      title: title,
      titleStyle: { backgroundColor: '#00bcd4', color: 'white' },
      contentClassName: css.dialogContent,
      bodyClassName: css.dialogBody
    },
    _react2.default.createElement('iframe', { src: url, width: '100%', height: '100%', title: 'Upgrade Promo', onLoad: handleFrameLoad })
  );
};
/*
*onClick={handleCose} />
*/
/*
      <div style={{ backgroundColor: 'rgb(250, 250, 250)', position: 'fixed', top: 0, left: 0, height: '100%', width: '100%', zIndex: 1350 }}>
        <iframe src={ url } width='100%' height='100%' title="Upgrade Promo"/>
      </div>
*/
exports.default = (0, _reactRedux.connect)(function (_ref2) {
  var _ref2$walls = _ref2.walls,
      open = _ref2$walls.open,
      url = _ref2$walls.url,
      blocker = _ref2$walls.blocker,
      skipBack = _ref2$walls.skipBack,
      user = _ref2.user;
  return {
    open: open, url: url, blocker: blocker, skipBack: skipBack, plan: user.getIn(['company', 'plan']) || 'basic'
  };
}, {
  setOpen: function setOpen(payload) {
    return {
      type: '[wall] openClose',
      payload: payload
    };
  },
  trackEvent: function trackEvent(payload) {
    return {
      type: 'TRACK_EVENT',
      payload: payload
    };
  },
  push: _reactRouterRedux.push
})((0, _reactJss2.default)(styles)(Wall));

/***/ }),
/* 2804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLockOpen = function ActionLockOpen(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z' })
  );
};
ActionLockOpen = (0, _pure2.default)(ActionLockOpen);
ActionLockOpen.displayName = 'ActionLockOpen';
ActionLockOpen.muiName = 'SvgIcon';

exports.default = ActionLockOpen;

/***/ }),
/* 2805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _onboardingModal = __webpack_require__(2806);

var _onboardingModal2 = _interopRequireDefault(_onboardingModal);

var _QuickLinksItem = __webpack_require__(2807);

var _QuickLinksItem2 = _interopRequireDefault(_QuickLinksItem);

var _DashboardRow = __webpack_require__(2808);

var _DashboardRow2 = _interopRequireDefault(_DashboardRow);

var _Stats = __webpack_require__(2809);

var _Stats2 = _interopRequireDefault(_Stats);

var _StatItem = __webpack_require__(2810);

var _StatItem2 = _interopRequireDefault(_StatItem);

var _Updates = __webpack_require__(2811);

var _Updates2 = _interopRequireDefault(_Updates);

var _connectionsActions = __webpack_require__(1221);

var _partnerFinderActions = __webpack_require__(1125);

var _actions = __webpack_require__(1877);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DashboardContainer = function (_Component) {
  _inherits(DashboardContainer, _Component);

  function DashboardContainer(props, context) {
    _classCallCheck(this, DashboardContainer);

    // if (props.user.contractingShell) context.router.push('/profile');

    var _this = _possibleConstructorReturn(this, (DashboardContainer.__proto__ || Object.getPrototypeOf(DashboardContainer)).call(this, props));

    _this.handleOnboardingClose = _this.handleOnboardingClose.bind(_this);
    return _this;
  }

  _createClass(DashboardContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          dispatch = _props.dispatch,
          user = _props.user;

      dispatch((0, _connectionsActions.filterConnections)({ 'status': 'requests' }));
      var partnerFinderSearchParams = { log: false };
      partnerFinderSearchParams.destinationsSold = partnerFinderSearchParams.destinationsSold || [];
      var country = user.company.address.country;

      partnerFinderSearchParams.companyType = partnerFinderSearchParams.companyType || (user.user.type === 'Contractor' ? 'Supplier' : 'Contractor');
      if (partnerFinderSearchParams.companyType === 'Contractor') {
        partnerFinderSearchParams.destinationsSold = [country];
        partnerFinderSearchParams.country = undefined;
      } else {
        partnerFinderSearchParams.destinationsSold = [];
        partnerFinderSearchParams.country = country;
      }
      partnerFinderSearchParams.isForPremiumUser = user.billingPlan === 'connected' || user.billingPlan === 'unlimited';
      partnerFinderSearchParams.page = undefined;
      dispatch((0, _partnerFinderActions.searchCountOnly)(partnerFinderSearchParams, false, false));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      dispatch((0, _actions.initDashboard)());
    }
  }, {
    key: 'handleOnboardingClose',
    value: function handleOnboardingClose(e) {
      var dispatch = this.props.dispatch;

      if (e) {
        e.preventDefault();
      }
      dispatch((0, _actions.closeOnboardingDialog)());
    }
  }, {
    key: 'handleFinishProfileModalClose',
    value: function handleFinishProfileModalClose() {
      this.setState({ finishProfileModalOpen: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          connections = _props2.connections,
          connectionsStats = _props2.connectionsStats,
          dashboard = _props2.dashboard,
          media = _props2.marketingMaterials.media,
          settings = _props2.settings,
          profile = _props2.profile,
          partnerFinder = _props2.partnerFinder,
          user = _props2.user,
          firstName = _props2.user.user.firstName,
          lockedPartnersBanner = _props2.lockedPartnersBanner;


      var quickLinks = {
        addExistingPartners: {
          buttonText: 'Grow Your Network',
          icon: __webpack_require__(2813),
          primaryText: 'Quickly Add Your Existing Partners and connect with partners you already work with.',
          routeName: '/connections/add-connections',
          secondaryText: ''
        },
        completeProfile: {
          buttonText: 'Complete Your Profile',
          icon: __webpack_require__(2814),
          primaryText: 'Your profile is ' + (profile.marketingReadinessPercentage ? 'only ' + profile.marketingReadinessPercentage + '%' : 'not') + ' complete.',
          routeName: '/profile',
          secondaryText: 'Show potential partners all you have to offer.'
        },
        searchPartnerFinder: {
          buttonText: 'Start Your Search',
          icon: __webpack_require__(2815),
          primaryText: 'There are ' + partnerFinder.total + ' ' + (user.user.type === 'Contractor' ? 'suppliers' : 'buyers') + ' in ' + user.company.address.country + '.',
          routeName: '/partner-finder/results',
          secondaryText: 'Search for new partners.'
        },
        inviteTeam: {
          buttonText: 'Invite Your Team',
          icon: __webpack_require__(2816),
          primaryText: 'TourConnect is better with friends.',
          routeName: '/settings/manage-users',
          secondaryText: 'Invite your collegues to join.'
        },
        uploadMarketingMaterial: {
          buttonText: 'Upload Now',
          icon: __webpack_require__(2817),
          primaryText: 'A single location to store and send your marketing assets.',
          routeName: '/profile#marketing-materials',
          secondaryText: ''
        },
        contractorRequestRates: {
          buttonText: 'Send Rate Requests',
          icon: __webpack_require__(2818),
          primaryText: 'Ready to make rates easier?',
          routeName: '/contracting/contract-list/recent',
          secondaryText: 'Request rates from your suppliers.'
        },
        supplierSendRates: {
          buttonText: 'Create A Rate Template',
          icon: __webpack_require__(2819),
          primaryText: 'Ready to automatically send your annual rates to all your partners around the world?',
          routeName: '/contracting',
          secondaryText: ''
        }
      };

      var onboardingModalSlides = [{
        header: 'Congratulations!',
        subHeader: 'Your company is now part of the TourConnect network.',
        content: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('img', { style: { minHeight: '100%', padding: '25px' }, src: __webpack_require__(2820) }),
          _react2.default.createElement(
            'div',
            { style: { padding: '10px 0' } },
            _react2.default.createElement(
              'h4',
              { style: { color: 'rgba(0, 0, 0, 0.54)' } },
              'Let\'s take a moment to show you how TourConnect works.'
            )
          )
        )
      }, {
        header: 'Your TourConnect Profile',
        subHeader: 'TourConnect helps showcase your products and services.',
        content: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', padding: '25px', width: '50%', verticalAlign: 'top' } },
            _react2.default.createElement('img', { style: { maxWidth: '100%' }, src: __webpack_require__(2821) })
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', padding: '25px', textAlign: 'left', width: '50%', verticalAlign: 'top' } },
            _react2.default.createElement(
              'p',
              { style: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' } },
              'Your TourConnect profile is where your partners find information about your products, contacts, and industry memberships.'
            ),
            _react2.default.createElement(
              'p',
              { style: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' } },
              'A complete, and up-to-date, profile helps to maintain a strong relationship \u2014 driving more business opportunities.'
            )
          )
        ),
        buttonText: "Let's Go"
      }, {
        header: 'PartnerFinder',
        subHeader: 'TourConnect makes it easier to find new partners.',
        content: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', padding: '25px', width: '50%', verticalAlign: 'top' } },
            _react2.default.createElement('img', { style: { maxWidth: '100%' }, src: __webpack_require__(2822) })
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', padding: '25px', textAlign: 'left', width: '50%', verticalAlign: 'top' } },
            _react2.default.createElement(
              'p',
              { style: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' } },
              'Quickly search for the type of partners you need to grow your business.'
            ),
            _react2.default.createElement(
              'p',
              { style: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' } },
              'Get detailed information about potential partners to decide if they are a fit for your business.'
            ),
            _react2.default.createElement(
              'p',
              { style: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' } },
              'Send a connection request to kickstart a potential new relationship.'
            )
          )
        ),
        buttonText: 'Finding New Partners'
      }, {
        header: 'Rates & Contracts',
        subHeader: 'TourConnect brings organization to the contracting process.',
        content: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', padding: '25px', width: '50%', verticalAlign: 'top' } },
            _react2.default.createElement('img', { style: { maxWidth: '100%' }, src: __webpack_require__(2823) })
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', padding: '25px', textAlign: 'left', width: '50%', verticalAlign: 'top' } },
            _react2.default.createElement(
              'p',
              { style: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' } },
              'Create and manage rate templates for your products and services - so you\'ll never have to duplicate effort again.'
            ),
            _react2.default.createElement(
              'p',
              { style: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' } },
              'Easily send contracts and updates to all of your partners - then know when they have been viewed or loaded.'
            )
          )
        ),
        buttonText: 'Automating Rates & Contracts'
      }];

      return _react2.default.createElement(
        'div',
        { style: { margin: '0 auto', maxWidth: '1232px', paddingTop: '64px' } },
        lockedPartnersBanner,
        _react2.default.createElement(
          _DashboardRow2.default,
          null,
          _react2.default.createElement(
            'div',
            { style: { width: '100%', padding: '20px 0' } },
            _react2.default.createElement(
              'h1',
              { style: { fontWeight: 300, fontSize: '28px', lineHeight: '36px', margin: 0, textAlign: 'center' } },
              'Welcome to TourConnect' + (firstName ? ', ' + firstName + '.' : '!')
            ),
            _react2.default.createElement(
              'h2',
              { style: { fontWeight: 300, fontSize: '16px', lineHeight: '24px', margin: 0, padding: 0, textAlign: 'center' } },
              'Take a look at new things going on in your Network'
            )
          )
        ),
        _react2.default.createElement(
          _DashboardRow2.default,
          null,
          profile.isMarketingReady ? _react2.default.createElement(_QuickLinksItem2.default, quickLinks.searchPartnerFinder) : _react2.default.createElement(_QuickLinksItem2.default, quickLinks.completeProfile),
          settings.usersArray.length > 1 ? _react2.default.createElement(_QuickLinksItem2.default, quickLinks.addExistingPartners) : _react2.default.createElement(_QuickLinksItem2.default, quickLinks.inviteTeam),
          user.user.type === 'Contractor' ? _react2.default.createElement(_QuickLinksItem2.default, quickLinks.contractorRequestRates) : profile.acctCreationReason === 'send-rates' && profile.isMarketingReady ? _react2.default.createElement(_QuickLinksItem2.default, quickLinks.supplierSendRates) : _react2.default.createElement(_QuickLinksItem2.default, quickLinks.uploadMarketingMaterial)
        ),
        _react2.default.createElement(
          _DashboardRow2.default,
          null,
          _react2.default.createElement(_Updates2.default, { items: connections.items, title: 'Recent Updates' }),
          _react2.default.createElement(
            _Stats2.default,
            { disabled: connectionsStats.totalCount < 5, title: 'Quick Stats', style: { padding: '15px' } },
            _react2.default.createElement(_StatItem2.default, { statName: 'Connections', statValue: connectionsStats.totalCount, style: { display: 'inline-block', marginBottom: '15px', textAlign: 'center', width: 'calc(100%/2)' } }),
            _react2.default.createElement(_StatItem2.default, { statName: 'Profile Views', statValue: profile.profileViews && profile.profileViews.length || 0, style: { display: 'inline-block', marginBottom: '15px', textAlign: 'center', width: 'calc(100%/2)' } }),
            _react2.default.createElement(_StatItem2.default, { statName: 'Storage', statValue: Math.ceil(media.length ? media.map(function (m) {
                return m.size && m.size !== 'external' ? parseFloat(m.size) : 0;
              }).reduce(function (total, size) {
                return total + size;
              }, 0) : '0') + 'mb', style: { display: 'inline-block', textAlign: 'center', width: 'calc(100%/2)' } }),
            _react2.default.createElement(_StatItem2.default, { statName: 'Invitations Sent', statValue: connectionsStats.pendingInviteCount, style: { display: 'inline-block', textAlign: 'center', width: 'calc(100%/2)' } })
          )
        ),
        user.user.type !== 'Contractor' && _react2.default.createElement(_onboardingModal2.default, {
          showOnboardingDialog: dashboard.showOnboardingDialog,
          handleModalClose: this.handleOnboardingClose,
          lastSlideButton: 'Next: Start Using TourConnect',
          onLastSlideButtonClick: this.handleOnboardingClose,
          slides: onboardingModalSlides
        })
      );
    }
  }]);

  return DashboardContainer;
}(_react.Component);

DashboardContainer.propTypes = {
  connections: _react.PropTypes.object,
  connectionsStats: _react.PropTypes.object,
  dashboard: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  marketingMaterials: _react.PropTypes.object,
  partnerFinder: _react.PropTypes.object,
  profile: _react.PropTypes.object,
  user: _react.PropTypes.object
};

var mapStateToProps = function mapStateToProps(store) {
  return {
    connections: store.connections.toJS(),
    connectionsStats: store.connectionsStats.toJS(),
    dashboard: store.dashboard,
    marketingMaterials: store.marketingMaterials.mainReducer.toJS(),
    partnerFinder: store.partnerFinder.toJS(),
    profile: store.profile.toJS(),
    settings: store.settings.toJS(),
    user: store.user.toJS()
  };
};

DashboardContainer.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DashboardContainer);

/***/ }),
/* 2806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(67);

var _materialUi = __webpack_require__(3);

var _chevronRight = __webpack_require__(1204);

var _chevronRight2 = _interopRequireDefault(_chevronRight);

var _arrowBack = __webpack_require__(1124);

var _arrowBack2 = _interopRequireDefault(_arrowBack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnboardingModal = function (_Component) {
  _inherits(OnboardingModal, _Component);

  function OnboardingModal(props) {
    _classCallCheck(this, OnboardingModal);

    var _this = _possibleConstructorReturn(this, (OnboardingModal.__proto__ || Object.getPrototypeOf(OnboardingModal)).call(this, props));

    _this.handleModalClose = function () {
      _this.props.handleModalClose();
    };

    _this.state = {
      currentIndex: 0
    };

    _this.nextSlide = _this.nextSlide.bind(_this);
    _this.prevSlide = _this.prevSlide.bind(_this);
    return _this;
  }

  _createClass(OnboardingModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.showOnboardingDialog !== nextProps.showOnboardingDialog) this.setState({ currentIndex: 0 });
    }
  }, {
    key: 'nextSlide',
    value: function nextSlide(e) {
      e.preventDefault();
      this.setState({ currentIndex: this.state.currentIndex + 1 });
    }
  }, {
    key: 'prevSlide',
    value: function prevSlide(e) {
      e.preventDefault();
      this.setState({ currentIndex: this.state.currentIndex - 1 });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleModalClose = _props.handleModalClose,
          lastSlideButton = _props.lastSlideButton,
          onLastSlideButtonClick = _props.onLastSlideButtonClick,
          showOnboardingDialog = _props.showOnboardingDialog,
          slides = _props.slides,
          showSkipButton = _props.showSkipButton;


      var buttonText = this.state.currentIndex !== slides.length - 1 ? slides[this.state.currentIndex + 1].buttonText : lastSlideButton;
      var onSlideButtonClick = this.state.currentIndex !== slides.length - 1 ? this.nextSlide : onLastSlideButtonClick;

      var nextButton = typeof onSlideButtonClick === 'string' ? _react2.default.createElement(
        _reactRouter.Link,
        { to: onSlideButtonClick },
        _react2.default.createElement(_materialUi.RaisedButton, { primary: true, label: '' + (this.state.currentIndex !== 0 && this.state.currentIndex !== slides.length - 1 ? 'Next: ' : '') + buttonText, labelPosition: 'before', icon: _react2.default.createElement(_chevronRight2.default, null), style: { marginLeft: '10%', textAlign: 'right' } })
      ) : _react2.default.createElement(_materialUi.RaisedButton, { onClick: onSlideButtonClick, primary: true, label: '' + (this.state.currentIndex !== 0 && this.state.currentIndex !== slides.length - 1 ? 'Next: ' : '') + buttonText, labelPosition: 'before', icon: _react2.default.createElement(_chevronRight2.default, null), style: { marginLeft: '10%', textAlign: 'right' } });

      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          actions: _react2.default.createElement(
            'div',
            { style: { backgroundColor: '#f3f3f3', padding: '10px', width: '100%' } },
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', width: '70%', textAlign: 'left' } },
              this.state.currentIndex > 0 && _react2.default.createElement(
                'p',
                { style: { display: 'inline-block', margin: '0 0 0 5%', padding: 0 } },
                _react2.default.createElement(_materialUi.FlatButton, { onClick: this.prevSlide, icon: _react2.default.createElement(_arrowBack2.default, null), style: { color: '#00bcd4' }, label: 'back' })
              ),
              nextButton
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', width: '30%' } },
              (showSkipButton || this.state.currentIndex !== slides.length - 1) && _react2.default.createElement(
                'a',
                { onTouchTap: handleModalClose, style: { marginRight: '10%', cursor: 'pointer', textAlign: 'right' } },
                'Skip the tour'
              )
            )
          ),
          modal: true,
          open: showOnboardingDialog,
          onRequestClose: this.handleModalClose,
          actionsContainerStyle: { padding: 0 },
          bodyStyle: { minHeight: '350px' },
          title: slides[this.state.currentIndex].header || null,
          titleStyle: { backgroundColor: 'rgb(0, 188, 212)', color: 'rgb(255, 255, 255)', fontSize: '18px', marginBottom: '10px', padding: '1%', textAlign: 'center' }
        },
        _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          _react2.default.createElement(
            'h2',
            { style: { fontWeight: 500, fontSize: '24px', margin: 0, padding: 0 } },
            slides[this.state.currentIndex].subHeader
          ),
          slides[this.state.currentIndex].content
        )
      );
    }
  }]);

  return OnboardingModal;
}(_react.Component);

OnboardingModal.propTypes = {
  handleModalClose: _react.PropTypes.func,
  lastSlideButton: _react.PropTypes.string,
  onLastSlideButtonClick: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
  showOnboardingDialog: _react.PropTypes.bool,
  showSkipButton: _react.PropTypes.bool,
  slides: _react.PropTypes.array
};

exports.default = OnboardingModal;

/***/ }),
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(67);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _react.PropTypes.func,
    string = _react.PropTypes.string;


var QuickLinksItem = function QuickLinksItem(_ref) {
  var buttonText = _ref.buttonText,
      disabled = _ref.disabled,
      icon = _ref.icon,
      primaryText = _ref.primaryText,
      routeName = _ref.routeName,
      onClick = _ref.onClick,
      secondaryText = _ref.secondaryText,
      style = _ref.style;
  return _react2.default.createElement(
    _materialUi.Paper,
    { style: _extends({}, { padding: '30px', textAlign: 'center' }, style, disabled && { position: 'relative' }) },
    _react2.default.createElement('img', { src: icon }),
    _react2.default.createElement(
      'div',
      { style: { padding: '10px 0' } },
      _react2.default.createElement(
        'p',
        { style: { margin: 0, padding: 0 } },
        primaryText
      ),
      _react2.default.createElement(
        'p',
        { style: { margin: 0, padding: 0 } },
        secondaryText
      )
    ),
    _react2.default.createElement(
      _reactRouter.Link,
      { to: routeName, onClick: onClick },
      _react2.default.createElement(_materialUi.RaisedButton, { primary: true, label: buttonText })
    )
  );
};

QuickLinksItem.propTypes = {
  buttonText: string.isRequired,
  icon: string.isRequired,
  onClick: func,
  primaryText: string.isRequired,
  secondaryText: string,
  routeName: string.isRequired
};

exports.default = QuickLinksItem;

/***/ }),
/* 2808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var node = _react.PropTypes.node,
    object = _react.PropTypes.object;


var DashboardRow = function DashboardRow(_ref) {
  var children = _ref.children,
      style = _ref.style,
      titleStyle = _ref.titleStyle;

  var requiredStyles = {
    verticalAlign: 'top',
    display: 'inline-block',
    width: 'calc(100%/' + (children.length || 1) + ')'
  };

  var rowStyle = _extends({}, { paddingBottom: '15px', paddingRight: '10px' }, style, requiredStyles);

  var rowContent = _react.Children.map(children, function (child, key) {
    return _react2.default.createElement(
      'div',
      { style: rowStyle },
      _react2.default.createElement(
        'h3',
        {
          style: _extends({}, {
            fontSize: '16px',
            fontWeight: '300',
            margin: 0,
            padding: 0,
            textAlign: key % 2 === 0 ? 'left' : 'right'
          }, titleStyle)
        },
        child.props.title
      ),
      (0, _react.cloneElement)(child, { key: key })
    );
  });

  return _react2.default.createElement(
    'div',
    null,
    rowContent
  );
};

DashboardRow.propTypes = {
  children: node.isRequired,
  style: object
};

exports.default = DashboardRow;

/***/ }),
/* 2809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(67);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bool = _react.PropTypes.bool,
    node = _react.PropTypes.node,
    object = _react.PropTypes.object;


var Stats = function Stats(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      style = _ref.style;
  return _react2.default.createElement(
    _materialUi.Paper,
    { style: _extends({}, style, { textAlign: 'center' }, disabled ? { position: 'relative' } : {}) },
    disabled && _react2.default.createElement(
      _materialUi.Paper,
      { style: {
          backgroundColor: 'rgba(232, 232, 232, 0.96)',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%'
        }
      },
      _react2.default.createElement(
        'div',
        { style: { position: 'absolute', top: '50%', transform: 'translateY(-50%)', width: '100%' } },
        _react2.default.createElement(
          'p',
          { style: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px', fontWeight: '500', margin: 0, padding: 0 } },
          'Stats shown after having more than 5 connections.'
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/connections/add-connections' },
          _react2.default.createElement(_materialUi.FlatButton, { label: 'Invite Your Current Partners', primary: true })
        )
      )
    ),
    !disabled ? children : _react.Children.map(children, function (child, key) {
      return (0, _react.cloneElement)(child, { disabled: disabled, key: key });
    })
  );
};

Stats.propTypes = {
  children: node,
  disabled: bool,
  style: object
};

exports.default = Stats;

/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bool = _react.PropTypes.bool,
    number = _react.PropTypes.number,
    object = _react.PropTypes.object,
    oneOfType = _react.PropTypes.oneOfType,
    string = _react.PropTypes.string;


var StatItem = function StatItem(_ref) {
  var disabled = _ref.disabled,
      statName = _ref.statName,
      statValue = _ref.statValue,
      statNameStyle = _ref.statNameStyle,
      stateValueStyle = _ref.stateValueStyle,
      style = _ref.style;
  return _react2.default.createElement(
    'div',
    { style: style },
    _react2.default.createElement(
      'h4',
      { style: _extends({}, { color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px', fontWeight: '400', lineHeight: '16px', marginBottom: '10px', padding: 0, textTransform: 'uppercase' }, statNameStyle) },
      statName
    ),
    _react2.default.createElement(
      'h5',
      { style: _extends({}, { fontSize: '48px', fontWeight: '500', lineHeight: '48px', margin: 0, padding: 0, marginBottom: '15px' }, stateValueStyle) },
      !disabled ? statValue : 0
    )
  );
};

StatItem.propTypes = {
  disabled: bool,
  statName: string.isRequired,
  statValue: oneOfType([string, number]).isRequired,
  statNameStyle: object,
  stateValueStyle: object
};

exports.default = StatItem;

/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(67);

var _materialUi = __webpack_require__(3);

var _UpdateItem = __webpack_require__(2812);

var _UpdateItem2 = _interopRequireDefault(_UpdateItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bool = _react.PropTypes.bool,
    node = _react.PropTypes.node,
    object = _react.PropTypes.object;


var StatItem = function StatItem(_ref) {
  var items = _ref.items;
  return _react2.default.createElement(
    'div',
    null,
    items.length > 0 ? items.slice(0, 3).map(function (connection, key) {
      if (connection.status === 'pending') {
        return _react2.default.createElement(_UpdateItem2.default, { companyName: connection.name, profileImageUrl: connection.profileImageUrl, key: key });
      }
    }) : _react2.default.createElement(
      _materialUi.Paper,
      { style: { padding: '30px', textAlign: 'center', height: '100%' } },
      'No Updates At This Time.'
    )
  );
};

StatItem.propTypes = {
  children: node,
  disabled: bool,
  style: object
};

exports.default = StatItem;

/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(67);

var _materialUi = __webpack_require__(3);

var _profileImage = __webpack_require__(548);

var _profileImage2 = _interopRequireDefault(_profileImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _react.PropTypes.object,
    string = _react.PropTypes.string;


var UpdateItem = function UpdateItem(_ref) {
  var companyName = _ref.companyName,
      profileImageUrl = _ref.profileImageUrl,
      style = _ref.style,
      updateType = _ref.updateType;
  return _react2.default.createElement(
    _materialUi.Paper,
    { style: { display: 'inline-block', height: '100%', marginBottom: '5px', width: '100%' } },
    _react2.default.createElement(
      'div',
      {
        style: {
          verticalAlign: 'middle',
          display: 'inline-block',
          textAlign: 'center',
          width: 'calc(15%)',
          paddingLeft: '3%'
        }
      },
      _react2.default.createElement(_profileImage2.default, {
        className: 'profile-link-image connections-profile-link-image',
        companySlugName: companyName,
        imageUrl: profileImageUrl
      })
    ),
    _react2.default.createElement(
      'div',
      {
        style: {
          verticalAlign: 'middle',
          display: 'inline-block',
          width: 'calc(70%)'
        }
      },
      _react2.default.createElement(
        'h2',
        { style: {
            fontSize: '16px',
            lineHeight: '16px',
            paddingTop: '0',
            margin: '0px',
            letterSpacing: '-1px',
            fontWeight: '300',
            color: 'rgba(0, 0, 0, 0.54)'
          }
        },
        _react2.default.createElement(
          'strong',
          { style: { fontWeight: 500 } },
          companyName
        ),
        ' has sent a request to connect'
      )
    ),
    _react2.default.createElement(
      'div',
      {
        style: {
          verticalAlign: 'middle',
          display: 'inline-block',
          width: 'calc(15%)',
          textAlign: 'right',
          padding: 0
        }
      },
      _react2.default.createElement(
        _reactRouter.Link,
        {
          style: {
            display: 'inline-block',
            backgroundColor: '#ff4081',
            color: '#ffffff',
            padding: '25px',
            textTransform: 'uppercase',
            fontWeight: 400,
            fontSize: '18px'
          },
          to: "/connections/requests"
        },
        'Go'
      )
    )
  );
};

UpdateItem.propTypes = {
  companyName: string,
  style: object,
  updateType: string
};

exports.default = UpdateItem;

/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "da6f471cd32f320b16359c7fe21b6339.svg";

/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dbdb2d426e6addaa92ab2c860dd77f71.svg";

/***/ }),
/* 2815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1f66e9cf8157cb04f2c6375da7fe1f74.svg";

/***/ }),
/* 2816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "34d75b2e9f4400f35616d05093e90998.svg";

/***/ }),
/* 2817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0acf0784970523e6bc838a1ed87cff44.svg";

/***/ }),
/* 2818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e1361ee17af8a5e1aad9f3e0f1776687.svg";

/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "03ac4c0d5fa7007aeb1402928ec57c13.svg";

/***/ }),
/* 2820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5cc6a9719864406ea87a6224ae1551e3.svg";

/***/ }),
/* 2821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b50d9fae898b29286b140df8b46b2c8a.png";

/***/ }),
/* 2822 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3ca5a54f941d84ba9d1513d0610c4ff4.png";

/***/ }),
/* 2823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7da29971d937e3c33d26516e330d119c.png";

/***/ }),
/* 2824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__(251);

var _jquery2 = _interopRequireDefault(_jquery);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

var _reactRedux = __webpack_require__(6);

var _onboardingActions = __webpack_require__(1482);

var _userActions = __webpack_require__(868);

var _profileActions = __webpack_require__(546);

var _actions = __webpack_require__(1877);

var _form = __webpack_require__(2826);

var _form2 = _interopRequireDefault(_form);

var _materialUi = __webpack_require__(3);

var _sectionHeading = __webpack_require__(732);

var _sectionHeading2 = _interopRequireDefault(_sectionHeading);

var _onBoardingProfileImage = __webpack_require__(2827);

var _onBoardingProfileImage2 = _interopRequireDefault(_onBoardingProfileImage);

var _contactInfo = __webpack_require__(2831);

var _contactInfo2 = _interopRequireDefault(_contactInfo);

var _aboutYourCompany = __webpack_require__(2832);

var _aboutYourCompany2 = _interopRequireDefault(_aboutYourCompany);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var languageSettings = _languages2.default['en-US'];

var doesntExist = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var camelCase = function camelCase(contactInformation) {
  return {
    contactFirstName: contactInformation.first_name,
    contactLastName: contactInformation.last_name,
    contactEmail: contactInformation.email,
    contactPhone: contactInformation.phone
  };
};

var OnBoarding = (0, _react.createClass)({

  propTypes: {
    routeName: _react.PropTypes.string,
    dispatch: _react.PropTypes.func,
    user: _react.PropTypes.object,
    onboarding: _react.PropTypes.object,
    history: _react.PropTypes.object
  },

  getInitialState: function getInitialState() {
    var _props = this.props,
        user = _props.user,
        dispatch = _props.dispatch;
    var contactInformation = user.company.contactInformation;

    var contactInfo = Object.keys(contactInformation).length ? camelCase(contactInformation) : {
      'firstName': user.firstName,
      'lastName': user.lastName
    };
    var profileImageUrl = user.company.profileImageUrl ? user.company.profileImageUrl + '?' + new Date().getTime() : undefined;
    var prePopulateAddress = user.company.address || {};
    var sharedFields = {
      companyTypes: user.company.companyTypes,
      countriesServed: user.company.countriesServed,
      description: user.company.description,
      phone: user.company.phone,
      websiteUrl: user.company.websiteUrl,
      refreshDialog: false,
      addressDialog: false,
      oneOrMultiProperties: user.company.oneOrMultiProperties,
      singleLocId: user.company.singleLocId
    };

    dispatch((0, _onboardingActions.setOnboardingFields)(_extends({
      city: prePopulateAddress.city,
      companyAddressLineOne: prePopulateAddress.address_1,
      companyAddressLineTwo: prePopulateAddress.address_2,
      contactEmail: contactInfo.email,
      contactFirstName: contactInfo.firstName,
      contactLastName: contactInfo.lastName,
      contactPhone: contactInfo.phone,
      country: prePopulateAddress.country,
      marketSegments: user.company.segments,
      postalCode: prePopulateAddress.postal_code,
      state: prePopulateAddress.state
    }, sharedFields)));
    // if (user.onBoardingStatus === 'verify') {
    //   dispatch(setOnboardingFields(Object.assign({
    //     city: prePopulateAddress.city,
    //     companyAddressLineOne: prePopulateAddress.address_1,
    //     companyAddressLineTwo: prePopulateAddress.address_2,
    //     contactEmail: contactInfo.email,
    //     contactFirstName: contactInfo.firstName,
    //     contactLastName: contactInfo.lastName,
    //     contactPhone: contactInfo.phone,
    //     country: prePopulateAddress.country,
    //     marketSegments: user.company.segments,
    //     postalCode: prePopulateAddress.postal_code,
    //     state: prePopulateAddress.state,
    //   }, sharedFields)));
    // } else {
    //   dispatch(setOnboardingFields({ country: prePopulateAddress.country }));
    // }
    // If no image display the default company logo
    return _extends({
      formattedAddressObj: {},
      onBoardingStatus: user.onBoardingStatus,
      prePopulateAddress: user.company.address,
      prePopulateContactInformation: contactInfo,
      productType: user.company.productType,
      segments: user.company.segments,
      selectedNo: 0,
      userCountry: user.userCountry,
      userType: user.user.type,
      profileImageUrl: profileImageUrl
    }, sharedFields);
  },
  componentWillMount: function componentWillMount() {
    var _props2 = this.props,
        user = _props2.user,
        history = _props2.history;

    if (user.onBoardingStatus === 'complete') {
      history.push('/');
      return false;
    }
  },
  onChange: function onChange(event, componentName) {
    var multiSelectInputValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var _props3 = this.props,
        dispatch = _props3.dispatch,
        onboarding = _props3.onboarding;

    if (event) {
      if (event.target.type === 'file') return undefined;
      if (onboarding[event.target.name] === event.target.value) return undefined;
      return dispatch((0, _onboardingActions.setOnboardingFields)(_defineProperty({}, event.target.name, event.target.value)));
    } else if (componentName && multiSelectInputValue.length) {
      if (onboarding[componentName] && onboarding[componentName].length === multiSelectInputValue.length) return undefined;
      return dispatch((0, _onboardingActions.setOnboardingFields)(_defineProperty({}, componentName, multiSelectInputValue)));
    }
  },


  // On form submit - verify address (fired if form is valid)
  onSubmit: function onSubmit(event) {
    var _this = this;

    var onboarding = this.props.onboarding;

    event.preventDefault();
    var addressToGeocode = ['companyAddressLineOne', 'city', 'country', 'state', 'postalCode'].reduce(function (addressToReturn, field, index) {
      var value = onboarding[field];
      if (value) return addressToReturn + ((index ? ' ' : '') + value);
      return addressToReturn;
    }, '');
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({
      'address': addressToGeocode,
      'region': 'US'
    }, function (results) {
      var _results = _slicedToArray(results, 1),
          result = _results[0];

      var formattedAddressObj = {};
      if (result) {
        formattedAddressObj.formattedAddress = result.formatted_address;
        result.address_components.forEach(function (component) {
          if (component.types.indexOf('locality') > -1) formattedAddressObj.city = component.long_name;
          if (component.types.indexOf('administrative_area_level_1') > -1) formattedAddressObj.state = component.long_name;
          if (component.types.indexOf('postal_code') > -1) formattedAddressObj.postalCode = component.long_name;
        });
        formattedAddressObj.coordinates = [result.geometry.location.lng(), result.geometry.location.lat()];
      }
      _this.setState({ formattedAddressObj: formattedAddressObj }, function () {
        return _this.confirmAddress();
      });
    });
  },


  // If there is an error submitting then ask user to refresh page
  onBoardingError: function onBoardingError() {
    this.showDialog('refreshDialog');
  },


  // Refresh page on error with DB post
  onDialogRefresh: function onDialogRefresh() {
    window.location.reload();
  },


  // Shows formatted address for confirm dialog
  getAddress: function getAddress() {
    var _this2 = this;

    var onboarding = this.props.onboarding;

    var _ref = function () {
      if (_this2.state.formattedAddressObj.formattedAddress) {
        var commaIndex = _this2.state.formattedAddressObj.formattedAddress.indexOf(',');
        var UKCheck = onboarding.country === 'United Kingdom' && onboarding.state !== _this2.state.formattedAddressObj.state ? onboarding.city + ', ' + _this2.state.formattedAddressObj.state + ' ' + onboarding.postalCode : _this2.state.formattedAddressObj.formattedAddress.substr(commaIndex + 2);
        return {
          addressOne: _this2.state.formattedAddressObj.formattedAddress.substr(0, commaIndex),
          addressTwo: onboarding.companyAddressLineTwo,
          everythingElse: UKCheck
        };
      }
      return {
        addressOne: onboarding.companyAddressLineOne,
        addressTwo: onboarding.companyAddressLineTwo,
        everythingElse: onboarding.city + ' ' + onboarding.state + ' ' + onboarding.country
      };
    }(),
        addressOne = _ref.addressOne,
        addressTwo = _ref.addressTwo,
        everythingElse = _ref.everythingElse;

    if (addressTwo) {
      return 'Is this your correct address?\n\n' + addressOne + '\n' + addressTwo + '\n' + everythingElse;
    }
    return 'Is this your correct address?\n\n' + addressOne + '\n' + everythingElse;
  },
  getTitle: function getTitle() {
    var formattedAddress = this.state.formattedAddressObj.formattedAddress;

    if (formattedAddress) return 'We were able to verify your address.';
    return 'We were unable to verify your address.';
  },
  confirmAddress: function confirmAddress() {
    this.showDialog('addressDialog');
  },


  // submit form
  _onDialogSubmit: function _onDialogSubmit() {
    var _this3 = this;

    this.dismissDialog('addressDialog');
    var formattedAddress = this.state.formattedAddressObj.formattedAddress;

    var payload = formattedAddress ? this.state.formattedAddressObj : {};
    this.setState({ sent: true }, function () {
      return _this3.completedProfile(payload);
    });
  },
  _onDialogSkip: function _onDialogSkip() {
    var _this4 = this;

    this.dismissDialog('addressDialog');
    this.setState({ sent: true }, function () {
      return _this4.completedProfile({});
    });
  },


  // else scroll back to address to fix
  _onDialogDeny: function _onDialogDeny() {
    this.dismissDialog('addressDialog');
    // increase count of times selected no by one
    this.setState({ selectedNo: this.state.selectedNo + 1 }, function () {
      // scroll to the address section
      var y = (0, _jquery2.default)('#address').offset().top - 64;
      // Necessary to wait for DOM to update classes
      setTimeout(function () {
        window.scrollTo(0, y);
      }, 500);
    });
  },
  dismissDialog: function dismissDialog(dialog) {
    this.setState(_defineProperty({}, dialog, false));
  },
  showDialog: function showDialog(dialog) {
    this.setState(_defineProperty({}, dialog, true));
  },


  // Transition to connections once onboarding is complete
  completedProfile: function completedProfile(payload) {
    var _this5 = this;

    var _props4 = this.props,
        dispatch = _props4.dispatch,
        onboarding = _props4.onboarding,
        history = _props4.history;

    dispatch((0, _onboardingActions.submitOnboarding)(_extends(payload, onboarding))).then(function () {
      _this5.dismissDialog('addressDialog');
      dispatch((0, _userActions.onBoardingComplete)());
      dispatch((0, _actions.showOnboardingDialog)());
      dispatch((0, _userActions.getUser)(true));
      dispatch((0, _profileActions.getProfile)());
      history.push('/dashboard');
    }).catch(function (err) {
      console.log(err);
      return _this5.onBoardingError();
    });
  },
  giveUrl: function giveUrl(url) {
    var dispatch = this.props.dispatch;

    dispatch((0, _onboardingActions.setOnboardingFields)({ profileImageUrl: url }));
  },
  render: function render() {
    var onboarding = this.props.onboarding;

    if (!this.state.userType) return _react2.default.createElement('div', null);
    var onBoardingStatus = this.props.user.onBoardingStatus || '';
    var multiSelectTypes = (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)('Supplier'), (0, _ramda.always)(['companyTypes', 'marketSegments']), (0, _ramda.always)(['companyTypes', 'marketSegments', 'countriesServed'])), this.state.userType);
    var getMultiSelectErrors = (0, _ramda.compose)((0, _ramda.zipObj)(multiSelectTypes), (0, _ramda.map)(doesntExist));
    // This multiselect is shared amongst all users

    var _ref2 = function () {
      if (onBoardingStatus.toLowerCase() === 'verify') {
        return {
          title: languageSettings.onboarding.verifyTitle,
          subtitle: "We're making some changes that will help you connect with other partners."
        };
      }
      return {
        title: languageSettings.onboarding.onBoardingTitle,
        subtitle: languageSettings.onboarding.onBoardingSubTitle
      };
    }(),
        title = _ref2.title,
        subtitle = _ref2.subtitle;

    var dialogActions = [_react2.default.createElement(_materialUi.FlatButton, {
      label: languageSettings.onboarding.dialogYes,
      onTouchTap: this._onDialogSubmit,
      primary: true,
      disabled: this.state.sent === true
    }), _react2.default.createElement(_materialUi.FlatButton, {
      label: languageSettings.onboarding.dialogNo,
      onTouchTap: this._onDialogDeny,
      secondary: true
    })];

    if (this.state.selectedNo) {
      dialogActions.push(_react2.default.createElement(_materialUi.FlatButton, {
        label: languageSettings.onboarding.dialogSkip,
        onTouchTap: this._onDialogSkip,
        secondary: true,
        disabled: this.state.sent === true
      }));
    }

    var refreshDialogActions = [_react2.default.createElement(_materialUi.FlatButton, {
      label: languageSettings.onboarding.dialogRefreshButton,
      onTouchTap: this.onDialogRefresh,
      secondary: true
    })];
    return _react2.default.createElement(
      'div',
      { className: 'l-app-content' },
      _react2.default.createElement(
        _form2.default,
        {
          sent: this.state.sent,
          onChange: this.onChange,
          onSubmit: this.onSubmit,
          submitName: languageSettings.onboarding.submitButton,
          onBoardingState: this.props.onboarding,
          userType: this.state.userType,
          requiredFields: true
        },
        _react2.default.createElement(_sectionHeading2.default, {
          title: title,
          subtitle: subtitle
        }),
        _react2.default.createElement(_onBoardingProfileImage2.default, {
          giveUrl: this.giveUrl,
          src: onboarding.profileImageUrl && onboarding.profileImageUrl + '?' + new Date().getTime()
        }),
        _react2.default.createElement(_aboutYourCompany2.default, _extends({
          onChange: this.onChange,
          dispatch: this.props.dispatch,
          onboarding: this.props.onboarding,
          multiSelectErrors: getMultiSelectErrors((0, _ramda.props)(multiSelectTypes, onboarding))
        }, this.state)),
        _react2.default.createElement(_contactInfo2.default, {
          onChange: this.onChange,
          phone: this.state.phone,
          prePopulateContactInformation: this.state.prePopulateContactInformation,
          prePopulateAddress: this.state.prePopulateAddress,
          dispatch: this.props.dispatch,
          onboarding: onboarding
        })
      ),
      _react2.default.createElement(
        _materialUi.Dialog,
        {
          className: 'form-dialog',
          title: languageSettings.onboarding.dialogErrorTitle,
          ref: 'refreshDialog',
          actions: refreshDialogActions,
          open: this.state.refreshDialog,
          onRequestClose: this.dismissDialog.bind(this, 'refreshDialog')
        },
        languageSettings.onboarding.dialogErrorMessage
      ),
      _react2.default.createElement(
        _materialUi.Dialog,
        {
          className: 'form-dialog',
          contentClassName: 'address-dialog-info',
          title: this.getTitle(),
          ref: 'addressDialog',
          actions: dialogActions,
          open: this.state.addressDialog,
          onRequestClose: this.dismissDialog.bind(this, 'dismissDialog')
        },
        this.getAddress()
      )
    );
  }
});

var select = function select(state) {
  return {
    onboarding: state.onboarding.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(select)(OnBoarding);

/***/ }),
/* 2825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ONBOARDING_SUBMIT = exports.ONBOARDING_SUBMIT = 'ONBOARDING_SUBMIT';
var SET_ONBOADING_FIELDS = exports.SET_ONBOADING_FIELDS = 'SET_ONBOADING_FIELDS';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';

/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = __webpack_require__(47);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var exists = (0, _ramda.complement)((0, _ramda.either)(_ramda.isNil, _ramda.isEmpty));
var flipProps = (0, _ramda.flip)(_ramda.props);

var InputForm = (0, _react.createClass)({

  propTypes: {
    onSubmit: _react.PropTypes.func,
    onChange: _react.PropTypes.func,
    className: _react.PropTypes.string,
    children: _react.PropTypes.any,
    name: _react.PropTypes.string,
    sent: _react.PropTypes.bool,
    userType: _react.PropTypes.string,
    onBoardingState: _react.PropTypes.object
  },

  getInitialState: function getInitialState() {
    return {
      disabled: false,
      emailValidationDialog: false,
      validationDialog: false
    };
  },
  onSubmit: function onSubmit(event) {
    var _this = this;

    var _props = this.props,
        userType = _props.userType,
        onBoardingState = _props.onBoardingState;

    var checkIfMultiSelectsValid = (0, _ramda.compose)((0, _ramda.all)(exists), flipProps(onBoardingState), (0, _ramda.ifElse)((0, _ramda.equals)('Supplier'), (0, _ramda.always)(['companyTypes', 'marketSegments']), (0, _ramda.always)(['companyTypes', 'marketSegments', 'countriesServed'])));
    var isValid = (0, _ramda.and)((0, _reactDom.findDOMNode)(this.refs.form).checkValidity(), checkIfMultiSelectsValid(userType));
    if (isValid) {
      this.props.onSubmit(event);
      this.setState({ sent: true });
    } else {
      event.preventDefault();
      this.setState({ disabled: true }, function () {
        if (!document.getElementById('contactEmail').checkValidity()) {
          _this.showDialog('emailValidationDialog');
        } else {
          _this.showDialog('validationDialog');
        }
      });
    }
  },
  onChange: function onChange(event) {
    if (this.props.onChange) this.props.onChange(event);
  },
  dismissDialog: function dismissDialog(dialog) {
    this.setState(_defineProperty({}, dialog, false));
  },
  showDialog: function showDialog(dialog) {
    this.setState(_defineProperty({}, dialog, true));
  },
  render: function render() {
    var dialogActions = [_react2.default.createElement(_materialUi.FlatButton, {
      label: 'OK',
      onTouchTap: this.dismissDialog.bind(this, 'validationDialog'),
      secondary: true
    })];

    var emailDialogActions = [_react2.default.createElement(_materialUi.FlatButton, {
      label: 'OK',
      onTouchTap: this.dismissDialog.bind(this, 'emailValidationDialog'),
      secondary: true
    })];

    var header = void 0;
    var submitButton = void 0;
    var classes = (0, _classnames2.default)('form-container', this.props.className, {
      'is-disabled-form': this.state.disabled
    });

    if (this.props.sent) submitButton = _react2.default.createElement(_materialUi.RaisedButton, { style: {
        margin: 'auto',
        display: 'block',
        width: '25%',
        marginBottom: '3em'
      }, className: 'loader', disableTouchRipple: true, disableFocusRipple: true, primary: true, label: '' });else submitButton = _react2.default.createElement(_materialUi.RaisedButton, { style: {
        margin: 'auto',
        display: 'block',
        width: '25%',
        marginBottom: '3em'
      }, disableTouchRipple: true, type: 'button', disableFocusRipple: true, primary: true, onClick: this.onSubmit, label: 'Submit Profile' });

    if (this.props.name) header = _react2.default.createElement(
      'h4',
      { className: 'form-header' },
      this.props.name
    );

    return _react2.default.createElement(
      'div',
      { className: classes },
      header,
      _react2.default.createElement(
        'form',
        { ref: 'form', onChange: this.onChange, onSubmit: this.onSubmit },
        this.props.children,
        submitButton
      ),
      _react2.default.createElement(
        _materialUi.Dialog,
        {
          className: 'form-dialog',
          title: 'Missing some required fields.',
          ref: 'validationDialog',
          actions: dialogActions,
          open: this.state.validationDialog,
          onRequestClose: this.dismissDialog.bind(this, 'validationDialog')
        },
        'Please complete the required fields marked in red.'
      ),
      _react2.default.createElement(
        _materialUi.Dialog,
        {
          className: 'form-dialog',
          title: 'Please input a valid email.',
          ref: 'emailValidationDialog',
          actions: emailDialogActions,
          open: this.state.emailValidationDialog,
          onRequestClose: this.dismissDialog.bind(this, 'emailValidationDialog')
        },
        'Please enter a valid email.'
      )
    );
  }
});

exports.default = InputForm;

/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(47);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _jquery = __webpack_require__(251);

var _jquery2 = _interopRequireDefault(_jquery);

var _card = __webpack_require__(873);

var _card2 = _interopRequireDefault(_card);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

var _imageCropDialog = __webpack_require__(1227);

var _imageCropDialog2 = _interopRequireDefault(_imageCropDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var languageSettings = _languages2.default['en-US'];

var OnBoardingImage = function (_Component) {
  _inherits(OnBoardingImage, _Component);

  function OnBoardingImage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OnBoardingImage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OnBoardingImage.__proto__ || Object.getPrototypeOf(OnBoardingImage)).call.apply(_ref, [this].concat(args))), _this), _this._removeImage = function () {
      _this._imageSrcChanged(null);
      _jquery2.default.get('/proxy/profileImage').fail(function (error) {
        console.log(error);
      });
    }, _this._imageSrcChanged = function (publicUrl) {
      _this._toggleLoader(false);
      _this.props.giveUrl(publicUrl);
    }, _this._loadAndResize = function () {
      // TO DO - get rid of jQuery;
      var resizeCss = function resizeCss(wrapper) {
        var margin = void 0;
        if (this.width > this.height) {
          wrapper.css({ width: '100%', height: 'auto' });
          margin = (256 - this.height) / 2;
          wrapper.css({ 'margin-top': margin, 'margin-bottom': margin });
        } else {
          wrapper.css({ width: 'auto', height: '100%' });
          margin = (256 - this.width) / 2;
          wrapper.css({ 'margin-left': margin, 'margin-right': margin });
        }
      };
      (0, _jquery2.default)('#profileImage').load(function () {
        resizeCss.call(this, (0, _jquery2.default)('#profileImage'));
      });
      (0, _jquery2.default)('#profileImageBackground').load(function () {
        resizeCss.call(this, (0, _jquery2.default)('#profileImageBackground'));
      });
    }, _this._toggleLoader = function (shouldToggle) {
      (0, _reactDom.findDOMNode)(_this.refs.profileLoader).classList.toggle('loader', shouldToggle);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OnBoardingImage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.src) this._loadAndResize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._loadAndResize();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var img = function () {
        if (_this2.props.src) return _react2.default.createElement('img', { id: 'profileImage', src: _this2.props.src });
        return _react2.default.createElement(_icon2.default, { className: 'tc-icon-office' });
      }();

      var deleteIcon = this.props.src ? _react2.default.createElement(_icon2.default, { className: 'tc-icon-delete onboarding-delete', onClick: this._removeImage }) : undefined;

      var logoStub = _react2.default.createElement(
        'div',
        { className: 'onboarding-image-background' },
        _react2.default.createElement(_icon2.default, { className: 'tc-icon-office' })
      );
      var logoReal = _react2.default.createElement('div', { id: 'profileViewImage', className: 'profileViewImage', style: {
          backgroundImage: 'url("' + this.props.src + '")' }
      });

      return _react2.default.createElement(
        _card2.default,
        {
          className: 'on-boarding-card',
          title: languageSettings.onboarding.companyLogo,
          subtitle: languageSettings.onboarding.optional
        },
        _react2.default.createElement(
          'div',
          { className: 'l-paper-split-form image' },
          _react2.default.createElement(
            'div',
            { className: 'l-paper-left' },
            _react2.default.createElement(
              'div',
              { ref: 'profileLoader', className: 'onboarding-image-container' },
              this.props.src ? logoReal : logoStub
            ),
            deleteIcon
          ),
          _react2.default.createElement(
            'div',
            { className: 'l-paper-right' },
            _react2.default.createElement(
              'p',
              null,
              languageSettings.onboarding.logoParagraph
            ),
            _react2.default.createElement(
              'div',
              { style: {
                  position: 'absolute',
                  left: '25%',
                  marginTop: '40px',
                  width: '50%'
                }
              },
              _react2.default.createElement(
                _imageCropDialog2.default,
                {
                  confirmCroppedFn: this._imageSrcChanged,
                  uploadStartFn: function uploadStartFn() {
                    if (_this2.props.src) {
                      _this2._removeImage();
                      _this2._toggleLoader.bind(_this2, true);
                    }
                    _this2._toggleLoader.bind(_this2, true);
                  },
                  cropWidth: 256,
                  cropHeight: 256,
                  imageName: 'profile',
                  dialogWidth: '400px',
                  round: true
                },
                _react2.default.createElement(
                  'div',
                  { style: {
                      backgroundColor: 'rgb(0, 188, 212)',
                      color: '#FFFFFF',
                      textAlign: 'center',
                      padding: '5px',
                      borderRadius: '3px'
                    }
                  },
                  'CHOOSE AN IMAGE'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return OnBoardingImage;
}(_react.Component);

OnBoardingImage.propTypes = {
  src: _react.PropTypes.string,
  imageSrcChanged: _react.PropTypes.func,
  giveUrl: _react.PropTypes.func
};

exports.default = OnBoardingImage;

/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(47);

var _materialUi = __webpack_require__(3);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _docCookie = __webpack_require__(142);

var _docCookie2 = _interopRequireDefault(_docCookie);

var _connectionsVertDropdown = __webpack_require__(1878);

var _connectionsVertDropdown2 = _interopRequireDefault(_connectionsVertDropdown);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var ConnectionsSearchBar = (0, _react.createClass)({

  propTypes: {
    config: _react.PropTypes.object,
    connectionsToolbar: _react.PropTypes.bool,
    search: _react.PropTypes.func,
    filteredCountries: _react.PropTypes.array,
    filterByCountry: _react.PropTypes.func,
    className: _react.PropTypes.string,
    connections: _react.PropTypes.object
  },

  getInitialState: function getInitialState() {
    return {
      open: true,
      input: ''
    };
  },
  onClick: function onClick() {
    var _this = this;

    document.getElementById('connectionsSearch').focus();
    this.setState({ open: !this.state.open }, function () {
      if (_this.state.open) document.getElementById('connectionsSearch').focus();else document.getElementById('connectionsSearch').blur();
    });
  },
  downloadAllContacts: function downloadAllContacts() {
    _docCookie2.default.setItem('userid', this.props.user.id, undefined, '/', 'tourconnect.com');
    window.location = this.props.config.apiUrl + '/download_all_contacts';
  },
  preventTabAndEnter: function preventTabAndEnter(event) {
    if (event.which === 13 || event.which === 9) {
      event.preventDefault();
    }
  },
  searchContent: function searchContent(value) {
    this.props.search(value);
    this.setState({ input: value });
  },
  clearInput: function clearInput() {
    this.props.search('');
    this.setState({ input: '' });
  },
  countryChanged: function countryChanged(selections) {
    var _props = this.props,
        filteredCountries = _props.filteredCountries,
        filterByCountry = _props.filterByCountry;

    filterByCountry(filteredCountries.concat(selections.map(function (selection) {
      return selection.value;
    })));
  },
  render: function render() {
    var _this2 = this;

    var _props2 = this.props,
        connections = _props2.connections,
        filteredCountries = _props2.filteredCountries;

    var classes = (0, _classnames2.default)('connections-search-input', this.props.className, {
      'is-closed': !this.state.open
    });

    var icon = this.state.open && this.state.input ? _react2.default.createElement(_icon2.default, { className: 'tc-icon-close', onClick: this.clearInput }) : _react2.default.createElement(_icon2.default, { className: 'tc-icon-search', onClick: this.onClick });

    var countriesServed = connections.countries.filter(function (country) {
      return filteredCountries.indexOf(country) === -1;
    }).map(function (country) {
      return { value: country, label: country };
    });

    var filterOptions = void 0;
    var downloadIcon = void 0;
    var filters = void 0;
    var searchbar = void 0;

    if (countriesServed) {
      filterOptions = [{
        type: 'nestedmenu',
        isOnNestedMultiselect: true,
        subOptions: [{
          text: _react2.default.createElement(_reactSelect2.default, {
            multi: true,
            name: "countriesServed",
            onChange: this.countryChanged,
            layout: "l-paper-right multi-select",
            scrollMenuIntoView: false,
            options: countriesServed
          }),
          leaveMenuOpen: true
        }],
        text: 'Filter By Country',
        icon: _react2.default.createElement(_icon2.default, { className: 'tc-icon-chevron-right' })
      }];
    }

    if (this.props.connectionsToolbar) {
      downloadIcon = _react2.default.createElement(_materialUi.IconButton, {
        style: { top: '-4px' },
        iconClassName: 'tc-icon-cloud-download',
        onTouchTap: this.downloadAllContacts,
        tooltip: 'Download Connections'
      });
      filters = _react2.default.createElement(_connectionsVertDropdown2.default, {
        isMultiSelect: true,
        componentClassName: 'connections-more-options connections-actions',
        label: 'Filters',
        options: filterOptions
      });
    } else {
      searchbar = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _materialUi.Paper,
          null,
          _react2.default.createElement(_materialUi.TextField, {
            hintText: 'Search Connections...',
            id: 'connectionsSearch',
            className: classes,
            onKeyDown: this.preventTabAndEnter,
            onChange: function onChange(_ref) {
              var value = _ref.target.value;
              return _this2.searchContent(value);
            },
            style: { width: '97%' },
            value: this.state.input
          })
        ),
        icon
      );
    }

    return _react2.default.createElement(
      'div',
      { className: 'connections-search-bar ' + this.props.className },
      searchbar,
      filters
    );
  }
}); // Dependencies
exports.default = ConnectionsSearchBar;

/* jshint ignore:end */

/***/ }),
/* 2829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactDom = __webpack_require__(47);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _isDataUrl = __webpack_require__(2830);

var _warning = __webpack_require__(89);

var _warning2 = _interopRequireDefault(_warning);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var numberableType = function numberableType(props, propName, componentName) {
  (0, _warning2.default)(!isNaN(parseInt(props[propName])), 'Invalid ' + propName + ' \'' + props.size + '\' sent to \'' + componentName + '\'. Requires an\n    int or string capable of conversion to an int.\n    Check the render method of == \'' + componentName + '\'. == ');
};

var Cropper = function (_React$Component) {
  _inherits(Cropper, _React$Component);

  function Cropper(props) {
    _classCallCheck(this, Cropper);

    // getInitialState
    var _this = _possibleConstructorReturn(this, (Cropper.__proto__ || Object.getPrototypeOf(Cropper)).call(this, props));

    _this.prepareCanvas = function () {
      // set the right canvas size to fill the modal content box
      var canvasContainerDOM = _reactDom2.default.findDOMNode(_this.refs.canvasContainer);
      if (canvasContainerDOM) {
        var modalContentWidth = canvasContainerDOM.getBoundingClientRect().width;
        var defaultCanvasWidth = _this.props.round ? _this.props.height : _this.props.width;
        var defaultCanvasHeight = _this.props.height;
        // update only if the canvas size is smaller than the modal content size
        if (modalContentWidth < defaultCanvasWidth) {
          var imageRatio = 1 / defaultCanvasWidth * modalContentWidth;
          var canvasWidth = modalContentWidth;
          var canvasHeight = defaultCanvasHeight * imageRatio;
          _this.setState({ canvasWidth: canvasWidth, canvasHeight: canvasHeight, imageRatio: imageRatio });
        } else {
          _this.setState({ imageRatio: 1 });
        }
      }
    };

    _this.prepareImage = function (imageUri) {
      var img = new Image();
      if (!(0, _isDataUrl.isDataURL)(imageUri)) img.crossOrigin = 'anonymous';
      img.onload = function () {
        var scaledImage = _this.fitImageToCanvas(img.width, img.height);
        scaledImage.resource = img;
        scaledImage.x = 0;
        scaledImage.y = 0;
        /*      const yCompensation = (((scaledImage.height * this.state.imageRatio) - this.state.canvasHeight) * -1);
              console.log(yCompensation, scaledImage.height, this.state.canvasHeight);*/
        _this.setState({ dragging: false, image: scaledImage, preview: _this.toDataURL() });
      };
      img.src = imageUri;
    };

    _this.mouseDownListener = function (e) {
      _this.setState({
        image: _this.state.image,
        dragging: true,
        mouse: {
          x: null,
          y: null
        }
      });
    };

    _this.preventSelection = function (e) {
      if (_this.state.dragging) {
        e.preventDefault();
        return false;
      }
    };

    _this.mouseUpListener = function () {
      _this.setState({ dragging: false, preview: _this.toDataURL() });
    };

    _this.mouseMoveListener = function (e) {
      if (!_this.state.dragging) return;
      var mouseX = e.clientX;
      var mouseY = e.clientY;
      var imageX = _this.state.image.x;
      var imageY = _this.state.image.y;
      var newImage = _this.state.image;
      if (_this.state.mouse.x && _this.state.mouse.y) {
        var dx = _this.state.mouse.x - mouseX;
        var dy = _this.state.mouse.y - mouseY;
        var bounded = _this.boundedCoords(imageX, imageY, dx, dy);
        newImage.x = bounded.x;
        newImage.y = bounded.y;
      }
      _this.setState({
        image: _this.state.image,
        mouse: {
          x: mouseX,
          y: mouseY
        }
      });
    };

    _this.boundedCoords = function (x, y, dx, dy) {
      // calculate the image size
      var _this$state = _this.state,
          canvasWidth = _this$state.canvasWidth,
          canvasHeight = _this$state.canvasHeight,
          zoom = _this$state.zoom;

      var scaledWidth = _this.state.image.width * zoom;
      var scaledHeight = _this.state.image.height * zoom;
      var yCompensation = (_this.state.image.height - canvasHeight) / 2 * -1;
      var xCompensation = (_this.state.image.width - canvasWidth) / 2 * -1;

      var newX = x - dx;
      var newY = y - dy;

      var rangeX = scaledWidth - canvasWidth;
      var rangeY = scaledHeight - canvasHeight;

      var lowX = rangeX / 2 * -1 + xCompensation;
      var highX = rangeX / 2;
      if (newX < lowX) {
        newX = lowX;
      } else if (newX > highX) {
        newX = highX;
      }

      var lowY = rangeY / 2 * -1 + yCompensation;
      var highY = rangeY + lowY;
      if (newY < lowY) {
        newY = lowY;
      } else if (newY > highY) {
        newY = highY;
      }

      // console.log({ canvasWidth, canvasHeight, scaledWidth, scaledHeight });
      // console.log({ yCompensation });
      // console.log({ x, y, zoom, newX, newY });
      // console.log({ lowX, highX });
      // console.log({ rangeX, rangeY, lowY, highY });

      return {
        x: newX,
        y: newY
      };
    };

    _this.fitImageToCanvas = function (width, height) {
      var scaledHeight = void 0;
      var scaledWidth = void 0;
      var _this$state2 = _this.state,
          canvasWidth = _this$state2.canvasWidth,
          canvasHeight = _this$state2.canvasHeight;

      if (Math.round(canvasWidth * (height / width)) >= canvasHeight) {
        // scroll on H
        scaledWidth = canvasWidth;
        scaledHeight = Math.round(scaledWidth * (height / width));
      } else {
        // scroll on W
        scaledHeight = canvasHeight;
        scaledWidth = Math.round(scaledHeight * (width / height));
      }

      return { width: scaledWidth, height: scaledHeight };
    };

    _this.addImageToCanvas = function (context, image) {
      if (!image.resource) return;
      context.save();
      context.globalCompositeOperation = 'destination-over';
      var _this$state3 = _this.state,
          zoom = _this$state3.zoom,
          canvasWidth = _this$state3.canvasWidth,
          canvasHeight = _this$state3.canvasHeight;

      var scaledWidth = _this.state.image.width * zoom;
      var scaledHeight = _this.state.image.height * zoom;
      var x = image.x - (scaledWidth - _this.state.image.width) / 2;
      var y = image.y - (scaledHeight - _this.state.image.height) / 2;
      // need to make sure we aren't going out of bounds here...
      x = Math.min(x, 0);
      y = Math.min(y, 0);
      x = Math.max(x, canvasWidth - scaledWidth);
      y = Math.max(y, canvasHeight - scaledHeight);
      context.drawImage(image.resource, x, y, image.width * zoom, image.height * zoom);
      context.restore();
    };

    _this.toDataURL = function () {
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = _this.state.canvasWidth;
      canvas.height = _this.state.canvasHeight;
      _this.addImageToCanvas(context, {
        resource: _this.state.image.resource,
        x: _this.state.image.x,
        y: _this.state.image.y,
        height: _this.state.image.height,
        width: _this.state.image.width
      });
      return canvas.toDataURL();
    };

    _this.handleCrop = function () {
      var data = _this.toDataURL();
      _this.props.onCrop(data);
    };

    _this.handleZoomUpdate = function (_, val) {
      //    console.log({ zoom: val });
      _this.setState({ zoom: val });
    };

    _this.state = {
      showHelper: true,
      dragging: false,
      image: {},
      mouse: {
        x: null,
        y: null
      },
      preview: null,
      canvasWidth: props.round ? props.height : props.width,
      canvasHeight: props.height,
      zoom: 1
    };
    _this.listeners = [];
    return _this;
  }

  _createClass(Cropper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var canvas = _reactDom2.default.findDOMNode(this.refs.canvas);
      this.prepareCanvas();
      this.prepareImage(this.props.image);
      this.listeners = {
        mousemove: function mousemove(e) {
          return _this2.mouseMoveListener(e);
        },
        mouseup: function mouseup(e) {
          return _this2.mouseUpListener(e);
        },
        mousedown: function mousedown(e) {
          return _this2.mouseDownListener(e);
        }
      };
      canvas.addEventListener('mousemove', this.listeners.mousemove);
      canvas.addEventListener('mouseup', this.listeners.mouseup, false);
      canvas.addEventListener('mousedown', this.listeners.mousedown, false);
      canvas.addEventListener('mouseout', this.listeners.mouseup, false);
      document.onselectstart = function (e) {
        return _this2.preventSelection(e);
      };
      setTimeout(function () {
        _this2.setState({ showHelper: false });
      }, 3e3);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var context = _reactDom2.default.findDOMNode(this.refs.canvas).getContext('2d');
      context.clearRect(0, 0, this.props.width, this.props.height);
      this.addImageToCanvas(context, this.state.image);
    }
    // make sure we clean up listeners when unmounted.

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var canvas = _reactDom2.default.findDOMNode(this.refs.canvas);
      canvas.removeEventListener('mousemove', this.listeners.mousemove);
      canvas.removeEventListener('mouseup', this.listeners.mouseup);
      canvas.removeEventListener('mousedown', this.listeners.mousedown);
      canvas.removeEventListener('mouseout', this.listeners.mouseup);
    }
  }, {
    key: 'render',
    value: function render() {
      var canvasStyle = {
        border: '2px dashed #efefef',
        cursor: 'move',
        backgroundColor: '#1b2936'
      };
      if (this.props.round) {
        // make it round
        canvasStyle['-moz-border-radius'] = this.props.height + 'px';
        canvasStyle['-webkit-border-radius'] = this.props.height + 'px';
      }
      var helperStyle = {
        display: this.state.showHelper ? 'block' : 'none',
        position: 'absolute',
        width: '224px',
        height: '34px',
        left: '50%',
        top: '50%',
        border: '1px solid white',
        backgroundColor: 'rgba(0,0,0,0.5)',
        color: 'white',
        marginLeft: '-113px',
        marginTop: '-108px',
        padding: '5px',
        userSelect: 'none'
      };
      return _react2.default.createElement(
        'div',
        { style: { textAlign: 'center' }, ref: 'canvasContainer' },
        _react2.default.createElement(
          'div',
          { style: helperStyle },
          _react2.default.createElement(_icon2.default, { className: 'tc-icon-cursor-default-outline', style: { fontSize: '17px' } }),
          ' Drag to Reposition Image'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('canvas', {
            style: canvasStyle,
            ref: 'canvas',
            width: this.state.canvasWidth,
            height: this.state.canvasHeight
          })
        ),
        _react2.default.createElement(_materialUi.Slider, {
          ref: 'zoom',
          name: 'zoom',
          onChange: this.handleZoomUpdate,
          min: 1,
          max: 3,
          step: 0.01,
          value: this.state.zoom,
          defaultValue: 1
        }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_materialUi.RaisedButton, {
            onTouchTap: this.props.onRequestHide,
            label: this.props.cancelButtonLabel
          }),
          _react2.default.createElement(_materialUi.RaisedButton, {
            secondary: true,
            style: { marginLeft: '6px' },
            onTouchTap: this.handleCrop.bind(this),
            label: this.props.cropButtonLabel
          })
        )
      );
    }
  }]);

  return Cropper;
}(_react2.default.Component);

Cropper.propTypes = {
  image: _react2.default.PropTypes.string.isRequired,
  onCrop: _react2.default.PropTypes.func.isRequired,
  cancelButtonLabel: _react2.default.PropTypes.string,
  cropButtonLabel: _react2.default.PropTypes.string,
  width: numberableType,
  height: numberableType,
  onRequestHide: _react2.default.PropTypes.func.isRequired,
  round: _react2.default.PropTypes.bool.isRequired
};
Cropper.defaultProps = {
  width: 400,
  height: 400,
  cancelButtonLabel: 'Cancel',
  cropButtonLabel: 'Crop and Save',
  round: false
};

exports.default = Cropper;

/***/ }),
/* 2830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDataURL = isDataURL;
function isDataURL(s) {
  return !!s.match(isDataURL.regex);
}
isDataURL.regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;

/***/ }),
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _input = __webpack_require__(1879);

var _input2 = _interopRequireDefault(_input);

var _card = __webpack_require__(873);

var _card2 = _interopRequireDefault(_card);

var _onboardingActions = __webpack_require__(1482);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

var _selectFields = __webpack_require__(141);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var languageSettings = _languages2.default['en-US'];

var ContactInfo = function (_Component) {
  _inherits(ContactInfo, _Component);

  function ContactInfo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContactInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContactInfo.__proto__ || Object.getPrototypeOf(ContactInfo)).call.apply(_ref, [this].concat(args))), _this), _this.setCountry = function (_ref2) {
      var country = _ref2.value;
      var dispatch = _this.props.dispatch;

      return dispatch((0, _onboardingActions.setOnboardingFields)({ country: country }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContactInfo, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _card2.default,
        {
          className: 'on-boarding-card',
          title: languageSettings.onboarding.contactInfo,
          subtitle: languageSettings.onboarding.required
        },
        _react2.default.createElement(
          'div',
          { className: 'l-paper-split-form' },
          _react2.default.createElement(
            'div',
            { className: 'field' },
            _react2.default.createElement(
              'div',
              { className: 'l-paper-left' },
              _react2.default.createElement('label', { className: 'form-label' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'l-paper-right' },
              _react2.default.createElement(
                'p',
                null,
                languageSettings.onboarding.contactInfoParagraph
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'l-paper-split-form' },
          _react2.default.createElement(
            'div',
            { className: 'field' },
            _react2.default.createElement(
              'div',
              { className: 'l-paper-left' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'contactFirstName', className: 'form-label' },
                languageSettings.onboarding.contact
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'l-paper-right' },
              _react2.default.createElement(
                'div',
                { className: 'form-line' },
                _react2.default.createElement(
                  'div',
                  { className: 'form-line-two' },
                  _react2.default.createElement(_input2.default, { name: 'contactFirstName', id: 'contactFirstName', defaultValue: this.props.prePopulateContactInformation ? this.props.prePopulateContactInformation.contactFirstName : this.props.user.firstName, placeholder: languageSettings.onboarding.firstName, type: "text", required: 'true' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'form-line-two' },
                  _react2.default.createElement(_input2.default, { name: 'contactLastName', defaultValue: this.props.prePopulateContactInformation ? this.props.prePopulateContactInformation.contactLastName : this.props.user.lastName, placeholder: languageSettings.onboarding.lastName, type: "text", required: 'true' })
                )
              ),
              _react2.default.createElement(_input2.default, { name: 'contactEmail', id: 'contactEmail', defaultValue: this.props.prePopulateContactInformation ? this.props.prePopulateContactInformation.contactEmail : '', placeholder: languageSettings.onboarding.email, type: "email", required: 'true' }),
              _react2.default.createElement(_input2.default, { name: 'contactPhone', defaultValue: this.props.prePopulateContactInformation ? this.props.prePopulateContactInformation.contactPhone : '', placeholder: languageSettings.onboarding.phone, type: "text", required: 'true' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'l-paper-left' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'companyAddressLineOne', className: 'form-label' },
                languageSettings.onboarding.address
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'l-paper-right', id: 'address' },
              _react2.default.createElement(_input2.default, { name: 'companyAddressLineOne', id: 'companyAddressLineOne', defaultValue: this.props.prePopulateAddress.address_1, placeholder: languageSettings.onboarding.addressOnePlaceholder, type: "text", required: 'true' }),
              _react2.default.createElement(_input2.default, { name: 'companyAddressLineTwo', defaultValue: this.props.prePopulateAddress.address_2, placeholder: languageSettings.onboarding.addressTwoPlaceholder, type: "text" }),
              _react2.default.createElement(_input2.default, { name: 'city', defaultValue: this.props.prePopulateAddress ? this.props.prePopulateAddress.city : '', placeholder: languageSettings.onboarding.city, type: "text", required: 'true' }),
              _react2.default.createElement(
                'div',
                { className: 'form-line' },
                _react2.default.createElement(
                  'div',
                  { className: 'form-line-two' },
                  _react2.default.createElement(_input2.default, { name: 'state', defaultValue: this.props.prePopulateAddress ? this.props.prePopulateAddress.state : '', placeholder: languageSettings.onboarding.statePlaceholder, type: "text", required: 'true' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'form-line-two' },
                  _react2.default.createElement(_input2.default, { name: 'postalCode', defaultValue: this.props.prePopulateAddress ? this.props.prePopulateAddress.postal_code : '', placeholder: languageSettings.onboarding.zipPlaceholder, type: "text", required: 'true' })
                )
              ),
              _react2.default.createElement(_reactSelect2.default, {
                value: this.props.onboarding.country,
                onChange: this.setCountry,
                clearable: false,
                options: _selectFields.countries
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'l-paper-left' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'corporatePhone', className: 'form-label' },
                languageSettings.onboarding.corporatePhone
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'l-paper-right' },
              _react2.default.createElement(_input2.default, { name: 'corporatePhone',
                id: 'corporatePhone',
                defaultValue: this.props.phone,
                type: "text",
                required: 'true'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'l-paper-split-form' },
              _react2.default.createElement(
                'div',
                { className: 'field' },
                _react2.default.createElement(
                  'div',
                  { className: 'l-paper-left' },
                  _react2.default.createElement('label', { className: 'form-label' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'l-paper-right' },
                  _react2.default.createElement(
                    'p',
                    { className: 'multi-select-paragraph' },
                    _react2.default.createElement(
                      'em',
                      null,
                      languageSettings.onboarding.phoneInfoParagraph
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ContactInfo;
}(_react.Component);

ContactInfo.propTypes = {
  prePopulateAddress: _react.PropTypes.object,
  phone: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  prePopulateContactInformation: _react.PropTypes.object,
  user: _react.PropTypes.object,
  onboarding: _react.PropTypes.object,
  dispatch: _react.PropTypes.func
};

exports.default = ContactInfo;

/***/ }),
/* 2832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _textarea = __webpack_require__(1050);

var _textarea2 = _interopRequireDefault(_textarea);

var _input = __webpack_require__(1879);

var _input2 = _interopRequireDefault(_input);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _card = __webpack_require__(873);

var _card2 = _interopRequireDefault(_card);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

var _onboardingActions = __webpack_require__(1482);

var _selectFields = __webpack_require__(141);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var languageSettings = _languages2.default['en-US'];

var ContactInfo = function (_Component) {
  _inherits(ContactInfo, _Component);

  function ContactInfo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContactInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContactInfo.__proto__ || Object.getPrototypeOf(ContactInfo)).call.apply(_ref, [this].concat(args))), _this), _this.changeMultiSelectValue = (0, _ramda.curry)(function (name, optsArray) {
      _this.props.dispatch((0, _onboardingActions.setOnboardingFields)(_defineProperty({}, name, optsArray ? optsArray.map(function (_ref2) {
        var value = _ref2.value;
        return value;
      }) : [])));
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContactInfo, [{
    key: 'render',
    value: function render() {
      var multiSelects = void 0;
      var errorStyle = {
        background: '#fff0f0',
        borderColor: '#dbb1b1',
        color: '#d95c5c',
        borderRadius: '0 .2857rem .2857rem 0'
      };
      if (this.props.userType === 'Contractor') {
        multiSelects = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'l-paper-split-form' },
            _react2.default.createElement(
              'div',
              { className: 'field' },
              _react2.default.createElement(
                'div',
                { className: 'l-paper-left' },
                _react2.default.createElement(
                  'label',
                  { htmlFor: '', className: 'form-label' },
                  languageSettings.onboarding.companyTypes
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'l-paper-right' },
                _react2.default.createElement(_reactSelect2.default, {
                  name: "companyTypes",
                  onChange: this.changeMultiSelectValue('companyTypes'),
                  options: _selectFields.contractorCompanyTypes,
                  value: this.props.onboarding.companyTypes,
                  style: this.props.multiSelectErrors.companyTypes ? errorStyle : {},
                  multi: true
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'l-paper-split-form' },
            _react2.default.createElement(
              'div',
              { className: 'field' },
              _react2.default.createElement(
                'div',
                { className: 'l-paper-left' },
                _react2.default.createElement(
                  'label',
                  { htmlFor: '', className: 'form-label' },
                  languageSettings.onboarding.countriesServed
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'l-paper-right' },
                _react2.default.createElement(_reactSelect2.default, {
                  name: "countriesServed",
                  onChange: this.changeMultiSelectValue('countriesServed'),
                  options: _selectFields.countries,
                  value: this.props.onboarding.countriesServed,
                  style: this.props.multiSelectErrors.countriesServed ? errorStyle : {},
                  multi: true
                }),
                _react2.default.createElement(
                  'p',
                  { className: 'multi-select-paragraph' },
                  _react2.default.createElement(
                    'em',
                    null,
                    languageSettings.onboarding.destinationsSoldDesc
                  )
                )
              )
            )
          )
        );
      } else if (this.props.userType === 'Supplier') {
        if (this.props.productType === 'Non-Accommodation') {
          multiSelects = _react2.default.createElement(
            'div',
            { className: 'l-paper-split-form' },
            _react2.default.createElement(
              'div',
              { className: 'field' },
              _react2.default.createElement(
                'div',
                { className: 'l-paper-left' },
                _react2.default.createElement(
                  'label',
                  { htmlFor: '', className: 'form-label' },
                  languageSettings.onboarding.companyTypes
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'l-paper-right' },
                _react2.default.createElement(_reactSelect2.default, {
                  name: 'companyTypes',
                  onChange: this.changeMultiSelectValue('companyTypes'),
                  options: _selectFields.nonAccomCompanyTypes,
                  value: this.props.onboarding.companyTypes,
                  style: this.props.multiSelectErrors.companyTypes ? errorStyle : {},
                  multi: true
                })
              )
            )
          );
        } else if (this.props.productType === 'Accommodation') {
          // Property Types
          multiSelects = _react2.default.createElement(
            'div',
            { className: 'l-paper-split-form' },
            _react2.default.createElement(
              'div',
              { className: 'field' },
              _react2.default.createElement(
                'div',
                { className: 'l-paper-left' },
                _react2.default.createElement(
                  'label',
                  { htmlFor: '', className: 'form-label' },
                  languageSettings.onboarding.propertyTypes
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'l-paper-right' },
                _react2.default.createElement(_reactSelect2.default, {
                  name: "companyTypes",
                  onChange: this.changeMultiSelectValue('companyTypes'),
                  options: _selectFields.accomCompanyTypes,
                  value: this.props.onboarding.companyTypes,
                  style: this.props.multiSelectErrors.companyTypes ? errorStyle : {},
                  multi: true
                })
              )
            )
          );
        }
      }
      return _react2.default.createElement(
        _card2.default,
        {
          className: 'on-boarding-card',
          title: languageSettings.onboarding.aboutYourCompany,
          subtitle: languageSettings.onboarding.required
        },
        _react2.default.createElement(
          'div',
          { className: 'l-paper-split-form' },
          _react2.default.createElement(
            'div',
            { className: 'field' },
            _react2.default.createElement(
              'div',
              { className: 'l-paper-left' },
              _react2.default.createElement('label', { className: 'form-label' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'l-paper-right' },
              _react2.default.createElement(
                'p',
                null,
                languageSettings.onboarding.textAreaParagraph
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'l-paper-split-form' },
          _react2.default.createElement(
            'div',
            { className: 'field' },
            _react2.default.createElement(
              'div',
              { className: 'l-paper-left' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'websiteUrl', className: 'form-label' },
                languageSettings.onboarding.website
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'l-paper-right' },
              _react2.default.createElement(_input2.default, { name: 'websiteUrl', id: 'websiteUrl', defaultValue: this.props.websiteUrl, type: "text" })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'l-paper-split-form textarea' },
          _react2.default.createElement(
            'div',
            { className: 'field' },
            _react2.default.createElement(
              'div',
              { className: 'l-paper-left' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'description', className: 'form-label short-description' },
                languageSettings.onboarding.shortDescription
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'l-paper-right' },
              _react2.default.createElement(_textarea2.default, { id: 'description', name: 'description', defaultValue: this.props.description, required: true }),
              _react2.default.createElement(
                'p',
                { className: 'multi-select-paragraph onboarding-short-description-reminder' },
                _react2.default.createElement(
                  'em',
                  null,
                  languageSettings.onboarding.shortDescriptionReminder
                )
              )
            )
          )
        ),
        multiSelects,
        _react2.default.createElement(
          'div',
          { className: 'l-paper-split-form' },
          _react2.default.createElement(
            'div',
            { className: 'field' },
            _react2.default.createElement(
              'div',
              { className: 'l-paper-left' },
              _react2.default.createElement(
                'label',
                { className: 'form-label' },
                languageSettings.onboarding.marketSegments
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'l-paper-right' },
              _react2.default.createElement(_reactSelect2.default, {
                name: "marketSegments",
                onChange: this.changeMultiSelectValue('marketSegments'),
                options: _selectFields.marketSegments,
                value: this.props.onboarding.marketSegments,
                multi: true,
                style: this.props.multiSelectErrors.marketSegments ? errorStyle : {}
              }),
              _react2.default.createElement(
                'p',
                { className: 'multi-select-paragraph' },
                _react2.default.createElement(
                  'em',
                  null,
                  languageSettings.onboarding.marketSegmentsDesc
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ContactInfo;
}(_react.Component);

ContactInfo.propTypes = {
  onChange: _react.PropTypes.func,
  description: _react.PropTypes.string,
  websiteUrl: _react.PropTypes.string,
  companyTypes: _react.PropTypes.array,
  userType: _react.PropTypes.string,
  productType: _react.PropTypes.string,
  countriesServed: _react.PropTypes.array,
  onboarding: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  multiSelectErrors: _react.PropTypes.object
};

exports.default = ContactInfo;

/***/ }),
/* 2833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _tempConnectionsActions = __webpack_require__(1880);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TempConnectionContainer = function (_Component) {
  _inherits(TempConnectionContainer, _Component);

  function TempConnectionContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TempConnectionContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TempConnectionContainer.__proto__ || Object.getPrototypeOf(TempConnectionContainer)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      var dispatch = _this.props.dispatch;

      return dispatch((0, _tempConnectionsActions.getTempConnections)());
    }, _this.changeCollectionItemValue = function (mapKey, valueKey, value) {
      var dispatch = _this.props.dispatch;

      return dispatch((0, _tempConnectionsActions.changeCollectionItemValue)(mapKey, valueKey, value));
    }, _this.isPersistedFromServer = function () {
      var dispatch = _this.props.dispatch;

      return dispatch((0, _tempConnectionsActions.isPersistedFromServer)());
    }, _this.sendEmailToTempConnections = function (emailValue) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _tempConnectionsActions.sendEmailToTempConnectionsStarting)());
      return dispatch((0, _tempConnectionsActions.sendEmailToTempConnections)(emailValue));
    }, _this.changeEmailValue = function (value) {
      var dispatch = _this.props.dispatch;

      return dispatch((0, _tempConnectionsActions.changeEmailValue)(value));
    }, _this.sendTempConnections = function (connections) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _tempConnectionsActions.sendEmailToTempConnectionsStarting)());
      return dispatch((0, _tempConnectionsActions.sendTempConnections)(connections));
    }, _this.addAnotherConnection = function () {
      var dispatch = _this.props.dispatch;

      return dispatch((0, _tempConnectionsActions.addAnotherConnection)());
    }, _this.removeInvitation = function (mapKey) {
      var dispatch = _this.props.dispatch;

      return dispatch((0, _tempConnectionsActions.removeInvitation)(mapKey));
    }, _this.cancelCSVHeaderSelection = function () {
      var dispatch = _this.props.dispatch;

      return dispatch((0, _tempConnectionsActions.cancelCSVHeaderSelection)());
    }, _this.acceptCurrentCSVSelection = function () {
      var dispatch = _this.props.dispatch;

      return dispatch((0, _tempConnectionsActions.acceptCurrentCSVSelection)());
    }, _this.convertFromCSV = function (fileContents) {
      var dispatch = _this.props.dispatch;

      return dispatch((0, _tempConnectionsActions.convertFromCSV)(fileContents));
    }, _this.deleteTempConnections = function () {
      var dispatch = _this.props.dispatch;

      return dispatch((0, _tempConnectionsActions.deleteTempConnections)());
    }, _this.cancelCurrentCSVSelection = function () {
      var dispatch = _this.props.dispatch;

      return dispatch((0, _tempConnectionsActions.cancelCurrentCSVSelection)());
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TempConnectionContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      var extraProps = _extends({
        changeCollectionItemValue: this.changeCollectionItemValue,
        sendTempConnections: this.sendTempConnections,
        addAnotherConnection: this.addAnotherConnection,
        removeInvitation: this.removeInvitation,
        cancelCSVHeaderSelection: this.cancelCSVHeaderSelection,
        acceptCurrentCSVSelection: this.acceptCurrentCSVSelection,
        cancelCurrentCSVSelection: this.cancelCurrentCSVSelection,
        isPersistedFromServer: this.isPersistedFromServer,
        sendEmailToTempConnections: this.sendEmailToTempConnections,
        changeEmailValue: this.changeEmailValue,
        deleteTempConnections: this.deleteTempConnections,
        convertFromCSV: this.convertFromCSV
      }, props);
      return _react2.default.createElement(
        'div',
        { className: 'l-app-content new-connection-container' },
        children ? (0, _react.cloneElement)(children, extraProps) : undefined
      );
    }
  }]);

  return TempConnectionContainer;
}(_react.Component);

TempConnectionContainer.propTypes = {
  dispatch: _react.PropTypes.func,
  children: _react.PropTypes.any
};

var select = function select(state) {
  return {
    tempConnections: state.tempConnections
  };
};

exports.default = (0, _reactRedux.connect)(select)(TempConnectionContainer);

/***/ }),
/* 2834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _sendEmailCard = __webpack_require__(2835);

var _sendEmailCard2 = _interopRequireDefault(_sendEmailCard);

var _materialUi = __webpack_require__(3);

var _sectionHeading = __webpack_require__(732);

var _sectionHeading2 = _interopRequireDefault(_sectionHeading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TempConnectionsSend = function (_Component) {
  _inherits(TempConnectionsSend, _Component);

  function TempConnectionsSend(props) {
    _classCallCheck(this, TempConnectionsSend);

    var _this = _possibleConstructorReturn(this, (TempConnectionsSend.__proto__ || Object.getPrototypeOf(TempConnectionsSend)).call(this, props));

    _this.getEmailErrorDialog = function () {
      var actions = [_react2.default.createElement(_materialUi.FlatButton, {
        label: 'Ok',
        onTouchTap: _this.dismissDialog,
        secondary: true
      })];
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          className: 'form-dialog',
          title: 'There Was An Error Sending Your Email',
          ref: 'emailErrorDialog',
          actions: actions,
          onRequestClose: _this.dismissDialog,
          open: _this.state.emailErrorDialog
        },
        'There was an error sending your email. Please resend your email. If the error persists, please reach out for technical assistance or start over'
      );
    };

    _this.dismissDialog = function () {
      _this.setState({ emailErrorDialog: false });
    };

    _this.sendEmail = function () {
      var _this$props = _this.props,
          history = _this$props.history,
          tempConnections = _this$props.tempConnections,
          sendEmailToTempConnections = _this$props.sendEmailToTempConnections;

      sendEmailToTempConnections(tempConnections.get('emailValue')).then(function (res) {
        if (res.payload.report) history.push('/connections/add-connections/results');
      }).catch(function () {
        _this.setState({ 'emailErrorDialog': true });
      });
    };

    _this.goBack = function () {
      var _this$props2 = _this.props,
          isPersistedFromServer = _this$props2.isPersistedFromServer,
          history = _this$props2.history;

      isPersistedFromServer();
      history.push('/connections/add-connections');
    };

    _this.state = {
      emailErrorDialog: false
    };
    return _this;
  }

  _createClass(TempConnectionsSend, [{
    key: 'render',
    value: function render() {
      var errorDialog = this.getEmailErrorDialog();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_sectionHeading2.default, {
          title: 'Personalize Your Invitations',
          subtitle: 'Enter an optional message or just click send to send your invitations now!',
          style: { marginTop: '64px' }
        }),
        _react2.default.createElement(_sendEmailCard2.default, this.props),
        _react2.default.createElement(
          'div',
          { style: { margin: '24px auto auto auto', width: '512px' } },
          _react2.default.createElement(_materialUi.RaisedButton, {
            label: 'Back',
            type: 'button',
            secondary: true,
            onClick: this.goBack
          }),
          _react2.default.createElement(_materialUi.RaisedButton, {
            style: { float: 'right' },
            label: 'Send',
            type: 'button',
            disabled: !this.props.tempConnections.get('emailValidLength') || this.props.tempConnections.get('sendingEmails'),
            primary: this.props.tempConnections.get('emailValidLength'),
            onClick: this.sendEmail
          })
        ),
        errorDialog
      );
    }
  }]);

  return TempConnectionsSend;
}(_react.Component);

TempConnectionsSend.propTypes = {
  changeEmailValue: _react.PropTypes.func,
  tempConnections: _react.PropTypes.object,
  sendEmailToTempConnections: _react.PropTypes.func,
  history: _react.PropTypes.object,
  isPersistedFromServer: _react.PropTypes.func
};

exports.default = TempConnectionsSend;

/***/ }),
/* 2835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _newCard = __webpack_require__(1483);

var _newCard2 = _interopRequireDefault(_newCard);

var _materialUi = __webpack_require__(3);

var _reactDom = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SendEmailCard = function (_Component) {
  _inherits(SendEmailCard, _Component);

  function SendEmailCard(props) {
    _classCallCheck(this, SendEmailCard);

    var _this = _possibleConstructorReturn(this, (SendEmailCard.__proto__ || Object.getPrototypeOf(SendEmailCard)).call(this, props));

    _this.setMoreText = function () {
      _this.setState({ moreText: true });
    };

    _this._getEmails = function (connections) {
      var emailString = '';
      var objectCount = 0;
      var maxHeight = '196px';
      var height = 'auto';
      var overflow = 'scroll';
      var more = void 0;
      var size = connections.size;
      var style = {
        lineHeight: '32px',
        width: '100%'
      };

      connections.forEach(function (connection) {
        objectCount++;
        emailString += connection.get('email');
        if (objectCount !== size) emailString += ', ';
      });

      if (_this.state.moreText) {
        more = _react2.default.createElement(
          'div',
          {
            className: 'send-email-more',
            style: {
              lineHeight: '48px',
              clear: 'both',
              cursor: 'pointer',
              overflow: 'auto',
              position: 'absolute',
              float: 'right',
              right: '0',
              bottom: '-8px'
            },
            onClick: function onClick() {
              return _this.setState({ 'moreText': false });
            }
          },
          '+ More'
        );
        maxHeight = '100px';
        height = '100px';
        overflow = 'hidden';
        style.width = '95%';
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'tc-card-header-title tc-new-card-header-title',
          style: { overflowY: overflow, maxWidth: '100%', maxHeight: maxHeight, height: height, position: 'relative' }
        },
        _react2.default.createElement(
          'div',
          { style: style, ref: 'emails' },
          _react2.default.createElement(
            'div',
            { style: { fontWeight: '600', fontSize: '14px', color: 'rgb(54%, 54%, 54%)', display: 'inline' } },
            'TO: '
          ),
          _react2.default.createElement(
            'div',
            { style: { fontSize: '14px', color: 'rgb(54%, 54%, 54%)', display: 'inline' } },
            emailString
          )
        ),
        more
      );
    };

    _this.state = {
      moreText: false
    };
    return _this;
  }

  _createClass(SendEmailCard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var connectionsObj = this.props.tempConnections.get('connections').toJS();
      var connections = Object.values(connectionsObj);
      this.props.changeEmailValue('Hi' + (connections && connections.length === 1 && connections[0].firstName ? ' ' + connections[0].firstName + ',' : ',') + '\n\nPlease connect with me on TourConnect, a private network built specifically for travel trade. It can help our existing partnership by allowing us to stay better connected with each other. We can easily share information & updates, contacts, marketing materials, and even automate rates and contracts. I look forward to connecting on TourConnect.');

      var emailHeight = this.refs.emails ? (0, _reactDom.findDOMNode)(this.refs.emails).offsetHeight : 0;
      if (emailHeight > 100) this.setMoreText();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.props.tempConnections.get('allInvitationsProcessed')) return false;
      var connections = this.props.tempConnections.get('connections');
      var emails = this._getEmails(connections);
      return _react2.default.createElement(
        _newCard2.default,
        { className: 'send-email-card' },
        emails,
        _react2.default.createElement(_materialUi.TextField, {
          fullWidth: true,
          multiLine: true,
          rows: 5,
          onChange: function onChange(event) {
            return _this2.props.changeEmailValue(event.target.value);
          },
          hintText: 'Enter an optional message...',
          value: this.props.tempConnections.get('emailValue')
        })
      );
    }
  }]);

  return SendEmailCard;
}(_react.Component);

SendEmailCard.propTypes = {
  tempConnections: _react.PropTypes.object,
  changeEmailValue: _react.PropTypes.func
};

exports.default = SendEmailCard;

/***/ }),
/* 2836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _sectionHeading = __webpack_require__(732);

var _sectionHeading2 = _interopRequireDefault(_sectionHeading);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TempConnectionsResults = function (_Component) {
  _inherits(TempConnectionsResults, _Component);

  function TempConnectionsResults() {
    _classCallCheck(this, TempConnectionsResults);

    return _possibleConstructorReturn(this, (TempConnectionsResults.__proto__ || Object.getPrototypeOf(TempConnectionsResults)).apply(this, arguments));
  }

  _createClass(TempConnectionsResults, [{
    key: 'render',
    value: function render() {
      var statuses = [];
      var _props = this.props,
          history = _props.history,
          tempConnections = _props.tempConnections;


      if (tempConnections.get('emailStatuses') && tempConnections.get('emailStatuses').size) {
        tempConnections.get('emailStatuses').forEach(function (statusCount, statusType) {
          if (statusCount) {
            if (statusType === 'sent') statuses.push('we sent ' + statusCount + ' ' + (statusCount === 1 ? 'invitation' : 'invitations'));
            if (statusType === 'resent') statuses.push('we resent ' + statusCount + ' invitations');
            if (statusType === 'nowConnected') statuses.push('you are now connected with ' + statusCount + ' partners');
            if (statusType === 'alreadyConnected') statuses.push('you were already connected with ' + statusCount + ' partners we sent invitations to');
            if (statusType === 'error') statuses.push('we could not send ' + statusCount + ' invitations');
            if (statusType === 'sentTooSoon') statuses.push(statusCount + ' of your invitations were already resent within the last week');
            if (statusType === 'receiverIsSelf') {
              if (statusCount === 1) {
                statuses.push(statusCount + ' of your invitations was addressed to a user associated with this account');
              } else if (statusCount > 1) {
                statuses.push(statusCount + ' of your invitations were addressed to a user associated with this account');
              }
            }
          }
        });
      }

      var statusString = '';
      statuses.forEach(function (string, index) {
        if (index === 0) {
          statusString += string.substr(0, 1).toUpperCase() + string.substr(1);
        } else {
          statusString += string;
        }
        if (index < statuses.length - 1) statusString += ', ';else statusString += '.';
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_icon2.default, { style: {
            height: '200px',
            width: '200px',
            fontSize: '200px',
            margin: '64px auto',
            display: 'block',
            color: '#00bcd4'
          }, className: 'tc-icon-paperplane'
        }),
        _react2.default.createElement(_sectionHeading2.default, {
          title: 'Invitations Sent',
          subtitle: 'Congratulations! Your invitations have been sent. Please see the results below.',
          style: { marginTop: '64px' }
        }),
        _react2.default.createElement(
          'div',
          { style: { marginBottom: '24px', textAlign: 'center' } },
          statusString
        ),
        _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          _react2.default.createElement(_materialUi.RaisedButton, {
            label: 'View Connections',
            type: 'button',
            secondary: true,
            disableTouchRipple: true,
            disableFocusRipple: true,
            style: { display: 'inline-block', minWidth: '22%', marginRight: '15px' },
            onClick: function onClick() {
              return history.push('/connections/invitations');
            }
          }),
          _react2.default.createElement(_materialUi.RaisedButton, {
            label: 'Add More Connections',
            type: 'button',
            primary: true,
            disableTouchRipple: true,
            disableFocusRipple: true,
            style: { display: 'inline-block', minWidth: '22%', marginLeft: '15px' },
            onClick: function onClick() {
              return history.push('/connections/add-connections');
            }
          })
        )
      );
    }
  }]);

  return TempConnectionsResults;
}(_react.Component);

TempConnectionsResults.propTypes = {
  history: _react.PropTypes.object,
  tempConnections: _react.PropTypes.object
};

exports.default = TempConnectionsResults;

/***/ }),
/* 2837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _newCard = __webpack_require__(1483);

var _newCard2 = _interopRequireDefault(_newCard);

var _materialUi = __webpack_require__(3);

var _json2csv = __webpack_require__(2838);

var _json2csv2 = _interopRequireDefault(_json2csv);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _sectionHeading = __webpack_require__(732);

var _sectionHeading2 = _interopRequireDefault(_sectionHeading);

var _tcContactImport = __webpack_require__(1456);

var _tcContactImport2 = _interopRequireDefault(_tcContactImport);

var _csvUploadModal = __webpack_require__(2845);

var _csvUploadModal2 = _interopRequireDefault(_csvUploadModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TempConnectionsAdd = function (_Component) {
  _inherits(TempConnectionsAdd, _Component);

  function TempConnectionsAdd() {
    _classCallCheck(this, TempConnectionsAdd);

    var _this = _possibleConstructorReturn(this, (TempConnectionsAdd.__proto__ || Object.getPrototypeOf(TempConnectionsAdd)).call(this));

    _this.onRequestClose = function (modal) {
      _this.setState(_defineProperty({}, modal, false));
    };

    _this.getProcessedModal = function () {
      var invalidRows = void 0;
      if (_this.props.tempConnections.get('invalidRecords') && _this.props.tempConnections.get('invalidRecords').size) {
        invalidRows = _this._rowMapper(_this.props.tempConnections.get('invalidRecords'), true);
        var actions = [_react2.default.createElement(_materialUi.FlatButton, {
          label: 'Reupload',
          type: 'button',
          secondary: true,
          disableTouchRipple: true,
          disableFocusRipple: true,
          onClick: _this.cancelCurrentCSVSelection
        })];

        if (_this.props.tempConnections.get('connections').size) {
          actions.push(_react2.default.createElement(_materialUi.FlatButton, {
            label: 'Add Good Records',
            type: 'button',
            disableTouchRipple: true,
            disableFocusRipple: true,
            primary: true,
            onClick: _this.acceptCurrentCSVSelection
          }));
        }

        return _react2.default.createElement(
          _materialUi.Dialog,
          {
            className: 'form-dialog',
            title: 'We Found Some Errors In Your File',
            actions: actions,
            open: _this.props.tempConnections.get('processed'),
            ref: 'processedModal',
            onRequestClose: function onRequestClose() {
              return _this.onRequestClose('processedModal');
            }
          },
          _react2.default.createElement(
            'div',
            { style: { marginBottom: '16px', borderBottom: '2px solid #efefef' } },
            'We have listed the errors below. You can either add just the good records or try again and reupload the file.'
          ),
          _react2.default.createElement(
            'div',
            { style: { maxHeight: '300px', overflow: 'auto' } },
            _react2.default.createElement(
              'div',
              { style: { borderBottom: '2px solid #efefef', width: '100%', lineHeight: '48px' } },
              _react2.default.createElement(
                'div',
                { style: { display: 'inline-block', fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '120px', 'marginRight': '16px' } },
                'Line Number'
              ),
              _react2.default.createElement(
                'div',
                { style: { display: 'inline-block', fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '220px', 'marginRight': '16px' } },
                'Error'
              )
            ),
            invalidRows.toArray()
          )
        );
      }
    };

    _this.getDynamicForm = function () {
      var form = _this.getFormTemplateAndData();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _newCard2.default,
          { addConnections: true },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              {
                style: { height: '48px', float: 'right', cursor: 'pointer' },
                className: 'tc-card-header-title tc-new-card-header-title'
              },
              _react2.default.createElement(_icon2.default, {
                style: { 'fontSize': '16px', 'lineHeight': '48px' },
                className: 'tc-icon-insert-drive-file tc-icon-with-label',
                onClick: _this.showUploadModal,
                label: 'UPLOAD'
              })
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'tc-table-sub-header'
            },
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', fontSize: '12px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '20%', 'marginRight': '16px' } },
              'Company Name'
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', fontSize: '12px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '20%', 'marginRight': '16px' } },
              'Email'
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', fontSize: '12px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '20%', 'marginRight': '16px' } },
              'First Name'
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', fontSize: '12px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '20%', 'marginRight': '16px' } },
              'Last Name'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { maxHeight: '300px', overflowX: 'auto' } },
            form.toArray()
          )
        )
      );
    };

    _this.getFormTemplateAndData = function () {
      var objectCount = 0;
      var size = _this.props.tempConnections.get('connections') ? _this.props.tempConnections.get('connections').size : 0;
      var icon = void 0;
      var closeIcon = void 0;
      return _this.props.tempConnections.get('connections').map(function (connection, key) {
        objectCount++;
        if (_this.isValidInvitation(connection, objectCount, size)) {
          icon = _react2.default.createElement(
            'div',
            {
              style: {
                lineHeight: '48px',
                display: 'inline-block',
                width: '24px',
                marginLeft: '5px'
              }
            },
            _react2.default.createElement(_icon2.default, {
              className: 'tc-icon-add',
              style: {
                lineHeight: '18px',
                verticalAlign: 'middle',
                border: '2px solid green',
                borderRadius: '50%',
                fontSize: '18px'
              },
              onClick: _this._newConnection
            })
          );
        }

        if (size > 1) {
          closeIcon = _react2.default.createElement(_icon2.default, { className: 'tc-icon-delete2', onClick: function onClick() {
              return _this._removeInvitation(key);
            } });
        }

        return _react2.default.createElement(
          'div',
          { key: key, className: 'individual-invitation' },
          _react2.default.createElement(_materialUi.TextField, {
            style: { fontSize: '12px', width: '20%', marginRight: '16px', verticalAlign: 'top' },
            value: connection.get('companyName'),
            hintText: 'Optional',
            onChange: _this._changeCollectionItemValue.bind(null, key, 'companyName')
          }),
          _react2.default.createElement(_materialUi.TextField, {
            style: { fontSize: '12px', width: '20%', marginRight: '16px', verticalAlign: 'top' },
            value: connection.get('email'),
            hintText: 'Required',
            errorText: connection.get('hasFocusedEmail') && function () {
              return _this.getErrorText(connection, 'email');
            }(),
            onChange: _this._changeCollectionItemValue.bind(null, key, 'email')
          }),
          _react2.default.createElement(_materialUi.TextField, {
            style: { fontSize: '12px', width: '20%', marginRight: '16px', verticalAlign: 'top' },
            value: connection.get('firstName'),
            hintText: 'Optional',
            onChange: _this._changeCollectionItemValue.bind(null, key, 'firstName')
          }),
          _react2.default.createElement(_materialUi.TextField, {
            style: { fontSize: '12px', width: '20%', marginRight: '16px', verticalAlign: 'top' },
            value: connection.get('lastName'),
            hintText: 'Optional',
            onChange: _this._changeCollectionItemValue.bind(null, key, 'lastName')
          }),
          closeIcon,
          icon
        );
      });
    };

    _this.getErrorText = function (invitation, type) {
      if (type === 'email') {
        if (!invitation.get('email')) return 'Email is required';else if (!_this.isValidEmail(invitation.get('email'))) return 'Must input a valid email';
      }
    };

    _this.showUploadModal = function () {
      _this.setState({ uploadModal: true });
    };

    _this._changeCollectionItemValue = function (mapKey, valueKey, event) {
      var value = event.target.value;
      _this.props.changeCollectionItemValue(mapKey, valueKey, value);
    };

    _this.sendConnections = function (connections) {
      var _this$props = _this.props,
          history = _this$props.history,
          sendTempConnections = _this$props.sendTempConnections;

      sendTempConnections(connections).then(function (res) {
        if (res.payload.allProcessed) history.push('/connections/add-connections/send');
      });
    };

    _this._newConnection = function () {
      _this.props.addAnotherConnection();
    };

    _this._removeInvitation = function (mapKey) {
      _this.props.removeInvitation(mapKey);
    };

    _this._cancelCSVHeaderSelect = function () {
      if (_this.props.tempConnections.get('persistedFromServer')) _this.props.deleteTempConnections();
      _this.props.cancelCSVHeaderSelection();
    };

    _this.isValidInvitation = function (connection, objectCount, size) {
      return Boolean(objectCount === size && connection.get('email') && _this.isValidEmail(connection.get('email')));
    };

    _this.acceptCurrentCSVSelection = function () {
      _this.props.acceptCurrentCSVSelection();
      _this.setState({ processedModal: false });
    };

    _this.cancelCurrentCSVSelection = function () {
      _this.props.cancelCurrentCSVSelection();
      _this.setState({ processedModal: false });
    };

    _this.afterSubmitContacts = function (contacts) {
      _this.props.convertFromCSV((0, _json2csv2.default)({ data: contacts.map(function (contact) {
          return { email: contact.__selectedMail__, firstName: contact.first_name, lastName: contact.last_name };
        }), fields: ['companyName', 'email', 'firstName', 'lastName'], hasCSVColumnTitle: false }));
    };

    _this.state = {
      processedModal: false,
      uploadModal: false
    };
    return _this;
  }

  _createClass(TempConnectionsAdd, [{
    key: '_rowMapper',
    value: function _rowMapper(rows, errors) {
      return rows.map(function (row) {
        var error = [];
        if (errors) {
          if (row.getIn([4, 'missingEmail'])) error.push('Missing Email');
          if (row.getIn([4, 'missingCompanyName'])) error.push('Missing Company Name');
          if (row.getIn([4, 'invalidEmail'])) {
            error.push('Invalid Email');
          }
          error = error.join(', ');
          return _react2.default.createElement(
            'div',
            { style: { borderBottom: '2px solid #efefef', width: '100%', lineHeight: '48px' } },
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', width: '120px', color: 'rgb(54%, 54%, 54%)' }, className: 'modalErrorLine' },
              row.getIn([4, 'line'])
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', width: '512px', marginLeft: '16px', color: 'rgb(54%, 54%, 54%)' }, className: 'modalError' },
              error
            )
          );
        }
        var rowToDisplay = row.toArray().map(function (item, index) {
          var classes = 'csvItem';
          if (index === 0 || index === 1) classes += ' longItem';
          return _react2.default.createElement(
            'div',
            { className: classes },
            ' ',
            item,
            ' '
          );
        });
        return _react2.default.createElement(
          'div',
          { className: 'csvRow' },
          ' ',
          rowToDisplay,
          ' '
        );
      });
    }
  }, {
    key: 'isValidEmail',
    value: function isValidEmail(email) {
      var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
      return String(email).search(filter) !== -1;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var content = this.getDynamicForm();
      var processedErrorModal = this.getProcessedModal();
      var button = this.props.tempConnections.get('processing') ? _react2.default.createElement(_materialUi.RaisedButton, {
        style: { float: 'right' },
        type: 'button',
        className: 'temp-connection-next-button loader',
        disableTouchRipple: true,
        disableFocusRipple: true,
        disabled: true,
        primary: false,
        label: ''
      }) : _react2.default.createElement(_materialUi.RaisedButton, {
        style: { float: 'right' },
        label: 'Next',
        type: 'button',
        disableTouchRipple: true,
        disableFocusRipple: true,
        disabled: !this.props.tempConnections.get('allRecordsValid') || this.props.tempConnections.get('processing'),
        primary: this.props.tempConnections.get('allRecordsValid') && !this.props.tempConnections.get('processing'),
        onClick: function onClick() {
          return _this2.sendConnections(_this2.props.tempConnections.get('connections').toArray().map(function (item) {
            var itemToObj = item.toObject();
            if (!itemToObj.firstName) itemToObj.firstName = '';
            if (!itemToObj.lastName) itemToObj.lastName = '';
            return itemToObj;
          }));
        }
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_sectionHeading2.default, {
          title: 'Add Connections',
          subtitle: 'Invite your existing partners by entering their contact information below or upload a file. Email is required.',
          style: { marginTop: '64px' }
        }),
        processedErrorModal,
        _react2.default.createElement(
          'div',
          { style: { width: 'calc(100% * (2/3))', display: 'inline-block', verticalAlign: 'top' } },
          content,
          _react2.default.createElement(
            'div',
            { style: { marginTop: '24px' } },
            _react2.default.createElement(_materialUi.RaisedButton, {
              label: 'Reset',
              type: 'button',
              secondary: true,
              disableTouchRipple: true,
              disableFocusRipple: true,
              onClick: this._cancelCSVHeaderSelect
            }),
            button
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { width: 'calc(100% * (1/3))', display: 'inline-block', verticalAlign: 'top', paddingLeft: '50px' } },
          _react2.default.createElement(_sectionHeading2.default, {
            title: 'Other ways to invite',
            subtitle: 'Invite your existing contacts'
          }),
          _react2.default.createElement(_tcContactImport2.default, { afterSubmitContacts: this.afterSubmitContacts })
        ),
        _react2.default.createElement(_csvUploadModal2.default, {
          open: this.state.uploadModal,
          onRequestClose: this.onRequestClose,
          reset: this._cancelCSVHeaderSelect
        }),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null)
      );
    }
  }]);

  return TempConnectionsAdd;
}(_react.Component);

TempConnectionsAdd.propTypes = {
  cancelCurrentCSVSelection: _react.PropTypes.func,
  acceptCurrentCSVSelection: _react.PropTypes.func,
  convertFromCSV: _react.PropTypes.func,
  changeCollectionItemValue: _react.PropTypes.func,
  sendTempConnections: _react.PropTypes.func,
  history: _react.PropTypes.object,
  addAnotherConnection: _react.PropTypes.func,
  removeInvitation: _react.PropTypes.func,
  deleteTempConnections: _react.PropTypes.func,
  cancelCSVHeaderSelection: _react.PropTypes.func,
  tempConnections: _react.PropTypes.object
};

exports.default = TempConnectionsAdd;

/***/ }),
/* 2838 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Module dependencies.
 */
var os = __webpack_require__(2839);
var lodashGet = __webpack_require__(1873);
var lodashFlatten = __webpack_require__(1876);
var lodashUniq = __webpack_require__(2840);
var lodashSet = __webpack_require__(2841);
var lodashCloneDeep = __webpack_require__(2842);
var flatten = __webpack_require__(2843);

/**
 * @name Json2CsvParams
 * @typedef {Object}
 * @property {Array} data - array of JSON objects
 * @property {Array} [fields] - see documentation for details
 * @property {String[]} [fieldNames] - names for fields at the same indexes. Must be same length as fields array
 *                                   (Optional. Maintained for backwards compatibility. Use fields config object for more features)
 * @property {String} [del=","] - delimiter of columns
 * @property {String} [defaultValue="<empty>"] - default value to use when missing data
 * @property {String} [quotes='"'] - quotes around cell values and column names
 * @property {String} [doubleQuotes='""'] - the value to replace double quotes in strings
 * @property {Boolean} [hasCSVColumnTitle=true] - determines whether or not CSV file will contain a title column
 * @property {String} [eol=''] - it gets added to each row of data
 * @property {String} [newLine] - overrides the default OS line ending (\n on Unix \r\n on Windows)
 * @property {Boolean} [flatten=false] - flattens nested JSON using flat (https://www.npmjs.com/package/flat)
 * @property {String[]} [unwindPath] - similar to MongoDB's $unwind, Deconstructs an array field from the input JSON to output a row for each element
 * @property {Boolean} [excelStrings] - converts string data into normalized Excel style data
 * @property {Boolean} [includeEmptyRows=false] - includes empty rows
 */

/**
 * Main function that converts json to csv.
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields,
 * delimiter (default is ','), hasCSVColumnTitle (default is true)
 * and default value (default is '')
 * @param {Function} [callback] Callback function
 *   if error, returning error in call back.
 *   if csv is created successfully, returning csv output to callback.
 */
module.exports = function (params, callback) {
  var hasCallback = typeof callback === 'function';
  var err;

  try {
    checkParams(params);
  } catch (err) {
    if (hasCallback) {
      return process.nextTick(function () {
        callback(err);
      });
    } else {
      throw err;
    }
  }

  var titles = createColumnTitles(params);
  var csv = createColumnContent(params, titles);

  if (hasCallback) {
    return process.nextTick(function () {
      callback(null, csv);
    });
  } else {
    return csv;
  }
};


/**
 * Check passing params.
 *
 * Note that this modifies params.
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields,
 * delimiter, default value, mark quotes and hasCSVColumnTitle
 */
function checkParams(params) {
  params.data = params.data || [];

  // if data is an Object, not in array [{}], then just create 1 item array.
  // So from now all data in array of object format.
  if (!Array.isArray(params.data)) {
    params.data = [params.data];
  }

  if (params.flatten) {
    params.data = params.data.map(flatten);
  }

  // Set params.fields default to first data element's keys
  if (!params.fields && (params.data.length === 0 || typeof params.data[0] !== 'object')) {
    throw new Error('params should include "fields" and/or non-empty "data" array of objects');
  }

  if (!params.fields) {
    var dataFields = params.data.map(function (item) {
      return Object.keys(item);
    });

    dataFields = lodashFlatten(dataFields);
    params.fields = lodashUniq(dataFields);
  }


  //#check fieldNames
  if (params.fieldNames && params.fieldNames.length !== params.fields.length) {
    throw new Error('fieldNames and fields should be of the same length, if fieldNames is provided.');
  }

  // Get fieldNames from fields
  params.fieldNames = params.fields.map(function (field, i) {
    if (params.fieldNames && typeof field === 'string') {
      return params.fieldNames[i];
    }
    return (typeof field === 'string') ? field : (field.label || field.value);
  });

  //#check delimiter
  params.del = params.del || ',';

  //#check end of line character
  params.eol = params.eol || '';

  //#check quotation mark
  params.quotes = typeof params.quotes === 'string' ? params.quotes : '"';

  //#check double quotes
  params.doubleQuotes = typeof params.doubleQuotes === 'string' ? params.doubleQuotes : Array(3).join(params.quotes);

  //#check default value
  params.defaultValue = params.defaultValue;

  //#check hasCSVColumnTitle, if it is not explicitly set to false then true.
  params.hasCSVColumnTitle = params.hasCSVColumnTitle !== false;

  //#check include empty rows, defaults to false
  params.includeEmptyRows = params.includeEmptyRows || false;

  //#check unwindPath, defaults to empty array
  params.unwindPath = params.unwindPath || [];

  // if unwindPath is not in array [{}], then just create 1 item array.
  if (!Array.isArray(params.unwindPath)) {
    params.unwindPath = [params.unwindPath];
  }
}

/**
 * Create the title row with all the provided fields as column headings
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields and delimiter
 * @returns {String} titles as a string
 */
function createColumnTitles(params) {
  var str = '';

  //if CSV has column title, then create it
  if (params.hasCSVColumnTitle) {
    params.fieldNames.forEach(function (element) {
      if (str !== '') {
        str += params.del;
      }
      str += JSON.stringify(element).replace(/\"/g, params.quotes);
    });
  }

  return str;
}

/**
 * Replace the quotation marks of the field element if needed (can be a not string-like item)
 *
 * @param {string} stringifiedElement The field element after JSON.stringify()
 * @param {string} quotes The params.quotes value. At this point we know that is not equal to double (")
 */
function replaceQuotationMarks(stringifiedElement, quotes) {
  var lastCharIndex = stringifiedElement.length - 1;

  //check if it's an string-like element
  if (stringifiedElement[0] === '"' && stringifiedElement[lastCharIndex] === '"') {
    //split the stringified field element because Strings are immutable
    var splitElement = stringifiedElement.split('');

    //replace the quotation marks
    splitElement[0] = quotes;
    splitElement[lastCharIndex] = quotes;

    //join again
    stringifiedElement = splitElement.join('');
  }

  return stringifiedElement;
}

/**
 * Create the content column by column and row by row below the title
 *
 * @param {Object} params Function parameters containing data, fields and delimiter
 * @param {String} str Title row as a string
 * @returns {String} csv string
 */
function createColumnContent(params, str) {
  createDataRows(params.data, params.unwindPath).forEach(function (dataElement) {
    //if null do nothing, if empty object without includeEmptyRows do nothing
    if (dataElement && (Object.getOwnPropertyNames(dataElement).length > 0 || params.includeEmptyRows)) {
      var line = '';
      var eol = params.newLine || os.EOL || '\n';

      params.fields.forEach(function (fieldElement) {
        var val;
        var defaultValue = params.defaultValue;
        if (typeof fieldElement === 'object' && 'default' in fieldElement) {
          defaultValue = fieldElement.default;
        }

        if (fieldElement && (typeof fieldElement === 'string' || typeof fieldElement.value === 'string')) {
          var path = (typeof fieldElement === 'string') ? fieldElement : fieldElement.value;
          val = lodashGet(dataElement, path, defaultValue);
        } else if (fieldElement && typeof fieldElement.value === 'function') {
          var field = {
            label: fieldElement.label,
            default: fieldElement.default
          };
          val = fieldElement.value(dataElement, field, params.data);
        }

        if (val === null || val === undefined){
          val = defaultValue;
        }

        if (val !== undefined) {
          if (params.preserveNewLinesInValues && typeof val === 'string') {
            val = val
              .replace(/\n/g, '\u2028')
              .replace(/\r/g, '\u2029');
          }

          var stringifiedElement = JSON.stringify(val);

          if (params.preserveNewLinesInValues && typeof val === 'string') {
            stringifiedElement = stringifiedElement
              .replace(/\u2028/g, '\n')
              .replace(/\u2029/g, '\r');
          }

          if (typeof val === 'object') stringifiedElement = JSON.stringify(stringifiedElement);

          if (params.quotes !== '"') {
            stringifiedElement = replaceQuotationMarks(stringifiedElement, params.quotes);
          }

          //JSON.stringify('\\') results in a string with two backslash
          //characters in it. I.e. '\\\\'.
          stringifiedElement = stringifiedElement.replace(/\\\\/g, '\\');

          if (params.excelStrings && typeof val === 'string') {
            stringifiedElement = '"="' + stringifiedElement + '""';
          }

          line += stringifiedElement;
        }

        line += params.del;
      });

      //remove last delimeter by its length
      line = line.substring(0, line.length - params.del.length);
      //Replace single quotes with double quotes. Single quotes are preceeded by
      //a backslash. Be careful not to remove backslash content from the string.
      line = line.split('\\\\').map(function (portion) {
        return portion.replace(/\\"/g, params.doubleQuotes);
      }).join('\\\\');
      //Remove the final excess backslashes from the stringified value.
      line = line.replace(/\\\\/g, '\\');
      //If header exists, add it, otherwise, print only content
      if (str !== '') {
        str += eol + line + params.eol;
      } else {
        str = line + params.eol;
      }
    }
  });

  return str;
}

/**
 * Performs the unwind recursively in specified sequence
 * 
 * @param {Array} originalData The params.data value. Original array of JSON objects
 * @param {String[]} unwindPaths The params.unwindPath value. Unwind strings to be used to deconstruct array
 * @returns {Array} Array of objects containing all rows after unwind of chosen paths
 */
function createDataRows(originalData, unwindPaths) {
  var dataRows = [];
  if (unwindPaths.length) {
    originalData.forEach(function(dataElement) {
      var dataRow = [dataElement];

      unwindPaths.forEach(function(unwindPath) {
        dataRow = unwindRows(dataRow, unwindPath);
      });

      Array.prototype.push.apply(dataRows, dataRow);
    });
  } else {
    dataRows = originalData;
  }

  return dataRows;
}

/**
 * Performs the unwind logic if necessary to convert single JSON document into multiple rows
 * 
 * @param {Array} inputRows Array contaning single or multiple rows to unwind
 * @param {String} unwindPath Single path to do unwind
 * @returns {Array} Array of rows processed
 */
function unwindRows(inputRows, unwindPath) {
  var outputRows = [];
  inputRows.forEach(function(dataEl) {
    var unwindArray = lodashGet(dataEl, unwindPath);
    var isArr = Array.isArray(unwindArray);

    if (isArr && unwindArray.length) {
      unwindArray.forEach(function(unwindEl) {
        var dataCopy = lodashCloneDeep(dataEl);
        lodashSet(dataCopy, unwindPath, unwindEl);
        outputRows.push(dataCopy);
      });
    } else if (isArr && !unwindArray.length) {
      var dataCopy = lodashCloneDeep(dataEl);
      lodashSet(dataCopy, unwindPath, undefined);
      outputRows.push(dataCopy);
    } else {
      outputRows.push(dataEl);
    }
  });
  return outputRows;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 2839 */
/***/ (function(module, exports) {

exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';

exports.homedir = function () {
	return '/'
};


/***/ }),
/* 2840 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    Set = getNative(root, 'Set'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each
 * element is kept.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length)
    ? baseUniq(array)
    : [];
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = uniq;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 2841 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 2842 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(236)(module)))

/***/ }),
/* 2843 */
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__(2844)

var flat = module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten(target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step(object, prev, currentDepth) {
    currentDepth = currentDepth ? currentDepth : 1
    Object.keys(object).forEach(function(key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === "[object Object]" ||
        type === "[object Array]"
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten(target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey(key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1
    ) ? key
      : parsedKey
  }

  Object.keys(target).forEach(function(key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === "[object Object]" ||
        type === "[object Array]"
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),
/* 2844 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 2845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _csvUploadContainer = __webpack_require__(1458);

var _csvUploadContainer2 = _interopRequireDefault(_csvUploadContainer);

var _tempConnectionsActions = __webpack_require__(1880);

var _addConnectionsExCsv = __webpack_require__(2846);

var _addConnectionsExCsv2 = _interopRequireDefault(_addConnectionsExCsv);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CSVUploadModal = function (_Component) {
  _inherits(CSVUploadModal, _Component);

  function CSVUploadModal() {
    _classCallCheck(this, CSVUploadModal);

    return _possibleConstructorReturn(this, (CSVUploadModal.__proto__ || Object.getPrototypeOf(CSVUploadModal)).apply(this, arguments));
  }

  _createClass(CSVUploadModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          updateProp = _props.updateProp,
          reset = _props.reset;


      return _react2.default.createElement(_csvUploadContainer2.default, {
        open: this.props.open,
        onRequestClose: function onRequestClose() {
          return _this2.props.onRequestClose('uploadModal');
        },
        additFixErrorsFunc: function additFixErrorsFunc() {
          return reset();
        },
        showFailedSection: true,
        onCompleteFunc: function onCompleteFunc(successfulRows) {
          updateProp({
            processed: true,
            allRecordsValid: true,
            allInvitationsProcessed: true,
            connections: successfulRows.map(function (record) {
              return _ramda2.default.merge(record, { recordValid: true });
            })
          });
          _this2.props.onRequestClose('uploadModal');
        },
        dialogTitle: 'Upload An Excel or CSV File',
        note: _react2.default.createElement(
          'div',
          null,
          'The CSV or Excel file must have the following layout: ',
          _react2.default.createElement(
            'b',
            null,
            'Company Name (optional), Email (required), First Name (optional), Last Name (optional)'
          ),
          '. Example format:',
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('img', { src: _addConnectionsExCsv2.default, width: 500 })
        ),
        dropzoneText: 'Drag and drop your CSV or Excel file here or click inside to choose a file from your computer',
        headers: [{
          headerTitle: 'companyName',
          required: false
        }, {
          headerTitle: 'email',
          required: true
        }, {
          headerTitle: 'firstName',
          required: false
        }, {
          headerTitle: 'lastName',
          required: false
        }]
      });
    }
  }]);

  return CSVUploadModal;
}(_react.Component);

CSVUploadModal.propTypes = {
  open: _react.PropTypes.bool,
  onRequestClose: _react.PropTypes.func,
  updateProp: _react.PropTypes.func,
  reset: _react.PropTypes.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_tempConnectionsActions.updateTempConnectionsProps.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(CSVUploadModal);

/***/ }),
/* 2846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a61e5a243d3ae960973b4a2c90abb806.png";

/***/ }),
/* 2847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _searchBarCard = __webpack_require__(1126);

var _searchBarCard2 = _interopRequireDefault(_searchBarCard);

var _integrationLeftNav = __webpack_require__(2848);

var _integrationLeftNav2 = _interopRequireDefault(_integrationLeftNav);

var _integrationTourplanAuth = __webpack_require__(2849);

var _integrationTourplanAuth2 = _interopRequireDefault(_integrationTourplanAuth);

var _integrationTourplanLogin = __webpack_require__(1228);

var _integrationTourplanLogin2 = _interopRequireDefault(_integrationTourplanLogin);

var _integrationContracts = __webpack_require__(2850);

var _integrationContracts2 = _interopRequireDefault(_integrationContracts);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

var _rateNameTextSettings = __webpack_require__(2851);

var _rateNameTextSettings2 = _interopRequireDefault(_rateNameTextSettings);

var _extrasSettings = __webpack_require__(2943);

var _extrasSettings2 = _interopRequireDefault(_extrasSettings);

var _cancelHourSettings = __webpack_require__(2945);

var _cancelHourSettings2 = _interopRequireDefault(_cancelHourSettings);

var _taxSettings = __webpack_require__(2946);

var _taxSettings2 = _interopRequireDefault(_taxSettings);

var _priceCodes = __webpack_require__(2947);

var _priceCodes2 = _interopRequireDefault(_priceCodes);

var _notesSettings = __webpack_require__(2948);

var _notesSettings2 = _interopRequireDefault(_notesSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Components


var languageSettings = _languages2.default['en-US'];

var Integration = function (_Component) {
  _inherits(Integration, _Component);

  function Integration(props) {
    _classCallCheck(this, Integration);

    var _this = _possibleConstructorReturn(this, (Integration.__proto__ || Object.getPrototypeOf(Integration)).call(this, props));

    _this.populateState(props);
    return _this;
  }

  _createClass(Integration, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.populateState(nextProps);
    }
  }, {
    key: 'setAuthenticated',
    value: function setAuthenticated() {
      this.setState({ authenticated: true });
    }
  }, {
    key: 'populateState',
    value: function populateState(props) {
      var integration = props.integration;
      this.state = {
        get authenticated() {
          if (integration.auth) {
            if (integration.auth.user_name) return true;
            return false;
          }
        }
      };
    }
  }, {
    key: 'sendRouteName',
    value: function sendRouteName(routeName) {
      var _this2 = this;

      this.setState({
        routeName: routeName
      }, function () {
        _this2.filterResults(routeName);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var history = this.props.history;

      var leftContent = function () {
        if (history.isActive('/integration/authentication')) {
          return _react2.default.createElement(
            _searchBarCard2.default,
            { title: languageSettings.integration.routeNames.authentication },
            _this3.state.authenticated ? _react2.default.createElement(_integrationTourplanAuth2.default, _this3.props) : _react2.default.createElement(_integrationTourplanLogin2.default, _extends({}, _this3.props, { transition: _this3.setAuthenticated.bind(_this3), type: 'login' }))
          );
        }
        if (history.isActive('/integration/contracts')) return _react2.default.createElement(_integrationContracts2.default, _this3.props);
        if (history.isActive('/integration/settings/rate-name-text')) return _react2.default.createElement(_rateNameTextSettings2.default, _this3.props);
        if (history.isActive('/integration/settings/tax')) return _react2.default.createElement(_taxSettings2.default, _this3.props);
        if (history.isActive('/integration/settings/extras')) return _react2.default.createElement(_extrasSettings2.default, _this3.props);
        if (history.isActive('/integration/settings/pricecodes')) return _react2.default.createElement(_priceCodes2.default, _this3.props);
        if (history.isActive('/integration/settings/notes')) return _react2.default.createElement(_notesSettings2.default, _this3.props);
        return _react2.default.createElement(_cancelHourSettings2.default, _this3.props);
      }();

      return _react2.default.createElement(
        'div',
        { className: 'l-app-content l-left-nav-with-content', style: { maxWidth: 'calc(100% - 48px)' } },
        _react2.default.createElement(_integrationLeftNav2.default, _extends({}, this.props, {
          className: 'integration-left-nav l-left-nav',
          sendRouteName: this.sendRouteName
        })),
        _react2.default.createElement(
          'div',
          { className: 'l-left-nav-content', style: { overflowX: 'hidden' } },
          leftContent
        )
      );
    }
  }]);

  return Integration;
}(_react.Component);

Integration.propTypes = {
  history: _react.PropTypes.object,
  integration: _react.PropTypes.object
};

exports.default = Integration;

/***/ }),
/* 2848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _navLink = __webpack_require__(1049);

var _navLink2 = _interopRequireDefault(_navLink);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var languageSettings = _languages2.default['en-US'];

var leftNav = function leftNav(props) {
  return _react2.default.createElement(
    'div',
    { className: props.className },
    _react2.default.createElement(
      'div',
      { className: 'integration-left-nav-inner' },
      _react2.default.createElement(
        'div',
        { className: 'integration-left-nav-heading' },
        'Tourplan Integration'
      ),
      _react2.default.createElement(
        'div',
        { className: 'connections-widget' },
        _react2.default.createElement(
          _navLink2.default,
          _extends({}, props, {
            classes: "nav-link connections-widget-link",
            routeName: "/integration/authentication",
            activeRoutes: ['/integration/authentication']
          }),
          languageSettings.integration.routeNames.authentication
        ),
        _react2.default.createElement(
          _navLink2.default,
          _extends({}, props, {
            classes: "nav-link connections-widget-link",
            routeName: "/integration/contracts",
            activeRoutes: ['/integration/contracts']
          }),
          languageSettings.integration.routeNames.contracts
        ),
        _react2.default.createElement(
          'div',
          { className: 'integration-left-nav-heading', style: { fontSize: '12px' } },
          'Export Settings'
        ),
        _react2.default.createElement(
          _navLink2.default,
          _extends({}, props, {
            classes: "nav-link connections-widget-link",
            routeName: "/integration/settings/rate-name-text",
            activeRoutes: ['/integration/settings/rate-name-text']
          }),
          'Rate Name & Rate Text'
        ),
        _react2.default.createElement(
          _navLink2.default,
          _extends({}, props, {
            classes: "nav-link connections-widget-link",
            routeName: "/integration/settings/extras",
            activeRoutes: ['/integration/settings/extras']
          }),
          'Extras'
        ),
        _react2.default.createElement(
          _navLink2.default,
          _extends({}, props, {
            classes: "nav-link connections-widget-link",
            routeName: "/integration/settings/cancel-hours",
            activeRoutes: ['/integration/settings/cancel-hours']
          }),
          'Cancellation Hours'
        ),
        _react2.default.createElement(
          _navLink2.default,
          _extends({}, props, {
            classes: "nav-link connections-widget-link",
            routeName: "/integration/settings/tax",
            activeRoutes: ['/integration/settings/tax']
          }),
          'Tax'
        ),
        _react2.default.createElement(
          _navLink2.default,
          _extends({}, props, {
            classes: "nav-link connections-widget-link",
            routeName: "/integration/settings/pricecodes",
            activeRoutes: ['/integration/settings/pricecodes']
          }),
          'Price Codes'
        ),
        _react2.default.createElement(
          _navLink2.default,
          _extends({}, props, {
            classes: "nav-link connections-widget-link",
            routeName: "/integration/settings/notes",
            activeRoutes: ['/integration/settings/notes']
          }),
          'Notes'
        )
      )
    )
  );
};

leftNav.propTypes = {
  className: _react.PropTypes.string
};

exports.default = leftNav;

/***/ }),
/* 2849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _integrationTourplanLogin = __webpack_require__(1228);

var _integrationTourplanLogin2 = _interopRequireDefault(_integrationTourplanLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TourPlanAuth = function (_Component) {
  _inherits(TourPlanAuth, _Component);

  function TourPlanAuth(props) {
    _classCallCheck(this, TourPlanAuth);

    var _this = _possibleConstructorReturn(this, (TourPlanAuth.__proto__ || Object.getPrototypeOf(TourPlanAuth)).call(this, props));

    _this._dialogHide = function () {
      _this.setState({ dialogOpen: false });
    };

    _this._dialogShow = function () {
      _this.setState({ dialogOpen: true });
    };

    _this.state = {
      dialogOpen: false
    };
    return _this;
  }

  _createClass(TourPlanAuth, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          integration = _props.integration,
          getAuth = _props.getAuth;

      if (!integration.auth) getAuth();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var dialogActions = [_react2.default.createElement(_materialUi.FlatButton, {
        label: 'Dismiss',
        secondary: true,
        disableTouchRipple: true,
        onClick: this._dialogHide
      })];
      var dialog = _react2.default.createElement(
        _materialUi.Dialog,
        {
          ref: 'dialog',
          actions: dialogActions,
          open: this.state.dialogOpen,
          modal: true
        },
        _react2.default.createElement(_integrationTourplanLogin2.default, _extends({}, this.props, { transition: this._dialogHide, type: 'update' }))
      );

      return _react2.default.createElement(
        'div',
        { style: {
            margin: 'auto',
            width: '70%',
            textAlign: 'center'
          }
        },
        _react2.default.createElement(
          'div',
          { style: { marginBottom: '20px', fontSize: '18px' } },
          "Your account have been authenticated."
        ),
        _react2.default.createElement(
          'div',
          { style: { marginBottom: '20px' } },
          "Should you wish to update your credentials, please click button below."
        ),
        _react2.default.createElement(_materialUi.RaisedButton, {
          label: 'UPDATE CREDENTIALS',
          onTouchTap: function onTouchTap() {
            return _this2._dialogShow();
          },
          secondary: true
        }),
        dialog
      );
    }
  }]);

  return TourPlanAuth;
}(_react.Component);

exports.default = TourPlanAuth;

/***/ }),
/* 2850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _materialUi = __webpack_require__(3);

var _searchBarCard = __webpack_require__(1126);

var _searchBarCard2 = _interopRequireDefault(_searchBarCard);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

var _pagination = __webpack_require__(870);

var _pagination2 = _interopRequireDefault(_pagination);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var languageSettings = _languages2.default['en-US'];

var IntegrationContracts = function (_Component) {
  _inherits(IntegrationContracts, _Component);

  function IntegrationContracts(props) {
    _classCallCheck(this, IntegrationContracts);

    var _this = _possibleConstructorReturn(this, (IntegrationContracts.__proto__ || Object.getPrototypeOf(IntegrationContracts)).call(this, props));

    _this.goToPage = function (page) {
      _this.setState({ page: page });
      _this.props.getContracts({ page: page });
    };

    _this._handleSearch = function () {
      var _this$state = _this.state,
          sortValue = _this$state.sortValue,
          searchInput = _this$state.searchInput;

      if (sortValue === '1') _this.props.getContracts({ sortKey: 'from.name', sort: -1, page: 1, searchInput: searchInput });else if (sortValue === '2') _this.props.getContracts({ sortKey: '_id', sort: -1, page: 1, searchInput: searchInput });else if (sortValue === '3') _this.props.getContracts({ sortKey: '_id', sort: 1, page: 1, searchInput: searchInput });else if (sortValue === '4') _this.props.getContracts({ sortKey: 'lastExport.date', sort: -1, page: 1, searchInput: searchInput });else _this.props.getContracts({ page: 1, searchInput: searchInput });
    };

    _this._handleDownloadClick = function (contractId) {
      return function (e) {
        _this.props.dispatch({
          type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
          payload: {
            docId: contractId,
            collection: 'contract',
            anchorEl: e.currentTarget
          }
        });
      };
    };

    _this.state = {
      page: 1
    };
    _this.populateInitalState(props, _ramda2.default.clone(_this.state));
    return _this;
  }

  _createClass(IntegrationContracts, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var getContracts = this.props.getContracts;

      getContracts({ page: 1 });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.populateInitalState(props, this.state);
    }
  }, {
    key: 'populateInitalState',
    value: function populateInitalState(props, state) {
      var contractsFromStateStore = props.integration.contracts || [];
      var productTypesForFilter = [];
      var contractYearsForFilter = [];
      this.state = _extends({}, state, {
        sortValue: '2',
        productTypesForFilter: productTypesForFilter,
        contractYearsForFilter: contractYearsForFilter,
        filtersSelected: productTypesForFilter.concat(contractYearsForFilter)
      });
    }
  }, {
    key: '_searchWithInput',
    value: function _searchWithInput(input) {
      this.setState({ searchInput: input, page: 1 }, this._handleSearch);
    }
  }, {
    key: '_handleSortChange',
    value: function _handleSortChange(e, value) {
      this.setState({ sortValue: value, page: 1 }, this._handleSearch);
    }

    // _handleFilterChange(e, value) {
    //   this.setState({ filtersSelected: value });
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          history = _props.history,
          integration = _props.integration;

      if (integration.loadingContracts === 'loading' || !integration.contracts) {
        return _react2.default.createElement(
          _searchBarCard2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'no-connections-loading', style: { width: '100%', height: '100px' } },
            _react2.default.createElement('div', { className: 'load-bar loader' })
          )
        );
      } else if (integration.loadingContracts === 'failed') {
        return _react2.default.createElement(
          'div',
          null,
          "Failed to load contracts, please try again or contact customer support if it happens again"
        );
      } else if (integration.loadingContracts === 'success') {
        var contracts = integration.contracts.map(function () {
          var contract = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var supplierName = _ramda2.default.pathOr(_ramda2.default.pathOr('', ['from', 'name'], contract), ['partners', 0, 'name'], contract);
          var locationName = contract.locationName;
          var contractYear = _moment2.default.utc(contract.startDate).format('D MMM YY') + ' - ' + _moment2.default.utc(contract.endDate).format('D MMM YY');
          var isExported = contract.lastExport;
          var newObj = {
            productType: contract.productType,
            supplierInfo: contract.supplierInfo,
            supplierName: supplierName,
            locationName: locationName,
            isExported: isExported,
            contractYear: contractYear,
            updatedAt: contract.updatedAt,
            contractId: contract._id,
            versions: contract.versions
          };
          if (isExported) {
            newObj.isExported.timestamp = (0, _moment2.default)(isExported.date).calendar(null, {
              sameDay: 'h:mm a l',
              lastDay: 'l',
              lastWeek: 'l',
              sameElse: 'l'
            });
          }
          return newObj;
        });
        // const productTypesFilter = this.state.productTypesForFilter.map((productType, index) => {
        //   const checked = this.state.filtersSelected.indexOf(productType) !== -1;
        //   return <MenuItem key={`${productType}${index}`} checked={checked} value={productType} primaryText={productType} />;
        // });
        // const contractYearsFilter = this.state.contractYearsForFilter.map((contractYear, index) => {
        //   const checked = this.state.filtersSelected.indexOf(contractYear) !== -1;
        //   return <MenuItem key={`${contractYear}${index}`} checked={checked} value={contractYear} primaryText={contractYear} />;
        // });
        var titleBarExtra = _react2.default.createElement(
          'div',
          { style: {
              display: 'inline-block',
              float: 'right',
              fontSize: '16px',
              color: 'rgba(0,0,0,.26)',
              cursor: 'pointer'
            }
          },
          _react2.default.createElement(
            _materialUi.IconMenu,
            { closeOnItemTouchTap: false, desktop: true, onChange: this._handleSortChange.bind(this), value: this.state.sortValue, openDirection: 'bottom-right', iconButtonElement: _react2.default.createElement(_materialUi.IconButton, { tooltip: 'Sort', tooltipPosition: 'top-right', iconClassName: 'tc-icon-move-down', iconStyle: { color: 'rgba(0,0,0,.26)' } }) },
            _react2.default.createElement(_materialUi.MenuItem, { value: '1', primaryText: 'Alphabetically' }),
            _react2.default.createElement(_materialUi.MenuItem, { value: '2', primaryText: 'Last Completed' }),
            _react2.default.createElement(_materialUi.MenuItem, { value: '3', primaryText: 'Earliest Completed' }),
            _react2.default.createElement(_materialUi.MenuItem, { value: '4', primaryText: 'Export Date' })
          )
        );
        return _react2.default.createElement(
          _searchBarCard2.default,
          { title: languageSettings.integration.routeNames.contracts,
            isSticky: true,
            searchHeader: true,
            search: true,
            listCard: true,
            padded: false,
            searchWithInput: this._searchWithInput.bind(this),
            titleBarExtra: titleBarExtra,
            defaultValue: this.state.searchInput,
            searchBarHintText: 'Search...'
          },
          _react2.default.createElement(
            'div',
            null,
            function () {
              if (integration.totalContractsNo < 1) {
                return _react2.default.createElement(
                  'div',
                  { className: 'no-connections' },
                  _react2.default.createElement(
                    'h4',
                    { className: 'no-connections-message' },
                    ' ',
                    "Sorry, no contracts were found."
                  )
                );
              }
              return contracts.map(function (contract, index) {
                var iconButtonElement = _react2.default.createElement(_materialUi.IconButton, { iconStyle: { color: '#888' }, iconClassName: 'tc-icon-more-vert' });
                var rightIconMenu = _react2.default.createElement(
                  _materialUi.IconMenu,
                  { desktop: true, onItemTouchTap: _this2._handleDownloadClick(contract.contractId), style: { marginTop: '5px' }, iconButtonElement: iconButtonElement, openDirection: 'bottom-right' },
                  _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Download' })
                );

                var _ref = function () {
                  if (contract.isExported) {
                    return {
                      secondline: _react2.default.createElement(
                        'div',
                        { style: { display: 'block' } },
                        'Last exported on: ' + contract.isExported.timestamp + ' by ' + contract.isExported.user
                      ),
                      button: _react2.default.createElement(_materialUi.RaisedButton, {
                        label: 're-export',
                        secondary: true,
                        style: { float: 'right', width: '120px', minWidth: '120px' },
                        onClick: function onClick() {
                          history.push('/integration/product-mapping/' + contract.contractId);
                        }
                      })
                    };
                  }
                  return {
                    secondline: ' ',
                    button: _react2.default.createElement(_materialUi.RaisedButton, {
                      label: 'export',
                      primary: true,
                      style: { float: 'right', width: '120px', minWidth: '120px' },
                      onClick: function onClick() {
                        history.push('/integration/product-mapping/' + contract.contractId);
                      }
                    })
                  };
                }(),
                    secondline = _ref.secondline,
                    button = _ref.button;

                var primaryText = _react2.default.createElement(
                  'div',
                  null,
                  contract.supplierName,
                  _react2.default.createElement(
                    'a',
                    { style: { fontSize: '16px', cursor: 'pointer' }, target: '__blank', href: '/contracting/contract/' + contract.contractId + '/details' },
                    _react2.default.createElement(_materialUi.FontIcon, { style: { fontSize: '16px', marginLeft: '15px' }, color: "#00bcd4", className: 'tc-icon-archive' }),
                    _react2.default.createElement(
                      'span',
                      { style: { fontSize: '14px', fontWeight: '400' } },
                      ' ' + contract.locationName
                    ),
                    _ramda2.default.path(['supplierInfo', 'marketInfo'], contract) ? _react2.default.createElement(
                      'small',
                      null,
                      '\xA0',
                      '(' + _ramda2.default.path(['supplierInfo', 'marketInfo'], contract) + ')'
                    ) : _react2.default.createElement('span', null),
                    _react2.default.createElement(
                      'small',
                      null,
                      '(v.' + (contract.versions.length + 1) + ')'
                    )
                  ),
                  button
                );
                var secondaryText = _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Year: '
                  ),
                  _react2.default.createElement(
                    'small',
                    null,
                    contract.contractYear
                  ),
                  '\xA0\xA0',
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Last Updated: '
                  ),
                  _react2.default.createElement(
                    'small',
                    null,
                    (0, _moment2.default)(contract.updatedAt).calendar(null, {
                      sameDay: 'h:mm a l',
                      lastDay: 'l',
                      lastWeek: 'l',
                      sameElse: 'l'
                    })
                  ),
                  secondline
                );
                var listDivider = index !== contracts.length - 1 ? _react2.default.createElement(_materialUi.Divider, null) : undefined;
                return _react2.default.createElement(
                  'div',
                  { style: { fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" }, key: index },
                  _react2.default.createElement(_materialUi.ListItem, {
                    disabled: true,
                    primaryText: primaryText,
                    secondaryText: secondaryText,
                    rightIconButton: rightIconMenu,
                    secondaryTextLines: 2
                  }),
                  listDivider
                );
              });
            }(),
            Math.ceil(integration.totalContractsNo / 10) > 1 ? _react2.default.createElement(_pagination2.default, {
              currentPage: this.state.page,
              totalPages: Math.ceil(integration.totalContractsNo / 10),
              goToPage: this.goToPage,
              noOfPagesToShow: 5
            }) : _react2.default.createElement('span', null)
          )
        );
      }
    }
  }]);

  return IntegrationContracts;
}(_react.Component);

IntegrationContracts.propTypes = {
  config: _react.PropTypes.object,
  getContract: _react.PropTypes.func,
  getContracts: _react.PropTypes.func,
  user: _react.PropTypes.object,
  integration: _react.PropTypes.object,
  history: _react.PropTypes.object
};

exports.default = IntegrationContracts;

/***/ }),
/* 2851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _aphrodite = __webpack_require__(123);

var _rateNameTextSettingsListDUMB = __webpack_require__(2852);

var _rateNameTextSettingsListDUMB2 = _interopRequireDefault(_rateNameTextSettingsListDUMB);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = _aphrodite.StyleSheet.create({
  header: { backgroundColor: '#f5f5f5', padding: '0 16px', lineHeight: '48px', color: 'black', fontSize: '20px' }
});
var updateAnItemAndPushUp = function updateAnItemAndPushUp(newItem, list) {
  return (0, _ramda.call)((0, _ramda.compose)(function (newList) {
    return (0, _ramda.concat)(newList.filter((0, _ramda.propEq)('checked', true)), newList.filter((0, _ramda.propEq)('checked', false)));
  }, (0, _ramda.update)(_ramda.__, newItem, list), (0, _ramda.findIndex)((0, _ramda.eqProps)('text', newItem))), list);
};
// Rate Name is Stay_Type in the doc limited 20, the first one in tourplan, also shown in the sub left menu
// Rate Text is Rate_Text in the doc limited 60
var IntegrationSettings = function IntegrationSettings(_ref) {
  var rateNameSetting = _ref.rateNameSetting,
      rateTextSetting = _ref.rateTextSetting,
      rateNameUseCombination = _ref.rateNameUseCombination,
      rateTextUseCombination = _ref.rateTextUseCombination,
      rateNamePopoverOpen = _ref.rateNamePopoverOpen,
      rateNameAnchorEl = _ref.rateNameAnchorEl,
      rateNamePopoverContent = _ref.rateNamePopoverContent,
      rateTextPopoverOpen = _ref.rateTextPopoverOpen,
      rateTextAnchorEl = _ref.rateTextAnchorEl,
      rateTextPopoverContent = _ref.rateTextPopoverContent,
      updateSettings = _ref.updateSettings,
      enableRateNameButton = _ref.enableRateNameButton,
      enableRateTextButton = _ref.enableRateTextButton,
      savingSettings = _ref.savingSettings,
      saveSettings = _ref.saveSettings,
      triggerSnackBarMessage = _ref.triggerSnackBarMessage;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '12px' } },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-bulb', color: '#ffc800', style: { fontSize: '24px', top: '-8px' } }),
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', width: '90%', marginLeft: '2%' } },
        'You can configure the Rate Name and Rate Text fields that will be exported into Tourplan with the list of options below.'
      )
    ),
    _react2.default.createElement(
      _materialUi.Paper,
      { style: { marginTop: '24px' } },
      _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styles.header) },
        'Rate Name Settings (20 character limit in Tourplan)'
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(_rateNameTextSettingsListDUMB2.default, {
        limit: 19,
        popoverContent: rateNamePopoverContent,
        popoverOpen: rateNamePopoverOpen,
        anchorEl: rateNameAnchorEl,
        closePopover: function closePopover() {
          return updateSettings({ rateNamePopoverOpen: false, rateNameAnchorEl: undefined, rateNamePopoverContent: {} });
        },
        openPopover: function openPopover(anchorEl, popoverContent) {
          return updateSettings({ rateNamePopoverOpen: true, rateNameAnchorEl: anchorEl, rateNamePopoverContent: popoverContent });
        },
        useCombination: rateNameUseCombination,
        arrayOfData: rateNameSetting,
        dragEnds: function dragEnds(newData) {
          return updateSettings({ rateNameSetting: newData, enableRateNameButton: true });
        },
        onToggle: function onToggle(toggeled) {
          return updateSettings({ rateNameUseCombination: toggeled, enableRateNameButton: true });
        },
        checkAnItem: function checkAnItem(item) {
          return updateSettings({ rateNameSetting: updateAnItemAndPushUp((0, _ramda.merge)(item, { checked: !item.checked }), rateNameSetting), enableRateNameButton: true });
        }
      }),
      _react2.default.createElement(_raisedButtonWithLoader2.default, {
        label: enableRateNameButton ? 'Save' : 'Saved',
        secondary: true,
        loader: savingSettings,
        disabled: !enableRateNameButton,
        style: { margin: '12px 80%', width: '130px' },
        onTouchTap: function onTouchTap() {
          saveSettings({
            rateNameSetting: rateNameSetting,
            rateNameUseCombination: rateNameUseCombination
          }, { enableRateNameButton: false }).catch(function () {
            triggerSnackBarMessage('Unable to save rate name settings');
            updateSettings({ enableRateNameButton: true });
          });
        }
      })
    ),
    _react2.default.createElement(
      _materialUi.Paper,
      { style: { marginTop: '24px' } },
      _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styles.header) },
        'Rate Text Settings (60 character limit in Tourplan)'
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(_rateNameTextSettingsListDUMB2.default, {
        limit: 59,
        popoverContent: rateTextPopoverContent,
        popoverOpen: rateTextPopoverOpen,
        anchorEl: rateTextAnchorEl,
        closePopover: function closePopover() {
          return updateSettings({ rateTextPopoverOpen: false, rateTextAnchorEl: undefined, rateTextPopoverContent: {} });
        },
        openPopover: function openPopover(anchorEl, popoverContent) {
          return updateSettings({ rateTextPopoverOpen: true, rateTextAnchorEl: anchorEl, rateTextPopoverContent: popoverContent });
        },
        useCombination: rateTextUseCombination,
        arrayOfData: rateTextSetting,
        dragEnds: function dragEnds(newData) {
          return updateSettings({ rateTextSetting: newData, enableRateTextButton: true });
        },
        onToggle: function onToggle(toggeled) {
          return updateSettings({ rateTextUseCombination: toggeled, enableRateTextButton: true });
        },
        checkAnItem: function checkAnItem(item) {
          return updateSettings({ rateTextSetting: updateAnItemAndPushUp((0, _ramda.merge)(item, { checked: !item.checked }), rateTextSetting), enableRateTextButton: true });
        }
      }),
      _react2.default.createElement(_raisedButtonWithLoader2.default, {
        label: enableRateTextButton ? 'Save' : 'Saved',
        secondary: true,
        loader: savingSettings,
        disabled: !enableRateTextButton,
        style: { margin: '12px 80%', width: '130px' },
        onTouchTap: function onTouchTap() {
          saveSettings({
            rateTextSetting: rateTextSetting,
            rateTextUseCombination: rateTextUseCombination
          }, { enableRateTextButton: false }).catch(function () {
            triggerSnackBarMessage('Unable to save rate text settings');
            updateSettings({ enableRateTextButton: true });
          });
        }
      })
    )
  );
};

var mapPropsToState = function mapPropsToState(_ref2) {
  var integration = _ref2.integration;
  return {
    rateNameSetting: integration.getIn(['settings', 'rateNameSetting']).toJS(),
    rateTextSetting: integration.getIn(['settings', 'rateTextSetting']).toJS(),
    rateNameUseCombination: integration.getIn(['settings', 'rateNameUseCombination']),
    rateTextUseCombination: integration.getIn(['settings', 'rateTextUseCombination']),
    rateNamePopoverOpen: integration.getIn(['settings', 'rateNamePopoverOpen']),
    rateNameAnchorEl: integration.getIn(['settings', 'rateNameAnchorEl']),
    rateNamePopoverContent: integration.getIn(['settings', 'rateNamePopoverContent']).toJS(),
    rateTextPopoverOpen: integration.getIn(['settings', 'rateTextPopoverOpen']),
    rateTextAnchorEl: integration.getIn(['settings', 'rateTextAnchorEl']),
    rateTextPopoverContent: integration.getIn(['settings', 'rateTextPopoverContent']).toJS(),
    savingSettings: integration.getIn(['settings', 'savingSettings']),
    enableRateNameButton: integration.getIn(['settings', 'enableRateNameButton']),
    enableRateTextButton: integration.getIn(['settings', 'enableRateTextButton'])
  };
};

exports.default = (0, _reactRedux.connect)(mapPropsToState)(IntegrationSettings);

/***/ }),
/* 2852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _aphrodite = __webpack_require__(123);

var _sortableList = __webpack_require__(1130);

var _sortableList2 = _interopRequireDefault(_sortableList);

var _draggableCard = __webpack_require__(1134);

var _draggableCard2 = _interopRequireDefault(_draggableCard);

var _rateNameTextExample = __webpack_require__(2942);

var _rateNameTextExample2 = _interopRequireDefault(_rateNameTextExample);

var _checkCircle = __webpack_require__(1044);

var _checkCircle2 = _interopRequireDefault(_checkCircle);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var border = '1px dashed rgba(0, 0, 0, 0.54)';
var disableDragBorder = '1px solid rgba(0, 0, 0, 0.54)';
var styles = _aphrodite.StyleSheet.create({
  listContainer: { display: 'flex', width: '100%' },
  draggableCard: { margin: '0px 0px 8px 32px', width: '90%' },
  sortableItem: { border: border, padding: '12px 6px', display: 'flex', alignItems: 'center' },
  nonSortableItem: { border: disableDragBorder, padding: '12px 6px', display: 'flex', alignItems: 'center' },
  text: { display: 'inline-block', width: '80%', marginLeft: '6px', position: 'relative', top: '-2px', cursor: 'pointer' }
});

var plusOr = function plusOr(combination) {
  return _react2.default.createElement(
    'div',
    { style: { textAlign: 'center', height: '65px' } },
    combination ? _react2.default.createElement(
      'span',
      { style: { top: '45px', position: 'relative' } },
      'AND'
    ) : _react2.default.createElement(
      'span',
      { style: { top: '45px', position: 'relative' } },
      'OR'
    )
  );
};

var CheckSortList = function CheckSortList(_ref) {
  var arrayOfData = _ref.arrayOfData,
      popoverContent = _ref.popoverContent,
      popoverOpen = _ref.popoverOpen,
      anchorEl = _ref.anchorEl,
      closePopover = _ref.closePopover,
      openPopover = _ref.openPopover,
      dragEnds = _ref.dragEnds,
      checkAnItem = _ref.checkAnItem,
      useCombination = _ref.useCombination,
      _onToggle = _ref.onToggle,
      limit = _ref.limit;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_materialUi.Toggle, {
      label: 'Combine',
      labelPosition: 'right',
      style: { width: '30%', marginLeft: '32px', marginBottom: '16px' },
      toggled: useCombination,
      onToggle: function onToggle(_, toggeled) {
        return _onToggle(toggeled);
      }
    }),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.listContainer) },
      _react2.default.createElement(
        _sortableList2.default,
        {
          style: { width: '45%', display: 'inline-block' },
          arrayOfData: arrayOfData,
          dragEnds: dragEnds
        },
        arrayOfData.map(function (item, index) {
          return _react2.default.createElement(
            _draggableCard2.default,
            { key: index, className: (0, _aphrodite.css)(styles.draggableCard), isDragSource: item.checked, isDropTarget: item.checked },
            _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles[item.checked ? 'sortableItem' : 'nonSortableItem']) },
              _react2.default.createElement(_checkCircle2.default, {
                onTouchTap: function onTouchTap() {
                  return checkAnItem(item);
                },
                style: { cursor: 'pointer', fill: item.checked ? 'rgb(0, 188, 212)' : '#eeeeee' }
              }),
              _react2.default.createElement(
                'div',
                { className: (0, _aphrodite.css)(styles.text), onClick: function onClick(_ref2) {
                    var currentTarget = _ref2.currentTarget;
                    return openPopover(currentTarget, item.mappings);
                  } },
                item.text
              ),
              _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-swap_vert', style: { color: item.checked ? 'rgba(0, 0, 0, 0.34)' : 'white', top: '5px' } })
            )
          );
        })
      ),
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', width: '5%' } },
        arrayOfData.filter((0, _ramda.propEq)('checked', true)).map(function (_, index) {
          return index ? plusOr(useCombination) : _react2.default.createElement('div', null);
        })
      ),
      _react2.default.createElement(
        'div',
        { style: { marginLeft: '16px', width: '45%', fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" } },
        _react2.default.createElement(
          'div',
          { style: { marginBottom: '16px', fontWeight: 'bold', borderBottom: '1px solid rgba(0, 0, 0, 0.34)' } },
          'Example:'
        ),
        _react2.default.createElement(_rateNameTextExample2.default, {
          rule: arrayOfData,
          combinable: useCombination,
          limit: limit
        })
      ),
      _react2.default.createElement(
        _materialUi.Popover,
        {
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          targetOrigin: { horizontal: 'left', vertical: 'top' },
          anchorEl: anchorEl,
          open: popoverOpen,
          onRequestClose: closePopover,
          style: { padding: '16px', fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif", width: '400px' }
        },
        (0, _ramda.call)((0, _ramda.compose)((0, _ramda.map)(function (key) {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { style: { width: '55%', display: 'inline-block' } },
              key
            ),
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-arrow-right2', style: { fontSize: '15px', margin: '0 5px', top: '2px' }, color: "#c8c8c8" }),
            _react2.default.createElement(
              'div',
              { style: { marginLeft: '32px', display: 'inline-block' } },
              popoverContent[key]
            )
          );
        }), _ramda.keys), popoverContent)
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { marginLeft: '32px' } },
      '* when applicable'
    )
  );
};

exports.default = CheckSortList;

/***/ }),
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(1020),
    _assign = __webpack_require__(127);

var invariant = __webpack_require__(56);
var hasOwnProperty = {}.hasOwnProperty;

function shallowCopy(x) {
  if (Array.isArray(x)) {
    return x.concat();
  } else if (x && typeof x === 'object') {
    return _assign(new x.constructor(), x);
  } else {
    return x;
  }
}

var COMMAND_PUSH = '$push';
var COMMAND_UNSHIFT = '$unshift';
var COMMAND_SPLICE = '$splice';
var COMMAND_SET = '$set';
var COMMAND_MERGE = '$merge';
var COMMAND_APPLY = '$apply';

var ALL_COMMANDS_LIST = [COMMAND_PUSH, COMMAND_UNSHIFT, COMMAND_SPLICE, COMMAND_SET, COMMAND_MERGE, COMMAND_APPLY];

var ALL_COMMANDS_SET = {};

ALL_COMMANDS_LIST.forEach(function (command) {
  ALL_COMMANDS_SET[command] = true;
});

function invariantArrayCase(value, spec, command) {
  !Array.isArray(value) ?  false ? invariant(false, 'update(): expected target of %s to be an array; got %s.', command, value) : _prodInvariant('1', command, value) : void 0;
  var specValue = spec[command];
  !Array.isArray(specValue) ?  false ? invariant(false, 'update(): expected spec of %s to be an array; got %s. Did you forget to wrap your parameter in an array?', command, specValue) : _prodInvariant('2', command, specValue) : void 0;
}

/**
 * Returns a updated shallow copy of an object without mutating the original.
 * See https://facebook.github.io/react/docs/update.html for details.
 */
function update(value, spec) {
  !(typeof spec === 'object') ?  false ? invariant(false, 'update(): You provided a key path to update() that did not contain one of %s. Did you forget to include {%s: ...}?', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : _prodInvariant('3', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : void 0;

  if (hasOwnProperty.call(spec, COMMAND_SET)) {
    !(Object.keys(spec).length === 1) ?  false ? invariant(false, 'Cannot have more than one key in an object with %s', COMMAND_SET) : _prodInvariant('4', COMMAND_SET) : void 0;

    return spec[COMMAND_SET];
  }

  var nextValue = shallowCopy(value);

  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
    var mergeObj = spec[COMMAND_MERGE];
    !(mergeObj && typeof mergeObj === 'object') ?  false ? invariant(false, 'update(): %s expects a spec of type \'object\'; got %s', COMMAND_MERGE, mergeObj) : _prodInvariant('5', COMMAND_MERGE, mergeObj) : void 0;
    !(nextValue && typeof nextValue === 'object') ?  false ? invariant(false, 'update(): %s expects a target of type \'object\'; got %s', COMMAND_MERGE, nextValue) : _prodInvariant('6', COMMAND_MERGE, nextValue) : void 0;
    _assign(nextValue, spec[COMMAND_MERGE]);
  }

  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
    invariantArrayCase(value, spec, COMMAND_PUSH);
    spec[COMMAND_PUSH].forEach(function (item) {
      nextValue.push(item);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
    spec[COMMAND_UNSHIFT].forEach(function (item) {
      nextValue.unshift(item);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
    !Array.isArray(value) ?  false ? invariant(false, 'Expected %s target to be an array; got %s', COMMAND_SPLICE, value) : _prodInvariant('7', COMMAND_SPLICE, value) : void 0;
    !Array.isArray(spec[COMMAND_SPLICE]) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
    spec[COMMAND_SPLICE].forEach(function (args) {
      !Array.isArray(args) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
      nextValue.splice.apply(nextValue, args);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
    !(typeof spec[COMMAND_APPLY] === 'function') ?  false ? invariant(false, 'update(): expected spec of %s to be a function; got %s.', COMMAND_APPLY, spec[COMMAND_APPLY]) : _prodInvariant('9', COMMAND_APPLY, spec[COMMAND_APPLY]) : void 0;
    nextValue = spec[COMMAND_APPLY](nextValue);
  }

  for (var k in spec) {
    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
      nextValue[k] = update(value[k], spec[k]);
    }
  }

  return nextValue;
}

module.exports = update;

/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(2855);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragDropManager = __webpack_require__(2857);

Object.defineProperty(exports, 'DragDropManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropManager).default;
  }
});

var _DragSource = __webpack_require__(2906);

Object.defineProperty(exports, 'DragSource', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragSource).default;
  }
});

var _DropTarget = __webpack_require__(2907);

Object.defineProperty(exports, 'DropTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropTarget).default;
  }
});

var _createTestBackend = __webpack_require__(2908);

Object.defineProperty(exports, 'createTestBackend', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createTestBackend).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createStore = __webpack_require__(2858);

var _createStore2 = _interopRequireDefault(_createStore);

var _reducers = __webpack_require__(2862);

var _reducers2 = _interopRequireDefault(_reducers);

var _dragDrop = __webpack_require__(1231);

var dragDropActions = _interopRequireWildcard(_dragDrop);

var _DragDropMonitor = __webpack_require__(2903);

var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragDropManager = function () {
	function DragDropManager(createBackend) {
		var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, DragDropManager);

		var store = (0, _createStore2.default)(_reducers2.default);
		this.context = context;
		this.store = store;
		this.monitor = new _DragDropMonitor2.default(store);
		this.registry = this.monitor.registry;
		this.backend = createBackend(this);

		store.subscribe(this.handleRefCountChange.bind(this));
	}

	_createClass(DragDropManager, [{
		key: 'handleRefCountChange',
		value: function handleRefCountChange() {
			var shouldSetUp = this.store.getState().refCount > 0;
			if (shouldSetUp && !this.isSetUp) {
				this.backend.setup();
				this.isSetUp = true;
			} else if (!shouldSetUp && this.isSetUp) {
				this.backend.teardown();
				this.isSetUp = false;
			}
		}
	}, {
		key: 'getContext',
		value: function getContext() {
			return this.context;
		}
	}, {
		key: 'getMonitor',
		value: function getMonitor() {
			return this.monitor;
		}
	}, {
		key: 'getBackend',
		value: function getBackend() {
			return this.backend;
		}
	}, {
		key: 'getRegistry',
		value: function getRegistry() {
			return this.registry;
		}
	}, {
		key: 'getActions',
		value: function getActions() {
			var manager = this;
			var dispatch = this.store.dispatch;


			function bindActionCreator(actionCreator) {
				return function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var action = actionCreator.apply(manager, args);
					if (typeof action !== 'undefined') {
						dispatch(action);
					}
				};
			}

			return Object.keys(dragDropActions).filter(function (key) {
				return typeof dragDropActions[key] === 'function';
			}).reduce(function (boundActions, key) {
				var action = dragDropActions[key];
				boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
				return boundActions;
			}, {});
		}
	}]);

	return DragDropManager;
}();

exports.default = DragDropManager;

/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ActionTypes = undefined;
exports['default'] = createStore;

var _isPlainObject = __webpack_require__(999);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _symbolObservable = __webpack_require__(1184);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = exports.ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!(0, _isPlainObject2['default'])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[_symbolObservable2['default']] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
}

/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1132);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 2860 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1883);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = reduce;

var _dragOffset = __webpack_require__(1884);

var _dragOffset2 = _interopRequireDefault(_dragOffset);

var _dragOperation = __webpack_require__(2863);

var _dragOperation2 = _interopRequireDefault(_dragOperation);

var _refCount = __webpack_require__(2893);

var _refCount2 = _interopRequireDefault(_refCount);

var _dirtyHandlerIds = __webpack_require__(1892);

var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);

var _stateId = __webpack_require__(2902);

var _stateId2 = _interopRequireDefault(_stateId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reduce() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	return {
		dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
		dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
		refCount: (0, _refCount2.default)(state.refCount, action),
		dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
		stateId: (0, _stateId2.default)(state.stateId)
	};
}

/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = dragOperation;

var _without = __webpack_require__(1886);

var _without2 = _interopRequireDefault(_without);

var _dragDrop = __webpack_require__(1231);

var _registry = __webpack_require__(1241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
	itemType: null,
	item: null,
	sourceId: null,
	targetIds: [],
	dropResult: null,
	didDrop: false,
	isSourcePublic: null
};

function dragOperation() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case _dragDrop.BEGIN_DRAG:
			return _extends({}, state, {
				itemType: action.itemType,
				item: action.item,
				sourceId: action.sourceId,
				isSourcePublic: action.isSourcePublic,
				dropResult: null,
				didDrop: false
			});
		case _dragDrop.PUBLISH_DRAG_SOURCE:
			return _extends({}, state, {
				isSourcePublic: true
			});
		case _dragDrop.HOVER:
			return _extends({}, state, {
				targetIds: action.targetIds
			});
		case _registry.REMOVE_TARGET:
			if (state.targetIds.indexOf(action.targetId) === -1) {
				return state;
			}
			return _extends({}, state, {
				targetIds: (0, _without2.default)(state.targetIds, action.targetId)
			});
		case _dragDrop.DROP:
			return _extends({}, state, {
				dropResult: action.dropResult,
				didDrop: true,
				targetIds: []
			});
		case _dragDrop.END_DRAG:
			return _extends({}, state, {
				itemType: null,
				item: null,
				sourceId: null,
				dropResult: null,
				didDrop: false,
				isSourcePublic: null,
				targetIds: []
			});
		default:
			return state;
	}
}

/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(2865),
    ListCache = __webpack_require__(1234),
    Map = __webpack_require__(1502);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(2866),
    hashDelete = __webpack_require__(2871),
    hashGet = __webpack_require__(2872),
    hashHas = __webpack_require__(2873),
    hashSet = __webpack_require__(2874);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1233);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(1501),
    isMasked = __webpack_require__(2868),
    isObject = __webpack_require__(735),
    toSource = __webpack_require__(1888);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(2869);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(550);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 2870 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 2871 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1233);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 2873 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1233);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 2874 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1233);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 2875 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(1235);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(1235);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(1235);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(1235);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(1236);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 2881 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(1236);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(1236);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(1236);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 2885 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 2886 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 2887 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(2888),
    baseIsNaN = __webpack_require__(2889),
    strictIndexOf = __webpack_require__(2890);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 2888 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 2889 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 2890 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 2891 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(2892),
    defineProperty = __webpack_require__(1890),
    identity = __webpack_require__(1052);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 2892 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 2893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = refCount;

var _registry = __webpack_require__(1241);

function refCount() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	var action = arguments[1];

	switch (action.type) {
		case _registry.ADD_SOURCE:
		case _registry.ADD_TARGET:
			return state + 1;
		case _registry.REMOVE_SOURCE:
		case _registry.REMOVE_TARGET:
			return state - 1;
		default:
			return state;
	}
}

/***/ }),
/* 2894 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1893),
    baseRest = __webpack_require__(875),
    baseXor = __webpack_require__(2895),
    isArrayLikeObject = __webpack_require__(1240);

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = baseRest(function(arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});

module.exports = xor;


/***/ }),
/* 2895 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(1887),
    baseFlatten = __webpack_require__(1508),
    baseUniq = __webpack_require__(1895);

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}

module.exports = baseXor;


/***/ }),
/* 2896 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1132),
    isArguments = __webpack_require__(1509),
    isArray = __webpack_require__(255);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(1051),
    isObjectLike = __webpack_require__(874);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 2898 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(1896),
    noop = __webpack_require__(1242),
    setToArray = __webpack_require__(1510);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 2899 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(1238),
    baseIntersection = __webpack_require__(2900),
    baseRest = __webpack_require__(875),
    castArrayLikeObject = __webpack_require__(2901);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 2900 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1232),
    arrayIncludes = __webpack_require__(1237),
    arrayIncludesWith = __webpack_require__(1503),
    arrayMap = __webpack_require__(1238),
    baseUnary = __webpack_require__(1504),
    cacheHas = __webpack_require__(1239);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(1240);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = stateId;
function stateId() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

	return state + 1;
}

/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(255);

var _isArray2 = _interopRequireDefault(_isArray);

var _matchesType = __webpack_require__(1885);

var _matchesType2 = _interopRequireDefault(_matchesType);

var _HandlerRegistry = __webpack_require__(2904);

var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);

var _dragOffset = __webpack_require__(1884);

var _dirtyHandlerIds = __webpack_require__(1892);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragDropMonitor = function () {
	function DragDropMonitor(store) {
		_classCallCheck(this, DragDropMonitor);

		this.store = store;
		this.registry = new _HandlerRegistry2.default(store);
	}

	_createClass(DragDropMonitor, [{
		key: 'subscribeToStateChange',
		value: function subscribeToStateChange(listener) {
			var _this = this;

			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var handlerIds = options.handlerIds;

			(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
			(0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');

			var prevStateId = this.store.getState().stateId;
			var handleChange = function handleChange() {
				var state = _this.store.getState();
				var currentStateId = state.stateId;
				try {
					var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);

					if (!canSkipListener) {
						listener();
					}
				} finally {
					prevStateId = currentStateId;
				}
			};

			return this.store.subscribe(handleChange);
		}
	}, {
		key: 'subscribeToOffsetChange',
		value: function subscribeToOffsetChange(listener) {
			var _this2 = this;

			(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');

			var previousState = this.store.getState().dragOffset;
			var handleChange = function handleChange() {
				var nextState = _this2.store.getState().dragOffset;
				if (nextState === previousState) {
					return;
				}

				previousState = nextState;
				listener();
			};

			return this.store.subscribe(handleChange);
		}
	}, {
		key: 'canDragSource',
		value: function canDragSource(sourceId) {
			var source = this.registry.getSource(sourceId);
			(0, _invariant2.default)(source, 'Expected to find a valid source.');

			if (this.isDragging()) {
				return false;
			}

			return source.canDrag(this, sourceId);
		}
	}, {
		key: 'canDropOnTarget',
		value: function canDropOnTarget(targetId) {
			var target = this.registry.getTarget(targetId);
			(0, _invariant2.default)(target, 'Expected to find a valid target.');

			if (!this.isDragging() || this.didDrop()) {
				return false;
			}

			var targetType = this.registry.getTargetType(targetId);
			var draggedItemType = this.getItemType();
			return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
		}
	}, {
		key: 'isDragging',
		value: function isDragging() {
			return Boolean(this.getItemType());
		}
	}, {
		key: 'isDraggingSource',
		value: function isDraggingSource(sourceId) {
			var source = this.registry.getSource(sourceId, true);
			(0, _invariant2.default)(source, 'Expected to find a valid source.');

			if (!this.isDragging() || !this.isSourcePublic()) {
				return false;
			}

			var sourceType = this.registry.getSourceType(sourceId);
			var draggedItemType = this.getItemType();
			if (sourceType !== draggedItemType) {
				return false;
			}

			return source.isDragging(this, sourceId);
		}
	}, {
		key: 'isOverTarget',
		value: function isOverTarget(targetId) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { shallow: false };
			var shallow = options.shallow;

			if (!this.isDragging()) {
				return false;
			}

			var targetType = this.registry.getTargetType(targetId);
			var draggedItemType = this.getItemType();
			if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
				return false;
			}

			var targetIds = this.getTargetIds();
			if (!targetIds.length) {
				return false;
			}

			var index = targetIds.indexOf(targetId);
			if (shallow) {
				return index === targetIds.length - 1;
			} else {
				return index > -1;
			}
		}
	}, {
		key: 'getItemType',
		value: function getItemType() {
			return this.store.getState().dragOperation.itemType;
		}
	}, {
		key: 'getItem',
		value: function getItem() {
			return this.store.getState().dragOperation.item;
		}
	}, {
		key: 'getSourceId',
		value: function getSourceId() {
			return this.store.getState().dragOperation.sourceId;
		}
	}, {
		key: 'getTargetIds',
		value: function getTargetIds() {
			return this.store.getState().dragOperation.targetIds;
		}
	}, {
		key: 'getDropResult',
		value: function getDropResult() {
			return this.store.getState().dragOperation.dropResult;
		}
	}, {
		key: 'didDrop',
		value: function didDrop() {
			return this.store.getState().dragOperation.didDrop;
		}
	}, {
		key: 'isSourcePublic',
		value: function isSourcePublic() {
			return this.store.getState().dragOperation.isSourcePublic;
		}
	}, {
		key: 'getInitialClientOffset',
		value: function getInitialClientOffset() {
			return this.store.getState().dragOffset.initialClientOffset;
		}
	}, {
		key: 'getInitialSourceClientOffset',
		value: function getInitialSourceClientOffset() {
			return this.store.getState().dragOffset.initialSourceClientOffset;
		}
	}, {
		key: 'getClientOffset',
		value: function getClientOffset() {
			return this.store.getState().dragOffset.clientOffset;
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset() {
			return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
		}
	}, {
		key: 'getDifferenceFromInitialOffset',
		value: function getDifferenceFromInitialOffset() {
			return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
		}
	}]);

	return DragDropMonitor;
}();

exports.default = DragDropMonitor;

/***/ }),
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(255);

var _isArray2 = _interopRequireDefault(_isArray);

var _asap = __webpack_require__(1229);

var _asap2 = _interopRequireDefault(_asap);

var _registry = __webpack_require__(1241);

var _getNextUniqueId = __webpack_require__(2905);

var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HandlerRoles = {
	SOURCE: 'SOURCE',
	TARGET: 'TARGET'
};

function validateSourceContract(source) {
	(0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
	(0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
	(0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}

function validateTargetContract(target) {
	(0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
	(0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
	(0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}

function validateType(type, allowArray) {
	if (allowArray && (0, _isArray2.default)(type)) {
		type.forEach(function (t) {
			return validateType(t, false);
		});
		return;
	}

	(0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

function getNextHandlerId(role) {
	var id = (0, _getNextUniqueId2.default)().toString();
	switch (role) {
		case HandlerRoles.SOURCE:
			return 'S' + id;
		case HandlerRoles.TARGET:
			return 'T' + id;
		default:
			(0, _invariant2.default)(false, 'Unknown role: ' + role);
	}
}

function parseRoleFromHandlerId(handlerId) {
	switch (handlerId[0]) {
		case 'S':
			return HandlerRoles.SOURCE;
		case 'T':
			return HandlerRoles.TARGET;
		default:
			(0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
	}
}

var HandlerRegistry = function () {
	function HandlerRegistry(store) {
		_classCallCheck(this, HandlerRegistry);

		this.store = store;

		this.types = {};
		this.handlers = {};

		this.pinnedSourceId = null;
		this.pinnedSource = null;
	}

	_createClass(HandlerRegistry, [{
		key: 'addSource',
		value: function addSource(type, source) {
			validateType(type);
			validateSourceContract(source);

			var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
			this.store.dispatch((0, _registry.addSource)(sourceId));
			return sourceId;
		}
	}, {
		key: 'addTarget',
		value: function addTarget(type, target) {
			validateType(type, true);
			validateTargetContract(target);

			var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
			this.store.dispatch((0, _registry.addTarget)(targetId));
			return targetId;
		}
	}, {
		key: 'addHandler',
		value: function addHandler(role, type, handler) {
			var id = getNextHandlerId(role);
			this.types[id] = type;
			this.handlers[id] = handler;

			return id;
		}
	}, {
		key: 'containsHandler',
		value: function containsHandler(handler) {
			var _this = this;

			return Object.keys(this.handlers).some(function (key) {
				return _this.handlers[key] === handler;
			});
		}
	}, {
		key: 'getSource',
		value: function getSource(sourceId, includePinned) {
			(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');

			var isPinned = includePinned && sourceId === this.pinnedSourceId;
			var source = isPinned ? this.pinnedSource : this.handlers[sourceId];

			return source;
		}
	}, {
		key: 'getTarget',
		value: function getTarget(targetId) {
			(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
			return this.handlers[targetId];
		}
	}, {
		key: 'getSourceType',
		value: function getSourceType(sourceId) {
			(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
			return this.types[sourceId];
		}
	}, {
		key: 'getTargetType',
		value: function getTargetType(targetId) {
			(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
			return this.types[targetId];
		}
	}, {
		key: 'isSourceId',
		value: function isSourceId(handlerId) {
			var role = parseRoleFromHandlerId(handlerId);
			return role === HandlerRoles.SOURCE;
		}
	}, {
		key: 'isTargetId',
		value: function isTargetId(handlerId) {
			var role = parseRoleFromHandlerId(handlerId);
			return role === HandlerRoles.TARGET;
		}
	}, {
		key: 'removeSource',
		value: function removeSource(sourceId) {
			var _this2 = this;

			(0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
			this.store.dispatch((0, _registry.removeSource)(sourceId));

			(0, _asap2.default)(function () {
				delete _this2.handlers[sourceId];
				delete _this2.types[sourceId];
			});
		}
	}, {
		key: 'removeTarget',
		value: function removeTarget(targetId) {
			var _this3 = this;

			(0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
			this.store.dispatch((0, _registry.removeTarget)(targetId));

			(0, _asap2.default)(function () {
				delete _this3.handlers[targetId];
				delete _this3.types[targetId];
			});
		}
	}, {
		key: 'pinSource',
		value: function pinSource(sourceId) {
			var source = this.getSource(sourceId);
			(0, _invariant2.default)(source, 'Expected an existing source.');

			this.pinnedSourceId = sourceId;
			this.pinnedSource = source;
		}
	}, {
		key: 'unpinSource',
		value: function unpinSource() {
			(0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');

			this.pinnedSourceId = null;
			this.pinnedSource = null;
		}
	}]);

	return HandlerRegistry;
}();

exports.default = HandlerRegistry;

/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getNextUniqueId;
var nextUniqueId = 0;

function getNextUniqueId() {
	return nextUniqueId++;
}

/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragSource = function () {
	function DragSource() {
		_classCallCheck(this, DragSource);
	}

	_createClass(DragSource, [{
		key: "canDrag",
		value: function canDrag() {
			return true;
		}
	}, {
		key: "isDragging",
		value: function isDragging(monitor, handle) {
			return handle === monitor.getSourceId();
		}
	}, {
		key: "endDrag",
		value: function endDrag() {}
	}]);

	return DragSource;
}();

exports.default = DragSource;

/***/ }),
/* 2907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DropTarget = function () {
	function DropTarget() {
		_classCallCheck(this, DropTarget);
	}

	_createClass(DropTarget, [{
		key: "canDrop",
		value: function canDrop() {
			return true;
		}
	}, {
		key: "hover",
		value: function hover() {}
	}, {
		key: "drop",
		value: function drop() {}
	}]);

	return DropTarget;
}();

exports.default = DropTarget;

/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createBackend;

var _noop = __webpack_require__(1242);

var _noop2 = _interopRequireDefault(_noop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TestBackend = function () {
	function TestBackend(manager) {
		_classCallCheck(this, TestBackend);

		this.actions = manager.getActions();
	}

	_createClass(TestBackend, [{
		key: 'setup',
		value: function setup() {
			this.didCallSetup = true;
		}
	}, {
		key: 'teardown',
		value: function teardown() {
			this.didCallTeardown = true;
		}
	}, {
		key: 'connectDragSource',
		value: function connectDragSource() {
			return _noop2.default;
		}
	}, {
		key: 'connectDragPreview',
		value: function connectDragPreview() {
			return _noop2.default;
		}
	}, {
		key: 'connectDropTarget',
		value: function connectDropTarget() {
			return _noop2.default;
		}
	}, {
		key: 'simulateBeginDrag',
		value: function simulateBeginDrag(sourceIds, options) {
			this.actions.beginDrag(sourceIds, options);
		}
	}, {
		key: 'simulatePublishDragSource',
		value: function simulatePublishDragSource() {
			this.actions.publishDragSource();
		}
	}, {
		key: 'simulateHover',
		value: function simulateHover(targetIds, options) {
			this.actions.hover(targetIds, options);
		}
	}, {
		key: 'simulateDrop',
		value: function simulateDrop() {
			this.actions.drop();
		}
	}, {
		key: 'simulateEndDrag',
		value: function simulateEndDrag() {
			this.actions.endDrag();
		}
	}]);

	return TestBackend;
}();

function createBackend(manager) {
	return new TestBackend(manager);
}

/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1230);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DragDropContext = __webpack_require__(1881);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This class is a React-Component based version of the DragDropContext.
 * This is an alternative to decorating an application component with an ES7 decorator.
 */
var DragDropContextProvider = (_temp = _class = function (_Component) {
  _inherits(DragDropContextProvider, _Component);

  function DragDropContextProvider(props, context) {
    _classCallCheck(this, DragDropContextProvider);

    var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));

    _this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
    return _this;
  }

  _createClass(DragDropContextProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _this2 = this;

      /**
       * This property determines which window global to use for creating the DragDropManager.
       * If a window has been injected explicitly via props, that is used first. If it is available
       * as a context value, then use that, otherwise use the browser global.
       */
      var getWindow = function getWindow() {
        if (_this2.props && _this2.props.window) {
          return _this2.props.window;
        } else if (_this2.context && _this2.context.window) {
          return _this2.context.window;
        } else if (typeof window !== 'undefined') {
          return window;
        }
        return undefined;
      };

      return (0, _DragDropContext.createChildContext)(this.backend, { window: getWindow() });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return DragDropContextProvider;
}(_react.Component), _class.propTypes = {
  backend: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]).isRequired,
  children: _propTypes2.default.element.isRequired,
  window: _propTypes2.default.object }, _class.defaultProps = {
  window: undefined
}, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
  window: _propTypes2.default.object
}, _temp);
exports.default = DragDropContextProvider;

/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = DragLayer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1230);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(503);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _isPlainObject = __webpack_require__(999);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _shallowEqual = __webpack_require__(1511);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _shallowEqualScalar = __webpack_require__(1897);

var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);

var _checkDecoratorArguments = __webpack_require__(1243);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function DragLayer(collect) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _checkDecoratorArguments2.default.apply(undefined, ['DragLayer', 'collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer ' + 'to be a function that collects props to inject into the component. ', 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);

  return function decorateLayer(DecoratedComponent) {
    var _class, _temp;

    var _options$arePropsEqua = options.arePropsEqual,
        arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;

    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

    var DragLayerContainer = (_temp = _class = function (_Component) {
      _inherits(DragLayerContainer, _Component);

      _createClass(DragLayerContainer, [{
        key: 'getDecoratedComponentInstance',
        value: function getDecoratedComponentInstance() {
          (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can ' + 'not be a stateless component.');
          return this.child;
        }
      }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
          return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
        }
      }]);

      function DragLayerContainer(props, context) {
        _classCallCheck(this, DragLayerContainer);

        var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);

        _this.manager = context.dragDropManager;
        (0, _invariant2.default)(_typeof(_this.manager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);

        _this.state = _this.getCurrentState();
        return _this;
      }

      _createClass(DragLayerContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.isCurrentlyMounted = true;

          var monitor = this.manager.getMonitor();
          this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
          this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);

          this.handleChange();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.isCurrentlyMounted = false;

          this.unsubscribeFromOffsetChange();
          this.unsubscribeFromStateChange();
        }
      }, {
        key: 'handleChange',
        value: function handleChange() {
          if (!this.isCurrentlyMounted) {
            return;
          }

          var nextState = this.getCurrentState();
          if (!(0, _shallowEqual2.default)(nextState, this.state)) {
            this.setState(nextState);
          }
        }
      }, {
        key: 'getCurrentState',
        value: function getCurrentState() {
          var monitor = this.manager.getMonitor();
          return collect(monitor);
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
            ref: function ref(child) {
              return _this2.child = child;
            }
          }));
        }
      }]);

      return DragLayerContainer;
    }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
      dragDropManager: _propTypes2.default.object.isRequired
    }, _temp);


    return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
  };
}

/***/ }),
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DragSource;

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(999);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _checkDecoratorArguments = __webpack_require__(1243);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

var _decorateHandler = __webpack_require__(1898);

var _decorateHandler2 = _interopRequireDefault(_decorateHandler);

var _registerSource = __webpack_require__(2916);

var _registerSource2 = _interopRequireDefault(_registerSource);

var _createSourceFactory = __webpack_require__(2917);

var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);

var _createSourceMonitor = __webpack_require__(2918);

var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);

var _createSourceConnector = __webpack_require__(2919);

var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);

var _isValidType = __webpack_require__(1901);

var _isValidType2 = _interopRequireDefault(_isValidType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DragSource(type, spec, collect) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  _checkDecoratorArguments2.default.apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
  var getType = type;
  if (typeof type !== 'function') {
    (0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
    getType = function getType() {
      return type;
    };
  }
  (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
  var createSource = (0, _createSourceFactory2.default)(spec);
  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);

  return function decorateSource(DecoratedComponent) {
    return (0, _decorateHandler2.default)({
      connectBackend: function connectBackend(backend, sourceId) {
        return backend.connectDragSource(sourceId);
      },
      containerDisplayName: 'DragSource',
      createHandler: createSource,
      registerHandler: _registerSource2.default,
      createMonitor: _createSourceMonitor2.default,
      createConnector: _createSourceConnector2.default,
      DecoratedComponent: DecoratedComponent,
      getType: getType,
      collect: collect,
      options: options
    });
  };
}

/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _isDisposable2 = __webpack_require__(1512);

var _isDisposable3 = _interopRequireDefault(_isDisposable2);

exports.isDisposable = _isDisposable3['default'];

var _Disposable2 = __webpack_require__(2913);

var _Disposable3 = _interopRequireDefault(_Disposable2);

exports.Disposable = _Disposable3['default'];

var _CompositeDisposable2 = __webpack_require__(2914);

var _CompositeDisposable3 = _interopRequireDefault(_CompositeDisposable2);

exports.CompositeDisposable = _CompositeDisposable3['default'];

var _SerialDisposable2 = __webpack_require__(2915);

var _SerialDisposable3 = _interopRequireDefault(_SerialDisposable2);

exports.SerialDisposable = _SerialDisposable3['default'];

/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var noop = function noop() {};

/**
 * The basic disposable.
 */

var Disposable = (function () {
  _createClass(Disposable, null, [{
    key: "empty",
    value: { dispose: noop },
    enumerable: true
  }]);

  function Disposable(action) {
    _classCallCheck(this, Disposable);

    this.isDisposed = false;
    this.action = action || noop;
  }

  Disposable.prototype.dispose = function dispose() {
    if (!this.isDisposed) {
      this.action.call(null);
      this.isDisposed = true;
    }
  };

  return Disposable;
})();

exports["default"] = Disposable;
module.exports = exports["default"];

/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _isDisposable = __webpack_require__(1512);

var _isDisposable2 = _interopRequireDefault(_isDisposable);

/**
 * Represents a group of disposable resources that are disposed together.
 */

var CompositeDisposable = (function () {
  function CompositeDisposable() {
    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
      disposables[_key] = arguments[_key];
    }

    _classCallCheck(this, CompositeDisposable);

    if (Array.isArray(disposables[0]) && disposables.length === 1) {
      disposables = disposables[0];
    }

    for (var i = 0; i < disposables.length; i++) {
      if (!_isDisposable2['default'](disposables[i])) {
        throw new Error('Expected a disposable');
      }
    }

    this.disposables = disposables;
    this.isDisposed = false;
  }

  /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Disposable} item Disposable to add.
   */

  CompositeDisposable.prototype.add = function add(item) {
    if (this.isDisposed) {
      item.dispose();
    } else {
      this.disposables.push(item);
    }
  };

  /**
   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
   * @param {Disposable} item Disposable to remove.
   * @returns {Boolean} true if found; false otherwise.
   */

  CompositeDisposable.prototype.remove = function remove(item) {
    if (this.isDisposed) {
      return false;
    }

    var index = this.disposables.indexOf(item);
    if (index === -1) {
      return false;
    }

    this.disposables.splice(index, 1);
    item.dispose();
    return true;
  };

  /**
   * Disposes all disposables in the group and removes them from the group.
   */

  CompositeDisposable.prototype.dispose = function dispose() {
    if (this.isDisposed) {
      return;
    }

    var len = this.disposables.length;
    var currentDisposables = new Array(len);
    for (var i = 0; i < len; i++) {
      currentDisposables[i] = this.disposables[i];
    }

    this.isDisposed = true;
    this.disposables = [];
    this.length = 0;

    for (var i = 0; i < len; i++) {
      currentDisposables[i].dispose();
    }
  };

  return CompositeDisposable;
})();

exports['default'] = CompositeDisposable;
module.exports = exports['default'];

/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _isDisposable = __webpack_require__(1512);

var _isDisposable2 = _interopRequireDefault(_isDisposable);

var SerialDisposable = (function () {
  function SerialDisposable() {
    _classCallCheck(this, SerialDisposable);

    this.isDisposed = false;
    this.current = null;
  }

  /**
   * Gets the underlying disposable.
   * @return The underlying disposable.
   */

  SerialDisposable.prototype.getDisposable = function getDisposable() {
    return this.current;
  };

  /**
   * Sets the underlying disposable.
   * @param {Disposable} value The new underlying disposable.
   */

  SerialDisposable.prototype.setDisposable = function setDisposable() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

    if (value != null && !_isDisposable2['default'](value)) {
      throw new Error('Expected either an empty value or a valid disposable');
    }

    var isDisposed = this.isDisposed;
    var previous = undefined;

    if (!isDisposed) {
      previous = this.current;
      this.current = value;
    }

    if (previous) {
      previous.dispose();
    }

    if (isDisposed && value) {
      value.dispose();
    }
  };

  /**
   * Disposes the underlying disposable as well as all future replacements.
   */

  SerialDisposable.prototype.dispose = function dispose() {
    if (this.isDisposed) {
      return;
    }

    this.isDisposed = true;
    var previous = this.current;
    this.current = null;

    if (previous) {
      previous.dispose();
    }
  };

  return SerialDisposable;
})();

exports['default'] = SerialDisposable;
module.exports = exports['default'];

/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = registerSource;
function registerSource(type, source, manager) {
  var registry = manager.getRegistry();
  var sourceId = registry.addSource(type, source);

  function unregisterSource() {
    registry.removeSource(sourceId);
  }

  return {
    handlerId: sourceId,
    unregister: unregisterSource
  };
}

/***/ }),
/* 2917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createSourceFactory;

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(999);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
var REQUIRED_SPEC_METHODS = ['beginDrag'];

function createSourceFactory(spec) {
  Object.keys(spec).forEach(function (key) {
    (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
  });
  REQUIRED_SPEC_METHODS.forEach(function (key) {
    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
  });

  var Source = function () {
    function Source(monitor) {
      _classCallCheck(this, Source);

      this.monitor = monitor;
      this.props = null;
      this.component = null;
    }

    _createClass(Source, [{
      key: 'receiveProps',
      value: function receiveProps(props) {
        this.props = props;
      }
    }, {
      key: 'receiveComponent',
      value: function receiveComponent(component) {
        this.component = component;
      }
    }, {
      key: 'canDrag',
      value: function canDrag() {
        if (!spec.canDrag) {
          return true;
        }

        return spec.canDrag(this.props, this.monitor);
      }
    }, {
      key: 'isDragging',
      value: function isDragging(globalMonitor, sourceId) {
        if (!spec.isDragging) {
          return sourceId === globalMonitor.getSourceId();
        }

        return spec.isDragging(this.props, this.monitor);
      }
    }, {
      key: 'beginDrag',
      value: function beginDrag() {
        var item = spec.beginDrag(this.props, this.monitor, this.component);
        if (false) {
          (0, _invariant2.default)((0, _isPlainObject2.default)(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', item);
        }
        return item;
      }
    }, {
      key: 'endDrag',
      value: function endDrag() {
        if (!spec.endDrag) {
          return;
        }

        spec.endDrag(this.props, this.monitor, this.component);
      }
    }]);

    return Source;
  }();

  return function createSource(monitor) {
    return new Source(monitor);
  };
}

/***/ }),
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createSourceMonitor;

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isCallingCanDrag = false;
var isCallingIsDragging = false;

var SourceMonitor = function () {
  function SourceMonitor(manager) {
    _classCallCheck(this, SourceMonitor);

    this.internalMonitor = manager.getMonitor();
  }

  _createClass(SourceMonitor, [{
    key: 'receiveHandlerId',
    value: function receiveHandlerId(sourceId) {
      this.sourceId = sourceId;
    }
  }, {
    key: 'canDrag',
    value: function canDrag() {
      (0, _invariant2.default)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');

      try {
        isCallingCanDrag = true;
        return this.internalMonitor.canDragSource(this.sourceId);
      } finally {
        isCallingCanDrag = false;
      }
    }
  }, {
    key: 'isDragging',
    value: function isDragging() {
      (0, _invariant2.default)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');

      try {
        isCallingIsDragging = true;
        return this.internalMonitor.isDraggingSource(this.sourceId);
      } finally {
        isCallingIsDragging = false;
      }
    }
  }, {
    key: 'getItemType',
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: 'getItem',
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: 'getDropResult',
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: 'didDrop',
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: 'getInitialClientOffset',
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: 'getInitialSourceClientOffset',
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: 'getSourceClientOffset',
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: 'getClientOffset',
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: 'getDifferenceFromInitialOffset',
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return SourceMonitor;
}();

function createSourceMonitor(manager) {
  return new SourceMonitor(manager);
}

/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSourceConnector;

var _wrapConnectorHooks = __webpack_require__(1899);

var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);

var _areOptionsEqual = __webpack_require__(1900);

var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createSourceConnector(backend) {
  var currentHandlerId = void 0;

  var currentDragSourceNode = void 0;
  var currentDragSourceOptions = void 0;
  var disconnectCurrentDragSource = void 0;

  var currentDragPreviewNode = void 0;
  var currentDragPreviewOptions = void 0;
  var disconnectCurrentDragPreview = void 0;

  function reconnectDragSource() {
    if (disconnectCurrentDragSource) {
      disconnectCurrentDragSource();
      disconnectCurrentDragSource = null;
    }

    if (currentHandlerId && currentDragSourceNode) {
      disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
    }
  }

  function reconnectDragPreview() {
    if (disconnectCurrentDragPreview) {
      disconnectCurrentDragPreview();
      disconnectCurrentDragPreview = null;
    }

    if (currentHandlerId && currentDragPreviewNode) {
      disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
    }
  }

  function receiveHandlerId(handlerId) {
    if (handlerId === currentHandlerId) {
      return;
    }

    currentHandlerId = handlerId;
    reconnectDragSource();
    reconnectDragPreview();
  }

  var hooks = (0, _wrapConnectorHooks2.default)({
    dragSource: function connectDragSource(node, options) {
      if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) {
        return;
      }

      currentDragSourceNode = node;
      currentDragSourceOptions = options;

      reconnectDragSource();
    },

    dragPreview: function connectDragPreview(node, options) {
      if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) {
        return;
      }

      currentDragPreviewNode = node;
      currentDragPreviewOptions = options;

      reconnectDragPreview();
    }
  });

  return {
    receiveHandlerId: receiveHandlerId,
    hooks: hooks
  };
}

/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cloneWithRef;

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cloneWithRef(element, newRef) {
  var previousRef = element.ref;
  (0, _invariant2.default)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');

  if (!previousRef) {
    // When there is no ref on the element, use the new ref directly
    return (0, _react.cloneElement)(element, {
      ref: newRef
    });
  }

  return (0, _react.cloneElement)(element, {
    ref: function ref(node) {
      newRef(node);

      if (previousRef) {
        previousRef(node);
      }
    }
  });
}

/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DropTarget;

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(999);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _checkDecoratorArguments = __webpack_require__(1243);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

var _decorateHandler = __webpack_require__(1898);

var _decorateHandler2 = _interopRequireDefault(_decorateHandler);

var _registerTarget = __webpack_require__(2922);

var _registerTarget2 = _interopRequireDefault(_registerTarget);

var _createTargetFactory = __webpack_require__(2923);

var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);

var _createTargetMonitor = __webpack_require__(2924);

var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);

var _createTargetConnector = __webpack_require__(2925);

var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);

var _isValidType = __webpack_require__(1901);

var _isValidType2 = _interopRequireDefault(_isValidType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropTarget(type, spec, collect) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  _checkDecoratorArguments2.default.apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
  var getType = type;
  if (typeof type !== 'function') {
    (0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
    getType = function getType() {
      return type;
    };
  }
  (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
  var createTarget = (0, _createTargetFactory2.default)(spec);
  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);

  return function decorateTarget(DecoratedComponent) {
    return (0, _decorateHandler2.default)({
      connectBackend: function connectBackend(backend, targetId) {
        return backend.connectDropTarget(targetId);
      },
      containerDisplayName: 'DropTarget',
      createHandler: createTarget,
      registerHandler: _registerTarget2.default,
      createMonitor: _createTargetMonitor2.default,
      createConnector: _createTargetConnector2.default,
      DecoratedComponent: DecoratedComponent,
      getType: getType,
      collect: collect,
      options: options
    });
  };
}

/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = registerTarget;
function registerTarget(type, target, manager) {
  var registry = manager.getRegistry();
  var targetId = registry.addTarget(type, target);

  function unregisterTarget() {
    registry.removeTarget(targetId);
  }

  return {
    handlerId: targetId,
    unregister: unregisterTarget
  };
}

/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createTargetFactory;

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(999);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];

function createTargetFactory(spec) {
  Object.keys(spec).forEach(function (key) {
    (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
  });

  var Target = function () {
    function Target(monitor) {
      _classCallCheck(this, Target);

      this.monitor = monitor;
      this.props = null;
      this.component = null;
    }

    _createClass(Target, [{
      key: 'receiveProps',
      value: function receiveProps(props) {
        this.props = props;
      }
    }, {
      key: 'receiveMonitor',
      value: function receiveMonitor(monitor) {
        this.monitor = monitor;
      }
    }, {
      key: 'receiveComponent',
      value: function receiveComponent(component) {
        this.component = component;
      }
    }, {
      key: 'canDrop',
      value: function canDrop() {
        if (!spec.canDrop) {
          return true;
        }

        return spec.canDrop(this.props, this.monitor);
      }
    }, {
      key: 'hover',
      value: function hover() {
        if (!spec.hover) {
          return;
        }

        spec.hover(this.props, this.monitor, this.component);
      }
    }, {
      key: 'drop',
      value: function drop() {
        if (!spec.drop) {
          return undefined;
        }

        var dropResult = spec.drop(this.props, this.monitor, this.component);
        if (false) {
          (0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isPlainObject2.default)(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', dropResult);
        }
        return dropResult;
      }
    }]);

    return Target;
  }();

  return function createTarget(monitor) {
    return new Target(monitor);
  };
}

/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createTargetMonitor;

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isCallingCanDrop = false;

var TargetMonitor = function () {
  function TargetMonitor(manager) {
    _classCallCheck(this, TargetMonitor);

    this.internalMonitor = manager.getMonitor();
  }

  _createClass(TargetMonitor, [{
    key: 'receiveHandlerId',
    value: function receiveHandlerId(targetId) {
      this.targetId = targetId;
    }
  }, {
    key: 'canDrop',
    value: function canDrop() {
      (0, _invariant2.default)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');

      try {
        isCallingCanDrop = true;
        return this.internalMonitor.canDropOnTarget(this.targetId);
      } finally {
        isCallingCanDrop = false;
      }
    }
  }, {
    key: 'isOver',
    value: function isOver(options) {
      return this.internalMonitor.isOverTarget(this.targetId, options);
    }
  }, {
    key: 'getItemType',
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: 'getItem',
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: 'getDropResult',
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: 'didDrop',
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: 'getInitialClientOffset',
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: 'getInitialSourceClientOffset',
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: 'getSourceClientOffset',
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: 'getClientOffset',
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: 'getDifferenceFromInitialOffset',
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return TargetMonitor;
}();

function createTargetMonitor(manager) {
  return new TargetMonitor(manager);
}

/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTargetConnector;

var _wrapConnectorHooks = __webpack_require__(1899);

var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);

var _areOptionsEqual = __webpack_require__(1900);

var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTargetConnector(backend) {
  var currentHandlerId = void 0;

  var currentDropTargetNode = void 0;
  var currentDropTargetOptions = void 0;
  var disconnectCurrentDropTarget = void 0;

  function reconnectDropTarget() {
    if (disconnectCurrentDropTarget) {
      disconnectCurrentDropTarget();
      disconnectCurrentDropTarget = null;
    }

    if (currentHandlerId && currentDropTargetNode) {
      disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
    }
  }

  function receiveHandlerId(handlerId) {
    if (handlerId === currentHandlerId) {
      return;
    }

    currentHandlerId = handlerId;
    reconnectDropTarget();
  }

  var hooks = (0, _wrapConnectorHooks2.default)({
    dropTarget: function connectDropTarget(node, options) {
      if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) {
        return;
      }

      currentDropTargetNode = node;
      currentDropTargetOptions = options;

      reconnectDropTarget();
    }
  });

  return {
    receiveHandlerId: receiveHandlerId,
    hooks: hooks
  };
}

/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _defaults = __webpack_require__(2927);

var _defaults2 = _interopRequireDefault(_defaults);

var _shallowEqual = __webpack_require__(2935);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _EnterLeaveCounter = __webpack_require__(2936);

var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);

var _BrowserDetector = __webpack_require__(1907);

var _OffsetUtils = __webpack_require__(2938);

var _NativeDragSources = __webpack_require__(2940);

var _NativeTypes = __webpack_require__(1514);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HTML5Backend = function () {
  function HTML5Backend(manager) {
    _classCallCheck(this, HTML5Backend);

    this.actions = manager.getActions();
    this.monitor = manager.getMonitor();
    this.registry = manager.getRegistry();
    this.context = manager.getContext();

    this.sourcePreviewNodes = {};
    this.sourcePreviewNodeOptions = {};
    this.sourceNodes = {};
    this.sourceNodeOptions = {};
    this.enterLeaveCounter = new _EnterLeaveCounter2.default();

    this.dragStartSourceIds = [];
    this.dropTargetIds = [];
    this.dragEnterTargetIds = [];
    this.currentNativeSource = null;
    this.currentNativeHandle = null;
    this.currentDragSourceNode = null;
    this.currentDragSourceNodeOffset = null;
    this.currentDragSourceNodeOffsetChanged = false;
    this.altKeyPressed = false;

    this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
    this.handleTopDragStart = this.handleTopDragStart.bind(this);
    this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
    this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
    this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
    this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
    this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
    this.handleTopDragOver = this.handleTopDragOver.bind(this);
    this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
    this.handleTopDrop = this.handleTopDrop.bind(this);
    this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
    this.handleSelectStart = this.handleSelectStart.bind(this);
    this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
    this.endDragNativeItem = this.endDragNativeItem.bind(this);
    this.asyncEndDragNativeItem = this.asyncEndDragNativeItem.bind(this);
  }

  _createClass(HTML5Backend, [{
    key: 'setup',
    value: function setup() {
      if (this.window === undefined) {
        return;
      }

      if (this.window.__isReactDndBackendSetUp) {
        // eslint-disable-line no-underscore-dangle
        throw new Error('Cannot have two HTML5 backends at the same time.');
      }
      this.window.__isReactDndBackendSetUp = true; // eslint-disable-line no-underscore-dangle
      this.addEventListeners(this.window);
    }
  }, {
    key: 'teardown',
    value: function teardown() {
      if (this.window === undefined) {
        return;
      }

      this.window.__isReactDndBackendSetUp = false; // eslint-disable-line no-underscore-dangle
      this.removeEventListeners(this.window);
      this.clearCurrentDragSourceNode();
      if (this.asyncEndDragFrameId) {
        this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
      }
    }
  }, {
    key: 'addEventListeners',
    value: function addEventListeners(target) {
      target.addEventListener('dragstart', this.handleTopDragStart);
      target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
      target.addEventListener('dragend', this.handleTopDragEndCapture, true);
      target.addEventListener('dragenter', this.handleTopDragEnter);
      target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
      target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
      target.addEventListener('dragover', this.handleTopDragOver);
      target.addEventListener('dragover', this.handleTopDragOverCapture, true);
      target.addEventListener('drop', this.handleTopDrop);
      target.addEventListener('drop', this.handleTopDropCapture, true);
    }
  }, {
    key: 'removeEventListeners',
    value: function removeEventListeners(target) {
      target.removeEventListener('dragstart', this.handleTopDragStart);
      target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
      target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
      target.removeEventListener('dragenter', this.handleTopDragEnter);
      target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
      target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
      target.removeEventListener('dragover', this.handleTopDragOver);
      target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
      target.removeEventListener('drop', this.handleTopDrop);
      target.removeEventListener('drop', this.handleTopDropCapture, true);
    }
  }, {
    key: 'connectDragPreview',
    value: function connectDragPreview(sourceId, node, options) {
      var _this = this;

      this.sourcePreviewNodeOptions[sourceId] = options;
      this.sourcePreviewNodes[sourceId] = node;

      return function () {
        delete _this.sourcePreviewNodes[sourceId];
        delete _this.sourcePreviewNodeOptions[sourceId];
      };
    }
  }, {
    key: 'connectDragSource',
    value: function connectDragSource(sourceId, node, options) {
      var _this2 = this;

      this.sourceNodes[sourceId] = node;
      this.sourceNodeOptions[sourceId] = options;

      var handleDragStart = function handleDragStart(e) {
        return _this2.handleDragStart(e, sourceId);
      };
      var handleSelectStart = function handleSelectStart(e) {
        return _this2.handleSelectStart(e, sourceId);
      };

      node.setAttribute('draggable', true);
      node.addEventListener('dragstart', handleDragStart);
      node.addEventListener('selectstart', handleSelectStart);

      return function () {
        delete _this2.sourceNodes[sourceId];
        delete _this2.sourceNodeOptions[sourceId];

        node.removeEventListener('dragstart', handleDragStart);
        node.removeEventListener('selectstart', handleSelectStart);
        node.setAttribute('draggable', false);
      };
    }
  }, {
    key: 'connectDropTarget',
    value: function connectDropTarget(targetId, node) {
      var _this3 = this;

      var handleDragEnter = function handleDragEnter(e) {
        return _this3.handleDragEnter(e, targetId);
      };
      var handleDragOver = function handleDragOver(e) {
        return _this3.handleDragOver(e, targetId);
      };
      var handleDrop = function handleDrop(e) {
        return _this3.handleDrop(e, targetId);
      };

      node.addEventListener('dragenter', handleDragEnter);
      node.addEventListener('dragover', handleDragOver);
      node.addEventListener('drop', handleDrop);

      return function () {
        node.removeEventListener('dragenter', handleDragEnter);
        node.removeEventListener('dragover', handleDragOver);
        node.removeEventListener('drop', handleDrop);
      };
    }
  }, {
    key: 'getCurrentSourceNodeOptions',
    value: function getCurrentSourceNodeOptions() {
      var sourceId = this.monitor.getSourceId();
      var sourceNodeOptions = this.sourceNodeOptions[sourceId];

      return (0, _defaults2.default)(sourceNodeOptions || {}, {
        dropEffect: this.altKeyPressed ? 'copy' : 'move'
      });
    }
  }, {
    key: 'getCurrentDropEffect',
    value: function getCurrentDropEffect() {
      if (this.isDraggingNativeItem()) {
        // It makes more sense to default to 'copy' for native resources
        return 'copy';
      }

      return this.getCurrentSourceNodeOptions().dropEffect;
    }
  }, {
    key: 'getCurrentSourcePreviewNodeOptions',
    value: function getCurrentSourcePreviewNodeOptions() {
      var sourceId = this.monitor.getSourceId();
      var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];

      return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
        anchorX: 0.5,
        anchorY: 0.5,
        captureDraggingState: false
      });
    }
  }, {
    key: 'getSourceClientOffset',
    value: function getSourceClientOffset(sourceId) {
      return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
    }
  }, {
    key: 'isDraggingNativeItem',
    value: function isDraggingNativeItem() {
      var itemType = this.monitor.getItemType();
      return Object.keys(NativeTypes).some(function (key) {
        return NativeTypes[key] === itemType;
      });
    }
  }, {
    key: 'beginDragNativeItem',
    value: function beginDragNativeItem(type) {
      this.clearCurrentDragSourceNode();

      var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
      this.currentNativeSource = new SourceType();
      this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
      this.actions.beginDrag([this.currentNativeHandle]);

      // On Firefox, if mouseover fires, the drag is over but browser failed to tell us.
      // See https://bugzilla.mozilla.org/show_bug.cgi?id=656164
      // This is not true for other browsers.
      if ((0, _BrowserDetector.isFirefox)()) {
        this.window.addEventListener('mouseover', this.asyncEndDragNativeItem, true);
      }
    }
  }, {
    key: 'asyncEndDragNativeItem',
    value: function asyncEndDragNativeItem() {
      this.asyncEndDragFrameId = this.window.requestAnimationFrame(this.endDragNativeItem);
      if ((0, _BrowserDetector.isFirefox)()) {
        this.window.removeEventListener('mouseover', this.asyncEndDragNativeItem, true);
        this.enterLeaveCounter.reset();
      }
    }
  }, {
    key: 'endDragNativeItem',
    value: function endDragNativeItem() {
      if (!this.isDraggingNativeItem()) {
        return;
      }

      this.actions.endDrag();
      this.registry.removeSource(this.currentNativeHandle);
      this.currentNativeHandle = null;
      this.currentNativeSource = null;
    }
  }, {
    key: 'endDragIfSourceWasRemovedFromDOM',
    value: function endDragIfSourceWasRemovedFromDOM() {
      var node = this.currentDragSourceNode;
      if (document.body.contains(node)) {
        return;
      }

      if (this.clearCurrentDragSourceNode()) {
        this.actions.endDrag();
      }
    }
  }, {
    key: 'setCurrentDragSourceNode',
    value: function setCurrentDragSourceNode(node) {
      this.clearCurrentDragSourceNode();
      this.currentDragSourceNode = node;
      this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
      this.currentDragSourceNodeOffsetChanged = false;

      // Receiving a mouse event in the middle of a dragging operation
      // means it has ended and the drag source node disappeared from DOM,
      // so the browser didn't dispatch the dragend event.
      this.window.addEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
    }
  }, {
    key: 'clearCurrentDragSourceNode',
    value: function clearCurrentDragSourceNode() {
      if (this.currentDragSourceNode) {
        this.currentDragSourceNode = null;
        this.currentDragSourceNodeOffset = null;
        this.currentDragSourceNodeOffsetChanged = false;
        this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
        return true;
      }

      return false;
    }
  }, {
    key: 'checkIfCurrentDragSourceRectChanged',
    value: function checkIfCurrentDragSourceRectChanged() {
      var node = this.currentDragSourceNode;
      if (!node) {
        return false;
      }

      if (this.currentDragSourceNodeOffsetChanged) {
        return true;
      }

      this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);

      return this.currentDragSourceNodeOffsetChanged;
    }
  }, {
    key: 'handleTopDragStartCapture',
    value: function handleTopDragStartCapture() {
      this.clearCurrentDragSourceNode();
      this.dragStartSourceIds = [];
    }
  }, {
    key: 'handleDragStart',
    value: function handleDragStart(e, sourceId) {
      this.dragStartSourceIds.unshift(sourceId);
    }
  }, {
    key: 'handleTopDragStart',
    value: function handleTopDragStart(e) {
      var _this4 = this;

      var dragStartSourceIds = this.dragStartSourceIds;

      this.dragStartSourceIds = null;

      var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);

      // Don't publish the source just yet (see why below)
      this.actions.beginDrag(dragStartSourceIds, {
        publishSource: false,
        getSourceClientOffset: this.getSourceClientOffset,
        clientOffset: clientOffset
      });

      var dataTransfer = e.dataTransfer;

      var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);

      if (this.monitor.isDragging()) {
        if (typeof dataTransfer.setDragImage === 'function') {
          // Use custom drag image if user specifies it.
          // If child drag source refuses drag but parent agrees,
          // use parent's node as drag image. Neither works in IE though.
          var sourceId = this.monitor.getSourceId();
          var sourceNode = this.sourceNodes[sourceId];
          var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;

          var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(),
              anchorX = _getCurrentSourcePrev.anchorX,
              anchorY = _getCurrentSourcePrev.anchorY;

          var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
          var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint);
          dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
        }

        try {
          // Firefox won't drag without setting data
          dataTransfer.setData('application/json', {});
        } catch (err) {}
        // IE doesn't support MIME types in setData


        // Store drag source node so we can check whether
        // it is removed from DOM and trigger endDrag manually.
        this.setCurrentDragSourceNode(e.target);

        // Now we are ready to publish the drag source.. or are we not?

        var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(),
            captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;

        if (!captureDraggingState) {
          // Usually we want to publish it in the next tick so that browser
          // is able to screenshot the current (not yet dragging) state.
          //
          // It also neatly avoids a situation where render() returns null
          // in the same tick for the source element, and browser freaks out.
          setTimeout(function () {
            return _this4.actions.publishDragSource();
          });
        } else {
          // In some cases the user may want to override this behavior, e.g.
          // to work around IE not supporting custom drag previews.
          //
          // When using a custom drag layer, the only way to prevent
          // the default drag preview from drawing in IE is to screenshot
          // the dragging state in which the node itself has zero opacity
          // and height. In this case, though, returning null from render()
          // will abruptly end the dragging, which is not obvious.
          //
          // This is the reason such behavior is strictly opt-in.
          this.actions.publishDragSource();
        }
      } else if (nativeType) {
        // A native item (such as URL) dragged from inside the document
        this.beginDragNativeItem(nativeType);
      } else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
        // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
        // Just let it drag. It's a native type (URL or text) and will be picked up in
        // dragenter handler.
        return; // eslint-disable-line no-useless-return
      } else {
        // If by this time no drag source reacted, tell browser not to drag.
        e.preventDefault();
      }
    }
  }, {
    key: 'handleTopDragEndCapture',
    value: function handleTopDragEndCapture() {
      if (this.clearCurrentDragSourceNode()) {
        // Firefox can dispatch this event in an infinite loop
        // if dragend handler does something like showing an alert.
        // Only proceed if we have not handled it already.
        this.actions.endDrag();
      }
    }
  }, {
    key: 'handleTopDragEnterCapture',
    value: function handleTopDragEnterCapture(e) {
      this.dragEnterTargetIds = [];

      var isFirstEnter = this.enterLeaveCounter.enter(e.target);
      if (!isFirstEnter || this.monitor.isDragging()) {
        return;
      }

      var dataTransfer = e.dataTransfer;

      var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);

      if (nativeType) {
        // A native item (such as file or URL) dragged from outside the document
        this.beginDragNativeItem(nativeType);
      }
    }
  }, {
    key: 'handleDragEnter',
    value: function handleDragEnter(e, targetId) {
      this.dragEnterTargetIds.unshift(targetId);
    }
  }, {
    key: 'handleTopDragEnter',
    value: function handleTopDragEnter(e) {
      var _this5 = this;

      var dragEnterTargetIds = this.dragEnterTargetIds;

      this.dragEnterTargetIds = [];

      if (!this.monitor.isDragging()) {
        // This is probably a native item type we don't understand.
        return;
      }

      this.altKeyPressed = e.altKey;

      if (!(0, _BrowserDetector.isFirefox)()) {
        // Don't emit hover in `dragenter` on Firefox due to an edge case.
        // If the target changes position as the result of `dragenter`, Firefox
        // will still happily dispatch `dragover` despite target being no longer
        // there. The easy solution is to only fire `hover` in `dragover` on FF.
        this.actions.hover(dragEnterTargetIds, {
          clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
        });
      }

      var canDrop = dragEnterTargetIds.some(function (targetId) {
        return _this5.monitor.canDropOnTarget(targetId);
      });

      if (canDrop) {
        // IE requires this to fire dragover events
        e.preventDefault();
        e.dataTransfer.dropEffect = this.getCurrentDropEffect();
      }
    }
  }, {
    key: 'handleTopDragOverCapture',
    value: function handleTopDragOverCapture() {
      this.dragOverTargetIds = [];
    }
  }, {
    key: 'handleDragOver',
    value: function handleDragOver(e, targetId) {
      this.dragOverTargetIds.unshift(targetId);
    }
  }, {
    key: 'handleTopDragOver',
    value: function handleTopDragOver(e) {
      var _this6 = this;

      var dragOverTargetIds = this.dragOverTargetIds;

      this.dragOverTargetIds = [];

      if (!this.monitor.isDragging()) {
        // This is probably a native item type we don't understand.
        // Prevent default "drop and blow away the whole document" action.
        e.preventDefault();
        e.dataTransfer.dropEffect = 'none';
        return;
      }

      this.altKeyPressed = e.altKey;

      this.actions.hover(dragOverTargetIds, {
        clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
      });

      var canDrop = dragOverTargetIds.some(function (targetId) {
        return _this6.monitor.canDropOnTarget(targetId);
      });

      if (canDrop) {
        // Show user-specified drop effect.
        e.preventDefault();
        e.dataTransfer.dropEffect = this.getCurrentDropEffect();
      } else if (this.isDraggingNativeItem()) {
        // Don't show a nice cursor but still prevent default
        // "drop and blow away the whole document" action.
        e.preventDefault();
        e.dataTransfer.dropEffect = 'none';
      } else if (this.checkIfCurrentDragSourceRectChanged()) {
        // Prevent animating to incorrect position.
        // Drop effect must be other than 'none' to prevent animation.
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
      }
    }
  }, {
    key: 'handleTopDragLeaveCapture',
    value: function handleTopDragLeaveCapture(e) {
      if (this.isDraggingNativeItem()) {
        e.preventDefault();
      }

      var isLastLeave = this.enterLeaveCounter.leave(e.target);
      if (!isLastLeave) {
        return;
      }

      if (this.isDraggingNativeItem()) {
        this.endDragNativeItem();
      }
    }
  }, {
    key: 'handleTopDropCapture',
    value: function handleTopDropCapture(e) {
      this.dropTargetIds = [];
      e.preventDefault();

      if (this.isDraggingNativeItem()) {
        this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
      }

      this.enterLeaveCounter.reset();
    }
  }, {
    key: 'handleDrop',
    value: function handleDrop(e, targetId) {
      this.dropTargetIds.unshift(targetId);
    }
  }, {
    key: 'handleTopDrop',
    value: function handleTopDrop(e) {
      var dropTargetIds = this.dropTargetIds;

      this.dropTargetIds = [];

      this.actions.hover(dropTargetIds, {
        clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
      });
      this.actions.drop({ dropEffect: this.getCurrentDropEffect() });

      if (this.isDraggingNativeItem()) {
        this.endDragNativeItem();
      } else {
        this.endDragIfSourceWasRemovedFromDOM();
      }
    }
  }, {
    key: 'handleSelectStart',
    value: function handleSelectStart(e) {
      var target = e.target;

      // Only IE requires us to explicitly say
      // we want drag drop operation to start

      if (typeof target.dragDrop !== 'function') {
        return;
      }

      // Inputs and textareas should be selectable
      if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return;
      }

      // For other targets, ask IE
      // to enable drag and drop
      e.preventDefault();
      target.dragDrop();
    }
  }, {
    key: 'window',
    get: function get() {
      if (this.context && this.context.window) {
        return this.context.window;
      } else if (typeof window !== 'undefined') {
        return window;
      }
      return undefined;
    }
  }]);

  return HTML5Backend;
}();

exports.default = HTML5Backend;

/***/ }),
/* 2927 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(875),
    eq = __webpack_require__(1133),
    isIterateeCall = __webpack_require__(1903),
    keysIn = __webpack_require__(2928);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;


/***/ }),
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1904),
    baseKeysIn = __webpack_require__(2933),
    isArrayLike = __webpack_require__(1053);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 2929 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 2930 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(1051),
    isLength = __webpack_require__(1507),
    isObjectLike = __webpack_require__(874);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(1882);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)(module)))

/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(735),
    isPrototype = __webpack_require__(1513),
    nativeKeysIn = __webpack_require__(2934);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 2934 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 2935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shallowEqual;
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i += 1) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }

    var valA = objA[keysA[i]];
    var valB = objB[keysA[i]];

    if (valA !== valB) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _union = __webpack_require__(2937);

var _union2 = _interopRequireDefault(_union);

var _without = __webpack_require__(1886);

var _without2 = _interopRequireDefault(_without);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EnterLeaveCounter = function () {
  function EnterLeaveCounter() {
    _classCallCheck(this, EnterLeaveCounter);

    this.entered = [];
  }

  _createClass(EnterLeaveCounter, [{
    key: 'enter',
    value: function enter(enteringNode) {
      var previousLength = this.entered.length;

      var isNodeEntered = function isNodeEntered(node) {
        return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
      };

      this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);

      return previousLength === 0 && this.entered.length > 0;
    }
  }, {
    key: 'leave',
    value: function leave(leavingNode) {
      var previousLength = this.entered.length;

      this.entered = (0, _without2.default)(this.entered.filter(function (node) {
        return document.documentElement.contains(node);
      }), leavingNode);

      return previousLength > 0 && this.entered.length === 0;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.entered = [];
    }
  }]);

  return EnterLeaveCounter;
}();

exports.default = EnterLeaveCounter;

/***/ }),
/* 2937 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(1508),
    baseRest = __webpack_require__(875),
    baseUniq = __webpack_require__(1895),
    isArrayLikeObject = __webpack_require__(1240);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNodeClientOffset = getNodeClientOffset;
exports.getEventClientOffset = getEventClientOffset;
exports.getDragPreviewOffset = getDragPreviewOffset;

var _BrowserDetector = __webpack_require__(1907);

var _MonotonicInterpolant = __webpack_require__(2939);

var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint
   no-mixed-operators: off
*/
var ELEMENT_NODE = 1;

function getNodeClientOffset(node) {
  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

  if (!el) {
    return null;
  }

  var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      left = _el$getBoundingClient.left;

  return { x: left, y: top };
}

function getEventClientOffset(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}

function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint) {
  // The browsers will use the image intrinsic size under different conditions.
  // Firefox only cares if it's an image, but WebKit also wants it to be detached.
  var isImage = dragPreview.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(dragPreview));
  var dragPreviewNode = isImage ? sourceNode : dragPreview;

  var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
  var offsetFromDragPreview = {
    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
  };

  var sourceWidth = sourceNode.offsetWidth,
      sourceHeight = sourceNode.offsetHeight;
  var anchorX = anchorPoint.anchorX,
      anchorY = anchorPoint.anchorY;


  var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
  var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;

  // Work around @2x coordinate discrepancies in browsers
  if ((0, _BrowserDetector.isSafari)() && isImage) {
    dragPreviewHeight /= window.devicePixelRatio;
    dragPreviewWidth /= window.devicePixelRatio;
  }

  // Interpolate coordinates depending on anchor point
  // If you know a simpler way to do this, let me know
  var interpolantX = new _MonotonicInterpolant2.default([0, 0.5, 1], [
  // Dock to the left
  offsetFromDragPreview.x,
  // Align at the center
  offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
  // Dock to the right
  offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
  var interpolantY = new _MonotonicInterpolant2.default([0, 0.5, 1], [
  // Dock to the top
  offsetFromDragPreview.y,
  // Align at the center
  offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
  // Dock to the bottom
  offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
  var x = interpolantX.interpolate(anchorX);
  var y = interpolantY.interpolate(anchorY);

  // Work around Safari 8 positioning bug
  if ((0, _BrowserDetector.isSafari)() && isImage) {
    // We'll have to wait for @3x to see if this is entirely correct
    y += (window.devicePixelRatio - 1) * dragPreviewHeight;
  }

  return { x: x, y: y };
}

/***/ }),
/* 2939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint
   no-plusplus: off,
   no-mixed-operators: off
*/
var MonotonicInterpolant = function () {
  function MonotonicInterpolant(xs, ys) {
    _classCallCheck(this, MonotonicInterpolant);

    var length = xs.length;

    // Rearrange xs and ys so that xs is sorted
    var indexes = [];
    for (var i = 0; i < length; i++) {
      indexes.push(i);
    }
    indexes.sort(function (a, b) {
      return xs[a] < xs[b] ? -1 : 1;
    });

    // Get consecutive differences and slopes
    var dys = [];
    var dxs = [];
    var ms = [];
    var dx = void 0;
    var dy = void 0;
    for (var _i = 0; _i < length - 1; _i++) {
      dx = xs[_i + 1] - xs[_i];
      dy = ys[_i + 1] - ys[_i];
      dxs.push(dx);
      dys.push(dy);
      ms.push(dy / dx);
    }

    // Get degree-1 coefficients
    var c1s = [ms[0]];
    for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
      var _m = ms[_i2];
      var mNext = ms[_i2 + 1];
      if (_m * mNext <= 0) {
        c1s.push(0);
      } else {
        dx = dxs[_i2];
        var dxNext = dxs[_i2 + 1];
        var common = dx + dxNext;
        c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
      }
    }
    c1s.push(ms[ms.length - 1]);

    // Get degree-2 and degree-3 coefficients
    var c2s = [];
    var c3s = [];
    var m = void 0;
    for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
      m = ms[_i3];
      var c1 = c1s[_i3];
      var invDx = 1 / dxs[_i3];
      var _common = c1 + c1s[_i3 + 1] - m - m;
      c2s.push((m - c1 - _common) * invDx);
      c3s.push(_common * invDx * invDx);
    }

    this.xs = xs;
    this.ys = ys;
    this.c1s = c1s;
    this.c2s = c2s;
    this.c3s = c3s;
  }

  _createClass(MonotonicInterpolant, [{
    key: "interpolate",
    value: function interpolate(x) {
      var xs = this.xs,
          ys = this.ys,
          c1s = this.c1s,
          c2s = this.c2s,
          c3s = this.c3s;

      // The rightmost point in the dataset should give an exact result

      var i = xs.length - 1;
      if (x === xs[i]) {
        return ys[i];
      }

      // Search for the interval x is in, returning the corresponding y if x is one of the original xs
      var low = 0;
      var high = c3s.length - 1;
      var mid = void 0;
      while (low <= high) {
        mid = Math.floor(0.5 * (low + high));
        var xHere = xs[mid];
        if (xHere < x) {
          low = mid + 1;
        } else if (xHere > x) {
          high = mid - 1;
        } else {
          return ys[mid];
        }
      }
      i = Math.max(0, high);

      // Interpolate
      var diff = x - xs[i];
      var diffSq = diff * diff;
      return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
  }]);

  return MonotonicInterpolant;
}();

exports.default = MonotonicInterpolant;

/***/ }),
/* 2940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _nativeTypesConfig;

exports.createNativeDragSource = createNativeDragSource;
exports.matchNativeItemType = matchNativeItemType;

var _NativeTypes = __webpack_require__(1514);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
  var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
    return resultSoFar || dataTransfer.getData(typeToTry);
  }, null);

  return result != null ? // eslint-disable-line eqeqeq
  result : defaultValue;
}

var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
  exposeProperty: 'files',
  matchesTypes: ['Files'],
  getData: function getData(dataTransfer) {
    return Array.prototype.slice.call(dataTransfer.files);
  }
}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
  exposeProperty: 'urls',
  matchesTypes: ['Url', 'text/uri-list'],
  getData: function getData(dataTransfer, matchesTypes) {
    return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
  }
}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
  exposeProperty: 'text',
  matchesTypes: ['Text', 'text/plain'],
  getData: function getData(dataTransfer, matchesTypes) {
    return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
  }
}), _nativeTypesConfig);

function createNativeDragSource(type) {
  var _nativeTypesConfig$ty = nativeTypesConfig[type],
      exposeProperty = _nativeTypesConfig$ty.exposeProperty,
      matchesTypes = _nativeTypesConfig$ty.matchesTypes,
      getData = _nativeTypesConfig$ty.getData;


  return function () {
    function NativeDragSource() {
      var _item, _mutatorMap;

      _classCallCheck(this, NativeDragSource);

      this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function () {
        console.warn( // eslint-disable-line no-console
        'Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
        return null;
      }, _defineEnumerableProperties(_item, _mutatorMap), _item);
    }

    _createClass(NativeDragSource, [{
      key: 'mutateItemByReadingDataTransfer',
      value: function mutateItemByReadingDataTransfer(dataTransfer) {
        delete this.item[exposeProperty];
        this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
      }
    }, {
      key: 'canDrag',
      value: function canDrag() {
        return true;
      }
    }, {
      key: 'beginDrag',
      value: function beginDrag() {
        return this.item;
      }
    }, {
      key: 'isDragging',
      value: function isDragging(monitor, handle) {
        return handle === monitor.getSourceId();
      }
    }, {
      key: 'endDrag',
      value: function endDrag() {}
    }]);

    return NativeDragSource;
  }();
}

function matchNativeItemType(dataTransfer) {
  var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);

  return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
    var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;

    return matchesTypes.some(function (t) {
      return dataTransferTypes.indexOf(t) > -1;
    });
  })[0] || null;
}

/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getEmptyImage;
var emptyImage = void 0;
function getEmptyImage() {
  if (!emptyImage) {
    emptyImage = new Image();
    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  }

  return emptyImage;
}

/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var forExample = {
  seasonName: {
    label: 'Season Name',
    example: 'Peak/High Season',
    shorthand: 'Peak'
  },
  rateSetName: {
    label: 'Rate Set Name',
    example: 'Nightly Midweek',
    shorthand: 'Midweek'
  },
  minMaxStay: {
    label: 'Min/Max Stay',
    example: '2 - 4 Nights',
    shorthand: '2-4Nts'
  },
  stayPay: {
    label: 'Stay X Pay Y',
    example: 'Stay 3 Pay 2',
    shorthand: 'S3P2'
  },
  daysOfWeek: {
    label: 'Days of The Week',
    example: 'Mon - Wed',
    shorthand: 'M-W'
  },
  rateSetCode: {
    label: 'Rate Set / Booking Code',
    example: 'DKFUE23',
    shorthand: 'DKFUE23'
  }
};

var Example = function Example(_ref) {
  var rule = _ref.rule,
      combinable = _ref.combinable,
      limit = _ref.limit;

  var getShorthand = function getShorthand(_ref2) {
    var field = _ref2.field;
    return _ramda2.default.pathOr('', [field, 'shorthand'], forExample);
  };
  return _react2.default.createElement(
    'div',
    null,
    _ramda2.default.call(_ramda2.default.compose(_ramda2.default.addIndex(_ramda2.default.map)(function (ele, index) {
      return _react2.default.createElement(
        'div',
        { key: index },
        _react2.default.createElement(
          'div',
          { style: { width: '50%', display: 'inline-block' } },
          ele.label,
          ':'
        ),
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '16px', display: 'inline-block' } },
          ele.example
        )
      );
    }), _ramda2.default.values), forExample),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'b',
      { style: { margin: '16px 0px 8px 0px', fontWeight: 'bold' } },
      'Result: '
    ),
    _ramda2.default.call(_ramda2.default.compose(_ramda2.default.slice(0, limit), _ramda2.default.ifElse(function () {
      return combinable;
    }, _ramda2.default.reduce(function (result, ele) {
      var shorthand = getShorthand(ele);
      if (shorthand) {
        if (result) return result + '-' + shorthand;
        return shorthand;
      }
      return result;
    }, ''), _ramda2.default.compose(getShorthand, _ramda2.default.head)), _ramda2.default.filter(_ramda2.default.propEq('checked', true))), rule)
  );
};

exports.default = Example;

/***/ }),
/* 2943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _aphrodite = __webpack_require__(123);

var _materialUi = __webpack_require__(3);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _ramda = __webpack_require__(2);

var _extraLine = __webpack_require__(2944);

var _extraLine2 = _interopRequireDefault(_extraLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = _aphrodite.StyleSheet.create({
  container: { padding: '0px 2px 4px 2px', marginBottom: '64px' }
});
var IntegrationExtraSettings = function IntegrationExtraSettings(_ref) {
  var extraSettings = _ref.extraSettings,
      updateSettings = _ref.updateSettings,
      saveSettings = _ref.saveSettings,
      savingSettings = _ref.savingSettings,
      enableExtraSettingSaveButton = _ref.enableExtraSettingSaveButton,
      triggerSnackBarMessage = _ref.triggerSnackBarMessage;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '12px' } },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-bulb', color: '#ffc800', style: { fontSize: '24px', top: '-8px' } }),
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', width: '90%', marginLeft: '2%' } },
        'You can export one TourConnect extra for each available Service Extras line in Tourplan. ',
        _react2.default.createElement('br', null),
        'Please configure which extras you would like to export below:'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.container) },
      (0, _ramda.call)((0, _ramda.compose)((0, _ramda.addIndex)(_ramda.map)(function (key, index) {
        return _react2.default.createElement(_extraLine2.default, _extends({
          key: index,
          lineNo: index + 1
        }, (0, _ramda.prop)(key, extraSettings), {
          otherSelectedExtras: (0, _ramda.call)((0, _ramda.compose)(_ramda.flatten, (0, _ramda.pluck)('selectedExtras'), _ramda.values, (0, _ramda.omit)([key])), extraSettings),
          removeAnExtraFromAnotherLine: function removeAnExtraFromAnotherLine(extraName) {
            return (0, _ramda.call)((0, _ramda.compose)(updateSettings, (0, _ramda.mapObjIndexed)((0, _ramda.mapObjIndexed)(function (val, k) {
              return (0, _ramda.call)((0, _ramda.ifElse)(function () {
                return (0, _ramda.equals)('selectedExtras', k);
              }, (0, _ramda.reject)((0, _ramda.equals)(extraName)), _ramda.identity), val);
            }))), extraSettings);
          },
          updateLine: function updateLine(payload) {
            var _updateSettings;

            return updateSettings((_updateSettings = {}, _defineProperty(_updateSettings, key, payload), _defineProperty(_updateSettings, 'enableExtraSettingSaveButton', true), _updateSettings));
          }
        }));
      }), _ramda.keys), extraSettings)
    ),
    _react2.default.createElement(
      _materialUi.Paper,
      { style: { position: 'fixed', bottom: '0px', width: '740px' } },
      _react2.default.createElement(_raisedButtonWithLoader2.default, {
        label: enableExtraSettingSaveButton ? 'Save' : 'Saved',
        secondary: true,
        loader: savingSettings,
        disabled: !enableExtraSettingSaveButton,
        style: { margin: '12px auto', width: '130px' },
        onTouchTap: function onTouchTap() {
          saveSettings(_extends({}, extraSettings), { enableExtraSettingSaveButton: false }).catch(function () {
            triggerSnackBarMessage('Unable to save extra settings.');
            updateSettings({ savingExtraSettingsError: true, enableExtraSettingSaveButton: true });
          });
        }
      })
    )
  );
};

var mapPropsToState = function mapPropsToState(_ref2) {
  var integration = _ref2.integration;
  return {
    extraSettings: {
      extra1: integration.getIn(['settings', 'extra1']).toJS(),
      extra2: integration.getIn(['settings', 'extra2']).toJS(),
      extra3: integration.getIn(['settings', 'extra3']).toJS(),
      extra4: integration.getIn(['settings', 'extra4']).toJS(),
      extra5: integration.getIn(['settings', 'extra5']).toJS()
    },
    savingExtraSettingsError: integration.getIn(['settings', 'savingExtraSettingsError']),
    savingSettings: integration.getIn(['settings', 'savingSettings']),
    enableExtraSettingSaveButton: integration.getIn(['settings', 'enableExtraSettingSaveButton'])
  };
};

exports.default = (0, _reactRedux.connect)(mapPropsToState)(IntegrationExtraSettings);

/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _aphrodite = __webpack_require__(123);

var _sortableList = __webpack_require__(1130);

var _sortableList2 = _interopRequireDefault(_sortableList);

var _draggableCard = __webpack_require__(1134);

var _draggableCard2 = _interopRequireDefault(_draggableCard);

var _contractingPresetNamesCodes = __webpack_require__(464);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var border = '1px dashed rgba(0, 0, 0, 0.54)';

var styles = _aphrodite.StyleSheet.create({
  header: { backgroundColor: '#f5f5f5', padding: '0 16px', lineHeight: '48px', color: 'black', fontSize: '20px' },
  listContainer: { display: 'flex', width: '100%', marginTop: '16px' },
  draggableCard: { margin: '0px 0px 8px 32px', width: '90%' },
  sortableItem: { border: border, padding: '12px 6px' },
  selectFieldStyle: { width: '80%', marginLeft: '32px' },
  text: { display: 'inline-block', width: '80%', marginLeft: '6px', position: 'relative', top: '-2px', cursor: 'pointer' }
});

var ExtraLine = function ExtraLine(_ref) {
  var selectedExtras = _ref.selectedExtras,
      otherSelectedExtras = _ref.otherSelectedExtras,
      updateLine = _ref.updateLine,
      lineNo = _ref.lineNo,
      removeAnExtraFromAnotherLine = _ref.removeAnExtraFromAnotherLine;

  var fullExtraNamesOptions = (0, _ramda.call)((0, _ramda.compose)((0, _ramda.map)(function (name) {
    return { label: name, value: name };
  }), (0, _ramda.concat)(_ramda.__, otherSelectedExtras), (0, _ramda.reject)((0, _ramda.contains)(_ramda.__, otherSelectedExtras)), _ramda.keys), _contractingPresetNamesCodes.extraNameAndCode);
  return _react2.default.createElement(
    _materialUi.Paper,
    { style: { marginTop: '24px', minHeight: '200px', paddingBottom: '32px' } },
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.header) },
      'Extra Line ',
      lineNo
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.selectFieldStyle) },
      _react2.default.createElement(_reactSelect2.default, {
        multi: true,
        simpleValue: true,
        options: fullExtraNamesOptions,
        value: selectedExtras.join(','),
        placeholder: 'Select extra(s) to export',
        onChange: function onChange(values) {
          var valAsArray = values ? values.split(',') : [];
          var currentValue = (0, _ramda.last)(valAsArray);
          if ((0, _ramda.contains)(currentValue, otherSelectedExtras)) {
            var confirmed = confirm('You have selected this extra for another line, do you want to move it to Extra Line ' + lineNo + '?');
            if (confirmed) {
              removeAnExtraFromAnotherLine(currentValue);
              updateLine({ selectedExtras: valAsArray });
            }
          } else updateLine({ selectedExtras: valAsArray });
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { display: !(0, _ramda.isEmpty)(selectedExtras) ? 'block' : 'none', margin: '24px 0px 0px 32px', width: '80%' } },
      _react2.default.createElement(
        'div',
        { style: { fontSize: '16px', color: 'rgba(0, 0, 0, 0.68)' } },
        'Prioritize extra(s) to export'
      ),
      _react2.default.createElement(
        'i',
        null,
        'If an extra is not present in TourConnect, we will attempt to export the next available extra in your list until there are no available options to export.'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.listContainer) },
      _react2.default.createElement(
        _sortableList2.default,
        {
          style: { width: '45%', display: 'inline-block' },
          arrayOfData: selectedExtras,
          dragEnds: function dragEnds(vals) {
            return updateLine({ selectedExtras: vals });
          }
        },
        selectedExtras.map(function (item, i) {
          return _react2.default.createElement(
            _draggableCard2.default,
            { key: i, className: (0, _aphrodite.css)(styles.draggableCard), isDragSource: true, isDropTarget: true },
            _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles.sortableItem) },
              _react2.default.createElement(
                'div',
                { className: (0, _aphrodite.css)(styles.text) },
                item
              ),
              _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-swap_vert', style: { color: 'rgba(0, 0, 0, 0.34)', top: '5px' } })
            )
          );
        })
      ),
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', width: '5%' } },
        selectedExtras.map(function (_, i) {
          return i ? _react2.default.createElement(
            'div',
            { style: { textAlign: 'center', height: '65px' }, key: i },
            _react2.default.createElement(
              'span',
              { style: { top: '45px', position: 'relative' } },
              'OR'
            )
          ) : _react2.default.createElement('div', { key: i });
        })
      )
    )
  );
};

exports.default = ExtraLine;

/***/ }),
/* 2945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _aphrodite = __webpack_require__(123);

var _materialUi = __webpack_require__(3);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = _aphrodite.StyleSheet.create({
  header: { backgroundColor: '#f5f5f5', padding: '0 16px', lineHeight: '48px', color: 'black', fontSize: '20px' },
  container: { padding: '0px 2px 4px 2px', marginBottom: '64px' }
});
var IntegrationCancelHourSettings = function IntegrationCancelHourSettings(_ref) {
  var cancelHourSettings = _ref.cancelHourSettings,
      updateSettings = _ref.updateSettings,
      saveSettings = _ref.saveSettings,
      savingSettings = _ref.savingSettings,
      enableCancelHourSettingSaveButton = _ref.enableCancelHourSettingSaveButton,
      triggerSnackBarMessage = _ref.triggerSnackBarMessage;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '12px' } },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-bulb', color: '#ffc800', style: { fontSize: '24px', top: '-2px' } }),
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', width: '90%', marginLeft: '2%' } },
        'You can configure how many hours you would like to add or substract.'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.container) },
      _react2.default.createElement(
        _materialUi.Paper,
        { style: { marginTop: '24px', minHeight: '100px' } },
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.header) },
          'Cancellation Hours Setting'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '16px' } },
          'Please enter number of hours you want to add or subtract: \xA0',
          _react2.default.createElement('input', {
            type: 'number',
            value: cancelHourSettings.number || 0,
            onChange: function onChange(_ref2) {
              var value = _ref2.target.value;
              return updateSettings({ cancelHourSettings: { number: value }, enableCancelHourSettingSaveButton: true });
            },
            style: { width: '15%', textAlign: 'right', fontSize: '25px', position: 'relative', top: '6px', height: '32px', marginLeft: '2%' }
          })
        ),
        _react2.default.createElement(_raisedButtonWithLoader2.default, {
          label: enableCancelHourSettingSaveButton ? 'Save' : 'Saved',
          secondary: true,
          loader: savingSettings,
          disabled: !enableCancelHourSettingSaveButton,
          style: { margin: '12px 80%', width: '130px' },
          onTouchTap: function onTouchTap() {
            saveSettings({ cancelHourSettings: cancelHourSettings }, { enableCancelHourSettingSaveButton: false }).catch(function () {
              triggerSnackBarMessage('Unable to save extra settings.');
              updateSettings({ savingCancelHourSettingsError: true, enableCancelHourSettingSaveButton: true });
            });
          }
        })
      )
    )
  );
};

var mapPropsToState = function mapPropsToState(_ref3) {
  var integration = _ref3.integration;
  return {
    savingCancelHourSettingsError: integration.getIn(['settings', 'savingCancelHourSettingsError']),
    savingSettings: integration.getIn(['settings', 'savingSettings']),
    enableCancelHourSettingSaveButton: integration.getIn(['settings', 'enableCancelHourSettingSaveButton']),
    cancelHourSettings: integration.getIn(['settings', 'cancelHourSettings']) ? integration.getIn(['settings', 'cancelHourSettings']).toJS() : {}
  };
};

exports.default = (0, _reactRedux.connect)(mapPropsToState)(IntegrationCancelHourSettings);

/***/ }),
/* 2946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _aphrodite = __webpack_require__(123);

var _materialUi = __webpack_require__(3);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = _aphrodite.StyleSheet.create({
  header: { backgroundColor: '#f5f5f5', padding: '0 16px', lineHeight: '48px', color: 'black', fontSize: '20px' },
  container: { padding: '0px 2px 4px 2px', marginBottom: '64px' }
});
var TaxSettings = function TaxSettings(_ref) {
  var taxSettings = _ref.taxSettings,
      updateSettings = _ref.updateSettings,
      saveSettings = _ref.saveSettings,
      savingSettings = _ref.savingSettings,
      enableTaxSettingSaveButton = _ref.enableTaxSettingSaveButton,
      triggerSnackBarMessage = _ref.triggerSnackBarMessage;

  var entryStyle = {
    width: '40%',
    fontSize: '16px',
    marginTop: '8px'
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.container) },
      _react2.default.createElement(
        _materialUi.Paper,
        { style: { marginTop: '24px', minHeight: '100px' } },
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.header) },
          'Tax Setting'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '16px' } },
          'Please enter your Tourplan tax codes \xA0',
          _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb', style: entryStyle },
            'Tax Inclusion:',
            _react2.default.createElement('input', {
              value: taxSettings.inclusive || '',
              onChange: function onChange(_ref2) {
                var value = _ref2.target.value;
                return updateSettings({
                  taxSettings: _extends({}, taxSettings, { inclusive: value }),
                  enableTaxSettingSaveButton: true
                });
              },
              style: { width: '25%', padding: '4px', height: '32px' }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb', style: entryStyle },
            'Tax Exclusion:',
            _react2.default.createElement('input', {
              value: taxSettings.exclusive || '',
              onChange: function onChange(_ref3) {
                var value = _ref3.target.value;
                return updateSettings({
                  taxSettings: _extends({}, taxSettings, { exclusive: value }),
                  enableTaxSettingSaveButton: true
                });
              },
              style: { width: '25%', padding: '4px', height: '32px' }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb', style: entryStyle },
            'Tax Exempt:',
            _react2.default.createElement('input', {
              value: taxSettings.exempt || '',
              onChange: function onChange(_ref4) {
                var value = _ref4.target.value;
                return updateSettings({
                  taxSettings: _extends({}, taxSettings, { exempt: value }),
                  enableTaxSettingSaveButton: true
                });
              },
              style: { width: '25%', padding: '4px', height: '32px' }
            })
          )
        ),
        _react2.default.createElement(_raisedButtonWithLoader2.default, {
          label: enableTaxSettingSaveButton ? 'Save' : 'Saved',
          secondary: true,
          loader: savingSettings,
          disabled: !enableTaxSettingSaveButton,
          style: { margin: '12px 80%', width: '130px' },
          onTouchTap: function onTouchTap() {
            saveSettings({ taxSettings: taxSettings }, { enableTaxSettingSaveButton: false }).catch(function () {
              triggerSnackBarMessage('Unable to save tax settings.');
              updateSettings({ savingTaxSettingsError: true, enableTaxSettingSaveButton: true });
            });
          }
        })
      )
    )
  );
};

var mapPropsToState = function mapPropsToState(_ref5) {
  var integration = _ref5.integration;
  return {
    savingTaxSettingsError: integration.getIn(['settings', 'savingTaxSettingsError']),
    savingSettings: integration.getIn(['settings', 'savingSettings']),
    enableTaxSettingSaveButton: integration.getIn(['settings', 'enableTaxSettingSaveButton']),
    taxSettings: integration.getIn(['settings', 'taxSettings']) ? integration.getIn(['settings', 'taxSettings']).toJS() : {}
  };
};

exports.default = (0, _reactRedux.connect)(mapPropsToState)(TaxSettings);

/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

var _aphrodite = __webpack_require__(123);

var _materialUi = __webpack_require__(3);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _AddItemCard = __webpack_require__(1245);

var _AddItemCard2 = _interopRequireDefault(_AddItemCard);

var _selectFields = __webpack_require__(141);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var styles = _aphrodite.StyleSheet.create({
  header: { backgroundColor: '#f5f5f5', padding: '0 16px', lineHeight: '48px', color: 'black', fontSize: '20px' },
  container: { padding: '0px 2px 4px 2px', marginBottom: '64px' },
  ruleBox: {
    padding: '24px 0',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #e0e0e0'
  },
  countryCurrencyBox: {
    minWidth: '185px',
    display: 'flex',
    flexDirection: 'column'
  },
  countryCurrencyBoxSelected: {
    minWidth: '185px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    bottom: '12px'
  },
  radioGroup: {
    padding: '0 4px'
  },
  country: {
    width: '250px'
  },
  currency: {
    width: '250px'
  },
  productType: {
    width: '200px'
  },
  codes: {
    border: '1px solid #e0e0e0',
    padding: '0 8px',
    width: '300px',
    fontSize: '12px',
    height: '32px',
    borderRadius: '3px'
  }
});
var IntegrationPriceCodesSettings = function IntegrationPriceCodesSettings(props) {
  var priceCodesSetting = props.priceCodesSetting,
      updateSettings = props.updateSettings,
      saveSettings = props.saveSettings,
      savingSettings = props.savingSettings,
      enablePriceCodeSettingSaveButton = props.enablePriceCodeSettingSaveButton,
      triggerSnackBarMessage = props.triggerSnackBarMessage;
  var defaultCode = priceCodesSetting.defaultCode,
      rules = priceCodesSetting.rules;

  var updatePCS = function updatePCS(payload, enableButton) {
    return updateSettings({
      priceCodesSetting: _extends({}, priceCodesSetting, payload),
      enablePriceCodeSettingSaveButton: enableButton
    });
  };
  var addOne = function addOne() {
    return updatePCS({
      rules: [].concat(_toConsumableArray(rules), [{ productType: 'all', codes: [] }])
    });
  };
  var removeRule = function removeRule(i) {
    return function () {
      return updatePCS({
        rules: _ramda2.default.remove(i, 1, rules)
      }, true);
    };
  };
  var checkCountryOrCurrency = function checkCountryOrCurrency(index, val) {
    return function () {
      return updatePCS({
        rules: _ramda2.default.update(index, _extends({}, rules[index], { countryOrCurrency: val }), rules)
      });
    };
  };
  var selectCountry = function selectCountry(index) {
    return function (_ref) {
      var value = _ref.value;
      return updatePCS({
        rules: _ramda2.default.update(index, _extends({}, rules[index], { country: value }), rules)
      }, true);
    };
  };
  var selectCurrency = function selectCurrency(index) {
    return function (_ref2) {
      var value = _ref2.value;
      return updatePCS({
        rules: _ramda2.default.update(index, _extends({}, rules[index], { currency: value }), rules)
      }, true);
    };
  };
  var selectProductType = function selectProductType(index) {
    return function (_ref3) {
      var value = _ref3.value;
      return updatePCS({
        rules: _ramda2.default.update(index, _extends({}, rules[index], { productType: value }), rules)
      }, true);
    };
  };
  var updateRulePriceCodes = function updateRulePriceCodes(index) {
    return function (_ref4) {
      var value = _ref4.target.value;
      return updatePCS({
        rules: _ramda2.default.update(index, _extends({}, rules[index], { codes: value.split(',') }), rules)
      }, true);
    };
  };
  var updateDefault = function updateDefault(_ref5) {
    var value = _ref5.target.value;
    return updatePCS({
      defaultCode: value
    }, true);
  };
  var validRules = rules.filter(function (rule) {
    return rule.codes.length && (rule.countryOrCurrency === 'country' && rule.country || rule.countryOrCurrency === 'currency' && rule.currency);
  });
  var save = function save() {
    saveSettings({
      priceCodesSetting: _extends({}, priceCodesSetting, {
        defaultCode: defaultCode,
        rules: validRules
      })
    }, { enablePriceCodeSettingSaveButton: false }).catch(function () {
      triggerSnackBarMessage('Unable to save price code settings.');
      updateSettings({ savingPriceCodeSettingsError: true, enablePriceCodeSettingSaveButton: true });
    });
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '12px' } },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-bulb', color: '#ffc800', style: { fontSize: '24px' } }),
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', width: '90%', marginLeft: '2%' } },
        'You can configure the price code(s) that your rates will be exported with by adding a setting here. Tip: use commas to separate price codes.'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.container) },
      _react2.default.createElement(
        _materialUi.Paper,
        { style: { marginTop: '24px', minHeight: '100px' } },
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.header) },
          'Price Codes Setting'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '16px' } },
          rules.map(function (rule, i) {
            return _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles.ruleBox), key: i },
              _react2.default.createElement(
                'b',
                null,
                'Rule ',
                i + 1,
                ':'
              ),
              '\xA0 Export rates in\xA0',
              _react2.default.createElement(
                'div',
                { className: (0, _aphrodite.css)(rule.countryOrCurrency ? styles.countryCurrencyBoxSelected : styles.countryCurrencyBox) },
                _react2.default.createElement(
                  'div',
                  { className: 'flex-tc-sb ' + (0, _aphrodite.css)(styles.radioGroup) },
                  _react2.default.createElement(_materialUi.RadioButton, {
                    label: 'Country',
                    iconStyle: { marginRight: '4px' },
                    checked: rule.countryOrCurrency === 'country',
                    onCheck: checkCountryOrCurrency(i, 'country')
                  }),
                  _react2.default.createElement(_materialUi.RadioButton, {
                    label: 'Currency',
                    iconStyle: { marginRight: '4px' },
                    checked: rule.countryOrCurrency === 'currency',
                    onCheck: checkCountryOrCurrency(i, 'currency')
                  })
                ),
                rule.countryOrCurrency === 'country' && _react2.default.createElement(
                  'div',
                  { className: (0, _aphrodite.css)(styles.country) },
                  _react2.default.createElement(_reactSelect2.default, {
                    name: 'countriesServed',
                    scrollMenuIntoView: false,
                    options: _selectFields.countries,
                    clearable: false,
                    placeholder: 'Please search and select a country...',
                    value: rule.country,
                    onChange: selectCountry(i)
                  })
                ),
                rule.countryOrCurrency === 'currency' && _react2.default.createElement(
                  'div',
                  { className: (0, _aphrodite.css)(styles.currency) },
                  _react2.default.createElement(_reactSelect2.default, {
                    name: 'currency',
                    scrollMenuIntoView: false,
                    options: _selectFields.currencies,
                    clearable: false,
                    placeholder: 'Please search and select a currency...',
                    value: rule.currency,
                    onChange: selectCurrency(i)
                  })
                )
              ),
              '\xA0for\xA0',
              _react2.default.createElement(
                'div',
                { className: (0, _aphrodite.css)(styles.productType) },
                _react2.default.createElement(_reactSelect2.default, {
                  name: 'productType',
                  scrollMenuIntoView: false,
                  options: [{ value: 'all', label: 'all' }, { value: 'accom', label: 'accommodation' }, { value: 'non-accom', label: 'non-accommodation' }],
                  clearable: false,
                  value: rule.productType,
                  onChange: selectProductType(i)
                })
              ),
              '\xA0services to\xA0',
              _react2.default.createElement('input', {
                value: rule.codes.join(','),
                placeholder: 'Enter price codes here...',
                onChange: updateRulePriceCodes(i),
                className: (0, _aphrodite.css)(styles.codes)
              }),
              '.\xA0\xA0',
              _react2.default.createElement(_raisedButtonWithLoader2.default, {
                label: 'Remove Rule',
                primary: true,
                style: { marginLeft: '12px', width: '130px' },
                onTouchTap: removeRule(i)
              })
            );
          }),
          Boolean(rules.length) && _react2.default.createElement('br', null),
          _react2.default.createElement(_AddItemCard2.default, {
            onClick: addOne,
            color: '#00bcd4',
            text: 'Add price code setting'
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          'Please enter a default price code (optional): \xA0',
          _react2.default.createElement('input', {
            value: defaultCode,
            onChange: updateDefault,
            style: { width: '15%', textAlign: 'right', fontSize: '25px', position: 'relative', top: '6px', height: '32px', marginLeft: '2%' }
          })
        ),
        _react2.default.createElement(_raisedButtonWithLoader2.default, {
          label: enablePriceCodeSettingSaveButton ? 'Save' : 'Saved',
          secondary: true,
          loader: savingSettings,
          disabled: !enablePriceCodeSettingSaveButton,
          style: { margin: '12px 80%', width: '130px' },
          onTouchTap: save
        })
      )
    )
  );
};

var mapPropsToState = function mapPropsToState(_ref6) {
  var integration = _ref6.integration;
  return {
    savingPriceCodeSettingsError: integration.getIn(['settings', 'savingPriceCodeSettingsError']),
    savingSettings: integration.getIn(['settings', 'savingSettings']),
    enablePriceCodeSettingSaveButton: integration.getIn(['settings', 'enablePriceCodeSettingSaveButton']),
    priceCodesSetting: integration.getIn(['settings', 'priceCodesSetting']) ? integration.getIn(['settings', 'priceCodesSetting']).toJS() : {}
  };
};

exports.default = (0, _reactRedux.connect)(mapPropsToState)(IntegrationPriceCodesSettings);

/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

var _aphrodite = __webpack_require__(123);

var _materialUi = __webpack_require__(3);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _AddItemCard = __webpack_require__(1245);

var _AddItemCard2 = _interopRequireDefault(_AddItemCard);

var _selectFields = __webpack_require__(141);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var styles = _aphrodite.StyleSheet.create({
  header: { backgroundColor: '#f5f5f5', padding: '0 16px', lineHeight: '48px', color: 'black', fontSize: '20px' },
  container: { padding: '0px 2px 4px 2px', marginBottom: '64px' },
  ruleBox: {
    padding: '24px 0',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #e0e0e0'
  },
  countryCurrencyBox: {
    minWidth: '185px',
    display: 'flex',
    flexDirection: 'column'
  },
  countryCurrencyBoxSelected: {
    minWidth: '185px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    bottom: '12px'
  },
  radioGroup: {
    padding: '0 4px'
  },
  country: {
    width: '250px'
  },
  currency: {
    width: '250px'
  },
  tcTypes: {
    width: '450px'
  },
  tpCode: {
    border: '1px solid #e0e0e0',
    padding: '0 8px',
    width: '200px',
    fontSize: '12px',
    height: '32px',
    borderRadius: '3px'
  }
});
var IntegrationNotesSettings = function IntegrationNotesSettings(props) {
  var _props$notesSettings = props.notesSettings,
      notesSettings = _props$notesSettings === undefined ? [] : _props$notesSettings,
      updateSettings = props.updateSettings,
      saveSettings = props.saveSettings,
      savingSettings = props.savingSettings,
      enableNotesSettingSaveButton = props.enableNotesSettingSaveButton,
      triggerSnackBarMessage = props.triggerSnackBarMessage;

  console.log(notesSettings);
  var updatePCS = function updatePCS(newArray) {
    return updateSettings({
      notesSettings: newArray,
      enableNotesSettingSaveButton: true
    });
  };
  var addOne = function addOne() {
    return updatePCS([].concat(_toConsumableArray(notesSettings), [{
      code: '',
      tcTypes: []
    }]));
  };
  var removeNote = function removeNote(i) {
    return function () {
      return updatePCS(_ramda2.default.remove(i, 1, notesSettings));
    };
  };
  var selectTCTypes = function selectTCTypes(index) {
    return function (values) {
      return updatePCS(_ramda2.default.update(index, _extends({}, notesSettings[index], { tcTypes: values.map(function (v) {
          return v.value;
        }) }), notesSettings));
    };
  };
  var updateNoteCode = function updateNoteCode(index) {
    return function (_ref) {
      var value = _ref.target.value;
      return updatePCS(_ramda2.default.update(index, _extends({}, notesSettings[index], { code: value }), notesSettings));
    };
  };
  var save = function save() {
    saveSettings({
      notesSettings: notesSettings
    }, { enableNotesSettingSaveButton: false }).catch(function () {
      triggerSnackBarMessage('Unable to save notes settings.');
      updateSettings({ savingNotesSettingsError: true, enableNotesSettingSaveButton: true });
    });
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '12px' } },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-bulb', color: '#ffc800', style: { fontSize: '24px' } }),
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', width: '90%', marginLeft: '2%' } },
        'You can configure the notes categories that your texts will be exported with by adding a setting here.'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.container) },
      _react2.default.createElement(
        _materialUi.Paper,
        { style: { marginTop: '24px', minHeight: '100px' } },
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.header) },
          'Product Notes Setting'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '16px' } },
          notesSettings.map(function (rule, i) {
            return _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles.ruleBox), key: i },
              _react2.default.createElement(
                'b',
                null,
                'Note Category ',
                i + 1,
                ':'
              ),
              '\xA0 Export content of\xA0\xA0',
              _react2.default.createElement(
                'div',
                { className: (0, _aphrodite.css)(styles.tcTypes) },
                _react2.default.createElement(_reactSelect2.default, {
                  name: 'TourConnect Text Types',
                  placeholder: 'TourConnect Text Types (you can select more than one)',
                  scrollMenuIntoView: false,
                  options: [{ value: 'bedsAndSofas', label: 'Bedding Configuration' }, { value: 'cancelPolicy', label: 'Cancellation Policy' }, { value: 'childPolicy', label: 'Child Policy' }, { value: 'infantPolicy', label: 'Infant Policy' }, { value: 'pickup', label: 'Pickup/Opening' }, { value: 'dropoff', label: 'Dropoff/Closing' }, { value: 'blackoutDates', label: 'Blackout Dates' }],
                  clearable: false,
                  multi: true,
                  value: rule.tcTypes.join(','),
                  onChange: selectTCTypes(i)
                })
              ),
              '\xA0to\xA0',
              _react2.default.createElement('input', {
                value: rule.code,
                placeholder: 'Note code from Tourplan',
                onChange: updateNoteCode(i),
                className: (0, _aphrodite.css)(styles.tpCode)
              }),
              '.\xA0\xA0',
              _react2.default.createElement(_raisedButtonWithLoader2.default, {
                label: 'Remove Note',
                primary: true,
                style: { marginLeft: '12px', width: '130px' },
                onTouchTap: removeNote(i)
              })
            );
          }),
          Boolean(notesSettings.length) && _react2.default.createElement('br', null),
          _react2.default.createElement(_AddItemCard2.default, {
            onClick: addOne,
            color: '#00bcd4',
            text: 'Add note category'
          }),
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(_raisedButtonWithLoader2.default, {
          label: enableNotesSettingSaveButton ? 'Save' : 'Saved',
          secondary: true,
          loader: savingSettings,
          disabled: !enableNotesSettingSaveButton,
          style: { margin: '12px 80%', width: '130px' },
          onTouchTap: save
        })
      )
    )
  );
};

var mapPropsToState = function mapPropsToState(_ref2) {
  var integration = _ref2.integration;
  return {
    savingNotesSettingsError: integration.getIn(['settings', 'savingNotesSettingsError']),
    savingSettings: integration.getIn(['settings', 'savingSettings']),
    enableNotesSettingSaveButton: integration.getIn(['settings', 'enableNotesSettingSaveButton']),
    notesSettings: integration.getIn(['settings', 'notesSettings']) ? integration.getIn(['settings', 'notesSettings']).toJS() : []
  };
};

exports.default = (0, _reactRedux.connect)(mapPropsToState)(IntegrationNotesSettings);

/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _productMapping = __webpack_require__(2950);

var _productMapping2 = _interopRequireDefault(_productMapping);

var _container = __webpack_require__(2954);

var _container2 = _interopRequireDefault(_container);

var _exportResult = __webpack_require__(2965);

var _exportResult2 = _interopRequireDefault(_exportResult);

var _materialUi = __webpack_require__(3);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _integrationActions = __webpack_require__(1912);

var _integrationTourplanLogin = __webpack_require__(1228);

var _integrationTourplanLogin2 = _interopRequireDefault(_integrationTourplanLogin);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  params: _react2.default.PropTypes.object,
  exportContract: _react2.default.PropTypes.func,
  history: _react2.default.PropTypes.object,
  user: _react2.default.PropTypes.object,
  contract: _react2.default.PropTypes.object,
  updateWithKeyPath: _react2.default.PropTypes.func,
  sendMsg: _react2.default.PropTypes.func,
  getConvertedContract: _react2.default.PropTypes.func,
  clearExportState: _react2.default.PropTypes.func,
  displayExportPreview: _react2.default.PropTypes.bool,
  dialogOpen: _react2.default.PropTypes.bool,
  convertedContract: _react2.default.PropTypes.array,
  exportStep: _react2.default.PropTypes.number,
  checkIfDupeRateNameExistsWithinADateRange: _react2.default.PropTypes.func,
  getContract: _react2.default.PropTypes.func,
  getAuth: _react2.default.PropTypes.func,
  exportStatus: _react2.default.PropTypes.string,
  ratePackageIds: _react2.default.PropTypes.array,
  markContractAsLoaded: _react2.default.PropTypes.func,
  updatingContractState: _react2.default.PropTypes.bool
};

var ExportContainer = function (_React$Component) {
  _inherits(ExportContainer, _React$Component);

  function ExportContainer(props) {
    _classCallCheck(this, ExportContainer);

    var _this = _possibleConstructorReturn(this, (ExportContainer.__proto__ || Object.getPrototypeOf(ExportContainer)).call(this, props));

    _this._dialogHide = function () {
      _this.props.updateWithKeyPath(['dialogOpen'], false);
    };

    _this.convertErrorCode = function (exportError) {
      return _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('500'), _ramda2.default.always('Sorry, please try again or inform our customer support team if it failed again!')], [_ramda2.default.equals(500), _ramda2.default.always('Sorry, please try again or inform our customer support team if it failed again!')], [_ramda2.default.equals('503'), _ramda2.default.always('Sorry, this service is temporarily not available.')], [_ramda2.default.equals('404'), _ramda2.default.always('Products are not correctly mapped, please check!')], [_ramda2.default.equals('TOOOOO LOOOOOG'), _ramda2.default.always("Looks like it would take a while to export all of these rate bands, please feel free to work on other stuff and we will email you once all rate bands are successfully exported")], [_ramda2.default.T, _ramda2.default.identity]]), exportError);
    };

    _this.state = {};
    return _this;
  }

  _createClass(ExportContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          getContract = _props.getContract,
          getAuth = _props.getAuth,
          params = _props.params;
      var contractID = params.contractID;

      getContract(contractID);
      getAuth();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react2.default.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearExportState();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          contract = _props2.contract,
          exportStatus = _props2.exportStatus,
          updateWithKeyPath = _props2.updateWithKeyPath,
          exportStep = _props2.exportStep,
          exportContract = _props2.exportContract,
          convertedContract = _props2.convertedContract,
          ratePackageIds = _props2.ratePackageIds,
          checkIfDupeRateNameExistsWithinADateRange = _props2.checkIfDupeRateNameExistsWithinADateRange,
          markContractAsLoaded = _props2.markContractAsLoaded,
          updatingContractState = _props2.updatingContractState,
          dialogOpen = _props2.dialogOpen;

      var ifDupeRateNameExistsAtAll = convertedContract.some(function (_ref) {
        var forTourplan = _ref.forTourplan;
        return forTourplan.some(function (_ref2) {
          var DateRange = _ref2.DateRange;
          return checkIfDupeRateNameExistsWithinADateRange(DateRange);
        });
      });

      var hasRates = Boolean(_ramda2.default.find(_ramda2.default.propEq('hasRates', true), contract && contract.products ? contract.products.filter(function (obj) {
        return ratePackageIds.indexOf(obj._id) > -1;
      }) : []));
      var missingPriceCodesOrTaxCodes = convertedContract.some(function (_ref3) {
        var forTourplan = _ref3.forTourplan;
        return forTourplan.some(function (_ref4) {
          var DateRange = _ref4.DateRange;
          return !(DateRange.PriceCodes && DateRange.PriceCodes.length) || !(DateRange.Taxes && DateRange.Taxes.TaxInfo && DateRange.Taxes.TaxInfo.Tax);
        });
      });
      var numOfDateBlocks = convertedContract.reduce(function (total, o) {
        return total + o.forTourplan.length;
      }, 0);
      return _react2.default.createElement(
        'div',
        { className: 'l-app-content', style: { marginBottom: '128px', maxWidth: 'calc(100% - 48px)' } },
        _react2.default.createElement(
          _materialUi.Paper,
          null,
          _react2.default.createElement(_materialUi.CardHeader, {
            style: { backgroundColor: '#f5f5f5' },
            title: _react2.default.createElement(
              'span',
              { style: { fontSize: '20px' } },
              contract.supplierName
            ),
            subtitle: _react2.default.createElement(
              'a',
              { style: { marginTop: '5px', cursor: 'pointer' }, target: '_blank', href: '/contracting/contract/' + contract.contractId + '/details' },
              _react2.default.createElement(_materialUi.FontIcon, { style: { fontSize: '16px', marginTop: '5px' }, color: "#00bcd4", className: 'tc-icon-archive' }),
              ' ' + contract.locationName,
              _ramda2.default.path(['supplierInfo', 'marketInfo'], contract) ? _react2.default.createElement(
                'small',
                null,
                '\xA0',
                '(' + _ramda2.default.path(['supplierInfo', 'marketInfo'], contract) + ')'
              ) : _react2.default.createElement('span', null)
            ),
            avatar: _react2.default.createElement(_materialUi.Avatar, { src: contract.avatarUrl, size: 50, style: { verticalAlign: 'middle' } })
          }),
          _react2.default.createElement(
            _materialUi.Stepper,
            {
              activeStep: exportStep - 1,
              linear: false,
              style: { borderTop: '1px solid #e0e0e0' }
            },
            _react2.default.createElement(
              _materialUi.Step,
              null,
              _react2.default.createElement(
                _materialUi.StepButton,
                { onTouchTap: function onTouchTap() {
                    return updateWithKeyPath(['exportStep'], 1);
                  } },
                'Mapping & History'
              )
            ),
            _react2.default.createElement(
              _materialUi.Step,
              null,
              _react2.default.createElement(
                _materialUi.StepButton,
                { onTouchTap: function onTouchTap() {
                    if (convertedContract && convertedContract.length) updateWithKeyPath(['exportStep'], 2);else _this2.props.getConvertedContract(contract.contractId, ratePackageIds);
                  } },
                'Export Preview'
              )
            ),
            _react2.default.createElement(
              _materialUi.Step,
              null,
              _react2.default.createElement(
                _materialUi.StepLabel,
                null,
                'Export Results'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { marginBottom: '24px' } },
          _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals(2), _ramda2.default.always(_react2.default.createElement(_container2.default, this.props))], [_ramda2.default.equals(3), _ramda2.default.always(_react2.default.createElement(_exportResult2.default, {
            exportResponses: contract.exportResponses,
            markContractAsLoaded: markContractAsLoaded,
            contractId: contract.contractId,
            state: contract.state,
            updatingContractState: updatingContractState
          }))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(_productMapping2.default, this.props))]]), exportStep)
        ),
        _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals(2), _ramda2.default.always(_react2.default.createElement(
          'div',
          { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
          _react2.default.createElement(_raisedButtonWithLoader2.default, { label: 'Back', onTouchTap: function onTouchTap() {
              return updateWithKeyPath(['exportStep'], 1);
            }, primary: true }),
          missingPriceCodesOrTaxCodes && _react2.default.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center', textAlign: 'left', overflow: 'auto', marginLeft: '8%', marginTop: '10px', height: '64px' } },
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-warning2', color: '#ff9100' }),
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', marginLeft: '8px', color: "#ff9100" } },
              'Please be informed that some date ranges you are trying to export are missing Tax Code or Price Codes.'
            )
          ),
          _react2.default.createElement(_raisedButtonWithLoader2.default, {
            label: hasRates ? 'Confirm and Re-export' : 'Confirm and export',
            loader: exportStatus === 'exporting',
            onClick: function onClick() {
              if (!hasRates || window.confirm('Tourplan currently has rates for the one (or more) of the options that you are going to export rates into. Are you sure you want to ovewrite the existing data?')) {
                exportContract(contract, convertedContract);
              }
            },
            disabled: ifDupeRateNameExistsAtAll,
            labelStyle: { textTransformation: 'none' }, secondary: true
          })
        ))], [_ramda2.default.equals(3), _ramda2.default.always(_react2.default.createElement(
          'div',
          { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
          _react2.default.createElement(_raisedButtonWithLoader2.default, {
            label: 'Go Back and Try Again',
            onTouchTap: function onTouchTap() {
              updateWithKeyPath(['exportStep'], 2);
              updateWithKeyPath(['contract', 'exportResponses'], null);
            },
            primary: true
          }),
          _react2.default.createElement(_raisedButtonWithLoader2.default, {
            label: 'Export Another Contract',
            onClick: function onClick() {
              return _this2.context.router.push('/integration/contracts');
            },
            labelStyle: { textTransformation: 'none' }, secondary: true
          })
        ))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement('div', null))]]), exportStep),
        _react2.default.createElement(_loadingOverlay2.default, {
          loading: ['gettingConvertedContract', 'exporting', 'checkingRates'].indexOf(exportStatus) > -1,
          text: exportStatus === 'exporting' && numOfDateBlocks > 5 ? 'We are exporting ' + convertedContract.length + ' ' + (0, _pluralize2.default)('Option', convertedContract.length) + ', ' + numOfDateBlocks + ' Date ' + (0, _pluralize2.default)('Band', numOfDateBlocks) + '...' : ''
        }),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            title: contract.exportError === '401' ? '' : 'Oops!',
            open: dialogOpen,
            onRequestClose: this._dialogHide,
            actions: [_react2.default.createElement(_materialUi.FlatButton, {
              label: 'Close',
              secondary: true,
              disableTouchRipple: true,
              onClick: this._dialogHide
            })],
            modal: false
          },
          contract.exportError === '401' ? _react2.default.createElement(_integrationTourplanLogin2.default, _extends({}, this.props, { transition: this._dialogHide, type: 'validate' })) : this.convertErrorCode(contract.exportError)
        )
      );
    }
  }]);

  return ExportContainer;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref5) {
  var integration = _ref5.integration;
  return {
    displayExportPreview: integration.get('displayExportPreview'),
    exportStatus: integration.get('exportStatus'),
    exportStep: integration.get('exportStep'),
    dialogOpen: integration.get('dialogOpen'),
    ratePackageIds: integration.get('ratePackageIds') ? integration.get('ratePackageIds').toJS() : [],
    contract: integration.get('contract') ? integration.get('contract').toJS() : {},
    updatingContractState: integration.get('updatingContractState'),
    convertedContract: integration.get('convertedContract') ? integration.get('convertedContract').toJS() : []
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getContract: function getContract() {
      return dispatch(_integrationActions.getContract.apply(undefined, arguments));
    },
    getAuth: function getAuth() {
      return dispatch(_integrationActions.getAuth.apply(undefined, arguments));
    },
    checkIfHasRates: function checkIfHasRates() {
      return dispatch(_integrationActions.checkIfHasRates.apply(undefined, arguments));
    },
    getConvertedContract: function getConvertedContract() {
      return dispatch(_integrationActions.getConvertedContract.apply(undefined, arguments));
    },
    markContractAsLoaded: function markContractAsLoaded() {
      return dispatch(_integrationActions.markContractAsLoaded.apply(undefined, arguments));
    },
    exportContract: function exportContract() {
      return dispatch(_integrationActions.exportContract.apply(undefined, arguments));
    },
    updateWithKeyPath: function updateWithKeyPath() {
      return dispatch(_integrationActions.updateWithKeyPath.apply(undefined, arguments));
    },
    clearExportState: function clearExportState() {
      return dispatch(_integrationActions.clearExportState.apply(undefined, arguments));
    },
    checkIfDupeRateNameExistsWithinADateRange: _ramda2.default.compose(_ramda2.default.any(function (array) {
      return array.length > 1;
    }), _ramda2.default.groupWith(_ramda2.default.eqProps('Stay_Type')), _ramda2.default.prop('RateSet'))
  };
};
ExportContainer.propTypes = propTypes;
ExportContainer.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ExportContainer);

/***/ }),
/* 2950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _productMappingProduct = __webpack_require__(2951);

var _productMappingProduct2 = _interopRequireDefault(_productMappingProduct);

var _sectionHeading = __webpack_require__(732);

var _sectionHeading2 = _interopRequireDefault(_sectionHeading);

var _exportHistoryFeed = __webpack_require__(2953);

var _exportHistoryFeed2 = _interopRequireDefault(_exportHistoryFeed);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  exportContract: _react.PropTypes.func,
  history: _react.PropTypes.object,
  user: _react.PropTypes.object,
  contract: _react.PropTypes.object,
  updateWithKeyPath: _react.PropTypes.func,
  clearContract: _react.PropTypes.func,
  sendMsg: _react.PropTypes.func,
  getConvertedContract: _react.PropTypes.func,
  displayExportPreview: _react.PropTypes.bool,
  convertedContract: _react.PropTypes.array,
  exportStatus: _react.PropTypes.string,
  priceCodesSetting: _react.PropTypes.object,
  saveSettings: _react.PropTypes.func,
  ratePackageIds: _react.PropTypes.array,
  checkAll: _react.PropTypes.func,
  checkOnePackage: _react.PropTypes.func,
  savingSettings: _react.PropTypes.bool
};

var productMapping = function (_Component) {
  _inherits(productMapping, _Component);

  function productMapping() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, productMapping);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = productMapping.__proto__ || Object.getPrototypeOf(productMapping)).call.apply(_ref, [this].concat(args))), _this), _this._sendContractnMapping = function (contract) {
      _this.props.getConvertedContract(contract.contractId, _this.props.ratePackageIds);
    }, _this.convertExportStatus = function (exportStatus) {
      return _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('exporting'), _ramda2.default.always('loading')], [_ramda2.default.equals('success'), _ramda2.default.always('hide')], [_ramda2.default.equals('failed'), _ramda2.default.always('ready')], [_ramda2.default.T, _ramda2.default.always('hide')]]), exportStatus);
    }, _this.savePriceCodesSettings = function (tourPlanOptionID) {
      return (0, _lodash2.default)(function (newCodes) {
        var _this$props = _this.props,
            saveSettings = _this$props.saveSettings,
            priceCodesSetting = _this$props.priceCodesSetting;

        saveSettings({
          priceCodesSetting: _extends({}, priceCodesSetting, {
            productRulesObj: _extends({}, priceCodesSetting.productRulesObj, _defineProperty({}, tourPlanOptionID, newCodes))
          })
        });
      }, 500);
    }, _this.checkOnePackage = function (ratePackageId, hasRates) {
      return function (_, checked) {
        return _this.props.checkOnePackage({
          ratePackageId: ratePackageId,
          hasRates: hasRates,
          checked: checked
        });
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(productMapping, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          contract = _props.contract,
          exportStatus = _props.exportStatus,
          _props$priceCodesSett = _props.priceCodesSetting,
          priceCodesSetting = _props$priceCodesSett === undefined ? {} : _props$priceCodesSett,
          ratePackageIds = _props.ratePackageIds,
          checkAll = _props.checkAll,
          convertedContract = _props.convertedContract,
          savingSettings = _props.savingSettings;
      var _priceCodesSetting$pr = priceCodesSetting.productRulesObj,
          productRulesObj = _priceCodesSetting$pr === undefined ? {} : _priceCodesSetting$pr;
      var router = this.context.router;

      if (!contract || _ramda2.default.isEmpty(contract)) return false;
      var spinner = this.convertExportStatus(exportStatus);
      var exportReady = Boolean(_ramda2.default.find(function (product) {
        return product.tourPlanOptionName;
      }, contract.products));
      var hasMerge = _ramda2.default.groupWith(function (a, b) {
        return a.tourPlanOptionID === b.tourPlanOptionID;
      }, contract.products.filter(function (o) {
        return ratePackageIds.indexOf(o._id) > -1;
      })).some(function (arr) {
        return arr.length > 1;
      });
      var histories = function () {
        if (!contract.locationLogs || contract.locationLogs.length === 0) {
          return _react2.default.createElement(
            'div',
            { style: { margin: '20px', textAlign: 'center' } },
            'No Export History'
          );
        }
        return _react2.default.createElement(
          'div',
          { style: { width: '75%', margin: '30px auto 40px', borderLeft: '2px solid #e8e8e8' } },
          contract.locationLogs.sort(function (a, b) {
            if (a.timestamp < b.timestamp) return 1;
            if (a.timestamp > b.timestamp) return -1;
            return 0;
          }).map(function (log, index) {
            return _react2.default.createElement(_exportHistoryFeed2.default, _extends({}, log, { key: index }));
          })
        );
      }();

      var hasRates = Boolean(_ramda2.default.find(_ramda2.default.propEq('hasRates', true), contract.products));
      return _react2.default.createElement(
        'div',
        { style: { marginTop: '16px' } },
        _react2.default.createElement(
          _materialUi.Paper,
          { style: { width: '100%', paddingBottom: '4px' } },
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: '3%', height: '48px', borderBottom: '2px solid #f5f5f5', width: '100%' }, className: 'tc-table-sub-header flex-tc-sb' },
            _react2.default.createElement(
              'div',
              { style: { width: '32px' } },
              _react2.default.createElement(_materialUi.Checkbox, {
                checked: ratePackageIds.length === contract.products.filter(function (o) {
                  return o.tourPlanOptionID;
                }).length,
                onCheck: checkAll
              })
            ),
            _react2.default.createElement(
              'div',
              { style: { fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: 'calc(50% - 282px)' } },
              'TourConnect Name'
            ),
            _react2.default.createElement(
              'div',
              { style: { fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '250px' } },
              'Tourplan Option ID'
            ),
            _react2.default.createElement(
              'div',
              { style: { fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: 'calc(50% - 420px)' } },
              'Tourplan Name'
            ),
            _react2.default.createElement(
              'div',
              { style: { fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '140px' } },
              'Rate Status'
            ),
            _react2.default.createElement(
              'div',
              { style: { fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '140px' } },
              'Export To'
            ),
            _react2.default.createElement(
              'div',
              { style: { fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '140px', paddingRight: '8px' }, className: 'flex-tc-sb' },
              'Tourplan Price Code',
              Boolean(savingSettings) && _react2.default.createElement(_materialUi.CircularProgress, { size: 30 })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { marginBottom: '24px' } },
            (contract.products || []).map(function (product, index) {
              return _react2.default.createElement(_productMappingProduct2.default, _extends({}, _this2.props, product, {
                index: index,
                key: index,
                checked: ratePackageIds.indexOf(product._id) > -1,
                startDate: contract.startDate,
                endDate: contract.endDate,
                exportTo: product.exportTo || 'FIT & Group',
                rateSetStatus: product.rateSetStatus || 'K',
                checkOnePackage: _this2.checkOnePackage(product._id, product.hasRates),
                priceCodes: productRulesObj[product.tourPlanOptionID],
                savePriceCodesSettings: _this2.savePriceCodesSettings(product.tourPlanOptionID)
              }));
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
          _react2.default.createElement(_raisedButtonWithLoader2.default, { style: { float: 'left', margin: '10px 0 15px' }, primary: true, label: 'Back', onClick: function onClick() {
              return router.push('/integration/contracts');
            } }),
          _react2.default.createElement(
            'div',
            { className: 'flex-center', style: { width: '30%', flexDirection: 'row-reverse' } },
            _react2.default.createElement(
              'div',
              { className: 'flex-center' },
              Boolean(convertedContract && convertedContract.length) ? _react2.default.createElement(_materialUi.FlatButton, {
                secondary: true,
                disabled: !exportReady || spinner === 'loading' || !ratePackageIds.length || savingSettings,
                label: 'Re-Generate Export Preview',
                onClick: this._sendContractnMapping.bind(this, contract)
              }) : _react2.default.createElement(_raisedButtonWithLoader2.default, {
                disabled: !exportReady || spinner === 'loading' || !ratePackageIds.length || savingSettings,
                secondary: true,
                label: 'Generate Export Preview',
                onClick: this._sendContractnMapping.bind(this, contract)
              }),
              _react2.default.createElement(_materialUi.RefreshIndicator, { size: 30, percentage: 60, left: 5, top: 5, status: spinner })
            )
          )
        ),
        hasRates && _react2.default.createElement(
          'div',
          { style: { display: 'flex', alignItems: 'center', textAlign: 'left', overflow: 'auto', marginLeft: '8%', marginTop: '10px', height: '64px' } },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-warning2', color: 'grey' }),
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', marginLeft: '8px' } },
            'Tourplan currently has rates for the option that this product has been mapped to. You can overwrite the rates in Tourplan by re-exporting or map this product to a new option.'
          )
        ),
        hasMerge && _react2.default.createElement(
          'div',
          { style: { display: 'flex', alignItems: 'center', textAlign: 'left', overflow: 'auto', marginLeft: '4%', width: '92%', marginTop: '10px', height: '64px' } },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-warning2', color: '#ff4081' }),
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', marginLeft: '8px' } },
            'You are attempting to export two TourConnect products into the same Tourplan Option. This feature should only be used to export both FIT and Group rates at the same time, using the same seasons and general settings for both products.'
          )
        ),
        contract.products.some(function (prod) {
          return prod.hasPrivateTransfers;
        }) && _react2.default.createElement(
          'div',
          { style: { display: 'flex', alignItems: 'center', textAlign: 'left', overflow: 'auto', marginLeft: '4%', width: '92%', marginTop: '10px', height: '64px' } },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-bulb', color: 'orange' }),
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', marginLeft: '8px' } },
            'TourConnect\u2019s \u2018Up-to X Pax\u2019 pricing is based on group pricing.  When importing these rates into your system, you can convert Up to X Pax to Group Pax Break pricing. For example, Up to 2 Pax = $200, Up to 5 Pax = $450, Up to 8 Pax = $560 can convert to 1-2 Pax = $100, 3-5 Pax = $450, 6-8 Pax = $560.'
          )
        ),
        _react2.default.createElement(_sectionHeading2.default, {
          title: 'Export History',
          subtitle: 'Contract Year ' + (contract.contractYear || 'year').slice(4),
          style: { whiteSpace: 'pre-wrap', margin: '12px 0 32px' }
        }),
        _react2.default.createElement(
          _materialUi.Card,
          { style: { width: '100%', margin: '40px 0', padding: '24px 0' } },
          histories
        )
      );
    }
  }]);

  return productMapping;
}(_react.Component);

productMapping.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref2) {
  var integration = _ref2.integration;
  return {
    displayExportPreview: integration.get('displayExportPreview'),
    exportStatus: integration.get('exportStatus'),
    ratePackageIds: integration.get('ratePackageIds') ? integration.get('ratePackageIds').toJS() : [],
    contract: integration.get('contract') ? integration.get('contract').toJS() : {},
    convertedContract: integration.get('convertedContract') ? integration.get('convertedContract').toJS() : [],
    priceCodesSetting: integration.getIn(['settings', 'priceCodesSetting']) ? integration.getIn(['settings', 'priceCodesSetting']).toJS() : {},
    savingSettings: integration.getIn(['settings', 'savingSettings'])
  };
};
var mapDispatchToProps = {
  checkAll: function checkAll(_, checked) {
    return { type: 'CHECK_ALL_RATE_PACKAGE_FOR_TOURPLAN_EXPORT', payload: { checked: checked } };
  },
  checkOnePackage: function checkOnePackage(payload) {
    return { type: 'CHECK_A_RATE_PACKAGE_FOR_TOURPLAN_EXPORT', payload: payload };
  }
};
productMapping.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(productMapping);

/***/ }),
/* 2951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _integrationTourplanLogin = __webpack_require__(1228);

var _integrationTourplanLogin2 = _interopRequireDefault(_integrationTourplanLogin);

var _warning = __webpack_require__(2952);

var _warning2 = _interopRequireDefault(_warning);

var _checkCircle = __webpack_require__(1044);

var _checkCircle2 = _interopRequireDefault(_checkCircle);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  productId: _react.PropTypes.string,
  tourPlanOptionID: _react.PropTypes.string,
  tourPlanOptionName: _react.PropTypes.string,
  exportTo: _react.PropTypes.string,
  rateSetStatus: _react.PropTypes.string,
  validateMappingStatus: _react.PropTypes.string,
  index: _react.PropTypes.number,
  startDate: _react.PropTypes.string,
  endDate: _react.PropTypes.string,
  checkIfHasRates: _react.PropTypes.func,
  validateMapping: _react.PropTypes.func,
  updateMapping: _react.PropTypes.func,
  dispatch: _react.PropTypes.func,
  hasRates: _react.PropTypes.bool,
  productName: _react.PropTypes.string,
  user: _react.PropTypes.object,
  integration: _react.PropTypes.object,
  contract: _react.PropTypes.object,
  ratePackageName: _react.PropTypes.string,
  priceCodes: _react.PropTypes.array,
  savePriceCodesSettings: _react.PropTypes.func,
  checkOnePackage: _react.PropTypes.func,
  checked: _react.PropTypes.bool,
  hasPrivateTransfers: _react.PropTypes.bool
};
// REWRITE THIS WHOLE THING WHEN POSSIBLE

var Product = function (_Component) {
  _inherits(Product, _Component);

  function Product(props) {
    _classCallCheck(this, Product);

    var _this = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this, props));

    _this.onChangePriceCodes = function (e) {
      var savePriceCodesSettings = _this.props.savePriceCodesSettings;

      var codes = e.target.value.split(',');
      savePriceCodesSettings(codes);
    };

    _this.onUpdateExportTo = function (option) {
      var _this$props = _this.props,
          index = _this$props.index,
          contract = _this$props.contract,
          updateMapping = _this$props.updateMapping;

      updateMapping(index, {
        contractWithProductToUpdate: _extends({}, contract, {
          products: [_extends({}, contract.products[index], {
            exportTo: option.value
          })]
        })
      }, { exportTo: option.value });
    };

    _this.onUpdateRateSetStatus = function (option) {
      var _this$props2 = _this.props,
          index = _this$props2.index,
          contract = _this$props2.contract,
          updateMapping = _this$props2.updateMapping;

      updateMapping(index, {
        contractWithProductToUpdate: _extends({}, contract, {
          products: [_extends({}, contract.products[index], {
            rateSetStatus: option.value
          })]
        })
      }, { rateSetStatus: option.value });
    };

    _this._handleOnBlur = function (e) {
      _this._validate(e.target.value);
    };

    _this._handleOnChange = function (e) {
      if (e.target.value.length > 15) {
        _this._validate(e.target.value);
      }
    };

    _this._validate = function (value) {
      var _this$props3 = _this.props,
          index = _this$props3.index,
          startDate = _this$props3.startDate,
          endDate = _this$props3.endDate,
          contract = _this$props3.contract,
          productId = _this$props3.productId;

      var tpID = value.trim().toUpperCase();
      var contractWithSingleProductMapping = (0, _ramda.merge)(contract, { products: (0, _ramda.slice)(index, index + 1, contract.products) });
      _this.props.validateMapping(index, tpID, startDate, endDate, contractWithSingleProductMapping, productId);
    };

    _this._edit = function () {
      _this.setState({ disableTF: false });
    };

    _this._dialogLoginHide = function () {
      _this.refs.dialogLogin.dismiss();
      _this.setState({ errorText: '' });
    };

    _this.state = {
      productId: props.productId,
      disableTF: Boolean(props.tourPlanOptionID),
      tpName: props.tourPlanOptionName ? props.tourPlanOptionName : undefined,
      validateStatus: props.tourPlanOptionName ? 'ready' : props.validateMappingStatus || undefined,
      doNotCheckRates: false,
      dialogLogin: false
    };
    return _this;
  }

  _createClass(Product, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          index = _props.index,
          tourPlanOptionID = _props.tourPlanOptionID,
          startDate = _props.startDate,
          endDate = _props.endDate,
          contract = _props.contract;

      if (tourPlanOptionID && !_ramda2.default.has('hasRates', this.props)) {
        var contractWithSingleProductMapping = (0, _ramda.merge)(contract, { products: (0, _ramda.slice)(index, index + 1, contract.products) });
        this.props.checkIfHasRates(index, tourPlanOptionID, startDate, endDate, contractWithSingleProductMapping);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var validateMappingStatus = nextProps.validateMappingStatus;
      var tourPlanOptionName = nextProps.tourPlanOptionName;
      var validateError = nextProps.validateError;
      var errorText = void 0;
      if (validateError === '404' || validateError === '400' || validateError === 'Not Found') {
        errorText = 'ID is invalid.';
      } else if (validateError === '401') {
        this.setState({ dialogOpen: true });
        errorText = 'Authentication Error';
      } else if (validateError) {
        errorText = 'Server error: please try again later or contact our customer service';
      }

      this.setState({
        disableTF: Boolean(nextProps.tourPlanOptionID),
        validateStatus: tourPlanOptionName ? 'ready' : validateMappingStatus || undefined,
        tpName: tourPlanOptionName,
        errorText: errorText
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var productHintText = 'Option ID';
      var indicator = function () {
        if (_this2.props.validateMappingStatus === 'validating') {
          return _react2.default.createElement(_materialUi.RefreshIndicator, { size: 30, top: 0, left: 0, status: 'loading', style: { position: 'none' } });
        } else if (_this2.props.validateMappingStatus === 'ready' && _this2.props.tourPlanOptionID) {
          if (_this2.props.hasRates) return _react2.default.createElement(_warning2.default, { color: 'rgba(0, 0, 0, 0.54)' });
          return _react2.default.createElement(_checkCircle2.default, { color: '#00bcd4' });
        } else if (_this2.props.validateMappingStatus === 'failed') {
          return _react2.default.createElement(_materialUi.RefreshIndicator, { percentage: 60, size: 30, top: 0, left: 0, status: 'ready', style: { position: 'none' } });
        }
      }();
      return _react2.default.createElement(
        'div',
        { style: { width: '100%', paddingLeft: '3%', justifyContent: 'space-between', display: 'flex', alignItems: 'center' } },
        _react2.default.createElement(
          'div',
          { style: { width: '32px' } },
          _react2.default.createElement(_materialUi.Checkbox, {
            disabled: !Boolean(this.props.tourPlanOptionID),
            checked: this.props.checked,
            onCheck: this.props.checkOnePackage
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { width: 'calc(50% - 282px)', fontSize: '14px' }, className: 'flex-center' },
          this.props.productName,
          ' ',
          this.props.ratePackageName ? ' - ' + this.props.ratePackageName : '',
          this.props.hasPrivateTransfers && _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-bulb', color: 'orange', style: { fontSize: '20px' } })
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '250px', display: 'flex', alignItems: 'center' } },
          _react2.default.createElement(_materialUi.TextField, {
            style: { width: '80%', minWidth: '200px' },
            ref: this.state.productId,
            errorText: this.state.errorText,
            id: this.state.productId,
            defaultValue: this.props.tourPlanOptionID || '',
            onBlur: this._handleOnBlur.bind(this),
            onChange: this._handleOnChange.bind(this),
            hintText: productHintText,
            disabled: this.state.disableTF
          }),
          _react2.default.createElement(_materialUi.IconButton, {
            iconClassName: this.state.disableTF ? 'tc-icon-mode_edit' : '',
            iconStyle: { color: '#E5625C', fontSize: '14px' },
            style: { width: '36px', height: '36px' },
            onClick: this._edit.bind(this),
            tooltip: 'Edit'
          })
        ),
        _react2.default.createElement(
          'div',
          { style: {
              width: 'calc(50% - 420px)',
              display: 'flex',
              alignItems: 'center',
              color: this.props.hasRates ? 'grey' : '#00bcd4'
            }
          },
          indicator,
          _react2.default.createElement(
            'div',
            { style: { marginLeft: '8px' } },
            this.state.tpName
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '140px' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'rateStatus',
            style: { width: '80%' },
            options: [{ value: 'K', label: 'Confirmed' }, { value: 'P', label: 'Provisional' }],
            value: this.props.rateSetStatus,
            onChange: this.onUpdateRateSetStatus,
            defaultValue: 'K',
            clearable: false
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '140px' } },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'exportTo',
            style: { width: '80%' },
            options: [{ value: 'FIT', label: 'FIT' }, { value: 'Group', label: 'Group' }, { value: 'FIT & Group', label: 'FIT & Group' }],
            value: this.props.exportTo,
            onChange: this.onUpdateExportTo,
            defaultValue: 'FIT',
            clearable: false
          })
        ),
        _react2.default.createElement(
          'div',
          {
            style: { fontSize: '14px', color: 'rgb(54%, 54%, 54%)', width: '140px' }
          },
          _react2.default.createElement('input', {
            id: this.state.productId + 'priceCodes',
            style: { width: '120px' },
            placeholder: 'Based on settings',
            defaultValue: this.props.priceCodes ? this.props.priceCodes.join(',') : '',
            onChange: this.onChangePriceCodes
          }),
          Boolean(this.props.priceCodes && this.props.priceCodes && !/^[a-zA-Z0-9,]*$/.test(this.props.priceCodes.join(','))) && _react2.default.createElement(
            'div',
            { style: { color: '#ff4081' } },
            _react2.default.createElement(
              'small',
              null,
              'Please separate price codes using commas only.'
            )
          )
        ),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            open: this.state.dialogLogin,
            ref: 'dialogLogin',
            actions: [_react2.default.createElement(_materialUi.FlatButton, {
              label: 'Dismiss',
              key: 'dialogLoginDismiss',
              secondary: true,
              disableTouchRipple: true,
              onClick: this._dialogLoginHide.bind(this)
            })],
            modal: true
          },
          _react2.default.createElement(_integrationTourplanLogin2.default, _extends({}, this.props, { transition: this._dialogLoginHide.bind(this), type: 'validate' }))
        )
      );
    }
  }]);

  return Product;
}(_react.Component);

Product.propTypes = propTypes;

exports.default = Product;

/***/ }),
/* 2952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertWarning = function AlertWarning(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
  );
};
AlertWarning = (0, _pure2.default)(AlertWarning);
AlertWarning.displayName = 'AlertWarning';
AlertWarning.muiName = 'SvgIcon';

exports.default = AlertWarning;

/***/ }),
/* 2953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _radioButtonUnchecked = __webpack_require__(1359);

var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);

var _singleProductExportStatus = __webpack_require__(1909);

var _singleProductExportStatus2 = _interopRequireDefault(_singleProductExportStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HistoryFeed = function HistoryFeed(_ref) {
  var user = _ref.user,
      timestamp = _ref.timestamp,
      products = _ref.products;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '5px' } },
      _react2.default.createElement(_radioButtonUnchecked2.default, { color: '#c8c8c8', style: { position: 'relative', fontSize: '15px', height: '25px', width: '20px', left: '-11px', top: '-18px', backgroundColor: 'white' } }),
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', marginLeft: '20px' } },
        _react2.default.createElement(
          'span',
          { style: { display: 'block', fontWeight: '600', fontSize: '14px' } },
          user
        ),
        _react2.default.createElement(
          'span',
          { style: { display: 'block', fontSize: 'small' } },
          (0, _moment2.default)(timestamp).format('MMMM Do YYYY, h:mm:ss a')
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { marginLeft: '40px', marginBottom: '24px', border: '1px solid #E6E6E6', padding: '5px 10px' } },
      products.map(function (product, index) {
        return _react2.default.createElement(_singleProductExportStatus2.default, _extends({}, product, { key: index }));
      })
    )
  );
};

HistoryFeed.propTypes = {
  user: _react.PropTypes.string,
  timestamp: _react.PropTypes.string,
  products: _react.PropTypes.array
};

module.exports = HistoryFeed;

/***/ }),
/* 2954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _singleProductPreview = __webpack_require__(2955);

var _singleProductPreview2 = _interopRequireDefault(_singleProductPreview);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  convertedContract: _react2.default.PropTypes.array,
  contract: _react2.default.PropTypes.object,
  updateWithKeyPath: _react2.default.PropTypes.func,
  sendMsg: _react2.default.PropTypes.func,
  exportContract: _react2.default.PropTypes.func,
  editCarriesTo: _react2.default.PropTypes.string,
  checkIfDupeRateNameExistsWithinADateRange: _react2.default.PropTypes.func
};

var ExportContentPreview = function (_React$Component) {
  _inherits(ExportContentPreview, _React$Component);

  function ExportContentPreview() {
    _classCallCheck(this, ExportContentPreview);

    var _this = _possibleConstructorReturn(this, (ExportContentPreview.__proto__ || Object.getPrototypeOf(ExportContentPreview)).call(this));

    _this.state = { selectedIndex: 0 };
    return _this;
  }

  _createClass(ExportContentPreview, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react2.default.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          convertedContract = _props.convertedContract,
          updateWithKeyPath = _props.updateWithKeyPath,
          _sendMsg = _props.sendMsg,
          editCarriesTo = _props.editCarriesTo,
          checkIfDupeRateNameExistsWithinADateRange = _props.checkIfDupeRateNameExistsWithinADateRange;

      if (!(convertedContract && convertedContract.length)) return _react2.default.createElement('div', null);
      var selectedIndex = this.state.selectedIndex;

      var productToDisplay = convertedContract[selectedIndex];
      var ifDupeRateNameExistsAtAll = function ifDupeRateNameExistsAtAll(product) {
        return product.forTourplan.some(function (_ref) {
          var DateRange = _ref.DateRange;
          return checkIfDupeRateNameExistsWithinADateRange(DateRange);
        });
      };
      return _react2.default.createElement(
        _materialUi.Paper,
        { style: { display: 'flex', marginTop: '8px' } },
        _react2.default.createElement(
          _materialUi.List,
          {
            style: { width: '15%', padding: '0' }
          },
          convertedContract.map(function (product, index) {
            return _react2.default.createElement(
              'div',
              { key: index },
              _react2.default.createElement(_materialUi.ListItem, {
                style: selectedIndex === index ? { backgroundColor: '#e0e0e0' } : {},
                primaryText: _react2.default.createElement(
                  'span',
                  { style: { display: 'flex', alignItems: 'center', wordBreak: 'break-word' } },
                  product.tourplanName,
                  ' (',
                  product.mapping,
                  ')',
                  ifDupeRateNameExistsAtAll(product) ? _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-report', style: { color: 'red', marginLeft: '4px' } }) : _react2.default.createElement('span', null)
                ),
                onTouchTap: function onTouchTap() {
                  return _this2.setState({ selectedIndex: index });
                }
              }),
              _react2.default.createElement(_materialUi.Divider, null)
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '85%', borderLeft: '1px solid #e0e0e0', padding: '0 4px 4px 4px' } },
          _react2.default.createElement(_singleProductPreview2.default, _extends({}, productToDisplay, {
            checkIfDupeRateNameExistsWithinADateRange: checkIfDupeRateNameExistsWithinADateRange,
            convertedContract: convertedContract,
            editCarriesTo: editCarriesTo,
            sendMsg: function sendMsg() {
              return _sendMsg(['convertedContract', selectedIndex], productToDisplay.historyFeedId, productToDisplay.discrepancyMsg);
            },
            updateWithKeyPath: updateWithKeyPath,
            updateThisProductWithKeyPath: function updateThisProductWithKeyPath(path, val) {
              return updateWithKeyPath(_ramda2.default.concat(['convertedContract', selectedIndex], path), val);
            }
          }))
        )
      );
    }
  }]);

  return ExportContentPreview;
}(_react2.default.Component);

ExportContentPreview.propTypes = propTypes;
var mapStateToProps = function mapStateToProps(_ref2) {
  var integration = _ref2.integration;
  return {
    editCarriesTo: integration.toJS().editCarriesTo,
    contract: integration.toJS().contract,
    convertedContract: integration.get('convertedContract') ? integration.get('convertedContract').toJS() : []
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ExportContentPreview);

/***/ }),
/* 2955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _arrowForward = __webpack_require__(1246);

var _arrowForward2 = _interopRequireDefault(_arrowForward);

var _previewRateNameText = __webpack_require__(2956);

var _previewRateNameText2 = _interopRequireDefault(_previewRateNameText);

var _previewExtras = __webpack_require__(2957);

var _previewExtras2 = _interopRequireDefault(_previewExtras);

var _previewAgePolicies = __webpack_require__(2961);

var _previewAgePolicies2 = _interopRequireDefault(_previewAgePolicies);

var _previewRoomPolicies = __webpack_require__(2962);

var _previewRoomPolicies2 = _interopRequireDefault(_previewRoomPolicies);

var _previewDiscrepancyMsgBox = __webpack_require__(2963);

var _previewDiscrepancyMsgBox2 = _interopRequireDefault(_previewDiscrepancyMsgBox);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _previewNotes = __webpack_require__(2964);

var _previewNotes2 = _interopRequireDefault(_previewNotes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// extraProps has policies, extraLines, pickedExtras, notPickedExtras, updateWithKeyPath, discrepancyMsg, sendMsg
var ExportContentPreview = function ExportContentPreview(_ref) {
  var productName = _ref.productName,
      mapping = _ref.mapping,
      tourplanName = _ref.tourplanName,
      style = _ref.style,
      stayPayExists = _ref.stayPayExists,
      ChargeExtras = _ref.ChargeExtras,
      extraProps = _objectWithoutProperties(_ref, ['productName', 'mapping', 'tourplanName', 'style', 'stayPayExists', 'ChargeExtras']);

  return _react2.default.createElement(
    'div',
    { style: style },
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', paddingLeft: '16px', alignItems: 'center', minHeight: '56px', borderBottom: '1px solid #e0e0e0' } },
      Array.isArray(productName) ? _react2.default.createElement(
        'div',
        { style: { whiteSpace: 'pre-wrap' } },
        productName.join('\n')
      ) : productName,
      _react2.default.createElement(_arrowForward2.default, { style: { fontSize: '15px', margin: '0 5px', top: '2px' }, color: "#c8c8c8" }),
      ' ' + tourplanName + ' (' + mapping + ')'
    ),
    _react2.default.createElement(
      'div',
      { style: { padding: '16px', borderBottom: '1px solid #e0e0e0' } },
      _react2.default.createElement(
        'label',
        null,
        'Edit Rule:'
      ),
      _react2.default.createElement(_materialUi.RadioButton, {
        label: 'Changes apply to one field only',
        checked: !extraProps.editCarriesTo,
        onCheck: function onCheck() {
          return extraProps.updateWithKeyPath(['editCarriesTo'], null);
        }
      }),
      _react2.default.createElement(_materialUi.RadioButton, {
        label: 'Changes apply to similar seasons within a product',
        checked: extraProps.editCarriesTo === 'sameProduct',
        onCheck: function onCheck() {
          return extraProps.updateWithKeyPath(['editCarriesTo'], 'sameProduct');
        }
      }),
      _react2.default.createElement(_materialUi.RadioButton, {
        label: 'Changes apply to similar seasons across all products',
        checked: extraProps.editCarriesTo === 'sameSeasonAcrossProducts',
        onCheck: function onCheck() {
          return extraProps.updateWithKeyPath(['editCarriesTo'], 'sameSeasonAcrossProducts');
        }
      }),
      _react2.default.createElement(_materialUi.RadioButton, {
        label: 'Changes apply to same field across all products',
        checked: extraProps.editCarriesTo === 'sameFieldAllSeasonsAllProducts',
        onCheck: function onCheck() {
          return extraProps.updateWithKeyPath(['editCarriesTo'], 'sameFieldAllSeasonsAllProducts');
        }
      })
    ),
    _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { display: 'flex', padding: '16px' },
      leftColumnStyle: { width: '35%' },
      leftColumnContent: _react2.default.createElement(_previewRateNameText2.default, extraProps),
      rightColumnStyle: { width: '65%', marginLeft: '2%' },
      rightColumnContent: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_previewExtras2.default, extraProps),
        Boolean(stayPayExists && _ramda2.default.values(extraProps.extraLines).filter(function (x) {
          return x;
        }).length) && _react2.default.createElement(
          'div',
          { style: { margin: '3em auto' } },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', width: '100%' } },
            _react2.default.createElement('div', { style: { width: '20%' } }),
            _react2.default.createElement(
              'div',
              { style: { textAlign: 'center', fontWeight: 'bold', paddingBottom: '16px', fontSize: '18px', width: '80%', borderBottom: '1px solid black' } },
              'Charge extras on FOC night for Stay Pay'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', width: '100%', marginTop: '1em' } },
            _react2.default.createElement('div', { style: { width: '40%' } }),
            _react2.default.createElement(
              'div',
              { style: { width: '40%' } },
              _ramda2.default.values(extraProps.extraLines).map(function (line, i) {
                return line ? _react2.default.createElement(_materialUi.Checkbox, {
                  key: i,
                  label: line,
                  checked: ChargeExtras['ChargeExtra' + (i + 1)] === 'Y',
                  onCheck: function onCheck(_, checked) {
                    return extraProps.updateThisProductWithKeyPath(['ChargeExtras', 'ChargeExtra' + (i + 1)], checked ? 'Y' : 'N');
                  }
                }) : _react2.default.createElement('div', { key: i });
              })
            )
          )
        ),
        _react2.default.createElement(_previewNotes2.default, extraProps),
        _react2.default.createElement(_previewRoomPolicies2.default, extraProps),
        _react2.default.createElement(_previewAgePolicies2.default, extraProps),
        _react2.default.createElement(_previewDiscrepancyMsgBox2.default, extraProps)
      )
    })
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var integration = _ref2.integration;
  return {
    convertedContract: integration.get('convertedContract') ? integration.get('convertedContract').toJS() : []
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ExportContentPreview);

/***/ }),
/* 2956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _immutable = __webpack_require__(26);

var _errorOutline = __webpack_require__(1515);

var _errorOutline2 = _interopRequireDefault(_errorOutline);

var _keyboardArrowDown = __webpack_require__(1350);

var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getDate = function getDate(fieldName) {
  return _ramda2.default.compose(_ramda2.default.ifElse(_ramda2.default.identity, function (date) {
    return (0, _moment2.default)(date).format('D MMM YYYY');
  }, _ramda2.default.identity), _ramda2.default.propOr('', fieldName));
};
var getNewForTourplanWhenRateSetDataChanges = function getNewForTourplanWhenRateSetDataChanges(forTourplan, seasonId, rateSetIndex, fieldName, newValue, currentVal) {
  return forTourplan.map(function (obj) {
    if (obj.DateRange.seasonId === seasonId) {
      var newDateRange = _ramda2.default.merge(obj.DateRange, {
        RateSet: obj.DateRange.RateSet.map(function (rateSetObj, thisIndex) {
          if (!rateSetObj[fieldName] || !currentVal) {
            if (thisIndex === rateSetIndex) return _ramda2.default.merge(rateSetObj, _defineProperty({}, fieldName, newValue));
          } else if (rateSetObj[fieldName] === currentVal) return _ramda2.default.merge(rateSetObj, _defineProperty({}, fieldName, newValue));
          return rateSetObj;
        })
      });
      return _ramda2.default.merge(obj, { DateRange: newDateRange });
    }
    return obj;
  });
};

var RateNameText = function RateNameText(_ref) {
  var updateThisProductWithKeyPath = _ref.updateThisProductWithKeyPath,
      convertedContract = _ref.convertedContract,
      updateWithKeyPath = _ref.updateWithKeyPath,
      forTourplan = _ref.forTourplan,
      editCarriesTo = _ref.editCarriesTo,
      checkIfDupeRateNameExistsWithinADateRange = _ref.checkIfDupeRateNameExistsWithinADateRange;

  var updateFieldStandalone = function updateFieldStandalone(_ref2) {
    var isInRateSet = _ref2.isInRateSet;

    if (isInRateSet) {
      return function (dateRangeIndex, seasonId, rateSetIndex, fieldName, newValue) {
        updateThisProductWithKeyPath(['forTourplan', dateRangeIndex, 'DateRange', 'RateSet', rateSetIndex, fieldName], newValue);
      };
    }
    return function (dateRangeIndex, seasonId, path, value) {
      updateThisProductWithKeyPath(['forTourplan', dateRangeIndex, 'DateRange'].concat(_toConsumableArray(path)), value);
    };
  };
  var updateFieldForSameSeason = function updateFieldForSameSeason(_ref3) {
    var isInRateSet = _ref3.isInRateSet;

    if (isInRateSet) {
      return function (dateRangeIndex, seasonId, rateSetIndex, fieldName, newValue, currentVal) {
        var newData = getNewForTourplanWhenRateSetDataChanges(forTourplan, seasonId, rateSetIndex, fieldName, newValue, currentVal);
        updateThisProductWithKeyPath(['forTourplan'], (0, _immutable.fromJS)(newData));
      };
    }
    return function (dateRangeIndex, seasonId, path, value) {
      var newData = forTourplan.map(function (obj) {
        if (obj.DateRange.seasonId === seasonId) return _ramda2.default.assocPath(['DateRange'].concat(_toConsumableArray(path)), value, obj);
        return obj;
      });
      updateThisProductWithKeyPath(['forTourplan'], (0, _immutable.fromJS)(newData));
    };
  };
  var updateFieldForSameSeasonAcrossProducts = function updateFieldForSameSeasonAcrossProducts(_ref4) {
    var isInRateSet = _ref4.isInRateSet;

    if (isInRateSet) {
      return function (dateRangeIndex, seasonId, rateSetIndex, fieldName, newValue, currentVal) {
        var newConvertedContract = convertedContract.map(function (product) {
          return _extends({}, product, {
            forTourplan: getNewForTourplanWhenRateSetDataChanges(product.forTourplan, seasonId, rateSetIndex, fieldName, newValue, currentVal)
          });
        });
        updateWithKeyPath(['convertedContract'], (0, _immutable.fromJS)(newConvertedContract));
      };
    }
    return function (dateRangeIndex, seasonId, path, value) {
      var newData = convertedContract.map(function (product) {
        return _extends({}, product, {
          forTourplan: product.forTourplan.map(function (obj) {
            if (obj.DateRange.seasonId === seasonId) return _ramda2.default.assocPath(['DateRange'].concat(_toConsumableArray(path)), value, obj);
            return obj;
          })
        });
      });
      updateWithKeyPath(['convertedContract'], (0, _immutable.fromJS)(newData));
    };
  };

  var updateFieldForSameSeasonsAllProducts = function updateFieldForSameSeasonsAllProducts(_ref5) {
    var isInRateSet = _ref5.isInRateSet;

    if (isInRateSet) {
      return function (dateRangeIndex, seasonId, rateSetIndex, fieldName, newValue, currentVal) {
        if (fieldName === 'Rate_Text' || fieldName === 'Stay_Type') {
          alert('You cannot update all Rate Name or Rate Text to the same value. Please update the edit rule.');
        } else {
          var newData = convertedContract.map(function (product) {
            return _extends({}, product, {
              forTourplan: product.forTourplan.map(function (obj) {
                return _extends({}, obj, {
                  DateRange: _extends({}, obj.DateRange, {
                    RateSet: obj.DateRange.RateSet.map(function (rs) {
                      return _extends({}, rs, _defineProperty({}, fieldName, newValue));
                    })
                  })
                });
              })
            });
          });
          updateWithKeyPath(['convertedContract'], (0, _immutable.fromJS)(newData));
        }
      };
    }
    return function (dateRangeIndex, seasonId, path, value) {
      var newData = convertedContract.map(function (product) {
        return _extends({}, product, {
          forTourplan: product.forTourplan.map(function (obj) {
            return _ramda2.default.assocPath(['DateRange'].concat(_toConsumableArray(path)), value, obj);
          })
        });
      });
      updateWithKeyPath(['convertedContract'], (0, _immutable.fromJS)(newData));
    };
  };

  var updateFn = _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('sameProduct'), _ramda2.default.always(updateFieldForSameSeason)], [_ramda2.default.equals('sameSeasonAcrossProducts'), _ramda2.default.always(updateFieldForSameSeasonAcrossProducts)], [_ramda2.default.equals('sameFieldAllSeasonsAllProducts'), _ramda2.default.always(updateFieldForSameSeasonsAllProducts)], [_ramda2.default.T, _ramda2.default.always(updateFieldStandalone)]]), editCarriesTo);
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { textAlign: 'center', fontWeight: 'bold', paddingBottom: '16px', fontSize: '18px' } },
      'Rate Name & Rate Text'
    ),
    forTourplan && !_ramda2.default.isEmpty(forTourplan) && forTourplan.map(function (_ref6, index) {
      var DateRange = _ref6.DateRange,
          collapsed = _ref6.collapsed;

      var duplicateRateName = checkIfDupeRateNameExistsWithinADateRange(DateRange);
      return _react2.default.createElement(
        'div',
        { key: index },
        _react2.default.createElement(
          'div',
          {
            style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' },
            onClick: function onClick() {
              return updateThisProductWithKeyPath(['forTourplan', index, 'collapsed'], !collapsed);
            }
          },
          _react2.default.createElement(
            'div',
            { style: { width: '50%', color: 'rgba(0, 0, 0, 0.64)', fontSize: '12px' } },
            getDate('Date_From')(DateRange),
            ' - ',
            getDate('Date_To')(DateRange)
          ),
          _react2.default.createElement(
            'div',
            { style: { color: 'rgba(0, 0, 0, 0.74)', width: '40%', textAlign: 'right', fontSize: '12px' } },
            DateRange.seasonName,
            ' ',
            DateRange.eventName ? '-' + DateRange.eventName : ''
          ),
          _react2.default.createElement(_keyboardArrowDown2.default, { style: { transform: Boolean(collapsed) ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 300ms ease-in-out' } })
        ),
        _react2.default.createElement(
          'div',
          { style: { display: collapsed ? 'none' : 'block' } },
          _react2.default.createElement(
            'div',
            { style: { marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' } },
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', width: '35%', color: 'rgba(0, 0, 0, 0.64)', fontSize: '12px' } },
              'Sale From:'
            ),
            _react2.default.createElement('input', {
              style: {
                border: DateRange.Sale_From !== DateRange.originalSale_From ? '2px solid #00bcd4' : '2px solid #e0e0e0',
                flexGrow: 2
              },
              value: _ramda2.default.pathOr('', ['Sale_From'], DateRange),
              onChange: function onChange(_ref7) {
                var value = _ref7.target.value;
                return updateFn({ isInRateSet: false })(index, DateRange.seasonId, ['Sale_From'], value, _ramda2.default.pathOr('', ['Sale_From'], DateRange));
              }
            }),
            _ramda2.default.pathOr('', ['Sale_From'], DateRange) && !_ramda2.default.test(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/, _ramda2.default.pathOr('', ['Sale_From'], DateRange)) && _react2.default.createElement(
              'small',
              { style: { color: 'red' } },
              'Please enter date in YYYY-MM-DD format'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' } },
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', width: '35%', color: 'rgba(0, 0, 0, 0.64)', fontSize: '12px' } },
              'Sale To:'
            ),
            _react2.default.createElement('input', {
              style: {
                border: DateRange.Sale_To !== DateRange.originalSale_To ? '2px solid #00bcd4' : '2px solid #e0e0e0',
                flexGrow: 2
              },
              value: _ramda2.default.pathOr('', ['Sale_To'], DateRange),
              onChange: function onChange(_ref8) {
                var value = _ref8.target.value;
                return updateFn({ isInRateSet: false })(index, DateRange.seasonId, ['Sale_To'], value, _ramda2.default.pathOr('', ['Sale_To'], DateRange));
              }
            }),
            _ramda2.default.pathOr('', ['Sale_To'], DateRange) && !_ramda2.default.test(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/, _ramda2.default.pathOr('', ['Sale_To'], DateRange)) && _react2.default.createElement(
              'small',
              { style: { color: 'red' } },
              'Please enter date in YYYY-MM-DD format'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' } },
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', width: '35%', color: 'rgba(0, 0, 0, 0.64)', fontSize: '12px' } },
              'Tax Code:'
            ),
            _react2.default.createElement('input', {
              style: {
                border: function () {
                  var currentVal = _ramda2.default.pathOr('', ['Taxes', 'TaxInfo', 'Tax'], DateRange);
                  if (!currentVal) return '2px solid #ff9100';
                  if (currentVal !== _ramda2.default.pathOr('', ['originalTaxes', 'TaxInfo', 'Tax'], DateRange)) return '2px solid #00bcd4';
                  return '2px solid #e0e0e0';
                }(),
                flexGrow: 2
              },
              value: _ramda2.default.pathOr('', ['Taxes', 'TaxInfo', 'Tax'], DateRange),
              onChange: function onChange(_ref9) {
                var value = _ref9.target.value;

                if (value && value.length > 3) alert('Maximum 3 characters allowed.');else updateFn({ isInRateSet: false })(index, DateRange.seasonId, ['Taxes', 'TaxInfo', 'Tax'], value, _ramda2.default.pathOr('', ['Taxes', 'TaxInfo', 'Tax'], DateRange));
              }
            })
          ),
          _react2.default.createElement(
            'div',
            { style: { marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' } },
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', width: '35%', color: 'rgba(0, 0, 0, 0.64)', fontSize: '12px' } },
              'Price Codes:'
            ),
            _react2.default.createElement('input', {
              style: {
                border: function () {
                  var currentVal = _ramda2.default.pathOr([], ['PriceCodes'], DateRange).join(',');
                  if (!currentVal) return '2px solid #ff9100';
                  if (currentVal !== _ramda2.default.pathOr([], ['originalPriceCodes'], DateRange).join(',')) return '2px solid #00bcd4';
                  return '2px solid #e0e0e0';
                }(),
                flexGrow: 2
              },
              value: _ramda2.default.pathOr([], ['PriceCodes'], DateRange).join(','),
              onChange: function onChange(_ref10) {
                var value = _ref10.target.value;

                updateFn({ isInRateSet: false })(index, DateRange.seasonId, ['PriceCodes'], value.split(','), _ramda2.default.pathOr('', ['PriceCodes'], DateRange));
              }
            })
          ),
          !/^[a-zA-Z0-9,]*$/.test(_ramda2.default.pathOr([], ['PriceCodes'], DateRange).join(',')) && _react2.default.createElement(
            'div',
            { style: { color: '#ff4081' } },
            _react2.default.createElement(
              'small',
              null,
              'Please separate price codes using commas only.'
            )
          ),
          duplicateRateName && _react2.default.createElement(
            'span',
            { style: { display: 'flex', alignItems: 'base-line', margin: '4px 0', color: 'red' } },
            _react2.default.createElement(_errorOutline2.default, { color: 'red' }),
            '\xA0\xA0Rate Names must be unique amongst the rate sets that belong to a single range.'
          ),
          DateRange.RateSet.map(function (rateSet, rateSetIndex) {
            return _react2.default.createElement(
              'div',
              { key: rateSetIndex, style: { margin: '8px 0', display: 'flex' } },
              _react2.default.createElement(
                'div',
                { style: { flexGrow: 2 } },
                _react2.default.createElement(
                  'div',
                  { style: { marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' } },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block', width: '35%' } },
                    'Rate Name:'
                  ),
                  _react2.default.createElement('input', {
                    style: { border: rateSet.Stay_Type !== rateSet.originalStay_Type ? '2px solid #00bcd4' : '2px solid #e0e0e0', flexGrow: 2 },
                    value: _ramda2.default.propOr('', 'Stay_Type', rateSet),
                    onChange: function onChange(_ref11) {
                      var value = _ref11.target.value;

                      if (value && value.length > 20) alert('Maximum 20 characters allowed.');else updateFn({ isInRateSet: true })(index, DateRange.seasonId, rateSetIndex, 'Stay_Type', value, _ramda2.default.propOr('', 'Stay_Type', rateSet));
                    }
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { style: { marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' } },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block', width: '35%' } },
                    'Rate Text:'
                  ),
                  _react2.default.createElement('input', {
                    style: { border: rateSet.Rate_Text !== rateSet.originalRate_Text ? '2px solid #00bcd4' : '2px solid #e0e0e0', flexGrow: 2 },
                    value: _ramda2.default.propOr('', 'Rate_Text', rateSet),
                    onChange: function onChange(_ref12) {
                      var value = _ref12.target.value;

                      if (value && value.length > 60) alert('Maximum 60 characters allowed.');else updateFn({ isInRateSet: true })(index, DateRange.seasonId, rateSetIndex, 'Rate_Text', value, _ramda2.default.propOr('', 'Rate_Text', rateSet));
                    }
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { style: { marginLeft: '16px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' } },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block', width: '35%' } },
                    'Cancel Hours:'
                  ),
                  _react2.default.createElement('input', {
                    type: 'number',
                    style: { border: (rateSet.Cancel_Hours || '').toString() !== (rateSet.originalCancel_Hours || '').toString() ? '2px solid #00bcd4' : '2px solid #e0e0e0', flexGrow: 2 },
                    value: _ramda2.default.propOr('', 'Cancel_Hours', rateSet),
                    onChange: function onChange(_ref13) {
                      var value = _ref13.target.value;
                      return updateFn({ isInRateSet: true })(index, DateRange.seasonId, rateSetIndex, 'Cancel_Hours', value, _ramda2.default.propOr('', 'Cancel_Hours', rateSet));
                    }
                  })
                )
              )
            );
          })
        )
      );
    })
  );
};

exports.default = RateNameText;

/***/ }),
/* 2957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _immutable = __webpack_require__(26);

var _aphrodite = __webpack_require__(123);

var _dragSource = __webpack_require__(2958);

var _dragSource2 = _interopRequireDefault(_dragSource);

var _dropTarget = __webpack_require__(1910);

var _dropTarget2 = _interopRequireDefault(_dropTarget);

var _container = __webpack_require__(2959);

var _container2 = _interopRequireDefault(_container);

var _singleExtra = __webpack_require__(2960);

var _singleExtra2 = _interopRequireDefault(_singleExtra);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var border = '1px dashed rgba(0, 0, 0, 0.54)';
var styles = _aphrodite.StyleSheet.create({
  extrasContainer: { display: 'flex', width: '100%' },
  draggableCard: { margin: '0px 0px 8px 8px' },
  extraContainer: {
    border: border,
    display: 'flex',
    alignItems: 'flex-start',
    margin: '8px auto',
    padding: '6px'
  },
  emptyDropTarget: { padding: '12px 6px', width: '70%', height: '83px', color: 'rgba(0, 0, 0, 0.34)', margin: '0px 0px 8px 8px', backgroundColor: '#f5f5f5' },
  activeDropTarget: { border: '2px dashed #14872b', width: '70%', padding: '12px 6px', height: '83px', margin: '0px 0px 8px 8px', backgroundColor: '#f2f7f3' },
  canDropClassName: { border: '2px dashed #94b3d4', width: '70%', padding: '12px 6px', height: '83px', margin: '0px 0px 8px 8px', backgroundColor: '#ebf2f9' },
  nonSortableItem: { display: 'block' }
});

var ExportExtrasPreview = function ExportExtrasPreview(_ref) {
  var updateThisProductWithKeyPath = _ref.updateThisProductWithKeyPath,
      extraLines = _ref.extraLines,
      pickedExtras = _ref.pickedExtras,
      notPickedExtras = _ref.notPickedExtras,
      _ref$allExtras = _ref.allExtras,
      allExtras = _ref$allExtras === undefined ? [] : _ref$allExtras,
      convertedContract = _ref.convertedContract,
      updateWithKeyPath = _ref.updateWithKeyPath,
      editCarriesTo = _ref.editCarriesTo;

  var availableExtraLines = _ramda2.default.values(extraLines);
  var updateAcrossProducts = function updateAcrossProducts(picked, all) {
    updateWithKeyPath(['convertedContract'], (0, _immutable.fromJS)(convertedContract.map(function (product) {
      return _extends({}, product, {
        pickedExtras: picked,
        allExtras: all
      });
    })));
  };
  var updateSingleProduct = function updateSingleProduct(picked, all) {
    updateThisProductWithKeyPath(['pickedExtras'], (0, _immutable.fromJS)(picked));
    updateThisProductWithKeyPath(['allExtras'], (0, _immutable.fromJS)(all));
  };
  var updateFn = _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('sameSeasonAcrossProducts'), _ramda2.default.always(updateAcrossProducts)], [_ramda2.default.equals('sameFieldAllSeasonsAllProducts'), _ramda2.default.always(updateAcrossProducts)], [_ramda2.default.T, _ramda2.default.always(updateSingleProduct)]]), editCarriesTo);
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.extrasContainer) },
      _react2.default.createElement('div', { style: { width: '20%' } }),
      _react2.default.createElement(
        'div',
        { style: { textAlign: 'center', fontWeight: 'bold', paddingBottom: '16px', fontSize: '18px', width: '80%', borderBottom: '1px solid rgba(0, 0, 0, 0.34)' } },
        'Extras'
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { width: '80%', marginLeft: '20%' } },
      function () {
        if (_ramda2.default.all(_ramda2.default.isEmpty, availableExtraLines)) {
          return _react2.default.createElement(
            'div',
            { style: { color: 'rgb(255, 152, 0)', marginLeft: '8px', lineHeight: '56px' } },
            'No extras configured in Tourplan'
          );
        }
        if (_ramda2.default.isEmpty(allExtras)) {
          return _react2.default.createElement(
            'div',
            { style: { color: 'rgb(255, 152, 0)', marginLeft: '8px', lineHeight: '56px' } },
            'No available extras'
          );
        }
        return allExtras.map(function (extra, index) {
          return _react2.default.createElement(
            'div',
            {
              key: '' + index + extra.extraType + extra.extraCode + extra.adult + extra.child + extra.infant,
              className: (0, _aphrodite.css)(styles.extraContainer)
            },
            _react2.default.createElement(_singleExtra2.default, {
              extra: extra,
              updateWithKey: function updateWithKey(key, value) {
                var all = allExtras.map(function (obj, thisIndex) {
                  if (thisIndex === index) return _extends({}, obj, _defineProperty({}, key, value));
                  return obj;
                });
                updateFn(pickedExtras, all);
              }
            }),
            _react2.default.createElement(
              'div',
              { style: { width: '50%' } },
              _react2.default.createElement(_reactSelect2.default, {
                name: 'tourplantarget',
                options: _ramda2.default.keys(extraLines).map(function (k, i) {
                  return {
                    value: k,
                    label: extraLines[k],
                    // disable if other extra has taken the place
                    disabled: Boolean(pickedExtras[i] && !_ramda2.default.isEmpty(pickedExtras[i]))
                  };
                }).filter(function (o) {
                  return o.label;
                }),
                onChange: function onChange(selected) {
                  if (!selected) {
                    // remove
                    var theIndex = parseInt(extra.extraLineKey.replace('extra', '')) - 1;
                    var picked = _ramda2.default.update(theIndex, {}, pickedExtras);
                    var all = _ramda2.default.update(index, _extends({}, extra, { extraLineKey: null }), allExtras);
                    updateFn(picked, all);
                  } else {
                    var newIndex = parseInt(selected.value.replace('extra', '')) - 1;
                    var _picked = _ramda2.default.update(newIndex, extra, pickedExtras);
                    var _all = _ramda2.default.update(index, _extends({}, extra, { extraLineKey: selected.value }), allExtras);
                    updateFn(_picked, _all);
                  }
                },
                value: extra.extraLineKey,
                placeholder: 'Please select Tourplan target',
                clearable: true,
                scrollMenuIntoView: false
              })
            )
          );
        });
      }()
    )
  );
};

exports.default = ExportExtrasPreview;

/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDnd = __webpack_require__(1131);

var _ramda = __webpack_require__(2);

var _dropTarget = __webpack_require__(1910);

var _dropTarget2 = _interopRequireDefault(_dropTarget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dragSource = {
  beginDrag: function beginDrag() {
    return {};
  },
  endDrag: function endDrag(props, monitor) {
    var dropResult = monitor.getDropResult();
    if (dropResult) {
      props.movedTo(dropResult.position);
    }
  }
};

var dragSourceFn = (0, _reactDnd.DragSource)('DRAG_SOURCE', dragSource, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
});
var Source = function Source(props) {
  var isDragging = props.isDragging,
      connectDragSource = props.connectDragSource,
      children = props.children,
      style = props.style,
      className = props.className;

  var opacity = isDragging ? 0.4 : 1;
  return connectDragSource(_react2.default.createElement(
    'div',
    { style: _extends({}, style, { opacity: opacity }), className: className },
    children
  ));
};

Source.propTypes = {
  connectDragSource: _react.PropTypes.func.isRequired,
  isDragging: _react.PropTypes.bool.isRequired,
  movedTo: _react.PropTypes.func.isRequired
};
exports.default = (0, _ramda.compose)(dragSourceFn)(Source);

/***/ }),
/* 2959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDnd = __webpack_require__(1131);

var _reactDndHtml5Backend = __webpack_require__(1902);

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_Component) {
  _inherits(Container, _Component);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  _createClass(Container, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: this.props.style },
        this.props.children
      );
    }
  }]);

  return Container;
}(_react.Component);

exports.default = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default)(Container);

/***/ }),
/* 2960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _aphrodite = __webpack_require__(123);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = _aphrodite.StyleSheet.create({
  extraInnerTextContainer: { display: 'flex', alignItems: 'center', flexDirection: 'column', width: '50%' },
  text: { display: 'flex', alignItems: 'center', width: '100%' }
});
var findByDescription = function findByDescription(descr) {
  return _ramda2.default.find(_ramda2.default.propEq('description', descr));
};
var getNettValue = function getNettValue(descr) {
  return _ramda2.default.compose(_ramda2.default.propOr('0.0000', 'nettRate'), findByDescription(descr), _ramda2.default.reject(_ramda2.default.propEq('notApplicable', true)), _ramda2.default.prop('rates'));
};
var findIndexByDescription = function findIndexByDescription(descr) {
  return _ramda2.default.findIndex(_ramda2.default.propEq('description', descr));
};

var SingleExtra = function SingleExtra(_ref) {
  var extra = _ref.extra,
      updateWithKey = _ref.updateWithKey;

  return _react2.default.createElement(
    'div',
    { className: (0, _aphrodite.css)(styles.extraInnerTextContainer) },
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.text) },
      _react2.default.createElement(
        'i',
        null,
        'Type:\xA0'
      ),
      extra.extraType
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.text) },
      _react2.default.createElement(
        'i',
        null,
        'Code:\xA0'
      ),
      extra.extraCode ? ' ' + extra.extraCode : ' N/A'
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.text) },
      _react2.default.createElement(
        'div',
        { style: { width: '20%' } },
        'Adult: '
      ),
      '\xA0',
      _react2.default.createElement('input', {
        defaultValue: extra.adult,
        type: 'number',
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;

          updateWithKey('adult', value);
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.text) },
      _react2.default.createElement(
        'div',
        { style: { width: '20%' } },
        'Child: '
      ),
      '\xA0',
      _react2.default.createElement('input', {
        defaultValue: extra.child,
        type: 'number',
        onChange: function onChange(_ref3) {
          var value = _ref3.target.value;

          updateWithKey('child', value);
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.text) },
      _react2.default.createElement(
        'div',
        { style: { width: '20%' } },
        'Infant: '
      ),
      '\xA0',
      _react2.default.createElement('input', {
        defaultValue: extra.infant,
        type: 'number',
        onChange: function onChange(_ref4) {
          var value = _ref4.target.value;

          updateWithKey('infant', value);
        }
      })
    )
  );
};

exports.default = SingleExtra;

/***/ }),
/* 2961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _aphrodite = __webpack_require__(123);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = _aphrodite.StyleSheet.create({
  rowContainer: { display: 'flex', width: '100%' },
  title: { marginBottom: '16px', fontWeight: 'bold', borderBottom: '1px solid rgba(0, 0, 0, 0.34)' }
});

var ExportAgePoliciesPreview = function ExportAgePoliciesPreview(_ref) {
  var policies = _ref.policies;

  var getColor = function getColor(type) {
    return (0, _ramda.eqProps)(type, policies.tourplan, policies.tc) ? 'rgba(0, 0, 0, 0.77)' : '#ff4081';
  };
  return _react2.default.createElement(
    'div',
    { style: { marginTop: '16px' } },
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.rowContainer) },
      _react2.default.createElement('div', { style: { width: '20%' } }),
      _react2.default.createElement(
        'div',
        { style: { textAlign: 'center', fontWeight: 'bold', paddingBottom: '16px', fontSize: '18px', width: '80%' } },
        'Age Policies'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.rowContainer) },
      _react2.default.createElement(
        'div',
        { style: { width: '20%', fontWeight: 'bold' } },
        _react2.default.createElement('div', { style: { height: '38px' } }),
        _react2.default.createElement(
          'div',
          null,
          'Infant '
        ),
        _react2.default.createElement(
          'div',
          null,
          'Child '
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '39%', textAlign: 'center' } },
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.title) },
          'Tourplan'
        ),
        _react2.default.createElement(
          'span',
          { style: { color: getColor('infantFrom') } },
          policies.tourplan.infantFrom
        ),
        '\xA0-\xA0',
        _react2.default.createElement(
          'span',
          { style: { color: getColor('infantTo') } },
          policies.tourplan.infantTo
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'span',
          { style: { color: getColor('childFrom') } },
          policies.tourplan.childFrom
        ),
        '\xA0-\xA0',
        _react2.default.createElement(
          'span',
          { style: { color: getColor('childTo') } },
          policies.tourplan.childTo
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '40%', textAlign: 'center', marginLeft: '1%' } },
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.title) },
          'TourConnect'
        ),
        _react2.default.createElement(
          'span',
          { style: { color: getColor('infantFrom') } },
          policies.tc.infantFrom
        ),
        '\xA0-\xA0',
        _react2.default.createElement(
          'span',
          { style: { color: getColor('infantTo') } },
          policies.tc.infantTo
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'span',
          { style: { color: getColor('childFrom') } },
          policies.tc.childFrom
        ),
        '\xA0-\xA0',
        _react2.default.createElement(
          'span',
          { style: { color: getColor('childTo') } },
          policies.tc.childTo
        )
      )
    )
  );
};

exports.default = ExportAgePoliciesPreview;

/***/ }),
/* 2962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _aphrodite = __webpack_require__(123);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _beddingConfigurationDumb = __webpack_require__(1911);

var _beddingConfigurationDumb2 = _interopRequireDefault(_beddingConfigurationDumb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var displayArray = function displayArray(array) {
  return array.length > 1 ? Math.max.apply(Math, _toConsumableArray(array.map(function (str) {
    return parseInt(str, 10);
  }))) : array[0];
};

var ExportRoomPoliciesPreview = function ExportRoomPoliciesPreview(_ref) {
  var policies = _ref.policies,
      isAccommodation = _ref.isAccommodation,
      bedsAndSofas = _ref.bedsAndSofas;

  if (!isAccommodation) return _react2.default.createElement('div', null);
  var tourplan = policies.tourplan,
      tc = policies.tc;

  var ifMatch = function ifMatch(roomType, type) {
    if (type === 'Avail') return _ramda2.default.eqProps(roomType + 'Avail', tourplan, tc);
    // return R.eqProps(`${roomType}Avail`, tourplan, tc) && R.call(R.compose(R.isEmpty, R.path(['tc', `${roomType}${type}`])), policies);
    if (tourplan[roomType + 'Avail'] === 'N' && tc[roomType + 'Avail'] === 'N') return true;
    return _ramda2.default.eqProps(roomType + 'Avail', tourplan, tc) && parseInt(tc['' + roomType + type], 10) === parseInt(tourplan['' + roomType + type], 10);
  };
  var getColor = _ramda2.default.ifElse(ifMatch, _ramda2.default.always('rgba(0, 0, 0, 0.77)'), _ramda2.default.always('#ff4081'));
  var styles = _aphrodite.StyleSheet.create({
    rowContainer: { display: 'flex', width: '100%' },
    title: { marginBottom: '16px', fontWeight: 'bold', borderBottom: '1px solid rgba(0, 0, 0, 0.34)', textAlign: 'center' },
    cell: { width: '20%', textAlign: 'center' },
    tc: { justifyContent: 'space-between', width: '95%', display: 'flex' }
  });
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.rowContainer) },
      _react2.default.createElement('div', { style: { width: '20%' } }),
      _react2.default.createElement(
        'div',
        { style: { textAlign: 'center', fontWeight: 'bold', paddingBottom: '16px', fontSize: '18px', width: '80%' } },
        'Room Policies'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.rowContainer) },
      _react2.default.createElement('div', { style: { width: '20%' } }),
      _react2.default.createElement(
        'div',
        { style: { width: '39%' }, className: (0, _aphrodite.css)(styles.title) },
        'Tourplan'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '40%', marginLeft: '1%' }, className: (0, _aphrodite.css)(styles.title) },
        'TourConnect'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.rowContainer), style: { color: 'rgba(0, 0, 0, 0.45)' } },
      _react2.default.createElement('div', { style: { width: '20%' } }),
      _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styles.cell) },
        'Max Ad'
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styles.cell) },
        'Ad+Ch'
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styles.cell) },
        'Max Ad'
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styles.cell) },
        'Ad+Ch'
      )
    ),
    [{ name: 'single', label: 'Single' }, { name: 'twin', label: 'Twin' }, { name: 'double', label: 'Double' }, { name: 'triple', label: 'Triple' }, { name: 'quad', label: 'Quad' }].map(function (type, index) {
      return _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styles.rowContainer), key: index },
        _react2.default.createElement(
          'div',
          { style: { width: '20%', fontWeight: 'bold' } },
          type.label
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.cell), style: { color: getColor(type.name, 'AdMax') } },
          tourplan[type.name + 'Avail'] === 'N' ? 'NA' : tourplan[type.name + 'AdMax']
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.cell), style: { color: getColor(type.name, 'Max') } },
          tourplan[type.name + 'Avail'] === 'N' ? 'NA' : tourplan[type.name + 'Max']
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.cell), style: { color: getColor(type.name, 'AdMax') } },
          tc[type.name + 'Avail'] === 'N' ? 'NA' : '',
          tc[type.name + 'Avail'] !== 'N' && ifMatch(type.name, 'AdMax') ? tourplan[type.name + 'AdMax'] : tc[type.name + 'AdMax'] || ''
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.cell), style: { color: getColor(type.name, 'Max') } },
          tc[type.name + 'Avail'] === 'N' ? 'NA' : '',
          tc[type.name + 'Avail'] !== 'N' && ifMatch(type.name, 'Max') ? tourplan[type.name + 'Max'] : tc[type.name + 'Max'] || ''
        )
      );
    }),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.rowContainer) },
      _react2.default.createElement('div', { style: { width: '20%' } }),
      _react2.default.createElement(
        'div',
        { style: { width: '80%' }, className: (0, _aphrodite.css)(styles.title) },
        'Bedding Configuration'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.rowContainer) },
      _react2.default.createElement('div', { style: { width: '20%' } }),
      _react2.default.createElement(_beddingConfigurationDumb2.default, { bedsAndSofas: bedsAndSofas, style: { width: '80%' } })
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var integration = _ref2.integration;
  return {
    contractId: integration.getIn(['contract', 'contractId'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ExportRoomPoliciesPreview);

/***/ }),
/* 2963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscrepancyMsg = function DiscrepancyMsg(_ref) {
  var updateThisProductWithKeyPath = _ref.updateThisProductWithKeyPath,
      discrepancyMsg = _ref.discrepancyMsg,
      sendMsg = _ref.sendMsg,
      msgFlags = _ref.msgFlags,
      contractId = _ref.contractId;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement('br', null),
      'Send a message to your partner about any discrepancies:',
      _react2.default.createElement(
        'div',
        { style: { padding: '0 12px 8px 12px', overflow: 'auto', minHeight: '80px', border: '1px solid #00BCD4', margin: '12px 0' } },
        _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-email', color: '#bfbfbf', style: { top: '12px' } }),
        _react2.default.createElement(_materialUi.TextField, {
          id: 'commentBoxTextField',
          hintStyle: { top: '12px' },
          hintText: 'Please review the room occupancies or child/infant ages provided in the contract.',
          underlineShow: false,
          onChange: function onChange(_ref2) {
            var value = _ref2.target.value;
            return updateThisProductWithKeyPath(['discrepancyMsg'], value);
          },
          style: { float: 'right', width: '85%', marginRight: '5%', fontSize: '14px', lineHeight: '18px' },
          multiLine: true,
          rowsMax: 5,
          maxLength: '400'
        })
      ),
      (0, _ramda.propOr)(false, 'msgSent', msgFlags) ? _react2.default.createElement(
        'div',
        null,
        'Your message has been sent to your partner, click ',
        _react2.default.createElement(
          'a',
          { href: '/contracting/contract/' + contractId + '/activities', target: '_blank' },
          'here'
        ),
        ' to view your message.'
      ) : _react2.default.createElement(_raisedButtonWithLoader2.default, {
        secondary: true,
        disabled: !Boolean(discrepancyMsg),
        loader: (0, _ramda.propOr)(false, 'sendingMsg', msgFlags),
        style: { float: 'right' },
        label: 'Send',
        onTouchTap: sendMsg
      })
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var integration = _ref3.integration;
  return {
    contractId: integration.getIn(['contract', 'contractId'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DiscrepancyMsg);

/***/ }),
/* 2964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(67);

var _aphrodite = __webpack_require__(123);

var _immutable = __webpack_require__(26);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = _aphrodite.StyleSheet.create({
  notesHeader: { display: 'flex', width: '100%' },
  noteBox: {
    border: '1px dashed rgba(0, 0, 0, 0.54)',
    display: 'flex',
    alignItems: 'flex-start',
    margin: '8px auto',
    padding: '6px'
  },
  text: { whiteSpace: 'pre-wrap', width: '20%' },
  tfbox: { width: '80%' },
  tf: { width: '100%' }
});

var PreviewNotes = function PreviewNotes(_ref) {
  var updateThisProductWithKeyPath = _ref.updateThisProductWithKeyPath,
      _ref$notes = _ref.notes,
      notes = _ref$notes === undefined ? [] : _ref$notes;

  var updateNote = function updateNote(i) {
    return function (e) {
      updateThisProductWithKeyPath(['notes'], (0, _immutable.fromJS)(_ramda2.default.update(i, _extends({}, notes[i], {
        text: e.target.value
      }), notes)));
    };
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.notesHeader) },
      _react2.default.createElement('div', { style: { width: '20%' } }),
      _react2.default.createElement(
        'div',
        { style: { textAlign: 'center', fontWeight: 'bold', paddingBottom: '16px', fontSize: '18px', width: '80%', borderBottom: '1px solid rgba(0, 0, 0, 0.34)' } },
        'Notes'
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { width: '80%', marginLeft: '20%' } },
      function () {
        if (_ramda2.default.isEmpty(notes)) {
          return _react2.default.createElement(
            'div',
            { style: { color: 'rgb(255, 152, 0)', marginLeft: '8px', lineHeight: '56px' } },
            'No available notes, please ',
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/integration/settings/notes' },
              'set up your notes settings here'
            ),
            '.'
          );
        }
        return notes.map(function (note, index) {
          return _react2.default.createElement(
            'div',
            {
              key: index,
              className: (0, _aphrodite.css)(styles.noteBox)
            },
            _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles.text) },
              _react2.default.createElement(
                'b',
                null,
                note.code
              )
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles.tfbox) },
              _react2.default.createElement('textarea', {
                rows: 4,
                value: note.text,
                onChange: updateNote(index)
              })
            )
          );
        });
      }()
    )
  );
};

exports.default = PreviewNotes;

/***/ }),
/* 2965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _singleProductExportStatus = __webpack_require__(1909);

var _singleProductExportStatus2 = _interopRequireDefault(_singleProductExportStatus);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExportResults = function ExportResults(props) {
  return _react2.default.createElement(
    _materialUi.Paper,
    { style: { padding: '32px', marginTop: '8px' } },
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' } },
      _react2.default.createElement(
        'div',
        null,
        props.exportResponses.products.map(function (product, index) {
          return _react2.default.createElement(_singleProductExportStatus2.default, _extends({}, product, { key: index }));
        })
      ),
      props.state === 'loaded' ? _react2.default.createElement(
        'span',
        null,
        'This contract has been marked as loaded'
      ) : _react2.default.createElement(_raisedButtonWithLoader2.default, {
        label: 'Mark This Contract As Loaded',
        loader: props.updatingContractState,
        style: { margin: '1em 0 1em 1em' },
        secondary: true,
        onClick: function onClick() {
          return props.markContractAsLoaded(props.contractId);
        }
      })
    )
  );
};
ExportResults.propTypes = {
  exportResponses: _react2.default.PropTypes.object,
  state: _react2.default.PropTypes.string,
  updatingContractState: _react2.default.PropTypes.bool,
  contractId: _react2.default.PropTypes.string,
  markContractAsLoaded: _react2.default.PropTypes.func
};
exports.default = ExportResults;

/***/ }),
/* 2966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = __webpack_require__(6);

var _integrationActions = __webpack_require__(1912);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IntegrationContainer = function (_Component) {
  _inherits(IntegrationContainer, _Component);

  function IntegrationContainer(props) {
    _classCallCheck(this, IntegrationContainer);

    var _this = _possibleConstructorReturn(this, (IntegrationContainer.__proto__ || Object.getPrototypeOf(IntegrationContainer)).call(this, props));

    _this.changeExportType = function (payload) {
      return _this.props.dispatch((0, _integrationActions.changeExportType)(payload));
    };

    _this._getRouteName = _this._getRouteName.bind(_this);
    return _this;
  }

  _createClass(IntegrationContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var dispatch = this.props.dispatch;

      dispatch((0, _integrationActions.getSettings)());
    }
  }, {
    key: '_getRouteName',
    value: function _getRouteName() {
      var location = this.props.location;

      if (location.pathname.indexOf('product-mapping') > 0) return 'product-mapping';
    }
  }, {
    key: '_getContractID',
    value: function _getContractID() {
      var _props = this.props,
          location = _props.location,
          params = _props.params;

      if (location.pathname.indexOf('product-mapping') > 0) return params.contractID;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          props = _objectWithoutProperties(_props2, ['children']);

      var routeName = this._getRouteName();
      var contractID = this._getContractID();
      var extraProps = _extends({
        routeName: routeName,
        contractID: contractID,
        changeExportType: this.changeExportType,
        login: function login(userName, password, url) {
          return props.dispatch((0, _integrationActions.login)(userName, password, url));
        }
      }, props);
      return _react2.default.createElement(
        'div',
        null,
        children ? (0, _react.cloneElement)(children, extraProps) : undefined
      );
    }
  }]);

  return IntegrationContainer;
}(_react.Component);

IntegrationContainer.propTypes = {
  location: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  params: _react.PropTypes.object,
  integration: _react.PropTypes.object,
  children: _react.PropTypes.object,
  history: _react.PropTypes.object
};

var select = function select(state) {
  return {
    integration: state.integration.toJS()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateSettings: function updateSettings(payload) {
      return dispatch((0, _integrationActions.updateSettingsAction)(payload));
    },
    saveSettings: function saveSettings() {
      return dispatch(_integrationActions.saveSettingsAction.apply(undefined, arguments));
    },
    updateWithKeyPath: function updateWithKeyPath() {
      return dispatch(_integrationActions.updateWithKeyPath.apply(undefined, arguments));
    },
    sendMsg: function sendMsg() {
      return dispatch(_integrationActions.sendHistoryFeedMsg.apply(undefined, arguments));
    },
    getContract: function getContract(contractId) {
      return dispatch((0, _integrationActions.getContract)(contractId));
    },
    getContracts: function getContracts(payload) {
      return dispatch((0, _integrationActions.getContracts)(payload));
    },
    getAuth: function getAuth() {
      return dispatch((0, _integrationActions.getAuth)());
    },
    exportContract: function exportContract() {
      return dispatch(_integrationActions.exportContract.apply(undefined, arguments));
    },
    validateMapping: function validateMapping() {
      return dispatch(_integrationActions.validateMapping.apply(undefined, arguments));
    },
    updateMapping: function updateMapping() {
      return dispatch(_integrationActions.updateMapping.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(select, mapDispatchToProps)(IntegrationContainer);

/***/ }),
/* 2967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsUpdate = __webpack_require__(1516);

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _connectionsLeftNav = __webpack_require__(2968);

var _connectionsLeftNav2 = _interopRequireDefault(_connectionsLeftNav);

var _connectionsActions = __webpack_require__(1221);

var _connectionsStatsActions = __webpack_require__(1850);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Dependencies


var ConnectionsContainer = function (_Component) {
  _inherits(ConnectionsContainer, _Component);

  function ConnectionsContainer(props) {
    _classCallCheck(this, ConnectionsContainer);

    var _this = _possibleConstructorReturn(this, (ConnectionsContainer.__proto__ || Object.getPrototypeOf(ConnectionsContainer)).call(this, props));

    _initialiseProps.call(_this);

    document.getElementsByTagName('body')[0].scrollTop = 0;

    _this.state = {
      filter: true,
      filteredTagsMap: {},
      filteredCountries: [],
      routeName: _this.getRouteName()
    };
    return _this;
  }

  _createClass(ConnectionsContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var routes = this.props.routes;

      var route = routes[2];
      this.filterResults(route ? route.path.slice(13) : 'connected');
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      dispatch((0, _connectionsActions.getCountries)());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var routeName = this.getRouteName(nextProps);
      if (this.state.routeName !== routeName) {
        this.setState({ routeName: routeName });
      }
      if (!(0, _ramda.equals)(nextProps.urlQuery, this.props.urlQuery)) {
        this.filterResults(routeName, nextProps);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          filteredTagsMap = _state.filteredTagsMap,
          filteredCountries = _state.filteredCountries,
          input = _state.input;

      var _props = this.props,
          children = _props.children,
          dispatch = _props.dispatch,
          props = _objectWithoutProperties(_props, ['children', 'dispatch']);

      var filterOptions = filteredCountries.map(function (country) {
        return {
          name: country,
          action: function action() {
            return _this2.removeCountryFilter(country);
          }
        };
      }).concat(Object.keys(filteredTagsMap).map(function (key) {
        return {
          name: filteredTagsMap[key],
          action: _this2.addOrRemoveTag
        };
      }));

      var searchInput = filterOptions.length || input ? true : undefined;

      var extraProps = _extends({
        filterResults: this.filterResults,
        filterByCountry: this.filterByCountry,
        addOrRemoveTag: this.addOrRemoveTag,
        loadMoreConnections: this.loadMoreConnections,
        search: this.search,
        sendRouteName: this.sendRouteName,
        resendConnection: this.resendConnection,
        acceptConnection: this.acceptConnection,
        removeConnection: this.removeConnection,
        ignoreConnection: this.ignoreConnection,
        searchInput: searchInput,
        filterOptions: filterOptions
      }, props, this.state);
      var connectionsStats = this.props.connectionsStats;


      var connectionsOrSplash = function () {
        if (connectionsStats.isSynced) {
          if (children) {
            return _react2.default.createElement(
              'div',
              { className: 'l-app-content l-left-nav-with-content' },
              _react2.default.createElement(_connectionsLeftNav2.default, _extends({ className: 'connections-left-nav l-left-nav' }, extraProps)),
              (0, _react.cloneElement)(children, extraProps)
            );
          }
        }
      }();
      return _react2.default.createElement(
        'div',
        null,
        connectionsOrSplash
      );
    }
  }]);

  return ConnectionsContainer;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getRouteName = function (props) {
    var _ref = props || _this3.props,
        history = _ref.history;

    if (history.isActive('/connections/invitations')) return 'invites';
    if (history.isActive('/connections/requests')) return 'requests';
    return 'connected';
  };

  this.filterResults = function (routeName, props) {
    var _ref2 = props || _this3.props,
        dispatch = _ref2.dispatch,
        _ref2$urlQuery = _ref2.urlQuery;

    _ref2$urlQuery = _ref2$urlQuery === undefined ? {} : _ref2$urlQuery;
    var connectionId = _ref2$urlQuery.id;

    var payload = {
      status: routeName === 'invitations' ? 'invites' : routeName,
      q: _this3.state.input,
      tags: Object.keys(_this3.state.filteredTagsMap),
      countries: _this3.state.filteredCountries,
      connectionId: connectionId
    };
    dispatch((0, _connectionsActions.filterConnections)(payload));
    dispatch((0, _connectionsStatsActions.refreshConnectionsStats)());
  };

  this.filterByCountry = function (filteredCountries) {
    var dispatch = _this3.props.dispatch;
    var _state2 = _this3.state,
        routeName = _state2.routeName,
        input = _state2.input,
        filteredTagsMap = _state2.filteredTagsMap;

    var tags = Object.keys(filteredTagsMap);
    _this3.setState({ filter: !filteredCountries.length, filteredCountries: filteredCountries }, function () {
      return dispatch((0, _connectionsActions.filterConnectionsByCountry)({
        'status': function () {
          if (_this3.state.filter) {
            if (routeName === 'invitations') return 'invites';
            return routeName;
          }
          return 'all';
        }(),
        'q': input,
        tags: tags,
        'countries': filteredCountries
      }));
    });
  };

  this.removeCountryFilter = function (countryName) {
    var filteredCountries = _this3.state.filteredCountries;

    _this3.filterByCountry(filteredCountries.filter(function (country) {
      return country !== countryName;
    }));
  };

  this.addOrRemoveTag = function (tag, remove) {
    var dispatch = _this3.props.dispatch;

    if (!_this3.state.filteredTagsMap[tag] || remove) {
      var newState = (0, _reactAddonsUpdate2.default)(_this3.state, {
        filteredTagsMap: {
          $apply: function $apply(tagsMap) {
            if (remove) delete tagsMap[tag];else tagsMap[tag] = tag;
            return tagsMap;
          }
        }
      });
      _this3.setState(newState, function () {
        var _state3 = _this3.state,
            filteredTagsMap = _state3.filteredTagsMap,
            filteredCountries = _state3.filteredCountries,
            routeName = _state3.routeName,
            input = _state3.input;

        var tags = Object.keys(filteredTagsMap);
        var payload = {
          'status': function () {
            if (!tags.length) {
              if (routeName === 'invitations') return 'invites';
              return routeName;
            }
            return 'all';
          }(),
          'q': input,
          tags: tags,
          'countries': filteredCountries
        };
        dispatch((0, _connectionsActions.filterConnections)(payload));
      });
    }
  };

  this.loadMoreConnections = function (pageNo) {
    // 'filter': true,
    var _props2 = _this3.props,
        dispatch = _props2.dispatch,
        connections = _props2.connections;
    var _state4 = _this3.state,
        input = _state4.input,
        routeName = _state4.routeName,
        filter = _state4.filter,
        filteredTagsMap = _state4.filteredTagsMap,
        filteredCountries = _state4.filteredCountries;

    if (connections.page === pageNo) return;
    dispatch((0, _connectionsActions.filterConnections)({
      'status': function () {
        if (filter) {
          if (routeName === 'invitations') return 'invites';
          return routeName;
        }
        return 'all';
      }(),
      'q': input,
      'tags': Object.keys(filteredTagsMap),
      'countries': filteredCountries,
      'page': pageNo
    }, true));
  };

  this.dispatchSearch = (0, _lodash2.default)(function (input) {
    var dispatch = _this3.props.dispatch;
    var _state5 = _this3.state,
        routeName = _state5.routeName,
        filteredTagsMap = _state5.filteredTagsMap,
        filteredCountries = _state5.filteredCountries;

    var payload = {
      'status': _this3.state.input ? 'all' : routeName,
      'q': input,
      'tags': Object.keys(filteredTagsMap),
      'countries': filteredCountries
    };
    dispatch((0, _connectionsActions.filterConnections)(payload));
  }, 400);

  this.search = function (input) {
    _this3.setState({ filter: false, input: input }, _this3.dispatchSearch.call(_this3, input));
  };

  this.sendRouteName = function (routeName) {
    document.getElementById('connectionsSearch').innerHTML = '';
    _this3.setState({ filter: true, routeName: routeName }, _this3.filterResults.call(_this3, routeName));
  };

  this.resendConnection = function (connectionId) {
    var _props3 = _this3.props,
        dispatch = _props3.dispatch,
        triggerSnackBarMessage = _props3.triggerSnackBarMessage;

    dispatch((0, _connectionsActions.resendConnection)(connectionId)).catch(function () {
      triggerSnackBarMessage({ message: 'Resending Invitation Failed' });
      dispatch((0, _connectionsActions.undoConnectionChange)());
    });
  };

  this.acceptConnection = function (connectionId) {
    var _props4 = _this3.props,
        dispatch = _props4.dispatch,
        triggerSnackBarMessage = _props4.triggerSnackBarMessage;

    dispatch((0, _connectionsActions.acceptConnection)(connectionId)).catch(function () {
      triggerSnackBarMessage({ message: 'Accepting Connection Failed' });
      dispatch((0, _connectionsActions.undoConnectionChange)());
    });
  };

  this.removeConnection = function (connectionId) {
    var _props5 = _this3.props,
        dispatch = _props5.dispatch,
        triggerSnackBarMessage = _props5.triggerSnackBarMessage;

    dispatch((0, _connectionsActions.removeConnection)(connectionId)).then(function () {
      return triggerSnackBarMessage({
        message: 'Connection Removed'
        // actionText: 'Undo',
        // actionTap: () => dispatch(undoConnectionChange(true)),
      });
    }).catch(function () {
      triggerSnackBarMessage({ message: 'Removing Connection Failed' });
      dispatch((0, _connectionsActions.undoConnectionChange)());
    });
  };

  this.ignoreConnection = function (connectionId) {
    var _props6 = _this3.props,
        dispatch = _props6.dispatch,
        triggerSnackBarMessage = _props6.triggerSnackBarMessage;

    dispatch((0, _connectionsActions.ignoreConnection)(connectionId)).catch(function () {
      triggerSnackBarMessage({ message: 'Ignoring Connection Failed' });
      dispatch((0, _connectionsActions.undoConnectionChange)());
    });
  };
};

function select(state) {
  var _state$routing$locati = state.routing.locationBeforeTransitions.query,
      urlQuery = _state$routing$locati === undefined ? {} : _state$routing$locati;

  return {
    connectionsStats: state.connectionsStats.toJS(),
    connections: state.connections.toJS(),
    urlQuery: urlQuery,
    tags: state.tags.toJS(),
    user: state.user.toJS()
  };
}

ConnectionsContainer.propTypes = {
  history: _react.PropTypes.object,
  routes: _react.PropTypes.array,
  dispatch: _react.PropTypes.func,
  connectionsStats: _react.PropTypes.object,
  connections: _react.PropTypes.object,
  triggerSnackBarMessage: _react.PropTypes.func,
  children: _react.PropTypes.object,
  user: _react.PropTypes.object,
  urlQuery: _react.PropTypes.object
};

exports.default = (0, _reactRedux.connect)(select)(ConnectionsContainer);

/***/ }),
/* 2968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _connectionsWidget = __webpack_require__(2969);

var _connectionsWidget2 = _interopRequireDefault(_connectionsWidget);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _findNewPartners = __webpack_require__(2971);

var _findNewPartners2 = _interopRequireDefault(_findNewPartners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeftNav = function (_Component) {
  _inherits(LeftNav, _Component);

  function LeftNav() {
    _classCallCheck(this, LeftNav);

    return _possibleConstructorReturn(this, (LeftNav.__proto__ || Object.getPrototypeOf(LeftNav)).apply(this, arguments));
  }

  _createClass(LeftNav, [{
    key: 'render',
    value: function render() {
      var history = this.props.history;


      return _react2.default.createElement(
        'div',
        { className: this.props.className },
        _react2.default.createElement(
          'div',
          { className: 'connections-left-nav-inner' },
          _react2.default.createElement(
            'div',
            { className: 'connections-left-nav-heading' },
            'Partner Requests'
          ),
          _react2.default.createElement(_connectionsWidget2.default, this.props),
          _react2.default.createElement(_findNewPartners2.default, {
            history: history
          })
        )
      );
    }
  }]);

  return LeftNav;
}(_react.Component);

LeftNav.propTypes = {
  history: _react.PropTypes.object,
  className: _react.PropTypes.string,
  tags: _react.PropTypes.array,
  addOrRemoveTag: _react.PropTypes.func
};

exports.default = LeftNav;

/***/ }),
/* 2969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _connectionsWidgetItem = __webpack_require__(2970);

var _connectionsWidgetItem2 = _interopRequireDefault(_connectionsWidgetItem);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Dependencies

// Components


var languageSettings = _languages2.default['en-US'];

var ConnectionsWidget = function (_Component) {
  _inherits(ConnectionsWidget, _Component);

  function ConnectionsWidget() {
    _classCallCheck(this, ConnectionsWidget);

    return _possibleConstructorReturn(this, (ConnectionsWidget.__proto__ || Object.getPrototypeOf(ConnectionsWidget)).apply(this, arguments));
  }

  _createClass(ConnectionsWidget, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'connections-widget' },
        _react2.default.createElement(_connectionsWidgetItem2.default, _extends({}, this.props, {
          sendRouteName: this.props.sendRouteName,
          data: this.props.connectionsStats.pendingRequestCount,
          routeName: '/connections/requests',
          activeRoutes: ['/connections/requests'],
          name: languageSettings.connections.routeNames.requests,
          counterStyle: { backgroundColor: 'red' }
        })),
        _react2.default.createElement(_connectionsWidgetItem2.default, _extends({}, this.props, {
          sendRouteName: this.props.sendRouteName,
          data: this.props.connectionsStats.pendingInviteCount,
          routeName: '/connections/invitations',
          activeRoutes: ['/connections/invitations'],
          name: languageSettings.connections.routeNames.invites
        }))
      );
    }
  }]);

  return ConnectionsWidget;
}(_react.Component);

ConnectionsWidget.propTypes = {
  sendRouteName: _react.PropTypes.func,
  connectionsStats: _react.PropTypes.object,
  searchInput: _react.PropTypes.any
};

exports.default = ConnectionsWidget;

/* jshint ignore:end */

/***/ }),
/* 2970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navLink = __webpack_require__(1049);

var _navLink2 = _interopRequireDefault(_navLink);

var _counter = __webpack_require__(1517);

var _counter2 = _interopRequireDefault(_counter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Dependencies


var ConnectionsWidget = function (_Component) {
  _inherits(ConnectionsWidget, _Component);

  function ConnectionsWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ConnectionsWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectionsWidget.__proto__ || Object.getPrototypeOf(ConnectionsWidget)).call.apply(_ref, [this].concat(args))), _this), _this.filterResults = function (routeName) {
      var routeNameCopy = routeName;
      if (routeName === 'invitations') routeNameCopy = 'invites';
      _this.props.sendRouteName(routeNameCopy);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ConnectionsWidget, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          name = _props.name,
          counterStyle = _props.counterStyle;

      var classes = (0, _classnames2.default)('nav-link', 'connections-widget-link', {
        'is-zero': data === 0
      });
      return _react2.default.createElement(
        _navLink2.default,
        _extends({
          filterResults: this.filterResults,
          classes: classes,
          className: classes
        }, this.props),
        name,
        _react2.default.createElement(_counter2.default, { data: data, style: counterStyle })
      );
    }
  }]);

  return ConnectionsWidget;
}(_react.Component);

ConnectionsWidget.propTypes = {
  sendRouteName: _react.PropTypes.func,
  data: _react.PropTypes.number,
  name: _react.PropTypes.string,
  counterStyle: _react.PropTypes.object
};

exports.default = ConnectionsWidget;

/* jshint ignore:end */

/***/ }),
/* 2971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PartnerFinderFade = __webpack_require__(2972);

var FindNewPartners = function FindNewPartners(props) {
  var history = props.history;

  var goToPartnerFinder = function goToPartnerFinder() {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'TRACK_EVENT',
        ev: {
          category: 'PartnerFinder',
          action: 'Clicks from Connections'
        }
      });
    }
    history.push('/partner-finder/results');
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      {
        className: 'connections-left-nav-heading',
        style: { cursor: 'pointer' },
        onClick: function onClick() {
          return goToPartnerFinder();
        }
      },
      'Partner Search'
    ),
    _react2.default.createElement(
      'div',
      {
        style: { margin: '15px 15px 25px', cursor: 'pointer' },
        onClick: function onClick() {
          return goToPartnerFinder();
        }
      },
      _react2.default.createElement('img', { src: PartnerFinderFade })
    )
  );
};

FindNewPartners.propTypes = {
  user: _react.PropTypes.object,
  history: _react.PropTypes.object
};

var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user;
  return {
    user: user.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(FindNewPartners);

/***/ }),
/* 2972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c8a1508826370c85f6b570aa0be991c0.png";

/***/ }),
/* 2973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _card = __webpack_require__(873);

var _card2 = _interopRequireDefault(_card);

var _connectionsList = __webpack_require__(2974);

var _connectionsList2 = _interopRequireDefault(_connectionsList);

var _connectionsToolbar = __webpack_require__(2989);

var _connectionsToolbar2 = _interopRequireDefault(_connectionsToolbar);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Dependencies

// Components


var languageSettings = _languages2.default['en-US'];

var Connections = function (_Component) {
  _inherits(Connections, _Component);

  function Connections(props) {
    _classCallCheck(this, Connections);

    var _this = _possibleConstructorReturn(this, (Connections.__proto__ || Object.getPrototypeOf(Connections)).call(this, props));

    _this.onScroll = function () {
      if (document.body.scrollTop >= 32 !== _this.state.isFixed) _this.setState({ isFixed: !_this.state.isFixed });
    };

    _this.state = { isFixed: false };
    return _this;
  }

  _createClass(Connections, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.addEventListener) {
        window.addEventListener('scroll', this.onScroll, false);
      } else {
        window.attachEvent('onscroll', this.onScroll);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (window.addEventListener) {
        window.removeEventListener('scroll', this.onScroll, false);
      } else {
        window.detachEvent('onScroll', this.onScroll);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          history = _props.history;

      var title = function () {
        var _languageSettings$con = languageSettings.connections.routeNames,
            invites = _languageSettings$con.invites,
            requests = _languageSettings$con.requests,
            connected = _languageSettings$con.connected;

        if (input) return 'Search Results';
        if (history.isActive('/connections/invitations')) return invites;
        if (history.isActive('/connections/requests')) return requests;
        return connected;
      }();

      var connectionsToolBar = this.props.filterOptions.length ? _react2.default.createElement(_connectionsToolbar2.default, this.props) : undefined;
      return _react2.default.createElement(
        'div',
        { className: 'l-left-nav-content' },
        _react2.default.createElement(
          _card2.default,
          _extends({
            title: connectionsToolBar ? undefined : title,
            isFixed: this.state.isFixed,
            isSticky: true,
            searchHeader: true,
            listCard: true,
            padded: false
          }, this.props),
          connectionsToolBar,
          _react2.default.createElement(_connectionsList2.default, this.props)
        )
      );
    }
  }]);

  return Connections;
}(_react.Component);

Connections.propTypes = {
  connectionsStats: _react.PropTypes.object,
  filterOptions: _react.PropTypes.array,
  connections: _react.PropTypes.object,
  input: _react.PropTypes.string,
  history: _react.PropTypes.object
};

exports.default = Connections;

/***/ }),
/* 2974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Dependencies


var _jquery = __webpack_require__(251);

var _jquery2 = _interopRequireDefault(_jquery);

var _connectionsListItem = __webpack_require__(2975);

var _connectionsListItem2 = _interopRequireDefault(_connectionsListItem);

var _reactRouter = __webpack_require__(67);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pagination = __webpack_require__(870);

var _pagination2 = _interopRequireDefault(_pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = (0, _react.createClass)({
  propTypes: {
    connections: _react.PropTypes.object,
    loadMoreConnections: _react.PropTypes.func,
    connectionsStats: _react.PropTypes.object,
    routeName: _react.PropTypes.string,
    isSearching: _react.PropTypes.bool,
    tags: _react.PropTypes.array
  },

  componentDidMount: function componentDidMount() {
    // if (window.addEventListener) {
    //   window.addEventListener('scroll', this.onScroll, false);
    // } else {
    //   window.attachEvent('onscroll', this.onScroll);
    // }
  },
  componentWillUnmount: function componentWillUnmount() {
    // if (window.addEventListener) {
    //   window.removeEventListener('scroll', this.onScroll, false);
    // } else {
    //   window.detachEvent('onScroll', this.onScroll);
    // }
  },
  onScroll: function onScroll() {
    var _props = this.props,
        connections = _props.connections,
        loadMoreConnections = _props.loadMoreConnections;

    var scrollTop = document.body.scrollTop || (0, _jquery2.default)('html').scrollTop(); // Firefox doc.body.scrollTop always 0 - so must switch to jquery html
    if (document.body.offsetHeight + scrollTop === document.body.scrollHeight && connections.nextPage) {
      loadMoreConnections(this.props.connections.nextPage);
    }
  },
  render: function render() {
    var _this = this;

    var connections = this.props.connections;

    var totalPages = Math.ceil(connections.resultCount / 20);
    var listItems = connections.items.map(function (connection, index) {
      return _react2.default.createElement(_connectionsListItem2.default, _extends({}, _this.props, connection, {
        connectionId: connection.id,
        allUserTags: _this.props.tags,
        key: index
      }));
    });

    var containerClass = void 0;
    var message = void 0;
    var itemsCount = void 0;

    var links = _react2.default.createElement(
      'span',
      null,
      'Add new connections ',
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/connections/add-connections' },
        'here'
      ),
      ' or search for new partners ',
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/partner-finder/results' },
        'here'
      ),
      '.'
    );

    switch (this.props.routeName) {
      case 'requests':
        itemsCount = this.props.connectionsStats.pendingRequestCount;
        if (!itemsCount) {
          message = 'You have no new connection requests.';
        }
        break;
      case 'invites':
        itemsCount = this.props.connectionsStats.pendingInviteCount;
        if (!itemsCount) {
          message = _react2.default.createElement(
            'span',
            null,
            'You have no pending connections. ',
            links
          );
        }
        break;
      case 'connected':
      default:
        itemsCount = this.props.connectionsStats.totalCount;
        if (!itemsCount) {
          message = _react2.default.createElement(
            'span',
            null,
            'You have no connections. ',
            links
          );
        }
        break;
    }

    if (message) {
      containerClass = 'no-connections';
      listItems = _react2.default.createElement(
        'h4',
        { className: 'no-connections-message' },
        message
      );
    } else if (!listItems.length) {
      if (!this.props.isSearching && (this.props.connections.searchString || this.props.connections.filteredCountries)) {
        containerClass = 'no-connections';
        listItems = _react2.default.createElement(
          'h4',
          { className: 'no-connections-message' },
          ' We did not find any results for your search.'
        );
      } else {
        containerClass = 'no-connections-loading';
        listItems = _react2.default.createElement('div', { className: 'no-connections' });
      }
    } else {
      containerClass = 'connections-list';
    }

    return _react2.default.createElement(
      'div',
      { onScroll: this.onScroll, className: containerClass },
      listItems,
      totalPages > 1 && this.props.filter ? _react2.default.createElement(_pagination2.default, {
        currentPage: connections.page,
        totalPages: totalPages,
        goToPage: this.props.loadMoreConnections,
        noOfPagesToShow: 5
      }) : _react2.default.createElement('span', null)
    );
  }
});

exports.default = List;

/* jshint ignore:end */

/***/ }),
/* 2975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _connectionsTagsContainer = __webpack_require__(2976);

var _connectionsTagsContainer2 = _interopRequireDefault(_connectionsTagsContainer);

var _connectionsTag = __webpack_require__(1913);

var _connectionsTag2 = _interopRequireDefault(_connectionsTag);

var _materialUi = __webpack_require__(3);

var _profileImage = __webpack_require__(548);

var _profileImage2 = _interopRequireDefault(_profileImage);

var _connectionsVertDropdown = __webpack_require__(1878);

var _connectionsVertDropdown2 = _interopRequireDefault(_connectionsVertDropdown);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

var _swapHoriz = __webpack_require__(2988);

var _swapHoriz2 = _interopRequireDefault(_swapHoriz);

var _reactRedux = __webpack_require__(6);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _actions = __webpack_require__(647);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Dependenceis


var languageSettings = _languages2.default['en-US'];


var propTypes = {
  companyId: _react.PropTypes.string,
  id: _react.PropTypes.string,
  isEmailContact: _react.PropTypes.bool,
  email: _react.PropTypes.string,
  connectionOrigin: _react.PropTypes.string,
  status: _react.PropTypes.string,
  lastSent: _react.PropTypes.string,
  profileImageUrl: _react.PropTypes.string,
  history: _react.PropTypes.object,
  className: _react.PropTypes.string,
  name: _react.PropTypes.string,
  allUserTags: _react.PropTypes.array,
  tags: _react.PropTypes.array,
  resendConnection: _react.PropTypes.func,
  acceptConnection: _react.PropTypes.func,
  ignoreConnection: _react.PropTypes.func,
  removeConnection: _react.PropTypes.func,
  addOrRemoveTag: _react.PropTypes.func,
  partner: _react.PropTypes.object,
  connectionId: _react.PropTypes.string,
  addConnectionAsPartner: _react.PropTypes.func
};

var ListItem = function (_React$Component) {
  _inherits(ListItem, _React$Component);

  function ListItem() {
    _classCallCheck(this, ListItem);

    var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this));

    _this.transitionToProfile = function () {
      var _this$props = _this.props,
          companyId = _this$props.companyId,
          history = _this$props.history;

      if (companyId) history.push('/company/' + companyId);
    };

    _this.toggleTypeAhead = function () {
      _this.showDialog();
    };

    _this.toggleZIndex = function () {
      _this.setState({ menuDropDownOpen: !_this.state.menuDropDownOpen });
    };

    _this.dismissDialog = function () {
      _this.setState({ dialogOpen: false });
    };

    _this.showDialog = function () {
      _this.setState({ dialogOpen: true });
    };

    _this.state = {
      typeAheadOpen: false,
      menuDropDownOpen: false,
      dialogOpen: false
    };
    return _this;
  }

  _createClass(ListItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classes = (0, _classnames2.default)('connections-company-name', this.props.className, {
        'is-link': this.props.companyId
      });

      var listItemClasses = (0, _classnames2.default)('connections-list-item', {
        'is-open': this.state.menuDropDownOpen
      });

      var modal = _react2.default.createElement(
        _materialUi.Dialog,
        {
          className: 'form-dialog tags-modal',
          title: 'Tags for ' + this.props.name,
          ref: 'tagsModal',
          open: this.state.dialogOpen,
          onRequestClose: this.dismissDialog
        },
        _react2.default.createElement(_connectionsTagsContainer2.default, _extends({}, this.props, { isTagModal: true, allUserTags: this.props.allUserTags }))
      );

      var email = void 0;
      var header = void 0;
      var dropDownButton = void 0;
      var category = function () {
        if (_this2.props.status === 'accepted') return 'connected';
        if (_this2.props.status === 'pending') {
          if (_this2.props.lastSent) {
            if (_this2.props.isEmailContact) return 'connected';
            return 'invites';
          }
          return 'requests';
        }
      }();
      var options = [{
        text: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-remove_red_eye',
            style: { color: '#00bcd4', fontSize: '14px', marginRight: '5px' }
          }),
          'View Profile'
        ),
        action: this.transitionToProfile
      }];
      switch (category) {
        case 'invites':
          // TODO: if other user has rejected request, do not show drop down button
          options.push({
            text: _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(_materialUi.FontIcon, {
                className: 'tc-icon-near_me',
                style: { color: '#00bcd4', fontSize: '14px', marginRight: '5px' }
              }),
              'Resend Partner Request'
            ),
            action: this.props.resendConnection
          });
          options.push({
            text: _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(_materialUi.FontIcon, {
                className: 'tc-icon-delete2',
                style: { color: 'rgb(255, 64, 129)', fontSize: '14px', marginRight: '5px' }
              }),
              'Cancel Partner Request'
            ),
            action: this.props.removeConnection
          });
          dropDownButton = _react2.default.createElement(_connectionsVertDropdown2.default, {
            componentClassName: 'connections-actions',
            toggleZIndex: this.toggleZIndex,
            options: options,
            style: { lineHeight: '24px' },
            payload: this.props.id
          });
          break;
        case 'requests':
          dropDownButton = _react2.default.createElement(_connectionsVertDropdown2.default, {
            componentClassName: 'connections-actions',
            toggleZIndex: this.toggleZIndex,
            options: options,
            style: { lineHeight: '24px' },
            isRequest: true,
            acceptConnection: this.props.acceptConnection,
            ignoreConnection: this.props.ignoreConnection,
            payload: this.props.id
          });
          break;
        case 'connected':
        default:
          options.unshift({
            text: _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(_materialUi.FontIcon, {
                className: 'tc-icon-message',
                style: { color: 'rgb(0, 188, 212)', fontSize: '14px', marginRight: '5px' }
              }),
              'Send a Message'
            ),
            action: function action() {
              _this2.context.router.push('/workspace/' + (_this2.props.companyId || _this2.props.email));
            }
          });
          options.push({
            text: _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(_materialUi.FontIcon, {
                className: 'tc-icon-delete2',
                style: { color: 'rgb(255, 64, 129)', fontSize: '14px', marginRight: '5px' }
              }),
              languageSettings.connections.listItem.removeConnection
            ),
            action: this.props.removeConnection
          });
          dropDownButton = _react2.default.createElement(_connectionsVertDropdown2.default, {
            componentClassName: 'connections-actions',
            style: { lineHeight: '24px' },
            toggleZIndex: this.toggleZIndex,
            payload: this.props.id,
            options: options
          });
          break;
      }

      if (this.props.email && (category === 'requests' || category === 'connected')) {
        email = _react2.default.createElement(
          'div',
          { className: 'connections-list-email' },
          this.props.email
        );
      }

      if (this.props.name) {
        header = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'connections-list-header', onClick: this.transitionToProfile },
            this.props.name
          ),
          _react2.default.createElement(
            'i',
            null,
            (0, _moment2.default)(this.props.created_at).fromNow()
          )
        );
      }

      var tags = Array.isArray(this.props.tags) ? this.props.tags : [];

      var companyTags = tags.map(function (tag, index) {
        return _react2.default.createElement(_connectionsTag2.default, {
          key: index,
          className: 'individual-company-tag',
          tag: tag,
          addOrRemoveTag: _this2.props.addOrRemoveTag
        });
      });

      var tagsToDisplay = _react2.default.createElement(
        'div',
        { className: 'company-tags-container' },
        companyTags
      );

      var companyDisplay = void 0;

      if (header) {
        companyDisplay = _react2.default.createElement(
          'div',
          { className: classes },
          _react2.default.createElement(
            'div',
            { className: 'inner-tags-container' },
            header,
            tagsToDisplay
          ),
          email
        );
      } else {
        companyDisplay = _react2.default.createElement(
          'div',
          { className: classes },
          email,
          tagsToDisplay
        );
      }

      return _react2.default.createElement(
        'div',
        { className: listItemClasses, style: { borderBottom: '1px solid #f0f0f0' } },
        _react2.default.createElement(
          'div',
          { className: 'connections-profile-image-container' },
          _react2.default.createElement(_profileImage2.default, {
            className: 'profile-link-image connections-profile-link-image',
            companySlugName: this.props.name,
            email: this.props.email,
            imageUrl: this.props.profileImageUrl
          })
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'connections-company-container',
            style: {
              minHeight: '72px',
              padding: '8px 0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }
          },
          companyDisplay,
          function () {
            if (category === 'connected') {
              if (_this2.props.partner && _this2.props.partner.partnerId) {
                return _react2.default.createElement(_materialUi.RaisedButton, {
                  label: 'View Details',
                  secondary: true,
                  icon: _react2.default.createElement(_swapHoriz2.default, null),
                  buttonStyle: { zIndex: 'inherited' },
                  onTouchTap: function onTouchTap() {
                    window.location = "https://app.tourconnect.com" + '/partner-management/partner-details/' + _this2.props.partner.partnerId + '?jwt=' + localStorage.getItem('jwt');
                  }
                });
              }
              return _react2.default.createElement(_materialUi.RaisedButton, {
                label: 'Add as Partner',
                primary: true,
                buttonStyle: { zIndex: 'inherited' },
                onTouchTap: function onTouchTap() {
                  return _this2.props.addConnectionAsPartner(_this2.props.connectionId, _this2.props.companyId);
                }
              });
            }
          }(),
          dropDownButton
        ),
        modal
      );
    }
  }]);

  return ListItem;
}(_react2.default.Component);

ListItem.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
ListItem.propTypes = propTypes;
exports.default = (0, _reactRedux.connect)(null, { addConnectionAsPartner: _actions.addConnectionAsPartner })(ListItem);

/***/ }),
/* 2976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _connectionsTag = __webpack_require__(1913);

var _connectionsTag2 = _interopRequireDefault(_connectionsTag);

var _typeaheadContainer = __webpack_require__(2977);

var _typeaheadContainer2 = _interopRequireDefault(_typeaheadContainer);

var _reactAddonsTransitionGroup = __webpack_require__(2982);

var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);

var _connectionsActions = __webpack_require__(1221);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TagsContainer = function (_Component) {
  _inherits(TagsContainer, _Component);

  function TagsContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TagsContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TagsContainer.__proto__ || Object.getPrototypeOf(TagsContainer)).call.apply(_ref, [this].concat(args))), _this), _this.addOrRemoveTag = function (tagName, addOrRemove) {
      var _this$props = _this.props,
          connectionId = _this$props.connectionId,
          addATag = _this$props.addATag,
          delTag = _this$props.delTag;

      if (_this.props.allUserTags && _this.props.allUserTags.indexOf(tagName) === -1) {
        if (addOrRemove === 'add') addATag(connectionId, tagName);
      }
      if (addOrRemove === 'remove') delTag(connectionId, tagName);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TagsContainer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Iterate through tags and append a comma if not first tag
      var tags = function () {
        if (_this2.props.tags) {
          return _this2.props.tags.map(function (tag, index) {
            return _react2.default.createElement(_connectionsTag2.default, {
              isTagModal: _this2.props.isTagModal,
              addOrRemoveTag: _this2.addOrRemoveTag,
              connectionId: _this2.props.connectionId,
              className: 'connections-tags',
              tag: tag,
              key: index
            });
          });
        }
      }();

      var classes = (0, _classnames2.default)(this.props.className, {
        'connections-tags-container': !this.props.typeAheadOpen,
        'connections-typeahead-container': this.props.typeAheadOpen
      });

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(_typeaheadContainer2.default, {
          addOrRemoveTag: this.addOrRemoveTag,
          allUserTags: this.props.allUserTags,
          open: this.props.typeAheadOpen,
          connectionId: this.props.connectionId,
          toggleTypeAhead: this.props.toggleTypeAhead
        }),
        _react2.default.createElement(
          'div',
          { className: 'individual-tags-container' },
          _react2.default.createElement(
            _reactAddonsTransitionGroup2.default,
            null,
            tags
          )
        )
      );
    }
  }]);

  return TagsContainer;
}(_react.Component);

TagsContainer.propTypes = {
  dispatch: _react.PropTypes.func,
  connectionId: _react.PropTypes.string,
  allUserTags: _react.PropTypes.array,
  tags: _react.PropTypes.array,
  className: _react.PropTypes.string,
  isTagModal: _react.PropTypes.bool,
  typeAheadOpen: _react.PropTypes.bool,
  toggleTypeAhead: _react.PropTypes.bool,
  addATag: _react.PropTypes.func,
  delTag: _react.PropTypes.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addATag: function addATag(connectionId, tagName) {
      return dispatch((0, _connectionsActions.addTag)(connectionId, tagName));
    },
    delTag: function delTag(connectionId, tagName) {
      return dispatch((0, _connectionsActions.removeTag)(connectionId, tagName));
    }
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(TagsContainer);

/***/ }),
/* 2977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Dependencies


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeahead = __webpack_require__(2978);

var _typeahead2 = _interopRequireDefault(_typeahead);

var _ClickAwayListener = __webpack_require__(853);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConnectionsTypeAhead = (0, _react.createClass)({

  propTypes: {
    open: _react.PropTypes.bool,
    toggleTypeAhead: _react.PropTypes.func,
    allUserTags: _react.PropTypes.object
  },

  componentClickAway: function componentClickAway() {
    if (this.props.open) this.props.toggleTypeAhead();
  },
  render: function render() {
    return _react2.default.createElement(
      _ClickAwayListener2.default,
      { onClickAway: this.componentClickAway },
      _react2.default.createElement(
        'div',
        { className: 'type-ahead-container' },
        _react2.default.createElement(_typeahead2.default, _extends({}, this.props, {
          tags: this.props.allUserTags
        }))
      )
    );
  }
});

exports.default = ConnectionsTypeAhead;

/* jshint ignore:end */

/***/ }),
/* 2978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Dependencies


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _typeaheadInputAndDropdownContainer = __webpack_require__(2979);

var _typeaheadInputAndDropdownContainer2 = _interopRequireDefault(_typeaheadInputAndDropdownContainer);

var _ClickAwayListener = __webpack_require__(853);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConnectionsTagsTypeAhead = (0, _react.createClass)({
  getInitialState: function getInitialState() {
    return {
      typeAheadDropDownOpen: false
    };
  },
  toggleTypeAheadDropDown: function toggleTypeAheadDropDown() {
    this.setState({ typeAheadDropDownOpen: !this.state.typeAheadDropDownOpen }, function () {
      // document.getElementById('type-ahead-input').focus();
    });
  },
  componentClickAway: function componentClickAway() {
    if (this.state.typeAheadDropDownOpen) this.toggleTypeAheadDropDown();
  },
  render: function render() {
    return _react2.default.createElement(
      _ClickAwayListener2.default,
      { onClickAway: this.componentClickAway },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_typeaheadInputAndDropdownContainer2.default, _extends({}, this.props, { open: this.state.typeAheadDropDownOpen })),
        _react2.default.createElement(_icon2.default, { className: 'connections-typeahead-tag-icon tc-icon-arrow-drop-down', onClick: this.toggleTypeAheadDropDown })
      )
    );
  }
});

exports.default = ConnectionsTagsTypeAhead;

/* jshint ignore:end */

/***/ }),
/* 2979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeaheadInput = __webpack_require__(2980);

var _typeaheadInput2 = _interopRequireDefault(_typeaheadInput);

var _typeaheadDropdown = __webpack_require__(2981);

var _typeaheadDropdown2 = _interopRequireDefault(_typeaheadDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagComponent = (0, _react.createClass)({

  propTypes: {
    addOrRemoveTag: _react.PropTypes.func,
    open: _react.PropTypes.bool,
    input: _react.PropTypes.string,
    tags: _react.PropTypes.array
  },

  getInitialState: function getInitialState() {
    return {
      input: ''
    };
  },
  onSelection: function onSelection(value) {
    this.props.addOrRemoveTag(value, 'add');
  },
  searchContent: function searchContent(input) {
    this.setState({ input: input });
  },
  render: function render() {
    return _react2.default.createElement(
      'div',
      { className: 'tags-typeahead-search-bar-container' },
      _react2.default.createElement(
        'div',
        { className: 'multi-select-search-bar' },
        _react2.default.createElement(_typeaheadInput2.default, { addOrRemoveTag: this.props.addOrRemoveTag, searchContent: this.searchContent })
      ),
      this.props.open || this.state.input ? _react2.default.createElement(_typeaheadDropdown2.default, {
        addOrRemoveTag: this.props.addOrRemoveTag,
        input: this.state.input,
        open: this.props.open || this.state.input,
        tags: this.props.tags
      }) : undefined
    );
  }
}); // Dependencies
exports.default = TagComponent;

/***/ }),
/* 2980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBar = (0, _react.createClass)({

  propTypes: {
    addOrRemoveTag: _react.PropTypes.func,
    searchContent: _react.PropTypes.func
  },

  getInitialState: function getInitialState() {
    return { input: '' };
  },
  addTags: function addTags() {
    if (this.state.input) this.props.addOrRemoveTag(this.state.input, 'add');
    this.setState({ input: '' });
    this.searchContent();
  },


  preventTabAndAllowEnter: function preventTabAndAllowEnter(event) {
    if (event.which === 9) {
      event.preventDefault();
    }
    if (event.which === 13) {
      event.preventDefault();
      undefined.addTags();
    }
  },

  searchContent: function searchContent(input) {
    this.props.searchContent(input.toLowerCase());
    this.setState({ input: input.toLowerCase() });
  },
  render: function render() {
    var _this = this;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_materialUi.TextField, {
        hintText: 'Add Tags...',
        id: 'type-ahead-input',
        className: 'type-ahead-search-input',
        style: { width: '100%', marginLeft: '-5px' },
        onKeyDown: this.preventTabAndAllowEnter,
        onChange: function onChange(_ref) {
          var value = _ref.target.value;
          return _this.searchContent(value);
        }
      }),
      _react2.default.createElement(_icon2.default, { className: 'tc-icon-add type-ahead-input-add', onClick: this.addTags })
    );
  }
});

exports.default = SearchBar;

/***/ }),
/* 2981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ClickAwayListener = __webpack_require__(853);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

; // Dependencies


var ConnectionsTagsTypeAhead = (0, _react.createClass)({

  propTypes: {
    addOrRemoveTag: _react.PropTypes.func,
    input: _react.PropTypes.string,
    tags: _react.PropTypes.array,
    open: _react.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    return {
      typeAheadDropDownOpen: false
    };
  },
  addTag: function addTag(tagName) {
    this.props.addOrRemoveTag(tagName, 'add');
  },
  toggleTypeAheadDropDown: function toggleTypeAheadDropDown() {
    this.setState({ typeAheadDropDownOpen: !this.state.typeAheadDropDownOpen });
  },
  componentClickAway: function componentClickAway() {
    if (this.state.typeAheadDropDownOpen) this.toggleTypeAheadDropDown();
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        input = _props.input,
        tags = _props.tags;

    if (!this.props.open) return false;
    var filteredTags = input ? tags.filter(function (option) {
      return option.tag.toLowerCase().search(new RegExp(input, 'g')) > -1;
    }) : undefined;
    var tagsToMap = filteredTags || tags;
    var allTags = tagsToMap.map(function (tag, index) {
      return _react2.default.createElement(
        'div',
        { className: 'type-ahead-option-container', key: index, onClick: _this.addTag.bind(_this, tag.tag) },
        _react2.default.createElement(
          'div',
          { className: 'type-ahead-option' },
          tag.tag
        )
      );
    });

    return _react2.default.createElement(
      _ClickAwayListener2.default,
      { onClickAway: this.componentClickAway },
      _react2.default.createElement(
        _materialUi.Paper,
        { zDepth: 1 },
        allTags
      )
    );
  }
});

exports.default = ConnectionsTagsTypeAhead;

/* jshint ignore:end */

/***/ }),
/* 2982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



module.exports = __webpack_require__(2983);


/***/ }),
/* 2983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(1758);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2984);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(89);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(2987);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 2984 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2985)();
}


/***/ }),
/* 2985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(2986);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 2988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSwapHoriz = function ActionSwapHoriz(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z' })
  );
};
ActionSwapHoriz = (0, _pure2.default)(ActionSwapHoriz);
ActionSwapHoriz.displayName = 'ActionSwapHoriz';
ActionSwapHoriz.muiName = 'SvgIcon';

exports.default = ActionSwapHoriz;

/***/ }),
/* 2989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _connectionsFilterItem = __webpack_require__(2990);

var _connectionsFilterItem2 = _interopRequireDefault(_connectionsFilterItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConnectionsToolbar = function (_Component) {
  _inherits(ConnectionsToolbar, _Component);

  function ConnectionsToolbar() {
    _classCallCheck(this, ConnectionsToolbar);

    return _possibleConstructorReturn(this, (ConnectionsToolbar.__proto__ || Object.getPrototypeOf(ConnectionsToolbar)).apply(this, arguments));
  }

  _createClass(ConnectionsToolbar, [{
    key: 'render',
    value: function render() {
      var filterOptions = this.props.filterOptions;

      return _react2.default.createElement(
        'div',
        null,
        filterOptions.map(function (filterOption, key) {
          return _react2.default.createElement(_connectionsFilterItem2.default, _extends({ key: key }, filterOption));
        })
      );
    }
  }]);

  return ConnectionsToolbar;
}(_react.Component);

ConnectionsToolbar.propTypes = {
  filterOptions: _react.PropTypes.array
};

exports.default = ConnectionsToolbar;

/***/ }),
/* 2990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConnectionsFilterItem = (0, _react.createClass)({

  propTypes: {
    action: _react.PropTypes.func,
    isTypeAheadTag: _react.PropTypes.bool,
    name: _react.PropTypes.string
  },

  removeTag: function removeTag() {
    var _props = this.props,
        action = _props.action,
        isTypeAheadTag = _props.isTypeAheadTag,
        name = _props.name;

    if (isTypeAheadTag) {
      return action(name, 'remove');
    }
    action(name, true);
  },
  render: function render() {
    return _react2.default.createElement(
      'div',
      { className: 'connections-tag-contianer' },
      _react2.default.createElement(
        'div',
        { className: 'connections-tag-name' },
        this.props.name
      ),
      _react2.default.createElement(_icon2.default, { className: 'tc-icon-close', onClick: this.removeTag })
    );
  }
});

exports.default = ConnectionsFilterItem;

/***/ }),
/* 2991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _profileActions = __webpack_require__(546);

var _locationActions = __webpack_require__(1054);

var _productActions = __webpack_require__(1518);

var _companyActions = __webpack_require__(2993);

var _locationActions2 = __webpack_require__(2996);

var _productActions2 = __webpack_require__(2999);

var _actions = __webpack_require__(1247);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var checkIfActiveRoute = function checkIfActiveRoute(routeToCheck, pathname) {
  var splitPath = pathname.split('/').slice(1);
  if (routeToCheck === 'profile' && splitPath.length === 1 && splitPath[0] === 'profile') return true;
  if (routeToCheck === 'profile-location' && splitPath.length === 3 && splitPath[0] === 'profile' && splitPath[1] === 'locations') return true;
  if (routeToCheck === 'profile-product' && splitPath.length === 3 && splitPath[0] === 'profile' && splitPath[1] === 'product') return true;
  if (routeToCheck === 'company' && splitPath.length === 2 && splitPath[0] === 'company') return true;
  if (routeToCheck === 'location' && splitPath.length === 2 && splitPath[0] === 'locations') return true;
  if (routeToCheck === 'product' && splitPath.length === 2 && splitPath[0] === 'product') return true;
  return false;
};

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var ProfileRouter = function (_Component) {
  _inherits(ProfileRouter, _Component);

  function ProfileRouter(props) {
    _classCallCheck(this, ProfileRouter);

    var _this = _possibleConstructorReturn(this, (ProfileRouter.__proto__ || Object.getPrototypeOf(ProfileRouter)).call(this, props));

    _initialiseProps.call(_this);

    return _this;
  }

  _createClass(ProfileRouter, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var dispatch = this.props.dispatch;

      this.getActiveProfile(this.props);
      dispatch((0, _actions.getBadges)());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          history = _props.history,
          profile = _props.profile;

      if (this.props.location.pathname !== nextProps.location.pathname) {
        this.getActiveProfile(nextProps);
      } else if (checkIfActiveRoute('profile', nextProps.location.pathname) && nextProps.profile.refresh) {
        this.getActiveProfile(nextProps);
      } else if (checkIfActiveRoute('profile-location', nextProps.location.pathname) && nextProps.profileLocation.refresh) {
        this.getActiveProfile(nextProps);
      } else if (!profile.isMarketingReady && nextProps.isMarketingReady) {
        return history.push('/profile-complete-splash');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _getRouteName = this._getRouteName(),
          routeName = _getRouteName.routeName,
          isEditable = _getRouteName.isEditable,
          profileToShow = _getRouteName.profileToShow;

      if ((typeof profileToShow === 'undefined' ? 'undefined' : _typeof(profileToShow)) === 'object' && !Object.keys(profileToShow).length || !profileToShow) return false;

      var _props2 = this.props,
          children = _props2.children,
          props = _objectWithoutProperties(_props2, ['children']);
      // if (
      //   routeName === 'product'
      //   && profileToShow.locationId
      //   && !this.props.profileLocation[profileToShow.locationId]
      // ) {
      //   this.props.dispatch(getUserLocationProfile(profileToShow.locationId));
      // }


      var extraProps = _extends({
        profileToShow: (0, _ramda.merge)(profileToShow, { viewingAs: this.props.profile.viewingAs }),
        isEditable: isEditable,
        routeName: routeName,
        children: children
      }, props);
      return _react2.default.createElement(
        'div',
        null,
        children ? (0, _react.cloneElement)(children, extraProps) : undefined,
        _react2.default.createElement(_loadingOverlay2.default, {
          loading: profileToShow.loading
        })
      );
    }
  }]);

  return ProfileRouter;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getActiveProfile = function (props) {
    var dispatch = props.dispatch,
        profile = props.profile,
        user = props.user,
        profileLocation = props.profileLocation,
        profileProduct = props.profileProduct,
        companyProfile = props.companyProfile,
        companyLocation = props.companyLocation,
        companyProduct = props.companyProduct,
        params = props.params,
        location = props.location;


    if (checkIfActiveRoute('profile', location.pathname)) {
      if ((0, _ramda.equals)((0, _ramda.path)(['user', 'type'], user), 'Contractor')) {
        dispatch((0, _profileActions.getProfile)(user.user.userID));
      } else if (!Object.keys(profile).length || profile.refresh) {
        dispatch((0, _profileActions.getProfile)(user.user.userID));
      }
      if (user.company.oneOrMultiProperties === 'one-prop') dispatch((0, _locationActions.getUserLocationProfile)(user.company.singleLocId));
    } else if (checkIfActiveRoute('profile-location', location.pathname)) {
      if (!profileLocation[params.locationId] || profileLocation.refresh) dispatch((0, _locationActions.getUserLocationProfile)(params.locationId));
    } else if (checkIfActiveRoute('profile-product', location.pathname)) {
      if (!profileProduct[params.productId]) dispatch((0, _productActions.getUserProductProfile)(params.productId));
    } else if (checkIfActiveRoute('company', location.pathname)) {
      if (!companyProfile[params.companyId]) dispatch((0, _companyActions.getNonLoggedInUsersProfile)(params.companyId));
    } else if (checkIfActiveRoute('location', location.pathname)) {
      if (!companyLocation[params.locationId]) dispatch((0, _locationActions2.getNonLoggedInUsersLocationProfile)(params.locationId));
    } else if (checkIfActiveRoute('product', location.pathname)) {
      if (!companyProduct[params.productId]) dispatch((0, _productActions2.getNonLoggedInUsersProductProfile)(params.productId));
    }
  };

  this._getRouteName = function () {
    var _props3 = _this2.props,
        params = _props3.params,
        profile = _props3.profile,
        profileLocation = _props3.profileLocation,
        profileProduct = _props3.profileProduct,
        companyProfile = _props3.companyProfile,
        companyLocation = _props3.companyLocation,
        companyProduct = _props3.companyProduct,
        user = _props3.user;

    if (checkIfActiveRoute('profile', _this2.props.location.pathname)) {
      return { routeName: 'profile', isEditable: _ramda2.default.contains('write', _ramda2.default.propOr([], 'corporateAccess', user)), profileToShow: user.company.oneOrMultiProperties === 'one-prop' ? (0, _ramda.merge)(profile, profileLocation[user.company.singleLocId]) : profile };
    }
    if (checkIfActiveRoute('profile-location', _this2.props.location.pathname)) {
      var locationAccess = _ramda2.default.pathOr([], [0, 'profile'], user.locAccess.filter(function (obj) {
        return obj.locId === params.locationId;
      }));
      return { routeName: 'location', isEditable: _ramda2.default.contains('write', locationAccess), profileToShow: profileLocation[params.locationId] };
    }
    if (checkIfActiveRoute('profile-product', _this2.props.location.pathname)) {
      var _locationAccess = _ramda2.default.pathOr([], [0, 'profile'], user.locAccess.filter(function (obj) {
        return obj.locId === _ramda2.default.pathOr('', [params.productId, 'locationId'], profileProduct);
      }));
      return { routeName: 'product', isEditable: _ramda2.default.contains('write', _locationAccess), profileToShow: profileProduct[params.productId] };
    }
    if (checkIfActiveRoute('company', _this2.props.location.pathname)) {
      return { routeName: 'profile', isEditable: false, profileToShow: companyProfile[params.companyId] };
    }
    if (checkIfActiveRoute('location', _this2.props.location.pathname)) {
      return { routeName: 'location', isEditable: false, profileToShow: companyLocation[params.locationId] };
    }
    if (checkIfActiveRoute('product', _this2.props.location.pathname)) {
      return { routeName: 'product', isEditable: false, profileToShow: companyProduct[params.productId] };
    }
  };
};

function select(state) {
  return {
    companyProfile: state.companyProfile.toJS(),
    companyLocation: state.companyLocation.toJS(),
    companyProduct: state.companyProduct.toJS(),
    profile: state.profile.toJS(),
    profileLocation: state.profileLocation.toJS(),
    profileProduct: state.profileProduct.toJS(),
    user: state.user.toJS(),
    MMReducer: state.marketingMaterials.mainReducer.toJS(),
    MMPartnerReducer: state.marketingMaterials.partnerReducer.toJS()
  };
}

ProfileRouter.propTypes = {
  dispatch: _react.PropTypes.func,
  profile: _react.PropTypes.object,
  user: _react.PropTypes.object,
  profileLocation: _react.PropTypes.object,
  profileProduct: _react.PropTypes.object,
  companyProfile: _react.PropTypes.object,
  companyLocation: _react.PropTypes.object,
  companyProduct: _react.PropTypes.object,
  history: _react.PropTypes.object,
  params: _react.PropTypes.object,
  location: _react.PropTypes.object,
  children: _react.PropTypes.any
};

exports.default = (0, _reactRedux.connect)(select, {})(ProfileRouter);

/***/ }),
/* 2992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_USER_PRODUCT_PROFILE = exports.GET_USER_PRODUCT_PROFILE = 'GET_USER_PRODUCT_PROFILE';
var EDIT_USER_PRODUCT_PROFILE_FIELD_STARTING = exports.EDIT_USER_PRODUCT_PROFILE_FIELD_STARTING = 'EDIT_USER_PRODUCT_PROFILE_FIELD_STARTING';
var EDIT_USER_PRODUCT_PROFILE_FIELD = exports.EDIT_USER_PRODUCT_PROFILE_FIELD = 'EDIT_USER_PRODUCT_PROFILE_FIELD';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';
var CLEAR_USER_PRODUCT_STORE = exports.CLEAR_USER_PRODUCT_STORE = 'CLEAR_USER_PRODUCT_STORE';
var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';
var PROFILE_IMAGE_CHANGED = exports.PROFILE_IMAGE_CHANGED = 'PROFILE_IMAGE_CHANGED';
var DELETE_COVER_IMAGE_FROM_PRODUCT = exports.DELETE_COVER_IMAGE_FROM_PRODUCT = 'DELETE_COVER_IMAGE_FROM_PRODUCT';

/***/ }),
/* 2993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNonLoggedInUsersProfile = getNonLoggedInUsersProfile;
exports.sendInvitation = sendInvitation;

var _soFetch = __webpack_require__(254);

var _companyConstants = __webpack_require__(2994);

var constants = _interopRequireWildcard(_companyConstants);

var _companyGraphqlQuery = __webpack_require__(2995);

var queries = _interopRequireWildcard(_companyGraphqlQuery);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getNonLoggedInUsersProfile(companyId) {
  return (0, _soFetch.soFetch)('/proxy/company/' + companyId + '?query=' + queries.companyProfileQuery, {
    method: 'get',
    actionType: constants.GET_COMPANY_PROFILE,
    responseBinding: 'companyProfile'
  });
}

function sendInvitation(companyId) {
  return (0, _soFetch.soFetch)('/proxy/connections/' + companyId, {
    method: 'post',
    actionType: constants.SEND_INVITATION,
    responseBinding: 'connection'
  });
}

/***/ }),
/* 2994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_COMPANY_PROFILE = exports.GET_COMPANY_PROFILE = 'GET_COMPANY_PROFILE';
var CLEAR_COMPANY_STORE = exports.CLEAR_COMPANY_STORE = 'CLEAR_COMPANY_STORE';
var CHANGE_CONNECTION = exports.CHANGE_CONNECTION = 'CHANGE_CONNECTION';
var SEND_INVITATION = exports.SEND_INVITATION = 'SEND_INVITATION';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';

/***/ }),
/* 2995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var companyProfileQuery = exports.companyProfileQuery = "query getCompanyProfile ($vieweeCompanyId: ID!, $viewerCompanyId: ID!) {\n      companyProfile  (id: $vieweeCompanyId) {\n        companyName\n        id\n        companyId\n        isMarketingReady\n        name\n        coverImageUrl\n        marketSegments\n        marketServed\n        companyTypes\n        website\n        phone\n        profileImageUrl\n        quickResponder\n        address {\n          addressOne\n          addressTwo\n          city\n          state\n          country\n          postalCode\n          formattedAddress\n        }\n        destinationsSold\n        connectionInfo (vieweeCompanyId: $vieweeCompanyId, viewerCompanyId: $viewerCompanyId) {\n          id\n          lastSent\n          shouldShowContactInfo\n          status\n          isSender\n        }\n        corporateIdentifier\n        type\n        description\n        contacts {\n          firstName\n          lastName\n          name\n          type\n          phone\n          fax\n          email\n        }\n        groups {\n          _id\n          tag\n          items\n        }\n        locations (viewerCompanyId: $viewerCompanyId) {\n          name\n          id\n          city\n          state\n          country\n          images\n          isMarketingReady\n          numOfProducts\n        }\n        companyBadges {\n          membershipId\n          verifiedStatus\n          name\n          badgeId\n          logo\n          companyBadgeId\n          acronym\n          website\n        }\n      }\n    }";

/***/ }),
/* 2996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNonLoggedInUsersLocationProfile = getNonLoggedInUsersLocationProfile;
exports.sendInvitation = sendInvitation;

var _soFetch = __webpack_require__(254);

var _locationConstants = __webpack_require__(2997);

var constants = _interopRequireWildcard(_locationConstants);

var _locationGraphqlQuery = __webpack_require__(2998);

var queries = _interopRequireWildcard(_locationGraphqlQuery);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getNonLoggedInUsersLocationProfile(locationId) {
  return (0, _soFetch.soFetch)('/proxy/locations/' + locationId + '?query=' + queries.locationProfileQuery, {
    method: 'get',
    actionType: constants.GET_LOCATION_PROFILE
  });
}

function sendInvitation(connectionInfo, locationId) {
  return (0, _soFetch.soFetch)('/proxy/connections/' + locationId, {
    method: 'post',
    actionType: constants.SEND_INVITATION
  });
}

/***/ }),
/* 2997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_LOCATION_PROFILE = exports.GET_LOCATION_PROFILE = 'GET_LOCATION_PROFILE';
var CLEAR_LOCATION_STORE = exports.CLEAR_LOCATION_STORE = 'CLEAR_LOCATION_STORE';
var SEND_INVITATION = exports.SEND_INVITATION = 'SEND_INVITATION';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';

/***/ }),
/* 2998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var locationProfileQuery = exports.locationProfileQuery = 'query getMyLocationProfile ($locationId: ID!, $viewerCompanyId: ID!) {\n      locationProfile  (id: $locationId) {\n        companyName\n        locationName\n        id\n        companyId\n        isMarketingReady\n        name\n        coverImageUrl\n        marketSegments\n        companyTypes\n        website\n        phone\n        productType\n        amenities\n        locationId\n        roomCount\n        isProductMarketingReady\n        profileImageUrl\n        imageUrls\n        type\n        description\n        rating {\n          value\n          type\n        }\n        address {\n          addressOne\n          addressTwo\n          city\n          state\n          country\n          postalCode\n          formattedAddress\n        }\n        connectionInfo (viewerCompanyId: $viewerCompanyId) {\n          shouldShowContactInfo\n          status\n          lastSent\n          id\n          isSender\n        }\n        contacts {\n          firstName\n          lastName\n          name\n          type\n          phone\n          fax\n          email\n        }\n        groups {\n          _id\n          tag\n          items\n        }\n        products (viewerCompanyId: $viewerCompanyId) {\n          name\n          id\n          images\n          isMarketingReady\n        }\n      }\n    }'.replace(/ +(?= )/g, '');

/***/ }),
/* 2999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNonLoggedInUsersProductProfile = getNonLoggedInUsersProductProfile;

var _soFetch = __webpack_require__(254);

var _productConstants = __webpack_require__(3000);

var constants = _interopRequireWildcard(_productConstants);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _productGraphqlQuery = __webpack_require__(3001);

var queries = _interopRequireWildcard(_productGraphqlQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getNonLoggedInUsersProductProfile(productId) {
  return (0, _soFetch.soFetch)('/proxy/products/' + productId + '?query=' + queries.productProfileQuery, {
    method: 'get',
    actionType: constants.GET_PRODUCT_PROFILE
  });
}

/***/ }),
/* 3000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_PRODUCT_PROFILE = exports.GET_PRODUCT_PROFILE = 'GET_PRODUCT_PROFILE';
var CLEAR_LOCATION_STORE = exports.CLEAR_LOCATION_STORE = 'CLEAR_PRODUCT_STORE';
var SEND_INVITATION = exports.SEND_INVITATION = 'SEND_INVITATION';
var CLEAR_STORES = exports.CLEAR_STORES = 'CLEAR_STORES';

/***/ }),
/* 3001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var productProfileQuery = exports.productProfileQuery = "query getProductProfile ($productId: ID!, $viewerCompanyId: ID!) {\n      productProfile  (id: $productId) {\n        id\n        name\n        productId\n        amenities\n        bedsAndSofas {\n          isApartment\n          rooms {\n            count\n            bedType\n            other\n          }\n        }\n        checkIn\n        checkOut\n        description\n        imageUrls\n        isMarketingReady\n        interconnectingRooms\n        connectionInfo (viewerCompanyId: $viewerCompanyId) {\n          status\n          isSender\n          lastSent\n          id\n          shouldShowContactInfo\n        }\n        locationName\n        locationId\n        productCode\n        notes\n        totalMaxPassengers\n        totalMinPassengers\n        productName\n        companyId\n        companyName\n        profileImageUrl\n        coverImageUrl\n        tourDuration {\n          value\n          unit\n        }\n        tourDurationDoesNotApply\n        roomCountInfo {\n          value\n          unit\n        }\n        roomSizeInfo {\n          value\n          unit\n        }\n        productInfo {\n          include\n          exclude\n          whatToBring\n        }\n        roomSize\n        productType\n        type\n      }\n    }";

/***/ }),
/* 3002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _profileActions = __webpack_require__(546);

var _locationActions = __webpack_require__(1054);

var _productActions = __webpack_require__(1518);

var _profileEditModalActions = __webpack_require__(3003);

var _companyAddress = __webpack_require__(3004);

var _companyAddress2 = _interopRequireDefault(_companyAddress);

var _editFieldModalContainer = __webpack_require__(3104);

var _editFieldModalContainer2 = _interopRequireDefault(_editFieldModalContainer);

var _content = __webpack_require__(3114);

var _content2 = _interopRequireDefault(_content);

var _profileLeftBarContainer = __webpack_require__(3162);

var _profileLeftBarContainer2 = _interopRequireDefault(_profileLeftBarContainer);

var _profileTopBarContainer = __webpack_require__(3176);

var _profileTopBarContainer2 = _interopRequireDefault(_profileTopBarContainer);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var toCapitalizedWords = function toCapitalizedWords(name) {
  if (name === 'bedsAndSofas') return 'Bedding Configuration';
  var words = name.match(/[A-Za-z][a-z]*/g);
  return words.map(function (word) {
    return word.charAt(0).toUpperCase() + word.substring(1);
  }).join(' ');
};

var Profile = function (_Component) {
  _inherits(Profile, _Component);

  function Profile(props) {
    _classCallCheck(this, Profile);

    var _this = _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).call(this, props));

    _this.sendEditToReducer = function (update) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _profileEditModalActions.editFieldForModal)(update));
    };

    _this.clearModalState = function () {
      var dispatch = _this.props.dispatch;

      dispatch((0, _profileEditModalActions.clearEditModalState)());
    };

    _this.shouldLocationUpdateForSingleLocUpdate = function (updateField) {
      var singleLocFields = ['contacts', 'description', 'website', 'phone', 'address', 'companyTypes', 'marketSegments', 'coverImageUrl'];
      return singleLocFields.indexOf(updateField) > -1;
    };

    _this.shouldLocationUpdateInsteadOfProfileForSingleLoc = function (updateField) {
      var singleLocFields = ['notes', 'imageUrls', 'rating', 'amenities', 'roomCount'];
      return singleLocFields.indexOf(updateField) > -1;
    };

    _this.submitEdit = function (_ref) {
      var route = _ref.route,
          options = _objectWithoutProperties(_ref, ['route']);

      var _this$props = _this.props,
          routeName = _this$props.routeName,
          productId = _this$props.params.productId,
          locationId = _this$props.profileToShow.locationId,
          user = _this$props.user,
          dispatch = _this$props.dispatch;

      var isOneLocationSupplier = (0, _ramda.path)(['company', 'oneOrMultiProperties'], user) === 'one-prop';
      options.isSingleLocSupplier = isOneLocationSupplier;
      var singleLocId = user.company.singleLocId;
      var checkIfSingleLocToUpdate = routeName === 'profile' && isOneLocationSupplier && _this.shouldLocationUpdateInsteadOfProfileForSingleLoc(options.updateField) ? 'location' : routeName;
      var routeToCheck = route || checkIfSingleLocToUpdate;
      (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('profile'), function () {
        dispatch((0, _profileActions.editProfileField)(options));
        dispatch((0, _profileEditModalActions.clearEditModalState)());
        if (isOneLocationSupplier && _this.shouldLocationUpdateForSingleLocUpdate(options.updateField)) {
          dispatch((0, _locationActions.editLocationField)(_extends({}, options, { id: singleLocId || locationId })));
        }
      }], [(0, _ramda.equals)('location'), function () {
        dispatch((0, _locationActions.editLocationField)(_extends({}, options, { id: singleLocId || locationId })));
        dispatch((0, _profileEditModalActions.clearEditModalState)());
      }], [(0, _ramda.equals)('product'), function () {
        dispatch((0, _productActions.editProductField)(_extends({}, options, { id: productId, locationId: locationId })));
        dispatch((0, _profileEditModalActions.clearEditModalState)());
      }]]), routeToCheck);
    };

    _this.editField = function (field) {
      var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          routeName = _this$props2.routeName;

      var getFieldName = (0, _ramda.cond)([[(0, _ramda.either)((0, _ramda.equals)('locationName'), (0, _ramda.equals)('productName')), (0, _ramda.always)('Name')], [_ramda.T, _ramda.identity]]);
      var fieldName = getFieldName(field);
      var title = settings.title || 'Edit Your ' + _this._descriptionType(routeName) + '\'s ' + toCapitalizedWords(fieldName);
      dispatch((0, _profileEditModalActions.startEdit)({ field: field, value: settings.initialValue || _this.props.profileToShow[field], title: title, settings: settings }));
    };

    _this.inlineEditField = function (field) {
      var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          routeName = _this$props3.routeName;

      var getFieldName = (0, _ramda.cond)([[(0, _ramda.either)((0, _ramda.equals)('locationName'), (0, _ramda.equals)('productName')), (0, _ramda.always)('Name')], [_ramda.T, _ramda.identity]]);
      var fieldName = getFieldName(field);
      var title = settings.title || 'Edit Your ' + _this._descriptionType(routeName) + '\'s ' + toCapitalizedWords(fieldName);
      dispatch((0, _profileEditModalActions.startInlineEdit)({ field: field, value: settings.initialValue || _this.props.profileToShow[field], title: title, settings: settings }));
    };

    _this._descriptionType = (0, _ramda.cond)([[(0, _ramda.equals)('profile'), (0, _ramda.always)('Company')], [(0, _ramda.equals)('location'), (0, _ramda.always)('Location')], [(0, _ramda.equals)('product'), (0, _ramda.always)('Product')]]);
    return _this;
  }

  _createClass(Profile, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !((0, _ramda.equals)(nextProps, this.props) && (0, _ramda.equals)(nextState, this.state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          user = _props.user,
          dispatch = _props.dispatch,
          location = _props.location,
          params = _props.params,
          connectionsStats = _props.connectionsStats,
          children = _props.children,
          isEditable = _props.isEditable,
          history = _props.history,
          routeName = _props.routeName,
          triggerSnackBarMessage = _props.triggerSnackBarMessage,
          updateUpgradeSource = _props.updateUpgradeSource,
          previewingOwnProfile = _props.previewingOwnProfile;

      // const routedFromPF = docCookies.getItem('fromPF'); // viewing profile from PF
      // const isViewingOwnProfile = !isNilOrEmpty(profileToShow.connectionInfo) && equals(profileToShow.companyId, path(['user', 'userID'], user));

      var isViewingOwnProfile = previewingOwnProfile;
      var isSingleLocSupplier = (0, _ramda.path)(['company', 'oneOrMultiProperties'], user) === 'one-prop';

      return _react2.default.createElement(
        'div',
        null,
        this.props.isEditable ? _react2.default.createElement(_editFieldModalContainer2.default, _extends({
          clearModalState: this.clearModalState,
          sendEditToReducer: this.sendEditToReducer,
          _saveField: this.submitEdit
        }, this.props, {
          ref: 'editFieldModal'
        })) : undefined,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_profileTopBarContainer2.default, _extends({
            isViewingOwnProfile: isViewingOwnProfile,
            editField: this.editField,
            inlineEditField: this.inlineEditField,
            _saveField: this.submitEdit,
            basicUser: Boolean(user.billingPlan === 'none' || user.billingPlan === 'basic'),
            isSingleLocSupplier: isSingleLocSupplier,
            singleLocId: user.company.singleLocId
          }, this.props))
        ),
        _react2.default.createElement(
          'div',
          { className: 'l-app-content l-app-profile-content' },
          _react2.default.createElement(
            'div',
            { className: 'l-profile-content' },
            _react2.default.createElement(
              'div',
              { className: 'l-profile-left-content' },
              _react2.default.createElement(_profileLeftBarContainer2.default, _extends({
                editField: this.editField,
                inlineEditField: this.inlineEditField,
                _saveField: this.submitEdit,
                isSingleLocSupplier: isSingleLocSupplier
              }, this.props))
            ),
            _react2.default.createElement(
              'div',
              { className: 'l-profile-right-content' },
              _react2.default.createElement(_content2.default, _extends({
                editField: this.editField,
                inlineEditField: this.inlineEditField,
                sendEditToReducer: this.sendEditToReducer,
                clearEditState: this.clearModalState,
                _saveField: this.submitEdit,
                isEditing: true,
                isViewingOwnProfile: isViewingOwnProfile
              }, this.props))
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'l-profile-address' },
          _react2.default.createElement(_companyAddress2.default, { address: profileToShow.address, className: 'address-data' })
        )
      );
    }
  }]);

  return Profile;
}(_react.Component);

Profile.propTypes = {
  isEditable: _react.PropTypes.bool,
  dispatch: _react.PropTypes.func,
  routeName: _react.PropTypes.string,
  params: _react.PropTypes.object,
  profileToShow: _react.PropTypes.object,
  user: _react.PropTypes.object,
  location: _react.PropTypes.object,
  connectionsStats: _react.PropTypes.object,
  children: _react.PropTypes.object,
  history: _react.PropTypes.object,
  triggerSnackBarMessage: _react.PropTypes.func,
  updateUpgradeSource: _react.PropTypes.func,
  previewingOwnProfile: _react.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var profile = _ref2.profile;
  return {
    previewingOwnProfile: profile.get('previewingOwnProfile') || false
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Profile);

/***/ }),
/* 3003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editFieldForModal = editFieldForModal;
exports.startEdit = startEdit;
exports.startInlineEdit = startInlineEdit;
exports.clearEditModalState = clearEditModalState;

var _profileEditModalConstants = __webpack_require__(1849);

var constants = _interopRequireWildcard(_profileEditModalConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function editFieldForModal(update) {
  return {
    type: constants.EDIT_FIELD_FOR_MODAL,
    payload: update
  };
}

function startEdit(options) {
  return {
    type: constants.START_EDIT,
    payload: options
  };
}

function startInlineEdit(options) {
  return {
    type: constants.START_INLINE_EDIT,
    payload: options
  };
}

function clearEditModalState() {
  return { type: constants.CLEAR_EDIT_MODAL_STATE };
}

/***/ }),
/* 3004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _map = __webpack_require__(3005);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Address = (0, _react.createClass)({

  propTypes: {
    address: _react.PropTypes.object,
    className: _react.PropTypes.string
  },

  render: function render() {
    var coordinates = void 0;
    var map = void 0;
    var address = this.props.address ? this.props.address : undefined;
    if (address) {
      if (address.loc) {
        if (address.loc.coordinates && address.loc.coordinates.length) {
          if (typeof address.loc.coordinates === 'string') {
            var longLat = address.loc.coordinates.split(',');
            coordinates = [longLat[1], longLat[0]];
          } else if (Array.isArray(address.loc.coordinates)) {
            coordinates = [address.loc.coordinates[1], address.loc.coordinates[0]];
          }
          // map = <SimpleMap coordinates={coordinates} googleMapsApi={window.google.maps} />;
        }
      }
    }
    if (!map) return false;

    return _react2.default.createElement(
      'div',
      { className: this.props.className },
      map
    );
  }
});

exports.default = Address;

/***/ }),
/* 3005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactGoogleMaps = __webpack_require__(1914);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var google = window.google;

var SimpleMap = function (_Component) {
  _inherits(SimpleMap, _Component);

  function SimpleMap() {
    _classCallCheck(this, SimpleMap);

    var _this = _possibleConstructorReturn(this, (SimpleMap.__proto__ || Object.getPrototypeOf(SimpleMap)).call(this));

    _this.state = {
      googleMapsIsReady: false
    };
    return _this;
  }

  _createClass(SimpleMap, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      // we are using google map's API and we have to wait for each api to load.
      window.initializedGoogleMap.listener(function () {
        _this2.setState({
          googleMapsIsReady: true
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.googleMapsIsReady) {
        return _react2.default.createElement(
          'div',
          null,
          ' Loading... '
        );
      }

      var _props = this.props,
          googleMapsApi = _props.googleMapsApi,
          otherProps = _objectWithoutProperties(_props, ['googleMapsApi']);

      var coordinates = this.props.coordinates || [-33.867486900000000000, 151.206990200000060000];
      return _react2.default.createElement(
        _reactGoogleMaps.GoogleMaps,
        {
          containerProps: _extends({}, otherProps, {
            style: {
              height: '100%',
              position: 'absolute',
              top: '0',
              bottom: '0',
              left: '0',
              right: '0'
            }
          }),
          ref: 'map',
          googleMapsApi: google ? google.maps : null,
          zoom: 12,
          center: new google.maps.LatLng(coordinates[0], coordinates[1] - 0.05)
        },
        _react2.default.createElement(_reactGoogleMaps.Marker, { position: new google.maps.LatLng(coordinates[0], coordinates[1]) })
      );
    }
  }]);

  return SimpleMap;
}(_react.Component);

SimpleMap.propTypes = {
  coordinates: _react.PropTypes.array,
  googleMapsApi: _react.PropTypes.object
};

exports.default = SimpleMap;

/***/ }),
/* 3006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(3007);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(3008);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3009);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3010);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3011);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3014);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = withGoogleMap;

var _warning = __webpack_require__(89);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _reactDisplayName = __webpack_require__(3017);

var _reactDisplayName2 = _interopRequireDefault(_reactDisplayName);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(539);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function withGoogleMap(WrappedComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    (0, _inherits3.default)(Container, _Component);

    function Container() {
      var _ref;

      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, Container);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Container.__proto__ || (0, _getPrototypeOf2.default)(Container)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        map: null
      }, _this.handleComponentMount = _this.handleComponentMount.bind(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Container, [{
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)({}, _constants.MAP, this.state.map);
      }
    }, {
      key: "componentWillMount",
      value: function componentWillMount() {
        var _props = this.props,
            containerElement = _props.containerElement,
            mapElement = _props.mapElement;

        (0, _invariant2.default)(!!containerElement && !!mapElement, "Required props containerElement or mapElement is missing. You need to provide both of them.\n The `google.maps.Map` instance will be initialized on mapElement and it's wrapped by containerElement.\nYou need to provide both of them since Google Map requires the DOM to have height when initialized.");
      }
    }, {
      key: "handleComponentMount",
      value: function handleComponentMount(node) {
        if (this.state.map || node === null) {
          return;
        }
        (0, _warning2.default)("undefined" !== typeof google, "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168");
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
        var map = new google.maps.Map(node);
        this.setState({ map: map });
      }
    }, {
      key: "render",
      value: function render() {
        var _props2 = this.props,
            containerElement = _props2.containerElement,
            mapElement = _props2.mapElement,
            restProps = (0, _objectWithoutProperties3.default)(_props2, ["containerElement", "mapElement"]);
        var map = this.state.map;


        if (map) {
          return _react2.default.cloneElement(containerElement, {}, _react2.default.cloneElement(mapElement, {
            ref: this.handleComponentMount
          }), _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(WrappedComponent, restProps)
          ));
        } else {
          return _react2.default.cloneElement(containerElement, {}, _react2.default.cloneElement(mapElement, {
            ref: this.handleComponentMount
          }), _react2.default.createElement("div", null));
        }
      }
    }]);
    return Container;
  }(_react.Component), _class.displayName = "withGoogleMap(" + (0, _reactDisplayName2.default)(WrappedComponent) + ")", _class.propTypes = {
    containerElement: _react.PropTypes.node.isRequired,
    mapElement: _react.PropTypes.node.isRequired
  }, _class.childContextTypes = (0, _defineProperty3.default)({}, _constants.MAP, _react.PropTypes.object), _temp2;
} /* global google */

/***/ }),
/* 3007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 3008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1032), __esModule: true };

/***/ }),
/* 3009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 3010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1915);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(1916);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 3012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1034), __esModule: true };

/***/ }),
/* 3013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1036), __esModule: true };

/***/ }),
/* 3014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(3015);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(3016);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(1916);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 3015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1037), __esModule: true };

/***/ }),
/* 3016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1038), __esModule: true };

/***/ }),
/* 3017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDisplayName;
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

/***/ }),
/* 3018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(3020);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(539);

var _enhanceElement = __webpack_require__(551);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  center: _react.PropTypes.object,

  heading: _react.PropTypes.number,

  mapTypeId: _react.PropTypes.any,

  options: _react.PropTypes.object,

  streetView: _react.PropTypes.any,

  tilt: _react.PropTypes.number,

  zoom: _react.PropTypes.number
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onBoundsChanged: "bounds_changed",

  onCenterChanged: "center_changed",

  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onHeadingChanged: "heading_changed",

  onIdle: "idle",

  onMapTypeIdChanged: "maptypeid_changed",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onProjectionChanged: "projection_changed",

  onResize: "resize",

  onRightClick: "rightclick",

  onTilesLoaded: "tilesloaded",

  onTiltChanged: "tilt_changed",

  onZoomChanged: "zoom_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getBounds: function getBounds(map) {
    return map.getBounds();
  },
  getCenter: function getCenter(map) {
    return map.getCenter();
  },
  getDiv: function getDiv(map) {
    return map.getDiv();
  },
  getHeading: function getHeading(map) {
    return map.getHeading();
  },
  getMapTypeId: function getMapTypeId(map) {
    return map.getMapTypeId();
  },
  getProjection: function getProjection(map) {
    return map.getProjection();
  },
  getStreetView: function getStreetView(map) {
    return map.getStreetView();
  },
  getTilt: function getTilt(map) {
    return map.getTilt();
  },
  getZoom: function getZoom(map) {
    return map.getZoom();
  },

  // END - Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  //
  // Public APIs - Use this carefully
  // See discussion in https://github.com/tomchentw/react-google-maps/issues/62
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return !it.match(/^get/) && !it.match(/^set/) && !it.match(/Map$/); })
  fitBounds: function fitBounds(map, args) {
    return map.fitBounds.apply(map, (0, _toConsumableArray3.default)(args));
  },
  panBy: function panBy(map, args) {
    return map.panBy.apply(map, (0, _toConsumableArray3.default)(args));
  },
  panTo: function panTo(map, args) {
    return map.panTo.apply(map, (0, _toConsumableArray3.default)(args));
  },
  panToBounds: function panToBounds(map, args) {
    return map.panToBounds.apply(map, (0, _toConsumableArray3.default)(args));
  }
};

var controlledPropUpdaterMap = {
  center: function center(map, _center) {
    map.setCenter(_center);
  },
  heading: function heading(map, _heading) {
    map.setHeading(_heading);
  },
  mapTypeId: function mapTypeId(map, _mapTypeId) {
    map.setMapTypeId(_mapTypeId);
  },
  options: function options(map, _options) {
    map.setOptions(_options);
  },
  streetView: function streetView(map, _streetView) {
    map.setStreetView(_streetView);
  },
  tilt: function tilt(map, _tilt) {
    map.setTilt(_tilt);
  },
  zoom: function zoom(map, _zoom) {
    map.setZoom(_zoom);
  }
};

function getInstanceFromComponent(component) {
  return component.context[_constants.MAP];
}

exports.default = (0, _flowRight3.default)(_react2.default.createClass, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "GoogleMap",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _react.PropTypes.object),

  getInitialState: function getInitialState() {
    var map = getInstanceFromComponent(this);

    (0, _invariant2.default)(!!map, "Did you wrap <GoogleMap> component with withGoogleMap() HOC?");

    map.setOptions((0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props));
    return null;
  },
  render: function render() {
    var children = this.props.children;


    return _react2.default.createElement(
      "div",
      null,
      children
    );
  }
});

/***/ }),
/* 3019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1028), __esModule: true };

/***/ }),
/* 3020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(3021);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 3021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1761), __esModule: true };

/***/ }),
/* 3022 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(1519),
    flatRest = __webpack_require__(3023),
    getData = __webpack_require__(1522),
    getFuncName = __webpack_require__(1919),
    isArray = __webpack_require__(255),
    isLaziable = __webpack_require__(1920);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 3023 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(3024),
    overRest = __webpack_require__(1889),
    setToString = __webpack_require__(1506);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 3024 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(1508);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 3025 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 3026 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(1523),
    LodashWrapper = __webpack_require__(1519),
    baseLodash = __webpack_require__(1521),
    isArray = __webpack_require__(255),
    isObjectLike = __webpack_require__(874),
    wrapperClone = __webpack_require__(3027);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 3027 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(1523),
    LodashWrapper = __webpack_require__(1519),
    copyArray = __webpack_require__(1921);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 3028 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(1922);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 3029 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(1248),
    root = __webpack_require__(550);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 3030 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1505),
    createCtor = __webpack_require__(1248),
    createHybrid = __webpack_require__(1924),
    createRecurry = __webpack_require__(1927),
    getHolder = __webpack_require__(1524),
    replaceHolders = __webpack_require__(1249),
    root = __webpack_require__(550);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 3031 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 3032 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 3033 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 3034 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(1930),
    arrayIncludes = __webpack_require__(1237);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 3035 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(1921),
    isIndex = __webpack_require__(1244);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 3036 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1505),
    createCtor = __webpack_require__(1248),
    root = __webpack_require__(550);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(1925),
    composeArgsRight = __webpack_require__(1926),
    replaceHolders = __webpack_require__(1249);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 3038 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(3039);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(1931);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(1930),
    baseEach = __webpack_require__(1932),
    castFunction = __webpack_require__(3046),
    isArray = __webpack_require__(255);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 3041 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(3042);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 3042 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 3043 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(1513),
    nativeKeys = __webpack_require__(3044);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1883);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 3045 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(1053);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 3046 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(1052);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 3047 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(875),
    createWrap = __webpack_require__(1922),
    getHolder = __webpack_require__(1524),
    replaceHolders = __webpack_require__(1249);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = baseRest(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

module.exports = bind;


/***/ }),
/* 3048 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(3049),
    hasPath = __webpack_require__(1934);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 3049 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 3050 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(3051);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 3051 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1908);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 3052 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(3053);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1132),
    arrayMap = __webpack_require__(1238),
    isArray = __webpack_require__(255),
    isSymbol = __webpack_require__(1250);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 3054 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(3055),
    baseEach = __webpack_require__(1932),
    baseIteratee = __webpack_require__(1936),
    baseReduce = __webpack_require__(3084),
    isArray = __webpack_require__(255);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 3055 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 3056 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(3057),
    getMatchData = __webpack_require__(3076),
    matchesStrictComparable = __webpack_require__(1941);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 3057 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(1937),
    baseIsEqual = __webpack_require__(1938);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 3058 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(1234);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 3059 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 3060 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 3061 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 3062 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(1234),
    Map = __webpack_require__(1502),
    MapCache = __webpack_require__(1500);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 3063 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(1937),
    equalArrays = __webpack_require__(1939),
    equalByTag = __webpack_require__(3065),
    equalObjects = __webpack_require__(3068),
    getTag = __webpack_require__(3073),
    isArray = __webpack_require__(255),
    isBuffer = __webpack_require__(1905),
    isTypedArray = __webpack_require__(1906);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 3064 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 3065 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1132),
    Uint8Array = __webpack_require__(3066),
    eq = __webpack_require__(1133),
    equalArrays = __webpack_require__(1939),
    mapToArray = __webpack_require__(3067),
    setToArray = __webpack_require__(1510);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 3066 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(550);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 3067 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 3068 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(3069);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 3069 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(3070),
    getSymbols = __webpack_require__(3071),
    keys = __webpack_require__(1251);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 3070 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1894),
    isArray = __webpack_require__(255);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 3071 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1893),
    stubArray = __webpack_require__(3072);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 3072 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 3073 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(3074),
    Map = __webpack_require__(1502),
    Promise = __webpack_require__(3075),
    Set = __webpack_require__(1896),
    WeakMap = __webpack_require__(1918),
    baseGetTag = __webpack_require__(1051),
    toSource = __webpack_require__(1888);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 3074 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(1000),
    root = __webpack_require__(550);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 3075 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(1000),
    root = __webpack_require__(550);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 3076 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(1940),
    keys = __webpack_require__(1251);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 3077 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(1938),
    get = __webpack_require__(3078),
    hasIn = __webpack_require__(3079),
    isKey = __webpack_require__(1525),
    isStrictComparable = __webpack_require__(1940),
    matchesStrictComparable = __webpack_require__(1941),
    toKey = __webpack_require__(1252);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 3078 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(1942);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 3079 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(3080),
    hasPath = __webpack_require__(1934);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 3080 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 3081 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(3082),
    basePropertyDeep = __webpack_require__(3083),
    isKey = __webpack_require__(1525),
    toKey = __webpack_require__(1252);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 3082 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 3083 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(1942);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 3084 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 3085 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(1526),
    baseForOwn = __webpack_require__(1933),
    baseIteratee = __webpack_require__(1936);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),
/* 3086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _contextTypes; /* global google */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(539);

var _enhanceElement = __webpack_require__(551);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
  animation: _react.PropTypes.any,

  attribution: _react.PropTypes.any,

  clickable: _react.PropTypes.bool,

  cursor: _react.PropTypes.string,

  draggable: _react.PropTypes.bool,

  icon: _react.PropTypes.any,

  label: _react.PropTypes.any,

  noRedraw: _react.PropTypes.bool,

  opacity: _react.PropTypes.number,

  options: _react.PropTypes.object,

  place: _react.PropTypes.any,

  position: _react.PropTypes.any,

  shape: _react.PropTypes.any,

  title: _react.PropTypes.string,

  visible: _react.PropTypes.bool,

  zIndex: _react.PropTypes.number
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onAnimationChanged: "animation_changed",

  onClick: "click",

  onClickableChanged: "clickable_changed",

  onCursorChanged: "cursor_changed",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDraggableChanged: "draggable_changed",

  onDragStart: "dragstart",

  onFlatChanged: "flat_changed",

  onIconChanged: "icon_changed",

  onMouseDown: "mousedown",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onPositionChanged: "position_changed",

  onRightClick: "rightclick",

  onShapeChanged: "shape_changed",

  onTitleChanged: "title_changed",

  onVisibleChanged: "visible_changed",

  onZindexChanged: "zindex_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getAnimation: function getAnimation(marker) {
    return marker.getAnimation();
  },
  getAttribution: function getAttribution(marker) {
    return marker.getAttribution();
  },
  getClickable: function getClickable(marker) {
    return marker.getClickable();
  },
  getCursor: function getCursor(marker) {
    return marker.getCursor();
  },
  getDraggable: function getDraggable(marker) {
    return marker.getDraggable();
  },
  getIcon: function getIcon(marker) {
    return marker.getIcon();
  },
  getLabel: function getLabel(marker) {
    return marker.getLabel();
  },
  getOpacity: function getOpacity(marker) {
    return marker.getOpacity();
  },
  getPlace: function getPlace(marker) {
    return marker.getPlace();
  },
  getPosition: function getPosition(marker) {
    return marker.getPosition();
  },
  getShape: function getShape(marker) {
    return marker.getShape();
  },
  getTitle: function getTitle(marker) {
    return marker.getTitle();
  },
  getVisible: function getVisible(marker) {
    return marker.getVisible();
  },
  getZIndex: function getZIndex(marker) {
    return marker.getZIndex();
  }
};

var controlledPropUpdaterMap = {
  animation: function animation(marker, _animation) {
    marker.setAnimation(_animation);
  },
  attribution: function attribution(marker, _attribution) {
    marker.setAttribution(_attribution);
  },
  clickable: function clickable(marker, _clickable) {
    marker.setClickable(_clickable);
  },
  cursor: function cursor(marker, _cursor) {
    marker.setCursor(_cursor);
  },
  draggable: function draggable(marker, _draggable) {
    marker.setDraggable(_draggable);
  },
  icon: function icon(marker, _icon) {
    marker.setIcon(_icon);
  },
  label: function label(marker, _label) {
    marker.setLabel(_label);
  },
  opacity: function opacity(marker, _opacity) {
    marker.setOpacity(_opacity);
  },
  options: function options(marker, _options) {
    marker.setOptions(_options);
  },
  place: function place(marker, _place) {
    marker.setPlace(_place);
  },
  position: function position(marker, _position) {
    marker.setPosition(_position);
  },
  shape: function shape(marker, _shape) {
    marker.setShape(_shape);
  },
  title: function title(marker, _title) {
    marker.setTitle(_title);
  },
  visible: function visible(marker, _visible) {
    marker.setVisible(_visible);
  },
  zIndex: function zIndex(marker, _zIndex) {
    marker.setZIndex(_zIndex);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.MARKER];
}

exports.default = (0, _flowRight3.default)(_react2.default.createClass, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Marker",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (_contextTypes = {}, (0, _defineProperty3.default)(_contextTypes, _constants.MAP, _react.PropTypes.object), (0, _defineProperty3.default)(_contextTypes, _constants.MARKER_CLUSTERER, _react.PropTypes.object), _contextTypes),

  childContextTypes: (0, _defineProperty3.default)({}, _constants.ANCHOR, _react.PropTypes.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
    var marker = new google.maps.Marker((0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props));
    var markerClusterer = this.context[_constants.MARKER_CLUSTERER];
    if (markerClusterer) {
      markerClusterer.addMarker(marker, !!this.props.noRedraw);
    } else {
      marker.setMap(this.context[_constants.MAP]);
    }
    return (0, _defineProperty3.default)({}, _constants.MARKER, marker);
  },
  getChildContext: function getChildContext() {
    return (0, _defineProperty3.default)({}, _constants.ANCHOR, this.context[_constants.ANCHOR] || getInstanceFromComponent(this));
  },
  componentWillUnmount: function componentWillUnmount() {
    var marker = getInstanceFromComponent(this);
    if (marker) {
      var markerClusterer = this.context[_constants.MARKER_CLUSTERER];
      if (markerClusterer) {
        markerClusterer.removeMarker(marker, !!this.props.noRedraw);
      }
      marker.setMap(null);
    }
  },
  render: function render() {
    var children = this.props.children;


    return _react2.default.createElement(
      "div",
      null,
      children
    );
  }
});

/***/ }),
/* 3087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(539);

var _enhanceElement = __webpack_require__(551);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
  bounds: _react.PropTypes.any,
  draggable: _react.PropTypes.bool,
  editable: _react.PropTypes.bool,
  options: _react.PropTypes.object,
  visible: _react.PropTypes.bool
}; /* global google */


var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onBoundsChanged: "bounds_changed",

  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onMouseDown: "mousedown",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onRightClick: "rightclick"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getBounds: function getBounds(rectangle) {
    return rectangle.getBounds();
  },
  getDraggable: function getDraggable(rectangle) {
    return rectangle.getDraggable();
  },
  getEditable: function getEditable(rectangle) {
    return rectangle.getEditable();
  },
  getVisible: function getVisible(rectangle) {
    return rectangle.getVisible();
  }
};

var controlledPropUpdaterMap = {
  bounds: function bounds(rectangle, _bounds) {
    rectangle.setBounds(_bounds);
  },
  draggable: function draggable(rectangle, _draggable) {
    rectangle.setDraggable(_draggable);
  },
  editable: function editable(rectangle, _editable) {
    rectangle.setEditable(_editable);
  },
  options: function options(rectangle, _options) {
    rectangle.setOptions(_options);
  },
  visible: function visible(rectangle, _visible) {
    rectangle.setVisible(_visible);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.RECTANGLE];
}

exports.default = (0, _flowRight3.default)(_react2.default.createClass, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Rectangle",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _react.PropTypes.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
    var rectangle = new google.maps.Rectangle((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.RECTANGLE, rectangle);
  },
  componentWillUnmount: function componentWillUnmount() {
    var rectangle = getInstanceFromComponent(this);
    if (rectangle) {
      rectangle.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 3088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(539);

var _enhanceElement = __webpack_require__(551);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
  draggable: _react.PropTypes.bool,
  editable: _react.PropTypes.bool,
  options: _react.PropTypes.object,
  path: _react.PropTypes.any,
  visible: _react.PropTypes.bool
}; /* global google */


var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onMouseDown: "mousedown",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onRightClick: "rightclick"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getDraggable: function getDraggable(polyline) {
    return polyline.getDraggable();
  },
  getEditable: function getEditable(polyline) {
    return polyline.getEditable();
  },
  getPath: function getPath(polyline) {
    return polyline.getPath();
  },
  getVisible: function getVisible(polyline) {
    return polyline.getVisible();
  }
};

var controlledPropUpdaterMap = {
  draggable: function draggable(polyline, _draggable) {
    polyline.setDraggable(_draggable);
  },
  editable: function editable(polyline, _editable) {
    polyline.setEditable(_editable);
  },
  options: function options(polyline, _options) {
    polyline.setOptions(_options);
  },
  path: function path(polyline, _path) {
    polyline.setPath(_path);
  },
  visible: function visible(polyline, _visible) {
    polyline.setVisible(_visible);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.POLYLINE];
}

exports.default = (0, _flowRight3.default)(_react2.default.createClass, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Polyline",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _react.PropTypes.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
    var polyline = new google.maps.Polyline((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.POLYLINE, polyline);
  },
  componentWillUnmount: function componentWillUnmount() {
    var polyline = getInstanceFromComponent(this);
    if (polyline) {
      polyline.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 3089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(539);

var _enhanceElement = __webpack_require__(551);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
  draggable: _react.PropTypes.bool,
  editable: _react.PropTypes.bool,
  options: _react.PropTypes.object,
  path: _react.PropTypes.any,
  paths: _react.PropTypes.any,
  visible: _react.PropTypes.bool
}; /* global google */


var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onMouseDown: "mousedown",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onRightClick: "rightclick"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getDraggable: function getDraggable(polygon) {
    return polygon.getDraggable();
  },
  getEditable: function getEditable(polygon) {
    return polygon.getEditable();
  },
  getPath: function getPath(polygon) {
    return polygon.getPath();
  },
  getPaths: function getPaths(polygon) {
    return polygon.getPaths();
  },
  getVisible: function getVisible(polygon) {
    return polygon.getVisible();
  }
};

var controlledPropUpdaterMap = {
  draggable: function draggable(polygon, _draggable) {
    polygon.setDraggable(_draggable);
  },
  editable: function editable(polygon, _editable) {
    polygon.setEditable(_editable);
  },
  options: function options(polygon, _options) {
    polygon.setOptions(_options);
  },
  path: function path(polygon, _path) {
    polygon.setPath(_path);
  },
  paths: function paths(polygon, _paths) {
    polygon.setPaths(_paths);
  },
  visible: function visible(polygon, _visible) {
    polygon.setVisible(_visible);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.POLYGON];
}

exports.default = (0, _flowRight3.default)(_react2.default.createClass, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Polygon",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _react.PropTypes.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
    var polygon = new google.maps.Polygon((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.POLYGON, polygon);
  },
  componentWillUnmount: function componentWillUnmount() {
    var polygon = getInstanceFromComponent(this);
    if (polygon) {
      polygon.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 3090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(539);

var _enhanceElement = __webpack_require__(551);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
  center: _react.PropTypes.any,
  draggable: _react.PropTypes.bool,
  editable: _react.PropTypes.bool,
  options: _react.PropTypes.object,
  radius: _react.PropTypes.number,
  visible: _react.PropTypes.bool
}; /* global google */


var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onCenterChanged: "center_changed",

  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onMouseDown: "mousedown",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onRadiusChanged: "radius_changed",

  onRightClick: "rightclick"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getBounds: function getBounds(circle) {
    return circle.getBounds();
  },
  getCenter: function getCenter(circle) {
    return circle.getCenter();
  },
  getDraggable: function getDraggable(circle) {
    return circle.getDraggable();
  },
  getEditable: function getEditable(circle) {
    return circle.getEditable();
  },
  getMap: function getMap(circle) {
    return circle.getMap();
  },
  getRadius: function getRadius(circle) {
    return circle.getRadius();
  },
  getVisible: function getVisible(circle) {
    return circle.getVisible();
  }
};

var controlledPropUpdaterMap = {
  center: function center(circle, _center) {
    circle.setCenter(_center);
  },
  draggable: function draggable(circle, _draggable) {
    circle.setDraggable(_draggable);
  },
  editable: function editable(circle, _editable) {
    circle.setEditable(_editable);
  },
  options: function options(circle, _options) {
    circle.setOptions(_options);
  },
  radius: function radius(circle, _radius) {
    circle.setRadius(_radius);
  },
  visible: function visible(circle, _visible) {
    circle.setVisible(_visible);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.CIRCLE];
}

exports.default = (0, _flowRight3.default)(_react2.default.createClass, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Circle",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _react.PropTypes.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
    var circle = new google.maps.Circle((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.CIRCLE, circle);
  },
  componentWillUnmount: function componentWillUnmount() {
    var circle = getInstanceFromComponent(this);
    if (circle) {
      circle.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 3091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(539);

var _enhanceElement = __webpack_require__(551);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
  defaultViewport: _react.PropTypes.any,
  options: _react.PropTypes.any,
  metadata: _react.PropTypes.any,
  status: _react.PropTypes.any,
  url: _react.PropTypes.string,
  zIndex: _react.PropTypes.number
}; /* global google */


var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onClick: "click",

  onDefaultViewportChanged: "defaultviewport_changed",

  onStatusChanged: "status_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getDefaultViewport: function getDefaultViewport(kmlLayer) {
    return kmlLayer.getDefaultViewport();
  },
  getMetadata: function getMetadata(kmlLayer) {
    return kmlLayer.getMetadata();
  },
  getOptions: function getOptions(kmlLayer) {
    return kmlLayer.getOptions();
  },
  getStatus: function getStatus(kmlLayer) {
    return kmlLayer.getStatus();
  },
  getUrl: function getUrl(kmlLayer) {
    return kmlLayer.getUrl();
  },
  getZIndex: function getZIndex(kmlLayer) {
    return kmlLayer.getZIndex();
  }
};

var controlledPropUpdaterMap = {
  defaultViewport: function defaultViewport(kmlLayer, _defaultViewport) {
    kmlLayer.setDefaultViewport(_defaultViewport);
  },
  metadata: function metadata(kmlLayer, _metadata) {
    kmlLayer.setMetadata(_metadata);
  },
  options: function options(kmlLayer, _options) {
    kmlLayer.setOptions(_options);
  },
  status: function status(kmlLayer, _status) {
    kmlLayer.setStatus(_status);
  },
  url: function url(kmlLayer, _url) {
    kmlLayer.setUrl(_url);
  },
  zIndex: function zIndex(kmlLayer, _zIndex) {
    kmlLayer.setZIndex(_zIndex);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.KML_LAYER];
}

exports.default = (0, _flowRight3.default)(_react2.default.createClass, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "KmlLayer",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _react.PropTypes.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
    var kmlLayer = new google.maps.KmlLayer((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.KML_LAYER, kmlLayer);
  },
  componentWillUnmount: function componentWillUnmount() {
    var kmlLayer = getInstanceFromComponent(this);
    if (kmlLayer) {
      kmlLayer.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 3092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(539);

var _enhanceElement = __webpack_require__(551);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
    // NOTICE!!!!!!
    //
    // Only expose those with getters & setters in the table as controlled props.
    //
    // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
    //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
    //
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
    options: _react.PropTypes.object
}; /* global google */


var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
    onClick: 'click'
};

var publicMethodMap = {
    // Public APIs
    //
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
    //
    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
    //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
    // END - Public APIs
};

var controlledPropUpdaterMap = {
    options: function options(fusionTablesLayer, _options) {
        fusionTablesLayer.setOptions(_options);
    }
};

function getInstanceFromComponent(component) {
    return component.state[_constants.FUSION_TABLES_LAYER];
}

exports.default = (0, _flowRight3.default)(_react2.default.createClass, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
    displayName: 'FusionTablesLayer',

    propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

    contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _react.PropTypes.object),

    getInitialState: function getInitialState() {
        var fusionTablesLayer = new google.maps.FusionTablesLayer((0, _extends3.default)({
            map: this.context[_constants.MAP]
        }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));

        return (0, _defineProperty3.default)({}, _constants.FUSION_TABLES_LAYER, fusionTablesLayer);
    },
    componentWillUnmount: function componentWillUnmount() {
        var fusionTablesLayer = getInstanceFromComponent(this);
        if (fusionTablesLayer) {
            fusionTablesLayer.setMap(null);
        }
    },
    render: function render() {
        return false;
    }
});

/***/ }),
/* 3093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(539);

var _enhanceElement = __webpack_require__(551);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
  options: _react.PropTypes.object
}; /* global google */


var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  // END - Public APIs
};

var controlledPropUpdaterMap = {
  options: function options(trafficLayer, _options) {
    trafficLayer.setOptions(_options);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.TRAFFIC_LAYER];
}

exports.default = (0, _flowRight3.default)(_react2.default.createClass, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "TrafficLayer",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _react.PropTypes.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
    var trafficLayer = new google.maps.TrafficLayer((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.TRAFFIC_LAYER, trafficLayer);
  },
  componentWillUnmount: function componentWillUnmount() {
    var trafficLayer = getInstanceFromComponent(this);
    if (trafficLayer) {
      trafficLayer.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 3094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(539);

var _enhanceElement = __webpack_require__(551);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
  directions: _react.PropTypes.any,
  options: _react.PropTypes.object,
  panel: _react.PropTypes.object,
  routeIndex: _react.PropTypes.number
}; /* global google */


var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onDirectionsChanged: "directions_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getDirections: function getDirections(directionsRenderer) {
    return directionsRenderer.getDirections();
  },
  getPanel: function getPanel(directionsRenderer) {
    return directionsRenderer.getPanel();
  },
  getRouteIndex: function getRouteIndex(directionsRenderer) {
    return directionsRenderer.getRouteIndex();
  }
};

var controlledPropUpdaterMap = {
  directions: function directions(directionsRenderer, _directions) {
    directionsRenderer.setDirections(_directions);
  },
  options: function options(directionsRenderer, _options) {
    directionsRenderer.setOptions(_options);
  },
  panel: function panel(directionsRenderer, _panel) {
    directionsRenderer.setPanel(_panel);
  },
  routeIndex: function routeIndex(directionsRenderer, _routeIndex) {
    directionsRenderer.setRouteIndex(_routeIndex);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.DIRECTIONS_RENDERER];
}

exports.default = (0, _flowRight3.default)(_react2.default.createClass, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "DirectionsRenderer",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _react.PropTypes.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
    var directionsRenderer = new google.maps.DirectionsRenderer((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.DIRECTIONS_RENDERER, directionsRenderer);
  },
  componentWillUnmount: function componentWillUnmount() {
    var directionsRenderer = getInstanceFromComponent(this);
    if (directionsRenderer) {
      directionsRenderer.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(539);

var _enhanceElement = __webpack_require__(551);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#HeatmapLayer
  data: _react.PropTypes.any,
  options: _react.PropTypes.object
}; /* global google */


var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#HeatmapLayer
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onZoomChanged: "zoom_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#HeatmapLayer
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  // END - Public APIs
};

var controlledPropUpdaterMap = {
  data: function data(heatmapLayer, _data) {
    heatmapLayer.setData(_data);
  },
  options: function options(heatmapLayer, _options) {
    heatmapLayer.setOptions(_options);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.HEATMAP_LAYER];
}

exports.default = (0, _flowRight3.default)(_react2.default.createClass, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "HeatmapLayer",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _react.PropTypes.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#HeatmapLayer
    var heatmapLayer = new google.maps.visualization.HeatmapLayer((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.HEATMAP_LAYER, heatmapLayer);
  },
  componentWillUnmount: function componentWillUnmount() {
    var heatmapLayer = getInstanceFromComponent(this);
    if (heatmapLayer) {
      heatmapLayer.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 3096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _contextTypes; /* global google */


var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(47);

var _constants = __webpack_require__(539);

var _enhanceElement = __webpack_require__(551);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
  children: _react.PropTypes.element,
  options: _react.PropTypes.object,
  position: _react.PropTypes.any,
  zIndex: _react.PropTypes.number
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onCloseClick: "closeclick",

  onContentChanged: "content_changed",

  onDomReady: "domready",

  onPositionChanged: "position_changed",

  onZIndexChanged: "zindex_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getPosition: function getPosition(infoWindow) {
    return infoWindow.getPosition();
  },
  getZIndex: function getZIndex(infoWindow) {
    return infoWindow.getZIndex();
  }
};

var controlledPropUpdaterMap = {
  children: function children(infoWindow, _children, component) {
    (0, _reactDom.unstable_renderSubtreeIntoContainer)(component, _react.Children.only(_children), infoWindow.getContent());
  },
  options: function options(infoWindow, _options) {
    infoWindow.setOptions(_options);
  },
  position: function position(infoWindow, _position) {
    infoWindow.setPosition(_position);
  },
  zIndex: function zIndex(infoWindow, _zIndex) {
    infoWindow.setZIndex(_zIndex);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.INFO_WINDOW];
}

function openInfoWindow(context, infoWindow) {
  var map = context[_constants.MAP];
  var anchor = context[_constants.ANCHOR];
  if (anchor) {
    infoWindow.open(map, anchor);
  } else if (infoWindow.getPosition()) {
    infoWindow.open(map);
  } else {
    (0, _invariant2.default)(false, "You must provide either an anchor (typically a <Marker>) or a position for <InfoWindow>.");
  }
}

exports.default = (0, _flowRight3.default)(_react2.default.createClass, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "InfoWindow",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (_contextTypes = {}, (0, _defineProperty3.default)(_contextTypes, _constants.MAP, _react.PropTypes.object), (0, _defineProperty3.default)(_contextTypes, _constants.ANCHOR, _react.PropTypes.object), _contextTypes),

  getInitialState: function getInitialState() {
    var map = this.context[_constants.MAP];
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
    var infoWindow = new google.maps.InfoWindow((0, _extends3.default)({
      map: map
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props), {
      // Override props of ReactElement type
      content: undefined,
      children: undefined
    }));

    openInfoWindow(this.context, infoWindow);
    return (0, _defineProperty3.default)({}, _constants.INFO_WINDOW, infoWindow);
  },
  componentDidMount: function componentDidMount() {
    var infoWindow = getInstanceFromComponent(this);
    var content = document.createElement("div");

    controlledPropUpdaterMap.children({
      getContent: function getContent() {
        return content;
      }
    }, this.props.children, this);
    infoWindow.setContent(content);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var anchorChanged = this.context[_constants.ANCHOR] !== nextContext[_constants.ANCHOR];
    if (anchorChanged) {
      var infoWindow = getInstanceFromComponent(this);
      openInfoWindow(nextContext, infoWindow);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    var infoWindow = getInstanceFromComponent(this);
    if (infoWindow) {
      (0, _reactDom.unmountComponentAtNode)(infoWindow.getContent());
      infoWindow.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 3097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(538);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _delay2 = __webpack_require__(3098);

var _delay3 = _interopRequireDefault(_delay2);

var _flowRight2 = __webpack_require__(540);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(539);

var _enhanceElement = __webpack_require__(551);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

var _OverlayViewHelper = __webpack_require__(3100);

var helpers = _interopRequireWildcard(_OverlayViewHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
  mapPaneName: _react.PropTypes.string,
  position: _react.PropTypes.object,
  bounds: _react.PropTypes.object
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getPanes: function getPanes(overlayView) {
    return overlayView.getPanes();
  },
  getProjection: function getProjection(overlayView) {
    return overlayView.getProjection();
  }
};

var controlledPropUpdaterMap = {};

function getInstanceFromComponent(component) {
  return component.state[_constants.OVERLAY_VIEW];
}

exports.default = (0, _flowRight3.default)(_react2.default.createClass, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "OverlayView",

  statics: {
    FLOAT_PANE: "floatPane",
    MAP_PANE: "mapPane",
    MARKER_LAYER: "markerLayer",
    OVERLAY_LAYER: "overlayLayer",
    OVERLAY_MOUSE_TARGET: "overlayMouseTarget"
  },

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes, {
    children: _react.PropTypes.node.isRequired,
    getPixelPositionOffset: _react.PropTypes.func
  }),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _react.PropTypes.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
    var overlayView = new google.maps.OverlayView();
    // You must implement three methods: onAdd(), draw(), and onRemove().
    overlayView.onAdd = this.onAdd;
    overlayView.draw = this.draw;
    overlayView.onRemove = this.onRemove;
    // You must call setMap() with a valid Map object to trigger the call to
    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
    overlayView.setMap(this.context[_constants.MAP]);
    return (0, _defineProperty3.default)({}, _constants.OVERLAY_VIEW, overlayView);
  },
  onAdd: function onAdd() {
    this._containerElement = helpers.createContainerElement();
  },
  draw: function draw() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
    var overlayView = getInstanceFromComponent(this);
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
    var mapPanes = overlayView.getPanes();
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapCanvasProjection
    var mapCanvasProjection = overlayView.getProjection();
    //
    var props = (0, _extends3.default)({}, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props), {
      children: this.props.children,
      getPixelPositionOffset: this.props.getPixelPositionOffset
    });
    helpers.mountContainerElementToPane(mapPanes, this._containerElement, props);
    helpers.renderChildToContainerElement(mapCanvasProjection, this._containerElement, props);
  },
  onRemove: function onRemove() {
    helpers.unmountAndDestroyContainerElement(this._containerElement);
    this._containerElement = null;
  },
  componentDidUpdate: function componentDidUpdate() {
    (0, _delay3.default)(this.draw);
  },
  componentWillUnmount: function componentWillUnmount() {
    var overlayView = getInstanceFromComponent(this);
    if (overlayView) {
      overlayView.setMap(null);
      // You must implement three methods: onAdd(), draw(), and onRemove().
      overlayView.onAdd = null;
      overlayView.draw = null;
      overlayView.onRemove = null;
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 3098 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(3099),
    baseRest = __webpack_require__(875),
    toNumber = __webpack_require__(1931);

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

module.exports = delay;


/***/ }),
/* 3099 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),
/* 3100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _assign2 = __webpack_require__(3101);

var _assign3 = _interopRequireDefault(_assign2);

var _isFunction2 = __webpack_require__(1501);

var _isFunction3 = _interopRequireDefault(_isFunction2);

exports.createContainerElement = createContainerElement;
exports.mountContainerElementToPane = mountContainerElementToPane;
exports.renderChildToContainerElement = renderChildToContainerElement;
exports.unmountAndDestroyContainerElement = unmountAndDestroyContainerElement;

var _invariant = __webpack_require__(69);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _reactDom = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createContainerElement() {
  var containerElement = document.createElement("div");
  containerElement.style.position = "absolute";
  return containerElement;
} /* global google */
function mountContainerElementToPane(mapPanes, containerElement, props) {
  var mapPaneName = props.mapPaneName;

  (0, _invariant2.default)(!!mapPaneName, "OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s", mapPaneName);
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
  mapPanes[mapPaneName].appendChild(containerElement);
}

function getOffsetOverride(containerElement, props) {
  var getPixelPositionOffset = props.getPixelPositionOffset;
  //
  // Allows the component to control the visual position of the OverlayView
  // relative to the LatLng pixel position.
  //

  if ((0, _isFunction3.default)(getPixelPositionOffset)) {
    return getPixelPositionOffset(containerElement.offsetWidth, containerElement.offsetHeight);
  } else {
    return {};
  }
}

function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng);
}

function createLatLngBounds(inst, Type) {
  return new Type(new google.maps.LatLng(inst.ne.lat, inst.ne.lng), new google.maps.LatLng(inst.sw.lat, inst.sw.lng));
}

function ensureOfType(inst, type, factory) {
  if (inst instanceof type) {
    return inst;
  } else {
    return factory(inst, type);
  }
}

function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast());
  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest());
  return {
    left: sw.x + offset.x + "px",
    top: ne.y + offset.y + "px",
    width: ne.x - sw.x - offset.x + "px",
    height: sw.y - ne.y - offset.y + "px"
  };
}

function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var _mapCanvasProjection$ = mapCanvasProjection.fromLatLngToDivPixel(position),
      x = _mapCanvasProjection$.x,
      y = _mapCanvasProjection$.y;

  return {
    left: x + offset.x + "px",
    top: y + offset.y + "px"
  };
}

function getLayoutStyles(mapCanvasProjection, offset, props) {
  if (props.bounds) {
    var bounds = ensureOfType(props.bounds, google.maps.LatLngBounds, createLatLngBounds);
    return getLayoutStylesByBounds(mapCanvasProjection, offset, bounds);
  } else {
    var position = ensureOfType(props.position, google.maps.LatLng, createLatLng);
    return getLayoutStylesByPosition(mapCanvasProjection, offset, position);
  }
}

function renderChildToContainerElement(mapCanvasProjection, containerElement, props) {
  var child = _react.Children.only(props.children);
  (0, _reactDom.render)(child, containerElement, function () {
    var offset = (0, _extends3.default)({
      x: 0,
      y: 0
    }, getOffsetOverride(containerElement, props));
    var layoutStyles = getLayoutStyles(mapCanvasProjection, offset, props);
    (0, _assign3.default)(containerElement.style, layoutStyles);
  });
}

function unmountAndDestroyContainerElement(containerElement) {
  containerElement.parentNode.removeChild(containerElement);
  (0, _reactDom.unmountComponentAtNode)(containerElement);
}

/***/ }),
/* 3101 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(1943),
    copyObject = __webpack_require__(3102),
    createAssigner = __webpack_require__(3103),
    isArrayLike = __webpack_require__(1053),
    isPrototype = __webpack_require__(1513),
    keys = __webpack_require__(1251);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 3102 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(1943),
    baseAssignValue = __webpack_require__(1526);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 3103 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(875),
    isIterateeCall = __webpack_require__(1903);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 3104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsUpdate = __webpack_require__(1516);

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _reactRedux = __webpack_require__(6);

var _editFieldModal = __webpack_require__(3105);

var _editFieldModal2 = _interopRequireDefault(_editFieldModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditFieldModalContainer = function (_Component) {
  _inherits(EditFieldModalContainer, _Component);

  function EditFieldModalContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EditFieldModalContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditFieldModalContainer.__proto__ || Object.getPrototypeOf(EditFieldModalContainer)).call.apply(_ref, [this].concat(args))), _this), _this.checkIfValidAddress = function (isValidAddress) {
      var sendEditToReducer = _this.props.sendEditToReducer;

      if (isValidAddress !== _this.props.editFieldModal.isValidAddress) sendEditToReducer({ isValidAddress: isValidAddress });
    }, _this._validateFieldForTextArea = function (fieldToValidate, type) {
      var required = _this.props.editFieldModal.settings ? _this.props.editFieldModal.settings.isRequired : false;
      if (fieldToValidate === undefined && required) return 'Required';
      if (fieldToValidate === '' && required) return 'Required';
      if (type === 'roomCountInfo' || type === 'number') {
        if (isNaN(fieldToValidate)) return 'Must Be A Valid Number';
        if (!(parseInt(fieldToValidate, 10) >= 0) || String(parseInt(fieldToValidate, 10)).length !== String(fieldToValidate).length) return 'Must Be A Valid Number';
      }
      if (type === 'tourDuration') {
        if (parseFloat(fieldToValidate) === 0) return 'Number Must Be Greater Than Zero';
        if (isNaN(fieldToValidate)) return 'Must Be A Valid Number';
        if (!(parseFloat(fieldToValidate) >= 0) || String(parseFloat(fieldToValidate, 10)).length !== String(fieldToValidate).length && parseFloat(fieldToValidate)) return 'Must Be A Valid Number';
      }
      if (type === 'roomSizeInfo') {
        // Ensures that only characters are digits/commas/periods - must be 0.12 or 0,12 (for european standard)
        if (!RegExp(/^[0-9]*?(\d(\.|\,)[0-9]+)*?$/).test(fieldToValidate)) return 'Must Be A Valid Number';
      }
    }, _this._updateFieldValue = function (event) {
      _this.props.sendEditToReducer({ value: event.target.value });
    }, _this._locateAddress = function (addressRef) {
      addressRef.geoLocateAndConfirmAddress(function (hasFormattedAddress, geoLocatedAddress) {
        _this.props.sendEditToReducer({
          needsToConfirmAddress: true,
          hasFormattedAddress: hasFormattedAddress,
          addressToConfirm: geoLocatedAddress
        });
      });
    }, _this._dismissModal = function () {
      _this.props.clearModalState();
    }, _this._toggleOptionValue = function (options) {
      _this.props.sendEditToReducer({
        value: options ? options.map(function (_ref2) {
          var value = _ref2.value;
          return value;
        }) : []
      });
    }, _this._goBack = function () {
      _this.props.sendEditToReducer({
        needsToConfirmAddress: false,
        hasTriedToLocate: true
      });
    }, _this.checkIfValidContact = function (isContactsInvalid) {
      if (isContactsInvalid !== _this.props.editFieldModal.isContactsInvalid) _this.props.sendEditToReducer({ isContactsInvalid: isContactsInvalid });
    }, _this.checkIfShouldBeDisabled = function () {
      var editFieldModal = _this.props.editFieldModal;
      var settings = editFieldModal.settings,
          value = editFieldModal.value;

      var required = settings ? settings.isRequired : false;
      if (value && required) {
        if (typeof value === 'string') return !value;
        if (Array.isArray(value)) return !value.some(function (item) {
          return item.value;
        });
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
          return !Object.keys(value).every(function (key) {
            if (settings && settings.type === 'tourDuration') {
              if (key === 'value') return parseFloat(value[key]);
              return value[key];
            } else if (settings && settings.type === 'roomSizeInfo' && key === 'value') {
              return value[key] && RegExp(/^[0-9]*?(\d(\.|\,)[0-9]+)*?$/).test(value[key]);
            } else if (settings && settings.type === 'roomCountInfo' && key === 'value') {
              return !Boolean(_this._validateFieldForTextArea(value.value, 'roomCountInfo'));
            }
            return value[key];
          });
        }
      }
      return required;
    }, _this._updateSubField = function (subField, updateValue) {
      var sendEditToReducer = _this.props.sendEditToReducer;

      if (_typeof(_this.props.editFieldModal.value) !== 'object') return;
      var valueToSet = (0, _reactAddonsUpdate2.default)(_this.props.editFieldModal.value, {
        $apply: function $apply(value) {
          if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
            value[subField] = updateValue;
            return value;
          }
          return value;
        }
      });
      sendEditToReducer({ value: valueToSet });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditFieldModalContainer, [{
    key: 'render',
    value: function render() {
      var props = _extends({
        checkIfValidAddress: this.checkIfValidAddress,
        _validateFieldForTextArea: this._validateFieldForTextArea,
        _updateFieldValue: this._updateFieldValue,
        _locateAddress: this._locateAddress,
        _dismissModal: this._dismissModal,
        _toggleOptionValue: this._toggleOptionValue,
        _goBack: this._goBack,
        checkIfValidContact: this.checkIfValidContact,
        checkIfShouldBeDisabled: this.checkIfShouldBeDisabled,
        _updateSubField: this._updateSubField
      }, this.props);
      return _react2.default.createElement(_editFieldModal2.default, props);
    }
  }]);

  return EditFieldModalContainer;
}(_react.Component);

var select = function select(state) {
  return { editFieldModal: state.editFieldModal.toJS() };
};

EditFieldModalContainer.propTypes = {
  dispatch: _react.PropTypes.func,
  sendEditToReducer: _react.PropTypes.func,
  isValidAddress: _react.PropTypes.bool,
  dialogOpen: _react.PropTypes.bool,
  editFieldModal: _react.PropTypes.object,
  clearModalState: _react.PropTypes.func
};

exports.default = (0, _reactRedux.connect)(select)(EditFieldModalContainer);

/***/ }),
/* 3105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rating = __webpack_require__(1944);

var _rating2 = _interopRequireDefault(_rating);

var _companyAddressEdit = __webpack_require__(3106);

var _companyAddressEdit2 = _interopRequireDefault(_companyAddressEdit);

var _companyContactEdit = __webpack_require__(3107);

var _companyContactEdit2 = _interopRequireDefault(_companyContactEdit);

var _beddingConfig = __webpack_require__(1528);

var _beddingConfig2 = _interopRequireDefault(_beddingConfig);

var _inputAndSingleSelectModal = __webpack_require__(3112);

var _inputAndSingleSelectModal2 = _interopRequireDefault(_inputAndSingleSelectModal);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _productInfoModal = __webpack_require__(3113);

var _productInfoModal2 = _interopRequireDefault(_productInfoModal);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

function validEmail(email) {
  var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
  return String(email).search(filter) !== -1;
}

var propTypes = {
  editFieldModal: _react.PropTypes.object,
  _toggleOptionValue: _react.PropTypes.func,
  checkIfValidAddress: _react.PropTypes.func,
  checkIfValidContact: _react.PropTypes.func,
  _updateSubField: _react.PropTypes.func,
  _validateFieldForTextArea: _react.PropTypes.func,
  _updateFieldValue: _react.PropTypes.func,
  checkIfValidBeddingConfig: _react.PropTypes.func,
  _dismissModal: _react.PropTypes.func,
  _locateAddress: _react.PropTypes.func,
  _goBack: _react.PropTypes.func,
  _saveField: _react.PropTypes.func,
  checkIfShouldBeDisabled: _react.PropTypes.func,
  sendEditToReducer: _react.PropTypes.func
};

var EditFieldModal = function (_Component) {
  _inherits(EditFieldModal, _Component);

  function EditFieldModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EditFieldModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditFieldModal.__proto__ || Object.getPrototypeOf(EditFieldModal)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditFieldModal, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var editFieldModal = this.props.editFieldModal;
      var _editFieldModal$setti = editFieldModal.settings,
          type = _editFieldModal$setti.type,
          warningNode = _editFieldModal$setti.warningNode;

      var confirmationButtons = void 0;
      if (type === 'address') {
        confirmationButtons = [_react2.default.createElement(_materialUi.FlatButton, {
          style: { marginRight: '8px' },
          label: 'Cancel',
          type: 'button',
          secondary: true,
          disableTouchRipple: true,
          disableFocusRipple: true,
          onClick: this.props._dismissModal
        }), _react2.default.createElement(_materialUi.FlatButton, {
          style: { marginRight: '8px' },
          label: 'Locate',
          type: 'button',
          disabled: !editFieldModal.isValidAddress,
          primary: editFieldModal.isValidAddress,
          disableTouchRipple: true,
          disableFocusRipple: true,
          onClick: function onClick() {
            return _this2.props._locateAddress(_this2.refs.address);
          }
        })];

        if (editFieldModal.needsToConfirmAddress) {
          confirmationButtons = [_react2.default.createElement(_materialUi.FlatButton, {
            style: { marginRight: '8px' },
            label: 'Back',
            type: 'button',
            secondary: true,
            disableTouchRipple: true,
            disableFocusRipple: true,
            onClick: this.props._goBack
          }), _react2.default.createElement(_materialUi.FlatButton, {
            style: { marginRight: '8px' },
            label: 'Yes',
            type: 'button',
            primary: true,
            disableTouchRipple: true,
            disableFocusRipple: true,
            onClick: function onClick() {
              return _this2.refs.address.saveAddress(_this2.props._saveField, false);
            }
          })];
          if (editFieldModal.hasTriedToLocate && editFieldModal.hasFormattedAddress) {
            confirmationButtons.push(_react2.default.createElement(_materialUi.FlatButton, {
              style: { marginRight: '8px' },
              label: 'Skip',
              type: 'button',
              primary: true,
              disableTouchRipple: true,
              disableFocusRipple: true,
              onClick: function onClick() {
                return _this2.refs.address.saveAddress(_this2.props._saveField, true);
              }
            }));
          }
        }
      } else {
        var disabled = void 0;
        var required = (0, _ramda.pathOr)(false, ['editFieldModal', 'settings', 'isRequired'], this.props);
        if (type === 'contacts') {
          var contact = editFieldModal.value[editFieldModal.settings.index];
          disabled = !contact.type || !contact.firstName || !contact.lastName || !validEmail(contact.email) || !contact.phone;
        } else if (type === 'bedsAndSofas') {
          disabled = editFieldModal.isBeddingConfigInvalid || isNilOrEmpty(editFieldModal.value.rooms);
        } else if (type === 'number') {
          disabled = required && Boolean(this.props._validateFieldForTextArea(editFieldModal.value, 'number'));
        } else if (type === 'multi' || type === 'single') {
          disabled = !Boolean((editFieldModal.value || []).length);
        } else if (type === 'website') {
          disabled = isNilOrEmpty(editFieldModal.value);
        } else {
          disabled = this.props.checkIfShouldBeDisabled();
        }

        confirmationButtons = [_react2.default.createElement(_materialUi.FlatButton, {
          style: { marginRight: '8px' },
          label: 'Cancel',
          type: 'button',
          primary: true,
          disableTouchRipple: true,
          disableFocusRipple: true,
          onClick: this.props._dismissModal
        }), _react2.default.createElement(_materialUi.FlatButton, {
          style: { marginRight: '8px' },
          label: 'Save',
          type: 'button',
          disabled: disabled,
          secondary: true,
          disableTouchRipple: true,
          disableFocusRipple: true,
          onClick: function onClick() {
            var options = {
              updateField: editFieldModal.field,
              updateBody: editFieldModal.value
            };
            return _this2.props._saveField(options);
          }
        })];
      }

      var getBodyStyle = (0, _ramda.cond)([[(0, _ramda.equals)('multi'), (0, _ramda.always)({
        minHeight: '166px'
      }), (0, _ramda.equals)('address'), (0, _ramda.always)({
        overflow: 'none',
        minHeight: type === 'address' && !editFieldModal.needsToConfirmAddress ? '350px' : '96px'
      })], [(0, _ramda.equals)('bedsAndSofas'), (0, _ramda.always)({ padding: '0', minHeight: '256px' })], [(0, _ramda.anyPass)([(0, _ramda.equals)('tourDuration'), (0, _ramda.equals)('roomSizeInfo'), (0, _ramda.equals)('roomCountInfo')]), (0, _ramda.always)({ overflowY: 'none', overflowX: 'none', minHeight: '96px' })], [_ramda.T, (0, _ramda.always)({ minHeight: '96px' })]]);
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          onRequestClose: this.props._dismissModal,
          className: 'form-dialog',
          ref: 'editModal',
          key: 'editModalInEditFieldModal',
          title: editFieldModal.title,
          titleStyle: { borderBottom: 'none' },
          open: editFieldModal.dialogOpen,
          actions: confirmationButtons,
          bodyStyle: getBodyStyle(type),
          actionsContainerStyle: { boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)' },
          autoScrollBodyContent: true,
          modal: true
        },
        warningNode,
        _ramda2.default.call((0, _ramda.cond)([[(0, _ramda.either)((0, _ramda.equals)('multi'), (0, _ramda.equals)('single')), function () {
          return _react2.default.createElement(_reactSelect2.default, {
            instanceId: type + '-indialog',
            multi: type === 'multi',
            placeholder: type === 'multi' ? 'You can select more than one...' : '',
            wrapperStyle: { width: '94%', position: 'absolute' },
            options: editFieldModal.settings.options,
            name: "countriesServed",
            onChange: _this2._onMultiSelectionChange,
            layout: "l-paper-right multi-select",
            value: editFieldModal.value,
            scrollMenuIntoView: false,
            clearable: false
          });
        }], [(0, _ramda.equals)('rating'), function () {
          return _react2.default.createElement(_rating2.default, {
            ref: 'rating',
            rating: editFieldModal.value,
            innerClass: 'inner-description',
            _updateSubField: _this2.props._updateSubField,
            isEditing: true
          });
        }], [(0, _ramda.equals)('address'), function () {
          return _react2.default.createElement(_companyAddressEdit2.default, {
            checkIfValidAddress: _this2.props.checkIfValidAddress,
            addressToConfirm: editFieldModal.addressToConfirm,
            address: editFieldModal.value,
            needsToConfirmAddress: editFieldModal.needsToConfirmAddress,
            ref: 'address'
          });
        }], [(0, _ramda.equals)('contacts'), function () {
          return _react2.default.createElement(_companyContactEdit2.default, {
            contact: editFieldModal.value[editFieldModal.settings.index],
            contacts: editFieldModal.value,
            index: editFieldModal.settings.index,
            ref: 'contacts',
            sendEditToReducer: _this2.props.sendEditToReducer,
            checkIfValidContact: _this2.props.checkIfValidContact
          });
        }], [(0, _ramda.anyPass)([(0, _ramda.equals)('tourDuration'), (0, _ramda.equals)('roomCountInfo'), (0, _ramda.equals)('roomSizeInfo')]), function () {
          return _react2.default.createElement(_inputAndSingleSelectModal2.default, {
            value: editFieldModal.value,
            _updateSubField: _this2.props._updateSubField,
            type: type,
            _validateFieldForTextArea: _this2.props._validateFieldForTextArea
          });
        }], [(0, _ramda.equals)('productInfo'), function () {
          return _react2.default.createElement(_productInfoModal2.default, {
            _updateSubField: _this2.props._updateSubField,
            value: editFieldModal.value
          });
        }], [(0, _ramda.anyPass)([(0, _ramda.equals)('website'), (0, _ramda.equals)('phone'), (0, _ramda.equals)('productCode'), (0, _ramda.equals)('number')]), function () {
          return _react2.default.createElement(_materialUi.TextField, {
            errorText: _this2.props._validateFieldForTextArea(editFieldModal.value, type),
            name: type,
            style: { width: '100%' },
            value: editFieldModal.value,
            onChange: _this2.props._updateFieldValue
          });
        }], [(0, _ramda.equals)('bedsAndSofas'), function () {
          return _react2.default.createElement(_beddingConfig2.default, {
            beddingConfig: editFieldModal.value,
            sendEditToReducer: _this2.props.sendEditToReducer
          });
        }], [(0, _ramda.either)((0, _ramda.equals)('locationName'), (0, _ramda.equals)('productName')), function () {
          return _react2.default.createElement(_materialUi.TextField, {
            value: editFieldModal.value,
            onChange: _this2.props._updateFieldValue,
            style: { width: '100% ' },
            multiLine: true
          });
        }], [_ramda.T, function () {
          return _react2.default.createElement(_materialUi.TextField, {
            name: 'description',
            rows: 6,
            rowsMax: 6,
            value: editFieldModal.value,
            onChange: _this2.props._updateFieldValue,
            style: { width: '100% ' },
            multiLine: true
          });
        }]]), type)
      );
    }
  }]);

  return EditFieldModal;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this._onMultiSelectionChange = function () {
    var _props;

    (_props = _this3.props)._toggleOptionValue.apply(_props, arguments);
  };
};

EditFieldModal.propTypes = propTypes;

exports.default = EditFieldModal;

/***/ }),
/* 3106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _selectFields = __webpack_require__(141);

var _address = __webpack_require__(1527);

var _materialUi = __webpack_require__(3);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var languageSettings = _languages2.default['en-US'];

var AddressEdit = function (_Component) {
  _inherits(AddressEdit, _Component);

  function AddressEdit(props) {
    _classCallCheck(this, AddressEdit);

    var _this = _possibleConstructorReturn(this, (AddressEdit.__proto__ || Object.getPrototypeOf(AddressEdit)).call(this));

    _initialiseProps.call(_this);

    var address = props.address;
    _this.state = {
      addressOne: address.addressOne,
      addressTwo: address.addressTwo,
      city: address.city,
      state: address.state,
      postalCode: address.postalCode,
      country: address.country
    };
    return _this;
  }

  _createClass(AddressEdit, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.checkIfValidAddress(this.checkIfValidAddress());
    }
  }, {
    key: 'geoLocateAndConfirmAddress',
    value: function geoLocateAndConfirmAddress(fn) {
      (0, _address.getGeoLocation)(this.state, function (address) {
        fn(Boolean(address && address.formattedAddress), address);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var initialInputValue = this.state.country;
      var content = void 0;
      if (this.props.needsToConfirmAddress) {
        if (this.props.addressToConfirm && this.props.addressToConfirm.formattedAddress) {
          content = _react2.default.createElement(
            'div',
            { style: { whiteSpace: 'pre-wrap' } },
            'Is This Your Correct Address?',
            this._getAddressForDialogConfirmation(),
            'If not please go back and check your inputs or hit skip to save your inputted address and skip geolocation.'
          );
        } else {
          content = _react2.default.createElement(
            'div',
            { style: { whiteSpace: 'pre-wrap' } },
            'We were unable to locate your address. Can you check your address again? If the following address you inputed is correct, then hit yes to skip geolocation:',
            this._getAddressForDialogConfirmation()
          );
        }
      } else {
        content = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_materialUi.TextField, {
            errorText: this.state.addressOneValidated !== undefined && !this.state.addressOneValidated && 'Required',
            ref: 'addressOne',
            value: this.state.addressOne,
            floatingLabelText: languageSettings.onboarding.addressOnePlaceholder,
            style: { width: '100%' },
            onBlur: this._validateField.bind(this, 'addressOne'),
            onChange: this._updateValue.bind(this, 'addressOne', this.props.checkIfValidAddress)
          }),
          _react2.default.createElement('div', { className: 'profile-edit-address-break' }),
          _react2.default.createElement(_materialUi.TextField, {
            ref: 'addressTwo',
            value: this.state.addressTwo,
            floatingLabelText: languageSettings.onboarding.addressTwoPlaceholder,
            style: { width: '100%' },
            onBlur: this._validateField.bind(this, 'addressTwo'),
            onChange: this._updateValue.bind(this, 'addressTwo', null)
          }),
          _react2.default.createElement('div', { className: 'profile-edit-address-break' }),
          _react2.default.createElement(_materialUi.TextField, {
            errorText: this.state.cityValidated !== undefined && !this.state.cityValidated && 'Required',
            ref: 'city',
            value: this.state.city,
            floatingLabelText: languageSettings.onboarding.city,
            style: { width: '100%' },
            onBlur: this._validateField.bind(this, 'city'),
            onChange: this._updateValue.bind(this, 'city', this.props.checkIfValidAddress)
          }),
          _react2.default.createElement('div', { className: 'profile-edit-address-break' }),
          _react2.default.createElement(
            'div',
            { className: 'form-line' },
            _react2.default.createElement(
              'div',
              { className: 'form-line-two' },
              _react2.default.createElement(_materialUi.TextField, {
                errorText: this.state.stateValidated !== undefined && !this.state.stateValidated && 'Required',
                ref: 'state',
                value: this.state.state,
                floatingLabelText: languageSettings.onboarding.statePlaceholder,
                style: { width: '100%' },
                onBlur: this._validateField.bind(this, 'state'),
                onChange: this._updateValue.bind(this, 'state', this.props.checkIfValidAddress)
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-line-two' },
              _react2.default.createElement(_materialUi.TextField, {
                errorText: this.state.postalCodeValidated !== undefined && !this.state.postalCodeValidated && 'Required',
                ref: 'postalCode',
                value: this.state.postalCode,
                floatingLabelText: languageSettings.onboarding.zipPlaceholder,
                style: { width: '100%' },
                onBlur: this._validateField.bind(this, 'postalCode'),
                onChange: this._updateValue.bind(this, 'postalCode', this.props.checkIfValidAddress)
              })
            )
          ),
          _react2.default.createElement(_reactSelect2.default, {
            wrapperStyle: { position: 'absolute', width: '94%' },
            name: 'country',
            onChange: this._updateCountryValue,
            options: _selectFields.countries,
            value: initialInputValue,
            placeholder: 'Search & Pick A Country',
            clearable: false,
            scrollMenuIntoView: false
          })
        );
      }

      return _react2.default.createElement(
        'div',
        { id: 'address' },
        content
      );
    }
  }]);

  return AddressEdit;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this._updateValue = function (field, fn, event) {
    var updater = {};
    updater[field] = event.target.value;
    _this2.setState(updater, function () {
      if (fn) fn(_this2.checkIfValidAddress());
    });
  };

  this._validateField = function (field) {
    var fieldToSet = field + 'Validated';
    var update = {};
    if (_this2.state[field]) {
      if (_this2.state[fieldToSet]) return;
      update[fieldToSet] = true;
    } else {
      if (_this2.state[fieldToSet] || _this2.state[fieldToSet] === undefined) {
        update[fieldToSet] = false;
      }
    }
    _this2.setState(update);
  };

  this.checkIfValidAddress = function () {
    return Boolean(_this2.state.addressOne && _this2.state.city && _this2.state.state && _this2.state.country && _this2.state.postalCode);
  };

  this._updateCountryValue = function (_ref) {
    var country = _ref.value;

    _this2.setState({ country: country }, function () {
      _this2.props.checkIfValidAddress(_this2.checkIfValidAddress());
    });
  };

  this._getAddressForDialogConfirmation = function () {
    var commaIndex = -1;
    var addressOne = '';
    var addressTwo = '';
    var everythingElse = '';
    var addressToConfirm = _this2.props.addressToConfirm;

    if (addressToConfirm && addressToConfirm.formattedAddress) {
      commaIndex = addressToConfirm.formattedAddress.indexOf(',');
      addressOne = commaIndex > -1 ? addressToConfirm.formattedAddress.substr(0, commaIndex) : addressToConfirm.formattedAddress;
      addressTwo = _this2.state.addressTwo;
      if (_this2.state.country === 'United Kingdom' && _this2.state.state !== addressToConfirm.state) {
        everythingElse = commaIndex > -1 ? _this2.state.city + ', ' + addressToConfirm.state + ' ' + _this2.state.postalCode : '';
      } else {
        everythingElse = commaIndex > -1 ? addressToConfirm.formattedAddress.substr(commaIndex + 2) : '';
      }
    } else {
      addressOne = _this2.state.addressOne;
      addressTwo = _this2.state.addressTwo;
      everythingElse = _this2.state.city + ' ' + _this2.state.state + ' ' + _this2.state.country;
    }
    if (addressTwo) return '\n\n' + addressOne + '\n' + addressTwo + '\n' + everythingElse + '\n\n';
    return '\n\n' + addressOne + '\n' + everythingElse + '\n\n';
  };

  this.saveAddress = function (fn, skipGeolocation) {
    var state = _this2.state;
    var address = _this2.props.addressToConfirm;
    var addressToSave = skipGeolocation ? state : _extends(state, address);
    fn({
      updateField: 'address',
      updateBody: {
        addressOne: addressToSave.addressOne,
        addressTwo: addressToSave.addressTwo,
        city: addressToSave.city,
        state: addressToSave.state,
        postalCode: addressToSave.postalCode,
        country: addressToSave.country,
        formattedAddress: addressToSave.formattedAddress,
        coordinates: addressToSave.coordinates
      }
    });
  };
};

AddressEdit.propTypes = {
  address: _react.PropTypes.object,
  checkIfValidAddress: _react.PropTypes.func,
  addressToConfirm: _react.PropTypes.object,
  needsToConfirmAddress: _react.PropTypes.bool
};

exports.default = AddressEdit;

/* jshint ignore:end */

/***/ }),
/* 3107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function validEmail(email) {
  var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
  return String(email).search(filter) !== -1;
}

var setIn = (0, _ramda.curry)(function (index, field, value, collection) {
  return (0, _ramda.set)((0, _ramda.lensPath)([index, field]), value, collection);
});

var ContactEdit = function (_Component) {
  _inherits(ContactEdit, _Component);

  function ContactEdit() {
    _classCallCheck(this, ContactEdit);

    var _this = _possibleConstructorReturn(this, (ContactEdit.__proto__ || Object.getPrototypeOf(ContactEdit)).call(this));

    _this._validateField = function (field) {
      var fieldToSet = field + 'Validated';
      var update = {};
      if (_this.props.contact[field]) {
        if (_this.props.contact[fieldToSet]) return;
        update[fieldToSet] = true;
      } else {
        if (_this.props.contact[fieldToSet] || _this.props.contact[fieldToSet] === undefined) {
          update[fieldToSet] = false;
        }
      }
      _this.setState(update);
    };

    _this._updateValue = function (field, event) {
      var updateObj = setIn(_this.props.index, field, event.target.value, _this.props.contacts);
      var update = Object.keys(updateObj).map(function (k) {
        return updateObj[k];
      }); //setIn converts the array to an object - so update has to convert back
      _this.props.sendEditToReducer({ value: update });
      _this._checkIfValidContact(update);
    };

    _this._checkIfValidContact = function (state) {
      var extendedState = _extends({}, _this.props.contact, state || {});
      var isInvalid = !extendedState.type || !extendedState.firstName || !extendedState.lastName || !validEmail(extendedState.email) || !extendedState.phone;
      _this.props.checkIfValidContact(isInvalid);
    };

    _this.state = {};
    return _this;
  }

  _createClass(ContactEdit, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._checkIfValidContact();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var requiredContactTypes = {
        Administrator: true,
        Billing: true,
        Reservation: true,
        Sales: true
      };
      var typeNode = _react2.default.createElement(_materialUi.TextField, {
        errorText: !this.props.contact.type && 'Required',
        value: this.props.contact.type,
        floatingLabelText: 'Contact Type',
        disabled: requiredContactTypes[this.props.contact.type],
        onChange: function onChange(e) {
          return _this2._updateValue('type', e);
        },
        style: { width: '100%' }
      });
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'profile-edit-contact' },
          typeNode,
          _react2.default.createElement(_materialUi.TextField, {
            errorText: this.state.firstNameValidated !== undefined && !this.props.contact.firstName && 'Required',
            value: this.props.contact.firstName,
            floatingLabelText: 'First Name',
            onBlur: function onBlur() {
              return _this2._validateField('firstName');
            },
            style: { width: '100%' },
            onChange: function onChange(e) {
              return _this2._updateValue('firstName', e);
            }
          }),
          _react2.default.createElement(_materialUi.TextField, {
            errorText: this.state.lastNameValidated !== undefined && !this.props.contact.lastName && 'Required',
            value: this.props.contact.lastName,
            floatingLabelText: 'Last Name',
            onBlur: function onBlur() {
              return _this2._validateField('lastName');
            },
            onChange: function onChange(e) {
              return _this2._updateValue('lastName', e);
            },
            style: { width: '100%' }
          }),
          _react2.default.createElement(_materialUi.TextField, {
            errorText: this.state.emailValidated !== undefined && !validEmail(this.props.contact.email) && 'Required',
            value: this.props.contact.email,
            floatingLabelText: 'Email',
            onBlur: function onBlur() {
              return _this2._validateField('email');
            },
            onChange: function onChange(e) {
              return _this2._updateValue('email', e);
            },
            style: { width: '100%' }
          }),
          _react2.default.createElement(_materialUi.TextField, {
            errorText: this.state.phoneValidated !== undefined && !this.props.contact.phone && 'Required',
            value: this.props.contact.phone,
            floatingLabelText: 'Phone',
            onBlur: function onBlur() {
              return _this2._validateField('phone');
            },
            onChange: function onChange(e) {
              return _this2._updateValue('phone', e);
            },
            style: { width: '100%' }
          }),
          _react2.default.createElement(_materialUi.TextField, {
            value: this.props.contact.fax,
            floatingLabelText: 'Fax - Optional',
            onChange: function onChange(e) {
              return _this2._updateValue('fax', e);
            },
            style: { width: '100%' }
          })
        )
      );
    }
  }]);

  return ContactEdit;
}(_react.Component);

ContactEdit.propTypes = {
  contact: _react.PropTypes.object,
  checkIfValidContact: _react.PropTypes.func,
  sendEditToReducer: _react.PropTypes.func
};

exports.default = ContactEdit;

/***/ }),
/* 3108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _selectFields = __webpack_require__(141);

var _copyPaste = __webpack_require__(3109);

var _copyPaste2 = _interopRequireDefault(_copyPaste);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleRoomConfig = function SingleRoomConfig(_ref) {
  var forSingleRoom = _ref.forSingleRoom,
      roomName = _ref.roomName,
      beddingConfigs = _ref.beddingConfigs,
      removeARoom = _ref.removeARoom,
      updateBeddingConfigs = _ref.updateBeddingConfigs;

  var updateOneBedding = function updateOneBedding(configIndex, beddingIndex, updateQuery) {
    return _ramda2.default.call(_ramda2.default.compose(updateBeddingConfigs, _ramda2.default.update(configIndex, _ramda2.default.__, beddingConfigs), _ramda2.default.update(beddingIndex, _ramda2.default.__, _ramda2.default.prop(configIndex, beddingConfigs)), _ramda2.default.merge(_ramda2.default.__, updateQuery), _ramda2.default.path([configIndex, beddingIndex])), beddingConfigs);
  };
  var addOneBedding = function addOneBedding(configIndex, beddingIndex) {
    return _ramda2.default.call(_ramda2.default.compose(updateBeddingConfigs, _ramda2.default.update(configIndex, _ramda2.default.__, beddingConfigs), _ramda2.default.insert(beddingIndex + 1, { count: 1 }), _ramda2.default.prop(configIndex)), beddingConfigs);
  };
  var removeOneBedding = function removeOneBedding(configIndex, beddingIndex) {
    return _ramda2.default.call(_ramda2.default.compose(updateBeddingConfigs, _ramda2.default.update(configIndex, _ramda2.default.__, beddingConfigs), _ramda2.default.remove(beddingIndex, 1), _ramda2.default.prop(configIndex)), beddingConfigs);
  };
  var addOneBeddingConfig = function addOneBeddingConfig() {
    return updateBeddingConfigs(_ramda2.default.append([{ count: 1 }], beddingConfigs));
  };
  var removeOneBeddingConfig = _ramda2.default.compose(updateBeddingConfigs, _ramda2.default.remove(_ramda2.default.__, 1, beddingConfigs));
  return _react2.default.createElement(
    'div',
    { style: { marginTop: '0px' } },
    _react2.default.createElement(
      'div',
      { style: { height: '32px', backgroundColor: '#fafafa', borderTop: '1px solid #ededed', borderBottom: '1px solid #ededed', lineHeight: '32px', marginBottom: '16px' } },
      _react2.default.createElement(
        'div',
        { style: { marginLeft: '32px', display: 'inline-block' } },
        roomName
      ),
      _react2.default.createElement(
        'div',
        {
          style: {
            display: forSingleRoom ? 'none' : 'inline-block',
            marginRight: '32px',
            lineHeight: '32px',
            verticalAlign: 'middle',
            color: '#ff4081',
            cursor: 'pointer',
            float: 'right'
          },
          onClick: removeARoom
        },
        'DELETE'
      )
    ),
    beddingConfigs.map(function (config, configIndex) {
      return _react2.default.createElement(_twoColumnRow2.default, {
        key: configIndex,
        outerContainerStyle: { display: 'flex', alignItems: 'flex-start', overflow: 'visible' },
        leftColumnStyle: { padding: '0 0 4px 32px', width: '45%' },
        leftColumnContent: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { style: { lineHeight: '45px' } },
            'Bedding Configuration ' + (configIndex + 1)
          ),
          _react2.default.createElement(_copyPaste2.default, {
            outerDivStyle: { display: forSingleRoom ? 'none' : 'flex' },
            pasteButtonOuterStyle: { marginLeft: '8px' },
            type: 'bedding-configuration',
            id: 'bedding-configuration-' + roomName + '-' + configIndex,
            copiedContent: { config: config },
            pasteFunc: function pasteFunc(copiedContent) {
              return updateBeddingConfigs(_ramda2.default.update(configIndex, copiedContent.config, beddingConfigs));
            }
          })
        ),
        rightColumnStyle: { width: '55%' },
        rightColumnContent: config.map(function (bedding, beddingIndex) {
          return _react2.default.createElement(
            'div',
            { key: beddingIndex, style: { display: 'flex', width: '100%', marginBottom: '8px', flexWrap: 'wrap' } },
            _react2.default.createElement(
              _materialUi.SelectField,
              {
                iconStyle: { fill: 'rgba(0, 0, 0, 0.87)' },
                hintText: 'Select Bed Type',
                hintStyle: { fontSize: '12px', color: 'rgba(0, 0, 0, 0.44)' },
                style: { width: '40%' },
                value: bedding.bedType,
                onChange: function onChange(e, _, val) {
                  return updateOneBedding(configIndex, beddingIndex, { bedType: val });
                }
              },
              _selectFields.beddingConfigOptions.map(function (option, optionIndex) {
                return _react2.default.createElement(_materialUi.MenuItem, { key: optionIndex, value: option.value, primaryText: option.label });
              })
            ),
            _react2.default.createElement('input', {
              value: bedding.count,
              onChange: function onChange(_ref2) {
                var value = _ref2.target.value;
                return updateOneBedding(configIndex, beddingIndex, { count: value });
              },
              type: 'number',
              min: 1,
              style: { width: '15%', textAlign: 'right', fontSize: '25px', position: 'relative', top: '6px', height: '32px', marginLeft: '2%' }
            }),
            _react2.default.createElement(_icon2.default, {
              className: 'tc-icon-add',
              style: {
                marginLeft: '16px',
                lineHeight: '24px',
                width: '28px',
                height: '28px',
                verticalAlign: 'middle',
                border: '2px solid green',
                borderRadius: '50%',
                cursor: 'pointer',
                top: '6px'
              },
              onClick: function onClick() {
                return addOneBedding(configIndex, beddingIndex);
              }
            }),
            _react2.default.createElement(_icon2.default, {
              className: 'tc-icon-close',
              style: {
                marginLeft: '16px',
                lineHeight: '24px',
                width: '28px',
                height: '28px',
                verticalAlign: 'middle',
                color: '#ff4081',
                cursor: 'pointer',
                top: '8px'
              },
              onClick: function onClick() {
                return config.length === 1 ? removeOneBeddingConfig(configIndex) : removeOneBedding(configIndex, beddingIndex);
              }
            }),
            bedding.bedType === 'Other' ? _react2.default.createElement(_materialUi.TextField, {
              hintText: 'Please specify',
              value: bedding.other,
              onChange: function onChange(_ref3) {
                var value = _ref3.target.value;
                return updateOneBedding(configIndex, beddingIndex, { other: value });
              }
            }) : _react2.default.createElement('span', null)
          );
        })
      });
    }),
    _react2.default.createElement(
      'div',
      {
        onClick: addOneBeddingConfig,
        className: 'description-segments-add',
        style: { color: '#00bcd4', cursor: 'pointer', margin: '0 0 16px 32px' }
      },
      _react2.default.createElement(_icon2.default, { className: 'tc-icon-add description-segments-add-icon' }),
      _react2.default.createElement(
        'span',
        { className: 'description-segments-add-label', style: { fontSize: '14px' } },
        'Add Another Bedding Configuration for ',
        roomName || 'this room'
      )
    )
  );
};

exports.default = SingleRoomConfig;

/***/ }),
/* 3109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _copyPasteActions = __webpack_require__(3110);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CopyPasteContainer = function CopyPasteContainer(props) {
  var copyPasteReducer = props.copyPasteReducer,
      type = props.type,
      id = props.id,
      copiedContent = props.copiedContent,
      pasteFunc = props.pasteFunc,
      outerDivStyle = props.outerDivStyle,
      copyButtonOuterStyle = props.copyButtonOuterStyle,
      copyButtonStyle = props.copyButtonStyle,
      pasteButtonOuterStyle = props.pasteButtonOuterStyle,
      pasteButtonStyle = props.pasteButtonStyle,
      copyLabelStyle = props.copyLabelStyle,
      pasteLabelStyle = props.pasteLabelStyle,
      dispatchGenericCopyItem = props.dispatchGenericCopyItem;


  var isItemCopied = (0, _ramda.equals)((0, _ramda.path)([type, 'id'], copyPasteReducer), id);

  return _react2.default.createElement(
    'div',
    { style: outerDivStyle },
    _react2.default.createElement(
      'div',
      { style: copyButtonOuterStyle },
      _react2.default.createElement(_materialUi.RaisedButton, {
        label: isItemCopied ? 'Copied' : 'Copy',
        labelStyle: copyLabelStyle,
        backgroundColor: isItemCopied ? '#d8d8d8' : '',
        style: copyButtonStyle,
        onTouchTap: function onTouchTap() {
          return dispatchGenericCopyItem(_defineProperty({}, type, (0, _ramda.merge)(copiedContent, { id: id })));
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { style: pasteButtonOuterStyle },
      _react2.default.createElement(_materialUi.RaisedButton, {
        label: 'Paste',
        secondary: true,
        labelStyle: pasteLabelStyle,
        style: pasteButtonStyle,
        onTouchTap: function onTouchTap() {
          return pasteFunc((0, _ramda.omit)(['id'], copyPasteReducer[type]));
        },
        disabled: !Boolean(copyPasteReducer[type]) || isItemCopied
      })
    )
  );
};

CopyPasteContainer.propTypes = {
  outerDivStyle: _react.PropTypes.object,
  copyButtonOuterStyle: _react.PropTypes.object,
  pasteButtonOuterStyle: _react.PropTypes.object,
  type: _react.PropTypes.string,
  pasteFunc: _react.PropTypes.func,
  copyPasteReducer: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  copiedContent: _react.PropTypes.any,
  id: _react.PropTypes.string,
  copyButtonStyle: _react.PropTypes.object,
  pasteButtonStyle: _react.PropTypes.object,
  copyLabelStyle: _react.PropTypes.object,
  pasteLabelStyle: _react.PropTypes.object,
  dispatchGenericCopyItem: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var copyPaste = _ref.copyPaste;
  return {
    copyPasteReducer: copyPaste.toJS()
  };
};

var mapDispatchToFunc = function mapDispatchToFunc(dispatch) {
  return {
    dispatchGenericCopyItem: function dispatchGenericCopyItem() {
      return dispatch(_copyPasteActions.genericCopyItem.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToFunc)(CopyPasteContainer);

/***/ }),
/* 3110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genericCopyItem = genericCopyItem;

var _copyPasteConstants = __webpack_require__(3111);

var constants = _interopRequireWildcard(_copyPasteConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function genericCopyItem(payload) {
  return { type: constants.COPY_ITEM, payload: payload };
}

/***/ }),
/* 3111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var COPY_ITEM = exports.COPY_ITEM = 'COPY_GENERIC_ITEM';

/***/ }),
/* 3112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _selectFields = __webpack_require__(141);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputAndSingleSelectModal = function (_Component) {
  _inherits(InputAndSingleSelectModal, _Component);

  function InputAndSingleSelectModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputAndSingleSelectModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputAndSingleSelectModal.__proto__ || Object.getPrototypeOf(InputAndSingleSelectModal)).call.apply(_ref, [this].concat(args))), _this), _this._updateSingleSelect = function (subField, type, _ref2) {
      var value = _ref2.value;

      var valueForUpdate = (0, _ramda.cond)([[(0, _ramda.either)((0, _ramda.equals)('roomCountInfo'), (0, _ramda.equals)('roomSizeInfo')), (0, _ramda.always)(value.toLowerCase())], [_ramda.T, (0, _ramda.always)(value)]]);
      _this.props._updateSubField(subField, valueForUpdate(type));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InputAndSingleSelectModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          type = _props.type,
          _updateSubField = _props._updateSubField,
          _validateFieldForTextArea = _props._validateFieldForTextArea;

      var fieldValue = value.value;
      var getSingleSelectValues = (0, _ramda.cond)([[(0, _ramda.equals)('tourDuration'), (0, _ramda.always)(_selectFields.tourDurationOptions)], [(0, _ramda.equals)('roomCountInfo'), (0, _ramda.always)(_selectFields.roomCountOptions)], [(0, _ramda.equals)('roomSizeInfo'), (0, _ramda.always)(_selectFields.roomSizeOptions)], [_ramda.T, (0, _ramda.always)([])]]);
      var singleSelectValues = getSingleSelectValues(type);
      var cap = function cap(str) {
        return (0, _ramda.concat)((0, _ramda.toUpper)(str.charAt(0)), str.substr(1));
      };
      var capitalize = (0, _ramda.compose)((0, _ramda.join)(' '), (0, _ramda.map)(cap), (0, _ramda.split)(' '));
      var getInitialValue = (0, _ramda.compose)(capitalize, (0, _ramda.or)(value.unit), _ramda.head);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'form-line', style: { display: 'flex' } },
          _react2.default.createElement(
            'div',
            { className: 'form-line-two' },
            _react2.default.createElement(_materialUi.TextField, {
              style: { width: '100%' },
              value: String(fieldValue),
              onChange: function onChange(_ref3) {
                var input = _ref3.target.value;
                return _updateSubField('value', input);
              },
              errorText: _validateFieldForTextArea(String(fieldValue), this.props.type)
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-line-two' },
            _react2.default.createElement(_reactSelect2.default, {
              name: 'companyTypes',
              wrapperStyle: { position: 'absolute', width: '94%' },
              onChange: this._updateSingleSelect.bind(this, 'unit', this.props.type),
              options: singleSelectValues,
              value: getInitialValue(singleSelectValues),
              clearable: false
            })
          )
        )
      );
    }
  }]);

  return InputAndSingleSelectModal;
}(_react.Component);

InputAndSingleSelectModal.propTypes = {
  _updateSubField: _react.PropTypes.func,
  value: _react.PropTypes.object,
  type: _react.PropTypes.string,
  _validateFieldForTextArea: _react.PropTypes.func
};

exports.default = InputAndSingleSelectModal;

/***/ }),
/* 3113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _textarea = __webpack_require__(1050);

var _textarea2 = _interopRequireDefault(_textarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductInfoModal = function (_Component) {
  _inherits(ProductInfoModal, _Component);

  function ProductInfoModal() {
    _classCallCheck(this, ProductInfoModal);

    return _possibleConstructorReturn(this, (ProductInfoModal.__proto__ || Object.getPrototypeOf(ProductInfoModal)).apply(this, arguments));
  }

  _createClass(ProductInfoModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          _updateSubField = _props._updateSubField;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'form-line' },
          _react2.default.createElement(
            'span',
            null,
            'Standard Inclusions'
          ),
          _react2.default.createElement(_textarea2.default, {
            style: { resize: 'none' },
            maxRows: 2,
            value: value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.include : '',
            valueToCheck: value,
            error: function () {
              if (value) {
                if (value.include) return undefined;
              }
              return 'Required Field';
            }(),
            onChange: function onChange(_ref) {
              var input = _ref.target.value;
              return _updateSubField('include', input);
            },
            required: true
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-line' },
          _react2.default.createElement(
            'span',
            null,
            'Standard Exclusions'
          ),
          _react2.default.createElement(_textarea2.default, {
            style: { resize: 'none' },
            maxRows: 2,
            value: value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.exclude : '',
            valueToCheck: value,
            error: function () {
              if (value) {
                if (value.exclude) return undefined;
              }
              return 'Required Field';
            }(),
            onChange: function onChange(_ref2) {
              var input = _ref2.target.value;
              return _updateSubField('exclude', input);
            },
            required: true
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-line' },
          _react2.default.createElement(
            'span',
            null,
            'What To Bring'
          ),
          _react2.default.createElement(_textarea2.default, {
            style: { resize: 'none' },
            maxRows: 2,
            value: value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.whatToBring : '',
            valueToCheck: value,
            error: function () {
              if (value) {
                if (value.whatToBring) return undefined;
              }
              return 'Required Field';
            }(),
            onChange: function onChange(_ref3) {
              var input = _ref3.target.value;
              return _updateSubField('whatToBring', input);
            },
            required: true
          })
        )
      );
    }
  }]);

  return ProductInfoModal;
}(_react.Component);

ProductInfoModal.propTypes = {
  value: _react.PropTypes.object,
  _updateSubField: _react.PropTypes.func
};

exports.default = ProductInfoModal;

/***/ }),
/* 3114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _companyDescription = __webpack_require__(3115);

var _companyDescription2 = _interopRequireDefault(_companyDescription);

var _companyContact = __webpack_require__(3116);

var _companyContact2 = _interopRequireDefault(_companyContact);

var _companyLocation = __webpack_require__(3118);

var _companyLocation2 = _interopRequireDefault(_companyLocation);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _amenities = __webpack_require__(3126);

var _amenities2 = _interopRequireDefault(_amenities);

var _productInfo = __webpack_require__(3127);

var _productInfo2 = _interopRequireDefault(_productInfo);

var _companyNotes = __webpack_require__(3128);

var _companyNotes2 = _interopRequireDefault(_companyNotes);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _container = __webpack_require__(3129);

var _container2 = _interopRequireDefault(_container);

var _membershipsContainer = __webpack_require__(3156);

var _membershipsContainer2 = _interopRequireDefault(_membershipsContainer);

var _actions = __webpack_require__(1247);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Content = function (_Component) {
  _inherits(Content, _Component);

  function Content(props) {
    _classCallCheck(this, Content);

    var _this = _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).call(this, props));

    _this.getBreadcrumb = function () {
      var _this$props = _this.props,
          profileToShow = _this$props.profileToShow,
          routeName = _this$props.routeName,
          user = _this$props.user,
          isViewingOwnProfile = _this$props.isViewingOwnProfile;

      var isOneLocationSupplier = (0, _ramda.path)(['company', 'oneOrMultiProperties'], user) === 'one-prop';
      var breadcrumbs = function () {
        if (routeName === 'location') {
          return _react2.default.createElement(
            'div',
            null,
            isOneLocationSupplier ? '' : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { onClick: _this.transitionBack.bind(_this, 'profile'), className: 'breadcrumb breadcrumb-link' },
                profileToShow.companyName
              ),
              _react2.default.createElement(_icon2.default, { className: 'tc-icon-chevron-right' }),
              _react2.default.createElement(
                'div',
                { className: 'breadcrumb' },
                profileToShow.locationName
              )
            )
          );
        } else if (routeName === 'product') {
          var location = function () {
            return _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'div',
                { onClick: _this.transitionBack.bind(_this, 'location'), className: 'breadcrumb breadcrumb-link' },
                profileToShow.locationName
              ),
              _react2.default.createElement(_icon2.default, { className: 'tc-icon-chevron-right' })
            );
          }();
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              {
                onClick: isViewingOwnProfile ? _this.transitionBack.bind(_this, 'location') : _this.transitionBack.bind(_this, 'profile'),
                className: 'breadcrumb breadcrumb-link'
              },
              profileToShow.companyName
            ),
            _react2.default.createElement(_icon2.default, { className: 'tc-icon-chevron-right' }),
            isOneLocationSupplier ? '' : location,
            _react2.default.createElement(
              'div',
              { className: 'breadcrumb' },
              profileToShow.productName
            )
          );
        }
      }();

      return _react2.default.createElement(
        'div',
        { className: 'breadcrumb-container' },
        breadcrumbs
      );
    };

    _this.getAmenities = function () {
      var _this$props2 = _this.props,
          routeName = _this$props2.routeName,
          profileToShow = _this$props2.profileToShow,
          isEditable = _this$props2.isEditable,
          user = _this$props2.user;

      var isOneLocationSupplier = (0, _ramda.path)(['company', 'oneOrMultiProperties'], user) === 'one-prop';
      if ((['product', 'location'].indexOf(routeName) > -1 || routeName === 'profile' && isOneLocationSupplier) && isEditable && profileToShow.productType === 'accommodation' || profileToShow.amenities && profileToShow.amenities.length) {
        return _react2.default.createElement(_amenities2.default, _extends({}, _this.props, { amenities: profileToShow.amenities || [] }));
      }
    };

    _this.getContactsNode = function () {
      var _this$props3 = _this.props,
          profileToShow = _this$props3.profileToShow,
          isEditable = _this$props3.isEditable,
          routeName = _this$props3.routeName,
          isViewingOwnProfile = _this$props3.isViewingOwnProfile;

      var contacts = profileToShow.contacts;
      if (contacts && contacts.length || isEditable && routeName !== 'product') {
        return _react2.default.createElement(_companyContact2.default, _extends({
          contacts: contacts,
          isViewingOwnProfile: isViewingOwnProfile,
          className: 'contact-sale'
        }, _this.props));
      }
    };

    _this.getLocationsOrProductsCard = function () {
      var _this$props4 = _this.props,
          routeName = _this$props4.routeName,
          profileToShow = _this$props4.profileToShow,
          isEditable = _this$props4.isEditable,
          user = _this$props4.user;

      var isOneLocationSupplier = (0, _ramda.path)(['company', 'oneOrMultiProperties'], user) === 'one-prop';
      var locationsOrProducts = profileToShow.locations || profileToShow.products;
      if (profileToShow.type !== 'Contractor' && routeName !== 'product' && isEditable === true || locationsOrProducts && locationsOrProducts.length) {
        return _react2.default.createElement(_companyLocation2.default, _extends({}, _this.props, {
          groups: profileToShow.groups,
          locations: profileToShow.locations,
          products: profileToShow.products,
          isOneLocationSupplier: isOneLocationSupplier,
          singleLocId: user.company.singleLocId,
          className: 'location-data'
        }));
      }
    };

    _this.getProductInfo = function () {
      var _this$props5 = _this.props,
          routeName = _this$props5.routeName,
          profileToShow = _this$props5.profileToShow,
          isEditable = _this$props5.isEditable;

      if ((routeName === 'profile-product' || routeName === 'product') && profileToShow.type === 'nonAccommodation') {
        if (_typeof(profileToShow.productInfo) === 'object' && Object.keys(profileToShow.productInfo).length || isEditable) {
          return _react2.default.createElement(_productInfo2.default, _extends({
            className: 'product-info',
            productInfo: profileToShow.productInfo
          }, _this.props));
        }
      }
    };

    _this.getMembershipInfo = function () {
      var _this$props6 = _this.props,
          dispatch = _this$props6.dispatch,
          user = _this$props6.user,
          isEditable = _this$props6.isEditable,
          routeName = _this$props6.routeName;

      if (routeName === 'profile' && isEditable) {
        return _react2.default.createElement(_membershipsContainer2.default, {
          dispatch: dispatch,
          user: user,
          isEditable: isEditable,
          deleteOneOrganization: function deleteOneOrganization(organization) {
            return dispatch((0, _actions.deleteOrganizationInProfile)(organization));
          }
        });
      }
    };

    _this.getMarketingMaterials = function () {
      var _this$props7 = _this.props,
          isEditable = _this$props7.isEditable,
          routeName = _this$props7.routeName,
          user = _this$props7.user,
          params = _this$props7.params,
          MMReducer = _this$props7.MMReducer;

      var isOneLocationSupplier = (0, _ramda.path)(['company', 'oneOrMultiProperties'], user) === 'one-prop';
      var tagIDToFind = (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), function () {
        return (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), (0, _ramda.always)(params.locationId), (0, _ramda.always)(params.productId)), Boolean(params.locationId));
      }, (0, _ramda.always)(undefined)), routeName !== 'profile');
      // find additional tags related to products of the same location
      var additionalTags = (MMReducer.locations || []).filter(function (e) {
        return e.id === tagIDToFind;
      }).reduce(function (prev, current) {
        return [].concat(_toConsumableArray(prev), _toConsumableArray(current.products.map(function (p) {
          return p.id;
        })));
      }, []);
      // filter media using the search tag + additionalTags
      var findPhotosForTag = tagIDToFind ? (MMReducer.media || []).filter(function (obj) {
        if ((0, _ramda.intersection)([tagIDToFind].concat(_toConsumableArray(additionalTags)), obj.tags || []).length > 0) return obj;
      }) : [];
      return _react2.default.createElement(_container2.default, {
        isEditable: isEditable,
        isSupplier: true,
        routeName: routeName,
        isOneLocationSupplier: isOneLocationSupplier,
        findPhotosForTag: findPhotosForTag,
        forLocationOrProductPages: routeName !== 'profile',
        params: params
      });
    };

    _this.transitionBack = function (route) {
      var _this$props8 = _this.props,
          profileToShow = _this$props8.profileToShow,
          history = _this$props8.history,
          isEditable = _this$props8.isEditable,
          location = _this$props8.location;

      var url = function () {
        if (route === 'profile') {
          if (isEditable || _ramda2.default.contains('profile', location.pathname.split('/'))) return '/profile';
          return '/company/' + profileToShow.companyId;
        }
        if (isEditable && route === 'location' || route === 'location' && _ramda2.default.contains('profile', location.pathname.split('/'))) return '/profile/locations/' + profileToShow.locationId;
        if (route === 'location') return '/locations/' + profileToShow.locationId;
      }();
      history.push(url);
      // window.location.reload();
    };

    return _this;
  }

  _createClass(Content, [{
    key: 'render',
    value: function render() {
      var user = this.props.user;

      var isOneLocationSupplier = (0, _ramda.path)(['company', 'oneOrMultiProperties'], user) === 'one-prop';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { id: 'breadcrumb-div' },
          this.getBreadcrumb()
        ),
        _react2.default.createElement(
          'div',
          { id: 'description-div' },
          _react2.default.createElement(_companyDescription2.default, _extends({}, this.props, { className: 'description-data' }))
        ),
        _react2.default.createElement(
          'div',
          { id: 'amenities-div' },
          this.getAmenities()
        ),
        _react2.default.createElement(
          'div',
          { id: 'productinfo-div' },
          this.getProductInfo()
        ),
        _react2.default.createElement(
          'div',
          { id: 'locations-products-div' },
          this.getLocationsOrProductsCard()
        ),
        _react2.default.createElement(
          'div',
          { id: 'memebership-div' },
          this.getMembershipInfo()
        ),
        _react2.default.createElement(
          'div',
          { id: 'mm-div' },
          this.getMarketingMaterials()
        ),
        _react2.default.createElement(
          'div',
          { id: 'contacts-div' },
          this.getContactsNode()
        ),
        isOneLocationSupplier ? _react2.default.createElement(
          'div',
          { id: 'notes-div' },
          _react2.default.createElement(_companyNotes2.default, this.props)
        ) : undefined
      );
    }
  }]);

  return Content;
}(_react.Component);

Content.propTypes = {
  profileToShow: _react.PropTypes.object,
  history: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool,
  routeName: _react.PropTypes.string,
  isViewingOwnProfile: _react.PropTypes.bool,
  user: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  MMReducer: _react.PropTypes.object,
  params: _react.PropTypes.object,
  profileLocation: _react.PropTypes.object,
  location: _react.PropTypes.object
};

exports.default = Content;

/***/ }),
/* 3115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = __webpack_require__(47);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _card = __webpack_require__(873);

var _card2 = _interopRequireDefault(_card);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _addItemCard = __webpack_require__(1253);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var Description = function (_Component) {
  _inherits(Description, _Component);

  function Description(props) {
    _classCallCheck(this, Description);

    var _this = _possibleConstructorReturn(this, (Description.__proto__ || Object.getPrototypeOf(Description)).call(this, props));

    _this.setShowAll = function () {
      var aboutHeight = (0, _reactDom.findDOMNode)(_this.refs.about).offsetHeight;
      if (aboutHeight > 126) {
        return _this.setState({
          showResults: true,
          moreText: true,
          labelState: true
        });
      }
      return _this.setState({
        showResults: false,
        labelState: false
      });
    };

    _this._addClass = function (e) {
      e.preventDefault();
      _this.setState({
        showResults: !_this.state.showResults,
        moreText: !_this.state.moreText
      });
    };

    _this._editDescription = function () {
      _this.props.inlineEditField('description', { isRequired: true, type: 'text' });
    };

    _this.state = {
      showResults: false,
      moreText: false,
      labelState: true
    };
    return _this;
  }

  _createClass(Description, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.refs.about) return;
      this.setShowAll();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          profileToShow = _props.profileToShow,
          field = _props.field,
          editMode = _props.editMode,
          editValue = _props.editValue,
          routeName = _props.routeName;

      var description = profileToShow.description;
      var title = routeName === 'product' ? 'About This Product' : 'Description';

      if (editMode) {
        return _react2.default.createElement(
          'div',
          { className: 'location-data' },
          _react2.default.createElement(
            _card2.default,
            {
              className: 'profile-card',
              title: 'Edit Description',
              subtitle: ''
            },
            _react2.default.createElement(_materialUi.TextField, {
              multiLine: true,
              id: 'descriptionTF',
              placeholder: 'Enter here...',
              style: { width: '100%' },
              onChange: function onChange(_ref) {
                var value = _ref.target.value;
                return _this2.props.sendEditToReducer({
                  value: value
                });
              },
              defaultValue: editValue
            }),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '16px', display: 'flex', justifyContent: 'flex-end' } },
              _react2.default.createElement(_materialUi.FlatButton, {
                style: { marginRight: '8px' },
                label: 'Cancel',
                primary: true,
                onClick: this.props.clearEditState
              }),
              _react2.default.createElement(_materialUi.FlatButton, {
                style: { marginRight: '8px' },
                label: 'Save',
                secondary: true,
                disabled: isNilOrEmpty(editValue),
                onClick: function onClick() {
                  var options = {
                    updateField: field,
                    updateBody: editValue
                  };
                  return _this2.props._saveField(options);
                }
              })
            )
          )
        );
      }
      var classes = (0, _classnames2.default)('l-paper-right-info profile-description-paragraph', this.props.className, {
        'short-info': this.state.showResults
      });

      var label = this.state.moreText ? '+ More' : null;
      var more = this.state.labelState ? label : null;
      var gradient = void 0;
      if (this.state.moreText) gradient = _react2.default.createElement('div', { className: 'cardGradient' });

      var descriptionNode = void 0;
      var addItemNode = void 0;
      var titleBarExtra = void 0;
      if (description) {
        if (this.props.isEditable) {
          titleBarExtra = _react2.default.createElement(
            'div',
            { className: 'profile-edit', onClick: this._editDescription },
            _react2.default.createElement(_icon2.default, { className: 'tc-icon-mode_edit profile-edit-icon' }),
            '\xA0EDIT'
          );
        }
        descriptionNode = _react2.default.createElement(
          _card2.default,
          {
            className: 'profile-card',
            title: title,
            companyData: 'companyData',
            subtitle: '',
            titleBarExtra: titleBarExtra
          },
          _react2.default.createElement(
            'div',
            { className: classes, style: { whiteSpace: 'pre-wrap' }, ref: 'about' },
            description
          ),
          gradient,
          _react2.default.createElement(
            'a',
            { href: '#', className: 'load-more', onClick: this._addClass },
            ' ',
            more,
            ' '
          )
        );
      } else if (this.props.isEditable) {
        addItemNode = _react2.default.createElement(_addItemCard2.default, { onClick: this._editDescription, text: 'Add A Description' });
      }
      return _react2.default.createElement(
        'div',
        { className: this.props.className, id: 'profile-description' },
        descriptionNode,
        addItemNode
      );
    }
  }]);

  return Description;
}(_react.Component);

Description.propTypes = {
  isEditable: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  profileToShow: _react.PropTypes.object,
  routeName: _react.PropTypes.string,
  user: _react.PropTypes.object,
  inlineEditField: _react.PropTypes.func,
  sendEditToReducer: _react.PropTypes.func,
  editValue: _react.PropTypes.any,
  field: _react.PropTypes.string,
  editMode: _react.PropTypes.bool,
  clearEditState: _react.PropTypes.func,
  _saveField: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var editFieldModal = _ref2.editFieldModal;
  return {
    field: editFieldModal.get('field'),
    editMode: editFieldModal.get('field') === 'description',
    editValue: editFieldModal.toJS().value || ''
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Description);

/***/ }),
/* 3116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _immutable = __webpack_require__(26);

var _vertDropdown = __webpack_require__(3117);

var _vertDropdown2 = _interopRequireDefault(_vertDropdown);

var _newCard = __webpack_require__(1483);

var _newCard2 = _interopRequireDefault(_newCard);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _locationActions = __webpack_require__(1054);

var _ramda = __webpack_require__(2);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var languageSettings = _languages2.default['en-US'];

var Contacts = function (_Component) {
  _inherits(Contacts, _Component);

  function Contacts() {
    _classCallCheck(this, Contacts);

    var _this = _possibleConstructorReturn(this, (Contacts.__proto__ || Object.getPrototypeOf(Contacts)).call(this));

    _this._addClass = function (e) {
      e.preventDefault();
      _this.setState({
        showResults: !_this.state.showResults
      });
    };

    _this._dialogDismissed = function () {
      _this.setState({
        errorDeletingContact: undefined
      });
    };

    _this._removeContact = function (index) {
      // dialog, then delete
      var contactType = _this.props.contacts[index].type;
      var contacts = _this.props.contacts.filter(function (contact, contactIndex) {
        if (contactIndex !== index) return true;
        return false;
      });
      var neededTypes = _this._getDefaultContactTypes(contacts, _this.props.routeName === 'profile');
      if (neededTypes.indexOf(contactType) !== -1) {
        _this.setState({
          errorDeletingContact: {
            contactIndex: index,
            contactType: contactType.toLowerCase()
          }
        });
        _this._showDialog('removeContactDialog');
      } else {
        _this.props._saveField({
          updateField: 'contacts',
          updateBody: contacts
        });
      }
    };

    _this._editErrorContact = function (index) {
      _this._editContact(index);
      _this._dismissDialog('removeContactDialog');
    };

    _this._editContact = function (index) {
      _this.props.editField('contacts', { type: 'contacts', index: index });
    };

    _this._dismissDialog = function (dialog) {
      _this._dialogDismissed();
      _this.setState(_defineProperty({}, dialog, false));
    };

    _this._showDialog = function (dialog) {
      _this.setState(_defineProperty({}, dialog, true));
    };

    _this._addContact = function (type) {
      _this.props.editField('contacts', {
        type: 'contacts',
        newContact: true,
        contactType: type,
        initialValue: _this.props.contacts.concat({
          type: type
        }),
        index: _this.props.contacts.length
      });
    };

    _this._getDefaultContactTypes = function (optionalContacts, isOnProfile) {
      var contacts = optionalContacts || _this.props.contacts;
      var defaults = ['Billing', 'Sales', 'Reservation'];
      if (isOnProfile) defaults.push('Administrator');
      defaults = defaults.filter(function (type) {
        // checks if exists
        return contacts && !contacts.some(function (contact) {
          return type === contact.type;
        });
      });
      if (!defaults.length) return [''];
      return defaults;
    };

    _this.sortContactsByName = function (contactOne, contactTwo) {
      if (contactOne.type && contactTwo.type && contactOne.type.toLowerCase() > contactTwo.type.toLowerCase()) return 1;
      if (contactOne.type && contactTwo.type && contactOne.type.toLowerCase() < contactTwo.type.toLowerCase()) return -1;
      if (contactOne.first_name && contactTwo.first_name && contactOne.first_name.toLowerCase() > contactTwo.first_name.toLowerCase()) return 1;
      if (contactOne.first_name && contactTwo.first_name && contactOne.first_name.toLowerCase() < contactTwo.first_name.toLowerCase()) return -1;
      if (contactOne.name && contactTwo.name && contactOne.name.toLowerCase() > contactTwo.name.toLowerCase()) return 1;
      if (contactOne.name && contactTwo.name && contactOne.name.toLowerCase() < contactTwo.name.toLowerCase()) return -1;
      return 0;
    };

    _this._copyContacts = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          params = _this$props.params;
      var id = params.locationId;

      dispatch((0, _locationActions.editLocationField)({
        updateField: 'contacts',
        updateBody: _this.props.user.company.contacts,
        id: id
      }));
      _this._dismissDialog('copyContactsDialog');
    };

    _this.state = {
      showResults: false,
      removeContactDialog: false,
      copyContactsDialog: false
    };
    return _this;
  }

  _createClass(Contacts, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.routeName !== nextProps.routeName) this.setState({ showResults: false });
    }
  }, {
    key: 'getListElementStyle',
    value: function getListElementStyle(width, height, otherCss) {
      return _extends({
        display: 'inline-block',
        fontSize: '14px',
        fontWeight: '400',
        color: 'rgb(54%, 54%, 54%)',
        lineHeight: '21px',
        overflow: 'auto',
        clear: 'both',
        paddingRight: '16px',
        height: height || 'auto',
        verticalAlign: 'top',
        width: width
      }, otherCss || {});
    }
  }, {
    key: 'getHeaderStyle',
    value: function getHeaderStyle(width) {
      return {
        display: 'inline-block',
        fontSize: '14px',
        fontWeight: '600',
        color: 'rgb(54%, 54%, 54%)',
        marginRight: '16px',
        width: width
      };
    }
  }, {
    key: 'createContactList',
    value: function createContactList(contact, index, contacts) {
      var name = function () {
        if (contact.firstName) return contact.firstName + ' ' + contact.lastName;
        if (contact.first_name) return contact.first_name + ' ' + contact.last_name;
        if (contact.name) return contact.name;
      }();
      var lastElement = index === contacts.length - 1;
      var fax = contact.fax ? _react2.default.createElement(
        'div',
        {
          style: {
            maxHeight: '32px',
            display: 'block',
            position: 'relative'
          }
        },
        _react2.default.createElement(_icon2.default, { className: 'tc-icon-print', style: { marginRight: '5px', lineHeight: '21px' } }),
        _react2.default.createElement(
          'span',
          {
            style: {
              lineHeight: '21px',
              position: 'relative',
              display: 'inline-block',
              verticalAlign: 'text-bottom'
            }
          },
          contact.fax
        )
      ) : _react2.default.createElement(
        'div',
        {
          style: {
            maxHeight: '32px',
            display: 'block',
            position: 'relative'
          }
        },
        _react2.default.createElement('span', {
          style: {
            lineHeight: '21px',
            position: 'relative',
            display: 'inline-block',
            verticalAlign: 'text-bottom'
          }
        })
      );

      var options = [{
        text: 'Edit',
        action: this._editContact.bind(this, index)
      }, {
        text: 'Delete',
        action: this._removeContact.bind(this, index)
      }];

      return _react2.default.createElement(
        'div',
        {
          key: index,
          ref: 'contactItem' + index,
          className: 'contact-info',
          style: {
            display: 'inline-block',
            lineHeight: '21px',
            width: '100%',
            minHeight: '80px',
            maxHeight: '68px',
            borderBottom: lastElement ? null : '2px solid #f5f5f5', padding: '16px'
          }
        },
        _react2.default.createElement(
          'div',
          { style: this.getListElementStyle('26%', '64px') },
          contact.type
        ),
        _react2.default.createElement(
          'div',
          { style: this.getListElementStyle('40%') },
          _react2.default.createElement(
            'div',
            null,
            name
          ),
          _react2.default.createElement(
            'div',
            null,
            contact.email
          )
        ),
        _react2.default.createElement(
          'div',
          { style: this.getListElementStyle('30%') },
          _react2.default.createElement(
            'div',
            { style: {
                maxHeight: '32px',
                display: 'block',
                position: 'relative'
              }
            },
            _react2.default.createElement(_icon2.default, { className: 'tc-icon-local-phone', style: {
                marginRight: '8px',
                lineHeight: '21px',
                float: 'left',
                overflow: 'hidden',
                clear: 'both',
                fontSize: '20px'
              }
            }),
            _react2.default.createElement(
              'span',
              { style: {
                  lineHeight: '21px',
                  position: 'relative',
                  display: 'inline-block'
                }
              },
              contact.phone
            )
          ),
          fax
        ),
        this.props.isEditable ? _react2.default.createElement(_vertDropdown2.default, {
          style: this.getListElementStyle('4%', 'auto', { overflow: undefined, verticalAlign: 'middle' }),
          componentClassName: 'profile-contact-more-vert',
          options: options
        }) : null
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isEditable = _props.isEditable,
          routeName = _props.routeName,
          className = _props.className,
          profileToShow = _props.profileToShow,
          isViewingOwnProfile = _props.isViewingOwnProfile;

      var shouldShowContactInfo = (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.path)(['profileToShow', 'connectionInfo']), (0, _ramda.path)(['profileToShow', 'connectionInfo', 'shouldShowContactInfo']), _ramda.T), this.props);
      if (!shouldShowContactInfo && !isViewingOwnProfile || isViewingOwnProfile && profileToShow.viewingAs === 'unconnected') return _react2.default.createElement('div', null);

      var copyFromCompanyProfileNode = _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', marginTop: '12px', marginLeft: '8px', fontSize: '16px', float: 'right' }, className: 'profile-edit-icon-container', onClick: this._showDialog.bind(this, 'copyContactsDialog') },
        _react2.default.createElement(_icon2.default, { className: 'tc-icon-copy profile-edit-icon' }),
        'Copy from Company Profile'
      );
      var contactsList = function () {
        if (_this2.props.contacts && _this2.props.contacts.length) {
          if (_this2.props.contacts.length > 1 || routeName === 'profile') copyFromCompanyProfileNode = null;
          return _this2.props.contacts.sort(_this2.sortContactsByName).map(function (contact, index, contacts) {
            return _this2.createContactList(contact, index, contacts);
          });
        }
        return (0, _immutable.List)();
      }();
      var gradient = void 0;

      var label = contactsList.length > 4 && !this.state.showResults ? languageSettings.company.more : null;
      var more = contactsList.length > 4 && !this.state.showResults ? label : null;

      if (contactsList.length > 4 && !this.state.showResults) gradient = _react2.default.createElement('div', { style: { bottom: '-8px', width: '100%' }, className: 'cardGradient' });

      var contactsListStyle = void 0;
      if (contactsList.length > 4 && !this.state.showResults) contactsListStyle = { maxHeight: '340px' };

      var addContactDiv = void 0;
      if (isEditable) {
        addContactDiv = this._getDefaultContactTypes(null, routeName === 'profile').map(function (contactType, index) {
          return _react2.default.createElement(
            'div',
            { className: 'add-contacts', style: { cursor: 'pointer', lineHeight: '21px', height: '68px', borderBottom: '2px solid #f5f5f5', padding: '0px 16px' }, onClick: _this2._addContact.bind(_this2, contactType), key: index },
            _react2.default.createElement(
              'div',
              { className: 'profile-image-add-container', style: { display: 'inline-block', verticalAlign: 'middle', lineHeight: '68px' } },
              _react2.default.createElement(
                'div',
                { className: 'profile-image profile-image-add' },
                _react2.default.createElement(
                  'div',
                  { className: 'profile-image-letter' },
                  ' ',
                  _react2.default.createElement(_icon2.default, { className: 'tc-icon-add' }),
                  ' '
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', marginLeft: '16px', height: '68px', verticalAlign: 'middle' } },
              _react2.default.createElement(
                'h4',
                { className: 'add-contacts-header', style: { fontWeight: '300', paddingTop: '16px', lineHeight: '38px', verticalAlign: 'middle' } },
                ' Add ',
                contactType,
                ' Contact'
              )
            )
          );
        });
      }

      var overflow = contactsList && contactsList.length > 4 && !this.state.showResults ? 'hidden' : 'visible';
      var dialogActions = void 0;
      var errorDeletingContactType = void 0;
      if (this.state.errorDeletingContact) {
        errorDeletingContactType = this.state.errorDeletingContact.contactType;
        dialogActions = [_react2.default.createElement(_materialUi.FlatButton, {
          label: 'Edit',
          onTouchTap: this._editErrorContact.bind(this, this.state.errorDeletingContact.contactIndex),
          secondary: true,
          disableTouchRipple: true
        }), _react2.default.createElement(_materialUi.FlatButton, {
          label: 'OK',
          onTouchTap: this._dismissDialog.bind(this, 'removeContactDialog'),
          primary: true,
          disableTouchRipple: true
        })];
      }
      var dialogActionsforCopy = [_react2.default.createElement(_materialUi.FlatButton, {
        label: 'Cancel',
        onTouchTap: this._dismissDialog.bind(this, 'copyContactsDialog'),
        secondary: true,
        disableTouchRipple: true
      }), _react2.default.createElement(_materialUi.FlatButton, {
        label: 'OK',
        onTouchTap: this._copyContacts,
        primary: true,
        disableTouchRipple: true
      })];
      return _react2.default.createElement(
        'div',
        { className: className, id: 'contactsNode' },
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            className: 'form-dialog',
            ref: 'removeContact',
            title: 'Contact Cannot Be Removed',
            actions: dialogActions,
            open: this.state.removeContactDialog,
            onRequestClose: this._dismissDialog.bind(this, 'removeContactDialog')
          },
          'You must have at least one ' + errorDeletingContactType + ' contact.'
        ),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            className: 'form-dialog',
            ref: 'copyContacts',
            title: 'Copy Contacts From Company Profile',
            actions: dialogActionsforCopy,
            open: this.state.copyContactsDialog,
            onRequestClose: this._dismissDialog.bind(this, 'copyContactsDialog')
          },
          'All existing contacts here will be overwritten. Are you sure you want to copy over all contacts from your company profile?'
        ),
        _react2.default.createElement(
          _newCard2.default,
          {
            contentStyle: { padding: '0px', overflow: overflow },
            className: 'profile-card'
          },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { style: {
                  height: '48px',
                  fontSize: '20px',
                  fontWeight: '500',
                  color: 'rgba(0, 0, 0, 0.87)' }, className: 'tc-card-header-title tc-new-card-header-title'
              },
              'Contacts'
            ),
            copyFromCompanyProfileNode
          ),
          _react2.default.createElement(
            'div',
            { style: contactsListStyle, ref: 'contactList' },
            addContactDiv,
            contactsList,
            _react2.default.createElement('div', { style: { clear: 'both' } }),
            gradient,
            _react2.default.createElement(
              'a',
              { href: '#', style: {
                  position: 'absolute',
                  bottom: '12px',
                  right: '8px',
                  display: 'inline-block'
                }, className: 'load-more', onClick: this._addClass
              },
              ' ',
              more,
              ' '
            )
          )
        )
      );
    }
  }]);

  return Contacts;
}(_react.Component);

Contacts.propTypes = {
  routeName: _react.PropTypes.string,
  dispatch: _react.PropTypes.func,
  params: _react.PropTypes.object,
  user: _react.PropTypes.object,
  profileToShow: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  contacts: _react.PropTypes.array,
  editField: _react.PropTypes.func,
  _saveField: _react.PropTypes.func,
  isViewingOwnProfile: _react.PropTypes.bool
};

exports.default = Contacts;

/***/ }),
/* 3117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _materialUi = __webpack_require__(3);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropDown = (0, _react.createClass)({

  propTypes: {
    iconClassName: _react.PropTypes.string,
    tooltip: _react.PropTypes.string,
    className: _react.PropTypes.string,
    label: _react.PropTypes.string,
    componentClassName: _react.PropTypes.string,
    options: _react.PropTypes.array,
    style: _react.PropTypes.object
  },

  getInitialState: function getInitialState() {
    return {
      showDropDown: false,
      isOnNestedMultiselect: false,
      menuMap: []
    };
  },
  componentClickAway: function componentClickAway() {
    this.setState({
      showDropDown: false
    });
  },
  _actionButtonClicked: function _actionButtonClicked() {
    this.setState({
      showDropDown: !this.state.showDropDown
    });
  },
  _optionClicked: function _optionClicked(option, index) {
    switch (option.type) {
      case 'nestedmenu':
        // show the other menu
        this.state.menuMap.push(index);
        this.setState({
          menuMap: this.state.menuMap,
          isOnNestedMultiselect: option.isOnNestedMultiselect
        });
        break;
      default:
        if (typeof option.action === 'function') {
          option.action();
        }
        if (!option.leaveMenuOpen) {
          this.setState({
            showDropDown: false
          });
        }
        break;
    }
  },
  _showPrevious: function _showPrevious() {
    this.state.menuMap.pop();
    this.setState({
      menuMap: this.state.menuMap,
      isOnNestedMultiselect: false
    });
  },
  render: function render() {
    var _this = this;

    var iconClassName = this.props.iconClassName || 'tc-icon-more-vert';
    var tooltip = this.props.tooltip === false ? undefined : 'More Actions';

    var menuToDisplay = this.props.options;
    var menuText = void 0;
    var filterIcon = void 0;
    this.state.menuMap.forEach(function (index) {
      menuText = menuToDisplay[index].text;
      menuToDisplay = menuToDisplay[index].subOptions;
    });

    var menu = menuToDisplay.map(function (option, index) {
      return _react2.default.createElement(
        'div',
        { onClick: function onClick() {
            return _this._optionClicked(option, index);
          }, className: 'more-vert-link', key: index },
        ' ',
        option.text,
        ' ',
        option.icon,
        ' '
      );
    });
    var classes = (0, _classnames2.default)('more-vert-drop-down', this.props.className, {
      'is-closed': !this.state.showDropDown,
      'is-vert-multi-select': this.state.isOnNestedMultiselect
    });
    var previousButton = this.state.menuMap.length ? _react2.default.createElement(
      'div',
      { onClick: this._showPrevious, className: 'more-vert-link' },
      ' ',
      _react2.default.createElement(_icon2.default, { className: 'tc-icon-chevron-left' }),
      menuText
    ) : null;

    if (this.props.label) {
      filterIcon = _react2.default.createElement(
        'div',
        { className: 'more-vert-label', onClick: this._actionButtonClicked },
        this.props.label
      );
    } else {
      filterIcon = _react2.default.createElement(_materialUi.IconButton, {
        iconClassName: iconClassName,
        onTouchTap: this._actionButtonClicked,
        tooltip: tooltip
      });
    }

    return _react2.default.createElement(
      'div',
      { className: this.props.componentClassName + ' more-vert', style: this.props.style },
      _react2.default.createElement(
        _materialUi.Paper,
        {
          style: { zIndex: 1 },
          className: classes
        },
        previousButton,
        menu
      ),
      filterIcon
    );
  }
});

exports.default = DropDown;

/***/ }),
/* 3118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _profileActions = __webpack_require__(546);

var _locationActions = __webpack_require__(1054);

var _reorderItems = __webpack_require__(3119);

var _reorderItems2 = _interopRequireDefault(_reorderItems);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _listLink = __webpack_require__(3120);

var _listLink2 = _interopRequireDefault(_listLink);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _importData = __webpack_require__(3121);

var _importData2 = _interopRequireDefault(_importData);

var _locProdSearchBar = __webpack_require__(3124);

var _locProdSearchBar2 = _interopRequireDefault(_locProdSearchBar);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _link = __webpack_require__(1254);

var _link2 = _interopRequireDefault(_link);

var _manageGroup = __webpack_require__(3125);

var _manageGroup2 = _interopRequireDefault(_manageGroup);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var LocationOrProduct = function (_Component) {
  _inherits(LocationOrProduct, _Component);

  function LocationOrProduct(props) {
    _classCallCheck(this, LocationOrProduct);

    var _this = _possibleConstructorReturn(this, (LocationOrProduct.__proto__ || Object.getPrototypeOf(LocationOrProduct)).call(this, props));

    _this.componentWillUnmount = function () {
      var _this$props = _this.props,
          profile = _this$props.profile,
          updateProps = _this$props.updateProps;

      if (profile.searchValue) updateProps({ searchValue: '', filteredResults: [] });
    };

    _this._openAddItemDialog = function () {
      var _this$props2 = _this.props,
          user = _this$props2.user,
          dispatch = _this$props2.dispatch,
          isOneLocationSupplier = _this$props2.isOneLocationSupplier;

      if (_this._showLocations() && !isOneLocationSupplier && !_ramda2.default.contains('createLocation', user.corporateAccess)) {
        dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload: { noAccessDialog: true, requestingAccessToFeature: 'Create Location', requestAccessData: { type: 'corporateAccess' } } });
      } else {
        _this.setState({
          newItemName: ''
        }, function () {
          return _this.showDialog('addItemDialog');
        });
      }
    };

    _this._addItem = function () {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          params = _this$props3.params,
          isOneLocationSupplier = _this$props3.isOneLocationSupplier,
          singleLocId = _this$props3.singleLocId;

      var _ref = function () {
        if (_this._showLocations() && !isOneLocationSupplier) return { action: _profileActions.addLocation };
        if (_this._showProducts()) return { action: _locationActions.addProduct, locationId: params.locationId || singleLocId };
        return {};
      }(),
          action = _ref.action,
          locationId = _ref.locationId;

      dispatch(action(_this.state.newItemName, locationId)).then(function () {
        return _this.dismissDialog('addItemDialog');
      }).catch(function (err) {
        console.log('error', err);
        _this.dismissDialog('addItemDialog');
        _this.props.triggerSnackBarMessage({
          message: 'Adding ' + (_this._showLocations() ? 'Location' : 'Product') + ' Failed'
        });
      });
    };

    _this._changeNewItemName = function (event) {
      _this.setState({
        newItemName: event.target.value
      });
    };

    _this._removeItem = function () {
      var _this$props4 = _this.props,
          dispatch = _this$props4.dispatch,
          params = _this$props4.params,
          isOneLocationSupplier = _this$props4.isOneLocationSupplier,
          singleLocId = _this$props4.singleLocId;

      var _ref2 = function () {
        if (_this._showLocations() && !isOneLocationSupplier) return { action: _profileActions.removeLocation };
        if (_this._showProducts()) return { action: _locationActions.removeProduct, locationId: params.locationId || singleLocId };
        return {};
      }(),
          action = _ref2.action,
          locationId = _ref2.locationId;

      _this.dismissDialog('removeItemDialog');
      _this.dismissDialog('confirmRemoveLocationAndProducts');
      dispatch(action(_this.state.removeItem.id, locationId)).catch(function (err) {
        console.log('error in removing location/product', err);
        _this.props.triggerSnackBarMessage({
          message: 'Removing ' + (_this._showLocations() ? 'Location' : 'Product') + ' Failed'
        });
      });
    };

    _this._confirmRemoveItem = function (item) {
      if (item.numOfProducts) {
        _this.setState({
          itemFailedName: item.name,
          removeItem: item
        }, function () {
          return _this.showDialog('confirmRemoveLocationAndProducts');
        });
      } else {
        _this.setState({
          removeItem: item
        }, function () {
          return _this.showDialog('removeItemDialog');
        });
      }
    };

    _this._showProducts = function () {
      var _this$props5 = _this.props,
          routeName = _this$props5.routeName,
          isOneLocationSupplier = _this$props5.isOneLocationSupplier;

      return routeName === 'location' || isOneLocationSupplier;
    };

    _this._showLocations = function () {
      var _this$props6 = _this.props,
          routeName = _this$props6.routeName,
          isOneLocationSupplier = _this$props6.isOneLocationSupplier;

      return routeName === 'profile' && !isOneLocationSupplier;
    };

    _this.dismissDialog = function (modal) {
      _this.setState(_defineProperty({}, modal, false));
    };

    _this.showDialog = function (modal) {
      _this.setState(_defineProperty({}, modal, true));
    };

    _this.getListComponent = function (dataArray, item) {
      return dataArray.map(function (locationOrProduct, index) {
        var borderBottom = index === dataArray && dataArray.length - 1 ? null : '1px solid #efefef';
        return _react2.default.createElement(_listLink2.default, _extends({
          key: locationOrProduct.id,
          item: item,
          borderBottom: borderBottom,
          locationOrProduct: locationOrProduct,
          _confirmRemoveItem: _this._confirmRemoveItem.bind(_this, locationOrProduct)
        }, _this.props));
      });
    };

    _this.state = {
      removeItemDialog: false,
      removeItemFailedDialog: false,
      addItemDialog: false,
      confirmRemoveLocationAndProducts: false
    };
    return _this;
  }

  _createClass(LocationOrProduct, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classes = (0, _classnames2.default)('l-paper-split-location', this.props.className);
      var productType = this.props.user.company.productType; // Accommodation or Non-Accomodation
      var addLabel = void 0;
      var item = void 0;
      var title = void 0;
      var itemUppercase = void 0;
      var descText = void 0;
      var hintText = void 0;
      var locationsOrProducts = void 0;
      var filterdResults = _ramda2.default.pathOr([], ['profile', 'filteredResults'], this.props);
      if (this._showProducts()) {
        locationsOrProducts = !isNilOrEmpty(filterdResults) ? filterdResults : this.props.products;
        itemUppercase = 'Product';

        if (productType === 'Accommodation') {
          descText = 'A product would be one room type.';
          hintText = 'The City View Suite';
        } else {
          descText = 'For day tours, multi-day tours, cruises, transfers, and the likes, a product would be one tour or experience.\n\nFor attractions, museums, amusement parks, and the likes, a product would be one ticket.';
          hintText = 'New York Afternoon Walking Tour / Statue of Liberty General Admission';
        }
      } else if (this._showLocations()) {
        locationsOrProducts = !isNilOrEmpty(filterdResults) ? filterdResults : this.props.locations;
        itemUppercase = 'Location';
        if (productType === 'Accommodation') {
          descText = 'A location would be one property. You should title your location as your property name.';
          hintText = 'The Hilton Times Square';
          addLabel = 'Property';
        } else {
          descText = 'For day tours, multi-day tours, cruises, transfers, and the likes, a location would be one shop or one operating area.\n\nFor attractions, museums, amusement parks, and the likes, a location would be one property.';
          hintText = 'New York City & surrounds / Coney Island';
        }
      } else {
        return _react2.default.createElement('div', null);
      }

      title = itemUppercase + 's';
      item = itemUppercase.toLowerCase();
      var addItemBorder = void 0;
      if (locationsOrProducts && locationsOrProducts.length) addItemBorder = '1px solid #efefef';

      var addItem = this.props.isEditable ? _react2.default.createElement(
        'div',
        {
          className: 'location-name profile-image-add-container',
          onClick: this._openAddItemDialog
        },
        _react2.default.createElement(
          'div',
          { style: {
              height: '80px',
              position: 'relative',
              display: 'block',
              clear: 'both',
              float: 'left',
              padding: '16px'
            }
          },
          _react2.default.createElement(
            'div',
            { className: 'profile-image profile-image-add add-location-add-container' },
            _react2.default.createElement(
              'div',
              { className: 'profile-image-letter add-location-add' },
              ' ',
              _react2.default.createElement(_icon2.default, { className: 'tc-icon-add' }),
              ' '
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: {
              height: '48px',
              borderBottom: addItemBorder
            }, className: 'location-content'
          },
          _react2.default.createElement(
            'h4',
            { className: 'add-location-header', style: {
                height: '48px',
                lineHeight: '38px',
                verticalAlign: 'middle'
              }
            },
            ' Add ',
            addLabel || itemUppercase,
            ' '
          )
        )
      ) : null;

      var removeItemActions = [_react2.default.createElement(_materialUi.FlatButton, { label: 'Cancel', secondary: true, onClick: function onClick() {
          return _this2.dismissDialog('removeItemDialog');
        } }), _react2.default.createElement(_materialUi.FlatButton, { label: 'Confirm', primary: true, onTouchTap: this._removeItem })];
      var allIdsInGroups = _ramda2.default.chain(_ramda2.default.prop('items'), this.props.groups || []);

      return _react2.default.createElement(
        'div',
        { className: this.props.className, id: 'prodAnchor' },
        _react2.default.createElement(
          _materialUi.Paper,
          null,
          _react2.default.createElement(
            'div',
            {
              className: this.props.classes.titleBar + ' flex-tc-sb'
            },
            title,
            this.props.isEditable && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_materialUi.RaisedButton, {
                label: 'Create Group',
                onTouchTap: function onTouchTap() {
                  return _this2.props.updateProps({
                    manageGroupOpen: true,
                    groupToManage: {
                      owner_id: _this2.props.profileToShow.id,
                      type: item === 'location' ? 'locGroup' : 'prodGroup',
                      owner_type: item === 'location' ? 'Supplier' : 'Location'
                    }
                  });
                }
              }),
              _react2.default.createElement(_materialUi.RaisedButton, {
                label: 'Reorder',
                style: { marginLeft: '8px' },
                onTouchTap: function onTouchTap() {
                  return _this2.props.updateProps({
                    reorderItemsOpen: true
                  });
                }
              })
            )
          ),
          this.props.isEditable ? _react2.default.createElement(_locProdSearchBar2.default, { locOrProd: item, allLocOrProd: this._showLocations() ? this.props.locations : this.props.products }) : _react2.default.createElement('span', null),
          _react2.default.createElement(
            'div',
            { style: {
                overflowY: 'scroll',
                maxHeight: '440px',
                overflowX: 'hidden',
                marginTop: '0px'
              }, className: classes, ref: 'locationList'
            },
            addItem,
            Boolean(this.props.groups && this.props.groups.length) && this.props.groups.map(function (group) {
              var forThisGroup = locationsOrProducts.filter(function (obj) {
                return group.items.indexOf(obj.id) > -1;
              });
              return _react2.default.createElement(
                _materialUi.Card,
                { key: group.tag, expandable: true },
                _react2.default.createElement(
                  _materialUi.CardHeader,
                  {
                    showExpandableButton: true,
                    actAsExpander: true,
                    style: { padding: '6px' },
                    textStyle: { display: 'none' }
                  },
                  _react2.default.createElement(
                    'div',
                    { className: _this2.props.classes.container },
                    _react2.default.createElement(
                      'div',
                      { className: _this2.props.classes.texts },
                      _react2.default.createElement(
                        'div',
                        { className: _this2.props.classes.groupName },
                        _react2.default.createElement(_link2.default, { color: 'rgba(0, 0, 0, 0.65)', style: { marginRight: '4px' } }),
                        group.tag
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: _this2.props.classes.subTitle },
                        forThisGroup.length + ' ' + (0, _pluralize2.default)(item, forThisGroup.length)
                      )
                    ),
                    Boolean(_this2.props.isEditable) && _react2.default.createElement(_materialUi.IconButton, {
                      iconClassName: 'tc-icon-mode_edit',
                      iconStyle: { color: 'rgba(0, 0, 0, 0.54)' },
                      style: { padding: '0', width: '36px', height: '24px' },
                      tooltip: 'Edit Group',
                      tooltipPosition: 'top-right',
                      onTouchTap: function onTouchTap() {
                        return _this2.props.updateProps({
                          manageGroupOpen: true,
                          groupToManage: { groupId: group._id, groupName: group.tag, items: forThisGroup }
                        });
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  _materialUi.CardText,
                  { expandable: true },
                  _this2.getListComponent(forThisGroup, item)
                )
              );
            }),
            Boolean(locationsOrProducts) && this.getListComponent(locationsOrProducts.filter(function (obj) {
              return allIdsInGroups.indexOf(obj.id) === -1;
            }), item)
          )
        ),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            className: 'form-dialog',
            ref: 'removeItemDialog',
            title: 'Are you sure you want to remove this ' + item + '?',
            actions: removeItemActions,
            open: this.state.removeItemDialog
          },
          'Are you sure you want to remove this ' + item + '?'
        ),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            className: 'form-dialog',
            ref: 'removeItemFailedDialog',
            title: 'Deleting the ' + itemUppercase + ' "' + this.state.itemFailedName + '" Failed',
            actions: [_react2.default.createElement(_materialUi.FlatButton, {
              label: 'OK',
              onTouchTap: function onTouchTap() {
                return _this2.dismissDialog('removeItemFailedDialog');
              },
              secondary: true
            })],
            open: this.state.removeItemFailedDialog
          },
          'If you want to remove ' + this.state.itemFailedName + ', first remove its products.'
        ),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            className: 'form-dialog',
            ref: 'confirmRemoveLocationAndProducts',
            title: 'Deleting this ' + itemUppercase + ' Will Delete All Products For "' + this.state.itemFailedName + '"',
            actions: [_react2.default.createElement(_materialUi.FlatButton, { label: 'Cancel', secondary: true, onClick: function onClick() {
                return _this2.dismissDialog('confirmRemoveLocationAndProducts');
              } }), _react2.default.createElement(_materialUi.FlatButton, { label: 'Confirm', primary: true, onTouchTap: this._removeItem })],
            open: this.state.confirmRemoveLocationAndProducts
          },
          'Are you sure you want to delete ' + this.state.itemFailedName + ' and all its products?'
        ),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            className: 'form-dialog',
            title: 'What is the name of your ' + item + '?',
            ref: 'addItemDialog',
            open: this.state.addItemDialog
          },
          _react2.default.createElement(
            'span',
            { style: { whiteSpace: 'pre-wrap', fontSize: '12px' } },
            descText
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(_materialUi.TextField, {
            value: this.state.newItemName,
            floatingLabelText: itemUppercase + ' Name',
            hintText: hintText,
            onChange: this._changeNewItemName,
            style: { width: '100%' }
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'right', clear: 'both' } },
            _react2.default.createElement(_materialUi.FlatButton, {
              style: { marginRight: '8px' },
              label: 'Cancel',
              type: 'button',
              secondary: true,
              disableTouchRipple: true,
              disableFocusRipple: true,
              onClick: function onClick() {
                return _this2.dismissDialog('addItemDialog');
              }
            }),
            _react2.default.createElement(_materialUi.FlatButton, {
              label: 'Add',
              type: 'button',
              disabled: !this.state.newItemName,
              primary: Boolean(this.state.newItemName),
              disableTouchRipple: true,
              disableFocusRipple: true,
              onClick: this._addItem
            })
          )
        ),
        _react2.default.createElement(_importData2.default, {
          locOrProd: item,
          params: this.props.params
        }),
        _react2.default.createElement(_manageGroup2.default, {
          open: Boolean(this.props.profile.manageGroupOpen),
          savingGroup: Boolean(this.props.profile.savingGroup),
          onRequestClose: function onRequestClose() {
            return _this2.props.updateProps({ manageGroupOpen: false, groupToManage: {} });
          },
          dataArray: item === 'location' ? this.props.locations : this.props.products,
          groupToManage: this.props.profile.groupToManage,
          deleteGroup: this.props.deleteGroup,
          type: item
        }),
        _react2.default.createElement(_reorderItems2.default, {
          open: Boolean(this.props.profile.reorderItemsOpen),
          savingChanges: Boolean(this.props.profile.savingReorderChanges),
          onRequestClose: function onRequestClose() {
            return _this2.props.updateProps({ reorderItemsOpen: false });
          },
          items: item === 'location' ? this.props.locations : this.props.products,
          updateOrder: item === 'location' ? this.props.reorderLocations : this.props.reorderProducts
        })
      );
    }
  }]);

  return LocationOrProduct;
}(_react.Component);

LocationOrProduct.propTypes = {
  dispatch: _react.PropTypes.func,
  params: _react.PropTypes.object,
  className: _react.PropTypes.string,
  triggerSnackBarMessage: _react.PropTypes.func,
  routeName: _react.PropTypes.string,
  isEditable: _react.PropTypes.bool,
  user: _react.PropTypes.object,
  products: _react.PropTypes.array,
  locations: _react.PropTypes.array,
  isOneLocationSupplier: _react.PropTypes.bool,
  singleLocId: _react.PropTypes.string,
  profile: _react.PropTypes.object,
  groups: _react.PropTypes.array,
  classes: _react.PropTypes.object,
  updateProps: _react.PropTypes.func,
  deleteGroup: _react.PropTypes.func,
  reorderLocations: _react.PropTypes.func,
  reorderProducts: _react.PropTypes.func
};

var styles = {
  titleBar: {
    fontSize: '20px',
    backgroundColor: '#f5f5f5',
    height: '48px',
    padding: '0 16px'
  },
  container: { height: '56px', display: 'flex', paddingLeft: '16px', alignItems: 'center', width: '93%', justifyContent: 'space-between' },
  texts: { width: '75%', color: 'rgba(0, 0, 0, 0.77)', cursor: 'pointer' },
  groupName: { fontSize: '14px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', width: '90%', display: 'flex', alignItems: 'center' },
  subTitle: { fontSize: '13px', marginLeft: '28px', color: '#00bcd4' }
};

exports.default = (0, _reactRedux.connect)(null, {
  updateProps: _profileActions.updateSuppProfileProps,
  deleteGroup: _profileActions.deleteGroup,
  reorderLocations: _profileActions.reorderLocations,
  reorderProducts: _profileActions.reorderProducts
})((0, _reactJss2.default)(styles)(LocationOrProduct));

/* jshint ignore:end */

/***/ }),
/* 3119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _draggableCard = __webpack_require__(1134);

var _draggableCard2 = _interopRequireDefault(_draggableCard);

var _sortableList = __webpack_require__(1130);

var _sortableList2 = _interopRequireDefault(_sortableList);

var _materialUi = __webpack_require__(3);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  draggableCard: { margin: '0px 0px 8px 32px', width: '90%' },
  sortableItem: { border: '1px dashed rgba(0, 0, 0, 0.54)', padding: '12px 6px' },
  selectFieldStyle: { width: '80%', marginLeft: '32px' },
  text: { display: 'inline-block', width: '80%', marginLeft: '6px', position: 'relative', top: '-2px', cursor: 'pointer' }
};

var ReorderItems = function (_React$Component) {
  _inherits(ReorderItems, _React$Component);

  function ReorderItems(props) {
    _classCallCheck(this, ReorderItems);

    var _this = _possibleConstructorReturn(this, (ReorderItems.__proto__ || Object.getPrototypeOf(ReorderItems)).call(this, props));

    _this._onDragEnds = function (vals) {
      _this.setState({ items: vals });
    };

    _this._updateOrder = function () {
      _this.props.updateOrder(_this.state.items);
    };

    _this.state = {
      items: props.items || []
    };
    return _this;
  }

  _createClass(ReorderItems, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!_ramda2.default.equals(this.props.items, nextProps.items)) {
        this.setState({ items: nextProps.items });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onRequestClose = _props.onRequestClose,
          _props$classes = _props.classes,
          classes = _props$classes === undefined ? {} : _props$classes,
          open = _props.open,
          savingChanges = _props.savingChanges;
      var _state$items = this.state.items,
          items = _state$items === undefined ? [] : _state$items;

      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          open: open,
          autoScrollBodyContent: true,
          title: 'Reorder List',
          contentStyle: { display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: '32px' },
          actions: [_react2.default.createElement(_materialUi.FlatButton, {
            label: 'cancel',
            onTouchTap: onRequestClose,
            primary: true
          }), _react2.default.createElement(_materialUi.FlatButton, {
            label: savingChanges ? 'saving' : 'confirm',
            disabled: savingChanges || !items.length,
            onTouchTap: this._updateOrder,
            secondary: true
          })]
        },
        _react2.default.createElement(
          'p',
          null,
          ' Drag and drop to reorder.'
        ),
        _react2.default.createElement(
          _sortableList2.default,
          {
            style: { width: '85%' },
            arrayOfData: this.state.items,
            dragEnds: this._onDragEnds
          },
          this.state.items.map(function (item, i) {
            return _react2.default.createElement(
              _draggableCard2.default,
              { key: item.id, className: classes.draggableCard, isDragSource: true, isDropTarget: true },
              _react2.default.createElement(
                'div',
                { className: classes.sortableItem },
                _react2.default.createElement(
                  'div',
                  { className: classes.text },
                  item.name
                ),
                _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-swap_vert', style: { color: 'rgba(0, 0, 0, 0.34)', top: '5px' } })
              )
            );
          })
        )
      );
    }
  }]);

  return ReorderItems;
}(_react2.default.Component);

ReorderItems.propTypes = {
  items: _react2.default.PropTypes.array,
  classes: _react2.default.PropTypes.object,
  onRequestClose: _react2.default.PropTypes.func,
  open: _react2.default.PropTypes.bool,
  savingChanges: _react2.default.PropTypes.bool,
  updateOrder: _react2.default.PropTypes.func
};

exports.default = (0, _reactJss2.default)(styles)(ReorderItems);

/***/ }),
/* 3120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactDom = __webpack_require__(47);

var _reactRouter = __webpack_require__(67);

var _importExport = __webpack_require__(1945);

var _importExport2 = _interopRequireDefault(_importExport);

var _profileActions = __webpack_require__(546);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _profileImage = __webpack_require__(548);

var _profileImage2 = _interopRequireDefault(_profileImage);

var _materialUi = __webpack_require__(3);

var _moreVert = __webpack_require__(876);

var _moreVert2 = _interopRequireDefault(_moreVert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var ListLink = function (_Component) {
  _inherits(ListLink, _Component);

  function ListLink(props) {
    _classCallCheck(this, ListLink);

    var _this = _possibleConstructorReturn(this, (ListLink.__proto__ || Object.getPrototypeOf(ListLink)).call(this, props));

    _this.showFullTitleAfterMount = function () {
      var shouldShowFullTitle = Boolean((0, _reactDom.findDOMNode)(_this.refs.listLink) && (0, _reactDom.findDOMNode)(_this.refs.outerContainer) && (0, _reactDom.findDOMNode)(_this.refs.listLink).offsetWidth === (0, _reactDom.findDOMNode)(_this.refs.outerContainer).offsetWidth);
      _this.setState({
        showFullTitle: shouldShowFullTitle
      });
    };

    _this._showTooltip = function () {
      _this.setState({ tooltipShown: true });
    };

    _this._hideTooltip = function () {
      _this.setState({ tooltipShown: false });
    };

    _this._handleMouseLeave = function () {
      _this._hideTooltip();
    };

    _this._handleMouseEnter = function () {
      _this._showTooltip();
    };

    _this.state = {
      tooltipShown: false,
      showFullTitle: false
    };
    return _this;
  }

  _createClass(ListLink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.showFullTitleAfterMount();
      this.setState({
        showFullTitle: Boolean((0, _reactDom.findDOMNode)(this.refs.listLink) && (0, _reactDom.findDOMNode)(this.refs.outerContainer) && (0, _reactDom.findDOMNode)(this.refs.listLink).offsetWidth === (0, _reactDom.findDOMNode)(this.refs.outerContainer).offsetWidth)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          item = _props.item,
          locationOrProduct = _props.locationOrProduct,
          isEditable = _props.isEditable,
          routeName = _props.routeName,
          borderBottom = _props.borderBottom,
          updateProp = _props.updateProp;

      var listNameStyles = {
        maxWidth: locationOrProduct.isMarketingReady && isEditable ? '70%' : '90%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        display: 'inline-block',
        textOverflow: 'ellipsis',
        paddingBottom: '2px'
      };
      var extraStyles = {};
      if (this.state.showFullTitle) {
        extraStyles.clear = 'both';
        extraStyles.overflow = 'hidden';
      }

      if (item === 'location') {
        extraStyles.position = 'relative';
        extraStyles.top = '-5px';
      }

      var isMarketingReady = function isMarketingReady() {
        var isProfilOrLocationRoute = routeName === 'profile' || routeName === 'location';
        if (!isProfilOrLocationRoute) return _react2.default.createElement('div', null);
        if (locationOrProduct.isMarketingReady && isEditable) return _react2.default.createElement(
          'div',
          { style: extraStyles, className: 'location-content-contract-readiness' },
          'Published'
        );
        if (!locationOrProduct.isMarketingReady && isEditable) return _react2.default.createElement(
          'div',
          { style: extraStyles, className: 'location-content-contract-readiness-draft' },
          'Draft'
        );
      };
      var numberOfProducts = void 0;
      if (item === 'location') {
        var label = 'PRODUCT';
        if (locationOrProduct.numOfProducts !== 1) {
          label += 'S';
        }
        var updatedAt = locationOrProduct.products.map(function (p) {
          return p.updatedAt;
        }).reduce(function (result, date) {
          return (0, _moment2.default)(date).isAfter(result) ? date : result;
        }, locationOrProduct.updatedAt);
        numberOfProducts = _react2.default.createElement(
          'div',
          { style: { display: 'flex', flexDirection: 'column', lineHeight: '24px' } },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'baseline' } },
            _react2.default.createElement(
              'span',
              { style: { fontSize: '20px' } },
              locationOrProduct.numOfProducts
            ),
            _react2.default.createElement(
              'span',
              { style: { fontSize: '12px', marginLeft: '4px' } },
              label
            )
          ),
          _react2.default.createElement(
            'small',
            null,
            (0, _moment2.default)(updatedAt).format('l')
          )
        );
      } else {
        numberOfProducts = _react2.default.createElement(
          'small',
          null,
          (0, _moment2.default)(locationOrProduct.updatedAt).format('l')
        );
      }

      var findPhotoForLocOrProd = function findPhotoForLocOrProd(locOrProdId) {
        var allFiles = _this2.props.profile.media || [];
        var findFilesForId = allFiles.filter(function (file) {
          return (0, _ramda.contains)((locOrProdId || '').toString(), file.tags) && (file.mediaType === 'image/jpeg' || file.mediaType === 'image/png');
        });
        if ((0, _ramda.not)(isNilOrEmpty(findFilesForId))) return (0, _ramda.path)([0, 'url'], findFilesForId);
      };
      var linkType = item === 'product' ? 'product' : 'locations';
      return _react2.default.createElement(
        'div',
        { className: 'location-name' },
        _react2.default.createElement(
          'div',
          {
            style: {
              height: '80px',
              position: 'relative',
              display: 'block',
              clear: 'both',
              float: 'left',
              padding: '16px'
            }
          },
          _react2.default.createElement(_profileImage2.default, {
            className: 'profile-image',
            companySlugName: locationOrProduct.name,
            imageUrl: findPhotoForLocOrProd(locationOrProduct.id)
          })
        ),
        _react2.default.createElement(
          'div',
          { style: {
              borderBottom: borderBottom
            }, className: 'location-content flex-tc-sb'
          },
          function () {
            if (item === 'location') {
              var addressInfo = [locationOrProduct.city, locationOrProduct.state, locationOrProduct.country];
              var addressString = addressInfo.reduce(function (string, addressPiece, index) {
                var stringToReturn = string;
                if (addressPiece) {
                  stringToReturn += addressPiece;
                  if (index !== 2) stringToReturn += ', ';
                }
                return stringToReturn;
              }, '');
              return _react2.default.createElement(
                'div',
                {
                  style: {
                    width: '75%',
                    maxHeight: '48px',
                    position: 'relative',
                    display: 'inline-block'
                  }
                },
                _react2.default.createElement(
                  'h5',
                  {
                    onMouseEnter: _this2._handleMouseEnter,
                    onMouseLeave: _this2._handleMouseLeave,
                    ref: 'listLink',
                    className: 'location-content-link',
                    style: listNameStyles
                  },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      to: isEditable || routeName === 'profile' && !_ramda2.default.contains('company', location.pathname.split('/')) ? '/profile/locations/' + locationOrProduct.id : '/locations/' + locationOrProduct.id
                    },
                    locationOrProduct.name
                  )
                ),
                isMarketingReady(),
                Boolean(addressString) && _react2.default.createElement(
                  'div',
                  { className: 'location-list-content' },
                  addressString
                )
              );
            }

            if (item === 'product') {
              var productStyle = {
                verticalAlign: 'middle',
                lineHeight: '48px',
                fontSize: '20px',
                fontWeight: '300',
                maxWidth: locationOrProduct.isMarketingReady && isEditable ? '75%' : '100%',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
              };
              return _react2.default.createElement(
                'div',
                {
                  style: {
                    width: '90%',
                    maxHeight: '48px',
                    display: 'inline-block'
                  }
                },
                _this2.state.showFullTitle ? _react2.default.createElement(
                  'span',
                  null,
                  locationOrProduct.name
                ) : undefined,
                _react2.default.createElement(
                  'h5',
                  { style: productStyle, ref: 'listLink', className: 'location-content-link' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: isEditable || _ramda2.default.contains('profile', location.pathname.split('/')) ? '/profile/product/' + locationOrProduct.id : '/product/' + locationOrProduct.id },
                    locationOrProduct.name
                  )
                ),
                isMarketingReady(),
                _react2.default.createElement('div', { className: 'location-list-content product-paragraph' })
              );
            }
          }(),
          _react2.default.createElement(
            'div',
            { style: {
                width: 'auto',
                display: 'flex',
                alignItems: 'center',
                maxHeight: '48px',
                lineHeight: '48px',
                marginRight: '8px'
              }
            },
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center', verticalAlign: 'middle' } },
              numberOfProducts
            ),
            isEditable ? _react2.default.createElement(
              _reactRouter.Link,
              { to: isEditable ? '/profile/' + linkType + '/' + locationOrProduct.id : '/' + linkType + '/' + locationOrProduct.id },
              _react2.default.createElement(_materialUi.IconButton, {
                iconClassName: 'tc-icon-mode_edit',
                tooltip: 'Edit',
                tooltipPosition: 'top-center',
                tooltipStyles: { top: '30px' },
                iconStyle: { fontSize: '20px', color: 'rgba(0, 0, 0, 0.54)', marginRight: '-5px' },
                hoveredStyle: { color: '#00bcd4' }
              })
            ) : null,
            isEditable ? _react2.default.createElement(
              _materialUi.IconMenu,
              {
                style: { display: 'flex' },
                iconButtonElement: _react2.default.createElement(
                  _materialUi.IconButton,
                  null,
                  _react2.default.createElement(_moreVert2.default, { style: { color: '#616061' } })
                ),
                anchorOrigin: { horizontal: 'right', vertical: 'top' },
                targetOrigin: { horizontal: 'right', vertical: 'top' }
              },
              _react2.default.createElement(_materialUi.MenuItem, {
                leftIcon: _react2.default.createElement(_importExport2.default, { style: { color: 'rgba(0, 0, 0, 0.54)' } }),
                primaryText: 'Import Data',
                key: 'Import Data',
                onTouchTap: function onTouchTap() {
                  updateProp({ itemToImport: {}, importDataOpen: !_this2.props.profile.importDataOpen, idToImportTo: locationOrProduct.id });
                }
              }),
              _react2.default.createElement(_materialUi.MenuItem, {
                leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-delete2', color: 'rgba(0, 0, 0, 0.54)', style: { fontSize: '24px' } }),
                primaryText: 'Delete',
                key: 'Delete',
                onTouchTap: this.props._confirmRemoveItem
              })
            ) : null
          )
        )
      );
    }
  }]);

  return ListLink;
}(_react.Component);

ListLink.propTypes = {
  profile: _react.PropTypes.object,
  item: _react.PropTypes.string,
  locationOrProduct: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool,
  routeName: _react.PropTypes.string,
  updateProp: _react.PropTypes.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_profileActions.updateSuppProfileProps.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ListLink);

/***/ }),
/* 3121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _profileActions = __webpack_require__(546);

var _locationActions = __webpack_require__(1054);

var _importLocData = __webpack_require__(3122);

var _importLocData2 = _interopRequireDefault(_importLocData);

var _importProdData = __webpack_require__(3123);

var _importProdData2 = _interopRequireDefault(_importProdData);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var ImportData = function ImportData(props) {
  var locOrProd = props.locOrProd,
      updateProp = props.updateProp,
      profileReducer = props.profileReducer,
      prodType = props.prodType,
      importLocationData = props.importLocationData,
      importProductData = props.importProductData,
      params = props.params;


  var updateTextForAccom = prodType === 'Accommodation' && locOrProd === 'location' ? 'Property' : locOrProd;

  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      contentStyle: { maxWidth: 'none', width: '75%' },
      open: _ramda2.default.propOr(false, 'importDataOpen', profileReducer),
      title: 'Import Data From Another ' + updateTextForAccom,
      actions: [_react2.default.createElement(_materialUi.FlatButton, {
        label: 'Cancel',
        primary: true,
        onTouchTap: function onTouchTap() {
          return updateProp({ itemToImport: {}, importDataOpen: false });
        }
      }), _react2.default.createElement(_materialUi.FlatButton, {
        label: 'Import',
        secondary: true,
        onTouchTap: function onTouchTap() {
          if (locOrProd === 'product') {
            importProductData({
              prodIdToImportTo: profileReducer.idToImportTo,
              locId: params.locationId,
              dataToImport: _ramda2.default.propOr({}, 'itemToImport', profileReducer),
              prodType: prodType
            });
          } else {
            importLocationData({
              locIdToImportTo: profileReducer.idToImportTo,
              propertyName: _ramda2.default.pluck('name')(_ramda2.default.propOr([], 'locations', profileReducer).filter(function (loc) {
                return loc.id === profileReducer.idToImportTo;
              }))[0],
              dataToImport: _ramda2.default.propOr({}, 'itemToImport', profileReducer)
            });
          }
          updateProp({ itemToImport: {}, importDataOpen: false });
        },
        disabled: isNilOrEmpty(_ramda2.default.propOr({}, 'itemToImport', profileReducer))
      })]
    },
    _react2.default.createElement(
      'div',
      { style: { overflowY: 'scroll', height: '350px' } },
      _react2.default.createElement(
        'div',
        { style: { margin: '10px 0 30px 0' } },
        'Select which ',
        updateTextForAccom,
        ' you want to import data from.',
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'span',
          { style: { color: 'red', fontWeight: 600 } },
          'Warning: This will overwrite any existing data.'
        )
      ),
      locOrProd === 'product' ? _react2.default.createElement(_importProdData2.default, null) : _react2.default.createElement(_importLocData2.default, null)
    )
  );
};

ImportData.propTypes = {
  locOrProd: _react.PropTypes.string,
  updateProp: _react.PropTypes.func,
  profileReducer: _react.PropTypes.object,
  prodType: _react.PropTypes.string,
  importLocationData: _react.PropTypes.func,
  importProductData: _react.PropTypes.func,
  params: _react.PropTypes.object
};

var mapStateToProps = function mapStateToProps(_ref) {
  var profile = _ref.profile,
      user = _ref.user;
  return {
    profileReducer: profile.toJS(),
    prodType: user.getIn(['company', 'productType'])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_profileActions.updateSuppProfileProps.apply(undefined, arguments));
    },
    importLocationData: function importLocationData() {
      return dispatch(_profileActions.importLocData.apply(undefined, arguments));
    },
    importProductData: function importProductData() {
      return dispatch(_locationActions.importProdData.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ImportData);

/***/ }),
/* 3122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _profileActions = __webpack_require__(546);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccomImg = __webpack_require__(1529);


var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var ImportData = function ImportData(props) {
  var updateProp = props.updateProp,
      profileReducer = props.profileReducer,
      productType = props.productType;
  var locToFilter = profileReducer.idToImportTo;

  var locItems = [{ text: 'Cover Image', db: 'coverImageUrl' }, { text: 'Company Types', db: 'company_types' }, { text: 'Address', db: 'address' }, { text: 'Website', db: 'website' }, { text: 'Phone', db: 'phone' }, { text: 'Description', db: 'description' }, { text: 'Market Segments', db: 'segments' }, { text: 'Marketing Materials', db: 'media' }, { text: 'Contacts', db: 'contact_informations' }];

  var locAccom = [{ text: 'Rating and Amenities', db: 'rating_and_amenity' }, { text: 'Number of Rooms', db: 'total_number_of_rooms' }];

  var filterOutLoc = _ramda2.default.propOr([], 'locations', profileReducer).filter(function (loc) {
    return _ramda2.default.propOr('', 'id', loc) !== (locToFilter || '');
  });

  return _react2.default.createElement(
    'div',
    { style: { borderRadius: '3px', border: '1px solid grey' } },
    isNilOrEmpty(filterOutLoc) ? _react2.default.createElement(
      'span',
      { style: { padding: '5px', color: 'red' } },
      'You do not have any ',
      productType === 'Accommodation' ? 'properties' : 'locations',
      ' to import from.'
    ) : filterOutLoc.map(function (loc, i) {
      var checkProdType = productType === 'Accommodation' ? locItems.concat(locAccom) : locItems;
      var itemsToImport = _ramda2.default.pathOr([], ['itemToImport', 'itemsToImport'], profileReducer);
      var checkName = _ramda2.default.equals(loc.id, _ramda2.default.pathOr([], ['itemToImport', 'locId'], profileReducer));
      return _react2.default.createElement(_materialUi.ListItem, {
        key: i,
        leftCheckbox: _react2.default.createElement(_materialUi.Checkbox, {
          onCheck: _ramda2.default.ifElse(function () {
            return checkName;
          }, function () {
            return updateProp({ itemToImport: {} });
          }, function () {
            return updateProp({ itemToImport: { locId: loc.id, itemsToImport: checkProdType } });
          }),
          checked: checkName
        }),
        primaryText: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement('img', { src: AccomImg, height: '16', style: { margin: '0 10px 0 -10px' } }),
          loc.name,
          ' ',
          _ramda2.default.pathOr('', ['itemToImport', 'locId'], profileReducer) === loc.id ? ' - Importing ' + _ramda2.default.pathOr('', ['itemToImport', 'itemsToImport', 'length'], profileReducer) + ' Items' : ''
        ),
        initiallyOpen: false,
        nestedItems: checkProdType.map(function (item, j) {
          var isChecked = _ramda2.default.contains(item.text, itemsToImport.map(function (obj) {
            return obj.text;
          })) && _ramda2.default.pathOr('', ['itemToImport', 'locId'], profileReducer) === loc.id;
          return _react2.default.createElement(_materialUi.ListItem, {
            key: j,
            primaryText: item.text,
            leftCheckbox: _react2.default.createElement(_materialUi.Checkbox, {
              onCheck: _ramda2.default.ifElse(function () {
                return isChecked;
              }, function () {
                return updateProp({ itemToImport: _ramda2.default.merge(_ramda2.default.propOr({}, 'itemToImport', profileReducer), { itemsToImport: _ramda2.default.without([item], itemsToImport) }) });
              }, function () {
                return updateProp({ itemToImport: _ramda2.default.merge(_ramda2.default.propOr({}, 'itemToImport', profileReducer), { itemsToImport: _ramda2.default.append(item, itemsToImport), locId: loc.id }) });
              }),
              checked: isChecked
            })
          });
        })
      });
    })
  );
};

ImportData.propTypes = {
  updateProp: _react.PropTypes.func,
  profileReducer: _react.PropTypes.object,
  productType: _react.PropTypes.string,
  locations: _react.PropTypes.array
};

var mapStateToProps = function mapStateToProps(_ref) {
  var profile = _ref.profile,
      user = _ref.user;
  return {
    profileReducer: profile.toJS(),
    productType: user.getIn(['company', 'productType'])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_profileActions.updateSuppProfileProps.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ImportData);

/***/ }),
/* 3123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _profileActions = __webpack_require__(546);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var ImportData = function ImportData(props) {
  var updateProp = props.updateProp,
      profileReducer = props.profileReducer,
      productType = props.productType;
  var prodToFilter = profileReducer.idToImportTo;

  var prodItems = [{ text: 'Cover Image', db: 'coverImageUrl' }, { text: 'Media', db: 'media' }];

  var accomProd = [{ text: 'Product Code', db: 'code' }, { text: 'Description', db: 'short_desc' }, { text: 'Amenities', db: 'amenities' }, { text: 'Room Size', db: 'avg_room_size;room_size_units' }, { text: 'Interconnection Rooms Availibility', db: 'interconnecting_rooms' }, { text: 'Room Count', db: 'total_room_of_this_type' }, { text: 'Bedding Configuration', db: 'rooms' }];

  var nonaccomProd = [{ text: 'Product Code', db: 'tour_code' }, { text: 'Description', db: 'description' }, { text: 'Tour Duration', db: 'tour_duration_unit;tour_duration' }, { text: 'Standard Inclusions', db: 'standard_inclusion' }, { text: 'Standard Exclusions', db: 'exclusion' }, { text: 'What To Bring', db: 'what_to_bring' }, { text: 'Max Passengers', db: 'total_max_pax' }, { text: 'Min Passengers', db: 'total_min_pax' }];

  var filterOutProd = _ramda2.default.flatten(_ramda2.default.propOr([], 'locations', profileReducer)).reduce(function (acc, loc) {
    if (_ramda2.default.propOr('', 'id', loc).toString() !== (prodToFilter || '').toString()) {
      loc.products.map(function (prod) {
        acc.push({
          locName: loc.name,
          prodName: prod.name,
          prodId: prod.id
        });
      });
      return acc;
    }
  }, []);

  return _react2.default.createElement(
    'div',
    { style: { borderRadius: '3px', border: '1px solid grey' } },
    isNilOrEmpty(filterOutProd) ? _react2.default.createElement(
      'span',
      { style: { padding: '5px', color: 'red' } },
      'You do not have any products to import from.'
    ) : filterOutProd.map(function (prod, i) {
      var checkProdType = productType === 'Accommodation' ? prodItems.concat(accomProd) : prodItems.concat(nonaccomProd);
      return _react2.default.createElement(_materialUi.ListItem, {
        key: i,
        leftCheckbox: _react2.default.createElement(_materialUi.Checkbox, {
          onCheck: _ramda2.default.ifElse(function () {
            return _ramda2.default.equals(prod.prodId, _ramda2.default.pathOr([], ['itemToImport', 'prodId'], profileReducer));
          }, function () {
            return updateProp({ itemToImport: {}, prodId: null });
          }, function () {
            return updateProp({ itemToImport: { prodId: prod.prodId, itemsToImport: checkProdType } });
          }),
          checked: _ramda2.default.pathOr('', ['itemToImport', 'prodId'], profileReducer) === prod.prodId && _ramda2.default.pathOr(0, ['itemToImport', 'itemsToImport', 'length'], profileReducer) === checkProdType.length
        }),
        primaryText: _react2.default.createElement(
          'span',
          null,
          prod.locName,
          ' - ',
          prod.prodName,
          ' ',
          _ramda2.default.pathOr('', ['itemToImport', 'prodId'], profileReducer) === prod.prodId ? ' - Importing ' + _ramda2.default.pathOr('', ['itemToImport', 'itemsToImport', 'length'], profileReducer) + ' Items' : ''
        ),
        initiallyOpen: false,
        nestedItems: checkProdType.map(function (item, j) {
          var itemsToImport = _ramda2.default.pathOr([], ['itemToImport', 'itemsToImport'], profileReducer);
          var isChecked = _ramda2.default.contains(item.text, itemsToImport.map(function (obj) {
            return obj.text;
          }));
          return _react2.default.createElement(_materialUi.ListItem, {
            key: j,
            primaryText: item.text,
            leftCheckbox: _react2.default.createElement(_materialUi.Checkbox, {
              onCheck: function onCheck() {
                var currentObj = _ramda2.default.propOr({}, 'itemToImport', profileReducer);
                var newItems = isChecked ? _ramda2.default.without([item], itemsToImport) : _ramda2.default.append(item, itemsToImport);
                updateProp({ itemToImport: _ramda2.default.merge(currentObj, { itemsToImport: newItems, prodId: prod.prodId }) });
              },
              checked: isChecked && _ramda2.default.pathOr('', ['itemToImport', 'prodId'], profileReducer) === prod.prodId
            })
          });
        })
      });
    })
  );
};

ImportData.propTypes = {
  updateProp: _react.PropTypes.func,
  profileReducer: _react.PropTypes.object,
  productType: _react.PropTypes.string,
  products: _react.PropTypes.array
};

var mapStateToProps = function mapStateToProps(_ref) {
  var profile = _ref.profile,
      user = _ref.user;
  return {
    profileReducer: profile.toJS(),
    productType: user.getIn(['company', 'productType'])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_profileActions.updateSuppProfileProps.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ImportData);

/***/ }),
/* 3124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _profileActions = __webpack_require__(546);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBar = function SearchBar(props) {
  var locOrProd = props.locOrProd,
      profileReducer = props.profileReducer,
      updateProp = props.updateProp,
      allLocOrProd = props.allLocOrProd,
      prodType = props.prodType;


  return _react2.default.createElement(
    'div',
    { style: { margin: '5px' } },
    _react2.default.createElement(_materialUi.TextField, {
      style: { border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', maxHeight: '34px' },
      inputStyle: { fontSize: '14px', whiteSpace: 'pre-wrap', padding: '0px 3px' },
      underlineShow: false,
      value: _ramda2.default.propOr('', 'searchValue', profileReducer),
      onChange: function onChange(_ref) {
        var value = _ref.target.value;
        return updateProp({
          searchValue: value,
          filteredResults: allLocOrProd.filter(function (item) {
            return _ramda2.default.contains(value.toLowerCase(), item.name.toLowerCase());
          })
        });
      },
      hintText: 'Search for a ' + (locOrProd === 'location' && prodType === 'Accommodation' ? 'Property' : locOrProd) + '...',
      hintStyle: { marginLeft: '5px', lineHeight: '34px', top: '-1px' }
    })
  );
};

SearchBar.propTypes = {
  allLocOrProd: _react.PropTypes.array,
  profileReducer: _react.PropTypes.object,
  updateProp: _react.PropTypes.func,
  locOrProd: _react.PropTypes.string,
  prodType: _react.PropTypes.string
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var profile = _ref2.profile,
      user = _ref2.user;
  return {
    profileReducer: profile.toJS(),
    prodType: user.getIn(['company', 'productType'])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_profileActions.updateSuppProfileProps.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchBar);

/***/ }),
/* 3125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _reactRedux = __webpack_require__(6);

var _profileActions = __webpack_require__(546);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  groupToManage: _react2.default.PropTypes.object,
  open: _react2.default.PropTypes.bool,
  type: _react2.default.PropTypes.string,
  dataArray: _react2.default.PropTypes.array,
  classes: _react2.default.PropTypes.object,
  savingGroup: _react2.default.PropTypes.bool,
  deleteGroup: _react2.default.PropTypes.func,
  updateGroup: _react2.default.PropTypes.func,
  onRequestClose: _react2.default.PropTypes.func
};

var ManageGroup = function (_React$Component) {
  _inherits(ManageGroup, _React$Component);

  function ManageGroup(props) {
    _classCallCheck(this, ManageGroup);

    var _this = _possibleConstructorReturn(this, (ManageGroup.__proto__ || Object.getPrototypeOf(ManageGroup)).call(this, props));

    _this.deleteGroup = function () {
      return _this.props.deleteGroup(_this.state);
    };

    _this.updateGroup = function () {
      return _this.props.updateGroup(_this.state);
    };

    _this.state = props.groupToManage || {};
    return _this;
  }

  _createClass(ManageGroup, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.state = _extends({}, this.state, nextProps.groupToManage || {});
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react2.default.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          open = _props.open,
          type = _props.type,
          onRequestClose = _props.onRequestClose,
          _props$dataArray = _props.dataArray,
          dataArray = _props$dataArray === undefined ? [] : _props$dataArray,
          classes = _props.classes,
          savingGroup = _props.savingGroup;
      var _state = this.state,
          _state$items = _state.items,
          items = _state$items === undefined ? [] : _state$items,
          groupName = _state.groupName,
          groupId = _state.groupId;

      var allSelectedIds = _ramda2.default.pluck('id', items);
      var label = type === 'location' ? 'Locations' : 'Products';
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          open: open,
          autoDetectWindowHeight: true,
          autoScrollBodyContent: true,
          onRequestClose: onRequestClose,
          title: _react2.default.createElement(
            'div',
            { className: 'flex-center' },
            !groupId ? 'Create Group' : 'Manage Group',
            _react2.default.createElement(_materialUi.IconButton, {
              iconClassName: 'tc-icon-delete2',
              iconStyle: { color: '#ff4081' },
              style: { padding: '0', width: '36px', height: '24px', marginLeft: '16px' },
              tooltip: 'Delete Group',
              tooltipPosition: 'top-right',
              onTouchTap: this.deleteGroup
            })
          ),
          actions: [_react2.default.createElement(_materialUi.FlatButton, {
            label: 'cancel',
            onTouchTap: onRequestClose,
            primary: true
          }), _react2.default.createElement(_materialUi.FlatButton, {
            label: savingGroup ? 'saving' : 'confirm',
            disabled: savingGroup || !groupName || !items.length,
            onTouchTap: this.updateGroup,
            secondary: true
          })]
        },
        _react2.default.createElement(
          'small',
          { style: { marginTop: '12px', display: 'block' } },
          'Groups are similar to folders and are used to allow you to organize your ',
          label,
          '.'
        ),
        _react2.default.createElement(_materialUi.TextField, {
          floatingLabelText: 'Group Name',
          id: 'groupName',
          value: groupName || '',
          onChange: function onChange(_, val) {
            return _this2.setState({ groupName: val });
          }
        }),
        Boolean(items.length) && _react2.default.createElement(
          'div',
          { style: { marginTop: '16px', fontWeight: 'bold' } },
          items.length,
          ' ',
          (0, _pluralize2.default)(label, items.length),
          ' included in this group:'
        ),
        _react2.default.createElement(
          'div',
          { className: classes.selected },
          items.map(function (obj, index) {
            return _react2.default.createElement(
              'div',
              {
                key: obj.id,
                className: classes.listContainer + ' flex-tc-sb'
              },
              obj.name,
              _react2.default.createElement(_materialUi.RaisedButton, {
                label: 'Remove',
                labelColor: '#ff4081',
                onTouchTap: function onTouchTap() {
                  return _this2.setState({ items: _ramda2.default.remove(index, 1, items) });
                }
              })
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { marginBottom: '16px', fontWeight: 'bold' } },
          items.length ? 'Additional ' + label : label,
          ' you can add to this group:'
        ),
        dataArray.map(function (obj) {
          var selected = allSelectedIds.indexOf(obj.id) > -1;
          if (selected) return;
          return _react2.default.createElement(
            'div',
            {
              key: obj.id,
              className: classes.listContainer + ' flex-tc-sb'
            },
            obj.name,
            _react2.default.createElement(_materialUi.RaisedButton, {
              label: selected ? 'Remove' : 'Add',
              secondary: true,
              disabled: selected,
              onTouchTap: function onTouchTap() {
                return _this2.setState({ items: _ramda2.default.append(obj, items) });
              }
            })
          );
        })
      );
    }
  }]);

  return ManageGroup;
}(_react2.default.Component);

var styles = {
  listContainer: {
    marginBottom: '8px'
  },
  selected: {
    maxHeight: '200px',
    overflowY: 'scroll',
    borderBottom: '1px solid #e0e0e0',
    margin: '16px 0 ',
    padding: '0 1px'
  }
};

ManageGroup.propTypes = propTypes;

var mapStateToProps = null;

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  updateGroup: _profileActions.updateGroup
})((0, _reactJss2.default)(styles)(ManageGroup));

/***/ }),
/* 3126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(47);

var _selectFields = __webpack_require__(141);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

var _card = __webpack_require__(873);

var _card2 = _interopRequireDefault(_card);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _addItemCard = __webpack_require__(1253);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var languageSettings = _languages2.default['en-US'];


var Amenities = (0, _react.createClass)({

  propTypes: {
    routeName: _react.PropTypes.string,
    editField: _react.PropTypes.func,
    className: _react.PropTypes.string,
    amenities: _react.PropTypes.array,
    isEditable: _react.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    return {
      showResults: false,
      moreText: false,
      labelState: true
    };
  },
  componentDidMount: function componentDidMount() {
    if (!this.refs.about) return;
    this.setShowAll();
  },
  setShowAll: function setShowAll() {
    var aboutHeight = (0, _reactDom.findDOMNode)(this.refs.about).offsetHeight;
    if (aboutHeight > 126) {
      return this.setState({
        showResults: true,
        moreText: true,
        labelState: true
      });
    }
    return this.setState({
      showResults: false,
      labelState: false
    });
  },
  addClass: function addClass(e) {
    e.preventDefault();
    this.setState({ showResults: !this.state.showResults,
      moreText: !this.state.moreText });
  },
  _editAmenities: function _editAmenities() {
    var options = _selectFields.amenitiesOptions;
    this.props.inlineEditField('amenities', {
      isRequired: this.props.routeName === 'location' ? true : false,
      type: 'multi',
      options: options
    });
  },
  render: function render() {
    var _this = this;

    var classes = (0, _classnames2.default)('l-paper-right-info', this.props.className, {
      'short-info': this.state.showResults
    });
    var _props = this.props,
        field = _props.field,
        editMode = _props.editMode,
        settings = _props.settings,
        value = _props.value;

    if (editMode) {
      return _react2.default.createElement(
        'div',
        { className: 'location-data' },
        _react2.default.createElement(
          _card2.default,
          {
            className: 'profile-card',
            title: 'Edit Amenities',
            subtitle: ''
          },
          _react2.default.createElement(_reactSelect2.default, {
            multi: true,
            placeholder: 'You can select more than one...',
            options: settings.options,
            name: 'amenities',
            onChange: function onChange(options) {
              return _this.props.sendEditToReducer({
                value: options ? options.map(function (option) {
                  return option.value;
                }) : []
              });
            },
            layout: "l-paper-right multi-select",
            value: value,
            scrollMenuIntoView: false,
            clearable: false
          }),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '16px', display: 'flex', justifyContent: 'flex-end' } },
            _react2.default.createElement(_materialUi.FlatButton, {
              style: { marginRight: '8px' },
              label: 'Cancel',
              type: 'button',
              primary: true,
              disableTouchRipple: true,
              disableFocusRipple: true,
              onClick: this.props.clearEditState
            }),
            _react2.default.createElement(_materialUi.FlatButton, {
              style: { marginRight: '8px' },
              label: 'Save',
              type: 'button',
              secondary: true,
              disableTouchRipple: true,
              disableFocusRipple: true,
              onClick: function onClick() {
                var options = {
                  updateField: field,
                  updateBody: value
                };
                return _this.props._saveField(options);
              }
            })
          )
        )
      );
    }
    var label = this.state.moreText ? languageSettings.company.more : null;
    var more = this.state.labelState ? label : null;
    var gradient = void 0;

    if (this.state.moreText) gradient = _react2.default.createElement('div', { className: 'cardGradient' });

    var amenitiesList = void 0;
    var addAmenitiesText = void 0;
    var titleBarExtra = void 0;
    if (Array.isArray(this.props.amenities) && this.props.amenities.length) {
      amenitiesList = this.props.amenities.map(function (amenity, index) {
        return _react2.default.createElement(
          'div',
          { className: 'amenity', key: index },
          ' ',
          amenity,
          ' '
        );
      });

      if (this.props.isEditable) {
        titleBarExtra = _react2.default.createElement(
          'div',
          { className: 'profile-edit', onClick: this._editAmenities },
          _react2.default.createElement(_icon2.default, { className: 'tc-icon-mode_edit profile-edit-icon' }),
          '\xA0EDIT'
        );
      }
    } else if (this.props.isEditable) {
      gradient = null;
      addAmenitiesText = _react2.default.createElement(_addItemCard2.default, { onClick: this._editAmenities, text: 'Add Amenities' });
    }

    return _react2.default.createElement(
      'div',
      { className: 'location-data', id: 'amenity' },
      addAmenitiesText ? addAmenitiesText : _react2.default.createElement(
        _card2.default,
        {
          className: 'profile-card',
          title: languageSettings.company.amenities.title,
          companyData: 'companyData',
          subtitle: '',
          titleBarExtra: titleBarExtra
        },
        _react2.default.createElement(
          'div',
          { className: classes, ref: 'about' },
          amenitiesList,
          addAmenitiesText
        ),
        gradient,
        _react2.default.createElement(
          'a',
          { href: '#', className: 'load-more', onClick: this.addClass },
          ' ',
          more,
          ' '
        )
      )
    );
  }
});

var mapStateToProps = function mapStateToProps(_ref) {
  var editFieldModal = _ref.editFieldModal;
  return {
    field: editFieldModal.get('field'),
    editMode: editFieldModal.get('field') === 'amenities',
    value: editFieldModal.toJS().value || [],
    settings: editFieldModal.toJS().settings || []
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Amenities);

/***/ }),
/* 3127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(47);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _card = __webpack_require__(873);

var _card2 = _interopRequireDefault(_card);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _addItemCard = __webpack_require__(1253);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductInfo = function (_Component) {
  _inherits(ProductInfo, _Component);

  function ProductInfo(props) {
    _classCallCheck(this, ProductInfo);

    var _this = _possibleConstructorReturn(this, (ProductInfo.__proto__ || Object.getPrototypeOf(ProductInfo)).call(this, props));

    _this.setComponentDisplayStateAfterMount = function (state) {
      _this.setState(state);
    };

    _this._addClass = function (e) {
      e.preventDefault();
      _this.setState({
        showResults: !_this.state.showResults,
        moreText: !_this.state.moreText
      });
    };

    _this._editDescription = function (initialValueSettings) {
      _this.props.editField('productInfo', {
        type: 'productInfo',
        initialValue: initialValueSettings,
        specifiedRoute: 'product',
        isRequired: true
      });
    };

    _this.state = {
      showResults: false,
      moreText: false,
      labelState: true
    };
    return _this;
  }

  _createClass(ProductInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.refs.about) return;
      var aboutHeight = (0, _reactDom.findDOMNode)(this.refs.about).offsetHeight;
      if (aboutHeight > 126) {
        this.setComponentDisplayStateAfterMount({
          showResults: true,
          moreText: true,
          labelState: true
        });
      } else {
        this.setComponentDisplayStateAfterMount({
          showResults: false,
          labelState: false
        });
      }
    }
  }, {
    key: '_descriptionType',
    value: function _descriptionType() {
      var routeName = this.props.routeName;

      var descriptionType = void 0;
      if (routeName === 'profile') descriptionType = 'Company';
      if (routeName === 'location') descriptionType = 'Location';
      if (routeName === 'product') descriptionType = 'Product';

      return descriptionType;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$productInfo = this.props.productInfo,
          include = _props$productInfo.include,
          exclude = _props$productInfo.exclude,
          whatToBring = _props$productInfo.whatToBring;


      var title = 'Product Information';

      var classes = (0, _classnames2.default)('l-paper-right-info profile-description-paragraph', this.props.className, {
        'short-info': this.state.showResult
      });

      var label = this.state.moreText ? '+ More' : null;
      var more = this.state.labelState ? label : null;
      var gradient = void 0;
      if (this.state.moreText) gradient = _react2.default.createElement('div', { className: 'cardGradient' });

      var descriptionNode = void 0;
      var addItemNode = void 0;
      var titleBarExtra = void 0;
      if (include || exclude || whatToBring) {
        if (this.props.isEditable) {
          titleBarExtra = _react2.default.createElement(
            'div',
            { className: 'profile-edit',
              onClick: this._editDescription.bind(this, {
                include: include,
                exclude: exclude,
                whatToBring: whatToBring
              })
            },
            _react2.default.createElement(_icon2.default, { className: 'tc-icon-mode_edit profile-edit-icon' }),
            '\xA0EDIT'
          );
        }
        descriptionNode = _react2.default.createElement(
          _card2.default,
          {
            className: 'profile-card',
            title: title,
            companyData: 'companyData',
            subtitle: '',
            titleBarExtra: titleBarExtra
          },
          _react2.default.createElement(
            'div',
            { className: classes, ref: 'about' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'description-segments' },
                'Inclusions'
              ),
              _react2.default.createElement(
                'div',
                { className: 'l-paper-split-segment' },
                include
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'description-segments' },
                'Exclusions'
              ),
              _react2.default.createElement(
                'div',
                { className: 'l-paper-split-segment' },
                exclude
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'description-segments' },
                'What To Bring'
              ),
              _react2.default.createElement(
                'div',
                { className: 'l-paper-split-segment' },
                whatToBring
              )
            )
          ),
          gradient,
          _react2.default.createElement(
            'a',
            { href: '#', className: 'load-more', onClick: this._addClass },
            ' ',
            more,
            ' '
          )
        );
      } else if (this.props.isEditable) {
        addItemNode = _react2.default.createElement(_addItemCard2.default, {
          onClick: this._editDescription.bind(this, {
            include: include,
            exclude: exclude,
            whatToBring: whatToBring
          }),
          text: 'Add Product Information',
          id: 'product-info'
        });
      }
      return _react2.default.createElement(
        'div',
        { style: { marginTop: '32px' }, className: this.props.className },
        descriptionNode,
        addItemNode
      );
    }
  }]);

  return ProductInfo;
}(_react.Component);

ProductInfo.propTypes = {
  editField: _react.PropTypes.func,
  routeName: _react.PropTypes.string,
  profile: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  productInfo: _react.PropTypes.object
};

exports.default = ProductInfo;

/***/ }),
/* 3128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(47);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(6);

var _card = __webpack_require__(873);

var _card2 = _interopRequireDefault(_card);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _materialUi = __webpack_require__(3);

var _addItemCard = __webpack_require__(1253);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CompanyNotes = function (_Component) {
  _inherits(CompanyNotes, _Component);

  function CompanyNotes(props) {
    _classCallCheck(this, CompanyNotes);

    var _this = _possibleConstructorReturn(this, (CompanyNotes.__proto__ || Object.getPrototypeOf(CompanyNotes)).call(this, props));

    _this.setShowAll = function () {
      var aboutHeight = (0, _reactDom.findDOMNode)(_this.refs.about).offsetHeight;
      if (aboutHeight > 126) {
        return _this.setState({
          showResults: true,
          moreText: true,
          labelState: true
        });
      }
      return _this.setState({
        showResults: false,
        labelState: false
      });
    };

    _this._addClass = function (e) {
      e.preventDefault();
      _this.setState({
        showResults: !_this.state.showResults,
        moreText: !_this.state.moreText
      });
    };

    _this._editNotes = function () {
      _this.props.inlineEditField('notes', { type: 'text' });
    };

    _this.state = {
      showResults: false,
      moreText: false,
      labelState: true
    };
    return _this;
  }

  _createClass(CompanyNotes, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.refs.about) return;
      this.setShowAll();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var profileToShow = this.props.profileToShow;

      var description = profileToShow.notes;

      var title = 'General Notes';
      var classes = (0, _classnames2.default)('l-paper-right-info profile-description-paragraph', this.props.className, {
        'short-info': this.state.showResults
      });

      var label = this.state.moreText ? '+ More' : null;
      var more = this.state.labelState ? label : null;
      var gradient = void 0;
      if (this.state.moreText) gradient = _react2.default.createElement('div', { className: 'cardGradient' });
      var _props = this.props,
          field = _props.field,
          editMode = _props.editMode,
          settings = _props.settings,
          value = _props.value;

      if (editMode) {
        return _react2.default.createElement(
          'div',
          { className: 'location-data' },
          _react2.default.createElement(
            _card2.default,
            {
              className: 'profile-card',
              title: 'Edit General Notes',
              subtitle: ''
            },
            _react2.default.createElement(_materialUi.TextField, {
              multiLine: true,
              id: 'generalNotesTF',
              placeholder: 'Enter here...',
              style: { width: '90%' },
              onChange: function onChange(_ref) {
                var value = _ref.target.value;
                return _this2.props.sendEditToReducer({
                  value: value
                });
              },
              defaultValue: value
            }),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '16px', display: 'flex', justifyContent: 'flex-end' } },
              _react2.default.createElement(_materialUi.FlatButton, {
                style: { marginRight: '8px' },
                label: 'Cancel',
                primary: true,
                onClick: this.props.clearEditState
              }),
              _react2.default.createElement(_materialUi.FlatButton, {
                style: { marginRight: '8px' },
                label: 'Save',
                secondary: true,
                onClick: function onClick() {
                  var options = {
                    updateField: field,
                    updateBody: value
                  };
                  return _this2.props._saveField(options);
                }
              })
            )
          )
        );
      }
      var descriptionNode = void 0;
      var addItemNode = void 0;
      var titleBarExtra = void 0;
      if (description) {
        if (this.props.isEditable) {
          titleBarExtra = _react2.default.createElement(
            'div',
            { className: 'profile-edit', onClick: this._editNotes },
            _react2.default.createElement(_icon2.default, { className: 'tc-icon-mode_edit profile-edit-icon' }),
            '\xA0EDIT'
          );
        }
        descriptionNode = _react2.default.createElement(
          _card2.default,
          {
            className: 'profile-card',
            title: title,
            companyData: 'companyData',
            subtitle: '',
            titleBarExtra: titleBarExtra
          },
          _react2.default.createElement(
            'div',
            { className: classes, ref: 'about' },
            description
          ),
          gradient,
          _react2.default.createElement(
            'a',
            { href: '#', className: 'load-more', onClick: this._addClass },
            ' ',
            more,
            ' '
          )
        );
      } else if (this.props.isEditable) {
        addItemNode = _react2.default.createElement(_addItemCard2.default, { onClick: this._editNotes, text: 'Add General Notes' });
      }
      return _react2.default.createElement(
        'div',
        { style: { marginTop: '32px' }, className: this.props.className },
        descriptionNode,
        addItemNode
      );
    }
  }]);

  return CompanyNotes;
}(_react.Component);

CompanyNotes.propTypes = {
  isEditable: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  inlineEditField: _react.PropTypes.func,
  profileToShow: _react.PropTypes.object
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var editFieldModal = _ref2.editFieldModal;
  return {
    field: editFieldModal.get('field'),
    editMode: editFieldModal.get('field') === 'notes',
    value: editFieldModal.toJS().value || [],
    settings: editFieldModal.toJS().settings || []
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CompanyNotes);

/* jshint ignore:end */

/***/ }),
/* 3129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _actions = __webpack_require__(1115);

var _dropzone = __webpack_require__(1946);

var _dropzone2 = _interopRequireDefault(_dropzone);

var _dragDropContainer = __webpack_require__(3135);

var _dragDropContainer2 = _interopRequireDefault(_dragDropContainer);

var _ramda = __webpack_require__(2);

var _bowser = __webpack_require__(1001);

var _titleContainer = __webpack_require__(3142);

var _titleContainer2 = _interopRequireDefault(_titleContainer);

var _unsupportedBrowser = __webpack_require__(3149);

var _unsupportedBrowser2 = _interopRequireDefault(_unsupportedBrowser);

var _containerSendToPartners = __webpack_require__(3150);

var _containerSendToPartners2 = _interopRequireDefault(_containerSendToPartners);

var _searchBar = __webpack_require__(3153);

var _searchBar2 = _interopRequireDefault(_searchBar);

var _tags = __webpack_require__(3154);

var _tags2 = _interopRequireDefault(_tags);

var _multiDownload = __webpack_require__(3155);

var _insertPhoto = __webpack_require__(1454);

var _insertPhoto2 = _interopRequireDefault(_insertPhoto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarketingMaterials = function (_Component) {
  _inherits(MarketingMaterials, _Component);

  function MarketingMaterials(props) {
    _classCallCheck(this, MarketingMaterials);

    var _this = _possibleConstructorReturn(this, (MarketingMaterials.__proto__ || Object.getPrototypeOf(MarketingMaterials)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      showSafariErrorForMultiFiles: false
    };
    // for viewers
    if (!_this.props.isEditable) {
      _this.state = {
        selectedFiles: [],
        filteredMedia: [],
        filterByMediaType: 'All File Types',
        hovering: false,
        previewDialog: false,
        selectedFileIndex: 0
      };
    }
    return _this;
  }

  _createClass(MarketingMaterials, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.getMMData(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.routeName !== nextProps.routeName || this.props.params.companyId !== nextProps.params.companyId) this.getMMData(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearReducer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          updateMMProp = _props.updateMMProp,
          updateMMPartnerProp = _props.updateMMPartnerProp,
          isEditable = _props.isEditable,
          MMReducer = _props.MMReducer,
          MMPartnerReducer = _props.MMPartnerReducer,
          isSupplier = _props.isSupplier,
          forLocationOrProductPages = _props.forLocationOrProductPages,
          findPhotosForTag = _props.findPhotosForTag,
          isOneLocationSupplier = _props.isOneLocationSupplier,
          profileLocationReducer = _props.profileLocationReducer,
          params = _props.params,
          routeName = _props.routeName;


      var selectedFilesUrls = isEditable ? (0, _ramda.propOr)([], 'selectedFiles', MMReducer).map(function (file) {
        return file.url;
      }) : (0, _ramda.propOr)([], 'selectedFiles', this.state);

      // const convertFileToBlob = (url, callback) => {
      //   const xhr = new XMLHttpRequest();
      //   xhr.onload = () => {
      //     const reader = new FileReader();
      //     reader.onloadend = () => {
      //       callback(reader.result);
      //     };
      //     reader.readAsDataURL(xhr.response);
      //   };
      //   xhr.open('GET', url);
      //   xhr.responseType = 'blob';
      //   xhr.send();
      // };

      var generateATag = function generateATag(browserName, url, fileName, fileType, base64String) {
        var link = document.createElement('a');
        link.setAttribute('download', fileName);
        link.style.display = 'none';
        document.body.appendChild(link);
        link.setAttribute('href', (0, _ramda.equals)(browserName, 'Firefox') ? base64String : '/proxy/s3/file?key=' + encodeURIComponent(url));
        // powerpoints will download correctly
        if (((0, _ramda.equals)(browserName, 'Safari') || (0, _ramda.equals)(browserName, 'Internet Explorer')) && !(0, _ramda.equals)(fileType, 'application/vnd.ms-powerpoint') && !(0, _ramda.equals)(fileType, 'application/vnd.openxmlformats-officedocument.presentationml.presentation')) link.setAttribute('target', '_blank');
        link.click();
        document.body.removeChild(link);
      };

      var downloadSingleFile = function downloadSingleFile(files) {
        if ((0, _ramda.equals)(_bowser.browser.name, 'Safari') || (0, _ramda.equals)(_bowser.browser.name, 'Internet Explorer') || (0, _ramda.equals)(_bowser.browser.name, 'Firefox')) {
          if ((0, _ramda.equals)((0, _ramda.prop)('length', files), 1)) return generateATag('Safari', (0, _ramda.path)([0, 'url'], files), (0, _ramda.path)([0, 'fileName'], files), (0, _ramda.path)([0, 'fileType'], files));
          if ((0, _ramda.prop)('length', files) > 1) _this2.setState({ showSafariErrorForMultiFiles: true });
        } else {
          if ((0, _ramda.equals)((0, _ramda.prop)('length', files), 1)) return generateATag(undefined, (0, _ramda.path)([0, 'url'], files), (0, _ramda.path)([0, 'fileName'], files));
          return (0, _multiDownload.multiDownload)(files);
        }
      };

      var sharedProps = {
        updateMMProp: updateMMProp,
        isSupplier: isSupplier
      };

      var propsForTitleAndDragDrop = (0, _ramda.merge)(sharedProps, {
        downloadSingleFile: downloadSingleFile,
        updateMM: this.updateMM,
        selectedFilesUrls: selectedFilesUrls
      });

      var propsForViewers = {
        containerStateForViewers: !isEditable ? this.state : undefined,
        updateStateForViewers: !isEditable ? function (key, field) {
          return _this2.setState(_defineProperty({}, key, field));
        } : undefined
      };

      return _react2.default.createElement(
        'div',
        { id: 'marketing-materials' },
        _react2.default.createElement(
          _materialUi.Paper,
          {
            rounded: false,
            zDepth: 1,
            style: { marginTop: '3%', padding: isSupplier || MMPartnerReducer.sendToPartners ? '' : '3% 5%' }
          },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_titleContainer2.default, _extends({
              updateMMPartnerProp: updateMMPartnerProp,
              isEditable: isEditable,
              forLocationOrProductPages: forLocationOrProductPages,
              findPhotosForTag: findPhotosForTag
            }, propsForViewers, propsForTitleAndDragDrop)),
            _react2.default.createElement(
              'div',
              { style: { clear: 'both', padding: '2% 5%' } },
              isEditable && !MMPartnerReducer.sendToPartners && !MMPartnerReducer.sendingMM && !MMReducer.managingTags ? _react2.default.createElement(
                'div',
                null,
                !findPhotosForTag.length && isEditable && _react2.default.createElement(
                  'div',
                  {
                    style: { marginBottom: '8px', display: 'flex', alignItems: 'center' }
                  },
                  _react2.default.createElement(_insertPhoto2.default, { style: { color: 'rgba(0, 0, 0, 0.54)' } }),
                  'Make a great first impression...add some beautiful images here!'
                ),
                _react2.default.createElement(_dropzone2.default, {
                  addFilesMessage: 'Add Marketing Materials by clicking here.',
                  acceptedFileTypes: '.jpg, .png, .jpeg, .mp4, .ppt, .pptx, .pdf',
                  arrayOfPhotoTypes: ['image/jpeg', 'image/png'],
                  arrayOfAcceptedFileTypes: ['image/jpeg', 'image/png', 'video/mp4', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/pdf'],
                  addRemoveLinks: false,
                  showFiletypeIcon: false,
                  allFiles: MMReducer.media || [],
                  showThumbnailPreviews: false,
                  uploadingFile: function uploadingFile() {
                    return updateMMProp({ uploadingFile: true });
                  },
                  suggestedMinFileSize: '50',
                  finishedFileUploadCB: function finishedFileUploadCB(imageUrl, fileType, fileName, fileSize) {
                    var tagIDToFind = (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), function () {
                      return (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), (0, _ramda.always)(params.locationId), (0, _ramda.always)(params.productId)), Boolean(params.locationId));
                    }, (0, _ramda.always)(undefined)), routeName !== 'profile');
                    MMReducer.media.unshift({
                      url: imageUrl,
                      mediaType: fileType,
                      name: fileName,
                      size: fileSize,
                      tags: (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)(true), function () {
                        return (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), (0, _ramda.always)([Object.keys(profileLocationReducer).pop()]), (0, _ramda.always)([tagIDToFind])), isOneLocationSupplier && routeName === 'profile');
                      }], [_ramda.T, (0, _ramda.always)([])]]), isOneLocationSupplier || forLocationOrProductPages),
                      created_at: new Date()
                    });
                    updateMMProp({
                      savingMedia: true,
                      media: MMReducer.media,
                      uploadingFile: false
                    });
                    _this2.updateMM({
                      updateField: 'media',
                      updateBody: MMReducer.media
                    });
                  }
                })
              ) : _react2.default.createElement('span', null),
              (0, _ramda.not)((0, _ramda.isEmpty)(MMReducer.media)) && isEditable && !MMPartnerReducer.sendToPartners && !MMPartnerReducer.sendingMM && !MMReducer.managingTags ? _react2.default.createElement(_searchBar2.default, {
                value: isEditable ? MMReducer.searchField : this.state.searchField,
                onChangeFunc: function onChangeFunc(_ref) {
                  var value = _ref.target.value;

                  var fileNameSearch = MMReducer.media.map(function (file) {
                    return file.name.toLowerCase();
                  }).filter(function (fileName) {
                    return (0, _ramda.contains)(value.toLowerCase(), fileName);
                  });
                  var findTags = isSupplier ? (0, _ramda.flatten)(MMReducer.media.map(function (file) {
                    var results = [];
                    var tagNames = file.tags.reduce(function (acc, tag) {
                      var tagName = MMReducer.productTags.concat(MMReducer.locationTags).filter(function (obj) {
                        return obj.id === tag;
                      })[0];
                      acc.push(tagName);
                      return acc;
                    }, []);
                    tagNames.map(function (tagObj) {
                      return tagObj.name;
                    }).map(function (tagName) {
                      if ((0, _ramda.contains)(value.toLowerCase(), tagName.toLowerCase())) results.push(file);
                    });
                    return results;
                  })) : [];
                  if (isEditable) {
                    updateMMProp({
                      selectedFiles: [],
                      filterByMediaType: 'All File Types',
                      searchField: value,
                      filteredMedia: (0, _ramda.uniq)(MMReducer.media.filter(function (file) {
                        return (0, _ramda.contains)(file.name.toLowerCase(), fileNameSearch);
                      }).concat(findTags))
                    });
                  } else {
                    _this2.setState({
                      filterByMediaType: 'All File Types',
                      searchField: value,
                      filteredMedia: (0, _ramda.uniq)(findTags),
                      selectedFiles: []
                    });
                  }
                },
                isSupplier: isSupplier,
                isEditable: isEditable
              }) : _react2.default.createElement('span', null),
              MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM ? _react2.default.createElement(_containerSendToPartners2.default, {
                updateMMPartnerProp: updateMMPartnerProp,
                isSupplier: isSupplier
              }) : _react2.default.createElement('span', null),
              MMReducer.managingTags ? _react2.default.createElement(_tags2.default, {
                updateMMProp: updateMMProp
              }) : _react2.default.createElement('span', null),
              _react2.default.createElement(
                'div',
                {
                  className: MMReducer.managingTags && (0, _ramda.equals)(MMReducer.tagsStep, 1) ? 'blur-photos' : '',
                  style: { clear: 'both', textAlign: 'center', marginTop: '10px', border: MMReducer.managingTags && (0, _ramda.equals)(MMReducer.tagsStep, 2) ? '1px solid #d3d3d3' : '', padding: MMReducer.managingTags ? '10px' : '' }
                },
                MMReducer.managingTags ? _react2.default.createElement(
                  'div',
                  { style: { textAlign: 'left', marginBottom: '15px' } },
                  _react2.default.createElement(
                    'b',
                    null,
                    'Step Two:'
                  ),
                  ' Select which files you would like to assign ',
                  (0, _ramda.equals)(MMReducer.tags.length, 1) ? 'the tag' : 'tags',
                  ' to. Deselecting a file will remove the tag from the location / product.'
                ) : _react2.default.createElement('span', null),
                (0, _ramda.not)((0, _ramda.isEmpty)(MMReducer.media)) && !MMPartnerReducer.sendToPartners && !MMPartnerReducer.sendingMM ? _react2.default.createElement(
                  'div',
                  { style: { maxHeight: '500px', overflowY: 'scroll', overflowX: 'hidden', pointerEvents: MMReducer.managingTags && (0, _ramda.equals)(MMReducer.tagsStep, 1) ? 'none' : '' } },
                  MMReducer.loadingMM ? _react2.default.createElement(_materialUi.CircularProgress, null) : _react2.default.createElement(_dragDropContainer2.default, _extends({
                    isEditable: isEditable,
                    forLocationOrProductPages: forLocationOrProductPages,
                    findPhotosForTag: findPhotosForTag
                  }, propsForViewers, propsForTitleAndDragDrop))
                ) : _react2.default.createElement('span', null),
                MMReducer.managingTags ? _react2.default.createElement(
                  'div',
                  { style: { display: 'block', textAlign: 'right', marginTop: '10px' } },
                  _react2.default.createElement(_materialUi.RaisedButton, {
                    key: 'MMSaveButton',
                    label: 'Save',
                    onTouchTap: function onTouchTap() {
                      var addIndex = MMReducer.media.map(function (obj, index) {
                        return (0, _ramda.merge)(obj, { index: index });
                      });
                      var selectedIndexes = MMReducer.selectedFiles.map(function (obj) {
                        var allUrls = addIndex.map(function (file) {
                          return file.url;
                        });
                        if ((0, _ramda.contains)(obj.url, allUrls)) return addIndex.filter(function (object) {
                          return object.url === obj.url;
                        })[0].index;
                      });
                      var originalFilesWithTags = addIndex.filter(function (obj) {
                        if (MMReducer.tags.every(function (i) {
                          return obj.tags.indexOf(i) !== -1;
                        })) return obj;
                      }).map(function (obj) {
                        return obj.index;
                      });
                      var removeTagsFrom = originalFilesWithTags.filter(function (i) {
                        return selectedIndexes.indexOf(i) < 0;
                      });
                      var addTagsTo = selectedIndexes.filter(function (i) {
                        return originalFilesWithTags.indexOf(i) < 0;
                      });
                      addTagsTo.map(function (index) {
                        return MMReducer.media[index].tags = MMReducer.media[index].tags.concat(MMReducer.tags);
                      });
                      removeTagsFrom.map(function (index) {
                        return MMReducer.media[index].tags = (0, _ramda.without)(MMReducer.tags, MMReducer.media[index].tags);
                      });
                      _this2.updateMM({
                        updateField: 'media',
                        updateBody: MMReducer.media
                      });
                      updateMMProp({
                        media: MMReducer.media,
                        tagsStep: 1,
                        managingTags: false,
                        tags: [],
                        selectedFiles: []
                      });
                    },
                    secondary: true
                  })
                ) : _react2.default.createElement('span', null)
              )
            )
          )
        ),
        this.state.showSafariErrorForMultiFiles ? _react2.default.createElement(_unsupportedBrowser2.default, {
          buttonText: 'OK',
          confirmationFunc: function confirmationFunc() {
            return _this2.setState({ showSafariErrorForMultiFiles: false });
          },
          title: 'Unsupported Browser',
          errorMessage: 'The browser you are using is not supported for multiple downloads. Please use Chrome.'
        }) : _react2.default.createElement('span', null)
      );
    }
  }]);

  return MarketingMaterials;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getMMData = function (props) {
    var user = props.user,
        getMM = props.getMM,
        routeName = props.routeName,
        updateMMProp = props.updateMMProp,
        params = props.params,
        isEditable = props.isEditable,
        companyProfileReducer = props.companyProfileReducer,
        companyLocationReducer = props.companyLocationReducer,
        companyProductReducer = props.companyProductReducer;

    var checkRoute = (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('profile'), (0, _ramda.always)(params.companyId || (0, _ramda.prop)(0, Object.keys(companyProfileReducer)))], [(0, _ramda.equals)('location'), (0, _ramda.always)((0, _ramda.path)([params.locationId, 'companyId'], companyLocationReducer))], [(0, _ramda.equals)('product'), (0, _ramda.always)((0, _ramda.path)([params.productId, 'companyId'], companyProductReducer))]]), routeName);
    var getCompanyId = isEditable ? (0, _ramda.path)(['user', 'userID'], user) : checkRoute || (0, _ramda.path)(['user', 'userID'], user);
    getMM(getCompanyId);
    if (routeName && !(0, _ramda.equals)(routeName, 'profile')) {
      updateMMProp({
        managingTags: false,
        selectedFiles: [],
        tagsStep: 1,
        tags: []
      });
    }
    if ((0, _ramda.equals)(routeName, 'profile')) {
      updateMMProp({
        selectedFiles: []
      });
    }
  };

  this.updateMM = function (options) {
    var _updateMMProp;

    var _props2 = _this3.props,
        updateMMProp = _props2.updateMMProp,
        saveMMField = _props2.saveMMField;

    updateMMProp((_updateMMProp = {}, _defineProperty(_updateMMProp, options.updateField, options.updateBody), _defineProperty(_updateMMProp, 'savingMedia', false), _updateMMProp));
    saveMMField(options);
  };
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var marketingMaterials = _ref2.marketingMaterials,
      profileLocation = _ref2.profileLocation,
      user = _ref2.user,
      companyProfile = _ref2.companyProfile,
      companyLocation = _ref2.companyLocation,
      companyProduct = _ref2.companyProduct;
  return {
    MMPartnerReducer: marketingMaterials.partnerReducer.toJS(),
    MMReducer: marketingMaterials.mainReducer.toJS(),
    profileLocationReducer: profileLocation.toJS(),
    companyProfileReducer: companyProfile.toJS(),
    companyLocationReducer: companyLocation.toJS(),
    companyProductReducer: companyProduct.toJS(),
    user: user.toJS()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getMM: function getMM(companyId) {
      return dispatch((0, _actions.getMarketingMaterials)(companyId));
    },
    updateMMProp: function updateMMProp() {
      return dispatch(_actions.updateMMProps.apply(undefined, arguments));
    },
    updateMMPartnerProp: function updateMMPartnerProp() {
      return dispatch(_actions.updateMMPartnerProps.apply(undefined, arguments));
    },
    saveMMField: function saveMMField() {
      return dispatch(_actions.editMMField.apply(undefined, arguments));
    },
    clearReducer: function clearReducer() {
      return dispatch((0, _actions.clearStore)());
    }
  };
};

MarketingMaterials.propTypes = {
  saveMMField: _react.PropTypes.func,
  updateMMProp: _react.PropTypes.func,
  updateMMPartnerProp: _react.PropTypes.func,
  isEditable: _react.PropTypes.bool,
  MMReducer: _react.PropTypes.object,
  MMPartnerReducer: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  user: _react.PropTypes.object,
  getMM: _react.PropTypes.func,
  isSupplier: _react.PropTypes.bool,
  forLocationOrProductPages: _react.PropTypes.bool,
  findPhotosForTag: _react.PropTypes.array,
  routeName: _react.PropTypes.string,
  isOneLocationSupplier: _react.PropTypes.bool,
  profileLocationReducer: _react.PropTypes.object,
  params: _react.PropTypes.object,
  clearReducer: _react.PropTypes.func,
  companyProfileReducer: _react.PropTypes.object,
  companyLocationReducer: _react.PropTypes.object,
  companyProductReducer: _react.PropTypes.object
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MarketingMaterials);

/***/ }),
/* 3130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
    ReactDOM = __webpack_require__(47),
    Helpers = __webpack_require__(3131),
    IconComponent = __webpack_require__(3132),
    Dropzone, DropzoneComponent;

DropzoneComponent = React.createClass({displayName: "DropzoneComponent",
    /**
     * Ensure we always have props to work with.
     */
    getDefaultProps: function () {
        return {
          djsConfig: {},
          config: {},
          eventHandlers: {}
        }
    },

    /**
     * Configuration of Dropzone.js. Defaults are
     * overriden by the 'djsConfig' property
     * For a full list of possible configurations,
     * please consult
     * http://www.dropzonejs.com/#configuration
     */
    getDjsConfig: function () {
        var options,
            defaults = {
                url: this.props.config.postUrl ? this.props.config.postUrl : null
            };

        if (this.props.djsConfig) {
            options = Helpers.extend(true, {}, defaults, this.props.djsConfig);
        } else {
            options = defaults;
        }

        return options;
    },

    /**
     * React 'componentDidMount' method
     * Sets up dropzone.js with the component.
     */
    componentDidMount: function () {
        var self = this,
            options = this.getDjsConfig();

        Dropzone = Dropzone || __webpack_require__(3133);
        Dropzone.autoDiscover = false;

        if (!this.props.config.postUrl && !this.props.eventHandlers.drop) {
            console.info('Neither postUrl nor a "drop" eventHandler specified, the React-Dropzone component might misbehave.');
        }

        var dropzoneNode = this.props.config.dropzoneSelector || ReactDOM.findDOMNode(this);
        this.dropzone = new Dropzone(dropzoneNode, options);
        this.setupEvents();
    },

    /**
     * React 'componentWillUnmount'
     * Removes dropzone.js (and all its globals) if the component is being unmounted
     */
    componentWillUnmount: function () {
        if (this.dropzone) {
            var files = this.dropzone.getActiveFiles();

            if (files.length > 0) {
                // Well, seems like we still have stuff uploading.
                // This is dirty, but let's keep trying to get rid
                // of the dropzone until we're done here.
                this.queueDestroy = true;

                var destroyInterval = window.setInterval(function()  {
                    if (this.queueDestroy = false) {
                        return window.clearInterval(destroyInterval);
                    }

                    if (this.dropzone.getActiveFiles().length === 0) {
                        this.dropzone = this.destroy(this.dropzone);
                        return window.clearInterval(destroyInterval);
                    }
                }.bind(this), 500);
            } else {
                this.dropzone = this.destroy(this.dropzone);
            }
        }
    },

    /**
     * React 'componentDidUpdate'
     * If the Dropzone hasn't been created, create it
     */
    componentDidUpdate: function () {
        this.queueDestroy = false;

        if (!this.dropzone) {
            var dropzoneNode = this.props.config.dropzoneSelector || ReactDOM.findDOMNode(this);
            this.dropzone = new Dropzone(dropzoneNode, this.getDjsConfig());
        }
    },

    /**
     * React 'componentWillUpdate'
     * Update Dropzone options each time the component updates.
     */
    componentWillUpdate: function() {
        var djsConfigObj, postUrlConfigObj;

        djsConfigObj = this.props.djsConfig ? this.props.djsConfig : {};        
        try {
            postUrlConfigObj = this.props.config.postUrl ? {url: this.props.config.postUrl} : {};            
        } catch (err) {   
            postUrlConfigObj = {};
        }
        
        this.dropzone.options = Helpers.extend(true, {}, this.dropzone.options, djsConfigObj, postUrlConfigObj);
    },

    /**
     * React 'render'
     */
    render: function () {
        var icons = [],
            files = this.state.files,
            config = this.props.config,
            className = (this.props.className) ? 'filepicker dropzone ' + this.props.className : 'filepicker dropzone';

        if (config.showFiletypeIcon && config.iconFiletypes && (!files || files.length < 1)) {
            for (var i = 0; i < this.props.config.iconFiletypes.length; i = i + 1) {
                icons.push(React.createElement(IconComponent, {filetype: this.props.config.iconFiletypes[i], key: "icon-component" + i}));
            }
        }

        if (!this.props.config.postUrl && this.props.action) {
            return (
                React.createElement("form", {action: this.props.action, className: className}, 
                    icons, 
                    this.props.children
                )
            );
        } else {
            return (
                React.createElement("div", {className: className}, 
                    icons, 
                    this.props.children
                )
            );
        }
    },

    /**
     * React 'getInitialState' method, setting the initial state
     * @return {object}
     */
    getInitialState: function () {
        return {
            files: []
        }
    },

    /**
     * Takes event handlers in this.props.eventHandlers
     * and binds them to dropzone.js events
     */
    setupEvents: function () {
        var eventHandlers = this.props.eventHandlers;

        if (!this.dropzone || !eventHandlers) {
            return;
        }

        for (var eventHandler in eventHandlers) {
            if (eventHandlers.hasOwnProperty(eventHandler) && eventHandlers[eventHandler]) {
                // Check if there's an array of event handlers
                if (Object.prototype.toString.call(eventHandlers[eventHandler]) === '[object Array]') {
                    for (var i = 0; i < eventHandlers[eventHandler].length; i = i + 1) {
                        // Check if it's an init handler
                        if (eventHandler === 'init') {
                            eventHandlers[eventHandler][i](this.dropzone);
                        } else {
                            this.dropzone.on(eventHandler, eventHandlers[eventHandler][i]);
                        }
                    }
                } else {
                    if (eventHandler === 'init') {
                        eventHandlers[eventHandler](this.dropzone);
                    } else {
                        this.dropzone.on(eventHandler, eventHandlers[eventHandler]);
                    }
                }
            }
        }

        this.dropzone.on('addedfile', function(file)  {
            if (file) {
                var files = this.state.files;

                if (!files) {
                    files = [];
                }

                files.push(file)

                this.setState({files: files});
            }
        }.bind(this));

        this.dropzone.on('removedfile', function(file)  {
            if (file) {
                var files = this.state.files;

                if (files && files.length > 0) {
                    for (var i = 0; i < files.length; i++) {
                        if (files[i].name === file.name && files[i].size === file.size) {
                            files.splice(i, 1);
                        }
                    }

                    this.setState({files: files});
                }
            }
        }.bind(this));
    },

    /**
     * Removes ALL listeners and Destroys dropzone. see https://github.com/enyo/dropzone/issues/1175
     */
    destroy: function(dropzone) {
        dropzone.off();
        return dropzone.destroy();
    }

});

module.exports = DropzoneComponent;


/***/ }),
/* 3131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Helpers = {
    /**
     * Clone of jQuery's extend
     * Usage: extend(true, {}, obj1, obj2)
     */
    extend: function () {
        var options, name, src, copy, copyIsArray, clone, self = this,
            target = arguments[0] || {},
            i = 1,
            length = arguments.length,
            deep = false,
            // helper which replicates the jquery internal functions
            objectHelper = {
                hasOwn: Object.prototype.hasOwnProperty,
                class2type: {},

                type: function (obj) {
                    return obj == null ?
                        String(obj) :
                        objectHelper.class2type[Object.prototype.toString.call(obj)] || 'object';
                },

                isPlainObject: function (obj) {
                    var key;

                    if (!obj || objectHelper.type(obj) !== 'object' || obj.nodeType || objectHelper.isWindow(obj)) {
                        return false;
                    }

                    try {
                        if (obj.constructor &&
                            !objectHelper.hasOwn.call(obj, 'constructor') &&
                            !objectHelper.hasOwn.call(obj.constructor.prototype, 'isPrototypeOf')) {
                            return false;
                        }
                    } catch (e) {
                        return false;
                    }

                    return key === undefined || objectHelper.hasOwn.call(obj, key);
                },

                isArray: Array.isArray || function (obj) {
                    return objectHelper.type(obj) === 'array';
                },

                isFunction: function (obj) {
                    return objectHelper.type(obj) === 'function';
                },

                isWindow: function (obj) {
                    return obj != null && obj == obj.window;
                }
            };

        // Handle a deep copy situation
        if (typeof target === 'boolean') {
            deep = target;
            target = arguments[1] || {};
            // skip the boolean and the target
            i = 2;
        }

        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== 'object' && !objectHelper.isFunction(target)) {
            target = {};
        }

        // If no second argument is used then this can extend an object that is using this method
        if (length === i) {
            target = self;
            --i;
        }

        for (; i < length; i = i + 1) {
            if ((options = arguments[i]) != null) {
                for (name in options) {
                    src = target[name];
                    copy = options[name];

                    if (target === copy) {
                        continue;
                    }

                    if (deep && copy && (objectHelper.isPlainObject(copy) || (copyIsArray = objectHelper.isArray(copy)))) {
                        if (copyIsArray) {
                            copyIsArray = false;
                            clone = src && objectHelper.isArray(src) ? src : [];
                        } else {
                            clone = src && objectHelper.isPlainObject(src) ? src : {};
                        }

                        target[name] = this.extend(deep, clone, copy);
                    } else if (copy !== undefined) {
                        target[name] = copy;
                    }
                }
            }
        }

        return target;
    }
}

module.exports = Helpers;


/***/ }),
/* 3132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
    
var Icon = React.createClass({displayName: "Icon",
    render: function () {
        return (
            React.createElement("div", {"data-filetype": this.props.filetype, className: "filepicker-file-icon"})
        );
    }
});

module.exports = Icon;


/***/ }),
/* 3133 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {
/*
 *
 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
 *
 * Copyright (c) 2012, Matias Meno
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

(function() {
  var Dropzone, Emitter, camelize, contentLoaded, detectVerticalSquash, drawImageIOSFix, noop, without,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  noop = function() {};

  Emitter = (function() {
    function Emitter() {}

    Emitter.prototype.addEventListener = Emitter.prototype.on;

    Emitter.prototype.on = function(event, fn) {
      this._callbacks = this._callbacks || {};
      if (!this._callbacks[event]) {
        this._callbacks[event] = [];
      }
      this._callbacks[event].push(fn);
      return this;
    };

    Emitter.prototype.emit = function() {
      var args, callback, callbacks, event, _i, _len;
      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      this._callbacks = this._callbacks || {};
      callbacks = this._callbacks[event];
      if (callbacks) {
        for (_i = 0, _len = callbacks.length; _i < _len; _i++) {
          callback = callbacks[_i];
          callback.apply(this, args);
        }
      }
      return this;
    };

    Emitter.prototype.removeListener = Emitter.prototype.off;

    Emitter.prototype.removeAllListeners = Emitter.prototype.off;

    Emitter.prototype.removeEventListener = Emitter.prototype.off;

    Emitter.prototype.off = function(event, fn) {
      var callback, callbacks, i, _i, _len;
      if (!this._callbacks || arguments.length === 0) {
        this._callbacks = {};
        return this;
      }
      callbacks = this._callbacks[event];
      if (!callbacks) {
        return this;
      }
      if (arguments.length === 1) {
        delete this._callbacks[event];
        return this;
      }
      for (i = _i = 0, _len = callbacks.length; _i < _len; i = ++_i) {
        callback = callbacks[i];
        if (callback === fn) {
          callbacks.splice(i, 1);
          break;
        }
      }
      return this;
    };

    return Emitter;

  })();

  Dropzone = (function(_super) {
    var extend, resolveOption;

    __extends(Dropzone, _super);

    Dropzone.prototype.Emitter = Emitter;


    /*
    This is a list of all available events you can register on a dropzone object.
    
    You can register an event handler like this:
    
        dropzone.on("dragEnter", function() { });
     */

    Dropzone.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];

    Dropzone.prototype.defaultOptions = {
      url: null,
      method: "post",
      withCredentials: false,
      parallelUploads: 2,
      uploadMultiple: false,
      maxFilesize: 256,
      paramName: "file",
      createImageThumbnails: true,
      maxThumbnailFilesize: 10,
      thumbnailWidth: 120,
      thumbnailHeight: 120,
      filesizeBase: 1000,
      maxFiles: null,
      params: {},
      clickable: true,
      ignoreHiddenFiles: true,
      acceptedFiles: null,
      acceptedMimeTypes: null,
      autoProcessQueue: true,
      autoQueue: true,
      addRemoveLinks: false,
      previewsContainer: null,
      hiddenInputContainer: "body",
      capture: null,
      renameFilename: null,
      dictDefaultMessage: "Drop files here to upload",
      dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
      dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
      dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
      dictInvalidFileType: "You can't upload files of this type.",
      dictResponseError: "Server responded with {{statusCode}} code.",
      dictCancelUpload: "Cancel upload",
      dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
      dictRemoveFile: "Remove file",
      dictRemoveFileConfirmation: null,
      dictMaxFilesExceeded: "You can not upload any more files.",
      accept: function(file, done) {
        return done();
      },
      init: function() {
        return noop;
      },
      forceFallback: false,
      fallback: function() {
        var child, messageElement, span, _i, _len, _ref;
        this.element.className = "" + this.element.className + " dz-browser-not-supported";
        _ref = this.element.getElementsByTagName("div");
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          child = _ref[_i];
          if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message";
            continue;
          }
        }
        if (!messageElement) {
          messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
          this.element.appendChild(messageElement);
        }
        span = messageElement.getElementsByTagName("span")[0];
        if (span) {
          if (span.textContent != null) {
            span.textContent = this.options.dictFallbackMessage;
          } else if (span.innerText != null) {
            span.innerText = this.options.dictFallbackMessage;
          }
        }
        return this.element.appendChild(this.getFallbackForm());
      },
      resize: function(file) {
        var info, srcRatio, trgRatio;
        info = {
          srcX: 0,
          srcY: 0,
          srcWidth: file.width,
          srcHeight: file.height
        };
        srcRatio = file.width / file.height;
        info.optWidth = this.options.thumbnailWidth;
        info.optHeight = this.options.thumbnailHeight;
        if ((info.optWidth == null) && (info.optHeight == null)) {
          info.optWidth = info.srcWidth;
          info.optHeight = info.srcHeight;
        } else if (info.optWidth == null) {
          info.optWidth = srcRatio * info.optHeight;
        } else if (info.optHeight == null) {
          info.optHeight = (1 / srcRatio) * info.optWidth;
        }
        trgRatio = info.optWidth / info.optHeight;
        if (file.height < info.optHeight || file.width < info.optWidth) {
          info.trgHeight = info.srcHeight;
          info.trgWidth = info.srcWidth;
        } else {
          if (srcRatio > trgRatio) {
            info.srcHeight = file.height;
            info.srcWidth = info.srcHeight * trgRatio;
          } else {
            info.srcWidth = file.width;
            info.srcHeight = info.srcWidth / trgRatio;
          }
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        return info;
      },

      /*
      Those functions register themselves to the events on init and handle all
      the user interface specific stuff. Overwriting them won't break the upload
      but can break the way it's displayed.
      You can overwrite them if you don't like the default behavior. If you just
      want to add an additional event handler, register it on the dropzone object
      and don't overwrite those options.
       */
      drop: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragstart: noop,
      dragend: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragenter: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragover: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragleave: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      paste: noop,
      reset: function() {
        return this.element.classList.remove("dz-started");
      },
      addedfile: function(file) {
        var node, removeFileEvent, removeLink, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _results;
        if (this.element === this.previewsContainer) {
          this.element.classList.add("dz-started");
        }
        if (this.previewsContainer) {
          file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
          file.previewTemplate = file.previewElement;
          this.previewsContainer.appendChild(file.previewElement);
          _ref = file.previewElement.querySelectorAll("[data-dz-name]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            node.textContent = this._renameFilename(file.name);
          }
          _ref1 = file.previewElement.querySelectorAll("[data-dz-size]");
          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
            node = _ref1[_j];
            node.innerHTML = this.filesize(file.size);
          }
          if (this.options.addRemoveLinks) {
            file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
            file.previewElement.appendChild(file._removeLink);
          }
          removeFileEvent = (function(_this) {
            return function(e) {
              e.preventDefault();
              e.stopPropagation();
              if (file.status === Dropzone.UPLOADING) {
                return Dropzone.confirm(_this.options.dictCancelUploadConfirmation, function() {
                  return _this.removeFile(file);
                });
              } else {
                if (_this.options.dictRemoveFileConfirmation) {
                  return Dropzone.confirm(_this.options.dictRemoveFileConfirmation, function() {
                    return _this.removeFile(file);
                  });
                } else {
                  return _this.removeFile(file);
                }
              }
            };
          })(this);
          _ref2 = file.previewElement.querySelectorAll("[data-dz-remove]");
          _results = [];
          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
            removeLink = _ref2[_k];
            _results.push(removeLink.addEventListener("click", removeFileEvent));
          }
          return _results;
        }
      },
      removedfile: function(file) {
        var _ref;
        if (file.previewElement) {
          if ((_ref = file.previewElement) != null) {
            _ref.parentNode.removeChild(file.previewElement);
          }
        }
        return this._updateMaxFilesReachedClass();
      },
      thumbnail: function(file, dataUrl) {
        var thumbnailElement, _i, _len, _ref;
        if (file.previewElement) {
          file.previewElement.classList.remove("dz-file-preview");
          _ref = file.previewElement.querySelectorAll("[data-dz-thumbnail]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            thumbnailElement = _ref[_i];
            thumbnailElement.alt = file.name;
            thumbnailElement.src = dataUrl;
          }
          return setTimeout(((function(_this) {
            return function() {
              return file.previewElement.classList.add("dz-image-preview");
            };
          })(this)), 1);
        }
      },
      error: function(file, message) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          file.previewElement.classList.add("dz-error");
          if (typeof message !== "String" && message.error) {
            message = message.error;
          }
          _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            _results.push(node.textContent = message);
          }
          return _results;
        }
      },
      errormultiple: noop,
      processing: function(file) {
        if (file.previewElement) {
          file.previewElement.classList.add("dz-processing");
          if (file._removeLink) {
            return file._removeLink.textContent = this.options.dictCancelUpload;
          }
        }
      },
      processingmultiple: noop,
      uploadprogress: function(file, progress, bytesSent) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          _ref = file.previewElement.querySelectorAll("[data-dz-uploadprogress]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            if (node.nodeName === 'PROGRESS') {
              _results.push(node.value = progress);
            } else {
              _results.push(node.style.width = "" + progress + "%");
            }
          }
          return _results;
        }
      },
      totaluploadprogress: noop,
      sending: noop,
      sendingmultiple: noop,
      success: function(file) {
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-success");
        }
      },
      successmultiple: noop,
      canceled: function(file) {
        return this.emit("error", file, "Upload canceled.");
      },
      canceledmultiple: noop,
      complete: function(file) {
        if (file._removeLink) {
          file._removeLink.textContent = this.options.dictRemoveFile;
        }
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-complete");
        }
      },
      completemultiple: noop,
      maxfilesexceeded: noop,
      maxfilesreached: noop,
      queuecomplete: noop,
      addedfiles: noop,
      previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>"
    };

    extend = function() {
      var key, object, objects, target, val, _i, _len;
      target = arguments[0], objects = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      for (_i = 0, _len = objects.length; _i < _len; _i++) {
        object = objects[_i];
        for (key in object) {
          val = object[key];
          target[key] = val;
        }
      }
      return target;
    };

    function Dropzone(element, options) {
      var elementOptions, fallback, _ref;
      this.element = element;
      this.version = Dropzone.version;
      this.defaultOptions.previewTemplate = this.defaultOptions.previewTemplate.replace(/\n*/g, "");
      this.clickableElements = [];
      this.listeners = [];
      this.files = [];
      if (typeof this.element === "string") {
        this.element = document.querySelector(this.element);
      }
      if (!(this.element && (this.element.nodeType != null))) {
        throw new Error("Invalid dropzone element.");
      }
      if (this.element.dropzone) {
        throw new Error("Dropzone already attached.");
      }
      Dropzone.instances.push(this);
      this.element.dropzone = this;
      elementOptions = (_ref = Dropzone.optionsForElement(this.element)) != null ? _ref : {};
      this.options = extend({}, this.defaultOptions, elementOptions, options != null ? options : {});
      if (this.options.forceFallback || !Dropzone.isBrowserSupported()) {
        return this.options.fallback.call(this);
      }
      if (this.options.url == null) {
        this.options.url = this.element.getAttribute("action");
      }
      if (!this.options.url) {
        throw new Error("No URL provided.");
      }
      if (this.options.acceptedFiles && this.options.acceptedMimeTypes) {
        throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
      }
      if (this.options.acceptedMimeTypes) {
        this.options.acceptedFiles = this.options.acceptedMimeTypes;
        delete this.options.acceptedMimeTypes;
      }
      this.options.method = this.options.method.toUpperCase();
      if ((fallback = this.getExistingFallback()) && fallback.parentNode) {
        fallback.parentNode.removeChild(fallback);
      }
      if (this.options.previewsContainer !== false) {
        if (this.options.previewsContainer) {
          this.previewsContainer = Dropzone.getElement(this.options.previewsContainer, "previewsContainer");
        } else {
          this.previewsContainer = this.element;
        }
      }
      if (this.options.clickable) {
        if (this.options.clickable === true) {
          this.clickableElements = [this.element];
        } else {
          this.clickableElements = Dropzone.getElements(this.options.clickable, "clickable");
        }
      }
      this.init();
    }

    Dropzone.prototype.getAcceptedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getRejectedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (!file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getFilesWithStatus = function(status) {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === status) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getQueuedFiles = function() {
      return this.getFilesWithStatus(Dropzone.QUEUED);
    };

    Dropzone.prototype.getUploadingFiles = function() {
      return this.getFilesWithStatus(Dropzone.UPLOADING);
    };

    Dropzone.prototype.getAddedFiles = function() {
      return this.getFilesWithStatus(Dropzone.ADDED);
    };

    Dropzone.prototype.getActiveFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.init = function() {
      var eventName, noPropagation, setupHiddenFileInput, _i, _len, _ref, _ref1;
      if (this.element.tagName === "form") {
        this.element.setAttribute("enctype", "multipart/form-data");
      }
      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
      }
      if (this.clickableElements.length) {
        setupHiddenFileInput = (function(_this) {
          return function() {
            if (_this.hiddenFileInput) {
              _this.hiddenFileInput.parentNode.removeChild(_this.hiddenFileInput);
            }
            _this.hiddenFileInput = document.createElement("input");
            _this.hiddenFileInput.setAttribute("type", "file");
            if ((_this.options.maxFiles == null) || _this.options.maxFiles > 1) {
              _this.hiddenFileInput.setAttribute("multiple", "multiple");
            }
            _this.hiddenFileInput.className = "dz-hidden-input";
            if (_this.options.acceptedFiles != null) {
              _this.hiddenFileInput.setAttribute("accept", _this.options.acceptedFiles);
            }
            if (_this.options.capture != null) {
              _this.hiddenFileInput.setAttribute("capture", _this.options.capture);
            }
            _this.hiddenFileInput.style.visibility = "hidden";
            _this.hiddenFileInput.style.position = "absolute";
            _this.hiddenFileInput.style.top = "0";
            _this.hiddenFileInput.style.left = "0";
            _this.hiddenFileInput.style.height = "0";
            _this.hiddenFileInput.style.width = "0";
            document.querySelector(_this.options.hiddenInputContainer).appendChild(_this.hiddenFileInput);
            return _this.hiddenFileInput.addEventListener("change", function() {
              var file, files, _i, _len;
              files = _this.hiddenFileInput.files;
              if (files.length) {
                for (_i = 0, _len = files.length; _i < _len; _i++) {
                  file = files[_i];
                  _this.addFile(file);
                }
              }
              _this.emit("addedfiles", files);
              return setupHiddenFileInput();
            });
          };
        })(this);
        setupHiddenFileInput();
      }
      this.URL = (_ref = window.URL) != null ? _ref : window.webkitURL;
      _ref1 = this.events;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        eventName = _ref1[_i];
        this.on(eventName, this.options[eventName]);
      }
      this.on("uploadprogress", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("removedfile", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("canceled", (function(_this) {
        return function(file) {
          return _this.emit("complete", file);
        };
      })(this));
      this.on("complete", (function(_this) {
        return function(file) {
          if (_this.getAddedFiles().length === 0 && _this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) {
            return setTimeout((function() {
              return _this.emit("queuecomplete");
            }), 0);
          }
        };
      })(this));
      noPropagation = function(e) {
        e.stopPropagation();
        if (e.preventDefault) {
          return e.preventDefault();
        } else {
          return e.returnValue = false;
        }
      };
      this.listeners = [
        {
          element: this.element,
          events: {
            "dragstart": (function(_this) {
              return function(e) {
                return _this.emit("dragstart", e);
              };
            })(this),
            "dragenter": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.emit("dragenter", e);
              };
            })(this),
            "dragover": (function(_this) {
              return function(e) {
                var efct;
                try {
                  efct = e.dataTransfer.effectAllowed;
                } catch (_error) {}
                e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';
                noPropagation(e);
                return _this.emit("dragover", e);
              };
            })(this),
            "dragleave": (function(_this) {
              return function(e) {
                return _this.emit("dragleave", e);
              };
            })(this),
            "drop": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.drop(e);
              };
            })(this),
            "dragend": (function(_this) {
              return function(e) {
                return _this.emit("dragend", e);
              };
            })(this)
          }
        }
      ];
      this.clickableElements.forEach((function(_this) {
        return function(clickableElement) {
          return _this.listeners.push({
            element: clickableElement,
            events: {
              "click": function(evt) {
                if ((clickableElement !== _this.element) || (evt.target === _this.element || Dropzone.elementInside(evt.target, _this.element.querySelector(".dz-message")))) {
                  _this.hiddenFileInput.click();
                }
                return true;
              }
            }
          });
        };
      })(this));
      this.enable();
      return this.options.init.call(this);
    };

    Dropzone.prototype.destroy = function() {
      var _ref;
      this.disable();
      this.removeAllFiles(true);
      if ((_ref = this.hiddenFileInput) != null ? _ref.parentNode : void 0) {
        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
        this.hiddenFileInput = null;
      }
      delete this.element.dropzone;
      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
    };

    Dropzone.prototype.updateTotalUploadProgress = function() {
      var activeFiles, file, totalBytes, totalBytesSent, totalUploadProgress, _i, _len, _ref;
      totalBytesSent = 0;
      totalBytes = 0;
      activeFiles = this.getActiveFiles();
      if (activeFiles.length) {
        _ref = this.getActiveFiles();
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          totalBytesSent += file.upload.bytesSent;
          totalBytes += file.upload.total;
        }
        totalUploadProgress = 100 * totalBytesSent / totalBytes;
      } else {
        totalUploadProgress = 100;
      }
      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    };

    Dropzone.prototype._getParamName = function(n) {
      if (typeof this.options.paramName === "function") {
        return this.options.paramName(n);
      } else {
        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
      }
    };

    Dropzone.prototype._renameFilename = function(name) {
      if (typeof this.options.renameFilename !== "function") {
        return name;
      }
      return this.options.renameFilename(name);
    };

    Dropzone.prototype.getFallbackForm = function() {
      var existingFallback, fields, fieldsString, form;
      if (existingFallback = this.getExistingFallback()) {
        return existingFallback;
      }
      fieldsString = "<div class=\"dz-fallback\">";
      if (this.options.dictFallbackText) {
        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
      }
      fieldsString += "<input type=\"file\" name=\"" + (this._getParamName(0)) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + " /><input type=\"submit\" value=\"Upload!\"></div>";
      fields = Dropzone.createElement(fieldsString);
      if (this.element.tagName !== "FORM") {
        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
        form.appendChild(fields);
      } else {
        this.element.setAttribute("enctype", "multipart/form-data");
        this.element.setAttribute("method", this.options.method);
      }
      return form != null ? form : fields;
    };

    Dropzone.prototype.getExistingFallback = function() {
      var fallback, getFallback, tagName, _i, _len, _ref;
      getFallback = function(elements) {
        var el, _i, _len;
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )fallback($| )/.test(el.className)) {
            return el;
          }
        }
      };
      _ref = ["div", "form"];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        tagName = _ref[_i];
        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
          return fallback;
        }
      }
    };

    Dropzone.prototype.setupEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.addEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.removeEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.removeEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.disable = function() {
      var file, _i, _len, _ref, _results;
      this.clickableElements.forEach(function(element) {
        return element.classList.remove("dz-clickable");
      });
      this.removeEventListeners();
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        _results.push(this.cancelUpload(file));
      }
      return _results;
    };

    Dropzone.prototype.enable = function() {
      this.clickableElements.forEach(function(element) {
        return element.classList.add("dz-clickable");
      });
      return this.setupEventListeners();
    };

    Dropzone.prototype.filesize = function(size) {
      var cutoff, i, selectedSize, selectedUnit, unit, units, _i, _len;
      selectedSize = 0;
      selectedUnit = "b";
      if (size > 0) {
        units = ['TB', 'GB', 'MB', 'KB', 'b'];
        for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
          unit = units[i];
          cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
          if (size >= cutoff) {
            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
            selectedUnit = unit;
            break;
          }
        }
        selectedSize = Math.round(10 * selectedSize) / 10;
      }
      return "<strong>" + selectedSize + "</strong> " + selectedUnit;
    };

    Dropzone.prototype._updateMaxFilesReachedClass = function() {
      if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        if (this.getAcceptedFiles().length === this.options.maxFiles) {
          this.emit('maxfilesreached', this.files);
        }
        return this.element.classList.add("dz-max-files-reached");
      } else {
        return this.element.classList.remove("dz-max-files-reached");
      }
    };

    Dropzone.prototype.drop = function(e) {
      var files, items;
      if (!e.dataTransfer) {
        return;
      }
      this.emit("drop", e);
      files = e.dataTransfer.files;
      this.emit("addedfiles", files);
      if (files.length) {
        items = e.dataTransfer.items;
        if (items && items.length && (items[0].webkitGetAsEntry != null)) {
          this._addFilesFromItems(items);
        } else {
          this.handleFiles(files);
        }
      }
    };

    Dropzone.prototype.paste = function(e) {
      var items, _ref;
      if ((e != null ? (_ref = e.clipboardData) != null ? _ref.items : void 0 : void 0) == null) {
        return;
      }
      this.emit("paste", e);
      items = e.clipboardData.items;
      if (items.length) {
        return this._addFilesFromItems(items);
      }
    };

    Dropzone.prototype.handleFiles = function(files) {
      var file, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        _results.push(this.addFile(file));
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromItems = function(items) {
      var entry, item, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = items.length; _i < _len; _i++) {
        item = items[_i];
        if ((item.webkitGetAsEntry != null) && (entry = item.webkitGetAsEntry())) {
          if (entry.isFile) {
            _results.push(this.addFile(item.getAsFile()));
          } else if (entry.isDirectory) {
            _results.push(this._addFilesFromDirectory(entry, entry.name));
          } else {
            _results.push(void 0);
          }
        } else if (item.getAsFile != null) {
          if ((item.kind == null) || item.kind === "file") {
            _results.push(this.addFile(item.getAsFile()));
          } else {
            _results.push(void 0);
          }
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromDirectory = function(directory, path) {
      var dirReader, errorHandler, readEntries;
      dirReader = directory.createReader();
      errorHandler = function(error) {
        return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log(error) : void 0 : void 0;
      };
      readEntries = (function(_this) {
        return function() {
          return dirReader.readEntries(function(entries) {
            var entry, _i, _len;
            if (entries.length > 0) {
              for (_i = 0, _len = entries.length; _i < _len; _i++) {
                entry = entries[_i];
                if (entry.isFile) {
                  entry.file(function(file) {
                    if (_this.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
                      return;
                    }
                    file.fullPath = "" + path + "/" + file.name;
                    return _this.addFile(file);
                  });
                } else if (entry.isDirectory) {
                  _this._addFilesFromDirectory(entry, "" + path + "/" + entry.name);
                }
              }
              readEntries();
            }
            return null;
          }, errorHandler);
        };
      })(this);
      return readEntries();
    };

    Dropzone.prototype.accept = function(file, done) {
      if (file.size > this.options.maxFilesize * 1024 * 1024) {
        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
        return done(this.options.dictInvalidFileType);
      } else if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
        return this.emit("maxfilesexceeded", file);
      } else {
        return this.options.accept.call(this, file, done);
      }
    };

    Dropzone.prototype.addFile = function(file) {
      file.upload = {
        progress: 0,
        total: file.size,
        bytesSent: 0
      };
      this.files.push(file);
      file.status = Dropzone.ADDED;
      this.emit("addedfile", file);
      this._enqueueThumbnail(file);
      return this.accept(file, (function(_this) {
        return function(error) {
          if (error) {
            file.accepted = false;
            _this._errorProcessing([file], error);
          } else {
            file.accepted = true;
            if (_this.options.autoQueue) {
              _this.enqueueFile(file);
            }
          }
          return _this._updateMaxFilesReachedClass();
        };
      })(this));
    };

    Dropzone.prototype.enqueueFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        this.enqueueFile(file);
      }
      return null;
    };

    Dropzone.prototype.enqueueFile = function(file) {
      if (file.status === Dropzone.ADDED && file.accepted === true) {
        file.status = Dropzone.QUEUED;
        if (this.options.autoProcessQueue) {
          return setTimeout(((function(_this) {
            return function() {
              return _this.processQueue();
            };
          })(this)), 0);
        }
      } else {
        throw new Error("This file can't be queued because it has already been processed or was rejected.");
      }
    };

    Dropzone.prototype._thumbnailQueue = [];

    Dropzone.prototype._processingThumbnail = false;

    Dropzone.prototype._enqueueThumbnail = function(file) {
      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
        this._thumbnailQueue.push(file);
        return setTimeout(((function(_this) {
          return function() {
            return _this._processThumbnailQueue();
          };
        })(this)), 0);
      }
    };

    Dropzone.prototype._processThumbnailQueue = function() {
      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
        return;
      }
      this._processingThumbnail = true;
      return this.createThumbnail(this._thumbnailQueue.shift(), (function(_this) {
        return function() {
          _this._processingThumbnail = false;
          return _this._processThumbnailQueue();
        };
      })(this));
    };

    Dropzone.prototype.removeFile = function(file) {
      if (file.status === Dropzone.UPLOADING) {
        this.cancelUpload(file);
      }
      this.files = without(this.files, file);
      this.emit("removedfile", file);
      if (this.files.length === 0) {
        return this.emit("reset");
      }
    };

    Dropzone.prototype.removeAllFiles = function(cancelIfNecessary) {
      var file, _i, _len, _ref;
      if (cancelIfNecessary == null) {
        cancelIfNecessary = false;
      }
      _ref = this.files.slice();
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
          this.removeFile(file);
        }
      }
      return null;
    };

    Dropzone.prototype.createThumbnail = function(file, callback) {
      var fileReader;
      fileReader = new FileReader;
      fileReader.onload = (function(_this) {
        return function() {
          if (file.type === "image/svg+xml") {
            _this.emit("thumbnail", file, fileReader.result);
            if (callback != null) {
              callback();
            }
            return;
          }
          return _this.createThumbnailFromUrl(file, fileReader.result, callback);
        };
      })(this);
      return fileReader.readAsDataURL(file);
    };

    Dropzone.prototype.createThumbnailFromUrl = function(file, imageUrl, callback, crossOrigin) {
      var img;
      img = document.createElement("img");
      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }
      img.onload = (function(_this) {
        return function() {
          var canvas, ctx, resizeInfo, thumbnail, _ref, _ref1, _ref2, _ref3;
          file.width = img.width;
          file.height = img.height;
          resizeInfo = _this.options.resize.call(_this, file);
          if (resizeInfo.trgWidth == null) {
            resizeInfo.trgWidth = resizeInfo.optWidth;
          }
          if (resizeInfo.trgHeight == null) {
            resizeInfo.trgHeight = resizeInfo.optHeight;
          }
          canvas = document.createElement("canvas");
          ctx = canvas.getContext("2d");
          canvas.width = resizeInfo.trgWidth;
          canvas.height = resizeInfo.trgHeight;
          drawImageIOSFix(ctx, img, (_ref = resizeInfo.srcX) != null ? _ref : 0, (_ref1 = resizeInfo.srcY) != null ? _ref1 : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, (_ref2 = resizeInfo.trgX) != null ? _ref2 : 0, (_ref3 = resizeInfo.trgY) != null ? _ref3 : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
          thumbnail = canvas.toDataURL("image/png");
          _this.emit("thumbnail", file, thumbnail);
          if (callback != null) {
            return callback();
          }
        };
      })(this);
      if (callback != null) {
        img.onerror = callback;
      }
      return img.src = imageUrl;
    };

    Dropzone.prototype.processQueue = function() {
      var i, parallelUploads, processingLength, queuedFiles;
      parallelUploads = this.options.parallelUploads;
      processingLength = this.getUploadingFiles().length;
      i = processingLength;
      if (processingLength >= parallelUploads) {
        return;
      }
      queuedFiles = this.getQueuedFiles();
      if (!(queuedFiles.length > 0)) {
        return;
      }
      if (this.options.uploadMultiple) {
        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
      } else {
        while (i < parallelUploads) {
          if (!queuedFiles.length) {
            return;
          }
          this.processFile(queuedFiles.shift());
          i++;
        }
      }
    };

    Dropzone.prototype.processFile = function(file) {
      return this.processFiles([file]);
    };

    Dropzone.prototype.processFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.processing = true;
        file.status = Dropzone.UPLOADING;
        this.emit("processing", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("processingmultiple", files);
      }
      return this.uploadFiles(files);
    };

    Dropzone.prototype._getFilesWithXhr = function(xhr) {
      var file, files;
      return files = (function() {
        var _i, _len, _ref, _results;
        _ref = this.files;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          if (file.xhr === xhr) {
            _results.push(file);
          }
        }
        return _results;
      }).call(this);
    };

    Dropzone.prototype.cancelUpload = function(file) {
      var groupedFile, groupedFiles, _i, _j, _len, _len1, _ref;
      if (file.status === Dropzone.UPLOADING) {
        groupedFiles = this._getFilesWithXhr(file.xhr);
        for (_i = 0, _len = groupedFiles.length; _i < _len; _i++) {
          groupedFile = groupedFiles[_i];
          groupedFile.status = Dropzone.CANCELED;
        }
        file.xhr.abort();
        for (_j = 0, _len1 = groupedFiles.length; _j < _len1; _j++) {
          groupedFile = groupedFiles[_j];
          this.emit("canceled", groupedFile);
        }
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", groupedFiles);
        }
      } else if ((_ref = file.status) === Dropzone.ADDED || _ref === Dropzone.QUEUED) {
        file.status = Dropzone.CANCELED;
        this.emit("canceled", file);
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", [file]);
        }
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    resolveOption = function() {
      var args, option;
      option = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      if (typeof option === 'function') {
        return option.apply(this, args);
      }
      return option;
    };

    Dropzone.prototype.uploadFile = function(file) {
      return this.uploadFiles([file]);
    };

    Dropzone.prototype.uploadFiles = function(files) {
      var file, formData, handleError, headerName, headerValue, headers, i, input, inputName, inputType, key, method, option, progressObj, response, updateProgress, url, value, xhr, _i, _j, _k, _l, _len, _len1, _len2, _len3, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
      xhr = new XMLHttpRequest();
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.xhr = xhr;
      }
      method = resolveOption(this.options.method, files);
      url = resolveOption(this.options.url, files);
      xhr.open(method, url, true);
      xhr.withCredentials = !!this.options.withCredentials;
      response = null;
      handleError = (function(_this) {
        return function() {
          var _j, _len1, _results;
          _results = [];
          for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
            file = files[_j];
            _results.push(_this._errorProcessing(files, response || _this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr));
          }
          return _results;
        };
      })(this);
      updateProgress = (function(_this) {
        return function(e) {
          var allFilesFinished, progress, _j, _k, _l, _len1, _len2, _len3, _results;
          if (e != null) {
            progress = 100 * e.loaded / e.total;
            for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
              file = files[_j];
              file.upload = {
                progress: progress,
                total: e.total,
                bytesSent: e.loaded
              };
            }
          } else {
            allFilesFinished = true;
            progress = 100;
            for (_k = 0, _len2 = files.length; _k < _len2; _k++) {
              file = files[_k];
              if (!(file.upload.progress === 100 && file.upload.bytesSent === file.upload.total)) {
                allFilesFinished = false;
              }
              file.upload.progress = progress;
              file.upload.bytesSent = file.upload.total;
            }
            if (allFilesFinished) {
              return;
            }
          }
          _results = [];
          for (_l = 0, _len3 = files.length; _l < _len3; _l++) {
            file = files[_l];
            _results.push(_this.emit("uploadprogress", file, progress, file.upload.bytesSent));
          }
          return _results;
        };
      })(this);
      xhr.onload = (function(_this) {
        return function(e) {
          var _ref;
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          if (xhr.readyState !== 4) {
            return;
          }
          response = xhr.responseText;
          if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
            try {
              response = JSON.parse(response);
            } catch (_error) {
              e = _error;
              response = "Invalid JSON response from server.";
            }
          }
          updateProgress();
          if (!((200 <= (_ref = xhr.status) && _ref < 300))) {
            return handleError();
          } else {
            return _this._finished(files, response, e);
          }
        };
      })(this);
      xhr.onerror = (function(_this) {
        return function() {
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          return handleError();
        };
      })(this);
      progressObj = (_ref = xhr.upload) != null ? _ref : xhr;
      progressObj.onprogress = updateProgress;
      headers = {
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      };
      if (this.options.headers) {
        extend(headers, this.options.headers);
      }
      for (headerName in headers) {
        headerValue = headers[headerName];
        if (headerValue) {
          xhr.setRequestHeader(headerName, headerValue);
        }
      }
      formData = new FormData();
      if (this.options.params) {
        _ref1 = this.options.params;
        for (key in _ref1) {
          value = _ref1[key];
          formData.append(key, value);
        }
      }
      for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
        file = files[_j];
        this.emit("sending", file, xhr, formData);
      }
      if (this.options.uploadMultiple) {
        this.emit("sendingmultiple", files, xhr, formData);
      }
      if (this.element.tagName === "FORM") {
        _ref2 = this.element.querySelectorAll("input, textarea, select, button");
        for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
          input = _ref2[_k];
          inputName = input.getAttribute("name");
          inputType = input.getAttribute("type");
          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
            _ref3 = input.options;
            for (_l = 0, _len3 = _ref3.length; _l < _len3; _l++) {
              option = _ref3[_l];
              if (option.selected) {
                formData.append(inputName, option.value);
              }
            }
          } else if (!inputType || ((_ref4 = inputType.toLowerCase()) !== "checkbox" && _ref4 !== "radio") || input.checked) {
            formData.append(inputName, input.value);
          }
        }
      }
      for (i = _m = 0, _ref5 = files.length - 1; 0 <= _ref5 ? _m <= _ref5 : _m >= _ref5; i = 0 <= _ref5 ? ++_m : --_m) {
        formData.append(this._getParamName(i), files[i], this._renameFilename(files[i].name));
      }
      return this.submitRequest(xhr, formData, files);
    };

    Dropzone.prototype.submitRequest = function(xhr, formData, files) {
      return xhr.send(formData);
    };

    Dropzone.prototype._finished = function(files, responseText, e) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.SUCCESS;
        this.emit("success", file, responseText, e);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("successmultiple", files, responseText, e);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    Dropzone.prototype._errorProcessing = function(files, message, xhr) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.ERROR;
        this.emit("error", file, message, xhr);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("errormultiple", files, message, xhr);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    return Dropzone;

  })(Emitter);

  Dropzone.version = "4.3.0";

  Dropzone.options = {};

  Dropzone.optionsForElement = function(element) {
    if (element.getAttribute("id")) {
      return Dropzone.options[camelize(element.getAttribute("id"))];
    } else {
      return void 0;
    }
  };

  Dropzone.instances = [];

  Dropzone.forElement = function(element) {
    if (typeof element === "string") {
      element = document.querySelector(element);
    }
    if ((element != null ? element.dropzone : void 0) == null) {
      throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    }
    return element.dropzone;
  };

  Dropzone.autoDiscover = true;

  Dropzone.discover = function() {
    var checkElements, dropzone, dropzones, _i, _len, _results;
    if (document.querySelectorAll) {
      dropzones = document.querySelectorAll(".dropzone");
    } else {
      dropzones = [];
      checkElements = function(elements) {
        var el, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )dropzone($| )/.test(el.className)) {
            _results.push(dropzones.push(el));
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      };
      checkElements(document.getElementsByTagName("div"));
      checkElements(document.getElementsByTagName("form"));
    }
    _results = [];
    for (_i = 0, _len = dropzones.length; _i < _len; _i++) {
      dropzone = dropzones[_i];
      if (Dropzone.optionsForElement(dropzone) !== false) {
        _results.push(new Dropzone(dropzone));
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };

  Dropzone.blacklistedBrowsers = [/opera.*Macintosh.*version\/12/i];

  Dropzone.isBrowserSupported = function() {
    var capableBrowser, regex, _i, _len, _ref;
    capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
      if (!("classList" in document.createElement("a"))) {
        capableBrowser = false;
      } else {
        _ref = Dropzone.blacklistedBrowsers;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          regex = _ref[_i];
          if (regex.test(navigator.userAgent)) {
            capableBrowser = false;
            continue;
          }
        }
      }
    } else {
      capableBrowser = false;
    }
    return capableBrowser;
  };

  without = function(list, rejectedItem) {
    var item, _i, _len, _results;
    _results = [];
    for (_i = 0, _len = list.length; _i < _len; _i++) {
      item = list[_i];
      if (item !== rejectedItem) {
        _results.push(item);
      }
    }
    return _results;
  };

  camelize = function(str) {
    return str.replace(/[\-_](\w)/g, function(match) {
      return match.charAt(1).toUpperCase();
    });
  };

  Dropzone.createElement = function(string) {
    var div;
    div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
  };

  Dropzone.elementInside = function(element, container) {
    if (element === container) {
      return true;
    }
    while (element = element.parentNode) {
      if (element === container) {
        return true;
      }
    }
    return false;
  };

  Dropzone.getElement = function(el, name) {
    var element;
    if (typeof el === "string") {
      element = document.querySelector(el);
    } else if (el.nodeType != null) {
      element = el;
    }
    if (element == null) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
    }
    return element;
  };

  Dropzone.getElements = function(els, name) {
    var e, el, elements, _i, _j, _len, _len1, _ref;
    if (els instanceof Array) {
      elements = [];
      try {
        for (_i = 0, _len = els.length; _i < _len; _i++) {
          el = els[_i];
          elements.push(this.getElement(el, name));
        }
      } catch (_error) {
        e = _error;
        elements = null;
      }
    } else if (typeof els === "string") {
      elements = [];
      _ref = document.querySelectorAll(els);
      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
        el = _ref[_j];
        elements.push(el);
      }
    } else if (els.nodeType != null) {
      elements = [els];
    }
    if (!((elements != null) && elements.length)) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
    }
    return elements;
  };

  Dropzone.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) {
      return accepted();
    } else if (rejected != null) {
      return rejected();
    }
  };

  Dropzone.isValidFile = function(file, acceptedFiles) {
    var baseMimeType, mimeType, validType, _i, _len;
    if (!acceptedFiles) {
      return true;
    }
    acceptedFiles = acceptedFiles.split(",");
    mimeType = file.type;
    baseMimeType = mimeType.replace(/\/.*$/, "");
    for (_i = 0, _len = acceptedFiles.length; _i < _len; _i++) {
      validType = acceptedFiles[_i];
      validType = validType.trim();
      if (validType.charAt(0) === ".") {
        if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
          return true;
        }
      } else if (/\/\*$/.test(validType)) {
        if (baseMimeType === validType.replace(/\/.*$/, "")) {
          return true;
        }
      } else {
        if (mimeType === validType) {
          return true;
        }
      }
    }
    return false;
  };

  if (typeof jQuery !== "undefined" && jQuery !== null) {
    jQuery.fn.dropzone = function(options) {
      return this.each(function() {
        return new Dropzone(this, options);
      });
    };
  }

  if (typeof module !== "undefined" && module !== null) {
    module.exports = Dropzone;
  } else {
    window.Dropzone = Dropzone;
  }

  Dropzone.ADDED = "added";

  Dropzone.QUEUED = "queued";

  Dropzone.ACCEPTED = Dropzone.QUEUED;

  Dropzone.UPLOADING = "uploading";

  Dropzone.PROCESSING = Dropzone.UPLOADING;

  Dropzone.CANCELED = "canceled";

  Dropzone.ERROR = "error";

  Dropzone.SUCCESS = "success";


  /*
  
  Bugfix for iOS 6 and 7
  Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
  based on the work of https://github.com/stomita/ios-imagefile-megapixel
   */

  detectVerticalSquash = function(img) {
    var alpha, canvas, ctx, data, ey, ih, iw, py, ratio, sy;
    iw = img.naturalWidth;
    ih = img.naturalHeight;
    canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    data = ctx.getImageData(0, 0, 1, ih).data;
    sy = 0;
    ey = ih;
    py = ih;
    while (py > sy) {
      alpha = data[(py - 1) * 4 + 3];
      if (alpha === 0) {
        ey = py;
      } else {
        sy = py;
      }
      py = (ey + sy) >> 1;
    }
    ratio = py / ih;
    if (ratio === 0) {
      return 1;
    } else {
      return ratio;
    }
  };

  drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    var vertSquashRatio;
    vertSquashRatio = detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
  };


  /*
   * contentloaded.js
   *
   * Author: Diego Perini (diego.perini at gmail.com)
   * Summary: cross-browser wrapper for DOMContentLoaded
   * Updated: 20101020
   * License: MIT
   * Version: 1.2
   *
   * URL:
   * http://javascript.nwbox.com/ContentLoaded/
   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
   */

  contentLoaded = function(win, fn) {
    var add, doc, done, init, poll, pre, rem, root, top;
    done = false;
    top = true;
    doc = win.document;
    root = doc.documentElement;
    add = (doc.addEventListener ? "addEventListener" : "attachEvent");
    rem = (doc.addEventListener ? "removeEventListener" : "detachEvent");
    pre = (doc.addEventListener ? "" : "on");
    init = function(e) {
      if (e.type === "readystatechange" && doc.readyState !== "complete") {
        return;
      }
      (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
      if (!done && (done = true)) {
        return fn.call(win, e.type || e);
      }
    };
    poll = function() {
      var e;
      try {
        root.doScroll("left");
      } catch (_error) {
        e = _error;
        setTimeout(poll, 50);
        return;
      }
      return init("poll");
    };
    if (doc.readyState !== "complete") {
      if (doc.createEventObject && root.doScroll) {
        try {
          top = !win.frameElement;
        } catch (_error) {}
        if (top) {
          poll();
        }
      }
      doc[add](pre + "DOMContentLoaded", init, false);
      doc[add](pre + "readystatechange", init, false);
      return win[add](pre + "load", init, false);
    }
  };

  Dropzone._autoDiscoverFunction = function() {
    if (Dropzone.autoDiscover) {
      return Dropzone.discover();
    }
  };

  contentLoaded(window, Dropzone._autoDiscoverFunction);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(236)(module)))

/***/ }),
/* 3134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileError = function FileError(props) {
  var showDialog = props.showDialog,
      title = props.title,
      confirmButtonFunc = props.confirmButtonFunc,
      topText = props.topText,
      problemFiles = props.problemFiles,
      subtext = props.subtext;


  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      title: title,
      actions: _react2.default.createElement(_materialUi.FlatButton, {
        label: 'OK',
        secondary: true,
        onTouchTap: confirmButtonFunc
      }),
      modal: true,
      open: showDialog
    },
    _react2.default.createElement(
      'div',
      null,
      topText,
      problemFiles.map(function (file, index) {
        return _react2.default.createElement(
          'div',
          { key: index, style: { textIndent: '20px' } },
          _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-fiber_manual_record2',
            style: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '8px', marginRight: '5px', verticalAlign: 'middle' }
          }),
          file.name,
          ' - ',
          Math.round(file.size / 1000),
          'KB'
        );
      }),
      subtext
    )
  );
};

FileError.propTypes = {
  showDialog: _react.PropTypes.bool,
  title: _react.PropTypes.string,
  confirmButtonFunc: _react.PropTypes.func,
  topText: _react.PropTypes.object,
  problemFiles: _react.PropTypes.array,
  subtext: _react.PropTypes.object
};

exports.default = FileError;

/***/ }),
/* 3135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _dragDropFiles = __webpack_require__(3136);

var _dragDropFiles2 = _interopRequireDefault(_dragDropFiles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DragDropContainer = function (_Component) {
  _inherits(DragDropContainer, _Component);

  function DragDropContainer() {
    _classCallCheck(this, DragDropContainer);

    return _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).apply(this, arguments));
  }

  _createClass(DragDropContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isEditable = _props.isEditable,
          updateMMProp = _props.updateMMProp,
          updateMM = _props.updateMM,
          MMReducer = _props.MMReducer,
          downloadSingleFile = _props.downloadSingleFile,
          containerStateForViewers = _props.containerStateForViewers,
          updateStateForViewers = _props.updateStateForViewers,
          forLocationOrProductPages = _props.forLocationOrProductPages,
          findPhotosForTag = _props.findPhotosForTag;


      var filesArray = function () {
        if (isEditable) {
          if ((0, _ramda.path)(['filteredMedia', 'length'], MMReducer)) return MMReducer.filteredMedia;else if (forLocationOrProductPages) return findPhotosForTag || [];
          return MMReducer.media || [];
        }
        if (!isEditable) {
          if ((0, _ramda.path)(['filteredMedia', 'length'], containerStateForViewers)) return containerStateForViewers.filteredMedia;else if (forLocationOrProductPages) return findPhotosForTag || [];
          return MMReducer.media;
        }
      }();

      var selectedFiles = function selectedFiles() {
        if (isEditable) return MMReducer.selectedFiles;
        return (0, _ramda.propOr)([], 'selectedFiles', containerStateForViewers);
      };

      var addFileForIsEditable = function addFileForIsEditable(file) {
        (0, _ramda.propOr)([], 'selectedFiles', MMReducer).push(file);
        updateMMProp({ selectedFiles: MMReducer.selectedFiles });
      };

      var addFileForViewers = function addFileForViewers(file) {
        var updatedSelectedList = (0, _ramda.propOr)([], 'selectedFiles', containerStateForViewers);
        updatedSelectedList.push(file);
        updateStateForViewers('selectedFiles', updatedSelectedList);
      };

      return _react2.default.createElement(_dragDropFiles2.default, {
        isEditable: isEditable,
        forLocationOrProductPages: forLocationOrProductPages,
        deleteFileFunc: function deleteFileFunc(removedFile, fileToRemove) {
          var removedSelectedFile = forLocationOrProductPages ? MMReducer.media.filter(function (file) {
            return file.url !== fileToRemove.url;
          }) : removedFile || [];
          updateMMProp({
            savingMedia: true,
            media: removedSelectedFile || [],
            selectedFiles: (0, _ramda.without)([fileToRemove], (0, _ramda.propOr)([], 'selectedFiles', MMReducer).map(function (file) {
              return (0, _ramda.omit)(['index'], file);
            }))
          });
          updateMM({
            updateField: 'media',
            updateBody: removedSelectedFile || []
          });
        },
        downloadOneFile: function downloadOneFile(file) {
          return downloadSingleFile([file]);
        },
        filesArray: filesArray,
        dragEndsFunc: function dragEndsFunc(updatedFileArrangement) {
          updateMMProp({ savingMedia: true });
          updateMM({
            updateField: 'media',
            updateBody: updatedFileArrangement
          });
        },
        cardStyle: { display: 'inline-block' },
        isUpdating: MMReducer.savingMedia,
        selectedFiles: selectedFiles(),
        onThumbnailSelect: function onThumbnailSelect(file) {
          if (isEditable) addFileForIsEditable(file);else addFileForViewers(file);
        },
        onThumbnailUnselect: function onThumbnailUnselect(updatedList) {
          if (isEditable) updateMMProp({ selectedFiles: updatedList });else {
            updateStateForViewers('selectedFiles', updatedList);
          }
        },
        onPreviewClick: function onPreviewClick(file, index) {
          if (isEditable) {
            if (!(0, _ramda.contains)(file.url, (0, _ramda.propOr)([], 'selectedFiles', MMReducer).map(function (selectedFile) {
              return selectedFile.url;
            }))) addFileForIsEditable(file);
            updateMMProp({
              previewDialog: true,
              selectedFileIndex: index
            });
          } else {
            if (!(0, _ramda.contains)(file.url, (0, _ramda.propOr)([], 'selectedFiles', containerStateForViewers).map(function (selectedFile) {
              return selectedFile.url;
            }))) addFileForViewers(file);
            updateStateForViewers('previewDialog', true);
            updateStateForViewers('selectedFileIndex', index);
          }
        },
        openPreview: isEditable ? MMReducer.previewDialog : (0, _ramda.propOr)(false, 'previewDialog', containerStateForViewers),
        closePreview: function closePreview() {
          if (isEditable) updateMMProp({ previewDialog: false });else {
            updateStateForViewers('previewDialog', false);
          }
        },
        updateUserHovering: function updateUserHovering(hovering) {
          if (isEditable) updateMMProp({ hovering: hovering });else {
            updateStateForViewers('hovering', hovering);
          }
        },
        isUserHovering: isEditable ? MMReducer.hovering : (0, _ramda.propOr)(false, 'hovering', containerStateForViewers),
        updateFileName: function updateFileName(updatedMediaList, updatedFile) {
          var updateForLocOrProductPage = updatedMediaList ? updatedMediaList : MMReducer.media.map(function (obj) {
            if ((0, _ramda.equals)(obj.url, updatedFile.url)) return (0, _ramda.merge)(obj, { name: updatedFile.name });
            return obj;
          });
          var selectedFilesUpdate = MMReducer.selectedFiles.map(function (file) {
            if (updatedFile && (0, _ramda.equals)(file.url, updatedFile.url)) return (0, _ramda.merge)(file, { name: updatedFile.name });
            return file;
          });
          updateMMProp({
            savingMedia: true,
            media: updateForLocOrProductPage,
            selectedFiles: selectedFilesUpdate
          });
          updateMM({
            updateField: 'media',
            updateBody: updateForLocOrProductPage
          });
        },
        uploadingFile: MMReducer.uploadingFile,
        indexToOpen: isEditable ? MMReducer.selectedFileIndex : containerStateForViewers.selectedFileIndex,
        changeFileIndex: isEditable ? function (newIndex) {
          return updateMMProp({ selectedFileIndex: newIndex });
        } : function (newIndex) {
          return updateStateForViewers('selectedFileIndex', newIndex);
        },
        removeIndividualTag: function removeIndividualTag(tagIdToRemove) {
          var fileIndexThatIsOpened = MMReducer.selectedFileIndex;
          var fileUrl = (0, _ramda.path)([fileIndexThatIsOpened, 'url'], filesArray);
          var removedTag = (0, _ramda.without)([tagIdToRemove], (0, _ramda.path)([fileIndexThatIsOpened, 'tags'], filesArray));
          var mediaClone = MMReducer.media.map(function (file) {
            if (file.url === fileUrl) {
              return _extends({}, file, { tags: removedTag });
            }
            return file;
          });
          updateMM({
            updateField: 'media',
            updateBody: mediaClone
          });
          updateMMProp({
            media: mediaClone
          });
        }
      });
    }
  }]);

  return DragDropContainer;
}(_react.Component);

DragDropContainer.propTypes = {
  isEditable: _react.PropTypes.bool,
  updateMMProp: _react.PropTypes.func,
  updateMM: _react.PropTypes.func,
  MMReducer: _react.PropTypes.object,
  downloadSingleFile: _react.PropTypes.func,
  containerStateForViewers: _react.PropTypes.object,
  updateStateForViewers: _react.PropTypes.func,
  forLocationOrProductPages: _react.PropTypes.bool,
  findPhotosForTag: _react.PropTypes.array
};

var mapStateToProps = function mapStateToProps(_ref) {
  var marketingMaterials = _ref.marketingMaterials;
  return {
    MMReducer: marketingMaterials.mainReducer.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DragDropContainer);

/***/ }),
/* 3136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _pagination = __webpack_require__(870);

var _pagination2 = _interopRequireDefault(_pagination);

var _generatePreview = __webpack_require__(1947);

var _generatePreview2 = _interopRequireDefault(_generatePreview);

var _mediaFileDialog = __webpack_require__(3141);

var _mediaFileDialog2 = _interopRequireDefault(_mediaFileDialog);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import SortableList from '../../tc-ui/sortable-list-with-react-dnd/sortable-list';
// import DraggableCard from '../../tc-ui/sortable-list-with-react-dnd/draggable-card';


var DragDropFiles = function (_Component) {
  _inherits(DragDropFiles, _Component);

  function DragDropFiles() {
    _classCallCheck(this, DragDropFiles);

    var _this = _possibleConstructorReturn(this, (DragDropFiles.__proto__ || Object.getPrototypeOf(DragDropFiles)).call(this));

    _this.goToPage = function (page) {
      return _this.setState({ page: page });
    };

    _this.state = { page: 1 };
    return _this;
  }

  _createClass(DragDropFiles, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          filesArray = _props.filesArray,
          isEditable = _props.isEditable,
          deleteFileFunc = _props.deleteFileFunc,
          dragEndsFunc = _props.dragEndsFunc,
          cardStyle = _props.cardStyle,
          isUpdating = _props.isUpdating,
          onThumbnailSelect = _props.onThumbnailSelect,
          onThumbnailUnselect = _props.onThumbnailUnselect,
          selectedFiles = _props.selectedFiles,
          _onPreviewClick = _props.onPreviewClick,
          openPreview = _props.openPreview,
          closePreview = _props.closePreview,
          updateUserHovering = _props.updateUserHovering,
          isUserHovering = _props.isUserHovering,
          updateFileName = _props.updateFileName,
          downloadOneFile = _props.downloadOneFile,
          uploadingFile = _props.uploadingFile,
          indexToOpen = _props.indexToOpen,
          changeFileIndex = _props.changeFileIndex,
          forLocationOrProductPages = _props.forLocationOrProductPages,
          removeIndividualTag = _props.removeIndividualTag;

      var page = Math.min(Math.ceil(filesArray.length / 5), this.state.page);
      var showPagination = filesArray.length > 5;
      var getFileName = function getFileName(fileName) {
        if (isEditable) {
          return _react2.default.createElement(
            'div',
            {
              style: {
                position: 'absolute',
                backgroundColor: 'rgba(138,138,138,.5)',
                color: '#ffffff',
                display: 'block',
                bottom: '16px',
                marginLeft: '16px',
                width: '128px',
                // cursor: 'move',
                cursor: 'default',
                textAlign: 'center',
                maxHeight: '23px',
                overflowX: 'hidden',
                textOverflow: 'ellipsis',
                overflowY: 'hidden'
              }
            },
            _react2.default.createElement(
              'span',
              null,
              fileName
            )
          );
        }
      };

      // UNDOING DRAG AND DROP FOR NOW
      // const dragDrop = () => {
      //   return (
      //     <SortableList
      //       arrayOfData={filesArray}
      //       dragEnds={(updatedArrangement) => dragEndsFunc(updatedArrangement)}
      //       cardStyle={cardStyle}
      //     >
      //       {
      //         filesArray.map((file, index) => {
      //           const photoClass = (file === true || isUpdating && index === filesArray.length - 1) ?
      //             'image-loading-indicater black-border' : '';
      //           const arrayOfSelectedUrls = selectedFiles.map(obj => obj.url);
      //           return (
      //             <DraggableCard
      //               style={{ position: 'relative', display: 'inline-block' }}
      //               key={index}
      //               isDragSource={isEditable}
      //               isDropTarget={isEditable}
      //             >
      //               <Paper
      //                 zDepth={1}
      //                 style={{
      //                   width: '128px',
      //                   display: 'inline-block',
      //                   margin: '16px',
      //                   cursor: 'pointer',
      //                 }}
      //               >
      //                 <div key={index} style={{ height: '100%', position: 'relative' }}>
      //                   <div
      //                     style={{
      //                       width: '128px',
      //                       height: '128px',
      //                       lineHeight: '128px',
      //                       position: 'relative',
      //                       color: 'white',
      //                       backgroundColor: '#f5f5f5',
      //                       textAlign: 'center',
      //                     }}
      //                     className={photoClass}
      //                   >
      //                     <GeneratePreview
      //                       index={index}
      //                       file={file}
      //                       hoverEffect
      //                       onThumbnailSelect={ifElse(
      //                         () => contains(file.url, arrayOfSelectedUrls),
      //                           () => onThumbnailUnselect(selectedFiles.filter(object => object.url !== file.url)),
      //                         (clickedFile) => onThumbnailSelect(clickedFile)
      //                       )}
      //                       selectedBorderStyle={{ outline: '2px solid #00bcd4' }}
      //                       isSelected={contains(file.url, arrayOfSelectedUrls)}
      //                       onPreviewClick={() => onPreviewClick(file, index)}
      //                       updateUserHovering={updateUserHovering}
      //                       isUserHovering={isUserHovering}
      //                       showVideoControls={false}
      //                       isUploadingFile={uploadingFile}
      //                     />
      //                   </div>
      //                 </div>
      //               </Paper>
      //               {getFileName(file.name)}
      //             </DraggableCard>
      //           );
      //         })
      //       }
      //     </SortableList>
      //   );
      // };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center' } },
          filesArray.slice((page - 1) * 5, page * 5).map(function (file, i) {
            var index = i + (page - 1) * 5;
            var photoClass = file === true || isUpdating && index === filesArray.length - 1 ? 'image-loading-indicater black-border' : '';
            var arrayOfSelectedUrls = selectedFiles.map(function (obj) {
              return obj.url;
            });
            return _react2.default.createElement(
              'div',
              { style: { position: 'relative', display: 'inline-block' }, key: index },
              _react2.default.createElement(
                _materialUi.Paper,
                {
                  zDepth: 1,
                  style: {
                    width: '128px',
                    display: 'inline-block',
                    margin: '16px',
                    cursor: 'pointer'
                  }
                },
                _react2.default.createElement(
                  'div',
                  { style: { height: '100%', position: 'relative' } },
                  _react2.default.createElement(
                    'div',
                    {
                      style: {
                        width: '128px',
                        height: '128px',
                        lineHeight: '128px',
                        position: 'relative',
                        color: 'white',
                        backgroundColor: '#f5f5f5',
                        textAlign: 'center'
                      },
                      className: photoClass
                    },
                    _react2.default.createElement(_generatePreview2.default, {
                      index: index,
                      file: file,
                      hoverEffect: true,
                      onThumbnailSelect: (0, _ramda.ifElse)(function () {
                        return (0, _ramda.contains)(file.url, arrayOfSelectedUrls);
                      }, function () {
                        return onThumbnailUnselect(selectedFiles.filter(function (object) {
                          return object.url !== file.url;
                        }));
                      }, function (clickedFile) {
                        return onThumbnailSelect(clickedFile);
                      }),
                      selectedBorderStyle: { outline: '2px solid #00bcd4' },
                      isSelected: (0, _ramda.contains)(file.url, arrayOfSelectedUrls),
                      onPreviewClick: function onPreviewClick() {
                        return _onPreviewClick(file, index);
                      },
                      updateUserHovering: updateUserHovering,
                      isUserHovering: isUserHovering,
                      showVideoControls: false,
                      isUploadingFile: uploadingFile
                    })
                  )
                )
              ),
              getFileName(file.name)
            );
          })
        ),
        showPagination && _react2.default.createElement(_pagination2.default, {
          currentPage: page,
          totalPages: Math.ceil(filesArray.length / 5),
          goToPage: this.goToPage,
          noOfPagesToShow: 5
        }),
        _react2.default.createElement(
          'div',
          null,
          openPreview && selectedFiles.length > 0 ? _react2.default.createElement(_mediaFileDialog2.default, {
            closePreview: closePreview,
            previewFiles: filesArray,
            open: openPreview,
            isEditable: isEditable,
            downloadOneFile: downloadOneFile,
            deleteFileFunc: deleteFileFunc,
            editFileNameFunc: function editFileNameFunc(updatedFile) {
              if (forLocationOrProductPages) {
                updateFileName(undefined, updatedFile);
              } else {
                filesArray[indexToOpen] = updatedFile;
                updateFileName(filesArray, updatedFile);
              }
            },
            indexToOpen: indexToOpen,
            changeFileIndex: changeFileIndex,
            forLocationOrProductPages: forLocationOrProductPages,
            removeIndividualTag: removeIndividualTag
          }) : _react2.default.createElement('span', null)
        )
      );
    }
  }]);

  return DragDropFiles;
}(_react.Component);

DragDropFiles.propTypes = {
  filesArray: _react.PropTypes.array,
  isEditable: _react.PropTypes.bool,
  deleteFileFunc: _react.PropTypes.func,
  dragEndsFunc: _react.PropTypes.func,
  cardStyle: _react.PropTypes.object,
  isUpdating: _react.PropTypes.bool,
  onThumbnailSelect: _react.PropTypes.func,
  selectedFiles: _react.PropTypes.array,
  onThumbnailUnselect: _react.PropTypes.func,
  onPreviewClick: _react.PropTypes.func,
  openPreview: _react.PropTypes.bool,
  closePreview: _react.PropTypes.func,
  updateUserHovering: _react.PropTypes.func,
  isUserHovering: _react.PropTypes.bool,
  updateFileName: _react.PropTypes.func,
  downloadOneFile: _react.PropTypes.func,
  uploadingFile: _react.PropTypes.bool,
  indexToOpen: _react.PropTypes.number,
  changeFileIndex: _react.PropTypes.func,
  forLocationOrProductPages: _react.PropTypes.bool,
  removeIndividualTag: _react.PropTypes.func
};

exports.default = DragDropFiles;

/***/ }),
/* 3137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c989b19edb9be7742d423d7d236f3f0d.png";

/***/ }),
/* 3138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "08ebe085ba37826b13fa7feaf4f3b0e6.png";

/***/ }),
/* 3139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3a091b8b0af2225155c70e0915e1a0c5.png";

/***/ }),
/* 3140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3ea0389dfabb5b09e956f1c1d73fb4d2.png";

/***/ }),
/* 3141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _saveCancelButtons = __webpack_require__(1948);

var _saveCancelButtons2 = _interopRequireDefault(_saveCancelButtons);

var _generatePreview = __webpack_require__(1947);

var _generatePreview2 = _interopRequireDefault(_generatePreview);

var _bowser = __webpack_require__(1001);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);
var isNotNilOrEmpty = (0, _ramda.complement)(isNilOrEmpty);

var MediaFileDialog = function (_Component) {
  _inherits(MediaFileDialog, _Component);

  function MediaFileDialog(props) {
    _classCallCheck(this, MediaFileDialog);

    var _this = _possibleConstructorReturn(this, (MediaFileDialog.__proto__ || Object.getPrototypeOf(MediaFileDialog)).call(this, props));

    _this.getOneImage = function (propToGet) {
      return (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('url'), function () {
        return _react2.default.createElement(
          'div',
          { style: { textAlign: 'center', maxHeight: '100%', maxWidth: '100%' } },
          _react2.default.createElement(_generatePreview2.default, {
            inDialog: true,
            file: _this.props.previewFiles[_this.props.indexToOpen],
            hoverEffect: false,
            showVideoControls: true,
            minHeight: '70px',
            maxHeight: '700px',
            downloadOneFile: function downloadOneFile() {
              return _this.props.downloadOneFile({
                url: _this.props.previewFiles[_this.props.indexToOpen].url,
                fileName: _this.props.previewFiles[_this.props.indexToOpen].name,
                fileType: _this.props.previewFiles[_this.props.indexToOpen].mediaType
              });
            }
          })
        );
      }], [(0, _ramda.equals)('urlLink'), (0, _ramda.always)((0, _ramda.path)([_this.props.indexToOpen, 'url'], _this.props.previewFiles))], [(0, _ramda.equals)('fileName'), (0, _ramda.always)((0, _ramda.path)([_this.props.indexToOpen, 'name'], _this.props.previewFiles))], [(0, _ramda.equals)('index'), (0, _ramda.always)((0, _ramda.path)([_this.props.indexToOpen, 'index'], _this.props.previewFiles))], [(0, _ramda.equals)('fileType'), (0, _ramda.always)((0, _ramda.path)([_this.props.indexToOpen, 'mediaType'], _this.props.previewFiles))], [(0, _ramda.equals)('storageProvider'), (0, _ramda.always)((0, _ramda.path)([_this.props.indexToOpen, 'storageProvider'], _this.props.previewFiles))], [(0, _ramda.equals)('username'), (0, _ramda.always)((0, _ramda.path)([_this.props.indexToOpen, 'username'], _this.props.previewFiles))], [(0, _ramda.equals)('password'), (0, _ramda.always)((0, _ramda.path)([_this.props.indexToOpen, 'password'], _this.props.previewFiles))], [(0, _ramda.equals)('tagNames'), function () {
        var tagIds = _ramda2.default.pathOr([], [_this.props.indexToOpen, 'tags'], _this.props.previewFiles).filter(function (item) {
          return isNotNilOrEmpty(item);
        });
        var findTagName = tagIds.map(function (eachId) {
          var tagName = _this.props.MMReducer.productTags.concat(_this.props.MMReducer.locationTags).filter(function (obj) {
            return obj.id === eachId;
          });
          if (isNotNilOrEmpty(tagName)) return _ramda2.default.pluck('name')(tagName);
        });
        return findTagName.filter(function (item) {
          return isNotNilOrEmpty(item);
        });
      }], [_ramda.T, (0, _ramda.always)(_react2.default.createElement('span', null))]]), propToGet);
    };

    _this.checkForCredentialsForCloudDrive = function () {
      return isNotNilOrEmpty(_this.getOneImage('username')) || isNotNilOrEmpty(_this.getOneImage('password'));
    };

    _this.state = {
      numberOfSelectedFiles: _this.props.previewFiles.length - 1,
      isEditingFileName: false,
      showCredentialsForCloudDrive: false
    };
    return _this;
  }

  _createClass(MediaFileDialog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          previewFiles = _props.previewFiles,
          deleteFileFunc = _props.deleteFileFunc,
          closePreview = _props.closePreview,
          downloadOneFile = _props.downloadOneFile,
          editFileNameFunc = _props.editFileNameFunc,
          isEditable = _props.isEditable,
          changeFileIndex = _props.changeFileIndex,
          indexToOpen = _props.indexToOpen,
          forLocationOrProductPages = _props.forLocationOrProductPages,
          removeIndividualTag = _props.removeIndividualTag;

      var clearEditingState = function clearEditingState() {
        return _this2.setState({
          updatedFileName: undefined,
          isEditingFileName: false
        });
      };

      var onArrowClick = function onArrowClick(newIndex) {
        clearEditingState();
        changeFileIndex(newIndex);
      };

      var deleteFile = function deleteFile() {
        if ((0, _ramda.equals)(previewFiles.length, 1)) {
          deleteFileFunc([], previewFiles[0]);
          closePreview();
        } else {
          var removedFile = _ramda2.default.remove(indexToOpen, 1, previewFiles);
          deleteFileFunc(removedFile, previewFiles[indexToOpen]);
          _this2.setState({ numberOfSelectedFiles: (0, _ramda.dec)(_this2.state.numberOfSelectedFiles) });
          onArrowClick((0, _ramda.dec)(indexToOpen) < 0 ? 0 : (0, _ramda.dec)(indexToOpen));
        }
      };

      var deleteAndDownloadButtons = function deleteAndDownloadButtons() {
        return _react2.default.createElement(
          'span',
          { className: 'Grid-cell Grid--1of3', style: { textAlign: 'right' } },
          isEditable ? _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-delete2',
            style: { color: '#ff4081', marginRight: '10px', cursor: 'pointer', fontSize: '32px' },
            onClick: function onClick() {
              return deleteFile();
            }
          }) : _react2.default.createElement('span', null),
          (0, _ramda.equals)(_this2.getOneImage('fileType'), 'CloudDrive') ? _react2.default.createElement('span', null) : _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-get_app',
            style: { color: '#00bcd4', marginRight: '10px', cursor: 'pointer', fontSize: '32px' },
            onClick: function onClick() {
              return downloadOneFile({
                url: previewFiles[indexToOpen].url,
                fileName: previewFiles[indexToOpen].name,
                fileType: previewFiles[indexToOpen].mediaType
              });
            }
          })
        );
      };

      var saveCancelButtons = function saveCancelButtons() {
        return _react2.default.createElement(_saveCancelButtons2.default, {
          objectInfoToMap: [{
            labelText: 'Cancel',
            labelStyle: { color: 'rgba(0, 0, 0, 0.54)' },
            style: { borderRadius: '3px', marginRight: '20px' },
            onTouchTap: clearEditingState
          }, {
            labelText: 'Save',
            style: { borderRadius: '3px' },
            onTouchTap: function onTouchTap() {
              var updateEditedFile = (0, _ramda.merge)(previewFiles[indexToOpen], {
                name: _this2.state.updatedFileName
              });
              clearEditingState();
              editFileNameFunc(updateEditedFile);
            },
            disableSave: (0, _ramda.equals)(_this2.state.updatedFileName, previewFiles[indexToOpen].name)
          }]
        });
      };

      var editingFileName = function editingFileName() {
        var fileName = _this2.state.updatedFileName || _this2.getOneImage('fileName');
        var index = fileName.lastIndexOf('.');
        var fileExtension = _this2.getOneImage('fileName').slice(_this2.getOneImage('fileName').lastIndexOf('.') + 1);
        var isCloudDrive = (0, _ramda.equals)(_this2.getOneImage('fileType'), 'CloudDrive');
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_materialUi.TextField, {
            inputStyle: { fontSize: '18px', whiteSpace: 'pre-wrap', padding: '0px 3px', color: 'white' },
            underlineShow: true,
            rowsMax: 1,
            value: isCloudDrive || index < 0 ? fileName : fileName.slice(0, index),
            onChange: function onChange(_ref) {
              var value = _ref.target.value;
              return _this2.setState({ updatedFileName: '' + (isCloudDrive || index < 0 ? value : value + '.' + fileExtension) });
            }
          }),
          saveCancelButtons()
        );
      };

      var actions = _react2.default.createElement(
        'div',
        { className: 'Grid', style: { color: 'white', fontWeight: '400', fontSize: '20px', marginTop: '16px' } },
        _react2.default.createElement('span', {
          className: (0, _ramda.equals)(_bowser.browser.name, 'Internet Explorer') ? '' : 'Grid-cell Grid--1of3',
          style: { width: (0, _ramda.equals)(_bowser.browser.name, 'Internet Explorer') ? '33%' : '' }
        }),
        _react2.default.createElement(
          'div',
          {
            className: (0, _ramda.equals)(_bowser.browser.name, 'Internet Explorer') ? '' : 'Grid-cell Grid--1of3',
            style: { textAlign: 'center', width: (0, _ramda.equals)(_bowser.browser.name, 'Internet Explorer') ? '33%' : '' }
          },
          _react2.default.createElement(
            'div',
            null,
            this.state.isEditingFileName ? editingFileName() : _react2.default.createElement(
              'div',
              { className: 'Grid--center', style: { overflow: (0, _ramda.equals)(_bowser.browser.name, 'Internet Explorer') ? 'hidden' : '', alignItems: 'center', display: 'flex', justifyContent: 'center' } },
              (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('CloudDrive'), (0, _ramda.always)(_react2.default.createElement(
                'a',
                { href: this.getOneImage('urlLink'), style: { color: '#ff4081' }, target: '_blank' },
                this.getOneImage('fileName')
              ))], [(0, _ramda.complement)((0, _ramda.equals)('CloudDrive')), (0, _ramda.always)(this.getOneImage('fileName'))]]), this.getOneImage('fileType')),
              _react2.default.createElement(
                'div',
                { className: 'edit-button hint--top', 'aria-label': 'Edit name', style: { marginLeft: '0px' } },
                !this.state.isEditingFileName ? _react2.default.createElement(_materialUi.FontIcon, {
                  className: 'tc-icon-mode_edit',
                  style: { fontSize: '24px', color: '#00bcd4', margin: (0, _ramda.equals)(_bowser.browser.name, 'Internet Explorer') ? '5px 0 0 10px' : '5px 0 0 20px' },
                  onClick: function onClick() {
                    return _this2.setState({
                      isEditingFileName: true,
                      updatedFileName: _this2.getOneImage('fileName')
                    });
                  }
                }) : _react2.default.createElement('span', null)
              )
            ),
            this.checkForCredentialsForCloudDrive() ? _react2.default.createElement(
              'div',
              { style: { display: 'inline-block', margin: '10px 0px' } },
              this.state.showCredentialsForCloudDrive ? _react2.default.createElement(
                'div',
                null,
                isNotNilOrEmpty(this.getOneImage('username')) ? _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'Username:'
                  ),
                  ' ',
                  this.getOneImage('username')
                ) : _react2.default.createElement('span', null),
                _react2.default.createElement('br', null),
                isNotNilOrEmpty(this.getOneImage('password')) ? _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'Password:'
                  ),
                  ' ',
                  this.getOneImage('password')
                ) : _react2.default.createElement('span', null)
              ) : _react2.default.createElement(
                'div',
                {
                  onClick: function onClick() {
                    return _this2.setState({ showCredentialsForCloudDrive: true });
                  },
                  style: { cursor: 'pointer', display: 'inline-block' }
                },
                _react2.default.createElement(
                  'b',
                  null,
                  'Show Credentials'
                )
              )
            ) : _react2.default.createElement('span', null)
          )
        ),
        _react2.default.createElement(
          'span',
          { className: (0, _ramda.equals)(_bowser.browser.name, 'Internet Explorer') ? '' : 'Grid-cell Grid--1of3', style: { width: (0, _ramda.equals)(_bowser.browser.name, 'Internet Explorer') ? '33%' : '' } },
          deleteAndDownloadButtons()
        )
      );

      var closePreviewIcon = _react2.default.createElement(
        'div',
        { style: { textAlign: 'right' } },
        _react2.default.createElement(_materialUi.FontIcon, {
          className: 'tc-icon-close22',
          style: { color: 'white', marginRight: '48px', cursor: 'pointer', fontSize: '50px' },
          onClick: function onClick() {
            return closePreview();
          }
        })
      );

      var imageGalleryPreview = function imageGalleryPreview() {
        var showArrows = previewFiles.length > 1;
        var arrowStyle = { fontSize: '50px', cursor: 'pointer', color: 'white' };
        return _react2.default.createElement(
          'div',
          { className: 'Grid', style: { height: '100%' } },
          _react2.default.createElement(
            'span',
            { className: 'Grid-cell Grid--1of4 Grid-cell--center' },
            showArrows ? _react2.default.createElement(_materialUi.FontIcon, {
              className: 'tc-icon-keyboard_arrow_left',
              style: arrowStyle,
              onClick: function onClick() {
                _this2.setState({ showCredentialsForCloudDrive: false });
                onArrowClick((0, _ramda.equals)(indexToOpen, 0) ? _this2.state.numberOfSelectedFiles : (0, _ramda.dec)(indexToOpen));
              }
            }) : _react2.default.createElement('span', null)
          ),
          _react2.default.createElement(
            'span',
            { className: 'Grid-cell Grid--1of2', style: { textAlign: 'center', flex: '0 0 80%' } },
            _this2.getOneImage('url')
          ),
          _react2.default.createElement(
            'span',
            { className: 'Grid-cell Grid--1of4 Grid-cell--center' },
            showArrows ? _react2.default.createElement(_materialUi.FontIcon, {
              className: 'tc-icon-keyboard_arrow_right',
              style: arrowStyle,
              onClick: function onClick() {
                _this2.setState({ showCredentialsForCloudDrive: false });
                onArrowClick((0, _ramda.equals)(indexToOpen, _this2.state.numberOfSelectedFiles) ? 0 : (0, _ramda.inc)(indexToOpen));
              }
            }) : _react2.default.createElement('span', null)
          )
        );
      };

      return _react2.default.createElement(
        'div',
        {
          style: {
            height: '100%',
            width: '100%',
            position: 'fixed',
            zIndex: 1,
            top: 0,
            left: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            overflowX: 'hidden',
            transition: '0.5s',
            textAlign: 'center',
            paddingTop: '80px'
          }
        },
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' } },
          closePreviewIcon,
          _react2.default.createElement(
            'div',
            null,
            imageGalleryPreview()
          ),
          _react2.default.createElement('div', { style: { height: '150px' } })
        ),
        _react2.default.createElement(
          'div',
          { style: { position: 'absolute', bottom: 0, width: '100%', padding: '24px 0', backgroundColor: 'rgba(0, 0, 0, 0.6)' } },
          _react2.default.createElement(
            'div',
            { style: { color: 'white', padding: '0 3%', alignItems: 'center', display: 'flex', justifyContent: 'center' } },
            _react2.default.createElement(
              'span',
              { style: { fontSize: '18px' } },
              Boolean(this.getOneImage('tagNames').length) && 'Tags:'
            ),
            this.getOneImage('tagNames').map(function (tag, i) {
              return _react2.default.createElement(
                'div',
                { key: i },
                isEditable ? _react2.default.createElement(
                  _materialUi.Chip,
                  {
                    style: { margin: '5px', display: 'inline-block' },
                    backgroundColor: 'rgb(0, 188, 212)',
                    labelColor: '#ffffff',
                    labelStyle: { verticalAlign: 'top' },
                    onRequestDelete: function onRequestDelete() {
                      return removeIndividualTag((0, _ramda.path)([_this2.props.indexToOpen, 'tags', i], _this2.props.previewFiles));
                    }
                  },
                  tag
                ) : _react2.default.createElement(
                  _materialUi.Chip,
                  {
                    style: { margin: '5px', display: 'inline-block' },
                    backgroundColor: 'rgb(0, 188, 212)',
                    labelColor: '#ffffff',
                    labelStyle: { verticalAlign: 'top' }
                  },
                  tag
                )
              );
            })
          ),
          actions
        )
      );
    }
  }]);

  return MediaFileDialog;
}(_react.Component);

MediaFileDialog.propTypes = {
  closePreview: _react.PropTypes.func,
  previewFiles: _react.PropTypes.array,
  deleteFileFunc: _react.PropTypes.func,
  isEditable: _react.PropTypes.bool,
  editFileNameFunc: _react.PropTypes.func,
  downloadOneFile: _react.PropTypes.func,
  indexToOpen: _react.PropTypes.number,
  changeFileIndex: _react.PropTypes.func,
  forLocationOrProductPages: _react.PropTypes.bool,
  MMReducer: _react.PropTypes.object,
  removeIndividualTag: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var marketingMaterials = _ref2.marketingMaterials,
      profileLocation = _ref2.profileLocation;
  return {
    MMReducer: marketingMaterials.mainReducer.toJS(),
    profileLocationReducer: profileLocation.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(MediaFileDialog);

/***/ }),
/* 3142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _filter = __webpack_require__(3143);

var _filter2 = _interopRequireDefault(_filter);

var _ramda = __webpack_require__(2);

var _dropdown = __webpack_require__(3144);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _materialUi = __webpack_require__(3);

var _reply = __webpack_require__(3148);

var _reply2 = _interopRequireDefault(_reply);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isEmpty, _ramda.isNil);

var TitleContainer = function TitleContainer(props) {
  var MMReducer = props.MMReducer,
      MMPartnerReducer = props.MMPartnerReducer,
      updateMMProp = props.updateMMProp,
      updateMMPartnerProp = props.updateMMPartnerProp,
      downloadSingleFile = props.downloadSingleFile,
      updateMM = props.updateMM,
      selectedFilesUrls = props.selectedFilesUrls,
      isEditable = props.isEditable,
      containerStateForViewers = props.containerStateForViewers,
      updateStateForViewers = props.updateStateForViewers,
      isSupplier = props.isSupplier,
      forLocationOrProductPages = props.forLocationOrProductPages,
      findPhotosForTag = props.findPhotosForTag,
      user = props.user;


  var sharedProps = {
    updateMMProp: updateMMProp,
    isEditable: isEditable,
    isSupplier: isSupplier,
    updateStateForViewers: !isEditable ? updateStateForViewers : undefined,
    containerStateForViewers: !isEditable ? containerStateForViewers : undefined,
    forLocationOrProductPages: forLocationOrProductPages,
    findPhotosForTag: findPhotosForTag
  };

  var checkIfSupplier = isSupplier ? {
    height: '48px',
    fontSize: '20px',
    color: 'rgba(0, 0, 0, 0.87)',
    backgroundColor: MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM || MMReducer.managingTags ? '#00bcd4' : '#f5f5f5',
    padding: '2%',
    width: '100%'
  } : {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 'calc(12px + 0.5vw)',
    fontWeight: '600',
    marginBottom: '45px',
    border: '1px solid transparent',
    backgroundColor: MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM ? '#00bcd4' : '',
    height: MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM ? '48px' : '',
    padding: MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM ? '0 2%' : ''
  };

  var checkHeader = function checkHeader() {
    if (MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM) {
      return _react2.default.createElement(_materialUi.FontIcon, {
        className: 'tc-icon-arrow_back',
        style: { color: '#ffffff', cursor: 'pointer' },
        onTouchTap: function onTouchTap() {
          return updateMMPartnerProp({
            sendToPartners: false,
            partnersToSendTo: [],
            filteredConnections: [],
            addPartnersMethod: '',
            showSelectMethod: false,
            showReview: false,
            individualCompanyName: '',
            individualEmail: '',
            searchField: '',
            selectedExistingPartners: []
          });
        }
      });
    } else if (MMReducer.managingTags) {
      return _react2.default.createElement(_materialUi.FontIcon, {
        className: 'tc-icon-arrow_back',
        style: { color: '#ffffff', cursor: 'pointer' },
        onTouchTap: function onTouchTap() {
          return updateMMProp({
            managingTags: false,
            tagsStep: 1,
            tags: [],
            selectedFiles: []
          });
        }
      });
    }
    return _react2.default.createElement(
      'span',
      null,
      'Marketing Materials'
    );
  };

  return _react2.default.createElement(
    'div',
    { style: checkIfSupplier },
    _react2.default.createElement(
      'span',
      { style: isSupplier ? {} : { float: 'left', marginTop: '10px' } },
      checkHeader()
    ),
    _react2.default.createElement(
      'span',
      { style: { float: 'right', margin: '-9px -5px 0 0', display: 'inline-block' } },
      _react2.default.createElement(
        'div',
        { style: {
            color: MMReducer.managingTags || MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM ? '#ffffff' : 'rgba(0, 0, 0, 0.54)',
            display: 'inline-block',
            float: 'left',
            margin: isSupplier ? '10px 20px 0 0' : '17px 20px 0 0',
            fontSize: '16px' }
        },
        selectedFilesUrls.length > 0 && isNilOrEmpty(MMReducer.searchField) ? selectedFilesUrls.length + ' of ' + ((0, _ramda.not)(isNilOrEmpty(findPhotosForTag)) ? (0, _ramda.prop)('length', findPhotosForTag) : (0, _ramda.path)(['media', 'length'], MMReducer)) + ' selected' : ''
      ),
      _react2.default.createElement(
        'div',
        { style: { color: MMReducer.managingTags ? '#ffffff' : 'rgba(0, 0, 0, 0.54)', display: 'inline-block', float: 'left', margin: isSupplier ? '10px 20px 0 0' : '17px 20px 0 0', fontSize: '16px' } },
        (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), function () {
          return (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), (0, _ramda.always)(selectedFilesUrls.length + ' of ' + (0, _ramda.path)(['filteredMedia', 'length'], MMReducer) + ' selected'), (0, _ramda.always)((0, _ramda.path)(['filteredMedia', 'length'], MMReducer) + ' ' + ((0, _ramda.equals)((0, _ramda.path)(['filteredMedia', 'length'], MMReducer), 1) ? 'file' : 'files') + ' found')), Boolean(selectedFilesUrls.length));
        }, (0, _ramda.always)('')), MMReducer.filteredMedia && (0, _ramda.not)(isNilOrEmpty(MMReducer.searchField)))
      ),
      isEditable ? _react2.default.createElement(
        'div',
        { style: { float: 'left', marginTop: isSupplier ? '5px' : '14px', cursor: 'pointer' } },
        (0, _ramda.path)(['media', 'length'], MMReducer) > 0 && !MMReducer.managingTags && !MMPartnerReducer.sendToPartners && !MMPartnerReducer.sendingMM ? _react2.default.createElement(
          'span',
          { id: 'shareMarketingMaterial' },
          _react2.default.createElement(
            _materialUi.FontIcon,
            {
              onTouchTap: function onTouchTap() {
                window.location = "https://app.tourconnect.com" + '/partner-management/send-assets?go_back_to=' + window.location.href + '&jwt=' + localStorage.getItem('jwt') + '&open_asset_type=mms';
              }
            },
            _react2.default.createElement(_reply2.default, {
              className: 'flip-icon',
              color: '#00bcd4',
              style: { verticalAlign: 'bottom' }
            }),
            _react2.default.createElement(
              'span',
              { style: { fontSize: '15px', color: 'rgba(0, 0, 0, 0.54)' } },
              'Share'
            )
          )
        ) : _react2.default.createElement('span', null)
      ) : _react2.default.createElement('span', null),
      _react2.default.createElement(
        'div',
        { style: { float: 'left' } },
        (0, _ramda.path)(['media', 'length'], MMReducer) > 0 && !MMReducer.managingTags && !MMPartnerReducer.sendToPartners && !MMPartnerReducer.sendingMM ? _react2.default.createElement(_filter2.default, _extends({
          filterByMediaType: isEditable ? MMReducer.filterByMediaType : (0, _ramda.propOr)('All File Types', 'filterByMediaType', containerStateForViewers)
        }, sharedProps)) : _react2.default.createElement('span', null)
      ),
      _react2.default.createElement(
        'div',
        { style: { float: 'right', marginTop: '17px' } },
        MMReducer.managingTags || MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM ? _react2.default.createElement('span', null) : _react2.default.createElement(_dropdown2.default, _extends({
          downloadSingleFile: downloadSingleFile,
          updateMM: updateMM,
          updateMMPartnerProp: updateMMPartnerProp,
          selectedFilesUrls: selectedFilesUrls
        }, sharedProps))
      )
    )
  );
};

TitleContainer.propTypes = {
  MMReducer: _react.PropTypes.object,
  updateMMProp: _react.PropTypes.func,
  updateMMPartnerProp: _react.PropTypes.func,
  downloadSingleFile: _react.PropTypes.func,
  updateMM: _react.PropTypes.func,
  selectedFilesUrls: _react.PropTypes.array,
  isEditable: _react.PropTypes.bool,
  containerStateForViewers: _react.PropTypes.object,
  updateStateForViewers: _react.PropTypes.func,
  isSupplier: _react.PropTypes.bool,
  MMPartnerReducer: _react.PropTypes.object,
  forLocationOrProductPages: _react.PropTypes.bool,
  findPhotosForTag: _react.PropTypes.array,
  user: _react.PropTypes.object
};

var mapStateToProps = function mapStateToProps(_ref) {
  var marketingMaterials = _ref.marketingMaterials,
      user = _ref.user;
  return {
    MMReducer: marketingMaterials.mainReducer.toJS(),
    MMPartnerReducer: marketingMaterials.partnerReducer.toJS(),
    user: user.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(TitleContainer);

/***/ }),
/* 3143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notEqual = function notEqual(first, second) {
  return (0, _ramda.not)((0, _ramda.equals)(first, second));
};
var isNilOrEmpty = (0, _ramda.either)(_ramda.isEmpty, _ramda.isNil);

var Filter = function Filter(props) {
  var updateMMProp = props.updateMMProp,
      filterByMediaType = props.filterByMediaType,
      updateStateForViewers = props.updateStateForViewers,
      isEditable = props.isEditable,
      isSupplier = props.isSupplier,
      forLocationOrProductPages = props.forLocationOrProductPages,
      findPhotosForTag = props.findPhotosForTag,
      MMReducer = props.MMReducer;


  var filesToUse = forLocationOrProductPages ? findPhotosForTag : (0, _ramda.prop)('media', MMReducer);
  var availableFileTypes = (0, _ramda.uniq)(filesToUse.map(function (file) {
    return file.mediaType;
  }));
  var filteredFileType = (0, _ramda.uniq)(availableFileTypes.reduce(function (acc, fileType) {
    acc.push('All File Types');
    if ((0, _ramda.call)((0, _ramda.either)((0, _ramda.equals)('image/jpeg'), (0, _ramda.equals)('image/png')), fileType)) acc.push('Image');
    if ((0, _ramda.call)((0, _ramda.either)((0, _ramda.equals)('application/vnd.ms-powerpoint'), (0, _ramda.equals)('application/vnd.openxmlformats-officedocument.presentationml.presentation')), fileType)) acc.push('PowerPoint');
    if ((0, _ramda.equals)(fileType, 'video/mp4')) acc.push('Video');
    if ((0, _ramda.equals)(fileType, 'application/pdf')) acc.push('PDF');
    if ((0, _ramda.equals)(fileType, 'CloudDrive')) acc.push('CloudDrive');
    return acc;
  }, []));

  return _react2.default.createElement(
    'div',
    null,
    isNilOrEmpty(filesToUse) ? _react2.default.createElement('span', null) : _react2.default.createElement(
      _materialUi.DropDownMenu,
      {
        value: filterByMediaType,
        onChange: function onChange(event, index, value) {
          var convertSelectedFilterType = notEqual(value, 'All File Types') ? (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('Image'), (0, _ramda.always)(['image/jpeg', 'image/png'])], [(0, _ramda.equals)('PowerPoint'), (0, _ramda.always)(['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'])], [(0, _ramda.equals)('Video'), (0, _ramda.always)(['video/mp4'])], [(0, _ramda.equals)('PDF'), (0, _ramda.always)(['application/pdf'])], [(0, _ramda.equals)('CloudDrive'), (0, _ramda.always)(['CloudDrive'])]]), value) : filesToUse;
          if (isEditable) {
            updateMMProp({
              filteredMedia: filesToUse.filter(function (file) {
                return (0, _ramda.contains)(file.mediaType, convertSelectedFilterType);
              }),
              filterByMediaType: value,
              searchField: ''
            });
          } else {
            updateStateForViewers('filteredMedia', filesToUse.filter(function (file) {
              return (0, _ramda.contains)(file.mediaType, convertSelectedFilterType);
            }));
            updateStateForViewers('filterByMediaType', value);
            updateStateForViewers('searchField', '');
          }
        },
        underlineStyle: { border: 'none' },
        labelStyle: { color: 'rgba(0, 0, 0, 0.54)' },
        style: { marginTop: isSupplier ? '-8px' : '' }
      },
      filteredFileType.map(function (fileType, index) {
        return _react2.default.createElement(_materialUi.MenuItem, { key: index, value: fileType, primaryText: fileType });
      })
    )
  );
};

Filter.propTypes = {
  updateMMProp: _react.PropTypes.func,
  filterByMediaType: _react.PropTypes.string,
  updateStateForViewers: _react.PropTypes.func,
  isEditable: _react.PropTypes.bool,
  isSupplier: _react.PropTypes.bool,
  forLocationOrProductPages: _react.PropTypes.bool,
  MMReducer: _react.PropTypes.object,
  findPhotosForTag: _react.PropTypes.array
};

var mapStateToProps = function mapStateToProps(_ref) {
  var marketingMaterials = _ref.marketingMaterials;
  return {
    MMReducer: marketingMaterials.mainReducer.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Filter);

/***/ }),
/* 3144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _externalLinksContainer = __webpack_require__(3145);

var _externalLinksContainer2 = _interopRequireDefault(_externalLinksContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dropdown = function Dropdown(props) {
  var updateMMProp = props.updateMMProp,
      downloadSingleFile = props.downloadSingleFile,
      updateMM = props.updateMM,
      MMReducer = props.MMReducer,
      selectedFilesUrls = props.selectedFilesUrls,
      isEditable = props.isEditable,
      updateStateForViewers = props.updateStateForViewers,
      containerStateForViewers = props.containerStateForViewers,
      isSupplier = props.isSupplier,
      forLocationOrProductPages = props.forLocationOrProductPages,
      findPhotosForTag = props.findPhotosForTag;


  var removeCloudDrive = isEditable ? (0, _ramda.propOr)([], 'selectedFiles', MMReducer).filter(function (file) {
    return file.mediaType !== 'CloudDrive';
  }) : (0, _ramda.propOr)([], 'selectedFiles', containerStateForViewers).filter(function (file) {
    return file.mediaType !== 'CloudDrive';
  });
  var numberOfSelectedFiles = isEditable ? (0, _ramda.path)(['selectedFiles', 'length'], MMReducer) : (0, _ramda.path)(['selectedFiles', 'length'], containerStateForViewers);
  var numberOfAllFiles = forLocationOrProductPages ? (0, _ramda.prop)('length', findPhotosForTag) : (0, _ramda.path)(['media', 'length'], MMReducer);
  var filesToUse = forLocationOrProductPages ? findPhotosForTag : (0, _ramda.prop)('media', MMReducer);
  var plusIcon = _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-add', style: { color: '#00bcd4', fontSize: '14px', marginRight: '5px' } });

  var options = [];

  if (isEditable) {
    options.push({
      text: _react2.default.createElement(
        'span',
        null,
        plusIcon,
        'Add File Link'
      ),
      action: function action() {
        return updateMMProp({ showFileLink: true });
      }
    });
    options.push({
      text: _react2.default.createElement(
        'span',
        null,
        plusIcon,
        'Add Storage Link'
      ),
      action: function action() {
        return updateMMProp({ showStorageLink: true });
      }
    });
    if (isSupplier && !forLocationOrProductPages) {
      options.push({
        text: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-tag', style: { color: '#00bcd4', fontSize: '14px', marginRight: '5px' } }),
          'Manage Tags'
        ),
        action: function action() {
          return updateMMProp({ managingTags: true });
        }
      });
    }
  }

  if (numberOfAllFiles > 0) {
    var checkIfAllFilesAreSelected = isEditable ? (0, _ramda.equals)((0, _ramda.path)(['selectedFiles', 'length'], MMReducer), (0, _ramda.prop)('length', filesToUse)) : (0, _ramda.equals)((0, _ramda.path)(['selectedFiles', 'length'], containerStateForViewers), filesToUse.length);
    options.push({
      text: checkIfAllFilesAreSelected ? _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-check_box_outline_blank', style: { color: '#00bcd4', fontSize: '14px', marginRight: '5px' } }),
        'Deselect All'
      ) : _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-check-square-o', style: { color: '#00bcd4', fontSize: '14px', marginRight: '5px' } }),
        'Select All'
      ),
      action: function action() {
        if (isEditable) updateMMProp({ selectedFiles: checkIfAllFilesAreSelected ? [] : filesToUse });else {
          updateStateForViewers('selectedFiles', checkIfAllFilesAreSelected ? [] : filesToUse);
        }
      }
    });
  }

  if (numberOfSelectedFiles > 0) {
    options.push({
      text: _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-get_app', style: { color: '#00a1ba', fontSize: '14px', marginRight: '5px' } }),
        'Download ',
        (0, _ramda.prop)('length', removeCloudDrive),
        ' ',
        (0, _ramda.prop)('length', removeCloudDrive) === 1 ? 'File' : 'Files',
        (isEditable ? (0, _ramda.find)((0, _ramda.propEq)('mediaType', 'CloudDrive'), MMReducer.selectedFiles) : (0, _ramda.find)((0, _ramda.propEq)('mediaType', 'CloudDrive'), containerStateForViewers.selectedFiles)) ? ' (CloudDrives cannot be downloaded)' : ''
      ),
      action: function action() {
        if (isEditable) {
          updateMMProp({ selectedFiles: removeCloudDrive });
        } else {
          updateStateForViewers('selectedFiles', removeCloudDrive);
        }
        downloadSingleFile(removeCloudDrive.map(function (file) {
          return { url: file.url, fileName: file.name, fileType: file.mediaType };
        }));
      }
    });
    if (isEditable) {
      options.push({
        text: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-delete2', style: { color: '#ff4081', fontSize: '14px', marginRight: '5px' } }),
          'Delete ',
          (0, _ramda.equals)(numberOfSelectedFiles, numberOfAllFiles) ? 'All' : numberOfSelectedFiles,
          ' ',
          (0, _ramda.equals)(numberOfSelectedFiles, 1) && !(0, _ramda.equals)(numberOfSelectedFiles, numberOfAllFiles) ? 'File' : 'Files'
        ),
        action: function action() {
          var confirmed = confirm('Are you sure you want to delete?');
          if (confirmed) {
            var removeSelectedFiles = (forLocationOrProductPages ? MMReducer.media : filesToUse).filter(function (file) {
              return selectedFilesUrls.indexOf(file.url) === -1;
            });
            var removeKeysFromSelectedFiles = MMReducer.selectedFiles.map(function (file) {
              return (0, _ramda.omit)(['index'], file);
            });
            var removeSelectedFilesFromFilteredFiles = (0, _ramda.without)(removeKeysFromSelectedFiles, MMReducer.filteredMedia);
            updateMMProp({
              savingMedia: true,
              selectedFiles: [],
              media: removeSelectedFiles,
              filteredMedia: removeSelectedFilesFromFilteredFiles
            });
            updateMM({
              updateField: 'media',
              updateBody: removeSelectedFiles
            });
          }
        }
      });
    }
  }

  return _react2.default.createElement(
    'span',
    { style: { float: 'right' } },
    (0, _ramda.not)((0, _ramda.isEmpty)(options)) ? _react2.default.createElement(
      _materialUi.IconMenu,
      {
        iconButtonElement: _react2.default.createElement(_materialUi.IconButton, {
          iconClassName: 'tc-icon-more-vert',
          iconStyle: { color: 'rgba(0, 0, 0, 0.54)' }
        }),
        anchorOrigin: { horizontal: 'left', vertical: 'top' },
        targetOrigin: { horizontal: 'left', vertical: 'top' },
        style: { display: 'inline-block', marginTop: isSupplier ? '-23px' : '-13px', verticalAlign: isSupplier ? 'middle' : '' }
      },
      options.map(function (option, i) {
        return _react2.default.createElement(_materialUi.MenuItem, { key: i, primaryText: option.text, onTouchTap: option.action });
      })
    ) : _react2.default.createElement('span', null),
    _react2.default.createElement(_externalLinksContainer2.default, {
      MMReducer: MMReducer,
      updateMMProp: updateMMProp,
      onCancel: function onCancel() {
        return updateMMProp({
          showFileLink: false,
          showStorageLink: false
        });
      },
      onFileLinkSubmit: function onFileLinkSubmit(file) {
        MMReducer.media.unshift({
          url: file.url,
          mediaType: file.fileType,
          name: file.fileName,
          size: MMReducer.showFileLink ? 'external' : undefined,
          storageProvider: MMReducer.showStorageLink ? file.storageProvider : undefined,
          username: MMReducer.showStorageLink ? (0, _ramda.prop)('username', file) : undefined,
          password: MMReducer.showStorageLink ? (0, _ramda.prop)('password', file) : undefined,
          created_at: new Date()
        });
        updateMMProp({
          savingMedia: true,
          showFileLink: false,
          showStorageLink: false
        });
        updateMM({
          updateField: 'media',
          updateBody: MMReducer.media
        });
      }
    })
  );
};

Dropdown.propTypes = {
  updateMMProp: _react.PropTypes.func,
  downloadSingleFile: _react.PropTypes.func,
  updateMM: _react.PropTypes.func,
  MMReducer: _react.PropTypes.object,
  selectedFilesUrls: _react.PropTypes.array,
  isEditable: _react.PropTypes.bool,
  updateStateForViewers: _react.PropTypes.func,
  containerStateForViewers: _react.PropTypes.object,
  isSupplier: _react.PropTypes.bool,
  forLocationOrProductPages: _react.PropTypes.bool,
  findPhotosForTag: _react.PropTypes.array
};

var mapStateToProps = function mapStateToProps(_ref) {
  var marketingMaterials = _ref.marketingMaterials;
  return {
    MMReducer: marketingMaterials.mainReducer.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Dropdown);

/***/ }),
/* 3145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _fileLink = __webpack_require__(3146);

var _fileLink2 = _interopRequireDefault(_fileLink);

var _storageLink = __webpack_require__(3147);

var _storageLink2 = _interopRequireDefault(_storageLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExternalLinksContainer = (0, _react.createClass)({
  propTypes: {
    MMReducer: _react.PropTypes.object,
    onFileLinkSubmit: _react.PropTypes.func,
    onCancel: _react.PropTypes.func
  },

  getInitialState: function getInitialState() {
    return {
      fileType: '',
      storageType: '',
      storageUrl: '',
      fileTypeChecked: false,
      fileTypeError: false,
      checkingFileType: false
    };
  },


  // video onError does NOT work with our version of react.
  // once updated, this should fire.
  // https://github.com/facebook/react/commit/e1c2c42c2461ae2007000196571be20b8e597171
  // update submit button to check for video
  onFileTypeError: function onFileTypeError() {
    this.setState({
      fileTypeError: true,
      fileTypeChecked: true
    });
  },
  onFileTypeCheckedSuccess: function onFileTypeCheckedSuccess() {
    this.setState({
      fileTypeError: false,
      fileTypeChecked: true
    });
    this.submitFile();
  },
  submitFile: function submitFile() {
    if (this.props.MMReducer.showFileLink) {
      // const fileExtension = call(cond([
      //   [equals('image/jpeg'), always('jpeg')],
      //   [equals('video/mp4'), always('mp4')],
      //   [equals('application/pdf'), always('pdf')],
      //   [equals('application/vnd.ms-powerpoint'), always('application/vnd.ms-powerpoint')],
      //   [T, always('')],
      // ]), this.state.fileType);
      var file = {
        url: this.state.url,
        fileType: 'image/jpeg', // this.state.fileType fix this for video
        fileName: this.state.name + '.jpeg' // `${this.state.name}.${fileExtension}` for video later
      };
      this.clearState();
      this.props.onFileLinkSubmit(file);
    }
    if (this.props.MMReducer.showStorageLink) {
      var _file = {
        url: this.state.url,
        fileType: 'CloudDrive',
        fileName: this.state.name,
        storageProvider: (0, _ramda.equals)(this.state.storageProvider, 'Other') ? this.state.otherStorageProvider : this.state.storageProvider,
        username: (0, _ramda.prop)('username', this.state),
        password: (0, _ramda.prop)('password', this.state)
      };
      this.clearState();
      this.props.onFileLinkSubmit(_file);
    }
  },
  clearState: function clearState() {
    this.setState({
      url: '',
      name: '',
      fileType: '',
      storageType: '',
      storageUrl: '',
      fileTypeChecked: false,
      fileTypeError: false,
      checkingFileType: false,
      storageProvider: ''
    });
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        MMReducer = _props.MMReducer,
        onCancel = _props.onCancel;

    // const getFileTypeFromUrl = (url, callback) => {
    //   const xhr = new XMLHttpRequest();
    //   xhr.open('HEAD', url, true);
    //   xhr.onreadystatechange = () => {
    //     callback(xhr.getResponseHeader('Content-Type'));
    //     // xhr.getResponseHeader('Content-Length') this is for file size but is unstable
    //   };
    //   xhr.send();
    // };

    var generateErrorText = function generateErrorText(errorType) {
      return (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('fileTypeError'), function () {
        return _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          _react2.default.createElement(
            'h5',
            { style: { color: 'red' } },
            'There was a problem with the image URL. Please make sure the URL is public and is an image.'
          )
        );
      }], [(0, _ramda.equals)('duplicateUrlError'), function () {
        return _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          _react2.default.createElement(
            'h5',
            { style: { color: 'red' } },
            'This URL has already been uploaded. Please enter a different one.'
          )
        );
      }], [(0, _ramda.equals)('missingHttp'), function () {
        return _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          _react2.default.createElement(
            'h5',
            { style: { color: 'red' } },
            'This URL is missing http:// or https://. Please double check the link.'
          )
        );
      }], [_ramda.T, function () {
        return _react2.default.createElement('span', null);
      }]]), errorType);
    };

    var sharedProps = {
      onCancel: onCancel,
      clearState: this.clearState,
      state: this.state,
      submitFile: this.submitFile,
      setState: function setState(update) {
        return _this.setState(update);
      },
      onFileTypeCheckedSuccess: this.onFileTypeCheckedSuccess,
      onFileTypeError: this.onFileTypeError,
      generateErrorText: generateErrorText,
      existingUrls: (this.props.MMReducer.media || []).map(function (item) {
        return item.url;
      })
    };

    return _react2.default.createElement(
      'div',
      null,
      MMReducer.showFileLink ? _react2.default.createElement(_fileLink2.default, sharedProps) : _react2.default.createElement('span', null),
      MMReducer.showStorageLink ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_storageLink2.default, sharedProps)
      ) : _react2.default.createElement('span', null)
    );
  }
});

exports.default = ExternalLinksContainer;

/***/ }),
/* 3146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _genericDialog = __webpack_require__(1949);

var _genericDialog2 = _interopRequireDefault(_genericDialog);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);
var isNotNilOrEmpty = (0, _ramda.complement)(isNilOrEmpty);
var notEqual = function notEqual(first, second) {
  return (0, _ramda.not)((0, _ramda.equals)(first, second));
};

var fileLinkFields = [{
  leftLabel: 'File Name',
  prop: 'name'
}, {
  leftLabel: 'File URL',
  prop: 'url'
}, {
  leftLabel: 'File Type',
  prop: 'mediaType'
}];

var FileLink = function FileLink(props) {
  var onCancel = props.onCancel,
      clearState = props.clearState,
      state = props.state,
      submitFile = props.submitFile,
      setState = props.setState,
      onFileTypeCheckedSuccess = props.onFileTypeCheckedSuccess,
      onFileTypeError = props.onFileTypeError,
      existingUrls = props.existingUrls,
      generateErrorText = props.generateErrorText;


  return _react2.default.createElement(_genericDialog2.default, {
    dialogTitle: 'Externally Hosted Image',
    actions: [_react2.default.createElement(_materialUi.FlatButton, {
      label: 'Cancel',
      primary: true,
      onTouchTap: function onTouchTap() {
        onCancel();
        clearState();
      }
    }), _react2.default.createElement(_materialUi.FlatButton, {
      label: !state.fileTypeChecked ? 'Validate File' : 'Submit',
      secondary: true,
      onTouchTap: function onTouchTap() {
        // FOR VIDEO LATER ON
        // const imageFile = state.fileType === 'image/jpeg';
        // const videoFile = state.fileType === 'video/mp4'; -- UNCOMMENT ONCE REACT IS UPDATED
        // if (imageFile) setState({ checkingFileType: true });
        // if (state.fileTypeChecked || notEqual(state.fileType, 'image/jpeg')) submitFile();
        setState({ checkingFileType: true });
        if (state.fileTypeChecked) submitFile();
      },
      disabled: (0, _ramda.contains)(state.url, existingUrls) || state.checkingFileType || state.fileTypeError || isNilOrEmpty(state.name) || isNilOrEmpty(state.url)
    })],
    mainContent: _react2.default.createElement(
      'div',
      null,
      fileLinkFields.map(function (linkField, index) {
        return _react2.default.createElement(
          'div',
          { key: index },
          _react2.default.createElement(_twoColumnRow2.default, {
            leftColumnClassName: 'Grid',
            leftColumnContent: _react2.default.createElement(
              'div',
              { className: 'Grid-cell Grid-cell--center' },
              linkField.leftLabel
            ),
            leftColumnStyle: { width: '25%', height: '34px' },
            rightColumnStyle: { width: '70%' },
            rightColumnContent:
            // {state.fileType} for value
            (0, _ramda.equals)(linkField.prop, 'mediaType') ? _react2.default.createElement(
              _materialUi.SelectField,
              {
                style: { width: '100%', marginTop: '-10px', overflow: 'hidden' },
                value: 'image/jpeg',
                disabled: true,
                onChange: function onChange(event, i, value) {
                  return setState({
                    fileType: value,
                    fileTypeError: false,
                    fileTypeChecked: false,
                    checkingFileType: false
                  });
                },
                hintText: 'Select A File Type'
              },
              _react2.default.createElement(_materialUi.MenuItem, { value: 'image/jpeg', primaryText: 'Image (.jpeg / .jpg / .png)' })
            ) : _react2.default.createElement(_materialUi.TextField, {
              key: linkField.prop,
              style: { border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px' },
              inputStyle: { fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' },
              underlineShow: false,
              onChange: function onChange(_ref) {
                var _setState;

                var value = _ref.target.value;
                return setState((_setState = {}, _defineProperty(_setState, linkField.prop, value), _defineProperty(_setState, 'fileTypeError', false), _defineProperty(_setState, 'fileTypeChecked', false), _defineProperty(_setState, 'checkingFileType', false), _setState));
              },
              value: state[linkField.prop]
            })
          })
        );
      }),
      isNotNilOrEmpty(state.url) && (0, _ramda.contains)(state.url, existingUrls) ? generateErrorText('duplicateUrlError') : _react2.default.createElement('span', null)
    ),
    subContent: state.fileTypeError ? generateErrorText('fileTypeError') : _react2.default.createElement('span', null),
    hiddenErrorChecking: state.checkingFileType ? _react2.default.createElement(
      'div',
      { style: { display: 'none' } },
      _react2.default.createElement('img', {
        src: state.url,
        onLoad: onFileTypeCheckedSuccess,
        onError: onFileTypeError
      })
    ) : _react2.default.createElement('span', null)
    // call(cond([
    //   [equals('image/jpeg'), () => {
    //     return (
    //       <div style={{ display: 'none' }}>
    //         <img
    //           src={state.url}
    //           onLoad={onFileTypeCheckedSuccess}
    //           onError={onFileTypeError}
    //         />
    //       </div>
    //     );
    //   }],
    //   // UNCOMMENT ONCE REACT / REACTDOM GETS UPDATED
    //   // [equals('video/mp4'), () => {
    //   //   return (
    //   //     <div style={{ display: 'none' }}>
    //   //       <video onCanPlay={onFileTypeCheckedSuccess}>
    //   //         <source
    //   //           src={state.url}
    //   //           type="video/mp4"
    //   //           onError={onFileTypeError}
    //   //         />
    //   //         Your browser doesn't support this video.
    //   //       </video>
    //   //     </div>
    //   //   );
    //   // }],
    //   [T, () => <div/>],
    // ]), state.fileType) : <span/>

  });
};

FileLink.propTypes = {
  onCancel: _react.PropTypes.func,
  clearState: _react.PropTypes.func,
  state: _react.PropTypes.object,
  submitFile: _react.PropTypes.func,
  setState: _react.PropTypes.func,
  onFileTypeCheckedSuccess: _react.PropTypes.func,
  onFileTypeError: _react.PropTypes.func,
  existingUrls: _react.PropTypes.array,
  generateErrorText: _react.PropTypes.func
};

exports.default = FileLink;

/***/ }),
/* 3147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _genericDialog = __webpack_require__(1949);

var _genericDialog2 = _interopRequireDefault(_genericDialog);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);
var isNotNilOrEmpty = (0, _ramda.complement)(isNilOrEmpty);

var storageLinkFields = [{
  leftLabel: 'Content Name',
  prop: 'name',
  hintText: 'eg. 2017 Brochure'
}, {
  leftLabel: 'Public URL',
  prop: 'url',
  hintText: 'https://drive.google.com/open?id=12345'
}, {
  leftLabel: 'Storage Provider',
  prop: 'storageProvider'
}];

var credentialFields = [{
  leftLabel: 'Username',
  prop: 'username'
}, {
  leftLabel: 'Password',
  prop: 'password'
}];

var StorageLink = function StorageLink(props) {
  var onCancel = props.onCancel,
      clearState = props.clearState,
      state = props.state,
      submitFile = props.submitFile,
      setState = props.setState,
      generateErrorText = props.generateErrorText,
      existingUrls = props.existingUrls;


  return _react2.default.createElement(_genericDialog2.default, {
    dialogTitle: 'External Public Storage Link',
    actions: [_react2.default.createElement(_materialUi.FlatButton, {
      label: 'Cancel',
      primary: true,
      onTouchTap: function onTouchTap() {
        onCancel();
        clearState();
      }
    }), _react2.default.createElement(_materialUi.FlatButton, {
      label: 'Submit',
      secondary: true,
      onTouchTap: function onTouchTap() {
        return submitFile();
      },
      disabled: (0, _ramda.contains)(state.url, existingUrls) || isNilOrEmpty(state.url) || isNilOrEmpty(state.name) || isNilOrEmpty(state.storageProvider) || !(0, _ramda.contains)('http', state.url)
    })],
    fieldsToMap: storageLinkFields,
    mainContent: _react2.default.createElement(
      'div',
      null,
      storageLinkFields.map(function (linkField, index) {
        return _react2.default.createElement(
          'div',
          { key: index },
          _react2.default.createElement(_twoColumnRow2.default, {
            leftColumnClassName: 'Grid',
            leftColumnContent: _react2.default.createElement(
              'div',
              { className: 'Grid-cell Grid-cell--center' },
              linkField.leftLabel
            ),
            leftColumnStyle: { width: '25%', height: '34px' },
            rightColumnStyle: { width: '70%' },
            rightColumnContent: _react2.default.createElement(
              'div',
              null,
              (0, _ramda.equals)(linkField.prop, 'storageProvider') ? _react2.default.createElement(
                _materialUi.SelectField,
                {
                  style: { width: '100%', marginTop: '-10px', overflow: '-moz-scrollbars-none' },
                  value: state.storageProvider,
                  onChange: function onChange(event, i, value) {
                    return setState({
                      storageProvider: value
                    });
                  },
                  hintText: 'Select where your files are stored'
                },
                _react2.default.createElement(_materialUi.MenuItem, { value: 'Dropbox', primaryText: 'Dropbox' }),
                _react2.default.createElement(_materialUi.MenuItem, { value: 'Google Drive', primaryText: 'Google Drive' }),
                _react2.default.createElement(_materialUi.MenuItem, { value: 'OneDrive', primaryText: 'OneDrive' }),
                _react2.default.createElement(_materialUi.MenuItem, { value: 'Box', primaryText: 'Box' }),
                _react2.default.createElement(_materialUi.MenuItem, { value: 'Other', primaryText: 'Other (Enter Name Below)' })
              ) : _react2.default.createElement(
                'div',
                { style: { overflow: '-moz-scrollbars-none' } },
                _react2.default.createElement(_materialUi.TextField, {
                  key: linkField.prop,
                  style: { border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px' },
                  inputStyle: { fontSize: '14px', whiteSpace: 'pre-wrap', position: 'absolute', marginTop: '-40px', padding: '0 5px' },
                  underlineShow: false,
                  onChange: function onChange(_ref) {
                    var value = _ref.target.value;
                    return setState(_defineProperty({}, linkField.prop, value));
                  },
                  value: state[linkField.prop],
                  hintText: linkField.hintText,
                  hintStyle: { margin: '15px 0 0 5px', position: 'relative', fontSize: '14px' }
                }),
                (0, _ramda.equals)(linkField.prop, 'url') && isNotNilOrEmpty(state.url) && (0, _ramda.contains)(state.url, existingUrls) ? generateErrorText('duplicateUrlError') : _react2.default.createElement('span', null),
                (0, _ramda.equals)(linkField.prop, 'url') && isNotNilOrEmpty(state.url) && !(0, _ramda.contains)('http', state.url) ? generateErrorText('missingHttp') : _react2.default.createElement('span', null)
              )
            )
          })
        );
      })
    ),
    subContent: _react2.default.createElement(
      'div',
      null,
      (0, _ramda.equals)(state.storageProvider, 'Other') ? _react2.default.createElement(
        'div',
        { style: { verticalAlign: 'middle', marginTop: '-5px' } },
        _react2.default.createElement(_twoColumnRow2.default, {
          leftColumnClassName: 'Grid',
          leftColumnStyle: { width: '25%', height: '34px' },
          rightColumnStyle: { width: '70%' },
          rightColumnContent: _react2.default.createElement(_materialUi.TextField, {
            key: 'otherStorageProvider',
            style: { border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px' },
            inputStyle: { fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' },
            underlineShow: false,
            onChange: function onChange(_ref2) {
              var value = _ref2.target.value;
              return setState({
                otherStorageProvider: value
              });
            },
            value: state.otherStorageProvider
          })
        })
      ) : _react2.default.createElement('span', null),
      _react2.default.createElement(
        'div',
        { style: { width: '35.5%' } },
        _react2.default.createElement(_materialUi.Toggle, {
          label: 'Requires Credentials',
          labelStyle: { color: 'rgba(0, 0, 0, 0.54)' },
          elementStyle: { border: '1px solid red' },
          onToggle: function onToggle() {
            return setState({ showCredentialFields: !state.showCredentialFields });
          }
        })
      ),
      state.showCredentialFields ? _react2.default.createElement(
        'div',
        { style: { marginTop: '35px' } },
        credentialFields.map(function (linkField, index) {
          return _react2.default.createElement(
            'div',
            { key: index },
            _react2.default.createElement(_twoColumnRow2.default, {
              leftColumnClassName: 'Grid',
              leftColumnContent: _react2.default.createElement(
                'div',
                { className: 'Grid-cell Grid-cell--center' },
                linkField.leftLabel
              ),
              leftColumnStyle: { width: '25%', height: '34px' },
              rightColumnStyle: { width: '70%' },
              rightColumnContent: _react2.default.createElement(_materialUi.TextField, {
                key: linkField.prop,
                style: { border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px' },
                inputStyle: { fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' },
                underlineShow: false,
                onChange: function onChange(_ref3) {
                  var value = _ref3.target.value;
                  return setState(_defineProperty({}, linkField.prop, value));
                },
                value: state[linkField.prop]
              })
            })
          );
        })
      ) : _react2.default.createElement('span', null)
    )
  });
};

StorageLink.propTypes = {
  onCancel: _react.PropTypes.func,
  clearState: _react.PropTypes.func,
  state: _react.PropTypes.object,
  submitFile: _react.PropTypes.func,
  setState: _react.PropTypes.func,
  generateErrorText: _react.PropTypes.func,
  existingUrls: _react.PropTypes.array
};

exports.default = StorageLink;

/***/ }),
/* 3148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentReply = function ContentReply(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' })
  );
};
ContentReply = (0, _pure2.default)(ContentReply);
ContentReply.displayName = 'ContentReply';
ContentReply.muiName = 'SvgIcon';

exports.default = ContentReply;

/***/ }),
/* 3149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnsupportedBrowserDialog = function UnsupportedBrowserDialog(props) {
  var buttonText = props.buttonText,
      title = props.title,
      errorMessage = props.errorMessage,
      confirmationFunc = props.confirmationFunc;


  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      title: title,
      actions: _react2.default.createElement(_materialUi.FlatButton, {
        label: buttonText,
        secondary: true,
        onTouchTap: confirmationFunc
      }),
      modal: false,
      open: true
    },
    errorMessage
  );
};

UnsupportedBrowserDialog.propTypes = {
  buttonText: _react.PropTypes.string,
  title: _react.PropTypes.string,
  errorMessage: _react.PropTypes.string,
  confirmationFunc: _react.PropTypes.func
};

exports.default = UnsupportedBrowserDialog;

/***/ }),
/* 3150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _selectMethod = __webpack_require__(3151);

var _selectMethod2 = _interopRequireDefault(_selectMethod);

var _reviewPartners = __webpack_require__(1856);

var _reviewPartners2 = _interopRequireDefault(_reviewPartners);

var _containerExisting = __webpack_require__(1857);

var _containerExisting2 = _interopRequireDefault(_containerExisting);

var _importFromEmail = __webpack_require__(1858);

var _importFromEmail2 = _interopRequireDefault(_importFromEmail);

var _uploadFile = __webpack_require__(1859);

var _uploadFile2 = _interopRequireDefault(_uploadFile);

var _addIndividually = __webpack_require__(1861);

var _addIndividually2 = _interopRequireDefault(_addIndividually);

var _actions = __webpack_require__(1115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var SendToPartners = function (_React$Component) {
  _inherits(SendToPartners, _React$Component);

  function SendToPartners() {
    _classCallCheck(this, SendToPartners);

    return _possibleConstructorReturn(this, (SendToPartners.__proto__ || Object.getPrototypeOf(SendToPartners)).apply(this, arguments));
  }

  _createClass(SendToPartners, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (isNilOrEmpty(this.props.MMPartnerReducer.existingConnections)) this.props.getPartnersForMM();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          MMPartnerReducer = _props.MMPartnerReducer,
          updateMMPartnerProp = _props.updateMMPartnerProp,
          isSupplier = _props.isSupplier;


      var clearReducer = function clearReducer() {
        return updateMMPartnerProp({
          sendToPartners: false,
          partnersToSendTo: [],
          filteredConnections: [],
          addPartnersMethod: '',
          showSelectMethod: false,
          individualCompanyName: '',
          individualEmail: '',
          searchField: '',
          selectedExistingPartners: []
        });
      };

      var sharedProps = {
        updateMMPartnerProp: updateMMPartnerProp,
        clearReducer: clearReducer
      };

      var actionItems = [{
        text: 'Select from connections',
        icon: 'tc-icon-user',
        func: function func() {
          return updateMMPartnerProp({
            addPartnersMethod: 'fromConnections',
            showSelectFromPartnersDialog: true
          });
        }
      }, {
        text: 'Import from email',
        icon: 'tc-icon-email',
        func: function func() {
          return updateMMPartnerProp({
            addPartnersMethod: 'emailImport',
            showEmailImportDialog: true
          });
        }
      }, {
        text: 'Upload a file',
        icon: 'tc-icon-insert-drive-file',
        func: function func() {
          return updateMMPartnerProp({
            addPartnersMethod: 'uploadFile',
            showUploadFileDialog: true
          });
        }
      }, {
        text: 'Add individually',
        icon: 'add-circle-icon',
        func: function func() {
          return updateMMPartnerProp({
            addPartnersMethod: 'addIndividually',
            showAddIndividuallyDialog: true
          });
        }
      }];

      var getSelectedMethod = function getSelectedMethod() {
        switch (MMPartnerReducer.addPartnersMethod) {
          case 'fromConnections':
            return _react2.default.createElement(_containerExisting2.default, sharedProps);
          case 'emailImport':
            return _react2.default.createElement(_importFromEmail2.default, sharedProps);
          case 'uploadFile':
            return _react2.default.createElement(_uploadFile2.default, sharedProps);
          case 'addIndividually':
            return _react2.default.createElement(_addIndividually2.default, sharedProps);
          default:
            return _react2.default.createElement('span', null);
        }
      };

      return _react2.default.createElement(
        'div',
        { style: { marginTop: '-3%' } },
        MMPartnerReducer.sendToPartners ? _react2.default.createElement(
          'div',
          null,
          (0, _ramda.not)((0, _ramda.isEmpty)(MMPartnerReducer.addPartnersMethod)) ? getSelectedMethod() : _react2.default.createElement('span', null),
          _react2.default.createElement(_reviewPartners2.default, _extends({
            actionItems: actionItems,
            isSupplier: isSupplier
          }, sharedProps))
        ) : _react2.default.createElement('span', null),
        MMPartnerReducer.sendingMM ? _react2.default.createElement(
          'div',
          { style: { marginTop: '20px', display: 'block', textAlign: 'center' } },
          _react2.default.createElement(_materialUi.CircularProgress, null),
          _react2.default.createElement('br', null),
          'Sending Marketing Materials to your partners.'
        ) : _react2.default.createElement('span', null)
      );
    }
  }]);

  return SendToPartners;
}(_react2.default.Component);

SendToPartners.propTypes = {
  MMPartnerReducer: _react.PropTypes.object,
  updateMMPartnerProp: _react.PropTypes.func,
  isSupplier: _react.PropTypes.bool,
  getPartnersForMM: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var marketingMaterials = _ref.marketingMaterials;
  return {
    MMPartnerReducer: marketingMaterials.partnerReducer.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { getPartnersForMM: _actions.getPartnersForMM })(SendToPartners);

/***/ }),
/* 3151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _buttons = __webpack_require__(3152);

var _buttons2 = _interopRequireDefault(_buttons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var SelectMethod = function SelectMethod(props) {
  var addPartnersMethod = props.addPartnersMethod,
      updateMMPartnerProp = props.updateMMPartnerProp,
      actionItems = props.actionItems,
      MMPartnerReducer = props.MMPartnerReducer,
      isSupplier = props.isSupplier;


  return _react2.default.createElement(
    'div',
    { style: { marginTop: isSupplier ? '30px' : '10px' } },
    'How would you like to add partners? ',
    _react2.default.createElement('br', null),
    _react2.default.createElement('br', null),
    'Note: Sending your marketing materials to users not on TourConnect will generate a connection request. This feature is currently in beta.',
    actionItems.map(function (_ref, index) {
      var text = _ref.text,
          func = _ref.func,
          icon = _ref.icon;
      return _react2.default.createElement(
        'div',
        { key: index, style: { marginTop: (0, _ramda.equals)(index, 0) ? '15px' : '' } },
        _react2.default.createElement(
          _materialUi.RaisedButton,
          {
            label: (0, _ramda.equals)(text, 'Select from connections') && isNilOrEmpty((0, _ramda.propOr)([], 'existingConnections', MMPartnerReducer)) ? text + ' - You do not have any connections' : text,
            labelPosition: 'after',
            labelStyle: { color: '#757575', fontSize: '14px', paddingLeft: '0px', marginLeft: '10px' },
            style: { marginTop: '1%', marginBottom: '1%' },
            onTouchTap: func,
            disabled: (0, _ramda.equals)(text, 'Select from connections') && isNilOrEmpty((0, _ramda.propOr)([], 'existingConnections', MMPartnerReducer))
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: icon, style: { color: '#757575', verticalAlign: 'middle', marginLeft: '10px' } })
        )
      );
    }),
    _react2.default.createElement(_buttons2.default, {
      outerDivStyle: { textAlign: 'right' },
      objectInfoToMap: [{
        labelText: 'Cancel',
        labelStyle: { fontWeight: '600' },
        style: { marginRight: '20px' },
        onTouchTap: function onTouchTap() {
          return updateMMPartnerProp({ sendToPartners: false });
        }
      }, {
        labelText: 'Next',
        labelStyle: { fontWeight: '600' },
        onTouchTap: function onTouchTap() {
          return updateMMPartnerProp({ sendToPartners: false });
        },
        disableButton: (0, _ramda.isEmpty)(addPartnersMethod)
      }]
    })
  );
};

SelectMethod.propTypes = {
  updateMMPartnerProp: _react.PropTypes.func,
  addPartnersMethod: _react.PropTypes.string,
  actionItems: _react.PropTypes.array,
  MMPartnerReducer: _react.PropTypes.object,
  isSupplier: _react.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var marketingMaterials = _ref2.marketingMaterials;
  return {
    MMPartnerReducer: marketingMaterials.partnerReducer.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SelectMethod);

/***/ }),
/* 3152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Buttons = function Buttons(props) {
  var outerDivStyle = props.outerDivStyle,
      objectInfoToMap = props.objectInfoToMap;


  return _react2.default.createElement(
    'div',
    { style: outerDivStyle },
    objectInfoToMap.map(function (buttonInfo, index) {
      return _react2.default.createElement(_materialUi.FlatButton, {
        key: index,
        label: buttonInfo.labelText,
        labelStyle: buttonInfo.labelStyle,
        style: buttonInfo.style,
        onTouchTap: buttonInfo.onTouchTap,
        primary: (0, _ramda.propEq)('labelText', 'Cancel', buttonInfo),
        secondary: (0, _ramda.propEq)('labelText', 'Save', buttonInfo) || (0, _ramda.propEq)('labelText', 'Next', buttonInfo),
        disabled: (0, _ramda.propEq)('labelText', 'Save', buttonInfo) || (0, _ramda.propEq)('labelText', 'Next', buttonInfo) ? buttonInfo.disableButton : false
      });
    })
  );
};

Buttons.propTypes = {
  outerDivStyle: _react.PropTypes.object,
  objectInfoToMap: _react.PropTypes.array
};

exports.default = Buttons;

/***/ }),
/* 3153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBar = function SearchBar(props) {
  var value = props.value,
      onChangeFunc = props.onChangeFunc,
      isEditable = props.isEditable,
      isSupplier = props.isSupplier;


  return _react2.default.createElement(
    'div',
    { style: { width: '100%', marginTop: '10px' } },
    !isEditable && !isSupplier ? _react2.default.createElement('span', null) : _react2.default.createElement(_materialUi.TextField, {
      style: { border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', maxHeight: '34px' },
      inputStyle: { fontSize: '14px', whiteSpace: 'pre-wrap', padding: '0px 3px' },
      underlineShow: false,
      value: value,
      onChange: onChangeFunc,
      hintText: _ramda2.default.call(_ramda2.default.ifElse(_ramda2.default.equals(true), function () {
        return _ramda2.default.call(_ramda2.default.ifElse(_ramda2.default.equals(true), _ramda2.default.always('Search for a filename, location, or product...'), _ramda2.default.always('Search for a filename...')), isSupplier);
      }, _ramda2.default.always('Search for a location or product...')), isEditable),
      hintStyle: { marginLeft: '5px', lineHeight: '34px', top: '-1px' }
    })
  );
};

SearchBar.propTypes = {
  value: _react.PropTypes.string,
  onChangeFunc: _react.PropTypes.func,
  isEditable: _react.PropTypes.bool,
  isSupplier: _react.PropTypes.bool
};

exports.default = SearchBar;

/***/ }),
/* 3154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var Tags = function Tags(props) {
  var MMReducer = props.MMReducer,
      updateMMProp = props.updateMMProp;


  var combineLocationAndProduct = MMReducer.locationTags.concat(MMReducer.productTags);
  var convertToSelectField = combineLocationAndProduct.map(function (obj) {
    return { value: obj.id, label: obj.name };
  });
  var selectedTagNames = (0, _ramda.flatten)(MMReducer.tags.map(function (id) {
    return combineLocationAndProduct.filter(function (obj) {
      return obj.id === id;
    }).map(function (obj) {
      return obj.name;
    });
  }));

  var editState = function editState() {
    var addIndex = MMReducer.media.map(function (obj, index) {
      return (0, _ramda.merge)(obj, { index: index });
    });
    var selectedFilesForTags = addIndex.filter(function (obj) {
      if (MMReducer.tags.every(function (i) {
        return (obj.tags || []).indexOf(i) !== -1;
      })) return obj;
    });
    return _react2.default.createElement(
      'div',
      { style: { border: (0, _ramda.equals)(MMReducer.tagsStep, 1) ? '1px solid #d3d3d3' : '', padding: '10px' } },
      _react2.default.createElement(
        'b',
        null,
        'Step One:'
      ),
      ' Select which location(s) / product(s) you would like to manage.',
      _react2.default.createElement(
        'div',
        { style: { marginTop: '10px' } },
        _react2.default.createElement(_reactSelect2.default, {
          name: 'mmTags',
          onChange: function onChange(value) {
            return updateMMProp({ tags: value.map(function (obj) {
                return obj.value;
              }) });
          },
          options: convertToSelectField,
          value: MMReducer.tags,
          multi: true,
          clearable: false
        })
      ),
      _react2.default.createElement(
        'div',
        { style: { display: 'block', textAlign: 'right', marginTop: '10px' } },
        _react2.default.createElement(_materialUi.RaisedButton, {
          key: 'MMNextButton',
          label: 'Next',
          labelStyle: { fontWeight: '600', top: '4px' },
          onTouchTap: function onTouchTap() {
            return updateMMProp({
              tagsStep: 2,
              selectedFiles: selectedFilesForTags
            });
          },
          secondary: true,
          disabled: isNilOrEmpty(MMReducer.tags),
          style: { width: '80px', borderRadius: '3px', height: '32px' }
        })
      )
    );
  };

  var displayState = function displayState() {
    return _react2.default.createElement(
      'div',
      null,
      'Managing tags for: ',
      _react2.default.createElement(
        'b',
        null,
        [selectedTagNames.slice(0, -1).join(', '), selectedTagNames.slice(-1)[0]].join(selectedTagNames.length < 2 ? '' : ', and ')
      ),
      '.',
      _react2.default.createElement(
        _materialUi.FlatButton,
        {
          secondary: true,
          hoverColor: 'none',
          style: { fontSize: '12px' },
          label: 'Edit',
          labelStyle: { paddingLeft: '3px' },
          labelPosition: 'after',
          onTouchTap: function onTouchTap() {
            return updateMMProp({ tagsStep: 1 });
          }
        },
        _react2.default.createElement(_materialUi.FontIcon, {
          className: 'tc-icon-mode_edit',
          style: { color: '#00bcd4', cursor: 'pointer', fontSize: '14px' }
        })
      )
    );
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h5',
      { style: { color: 'rgba(0, 0, 0, 0.54)' } },
      'You can assign tags to files so that they also appear on your location or product profiles.'
    ),
    (0, _ramda.equals)(MMReducer.tagsStep, 1) ? editState() : displayState()
  );
};

Tags.propTypes = {
  MMReducer: _react.PropTypes.object,
  updateMMProp: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var marketingMaterials = _ref.marketingMaterials;
  return {
    MMReducer: marketingMaterials.mainReducer.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Tags);

/***/ }),
/* 3155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/sindresorhus/multi-download


var _actions = __webpack_require__(537);

// takes an array of objs containing url and fileName:
// [{
//   url,
//   fileName,
// }]

function fallback(urls) {
	var i = 0;

	(function createIframe() {
		var frame = document.createElement('iframe');
		frame.style.display = 'none';
		frame.src = urls[i++];
		document.documentElement.appendChild(frame);

		// the download init has to be sequential otherwise IE only use the first
		var interval = setInterval(function () {
			if (frame.contentWindow.document.readyState === 'complete' || frame.contentWindow.document.readyState === 'interactive') {
				clearInterval(interval);

				// Safari needs a timeout
				setTimeout(function () {
					frame.parentNode.removeChild(frame);
				}, 1000);

				if (i < urls.length) {
					createIframe();
				}
			}
		}, 100);
	})();
}

function isFirefox() {
	// sad panda :(
	return (/Firefox\//i.test(navigator.userAgent)
	);
}

function sameDomain(url) {
	var a = document.createElement('a');
	a.href = url;

	return location.hostname === a.hostname && location.protocol === a.protocol;
}

function download(file) {
	var a = document.createElement('a');
	a.download = file.fileName || '';
	a.setAttribute('download', file.fileName);
	a.href = '/proxy/s3/file?key=' + encodeURIComponent(file.url);
	// firefox doesn't support `a.click()`...
	a.dispatchEvent(new MouseEvent('click'));
}

module.exports = {
	multiDownload: function multiDownload(files) {
		if (!files) {
			throw new Error('`files` required');
		}
		(0, _actions.bulkDownloadS3File)(files, 'bulkDownload');
		// if (typeof document.createElement('a').download === 'undefined') {
		// 	return fallback(files);
		// }
		//
		// var delay = 0;
		//
		// files.forEach(file => {
		// 	// the download init has to be sequential for firefox if the urls are not on the same domain
		// 	if (isFirefox() && !sameDomain(file.url)) {
		// 		return setTimeout(download.bind(null, file.url), 100 * ++delay);
		// 	}
		//
		// 	download(file);
		// });
	}
};

/***/ }),
/* 3156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _editState = __webpack_require__(3157);

var _editState2 = _interopRequireDefault(_editState);

var _displayState = __webpack_require__(3160);

var _displayState2 = _interopRequireDefault(_displayState);

var _actions = __webpack_require__(1247);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MembershipsContainer = function MembershipsContainer(props) {
  var updateProfileBadges = props.updateProfileBadges,
      updateProps = props.updateProps,
      isEditable = props.isEditable,
      membershipsReducer = props.membershipsReducer,
      deleteOneOrganization = props.deleteOneOrganization,
      user = props.user,
      companyProfile = props.companyProfile;


  var companyIdForCompanyProfile = !isEditable ? (0, _ramda.prop)(0, Object.keys(companyProfile)) : undefined;
  var checkIfIsEditable = isEditable ? membershipsReducer.memberships : (0, _ramda.prop)('companyBadges', companyProfile[companyIdForCompanyProfile]);
  var checkForDeletedOrg = checkIfIsEditable.filter(function (org) {
    return !org.delete;
  });
  var isSupplier = (0, _ramda.equals)(user.user.type, 'Supplier');

  var sortedMemberships = checkForDeletedOrg.sort(function (a, b) {
    if (a.badgeId === '5ec074e495512b0156baf64f') return -1;
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  });

  var sharedProps = {
    updateProps: updateProps,
    isEditable: isEditable,
    membershipsReducer: membershipsReducer,
    deleteOneOrganization: deleteOneOrganization,
    isSupplier: isSupplier,
    sortedMemberships: sortedMemberships
  };

  var companyId = user.user.userID;

  return _react2.default.createElement(
    'div',
    { id: 'membership' },
    !isEditable || !membershipsReducer.membershipsEditState ? _react2.default.createElement(_displayState2.default, sharedProps) : _react2.default.createElement(_editState2.default, _extends({
      updateProfileBadge: function updateProfileBadge(memberships) {
        return updateProfileBadges(companyId, (0, _ramda.merge)(memberships, { companyName: companyProfile.companyName }));
      }
    }, sharedProps))
  );
};

MembershipsContainer.propTypes = {
  updateProps: _react.PropTypes.func,
  isEditable: _react.PropTypes.bool,
  saveProfileField: _react.PropTypes.func,
  membershipsReducer: _react.PropTypes.object,
  deleteOneOrganization: _react.PropTypes.func,
  dispatch: _react.PropTypes.func,
  user: _react.PropTypes.object,
  companyProfile: _react.PropTypes.object
};

var mapStateToProps = function mapStateToProps(_ref) {
  var membershipsReducer = _ref.membershipsReducer,
      user = _ref.user,
      companyProfile = _ref.companyProfile;
  return {
    membershipsReducer: membershipsReducer.toJS(),
    user: user.toJS(),
    companyProfile: companyProfile.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  updateProfileBadges: _actions.updateProfileBadges,
  updateProps: _actions.updateProps
})(MembershipsContainer);

/***/ }),
/* 3157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _rightSideLayout = __webpack_require__(1950);

var _rightSideLayout2 = _interopRequireDefault(_rightSideLayout);

var _addOrg = __webpack_require__(3158);

var _addOrg2 = _interopRequireDefault(_addOrg);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditMemberships = function EditMemberships(props) {
  var updateProps = props.updateProps,
      membershipsReducer = props.membershipsReducer,
      deleteOneOrganization = props.deleteOneOrganization,
      updateProfileBadge = props.updateProfileBadge,
      isSupplier = props.isSupplier,
      sortedMemberships = props.sortedMemberships;


  var updateMembershipsEditState = function updateMembershipsEditState(membershipsEditState) {
    updateProps({
      membershipsEditState: membershipsEditState,
      cancelClicked: false
    });
  };

  return _react2.default.createElement(_rightSideLayout2.default, {
    isSupplier: isSupplier,
    leftColumnContentText: 'Industry Memberships / Organizations',
    rightColumnContentText: membershipsReducer.membershipsEditState ? _react2.default.createElement('span', null) : _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_materialUi.FlatButton, {
        label: 'Edit',
        labelStyle: { color: 'rgba(0, 0, 0, 0.54)', fontWeight: '600' },
        style: { backgroundColor: '#d8d8d8', width: '8vw', height: '28px', lineHeight: '1.5' },
        onTouchTap: function onTouchTap() {
          return updateMembershipsEditState(true);
        }
      })
    ),
    mainContent: _react2.default.createElement(
      'div',
      { style: isSupplier ? { padding: '1% 2.2%' } : { marginBottom: '20px' } },
      sortedMemberships.length ? _react2.default.createElement(
        'div',
        null,
        sortedMemberships.filter(function (org) {
          return !org.delete && org.badgeId !== '5ec074e495512b0156baf64f';
        }).map(function (membership, index) {
          return _react2.default.createElement(
            'div',
            { key: index },
            _react2.default.createElement(_twoColumnRow2.default, {
              leftColumnContent: _react2.default.createElement(
                'span',
                { style: { display: 'inline-block' } },
                membership.name,
                membershipsReducer.membershipsEditState ? _react2.default.createElement(_materialUi.IconButton, {
                  iconClassName: 'tc-icon-delete2',
                  iconStyle: { color: 'rgba(0, 0, 0, 0.54)', margin: '-10px 0 0 -20px', verticalAlign: 'middle' },
                  onTouchTap: function onTouchTap() {
                    deleteOneOrganization(membership.name);
                    updateProps({ disableMembershipsSaveButton: false });
                  }
                }) : _react2.default.createElement('span', null)
              ),
              leftColumnStyle: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', textAlign: 'left', width: '45%' },
              rightColumnStyle: { width: '50%', marginRight: '10px' },
              rightColumnContent: _react2.default.createElement(_materialUi.TextField, {
                name: 'membershipId',
                key: 'membershipTF' + membership.name,
                id: 'membershipTF' + membership.name,
                value: membership.membershipId || '',
                onChange: function onChange(_ref) {
                  var value = _ref.target.value;

                  var newObj = {
                    name: membership.name,
                    membershipId: value,
                    type: 'organization',
                    verifiedStatus: 'pending',
                    badgeId: membership.badgeId,
                    companyBadgeId: membership.companyBadgeId
                  };
                  var omitOldObj = membershipsReducer.memberships.filter(function (org) {
                    return org.name !== membership.name;
                  });
                  updateProps({ memberships: omitOldObj.concat([newObj]) });
                },
                style: { border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px', margin: '5px 0 15px 0' },
                inputStyle: { fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' },
                underlineShow: false,
                hintText: 'Membership ID',
                hintStyle: { marginLeft: '5px', fontSize: '12px', marginBottom: '-5px', maxHeight: '20px' }
              })
            })
          );
        })
      ) : _react2.default.createElement('span', null),
      _react2.default.createElement(_addOrg2.default, null),
      membershipsReducer.showAddAnotherOrganizationButton ? _react2.default.createElement(
        'div',
        {
          className: 'div-link',
          style: { fontSize: '14px', textAlign: 'left', marginLeft: '30.5%', marginTop: '-5px', display: 'inline-block', fontWeight: '600' },
          onClick: function onClick() {
            return updateProps({
              resetOtherMembershipObj: membershipsReducer.otherMembershipValidated || membershipsReducer.membershipValidated,
              showAddAnotherOrganizationButton: false
            });
          }
        },
        'ADD ANOTHER ORGANIZATION'
      ) : _react2.default.createElement('span', null)
    ),
    shouldSaveCancelButtonsShow: membershipsReducer.membershipsEditState,
    saveCancelOuterDivStyle: isSupplier ? { paddingBottom: '3%', textAlign: 'right', marginRight: '27px', clear: 'both', paddingTop: membershipsReducer.showAddAnotherOrganizationButton ? '10px' : '20px' } : { textAlign: 'right', marginRight: '10px', clear: 'both', paddingTop: membershipsReducer.showAddAnotherOrganizationButton ? '10px' : '20px' },
    cancelOnTouchTapFunc: function cancelOnTouchTapFunc() {
      updateMembershipsEditState(false);
      updateProps({ cancelMembershipsClicked: true });
    },
    saveOnTouchTapFunc: function saveOnTouchTapFunc() {
      updateMembershipsEditState(false);
      updateProps({
        originalMemberships: membershipsReducer.memberships,
        resetOtherMembershipObj: true,
        membershipsCompleted: true,
        showAddAnotherOrganizationButton: false
      });
      updateProfileBadge({ memberships: (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.propEq)('otherMembershipValidated', true), (0, _ramda.always)(membershipsReducer.memberships.concat([membershipsReducer.otherMembership]))], [(0, _ramda.propEq)('membershipValidated', true), (0, _ramda.always)(membershipsReducer.memberships.concat([membershipsReducer.membership]))], [_ramda.T, (0, _ramda.always)(membershipsReducer.memberships)]]), membershipsReducer) });
    },
    shouldSaveButtonBeDisabled: membershipsReducer.disableMembershipsSaveButton
  });
};

EditMemberships.propTypes = {
  membershipsReducer: _react.PropTypes.object,
  updateProps: _react.PropTypes.func,
  updateProfileBadge: _react.PropTypes.func,
  deleteOneOrganization: _react.PropTypes.func,
  isSupplier: _react.PropTypes.bool,
  sortedMemberships: _react.PropTypes.array
};

exports.default = EditMemberships;

/***/ }),
/* 3158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _actions = __webpack_require__(1247);

var _addOrgLink = __webpack_require__(3159);

var _addOrgLink2 = _interopRequireDefault(_addOrgLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var AddOrg = function (_Component) {
  _inherits(AddOrg, _Component);

  function AddOrg() {
    _classCallCheck(this, AddOrg);

    var _this = _possibleConstructorReturn(this, (AddOrg.__proto__ || Object.getPrototypeOf(AddOrg)).call(this));

    _this.state = {
      searchingForOrg: '',
      filteredOrgList: null,
      showListOfOrganizationsDropdown: false
    };
    return _this;
  }

  _createClass(AddOrg, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (_ramda2.default.isEmpty(nextProps.membership) && _ramda2.default.isEmpty(nextProps.otherMembership)) {
        this.state = {
          searchingForOrg: '',
          filteredOrgList: null,
          showListOfOrganizationsDropdown: false
        };
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          updateProps = _props.updateProps,
          listOfAvailableOrganizations = _props.listOfAvailableOrganizations,
          membership = _props.membership,
          otherMembership = _props.otherMembership,
          userMemberships = _props.userMemberships;
      var _state = this.state,
          searchingForOrg = _state.searchingForOrg,
          filteredOrgList = _state.filteredOrgList,
          showListOfOrganizationsDropdown = _state.showListOfOrganizationsDropdown;


      var selectFieldOptions = function selectFieldOptions() {
        var membershipList = [];
        (showListOfOrganizationsDropdown ? listOfAvailableOrganizations : filteredOrgList).map(function (org) {
          return membershipList.push({ value: org.name, label: org.name });
        });
        var uniqueOrganizations = [];
        var existingOrganizations = userMemberships.map(function (org) {
          if (!org.delete) return org.name;
        });
        var organizationsFromDropdown = membershipList.map(function (org) {
          return org.value;
        });
        var duplicatedOrganizations = _ramda2.default.intersection(existingOrganizations, organizationsFromDropdown);
        membershipList.map(function (org) {
          if (!_ramda2.default.contains(org.value, duplicatedOrganizations)) uniqueOrganizations.push(org);
        });
        return uniqueOrganizations;
      };

      var findSelectedOrganizationInfo = function findSelectedOrganizationInfo(organizationName) {
        return listOfAvailableOrganizations.filter(function (org) {
          return org.name === organizationName;
        });
      };
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { float: 'left', color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', width: '45%' } },
          _react2.default.createElement(
            'span',
            null,
            'Organization Name'
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { float: 'right', width: '50%', marginRight: '10px', zIndex: '1' } },
          _react2.default.createElement(_materialUi.TextField, {
            name: 'organizationDropdown',
            key: 'organizationDropdown',
            id: 'organizationDropdown',
            value: searchingForOrg,
            onChange: function onChange(_ref) {
              var value = _ref.target.value;

              _this2.setState({ searchingForOrg: value });
              if (isNilOrEmpty(value)) {
                _this2.setState({ filteredOrgList: null });
                updateProps({ membership: {}, otherMembership: {}, showAddAnotherOrganizationButton: false });
              } else {
                _this2.setState({ showListOfOrganizationsDropdown: false, filteredOrgList: listOfAvailableOrganizations.filter(function (org) {
                    return org.name.toLowerCase().includes(searchingForOrg.toLowerCase());
                  }) });
              }
            },
            style: { border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px', marginBottom: '15px' },
            inputStyle: { fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' },
            underlineShow: false,
            hintText: _react2.default.createElement(
              'div',
              { style: { width: '100%', height: '25px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' } },
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', marginLeft: '5px' } },
                'Search For Organization...'
              ),
              _react2.default.createElement(
                'div',
                { style: { display: 'flex' } },
                _react2.default.createElement(_materialUi.IconButton, { iconClassName: 'tc-icon-arrow-drop-down', onTouchTap: function onTouchTap() {
                    return _this2.setState({ showListOfOrganizationsDropdown: !showListOfOrganizationsDropdown });
                  } })
              )
            ),
            hintStyle: { fontSize: '12px', width: '100%', height: '34px', top: '5px' }
          }),
          _react2.default.createElement(
            'div',
            { style: { margin: '-15px 0 10px 0', maxHeight: '300px', overflowY: 'scroll' } },
            (!isNilOrEmpty(filteredOrgList) && isNilOrEmpty(membership) || showListOfOrganizationsDropdown) && selectFieldOptions().map(function (org, i) {
              return _react2.default.createElement(_materialUi.ListItem, {
                key: i,
                style: { border: '1px solid #eeeeee', minHeight: '34px', overflow: 'hidden' },
                primaryText: _react2.default.createElement(
                  'div',
                  { style: { color: 'rgba(0, 0, 0, 0.54)', marginTop: '-7px', fontSize: 'calc(8px + 0.4vw)' } },
                  _react2.default.createElement(
                    'div',
                    { style: { float: 'left', width: '70%', marginBottom: '5px' } },
                    org.label
                  )
                ),
                rightIconButton: _react2.default.createElement(_addOrgLink2.default, { orgInfo: findSelectedOrganizationInfo(org.label) }),
                onTouchTap: function onTouchTap() {
                  _this2.setState({ searchingForOrg: org.value, showListOfOrganizationsDropdown: false });
                  updateProps({
                    membership: _ramda2.default.merge(membership, {
                      name: org.value,
                      type: 'organization',
                      badgeId: _ramda2.default.path([0, 'badgeId'], listOfAvailableOrganizations.filter(function (organ) {
                        return _ramda2.default.equals(organ.name, org.value);
                      }))
                    })
                  });
                }
              });
            })
          ),
          !isNilOrEmpty(searchingForOrg) && isNilOrEmpty(filteredOrgList) && isNilOrEmpty(membership) && _react2.default.createElement(_materialUi.TextField, {
            name: 'otherMembershipId',
            id: 'otherMembershipId',
            value: _ramda2.default.propOr('', 'membershipId', otherMembership),
            onChange: function onChange(_ref2) {
              var value = _ref2.target.value;
              return updateProps({
                otherMembership: {
                  membershipId: value,
                  name: searchingForOrg
                }
              });
            },
            style: { border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px', margin: '5px 0 15px 0' },
            inputStyle: { fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' },
            underlineShow: false,
            hintText: 'Membership ID',
            hintStyle: { marginLeft: '5px', fontSize: '12px', marginBottom: '-5px', maxHeight: '20px' }
          }),
          !isNilOrEmpty(membership) && !isNilOrEmpty(searchingForOrg) && _react2.default.createElement(_materialUi.TextField, {
            name: 'membershipId',
            id: 'membershipId',
            value: _ramda2.default.propOr('', 'membershipId', membership),
            onChange: function onChange(_ref3) {
              var value = _ref3.target.value;
              return updateProps({
                membership: _ramda2.default.merge(membership, {
                  membershipId: value,
                  badgeId: _ramda2.default.path([0, 'badgeId'], listOfAvailableOrganizations.filter(function (org) {
                    return _ramda2.default.equals(org.name, membership.name);
                  }))
                })
              });
            },
            style: { border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px', margin: '5px 0 15px 0' },
            inputStyle: { fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' },
            underlineShow: false,
            hintText: 'Membership ID',
            hintStyle: { marginLeft: '5px', fontSize: '12px', marginBottom: '-5px', maxHeight: '20px' }
          })
        )
      );
    }
  }]);

  return AddOrg;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref4) {
  var membershipsReducer = _ref4.membershipsReducer,
      user = _ref4.user,
      companyProfile = _ref4.companyProfile;
  return {
    listOfAvailableOrganizations: membershipsReducer.get('listOfAvailableOrganizations').toJS(),
    membership: membershipsReducer.get('membership').toJS(),
    user: user.toJS(),
    companyProfile: companyProfile.toJS(),
    userMemberships: membershipsReducer.get('memberships').toJS(),
    otherMembership: membershipsReducer.get('otherMembership').toJS()
  };
};

var mapDispatchToProps = {
  updateProps: _actions.updateProps
};

AddOrg.propTypes = {
  updateProps: _react.PropTypes.func,
  listOfAvailableOrganizations: _react.PropTypes.array,
  userMemberships: _react.PropTypes.array,
  membership: _react.PropTypes.object,
  otherMembership: _react.PropTypes.object
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddOrg);

/***/ }),
/* 3159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  var _props$orgInfo = _slicedToArray(props.orgInfo, 1),
      _props$orgInfo$ = _props$orgInfo[0],
      acronym = _props$orgInfo$.acronym,
      website = _props$orgInfo$.website,
      name = _props$orgInfo$.name;

  var openLinkNewPage = function openLinkNewPage(e) {
    window.open(website, '_blank');
    e.preventDefault();
    e.stopPropagation();
  };
  return Boolean(website) ? _react2.default.createElement(
    'div',
    { style: { position: 'absolute', display: 'block', top: '8px', right: '4px', width: '29%', fontSize: '10px' } },
    'What is ',
    _react2.default.createElement(
      'a',
      { onTouchTap: openLinkNewPage },
      _react2.default.createElement(
        'span',
        { style: {
            display: 'inline-block',
            marginBottom: '-4px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '60px'
          }
        },
        acronym || name
      )
    ),
    ' ?'
  ) : null;
};

/***/ }),
/* 3160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _rightSideLayout = __webpack_require__(1950);

var _rightSideLayout2 = _interopRequireDefault(_rightSideLayout);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _membershipsText = __webpack_require__(3161);

var _getVerified = __webpack_require__(1862);

var _getVerified2 = _interopRequireDefault(_getVerified);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisplayMemberships = function DisplayMemberships(props) {
  var updateProps = props.updateProps,
      isEditable = props.isEditable,
      membershipsReducer = props.membershipsReducer,
      sortedMemberships = props.sortedMemberships,
      isSupplier = props.isSupplier;

  var generateExistingBadges = function generateExistingBadges(isColoredIcon, name) {
    return (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('National Tour Association (NTA)'), function () {
      return (0, _membershipsText.ntaIcon)(isColoredIcon);
    }], [(0, _ramda.equals)('European Tourism Association (ETOA)'), function () {
      return (0, _membershipsText.etoaIcon)(isColoredIcon);
    }], [_ramda.T, function () {
      return _react2.default.createElement(_materialUi.FontIcon, {
        className: 'tc-icon-hourglass_empty',
        color: 'rgba(0, 0, 0, 0.54)',
        style: { fontSize: '26px', marginLeft: '-5px' }
      });
    }]]), name);
  };

  return _react2.default.createElement(_rightSideLayout2.default, {
    isSupplier: isSupplier,
    leftColumnContentText: 'Industry Memberships / Organizations',
    rightColumnContentText: (0, _ramda.or)(membershipsReducer.membershipsEditState, (0, _ramda.not)(isEditable)) ? _react2.default.createElement('span', null) : _react2.default.createElement(
      'div',
      { style: { marginRight: '10px' } },
      isSupplier ? _react2.default.createElement(
        'div',
        { style: { color: '#00bcd4' }, onTouchTap: function onTouchTap() {
            return updateProps({ membershipsEditState: true });
          } },
        _react2.default.createElement(_materialUi.FontIcon, {
          className: 'tc-icon-mode_edit profile-edit-icon',
          color: '#00bcd4',
          style: { fontSize: '14px' }
        }),
        '\xA0EDIT'
      ) : _react2.default.createElement(_materialUi.RaisedButton, {
        label: 'Edit',
        labelColor: '#00bcd4',
        labelStyle: { top: '3px' },
        style: { width: '8vw', height: '28px' },
        onTouchTap: function onTouchTap() {
          return updateProps({ membershipsEditState: true });
        }
      })
    ),
    mainContent: _react2.default.createElement(
      'div',
      { style: { margin: isSupplier ? '0 15px' : '' } },
      isEditable && !(sortedMemberships || []).find(function (_ref) {
        var badgeId = _ref.badgeId;
        return badgeId === '5ec074e495512b0156baf64f';
      }) && _react2.default.createElement(
        'div',
        { key: 0, className: 'Grid' },
        _react2.default.createElement(
          'div',
          { className: 'Grid-cell Grid--1of3 verified-member-block', style: { maxWidth: '25%', wordWrap: 'break-word', margin: '5px 2% 0 0' } },
          _react2.default.createElement('img', { src: 'https://s3.amazonaws.com/tourconnect_production/0000105302651/tc_verified.jpg', height: '30px' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'Grid-cell Grid--1of3 Grid-cell--center', style: { maxWidth: isSupplier ? '55%' : '39%', wordWrap: 'break-word', marginRight: '2%' } },
          _react2.default.createElement(
            'p',
            { style: { color: isSupplier ? 'rgba(0, 0, 0, 0.54)' : 'rgba(0, 0, 0, 0.87)', fontSize: '14px' } },
            'TourConnect Verified'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'Grid-cell Grid--1of3', style: { wordWrap: 'break-word', margin: '5px 2% 0 0', textAlign: isSupplier ? 'right' : 'center' } },
          _react2.default.createElement(_getVerified2.default, null)
        )
      ),
      sortedMemberships && sortedMemberships.length ? sortedMemberships.map(function (membership, index) {
        if ((0, _ramda.equals)(membership.verifiedStatus, 'verified') && !isEditable || isEditable) {
          return _react2.default.createElement(
            'div',
            { key: index, className: 'Grid' },
            _react2.default.createElement(
              'div',
              { className: 'Grid-cell Grid--1of3 verified-member-block', style: { maxWidth: '25%', wordWrap: 'break-word', margin: '5px 2% 0 0' } },
              membership.logo && _react2.default.createElement('img', { src: membership.logo, height: membership.name === 'European Tourism Association (ETOA)' ? '25px' : '30px' }),
              isSupplier && membership.website && _react2.default.createElement(
                'span',
                { className: 'what-is-org-hover' },
                'What is ',
                _react2.default.createElement(
                  'a',
                  { href: (0, _ramda.prop)('website', membership), style: { color: '#ff4081' }, target: '_blank' },
                  membership.acronym ? membership.acronym : membership.name
                ),
                '?'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'Grid-cell Grid--1of3 Grid-cell--center', style: { maxWidth: isSupplier ? '55%' : '39%', wordWrap: 'break-word', marginRight: '2%' } },
              _react2.default.createElement(
                'p',
                { style: { color: isSupplier ? 'rgba(0, 0, 0, 0.54)' : 'rgba(0, 0, 0, 0.87)', fontSize: '14px' } },
                membership.name
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'Grid-cell Grid--1of3', style: { maxWidth: isSupplier ? '10%' : '39%', wordWrap: 'break-word', margin: '5px 2% 0 0', textAlign: isSupplier ? 'right' : 'center' } },
              {
                verified: _react2.default.createElement(
                  'span',
                  { style: { color: '#00bcd4' } },
                  'Verified'
                ),
                rejected: _react2.default.createElement(
                  'span',
                  { style: { color: '#ff4081' } },
                  'Rejected'
                )
              }[membership.verifiedStatus] || _react2.default.createElement(
                'span',
                null,
                'Pending'
              )
            )
          );
        }
      }) : _react2.default.createElement(
        'div',
        { style: { paddingBottom: '16px' } },
        'Did you know, a verified membership can get you to the top of our PartnerFinder search results? ',
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'a',
          { style: { cursor: 'pointer' }, onClick: function onClick() {
              return updateProps({ membershipsEditState: true });
            } },
          'Add a membership now'
        )
      )
    )
  });
};

DisplayMemberships.propTypes = {
  updateProps: _react.PropTypes.func,
  isEditable: _react.PropTypes.bool,
  membershipsReducer: _react.PropTypes.object,
  sortedMemberships: _react.PropTypes.array,
  isSupplier: _react.PropTypes.bool
};

exports.default = DisplayMemberships;

/***/ }),
/* 3161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ntaIcon = exports.etoaIcon = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var etoaIcon = exports.etoaIcon = function etoaIcon(isColoredIcon) {
  return _react2.default.createElement(_materialUi.FontIcon, {
    className: 'tc-icon-etoa',
    color: isColoredIcon ? '#00bcd4' : 'rgba(0, 0, 0, 0.54)',
    style: { fontSize: '16px' }
  });
};

var ntaIcon = exports.ntaIcon = function ntaIcon(isColoredIcon) {
  return _react2.default.createElement(_materialUi.FontIcon, {
    className: 'tc-icon-nta',
    color: isColoredIcon ? '#00bcd4' : 'rgba(0, 0, 0, 0.54)',
    style: { fontSize: '26px' }
  });
};

/***/ }),
/* 3162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _marketingProfileReadiness = __webpack_require__(3163);

var _marketingProfileReadiness2 = _interopRequireDefault(_marketingProfileReadiness);

var _beddingConfig = __webpack_require__(3164);

var _beddingConfig2 = _interopRequireDefault(_beddingConfig);

var _destinationsSold = __webpack_require__(3165);

var _destinationsSold2 = _interopRequireDefault(_destinationsSold);

var _marketServed = __webpack_require__(3166);

var _marketServed2 = _interopRequireDefault(_marketServed);

var _interconnectingRooms = __webpack_require__(3167);

var _interconnectingRooms2 = _interopRequireDefault(_interconnectingRooms);

var _companyTypes = __webpack_require__(3168);

var _companyTypes2 = _interopRequireDefault(_companyTypes);

var _marketSegments = __webpack_require__(3169);

var _marketSegments2 = _interopRequireDefault(_marketSegments);

var _passengers = __webpack_require__(3170);

var _passengers2 = _interopRequireDefault(_passengers);

var _roomCount = __webpack_require__(3171);

var _roomCount2 = _interopRequireDefault(_roomCount);

var _roomSize = __webpack_require__(3172);

var _roomSize2 = _interopRequireDefault(_roomSize);

var _taxId = __webpack_require__(3173);

var _taxId2 = _interopRequireDefault(_taxId);

var _tourDuration = __webpack_require__(3174);

var _tourDuration2 = _interopRequireDefault(_tourDuration);

var _memberships = __webpack_require__(3175);

var _memberships2 = _interopRequireDefault(_memberships);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileLeftBarContainer = function (_Component) {
  _inherits(ProfileLeftBarContainer, _Component);

  function ProfileLeftBarContainer() {
    _classCallCheck(this, ProfileLeftBarContainer);

    return _possibleConstructorReturn(this, (ProfileLeftBarContainer.__proto__ || Object.getPrototypeOf(ProfileLeftBarContainer)).apply(this, arguments));
  }

  _createClass(ProfileLeftBarContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          routeName = _props.routeName,
          isEditable = _props.isEditable,
          isSingleLocSupplier = _props.isSingleLocSupplier,
          companyProfileReducer = _props.companyProfileReducer;


      var roomIsEditable = isEditable && (routeName !== 'profile' || routeName === 'profile' && isSingleLocSupplier) && profileToShow.productType === 'accommodation';
      var showInterConnectingRooms = routeName === 'product' && (profileToShow.interconnectingRooms || roomIsEditable);
      var showTourDuration = profileToShow.productType === 'nonAccommodation' && routeName === 'product';
      var showBeddingConfig = routeName === 'product' && (Boolean(_ramda2.default.pathOr(0, ['bedsAndSofas', 'rooms', 'length'], profileToShow)) || roomIsEditable);
      var showDestinationsSold = profileToShow.type === 'Contractor';
      var showMarketServed = profileToShow.type === 'Contractor';
      var showTaxId = isEditable && profileToShow.type === 'Contractor';
      var showCompanyTypes = profileToShow.type === 'Contractor' || profileToShow.type === 'Supplier';
      var showMarketSegments = routeName !== 'product';
      var showMarketingProfileReadiness = isEditable;
      var showPassengers = routeName === 'product' && profileToShow.productType === 'nonAccommodation';
      var showRoomSize = routeName === 'product' && (profileToShow.roomSizeInfo.value && profileToShow.roomSizeInfo.unit || roomIsEditable);
      var showLocationRoomCount = (routeName === 'location' || routeName === 'profile' && isSingleLocSupplier) && Boolean(profileToShow.roomCount || roomIsEditable);
      var showProductRoomCount = Boolean(routeName === 'product' && (profileToShow.roomSizeInfo.value && profileToShow.roomCountInfo.unit || roomIsEditable));
      var roomCountProps = {
        roomIsEditable: roomIsEditable,
        showLocationRoomCount: showLocationRoomCount,
        showProductRoomCount: showProductRoomCount
      };

      var isEditableProps = {
        roomIsEditable: roomIsEditable
      };

      return _react2.default.createElement(
        'div',
        null,
        !isEditable && _react2.default.createElement(_memberships2.default, {
          profileToShow: routeName === 'profile' ? profileToShow : (0, _ramda.merge)(profileToShow, {
            companyBadges: (0, _ramda.propOr)([], 'companyBadges', companyProfileReducer[(0, _ramda.prop)(0, Object.keys(companyProfileReducer))])
          }),
          routeName: routeName,
          isEditable: isEditable,
          isSingleLocSupplier: isSingleLocSupplier
        }),
        showMarketingProfileReadiness ? _react2.default.createElement(_marketingProfileReadiness2.default, null) : undefined,
        showRoomSize ? _react2.default.createElement(_roomSize2.default, _extends({}, isEditableProps, this.props)) : undefined,
        showInterConnectingRooms ? _react2.default.createElement(_interconnectingRooms2.default, _extends({}, isEditableProps, this.props)) : undefined,
        showBeddingConfig ? _react2.default.createElement(_beddingConfig2.default, this.props) : undefined,
        showTourDuration ? _react2.default.createElement(_tourDuration2.default, this.props) : undefined,
        showPassengers ? _react2.default.createElement(_passengers2.default, this.props) : undefined,
        showCompanyTypes ? _react2.default.createElement(_companyTypes2.default, this.props) : undefined,
        showMarketSegments ? _react2.default.createElement(_marketSegments2.default, this.props) : undefined,
        showDestinationsSold && _react2.default.createElement(_destinationsSold2.default, this.props),
        showMarketServed && _react2.default.createElement(_marketServed2.default, this.props),
        showTaxId ? _react2.default.createElement(_taxId2.default, this.props) : undefined,
        showLocationRoomCount || showProductRoomCount ? _react2.default.createElement(_roomCount2.default, _extends({}, roomCountProps, this.props)) : undefined
      );
    }
  }]);

  return ProfileLeftBarContainer;
}(_react.Component);

ProfileLeftBarContainer.propTypes = {
  profileToShow: _react.PropTypes.object,
  routeName: _react.PropTypes.string,
  isEditable: _react.PropTypes.bool,
  isSingleLocSupplier: _react.PropTypes.bool,
  companyProfileReducer: _react.PropTypes.object
};

var mapStateToProps = function mapStateToProps(_ref) {
  var companyProfile = _ref.companyProfile;
  return {
    companyProfileReducer: companyProfile.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ProfileLeftBarContainer);

/***/ }),
/* 3163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(67);

var _scrollToElement = __webpack_require__(859);

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarketingProfileReadiness = function (_Component) {
  _inherits(MarketingProfileReadiness, _Component);

  function MarketingProfileReadiness(props) {
    _classCallCheck(this, MarketingProfileReadiness);

    var _this = _possibleConstructorReturn(this, (MarketingProfileReadiness.__proto__ || Object.getPrototypeOf(MarketingProfileReadiness)).call(this, props));

    _this.state = {
      isMarketingReady: false,
      marketingReadyPercentage: 0,
      marketingReadinessErrors: []
    };
    return _this;
  }

  _createClass(MarketingProfileReadiness, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(next) {
      if (next['isMarketingReady'] !== this.props['isMarketingReady']) {
        // update internal state
        this.setState({
          isMarketingReady: next['isMarketingReady'],
          marketingReadyPercentage: next['marketingReadinessPercentage'],
          marketingReadinessErrors: next['marketingReadinessErrors']
        });
      }
    }
  }, {
    key: 'getRouteToDisplay',
    value: function getRouteToDisplay() {
      var pathname = this.props.pathname;

      if (pathname.indexOf('/profile/product') > -1) return 'Product';
      if (pathname.indexOf('/profile/locations') > -1) return 'Location';
      return 'Profile';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isMarketingReady = _props.isMarketingReady,
          marketingReadyPercentage = _props.marketingReadyPercentage,
          marketingReadinessErrors = _props.marketingReadinessErrors;


      var classes = 'marketing-readiness-div';
      var title = void 0;
      var errors = void 0;
      var routeToDisplay = this.getRouteToDisplay();
      var readinessContainerStyle = {
        position: 'relative',
        display: 'block',
        maxWidth: '100%',
        boxShadow: 'none',
        background: 'rgba(0,0,0,.03)',
        height: '48px',
        borderRadius: '2px 2px 0px 0px'
      };
      if (isMarketingReady && marketingReadyPercentage === 100) {
        title = routeToDisplay + ' Complete!';
        classes += ' marketing-is-ready';
        if (routeToDisplay === 'Profile') {
          errors = _react2.default.createElement(
            'div',
            { className: 'market-readiness-error-container l-paper-split-segment' },
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                ' You are ready to ',
                _react2.default.createElement(
                  'a',
                  { className: 'profile-link-container-link', href: "https://app.tourconnect.com" + '/partner-management/partner-list/partner?jwt=' + localStorage.getItem('jwt') },
                  'add partners'
                ),
                '. '
              ),
              _react2.default.createElement(
                'li',
                null,
                ' You are ready for ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'profile-link-container-link', to: '/contracting/contract-list/recent' },
                  'Rates & Contracting'
                ),
                '. '
              ),
              _react2.default.createElement(
                'li',
                null,
                ' You are visible on ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'profile-link-container-link', to: '/partner-finder/results' },
                  'Partner Finder'
                ),
                '. '
              )
            )
          );
        }
      } else {
        title = routeToDisplay + ': ' + marketingReadyPercentage + '% Complete';
        classes += ' marketing-is-not-ready';
        readinessContainerStyle.border = '1px solid rgba(39,41,43,.15)';
        readinessContainerStyle.borderBottom = '0px';
        errors = _react2.default.createElement(
          'div',
          { className: 'market-readiness-error-container l-paper-split-segment' },
          _react2.default.createElement(
            'ul',
            null,
            (marketingReadinessErrors || []).map(function (error, index) {
              return _react2.default.createElement(
                'li',
                {
                  key: index,
                  onTouchTap: error.warning.includes('contact') ? function () {
                    var scrollToAnchor = function scrollToAnchor() {
                      var element = document.querySelector('#contactsNode');
                      if (element) (0, _scrollToElement2.default)('#contactsNode', { offset: -70 });
                    };
                    scrollToAnchor();
                  } : error.scrollTo,
                  className: 'underline',
                  style: { cursor: 'pointer', color: '#00bcd4' }
                },
                error.warning
              );
            })
          )
        );
      }

      var color = marketingReadyPercentage === 100 ? '#5bbd72' : '#f2c037';
      var textColor = marketingReadyPercentage === 100 ? 'white' : 'rgba(0, 0, 0, 0.870588)';
      return _react2.default.createElement(
        'div',
        {
          className: classes,
          style: { marginTop: '32px' }
        },
        _react2.default.createElement(
          'div',
          { style: readinessContainerStyle },
          _react2.default.createElement(
            'div',
            {
              style: {
                transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
                position: 'absolute',
                width: marketingReadyPercentage + '%',
                height: '100%',
                zIndex: '-1',
                backgroundColor: color,
                top: 0
              }
            },
            '\xA0'
          ),
          _react2.default.createElement(
            'div',
            {
              style: {
                padding: '0 6px',
                textAlign: 'center',
                lineHeight: '48px',
                verticalAlign: 'middle',
                fontSize: '18px',
                color: textColor
              }
            },
            title
          )
        ),
        errors
      );
    }
  }]);

  return MarketingProfileReadiness;
}(_react.Component);

MarketingProfileReadiness.propTypes = {
  isMarketingReady: _react.PropTypes.bool,
  marketingReadinessErrors: _react.PropTypes.array,
  marketingReadyPercentage: _react.PropTypes.number,
  pathname: _react.PropTypes.string,
  routeName: _react.PropTypes.string,
  singleLoc: _react.PropTypes.bool
};

var select = function select(_ref) {
  var user = _ref.user,
      profile = _ref.profile,
      profileLocation = _ref.profileLocation,
      profileProduct = _ref.profileProduct,
      routing = _ref.routing;

  var defaultMap = {
    pathname: routing.locationBeforeTransitions.pathname,
    singleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop'
  };
  if (defaultMap.pathname.indexOf('/profile/product') > -1) {
    // at a product
    var productId = defaultMap.pathname.split('/').pop().toString();
    return _extends({}, defaultMap, {
      isMarketingReady: profileProduct.getIn([productId, 'isMarketingReady']),
      marketingReadyPercentage: profileProduct.getIn([productId, 'marketingReadinessPercentage']) || 0,
      marketingReadinessErrors: profileProduct.getIn([productId, 'marketingReadinessErrors'])
    });
  }
  if (defaultMap.singleLoc) {
    // single locations have two pages in one
    var locationId = profile.getIn(['locations', 0, 'id']);
    var filteredCompanyErrors = (profile.get('marketingReadinessErrors') || []).filter(function (x) {
      return x.warning !== 'At least 1 complete location is required.' && x.warning !== 'At least 1 contact is required.';
    });
    return _extends({}, defaultMap, {
      isMarketingReady: profileLocation.getIn([locationId, 'isMarketingReady']) && profile.get('isMarketingReady'),
      marketingReadyPercentage: Math.min(profileLocation.getIn([locationId, 'marketingReadinessPercentage']) || 0, profile.get('marketingReadinessPercentage') || 0),
      marketingReadinessErrors: _ramda2.default.uniqBy(function (x) {
        return x.warning;
      }, (profileLocation.getIn([locationId, 'marketingReadinessErrors']) || []).concat(filteredCompanyErrors))
    });
  }
  if (defaultMap.pathname.indexOf('/profile/locations') > -1) {
    // at a location
    var _locationId = defaultMap.pathname.split('/').pop().toString();
    return _extends({}, defaultMap, {
      isMarketingReady: profileLocation.getIn([_locationId, 'isMarketingReady']),
      marketingReadyPercentage: profileLocation.getIn([_locationId, 'marketingReadinessPercentage']) || 0,
      marketingReadinessErrors: profileLocation.getIn([_locationId, 'marketingReadinessErrors'])
    });
  }
  return _extends({}, defaultMap, {
    isMarketingReady: profile.get('isMarketingReady'),
    marketingReadyPercentage: profile.get('marketingReadinessPercentage') || 0,
    marketingReadinessErrors: profile.get('marketingReadinessErrors')
  });
};

exports.default = (0, _reactRedux.connect)(select, {})(MarketingProfileReadiness);

/***/ }),
/* 3164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _selectFields = __webpack_require__(141);

var _beddingConfigurationDumb = __webpack_require__(1911);

var _beddingConfigurationDumb2 = _interopRequireDefault(_beddingConfigurationDumb);

var _functional = __webpack_require__(872);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BeddingConfig = function (_Component) {
  _inherits(BeddingConfig, _Component);

  function BeddingConfig() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BeddingConfig);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BeddingConfig.__proto__ || Object.getPrototypeOf(BeddingConfig)).call.apply(_ref, [this].concat(args))), _this), _this._editBeddingConfig = function (index) {
      var editField = _this.props.editField;

      var options = _selectFields.beddingConfigOptions;
      editField('bedsAndSofas', {
        type: 'bedsAndSofas',
        isRequired: true,
        index: index,
        options: options
      });
    }, _this._removeBeddingConfig = function (index) {
      var updateBeddingConfigs = (0, _ramda.compose)(_this.props._saveField, function (updateBody) {
        return { updateField: 'bedsAndSofas', updateBody: updateBody };
      }, (0, _functional.removeAtIndex)(index), (0, _ramda.pathOr)([], ['profileToShow', 'bedsAndSofas']));
      updateBeddingConfigs(_this.props);
    }, _this._addBeddingConfig = function () {
      var options = _selectFields.beddingConfigOptions;
      _this.props.editField('bedsAndSofas', { type: 'bedsAndSofas',
        initialValue: _this.props.profileToShow.bedsAndSofas,
        index: _this.props.profileToShow.bedsAndSofas.length,
        options: options
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BeddingConfig, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _functional.notEqual)(this.props.routeName, nextProps.routeName)) this.setState({ showResults: false });
    }
  }, {
    key: 'getListElementStyle',
    value: function getListElementStyle(width, height, otherCss) {
      return _extends({
        display: 'inline-block',
        fontSize: '14px',
        fontWeight: '400',
        color: 'rgb(54%, 54%, 54%)',
        lineHeight: '21px',
        overflow: 'auto',
        clear: 'both',
        paddingRight: '16px',
        height: height || 'auto',
        verticalAlign: 'top',
        width: width
      }, otherCss || {});
    }
  }, {
    key: 'getHeaderStyle',
    value: function getHeaderStyle(width) {
      return {
        display: 'inline-block',
        fontSize: '14px',
        fontWeight: '600',
        color: 'rgb(54%, 54%, 54%)',
        marginRight: '16px',
        width: width
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isEditable = this.props.isEditable;

      var title = 'Bedding Configuration';
      var bedsAndSofas = (0, _ramda.pathOr)([], ['profileToShow', 'bedsAndSofas'], this.props);
      var hasContent = (0, _ramda.call)((0, _ramda.compose)((0, _ramda.ifElse)(_ramda.isNil, (0, _ramda.always)(false), (0, _ramda.compose)((0, _ramda.any)((0, _ramda.has)('bedType')), _ramda.flatten)), (0, _ramda.prop)('rooms')), bedsAndSofas);

      var addBeddingConfiguration = (0, _ramda.ifElse)((0, _ramda.both)(_ramda.identity, function () {
        return !hasContent;
      }), function () {
        return _react2.default.createElement(
          'div',
          { onClick: _this2._addBeddingConfig, className: 'description-segments-add', style: { marginBottom: '32px' } },
          _react2.default.createElement(_icon2.default, { className: 'tc-icon-add description-segments-add-icon' }),
          _react2.default.createElement(
            'span',
            { className: 'description-segments-add-label' },
            'Add Bedding Configuration'
          )
        );
      }, (0, _ramda.always)(undefined));

      var header = _react2.default.createElement(
        'div',
        { style: { lineHeight: '48px', textTransform: 'uppercase', color: 'rgba(0, 0, 0, 0.87)' } },
        title,
        _react2.default.createElement(
          'span',
          { onClick: this._addBeddingConfig, className: 'description-segments-edit', style: { marginLeft: '6px', display: isEditable && hasContent ? 'inline-block' : 'none' } },
          _react2.default.createElement(_icon2.default, { style: { fontSize: '14px', marginRight: '4px' }, className: 'tc-icon-mode_edit' }),
          'Edit'
        )
      );

      if ((0, _functional.neither)(hasContent, isEditable)) return false;
      return _react2.default.createElement(
        'div',
        { style: { marginTop: '32px' }, id: 'beddingConfig' },
        header,
        _react2.default.createElement(
          'div',
          { className: 'l-paper-split-segment' },
          _react2.default.createElement(_beddingConfigurationDumb2.default, { bedsAndSofas: bedsAndSofas })
        ),
        addBeddingConfiguration(isEditable)
      );
    }
  }]);

  return BeddingConfig;
}(_react.Component);

BeddingConfig.propTypes = {
  isEditable: _react.PropTypes.bool,
  profileToShow: _react.PropTypes.object,
  editField: _react.PropTypes.func,
  routeName: _react.PropTypes.string,
  _saveField: _react.PropTypes.func
};

module.exports = BeddingConfig;

/* jshint ignore:end */

/***/ }),
/* 3165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(26);

var _selectFields = __webpack_require__(141);

var _leftBarDetail = __webpack_require__(736);

var _leftBarDetail2 = _interopRequireDefault(_leftBarDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DestinationSold = function (_Component) {
  _inherits(DestinationSold, _Component);

  function DestinationSold() {
    _classCallCheck(this, DestinationSold);

    return _possibleConstructorReturn(this, (DestinationSold.__proto__ || Object.getPrototypeOf(DestinationSold)).apply(this, arguments));
  }

  _createClass(DestinationSold, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          editField = _props.editField;

      var destinationsSold = function (destinations) {
        if (destinations && destinations.length > 1 && destinations[0] === '') {
          return destinations.slice(1);
        }
        return destinations;
      }(profileToShow.destinationsSold || profileToShow.markets || (0, _immutable.List)());

      var destinationSoldSettings = {
        options: _selectFields.countries,
        type: 'multi'
      };

      return _react2.default.createElement(
        'div',
        { id: 'destinationsSold' },
        _react2.default.createElement(_leftBarDetail2.default, _extends({}, this.props, {
          itemName: "Destination",
          infoArray: destinationsSold,
          title: "Destinations Sold",
          className: 'segment-content',
          editField: editField.bind(this, 'destinationsSold', destinationSoldSettings)
        }))
      );
    }
  }]);

  return DestinationSold;
}(_react.Component);

DestinationSold.propTypes = {
  profileToShow: _react.PropTypes.object,
  editField: _react.PropTypes.func
};

exports.default = DestinationSold;

/***/ }),
/* 3166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(26);

var _selectFields = __webpack_require__(141);

var _leftBarDetail = __webpack_require__(736);

var _leftBarDetail2 = _interopRequireDefault(_leftBarDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DestinationSold = function (_Component) {
  _inherits(DestinationSold, _Component);

  function DestinationSold() {
    _classCallCheck(this, DestinationSold);

    return _possibleConstructorReturn(this, (DestinationSold.__proto__ || Object.getPrototypeOf(DestinationSold)).apply(this, arguments));
  }

  _createClass(DestinationSold, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          editField = _props.editField;

      var marketServed = function (markets) {
        if (markets && markets.length > 1 && markets[0] === '') {
          return markets.slice(1);
        }
        return markets;
      }(profileToShow.marketServed || profileToShow.markets || (0, _immutable.List)());

      var marketServedSettings = {
        options: _selectFields.countries,
        type: 'multi'
      };

      return _react2.default.createElement(
        'div',
        { id: 'marketServed' },
        _react2.default.createElement(_leftBarDetail2.default, _extends({}, this.props, {
          itemName: "Market",
          infoArray: marketServed,
          title: "Market Served",
          className: 'segment-content',
          editField: editField.bind(this, 'marketServed', marketServedSettings)
        }))
      );
    }
  }]);

  return DestinationSold;
}(_react.Component);

DestinationSold.propTypes = {
  profileToShow: _react.PropTypes.object,
  editField: _react.PropTypes.func
};

exports.default = DestinationSold;

/***/ }),
/* 3167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InterconnectingRooms = function (_Component) {
  _inherits(InterconnectingRooms, _Component);

  function InterconnectingRooms() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InterconnectingRooms);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InterconnectingRooms.__proto__ || Object.getPrototypeOf(InterconnectingRooms)).call.apply(_ref, [this].concat(args))), _this), _this.toggleValue = function (field) {
      _this.props._saveField({
        updateField: field,
        updateBody: !_this.props.profileToShow[field]
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InterconnectingRooms, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          profileToShow = _props.profileToShow,
          roomIsEditable = _props.roomIsEditable;

      var isInterconnecting = profileToShow.interconnectingRooms;
      var label = isInterconnecting ? 'Interconnecting Rooms Available' : 'No Interconnecting Rooms Available';
      var toggleOrDisplay = function () {
        if (roomIsEditable) {
          return _react2.default.createElement(_materialUi.Toggle, {
            checked: isInterconnecting,
            style: {
              cursor: 'pointer',
              overflow: 'visible',
              width: '100%',
              display: 'inline-block',
              verticalAlign: 'middle'
            },
            onToggle: _this2.toggleValue.bind(_this2, 'interconnectingRooms'),
            name: 'toggleName1',
            labelPosition: 'right',
            label: label,
            value: 'toggleValue1'
          });
        }
        return _react2.default.createElement(
          'span',
          {
            style: {
              fontSize: '14px',
              color: 'rgba(0, 0, 0, 0.541176)'
            }
          },
          label
        );
      }();

      return _react2.default.createElement(
        'div',
        { style: { marginTop: '32px', height: '48px' } },
        toggleOrDisplay
      );
    }
  }]);

  return InterconnectingRooms;
}(_react.Component);

InterconnectingRooms.propTypes = {
  _saveField: _react.PropTypes.func,
  profileToShow: _react.PropTypes.object,
  editField: _react.PropTypes.func,
  roomIsEditable: _react.PropTypes.bool
};

exports.default = InterconnectingRooms;

/***/ }),
/* 3168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(26);

var _leftBarDetail = __webpack_require__(736);

var _leftBarDetail2 = _interopRequireDefault(_leftBarDetail);

var _selectFields = __webpack_require__(141);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CompanyTypes = function (_Component) {
  _inherits(CompanyTypes, _Component);

  function CompanyTypes() {
    _classCallCheck(this, CompanyTypes);

    return _possibleConstructorReturn(this, (CompanyTypes.__proto__ || Object.getPrototypeOf(CompanyTypes)).apply(this, arguments));
  }

  _createClass(CompanyTypes, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          isEditable = _props.isEditable,
          editField = _props.editField;

      var companyTypes = function (segments) {
        if (segments && segments.length > 1 && segments[0] === '') {
          return segments.slice(1);
        }
        return segments;
      }(profileToShow.companyTypes || (0, _immutable.List)());

      var companyTypesOptions = function () {
        if (profileToShow.type === 'Contractor') {
          if (_ramda2.default.intersection(_selectFields.basicBuyerTypes, companyTypes).length) {
            return _selectFields.basicBuyerTypes.map(function (str) {
              return { label: str, value: str };
            });
          }
          if (_ramda2.default.intersection(_selectFields.DMOtypes, companyTypes).length) {
            return _selectFields.DMOtypes.map(function (str) {
              return { label: str, value: str };
            });
          }
          if (_ramda2.default.intersection(_selectFields.otherBuyersTypes, companyTypes).length) {
            return _selectFields.otherBuyersTypes.map(function (str) {
              return { label: str, value: str };
            });
          }
          return _selectFields.contractorCompanyTypes;
        }
        if (profileToShow.productType === 'accommodation') return _selectFields.accomCompanyTypes;
        return _selectFields.nonAccomCompanyTypes;
      }();

      var companyTypesSettings = {
        options: companyTypesOptions,
        itemsPerRow: 2,
        type: 'multi'
      };

      return _react2.default.createElement(
        'div',
        { id: 'companyTypes' },
        _react2.default.createElement(_leftBarDetail2.default, {
          isEditable: isEditable,
          infoArray: companyTypes.toJS ? companyTypes.toJS() : companyTypes,
          title: "Company Types",
          itemName: 'Company Type',
          className: 'segment-content',
          editField: editField.bind(this, 'companyTypes', companyTypesSettings),
          isRequired: true
        })
      );
    }
  }]);

  return CompanyTypes;
}(_react.Component);

CompanyTypes.propTypes = {
  profileToShow: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool,
  editField: _react.PropTypes.func
};

exports.default = CompanyTypes;

/***/ }),
/* 3169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(26);

var _leftBarDetail = __webpack_require__(736);

var _leftBarDetail2 = _interopRequireDefault(_leftBarDetail);

var _selectFields = __webpack_require__(141);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarketSegments = function (_Component) {
  _inherits(MarketSegments, _Component);

  function MarketSegments() {
    _classCallCheck(this, MarketSegments);

    return _possibleConstructorReturn(this, (MarketSegments.__proto__ || Object.getPrototypeOf(MarketSegments)).apply(this, arguments));
  }

  _createClass(MarketSegments, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          isEditable = _props.isEditable,
          editField = _props.editField;

      var marketSegments = function (segments) {
        if (segments && segments.length > 1 && segments[0] === '') {
          return segments.slice(1);
        }
        return segments;
      }(profileToShow.marketSegments || (0, _immutable.List)());

      var marketSegmentSettings = {
        options: _selectFields.marketSegments,
        type: 'multi'
      };

      return _react2.default.createElement(
        'div',
        { id: 'marketSegments' },
        _react2.default.createElement(_leftBarDetail2.default, {
          isEditable: isEditable,
          infoArray: marketSegments.toJS ? marketSegments.toJS() : marketSegments,
          title: "Market Segments",
          itemName: 'Market Segment',
          className: 'segment-content',
          editField: editField.bind(this, 'marketSegments', marketSegmentSettings),
          isRequired: true
        })
      );
    }
  }]);

  return MarketSegments;
}(_react.Component);

MarketSegments.propTypes = {
  profileToShow: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool,
  editField: _react.PropTypes.func
};

exports.default = MarketSegments;

/***/ }),
/* 3170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leftBarDetail = __webpack_require__(736);

var _leftBarDetail2 = _interopRequireDefault(_leftBarDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Passengers = function (_Component) {
  _inherits(Passengers, _Component);

  function Passengers() {
    _classCallCheck(this, Passengers);

    return _possibleConstructorReturn(this, (Passengers.__proto__ || Object.getPrototypeOf(Passengers)).apply(this, arguments));
  }

  _createClass(Passengers, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          editField = _props.editField,
          isEditable = _props.isEditable;

      var minMaxPassengersNodes = [];

      if (profileToShow.totalMaxPassengers !== undefined || isEditable) {
        minMaxPassengersNodes.push(_react2.default.createElement(_leftBarDetail2.default, {
          key: 'max',
          isEditable: isEditable,
          infoToDisplay: profileToShow.totalMaxPassengers,
          classification: 'MAX',
          itemName: 'Max Passengers',
          className: 'segment-content',
          editField: editField.bind(this, 'totalMaxPassengers', { type: 'number', isRequired: true }),
          inline: true,
          noMargin: true
        }));
      }

      if (profileToShow.totalMinPassengers !== undefined || isEditable) {
        minMaxPassengersNodes.push(_react2.default.createElement(_leftBarDetail2.default, {
          key: 'min',
          isEditable: isEditable,
          infoToDisplay: profileToShow.totalMinPassengers,
          classification: 'MIN',
          itemName: 'Min Passengers',
          className: 'segment-content',
          editField: editField.bind(this, 'totalMinPassengers', { type: 'number', isRequired: true }),
          noMargin: true,
          inline: true
        }));
      }

      return _react2.default.createElement(
        'div',
        { style: { marginTop: '32px' }, id: 'passengers' },
        _react2.default.createElement(
          'div',
          { className: 'description-segments' },
          _react2.default.createElement(
            'span',
            { className: 'description-segments-titel' },
            'PASSENGERS'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'l-paper-split-segment' },
          minMaxPassengersNodes
        )
      );
    }
  }]);

  return Passengers;
}(_react.Component);

Passengers.propTypes = {
  profileToShow: _react.PropTypes.object,
  editField: _react.PropTypes.func,
  isEditable: _react.PropTypes.bool
};

exports.default = Passengers;

/***/ }),
/* 3171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leftBarDetail = __webpack_require__(736);

var _leftBarDetail2 = _interopRequireDefault(_leftBarDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RoomCount = function (_Component) {
  _inherits(RoomCount, _Component);

  function RoomCount() {
    _classCallCheck(this, RoomCount);

    return _possibleConstructorReturn(this, (RoomCount.__proto__ || Object.getPrototypeOf(RoomCount)).apply(this, arguments));
  }

  _createClass(RoomCount, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          isEditable = _props.isEditable,
          editField = _props.editField,
          showLocationRoomCount = _props.showLocationRoomCount,
          showProductRoomCount = _props.showProductRoomCount;


      if (showLocationRoomCount) {
        return _react2.default.createElement(
          'div',
          { id: 'roomCount' },
          _react2.default.createElement(_leftBarDetail2.default, {
            isEditable: isEditable,
            infoToDisplay: profileToShow.roomCount,
            classification: 'ROOMS',
            itemName: 'Room Count',
            className: 'segment-content',
            editField: editField.bind(this, 'roomCount', {
              type: 'number',
              isRequired: true
            }),
            inline: true
          })
        );
      }

      if (showProductRoomCount) {
        return _react2.default.createElement(
          'div',
          { id: 'roomCount' },
          _react2.default.createElement(_leftBarDetail2.default, {
            isEditable: isEditable,
            infoToDisplay: profileToShow.roomCountInfo.value,
            classification: profileToShow.roomCountInfo.unit ? profileToShow.roomCountInfo.unit + 'S' : 'ROOMS',
            itemName: 'Room Count',
            className: 'segment-content',
            editField: editField.bind(this, 'roomCountInfo', {
              type: 'roomCountInfo',
              isRequired: true,
              initialValue: {
                unit: profileToShow.roomCountInfo.unit,
                value: profileToShow.roomCountInfo.value
              }
            }),
            inline: true
          })
        );
      }
    }
  }]);

  return RoomCount;
}(_react.Component);

RoomCount.propTypes = {
  profileToShow: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool,
  editField: _react.PropTypes.func,
  showLocationRoomCount: _react.PropTypes.bool,
  showProductRoomCount: _react.PropTypes.bool
};

exports.default = RoomCount;

/***/ }),
/* 3172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leftBarDetail = __webpack_require__(736);

var _leftBarDetail2 = _interopRequireDefault(_leftBarDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RoomSize = function (_Component) {
  _inherits(RoomSize, _Component);

  function RoomSize() {
    _classCallCheck(this, RoomSize);

    return _possibleConstructorReturn(this, (RoomSize.__proto__ || Object.getPrototypeOf(RoomSize)).apply(this, arguments));
  }

  _createClass(RoomSize, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          isEditable = _props.isEditable,
          editField = _props.editField;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_leftBarDetail2.default, {
          isEditable: isEditable,
          itemName: 'Room Size',
          className: 'segment-content',
          infoToDisplay: profileToShow.roomSizeInfo.value,
          classification: profileToShow.roomSizeInfo.unit,
          editField: editField.bind(this, 'roomSizeInfo', {
            type: 'roomSizeInfo',
            isRequired: true,
            initialValue: {
              unit: profileToShow.roomSizeInfo.unit,
              value: profileToShow.roomSizeInfo.value
            }
          }),
          inline: true
        })
      );
    }
  }]);

  return RoomSize;
}(_react.Component);

RoomSize.propTypes = {
  profileToShow: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool,
  editField: _react.PropTypes.func
};

exports.default = RoomSize;

/***/ }),
/* 3173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leftBarDetail = __webpack_require__(736);

var _leftBarDetail2 = _interopRequireDefault(_leftBarDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaxId = function (_Component) {
  _inherits(TaxId, _Component);

  function TaxId() {
    _classCallCheck(this, TaxId);

    return _possibleConstructorReturn(this, (TaxId.__proto__ || Object.getPrototypeOf(TaxId)).apply(this, arguments));
  }

  _createClass(TaxId, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          isEditable = _props.isEditable,
          editField = _props.editField;

      return _react2.default.createElement('div', null);
    }
  }]);

  return TaxId;
}(_react.Component);

TaxId.propTypes = {
  profileToShow: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool,
  editField: _react.PropTypes.func
};

exports.default = TaxId;

/***/ }),
/* 3174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leftBarDetail = __webpack_require__(736);

var _leftBarDetail2 = _interopRequireDefault(_leftBarDetail);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getTourDurationUnit(_ref) {
  var value = _ref.value,
      unit = _ref.unit;

  if (!value || !unit) return undefined;
  var normalizedUnit = unit.split('(')[0];
  if (value > 1) normalizedUnit += 's';
  return value + ' ' + normalizedUnit;
}

var TourDuration = function (_Component) {
  _inherits(TourDuration, _Component);

  function TourDuration() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, TourDuration);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = TourDuration.__proto__ || Object.getPrototypeOf(TourDuration)).call.apply(_ref2, [this].concat(args))), _this), _this.toggleValue = function (field) {
      var _this$props = _this.props,
          _saveField = _this$props._saveField,
          profileToShow = _this$props.profileToShow;

      _saveField({ updateField: field, updateBody: !profileToShow[field] });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TourDuration, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          isEditable = _props.isEditable,
          editField = _props.editField;

      var showTourDuration = !profileToShow.tourDurationDoesNotApply;
      var tourDurationNodes = [];

      if (isEditable) {
        tourDurationNodes.push(_react2.default.createElement(
          'div',
          { style: { marginTop: '32px' }, key: 'editable' },
          _react2.default.createElement(_materialUi.Toggle, {
            checked: showTourDuration,
            style: {
              cursor: 'pointer',
              overflow: 'visible',
              width: '100%',
              display: 'inline-block',
              verticalAlign: 'middle'
            },
            onToggle: this.toggleValue.bind(this, 'tourDurationDoesNotApply'),
            name: 'toggleName1',
            labelPosition: 'right',
            label: showTourDuration ? 'Show Tour Duration' : 'Don\'t Show Tour Duration',
            value: 'toggleValue1'
          })
        ));
      }

      if (showTourDuration && (profileToShow.tourDuration && profileToShow.tourDuration.value || isEditable)) {
        tourDurationNodes.push(_react2.default.createElement(_leftBarDetail2.default, {
          key: 'showTourDuration',
          isEditable: isEditable,
          className: 'segment-content',
          infoToDisplay: getTourDurationUnit(profileToShow.tourDuration),
          title: "Tour Duration",
          itemName: "Tour Duration",
          editField: editField.bind(this, 'tourDuration', {
            type: 'tourDuration',
            isRequired: true,
            initialValue: {
              unit: profileToShow.tourDuration.unit,
              value: profileToShow.tourDuration.value
            }
          })
        }));
      }

      return _react2.default.createElement(
        'div',
        { id: 'tourDuration' },
        tourDurationNodes
      );
    }
  }]);

  return TourDuration;
}(_react.Component);

TourDuration.propTypes = {
  profileToShow: _react.PropTypes.object,
  routeName: _react.PropTypes.string,
  isEditable: _react.PropTypes.bool,
  editField: _react.PropTypes.func,
  _saveField: _react.PropTypes.func
};

exports.default = TourDuration;

/***/ }),
/* 3175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SupplierLeftBarMembership = function SupplierLeftBarMembership(props) {
  var isEditable = props.isEditable,
      profileToShow = props.profileToShow;

  if ((0, _ramda.isEmpty)(profileToShow.companyBadges)) return _react2.default.createElement('div', null);
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _materialUi.Paper,
      { style: { marginTop: '30px' } },
      _react2.default.createElement(
        'div',
        { style: { backgroundColor: '#f5f5f5' } },
        _react2.default.createElement(
          'h4',
          { style: { marginLeft: '15px', paddingBottom: '7%', lineHeight: '0.7' } },
          'Industry Memberships'
        )
      ),
      profileToShow.companyBadges && profileToShow.companyBadges.filter(function (org) {
        return org.verifiedStatus === 'verified';
      }).length > 0 && !isEditable ? _react2.default.createElement(
        'div',
        { style: { height: '100%', padding: '0 10px 20px 10px', textAlign: 'center' } },
        profileToShow.companyBadges.filter(function (_ref) {
          var verifiedStatus = _ref.verifiedStatus;
          return verifiedStatus === 'verified';
        }).sort(function (a, b) {
          if (a.badgeId === '5ec074e495512b0156baf64f') return -1;
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        }).map(function (membership, index) {
          return _react2.default.createElement(
            'div',
            {
              className: 'verified-member-block',
              style: { textAlign: 'center', padding: '2px', margin: '7px 10px 0 0', verticalAlign: 'top', overflow: 'hidden' },
              key: index
            },
            _react2.default.createElement('img', { src: membership.logo, height: membership.name === 'European Tourism Association (ETOA)' ? '30px' : '40px' }),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(_materialUi.FontIcon, {
                className: 'tc-icon-check',
                color: '#00bcd4',
                style: { fontSize: '10px' }
              }),
              _react2.default.createElement(
                'span',
                { style: { color: '#00bcd4', fontSize: '10px' } },
                'Verified Member'
              )
            ),
            membership.website ? _react2.default.createElement(
              'div',
              { className: 'what-is-org-hover', style: { marginTop: '-10px', textAlign: 'center' } },
              _react2.default.createElement(
                'span',
                { style: { color: '#00bcd4', fontSize: '10px' } },
                'What is ',
                _react2.default.createElement(
                  'a',
                  { href: (0, _ramda.prop)('website', membership), style: { color: '#ff4081' }, target: '_blank' },
                  membership.acronym ? membership.acronym : membership.name
                ),
                '?'
              )
            ) : _react2.default.createElement('span', null)
          );
        })
      ) : _react2.default.createElement('span', null)
    )
  );
};

SupplierLeftBarMembership.propTypes = {
  isEditable: _react.PropTypes.bool,
  profileToShow: _react.PropTypes.object
};

exports.default = SupplierLeftBarMembership;

/***/ }),
/* 3176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _coverPhotoContainer = __webpack_require__(3177);

var _coverPhotoContainer2 = _interopRequireDefault(_coverPhotoContainer);

var _productCode = __webpack_require__(3180);

var _productCode2 = _interopRequireDefault(_productCode);

var _address = __webpack_require__(3181);

var _address2 = _interopRequireDefault(_address);

var _website = __webpack_require__(3182);

var _website2 = _interopRequireDefault(_website);

var _phone = __webpack_require__(3183);

var _phone2 = _interopRequireDefault(_phone);

var _logo = __webpack_require__(3184);

var _logo2 = _interopRequireDefault(_logo);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _topBanner = __webpack_require__(3190);

var _topBanner2 = _interopRequireDefault(_topBanner);

var _partnerFinderActions = __webpack_require__(1125);

var _profileActions = __webpack_require__(546);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var ProfileTopBar = function (_Component) {
  _inherits(ProfileTopBar, _Component);

  function ProfileTopBar(props) {
    _classCallCheck(this, ProfileTopBar);

    return _possibleConstructorReturn(this, (ProfileTopBar.__proto__ || Object.getPrototypeOf(ProfileTopBar)).call(this, props));
  }

  _createClass(ProfileTopBar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          profileToShow = _props.profileToShow,
          isViewingOwnProfile = _props.isViewingOwnProfile,
          routeName = _props.routeName,
          isSingleLocSupplier = _props.isSingleLocSupplier,
          singleLocId = _props.singleLocId,
          isEditable = _props.isEditable,
          user = _props.user,
          updateProp = _props.updateProp;

      var showBackBanner = (0, _ramda.path)(['location', 'state', 'from'], this.props);
      var backBannerText = (0, _ramda.path)(['location', 'state', 'text'], this.props);
      var viewingAsObj = (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('profile'), (0, _ramda.always)({ companyId: profileToShow.companyId })], [(0, _ramda.equals)('location'), (0, _ramda.always)({ locationId: profileToShow.locationId })], [(0, _ramda.equals)('product'), (0, _ramda.always)({ productId: profileToShow.productId })], [_ramda.T, (0, _ramda.always)({})]]), routeName);

      return _react2.default.createElement(
        'div',
        { style: { maxWidth: '1232px', margin: '0 auto', padding: '0 16px 0 16px' }, id: 'topSuppEl' },
        _react2.default.createElement(
          'div',
          { style: { marginTop: isViewingOwnProfile ? '65px' : '' } },
          isViewingOwnProfile ? _react2.default.createElement(_topBanner2.default, {
            numberOfIcons: 0,
            bannerColor: '#00bcd4',
            bannerHeight: '50px',
            bannerContent: _react2.default.createElement(
              'div',
              { className: 'Grid', style: { color: '#ffffff', alignItems: 'center', justifyContent: 'center' } },
              _react2.default.createElement(
                'span',
                { style: { display: 'inline-block', marginRight: '20px' } },
                _react2.default.createElement(_icon2.default, {
                  className: 'tc-icon-cancel',
                  onClick: function onClick() {
                    updateProp((0, _ramda.merge)(viewingAsObj, { viewingAs: 'unconnected', previewingOwnProfile: false }));
                    _this2.context.router.push('/profile');
                  },
                  style: { cursor: 'pointer' }
                })
              ),
              _react2.default.createElement(
                'span',
                { style: { display: 'inline-block', marginRight: '10px' } },
                'This is what your profile looks like to ',
                (0, _ramda.equals)(profileToShow.viewingAs, 'unconnected') ? 'an' : 'a'
              ),
              _react2.default.createElement(
                'span',
                { style: { display: 'inline-block' } },
                _react2.default.createElement(_reactSelect2.default, {
                  name: 'viewAs',
                  options: [{ value: 'connected', label: 'Connected' }, { value: 'unconnected', label: 'Unconnected' }],
                  clearable: false,
                  style: { width: '130px', textAlign: 'left' },
                  value: profileToShow.viewingAs,
                  onChange: function onChange(value) {
                    return updateProp((0, _ramda.merge)(viewingAsObj, { viewingAs: value.value }));
                  }
                })
              ),
              _react2.default.createElement(
                'span',
                { style: { display: 'inline-block', marginLeft: '10px' } },
                ' user.'
              )
            )
          }) : _react2.default.createElement('span', null),
          showBackBanner ? _react2.default.createElement(
            'div',
            { style: isViewingOwnProfile ? { borderTop: '1px solid #26c6da' } : { margin: '65px 0 -65px 0' } },
            _react2.default.createElement(_topBanner2.default, {
              numberOfIcons: 0,
              bannerColor: '#00bcd4',
              bannerHeight: '50px',
              bannerContent: _react2.default.createElement(
                'div',
                { style: { color: '#ffffff', textAlign: 'center' } },
                _react2.default.createElement(
                  _materialUi.FontIcon,
                  {
                    className: 'tc-icon-arrow_back',
                    style: { color: '#ffffff', cursor: 'pointer' },
                    onTouchTap: this.context.router.goBack
                  },
                  _react2.default.createElement(
                    'span',
                    { style: { fontSize: '24px', fontWeight: '600', marginLeft: '10px', fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" } },
                    backBannerText
                  )
                )
              )
            })
          ) : _react2.default.createElement('span', null)
        ),
        _react2.default.createElement(_coverPhotoContainer2.default, _extends({
          isViewingOwnProfile: isViewingOwnProfile,
          isSingleLocSupplier: isSingleLocSupplier
        }, this.props)),
        _react2.default.createElement(
          'div',
          { style: { marginTop: isViewingOwnProfile ? '' : '64px' }, className: 'l-profile-tool-panel-container' },
          _react2.default.createElement(
            'div',
            { style: {
                position: 'relative',
                height: '100%',
                maxWidth: '1232px',
                margin: 'auto'
              }
            },
            _react2.default.createElement(_logo2.default, this.props),
            _react2.default.createElement(
              'div',
              { className: 'l-profile-tool-panel' },
              _react2.default.createElement(_productCode2.default, this.props),
              _react2.default.createElement(_address2.default, this.props),
              _react2.default.createElement(_website2.default, this.props),
              _react2.default.createElement(_phone2.default, this.props),
              _react2.default.createElement(
                'div',
                null,
                (0, _ramda.equals)(routeName, 'profile') && (0, _ramda.equals)(location.pathname.split('/').slice(1)[0], 'profile') ? _react2.default.createElement(
                  'div',
                  { style: { float: 'right', display: 'inline-block' } },
                  _react2.default.createElement(_materialUi.RaisedButton, {
                    label: 'Preview Profile As',
                    backgroundColor: '#f5f5f5',
                    onTouchTap: function onTouchTap() {
                      var hash = '#topSuppEl';
                      var element = document.querySelector(hash);
                      if (element) scrollTo(hash, { offset: -70 });
                      updateProp({ previewingOwnProfile: true });
                      _this2.context.router.push(isSingleLocSupplier ? '/locations/' + singleLocId : '/company/' + profileToShow.companyId);
                      window.dataLayer.push({
                        event: 'TRACK_EVENT',
                        ev: {
                          category: 'Profile',
                          action: 'Clicks from preview profile as'
                        }
                      });
                    },
                    style: { height: '25px' }
                  })
                ) : _react2.default.createElement('span', null)
              )
            )
          )
        )
      );
    }
  }]);

  return ProfileTopBar;
}(_react.Component);

ProfileTopBar.propTypes = {
  user: _react.PropTypes.object,
  profileToShow: _react.PropTypes.object,
  history: _react.PropTypes.object,
  partnerFinderReducer: _react.PropTypes.object,
  updateProfileProp: _react.PropTypes.func,
  isViewingOwnProfile: _react.PropTypes.bool,
  routeName: _react.PropTypes.string,
  isSingleLocSupplier: _react.PropTypes.bool,
  singleLocId: _react.PropTypes.string,
  isEditable: _react.PropTypes.bool,
  setPFPage: _react.PropTypes.func,
  updateProp: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var partnerFinder = _ref.partnerFinder,
      user = _ref.user;
  return {
    partnerFinderReducer: partnerFinder.toJS(),
    user: user.toJS()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setPFPage: function setPFPage(params, pagination) {
      return dispatch((0, _partnerFinderActions.search)(params, pagination));
    },
    updateProp: function updateProp() {
      return dispatch(_profileActions.updateSuppProfileProps.apply(undefined, arguments));
    }
  };
};
ProfileTopBar.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ProfileTopBar);

/***/ }),
/* 3177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(47);

var _imageCropDialog = __webpack_require__(1227);

var _imageCropDialog2 = _interopRequireDefault(_imageCropDialog);

var _ratingNode = __webpack_require__(3178);

var _ratingNode2 = _interopRequireDefault(_ratingNode);

var _nameNode = __webpack_require__(3179);

var _nameNode2 = _interopRequireDefault(_nameNode);

var _ramda = __webpack_require__(2);

var _profileActions = __webpack_require__(546);

var _locationActions = __webpack_require__(1054);

var _productActions = __webpack_require__(1518);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CoverPhotoContainer = function (_Component) {
  _inherits(CoverPhotoContainer, _Component);

  function CoverPhotoContainer(props) {
    _classCallCheck(this, CoverPhotoContainer);

    var _this = _possibleConstructorReturn(this, (CoverPhotoContainer.__proto__ || Object.getPrototypeOf(CoverPhotoContainer)).call(this, props));

    _this.setContainerWidth = function () {
      _this.setState({
        containerWidth: (0, _reactDom.findDOMNode)(_this.refs.outerContainer) && (0, _reactDom.findDOMNode)(_this.refs.outerContainer).offsetWidth
      });
    };

    _this.getCompanyTypesToDisplay = function () {
      var profileToShow = _this.props.profileToShow;


      var companyTypes = profileToShow.companyTypes || [];
      if (companyTypes[0] === '') companyTypes = companyTypes.slice(1);
      var itemsPerTypeArray = profileToShow.type === 'Contractor' ? 2 : 3;

      if (companyTypes.length) {
        return companyTypes.reduce(function (displayObject, type, index, types) {
          var rowItems = displayObject.rowItems,
              finalArray = displayObject.finalArray;

          var string = '';

          var buildSpan = function buildSpan(span) {
            return _react2.default.createElement(
              'span',
              {
                key: 'span' + index,
                style: { display: 'inline-block', wordWrap: 'wrap-text', whiteSpace: 'pre-wrap', fontSize: '16px' }
              },
              span.toUpperCase()
            );
          };

          if ((index + 1) % itemsPerTypeArray === 0 && index !== 0 || types.length < itemsPerTypeArray && index === types.length - 1 || index === types.length - 1) {
            string += type;
            rowItems.push(buildSpan(string));
            finalArray.push(_react2.default.createElement(
              'div',
              { key: 'column' + index, style: {
                  marginTop: finalArray.length === 0 ? '8px' : '0px',
                  display: index === types.length - 1 ? 'inline-block' : 'block'
                }
              },
              rowItems
            ));

            displayObject.rowItems = [];
          } else {
            string += type + ', ';
            rowItems.push(buildSpan(string));
          }
          if (index < types.length - 1) return displayObject;
          return finalArray;
        }, {
          rowItems: [],
          finalArray: []
        });
      }
    };

    _this._removeSpinnerOnLoad = function () {
      var profileToShow = _this.props.profileToShow;

      var image = new Image();
      image.src = profileToShow.coverImageUrl;
      image.onload = _this._toggleLoader.bind(_this, 'coverPhoto', false);
    };

    _this.coverImageSourceChanged = function (coverImageUrl) {
      var _this$props = _this.props,
          _saveField = _this$props._saveField,
          routeName = _this$props.routeName;

      _saveField({
        route: routeName,
        updateField: 'coverImageUrl',
        updateBody: coverImageUrl
      });
      _this._removeSpinnerOnLoad();
    };

    _this._toggleLoader = function (field, isLoading) {
      _this.setState(_defineProperty({}, field + 'IsLoading', isLoading));
    };

    _this.deleteCoverImage = function () {
      var _this$props2 = _this.props,
          routeName = _this$props2.routeName,
          dispatch = _this$props2.dispatch,
          params = _this$props2.params;

      if (routeName === 'profile') dispatch((0, _profileActions.deleteCoverImageFromProfile)('profileCover'));
      if (routeName === 'location') dispatch((0, _locationActions.deleteCoverImageFromLocation)('locationCover', params.locationId));
      if (routeName === 'product') dispatch((0, _productActions.deleteCoverImageFromProduct)('productCover', params.productId));
    };

    _this.numOfCompanyTypes = (0, _ramda.path)(['companyTypes', 'length'], _this.props.profileToShow) || 0;

    _this.heightForBackground = function () {
      return (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), (0, _ramda.always)(400), (0, _ramda.always)(350)), _this.numOfCompanyTypes > 5);
    };

    _this.coverImageEditIcon = function () {
      var _this$props3 = _this.props,
          profileToShow = _this$props3.profileToShow,
          routeName = _this$props3.routeName;


      var coverPhotoTypes = {
        profile: [{
          maxSize: 1500,
          name: 'profileCover',
          onStart: _this._toggleLoader.bind(_this, 'coverPhoto', true),
          onChange: _this.coverImageSourceChanged
        }],
        location: [{
          maxSize: 1500,
          name: 'locationCover' + profileToShow.locationId,
          onStart: _this._toggleLoader.bind(_this, 'coverPhoto', true),
          onChange: _this.coverImageSourceChanged
        }],
        product: [{
          maxSize: 1500,
          name: 'productCover' + profileToShow.productId,
          onStart: _this._toggleLoader.bind(_this, 'coverPhoto', true),
          onChange: _this.coverImageSourceChanged
        }]
      };
      var coverPhotoNames = {
        profile: 'profileCover',
        location: 'locationCover' + profileToShow.locationId,
        product: 'productCover' + profileToShow.productId
      };
      if (profileToShow.coverImageUrl) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'profile-cover-edit-image-icon', style: { right: '44px' } },
            _react2.default.createElement(
              _imageCropDialog2.default,
              {
                confirmCroppedFn: _this.coverImageSourceChanged,
                uploadStartFn: _this._toggleLoader.bind(_this, 'coverPhoto', true),
                cropWidth: 1200,
                cropHeight: _this.heightForBackground(),
                imageName: coverPhotoNames[routeName],
                dialogWidth: '1200px'
              },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_icon2.default, {
                  className: 'tc-icon-mode_edit',
                  style: { fontSize: '16px', verticalAlign: 'middle' }
                }),
                _react2.default.createElement(
                  'span',
                  { style: { marginLeft: '8px' } },
                  'Change Cover Photo'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { onClick: _this.deleteCoverImage, className: 'profile-cover-edit-image-icon', style: { right: '4px' } },
            _react2.default.createElement(_icon2.default, {
              className: 'tc-icon-delete2',
              style: { fontSize: '16px', verticalAlign: 'middle' }
            })
          )
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'add-cover-image-url' },
          _react2.default.createElement(
            _imageCropDialog2.default,
            {
              confirmCroppedFn: _this.coverImageSourceChanged,
              uploadStartFn: _this._toggleLoader.bind(_this, 'coverPhoto', true),
              cropWidth: 1200,
              cropHeight: _this.heightForBackground(),
              imageName: coverPhotoNames[routeName],
              dialogWidth: '800px'
            },
            _react2.default.createElement(_icon2.default, {
              style: {
                fontSize: '48px',
                textAlign: 'center',
                verticalAlign: 'middle',
                marginRight: '16px',
                border: '2px dashed',
                zIndex: '0'
              },
              className: 'tc-icon-add description-segments-add-icon'
            }),
            _react2.default.createElement(
              'span',
              {
                style: {
                  display: 'inline-block',
                  verticalAlign: 'middle'
                },
                className: 'description-segments-add-label'
              },
              'Add Cover Photo'
            )
          )
        )
      );
    };

    _this.state = {};
    return _this;
  }

  _createClass(CoverPhotoContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setContainerWidth();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          routeName = _props.routeName,
          profileToShow = _props.profileToShow,
          isEditable = _props.isEditable,
          isViewingOwnProfile = _props.isViewingOwnProfile,
          isSingleLocSupplier = _props.isSingleLocSupplier;

      var coverPhotoGradient = profileToShow.coverImageUrl ? _react2.default.createElement('div', { className: 'cover-photo-gradient' }) : undefined;
      var companyTypesToDisplay = this.getCompanyTypesToDisplay();
      var rating = profileToShow.rating;

      var coverContainerStyle = {
        position: 'relative',
        minHeight: this.heightForBackground() + 'px',
        maxHeight: this.heightForBackground() + 'px',
        top: isViewingOwnProfile ? '' : '64px',
        overflow: 'hidden'
      };

      var coverBackgroundStyle = {
        backgroundImage: 'url(' + profileToShow.coverImageUrl + ')',
        position: 'relative',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 50%',
        backgroundColor: '#e5e5e5',
        backgroundSize: 'cover',
        height: this.heightForBackground() + 'px',
        opacity: '0.9'
      };

      var styleForTopBar = {
        get top() {
          var defaultPosition = this.numOfCompanyTypes > 5 ? -85 : -70;
          if (companyTypesToDisplay && routeName !== 'product') {
            defaultPosition -= 22 * (companyTypesToDisplay.length || 1);
          } else if (routeName !== 'product' && isEditable) {
            defaultPosition -= 22;
          }
          if (routeName === 'location' && profileToShow.productType === 'accommodation' && (rating && rating.type || isEditable) || routeName === 'profile' && isSingleLocSupplier) {
            defaultPosition -= 22;
          }
          return defaultPosition + 'px';
        },
        get color() {
          if (!profileToShow.coverImageUrl) return 'rbga(0, 0, 0, 0.81)';
        }
      };

      return _react2.default.createElement(
        'div',
        { style: coverContainerStyle, className: 'profile-cover-photo ' + (this.state.coverPhotoIsLoading ? ' image-loading-indicater' : '') },
        _react2.default.createElement('div', { style: coverBackgroundStyle }),
        coverPhotoGradient,
        _react2.default.createElement(
          'div',
          { className: 'profile-top-bar-top-info', ref: 'outerContainer', style: styleForTopBar },
          _react2.default.createElement(_nameNode2.default, _extends({}, this.props, { containerWidth: this.state.containerWidth })),
          routeName !== 'product' ? _react2.default.createElement(_ratingNode2.default, _extends({
            isSingleLocSupplier: isSingleLocSupplier
          }, this.props)) : _react2.default.createElement('span', null)
        ),
        isEditable ? this.coverImageEditIcon() : undefined
      );
    }
  }]);

  return CoverPhotoContainer;
}(_react.Component);

CoverPhotoContainer.propTypes = {
  profileToShow: _react.PropTypes.object,
  _saveField: _react.PropTypes.func,
  routeName: _react.PropTypes.string,
  dispatch: _react.PropTypes.func,
  isEditable: _react.PropTypes.bool,
  params: _react.PropTypes.object,
  isViewingOwnProfile: _react.PropTypes.bool,
  isSingleLocSupplier: _react.PropTypes.bool
};

exports.default = CoverPhotoContainer;

/***/ }),
/* 3178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rating = __webpack_require__(1944);

var _rating2 = _interopRequireDefault(_rating);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RatingNode = function (_Component) {
  _inherits(RatingNode, _Component);

  function RatingNode() {
    _classCallCheck(this, RatingNode);

    return _possibleConstructorReturn(this, (RatingNode.__proto__ || Object.getPrototypeOf(RatingNode)).apply(this, arguments));
  }

  _createClass(RatingNode, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          editField = _props.editField,
          routeName = _props.routeName,
          isEditable = _props.isEditable,
          isSingleLocSupplier = _props.isSingleLocSupplier;

      var rating = profileToShow.rating;

      var baseSettings = {
        type: 'rating',
        isRequired: true
      };

      var ratingSettings = (0, _ramda.ifElse)((0, _ramda.compose)((0, _ramda.any)(_ramda.isNil), _ramda.values), function () {
        return (0, _ramda.assoc)('initialValue', {
          value: 3,
          type: 'Self-Assessed'
        }, baseSettings);
      }, (0, _ramda.always)(baseSettings));

      var editRatingIcon = _react2.default.createElement(
        'div',
        {
          style: { display: 'inline-block', marginLeft: '8px', marginTop: '12px' },
          className: 'profile-edit-icon-container',
          onClick: editField.bind(this, 'rating', ratingSettings(rating))
        },
        _react2.default.createElement(_icon2.default, { className: 'tc-icon-mode_edit profile-edit-icon' }),
        rating && rating.type ? 'EDIT' : function () {
          var routeDisplay = '';
          if (routeName === 'profile') routeDisplay = 'Company';
          if (routeName === 'location') routeDisplay = 'Location';
          return 'Add ' + routeDisplay + ' Rating';
        }()
      );

      if ((routeName === 'location' || isSingleLocSupplier) && profileToShow.productType === 'accommodation' && (rating && Object.keys(rating).length || isEditable)) {
        return _react2.default.createElement(
          'div',
          { id: 'rating' },
          _react2.default.createElement(_rating2.default, {
            style: profileToShow.coverImageUrl ? undefined : { color: 'rgba(0, 0, 0, 0.87)' },
            rating: rating,
            isEditable: isEditable,
            innerClass: 'inner-description'
          }),
          isEditable && (routeName === 'location' || isSingleLocSupplier) ? editRatingIcon : undefined
        );
      }
      return false;
    }
  }]);

  return RatingNode;
}(_react.Component);

RatingNode.propTypes = {
  profileToShow: _react.PropTypes.object,
  editField: _react.PropTypes.func,
  routeName: _react.PropTypes.string,
  isEditable: _react.PropTypes.bool,
  isSingleLocSupplier: _react.PropTypes.bool
};

exports.default = RatingNode;

/***/ }),
/* 3179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(47);

var _materialUi = __webpack_require__(3);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Name = function (_Component) {
  _inherits(Name, _Component);

  function Name(props) {
    _classCallCheck(this, Name);

    var _this = _possibleConstructorReturn(this, (Name.__proto__ || Object.getPrototypeOf(Name)).call(this, props));

    _this.getEditNameIcon = function () {
      var iconContainerStyle = {
        display: 'inline-block',
        marginLeft: '8px',
        fontSize: '16px',
        clear: 'both',
        overflow: 'hidden'
      };

      return _react2.default.createElement(
        'div',
        { style: iconContainerStyle, className: 'profile-edit-icon-container', onClick: _this._editName },
        _react2.default.createElement(_icon2.default, { className: 'tc-icon-mode_edit profile-edit-icon' }),
        'EDIT'
      );
    };

    _this._editName = function () {
      var _this$props = _this.props,
          editField = _this$props.editField,
          routeName = _this$props.routeName,
          profileToShow = _this$props.profileToShow;

      var isSupplier = _this.props.profile.type === 'Supplier';
      var isAccom = _this.props.profile.productType === 'accommodation';
      editField(routeName + 'Name', {
        specifiedRoute: routeName,
        isRequired: true,
        value: profileToShow[routeName + 'Name'],
        type: routeName + 'Name',
        warningNode: !isSupplier ? null : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'i',
            null,
            'Please note: If you have existing contracts using this ',
            isAccom && routeName === 'location' ? 'property' : routeName,
            ', those ',
            _react2.default.createElement(
              'b',
              null,
              'existing contracts will not be updated'
            ),
            ' with the new name.  Please contact your partners to inform them of this change.'
          )
        )
      });
    };

    _this._showTooltip = function () {
      _this.setState({ tooltipShown: true });
    };

    _this._hideTooltip = function () {
      _this.setState({ tooltipShown: false });
    };

    _this._handleMouseLeave = function () {
      _this._hideTooltip();
    };

    _this._handleMouseEnter = function () {
      _this._showTooltip();
    };

    _this.state = {
      showFullTitle: false
    };
    return _this;
  }

  _createClass(Name, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        showFullTitle: nextProps.containerWidth && (0, _reactDom.findDOMNode)(this.refs.nameNode) && (0, _reactDom.findDOMNode)(this.refs.nameNode).offsetWidth >= nextProps.containerWidth * 0.83
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          isEditable = _props.isEditable,
          routeName = _props.routeName;


      var profileNameField = routeName === 'profile' ? 'companyName' : routeName + 'Name';

      var containerStyle = {
        display: 'inline-block',
        position: 'relative',
        fontSize: 'calc(20px + 0.5vw)',
        color: profileToShow.coverImageUrl ? 'white' : 'rgba(0, 0, 0, 0.87)',
        maxWidth: '65%',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        lineHeight: '43px'
      };

      if (this.state.showFullTitle) {
        containerStyle.position = 'relative';
        containerStyle.height = '43px';
      }

      return _react2.default.createElement(
        'div',
        { style: this.state.showFullTitle ? { height: '32px', maxHeight: '32px' } : {} },
        _react2.default.createElement(
          'div',
          {
            style: containerStyle,
            onMouseEnter: this._handleMouseEnter,
            onMouseLeave: this._handleMouseLeave
          },
          _react2.default.createElement(
            'span',
            { ref: 'nameNode' },
            profileToShow[profileNameField]
          ),
          (0, _ramda.prop)('quickResponder', profileToShow) ? _react2.default.createElement(
            'span',
            { style: { overflow: 'visible' } },
            _react2.default.createElement(_materialUi.IconButton, {
              iconClassName: 'tc-icon-update',
              iconStyle: { fontSize: '24px', color: '#7F00FF', backgroundColor: '#ffffff', borderRadius: '50%', padding: '2px', opacity: '0.8' },
              tooltip: 'Quick Responder',
              tooltipPosition: 'top-right'
            })
          ) : _react2.default.createElement('span', null)
        ),
        routeName !== 'profile' && isEditable ? this.getEditNameIcon() : null
      );
    }
  }]);

  return Name;
}(_react.Component);

Name.propTypes = {
  editField: _react.PropTypes.func,
  routeName: _react.PropTypes.string,
  profileToShow: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool
};

exports.default = Name;

/***/ }),
/* 3180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductCode = function (_Component) {
  _inherits(ProductCode, _Component);

  function ProductCode() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductCode);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductCode.__proto__ || Object.getPrototypeOf(ProductCode)).call.apply(_ref, [this].concat(args))), _this), _this.getEditProductCodeIcon = function () {
      var _this$props = _this.props,
          profileToShow = _this$props.profileToShow,
          editField = _this$props.editField;

      return _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', marginLeft: '8px', fontSize: '16px' },
          className: 'profile-edit-icon-container',
          onClick: editField.bind(_this, 'productCode', { type: 'productCode' })
        },
        _react2.default.createElement(_icon2.default, { className: profileToShow.productCode ? 'tc-icon-mode_edit profile-edit-icon' : 'tc-icon-add description-segments-add-icon' }),
        profileToShow.productCode ? 'EDIT' : 'Add Product Code'
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductCode, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          isEditable = _props.isEditable,
          routeName = _props.routeName;

      var productCode = profileToShow.productCode && routeName === 'product' ? profileToShow.productCode : undefined;
      if (profileToShow.productCode || isEditable && routeName === 'product') {
        return _react2.default.createElement(
          'span',
          { style: { display: 'block', whiteSpace: 'pre-wrap' } },
          productCode ? 'Product Code: ' + productCode : undefined,
          routeName === 'product' && isEditable ? this.getEditProductCodeIcon() : undefined
        );
      }
      return false;
    }
  }]);

  return ProductCode;
}(_react.Component);

ProductCode.propTypes = {
  profileToShow: _react.PropTypes.object,
  editField: _react.PropTypes.func,
  isEditable: _react.PropTypes.bool,
  routeName: _react.PropTypes.string
};

exports.default = ProductCode;

/***/ }),
/* 3181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _functional = __webpack_require__(872);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Address = function (_Component) {
  _inherits(Address, _Component);

  function Address() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Address);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Address.__proto__ || Object.getPrototypeOf(Address)).call.apply(_ref, [this].concat(args))), _this), _this.getEditAddressIcon = function () {
      var _this$props = _this.props,
          profileToShow = _this$props.profileToShow,
          routeName = _this$props.routeName,
          isEditable = _this$props.isEditable;

      if (isEditable) {
        return _react2.default.createElement(
          'div',
          {
            style: { display: 'inline-block', marginLeft: '8px' },
            className: 'profile-edit-icon-container',
            onClick: _this._editAddress
          },
          _react2.default.createElement(_icon2.default, { className: 'tc-icon-mode_edit profile-edit-icon' }),
          profileToShow.address && profileToShow.address.addressOne ? 'EDIT' : function () {
            var routeDisplay = '';
            if (routeName === 'profile') routeDisplay += 'Company';
            if (routeName === 'location') routeDisplay += 'Location';
            return 'Add ' + routeDisplay + ' Address';
          }()
        );
      }
    }, _this._editAddress = function () {
      var _this$props2 = _this.props,
          routeName = _this$props2.routeName,
          editField = _this$props2.editField;

      var route = routeName === 'product' ? 'location' : undefined;
      editField('address', { specifiedRoute: route, type: 'address' });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Address, [{
    key: 'getAddress',
    value: function getAddress(addressObject) {
      var address = addressObject || {};
      var formattedAddressStreet = '';
      var formattedAddressRest = '';
      if (address.addressOne) formattedAddressStreet += address.addressOne;
      if (address.addressTwo) formattedAddressStreet += ', ' + address.addressTwo;
      if (address.city) formattedAddressRest += address.city;
      if (address.state) formattedAddressRest += ', ' + address.state;
      if (address.country) formattedAddressRest += ', ' + address.country;
      if (address.postalCode) formattedAddressRest += ' ' + address.postalCode;
      return _react2.default.createElement(
        'div',
        { style: { display: 'inline-block' } },
        _react2.default.createElement(
          'span',
          { style: { display: 'block' } },
          formattedAddressStreet
        ),
        _react2.default.createElement(
          'span',
          { style: { display: 'block' } },
          formattedAddressRest
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          routeName = _props.routeName,
          basicUser = _props.basicUser,
          user = _props.user;
      // if (basicUser && getIn(['connectionInfo', 'status'], profileToShow) !== 'accepted' && getIn(['user', 'userID'], user) !== profileToShow.companyId) {
      //   return (<span style={{ display: 'block', whiteSpace: 'pre-wrap' }} id="address">
      //     Connect to this company to see address, phone and website.
      //   </span>);
      // }

      return _react2.default.createElement(
        'span',
        { style: { display: 'block', whiteSpace: 'pre-wrap' }, id: 'address' },
        this.getAddress(profileToShow.address),
        routeName !== 'product' ? this.getEditAddressIcon() : undefined
      );
    }
  }]);

  return Address;
}(_react.Component);

Address.propTypes = {
  routeName: _react.PropTypes.string,
  editField: _react.PropTypes.func,
  profileToShow: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool,
  basicUser: _react.PropTypes.bool,
  user: _react.PropTypes.object
};

exports.default = Address;

/***/ }),
/* 3182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _functional = __webpack_require__(872);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Website = function (_Component) {
  _inherits(Website, _Component);

  function Website() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Website);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Website.__proto__ || Object.getPrototypeOf(Website)).call.apply(_ref, [this].concat(args))), _this), _this.getEditWebsiteIcon = function () {
      var _this$props = _this.props,
          profileToShow = _this$props.profileToShow,
          routeName = _this$props.routeName;


      return _react2.default.createElement(
        'div',
        { style: { display: 'inline-block', marginLeft: '8px' }, className: 'profile-edit-icon-container', onClick: _this._editWebsite },
        _react2.default.createElement(_icon2.default, { className: 'tc-icon-mode_edit profile-edit-icon' }),
        profileToShow.website ? 'EDIT' : function () {
          var routeDisplay = '';
          if (routeName === 'profile') routeDisplay = 'Company';
          if (routeName === 'location') {
            routeDisplay = 'Location';
          }
          if (routeName === 'product') routeDisplay = 'Product';
          return 'Add ' + routeDisplay + ' Website';
        }()
      );
    }, _this._editWebsite = function () {
      var _this$props2 = _this.props,
          editField = _this$props2.editField,
          routeName = _this$props2.routeName;

      var route = routeName === 'product' ? 'location' : undefined;
      editField('website', { type: 'website', specifiedRoute: route });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Website, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          isEditable = _props.isEditable,
          routeName = _props.routeName,
          basicUser = _props.basicUser,
          user = _props.user;

      var website = profileToShow.website && routeName !== 'product' ? profileToShow.website : null;
      // if (basicUser && getIn(['connectionInfo', 'status'], profileToShow) !== 'accepted' && getIn(['user', 'userID'], user) !== profileToShow.companyId) return false;
      return _react2.default.createElement(
        'span',
        { style: { display: 'block', whiteSpace: 'pre-wrap' }, id: 'website' },
        website,
        routeName !== 'product' && isEditable ? this.getEditWebsiteIcon() : null
      );
    }
  }]);

  return Website;
}(_react.Component);

Website.propTypes = {
  profileToShow: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool,
  routeName: _react.PropTypes.string,
  editField: _react.PropTypes.func,
  basicUser: _react.PropTypes.bool,
  user: _react.PropTypes.object
};

exports.default = Website;

/***/ }),
/* 3183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _functional = __webpack_require__(872);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Phone = function (_Component) {
  _inherits(Phone, _Component);

  function Phone() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Phone);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Phone.__proto__ || Object.getPrototypeOf(Phone)).call.apply(_ref, [this].concat(args))), _this), _this.getEditPhoneIcon = function () {
      var _this$props = _this.props,
          profileToShow = _this$props.profileToShow,
          routeName = _this$props.routeName;

      return _react2.default.createElement(
        'div',
        {
          style: { display: 'inline-block', marginLeft: '8px' },
          className: 'profile-edit-icon-container',
          onClick: _this._editPhone
        },
        _react2.default.createElement(_icon2.default, { className: 'tc-icon-mode_edit profile-edit-icon' }),
        profileToShow.phone ? 'EDIT' : function () {
          var routeDisplay = '';
          if (routeName === 'profile') routeDisplay = 'Company';
          if (routeName === 'location') {
            routeDisplay = 'Location';
          }
          if (routeName === 'product') routeDisplay = 'Product';
          return 'Add ' + routeDisplay + ' Phone';
        }()
      );
    }, _this._editPhone = function () {
      var _this$props2 = _this.props,
          editField = _this$props2.editField,
          routeName = _this$props2.routeName;

      var route = routeName === 'product' ? 'location' : undefined;
      editField('phone', { type: 'phone', specifiedRoute: route, isRequired: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Phone, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profileToShow = _props.profileToShow,
          isEditable = _props.isEditable,
          routeName = _props.routeName,
          basicUser = _props.basicUser,
          user = _props.user;

      var phone = profileToShow.phone && routeName !== 'product' ? profileToShow.phone : null;
      // if (basicUser && getIn(['connectionInfo', 'status'], profileToShow) !== 'accepted' && getIn(['user', 'userID'], user) !== profileToShow.companyId) return false;
      return _react2.default.createElement(
        'span',
        { style: { display: 'block', whiteSpace: 'pre-wrap' }, id: 'phone' },
        phone,
        routeName !== 'product' && isEditable ? this.getEditPhoneIcon() : null
      );
    }
  }]);

  return Phone;
}(_react.Component);

Phone.propTypes = {
  profileToShow: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool,
  routeName: _react.PropTypes.string,
  editField: _react.PropTypes.func,
  basicUser: _react.PropTypes.bool,
  user: _react.PropTypes.object
};

exports.default = Phone;

/***/ }),
/* 3184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _imageCropDialog = __webpack_require__(1227);

var _imageCropDialog2 = _interopRequireDefault(_imageCropDialog);

var _companyConnection = __webpack_require__(3185);

var _companyConnection2 = _interopRequireDefault(_companyConnection);

var _viewLink = __webpack_require__(3187);

var _viewLink2 = _interopRequireDefault(_viewLink);

var _ramda = __webpack_require__(2);

var _jquery = __webpack_require__(251);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getRandomColorClass() {
  var colors = ['is-red', 'is-pink', 'is-purple', 'is-deep-purple', 'is-indigo', 'is-blue', 'is-light-blue', 'is-cyan', 'is-teal', 'is-green', 'is-deep-orange'];

  var assignRandomColorClass = function assignRandomColorClass() {
    return colors[Math.floor(Math.random() * colors.length)];
  };

  return 'profile-image-letter' + assignRandomColorClass();
}

var Logo = function (_Component) {
  _inherits(Logo, _Component);

  function Logo(props) {
    _classCallCheck(this, Logo);

    var _this = _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).call(this, props));

    _this.getEditableBackground = function () {
      var _this$props = _this.props,
          isEditable = _this$props.isEditable,
          profileToShow = _this$props.profileToShow;

      if (isEditable) {
        if (profileToShow.profileImageUrl) {
          return _react2.default.createElement(
            'div',
            { className: 'l-profile-logo-background' },
            _react2.default.createElement(
              _imageCropDialog2.default,
              {
                confirmCroppedFn: _this.profileImageSourceChanged,
                uploadStartFn: _this._toggleLoader.bind(_this, 'logo', true),
                cropWidth: 256,
                cropHeight: 256,
                imageName: 'profile',
                dialogWidth: '400px',
                round: true
              },
              'Edit'
            )
          );
        }
        return _react2.default.createElement(
          'div',
          {
            style: {
              width: '128px',
              height: '128px',
              top: '-64px',
              left: '16px',
              lineHeight: '128px',
              borderRadius: '50%',
              position: 'absolute',
              color: '#fff',
              backgroundColor: 'rgba(184,184,184,.8)',
              textAlign: 'center'
            }
          },
          _react2.default.createElement(
            _imageCropDialog2.default,
            {
              confirmCroppedFn: _this.profileImageSourceChanged,
              uploadStartFn: _this._toggleLoader.bind(_this, 'logo', true),
              cropWidth: 128,
              cropHeight: 128,
              imageName: 'profile',
              dialogWidth: '400px',
              round: true
            },
            'Add Profile Photo'
          )
        );
      }
    };

    _this.getProfileLogoNode = function () {
      var _this$props2 = _this.props,
          routeName = _this$props2.routeName,
          profileToShow = _this$props2.profileToShow,
          isEditable = _this$props2.isEditable;

      var profileNameField = routeName === 'profile' ? 'companyName' : routeName + 'Name';
      var logo = function () {
        if (!profileToShow.profileImageUrl && !isEditable) {
          var companyLetter = profileToShow[profileNameField].charAt(0).toUpperCase();
          return _react2.default.createElement(
            'div',
            {
              className: _this.state.colorClass,
              style: { lineHeight: '128px', fontSize: '38px' }
            },
            companyLetter
          );
        }
        var imageStyle = {
          backgroundImage: 'url("' + profileToShow.profileImageUrl + '")'
        };
        if (_this.state.logoIsLoading) {
          var bgImg = new Image(128, 128);
          bgImg.onload = function () {
            // image is loaded
            _this._toggleLoader('logo', false);
            delete bgImg.prototype;
          };
          bgImg.src = profileToShow.profileImageUrl;
        }
        return _react2.default.createElement('div', { id: 'profileViewImage', className: 'profileViewImage', style: imageStyle });
      }();

      var showLoaderClass = _this.state.logoIsLoading ? ' image-loading-indicater' : '';
      var logoPhotoClass = 'l-profile-logo' + (!profileToShow.profileImageUrl && !isEditable ? ' profile-image' : '') + ' ' + showLoaderClass;
      if (isEditable || profileToShow.profileImageUrl) logoPhotoClass += ' l-profile-logo-grey-background';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { overflow: 'hidden' }, className: logoPhotoClass },
          logo
        ),
        _this.getEditableBackground()
      );
    };

    _this.profileImageSourceChanged = function (profileImageUrl) {
      var _saveField = _this.props._saveField;

      _saveField({
        route: 'profile',
        updateField: 'profileImageUrl',
        updateBody: profileImageUrl
      });
    };

    _this._toggleLoader = function (field, isLoading) {
      _this.setState(_defineProperty({}, field + 'IsLoading', isLoading));
    };

    _this.resizeImageAfterLoading = function (e) {
      var margin = void 0;
      if (e.target.width > e.target.height) {
        (0, _jquery2.default)('#profileViewImage').css({ width: '100%', height: 'auto' });
        margin = (128 - e.target.height) / 2;
        (0, _jquery2.default)('#profileViewImage').css({ 'margin-top': margin, 'margin-bottom': margin });
      } else {
        (0, _jquery2.default)('#profileViewImage').css({ width: 'auto', height: '100%' });
        margin = (128 - e.target.width) / 2;
        (0, _jquery2.default)('#profileViewImage').css({ 'margin-left': margin, 'margin-right': margin });
      }
      _this._toggleLoader('logo', false);
    };

    _this.state = { colorClass: getRandomColorClass() };
    return _this;
  }

  _createClass(Logo, [{
    key: 'render',
    value: function render() {
      var profileToShow = this.props.profileToShow;

      var isViewedByOwner = (0, _ramda.equals)((0, _ramda.path)(['user', 'company', 'companyId'], this.props), (0, _ramda.path)(['profileToShow', 'companyId'], this.props));
      var connectionInfoNode = profileToShow.connectionInfo ? _react2.default.createElement(_companyConnection2.default, this.props) : undefined;
      var viewsInfoNode = profileToShow.profileViews && isViewedByOwner ? _react2.default.createElement(_viewLink2.default, this.props) : undefined;
      return _react2.default.createElement(
        'div',
        { className: 'l-profile-logo-container' },
        this.getProfileLogoNode(),
        connectionInfoNode,
        viewsInfoNode
      );
    }
  }]);

  return Logo;
}(_react.Component);

Logo.propTypes = {
  routeName: _react.PropTypes.string,
  profileToShow: _react.PropTypes.object,
  isEditable: _react.PropTypes.bool,
  _saveField: _react.PropTypes.func
};

exports.default = Logo;

/***/ }),
/* 3185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _partnerFinderActions = __webpack_require__(1125);

var _materialUi = __webpack_require__(3);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _sendCustomMsg = __webpack_require__(1951);

var _sendCustomMsg2 = _interopRequireDefault(_sendCustomMsg);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _check = __webpack_require__(854);

var _check2 = _interopRequireDefault(_check);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

var _upgradeActions = __webpack_require__(611);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var languageSettings = _languages2.default['en-US'];

var CompanyConnection = function (_Component) {
  _inherits(CompanyConnection, _Component);

  function CompanyConnection() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CompanyConnection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CompanyConnection.__proto__ || Object.getPrototypeOf(CompanyConnection)).call.apply(_ref, [this].concat(args))), _this), _this.acceptConnection = function (connectionId) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          triggerSnackBarMessage = _this$props.triggerSnackBarMessage;
      var _this$props$profileTo = _this.props.profileToShow,
          companyId = _this$props$profileTo.companyId,
          locationId = _this$props$profileTo.locationId,
          productId = _this$props$profileTo.productId;

      dispatch((0, _partnerFinderActions.acceptConnection)(connectionId, companyId, locationId, productId)).then(function () {
        triggerSnackBarMessage({ message: 'Invitation Accepted' });
      }).catch(function () {
        triggerSnackBarMessage({ message: 'Accepting Connection Failed' });
        // dispatch(undoConnectionChange());
      });
    }, _this._fakeResendInvitation = function (connectionId) {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          triggerSnackBarMessage = _this$props2.triggerSnackBarMessage;
      var _this$props$profileTo2 = _this.props.profileToShow,
          companyId = _this$props$profileTo2.companyId,
          locationId = _this$props$profileTo2.locationId,
          productId = _this$props$profileTo2.productId;

      dispatch((0, _partnerFinderActions.fakeResendInvitation)(connectionId, companyId, locationId, productId)).then(function () {
        triggerSnackBarMessage({ message: 'Invitation Sent' });
      }).catch(function () {
        triggerSnackBarMessage({ message: 'Resending Invitation Failed' });
      });
    }, _this.ignoreConnection = function (connectionId) {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          triggerSnackBarMessage = _this$props3.triggerSnackBarMessage;
      var _this$props$profileTo3 = _this.props.profileToShow,
          companyId = _this$props$profileTo3.companyId,
          locationId = _this$props$profileTo3.locationId,
          productId = _this$props$profileTo3.productId;

      dispatch((0, _partnerFinderActions.ignoreConnection)(connectionId, companyId, locationId, productId)).then(function () {
        triggerSnackBarMessage({ message: 'Connection Request Ignored' });
      }).catch(function () {
        triggerSnackBarMessage({ message: 'Ignoring Connection Failed' });
      });
    }, _this.resendConnection = function (connectionId) {
      var _this$props4 = _this.props,
          dispatch = _this$props4.dispatch,
          triggerSnackBarMessage = _this$props4.triggerSnackBarMessage;
      var _this$props$profileTo4 = _this.props.profileToShow,
          companyId = _this$props$profileTo4.companyId,
          locationId = _this$props$profileTo4.locationId,
          productId = _this$props$profileTo4.productId;

      dispatch((0, _partnerFinderActions.resendInvitation)(connectionId, companyId, locationId, productId)).then(function () {
        triggerSnackBarMessage({ message: 'Invitation Sent' });
      }).catch(function () {
        triggerSnackBarMessage({ message: 'Resending Invitation Failed' });
        // dispatch(undoConnectionChange());
      });
    }, _this.initConnect = function (customMsg) {
      var _this$props5 = _this.props,
          dispatch = _this$props5.dispatch,
          triggerSnackBarMessage = _this$props5.triggerSnackBarMessage;
      var _this$props$profileTo5 = _this.props.profileToShow,
          companyId = _this$props$profileTo5.companyId,
          locationId = _this$props$profileTo5.locationId,
          productId = _this$props$profileTo5.productId;

      dispatch((0, _partnerFinderActions.sendInvitation)(customMsg, { companyId: companyId, locationId: locationId, productId: productId })).then(function () {
        triggerSnackBarMessage({ message: 'Invitation Sent' });
      }).catch(function () {
        triggerSnackBarMessage({ message: 'Sending Invitation Failed' });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CompanyConnection, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var raisedButton = void 0;
      var _props = this.props,
          basicUser = _props.basicUser,
          isViewingOwnProfile = _props.isViewingOwnProfile;
      var connectionInfo = this.props.profileToShow.connectionInfo;
      var _props$profileToShow = this.props.profileToShow,
          companyId = _props$profileToShow.companyId,
          locationId = _props$profileToShow.locationId,
          productId = _props$profileToShow.productId,
          companyName = _props$profileToShow.companyName,
          viewingAs = _props$profileToShow.viewingAs;

      var acceptedButton = _react2.default.createElement(
        'div',
        { className: 'company-connected-status' },
        _react2.default.createElement(_check2.default, {
          color: 'rgba(0, 0, 0, 0.54)',
          style: { marginRight: '3px', top: '5px', position: 'relative' }
        }),
        _react2.default.createElement(
          'span',
          null,
          'Partners'
        )
      );
      if (isViewingOwnProfile) {
        raisedButton = (0, _ramda.equals)(viewingAs, 'connected') ? acceptedButton : _react2.default.createElement(_materialUi.RaisedButton, { primary: true, fullWidth: true, label: languageSettings.company.leftNav.unconnected });
      } else {
        switch (connectionInfo.status) {
          case 'accepted':
            raisedButton = acceptedButton;
            break;
          case 'pending':
            if (connectionInfo.isSender) {
              raisedButton = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_materialUi.RaisedButton, {
                  secondary: true,
                  fullWidth: true,
                  label: 'RESEND PARTNER REQUEST',
                  onClick: this.resendConnection.bind(this, connectionInfo.id)
                }),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'span',
                  { className: 'last-sent', style: { lineHeight: '8px' } },
                  'Last sent ',
                  connectionInfo.lastSent
                )
              );
            } else {
              raisedButton = _react2.default.createElement(
                'div',
                { className: 'company-connected-status' },
                _react2.default.createElement(
                  'span',
                  { className: 'company-connection-text' },
                  languageSettings.company.leftNav.accept
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'company-connection-buttons' },
                  _react2.default.createElement(_icon2.default, {
                    className: 'tc-icon-close',
                    onClick: this.ignoreConnection.bind(this, connectionInfo.id)
                  }),
                  _react2.default.createElement(_icon2.default, {
                    className: 'tc-icon-check',
                    onClick: this.acceptConnection.bind(this, connectionInfo.id)
                  })
                )
              );
            }
            break;
          case 'unconnected':
            // TO DO
            raisedButton = _react2.default.createElement(
              _materialUi.RaisedButton,
              {
                fullWidth: true,
                secondary: true,
                style: { marginLeft: basicUser ? '5%' : '0' },
                label: 'SEND PARTNER REQUEST',
                onClick: function onClick(e) {
                  return _this2.props.openPopover({
                    popOverAnchorEl: e.currentTarget,
                    receiverInfo: { companyId: companyId, locationId: locationId, productId: productId, companyName: companyName }
                  });
                }
              },
              _react2.default.createElement(_sendCustomMsg2.default, {
                sendInvitation: this.initConnect,
                onRequestClose: this.props.closePopover,
                updateCustomizedMsg: this.props.updateCustomizedMsg
              })
            );
            break;
          case 'rejected':
            if (connectionInfo.isSender) {
              raisedButton = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_materialUi.RaisedButton, {
                  fullWidth: true,
                  onClick: this._fakeResendInvitation.bind(this, connectionInfo.id),
                  secondary: true,
                  label: languageSettings.company.leftNav.resend
                }),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'span',
                  { className: 'last-sent', style: { lineHeight: '8px' } },
                  'Last sent ',
                  connectionInfo.lastSent
                )
              );
            } else {
              raisedButton = _react2.default.createElement(_materialUi.FlatButton, {
                fullWidth: true,
                disabled: true,
                label: languageSettings.partnerFinder.rightContent.ignored
              });
            }
            break;
          default:
            break;
        }
      }

      return _react2.default.createElement(
        'div',
        { className: 'profile-connection-info' },
        _react2.default.createElement(
          'span',
          {
            style: {
              whiteSpace: basicUser ? 'pre' : undefined,
              marginLeft: basicUser ? '-10px' : undefined
            }
          },
          raisedButton
        )
      );
    }
  }]);

  return CompanyConnection;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
  var partnerFinder = _ref2.partnerFinder,
      user = _ref2.user;
  return {
    sendCustomMsg: partnerFinder.get('sendCustomMsg').toJS(),
    userId: user.getIn(['user', 'userID']),
    basicUser: (user.get('billingPlan') || 'basic') === 'basic'
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closePopover: function closePopover() {
      return dispatch((0, _partnerFinderActions.closePopover)());
    },
    openPopover: function openPopover(payload) {
      return dispatch((0, _partnerFinderActions.openPopover)(payload));
    },
    updateCustomizedMsg: function updateCustomizedMsg(payload) {
      return dispatch((0, _partnerFinderActions.updateCustomizedMsg)(payload));
    },
    openUpgrade: function openUpgrade(clickedCompany) {
      return dispatch((0, _upgradeActions.openUpgradeFrom)('profileConnectBtn', { clickedCompany: clickedCompany }));
    }
  };
};

CompanyConnection.propTypes = {
  dispatch: _react.PropTypes.func,
  triggerSnackBarMessage: _react.PropTypes.func,
  profileToShow: _react.PropTypes.object,
  partnerFinder: _react.PropTypes.object,
  basicUser: _react.PropTypes.bool,
  history: _react.PropTypes.object,
  openPopover: _react.PropTypes.func,
  closePopover: _react.PropTypes.func,
  updateCustomizedMsg: _react.PropTypes.func,
  isViewingOwnProfile: _react.PropTypes.bool,
  openUpgrade: _react.PropTypes.func
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CompanyConnection);

/***/ }),
/* 3186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1b78574b361f178ee30908c155efa2fc.png";

/***/ }),
/* 3187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsUpdate = __webpack_require__(1516);

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _materialUi = __webpack_require__(3);

var _ClickAwayListener = __webpack_require__(853);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _arrowBox = __webpack_require__(3188);

var _arrowBox2 = _interopRequireDefault(_arrowBox);

var _reactRedux = __webpack_require__(6);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _blurry = __webpack_require__(3189);

var _blurry2 = _interopRequireDefault(_blurry);

var _upgradeActions = __webpack_require__(611);

var _lock = __webpack_require__(578);

var _lock2 = _interopRequireDefault(_lock);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewLink = (0, _react.createClass)({

  propTypes: {
    history: _react.PropTypes.object,
    dispatch: _react.PropTypes.func,
    triggerSnackBarMessage: _react.PropTypes.func,
    profile: _react.PropTypes.object,
    updateUpgradeSource: _react.PropTypes.func,
    profileToShow: _react.PropTypes.object,
    className: _react.PropTypes.string,
    user: _react.PropTypes.object,
    openUpgradeFrom: _react.PropTypes.func
  },

  getInitialState: function getInitialState() {
    return {
      localComponentState: {
        open: false
      }
    };
  },
  setLocalComponentState: function setLocalComponentState(update) {
    this.setState({ localComponentState: (0, _reactAddonsUpdate2.default)(this.state.localComponentState, { $merge: update }) });
  },
  componentClickAway: function componentClickAway() {
    this.setLocalComponentState({ open: false });
  },
  handleOnClick: function handleOnClick() {
    this.setLocalComponentState({ open: !this.state.localComponentState.open });
  },
  openProfile: function openProfile(companyId) {
    var history = this.props.history;

    history.push('/company/' + companyId);
  },
  upgradePlanClicked: function upgradePlanClicked() {
    this.setLocalComponentState({ open: false });
    this.props.openUpgradeFrom('profileViews');
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        profileToShow = _props.profileToShow,
        history = _props.history;

    var classes = (0, _classnames2.default)('view-link', this.props.className, {
      'is-closed': !this.state.localComponentState.open
    });
    var numberOfViews = void 0;
    var viewerLists = void 0;
    var arrowBoxContent = void 0;
    if (profileToShow.profileViews) {
      numberOfViews = profileToShow.profileViews.length;
      viewerLists = profileToShow.profileViews.map(function (view, index) {
        var primaryText = _react2.default.createElement(
          'div',
          { className: 'div-link', style: { fontSize: '13px' }, onClick: function onClick() {
              return _this.openProfile(view.companyId);
            } },
          view.companyName
        );
        var secondaryText = _react2.default.createElement(
          'div',
          { style: { fontSize: '11px' } },
          (0, _moment2.default)(new Date(+view.timeViewed)).isValid() ? (0, _moment2.default)(new Date(+view.timeViewed)).format('l, h:mm a') : (0, _moment2.default)(new Date(view.timeViewed)).format('l, h:mm a')
        );
        var listDivider = void 0;
        var rightIcon = void 0;
        var rightIconButton = void 0;
        if (index !== 0) listDivider = _react2.default.createElement(_materialUi.Divider, { inset: true });
        return _react2.default.createElement(
          'div',
          { key: index },
          _react2.default.createElement(_materialUi.ListItem, {
            primaryText: primaryText,
            secondaryText: secondaryText,
            rightIconButton: rightIconButton,
            rightIcon: rightIcon,
            leftAvatar: _react2.default.createElement(_materialUi.Avatar, { src: view.profileImageUrl }),
            disabled: true
          }),
          listDivider
        );
      });
      viewerLists.reverse();
    }

    var overflow = void 0;
    if (this.props.user.company.plan === 'unlimited' || this.props.user.company.plan === 'connected') {
      if (viewerLists.length) {
        arrowBoxContent = _react2.default.createElement(
          _materialUi.List,
          { style: { textAlign: 'left', margin: '0px' } },
          viewerLists
        );
      } else {
        arrowBoxContent = _react2.default.createElement(
          'div',
          { style: { width: '90%', margin: '20px auto', textAlign: 'center', fontSize: '16px', color: 'grey' } },
          _react2.default.createElement(
            'div',
            { style: { margin: '45px 0 15px 0' } },
            "Seems a bit quiet here."
          ),
          _react2.default.createElement(
            'div',
            { style: { marginBottom: '20px' } },
            "Start inviting more partners!"
          ),
          _react2.default.createElement(_materialUi.RaisedButton, { primary: true, label: '+ add connections', onTouchTap: function onTouchTap() {
              return history.push('/connections/add-connections');
            } }),
          _react2.default.createElement(
            'div',
            { style: { margin: '10px auto' } },
            'OR'
          ),
          _react2.default.createElement(_materialUi.RaisedButton, { secondary: true, label: '+ find new partners', onTouchTap: function onTouchTap() {
              return history.push('/partner-finder/results');
            } })
        );
      }
      overflow = 'scroll';
    } else {
      arrowBoxContent = _react2.default.createElement(
        'div',
        { style: { width: '90%', margin: '20px auto', textAlign: 'center' } },
        _react2.default.createElement(
          'h4',
          null,
          'Upgrade to see who has viewed your Profile'
        ),
        _react2.default.createElement(
          _wrapper2.default,
          { hideOnSkip: true, blocker: true, slug: 'upgrade-pf-mktg-prfle', amazonOrange: true, lockIcon: true },
          _react2.default.createElement(_materialUi.RaisedButton, {
            primary: true,
            label: 'upgrade my plan',
            onClick: this.upgradePlanClicked
          })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('img', { src: _blurry2.default })
        )
      );
      overflow = 'hidden';
    }
    return _react2.default.createElement(
      'div',
      { className: classes },
      _react2.default.createElement(
        'div',
        { className: 'views-info' },
        _react2.default.createElement(
          'div',
          { className: 'div-link', onClick: this.handleOnClick },
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', cursor: 'pointer', fontSize: '20px', lineHeight: '40px', marginRight: '3px' } },
            _react2.default.createElement(
              'strong',
              null,
              numberOfViews
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', marginLeft: '4px' } },
            'Profile Views'
          )
        )
      ),
      _react2.default.createElement(
        _ClickAwayListener2.default,
        { onClickAway: this.componentClickAway },
        _react2.default.createElement(
          'div',
          { className: 'view-link-container' },
          _react2.default.createElement(
            _arrowBox2.default,
            {
              boxStyle: { marginTop: '12px', marginLeft: '-8px', width: '285px' },
              innerBoxStyle: { paddingRight: '20px', height: '300px', overflow: overflow }
            },
            arrowBoxContent
          )
        )
      )
    );
  }
});

exports.default = (0, _reactRedux.connect)(null, { openUpgradeFrom: _upgradeActions.openUpgradeFrom })(ViewLink);

/***/ }),
/* 3188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArrowBox = function (_Component) {
  _inherits(ArrowBox, _Component);

  function ArrowBox() {
    _classCallCheck(this, ArrowBox);

    return _possibleConstructorReturn(this, (ArrowBox.__proto__ || Object.getPrototypeOf(ArrowBox)).apply(this, arguments));
  }

  _createClass(ArrowBox, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: this.props.boxStyle, className: this.props.blueArrowColor ? ' arrow-box blue-arrow-box' : 'arrow-box' },
        _react2.default.createElement(
          'div',
          { style: this.props.innerBoxStyle, className: 'arrow-box-inner' },
          this.props.children
        )
      );
    }
  }]);

  return ArrowBox;
}(_react.Component);

ArrowBox.propTypes = {
  boxStyle: _react.PropTypes.object,
  innerBoxStyle: _react.PropTypes.object,
  children: _react.PropTypes.any,
  blueArrowColor: _react.PropTypes.bool
};

exports.default = ArrowBox;

/***/ }),
/* 3189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cdaeb2689e132ea6dd9c6ad69f56430a.jpg";

/***/ }),
/* 3190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(3191);

var _Link2 = _interopRequireDefault(_Link);

var _ramda = __webpack_require__(2);

var _imageUpload = __webpack_require__(3197);

var _imageUpload2 = _interopRequireDefault(_imageUpload);

var _imageCropDialog = __webpack_require__(1227);

var _imageCropDialog2 = _interopRequireDefault(_imageCropDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompletedIcon = __webpack_require__(3198);


var TopBannerContainer = function TopBannerContainer(props) {
  var firstIcon = props.firstIcon,
      firstText = props.firstText,
      firstIconCompleted = props.firstIconCompleted,
      secondIcon = props.secondIcon,
      secondText = props.secondText,
      secondIconCompleted = props.secondIconCompleted,
      numberOfIcons = props.numberOfIcons,
      iconTextArray = props.iconTextArray,
      bannerColor = props.bannerColor,
      bannerContent = props.bannerContent,
      bannerHeight = props.bannerHeight,
      anchorFirstIconTo = props.anchorFirstIconTo,
      anchorFirstOffset = props.anchorFirstOffset,
      anchorSecondIconTo = props.anchorSecondIconTo;


  var standardTextStyle = { color: '#ffffff', fontSize: '14px' };
  var gridCellClass = (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)(3), (0, _ramda.always)('Grid-cell Grid--1of3')], [(0, _ramda.equals)(4), (0, _ramda.always)('Grid-cell Grid--1of4')], [(0, _ramda.equals)(0), (0, _ramda.always)('Grid-cell')], [_ramda.T, (0, _ramda.always)('')]]), numberOfIcons);
  var completedIcon = _react2.default.createElement('img', {
    src: CompletedIcon,
    height: '30px'
  });

  var displayIcon = function displayIcon(obj) {
    return (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), function () {
      return completedIcon;
    }, function () {
      return (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), function () {
        return _react2.default.createElement('img', {
          src: obj.icon,
          height: '30px'
        });
      }, function () {
        return obj.icon;
      }), obj.svgIcon);
    }), obj.completed);
  };

  return _react2.default.createElement(
    'div',
    { className: 'Grid top-action-bar', style: { backgroundColor: bannerColor ? bannerColor : '#1b2936', height: bannerHeight ? bannerHeight : '160px' } },
    _react2.default.createElement(
      'div',
      { className: 'Grid-cell--center', style: { width: '50%', textAlign: 'center', margin: '0 auto' } },
      (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)(0), function () {
        return bannerContent;
      }], [(0, _ramda.equals)(2), function () {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _Link2.default,
            { to: anchorFirstIconTo, offset: anchorFirstOffset },
            _react2.default.createElement(
              'div',
              { style: { float: 'left', cursor: 'pointer' } },
              firstIconCompleted ? completedIcon : firstIcon,
              _react2.default.createElement(
                'p',
                { style: standardTextStyle },
                firstText
              )
            )
          ),
          _react2.default.createElement(
            _Link2.default,
            { to: anchorSecondIconTo },
            _react2.default.createElement(
              'div',
              { style: { float: 'right', cursor: 'pointer' } },
              secondIconCompleted ? completedIcon : secondIcon,
              _react2.default.createElement(
                'p',
                { style: standardTextStyle },
                secondText
              )
            )
          )
        );
      }], [_ramda.T, function () {
        return _react2.default.createElement(
          'div',
          { className: 'Grid' },
          iconTextArray.map(function (obj, index) {
            var getAnchorTag = (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('Add Memberships'), (0, _ramda.always)('#membership')], [(0, _ramda.equals)('Add Marketing Materials'), (0, _ramda.always)('#marketing-materials')], [_ramda.T, (0, _ramda.always)('')]]), obj.iconText);
            var UploadOrAnchor = (0, _ramda.call)((0, _ramda.cond)([[function () {
              return obj.iconText === 'Add Memberships';
            }, (0, _ramda.always)('a')], [function () {
              return obj.iconText === 'Add Marketing Materials';
            }, (0, _ramda.always)('a')], [(0, _ramda.has)('forCropDialog'), function () {
              return _imageCropDialog2.default;
            }], [_ramda.T, function () {
              return _imageUpload2.default;
            }]]), obj);
            return _react2.default.createElement(
              'div',
              { key: index, style: { width: '25%' } },
              _react2.default.createElement(
                'div',
                { className: gridCellClass, style: { position: 'relative', overflow: 'hidden', cursor: 'pointer' } },
                _react2.default.createElement(
                  UploadOrAnchor,
                  _extends({ types: obj.types, href: getAnchorTag }, obj.forCropDialog),
                  displayIcon(obj),
                  _react2.default.createElement(
                    'p',
                    { style: (0, _ramda.merge)(standardTextStyle, { color: obj.completed ? '#ffffff' : '#50c7f9' }) },
                    _react2.default.createElement(
                      'span',
                      null,
                      obj.completed ? obj.completedText : obj.iconText,
                      ' '
                    ),
                    _react2.default.createElement('br', null)
                  )
                )
              )
            );
          })
        );
      }]]), numberOfIcons)
    )
  );
};

TopBannerContainer.propTypes = {
  firstIcon: _react.PropTypes.object,
  firstText: _react.PropTypes.any,
  firstIconCompleted: _react.PropTypes.bool,
  secondIcon: _react.PropTypes.object,
  secondText: _react.PropTypes.any,
  secondIconCompleted: _react.PropTypes.bool,
  numberOfIcons: _react.PropTypes.number,
  iconTextArray: _react.PropTypes.array,
  bannerColor: _react.PropTypes.string,
  bannerContent: _react.PropTypes.object,
  bannerHeight: _react.PropTypes.string,
  anchorFirstIconTo: _react.PropTypes.string,
  anchorFirstOffset: _react.PropTypes.number,
  anchorSecondIconTo: _react.PropTypes.string
};

exports.default = TopBannerContainer;

/***/ }),
/* 3191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var Helpers = __webpack_require__(3192);

var Link = React.createClass({
  displayName: 'Link',

  render: function render() {
    return React.DOM.a(this.props, this.props.children);
  }
});

module.exports = Helpers.Scroll(Link);

/***/ }),
/* 3192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(47);

var _React$PropTypes = React.PropTypes,
    bool = _React$PropTypes.bool,
    object = _React$PropTypes.object,
    string = _React$PropTypes.string,
    func = _React$PropTypes.func,
    number = _React$PropTypes.number;


var animateScroll = __webpack_require__(1952);
var scrollSpy = __webpack_require__(3195);
var scroller = __webpack_require__(3196);

var Helpers = {

  Scroll: function Scroll(Component) {

    return React.createClass({

      propTypes: {
        to: string.isRequired,
        offset: number,
        onClick: func
      },

      getDefaultProps: function getDefaultProps() {
        return { offset: 0 };
      },

      scrollTo: function scrollTo(to) {
        scroller.scrollTo(to, this.props.smooth, this.props.duration, this.props.offset);
      },

      handleClick: function handleClick(event) {

        /*
         * give the posibility to override onClick
         */

        if (this.props.onClick) {
          this.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */

        this.scrollTo(this.props.to);
      },

      componentDidMount: function componentDidMount() {

        scrollSpy.mount();

        if (this.props.spy) {
          var to = this.props.to;
          var element = null;
          var elemTopBound = 0;
          var elemBottomBound = 0;

          scrollSpy.addStateHandler(function () {
            if (scroller.getActiveLink() != to) {
              this.setState({ active: false });
            }
          }.bind(this));

          scrollSpy.addSpyHandler(function (y) {

            if (!element) {
              element = scroller.get(to);

              var cords = element.getBoundingClientRect();
              elemTopBound = cords.top + y;
              elemBottomBound = elemTopBound + cords.height;
            }

            var offsetY = y - this.props.offset;
            var isInside = offsetY >= elemTopBound && offsetY <= elemBottomBound;
            var isOutside = offsetY < elemTopBound || offsetY > elemBottomBound;
            var activeLink = scroller.getActiveLink();

            if (isOutside && activeLink === to) {
              scroller.setActiveLink(void 0);
              this.setState({ active: false });
            } else if (isInside && activeLink != to) {
              scroller.setActiveLink(to);
              this.setState({ active: true });

              if (this.props.onSetActive) {
                this.props.onSetActive(to);
              }

              scrollSpy.updateStates();
            }
          }.bind(this));
        }
      },
      componentWillUnmount: function componentWillUnmount() {
        scrollSpy.unmount();
      },
      render: function render() {
        var className = "";
        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var props = {};
        for (var prop in this.props) {
          props[prop] = this.props[prop];
        }

        props.className = className;
        props.onClick = this.handleClick;

        return React.createElement(Component, props);
      }
    });
  },

  Element: function Element(Component) {
    return React.createClass({
      propTypes: {
        name: React.PropTypes.string.isRequired
      },
      componentDidMount: function componentDidMount() {
        var domNode = ReactDOM.findDOMNode(this);
        scroller.register(this.props.name, domNode);
      },
      componentWillUnmount: function componentWillUnmount() {
        scroller.unregister(this.props.name);
      },
      render: function render() {
        return React.createElement(Component, this.props);
      }
    });
  }
};

module.exports = Helpers;

/***/ }),
/* 3193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    'use strict';

    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  }
};

/***/ }),
/* 3194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

module.exports = {
	register: function register(cancelEvent) {
		if (typeof document === 'undefined') {
			return;
		}

		for (var i = 0; i < events.length; i = i + 1) {
			document.addEventListener(events[i], cancelEvent);
		}
	}
};

/***/ }),
/* 3195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],

  mount: function mount() {
    if (typeof document !== 'undefined') {
      document.addEventListener('scroll', this.scrollHandler.bind(this));
    }
  },
  currentPositionY: function currentPositionY() {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  },

  scrollHandler: function scrollHandler() {
    for (var i = 0; i < this.spyCallbacks.length; i++) {
      this.spyCallbacks[i](this.currentPositionY());
    }
  },

  addStateHandler: function addStateHandler(handler) {
    this.spySetState.push(handler);
  },

  addSpyHandler: function addSpyHandler(handler) {
    this.spyCallbacks.push(handler);
  },

  updateStates: function updateStates() {
    var length = this.spySetState.length;

    for (var i = 0; i < length; i++) {
      this.spySetState[i]();
    }
  },
  unmount: function unmount() {
    this.spyCallbacks = [];
    this.spySetState = [];

    document.removeEventListener('scroll', this.scrollHandler);
  }
};

module.exports = scrollSpy;

/***/ }),
/* 3196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var animateScroll = __webpack_require__(1952);
var events = __webpack_require__(1953);

var __mapped = {};
var __activeLink;

module.exports = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name];
  },

  setActiveLink: function setActiveLink(link) {
    __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, animate, duration, offset) {

    /*
    * get the mapped DOM element
    */

    var target = __mapped[to];

    if (!target) {
      throw new Error("target Element not found");
    }

    var coordinates = target.getBoundingClientRect();

    if (events.registered['begin']) {
      events.registered['begin'](to, target);
    }
    /*
     * if animate is not provided just scroll into the view
     */

    if (!animate) {
      var bodyRect = document.body.getBoundingClientRect();
      var scrollOffset = coordinates.top - bodyRect.top;
      window.scrollTo(0, scrollOffset + (offset || 0));

      if (events.registered['end']) {
        events.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    var options = {
      duration: duration
    };

    animateScroll.animateTopScroll(coordinates.top + (offset || 0), options, to, target);
  }
};

/***/ }),
/* 3197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _s3Upload = __webpack_require__(564);

var _s3Upload2 = _interopRequireDefault(_s3Upload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileImage = function (_Component) {
  _inherits(ProfileImage, _Component);

  function ProfileImage(props) {
    _classCallCheck(this, ProfileImage);

    var _this = _possibleConstructorReturn(this, (ProfileImage.__proto__ || Object.getPrototypeOf(ProfileImage)).call(this, props));

    _this.onChange = function (event) {
      var fileToUpload = void 0;
      if (event) {
        if (event.target.type === 'file') {
          // Make sure there are files
          if (event.target.files && event.target.files[0]) {
            // Make sure files are images
            if (event.target.files[0].type.match(/image.*/)) {
              var reader = new FileReader();
              reader.onloadend = function () {
                var image = new Image();
                image.src = reader.result;

                image.onload = function () {
                  // Resize image
                  // Check here to make sure no infinite loop of file reads;
                  if (fileToUpload) {
                    return;
                  }
                  _this.props.types.forEach(function (type) {
                    if (typeof type.onStart === 'function') {
                      type.onStart();
                    }
                    // upload regular and thumb
                    _this.initUpload(image, type.maxSize, image, type);
                    _this.initUpload(image, 256, image, {
                      maxSize: 256,
                      name: type.name + '/thumb'
                    });
                    fileToUpload = true;
                  });
                };
              };
              reader.readAsDataURL(event.target.files[0]);
            } else {
              alert('Please upload a valid image!');
            }
          }
        }
      }
    };

    _this.state = {
      options: [],
      profileImageStyle: {},
      profileImageBackgroundStyle: {}
    };
    return _this;
  }

  _createClass(ProfileImage, [{
    key: 'initUpload',
    value: function initUpload(image, maxSize, context, type) {
      var uploadImage = function uploadImage(file, fileName, callback) {
        _s3Upload2.default.s3upload({
          file_to_upload: file,
          file_name: fileName,
          onProgress: function onProgress(percent) {
            if (percent === 100) return;
          },
          onFinishS3Put: function onFinishS3Put(publicUrl) {
            // set profile IMG in preview box to new S3 URL;
            if (typeof callback === 'function') {
              callback(publicUrl);
            }
          },
          onError: function onError(status) {
            console.log(status);
          }
        });
      };
      var isCoverPhoto = type.name === 'profileCover' || type.name === 'locationCover' || type.name === 'productCover';
      var resizedImage = isCoverPhoto ? _s3Upload2.default.resizeCoverImage(image, type.maxSize, context, type) : _s3Upload2.default.resizeImage(image, type.maxSize, context, type);
      var file = _s3Upload2.default.dataURItoBlob(resizedImage, type);
      uploadImage(file, type.name, type.onChange);
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.props.style || {},
          width = _ref.width,
          left = _ref.left,
          height = _ref.height,
          zIndex = _ref.zIndex;

      var imageUploadStyle = {
        position: 'absolute',
        top: '0',
        cursor: 'pointer',
        bottom: '0',
        right: '0',
        opacity: '0',
        width: width,
        left: left,
        height: height,
        zIndex: zIndex
      };

      return _react2.default.createElement(
        'div',
        { style: { width: '100%' } },
        _react2.default.createElement('input', { onChange: this.onChange, type: 'file', style: imageUploadStyle }),
        this.props.children
      );
    }
  }]);

  return ProfileImage;
}(_react.Component);

ProfileImage.propTypes = {
  types: _react.PropTypes.array,
  style: _react.PropTypes.object,
  children: _react.PropTypes.any
};

exports.default = ProfileImage;

/***/ }),
/* 3198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d6ba6f5dd2cead3d61a98fed45df2c04.svg";

/***/ }),
/* 3199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _contractorProfileCompletenessSplash = __webpack_require__(3200);

var _contractorProfileCompletenessSplash2 = _interopRequireDefault(_contractorProfileCompletenessSplash);

var _supplierProfileCompletenessSplash = __webpack_require__(3201);

var _supplierProfileCompletenessSplash2 = _interopRequireDefault(_supplierProfileCompletenessSplash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileCompleteSplash = function (_Component) {
  _inherits(ProfileCompleteSplash, _Component);

  function ProfileCompleteSplash() {
    _classCallCheck(this, ProfileCompleteSplash);

    return _possibleConstructorReturn(this, (ProfileCompleteSplash.__proto__ || Object.getPrototypeOf(ProfileCompleteSplash)).apply(this, arguments));
  }

  _createClass(ProfileCompleteSplash, [{
    key: 'render',
    value: function render() {
      return this.props.user.user.type === 'Supplier' ? _react2.default.createElement(_supplierProfileCompletenessSplash2.default, this.props) : _react2.default.createElement(_contractorProfileCompletenessSplash2.default, this.props);
    }
  }]);

  return ProfileCompleteSplash;
}(_react.Component);

ProfileCompleteSplash.propTypes = {
  user: _react.PropTypes.object
};

exports.default = ProfileCompleteSplash;

/***/ }),
/* 3200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _search = __webpack_require__(1223);

var _search2 = _interopRequireDefault(_search);

var _sectionHeading = __webpack_require__(732);

var _sectionHeading2 = _interopRequireDefault(_sectionHeading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileCompleteSplash = function (_Component) {
  _inherits(ProfileCompleteSplash, _Component);

  function ProfileCompleteSplash() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProfileCompleteSplash);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProfileCompleteSplash.__proto__ || Object.getPrototypeOf(ProfileCompleteSplash)).call.apply(_ref, [this].concat(args))), _this), _this.goToUrl = function (pageToGoTo) {
      var history = _this.props.history;

      history.push(pageToGoTo);
    }, _this.goToNewSystem = function (pageToGoTo, search) {
      return window.location = '' + "https://app.tourconnect.com" + pageToGoTo + (search ? search + '&' : '?') + 'jwt=' + localStorage.getItem('jwt');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProfileCompleteSplash, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = {
        buttonFontIcon: {
          height: '100%',
          display: 'inline-block',
          verticalAlign: 'middle',
          float: 'left',
          paddingLeft: '12px',
          lineHeight: '36px'
        },
        canvasPaper: {
          width: '100%',
          padding: '20px',
          textAlign: 'center'
        },
        leftDiv: {
          width: '33%',
          display: 'inline-block',
          textAlign: 'center'
        },
        middleDiv: {
          width: '33%',
          display: 'inline-block',
          textAlign: 'center'
        },
        rightDiv: {
          width: '33%',
          display: 'inline-block',
          textAlign: 'center'
        },
        paper: {
          margin: '20px auto',
          height: '245px'
        },
        paperTitle: {
          borderBottom: '1px solid #efefef',
          backgroundColor: '#fbfbfb',
          padding: '15px',
          fontSize: '20px',
          fontWeight: '500'
        },
        paperBody: {
          margin: '20px 20px 24px 40px',
          whiteSpace: 'pre-wrap',
          textAlign: 'center',
          minHeight: '90px'
        }
      };

      return _react2.default.createElement(
        'div',
        { className: 'l-app-content' },
        _react2.default.createElement(
          'div',
          { style: styles.canvasPaper },
          _react2.default.createElement(_sectionHeading2.default, {
            title: "Congratulations, your profile is complete!",
            subtitle: "Here are a few ways we can help you:",
            style: { marginBottom: '96px' }
          }),
          _react2.default.createElement(
            'div',
            { style: styles.leftDiv },
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-person_add', color: '#ff4081', style: { fontSize: '128px' } }),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '10px' } },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  'ADD EXISTING PARTNERS'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: styles.paperBody },
              "Wouldn't it be nice if you had up-to-date contacts for all of your partners? Upload your partners."
            ),
            _react2.default.createElement(_materialUi.RaisedButton, {
              onClick: function onClick() {
                return _this2.goToNewSystem('/partner-management/import');
              },
              label: 'Add Partners',
              style: styles.button,
              primary: true,
              labelStyle: { fontWeight: 'bold' }
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.middleDiv },
            _react2.default.createElement(_search2.default, { color: '#00bcd4', style: { height: '128px', width: '128px' } }),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '10px' } },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  'SEARCH FOR NEW PARTNERS'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: styles.paperBody },
              "Are you looking to find new suppliers to work with or agents to book with you? Start searching now."
            ),
            _react2.default.createElement(_materialUi.RaisedButton, {
              onClick: function onClick() {
                return _this2.goToUrl('/partner-finder/results');
              },
              label: 'Start Searching',
              style: styles.button,
              secondary: true,
              labelStyle: { fontWeight: 'bold' }
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.rightDiv },
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-insert-drive-file', color: 'rgba(255, 183, 0, 0.87)', style: { fontSize: '128px' } }),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '10px' } },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  'RECEIVE SUPPLIER RATES'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: styles.paperBody },
              "If you contract or book directly with your suppliers, go ahead and request their rates using our universal contract format."
            ),
            _react2.default.createElement(_materialUi.RaisedButton, {
              onClick: function onClick() {
                return _this2.goToNewSystem('/partner-management/send-assets', '?open_asset_type=requests');
              },
              label: 'REQUEST RATES',
              style: styles.button,
              backgroundColor: 'rgba(255, 183, 0, 0.87)',
              labelColor: '#ffffff'
            })
          )
        )
      );
    }
  }]);

  return ProfileCompleteSplash;
}(_react.Component);

ProfileCompleteSplash.propTypes = {
  history: _react.PropTypes.object
};

exports.default = ProfileCompleteSplash;

/***/ }),
/* 3201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _search = __webpack_require__(1223);

var _search2 = _interopRequireDefault(_search);

var _sectionHeading = __webpack_require__(732);

var _sectionHeading2 = _interopRequireDefault(_sectionHeading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileCompleteSplash = function (_Component) {
  _inherits(ProfileCompleteSplash, _Component);

  function ProfileCompleteSplash() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProfileCompleteSplash);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProfileCompleteSplash.__proto__ || Object.getPrototypeOf(ProfileCompleteSplash)).call.apply(_ref, [this].concat(args))), _this), _this._goToPage = function (pageToGoTo) {
      var history = _this.props.history;

      history.push(pageToGoTo);
    }, _this.goToNewSystem = function (pageToGoTo, search) {
      return window.location = '' + "https://app.tourconnect.com" + pageToGoTo + (search ? search + '&' : '?') + 'jwt=' + localStorage.getItem('jwt');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProfileCompleteSplash, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var productType = this.props.user.company.productType;
      var styles = {
        buttonFontIcon: {
          height: '100%',
          display: 'inline-block',
          verticalAlign: 'middle',
          float: 'left',
          paddingLeft: '12px',
          lineHeight: '36px'
        },
        canvasPaper: {
          width: '100%',
          padding: '20px',
          textAlign: 'center'
        },
        leftDiv: {
          width: '33%',
          display: 'inline-block',
          textAlign: 'center'
        },
        middleDiv: {
          width: '33%',
          display: 'inline-block',
          textAlign: 'center'
        },
        rightDiv: {
          width: '33%',
          display: 'inline-block',
          textAlign: 'center'
        },
        paper: {
          margin: '20px auto',
          height: '245px'
        },
        paperTitle: {
          borderBottom: '1px solid #efefef',
          backgroundColor: '#fbfbfb',
          padding: '15px',
          fontSize: '20px',
          fontWeight: '500'
        },
        paperBody: {
          margin: '20px 20px 24px 40px',
          whiteSpace: 'pre-wrap',
          textAlign: 'center',
          minHeight: '80px'
        }
      };

      return _react2.default.createElement(
        'div',
        { className: 'l-app-content' },
        _react2.default.createElement(
          'div',
          { style: styles.canvasPaper },
          _react2.default.createElement(_sectionHeading2.default, {
            title: "Congratulations, your profile is complete!",
            subtitle: "Here are a few ways we can help you:",
            style: { marginBottom: '96px' }
          }),
          _react2.default.createElement(
            'div',
            { style: styles.leftDiv },
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-person_add', color: '#ff4081', style: { fontSize: '128px' } }),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '10px' } },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  'ADD EXISTING PARTNERS'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: styles.paperBody },
              "Wouldn't it be nice if you had up-to-date contacts for all of your partners? Upload your partners."
            ),
            _react2.default.createElement(_materialUi.RaisedButton, {
              onClick: function onClick() {
                return _this2.goToNewSystem('/partner-management/import');
              },
              label: 'Add Partners',
              style: styles.button,
              primary: true,
              labelStyle: { fontWeight: 'bold' }
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.middleDiv },
            _react2.default.createElement(_search2.default, { color: '#00bcd4', style: { height: '128px', width: '128px' } }),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '10px' } },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  'SEARCH FOR NEW PARTNERS'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: styles.paperBody },
              'Want to find new agents to sell your ' + (productType === 'Accommodation' ? 'rooms' : 'products') + '? Start searching now.'
            ),
            _react2.default.createElement(_materialUi.RaisedButton, {
              onClick: function onClick() {
                return _this2._goToPage('/partner-finder/results');
              },
              label: 'Start Searching',
              labelStyle: { fontWeight: 'bold' },
              secondary: true,
              style: styles.button
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.rightDiv },
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-insert-drive-file', color: 'rgba(255, 183, 0, 0.87)', style: { fontSize: '128px' } }),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '10px' } },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  'SEND YOUR RATES'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: styles.paperBody },
              "Your agents can't sell your products if they don't have your rates. Create a rate template and send your rates now."
            ),
            _react2.default.createElement(_materialUi.RaisedButton, {
              onClick: function onClick() {
                return _this2._goToPage('/contracting/create-template-draft');
              },
              label: 'CREATE RATE TEMPLATE',
              style: styles.button,
              backgroundColor: 'rgba(255, 183, 0, 0.87)',
              labelColor: '#ffffff',
              labelStyle: { fontWeight: 'bold' }
            })
          )
        )
      );
    }
  }]);

  return ProfileCompleteSplash;
}(_react.Component);

ProfileCompleteSplash.propTypes = {
  user: _react.PropTypes.object,
  history: _react.PropTypes.object
};

exports.default = ProfileCompleteSplash;

/***/ }),
/* 3202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__(6);

var _partnerFinderActions = __webpack_require__(1125);

var _upgradeActions = __webpack_require__(611);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContainerPartnerFinder = function (_Component) {
  _inherits(ContainerPartnerFinder, _Component);

  function ContainerPartnerFinder(props) {
    _classCallCheck(this, ContainerPartnerFinder);

    var _this = _possibleConstructorReturn(this, (ContainerPartnerFinder.__proto__ || Object.getPrototypeOf(ContainerPartnerFinder)).call(this, props));

    _this.search = function () {
      var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var pagination = arguments[1];
      var noCount = arguments[2];

      // console.log('search !', { searchParams });
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          user = _this$props.user;

      searchParams.destinationsSold = searchParams.destinationsSold || [];
      var defaultCountry = _this.props.user.company.address.country || 'Australia';
      searchParams.companyType = searchParams.companyType || (user.user.type === 'Contractor' ? 'Supplier' : 'Contractor');
      if (searchParams.companyType === 'Supplier') {
        searchParams.country = searchParams.country || defaultCountry;
        searchParams.buyerClientsFrom = '';
        searchParams.destinationsSold = [];
      } else if (searchParams.companyType === 'Contractor') {
        searchParams.country = searchParams.country || '';
        searchParams.buyerClientsFrom = searchParams.buyerClientsFrom || '';
        searchParams.destinationsSold = [searchParams.destinationsSold[0] || defaultCountry];
      } else if (searchParams.companyType === 'TechAndServices') {
        searchParams.country = '';
        searchParams.destinationsSold = [];
        searchParams.buyerClientsFrom = '';
      } else {
        searchParams.destinationsSold = [searchParams.country || defaultCountry];
        searchParams.country = searchParams.country || defaultCountry;
        searchParams.buyerClientsFrom = '';
      }
      searchParams.isForPremiumUser = user.billingPlan === 'connected' || user.billingPlan === 'unlimited';
      searchParams.page = undefined;
      // no aditional country filter for non-buyer types
      if (searchParams.companyType !== 'Contractor') {
        searchParams.buyerClientsFrom = '';
        searchParams.buyerLocatedIn = '';
      }
      dispatch((0, _partnerFinderActions.search)(searchParams, pagination, noCount));
    };

    _this.showHelpBox = function (existingBoxes, boxName) {
      if (!existingBoxes) return true;
      return existingBoxes.findIndex(function (box) {
        return box.name === boxName;
      }) < 0;
    };

    _this.loadMore = function (page) {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          partnerFinder = _this$props2.partnerFinder;

      dispatch((0, _partnerFinderActions.search)(_extends({}, partnerFinder.searchParams, { page: page }), true, true));
    };

    _this.searchWithInput = (0, _lodash2.default)(function (input) {
      var partnerFinder = _this.props.partnerFinder;

      var params = partnerFinder.searchParams;
      params.companyOrLocationName = input;
      _this.search(params);
    }, 400);

    _this.sendInvitation = function (customMsg, receiverInfo) {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          triggerSnackBarMessage = _this$props3.triggerSnackBarMessage;

      dispatch((0, _partnerFinderActions.sendInvitation)(customMsg, receiverInfo)).then(function () {
        triggerSnackBarMessage({ message: 'Invitation Sent' });
      }).catch(function () {
        triggerSnackBarMessage({ message: 'Sending Invitation Failed' });
      });
    };

    _this.resendConnection = function (connectionId) {
      var _this$props4 = _this.props,
          dispatch = _this$props4.dispatch,
          triggerSnackBarMessage = _this$props4.triggerSnackBarMessage;

      dispatch((0, _partnerFinderActions.resendInvitation)(connectionId)).then(function () {
        triggerSnackBarMessage({ message: 'Invitation Sent' });
      }).catch(function () {
        triggerSnackBarMessage({ message: 'Resending Invitation Failed' });
        // dispatch(undoConnectionChange());
      });
    };

    _this.fakeResendInvitation = function (connectionId) {
      var _this$props5 = _this.props,
          dispatch = _this$props5.dispatch,
          triggerSnackBarMessage = _this$props5.triggerSnackBarMessage;

      dispatch((0, _partnerFinderActions.fakeResendInvitation)(connectionId)).then(function () {
        triggerSnackBarMessage({ message: 'Invitation Sent' });
      }).catch(function () {
        triggerSnackBarMessage({ message: 'Resending Invitation Failed' });
      });
    };

    _this.acceptConnection = function (connectionId) {
      var _this$props6 = _this.props,
          dispatch = _this$props6.dispatch,
          triggerSnackBarMessage = _this$props6.triggerSnackBarMessage;

      dispatch((0, _partnerFinderActions.acceptConnection)(connectionId)).then(function () {
        triggerSnackBarMessage({ message: 'Invitation Accepted' });
      }).catch(function () {
        triggerSnackBarMessage({ message: 'Accepting Connection Failed' });
        // dispatch(undoConnectionChange());
      });
    };

    _this.ignoreConnection = function (connectionId) {
      var _this$props7 = _this.props,
          dispatch = _this$props7.dispatch,
          triggerSnackBarMessage = _this$props7.triggerSnackBarMessage;

      dispatch((0, _partnerFinderActions.ignoreConnection)(connectionId)).then(function () {
        triggerSnackBarMessage({ message: 'Connection Request Ignored' });
      }).catch(function () {
        triggerSnackBarMessage({ message: 'Ignoring Connection Failed' });
      });
    };

    _this.openUpgrade = function (clickedCompany) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _upgradeActions.openUpgradeFrom)('pfListConnectBtn', { clickedCompany: clickedCompany }));
    };

    _this.state = {};
    return _this;
  }

  _createClass(ContainerPartnerFinder, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      var extraProps = _extends({
        search: this.search,
        loadMore: this.loadMore,
        searchWithInput: this.searchWithInput,
        sendInvitation: this.sendInvitation,
        resendConnection: this.resendConnection,
        acceptConnection: this.acceptConnection,
        ignoreConnection: this.ignoreConnection,
        fakeResendInvitation: this.fakeResendInvitation,
        router: this.context.router,
        openUpgrade: this.openUpgrade
      }, props);

      return _react2.default.createElement(
        'div',
        null,
        children ? (0, _react.cloneElement)(children, extraProps) : undefined
      );
    }
  }]);

  return ContainerPartnerFinder;
}(_react.Component);

ContainerPartnerFinder.propTypes = {
  user: _react.PropTypes.object,
  partnerFinder: _react.PropTypes.object,
  triggerSnackBarMessage: _react.PropTypes.func,
  dispatch: _react.PropTypes.func,
  children: _react.PropTypes.object
};

var mapStateToProps = function mapStateToProps(_ref) {
  var partnerFinder = _ref.partnerFinder;
  return {
    partnerFinder: partnerFinder.toJS()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closePopover: function closePopover() {
      return dispatch((0, _partnerFinderActions.closePopover)());
    },
    openPopover: function openPopover(payload) {
      return dispatch((0, _partnerFinderActions.openPopover)(payload));
    },
    updateCustomizedMsg: function updateCustomizedMsg(payload) {
      return dispatch((0, _partnerFinderActions.updateCustomizedMsg)(payload));
    }
  };
};

ContainerPartnerFinder.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContainerPartnerFinder);

/***/ }),
/* 3203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _materialUi = __webpack_require__(3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionsPartnerFinder = function (_Component) {
  _inherits(OptionsPartnerFinder, _Component);

  function OptionsPartnerFinder() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OptionsPartnerFinder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OptionsPartnerFinder.__proto__ || Object.getPrototypeOf(OptionsPartnerFinder)).call.apply(_ref, [this].concat(args))), _this), _this._startSearchingClicked = function (e) {
      var history = _this.props.history;

      e.preventDefault();
      history.push('/partner-finder/results');
    }, _this._addConnectionsClicked = function (e) {
      var history = _this.props.history;

      e.preventDefault();
      history.push('/connections/add-connections');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OptionsPartnerFinder, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          connectionsStats = _props.connectionsStats,
          history = _props.history;

      if (!connectionsStats.shouldShow) {
        window.dataLayer.push({
          event: 'TRACK_EVENT',
          ev: {
            category: 'Connections',
            action: 'Clicks from AppBar'
          }
        });
        history.push('/connections');
        return false;
      }
      var styles = {
        buttonFontIcon: {
          height: '100%',
          display: 'inline-block',
          verticalAlign: 'middle',
          float: 'left',
          paddingLeft: '12px',
          lineHeight: '36px'
        },
        canvasPaper: {
          width: '100%',
          margin: '32px auto',
          padding: '20px',
          textAlign: 'center'
        },
        leftDiv: {
          width: '40%',
          display: 'inline-block',
          marginLeft: '5%',
          float: 'left',
          textAlign: 'center'
        },
        rightDiv: {
          width: '40%',
          display: 'inline-block',
          marginLeft: '5%',
          textAlign: 'center'
        },
        button: {
          marginTop: '10px',
          width: '205px'
        },
        paper: {
          margin: '20px auto',
          height: '245px'
        },
        paperTitle: {
          borderBottom: '1px solid #efefef',
          backgroundColor: '#fbfbfb',
          padding: '15px',
          fontSize: '20px',
          fontWeight: '500'
        },
        paperBody: { margin: '20px 20px 0 40px', height: '105px', textAlign: 'left' }
      };

      var _ref2 = function () {
        return {
          findNewPartnersBodyText: 'Search our growing network for the perfect partnership.',
          findNewPartnersButton: _react2.default.createElement(_materialUi.RaisedButton, { onClick: _this2._startSearchingClicked, label: 'start searching', secondary: true, style: styles.button })
        };
      }(),
          findNewPartnersBodyText = _ref2.findNewPartnersBodyText,
          findNewPartnersButton = _ref2.findNewPartnersButton;

      return _react2.default.createElement(
        'div',
        { className: 'l-app-content' },
        _react2.default.createElement(
          'div',
          { style: styles.canvasPaper },
          _react2.default.createElement(
            'div',
            { style: styles.leftDiv },
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-person_add', color: 'rgba(0, 0, 0, 0.54)', style: { fontSize: '64px' } }),
            _react2.default.createElement(
              _materialUi.Paper,
              { style: styles.paper },
              _react2.default.createElement(
                'div',
                { style: styles.paperTitle },
                "Add Existing Partners"
              ),
              _react2.default.createElement(
                'div',
                { style: styles.paperBody },
                "Manage all of your travel trade partners in one place.",
                _react2.default.createElement('br', null),
                _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-add', color: '#00bcd4', style: { top: '2px', fontSize: '16px', marginRight: '10px', marginTop: '10px' } }),
                "Get Up-to-Date Contacts",
                _react2.default.createElement('br', null),
                _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-add', color: '#00bcd4', style: { top: '2px', fontSize: '16px', marginRight: '10px' } }),
                "Exchange Rates",
                _react2.default.createElement('br', null),
                _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-add', color: '#00bcd4', style: { top: '2px', fontSize: '16px', marginRight: '10px' } }),
                "Message with Partners (",
                _react2.default.createElement(
                  'i',
                  null,
                  "coming soon"
                ),
                ")"
              ),
              _react2.default.createElement(
                _materialUi.RaisedButton,
                { onClick: this._addConnectionsClicked, label: 'Add Connections', style: styles.button, primary: true },
                _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-add', style: styles.buttonFontIcon, color: 'white' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: styles.rightDiv },
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-search', color: 'rgba(0, 0, 0, 0.54)', style: { fontSize: '64px' } }),
            _react2.default.createElement(
              _materialUi.Paper,
              { style: styles.paper },
              _react2.default.createElement(
                'div',
                { style: styles.paperTitle },
                "Find New Partners"
              ),
              _react2.default.createElement(
                'div',
                { style: styles.paperBody },
                findNewPartnersBodyText
              ),
              findNewPartnersButton
            )
          )
        )
      );
    }
  }]);

  return OptionsPartnerFinder;
}(_react.Component);

OptionsPartnerFinder.propTypes = {
  history: _react.PropTypes.object,
  user: _react.PropTypes.object,
  connectionsStats: _react.PropTypes.object
};

exports.default = OptionsPartnerFinder;

/***/ }),
/* 3204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leftNavPartnerFinder = __webpack_require__(3205);

var _leftNavPartnerFinder2 = _interopRequireDefault(_leftNavPartnerFinder);

var _listPartnerFinder = __webpack_require__(3212);

var _listPartnerFinder2 = _interopRequireDefault(_listPartnerFinder);

var _sendCustomMsg = __webpack_require__(1951);

var _sendCustomMsg2 = _interopRequireDefault(_sendCustomMsg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchResults = function SearchResults(props) {
  return _react2.default.createElement(
    'div',
    { className: 'l-app-content l-left-nav-with-content', style: { paddingTop: '72px' } },
    _react2.default.createElement(_leftNavPartnerFinder2.default, _extends({ className: 'integration-left-nav l-left-nav' }, props)),
    _react2.default.createElement(_listPartnerFinder2.default, props),
    _react2.default.createElement(_sendCustomMsg2.default, {
      sendInvitation: props.sendInvitation,
      onRequestClose: props.closePopover,
      updateCustomizedMsg: props.updateCustomizedMsg
    })
  );
};

SearchResults.propTypes = {
  sendInvitation: _react.PropTypes.func,
  closePopover: _react.PropTypes.func,
  updateCustomizedMsg: _react.PropTypes.func
};

exports.default = SearchResults;

/***/ }),
/* 3205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _searchWidgetPartnerFinder = __webpack_require__(3206);

var _searchWidgetPartnerFinder2 = _interopRequireDefault(_searchWidgetPartnerFinder);

var _selectFields = __webpack_require__(141);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var leftNav = function (_Component) {
  _inherits(leftNav, _Component);

  function leftNav(props) {
    _classCallCheck(this, leftNav);

    var _this = _possibleConstructorReturn(this, (leftNav.__proto__ || Object.getPrototypeOf(leftNav)).call(this, props));

    _this.state = {
      filters: {
        Supplier: [{
          filterName: 'Product Types',
          filterList: ['Accommodation', 'Non-Accommodation']
        }, {
          hide: true,
          filterName: 'Property Types',
          filterList: _selectFields.accomCompanyTypesFields
        }, {
          hide: true,
          filterName: 'Business Types',
          filterList: _selectFields.nonAccomCompanyTypesFields
        }, {
          filterName: 'Segments',
          filterList: ['Adventure', 'Business', 'Cultural and Heritage', 'Eco-Tourism', 'Family', 'Group Travel', 'Health and Wellness', 'Luxury', 'Senior Travel', 'Sport Tourism', 'Student Travel']
        }],
        Contractor: [{
          filterName: 'Business Types',
          filterList: _selectFields.basicBuyerTypes
        }, {
          filterName: 'Segments',
          filterList: ['Adventure', 'Business', 'Cultural and Heritage', 'Eco-Tourism', 'Family', 'Group Travel', 'Health and Wellness', 'Luxury', 'Senior Travel', 'Sport Tourism', 'Student Travel']
        }],
        DMOs: [{
          filterName: 'Business Types',
          filterList: _selectFields.DMOtypes
        }],
        Other: [{
          filterName: 'Business Types',
          filterList: _selectFields.otherBuyersTypes
        }]
      }
    };
    return _this;
  }

  _createClass(leftNav, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.props.className, style: { overflowX: 'visible', overflowY: 'scroll' } },
        _react2.default.createElement(
          'div',
          { className: 'integration-left-nav-inner' },
          _react2.default.createElement(
            'div',
            { className: 'connections-widget' },
            _react2.default.createElement(_searchWidgetPartnerFinder2.default, _extends({}, this.props, { filters: this.state.filters, position: 'leftNav' }))
          )
        )
      );
    }
  }]);

  return leftNav;
}(_react.Component);

leftNav.propTypes = {
  className: _react.PropTypes.string
};

exports.default = leftNav;

/***/ }),
/* 3206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _materialUi = __webpack_require__(3);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _selectFields = __webpack_require__(141);

var _filterPartnerFinder = __webpack_require__(3207);

var _filterPartnerFinder2 = _interopRequireDefault(_filterPartnerFinder);

var _address = __webpack_require__(1527);

var _searchForCompanyType = __webpack_require__(3208);

var _searchForCompanyType2 = _interopRequireDefault(_searchForCompanyType);

var _searchLocation = __webpack_require__(3210);

var _searchLocation2 = _interopRequireDefault(_searchLocation);

var _searchCheckbox = __webpack_require__(3211);

var _searchCheckbox2 = _interopRequireDefault(_searchCheckbox);

var _tourconnectLogoGlobe = __webpack_require__(231);

var _tourconnectLogoGlobe2 = _interopRequireDefault(_tourconnectLogoGlobe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchWidget = function (_Component) {
  _inherits(SearchWidget, _Component);

  function SearchWidget(props) {
    _classCallCheck(this, SearchWidget);

    var _this = _possibleConstructorReturn(this, (SearchWidget.__proto__ || Object.getPrototypeOf(SearchWidget)).call(this, props));

    _initialiseProps.call(_this);

    var searchParams = {
      tabIndex: 0,
      country: undefined,
      city: undefined,
      latitude: undefined,
      longitude: undefined,
      companyType: undefined,
      segments: [],
      businessTypes: [], // only for nonaccom suppliers and contractors and others
      propertyTypes: [], // only for accom supliers
      destinationsSold: [],
      productType: [],
      page: undefined,
      companyOrLocationName: undefined,
      isForPremiumUser: false,
      buyerClientsFrom: ''
    };
    _this.state = _this.populateState(props, searchParams);
    return _this;
  }

  _createClass(SearchWidget, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState(this.populateState(props, this.state.searchParams));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          searchParams = _state.searchParams,
          selectedCompanyType = _state.searchParams.companyType;
      var css = this.props.classes;

      var stylesLeftNav = {
        earth: { display: 'none' },
        selectField: { width: '90%', marginLeft: '15px' },
        list: { textAlign: 'left', display: 'block' },
        listItem: {},
        primaryText: { fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
          fontSize: '12px', color: '#000', textTransform: 'uppercase', position: 'relative', top: '10px' },
        nestedPrimaryText: { fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
          fontSize: '12px', marginLeft: '-20px', color: 'rgba(0, 0, 0, 0.54)' },
        nestedListItem: { marginLeft: '0px', paddingBottom: '0px' },
        secondaryText: { fontSize: '12px' },
        labelMenuStyle: { fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif", fontSize: '14px' },
        infoIcon: { width: '24px', height: '24px', fontSize: '16px', padding: '0', marginTop: '10px', marginRight: '5px', float: 'right' },
        checkbox: {}
      };

      var _ref = function () {
        return {
          styles: stylesLeftNav,
          classes: {
            selectFieldContainer: 'select-field-container-left-nav',
            labelText: 'label-text-left-nav'
          }
        };
      }(),
          styles = _ref.styles,
          classes = _ref.classes;

      var citySearchText = _react2.default.createElement(
        'div',
        { style: { marginTop: '-25px' } },
        _react2.default.createElement(_materialUi.TextField, {
          style: {
            fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
            fontSize: '14px',
            textAlign: 'left',
            width: '90%',
            display: 'block',
            margin: '0 0 10px 15px'
          },
          ref: 'city',
          floatingLabelText: 'City / Region / Province',
          onKeyUp: this.debounceCitySearch,
          defaultValue: searchParams.city,
          hintText: 'City / Region / Province'
        })
      );
      var contractorFilters = void 0;
      var supplierFilters = void 0;
      var dmoFilters = void 0;
      var otherFilters = void 0;
      var filters = void 0;

      if (this.state.filters) {
        var genericFilter = function genericFilter(index, filterNameCamelCase, filter) {
          return _react2.default.createElement(_filterPartnerFinder2.default, _extends({}, _this2.props, {
            key: index,
            filterNameCamelCase: filterNameCamelCase,
            filterItemsSelected: searchParams[filterNameCamelCase] || [],
            filterStyles: styles,
            filterName: filter.filterName,
            filterList: filter.filterList,
            iconClassName: filter.filterIcon,
            onCheckFunction: _this2.itemsChecked
          }));
        };
        contractorFilters = this.state.filters.Contractor.map(function (filter, index) {
          var filterNameCamelCase = _this2._getCamelCase(filter.filterName);
          return genericFilter(index, filterNameCamelCase, filter);
        });
        dmoFilters = this.state.filters.DMOs.map(function (filter, index) {
          var filterNameCamelCase = _this2._getCamelCase(filter.filterName);
          return genericFilter(index, filterNameCamelCase, filter);
        });
        otherFilters = this.state.filters.Other.map(function (filter, index) {
          var filterNameCamelCase = _this2._getCamelCase(filter.filterName);
          return genericFilter(index, filterNameCamelCase, filter);
        });
        supplierFilters = this.state.filters.Supplier.map(function (filter, index) {
          var filterNameCamelCase = _this2._getCamelCase(filter.filterName);
          var shouldReallyHide = filter.hide && !(searchParams[filterNameCamelCase] && searchParams[filterNameCamelCase].length);
          if (!shouldReallyHide) return genericFilter(index, filterNameCamelCase, filter);
        });
      }

      if (selectedCompanyType === 'Supplier') filters = supplierFilters;else if (selectedCompanyType === 'DMOs') filters = dmoFilters;else if (selectedCompanyType === 'TechAndServices') filters = otherFilters;else filters = contractorFilters;

      return _react2.default.createElement(
        'div',
        { style: { width: '100%' } },
        _react2.default.createElement(_searchForCompanyType2.default, {
          companyType: selectedCompanyType,
          onChange: this._handleRadioOrTabsChange
        }),
        _react2.default.createElement(_materialUi.Divider, null),
        _react2.default.createElement(
          'div',
          { style: styles.tab },
          selectedCompanyType === 'TechAndServices' ? undefined : _react2.default.createElement(_searchLocation2.default, {
            companyType: selectedCompanyType,
            searcherCompanyType: this.props.user.user.type,
            onChange: function onChange(country) {
              return _this2._handleSearchChange({
                field: selectedCompanyType === 'Contractor' ? 'destinationsSold' : 'country',
                value: selectedCompanyType === 'Contractor' ? [country] : country
              });
            },
            value: {
              Supplier: (0, _ramda.propOr)('', 'country', searchParams),
              Contractor: (0, _ramda.pathOr)('', ['destinationsSold', 0], searchParams),
              DMOs: (0, _ramda.propOr)('', 'country', searchParams)
            }[selectedCompanyType] || ''
          }),
          selectedCompanyType === 'TechAndServices' || selectedCompanyType === 'Contractor' ? undefined : citySearchText,
          selectedCompanyType === 'Contractor' ? _react2.default.createElement(
            'div',
            { className: css.section },
            _react2.default.createElement(_materialUi.Divider, null),
            _react2.default.createElement(
              'div',
              { className: css.upperCaseTitle },
              'Traveler Origin'
            ),
            _react2.default.createElement(
              'div',
              { className: css.questionTitle },
              'Clients are from:'
            ),
            _react2.default.createElement(_reactSelect2.default, {
              className: css.countrySelect,
              onChange: function onChange(_ref2) {
                var val = _ref2.value;
                return _this2._handleSearchChange({ field: 'buyerClientsFrom', value: val });
              },
              options: [{ value: '', label: 'Anywhere' }].concat(_toConsumableArray(_selectFields.countries)),
              value: searchParams.buyerClientsFrom,
              placeholder: 'Anywhere',
              clearable: false,
              scrollMenuIntoView: false
            })
          ) : undefined,
          selectedCompanyType === 'Contractor' ? _react2.default.createElement(
            'div',
            { className: css.section },
            _react2.default.createElement(_materialUi.Divider, null),
            _react2.default.createElement(
              'div',
              { className: css.upperCaseTitle },
              'Buyer / Agent Location'
            ),
            _react2.default.createElement(
              'div',
              { className: css.questionTitle },
              'Located in:'
            ),
            _react2.default.createElement(_reactSelect2.default, {
              className: css.countrySelect,
              onChange: function onChange(_ref3) {
                var val = _ref3.value;
                return _this2._handleSearchChange({ field: 'country', value: val });
              },
              options: [{ value: '', label: 'Anywhere' }].concat(_toConsumableArray(_selectFields.countries)),
              value: searchParams.country,
              placeholder: 'Anywhere',
              clearable: false,
              scrollMenuIntoView: false
            })
          ) : undefined,
          _react2.default.createElement(_materialUi.Divider, null),
          _react2.default.createElement(
            'div',
            { className: 'tc-filtered-content', style: { marginTop: '10px' } },
            _react2.default.createElement(
              'div',
              {
                'aria-label': 'TourConnect Verified status is reserved for legitimate tourism organisations that have active B2B relationships.',
                className: 'hint--top hint--medium',
                style: { width: '100%' }
              },
              _react2.default.createElement(_searchCheckbox2.default, { style: styles.checkbox,
                iconEl: _react2.default.createElement('img', {
                  src: _tourconnectLogoGlobe2.default,
                  style: { height: '14px', margin: '12px 15px 0px 17px' }
                }),
                label: 'TourConnect Verified',
                toggled: Boolean(searchParams.tourConnectVerified),
                onToggle: this.handleOnToggle('tourConnectVerified')
              })
            ),
            _react2.default.createElement(_searchCheckbox2.default, { style: styles.checkbox, icon: 'tc-icon-verified_user', iconColor: '#97E397', label: 'Industry Verified', toggled: Boolean(searchParams.industryVerified), onToggle: this.handleOnToggle('industryVerified') }),
            _react2.default.createElement(_searchCheckbox2.default, { style: styles.checkbox, icon: 'tc-icon-photo', iconColor: '#0080ff', label: 'Marketing Materials', labelSize: '13px', toggled: Boolean(searchParams.hasMM), onToggle: this.handleOnToggle('hasMM') }),
            _react2.default.createElement(_searchCheckbox2.default, { style: styles.checkbox, icon: 'tc-icon-update', iconColor: '#7F00FF', label: 'Quick Responder', toggled: Boolean(searchParams.quickResponder), onToggle: this.handleOnToggle('quickResponder') }),
            _react2.default.createElement(_searchCheckbox2.default, { style: styles.checkbox, icon: 'tc-icon-user-check', iconColor: 'rgba(0, 0, 0, 0.54)', label: 'Exclude Connected', toggled: Boolean(searchParams.excludeConnected), onToggle: this.handleOnToggle('excludeConnected') }),
            selectedCompanyType === 'Supplier' && _react2.default.createElement(_searchCheckbox2.default, { style: styles.checkbox, icon: 'tc-icon-description', iconColor: '#ff7f00', label: 'Rates Loaded', toggled: Boolean(searchParams.ratesLoaded), onToggle: this.handleOnToggle('ratesLoaded') })
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(_materialUi.Divider, null),
          filters
        )
      );
    }
  }]);

  return SearchWidget;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.populateState = function (props, searchParams) {
    var originalSearchParams = {};
    if (Object.keys(props.partnerFinder.searchParams).length) {
      originalSearchParams = _extends({}, searchParams, props.partnerFinder.searchParams);
    } else {
      var oppositeTypeOfSearcher = props.user.user.type === 'Contractor' ? 'Supplier' : 'Contractor';
      var companyType = searchParams.companyType || oppositeTypeOfSearcher;
      originalSearchParams.companyType = companyType;
      if (companyType === 'Contractor') {
        originalSearchParams.tabIndex = 0;
      } else if (companyType === 'DMOs') {
        originalSearchParams.tabIndex = 0;
      } else if (companyType === 'TechAndServices') {
        originalSearchParams.tabIndex = 0;
      } else {
        originalSearchParams.tabIndex = 1;
      }
    }
    var state = _this3.hideOrShowExtraforProductType(searchParams.productType, props.filters, originalSearchParams);
    state.position = props.position;
    return state;
  };

  this._getCamelCase = (0, _ramda.cond)([[(0, _ramda.equals)('Business Types'), (0, _ramda.always)('businessTypes')], [(0, _ramda.equals)('Product Types'), (0, _ramda.always)('productType')], [(0, _ramda.equals)('Segments'), (0, _ramda.always)('segments')], [(0, _ramda.equals)('Property Types'), (0, _ramda.always)('propertyTypes')]]);
  this.debounceCitySearch = (0, _lodash2.default)(function () {
    return _this3._getGeoLocationThenSearch();
  }, 500);

  this._handleRadioOrTabsChange = function (type) {
    var originalSearchParams = (0, _ramda.merge)(_this3.state.searchParams, {
      companyType: type,
      businessTypes: [],
      productType: [],
      propertyTypes: []
    });

    var _hideOrShowExtraforPr = _this3.hideOrShowExtraforProductType(_this3.state.searchParams.productType, _this3.state.filters, originalSearchParams),
        filters = _hideOrShowExtraforPr.filters,
        searchParams = _hideOrShowExtraforPr.searchParams;

    if (type === 'Contractor') {
      searchParams.country = '';
    } else {
      searchParams.buyerClientsFrom = '';
    }
    if (type !== 'Supplier') {
      // querys not included on other types of companies
      searchParams.ratesLoaded = 0;
      searchParams.city = '';
    }
    _this3.setState({ filters: filters, searchParams: searchParams }, function () {
      _this3._getGeoLocationThenSearch();
    });
  };

  this._handleSearchChange = function (_ref4) {
    var field = _ref4.field,
        value = _ref4.value;

    _this3.setState({ searchParams: _extends({}, _this3.state.searchParams, _defineProperty({}, field, value)) }, function () {
      _this3._getGeoLocationThenSearch();
    });
  };

  this._getGeoLocationThenSearch = function (initialClick) {
    var _state2 = _this3.state,
        _state2$searchParams = _state2.searchParams,
        countryState = _state2$searchParams.country,
        isForMap = _state2$searchParams.isForMap,
        companyType = _state2$searchParams.companyType,
        cityState = _state2$searchParams.city,
        searchParams = _state2.searchParams;
    var _props = _this3.props,
        search = _props.search,
        push = _props.router.push;

    if (initialClick) {
      window.dataLayer.push({
        event: 'TRACK_EVENT',
        ev: {
          category: 'PartnerFinder',
          action: 'Initial Search Click'
        }
      });
    }
    var city = _this3.refs.city ? _this3.refs.city.getValue() : cityState;
    var country = companyType === 'TechAndServices' ? '' : countryState;

    (0, _address.getGeoLocation)({ city: city, country: country }, function (address, geometry) {
      var _ref5 = function () {
        if ((city || country) && isForMap) return address.coordinates;
        return [undefined, undefined];
      }(),
          _ref6 = _slicedToArray(_ref5, 2),
          longitude = _ref6[0],
          latitude = _ref6[1];

      var newSearchParams = _extends({}, searchParams, {
        city: city,
        longitude: longitude,
        latitude: latitude,
        bounds: geometry.viewport
      });
      _this3.setState({
        searchParams: newSearchParams
      }, function () {
        search(_this3.state.searchParams);
        push('/partner-finder/results');
      });
    });
  };

  this.itemsChecked = function (filterName, itemsChecked) {
    var originalSearchParams = _this3.state.searchParams;
    var originalFilters = _this3.state.filters;
    var filters = originalFilters;
    var searchParams = _extends({}, originalSearchParams);
    if (filterName === 'productType') {
      var obj = _this3.hideOrShowExtraforProductType(itemsChecked, originalFilters, originalSearchParams);
      filters = obj.filters;
      searchParams = obj.searchParams;
    }
    if (filterName === 'country') {
      if (_this3.state.searchParams.companyType === 'Supplier') {
        searchParams.country = itemsChecked;
        searchParams.destinationsSold = [];
      } else if (_this3.state.searchParams.companyType === 'TechAndServices') {
        searchParams.country = '';
      } else {
        searchParams.country = '';
        searchParams.destinationsSold = [itemsChecked];
      }
    }
    searchParams[filterName] = itemsChecked;
    _this3.setState({
      filters: filters,
      searchParams: searchParams
    }, function () {
      _this3._getGeoLocationThenSearch();
    });
  };

  this.hideOrShowExtraforProductType = function (productType, oldFilters, searchParams) {
    var filters = (0, _ramda.identity)(oldFilters);
    filters.Supplier[1].hide = productType ? productType.indexOf('Accommodation') === -1 || productType.length === 2 : true;
    filters.Supplier[2].hide = productType ? productType.indexOf('Non-Accommodation') === -1 || productType.length === 2 : true;
    searchParams.propertyTypes = filters.Supplier[1].hide ? [] : searchParams.propertyTypes;
    if (searchParams.companyType === 'Non-Accommodation') {
      searchParams.businessTypes = filters.Supplier[2].hide ? [] : searchParams.businessTypes;
    }
    return {
      filters: filters,
      searchParams: searchParams
    };
  };

  this.handleOnToggle = function (toggleType) {
    return function () {
      var searchParams = _this3.state.searchParams;

      searchParams[toggleType] = searchParams[toggleType] ? 0 : 1;
      _this3.setState({ searchParams: searchParams }, function () {
        return _this3._getGeoLocationThenSearch();
      });
    };
  };
};

SearchWidget.propTypes = {
  classes: _react.PropTypes.object,
  context: _react.PropTypes.object,
  filters: _react.PropTypes.object,
  partnerFinder: _react.PropTypes.object,
  position: _react.PropTypes.string,
  router: _react.PropTypes.object,
  search: _react.PropTypes.func,
  searchParams: _react.PropTypes.object,
  user: _react.PropTypes.object
};

exports.default = (0, _reactJss2.default)({
  section: {
    margin: '10px 0 10px 0'
  },
  questionTitle: {
    margin: '5px 0 0 10px',
    color: 'black'
  },
  upperCaseTitle: {
    color: '#000',
    fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
    fontSize: '12px',
    fontWeight: '600',
    margin: '10px 0 0 15px',
    position: 'relative',
    textTransform: 'uppercase'
  },
  countrySelect: {
    margin: '5px 0 15px 15px',
    width: '90%',
    '& div': {
      borderLeft: 'none !important',
      borderRight: 'none !important',
      borderTop: 'none !important'
    }
  }
})(SearchWidget);

/***/ }),
/* 3207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var Filter = function (_Component) {
  _inherits(Filter, _Component);

  function Filter(props) {
    _classCallCheck(this, Filter);

    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

    _this.handleOnCheck = function (itemChecked) {
      var filterItemsSelected = _this.props.filterItemsSelected;
      if (_this.refs[itemChecked].isChecked()) {
        filterItemsSelected.push(itemChecked);
      } else {
        if (filterItemsSelected.indexOf(itemChecked) !== -1) {
          filterItemsSelected.splice(filterItemsSelected.indexOf(itemChecked), 1);
        } else {
          filterItemsSelected.push(itemChecked);
        }
      }
      _this.props.onCheckFunction(_this.props.filterNameCamelCase, filterItemsSelected);
    };

    _this.state = {
      seeMoreExpanded: false
    };
    return _this;
  }

  _createClass(Filter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = this.props.filterStyles;

      var numberChecked = function numberChecked() {
        return _react2.default.createElement(
          'span',
          { style: { marginRight: '15px' } },
          (0, _ramda.path)(['filterItemsSelected', 'length'], _this2.props),
          ' Selected'
        );
      };

      var seeMoreSeeLessExpander = function seeMoreSeeLessExpander(label) {
        return _react2.default.createElement(
          'div',
          { style: { textAlign: 'center', marginLeft: '-20px' } },
          _react2.default.createElement(_materialUi.FlatButton, {
            label: label,
            labelStyle: { fontWeight: '600' },
            secondary: true,
            onTouchTap: function onTouchTap() {
              return _this2.setState({ seeMoreExpanded: !_this2.state.seeMoreExpanded });
            }
          })
        );
      };

      var nestedCheckboxes = function nestedCheckboxes(item, i) {
        return _react2.default.createElement(_materialUi.Checkbox, {
          key: i,
          style: styles.checkbox,
          defaultChecked: _this2.props.filterItemsSelected.indexOf(item) === -1 ? false : true,
          ref: item,
          value: item,
          onCheck: _this2.handleOnCheck.bind(_this2, item),
          label: item
        });
      };

      return _react2.default.createElement(
        'div',
        { style: { clear: 'both', paddingTop: this.props.filterName === 'Segments' && (0, _ramda.pathOr)(false, ['partnerFinder', 'searchParams', 'companyType'], this.props) === 'Contractor' ? '2%' : '' } },
        _react2.default.createElement(
          'div',
          {
            style: {
              fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
              fontSize: '12px',
              color: '#000',
              textTransform: 'uppercase',
              position: 'relative',
              fontWeight: '600',
              margin: '10px 0 0 15px'
            }
          },
          this.props.filterName
        ),
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '20px' } },
          this.props.filterList.map(function (item, index) {
            return index > 2 ? _react2.default.createElement('span', { key: index }) : nestedCheckboxes(item, index);
          }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { style: { float: 'left', paddingBottom: this.props.filterName === 'Segments' ? '50px' : '' } },
              (0, _ramda.path)(['filterList', 'length'], this.props) > 2 && !this.state.seeMoreExpanded ? seeMoreSeeLessExpander('+ SEE MORE') : _react2.default.createElement('span', null)
            ),
            _react2.default.createElement(
              'div',
              { style: { float: 'right', marginTop: '8px' } },
              (0, _ramda.not)(isNilOrEmpty(this.props.filterItemsSelected)) && !this.state.seeMoreExpanded && this.props.filterName !== 'Product Types' ? numberChecked() : _react2.default.createElement('span', null)
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            this.state.seeMoreExpanded ? _react2.default.createElement(
              'div',
              null,
              this.props.filterList.map(function (item, i) {
                return i > 2 ? nestedCheckboxes(item, i) : _react2.default.createElement('span', { key: i });
              })
            ) : _react2.default.createElement('span', null),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { style: { float: 'left', paddingBottom: this.props.filterName === 'Segments' ? '50px' : '' } },
                (0, _ramda.path)(['filterList', 'length'], this.props) > 2 && this.state.seeMoreExpanded ? seeMoreSeeLessExpander('- SEE LESS') : _react2.default.createElement('span', null)
              ),
              _react2.default.createElement(
                'div',
                { style: { float: 'right', marginTop: '8px' } },
                (0, _ramda.not)(isNilOrEmpty(this.props.filterItemsSelected)) && this.state.seeMoreExpanded && this.props.filterName !== 'Product Types' ? numberChecked() : _react2.default.createElement('span', null)
              )
            )
          )
        )
      );
    }
  }]);

  return Filter;
}(_react.Component);

Filter.propTypes = {
  position: _react.PropTypes.string,
  filterName: _react.PropTypes.string,
  iconClassName: _react.PropTypes.string,
  filterList: _react.PropTypes.array,
  filterStyles: _react.PropTypes.object,
  filterItemsSelected: _react.PropTypes.array,
  filterNameCamelCase: _react.PropTypes.string,
  onCheckFunction: _react.PropTypes.func
};

exports.default = Filter;

/***/ }),
/* 3208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _materialUi = __webpack_require__(3);

var _connections = __webpack_require__(3209);

var _connections2 = _interopRequireDefault(_connections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchFor = function SearchFor(_ref) {
  var companyType = _ref.companyType,
      _onChange = _ref.onChange,
      css = _ref.classes;

  return _react2.default.createElement(
    'div',
    { style: { marginTop: '-15px' } },
    _react2.default.createElement(_connections2.default, null),
    _react2.default.createElement(
      'div',
      {
        style: _connections.styles.title,
        onClick: function onClick() {
          undefined.props.push('/partner-finder/results');
        }
      },
      'Partner Search'
    ),
    _react2.default.createElement(
      'div',
      { className: 'searchCompanyType ' + css.searchForText, style: { marginTop: '16px' } },
      'I\'m searching for:'
    ),
    _react2.default.createElement(
      _materialUi.RadioButtonGroup,
      {
        name: 'type',
        className: css.radioGroup,
        defaultSelected: companyType,
        onChange: function onChange(_, type) {
          return _onChange(type);
        }
      },
      _react2.default.createElement(_materialUi.RadioButton, { value: 'Contractor', className: css.radioButton, label: 'Buyers / Agents' }),
      _react2.default.createElement(_materialUi.RadioButton, { value: 'Supplier', className: css.radioButton, label: 'Suppliers' }),
      _react2.default.createElement(_materialUi.RadioButton, { value: 'DMOs', className: css.radioButton, label: 'DMO\'s' }),
      _react2.default.createElement(_materialUi.RadioButton, { value: 'TechAndServices', className: css.radioButton, label: 'Tech & Services' })
    )
  );
};

exports.default = (0, _reactJss2.default)({
  searchForText: { color: 'black', marginLeft: '16px' },
  radioGroup: { padding: '10px 16px' },
  radioButton: { marginBottom: '10px' }
})(SearchFor);

/***/ }),
/* 3209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _navLink = __webpack_require__(1049);

var _navLink2 = _interopRequireDefault(_navLink);

var _counter = __webpack_require__(1517);

var _counter2 = _interopRequireDefault(_counter);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = exports.styles = {
  connections: {
    paddingTop: '7px'
  },
  title: {
    textTransform: 'uppercase',
    paddingLeft: '16px',
    lineHeight: '48px',
    borderBottom: '1px solid #eee'
  },
  divider: {
    margin: '8px 0 8px 0 !important'
  }
};

var Connections = function (_React$Component) {
  _inherits(Connections, _React$Component);

  function Connections(props) {
    _classCallCheck(this, Connections);

    return _possibleConstructorReturn(this, (Connections.__proto__ || Object.getPrototypeOf(Connections)).call(this, props));
  }

  _createClass(Connections, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          css = _props.classes,
          _props$values = _props.values,
          values = _props$values === undefined ? [] : _props$values;

      var _ref = function () {
        return values.map(function (value) {
          return {
            value: value,
            classes: 'nav-link connections-widget-link' + (value === 0 ? ' is-zero' : '')
          };
        });
      }(),
          _ref2 = _slicedToArray(_ref, 2),
          requests = _ref2[0],
          invitations = _ref2[1];

      return _react2.default.createElement(
        'div',
        { className: css.connections },
        _react2.default.createElement(
          'div',
          {
            className: css.title
          },
          'Partner Requests'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _navLink2.default,
            {
              routeName: '/connections/requests',
              classes: requests.classes
              // className={classes}
              // {...this.props}
            },
            'Received',
            _react2.default.createElement(_counter2.default, { data: requests.value, style: { backgroundColor: 'red' } })
          ),
          _react2.default.createElement(
            _navLink2.default,
            {
              routeName: '/connections/invitations',
              classes: invitations.classes
              // className={classes}
              // {...this.props}
            },
            'Sent',
            _react2.default.createElement(_counter2.default, { data: invitations.value })
          )
        ),
        _react2.default.createElement(_materialUi.Divider, null)
      );
    }
  }]);

  return Connections;
}(_react2.default.Component);

Connections.propTypes = {
  classes: _react.PropTypes.object,
  values: _react.PropTypes.array,
  push: _react.PropTypes.func
};

var select = function select(state) {
  return {
    values: [state.connectionsStats.get('pendingRequestCount'), state.connectionsStats.get('pendingInviteCount')]
  };
};

exports.default = (0, _reactRedux.connect)(select, { push: _reactRouterRedux.push })((0, _reactJss2.default)(styles)(Connections));

/***/ }),
/* 3210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _selectFields = __webpack_require__(141);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchLocation = function SearchLocation(_ref) {
  var companyType = _ref.companyType,
      _onChange = _ref.onChange,
      value = _ref.value,
      css = _ref.classes;

  var countryLabelText = {
    Supplier: 'Located in:',
    DMOs: 'That promote destinations in:'
  }[companyType] || 'That sell trips to:';
  return _react2.default.createElement(
    'div',
    { className: css.wrapper },
    _react2.default.createElement(
      'div',
      { className: 'label-text-left-nav', style: { textAlign: 'left', whiteSpace: 'pre-wrap', margin: '-10px 0 0 15px' } },
      countryLabelText
    ),
    _react2.default.createElement(_reactSelect2.default, {
      className: css.countrySelect,
      onChange: function onChange(_ref2) {
        var val = _ref2.value;
        return _onChange(val);
      },
      options: _selectFields.countries,
      value: value,
      placeholder: 'Search & Pick A Country',
      clearable: false,
      scrollMenuIntoView: false
    })
  );
};

exports.default = (0, _reactJss2.default)({
  wrapper: {
    margin: '10px 0 10px 0'
  },
  countrySelect: {
    margin: '5px 0 15px 15px',
    width: '90%',
    '& div': {
      borderLeft: 'none !important',
      borderRight: 'none !important',
      borderTop: 'none !important'
    }
  }
})(SearchLocation);

/***/ }),
/* 3211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _check = __webpack_require__(854);

var _check2 = _interopRequireDefault(_check);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SearchCheckbox = function SearchCheckbox(_ref) {
  var _React$createElement;

  var icon = _ref.icon,
      iconColor = _ref.iconColor,
      label = _ref.label,
      iconEl = _ref.iconEl,
      labelSize = _ref.labelSize,
      onToggle = _ref.onToggle,
      style = _ref.style,
      toggled = _ref.toggled;
  return _react2.default.createElement(_materialUi.Checkbox, (_React$createElement = {
    label: icon === 'tc-icon-user-check' ? _react2.default.createElement(
      'div',
      {
        style: { marginLeft: '6px', top: '8px', position: 'relative' }
      },
      _react2.default.createElement(_check2.default, {
        color: iconColor,
        style: { height: '14px' }
      }),
      _react2.default.createElement(
        'span',
        { style: { marginLeft: '8px' } },
        label
      )
    ) : _react2.default.createElement(
      'div',
      {
        style: { marginLeft: '-5px' }
      },
      iconEl ? iconEl : _react2.default.createElement(_materialUi.IconButton, {
        iconClassName: icon,
        iconStyle: { fontSize: '14px', color: iconColor }
      }),
      _react2.default.createElement(
        'span',
        { style: { marginLeft: '-5px' } },
        label
      )
    ),
    labelStyle: { width: '100%', marginLeft: '-10px', textAlign: 'left', marginTop: '-8px', height: '20px' },
    style: style,
    onCheck: onToggle
  }, _defineProperty(_React$createElement, 'style', { width: '95%', textAlign: 'center', height: '20px', padding: '2px 0', marginLeft: '8px' }), _defineProperty(_React$createElement, 'checked', toggled), _React$createElement));
};

exports.default = SearchCheckbox;

/***/ }),
/* 3212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__(251);

var _jquery2 = _interopRequireDefault(_jquery);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

var _listItemPartnerFinder = __webpack_require__(3213);

var _listItemPartnerFinder2 = _interopRequireDefault(_listItemPartnerFinder);

var _searchBarCard = __webpack_require__(1126);

var _searchBarCard2 = _interopRequireDefault(_searchBarCard);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _sectionHeading = __webpack_require__(732);

var _sectionHeading2 = _interopRequireDefault(_sectionHeading);

var _mapMultimarkers = __webpack_require__(3214);

var _mapMultimarkers2 = _interopRequireDefault(_mapMultimarkers);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

var _address = __webpack_require__(1527);

var _pagination = __webpack_require__(870);

var _pagination2 = _interopRequireDefault(_pagination);

var _growNetwork = __webpack_require__(3215);

var _growNetwork2 = _interopRequireDefault(_growNetwork);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Dependencies

// Components


var languageSettings = _languages2.default['en-US'];

// fix for firefox
// const getDocHeight = () => {
//   const D = document;
//   return Math.max(
//     Math.max(D.body.scrollHeight, D.documentElement.scrollHeight),
//     Math.max(D.body.offsetHeight, D.documentElement.offsetHeight),
//     Math.max(D.body.clientHeight, D.documentElement.clientHeight)
//   );
// }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _this._handleViewChange = function (value) {
      _this.setState({ view: value, infoBoxContent: undefined });
      var searchParams = _this.props.partnerFinder.searchParams;
      if (value === 'Map View') {
        searchParams.isForMap = true;
        (0, _address.getGeoLocation)({ city: searchParams.city, country: searchParams.country }, function (address, geometry) {
          var _address$coordinates = _slicedToArray(address.coordinates, 2),
              longitude = _address$coordinates[0],
              latitude = _address$coordinates[1];

          searchParams = _extends({}, searchParams, {
            longitude: longitude,
            latitude: latitude,
            bounds: geometry.viewport,
            radius: _this._calculateRadius([latitude, longitude], geometry.viewport)
          });
          _this.props.search(searchParams);
        });
      } else {
        searchParams.isForMap = undefined;
        searchParams.longitude = undefined;
        searchParams.latitude = undefined;
        searchParams.radius = undefined;
        _this.props.search(searchParams);
      }
    };

    _this._handleMapChangeAndSearch = function (center, bounds, zoom) {
      var searchParams = _this.props.partnerFinder.searchParams;
      searchParams.latitude = center[0];
      searchParams.longitude = center[1];
      if (bounds) {
        searchParams.bounds = undefined;
        searchParams.radius = _this._calculateRadius(center, bounds);
      }
      if (zoom) {
        searchParams.zoom = zoom;
      }
      _this.props.search(searchParams);
    };

    _this._openInfoBox = function (result) {
      _this.setState({
        infoBoxContent: result
      });
    };

    _this.state = {
      view: 'List View',
      isFixed: false
    };
    _this.onScroll = _this.onScroll.bind(_this);
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.partnerFinder.results) {
        this.props.search(this.props.partnerFinder.searchParams, undefined, true);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.addEventListener) {
        window.addEventListener('scroll', this.onScroll);
      } else {
        window.attachEvent('onscroll', this.onScroll);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.partnerFinder.searchParams.companyType === 'Contractor' || props.partnerFinder.searchParams.companyType === 'Other') {
        this.setState({
          view: 'List View',
          infoBoxContent: undefined
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (window.addEventListener) {
        window.removeEventListener('scroll', this.onScroll);
      } else {
        window.detachEvent('onScroll', this.onScroll);
      }
      // const searchParams = this.props.partnerFinder.searchParams;
      // searchParams.isForMap = undefined;
      // searchParams.latitude = undefined;
      // searchParams.longitude = undefined;
      // searchParams.radius = undefined;
      // searchParams.page = 1;
      // this.props.search(searchParams, undefined, true);
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      var partnerFinder = this.props.partnerFinder;

      var scrollTop = document.body.scrollTop || (0, _jquery2.default)('html').scrollTop(); // Firefox doc.body.scrollTop always 0 - so must switch to jquery html

      if (this.state.view === 'Map View') {
        this.setState({ isFixed: false });
      } else if (scrollTop >= 32 !== this.state.isFixed) {
        this.setState({ isFixed: !this.state.isFixed });
      }
      // if (document.body.offsetHeight + scrollTop === getDocHeight()) {
      //   loadMore(partnerFinder.searchParams, true);
      // }
    }
  }, {
    key: 'getDistanceFromLatLonInKm',
    value: function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
      var r = 6371;
      var dLat = (lat2 - lat1) * (Math.PI / 180);
      var dLon = (lon2 - lon1) * (Math.PI / 180);
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return r * c;
    }
  }, {
    key: '_calculateRadius',
    value: function _calculateRadius(center, bounds) {
      var radius1 = this.getDistanceFromLatLonInKm(center[0], center[1], bounds.getSouthWest().lat(), bounds.getSouthWest().lng());
      var radius2 = this.getDistanceFromLatLonInKm(center[0], center[1], bounds.getNorthEast().lat(), bounds.getNorthEast().lng());
      return Math.max(radius1, radius2);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          partnerFinder = _props.partnerFinder,
          loadMore = _props.loadMore,
          searchDefault = _props.searchDefault,
          lockedPartnersBanner = _props.lockedPartnersBanner;


      var pagination = partnerFinder.total > 10 ? _react2.default.createElement(_pagination2.default, {
        style: { backgroundColor: '#fafafa', marginLeft: '-16px' },
        currentPage: partnerFinder.searchParams.page || 1,
        totalPages: Math.ceil((partnerFinder.total || 0) / 10),
        goToPage: function goToPage(page) {
          return loadMore(page);
        },
        noOfPagesToShow: 5
      }) : _react2.default.createElement('div', null);
      var listItems = function () {
        if (!partnerFinder.results) return '';
        if (!Array.isArray(partnerFinder.results)) {
          return _react2.default.createElement(
            'div',
            { className: 'no-connections' },
            _react2.default.createElement(
              'h4',
              { className: 'no-connections-message' },
              ' ',
              "Sorry, we did not find any results for your search."
            )
          );
        }
        return partnerFinder.results.map(function (result, index) {
          result.companyId = result.companyId ? result.companyId : result.supplierId;
          return _react2.default.createElement(_listItemPartnerFinder2.default, _extends({}, _this2.props, result, { key: index, isForPremiumUser: partnerFinder.searchParams.isForPremiumUser }));
        });
      }();
      var checkCompanyType = _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('Contractor'), _ramda2.default.always('buyers')], [_ramda2.default.equals('Supplier'), _ramda2.default.always('suppliers')], [_ramda2.default.equals('Other'), _ramda2.default.always('others')], [_ramda2.default.T, _ramda2.default.always('companies')]]), partnerFinder.searchParams.companyType);
      var SellingOrIn = checkCompanyType === 'suppliers' || checkCompanyType === 'others' ? 'in' : 'selling';
      var country = partnerFinder.searchParams.country || (partnerFinder.searchParams.destinationsSold ? partnerFinder.searchParams.destinationsSold[0] : 'your search');
      var subtitle = function () {
        if (_this2.state.view === 'Map View') return 'We found ' + partnerFinder.results.length + ' ' + checkCompanyType + ' in this area that match your search';
        return 'We found ' + partnerFinder.total + ' ' + checkCompanyType + ' ' + SellingOrIn + ' ' + country + ' that match your search.';
      }();
      var titleBarExtra = function () {
        if (partnerFinder.searchParams.companyType === 'Supplier') {
          if (_this2.state.view === 'List View') {
            return _react2.default.createElement(
              'div',
              { onClick: _this2._handleViewChange.bind(_this2, 'Map View'), style: { float: 'right', marginTop: '12px', marginRight: '5px' }, className: 'profile-edit-icon-container top-bar-edit-container' },
              _react2.default.createElement(_icon2.default, { className: 'tc-icon-map profile-edit-icon', style: { top: '1px' } }),
              "Map View"
            );
          } else if (_this2.state.view === 'Map View') {
            return _react2.default.createElement(
              'div',
              { onClick: _this2._handleViewChange.bind(_this2, 'List View'), style: { float: 'right', marginTop: '12px', marginRight: '5px' }, className: 'profile-edit-icon-container top-bar-edit-container' },
              _react2.default.createElement(_icon2.default, { className: 'tc-icon-list2 profile-edit-icon', style: { top: '1px' } }),
              "List View"
            );
          }
        }
      }();

      var searchBarHintText = languageSettings.partnerFinder.rightContent.searchBarText;
      var bounds = partnerFinder.searchParams.bounds;
      var zoom = partnerFinder.searchParams.zoom;
      var centerCoordinates = partnerFinder.searchParams.latitude ? [partnerFinder.searchParams.latitude, partnerFinder.searchParams.longitude] : undefined;
      var infoBoxForMapView = void 0;
      var content = function () {
        if (_this2.state.view === 'List View') {
          if (_this2.props.partnerFinder.status === 'isSyncing') {
            return _react2.default.createElement(
              'div',
              { className: 'no-connections-loading', style: { width: '100%', height: '100px' } },
              _react2.default.createElement('div', { className: 'load-bar loader' })
            );
          }
          // if (partnerFinder.threeConnectedCustomers) {
          //   return (
          //     <div className={'connections-list'}>
          //       {listItems}
          //     </div>
          //   );
          // }
          return _react2.default.createElement(
            'div',
            { onScroll: _this2.onScroll, className: 'connections-list' },
            listItems,
            pagination
          );
        }
        if (_this2.state.view === 'Map View') {
          if (_this2.state.infoBoxContent) {
            // if (partnerFinder.searchParams.isForPremiumUser) {
            var listItemContent = _extends({}, _this2.state.infoBoxContent);
            listItemContent.companyId = listItemContent.companyId || listItemContent.supplierId;
            listItemContent.isForPremiumUser = partnerFinder.searchParams.isForPremiumUser;
            infoBoxForMapView = _react2.default.createElement(
              _materialUi.Paper,
              { style: { paddingLeft: '15px' } },
              _react2.default.createElement(_listItemPartnerFinder2.default, _extends({}, _this2.props, listItemContent))
            );
            // } else {
            //   infoBoxForMapView = (
            //     <Paper style={{ textAlign: 'center' }}>
            //       <RaisedButton style={{ margin: '20px auto 20px auto' }} primary label="upgrade my plan" onClick={this._pullOutUpgrade.bind(this, 'down')}/>
            //     </Paper>
            //     );
            // }
          }
          if (Array.isArray(_this2.props.partnerFinder.results)) {
            return _react2.default.createElement(
              'div',
              { style: { height: '500px', width: '100%' } },
              _react2.default.createElement(_mapMultimarkers2.default, {
                onChange: _this2._handleMapChangeAndSearch.bind(_this2),
                bounds: bounds,
                zoom: zoom,
                isForPremiumUser: partnerFinder.searchParams.isForPremiumUser,
                openInfoBox: _this2._openInfoBox.bind(_this2),
                centerCoordinates: centerCoordinates,
                markers: partnerFinder.results,
                googleMapsApi: window.google.maps
              })
            );
          }
          return _react2.default.createElement('div', null);
        }
      }();
      var searchResultsTitle = function () {
        if (partnerFinder.searchParams.companyType === 'Supplier') return languageSettings.partnerFinder.rightContent.supplierSearchResultsTitle;
        if (partnerFinder.searchParams.companyType === 'Other') return languageSettings.partnerFinder.rightContent.otherSearchResultsTitle;
        return languageSettings.partnerFinder.rightContent.contractorSearchResultsTitle;
      }();

      return _react2.default.createElement(
        'div',
        { style: this.state.position, className: 'l-left-nav-content transformation' },
        lockedPartnersBanner,
        lockedPartnersBanner ? _react2.default.createElement('br', null) : undefined,
        partnerFinder.results && partnerFinder.total < 3 ? _react2.default.createElement(_growNetwork2.default, { history: this.props.history, networkLocation: country, containerStyle: { marginBottom: '10px' } }) : _react2.default.createElement('span', null),
        _react2.default.createElement(
          _searchBarCard2.default,
          _extends({
            title: searchResultsTitle,
            subtitle: subtitle,
            isSticky: true,
            isFixed: this.state.isFixed,
            searchHeader: true,
            listCard: true,
            padded: false,
            titleBarExtra: titleBarExtra,
            searchBarHintText: searchBarHintText
          }, this.props, {
            defaultValue: searchDefault
          }),
          content
        ),
        infoBoxForMapView
      );
    }
  }]);

  return List;
}(_react.Component);

List.propTypes = {
  search: _react.PropTypes.func,
  partnerFinder: _react.PropTypes.object,
  searchParams: _react.PropTypes.object,
  loadMore: _react.PropTypes.func,
  router: _react.PropTypes.object,
  history: _react.PropTypes.object,
  searchDefault: _react.PropTypes.string
};

exports.default = (0, _reactRedux.connect)(function (_ref) {
  var partnerFinder = _ref.partnerFinder;
  return {
    searchDefault: partnerFinder.getIn(['searchParams', 'companyOrLocationName'])
  };
}, {})(List);

/***/ }),
/* 3213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _classnames = __webpack_require__(119);

var _classnames2 = _interopRequireDefault(_classnames);

var _materialUi = __webpack_require__(3);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _profileImage = __webpack_require__(548);

var _profileImage2 = _interopRequireDefault(_profileImage);

var _docCookie = __webpack_require__(142);

var _docCookie2 = _interopRequireDefault(_docCookie);

var _lock = __webpack_require__(578);

var _lock2 = _interopRequireDefault(_lock);

var _ramda = __webpack_require__(2);

var _check = __webpack_require__(854);

var _check2 = _interopRequireDefault(_check);

var _tourconnectLogoGlobe = __webpack_require__(231);

var _tourconnectLogoGlobe2 = _interopRequireDefault(_tourconnectLogoGlobe);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

var _languages = __webpack_require__(248);

var _languages2 = _interopRequireDefault(_languages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Dependenceis


var ColoredAccomImg = __webpack_require__(1532);
var ColoredNonAccomImg = __webpack_require__(1533);
// import { getMarketingMaterials } from '../../stores/partner-finder/partnerFinder-actions';
// import Filmstrip from '../tc-ui/filmstrip/container';


// Components

var languageSettings = _languages2.default['en-US'];

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var ListItem = function (_Component) {
  _inherits(ListItem, _Component);

  function ListItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.transitionToProfile = function () {
      var _this$props = _this.props,
          companyId = _this$props.companyId,
          router = _this$props.router;

      var routeName = '/company/' + companyId;
      router.push({
        pathname: routeName,
        state: {
          from: 'PF',
          text: 'Back To Results'
        }
      });
    }, _this.transitionToLocation = function () {
      var _this$props2 = _this.props,
          locationId = _this$props2.locationId,
          router = _this$props2.router;

      var routeName = '/locations/' + locationId;
      // docCookies.setItem('fromPF', true);
      router.push({
        pathname: routeName,
        state: {
          from: 'PF',
          text: 'Back To Results'
        }
      });
    }, _this.acceptConnection = function () {
      _this.props.acceptConnection(_this.props.connectionId);
    }, _this.ignoreConnection = function () {
      _this.props.ignoreConnection(_this.props.connectionId);
    }, _this.sendInvitation = function () {
      var companyId = _this.props.companyId;
      _this.props.sendInvitation(companyId);
    }, _this.resendConnection = function () {
      _this.props.resendConnection(_this.props.connectionId);
    }, _this.fakeResendConnection = function () {
      _this.props.fakeResendInvitation(_this.props.connectionId);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     showMM: false,
  //     loadingMM: false,
  //   };
  // }
  //
  // getMM = () => {
  //   const { dispatch, companyId, locationId } = this.props;
  //   this.setState({ loadingMM: true });
  //   dispatch(getMarketingMaterials(companyId, locationId))
  //   .then(() => this.setState({ loadingMM: false }));
  // }

  _createClass(ListItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          partnerFinder = _props.partnerFinder,
          city = _props.city,
          state = _props.state,
          numOfAcceptedConn = _props.numOfAcceptedConn,
          numCompletedProds = _props.numCompletedProds,
          numOfMM = _props.numOfMM,
          locationId = _props.locationId,
          locationName = _props.locationName;


      var id = this.props.companyId;
      var classes = (0, _classnames2.default)('connections-company-name', this.props.className, {
        'is-link': id
      });

      var listItemClasses = (0, _classnames2.default)('connections-list-item', {
        'is-open': this.state
      });

      var createBadge = function createBadge(icon, iconColor, tooltip) {
        return _react2.default.createElement(_materialUi.IconButton, {
          iconClassName: icon,
          style: { padding: '0', width: '13px', marginLeft: '2px' },
          iconStyle: { fontSize: '14px', color: iconColor },
          tooltip: tooltip,
          tooltipPosition: 'bottom-right'
        });
      };

      var companyNameForHeader = function companyNameForHeader(companyNameLarger, showIcon) {
        return _react2.default.createElement(
          'div',
          {
            style: {
              marginBottom: _this2.props.industryVerified || _this2.props.tourConnectVerified || _this2.props.hasMM || _this2.props.quickResponder || _this2.props.ratesLoaded ? '-15px' : ''
            }
          },
          _react2.default.createElement(
            'div',
            {
              className: 'connections-list-header',
              onClick: locationId ? _this2.transitionToLocation : _this2.transitionToProfile,
              style: { fontSize: companyNameLarger ? '14px' : '' }
            },
            showIcon ? _react2.default.createElement('img', {
              src: ColoredNonAccomImg,
              height: '16px',
              style: { marginRight: '5px', cursor: 'default' }
            }) : _react2.default.createElement('span', null),
            _react2.default.createElement(
              'span',
              { style: { fontSize: companyNameLarger ? '14px' : '' } },
              _this2.props.companyName
            )
          ),
          _react2.default.createElement(
            'span',
            { style: { marginLeft: '-13px' } },
            _this2.props.tourConnectVerified ? _react2.default.createElement(
              _materialUi.IconButton,
              {
                style: { padding: '0', width: '13px', marginLeft: '2px' },
                tooltip: 'TourConnect Verified',
                tooltipPosition: 'bottom-right'
              },
              _react2.default.createElement('img', { src: _tourconnectLogoGlobe2.default })
            ) : '',
            _this2.props.industryVerified ? createBadge('tc-icon-verified_user', '#97E397', 'Industry Verified') : '',
            _this2.props.hasMM ? createBadge('tc-icon-photo', '#0080ff', numOfMM + ' ' + (numOfMM === 1 ? 'Marketing Material' : 'Marketing Materials')) : '',
            _this2.props.quickResponder ? createBadge('tc-icon-update', '#7F00FF', 'Usually Responds Within 7 Days') : '',
            locationName && _this2.props.ratesLoaded ? createBadge('tc-icon-description', '#ff7f00', 'Rates Loaded') : ''
          )
        );
      };

      var header = function () {
        // for suppliers
        if (locationName) {
          return _react2.default.createElement(
            'div',
            null,
            _this2.props.businessTypes ? _react2.default.createElement(
              'div',
              null,
              companyNameForHeader(false, true),
              _react2.default.createElement(
                'div',
                {
                  className: 'connections-list-header',
                  style: { display: 'block', fontSize: '14px' },
                  onClick: _this2.transitionToLocation
                },
                locationName
              )
            ) : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                {
                  className: 'connections-list-header',
                  style: { display: 'block', color: '#00bcd4' },
                  onClick: _this2.transitionToLocation
                },
                _react2.default.createElement('img', {
                  src: ColoredAccomImg,
                  height: '16px',
                  style: { marginRight: '5px', cursor: 'default' }
                }),
                locationName
              ),
              companyNameForHeader(true)
            )
          );
        }
        // for contractors
        return companyNameForHeader(false);
      }();
      var companyTypes = void 0;
      if (this.props.businessTypes) {
        var businessTypes = this.props.businessTypes;
        if (!businessTypes[0]) businessTypes.shift();
        companyTypes = businessTypes.join(', ');
      }

      var companyDisplay = _react2.default.createElement(
        'div',
        { className: classes, style: { overflow: 'visible' } },
        _react2.default.createElement(
          'div',
          { className: 'inner-tags-container' },
          header
        ),
        _react2.default.createElement(
          'small',
          null,
          function () {
            if (city && state) return city + ', ' + state;
            if (city) return city;
            return state;
          }()
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'small',
          null,
          companyTypes
        )
      );

      var styles = {
        buttonDiv: { width: '200px', display: 'inline-block', textAlign: 'center' },
        upgradeButtonDiv: {
          width: '31%',
          display: 'inline-block',
          textAlign: 'center',
          marginRight: '2%'
        },
        button: { width: '100%' },
        leftButton: { width: '47.5%', display: 'inline-block', minWidth: '47.5%' },
        rightButton: { display: 'inline-block', marginLeft: '5%', width: '47.5%', minWidth: '47.5%' },
        labelStyle: { fontSize: '12px', padding: '0 6px' }
      };
      var connectButton = function () {
        if (_this2.props.status !== 'unconnected') {
          if (_this2.props.status === 'accepted') {
            return _react2.default.createElement(
              'div',
              { style: styles.buttonDiv },
              _react2.default.createElement(
                _materialUi.FontIcon,
                { style: { marginRight: '5px', marginTop: '5px', marginLeft: '-10px' } },
                _react2.default.createElement(_check2.default, { color: '#00bcd4' })
              ),
              _react2.default.createElement(
                'div',
                {
                  style: {
                    verticalAlign: 'top',
                    lineHeight: '34px',
                    display: 'inline-block',
                    color: '#00bcd4'
                  }
                },
                'Partners'
              )
            );
          } else if (_this2.props.status === 'pending') {
            if (_this2.props.isSender) {
              var daysToRespond = (0, _ramda.pathOr)(0, [0, 'daysToRespond'], (partnerFinder.responseTime || []).filter(function (item) {
                return item.companyId === id;
              }));
              return _react2.default.createElement(
                'div',
                { style: styles.buttonDiv },
                (0, _ramda.not)(isNilOrEmpty((0, _ramda.prop)('responseTime', partnerFinder))) && (0, _ramda.contains)(id, (partnerFinder.responseTime || []).map(function (item) {
                  return item.companyId;
                })) && daysToRespond !== -1 ? _react2.default.createElement(_raisedButtonWithLoader2.default, {
                  style: styles.button,
                  loader: _this2.props.loader,
                  onClick: _this2.resendConnection,
                  secondary: true,
                  label: daysToRespond > 30 ? 'Avg response: > 30 days' : 'Avg Response: ' + (daysToRespond < 1 ? '< 1 day' : daysToRespond + ' days'),
                  labelStyle: { fontSize: '12px', whiteSpace: 'pre' }
                }) : _react2.default.createElement(_raisedButtonWithLoader2.default, {
                  style: styles.button,
                  loader: _this2.props.loader,
                  onClick: _this2.resendConnection,
                  secondary: true,
                  label: languageSettings.partnerFinder.rightContent.resend
                }),
                _react2.default.createElement(
                  'div',
                  { style: { display: 'block', fontSize: '10px' } },
                  languageSettings.partnerFinder.rightContent.lastSent + _this2.props.lastSent
                )
              );
            }
            if (_this2.props.loader) return _react2.default.createElement(
              'div',
              { style: styles.buttonDiv },
              _react2.default.createElement(_raisedButtonWithLoader2.default, { style: styles.button, loader: true })
            );
            return _react2.default.createElement(
              'div',
              { style: styles.buttonDiv },
              _react2.default.createElement(_materialUi.FlatButton, {
                style: styles.rightButton,
                primary: true,
                labelStyle: { padding: '0' },
                onTouchTap: _this2.ignoreConnection,
                label: 'Reject'
              }),
              _react2.default.createElement(_materialUi.FlatButton, {
                style: styles.leftButton,
                labelStyle: { color: 'green', padding: '0' },
                onTouchTap: _this2.acceptConnection,
                label: 'Accept'
              })
            );
          } else if (_this2.props.status === 'rejected') {
            if (_this2.props.isSender) {
              return _react2.default.createElement(
                'div',
                { style: styles.buttonDiv },
                _react2.default.createElement(_raisedButtonWithLoader2.default, {
                  style: styles.button,
                  loader: _this2.props.loader,
                  onClick: _this2.fakeResendConnection,
                  secondary: true,
                  label: languageSettings.partnerFinder.rightContent.resend
                }),
                _react2.default.createElement(
                  'div',
                  { style: { display: 'block', fontSize: '10px' } },
                  languageSettings.partnerFinder.rightContent.lastSent + _this2.props.lastSent
                )
              );
            }
            return _react2.default.createElement(
              'div',
              { style: styles.buttonDiv },
              _react2.default.createElement(_materialUi.FlatButton, {
                style: styles.button,
                disabled: true,
                label: languageSettings.partnerFinder.rightContent.ignored
              })
            );
          }
        } else {
          var _daysToRespond = (0, _ramda.pathOr)(0, [0, 'daysToRespond'], (partnerFinder.responseTime || []).filter(function (item) {
            return item.companyId === id;
          }));
          return _react2.default.createElement(
            'div',
            { style: styles.buttonDiv },
            (0, _ramda.not)(isNilOrEmpty((0, _ramda.prop)('responseTime', partnerFinder))) && (0, _ramda.contains)(id, (partnerFinder.responseTime || []).map(function (item) {
              return item.companyId;
            })) && _daysToRespond !== -1 ? _react2.default.createElement(_raisedButtonWithLoader2.default, {
              style: styles.button,
              loader: _this2.props.loader,
              onClick: _this2.resendConnection,
              secondary: true,
              label: _daysToRespond > 30 ? 'Avg response: > 30 days' : 'Avg Response: ' + (_daysToRespond < 1 ? '< 1 day' : _daysToRespond + ' days'),
              labelStyle: { fontSize: '12px', whiteSpace: 'pre' }
            }) : _react2.default.createElement(_raisedButtonWithLoader2.default, {
              id: 'connectbutton' + _this2.props.companyId,
              loader: _this2.props.loader,
              style: styles.button,
              onClick: function onClick() {
                return _this2.props.openPopover({
                  popOverAnchorEl: 'connectbutton' + _this2.props.companyId,
                  receiverInfo: {
                    companyId: _this2.props.companyId,
                    companyName: _this2.props.companyName
                  }
                });
              },
              primary: true,
              label: 'Send Partner Request'
            })
          );
        }
      }();

      // const findPhotosForComp = locationId ?
      //   pathOr([], [0, 'media'], (partnerFinder.connectionsWithMM || []).filter(connection => connection.locationId === locationId))
      //   : pathOr([], [0, 'media'], (partnerFinder.connectionsWithMM || []).filter(connection => connection.companyId === id));

      // const generateThumbnails = (photos) => {
      //   return (
      //     <div style={{ height: '50px', overflow: 'hidden', marginBottom: '5px' }}>
      //       {
      //         (photos || []).map((url, i) => <img key={i} src={url} height="50px" style={{ borderRadius: '7px', marginRight: '5px' }}/>)
      //       }
      //     </div>
      //   );
      // };

      // const MMFilmstrip = () => {
      //   return (
      //     <div style={{ margin: '15px 0 0 1.5%', clear: 'both', borderBottom: '1px solid #e0e0e0', width: '95%' }}>
      //       {
      //         call(ifElse(
      //           equals(true),
      //             () => call(ifElse(
      //               equals(true),
      //                 () => (<div style={{ marginBottom: '5px' }}>
      //                   <Filmstrip
      //                     photos={findPhotosForComp}
      //                   />
      //                 </div>),
      //               () => generateThumbnails(findPhotosForComp)
      //             ), findPhotosForComp.length > 14),
      //           () => always(<span/>)
      //         ), contains(id, partnerFinder.connectionsWithMM.map(item => item.companyId)))
      //       }
      //       {
      //         this.state.loadingMM ?
      //           <div style={{ textAlign: 'center' }}>
      //             <CircularProgress />
      //           </div> : <span/>
      //       }
      //     </div>
      //   );
      // };

      var numOfConnections = function numOfConnections() {
        return _react2.default.createElement(
          'div',
          {
            style: {
              minHeight: !locationName ? '80px' : '',
              textAlign: 'center',
              paddingTop: !locationName ? companyTypes && companyTypes.length > 83 ? '20px' : '15px' : '-5px'
            }
          },
          _react2.default.createElement(
            'b',
            null,
            numOfAcceptedConn
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'span',
            { style: { fontSize: '10px' } },
            numOfAcceptedConn === 1 ? 'Connection' : 'Connections'
          )
        );
      };

      return _react2.default.createElement(
        'div',
        { className: listItemClasses },
        _react2.default.createElement(
          'div',
          {
            className: 'connections-profile-image-container',
            style: {
              minHeight: !locationName ? '80px' : '',
              marginTop: !locationName ? companyTypes && companyTypes.length > 83 ? '20px' : '10px' : '20px'
            }
          },
          _react2.default.createElement(_profileImage2.default, {
            className: 'profile-link-image connections-profile-link-image',
            companySlugName: this.props.companyName,
            imageUrl: this.props.profileImageUrl
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '48px', borderBottom: '1px solid #e0e0e0' } },
          _react2.default.createElement(
            'div',
            {
              style: {
                padding: '16px 0px',
                display: 'inline-block',
                float: 'left',
                width: '64px',
                marginLeft: '30px'
              }
            },
            numOfConnections(),
            locationName && numCompletedProds ? _react2.default.createElement(
              'div',
              {
                style: {
                  textAlign: 'center',
                  borderTop: '1px solid #e0e0e0',
                  marginTop: companyTypes ? '15px' : '5px'
                }
              },
              _react2.default.createElement(
                'div',
                {
                  style: {
                    margin: companyTypes && !locationName ? '15px 0 -15px 0' : '5px 0 -5px 0'
                  }
                },
                _react2.default.createElement(
                  'b',
                  null,
                  numCompletedProds
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'span',
                  { style: { fontSize: '10px' } },
                  numCompletedProds === 1 ? 'Product' : 'Products'
                )
              )
            ) : _react2.default.createElement('span', null)
          ),
          _react2.default.createElement(
            'div',
            { className: 'connections-company-container' },
            companyDisplay,
            connectButton
          )
        )
      );
    }
  }]);

  return ListItem;
}(_react.Component);

ListItem.propTypes = {
  isForPremiumUser: _react.PropTypes.bool,
  companyId: _react.PropTypes.string,
  locationId: _react.PropTypes.string,
  connectionId: _react.PropTypes.string,
  className: _react.PropTypes.string,
  locationName: _react.PropTypes.string,
  history: _react.PropTypes.object,
  companyName: _react.PropTypes.string,
  status: _react.PropTypes.string,
  industryVerified: _react.PropTypes.number,
  tourConnectVerified: _react.PropTypes.number,
  lastSent: _react.PropTypes.string,
  profileImageUrl: _react.PropTypes.string,
  isSender: _react.PropTypes.bool,
  loader: _react.PropTypes.bool,
  businessTypes: _react.PropTypes.array,
  router: _react.PropTypes.object,
  openUpgrade: _react.PropTypes.func,
  acceptConnection: _react.PropTypes.func,
  ignoreConnection: _react.PropTypes.func,
  sendInvitation: _react.PropTypes.func,
  resendConnection: _react.PropTypes.func,
  fakeResendInvitation: _react.PropTypes.func,
  user: _react.PropTypes.object,
  openPopover: _react.PropTypes.func,
  hasMM: _react.PropTypes.number,
  dispatch: _react.PropTypes.func,
  partnerFinder: _react.PropTypes.object,
  city: _react.PropTypes.string,
  state: _react.PropTypes.string,
  numOfAcceptedConn: _react.PropTypes.number,
  numCompletedProds: _react.PropTypes.number,
  numOfMM: _react.PropTypes.number,
  quickResponder: _react.PropTypes.number,
  ratesLoaded: _react.PropTypes.number
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var partnerFinder = _ref2.partnerFinder;
  return {
    partnerFinder: partnerFinder.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ListItem);

/***/ }),
/* 3214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactGoogleMaps = __webpack_require__(1914);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var google = window.google;

var MultiMarkerMap = function (_Component) {
  _inherits(MultiMarkerMap, _Component);

  function MultiMarkerMap(props) {
    _classCallCheck(this, MultiMarkerMap);

    var _this = _possibleConstructorReturn(this, (MultiMarkerMap.__proto__ || Object.getPrototypeOf(MultiMarkerMap)).call(this, props));

    _this._handleDragEnd = function () {
      var center = [_this._map.getCenter().lat(), _this._map.getCenter().lng()];
      var bounds = _this._map.getBounds();
      var zoomLevel = _this._map.getZoom();
      _this.setState({ center: center, bounds: bounds, zoom: zoomLevel });
      _this.props.onChange(center, bounds, zoomLevel);
    };

    _this._handleMarkerClick = function (marker, markerIndex) {
      var markers = _ramda2.default.prop('markers', _this.state);
      markers[markerIndex].showInfoBox = true;
      _this.setState({ markers: markers });
      _this.props.openInfoBox(marker);
    };

    _this._handleCloseClick = function (markerIndex) {
      var markers = _ramda2.default.prop('markers', _this.state);
      markers[markerIndex].showInfoBox = false;
      _this.setState({ markers: markers });
    };

    _this.handleMapMounted = function (map) {
      _this._map = map;
    };

    _this.state = {
      googleMapsIsReady: false,
      markers: props.markers,
      zoom: props.zoom,
      bounds: props.bounds,
      centerCoordinates: props.centerCoordinates
    };
    return _this;
  }

  _createClass(MultiMarkerMap, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      // we are using google map's API and we have to wait for each api to load.
      window.initializedGoogleMap.listener(function () {
        _this2.setState({
          googleMapsIsReady: true
        });
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({
        markers: props.markers,
        zoom: props.zoom,
        bounds: props.bounds,
        centerCoordinates: props.centerCoordinates
      });
    }
  }, {
    key: '_renderInfoWindow',
    value: function _renderInfoWindow(ref, marker, markerIndex) {
      var _this3 = this;

      var content = void 0;
      if (this.props.isForPremiumUser) {
        if (marker.companyId) {
          content = marker.companyName;
        }
        if (marker.supplierId) {
          content = marker.locationName;
        }
      } else {
        content = 'Upgrade your plan to connect';
      }
      return _react2.default.createElement(
        _reactGoogleMaps.InfoWindow,
        {
          key: ref + '_info_window',
          onCloseClick: function onCloseClick() {
            return _this3._handleCloseClick(markerIndex);
          }
        },
        _react2.default.createElement(
          'div',
          null,
          content
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      if (!this.state.googleMapsIsReady) {
        return _react2.default.createElement(
          'div',
          null,
          ' Loading... '
        );
      }
      var zoom = this.state.zoom || 4;
      var propsBounds = this.state.bounds;
      /* jshint ignore:start */
      var bounds = void 0;
      if (propsBounds) {
        bounds = new window.google.maps.LatLngBounds(propsBounds.getSouthWest(), propsBounds.getNorthEast());
      }
      var centerCoordinates = this.state.centerCoordinates || [-33.867486900000000000, 151.206990200000060000];
      var GoogleMapLoader = (0, _reactGoogleMaps.withGoogleMap)(function () {
        return _react2.default.createElement(
          _reactGoogleMaps.GoogleMap,
          {
            bounds: bounds,
            onDragEnd: _this4._handleDragEnd,
            defaultZoom: zoom,
            ref: _this4.handleMapMounted,
            onZoomChanged: _this4._handleDragEnd,
            defaultCenter: new window.google.maps.LatLng(centerCoordinates[0], centerCoordinates[1] - 0.05)
          },
          _this4.state.markers.map(function (marker, index) {
            var ref = 'marker_' + index;
            if (marker.loc && marker.loc.coordinates) {
              return _react2.default.createElement(
                _reactGoogleMaps.Marker,
                {
                  key: ref,
                  onClick: function onClick() {
                    return _this4._handleMarkerClick(marker, index);
                  },
                  position: new window.google.maps.LatLng(marker.loc.coordinates[1], marker.loc.coordinates[0])
                },
                marker.showInfoBox ? _this4._renderInfoWindow(ref, marker, index) : _react2.default.createElement('span', null)
              );
            }
          })
        );
      });
      return _react2.default.createElement(GoogleMapLoader, {
        containerElement: _react2.default.createElement('div', {
          style: {
            height: '100%',
            position: 'absolute',
            top: '0',
            bottom: '0',
            left: '0',
            right: '0'
          }
        }),
        mapElement: _react2.default.createElement('div', { style: { height: '100%' } })
      });
    }
  }]);

  return MultiMarkerMap;
}(_react.Component);

MultiMarkerMap.propTypes = {
  markers: _react.PropTypes.array,
  onChange: _react.PropTypes.func,
  openInfoBox: _react.PropTypes.func,
  isForPremiumUser: _react.PropTypes.bool,
  googleMapsApi: _react.PropTypes.object,
  zoom: _react.PropTypes.number,
  bounds: _react.PropTypes.object,
  centerCoordinates: _react.PropTypes.array
};

exports.default = MultiMarkerMap;

/***/ }),
/* 3215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GrowNetwork = function GrowNetwork(_ref) {
  var containerStyle = _ref.containerStyle,
      networkLocation = _ref.networkLocation,
      history = _ref.history;

  return _react2.default.createElement(
    _materialUi.Paper,
    { style: _extends({}, containerStyle, { padding: '10px 50px', textAlign: 'center' }) },
    _react2.default.createElement(
      'h4',
      { style: { marginBottom: '5px' } },
      'You\'ve found a network we are still growing.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Help it grow faster by inviting your ',
      _react2.default.createElement(
        'a',
        { style: { cursor: 'pointer' }, onTouchTap: function onTouchTap() {
            return history.push('/connections/add-connections');
          } },
        'existing partners ',
        'in ' + networkLocation + '.'
      )
    )
  );
};

GrowNetwork.propTypes = {
  containerStyle: _react.PropTypes.object,
  networkLocation: _react.PropTypes.string,
  history: _react.PropTypes.object.isRequired
};

exports.default = GrowNetwork;

/***/ }),
/* 3216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _userInputActions = __webpack_require__(1002);

var _dialogActions = __webpack_require__(3217);

var _rootActionsMap = __webpack_require__(1135);

var _rootActionsMap2 = _interopRequireDefault(_rootActionsMap);

var _templateListActions = __webpack_require__(877);

var _actions = __webpack_require__(537);

var _chromeReaderMode = __webpack_require__(1461);

var _chromeReaderMode2 = _interopRequireDefault(_chromeReaderMode);

var _dashboard = __webpack_require__(1864);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _assessment = __webpack_require__(1865);

var _assessment2 = _interopRequireDefault(_assessment);

var _description = __webpack_require__(561);

var _description2 = _interopRequireDefault(_description);

var _requestsWithSameNameOrDomain = __webpack_require__(3220);

var _requestsWithSameNameOrDomain2 = _interopRequireDefault(_requestsWithSameNameOrDomain);

var _requestDataLoading = __webpack_require__(3221);

var _requestDataLoading2 = _interopRequireDefault(_requestDataLoading);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _yearDropdown = __webpack_require__(3222);

var _yearDropdown2 = _interopRequireDefault(_yearDropdown);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var convertToYY = function convertToYY(_ref) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate;
  return startDate && endDate ? _moment2.default.utc(startDate).format('D MMM YYYY') + ' - ' + _moment2.default.utc(endDate).format('D MMM YYYY') : '';
};

var ContractingController = function (_Component) {
  _inherits(ContractingController, _Component);

  function ContractingController(props) {
    _classCallCheck(this, ContractingController);

    var _this = _possibleConstructorReturn(this, (ContractingController.__proto__ || Object.getPrototypeOf(ContractingController)).call(this, props));

    _this.goStartNewContract = function () {
      window.location = "https://app.tourconnect.com" + '/partner-management/send-assets?jwt=' + localStorage.getItem('jwt') + '&open_asset_type=' + (_this.props.user.user.type === 'Contractor' ? 'requests' : 'rates');
    };

    _this.goTo = function (path) {
      var history = _this.props.history;

      history.push(path);
    };

    _this.goTo = _this.goTo.bind(_this);
    return _this;
  }

  _createClass(ContractingController, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          dispatch = _props.dispatch,
          user = _props.user;

      dispatch((0, _actions.getContractingYears)());
      if (user.user.type === 'Supplier' && window.location.pathname.indexOf('template-list') === -1 && user.user.email.indexOf('dl+') === -1) {
        dispatch((0, _templateListActions.getTemplates)());
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          children = _props2.children,
          user = _props2.user,
          _props2$location = _props2.location,
          pathname = _props2$location.pathname,
          latest = _props2$location.query.latest,
          contractId = _props2.contractId,
          contractPeriods = _props2.contractPeriods,
          contractListSearchParams = _props2.contractListSearchParams,
          templateListSearchParams = _props2.templateListSearchParams,
          contractListType = _props2.contractListType,
          updateCurrentYear = _props2.updateCurrentYear,
          billingPlan = _props2.billingPlan,
          templateList = _props2.templateList,
          contractVersions = _props2.contractVersions,
          push = _props2.push,
          props = _objectWithoutProperties(_props2, ['children', 'user', 'location', 'contractId', 'contractPeriods', 'contractListSearchParams', 'templateListSearchParams', 'contractListType', 'updateCurrentYear', 'billingPlan', 'templateList', 'contractVersions', 'push']);

      var extraProps = _extends({
        downloadExistingConnections: this.downloadExistingConnections,
        goStartNewContract: this.goStartNewContract,
        user: user
      }, props);
      var showBannerRoutes = ['/contracting/contract-list', '/contracting/template-list', '/contracting/supplier-updates-queue', '/contracting/master-template-list', '/contracting/supplier-dashboard', '/contracting/buyer-dashboard', '/contracting/reports'];
      if (Boolean(latest) && contractVersions.length > 0) {
        var latestId = contractVersions[contractVersions.length - 1];
        if (latestId !== contractId) {
          push(pathname.replace(contractId, latestId));
        } else {
          push(pathname);
        }
      }
      return _react2.default.createElement(
        'div',
        { className: 'l-app-content', style: _extends({ paddingTop: '70px', maxWidth: '1440px' }, Boolean(latest) ? { display: 'none' } : {}) },
        showBannerRoutes.some(function (route) {
          return pathname.indexOf(route) > -1;
        }) && _react2.default.createElement(
          'div',
          { className: 'flex-tc-sb', style: { flexDirection: 'row-reverse', backgroundColor: '#00bcd4', height: '48px', lineHeight: '48px', color: 'white', fontSize: '18px', padding: '4px' } },
          _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb' },
            user.user.type === 'Supplier' ? _react2.default.createElement(_flatButtonWithLoader2.default, {
              icon: _react2.default.createElement(_description2.default, { style: { fill: 'white' } }),
              label: 'Rate Templates',
              labelStyle: { color: 'white', textTransform: 'none', fontSize: '18px' },
              style: { height: '40px' },
              hoverColor: 'rgba(0, 0, 0, 0.1)',
              backgroundColor: pathname.indexOf('template-list') > -1 ? 'rgba(0, 0, 0, 0.2)' : null,
              disabled: pathname.indexOf('template-list') > -1,
              onTouchTap: function onTouchTap() {
                return _this2.props.push({
                  pathname: '/contracting/template-list',
                  query: templateListSearchParams
                });
              }
            }) : _react2.default.createElement(_flatButtonWithLoader2.default, {
              icon: _react2.default.createElement(_description2.default, { style: { fill: 'white' } }),
              label: 'Workspace List',
              labelStyle: { color: 'white', textTransform: 'none', fontSize: '18px' },
              style: { height: '40px' },
              hoverColor: 'rgba(0, 0, 0, 0.1)',
              onClick: function onClick() {
                return window.location = "https://app.tourconnect.com" + '/contracting/workspace-list?jwt=' + localStorage.getItem('jwt');
              }
            }),
            _react2.default.createElement(_flatButtonWithLoader2.default, {
              icon: _react2.default.createElement(_chromeReaderMode2.default, { style: { fill: 'white' } }),
              label: 'Contract List',
              labelStyle: { color: 'white', textTransform: 'none', fontSize: '18px' },
              style: { height: '40px' },
              hoverColor: 'rgba(0, 0, 0, 0.1)',
              backgroundColor: pathname.indexOf('contract-list') > -1 ? 'rgba(0, 0, 0, 0.2)' : null,
              disabled: pathname.indexOf('contract-list') > -1,
              onClick: function onClick() {
                if (user.user.type === 'Contractor') {
                  window.location = "https://app.tourconnect.com" + '/contracting/contract-list?jwt=' + localStorage.getItem('jwt');
                } else {
                  _this2.props.push({
                    pathname: '/contracting/contract-list/' + (contractListType || 'recent'),
                    query: contractListSearchParams
                  });
                }
              }
            }),
            _react2.default.createElement(_flatButtonWithLoader2.default, {
              icon: _react2.default.createElement(_dashboard2.default, { style: { fill: 'white' } }),
              label: 'Dashboard',
              labelStyle: { color: 'white', textTransform: 'none', fontSize: '18px' },
              style: { height: '40px' },
              hoverColor: 'rgba(0, 0, 0, 0.1)',
              backgroundColor: pathname.indexOf('-dashboard') > -1 ? 'rgba(0, 0, 0, 0.2)' : null,
              disabled: pathname.indexOf('-dashboard') > -1,
              onTouchTap: function onTouchTap() {
                return _this2.props.push('/contracting/' + (user.user.type === 'Supplier' ? 'supplier' : 'buyer') + '-dashboard');
              }
            }),
            _react2.default.createElement(
              _wrapper2.default,
              { lockIcon: true, amazonOrange: true },
              _react2.default.createElement(_flatButtonWithLoader2.default, {
                icon: _react2.default.createElement(_assessment2.default, { style: { fill: 'white' } }),
                label: 'Reports',
                labelStyle: { color: 'white', textTransform: 'none', fontSize: '18px' },
                style: { height: '40px' },
                hoverColor: 'rgba(0, 0, 0, 0.1)',
                backgroundColor: pathname.indexOf('/contracting/reports') > -1 ? 'rgba(0, 0, 0, 0.2)' : null,
                disabled: pathname.indexOf('/contracting/reports') > -1,
                onTouchTap: function onTouchTap() {
                  return _this2.props.push('/contracting/reports');
                }
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb', style: { display: 'flex' } },
            _react2.default.createElement(_yearDropdown2.default, {
              showAllPeriods: pathname.indexOf('contract-list') > -1 || pathname.indexOf('template-list') > -1,
              selectAllPeriods: pathname.indexOf('contract-list') > -1 ? props.selectAllPeriodsForContractList : props.selectAllPeriodsForTemplateList,
              arrayOfYears: contractPeriods,
              selectedYearRange: pathname.indexOf('contract-list') > -1 && contractListSearchParams.searchingAllYears || pathname.indexOf('template-list') > -1 && templateList.searchingAllYears ? 'All Periods' : convertToYY(this.props.currentYear),
              currentPeriod: this.props.currentYear,
              onDropdownChange: updateCurrentYear(pathname)
            }),
            Boolean(contractListType === 'search' && pathname.indexOf('contract-list') > -1) && _react2.default.createElement(
              'span',
              { style: { fontSize: '14px', position: 'relative', top: '4px' } },
              '\xA0Search Results - ',
              contractListSearchParams.searchCategory
            )
          )
        ),
        children ? (0, _react.cloneElement)(children, extraProps) : undefined,
        _react2.default.createElement(_materialUi.Snackbar, {
          bodyStyle: { maxWidth: '768px' },
          action: 'Dismiss',
          onActionTouchTap: this.props.clearContractingErrorString,
          onRequestClose: this.props.clearContractingErrorString,
          autoHideDuration: 6000,
          open: Boolean(this.props.contractingErrorString),
          message: this.props.contractingErrorString
        }),
        user.user.type === 'Contractor' && _react2.default.createElement(_requestsWithSameNameOrDomain2.default, null),
        user.user.type === 'Contractor' && _react2.default.createElement(_requestDataLoading2.default, null)
      );
    }
  }]);

  return ContractingController;
}(_react.Component);

ContractingController.propTypes = {
  dispatch: _react.PropTypes.func,
  history: _react.PropTypes.object,
  location: _react.PropTypes.object,
  user: _react.PropTypes.object,
  children: _react.PropTypes.object,
  params: _react.PropTypes.object,
  clearContractingErrorString: _react.PropTypes.func,
  contractingErrorString: _react.PropTypes.string,
  push: _react.PropTypes.func,
  currentYear: _react.PropTypes.object,
  contractPeriods: _react.PropTypes.array,
  updateCurrentYear: _react.PropTypes.func,
  contractListType: _react.PropTypes.string,
  contractListSearchParams: _react.PropTypes.object,
  templateListSearchParams: _react.PropTypes.object.isRequired,
  billingPlan: _react.PropTypes.string,
  selectAllPeriodsForContractList: _react.PropTypes.func,
  selectAllPeriodsForTemplateList: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
  var contracting = _ref2.contracting,
      user = _ref2.user,
      ui = _ref2.ui;
  var latest = _ref3.location.query.latest;

  var contractVersions = function () {
    if (!latest) return [];
    var versions = contracting.contractActivitiesProducts.getIn(['leftNav', 'allVersions']);
    return versions && versions !== 'versions' ? versions.toJS() : [];
  }();
  return {
    wizard: contracting.wizard.toJS(),
    contractingErrorString: contracting.contractingError.get('errorString'),
    templateList: contracting.templateList.toJS(),
    isShellAccount: user.get('contractingShell') || false,
    isTourReady: ui.walkthru.get('isTourReady'),
    isTourRunning: ui.walkthru.get('isOpen'),
    contractListType: contracting.contractList.getIn(['list', 'listType']),
    contractListSearchParams: contracting.contractList.get('searchParams').toJS(),
    templateListSearchParams: {
      statusesFilter: contracting.templateList.get('statusesFilter').toJS(),
      showType: contracting.templateList.get('showType')
    },
    contractPeriods: contracting.contractPeriods,
    currentYear: contracting.currentYear,
    billingPlan: user.get('billingPlan'),
    contractId: contracting.contractActivitiesProducts.getIn(['leftNav', 'contractId']),
    contractVersions: contractVersions
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onUserInput: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default),
    openDialog: (0, _dialogActions.openDialog)(dispatch, _rootActionsMap2.default),
    closeDialog: (0, _dialogActions.closeDialog)(dispatch, _rootActionsMap2.default),
    clearContractingErrorString: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default, 'clearContractingErrorString'),
    push: function push() {
      return dispatch(_reactRouterRedux.push.apply(undefined, arguments));
    },
    updateCurrentYear: function updateCurrentYear(currentRoute) {
      return function (dates) {
        return dispatch({ type: '[contracting]SELECTED_YEAR_FOR_CONTRACTING', payload: dates, currentRoute: currentRoute });
      };
    },
    selectAllPeriodsForContractList: function selectAllPeriodsForContractList() {
      return dispatch({ type: '[contract-list]UPDATE_SEARCH_PARAMS', payload: { searchingAllYears: true } });
    },
    selectAllPeriodsForTemplateList: function selectAllPeriodsForTemplateList() {
      return dispatch({ type: '[template-list]UPDATE_PROPS_IN_TEMPLATE_LIST', payload: { searchingAllYears: true } });
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContractingController);

/***/ }),
/* 3217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});
exports.openDialog = exports.closeDialog = undefined;

var _redux = __webpack_require__(131);

var _actionCreatorFactory = __webpack_require__(1256);

var _ramda = __webpack_require__(2);

var closeDialog = exports.closeDialog = (0, _ramda.curry)(function (dispatch, actions, dialog) {
   return (0, _redux.compose)(dispatch, function () {
      for (var _len = arguments.length, xs = Array(_len), _key = 0; _key < _len; _key++) {
         xs[_key] = arguments[_key];
      }

      return xs.length ? (0, _actionCreatorFactory.actionCreatorFactoryWithOpts)(actions[dialog], false, xs) : (0, _actionCreatorFactory.actionCreatorFactory)(actions[dialog], false);
   });
});

var openDialog = exports.openDialog = (0, _ramda.curry)(function (dispatch, actions, dialog) {
   return (0, _redux.compose)(dispatch, function () {
      for (var _len2 = arguments.length, xs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
         xs[_key2] = arguments[_key2];
      }

      return xs.length ? (0, _actionCreatorFactory.actionCreatorFactoryWithOpts)(actions[dialog], true, xs) : (0, _actionCreatorFactory.actionCreatorFactory)(actions[dialog], true);
   });
});

/***/ }),
/* 3218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _immutable = __webpack_require__(26);

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var insertSeasonsToSeasonRates = function insertSeasonsToSeasonRates(immutableProduct, seasons) {
  var basedSeasons = seasons || immutableProduct.get('seasons').toJS();
  return immutableProduct.set('seasonRates', (0, _immutable.fromJS)(basedSeasons.map(function (season, i) {
    var seasonRate = immutableProduct.getIn(['seasonRates', i]);
    if (seasonRate) return _ramda2.default.merge(seasonRate.toJS(), season);
    return _ramda2.default.merge(season, { rateSets: [] });
  })));
};

var policiesInCaps = {
  cancellation: 'Cancellation',
  group: 'Group',
  freeOfCharge: 'Free of Charge',
  family: 'Family',
  child: 'Child',
  infant: 'Infant'
};
var editProduct = function editProduct(initialProduct, payload) {
  switch (payload.updateType) {
    case 'DELETE_PRODUCT_POLICY_FROM_CONTRACT':
      return {
        hash: { 'hash.productPolicy': _nodeUuid2.default.v1() },
        section: 'policy',
        product: initialProduct.update('productPolicy', (0, _ramda.filter)(function (policy) {
          return policy.get('policyType') !== payload.policyType;
        })),
        editHistory: { detail: 'Deleted ' + payload.policyType }
      };
    case 'DELETE_SEASON_FROM_PRODUCT':
      var contractingPeriod = [{ seasonStartDate: payload.contractingPeriod.startDate, seasonEndDate: payload.contractingPeriod.endDate }];
      var deleteFromSeasonalArrFn = function deleteFromSeasonalArrFn(arr) {
        if (arr.size > 1 && arr.size === initialProduct.get('seasons').size) {
          var deleted = arr.delete(payload.seasonRatesIndex);
          if (deleted.size === 1) return deleted.setIn([0, 'dateRanges'], (0, _immutable.fromJS)(contractingPeriod));
          return deleted;
        }
        return arr;
      };
      return {
        hash: {
          'hash.seasons': _nodeUuid2.default.v1(),
          'hash.rates': _nodeUuid2.default.v1()
        },
        section: 'seasons',
        product: initialProduct.deleteIn(['seasonRates', payload.seasonRatesIndex]).deleteIn(['seasons', payload.seasonRatesIndex]).update('allocation', deleteFromSeasonalArrFn).update('pickup', deleteFromSeasonalArrFn).update('dropoff', deleteFromSeasonalArrFn).update('productPolicy', function (productPolicy) {
          return productPolicy.map(function (policy) {
            if (policy.get('policyType') === 'cancellation') {
              return policy.update('cancellations', deleteFromSeasonalArrFn);
            }
            return policy;
          });
        }),
        editHistory: { detail: 'Deleted ' + (initialProduct.getIn(['seasons', payload.seasonRatesIndex, 'seasonName']) ? initialProduct.getIn(['seasons', payload.seasonRatesIndex, 'seasonName']) + ' Season' : 'A Season') }
      };
    case 'DELETE_RATE_SET_FROM_SEASON':
      return {
        hash: { 'hash.rates': _nodeUuid2.default.v1() },
        section: 'rates',
        product: initialProduct.deleteIn(['seasonRates', payload.seasonRatesIndex, 'rateSets', payload.rateSetsIndex]),
        editHistory: { detail: 'Deleted A Rate Set ' + (initialProduct.getIn(['seasons', payload.seasonRatesIndex, 'seasonName']) ? 'from ' + initialProduct.getIn(['seasons', payload.seasonRatesIndex, 'seasonName']) + ' Season' : '') }
      };
    case 'SEASONRATES_SAVED_TO_DB':
      return {
        hash: {
          'hash.seasons': _nodeUuid2.default.v1(),
          'hash.rates': _nodeUuid2.default.v1()
        },
        section: 'seasons',
        product: initialProduct.update('seasonRates', function (oldSeasonRates) {
          return oldSeasonRates ? oldSeasonRates.push((0, _immutable.fromJS)(payload.seasonRates)) : (0, _immutable.fromJS)([payload.seasonRates]);
        }).update('seasons', function (seasons) {
          return seasons.push((0, _immutable.fromJS)(_ramda2.default.pick(['seasonName', 'dateRanges'], payload.seasonRates)));
        }),
        editHistory: { detail: 'Added Season and Rates ' + (payload.seasonRates.seasonName ? '- ' + payload.seasonRates.seasonName + ' Season' : '') }
      };
    case 'SAVE_PRODUCT_CODE_ALLOCATION':
      return {
        hash: { 'hash.allocation': _nodeUuid2.default.v1() },
        section: 'allocation',
        product: initialProduct.merge((0, _immutable.fromJS)(payload.data)),
        editHistory: { detail: 'Updated Allocation Information' }
      };
    case 'SAVE_SEASON_DATES_CHANGES':
      var sortByStartDateAsc = _ramda2.default.sort(_ramda2.default.cond([[_ramda2.default.useWith(_ramda2.default.lt, [_ramda2.default.prop('seasonStartDate'), _ramda2.default.prop('seasonEndDate')]), _ramda2.default.always(-1)], [_ramda2.default.useWith(_ramda2.default.gt, [_ramda2.default.prop('seasonStartDate'), _ramda2.default.prop('seasonEndDate')]), _ramda2.default.always(1)], [_ramda2.default.T, _ramda2.default.always(0)]]));
      var datesSortedSeasons = payload.data.existingSeasons.map(_ramda2.default.mapObjIndexed(function (val, key) {
        if (key === 'dateRanges') {
          return sortByStartDateAsc(val.filter(function (dateRange) {
            return dateRange.seasonStartDate;
          }));
        }
        return val;
      }));
      return {
        hash: { 'hash.seasons': _nodeUuid2.default.v1() },
        section: 'seasons',
        product: insertSeasonsToSeasonRates(initialProduct.set('seasons', (0, _immutable.fromJS)(datesSortedSeasons)), datesSortedSeasons),
        editHistory: { detail: 'Updated Season Information' }
      };
    case 'SAVE_RATES_CHANGES_ADD_EDIT':
      /*
       seasons OR seasonRates, whichever one is longer array should be considered as the base array
       */
      // seasonRates is longer array
      // need to make sure seasons match with seasonRates
      if (initialProduct.get('seasonRates').filter(function (x) {
        return x;
      }).size > initialProduct.get('seasons').filter(function (x) {
        return x;
      }).size) {
        return {
          hash: { 'hash.rates': _nodeUuid2.default.v1() },
          section: 'rates',
          editHistory: { detail: 'Updated Rate Set' },
          product: initialProduct.update('seasonRates', function (seasonRates) {
            return seasonRates.filter(function (x) {
              return x;
            }).map(function (seasonRate, thisIndex) {
              if (thisIndex === payload.data.seasonRatesIndex) {
                return seasonRate.set('rateSets', (0, _immutable.fromJS)(payload.data.rateSets));
              }
              return seasonRate;
            });
          }).update('seasons', function () {
            return initialProduct.get('seasonRates');
          })
        };
      }
      // seasons is longer array
      // this will make sure seasonRates' length match seasons
      return {
        hash: { 'hash.rates': _nodeUuid2.default.v1() },
        section: 'rates',
        editHistory: { detail: 'Updated Rate Set ' + (initialProduct.getIn(['seasons', payload.data.seasonRatesIndex, 'seasonName']) ? 'for ' + initialProduct.getIn(['seasons', payload.data.seasonRatesIndex, 'seasonName']) + ' Season' : '') },
        product: initialProduct.update('seasonRates', function (seasonRates) {
          return initialProduct.get('seasons').filter(function (x) {
            return x;
          }).map(function (season, thisIndex) {
            if (thisIndex === payload.data.seasonRatesIndex) {
              return season.set('rateSets', (0, _immutable.fromJS)(payload.data.rateSets));
            }
            var seasonRateObject = seasonRates.get(thisIndex);
            if (seasonRateObject) return seasonRateObject;
            return season;
          });
        })
      };
    case 'SAVED_BLACKOUT_DAYS':
      var blackouts = payload.data.blackouts.filter(function (blackout) {
        return blackout.startDate;
      });
      return {
        hash: { 'hash.blackouts': _nodeUuid2.default.v1() },
        section: 'blackouts',
        product: initialProduct.set('blackouts', (0, _immutable.fromJS)(blackouts)),
        editHistory: { detail: ((initialProduct.toJS().blackouts || []).length < blackouts.length ? 'Added' : 'Updated') + ' Blackout Days' }
      };
    case 'SAVED_PRODUCT_POLICY':
      var productPolicy = [].concat(_toConsumableArray(payload.data.productPolicy), [payload.data.selectedPolicy]);
      return {
        hash: { 'hash.productPolicy': _nodeUuid2.default.v1() },
        section: 'policy',
        product: initialProduct.set('productPolicy', (0, _immutable.fromJS)(productPolicy)),
        editHistory: { detail: 'Added ' + (policiesInCaps[payload.data.selectedPolicy.policyType] || 'Product') + ' Policy' }
      };
    case 'SAVED_EDITED_PRODUCT_POLICY':
      var udpatedProductPolicy = payload.data.productPolicy.map(function (policy) {
        if (policy.policyType === payload.data.selectedPolicy.policyType) return payload.data.selectedPolicy;
        return policy;
      });
      return {
        hash: { 'hash.productPolicy': _nodeUuid2.default.v1() },
        section: 'policy',
        product: initialProduct.set('productPolicy', (0, _immutable.fromJS)(udpatedProductPolicy)),
        editHistory: { detail: 'Updated ' + (policiesInCaps[payload.data.selectedPolicy.policyType] || 'Product') + ' Policy' }
      };
    case 'DELETE_OFFER_FROM_PRODUCT':
      return {
        hash: { 'hash.offers': _nodeUuid2.default.v1() },
        section: 'offers',
        product: initialProduct.deleteIn(['offers', payload.offerIndex]),
        editHistory: { detail: 'Deleted An Special Offer' }
      };
    case 'DELETE_EXTRA_FROM_PRODUCT':
      return {
        hash: { 'hash.extras': _nodeUuid2.default.v1() },
        section: 'extras',
        product: initialProduct.deleteIn(['extras', payload.extraIndex]),
        editHistory: { detail: 'Deleted An Extra' }
      };
    case 'SAVE_PICKUP_DROPOFF_INFO':
      return {
        hash: { 'hash.pickupDropoff': _nodeUuid2.default.v1() },
        section: payload.data.pickupOrDropoff,
        product: initialProduct.set(payload.data.pickupOrDropoff, (0, _immutable.fromJS)(payload.data[payload.data.pickupOrDropoff])),
        editHistory: { detail: 'Updated Pickup and Dropoff Information' }
      };
    case 'SAVE_SEASONAL_CANCELLATION_POLICIES':
      var updateCxl = (initialProduct.toJS().productPolicy || []).some(function (policy) {
        return policy.policyType === 'cancellation';
      });
      var cancellationPolciesObj = _ramda2.default.pick(['cancellations', 'policyType', 'cancellations', 'dateRanges'], payload.data);
      return {
        hash: { 'hash.productPolicy': _nodeUuid2.default.v1() },
        section: 'cancellations',
        product: initialProduct.update('productPolicy', function (policy) {
          if (!(policy && policy.length)) return (0, _immutable.fromJS)([cancellationPolciesObj]);
          if (policy.some(function (obj) {
            return obj.get('policyType') === 'cancellation';
          })) {
            return policy.map(function (obj) {
              if (obj.get('policyType') === 'cancellation') return (0, _immutable.fromJS)(cancellationPolciesObj);
              return obj;
            });
          }
          return policy.concat((0, _immutable.fromJS)([cancellationPolciesObj]));
        }),
        editHistory: { detail: (updateCxl ? 'Updated' : 'Added') + ' Cancellation Policies' }
      };
    default:
      return {
        product: initialProduct
      };
  }
};

exports.default = editProduct;

/***/ }),
/* 3219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_RADIO_BUTTON_VALUE = exports.SET_RADIO_BUTTON_VALUE = 'SET_RADIO_BUTTON_VALUE';
var CONVERT_FROM_CSV_FOR_CONTRACTING = exports.CONVERT_FROM_CSV_FOR_CONTRACTING = 'CONVERT_FROM_CSV_FOR_CONTRACTING';
var SEARCH_LIST_ITEMS = exports.SEARCH_LIST_ITEMS = 'SEARCH_LIST_ITEMS';
var ADD_SELECTED_CONNECTIONS = exports.ADD_SELECTED_CONNECTIONS = 'ADD_SELECTED_CONNECTIONS';
var CHANGE_ADD_FOLDER_DIALOG_STATE = exports.CHANGE_ADD_FOLDER_DIALOG_STATE = 'CHANGE_ADD_FOLDER_DIALOG_STATE';
var MODAL_ACTIONS = exports.MODAL_ACTIONS = 'MODAL_ACTIONS';
var ADD_CONTRACT_SETTINGS_UPDATE = exports.ADD_CONTRACT_SETTINGS_UPDATE = 'ADD_CONTRACT_SETTINGS_UPDATE';
var SET_SUBMISSION_CRITERIA_COPY_TEMPLATE_DROPDOWN_VALUE = exports.SET_SUBMISSION_CRITERIA_COPY_TEMPLATE_DROPDOWN_VALUE = 'SET_SUBMISSION_CRITERIA_COPY_TEMPLATE_DROPDOWN_VALUE';

var wizardMappedActions = exports.wizardMappedActions = {
  addContractSettingsUpdate: 'ADD_CONTRACT_SETTINGS_UPDATE',
  disableContinueAndShowErrors: 'DISABLE_CONTINUE_AND_SHOW_ERRORS',
  showAllContractPartners: 'SHOW_ALL_CONTRACT_PARTNERS',
  notesRadioButtonChange: 'NOTES_RADIO_BUTTON_CHANGE',
  termsRadioButtonChange: 'TERMS_RADIO_BUTTON_CHANGE'
};

/***/ }),
/* 3220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  searchCompanyName: _react.PropTypes.string,
  searchDomain: _react.PropTypes.string,
  contractPeriod: _react.PropTypes.object,
  open: _react.PropTypes.bool,
  loadingData: _react.PropTypes.bool,
  dataLoaded: _react.PropTypes.bool,
  companyId: _react.PropTypes.string,
  onRequestClose: _react.PropTypes.func,
  requests: _react.PropTypes.array,
  selectedIds: _react.PropTypes.array,
  onCheck: _react.PropTypes.func,
  discardSelected: _react.PropTypes.func,
  onClickSelectAll: _react.PropTypes.func,
  apiCallStatus: _react.PropTypes.string
};

var RequestsWithSameNameOrDomain = function RequestsWithSameNameOrDomain(props) {
  var open = props.open,
      onRequestClose = props.onRequestClose,
      requests = props.requests,
      selectedIds = props.selectedIds,
      _onCheck = props.onCheck,
      discardSelected = props.discardSelected,
      loadingData = props.loadingData,
      dataLoaded = props.dataLoaded,
      searchCompanyName = props.searchCompanyName,
      searchDomain = props.searchDomain,
      apiCallStatus = props.apiCallStatus,
      contractPeriod = props.contractPeriod,
      onClickSelectAll = props.onClickSelectAll;

  var text = 'requests sent to the same ' + (searchDomain ? ' domain as ' + searchDomain : ' company as ' + searchCompanyName) + ' for the selected contracting period - ' + (new Date(contractPeriod.startDate).getYear() - 100) + '-' + (new Date(contractPeriod.endDate).getYear() - 100);
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: open,
      onRequestClose: onRequestClose,
      actions: [_react2.default.createElement(_flatButtonWithLoader2.default, { label: apiCallStatus === 'success' ? 'Dismiss' : 'Cancel', onTouchTap: onRequestClose }), _react2.default.createElement(_flatButtonWithLoader2.default, { secondary: true, label: 'Discard', onTouchTap: discardSelected, loader: apiCallStatus === 'processing', disabled: _ramda2.default.isEmpty(selectedIds) || apiCallStatus === 'success' })]
    },
    _ramda2.default.call(_ramda2.default.cond([[function () {
      return loadingData || apiCallStatus === 'processing';
    }, _ramda2.default.always(_react2.default.createElement(_materialUi.CircularProgress, { style: { margin: '20px 50% auto' } }))], [function () {
      return dataLoaded && _ramda2.default.isEmpty(requests);
    }, _ramda2.default.always(_react2.default.createElement(
      'div',
      { style: { margin: '20px' } },
      'We did not find any other ' + text
    ))], [function () {
      return apiCallStatus === 'success';
    }, _ramda2.default.always(_react2.default.createElement(
      'div',
      { style: { margin: '20px' } },
      selectedIds.length,
      ' ',
      (0, _pluralize2.default)('requests', selectedIds.length),
      ' ',
      (0, _pluralize2.default)('have', selectedIds.length),
      ' been archived.'
    ))], [function () {
      return apiCallStatus === 'error';
    }, _ramda2.default.always(_react2.default.createElement(
      'div',
      { style: { margin: '20px' } },
      'There has been an error, please try again.'
    ))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { style: { margin: '20px' } },
        'We found the following ' + text + '.  Please select which requests you would like to discard.'
      ),
      _react2.default.createElement(_materialUi.Checkbox, {
        style: { paddingBottom: '8px', borderBottom: '1px solid #e0e0e0' },
        label: 'Select All',
        checked: selectedIds.length === requests.length,
        onCheck: function onCheck(_, checked) {
          return onClickSelectAll(checked);
        }
      }),
      requests.map(function (contract, ix) {
        return _react2.default.createElement(
          'div',
          { key: ix, style: { display: 'flex', alignItems: 'center', borderBottom: '1px solid #e0e0e0', padding: '8px 0' } },
          _react2.default.createElement(_materialUi.Checkbox, {
            style: { width: '48px' },
            checked: _ramda2.default.contains(contract._id, selectedIds),
            onCheck: function onCheck(_, checked) {
              return _onCheck(contract._id, checked);
            }
          }),
          _react2.default.createElement(
            'div',
            { style: { width: '70%' } },
            _react2.default.createElement(
              'div',
              null,
              contract.companyName
            ),
            _react2.default.createElement(
              'small',
              null,
              contract.email
            )
          ),
          _react2.default.createElement(
            'small',
            null,
            'last updated: ',
            (0, _moment2.default)(contract.updatedAt).format('DD MMM YYYY')
          )
        );
      })
    ))]]))
  );
};

RequestsWithSameNameOrDomain.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting;

  return _extends({}, contracting.requestsWithSameNameOrDomainDialog);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  onRequestClose: function onRequestClose() {
    return { type: 'CLOSE_DIALOG_SHOW_REQUESTS_WITH_SAME_NAME' };
  },
  onCheck: function onCheck(id, checked) {
    return { type: 'ON_CHECK_IN_REQUESTS_WITH_SAME_NAME_DIALOG', payload: { id: id, checked: checked } };
  },
  discardSelected: function discardSelected() {
    return { type: 'DISCARD_SELECTED_IN_REQUESTS_WITH_SAME_NAME_DIALOG' };
  },
  onClickSelectAll: function onClickSelectAll(checked) {
    return { type: 'ON_SELECT_ALL_IN_REQUESTS_WITH_SAME_NAME_DIALOG', payload: { checked: checked } };
  }
})(RequestsWithSameNameOrDomain);

/***/ }),
/* 3221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ramda = __webpack_require__(2);

var R = _interopRequireWildcard(_ramda);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RequestDL = function (_Component) {
  _inherits(RequestDL, _Component);

  function RequestDL() {
    _classCallCheck(this, RequestDL);

    var _this = _possibleConstructorReturn(this, (RequestDL.__proto__ || Object.getPrototypeOf(RequestDL)).call(this));

    _this.onCheckAgree = function (_, checked) {
      return _this.setState({ iagree: checked });
    };

    _this.onCheck = function (setting) {
      return function () {
        return _this.props.checkSetting(setting);
      };
    };

    _this.onCheckPriority = function (priority) {
      return function () {
        return _this.props.checkPriority(priority);
      };
    };

    _this.onMsgChange = function (e) {
      return _this.props.enterMsg(e.target.value);
    };

    _this.state = {
      iagree: false
    };
    return _this;
  }

  _createClass(RequestDL, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          open = _props.open,
          priority = _props.priority,
          rateConversionSetting = _props.rateConversionSetting,
          closeDialog = _props.closeDialog,
          files = _props.files,
          loading = _props.loading,
          success = _props.success,
          doRequestDL = _props.doRequestDL,
          messageForDL = _props.messageForDL;

      var disableSubmit = !this.state.iagree || !rateConversionSetting || loading;
      var submitIcon = loading ? _react2.default.createElement(_materialUi.CircularProgress, { size: 25, tickness: 2 }) : undefined;
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          open: open,
          title: _react2.default.createElement(
            'div',
            { style: { backgroundColor: '#00BCD4', color: 'white', fontSize: '18px', padding: '16px 2%' } },
            'Submit this workspace for data loading'
          ),
          bodyStyle: { padding: '32px' },
          onRequestClose: closeDialog,
          autoScrollBodyContent: true,
          actions: success ? _react2.default.createElement(_materialUi.FlatButton, {
            label: 'dismiss',
            secondary: true,
            onClick: closeDialog
          }) : [_react2.default.createElement(_materialUi.FlatButton, {
            key: 'cancel',
            label: 'cancel',
            primary: true,
            onClick: closeDialog
          }), _react2.default.createElement(_materialUi.FlatButton, {
            key: 'submit',
            label: 'submit',
            disabled: disableSubmit,
            secondary: true,
            onClick: doRequestDL,
            icon: submitIcon
          })]
        },
        function () {
          if (success) {
            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { style: { margin: '1em 0', textAlign: 'center' } },
                _react2.default.createElement(
                  'div',
                  null,
                  'We have sent your request to our Data Loading team!'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null),
                _react2.default.createElement('img', { src: __webpack_require__(1535), width: 80 })
              )
            );
          }
          if (!(files && files.length)) {
            return _react2.default.createElement(
              'div',
              null,
              'We didn\'t find any files in this contract, please upload the files you received from the supplier.'
            );
          }
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'flex-start' } },
              _react2.default.createElement(_materialUi.FontIcon, {
                className: 'tc-icon-warning2',
                color: '#ff4081'
              }),
              '\xA0\xA0',
              _react2.default.createElement(
                'div',
                { className: 'flex-center' },
                'TourConnect\'s data conversion wait times are approximately 2-4 weeks. If you need this contract urgently, we would recommend to cancel this request and manually convert these rates yourself.'
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { margin: '2em 0' } },
              _react2.default.createElement(
                'div',
                { className: 'flex-tc-sb', style: { width: '450px' } },
                _react2.default.createElement(_materialUi.RadioButton, {
                  label: 'Convert & Require Supplier Signature',
                  checked: rateConversionSetting === 'opt-in',
                  onCheck: _this2.onCheck('opt-in')
                }),
                _react2.default.createElement(
                  'div',
                  {
                    'aria-label': 'TourConnect will convert all rates received into the TourConnect format, then require the supplier to review, sign, and submit the rates to you. NOTE: You will always have access to the original rates submitted.',
                    className: 'hint--bottom hint--large'
                  },
                  _react2.default.createElement(_materialUi.FontIcon, {
                    className: 'tc-icon-help_outline'
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'flex-tc-sb', style: { width: '450px', marginBottom: '24px' } },
                _react2.default.createElement(_materialUi.RadioButton, {
                  label: 'Convert & Do Not Require Supplier Signature',
                  checked: rateConversionSetting === 'opt-out',
                  onCheck: _this2.onCheck('opt-out')
                }),
                _react2.default.createElement(
                  'div',
                  {
                    'aria-label': 'TourConnect will convert all rates received into the TourConnect format, and you will be notified when this is complete. The supplier will not be required to review, sign, and submit the converted rates to you. NOTE: You will always have access to the original rates submitted.',
                    className: 'hint--bottom hint--large'
                  },
                  _react2.default.createElement(_materialUi.FontIcon, {
                    className: 'tc-icon-help_outline'
                  })
                )
              ),
              _react2.default.createElement(
                'label',
                null,
                'What is the priority of this request?'
              ),
              _react2.default.createElement(
                'div',
                { style: { marginBottom: '24px' } },
                ['Highest', 'High', 'Medium', 'Low', 'Lowest'].map(function (str) {
                  return _react2.default.createElement(_materialUi.RadioButton, {
                    key: str,
                    label: str,
                    checked: priority === str,
                    onCheck: _this2.onCheckPriority(str)
                  });
                })
              ),
              _react2.default.createElement(
                'label',
                null,
                'Optional Note/Instructions'
              ),
              _react2.default.createElement(
                'div',
                {
                  style: {
                    padding: '8px 12px',
                    overflow: 'auto',
                    minHeight: '80px',
                    border: '1px solid #00BCD4',
                    margin: '12px 0'
                  }
                },
                _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-email', color: '#bfbfbf', style: { top: '12px' } }),
                _react2.default.createElement(_materialUi.TextField, {
                  id: 'commentBoxTextField',
                  hintStyle: { fontSize: '14px' },
                  underlineShow: false,
                  defaultValue: messageForDL,
                  onChange: _this2.onMsgChange,
                  style: { float: 'right', width: '85%', marginRight: '5%' },
                  multiLine: true,
                  rowsMax: 5
                })
              )
            ),
            _react2.default.createElement(_materialUi.Checkbox, {
              label: 'I understand that TourConnect is not responsible for any rates or rate-related data, including errors or omissions, whether submitted directly to you by the supplier or submitted via the TourConnect team after conversion to the TourConnect format.',
              checked: _this2.state.iagree,
              onCheck: _this2.onCheckAgree
            })
          );
        }()
      );
    }
  }]);

  return RequestDL;
}(_react.Component);

RequestDL.propTypes = {
  open: _react.PropTypes.bool,
  rateConversionSetting: _react.PropTypes.string,
  priority: _react.PropTypes.string,
  messageForDL: _react.PropTypes.string,
  closeDialog: _react.PropTypes.func,
  files: _react.PropTypes.array,
  loading: _react.PropTypes.bool,
  success: _react.PropTypes.bool,
  doRequestDL: _react.PropTypes.func,
  checkSetting: _react.PropTypes.func,
  enterMsg: _react.PropTypes.func,
  checkPriority: _react.PropTypes.func
};

var mapState = function mapState(_ref) {
  var contracting = _ref.contracting;

  var defaultFiles = contracting.contractActivitiesProducts.getIn(['rightSideContent', 'files']);
  return _extends({}, contracting.requestDL, {
    files: defaultFiles && defaultFiles.toJS() || R.path(['requestDL', 'files'], contracting)
  });
};

var mapAction = {
  closeDialog: function closeDialog() {
    return { type: 'CLOSE_REQUEST_RATE_LOADING_DIALOG' };
  },
  checkSetting: function checkSetting(setting) {
    return { type: 'CHECK_RATE_LOADING_SETTING', payload: { setting: setting } };
  },
  enterMsg: function enterMsg(str) {
    return { type: 'ENTER_MESSAGE_FOR_DL_IN_REQUEST_DIALOG', payload: str };
  },
  checkPriority: function checkPriority(priority) {
    return { type: 'CHECK_RATE_LOADING_PRIORITY', payload: { priority: priority } };
  },
  doRequestDL: function doRequestDL() {
    return { type: 'REQUEST_DL' };
  }
};

exports.default = (0, _reactRedux.connect)(mapState, mapAction)(RequestDL);

/***/ }),
/* 3222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _arrowDropDown = __webpack_require__(559);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _flatDropDownMenu = __webpack_require__(494);

var _flatDropDownMenu2 = _interopRequireDefault(_flatDropDownMenu);

var _datePicker = __webpack_require__(1003);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var convertToYY = function convertToYY(_ref) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate;
  return startDate && endDate ? _moment2.default.utc(startDate).format('D MMM YYYY') + ' - ' + _moment2.default.utc(endDate).format('D MMM YYYY') : '';
};
var propTypes = {
  outerDivStyle: _react.PropTypes.object,
  arrayOfYears: _react.PropTypes.array,
  onDropdownChange: _react.PropTypes.func,
  selectedYearRange: _react.PropTypes.string,
  showAllPeriods: _react.PropTypes.bool,
  selectAllPeriods: _react.PropTypes.func,
  currentPeriod: _react.PropTypes.object
};

var YearDropdown = function (_Component) {
  _inherits(YearDropdown, _Component);

  function YearDropdown(props) {
    _classCallCheck(this, YearDropdown);

    var _this = _possibleConstructorReturn(this, (YearDropdown.__proto__ || Object.getPrototypeOf(YearDropdown)).call(this, props));

    _this.togglePopover = function (open) {
      return function (e) {
        _this.setState({ open: open, anchorEl: e ? e.currentTarget : null });
      };
    };

    _this.state = {
      open: false,
      allPeriodsChecked: false,
      fromDate: props.currentPeriod.startDate,
      toDate: props.currentPeriod.endDate
    };
    return _this;
  }

  _createClass(YearDropdown, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(this.props.currentPeriod && this.props.currentPeriod.startDate) && nextProps.currentPeriod.startDate) {
        this.setState({
          allPeriodsChecked: nextProps.selectedYearRange === 'All Periods',
          fromDate: nextProps.currentPeriod.startDate,
          toDate: nextProps.currentPeriod.endDate
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          arrayOfYears = _props.arrayOfYears,
          outerDivStyle = _props.outerDivStyle,
          selectedYearRange = _props.selectedYearRange,
          onDropdownChange = _props.onDropdownChange,
          showAllPeriods = _props.showAllPeriods,
          selectAllPeriods = _props.selectAllPeriods;
      var _state = this.state,
          allPeriodsChecked = _state.allPeriodsChecked,
          fromDate = _state.fromDate,
          toDate = _state.toDate;

      return _react2.default.createElement(
        'div',
        { style: outerDivStyle },
        _react2.default.createElement(_materialUi.FlatButton, {
          label: selectedYearRange,
          labelPosition: 'before',
          onTouchTap: this.togglePopover(true),
          icon: _react2.default.createElement(_arrowDropDown2.default, { style: { fill: 'white' } }),
          style: { borderRadius: '4px' },
          labelStyle: { textTransform: 'none', color: 'white', fontSize: '18px' }
        }),
        _react2.default.createElement(
          _materialUi.Popover,
          {
            open: this.state.open,
            onRequestClose: this.togglePopover(false),
            anchorEl: this.state.anchorEl,
            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
            targetOrigin: { horizontal: 'left', vertical: 'top' }
          },
          _react2.default.createElement(
            'div',
            { style: { padding: '24px 0 8px 24px' } },
            showAllPeriods ? _react2.default.createElement(_materialUi.Toggle, {
              label: 'All Periods',
              toggled: allPeriodsChecked,
              onToggle: function onToggle(_, val) {
                return _this2.setState({ allPeriodsChecked: val });
              },
              style: { width: '150px' }
            }) : undefined,
            _react2.default.createElement(_datePicker2.default, {
              'data-cy': 'fromDate',
              disabled: showAllPeriods && allPeriodsChecked,
              containerStyle: { display: 'inline-block', verticalAlign: 'top' },
              textFieldStyle: { width: '100%' },
              onChange: function onChange(date) {
                return _this2.setState({ fromDate: date });
              },
              value: fromDate,
              initialMonth: fromDate || toDate,
              floatingLabelText: 'From Date',
              closeOnSelect: true
            }),
            _react2.default.createElement(_datePicker2.default, {
              'data-cy': 'toDate',
              disabled: showAllPeriods && allPeriodsChecked,
              containerStyle: { display: 'inline-block', marginLeft: '24px', verticalAlign: 'top' },
              textFieldStyle: { width: '100%' },
              onChange: function onChange(date) {
                return _this2.setState({ toDate: date });
              },
              value: toDate,
              enableFrom: fromDate,
              initialMonth: toDate || fromDate,
              floatingLabelText: 'To Date',
              closeOnSelect: true
            })
          ),
          _react2.default.createElement(
            'div',
            { style: { margin: '0 0 12px 12px' } },
            _react2.default.createElement(_materialUi.FlatButton, {
              label: 'Apply',
              secondary: true,
              onTouchTap: function onTouchTap() {
                if (allPeriodsChecked) selectAllPeriods();else onDropdownChange({ startDate: fromDate, endDate: toDate });
                _this2.setState({ open: false });
              }
            })
          )
        )
      );
    }
  }]);

  return YearDropdown;
}(_react.Component);

YearDropdown.propTypes = propTypes;

exports.default = YearDropdown;

/***/ }),
/* 3223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Caption = __webpack_require__(3224);

var _Caption2 = _interopRequireDefault(_Caption);

var _Navbar = __webpack_require__(1955);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Month = __webpack_require__(3228);

var _Month2 = _interopRequireDefault(_Month);

var _Day = __webpack_require__(3230);

var _Day2 = _interopRequireDefault(_Day);

var _Weekday = __webpack_require__(1956);

var _Weekday2 = _interopRequireDefault(_Weekday);

var _Helpers = __webpack_require__(1537);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(1136);

var DateUtils = _interopRequireWildcard(_DateUtils);

var _LocaleUtils = __webpack_require__(1538);

var LocaleUtils = _interopRequireWildcard(_LocaleUtils);

var _ModifiersUtils = __webpack_require__(1957);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _classNames = __webpack_require__(1536);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(3231);

var _keys2 = _interopRequireDefault(_keys);

var _PropTypes = __webpack_require__(878);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    /* istanbul ignore next */
    // for the ignore above see: https://github.com/gotwarlost/istanbul/issues/690

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _initialiseProps.call(_this);

    _this.renderDayInMonth = _this.renderDayInMonth.bind(_this);
    _this.showNextMonth = _this.showNextMonth.bind(_this);
    _this.showPreviousMonth = _this.showPreviousMonth.bind(_this);

    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleDayClick = _this.handleDayClick.bind(_this);
    _this.handleDayKeyDown = _this.handleDayKeyDown.bind(_this);

    _this.state = _this.getStateFromProps(props);
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.month !== nextProps.month) {
        this.setState(this.getStateFromProps(nextProps));
      }
    }
  }, {
    key: 'getDayNodes',
    value: function getDayNodes() {
      var outsideClassName = void 0;
      if (this.props.classNames === _classNames2.default) {
        // When using CSS modules prefix the modifier as required by the BEM syntax
        outsideClassName = this.props.classNames.day + '--' + this.props.classNames.outside;
      } else {
        outsideClassName = '' + this.props.classNames.outside;
      }
      var dayQuery = this.props.classNames.day.replace(/ /g, '.');
      var outsideDayQuery = outsideClassName.replace(/ /g, '.');
      var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
      return this.dayPicker.querySelectorAll(selector);
    }
  }, {
    key: 'getNextNavigableMonth',
    value: function getNextNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
    }
  }, {
    key: 'getPreviousNavigableMonth',
    value: function getPreviousNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, -1);
    }
  }, {
    key: 'allowPreviousMonth',
    value: function allowPreviousMonth() {
      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -1);
      return this.allowMonth(previousMonth);
    }
  }, {
    key: 'allowNextMonth',
    value: function allowNextMonth() {
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
      return this.allowMonth(nextMonth);
    }
  }, {
    key: 'allowMonth',
    value: function allowMonth(d) {
      var _props = this.props,
          fromMonth = _props.fromMonth,
          toMonth = _props.toMonth,
          canChangeMonth = _props.canChangeMonth;

      if (!canChangeMonth || fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
        return false;
      }
      return true;
    }
  }, {
    key: 'allowYearChange',
    value: function allowYearChange() {
      return this.props.canChangeMonth;
    }
  }, {
    key: 'showMonth',
    value: function showMonth(d, callback) {
      var _this2 = this;

      if (!this.allowMonth(d)) {
        return;
      }
      this.setState({ currentMonth: Helpers.startOfMonth(d) }, function () {
        if (callback) {
          callback();
        }
        if (_this2.props.onMonthChange) {
          _this2.props.onMonthChange(_this2.state.currentMonth);
        }
      });
    }
  }, {
    key: 'showNextMonth',
    value: function showNextMonth(callback) {
      if (!this.allowNextMonth()) {
        return;
      }
      var deltaMonths = this.props.pagedNavigation ? this.props.numberOfMonths : 1;
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, deltaMonths);
      this.showMonth(nextMonth, callback);
    }
  }, {
    key: 'showPreviousMonth',
    value: function showPreviousMonth(callback) {
      if (!this.allowPreviousMonth()) {
        return;
      }
      var deltaMonths = this.props.pagedNavigation ? this.props.numberOfMonths : 1;
      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -deltaMonths);
      this.showMonth(previousMonth, callback);
    }
  }, {
    key: 'showNextYear',
    value: function showNextYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, 12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'showPreviousYear',
    value: function showPreviousYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, -12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'focusFirstDayOfMonth',
    value: function focusFirstDayOfMonth() {
      this.getDayNodes()[0].focus();
    }
  }, {
    key: 'focusLastDayOfMonth',
    value: function focusLastDayOfMonth() {
      var dayNodes = this.getDayNodes();
      dayNodes[dayNodes.length - 1].focus();
    }
  }, {
    key: 'focusPreviousDay',
    value: function focusPreviousDay(dayNode) {
      var _this3 = this;

      var dayNodes = this.getDayNodes();
      var dayNodeIndex = [].concat(_toConsumableArray(dayNodes)).indexOf(dayNode);

      if (dayNodeIndex === 0) {
        this.showPreviousMonth(function () {
          return _this3.focusLastDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex - 1].focus();
      }
    }
  }, {
    key: 'focusNextDay',
    value: function focusNextDay(dayNode) {
      var _this4 = this;

      var dayNodes = this.getDayNodes();
      var dayNodeIndex = [].concat(_toConsumableArray(dayNodes)).indexOf(dayNode);

      if (dayNodeIndex === dayNodes.length - 1) {
        this.showNextMonth(function () {
          return _this4.focusFirstDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex + 1].focus();
      }
    }
  }, {
    key: 'focusNextWeek',
    value: function focusNextWeek(dayNode) {
      var _this5 = this;

      var dayNodes = this.getDayNodes();
      var dayNodeIndex = [].concat(_toConsumableArray(dayNodes)).indexOf(dayNode);
      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;

      if (isInLastWeekOfMonth) {
        this.showNextMonth(function () {
          var daysAfterIndex = dayNodes.length - dayNodeIndex;
          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
          _this5.getDayNodes()[nextMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex + 7].focus();
      }
    }
  }, {
    key: 'focusPreviousWeek',
    value: function focusPreviousWeek(dayNode) {
      var _this6 = this;

      var dayNodes = this.getDayNodes();
      var dayNodeIndex = [].concat(_toConsumableArray(dayNodes)).indexOf(dayNode);
      var isInFirstWeekOfMonth = dayNodeIndex <= 6;

      if (isInFirstWeekOfMonth) {
        this.showPreviousMonth(function () {
          var previousMonthDayNodes = _this6.getDayNodes();
          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex - 7].focus();
      }
    }

    // Event handlers

  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      e.persist();

      switch (e.keyCode) {
        case _keys2.default.LEFT:
          this.showPreviousMonth();
          break;
        case _keys2.default.RIGHT:
          this.showNextMonth();
          break;
        case _keys2.default.UP:
          this.showPreviousYear();
          break;
        case _keys2.default.DOWN:
          this.showNextYear();
          break;
        default:
          break;
      }

      if (this.props.onKeyDown) {
        this.props.onKeyDown(e);
      }
    }
  }, {
    key: 'handleDayKeyDown',
    value: function handleDayKeyDown(day, modifiers, e) {
      e.persist();
      switch (e.keyCode) {
        case _keys2.default.LEFT:
          Helpers.cancelEvent(e);
          this.focusPreviousDay(e.target);
          break;
        case _keys2.default.RIGHT:
          Helpers.cancelEvent(e);
          this.focusNextDay(e.target);
          break;
        case _keys2.default.UP:
          Helpers.cancelEvent(e);
          this.focusPreviousWeek(e.target);
          break;
        case _keys2.default.DOWN:
          Helpers.cancelEvent(e);
          this.focusNextWeek(e.target);
          break;
        case _keys2.default.ENTER:
        case _keys2.default.SPACE:
          Helpers.cancelEvent(e);
          if (this.props.onDayClick) {
            this.handleDayClick(day, modifiers, e);
          }
          break;
        default:
          break;
      }
      if (this.props.onDayKeyDown) {
        this.props.onDayKeyDown(day, modifiers, e);
      }
    }
  }, {
    key: 'handleDayClick',
    value: function handleDayClick(day, modifiers, e) {
      e.persist();
      if (modifiers.outside) {
        this.handleOutsideDayClick(day);
      }
      this.props.onDayClick(day, modifiers, e);
    }
  }, {
    key: 'handleOutsideDayClick',
    value: function handleOutsideDayClick(day) {
      var currentMonth = this.state.currentMonth;
      var numberOfMonths = this.props.numberOfMonths;

      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
        this.showNextMonth();
      } else if (diffInMonths < 0) {
        this.showPreviousMonth();
      }
    }
  }, {
    key: 'renderNavbar',
    value: function renderNavbar() {
      var _props2 = this.props,
          labels = _props2.labels,
          locale = _props2.locale,
          localeUtils = _props2.localeUtils,
          canChangeMonth = _props2.canChangeMonth,
          navbarElement = _props2.navbarElement,
          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);

      if (!canChangeMonth) return null;

      var props = {
        classNames: this.props.classNames,
        className: this.props.classNames.navBar,
        nextMonth: this.getNextNavigableMonth(),
        previousMonth: this.getPreviousNavigableMonth(),
        showPreviousButton: this.allowPreviousMonth(),
        showNextButton: this.allowNextMonth(),
        onNextClick: this.showNextMonth,
        onPreviousClick: this.showPreviousMonth,
        dir: attributes.dir,
        labels: labels,
        locale: locale,
        localeUtils: localeUtils
      };
      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
    }
  }, {
    key: 'renderDayInMonth',
    value: function renderDayInMonth(day, month) {
      var propModifiers = Helpers.getModifiersFromProps(this.props);
      var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
      if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, this.props.classNames.today)) {
        dayModifiers.push(this.props.classNames.today);
      }
      if (day.getMonth() !== month.getMonth()) {
        dayModifiers.push(this.props.classNames.outside);
      }

      var isOutside = day.getMonth() !== month.getMonth();
      var tabIndex = null;
      if (this.props.onDayClick && !isOutside) {
        tabIndex = -1;
        // Focus on the first day of the month
        if (day.getDate() === 1) {
          tabIndex = this.props.tabIndex;
        }
      }
      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
      var modifiers = {};
      dayModifiers.forEach(function (modifier) {
        modifiers[modifier] = true;
      });

      return _react2.default.createElement(
        _Day2.default,
        {
          key: '' + (isOutside ? 'outside-' : '') + key,
          classNames: this.props.classNames,
          day: day,
          modifiers: modifiers,
          modifiersStyles: this.props.modifiersStyles,
          empty: isOutside && !this.props.enableOutsideDays && !this.props.fixedWeeks,
          tabIndex: tabIndex,
          ariaLabel: this.props.localeUtils.formatDay(day, this.props.locale),
          ariaDisabled: isOutside || dayModifiers.indexOf('disabled') > -1,
          ariaSelected: dayModifiers.indexOf('selected') > -1,
          onMouseEnter: this.props.onDayMouseEnter,
          onMouseLeave: this.props.onDayMouseLeave,
          onKeyDown: this.handleDayKeyDown,
          onTouchStart: this.props.onDayTouchStart,
          onTouchEnd: this.props.onDayTouchEnd,
          onFocus: this.props.onDayFocus,
          onClick: this.props.onDayClick ? this.handleDayClick : undefined
        },
        this.props.renderDay(day, modifiers)
      );
    }
  }, {
    key: 'renderMonths',
    value: function renderMonths() {
      var months = [];
      var firstDayOfWeek = Helpers.getFirstDayOfWeekFromProps(this.props);

      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
        var month = DateUtils.addMonths(this.state.currentMonth, i);

        months.push(_react2.default.createElement(
          _Month2.default,
          {
            key: i,
            classNames: this.props.classNames,
            month: month,
            months: this.props.months,
            weekdayElement: this.props.weekdayElement,
            captionElement: this.props.captionElement,
            fixedWeeks: this.props.fixedWeeks,
            weekdaysShort: this.props.weekdaysShort,
            weekdaysLong: this.props.weekdaysLong,
            locale: this.props.locale,
            localeUtils: this.props.localeUtils,
            firstDayOfWeek: firstDayOfWeek,
            footer: this.props.todayButton && this.renderTodayButton(),
            showWeekNumbers: this.props.showWeekNumbers,
            onCaptionClick: this.props.onCaptionClick,
            onWeekClick: this.props.onWeekClick
          },
          this.renderDayInMonth
        ));
      }

      if (this.props.reverseMonths) {
        months.reverse();
      }
      return months;
    }
  }, {
    key: 'renderTodayButton',
    value: function renderTodayButton() {
      return _react2.default.createElement(
        'button',
        {
          tabIndex: 0,
          className: this.props.classNames.todayButton,
          'aria-label': this.props.todayButton,
          onClick: this.handleTodayButtonClick
        },
        this.props.todayButton
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var className = this.props.classNames.container;

      if (!this.props.onDayClick) {
        className = className + ' ' + this.props.classNames.interactionDisabled;
      }
      if (this.props.className) {
        className = className + ' ' + this.props.className;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, this.props.containerProps, {
          className: className,
          ref: function ref(el) {
            _this7.dayPicker = el;
          },
          role: 'application',
          lang: this.props.locale,
          tabIndex: this.props.canChangeMonth && this.props.tabIndex,
          onKeyDown: this.handleKeyDown,
          onFocus: this.props.onFocus,
          onBlur: this.props.onBlur
        }),
        this.renderNavbar(),
        this.renderMonths()
      );
    }
  }]);

  return DayPicker;
}(_react.Component);

DayPicker.VERSION = '5.5.3';
DayPicker.propTypes = {
  // Rendering months
  initialMonth: _PropTypes2.default.instanceOf(Date),
  month: _PropTypes2.default.instanceOf(Date),
  numberOfMonths: _PropTypes2.default.number,
  fromMonth: _PropTypes2.default.instanceOf(Date),
  toMonth: _PropTypes2.default.instanceOf(Date),
  canChangeMonth: _PropTypes2.default.bool,
  reverseMonths: _PropTypes2.default.bool,
  pagedNavigation: _PropTypes2.default.bool,
  todayButton: _PropTypes2.default.string,
  showWeekNumbers: _PropTypes2.default.bool,

  // Modifiers
  selectedDays: _PropTypes2.default.oneOfType([_PropTypes.ModifierPropType, _PropTypes2.default.arrayOf(_PropTypes.ModifierPropType)]),
  disabledDays: _PropTypes2.default.oneOfType([_PropTypes.ModifierPropType, _PropTypes2.default.arrayOf(_PropTypes.ModifierPropType)]),

  modifiers: _PropTypes2.default.object,
  modifiersStyles: _PropTypes2.default.object,

  // Localization
  dir: _PropTypes2.default.string,
  firstDayOfWeek: _PropTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
  labels: _PropTypes2.default.shape({
    nextMonth: _PropTypes2.default.string.isRequired,
    previousMonth: _PropTypes2.default.string.isRequired
  }).isRequired,
  locale: _PropTypes2.default.string,
  localeUtils: _PropTypes2.default.localeUtils,
  months: _PropTypes2.default.arrayOf(_PropTypes2.default.string),
  weekdaysLong: _PropTypes2.default.arrayOf(_PropTypes2.default.string),
  weekdaysShort: _PropTypes2.default.arrayOf(_PropTypes2.default.string),

  // Customization
  enableOutsideDays: _PropTypes2.default.bool,
  fixedWeeks: _PropTypes2.default.bool,

  // CSS and HTML
  classNames: _PropTypes2.default.shape({
    body: _PropTypes2.default.string,
    container: _PropTypes2.default.string,
    day: _PropTypes2.default.string.isRequired,
    disabled: _PropTypes2.default.string.isRequired,
    footer: _PropTypes2.default.string,
    interactionDisabled: _PropTypes2.default.string,
    month: _PropTypes2.default.string,
    navBar: _PropTypes2.default.string,
    outside: _PropTypes2.default.string.isRequired,
    selected: _PropTypes2.default.string.isRequired,
    today: _PropTypes2.default.string.isRequired,
    todayButton: _PropTypes2.default.string,
    week: _PropTypes2.default.string
  }),
  className: _PropTypes2.default.string,
  containerProps: _PropTypes2.default.object,
  tabIndex: _PropTypes2.default.number,

  // Custom elements
  renderDay: _PropTypes2.default.func,
  weekdayElement: _PropTypes2.default.oneOfType([_PropTypes2.default.element, _PropTypes2.default.func, _PropTypes2.default.instanceOf(_react.Component)]),
  navbarElement: _PropTypes2.default.oneOfType([_PropTypes2.default.element, _PropTypes2.default.func, _PropTypes2.default.instanceOf(_react.Component)]),
  captionElement: _PropTypes2.default.oneOfType([_PropTypes2.default.element, _PropTypes2.default.func, _PropTypes2.default.instanceOf(_react.Component)]),

  // Events
  onBlur: _PropTypes2.default.func,
  onFocus: _PropTypes2.default.func,
  onKeyDown: _PropTypes2.default.func,
  onDayClick: _PropTypes2.default.func,
  onDayKeyDown: _PropTypes2.default.func,
  onDayMouseEnter: _PropTypes2.default.func,
  onDayMouseLeave: _PropTypes2.default.func,
  onDayTouchStart: _PropTypes2.default.func,
  onDayTouchEnd: _PropTypes2.default.func,
  onDayFocus: _PropTypes2.default.func,
  onMonthChange: _PropTypes2.default.func,
  onCaptionClick: _PropTypes2.default.func,
  onWeekClick: _PropTypes2.default.func
};
DayPicker.defaultProps = {
  classNames: _classNames2.default,
  tabIndex: 0,
  initialMonth: new Date(),
  numberOfMonths: 1,
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  locale: 'en',
  localeUtils: LocaleUtils,
  enableOutsideDays: false,
  fixedWeeks: false,
  canChangeMonth: true,
  reverseMonths: false,
  pagedNavigation: false,
  showWeekNumbers: false,
  renderDay: function renderDay(day) {
    return day.getDate();
  },
  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
};

var _initialiseProps = function _initialiseProps() {
  var _this8 = this;

  this.getStateFromProps = function (props) {
    var initialMonth = Helpers.startOfMonth(props.month || props.initialMonth);
    var currentMonth = initialMonth;

    if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
      var diffInMonths = Helpers.getMonthsDiff(props.fromMonth, currentMonth);
      currentMonth = DateUtils.addMonths(props.fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
    }
    return { currentMonth: currentMonth };
  };

  this.dayPicker = null;

  this.handleTodayButtonClick = function (e) {
    _this8.showMonth(new Date());
    e.target.blur();
  };
};

exports.default = DayPicker;
//# sourceMappingURL=DayPicker.js.map

/***/ }),
/* 3224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Caption;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(878);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Caption(_ref) {
  var classNames = _ref.classNames,
      date = _ref.date,
      months = _ref.months,
      locale = _ref.locale,
      localeUtils = _ref.localeUtils,
      onClick = _ref.onClick;

  return _react2.default.createElement(
    'div',
    { className: classNames.caption, onClick: onClick, role: 'heading' },
    months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)
  );
}

Caption.propTypes = {
  date: _PropTypes2.default.instanceOf(Date),
  months: _PropTypes2.default.arrayOf(_PropTypes2.default.string),
  locale: _PropTypes2.default.string,
  localeUtils: _PropTypes2.default.localeUtils,
  onClick: _PropTypes2.default.func,
  classNames: _PropTypes2.default.shape({
    caption: _PropTypes2.default.string.isRequired
  }).isRequired
};
//# sourceMappingURL=Caption.js.map

/***/ }),
/* 3225 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(3226)();
}


/***/ }),
/* 3226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(3227);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 3227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 3228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Month;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(878);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Weekdays = __webpack_require__(3229);

var _Weekdays2 = _interopRequireDefault(_Weekdays);

var _Helpers = __webpack_require__(1537);

var _DateUtils = __webpack_require__(1136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Month(_ref) {
  var classNames = _ref.classNames,
      month = _ref.month,
      months = _ref.months,
      fixedWeeks = _ref.fixedWeeks,
      captionElement = _ref.captionElement,
      weekdayElement = _ref.weekdayElement,
      locale = _ref.locale,
      localeUtils = _ref.localeUtils,
      weekdaysLong = _ref.weekdaysLong,
      weekdaysShort = _ref.weekdaysShort,
      firstDayOfWeek = _ref.firstDayOfWeek,
      onCaptionClick = _ref.onCaptionClick,
      children = _ref.children,
      footer = _ref.footer,
      showWeekNumbers = _ref.showWeekNumbers,
      onWeekClick = _ref.onWeekClick;

  var captionProps = {
    date: month,
    classNames: classNames,
    months: months,
    localeUtils: localeUtils,
    locale: locale,
    onClick: onCaptionClick ? function (e) {
      return onCaptionClick(month, e);
    } : undefined
  };
  var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);

  var weeks = (0, _Helpers.getWeekArray)(month, firstDayOfWeek, fixedWeeks);

  return _react2.default.createElement(
    'div',
    { className: classNames.month, role: 'grid' },
    caption,
    _react2.default.createElement(_Weekdays2.default, {
      classNames: classNames,
      weekdaysShort: weekdaysShort,
      weekdaysLong: weekdaysLong,
      firstDayOfWeek: firstDayOfWeek,
      showWeekNumbers: showWeekNumbers,
      locale: locale,
      localeUtils: localeUtils,
      weekdayElement: weekdayElement
    }),
    _react2.default.createElement(
      'div',
      { className: classNames.body, role: 'rowgroup' },
      weeks.map(function (week) {
        var weekNumber = void 0;
        if (showWeekNumbers) {
          weekNumber = (0, _DateUtils.getWeekNumber)(week[0]);
        }
        return _react2.default.createElement(
          'div',
          { key: week[0].getTime(), className: classNames.week, role: 'row' },
          showWeekNumbers && _react2.default.createElement(
            'div',
            {
              className: classNames.weekNumber,
              tabIndex: 0,
              role: 'gridcell',
              onClick: function onClick(e) {
                return onWeekClick(weekNumber, week, e);
              }
            },
            weekNumber
          ),
          week.map(function (day) {
            return children(day, month);
          })
        );
      })
    ),
    footer && _react2.default.createElement(
      'div',
      { className: classNames.footer },
      footer
    )
  );
}

Month.propTypes = {
  classNames: _PropTypes2.default.shape({
    month: _PropTypes2.default.string.isRequired,
    body: _PropTypes2.default.string.isRequired,
    week: _PropTypes2.default.string.isRequired
  }).isRequired,

  month: _PropTypes2.default.instanceOf(Date).isRequired,
  months: _PropTypes2.default.arrayOf(_PropTypes2.default.string),

  fixedWeeks: _PropTypes2.default.bool,
  captionElement: _PropTypes2.default.oneOfType([_PropTypes2.default.element, _PropTypes2.default.func, _PropTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
  weekdayElement: _PropTypes2.default.oneOfType([_PropTypes2.default.element, _PropTypes2.default.func, _PropTypes2.default.instanceOf(_react2.default.Component)]),

  footer: _PropTypes2.default.node,
  showWeekNumbers: _PropTypes2.default.bool,
  onWeekClick: _PropTypes2.default.func,

  locale: _PropTypes2.default.string.isRequired,
  localeUtils: _PropTypes2.default.localeUtils.isRequired,
  weekdaysLong: _PropTypes2.default.arrayOf(_PropTypes2.default.string),
  weekdaysShort: _PropTypes2.default.arrayOf(_PropTypes2.default.string),
  firstDayOfWeek: _PropTypes2.default.number.isRequired,

  onCaptionClick: _PropTypes2.default.func,

  children: _PropTypes2.default.func.isRequired
};
//# sourceMappingURL=Month.js.map

/***/ }),
/* 3229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Weekdays;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(878);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Weekdays(_ref) {
  var classNames = _ref.classNames,
      firstDayOfWeek = _ref.firstDayOfWeek,
      showWeekNumbers = _ref.showWeekNumbers,
      weekdaysLong = _ref.weekdaysLong,
      weekdaysShort = _ref.weekdaysShort,
      locale = _ref.locale,
      localeUtils = _ref.localeUtils,
      weekdayElement = _ref.weekdayElement;

  var days = [];
  for (var i = 0; i < 7; i += 1) {
    var weekday = (i + firstDayOfWeek) % 7;
    var elementProps = {
      key: i,
      className: classNames.weekday,
      weekday: weekday,
      weekdaysLong: weekdaysLong,
      weekdaysShort: weekdaysShort,
      localeUtils: localeUtils,
      locale: locale
    };
    var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
    days.push(element);
  }

  return _react2.default.createElement(
    'div',
    { className: classNames.weekdays, role: 'rowgroup' },
    _react2.default.createElement(
      'div',
      { className: classNames.weekdaysRow, role: 'row' },
      showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }),
      days
    )
  );
}

Weekdays.propTypes = {
  classNames: _PropTypes2.default.shape({
    weekday: _PropTypes2.default.string.isRequired,
    weekdays: _PropTypes2.default.string.isRequired,
    weekdaysRow: _PropTypes2.default.string.isRequired
  }).isRequired,

  firstDayOfWeek: _PropTypes2.default.number.isRequired,
  weekdaysLong: _PropTypes2.default.arrayOf(_PropTypes2.default.string),
  weekdaysShort: _PropTypes2.default.arrayOf(_PropTypes2.default.string),
  showWeekNumbers: _PropTypes2.default.bool,
  locale: _PropTypes2.default.string.isRequired,
  localeUtils: _PropTypes2.default.localeUtils.isRequired,
  weekdayElement: _PropTypes2.default.oneOfType([_PropTypes2.default.element, _PropTypes2.default.func, _PropTypes2.default.instanceOf(_react2.default.Component)])
};
//# sourceMappingURL=Weekdays.js.map

/***/ }),
/* 3230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Day;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classNames = __webpack_require__(1536);

var _classNames2 = _interopRequireDefault(_classNames);

var _PropTypes = __webpack_require__(878);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }
  return function (e) {
    e.persist();
    handler(day, modifiers, e);
  };
} /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */

function Day(_ref) {
  var classNames = _ref.classNames,
      modifiersStyles = _ref.modifiersStyles,
      day = _ref.day,
      tabIndex = _ref.tabIndex,
      empty = _ref.empty,
      modifiers = _ref.modifiers,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      onTouchStart = _ref.onTouchStart,
      onTouchEnd = _ref.onTouchEnd,
      onFocus = _ref.onFocus,
      ariaLabel = _ref.ariaLabel,
      ariaDisabled = _ref.ariaDisabled,
      ariaSelected = _ref.ariaSelected,
      children = _ref.children;

  var className = classNames.day;
  if (classNames !== _classNames2.default) {
    // When using CSS modules prefix the modifier as required by the BEM syntax
    className += ' ' + Object.keys(modifiers).join(' ');
  } else {
    className += Object.keys(modifiers).map(function (modifier) {
      return ' ' + className + '--' + modifier;
    }).join('');
  }

  var style = void 0;
  if (modifiersStyles) {
    Object.keys(modifiers).filter(function (modifier) {
      return !!modifiersStyles[modifier];
    }).forEach(function (modifier) {
      style = Object.assign({}, style, modifiersStyles[modifier]);
    });
  }

  if (empty) {
    return _react2.default.createElement('div', { role: 'gridcell', 'aria-disabled': true, className: className, style: style });
  }

  return _react2.default.createElement(
    'div',
    {
      className: className,
      tabIndex: tabIndex || 0,
      style: style,
      role: 'gridcell',
      'aria-label': ariaLabel,
      'aria-disabled': ariaDisabled.toString(),
      'aria-selected': ariaSelected.toString(),
      onClick: handleEvent(onClick, day, modifiers),
      onKeyDown: handleEvent(onKeyDown, day, modifiers),
      onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
      onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
      onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
      onTouchStart: handleEvent(onTouchStart, day, modifiers),
      onFocus: handleEvent(onFocus, day, modifiers)
    },
    children
  );
}

Day.propTypes = {
  classNames: _PropTypes2.default.shape({
    day: _PropTypes2.default.string.isRequired
  }).isRequired,

  day: _PropTypes2.default.instanceOf(Date).isRequired,
  children: _PropTypes2.default.node.isRequired,

  ariaDisabled: _PropTypes2.default.bool,
  ariaLabel: _PropTypes2.default.string,
  ariaSelected: _PropTypes2.default.bool,
  empty: _PropTypes2.default.bool,
  modifiers: _PropTypes2.default.object,
  modifiersStyles: _PropTypes2.default.object,
  onClick: _PropTypes2.default.func,
  onKeyDown: _PropTypes2.default.func,
  onMouseEnter: _PropTypes2.default.func,
  onMouseLeave: _PropTypes2.default.func,
  onTouchEnd: _PropTypes2.default.func,
  onTouchStart: _PropTypes2.default.func,
  onFocus: _PropTypes2.default.func,
  tabIndex: _PropTypes2.default.number
};

Day.defaultProps = {
  modifiers: {},
  empty: false
};
//# sourceMappingURL=Day.js.map

/***/ }),
/* 3231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ENTER: 13,
  SPACE: 32,
  ESC: 27
};
//# sourceMappingURL=keys.js.map

/***/ }),
/* 3232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotFound = function (_Component) {
  _inherits(NotFound, _Component);

  function NotFound() {
    _classCallCheck(this, NotFound);

    return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
  }

  _createClass(NotFound, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'l-app-content',
          style: { textAlign: 'center' }
        },
        _react2.default.createElement(
          'h1',
          null,
          '404'
        ),
        _react2.default.createElement(
          'h2',
          null,
          'The page you requested is not found.'
        ),
        _react2.default.createElement(
          'h4',
          null,
          'You may have mistyped the address or the page may have moved!'
        )
      );
    }
  }]);

  return NotFound;
}(_react.Component);

exports.default = NotFound;

/***/ }),
/* 3233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractingCardIntro = function ContractingCardIntro(props) {
  var goStartNewContract = props.goStartNewContract,
      user = props.user;

  var userType = user.user.type;

  var contractorBlurb = _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'p',
      { style: { fontSize: '16px', marginBottom: '3%', color: 'rgba(0, 0, 0, 0.54)' } },
      'You need rates and a few other details from your suppliers, so you have everything you need to book their products. We use contracts to hold all of this information.'
    ),
    _react2.default.createElement(
      'p',
      { style: { fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)' } },
      'Use TourConnect to request your supplier rates. Once you\'ve requested rates from your partners, you can:'
    ),
    _react2.default.createElement(
      'ul',
      { style: { fontSize: '16px', padding: '3% 5% 5% 5%' } },
      _react2.default.createElement(
        'li',
        { style: { fontSize: '16px' } },
        'Review, comment, and accept rates provided via TourConnect contracts'
      ),
      _react2.default.createElement(
        'li',
        { style: { fontSize: '16px' } },
        'Store and manage rates sent in other formats (spreadsheet, pdf, word document, etc.)'
      ),
      _react2.default.createElement(
        'li',
        { style: { fontSize: '16px' } },
        'Automatically load rates into your booking system using our API'
      )
    )
  );

  var supplierBlurb = _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'p',
      { style: { fontSize: '16px', marginBottom: '3%', color: 'rgba(0, 0, 0, 0.54)' } },
      'In order for your partners to sell your products, they need your rates and a few other details. We use contracts to hold all of this information.'
    ),
    _react2.default.createElement(
      'p',
      { style: { fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)' } },
      'Use TourConnect to send these contracts to your partners. Once you\'ve finished your first contract, you can:'
    ),
    _react2.default.createElement(
      'ul',
      { style: { fontSize: '16px', padding: '3% 5% 5% 5%' } },
      _react2.default.createElement(
        'li',
        { style: { fontSize: '16px' } },
        'Save your rates and details to use at a later time'
      ),
      _react2.default.createElement(
        'li',
        { style: { fontSize: '16px' } },
        'Send your rates to anyone in the world'
      )
    )
  );
  var flatButtonLabel = userType === 'Supplier' ? 'Start a New Contract' : 'Request Supplier Rates';

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _materialUi.Paper,
      { style: { width: '50%', margin: 'auto', position: 'relative', clear: 'both', overflow: 'hidden' } },
      _react2.default.createElement(
        'div',
        { style: { position: 'relative', backgroundColor: '#00bcd4', color: '#fff', padding: '18px', paddingTop: '25%' } },
        _react2.default.createElement(
          'span',
          { style: { position: 'relative', fontSize: '22px' } },
          'Exchange rates with your partners'
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { padding: '3%' } },
        userType === 'Supplier' ? supplierBlurb : contractorBlurb,
        _react2.default.createElement(_materialUi.FlatButton, {
          label: flatButtonLabel,
          onTouchTap: goStartNewContract,
          secondary: true,
          style: { float: 'right', display: 'block', position: 'relative', marginBottom: '2%' }
        })
      )
    )
  );
};

ContractingCardIntro.propTypes = {
  goStartNewContract: _react.PropTypes.func,
  user: _react.PropTypes.object
};

exports.default = ContractingCardIntro;

/***/ }),
/* 3234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(1958);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SupplierWizardContainer = function (_Component) {
  _inherits(SupplierWizardContainer, _Component);

  function SupplierWizardContainer() {
    _classCallCheck(this, SupplierWizardContainer);

    return _possibleConstructorReturn(this, (SupplierWizardContainer.__proto__ || Object.getPrototypeOf(SupplierWizardContainer)).apply(this, arguments));
  }

  _createClass(SupplierWizardContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getLocations();
      this.props.getTemplates();
      if (this.props.params.contractId) this.props.getContractRequestInfo(this.props.params.contractId);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearStore();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          extraProps = _objectWithoutProperties(_props, ['children']);

      var allProps = _extends({
        router: this.context.router
      }, extraProps);
      return _react2.default.createElement(
        'div',
        { style: { width: '100%', maxWidth: '1000px', margin: 'auto' } },
        children ? (0, _react.cloneElement)(children, allProps) : undefined
      );
    }
  }]);

  return SupplierWizardContainer;
}(_react.Component);

SupplierWizardContainer.propTypes = {
  children: _react.PropTypes.object,
  params: _react.PropTypes.object,
  updateProps: _react.PropTypes.func,
  getTemplates: _react.PropTypes.func,
  getLocations: _react.PropTypes.func,
  clearStore: _react.PropTypes.func,
  sendContracts: _react.PropTypes.func,
  getContractRequestInfo: _react.PropTypes.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProps: function updateProps(payload) {
      return dispatch((0, _actions.updateProps)(payload));
    },
    clearStore: function clearStore() {
      return dispatch((0, _actions.clearStore)());
    },
    getTemplates: function getTemplates() {
      return dispatch((0, _actions.getTemplates)());
    },
    getLocations: function getLocations() {
      return dispatch((0, _actions.getLocations)());
    },
    getContractRequestInfo: function getContractRequestInfo() {
      return dispatch(_actions.getContractRequestInfo.apply(undefined, arguments));
    }
  };
};
var mapStateToProps = function mapStateToProps() {
  return {};
};

SupplierWizardContainer.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SupplierWizardContainer);

/***/ }),
/* 3235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _profileImage = __webpack_require__(548);

var _profileImage2 = _interopRequireDefault(_profileImage);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _rightSideContent = __webpack_require__(3236);

var _rightSideContent2 = _interopRequireDefault(_rightSideContent);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _partnerNode = __webpack_require__(1055);

var _partnerNode2 = _interopRequireDefault(_partnerNode);

var _actionButtons = __webpack_require__(3251);

var _actionButtons2 = _interopRequireDefault(_actionButtons);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  contractRequest: _react.PropTypes.object,
  updateProps: _react.PropTypes.func,
  sendContracts: _react.PropTypes.func,
  message: _react.PropTypes.string,
  subject: _react.PropTypes.string,
  templates: _react.PropTypes.array,
  drafts: _react.PropTypes.array,
  templateSelected: _react.PropTypes.object,
  templateGroupSelected: _react.PropTypes.object,
  contractsSent: _react.PropTypes.bool,
  bccSelf: _react.PropTypes.bool,
  assignTag: _react.PropTypes.bool,
  assignFolder: _react.PropTypes.bool,
  tags: _react.PropTypes.array,
  folders: _react.PropTypes.array,
  sendingContracts: _react.PropTypes.bool,
  showReviewAndSendForResponseWizard: _react.PropTypes.bool,
  isSingleLoc: _react.PropTypes.bool,
  loadedTemplates: _react.PropTypes.bool
};

var overLapDates = function overLapDates(contractRequest) {
  return _ramda2.default.anyPass([function (obj) {
    return obj.startDate <= contractRequest.endDate && obj.startDate >= contractRequest.startDate;
  }, function (obj) {
    return obj.endDate <= contractRequest.endDate && obj.endDate >= contractRequest.startDate;
  }, function (obj) {
    return obj.startDate < contractRequest.startDate && obj.endDate > contractRequest.endDate;
  }]);
};

var ContractRequest = function (_React$Component) {
  _inherits(ContractRequest, _React$Component);

  function ContractRequest() {
    _classCallCheck(this, ContractRequest);

    return _possibleConstructorReturn(this, (ContractRequest.__proto__ || Object.getPrototypeOf(ContractRequest)).apply(this, arguments));
  }

  _createClass(ContractRequest, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          loadedLocations = _props.loadedLocations,
          locations = _props.locations,
          loadedTemplates = _props.loadedTemplates,
          templates = _props.templates,
          getL = _props.getLocations,
          getT = _props.getTemplates;

      if (!(loadedLocations || locations.length)) getL();
      if (!(loadedTemplates || templates.length)) getT();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.contractRequest && nextProps.contractRequest.startDate && nextProps.contractRequest.endDate && nextProps.templates && nextProps.templates.length && _ramda2.default.find(overLapDates(nextProps.contractRequest), nextProps.templates || [])) {
        window.location = "https://app.tourconnect.com" + '/partner-management/send-assets?' + _queryString2.default.stringify({
          partnerids: [nextProps.contractRequest.partners[0].id],
          contactids: [nextProps.contractRequest.contacts[0].id],
          go_back_to: window.location.protocol + '//' + window.location.host + '/contracting/contract-list/recent',
          open_asset_type: 'rates'
        }) + '&jwt=' + localStorage.getItem('jwt');
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          contractRequest = _props2.contractRequest,
          loadedTemplates = _props2.loadedTemplates,
          templates = _props2.templates,
          drafts = _props2.drafts;
      // TODO: make the contract request view more intuitive for supplier.
      // Before then, we will just route user to send assets wizard.

      var foundMatchedTemplate = _ramda2.default.find(overLapDates(contractRequest), templates || []);
      if (!(contractRequest && contractRequest.contentLoaded) || !(loadedTemplates || templates.length) || foundMatchedTemplate) {
        return _react2.default.createElement(_loadingOverlay2.default, { loading: true, text: 'Thank you for your patience.\nWe are checking if you have available templates for this request.' });
      }
      var foundMatchedDrafts = _ramda2.default.filter(_ramda2.default.allPass([function (draft) {
        return draft.originFrom !== 'edited';
      }, overLapDates(contractRequest)]), drafts || []);
      var respondedContractLength = _ramda2.default.pathOr(0, ['respondedContractList', 'length'], contractRequest);
      var divStyleSwitch = { backgroundColor: '#eeeeee', width: '30%', padding: '2%', paddingBottom: '48px', minHeight: '500px' };
      return _react2.default.createElement(
        _materialUi.Paper,
        { style: { width: '100%', margin: 'auto auto 64px auto', display: 'flex', flexDirection: 'column' } },
        _react2.default.createElement(
          'div',
          { style: { backgroundColor: '#00bcd4', color: '#fff', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'space-between' } },
          _react2.default.createElement(
            'h4',
            { style: { width: '50%', color: '#FFFFFF', fontWeight: '500', paddingRight: '32px', textAlign: 'right' } },
            'Contract Request'
          ),
          _react2.default.createElement(_flatButtonWithLoader2.default, {
            icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-arrow_back', color: 'white' }),
            label: 'back',
            labelPosition: 'after',
            style: { color: 'white' },
            onTouchTap: function onTouchTap() {
              return _this2.context.router.goBack();
            }
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex' } },
          _react2.default.createElement(
            'div',
            { style: divStyleSwitch },
            _react2.default.createElement(_materialUi.ListItem, {
              disabled: true,
              leftAvatar: _react2.default.createElement(_profileImage2.default, {
                className: 'profile-link-image connections-profile-link-image',
                companySlugName: _ramda2.default.path(['from', 'name'], contractRequest),
                imageUrl: _ramda2.default.path(['from', 'avatar'], contractRequest),
                style: { marginLeft: '-3%' }
              }),
              style: { paddingBottom: '12%', fontWeight: '500' },
              primaryText: _ramda2.default.path(['from', 'name'], contractRequest),
              secondaryText: _ramda2.default.path(['from', 'email'], contractRequest)
            }),
            _react2.default.createElement(_partnerNode2.default, {
              partners: contractRequest.partners,
              contacts: contractRequest.contacts
            }),
            _react2.default.createElement('hr', { style: { marginTop: '1%' } }),
            _react2.default.createElement(
              'b',
              null,
              'This request was prepared for:'
            ),
            _react2.default.createElement('br', null),
            (contractRequest.to || {}).name,
            _react2.default.createElement('hr', { style: { marginTop: '18px' } }),
            _react2.default.createElement(
              'div',
              { style: { padding: '2%', minHeight: '150px' } },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  { style: { fontWeight: 'bold', color: '#757575' } },
                  'Contracting Period'
                ),
                _react2.default.createElement(
                  'p',
                  { style: { color: '#616161' } },
                  _moment2.default.utc((contractRequest || {}).startDate).format('DD MMM YYYY'),
                  '-',
                  _moment2.default.utc((contractRequest || {}).endDate).format('DD MMM YYYY')
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  { style: { fontWeight: 'bold', color: '#757575' } },
                  'Submission Criteria'
                ),
                _ramda2.default.pathOr('', ['buyerInfo', 'submissionCriteria'], contractRequest) ? _react2.default.createElement(
                  'p',
                  { style: { color: '#616161', maxHeight: '300px', overflowY: 'scroll' } },
                  _ramda2.default.pathOr('', ['buyerInfo', 'submissionCriteria'], contractRequest)
                ) : _react2.default.createElement(
                  'p',
                  { style: { color: '#616161' } },
                  'N/A'
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  { style: { fontWeight: 'bold', color: '#757575' } },
                  'Terms & Conditions'
                ),
                _ramda2.default.pathOr('', ['buyerInfo', 'termsAndConditions'], contractRequest) ? _react2.default.createElement(
                  'p',
                  { style: { color: '#616161', maxHeight: '300px', overflowY: 'scroll' } },
                  _ramda2.default.pathOr('', ['buyerInfo', 'termsAndConditions'], contractRequest)
                ) : _react2.default.createElement(
                  'p',
                  { style: { color: '#616161' } },
                  'N/A'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { width: '70%', display: 'inline-block', height: '100%' } },
            _react2.default.createElement(
              'div',
              { style: { color: '#616161', fontSize: '14px', padding: '16px 32px' } },
              _react2.default.createElement(
                'b',
                null,
                'No templates found for ',
                _moment2.default.utc((contractRequest || {}).startDate).format('DD MMM YYYY'),
                '-',
                _moment2.default.utc((contractRequest || {}).endDate).format('DD MMM YYYY'),
                '.  Please create a new template below.'
              ),
              _react2.default.createElement(
                'div',
                { style: { marginTop: '16px', fontSize: '12px' } },
                'NOTE: You can import rates from an existing template on the next step.'
              )
            ),
            _react2.default.createElement(_rightSideContent2.default, _extends({}, this.props, {
              router: this.context.router,
              foundMatchedTemplate: foundMatchedTemplate,
              foundMatchedDrafts: foundMatchedDrafts
            })),
            Boolean(foundMatchedTemplate) && _react2.default.createElement(_actionButtons2.default, _extends({}, this.props, {
              router: this.context.router
            }))
          )
        )
      );
    }
  }]);

  return ContractRequest;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user;

  return _extends({}, contracting.supplierWizard.toJS(), {
    drafts: contracting.templateList.get('drafts').toJS(),
    isSingleLoc: user.get('allLocations').length < 2
  });
};

ContractRequest.propTypes = propTypes;
ContractRequest.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ContractRequest);

/***/ }),
/* 3236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _formWithButtons = __webpack_require__(1959);

var _formWithButtons2 = _interopRequireDefault(_formWithButtons);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var contractRequest = _ref.contractRequest,
      isSingleLoc = _ref.isSingleLoc,
      router = _ref.router,
      foundMatchedTemplate = _ref.foundMatchedTemplate,
      foundMatchedDrafts = _ref.foundMatchedDrafts;

  if (!foundMatchedTemplate) {
    if (foundMatchedDrafts && foundMatchedDrafts.length) {
      return _react2.default.createElement(
        'div',
        { style: { border: '1px solid #e0e0e0', margin: '0 32px 32px', padding: '8px 16px' } },
        'We have found below unfinished drafts for this contracting period:',
        foundMatchedDrafts.map(function (draft, ix) {
          return _react2.default.createElement(_materialUi.ListItem, {
            key: ix,
            disabled: true,
            primaryText: draft.templateName,
            secondaryText: !isSingleLoc && draft.locationName,
            rightAvatar: _react2.default.createElement(_materialUi.FlatButton, { secondary: true, label: 'Continue Loading Rates', onTouchTap: function onTouchTap() {
                return router.push('/contracting/draft/' + draft.originalContractId + '/details');
              } })
          });
        })
      );
    }
    return _react2.default.createElement(
      'div',
      { style: { border: '1px solid #e0e0e0', margin: '0 32px 32px', padding: '8px 16px' } },
      _react2.default.createElement(_formWithButtons2.default, {
        prefillData: {
          startDate: contractRequest.startDate,
          endDate: contractRequest.endDate,
          buyerName: contractRequest.buyerName
        }
      })
    );
  }
};

/***/ }),
/* 3237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _locationContactInfoForm = __webpack_require__(3238);

var _locationContactInfoForm2 = _interopRequireDefault(_locationContactInfoForm);

var _AddItemCard = __webpack_require__(1245);

var _AddItemCard2 = _interopRequireDefault(_AddItemCard);

var _immutable = __webpack_require__(26);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(250); // FOR STORYBOOK

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var propTypes = {
  updateProps: _react.PropTypes.func,
  checkLocation: _react.PropTypes.func,
  checkAllLocations: _react.PropTypes.func,
  checkProduct: _react.PropTypes.func,
  isSingleLoc: _react.PropTypes.bool,
  hasAccessToCreateLoc: _react.PropTypes.bool,
  style: _react.PropTypes.object,
  locations: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    locationId: _react.PropTypes.string,
    name: _react.PropTypes.string,
    contactInfoComplete: _react.PropTypes.bool,
    contactInfo: _react.PropTypes.shape({
      address: _react.PropTypes.shape({
        postal_code: _react.PropTypes.string,
        country: _react.PropTypes.string,
        address_1: _react.PropTypes.string,
        address_2: _react.PropTypes.string,
        city: _react.PropTypes.string,
        state: _react.PropTypes.string
      }),
      phone: _react.PropTypes.string,
      firstName: _react.PropTypes.string,
      lastName: _react.PropTypes.string
    }),
    products: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      productId: _react.PropTypes.string,
      name: _react.PropTypes.string,
      checked: _react.PropTypes.bool
    })),
    access: _react.PropTypes.arrayOf(_react.PropTypes.string),
    checked: _react.PropTypes.bool
  })).isRequired
};

var SelectLocationsProducts = function (_Component) {
  _inherits(SelectLocationsProducts, _Component);

  function SelectLocationsProducts(props) {
    _classCallCheck(this, SelectLocationsProducts);

    var _this = _possibleConstructorReturn(this, (SelectLocationsProducts.__proto__ || Object.getPrototypeOf(SelectLocationsProducts)).call(this, props));

    _this.toToggleShowTF = function () {
      return _this.setState({ showCreateLocTF: !_this.state.showCreateLocTF });
    };

    _this.state = {
      showCreateLocTF: props.locations.length === 1
    };
    return _this;
  }

  _createClass(SelectLocationsProducts, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          updateProps = _props.updateProps,
          checkLocation = _props.checkLocation,
          checkAllLocations = _props.checkAllLocations,
          checkProduct = _props.checkProduct,
          isSingleLoc = _props.isSingleLoc,
          hasAccessToCreateLoc = _props.hasAccessToCreateLoc,
          style = _props.style,
          locations = _props.locations;


      var containerStyle = _extends({
        borderRadius: '2px',
        border: '1px solid #e0e0e0'
      }, style);
      var selectedLocs = _ramda2.default.filter(_ramda2.default.both(_ramda2.default.propEq('checked', true), function (loc) {
        return loc.name;
      }), locations || []);
      var allChecked = _ramda2.default.all(_ramda2.default.either(_ramda2.default.propEq('checked', true), function (loc) {
        return !loc.name;
      }))(locations || []);

      var updateLocationProps = _ramda2.default.curry(function (locationIndex, updater) {
        var immutableNewLocs = (0, _immutable.fromJS)(locations).update(locationIndex, function (location) {
          return location.merge((0, _immutable.fromJS)(updater));
        });
        updateProps({ locations: immutableNewLocs });
      });

      if (isSingleLoc) {
        if (_ramda2.default.path([0, 'contactInfoComplete'], locations)) return _react2.default.createElement('div', null);
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_locationContactInfoForm2.default, {
            contactInfo: _ramda2.default.pathOr({}, [0, 'contactInfo'], locations),
            updateLocationProps: updateLocationProps(0),
            isSingleLoc: true
          })
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Please select the properties/locations you would like to create templates for:'
          )
        ),
        ' ',
        _react2.default.createElement(
          'span',
          { style: { color: 'red' } },
          '* Required'
        ),
        _react2.default.createElement(
          'div',
          { style: containerStyle },
          locations && locations.length > 1 ? _react2.default.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center' } },
            _react2.default.createElement(_materialUi.Checkbox, {
              label: 'Select All',
              checked: allChecked,
              disabled: locations.some(function (loc) {
                return loc.locationId && !_ramda2.default.contains('write', loc.access || []);
              }),
              style: { marginTop: '8px', fontWeight: 'bold', width: '50%' },
              onCheck: function onCheck() {
                return checkAllLocations(!allChecked);
              }
            }),
            _react2.default.createElement(
              'span',
              null,
              selectedLocs.length,
              ' property(s)/location(s) selected'
            )
          ) : _react2.default.createElement('span', null),
          locations.map(function (location, locationIndex) {
            var numProductsChecked = location.products ? location.products.filter(_ramda2.default.prop('checked')).length : 0;
            if (location.locationId) {
              return _react2.default.createElement(
                _materialUi.Card,
                {
                  key: location.locationId,
                  style: { boxShadow: '0' }
                },
                _react2.default.createElement(
                  _materialUi.CardHeader,
                  {
                    actAsExpander: true,
                    showExpandableButton: !isNilOrEmpty(location.products),
                    style: { fontWeight: 'normal', padding: '8px 8px 8px 16px', height: '48px' }
                  },
                  _react2.default.createElement(_materialUi.Checkbox, {
                    label: _react2.default.createElement(
                      'div',
                      { style: { display: 'flex', justifyContent: 'space-between' } },
                      location.name,
                      !isNilOrEmpty(location.products) && _react2.default.createElement(
                        'small',
                        null,
                        numProductsChecked + ' ' + (0, _pluralize2.default)('products', numProductsChecked) + ' selected'
                      )
                    ),
                    disabled: !_ramda2.default.contains('write', location.access),
                    checked: location.checked,
                    labelStyle: { textOverflow: 'ellipsis', overflowX: 'hidden', whiteSpace: 'nowrap' },
                    style: { bottom: '16px', width: '80%' },
                    onCheck: function onCheck() {
                      return checkLocation(locationIndex, !location.checked);
                    }
                  })
                ),
                !isNilOrEmpty(location.products) && _react2.default.createElement(
                  _materialUi.CardText,
                  { expandable: true, style: { paddingLeft: '52px', marginBottom: '12px', padding: '8px 8px 8px 16px' } },
                  location.products.map(function (product, productIndex) {
                    return _react2.default.createElement(_materialUi.Checkbox, { key: productIndex, label: product.name, checked: product.checked, onCheck: function onCheck() {
                        return checkProduct(locationIndex, productIndex, !product.checked);
                      } });
                  })
                ),
                location.checked && !location.contactInfoComplete && _react2.default.createElement(_locationContactInfoForm2.default, {
                  updateLocationProps: updateLocationProps(locationIndex),
                  contactInfo: _ramda2.default.propOr({}, 'contactInfo', location),
                  isSingleLoc: isSingleLoc
                })
              );
            }
            if (!hasAccessToCreateLoc) return _react2.default.createElement('div', { key: locationIndex });
            if (!_this2.state.showCreateLocTF) {
              return _react2.default.createElement(
                'div',
                {
                  key: locationIndex,
                  style: { margin: '12px 0 18px 18px' },
                  className: 'add-item-card-flex',
                  onClick: _this2.toToggleShowTF
                },
                _react2.default.createElement(
                  'div',
                  { style: { border: '1px dashed #00bcd4', height: '20px', width: '20px', display: 'inline-block' } },
                  _react2.default.createElement(_materialUi.FontIcon, { style: { verticalAlign: 'middle', color: '#00bcd4', fontSize: '18px', marginTop: '-5px' }, className: 'tc-icon-add' })
                ),
                _react2.default.createElement(
                  'span',
                  { style: { marginLeft: '18px', color: '#00bcd4', display: 'inline-block', verticalAlign: 'middle' } },
                  'Create a new property/location'
                )
              );
            }
            var duplicateLocName = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.any(_ramda2.default.compose(_ramda2.default.lt(1), _ramda2.default.length)), _ramda2.default.values, _ramda2.default.groupBy(_ramda2.default.prop('name'))), locations);
            return _react2.default.createElement(
              'div',
              {
                key: 'newlocName' + locationIndex
              },
              _react2.default.createElement(
                'div',
                {
                  style: { fontWeight: 'normal', padding: '8px 8px 8px 16px', height: '48px', display: 'flex', alignItems: 'center' }
                },
                _react2.default.createElement(_materialUi.Checkbox, {
                  checked: Boolean(location.name) || locations.length === 1,
                  disabled: !Boolean(location.name),
                  style: { width: '44px' },
                  onCheck: function onCheck() {
                    updateLocationProps(locationIndex, { name: '', products: [] });
                  }
                }),
                _react2.default.createElement(_materialUi.TextField, {
                  id: 'newlocName' + locationIndex,
                  defaultValue: location.name,
                  hintText: 'Enter a new name here...',
                  errorText: duplicateLocName ? 'Duplicate with another property/location' : '',
                  onChange: function onChange(_, val) {
                    updateLocationProps(locationIndex, { name: val, checked: Boolean(val) });
                  }
                })
              ),
              _react2.default.createElement(_locationContactInfoForm2.default, {
                style: { display: !location.contactInfoComplete && location.name ? 'block' : 'none' },
                updateLocationProps: updateLocationProps(locationIndex),
                contactInfo: _ramda2.default.propOr({}, 'contactInfo', location),
                isSingleLoc: isSingleLoc
              })
            );
          })
        )
      );
    }
  }]);

  return SelectLocationsProducts;
}(_react.Component);

SelectLocationsProducts.propTypes = propTypes;

exports.default = SelectLocationsProducts;

/***/ }),
/* 3238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactPlacesAutocomplete = __webpack_require__(3239);

var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var updateLocationProps = _ref.updateLocationProps,
      contactInfo = _ref.contactInfo,
      style = _ref.style,
      isSingleLoc = _ref.isSingleLoc;

  return _react2.default.createElement(
    'div',
    { style: _extends({}, { padding: '4px 8px 8px', backgroundColor: '#efefef' }, style) },
    _react2.default.createElement(
      'small',
      { style: { marginBottom: '6px', display: 'block' } },
      'You only need to enter below information once for ',
      _ramda2.default.call(_ramda2.default.cond([[function () {
        return isSingleLoc;
      }, _ramda2.default.always('your business')], [_ramda2.default.T, _ramda2.default.always('this property/location')]])),
      ', and you can update it later by going to the ',
      _react2.default.createElement(
        'b',
        null,
        'Profile'
      ),
      '.'
    ),
    _react2.default.createElement(
      'label',
      { style: { display: 'block' } },
      'Primary Contact: ',
      _react2.default.createElement(
        'small',
        { style: { color: 'red' } },
        '* All fields required'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'flex-tc-sb' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'small',
          null,
          'First Name'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('input', { style: { width: '100%' }, value: contactInfo.firstName || '', onChange: function onChange(e) {
            return updateLocationProps({ contactInfo: _extends({}, contactInfo, { firstName: e.target.value }) });
          } }),
        _react2.default.createElement('br', null)
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'small',
          null,
          'Last Name'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('input', { style: { width: '100%' }, value: contactInfo.lastName || '', onChange: function onChange(e) {
            return updateLocationProps({ contactInfo: _extends({}, contactInfo, { lastName: e.target.value }) });
          } }),
        _react2.default.createElement('br', null)
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'small',
          null,
          'Phone'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('input', { style: { width: '100%' }, value: contactInfo.phone || '', onChange: function onChange(e) {
            return updateLocationProps({ contactInfo: _extends({}, contactInfo, { phone: e.target.value }) });
          } }),
        _react2.default.createElement('br', null)
      )
    ),
    _react2.default.createElement(
      'label',
      null,
      'Address'
    ),
    _react2.default.createElement(
      'small',
      { style: { color: 'red' } },
      '* Required'
    ),
    _react2.default.createElement(_reactPlacesAutocomplete2.default, {
      onSelect: function onSelect(address, placeId) {
        (0, _reactPlacesAutocomplete.geocodeByPlaceId)(placeId).then(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 1),
              results = _ref3[0];

          var addressToReturn = {};
          if (results) {
            addressToReturn.address_1 = results.formatted_address.split(',')[0];
            addressToReturn.formattedAddress = results.formatted_address;
            var coordinates = [results.geometry.location.lng(), results.geometry.location.lat()];
            addressToReturn.coordinates = coordinates;
            addressToReturn.loc = { coordinates: coordinates };
            results.address_components.forEach(function (component) {
              if (_ramda2.default.contains('locality', component.types)) addressToReturn.city = component.long_name;
              if (_ramda2.default.contains('administrative_area_level_1', component.types)) addressToReturn.state = component.long_name;
              if (_ramda2.default.contains('postal_code', component.types)) addressToReturn.postal_code = component.long_name;
              if (_ramda2.default.contains('country', component.types)) addressToReturn.country = component.long_name;
            });
          }
          updateLocationProps({
            contactInfo: _extends({}, contactInfo, {
              address: addressToReturn
            })
          });
        });
      },
      onEnterKeyDown: function onEnterKeyDown(address) {
        return updateLocationProps({ contactInfo: _ramda2.default.merge(contactInfo, { address: address }) });
      },
      autocompleteItem: function autocompleteItem(_ref4) {
        var formattedSuggestion = _ref4.formattedSuggestion;
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'strong',
            null,
            formattedSuggestion.mainText
          ),
          ' ',
          _react2.default.createElement(
            'small',
            null,
            formattedSuggestion.secondaryText
          )
        );
      },
      styles: {
        root: { width: '100%' },
        input: {
          padding: '0'
        },
        googleLogoContainer: { boxShadow: '0 2px 4px rgba(0,0,0,0.2)' },
        autocompleteContainer: {
          position: 'none',
          height: '200px',
          width: '100%',
          zIndex: '14000 !important',
          border: '1px solid #e6e6e6',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
          borderRadius: '0 0 2px 2px'
        }
      },
      inputProps: {
        type: 'text',
        value: _ramda2.default.pathOr('', ['address', 'formattedAddress'], contactInfo) || _ramda2.default.pathOr('', ['address', 'address_1'], contactInfo),
        onChange: function onChange(addressTyped) {
          updateLocationProps({
            contactInfo: _extends({}, contactInfo, {
              address: _ramda2.default.merge(contactInfo.address || {}, { formattedAddress: addressTyped, address_1: addressTyped })
            })
          });
        },
        autoFocus: true
      }
    })
  );
};

/***/ }),
/* 3239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLatLng = exports.geocodeByPlaceId = exports.geocodeByAddress = undefined;

var _PlacesAutocomplete = __webpack_require__(3240);

var _PlacesAutocomplete2 = _interopRequireDefault(_PlacesAutocomplete);

var _utils = __webpack_require__(3249);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.geocodeByAddress = _utils.geocodeByAddress;
exports.geocodeByPlaceId = _utils.geocodeByPlaceId;
exports.getLatLng = _utils.getLatLng;
exports.default = _PlacesAutocomplete2.default;

/***/ }),
/* 3240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3241);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(3244);

var _lodash2 = _interopRequireDefault(_lodash);

var _defaultStyles = __webpack_require__(3245);

var _defaultStyles2 = _interopRequireDefault(_defaultStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Copyright (c) 2017 Ken Hibino.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Licensed under the MIT License (MIT).
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * See https://kenny-hibino.github.io/react-places-autocomplete
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var PlacesAutocomplete = function (_Component) {
  _inherits(PlacesAutocomplete, _Component);

  function PlacesAutocomplete(props) {
    _classCallCheck(this, PlacesAutocomplete);

    var _this = _possibleConstructorReturn(this, (PlacesAutocomplete.__proto__ || Object.getPrototypeOf(PlacesAutocomplete)).call(this, props));

    _this.state = { autocompleteItems: [] };

    _this.autocompleteCallback = _this.autocompleteCallback.bind(_this);
    _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.debouncedFetchPredictions = (0, _lodash2.default)(_this.fetchPredictions, _this.props.debounce);
    return _this;
  }

  _createClass(PlacesAutocomplete, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!window.google) {
        throw new Error('Google Maps JavaScript API library must be loaded. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library');
      }

      if (!window.google.maps.places) {
        throw new Error('Google Maps Places library must be loaded. Please add `libraries=places` to the src URL. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library');
      }

      this.autocompleteService = new google.maps.places.AutocompleteService();
      this.autocompleteOK = google.maps.places.PlacesServiceStatus.OK;
    }
  }, {
    key: 'autocompleteCallback',
    value: function autocompleteCallback(predictions, status) {
      if (status != this.autocompleteOK) {
        this.props.onError(status);
        if (this.props.clearItemsOnError) {
          this.clearAutocomplete();
        }
        return;
      }

      // transform snake_case to camelCase
      var formattedSuggestion = function formattedSuggestion(structured_formatting) {
        return {
          mainText: structured_formatting.main_text,
          secondaryText: structured_formatting.secondary_text
        };
      };

      var highlightFirstSuggestion = this.props.highlightFirstSuggestion;


      this.setState({
        autocompleteItems: predictions.map(function (p, idx) {
          return {
            suggestion: p.description,
            placeId: p.place_id,
            active: highlightFirstSuggestion && idx === 0 ? true : false,
            index: idx,
            formattedSuggestion: formattedSuggestion(p.structured_formatting)
          };
        })
      });
    }
  }, {
    key: 'fetchPredictions',
    value: function fetchPredictions() {
      var value = this.props.inputProps.value;

      if (value.length) {
        this.autocompleteService.getPlacePredictions(_extends({}, this.props.options, {
          input: value
        }), this.autocompleteCallback);
      }
    }
  }, {
    key: 'clearAutocomplete',
    value: function clearAutocomplete() {
      this.setState({ autocompleteItems: [] });
    }
  }, {
    key: 'selectAddress',
    value: function selectAddress(address, placeId) {
      this.clearAutocomplete();
      this.handleSelect(address, placeId);
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(address, placeId) {
      this.props.onSelect ? this.props.onSelect(address, placeId) : this.props.inputProps.onChange(address);
    }
  }, {
    key: 'getActiveItem',
    value: function getActiveItem() {
      return this.state.autocompleteItems.find(function (item) {
        return item.active;
      });
    }
  }, {
    key: 'selectActiveItemAtIndex',
    value: function selectActiveItemAtIndex(index) {
      var activeName = this.state.autocompleteItems.find(function (item) {
        return item.index === index;
      }).suggestion;
      this.setActiveItemAtIndex(index);
      this.props.inputProps.onChange(activeName);
    }
  }, {
    key: 'handleEnterKey',
    value: function handleEnterKey() {
      var activeItem = this.getActiveItem();
      if (activeItem === undefined) {
        this.handleEnterKeyWithoutActiveItem();
      } else {
        this.selectAddress(activeItem.suggestion, activeItem.placeId);
      }
    }
  }, {
    key: 'handleEnterKeyWithoutActiveItem',
    value: function handleEnterKeyWithoutActiveItem() {
      if (this.props.onEnterKeyDown) {
        this.props.onEnterKeyDown(this.props.inputProps.value);
        this.clearAutocomplete();
      } else {
        return; //noop
      }
    }
  }, {
    key: 'handleDownKey',
    value: function handleDownKey() {
      if (this.state.autocompleteItems.length === 0) {
        return;
      }

      var activeItem = this.getActiveItem();
      if (activeItem === undefined) {
        this.selectActiveItemAtIndex(0);
      } else {
        var nextIndex = (activeItem.index + 1) % this.state.autocompleteItems.length;
        this.selectActiveItemAtIndex(nextIndex);
      }
    }
  }, {
    key: 'handleUpKey',
    value: function handleUpKey() {
      if (this.state.autocompleteItems.length === 0) {
        return;
      }

      var activeItem = this.getActiveItem();
      if (activeItem === undefined) {
        this.selectActiveItemAtIndex(this.state.autocompleteItems.length - 1);
      } else {
        var prevIndex = void 0;
        if (activeItem.index === 0) {
          prevIndex = this.state.autocompleteItems.length - 1;
        } else {
          prevIndex = (activeItem.index - 1) % this.state.autocompleteItems.length;
        }
        this.selectActiveItemAtIndex(prevIndex);
      }
    }
  }, {
    key: 'handleInputKeyDown',
    value: function handleInputKeyDown(event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          this.handleEnterKey();
          break;
        case 'ArrowDown':
          event.preventDefault(); // prevent the cursor from moving
          this.handleDownKey();
          break;
        case 'ArrowUp':
          event.preventDefault(); // prevent the cursor from moving
          this.handleUpKey();
          break;
        case 'Escape':
          this.clearAutocomplete();
          break;
      }

      if (this.props.inputProps.onKeyDown) {
        this.props.inputProps.onKeyDown(event);
      }
    }
  }, {
    key: 'setActiveItemAtIndex',
    value: function setActiveItemAtIndex(index) {
      this.setState({
        autocompleteItems: this.state.autocompleteItems.map(function (item, idx) {
          if (idx === index) {
            return _extends({}, item, { active: true });
          } else {
            return _extends({}, item, { active: false });
          }
        })
      });
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(event) {
      this.props.inputProps.onChange(event.target.value);
      if (!event.target.value) {
        this.clearAutocomplete();
        return;
      }
      this.debouncedFetchPredictions();
    }
  }, {
    key: 'handleInputOnBlur',
    value: function handleInputOnBlur(event) {
      this.clearAutocomplete();

      if (this.props.inputProps.onBlur) {
        this.props.inputProps.onBlur(event);
      }
    }
  }, {
    key: 'inlineStyleFor',
    value: function inlineStyleFor() {
      var _props = this.props,
          classNames = _props.classNames,
          styles = _props.styles;
      // No inline style if className is passed via props for the element.

      for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
        props[_key] = arguments[_key];
      }

      if (props.some(function (prop) {
        return classNames.hasOwnProperty(prop);
      })) {
        return {};
      }

      return props.reduce(function (acc, prop) {
        return _extends({}, acc, _defaultStyles2.default[prop], styles[prop]);
      }, {});
    }
  }, {
    key: 'classNameFor',
    value: function classNameFor() {
      var classNames = this.props.classNames;

      for (var _len2 = arguments.length, props = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        props[_key2] = arguments[_key2];
      }

      return props.reduce(function (acc, prop) {
        var name = classNames[prop] || '';
        return name ? acc + ' ' + name : acc;
      }, '');
    }
  }, {
    key: 'getInputProps',
    value: function getInputProps() {
      var _this2 = this;

      var defaultInputProps = {
        type: "text",
        autoComplete: "off"
      };

      return _extends({}, defaultInputProps, this.props.inputProps, {
        onChange: function onChange(event) {
          _this2.handleInputChange(event);
        },
        onKeyDown: function onKeyDown(event) {
          _this2.handleInputKeyDown(event);
        },
        onBlur: function onBlur(event) {
          _this2.handleInputOnBlur(event);
        },
        style: this.inlineStyleFor('input'),
        className: this.classNameFor('input')
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          classNames = _props2.classNames,
          styles = _props2.styles;
      var autocompleteItems = this.state.autocompleteItems;

      var inputProps = this.getInputProps();

      return _react2.default.createElement(
        'div',
        {
          id: 'PlacesAutocomplete__root',
          style: this.inlineStyleFor('root'),
          className: this.classNameFor('root') },
        _react2.default.createElement('input', inputProps),
        autocompleteItems.length > 0 && _react2.default.createElement(
          'div',
          {
            id: 'PlacesAutocomplete__autocomplete-container',
            style: this.inlineStyleFor('autocompleteContainer'),
            className: this.classNameFor('autocompleteContainer') },
          autocompleteItems.map(function (p, idx) {
            return _react2.default.createElement(
              'div',
              {
                key: p.placeId,
                onMouseOver: function onMouseOver() {
                  return _this3.setActiveItemAtIndex(p.index);
                },
                onMouseDown: function onMouseDown() {
                  return _this3.selectAddress(p.suggestion, p.placeId);
                },
                onTouchStart: function onTouchStart() {
                  return _this3.setActiveItemAtIndex(p.index);
                },
                onTouchEnd: function onTouchEnd() {
                  return _this3.selectAddress(p.suggestion, p.placeId);
                },
                style: p.active ? _this3.inlineStyleFor('autocompleteItem', 'autocompleteItemActive') : _this3.inlineStyleFor('autocompleteItem'),
                className: p.active ? _this3.classNameFor('autocompleteItem', 'autocompleteItemActive') : _this3.classNameFor('autocompleteItem') },
              _this3.props.autocompleteItem({ suggestion: p.suggestion, formattedSuggestion: p.formattedSuggestion })
            );
          }),
          this.props.googleLogo && _react2.default.createElement(
            'div',
            {
              id: 'PlacesAutocomplete__google-logo',
              style: this.inlineStyleFor('googleLogoContainer'),
              className: this.classNameFor('googleLogoContainer') },
            _react2.default.createElement('img', {
              src: __webpack_require__(3246)("./powered_by_google_" + this.props.googleLogoType + '.png'),
              style: this.inlineStyleFor('googleLogoImage'),
              className: this.classNameFor('googleLogoImage')
            })
          )
        )
      );
    }
  }]);

  return PlacesAutocomplete;
}(_react.Component);

PlacesAutocomplete.propTypes = {
  inputProps: function inputProps(props, propName) {
    var inputProps = props[propName];

    if (!inputProps.hasOwnProperty('value')) {
      throw new Error('\'inputProps\' must have \'value\'.');
    }

    if (!inputProps.hasOwnProperty('onChange')) {
      throw new Error('\'inputProps\' must have \'onChange\'.');
    }
  },
  onError: _propTypes2.default.func,
  clearItemsOnError: _propTypes2.default.bool,
  onSelect: _propTypes2.default.func,
  autocompleteItem: _propTypes2.default.func,
  classNames: _propTypes2.default.shape({
    root: _propTypes2.default.string,
    input: _propTypes2.default.string,
    autocompleteContainer: _propTypes2.default.string,
    autocompleteItem: _propTypes2.default.string,
    autocompleteItemActive: _propTypes2.default.string
  }),
  styles: _propTypes2.default.shape({
    root: _propTypes2.default.object,
    input: _propTypes2.default.object,
    autocompleteContainer: _propTypes2.default.object,
    autocompleteItem: _propTypes2.default.object,
    autocompleteItemActive: _propTypes2.default.object
  }),
  options: _propTypes2.default.shape({
    bounds: _propTypes2.default.object,
    componentRestrictions: _propTypes2.default.object,
    location: _propTypes2.default.object,
    offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    types: _propTypes2.default.array
  }),
  debounce: _propTypes2.default.number,
  highlightFirstSuggestion: _propTypes2.default.bool,
  googleLogo: _propTypes2.default.bool,
  googleLogoType: _propTypes2.default.oneOf(["default", "inverse"])
};

PlacesAutocomplete.defaultProps = {
  clearItemsOnError: false,
  onError: function onError(status) {
    return console.error('[react-places-autocomplete]: error happened when fetching data from Google Maps API.\nPlease check the docs here (https://developers.google.com/maps/documentation/javascript/places#place_details_responses)\nStatus: ', status);
  },
  classNames: {},
  autocompleteItem: function autocompleteItem(_ref) {
    var suggestion = _ref.suggestion;
    return _react2.default.createElement(
      'div',
      null,
      suggestion
    );
  },
  styles: {},
  options: {},
  debounce: 200,
  highlightFirstSuggestion: false,
  googleLogo: true,
  googleLogoType: 'default'
};

exports.default = PlacesAutocomplete;

/***/ }),
/* 3241 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(3242)();
}


/***/ }),
/* 3242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(3243);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 3243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 3244 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 3245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultStyles = {
  root: {
    position: 'relative',
    paddingBottom: '0px'
  },
  input: {
    display: 'inline-block',
    width: '100%',
    padding: '10px'
  },
  autocompleteContainer: {
    position: 'absolute',
    top: '100%',
    backgroundColor: 'white',
    border: '1px solid #555555',
    width: '100%'
  },
  autocompleteItem: {
    backgroundColor: '#ffffff',
    padding: '10px',
    color: '#555555',
    cursor: 'pointer'
  },
  autocompleteItemActive: {
    backgroundColor: '#fafafa'
  },
  googleLogoContainer: {
    textAlign: 'right',
    padding: '1px',
    backgroundColor: '#fafafa'
  },
  googleLogoImage: {
    width: 150
  }
};

exports.default = defaultStyles;

/***/ }),
/* 3246 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./powered_by_google_default.png": 3247,
	"./powered_by_google_inverse.png": 3248
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3246;

/***/ }),
/* 3247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "60e8a8323a1f5c9dc59c6783d5974123.png";

/***/ }),
/* 3248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e72d1907bf5d0f6c1153e50aa7cf7f9a.png";

/***/ }),
/* 3249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var geocodeByAddress = exports.geocodeByAddress = function geocodeByAddress(address, callback) {
  var geocoder = new google.maps.Geocoder();
  var OK = google.maps.GeocoderStatus.OK;

  return new Promise(function (resolve, reject) {
    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== OK) {

        // TODO: Remove callback support in the next major version.
        if (callback) {
          console.warn('Deprecated: Passing a callback to geocodeByAddress is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyaddress-api"');
          callback({ status: status }, null, results);
          return;
        }

        reject(status);
      }

      // TODO: Remove callback support in the next major version.
      if (callback) {
        var latLng = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        };
        console.warn('Deprecated: Passing a callback to geocodeByAddress is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyaddress-api"');
        callback(null, latLng, results);
      }

      resolve(results);
    });
  });
};

var getLatLng = exports.getLatLng = function getLatLng(result) {
  return new Promise(function (resolve, reject) {
    try {
      var latLng = {
        lat: result.geometry.location.lat(),
        lng: result.geometry.location.lng()
      };
      resolve(latLng);
    } catch (e) {
      reject(e);
    }
  });
};

var geocodeByPlaceId = exports.geocodeByPlaceId = function geocodeByPlaceId(placeId, callback) {
  var geocoder = new google.maps.Geocoder();
  var OK = google.maps.GeocoderStatus.OK;

  return new Promise(function (resolve, reject) {
    geocoder.geocode({ placeId: placeId }, function (results, status) {
      if (status !== OK) {

        // TODO: Remove callback support in the next major version.
        if (callback) {
          console.warn('Deprecated: Passing a callback to geocodeByAddress is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyplaceid-api"');
          callback({ status: status }, null, results);
          return;
        }

        reject(status);
      }

      // TODO: Remove callback support in the next major version.
      if (callback) {
        var latLng = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        };
        console.warn('Deprecated: Passing a callback to geocodeByPlaceId is deprecated. Please see "https://github.com/kenny-hibino/react-places-autocomplete#geocodebyplaceid-api"');
        callback(null, latLng, results);
      }

      resolve(results);
    });
  });
};

/***/ }),
/* 3250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  users: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    firstName: _react.PropTypes.string,
    lastName: _react.PropTypes.string,
    name: _react.PropTypes.string,
    email: _react.PropTypes.string
  })),
  style: _react.PropTypes.object,
  listItemStyle: _react.PropTypes.object
};
var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var ContactList = function (_Component) {
  _inherits(ContactList, _Component);

  function ContactList(props) {
    _classCallCheck(this, ContactList);

    var _this = _possibleConstructorReturn(this, (ContactList.__proto__ || Object.getPrototypeOf(ContactList)).call(this, props));

    _this.toggleList = function () {
      _this.setState({ expanded: !_this.state.expanded });
    };

    _this.state = {
      expanded: false
    };
    return _this;
  }

  _createClass(ContactList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var arrLength = _ramda2.default.pathOr(0, ['users', 'length'], this.props);
      return _react2.default.createElement(
        'div',
        { style: this.props.style },
        this.props.users.slice(0, this.state.expanded ? this.props.users.length : 3).map(function (user) {
          return _react2.default.createElement(
            'small',
            { key: user.email, style: _this2.props.listItemStyle },
            user.name || (user.firstName || '') + ' ' + (user.lastName || ''),
            ' ',
            user.email
          );
        }),
        arrLength > 3 ? _react2.default.createElement(
          'a',
          { onClick: this.toggleList, style: { cursor: 'pointer', fontSize: '10px', textDecoration: 'underline' } },
          this.state.expanded ? 'Show Less' : 'Show All'
        ) : _react2.default.createElement('div', null)
      );
    }
  }]);

  return ContactList;
}(_react.Component);

ContactList.propTypes = propTypes;

exports.default = ContactList;

/***/ }),
/* 3251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

exports.default = function (_ref) {
  var router = _ref.router,
      contractRequest = _ref.contractRequest,
      updateProps = _ref.updateProps,
      sendContracts = _ref.sendContracts,
      message = _ref.message,
      subject = _ref.subject,
      templateSelected = _ref.templateSelected,
      templateGroupSelected = _ref.templateGroupSelected,
      contractsSent = _ref.contractsSent,
      bccSelf = _ref.bccSelf,
      tags = _ref.tags,
      folders = _ref.folders,
      sendingContracts = _ref.sendingContracts,
      showReviewAndSendForResponseWizard = _ref.showReviewAndSendForResponseWizard,
      error = _ref.error,
      templates = _ref.templates;

  if (isNilOrEmpty(templates) || !contractRequest || _ramda2.default.isEmpty(contractRequest)) return _react2.default.createElement('div', null);
  var partners = [{
    profileImageUrl: contractRequest.buyerProfileImageUrl,
    company_name: contractRequest.buyerName,
    companyId: contractRequest.buyerId
  }];
  var handleActionButton = function handleActionButton() {
    return _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals(true), function () {
      if (!subject) {
        updateProps({ error: 'Please enter a subject line.' });
        (0, _lodash2.default)(function () {
          return updateProps({ error: '' });
        }, 4000)();
      } else {
        sendContracts({ templateSelected: templateSelected, templateGroupSelected: templateGroupSelected, message: message, partners: partners, subject: subject, bccSelf: bccSelf, tags: tags, folders: folders });
      }
    }], [_ramda2.default.T, function () {
      if (isNilOrEmpty(templateSelected) && isNilOrEmpty(templateGroupSelected)) {
        updateProps({ error: 'Please select a template before proceeding.' });
        (0, _lodash2.default)(function () {
          return updateProps({ error: '' });
        }, 4000)();
      } else {
        // updateProps({ showReviewAndSendForResponseWizard: true });
        window.location = "https://app.tourconnect.com" + '/partner-management/send-assets?' + _queryString2.default.stringify(_extends({
          partnerids: [contractRequest.partners[0].id],
          contactids: [contractRequest.contacts[0].id],
          go_back_to: window.location.href
        }, templateGroupSelected && templateGroupSelected._id ? { templategroupid: [templateGroupSelected._id] } : { templateids: [templateSelected._id] }, {
          message: message,
          subject: subject
          // openpanel: 'message',
        })) + '&jwt=' + localStorage.getItem('jwt');
      }
    }]]), showReviewAndSendForResponseWizard);
  };
  if (contractsSent) {
    return _react2.default.createElement(_raisedButtonWithLoader2.default, {
      secondary: true,
      style: { margin: '24px 0 40px 40%' },
      label: 'View Contracts',
      onTouchTap: function onTouchTap() {
        return router.push('/contracting/contract-list/all%20contracts');
      }
    });
  }
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex', justifyContent: 'space-between', margin: '16px' } },
    _react2.default.createElement(_flatButtonWithLoader2.default, {
      label: 'exit',
      primary: true,
      onTouchTap: function onTouchTap() {
        return router.push('/contracting/contract-list/recent');
      },
      labelStyle: { fontWeight: '600' }
    }),
    _react2.default.createElement(
      'div',
      { style: { color: 'red' } },
      error
    ),
    _react2.default.createElement(
      'div',
      null,
      showReviewAndSendForResponseWizard ? _react2.default.createElement(_flatButtonWithLoader2.default, {
        label: 'back',
        onTouchTap: function onTouchTap() {
          return updateProps({ showReviewAndSendForResponseWizard: false });
        }
      }) : _react2.default.createElement('div', null),
      _react2.default.createElement(_raisedButtonWithLoader2.default, {
        label: 'Continue',
        secondary: true,
        loader: sendingContracts,
        labelStyle: { fontWeight: '600' },
        onTouchTap: handleActionButton
      })
    )
  );
};

/***/ }),
/* 3252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _selectTemplate = __webpack_require__(3253);

var _selectTemplate2 = _interopRequireDefault(_selectTemplate);

var _contractingUtils = __webpack_require__(124);

var _containerSendToPartners = __webpack_require__(3254);

var _containerSendToPartners2 = _interopRequireDefault(_containerSendToPartners);

var _reviewSend = __webpack_require__(3263);

var _reviewSend2 = _interopRequireDefault(_reviewSend);

var _materialUi = __webpack_require__(3);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _addAllotments = __webpack_require__(3265);

var _addAllotments2 = _interopRequireDefault(_addAllotments);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
// Basic Account Partners Threshold
var basicNo = 20;
var propTypes = {
  companyType: _react.PropTypes.string,
  showAllPartners: _react.PropTypes.bool,
  sendingContracts: _react.PropTypes.bool,
  bccSelf: _react.PropTypes.bool,
  assignTag: _react.PropTypes.bool,
  assignFolder: _react.PropTypes.bool,
  tags: _react.PropTypes.array,
  folders: _react.PropTypes.array,
  templateSelected: _react.PropTypes.object,
  templateGroupSelected: _react.PropTypes.object,
  router: _react.PropTypes.object,
  stepIndex: _react.PropTypes.number,
  contractsSent: _react.PropTypes.bool,
  locationId: _react.PropTypes.string,
  partners: _react.PropTypes.array,
  message: _react.PropTypes.string,
  subject: _react.PropTypes.string,
  error: _react.PropTypes.string,
  updateProps: _react.PropTypes.func,
  getTemplates: _react.PropTypes.func,
  getLocations: _react.PropTypes.func,
  clearStore: _react.PropTypes.func,
  sendContracts: _react.PropTypes.func,
  showAllocationError: _react.PropTypes.bool,
  contractingPartners: _react.PropTypes.array,
  newPartnersSelected: _react.PropTypes.array,
  billingPlan: _react.PropTypes.string
};

var SendContractStepper = function (_Component) {
  _inherits(SendContractStepper, _Component);

  function SendContractStepper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SendContractStepper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SendContractStepper.__proto__ || Object.getPrototypeOf(SendContractStepper)).call.apply(_ref, [this].concat(args))), _this), _this.getStepContent = function (validPartners) {
      var _this$props = _this.props,
          templateSelected = _this$props.templateSelected,
          stepIndex = _this$props.stepIndex,
          message = _this$props.message,
          showAllPartners = _this$props.showAllPartners,
          subject = _this$props.subject,
          bccSelf = _this$props.bccSelf,
          assignTag = _this$props.assignTag,
          assignFolder = _this$props.assignFolder,
          partners = _this$props.partners,
          contractsSent = _this$props.contractsSent,
          sendingContracts = _this$props.sendingContracts,
          templateGroupSelected = _this$props.templateGroupSelected,
          showAllocationError = _this$props.showAllocationError;

      var _ref2 = isNilOrEmpty(templateSelected) ? templateGroupSelected : templateSelected,
          startDate = _ref2.startDate,
          endDate = _ref2.endDate;
      // const contractExistsPartnerExist = R.call(R.compose(R.complement(R.isEmpty), R.filter(this.checkIfContractsExists(templateSelected, templateGroupSelected))), partners);


      return _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals(0), _ramda2.default.always(_react2.default.createElement(_selectTemplate2.default, { updateProps: _this.props.updateProps }))], [_ramda2.default.equals(1), _ramda2.default.always(_react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_containerSendToPartners2.default, {
          validityCheckFn: (0, _contractingUtils.processPartnersForSendingRates)(templateSelected, templateGroupSelected),
          startDate: startDate,
          endDate: endDate
        })
      ))], [_ramda2.default.equals(2), _ramda2.default.always(_react2.default.createElement(_addAllotments2.default, { templateSelected: templateSelected, templateGroupSelected: templateGroupSelected, showAllocationError: showAllocationError }))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(_reviewSend2.default, {
        updateProps: _this.props.updateProps,
        partners: validPartners,
        sentPartnersLength: validPartners.length,
        sendingContracts: sendingContracts,
        goBack: function goBack() {
          return _this.props.router.goBack();
        },
        templateSelected: templateSelected,
        message: message,
        subject: subject,
        bccSelf: bccSelf,
        assignTag: assignTag,
        assignFolder: assignFolder,
        contractsSent: contractsSent,
        showAllPartners: showAllPartners,
        templateGroupSelected: templateGroupSelected
      }))]]), stepIndex);
    }, _this.handleNext = function () {
      _this.props.updateProps({
        stepIndex: _this.props.stepIndex + 1
      });
    }, _this.handlePrev = function () {
      var _this$props2 = _this.props,
          stepIndex = _this$props2.stepIndex,
          updateProps = _this$props2.updateProps;

      updateProps({ stepIndex: stepIndex - 1 });
    }, _this.handleActionButton = function (validPartners) {
      return function () {
        var _this$props3 = _this.props,
            stepIndex = _this$props3.stepIndex,
            updateProps = _this$props3.updateProps,
            templateSelected = _this$props3.templateSelected,
            templateGroupSelected = _this$props3.templateGroupSelected,
            sendContracts = _this$props3.sendContracts,
            message = _this$props3.message,
            subject = _this$props3.subject,
            bccSelf = _this$props3.bccSelf,
            partners = _this$props3.partners,
            contractingPartners = _this$props3.contractingPartners,
            billingPlan = _this$props3.billingPlan,
            newPartnersSelected = _this$props3.newPartnersSelected,
            folders = _this$props3.folders,
            tags = _this$props3.tags;

        return _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals(0), function () {
          if (isNilOrEmpty(templateSelected) && isNilOrEmpty(templateGroupSelected)) {
            updateProps({ error: 'Please select a template before proceeding.' });
            (0, _lodash2.default)(function () {
              return updateProps({ error: '' });
            }, 7000)();
          } else _this.handleNext();
        }], [_ramda2.default.equals(1), function () {
          var contractingPartnersLength = (contractingPartners || []).filter(function (obj) {
            return obj.paidBy === 'Supplier';
          }).length;
          if (!validPartners.length) {
            updateProps({ error: 'Please select at least ONE valid partner before proceeding.' });
            (0, _lodash2.default)(function () {
              return updateProps({ error: '' });
            }, 7000)();
          } else if (billingPlan === 'basic' && newPartnersSelected.length + contractingPartnersLength > Math.max(basicNo, contractingPartnersLength)) {
            updateProps({ error: 'You\'ve selected ' + newPartnersSelected.length + ' new ' + (0, _pluralize2.default)('partner', newPartnersSelected.length) + '.\n          If you would like to continue, please remove ' + (newPartnersSelected.length - Math.max(basicNo, contractingPartnersLength) + contractingPartnersLength) + ' from your new contracting partners.' });
            (0, _lodash2.default)(function () {
              return updateProps({ error: '' });
            }, 7000)();
          } else _this.handleNext();
        }], [_ramda2.default.equals(2), function () {
          var allocationValid = partners.every(function (partner) {
            return isNilOrEmpty(partner.templates) || partner.templates.every(function (obj) {
              return obj.products.every(function (prod) {
                return isNilOrEmpty(prod.customizedAllocation) || prod.customizedAllocation.every(function (allo) {
                  if (allo.allocationType === 'onRequest') return true;
                  if (allo.allocationType === 'freesale') return Boolean(allo.releaseBackDays);
                  return allo.allotments.every(function (allotment) {
                    return Boolean(allotment.releaseBackDays) && Boolean(allotment.numberOfRooms);
                  });
                });
              });
            });
          });
          if (!allocationValid) {
            updateProps({ showAllocationError: true, error: 'Please fill all required fields.' });
            (0, _lodash2.default)(function () {
              return updateProps({ error: '' });
            }, 4000)();
          } else _this.handleNext();
        }], [_ramda2.default.equals(3), function () {
          if (!subject) {
            updateProps({ error: 'Please enter a subject line.' });
            (0, _lodash2.default)(function () {
              return updateProps({ error: '' });
            }, 7000)();
          } else {
            sendContracts({ templateSelected: templateSelected, templateGroupSelected: templateGroupSelected, message: message, partners: validPartners, subject: subject, bccSelf: bccSelf, folders: folders, tags: tags });
          }
        }], [_ramda2.default.T, function () {
          return updateProps({ error: 'Please refresh your page and try again.' });
        }]]), stepIndex);
      };
    }, _this.invalidCheck = _ramda2.default.curry(function (templateSelected, templateGroupSelected, partner) {
      var partnerErr = (0, _contractingUtils.processPartnersForSendingRates)(templateSelected, templateGroupSelected, partner);
      // return partnerErr && partnerErr !== '* Contract exists';
      return partnerErr;
    }), _this.checkIfContractsExists = _ramda2.default.curry(function (templateSelected, templateGroupSelected, partner) {
      var partnerErr = (0, _contractingUtils.processPartnersForSendingRates)(templateSelected, templateGroupSelected, partner);
      return partnerErr === '* Contract exists';
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SendContractStepper, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes);
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          stepIndex = _props.stepIndex,
          error = _props.error,
          contractsSent = _props.contractsSent,
          templateSelected = _props.templateSelected,
          templateGroupSelected = _props.templateGroupSelected,
          partners = _props.partners,
          sendingContracts = _props.sendingContracts;

      var contentStyle = { margin: '0 16px', padding: '16px', overflow: 'hidden' };
      var inValidPartnersLength = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.length, _ramda2.default.filter(this.invalidCheck(templateSelected, templateGroupSelected))), partners);
      var validPartners = _ramda2.default.reject(this.invalidCheck(templateSelected, templateGroupSelected), partners);
      var validPartnersLength = _ramda2.default.length(validPartners);

      var numberOfTemplateSelected = function () {
        if (!isNilOrEmpty(templateGroupSelected)) return templateGroupSelected.templates.length;
        if (!isNilOrEmpty(templateSelected)) return 1;
        return 0;
      }();
      return _react2.default.createElement(
        _materialUi.Paper,
        { style: { width: '100%', maxWidth: '900px', margin: 'auto' } },
        _react2.default.createElement(
          'div',
          { style: { backgroundColor: '#00BCD4', height: '51px', paddingLeft: '16px', lineHeight: '51px', color: 'white', fontSize: '20px' } },
          'Send Contracts with Allocation'
        ),
        _react2.default.createElement(
          _materialUi.Stepper,
          { activeStep: stepIndex },
          _react2.default.createElement(
            _materialUi.Step,
            null,
            _react2.default.createElement(
              _materialUi.StepLabel,
              { style: { height: '54px' } },
              numberOfTemplateSelected === 0 || stepIndex === 0 ? 'Select Templates' : numberOfTemplateSelected + ' ' + (0, _pluralize2.default)('Templates', numberOfTemplateSelected) + ' Selected'
            )
          ),
          _react2.default.createElement(
            _materialUi.Step,
            null,
            _react2.default.createElement(
              _materialUi.StepLabel,
              { style: { height: '54px' } },
              stepIndex === 2 || stepIndex === 3 ? validPartnersLength + ' ' + (0, _pluralize2.default)('Partners', validPartnersLength) + ' Selected' : 'Select Partners'
            )
          ),
          _react2.default.createElement(
            _materialUi.Step,
            null,
            _react2.default.createElement(
              _materialUi.StepLabel,
              null,
              'Add Allotments'
            )
          ),
          _react2.default.createElement(
            _materialUi.Step,
            null,
            _react2.default.createElement(
              _materialUi.StepLabel,
              null,
              'Review & Send'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: contentStyle },
          _react2.default.createElement(
            'div',
            null,
            this.getStepContent(validPartners)
          ),
          contractsSent ? _react2.default.createElement('div', null) : _react2.default.createElement(
            'div',
            { style: { marginTop: 24, marginBottom: 12, display: 'flex', flexDirection: 'row-reverse', alignItems: 'center' } },
            _react2.default.createElement(_raisedButtonWithLoader2.default, {
              label: stepIndex === 3 ? 'Send' : 'Next',
              secondary: true,
              loader: sendingContracts,
              onTouchTap: this.handleActionButton(validPartners)
            }),
            _react2.default.createElement(_materialUi.FlatButton, {
              label: 'Back',
              disabled: stepIndex === 0,
              onTouchTap: this.handlePrev,
              style: { marginRight: 12 }
            }),
            _react2.default.createElement(
              'div',
              { style: { width: '60%', color: error ? 'red' : 'rgba(0, 0, 0, 0.54)' } },
              error,
              !error && !_ramda2.default.isEmpty(partners) && stepIndex === 1 ? validPartnersLength + ' valid partner' + (validPartnersLength === 1 ? '' : 's') + ', ' + inValidPartnersLength + ' invalid partner' + (inValidPartnersLength === 1 ? '' : 's') : ''
            )
          )
        )
      );
    }
  }]);

  return SendContractStepper;
}(_react.Component);

SendContractStepper.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref3) {
  var contracting = _ref3.contracting,
      user = _ref3.user;
  return _extends({
    companyType: user.getIn(['user', 'type']),
    partners: contracting.sendToPartners.get('partnersToSendTo').toJS(),
    billingPlan: user.get('billingPlan'),
    contractingPartners: contracting.sendToPartners.get('contractingPartners').toJS(),
    newPartnersSelected: contracting.sendToPartners.get('newPartnersSelected').toJS(),
    locationId: contracting.supplierWizard.getIn(['templateSelected', 'locationId'])
  }, contracting.supplierWizard.toJS());
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SendContractStepper);

/***/ }),
/* 3253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _actions = __webpack_require__(1958);

var _actions2 = __webpack_require__(1455);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var getTemplatesForGroup = function getTemplatesForGroup(templates, group) {
  return templates.filter(_ramda2.default.compose(_ramda2.default.contains(group._id), _ramda2.default.propOr([], 'templateGroups')));
};
var getGenitiveCase = function getGenitiveCase(string) {
  if (!string) return string;
  if (string.slice(-1) === 's') return string + '\'';
  return string + '\'s';
};

var SelectTemplate = function (_Component) {
  _inherits(SelectTemplate, _Component);

  function SelectTemplate(props) {
    _classCallCheck(this, SelectTemplate);

    var _this = _possibleConstructorReturn(this, (SelectTemplate.__proto__ || Object.getPrototypeOf(SelectTemplate)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(SelectTemplate, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          loadedLocations = _props.loadedLocations,
          loadedTemplates = _props.loadedTemplates,
          getL = _props.getLocations,
          getT = _props.getTemplates;

      if (!loadedLocations) getL();
      if (!loadedTemplates) getT();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          className = _props2.className,
          companyName = _props2.companyName,
          dontScroll = _props2.dontScroll,
          loadingLocations = _props2.loadingLocations,
          locationId = _props2.locationId,
          locations = _props2.locations,
          preSetInfo = _props2.preSetInfo,
          push = _props2.pushAction,
          sendTemplateOrGroup = _props2.sendTemplateOrGroup,
          templateGroups = _props2.templateGroups,
          templateGroupSelected = _props2.templateGroupSelected,
          templates = _props2.templates,
          templateSelected = _props2.templateSelected,
          updatePropsFn = _props2.updatePropsAction;

      var filteredTemplateGroups = templateGroups.filter(function (group) {
        var tplts = getTemplatesForGroup(templates, group);
        return tplts.every(function (tplt) {
          return _ramda2.default.contains('write', tplt.access || []);
        });
      });
      var groupsForDates = !preSetInfo ? filteredTemplateGroups : (filteredTemplateGroups || []).filter(_ramda2.default.anyPass([function (obj) {
        return obj.startDate <= preSetInfo.endDate && obj.startDate >= preSetInfo.startDate;
      }, function (obj) {
        return obj.endDate <= preSetInfo.endDate && obj.endDate >= preSetInfo.startDate;
      }, function (obj) {
        return obj.startDate < preSetInfo.startDate && obj.endDate > preSetInfo.endDate;
      }]));
      var templatesForDates = !preSetInfo ? templates : (templates || []).filter(_ramda2.default.anyPass([function (obj) {
        return obj.startDate <= preSetInfo.endDate && obj.startDate >= preSetInfo.startDate;
      }, function (obj) {
        return obj.endDate <= preSetInfo.endDate && obj.endDate >= preSetInfo.startDate;
      }, function (obj) {
        return obj.startDate < preSetInfo.startDate && obj.endDate > preSetInfo.endDate;
      }]));
      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(_loadingOverlay2.default, { loading: loadingLocations }),
        isNilOrEmpty(templatesForDates) ? _react2.default.createElement(
          'div',
          { style: { maxWidth: '700px', height: '380px', display: 'block', marginTop: '48px', textAlign: 'center' } },
          'You currently don\'t have templates ' + (preSetInfo ? ' for this contracting period' : '') + '.',
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          'Would you like to load your rates to a template?',
          _react2.default.createElement(_materialUi.RaisedButton, {
            id: 'openCreateDraftWizard',
            label: 'create',
            secondary: true,
            style: { marginLeft: '12px' },
            onTouchTap: function onTouchTap() {
              return push({
                pathname: '/contracting/create-template-draft',
                query: preSetInfo ? {
                  startDate: preSetInfo.startDate,
                  endDate: preSetInfo.endDate,
                  buyerName: preSetInfo.buyerName
                } : {}
              });
            }
          })
        ) : _react2.default.createElement('div', null),
        !_ramda2.default.propOr(0, 'length', templateGroups) || isNilOrEmpty(templatesForDates) ? _react2.default.createElement('div', null) : _react2.default.createElement(
          'div',
          { style: { marginBottom: '32px' } },
          'Would you like to send an individual template or a template group?',
          _react2.default.createElement(
            'div',
            { style: { marginTop: '1em' } },
            _react2.default.createElement(_materialUi.RadioButton, {
              label: 'template',
              checked: sendTemplateOrGroup === 'template',
              onCheck: function onCheck() {
                updatePropsFn({ sendTemplateOrGroup: 'template' });
                _this2.props.resetRateOptions();
              }
            }),
            _react2.default.createElement(_materialUi.RadioButton, {
              label: 'template group',
              checked: sendTemplateOrGroup === 'group',
              onCheck: function onCheck() {
                updatePropsFn({ sendTemplateOrGroup: 'group' });
                _this2.props.resetRateOptions();
              }
            })
          )
        ),
        (sendTemplateOrGroup === 'template' || !_ramda2.default.propOr(0, 'length', templateGroups)) && !isNilOrEmpty(templatesForDates) && _react2.default.createElement(
          'div',
          { style: _extends({
              maxWidth: '700px',
              margin: 'auto'
            }, dontScroll ? {} : { height: '380px', display: 'block', overflowY: 'scroll' })
          },
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'center', marginBottom: '24px' } },
            'Select the template that you would like to send.'
          ),
          _react2.default.createElement(
            'div',
            { style: { margin: '0 24px', display: locations.length > 1 ? 'block' : 'none' } },
            _react2.default.createElement(_reactSelect2.default, {
              style: { fontSize: '14px' },
              name: 'allocation',
              options: locations.filter(_ramda2.default.compose(_ramda2.default.contains('write'), _ramda2.default.prop('access'))).map(function (loc) {
                return { value: loc.id, label: loc.name };
              }),
              value: locationId,
              onChange: function onChange(_ref) {
                var value = _ref.value;
                return updatePropsFn({ locationId: value });
              },
              placeholder: 'Please select a location',
              clearable: false,
              scrollMenuIntoView: false
            })
          ),
          locationId ? _react2.default.createElement(
            'div',
            { style: { paddingLeft: '40px' } },
            'Depracated Small Template List'
          ) : _react2.default.createElement('div', null)
        ),
        sendTemplateOrGroup === 'group' && groupsForDates.length ? _react2.default.createElement(
          'div',
          { style: _extends({
              maxWidth: '700px',
              margin: 'auto'
            }, dontScroll ? {} : { height: '380px', display: 'block', overflowY: 'scroll' })
          },
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'center' } },
            'Select the template group that you would like to send.'
          ),
          _react2.default.createElement(
            'div',
            { style: { margin: '24px' } },
            _react2.default.createElement(_reactSelect2.default, {
              style: { fontSize: '14px' },
              name: 'group',
              options: groupsForDates.map(function (group) {
                return { value: group._id, group: group, label: group.groupName };
              }),
              value: _ramda2.default.propOr('', '_id', templateGroupSelected),
              onChange: function onChange(_ref2) {
                var group = _ref2.group;
                return updatePropsFn({
                  templateGroupSelected: _ramda2.default.merge(group, { templates: getTemplatesForGroup(templates, group) }),
                  message: 'Please find ' + getGenitiveCase(companyName) + ' ' + (0, _moment2.default)(group.startDate).utc().startOf('day').format('DD MMM YYYY') + ' - ' + (0, _moment2.default)(group.endDate).utc().startOf('day').format('DD MMM YYYY') + ' rates below. We are using TourConnect as they provide several standardised download formats that should make it easy for you to read and load our rates.\n\nIf you have any questions please let me know and thank you for your support.',
                  subject: companyName + ' ' + (0, _moment2.default)(group.startDate).utc().get('year') + '-' + (0, _moment2.default)(group.endDate).utc().get('year') + ' Rates'
                });
              },
              placeholder: 'Please select a template group',
              clearable: false,
              scrollMenuIntoView: false
            })
          ),
          !isNilOrEmpty(templateGroupSelected) && getTemplatesForGroup(templates, templateGroupSelected).map(function (_ref3, i) {
            var templateName = _ref3.templateName,
                locationName = _ref3.locationName;
            return _react2.default.createElement(
              'div',
              { key: '' + i + templateName, style: { color: 'rgba(0, 0, 0, 0.54)', marginLeft: '48px' } },
              _react2.default.createElement(
                'div',
                { style: { height: '40px', display: 'flex', alignItems: 'center' } },
                _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-description', color: 'rgba(0, 0, 0, 0.54)' }),
                _react2.default.createElement(
                  'div',
                  null,
                  locationName,
                  _react2.default.createElement(
                    'small',
                    { style: { paddingLeft: '2px' } },
                    '(',
                    templateName,
                    ')'
                  )
                )
              )
            );
          })
        ) : _react2.default.createElement('div', null),
        sendTemplateOrGroup === 'group' && isNilOrEmpty(groupsForDates) ? _react2.default.createElement(
          'div',
          { style: { maxWidth: '700px', height: '380px', display: 'block', marginTop: '48px', textAlign: 'center' } },
          'You currently don\'t have template groups' + (!preSetInfo ? ' for this contracting period' : '') + '.',
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          'Would you like to create a template group?',
          _react2.default.createElement(_materialUi.RaisedButton, {
            label: 'create',
            secondary: true,
            style: { marginLeft: '12px' },
            onTouchTap: function onTouchTap() {
              return push('/contracting/create-template-group');
            }
          })
        ) : _react2.default.createElement('div', null)
      );
    }
  }]);

  return SelectTemplate;
}(_react.Component);

SelectTemplate.propTypes = {
  className: _react.PropTypes.string,
  companyName: _react.PropTypes.string,
  dontScroll: _react.PropTypes.bool.isRequired,
  getLocations: _react.PropTypes.func,
  getTemplates: _react.PropTypes.func,
  loadedLocations: _react.PropTypes.bool,
  loadedTemplates: _react.PropTypes.bool,
  loadingLocations: _react.PropTypes.bool,
  locationId: _react.PropTypes.string, // sent from aboce
  locations: _react.PropTypes.array,
  preSetInfo: _react.PropTypes.object, // sent from above
  pushAction: _react.PropTypes.func,
  resetRateOptions: _react.PropTypes.func,
  sendTemplateOrGroup: _react.PropTypes.string,
  templateGroups: _react.PropTypes.array,
  templateGroupSelected: _react.PropTypes.object,
  templates: _react.PropTypes.array,
  templateSelected: _react.PropTypes.object,
  updatePropsAction: _react.PropTypes.func
};

SelectTemplate.defaultProps = {
  className: '',
  dontScroll: false
};

var mapStateToProps = function mapStateToProps(_ref4) {
  var user = _ref4.user,
      supplierWizard = _ref4.contracting.supplierWizard;
  return {
    companyName: user.getIn(['company', 'companyName']),
    loadedLocations: supplierWizard.get('loadedLocations'),
    loadedTemplates: supplierWizard.get('loadedTemplates'),
    loadingLocations: supplierWizard.get('loadingLocations'),
    locationId: supplierWizard.get('locationId'),
    locations: supplierWizard.get('locations').toJS(),
    sendTemplateOrGroup: supplierWizard.get('sendTemplateOrGroup'),
    templateGroups: supplierWizard.get('templateGroups').toJS(),
    templateGroupSelected: supplierWizard.get('templateGroupSelected').toJS(),
    templates: supplierWizard.get('templates').toJS(),
    templateSelected: supplierWizard.get('templateSelected').toJS()
    //  ...contracting.supplierWizard.toJS(),
    //  isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
    //  preSetInfo: supplierWizard.get('preSetInfo').toJS(),
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  getLocations: _actions.getLocations,
  getTemplates: _actions.getTemplates,
  pushAction: _reactRouterRedux.push,
  resetRateOptions: _actions2.resetRateOptions,
  updatePropsAction: _actions.updateProps
})(SelectTemplate);

/***/ }),
/* 3254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(1963);

var _materialUi = __webpack_require__(3);

var _selectMethod = __webpack_require__(3255);

var _selectMethod2 = _interopRequireDefault(_selectMethod);

var _reviewPartners = __webpack_require__(3256);

var _reviewPartners2 = _interopRequireDefault(_reviewPartners);

var _containerExisting = __webpack_require__(3257);

var _containerExisting2 = _interopRequireDefault(_containerExisting);

var _importFromEmail = __webpack_require__(3260);

var _importFromEmail2 = _interopRequireDefault(_importFromEmail);

var _uploadFile = __webpack_require__(3261);

var _uploadFile2 = _interopRequireDefault(_uploadFile);

var _addIndividually = __webpack_require__(3262);

var _addIndividually2 = _interopRequireDefault(_addIndividually);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _upgradeActions = __webpack_require__(611);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Basic Account Partners Threshold
var basicNo = 20;
var propTypes = {
  sendToPartners: _react.PropTypes.object,
  outstandingRequests: _react.PropTypes.array,
  updateProps: _react.PropTypes.func,
  loadExistingConnections: _react.PropTypes.func,
  clearStore: _react.PropTypes.func,
  startDate: _react.PropTypes.string.isRequired,
  endDate: _react.PropTypes.string.isRequired,
  locationId: _react.PropTypes.string,
  processPartners: _react.PropTypes.func,
  validityCheckFn: _react.PropTypes.func,
  getContractingPartners: _react.PropTypes.func,
  billingPlan: _react.PropTypes.string,
  companyType: _react.PropTypes.string,
  getContractRequest: _react.PropTypes.func,
  openUpgradeFrom: _react.PropTypes.func,
  classes: _react.PropTypes.object
};
var styles = {};

var SendToPartners = function (_Component) {
  _inherits(SendToPartners, _Component);

  function SendToPartners() {
    _classCallCheck(this, SendToPartners);

    return _possibleConstructorReturn(this, (SendToPartners.__proto__ || Object.getPrototypeOf(SendToPartners)).apply(this, arguments));
  }

  _createClass(SendToPartners, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          sendToPartners = _props.sendToPartners,
          loadExistingConnections = _props.loadExistingConnections,
          billingPlan = _props.billingPlan,
          getContractingPartners = _props.getContractingPartners,
          startDate = _props.startDate,
          endDate = _props.endDate,
          companyType = _props.companyType,
          locationId = _props.locationId,
          getContractRequest = _props.getContractRequest;

      if (_ramda2.default.isEmpty(sendToPartners.partnersToSendTo)) {
        loadExistingConnections();
        if (billingPlan === 'basic') getContractingPartners(startDate, endDate);
        if (companyType === 'Supplier') getContractRequest({ startDate: startDate, endDate: endDate, locationId: locationId });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes);
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          sendToPartners = _props2.sendToPartners,
          updateProps = _props2.updateProps,
          validityCheckFn = _props2.validityCheckFn,
          processPartners = _props2.processPartners,
          billingPlan = _props2.billingPlan,
          companyType = _props2.companyType;


      var sharedProps = {
        updateProps: updateProps,
        processPartners: processPartners,
        clearReducer: this.props.clearStore
      };

      var actionItems = [{
        cyData: 'selectFromConnections',
        text: 'Select from connections',
        icon: 'tc-icon-user',
        func: function func() {
          return updateProps({
            addPartnersMethod: 'fromConnections',
            showSelectFromPartnersDialog: true
          });
        }
      }, {
        cyData: 'importFromEmail',
        text: 'Import from email',
        icon: 'tc-icon-email',
        func: function func() {
          return updateProps({
            addPartnersMethod: 'emailImport',
            showEmailImportDialog: true
          });
        }
      }, {
        cyData: 'uploadAFile',
        text: 'Upload a file',
        icon: 'tc-icon-insert-drive-file',
        func: function func() {
          return updateProps({
            addPartnersMethod: 'uploadFile',
            showUploadFileDialog: true
          });
        }
      }, {
        cyData: 'addIndividually',
        text: 'Add individually',
        icon: 'add-circle-icon',
        func: function func() {
          return updateProps({
            addPartnersMethod: 'addIndividually',
            showAddIndividuallyDialog: true
          });
        }
      }];

      var getSelectedMethod = function getSelectedMethod() {
        switch (sendToPartners.addPartnersMethod) {
          case 'fromConnections':
            return _react2.default.createElement(_containerExisting2.default, sharedProps);
          case 'emailImport':
            return _react2.default.createElement(_importFromEmail2.default, sharedProps);
          case 'uploadFile':
            return _react2.default.createElement(_uploadFile2.default, sharedProps);
          case 'addIndividually':
            return _react2.default.createElement(_addIndividually2.default, sharedProps);
          default:
            return _react2.default.createElement('span', null);
        }
      };
      var contractingPartnersLength = (sendToPartners.contractingPartners || []).filter(function (obj) {
        return obj.paidBy === 'Supplier';
      }).length;
      var noneSelected = !(sendToPartners.partnersToSendTo && sendToPartners.partnersToSendTo.length);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,

          // Basic Account Partners Threshold
          Boolean(companyType === 'Supplier' && billingPlan === 'basic' && contractingPartnersLength && contractingPartnersLength < basicNo) && _react2.default.createElement(
            'div',
            { style: { fontWeight: 'bold' } },
            _react2.default.createElement(
              'div',
              null,
              'You have used ' + contractingPartnersLength + '/' + basicNo + ' of your free contracting partners under the Basic Plan.'
            ),
            _react2.default.createElement(
              'div',
              null,
              'You will be able to send your contracts to ',
              basicNo - contractingPartnersLength,
              ' additional ',
              (0, _pluralize2.default)('partner', basicNo - contractingPartnersLength),
              '.'
            )
          ),
          Boolean(companyType === 'Supplier' && billingPlan === 'basic' && contractingPartnersLength >= basicNo) && _react2.default.createElement(
            'div',
            { style: { fontWeight: 'bold' } },
            _react2.default.createElement(
              'div',
              null,
              'You have used ' + contractingPartnersLength + '/' + basicNo + ' of your free contracting partners under the Basic Plan.'
            ),
            _react2.default.createElement(
              'div',
              null,
              'In order to send your rates to all of your partners, you can \xA0',
              _react2.default.createElement(_materialUi.RaisedButton, { label: 'upgrade', secondary: true, onTouchTap: function onTouchTap() {
                  return _this2.context.router.push('/upgrade');
                } }),
              '\xA0 to our Connected Plan.'
            )
          ),
          noneSelected ? _react2.default.createElement(_selectMethod2.default, {
            updateProps: updateProps,
            addPartnersMethod: sendToPartners.addPartnersMethod,
            actionItems: actionItems
          }) : _react2.default.createElement('span', null),
          Boolean(sendToPartners.addPartnersMethod) ? getSelectedMethod() : _react2.default.createElement('span', null),
          !noneSelected ? _react2.default.createElement(_reviewPartners2.default, _extends({
            actionItems: actionItems,
            validityCheckFn: validityCheckFn
          }, sharedProps)) : _react2.default.createElement('span', null)
        ),
        _react2.default.createElement(_loadingOverlay2.default, {
          loading: sendToPartners.processingPartners || sendToPartners.loadingExisting || sendToPartners.gettingRequests,
          text: 'Checking partner validity, thanks for your patience...'
        })
      );
    }
  }]);

  return SendToPartners;
}(_react.Component);

SendToPartners.propTypes = propTypes;
SendToPartners.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user;
  return {
    sendToPartners: contracting.sendToPartners.toJS(),
    billingPlan: user.get('billingPlan'),
    companyType: user.getIn(['user', 'type'])
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var startDate = _ref2.startDate,
      endDate = _ref2.endDate;
  return {
    updateProps: function updateProps(payload) {
      return dispatch((0, _actions.updateProps)(payload));
    },
    processPartners: function processPartners(payload) {
      return dispatch((0, _actions.processPartners)(payload, startDate, endDate));
    },
    clearStore: function clearStore() {
      return dispatch((0, _actions.clearStore)());
    },
    loadExistingConnections: function loadExistingConnections() {
      return dispatch((0, _actions.loadExistingConnections)());
    },
    getContractingPartners: function getContractingPartners() {
      return dispatch(_actions.getContractingPartners.apply(undefined, arguments));
    },
    getContractRequest: function getContractRequest() {
      return dispatch(_actions.getContractRequest.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(SendToPartners));

/***/ }),
/* 3255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var SelectMethod = function SelectMethod(props) {
  var actionItems = props.actionItems,
      sendToPartners = props.sendToPartners;


  return _react2.default.createElement(
    'div',
    { style: { margin: '30px 0 0 4px' } },
    'How would you like to add partners? ',
    _react2.default.createElement('br', null),
    _react2.default.createElement('br', null),
    actionItems.map(function (_ref, index) {
      var cyData = _ref.cyData,
          text = _ref.text,
          func = _ref.func,
          icon = _ref.icon,
          svgIcon = _ref.svgIcon,
          toolTip = _ref.toolTip;
      return _react2.default.createElement(
        'div',
        _extends({
          key: index,
          style: { marginTop: (0, _ramda.equals)(index, 0) ? '15px' : '' }
        }, toolTip ? { className: 'hint--top', 'aria-label': toolTip } : {}),
        _react2.default.createElement(
          _materialUi.RaisedButton,
          _extends({
            'data-cy': cyData,
            label: (0, _ramda.equals)(text, 'Select from connections') && isNilOrEmpty((0, _ramda.propOr)([], 'existingConnections', sendToPartners)) ? text + ' - You do not have any connections' : text,
            labelPosition: 'after',
            labelStyle: { color: '#757575', fontSize: '14px', paddingLeft: '0px', marginLeft: '10px' },
            style: { marginTop: '1%', marginBottom: '1%' },
            onTouchTap: func,
            disabled: (0, _ramda.equals)(text, 'Select from connections') && isNilOrEmpty((0, _ramda.propOr)([], 'existingConnections', sendToPartners))
          }, svgIcon ? { icon: (0, _react.cloneElement)(svgIcon, { style: { marginTop: '5px', marginLeft: '10px' } }) } : {}),
          svgIcon ? null : _react2.default.createElement(_materialUi.FontIcon, { className: icon, style: { color: '#757575', verticalAlign: 'middle', marginLeft: '10px' } })
        )
      );
    })
  );
};

SelectMethod.propTypes = {
  updateProps: _react.PropTypes.func,
  addPartnersMethod: _react.PropTypes.string,
  actionItems: _react.PropTypes.array,
  sendToPartners: _react.PropTypes.object,
  isSupplier: _react.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    sendToPartners: contracting.sendToPartners.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SelectMethod);

/***/ }),
/* 3256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _arrowDropDown = __webpack_require__(559);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _flatDropDownMenu = __webpack_require__(494);

var _flatDropDownMenu2 = _interopRequireDefault(_flatDropDownMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewPartners = function ReviewPartners(props) {
  var updateProps = props.updateProps,
      sendToPartners = props.sendToPartners,
      actionItems = props.actionItems,
      validityCheckFn = props.validityCheckFn;
  // workaround for dropdown menu not closing

  var hideDropdownMenu = Boolean(sendToPartners.showAddIndividuallyDialog || sendToPartners.showSelectFromPartnersDialog || sendToPartners.showUploadFileDialog || sendToPartners.showEmailImportDialog);

  return _react2.default.createElement(
    'div',
    { style: { marginTop: '15px' } },
    _react2.default.createElement(
      'div',
      null,
      hideDropdownMenu ? _react2.default.createElement('span', null) : _react2.default.createElement(
        _flatDropDownMenu2.default,
        {
          button: _react2.default.createElement(_materialUi.FlatButton, {
            'data-cy': 'selectMorePartners',
            label: _react2.default.createElement(
              'span',
              { style: { color: '#00bcd4' } },
              '+ ADD MORE PARTNERS'
            ),
            labelPosition: 'before',
            icon: _react2.default.createElement(_arrowDropDown2.default, { style: { fill: 'rgba(0, 0, 0, 0.54)' } }),
            style: { borderRadius: '4px' },
            backgroundColor: '#f4f5f7',
            labelStyle: { textTransform: 'none' }
          })
        },
        actionItems.map(function (actionItem, index) {
          return _react2.default.createElement(_materialUi.MenuItem, {
            'data-cy': actionItem.cyData,
            key: index,
            onClick: actionItem.func,
            value: index,
            primaryText: actionItem.text,
            leftIcon: actionItem.svgIcon || _react2.default.createElement(_materialUi.FontIcon, { className: actionItem.icon, style: { color: '#757575' } })
          });
        })
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _materialUi.Table,
        { style: { backgroundColor: 'rgba(244, 244, 244, 0.24)' } },
        _react2.default.createElement(
          _materialUi.TableHeader,
          { adjustForCheckbox: false, displaySelectAll: false },
          _react2.default.createElement(
            _materialUi.TableRow,
            null,
            _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              null,
              'Company Name/Email'
            ),
            _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              null,
              'Company Type'
            ),
            validityCheckFn ? _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              { style: { padding: '0' } },
              'Validity'
            ) : _react2.default.createElement(_materialUi.TableHeaderColumn, null),
            _react2.default.createElement(_materialUi.TableHeaderColumn, null)
          )
        ),
        _react2.default.createElement(
          _materialUi.TableBody,
          { displayRowCheckbox: false },
          (0, _ramda.propOr)([], 'partnersToSendTo', sendToPartners).filter(function (_, i, arr) {
            return arr.length < 31 || sendToPartners.showAllInReview || i < 31;
          }).map(function (obj, i) {
            var errors = validityCheckFn ? validityCheckFn(obj) : '';
            return _react2.default.createElement(
              _materialUi.TableRow,
              { key: '' + obj.email + i, style: { height: '32px' } },
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                { style: { height: '32px', fontSize: '14px' } },
                obj.company_name || obj.companyName || obj.email
              ),
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                { style: { height: '32px', fontSize: '14px' } },
                obj._type || _react2.default.createElement(
                  'i',
                  null,
                  'Not on TourConnect'
                )
              ),
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                { style: { height: '32px', fontSize: '14px', color: _ramda2.default.call(_ramda2.default.cond([[function () {
                      return (0, _ramda.isNil)(errors);
                    }, _ramda2.default.always('green')],
                    // [() => R.equals(errors, '* Contract exists'), R.always('#c07942')],
                    [_ramda2.default.T, _ramda2.default.always('red')]])), padding: '0' }
                },
                (0, _ramda.isNil)(errors) ? 'valid' : errors
              ),
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                { style: { height: '32px', fontSize: '14px', textAlign: 'right' } },
                _react2.default.createElement(_materialUi.IconButton, {
                  iconClassName: 'tc-icon-delete2',
                  iconStyle: { color: 'rgb(255, 64, 129)' },
                  onTouchTap: function onTouchTap() {
                    return updateProps({
                      partnersToSendTo: (0, _ramda.remove)(i, 1, sendToPartners.partnersToSendTo)
                    });
                  }
                })
              )
            );
          })
        )
      ),
      sendToPartners.partnersToSendTo && sendToPartners.partnersToSendTo.length > 30 ? _react2.default.createElement(
        'div',
        {
          style: { lineHeight: '48px', color: '#00bcd4', cursor: 'pointer' },
          onClick: function onClick() {
            return updateProps({ showAllInReview: !sendToPartners.showAllInReview });
          }
        },
        sendToPartners.showAllInReview ? 'Show Less' : 'Show All'
      ) : _react2.default.createElement('div', null)
    )
  );
};

ReviewPartners.propTypes = {
  updateProps: _react.PropTypes.func,
  sendToPartners: _react.PropTypes.object,
  actionItems: _react.PropTypes.array,
  clearReducer: _react.PropTypes.func,
  validityCheckFn: _react.PropTypes.func,
  billingPlan: _react.PropTypes.string,
  isSupplier: _react.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user;
  return {
    billingPlan: user.get('billingPlan'),
    sendToPartners: contracting.sendToPartners.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReviewPartners);

/***/ }),
/* 3257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _search = __webpack_require__(3258);

var _search2 = _interopRequireDefault(_search);

var _table = __webpack_require__(3259);

var _table2 = _interopRequireDefault(_table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var ExistingConnections = function ExistingConnections(props) {
  var updateProps = props.updateProps,
      sendToPartners = props.sendToPartners,
      processPartners = props.processPartners;


  var cancelButton = _react2.default.createElement(_materialUi.FlatButton, {
    'data-cy': 'cancel',
    label: 'Cancel',
    primary: true,
    labelStyle: { fontWeight: '600' },
    onTouchTap: function onTouchTap() {
      return updateProps({
        showAllExisting: false,
        showSelectFromPartnersDialog: false,
        addPartnersMethod: '',
        filteredConnections: [],
        searchField: '',
        selectedExistingPartners: []
      });
    }
  });

  var addButton = _react2.default.createElement(_materialUi.FlatButton, {
    'data-cy': 'addPartners',
    label: (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), function () {
      return (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)(true), (0, _ramda.always)('Add 1 partner'), (0, _ramda.always)('Add ' + (0, _ramda.path)(['selectedExistingPartners', 'length'], sendToPartners) + ' partners')), (0, _ramda.equals)((0, _ramda.path)(['selectedExistingPartners', 'length'], sendToPartners), 1));
    }, (0, _ramda.always)('Add')), (0, _ramda.not)(isNilOrEmpty(sendToPartners.selectedExistingPartners))),
    secondary: true,
    labelStyle: { fontWeight: '600' },
    onTouchTap: function onTouchTap() {
      return processPartners({
        showSelectFromPartnersDialog: false,
        filteredConnections: [],
        searchField: '',
        addPartnersMethod: '',
        partnersToSendTo: sendToPartners.partnersToSendTo.concat(sendToPartners.selectedExistingPartners),
        selectedExistingPartners: []
      });
    },
    disabled: isNilOrEmpty(sendToPartners.selectedExistingPartners)
  });

  var numberOfSelected = _react2.default.createElement(_materialUi.FlatButton, {
    label: (0, _ramda.equals)((0, _ramda.path)(['selectedExistingPartners', 'length'], sendToPartners), 1) ? '1 partner selected' : (0, _ramda.path)(['selectedExistingPartners', 'length'], sendToPartners) + ' partners selected',
    disabled: true,
    style: { float: 'left' },
    labelStyle: { fontWeight: '600', color: 'rgba(0, 0, 0, 0.54)' }
  });

  var actions = [cancelButton, addButton];

  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: sendToPartners.showSelectFromPartnersDialog,
      autoScrollBodyContent: true,
      actions: (0, _ramda.not)(isNilOrEmpty(sendToPartners.selectedExistingPartners)) ? (0, _ramda.append)(numberOfSelected, actions) : actions,
      titleStyle: { padding: '0' },
      title: _react2.default.createElement(
        'div',
        null,
        (0, _ramda.not)(isNilOrEmpty(sendToPartners.filteredConnections)) || (0, _ramda.not)(isNilOrEmpty(sendToPartners.searchField)) ? _react2.default.createElement(
          'div',
          { style: { display: 'block', backgroundColor: '#00bcd4', color: '#ffffff', height: '50px' } },
          _react2.default.createElement(
            'div',
            { style: { padding: '2% 3%', float: 'left', fontSize: '20px', fontWeight: '600' } },
            'Add From Connections'
          ),
          _react2.default.createElement(
            'div',
            { style: { padding: '2% 3%', float: 'right', fontSize: '14px' } },
            (0, _ramda.equals)((0, _ramda.path)(['filteredConnections', 'length'], sendToPartners), 1) ? '1 result found' : (0, _ramda.path)(['filteredConnections', 'length'], sendToPartners) + ' results found'
          )
        ) : _react2.default.createElement(
          'h4',
          { style: { color: '#ffffff', backgroundColor: '#00bcd4', padding: '2% 3%' } },
          'Add From Connections'
        ),
        _react2.default.createElement(
          'div',
          { style: { clear: 'both' } },
          _react2.default.createElement(_search2.default, {
            updateProps: updateProps
          })
        )
      ),
      contentStyle: { width: '840px', maxWidth: '840px' },
      bodyStyle: { paddingTop: '0' }
    },
    _react2.default.createElement(_table2.default, { updateProps: updateProps })
  );
};

ExistingConnections.propTypes = {
  updateProps: _react.PropTypes.func,
  sendToPartners: _react.PropTypes.object,
  processPartners: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting;
  return {
    sendToPartners: contracting.sendToPartners.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ExistingConnections);

/***/ }),
/* 3258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function Search(props) {
  var sendToPartners = props.sendToPartners,
      updateProps = props.updateProps;


  return _react2.default.createElement(
    'div',
    { style: { width: '100%', borderBottom: '1px solid #e0e0e0', marginTop: '-10px' } },
    _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-search', color: 'rgba(0,0,0,0.5)', style: { top: '5px', margin: '0 2% 0 7.5%' } }),
    _react2.default.createElement(_materialUi.TextField, {
      underlineShow: false,
      inputStyle: { fontSize: '14px', whiteSpace: 'pre-wrap', padding: '0px 3px' },
      value: sendToPartners.searchField,
      onChange: function onChange(_ref) {
        var value = _ref.target.value;

        updateProps({
          searchField: value,
          filteredConnections: sendToPartners.existingConnections.filter(function (connection) {
            if (connection.companyName && (0, _ramda.contains)(value.toLowerCase(), connection.companyName.toLowerCase()) || connection.email && connection.email !== 'via TourConnect' && (0, _ramda.contains)(value.toLowerCase(), connection.email.toLowerCase())) {
              if (sendToPartners.selectedTag) return (0, _ramda.contains)(sendToPartners.selectedTag, connection.tags);
              return true;
            }
          })
        });
      },
      onKeyDown: function onKeyDown(e) {
        return e.which === 13 || e.which === 9 ? e.preventDefault() : undefined;
      },
      hintText: 'Search company name or email',
      hintStyle: { marginLeft: '3px' }
    })
  );
};

Search.propTypes = {
  updateProps: _react.PropTypes.func,
  sendToPartners: _react.PropTypes.object
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    sendToPartners: contracting.sendToPartners.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Search);

/***/ }),
/* 3259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _actions = __webpack_require__(1963);

var _flatDropDownMenu = __webpack_require__(494);

var _flatDropDownMenu2 = _interopRequireDefault(_flatDropDownMenu);

var _arrowDropDown = __webpack_require__(559);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _smallButtons = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var TableContainer = function TableContainer(props) {
  var updateProps = props.updateProps,
      sendToPartners = props.sendToPartners,
      check = props.check,
      uncheck = props.uncheck;
  var filteredConnections = sendToPartners.filteredConnections,
      searchField = sendToPartners.searchField,
      selectedTag = sendToPartners.selectedTag,
      selectedExistingPartners = sendToPartners.selectedExistingPartners,
      existingConnections = sendToPartners.existingConnections;

  var partnersToShow = (0, _ramda.not)(isNilOrEmpty(filteredConnections)) || searchField || selectedTag ? filteredConnections : existingConnections;
  var selectAllCheck = selectedExistingPartners.length > 0 && selectedExistingPartners.length === partnersToShow.length;
  var tags = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.uniq, _ramda2.default.chain(_ramda2.default.propOr([], 'tags'))), existingConnections);
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _materialUi.Table,
      { selectable: false, style: { borderBottom: '1px solid #e0e0e0' } },
      _react2.default.createElement(
        _materialUi.TableHeader,
        { displaySelectAll: false, adjustForCheckbox: false },
        _react2.default.createElement(
          _materialUi.TableRow,
          null,
          _react2.default.createElement(
            _materialUi.TableHeaderColumn,
            { colSpan: '1' },
            _react2.default.createElement(_materialUi.Checkbox, {
              onCheck: (0, _ramda.ifElse)(function () {
                return selectAllCheck;
              }, function () {
                return uncheck({ checkType: 'uncheckAll' });
              }, function () {
                return check({ checkType: 'checkAll' });
              }),
              checked: selectAllCheck
            })
          ),
          _react2.default.createElement(_materialUi.TableHeaderColumn, { colSpan: '1' }),
          _react2.default.createElement(
            _materialUi.TableHeaderColumn,
            { colSpan: '5' },
            'Company Name'
          ),
          _react2.default.createElement(
            _materialUi.TableHeaderColumn,
            { colSpan: '5' },
            'Email'
          ),
          _react2.default.createElement(
            _materialUi.TableHeaderColumn,
            { colSpan: '3', style: { padding: 0 } },
            _react2.default.createElement(
              _flatDropDownMenu2.default,
              {
                button: _react2.default.createElement(_smallButtons.SmallFlatButton, { label: selectedTag ? 'Tag: ' + selectedTag : 'Tags', labelStyle: { color: 'rgba(0, 0, 0, 0.34)', fontSize: '12px', top: '0px' }, icon: _react2.default.createElement(_arrowDropDown2.default, null), labelPosition: 'before' })
              },
              tags.map(function (tag, i) {
                return _react2.default.createElement(_materialUi.MenuItem, {
                  key: i,
                  value: tag,
                  primaryText: tag,
                  checked: selectedTag === tag,
                  onTouchTap: function onTouchTap() {
                    return updateProps({
                      selectedTag: selectedTag === tag ? undefined : tag,
                      filteredConnections: existingConnections.filter(function (partner) {
                        var textSearch = searchField ? partner.companyName && (0, _ramda.contains)(searchField.toLowerCase(), partner.companyName.toLowerCase()) || partner.email && partner.email !== 'via TourConnect' && (0, _ramda.contains)(searchField.toLowerCase(), partner.email.toLowerCase()) : true;
                        var tagSearch = selectedTag !== tag ? (0, _ramda.contains)(tag, partner.tags) : true;
                        return textSearch && tagSearch;
                      })
                    });
                  }
                });
              })
            )
          )
        )
      ),
      _react2.default.createElement(
        _materialUi.TableBody,
        { displayRowCheckbox: false },

        // the filter is reduce the amount of initial rendering
        partnersToShow.filter(function (_, i) {
          return partnersToShow.length < 81 || sendToPartners.showAllExisting || i < 81;
        }).map(function (partner, i) {
          return _react2.default.createElement(
            _materialUi.TableRow,
            { key: i, style: { height: '32px' } },
            _react2.default.createElement(
              _materialUi.TableRowColumn,
              { colSpan: '1' },
              _react2.default.createElement(_materialUi.Checkbox, {
                onCheck: (0, _ramda.ifElse)(function () {
                  return (0, _ramda.contains)(partner, sendToPartners.selectedExistingPartners);
                }, function () {
                  return uncheck({ checkType: 'uncheckOne', partner: partner });
                }, function () {
                  return check({ checkType: 'checkOne', partner: partner });
                }),
                checked: (0, _ramda.contains)(partner, sendToPartners.selectedExistingPartners)
              })
            ),
            _react2.default.createElement(
              _materialUi.TableRowColumn,
              { style: { height: '32px', fontSize: '14px', textAlign: 'center', padding: 0 }, colSpan: '1' },
              partner.profileImageUrl ? _react2.default.createElement(_materialUi.Avatar, { src: partner.profileImageUrl }) : _react2.default.createElement(
                _materialUi.Avatar,
                null,
                _ramda2.default.head(partner.companyId ? partner.companyName : partner.email)
              )
            ),
            _react2.default.createElement(
              _materialUi.TableRowColumn,
              { style: { height: '32px', fontSize: '14px' }, colSpan: '5' },
              partner.companyName
            ),
            _react2.default.createElement(
              _materialUi.TableRowColumn,
              { style: { height: '32px', fontSize: '14px' }, colSpan: '5' },
              partner.email
            ),
            _react2.default.createElement(
              _materialUi.TableRowColumn,
              { style: { fontSize: '14px', padding: 0, whiteSpace: 'pre-wrap' }, colSpan: '3' },
              partner.tags.join(', ')
            )
          );
        })
      )
    ),
    partnersToShow && partnersToShow.length > 80 ? _react2.default.createElement(
      'div',
      {
        style: { lineHeight: '48px', color: '#00bcd4', cursor: 'pointer' },
        onClick: function onClick() {
          return updateProps({ showAllExisting: !sendToPartners.showAllExisting });
        }
      },
      sendToPartners.showAllExisting ? 'Show Less' : 'Show All'
    ) : _react2.default.createElement('div', null)
  );
};

TableContainer.propTypes = {
  sendToPartners: _react.PropTypes.object,
  check: _react.PropTypes.func,
  uncheck: _react.PropTypes.func,
  updateProps: _react.PropTypes.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    check: function check() {
      return dispatch(_actions.checkConnection.apply(undefined, arguments));
    },
    uncheck: function uncheck() {
      return dispatch(_actions.uncheckConnection.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting;
  return {
    sendToPartners: contracting.sendToPartners.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TableContainer);

/***/ }),
/* 3260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _tcContactImport = __webpack_require__(1456);

var _tcContactImport2 = _interopRequireDefault(_tcContactImport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportFromEmail = function ImportFromEmail(props) {
  var updateProps = props.updateProps,
      sendToPartners = props.sendToPartners,
      processPartners = props.processPartners;


  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: sendToPartners.showEmailImportDialog,
      actions: [_react2.default.createElement(_materialUi.FlatButton, {
        label: 'Cancel',
        primary: true,
        labelStyle: { fontWeight: '600' },
        onTouchTap: function onTouchTap() {
          return updateProps({
            showEmailImportDialog: false,
            addPartnersMethod: ''
          });
        }
      })],
      title: 'Import From Email',
      contentStyle: { width: '512px' },
      bodyStyle: { paddingTop: '0' }
    },
    _react2.default.createElement(
      'div',
      { style: { marginTop: '15px' } },
      _react2.default.createElement(
        'div',
        { style: { marginBottom: '15px' } },
        'Select which email provider you would like to import your contacts from.'
      ),
      _react2.default.createElement(_tcContactImport2.default, {
        afterSubmitContacts: function afterSubmitContacts(contacts) {
          var pullEmail = contacts.map(function (contact) {
            return {
              email: (0, _ramda.prop)('__selectedMail__', contact)
            };
          });
          processPartners({
            showEmailImportDialog: false,
            addPartnersMethod: '',
            partnersToSendTo: sendToPartners.partnersToSendTo.concat(pullEmail)
          });
        }
      })
    )
  );
};

ImportFromEmail.propTypes = {
  updateProps: _react.PropTypes.func,
  sendToPartners: _react.PropTypes.object
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting;
  return {
    sendToPartners: contracting.sendToPartners.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ImportFromEmail);

/***/ }),
/* 3261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _csvUploadContainer = __webpack_require__(1458);

var _csvUploadContainer2 = _interopRequireDefault(_csvUploadContainer);

var _exCsvUploadContracting = __webpack_require__(1860);

var _exCsvUploadContracting2 = _interopRequireDefault(_exCsvUploadContracting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UploadFile = function UploadFile(props) {
  var updateProps = props.updateProps,
      sendToPartners = props.sendToPartners,
      processPartners = props.processPartners;


  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_csvUploadContainer2.default, {
      onCompleteFunc: function onCompleteFunc(successfulRows) {
        processPartners({
          showUploadFileDialog: false,
          addPartnersMethod: '',
          partnersToSendTo: sendToPartners.partnersToSendTo.concat(successfulRows)
        });
      },
      showFailedSection: true,
      open: sendToPartners.showUploadFileDialog,
      onRequestClose: function onRequestClose() {
        return updateProps({ showUploadFileDialog: false, addPartnersMethod: '' });
      },
      dialogTitle: 'Upload A File',
      note: _react2.default.createElement(
        'div',
        null,
        'The CSV or Excel file must have the following layout: ',
        _react2.default.createElement(
          'b',
          null,
          'Company Name (optional), Email (required)'
        ),
        '. Example format:',
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('img', { src: _exCsvUploadContracting2.default, width: 500 })
      ),
      dropzoneText: 'Drag and drop your CSV or Excel file here or click inside to choose a file from your computer.',
      headers: [{
        headerTitle: 'companyName',
        required: false
      }, {
        headerTitle: 'email',
        required: true
      }]
    })
  );
};

UploadFile.propTypes = {
  updateProps: _react.PropTypes.func,
  sendToPartners: _react.PropTypes.object,
  processPartners: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting;
  return {
    sendToPartners: contracting.sendToPartners.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(UploadFile);

/***/ }),
/* 3262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _validations = __webpack_require__(871);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);

var AddIndividually = function AddIndividually(props) {
  var updateProps = props.updateProps,
      sendToPartners = props.sendToPartners,
      processPartners = props.processPartners;


  var textFields = [{
    cyData: 'companyNameInput',
    icon: 'tc-icon-office',
    iconStyle: { color: '#757575', lineHeight: '1', margin: '0px 28px 0px 7px' },
    label: 'Company Name (optional)',
    func: function func(_ref) {
      var value = _ref.target.value;
      return updateProps({ individualCompanyName: value });
    }
  }, {
    cyData: 'emailInput',
    icon: 'tc-icon-email',
    iconStyle: { color: '#757575', margin: '0px 28px 0px 10px', fontSize: '20px' },
    label: 'Email (REQUIRED)',
    func: function func(_ref2) {
      var value = _ref2.target.value;
      return updateProps({ individualEmail: value });
    }
  }];

  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: sendToPartners.showAddIndividuallyDialog,
      actions: [_react2.default.createElement(_materialUi.FlatButton, {
        'data-cy': 'addIndividuallyCancel',
        label: 'Cancel',
        primary: true,
        labelStyle: { fontWeight: '600' },
        onTouchTap: function onTouchTap() {
          return updateProps({
            showAddIndividuallyDialog: false,
            addPartnersMethod: ''
          });
        }
      }), _react2.default.createElement(_materialUi.FlatButton, {
        'data-cy': 'addIndividuallyContinue',
        label: 'ADD',
        secondary: true,
        labelStyle: { fontWeight: '600' },
        onTouchTap: function onTouchTap() {
          return processPartners({
            showAddIndividuallyDialog: false,
            partnersToSendTo: (0, _ramda.not)(isNilOrEmpty(sendToPartners.individualCompanyName)) ? (0, _ramda.append)({
              companyName: sendToPartners.individualCompanyName,
              email: sendToPartners.individualEmail
            }, sendToPartners.partnersToSendTo) : (0, _ramda.append)({
              email: sendToPartners.individualEmail
            }, sendToPartners.partnersToSendTo),
            individualCompanyName: '',
            individualEmail: ''
          });
        },
        disabled: (0, _ramda.isEmpty)(sendToPartners.individualEmail)
      })],
      title: 'Add Individually',
      contentStyle: { width: '512px' },
      bodyStyle: { paddingTop: '0' }
    },
    textFields.map(function (field, i) {
      return _react2.default.createElement(
        'div',
        { className: 'add-individ-connection-dialog', key: i },
        _react2.default.createElement(_materialUi.FontIcon, {
          className: field.icon,
          style: field.iconStyle
        }),
        _react2.default.createElement(_materialUi.TextField, {
          'data-cy': field.cyData,
          floatingLabelText: field.label,
          floatingLabelStyle: { fontSize: '1.1vw' },
          style: { width: '85%', marginBottom: '20px' },
          onChange: field.func
        })
      );
    })
  );
};

AddIndividually.propTypes = {
  updateProps: _react.PropTypes.func,
  sendToPartners: _react.PropTypes.object
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var contracting = _ref3.contracting;
  return {
    sendToPartners: contracting.sendToPartners.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddIndividually);

/***/ }),
/* 3263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _messageBox = __webpack_require__(1137);

var _messageBox2 = _interopRequireDefault(_messageBox);

var _emailToPartners = __webpack_require__(1540);

var _emailToPartners2 = _interopRequireDefault(_emailToPartners);

var _materialUi = __webpack_require__(3);

var _successPage = __webpack_require__(3264);

var _successPage2 = _interopRequireDefault(_successPage);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _link = __webpack_require__(1254);

var _link2 = _interopRequireDefault(_link);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var ReviewAndSend = function (_React$Component) {
  _inherits(ReviewAndSend, _React$Component);

  function ReviewAndSend() {
    _classCallCheck(this, ReviewAndSend);

    var _this = _possibleConstructorReturn(this, (ReviewAndSend.__proto__ || Object.getPrototypeOf(ReviewAndSend)).call(this));

    _this.state = {
      showAllInReview: false
    };
    return _this;
  }

  _createClass(ReviewAndSend, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          partners = _props.partners,
          sendingContracts = _props.sendingContracts,
          updateProps = _props.updateProps,
          templateSelected = _props.templateSelected,
          templateGroupSelected = _props.templateGroupSelected,
          sentPartnersLength = _props.sentPartnersLength,
          message = _props.message,
          subject = _props.subject,
          bccSelf = _props.bccSelf,
          contractsSent = _props.contractsSent;

      var contractsToBeCreated = isNilOrEmpty(templateGroupSelected) ? sentPartnersLength : _ramda2.default.pathOr(0, ['templates', 'length'], templateGroupSelected) * sentPartnersLength;
      if (sendingContracts) {
        return _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          _react2.default.createElement(_materialUi.CircularProgress, { size: 120 }),
          _react2.default.createElement(
            'p',
            { style: { fontSize: '16px', margin: '32px' } },
            'We are processing your request, thanks for your patience!'
          )
        );
      }
      if (contractsSent && contractsToBeCreated > 100) {
        return _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          _react2.default.createElement(
            'p',
            { style: { fontSize: '16px', margin: '32px' } },
            'We are processing your request. Due to the large number of contracts, this may take a little while. Feel free to continue working in the system.'
          ),
          _react2.default.createElement(_materialUi.RaisedButton, {
            secondary: true,
            style: { margin: '24px auto' },
            label: 'Go to My Contract List',
            onTouchTap: function onTouchTap() {
              return _this2.context.router.push('/contracting/contract-list/all%20contracts');
            }
          })
        );
      }
      if (contractsSent && contractsToBeCreated < 101) {
        return _react2.default.createElement(_successPage2.default, {
          contractsToBeCreated: contractsToBeCreated,
          sentPartnersLength: sentPartnersLength
        });
      }
      var labelStyle = { width: '70%', color: 'rgba(0, 0, 0, 0.64)', marginRight: '40px' };
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { borderBottom: '1px solid #e0e0e0', lineHeight: '32px', marginBottom: '20px', fontWeight: 'bold' } },
          'Organize Buyers and Contracts'
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingLeft: '16px' } },
          _react2.default.createElement(_materialUi.Checkbox, {
            labelStyle: labelStyle,
            style: { marginBottom: '16px' },
            label: 'Assign a tag to ' + (0, _pluralize2.default)('buyers', partners.length),
            onCheck: function onCheck(_, inputChecked) {
              return updateProps({ assignTag: inputChecked });
            }
          }),
          Boolean(this.props.assignTag) && _react2.default.createElement(
            'div',
            { style: { marginBottom: '16px' } },
            _react2.default.createElement(
              'div',
              { style: _extends({}, labelStyle, { fontSize: '12px' }) },
              'To assign a tag to these ',
              (0, _pluralize2.default)('buyer', partners.length),
              ' in the Connections enter the tag name below'
            ),
            _react2.default.createElement(_materialUi.TextField, {
              style: { width: '40%' },
              hintText: 'Enter tag name here...',
              onChange: function onChange(_, value) {
                return updateProps({ tags: [value] });
              }
            })
          ),
          _react2.default.createElement(_materialUi.Checkbox, {
            labelStyle: labelStyle,
            style: { marginBottom: '16px' },
            label: 'Assign ' + (0, _pluralize2.default)('contracts', partners.length) + ' to a folder',
            onCheck: function onCheck(_, inputChecked) {
              return updateProps({ assignFolder: inputChecked });
            }
          }),
          Boolean(this.props.assignFolder) && _react2.default.createElement(
            'div',
            { style: { marginBottom: '16px' } },
            _react2.default.createElement(
              'div',
              { style: _extends({}, labelStyle, { fontSize: '12px' }) },
              'To assign these ',
              (0, _pluralize2.default)('contracts', partners.length),
              ' to a folder in the Contract List enter the folder name below'
            ),
            _react2.default.createElement(_materialUi.TextField, {
              style: { width: '40%' },
              hintText: 'Enter folder name here...',
              onChange: function onChange(_, value) {
                return updateProps({ folders: [value] });
              }
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { borderBottom: '1px solid #e0e0e0', lineHeight: '32px', marginBottom: '20px', fontWeight: 'bold' } },
          'Review & Send'
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingLeft: '16px' } },
          _react2.default.createElement(_materialUi.Checkbox, {
            checked: bccSelf,
            onCheck: function onCheck() {
              return updateProps({ bccSelf: !bccSelf });
            },
            label: 'Send a Copy to yourself',
            labelStyle: { color: 'rgba(0, 0, 0, 0.64)' },
            style: { width: '250px', margin: '8px 0' }
          }),
          _react2.default.createElement(
            'label',
            { style: { fontSize: '14px' } },
            'Subject:'
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('input', {
            value: subject,
            autoFocus: true,
            onChange: function onChange(_ref) {
              var value = _ref.target.value;
              return updateProps({ subject: value });
            },
            style: { width: '100%', height: '32px' }
          }),
          _react2.default.createElement(
            'div',
            { style: { fontSize: '14px', margin: '12px 8px 24px 0', color: '#616161' } },
            _react2.default.createElement(
              'label',
              null,
              'Custom Message: '
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_messageBox2.default, {
              value: message,
              onChange: function onChange(value) {
                return updateProps({ message: value });
              }
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'div',
              null,
              'Send your partner a nice message with your rates, above. Be sure to include any important information about your rates. For example:',
              _react2.default.createElement('br', null),
              '- Are your rates the same as last year or did they change?',
              _react2.default.createElement('br', null),
              '- How much did they change?',
              _react2.default.createElement('br', null),
              '- Did any of your key policies change?'
            )
          )
        )
      );
    }
  }]);

  return ReviewAndSend;
}(_react2.default.Component);

ReviewAndSend.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = ReviewAndSend;

/***/ }),
/* 3264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Basic Account Partners Threshold
var basicNo = 20;
var SuccessPage = function SuccessPage(_ref, _ref2) {
  var contractsToBeCreated = _ref.contractsToBeCreated,
      sentPartnersLength = _ref.sentPartnersLength,
      onRequestClose = _ref.onRequestClose,
      contractingPartners = _ref.contractingPartners,
      billingPlan = _ref.billingPlan,
      newPartnersSelected = _ref.newPartnersSelected,
      isShellAccount = _ref.isShellAccount,
      templates = _ref.templates;
  var router = _ref2.router;

  var contractingPartnersLength = _ramda2.default.propOr(0, 'length', contractingPartners) + (newPartnersSelected.length || 0);
  return _react2.default.createElement(
    'div',
    { style: { marginTop: '32px', textAlign: 'center' } },
    _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-paperplane', color: '#00bcd4', style: { fontSize: '128px' } }),
    _react2.default.createElement(
      'p',
      { style: { fontSize: '16px', margin: '16px' } },
      'Congratulations!',
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'p',
        { style: { marginBottom: '0' } },
        'We have sent your rates\xA0to\xA0',
        sentPartnersLength,
        '\xA0',
        (0, _pluralize2.default)('partner', sentPartnersLength),
        '.'
      )
    ),
    isShellAccount && _ramda2.default.isEmpty(templates) ? _react2.default.createElement(
      'p',
      null,
      'We\'ve also saved these rates as a template, so you can send them to other partners and access them in the future.'
    ) : _react2.default.createElement(
      'p',
      null,
      'If you need to send updates in the future, simply edit the contract or template.'
    ),
    Boolean(billingPlan === 'basic' && contractingPartnersLength) && _react2.default.createElement(
      'div',
      { style: { padding: '24px' } },
      _react2.default.createElement(
        'div',
        { style: { fontStyle: 'italic' } },
        'You have used ' + contractingPartnersLength + '/' + basicNo + ' of your free contracting partners under the Basic Plan.'
      ),
      _react2.default.createElement(
        'div',
        { style: { fontStyle: 'italic' } },
        'You can \xA0',
        _react2.default.createElement(_materialUi.RaisedButton, { label: 'upgrade', secondary: true, onTouchTap: function onTouchTap() {
            return undefined.context.router.push('/upgrade');
          } }),
        '\xA0 to send your contracts to all of the partners you work with.'
      )
    ),
    _react2.default.createElement(_materialUi.FlatButton, {
      label: 'Go to my Contract List',
      labelStyle: { color: '#fb5500' },
      onTouchTap: function onTouchTap() {
        if (onRequestClose) onRequestClose();
        router.push('/contracting/contract-list/all%20contracts');
      }
    }),
    _react2.default.createElement(_materialUi.FlatButton, {
      label: 'Keep working on my templates',
      secondary: true,
      onTouchTap: function onTouchTap() {
        if (onRequestClose) onRequestClose();
        router.push('/contracting/template-list');
      }
    })
  );
};
var mapStateToProps = function mapStateToProps(_ref3) {
  var user = _ref3.user,
      contracting = _ref3.contracting;
  return {
    billingPlan: user.get('billingPlan'),
    isShellAccount: user.get('contractingShell'),
    templates: contracting.templateList.get('templates').toJS(),
    contractingPartners: contracting.sendToPartners.get('contractingPartners').toJS().filter(function (obj) {
      return obj.paidBy === 'Supplier';
    }),
    newPartnersSelected: contracting.sendToPartners.get('newPartnersSelected').toJS()
  };
};
SuccessPage.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(SuccessPage);

/***/ }),
/* 3265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _immutable = __webpack_require__(26);

var _singleAllocationNode = __webpack_require__(1964);

var _singleAllocationNode2 = _interopRequireDefault(_singleAllocationNode);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _askIfVaryBySeason = __webpack_require__(1965);

var _askIfVaryBySeason2 = _interopRequireDefault(_askIfVaryBySeason);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var propTypes = {
  templateSelected: _react2.default.PropTypes.object,
  templateGroupSelected: _react2.default.PropTypes.object,
  partners: _react2.default.PropTypes.array,
  productIdNameMap: _react2.default.PropTypes.object,
  updateSendToPartnerReducer: _react2.default.PropTypes.func,
  showAllocationError: _react2.default.PropTypes.bool
};

var AddAllotments = function (_React$Component) {
  _inherits(AddAllotments, _React$Component);

  function AddAllotments() {
    _classCallCheck(this, AddAllotments);

    return _possibleConstructorReturn(this, (AddAllotments.__proto__ || Object.getPrototypeOf(AddAllotments)).apply(this, arguments));
  }

  _createClass(AddAllotments, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes);
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          partners = _props.partners,
          productIdNameMap = _props.productIdNameMap,
          updateSendToPartnerReducer = _props.updateSendToPartnerReducer,
          templateSelected = _props.templateSelected,
          templateGroupSelected = _props.templateGroupSelected,
          showAllocationError = _props.showAllocationError;

      var templates = isNilOrEmpty(templateSelected) ? templateGroupSelected.templates : [templateSelected];
      return _react2.default.createElement(
        'div',
        null,
        partners.map(function (partner, partnerIndex) {
          return _react2.default.createElement(
            _materialUi.Card,
            { key: partnerIndex, expandable: true, style: { boxShadow: 'none' }, initiallyExpanded: false },
            _react2.default.createElement(_materialUi.CardHeader, {
              actAsExpander: true,
              showExpandableButton: true,
              style: { borderBottom: '1px solid #e0e0e0' },
              title: _react2.default.createElement(
                _materialUi.Chip,
                null,
                partner.profileImageUrl ? _react2.default.createElement(_materialUi.Avatar, { src: partner.profileImageUrl }) : _react2.default.createElement(
                  _materialUi.Avatar,
                  null,
                  _ramda2.default.head(partner.email && partner.email !== 'via TourConnect' ? partner.email : partner.company_name)
                ),
                partner.company_name || partner.companyName || partner.email
              )
            }),
            _react2.default.createElement(
              _materialUi.CardText,
              { expandable: true },
              (partner.templates || templates).map(function (template, templateIndex) {
                return _react2.default.createElement(
                  'div',
                  { key: templateIndex, style: { paddingLeft: '5%' } },
                  _react2.default.createElement(
                    'div',
                    { style: { fontSize: '16px', lineHeight: '32px' } },
                    _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-location_on', color: 'rgba(0, 0, 0, 0.54)' }),
                    template.locationName
                  ),
                  template.products.map(function (product, productIndex) {
                    var productId = product.productId,
                        customizedAllocation = product.customizedAllocation,
                        includeSpecialAllocation = product.includeSpecialAllocation,
                        varyBySeason = product.varyBySeason,
                        seasons = product.seasons,
                        seasonRates = product.seasonRates;

                    var seasonNames = _ramda2.default.pluck('seasonName', isNilOrEmpty(seasons) ? seasonRates : seasons);
                    return _react2.default.createElement(
                      'div',
                      { key: productIndex, style: { paddingLeft: '5%' } },
                      _react2.default.createElement(
                        'div',
                        { style: { display: 'flex', justifyContent: 'space-between' } },
                        productIdNameMap[productId],
                        _react2.default.createElement(_materialUi.Toggle, {
                          toggled: Boolean(includeSpecialAllocation),
                          label: 'Include Special Allocation',
                          style: { width: '240px' },
                          labelPosition: 'right',
                          onToggle: function onToggle(_, newVal) {
                            var updatedImmutableProd = (0, _immutable.fromJS)(product).merge({
                              includeSpecialAllocation: newVal,
                              varyBySeason: newVal ? varyBySeason : undefined,
                              customizedAllocation: newVal ? customizedAllocation : undefined
                            });
                            // why if blocks: only the first time toggle need to update templates in the reducer, less updates better experience
                            if (!partner.templates) {
                              var updatedImmutablePartner = (0, _immutable.fromJS)(partner).merge((0, _immutable.fromJS)({ templates: partner.templates || templates })).setIn(['templates', templateIndex, 'products', productIndex], updatedImmutableProd);
                              updateSendToPartnerReducer({
                                keyPath: ['partnersToSendTo', partnerIndex],
                                immutableValue: updatedImmutablePartner
                              });
                            } else {
                              updateSendToPartnerReducer({
                                keyPath: ['partnersToSendTo', partnerIndex, 'templates', templateIndex, 'products', productIndex],
                                immutableValue: updatedImmutableProd
                              });
                            }
                          }
                        })
                      ),
                      includeSpecialAllocation ? _react2.default.createElement(
                        'div',
                        { style: { paddingBottom: '24px' } },
                        _react2.default.createElement(_askIfVaryBySeason2.default, {
                          name: 'Allocation',
                          enableManualDatesEntry: false,
                          varyBySeason: varyBySeason,
                          useSeasons: false,
                          selectIfVaryBySeason: function selectIfVaryBySeason(newVal) {
                            var singleEmptyAllo = { allocationType: 'allotment', allotments: [{}] };
                            var newAllo = newVal ? seasonNames.map(_ramda2.default.always(singleEmptyAllo)) : [singleEmptyAllo];
                            var immutableProduct = (0, _immutable.fromJS)(product).merge((0, _immutable.fromJS)({
                              varyBySeason: newVal,
                              customizedAllocation: newVal !== varyBySeason ? newAllo : customizedAllocation
                            }));
                            updateSendToPartnerReducer({
                              keyPath: ['partnersToSendTo', partnerIndex, 'templates', templateIndex, 'products', productIndex],
                              immutableValue: immutableProduct
                            });
                          }
                        }),
                        customizedAllocation ? customizedAllocation.map(function (_ref, allocationIndex) {
                          var allocationType = _ref.allocationType,
                              allotments = _ref.allotments,
                              releaseBackDays = _ref.releaseBackDays;

                          var path = ['partnersToSendTo', partnerIndex, 'templates', templateIndex, 'products', productIndex, 'customizedAllocation'];
                          return _react2.default.createElement(
                            'div',
                            { key: allocationIndex, style: { padding: '0 0 4px 2%', margin: '8px 5%', display: 'flex', justifyContent: 'space-between', border: '3px solid #e0e0e0' } },
                            _react2.default.createElement(
                              'div',
                              { style: { width: '30%', paddingTop: '12px' } },
                              varyBySeason ? seasonNames[allocationIndex] : 'All Year'
                            ),
                            _react2.default.createElement(
                              'div',
                              { style: { width: '65%' } },
                              _react2.default.createElement(_singleAllocationNode2.default, {
                                index: allocationIndex,
                                style: { width: '100%', margin: 0 },
                                showError: showAllocationError,
                                allocationType: allocationType,
                                allotments: allotments,
                                releaseBackDays: releaseBackDays,
                                onTextFieldChangeWithKeyPath: function onTextFieldChangeWithKeyPath(_ref2) {
                                  var keyPath = _ref2.keyPath,
                                      value = _ref2.value;
                                  return updateSendToPartnerReducer({
                                    keyPath: _ramda2.default.concat(path, keyPath),
                                    immutableValue: _ramda2.default.is(Object, value) ? (0, _immutable.fromJS)(value) : value
                                  });
                                },
                                addOneElementWithKeyPath: function addOneElementWithKeyPath() {
                                  return updateSendToPartnerReducer({
                                    keyPath: _ramda2.default.concat(path, [allocationIndex, 'allotments']),
                                    immutableValue: (0, _immutable.fromJS)(_ramda2.default.append({}, allotments))
                                  });
                                },
                                deleteOneElementWithKeyPath: function deleteOneElementWithKeyPath(_ref3) {
                                  var keyPath = _ref3.keyPath;
                                  return updateSendToPartnerReducer({
                                    keyPath: _ramda2.default.concat(path, [allocationIndex, 'allotments']),
                                    immutableValue: (0, _immutable.fromJS)(_ramda2.default.remove(_ramda2.default.last(keyPath), 1, allotments))
                                  });
                                }
                              })
                            )
                          );
                        }) : _react2.default.createElement('span', null)
                      ) : _react2.default.createElement('span', null)
                    );
                  })
                );
              })
            )
          );
        })
      );
    }
  }]);

  return AddAllotments;
}(_react2.default.Component);

AddAllotments.propTypes = propTypes;
var mapStateToProps = function mapStateToProps(_ref4) {
  var contracting = _ref4.contracting;
  return {
    partners: contracting.sendToPartners.get('partnersToSendTo').toJS(),
    productIdNameMap: contracting.supplierWizard.get('productIdNameMap').toJS()
  };
};
var mapDispatchToActions = function mapDispatchToActions(dispatch) {
  return {
    updateSendToPartnerReducer: function updateSendToPartnerReducer(payload) {
      return dispatch({ type: 'UPDATE_CONTRACTING_SEND_TO_PARNTNERS_WITH_KEYPATH', payload: payload });
    }
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToActions)(AddAllotments);

/***/ }),
/* 3266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _contractWindow = __webpack_require__(3267);

var _contractWindow2 = _interopRequireDefault(_contractWindow);

var _watermark = __webpack_require__(1547);

var _watermark2 = _interopRequireDefault(_watermark);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRouterRedux = __webpack_require__(27);

var _addEditContractDialog = __webpack_require__(1548);

var _addEditContractDialog2 = _interopRequireDefault(_addEditContractDialog);

var _container = __webpack_require__(3342);

var _container2 = _interopRequireDefault(_container);

var _reactRedux = __webpack_require__(6);

var _rootActionsMap = __webpack_require__(1135);

var _rootActionsMap2 = _interopRequireDefault(_rootActionsMap);

var _userInputActions = __webpack_require__(1002);

var _contractActivitiesProductsActions = __webpack_require__(493);

var _dashboardActions = __webpack_require__(1988);

var _resendOrUpdateDialog = __webpack_require__(1141);

var _resendOrUpdateDialog2 = _interopRequireDefault(_resendOrUpdateDialog);

var _dialogCreateContractDraft = __webpack_require__(3347);

var _dialogCreateContractDraft2 = _interopRequireDefault(_dialogCreateContractDraft);

var _docCookie = __webpack_require__(142);

var _docCookie2 = _interopRequireDefault(_docCookie);

var _accessCheckHelperFns = __webpack_require__(631);

var _publishDraftDialog = __webpack_require__(1260);

var _publishDraftDialog2 = _interopRequireDefault(_publishDraftDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getMainTitle = function getMainTitle(partnerCompanyName, locationName) {
  var flipConcat = _ramda2.default.flip(_ramda2.default.concat);
  var lengthGt = function lengthGt(gtNum) {
    return _ramda2.default.compose(_ramda2.default.lt(gtNum), _ramda2.default.length);
  };
  var composeThreeDotsString = function composeThreeDotsString(gtNum) {
    return _ramda2.default.ifElse(lengthGt(gtNum), _ramda2.default.compose(flipConcat('...'), _ramda2.default.slice(0, gtNum)), _ramda2.default.slice(0, gtNum));
  };
  var composeString = function composeString(a, b) {
    return a + ' / ' + b;
  };
  var companyNameCheck = _ramda2.default.call(composeThreeDotsString(23), partnerCompanyName);
  var hasLocation = _ramda2.default.ifElse(_ramda2.default.useWith(_ramda.and, [lengthGt(23), lengthGt(50)]), _ramda2.default.useWith(composeString, [composeThreeDotsString(23), composeThreeDotsString(23)]), function (company, location) {
    return companyNameCheck + ' / ' + _ramda2.default.call(composeThreeDotsString(72 - companyNameCheck.length), location);
  });
  return _ramda2.default.ifElse(function () {
    return !locationName;
  }, composeThreeDotsString(72), hasLocation)(partnerCompanyName, locationName);
};
/*
@params pathname = route || location.pathname
 */
var getRouteName = _ramda2.default.cond([[_ramda2.default.contains('activities'), _ramda2.default.always('activities')], [_ramda2.default.contains('notes'), _ramda2.default.always('notes')], [_ramda2.default.contains('product'), _ramda2.default.always('product')], [_ramda2.default.contains('policies'), _ramda2.default.always('policies')], [_ramda2.default.T, _ramda2.default.always('contractDetails')]]);

var propTypes = {
  children: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  location: _react.PropTypes.object,
  contentLoading: _react.PropTypes.bool,
  leftNavLoading: _react.PropTypes.bool,
  errorOccurs: _react.PropTypes.string,
  leftNav: _react.PropTypes.object,
  rightSideContent: _react.PropTypes.object,
  params: _react.PropTypes.object,
  getContractDetails: _react.PropTypes.func,
  getProductDetails: _react.PropTypes.func,
  changeContractStateTo: _react.PropTypes.func,
  openAddEditContractDialog: _react.PropTypes.func,
  getContractLeftNav: _react.PropTypes.func,
  getHistoryFeeds: _react.PropTypes.func,
  downloadContractPdf: _react.PropTypes.func,
  changeResendContractDialogState: _react.PropTypes.func,
  onClickDiscardRequestsSentToSameName: _react.PropTypes.func,
  clearStore: _react.PropTypes.func,
  companyType: _react.PropTypes.string,
  isShellAccount: _react.PropTypes.bool,
  createDraftDialogOpen: _react.PropTypes.bool,
  toggleCreateDraftDialog: _react.PropTypes.func,
  createDummyTemplateDraft: _react.PropTypes.func,
  readOnly: _react.PropTypes.bool,
  noAccess: _react.PropTypes.bool,
  viewerId: _react.PropTypes.string
};

var Container = function (_Component) {
  _inherits(Container, _Component);

  function Container() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref, [this].concat(args))), _this), _this.routeToFirstProductOrSupplierWizard = function (newLeftNav) {
      var _this$props = _this.props,
          location = _this$props.location,
          params = _this$props.params,
          companyType = _this$props.companyType;
      // AUTO route user to the first product page

      var routeName = getRouteName(location.pathname);
      // route to supplier wizard if supplier viewing request
      if (newLeftNav && !newLeftNav.payload.locationId && companyType === 'Supplier' && routeName !== 'activities' && routeName !== 'notes') {
        return _this.context.router.replace('/contracting/supplier-wizard/' + params.contractId);
      }
      if (routeName === 'contractDetails') {
        var firstProduct = _ramda2.default.path(['payload', 'productsArray', 0], newLeftNav);
        if (!firstProduct) _this.context.router.replace(location.pathname.replace('details', 'policies'));else {
          var ratePackageId = function () {
            if (firstProduct._id) return firstProduct._id;
            return firstProduct.ratePackageName ? encodeURIComponent(firstProduct.ratePackageName) : 'Primary';
          }();
          _this.context.router.replace('/contracting/contract/' + params.contractId + '/product/' + firstProduct.productId + '/' + ratePackageId);
        }
      }
    }, _this.changeLeftNavRoute = function (route) {
      var location = _this.props.location;
      var router = _this.context.router;

      if (location.pathname !== route) {
        router.replace(route);
      }
    }, _this.createNGoToDraft = function () {
      var _this$props2 = _this.props,
          leftNav = _this$props2.leftNav,
          params = _this$props2.params,
          companyType = _this$props2.companyType;
      var contractId = params.contractId,
          productId = params.productId;
      var hasDraft = leftNav.hasDraft,
          templateHasDraft = leftNav.templateHasDraft,
          templateId = leftNav.templateId;

      if (companyType === 'Supplier' && (hasDraft || templateHasDraft)) {
        var draftId = _ramda2.default.call(_ramda2.default.cond([[function () {
          return templateHasDraft;
        }, _ramda2.default.always(templateId)], [_ramda2.default.T, _ramda2.default.always(contractId)]]));
        if (!productId) _this.context.router.push('/contracting/draft/' + draftId + '/details');
      } else _this.props.toggleCreateDraftDialog();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Container, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.dispatch({ type: 'CLOSE_PUBLISH_DRAFT_DIALOG' });
      this.props.getContractLeftNav('contract', this.props.params.contractId).then(this.routeToFirstProductOrSupplierWizard);
      this.props.getHistoryFeeds('contract', this.props.params.contractId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var getContractLeftNav = nextProps.getContractLeftNav,
          params = nextProps.params;

      if (this.props.location.query !== nextProps.location.query) {
        getContractLeftNav('contract', params.contractId).then(this.routeToFirstProductOrSupplierWizard);
      }
      if (this.props.leftNav.companyName !== nextProps.leftNav.companyName) {
        document.title = getMainTitle(nextProps.leftNav.companyName || nextProps.leftNav.email || '', nextProps.leftNav.locationName || '') + ' - TourConnect';
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _docCookie2.default.removeItem('pathname');
      _docCookie2.default.removeItem('query');
      this.props.clearStore();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var router = this.context.router;
      var _props = this.props,
          children = _props.children,
          params = _props.params,
          contentLoading = _props.contentLoading,
          leftNavLoading = _props.leftNavLoading,
          errorOccurs = _props.errorOccurs,
          leftNav = _props.leftNav,
          rightSideContent = _props.rightSideContent,
          openAddEditContractDialog = _props.openAddEditContractDialog,
          changeContractStateTo = _props.changeContractStateTo,
          downloadContractPdf = _props.downloadContractPdf,
          openResendContractDialog = _props.openResendContractDialog,
          openDialogSaveAsTemplate = _props.openDialogSaveAsTemplate,
          _createDummyTemplateDraft = _props.createDummyTemplateDraft,
          isDummyAccount = _props.isDummyAccount,
          isAnAdmin = _props.isAnAdmin,
          pureDocView = _props.pureDocView,
          companyType = _props.companyType,
          goBack = _props.goBack;
      var productId = params.productId,
          contractId = params.contractId;
      var location = this.props.location;

      var routeName = getRouteName(location.pathname);
      // if (routeName !== 'activities' && (isNilOrEmpty(rightSideContent) || contentLoading) && !errorOccurs) return <div style={{ marginTop: '150px', textAlign: 'center' }}><CircularProgress size={90} thickness={4} /></div>;
      // const contractState = leftNav.contractState;
      // const acceptedOrLoaded = contractState === 'accepted' || contractState === 'loading' || contractState === 'loaded';
      // const amendmentNeeded = () => {
      //   if (acceptedOrLoaded) return confirm('This contract has already been accepted by both parties. If this contract needs to be updated, an amendment will be created. Do you want to proceed?');
      //   return true;
      // };
      var loading = contentLoading || leftNavLoading;
      var extraProps = {
        reducerName: 'contractActivitiesProducts',
        viewerId: this.props.viewerId,
        // openAddEditContractDialog: R.ifElse(amendmentNeeded, openAddEditContractDialog, () => {}),
        // TODO: fix contractor updates
        productDoesnotExistInDoc: routeName === 'product' && !loading && _ramda2.default.isNil(rightSideContent.ratePackageIndex),
        openAddEditContractDialog: openAddEditContractDialog,
        readOnly: this.props.readOnly,
        isLatest: leftNav.isLatest,
        resendContract: function resendContract() {
          return openResendContractDialog({
            contractId: contractId,
            // this function is only available for the sender
            // for whom partners length should only be one
            partner: _ramda2.default.pathOr({}, ['partners', 0], leftNav),
            to: leftNav.to,
            toEmails: leftNav.toEmails,
            resendToEmails: leftNav.toEmails
          });
        }
      };
      var propsForLeftNav = {
        reducerName: extraProps.reducerName,
        location: this.props.location,
        changeLeftNavRoute: this.changeLeftNavRoute,
        goToDashboard: function goToDashboard() {
          if (companyType === 'Contractor') {
            window.location = "https://app.tourconnect.com" + '/contracting/' + (leftNav.locationId ? 'contract' : 'workspace') + '-list?jwt=' + localStorage.getItem('jwt');
          } else if (localStorage.getItem('lastContractListHref') && localStorage.getItem('lastContractListHref').indexOf('contract-list') > -1) {
            router.push(localStorage.getItem('lastContractListHref'));
          } else {
            router.push('/contracting/contract-list/all%20contracts');
          }
        },
        changeContractStateTo: changeContractStateTo,
        openAddEditContractDialog: openAddEditContractDialog
      };
      var shouldHideAppBars = isDummyAccount && !isAnAdmin || pureDocView;
      return _react2.default.createElement(
        'div',
        {
          className: shouldHideAppBars ? 'full-screen-page' : '',
          style: shouldHideAppBars ? { padding: '0 128px' } : {}
        },
        Boolean(this.props.readOnly && !loading && leftNav.isLatest) && _react2.default.createElement(
          'div',
          { style: { textAlign: 'center', marginBottom: '-12px', marginLeft: '4px', fontWeight: 'bold' } },
          'This Contract is READ-ONLY.'
        ),
        _react2.default.createElement(_container2.default, {
          changeContractStateTo: changeContractStateTo,
          resendContract: extraProps.resendContract
        }),
        _react2.default.createElement(
          _contractWindow2.default,
          {
            routeName: routeName,
            reducerName: extraProps.reducerName,
            actionsForLeftNav: propsForLeftNav,
            actionsForContractWindow: {
              downloadContractPdf: downloadContractPdf,
              resendContract: extraProps.resendContract,
              router: router,
              changeLeftNavRoute: this.changeLeftNavRoute,
              createNGoToDraft: this.createNGoToDraft,
              onClickDiscardRequestsSentToSameName: this.props.onClickDiscardRequestsSentToSameName,
              openDialogSaveAsTemplate: openDialogSaveAsTemplate
            },
            getMainTitle: getMainTitle
          },
          // for CR, don't show watermark
          Boolean(!leftNav.isLatest && !loading && leftNav.locationId) && _react2.default.createElement(_watermark2.default, {
            texts: leftNav.amended ? ['Amended', 'Void', 'Amended', 'Void'] : ['Old Version', 'Void', 'Old Version', 'Void']
          }),
          children && !errorOccurs ? (0, _react.cloneElement)(children, extraProps) : undefined,
          errorOccurs ? _react2.default.createElement(
            'div',
            { style: { marginTop: '100px', textAlign: 'center', fontSize: '20px' } },
            errorOccurs
          ) : _react2.default.createElement('div', null),
          _react2.default.createElement(_resendOrUpdateDialog2.default, null),
          _react2.default.createElement(_publishDraftDialog2.default, { forBuyer: true }),
          _react2.default.createElement(_addEditContractDialog2.default, {
            reducerName: 'contractActivitiesProducts',
            router: this.context.router
          }),
          _react2.default.createElement(_dialogCreateContractDraft2.default, {
            templateId: leftNav.templateId,
            templateFromDummy: leftNav.templateFromDummy,
            companyType: companyType,
            open: this.props.createDraftDialogOpen,
            createSingleDraft: function createSingleDraft() {
              _this2.props.toggleCreateDraftDialog();
              (0, _contractActivitiesProductsActions.createDraft)(contractId, leftNav.templateId, false).then(function () {
                return _this2.context.router.push('/contracting/draft/' + contractId + '/details');
              });
            },
            createTemplateDraft: function createTemplateDraft() {
              _this2.props.toggleCreateDraftDialog();
              (0, _contractActivitiesProductsActions.createDraft)(contractId, leftNav.templateId, true).then(function () {
                return _this2.context.router.push('/contracting/draft/' + leftNav.templateId + '/details');
              });
            },
            createDummyTemplateDraft: function createDummyTemplateDraft() {
              return _createDummyTemplateDraft({
                contractId: contractId,
                templateId: leftNav.templateId,
                isDummyTemplate: leftNav.templateFromDummy
              });
            },
            onRequestClose: this.props.toggleCreateDraftDialog
          })
        )
      );
    }
  }]);

  return Container;
}(_react.Component);

Container.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting,
      user = _ref2.user;

  var contractStore = contracting.contractActivitiesProducts;
  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  var readOnly = !(0, _accessCheckHelperFns.checkLocAccess)({ user: user }, leftNav.locationId, 'contracting', 'write');
  var noAccess = !(0, _accessCheckHelperFns.checkLocAccess)({ user: user }, leftNav.locationId, 'contracting', 'read');
  return {
    readOnly: readOnly,
    noAccess: noAccess,
    createDraftDialogOpen: contractStore.get('createDraftDialogOpen'),
    contentLoading: contractStore.get('contentLoading'),
    leftNavLoading: contractStore.get('leftNavLoading'),
    errorOccurs: contractStore.get('errorOccurs'),
    leftNav: leftNav,
    rightSideContent: contractStore.get('rightSideContent').toJS(),
    routeName: contractStore.get('routeName'),
    billingPlan: user.get('billingPlan'),
    contractActivitiesProducts: contractStore.toJS(),
    companyType: user.getIn(['user', 'type']),
    viewerId: user.toJS().company.companyId,
    isShellAccount: user.get('contractingShell') || false,
    isDummyAccount: user.get('isDummyAccount'),
    isAnAdmin: user.get('isAnAdmin'),
    pureDocView: user.get('pureDocView')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    clearStore: function clearStore() {
      return dispatch((0, _contractActivitiesProductsActions.clearStore)());
    },
    getContractDetails: function getContractDetails() {
      return dispatch(_contractActivitiesProductsActions.getContractDetails.apply(undefined, arguments));
    },
    getContractLeftNav: function getContractLeftNav() {
      return dispatch(_contractActivitiesProductsActions.getContractLeftNav.apply(undefined, arguments));
    },
    getProductDetails: function getProductDetails() {
      return dispatch(_contractActivitiesProductsActions.getProductDetails.apply(undefined, arguments));
    },
    getHistoryFeeds: function getHistoryFeeds() {
      return dispatch(_contractActivitiesProductsActions.getHistoryFeeds.apply(undefined, arguments));
    },
    changeContractStateTo: function changeContractStateTo(state, ids) {
      return dispatch((0, _dashboardActions.changeContractState)(state, ids));
    },
    openAddEditContractDialog: (0, _userInputActions.onUserInput)(dispatch, _rootActionsMap2.default, 'openAddEditContractDialog'),
    downloadContractPdf: function downloadContractPdf() {
      return dispatch(_contractActivitiesProductsActions.downloadContractPdf.apply(undefined, arguments));
    },
    toggleCreateDraftDialog: function toggleCreateDraftDialog() {
      return dispatch({ type: '[contractTemplate]TOGGLE_CREATE_DRAFT_DIALOG' });
    },
    createDummyTemplateDraft: function createDummyTemplateDraft(payload) {
      return dispatch({ type: '{dummy-account} CREATE_DUMMY_TEMPLATE_DRAFT', payload: payload });
    },
    onClickDiscardRequestsSentToSameName: function onClickDiscardRequestsSentToSameName(payload) {
      return dispatch({ type: 'OPEN_DIALOG_SHOW_REQUESTS_WITH_SAME_NAME', payload: payload });
    },
    openResendContractDialog: function openResendContractDialog(payload) {
      return dispatch({
        type: 'CHANGE_RESEND_CONTRACT_DIALOG_STATE',
        payload: payload
      });
    },
    openDialogSaveAsTemplate: function openDialogSaveAsTemplate(_ref3) {
      var contractId = _ref3.contractId,
          contractYear = _ref3.contractYear,
          templateId = _ref3.templateId,
          isDummyTemplate = _ref3.isDummyTemplate;

      dispatch({ type: 'OPEN_AS_SAVE_CONTRACT_AS_TEMPLATE', payload: { contractId: contractId, contractYear: contractYear, templateId: templateId, isDummyTemplate: isDummyTemplate } });
    },
    goBack: function goBack(payload) {
      return dispatch((0, _reactRouterRedux.goBack)(payload));
    }
  };
};

Container.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Container);

/***/ }),
/* 3267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(67);

var _contractingWindow = __webpack_require__(1966);

var _contractingWindow2 = _interopRequireDefault(_contractingWindow);

var _nextWeek = __webpack_require__(3268);

var _nextWeek2 = _interopRequireDefault(_nextWeek);

var _redDot = __webpack_require__(1056);

var _redDot2 = _interopRequireDefault(_redDot);

var _hotel = __webpack_require__(1541);

var _hotel2 = _interopRequireDefault(_hotel);

var _explore = __webpack_require__(1967);

var _explore2 = _interopRequireDefault(_explore);

var _materialUi = __webpack_require__(3);

var _speakerNotes = __webpack_require__(1968);

var _speakerNotes2 = _interopRequireDefault(_speakerNotes);

var _reactRouterRedux = __webpack_require__(27);

var _leftNav = __webpack_require__(1969);

var _leftNav2 = _interopRequireDefault(_leftNav);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _contractMailbox = __webpack_require__(1970);

var _contractMailbox2 = _interopRequireDefault(_contractMailbox);

var _exportTourWriter = __webpack_require__(1546);

var _exportTourWriter2 = _interopRequireDefault(_exportTourWriter);

var _markunreadMailbox = __webpack_require__(1971);

var _markunreadMailbox2 = _interopRequireDefault(_markunreadMailbox);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);


var WindowDataWrapper = function WindowDataWrapper(_ref) {
  var routeName = _ref.routeName,
      children = _ref.children,
      actionsForLeftNav = _ref.actionsForLeftNav,
      actionsForContractWindow = _ref.actionsForContractWindow,
      _ref$supplierInfo = _ref.supplierInfo,
      supplierInfo = _ref$supplierInfo === undefined ? {} : _ref$supplierInfo,
      buyerChecked = _ref.buyerChecked,
      files = _ref.files,
      state = _ref.state,
      rateConversionSetting = _ref.rateConversionSetting,
      contractState = _ref.contractState,
      locationId = _ref.locationId,
      contractId = _ref.contractId,
      locationName = _ref.locationName,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      hasNewComments = _ref.hasNewComments,
      hasDraft = _ref.hasDraft,
      templateId = _ref.templateId,
      draftMagicLink = _ref.draftMagicLink,
      amended = _ref.amended,
      isLatest = _ref.isLatest,
      versions = _ref.versions,
      allVersions = _ref.allVersions,
      email = _ref.email,
      _ref$partners = _ref.partners,
      partners = _ref$partners === undefined ? [] : _ref$partners,
      isSender = _ref.isSender,
      _ref$from = _ref.from,
      from = _ref$from === undefined ? {} : _ref$from,
      _ref$to = _ref.to,
      to = _ref$to === undefined ? {} : _ref$to,
      viewingAs = _ref.viewingAs,
      templateFromDummy = _ref.templateFromDummy,
      buyerHasDraftId = _ref.buyerHasDraftId,
      _ref$rateContainer = _ref.rateContainer,
      rateContainer = _ref$rateContainer === undefined ? {} : _ref$rateContainer,
      productType = _ref.productType,
      productName = _ref.productName,
      productId = _ref.productId,
      tourPlanUser = _ref.tourPlanUser,
      push = _ref.push,
      buyerId = _ref.buyerId,
      requestDataLoading = _ref.requestDataLoading,
      pureDocView = _ref.pureDocView,
      openRateDocIframe = _ref.openRateDocIframe;

  var mainTitleStyle = {
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
  var bgColor = function () {
    if (!isLatest) return '#373737';
    if (templateFromDummy) return '#00bcd447';
    return '#00a1ba';
  }();
  var textColor = function () {
    if (templateFromDummy) return 'rgba(0, 0, 0, 0.64)';
    return '#fff';
  }();
  var requestDL = function requestDL() {
    return requestDataLoading({ contractId: contractId, files: files });
  };
  var acceptedOrLoaded = contractState === 'accepted' || contractState === 'loading' || contractState === 'loaded';
  var openDraft = function openDraft() {
    openRateDocIframe({
      url: draftMagicLink + '&jumpBackTo=' + window.location.href,
      collection: 'draft',
      rateDocId: buyerHasDraftId,
      isInSigning: false
    });
  };
  var contractHasA = function () {
    if (hasDraft && viewingAs === 'Supplier') {
      return _react2.default.createElement(
        'span',
        null,
        '\xA0\xA0\xA0This contract has an ',
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/contracting/draft/' + contractId + '/details', style: { color: 'red' } },
          'unfinished draft'
        ),
        '.'
      );
    } else if (viewingAs === 'Buyer' && buyerHasDraftId) {
      return _react2.default.createElement(
        'span',
        null,
        '\xA0\xA0\xA0This contract has an ',
        _react2.default.createElement(
          'span',
          { onClick: openDraft, style: { color: 'red', cursor: 'pointer' } },
          'unfinished draft'
        ),
        '.'
      );
    }
    // if (amendedFromId) return <span>This {isInitialAmendmentDraft ? 'draft' : 'amendment'} was created from this<a href={`/contracting/contract/${amendedFromId}/details`}> contract</a>.</span>;
  }();
  var buttonLabelStyle = { textTransform: 'none', paddingRight: '8px' };
  var buttonStyle = { color: textColor, minWidth: '68px', flex: '0 0 auto' };
  var titleName = _ramda2.default.pathOr(isSender ? to.name : from.name, [0, 'name'], partners);
  var partnerDetailsLink = function () {
    var url = "https://app.tourconnect.com" + '/partner-management/partner-details/' + _ramda2.default.pathOr('', [0, 'id'], partners) + '?jwt=' + localStorage.getItem('jwt');
    // TODO: use below after we have contactDetails page
    // const url = partners.length === 1
    //   ? `/partnerDetails/${R.pathOr('', [0, 'id'], partners)}`
    //   : `/contactDetails/${R.pathOr('', [0, 'id'], contacts)}`;
    return _react2.default.createElement(
      'span',
      {
        style: { cursor: 'pointer' },
        onClick: function onClick() {
          return window.location = url;
        }
      },
      titleName
    );
  }();
  return _react2.default.createElement(
    _contractingWindow2.default,
    {
      leftNavNode: _react2.default.createElement(_leftNav2.default, _extends({}, actionsForLeftNav, {
        textColor: textColor,
        headerStyle: {
          backgroundColor: bgColor,
          color: textColor
          // borderTop: templateFromDummy ? `1px solid ${textColor}` : 'none',
          // borderBottom: templateFromDummy ? `1px solid ${textColor}` : 'none',
        },
        leftNavTitle: 'Back to Rates & Contracts'
      })),
      textColor: textColor,
      headerStyle: {
        backgroundColor: bgColor,
        color: textColor
        // border: templateFromDummy ? `1px solid ${textColor}` : 'none',
      },
      title:
      // getMainTitle(companyName || email || '', locationName || '')
      !locationName || titleName === locationName ? _react2.default.createElement(
        'div',
        {
          style: _extends({}, mainTitleStyle, { lineHeight: '48px' })
        },
        partnerDetailsLink,
        ' ',
        supplierInfo.marketInfo ? '(' + supplierInfo.marketInfo + ')' : ''
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: mainTitleStyle },
          partnerDetailsLink
        ),
        _react2.default.createElement(
          'div',
          { style: mainTitleStyle },
          locationName,
          ' ',
          supplierInfo.marketInfo ? '(' + supplierInfo.marketInfo + ')' : ''
        )
      ),
      subtitle: {
        hideBottomBorder: routeName === 'activities',
        dateRange: _moment2.default.utc(startDate).format('D MMM YYYY') + ' - ' + _moment2.default.utc(endDate).format('D MMM YYYY'),
        name: _react2.default.createElement(
          'div',
          { style: { display: 'flex', alignItems: 'center' } },
          Boolean(productId && productType === 'Accommodation') && _react2.default.createElement(_hotel2.default, null),
          Boolean(productId && productType === 'Non-Accommodation') && _react2.default.createElement(_explore2.default, null),
          _react2.default.createElement(
            'a',
            { href: '/product/' + productId, target: '_blank', style: { marginLeft: productId ? '12px' : '0', display: 'inline-block', maxWidth: '200px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' } },
            productName
          )
        ),
        secondLineSubtitle: _react2.default.createElement(
          'div',
          { className: 'flex-tc-sb', style: { display: locationId && contractHasA ? 'flex' : 'none', lineHeight: '24px', padding: '0 24px', fontSize: '14px' } },
          _react2.default.createElement('div', null),
          _react2.default.createElement(
            'div',
            null,
            contractHasA
          )
        ),
        // don't want to show version number to confuse read only supplier
        // also should not show version number for contract request, because it's one to many relationship
        // we are displaying all rate contracts for this request, no need to show versions
        versions: !pureDocView && locationId && (isLatest && versions && versions.length > 1 || !isLatest && !isNilOrEmpty(allVersions)) ? _react2.default.createElement(
          _materialUi.IconMenu,
          {
            desktop: true,
            style: { marginLeft: '4px', cursor: 'pointer' },
            iconButtonElement: _react2.default.createElement(
              _materialUi.IconButton,
              { style: { fontSize: '12px', padding: '0', width: '100%', height: '30px' } },
              _react2.default.createElement(
                'a',
                null,
                'Version ' + versions.length
              )
            )
          },
          (isLatest ? versions : allVersions).map(function (version, i) {
            return _react2.default.createElement(_materialUi.MenuItem, {
              key: i,
              disabled: version === contractId,
              primaryText: function () {
                if (rateContainer && !i) {
                  if (viewingAs === 'Buyer') return rateContainer.partnerName + ' ' + rateContainer.year + ' contracting workspace';
                  return 'Rate Request';
                }
                return 'Version ' + (i + 1);
              }(),
              onClick: function onClick() {
                return actionsForContractWindow.changeLeftNavRoute('/contracting/contract/' + version + '/details');
              }
            });
          })
        ) : ''
      },
      titleBarRightWidgets: pureDocView ? [] : [_react2.default.createElement(
        _materialUi.IconMenu,
        { key: 'moreAction', iconButtonElement: _react2.default.createElement(_materialUi.IconButton, { iconClassName: 'tc-icon-more-vert', iconStyle: { color: textColor, fontSize: '22px', marginLeft: '8px' } }) },
        viewingAs === 'Buyer' && isLatest && !locationId && buyerChecked ? _react2.default.createElement(_materialUi.MenuItem, {
          key: 'requestDL',
          style: { fontSize: '15px', minHeight: '32px', lineHeight: '32px' },
          innerDivStyle: { padding: '0px 24px 0px 64px' },
          primaryText: 'Submit this workspace for data loading',
          onTouchTap: requestDL,
          disabled: ['loading', 'loaded', 'rejected'].indexOf(state) > -1 || ['defer', 'opt-out'].indexOf(rateConversionSetting) < 0,
          leftIcon: _react2.default.createElement(_markunreadMailbox2.default, {
            style: {
              top: '4px',
              margin: '0',
              left: '24px',
              fill: 'rgb(117, 117, 117)'
            }
          })
        }) : undefined,
        Boolean(isLatest && locationId) ? _react2.default.createElement(_materialUi.MenuItem, {
          key: 'edit',
          style: { fontSize: '15px', minHeight: '32px', lineHeight: '32px' },
          innerDivStyle: { padding: '0px 24px 0px 64px' },
          primaryText: 'Edit',
          onTouchTap: actionsForContractWindow.createNGoToDraft,
          leftIcon: _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-mode_edit',
            style: {
              top: '4px',
              margin: '0',
              left: '24px',
              fill: 'rgb(117, 117, 117)'
            }
          })
        }) : undefined,
        Boolean(viewingAs === 'Buyer' && locationId) ? _react2.default.createElement(_materialUi.MenuItem, {
          key: 'makeACopy',
          style: { fontSize: '15px', minHeight: '32px', lineHeight: '32px' },
          innerDivStyle: { padding: '0px 24px 0px 64px' },
          primaryText: 'Make A Copy',
          onClick: function onClick() {
            return actionsForContractWindow.openDialogSaveAsTemplate({
              contractId: contractId,
              contractYear: { startDate: startDate, endDate: endDate },
              templateId: templateId,
              isDummyTemplate: templateFromDummy
            });
          },
          leftIcon: _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-content_copy',
            style: {
              top: '4px',
              margin: '0',
              left: '24px',
              fill: 'rgb(117, 117, 117)'
            }
          })
        }) : undefined,
        !amended && (viewingAs === 'Supplier' && locationId || viewingAs === 'Buyer' && !locationId) ? _react2.default.createElement(_materialUi.MenuItem, {
          key: 'Resend',
          style: { fontSize: '15px', minHeight: '32px', lineHeight: '32px' },
          innerDivStyle: { padding: '0px 24px 0px 64px' },
          primaryText: 'Resend',
          onTouchTap: actionsForContractWindow.resendContract,
          leftIcon: _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-near_me',
            style: {
              top: '4px',
              margin: '0',
              left: '24px',
              fill: 'rgb(117, 117, 117)'
            } })
        }) : undefined,
        Boolean(viewingAs === 'Buyer' && !locationId) && _react2.default.createElement(_contractMailbox2.default, { contractId: contractId }),
        Boolean(viewingAs === 'Buyer' && locationId) && _react2.default.createElement(_exportTourWriter2.default, { contractId: contractId }),
        Boolean(viewingAs === 'Buyer' && locationId) && _react2.default.createElement(_exportTourWriter2.default, { contractId: contractId, blackout: true })
      ), locationId ? _react2.default.createElement(
        _wrapper2.default,
        { amazonOrange: true, key: 'compare' },
        _react2.default.createElement(_materialUi.FlatButton, {
          label: 'Compare with',
          labelStyle: { textTransform: 'none', paddingRight: '8px' },
          hoverColor: 'rgba(0, 0, 0, 0.15)',
          style: { color: textColor, minWidth: '68px' },
          onTouchTap: function onTouchTap() {
            return push('/contracting/reports/diff/contract/' + contractId + '?' + _queryString2.default.stringify({
              locationId: locationId,
              buyerId: buyerId,
              email: email,
              locationName: locationName,
              companyName: titleName
            }));
          },
          icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-swap_horiz', style: { color: textColor, fontSize: '22px', marginLeft: '8px' } })
        })
      ) : undefined, viewingAs === 'Buyer' && acceptedOrLoaded && tourPlanUser ? _react2.default.createElement(_materialUi.FlatButton, {
        key: 'Export',
        label: 'Export',
        labelStyle: buttonLabelStyle,
        hoverColor: 'rgba(0, 0, 0, 0.15)',
        style: buttonStyle,
        onTouchTap: function onTouchTap() {
          return push('/integration/product-mapping/' + contractId);
        },
        icon: _react2.default.createElement(_nextWeek2.default, { style: { color: textColor, fontSize: '22px', marginLeft: '8px' } })
      }) : undefined, locationId ? _react2.default.createElement(_materialUi.FlatButton, {
        key: 'Download',
        label: 'Download',
        labelStyle: buttonLabelStyle,
        hoverColor: 'rgba(0, 0, 0, 0.15)',
        style: buttonStyle,
        onTouchTap: function onTouchTap(e) {
          return actionsForContractWindow.downloadContractPdf(contractId, contractState, e.currentTarget);
        },
        icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-get_app', style: { color: textColor, fontSize: '22px', marginLeft: '8px' } })
      }) : undefined, _react2.default.createElement(
        _materialUi.FlatButton,
        {
          key: 'Activities',
          hoverColor: 'rgba(0, 0, 0, 0.15)',
          disabled: routeName === 'activities',
          backgroundColor: routeName === 'activities' ? 'rgba(0, 0, 0, 0.15)' : 'transparent',
          labelStyle: buttonLabelStyle,
          style: buttonStyle,
          onTouchTap: function onTouchTap() {
            return actionsForContractWindow.changeLeftNavRoute('/contracting/contract/' + contractId + '/activities');
          }
        },
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', paddingRight: '8px' } },
          _react2.default.createElement(
            'div',
            { style: { position: 'relative', top: '4px', width: '40px' } },
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-question_answer', style: { color: textColor, fontSize: '22px', marginLeft: '8px' } }),
            Boolean(hasNewComments && routeName !== 'activities') && _react2.default.createElement(_redDot2.default, null)
          ),
          _react2.default.createElement(
            'span',
            null,
            'Activities'
          )
        )
      ), _react2.default.createElement(
        _wrapper2.default,
        { amazonOrange: true, key: 'internal-notes' },
        _react2.default.createElement(_materialUi.FlatButton, {
          label: 'Internal Notes',
          hoverColor: 'rgba(0, 0, 0, 0.15)',
          disabled: routeName === 'notes',
          backgroundColor: routeName === 'notes' ? 'rgba(0, 0, 0, 0.15)' : 'transparent',
          labelStyle: buttonLabelStyle,
          style: buttonStyle,
          onTouchTap: function onTouchTap() {
            return actionsForContractWindow.changeLeftNavRoute('/contracting/contract/' + contractId + '/notes');
          },
          icon: _react2.default.createElement(_speakerNotes2.default, {
            style: { color: textColor, fontSize: '22px', marginLeft: '8px', marginBottom: '5px' }
          })
        })
      )]
    },
    children
  );
};

var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
  var contracting = _ref2.contracting,
      user = _ref2.user,
      config = _ref2.config,
      routing = _ref2.routing;
  var reducerName = _ref3.reducerName;

  var leftNav = contracting[reducerName].get('leftNav').toJS();
  var rightContent = contracting[reducerName].get('rightSideContent').toJS();
  return _extends({
    companyType: user.getIn(['user', 'type']),
    userId: user.get('id'),
    apiUrl: config.get('apiUrl'),
    tourPlanUser: user.getIn(['company', 'tourplan']) ? Boolean(user.getIn(['company', 'tourplan']).password) : false
  }, leftNav, {
    productName: rightContent.productName,
    productId: rightContent.productId,
    productType: rightContent.productType,
    routePath: routing.locationBeforeTransitions.pathname,
    pureDocView: user.get('pureDocView')
  });
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  push: _reactRouterRedux.push,
  requestDataLoading: function requestDataLoading(payload) {
    return { type: 'OPEN_REQUEST_DL', payload: payload };
  },
  openRateDocIframe: function openRateDocIframe(payload) {
    return {
      type: '{dummy-account} RateDocIframe_open',
      payload: payload
    };
  }
})(WindowDataWrapper);

/***/ }),
/* 3268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentNextWeek = function ContentNextWeek(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z' })
  );
};
ContentNextWeek = (0, _pure2.default)(ContentNextWeek);
ContentNextWeek.displayName = 'ContentNextWeek';
ContentNextWeek.muiName = 'SvgIcon';

exports.default = ContentNextWeek;

/***/ }),
/* 3269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _contractingUtils = __webpack_require__(124);

var _changeStatusMenuContractor = __webpack_require__(3270);

var _changeStatusMenuContractor2 = _interopRequireDefault(_changeStatusMenuContractor);

var _titlecase = __webpack_require__(549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LeftNavStatuses = function LeftNavStatuses(_ref) {
  var contractState = _ref.contractState,
      _changeContractStateTo = _ref.changeContractStateTo,
      contractId = _ref.contractId,
      files = _ref.files,
      companyType = _ref.companyType,
      locationId = _ref.locationId,
      originFrom = _ref.originFrom,
      buyerChecked = _ref.buyerChecked,
      buyerDownloaded = _ref.buyerDownloaded;

  if (contractState === 'draft' || contractState === 'template' || !contractState) return _react2.default.createElement('span', null);
  var shownStatus = (0, _contractingUtils.getShownState)({
    companyType: companyType,
    locationId: locationId,
    state: contractState,
    hasSeenResponseWizard: 'na',
    originFrom: originFrom,
    buyerChecked: buyerChecked,
    buyerDownloaded: buyerDownloaded,
    files: files
  });
  var capitalizedStatus = (0, _titlecase.toLaxTitleCase)(shownStatus);
  var propsForMenu = {
    state: contractState,
    shownStatus: shownStatus,
    changeContractStateTo: function changeContractStateTo(changeToState) {
      return _changeContractStateTo(changeToState, _defineProperty({}, contractId, contractId));
    },
    locationId: locationId,
    files: files
  };
  return _react2.default.createElement(
    'div',
    { className: 'flex-tc-sb', style: { borderBottom: '1px solid #d9d9d9' } },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_materialUi.IconButton, {
        iconClassName: (0, _contractingUtils.getStatusIcon)(shownStatus),
        iconStyle: { color: (0, _contractingUtils.getStatusColor)(shownStatus) }
      }),
      _react2.default.createElement(
        'span',
        { style: { color: (0, _contractingUtils.getStatusColor)(shownStatus), position: 'relative', top: '-4px' } },
        capitalizedStatus
      )
    ),
    companyType === 'Supplier' ? _react2.default.createElement('span', null) : _react2.default.createElement(_changeStatusMenuContractor2.default, propsForMenu)
  );
};

LeftNavStatuses.propTypes = {
  contractState: _react.PropTypes.string,
  changeContractStateTo: _react.PropTypes.func
};

exports.default = LeftNavStatuses;

/***/ }),
/* 3270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _contractingUtils = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangeStatusMenuForContractor = function ChangeStatusMenuForContractor(_ref) {
  var state = _ref.state,
      shownStatus = _ref.shownStatus,
      changeContractStateTo = _ref.changeContractStateTo,
      locationId = _ref.locationId,
      files = _ref.files;

  return _react2.default.createElement(
    _materialUi.IconMenu,
    {
      autoWidth: false,
      iconButtonElement: _react2.default.createElement(_materialUi.IconButton, {
        iconClassName: 'tc-icon-arrow-drop-down',
        iconStyle: { color: '#616061' }
      }),
      anchorOrigin: { horizontal: 'right', vertical: 'top' },
      targetOrigin: { horizontal: 'right', vertical: 'top' },
      menuStyle: { overflow: 'hidden' }
    },
    shownStatus !== 'sent' && !locationId ? _react2.default.createElement(_materialUi.MenuItem, {
      onTouchTap: function onTouchTap() {
        return changeContractStateTo('sent');
      },
      innerDivStyle: { color: (0, _contractingUtils.getStatusColor)('sent'), left: '-8px' },
      disabled: shownStatus === 'sent',
      leftIcon: _react2.default.createElement(_materialUi.IconButton, {
        iconClassName: (0, _contractingUtils.getStatusIcon)('sent'),
        iconStyle: { color: (0, _contractingUtils.getStatusColor)('sent'), top: '-14px' }
      }),
      primaryText: 'sent'
    }) : _react2.default.createElement('div', null),
    _react2.default.createElement(_materialUi.MenuItem, {
      onTouchTap: function onTouchTap() {
        return changeContractStateTo('received');
      },
      disabled: shownStatus === 'received',
      innerDivStyle: { color: (0, _contractingUtils.getStatusColor)('rates received'), left: '-8px' },
      leftIcon: _react2.default.createElement(_materialUi.IconButton, {
        iconClassName: (0, _contractingUtils.getStatusIcon)('rates received'),
        iconStyle: { color: (0, _contractingUtils.getStatusColor)('rates received'), top: '-14px' }
      }),
      primaryText: 'rates received'
    }),
    _react2.default.createElement(_materialUi.MenuItem, {
      disabled: (0, _ramda.equals)(state, 'accepted'),
      onTouchTap: function onTouchTap() {
        return changeContractStateTo('accepted');
      },
      innerDivStyle: { color: (0, _contractingUtils.getStatusColor)('accepted'), left: '-8px' },
      leftIcon: _react2.default.createElement(_materialUi.IconButton, {
        iconClassName: (0, _contractingUtils.getStatusIcon)('accepted'),
        iconStyle: { color: (0, _ramda.equals)(state, 'accepted') ? 'grey' : (0, _contractingUtils.getStatusColor)('accepted'), top: '-14px' }
      }),
      primaryText: 'accepted'
    }),
    _react2.default.createElement(_materialUi.MenuItem, {
      disabled: (0, _ramda.equals)(state, 'loading'),
      onTouchTap: function onTouchTap() {
        return changeContractStateTo('loading');
      },
      innerDivStyle: { color: (0, _contractingUtils.getStatusColor)('loading'), left: '-8px' },
      leftIcon: _react2.default.createElement(_materialUi.IconButton, {
        iconClassName: (0, _contractingUtils.getStatusIcon)('loading'),
        iconStyle: { color: (0, _ramda.equals)(state, 'loading') ? 'grey' : (0, _contractingUtils.getStatusColor)('loading'), top: '-14px' }
      }),
      primaryText: 'loading'
    }),
    _react2.default.createElement(_materialUi.MenuItem, {
      disabled: (0, _ramda.equals)(state, 'loaded'),
      onTouchTap: function onTouchTap() {
        return changeContractStateTo('loaded');
      },
      innerDivStyle: { color: (0, _contractingUtils.getStatusColor)('loaded'), left: '-8px' },
      leftIcon: _react2.default.createElement(_materialUi.IconButton, {
        iconClassName: (0, _contractingUtils.getStatusIcon)('loaded'),
        iconStyle: { color: (0, _ramda.equals)(state, 'loaded') ? 'grey' : (0, _contractingUtils.getStatusColor)('loaded'), top: '-14px' }
      }),
      primaryText: 'loaded'
    }),
    _react2.default.createElement(_materialUi.MenuItem, {
      disabled: (0, _ramda.equals)(state, 'rejected'),
      onTouchTap: function onTouchTap() {
        return changeContractStateTo('rejected');
      },
      innerDivStyle: { color: (0, _contractingUtils.getStatusColor)('rejected'), left: '-8px' },
      leftIcon: _react2.default.createElement(_materialUi.IconButton, {
        iconClassName: (0, _contractingUtils.getStatusIcon)('rejected'),
        iconStyle: { color: (0, _ramda.equals)(state, 'rejected') ? 'grey' : (0, _contractingUtils.getStatusColor)('rejected'), top: '-14px' }
      }),
      primaryText: 'rejected'
    })
  );
};

exports.default = ChangeStatusMenuForContractor;

/***/ }),
/* 3271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _leftNavWidget = __webpack_require__(1543);

var _leftNavWidget2 = _interopRequireDefault(_leftNavWidget);

var _addProductButton = __webpack_require__(3272);

var _addProductButton2 = _interopRequireDefault(_addProductButton);

var _errorCheckIndicatorIcon = __webpack_require__(1138);

var _errorCheckIndicatorIcon2 = _interopRequireDefault(_errorCheckIndicatorIcon);

var _smallButtons = __webpack_require__(94);

var _ratePackageGroup = __webpack_require__(3273);

var _ratePackageGroup2 = _interopRequireDefault(_ratePackageGroup);

var _sortRatePackageGroup = __webpack_require__(3274);

var _sortRatePackageGroup2 = _interopRequireDefault(_sortRatePackageGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  contractId: _propTypes2.default.string.isRequired,
  productsArray: _propTypes2.default.array.isRequired,
  location: _propTypes2.default.object.isRequired,
  changeLeftNavRoute: _propTypes2.default.func.isRequired,
  supplierEditable: _propTypes2.default.bool.isRequired,
  sortingProducts: _propTypes2.default.func,
  locationId: _propTypes2.default.string,
  productsErrors: _propTypes2.default.array,
  thisProductId: _propTypes2.default.string,
  collection: _propTypes2.default.string,
  openAddProductDialog: _propTypes2.default.func,
  openAddEditContractDialog: _propTypes2.default.func
};
var simpleStyle = { marginTop: '10px', marginLeft: '18px', padding: '0 4px 0 0' };

var LeftNavProducts = function (_Component) {
  _inherits(LeftNavProducts, _Component);

  function LeftNavProducts() {
    _classCallCheck(this, LeftNavProducts);

    var _this = _possibleConstructorReturn(this, (LeftNavProducts.__proto__ || Object.getPrototypeOf(LeftNavProducts)).call(this));

    _this.closeSortDialog = function () {
      return _this.setState({ sortDialogOpen: false });
    };

    _this.saveSorted = function (newArray) {
      _this.props.sortingProducts(newArray);
      _this.setState({
        sortDialogOpen: false
      });
    };

    _this.state = {
      sortDialogOpen: false
    };
    return _this;
  }

  _createClass(LeftNavProducts, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes);
      var update = !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
      return update;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          contractId = _props.contractId,
          locationId = _props.locationId,
          collection = _props.collection,
          productsArray = _props.productsArray,
          changeLeftNavRoute = _props.changeLeftNavRoute,
          supplierEditable = _props.supplierEditable,
          sortingProducts = _props.sortingProducts,
          productsErrors = _props.productsErrors,
          location = _props.location,
          thisProductId = _props.thisProductId,
          openAddEditContractDialog = _props.openAddEditContractDialog;

      if (!locationId) return _react2.default.createElement('div', null);
      var groupedByProductId = _ramda2.default.groupBy(_ramda2.default.prop('productId'), productsArray);
      var sortDialogOpen = this.state.sortDialogOpen;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'flex-tc-sb', style: _ramda2.default.merge(simpleStyle, { fontWeight: 'bold' }) },
          'Room/Product Rates',
          supplierEditable && sortingProducts && productsArray && productsArray.length > 1 ? _react2.default.createElement(_smallButtons.SmallFlatButton, {
            label: 'Reorder',
            onTouchTap: function onTouchTap() {
              return _this2.setState({ sortDialogOpen: true, sortType: 'products', sortProductId: '' });
            },
            secondary: true,
            style: { border: '1px solid rgba(0, 0, 0, 0.64)' },
            labelStyle: { padding: '4px 8px 4px 2px', color: 'rgba(0, 0, 0, 0.64)', top: '-1px' },
            icon: _react2.default.createElement(_materialUi.FontIcon, {
              className: 'tc-icon-swap_vert',
              style: { color: 'rgba(0, 0, 0, 0.64)' }
            })
          }) : _react2.default.createElement('div', null)
        ),
        _ramda2.default.isEmpty(productsArray) && _react2.default.createElement(
          'div',
          {
            style: {
              marginLeft: '18px',
              display: 'flex',
              alignItems: 'center',
              color: '#f44336'
            }
          },
          _react2.default.createElement(_errorCheckIndicatorIcon2.default, { showError: true }),
          '\xA0 Please add a room/product'
        ),

        /*
          raw data structure:
          [{ productId, ratePackageName, productName, ...etc }]
          groupedByProductId:
          {
            <productId>: [{ productId, ratePackageName, productName }]
          }
          we are rendering it this way:
          product name A (Not clickable, just a label)
          ratePackageName 1 (clickable)
          ratePackageName 2 (clickable)
          product name B (clickable)
        */
        _ramda2.default.keys(groupedByProductId).map(function (productId) {
          if (groupedByProductId[productId].length > 1) {
            var showErrorForProduct = groupedByProductId[productId].some(function (obj) {
              var percent = _ramda2.default.call(_ramda2.default.compose(function (foundProduct) {
                return foundProduct ? foundProduct.percent : 100;
              }, _ramda2.default.find(function (productInError) {
                return productInError.ratePackageIndex === obj.ratePackageIndex;
              })), productsErrors);
              return percent !== 100;
            });
            var ratePackages = groupedByProductId[productId];
            var _groupedByProductId$p = groupedByProductId[productId][0],
                productName = _groupedByProductId$p.productName,
                ratePackageIndex = _groupedByProductId$p.ratePackageIndex;

            return _react2.default.createElement(_ratePackageGroup2.default, _extends({
              key: productId
            }, {
              location: location,
              productName: productName,
              thisProductId: thisProductId,
              urlPartial: '/contracting/' + collection + '/' + contractId + '/product/' + productId,
              supplierEditable: supplierEditable,
              showErrorForProduct: showErrorForProduct,
              changeLeftNavRoute: changeLeftNavRoute,
              ratePackages: ratePackages,
              productsErrors: productsErrors,
              productId: productId,
              managePackages: function managePackages() {
                return openAddEditContractDialog({
                  type: 'manageRatePackage',
                  title: 'Manage Rate Packages for ' + productName,
                  data: { productId: productId, ratePackageIndex: ratePackageIndex }
                });
              }
            }));
          }
          var ratePackage = groupedByProductId[productId][0];
          var percent = _ramda2.default.call(_ramda2.default.compose(function (foundProduct) {
            return foundProduct ? foundProduct.percent : 100;
          }, _ramda2.default.find(function (productInError) {
            return productInError.ratePackageIndex === ratePackage.ratePackageIndex;
          })), productsErrors);
          var label = !supplierEditable ? ratePackage.productName : _react2.default.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center' } },
            supplierEditable && _react2.default.createElement(_errorCheckIndicatorIcon2.default, { showError: percent !== 100 }),
            ratePackage.productName
          );
          var ratePackageId = function () {
            if (ratePackage._id) return ratePackage._id;
            return ratePackage.ratePackageName ? encodeURIComponent(ratePackage.ratePackageName) : 'Primary';
          }();
          return _react2.default.createElement(_leftNavWidget2.default, {
            key: productId,
            routeName: '/contracting/' + collection + '/' + contractId + '/product/' + productId + '/' + ratePackageId,
            name: label,
            onTouchTap: function onTouchTap() {
              return changeLeftNavRoute('/contracting/' + collection + '/' + contractId + '/product/' + productId + '/' + ratePackageId);
            }
          });
        }),
        _react2.default.createElement(_sortRatePackageGroup2.default, {
          productsArray: productsArray,
          open: sortDialogOpen,
          onRequestClose: this.closeSortDialog,
          saveSorted: this.saveSorted
        }),
        Boolean(supplierEditable) && _react2.default.createElement(_addProductButton2.default, {
          openAddEditContractDialog: openAddEditContractDialog,
          productsArray: productsArray
        })
      );
    }
  }]);

  return LeftNavProducts;
}(_react.Component);

LeftNavProducts.defaultProps = {
  collection: '',
  thisProductId: '',
  productsErrors: [],
  openAddProductDialog: function openAddProductDialog() {},
  openAddEditContractDialog: function openAddEditContractDialog() {}
};

LeftNavProducts.propTypes = propTypes;
var mapStateToProps = function mapStateToProps(_ref, props) {
  var contracting = _ref.contracting;

  var state = contracting.contractActivitiesProducts.toJS();
  var productsErrors = _ramda2.default.pathOr([], ['draftErrors', 'products'], state);
  var thisProductId = _ramda2.default.pathOr('', ['rightSideContent', 'productId'], state) || props.thisProductId;
  return { productsErrors: productsErrors, thisProductId: thisProductId };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(LeftNavProducts);

/***/ }),
/* 3272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddProductButton = function AddProductButton(_ref) {
  var openAddEditContractDialog = _ref.openAddEditContractDialog;

  return _react2.default.createElement(
    'div',
    { style: { margin: '8px 0 16px 16px' } },
    _react2.default.createElement(_addItemCard2.default, {
      text: 'Add room types/products',
      onClick: function onClick() {
        return openAddEditContractDialog({
          type: 'addProducts'
        });
      },
      editable: true
    })
  );
};

AddProductButton.propTypes = {
  openAddEditContractDialog: _react.PropTypes.func
};

exports.default = AddProductButton;

/***/ }),
/* 3273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _errorCheckIndicatorIcon = __webpack_require__(1138);

var _errorCheckIndicatorIcon2 = _interopRequireDefault(_errorCheckIndicatorIcon);

var _leftNavWidget = __webpack_require__(1543);

var _leftNavWidget2 = _interopRequireDefault(_leftNavWidget);

var _smallButtons = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var simpleStyle = { marginLeft: '18px', padding: '0 4px 0 0' };

var RatePackageGroup = function (_React$Component) {
  _inherits(RatePackageGroup, _React$Component);

  function RatePackageGroup(props) {
    _classCallCheck(this, RatePackageGroup);

    var _this = _possibleConstructorReturn(this, (RatePackageGroup.__proto__ || Object.getPrototypeOf(RatePackageGroup)).call(this, props));

    var productId = props.productId,
        thisProductId = props.thisProductId;

    _this.state = {
      isExpanded: productId === thisProductId
    };
    return _this;
  }

  _createClass(RatePackageGroup, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          productId = _props.productId,
          thisProductId = _props.thisProductId;
      // route change

      if (nextProps.thisProductId !== thisProductId && nextProps.thisProductId === productId) {
        this.state = {
          isExpanded: true
        };
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          urlPartial = _props2.urlPartial,
          location = _props2.location,
          productName = _props2.productName,
          managePackages = _props2.managePackages,
          supplierEditable = _props2.supplierEditable,
          showErrorForProduct = _props2.showErrorForProduct,
          turnOnSort = _props2.turnOnSort,
          changeLeftNavRoute = _props2.changeLeftNavRoute,
          ratePackages = _props2.ratePackages,
          productsErrors = _props2.productsErrors;
      var isExpanded = this.state.isExpanded;


      var labelForProductName = !supplierEditable ? _react2.default.createElement(
        'div',
        { style: { whiteSpace: 'pre-wrap', width: 'calc(100% - 40px)' } },
        productName
      ) : _react2.default.createElement(
        'div',
        {
          style: {
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'pre-wrap',
            width: 'calc(100% - 40px)'
          }
        },
        supplierEditable && _react2.default.createElement(_errorCheckIndicatorIcon2.default, { showError: showErrorForProduct }),
        productName
      );
      return _react2.default.createElement(
        _materialUi.Card,
        {
          expandable: true,
          expanded: isExpanded,
          onExpandChange: function onExpandChange(expanded) {
            return _this2.setState({ isExpanded: expanded });
          },
          style: { backgroundColor: '#f5f6fb', boxShadow: 'none' }
        },
        _react2.default.createElement(
          _materialUi.CardHeader,
          {
            style: _extends({}, simpleStyle, { padding: '12px 4px 12px 0' }),
            textStyle: { display: 'none' },
            actAsExpander: true,
            showExpandableButton: true
          },
          labelForProductName
        ),
        _react2.default.createElement(
          _materialUi.CardText,
          { expandable: true, style: { padding: 0 } },

          // render rate packages
          ratePackages.map(function (ratePackage) {
            var ratePackageName = ratePackage.ratePackageName || 'Primary';
            var errorsObj = _ramda2.default.find(function (productInError) {
              return productInError.ratePackageIndex === ratePackage.ratePackageIndex;
            }, productsErrors);
            var percent = errorsObj ? errorsObj.percent : 100;
            var label = !supplierEditable ? _react2.default.createElement(
              'div',
              { style: { paddingLeft: '32px' } },
              ratePackage.ratePackageName || 'Primary'
            ) : _react2.default.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center', paddingLeft: '32px' } },
              supplierEditable && _react2.default.createElement(_errorCheckIndicatorIcon2.default, { showError: percent !== 100 }),
              ratePackageName
            );
            var ratePackageId = function () {
              if (ratePackage._id) return ratePackage._id;
              return encodeURIComponent(ratePackageName);
            }();
            return _react2.default.createElement(_leftNavWidget2.default, {
              key: ratePackageName,
              routeName: urlPartial + '/' + ratePackageId,
              name: label,
              location: location,
              onTouchTap: function onTouchTap() {
                return changeLeftNavRoute(urlPartial + '/' + ratePackageId);
              }
            });
          })
        )
      );
    }
  }]);

  return RatePackageGroup;
}(_react2.default.Component);

RatePackageGroup.defaultProps = {
  showErrorForProduct: false,
  productsErrors: [],
  managePackages: function managePackages() {},
  turnOnSort: function turnOnSort() {},
  thisProductId: '',
  urlPartial: '',
  productId: ''
};

RatePackageGroup.propTypes = {
  location: _propTypes2.default.object.isRequired,
  productId: _propTypes2.default.string,
  productName: _propTypes2.default.string.isRequired,
  supplierEditable: _propTypes2.default.bool.isRequired,
  showErrorForProduct: _propTypes2.default.bool,
  turnOnSort: _propTypes2.default.func,
  changeLeftNavRoute: _propTypes2.default.func.isRequired,
  ratePackages: _propTypes2.default.array.isRequired,
  productsErrors: _propTypes2.default.array,
  managePackages: _propTypes2.default.func,
  urlPartial: _propTypes2.default.string
};

exports.default = RatePackageGroup;

/***/ }),
/* 3274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _sortableList = __webpack_require__(1130);

var _sortableList2 = _interopRequireDefault(_sortableList);

var _draggableCard = __webpack_require__(1134);

var _draggableCard2 = _interopRequireDefault(_draggableCard);

var _smallButtons = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SortPackageGroup = function (_React$Component) {
  _inherits(SortPackageGroup, _React$Component);

  function SortPackageGroup(props) {
    _classCallCheck(this, SortPackageGroup);

    var _this = _possibleConstructorReturn(this, (SortPackageGroup.__proto__ || Object.getPrototypeOf(SortPackageGroup)).call(this, props));

    _this.getArrays = function (productsArray) {
      if (!(productsArray && productsArray.length)) {
        return {
          productsArray: [],
          products: [],
          groupedByProductId: {}
        };
      }
      var groupedByProductId = _ramda2.default.groupBy(_ramda2.default.prop('productId'), productsArray);
      return {
        productsArray: productsArray,
        products: _ramda2.default.keys(groupedByProductId).map(function (id) {
          return {
            productId: id,
            productName: groupedByProductId[id][0].productName,
            hasRatePackages: groupedByProductId[id].length > 1
          };
        }),
        groupedByProductId: groupedByProductId
      };
    };

    _this.onDragEnds = function (newArray) {
      var _this$state = _this.state,
          groupedByProductId = _this$state.groupedByProductId,
          sortProductId = _this$state.sortProductId,
          sortType = _this$state.sortType;

      if (sortType === 'products') {
        var sortedProductsArray = _ramda2.default.flatten(newArray.map(function (obj) {
          return groupedByProductId[obj.productId];
        }));
        _this.setState({
          products: newArray,
          productsArray: sortedProductsArray
        });
      } else {
        _this.setState({
          ratePackages: newArray
        });
      }
    };

    _this.confirmRatePackagesChanges = function () {
      var _this$state2 = _this.state,
          groupedByProductId = _this$state2.groupedByProductId,
          sortProductId = _this$state2.sortProductId,
          ratePackages = _this$state2.ratePackages;

      var newGroupedByProductId = _ramda2.default.assoc(sortProductId, ratePackages, groupedByProductId);
      var productsArray = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.flatten, _ramda2.default.values), newGroupedByProductId);
      _this.setState({
        groupedByProductId: newGroupedByProductId,
        productsArray: productsArray,
        ratePackages: [],
        sortProductId: '',
        sortType: 'products'
      });
    };

    _this.state = _extends({
      sortType: 'products',
      sortProductId: ''
    }, _this.getArrays(props.productsArray));
    return _this;
  }

  _createClass(SortPackageGroup, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var productsArray = this.props.productsArray;

      if (nextProps.productsArray !== productsArray) {
        this.state = _extends({}, this.state, this.getArrays(nextProps.productsArray));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          open = _props.open,
          saveSorted = _props.saveSorted,
          onRequestClose = _props.onRequestClose;
      var _state = this.state,
          products = _state.products,
          productsArray = _state.productsArray,
          groupedByProductId = _state.groupedByProductId,
          ratePackages = _state.ratePackages,
          sortType = _state.sortType;

      var processedData = function () {
        if (sortType === 'ratePackages') {
          return {
            arrayOfData: ratePackages,
            title: 'Reorder rate packages for ' + ratePackages[0].productName
          };
        }
        if (sortType === 'products') {
          return {
            arrayOfData: products,
            title: 'Reorder Rooms/Products'
          };
        }
        return {
          arrayOfData: [],
          title: ''
        };
      }();
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          open: open,
          onRequestClose: onRequestClose,
          autoScrollBodyContent: true,
          contentStyle: { width: '40%' },
          bodyStyle: { padding: '24px' },
          title: _react2.default.createElement(
            'div',
            {
              style: {
                backgroundColor: '#00BCD4',
                color: 'white',
                fontSize: '18px',
                padding: '12px'
              }
            },
            processedData.title
          ),
          actions: sortType === 'ratePackages' ? _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb' },
            _react2.default.createElement(_materialUi.FlatButton, {
              label: 'Go Back',
              onTouchTap: this.confirmRatePackagesChanges,
              secondary: true,
              icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-arrow_back' })
            }),
            _react2.default.createElement('div', null)
          ) : [_react2.default.createElement(_materialUi.FlatButton, {
            label: 'Cancel',
            primary: true,
            onTouchTap: onRequestClose
          }), _react2.default.createElement(_materialUi.FlatButton, {
            label: 'Confirm',
            secondary: true,
            onTouchTap: function onTouchTap() {
              return saveSorted(productsArray);
            }
          })]
        },
        _react2.default.createElement(
          _sortableList2.default,
          {
            arrayOfData: processedData.arrayOfData,
            dragEnds: this.onDragEnds,
            sortable: true
          },
          processedData.arrayOfData.map(function (obj) {
            var name = sortType === 'products' ? obj.productName : obj.ratePackageName || 'Primary';
            return _react2.default.createElement(
              _draggableCard2.default,
              {
                key: name,
                className: 'flex-tc-sb',
                style: {
                  marginTop: '5px',
                  padding: '2px 8px',
                  fontSize: '12px',
                  color: 'rgba(0, 0, 0, 0.9)',
                  border: '1px dashed rgba(0, 0, 0, 0.34)'
                },
                isDropTarget: true,
                isDragSource: true
              },
              _react2.default.createElement(
                'div',
                { className: 'flex-tc-sb', style: { width: '93%' } },
                _react2.default.createElement(
                  'div',
                  { style: { width: 'calc(100% - 180px)', whiteSpace: 'pre-wrap' } },
                  name
                ),
                obj.hasRatePackages && _react2.default.createElement(_smallButtons.SmallFlatButton, {
                  label: 'Reorder Rate Packages',
                  onTouchTap: function onTouchTap() {
                    return _this2.setState({
                      sortProductId: obj.productId,
                      sortType: 'ratePackages',
                      ratePackages: groupedByProductId[obj.productId]
                    });
                  },
                  style: { border: '1px solid rgba(0, 0, 0, 0.64)' },
                  labelStyle: { padding: '2px 4px', color: 'rgba(0, 0, 0, 0.64)' },
                  icon: _react2.default.createElement(_materialUi.FontIcon, {
                    className: 'tc-icon-swap_vert',
                    style: { color: 'rgba(0, 0, 0, 0.64)' }
                  })
                })
              ),
              _react2.default.createElement(_materialUi.FontIcon, {
                className: 'tc-icon-swap_vert',
                style: { color: 'rgba(0, 0, 0, 0.34)' }
              })
            );
          })
        )
      );
    }
  }]);

  return SortPackageGroup;
}(_react2.default.Component);

SortPackageGroup.defaultProps = {
  sortType: ''
};

SortPackageGroup.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  productsArray: _propTypes2.default.array.isRequired,
  saveSorted: _propTypes2.default.func.isRequired,
  onRequestClose: _propTypes2.default.func.isRequired
};

exports.default = SortPackageGroup;

/***/ }),
/* 3275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationEmail = function CommunicationEmail(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
  );
};
CommunicationEmail = (0, _pure2.default)(CommunicationEmail);
CommunicationEmail.displayName = 'CommunicationEmail';
CommunicationEmail.muiName = 'SvgIcon';

exports.default = CommunicationEmail;

/***/ }),
/* 3276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _addRatesWizard = __webpack_require__(3277);

var _addRatesWizard2 = _interopRequireDefault(_addRatesWizard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddRates = function AddRates(_ref) {
  var onRequestClose = _ref.onRequestClose,
      contractId = _ref.contractId,
      productId = _ref.productId,
      productName = _ref.productName,
      existingSeasons = _ref.existingSeasons,
      _saveProductInfoChanges = _ref.saveProductInfoChanges,
      productType = _ref.productType,
      contractingPeriod = _ref.contractingPeriod,
      openGlobalAlert = _ref.openGlobalAlert;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_addRatesWizard2.default, {
      contractingPeriod: contractingPeriod,
      productType: productType,
      productName: productName,
      existingSeasons: existingSeasons,
      cancelText: 'Cancel',
      cancelFunc: function cancelFunc() {
        openGlobalAlert({
          text: 'You will lose all the data you just entered if you cancel now. Are you sure you want to cancel?',
          onOk: onRequestClose
        });
      },
      continueText: 'Save season',
      saveProductInfoChanges: function saveProductInfoChanges(seasonRates) {
        return _saveProductInfoChanges({ seasonRates: seasonRates, productId: productId, contractId: contractId, updateType: 'SEASONRATES_SAVED_TO_DB' });
      }
    })
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var user = _ref2.user,
      contracting = _ref2.contracting;
  return {
    productType: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productType']) || contracting.contractActivitiesProducts.getIn(['leftNav', 'productType']) || user.getIn(['company', 'productType'])
  };
};

AddRates.propTypes = {
  open: _react.PropTypes.bool,
  onRequestClose: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  productId: _react.PropTypes.string,
  data: _react.PropTypes.object,
  savingRates: _react.PropTypes.func,
  productName: _react.PropTypes.string,
  contractingPeriod: _react.PropTypes.object,
  openGlobalAlert: _react.PropTypes.func
};

var mapActions = {
  openGlobalAlert: function openGlobalAlert(payload) {
    return {
      type: 'open_global_alert',
      payload: payload
    };
  }
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapActions)(AddRates);

/***/ }),
/* 3277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _stepperWizard = __webpack_require__(1139);

var _stepperWizard2 = _interopRequireDefault(_stepperWizard);

var _allFourStepsDumb = __webpack_require__(1972);

var _allFourStepsDumb2 = _interopRequireDefault(_allFourStepsDumb);

var _reactRedux = __webpack_require__(6);

var _ratesWizardActions = __webpack_require__(1549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AddRatesStepper = function AddRatesStepper(props) {
  var addRateSetToSeason = props.addRateSetToSeason,
      addRatesStepperComponentIndex = props.addRatesStepperComponentIndex,
      goToStep = props.goToStep,
      extraProps = _objectWithoutProperties(props, ['addRateSetToSeason', 'addRatesStepperComponentIndex', 'goToStep']);

  var stepNames = ['Rate Set Info', 'Add Rates', 'Review Rates', 'Select Season'];

  var feedAllFourSteps = _extends({
    step3ContinueText: 'Add rate set',
    onFinish: addRateSetToSeason,
    goToNextStep: function goToNextStep(componentIndex) {
      return goToStep({ stepperWizardName: 'addRatesStepper', componentIndex: componentIndex + 1 });
    },
    goToPreviousStep: function goToPreviousStep(componentIndex) {
      return goToStep({ stepperWizardName: 'addRatesStepper', componentIndex: componentIndex - 1 });
    }
  }, extraProps);
  return _react2.default.createElement(
    _stepperWizard2.default,
    {
      componentIndex: addRatesStepperComponentIndex,
      steps: stepNames,
      showStepsBar: true
    },
    _react2.default.createElement(_allFourStepsDumb2.default, _extends({}, feedAllFourSteps, { index: 0 })),
    _react2.default.createElement(_allFourStepsDumb2.default, _extends({}, feedAllFourSteps, { index: 1 })),
    _react2.default.createElement(_allFourStepsDumb2.default, _extends({}, feedAllFourSteps, { index: 2 })),
    _react2.default.createElement(_allFourStepsDumb2.default, _extends({}, feedAllFourSteps, { index: 3 }))
  );
};

AddRatesStepper.propTypes = {
  productName: _react.PropTypes.string,
  goToStep: _react.PropTypes.func,
  updateFieldValue: _react.PropTypes.func,
  addRateSetToSeason: _react.PropTypes.func,
  addDateRanges: _react.PropTypes.func,
  addRatesStepperComponentIndex: _react.PropTypes.number,
  seasonInfo: _react.PropTypes.object,
  selectExistingSeason: _react.PropTypes.func,
  cancelText: _react.PropTypes.string,
  cancelFunc: _react.PropTypes.func,
  onContinue: _react.PropTypes.func,
  continueText: _react.PropTypes.string,
  existingSeasons: _react.PropTypes.array,
  showStepOneBack: _react.PropTypes.bool,
  stepOneBackFunc: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting;
  return {
    addRatesStepperComponentIndex: contracting.steppers.get('addRatesStepper'),
    seasonInfo: _extends({}, contracting.addRatesWizard.toJS()),
    fieldValues: _extends({}, contracting.addRateSetWizard.toJS(), {
      productId: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productId']),
      locationId: contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId'])
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    goToStep: function goToStep(payload) {
      return dispatch({ type: 'CHANGE_STEPPER_WIZARD_STEP', payload: payload });
    },
    updateFieldValue: function updateFieldValue(payload) {
      return dispatch({ type: 'UPDATE_ADD_RATES_FIELD', payload: payload });
    },
    updateSeasonWizardWithKeyPath: function updateSeasonWizardWithKeyPath(payload) {
      return dispatch({ type: 'UPDATE_SEASON_IN_WIZARD_WITH_KEYPATH', payload: payload });
    },
    addDateRanges: function addDateRanges(payload) {
      return dispatch({ type: 'ADD_DATE_RANGES_TO_SEASON', payload: payload });
    },
    addRateSetToSeason: function addRateSetToSeason(payload) {
      return dispatch({ type: 'ADD_RATE_SET_TO_SEASON', payload: payload });
    },
    selectExistingSeason: function selectExistingSeason(payload) {
      return dispatch({ type: 'SELECT_FROM_EXISTING_SEASON', payload: payload });
    },
    updateFieldWithKeyPath: function updateFieldWithKeyPath(payload) {
      return dispatch({ type: 'UPDATE_ADD_RATES_FIELD_WITH_KEYPATH', payload: payload });
    },
    updateDaysOfWeek: function updateDaysOfWeek(payload) {
      return dispatch({ type: 'UPDATE_ADD_RATES_DAYSOFWEEK', payload: payload });
    },
    updateRatesTableCell: function updateRatesTableCell(payload) {
      return dispatch({ type: 'UPDATE_ADD_RATES_RATES_TABLE_CELL_VALUE', payload: payload });
    },
    calculateRatesTable: function calculateRatesTable() {
      return dispatch({ type: 'CALCULATE_RATES_TABLE' });
    },
    calculateStandardNonAccomRateTable: function calculateStandardNonAccomRateTable() {
      return dispatch({ type: 'CALCULATE_STANDARD_NON_ACCOM_RATES_TABLE' });
    },
    updateFormData: function updateFormData() {
      return dispatch(_ratesWizardActions.updateFormData.apply(undefined, arguments));
    },
    removeRateSetFromSeasonWhenGoBack: function removeRateSetFromSeasonWhenGoBack(payload) {
      return dispatch({ type: 'REMOVE_RATE_SET_FROM_SEASON_WHEN_GO_BACK', payload: payload });
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddRatesStepper);

/***/ }),
/* 3278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _rateSetInfoTemplate = __webpack_require__(1973);

var _rateSetInfoTemplate2 = _interopRequireDefault(_rateSetInfoTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var RateSetInfo = function RateSetInfo(props) {
  var _updateFieldValue = props.updateFieldValue,
      _updateDaysOfWeek = props.updateDaysOfWeek,
      goToNextStep = props.goToNextStep,
      cancelFunc = props.cancelFunc,
      cancelText = props.cancelText,
      componentIndex = props.componentIndex,
      productType = props.productType,
      productName = props.productName,
      usedRateSetNamesAndCodes = props.usedRateSetNamesAndCodes,
      getOverlappingDaysError = props.getOverlappingDaysError,
      fieldValues = _objectWithoutProperties(props, ['updateFieldValue', 'updateDaysOfWeek', 'goToNextStep', 'cancelFunc', 'cancelText', 'componentIndex', 'productType', 'productName', 'usedRateSetNamesAndCodes', 'getOverlappingDaysError']);

  var rateSetNameAndCodeError = function () {
    if (usedRateSetNamesAndCodes && usedRateSetNamesAndCodes.some(function (nameAndCode) {
      if (nameAndCode.rateSetName === fieldValues.rateSetName) {
        if (!nameAndCode.rateSetCode && !fieldValues.rateSetCode) return true;
        return nameAndCode.rateSetCode === fieldValues.rateSetCode;
      }
    })) {
      return 'You have already entered a ' + fieldValues.rateSetName + ' rate set using ' + (fieldValues.rateSetCode ? 'the ' + fieldValues.rateSetCode : ' an empty') + ' rate set code for this season. Please enter a new rate set name or rate set code so your agents know which rate is applicable.';
    }
  }();
  var overlappingDaysError = getOverlappingDaysError ? getOverlappingDaysError(fieldValues) : '';
  var shouldDisableContinue = Boolean(!fieldValues.rateSetName || !(fieldValues.daysOfWeek && fieldValues.daysOfWeek.length) || rateSetNameAndCodeError || overlappingDaysError);
  return _react2.default.createElement(
    'div',
    { style: { padding: '24px' } },
    _react2.default.createElement(_rateSetInfoTemplate2.default, _extends({}, fieldValues, {
      overlappingDaysError: overlappingDaysError,
      rateSetNameAndCodeError: rateSetNameAndCodeError,
      productName: productName,
      productType: productType,
      updateFieldValue: function updateFieldValue(fieldName, value) {
        return _updateFieldValue({ fieldName: fieldName, value: value });
      },
      updateDaysOfWeek: function updateDaysOfWeek(checked, day, dayIndexInReducer) {
        return _updateDaysOfWeek({ checked: checked, day: day, dayIndexInReducer: dayIndexInReducer });
      }
    })),
    _react2.default.createElement('br', null),
    _react2.default.createElement('br', null),
    _react2.default.createElement(_stepperActions2.default, {
      rightButtons: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_materialUi.FlatButton, {
          label: cancelText,
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onTouchTap: cancelFunc
        }),
        _react2.default.createElement(_materialUi.FlatButton, {
          label: 'Continue',
          labelStyle: { fontWeight: '600' },
          disabled: shouldDisableContinue,
          onTouchTap: function onTouchTap() {
            goToNextStep(componentIndex);
          },
          secondary: true
        })
      )
    })
  );
};

RateSetInfo.propTypes = {
  updateFieldValue: _react.PropTypes.func,
  updateDaysOfWeek: _react.PropTypes.func,
  goToNextStep: _react.PropTypes.func,
  cancelFunc: _react.PropTypes.func,
  cancelText: _react.PropTypes.string,
  componentIndex: _react.PropTypes.number,
  fieldValues: _react.PropTypes.object
};

exports.default = RateSetInfo;

/***/ }),
/* 3279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _accomRatesForm = __webpack_require__(1552);

var _accomRatesForm2 = _interopRequireDefault(_accomRatesForm);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Rates = function Rates(_ref) {
  var componentIndex = _ref.componentIndex,
      updateFieldValue = _ref.updateFieldValue,
      goToPreviousStep = _ref.goToPreviousStep,
      goToNextStep = _ref.goToNextStep,
      cancelFunc = _ref.cancelFunc,
      cancelText = _ref.cancelText,
      calculateRatesTable = _ref.calculateRatesTable,
      updateFormData = _ref.updateFormData,
      fieldValues = _objectWithoutProperties(_ref, ['componentIndex', 'updateFieldValue', 'goToPreviousStep', 'goToNextStep', 'cancelFunc', 'cancelText', 'calculateRatesTable', 'updateFormData']);

  var requiredFields = ['currency', 'taxInclusion', 'additionalChild', 'additionalAdult', 'includedGuestsinBaseRate', 'maxAdultsChildren', 'maxAdults'];
  var errorFields = ['maxAdultsError', 'maxGuestsError', 'includedGuestsError'];
  var isValueNotExists = function isValueNotExists(field) {
    return _ramda2.default.anyPass([_ramda2.default.isEmpty, _ramda2.default.isNil])(_ramda2.default.prop(field, fieldValues));
  };
  var isValueExists = function isValueExists(field) {
    return _ramda2.default.allPass([_ramda2.default.complement(_ramda2.default.isEmpty), _ramda2.default.complement(_ramda2.default.isNil)])(_ramda2.default.prop(field, fieldValues));
  };

  var disableContinue = function () {
    if (!fieldValues.taxInclusion) return true;
    if (fieldValues.taxInclusion !== 'exempt' && !fieldValues.taxType) return true;
    if (fieldValues.rateType === 'includeCommission') {
      if (!fieldValues.commissionPercentage || !fieldValues.retailRate) return true;
    }
    return _ramda2.default.or(_ramda2.default.any(isValueNotExists)(requiredFields), _ramda2.default.any(isValueExists)(errorFields));
  }();
  return _react2.default.createElement(
    'div',
    { style: { padding: '48px' } },
    _react2.default.createElement(_accomRatesForm2.default, _extends({
      showTaxCurrency: true
    }, fieldValues, {
      updateFieldValue: updateFieldValue,
      updateFormData: updateFormData
    })),
    _react2.default.createElement(_stepperActions2.default, {
      showBackButton: true,
      backButtonFunc: function backButtonFunc() {
        return goToPreviousStep(componentIndex);
      },
      rightButtons: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_materialUi.FlatButton, {
          label: cancelText,
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onTouchTap: cancelFunc
        }),
        _react2.default.createElement(_materialUi.FlatButton, {
          onTouchTap: function onTouchTap() {
            calculateRatesTable();
            goToNextStep(componentIndex);
          },
          disabled: disableContinue,
          secondary: true,
          label: 'continue',
          labelStyle: { fontWeight: '600' }
        })
      )
    })
  );
};

Rates.propTypes = {
  calculateRatesTable: _react.PropTypes.func,
  goToStep: _react.PropTypes.func
};

exports.default = Rates;

/***/ }),
/* 3280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _materialUi = __webpack_require__(3);

var _nonAccomRatesForm = __webpack_require__(1553);

var _nonAccomRatesForm2 = _interopRequireDefault(_nonAccomRatesForm);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NonAccomRates = function NonAccomRates(_ref) {
  var componentIndex = _ref.componentIndex,
      updateFieldValue = _ref.updateFieldValue,
      updateFieldWithKeyPath = _ref.updateFieldWithKeyPath,
      goToNextStep = _ref.goToNextStep,
      goToPreviousStep = _ref.goToPreviousStep,
      cancelFunc = _ref.cancelFunc,
      cancelText = _ref.cancelText,
      calculateStandardNonAccomRateTable = _ref.calculateStandardNonAccomRateTable,
      updateFormData = _ref.updateFormData,
      fieldValues = _objectWithoutProperties(_ref, ['componentIndex', 'updateFieldValue', 'updateFieldWithKeyPath', 'goToNextStep', 'goToPreviousStep', 'cancelFunc', 'cancelText', 'calculateStandardNonAccomRateTable', 'updateFormData']);

  var nonAccomStandard = fieldValues.nonAccomStandard;
  var retailOrNett = fieldValues.rateType === 'includeCommission' ? 'retail' : 'nett';
  var noRatesEntered = !_ramda2.default.values(nonAccomStandard[retailOrNett]).some(function (x) {
    return x;
  });
  var shouldDisableForMultiDay = _ramda2.default.path([retailOrNett, 'single'], nonAccomStandard) && _ramda2.default.path([retailOrNett, 'single supplement'], nonAccomStandard);
  var checkIfShouldDisableForTransfersPriceBreak = function () {
    var checkForSingleDetail = function checkForSingleDetail(detail) {
      return (detail.maxAdultsPlusChild || detail.minGuests) && detail.baseRate && (fieldValues.rateType === 'includeCommission' ? detail.retailRate : true);
    };
    var filteredArray = fieldValues.transfersOrPriceBreak.filter(checkForSingleDetail);
    return !Boolean(filteredArray.length);
  }();
  var shouldDisable = function () {
    if (!fieldValues.currency) return true;
    if (!fieldValues.taxInclusion) return true;
    if (fieldValues.taxInclusion !== 'exempt' && !fieldValues.taxType) return true;
    if (fieldValues.rateType === 'includeCommission' && !fieldValues.commissionPercentage) return true;
    if (fieldValues.nonStandardTemplateType === 'standard') return noRatesEntered;
    if (fieldValues.nonStandardTemplateType === 'multiDayTour') {
      return noRatesEntered || shouldDisableForMultiDay;
    }
    return checkIfShouldDisableForTransfersPriceBreak;
  }();
  return _react2.default.createElement(
    'div',
    { style: { padding: '48px', paddingTop: '24px' } },
    _react2.default.createElement(_nonAccomRatesForm2.default, _extends({}, fieldValues, {
      showTaxCurrency: true,
      updateFieldWithKeyPath: updateFieldWithKeyPath,
      updateFieldValue: updateFieldValue,
      updateFormData: updateFormData
    })),
    _react2.default.createElement(_stepperActions2.default, {
      style: { clear: 'both', position: 'relative', top: '12px' },
      showBackButton: true,
      backButtonFunc: function backButtonFunc() {
        return goToPreviousStep(componentIndex);
      },
      rightButtons: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_materialUi.FlatButton, {
          label: cancelText,
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onTouchTap: cancelFunc
        }),
        _react2.default.createElement(_materialUi.FlatButton, {
          onTouchTap: function onTouchTap() {
            calculateStandardNonAccomRateTable();
            goToNextStep(componentIndex);
          },
          secondary: true,
          label: 'continue',
          disabled: shouldDisable,
          labelStyle: { fontWeight: '600' }
        })
      )
    })
  );
};

exports.default = NonAccomRates;

/***/ }),
/* 3281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _contractingPresetNamesCodes = __webpack_require__(464);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NonAccomRates = function NonAccomRates(_ref) {
  var updateFieldValue = _ref.updateFieldValue,
      fieldValues = _objectWithoutProperties(_ref, ['updateFieldValue']);

  var nonAccomStandard = fieldValues.nonAccomStandard;
  var fontFamily = "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif";
  var leftColumnStyle = { width: '30%', textAlign: 'left', fontSize: '15px', fontFamily: fontFamily };

  return _react2.default.createElement(_twoColumnRow2.default, {
    leftColumnStyle: leftColumnStyle,
    rightColumnStyle: { width: '70%', textAlign: 'left' },
    outerContainerStyle: { overflow: 'inherit', clear: 'both', marginTop: '12px' },
    leftColumnContent: _react2.default.createElement(
      'div',
      { style: { marginTop: '12px', position: 'relative', top: '12px' } },
      'Rates information',
      _react2.default.createElement(
        'div',
        { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
        '* At least one rate is required'
      )
    ),
    rightColumnContent: _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { overflow: 'inherit' },
      leftColumnStyle: { width: '45%' },
      leftColumnContent: fieldValues.rateType === 'includeCommission' ? _react2.default.createElement(
        'div',
        null,
        _contractingPresetNamesCodes.standardNonAccomDescrs.map(function (field, index) {
          return _react2.default.createElement(
            'div',
            { key: index },
            _react2.default.createElement(_typeControlledTextfield2.default, {
              id: field + 'retail',
              controlledType: 'number',
              errorStyle: { fontSize: '10px', bottom: '10px' },
              style: { width: '65%', marginRight: '18px', height: '48px' },
              hintStyle: { fontSize: '12px', zIndex: '0' },
              floatingLabelStyle: { fontSize: '12px', top: '18px' },
              inputStyle: { fontSize: '14px', marginTop: '0' },
              floatingLabelText: field,
              hintText: 'Number only',
              value: nonAccomStandard.retail['' + (field.toLowerCase().indexOf('senior') < 0 ? field.toLowerCase() : 'senior')],
              onChange: function onChange(_ref2) {
                var value = _ref2.target.value;
                return updateFieldValue({
                  fieldName: '' + (field.toLowerCase().indexOf('senior') < 0 ? field.toLowerCase() : 'senior'),
                  value: value,
                  nonAccomStandard: true,
                  retail: true
                });
              }
            }),
            _react2.default.createElement(
              'span',
              { style: { position: 'relative', top: '6px', fontSize: '14px' } },
              'Retail'
            )
          );
        })
      ) : undefined,
      rightColumnStyle: { float: fieldValues.rateType === 'includeCommission' ? 'right' : '', marginRight: '5%', width: '45%' },
      rightColumnContent: _react2.default.createElement(
        'div',
        null,
        _contractingPresetNamesCodes.standardNonAccomDescrs.map(function (field, index) {
          var seniorCheck = nonAccomStandard.nett['' + (field.toLowerCase().indexOf('senior') < 0 ? field.toLowerCase() : 'senior')];
          return _react2.default.createElement(
            'div',
            { key: index },
            _react2.default.createElement(_typeControlledTextfield2.default, {
              id: field + 'nett',
              controlledType: 'number',
              errorStyle: { fontSize: '10px', bottom: '10px' },
              style: { width: '65%', marginRight: '18px', height: '48px' },
              hintStyle: { fontSize: '12px', zIndex: '0' },
              floatingLabelStyle: { fontSize: '12px', top: '18px' },
              inputStyle: { fontSize: '14px', marginTop: '0' },
              disabled: fieldValues.rateType === 'includeCommission',
              floatingLabelText: field,
              hintText: 'Number only',
              value: seniorCheck,
              onChange: function onChange(_ref3) {
                var value = _ref3.target.value;
                return updateFieldValue({ fieldName: '' + (field.toLowerCase().indexOf('senior') < 0 ? field.toLowerCase() : 'senior'), value: value, nonAccomStandard: true, nett: true });
              }
            }),
            _react2.default.createElement(
              'span',
              { style: { position: 'relative', top: '6px', fontSize: '14px' } },
              'Nett'
            )
          );
        })
      )
    })
  });
};

exports.default = NonAccomRates;

/***/ }),
/* 3282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _contractingPresetNamesCodes = __webpack_require__(464);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NonAccomRates = function NonAccomRates(_ref) {
  var updateFieldValue = _ref.updateFieldValue,
      fieldValues = _objectWithoutProperties(_ref, ['updateFieldValue']);

  var retailOrNett = fieldValues.rateType === 'includeCommission' ? 'retail' : 'nett';
  var nonAccomStandard = fieldValues.nonAccomStandard;
  var leftColumnStyle = { width: '30%', textAlign: 'left', fontSize: '15px' };
  var shouldDisableField = function shouldDisableField(str) {
    if (str === 'Single') {
      return Boolean(_ramda2.default.path([retailOrNett, 'single supplement'], nonAccomStandard));
    }
    if (str === 'Single Supplement') {
      return Boolean(_ramda2.default.path([retailOrNett, 'single'], nonAccomStandard));
    }
    return false;
  };
  return _react2.default.createElement(_twoColumnRow2.default, {
    leftColumnStyle: leftColumnStyle,
    rightColumnStyle: { width: '70%', textAlign: 'left' },
    outerContainerStyle: { overflow: 'inherit', clear: 'both', marginTop: '12px' },
    leftColumnContent: _react2.default.createElement(
      'div',
      { style: { marginTop: '12px', position: 'relative', top: '12px' } },
      'Rates information',
      _react2.default.createElement(
        'div',
        { style: { color: 'red', fontSize: '12px', fontWeight: '400' } },
        '* At least one rate is required'
      ),
      Boolean(_ramda2.default.path([retailOrNett, 'single'], nonAccomStandard) || _ramda2.default.path([retailOrNett, 'single supplement'], nonAccomStandard)) && _react2.default.createElement(
        'div',
        { style: { fontSize: '12px', marginTop: '32px' } },
        'Please note, you cannot have both "Single" and "Single Supplement" rate.'
      )
    ),
    rightColumnContent: _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { overflow: 'inherit' },
      leftColumnStyle: { width: '45%' },
      leftColumnContent: fieldValues.rateType === 'includeCommission' ? _react2.default.createElement(
        'div',
        null,
        _contractingPresetNamesCodes.multiDayTourDescrs.map(function (field, index) {
          return _react2.default.createElement(
            'div',
            { key: index, style: { display: 'flex', alignItems: 'baseline' } },
            _react2.default.createElement(_typeControlledTextfield2.default, {
              id: field + 'retail',
              disabled: shouldDisableField(field),
              controlledType: 'number',
              errorStyle: { fontSize: '10px', bottom: '10px' },
              style: { width: '65%', marginRight: '18px', height: '48px' },
              hintStyle: { fontSize: '12px', zIndex: '0' },
              floatingLabelStyle: { fontSize: '12px', top: '18px' },
              inputStyle: { fontSize: '14px', marginTop: '0' },
              floatingLabelText: field,
              hintText: 'Number only',
              value: nonAccomStandard.retail[field.toLowerCase()],
              onChange: function onChange(_ref2) {
                var value = _ref2.target.value;
                return updateFieldValue({
                  fieldName: field.toLowerCase(),
                  value: value,
                  nonAccomStandard: true,
                  retail: true
                });
              }
            }),
            _react2.default.createElement(
              'span',
              { style: { position: 'relative', top: '6px', fontSize: '14px' } },
              'Retail'
            )
          );
        })
      ) : undefined,
      rightColumnStyle: { float: fieldValues.rateType === 'includeCommission' ? 'right' : '', marginRight: '5%', width: '45%' },
      rightColumnContent: _react2.default.createElement(
        'div',
        null,
        _contractingPresetNamesCodes.multiDayTourDescrs.map(function (field, index) {
          return _react2.default.createElement(
            'div',
            { key: index, style: { display: 'flex', alignItems: 'baseline' } },
            _react2.default.createElement(_typeControlledTextfield2.default, {
              controlledType: 'number',
              id: field + 'nett',
              errorStyle: { fontSize: '10px', bottom: '10px' },
              style: { width: '65%', marginRight: '18px', height: '48px' },
              hintStyle: { fontSize: '12px', zIndex: '0' },
              floatingLabelStyle: { fontSize: '12px', top: '18px' },
              inputStyle: { fontSize: '14px', marginTop: '0' },
              disabled: fieldValues.rateType === 'includeCommission' || shouldDisableField(field),
              floatingLabelText: field,
              hintText: 'Number only',
              value: nonAccomStandard.nett[field.toLowerCase()],
              onChange: function onChange(_ref3) {
                var value = _ref3.target.value;
                return updateFieldValue({
                  fieldName: field.toLowerCase(),
                  value: value,
                  nonAccomStandard: true,
                  nett: true
                });
              }
            }),
            _react2.default.createElement(
              'span',
              { style: { position: 'relative', top: '6px', fontSize: '14px' } },
              'Nett'
            )
          );
        })
      )
    })
  });
};

exports.default = NonAccomRates;

/***/ }),
/* 3283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PrivateToursTransfersPriceBreak = function PrivateToursTransfersPriceBreak(_ref) {
  var updateFieldWithKeyPath = _ref.updateFieldWithKeyPath,
      nonStandardTemplateType = _ref.nonStandardTemplateType,
      fieldValues = _objectWithoutProperties(_ref, ['updateFieldWithKeyPath', 'nonStandardTemplateType']);

  var fontFamily = "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif";
  var leftColumnStyle = { width: '30%', textAlign: 'left', fontSize: '15px', fontFamily: fontFamily };
  var rightColumnStyle = { width: '70%', textAlign: 'left', fontFamily: fontFamily };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_twoColumnRow2.default, {
      leftColumnStyle: leftColumnStyle,
      rightColumnStyle: rightColumnStyle,
      outerContainerStyle: { overflow: 'inherit', clear: 'both', height: '24px', marginBottom: '0', marginTop: '12px' },
      rightColumnContent: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { style: { width: '10%', display: 'inline-block' } }),
        _react2.default.createElement(
          'div',
          { style: { width: '18%', display: 'inline-block', marginLeft: '2%' } },
          'Guests'
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '20%', display: fieldValues.rateType === 'includeCommission' ? 'inline-block' : 'none', marginLeft: '2%' } },
          'Retail'
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '20%', display: 'inline-block', marginLeft: '2%' } },
          'Nett'
        )
      )
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      leftColumnStyle: leftColumnStyle,
      rightColumnStyle: rightColumnStyle,
      outerContainerStyle: { overflow: 'inherit', clear: 'both', height: '42px', marginBottom: '0' },
      leftColumnContent: _react2.default.createElement(
        'div',
        { style: { position: 'relative', top: '14px' } },
        'Base rates information',
        _react2.default.createElement(
          'div',
          { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
          '* At least one rate detail is required'
        )
      ),
      rightColumnContent: fieldValues.transfersOrPriceBreak.map(function (transfer, index) {
        return _react2.default.createElement(
          'div',
          { key: index },
          _react2.default.createElement(
            'div',
            { style: { width: '10%', display: 'inline-block' } },
            'Up to'
          ),
          _react2.default.createElement(_typeControlledTextfield2.default, {
            id: 'maxAdultsPlusChild',
            style: { width: '20%' },
            value: transfer.maxAdultsPlusChild,
            onChange: function onChange(_ref2) {
              var value = _ref2.target.value;
              return updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak', index, 'maxAdultsPlusChild'], value: value });
            }
          }),
          fieldValues.rateType === 'includeCommission' ? _react2.default.createElement(_typeControlledTextfield2.default, {
            id: 'retailRate',
            style: { width: '20%', marginLeft: '2%' },
            hintText: 'Total cost',
            hintStyle: { fontSize: '14px' },
            value: transfer.retailRate,
            onChange: function onChange(_ref3) {
              var value = _ref3.target.value;
              return updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak', index, 'retailRate'], value: value });
            }
          }) : undefined,
          _react2.default.createElement(_typeControlledTextfield2.default, {
            id: 'baseRate',
            style: { width: '20%', marginLeft: '2%' },
            disabled: fieldValues.rateType === 'includeCommission',
            hintText: 'Total cost',
            hintStyle: { fontSize: '14px' },
            value: transfer.baseRate,
            onChange: function onChange(_ref4) {
              var value = _ref4.target.value;
              return updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak', index, 'baseRate'], value: value });
            }
          }),
          _react2.default.createElement(_icon2.default, {
            className: 'tc-icon-close',
            style: {
              marginLeft: '16px',
              lineHeight: '24px',
              verticalAlign: 'middle',
              color: fieldValues.transfersOrPriceBreak.length > 1 ? '#ff4081' : 'grey',
              cursor: fieldValues.transfersOrPriceBreak.length > 1 ? 'pointer' : 'normal'
            },
            onClick: function onClick() {
              if (fieldValues.transfersOrPriceBreak.length > 1) updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak'], value: (0, _ramda.remove)(index, 1, fieldValues.transfersOrPriceBreak) });
            }
          }),
          _react2.default.createElement(_icon2.default, {
            className: 'tc-icon-add',
            style: {
              marginLeft: '16px',
              lineHeight: '24px',
              verticalAlign: 'middle',
              border: '2px solid green',
              borderRadius: '50%',
              cursor: 'pointer'
            },
            onClick: function onClick() {
              return updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak'], value: (0, _ramda.insert)(index + 1, {}, fieldValues.transfersOrPriceBreak) });
            }
          })
        );
      })
    })
  );
};

exports.default = PrivateToursTransfersPriceBreak;

/***/ }),
/* 3284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PrivateToursTransfersPriceBreak = function PrivateToursTransfersPriceBreak(_ref) {
  var updateFieldWithKeyPath = _ref.updateFieldWithKeyPath,
      nonStandardTemplateType = _ref.nonStandardTemplateType,
      fieldValues = _objectWithoutProperties(_ref, ['updateFieldWithKeyPath', 'nonStandardTemplateType']);

  var leftColumnStyle = { width: '30%', textAlign: 'left', fontSize: '15px' };
  var rightColumnStyle = { width: '70%', textAlign: 'left' };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_twoColumnRow2.default, {
      leftColumnStyle: leftColumnStyle,
      rightColumnStyle: rightColumnStyle,
      outerContainerStyle: { overflow: 'inherit', clear: 'both', height: '24px', marginBottom: '0', marginTop: '12px' },
      rightColumnContent: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { width: '15%', display: 'inline-block' } },
          'Min'
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '15%', display: 'inline-block', marginLeft: '2%' } },
          'Max'
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '20%', display: fieldValues.rateType === 'includeCommission' ? 'inline-block' : 'none', marginLeft: '2%' } },
          'Retail'
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '20%', display: 'inline-block', marginLeft: '2%' } },
          'Nett'
        )
      )
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      leftColumnStyle: leftColumnStyle,
      rightColumnStyle: rightColumnStyle,
      outerContainerStyle: { overflow: 'inherit', clear: 'both', height: '42px', marginBottom: '0' },
      leftColumnContent: _react2.default.createElement(
        'div',
        { style: { position: 'relative', top: '14px' } },
        'Base rates information',
        _react2.default.createElement(
          'div',
          { style: { color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' } },
          '* At least one rate detail is required'
        )
      ),
      rightColumnContent: fieldValues.transfersOrPriceBreak.map(function (transfer, index) {
        return _react2.default.createElement(
          'div',
          { key: index },
          _react2.default.createElement(_typeControlledTextfield2.default, {
            style: { width: '15%' },
            hintText: 'Guests',
            hintStyle: { fontSize: '14px' },
            onBlur: function onBlur() {
              if (index && Number(transfer.minGuests) <= Number(fieldValues.transfersOrPriceBreak[index - 1].minGuests)) {
                alert('Current minimum guests have to be more than the last minimum guests.');
                var maxMinMax = Math.max(Number(fieldValues.transfersOrPriceBreak[index - 1].maxAdultsPlusChild), Number(fieldValues.transfersOrPriceBreak[index - 1].minGuests));
                updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak', index, 'minGuests'], value: maxMinMax + 1 });
              }
            },
            value: transfer.minGuests,
            onChange: function onChange(_ref2) {
              var value = _ref2.target.value;
              return updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak', index, 'minGuests'], value: value });
            }
          }),
          _react2.default.createElement(_typeControlledTextfield2.default, {
            style: { width: '15%', marginLeft: '2%' },
            hintText: 'Guests',
            hintStyle: { fontSize: '14px' },
            onBlur: function onBlur() {
              if (Number(transfer.maxAdultsPlusChild) < Number(transfer.minGuests)) {
                alert('Maximum guests have to be more than minimum guests.');
                updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak', index, 'maxAdultsPlusChild'], value: Number(transfer.minGuests) + 1 });
              }
            },
            value: transfer.maxAdultsPlusChild,
            onChange: function onChange(_ref3) {
              var value = _ref3.target.value;
              return updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak', index, 'maxAdultsPlusChild'], value: value });
            }
          }),
          fieldValues.rateType === 'includeCommission' ? _react2.default.createElement(_typeControlledTextfield2.default, {
            style: { width: '19%', marginLeft: '2%' },
            hintText: 'Per person',
            hintStyle: { fontSize: '14px' },
            value: transfer.retailRate,
            onChange: function onChange(_ref4) {
              var value = _ref4.target.value;
              return updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak', index, 'retailRate'], value: value });
            }
          }) : undefined,
          _react2.default.createElement(_typeControlledTextfield2.default, {
            style: { width: '19%', marginLeft: '2%' },
            disabled: fieldValues.rateType === 'includeCommission',
            hintText: 'Per person',
            hintStyle: { fontSize: '14px' },
            value: transfer.baseRate,
            onChange: function onChange(_ref5) {
              var value = _ref5.target.value;
              return updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak', index, 'baseRate'], value: value });
            }
          }),
          _react2.default.createElement(_icon2.default, {
            className: 'tc-icon-close',
            style: {
              marginLeft: '16px',
              lineHeight: '24px',
              verticalAlign: 'middle',
              color: fieldValues.transfersOrPriceBreak.length > 1 ? '#ff4081' : 'grey',
              cursor: fieldValues.transfersOrPriceBreak.length > 1 ? 'pointer' : 'normal'
            },
            onClick: function onClick() {
              if (fieldValues.transfersOrPriceBreak.length > 1) updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak'], value: (0, _ramda.remove)(index, 1, fieldValues.transfersOrPriceBreak) });
            }
          }),
          _react2.default.createElement(_icon2.default, {
            className: 'tc-icon-add',
            style: {
              marginLeft: '16px',
              lineHeight: '24px',
              verticalAlign: 'middle',
              border: '2px solid green',
              borderRadius: '50%',
              cursor: 'pointer'
            },
            onClick: function onClick() {
              return updateFieldWithKeyPath({ keyPath: ['transfersOrPriceBreak'], value: (0, _ramda.insert)(index + 1, {}, fieldValues.transfersOrPriceBreak) });
            }
          })
        );
      })
    })
  );
};

exports.default = PrivateToursTransfersPriceBreak;

/***/ }),
/* 3285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _rateTableTemplateContainer = __webpack_require__(632);

var _rateTableTemplateContainer2 = _interopRequireDefault(_rateTableTemplateContainer);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ReviewAdd = function ReviewAdd(_ref) {
  var saving = _ref.saving,
      componentIndex = _ref.componentIndex,
      goToPreviousStep = _ref.goToPreviousStep,
      goToNextStep = _ref.goToNextStep,
      cancelFunc = _ref.cancelFunc,
      cancelText = _ref.cancelText,
      updateRatesTableCell = _ref.updateRatesTableCell,
      step3ContinueText = _ref.step3ContinueText,
      onFinish = _ref.onFinish,
      productType = _ref.productType,
      paxMax = _ref.paxMax,
      twinBedsAvail = _ref.twinBedsAvail,
      rateSet = _objectWithoutProperties(_ref, ['saving', 'componentIndex', 'goToPreviousStep', 'goToNextStep', 'cancelFunc', 'cancelText', 'updateRatesTableCell', 'step3ContinueText', 'onFinish', 'productType', 'paxMax', 'twinBedsAvail']);

  var invalidRateDescrs = productType === 'Non-Accommodation' ? [] : rateSet.rates.filter(function (obj) {
    if (obj.notApplicable) return false;
    if (obj.description === 'Twin') return !twinBedsAvail;
    return obj.maxAdults > paxMax;
  }).map(function (obj) {
    return obj.description;
  });
  return _react2.default.createElement(
    'div',
    { style: { padding: '24px' } },
    _react2.default.createElement(
      'div',
      { style: { width: '72%', margin: 'auto' } },
      'We\u2019ve generated this rate table based on what you\u2019ve told us. If you need to fine tune these rates, just edit the table below.'
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'div',
      { style: { width: '72%', margin: 'auto' } },
      _react2.default.createElement(_rateTableTemplateContainer2.default, {
        productType: productType,
        showHeader: true,
        rateSet: rateSet,
        withEditableCell: true,
        updateTableCell: updateRatesTableCell
      })
    ),
    _react2.default.createElement('br', null),
    Boolean(invalidRateDescrs && invalidRateDescrs.length) && _react2.default.createElement(
      'div',
      { style: { color: '#ff6200', width: '72%', margin: 'auto' } },
      'The bedding configuration added for this room type does not allow for ',
      invalidRateDescrs.length === 1 ? ' a' : '',
      ' ',
      invalidRateDescrs.join('/'),
      ' ',
      (0, _pluralize2.default)('rate', invalidRateDescrs.length),
      '. Please update your bedding configuration in the Profile, or unselect ',
      invalidRateDescrs.join('/'),
      ' as applicable.'
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(_stepperActions2.default, {
      showBackButton: true,
      backButtonFunc: function backButtonFunc() {
        return goToPreviousStep(componentIndex);
      },
      rightButtons: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: cancelText,
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onTouchTap: cancelFunc
        }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          loader: saving,
          onTouchTap: function onTouchTap() {
            if (rateSet.rates.every(function (rate) {
              return rate.notApplicable;
            })) alert('You need to include at least one rate for this rate set to be valid.');else onFinish((0, _ramda.omit)('staypayApplicable', rateSet));
          },
          secondary: true,
          label: step3ContinueText,
          labelStyle: { fontWeight: '600' }
        })
      )
    })
  );
};

ReviewAdd.propTypes = {
  componentIndex: _react.PropTypes.number,
  goToStep: _react.PropTypes.func,
  cancelFunc: _react.PropTypes.func,
  cancelText: _react.PropTypes.string.isRequired,
  updateRatesTableCell: _react.PropTypes.func,
  step3ContinueText: _react.PropTypes.string,
  onFinish: _react.PropTypes.func,
  ratesTable: _react.PropTypes.object
};

exports.default = ReviewAdd;

/***/ }),
/* 3286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _standardWithRetailRate = __webpack_require__(3287);

var _standardWithRetailRate2 = _interopRequireDefault(_standardWithRetailRate);

var _standardWithoutRetailRate = __webpack_require__(3288);

var _standardWithoutRetailRate2 = _interopRequireDefault(_standardWithoutRetailRate);

var _transfersWithRetailRate = __webpack_require__(3289);

var _transfersWithRetailRate2 = _interopRequireDefault(_transfersWithRetailRate);

var _transfersWithoutRetailRate = __webpack_require__(3290);

var _transfersWithoutRetailRate2 = _interopRequireDefault(_transfersWithoutRetailRate);

var _priceBreakWithRetailRate = __webpack_require__(3291);

var _priceBreakWithRetailRate2 = _interopRequireDefault(_priceBreakWithRetailRate);

var _priceBreakWithoutRetailRate = __webpack_require__(3292);

var _priceBreakWithoutRetailRate2 = _interopRequireDefault(_priceBreakWithoutRetailRate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NonAccommodationRate = function NonAccommodationRate(_ref) {
  var rateSet = _ref.rateSet,
      contractState = _ref.contractState,
      extraProps = _objectWithoutProperties(_ref, ['rateSet', 'contractState']);

  var RateTableTemplate = function () {
    if (rateSet.nonStandardTemplateType === 'privateTransfer') {
      if (rateSet.rates.some(function (rate) {
        return rate.retailRate;
      })) return _transfersWithRetailRate2.default;
      return _transfersWithoutRetailRate2.default;
    }
    if (rateSet.nonStandardTemplateType === 'priceBreak') {
      if (rateSet.rates.some(function (rate) {
        return rate.retailRate;
      })) return _priceBreakWithRetailRate2.default;
      return _priceBreakWithoutRetailRate2.default;
    }
    if (rateSet.rates.some(function (rate) {
      return rate.retailRate;
    })) return _standardWithRetailRate2.default;
    return _standardWithoutRetailRate2.default;
  }();
  return _react2.default.createElement(RateTableTemplate, _extends({}, rateSet, extraProps, { contractState: contractState, standardNonAccom: true }));
};

NonAccommodationRate.propTypes = {
  rateSets: _react.PropTypes.array
};

exports.default = (0, _reactRedux.connect)(function (_ref2) {
  var contracting = _ref2.contracting;
  return {
    contractState: contracting.contractActivitiesProducts.getIn(['leftNav', 'contractState'])
  };
})(NonAccommodationRate);

/***/ }),
/* 3287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _clickEditCell = __webpack_require__(879);

var _clickEditCell2 = _interopRequireDefault(_clickEditCell);

var _ratesTableMiscellaneous = __webpack_require__(880);

var _ratesTableMiscellaneous2 = _interopRequireDefault(_ratesTableMiscellaneous);

var _checkRatesDescriptionHelper = __webpack_require__(1058);

var _checkRatesDescriptionHelper2 = _interopRequireDefault(_checkRatesDescriptionHelper);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _contractingPresetNamesCodes = __webpack_require__(464);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var WithRetailRate = function WithRetailRate(props) {
  var rates = props.rates,
      onEdit = props.onEdit,
      deleteFromProduct = props.deleteFromProduct,
      supplierEditable = props.supplierEditable,
      withEditableCell = props.withEditableCell,
      updateTableCell = props.updateTableCell,
      forOffer = props.forOffer,
      rateSetName = props.rateSetName,
      rateSetCode = props.rateSetCode,
      contractState = props.contractState,
      _props$classes = props.classes,
      classes = _props$classes === undefined ? {} : _props$classes,
      forMiscellaneous = _objectWithoutProperties(props, ['rates', 'onEdit', 'deleteFromProduct', 'supplierEditable', 'withEditableCell', 'updateTableCell', 'forOffer', 'rateSetName', 'rateSetCode', 'contractState', 'classes']);

  var inDraft = contractState === 'draft' || contractState === 'publish-ready';
  var isMultiDayTour = forMiscellaneous.nonStandardTemplateType === 'multiDayTour';
  var hasNonStandardDesc = rates.some(function (rate) {
    return !rate.notApplicable && !(0, _checkRatesDescriptionHelper2.default)(rate.description, isMultiDayTour);
  });
  var descriptionsAllowed = function () {
    var descrs = (isMultiDayTour ? _contractingPresetNamesCodes.multiDayTourDescrs : _contractingPresetNamesCodes.standardNonAccomDescrs).map(function (str) {
      return '"' + str + '"';
    });
    return descrs.join(', ');
  }();
  // this is for alternating table row colors
  var rateCount = 0;
  return _react2.default.createElement(
    'div',
    { className: classes['main'] },
    _react2.default.createElement(
      'div',
      { className: 'retail-rate', style: { display: 'block' } },
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '30%' : '45%', textAlign: 'left', display: 'inline-block', fontSize: '14px' } },
        _react2.default.createElement(
          'span',
          { className: classes.rateSetName },
          (rateSetName || '').toUpperCase()
        ),
        _react2.default.createElement(
          'span',
          { className: classes.rateSetCode },
          rateSetCode ? ' (' + rateSetCode + ')' : ''
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '14%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        '\nADULTS'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '15%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        '\nCHILDREN'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '12%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'RETAIL\nRATE'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '13%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'NETT\nRATE'
      ),
      withEditableCell ? _react2.default.createElement(
        'div',
        { style: { width: '16%', textAlign: 'right', paddingRight: '4px', whiteSpace: 'pre', display: 'inline-block' } },
        'APPLICABLE'
      ) : undefined
    ),
    _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '8px', display: 'block' } }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        regularDiv: withEditableCell || forOffer,
        editable: supplierEditable,
        doubleLineTitle: true,
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: onEdit,
          onDelete: deleteFromProduct,
          deleteButton: true
        })
      },
      _react2.default.createElement(_ratesTableMiscellaneous2.default, _extends({}, forMiscellaneous, { rateType: 'includeCommission', classes: classes })),
      _react2.default.createElement(
        'div',
        { style: { display: withEditableCell && hasNonStandardDesc && inDraft ? 'block' : 'none', marginTop: '8px', marginBottom: '8px', color: '#ff4081' } },
        _react2.default.createElement(
          'b',
          null,
          'NOTE: Some rate types in this rate table are no longer supported, as they cannot be automated into your partners\' booking systems.'
        ),
        _react2.default.createElement(
          'div',
          { style: { marginTop: '8px' } },
          'Allowed Descriptions:',
          _react2.default.createElement(
            'div',
            null,
            descriptionsAllowed
          )
        )
      ),

      // 'rates' MUST NOT be filtered because of the classes
      rates.map(function (rate, key) {
        if (!withEditableCell && rate.notApplicable) return _react2.default.createElement('span', { key: key });
        var backgroundColor = rateCount % 2 !== 0 ? 'transparent' : 'rgba(0, 0, 0, 0.1)';
        rateCount++;
        var calculatedMaxChild = function () {
          if (!isNaN(rate.maxChild)) {
            if (Number(rate.maxChild) < 0) return 0;
          }
          var calculatedChild = parseInt(rate.maxAdultsPlusChild, 10) - parseInt(rate.maxAdults, 10);
          return calculatedChild > -1 ? calculatedChild : 0;
        }();
        // Please note: multi day tour template is per pax rate, so maxAdults and maxChild are disabled
        return _react2.default.createElement(
          'div',
          { style: { backgroundColor: backgroundColor }, key: key, className: classes[key + '-rate'] || classes[key + '-notApplicable'] },
          _react2.default.createElement(
            'div',
            { className: 'rates-table-titles' },
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-description'],
                fullWidthInput: true,
                stringAllowed: true,
                defaultValue: '-',
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'description' });
                },
                editable: withEditableCell && !(0, _checkRatesDescriptionHelper2.default)(rate.description, isMultiDayTour) && !rate.notApplicable,
                style: { color: _ramda2.default.call(_ramda2.default.cond([[function () {
                    return rate.notApplicable;
                  }, _ramda2.default.always('rgba(0, 0, 0, 0.34')], [function () {
                    return (0, _checkRatesDescriptionHelper2.default)(rate.description, isMultiDayTour) || !inDraft;
                  }, _ramda2.default.always('')], [_ramda2.default.T, _ramda2.default.always('#ff4081')]])), width: withEditableCell ? '30%' : '41%', textAlign: 'left', paddingLeft: '4px', whiteSpace: 'pre', display: 'inline-block' }
              },
              !(0, _checkRatesDescriptionHelper2.default)(rate.description, isMultiDayTour) && !withEditableCell && inDraft ? rate.description + '!' : rate.description
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-maxAdults'],
                decimalNumber: 0,
                inputAlignRight: true,
                defaultValue: '-',
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'maxAdults' });
                },
                style: { width: withEditableCell ? '14%' : '13%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' },
                editable: withEditableCell && !isMultiDayTour && !rate.notApplicable
              },
              rate.maxAdults
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-maxAdults'] || classes[key + '-maxChild'],
                decimalNumber: 0,
                defaultValue: '-',
                inputAlignRight: true,
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'maxChild' });
                },
                style: { width: withEditableCell ? '16%' : '15%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' },
                editable: withEditableCell && !isMultiDayTour && !rate.notApplicable
              },
              calculatedMaxChild
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-retailRate'],
                decimalNumber: 2,
                defaultValue: '-',
                inputAlignRight: true,
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'retailRate' });
                },
                style: { width: withEditableCell ? '17%' : '16%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' },
                editable: withEditableCell && !rate.notApplicable
              },
              rate.retailRate
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-nettRate'],
                decimalNumber: 2,
                defaultValue: '-',
                inputAlignRight: true,
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'nettRate' });
                },
                style: { width: '14%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' },
                editable: withEditableCell && !rate.notApplicable
              },
              rate.nettRate
            ),
            withEditableCell ? _react2.default.createElement(_materialUi.Checkbox, { style: { marginLeft: '25px', width: '12%', textAlign: 'right', top: '-2px', display: 'inline-block !important' },
              checked: !rate.notApplicable,
              onCheck: function onCheck() {
                return updateTableCell({ value: !rate.notApplicable, row: key, column: 'notApplicable' });
              }
            }) : undefined
          )
        );
      })
    ),
    _react2.default.createElement(_materialUi.Divider, null)
  );
};

WithRetailRate.propTypes = {
  _id: _react.PropTypes.string,
  supplierEditable: _react.PropTypes.bool,
  rates: _react.PropTypes.array,
  rateSetName: _react.PropTypes.string,
  minStay: _react.PropTypes.any,
  maxStay: _react.PropTypes.any,
  withEditableCell: _react.PropTypes.bool,
  updateTableCell: _react.PropTypes.func,
  onEdit: _react.PropTypes.func,
  daysOfWeek: _react.PropTypes.array,
  deleteRates: _react.PropTypes.func,
  contractState: _react.PropTypes.string
};

exports.default = WithRetailRate;

/***/ }),
/* 3288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _clickEditCell = __webpack_require__(879);

var _clickEditCell2 = _interopRequireDefault(_clickEditCell);

var _ratesTableMiscellaneous = __webpack_require__(880);

var _ratesTableMiscellaneous2 = _interopRequireDefault(_ratesTableMiscellaneous);

var _checkRatesDescriptionHelper = __webpack_require__(1058);

var _checkRatesDescriptionHelper2 = _interopRequireDefault(_checkRatesDescriptionHelper);

var _contractingPresetNamesCodes = __webpack_require__(464);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var WithoutRetailRate = function WithoutRetailRate(props) {
  var rates = props.rates,
      onEdit = props.onEdit,
      deleteFromProduct = props.deleteFromProduct,
      supplierEditable = props.supplierEditable,
      withEditableCell = props.withEditableCell,
      updateTableCell = props.updateTableCell,
      forOffer = props.forOffer,
      rateSetName = props.rateSetName,
      rateSetCode = props.rateSetCode,
      contractState = props.contractState,
      _props$classes = props.classes,
      classes = _props$classes === undefined ? {} : _props$classes,
      forMiscellaneous = _objectWithoutProperties(props, ['rates', 'onEdit', 'deleteFromProduct', 'supplierEditable', 'withEditableCell', 'updateTableCell', 'forOffer', 'rateSetName', 'rateSetCode', 'contractState', 'classes']);

  var inDraft = contractState === 'draft' || contractState === 'publish-ready';
  var isMultiDayTour = forMiscellaneous.nonStandardTemplateType === 'multiDayTour';
  var hasNonStandardDesc = rates.some(function (rate) {
    return !rate.notApplicable && !(0, _checkRatesDescriptionHelper2.default)(rate.description, isMultiDayTour);
  });
  var descriptionsAllowed = function () {
    var descrs = (isMultiDayTour ? _contractingPresetNamesCodes.multiDayTourDescrs : _contractingPresetNamesCodes.standardNonAccomDescrs).map(function (str) {
      return '"' + str + '"';
    });
    return descrs.join(', ');
  }();
  // this is for alternating table row colors
  var rateCount = 0;
  return _react2.default.createElement(
    'div',
    { className: classes['main'] },
    _react2.default.createElement(
      'div',
      { className: 'without-retail-rate', style: { display: 'block' } },
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '35%' : '51%', textAlign: 'left', display: 'inline-block', fontSize: '14px' } },
        _react2.default.createElement(
          'span',
          { className: classes.rateSetName },
          (rateSetName || '').toUpperCase()
        ),
        _react2.default.createElement(
          'span',
          { className: classes.rateSetCode },
          rateSetCode ? ' (' + rateSetCode + ')' : ''
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '14%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        '\nADULTS'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '18%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        '\nCHILDREN'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '15%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'NETT\nRATE'
      ),
      withEditableCell ? _react2.default.createElement(
        'div',
        { style: { width: '16%', textAlign: 'right', paddingRight: '4px', whiteSpace: 'pre', display: 'inline-block' } },
        'APPLICABLE'
      ) : undefined
    ),
    _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '8px', display: 'block' } }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        regularDiv: withEditableCell || forOffer,
        editable: supplierEditable,
        doubleLineTitle: true,
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: onEdit,
          onDelete: deleteFromProduct,
          deleteButton: true
        })
      },
      _react2.default.createElement(_ratesTableMiscellaneous2.default, _extends({}, forMiscellaneous, { classes: classes, rateType: 'nett' })),
      _react2.default.createElement(
        'div',
        { style: { display: withEditableCell && hasNonStandardDesc && inDraft ? 'block' : 'none', marginTop: '8px', marginBottom: '8px', color: '#ff4081' } },
        _react2.default.createElement(
          'b',
          null,
          'NOTE: Some rate types in this rate table are no longer supported, as they cannot be automated into your partners\' booking systems.'
        ),
        _react2.default.createElement(
          'div',
          { style: { marginTop: '8px' } },
          'Allowed Descriptions:',
          _react2.default.createElement(
            'div',
            null,
            descriptionsAllowed
          )
        )
      ),

      // 'rates' MUST NOT be filtered because of the classes
      rates.map(function (rate, key) {
        if (!withEditableCell && rate.notApplicable) return _react2.default.createElement('span', { key: key });
        var backgroundColor = rateCount % 2 !== 0 ? 'transparent' : 'rgba(0, 0, 0, 0.1)';
        rateCount++;
        var calculatedMaxChild = function () {
          if (!isNaN(rate.maxChild)) {
            if (Number(rate.maxChild) < 0) return 0;
          }
          var calculatedChild = parseInt(rate.maxAdultsPlusChild, 10) - parseInt(rate.maxAdults, 10);
          return calculatedChild > -1 ? calculatedChild : 0;
        }();
        // Please note: multi day tour template is per pax rate, so maxAdults and maxChild are disabled
        return _react2.default.createElement(
          'div',
          { style: { backgroundColor: backgroundColor }, key: key, className: classes[key + '-rate'] || classes[key + '-notApplicable'] },
          _react2.default.createElement(
            'div',
            { className: 'rates-table-titles' },
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-description'],
                fullWidthInput: true,
                stringAllowed: true,
                decimalNumber: 0,
                defaultValue: '-',
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'description' });
                },
                editable: withEditableCell && !(0, _checkRatesDescriptionHelper2.default)(rate.description, isMultiDayTour) && !rate.notApplicable,
                style: { color: _ramda2.default.call(_ramda2.default.cond([[function () {
                    return rate.notApplicable;
                  }, _ramda2.default.always('rgba(0, 0, 0, 0.34')], [function () {
                    return (0, _checkRatesDescriptionHelper2.default)(rate.description, isMultiDayTour) || !inDraft;
                  }, _ramda2.default.always('')], [_ramda2.default.T, _ramda2.default.always('#ff4081')]])), width: withEditableCell ? '37%' : '51%', textAlign: 'left', paddingLeft: '4px', whiteSpace: 'pre', display: 'inline-block' }
              },
              !(0, _checkRatesDescriptionHelper2.default)(rate.description, isMultiDayTour) && !withEditableCell && inDraft ? rate.description + '!' : rate.description
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-maxAdults'],
                inputAlignRight: true,
                decimalNumber: 0,
                defaultValue: '-',
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'maxAdults' });
                },
                style: { width: '14%', textAlign: 'right', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', whiteSpace: 'pre', display: 'inline-block' },
                editable: withEditableCell && !isMultiDayTour && !rate.notApplicable
              },
              rate.maxAdults
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-maxChild'],
                decimalNumber: 0,
                defaultValue: '-',
                inputAlignRight: true,
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'maxChild' });
                },
                style: { width: '16%', textAlign: 'right', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', display: 'inline-block' },
                editable: withEditableCell && !isMultiDayTour && !rate.notApplicable
              },
              calculatedMaxChild
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-nettRate'],
                inputAlignRight: true,
                decimalNumber: 2,
                defaultValue: '-',
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'nettRate' });
                },
                style: { width: withEditableCell ? '15%' : '18%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' },
                editable: withEditableCell && !rate.notApplicable
              },
              rate.nettRate
            ),
            withEditableCell ? _react2.default.createElement(_materialUi.Checkbox, { style: { marginLeft: '25px', width: '14%', textAlign: 'right', top: '-2px', display: 'inline-block !important' },
              checked: !rate.notApplicable,
              onCheck: function onCheck() {
                return updateTableCell({ value: !rate.notApplicable, row: key, column: 'notApplicable' });
              }
            }) : undefined
          )
        );
      })
    ),
    _react2.default.createElement(_materialUi.Divider, null)
  );
};

WithoutRetailRate.propTypes = {
  _id: _react.PropTypes.string,
  supplierEditable: _react.PropTypes.bool,
  rates: _react.PropTypes.array,
  rateSetName: _react.PropTypes.string,
  minStay: _react.PropTypes.any,
  maxStay: _react.PropTypes.any,
  withEditableCell: _react.PropTypes.bool,
  updateTableCell: _react.PropTypes.func,
  onEdit: _react.PropTypes.func,
  daysOfWeek: _react.PropTypes.array,
  deleteRates: _react.PropTypes.func,
  deleteFromProduct: _react.PropTypes.func,
  contractState: _react.PropTypes.string
};

exports.default = WithoutRetailRate;

/***/ }),
/* 3289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _clickEditCell = __webpack_require__(879);

var _clickEditCell2 = _interopRequireDefault(_clickEditCell);

var _ratesTableMiscellaneous = __webpack_require__(880);

var _ratesTableMiscellaneous2 = _interopRequireDefault(_ratesTableMiscellaneous);

var _checkRatesDescriptionHelper = __webpack_require__(1058);

var _checkRatesDescriptionHelper2 = _interopRequireDefault(_checkRatesDescriptionHelper);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var WithRetailRate = function WithRetailRate(props) {
  var rates = props.rates,
      onEdit = props.onEdit,
      deleteFromProduct = props.deleteFromProduct,
      supplierEditable = props.supplierEditable,
      withEditableCell = props.withEditableCell,
      updateTableCell = props.updateTableCell,
      forOffer = props.forOffer,
      rateSetName = props.rateSetName,
      rateSetCode = props.rateSetCode,
      _props$classes = props.classes,
      classes = _props$classes === undefined ? {} : _props$classes,
      forMiscellaneous = _objectWithoutProperties(props, ['rates', 'onEdit', 'deleteFromProduct', 'supplierEditable', 'withEditableCell', 'updateTableCell', 'forOffer', 'rateSetName', 'rateSetCode', 'classes']);

  var hasNonStandardDesc = rates.some(function (rate) {
    return !rate.notApplicable && !(0, _checkRatesDescriptionHelper2.default)(rate.description);
  });
  // this is for alternating table row colors
  var rateCount = 0;
  return _react2.default.createElement(
    'div',
    { className: classes['main'] },
    _react2.default.createElement(
      'div',
      { className: 'retail-rate', style: { display: 'block' } },
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '26%' : '48%', textAlign: 'left', display: 'inline-block', fontSize: '14px' } },
        '' + (rateSetName || '').toUpperCase() + (rateSetCode ? ' (' + rateSetCode + ')' : '')
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '24%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'TOTAL\nGUESTS'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '14%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'RETAIL\nRATE'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '13%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'NETT\nRATE'
      ),
      withEditableCell ? _react2.default.createElement(
        'div',
        { style: { width: '22%', textAlign: 'left', paddingLeft: '8%', whiteSpace: 'pre', display: 'inline-block' } },
        'APPLICABLE'
      ) : undefined
    ),
    _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '8px', display: 'block' } }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        regularDiv: withEditableCell || forOffer,
        editable: supplierEditable,
        doubleLineTitle: true,
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: onEdit,
          onDelete: deleteFromProduct,
          deleteButton: true
        })
      },
      _react2.default.createElement(_ratesTableMiscellaneous2.default, _extends({}, forMiscellaneous, { rateType: 'includeCommission', classes: classes })),
      _react2.default.createElement(
        'div',
        { style: { display: withEditableCell && hasNonStandardDesc ? 'block' : 'none', marginTop: '8px', marginBottom: '8px', color: '#ff4081' } },
        _react2.default.createElement(
          'b',
          null,
          'NOTE: Some rate types in this rate table are no longer supported, as they cannot be automated into your partners\' booking systems.'
        ),
        _react2.default.createElement(
          'div',
          { style: { marginTop: '8px' } },
          'Allowed Description: "Up to"'
        )
      ),

      // 'rates' MUST NOT be filtered because of the classes
      rates.map(function (rate, key) {
        if (!withEditableCell && rate.notApplicable) return _react2.default.createElement('span', { key: key });
        var backgroundColor = rateCount % 2 !== 0 ? 'transparent' : 'rgba(0, 0, 0, 0.1)';
        rateCount++;
        return _react2.default.createElement(
          'div',
          { style: { backgroundColor: backgroundColor }, key: key, className: classes[key + '-rate'] || classes[key + '-notApplicable'] },
          _react2.default.createElement(
            'div',
            { className: 'rates-table-titles' },
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                fullWidthInput: true,
                stringAllowed: true,
                decimalNumber: 0,
                defaultValue: '-',
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'description' });
                },
                editable: withEditableCell && !(0, _checkRatesDescriptionHelper2.default)(rate.description),
                style: { color: _ramda2.default.call(_ramda2.default.cond([[function () {
                    return rate.notApplicable;
                  }, _ramda2.default.always('rgba(0, 0, 0, 0.34')], [function () {
                    return (0, _checkRatesDescriptionHelper2.default)(rate.description);
                  }, _ramda2.default.always('')], [_ramda2.default.T, _ramda2.default.always('#ff4081')]])), width: withEditableCell ? '25%' : '46%', textAlign: 'left', paddingLeft: '4px', whiteSpace: 'pre', display: 'inline-block' }
              },
              'Up to (or ',
              key ? parseInt(rates[key - 1].maxAdultsPlusChild, 10) + 1 : 1,
              '-',
              rate.maxAdultsPlusChild,
              ' pax)'
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                decimalNumber: 0,
                inputAlignRight: true,
                defaultValue: '-',
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'maxAdultsPlusChild' });
                },
                style: { width: '24%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' },
                editable: withEditableCell
              },
              rate.maxAdultsPlusChild
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                decimalNumber: 2,
                defaultValue: '-',
                inputAlignRight: true,
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'retailRate' });
                },
                style: { width: '15%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' },
                editable: withEditableCell
              },
              rate.retailRate
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                decimalNumber: 2,
                defaultValue: '-',
                inputAlignRight: true,
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'nettRate' });
                },
                style: { width: '13%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' },
                editable: withEditableCell
              },
              rate.nettRate
            ),
            withEditableCell ? _react2.default.createElement(_materialUi.Checkbox, { style: { width: '21%', paddingLeft: '12%', top: '-2px' },
              checked: !rate.notApplicable,
              onCheck: function onCheck() {
                return updateTableCell({ value: !rate.notApplicable, row: key, column: 'notApplicable' });
              }
            }) : undefined
          )
        );
      })
    ),
    _react2.default.createElement(_materialUi.Divider, null)
  );
};

WithRetailRate.propTypes = {
  _id: _react.PropTypes.string,
  supplierEditable: _react.PropTypes.bool,
  rates: _react.PropTypes.array,
  rateSetName: _react.PropTypes.string,
  minStay: _react.PropTypes.any,
  maxStay: _react.PropTypes.any,
  withEditableCell: _react.PropTypes.bool,
  updateTableCell: _react.PropTypes.func,
  onEdit: _react.PropTypes.func,
  daysOfWeek: _react.PropTypes.array,
  deleteRates: _react.PropTypes.func
};

exports.default = WithRetailRate;

/***/ }),
/* 3290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _clickEditCell = __webpack_require__(879);

var _clickEditCell2 = _interopRequireDefault(_clickEditCell);

var _ratesTableMiscellaneous = __webpack_require__(880);

var _ratesTableMiscellaneous2 = _interopRequireDefault(_ratesTableMiscellaneous);

var _checkRatesDescriptionHelper = __webpack_require__(1058);

var _checkRatesDescriptionHelper2 = _interopRequireDefault(_checkRatesDescriptionHelper);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var WithoutRetailRate = function WithoutRetailRate(props) {
  var rates = props.rates,
      onEdit = props.onEdit,
      deleteFromProduct = props.deleteFromProduct,
      supplierEditable = props.supplierEditable,
      withEditableCell = props.withEditableCell,
      updateTableCell = props.updateTableCell,
      forOffer = props.forOffer,
      rateSetName = props.rateSetName,
      rateSetCode = props.rateSetCode,
      _props$classes = props.classes,
      classes = _props$classes === undefined ? {} : _props$classes,
      forMiscellaneous = _objectWithoutProperties(props, ['rates', 'onEdit', 'deleteFromProduct', 'supplierEditable', 'withEditableCell', 'updateTableCell', 'forOffer', 'rateSetName', 'rateSetCode', 'classes']);

  var hasNonStandardDesc = rates.some(function (rate) {
    return !rate.notApplicable && !(0, _checkRatesDescriptionHelper2.default)(rate.description);
  });
  // this is for alternating table row colors
  var rateCount = 0;
  return _react2.default.createElement(
    'div',
    { className: classes['main'] },
    _react2.default.createElement(
      'div',
      { className: 'without-retail-rate', style: { display: 'block' } },
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '40%' : '62%', textAlign: 'left', display: 'inline-block', fontSize: '14px' } },
        _react2.default.createElement(
          'span',
          { className: classes.rateSetName },
          (rateSetName || '').toUpperCase()
        ),
        _react2.default.createElement(
          'span',
          { className: classes.rateSetCode },
          rateSetCode ? ' (' + rateSetCode + ')' : ''
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '21%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'TOTAL\nGUESTS'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '15%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'NETT\nRATE'
      ),
      withEditableCell ? _react2.default.createElement(
        'div',
        { style: { width: '22%', textAlign: 'right', paddingRight: '4px', whiteSpace: 'pre', display: 'inline-block' } },
        'APPLICABLE'
      ) : undefined
    ),
    _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '8px', display: 'block' } }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        regularDiv: withEditableCell || forOffer,
        editable: supplierEditable,
        doubleLineTitle: true,
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: onEdit,
          onDelete: deleteFromProduct,
          deleteButton: true
        })
      },
      _react2.default.createElement(_ratesTableMiscellaneous2.default, _extends({}, forMiscellaneous, { classes: classes, rateType: 'nett' })),
      _react2.default.createElement(
        'div',
        { style: { display: withEditableCell && hasNonStandardDesc ? 'block' : 'none', marginTop: '8px', marginBottom: '8px', color: '#ff4081' } },
        _react2.default.createElement(
          'b',
          null,
          'NOTE: Some rate types in this rate table are no longer supported, as they cannot be automated into your partners\' booking systems.'
        ),
        _react2.default.createElement(
          'div',
          { style: { marginTop: '8px' } },
          'Allowed Description: "Up to"'
        )
      ),

      // 'rates' MUST NOT be filtered because of the classes
      rates.map(function (rate, key) {
        if (!withEditableCell && rate.notApplicable) return _react2.default.createElement('span', { key: key });
        var backgroundColor = rateCount % 2 !== 0 ? 'transparent' : 'rgba(0, 0, 0, 0.1)';
        rateCount++;
        return _react2.default.createElement(
          'div',
          { style: { backgroundColor: backgroundColor }, key: key, className: classes[key + '-rate'] || classes[key + '-notApplicable'] },
          _react2.default.createElement(
            'div',
            { className: 'rates-table-titles' },
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-description'],
                fullWidthInput: true,
                stringAllowed: true,
                decimalNumber: 0,
                defaultValue: '-',
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'description' });
                },
                editable: withEditableCell && !(0, _checkRatesDescriptionHelper2.default)(rate.description),
                style: { color: _ramda2.default.call(_ramda2.default.cond([[function () {
                    return rate.notApplicable;
                  }, _ramda2.default.always('rgba(0, 0, 0, 0.34')], [function () {
                    return (0, _checkRatesDescriptionHelper2.default)(rate.description);
                  }, _ramda2.default.always('')], [_ramda2.default.T, _ramda2.default.always('#ff4081')]])), width: withEditableCell ? '40%' : '62%', textAlign: 'left', paddingLeft: '4px', whiteSpace: 'pre', display: 'inline-block' }
              },
              'Up to (or ',
              key ? parseInt(rates[key - 1].maxAdultsPlusChild, 10) : 1,
              '-',
              rate.maxAdultsPlusChild,
              ' pax)'
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-maxAdultsPlusChild'],
                inputAlignRight: true,
                decimalNumber: 0,
                defaultValue: '-',
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'maxAdultsPlusChild' });
                },
                style: { width: '19%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' },
                editable: withEditableCell
              },
              rate.maxAdultsPlusChild
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-nettRate'],
                inputAlignRight: true,
                decimalNumber: 2,
                defaultValue: '-',
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'nettRate' });
                },
                style: { width: '17%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' },
                editable: withEditableCell
              },
              rate.nettRate
            ),
            withEditableCell ? _react2.default.createElement(_materialUi.Checkbox, { style: { width: '22%', top: '-2px', paddingLeft: '15%' },
              checked: !rate.notApplicable,
              onCheck: function onCheck() {
                return updateTableCell({ value: !rate.notApplicable, row: key, column: 'notApplicable' });
              }
            }) : undefined
          )
        );
      })
    ),
    _react2.default.createElement(_materialUi.Divider, null)
  );
};

WithoutRetailRate.propTypes = {
  _id: _react.PropTypes.string,
  supplierEditable: _react.PropTypes.bool,
  rates: _react.PropTypes.array,
  rateSetName: _react.PropTypes.string,
  minStay: _react.PropTypes.any,
  maxStay: _react.PropTypes.any,
  withEditableCell: _react.PropTypes.bool,
  updateTableCell: _react.PropTypes.func,
  onEdit: _react.PropTypes.func,
  daysOfWeek: _react.PropTypes.array,
  deleteRates: _react.PropTypes.func,
  deleteFromProduct: _react.PropTypes.func,
  usedRateSetNamesAndCodes: _react.PropTypes.array,
  forOffer: _react.PropTypes.bool,
  contractState: _react.PropTypes.string
};

exports.default = WithoutRetailRate;

/***/ }),
/* 3291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _clickEditCell = __webpack_require__(879);

var _clickEditCell2 = _interopRequireDefault(_clickEditCell);

var _ratesTableMiscellaneous = __webpack_require__(880);

var _ratesTableMiscellaneous2 = _interopRequireDefault(_ratesTableMiscellaneous);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var WithRetailRate = function WithRetailRate(props) {
  var rates = props.rates,
      onEdit = props.onEdit,
      deleteFromProduct = props.deleteFromProduct,
      supplierEditable = props.supplierEditable,
      withEditableCell = props.withEditableCell,
      updateTableCell = props.updateTableCell,
      forOffer = props.forOffer,
      rateSetName = props.rateSetName,
      rateSetCode = props.rateSetCode,
      _props$classes = props.classes,
      classes = _props$classes === undefined ? {} : _props$classes,
      forMiscellaneous = _objectWithoutProperties(props, ['rates', 'onEdit', 'deleteFromProduct', 'supplierEditable', 'withEditableCell', 'updateTableCell', 'forOffer', 'rateSetName', 'rateSetCode', 'classes']);
  // this is for alternating table row colors


  var rateCount = 0;
  return _react2.default.createElement(
    'div',
    { className: classes['main'] },
    _react2.default.createElement(
      'div',
      { className: 'retail-rate', style: { display: 'block' } },
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '30%' : '45%', textAlign: 'left', display: 'inline-block', fontSize: '14px' } },
        _react2.default.createElement(
          'span',
          { className: classes.rateSetName },
          (rateSetName || '').toUpperCase()
        ),
        _react2.default.createElement(
          'span',
          { className: classes.rateSetCode },
          rateSetCode ? ' (' + rateSetCode + ')' : ''
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '13%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'MINIMUM\nGUESTS'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '15%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'MAXIMUM\nGUESTS'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '12%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'RETAIL\nRATE'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '13%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'NETT\nRATE'
      ),
      withEditableCell ? _react2.default.createElement(
        'div',
        { style: { width: '16%', textAlign: 'right', paddingRight: '4px', whiteSpace: 'pre', display: 'inline-block' } },
        'APPLICABLE'
      ) : undefined
    ),
    _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '8px', display: 'block' } }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        regularDiv: withEditableCell || forOffer,
        editable: supplierEditable,
        doubleLineTitle: true,
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: onEdit,
          onDelete: deleteFromProduct,
          deleteButton: true
        })
      },
      _react2.default.createElement(_ratesTableMiscellaneous2.default, _extends({}, forMiscellaneous, { rateType: 'includeCommission', classes: classes })),

      // 'rates' MUST NOT be filtered because of the classes
      rates.map(function (rate, key) {
        if (!withEditableCell && rate.notApplicable) return _react2.default.createElement('span', { key: key });
        var backgroundColor = rateCount % 2 !== 0 ? 'transparent' : 'rgba(0, 0, 0, 0.1)';
        rateCount++;
        return _react2.default.createElement(
          'div',
          { style: { backgroundColor: backgroundColor }, key: key, className: classes[key + '-rate'] || classes[key + '-notApplicable'] },
          _react2.default.createElement(
            'div',
            { className: 'rates-table-titles' },
            _react2.default.createElement(
              'div',
              {
                className: classes[key + '-description'],
                style: { width: withEditableCell ? '25%' : '41%', textAlign: 'left', paddingLeft: '4px', whiteSpace: 'pre', display: 'inline-block' }
              },
              rate.description || 'Per Person'
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-minGuests'],
                decimalNumber: 0,
                defaultValue: '-',
                inputAlignRight: true,
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'minGuests' });
                },
                onBlur: function onBlur() {
                  if (Number(rate.minGuests) <= Number(rates[key - 1].minGuests)) {
                    alert('Current minimum guests have to be more than the last minimum guests.');
                    var maxMinMax = Math.max(Number(rates[key - 1].maxAdultsPlusChild), Number(rates[key - 1].minGuests));
                    updateTableCell({ row: key, column: 'minGuests', value: maxMinMax + 1 });
                  }
                },
                style: { width: withEditableCell ? '14%' : '13%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' },
                editable: withEditableCell
              },
              rate.minGuests
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-maxAdultsPlusChild'],
                decimalNumber: 0,
                defaultValue: '-',
                inputAlignRight: true,
                onBlur: function onBlur() {
                  if (Number(rate.maxAdultsPlusChild) < Number(rate.minGuests)) {
                    alert('Maximum guests have to be more than minimum guests.');
                    updateTableCell({ column: 'maxAdultsPlusChild', row: key, value: Number(rate.minGuests) + 1 });
                  }
                },
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'maxAdultsPlusChild' });
                },
                style: { width: withEditableCell ? '16%' : '15%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' },
                editable: withEditableCell
              },
              rate.maxAdultsPlusChild
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-retailRate'],
                decimalNumber: 2,
                defaultValue: '-',
                inputAlignRight: true,
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'retailRate' });
                },
                style: { width: withEditableCell ? '14%' : '16%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' },
                editable: withEditableCell
              },
              rate.retailRate
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-nettRate'],
                decimalNumber: 2,
                defaultValue: '-',
                inputAlignRight: true,
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'nettRate' });
                },
                style: { width: '14%', textAlign: 'right', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', display: 'inline-block' },
                editable: withEditableCell
              },
              rate.nettRate
            ),
            withEditableCell ? _react2.default.createElement(_materialUi.Checkbox, { style: { marginLeft: '25px', width: '14%', textAlign: 'right', top: '-2px', display: 'inline-block !important' },
              checked: !rate.notApplicable,
              onCheck: function onCheck() {
                return updateTableCell({ value: !rate.notApplicable, row: key, column: 'notApplicable' });
              }
            }) : undefined
          )
        );
      })
    ),
    _react2.default.createElement(_materialUi.Divider, null)
  );
};

WithRetailRate.propTypes = {
  _id: _react.PropTypes.string,
  supplierEditable: _react.PropTypes.bool,
  rates: _react.PropTypes.array,
  rateSetName: _react.PropTypes.string,
  minStay: _react.PropTypes.any,
  maxStay: _react.PropTypes.any,
  withEditableCell: _react.PropTypes.bool,
  updateTableCell: _react.PropTypes.func,
  onEdit: _react.PropTypes.func,
  daysOfWeek: _react.PropTypes.array,
  deleteRates: _react.PropTypes.func,
  contractState: _react.PropTypes.string
};

exports.default = WithRetailRate;

/***/ }),
/* 3292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _clickEditCell = __webpack_require__(879);

var _clickEditCell2 = _interopRequireDefault(_clickEditCell);

var _ratesTableMiscellaneous = __webpack_require__(880);

var _ratesTableMiscellaneous2 = _interopRequireDefault(_ratesTableMiscellaneous);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var WithoutRetailRate = function WithoutRetailRate(props) {
  var rates = props.rates,
      onEdit = props.onEdit,
      deleteFromProduct = props.deleteFromProduct,
      supplierEditable = props.supplierEditable,
      withEditableCell = props.withEditableCell,
      updateTableCell = props.updateTableCell,
      forOffer = props.forOffer,
      rateSetName = props.rateSetName,
      rateSetCode = props.rateSetCode,
      _props$classes = props.classes,
      classes = _props$classes === undefined ? {} : _props$classes,
      forMiscellaneous = _objectWithoutProperties(props, ['rates', 'onEdit', 'deleteFromProduct', 'supplierEditable', 'withEditableCell', 'updateTableCell', 'forOffer', 'rateSetName', 'rateSetCode', 'classes']);
  // this is for alternating table row colors


  var rateCount = 0;
  return _react2.default.createElement(
    'div',
    { className: classes['main'] },
    _react2.default.createElement(
      'div',
      { className: 'without-retail-rate', style: { display: 'block' } },
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '35%' : '51%', textAlign: 'left', display: 'inline-block', fontSize: '14px' } },
        '' + (rateSetName || '').toUpperCase() + (rateSetCode ? ' (' + rateSetCode + ')' : '')
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '14%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'MINIMUM\nGUESTS'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '18%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'MAXIMUM\nGUESTS'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '15%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'NETT\nRATE'
      ),
      withEditableCell ? _react2.default.createElement(
        'div',
        { style: { width: '16%', textAlign: 'right', paddingRight: '4px', whiteSpace: 'pre', display: 'inline-block' } },
        'APPLICABLE'
      ) : undefined
    ),
    _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '8px', display: 'block' } }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        regularDiv: withEditableCell || forOffer,
        editable: supplierEditable,
        doubleLineTitle: true,
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: onEdit,
          onDelete: deleteFromProduct,
          deleteButton: true
        })
      },
      _react2.default.createElement(_ratesTableMiscellaneous2.default, _extends({}, forMiscellaneous, { rateType: 'nett', classes: classes })),

      // 'rates' MUST NOT be filtered because of the classes
      rates.map(function (rate, key) {
        if (!withEditableCell && rate.notApplicable) return _react2.default.createElement('span', { key: key });
        var backgroundColor = rateCount % 2 !== 0 ? 'transparent' : 'rgba(0, 0, 0, 0.1)';
        rateCount++;
        return _react2.default.createElement(
          'div',
          { style: { backgroundColor: backgroundColor }, key: key, className: classes[key + '-rate'] || classes[key + '-notApplicable'] },
          _react2.default.createElement(
            'div',
            { className: 'rates-table-titles' },
            _react2.default.createElement(
              'div',
              {
                className: classes[key + '-description'],
                style: { width: withEditableCell ? '37%' : '51%', textAlign: 'left', paddingLeft: '4px', whiteSpace: 'pre', display: 'inline-block' }
              },
              rate.description || 'Per Person'
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-minGuests'],
                inputAlignRight: true,
                decimalNumber: 0,
                defaultValue: '-',
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'minGuests' });
                },
                onBlur: function onBlur() {
                  if (Number(rate.minGuests) <= Number(rates[key - 1].minGuests)) {
                    alert('Current minimum guests have to be more than the last minimum guests.');
                    var maxMinMax = Math.max(Number(rates[key - 1].maxAdultsPlusChild), Number(rates[key - 1].minGuests));
                    updateTableCell({ row: key, column: 'minGuests', value: maxMinMax + 1 });
                  }
                },
                style: { width: '14%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' },
                editable: withEditableCell
              },
              rate.minGuests
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-maxAdultsPlusChild'],
                inputAlignRight: true,
                decimalNumber: 0,
                defaultValue: '-',
                onBlur: function onBlur() {
                  if (Number(rate.maxAdultsPlusChild) < Number(rate.minGuests)) {
                    alert('Maximum guests have to be more than minimum guests.');
                    updateTableCell({ column: 'maxAdultsPlusChild', row: key, value: Number(rate.minGuests) + 1 });
                  }
                },
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'maxAdultsPlusChild' });
                },
                style: { width: '16%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' },
                editable: withEditableCell
              },
              rate.maxAdultsPlusChild
            ),
            _react2.default.createElement(
              _clickEditCell2.default,
              {
                className: classes[key + '-nettRate'],
                inputAlignRight: true,
                decimalNumber: 2,
                defaultValue: '-',
                onChange: function onChange(value) {
                  return updateTableCell({ value: value, row: key, column: 'nettRate' });
                },
                style: { width: withEditableCell ? '15%' : '18%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' },
                editable: withEditableCell
              },
              rate.nettRate
            ),
            withEditableCell ? _react2.default.createElement(_materialUi.Checkbox, { style: { width: '14%', top: '-2px', paddingLeft: '10%' },
              checked: !rate.notApplicable,
              onCheck: function onCheck() {
                return updateTableCell({ value: !rate.notApplicable, row: key, column: 'notApplicable' });
              }
            }) : undefined
          )
        );
      })
    ),
    _react2.default.createElement(_materialUi.Divider, null)
  );
};

WithoutRetailRate.propTypes = {
  _id: _react.PropTypes.string,
  supplierEditable: _react.PropTypes.bool,
  rates: _react.PropTypes.array,
  rateSetName: _react.PropTypes.string,
  minStay: _react.PropTypes.any,
  maxStay: _react.PropTypes.any,
  withEditableCell: _react.PropTypes.bool,
  updateTableCell: _react.PropTypes.func,
  onEdit: _react.PropTypes.func,
  daysOfWeek: _react.PropTypes.array,
  deleteRates: _react.PropTypes.func,
  deleteFromProduct: _react.PropTypes.func,
  contractState: _react.PropTypes.string
};

exports.default = WithoutRetailRate;

/***/ }),
/* 3293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _withRetailRate = __webpack_require__(3294);

var _withRetailRate2 = _interopRequireDefault(_withRetailRate);

var _withoutRetailRate = __webpack_require__(3295);

var _withoutRetailRate2 = _interopRequireDefault(_withoutRetailRate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AccommodationRate = function AccommodationRate(_ref) {
  var rateSet = _ref.rateSet,
      contractState = _ref.contractState,
      extraProps = _objectWithoutProperties(_ref, ['rateSet', 'contractState']);

  var RateTableTemplate = function () {
    if (rateSet.rates.some(function (rate) {
      return rate.retailRate;
    })) return _withRetailRate2.default;
    return _withoutRetailRate2.default;
  }();
  return _react2.default.createElement(RateTableTemplate, _extends({}, rateSet, { contractState: contractState }, extraProps));
};

AccommodationRate.propTypes = {
  rateSets: _react.PropTypes.array
};

exports.default = AccommodationRate;

/***/ }),
/* 3294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _clickEditCell = __webpack_require__(879);

var _clickEditCell2 = _interopRequireDefault(_clickEditCell);

var _ratesTableMiscellaneous = __webpack_require__(880);

var _ratesTableMiscellaneous2 = _interopRequireDefault(_ratesTableMiscellaneous);

var _checkRatesDescriptionHelper = __webpack_require__(1058);

var _checkRatesDescriptionHelper2 = _interopRequireDefault(_checkRatesDescriptionHelper);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var WithRetailRate = function WithRetailRate(props) {
  var rates = props.rates,
      onEdit = props.onEdit,
      deleteFromProduct = props.deleteFromProduct,
      supplierEditable = props.supplierEditable,
      withEditableCell = props.withEditableCell,
      updateTableCell = props.updateTableCell,
      forOffer = props.forOffer,
      rateSetName = props.rateSetName,
      rateSetCode = props.rateSetCode,
      _props$classes = props.classes,
      classes = _props$classes === undefined ? {} : _props$classes,
      forMiscellaneous = _objectWithoutProperties(props, ['rates', 'onEdit', 'deleteFromProduct', 'supplierEditable', 'withEditableCell', 'updateTableCell', 'forOffer', 'rateSetName', 'rateSetCode', 'classes']);

  var exists = _ramda2.default.allPass([function (val) {
    return _ramda2.default.complement(_ramda2.default.isNil)(val);
  }, function (val) {
    return _ramda2.default.complement(_ramda2.default.equals(0))(val);
  }, function (val) {
    return _ramda2.default.complement(_ramda2.default.equals('0'))(val);
  }, function (val) {
    return _ramda2.default.complement(_ramda2.default.equals(''))(val);
  }]);
  var rateWithMaxAdultsPlusChild = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.last, _ramda2.default.sort(function (a, b) {
    var rateA = _ramda2.default.propOr(0, 'maxAdultsPlusChild', a);
    var rateB = _ramda2.default.propOr(0, 'maxAdultsPlusChild', b);
    if (rateA > rateB) return 1;
    if (rateB > rateA) return -1;
    return 0;
  }), _ramda2.default.filter(function (rate) {
    return exists(_ramda2.default.prop('maxAdultsPlusChild', rate));
  })), rates);
  var maxAdultsPlusChild = _ramda2.default.propOr(0, 'maxAdultsPlusChild', rateWithMaxAdultsPlusChild || {});
  var hasNonStandardDesc = rates.some(function (rate) {
    return !rate.notApplicable && !(0, _checkRatesDescriptionHelper2.default)(rate.description);
  });
  var descriptionsAllowed = rates.every(function (rate) {
    return rate.description && rate.description.indexOf('uest') === -1;
  }) ? '"Single", "Double", "Twin", "Triple", "Quad".' : '"1 Guest", "2 Guests", "3 Guests", "4 Guests", "5 Guests", ...etc.';
  // this is for alternating table row colors
  var rateCount = 0;
  return _react2.default.createElement(
    'div',
    { className: classes['main'] },
    _react2.default.createElement(
      'div',
      { className: 'rates-table', style: { display: 'block' } },
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '24%' : '28%', textAlign: 'left', whiteSpace: 'pre-wrap', display: 'inline-block', fontSize: '14px' } },
        _react2.default.createElement(
          'span',
          { className: classes.rateSetName },
          (rateSetName || '').toUpperCase()
        ),
        _react2.default.createElement(
          'span',
          { className: classes.rateSetCode },
          rateSetCode ? ' (' + rateSetCode + ')' : ''
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '16%' : '20%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        forOffer ? '' : 'PRICE CODE'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '12%' : '14%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'ADULTS'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '16%' : '19%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'RETAIL RATE'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '16%' : '19%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'NETT RATE'
      ),
      withEditableCell ? _react2.default.createElement(
        'div',
        { style: { width: '15%', textAlign: 'right', paddingRight: '4px', whiteSpace: 'pre', display: 'inline-block' } },
        'APPLICABLE'
      ) : undefined
    ),
    _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '8px', display: 'block' } }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        regularDiv: withEditableCell || forOffer,
        editable: supplierEditable,
        doubleLineTitle: true,
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: onEdit,
          onDelete: deleteFromProduct,
          deleteButton: true
        })
      },
      _react2.default.createElement(_ratesTableMiscellaneous2.default, _extends({}, forMiscellaneous, { rateType: 'includeCommission', maxAdultsPlusChild: maxAdultsPlusChild, rateSetName: rateSetName, classes: classes })),
      _react2.default.createElement(
        'div',
        { style: { display: withEditableCell && hasNonStandardDesc ? 'block' : 'none', marginTop: '8px', marginBottom: '8px', color: '#ff4081' } },
        _react2.default.createElement(
          'b',
          null,
          'NOTE: Some rate types in this rate table are no longer supported, as they cannot be automated into your partners\' booking systems.'
        ),
        _react2.default.createElement(
          'div',
          { style: { marginTop: '8px' } },
          'Allowed Descriptions:',
          _react2.default.createElement(
            'div',
            null,
            descriptionsAllowed
          )
        )
      ),
      _react2.default.createElement(
        'div',
        null,

        // 'rates' MUST NOT be filtered because of the classes
        rates.map(function (rate, key) {
          if (!withEditableCell && rate.notApplicable) return _react2.default.createElement('span', { key: key });
          var backgroundColor = rateCount % 2 !== 0 ? 'transparent' : 'rgba(0, 0, 0, 0.1)';
          rateCount++;
          return _react2.default.createElement(
            'div',
            { style: { backgroundColor: backgroundColor }, key: key, className: classes[key + '-rate'] || classes[key + '-notApplicable'] },
            _react2.default.createElement(
              'div',
              { className: 'rates-table-titles' },
              _react2.default.createElement(
                _clickEditCell2.default,
                {
                  className: classes[key + '-description'],
                  fullWidthInput: true,
                  stringAllowed: true,
                  defaultValue: '-',
                  onChange: function onChange(value) {
                    return updateTableCell({ value: value, row: key, column: 'description' });
                  },
                  editable: withEditableCell && !(0, _checkRatesDescriptionHelper2.default)(rate.description),
                  style: { color: _ramda2.default.call(_ramda2.default.cond([[function () {
                      return rate.notApplicable;
                    }, _ramda2.default.always('rgba(0, 0, 0, 0.34')], [function () {
                      return (0, _checkRatesDescriptionHelper2.default)(rate.description);
                    }, _ramda2.default.always('')], [_ramda2.default.T, _ramda2.default.always('#ff4081')]])), width: withEditableCell ? '24%' : '28%', textAlign: 'left', paddingLeft: '4px', whiteSpace: 'pre', display: 'inline-block' }
                },
                !(0, _checkRatesDescriptionHelper2.default)(rate.description) && !withEditableCell ? rate.description + '!' : rate.description
              ),
              _react2.default.createElement(
                _clickEditCell2.default,
                {
                  className: classes[key + '-priceCode'],
                  stringAllowed: true,
                  fullWidthInput: true,
                  inputAlignRight: true,
                  onChange: function onChange(value) {
                    return updateTableCell({ value: value, row: key, column: 'priceCode' });
                  },
                  style: { width: withEditableCell ? '16%' : '20%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' },
                  editable: withEditableCell && !forOffer && !rate.notApplicable
                },
                rate.priceCode
              ),
              _react2.default.createElement(
                _clickEditCell2.default,
                {
                  className: classes[key + '-maxAdults'],
                  decimalNumber: 0,
                  inputAlignRight: true,
                  defaultValue: '-',
                  onChange: function onChange(value) {
                    return updateTableCell({ value: value, row: key, column: 'maxAdults' });
                  },
                  style: { width: '12%', textAlign: 'right', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', whiteSpace: 'pre', display: 'inline-block' },
                  editable: withEditableCell && !rate.notApplicable
                },
                rate.maxAdults
              ),
              _react2.default.createElement(
                _clickEditCell2.default,
                {
                  className: classes[key + '-retailRate'],
                  inputAlignRight: true,
                  decimalNumber: 2,
                  defaultValue: '-',
                  onChange: function onChange(value) {
                    return updateTableCell({ value: value, row: key, column: 'retailRate' });
                  },
                  style: { width: withEditableCell ? '16%' : '20%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' },
                  editable: withEditableCell && !rate.notApplicable
                },
                rate.retailRate
              ),
              _react2.default.createElement(
                _clickEditCell2.default,
                {
                  className: classes[key + '-nettRate'],
                  inputAlignRight: true,
                  decimalNumber: 2,
                  defaultValue: '-',
                  onChange: function onChange(value) {
                    return updateTableCell({ value: value, row: key, column: 'nettRate' });
                  },
                  style: { width: withEditableCell ? '16%' : '19%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' },
                  editable: withEditableCell && !rate.notApplicable
                },
                rate.nettRate
              ),
              withEditableCell ? _react2.default.createElement(
                'div',
                { style: { width: '15%', display: 'inline-block !important' } },
                _react2.default.createElement(_materialUi.Checkbox, {
                  style: { top: '-2px', width: '50%', marginLeft: '50%' },
                  checked: !rate.notApplicable,
                  onCheck: function onCheck() {
                    return updateTableCell({ value: !rate.notApplicable, row: key, column: 'notApplicable' });
                  }
                })
              ) : undefined
            )
          );
        })
      )
    ),
    _react2.default.createElement(_materialUi.Divider, null)
  );
};

WithRetailRate.propTypes = {
  _id: _react.PropTypes.string,
  supplierEditable: _react.PropTypes.bool,
  rates: _react.PropTypes.array,
  rateSetName: _react.PropTypes.string,
  minStay: _react.PropTypes.any,
  maxStay: _react.PropTypes.any,
  withEditableCell: _react.PropTypes.bool,
  updateTableCell: _react.PropTypes.func,
  onEdit: _react.PropTypes.func,
  daysOfWeek: _react.PropTypes.array,
  deleteRates: _react.PropTypes.func,
  deleteFromProduct: _react.PropTypes.func
};

exports.default = WithRetailRate;

/***/ }),
/* 3295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _mouseOverEditDiv = __webpack_require__(217);

var _mouseOverEditDiv2 = _interopRequireDefault(_mouseOverEditDiv);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

var _clickEditCell = __webpack_require__(879);

var _clickEditCell2 = _interopRequireDefault(_clickEditCell);

var _ratesTableMiscellaneous = __webpack_require__(880);

var _ratesTableMiscellaneous2 = _interopRequireDefault(_ratesTableMiscellaneous);

var _checkRatesDescriptionHelper = __webpack_require__(1058);

var _checkRatesDescriptionHelper2 = _interopRequireDefault(_checkRatesDescriptionHelper);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var WithoutRetailRate = function WithoutRetailRate(props) {
  var rates = props.rates,
      onEdit = props.onEdit,
      deleteFromProduct = props.deleteFromProduct,
      supplierEditable = props.supplierEditable,
      withEditableCell = props.withEditableCell,
      updateTableCell = props.updateTableCell,
      forOffer = props.forOffer,
      rateSetName = props.rateSetName,
      rateSetCode = props.rateSetCode,
      _props$classes = props.classes,
      classes = _props$classes === undefined ? {} : _props$classes,
      forMiscellaneous = _objectWithoutProperties(props, ['rates', 'onEdit', 'deleteFromProduct', 'supplierEditable', 'withEditableCell', 'updateTableCell', 'forOffer', 'rateSetName', 'rateSetCode', 'classes']);

  var exists = _ramda2.default.allPass([function (val) {
    return _ramda2.default.complement(_ramda2.default.isNil)(val);
  }, function (val) {
    return _ramda2.default.complement(_ramda2.default.equals(0))(val);
  }, function (val) {
    return _ramda2.default.complement(_ramda2.default.equals('0'))(val);
  }, function (val) {
    return _ramda2.default.complement(_ramda2.default.equals(''))(val);
  }]);
  var rateWithMaxAdultsPlusChild = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.last, _ramda2.default.sort(function (a, b) {
    var rateA = _ramda2.default.propOr(0, 'maxAdultsPlusChild', a);
    var rateB = _ramda2.default.propOr(0, 'maxAdultsPlusChild', b);
    if (rateA > rateB) return 1;
    if (rateB > rateA) return -1;
    return 0;
  }), _ramda2.default.filter(function (rate) {
    return exists(_ramda2.default.prop('maxAdultsPlusChild', rate));
  })), rates);
  var maxAdultsPlusChild = _ramda2.default.propOr(0, 'maxAdultsPlusChild', rateWithMaxAdultsPlusChild || {});
  var hasNonStandardDesc = rates.some(function (rate) {
    return !rate.notApplicable && !(0, _checkRatesDescriptionHelper2.default)(rate.description);
  });
  var descriptionsAllowed = rates.every(function (rate) {
    return rate.description && rate.description.indexOf('uest') === -1;
  }) ? '"Single", "Double", "Twin", "Triple", "Quad".' : '"1 Guest", "2 Guests", "3 Guests", "4 Guests", "5 Guests", ...etc.';
  // this is for alternating table row colors
  var rateCount = 0;
  return _react2.default.createElement(
    'div',
    { className: classes['main'] },
    _react2.default.createElement(
      'div',
      { className: 'rates-table', style: { display: 'block' } },
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '39%' : '47%', textAlign: 'left', whiteSpace: 'pre-wrap', display: 'inline-block', fontSize: '14px' } },
        _react2.default.createElement(
          'span',
          { className: classes.rateSetName },
          (rateSetName || '').toUpperCase()
        ),
        _react2.default.createElement(
          'span',
          { className: classes.rateSetCode },
          rateSetCode ? ' (' + rateSetCode + ')' : ''
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '12%' : '14%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        forOffer ? '' : 'PRICE CODE'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '16%' : '19%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        '\nADULTS'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: withEditableCell ? '16%' : '19%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' } },
        'NETT RATE'
      ),
      withEditableCell ? _react2.default.createElement(
        'div',
        { style: { width: '16%', textAlign: 'right', paddingRight: '4px', whiteSpace: 'pre', display: 'inline-block' } },
        'APPLICABLE'
      ) : undefined
    ),
    _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '8px', display: 'block' } }),
    _react2.default.createElement(
      _mouseOverEditDiv2.default,
      {
        regularDiv: withEditableCell || forOffer,
        editable: supplierEditable,
        doubleLineTitle: true,
        actionButtons: _react2.default.createElement(_editButton2.default, {
          onEdit: onEdit,
          onDelete: deleteFromProduct,
          deleteButton: true
        })
      },
      _react2.default.createElement(_ratesTableMiscellaneous2.default, _extends({}, forMiscellaneous, { rateType: 'nett', classes: classes, maxAdultsPlusChild: maxAdultsPlusChild, rateSetName: rateSetName })),
      _react2.default.createElement(
        'div',
        { style: { display: withEditableCell && hasNonStandardDesc ? 'block' : 'none', marginTop: '8px', marginBottom: '8px', color: '#ff4081' } },
        _react2.default.createElement(
          'b',
          null,
          'NOTE: Some rate types in this rate table are no longer supported, as they cannot be automated into your partners\' booking systems.'
        ),
        _react2.default.createElement(
          'div',
          { style: { marginTop: '8px' } },
          'Allowed Descriptions:',
          _react2.default.createElement(
            'div',
            null,
            descriptionsAllowed
          )
        )
      ),
      _react2.default.createElement(
        'div',
        null,

        // 'rates' MUST NOT be filtered because of the classes
        rates.map(function (rate, key) {
          if (!withEditableCell && rate.notApplicable) return _react2.default.createElement('span', { key: key });
          var backgroundColor = rateCount % 2 !== 0 ? 'transparent' : 'rgba(0, 0, 0, 0.1)';
          rateCount++;
          return _react2.default.createElement(
            'div',
            { style: { backgroundColor: backgroundColor }, key: key, className: classes[key + '-rate'] || classes[key + '-notApplicable'] },
            _react2.default.createElement(
              'div',
              { className: 'rates-table-titles' },
              _react2.default.createElement(
                _clickEditCell2.default,
                {
                  className: classes[key + '-description'],
                  fullWidthInput: true,
                  stringAllowed: true,
                  defaultValue: '-',
                  onChange: function onChange(value) {
                    return updateTableCell({ value: value, row: key, column: 'description' });
                  },
                  editable: withEditableCell && !(0, _checkRatesDescriptionHelper2.default)(rate.description),
                  style: { color: _ramda2.default.call(_ramda2.default.cond([[function () {
                      return rate.notApplicable;
                    }, _ramda2.default.always('rgba(0, 0, 0, 0.34')], [function () {
                      return (0, _checkRatesDescriptionHelper2.default)(rate.description);
                    }, _ramda2.default.always('')], [_ramda2.default.T, _ramda2.default.always('#ff4081')]])), width: withEditableCell ? '23%' : '27%', textAlign: 'left', paddingLeft: '4px', whiteSpace: 'pre', display: 'inline-block' }
                },
                !(0, _checkRatesDescriptionHelper2.default)(rate.description) && !withEditableCell ? rate.description + '!' : rate.description
              ),
              _react2.default.createElement('div', { style: { width: withEditableCell ? '16%' : '20%', textAlign: 'center', display: 'inline-block' } }),
              _react2.default.createElement(
                _clickEditCell2.default,
                {
                  className: classes[key + '-priceCode'],
                  stringAllowed: true,
                  fullWidthInput: true,
                  inputAlignRight: true,
                  defaultValue: '-',
                  onChange: function onChange(value) {
                    return updateTableCell({ value: value, row: key, column: 'priceCode' });
                  },
                  style: { width: withEditableCell ? '12%' : '14%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' },
                  editable: withEditableCell && !forOffer && !rate.notApplicable
                },
                rate.priceCode
              ),
              _react2.default.createElement(
                _clickEditCell2.default,
                {
                  className: classes[key + '-maxAdults'],
                  inputAlignRight: true,
                  decimalNumber: 0,
                  defaultValue: '-',
                  onChange: function onChange(value) {
                    return updateTableCell({ value: value, row: key, column: 'maxAdults' });
                  },
                  style: { width: withEditableCell ? '16%' : '17%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' },
                  editable: withEditableCell && !rate.notApplicable
                },
                rate.maxAdults
              ),
              _react2.default.createElement(
                _clickEditCell2.default,
                {
                  className: classes[key + '-nettRate'],
                  inputAlignRight: true,
                  decimalNumber: 2,
                  defaultValue: '-',
                  onChange: function onChange(value) {
                    return updateTableCell({ value: value, row: key, column: 'nettRate' });
                  },
                  style: { width: withEditableCell ? '16%' : '21%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' },
                  editable: withEditableCell && !rate.notApplicable
                },
                rate.nettRate
              ),
              withEditableCell ? _react2.default.createElement(
                'div',
                { style: { width: '16%', display: 'inline-block !important' } },
                _react2.default.createElement(_materialUi.Checkbox, {
                  style: { top: '-2px', width: '50%', marginLeft: '50%' },
                  checked: !rate.notApplicable,
                  onCheck: function onCheck() {
                    return updateTableCell({ value: !rate.notApplicable, row: key, column: 'notApplicable' });
                  }
                })
              ) : undefined
            )
          );
        })
      )
    ),
    _react2.default.createElement(_materialUi.Divider, null)
  );
};

WithoutRetailRate.propTypes = {
  _id: _react.PropTypes.string,
  supplierEditable: _react.PropTypes.bool,
  rates: _react.PropTypes.array,
  rateSetName: _react.PropTypes.string,
  minStay: _react.PropTypes.any,
  maxStay: _react.PropTypes.any,
  withEditableCell: _react.PropTypes.bool,
  updateTableCell: _react.PropTypes.func,
  onEdit: _react.PropTypes.func,
  daysOfWeek: _react.PropTypes.array,
  deleteRates: _react.PropTypes.func,
  deleteFromProduct: _react.PropTypes.func
};

exports.default = WithoutRetailRate;

/***/ }),
/* 3296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dateRangePicker = __webpack_require__(1974);

var _dateRangePicker2 = _interopRequireDefault(_dateRangePicker);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _datePickerSet = __webpack_require__(1140);

var _datePickerSet2 = _interopRequireDefault(_datePickerSet);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _selectSeasonName = __webpack_require__(1554);

var _selectSeasonName2 = _interopRequireDefault(_selectSeasonName);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _contractingPresetNamesCodes = __webpack_require__(464);

var _syncSectionCheckbox = __webpack_require__(1004);

var _syncSectionCheckbox2 = _interopRequireDefault(_syncSectionCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _getDateFromUTC = function _getDateFromUTC(date) {
  if (!date) return date;
  var dateObject = new Date(date);
  return new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate());
};

var transformDateRanges = function transformDateRanges(dateRanges) {
  return dateRanges.map(function (dateRange) {
    return Object.keys(dateRange).reduce(function (result, key) {
      if (key.indexOf('tartDate') > 0) result.from = _getDateFromUTC(dateRange[key]);
      if (key.indexOf('ndDate') > 0) result.to = _getDateFromUTC(dateRange[key]);
      return result;
    }, {});
  });
};
var getTakenDateRanges = function getTakenDateRanges(seasonRates) {
  if (!seasonRates) return seasonRates;
  return seasonRates.reduce(function (result, season) {
    return result.concat(transformDateRanges(season.dateRanges));
  }, []);
};

var SeasonDates = function SeasonDates(_ref) {
  var updateSeasonWizardWithKeyPath = _ref.updateSeasonWizardWithKeyPath,
      seasonInfo = _ref.seasonInfo,
      addDateRanges = _ref.addDateRanges,
      cancelText = _ref.cancelText,
      cancelFunc = _ref.cancelFunc,
      saveProductInfoChanges = _ref.saveProductInfoChanges,
      existingSeasons = _ref.existingSeasons,
      selectExistingSeason = _ref.selectExistingSeason,
      contractingPeriod = _ref.contractingPeriod,
      backFunc = _ref.backFunc,
      updateFieldWithKeyPath = _ref.updateFieldWithKeyPath;

  var dateRanges = seasonInfo.dateRanges.map(function (dateRange) {
    return {
      from: _getDateFromUTC(dateRange.seasonStartDate),
      to: _getDateFromUTC(dateRange.seasonEndDate)
    };
  });
  var contractingPeriodString = _moment2.default.utc(contractingPeriod.startDate).format('D MMM YYYY') + ' - ' + _moment2.default.utc(contractingPeriod.endDate).format('D MMM YYYY');
  var takenDateRanges = getTakenDateRanges(existingSeasons);
  var systemSeasons = [].concat(_toConsumableArray(Object.keys(_contractingPresetNamesCodes.seasonNamesMap))).filter(function (name) {
    return name === 'Special Event' || name && existingSeasons.every(function (season) {
      return season.seasonName !== name;
    });
  }).map(function (name) {
    return { seasonName: name, dateRanges: name === contractingPeriodString || name === 'All Year' ? [{ seasonStartDate: contractingPeriod.startDate, seasonEndDate: contractingPeriod.endDate }] : [] };
  });
  return _react2.default.createElement(
    'div',
    { style: { padding: '24px 24px 0', overflow: 'auto' } },
    _react2.default.createElement(
      'div',
      { style: { minHeight: '200px' } },
      _react2.default.createElement(
        'label',
        { style: { display: 'block', fontSize: '13px', marginLeft: '4px' } },
        'Please enter or select the season these rates are valid for. '
      ),
      _react2.default.createElement(
        'div',
        { style: { marginBottom: '12px', width: '460px', fontSize: '13px', float: 'left', display: 'inline-block' } },
        _react2.default.createElement(
          'label',
          { style: { display: 'block', marginBottom: '8px', marginLeft: '4px', whiteSpace: 'nowrap' } },
          'If the rates are valid more than once during the year, you can select multiple date ranges.'
        ),
        _react2.default.createElement(_selectSeasonName2.default, {
          selectedSeasonName: seasonInfo.selectedSeasonName,
          contractingPeriod: contractingPeriod,
          existingSeasons: existingSeasons,
          onChange: function onChange(value) {
            var selected = systemSeasons.filter(function (season) {
              return season.seasonName === value;
            })[0];
            selectExistingSeason(selected);
          }
        })
      ),
      _react2.default.createElement(
        'small',
        { style: { color: 'red', display: 'inline-block', marginTop: '40px', marginLeft: '4px' } },
        ' * Required'
      ),
      seasonInfo.selectedSeasonName && seasonInfo.selectedSeasonName !== contractingPeriodString && seasonInfo.selectedSeasonName !== 'All Year' && (seasonInfo.selectedSeasonName === 'Special Event' || existingSeasons.every(function (season) {
        return season.seasonName !== seasonInfo.selectedSeasonName;
      })) ? _react2.default.createElement(
        'div',
        { style: { clear: 'both', display: 'flex', alignItems: 'flex-start' } },
        _react2.default.createElement(
          'div',
          { style: { width: '550px' } },
          _react2.default.createElement(_dateRangePicker2.default, {
            noShowSelected: true,
            numberOfMonths: 6,
            startDate: contractingPeriod.startDate,
            endDate: contractingPeriod.endDate,
            disabledRanges: takenDateRanges,
            selectedRanges: dateRanges,
            removeADateRange: function removeADateRange(i) {
              return addDateRanges({ ranges: _ramda2.default.remove(i, 1, seasonInfo.dateRanges.map(function (range) {
                  return { from: range.seasonStartDate, to: range.seasonEndDate };
                })) });
            },
            onConfirmClick: function onConfirmClick(range) {
              return addDateRanges({
                ranges: seasonInfo.dateRanges.length && range.to ? [].concat(_toConsumableArray(_ramda2.default.dropLast(1, seasonInfo.dateRanges).map(function (r) {
                  return { from: r.seasonStartDate, to: r.seasonEndDate };
                })), [range]) : _ramda2.default.append(range, seasonInfo.dateRanges.map(function (r) {
                  return { from: r.seasonStartDate, to: r.seasonEndDate };
                }))
              });
            }
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { width: 'calc(100% - 550px)' } },
          _react2.default.createElement(
            'small',
            { style: { color: 'red' } },
            ' * At least one date range is required'
          ),
          _react2.default.createElement('br', null),
          (seasonInfo.dateRanges.length ? seasonInfo.dateRanges : [{}]).map(function (range, index) {
            var currentFromDate = (0, _ramda.prop)('seasonStartDate', range);
            var currentToDate = (0, _ramda.prop)('seasonEndDate', range);
            var initialStartDateMonth = function () {
              if (currentFromDate) return currentFromDate;
              if (currentToDate) return currentToDate;
              if (seasonInfo.dateRanges.length > 1 && index) return seasonInfo.dateRanges[index - 1].seasonEndDate || seasonInfo.dateRanges[index - 1].seasonStartDate;
              return contractingPeriod.startDate;
            }();
            var initialEndDateMonth = function () {
              if (currentToDate) return currentToDate;
              if (currentFromDate) return currentFromDate;
              if (seasonInfo.dateRanges.length > 1 && index) return seasonInfo.dateRanges[index - 1].seasonEndDate || seasonInfo.dateRanges[index - 1].seasonStartDate;
              return contractingPeriod.startDate;
            }();
            var newTakenRanges = (0, _ramda.call)((0, _ramda.compose)((0, _ramda.concat)(takenDateRanges), transformDateRanges, (0, _ramda.addIndex)(_ramda.reject)(function (_, filterIndex) {
              return (0, _ramda.equals)(filterIndex, index);
            }), (0, _ramda.propOr)([], 'dateRanges')), seasonInfo);
            return _react2.default.createElement(_datePickerSet2.default, {
              key: index,
              showTextField: seasonInfo.selectedSeasonName.toLowerCase() === 'special event',
              endDateCloseOnSelect: true,
              startDateCloseOnSelect: true,
              disableDeleteButton: seasonInfo.dateRanges.length < 2,
              textFieldStyle: { display: 'inline-block', width: '100px', fontSize: '12px' },
              startDateContainerStyle: { display: 'inline-block', marginLeft: '8px', width: 'calc(50% - 80px)' },
              startDateTextFieldStyle: { width: '100%', fontSize: '12px' },
              endDateContainerStyle: { display: 'inline-block', width: 'calc(50% - 80px)' },
              endDateTextFieldStyle: { width: '100%', fontSize: '12px' },
              addButtonStyle: { marginLeft: '8px', lineHeight: '24px', verticalAlign: 'middle' },
              deleteButtonStyle: { lineHeight: '24px', verticalAlign: 'middle' },
              textFieldFloatingText: 'Event Name',
              startDateFloatingText: 'Start Date',
              endDateFloatingText: 'End Date',
              disabledRanges: newTakenRanges,
              initialStartDateMonth: initialStartDateMonth,
              startDateEnableFrom: contractingPeriod.startDate,
              startDateEnableTo: contractingPeriod.endDate,
              initialEndDateMonth: initialEndDateMonth,
              endDateEnableFrom: range.seasonStartDate || contractingPeriod.startDate,
              endDateEnableTo: contractingPeriod.endDate,
              textFieldValue: range.eventName,
              startDate: range.seasonStartDate,
              endDate: range.seasonEndDate,
              textFieldOnChange: function textFieldOnChange(e) {
                return updateSeasonWizardWithKeyPath({ keyPath: ['dateRanges', index, 'eventName'], value: e.target.value });
              },
              onChangeStartDate: function onChangeStartDate(value) {
                return updateSeasonWizardWithKeyPath({ keyPath: ['dateRanges', index, 'seasonStartDate'], value: value });
              },
              onChangeEndDate: function onChangeEndDate(value) {
                return updateSeasonWizardWithKeyPath({ keyPath: ['dateRanges', index, 'seasonEndDate'], value: value });
              },
              onDelete: function onDelete() {
                return updateSeasonWizardWithKeyPath({ keyPath: ['dateRanges'], value: (0, _ramda.remove)(index, 1, seasonInfo.dateRanges) });
              },
              onAdd: function onAdd() {
                return updateSeasonWizardWithKeyPath({ keyPath: ['dateRanges'], value: !seasonInfo.dateRanges.length ? [{}, {}] : (0, _ramda.insert)(index + 1, {}, seasonInfo.dateRanges) });
              }
            });
          })
        )
      ) : undefined,
      seasonInfo.selectedSeasonName && seasonInfo.selectedSeasonName === contractingPeriodString || seasonInfo.selectedSeasonName === 'All Year' ? _react2.default.createElement(
        'div',
        null,
        seasonInfo.dateRanges.map(function (range, index) {
          return _react2.default.createElement(
            'div',
            { key: index, style: { clear: 'both', textAlign: 'left', whiteSpace: 'pre' } },
            '' + (range.eventName ? range.eventName.toUpperCase() + '     ' : '') + _moment2.default.utc(range.seasonStartDate).format('D MMM YYYY') + ' - ' + _moment2.default.utc(range.seasonEndDate).format('D MMM YYYY')
          );
        })
      ) : undefined
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', justifyContent: 'space-between', marginTop: '16px', alignItems: 'center' } },
      _react2.default.createElement(_flatButtonWithLoader2.default, {
        label: 'back',
        secondary: true,
        onTouchTap: backFunc
      }),
      _react2.default.createElement(
        'div',
        { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
        _react2.default.createElement(_syncSectionCheckbox2.default, {
          label: 'Sync Seasons to Other Products',
          style: { width: '300px' },
          sectionInEdit: 'seasons'
        }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_flatButtonWithLoader2.default, {
            label: cancelText,
            labelStyle: { fontWeight: '600', marginRight: '15px' },
            primary: true,
            onTouchTap: cancelFunc
          }),
          _react2.default.createElement(_flatButtonWithLoader2.default, {
            onTouchTap: function onTouchTap() {
              var seasonInfoWithEmptySetRemoved = (0, _ramda.mapObjIndexed)((0, _ramda.ifElse)((0, _ramda.compose)((0, _ramda.equals)('dateRanges'), (0, _ramda.nthArg)(1)), (0, _ramda.filter)((0, _ramda.has)('seasonStartDate')), _ramda.identity), seasonInfo);
              return saveProductInfoChanges(seasonInfoWithEmptySetRemoved);
            },
            secondary: true,
            disabled: !seasonInfo.seasonName || !seasonInfo.dateRanges.length || seasonInfo.selectedSeasonName === 'Special Event' && !seasonInfo.dateRanges.filter(function (range) {
              return range.seasonStartDate;
            }).length,
            label: 'Add Season and Rates',
            loader: seasonInfo.saving,
            labelStyle: { fontWeight: '600' }
          })
        )
      )
    )
  );
};

SeasonDates.propTypes = {
  updateFieldValue: _react.PropTypes.func,
  seasonInfo: _react.PropTypes.object,
  addDateRanges: _react.PropTypes.func,
  cancelText: _react.PropTypes.string,
  cancelFunc: _react.PropTypes.func,
  onContinue: _react.PropTypes.func,
  takenDateRanges: _react.PropTypes.array,
  existingSeasons: _react.PropTypes.array,
  selectExistingSeason: _react.PropTypes.func,
  backFunc: _react.PropTypes.func
};

exports.default = SeasonDates;

/***/ }),
/* 3297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _beddingConfig = __webpack_require__(1528);

var _beddingConfig2 = _interopRequireDefault(_beddingConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BedsAndSofasForm = function BedsAndSofasForm(_ref) {
  var product = _ref.product,
      updateProduct = _ref.updateProduct;

  if (product.checked && !product.bedsAndSofasComplete) {
    return _react2.default.createElement(
      'div',
      { style: { border: '1px solid #e0e0e0', marginBottom: '8px' } },
      _react2.default.createElement(
        'div',
        { style: { padding: '16px 16px 0' } },
        _react2.default.createElement(
          'small',
          null,
          'Bedding Configuration is important for your partner to load your rates into their booking system.'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'small',
          null,
          'You only need to enter this information once, and you can always update it later via the ',
          _react2.default.createElement(
            'b',
            null,
            'Tools'
          ),
          '.'
        )
      ),
      _react2.default.createElement(_beddingConfig2.default, {
        beddingConfig: product.bedsAndSofas,
        sendEditToReducer: function sendEditToReducer(_ref2) {
          var value = _ref2.value;

          var newProduct = _extends({}, product, { bedsAndSofas: value });
          updateProduct(newProduct);
        }
      })
    );
  }
  return _react2.default.createElement('div', null);
};

var AddProductsDialog = function AddProductsDialog(_ref3) {
  var onRequestClose = _ref3.onRequestClose,
      contractId = _ref3.contractId,
      locationId = _ref3.locationId,
      data = _ref3.data,
      onTextFieldChangeWithKeyPath = _ref3.onTextFieldChangeWithKeyPath,
      saveProductsToContract = _ref3.saveProductsToContract,
      saving = _ref3.saving,
      openGlobalAlert = _ref3.openGlobalAlert;

  var checkedProducts = data.products.filter(function (product) {
    return product.checked;
  });
  // excluding new product
  var addedOrCheckedProductNames = data.products.filter(function (p) {
    return (p.added || p.checked) && p.productId;
  }).map(function (p) {
    return p.productName;
  });
  var notAddedAndExistingProducts = data.products.filter(function (product) {
    return !product.added && product.productId;
  });
  var isCreatingAProduct = data.isFirstProduct || _ramda2.default.isEmpty(notAddedAndExistingProducts);
  var newProductName = (data.products.find(function (p) {
    return !p.productId;
  }) || {}).productName;
  var duplicateProductName = Boolean(newProductName && addedOrCheckedProductNames.indexOf(newProductName) > -1);
  var updateProductWithIndex = function updateProductWithIndex(index) {
    return function (newProd) {
      return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'products', index], value: newProd });
    };
  };
  var onClickAdd = function onClickAdd() {
    if (checkedProducts.length + addedOrCheckedProductNames.length > 35) {
      openGlobalAlert({
        text: 'We strongly suggest do not add more than 35 room types/products to a rate sheet. Please feel free to contact us through our live chat or email us at support@tourconnect.com, we are happy to help with your rate sheet.\n        \n\nAre you sure you still want to add ' + (checkedProducts.length > 1 ? 'these' : 'this') + ' ' + (checkedProducts.length > 1 ? 'room types/products' : 'room type/product') + '?',
        onOk: function onOk() {
          return saveProductsToContract(contractId, locationId, checkedProducts);
        }
      });
    } else {
      saveProductsToContract(contractId, locationId, checkedProducts);
    }
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { backgroundColor: '#00BCD4', color: 'white', fontSize: '18px', padding: '2%' } },
      _ramda2.default.call(_ramda2.default.cond([[function () {
        return data.isFirstProduct;
      }, _ramda2.default.always('Add Your First Room Type/Product')], [function () {
        return _ramda2.default.isEmpty(notAddedAndExistingProducts);
      }, _ramda2.default.always('Add Another Room Type/Product')], [_ramda2.default.T, _ramda2.default.always('Select Room Type(s)/Product(s)')]]))
    ),
    _react2.default.createElement(
      'div',
      { style: { padding: '16px', paddingBottom: '8px', overflow: 'auto' } },
      _react2.default.createElement(
        'div',
        { style: { marginBottom: '12px', marginTop: '12px', fontSize: '16px' } },
        _react2.default.createElement(
          'b',
          null,
          _ramda2.default.call(_ramda2.default.cond([[function () {
            return isCreatingAProduct;
          }, _ramda2.default.always('')], [_ramda2.default.T, _ramda2.default.always('Please select the room types/products you would like to add rates for: ')]]))
        )
      ),
      data.products.map(function (product, index) {
        if (product.added) return undefined;
        if (product.productId) {
          if (addedOrCheckedProductNames.indexOf(product.productName) > -1 && !product.checked) return undefined;
          return _react2.default.createElement(
            'div',
            { key: index },
            _react2.default.createElement(_materialUi.Checkbox, {
              label: _react2.default.createElement(
                'span',
                null,
                product.productName,
                ' ',
                _react2.default.createElement(
                  'small',
                  { style: { color: '#e57373' } },
                  product.bedsAndSofasComplete ? '' : 'missing bedding configuration'
                )
              ),
              checked: Boolean(product.checked),
              onCheck: function onCheck(_, checked) {
                return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'products', index, 'checked'], value: checked });
              }
            }),
            _react2.default.createElement(BedsAndSofasForm, {
              product: product,
              updateProduct: updateProductWithIndex(index)
            })
          );
        }
        if (!data.showCreateProdTF && !isCreatingAProduct) {
          return _react2.default.createElement(
            'div',
            {
              key: index,
              className: 'add-item-card-flex',
              style: { marginLeft: '2px' },
              onClick: function onClick() {
                return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'showCreateProdTF'], value: !data.showCreateProdTF });
              }
            },
            _react2.default.createElement(
              'div',
              { style: { border: '1px dashed #00bcd4', height: '20px', width: '20px', display: 'inline-block' } },
              _react2.default.createElement(_materialUi.FontIcon, { style: { verticalAlign: 'middle', color: '#00bcd4', fontSize: '18px', marginTop: '-5px' }, className: 'tc-icon-add' })
            ),
            _react2.default.createElement(
              'span',
              { style: { margin: '7px 0px 0px 20px', color: '#00bcd4', display: 'inline-block', verticalAlign: 'middle' } },
              'Create a new product type'
            )
          );
        }
        return _react2.default.createElement(
          'div',
          { key: index },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center' } },
            !isCreatingAProduct && _react2.default.createElement(_materialUi.Checkbox, {
              checked: product.checked,
              style: { width: '44px' },
              onCheck: function onCheck(_, checked) {
                return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'products', index, 'checked'], value: checked });
              }
            }),
            _react2.default.createElement(_materialUi.TextField, {
              id: 'NewProd' + index,
              value: product.productName,
              style: { width: '280px' },
              hintText: 'Enter a new name here...',
              errorText: duplicateProductName ? 'Duplicate with another room type/product' : '',
              onChange: function onChange(_, value) {
                var newProduct = { productName: value, checked: Boolean(value) };
                onTextFieldChangeWithKeyPath({ keyPath: ['data', 'products', index], value: newProduct });
              }
            })
          ),
          product.checked && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'label',
              null,
              'What type of product is this?'
            ),
            ' ',
            _react2.default.createElement(
              'span',
              { style: { color: 'red' } },
              '*'
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              _materialUi.RadioButtonGroup,
              {
                name: 'productType',
                valueSelected: product.productType,
                onChange: function onChange(e, val) {
                  return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'products', index], value: _extends({}, product, {
                      productType: val,
                      bedsAndSofasComplete: val !== 'Accommodation'
                    }) });
                }
              },
              _react2.default.createElement(_materialUi.RadioButton, { 'data-cy': 'nonAccom', label: 'Non-Accommodation (tours, attractions, etc.)', value: 'Non-Accommodation' }),
              _react2.default.createElement(_materialUi.RadioButton, { label: 'Accommodation (hotels, apartments, B&Bs, etc.)', value: 'Accommodation' })
            )
          ),
          Boolean(product.checked && product.productType) && _react2.default.createElement(BedsAndSofasForm, {
            product: product,
            updateProduct: updateProductWithIndex(index)
          })
        );
      }),
      _react2.default.createElement(_stepperActions2.default, {
        rightButtons: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_flatButtonWithLoader2.default, { labelStyle: { fontWeight: '600' }, label: 'Cancel', primary: true, onClick: onRequestClose }),
          _react2.default.createElement(_flatButtonWithLoader2.default, {
            label: 'Add Room Type(s)/Product(s)',
            onClick: onClickAdd,
            disabled: !(checkedProducts.length && checkedProducts.every(function (prod) {
              if (!prod.productName) return false;
              if (!prod.productType) return false;
              if (prod.productType !== 'Accommodation') return true;
              var rooms = _ramda2.default.pathOr([], ['bedsAndSofas', 'rooms'], prod);
              return prod.bedsAndSofasComplete || rooms && rooms.length && rooms.every(function (room) {
                return room.every(function (config) {
                  return config.every(function (bedding) {
                    return bedding.count && bedding.bedType;
                  });
                });
              });
            })) || duplicateProductName,
            secondary: true,
            loader: saving,
            labelStyle: { fontWeight: '600' }
          })
        )
      })
    )
  );
};

AddProductsDialog.propTypes = {
  onRequestClose: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  data: _react.PropTypes.object,
  productType: _react.PropTypes.string
};
AddProductsDialog.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = AddProductsDialog;

/***/ }),
/* 3298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManageRatePackage = function ManageRatePackage(_ref, _ref2) {
  var onRequestClose = _ref.onRequestClose,
      contractId = _ref.contractId,
      data = _ref.data,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      manageRatePackage = _ref.manageRatePackage,
      productId = _ref.productId,
      ratePackageIndex = _ref.ratePackageIndex,
      saving = _ref.saving,
      productType = _ref.productType;
  var router = _ref2.router;

  var enteredNewPackageName = Boolean(data.newRatePackageName && data.newRatePackageName.trim());
  var allPackageNames = _ramda2.default.call(_ramda2.default.compose(function (existingNames) {
    if (enteredNewPackageName) return _ramda2.default.append(data.newRatePackageName.trim(), existingNames);
    return existingNames;
  }, _ramda2.default.map(function (prod) {
    return (prod.ratePackageName || '').trim();
  })), data.existingPackagesForProduct);
  var duplicateRatePackage = allPackageNames.length > _ramda2.default.uniq(allPackageNames).length;
  var containInvalidSymbols = allPackageNames.some(function (name) {
    return _ramda2.default.contains('/', name);
  });
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { padding: '32px 32px 0 32px', fontSize: '13px' } },
      productType === 'Accommodation' ? 'Rate packages allow you to offer different types of rates for one room type. For example, you can have Room Only, Bed & Breakfast, and Full Room & Board rates for the same room type.' : 'Rate packages allow you to offer different types of rates for one product. For example, you can have an English rate package and a French rate package for the same product.'
    ),
    _react2.default.createElement(
      'div',
      { style: { padding: '32px' } },
      'You can modify the existing rate ',
      (0, _pluralize2.default)('package', data.existingPackagesForProduct.length),
      ':',
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      data.existingPackagesForProduct.map(function (prod, i) {
        return _react2.default.createElement(
          'div',
          { key: i },
          _react2.default.createElement(
            'div',
            { style: { fontWeight: 'bold' } },
            'Rate Package ',
            i + 1
          ),
          _react2.default.createElement(_materialUi.TextField, {
            style: { display: 'inline-block' },
            id: 'existingPackageForProduct' + i,
            errorText: !prod.ratePackageName ? 'Can\'t be empty' : '',
            hintText: 'Type here...',
            value: prod.ratePackageName || '',
            onChange: function onChange(_, val) {
              if (!data.editedExisting) onTextFieldChangeWithKeyPath({ keyPath: ['data', 'editedExisting'], value: true });
              onTextFieldChangeWithKeyPath({ keyPath: ['data', 'existingPackagesForProduct', i, 'ratePackageName'], value: val });
            }
          })
        );
      }),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      'Please enter the name for the new package below:',
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'div',
        { style: { fontWeight: 'bold' } },
        'Rate Package ',
        data.existingPackagesForProduct.length + 1
      ),
      _react2.default.createElement(_materialUi.TextField, {
        id: 'newRatePackage',
        hintText: 'Type here...',
        value: data.newRatePackageName || '',
        onChange: function onChange(_, val) {
          return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'newRatePackageName'], value: val });
        }
      }),
      data.title.indexOf('Create Rate Package') > -1 ? _react2.default.createElement(
        'small',
        { style: { color: 'red' } },
        ' * Required'
      ) : _react2.default.createElement('small', null),
      enteredNewPackageName && duplicateRatePackage ? _react2.default.createElement(
        'div',
        { style: { color: 'red' } },
        'Please do not create duplicate rate package.'
      ) : _react2.default.createElement('div', null),
      containInvalidSymbols ? _react2.default.createElement(
        'div',
        { style: { color: 'red' } },
        'Name cannot have "/".'
      ) : _react2.default.createElement('div', null)
    ),
    _react2.default.createElement(_stepperActions2.default, {
      rightButtons: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_flatButtonWithLoader2.default, { labelStyle: { fontWeight: '600' }, label: 'Cancel', primary: true, onTouchTap: onRequestClose }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Save Changes',
          onTouchTap: function onTouchTap() {
            manageRatePackage(contractId, data.productId, data).then(function (res) {
              if (data.newRatePackageName) {
                router.replace('/contracting/draft/' + contractId + '/product/' + data.productId + '/' + (res.payload.newRatePackage ? res.payload.newRatePackage._id : encodeURIComponent(data.newRatePackageName)));
              } else if (ratePackageIndex === data.ratePackageIndex) {
                var thisPackageId = data.existingPackagesForProduct.find(function (prod) {
                  return prod.ratePackageIndex === ratePackageIndex;
                })._id;
                router.replace('/contracting/draft/' + contractId + '/product/' + productId + '/' + thisPackageId);
              }
            });
          },
          disabled: function () {
            if (containInvalidSymbols) return true;
            if (enteredNewPackageName && duplicateRatePackage) return true;
            if (data.existingPackagesForProduct.some(function (prod) {
              return !prod.ratePackageName;
            })) return true;
            if (data.title.indexOf('Create Rate Package') > -1) {
              if (!enteredNewPackageName) return true;
              return saving;
            }
            if (!(data.editedExisting || enteredNewPackageName)) return true;
            return saving;
          }(),
          secondary: true,
          labelStyle: { fontWeight: '600' }
        })
      )
    })
  );
};

ManageRatePackage.propTypes = {
  onRequestClose: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  data: _react.PropTypes.object,
  productType: _react.PropTypes.string
};
ManageRatePackage.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = ManageRatePackage;

/***/ }),
/* 3299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BankInfo = function BankInfo(props) {
  var bankTextFields = [{
    hint: 'Financial institution',
    shortName: 'financialInstitution',
    error: props.financialInstitutionError,
    onChange: function onChange(_ref) {
      var value = _ref.target.value;
      return props.onChange({ key: 'financialInstitution', value: value.trim() });
    }
  }, {
    hint: 'Branch',
    shortName: 'branch',
    error: props.branchError,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return props.onChange({ key: 'branch', value: value.trim() });
    }
  }, {
    hint: 'Account name',
    shortName: 'accountName',
    error: props.accountNameError,
    onChange: function onChange(_ref3) {
      var value = _ref3.target.value;
      return props.onChange({ key: 'accountName', value: value.trim() });
    }
  }, {
    hint: 'Account number',
    shortName: 'accountNumber',
    error: props.accountNumberError,
    onChange: function onChange(_ref4) {
      var value = _ref4.target.value;
      return props.onChange({ key: 'accountNumber', value: value.trim() });
    }
  }, {
    hint: 'BSB / Routing number',
    shortName: 'bsbRoutingNumber',
    error: props.bsbRoutingNumberError,
    onChange: function onChange(_ref5) {
      var value = _ref5.target.value;
      return props.onChange({ key: 'bsbRoutingNumber', value: value.trim() });
    }
  }, {
    hint: 'Iban / Swift code',
    shortName: 'ibanSwiftCode',
    error: props.ibanSwiftCodeError,
    onChange: function onChange(_ref6) {
      var value = _ref6.target.value;
      return props.onChange({ key: 'ibanSwiftCode', value: value.trim() });
    }
  }];

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'p',
      { style: { fontWeight: '600', color: '#757575', marginBottom: '0px' } },
      'Bank Information'
    ),
    bankTextFields.map(function (bankTextField, index) {
      return _react2.default.createElement(_twoColumnRow2.default, {
        key: index,
        outerContainerStyle: { display: 'flex', alignItems: 'baseline', marginBottom: '4px' },
        leftColumnContent: bankTextField.hint,
        leftColumnStyle: { width: '35%', color: 'rbga(0, 0, 0, 0.77)' },
        rightColumnContent: _react2.default.createElement(_materialUi.TextField, {
          inputStyle: { fontSize: '14px' },
          hintStyle: { fontSize: '14px' },
          hintText: bankTextField.hint,
          errorText: bankTextField.error,
          onChange: bankTextField.onChange,
          defaultValue: props[bankTextField.shortName]
        })
      });
    })
  );
};

BankInfo.propTypes = {
  title: _react.PropTypes.string,
  currency: _react.PropTypes.string,
  value: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  financialInstitutionError: _react.PropTypes.string,
  branchError: _react.PropTypes.string,
  accountNameError: _react.PropTypes.string,
  accountNumberError: _react.PropTypes.string,
  bsbRoutingNumberError: _react.PropTypes.string,
  ibanSwiftCodeError: _react.PropTypes.string,
  currencyError: _react.PropTypes.string
};

exports.default = BankInfo;

/***/ }),
/* 3300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _selectFields = __webpack_require__(141);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _dropzone = __webpack_require__(869);

var _dropzone2 = _interopRequireDefault(_dropzone);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InsuranceInfo = function InsuranceInfo(props) {
  var title = props.title,
      insExpMonthError = props.insExpMonthError,
      insuranceExpirationMonth = props.insuranceExpirationMonth,
      insExpYearError = props.insExpYearError,
      insuranceExpirationYear = props.insuranceExpirationYear,
      _onChange = props.onChange,
      attachedFiles = props.attachedFiles,
      removeFile = props.removeFile,
      attachFile = props.attachFile;


  var textFieldInfo = [{
    name: 'month',
    placeholder: 'Month',
    options: _selectFields.months,
    error: insExpMonthError,
    value: insuranceExpirationMonth,
    onChange: function onChange(_ref) {
      var value = _ref.value;
      return _onChange({ key: 'insuranceExpirationMonth', value: value });
    }
  }, {
    name: 'year',
    placeholder: 'Year',
    options: _selectFields.years,
    error: insExpYearError,
    value: insuranceExpirationYear,
    onChange: function onChange(_ref2) {
      var value = _ref2.value;
      return _onChange({ key: 'insuranceExpirationYear', value: value });
    }
  }];
  var textFieldStyling = { width: '36%', display: 'inline-block' };

  return _react2.default.createElement(
    'div',
    { style: { marginTop: '2%' } },
    _react2.default.createElement(
      'p',
      { style: { fontWeight: '600', color: '#757575' } },
      'Insurance expiration'
    ),
    textFieldInfo.map(function (textField, index) {
      return _react2.default.createElement(
        'div',
        { key: index, style: textFieldStyling },
        _react2.default.createElement(_reactSelect2.default, {
          name: textField.name,
          options: textField.options,
          menuStyle: { height: '80px' },
          value: textField.value,
          onChange: textField.onChange,
          placeholder: textField.placeholder,
          clearable: false,
          scrollMenuIntoView: false
        })
      );
    }),
    _react2.default.createElement(
      'div',
      { style: { clear: 'both', marginTop: '8px' } },
      attachedFiles && attachedFiles.length && (attachedFiles[0].fileName || attachedFiles[0].name) ? _react2.default.createElement(
        'div',
        { style: { color: '#bfbfbf', fontSize: '12px' } },
        _react2.default.createElement(
          'label',
          { style: { fontSize: '14px' } },
          'Insurance document: '
        ),
        attachedFiles.map(function (file, index) {
          return _react2.default.createElement(
            'div',
            {
              key: index,
              style: {
                backgroundColor: 'rgba(0, 126, 255, 0.08)',
                borderRadius: '2px',
                border: '1px solid rgba(0, 126, 255, 0.24)',
                color: '#007eff',
                display: 'inline-block',
                fontSize: '0.9em',
                lineHeight: '1.4',
                marginLeft: '5px',
                verticalAlign: 'top'
              }
            },
            _react2.default.createElement(
              'span',
              {
                onClick: function onClick() {
                  return removeFile(file);
                },
                style: {
                  cursor: 'pointer',
                  borderBottomLeftRadius: '2px',
                  borderTopLeftRadius: '2px',
                  borderRight: '1px solid rgba(0, 126, 255, 0.24)',
                  padding: '1px 5px 3px',
                  display: 'inline-block',
                  verticalAlign: 'middle'
                }
              },
              'x'
            ),
            _react2.default.createElement(
              'span',
              {
                style: {
                  color: '#007eff',
                  textDecoration: 'none',
                  borderBottomRightRadius: '2px',
                  borderTopRightRadius: '2px',
                  cursor: 'default',
                  padding: '2px 5px',
                  display: 'inline-block',
                  verticalAlign: 'middle'
                }
              },
              file.name || file.fileName
            )
          );
        })
      ) : _react2.default.createElement(
        _dropzone2.default,
        {
          style: { border: '1px dotted #bfbfbf', padding: '12px 8px', color: '#bfbfbf', fontSize: '12px', minHeight: '50px', width: '95%' },
          onDrop: attachFile
        },
        _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-attach_file', color: '#bfbfbf', style: { fontSize: '14px', top: '2px', marginRight: '5px' } }),
        'Attach insurance documents by dragging & dropping or ',
        _react2.default.createElement(
          'span',
          { style: { color: '#00b3cf', cursor: 'pointer' } },
          'selecting them. ',
          _react2.default.createElement(
            'div',
            { style: { color: 'red' } },
            'This is required.'
          )
        )
      )
    )
  );
};

InsuranceInfo.propTypes = {
  insuranceExpirationMonth: _react.PropTypes.any,
  insuranceExpirationYear: _react.PropTypes.any,
  title: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  insExpMonthError: _react.PropTypes.string,
  insExpYearError: _react.PropTypes.string,
  attachFile: _react.PropTypes.func,
  attachedFiles: _react.PropTypes.array,
  removeFile: _react.PropTypes.func,
  insuranceFiles: _react.PropTypes.array
};

exports.default = InsuranceInfo;

/***/ }),
/* 3301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _singleAllocationNode = __webpack_require__(1964);

var _singleAllocationNode2 = _interopRequireDefault(_singleAllocationNode);

var _seasonalSections = __webpack_require__(1555);

var _seasonalSections2 = _interopRequireDefault(_seasonalSections);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _ramda = __webpack_require__(2);

var _syncSectionCheckbox = __webpack_require__(1004);

var _syncSectionCheckbox2 = _interopRequireDefault(_syncSectionCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductCodeAllocation = function ProductCodeAllocation(_ref) {
  var contractingPeriod = _ref.contractingPeriod,
      onRequestClose = _ref.onRequestClose,
      _onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      _addOneElementWithKeyPath = _ref.addOneElementWithKeyPath,
      _deleteOneElementWithKeyPath = _ref.deleteOneElementWithKeyPath,
      existingSeasons = _ref.existingSeasons,
      contractId = _ref.contractId,
      productId = _ref.productId,
      saveProductInfoChanges = _ref.saveProductInfoChanges,
      data = _ref.data,
      saving = _ref.saving,
      syncedSections = _ref.syncedSections;

  var contentsData = (0, _ramda.propOr)([], 'allocation', data);
  var allDateRanges = _dateUtils2.default.getFlattenedUnEmptyDates(contentsData);
  var seasonCovered = _dateUtils2.default.seasonCovered(allDateRanges, contractingPeriod);
  var emptyInitialContent = { allotments: [{}] };
  var onFieldChange = (0, _ramda.curry)(function (extraPaths, value) {
    return _onTextFieldChangeWithKeyPath({ keyPath: (0, _ramda.concat)(['data', 'allocation'], extraPaths), value: value });
  });
  var onVaryBySeasonChange = function onVaryBySeasonChange(value) {
    return _onTextFieldChangeWithKeyPath({ keyPath: ['data', 'varyBySeason'], value: value });
  };
  var singleAllocationActions = {
    onTextFieldChangeWithKeyPath: function onTextFieldChangeWithKeyPath(_ref2) {
      var keyPath = _ref2.keyPath,
          value = _ref2.value;
      return _onTextFieldChangeWithKeyPath({ keyPath: (0, _ramda.concat)(['data', 'allocation'], keyPath), value: value });
    },
    addOneElementWithKeyPath: function addOneElementWithKeyPath(_ref3) {
      var keyPath = _ref3.keyPath,
          element = _ref3.element;
      return _addOneElementWithKeyPath({ keyPath: (0, _ramda.concat)(['data', 'allocation'], keyPath), element: element });
    },
    deleteOneElementWithKeyPath: function deleteOneElementWithKeyPath(_ref4) {
      var keyPath = _ref4.keyPath;
      return _deleteOneElementWithKeyPath({ keyPath: (0, _ramda.concat)(['data', 'allocation'], keyPath) });
    }
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_seasonalSections2.default, {
      name: 'allocations',
      seasons: existingSeasons,
      contractingPeriod: contractingPeriod,
      varyBySeason: data.varyBySeason,
      useSeasons: data.varyBySeason,
      contentsData: contentsData,
      emptyInitialContent: emptyInitialContent,
      onFieldChange: onFieldChange,
      contentActions: singleAllocationActions,
      ContentNode: _singleAllocationNode2.default,
      onVaryBySeasonChange: onVaryBySeasonChange
    }),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'div',
      { className: 'flex-tc-sb', style: { paddingLeft: '20px' } },
      Boolean(!data.varyBySeason || syncedSections.indexOf('seasons') > -1) ? _react2.default.createElement(_syncSectionCheckbox2.default, {
        label: 'Sync Allocation to Other Products',
        style: { width: '350px' },
        sectionInEdit: 'allocation'
      }) : _react2.default.createElement(
        'div',
        null,
        'Syncing is disabled because seasons aren\'t synced.'
      ),
      _react2.default.createElement(
        'div',
        { className: 'flex-center' },
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Cancel',
          hoverColor: 'none',
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onTouchTap: onRequestClose
        }),
        ' \xA0\xA0',
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Save',
          loader: saving,
          hoverColor: 'none',
          disabled: (0, _ramda.any)(function (content) {
            if (!content.allocationType) return true;
            if (content.allocationType === 'allotment') return content.allotments.some(function (allotment) {
              return !(allotment.releaseBackDays && allotment.numberOfRooms);
            });
            return false;
          }, contentsData) || !seasonCovered,
          labelStyle: { fontWeight: '600' },
          onTouchTap: function onTouchTap() {
            return saveProductInfoChanges({ contractId: contractId, productId: productId, data: data, updateType: 'SAVE_PRODUCT_CODE_ALLOCATION' });
          },
          secondary: true
        })
      )
    )
  );
};

ProductCodeAllocation.propTypes = {
  onRequestClose: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  productId: _react.PropTypes.string,
  data: _react.PropTypes.object,
  saveProductInfoChanges: _react.PropTypes.func,
  onTextFieldChange: _react.PropTypes.func,
  saving: _react.PropTypes.bool,
  syncedSections: _react.PropTypes.array
};

var mapStateToProps = function mapStateToProps(_ref5) {
  var contracting = _ref5.contracting;
  return {
    syncedSections: contracting.contractActivitiesProducts.getIn(['leftNav', 'syncedSections']) ? contracting.contractActivitiesProducts.getIn(['leftNav', 'syncedSections']).toJS() : []
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ProductCodeAllocation);

/***/ }),
/* 3302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _dateRanges = __webpack_require__(3303);

var _dateRanges2 = _interopRequireDefault(_dateRanges);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SingleSection = function SingleSection(_ref) {
  var index = _ref.index,
      ContentNode = _ref.ContentNode,
      contractingPeriod = _ref.contractingPeriod,
      takenDateRanges = _ref.takenDateRanges,
      removeOneSeasonSet = _ref.removeOneSeasonSet,
      contentActions = _ref.contentActions,
      dateRangeActions = _ref.dateRangeActions,
      seasons = _ref.seasons,
      datesEditable = _ref.datesEditable,
      correctSeasonName = _ref.correctSeasonName,
      useCorrectSeason = _ref.useCorrectSeason,
      contentData = _objectWithoutProperties(_ref, ['index', 'ContentNode', 'contractingPeriod', 'takenDateRanges', 'removeOneSeasonSet', 'contentActions', 'dateRangeActions', 'seasons', 'datesEditable', 'correctSeasonName', 'useCorrectSeason']);

  var onChangeDate = dateRangeActions.onChangeDate,
      removeADateRange = dateRangeActions.removeADateRange,
      addADateRange = dateRangeActions.addADateRange;

  var dateRanges = (0, _ramda.propOr)([{}], 'dateRanges', contentData);
  var seasonName = datesEditable ? '' : _dateUtils2.default.getSeasonNameIfMatch(seasons, dateRanges);
  // const seasonName = seasons[index] ? seasons[index].seasonName : '';
  return _react2.default.createElement(
    'div',
    {
      style: { borderBottom: '1px solid #ededed', borderTop: '1px solid #ededed', minHeight: '100px' }
    },
    _react2.default.createElement(
      'div',
      { style: { height: '32px', backgroundColor: '#fafafa', borderBottom: '1px solid #ededed', lineHeight: '32px' } },
      _react2.default.createElement(
        'div',
        { style: { marginLeft: '32px', display: 'inline-block' } },
        _react2.default.createElement(
          'span',
          null,
          seasonName
        ),
        !seasonName && correctSeasonName ? _react2.default.createElement(
          'div',
          { style: { color: '#f44336' } },
          'The date ranges below doesn\'t match ',
          correctSeasonName,
          '.',
          _react2.default.createElement(
            'div',
            {
              onClick: useCorrectSeason,
              style: { display: 'inline-block', marginLeft: '12px', color: '#00BCD4', cursor: 'pointer' }
            },
            'Correct Date Ranges'
          )
        ) : _react2.default.createElement('div', null)
      ),
      _react2.default.createElement(
        'div',
        {
          style: {
            display: datesEditable ? 'inline-block' : 'none',
            marginRight: '64px',
            lineHeight: '32px',
            verticalAlign: 'middle',
            color: '#ff4081',
            cursor: 'pointer',
            float: 'right'
          },
          onClick: function onClick() {
            return removeOneSeasonSet(index);
          }
        },
        'DELETE'
      )
    ),
    _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { overflow: 'hidden', minHeight: '52px', paddingTop: '4px', paddingLeft: '32px', marginBottom: '0' },
      leftColumnStyle: { width: datesEditable ? '40%' : '20%', fontSize: '12px', position: 'relative', top: '12px', paddingBottom: datesEditable ? '0px' : '24px' },
      rightColumnStyle: { width: datesEditable ? '60%' : '80%' },
      leftColumnContent: _react2.default.createElement(_dateRanges2.default, {
        dateRanges: dateRanges,
        datesNotEditable: !datesEditable,
        contractingPeriod: contractingPeriod,
        takenDateRanges: takenDateRanges,
        onChangeDate: onChangeDate(index),
        removeADateRange: removeADateRange(index),
        addADateRange: addADateRange(index)
      }),
      rightColumnContent: _react2.default.createElement(ContentNode, _extends({ index: index }, contentData, contentActions))
    })
  );
};

exports.default = SingleSection;

/***/ }),
/* 3303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _datePickerSet = __webpack_require__(1140);

var _datePickerSet2 = _interopRequireDefault(_datePickerSet);

var _ramda = __webpack_require__(2);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateRanges = function DateRanges(_ref) {
  var dateRanges = _ref.dateRanges,
      datesNotEditable = _ref.datesNotEditable,
      contractingPeriod = _ref.contractingPeriod,
      takenDateRanges = _ref.takenDateRanges,
      onChangeDate = _ref.onChangeDate,
      removeADateRange = _ref.removeADateRange,
      addADateRange = _ref.addADateRange;

  if (datesNotEditable) return _react2.default.createElement(
    'div',
    null,
    (dateRanges || []).map(function (range, rangeIndex) {
      return _react2.default.createElement(
        'div',
        { key: rangeIndex },
        _dateUtils2.default.displayRange(range)
      );
    })
  );
  return _react2.default.createElement(
    'div',
    null,
    dateRanges.map(function (range, index) {
      var currentFromDate = (0, _ramda.prop)('seasonStartDate', range);
      var currentToDate = (0, _ramda.prop)('seasonEndDate', range);
      var ifCurrentExist = (0, _ramda.ifElse)((0, _ramda.equals)('getStart'), (0, _ramda.always)(currentFromDate || currentToDate), (0, _ramda.always)(currentToDate || currentFromDate));
      var getInitialDate = (0, _ramda.cond)([[function () {
        return (0, _ramda.or)(currentFromDate, currentToDate);
      }, ifCurrentExist], [function () {
        return (0, _ramda.and)(dateRanges.length > 1, index);
      }, (0, _ramda.always)((0, _ramda.path)([index - 1, 'seasonEndDate'], dateRanges) || (0, _ramda.path)([index - 1, 'seasonStartDate'], dateRanges))], [_ramda.T, (0, _ramda.always)((0, _ramda.prop)('startDate', contractingPeriod))]]);
      var initialStartDateMonth = getInitialDate('getStart');
      var initialEndDateMonth = getInitialDate('getEnd');
      var newTakenRanges = (0, _ramda.call)((0, _ramda.compose)((0, _ramda.concat)(takenDateRanges), _dateUtils2.default.transformDateRanges, (0, _ramda.addIndex)(_ramda.reject)(function (_, filterIndex) {
        return (0, _ramda.equals)(filterIndex, index);
      })), dateRanges);
      return _react2.default.createElement(_datePickerSet2.default, {
        key: index,
        endDateCloseOnSelect: true,
        startDateCloseOnSelect: true,
        disableDeleteButton: dateRanges.length < 2,
        startDateContainerStyle: { display: 'inline-block', marginLeft: '3%', width: '32%' },
        startDateTextFieldStyle: { width: '100%', fontSize: '12px' },
        endDateContainerStyle: { display: 'inline-block', marginLeft: '3%', width: '32%' },
        endDateTextFieldStyle: { width: '100%', fontSize: '12px' },
        addButtonStyle: { marginLeft: '16px', lineHeight: '24px', verticalAlign: 'middle' },
        deleteButtonStyle: { lineHeight: '24px', verticalAlign: 'middle' },
        startDateHintText: 'Start Date',
        endDateHintText: 'End Date',
        disabledRanges: newTakenRanges,
        initialStartDateMonth: initialStartDateMonth,
        startDateEnableFrom: contractingPeriod.startDate,
        startDateEnableTo: contractingPeriod.endDate,
        initialEndDateMonth: initialEndDateMonth,
        endDateEnableFrom: currentFromDate || contractingPeriod.startDate,
        endDateEnableTo: contractingPeriod.endDate,
        startDate: currentFromDate,
        endDate: currentToDate,
        onChangeStartDate: onChangeDate(index, 'seasonStartDate'),
        onChangeEndDate: onChangeDate(index, 'seasonEndDate'),
        onDelete: function onDelete() {
          return removeADateRange(index);
        },
        onAdd: function onAdd() {
          return addADateRange(index);
        }
      });
    })
  );
};

exports.default = DateRanges;

/***/ }),
/* 3304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _syncSectionCheckbox = __webpack_require__(1004);

var _syncSectionCheckbox2 = _interopRequireDefault(_syncSectionCheckbox);

var _contractingPresetNamesCodes = __webpack_require__(464);

var _reactRedux = __webpack_require__(6);

var _editSeason = __webpack_require__(3305);

var _editSeason2 = _interopRequireDefault(_editSeason);

var _assignDateRanges = __webpack_require__(3307);

var _assignDateRanges2 = _interopRequireDefault(_assignDateRanges);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var propTypes = {
  onRequestClose: _react.PropTypes.func,
  onTextFieldChange: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  productId: _react.PropTypes.string,
  saveProductInfoChanges: _react.PropTypes.func,
  data: _react.PropTypes.object,
  takenDateRanges: _react.PropTypes.array,
  saving: _react.PropTypes.bool,
  onTextFieldChangeWithKeyPath: _react.PropTypes.func,
  contractingPeriod: _react.PropTypes.object,
  dialogOpen: _react.PropTypes.bool
};

var EditSeasonsDialog = function (_Component) {
  _inherits(EditSeasonsDialog, _Component);

  function EditSeasonsDialog() {
    _classCallCheck(this, EditSeasonsDialog);

    var _this = _possibleConstructorReturn(this, (EditSeasonsDialog.__proto__ || Object.getPrototypeOf(EditSeasonsDialog)).call(this));

    _this.generateSeasonErrors = function (existingSeasons) {
      var contractingPeriod = _this.props.contractingPeriod;

      var withErrors = (existingSeasons || []).map(function (season, seasonIndex) {
        var otherSeasons = _ramda2.default.remove(seasonIndex, 1, existingSeasons);
        var emptyRange = isNilOrEmpty(season.dateRanges);
        var inValidDates = _dateUtils2.default.notInContractingPeriod(season.dateRanges, contractingPeriod.startDate, contractingPeriod.endDate);
        var overlappingDates = season.dateRanges.some(function (range) {
          return _dateUtils2.default.overlapExisting({ from: range.seasonStartDate, to: range.seasonEndDate }, otherSeasons);
        });
        return _extends({}, season, {
          hasError: emptyRange || inValidDates || overlappingDates,
          inValidDates: inValidDates,
          emptyRange: emptyRange,
          overlappingDates: overlappingDates
        });
      });
      var hasError = withErrors.some(function (s) {
        return s.hasError;
      });
      _this.setState({ seasonsWithErrors: withErrors, showError: hasError });
      return hasError;
    };

    _this.saveChanges = function () {
      var _this$props = _this.props,
          contractId = _this$props.contractId,
          productId = _this$props.productId,
          saveProductInfoChanges = _this$props.saveProductInfoChanges,
          data = _this$props.data;
      // filter out empty date ranges

      var processedData = _extends({}, data, {
        existingSeasons: data.existingSeasons.map(function (s) {
          return _extends({}, s, {
            dateRanges: s.dateRanges.filter(function (dr) {
              return dr.seasonStartDate;
            })
          });
        })
      });
      var hasError = _this.generateSeasonErrors(processedData.existingSeasons);
      if (!hasError) {
        saveProductInfoChanges({
          contractId: contractId,
          productId: productId,
          data: _extends({}, data, {
            existingSeasons: data.existingSeasons.filter(function (season) {
              return !_dateUtils2.default.isDateRangesWithEmptyDates(season.dateRanges);
            })
          }),
          updateType: 'SAVE_SEASON_DATES_CHANGES'
        });
      }
    };

    _this.state = {
      showError: false,
      seasonsWithErrors: []
    };
    return _this;
  }

  _createClass(EditSeasonsDialog, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onRequestClose = _props.onRequestClose,
          onTextFieldChangeWithKeyPath = _props.onTextFieldChangeWithKeyPath,
          data = _props.data,
          saving = _props.saving,
          contractingPeriod = _props.contractingPeriod,
          dialogOpen = _props.dialogOpen,
          productName = _props.productName,
          ratePackageName = _props.ratePackageName;


      var onChange = onTextFieldChangeWithKeyPath;
      if (_ramda2.default.isEmpty(data) || isNaN(data.seasonIndex)) return _react2.default.createElement('div', null);
      var existingSeasons = this.state.showError ? this.state.seasonsWithErrors : data.existingSeasons;
      var allDateRanges = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.filter(_ramda2.default.has('seasonStartDate')), _ramda2.default.chain(_ramda2.default.propOr([], 'dateRanges'))), existingSeasons);
      var notAssignedRanges = _dateUtils2.default.getMissingRanges(allDateRanges, contractingPeriod);
      var someDatesNotInPeriod = _dateUtils2.default.notInContractingPeriod(allDateRanges, contractingPeriod.startDate, contractingPeriod.endDate);
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          autoScrollBodyContent: true,
          bodyStyle: { padding: '0' },
          contentStyle: { maxWidth: '1200px', width: '100%' },
          open: dialogOpen,
          actionsContainerStyle: {
            boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)'
          },
          title: _react2.default.createElement(
            'div',
            {
              style: {
                backgroundColor: '#00BCD4',
                color: 'white',
                fontSize: '18px',
                padding: '12px 2%'
              }
            },
            'Edit Season  - ',
            productName,
            ' ',
            ratePackageName ? '(' + ratePackageName + ')' : ''
          ),
          actions: [_react2.default.createElement(_syncSectionCheckbox2.default, {
            sectionInEdit: 'seasons',
            label: 'Sync Updates to Other Products (If applicable)',
            labelStyle: { marginLeft: '16px', width: '70%' },
            style: { float: 'left', width: '55%', top: '6px' }
          }), _react2.default.createElement(_flatButtonWithLoader2.default, {
            label: 'Cancel',
            labelStyle: { fontWeight: '600', marginRight: '15px' },
            primary: true,
            onTouchTap: onRequestClose
          }), _react2.default.createElement(_flatButtonWithLoader2.default, {
            onClick: this.saveChanges,
            secondary: true,
            loader: saving,
            label: 'save changes',
            labelStyle: { fontWeight: '600' }
          })]
        },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { display: 'flex' } },
            _react2.default.createElement(
              _materialUi.List,
              { style: { width: '165px', marginRight: '16px', borderRight: '1px solid #e0e0e0' } },
              existingSeasons.map(function (season, seasonIndex) {
                return _react2.default.createElement(_materialUi.ListItem, {
                  key: seasonIndex,
                  style: data.seasonIndex === seasonIndex ? { backgroundColor: '#e0e0e0' } : {},
                  primaryText: _react2.default.createElement(
                    'div',
                    {
                      style: {
                        color: _contractingPresetNamesCodes.seasonColors[seasonIndex] || 'rgba(0, 0, 0, 0.54)',
                        fontSize: '13px'
                      }
                    },
                    season.seasonName.replace('Season', ''),
                    season.hasError ? _react2.default.createElement(_materialUi.FontIcon, {
                      className: 'tc-icon-report',
                      style: { color: '#f44336', marginLeft: '4px' }
                    }) : _react2.default.createElement('span', null)
                  ),
                  onTouchTap: function onTouchTap() {
                    return onChange({ keyPath: ['data', 'seasonIndex'], value: seasonIndex });
                  }
                });
              }),
              !someDatesNotInPeriod && notAssignedRanges && notAssignedRanges.length ? _react2.default.createElement(_materialUi.Divider, null) : _react2.default.createElement('span', null),
              !someDatesNotInPeriod && notAssignedRanges && notAssignedRanges.length ? _react2.default.createElement(_materialUi.ListItem, {
                style: { backgroundColor: data.seasonIndex === -1 ? '#e0e0e0' : '' },
                primaryText: _react2.default.createElement(
                  'div',
                  { style: { fontSize: '13px' } },
                  'Unassigned Dates'
                ),
                onTouchTap: function onTouchTap() {
                  return onChange({ keyPath: ['data', 'seasonIndex'], value: -1 });
                }
              }) : _react2.default.createElement('span', null)
            ),
            data.seasonIndex === -1 ? _react2.default.createElement(_assignDateRanges2.default, {
              data: data,
              notAssignedRanges: notAssignedRanges,
              onChange: onChange,
              contractingPeriod: contractingPeriod
            }) : _react2.default.createElement(_editSeason2.default, {
              existingSeasons: existingSeasons,
              onChange: onChange,
              contractingPeriod: contractingPeriod,
              seasonIndex: data.seasonIndex,
              selectedSeasonName: _ramda2.default.path([data.seasonIndex, 'seasonName'], existingSeasons),
              selectedDateRanges: _ramda2.default.path([data.seasonIndex, 'dateRanges'], existingSeasons) || []
            })
          )
        )
      );
    }
  }]);

  return EditSeasonsDialog;
}(_react.Component);

EditSeasonsDialog.propTypes = propTypes;
var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting;
  return {
    dialogOpen: contracting.addEditContractDialog.get('open')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(EditSeasonsDialog);

/***/ }),
/* 3305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _dateRangePicker = __webpack_require__(1974);

var _dateRangePicker2 = _interopRequireDefault(_dateRangePicker);

var _contractingPresetNamesCodes = __webpack_require__(464);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _startEndDate = __webpack_require__(3306);

var _startEndDate2 = _interopRequireDefault(_startEndDate);

var _selectSeasonName = __webpack_require__(1554);

var _selectSeasonName2 = _interopRequireDefault(_selectSeasonName);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _convertDateRanges = function _convertDateRanges(dateRanges) {
  return dateRanges.map(function (dateRange) {
    return {
      from: _dateUtils2.default._getDateFromUTC(dateRange.seasonStartDate),
      to: _dateUtils2.default._getDateFromUTC(dateRange.seasonEndDate),
      _id: dateRange._id
    };
  });
};

var EditSeason = function EditSeason(_ref) {
  var existingSeasons = _ref.existingSeasons,
      _onChange = _ref.onChange,
      seasonIndex = _ref.seasonIndex,
      selectedSeasonName = _ref.selectedSeasonName,
      selectedDateRanges = _ref.selectedDateRanges,
      contractingPeriod = _ref.contractingPeriod;

  var dateRanges = _convertDateRanges(selectedDateRanges);
  var renderDay = _ramda2.default.curry(function (rangePicker, day) {
    var foundSeasonIndex = _ramda2.default.findIndex(_ramda2.default.compose(_dateUtils2.default.dayInDateRanges(day), _ramda2.default.prop('dateRanges')), existingSeasons);
    return _react2.default.createElement(
      'div',
      {
        style: {
          get color() {
            if (foundSeasonIndex === seasonIndex && rangePicker) return 'white';
            if (foundSeasonIndex + 1 > _contractingPresetNamesCodes.seasonColors.length) return 'grey';
            return _contractingPresetNamesCodes.seasonColors[foundSeasonIndex];
          },
          fontWeight: foundSeasonIndex < 0 ? '500' : '600'
        }
      },
      day.getDate()
    );
  });
  var otherSeasons = _ramda2.default.remove(seasonIndex, 1, existingSeasons);
  var onStartEndUpdate = function onStartEndUpdate(index) {
    return function (newRange) {
      var restOfSeasons = existingSeasons.map(function (existingSeason, i) {
        if (i === seasonIndex) {
          return _ramda2.default.merge(existingSeason, {
            dateRanges: _ramda2.default.remove(index, 1, existingSeason.dateRanges)
          });
        }
        return existingSeason;
      });
      if (_dateUtils2.default.overlapExisting({ from: newRange.seasonStartDate, to: newRange.seasonEndDate }, restOfSeasons)) {
        var adjustRestOfSeasons = _dateUtils2.default.removeOverlapDates({ from: newRange.seasonStartDate, to: newRange.seasonEndDate }, restOfSeasons);
        var adjustedExistingSeasons = adjustRestOfSeasons.map(function (existingSeason, i) {
          if (i === seasonIndex) {
            return _ramda2.default.merge(existingSeason, {
              dateRanges: _ramda2.default.insert(index, newRange, existingSeason.dateRanges)
            });
          }
          return existingSeason;
        });
        _onChange({ keyPath: ['data', 'existingSeasons'], value: adjustedExistingSeasons });
      } else {
        _onChange({
          keyPath: ['data', 'existingSeasons', seasonIndex, 'dateRanges', index],
          value: newRange
        });
      }
    };
  };
  var onDeleteDR = function onDeleteDR(i) {
    return function () {
      _onChange({
        keyPath: ['data', 'existingSeasons', seasonIndex, 'dateRanges'],
        value: _ramda2.default.remove(i, 1, selectedDateRanges)
      });
    };
  };
  var onAddDR = function onAddDR(i) {
    return function () {
      _onChange({
        keyPath: ['data', 'existingSeasons', seasonIndex, 'dateRanges'],
        value: !selectedDateRanges.length ? [{}, {}] : _ramda2.default.insert(i + 1, {}, selectedDateRanges)
      });
    };
  };
  return _react2.default.createElement(
    'div',
    { style: { paddingTop: '16px', width: 'calc(100% - 200px)' } },
    _react2.default.createElement(_selectSeasonName2.default, {
      style: { marginBottom: '12px', width: '460px', fontSize: '13px' },
      selectedSeasonName: selectedSeasonName,
      contractingPeriod: contractingPeriod,
      existingSeasons: existingSeasons,
      onChange: function onChange(value) {
        return _onChange({ keyPath: ['data', 'existingSeasons', seasonIndex, 'seasonName'], value: value });
      }
    }),
    _react2.default.createElement(
      'small',
      null,
      _react2.default.createElement(
        'i',
        null,
        'Please select from the calendar or enter dates directly.'
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexDirection: 'row-reverse', marginTop: '8px' } },
      _react2.default.createElement(
        'div',
        { style: { marginTop: '12px', width: '400px' } },
        (selectedDateRanges.length ? selectedDateRanges : [{}]).map(function (range, index) {
          var overlapping = existingSeasons[seasonIndex].overlappingDates && _dateUtils2.default.overlapExisting({ from: range.seasonStartDate, to: range.seasonEndDate }, otherSeasons);
          return _react2.default.createElement(
            'div',
            { key: '' + index + seasonIndex },
            _react2.default.createElement(_startEndDate2.default, {
              index: index,
              prevDREnd: _ramda2.default.pathOr(null, [index - 1, 'seasonEndDate'], selectedDateRanges) || _ramda2.default.pathOr(null, [index - 1, 'seasonStartDate'], selectedDateRanges),
              renderDay: renderDay,
              selectedSeasonName: selectedSeasonName,
              seasonIndex: seasonIndex,
              contractingPeriod: contractingPeriod,
              range: range,
              onChange: _onChange,
              onUpdate: onStartEndUpdate(index),
              onDelete: onDeleteDR(index),
              onAdd: onAddDR(index)
            }),
            overlapping ? _react2.default.createElement(
              'small',
              { style: { color: 'red' } },
              'This date range is overlapping with another season.'
            ) : _react2.default.createElement('small', null)
          );
        }),
        !selectedDateRanges.length && _react2.default.createElement(
          'small',
          { style: { color: '#f5372a' } },
          'Please enter at least one valid date range for this season.'
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { paddingRight: '16px', width: '566px' } },
        _react2.default.createElement(_dateRangePicker2.default, {
          noShowSelected: true,
          numberOfMonths: 6,
          startDate: contractingPeriod.startDate,
          endDate: contractingPeriod.endDate,
          selectedRanges: dateRanges,
          initialMonth: dateRanges.length ? _dateUtils2.default.getFirstDayFromAnArrayOfRanges(dateRanges.filter(function (dr) {
            return dr.from;
          })) : new Date(contractingPeriod.startDate.getUTCFullYear(), contractingPeriod.startDate.getUTCMonth(), contractingPeriod.startDate.getUTCDate()),
          renderDay: renderDay(true),
          onConfirmClick: function onConfirmClick(range) {
            var newRange = {
              seasonStartDate: _moment2.default.utc(range.from).format(),
              seasonEndDate: range.to ? _moment2.default.utc(range.to).format() : range.to
            };
            var newDateRangesForTheSeason = function () {
              // for when user click the end date of a range
              if (selectedDateRanges.length && (0, _moment2.default)(_ramda2.default.last(selectedDateRanges).seasonStartDate).isSame(range.from)) {
                return [].concat(_toConsumableArray(_ramda2.default.dropLast(1, selectedDateRanges)), [newRange]);
              }
              return _ramda2.default.append(newRange, selectedDateRanges);
            }();
            if (_dateUtils2.default.overlapExisting(range, existingSeasons)) {
              var adjustedExistingSeasons = _dateUtils2.default.removeOverlapDates(range, existingSeasons);
              _onChange({
                keyPath: ['data', 'existingSeasons'],
                value: adjustedExistingSeasons.map(function (season, i) {
                  return i === seasonIndex ? _ramda2.default.merge(season, { dateRanges: newDateRangesForTheSeason }) : season;
                })
              });
            } else {
              _onChange({
                keyPath: ['data', 'existingSeasons', seasonIndex, 'dateRanges'],
                value: newDateRangesForTheSeason
              });
            }
          }
        })
      )
    )
  );
};

EditSeason.propTypes = {
  onRequestClose: _react.PropTypes.func,
  onTextFieldChange: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  productId: _react.PropTypes.string,
  saveProductInfoChanges: _react.PropTypes.func,
  data: _react.PropTypes.object,
  takenDateRanges: _react.PropTypes.array,
  saving: _react.PropTypes.bool
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    dialogOpen: contracting.addEditContractDialog.get('open')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(EditSeason);

/***/ }),
/* 3306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _datePickerSet = __webpack_require__(1140);

var _datePickerSet2 = _interopRequireDefault(_datePickerSet);

var _materialUi = __webpack_require__(3);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  prevDREnd: _react.PropTypes.any,
  renderDay: _react.PropTypes.func,
  selectedSeasonName: _react.PropTypes.string,
  seasonIndex: _react.PropTypes.number,
  index: _react.PropTypes.number,
  contractingPeriod: _react.PropTypes.object,
  range: _react.PropTypes.object,
  onChange: _react.PropTypes.func,
  onUpdate: _react.PropTypes.func,
  onDelete: _react.PropTypes.func,
  onAdd: _react.PropTypes.func
};

var StartEndDate = function (_Component) {
  _inherits(StartEndDate, _Component);

  function StartEndDate() {
    _classCallCheck(this, StartEndDate);

    return _possibleConstructorReturn(this, (StartEndDate.__proto__ || Object.getPrototypeOf(StartEndDate)).apply(this, arguments));
  }

  _createClass(StartEndDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          prevDREnd = _props.prevDREnd,
          renderDay = _props.renderDay,
          selectedSeasonName = _props.selectedSeasonName,
          seasonIndex = _props.seasonIndex,
          index = _props.index,
          contractingPeriod = _props.contractingPeriod,
          range = _props.range,
          onChange = _props.onChange,
          onUpdate = _props.onUpdate,
          onAdd = _props.onAdd,
          onDelete = _props.onDelete;


      var currentFromDate = _ramda2.default.prop('seasonStartDate', range);
      var currentToDate = _ramda2.default.prop('seasonEndDate', range);
      var initialStartDateMonth = function () {
        if (currentFromDate) return currentFromDate;
        if (currentToDate) return currentToDate;
        if (prevDREnd) return prevDREnd;
        return contractingPeriod.startDate;
      }();
      var initialEndDateMonth = function () {
        if (currentToDate) return currentToDate;
        if (currentFromDate) return currentFromDate;
        if (prevDREnd) return prevDREnd;
        return contractingPeriod.startDate;
      }();
      var isSpecialEvent = selectedSeasonName.toLowerCase() === 'special event';
      var notInContractPeriod = range.seasonStartDate && range.seasonEndDate && _dateUtils2.default.notInContractingPeriod([range], contractingPeriod.startDate, contractingPeriod.endDate);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_datePickerSet2.default, {
          key: index,
          style: { display: 'flex', width: '95%' },
          showTextField: isSpecialEvent,
          endDateCloseOnSelect: true,
          startDateCloseOnSelect: true,
          textFieldStyle: { display: 'inline-block', width: '100px', fontSize: '12px' },
          startDateContainerStyle: { display: 'inline-block', marginLeft: '8px', width: 'calc(50% - 80px)' },
          startDateTextFieldStyle: { width: '100%', fontSize: '12px' },
          endDateContainerStyle: { display: 'inline-block', width: 'calc(50% - 80px)' },
          endDateTextFieldStyle: { width: '100%', fontSize: '12px' },
          addButtonStyle: { marginLeft: '8px', lineHeight: '24px', verticalAlign: 'middle' },
          deleteButtonStyle: { lineHeight: '24px', verticalAlign: 'middle' },
          textFieldFloatingText: 'Event Name',
          startDateFloatingText: 'Start Date',
          endDateFloatingText: 'End Date',
          renderDay: renderDay(false),
          initialStartDateMonth: initialStartDateMonth,
          startDateEnableFrom: contractingPeriod.startDate,
          startDateEnableTo: contractingPeriod.endDate,
          initialEndDateMonth: initialEndDateMonth,
          endDateEnableFrom: contractingPeriod.startDate,
          endDateEnableTo: contractingPeriod.endDate,
          textFieldValue: range.eventName,
          startDate: range.seasonStartDate,
          endDate: range.seasonEndDate,
          startDateUnderlineStyle: notInContractPeriod ? { borderColor: 'red' } : {},
          endDateUnderlineStyle: notInContractPeriod ? { borderColor: 'red' } : {},
          textFieldOnChange: function textFieldOnChange(e) {
            return onChange({
              keyPath: ['data', 'existingSeasons', seasonIndex, 'dateRanges', index, 'eventName'],
              value: e.target.value
            });
          },
          onChangeStartDate: function onChangeStartDate(value) {
            return onUpdate({
              eventName: range.eventName,
              seasonStartDate: value || range.seasonEndDate,
              seasonEndDate: range.seasonEndDate
            });
          },
          onChangeEndDate: function onChangeEndDate(value) {
            return onUpdate({
              eventName: range.eventName,
              seasonStartDate: range.seasonStartDate,
              seasonEndDate: value || range.seasonStartDate
            });
          },
          onDelete: onDelete,
          onAdd: onAdd
        }),
        notInContractPeriod ? _react2.default.createElement(
          'div',
          {
            style: {
              color: '#f44336',
              fontSize: '12px',
              display: 'flex',
              width: '100%',
              alignItems: 'center'
            }
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-report', style: { color: '#f44336', marginRight: '4px' } }),
          'Not in contracting period, please UPDATE or REMOVE'
        ) : _react2.default.createElement('span', null)
      );
    }
  }]);

  return StartEndDate;
}(_react.Component);

StartEndDate.propTypes = propTypes;
exports.default = StartEndDate;

/***/ }),
/* 3307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _contractingPresetNamesCodes = __webpack_require__(464);

var _selectSeasonName = __webpack_require__(1554);

var _selectSeasonName2 = _interopRequireDefault(_selectSeasonName);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignDateRanges = function AssignDateRanges(_ref) {
  var data = _ref.data,
      contractingPeriod = _ref.contractingPeriod,
      notAssignedRanges = _ref.notAssignedRanges,
      _onChange = _ref.onChange;

  var existingSeasons = data.existingSeasons || [];
  var assignInProgress = data.missingDatesIndexSelected && data.missingDatesIndexSelected.length && !isNaN(data.assignToSeasonIndex);
  var selected = data.missingDatesIndexSelected || [];
  return _react2.default.createElement(
    'div',
    { style: { padding: '24px 0 32px 0', width: '70%' } },
    _react2.default.createElement(
      'b',
      null,
      'Step One: Select Dates'
    ),
    _react2.default.createElement('br', null),
    notAssignedRanges && notAssignedRanges.length > 1 && _react2.default.createElement(_materialUi.Checkbox, {
      label: 'Select All',
      labelStyle: { fontWeight: 'bold' },
      checked: selected.length === notAssignedRanges.length,
      onCheck: function onCheck(_, inputChecked) {
        return _onChange({ keyPath: ['data', 'missingDatesIndexSelected'], value: inputChecked ? notAssignedRanges.map(function (__, i) {
            return i;
          }) : [] });
      }
    }),
    notAssignedRanges.map(function (range, i) {
      var checked = _ramda2.default.contains(i, selected);
      return _react2.default.createElement(_materialUi.Checkbox, {
        key: i,
        label: _dateUtils2.default.displayRange(range),
        checked: checked,
        onCheck: function onCheck() {
          var value = !checked ? _ramda2.default.append(i, selected) : _ramda2.default.reject(_ramda2.default.equals(i), selected);
          _onChange({
            keyPath: ['data', 'missingDatesIndexSelected'],
            value: value
          });
        }
      });
    }),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'b',
      null,
      'Step Two: Assign to Season'
    ),
    existingSeasons.map(function (season, i) {
      return _react2.default.createElement(_materialUi.RadioButton, {
        key: i,
        checked: _ramda2.default.equals(i, data.assignToSeasonIndex),
        label: season.seasonName,
        labelStyle: { color: _contractingPresetNamesCodes.seasonColors[i] },
        onCheck: function onCheck() {
          return _onChange({
            keyPath: ['data', 'assignToSeasonIndex'],
            value: i
          });
        }
      });
    }),
    _react2.default.createElement(_materialUi.RadioButton, {
      label: 'CREATE NEW SEASON',
      checked: _ramda2.default.equals(-1, data.assignToSeasonIndex),
      onCheck: function onCheck() {
        return _onChange({ keyPath: ['data', 'assignToSeasonIndex'], value: -1 });
      }
    }),
    _ramda2.default.equals(-1, data.assignToSeasonIndex) ? _react2.default.createElement(_selectSeasonName2.default, {
      labelNode: _react2.default.createElement(
        'label',
        {
          style: { display: 'block', margin: '0 0 8px 4px', fontSize: '13px' }
        },
        'Season Name',
        _react2.default.createElement(
          'span',
          { style: { color: '#f44336', marginLeft: '6px' } },
          '* Required'
        )
      ),
      style: { width: '70%', marginLeft: '5%' },
      selectedSeasonName: data.newSeasonName,
      contractingPeriod: contractingPeriod,
      existingSeasons: existingSeasons,
      onChange: function onChange(value) {
        return _onChange({ keyPath: ['data', 'newSeasonName'], value: value });
      }
    }) : _react2.default.createElement('span', null),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'b',
      null,
      'Step Three:'
    ),
    _react2.default.createElement(_materialUi.RaisedButton, {
      label: 'Assign',
      secondary: true,
      style: { marginLeft: '8px' },
      disabled: !assignInProgress || data.assignToSeasonIndex === -1 && !data.newSeasonName,
      onTouchTap: function onTouchTap() {
        var selectedRanges = notAssignedRanges.filter(function (_, j) {
          return _ramda2.default.contains(j, data.missingDatesIndexSelected);
        }).map(function (naRange) {
          return { seasonStartDate: _moment2.default.utc(naRange.from).format(), seasonEndDate: _moment2.default.utc(naRange.to || naRange.from).format() };
        });
        var newExistingSeasons = data.assignToSeasonIndex > -1 ? existingSeasons.map(function (season, i) {
          if (i === data.assignToSeasonIndex) return _ramda2.default.merge(season, { dateRanges: _ramda2.default.concat(season.dateRanges, selectedRanges) });
          return season;
        }) : _ramda2.default.append({ seasonName: data.newSeasonName, dateRanges: selectedRanges }, existingSeasons);
        // if there is no more dates to be assigned
        // NOTE: existingSeasons hasn't been updated at this point so notAssignedRanges won't be empty, check isNilOrEmpty(notAssignedRanges) won't work
        if (notAssignedRanges.length === data.missingDatesIndexSelected.length) {
          _onChange({ keyPath: ['data', 'seasonIndex'], value: data.assignToSeasonIndex > -1 ? data.assignToSeasonIndex : existingSeasons.length });
        }
        _onChange({
          keyPath: ['data', 'existingSeasons'],
          value: newExistingSeasons
        });
      }
    }),
    _react2.default.createElement(
      'div',
      null,
      assignInProgress ? "Note: Dates won't be assigned until the ASSIGN button is clicked." : ''
    )
  );
};

exports.default = AssignDateRanges;

/***/ }),
/* 3308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _editRateSet = __webpack_require__(3309);

var _editRateSet2 = _interopRequireDefault(_editRateSet);

var _addRateSet = __webpack_require__(3310);

var _addRateSet2 = _interopRequireDefault(_addRateSet);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditRates = function EditRates(props) {
  var saving = props.saving,
      onRequestClose = props.onRequestClose,
      contractId = props.contractId,
      productId = props.productId,
      saveProductInfoChanges = props.saveProductInfoChanges,
      data = props.data,
      productType = props.productType,
      dialogOpen = props.dialogOpen,
      onTextFieldChangeWithKeyPath = props.onTextFieldChangeWithKeyPath,
      productName = props.productName,
      ratePackageName = props.ratePackageName;

  if (_ramda2.default.isEmpty(data)) return _react2.default.createElement('div', null);
  var currentRateSet = data.rateSets[data.rateSetsIndex];
  var exists = _ramda2.default.allPass([function (val) {
    return _ramda2.default.complement(_ramda2.default.isNil)(val);
  }, function (val) {
    return _ramda2.default.complement(_ramda2.default.equals(0))(val);
  }, function (val) {
    return _ramda2.default.complement(_ramda2.default.equals('0'))(val);
  }, function (val) {
    return _ramda2.default.complement(_ramda2.default.equals(''))(val);
  }]);
  var getRateWithMaxAdultsPlusChild = _ramda2.default.compose(_ramda2.default.last, _ramda2.default.sort(function (a, b) {
    var rateA = _ramda2.default.propOr(0, 'maxAdultsPlusChild', a);
    var rateB = _ramda2.default.propOr(0, 'maxAdultsPlusChild', b);
    if (rateA > rateB) return 1;
    if (rateB > rateA) return -1;
    return 0;
  }), _ramda2.default.filter(function (rate) {
    return exists(_ramda2.default.prop('maxAdultsPlusChild', rate));
  }), _ramda2.default.propOr([], 'rates'));
  var maxAdultsPlusChild = _ramda2.default.propOr(0, 'maxAdultsPlusChild', getRateWithMaxAdultsPlusChild(currentRateSet) || {});
  var getUsedRateSetNamesAndCodes = function getUsedRateSetNamesAndCodes(indexToExclude) {
    return data.rateSets.filter(function (_, i) {
      return i !== indexToExclude;
    }).map(_ramda2.default.pick(['rateSetName', 'rateSetCode']));
  };

  var normalizeMinMaxDays = function normalizeMinMaxDays(obj) {
    return (obj.daysOfWeek || []).reduce(function (newObj, day) {
      newObj[day] = {
        minStay: obj.minStay || 1,
        maxStay: obj.maxStay || 999
      };
      return newObj;
    }, {});
  };
  var getGroupedUsedMinMaxDays = function getGroupedUsedMinMaxDays(indexToExclude) {
    return _ramda2.default.call(_ramda2.default.compose(_ramda2.default.reduce(function (daysMinMaxMap, obj) {
      if (obj.Monday) daysMinMaxMap.Monday.push(obj.Monday);
      if (obj.Tuesday) daysMinMaxMap.Tuesday.push(obj.Tuesday);
      if (obj.Wednesday) daysMinMaxMap.Wednesday.push(obj.Wednesday);
      if (obj.Thursday) daysMinMaxMap.Thursday.push(obj.Thursday);
      if (obj.Friday) daysMinMaxMap.Friday.push(obj.Friday);
      if (obj.Saturday) daysMinMaxMap.Saturday.push(obj.Saturday);
      if (obj.Sunday) daysMinMaxMap.Sunday.push(obj.Sunday);
      return daysMinMaxMap;
    }, { Monday: [], Tuesday: [], Wednesday: [], Thursday: [], Friday: [], Saturday: [], Sunday: [] }), _ramda2.default.map(_ramda2.default.compose(normalizeMinMaxDays, _ramda2.default.pick(['minStay', 'maxStay', 'daysOfWeek']))), _ramda2.default.addIndex(_ramda2.default.filter)(function (_, i) {
      return i !== indexToExclude;
    })), data.rateSets);
  };

  var overlappingDays = function overlappingDays(rateSet, rateSetIndex) {
    var groupedUsedMinMaxDays = getGroupedUsedMinMaxDays(rateSetIndex);
    var currentGroupedMinMax = normalizeMinMaxDays(rateSet);
    var isMinMaxOverlap = _ramda2.default.curry(function (objA, objB) {
      var isBetweenRateSetMinMax = function isBetweenRateSetMinMax(num) {
        return _ramda2.default.lte(num, objA.maxStay || 999) && _ramda2.default.gte(num, objA.minStay || 1);
      };
      return isBetweenRateSetMinMax(objB.minStay || 1) || isBetweenRateSetMinMax(objB.maxStay || 999);
    });
    if (rateSet.daysOfWeek && rateSet.daysOfWeek.some(function (day) {
      var currentMinMaxObj = currentGroupedMinMax[day];
      var usedMinMaxArray = groupedUsedMinMaxDays[day];
      if (productType === 'Non-Accommodation') return usedMinMaxArray && usedMinMaxArray.length > 0;
      return usedMinMaxArray.some(function (objA) {
        return isMinMaxOverlap(objA, currentMinMaxObj);
      });
    })) {
      return productType === 'Accommodation' ? 'Rate sets cannot have overlapping min/max night stays and be applied to the same days of the week.' : 'Rate sets cannot have overlapping days of the week.';
    }
  };
  var invalidRateSetNameAndCode = function invalidRateSetNameAndCode(rateSet, rateSetsIndex) {
    var usedRateSetNamesAndCodes = getUsedRateSetNamesAndCodes(rateSetsIndex);

    if (usedRateSetNamesAndCodes.some(function (nameAndCode) {
      if (nameAndCode.rateSetName === rateSet.rateSetName) {
        if (!nameAndCode.rateSetCode && !rateSet.rateSetCode) return true;
        return nameAndCode.rateSetCode === rateSet.rateSetCode;
      }
    })) {
      return 'You have already entered a ' + rateSet.rateSetName + ' rate set using ' + (rateSet.rateSetCode ? 'the ' + rateSet.rateSetCode : ' an empty') + ' rate set code for this season. Please enter a new rate set name or rate set code so your agents know which rate is applicable.';
    }
  };

  var ratesTableNotComplete = function ratesTableNotComplete(rateSet) {
    if (rateSet.rates && rateSet.rates.every(function (rate) {
      return rate.notApplicable;
    })) return 'You need to include at least one rate for this rate set to be valid.';
  };
  var isRateSetValid = function isRateSetValid(rateSet, rateSetsIndex) {
    if (invalidRateSetNameAndCode(rateSet, rateSetsIndex) || ratesTableNotComplete(rateSet) || overlappingDays(rateSet, rateSetsIndex)) return false;
    if (productType === 'Accommodation' && !getRateWithMaxAdultsPlusChild(rateSet)) return false;
    if (!rateSet.rateSetName || !rateSet.daysOfWeek.length) return false;
    return true;
  };
  var invalidRSIndexes = data.rateSets.reduce(function (result, rs, i) {
    if (!isRateSetValid(rs, i)) result.push(i);
    return result;
  }, []);
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      autoScrollBodyContent: true,
      bodyStyle: { padding: '0', paddingBottom: '12px' },
      contentStyle: { maxWidth: '1200px', width: '1200px' },
      open: dialogOpen,
      actionsContainerStyle: { boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)' },
      title: _react2.default.createElement(
        'div',
        {
          style: { backgroundColor: '#00BCD4', color: 'white', fontSize: '18px', padding: '16px 2%' }
        },
        'Edit Rates for ',
        data.seasonName,
        ' - ',
        productName,
        ' ',
        ratePackageName ? '(' + ratePackageName + ')' : ''
      ),
      actions: currentRateSet.new ? null : [_react2.default.createElement(_flatButtonWithLoader2.default, {
        label: 'Cancel',
        labelStyle: { fontWeight: '600', marginRight: '15px' },
        primary: true,
        onTouchTap: onRequestClose
      }), _react2.default.createElement(_flatButtonWithLoader2.default, {
        onTouchTap: function onTouchTap() {
          return saveProductInfoChanges({ contractId: contractId, productId: productId, data: data, updateType: 'SAVE_RATES_CHANGES_ADD_EDIT' });
        },
        secondary: true,
        loader: saving,
        disabled: !_ramda2.default.isEmpty(invalidRSIndexes),
        label: 'save changes',
        labelStyle: { fontWeight: '600' }
      })]
    },
    _react2.default.createElement(
      'div',
      { style: { display: 'flex' } },
      _react2.default.createElement(
        _materialUi.List,
        { style: { width: '265px', minWidth: '265px', marginRight: '16px', borderRight: '1px solid #e0e0e0' } },
        data.rateSets.map(function (rateSet, rateSetsIndex) {
          return _react2.default.createElement(_materialUi.ListItem, {
            key: rateSetsIndex,
            rightIconButton: _react2.default.createElement(_materialUi.IconButton, {
              iconClassName: 'tc-icon-close',
              iconStyle: { color: 'rgba(0, 0, 0, 0.54)' },
              tooltip: 'delete rate set',
              onTouchTap: function onTouchTap() {
                onTextFieldChangeWithKeyPath({
                  keyPath: ['data'],
                  value: _extends({}, data, {
                    rateSetsIndex: Math.max(0, data.rateSetsIndex - 1),
                    rateSets: data.rateSets.filter(function (_, i) {
                      return i !== rateSetsIndex;
                    })
                  })
                });
                if (rateSet.new) {
                  props.clearAddRateSetWizard();
                }
              }
            }),
            style: _ramda2.default.merge({ color: 'rgba(0, 0, 0, 0.64)' }, data.rateSetsIndex === rateSetsIndex ? { backgroundColor: '#efefef' } : {}),
            primaryText: _react2.default.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center' } },
              rateSet.rateSetName || 'New',
              rateSet.rateSetCode ? '(' + rateSet.rateSetCode + ')' : '',
              _ramda2.default.contains(rateSetsIndex, invalidRSIndexes) && _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-report', style: { color: '#f44336', marginLeft: '4px' } })
            ),
            onTouchTap: function onTouchTap() {
              return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'rateSetsIndex'], value: rateSetsIndex });
            }
          });
        }),
        _react2.default.createElement(_materialUi.ListItem, {
          leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-add_circle', color: '#00bcd4' }),
          primaryText: 'Add Rate Set',
          onTouchTap: function onTouchTap() {
            onTextFieldChangeWithKeyPath({
              keyPath: ['data'],
              value: _extends({}, data, {
                rateSets: _ramda2.default.append({ new: true }, data.rateSets),
                rateSetsIndex: data.rateSets.length
              })
            });
          }
        })
      ),
      currentRateSet.new ? _react2.default.createElement(_addRateSet2.default, {
        onRequestClose: onRequestClose,
        productName: productName,
        getOverlappingDaysError: function getOverlappingDaysError(rateSet) {
          return overlappingDays(rateSet, data.rateSetsIndex);
        },
        usedRateSetNamesAndCodes: getUsedRateSetNamesAndCodes(data.rateSetsIndex),
        productType: productType,
        onFinish: function onFinish(rateSet) {
          props.clearAddRateSetWizard();
          onTextFieldChangeWithKeyPath({
            keyPath: ['data', 'rateSets'],
            value: data.rateSets.map(function (rs) {
              return !rs.new ? rs : rateSet;
            })
          });
        }
      }) : _react2.default.createElement(_editRateSet2.default, _extends({}, props, currentRateSet, {
        maxAdultsPlusChild: maxAdultsPlusChild,
        rateSetNameAndCodeError: invalidRateSetNameAndCode(currentRateSet, data.rateSetsIndex),
        overlappingDaysError: overlappingDays(currentRateSet, data.rateSetsIndex),
        ratesTableError: ratesTableNotComplete(currentRateSet)
      }))
    )
  );
};

EditRates.propTypes = {
  dialogOpen: _react.PropTypes.bool,
  saving: _react.PropTypes.bool,
  onRequestClose: _react.PropTypes.func,
  onTextFieldChange: _react.PropTypes.func,
  updateDaysOfWeek: _react.PropTypes.func,
  updateTableCell: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  productId: _react.PropTypes.string,
  productName: _react.PropTypes.string,
  saveProductInfoChanges: _react.PropTypes.func,
  data: _react.PropTypes.object,
  productType: _react.PropTypes.string,
  onTextFieldChangeWithKeyPath: _react.PropTypes.func,
  clearAddRateSetWizard: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting;
  return {
    dialogOpen: contracting.addEditContractDialog.get('open'),
    paxMax: contracting.addRateSetWizard.get('paxMax'),
    twinBedsAvail: contracting.addRateSetWizard.get('twinBedsAvail')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return { clearAddRateSetWizard: function clearAddRateSetWizard() {
      return dispatch({ type: 'CLEAR_ADD_RATE_SET_WIZARD' });
    } };
})(EditRates);

/***/ }),
/* 3309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rateSetInfoTemplate = __webpack_require__(1973);

var _rateSetInfoTemplate2 = _interopRequireDefault(_rateSetInfoTemplate);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _rateTableTemplateContainer = __webpack_require__(632);

var _rateTableTemplateContainer2 = _interopRequireDefault(_rateTableTemplateContainer);

var _taxCurrencyCommissionForm = __webpack_require__(1556);

var _taxCurrencyCommissionForm2 = _interopRequireDefault(_taxCurrencyCommissionForm);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var EditRateSet = function EditRateSet(_ref) {
  var productType = _ref.productType,
      productName = _ref.productName,
      data = _ref.data,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      updateFormData = _ref.updateFormData,
      paxMax = _ref.paxMax,
      twinBedsAvail = _ref.twinBedsAvail,
      contractState = _ref.contractState,
      _updateTableCell = _ref.updateTableCell,
      maxAdultsPlusChild = _ref.maxAdultsPlusChild,
      extraProps = _objectWithoutProperties(_ref, ['productType', 'productName', 'data', 'onTextFieldChangeWithKeyPath', 'updateFormData', 'paxMax', 'twinBedsAvail', 'contractState', 'updateTableCell', 'maxAdultsPlusChild']);

  var invalidRateDescrs = productType === 'Non-Accommodation' ? [] : extraProps.rates.filter(function (obj) {
    if (obj.notApplicable) return false;
    if (obj.description === 'Twin') return !twinBedsAvail;
    return obj.maxAdults > paxMax;
  }).map(function (obj) {
    return obj.description;
  });
  var basePath = ['data', 'rateSets', data.rateSetsIndex];
  return _react2.default.createElement(
    'div',
    { style: { padding: '24px' } },
    _react2.default.createElement(_rateSetInfoTemplate2.default, _extends({}, extraProps, {
      rateSetsIndex: data.rateSetsIndex,
      productType: productType,
      productName: productName,
      updateFieldValue: function updateFieldValue(key, value) {
        return onTextFieldChangeWithKeyPath({ keyPath: [].concat(basePath, [key]), value: value });
      },
      updateDaysOfWeek: function updateDaysOfWeek(checked, day) {
        if (day === 'All') {
          onTextFieldChangeWithKeyPath({ keyPath: [].concat(basePath, ['daysOfWeek']), value: checked ? ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'] : [] });
        } else {
          var newDaysOfWeek = checked ? [].concat(_toConsumableArray(extraProps.daysOfWeek), [day]) : extraProps.daysOfWeek.filter(function (thisDay) {
            return thisDay !== day;
          });
          onTextFieldChangeWithKeyPath({ keyPath: [].concat(basePath, ['daysOfWeek']), value: newDaysOfWeek });
        }
      }
    })),
    productType === 'Accommodation' ? _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_typeControlledTextfield2.default, {
        id: 'maxAdultsPlusChild' + data.rateSetsIndex,
        controlledType: 'number',
        style: { display: 'inline-block', width: '50%' },
        hintStyle: { fontSize: '14px' },
        floatingLabelShrinkStyle: { color: 'rgba(0, 0, 0, 0.64)' },
        inputStyle: { fontSize: '14px' },
        hintText: 'Whole number only',
        floatingLabelText: 'Max Occupancy (Adults + Children)',
        value: maxAdultsPlusChild,
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;

          onTextFieldChangeWithKeyPath({
            keyPath: [].concat(basePath, ['rates']),
            value: extraProps.rates.map(function (rate) {
              return _extends({}, rate, { maxAdultsPlusChild: value });
            })
          });
        }
      }),
      _react2.default.createElement(
        'span',
        { style: { color: 'red', marginLeft: '5px', fontSize: '24px', verticalAlign: 'bottom' } },
        ' *'
      )
    ) : _react2.default.createElement('div', null),
    _react2.default.createElement(_taxCurrencyCommissionForm2.default, {
      taxInclusion: extraProps.taxInclusion,
      taxType: extraProps.taxType,
      currency: extraProps.currency,
      rateType: extraProps.rateType,
      commissionPercentage: extraProps.commissionPercentage,
      nettCommission: extraProps.nettCommission,
      updateFunc: function updateFunc(field, value) {
        if (['taxInclusion', 'taxType', 'currency'].indexOf(field) > -1) {
          updateFormData({ keyPath: [].concat(basePath, [field]), fieldName: field, value: value.trim() }, 'ON_CHANGE_TEXTFIELD_WITH_KEYPATH_IN_ADD_EDIT_DIALOG', 'location');
        } else {
          onTextFieldChangeWithKeyPath({
            keyPath: [].concat(basePath, [field]),
            value: value
          });
        }
      }
    }),
    _react2.default.createElement(
      'small',
      { style: { color: 'red', display: 'block' } },
      extraProps.ratesTableError
    ),
    _react2.default.createElement(
      'div',
      { style: { width: '75%' } },
      _react2.default.createElement(_rateTableTemplateContainer2.default, {
        productType: productType,
        showHeader: true,
        withEditableCell: true,
        rateSet: extraProps,
        updateTableCell: function updateTableCell(payload) {
          return _updateTableCell(_extends({}, payload, { pathToRates: basePath }));
        },
        contractState: contractState,
        addRateDetails: function addRateDetails(newRates) {
          return onTextFieldChangeWithKeyPath({
            keyPath: [].concat(basePath, ['rates']),
            value: newRates
          });
        }
      })
    ),
    Boolean(invalidRateDescrs && invalidRateDescrs.length) && _react2.default.createElement(
      'div',
      { style: { color: '#ff6200', width: '75%' } },
      'The bedding configuration added for this room type does not allow for',
      invalidRateDescrs.length === 1 ? ' a' : '',
      ' ',
      invalidRateDescrs.join('/'),
      ' ',
      (0, _pluralize2.default)('rate', invalidRateDescrs.length),
      '. Please update your bedding configuration in the Profile, or unselect ',
      invalidRateDescrs.join('/'),
      ' as applicable.'
    )
  );
};

exports.default = EditRateSet;

/***/ }),
/* 3310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _addRatesetWizard = __webpack_require__(3311);

var _addRatesetWizard2 = _interopRequireDefault(_addRatesetWizard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddRateSet = function AddRateSet(_ref) {
  var onRequestClose = _ref.onRequestClose,
      productName = _ref.productName,
      usedRateSetNamesAndCodes = _ref.usedRateSetNamesAndCodes,
      productType = _ref.productType,
      onFinish = _ref.onFinish,
      getOverlappingDaysError = _ref.getOverlappingDaysError,
      openGlobalAlert = _ref.openGlobalAlert;

  return _react2.default.createElement(_addRatesetWizard2.default, {
    cancelText: 'Cancel',
    productName: productName,
    usedRateSetNamesAndCodes: usedRateSetNamesAndCodes,
    getOverlappingDaysError: getOverlappingDaysError,
    onFinish: onFinish,
    cancelFunc: function cancelFunc() {
      openGlobalAlert({
        text: 'You will lose all the data you just entered if you cancel now. Are you sure you want to cancel?',
        onOk: onRequestClose
      });
    },
    showStepOneBack: false,
    step3ContinueText: 'add rate set',
    productType: productType
  });
};

AddRateSet.propTypes = {
  onRequestClose: _react.PropTypes.func,
  data: _react.PropTypes.object,
  onTextFieldChangeWithKeyPath: _react.PropTypes.func,
  productType: _react.PropTypes.string,
  productName: _react.PropTypes.string,
  clearWizard: _react.PropTypes.func,
  getOverlappingDaysError: _react.PropTypes.func
};

var mapActions = {
  clearWizard: function clearWizard() {
    return { type: 'CLEAR_ADD_RATE_SET_WIZARD' };
  },
  openGlobalAlert: function openGlobalAlert(payload) {
    return {
      type: 'open_global_alert',
      payload: payload
    };
  }
};
exports.default = (0, _reactRedux.connect)(null, mapActions)(AddRateSet);

/***/ }),
/* 3311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _stepperWizard = __webpack_require__(1139);

var _stepperWizard2 = _interopRequireDefault(_stepperWizard);

var _allFourStepsDumb = __webpack_require__(1972);

var _allFourStepsDumb2 = _interopRequireDefault(_allFourStepsDumb);

var _reactRedux = __webpack_require__(6);

var _ratesWizardActions = __webpack_require__(1549);

var _rootActionsMap = __webpack_require__(1135);

var _rootActionsMap2 = _interopRequireDefault(_rootActionsMap);

var _userInputActions = __webpack_require__(1002);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AddRateSetStepper = function AddRateSetStepper(props) {
  var addRateSetStepperComponentIndex = props.addRateSetStepperComponentIndex,
      goToStep = props.goToStep,
      extraProps = _objectWithoutProperties(props, ['addRateSetStepperComponentIndex', 'goToStep']);

  var stepNames = ['Rate Set Info', 'Add Rates', 'Review & Add'];
  var feedAllFourSteps = _extends({}, extraProps, {
    goToNextStep: function goToNextStep(componentIndex) {
      return goToStep({ stepperWizardName: 'addRateSetStepper', componentIndex: componentIndex + 1 });
    },
    goToPreviousStep: function goToPreviousStep(componentIndex) {
      return goToStep({ stepperWizardName: 'addRateSetStepper', componentIndex: componentIndex - 1 });
    }
  });
  return _react2.default.createElement(
    _stepperWizard2.default,
    {
      steps: stepNames,
      componentIndex: addRateSetStepperComponentIndex,
      showStepsBar: true
    },
    _react2.default.createElement(_allFourStepsDumb2.default, _extends({}, feedAllFourSteps, { index: 0 })),
    _react2.default.createElement(_allFourStepsDumb2.default, _extends({}, feedAllFourSteps, { index: 1 })),
    _react2.default.createElement(_allFourStepsDumb2.default, _extends({}, feedAllFourSteps, { index: 2 }))
  );
};

AddRateSetStepper.propTypes = {
  addRateSetStepperComponentIndex: _react.PropTypes.number,
  fieldValues: _react.PropTypes.object,
  updateFieldValue: _react.PropTypes.func,
  updateDaysOfWeek: _react.PropTypes.func,
  updateRatesTableCell: _react.PropTypes.func,
  calculateRatesTable: _react.PropTypes.func,
  goToStep: _react.PropTypes.func,
  onFinish: _react.PropTypes.func,
  cancelFunc: _react.PropTypes.func,
  showStepOneBack: _react.PropTypes.bool,
  stepOneBackFunc: _react.PropTypes.func,
  step3ContinueText: _react.PropTypes.string,
  cancelText: _react.PropTypes.string,
  usedRateSetNamesAndCodes: _react.PropTypes.array,
  getOverlappingDaysError: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting;
  return {
    addRateSetStepperComponentIndex: contracting.steppers.get('addRateSetStepper'),
    fieldValues: _extends({}, contracting.addRateSetWizard.toJS(), {
      productId: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productId']),
      locationId: contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId'])
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    goToStep: function goToStep(payload) {
      return dispatch({ type: 'CHANGE_STEPPER_WIZARD_STEP', payload: payload });
    },
    updateFieldValue: function updateFieldValue(payload) {
      return dispatch({ type: 'UPDATE_ADD_RATES_FIELD', payload: payload });
    },
    updateFieldWithKeyPath: function updateFieldWithKeyPath(payload) {
      return dispatch({ type: 'UPDATE_ADD_RATES_FIELD_WITH_KEYPATH', payload: payload });
    },
    updateDaysOfWeek: function updateDaysOfWeek(payload) {
      return dispatch({ type: 'UPDATE_ADD_RATES_DAYSOFWEEK', payload: payload });
    },
    updateRatesTableCell: function updateRatesTableCell(payload) {
      return dispatch({ type: 'UPDATE_ADD_RATES_RATES_TABLE_CELL_VALUE', payload: payload });
    },
    calculateRatesTable: function calculateRatesTable() {
      return dispatch({ type: 'CALCULATE_RATES_TABLE' });
    },
    calculateStandardNonAccomRateTable: function calculateStandardNonAccomRateTable() {
      return dispatch({ type: 'CALCULATE_STANDARD_NON_ACCOM_RATES_TABLE' });
    },
    updateFormData: function updateFormData() {
      return dispatch(_ratesWizardActions.updateFormData.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddRateSetStepper);

/***/ }),
/* 3312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _rules = __webpack_require__(1979);

var _rules2 = _interopRequireDefault(_rules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleCancellationPolicy = function SingleCancellationPolicy(_ref) {
  var index = _ref.index,
      cancelNum = _ref.cancelNum,
      cancelHoursDays = _ref.cancelHoursDays,
      conditions = _ref.conditions,
      additionalRules = _ref.additionalRules,
      onTextFieldChange = _ref.onTextFieldChange,
      showError = _ref.showError;

  return _react2.default.createElement(
    'div',
    null,
    'Same as location cancellation policy:',
    _react2.default.createElement(
      _materialUi.RadioButtonGroup,
      {
        name: 'sameAsLocation',
        valueSelected: conditions === 'Same as location cancellation policy' ? 'yes' : 'no',
        style: { display: 'inline-block', position: 'relative', top: '6px', marginLeft: '15px' },
        onChange: function onChange(_, val) {
          return onTextFieldChange(index, 'conditions', val === 'yes' ? 'Same as location cancellation policy' : '');
        }
      },
      _react2.default.createElement(_materialUi.RadioButton, { label: 'Yes', value: 'yes', style: { display: 'inline-block', width: '75px' } }),
      _react2.default.createElement(_materialUi.RadioButton, { label: 'No', value: 'no', style: { display: 'inline-block', width: '65px' } })
    ),
    _react2.default.createElement(
      'div',
      { style: { display: conditions === 'Same as location cancellation policy' ? 'none' : 'block' } },
      _react2.default.createElement(_rules2.default, {
        cancelNum: cancelNum,
        cancelHoursDays: cancelHoursDays,
        conditions: conditions,
        additionalRules: additionalRules,
        onChange: function onChange(key, value) {
          return onTextFieldChange(index, key, value);
        },
        showError: showError
      })
    )
  );
};

exports.default = SingleCancellationPolicy;

/***/ }),
/* 3313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _titlecase = __webpack_require__(549);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _cancellationPolicies = __webpack_require__(1980);

var _cancellationPolicies2 = _interopRequireDefault(_cancellationPolicies);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = (0, _ramda.either)(_ramda.isNil, _ramda.isEmpty);
var AddProductPolicy = function AddProductPolicy(_ref) {
  var type = _ref.type,
      onRequestClose = _ref.onRequestClose,
      onTextFieldChange = _ref.onTextFieldChange,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      contractId = _ref.contractId,
      productId = _ref.productId,
      saveProductInfoChanges = _ref.saveProductInfoChanges,
      data = _ref.data,
      saving = _ref.saving,
      existingSeasons = _ref.existingSeasons,
      contractingPeriod = _ref.contractingPeriod,
      productType = _ref.productType;

  var toGreaterThanFrom = function toGreaterThanFrom(fromAge, toAge) {
    return fromAge > toAge ? 'Invalid age range' : '';
  };
  var propForCancellation = {
    existingSeasons: existingSeasons,
    onTextFieldChangeWithKeyPath: onTextFieldChangeWithKeyPath,
    data: data,
    contractingPeriod: contractingPeriod,
    productType: productType
  };
  var ages = [];
  for (var i = 0; i < 22; i++) {
    ages.push(_react2.default.createElement(_materialUi.MenuItem, { value: i, key: i, primaryText: '' + i }));
  }
  var agesForInfantAndChild = _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'p',
      { style: { float: 'left', margin: '3% 0% 0% 4.7%', fontSize: '14px' } },
      'From'
    ),
    _react2.default.createElement(
      _materialUi.SelectField,
      {
        style: { margin: '4px 0px 20px 10px', width: '23%', float: 'left' },
        hintText: data.selectedPolicy.policyType === 'child' ? '2' : '0',
        value: data.selectedPolicy.ageFrom,
        onChange: function onChange(event, index, value) {
          return onTextFieldChange({ key: 'ageFrom', value: value, updateProductPolicy: true });
        },
        maxHeight: 200,
        errorText: data.selectedPolicy.ageTo ? toGreaterThanFrom(data.selectedPolicy.ageFrom, data.selectedPolicy.ageTo) : ''
      },
      ages
    ),
    _react2.default.createElement(
      'p',
      { style: { float: 'left', margin: '3% 0% 0% 4.5%', fontSize: '14px' } },
      'To'
    ),
    _react2.default.createElement(
      _materialUi.SelectField,
      {
        style: { margin: '4px 0px 20px 10px', width: '23%', float: 'left' },
        hintText: data.selectedPolicy.policyType === 'child' ? '15' : '1',
        value: data.selectedPolicy.ageTo,
        onChange: function onChange(event, index, value) {
          return onTextFieldChange({ key: 'ageTo', value: value, updateProductPolicy: true });
        },
        maxHeight: 200,
        errorText: data.selectedPolicy.ageTo ? toGreaterThanFrom(data.selectedPolicy.ageFrom, data.selectedPolicy.ageTo) : ''
      },
      ages
    ),
    _react2.default.createElement(
      'p',
      { style: { float: 'left', margin: '3% 0% 0% 4.5%', fontSize: '14px' } },
      '(inclusive)'
    )
  );

  var _ref2 = function () {
    var policyType = data.selectedPolicy ? data.selectedPolicy.policyType : '';
    switch (policyType) {
      case 'cancellation':
        return {
          additionalDiv: _react2.default.createElement(_cancellationPolicies2.default, propForCancellation),
          note: 'Your cancellation policy tells your partners when, and how much, they will be charged for cancelling a booking.',
          example: ''
        };
      case 'group':
        return {
          additionalDiv: _react2.default.createElement('div', null),
          note: 'Please note any special conditions or policies that apply for group bookings. If you have policies for specific seasons, please note them below.',
          example: ''
        };
      case 'family':
        return {
          additionalDiv: _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_typeControlledTextfield2.default, {
              controlledType: 'number',
              style: { marginLeft: '20px', width: '30%', marginBottom: '20px', float: 'left' },
              floatingLabelText: 'Number of Adults',
              floatingLabelStyle: { fontSize: '12px' },
              value: data.selectedPolicy.adultCount,
              onChange: function onChange(_ref3) {
                var value = _ref3.target.value;
                return onTextFieldChange({ key: 'adultCount', value: value, updateProductPolicy: true });
              }
            }),
            _react2.default.createElement(
              'p',
              { style: { float: 'left', margin: '9% 0% 0% 2%', fontSize: '14px' } },
              'Adults'
            ),
            _react2.default.createElement(_typeControlledTextfield2.default, {
              controlledType: 'number',
              style: { marginLeft: '10px', width: '30%', marginBottom: '20px', float: 'left' },
              floatingLabelText: 'Number of Children',
              floatingLabelStyle: { fontSize: '12px' },
              value: data.selectedPolicy.childrenCount,
              onChange: function onChange(_ref4) {
                var value = _ref4.target.value;
                return onTextFieldChange({ key: 'childrenCount', value: value, updateProductPolicy: true });
              }
            }),
            _react2.default.createElement(
              'p',
              { style: { float: 'left', margin: '9% 0% 0% 2%', fontSize: '14px' } },
              'Children'
            )
          ),
          cap: 'Family',
          note: 'If you have policies for specific seasons, please note them below.',
          example: 'Ex: Family Policy: 2 Adults and 2 Children.'
        };
      case 'freeOfCharge':
        return {
          additionalDiv: _react2.default.createElement('div', null),
          note: 'On occasion, your partners will have tour leaders, escorts, or guides accompany a group. Please note any conditions in which they will not be charged as part of the booking. If you have policies for specific seasons, please note them below.',
          example: ''
        };
      case 'child':
        return {
          additionalDiv: _react2.default.createElement(
            'div',
            { style: { display: 'flex', flexDirection: 'column' } },
            agesForInfantAndChild,
            _react2.default.createElement(_materialUi.Checkbox, {
              checked: Boolean(data.selectedPolicy.focChildrenAllowed),
              onCheck: function onCheck() {
                return onTextFieldChange({ key: 'focChildrenAllowed', value: !data.selectedPolicy.focChildrenAllowed, updateProductPolicy: true });
              },
              style: { marginLeft: '16px', width: '90%' },
              label: 'Children Free of Charge (FOC) when sharing existing bedding with adults'
            }),
            _react2.default.createElement(
              'div',
              { style: { display: Boolean(data.selectedPolicy.focChildrenAllowed) ? 'flex' : 'none', alignItems: 'center', marginLeft: '56px' } },
              _react2.default.createElement(_materialUi.TextField, { type: 'number', hintText: 'Number', id: 'focChildrenCount', value: data.selectedPolicy.focChildrenCount, style: { width: '100px' }, onChange: function onChange(_ref5) {
                  var value = _ref5.target.value;
                  return onTextFieldChange({ key: 'focChildrenCount', value: value, updateProductPolicy: true });
                } }),
              '\xA0 free children ',
              _react2.default.createElement(
                'span',
                { style: { color: 'red' } },
                ' * Required'
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_materialUi.Checkbox, {
              checked: Boolean(data.selectedPolicy.childrenNotAccepted),
              onCheck: function onCheck() {
                return onTextFieldChange({ key: 'childrenNotAccepted', value: !data.selectedPolicy.childrenNotAccepted, updateProductPolicy: true });
              },
              style: { marginLeft: '16px', width: '90%' },
              label: 'Children not accepted'
            }),
            _react2.default.createElement('br', null)
          ),
          note: 'If you have policies for specific seasons, please note them below.',
          textAboveTextField: 'Please note any other conditions related to your Child Policy. For example, if a cot or rollaway is required, you will be charged for the additional bedding.'
        };
      case 'infant':
        return {
          additionalDiv: _react2.default.createElement(
            'div',
            { style: { display: 'flex', flexDirection: 'column' } },
            agesForInfantAndChild,
            _react2.default.createElement(_materialUi.Checkbox, {
              checked: Boolean(data.selectedPolicy.infantAsOccupant),
              style: { marginLeft: '16px', width: '90%' },
              onCheck: function onCheck() {
                return onTextFieldChange({ key: 'infantAsOccupant', value: !data.selectedPolicy.infantAsOccupant, updateProductPolicy: true });
              },
              label: 'Infant counts as an occupant'
            })
          ),
          note: 'If you have policies for specific seasons, please note them below.',
          example: ''
        };
      default:
        return _react2.default.createElement('div', null);
    }
  }(),
      additionalDiv = _ref2.additionalDiv,
      note = _ref2.note,
      example = _ref2.example,
      textAboveTextField = _ref2.textAboveTextField;

  var emptyPolicies = ['group', 'freeOfCharge', 'family', 'child', 'infant'].filter(function (policyType) {
    return data.productPolicy.every(function (policy) {
      return policy.policyType !== policyType;
    });
  });
  var checkIfShouldDisable = function checkIfShouldDisable(dataInfo) {
    var selectedPolicy = (0, _ramda.propOr)({}, 'selectedPolicy', dataInfo);
    var policyType = selectedPolicy.policyType,
        adultCount = selectedPolicy.adultCount,
        childrenCount = selectedPolicy.childrenCount,
        ageFrom = selectedPolicy.ageFrom,
        ageTo = selectedPolicy.ageTo,
        conditions = selectedPolicy.conditions;

    var cancellations = (0, _ramda.propOr)([{}], 'cancellations', selectedPolicy);
    var isCancellationNotValid = (0, _ramda.complement)((0, _ramda.anyPass)([(0, _ramda.allPass)([(0, _ramda.prop)('cancelNum'), (0, _ramda.prop)('cancelHoursDays'), (0, _ramda.prop)('conditions')]), (0, _ramda.propEq)('conditions', 'Same as location cancellation policy')]));
    var cancellationsNotValid = function cancellationsNotValid() {
      var allDateRanges = _dateUtils2.default.getFlattenedUnEmptyDates(cancellations);
      var seasonCovered = _dateUtils2.default.seasonCovered(allDateRanges, contractingPeriod);
      return (0, _ramda.or)((0, _ramda.any)(isCancellationNotValid, cancellations), (0, _ramda.not)(seasonCovered));
    };
    var familyPolicyNotValid = function familyPolicyNotValid() {
      return (0, _ramda.any)(isNilOrEmpty, [adultCount, childrenCount]);
    };
    var infantPolicyNotValid = function infantPolicyNotValid() {
      return (0, _ramda.any)(isNilOrEmpty, [ageFrom, ageTo]);
    };
    var childPolicyNotValid = function childPolicyNotValid() {
      return (0, _ramda.call)((0, _ramda.anyPass)([function () {
        return ageFrom == null || ageFrom === false || ageTo == null || ageTo === false;
      }, // == includes undefined check
      function () {
        return selectedPolicy.focChildrenAllowed && !selectedPolicy.focChildrenCount;
      }]));
    };
    return (0, _ramda.call)((0, _ramda.cond)([[(0, _ramda.equals)('cancellation'), cancellationsNotValid], [(0, _ramda.equals)('family'), familyPolicyNotValid], [(0, _ramda.equals)('child'), childPolicyNotValid], [(0, _ramda.equals)('infant'), infantPolicyNotValid], [_ramda.T, function () {
      return !conditions;
    }]]), policyType);
  };
  var shouldDisable = checkIfShouldDisable(data);

  return _react2.default.createElement(
    'div',
    { style: { padding: '16px', minHeight: '250px' } },
    _react2.default.createElement(
      'div',
      null,
      emptyPolicies.length < 1 || (0, _ramda.equals)(type, 'editProductPolicy') || data.selectedPolicy.policyType === 'cancellation' ? _react2.default.createElement('div', null) : _react2.default.createElement(
        _materialUi.SelectField,
        {
          style: { width: '90%', marginLeft: '20px' },
          floatingLabelText: 'Please select the type of policy you want to add',
          floatingLabelStyle: { color: '#00bcd4' },
          value: data.selectedPolicy.policyType,
          onChange: function onChange(e, _, value) {
            return onTextFieldChange({ key: 'policyType', value: value, updateProductPolicy: true });
          }
        },
        emptyPolicies.map(function (policyType, index) {
          var primaryText = policyType === 'freeOfCharge' ? 'Free of Charge Policy' : (0, _titlecase.toLaxTitleCase)(policyType) + ' Policy';
          return _react2.default.createElement(_materialUi.MenuItem, { value: policyType, key: index, primaryText: primaryText });
        })
      ),
      data.selectedPolicy.policyType ? _react2.default.createElement(
        'div',
        { style: { fontSize: '12px' } },
        _react2.default.createElement(
          'div',
          { style: { width: '90%', margin: '16px 16px 0 16px' } },
          note
        ),
        additionalDiv,
        _react2.default.createElement(
          'i',
          { style: { marginLeft: '20px', float: 'left', width: '90%', fontSize: '14px', color: 'rgba(0, 0, 0, 0.54)' } },
          textAboveTextField
        ),
        data.selectedPolicy.policyType !== 'cancellation' ? _react2.default.createElement(_materialUi.TextField, {
          id: 'product policy conditions',
          style: { marginLeft: '20px', width: '90%', marginBottom: '20px' },
          defaultValue: data.selectedPolicy.conditions,
          hintText: example,
          multiLine: true,
          rowsMax: 4,
          onChange: function onChange(_ref6) {
            var value = _ref6.target.value;
            return onTextFieldChange({ key: 'conditions', value: value, updateProductPolicy: true });
          }
        }) : ''
      ) : undefined
    ),
    _react2.default.createElement(_stepperActions2.default, { rightButtons: _react2.default.createElement(
        'div',
        { style: { marginTop: Object.keys(data.selectedPolicy).length ? '' : '150px' } },
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Cancel',
          hoverColor: 'none',
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onTouchTap: onRequestClose
        }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Save',
          loader: saving,
          hoverColor: 'none',
          labelStyle: { fontWeight: '600' },
          onTouchTap: function onTouchTap() {
            return saveProductInfoChanges({
              contractId: contractId,
              productId: productId,
              data: data,
              updateType: (0, _ramda.call)((0, _ramda.ifElse)((0, _ramda.equals)('editProductPolicy'), (0, _ramda.always)('SAVED_EDITED_PRODUCT_POLICY'), (0, _ramda.always)('SAVED_PRODUCT_POLICY')), type) });
          },
          secondary: true,
          disabled: shouldDisable
        })
      )
    })
  );
};

AddProductPolicy.propTypes = {
  onRequestClose: _react.PropTypes.func,
  onTextFieldChange: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  productId: _react.PropTypes.string,
  saveProductInfoChanges: _react.PropTypes.func,
  data: _react.PropTypes.object,
  saving: _react.PropTypes.bool
};
var mapStateToProps = function mapStateToProps(_ref7) {
  var contracting = _ref7.contracting;
  return {
    type: contracting.addEditContractDialog.get('type')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddProductPolicy);

/***/ }),
/* 3314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _datePickerSet = __webpack_require__(1140);

var _datePickerSet2 = _interopRequireDefault(_datePickerSet);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _materialUi = __webpack_require__(3);

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _syncSectionCheckbox = __webpack_require__(1004);

var _syncSectionCheckbox2 = _interopRequireDefault(_syncSectionCheckbox);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Blackouts = function Blackouts(_ref) {
  var onRequestClose = _ref.onRequestClose,
      contractingPeriod = _ref.contractingPeriod,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      contractId = _ref.contractId,
      productId = _ref.productId,
      saveProductInfoChanges = _ref.saveProductInfoChanges,
      data = _ref.data,
      saving = _ref.saving;

  var blackoutsLength = _ramda2.default.pathOr(0, ['blackouts', 'length'], data);
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex', flexDirection: 'column', justifyContent: 'space-between' } },
    _react2.default.createElement(
      'div',
      { style: { padding: '0 32px 16px' } },
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'small',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Enter a blackout date to let your partners know which dates you are not operating or accepting bookings; for instance, if you are closed on Christmas Day, you can add it as a blackout date.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Tip: If your blackout has just one date, you can select the start date only.'
        )
      ),
      data.blackouts.map(function (blackout, index) {
        var initialStartDateMonth = function () {
          if (blackout.startDate) return blackout.startDate;
          if (blackout.endDate) return blackout.endDate;
          if (blackoutsLength > 1 && index) return data.blackouts[index - 1].endDate || data.blackouts[index - 1].startDate;
          return contractingPeriod.startDate;
        }();
        var initialEndDateMonth = function () {
          if (blackout.endDate) return blackout.endDate;
          if (blackout.startDate) return blackout.startDate;
          if (blackoutsLength > 1 && index) return data.blackouts[index - 1].endDate || data.blackouts[index - 1].startDate;
          return contractingPeriod.startDate;
        }();
        return _react2.default.createElement(
          'div',
          { key: blackout.dataKey, style: { marginBottom: index === blackoutsLength - 1 ? '20px' : '0' } },
          _react2.default.createElement(_datePickerSet2.default, {
            showTextField: true,
            endDateCloseOnSelect: true,
            startDateCloseOnSelect: true,
            disableDeleteButton: blackoutsLength === 1,
            textFieldStyle: { display: 'inline-block', width: '20%', fontSize: '12px' },
            startDateContainerStyle: { display: 'inline-block', marginLeft: '3%', width: '25%' },
            startDateTextFieldStyle: { width: '100%', fontSize: '12px' },
            endDateContainerStyle: { display: 'inline-block', marginLeft: '3%', width: '25%' },
            endDateTextFieldStyle: { width: '100%', fontSize: '12px' },
            addButtonStyle: { marginLeft: '16px', lineHeight: '24px', verticalAlign: 'middle' },
            deleteButtonStyle: { marginLeft: '16px', lineHeight: '24px', verticalAlign: 'middle' },
            textFieldFloatingText: 'Name',
            startDateFloatingText: 'Start Date',
            endDateFloatingText: 'End Date',
            initialStartDateMonth: initialStartDateMonth,
            startDateEnableFrom: contractingPeriod.startDate,
            startDateEnableTo: contractingPeriod.endDate,
            initialEndDateMonth: initialEndDateMonth,
            endDateEnableFrom: blackout.startDate || contractingPeriod.startDate,
            endDateEnableTo: contractingPeriod.endDate,
            textFieldValue: blackout.name,
            startDate: blackout.startDate,
            endDate: blackout.endDate,
            textFieldOnChange: function textFieldOnChange(e) {
              return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'blackouts', index, 'name'], value: e.target.value });
            },
            onChangeStartDate: function onChangeStartDate(value) {
              return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'blackouts', index, 'startDate'], value: value });
            },
            onChangeEndDate: function onChangeEndDate(value) {
              return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'blackouts', index, 'endDate'], value: value });
            },
            onDelete: function onDelete() {
              return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'blackouts'], value: (0, _ramda.remove)(index, 1, data.blackouts) });
            },
            onAdd: function onAdd() {
              return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'blackouts'], value: (0, _ramda.insert)(index + 1, { dataKey: _nodeUuid2.default.v1() }, data.blackouts) });
            },
            startDateErrorText: data.startDateRequired && !blackout.startDate ? data.startDateRequired : ''
          }),
          blackout.startDate && blackout.endDate && _dateUtils2.default.notInContractingPeriod([blackout], contractingPeriod.startDate, contractingPeriod.endDate) ? _react2.default.createElement(
            'div',
            { style: { color: '#f44336', fontSize: '12px', display: 'flex', width: '80%', alignItems: 'center', marginBottom: '12px' } },
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-report', style: { color: '#f44336', marginRight: '4px' } }),
            'Not in contracting period, please UPDATE or REMOVE'
          ) : _react2.default.createElement('span', null)
        );
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', justifyContent: 'space-between', padding: '0px 8px 0px 12px' } },
      _react2.default.createElement(_syncSectionCheckbox2.default, {
        sectionInEdit: 'blackouts',
        labelStyle: { width: '70%' },
        style: { width: '55%', top: '6px' }
      }),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Cancel',
          labelStyle: { fontWeight: '600' },
          primary: true,
          onTouchTap: onRequestClose
        }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Save',
          loader: saving,
          labelStyle: { fontWeight: '600' },
          onTouchTap: function onTouchTap() {
            if (data.blackouts.some(function (blackout) {
              return !blackout.startDate && (blackout.endDate || blackout.name);
            })) onTextFieldChangeWithKeyPath({ keyPath: ['data', 'startDateRequired'], value: 'Required' });else saveProductInfoChanges({ contractId: contractId, productId: productId, data: data, updateType: 'SAVED_BLACKOUT_DAYS' });
          },
          secondary: true
        })
      )
    )
  );
};

Blackouts.propTypes = {};

exports.default = Blackouts;

/***/ }),
/* 3315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _singlePickupdropoff = __webpack_require__(3316);

var _singlePickupdropoff2 = _interopRequireDefault(_singlePickupdropoff);

var _seasonalSections = __webpack_require__(1555);

var _seasonalSections2 = _interopRequireDefault(_seasonalSections);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _validations = __webpack_require__(871);

var _ramda = __webpack_require__(2);

var _syncSectionCheckbox = __webpack_require__(1004);

var _syncSectionCheckbox2 = _interopRequireDefault(_syncSectionCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditPickupDropoff = function EditPickupDropoff(_ref) {
  var contractingPeriod = _ref.contractingPeriod,
      onRequestClose = _ref.onRequestClose,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      existingSeasons = _ref.existingSeasons,
      contractId = _ref.contractId,
      productId = _ref.productId,
      saveProductInfoChanges = _ref.saveProductInfoChanges,
      data = _ref.data,
      saving = _ref.saving;

  var pickupOrDropoffText = (0, _ramda.propOr)('', 'pickupOrDropoff', data);
  var contentsData = (0, _ramda.propOr)([], pickupOrDropoffText, data);
  var contentActions = { onTextFieldChangeWithKeyPath: onTextFieldChangeWithKeyPath, pickupOrDropoff: pickupOrDropoffText };
  var allDateRanges = _dateUtils2.default.getFlattenedUnEmptyDates(contentsData);
  var seasonCovered = _dateUtils2.default.seasonCovered(allDateRanges, contractingPeriod);
  var onFieldChange = (0, _ramda.curry)(function (extraPaths, value) {
    return onTextFieldChangeWithKeyPath({ keyPath: (0, _ramda.concat)(['data', pickupOrDropoffText], extraPaths), value: value });
  });
  var checkIfTimeValid = function checkIfTimeValid() {
    return contentsData.some(function (obj) {
      return obj.timeLocArray.some(function (timeLoc) {
        return (timeLoc.time || '').split(';').filter(function (x) {
          return x && Boolean(x.trim());
        }).some(function (str) {
          return !(0, _validations.isValidTime)(str);
        });
      });
    });
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_seasonalSections2.default, {
      name: pickupOrDropoffText + ' information',
      enableManualDatesEntry: true,
      seasons: existingSeasons,
      contractingPeriod: contractingPeriod,
      varyBySeason: data.varyBySeason,
      useSeasons: data.useSeasons,
      contentsData: contentsData,
      emptyInitialContent: { notes: '', timeLocArray: [{}] },
      onFieldChange: onFieldChange,
      contentActions: contentActions,
      ContentNode: _singlePickupdropoff2.default
    }),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'div',
      { className: 'flex-tc-sb', style: { paddingLeft: '20px' } },
      _react2.default.createElement(_syncSectionCheckbox2.default, {
        style: { width: '350px' },
        sectionInEdit: pickupOrDropoffText
      }),
      _react2.default.createElement(
        'div',
        { className: 'flex-center' },
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Cancel',
          hoverColor: 'none',
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onTouchTap: onRequestClose
        }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Save',
          loader: saving,
          hoverColor: 'none',
          disabled: !seasonCovered || checkIfTimeValid(),
          labelStyle: { fontWeight: '600' },
          onTouchTap: function onTouchTap() {
            return saveProductInfoChanges({ contractId: contractId, productId: productId, data: data, updateType: 'SAVE_PICKUP_DROPOFF_INFO' });
          },
          secondary: true
        })
      )
    )
  );
};
exports.default = EditPickupDropoff;

/***/ }),
/* 3316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

var _validations = __webpack_require__(871);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SinglePickupDropoff = function SinglePickupDropoff(_ref) {
  var index = _ref.index,
      notes = _ref.notes,
      pickupOrDropoff = _ref.pickupOrDropoff,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      timeLocArray = _ref.timeLocArray;

  var baseKeyPath = ['data', pickupOrDropoff, index];
  var array = !timeLocArray || _ramda2.default.isEmpty(timeLocArray) ? [{}] : _ramda2.default.clone(timeLocArray);
  return _react2.default.createElement(
    'div',
    null,
    array.map(function (_ref2, i) {
      var time = _ref2.time,
          location = _ref2.location;

      var disableDeleteButton = i === 0 && array.length === 1;
      var timeNotValid = Boolean(time) && time.split(';').filter(function (x) {
        return x && Boolean(x.trim());
      }).some(function (str) {
        return !(0, _validations.isValidTime)(str);
      });
      return _react2.default.createElement(
        'div',
        {
          key: i,
          className: 'flex-center',
          style: {}
        },
        _react2.default.createElement(
          'div',
          {
            style: {
              border: '1px dashed #e0e0e0',
              width: '80%',
              padding: '16px',
              marginBottom: '16px',
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'space-between'
            }
          },
          _react2.default.createElement(
            'div',
            { style: { width: '90%' } },
            _react2.default.createElement(
              'div',
              { className: 'flex-center', style: { marginBottom: '8px' } },
              _react2.default.createElement(
                'label',
                { className: 'flex-center' },
                _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-location_on', style: { fontSize: '18px', color: 'rgba(0, 0, 0, 0.54)' } }),
                'Location:'
              ),
              _react2.default.createElement(
                'div',
                { style: { marginLeft: '16px', width: '85%', border: '1px solid #ccc', borderRadius: '3px' } },
                _react2.default.createElement('input', {
                  style: { padding: '4px', fontSize: '14px', border: 'none', width: '100%' },
                  value: location || '',
                  onChange: function onChange(_ref3) {
                    var value = _ref3.target.value;

                    onTextFieldChangeWithKeyPath({ keyPath: [].concat(baseKeyPath, ['timeLocArray', i, 'location']), value: value });
                  }
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'flex-center' },
              _react2.default.createElement(
                'label',
                { className: 'flex-center' },
                _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-watch_later', style: { fontSize: '18px', color: 'rgba(0, 0, 0, 0.54)' } }),
                'Time(s):'
              ),
              _react2.default.createElement(
                'div',
                { style: { width: '85%', marginLeft: '24px', border: '1px solid #ccc', borderRadius: '3px' } },
                _react2.default.createElement('input', {
                  style: { padding: '4px', fontSize: '14px', border: 'none', width: '100%' },
                  value: time || '',
                  onChange: function onChange(_ref4) {
                    var value = _ref4.target.value;

                    onTextFieldChangeWithKeyPath({ keyPath: [].concat(baseKeyPath, ['timeLocArray', i, 'time']), value: value });
                  }
                })
              )
            ),
            _react2.default.createElement('br', null),
            timeNotValid && _react2.default.createElement(
              'div',
              { style: { color: '#ff4081', marginBottom: '8px' } },
              'Please enter times with the correct format, such as: "8am; 4:30pm".'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'i',
                null,
                'Please separate times with a semicolon, such as: "4:00pm; 4:30pm".'
              )
            )
          ),
          _react2.default.createElement(_icon2.default, {
            className: 'tc-icon-close',
            style: {
              color: disableDeleteButton ? 'grey' : '#ff4081',
              cursor: disableDeleteButton ? 'normal' : 'pointer'
            },
            onClick: disableDeleteButton ? undefined : function () {
              return onTextFieldChangeWithKeyPath({ keyPath: [].concat(baseKeyPath, ['timeLocArray']), value: _ramda2.default.remove(i, 1, timeLocArray) });
            }
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'flex-tc-sb', style: { marginLeft: '8px', width: '60px' } },
          array.length - 1 === i && _react2.default.createElement(_icon2.default, {
            className: 'tc-icon-add',
            style: {
              border: '2px solid green',
              borderRadius: '50%',
              cursor: 'pointer'
            },
            onClick: function onClick() {
              return onTextFieldChangeWithKeyPath({ keyPath: [].concat(baseKeyPath, ['timeLocArray']), value: _ramda2.default.append({}, timeLocArray) });
            }
          })
        )
      );
    }),
    _react2.default.createElement('textarea', {
      style: { overflowX: 'hidden', width: '80%', marginBottom: '12px' },
      rows: 4,
      placeholder: 'Enter notes here...',
      defaultValue: notes,
      onChange: function onChange(_ref5) {
        var value = _ref5.target.value;
        return onTextFieldChangeWithKeyPath({ keyPath: [].concat(baseKeyPath, ['notes']), value: value });
      }
    })
  );
};

exports.default = SinglePickupDropoff;

/***/ }),
/* 3317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _importOptions = __webpack_require__(3318);

var _importOptions2 = _interopRequireDefault(_importOptions);

var _smallTemplateListActions = __webpack_require__(3321);

var _singleTemplate = __webpack_require__(1982);

var _singleTemplate2 = _interopRequireDefault(_singleTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImportFromTemplate = function (_React$Component) {
  _inherits(ImportFromTemplate, _React$Component);

  function ImportFromTemplate(props) {
    _classCallCheck(this, ImportFromTemplate);

    var _this = _possibleConstructorReturn(this, (ImportFromTemplate.__proto__ || Object.getPrototypeOf(ImportFromTemplate)).call(this, props));

    _this.goToImportOwn = function () {
      if (!(_this.props.templates && _this.props.templates.filter(function (t) {
        return (t.originalContractId || t._id) !== _this.props.contractId;
      }).length)) {
        _this.props.openGlobalAlert({
          text: 'You currently don\'t have templates available for import for this location/property.'
        });
      } else {
        _this.setState({ show: 'importOwn' });
      }
    };

    _this.goToImportOptions = function () {
      return _this.setState({ show: 'importOptions' });
    };

    _this.state = {
      searchInput: '',
      useCC: false,
      show: props.isTrueSupplier && !props.isAnAdmin ? 'importOwn' : 'importOptions'
    };
    return _this;
  }

  _createClass(ImportFromTemplate, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          getTemplatesForImport = _props.getTemplatesForImport,
          locationId = _props.locationId,
          locationName = _props.locationName;

      getTemplatesForImport(locationId, locationName);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.locationId !== nextProps.locationId) {
        var getTemplatesForImport = nextProps.getTemplatesForImport,
            locationId = nextProps.locationId,
            locationName = nextProps.locationName;

        getTemplatesForImport(locationId, locationName);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var show = this.state.show;
      var _props2 = this.props,
          _props2$data = _props2.data;
      _props2$data = _props2$data === undefined ? {} : _props2$data;
      var forNewDraft = _props2$data.forNewDraft,
          _props2$data$template = _props2$data.templateSelected,
          templateSelected = _props2$data$template === undefined ? {} : _props2$data$template,
          onTextFieldChangeWithKeyPath = _props2.onTextFieldChangeWithKeyPath,
          locationName = _props2.locationName,
          loadingTemplates = _props2.loadingTemplates,
          _props2$templates = _props2.templates,
          templates = _props2$templates === undefined ? [] : _props2$templates,
          _props2$templatesForC = _props2.templatesForCC,
          templatesForCC = _props2$templatesForC === undefined ? [] : _props2$templatesForC,
          contractId = _props2.contractId,
          openOmniImport = _props2.openOmniImport,
          onRequestClose = _props2.onRequestClose,
          importTemplate = _props2.importTemplate,
          isTrueSupplier = _props2.isTrueSupplier;

      var goToOmniImport = function goToOmniImport() {
        return openOmniImport(templatesForCC, locationName);
      };
      var doImport = function doImport() {
        return importTemplate({
          contractId: contractId,
          templateId: templateSelected._id || templateSelected.originalContractId,
          fieldsToImport: {
            locationFieldsToImport: ['General Terms & Conditions and Notes', 'Billing Information', 'Location Policies', 'Check-in and Check-out Information', 'Products']
          }
        });
      };
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          open: true,
          autoScrollBodyContent: true,
          titleStyle: _extends({
            padding: '12px 12px 10px'
          }, show === 'importOptions' ? { background: '#00bcd4', color: '#fff', textAlign: 'center', fontWeight: 'bold', display: 'block' } : {}),
          title: _react2.default.createElement(
            'div',
            { className: 'flex-center' },
            forNewDraft ? 'Add Rates' : 'Import Rates',
            show === 'importOwn' && _react2.default.createElement(
              _materialUi.Stepper,
              { activeStep: 1, style: { width: '80%' } },
              _react2.default.createElement(
                _materialUi.Step,
                null,
                _react2.default.createElement(
                  _materialUi.StepLabel,
                  { style: { height: '36px' } },
                  'Import Options'
                )
              ),
              _react2.default.createElement(
                _materialUi.Step,
                null,
                _react2.default.createElement(
                  _materialUi.StepLabel,
                  { style: { height: '36px' } },
                  'Select Template'
                )
              )
            )
          ),
          actionsContainerClassName: 'flex-tc-sb',
          actionsContainerStyle: show === 'importOptions' ? { display: 'flex', justifyContent: 'center' } : {},
          actions: show === 'importOptions' ? [_react2.default.createElement(_materialUi.RaisedButton, {
            key: 'dismiss',
            label: 'Dismiss',
            onClick: onRequestClose
          })] : [isTrueSupplier ? _react2.default.createElement('div', null) : _react2.default.createElement(_materialUi.RaisedButton, {
            key: 'back',
            label: 'Back',
            onClick: this.goToImportOptions
          }), _react2.default.createElement(
            'div',
            { key: 'action' },
            _react2.default.createElement(_materialUi.FlatButton, {
              label: 'dismiss',
              primary: true,
              onClick: onRequestClose
            }),
            _react2.default.createElement(_materialUi.FlatButton, {
              label: 'Import',
              secondary: true,
              onClick: doImport
            })
          )]
        },
        _react2.default.createElement(
          'div',
          null,
          function () {
            if (loadingTemplates && !(templates.length || templatesForCC.length)) {
              return _react2.default.createElement(
                'div',
                {
                  style: {
                    textAlign: 'center'
                  }
                },
                _react2.default.createElement(_materialUi.CircularProgress, { size: 90, thickness: 4 })
              );
            }
            if (show === 'importOptions') {
              return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_importOptions2.default, {
                  forNewDraft: forNewDraft,
                  templates: templates.filter(function (t) {
                    return (t.originalContractId || t._id) !== contractId;
                  }),
                  templatesForCC: templatesForCC.filter(function (t) {
                    return (t.originalContractId || t._id) !== contractId;
                  }),
                  docId: contractId,
                  goToOmniImport: goToOmniImport,
                  goToImportOwn: _this2.goToImportOwn,
                  onRequestClose: onRequestClose
                }),
                _react2.default.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } })
              );
            }
            if (show === 'importOwn') {
              if (!templates.filter(function (t) {
                return (t.originalContractId || t._id) !== contractId;
              }).length) {
                return _react2.default.createElement(
                  'div',
                  { style: { lineHeight: '24px', color: '#000', marginTop: '1em' } },
                  'You don\'t have any rate sheet template available.'
                );
              }
              return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { style: { lineHeight: '24px', color: '#000', marginTop: '1em' } },
                  'Please select a rate sheet template:'
                ),
                templates.filter(function (t) {
                  return (t.originalContractId || t._id) !== contractId;
                }).map(function (t) {
                  return _react2.default.createElement(_singleTemplate2.default, {
                    key: t._id || t.originalContractId,
                    selected: templateSelected && (templateSelected.originalContractId ? templateSelected.originalContractId === t.originalContractId : templateSelected._id === t._id),
                    template: t,
                    onSelect: function onSelect() {
                      return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'templateSelected'], value: t });
                    },
                    onUnselect: function onUnselect() {
                      return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'templateSelected'], value: null });
                    }
                  });
                })
              );
            }
          }()
        )
      );
    }
  }]);

  return ImportFromTemplate;
}(_react2.default.Component);

ImportFromTemplate.propTypes = {
  data: _react.PropTypes.object,
  locationId: _react.PropTypes.string,
  locationName: _react.PropTypes.string,
  contractId: _react.PropTypes.string,
  loadingTemplates: _react.PropTypes.bool,
  backFunc: _react.PropTypes.func,
  onTextFieldChangeWithKeyPath: _react.PropTypes.func,
  templates: _react.PropTypes.array,
  templatesForCC: _react.PropTypes.array,
  getTemplatesForImport: _react.PropTypes.func,
  onRadioButtonClick: _react.PropTypes.func,
  clearStore: _react.PropTypes.func,
  openOmniImport: _react.PropTypes.func,
  onRequestClose: _react.PropTypes.func,
  openGlobalAlert: _react.PropTypes.func,
  productType: _react.PropTypes.string,
  importTemplate: _react.PropTypes.func,
  isTrueSupplier: _react.PropTypes.bool,
  isAnAdmin: _react.PropTypes.bool
};
var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user;
  return _extends({}, contracting.smallContractTemplateList.toJS(), {
    isTrueSupplier: user.getIn(['user', 'type']) === 'Supplier' && !user.get('isDummyAccount'),
    isAnAdmin: user.get('isAnAdmin')
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var forNewDraft = _ref2.data.forNewDraft;
  return {
    getTemplatesForImport: function getTemplatesForImport() {
      return dispatch(_smallTemplateListActions.getTemplatesForImport.apply(undefined, arguments));
    },
    clearStore: function clearStore() {
      return dispatch(_smallTemplateListActions.clearStore.apply(undefined, arguments));
    },
    openOmniImport: function openOmniImport(templatesForCC, locationName) {
      return dispatch({
        type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
        payload: {
          type: 'omniImport',
          data: {
            title: 'Omni Import',
            sourceTemplate: {},
            step: 'selectTemplate',
            matches: {},
            templates: templatesForCC,
            searchInput: locationName,
            forNewDraft: forNewDraft
          }
        }
      });
    },
    openGlobalAlert: function openGlobalAlert(payload) {
      return dispatch({
        type: 'open_global_alert',
        payload: payload
      });
    }
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ImportFromTemplate);

/***/ }),
/* 3318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _description = __webpack_require__(561);

var _description2 = _interopRequireDefault(_description);

var _lightbulbOutline = __webpack_require__(3319);

var _lightbulbOutline2 = _interopRequireDefault(_lightbulbOutline);

var _insertDriveFile = __webpack_require__(3320);

var _insertDriveFile2 = _interopRequireDefault(_insertDriveFile);

var _chevronRight = __webpack_require__(1204);

var _chevronRight2 = _interopRequireDefault(_chevronRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  cardDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '1em',
    width: '220px',
    cursor: 'pointer',
    transition: 'box-shadow 0.3s ease-in-out',
    borderRadius: '5px'
  },
  mainIcon: {
    height: '72px',
    width: '72px',
    color: 'rgba(0, 0, 0, 0.64)',
    display: 'block',
    transition: 'transform .3s ease-in-out'
  },
  arrowBtn: { border: '2px solid #00bcd4', borderRadius: '50%', color: '#00bcd4', height: '32px', width: '32px', transition: 'transform .3s ease-in-out' },
  cardTitle: { height: '72px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' },
  title: {
    fontSize: '13px',
    whiteSpace: 'pre-wrap',
    textAlign: 'center',
    fontWeight: 'bold'
  }
};

var OptionCard = function (_React$Component) {
  _inherits(OptionCard, _React$Component);

  function OptionCard(props) {
    _classCallCheck(this, OptionCard);

    var _this = _possibleConstructorReturn(this, (OptionCard.__proto__ || Object.getPrototypeOf(OptionCard)).call(this, props));

    _this.onMouseEnter = function () {
      return _this.setState({ hover: true });
    };

    _this.onMouseLeave = function () {
      return _this.setState({ hover: false });
    };

    _this.state = {
      hover: false
    };
    return _this;
  }

  _createClass(OptionCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          IconComp = _props.IconComp,
          title = _props.title,
          subTitle = _props.subTitle,
          disabled = _props.disabled,
          defaultPop = _props.defaultPop,
          loadFromScrach = _props.loadFromScrach,
          onClick = _props.onClick;
      var hover = this.state.hover;

      var highlight = hover && !disabled;
      var color = function color(isIcon) {
        if (disabled) return 'rgba(0, 0, 0, 0.34)';
        if (highlight) return '#00bcd4';
        if (loadFromScrach) return 'rgba(0, 0, 0, 0.54)';
        return 'rgba(0, 0, 0, 0.64)';
      };
      return _react2.default.createElement(
        'div',
        {
          style: _extends({}, styles.cardDiv, loadFromScrach ? {
            border: 'none'
          } : {}, {
            boxShadow: function () {
              if (highlight) return '0 10px 35px rgba(0,0,0,0.2)';
              if (defaultPop) return '0 5px 15px rgba(0,0,0,0.35)';
              return '0 0 0 rgba(0,0,0,0.15)';
            }(),
            backgroundColor: loadFromScrach ? '#fff' : '#00bcd41f'
          }),
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave,
          onClick: onClick
        },
        _react2.default.createElement(IconComp, { style: _extends({}, styles.mainIcon, { transform: highlight ? 'scale(1.2)' : 'none', color: color(true) }) }),
        _react2.default.createElement(
          'div',
          { style: _extends({}, styles.cardTitle, { color: color(false) }) },
          _react2.default.createElement(
            'div',
            { style: styles.title },
            title
          ),
          _react2.default.createElement(
            'small',
            {
              style: { visibility: subTitle ? 'visible' : 'hidden', fontSize: '11px' }
            },
            subTitle
          )
        ),
        _react2.default.createElement(
          _materialUi.IconButton,
          { iconStyle: _extends({}, styles.arrowBtn, { transform: highlight ? 'scale(1.2)' : 'none', color: color(true), borderColor: color(true) }) },
          _react2.default.createElement(_chevronRight2.default, null)
        )
      );
    }
  }]);

  return OptionCard;
}(_react2.default.Component);

var TemplateOptions = function TemplateOptions(props) {
  var templates = props.templates,
      templatesForCC = props.templatesForCC,
      docId = props.docId,
      style = props.style,
      goToOmniImport = props.goToOmniImport,
      goToImportOwn = props.goToImportOwn;

  var filteredCCList = templatesForCC.filter(function (o) {
    return o.originalContractId !== docId;
  });
  return _react2.default.createElement(
    'div',
    { style: _extends({ display: 'flex', alignItems: 'flex-start' }, style) },
    _react2.default.createElement(OptionCard, {
      defaultPop: Boolean(templates.length),
      IconComp: _description2.default,
      disabled: !Boolean(templates.length),
      title: 'Your Rate Sheets',
      subTitle: '(' + templates.length + ' found)',
      onClick: goToImportOwn
    }),
    '\xA0\xA0',
    _react2.default.createElement(OptionCard, {
      defaultPop: !templates.length,
      IconComp: _lightbulbOutline2.default,
      title: 'TourConnect\nRate Sheets Database',
      subTitle: filteredCCList.length ? '(' + filteredCCList.length + ' found)' : '',
      onClick: goToOmniImport
    })
  );
};

var ImportOptions = function ImportOptions(props) {
  var forNewDraft = props.forNewDraft,
      templates = props.templates,
      templatesForCC = props.templatesForCC,
      docId = props.docId,
      goToOmniImport = props.goToOmniImport,
      goToImportOwn = props.goToImportOwn,
      onRequestClose = props.onRequestClose;

  if (forNewDraft) {
    // 2px solid #00bcd45
    return _react2.default.createElement(
      'div',
      { className: 'flex-center' },
      _react2.default.createElement(
        'div',
        { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', border: 'none' } },
        _react2.default.createElement(
          'h4',
          { style: { fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.44)' } },
          'Import'
        ),
        _react2.default.createElement(TemplateOptions, {
          style: { borderTop: 'none' },
          templates: templates,
          templatesForCC: templatesForCC,
          docId: docId,
          goToOmniImport: goToOmniImport,
          goToImportOwn: goToImportOwn
        })
      ),
      _react2.default.createElement(
        'div',
        { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '1em', border: 'none' } },
        _react2.default.createElement(
          'h4',
          { style: { fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.44)' } },
          'Load from Scratch'
        ),
        _react2.default.createElement(
          'div',
          { style: { borderTop: 'none' } },
          _react2.default.createElement(OptionCard, {
            loadFromScrach: true,
            IconComp: _insertDriveFile2.default,
            title: 'Blank Rate Sheet',
            onClick: onRequestClose
          })
        )
      )
    );
  }
  return _react2.default.createElement(TemplateOptions, {
    style: { justifyContent: 'space-between', width: '60%', margin: '1em auto' },
    templates: templates,
    templatesForCC: templatesForCC,
    docId: docId,
    goToOmniImport: goToOmniImport,
    goToImportOwn: goToImportOwn
  });
};

exports.default = ImportOptions;

/***/ }),
/* 3319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLightbulbOutline = function ActionLightbulbOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z' })
  );
};
ActionLightbulbOutline = (0, _pure2.default)(ActionLightbulbOutline);
ActionLightbulbOutline.displayName = 'ActionLightbulbOutline';
ActionLightbulbOutline.muiName = 'SvgIcon';

exports.default = ActionLightbulbOutline;

/***/ }),
/* 3320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertDriveFile = function EditorInsertDriveFile(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z' })
  );
};
EditorInsertDriveFile = (0, _pure2.default)(EditorInsertDriveFile);
EditorInsertDriveFile.displayName = 'EditorInsertDriveFile';
EditorInsertDriveFile.muiName = 'SvgIcon';

exports.default = EditorInsertDriveFile;

/***/ }),
/* 3321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearStore = clearStore;
exports.getTemplatesForImport = getTemplatesForImport;

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _smallTemplateListConstants = __webpack_require__(649);

var constants = _interopRequireWildcard(_smallTemplateListConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clearStore() {
  return { type: constants.CLEAR_STORE };
}

function getTemplatesForImport(locationId, locationName) {
  return function (dispatch) {
    dispatch({ type: constants.GETTING_TEMPLATES });
    return fetch('/proxy/contracting/location/' + locationId + '/templates?locationName=' + locationName, {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (_ref) {
      var templates = _ref.templates,
          templatesForCC = _ref.templatesForCC;
      return dispatch({ type: constants.POPULATE_REDUCER, payload: { templates: templates, templatesForCC: templatesForCC, locationName: locationName } });
    }).catch(function () {
      return dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Getting templates failed' });
    });
  };
}

/***/ }),
/* 3322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CopyDataFromProductDialog = function CopyDataFromProductDialog(_ref) {
  var onRequestClose = _ref.onRequestClose,
      contractId = _ref.contractId,
      ratePackageIndex = _ref.ratePackageIndex,
      data = _ref.data,
      copyDataFromAnotherProduct = _ref.copyDataFromAnotherProduct,
      saving = _ref.saving,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      productsMap = _ref.productsMap;

  var _onChange = onTextFieldChangeWithKeyPath;
  var fieldNameMap = {
    extras: 'Extras',
    offers: 'Offers',
    allocation: 'Allocation information',
    blackouts: 'Blackouts',
    pickup: 'Pick-up/Opening information',
    dropoff: 'Drop-off/Closing information',
    productPolicy: 'Product policy'
  };
  var onChangeRatesRadio = function onChangeRatesRadio() {
    if (data.addedProducts[data.productSelectedToBeCopied].productType !== data.thisProductType && data.withoutRates) {
      window.alert('Sorry, you can not import rates from ' + data.addedProducts[data.productSelectedToBeCopied].productType + ' product to ' + data.thisProductType + ' product');
    } else _onChange({ keyPath: ['data', 'withoutRates'], value: !data.withoutRates });
  };
  var allChecked = (0, _ramda.all)((0, _ramda.propEq)('checked', true), data.availableFields);
  var labelsAndValues = data.addedProducts.map(function (product, productIndex) {
    return {
      value: productIndex,
      label: productsMap[product.productId] + ' ' + (product.ratePackageName ? ' - ' + product.ratePackageName : '') + ' (' + product.percent + '% completed)'
    };
  });
  return _react2.default.createElement(
    'div',
    { style: { maxHeight: '550px' } },
    _react2.default.createElement(
      'div',
      {
        style: {
          maxHeight: '500px',
          overflowY: 'scroll',
          margin: '16px 5%',
          width: '90%',
          minHeight: '300px'
        }
      },
      _react2.default.createElement(
        'div',
        { style: { marginBottom: '8px', marginLeft: '48px' } },
        'Please select a room type/product you want to copy data from:'
      ),
      _ramda2.default.call(_ramda2.default.cond([[function () {
        return data.addedProducts.length > 5;
      }, _ramda2.default.always(_react2.default.createElement(
        'div',
        { style: { width: '80%', marginLeft: '48px', marginBottom: '16px' } },
        _react2.default.createElement(_reactSelect2.default, {
          style: { fontSize: '14px' },
          name: 'allocation',
          options: labelsAndValues,
          value: data.productSelectedToBeCopied,
          onChange: function onChange(_ref2) {
            var value = _ref2.value;
            return _onChange({
              keyPath: ['data', 'productSelectedToBeCopied'],
              value: Number(value)
            });
          },
          placeholder: 'Search here...',
          clearable: false,
          scrollMenuIntoView: false
        })
      ))], [function () {
        return data.addedProducts.length;
      }, _ramda2.default.always(_react2.default.createElement(
        _materialUi.RadioButtonGroup,
        {
          name: 'selectProduct',
          valueSelected: '' + data.productSelectedToBeCopied,
          onChange: function onChange(_, value) {
            return _onChange({
              keyPath: ['data', 'productSelectedToBeCopied'],
              value: Number(value)
            });
          }
        },
        labelsAndValues.map(function (_ref3, productIndex) {
          var label = _ref3.label,
              value = _ref3.value;
          return _react2.default.createElement(_materialUi.RadioButton, {
            key: productIndex,
            value: '' + productIndex,
            style: { marginTop: '12px' },
            label: _react2.default.createElement(
              'div',
              null,
              label,
              _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '12px' } })
            )
          });
        })
      ))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(
        'div',
        { style: { margin: '70px', fontSize: '20px' } },
        'There\'s no product information in this contract to copy from.'
      ))]])),
      data.productSelectedToBeCopied > -1 ? _react2.default.createElement(
        'div',
        { style: { marginLeft: '48px', width: '80%', marginTop: '24px' } },
        _react2.default.createElement(
          'div',
          { style: { marginBottom: '8px' } },
          'Please select the data you would like to copy from the product'
        ),
        _react2.default.createElement(
          'div',
          { style: { color: '#ff4081', marginBottom: '24px' } },
          data.error || ''
        ),
        _react2.default.createElement(_materialUi.Checkbox, {
          label: 'All',
          checked: allChecked,
          onCheck: function onCheck() {
            return _onChange({
              keyPath: ['data', 'availableFields'],
              value: (0, _ramda.map)((0, _ramda.set)((0, _ramda.lensProp)('checked'), !allChecked), data.availableFields)
            });
          }
        }),
        _react2.default.createElement(_materialUi.Checkbox, {
          label: 'Seasons',
          checked: (0, _ramda.pathOr)(false, ['availableFields', 0, 'checked'], data),
          style: { marginLeft: '24px', display: 'inline-block' },
          onCheck: function onCheck() {
            return _onChange({
              keyPath: ['data', 'availableFields', 0, 'checked'],
              value: !(0, _ramda.pathOr)(false, ['availableFields', 0, 'checked'], data)
            });
          }
        }),
        (0, _ramda.pathOr)(false, ['availableFields', 0, 'checked'], data) ? _react2.default.createElement(
          'div',
          { style: { marginLeft: '36px' } },
          _react2.default.createElement(_materialUi.RadioButton, {
            checked: data.withoutRates,
            onCheck: onChangeRatesRadio,
            style: { width: '45%', display: 'inline-block' },
            label: 'Without rates'
          }),
          _react2.default.createElement(_materialUi.RadioButton, {
            checked: !data.withoutRates,
            onCheck: onChangeRatesRadio,
            style: { width: '45%', display: 'inline-block' },
            label: 'With rates'
          })
        ) : _react2.default.createElement('div', null),
        data.availableFields.filter(function (obj) {
          return obj.field !== 'seasonRates';
        }).map(function (fieldObject, fieldIndex) {
          return _react2.default.createElement(_materialUi.Checkbox, {
            label: fieldNameMap[fieldObject.field],
            checked: fieldObject.checked,
            style: { marginLeft: '24px' },
            key: fieldIndex,
            onCheck: function onCheck() {
              var realIndex = data.availableFields.findIndex(function (o) {
                return o.field === fieldObject.field;
              });
              _onChange({
                keyPath: ['data', 'availableFields', realIndex, 'checked'],
                value: !fieldObject.checked
              });
            }
          });
        })
      ) : ''
    ),
    _react2.default.createElement(_stepperActions2.default, {
      rightButtons: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Cancel',
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onTouchTap: onRequestClose
        }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Save',
          loader: saving,
          disabled: !(0, _ramda.is)(Number, data.productSelectedToBeCopied) || data.productSelectedToBeCopied < 0,
          labelStyle: { fontWeight: '600' },
          onTouchTap: function onTouchTap() {
            var dataFieldsToImport = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.ifElse(_ramda2.default.contains('seasonRates'), _ramda2.default.append('seasons'), _ramda2.default.identity), _ramda2.default.map(_ramda2.default.prop('field')), _ramda2.default.filter(_ramda2.default.propEq('checked', true))), data.availableFields);
            copyDataFromAnotherProduct({
              contractId: contractId,
              ratePackageNeedDataIndex: ratePackageIndex,
              ratePackageHasDataIndex: data.addedProducts[data.productSelectedToBeCopied].ratePackageIndex,
              withoutRates: data.withoutRates,
              dataFieldsToImport: dataFieldsToImport
            });
          },
          secondary: true
        })
      )
    })
  );
};

CopyDataFromProductDialog.propTypes = {
  onRequestClose: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  data: _react.PropTypes.object
};

exports.default = CopyDataFromProductDialog;

/***/ }),
/* 3323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _singleTemplate = __webpack_require__(1982);

var _singleTemplate2 = _interopRequireDefault(_singleTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OmniImport = function OmniImport(props) {
  var _props$data = props.data,
      sourceTemplate = _props$data.sourceTemplate,
      targetTemplate = _props$data.targetTemplate,
      step = _props$data.step,
      matches = _props$data.matches,
      showCC = _props$data.showCC,
      searchInput = _props$data.searchInput,
      _props$data$templates = _props$data.templates,
      templates = _props$data$templates === undefined ? [] : _props$data$templates,
      loadingCCTemplates = _props$data.loadingCCTemplates,
      noNeedToMatch = _props$data.noNeedToMatch,
      forNewDraft = _props$data.forNewDraft,
      importPoliciesNotes = _props$data.importPoliciesNotes,
      onRequestClose = props.onRequestClose,
      onTextFieldChangeWithKeyPath = props.onTextFieldChangeWithKeyPath,
      selectSourceTemplate = props.selectSourceTemplate,
      omniImport = props.omniImport,
      saving = props.saving,
      searchCCTemplates = props.searchCCTemplates,
      importOwnTemplateFunc = props.importOwnTemplate,
      openGlobalAlert = props.openGlobalAlert,
      isAnAdmin = props.isAnAdmin,
      loadProducts = props.loadProducts;

  var importOwnTemplate = function importOwnTemplate() {
    return importOwnTemplateFunc(forNewDraft);
  };
  var updateData = function updateData(key, value) {
    return onTextFieldChangeWithKeyPath({ keyPath: ['data', key], value: value });
  };
  var selectTemplate = function selectTemplate(template) {
    return function () {
      selectSourceTemplate(template);
    };
  };
  var uniqProducts = sourceTemplate && sourceTemplate.products ? _ramda2.default.uniqBy(function (p) {
    return p.productId;
  }, sourceTemplate.products) : [];
  var selectedTargetProducts = _ramda2.default.values(matches).filter(function (x) {
    return x;
  }).reduce(function (result, prod) {
    result[prod.value] = true;
    return result;
  }, {});

  var onSearch = function onSearch() {
    if (searchInput.trim().length < 6) {
      openGlobalAlert({ text: 'Please type more than 6 characters.' });
    } else {
      searchCCTemplates(targetTemplate.locationId, searchInput);
    }
  };
  var onChangeSearchInput = function onChangeSearchInput(e) {
    if (e.keyCode === 13) onSearch();else updateData('searchInput', e.target.value);
  };
  // const openInNewWindow = doc => () => {
  //   window.open(doc.magicLink);
  // };
  var clickImport = function clickImport() {
    var warningText = '';
    if (!importPoliciesNotes && !(sourceTemplate.productsToImport && sourceTemplate.productsToImport.length)) {
      warningText = 'Please select at least one item to import';
    } else if (!noNeedToMatch && sourceTemplate.productsToImport && sourceTemplate.productsToImport.length) {
      if (sourceTemplate.productsToImport.some(function (pId) {
        return !matches[pId];
      })) {
        warningText = 'Please make sure every room type/product you want to import is mapped to one destination from the Import To dropdown menu.';
      }
    }
    if (warningText) {
      openGlobalAlert({
        text: warningText
      });
    } else {
      var onOk = function onOk() {
        return omniImport({
          matches: matches,
          // if DL entered a contract, swap the _id as templateId so that the backend can process correctly
          sourceTemplate: function () {
            if (sourceTemplate.idFromTCAdmin) {
              if (sourceTemplate.templateId) {
                return _extends({}, sourceTemplate, {
                  _id: sourceTemplate.templateId
                });
              }
              return _extends({}, sourceTemplate, _defineProperty({}, sourceTemplate.collection === 'template' ? '_id' : 'originalContractId', sourceTemplate.idFromTCAdmin));
            }
            return sourceTemplate;
          }(),
          targetTemplateId: targetTemplate.docId,
          importAllBool: Boolean(isAnAdmin),
          importPoliciesNotes: importPoliciesNotes
        });
      };
      if (forNewDraft) {
        onOk();
      } else {
        openGlobalAlert({
          text: 'This action will overwrite the data you currently have, do you want to proceed?',
          onOk: onOk
        });
      }
    }
  };
  var manuallyEnterId = function manuallyEnterId(id, collection) {
    if (id && collection) loadProducts({ idFromTCAdmin: id, collection: collection });else updateData('sourceTemplate', { idFromTCAdmin: id, collection: collection });
  };
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: true,
      bodyStyle: { minHeight: '300px' },
      titleStyle: { padding: '12px 12px 10px' },
      title: _react2.default.createElement(
        'div',
        { className: 'flex-center' },
        _react2.default.createElement(
          'span',
          null,
          'Import Rates'
        ),
        _react2.default.createElement(
          _materialUi.Stepper,
          { activeStep: step === 'selectTemplate' ? 1 : 2, style: { width: '80%' } },
          _react2.default.createElement(
            _materialUi.Step,
            null,
            _react2.default.createElement(
              _materialUi.StepLabel,
              { style: { height: '36px' } },
              'Import Options'
            )
          ),
          _react2.default.createElement(
            _materialUi.Step,
            null,
            _react2.default.createElement(
              _materialUi.StepLabel,
              { style: { height: '36px' } },
              'Select a Template'
            )
          ),
          _react2.default.createElement(
            _materialUi.Step,
            null,
            _react2.default.createElement(
              _materialUi.StepLabel,
              { style: { height: '36px' } },
              'Choose Products/Rooms'
            )
          )
        )
      ),
      autoScrollBodyContent: true,
      actionsContainerClassName: 'flex-tc-sb',
      actions: [_react2.default.createElement(_materialUi.RaisedButton, {
        key: 'own',
        label: 'Back',
        labelStyle: { textTransform: 'none' },
        onClick: step === 'matchProducts' ? function () {
          return updateData('step', 'selectTemplate');
        } : importOwnTemplate
      }), _react2.default.createElement(
        'div',
        { key: 'action' },
        _react2.default.createElement(_materialUi.FlatButton, {
          label: 'dismiss',
          primary: true,
          onClick: onRequestClose
        }),
        step === 'selectTemplate' ? _react2.default.createElement(_materialUi.FlatButton, {
          label: 'Next',
          secondary: true,
          onClick: function onClick() {
            return updateData('step', 'matchProducts');
          },
          disabled: !(sourceTemplate && (sourceTemplate._id || sourceTemplate.originalContractId || sourceTemplate.idFromTCAdmin)) || sourceTemplate.loadingProducts
        }) : _react2.default.createElement(_materialUi.FlatButton, {
          label: 'Import',
          secondary: true,
          onClick: clickImport,
          disabled: saving
        })
      )]
    },
    step === 'selectTemplate' ? _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { style: { margin: '1em 0', display: isAnAdmin ? 'flex' : 'none' }, className: 'flex-center' },
        _react2.default.createElement(_materialUi.RadioButton, {
          label: 'Manually Enter Data',
          checked: !showCC,
          onCheck: function onCheck() {
            return updateData('showCC', false);
          }
        }),
        _react2.default.createElement(_materialUi.RadioButton, {
          label: 'Search TourConnect Database',
          checked: showCC,
          onCheck: function onCheck() {
            return updateData('showCC', true);
          }
        })
      ),
      showCC ? _react2.default.createElement(
        'div',
        { style: { marginTop: '1em' } },
        _react2.default.createElement(
          'span',
          { style: { color: '#000' } },
          'Search by location/property name'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          { style: { height: '16px', lineHeight: '16px', fontSize: '10px' } },
          Boolean(searchInput.trim() && searchInput.trim().length < 6) && 'Type more than 6 characters to search'
        ),
        _react2.default.createElement('input', {
          style: { border: '1px solid #00bcd4', padding: '6px', width: '580px', borderRadius: '2px' },
          value: searchInput,
          onKeyDown: onChangeSearchInput,
          onChange: onChangeSearchInput
        }),
        '\xA0\xA0',
        _react2.default.createElement(_materialUi.RaisedButton, {
          label: 'Search',
          secondary: true,
          style: { marginLeft: '12px' },
          onClick: onSearch
        }),
        _react2.default.createElement('br', null),
        function () {
          if (loadingCCTemplates) {
            return _react2.default.createElement(_materialUi.CircularProgress, { style: { margin: '1em' } });
          }
          if (!templates.length) {
            return _react2.default.createElement(
              'div',
              { style: { marginTop: '1em', fontSize: '10px' } },
              'No templates found. (Please try a different search.)'
            );
          }
          if (templates.length) {
            return _react2.default.createElement(
              'div',
              { style: { marginTop: '1em' } },
              templates.map(function (t) {
                if (t.originalContractId === targetTemplate.docId) return null;
                return _react2.default.createElement(_singleTemplate2.default, {
                  key: t._id || t.originalContractId,
                  template: t,
                  selected: sourceTemplate && (sourceTemplate.originalContractId ? sourceTemplate.originalContractId === t.originalContractId : sourceTemplate._id === t._id),
                  onSelect: selectTemplate(t),
                  onUnselect: selectTemplate(),
                  forCCImport: true
                });
              })
            );
          }
        }()
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          'Enter Contract/Template/Draft Id:'
        ),
        _react2.default.createElement(_materialUi.TextField, {
          value: sourceTemplate.idFromTCAdmin,
          onChange: function onChange(e) {
            return manuallyEnterId(e.target.value, sourceTemplate.collection);
          }
        }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_materialUi.RadioButton, {
            value: 'draft',
            label: 'Draft',
            checked: sourceTemplate.collection === 'draft',
            onCheck: function onCheck() {
              return manuallyEnterId(sourceTemplate.idFromTCAdmin, 'draft');
            }
          }),
          _react2.default.createElement(_materialUi.RadioButton, {
            value: 'template',
            label: 'Template',
            checked: sourceTemplate.collection === 'template',
            onCheck: function onCheck() {
              return manuallyEnterId(sourceTemplate.idFromTCAdmin, 'template');
            }
          }),
          _react2.default.createElement(_materialUi.RadioButton, {
            value: 'contract',
            label: 'Contract',
            checked: sourceTemplate.collection === 'contract',
            onCheck: function onCheck() {
              return manuallyEnterId(sourceTemplate.idFromTCAdmin, 'contract');
            }
          })
        )
      )
    ) : _react2.default.createElement(
      'div',
      { style: { padding: '1em 0 0' } },
      _react2.default.createElement(
        'div',
        { style: { marginBottom: '1em', color: '#000' } },
        _react2.default.createElement(_materialUi.Checkbox, {
          checked: Boolean(importPoliciesNotes),
          label: 'Check this if you would like to import Policies and Notes',
          onCheck: function onCheck(_, checked) {
            return updateData('importPoliciesNotes', checked);
          }
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'flex-tc-sb', style: { marginBottom: '8px', paddingBottom: '8px', borderBottom: '1px solid #e0e0e0' } },
        _react2.default.createElement(
          'div',
          { style: { width: '50%' } },
          _react2.default.createElement(_materialUi.Checkbox, {
            label: 'Import Room Types/Products',
            labelStyle: { color: 'rgba(0, 0, 0, 0.54)' },
            checked: Boolean(sourceTemplate.productsToImport.length && uniqProducts.length === sourceTemplate.productsToImport.length),
            onCheck: function onCheck(_, checked) {
              return updateData('sourceTemplate', _extends({}, sourceTemplate, {
                productsToImport: checked ? uniqProducts.map(function (prod) {
                  return prod.productId;
                }) : []
              }));
            }
          })
        ),
        _react2.default.createElement(
          'div',
          {
            style: {
              width: '50%',
              visibility: !noNeedToMatch ? 'visible' : 'hidden',
              color: 'rgba(0, 0, 0, 0.54)'
            }
          },
          'Import To'
        )
      ),
      uniqProducts.map(function (prod, i) {
        var selected = (sourceTemplate.productsToImport || []).indexOf(prod.productId) > -1;
        return _react2.default.createElement(
          'div',
          { key: i, className: 'flex-tc-sb', style: { marginBottom: '8px', paddingLeft: '16px' } },
          _react2.default.createElement(
            'div',
            { style: { width: 'calc(50% - 16px)' } },
            _react2.default.createElement(_materialUi.Checkbox, {
              checked: selected,
              label: prod.productName,
              onCheck: function onCheck(_, checked) {
                return updateData('sourceTemplate', _extends({}, sourceTemplate, {
                  productsToImport: checked ? [].concat(_toConsumableArray(sourceTemplate.productsToImport), [prod.productId]) : sourceTemplate.productsToImport.filter(function (x) {
                    return x !== prod.productId;
                  })
                }));
              }
            })
          ),
          _react2.default.createElement(
            'div',
            {
              style: {
                width: '50%',
                visibility: !noNeedToMatch && selected ? 'visible' : 'hidden'
              }
            },
            _react2.default.createElement(_reactSelect2.default, {
              placeholder: 'Import To...',
              options: [{ label: '<New Product>', value: null }].concat(_toConsumableArray(targetTemplate.products.filter(function (p) {
                return !selectedTargetProducts[p.productId];
              }).map(function (p) {
                return { label: p.productName, value: p.productId };
              }))),
              value: matches[prod.productId],
              menuIsOpen: true,
              onChange: function onChange(option) {
                return updateData('matches', _extends({}, matches, _defineProperty({}, prod.productId, option)));
              }
            })
          )
        );
      })
    )
  );
};

var mapState = function mapState(_ref) {
  var user = _ref.user;
  return {
    isAnAdmin: user.get('isAnAdmin')
  };
};

OmniImport.propTypes = {
  data: _react2.default.PropTypes.object,
  onRequestClose: _react2.default.PropTypes.func,
  templates: _react2.default.PropTypes.array,
  onTextFieldChangeWithKeyPath: _react2.default.PropTypes.func,
  selectSourceTemplate: _react2.default.PropTypes.func,
  omniImport: _react2.default.PropTypes.func,
  saving: _react2.default.PropTypes.bool,
  openRateDocIframe: _react2.default.PropTypes.func,
  searchCCTemplates: _react2.default.PropTypes.func,
  isAnAdmin: _react2.default.PropTypes.bool,
  importOwnTemplate: _react2.default.PropTypes.func,
  openGlobalAlert: _react2.default.PropTypes.func,
  loadProducts: _react2.default.PropTypes.func
};

exports.default = (0, _reactRedux.connect)(mapState, {
  loadProducts: function loadProducts(template) {
    return { type: 'LOAD_PRODUCTS_FOR_OMNI_IMPORT_SOURCE_TEMPLATE', payload: { template: template } };
  },
  selectSourceTemplate: function selectSourceTemplate(template) {
    return { type: 'SELECT_OMNI_IMPORT_SOURCE_TEMPLATE', payload: { template: template } };
  },
  omniImport: function omniImport(payload) {
    return { type: 'OMNI_IMPORT', payload: payload };
  },
  searchCCTemplates: function searchCCTemplates(locationId, searchInput) {
    return {
      type: 'SEARCH_CC_RATES_TEMPLATES',
      payload: { locationId: locationId, searchInput: searchInput }
    };
  },
  importOwnTemplate: function importOwnTemplate(forNewDraft) {
    return {
      type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
      payload: { type: 'importFromTemplate', data: { forNewDraft: forNewDraft } }
    };
  },
  openGlobalAlert: function openGlobalAlert(payload) {
    return {
      type: 'open_global_alert',
      payload: payload
    };
  }
})(OmniImport);

/***/ }),
/* 3324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.offerMissingInfo = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _leftNav = __webpack_require__(3325);

var _leftNav2 = _interopRequireDefault(_leftNav);

var _selectProducts = __webpack_require__(3326);

var _selectProducts2 = _interopRequireDefault(_selectProducts);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _editOffer = __webpack_require__(3327);

var _editOffer2 = _interopRequireDefault(_editOffer);

var _specialOffersWizard = __webpack_require__(3330);

var _specialOffersWizard2 = _interopRequireDefault(_specialOffersWizard);

var _editExtra = __webpack_require__(3335);

var _editExtra2 = _interopRequireDefault(_editExtra);

var _addExtraWizard = __webpack_require__(3336);

var _addExtraWizard2 = _interopRequireDefault(_addExtraWizard);

var _stepAddExtra = __webpack_require__(1987);

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var offerMissingInfo = exports.offerMissingInfo = function offerMissingInfo(offer) {
  return _ramda2.default.call(_ramda2.default.anyPass([function () {
    return !_ramda2.default.prop('offerName', offer);
  }, function () {
    return !_ramda2.default.prop('bookingCode', offer);
  }, function () {
    return (offer.validDatesOfSale || []).every(function (range) {
      return !range.fromDate;
    });
  }, function () {
    return (offer.validDatesOfTravel || []).every(function (range) {
      return !range.fromDate;
    });
  }, function () {
    if (offer.isStayPay) {
      return !(offer.daysOfWeek && offer.daysOfWeek.length) || (offer.stayPays || []).some(function (staypay) {
        return !(staypay.maxFOC && staypay.stayDays && staypay.payDays);
      });
    }
    var ratesEmpty = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.isEmpty, _ramda2.default.reject(_ramda2.default.propOr('', 'notApplicable')), _ramda2.default.propOr([], 'rates')), offer);
    if (!offer.rate) return true;
    if (offer.rate === 'rateAmount') return ratesEmpty;
    if (offer.rate === 'discount') return !(offer.amount && offer.discountType);
    return false;
  }]), offer);
};

var ManageExtrasOffer = function ManageExtrasOffer(props) {
  var data = props.data,
      offersOrExtras = props.offersOrExtras,
      onRequestClose = props.onRequestClose,
      manageExtrasOffers = props.manageExtrasOffers,
      saving = props.saving,
      RatesFormAndTable = props.RatesFormAndTable,
      contractingPeriod = props.contractingPeriod,
      onTextFieldChangeWithKeyPath = props.onTextFieldChangeWithKeyPath,
      addExtraStepper = props.addExtraStepper,
      specialOffersStepper = props.specialOffersStepper,
      openGlobalAlert = props.openGlobalAlert;


  var processOfferForSaving = function processOfferForSaving(offer, forNewOffer) {
    return _extends({}, offer, {
      validDatesOfTravel: offer.validDatesOfTravel.filter(_ramda2.default.either(_ramda2.default.prop('fromDate'), _ramda2.default.prop('toDate'))),
      validDatesOfSale: offer.validDatesOfSale.filter(_ramda2.default.either(_ramda2.default.prop('fromDate'), _ramda2.default.prop('toDate')))
    }, offer.rate === 'rateAmount' && forNewOffer ? {
      rates: RatesFormAndTable.rates,
      rateType: RatesFormAndTable.rateType,
      nettCommission: RatesFormAndTable.nettCommission,
      commissionPercentage: RatesFormAndTable.commissionPercentage,
      nonStandardTemplateType: RatesFormAndTable.nonStandardTemplateType
    } : {}, forNewOffer ? { _id: 'new-' + _nodeUuid2.default.v1() } : {});
  };
  var listToSave = offersOrExtras.list.filter(function (item) {
    return item.ratePackages.length;
  }).map(function (item) {
    if (offersOrExtras.type === 'offers' && item._id === offersOrExtras.selectedId) {
      return processOfferForSaving(item);
    }
    return item;
  });
  var onClickDuplicate = function onClickDuplicate() {
    var foundItem = offersOrExtras.list.find(function (o) {
      return o._id === offersOrExtras.selectedId;
    });
    return onTextFieldChangeWithKeyPath({
      keyPath: ['offersOrExtras', 'list'],
      value: [].concat(_toConsumableArray(offersOrExtras.list), [_extends({}, foundItem, {
        _id: 'new-' + _nodeUuid2.default.v1()
      }, offersOrExtras.type === 'offers' ? {
        bookingCode: (foundItem.bookingCode || '') + ' - Duplicated'
      } : { extraCode: (foundItem.extraCode || '') + ' - Duplicated' }, {
        ratePackages: []
      })])
    });
  };
  var shouldDisableSaveBtn = function () {
    if (offersOrExtras.type === 'offers') {
      return offersOrExtras.list.some(function (offer) {
        return offerMissingInfo(offer) && offer.ratePackages && offer.ratePackages.length;
      });
    }
    return offersOrExtras.list.some(function (extra) {
      return (0, _editExtra.extraMissingInfo)(extra) && extra.ratePackages && extra.ratePackages.length;
    });
  }();
  var onSave = function onSave() {
    if (offersOrExtras.createNew) {
      if (offersOrExtras.type === 'offers') {
        var isNewOfferMissingATable = data.rate === 'rateAmount' && specialOffersStepper === 1;
        var newOffer = processOfferForSaving(data, true);
        var incomplete = offerMissingInfo(newOffer);
        var emptyRatePackages = !(newOffer.ratePackages && newOffer.ratePackages.length);
        if (incomplete) {
          if (isNewOfferMissingATable) {
            onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'error'], value: 'The new special offer is incomplete, don\'t forget to click on Generate Rate Table to complete the process.' });
            (0, _lodash2.default)(function () {
              return onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'error'], value: '' });
            }, 4000)();
          } else {
            openGlobalAlert({
              text: 'The new offer is incomplete, would you like to discard the new offer and save other changes?',
              onOk: function onOk() {
                return manageExtrasOffers({ list: listToSave });
              }
            });
          }
        } else if (emptyRatePackages) {
          openGlobalAlert({
            text: 'You haven\'t apply this new offer to any room types/products.'
          });
        } else {
          manageExtrasOffers({ list: [].concat(_toConsumableArray(listToSave), [newOffer]) });
        }
      } else if (offersOrExtras.type === 'extras') {
        var isNewExtraMissingATable = !(0, _stepAddExtra.checkIfShouldDisable)(data, RatesFormAndTable) && addExtraStepper === 0;
        var newExtra = _extends({}, data, {
          _id: 'new-' + _nodeUuid2.default.v1(),
          rates: RatesFormAndTable.rates,
          rateType: RatesFormAndTable.rateType,
          nettCommission: RatesFormAndTable.nettCommission,
          commissionPercentage: RatesFormAndTable.commissionPercentage,
          nonStandardTemplateType: RatesFormAndTable.nonStandardTemplateType,
          taxType: RatesFormAndTable.taxType,
          currency: RatesFormAndTable.currency,
          taxInclusion: RatesFormAndTable.taxInclusion
        });
        var _incomplete = (0, _editExtra.extraMissingInfo)(newExtra);
        var _emptyRatePackages = !(data.ratePackages && data.ratePackages.length);
        if (_incomplete) {
          if (isNewExtraMissingATable) {
            onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'error'], value: 'The new extra is incomplete, don\'t forget to click on Generate Rate Table to complete the process.' });
            (0, _lodash2.default)(function () {
              return onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'error'], value: '' });
            }, 4000)();
          } else {
            openGlobalAlert({
              text: 'The new extra is incomplete, would you like to discard the new extra and save other changes?',
              onOk: function onOk() {
                return manageExtrasOffers({ list: listToSave });
              }
            });
          }
        } else if (_emptyRatePackages) {
          openGlobalAlert({
            text: 'You haven\'t apply this new extra to any room types/products.'
          });
        } else {
          manageExtrasOffers({ list: [].concat(_toConsumableArray(listToSave), [newExtra]) });
        }
      }
    } else {
      manageExtrasOffers({ list: listToSave });
    }
  };
  var addNewItem = function addNewItem() {
    onTextFieldChangeWithKeyPath({
      keyPath: [],
      value: {
        offersOrExtras: _extends({}, offersOrExtras, {
          createNew: true,
          selectedId: null
        }),
        data: _extends({
          title: data.title,
          ratePackages: offersOrExtras.productsArray.map(function (o) {
            return o._id;
          })
        }, offersOrExtras.type === 'offers' ? {
          offerName: '',
          offerDetail: '',
          specialConditions: '',
          allowCombination: false,
          validDatesOfSale: [{
            fromDate: (0, _moment2.default)(new Date()).isAfter(contractingPeriod.endDate) ? contractingPeriod.startDate : _moment2.default.utc().startOf('day').toISOString(),
            toDate: contractingPeriod.endDate
          }],
          validDatesOfTravel: [{}]
        } : {})
      }
    });
  };
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex', flexDirection: 'column', justifyContent: 'space-between' } },
    offersOrExtras.list && offersOrExtras.list.length || offersOrExtras.createNew ? _react2.default.createElement(
      'div',
      { style: { display: 'flex' } },
      _react2.default.createElement(_leftNav2.default, _extends({
        invalidCheck: offersOrExtras.type === 'offers' ? offerMissingInfo : _editExtra.extraMissingInfo,
        addNewItem: addNewItem
      }, props)),
      _react2.default.createElement(
        'div',
        {
          style: {
            padding: '16px',
            width: 'calc(100% - 600px)'
          }
        },
        !offersOrExtras.createNew && _react2.default.createElement(
          'div',
          { style: { display: 'flex', flexDirection: 'row-reverse' } },
          _react2.default.createElement(_materialUi.RaisedButton, {
            label: 'Duplicate this ' + (offersOrExtras.type === 'offers' ? 'Special Offer' : 'Extra'),
            onClick: onClickDuplicate
          })
        ),
        function () {
          if (offersOrExtras.createNew) {
            if (offersOrExtras.type === 'offers') {
              return _react2.default.createElement(_specialOffersWizard2.default, props);
            }
            return _react2.default.createElement(_addExtraWizard2.default, props);
          }
          if (offersOrExtras.type === 'offers') {
            return _react2.default.createElement(_editOffer2.default, props);
          }
          if (offersOrExtras.type === 'extras') {
            return _react2.default.createElement(_editExtra2.default, props);
          }
        }()
      ),
      _react2.default.createElement(_selectProducts2.default, props)
    ) : _react2.default.createElement(
      'div',
      { style: { padding: '32px', margin: 'auto', textAlign: 'center' } },
      'There are no ',
      data.type === 'offers' ? 'special offers' : 'extras',
      ' to manage.',
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Click Here to Add One',
          secondary: true,
          onClick: addNewItem
        })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'flex-tc-sb', style: { padding: '4px 8px 0px 36px', borderTop: '1px solid #e0e0e0' } },
      _react2.default.createElement(
        'div',
        { style: { color: '#ff4081' } },
        offersOrExtras.error
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'cancel',
          labelStyle: { fontWeight: '600' },
          primary: true,
          onTouchTap: onRequestClose
        }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          secondary: true,
          label: 'Save',
          loader: saving,
          disabled: shouldDisableSaveBtn,
          onClick: onSave,
          labelStyle: { fontWeight: '600' }
        })
      )
    )
  );
};

var mapActions = {
  openGlobalAlert: function openGlobalAlert(payload) {
    return {
      type: 'open_global_alert',
      payload: payload
    };
  }
};
exports.default = (0, _reactRedux.connect)(null, mapActions)(ManageExtrasOffer);

/***/ }),
/* 3325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _sortableList = __webpack_require__(1130);

var _sortableList2 = _interopRequireDefault(_sortableList);

var _draggableCard = __webpack_require__(1134);

var _draggableCard2 = _interopRequireDefault(_draggableCard);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManageExtrasOfferLeftNav = function ManageExtrasOfferLeftNav(props) {
  var invalidCheck = props.invalidCheck,
      offersOrExtras = props.offersOrExtras,
      onTextFieldChangeWithKeyPath = props.onTextFieldChangeWithKeyPath,
      addNewItem = props.addNewItem;

  var getPrimaryName = function getPrimaryName(obj) {
    return offersOrExtras.type === 'extras' ? obj.extraType : obj.offerName;
  };
  var getSecondaryName = function getSecondaryName(obj) {
    var name = offersOrExtras.type === 'extras' ? obj.extraCode : obj.bookingCode;
    return name ? '(' + name + ')' : '';
  };
  return _react2.default.createElement(
    'div',
    { style: { width: '300px', marginRight: '16px', borderRight: '1px solid #e0e0e0' } },
    _react2.default.createElement(
      _sortableList2.default,
      {
        arrayOfData: offersOrExtras.list,
        dragEnds: function dragEnds(sorted) {
          return onTextFieldChangeWithKeyPath({
            keyPath: ['offersOrExtras', 'list'],
            value: sorted
          });
        },
        style: { width: '100%' },
        sortable: true
      },
      offersOrExtras.list.map(function (obj) {
        var primaryName = getPrimaryName(obj);
        var secondaryName = getSecondaryName(obj);
        return _react2.default.createElement(
          _draggableCard2.default,
          {
            key: obj._id,
            isDropTarget: true,
            isDragSource: true
          },
          _react2.default.createElement(
            'div',
            {
              className: 'flex-tc-sb',
              style: _extends({
                color: 'rgba(0, 0, 0, 0.64)',
                padding: '12px',
                cursor: 'pointer',
                height: 'auto',
                borderBottom: '1px solid #e0e0e0'
              }, offersOrExtras.selectedId === obj._id ? { backgroundColor: '#efefef' } : {}),
              onClick: function onClick() {
                return onTextFieldChangeWithKeyPath({
                  keyPath: ['offersOrExtras'],
                  value: _extends({}, offersOrExtras, {
                    selectedId: obj._id,
                    createNew: false,
                    newOffer: null
                  })
                });
              }
            },
            _react2.default.createElement(
              'div',
              { className: 'flex-center' },
              invalidCheck(obj) && _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-report', style: { color: '#f44336', marginLeft: '4px' } }),
              _react2.default.createElement(
                'div',
                { style: { color: obj._id && obj._id.indexOf('new') > -1 ? '#00bcd4' : 'inherit' } },
                _react2.default.createElement(
                  'small',
                  null,
                  primaryName
                ),
                _react2.default.createElement(
                  'div',
                  { style: { fontSize: '12px' } },
                  secondaryName
                )
              ),
              !(obj.ratePackages && obj.ratePackages.length) && _react2.default.createElement(
                'small',
                { style: { color: '#f44336' } },
                '\xA0to be removed'
              )
            ),
            _react2.default.createElement(_materialUi.FontIcon, {
              className: 'tc-icon-swap_vert',
              style: { color: 'rgba(0, 0, 0, 0.44)' }
            })
          )
        );
      })
    ),
    _react2.default.createElement(
      'div',
      {
        style: {
          cursor: 'pointer',
          color: '#00bcd4',
          padding: '12px',
          backgroundColor: offersOrExtras.createNew ? '#e0e0e0' : '#fff'
        },
        onClick: offersOrExtras.createNew ? function () {} : addNewItem
      },
      '+ Add ',
      offersOrExtras.type === 'offers' ? 'A Special Offer' : 'An Extra'
    )
  );
};

exports.default = ManageExtrasOfferLeftNav;

/***/ }),
/* 3326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManageExtrasOfferSelectProducts = function ManageExtrasOfferSelectProducts(props) {
  var data = props.data,
      offersOrExtras = props.offersOrExtras,
      onTextFieldChangeWithKeyPath = props.onTextFieldChangeWithKeyPath;


  var getPrimaryName = function getPrimaryName(obj) {
    return offersOrExtras.type === 'extras' ? obj.extraType || 'this extra' : obj.offerName || 'this offer';
  };
  var selectedIndex = offersOrExtras.list.findIndex(function (o) {
    return o._id === offersOrExtras.selectedId;
  });
  var getSecondaryName = function getSecondaryName(obj) {
    var name = offersOrExtras.type === 'extras' ? obj.extraCode : obj.bookingCode;
    return name ? '(' + name + ')' : '';
  };

  var getProdDisplayName = function getProdDisplayName(product) {
    var ratePName = _ramda2.default.filter(function (o) {
      return o.productName === product.productName;
    }, offersOrExtras.productsArray).length > 1 && product.ratePackageName;
    return '' + product.productName + (ratePName ? ' - ' : '') + (ratePName || '');
  };

  var currentObject = offersOrExtras.createNew ? data : offersOrExtras.list.find(function (obj) {
    return obj._id === offersOrExtras.selectedId;
  }) || {};
  var currentObjectName = getPrimaryName(currentObject) + ' ' + getSecondaryName(currentObject);
  return _react2.default.createElement(
    'div',
    {
      style: {
        padding: '16px',
        width: '300px',
        borderLeft: '1px solid #e0e0e0'
      }
    },
    _react2.default.createElement(
      'p',
      null,
      'Please select which room type(s)/product(s) that ',
      _react2.default.createElement(
        'b',
        null,
        currentObjectName
      ),
      ' should apply to:'
    ),
    offersOrExtras.toDelete && _react2.default.createElement(
      'p',
      { style: { color: '#00bcd4' } },
      'We\'ve unselected the ',
      getProdDisplayName(offersOrExtras.productsArray.find(function (x) {
        return x._id === offersOrExtras.toDelete;
      })),
      '. Click SAVE to remove this ',
      offersOrExtras.type === 'extras' ? 'Extra' : 'Special Offer',
      '.'
    ),
    !currentObject.ratePackages.length && _react2.default.createElement(
      'p',
      { style: { color: '#ff4081' } },
      'Warning: ',
      _react2.default.createElement(
        'b',
        null,
        currentObjectName
      ),
      ' will ',
      offersOrExtras.createNew ? 'not be added' : 'be removed',
      '.'
    ),
    _react2.default.createElement(_materialUi.Checkbox, {
      style: { marginBottom: '16px' },
      checked: currentObject.ratePackages.length === offersOrExtras.productsArray.length,
      label: 'Select All',
      labelStyle: { fontSize: '12px' },
      onCheck: function onCheck() {
        return onTextFieldChangeWithKeyPath({
          keyPath: offersOrExtras.createNew ? ['data', 'ratePackages'] : ['offersOrExtras', 'list', selectedIndex, 'ratePackages'],
          value: currentObject.ratePackages.length === offersOrExtras.productsArray.length ? [] : offersOrExtras.productsArray.map(function (product) {
            return product._id;
          })
        });
      }
    }),
    (offersOrExtras.productsArray || []).map(function (product) {
      var ratePackageId = product._id;
      var checked = _ramda2.default.contains(ratePackageId, currentObject.ratePackages || []);
      return _react2.default.createElement(_materialUi.Checkbox, {
        key: ratePackageId,
        checked: checked,
        label: getProdDisplayName(product),
        labelStyle: { fontSize: '12px' },
        onCheck: function onCheck() {
          return onTextFieldChangeWithKeyPath({
            keyPath: offersOrExtras.createNew ? ['data', 'ratePackages'] : ['offersOrExtras', 'list', selectedIndex, 'ratePackages'],
            value: checked ? currentObject.ratePackages.filter(function (str) {
              return str !== ratePackageId;
            }) : _ramda2.default.append(ratePackageId, currentObject.ratePackages)
          });
        }
      });
    })
  );
};

exports.default = ManageExtrasOfferSelectProducts;

/***/ }),
/* 3327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _specialOfferTable = __webpack_require__(1557);

var _specialOfferTable2 = _interopRequireDefault(_specialOfferTable);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var EditOffer = function EditOffer(_ref) {
  var offersOrExtras = _ref.offersOrExtras,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      updateCellValueForOfferRates = _ref.updateCellValueForOfferRates,
      productType = _ref.productType,
      RatesFormAndTable = _ref.RatesFormAndTable,
      contractingPeriod = _ref.contractingPeriod;

  if (!offersOrExtras.selectedId || isNilOrEmpty(offersOrExtras.list)) return _react2.default.createElement('div', null);
  var selectedIndex = offersOrExtras.list.findIndex(function (o) {
    return o._id === offersOrExtras.selectedId;
  });
  var nonStandardTemplateType = _ramda2.default.path(['list', selectedIndex, 'nonStandardTemplateType'], offersOrExtras) || RatesFormAndTable.nonStandardTemplateType;
  var rates = _ramda2.default.pathOr(0, ['list', selectedIndex, 'rates', 'length'], offersOrExtras) ? _ramda2.default.path(['list', selectedIndex, 'rates'], offersOrExtras) : RatesFormAndTable.rates;
  var updateTableCell = _ramda2.default.pathOr(0, ['list', selectedIndex, 'rates', 'length'], offersOrExtras) ? function (_ref2) {
    var value = _ref2.value,
        row = _ref2.row,
        column = _ref2.column;

    onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'list', selectedIndex, 'rates', row, column], value: value });
  } : updateCellValueForOfferRates;
  return _react2.default.createElement(
    'div',
    { style: { overflow: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' } },
    _react2.default.createElement(_specialOfferTable2.default, _extends({}, _ramda2.default.omit(['list'], offersOrExtras), _ramda2.default.pathOr({}, ['list', selectedIndex], offersOrExtras), {
      inEdit: true,
      style: { width: '100%', padding: '16px 24px 36px 0' },
      rates: rates,
      nonStandardTemplateType: nonStandardTemplateType,
      productType: productType,
      updateTableCell: updateTableCell,
      contractingPeriod: contractingPeriod,
      updateFieldValue: function updateFieldValue(keyPath, value) {
        if (keyPath[0] === 'isStayPay') {
          onTextFieldChangeWithKeyPath({
            keyPath: ['offersOrExtras', 'list', selectedIndex],
            value: {
              isStayPay: true,
              offerName: 'Stay Pay',
              daysOfWeek: [],
              stayPays: [{}],
              rate: null,
              rates: [],
              nonStandardTemplateType: '',
              discountType: null,
              amount: null,
              numberOfGuests: null,
              commissionPercentage: null
            }
          });
        } else onTextFieldChangeWithKeyPath({ keyPath: _ramda2.default.concat(['offersOrExtras', 'list', selectedIndex], keyPath), value: value });
      }
    }))
  );
};

exports.default = EditOffer;

/***/ }),
/* 3328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _rateTableTemplateContainer = __webpack_require__(632);

var _rateTableTemplateContainer2 = _interopRequireDefault(_rateTableTemplateContainer);

var _contractingUtils = __webpack_require__(124);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Table = function Table(props) {
  var stayPays = props.stayPays,
      daysOfWeek = props.daysOfWeek,
      isStayPay = props.isStayPay,
      allowCombination = props.allowCombination,
      offerName = props.offerName,
      bookingCode = props.bookingCode,
      validDatesOfSale = props.validDatesOfSale,
      validDatesOfTravel = props.validDatesOfTravel,
      offerDetail = props.offerDetail,
      specialConditions = props.specialConditions,
      productType = props.productType,
      rate = props.rate,
      rates = props.rates,
      rateType = props.rateType,
      nettCommission = props.nettCommission,
      commissionPercentage = props.commissionPercentage,
      nonStandardTemplateType = props.nonStandardTemplateType,
      discountType = props.discountType,
      amount = props.amount,
      style = props.style,
      contractState = props.contractState,
      openEditModal = props.openEditModal,
      contractingPeriod = props.contractingPeriod,
      withEditableRateTable = props.withEditableRateTable,
      updateTableCell = props.updateTableCell,
      offerIndex = props.offerIndex,
      _props$classes = props.classes,
      classes = _props$classes === undefined ? {} : _props$classes;

  var rateString = function () {
    if (rate === 'discount') return (discountType === 'percentage' ? amount + '%' : '$' + amount) + ' off';
  }();
  var getClass = function getClass(type) {
    var className = _ramda2.default.keys(classes).find(function (str) {
      return str.indexOf(type) > -1;
    });
    return classes[className];
  };
  var commission = commissionPercentage ? _react2.default.createElement(
    'span',
    { className: classes['commissionPercentage'] },
    'COMMISSION: ' + commissionPercentage + '%\n'
  ) : '';
  var basedCommission = nettCommission ? _react2.default.createElement(
    'span',
    { className: classes['nettCommission'] },
    'NETT RATE BASED ON ' + nettCommission + '% COMMISSION\n'
  ) : '';
  return _react2.default.createElement(
    'div',
    { style: style, className: classes[offerIndex + '-offer'] || '' },
    _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { marginBottom: '12px' },
      leftColumnStyle: { textAlign: 'left', whiteSpace: 'pre' },
      leftColumnContent: _react2.default.createElement(
        'div',
        null,
        'OFFER TITLE\n',
        _react2.default.createElement(
          'b',
          { className: classes[offerIndex + '-offerName'] || '' },
          offerName
        )
      ),
      rightColumnStyle: { textAlign: 'right', whiteSpace: 'pre' },
      rightColumnContent: _react2.default.createElement(
        'span',
        null,
        'BOOKING CODE\n',
        _react2.default.createElement(
          'b',
          { className: classes[offerIndex + '-bookingCode'] || '' },
          bookingCode
        )
      )
    }),
    _react2.default.createElement(_materialUi.Divider, null),
    _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { marginTop: '6px', marginBottom: '6px', fontSize: '12px', padding: '0 4px' },
      leftColumnStyle: { textAlign: 'left', whiteSpace: 'pre' },
      leftColumnContent: 'SALE DATES',
      rightColumnStyle: { textAlign: 'right', whiteSpace: 'pre' },
      rightColumnContent: 'TRAVEL DATES'
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { marginTop: '6px', marginBottom: '6px', padding: '0 4px' },
      leftColumnStyle: { textAlign: 'left', whiteSpace: 'pre', display: 'flex', flexDirection: 'column' },
      leftColumnContent: validDatesOfSale.length || !_ramda2.default.isEmpty(classes) ? validDatesOfSale.map(function (validDate, dateIndex) {
        var fromDateStr = _moment2.default.utc(new Date(validDate.fromDate)).format('DD MMM YYYY');
        var toDateStr = validDate.toDate ? _moment2.default.utc(new Date(validDate.toDate)).format('DD MMM YYYY') : fromDateStr;
        return fromDateStr === toDateStr ? _react2.default.createElement(
          'span',
          { key: 'sale' + dateIndex, className: classes[offerIndex + '-validDatesOfSale-' + dateIndex + '-fromDate'] },
          fromDateStr
        ) : _react2.default.createElement(
          'span',
          { key: 'sale' + dateIndex },
          _react2.default.createElement(
            'span',
            { className: classes[offerIndex + '-validDatesOfSale-' + dateIndex + '-fromDate'] },
            fromDateStr
          ),
          ' -',
          _react2.default.createElement(
            'span',
            { className: classes[offerIndex + '-validDatesOfSale-' + dateIndex + '-toDate'] },
            toDateStr
          )
        );
      }) : _react2.default.createElement(
        'span',
        { style: { cursor: 'pointer', color: '#f44336' }, onClick: openEditModal },
        'Update Sale Dates'
      ),
      rightColumnStyle: { textAlign: 'right', whiteSpace: 'pre', display: 'flex', flexDirection: 'column' },
      rightColumnContent: validDatesOfTravel.length || !_ramda2.default.isEmpty(classes) ? validDatesOfTravel.map(function (travelDate, dateIndex) {
        var fromDateStr = _moment2.default.utc(new Date(travelDate.fromDate)).format('DD MMM YYYY');
        var toDateStr = travelDate.toDate ? _moment2.default.utc(new Date(travelDate.toDate)).format('DD MMM YYYY') : fromDateStr;
        return fromDateStr === toDateStr ? _react2.default.createElement(
          'span',
          { key: 'travel' + dateIndex, className: classes[offerIndex + '-validDatesOfTravel-' + dateIndex + '-fromDate'] },
          fromDateStr
        ) : _react2.default.createElement(
          'span',
          { key: 'travel' + dateIndex },
          _react2.default.createElement(
            'span',
            { className: classes[offerIndex + '-validDatesOfTravel-' + dateIndex + '-fromDate'] },
            fromDateStr
          ),
          ' -',
          _react2.default.createElement(
            'span',
            { className: classes[offerIndex + '-validDatesOfTravel-' + dateIndex + '-toDate'] },
            toDateStr
          )
        );
      }) : _react2.default.createElement(
        'span',
        { style: { cursor: 'pointer', color: '#f44336' }, onClick: openEditModal },
        'Update Travel Dates'
      )
    }),
    _react2.default.createElement(_materialUi.Divider, null),
    Boolean(rateString) && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { marginTop: '6px', marginBottom: '6px', fontSize: '12px', padding: '0 4px' },
        leftColumnStyle: { textAlign: 'left', whiteSpace: 'pre' },
        leftColumnContent: 'OFFER RATE',
        rightColumnStyle: { textAlign: 'right', whiteSpace: 'pre', fontWeight: 'bold' },
        rightColumnClassName: classes[offerIndex + '-rate'] || classes[offerIndex + '-discountType'] || classes[offerIndex + '-amount'],
        rightColumnContent: rateString
      }),
      _react2.default.createElement(_materialUi.Divider, null)
    ),
    isStayPay ? _react2.default.createElement(
      'div',
      { style: { marginTop: '12px', fontWeight: 'bold', padding: '0 0 12px 4px', display: 'flex', justifyContent: 'space-between', clear: 'both' } },
      _react2.default.createElement(
        'div',
        { className: getClass(offerIndex + '-daysOfWeek') },
        (0, _contractingUtils.prettifyDays)(daysOfWeek)
      ),
      _react2.default.createElement(
        'div',
        { className: getClass(offerIndex + '-stayPays') },
        stayPays.map(function (sp, i) {
          return _react2.default.createElement(
            'div',
            { key: i },
            'Stay ' + sp.stayDays + ' Pay ' + sp.payDays + (sp.maxFOC ? ', Max ' + sp.maxFOC + ' FOC Nights Allowed' : '')
          );
        })
      )
    ) : _react2.default.createElement('div', null),
    rate === 'rateAmount' ? _react2.default.createElement(_materialUi.Divider, { style: { marginBottom: '12px' } }) : _react2.default.createElement('span', null),
    rate === 'rateAmount' && _react2.default.createElement(
      'div',
      null,
      rateType === 'includeCommission' ? commission : basedCommission,
      _react2.default.createElement(_rateTableTemplateContainer2.default, {
        productType: productType,
        classes: classes[offerIndex + '-ratesClasses'],
        withEditableCell: withEditableRateTable,
        updateTableCell: updateTableCell,
        contractState: contractState,
        rateSet: { rates: rates, nonStandardTemplateType: nonStandardTemplateType },
        forOffer: true,
        showHeader: true
      })
    ),
    _react2.default.createElement(_materialUi.Divider, null),
    _react2.default.createElement(
      'div',
      { style: { display: offerDetail ? 'block' : 'none', marginTop: '12px', paddingLeft: '4px', whiteSpace: 'pre-line', clear: 'both' } },
      _react2.default.createElement(
        'label',
        { style: { fontSize: '12px' } },
        'OFFER DETAILS: '
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'span',
        { className: classes[offerIndex + '-offerDetail-textblock'] ? '' : classes[offerIndex + '-offerDetail'] },
        classes[offerIndex + '-offerDetail-textblock'] || offerDetail
      )
    ),
    Boolean(specialConditions) && _react2.default.createElement(
      'div',
      { style: { marginTop: '12px', paddingLeft: '4px', whiteSpace: 'pre-line' } },
      _react2.default.createElement(
        'label',
        { style: { fontSize: '12px' } },
        'SPECIAL CONDITIONS: '
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'span',
        { className: classes[offerIndex + '-specialConditions-textblock'] ? '' : classes[offerIndex + '-specialConditions'] },
        classes[offerIndex + '-specialConditions-textblock'] || specialConditions
      )
    ),
    _react2.default.createElement(
      'div',
      {
        style: { marginTop: '12px', paddingLeft: '4px', color: 'rgba(0, 0, 0, 0.74)' }
      },
      'This special offer ',
      _react2.default.createElement(
        'span',
        { className: classes[offerIndex + '-allowCombination'] },
        allowCombination ? 'IS ' : 'IS NOT '
      ),
      'combinable with other offers.'
    )
  );
};

exports.default = Table;

/***/ }),
/* 3329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _rateTableTemplateContainer = __webpack_require__(632);

var _rateTableTemplateContainer2 = _interopRequireDefault(_rateTableTemplateContainer);

var _travelSalesDatesPickers = __webpack_require__(1983);

var _travelSalesDatesPickers2 = _interopRequireDefault(_travelSalesDatesPickers);

var _taxCurrencyCommissionForm = __webpack_require__(1556);

var _taxCurrencyCommissionForm2 = _interopRequireDefault(_taxCurrencyCommissionForm);

var _daysOfWeek = __webpack_require__(1551);

var _daysOfWeek2 = _interopRequireDefault(_daysOfWeek);

var _staypay = __webpack_require__(1550);

var _staypay2 = _interopRequireDefault(_staypay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  stayPays: _react2.default.PropTypes.array,
  daysOfWeek: _react2.default.PropTypes.array,
  isStayPay: _react2.default.PropTypes.bool,
  allowCombination: _react2.default.PropTypes.bool,
  offerName: _react2.default.PropTypes.string,
  bookingCode: _react2.default.PropTypes.string,
  validDatesOfSale: _react2.default.PropTypes.array,
  validDatesOfTravel: _react2.default.PropTypes.array,
  offerDetail: _react2.default.PropTypes.string,
  specialConditions: _react2.default.PropTypes.string,
  inEdit: _react2.default.PropTypes.bool,
  productType: _react2.default.PropTypes.string,
  updateFieldValue: _react2.default.PropTypes.func,
  updateTableCell: _react2.default.PropTypes.func,
  offerType: _react2.default.PropTypes.string,
  rate: _react2.default.PropTypes.oneOf(['freeOfCharge', 'discount', 'rateAmount', '']),
  rates: _react2.default.PropTypes.array,
  nonStandardTemplateType: _react2.default.PropTypes.string,
  discountType: _react2.default.PropTypes.string,
  amount: _react2.default.PropTypes.string,
  style: _react2.default.PropTypes.object,
  contractingPeriod: _react2.default.PropTypes.object,
  updateDaysOfWeek: _react2.default.PropTypes.func
};
var datesValid = function datesValid(dates) {
  return dates.some(_ramda2.default.prop('fromDate'));
};
var ratesTableNotValid = _ramda2.default.compose(_ramda2.default.isEmpty, _ramda2.default.reject(_ramda2.default.propOr('', 'notApplicable')), _ramda2.default.propOr([], 'rates'));
var SpecialOfferTableInEdit = function SpecialOfferTableInEdit(props) {
  var _updateFieldValue = props.updateFieldValue,
      updateTableCell = props.updateTableCell;

  var ratesNotValid = function () {
    if (props.rate === 'rateAmount') return ratesTableNotValid(props);
    if (props.rate === 'discount') return !(props.amount && props.discountType);
    return false;
  }();
  return _react2.default.createElement(
    'div',
    { style: props.style },
    _react2.default.createElement(
      'div',
      { style: { display: props.isStayPay ? 'none' : 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'center' } },
      _react2.default.createElement(
        'div',
        { style: { width: '30%' } },
        ' Stay Pay'
      ),
      _react2.default.createElement(_materialUi.Toggle, {
        style: { width: '70%' },
        toggled: props.isStayPay,
        onToggle: function onToggle() {
          _updateFieldValue(['isStayPay'], !props.isStayPay);
          _updateFieldValue(['validDatesOfSale'], [{ fromDate: new Date().toISOString(), toDate: props.contractingPeriod.endDate }]);
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { display: props.isStayPay ? 'none' : 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'baseline' } },
      _react2.default.createElement(
        'div',
        { style: { width: '30%' } },
        ' Offer title',
        _react2.default.createElement(
          'small',
          { style: { color: 'red', display: !props.offerName ? 'block' : 'none' } },
          ' * Required'
        )
      ),
      _react2.default.createElement(_materialUi.TextField, {
        id: 'offerName',
        style: { width: '70%' },
        value: props.offerName || '',
        onChange: function onChange(_, value) {
          return _updateFieldValue(['offerName'], value);
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'baseline' } },
      _react2.default.createElement(
        'div',
        { style: { width: '30%' } },
        ' Booking code',
        _react2.default.createElement(
          'small',
          { style: { color: 'red', display: !props.bookingCode ? 'block' : 'none' } },
          ' * Required'
        )
      ),
      _react2.default.createElement(_materialUi.TextField, {
        id: 'bookingCode',
        style: { width: '70%' },
        value: props.bookingCode || '',
        onChange: function onChange(_, value) {
          return _updateFieldValue(['bookingCode'], value);
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '16px', alignItems: 'baseline' } },
      _react2.default.createElement(
        'div',
        { style: { width: '30%', position: 'relative', top: '-12px' } },
        ' Sale dates',
        _react2.default.createElement(
          'small',
          { style: { color: 'red', display: !datesValid(props.validDatesOfSale) ? 'block' : 'none' } },
          ' * Required'
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '70%' } },
        _react2.default.createElement(_travelSalesDatesPickers2.default, {
          dates: props.validDatesOfSale,
          disabled: props.isStayPay,
          forSaleDates: true,
          contractingPeriod: props.contractingPeriod,
          onChange: function onChange(kp, value) {
            return _updateFieldValue(_ramda2.default.concat(['validDatesOfSale'], kp), value);
          }
        })
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'baseline' } },
      _react2.default.createElement(
        'div',
        { style: { width: '30%', position: 'relative', top: '-12px' } },
        ' Travel dates',
        _react2.default.createElement(
          'small',
          { style: { color: 'red', display: !datesValid(props.validDatesOfTravel) ? 'block' : 'none' } },
          ' * Required'
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '70%' } },
        _react2.default.createElement(_travelSalesDatesPickers2.default, {
          dates: props.validDatesOfTravel,
          contractingPeriod: props.contractingPeriod,
          onChange: function onChange(kp, value) {
            return _updateFieldValue(_ramda2.default.concat(['validDatesOfTravel'], kp), value);
          }
        })
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'baseline' } },
      _react2.default.createElement(
        'div',
        { style: { width: '30%' } },
        'Offer detail'
      ),
      _react2.default.createElement('textarea', {
        className: 'clickEditCell',
        style: { border: '1px solid #00BCD4', textAlign: 'left', width: '70%', color: 'rgba(0, 0, 0, 0.64)' },
        value: props.offerDetail || '',
        onChange: function onChange(_ref) {
          var value = _ref.target.value;
          return _updateFieldValue(['offerDetail'], value);
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'baseline' } },
      _react2.default.createElement(
        'div',
        { style: { width: '30%' } },
        'Special conditions'
      ),
      _react2.default.createElement('textarea', {
        className: 'clickEditCell',
        style: { border: '1px solid #00BCD4', textAlign: 'left', width: '70%', color: 'rgba(0, 0, 0, 0.64)' },
        value: props.specialConditions || '',
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          return _updateFieldValue(['specialConditions'], value);
        }
      })
    ),
    props.isStayPay && _react2.default.createElement(
      'div',
      { style: { marginTop: '12px', padding: '0 0 8px 4px', clear: 'both' } },
      _react2.default.createElement(
        'label',
        null,
        _react2.default.createElement(
          'b',
          null,
          'Which day(s) of the week does this offer apply to?'
        ),
        _react2.default.createElement(
          'small',
          { style: { color: 'red', display: _ramda2.default.isEmpty(props.daysOfWeek) ? 'inline-block' : 'none' } },
          ' * Required'
        )
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(_daysOfWeek2.default, {
        daysOfWeek: props.daysOfWeek,
        updateDaysOfWeek: function updateDaysOfWeek(checked, day, dayIndexInReducer) {
          if (day === 'All') _updateFieldValue(['daysOfWeek'], !checked ? [] : ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']);else {
            var daysOfWeek = checked ? _ramda2.default.uniq(_ramda2.default.append(day, props.daysOfWeek)) : _ramda2.default.remove(dayIndexInReducer, 1, props.daysOfWeek);
            _updateFieldValue(['daysOfWeek'], daysOfWeek);
          }
        }
      }),
      _react2.default.createElement(_staypay2.default, {
        defaultYes: true,
        staypayApplicable: 'yes',
        stayPayError: props.stayPayError,
        stayPays: props.stayPays,
        updateFieldValue: function updateFieldValue(key, val) {
          return _updateFieldValue([key], val);
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'baseline' } },
      _react2.default.createElement(
        'div',
        { style: { width: '30%' } },
        'Rate details',
        _react2.default.createElement(
          'small',
          { style: { color: 'red', display: ratesNotValid ? 'block' : 'none' } },
          ' * Required'
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '70%', display: 'flex', justifyContent: 'space-between' } },
        _react2.default.createElement(
          'div',
          { style: { padding: '8px 0', width: '35%' } },
          _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('freeOfCharge'), _ramda2.default.always('Free of charge')], [_ramda2.default.equals('discount'), _ramda2.default.always('Discount')], [_ramda2.default.T, _ramda2.default.always('Rate Amount')]]), props.rate)
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '60%', display: props.rate === 'discount' ? 'flex' : 'none', justifyContent: 'space-between' } },
          _react2.default.createElement(
            'div',
            { style: { padding: '8px 0', width: '50%' } },
            _react2.default.createElement(_reactSelect2.default, {
              name: 'rate',
              options: [{ value: 'percentage', label: 'Percentage' }, { value: 'flatRate', label: 'Flat fee' }],
              value: props.discountType,
              onChange: function onChange(_ref3) {
                var value = _ref3.value;
                return _updateFieldValue(['discountType'], value);
              },
              placeholder: 'Discount Type',
              clearable: false,
              scrollMenuIntoView: false
            })
          ),
          _react2.default.createElement(
            'div',
            { style: { padding: '8px 0', display: 'flex', alignItems: 'center' } },
            _react2.default.createElement('input', {
              type: 'number',
              onChange: function onChange(_ref4) {
                var value = _ref4.target.value;
                return _updateFieldValue(['amount'], value);
              },
              value: props.amount || '',
              style: { border: '1px solid #ccc', height: '37px', paddingLeft: '8px', width: '100px' }
            }),
            _react2.default.createElement(
              'span',
              { style: { lineHeight: '37px', fontSize: '24px' } },
              props.discountType === 'percentage' ? '%' : '$'
            )
          )
        )
      )
    ),
    props.rate === 'rateAmount' && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_taxCurrencyCommissionForm2.default, {
        hideCurrencyTax: true,
        rateType: props.rateType,
        commissionPercentage: props.commissionPercentage,
        nettCommission: props.nettCommission,
        updateFunc: function updateFunc(field, value) {
          _updateFieldValue([field], value);
        }
      }),
      _react2.default.createElement(_rateTableTemplateContainer2.default, {
        productType: props.productType,
        withEditableCell: true,
        rateSet: { rates: props.rates, nonStandardTemplateType: props.nonStandardTemplateType },
        updateTableCell: updateTableCell,
        forOffer: true,
        showHeader: true
      }),
      ratesTableNotValid(props) && _react2.default.createElement(
        'div',
        { style: { color: 'red' } },
        'At least one rate detail is required.'
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { marginTop: '12px', paddingLeft: '4px' } },
      _react2.default.createElement(
        'label',
        null,
        _react2.default.createElement(
          'b',
          null,
          'Is this special offer combinable with other special offers?'
        )
      ),
      _react2.default.createElement(_materialUi.Toggle, {
        style: { display: 'inline-block', width: '60px' },
        toggled: props.allowCombination,
        onToggle: function onToggle() {
          return _updateFieldValue(['allowCombination'], !props.allowCombination);
        }
      })
    )
  );
};
SpecialOfferTableInEdit.propTypes = propTypes;
exports.default = SpecialOfferTableInEdit;

/***/ }),
/* 3330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _standardOfferWizard = __webpack_require__(3331);

var _standardOfferWizard2 = _interopRequireDefault(_standardOfferWizard);

var _staypayOfferWizard = __webpack_require__(3333);

var _staypayOfferWizard2 = _interopRequireDefault(_staypayOfferWizard);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var propTypes = {
  data: _react2.default.PropTypes.object,
  offersOrExtras: _react2.default.PropTypes.object,
  productType: _react2.default.PropTypes.string,
  onTextFieldChangeWithKeyPath: _react2.default.PropTypes.func,
  onRequestClose: _react2.default.PropTypes.func,
  contractingPeriod: _react2.default.PropTypes.object
};
var SpecialOffersContainer = function SpecialOffersContainer(props) {
  var data = props.data,
      offersOrExtras = props.offersOrExtras,
      productType = props.productType,
      onTextFieldChangeWithKeyPath = props.onTextFieldChangeWithKeyPath,
      contractingPeriod = props.contractingPeriod;

  var isStayPay = _ramda2.default.prop('isStayPay', data);
  var isAccom = _ramda2.default.equals('Accommodation', productType);
  var stayPayQ = _react2.default.createElement(
    'div',
    { style: { padding: '32px 0 0 32px' } },
    'Will you be adding a Stay Pay offer?',
    _react2.default.createElement(_materialUi.RadioButton, {
      label: 'Yes',
      checked: _ramda2.default.has('isStayPay', data) && _ramda2.default.prop('isStayPay', data),
      onCheck: function onCheck() {
        onTextFieldChangeWithKeyPath({ keyPath: ['data'], value: { isStayPay: true, offerName: 'Stay Pay', title: 'ADD STAY PAY Offer', daysOfWeek: [], stayPays: [{}] } });
      }
    }),
    _react2.default.createElement(_materialUi.RadioButton, {
      label: 'No',
      checked: _ramda2.default.has('isStayPay', data) && !_ramda2.default.prop('isStayPay', data),
      onCheck: function onCheck() {
        return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'isStayPay'], value: false });
      }
    })
  );
  if (!_ramda2.default.has('isStayPay', data) && isAccom) return stayPayQ;
  var sharedProps = _extends({}, props, {
    addAnotherNewOffer: function addAnotherNewOffer(dataToSave) {
      if (dataToSave.ratePackages && dataToSave.ratePackages.length) {
        onTextFieldChangeWithKeyPath({
          keyPath: [],
          value: {
            offersOrExtras: _extends({}, offersOrExtras, {
              list: [].concat(_toConsumableArray(offersOrExtras.list), [dataToSave]),
              selectedId: dataToSave._id,
              createNew: true
            }),
            data: {
              title: data.title,
              offerName: '',
              offerDetail: '',
              specialConditions: '',
              allowCombination: false,
              validDatesOfSale: [{
                fromDate: (0, _moment2.default)(new Date()).isAfter(contractingPeriod.endDate) ? contractingPeriod.startDate : _moment2.default.utc().startOf('day').toISOString(),
                toDate: contractingPeriod.endDate
              }],
              validDatesOfTravel: [{}],
              ratePackages: offersOrExtras.productsArray.map(function (o) {
                return o._id;
              })
            }
          }
        });
        props.clearAddRateSetWizard();
        props.goToStep({ stepperWizardName: 'specialOffersStepper', componentIndex: 0 });
      } else {
        window.alert('Please select at least one ' + (isAccom ? 'room' : 'product') + ' this offer should apply to.');
      }
    }
  });
  if (!isStayPay || !isAccom) {
    return _react2.default.createElement(_standardOfferWizard2.default, sharedProps);
  }
  return _react2.default.createElement(_staypayOfferWizard2.default, sharedProps);
};
SpecialOffersContainer.propTypes = propTypes;
exports.default = SpecialOffersContainer;

/***/ }),
/* 3331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _stepperWizard = __webpack_require__(1139);

var _stepperWizard2 = _interopRequireDefault(_stepperWizard);

var _stepOffers = __webpack_require__(3332);

var _stepOffers2 = _interopRequireDefault(_stepOffers);

var _stepOffers3 = __webpack_require__(1985);

var _stepOffers4 = _interopRequireDefault(_stepOffers3);

var _stepOffers5 = __webpack_require__(1986);

var _stepOffers6 = _interopRequireDefault(_stepOffers5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var StandardSpecialOffersContainer = function StandardSpecialOffersContainer(_ref) {
  var specialOffersStepper = _ref.specialOffersStepper,
      RatesFormAndTable = _ref.RatesFormAndTable,
      updateCellValueForOfferRates = _ref.updateCellValueForOfferRates,
      extraProps = _objectWithoutProperties(_ref, ['specialOffersStepper', 'RatesFormAndTable', 'updateCellValueForOfferRates']);

  var stepNames = ['Offer Details', 'Rates', 'Dates & Review'];
  return _react2.default.createElement(
    _stepperWizard2.default,
    {
      steps: stepNames,
      componentIndex: specialOffersStepper,
      showStepsBar: true
    },
    _react2.default.createElement(_stepOffers2.default, extraProps),
    _react2.default.createElement(_stepOffers4.default, _extends({}, extraProps, { offerRates: RatesFormAndTable })),
    _react2.default.createElement(_stepOffers6.default, _extends({}, extraProps, {
      commissionPercentage: extraProps.data.commissionPercentage || RatesFormAndTable.commissionPercentage,
      rateType: extraProps.data.rateType || RatesFormAndTable.rateType,
      nettCommission: extraProps.data.nettCommission || RatesFormAndTable.nettCommission,
      currency: extraProps.data.currency || RatesFormAndTable.currency,
      taxInclusion: extraProps.data.taxInclusion || RatesFormAndTable.taxInclusion,
      taxType: extraProps.data.taxType || RatesFormAndTable.taxType,
      nonStandardTemplateType: extraProps.data.nonStandardTemplateType || RatesFormAndTable.nonStandardTemplateType,
      rates: extraProps.data.rates && extraProps.data.rates.length ? extraProps.data.rates : RatesFormAndTable.rates,
      updateTableCell: extraProps.data.rates && extraProps.data.rates.length ? function (_ref2) {
        var value = _ref2.value,
            row = _ref2.row,
            column = _ref2.column;

        extraProps.onTextFieldChangeWithKeyPath({ keyPath: ['data', 'rates', row, column], value: value });
      } : updateCellValueForOfferRates
    }))
  );
};

exports.default = StandardSpecialOffersContainer;

/***/ }),
/* 3332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _dates = __webpack_require__(1984);

var _dates2 = _interopRequireDefault(_dates);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkIfShouldDisable = function checkIfShouldDisable(data) {
  return !Boolean(data.offerName && data.bookingCode && (0, _ramda.path)(['validDatesOfSale', 0, 'fromDate'], data) && (0, _ramda.path)(['validDatesOfSale', 0, 'toDate'], data) && (0, _moment2.default)((0, _ramda.path)(['validDatesOfSale', 0, 'toDate'], data)).isSameOrAfter((0, _ramda.path)(['validDatesOfSale', 0, 'fromDate'], data)) && (0, _ramda.path)(['validDatesOfTravel', 0, 'fromDate'], data) && (0, _ramda.path)(['validDatesOfTravel', 0, 'toDate'], data) && (0, _moment2.default)((0, _ramda.path)(['validDatesOfTravel', 0, 'toDate'], data)).isSameOrAfter((0, _ramda.path)(['validDatesOfTravel', 0, 'fromDate'], data)) && data.offerDetail);
};
var StepOne = function StepOne(_ref) {
  var data = _ref.data,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      goToStep = _ref.goToStep,
      contractingPeriod = _ref.contractingPeriod;

  var shouldDisable = checkIfShouldDisable(data);
  return _react2.default.createElement(
    'div',
    { style: { padding: '24px 12px 0', overflow: 'inherit' } },
    _react2.default.createElement(_twoColumnRow2.default, {
      leftColumnStyle: { position: 'relative', top: '20px', fontSize: '16px', width: '45%' },
      leftColumnContent: _react2.default.createElement(
        'div',
        null,
        'Please enter a name for your special offer',
        _react2.default.createElement(
          'div',
          { style: { fontSize: '12px', color: '#ff4081' } },
          '* Required'
        )
      ),
      rightColumnStyle: { width: '48%' },
      rightColumnContent: _react2.default.createElement(_typeControlledTextfield2.default, {
        style: { width: '100%', position: 'relative', top: '-20px' },
        value: data.offerName,
        floatingLabelText: 'Offer Title',
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'offerName'], value: value });
        }
      })
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      leftColumnStyle: { position: 'relative', top: '10px', fontSize: '16px', width: '45%' },
      leftColumnContent: _react2.default.createElement(
        'div',
        null,
        'Please enter a booking code that the agent should include at the time of booking.',
        _react2.default.createElement(
          'div',
          { style: { fontSize: '12px', color: '#ff4081' } },
          '* Required'
        )
      ),
      rightColumnStyle: { width: '48%' },
      rightColumnContent: _react2.default.createElement(_typeControlledTextfield2.default, {
        style: { width: '100%', position: 'relative', top: '-20px' },
        value: data.bookingCode,
        floatingLabelText: 'Booking Code',
        onChange: function onChange(_ref3) {
          var value = _ref3.target.value;
          return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'bookingCode'], value: value });
        }
      })
    }),
    _react2.default.createElement(_dates2.default, {
      data: data,
      contractingPeriod: contractingPeriod,
      onTextFieldChangeWithKeyPath: onTextFieldChangeWithKeyPath
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { height: '104px', overflow: '' },
      leftColumnStyle: { position: 'relative', top: '10px', fontSize: '16px', width: '45%' },
      leftColumnContent: _react2.default.createElement(
        'div',
        null,
        'Please note the details of this special offer. For example, when room upgrades are processed (at booking or check-in), buy one get one free, etc.',
        _react2.default.createElement(
          'div',
          { style: { fontSize: '12px', color: '#ff4081' } },
          '* Required'
        )
      ),
      rightColumnStyle: { width: '48%', height: '104px', overflowY: 'scroll' },
      rightColumnContent: _react2.default.createElement(_typeControlledTextfield2.default, {
        style: { width: '100%', position: 'relative', top: '-10px' }, multiLine: true,
        floatingLabelText: 'Offer Details',
        value: data.offerDetail,
        onChange: function onChange(_ref4) {
          var value = _ref4.target.value;
          return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'offerDetail'], value: value });
        }
      })
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { height: '68px', overflow: '' },
      leftColumnStyle: { position: 'relative', top: '20px', fontSize: '16px', width: '45%' },
      leftColumnContent: 'Please enter any special conditions for this offer, if needed.',
      rightColumnStyle: { width: '48%', height: '84px', overflowY: 'scroll' },
      rightColumnContent: _react2.default.createElement(_typeControlledTextfield2.default, {
        style: { width: '100%', position: 'relative', top: '-10px' }, multiLine: true,
        floatingLabelText: 'Special Conditions',
        value: data.specialConditions,
        onChange: function onChange(_ref5) {
          var value = _ref5.target.value;
          return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'specialConditions'], value: value });
        }
      })
    }),
    _react2.default.createElement(_twoColumnRow2.default, {
      outerContainerStyle: { height: '68px', overflow: '' },
      leftColumnStyle: { position: 'relative', top: '20px', fontSize: '16px', width: '45%' },
      leftColumnContent: 'Is this special offer allowed to be combined with other special offers?',
      rightColumnStyle: { width: '48%', height: '84px' },
      rightColumnContent: _react2.default.createElement(
        'div',
        { style: { position: 'relative', top: '20px' } },
        _react2.default.createElement(_materialUi.Toggle, {
          style: { display: 'inline-block', width: '60px' },
          toggled: data.allowCombination,
          onToggle: function onToggle() {
            return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'allowCombination'], value: !data.allowCombination });
          }
        })
      )
    }),
    _react2.default.createElement(
      'div',
      { className: 'flex-tc-sb' },
      _react2.default.createElement(_flatButtonWithLoader2.default, {
        secondary: true,
        label: 'Back',
        onTouchTap: function onTouchTap() {
          return onTextFieldChangeWithKeyPath({ keyPath: ['data'], value: _ramda2.default.omit(['isStayPay', data]) });
        },
        labelStyle: { fontWeight: '600' }
      }),
      _react2.default.createElement(_flatButtonWithLoader2.default, {
        secondary: true,
        label: 'Continue',
        onTouchTap: function onTouchTap() {
          return goToStep({ stepperWizardName: 'specialOffersStepper', componentIndex: 1 });
        },
        labelStyle: { fontWeight: '600' },
        disabled: shouldDisable
      })
    )
  );
};

exports.default = StepOne;

/***/ }),
/* 3333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _stepperWizard = __webpack_require__(1139);

var _stepperWizard2 = _interopRequireDefault(_stepperWizard);

var _stepStaypayOffers = __webpack_require__(3334);

var _stepStaypayOffers2 = _interopRequireDefault(_stepStaypayOffers);

var _stepOffers = __webpack_require__(1985);

var _stepOffers2 = _interopRequireDefault(_stepOffers);

var _stepOffers3 = __webpack_require__(1986);

var _stepOffers4 = _interopRequireDefault(_stepOffers3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var StayPayOffersContainer = function StayPayOffersContainer(_ref) {
  var specialOffersStepper = _ref.specialOffersStepper,
      RatesFormAndTable = _ref.RatesFormAndTable,
      updateCellValueForOfferRates = _ref.updateCellValueForOfferRates,
      extraProps = _objectWithoutProperties(_ref, ['specialOffersStepper', 'RatesFormAndTable', 'updateCellValueForOfferRates']);

  var stepNames = ['Offer Details', 'Rates', 'Dates & Review'];
  return _react2.default.createElement(
    _stepperWizard2.default,
    {
      steps: stepNames,
      componentIndex: specialOffersStepper,
      showStepsBar: true
    },
    _react2.default.createElement(_stepStaypayOffers2.default, extraProps),
    _react2.default.createElement(_stepOffers2.default, _extends({}, extraProps, { offerRates: RatesFormAndTable })),
    _react2.default.createElement(_stepOffers4.default, _extends({}, extraProps, {
      commissionPercentage: RatesFormAndTable.commissionPercentage,
      nonStandardTemplateType: extraProps.data.nonStandardTemplateType || RatesFormAndTable.nonStandardTemplateType,
      rates: extraProps.data.rates && extraProps.data.rates.length ? extraProps.data.rates : RatesFormAndTable.rates,
      updateTableCell: extraProps.data.rates && extraProps.data.rates.length ? function (_ref2) {
        var value = _ref2.value,
            row = _ref2.row,
            column = _ref2.column;

        extraProps.onTextFieldChangeWithKeyPath({ keyPath: ['rates', row, column], value: value });
      } : updateCellValueForOfferRates
    }))
  );
};

exports.default = StayPayOffersContainer;

/***/ }),
/* 3334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _syncSectionCheckbox = __webpack_require__(1004);

var _syncSectionCheckbox2 = _interopRequireDefault(_syncSectionCheckbox);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _twoColumnRow = __webpack_require__(128);

var _twoColumnRow2 = _interopRequireDefault(_twoColumnRow);

var _dates = __webpack_require__(1984);

var _dates2 = _interopRequireDefault(_dates);

var _staypay = __webpack_require__(1550);

var _staypay2 = _interopRequireDefault(_staypay);

var _daysOfWeek = __webpack_require__(1551);

var _daysOfWeek2 = _interopRequireDefault(_daysOfWeek);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  data: _react2.default.PropTypes.object,
  contractingPeriod: _react2.default.PropTypes.object,
  contractId: _react2.default.PropTypes.string,
  productId: _react2.default.PropTypes.string,
  saving: _react2.default.PropTypes.bool,
  onTextFieldChangeWithKeyPath: _react2.default.PropTypes.func,
  updateDaysOfWeek: _react2.default.PropTypes.func,
  onRequestClose: _react2.default.PropTypes.func,
  saveProductInfoChanges: _react2.default.PropTypes.func,
  goToStep: _react2.default.PropTypes.func
};

var StepOneStayPayOfferWizard = function StepOneStayPayOfferWizard(props) {
  var data = props.data,
      onTextFieldChangeWithKeyPath = props.onTextFieldChangeWithKeyPath,
      _updateDaysOfWeek = props.updateDaysOfWeek,
      goToStep = props.goToStep,
      contractingPeriod = props.contractingPeriod;

  var validDatesOfTravel = data.validDatesOfTravel.filter(function (dateSet) {
    return dateSet.fromDate || dateSet.toDate;
  });
  var validDatesOfSale = data.validDatesOfSale.filter(function (dateSet) {
    return dateSet.fromDate || dateSet.toDate;
  });
  var checkRequiredField = function checkRequiredField() {
    var stayPays = data.stayPays,
        bookingCode = data.bookingCode,
        daysOfWeek = data.daysOfWeek;

    var stayPaysEmpty = stayPays.every(function (stayPay) {
      return !(stayPay.stayDays && stayPay.payDays);
    });
    var validDatesOfTravelEmpty = _ramda2.default.isEmpty(validDatesOfTravel);
    var validDatesOfSaleEmpty = _ramda2.default.isEmpty(validDatesOfSale);
    var daysOfWeekEmpty = _ramda2.default.isEmpty(daysOfWeek);
    if (stayPaysEmpty || !bookingCode || validDatesOfSaleEmpty || validDatesOfTravelEmpty || daysOfWeekEmpty) {
      onTextFieldChangeWithKeyPath({ keyPath: ['data', 'generalError'], value: 'Please fill all required fields.' });
      (0, _lodash2.default)(function () {
        return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'generalError'], value: '' });
      }, 3000)();
      return false;
    }
    return true;
  };
  var checkStayPayValidity = function checkStayPayValidity() {
    var stayPays = data.stayPays;

    if (stayPays.every(function (stayPay) {
      return !(stayPay.stayDays && stayPay.payDays);
    })) {
      onTextFieldChangeWithKeyPath({ keyPath: ['data', 'stayPayError'], value: 'Please enter at least one set of Stay Pay rule.' });
      (0, _lodash2.default)(function () {
        return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'stayPayError'], value: '' });
      }, 3000)();
      return false;
    }
    if (stayPays.some(function (stayPay) {
      return stayPay.stayDays < stayPay.payDays;
    })) {
      onTextFieldChangeWithKeyPath({ keyPath: ['data', 'stayPayError'], value: 'Stay Days have to be more than Pay Days.' });
      (0, _lodash2.default)(function () {
        return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'stayPayError'], value: '' });
      }, 3000)();
      return false;
    }
    if (stayPays.some(function (stayPay) {
      return !stayPay.maxFOC;
    })) {
      onTextFieldChangeWithKeyPath({ keyPath: ['data', 'stayPayError'], value: 'Maximum FOC nights is required.' });
      (0, _lodash2.default)(function () {
        return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'stayPayError'], value: '' });
      }, 3000)();
      return false;
    }
    return true;
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { padding: '24px 12px 0', overflow: 'inherit' } },
      _react2.default.createElement(
        'div',
        { style: { fontSize: '12px', color: 'red' } },
        data.generalError
      ),
      _react2.default.createElement(_twoColumnRow2.default, {
        leftColumnStyle: { position: 'relative', top: '10px', fontSize: '16px', width: '45%' },
        leftColumnContent: _react2.default.createElement(
          'div',
          null,
          'Please enter a booking code that the agent should include at the time of booking.',
          _react2.default.createElement(
            'div',
            { style: { fontSize: '12px', color: '#ff4081' } },
            '* Required'
          )
        ),
        rightColumnStyle: { width: '48%' },
        rightColumnContent: _react2.default.createElement(_typeControlledTextfield2.default, {
          style: { width: '100%', position: 'relative', top: '-20px' },
          value: data.bookingCode,
          floatingLabelText: 'Booking Code',
          onChange: function onChange(_ref) {
            var value = _ref.target.value;
            return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'bookingCode'], value: value });
          }
        })
      }),
      _react2.default.createElement(_dates2.default, {
        data: data,
        disableSalesDates: true,
        contractingPeriod: contractingPeriod,
        onTextFieldChangeWithKeyPath: onTextFieldChangeWithKeyPath
      }),
      _react2.default.createElement(_twoColumnRow2.default, {
        leftColumnStyle: { fontSize: '16px', width: '45%', display: 'flex', justifyContent: 'space-between' },
        leftColumnContent: _react2.default.createElement(
          'div',
          null,
          'Which day(s) of the week does this offer apply to?',
          _react2.default.createElement(
            'span',
            { style: { fontSize: '12px', color: '#ff4081' } },
            '* Required'
          )
        ),
        rightColumnStyle: { width: '48%' },
        rightColumnContent: _react2.default.createElement(_daysOfWeek2.default, {
          daysOfWeek: data.daysOfWeek,
          updateDaysOfWeek: function updateDaysOfWeek(checked, day, dayIndexInReducer) {
            return _updateDaysOfWeek({ checked: checked, day: day, dayIndexInReducer: dayIndexInReducer });
          }
        })
      }),
      _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { height: '104px', display: 'flex', justifyContent: 'space-between' },
        leftColumnStyle: { fontSize: '16px', width: '45%' },
        leftColumnContent: _react2.default.createElement(
          'div',
          null,
          'Please note the details of this special offer. For example, when room upgrades are processed (at booking or check-in), buy one get one free, etc.'
        ),
        rightColumnStyle: { width: '48%', height: '104px', overflowY: 'scroll' },
        rightColumnContent: _react2.default.createElement(_typeControlledTextfield2.default, {
          style: { width: '100%', position: 'relative', top: '-10px' }, multiLine: true,
          floatingLabelText: 'Offer Details',
          value: data.offerDetail,
          onChange: function onChange(_ref2) {
            var value = _ref2.target.value;
            return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'offerDetail'], value: value });
          }
        })
      }),
      _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { height: '68px', display: 'flex', justifyContent: 'space-between' },
        leftColumnStyle: { position: 'relative', top: '20px', fontSize: '16px', width: '45%' },
        leftColumnContent: 'Please enter any special conditions for this offer, if needed.',
        rightColumnStyle: { width: '48%', height: '84px', overflowY: 'scroll' },
        rightColumnContent: _react2.default.createElement(_typeControlledTextfield2.default, {
          style: { width: '100%', position: 'relative', top: '-10px' }, multiLine: true,
          floatingLabelText: 'Special Conditions',
          value: data.specialConditions,
          onChange: function onChange(_ref3) {
            var value = _ref3.target.value;
            return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'specialConditions'], value: value });
          }
        })
      }),
      _react2.default.createElement(
        'div',
        { style: { width: '100%', paddingLeft: '10%' } },
        _react2.default.createElement(_staypay2.default, {
          defaultYes: true,
          staypayApplicable: 'yes',
          stayPayError: data.stayPayError,
          stayPays: data.stayPays,
          updateFieldValue: function updateFieldValue(key, value) {
            return onTextFieldChangeWithKeyPath({ keyPath: ['data', key], value: value });
          }
        })
      ),
      _react2.default.createElement(_twoColumnRow2.default, {
        outerContainerStyle: { height: '68px', display: 'flex', justifyContent: 'space-between', marginBottom: 0 },
        leftColumnStyle: { position: 'relative', top: '20px', fontSize: '16px', width: '45%' },
        leftColumnContent: 'Is this special offer allowed to be combined with other special offers?',
        rightColumnStyle: { width: '48%', height: '48px' },
        rightColumnContent: _react2.default.createElement(
          'div',
          { style: { position: 'relative', top: '20px' } },
          _react2.default.createElement(_materialUi.Toggle, {
            style: { display: 'inline-block', width: '60px' },
            toggled: data.allowCombination,
            onToggle: function onToggle() {
              return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'allowCombination'], value: !data.allowCombination });
            }
          })
        )
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { width: '95%', margin: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
      _react2.default.createElement(_flatButtonWithLoader2.default, {
        secondary: true,
        label: 'Back',
        onTouchTap: function onTouchTap() {
          return onTextFieldChangeWithKeyPath({ keyPath: ['data'], value: _ramda2.default.omit(['isStayPay', data]) });
        },
        labelStyle: { fontWeight: '600' }
      }),
      _react2.default.createElement(
        'div',
        { style: { fontSize: '12px', color: 'red' } },
        data.generalError
      ),
      _react2.default.createElement(_flatButtonWithLoader2.default, {
        secondary: true,
        label: 'Continue',
        onTouchTap: function onTouchTap() {
          if (checkRequiredField() && checkStayPayValidity()) goToStep({ stepperWizardName: 'specialOffersStepper', componentIndex: 1 });
        },
        labelStyle: { fontWeight: '600' }
      })
    )
  );
};
StepOneStayPayOfferWizard.propTypes = propTypes;
exports.default = StepOneStayPayOfferWizard;

/***/ }),
/* 3335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extraMissingInfo = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _contractingPresetNamesCodes = __webpack_require__(464);

var _typeControlledTextfield = __webpack_require__(234);

var _typeControlledTextfield2 = _interopRequireDefault(_typeControlledTextfield);

var _rateTableTemplateContainer = __webpack_require__(632);

var _rateTableTemplateContainer2 = _interopRequireDefault(_rateTableTemplateContainer);

var _taxCurrencyCommissionForm = __webpack_require__(1556);

var _taxCurrencyCommissionForm2 = _interopRequireDefault(_taxCurrencyCommissionForm);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var ratesTableNotValid = _ramda2.default.compose(_ramda2.default.isEmpty, _ramda2.default.reject(_ramda2.default.propOr('', 'notApplicable')), _ramda2.default.propOr([], 'rates'));

var extraMissingInfo = exports.extraMissingInfo = function extraMissingInfo(extra) {
  return !extra.extraType || !(extra.taxInclusion === 'exempt' || extra.taxType) || !extra.taxInclusion || !extra.currency || ratesTableNotValid(extra);
};
var EditExtra = function EditExtra(_ref) {
  var offersOrExtras = _ref.offersOrExtras,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      updateFormData = _ref.updateFormData;

  if (!offersOrExtras.selectedId || isNilOrEmpty(offersOrExtras.list)) return _react2.default.createElement('div', null);
  var selectedIndex = offersOrExtras.list.findIndex(function (o) {
    return o._id === offersOrExtras.selectedId;
  });
  var currentExtra = offersOrExtras.list[selectedIndex];
  var extraType = currentExtra.extraType,
      extraCode = currentExtra.extraCode,
      description = currentExtra.description,
      taxType = currentExtra.taxType,
      taxInclusion = currentExtra.taxInclusion,
      currency = currentExtra.currency,
      rateType = currentExtra.rateType,
      commissionPercentage = currentExtra.commissionPercentage,
      nettCommission = currentExtra.nettCommission;

  var extraNameSelectFields = Object.keys(_contractingPresetNamesCodes.extraNameAndCode).map(function (nameAndCode) {
    return { label: nameAndCode, value: nameAndCode };
  });
  // NonAccomRateTable for soft release
  var updateTableCell = function updateTableCell(_ref2) {
    var value = _ref2.value,
        row = _ref2.row,
        column = _ref2.column;

    onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'list', selectedIndex, 'rates', row, column], value: value });
  };
  return _react2.default.createElement(
    'div',
    { style: { padding: '16px 0' } },
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', marginBottom: '8px' } },
      _react2.default.createElement(
        'div',
        { style: { width: '130px' } },
        ' Extra type ',
        _react2.default.createElement(
          'small',
          { style: { color: 'red', display: !extraType ? 'block' : 'none' } },
          ' * Required'
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '70%' } },
        _react2.default.createElement(_reactSelect2.default, {
          name: 'extraType',
          options: extraNameSelectFields,
          value: extraType,
          onChange: function onChange(_ref3) {
            var value = _ref3.value;
            return onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'list', selectedIndex, 'extraType'], value: value });
          },
          placeholder: 'Please select extra type',
          clearable: false,
          scrollMenuIntoView: false
        })
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', alignItems: 'baseline', marginBottom: '8px' } },
      _react2.default.createElement(
        'div',
        { style: { width: '130px' } },
        'Extra code'
      ),
      _react2.default.createElement(_typeControlledTextfield2.default, {
        id: 'extraCode',
        style: { width: '70%' },
        hintText: _contractingPresetNamesCodes.extraNameAndCode[extraType],
        value: extraCode || '',
        onChange: function onChange(_ref4) {
          var value = _ref4.target.value;
          return onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'list', selectedIndex, 'extraCode'], value: value });
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', alignItems: 'baseline', marginBottom: '8px' } },
      _react2.default.createElement(
        'div',
        { style: { width: '130px' } },
        'Description'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '70%' } },
        _react2.default.createElement('textarea', {
          id: 'description',
          rows: 8,
          defaultValue: description,
          onChange: function onChange(_ref5) {
            var value = _ref5.target.value;
            return onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'list', selectedIndex, 'description'], value: value });
          }
        })
      )
    ),
    _react2.default.createElement(_taxCurrencyCommissionForm2.default, {
      taxInclusion: taxInclusion,
      taxType: taxType,
      currency: currency,
      rateType: rateType,
      commissionPercentage: commissionPercentage,
      nettCommission: nettCommission,
      updateFunc: function updateFunc(field, value) {
        if (['taxInclusion', 'taxType', 'currency'].indexOf(field) > -1) {
          updateFormData({ keyPath: ['offersOrExtras', 'list', selectedIndex, field], fieldName: field, value: value.trim() }, 'ON_CHANGE_TEXTFIELD_WITH_KEYPATH_IN_ADD_EDIT_DIALOG', 'location');
        } else {
          onTextFieldChangeWithKeyPath({
            keyPath: ['offersOrExtras', 'list', selectedIndex, field],
            value: value
          });
        }
      }
    }),
    _react2.default.createElement(_rateTableTemplateContainer2.default, { productType: 'Non-Accommodation', withEditableCell: true, rateSet: _extends({}, currentExtra), updateTableCell: updateTableCell }),
    ratesTableNotValid(currentExtra) && _react2.default.createElement(
      'div',
      { style: { color: 'red' } },
      'At least one rate detail is required.'
    )
  );
};

exports.default = EditExtra;

/***/ }),
/* 3336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _stepperWizard = __webpack_require__(1139);

var _stepperWizard2 = _interopRequireDefault(_stepperWizard);

var _stepAddExtra = __webpack_require__(1987);

var _stepAddExtra2 = _interopRequireDefault(_stepAddExtra);

var _stepAddExtra3 = __webpack_require__(3337);

var _stepAddExtra4 = _interopRequireDefault(_stepAddExtra3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AddExtra = function AddExtra(_ref) {
  var RatesFormAndTable = _ref.RatesFormAndTable,
      addExtraStepper = _ref.addExtraStepper,
      updateCellValueForOfferRates = _ref.updateCellValueForOfferRates,
      extraProps = _objectWithoutProperties(_ref, ['RatesFormAndTable', 'addExtraStepper', 'updateCellValueForOfferRates']);

  var stepNames = ['Add information', 'Review Rate Table'];
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _stepperWizard2.default,
      {
        steps: stepNames,
        componentIndex: addExtraStepper,
        showStepsBar: true
      },
      _react2.default.createElement(_stepAddExtra2.default, _extends({}, extraProps, { extraRates: RatesFormAndTable })),
      _react2.default.createElement(_stepAddExtra4.default, _extends({}, extraProps, { extraRates: RatesFormAndTable, updateTableCell: updateCellValueForOfferRates }))
    )
  );
};

exports.default = AddExtra;

/***/ }),
/* 3337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _rateTableTemplateContainer = __webpack_require__(632);

var _rateTableTemplateContainer2 = _interopRequireDefault(_rateTableTemplateContainer);

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var StepTwo = function StepTwo(_ref) {
  var offersOrExtras = _ref.offersOrExtras,
      onTextFieldChangeWithKeyPath = _ref.onTextFieldChangeWithKeyPath,
      updateTableCell = _ref.updateTableCell,
      extraRates = _ref.extraRates,
      goToStep = _ref.goToStep,
      saving = _ref.saving,
      data = _ref.data,
      clearAddRateSetWizard = _ref.clearAddRateSetWizard;

  var fontFamily = "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif";
  var dataToSave = _extends({}, data, {
    _id: 'new-' + _nodeUuid2.default.v1(),
    nonStandardTemplateType: extraRates.nonStandardTemplateType,
    commissionPercentage: extraRates.commissionPercentage,
    rateType: extraRates.rateType,
    nettCommission: extraRates.nettCommission,
    rates: extraRates.rates,
    taxType: extraRates.taxType,
    currency: extraRates.currency,
    taxInclusion: extraRates.taxInclusion
  });
  return _react2.default.createElement(
    'div',
    { style: { fontFamily: fontFamily } },
    _react2.default.createElement(
      'div',
      { style: { padding: '24px 10%' } },
      _react2.default.createElement(
        'div',
        { style: { marginBottom: '12px' } },
        'Extra type: ',
        _react2.default.createElement(
          'b',
          null,
          data.extraType
        )
      ),
      data.extraCode ? _react2.default.createElement(
        'div',
        { style: { marginBottom: '12px' } },
        'Extra code: ',
        _react2.default.createElement(
          'b',
          null,
          data.extraCode
        )
      ) : undefined,
      data.description ? _react2.default.createElement(
        'div',
        { style: { marginBottom: '12px' } },
        'Description: ',
        _react2.default.createElement(
          'b',
          null,
          data.description
        )
      ) : undefined,
      _react2.default.createElement(_rateTableTemplateContainer2.default, {
        productType: 'Non-Accommodation',
        withEditableCell: true,
        rateSet: _extends({}, extraRates),
        updateTableCell: updateTableCell
      })
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', justifyContent: 'space-between', marginTop: '16px', alignItems: 'center' } },
      _react2.default.createElement(_flatButtonWithLoader2.default, {
        label: 'back',
        secondary: true,
        onTouchTap: function onTouchTap() {
          return goToStep({ stepperWizardName: 'addExtraStepper', componentIndex: 0 });
        }
      }),
      _react2.default.createElement(_flatButtonWithLoader2.default, {
        label: 'Add Another',
        loader: saving,
        hoverColor: 'none',
        labelStyle: { fontWeight: '600' },
        onTouchTap: function onTouchTap() {
          if (dataToSave.ratePackages && dataToSave.ratePackages.length) {
            onTextFieldChangeWithKeyPath({
              keyPath: [],
              value: {
                offersOrExtras: _extends({}, offersOrExtras, {
                  list: [].concat(_toConsumableArray(offersOrExtras.list), [dataToSave]),
                  selectedId: dataToSave._id,
                  createNew: true
                }),
                data: {
                  title: data.title,
                  ratePackages: offersOrExtras.productsArray.map(function (o) {
                    return o._id;
                  })
                }
              }
            });
            goToStep({ stepperWizardName: 'addExtraStepper', componentIndex: 0 });
            clearAddRateSetWizard();
          } else {
            window.alert('Please select at least one room type/product this offer should apply to.');
          }
        },
        secondary: true
      })
    )
  );
};

exports.default = StepTwo;

/***/ }),
/* 3338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpdateProductName = function UpdateProductName(props) {
  var newProductName = props.data.newProductName,
      productId = props.productId,
      onTextFieldChangeWithKeyPath = props.onTextFieldChangeWithKeyPath,
      onRequestClose = props.onRequestClose,
      editProductProfile = props.editProductProfile,
      locationId = props.locationId,
      contractId = props.contractId;

  var onSave = function onSave() {
    return editProductProfile({ contractId: contractId, productId: productId, updateBody: newProductName, updateField: 'productName', locationId: locationId });
  };
  return _react2.default.createElement(
    'div',
    { style: { width: '95%', margin: 'auto' } },
    _react2.default.createElement(_materialUi.TextField, {
      value: newProductName,
      onChange: function onChange(e) {
        return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'newProductName'], value: e.target.value });
      }
    }),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', flexDirection: 'row-reverse' } },
      _react2.default.createElement(
        'div',
        { className: 'flex-center' },
        _react2.default.createElement(_materialUi.FlatButton, {
          label: 'Cancel',
          primary: true,
          onClick: onRequestClose
        }),
        _react2.default.createElement(_materialUi.FlatButton, {
          label: 'Save',
          secondary: true,
          onClick: onSave
        })
      )
    )
  );
};

exports.default = UpdateProductName;

/***/ }),
/* 3339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _beddingConfig = __webpack_require__(1528);

var _beddingConfig2 = _interopRequireDefault(_beddingConfig);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpdateBeddingConfig = function UpdateBeddingConfig(props) {
  var bedsAndSofas = props.data.bedsAndSofas,
      productId = props.productId,
      onRequestClose = props.onRequestClose,
      onTextFieldChangeWithKeyPath = props.onTextFieldChangeWithKeyPath,
      editProductProfile = props.editProductProfile,
      locationId = props.locationId,
      contractId = props.contractId;

  var onSave = function onSave() {
    return editProductProfile({ contractId: contractId, productId: productId, updateBody: bedsAndSofas, updateField: 'bedsAndSofas', locationId: locationId });
  };
  var sendEditToReducer = function sendEditToReducer(_ref) {
    var value = _ref.value,
        isBeddingConfigInvalid = _ref.isBeddingConfigInvalid;
    return onTextFieldChangeWithKeyPath({
      keyPath: ['data'],
      value: _extends({}, props.data, {
        bedsAndSofas: value,
        isBeddingConfigInvalid: isBeddingConfigInvalid
      })
    });
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_beddingConfig2.default, {
      beddingConfig: bedsAndSofas,
      sendEditToReducer: sendEditToReducer
    }),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', flexDirection: 'row-reverse' } },
      _react2.default.createElement(
        'div',
        { className: 'flex-center' },
        _react2.default.createElement(_materialUi.FlatButton, {
          label: 'Cancel',
          primary: true,
          onClick: onRequestClose
        }),
        _react2.default.createElement(_materialUi.FlatButton, {
          label: 'Save',
          secondary: true,
          onClick: onSave
        })
      )
    )
  );
};

exports.default = UpdateBeddingConfig;

/***/ }),
/* 3340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _contractingYear = __webpack_require__(1539);

var _contractingYear2 = _interopRequireDefault(_contractingYear);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditContractPeriod = function EditContractPeriod(props) {
  var contractId = props.contractId,
      onTextFieldChangeWithKeyPath = props.onTextFieldChangeWithKeyPath,
      saving = props.saving,
      onRequestClose = props.onRequestClose,
      _props$data = props.data,
      newStartDate = _props$data.newStartDate,
      newEndDate = _props$data.newEndDate,
      saveSupplierInfoChanges = props.saveSupplierInfoChanges;

  var onClickSave = function onClickSave() {
    return saveSupplierInfoChanges({ contractId: contractId, data: { newStartDate: newStartDate, newEndDate: newEndDate }, updateType: 'SAVE_CONTRACT_PERIOD' });
  };
  var onDateChange = function onDateChange(key, value) {
    return onTextFieldChangeWithKeyPath({
      keyPath: ['data', 'new' + (key === 'startDate' ? 'StartDate' : 'EndDate')],
      value: value
    });
  };
  return _react2.default.createElement(
    'div',
    { style: { padding: '0 12px 12px 12px' } },
    _react2.default.createElement(
      'div',
      { style: { padding: '20px' } },
      _react2.default.createElement(_contractingYear2.default, {
        required: true,
        startDate: newStartDate,
        endDate: newEndDate,
        onChange: onDateChange
      })
    ),
    _react2.default.createElement(_stepperActions2.default, {
      rightButtons: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Dismiss',
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onClick: onRequestClose
        }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Save',
          loader: saving,
          onClick: onClickSave,
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          secondary: true
        })
      )
    })
  );
};

EditContractPeriod.propTypes = {
  onTextFieldChangeWithKeyPath: _react.PropTypes.func,
  saving: _react.PropTypes.bool,
  onRequestClose: _react.PropTypes.func,
  saveSupplierInfoChanges: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  data: _react.PropTypes.object
};

exports.default = EditContractPeriod;

/***/ }),
/* 3341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpdateLocationName = function UpdateLocationName(props) {
  var newLocationName = props.data.newLocationName,
      onTextFieldChangeWithKeyPath = props.onTextFieldChangeWithKeyPath,
      onRequestClose = props.onRequestClose,
      saveSupplierInfoChanges = props.saveSupplierInfoChanges,
      locationId = props.locationId,
      contractId = props.contractId;

  var onSave = function onSave() {
    return saveSupplierInfoChanges({
      contractId: contractId,
      data: { newLocationName: newLocationName },
      updateType: 'SAVE_LOCATION_NAME'
    });
  };
  return _react2.default.createElement(
    'div',
    { style: { width: '95%', margin: 'auto' } },
    _react2.default.createElement(_materialUi.TextField, {
      id: 'locName',
      value: newLocationName,
      onChange: function onChange(e) {
        return onTextFieldChangeWithKeyPath({ keyPath: ['data', 'newLocationName'], value: e.target.value });
      }
    }),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', flexDirection: 'row-reverse' } },
      _react2.default.createElement(
        'div',
        { className: 'flex-center' },
        _react2.default.createElement(_materialUi.FlatButton, {
          label: 'Cancel',
          primary: true,
          onClick: onRequestClose
        }),
        _react2.default.createElement(_materialUi.FlatButton, {
          label: 'Save',
          secondary: true,
          onClick: onSave
        })
      )
    )
  );
};

exports.default = UpdateLocationName;

/***/ }),
/* 3342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(27);

var _reactRedux = __webpack_require__(6);

var _forBuyer = __webpack_require__(3343);

var _forBuyer2 = _interopRequireDefault(_forBuyer);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  viewingBy: _react2.default.PropTypes.string,
  locationId: _react2.default.PropTypes.string,
  files: _react2.default.PropTypes.array,
  state: _react2.default.PropTypes.string,
  isTourPlanUser: _react2.default.PropTypes.bool,
  supplierId: _react2.default.PropTypes.string,
  messageArray: _react2.default.PropTypes.array,
  emailStatus: _react2.default.PropTypes.number,
  viewingCompanyId: _react2.default.PropTypes.string,
  buyerChecked: _react2.default.PropTypes.bool,
  isLatest: _react2.default.PropTypes.bool,
  push: _react2.default.PropTypes.func
};

var ProgressBarContainer = function (_React$Component) {
  _inherits(ProgressBarContainer, _React$Component);

  function ProgressBarContainer(props) {
    _classCallCheck(this, ProgressBarContainer);

    var _this = _possibleConstructorReturn(this, (ProgressBarContainer.__proto__ || Object.getPrototypeOf(ProgressBarContainer)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(ProgressBarContainer, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          viewingBy = _props.viewingBy,
          extraProps = _objectWithoutProperties(_props, ['viewingBy']);

      return _react2.default.createElement(
        'div',
        { style: { marginBottom: '8px' } },
        viewingBy === 'Contractor' && extraProps.isLatest && extraProps.locationId ? _react2.default.createElement(_forBuyer2.default, extraProps) : _react2.default.createElement('div', null)
      );
    }
  }]);

  return ProgressBarContainer;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user;
  return _extends({
    userNameOrEmail: user.getIn(['user', 'name']) || user.getIn(['user', 'email']),
    viewingBy: user.getIn(['user', 'type']),
    viewingCompanyId: user.getIn(['company', 'companyId']),
    isTourPlanUser: Boolean(_ramda2.default.path(['company', 'tourplan', 'url'], user.toJS()))
  }, contracting.contractActivitiesProducts.toJS().leftNav, contracting.contractActivitiesProducts.toJS().activities);
};

var mapDispatchToProps = {
  push: _reactRouterRedux.push
};
ProgressBarContainer.propTypes = propTypes;
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ProgressBarContainer);

/***/ }),
/* 3343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _supplierWizardComplete = __webpack_require__(1057);

var _supplierWizardComplete2 = _interopRequireDefault(_supplierWizardComplete);

var _materialUi = __webpack_require__(3);

var _contractingUtils = __webpack_require__(124);

var _basicBox = __webpack_require__(3344);

var _basicBox2 = _interopRequireDefault(_basicBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  viewingBy: _react2.default.PropTypes.string,
  locationId: _react2.default.PropTypes.string,
  files: _react2.default.PropTypes.array,
  state: _react2.default.PropTypes.string,
  isTourPlanUser: _react2.default.PropTypes.bool,
  supplierId: _react2.default.PropTypes.string,
  messageArray: _react2.default.PropTypes.array,
  emailStatus: _react2.default.PropTypes.number,
  viewingCompanyId: _react2.default.PropTypes.string,
  contractId: _react2.default.PropTypes.string,
  changeContractStateTo: _react2.default.PropTypes.func,
  resendContract: _react2.default.PropTypes.func,
  userNameOrEmail: _react2.default.PropTypes.string,
  buyerChecked: _react2.default.PropTypes.bool,
  viewedBy: _react2.default.PropTypes.array,
  from: _react2.default.PropTypes.object,
  rateContainer: _react2.default.PropTypes.object,
  push: _react2.default.PropTypes.func
};

var BuyerContractProgressBar = function (_Component) {
  _inherits(BuyerContractProgressBar, _Component);

  function BuyerContractProgressBar(props) {
    _classCallCheck(this, BuyerContractProgressBar);

    var _this = _possibleConstructorReturn(this, (BuyerContractProgressBar.__proto__ || Object.getPrototypeOf(BuyerContractProgressBar)).call(this, props));

    _this.setHoveringFalse = function () {
      _this.setState({ hovering: false });
    };

    _this.setHoveringTrue = function () {
      _this.setState({ hovering: true });
    };

    _this._handleAcceptContract = function () {
      window.dataLayer.push({
        event: 'TRACK_EVENT',
        ev: {
          category: 'Contract Top Bar Clicked',
          action: 'accepted'
        }
      });
      _this.props.changeContractStateTo('accepted', _defineProperty({}, _this.props.contractId, _this.props.contractId));
    };

    _this._handleLoadingContract = function () {
      window.dataLayer.push({
        event: 'TRACK_EVENT',
        ev: {
          category: 'Contract Top Bar Clicked',
          action: 'loading'
        }
      });
      _this.props.changeContractStateTo('loading', _defineProperty({}, _this.props.contractId, _this.props.contractId));
    };

    _this._handleLoadContract = function () {
      window.dataLayer.push({
        event: 'TRACK_EVENT',
        ev: {
          category: 'Contract Top Bar Clicked',
          action: 'loaded'
        }
      });
      _this.props.changeContractStateTo('loaded', _defineProperty({}, _this.props.contractId, _this.props.contractId));
    };

    _this._handleRejectContract = function () {
      return _this.props.changeContractStateTo('rejected', _defineProperty({}, _this.props.contractId, _this.props.contractId));
    };

    _this._markContractAsReceived = function () {
      return _this.props.changeContractStateTo('received externally', _defineProperty({}, _this.props.contractId, _this.props.contractId));
    };

    _this._markContractAsNOTReceived = function () {
      return _this.props.changeContractStateTo('sent', _defineProperty({}, _this.props.contractId, _this.props.contractId));
    };

    _this.state = {
      hovering: false
    };
    return _this;
  }

  _createClass(BuyerContractProgressBar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          locationId = _props.locationId,
          state = _props.state,
          contractId = _props.contractId,
          messageArray = _props.messageArray,
          buyerChecked = _props.buyerChecked,
          emailStatus = _props.emailStatus,
          userNameOrEmail = _props.userNameOrEmail,
          from = _props.from,
          rateContainer = _props.rateContainer,
          buyerCreatedFrom = _props.buyerCreatedFrom,
          push = _props.push;

      if (!messageArray) return _react2.default.createElement('div', null);
      var selfLoaded = Boolean(from && from.email.indexOf('dl+') > -1);
      var firstMsg = _ramda2.default.last(messageArray) || {};
      var initiatedByBuyer = firstMsg.isSender;
      var loadedLogs = messageArray.filter(function (msg) {
        return _ramda2.default.pathOr([], ['bodyJson', 'contracts'], msg).some(function (obj) {
          return obj.currentVersionId === contractId && obj.statusChanged === 'loaded';
        });
      });
      var loadingLogs = messageArray.filter(function (msg) {
        return _ramda2.default.pathOr([], ['bodyJson', 'contracts'], msg).some(function (obj) {
          return obj.currentVersionId === contractId && obj.statusChanged === 'loading';
        });
      });
      var acceptedLogs = messageArray.filter(function (msg) {
        return _ramda2.default.pathOr([], ['bodyJson', 'contracts'], msg).some(function (obj) {
          return obj.currentVersionId === contractId && obj.statusChanged === 'accepted';
        });
      });
      var rejectedLogs = messageArray.filter(function (msg) {
        return _ramda2.default.pathOr([], ['bodyJson', 'contracts'], msg).some(function (obj) {
          return obj.currentVersionId === contractId && obj.statusChanged === 'rejected';
        });
      });
      var hovering = this.state.hovering;
      var isSent = initiatedByBuyer;
      var isBounced = Boolean(initiatedByBuyer && emailStatus === 1);
      var openEvent = initiatedByBuyer && firstMsg.events && _ramda2.default.values(firstMsg.events).length && _ramda2.default.values(firstMsg.events).find(function (obj) {
        return obj.event === 'open';
      });
      var deliverEvent = initiatedByBuyer && firstMsg.events && _ramda2.default.values(firstMsg.events).length && _ramda2.default.values(firstMsg.events).find(function (obj) {
        return obj.event === 'delivered';
      });
      var isDelivered = initiatedByBuyer && (emailStatus > 1 || Boolean(deliverEvent));
      var isOpened = Boolean(openEvent);
      var ratesReceived = Boolean(locationId) || buyerChecked;
      var isRejected = state === 'rejected';
      var isAccepted = state === 'accepted';
      var isLoaded = state === 'loaded';
      var isLoading = state === 'loading';
      var valueMap = {
        loaded: 11,
        loading: 10,
        accepted: 9,
        rejected: 8,
        ratesReceived: 7,
        opened: 6,
        delivered: 5,
        bounced: 4,
        sent: 3
      };
      var currentState = function () {
        if (isLoaded) return 11;
        if (isLoading) return 10;
        if (isAccepted) return 9;
        if (isRejected) return 8;
        if (ratesReceived) return 7;
        if (isOpened) return 6;
        if (isDelivered) return 5;
        if (isBounced) return 4;
        if (isSent) return 3;
      }();
      return _react2.default.createElement(
        'div',
        { className: 'flex-tc-sb', style: { position: 'relative' }, onMouseEnter: this.setHoveringTrue, onMouseLeave: this.setHoveringFalse },
        _react2.default.createElement(_basicBox2.default, {
          content: function () {
            if (selfLoaded) {
              if (buyerCreatedFrom) return 'Created from Supplier-Sent Contract';
              return 'Created from Workspace';
            }
            return 'Received from Supplier';
          }(),
          buttonLabel: function () {
            if (selfLoaded) {
              if (buyerCreatedFrom) return 'Go To Contract';
              return 'Go To Workspace';
            }
          }(),
          style: { flex: 'auto' },
          hovering: Boolean(selfLoaded && hovering),
          onClick: function onClick() {
            if (selfLoaded && rateContainer) {
              if (buyerCreatedFrom) return push('/contracting/contract/' + buyerCreatedFrom.split('|')[0] + '/policies');
              return push('/contracting/contract/' + rateContainer.id + '/policies');
            }
          },
          actorName: (firstMsg.creatorMeta || {}).name || firstMsg.creatorEmail,
          ts: selfLoaded ? firstMsg.createdAt : null,
          done: true
        }),
        isRejected && _react2.default.createElement(_basicBox2.default, {
          content: _react2.default.createElement(
            'div',
            { className: 'flex-center', style: { color: (0, _contractingUtils.getStatusColor)('rejected') } },
            _react2.default.createElement(_materialUi.FontIcon, { className: (0, _contractingUtils.getStatusIcon)('rejected'), color: (0, _contractingUtils.getStatusColor)('rejected') }),
            '\xA0Rejected'
          ),
          style: { color: '#e53935', flex: 'auto', width: '20%', fontWeight: 'bold' },
          noArrow: true,
          done: true,
          actorName: function () {
            if (rejectedLogs && rejectedLogs.length) {
              return _ramda2.default.pathOr('', ['creatorMeta', 'name'], _ramda2.default.last(rejectedLogs)) || _ramda2.default.last(rejectedLogs).creatorEmail;
            }
            return userNameOrEmail;
          }(),
          ts: function () {
            if (rejectedLogs && rejectedLogs.length) return _ramda2.default.last(rejectedLogs).createdAt;
            return new Date().toISOString();
          }()
        }),
        _react2.default.createElement(_basicBox2.default, {
          content: currentState >= valueMap.accepted ? _react2.default.createElement(
            'div',
            { className: 'flex-center', style: { color: (0, _contractingUtils.getStatusColor)('accepted') } },
            _react2.default.createElement(_materialUi.FontIcon, { className: (0, _contractingUtils.getStatusIcon)('accepted'), color: (0, _contractingUtils.getStatusColor)('accepted') }),
            '\xA0Accepted'
          ) : 'Accepted',
          style: { flex: 'auto' },
          hovering: hovering,
          tooltip: currentState < 8 && 'Click to accept this contract',
          onClick: state !== 'accepted' && this._handleAcceptContract,
          done: currentState >= valueMap.accepted,
          buttonLabel: 'Mark as Accepted',
          actorName: function () {
            if (state === 'accepted' || state === 'loading' || state === 'loaded') {
              if (acceptedLogs && acceptedLogs.length) {
                return _ramda2.default.pathOr('', ['creatorMeta', 'name'], _ramda2.default.last(acceptedLogs)) || _ramda2.default.pathOr('', ['creatorMeta', 'realActorEmail'], _ramda2.default.last(acceptedLogs)) || _ramda2.default.last(acceptedLogs).creatorEmail;
              }
              if (loadingLogs && loadingLogs.length) {
                return _ramda2.default.pathOr('', ['creatorMeta', 'name'], _ramda2.default.last(loadingLogs)) || _ramda2.default.last(loadingLogs).creatorEmail;
              }
              if (loadedLogs && loadedLogs.length) {
                return _ramda2.default.pathOr('', ['creatorMeta', 'name'], _ramda2.default.last(loadedLogs)) || _ramda2.default.last(loadedLogs).creatorEmail;
              }
              return userNameOrEmail;
            }
          }(),
          ts: function () {
            if (state === 'accepted' || state === 'loading' || state === 'loaded') {
              if (acceptedLogs && acceptedLogs.length) return _ramda2.default.last(acceptedLogs).createdAt;
              if (loadingLogs && loadingLogs.length) return _ramda2.default.last(loadingLogs).createdAt;
              if (loadedLogs && loadedLogs.length) return _ramda2.default.last(loadedLogs).createdAt;
              return new Date().toISOString();
            }
          }()
        }),
        _react2.default.createElement(_basicBox2.default, {
          content: currentState >= 10 ? _react2.default.createElement(
            'div',
            { className: 'flex-center', style: { color: (0, _contractingUtils.getStatusColor)('loading') } },
            _react2.default.createElement(_materialUi.FontIcon, { className: (0, _contractingUtils.getStatusIcon)('loading'), color: (0, _contractingUtils.getStatusColor)('loading') }),
            '\xA0Loading'
          ) : 'Loading',
          style: { flex: 'auto' },
          hovering: hovering,
          tooltip: currentState < 10 && state !== 'rejected' && 'Click to mark this contract as loading',
          onClick: state !== 'rejected' && this._handleLoadingContract,
          done: currentState >= 10,
          buttonLabel: 'Mark as Loading',
          actorName: function () {
            if (state === 'loading' || state === 'loaded') {
              if (loadingLogs && loadingLogs.length) {
                return _ramda2.default.pathOr('', ['creatorMeta', 'name'], _ramda2.default.last(loadingLogs)) || _ramda2.default.last(loadingLogs).creatorEmail;
              }
              if (loadedLogs && loadedLogs.length) {
                return _ramda2.default.pathOr('', ['creatorMeta', 'name'], _ramda2.default.last(loadedLogs)) || _ramda2.default.last(loadedLogs).creatorEmail;
              }
              return userNameOrEmail;
            }
          }(),
          ts: function () {
            if (state === 'loading' || state === 'loaded') {
              if (loadingLogs && loadingLogs.length) return _ramda2.default.last(loadingLogs).createdAt;
              if (loadedLogs && loadedLogs.length) return _ramda2.default.last(loadedLogs).createdAt;
              return new Date().toISOString();
            }
          }()
        }),
        _react2.default.createElement(_basicBox2.default, {
          content: isLoaded ? _react2.default.createElement(
            'span',
            { className: 'flex-tc-sb' },
            _react2.default.createElement('img', { src: _supplierWizardComplete2.default, style: { height: '24px' } }),
            ' Loaded ',
            _react2.default.createElement('img', { src: _supplierWizardComplete2.default, style: { height: '24px' } })
          ) : 'Loaded',
          hovering: hovering,
          tooltip: currentState < 11 && state !== 'rejected' && 'Click to mark this contract as loaded',
          onClick: state !== 'loaded' && this._handleLoadContract,
          style: { flex: 'auto', borderRight: '1px solid #e0e0e0' },
          done: isLoaded,
          buttonLabel: 'Mark as Loaded',
          noArrow: true,
          actorName: function () {
            if (state === 'loaded') {
              if (loadedLogs && loadedLogs.length) {
                return _ramda2.default.pathOr('', ['creatorMeta', 'name'], _ramda2.default.last(loadedLogs)) || _ramda2.default.last(loadedLogs).creatorEmail;
              }
              return userNameOrEmail;
            }
          }(),
          ts: function () {
            if (state === 'loaded') {
              if (loadedLogs && loadedLogs.length) return _ramda2.default.last(loadedLogs).createdAt;
              return new Date().toISOString();
            }
          }()
        }),
        !initiatedByBuyer && _react2.default.createElement(
          'div',
          {
            className: 'flag-across-progress-bar',
            style: { backgroundColor: '#546e7a', width: '32%', position: 'absolute', top: '74px' }
          },
          'Contract was inititated by Supplier'
        )
      );
    }
  }]);

  return BuyerContractProgressBar;
}(_react.Component);

BuyerContractProgressBar.propTypes = propTypes;

exports.default = BuyerContractProgressBar;

/***/ }),
/* 3344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _contractingUtils = __webpack_require__(124);

var _smallButtons = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tsStyle = {
  textAlign: 'left',
  fontSize: '10px',
  height: '16px',
  lineHeight: '16px',
  padding: '0 16px',
  textOverflow: 'ellipsis',
  overflowX: 'hidden',
  whiteSpace: 'nowrap'
};

var BasicBox = function BasicBox(_ref) {
  var content = _ref.content,
      ts = _ref.ts,
      done = _ref.done,
      isSupplierAction = _ref.isSupplierAction,
      noArrow = _ref.noArrow,
      tooltip = _ref.tooltip,
      style = _ref.style,
      inactive = _ref.inactive,
      collapsed = _ref.collapsed,
      onClick = _ref.onClick,
      hovering = _ref.hovering,
      buttonLabel = _ref.buttonLabel,
      actorName = _ref.actorName;

  var doneClass = isSupplierAction ? 'supplier-step-done' : 'buyer-step-done';
  var showBanner = !done && !inactive;

  var innerBoxStyle = { lineHeight: '48px', height: '48px', marginTop: collapsed ? '' : '4px', textAlign: 'left', width: '100%', paddingLeft: '16px' };
  return _react2.default.createElement(
    'div',
    {
      style: _extends({
        width: '0',
        height: collapsed ? '50px' : '88px',
        border: '1px solid #e0e0e0',
        borderBottom: '4px solid #e0e0e0',
        borderRight: 'none',
        cursor: onClick ? 'pointer' : ''
      }, style),
      onClick: onClick,
      className: (noArrow ? '' : 'right-arrow-box') + ' ' + (done && !inactive ? doneClass : '')
    },
    showBanner ? _react2.default.createElement(
      'div',
      {
        className: 'flag-across-progress-bar',
        style: {
          marginTop: collapsed ? '' : '4px',
          backgroundColor: (0, _contractingUtils.getActionIndicatorColor)({ viewingBy: 'Contractor', ratesReceived: !isSupplierAction })
        }
      },
      isSupplierAction ? 'Waiting on Supplier' : 'Needs Your Attention'
    ) : _react2.default.createElement('div', { style: { height: '14px' } }),
    _react2.default.createElement(
      'div',
      {
        className: tooltip ? 'hint--top' : '',
        'aria-label': tooltip,
        style: _extends({}, innerBoxStyle, {
          color: done && !inactive ? '' : '#b4b4b4'
        })
      },
      hovering && onClick ? _react2.default.createElement(_smallButtons.JiraFlatButton, { label: buttonLabel, style: { border: '1px solid #e0e0e0' }, labelStyle: { color: '#5E6C84', padding: '0 4px' } }) : _react2.default.createElement(
        'div',
        { style: { padding: '0 5px' } },
        content
      )
    ),
    _react2.default.createElement(
      'div',
      {
        style: _extends({}, tsStyle, {
          visibility: !collapsed && Boolean(ts) && !inactive ? 'visible' : 'hidden'
        })
      },
      (0, _moment2.default)(isNaN(ts) ? ts : ts * 1000).calendar(null, {
        sameDay: 'h:mm a',
        lastDay: '[Yesterday] h:mm a',
        lastWeek: '[Last] dddd',
        sameElse: 'DD MMM YYYY'
      }),
      actorName ? ' by ' + actorName : ''
    )
  );
};

exports.default = BasicBox;

/***/ }),
/* 3345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_CONTRACT_LISTING0 = exports.GET_CONTRACT_LISTING0 = 'GET_CONTRACT_LISTING0';

var dashboardActions = exports.dashboardActions = {
  expandListItem: 'EXPAND_LIST_ITEM',
  collapseListItem: 'COLLAPSE_LIST_ITEM',
  selectListItem: 'SELECT_LIST_ITEM',
  selectAllListItems: 'SELECT_ALL_LIST_ITEMS',
  checkOneContract: 'CHECK_ONE_CONTRACT',
  checkAllContracts: 'CHECK_ALL_CONTRACTS',
  uncheckOneContract: 'UNCHECK_ONE_CONTRACT',
  uncheckAllContracts: 'UNCHECK_ALL_CONTRACTS',
  checkAllLocations: 'CHECK_ALL_LOCATIONS',
  uncheckAllLocations: 'UNCHECK_ALL_LOCATIONS',
  checkOneLocation: 'CHECK_ONE_LOCATION',
  uncheckOneLocation: 'UNCHECK_ONE_LOCATION',
  searchContracts: 'FILTER_BY_SEARCH_FRONT_END',
  expandCompanyInContractListing: 'EXPAND_COMPANY_IN_CONTRACT_LISTING',
  sortCompanyNameFnInContractListing: 'SORT_COMPANY_NAME_IN_CONTRACT_LISTING',
  toggleTimeStampFn: 'TOGGLE_TIME_STAMP_IN_CONTRACT_LISTING'
};

/***/ }),
/* 3346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _datePicker = __webpack_require__(1003);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _openInNew = __webpack_require__(1962);

var _openInNew2 = _interopRequireDefault(_openInNew);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

__webpack_require__(250); // FOR STORYBOOK
var propTypes = {
  open: _react.PropTypes.bool,
  closeResendContractDialog: _react.PropTypes.func,
  BCCToSelf: _react.PropTypes.bool,
  includeNotes: _react.PropTypes.bool,
  companyName: _react.PropTypes.string,
  companyProfileImage: _react.PropTypes.string,
  customizedMessage: _react.PropTypes.string,
  companyType: _react.PropTypes.string,
  email: _react.PropTypes.string,
  finishedSendingEmail: _react.PropTypes.bool,
  updateProps: _react.PropTypes.func,
  dispatchResendContract: _react.PropTypes.func,
  onBCCSelfCheck: _react.PropTypes.func,
  submissionCriteria: _react.PropTypes.string,
  loading: _react.PropTypes.bool,
  isExternal: _react.PropTypes.bool,
  editEmail: _react.PropTypes.bool,
  newEmail: _react.PropTypes.string,
  updatePartnerForAllContracts: _react.PropTypes.bool,
  doNotSendEmail: _react.PropTypes.bool,
  updatePartnerForSentDoc: _react.PropTypes.func,
  newPartnerName: _react.PropTypes.string,
  changesSaved: _react.PropTypes.bool,
  resendToEmails: _react.PropTypes.array,
  to: _react.PropTypes.object,
  toEmails: _react.PropTypes.array,
  partner: _react.PropTypes.object,
  subject: _react.PropTypes.string,
  deadlineDate: _react.PropTypes.string
};
var ResendContractComponent = function ResendContractComponent(props) {
  var open = props.open,
      closeResendContractDialog = props.closeResendContractDialog,
      loading = props.loading,
      subject = props.subject,
      customizedMessage = props.customizedMessage,
      finishedSendingEmail = props.finishedSendingEmail,
      updateProps = props.updateProps,
      dispatchResendContract = props.dispatchResendContract,
      resendToEmails = props.resendToEmails,
      changesSaved = props.changesSaved,
      deadlineDate = props.deadlineDate,
      _props$partner = props.partner,
      partner = _props$partner === undefined ? {} : _props$partner;

  var isSupplier = props.companyType === 'Supplier';
  var onCheckAContact = function onCheckAContact(email) {
    return function (_, checked) {
      if (checked) {
        updateProps({
          resendToEmails: [].concat(_toConsumableArray(resendToEmails), [email])
        });
      } else {
        updateProps({
          resendToEmails: resendToEmails.filter(function (x) {
            return x !== email;
          })
        });
      }
    };
  };
  var onChangeDeadlineDate = function onChangeDeadlineDate(date) {
    return updateProps({ deadlineDate: date });
  };
  var onChangeSubject = function onChangeSubject(e) {
    updateProps({ subject: e.target.value });
  };
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      contentStyle: { width: '700px' },
      autoScrollBodyContent: true,
      title: (changesSaved ? 'Send' : 'Resend') + ' Email for this ' + (isSupplier ? 'Contract' : 'Request'),
      titleStyle: { backgroundColor: '#00BCD4', color: '#ffffff', fontSize: '18px', padding: '2%' },
      open: open,
      actions: [_react2.default.createElement(_flatButtonWithLoader2.default, {
        loader: loading,
        label: finishedSendingEmail ? 'Close' : 'Cancel',
        primary: true,
        onTouchTap: closeResendContractDialog
      }), _react2.default.createElement(_flatButtonWithLoader2.default, {
        loader: loading,
        label: 'Resend',
        secondary: true,
        onTouchTap: dispatchResendContract,
        disabled: finishedSendingEmail || loading || !customizedMessage || !subject
      })]
    },
    finishedSendingEmail ? _react2.default.createElement(
      'div',
      { style: { marginTop: '20px' } },
      'Congratulations, your ',
      isSupplier ? 'contract' : 'request',
      ' has been sent!'
    ) : _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { style: { margin: '12px 0px 4px', display: 'flex', alignItems: 'center' } },
        _react2.default.createElement(
          'div',
          { style: { fontSize: '16px' } },
          'Partner: ',
          partner.name
        ),
        _react2.default.createElement(_openInNew2.default, {
          style: { color: 'rgba(0, 0, 0, 0.54)', height: '22px', width: '22px', cursor: 'pointer', marginLeft: '16px' },
          onClick: function onClick() {
            return window.open("https://app.tourconnect.com" + '/partner-management/partner-details/' + partner.id + '?jwt=' + localStorage.getItem('jwt'));
          }
        })
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '100%', fontSize: '13px' } },
        (partner.contacts || []).map(function (_ref) {
          var id = _ref.id,
              email = _ref.email;
          return _react2.default.createElement(_materialUi.Checkbox, {
            key: id,
            label: email,
            checked: resendToEmails.indexOf(email) > -1,
            onCheck: onCheckAContact(email)
          });
        })
      ),
      !finishedSendingEmail && _react2.default.createElement(
        'div',
        null,
        !isSupplier && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_datePicker2.default, {
            textFieldStyle: { display: 'inline-block', width: '90%' },
            containerStyle: { display: 'inline-block', marginTop: '1em' },
            value: deadlineDate,
            initialMonth: deadlineDate || new Date(),
            onChange: onChangeDeadlineDate,
            floatingLabelText: 'Deadline Date',
            closeOnSelect: true
          })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'label',
            null,
            'Subject:'
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('input', {
            value: subject || '',
            style: { width: '100%' },
            onChange: onChangeSubject
          })
        ),
        _react2.default.createElement(
          'label',
          null,
          'Message:'
        ),
        _react2.default.createElement(
          'div',
          {
            style: {
              padding: '8px 12px',
              overflow: 'auto',
              minHeight: '80px',
              border: '1px solid #00BCD4',
              margin: '12px 0'
            }
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-email', color: '#bfbfbf', style: { top: '12px' } }),
          _react2.default.createElement(_materialUi.TextField, {
            id: 'commentBoxTextField',
            hintStyle: { fontSize: '14px' },
            underlineShow: false,
            defaultValue: customizedMessage,
            onChange: function onChange(_ref2) {
              var value = _ref2.target.value;
              return updateProps({ customizedMessage: value });
            },
            style: { float: 'right', width: '85%', marginRight: '5%' },
            multiLine: true,
            rowsMax: 5
          })
        )
      )
    )
  );
};

ResendContractComponent.propTypes = propTypes;
exports.default = ResendContractComponent;

/***/ }),
/* 3347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateDraft = function CreateDraft(_ref) {
  var companyType = _ref.companyType,
      onRequestClose = _ref.onRequestClose,
      createSingleDraft = _ref.createSingleDraft,
      createTemplateDraft = _ref.createTemplateDraft,
      open = _ref.open,
      templateId = _ref.templateId,
      templateFromDummy = _ref.templateFromDummy,
      createDummyTemplateDraft = _ref.createDummyTemplateDraft;

  var actions = function () {
    if (companyType === 'Contractor') {
      return [_react2.default.createElement(_materialUi.FlatButton, { label: 'cancel', primary: true, onClick: onRequestClose }), _react2.default.createElement(_materialUi.FlatButton, { label: 'confirm', secondary: true, onClick: createDummyTemplateDraft })];
    }
    return [_react2.default.createElement(_materialUi.FlatButton, { label: 'cancel', primary: true, onClick: onRequestClose }), _react2.default.createElement(_materialUi.FlatButton, { label: templateId ? 'No, edit this contract only' : 'confirm', secondary: true, onClick: createSingleDraft }), templateId ? _react2.default.createElement(_materialUi.RaisedButton, { label: 'Yes, edit template', secondary: true, onClick: createTemplateDraft }) : undefined];
  }();
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: open,
      title: 'EDITING A CONTRACT',
      onRequestClose: onRequestClose,
      actions: actions
    },
    function () {
      if (companyType === 'Contractor' && !templateFromDummy) {
        return _react2.default.createElement(
          'div',
          null,
          'This contract was created by the supplier.  To maintain the integrity of the rates, we will create a buyer copy of this contract so you can make edits yourself.'
        );
      }
      if (templateFromDummy) {
        return _react2.default.createElement(
          'div',
          null,
          'Please click CONFIRM if you\u2019d like to edit this contract.'
        );
      }
      if (!templateId) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            null,
            'Please click CONFIRM if you\u2019d like to edit this contract.'
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'i',
            null,
            'Note that we will create a new contract draft for you to work on your changes. Unless you publish the changes, your partner will only see their original contract.'
          )
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          'This contract was created from a template and sent to multiple buyers. Would you like to edit the template and send updates to all associated buyers?'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'i',
          null,
          'Note that we will create a new draft for you to work on your changes. Unless you publish the changes, your partners will only see their original contract.'
        )
      );
    }()
  );
};

exports.default = CreateDraft;

/***/ }),
/* 3348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _stepperActions = __webpack_require__(257);

var _stepperActions2 = _interopRequireDefault(_stepperActions);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNotEmpty = (0, _ramda.complement)(_ramda.isEmpty);

var DownloadPDFAsDraft = function DownloadPDFAsDraft(_ref) {
  var onRequestClose = _ref.onRequestClose,
      draftErrors = _ref.draftErrors,
      downloadContractPdf = _ref.downloadContractPdf;

  return _react2.default.createElement(
    'div',
    { style: { padding: '24px' } },
    draftErrors.errorExist ? _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { style: { margin: '0 36px 48px 36px' } },
        'We are checking if your draft has all the required information so we can generate a complete draft pdf.'
      )
    ) : _react2.default.createElement(
      'div',
      { style: { margin: '0 36px 24px 36px', fontSize: '16px', lineHeight: '24px' } },
      'Congratulations! Your draft has passed all requirement checks.',
      _react2.default.createElement(
        'div',
        null,
        ' Please click \'Download PDF\' button to preview your contract.'
      )
    ),
    _react2.default.createElement(_stepperActions2.default, { rightButtons: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Cancel',
          hoverColor: 'none',
          labelStyle: { fontWeight: '600', marginRight: '15px' },
          primary: true,
          onTouchTap: onRequestClose
        }),
        _react2.default.createElement(_flatButtonWithLoader2.default, {
          label: 'Download PDF',
          hoverColor: 'none',
          labelStyle: { fontWeight: '600' },
          onTouchTap: function onTouchTap(e) {
            return downloadContractPdf(e.currentTarget);
          },
          secondary: true
        })
      )
    })
  );
};

exports.default = DownloadPDFAsDraft;

/***/ }),
/* 3349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(737);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DraftComplete = function DraftComplete(_ref) {
  var isTemplateDraft = _ref.isTemplateDraft,
      sentPartners = _ref.sentPartners,
      leftNav = _ref.leftNav,
      publishDraft = _ref.publishDraft,
      updateProps = _ref.updateProps,
      draftApproved = _ref.draftApproved,
      reviewRateEmailSent = _ref.reviewRateEmailSent,
      sendReviewRatesEmail = _ref.sendReviewRatesEmail;

  var templateDraftWithoutPartners = isTemplateDraft && _ramda2.default.isEmpty(sentPartners);
  var isEditedDraft = leftNav.originFrom === 'edited';
  var isContractDraft = isEditedDraft && leftNav.draftType !== 'template';
  var activeDraft = isContractDraft || Boolean(sentPartners && sentPartners.length);
  // for first version only
  if (draftApproved !== true && !activeDraft) {
    return _react2.default.createElement(
      'div',
      { style: { textAlign: 'center' } },
      Boolean(reviewRateEmailSent) ? _react2.default.createElement(
        'div',
        { style: { fontSize: '20x', margin: '16px', padding: '16px 40px' } },
        'A rate expert has received your rates and will be in contact with your shortly to schedule a call with you.'
      ) : _react2.default.createElement(
        'div',
        { style: { margin: '16px', padding: '16px 40px' } },
        _react2.default.createElement(
          'div',
          { style: { fontSize: '20x' } },
          'We would be happy to review your rates, for FREE, to help make sure your rates are easy for your partners to load - and sell!'
        ),
        _react2.default.createElement(
          'div',
          { style: { marginTop: '32px' } },
          _react2.default.createElement(_materialUi.FlatButton, {
            label: 'Schedule A Review',
            labelStyle: { textTransform: 'none' },
            style: { border: '1px solid #ff4081' },
            primary: true,
            onTouchTap: sendReviewRatesEmail
          }),
          _react2.default.createElement(_materialUi.RaisedButton, {
            label: 'Finalise Template',
            labelStyle: { textTransform: 'none' },
            secondary: true,
            style: { marginLeft: '12px' },
            onTouchTap: publishDraft
          })
        )
      )
    );
  }
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { style: { padding: '18px' } },
        _react2.default.createElement(
          'p',
          { style: { color: '#00bcd4', fontSize: '14px', marginLeft: '24px' } },
          'Your template is 100% complete.'
        ),
        _react2.default.createElement(
          'p',
          { style: { fontSize: '16px', marginLeft: '24px', color: '#616161' } },
          'Would you like to keep working on your templates or select your partners and send these rates now?'
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { margin: '24px 32px', textAlign: 'center' } },
      _react2.default.createElement(_materialUi.FlatButton, {
        label: 'Finalise & Send Later',
        labelStyle: { textTransform: 'none' },
        secondary: true,
        onTouchTap: publishDraft,
        style: { border: '1px solid #00bcd4' }
      }),
      _react2.default.createElement(_materialUi.RaisedButton, {
        label: 'Finalise & Continue',
        labelStyle: { textTransform: 'none' },
        secondary: true,
        onTouchTap: function onTouchTap() {
          return publishDraft({ goToSend: true });
        },
        style: { marginLeft: '16px' }
      })
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;

  var leftNav = contracting.contractActivitiesProducts.get('leftNav');
  return {
    isTemplateDraft: leftNav.get('draftType') === 'template' || leftNav.get('originFrom') !== 'edited',
    originFrom: leftNav.get('originFrom'),
    sentPartners: leftNav.get('sentPartners') ? leftNav.get('sentPartners').toJS() : []
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { addDraftToQueue: _actions.addDraftToQueue })(DraftComplete);

/***/ }),
/* 3350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _messageBox = __webpack_require__(1137);

var _messageBox2 = _interopRequireDefault(_messageBox);

var _emailToPartners = __webpack_require__(1540);

var _emailToPartners2 = _interopRequireDefault(_emailToPartners);

var _editHistories = __webpack_require__(1261);

var _editHistories2 = _interopRequireDefault(_editHistories);

var _actions = __webpack_require__(1263);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var SendUpdates = function SendUpdates(_ref) {
  var sentPartners = _ref.sentPartners,
      publishDraft = _ref.publishDraft,
      sendUpdatesMessage = _ref.sendUpdatesMessage,
      onRequestClose = _ref.onRequestClose,
      updateProps = _ref.updateProps,
      sendUpdatesSubject = _ref.sendUpdatesSubject,
      publishingDraft = _ref.publishingDraft,
      diffSummary = _ref.diffSummary,
      isAnAdmin = _ref.isAnAdmin,
      doNotIssueUpdate = _ref.doNotIssueUpdate,
      contractId = _ref.contractId,
      addDraftToQueue = _ref.addDraftToQueue;

  var shouldDisableBtns = Boolean(!doNotIssueUpdate && !sendUpdatesMessage) || !(diffSummary && diffSummary.summaryByPage.length);
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { padding: '18px' } },
      _react2.default.createElement(_emailToPartners2.default, {
        partners: sentPartners.map(function (partner) {
          return {
            company_name: partner.to.name,
            profileImageUrl: partner.to.avatar
          };
        }),
        defaultShowNumOfPartners: 8
      }),
      _react2.default.createElement(
        'b',
        { style: { color: 'rgba(0, 0, 0, 0.64)' } },
        'Subject:'
      ),
      _react2.default.createElement('input', {
        value: sendUpdatesSubject,
        autoFocus: true,
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          return updateProps({ sendUpdatesSubject: value });
        },
        style: { width: '87%', height: '32px', marginLeft: '4px', paddingLeft: '4px' }
      }),
      _react2.default.createElement(_messageBox2.default, {
        style: { fontSize: '14px', margin: '24px 0', color: '#616161' },
        value: sendUpdatesMessage,
        onChange: function onChange(value) {
          return updateProps({ sendUpdatesMessage: value });
        },
        placeholder: 'To help your partners quickly understand what you\'ve updated, please add a brief note here. We\'ll include it in the contract\'s activity feed as well as in the email.'
      }),
      !isNilOrEmpty(diffSummary) ? _react2.default.createElement(_editHistories2.default, {
        diffSummary: diffSummary
      }) : _react2.default.createElement('span', null),
      _react2.default.createElement(
        'div',
        { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginTop: '8px', flexDirection: 'row-reverse' } },
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'space-between' } },
          _react2.default.createElement(_flatButtonWithLoader2.default, {
            label: 'Cancel',
            primary: true,
            onTouchTap: onRequestClose
          }),
          _react2.default.createElement(_flatButtonWithLoader2.default, {
            label: 'Send Updates Now',
            labelStyle: { textTransform: 'none' },
            secondary: true,
            loader: publishingDraft,
            disabled: shouldDisableBtns,
            style: {
              lineHeight: '33px',
              marginLeft: '16px',
              border: '1px solid ' + (shouldDisableBtns ? '#efefef' : '#00bcd4')
            },
            onTouchTap: publishDraft
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '50%' } },
          _react2.default.createElement(_materialUi.Checkbox, {
            label: 'Do Not Issue Updates to Buyers',
            style: { marginBottom: '4px', display: isAnAdmin ? 'block' : 'none', fontSize: '12px' },
            checked: doNotIssueUpdate,
            onCheck: function onCheck() {
              return updateProps({ doNotIssueUpdate: !doNotIssueUpdate });
            }
          }),
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' } },
            _react2.default.createElement(
              _wrapper2.default,
              { amazonOrange: true, skipClick: true },
              _react2.default.createElement(_materialUi.RaisedButton, {
                label: 'Add this draft to the Updates Queue',
                labelStyle: { textTransform: 'none' },
                disabled: shouldDisableBtns,
                secondary: true,
                onTouchTap: function onTouchTap() {
                  return addDraftToQueue(contractId, sendUpdatesMessage);
                },
                style: { minWidth: '287px', marginRight: '1em' }
              })
            ),
            _react2.default.createElement(
              'a',
              {
                style: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '10px', textDecoration: 'underline' },
                target: '__blank',
                href: 'http://support.tourconnect.com/en/articles/3150458-send-multiple-updates-at-once-with-the-updates-queue'
              },
              'What\'s\xA0this?'
            )
          )
        )
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var contracting = _ref3.contracting,
      user = _ref3.user;

  var leftNav = contracting.contractActivitiesProducts.get('leftNav');
  return {
    isAnAdmin: user.get('isAnAdmin'),
    isTemplateDraft: leftNav.get('draftType') === 'template' || leftNav.get('originFrom') !== 'edited',
    originFrom: leftNav.get('originFrom'),
    buyerName: leftNav.get('buyerName'),
    email: leftNav.get('email'),
    buyerProfileImageUrl: leftNav.get('buyerProfileImageUrl'),
    sentPartners: leftNav.get('sentPartners') ? leftNav.get('sentPartners').toJS() : [],
    diffSummary: leftNav.get('diffSummary') ? leftNav.get('diffSummary').toJS() : {}
    // editHistory: leftNav.get('editHistory') ? leftNav.get('editHistory').toJS() : [],
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { addDraftToQueue: _actions.addDraftToQueue })(SendUpdates);

/***/ }),
/* 3351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _draftNTemplateWindow = __webpack_require__(3352);

var _draftNTemplateWindow2 = _interopRequireDefault(_draftNTemplateWindow);

var _addEditContractDialog = __webpack_require__(1548);

var _addEditContractDialog2 = _interopRequireDefault(_addEditContractDialog);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _publishDraftDialog = __webpack_require__(1260);

var _publishDraftDialog2 = _interopRequireDefault(_publishDraftDialog);

var _reactRedux = __webpack_require__(6);

var _progressIndicatorContainer = __webpack_require__(3367);

var _progressIndicatorContainer2 = _interopRequireDefault(_progressIndicatorContainer);

var _watermark = __webpack_require__(1547);

var _watermark2 = _interopRequireDefault(_watermark);

var _draftSnackbar = __webpack_require__(3374);

var _draftSnackbar2 = _interopRequireDefault(_draftSnackbar);

var _titlecase = __webpack_require__(549);

var _accessCheckHelperFns = __webpack_require__(631);

var _contractActivitiesProductsActions = __webpack_require__(493);

var _dashboardActions = __webpack_require__(1988);

var _dialogConstants = __webpack_require__(616);

var _resendOrUpdateDialog = __webpack_require__(1141);

var _resendOrUpdateDialog2 = _interopRequireDefault(_resendOrUpdateDialog);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _dialogCreateTemplateDraft = __webpack_require__(3376);

var _dialogCreateTemplateDraft2 = _interopRequireDefault(_dialogCreateTemplateDraft);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  location: _react.PropTypes.object,
  history: _react.PropTypes.object,
  wizard: _react.PropTypes.object,
  contentLoading: _react.PropTypes.bool,
  refreshing: _react.PropTypes.bool,
  errorOccurs: _react.PropTypes.string,
  leftNav: _react.PropTypes.object,
  rightSideContent: _react.PropTypes.object,
  params: _react.PropTypes.object,
  changeContractStateTo: _react.PropTypes.func,
  openAddEditContractDialog: _react.PropTypes.func,
  checkContractReadiness: _react.PropTypes.func,
  deleteProductFromContract: _react.PropTypes.func,
  askIfWantToCheckReadiness: _react.PropTypes.func,
  getContractLeftNav: _react.PropTypes.func,
  openDialogSaveAsTemplate: _react.PropTypes.func,
  downloadContractPdf: _react.PropTypes.func,
  openImportFromOtherProductsDialog: _react.PropTypes.func,
  dispatchedSortingProducts: _react.PropTypes.func,
  saveProductInfoChangesDispatched: _react.PropTypes.func,
  toggleDraftErrorsDialog: _react.PropTypes.func,
  clearStore: _react.PropTypes.func,
  leftNavLoading: _react.PropTypes.bool,
  publishDraft: _react.PropTypes.func,
  goToSendUpdates: _react.PropTypes.func,
  draftComplete: _react.PropTypes.bool,
  toggleCreateDraftDialog: _react.PropTypes.func,
  createDraftDialogOpen: _react.PropTypes.bool,
  readOnly: _react.PropTypes.bool,
  noAccess: _react.PropTypes.bool,
  reloadContentInBg: _react.PropTypes.func,
  openPublishConfirmation: _react.PropTypes.func,
  previousRoute: _react.PropTypes.string,
  isDummyAccount: _react.PropTypes.bool,
  isAnAdmin: _react.PropTypes.bool,
  jumpBackTo: _react.PropTypes.string,
  magicLinkHashToken: _react.PropTypes.string,
  pureDocView: _react.PropTypes.bool
};
var getMainTitle = function getMainTitle(partnerCompanyName, locationName, templateName) {
  var flipConcat = _ramda2.default.flip(_ramda2.default.concat);
  var lengthGt = function lengthGt(gtNum) {
    return _ramda2.default.compose(_ramda2.default.lt(gtNum), _ramda2.default.length);
  };
  var composeThreeDotsString = function composeThreeDotsString(gtNum) {
    return _ramda2.default.ifElse(lengthGt(gtNum), _ramda2.default.compose(flipConcat('...'), _ramda2.default.slice(0, gtNum)), _ramda2.default.slice(0, gtNum));
  };
  var composeString = function composeString(a, b) {
    return '' + a + (a && b ? ' / ' : '') + b;
  };
  return _ramda2.default.useWith(composeString, [composeThreeDotsString(50), composeThreeDotsString(23)])(locationName, templateName || partnerCompanyName);
};
/*
 @params pathname = route || location.pathname
 */
var getRouteName = _ramda2.default.cond([[_ramda2.default.contains('activities'), _ramda2.default.always('activities')], [_ramda2.default.contains('product'), _ramda2.default.always('product')], [_ramda2.default.contains('partners'), _ramda2.default.always('partners')], [_ramda2.default.contains('logs'), _ramda2.default.always('logs')], [_ramda2.default.contains('policies'), _ramda2.default.always('policies')], [_ramda2.default.T, _ramda2.default.always('contractDetails')]]);

var DraftNTemplateContainer = function (_Component) {
  _inherits(DraftNTemplateContainer, _Component);

  function DraftNTemplateContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DraftNTemplateContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DraftNTemplateContainer.__proto__ || Object.getPrototypeOf(DraftNTemplateContainer)).call.apply(_ref, [this].concat(args))), _this), _this.routeToFirstProduct = function (newLeftNav) {
      var _this$props = _this.props,
          location = _this$props.location,
          params = _this$props.params;
      // AUTO route user to the first product page

      var routeName = getRouteName(location.pathname);
      if (routeName === 'contractDetails') {
        var firstProduct = _ramda2.default.path(['payload', 'productsArray', 0], newLeftNav);
        if (!firstProduct) _this.context.router.replace(location.pathname.replace('details', 'policies'));else {
          var ratePackageId = function () {
            if (firstProduct._id) return firstProduct._id;
            return firstProduct.ratePackageName ? encodeURIComponent(firstProduct.ratePackageName) : 'Primary';
          }();
          _this.context.router.replace('/contracting/' + params.collection + '/' + params.contractId + '/product/' + firstProduct.productId + '/' + ratePackageId);
        }
      }
    }, _this.reloadContent = function () {
      var _this$props2 = _this.props,
          params = _this$props2.params,
          reloadContentInBg = _this$props2.reloadContentInBg;

      reloadContentInBg({
        collection: params.collection,
        contractId: params.contractId,
        productId: params.productId,
        ratePackage: params.ratePackage
      });
    }, _this.changeLeftNavRoute = function (route) {
      var location = _this.props.location;
      var router = _this.context.router;

      if (location.pathname !== route) {
        router.replace(route);
      }
    }, _this.createNGoToDraft = function () {
      var _this$props3 = _this.props,
          leftNav = _this$props3.leftNav,
          location = _this$props3.location;

      var routeName = getRouteName(location.pathname);
      if (leftNav.templateHasDraft) {
        var newRoute = routeName !== 'activities' || routeName === 'partners' ? location.pathname.replace('/template/', '/draft/') : '/contracting/draft/' + leftNav.contractId + '/details';
        _this.context.router.replace(newRoute);
      } else _this.props.toggleCreateDraftDialog();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DraftNTemplateContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          dispatch = _props.dispatch,
          getContractLeftNav = _props.getContractLeftNav,
          params = _props.params;

      dispatch({ type: 'CLOSE_PUBLISH_DRAFT_DIALOG' });
      getContractLeftNav(params.collection, params.contractId).then(this.routeToFirstProduct);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var leftNav = nextProps.leftNav,
          getContractLeftNav = nextProps.getContractLeftNav,
          params = nextProps.params;

      if (params !== this.props.params || this.props.location.query !== nextProps.location.query) {
        if (params.collection !== this.props.params.collection || params.contractId !== this.props.params.contractId || nextProps.location.query.refresh === 'true') {
          getContractLeftNav(params.collection, params.contractId).then(this.routeToFirstProduct);
        }
      }
      if (this.props.leftNav.locationName !== leftNav.locationName || this.props.leftNav.templateName !== leftNav.templateName) {
        var collection = params.collection;
        document.title = getMainTitle(leftNav.companyName || '', leftNav.locationName || '', leftNav.templateName || '') + ' - ' + (0, _titlecase.toLaxTitleCase)(collection) + ' - TourConnect';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var router = this.context.router;
      var _props2 = this.props,
          previousRoute = _props2.previousRoute,
          children = _props2.children,
          params = _props2.params,
          contentLoading = _props2.contentLoading,
          leftNavLoading = _props2.leftNavLoading,
          refreshing = _props2.refreshing,
          errorOccurs = _props2.errorOccurs,
          leftNav = _props2.leftNav,
          rightSideContent = _props2.rightSideContent,
          openAddEditContractDialog = _props2.openAddEditContractDialog,
          changeContractStateTo = _props2.changeContractStateTo,
          openDialogSaveAsTemplate = _props2.openDialogSaveAsTemplate,
          downloadContractPdf = _props2.downloadContractPdf,
          openImportFromOtherProductsDialog = _props2.openImportFromOtherProductsDialog,
          dispatchedSortingProducts = _props2.dispatchedSortingProducts,
          saveProductInfoChangesDispatched = _props2.saveProductInfoChangesDispatched,
          isDummyAccount = _props2.isDummyAccount,
          isAnAdmin = _props2.isAnAdmin,
          magicLinkHashToken = _props2.magicLinkHashToken,
          pureDocView = _props2.pureDocView;
      var productId = params.productId,
          contractId = params.contractId;
      var location = this.props.location;

      var isADraft = leftNav.contractState === 'draft' || leftNav.contractState === 'publish-ready';
      var routeName = getRouteName(location.pathname);
      var loading = leftNavLoading || contentLoading;
      var extraProps = {
        reducerName: 'contractActivitiesProducts',
        reloadContent: this.reloadContent,
        openAddEditContractDialog: leftNav.supplierEditable ? openAddEditContractDialog : function () {
          var confirmed = window.confirm('Would you like create a draft for editing?');
          if (confirmed) _this2.createNGoToDraft();
        },
        productDoesnotExistInDoc: routeName === 'product' && !loading && _ramda2.default.isNil(rightSideContent.ratePackageIndex),
        deleteFromProduct: function deleteFromProduct(extraPayload) {
          return saveProductInfoChangesDispatched(_ramda2.default.merge({ contractId: contractId, productId: productId }, extraPayload));
        }
      };
      var propsForLeftNav = {
        reducerName: extraProps.reducerName,
        location: this.props.location,
        changeLeftNavRoute: this.changeLeftNavRoute,
        goToDashboard: function goToDashboard() {
          if (_this2.props.jumpBackTo) window.location = _this2.props.jumpBackTo;else if (previousRoute) router.goBack();else router.push('/contracting/template-list');
        },
        changeContractStateTo: changeContractStateTo,
        openAddEditContractDialog: extraProps.openAddEditContractDialog,
        sortingProducts: dispatchedSortingProducts(contractId),
        openDialogSaveAsTemplate: openDialogSaveAsTemplate,
        toggleDraftErrorsDialog: this.props.toggleDraftErrorsDialog
      };
      var propsForMenu = {
        productId: productId,
        contractId: contractId,
        locationId: leftNav.locationId,
        router: router,
        openAddEditContractDialog: extraProps.openAddEditContractDialog,
        openImportFromOtherProductsDialog: openImportFromOtherProductsDialog,
        openDialogSaveAsTemplate: openDialogSaveAsTemplate
      };
      var shouldHideAppBars = isDummyAccount && !isAnAdmin || pureDocView;
      return _react2.default.createElement(
        'div',
        {
          className: shouldHideAppBars ? 'full-screen-page' : '',
          style: shouldHideAppBars ? { padding: '0 128px' } : {}
        },
        Boolean(this.props.readOnly && !loading && leftNav.isLatest) && _react2.default.createElement(
          'div',
          { style: { textAlign: 'center', marginBottom: '8px', fontWeight: 'bold' } },
          'This ',
          this.props.params.collection === 'draft' ? 'Draft' : 'Template',
          ' is READ-ONLY.'
        ),
        _react2.default.createElement(_progressIndicatorContainer2.default, {
          isADraft: this.props.params.collection === 'draft',
          contractId: contractId,
          isDummyAccount: isDummyAccount
        }),
        _react2.default.createElement(
          _draftNTemplateWindow2.default,
          {
            reducerName: extraProps.reducerName,
            actionsForLeftNav: propsForLeftNav,
            actionsForMenu: propsForMenu,
            productDoesnotExistInDoc: extraProps.productDoesnotExistInDoc,
            actionsForContractWindow: {
              deleteProductFromContract: this.props.deleteProductFromContract,
              downloadContractPdf: downloadContractPdf,
              changeLeftNavRoute: this.changeLeftNavRoute,
              openDialogSaveAsTemplate: openDialogSaveAsTemplate,
              createNGoToDraft: this.createNGoToDraft,
              publishDraftWithRouting: this.props.publishDraft
            },
            getMainTitle: getMainTitle
          },
          Boolean(leftNav.stagedUpdates && leftNav.stagedUpdates.some(function (obj) {
            return obj.source === 'draft';
          })) && _react2.default.createElement(_watermark2.default, { texts: ['Queued for Updates', 'Queued for Updates', 'Queued for Updates', 'Queued for Updates'] }),
          Boolean(!leftNav.isLatest && !loading) && _react2.default.createElement(_watermark2.default, { texts: ['Old Version', 'Old Version', 'Old Version', 'Old Version'] }),
          children && !errorOccurs ? (0, _react.cloneElement)(children, extraProps) : undefined,
          _react2.default.createElement(_resendOrUpdateDialog2.default, null),
          _react2.default.createElement(_addEditContractDialog2.default, {
            reducerName: extraProps.reducerName,
            router: this.context.router,
            reloadContent: this.reloadContent
          }),
          _react2.default.createElement(_publishDraftDialog2.default, {
            reducerName: extraProps.reducerName,
            goToDashBoard: propsForLeftNav.goToDashboard,
            changeLeftNavRoute: this.changeLeftNavRoute
          }),
          isADraft && !pureDocView ? _react2.default.createElement(_draftSnackbar2.default, {
            leftNav: leftNav,
            goToSendUpdates: this.props.goToSendUpdates,
            checkContractReadiness: this.props.toggleDraftErrorsDialog,
            publishDraftWithRouting: this.props.publishDraft,
            draftComplete: this.props.draftComplete,
            openPublishConfirmation: this.props.openPublishConfirmation,
            isDummyAccount: isDummyAccount
          }) : _react2.default.createElement('div', null),
          _react2.default.createElement(_dialogCreateTemplateDraft2.default, {
            open: this.props.createDraftDialogOpen,
            sentPartners: leftNav.sentPartners,
            isDummyAccount: isDummyAccount,
            createTemplateDraft: function createTemplateDraft() {
              _this2.props.toggleCreateDraftDialog();
              (0, _contractActivitiesProductsActions.createDraft)(contractId, contractId, true).then(function () {
                return _this2.context.router.replace('/contracting/draft/' + contractId + '/details');
              });
            },
            onRequestClose: this.props.toggleCreateDraftDialog
          })
        ),
        _react2.default.createElement(_loadingOverlay2.default, {
          loading: refreshing
        }),
        _react2.default.createElement(
          'div',
          {
            className: 'full-screen-page',
            style: {
              display: Boolean(errorOccurs) ? 'block' : 'none',
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              textAlign: 'center',
              paddingTop: '20%'
            }
          },
          _react2.default.createElement(
            'div',
            { style: { fontSize: '20px', color: 'white', marginTop: '24px', whiteSpace: 'pre-wrap', width: '50%', margin: 'auto', lineHeight: '24px' } },
            function () {
              if (errorOccurs === 'An Error Occurred') {
                return _react2.default.createElement(
                  'div',
                  { style: { marginTop: '100px', textAlign: 'center' } },
                  'Oops, an error occured, please ',
                  _react2.default.createElement(
                    'a',
                    { style: { cursor: 'pointer' }, onClick: router.goBack },
                    'go back'
                  ),
                  ' and try again.',
                  _react2.default.createElement(
                    'div',
                    { style: { marginTop: '16px', fontSize: '12px' } },
                    'If this happens again, please reach out to our support team on support@tourconnect.com.'
                  )
                );
              } else if (errorOccurs) {
                if (magicLinkHashToken) {
                  return _react2.default.createElement(
                    'div',
                    null,
                    errorOccurs,
                    _react2.default.createElement(
                      'div',
                      { style: { marginTop: '24px' } },
                      _react2.default.createElement(_materialUi.RaisedButton, {
                        label: 'REOPEN THIS RATE SHEET',
                        secondary: true,
                        onClick: function onClick() {
                          return window.location = "https://sec.tourconnect.com" + '/assets-landing?hashToken=' + magicLinkHashToken;
                        }
                      }),
                      '\xA0\xA0',
                      _react2.default.createElement(_materialUi.FlatButton, {
                        label: 'CLOSE THIS TAB',
                        primary: true,
                        onClick: function onClick() {
                          return window.close();
                        }
                      })
                    )
                  );
                }
                return errorOccurs;
              }
            }()
          )
        )
      );
    }
  }]);

  return DraftNTemplateContainer;
}(_react.Component);

DraftNTemplateContainer.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting,
      user = _ref2.user,
      route = _ref2.route,
      dummyAcct = _ref2.dummyAcct;

  var contractStore = contracting.contractActivitiesProducts;
  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  var readOnly = !(0, _accessCheckHelperFns.checkLocAccess)({ user: user }, leftNav.locationId, 'contracting', 'write');
  var noAccess = !(0, _accessCheckHelperFns.checkLocAccess)({ user: user }, leftNav.locationId, 'contracting', 'read');
  return _extends({
    readOnly: readOnly,
    noAccess: noAccess,
    contentLoading: contractStore.get('contentLoading'),
    leftNavLoading: contractStore.get('leftNavLoading'),
    refreshing: contractStore.get('refreshing'),
    createDraftDialogOpen: contractStore.get('createDraftDialogOpen'),
    draftComplete: !contractStore.toJS().draftErrors.errorExist,
    errorOccurs: contractStore.get('errorOccurs'),
    leftNav: leftNav,
    rightSideContent: contractStore.get('rightSideContent') ? contractStore.get('rightSideContent').toJS() : contractStore.get('rightSideContent'),
    routeName: contractStore.get('routeName'),
    billingPlan: user.get('billingPlan'),
    previousRoute: route.previousRoute,
    isDummyAccount: user.get('isDummyAccount'),
    isAnAdmin: user.get('isAnAdmin'),
    pureDocView: user.get('pureDocView')
  }, dummyAcct.dummyTemplate);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, state) {
  return {
    clearStore: function clearStore() {
      return dispatch((0, _contractActivitiesProductsActions.clearStore)());
    },
    getContractLeftNav: function getContractLeftNav() {
      return dispatch(_contractActivitiesProductsActions.getContractLeftNav.apply(undefined, arguments));
    },
    deleteProductFromContract: function deleteProductFromContract(contractId, ratePackageIndex, productName) {
      return dispatch((0, _contractActivitiesProductsActions.deleteProductFromContract)({ contractId: contractId, ratePackageIndex: ratePackageIndex, productName: productName }));
    },
    changeContractStateTo: function changeContractStateTo(state, ids) {
      return dispatch((0, _dashboardActions.changeContractState)(state, ids));
    },
    goToSendUpdates: function goToSendUpdates() {
      return dispatch({ type: 'SEND_UPDATES_IN_PUBLISH_DRAFT_DIALOG' });
    },
    checkContractReadiness: function checkContractReadiness(contractId) {
      return dispatch((0, _contractActivitiesProductsActions.checkContractReadiness)(contractId));
    },
    openAddEditContractDialog: function openAddEditContractDialog(payload) {
      dispatch({ type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE', payload: payload });
    },
    openDialogSaveAsTemplate: function openDialogSaveAsTemplate(contractId, contractYear) {
      dispatch({ type: 'OPEN_AS_SAVE_CONTRACT_AS_TEMPLATE', payload: { contractId: contractId, contractYear: contractYear } });
    },
    downloadContractPdf: function downloadContractPdf() {
      return dispatch(_contractActivitiesProductsActions.downloadContractPdf.apply(undefined, arguments));
    },
    openImportFromOtherProductsDialog: function openImportFromOtherProductsDialog() {
      return dispatch(_contractActivitiesProductsActions.openImportFromOtherProductsDialog.apply(undefined, arguments));
    },
    dispatchedSortingProducts: _ramda2.default.curry(function (contractId, products) {
      return dispatch((0, _contractActivitiesProductsActions.sortingProducts)(contractId, products));
    }),
    saveProductInfoChangesDispatched: function saveProductInfoChangesDispatched() {
      return dispatch(_dialogConstants.saveProductInfoChanges.apply(undefined, arguments));
    },
    publishDraft: function publishDraft() {
      return dispatch(_dialogConstants.publishDraft.apply(undefined, arguments));
    },
    toggleDraftErrorsDialog: function toggleDraftErrorsDialog() {
      return dispatch(_contractActivitiesProductsActions.toggleDraftErrorsDialog.apply(undefined, arguments));
    },
    toggleCreateDraftDialog: function toggleCreateDraftDialog() {
      return dispatch({ type: '[contractTemplate]TOGGLE_CREATE_DRAFT_DIALOG' });
    },
    reloadContentInBg: function reloadContentInBg() {
      return dispatch(_contractActivitiesProductsActions.reloadContentInBg.apply(undefined, arguments));
    },
    openPublishConfirmation: function openPublishConfirmation() {
      return dispatch({ type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG', payload: { open: true, title: 'Finalise Template' } });
    }
  };
};

DraftNTemplateContainer.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DraftNTemplateContainer);

/***/ }),
/* 3352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _contractingWindow = __webpack_require__(1966);

var _contractingWindow2 = _interopRequireDefault(_contractingWindow);

var _materialUi = __webpack_require__(3);

var _hotel = __webpack_require__(1541);

var _hotel2 = _interopRequireDefault(_hotel);

var _explore = __webpack_require__(1967);

var _explore2 = _interopRequireDefault(_explore);

var _index = __webpack_require__(3353);

var _index2 = _interopRequireDefault(_index);

var _reactRouterRedux = __webpack_require__(27);

var _leftNav = __webpack_require__(1969);

var _leftNav2 = _interopRequireDefault(_leftNav);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _delete = __webpack_require__(738);

var _delete2 = _interopRequireDefault(_delete);

var _smallButtons = __webpack_require__(94);

var _pickMasterButtonNIndicator = __webpack_require__(3366);

var _pickMasterButtonNIndicator2 = _interopRequireDefault(_pickMasterButtonNIndicator);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import ThreeDotsMenu from './three-dots-menuItems';


var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var DraftNTemplateWindowDataWrapper = function (_Component) {
  _inherits(DraftNTemplateWindowDataWrapper, _Component);

  function DraftNTemplateWindowDataWrapper() {
    _classCallCheck(this, DraftNTemplateWindowDataWrapper);

    var _this = _possibleConstructorReturn(this, (DraftNTemplateWindowDataWrapper.__proto__ || Object.getPrototypeOf(DraftNTemplateWindowDataWrapper)).call(this));

    _this.toggleToolbar = function () {
      return _this.setState({ showToolBar: !_this.state.showToolBar });
    };

    _this.state = {
      showToolBar: true
    };
    return _this;
  }

  _createClass(DraftNTemplateWindowDataWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          actionsForLeftNav = _props.actionsForLeftNav,
          actionsForMenu = _props.actionsForMenu,
          actionsForContractWindow = _props.actionsForContractWindow,
          contractState = _props.contractState,
          contractId = _props.contractId,
          locationName = _props.locationName,
          locationId = _props.locationId,
          startDate = _props.startDate,
          endDate = _props.endDate,
          templateName = _props.templateName,
          isLatest = _props.isLatest,
          draftErrorsExist = _props.draftErrorsExist,
          draftType = _props.draftType,
          originFrom = _props.originFrom,
          templateVersions = _props.templateVersions,
          allTemplateVersions = _props.allTemplateVersions,
          threadId = _props.threadId,
          _props$supplierInfo = _props.supplierInfo,
          supplierInfo = _props$supplierInfo === undefined ? {} : _props$supplierInfo,
          supplierEditable = _props.supplierEditable,
          productType = _props.productType,
          productName = _props.productName,
          productId = _props.productId,
          ratePackageIndex = _props.ratePackageIndex,
          ratePackageName = _props.ratePackageName,
          policyNotesTemplateId = _props.policyNotesTemplateId,
          policyNotesTemplateName = _props.policyNotesTemplateName,
          isShellAccount = _props.isShellAccount,
          productDoesnotExistInDoc = _props.productDoesnotExistInDoc,
          push = _props.push,
          isDummyAccount = _props.isDummyAccount,
          pureDocView = _props.pureDocView;

      var updateProductName = function updateProductName() {
        return actionsForMenu.openAddEditContractDialog({
          type: 'updateProductName',
          data: {
            title: 'Update Room/Product Name',
            newProductName: productName
          }
        });
      };
      var updateLocationName = function updateLocationName() {
        return actionsForMenu.openAddEditContractDialog({
          type: 'UpdateLocationName',
          data: {
            title: 'Update Location/Property Name',
            newLocationName: locationName
          }
        });
      };
      var updateContractPeriod = function updateContractPeriod() {
        return actionsForMenu.openAddEditContractDialog({
          type: 'UpdateContractPeriod',
          data: {
            title: 'Update Contract Period',
            newStartDate: startDate,
            newEndDate: endDate,
            startDate: startDate,
            endDate: endDate
          }
        });
      };
      var isADraft = contractState === 'draft' || contractState === 'publish-ready';
      var isEditedDraft = isADraft && originFrom === 'edited';
      var isContractDraft = isEditedDraft && draftType !== 'template';
      var versionsNode = isLatest && templateVersions && templateVersions.length > 1 || !isLatest && !isNilOrEmpty(allTemplateVersions) ? _react2.default.createElement(
        _materialUi.IconMenu,
        {
          desktop: true,
          style: { marginLeft: '4px', cursor: 'pointer' },
          iconButtonElement: _react2.default.createElement(
            _materialUi.IconButton,
            { style: { fontSize: '12px', padding: '0', width: '100%', height: '30px' } },
            _react2.default.createElement(
              'a',
              null,
              'Version ' + templateVersions.length
            )
          )
        },
        (isLatest ? templateVersions : allTemplateVersions).map(function (version, i) {
          return _react2.default.createElement(_materialUi.MenuItem, {
            key: i,
            disabled: version === contractId,
            primaryText: 'Version ' + (i + 1),
            onTouchTap: function onTouchTap() {
              return actionsForContractWindow.changeLeftNavRoute('/contracting/template/' + version + '/details');
            }
          });
        })
      ) : '';
      return _react2.default.createElement(
        _contractingWindow2.default,
        {
          leftNavNode: _react2.default.createElement(_leftNav2.default, _extends({}, actionsForLeftNav, {
            appBarBgColor: _ramda2.default.call(_ramda2.default.cond([[function () {
              return isADraft;
            }, _ramda2.default.always('#1c313a')], [function () {
              return isLatest;
            }, _ramda2.default.always('#005662')], [_ramda2.default.T, _ramda2.default.always('#373737')]])),
            leftNavTitle: isShellAccount ? '' : _ramda2.default.call(_ramda2.default.cond([[function () {
              return isContractDraft;
            }, _ramda2.default.always('Contract Draft')], [function () {
              return isADraft;
            }, _ramda2.default.always('Template Draft')], [_ramda2.default.T, _ramda2.default.always('Template')]]))
          })),
          headerBgColor: _ramda2.default.call(_ramda2.default.cond([[function () {
            return isADraft;
          }, _ramda2.default.always('#455a64')], [function () {
            return isLatest;
          }, _ramda2.default.always('#00838f')], [_ramda2.default.T, _ramda2.default.always('#616161')]])),
          title: isDummyAccount ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'flex-center', style: { whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflowX: 'hidden', lineHeight: '48px' } },
              locationName,
              ' \xA0',
              isADraft && _react2.default.createElement(_smallButtons.JiraFlatButton, {
                label: 'Edit',
                style: { marginLeft: '4px' },
                labelPosition: 'before',
                onClick: updateLocationName,
                icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-mode_edit', style: { color: '#5E6C84' } })
              })
            ),
            Boolean(supplierInfo.marketInfo) && _react2.default.createElement(
              'div',
              { style: { whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflowX: 'hidden' } },
              '(',
              supplierInfo.marketInfo,
              ')'
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { style: { whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflowX: 'hidden' } },
              templateName,
              supplierInfo.marketInfo ? ' (' + supplierInfo.marketInfo + ')' : ''
            ),
            _react2.default.createElement(
              'div',
              { style: { whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflowX: 'hidden' } },
              locationName
            )
          ),
          subtitle: {
            dateRange: _react2.default.createElement(
              'div',
              { className: 'flex-center' },
              _moment2.default.utc(startDate).format('D MMM YYYY'),
              ' - ',
              _moment2.default.utc(endDate).format('D MMM YYYY'),
              isADraft && _react2.default.createElement(_smallButtons.JiraFlatButton, {
                label: 'Edit',
                style: { marginLeft: '4px' },
                labelPosition: 'before',
                onClick: updateContractPeriod,
                icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-mode_edit', style: { color: '#5E6C84' } })
              })
            ),
            name: _react2.default.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center' } },
              Boolean(productId && productType === 'Accommodation') && _react2.default.createElement(_hotel2.default, null),
              Boolean(productId && productType === 'Non-Accommodation') && _react2.default.createElement(_explore2.default, null),
              _react2.default.createElement(
                'div',
                { style: { maxWidth: isADraft ? '400px' : '300px', marginLeft: productId ? '12px' : '0', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' } },
                productName,
                ' ',
                ratePackageName ? ' - ' + ratePackageName : ''
              ),
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center' } },
                Boolean(productId && isADraft && !productDoesnotExistInDoc && isDummyAccount) && _react2.default.createElement(_smallButtons.JiraFlatButton, {
                  label: 'Edit Name',
                  style: { marginLeft: '4px' },
                  labelPosition: 'before',
                  onClick: updateProductName,
                  icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-mode_edit', style: { color: '#5E6C84' } })
                }),
                Boolean(productId && isADraft && !productDoesnotExistInDoc) && _react2.default.createElement(_smallButtons.JiraFlatButton, {
                  label: 'Remove',
                  labelStyle: { color: '#f06292' },
                  style: { marginLeft: '4px' },
                  labelPosition: 'before',
                  onTouchTap: function onTouchTap() {
                    return actionsForContractWindow.deleteProductFromContract(contractId, ratePackageIndex, productName);
                  },
                  icon: _react2.default.createElement(_delete2.default, { style: { fill: '#f06292' } })
                }),
                Boolean(!productId && !pureDocView) && _react2.default.createElement(_pickMasterButtonNIndicator2.default, {
                  templateDraftId: contractId,
                  masterTemplateType: 'policyNotes',
                  masterTemplateId: policyNotesTemplateId,
                  masterTemplateName: policyNotesTemplateName,
                  editable: isADraft
                })
              )
            ),
            versions: isADraft ? undefined : versionsNode
          },
          toolbarNode: isADraft && this.state.showToolBar && supplierEditable ? _react2.default.createElement(_index2.default, null) : undefined,
          titleBarRightWidgets: pureDocView ? [] : [
          // isADraft ? <ThreeDotsMenu key="menu" {...actionsForMenu} productName={productName} ratePackageName={ratePackageName} /> : undefined,
          isADraft && _react2.default.createElement(_materialUi.FlatButton, {
            key: 'editTools',
            label: this.state.showToolBar ? 'Hide Toolbar' : 'Show Toolbar',
            labelStyle: { textTransform: 'none', paddingRight: '8px' },
            hoverColor: 'rgba(0, 0, 0, 0.15)',
            style: { color: 'white', width: '165px' },
            onTouchTap: this.toggleToolbar,
            labelPosition: 'before',
            icon: _react2.default.createElement(_materialUi.FontIcon, {
              className: this.state.showToolBar ? 'tc-icon-keyboard_arrow_up2' : 'tc-icon-keyboard_arrow_down2',
              style: { color: 'white', fontSize: '22px', marginLeft: '8px' }
            })
          }), !isADraft && _react2.default.createElement(
            _wrapper2.default,
            { amazonOrange: true, key: 'compare' },
            _react2.default.createElement(_materialUi.FlatButton, {
              key: 'compare',
              label: 'Compare with',
              labelStyle: { textTransform: 'none', paddingRight: '8px' },
              hoverColor: 'rgba(0, 0, 0, 0.15)',
              style: { color: 'white', minWidth: '68px' },
              onClick: function onClick() {
                return push('/contracting/reports/diff/template/' + contractId + '?locationId=' + locationId + '&locationName=' + locationName);
              },
              labelPosition: 'before',
              icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-swap_horiz', style: { color: 'white', fontSize: '22px', marginLeft: '8px' } })
            })
          ), !isADraft && !isDummyAccount && _react2.default.createElement(_materialUi.FlatButton, {
            key: 'copy',
            label: 'Make a copy',
            labelStyle: { textTransform: 'none', paddingRight: '8px' },
            hoverColor: 'rgba(0, 0, 0, 0.15)',
            style: { color: 'white', minWidth: '68px' },
            onTouchTap: function onTouchTap() {
              return actionsForContractWindow.openDialogSaveAsTemplate(contractId, { startDate: startDate, endDate: endDate });
            },
            labelPosition: 'before',
            icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-content_copy', style: { color: 'white', fontSize: '22px', marginLeft: '8px' } })
          }), _react2.default.createElement(_materialUi.FlatButton, {
            key: 'Download',
            label: 'Review Rates',
            labelStyle: { textTransform: 'none', paddingRight: '8px' },
            hoverColor: 'rgba(0, 0, 0, 0.15)',
            style: { color: 'white', minWidth: '68px' },
            onTouchTap: function onTouchTap(e) {
              if (draftErrorsExist) window.alert('Please complete the draft first');else actionsForContractWindow.downloadContractPdf(contractId, contractState, e.currentTarget);
            },
            labelPosition: 'before',
            icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-get_app', style: { color: 'white', fontSize: '22px', marginLeft: '8px' } })
          }), !isADraft && isLatest ? _react2.default.createElement(_materialUi.FlatButton, {
            key: 'edit',
            label: 'Edit',
            hoverColor: 'rgba(0, 0, 0, 0.15)',
            labelStyle: { textTransform: 'none', paddingRight: '8px' },
            style: { color: 'white', minWidth: '68px' },
            onTouchTap: actionsForContractWindow.createNGoToDraft,
            labelPosition: 'before',
            icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-mode_edit', style: { color: 'white', fontSize: '22px', marginLeft: '8px' } })
          }) : undefined, threadId ? _react2.default.createElement(_smallButtons.SmallRaisedButton, {
            label: 'Activities',
            key: 'changelog',
            labelStyle: { padding: '8px' },
            style: { borderRadius: '5px' },
            secondary: true,
            onClick: function onClick() {
              return push('/contracting/template/' + threadId + '/logs');
            }
          }) : undefined]
        },
        children
      );
    }
  }]);

  return DraftNTemplateWindowDataWrapper;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state, _ref) {
  var reducerName = _ref.reducerName;
  var contracting = state.contracting,
      user = state.user;

  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  var companyType = user.getIn(['user', 'type']);
  return _extends({
    companyType: companyType,
    isShellAccount: user.get('contractingShell') || false,
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop'
  }, leftNav, {
    productType: contracting[reducerName].getIn(['rightSideContent', 'productType']),
    draftErrorsExist: contracting[reducerName].get('draftErrors').toJS().errorExist,
    productName: contracting[reducerName].getIn(['rightSideContent', 'productName']),
    productId: contracting[reducerName].getIn(['rightSideContent', 'productId']),
    ratePackageIndex: contracting[reducerName].getIn(['rightSideContent', 'ratePackageIndex']),
    ratePackageName: contracting[reducerName].getIn(['rightSideContent', 'ratePackageName']),
    policyNotesTemplateId: contracting[reducerName].getIn(['rightSideContent', 'policyNotesTemplateId']),
    policyNotesTemplateName: contracting[reducerName].getIn(['rightSideContent', 'policyNotesTemplateName']),
    isDummyAccount: user.get('isDummyAccount'),
    pureDocView: user.get('pureDocView')
  });
};
DraftNTemplateWindowDataWrapper.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  push: _reactRouterRedux.push
})(DraftNTemplateWindowDataWrapper);

/***/ }),
/* 3353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _playlistAddCheck = __webpack_require__(3354);

var _playlistAddCheck2 = _interopRequireDefault(_playlistAddCheck);

var _getApp = __webpack_require__(1558);

var _getApp2 = _interopRequireDefault(_getApp);

var _save = __webpack_require__(3355);

var _save2 = _interopRequireDefault(_save);

var _importExport = __webpack_require__(1945);

var _importExport2 = _interopRequireDefault(_importExport);

var _contentCopy = __webpack_require__(3356);

var _contentCopy2 = _interopRequireDefault(_contentCopy);

var _sync = __webpack_require__(3357);

var _sync2 = _interopRequireDefault(_sync);

var _syncDisabled = __webpack_require__(3358);

var _syncDisabled2 = _interopRequireDefault(_syncDisabled);

var _attachMoney = __webpack_require__(3359);

var _attachMoney2 = _interopRequireDefault(_attachMoney);

var _driveEta = __webpack_require__(3360);

var _driveEta2 = _interopRequireDefault(_driveEta);

var _timer = __webpack_require__(3361);

var _timer2 = _interopRequireDefault(_timer);

var _libraryAdd = __webpack_require__(3362);

var _libraryAdd2 = _interopRequireDefault(_libraryAdd);

var _hotel = __webpack_require__(1541);

var _hotel2 = _interopRequireDefault(_hotel);

var _iconTextTile = __webpack_require__(3363);

var _iconTextTile2 = _interopRequireDefault(_iconTextTile);

var _tabWithMenu = __webpack_require__(3364);

var _tabWithMenu2 = _interopRequireDefault(_tabWithMenu);

var _syncDialog = __webpack_require__(3365);

var _syncDialog2 = _interopRequireDefault(_syncDialog);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _contractActivitiesProductsActions = __webpack_require__(493);

var _dialogConstants = __webpack_require__(616);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  container: { borderBottom: '1px solid #e0e0e0', padding: '0 8px', marginBottom: '4px', backgroundColor: '#f4f6fa' },
  tabItemContainer: { backgroundColor: 'transparent' },
  buttonStyle: { color: 'rgba(0, 0, 0, 0.87)', height: '32px' },
  tab: { textTransform: 'none' }
};

var TemplateDraftToolbar = function (_Component) {
  _inherits(TemplateDraftToolbar, _Component);

  function TemplateDraftToolbar() {
    _classCallCheck(this, TemplateDraftToolbar);

    var _this = _possibleConstructorReturn(this, (TemplateDraftToolbar.__proto__ || Object.getPrototypeOf(TemplateDraftToolbar)).call(this));

    _this.onMenuOpen = function (value) {
      return function (e) {
        _this.setState({
          menuOpen: _this.state.menuOpen === value ? '' : value
        });
      };
    };

    _this.onMenuClose = function (value) {
      return function (open) {
        if (!open && value === _this.state.menuOpen) _this.setState({ menuOpen: '' });
      };
    };

    _this.onTabChange = function (value) {
      return _this.setState({ value: value });
    };

    _this.onReviewRates = function () {
      if (_this.props.draftErrorsExist) window.alert('Please complete the draft first');else _this.props.downloadContractPdf(_this.props.contractId, _this.props.contractState);
    };

    _this.onClickFinalise = function () {
      var _this$props = _this.props,
          draftErrorsExist = _this$props.draftErrorsExist,
          editHistory = _this$props.editHistory,
          goToSendUpdates = _this$props.goToSendUpdates,
          openPublishConfirmation = _this$props.openPublishConfirmation,
          sentPartners = _this$props.sentPartners,
          stagedUpdates = _this$props.stagedUpdates,
          originFrom = _this$props.originFrom,
          draftType = _this$props.draftType,
          progressCheck = _this$props.progressCheck;

      var firstStepCompleted = !draftErrorsExist;
      var isEditedDraft = originFrom === 'edited';
      var isContractDraft = isEditedDraft && draftType !== 'template';
      var activeDraft = isContractDraft || sentPartners && sentPartners.length;
      var stagedDraft = stagedUpdates && stagedUpdates.find(function (obj) {
        return obj.source === 'draft';
      });
      if (_ramda2.default.isEmpty(editHistory)) {
        window.alert('You haven\'t made any updates to this template.');
      } else if (stagedDraft) {
        window.alert('Please remove draft from queue to continue editing.');
      } else if (!firstStepCompleted) {
        window.alert('Please complete the template before finalising it.');
        progressCheck();
      } else if (activeDraft) {
        goToSendUpdates();
      } else {
        openPublishConfirmation();
      }
    };

    _this.goToMassRateChange = function () {
      var _this$props2 = _this.props,
          locationName = _this$props2.locationName,
          contractId = _this$props2.contractId,
          push = _this$props2.push;

      push('/contracting/mass-rate-change/' + contractId + '/seasonRates?locationName=' + locationName);
    };

    _this.openSyncDialog = function (payload) {
      return function () {
        _this.setState({ syncDialog: _extends({ open: true }, payload) });
      };
    };

    _this.closeSyncDialog = function () {
      return _this.setState({ syncDialog: { open: false } });
    };

    _this.dontSyncRates = function () {
      return _this.setState({ syncDialog: _extends({}, _this.state.syncDialog, { syncRatesToo: false }) });
    };

    _this.checkSyncRates = function () {
      return _this.setState({ syncDialog: _extends({}, _this.state.syncDialog, { syncRatesToo: true }) });
    };

    _this.doSync = function () {
      var _this$props3 = _this.props,
          contractId = _this$props3.contractId,
          productId = _this$props3.productId,
          syncProductInfo = _this$props3.syncProductInfo;
      var _this$state$syncDialo = _this.state.syncDialog,
          syncRatesToo = _this$state$syncDialo.syncRatesToo,
          value = _this$state$syncDialo.value,
          currentlySynced = _this$state$syncDialo.currentlySynced;

      _this.setState({ syncDialog: _extends({}, _this.state.syncDialog, { loading: true }) });
      syncProductInfo({
        contractId: contractId,
        productId: productId,
        sectionInEdit: value,
        syncRatesToo: syncRatesToo,
        syncSection: !currentlySynced
      }).then(function () {
        return _this.setState({ syncDialog: _extends({}, _this.state.syncDialog, { loading: false, open: false }) });
      });
    };

    _this.manageRatePackages = function () {
      var _this$props4 = _this.props,
          productName = _this$props4.productName,
          productId = _this$props4.productId,
          ratePackageIndex = _this$props4.ratePackageIndex,
          manageRatePackages = _this$props4.manageRatePackages;

      manageRatePackages({ productName: productName, productId: productId, ratePackageIndex: ratePackageIndex });
    };

    _this.state = {
      value: 'template',
      menuOpen: '',
      syncDialog: {
        open: false
      }
    };
    return _this;
  }

  _createClass(TemplateDraftToolbar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classes = _props.classes,
          progressCheck = _props.progressCheck,
          importFromTemplate = _props.importFromTemplate,
          copyDataFromAnotherProduct = _props.copyDataFromAnotherProduct,
          manageOffers = _props.manageOffers,
          manageExtras = _props.manageExtras,
          isAccom = _props.isAccom,
          isDummyAccount = _props.isDummyAccount,
          pureDocView = _props.pureDocView,
          productType = _props.productType;

      var syncedSections = this.props.syncedSections || [];
      var tabData = [{
        labelText: 'Template',
        value: 'template'
      }, {
        labelText: 'Import',
        value: 'import'
      }, window.location.href.indexOf('/product/') > -1 ? {
        labelText: 'Sync',
        value: 'sync'
      } : null, {
        labelText: 'Tools',
        value: 'tools'
      }].filter(function (x) {
        return x;
      });
      var data = {
        template: [{
          text: 'Progress Check',
          Icon: _playlistAddCheck2.default,
          onClick: progressCheck
        }, {
          text: 'Review rates',
          Icon: _getApp2.default,
          onClick: this.onReviewRates
        }, pureDocView ? null : {
          text: 'Finalise template',
          Icon: _save2.default,
          onClick: this.onClickFinalise
        }].filter(function (x) {
          return x;
        }),
        import: [{
          text: 'Import template',
          Icon: _importExport2.default,
          onClick: importFromTemplate
        }],
        sync: [{
          text: syncedSections.indexOf('seasons') > -1 ? 'Seasons synced' : 'Seasons not synced',
          Icon: syncedSections.indexOf('seasons') > -1 ? _sync2.default : _syncDisabled2.default,
          iconColor: syncedSections.indexOf('seasons') > -1 ? '#00bcd4' : 'rgba(0, 0, 0, 0.87)',
          onClick: this.openSyncDialog({
            value: 'seasons',
            labelText: 'Seasons',
            currentlySynced: syncedSections.indexOf('seasons') > -1
          })
        }, {
          text: syncedSections.indexOf('blackouts') > -1 ? 'Blackouts synced' : 'Blackouts not synced',
          Icon: syncedSections.indexOf('blackouts') > -1 ? _sync2.default : _syncDisabled2.default,
          iconColor: syncedSections.indexOf('blackouts') > -1 ? '#00bcd4' : 'rgba(0, 0, 0, 0.87)',
          onClick: this.openSyncDialog({
            value: 'blackouts',
            labelText: 'Blackout Dates',
            currentlySynced: syncedSections.indexOf('blackouts') > -1
          })
        }, {
          text: syncedSections.indexOf('allocation') > -1 ? 'Allocation synced' : 'Allocation not synced',
          Icon: syncedSections.indexOf('allocation') > -1 ? _sync2.default : _syncDisabled2.default,
          iconColor: syncedSections.indexOf('allocation') > -1 ? '#00bcd4' : 'rgba(0, 0, 0, 0.87)',
          onClick: this.openSyncDialog({
            value: 'allocation',
            labelText: 'Allocation',
            currentlySynced: syncedSections.indexOf('allocation') > -1
          })
        }, isAccom ? null : {
          text: syncedSections.indexOf('pickup') > -1 ? 'Pick Up / Opening synced' : 'Pick Up / Opening not synced',
          Icon: syncedSections.indexOf('pickup') > -1 ? _sync2.default : _syncDisabled2.default,
          iconColor: syncedSections.indexOf('pickup') > -1 ? '#00bcd4' : 'rgba(0, 0, 0, 0.87)',
          onClick: this.openSyncDialog({
            value: 'pickup',
            labelText: 'Pick Up / Opening',
            currentlySynced: syncedSections.indexOf('pickup') > -1
          })
        }, isAccom ? null : {
          text: syncedSections.indexOf('dropoff') > -1 ? 'Drop Off / Closing synced' : 'Drop Off / Closing not synced',
          Icon: syncedSections.indexOf('dropoff') > -1 ? _sync2.default : _syncDisabled2.default,
          iconColor: syncedSections.indexOf('dropoff') > -1 ? '#00bcd4' : 'rgba(0, 0, 0, 0.87)',
          onClick: this.openSyncDialog({
            value: 'dropoff',
            labelText: 'Drop Off / Closing',
            currentlySynced: syncedSections.indexOf('dropoff') > -1
          })
        }, {
          text: syncedSections.indexOf('cancellations') > -1 ? 'Seasonal Cancellations synced' : 'Seasonal Cancellations not synced',
          Icon: syncedSections.indexOf('cancellations') > -1 ? _sync2.default : _syncDisabled2.default,
          iconColor: syncedSections.indexOf('cancellations') > -1 ? '#00bcd4' : 'rgba(0, 0, 0, 0.87)',
          onClick: this.openSyncDialog({
            value: 'cancellations',
            labelText: 'Seasonal Cancellations',
            currentlySynced: syncedSections.indexOf('cancellations') > -1
          })
        }].filter(function (x) {
          return x;
        }),
        tools: [{
          text: 'Mass Rate Change',
          Icon: _attachMoney2.default,
          onClick: this.goToMassRateChange
        }, {
          text: 'Manage Extras',
          Icon: _driveEta2.default,
          onClick: manageExtras
        }, {
          text: 'Manage Special Offers',
          Icon: _timer2.default,
          onClick: manageOffers
        }]
      };
      if (window.location.href.indexOf('/product/') > -1) {
        data.import.push({
          text: 'Import product data',
          Icon: _contentCopy2.default,
          onClick: copyDataFromAnotherProduct
        });
        data.tools.push({
          text: 'Manage Rate Packages',
          Icon: _libraryAdd2.default,
          tooltip: 'Rate packages allow you to load different rates types for the same product and season. For instance, if you have an English/Foreign Language rate or Bed & Breakfast/Room Only rate.',
          onClick: this.manageRatePackages
        });
        if (isDummyAccount && productType === 'Accommodation') {
          data.tools.push({
            text: 'Update Bedding Config',
            Icon: _hotel2.default,
            tooltip: '',
            onClick: this.props.updateBeddingConfig
          });
        }
      }
      return _react2.default.createElement(
        'div',
        { className: classes.container },
        _react2.default.createElement(
          _materialUi.Tabs,
          {
            value: this.state.value,
            style: {
              paddingRight: window.location.href.indexOf('/product/') > -1 ? 'calc(100% - 500px)' : 'calc(100% - 300px)',
              borderBottom: '1px solid #e0e0e0'
            },
            tabItemContainerStyle: styles.tabItemContainer,
            inkBarStyle: { backgroundColor: '#00bcd4' },
            onChange: this.onTabChange
          },
          tabData.map(function (obj) {
            return _react2.default.createElement(_materialUi.Tab, {
              key: obj.labelText,
              label: _react2.default.createElement(_tabWithMenu2.default, _extends({}, obj, {
                menuOpen: _this2.state.menuOpen === obj.value,
                onMenuClose: _this2.onMenuClose,
                onMenuOpen: _this2.onMenuOpen,
                menuData: data[obj.value]
              })),
              buttonStyle: styles.buttonStyle,
              style: styles.tab,
              value: obj.value
            });
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'flex-center' },
          function () {
            if (_this2.state.value === 'sync' && window.location.href.indexOf('/product/') === -1) {
              return _react2.default.createElement('div', null);
            }
            if (_this2.state.value) {
              return data[_this2.state.value].map(function (obj) {
                return _react2.default.createElement(_iconTextTile2.default, _extends({ key: obj.text }, obj));
              });
            }
          }()
        ),
        _react2.default.createElement(_syncDialog2.default, _extends({}, this.state.syncDialog, {
          onRequestClose: this.closeSyncDialog,
          onConfirm: this.doSync,
          dontSyncRates: this.dontSyncRates,
          checkSyncRates: this.checkSyncRates,
          isAccom: isAccom
        }))
      );
    }
  }]);

  return TemplateDraftToolbar;
}(_react.Component);

TemplateDraftToolbar.propTypes = {
  classes: _react2.default.PropTypes.object,
  syncedSections: _react2.default.PropTypes.array,
  progressCheck: _react2.default.PropTypes.func,
  importFromTemplate: _react2.default.PropTypes.func,
  copyDataFromAnotherProduct: _react2.default.PropTypes.func,
  manageOffers: _react2.default.PropTypes.func,
  manageExtras: _react2.default.PropTypes.func,
  contractId: _react2.default.PropTypes.string,
  productId: _react2.default.PropTypes.string,
  syncProductInfo: _react2.default.PropTypes.func,
  draftErrorsExist: _react2.default.PropTypes.bool,
  editHistory: _react2.default.PropTypes.array,
  goToSendUpdates: _react2.default.PropTypes.func,
  openPublishConfirmation: _react2.default.PropTypes.func,
  sentPartners: _react2.default.PropTypes.array,
  stagedUpdates: _react2.default.PropTypes.array,
  originFrom: _react2.default.PropTypes.string,
  draftType: _react2.default.PropTypes.string,
  downloadContractPdf: _react2.default.PropTypes.func,
  contractState: _react2.default.PropTypes.string,
  push: _react2.default.PropTypes.func,
  locationName: _react2.default.PropTypes.string,
  isAccom: _react2.default.PropTypes.bool,
  productName: _react2.default.PropTypes.string,
  productType: _react2.default.PropTypes.string,
  ratePackageIndex: _react2.default.PropTypes.number,
  manageRatePackages: _react2.default.PropTypes.func,
  isDummyAccount: _react2.default.PropTypes.bool,
  pureDocView: _react2.default.PropTypes.bool,
  updateBeddingConfig: _react2.default.PropTypes.func

};

var mapState = function mapState(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user;
  return _extends({}, contracting.contractActivitiesProducts.get('leftNav').toJS(), {
    productId: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productId']),
    productName: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productName']),
    productType: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productType']),
    ratePackageIndex: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'ratePackageIndex']),
    draftErrorsExist: contracting.contractActivitiesProducts.get('draftErrors').toJS().errorExist,
    isAccom: contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productType']) === 'Accommodation',
    isDummyAccount: user.get('isDummyAccount'),
    pureDocView: user.get('pureDocView')
  });
};

var mapActions = {
  push: _reactRouterRedux.push,
  progressCheck: function progressCheck() {
    return { type: 'TOGGLE_DRAFT_ERRORS_DIALOG' };
  },
  syncProductInfo: _dialogConstants.syncProductInfo,
  downloadContractPdf: _contractActivitiesProductsActions.downloadContractPdf,
  openPublishConfirmation: function openPublishConfirmation() {
    return {
      type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG',
      payload: { open: true, title: 'Finalise Template' }
    };
  },
  goToSendUpdates: function goToSendUpdates() {
    return { type: 'SEND_UPDATES_IN_PUBLISH_DRAFT_DIALOG' };
  },
  importFromTemplate: function importFromTemplate() {
    return {
      type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
      payload: { type: 'importFromTemplate' }
    };
  },
  copyDataFromAnotherProduct: function copyDataFromAnotherProduct() {
    return {
      type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
      payload: {
        type: 'copyDataFromAnotherProduct',
        data: {
          title: 'Copy data from another product',
          noShowIfEmpty: false
        }
      }
    };
  },
  manageOffers: function manageOffers() {
    return {
      type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
      payload: {
        type: 'manageExtrasOffers',
        data: {
          title: 'Manage Special Offers'
        },
        offersOrExtras: {
          type: 'offers'
        }
      }
    };
  },
  manageExtras: function manageExtras() {
    return {
      type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
      payload: {
        type: 'manageExtrasOffers',
        data: {
          title: 'Manage Extras'
        },
        offersOrExtras: {
          type: 'extras'
        }
      }
    };
  },
  manageRatePackages: function manageRatePackages(_ref2) {
    var productName = _ref2.productName,
        productId = _ref2.productId,
        ratePackageIndex = _ref2.ratePackageIndex;
    return {
      type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
      payload: {
        type: 'manageRatePackage',
        title: 'Manage Rate Packages for ' + productName,
        data: { productId: productId, ratePackageIndex: ratePackageIndex }
      }
    };
  },
  updateBeddingConfig: function updateBeddingConfig() {
    return {
      type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
      payload: {
        type: 'updateBeddingConfig',
        data: {
          title: 'Update Bedding Configuration'
        }
      }
    };
  }
};

exports.default = (0, _reactJss2.default)(styles)((0, _reactRedux.connect)(mapState, mapActions)(TemplateDraftToolbar));

/***/ }),
/* 3354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPlaylistAddCheck = function AvPlaylistAddCheck(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z' })
  );
};
AvPlaylistAddCheck = (0, _pure2.default)(AvPlaylistAddCheck);
AvPlaylistAddCheck.displayName = 'AvPlaylistAddCheck';
AvPlaylistAddCheck.muiName = 'SvgIcon';

exports.default = AvPlaylistAddCheck;

/***/ }),
/* 3355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentSave = function ContentSave(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z' })
  );
};
ContentSave = (0, _pure2.default)(ContentSave);
ContentSave.displayName = 'ContentSave';
ContentSave.muiName = 'SvgIcon';

exports.default = ContentSave;

/***/ }),
/* 3356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentContentCopy = function ContentContentCopy(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z' })
  );
};
ContentContentCopy = (0, _pure2.default)(ContentContentCopy);
ContentContentCopy.displayName = 'ContentContentCopy';
ContentContentCopy.muiName = 'SvgIcon';

exports.default = ContentContentCopy;

/***/ }),
/* 3357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationSync = function NotificationSync(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
  );
};
NotificationSync = (0, _pure2.default)(NotificationSync);
NotificationSync.displayName = 'NotificationSync';
NotificationSync.muiName = 'SvgIcon';

exports.default = NotificationSync;

/***/ }),
/* 3358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationSyncDisabled = function NotificationSyncDisabled(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64L20 4z' })
  );
};
NotificationSyncDisabled = (0, _pure2.default)(NotificationSyncDisabled);
NotificationSyncDisabled.displayName = 'NotificationSyncDisabled';
NotificationSyncDisabled.muiName = 'SvgIcon';

exports.default = NotificationSyncDisabled;

/***/ }),
/* 3359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorAttachMoney = function EditorAttachMoney(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z' })
  );
};
EditorAttachMoney = (0, _pure2.default)(EditorAttachMoney);
EditorAttachMoney.displayName = 'EditorAttachMoney';
EditorAttachMoney.muiName = 'SvgIcon';

exports.default = EditorAttachMoney;

/***/ }),
/* 3360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationDriveEta = function NotificationDriveEta(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z' })
  );
};
NotificationDriveEta = (0, _pure2.default)(NotificationDriveEta);
NotificationDriveEta.displayName = 'NotificationDriveEta';
NotificationDriveEta.muiName = 'SvgIcon';

exports.default = NotificationDriveEta;

/***/ }),
/* 3361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageTimer = function ImageTimer(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
  );
};
ImageTimer = (0, _pure2.default)(ImageTimer);
ImageTimer.displayName = 'ImageTimer';
ImageTimer.muiName = 'SvgIcon';

exports.default = ImageTimer;

/***/ }),
/* 3362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvLibraryAdd = function AvLibraryAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
  );
};
AvLibraryAdd = (0, _pure2.default)(AvLibraryAdd);
AvLibraryAdd.displayName = 'AvLibraryAdd';
AvLibraryAdd.muiName = 'SvgIcon';

exports.default = AvLibraryAdd;

/***/ }),
/* 3363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconTextTile = function (_Component) {
  _inherits(IconTextTile, _Component);

  function IconTextTile() {
    _classCallCheck(this, IconTextTile);

    var _this = _possibleConstructorReturn(this, (IconTextTile.__proto__ || Object.getPrototypeOf(IconTextTile)).call(this));

    _this.onMouseOver = function () {
      return _this.setState({ mouseOver: true });
    };

    _this.onMouseLeave = function () {
      return _this.setState({ mouseOver: false });
    };

    _this.state = {
      mouseOver: false
    };
    return _this;
  }

  _createClass(IconTextTile, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          Icon = _props.Icon,
          onClick = _props.onClick,
          iconColor = _props.iconColor,
          tooltip = _props.tooltip;

      return _react2.default.createElement(
        'div',
        {
          style: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            cursor: 'pointer',
            padding: '4px 8px',
            backgroundColor: this.state.mouseOver ? '#e0e0e0' : 'transparent',
            whiteSpace: 'pre-wrap'
          },
          onMouseEnter: this.onMouseOver,
          onMouseLeave: this.onMouseLeave,
          onClick: onClick
        },
        _react2.default.createElement(Icon, { color: iconColor || 'rgba(0, 0, 0, 0.87)' }),
        tooltip ? _react2.default.createElement(
          'div',
          {
            className: 'hint--bottom hint--large hint--rounded',
            'aria-label': tooltip
          },
          text
        ) : _react2.default.createElement(
          'div',
          { style: { textAlign: 'center', fontSize: '1em' } },
          text
        )
      );
    }
  }]);

  return IconTextTile;
}(_react.Component);

exports.default = IconTextTile;

/***/ }),
/* 3364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabLabelWithMenu = function TabLabelWithMenu(props) {
  var menuOpen = props.menuOpen,
      onMenuClose = props.onMenuClose,
      onMenuOpen = props.onMenuOpen,
      menuData = props.menuData,
      labelText = props.labelText,
      value = props.value;

  return _react2.default.createElement(
    'div',
    { className: 'flex-center', onMouseOver: onMenuOpen(value), onMouseLeave: onMenuClose(value) },
    labelText
  );
};

exports.default = TabLabelWithMenu;

/***/ }),
/* 3365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SyncDialog = function SyncDialog(props) {
  var open = props.open,
      loading = props.loading,
      onRequestClose = props.onRequestClose,
      onConfirm = props.onConfirm,
      value = props.value,
      syncRatesToo = props.syncRatesToo,
      labelText = props.labelText,
      dontSyncRates = props.dontSyncRates,
      checkSyncRates = props.checkSyncRates,
      currentlySynced = props.currentlySynced,
      isAccom = props.isAccom;

  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: open,
      contentStyle: { width: '450px' },
      onRequestClose: onRequestClose,
      actions: [_react2.default.createElement(_flatButtonWithLoader2.default, {
        label: 'cancel',
        primary: true,
        disabled: loading,
        onTouchTap: onRequestClose
      }), _react2.default.createElement(_flatButtonWithLoader2.default, {
        label: 'confirm',
        secondary: true,
        onTouchTap: onConfirm,
        loader: loading
      })]
    },
    function () {
      if (currentlySynced) {
        return _react2.default.createElement(
          'i',
          null,
          labelText,
          ' are currently synced. Once turned off, changes will not be synced the next time you edit ',
          labelText,
          '.'
        );
      }
      if (value === 'seasons') {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'label',
            null,
            'Please select what you would like to sync to other products:'
          ),
          _react2.default.createElement(_materialUi.RadioButton, {
            label: 'Seasons',
            checked: !syncRatesToo,
            onCheck: dontSyncRates
          }),
          _react2.default.createElement(_materialUi.RadioButton, {
            label: 'Seasons with Rates',
            checked: syncRatesToo,
            onCheck: checkSyncRates
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'i',
            null,
            'Please note that by proceeding with this change existing ',
            !syncRatesToo ? 'SEASON' : 'SEASON & RATES',
            ' in other\xA0',
            isAccom ? 'rooms' : 'products',
            ' will be overwritten.'
          )
        );
      }
      return _react2.default.createElement(
        'i',
        null,
        'Please note that by proceeding with this change existing ',
        labelText,
        ' in other ',
        isAccom ? 'rooms' : 'products',
        ' will be overwritten.'
      );
    }()
  );
};

SyncDialog.propTypes = {
  open: _react2.default.PropTypes.bool,
  loading: _react2.default.PropTypes.bool,
  onRequestClose: _react2.default.PropTypes.func,
  onConfirm: _react2.default.PropTypes.func,
  value: _react2.default.PropTypes.string,
  syncRatesToo: _react2.default.PropTypes.bool,
  labelText: _react2.default.PropTypes.string,
  dontSyncRates: _react2.default.PropTypes.func,
  checkSyncRates: _react2.default.PropTypes.func,
  currentlySynced: _react2.default.PropTypes.bool,
  isAccom: _react2.default.PropTypes.bool
};

exports.default = SyncDialog;

/***/ }),
/* 3366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _smallButtons = __webpack_require__(94);

var _actions = __webpack_require__(737);

var _reactRouter = __webpack_require__(67);

var _reactRouterRedux = __webpack_require__(27);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickMasterBtnIndicator = function PickMasterBtnIndicator(props) {
  var push = props.push,
      removeMasterTemplate = props.removeMasterTemplate,
      templateDraftId = props.templateDraftId,
      masterTemplateName = props.masterTemplateName,
      masterTemplateType = props.masterTemplateType,
      masterTemplateId = props.masterTemplateId,
      editable = props.editable;

  if (masterTemplateId) {
    return _react2.default.createElement(
      'div',
      { className: 'flex-center' },
      _react2.default.createElement(
        _reactRouter.Link,
        {
          to: '/contracting/master-template/' + masterTemplateId,
          style: { fontSize: '14px' }
        },
        'Corporate Policies & Notes applied: ',
        masterTemplateName
      ),
      editable && _react2.default.createElement(_smallButtons.SmallFlatButton, {
        style: { border: '1px solid #ff4081', marginLeft: '8px' },
        primary: true,
        labelStyle: { padding: '0 6px' },
        label: 'Remove Corporate Template',
        onTouchTap: removeMasterTemplate
      })
    );
  }
  if (!editable) {
    return _react2.default.createElement('div', null);
  }
  return _react2.default.createElement(_smallButtons.SmallFlatButton, {
    style: { border: '1px solid #00bcd4' },
    secondary: true,
    labelStyle: { padding: '0 6px', top: '-1px' },
    label: 'Apply A Corporate Template',
    onTouchTap: function onTouchTap() {
      return push('/contracting/pick-master-template/' + templateDraftId + '?type=' + masterTemplateType);
    }
  });
};

PickMasterBtnIndicator.propTypes = {
  push: _react.PropTypes.func,
  removeMasterTemplate: _react.PropTypes.func,
  templateDraftId: _react.PropTypes.string,
  masterTemplateName: _react.PropTypes.string,
  masterTemplateType: _react.PropTypes.string,
  masterTemplateId: _react.PropTypes.string,
  editable: _react.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(null, {
  push: _reactRouterRedux.push,
  removeMasterTemplate: _actions.removeMasterTemplate
})((0, _reactJss2.default)({})(PickMasterBtnIndicator));

/***/ }),
/* 3367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _newDraft = __webpack_require__(3368);

var _newDraft2 = _interopRequireDefault(_newDraft);

var _template = __webpack_require__(3369);

var _template2 = _interopRequireDefault(_template);

var _editedDraft = __webpack_require__(3370);

var _editedDraft2 = _interopRequireDefault(_editedDraft);

var _draftCompletionErrors = __webpack_require__(3371);

var _draftCompletionErrors2 = _interopRequireDefault(_draftCompletionErrors);

var _dialogConstants = __webpack_require__(616);

var _contractActivitiesProductsActions = __webpack_require__(493);

var _templateStagedUpdatesTextFlag = __webpack_require__(1559);

var _templateStagedUpdatesTextFlag2 = _interopRequireDefault(_templateStagedUpdatesTextFlag);

var _editHistories = __webpack_require__(1261);

var _editHistories2 = _interopRequireDefault(_editHistories);

var _reactRouter = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var propTypes = {
  isADraft: _react.PropTypes.bool,
  leftNav: _react.PropTypes.object,
  processing: _react.PropTypes.bool,
  showDraftChangesPopover: _react.PropTypes.object,
  toggleDraftErrorsDialog: _react.PropTypes.func,
  toggleShowChangesPopover: _react.PropTypes.func,
  discardEditedDraft: _react.PropTypes.func,
  publishDraft: _react.PropTypes.func,
  productsMap: _react.PropTypes.object,
  openPublishConfirmation: _react.PropTypes.func,
  removeDraftFromQueue: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  isDummyAccount: _react.PropTypes.bool,
  isAnAdmin: _react.PropTypes.bool,
  pureDocView: _react.PropTypes.bool,
  acctCreationReason: _react.PropTypes.string,
  forCC: _react.PropTypes.bool
};
var DraftProgressIndicator = function DraftProgressIndicator(props) {
  var isADraft = props.isADraft,
      leftNav = props.leftNav,
      showDraftChangesPopover = props.showDraftChangesPopover,
      toggleDraftErrorsDialog = props.toggleDraftErrorsDialog,
      toggleShowChangesPopover = props.toggleShowChangesPopover,
      discardEditedDraft = props.discardEditedDraft,
      contractId = props.contractId,
      isDummyAccount = props.isDummyAccount,
      pureDocView = props.pureDocView,
      acctCreationReason = props.acctCreationReason;

  var isEditedDraft = leftNav.originFrom === 'edited';
  var isEditedTemplate = leftNav.templateHasDraft;
  var discardEditedDraftWithRouting = function discardEditedDraftWithRouting() {
    discardEditedDraft(contractId);
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { padding: '0 2px' } },
      _ramda2.default.call(_ramda2.default.cond([
      // [() => forCC, R.always(<h4>Actual rate amount are hidden for privacy reasons.</h4>)],
      [function () {
        return pureDocView || acctCreationReason === 'al-account';
      }, _ramda2.default.always(_react2.default.createElement('div', null))],
      // [() => isDummyAccount, R.always(<ForCR {...props} />)],
      [function () {
        return isADraft && !isEditedDraft;
      }, _ramda2.default.always(_react2.default.createElement(_newDraft2.default, props))], [function () {
        return isADraft && isEditedDraft;
      }, _ramda2.default.always(_react2.default.createElement(_editedDraft2.default, props))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(_template2.default, props))]]))
    ),
    _react2.default.createElement(_draftCompletionErrors2.default, { onRequestClose: toggleDraftErrorsDialog }),
    _react2.default.createElement(
      _materialUi.Popover,
      {
        open: showDraftChangesPopover.open,
        anchorEl: showDraftChangesPopover.anchorEl,
        anchorOrigin: { horizontal: 'middle', vertical: 'bottom' },
        targetOrigin: { horizontal: 'right', vertical: 'top' },
        onRequestClose: toggleShowChangesPopover(false),
        style: { padding: '16px' }
      },
      leftNav.diffSummary && leftNav.diffSummary.loading && _react2.default.createElement(
        'div',
        { style: { textAlign: 'center', padding: '10px' } },
        _react2.default.createElement(_materialUi.CircularProgress, { size: 30 })
      ),
      !isNilOrEmpty(leftNav.diffSummary) ? _react2.default.createElement(_editHistories2.default, {
        diffSummary: leftNav.diffSummary
      }) : _react2.default.createElement(
        'span',
        null,
        'You haven\'t made any changes yet.'
      ),
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/contracting/reports/diff/draft/' + contractId + '/' + contractId, style: { color: '#00b3cf' } },
        'View side by side comparison'
      )
    ),
    _ramda2.default.call(_ramda2.default.cond([[function () {
      return leftNav.stagedUpdates && leftNav.stagedUpdates.length;
    }, _ramda2.default.always(_react2.default.createElement(
      'div',
      { style: { margin: '8px 12px', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center' } },
      _react2.default.createElement(_templateStagedUpdatesTextFlag2.default, {
        style: { textAlign: 'right' },
        stagedUpdates: leftNav.stagedUpdates,
        updateInitiated: leftNav.updateInitiated,
        isEditedTemplate: isEditedTemplate,
        isEditedDraft: isEditedDraft,
        refreshSection: 'doc'
      })
    ))], [function () {
      return isEditedDraft && !pureDocView;
    }, _ramda2.default.always(_react2.default.createElement(
      'div',
      { className: 'flex-tc-sb', style: { margin: '8px 0', flexDirection: 'row-reverse' } },
      leftNav.draftType === 'contract' ? _react2.default.createElement(
        'span',
        null,
        'This draft was created from this ',
        _react2.default.createElement(
          'a',
          { style: { cursor: 'pointer' }, href: '/contracting/contract/' + contractId + '/details' },
          ' contract'
        ),
        '.'
      ) : _react2.default.createElement(
        'span',
        null,
        'This draft was created from this ',
        _react2.default.createElement(
          'a',
          { style: { cursor: 'pointer' }, href: '/contracting/template/' + contractId + '/details' },
          ' template'
        ),
        '.'
      ),
      _react2.default.createElement(
        'div',
        { className: 'flex-center' },
        _react2.default.createElement(_materialUi.FlatButton, {
          secondary: true,
          label: _ramda2.default.isEmpty(leftNav.editHistory) ? 'You haven\'t made any changes yet.' : 'View Changes',
          labelStyle: { textTransform: 'none', lineHeight: '30px', height: '30px', padding: '4px', verticalAlign: '', top: '-2px' },
          style: { height: '30px', display: 'block', border: _ramda2.default.isEmpty(leftNav.editHistory) ? 'none' : '1px solid #00bcd4' },
          disabled: _ramda2.default.isEmpty(leftNav.editHistory),
          onTouchTap: toggleShowChangesPopover(true)
        }),
        _react2.default.createElement(_materialUi.FlatButton, {
          primary: true,
          label: _ramda2.default.isEmpty(leftNav.editHistory) ? 'Discard Draft' : 'Discard Changes',
          labelStyle: { textTransform: 'none', lineHeight: '30px', height: '30px', padding: '4px', verticalAlign: '', top: '-2px' },
          style: { height: '30px', border: '1px solid #ff4081', marginLeft: '8px' },
          onTouchTap: discardEditedDraftWithRouting
        })
      )
    ))], [function () {
      return isEditedDraft && pureDocView;
    }, _ramda2.default.always(_react2.default.createElement(_materialUi.FlatButton, {
      secondary: true,
      label: _ramda2.default.isEmpty(leftNav.editHistory) ? 'You haven\'t made any changes yet.' : 'View Changes',
      labelStyle: { textTransform: 'none', lineHeight: '30px', height: '30px', padding: '4px', verticalAlign: '', top: '-2px' },
      style: { height: '30px', display: 'block', border: _ramda2.default.isEmpty(leftNav.editHistory) ? 'none' : '1px solid #00bcd4', marginBottom: '8px' },
      disabled: _ramda2.default.isEmpty(leftNav.editHistory),
      onTouchTap: toggleShowChangesPopover(true)
    }))], [function () {
      return isEditedTemplate;
    }, _ramda2.default.always(_react2.default.createElement(
      'div',
      { style: { margin: '8px 12px', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center' } },
      _react2.default.createElement(
        'span',
        null,
        'This template has a ',
        _react2.default.createElement(
          'a',
          { style: { cursor: 'pointer' }, href: '/contracting/draft/' + contractId + '/details' },
          'draft'
        ),
        '.'
      )
    ))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement('div', { style: { height: '12px' } }))]]))
  );
};
DraftProgressIndicator.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state) {
  var contracting = state.contracting,
      user = state.user;

  var contractingState = contracting.contractActivitiesProducts.toJS();
  var leftNav = contractingState.leftNav;
  return {
    leftNav: leftNav,
    errors: contractingState.draftErrors,
    showDraftChangesPopover: contractingState.showDraftChangesPopover,
    realActorEmail: user.get('realActorEmail'),
    isAnAdmin: user.get('isAnAdmin'),
    pureDocView: user.get('pureDocView'),
    forCC: user.get('forCC'),
    acctCreationReason: user.getIn(['company', 'acctCreationReason'])
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    publishDraft: function publishDraft() {
      return dispatch(_dialogConstants.publishDraft.apply(undefined, arguments));
    },
    toggleDraftErrorsDialog: function toggleDraftErrorsDialog() {
      return dispatch(_contractActivitiesProductsActions.toggleDraftErrorsDialog.apply(undefined, arguments));
    },
    toggleShowChangesPopover: _ramda2.default.curry(function (open, event) {
      return dispatch((0, _contractActivitiesProductsActions.toggleShowChangesPopover)(open, event));
    }),
    discardEditedDraft: function discardEditedDraft() {
      return dispatch(_contractActivitiesProductsActions.discardEditedDraft.apply(undefined, arguments));
    },
    goToSendUpdates: function goToSendUpdates() {
      return dispatch({ type: 'SEND_UPDATES_IN_PUBLISH_DRAFT_DIALOG' });
    },
    openPublishConfirmation: function openPublishConfirmation() {
      return dispatch({ type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG', payload: { open: true, title: 'Finalise Template' } });
    }
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DraftProgressIndicator);

/***/ }),
/* 3368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _arrowForward = __webpack_require__(1246);

var _arrowForward2 = _interopRequireDefault(_arrowForward);

var _supplierWizardComplete = __webpack_require__(1057);

var _supplierWizardComplete2 = _interopRequireDefault(_supplierWizardComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewDraftProgressIndicator = function NewDraftProgressIndicator(_ref) {
  var errors = _ref.errors,
      openPublishConfirmation = _ref.openPublishConfirmation;

  var firstStepCompleted = !errors.errorExist;
  return _react2.default.createElement(
    _materialUi.Stepper,
    { activeStep: firstStepCompleted ? 2 : 1 },
    _react2.default.createElement(
      _materialUi.Step,
      { completed: true },
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px', paddingLeft: 0 } },
        _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          'Create Rate Template'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.Step,
      { completed: firstStepCompleted },
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px', paddingLeft: 0 } },
        _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          'Enter Rates & Required Information'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.Step,
      null,
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px' } },
        _react2.default.createElement(
          'div',
          { style: { textAlign: 'center', width: '100%', display: 'flex', alignItems: 'center' } },
          _react2.default.createElement(
            'span',
            { style: { width: '68px' } },
            'Review &'
          ),
          firstStepCompleted ? _react2.default.createElement(_materialUi.RaisedButton, {
            secondary: true,
            label: 'Finalise Template',
            labelStyle: { padding: '0 4px', textTransform: 'none' },
            style: { marginLeft: '4px', width: '140px' },
            onTouchTap: openPublishConfirmation
          }) : 'Finalise'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.Step,
      { completed: false },
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px', paddingRight: 0 } },
        _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          'Send Rates to Partners'
        )
      )
    )
  );
};

exports.default = NewDraftProgressIndicator;

/***/ }),
/* 3369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _dialogConstants = __webpack_require__(616);

var _send = __webpack_require__(577);

var _send2 = _interopRequireDefault(_send);

var _reactRouterRedux = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getGenitiveCase = function getGenitiveCase(string) {
  if (!string) return string;
  if (string.slice(-1) === 's') return string + '\'';
  return string + '\'s';
};
var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var TemplateProgressIndicator = function TemplateProgressIndicator(_ref) {
  var isADraft = _ref.isADraft,
      errors = _ref.errors,
      leftNav = _ref.leftNav;

  var isEditedDraft = leftNav.originFrom === 'edited';
  var isContractDraft = isEditedDraft && leftNav.draftType !== 'template';
  var activeDraft = isContractDraft || !isNilOrEmpty(leftNav.sentPartners);
  var firstStepCompleted = !isADraft || !errors.errorExist;
  var secondStepCompleted = !isADraft;
  var thirdStepCompleted = !isADraft && !_ramda2.default.isEmpty(leftNav.sentPartners);
  var isLocAccom = leftNav.productType === 'Accommodation';
  return _react2.default.createElement(
    _materialUi.Stepper,
    null,
    _react2.default.createElement(
      _materialUi.Step,
      { completed: true },
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px', paddingLeft: 0 } },
        _react2.default.createElement(
          'div',
          { style: { width: '100%', textAlign: 'center' } },
          'Create Rate Template'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.Step,
      { completed: firstStepCompleted },
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px', paddingLeft: 0 } },
        _react2.default.createElement(
          'div',
          { style: { width: '100%', textAlign: 'center' } },
          'Enter Rates & Required Information'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.Step,
      { completed: secondStepCompleted },
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px' } },
        _react2.default.createElement(
          'div',
          { style: { width: '100%', textAlign: 'center' } },
          'Review & Finalise'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.Step,
      { completed: thirdStepCompleted },
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px', paddingRight: 0 } },
        _react2.default.createElement(
          'div',
          { style: { width: '100%', textAlign: 'center' } },
          secondStepCompleted ? _react2.default.createElement(_materialUi.FlatButton, {
            'data-cy': 'sendRatesToPartnersButton',
            icon: _react2.default.createElement(_send2.default, null),
            label: Boolean(leftNav.partnersCount) ? 'Send to more partners' : 'Send Rates to Partners',
            labelStyle: { padding: '0 4px', fontSize: '12px' },
            secondary: true,
            style: { border: '1px solid #00bcd4', marginLeft: '4px' },
            onTouchTap: function onTouchTap() {
              window.location = "https://app.tourconnect.com" + '/partner-management/send-assets?' + _queryString2.default.stringify({
                go_back_to: window.location.href,
                templateids: [leftNav.contractId],
                message: 'Please find ' + getGenitiveCase(leftNav.locationName === leftNav.supplierName ? leftNav.locationName : leftNav.locationName + ' - ' + leftNav.supplierName) + ' ' + (0, _moment2.default)(leftNav.startDate).utc().format('DD MMM YYYY') + ' - ' + (0, _moment2.default)(leftNav.endDate).utc().format('DD MMM YYYY') + ' rates below. We are using TourConnect as they provide several standardised download formats that should make it easy for you to read and load our rates.\n\nIf you have any questions please let me know and thank you for your support.',
                subject: getGenitiveCase(leftNav.locationName === leftNav.supplierName ? leftNav.locationName : leftNav.locationName + ' - ' + leftNav.supplierName) + ' ' + (0, _moment2.default)(leftNav.startDate).utc().get('year') + '-' + (0, _moment2.default)(leftNav.endDate).utc().get('year') + ' Rates'
              }) + '&jwt=' + localStorage.getItem('jwt');
            }
          }) : 'Send Rates to Partners'
        )
      )
    )
  );
};
TemplateProgressIndicator.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    errors: contracting.contractActivitiesProducts.toJS().draftErrors
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    publishDraft: function publishDraft() {
      return dispatch(_dialogConstants.publishDraft.apply(undefined, arguments));
    },
    routerPush: function routerPush() {
      return dispatch(_reactRouterRedux.push.apply(undefined, arguments));
    }
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TemplateProgressIndicator);

/***/ }),
/* 3370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(1263);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var EditedDraftProgressIndicator = function EditedDraftProgressIndicator(_ref) {
  var errors = _ref.errors,
      leftNav = _ref.leftNav,
      goToSendUpdates = _ref.goToSendUpdates,
      openPublishConfirmation = _ref.openPublishConfirmation,
      removeDraftFromQueue = _ref.removeDraftFromQueue;

  var firstStepCompleted = !errors.errorExist && !_ramda2.default.isEmpty(leftNav.editHistory);
  var isEditedDraft = leftNav.originFrom === 'edited';
  var isContractDraft = isEditedDraft && leftNav.draftType !== 'template';
  var activeDraft = isContractDraft || !isNilOrEmpty(leftNav.sentPartners);
  var stagedDraft = leftNav.stagedUpdates && leftNav.stagedUpdates.find(function (obj) {
    return obj.source === 'draft';
  });
  return _react2.default.createElement(
    _materialUi.Stepper,
    { activeStep: firstStepCompleted ? 1 : 0 },
    _react2.default.createElement(
      _materialUi.Step,
      null,
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px', paddingLeft: 0 } },
        _react2.default.createElement(
          'div',
          { style: { width: '100%', textAlign: 'center' } },
          'Make Changes'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.Step,
      null,
      _react2.default.createElement(
        _materialUi.StepLabel,
        { style: { height: '32px', paddingRight: 0 } },
        _react2.default.createElement(
          'div',
          { style: { width: '100%', textAlign: 'center' } },
          stagedDraft ? _react2.default.createElement(_materialUi.RaisedButton, {
            primary: true,
            label: 'Remove draft from queue to continue editing',
            style: { width: '100%' },
            labelStyle: { textTransform: 'none' },
            disabled: !firstStepCompleted,
            onTouchTap: function onTouchTap() {
              return removeDraftFromQueue(stagedDraft.sourceId, 'doc');
            }
          }) : _react2.default.createElement(_materialUi.RaisedButton, {
            secondary: true,
            label: activeDraft ? 'Send Updates to Partners' : 'Finalise Template',
            style: { width: '100%' },
            disabled: !firstStepCompleted,
            onTouchTap: activeDraft ? goToSendUpdates : openPublishConfirmation
          })
        )
      )
    )
  );
};
EditedDraftProgressIndicator.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(null, { removeDraftFromQueue: _actions.removeDraftFromQueue })(EditedDraftProgressIndicator);

/***/ }),
/* 3371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _main = __webpack_require__(3372);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DraftCompletionErrors = function DraftCompletionErrors(_ref) {
  var open = _ref.open,
      errors = _ref.errors,
      onRequestClose = _ref.onRequestClose,
      productsMap = _ref.productsMap;

  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: open,
      autoScrollBodyContent: true,
      actions: _react2.default.createElement(_materialUi.FlatButton, {
        label: !productsMap ? 'DISMISS' : 'Continue Editing',
        labelStyle: { fontWeight: '600' },
        secondary: true,
        onTouchTap: onRequestClose
      }),
      title: _react2.default.createElement(
        'div',
        { style: { backgroundColor: '#00BCD4', color: 'white', fontSize: '18px', padding: '2%' } },
        'What\'s missing?'
      )
    },
    _react2.default.createElement(_main2.default, { errors: errors, productsMap: productsMap, onRequestClose: onRequestClose, style: { marginTop: '8px' } })
  );
};

DraftCompletionErrors.propTypes = {
  errors: _react.PropTypes.object,
  onRequestClose: _react.PropTypes.func,
  productsMap: _react.PropTypes.object
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    open: contracting.contractActivitiesProducts.get('showAllDraftErrorsDialog'),
    productsMap: contracting.contractActivitiesProducts.getIn(['leftNav', 'productsArray']) ? contracting.contractActivitiesProducts.getIn(['leftNav', 'productsArray']).toJS().reduce(function (result, product) {
      result[product.productId] = product.productName;
      return result;
    }, {}) : {},
    errors: contracting.contractActivitiesProducts.toJS().draftErrors
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DraftCompletionErrors);

/***/ }),
/* 3372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _editLink = __webpack_require__(3373);

var _editLink2 = _interopRequireDefault(_editLink);

var _errorCheckIndicatorIcon = __webpack_require__(1138);

var _errorCheckIndicatorIcon2 = _interopRequireDefault(_errorCheckIndicatorIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var SingleSection = function SingleSection(_ref) {
  var text = _ref.text,
      to = _ref.to,
      hide = _ref.hide,
      showError = _ref.showError,
      onRequestClose = _ref.onRequestClose,
      openEditDialog = _ref.openEditDialog,
      hash = _ref.hash,
      additionalTexts = _ref.additionalTexts;

  return _react2.default.createElement(
    'div',
    { style: { display: hide ? 'none' : 'flex', alignItems: 'flex-start', marginLeft: '24px' } },
    _react2.default.createElement(_errorCheckIndicatorIcon2.default, { showError: showError }),
    _react2.default.createElement(
      'div',
      { style: { marginLeft: '16px' } },
      text,
      _react2.default.createElement(_editLink2.default, {
        onRequestClose: onRequestClose,
        openEditDialog: openEditDialog,
        hash: hash
      }),
      Boolean(additionalTexts && additionalTexts.length) && additionalTexts.map(function (additionalText, i) {
        return _react2.default.createElement(
          'div',
          { key: i, style: { display: 'flex', alignItems: 'center', fontSize: '14px' } },
          '--',
          additionalText
        );
      })
    )
  );
};

var CheckYourProgress = function CheckYourProgress(_ref2) {
  var errors = _ref2.errors,
      productsMap = _ref2.productsMap,
      contractId = _ref2.contractId,
      onRequestClose = _ref2.onRequestClose,
      style = _ref2.style,
      editFn = _ref2.initiateAddEditContractDialog;

  var missingCheck = function missingCheck(category, type) {
    return _ramda2.default.call(_ramda2.default.compose(_ramda2.default.contains(type), _ramda2.default.propOr([], category)), errors);
  };
  var contractDetailsCheckData = [{
    text: 'Billing Information',
    hash: '#billingInfo',
    hide: !errors.insurance,
    showError: errors.insurance === 'Your insurance document has expired.' || errors.insurance === 'Missing insurance document',
    additionalTexts: [errors.insurance !== 'show' ? errors.insurance : ''].filter(function (x) {
      return x;
    }),
    openEditDialog: function openEditDialog() {
      return editFn({ type: 'billingInfo', title: 'Edit Billing Information', policiesNotesPage: true });
    }
  }, {
    text: 'Cancellation Policy',
    hash: '#cancellationPolicy',
    showError: missingCheck('policyMissing', 'cancellation') || errors.incompleteCancellation,
    openEditDialog: function openEditDialog() {
      return editFn({ type: 'policy', policyType: 'cancellation', policiesNotesPage: true, title: 'Edit Cancellation Policy' });
    },
    additionalTexts: [missingCheck('policyMissing', 'cancellation') ? '-- Cancellation Policy is required' : '', errors.incompleteCancellation ? '-- Incomplete cancellation policy' : ''].filter(function (x) {
      return x;
    })
  }, {
    text: 'Child Policy',
    hash: '#childPolicy',
    showError: missingCheck('policyMissing', 'child') || errors.childInfantOverlap,
    additionalTexts: [errors.childInfantOverlap].filter(function (x) {
      return x;
    }),
    openEditDialog: function openEditDialog() {
      return editFn({ type: 'policy', policyType: 'child', policiesNotesPage: true, title: 'Edit Child Policy' });
    }
  }];
  return _react2.default.createElement(
    'div',
    { style: style },
    _react2.default.createElement(
      'div',
      { style: { border: '1px solid #e0e0e0', padding: '4% 8%' } },
      _react2.default.createElement(
        'b',
        null,
        'REQUIREMENTS: '
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'div',
        { style: { fontSize: '14px', color: 'rgba(0, 0, 0, 0.74)', marginBottom: '24px', display: errors.errorExist ? 'block' : 'none' } },
        'All of the sections below are required in order to complete this template. This information is needed from your partners so they can load and book your products.'
      ),
      _react2.default.createElement(
        'div',
        { style: { textDecoration: 'underline' } },
        'Policies & Notes'
      ),
      _react2.default.createElement('br', null),
      contractDetailsCheckData.map(function (obj, i) {
        return _react2.default.createElement(SingleSection, _extends({
          key: i,
          onRequestClose: onRequestClose
        }, obj));
      }),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'div',
        { style: { textDecoration: 'underline' } },
        'Product',
        _ramda2.default.pathOr(0, ['products', 'length'], errors) === 1 ? '' : 's'
      ),
      _react2.default.createElement('br', null),
      errors.products.map(function (_ref3, index) {
        var rates = _ref3.rates,
            offers = _ref3.offers,
            allocation = _ref3.allocation,
            blackouts = _ref3.blackouts,
            pickup = _ref3.pickup,
            dropoff = _ref3.dropoff,
            productId = _ref3.productId,
            ratePackageName = _ref3.ratePackageName,
            ratePackageIndex = _ref3.ratePackageIndex,
            cancellation = _ref3.cancellation,
            productType = _ref3.productType,
            ratePackageId = _ref3.ratePackageId;

        var sharedPropsForEdit = {
          productId: productId,
          ratePackageName: ratePackageName,
          ratePackageIndex: ratePackageIndex,
          ratePackageId: ratePackageId
        };
        var rpId = function () {
          if (ratePackageId) return ratePackageId;
          return ratePackageName ? encodeURIComponent(ratePackageName) : 'Primary';
        }();
        return _react2.default.createElement(
          'div',
          { key: index, style: { marginBottom: index + 1 < _ramda2.default.pathOr(0, ['products', 'length'], errors) ? '12px' : '0px' } },
          _react2.default.createElement(
            'div',
            { style: { color: 'rgba(0, 0, 0, 0.54)', fontWeight: 'bold' } },
            productsMap[productId],
            ' ',
            ratePackageName ? ' - ' + ratePackageName : ''
          ),
          [{
            text: 'Rates', // TITLE
            showError: _ramda2.default.prop('seasonsCoveringWholePeriod', rates) !== 0 || rates.missingRateSets || _ramda2.default.prop('emptySeasonDates', rates) || !isNilOrEmpty(_ramda2.default.prop('overlappedSeasonRates', rates)) || rates.invalidRateDescriptions || rates.datesOutside,
            hash: '#seasonRates',
            to: '/contracting/draft/' + contractId + '/product/' + productId + '/' + rpId + '#seasonRates',
            additionalTexts: [rates.missingRateSets ? '-- One or more seasons have missing rates' : '', _ramda2.default.prop('seasonsCoveringWholePeriod', rates) > 0 ? '-- Rates do not cover entire contracting period' : '', _ramda2.default.prop('seasonsCoveringWholePeriod', rates) < 0 ? '-- There are overlapping dates' : '', _ramda2.default.prop('emptySeasonDates', rates) ? '-- One or more seasons have missing dates' : '', !isNilOrEmpty(_ramda2.default.prop('overlappedSeasonRates', rates)) && productType === 'Accommodation' ? '-- One or more seasons have overlapping days of the week and min/max stays' : '', !isNilOrEmpty(_ramda2.default.prop('overlappedSeasonRates', rates)) && productType === 'Non-Accommodation' ? '-- One or more seasons have overlapping days of the week' : '', rates.invalidRateDescriptions ? '-- Some rate types in this rate table are no longer supported, as they cannot be automated into your partners\' booking systems.' : '', _ramda2.default.prop('datesOutside', rates) ? '-- Your seasons are not within your contract validity period.' : ''].filter(function (x) {
              return x;
            })
          }, {
            text: 'Allocation', // TITLE
            showError: allocation.allocationMissing || allocation.incompleteAllocation || allocation.datesOutside,
            hash: '#allocation',
            openEditDialog: function openEditDialog() {
              return editFn(_extends({ type: 'allocation', title: 'Edit Allocation' }, sharedPropsForEdit));
            },
            additionalTexts: [allocation.allocationMissing ? '-- Allocation information is required' : '', allocation.incompleteAllocation ? '-- Incomplete allocation information' : '', _ramda2.default.prop('datesOutside', allocation) ? '-- Dates fall outside of contracting period' : ''].filter(function (x) {
              return x;
            })
          }, {
            text: 'Pick-up', // TITLE
            showError: pickup.pickupMissing || pickup.incompletePickup || pickup.datesOutside,
            hide: productType === 'Accommodation',
            hash: '#pickupDropoff',
            openEditDialog: function openEditDialog() {
              return editFn(_extends({
                type: 'pickupDropoff',
                title: 'Edit Pick-up / Opening Information',
                data: { pickupOrDropoff: 'pickup' }
              }, sharedPropsForEdit));
            },
            additionalTexts: [pickup.pickupMissing ? '-- Pick-up / Opening information is required' : '', pickup.incompletePickup ? '-- Incomplete Pick-up / Opening information' : '', _ramda2.default.prop('datesOutside', pickup) ? '-- Dates fall outside of contracting period' : ''].filter(function (x) {
              return x;
            })
          }, {
            text: 'Drop-off', // TITLE
            showError: dropoff.dropoffMissing || dropoff.incompleteDropoff || dropoff.datesOutside,
            hide: productType === 'Accommodation',
            hash: '#pickupDropoff',
            openEditDialog: function openEditDialog() {
              return editFn(_extends({
                type: 'pickupDropoff',
                title: 'Edit Drop-off / Closing Informationn',
                data: { pickupOrDropoff: 'dropoff' }
              }, sharedPropsForEdit));
            },
            additionalTexts: [dropoff.dropoffMissing ? '-- Drop-off / Closing information is required' : '', dropoff.incompleteDropoff ? '-- Incomplete Drop-off / Closing information' : '', _ramda2.default.prop('datesOutside', dropoff) ? '-- Dates fall outside of contracting period' : ''].filter(function (x) {
              return x;
            })
          }, {
            text: 'Offers', // TITLE
            hide: !offers.showOffer,
            showError: _ramda2.default.prop('emptyDates', offers) || _ramda2.default.prop('datesOutside', offers),
            hash: '#offers',
            openEditDialog: function openEditDialog() {
              return editFn(_extends({
                type: 'manageExtrasOffers',
                data: {
                  title: 'Manage Special Offers',
                  type: 'offers'
                },
                offersOrExtras: { type: 'offers' }
              }, sharedPropsForEdit));
            },
            additionalTexts: [_ramda2.default.prop('emptyDates', offers) ? '-- Missing Dates' : '', _ramda2.default.prop('datesOutside', offers) ? '-- Dates fall outside of contracting period' : ''].filter(function (x) {
              return x;
            })
          }, {
            text: 'Blackouts', // TITLE
            hide: !blackouts.showBlackout,
            showError: _ramda2.default.prop('emptyDates', blackouts) || _ramda2.default.prop('datesOutside', blackouts),
            hash: '#blackouts',
            openEditDialog: function openEditDialog() {
              return editFn(_extends({
                type: 'blackouts',
                title: 'Edit Blackouts'
              }, sharedPropsForEdit));
            },
            additionalTexts: [_ramda2.default.prop('emptyDates', blackouts) ? '-- Missing Dates' : '', _ramda2.default.prop('datesOutside', blackouts) ? '-- Dates fall outside of contracting period' : ''].filter(function (x) {
              return x;
            })
          }, {
            text: productType === 'Non-Accommodation' ? 'Product Specific Cancellation Policy' : 'Seasonal Cancellation Policies', // TITLE
            hide: !cancellation.showCancellation,
            showError: cancellation.incompleteCancellation || cancellation.datesOutside,
            hash: '#cancellationPolicy',
            openEditDialog: function openEditDialog() {
              return editFn(_extends({
                type: 'seasonalCancelPolicies',
                title: productType === 'Non-Accommodation' ? 'Edit Product Specific Cancellation Policies' : 'Edit Season Specific Cancellation Policies'
              }, sharedPropsForEdit));
            },
            additionalTexts: [cancellation.incompleteCancellation ? '-- Incomplete Cancellation Policy' : '', _ramda2.default.prop('datesOutside', cancellation) ? '-- Dates fall outside of contracting period' : ''].filter(function (x) {
              return x;
            })
          }].map(function (obj, i) {
            return _react2.default.createElement(SingleSection, _extends({
              key: i,
              onRequestClose: onRequestClose
            }, obj));
          })
        );
      })
    )
  );
};
exports.default = (0, _reactRedux.connect)(function (_ref4) {
  var contracting = _ref4.contracting;
  return {
    contractId: contracting.publishDraftDialog.get('contractId')
  };
}, {
  initiateAddEditContractDialog: function initiateAddEditContractDialog(payload) {
    return { type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE', payload: payload };
  }
})(CheckYourProgress);

/***/ }),
/* 3373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(67);

var _scrollToElement = __webpack_require__(859);

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var to = _ref.to,
      onRequestClose = _ref.onRequestClose,
      hash = _ref.hash,
      openEditDialog = _ref.openEditDialog;
  return to ? _react2.default.createElement(
    _reactRouter.Link,
    { style: { fontSize: '14px', marginLeft: '8px', color: '#00bcd4', cursor: 'pointer' }, to: to, onClick: function onClick() {
        onRequestClose('');
        var scrollToAnchor = function scrollToAnchor() {
          var element = document.querySelector(hash);
          if (element) (0, _scrollToElement2.default)(hash, { offset: -70 });
        };
        scrollToAnchor();
      }
    },
    'Edit'
  ) : _react2.default.createElement(
    'span',
    { style: { fontSize: '14px', marginLeft: '8px', color: '#00bcd4', cursor: 'pointer' }, onClick: function onClick() {
        onRequestClose('');
        var scrollToAnchor = function scrollToAnchor() {
          var element = document.querySelector(hash);
          if (element) (0, _scrollToElement2.default)(hash, { offset: -70 });
        };
        scrollToAnchor();
        openEditDialog();
      }
    },
    'Edit'
  );
};

/***/ }),
/* 3374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _snackBarForPublish = __webpack_require__(3375);

var _snackBarForPublish2 = _interopRequireDefault(_snackBarForPublish);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var ContractDraftSnackBar = function ContractDraftSnackBar(props) {
  var leftNav = props.leftNav,
      processing = props.processing,
      checkContractReadiness = props.checkContractReadiness,
      draftComplete = props.draftComplete,
      goToSendUpdates = props.goToSendUpdates,
      openPublishConfirmation = props.openPublishConfirmation,
      isDummyAccount = props.isDummyAccount;

  if (isDummyAccount) return _react2.default.createElement('span', null);
  var isEditedDraft = leftNav.originFrom === 'edited';
  var isContractDraft = isEditedDraft && leftNav.draftType !== 'template';
  var activeDraft = isContractDraft || !isNilOrEmpty(leftNav.sentPartners);
  return _react2.default.createElement(_snackBarForPublish2.default, {
    className: 'completionCheck',
    bodyStyle: { maxWidth: '1000px', textAlign: 'center' },
    open: true,
    onRequestClose: function onRequestClose() {},
    shouldUpdate: {
      draftComplete: draftComplete,
      activeDraft: activeDraft,
      editHistory: leftNav.editHistory
    },
    message: _react2.default.createElement(
      'div',
      null,
      activeDraft && !isNilOrEmpty(leftNav.editHistory) ? 'Changes have not been sent to your buyers.' : '',
      activeDraft && isNilOrEmpty(leftNav.editHistory) ? 'You haven\'t made any changes yet.' : '',
      draftComplete ? _react2.default.createElement(_flatButtonWithLoader2.default, {
        label: activeDraft ? 'Send Updates' : 'Finalise Template',
        secondary: true,
        disabled: isNilOrEmpty(leftNav.editHistory),
        loader: processing,
        onTouchTap: activeDraft ? goToSendUpdates : openPublishConfirmation,
        labelStyle: isNilOrEmpty(leftNav.editHistory) ? { color: 'grey' } : { fontWeight: '600' },
        hoverColor: 'none',
        style: { marginLeft: '0' }
      }) : _react2.default.createElement(_flatButtonWithLoader2.default, {
        label: 'Check Your Progress',
        secondary: true,
        loader: processing,
        onTouchTap: function onTouchTap() {
          return checkContractReadiness(leftNav.contractId);
        },
        labelStyle: { fontWeight: '600' },
        hoverColor: 'none',
        style: { marginLeft: '0' }
      })
    )
  });
};

exports.default = ContractDraftSnackBar;

/***/ }),
/* 3375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewSnackbarForContractDetailsContainer = function (_Component) {
  _inherits(NewSnackbarForContractDetailsContainer, _Component);

  function NewSnackbarForContractDetailsContainer() {
    _classCallCheck(this, NewSnackbarForContractDetailsContainer);

    return _possibleConstructorReturn(this, (NewSnackbarForContractDetailsContainer.__proto__ || Object.getPrototypeOf(NewSnackbarForContractDetailsContainer)).apply(this, arguments));
  }

  _createClass(NewSnackbarForContractDetailsContainer, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !_ramda2.default.equals(this.props.shouldUpdate, nextProps.shouldUpdate);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          shouldUpdate = _props.shouldUpdate,
          props = _objectWithoutProperties(_props, ['shouldUpdate']);

      return _react2.default.createElement(_materialUi.Snackbar, props);
    }
  }]);

  return NewSnackbarForContractDetailsContainer;
}(_react.Component);

exports.default = NewSnackbarForContractDetailsContainer;

/***/ }),
/* 3376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateDraft = function CreateDraft(_ref) {
  var onRequestClose = _ref.onRequestClose,
      createTemplateDraft = _ref.createTemplateDraft,
      open = _ref.open,
      sentPartners = _ref.sentPartners,
      isDummyAccount = _ref.isDummyAccount;
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: open,
      title: isDummyAccount ? 'EDITING A RATE SHEET' : 'EDITING A TEMPLATE',
      onRequestClose: onRequestClose,
      actions: [_react2.default.createElement(_materialUi.FlatButton, { label: 'cancel', primary: true, onTouchTap: onRequestClose }), _react2.default.createElement(_materialUi.FlatButton, { label: 'confirm', secondary: true, onTouchTap: createTemplateDraft })]
    },
    isDummyAccount ? _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        null,
        'Please click CONFIRM if you\u2019d like to edit this rate sheet.'
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'i',
        null,
        'Note that we will create a new draft for you to work on your changes. Unless you accept the changes, your contract will include the changes.'
      )
    ) : _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        null,
        'Please click CONFIRM if you\u2019d like to edit this saved template.'
      ),
      _react2.default.createElement('br', null),
      _ramda2.default.isEmpty(sentPartners) ? _react2.default.createElement(
        'i',
        null,
        'Note that we\u2019ll create a new template draft for you to work on your changes.'
      ) : _react2.default.createElement(
        'i',
        null,
        'Note that we will create a new template draft for you to work on your changes. Unless you issue the changes, your partners will only see their original contract.'
      )
    )
  );
};

exports.default = CreateDraft;

/***/ }),
/* 3377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _buyer = __webpack_require__(3378);

var _buyer2 = _interopRequireDefault(_buyer);

var _seller = __webpack_require__(3381);

var _seller2 = _interopRequireDefault(_seller);

var _materialUi = __webpack_require__(3);

var _oldRouter = __webpack_require__(3384);

var _oldRouter2 = _interopRequireDefault(_oldRouter);

var _contractActivitiesProductsActions = __webpack_require__(493);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractDetails = function (_Component) {
  _inherits(ContractDetails, _Component);

  function ContractDetails() {
    _classCallCheck(this, ContractDetails);

    return _possibleConstructorReturn(this, (ContractDetails.__proto__ || Object.getPrototypeOf(ContractDetails)).apply(this, arguments));
  }

  _createClass(ContractDetails, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          contractId = _props.contractId,
          params = _props.params,
          rightSideLoaded = _props.rightSideLoaded;
      // if data has not been loaded, do load

      if (!(contractId === params.contractId && rightSideLoaded)) {
        this.props.getContractDetails('contract', params.contractId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.loading) {
        return _react2.default.createElement(
          'div',
          { style: { textAlign: 'center', paddingTop: '56px' } },
          _react2.default.createElement(_materialUi.CircularProgress, { size: 100, thickness: 7 })
        );
      }

      if (this.props.isRequest && this.props.isSender) {
        return _react2.default.createElement(_oldRouter2.default, null);
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_seller2.default, this.props),
        _react2.default.createElement(_buyer2.default, this.props)
      );
    }
  }]);

  return ContractDetails;
}(_react.Component);

ContractDetails.propTypes = {
  email: _react.PropTypes.string,
  buyerChecked: _react.PropTypes.bool,
  locationId: _react.PropTypes.string,
  getContractDetails: _react.PropTypes.func,
  params: _react.PropTypes.object,
  loading: _react.PropTypes.bool,
  isSender: _react.PropTypes.bool,
  isRequest: _react.PropTypes.bool,
  from: _react.PropTypes.object,
  contractId: _react.PropTypes.string,
  rightSideLoaded: _react.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var contracting = _ref.contracting,
      user = _ref.user;
  var params = _ref2.params;

  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  var rightSideContent = contracting.contractActivitiesProducts.get('rightSideContent').toJS();
  return _extends({
    loading: contracting.contractActivitiesProducts.get('contentLoading'),
    rightSideLoaded: rightSideContent[params.contractId + 'Loaded']
  }, rightSideContent, {
    state: leftNav.state,
    isSender: leftNav.isSender,
    isRequest: leftNav.isRequest,
    respondedContractList: leftNav.respondedContractList,
    supplierEditable: leftNav.supplierEditable,
    contractorEditable: leftNav.contractState === 'pending' && user.getIn(['user', 'type']) === 'Contractor'
  });
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  getContractDetails: _contractActivitiesProductsActions.getContractDetails
})(ContractDetails);

/***/ }),
/* 3378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _partnerNode = __webpack_require__(1055);

var _partnerNode2 = _interopRequireDefault(_partnerNode);

var _termsCriteriaNode = __webpack_require__(1264);

var _termsCriteriaNode2 = _interopRequireDefault(_termsCriteriaNode);

var _smallButtons = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Buyer = function Buyer(props) {
  var contractorEditable = props.contractorEditable,
      supplierEditable = props.supplierEditable,
      isPartner = props.isPartner,
      partners = props.partners,
      contacts = props.contacts,
      locationId = props.locationId,
      propsForTermsCriteria = props.propsForTermsCriteria,
      _props$from = props.from,
      from = _props$from === undefined ? {} : _props$from,
      _props$to = props.to,
      to = _props$to === undefined ? {} : _props$to;

  var buyerIsSender = Boolean(!locationId);
  return _react2.default.createElement(
    'div',
    { style: {
        overflow: 'auto',
        paddingRight: '4%',
        width: '50%',
        margin: '8px 0',
        float: 'right',
        fontSize: '14px'
      }
    },
    _react2.default.createElement(
      'div',
      {
        style: {
          marginLeft: '10%',
          width: '85%',
          padding: '24px',
          border: '1px solid #e0e0e0',
          borderRadius: '5px'
        }
      },
      _react2.default.createElement(
        'b',
        null,
        buyerIsSender ? 'Buyer' : 'Contract prepared for:'
      ),
      buyerIsSender ? _react2.default.createElement(
        'div',
        null,
        from.emailAlias || from.email
      ) : _react2.default.createElement(
        'div',
        null,
        to.name
      ),
      isPartner && _react2.default.createElement(
        'div',
        { style: { marginTop: '8px' } },
        _react2.default.createElement(_partnerNode2.default, {
          isReceiver: !buyerIsSender,
          partners: partners,
          contacts: contacts
        })
      )
    ),
    _react2.default.createElement(_termsCriteriaNode2.default, _extends({
      editable: !supplierEditable && contractorEditable
    }, propsForTermsCriteria))
  );
};

Buyer.propTypes = {
  contractorEditable: _react.PropTypes.bool,
  resendContract: _react.PropTypes.func,
  supplierEditable: _react.PropTypes.bool,
  isPartner: _react.PropTypes.bool,
  partner: _react.PropTypes.object,
  propsForTermsCriteria: _react.PropTypes.object
};

var mapState = function mapState(_ref) {
  var contractActivitiesProducts = _ref.contracting.contractActivitiesProducts;

  var rightSideContent = contractActivitiesProducts.get('rightSideContent').toJS();
  var leftNav = contractActivitiesProducts.get('leftNav').toJS();

  return {
    isPartner: leftNav.viewingAs === 'Supplier',
    partners: leftNav.partners,
    contacts: leftNav.contacts,
    locationId: leftNav.locationId,
    contractorEditable: leftNav.contractorEditable,
    supplierEditable: leftNav.supplierEditable,
    contractId: leftNav.contractId,
    from: leftNav.from,
    to: leftNav.to,
    toEmails: leftNav.toEmails,
    propsForTermsCriteria: _extends({}, rightSideContent.buyerInfo, {
      deadlineDate: rightSideContent.deadlineDate,
      contractState: leftNav.contractState
    })
  };
};

exports.default = (0, _reactRedux.connect)(mapState)(Buyer);

/***/ }),
/* 3379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAutorenew = function ActionAutorenew(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z' })
  );
};
ActionAutorenew = (0, _pure2.default)(ActionAutorenew);
ActionAutorenew.displayName = 'ActionAutorenew';
ActionAutorenew.muiName = 'SvgIcon';

exports.default = ActionAutorenew;

/***/ }),
/* 3380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(27);

var _actions = __webpack_require__(737);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverwriteBtnIndicator = function OverwriteBtnIndicator(props) {
  var templateDraftId = props.templateDraftId,
      sectionValue = props.sectionValue,
      masterTemplateApplied = props.masterTemplateApplied,
      updateSameAsCorporatePolicyNotes = props.updateSameAsCorporatePolicyNotes,
      editable = props.editable;

  return _react2.default.createElement(_materialUi.Checkbox, {
    checked: masterTemplateApplied,
    disabled: !editable,
    iconStyle: {
      width: '20px',
      height: '20px',
      top: '2px'
    },
    style: {
      width: '260px',
      display: 'flex',
      alignItems: 'center',
      right: '-24px'
    },
    labelStyle: { fontSize: '12px' },
    labelPosition: 'left',
    label: 'Same as Corporate Policies & Notes',
    onCheck: function onCheck() {
      updateSameAsCorporatePolicyNotes(templateDraftId, sectionValue, !masterTemplateApplied);
    }
  });
};

OverwriteBtnIndicator.propTypes = {
  push: _react.PropTypes.func,
  updateSameAsCorporatePolicyNotes: _react.PropTypes.func,
  masterTemplateApplied: _react.PropTypes.bool,
  templateDraftId: _react.PropTypes.string,
  sectionValue: _react.PropTypes.string,
  editable: _react.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(null, {
  push: _reactRouterRedux.push,
  updateSameAsCorporatePolicyNotes: _actions.updateSameAsCorporatePolicyNotes
})((0, _reactJss2.default)({})(OverwriteBtnIndicator));

/***/ }),
/* 3381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _partnerNode = __webpack_require__(1055);

var _partnerNode2 = _interopRequireDefault(_partnerNode);

var _billingInfoNode = __webpack_require__(1265);

var _billingInfoNode2 = _interopRequireDefault(_billingInfoNode);

var _policiesNode = __webpack_require__(1561);

var _policiesNode2 = _interopRequireDefault(_policiesNode);

var _checkinout = __webpack_require__(1267);

var _checkinout2 = _interopRequireDefault(_checkinout);

var _termsCriteriaNode = __webpack_require__(1264);

var _termsCriteriaNode2 = _interopRequireDefault(_termsCriteriaNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Seller = function Seller(_ref) {
  var supplierInfo = _ref.supplierInfo,
      locationPolicy = _ref.locationPolicy,
      billingInformation = _ref.billingInformation,
      supplierEditable = _ref.supplierEditable,
      openAddEditContractDialog = _ref.openAddEditContractDialog,
      contractState = _ref.contractState,
      locationId = _ref.locationId,
      propsForCheckInCheckOut = _ref.propsForCheckInCheckOut,
      isPartner = _ref.isPartner,
      _ref$partners = _ref.partners,
      partners = _ref$partners === undefined ? [] : _ref$partners,
      _ref$contacts = _ref.contacts,
      contacts = _ref$contacts === undefined ? [] : _ref$contacts,
      _ref$from = _ref.from,
      from = _ref$from === undefined ? {} : _ref$from,
      _ref$to = _ref.to,
      to = _ref$to === undefined ? {} : _ref$to;

  var supplierIsSender = Boolean(locationId);
  return _react2.default.createElement(
    'div',
    { style: { overflow: 'auto', padding: '0 2%', width: '50%', margin: '8px 0', float: 'left', fontSize: '14px' } },
    _react2.default.createElement(
      'div',
      {
        style: {
          marginLeft: '10%',
          width: '85%',
          padding: '24px',
          border: '1px solid #e0e0e0',
          borderRadius: '5px'
        }
      },
      _react2.default.createElement(
        'b',
        null,
        supplierIsSender ? 'Supplier' : 'Contract Request prepared for'
      ),
      supplierIsSender ? _react2.default.createElement(
        'div',
        null,
        from.email.indexOf('dl+') === -1 ? from.email : ''
      ) : _react2.default.createElement(
        'div',
        null,
        to.name
      ),
      isPartner && _react2.default.createElement(
        'div',
        { style: { marginTop: '8px' } },
        _react2.default.createElement(_partnerNode2.default, {
          isReceiver: !supplierIsSender,
          partners: partners,
          contacts: contacts
        })
      )
    ),
    _react2.default.createElement(_termsCriteriaNode2.default, _extends({}, supplierInfo, { contractState: contractState, editable: supplierEditable, openAddEditContractDialog: openAddEditContractDialog, forSupplier: true })),
    _react2.default.createElement(_policiesNode2.default, { locationPolicy: locationPolicy, contractState: contractState, supplierEditable: supplierEditable, openAddEditContractDialog: openAddEditContractDialog }),
    _react2.default.createElement(_checkinout2.default, propsForCheckInCheckOut),
    _react2.default.createElement(_billingInfoNode2.default, _extends({}, billingInformation, { contractState: contractState, supplierEditable: supplierEditable, openAddEditContractDialog: openAddEditContractDialog }))
  );
};

Seller.propTypes = {
  locationPolicy: _react.PropTypes.array,
  supplierEditable: _react.PropTypes.bool,
  openAddEditContractDialog: _react.PropTypes.func
};

var mapState = function mapState(_ref2, _ref3) {
  var contractActivitiesProducts = _ref2.contracting.contractActivitiesProducts;
  var openAddEditContractDialog = _ref3.openAddEditContractDialog;

  var rightSideContent = contractActivitiesProducts.get('rightSideContent').toJS();
  var leftNav = contractActivitiesProducts.get('leftNav').toJS();
  return {
    isPartner: leftNav.viewingAs === 'Buyer',
    partners: leftNav.partners,
    contacts: leftNav.contacts,
    contractorEditable: leftNav.contractorEditable,
    supplierEditable: leftNav.supplierEditable,
    contractState: leftNav.contractState,
    locationId: leftNav.locationId,
    contractId: leftNav.contractId,
    from: leftNav.from,
    to: leftNav.to,
    toEmails: leftNav.toEmails,
    propsForCheckInCheckOut: {
      openAddEditContractDialog: openAddEditContractDialog,
      supplierEditable: leftNav.supplierEditable,
      checkIn: rightSideContent.checkIn,
      checkOut: rightSideContent.checkOut,
      earlyCheckIn: rightSideContent.earlyCheckIn,
      earlyCheckInCostType: rightSideContent.earlyCheckInCostType,
      earlyCheckInPercentageType: rightSideContent.earlyCheckInPercentageType,
      earlyCheckInFee: rightSideContent.earlyCheckInFee,
      lateCheckOut: rightSideContent.lateCheckOut,
      lateCheckOutCostType: rightSideContent.lateCheckOutCostType,
      lateCheckOutFee: rightSideContent.lateCheckOutFee,
      lateCheckOutPercentageType: rightSideContent.lateCheckOutPercentageType
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapState)(Seller);

/***/ }),
/* 3382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportFields = function ImportFields(_ref) {
  var importedFields = _ref.importedFields,
      contractId = _ref.contractId;

  var linkToContractDetails = (0, _ramda.ifElse)(function () {
    return (0, _ramda.isNil)(contractId);
  }, function (edit, index) {
    return _react2.default.createElement(
      'div',
      { key: index, style: { color: 'rgba(0, 0, 0, 0.54)' } },
      edit
    );
  }, function (edit, index) {
    return _react2.default.createElement(
      'a',
      { target: '_blank', href: '/contracting/contract/' + contractId + '/details', key: index, style: { cursor: 'pointer', display: 'block' } },
      edit
    );
  });
  var linkToProductDetails = (0, _ramda.ifElse)(function () {
    return (0, _ramda.isNil)(contractId);
  }, function (productId, edit, index) {
    return _react2.default.createElement(
      'div',
      { key: index, style: { marginLeft: '12px', color: 'rgba(0, 0, 0, 0.54)' } },
      edit
    );
  }, function (productId, edit, index) {
    return _react2.default.createElement(
      'a',
      { target: '_blank', href: '/contracting/contract/' + contractId + '/product/' + productId + '/Primary', key: index, style: { cursor: 'pointer', display: 'block', marginLeft: '12px' } },
      edit
    );
  });
  var productsToImport = (0, _ramda.propOr)([], 'productsToImport', importedFields);
  var locationFieldsToImport = (0, _ramda.propOr)([], 'locationFieldsToImport', importedFields);
  return _react2.default.createElement(
    _materialUi.Card,
    { style: { boxShadow: 'none' } },
    _react2.default.createElement(_materialUi.CardHeader, {
      style: { height: '24px', padding: '0', marginBottom: '12px' },
      title: _react2.default.createElement(
        'div',
        { style: { lineHeight: '20px', marginBottom: '12px' } },
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '5px', color: 'rgba(0, 0, 0, 0.54)', fontSize: '13px' } },
          'Contract Updates - ',
          _react2.default.createElement(
            'span',
            { style: { color: '#00b3cf' } },
            'View all'
          )
        )
      ),
      actAsExpander: true
    }),
    _react2.default.createElement(
      _materialUi.CardText,
      { expandable: true, style: { padding: '0 0 0 36px', marginBottom: '12px', lineHeight: '20px' } },
      locationFieldsToImport.map(linkToContractDetails),
      productsToImport.map(function (_ref2, index) {
        var productId = _ref2.productId,
            productName = _ref2.productName,
            productFields = _ref2.productFields;
        return _react2.default.createElement(
          'div',
          { key: index, style: { display: (0, _ramda.gt)(productFields, []) ? 'block' : 'none' } },
          productName,
          productFields.map(linkToProductDetails(productId))
        );
      })
    )
  );
};

exports.default = ImportFields;

/***/ }),
/* 3383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _materialUi = __webpack_require__(3);

var _editSeasonButton = __webpack_require__(1563);

var _editSeasonButton2 = _interopRequireDefault(_editSeasonButton);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notNil = (0, _ramda.complement)(_ramda.isNil);
var SingleCancellation = function SingleCancellation(_ref) {
  var cancelNum = _ref.cancelNum,
      cancelHoursDays = _ref.cancelHoursDays,
      composedText = _ref.composedText,
      additionalRules = _ref.additionalRules,
      conditions = _ref.conditions,
      dateRanges = _ref.dateRanges,
      index = _ref.index,
      varyBySeason = _ref.varyBySeason,
      existingSeasons = _ref.existingSeasons,
      openAddEditContractDialog = _ref.openAddEditContractDialog,
      _ref$classes = _ref.classes,
      classes = _ref$classes === undefined ? {} : _ref$classes;
  return _react2.default.createElement(
    'div',
    { className: classes[index + '-prod-cancellation'] },
    _react2.default.createElement(
      'div',
      {
        style: {
          fontSize: '12px',
          marginBottom: '0',
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          borderLeft: '1px solid #bababa',
          borderBottom: '1px solid #bababa',
          borderRight: '1px solid #bababa',
          borderTop: !index ? '1px solid #bababa' : '',
          color: '#262626',
          padding: '4px 8px'
        }
      },
      _react2.default.createElement(
        'div',
        { style: { color: '#f44336' } },
        varyBySeason && existingSeasons && existingSeasons.length && !_dateUtils2.default.isDateRangesWithEmptyDates(dateRanges) && !_dateUtils2.default.getSeasonNameIfMatch(existingSeasons, dateRanges || []) ? "These dates don't match any seasons." : ''
      ),
      _dateUtils2.default.isDateRangesWithEmptyDates(dateRanges) && openAddEditContractDialog ? _react2.default.createElement(_editSeasonButton2.default, {
        openAddEditContractDialog: openAddEditContractDialog,
        existingSeasons: existingSeasons,
        seasonRatesIndex: index,
        seasonName: _ramda2.default.path([index, 'seasonName'], existingSeasons),
        dateRanges: dateRanges
      }) : dateRanges.map(function (range, rangeIndex) {
        return _react2.default.createElement(
          'div',
          { key: rangeIndex, className: classes[index + '-dateRanges-' + rangeIndex] },
          _dateUtils2.default.displayRange(range, {
            start: classes[index + '-dateRanges-' + rangeIndex + '-seasonStartDate'],
            end: classes[index + '-dateRanges-' + rangeIndex + '-seasonEndDate']
          })
        );
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { padding: '4px 8px', borderLeft: '1px solid #bababa', color: 'rgba(0,0,0,0.74)', borderBottom: '1px solid #bababa', borderRight: '1px solid #bababa' } },
      notNil(cancelNum) && notNil(cancelHoursDays) ? _react2.default.createElement(
        'div',
        { style: { color: 'rgba(0,0,0,0.74)', paddingLeft: '12px', whiteSpace: 'pre-wrap', wordWrap: 'break-word' } },
        'Cancel at least ',
        _react2.default.createElement(
          'b',
          null,
          _react2.default.createElement(
            'span',
            { className: classes[index + '-cancelNum'] },
            cancelNum
          ),
          ' ',
          _react2.default.createElement(
            'span',
            { className: classes[index + '-cancelHoursDays'] },
            cancelHoursDays
          )
        ),
        ' prior to the date of travel to avoid any cancellation fees.'
      ) : _react2.default.createElement('span', null),
      additionalRules && additionalRules.length ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'b',
          { style: { display: 'inline-block', margin: '8px 0' } },
          'Additional Cancellation Rules'
        ),
        additionalRules.map(function (rule, ruleIndex) {
          return _react2.default.createElement(
            'div',
            { key: ruleIndex },
            ruleIndex + 1,
            '. If cancelled within ',
            _react2.default.createElement(
              'b',
              null,
              rule.cancelNum
            ),
            ' ',
            _react2.default.createElement(
              'b',
              null,
              rule.cancelHoursDays
            ),
            ' of the date of ',
            _react2.default.createElement(
              'b',
              null,
              rule.arrivalDeparture
            ),
            ', a fee equivalent to ',
            _react2.default.createElement(
              'b',
              null,
              rule.cancelFee
            ),
            ' ',
            _react2.default.createElement(
              'b',
              null,
              rule.feeDollarPercent
            ),
            ' ',
            _react2.default.createElement(
              'b',
              null,
              rule.feeBase
            ),
            ' will be charged.'
          );
        })
      ) : _react2.default.createElement('div', null),
      _react2.default.createElement(
        'div',
        { style: { color: 'rgba(0,0,0,0.74)', paddingLeft: '12px', whiteSpace: 'pre-wrap', wordWrap: 'break-word' } },
        classes[index + '-conditions-textblock'] || (conditions === 'NA' ? '' : conditions)
      )
    )
  );
};

SingleCancellation.propTypes = {
  cancelNum: _react.PropTypes.number,
  cancelHoursDays: _react.PropTypes.string,
  conditions: _react.PropTypes.string,
  dateRanges: _react.PropTypes.array,
  index: _react.PropTypes.number
};

exports.default = SingleCancellation;

/***/ }),
/* 3384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _externalFiles = __webpack_require__(1996);

var _externalFiles2 = _interopRequireDefault(_externalFiles);

var _respondedContractList = __webpack_require__(1998);

var _respondedContractList2 = _interopRequireDefault(_respondedContractList);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _rateConversion = __webpack_require__(2006);

var _rateConversion2 = _interopRequireDefault(_rateConversion);

var _partnerNode = __webpack_require__(1055);

var _partnerNode2 = _interopRequireDefault(_partnerNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  contractId: _react.PropTypes.string,
  buyerInfo: _react.PropTypes.object,
  contractorEditable: _react.PropTypes.bool,
  openAddEditContractDialog: _react.PropTypes.func,
  isLatest: _react.PropTypes.bool,
  from: _react.PropTypes.object,
  to: _react.PropTypes.object,
  partners: _react.PropTypes.array,
  contacts: _react.PropTypes.array,
  deadlineDate: _react.PropTypes.string,
  rateConversionStatus: _react.PropTypes.string,
  rateConversionSetting: _react.PropTypes.string,
  respondedContracts: _react.PropTypes.array,
  files: _react.PropTypes.array
};

var CRBuyerView = function CRBuyerView(props) {
  var deadlineDate = props.deadlineDate,
      partners = props.partners,
      contacts = props.contacts,
      rateConversionStatus = props.rateConversionStatus,
      _props$respondedContr = props.respondedContracts,
      respondedContracts = _props$respondedContr === undefined ? [] : _props$respondedContr,
      _props$files = props.files,
      files = _props$files === undefined ? [] : _props$files;


  var converting = rateConversionStatus !== 'Awaiting Supplier Rates' && rateConversionStatus !== 'Conversion Complete' && rateConversionStatus !== 'Signed';
  return _react2.default.createElement(
    'div',
    { style: { padding: '2% 5%' } },
    _react2.default.createElement(
      _materialUi.Card,
      { style: { marginTop: '1em' } },
      _react2.default.createElement(_materialUi.CardHeader, {
        title: 'Files (' + files.length + ')',
        titleStyle: { fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' },
        actAsExpander: true,
        showExpandableButton: true
      }),
      _react2.default.createElement(
        _materialUi.CardText,
        { expandable: true, style: { padding: '1em 2em' } },
        _react2.default.createElement(_externalFiles2.default, null)
      )
    ),
    _react2.default.createElement(
      _materialUi.Card,
      {
        style: { marginTop: '1em' },
        initiallyExpanded: Boolean(respondedContracts.length)
      },
      _react2.default.createElement(_materialUi.CardHeader, {
        title: 'TourConnect Format Rate Contracts (' + respondedContracts.length + ')',
        titleStyle: { fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' },
        actAsExpander: true,
        showExpandableButton: true
      }),
      _react2.default.createElement(
        _materialUi.CardText,
        { expandable: true, style: { padding: '1em 2em' } },
        _react2.default.createElement(_respondedContractList2.default, null)
      )
    ),
    _react2.default.createElement(
      _materialUi.Card,
      {
        style: { marginTop: '1em' },
        initiallyExpanded: converting
      },
      _react2.default.createElement(_materialUi.CardHeader, {
        title: 'Rate Conversion',
        titleStyle: { fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' },
        actAsExpander: true,
        showExpandableButton: true
      }),
      _react2.default.createElement(
        _materialUi.CardText,
        { expandable: true, style: { padding: '1em 2em' } },
        _react2.default.createElement(_rateConversion2.default, null)
      )
    ),
    _react2.default.createElement(
      _materialUi.Card,
      { style: { marginTop: '1em' } },
      _react2.default.createElement(_materialUi.CardHeader, {
        title: 'Request Details (Deadline & Notes)',
        titleStyle: { fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' },
        actAsExpander: true,
        showExpandableButton: true
      }),
      _react2.default.createElement(
        _materialUi.CardText,
        { expandable: true, style: { padding: '1em 2em' } },
        _react2.default.createElement(
          _materialUi.Paper,
          {
            style: {
              width: '400px',
              marginLeft: '24px',
              padding: '24px',
              border: '1px solid #e0e0e0',
              borderRadius: '5px'
            }
          },
          _react2.default.createElement(_partnerNode2.default, {
            forWS: true,
            isReceiver: true,
            forSupplier: true,
            partners: partners,
            contacts: contacts
          })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { fontWeight: 'bolder' } },
            'Rate Submission Deadline'
          ),
          _react2.default.createElement(
            'div',
            { style: { margin: '1em 0 1em 0' } },
            deadlineDate ? _moment2.default.utc(new Date(deadlineDate)).format('MMMM DD, YYYY') : 'NA'
          )
        )
      )
    )
  );
};

CRBuyerView.propTypes = propTypes;

exports.default = (0, _reactRedux.connect)(function (_ref) {
  var contracting = _ref.contracting;

  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  var rightSideContent = contracting.contractActivitiesProducts.get('rightSideContent').toJS();
  return {
    contractId: leftNav.contractId,
    viewingAs: leftNav.viewingAs,
    partners: leftNav.partners,
    contacts: leftNav.contacts,
    from: leftNav.from,
    to: leftNav.to,
    rateConversionStatus: rightSideContent.rateConversionStatus,
    rateConversionSetting: rightSideContent.rateConversionSetting,
    isLatest: leftNav.isLatest,
    deadlineDate: rightSideContent.deadlineDate,
    buyerInfo: rightSideContent.buyerInfo,
    files: rightSideContent.files,
    respondedContracts: leftNav.respondedContracts
  };
})(CRBuyerView);

/***/ }),
/* 3385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _list = __webpack_require__(3386);

var _list2 = _interopRequireDefault(_list);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  list: _react.PropTypes.object,
  selectedContracts: _react.PropTypes.array,
  actionsForContract: _react.PropTypes.object,
  className: _react.PropTypes.string,
  showFolder: _react.PropTypes.bool,
  hoveringOverContractId: _react.PropTypes.string,
  selectCurrentAll: _react.PropTypes.func,
  unselectAll: _react.PropTypes.func,
  searchingAllYears: _react.PropTypes.bool,
  contractPeriods: _react.PropTypes.array,
  updateCurrentYear: _react.PropTypes.func,
  updateSearchParams: _react.PropTypes.func,
  currentYear: _react.PropTypes.object,
  sortValue: _react.PropTypes.string,
  sortRule: _react.PropTypes.number,
  assignee: _react.PropTypes.string,
  companyType: _react.PropTypes.string
};

var ContractList = function (_Component) {
  _inherits(ContractList, _Component);

  function ContractList() {
    _classCallCheck(this, ContractList);

    return _possibleConstructorReturn(this, (ContractList.__proto__ || Object.getPrototypeOf(ContractList)).apply(this, arguments));
  }

  _createClass(ContractList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func && key !== 'actionsForContract';
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_list2.default, this.props);
    }
  }]);

  return ContractList;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user;
  return {
    currentYear: contracting.currentYear,
    contractPeriods: contracting.contractPeriods,
    list: contracting.contractList.get('list').toJS(),
    searchingAllYears: contracting.contractList.getIn(['searchParams', 'searchingAllYears']),
    selectedContracts: contracting.contractList.get('selectedContracts').toJS(),
    sortValue: contracting.contractList.getIn(['searchParams', 'sortValue']),
    sortRule: contracting.contractList.getIn(['searchParams', 'sortRule']),
    assignee: contracting.contractList.getIn(['searchParams', 'assignee']),
    priority: contracting.contractList.getIn(['searchParams', 'priority']),
    sentContractsCount: user.get('sentContractsCount'),
    companyType: user.getIn(['company', 'companyType'])
  };
};
ContractList.propTypes = propTypes;
exports.default = (0, _reactRedux.connect)(mapStateToProps, { updateCurrentYear: function updateCurrentYear(dates) {
    return { type: '[contracting]SELECTED_YEAR_FOR_CONTRACTING', payload: dates };
  }, push: _reactRouterRedux.push })(ContractList);

/***/ }),
/* 3386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _contractRow = __webpack_require__(3387);

var _contractRow2 = _interopRequireDefault(_contractRow);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _expandMore = __webpack_require__(1774);

var _expandMore2 = _interopRequireDefault(_expandMore);

var _expandLess = __webpack_require__(1348);

var _expandLess2 = _interopRequireDefault(_expandLess);

var _unfoldMore = __webpack_require__(3392);

var _unfoldMore2 = _interopRequireDefault(_unfoldMore);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _rateConversionTableHeader = __webpack_require__(3393);

var _rateConversionTableHeader2 = _interopRequireDefault(_rateConversionTableHeader);

var _zeroState = __webpack_require__(2002);

var _zeroState2 = _interopRequireDefault(_zeroState);

var _assigneeFilter = __webpack_require__(2001);

var _assigneeFilter2 = _interopRequireDefault(_assigneeFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getSortIcon = function getSortIcon(sort, rule) {
  if (!sort) return _react2.default.createElement(_unfoldMore2.default, { style: { fill: 'rgba(0, 0, 0, 0.54)', width: '14px' } });
  if (rule === -1) return _react2.default.createElement(_expandMore2.default, { style: { fill: 'rgba(0, 0, 0, 0.54)', width: '14px' } });
  return _react2.default.createElement(_expandLess2.default, { style: { fill: 'rgba(0, 0, 0, 0.54)', width: '14px' } });
};

var ContractList = function (_Component) {
  _inherits(ContractList, _Component);

  function ContractList() {
    _classCallCheck(this, ContractList);

    var _this = _possibleConstructorReturn(this, (ContractList.__proto__ || Object.getPrototypeOf(ContractList)).call(this));

    _this.openContacts = function (contract) {
      return function (e) {
        return _this.setState({
          contactsOpen: {
            from: contract.from || {},
            to: contract.to || {},
            toEmails: contract.toEmails || [],
            anchorEl: e.currentTarget
          }
        });
      };
    };

    _this.closeContacts = function () {
      return _this.setState({ contactsOpen: null });
    };

    _this.state = {
      contactsOpen: null
    };
    return _this;
  }

  _createClass(ContractList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var contactsOpen = this.state.contactsOpen;
      var _props = this.props,
          list = _props.list,
          selectedContracts = _props.selectedContracts,
          actionsForContract = _props.actionsForContract,
          className = _props.className,
          showFolder = _props.showFolder,
          hideStatusIcon = _props.hideStatusIcon,
          forLandingPage = _props.forLandingPage,
          hoveringOverContractId = _props.hoveringOverContractId,
          selectCurrentAll = _props.selectCurrentAll,
          unselectAll = _props.unselectAll,
          updateSearchParams = _props.updateSearchParams,
          sortValue = _props.sortValue,
          sortRule = _props.sortRule,
          sentContractsCount = _props.sentContractsCount,
          push = _props.push,
          companyType = _props.companyType,
          assignee = _props.assignee,
          priority = _props.priority;

      var hasContent = Boolean(list.dataToShow && list.dataToShow.length);
      return _react2.default.createElement(
        'div',
        { className: className, 'data-cy': 'list-content' },
        list.loading && hasContent && _react2.default.createElement(_materialUi.LinearProgress, { mode: 'indeterminate' }),
        _react2.default.createElement(
          _materialUi.Table,
          { bodyStyle: { overflow: 'visible' } },
          _react2.default.createElement(
            _materialUi.TableHeader,
            { displaySelectAll: false, adjustForCheckbox: false },
            window.location.href.indexOf('/contract-list/rate-conversion') > -1 ? _react2.default.createElement(_rateConversionTableHeader2.default, {
              sort: function sort(value) {
                return updateSearchParams({
                  sortValue: value,
                  sortRule: sortValue === value && sortRule === -1 ? 1 : -1
                });
              },
              getSortIcon: getSortIcon,
              sortRule: sortRule,
              sortValue: sortValue,
              filterByAssignee: function filterByAssignee(value) {
                return updateSearchParams({
                  assignee: value
                });
              },
              assigneeFilter: assignee,
              priorityFilter: priority,
              filterByPriority: function filterByPriority(value) {
                return updateSearchParams({
                  priority: value
                });
              }
            }) : _react2.default.createElement(
              _materialUi.TableRow,
              null,
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { colSpan: '1' },
                _react2.default.createElement(_materialUi.Checkbox, {
                  checked: Boolean(selectedContracts.length >= list.dataToShow.length && list.dataToShow.length),
                  onCheck: function onCheck(_, inputChecked) {
                    return inputChecked ? selectCurrentAll() : unselectAll();
                  }
                })
              ),
              _react2.default.createElement(_materialUi.TableHeaderColumn, { colSpan: '1' }),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { colSpan: '6', style: { padding: 0 } },
                'Contract'
              ),
              _react2.default.createElement(_materialUi.TableHeaderColumn, { colSpan: '1', style: { padding: 0, textAlign: 'center' } }),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                {
                  'data-walkthru': 'contractListStatus',
                  colSpan: '1',
                  style: { padding: 0, paddingLeft: '8px' }
                },
                'Status'
              ),
              companyType === 'Contractor' && _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { colSpan: '1', style: { padding: 0, overflow: 'hidden' } },
                _react2.default.createElement(_assigneeFilter2.default, {
                  filter: assignee,
                  filterByAssignee: function filterByAssignee(value) {
                    return updateSearchParams({
                      assignee: value
                    });
                  },
                  isContainer: true
                })
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                {
                  colSpan: '2',
                  style: {
                    padding: '0 0 0 2px',
                    textAlign: 'center'
                  }
                },
                window.location.pathname.indexOf('contract-list') === -1 ? 'Contacts & Notes' : 'Contacts Notes Activity'
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { colSpan: '1', style: { padding: 0, textAlign: 'center' } },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'flex-tc-sb',
                    style: { justifyContent: 'center', cursor: 'pointer' },
                    onClick: function onClick() {
                      return updateSearchParams({
                        sortValue: 'endDate',
                        sortRule: sortValue === 'endDate' && sortRule === -1 ? 1 : -1
                      });
                    }
                  },
                  'Periods ',
                  getSortIcon(_ramda2.default.equals('endDate', sortValue), sortRule)
                )
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { colSpan: '1', style: { padding: 0, textAlign: 'center' } },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'flex-tc-sb',
                    style: { justifyContent: 'center', cursor: 'pointer' },
                    onClick: function onClick() {
                      return updateSearchParams({
                        sortValue: 'updatedAt',
                        sortRule: sortValue === 'updatedAt' && sortRule === -1 ? 1 : -1
                      });
                    }
                  },
                  'Modified ',
                  getSortIcon(_ramda2.default.equals('updatedAt', sortValue), sortRule)
                )
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { colSpan: '1', style: { padding: 0, textAlign: 'center' } },
                'Actions'
              )
            )
          ),
          _react2.default.createElement(
            _materialUi.TableBody,
            { style: { overflow: 'visible' } },
            list.dataToShow.map(function (contract, i) {
              return _react2.default.createElement(_contractRow2.default, {
                key: i,
                showContractYear: true,
                hideStatusIcon: hideStatusIcon,
                forLandingPage: forLandingPage,
                contract: contract,
                actions: actionsForContract,
                showFolder: showFolder,
                hoveringOverContractId: hoveringOverContractId,
                openContacts: _this2.openContacts(contract)
              });
            })
          )
        ),
        !Boolean(sentContractsCount) && _react2.default.createElement(_zeroState2.default, {
          title: 'Welcome to the Contract List!',
          buttonTitle: companyType === 'Supplier' ? 'Start by creating a rate template' : 'Start by requesting rates',
          videoLink: 'https://vimeo.com/432916768',
          buttonList: companyType === 'Supplier' ? [{
            label: 'Create a Rate Template',
            func: function func() {
              return push('/contracting/create-template-draft');
            }
          }, {
            label: 'Send a Contract',
            func: function func() {
              window.location = "https://app.tourconnect.com" + '/partner-management/send-assets?jwt=' + localStorage.getItem('jwt') + '&open_asset_type=rates';
            }
          }] : [{
            label: 'SEND A CONTRACT REQUEST',
            func: function func() {
              window.location = "https://app.tourconnect.com" + '/partner-management/send-assets?jwt=' + localStorage.getItem('jwt') + '&open_asset_type=requests';
            }
          }],
          enjoyBenefits: companyType === 'Supplier' ? ['Track the status of each contract', 'View the rates & history for each partner', 'Send updates quickly', 'View real time statistics in your dashboard'] : ['Track the status of each contract', 'Manage the workflow for each contract', 'View the rates & history for each partner', 'Compare two versions of a contract', 'View real time statistics in your dashboard']
        }),
        _react2.default.createElement(
          'div',
          {
            style: {
              display: list.loading || hasContent || !sentContractsCount ? 'none' : 'block',
              minHeight: '400px',
              fontSize: '24px',
              textAlign: 'center',
              marginTop: '50px',
              marginBottom: '50px'
            }
          },
          'There are no files in this category.'
        ),
        _react2.default.createElement(_loadingOverlay2.default, { loading: list.loading && !hasContent, text: list.loadingText }),
        _react2.default.createElement(
          _materialUi.Popover,
          {
            open: Boolean(contactsOpen),
            onRequestClose: this.closeContacts,
            anchorEl: contactsOpen && contactsOpen.anchorEl,
            anchorOrigin: { horizontal: 'middle', vertical: 'bottom' },
            targetOrigin: { horizontal: 'middle', vertical: 'top' },
            style: {
              width: '350px',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              color: 'white',
              padding: '8px',
              fontSize: '12px'
            }
          },
          Boolean(contactsOpen) && _react2.default.createElement(
            'div',
            null,
            'This ',
            contactsOpen.templateId ? 'contract' : 'contract request',
            ' was prepared for',
            ' ',
            _react2.default.createElement(
              'b',
              null,
              contactsOpen.to.name
            ),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '12px' } },
              'From: ',
              contactsOpen.from.name,
              _react2.default.createElement(
                'div',
                { style: { marginLeft: '20px' } },
                '(',
                contactsOpen.from.emailAlias || contactsOpen.from.email,
                ')'
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '12px' } },
              'To: ',
              contactsOpen.to.name,
              _react2.default.createElement(
                'div',
                { style: { marginLeft: '20px' } },
                contactsOpen.toEmails.map(function (str) {
                  return _react2.default.createElement(
                    'div',
                    { key: str },
                    str
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);

  return ContractList;
}(_react.Component);

exports.default = ContractList;

/***/ }),
/* 3387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _rowDumb = __webpack_require__(3388);

var _rowDumb2 = _interopRequireDefault(_rowDumb);

var _rateConversionRowDumb = __webpack_require__(3391);

var _rateConversionRowDumb2 = _interopRequireDefault(_rateConversionRowDumb);

var _accessCheckHelperFns = __webpack_require__(631);

var _upgradeActions = __webpack_require__(611);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  selectedContracts: _react.PropTypes.array,
  hoveringOverContractId: _react.PropTypes.string,
  actions: _react.PropTypes.object,
  showFolder: _react.PropTypes.bool,
  contract: _react.PropTypes.object,
  drafts: _react.PropTypes.array,
  templates: _react.PropTypes.array,
  isSingleLoc: _react.PropTypes.bool
};

var ContractRow = function (_Component) {
  _inherits(ContractRow, _Component);

  function ContractRow() {
    _classCallCheck(this, ContractRow);

    return _possibleConstructorReturn(this, (ContractRow.__proto__ || Object.getPrototypeOf(ContractRow)).apply(this, arguments));
  }

  _createClass(ContractRow, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react2.default.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var contract = this.props.contract;

      if (window.location.href.indexOf('/contract-list/rate-conversion') > -1 || !contract.isLatest && ['opt-in', 'opt-out'].indexOf(contract.rateConversionSetting) > -1) {
        return _react2.default.createElement(_rateConversionRowDumb2.default, _extends({}, this.props, {
          inSearchResult: window.location.href.indexOf('/contract-list/search') > -1
        }));
      }
      return _react2.default.createElement(_rowDumb2.default, this.props);
    }
  }]);

  return ContractRow;
}(_react.Component);

ContractRow.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user,
      config = _ref.config;
  return {
    apiUrl: config.get('apiUrl'),
    drafts: contracting.templateList.get('drafts').toJS(),
    templates: contracting.templateList.get('templates').toJS(),
    hoveringOverContractId: contracting.contractList.get('hoveringOverContractId'),
    isShellAccount: user.get('contractingShell') || user.get('unApprovedShellAccount') || false,
    selectedContracts: contracting.contractList.get('selectedContracts').toJS(),
    userId: user.get('id'),
    billingPlan: user.get('billingPlan'),
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop'
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    triggerNoAccessWarning: function triggerNoAccessWarning() {
      return dispatch(_accessCheckHelperFns.triggerNoAccessWarning.apply(undefined, arguments));
    },
    openUpgradeFrom: function openUpgradeFrom() {
      return dispatch((0, _upgradeActions.openUpgradeFrom)('contractListSentStatus'));
    }
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContractRow);

/***/ }),
/* 3388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _smallButtons = __webpack_require__(94);

var _arrowDropDown = __webpack_require__(559);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _flatDropDownMenu = __webpack_require__(494);

var _flatDropDownMenu2 = _interopRequireDefault(_flatDropDownMenu);

var _redDot = __webpack_require__(1056);

var _redDot2 = _interopRequireDefault(_redDot);

var _contractingUtils = __webpack_require__(124);

var _actionButtons = __webpack_require__(3389);

var _actionButtons2 = _interopRequireDefault(_actionButtons);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _description = __webpack_require__(561);

var _description2 = _interopRequireDefault(_description);

var _lockOutline = __webpack_require__(1867);

var _lockOutline2 = _interopRequireDefault(_lockOutline);

var _borderColor = __webpack_require__(2000);

var _borderColor2 = _interopRequireDefault(_borderColor);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _updateAssignee = __webpack_require__(1258);

var _updateAssignee2 = _interopRequireDefault(_updateAssignee);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ContractRowDumb = function ContractRowDumb(_ref) {
  var contract = _ref.contract,
      selectedContracts = _ref.selectedContracts,
      actions = _ref.actions,
      showFolder = _ref.showFolder,
      showContractYear = _ref.showContractYear,
      hideStatusIcon = _ref.hideStatusIcon,
      forLandingPage = _ref.forLandingPage,
      templates = _ref.templates,
      billingPlan = _ref.billingPlan,
      openContacts = _ref.openContacts,
      extraProps = _objectWithoutProperties(_ref, ['contract', 'selectedContracts', 'actions', 'showFolder', 'showContractYear', 'hideStatusIcon', 'forLandingPage', 'templates', 'billingPlan', 'openContacts']);

  var noReadAccess = !_ramda2.default.contains('read', contract.access || []);
  var viewingBy = contract.viewingBy,
      locationId = contract.locationId,
      respondedContracts = contract.respondedContracts,
      emailStatus = contract.emailStatus,
      viewerIsSender = contract.viewerIsSender,
      partners = contract.partners,
      files = contract.files,
      _contract$to = contract.to,
      to = _contract$to === undefined ? {} : _contract$to,
      convertedFromExternal = contract.convertedFromExternal;

  var tcContractsInRequest = Boolean(!locationId && respondedContracts && respondedContracts.length);
  var shownState = (0, _contractingUtils.getShownState)(_extends({ companyType: viewingBy }, contract));
  var sentState = (0, _contractingUtils.getSentState)(contract.isViewed, contract.emailStatus);
  var hasVersion = !_ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty)(contract.versions);
  var goIntoContractOrWizard = noReadAccess ? function () {} : function () {
    if (contract.viewingBy === 'Supplier' && !contract.locationId && !contract.buyerChecked) actions.goToSupplierWizard(contract._id);else actions.viewContract('contract', contract._id);
  };
  var hasEditingDraftForSupplierAcct = contract.hasDraft && contract.locationId && contract.viewingBy === 'Supplier';
  var hasEditingDraftForBuyerAcct = contract.viewingBy !== 'Supplier' && contract.buyerHasDraftId;
  var readOnly = !_ramda2.default.contains('write', contract.access || []) && !noReadAccess;
  // const iconToDisplay = (() => {
  //   if (Boolean(contract.locationName)) return 'tc-icon-location_on';
  // })();
  var fileExists = files && files.length;
  var externalRates = !locationId && (contract.buyerChecked || Boolean(fileExists));
  var unread = !viewerIsSender && !contract.isViewed;
  var otherSideRead = contract.viewedBy && contract.viewedBy.length;
  var showEmailAndContractStatus = function () {
    // hide for received rates if it is a Buyer
    if (viewingBy !== 'Supplier' && locationId) return false;
    // hide for rate requests if it is a Supplier
    if (viewingBy === 'Supplier' && !locationId) return false;
    // rates received externally
    if (viewingBy !== 'Supplier' && externalRates) return false;
    return true;
  }();
  var stateChange = function stateChange(newStatus) {
    if (readOnly) extraProps.triggerNoAccessWarning();else actions.stateChange(contract._id, newStatus);
  };
  var requestText = function () {
    if (tcContractsInRequest && viewingBy === 'Contractor') {
      return _react2.default.createElement(
        'span',
        { style: { color: 'green' } },
        respondedContracts.length,
        ' ',
        (0, _pluralize2.default)('contracts', respondedContracts.length)
      );
    }
    // if (fileExists && viewingBy === 'Contractor') {
    //   return <span style={{ color: 'green' }}>Received {files.length} {pluralize('files', files.length)}</span>;
    // }
    if (!locationId && viewingBy === 'Supplier' && shownState !== 'sent') {
      return _react2.default.createElement(
        'span',
        null,
        'Prepared for ',
        to.name
      );
    }
    return '';
  }();

  var _ref2 = function () {
    // display based on owners' partner list
    var partner = partners[0] || {};
    return {
      displayName: partner.name || contract.from.name,
      logoToDisplay: partner.avatar || contract.from.avatar
    };
  }(),
      displayName = _ref2.displayName,
      logoToDisplay = _ref2.logoToDisplay;

  var propsForActions = {
    disabled: noReadAccess,
    contract: contract,
    templates: templates,
    triggerNoAccessWarning: extraProps.triggerNoAccessWarning,
    actions: _ramda2.default.merge(actions, {
      downloadContractPdf: function downloadContractPdf(anchorEl) {
        return actions.downloadContractPdf({
          docId: tcContractsInRequest ? null : contract._id,
          files: files,
          contractIds: tcContractsInRequest ? respondedContracts : null,
          zipFileName: displayName,
          zipNameWhenFileExists: displayName,
          anchorEl: anchorEl
        });
      }
    }),
    openManageFolderDialog: function openManageFolderDialog(folderAction) {
      return function () {
        return actions.updateProps({
          manageFolderDialogOpen: true,
          contractFolders: contract.folders,
          folderAction: folderAction
        });
      };
    },
    openMenu: function openMenu() {
      return actions.updateProps({ hoveringOverContractId: contract._id });
    },
    goIntoContractOrWizard: goIntoContractOrWizard
  };
  var displayLoc = Boolean(locationId && displayName !== contract.locationName);
  return _react2.default.createElement(
    _materialUi.TableRow,
    {
      selectable: false,
      'data-cy': contract._id + 'contractRow',
      style: { height: '56px', overflow: 'visible', backgroundColor: convertedFromExternal ? '#edfafc' : '#fff' }
    },
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '1'
      },
      noReadAccess ? _react2.default.createElement(_lockOutline2.default, { color: 'rgba(0, 0, 0, 0.44)' }) : _react2.default.createElement(_materialUi.Checkbox, {
        onCheck: function onCheck() {
          return actions.selectAContract(contract._id);
        },
        defaultChecked: _ramda2.default.contains(contract._id, selectedContracts)
      })
    ),
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      { colSpan: '1', style: { padding: 0, overflow: 'visible' } },
      _ramda2.default.call(_ramda2.default.cond([[function () {
        return logoToDisplay;
      }, _ramda2.default.always(_react2.default.createElement(_materialUi.Avatar, { src: logoToDisplay, style: { marginTop: '4px' } }))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(
        _materialUi.Avatar,
        null,
        _ramda2.default.head(displayName || '')
      ))]]))
    ),
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '6',
        style: { padding: 0, color: noReadAccess ? 'rgba(0, 0, 0, 0.44)' : '', overflow: 'visible' }
      },
      _react2.default.createElement(
        'div',
        {
          style: { height: '48px', display: 'table-cell', verticalAlign: 'middle', cursor: noReadAccess ? '' : 'pointer' },
          onClick: goIntoContractOrWizard
        },
        _react2.default.createElement(
          'div',
          { style: { fontWeight: unread ? 'bold' : '', lineHeight: '12px', fontSize: '12px' }, className: 'flex-center' },
          displayName,
          '\xA0',
          _react2.default.createElement(
            'small',
            null,
            _react2.default.createElement(
              'i',
              null,
              hasVersion ? '(v.' + (_ramda2.default.path(['versions', 'length'], contract) + 1) + ')' : ''
            )
          ),
          _react2.default.createElement(
            'small',
            {
              style: { color: 'rgba(0, 0, 0, 0.44)' },
              'data-cy': 'folder-' + contract.folders.join(', ')
            },
            showFolder && !_ramda2.default.isEmpty(contract.folders) ? ' (' + contract.folders.join(', ') + ')' : ''
          ),
          _react2.default.createElement(
            'small',
            { style: { color: 'red' } },
            showFolder && contract.isDeleted ? 'Trash' : ''
          ),
          _react2.default.createElement(
            'small',
            { style: { color: 'red' } },
            showFolder && contract.isArchived ? 'Archived' : ''
          ),
          Boolean(contract.signatures && contract.signatures.length) && _react2.default.createElement(
            'span',
            { className: 'hint--top', 'aria-label': 'Signed' },
            '\xA0\xA0',
            _react2.default.createElement(_borderColor2.default, { style: { height: '18px', width: '18px', color: '#2e7d32' } })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { fontWeight: unread ? 'bold' : '', display: 'flex', alignItems: 'center', lineHeight: '16px', fontSize: '12px' } },
          displayLoc && _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-location_on', style: { fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)', marginRight: '8px' } }),
          displayLoc && contract.locationName,
          _ramda2.default.path(['supplierInfo', 'marketInfo'], contract) ? _react2.default.createElement(
            'small',
            null,
            '\xA0',
            '(' + _ramda2.default.path(['supplierInfo', 'marketInfo'], contract) + ')'
          ) : _react2.default.createElement('span', null),
          requestText,
          _react2.default.createElement(
            'span',
            { style: { color: 'rgba(0, 0, 0, 0.44)' } },
            ' ',
            readOnly && '(READ-ONLY)'
          )
        ),
        hasEditingDraftForSupplierAcct ? _react2.default.createElement(
          'div',
          {
            style: { lineHeight: '10px', color: 'red', fontSize: '10px' }
          },
          'This contract has a\xA0',
          _react2.default.createElement(
            'a',
            { href: '/contracting/draft/' + contract._id + '/details', onClick: function onClick(e) {
                return e.stopPropagation();
              } },
            'draft'
          ),
          '.'
        ) : _react2.default.createElement('span', null),
        hasEditingDraftForBuyerAcct ? _react2.default.createElement(
          'div',
          {
            style: { lineHeight: '10px', color: 'red', fontSize: '10px' }
          },
          'This contract has a draft.'
        ) : _react2.default.createElement('span', null)
      )
    ),
    !hideStatusIcon && _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '1',
        style: { padding: 0, textAlign: 'center', overflow: 'visible' }
      },
      _react2.default.createElement(
        'div',
        null,
        _ramda2.default.call(_ramda2.default.cond([[function () {
          return shownState === 'sent' && billingPlan === 'basic';
        }, _ramda2.default.always((0, _contractingUtils.getIconEle)({ status: 'unpaid', showEmailAndContractStatus: showEmailAndContractStatus, otherSideRead: otherSideRead, sentState: sentState, companyType: viewingBy, emailStatus: emailStatus }))], [function () {
          return shownState === 'sent';
        }, _ramda2.default.always((0, _contractingUtils.getIconEle)({ showEmailAndContractStatus: showEmailAndContractStatus, status: shownState, sentState: sentState, companyType: viewingBy, overwriteColor: null, externalRates: contract.buyerChecked && externalRates, otherSideRead: otherSideRead, emailStatus: emailStatus }))], [function () {
          return viewingBy === 'Contractor' && (locationId || fileExists || tcContractsInRequest);
        }, _ramda2.default.always((0, _contractingUtils.getIconEle)({
          showEmailAndContractStatus: showEmailAndContractStatus,
          status: locationId || tcContractsInRequest ? 'rates received' : 'rates received externally',
          otherSideRead: otherSideRead,
          emailStatus: emailStatus,
          convertedFromExternal: convertedFromExternal
        }))], [function () {
          return viewingBy === 'Contractor' && contract.buyerChecked;
        }, _ramda2.default.always(_react2.default.createElement(
          'span',
          { style: { width: '35px', display: 'inline-block' } },
          _react2.default.createElement(_description2.default, { color: 'rgba(0, 0, 0, 0.1)' }),
          _react2.default.createElement(
            'span',
            { style: { visibility: 'hidden' } },
            '?'
          )
        ))], [function () {
          return viewingBy === 'Supplier' && shownState !== 'sent';
        }, _ramda2.default.always((0, _contractingUtils.getIconEle)({ showEmailAndContractStatus: showEmailAndContractStatus, status: shownState, otherSideRead: otherSideRead, emailStatus: emailStatus }))]]))
      )
    ),
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '1',
        style: { padding: 0 }
      },
      viewingBy === 'Contractor' ? _react2.default.createElement(
        _flatDropDownMenu2.default,
        {
          button: _react2.default.createElement(_smallButtons.SmallFlatButton, {
            labelStyle: { padding: 0 },
            icon: _react2.default.createElement(_arrowDropDown2.default, { style: { fill: 'rgba(0, 0, 0, 0.54)', margin: 0 } }),
            labelPosition: 'before',
            label: _react2.default.createElement(
              'span',
              { style: { color: (0, _contractingUtils.getStatusColor)(shownState), width: '54px', display: 'inline-block' } },
              shownState
            )
          })
        },
        _react2.default.createElement(_materialUi.MenuItem, {
          primaryText: 'Mark as Sent',
          style: { color: (0, _contractingUtils.getStatusColor)('sent') },
          disabled: Boolean(shownState === 'sent' || locationId),
          onTouchTap: function onTouchTap() {
            return stateChange('sent');
          }
        }),
        _react2.default.createElement(_materialUi.MenuItem, {
          primaryText: 'Mark as Received',
          style: { color: (0, _contractingUtils.getStatusColor)('received') },
          disabled: shownState === 'received',
          onTouchTap: function onTouchTap() {
            return stateChange('received');
          }
        }),
        _react2.default.createElement(_materialUi.MenuItem, {
          primaryText: 'Mark as Accepted',
          style: { color: (0, _contractingUtils.getStatusColor)('accepted') },
          disabled: shownState === 'accepted',
          onTouchTap: function onTouchTap() {
            return stateChange('accepted');
          }
        }),
        _react2.default.createElement(_materialUi.MenuItem, {
          primaryText: 'Mark as Loading',
          style: { color: (0, _contractingUtils.getStatusColor)('loading') },
          disabled: shownState === 'loading',
          onTouchTap: function onTouchTap() {
            return stateChange('loading');
          }
        }),
        _react2.default.createElement(_materialUi.MenuItem, {
          primaryText: 'Mark as Loaded',
          style: { color: (0, _contractingUtils.getStatusColor)('loaded') },
          disabled: shownState === 'loaded',
          onTouchTap: function onTouchTap() {
            return stateChange('loaded');
          }
        }),
        _react2.default.createElement(_materialUi.MenuItem, {
          primaryText: 'Mark as Rejected',
          style: { color: (0, _contractingUtils.getStatusColor)('rejected') },
          disabled: shownState === 'rejected',
          onTouchTap: function onTouchTap() {
            return stateChange('rejected');
          }
        })
      ) : _react2.default.createElement(
        'span',
        { style: { color: (0, _contractingUtils.getStatusColor)(shownState) } },
        shownState
      )
    ),
    viewingBy === 'Contractor' && _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '1',
        style: { padding: 0, fontSize: '10px' }
      },
      _react2.default.createElement(_updateAssignee2.default, {
        assignee: contract.assignee,
        contractId: contract._id,
        isContainer: !Boolean(contract.locationId),
        files: contract.files
      })
    ),
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '2',
        style: {
          padding: 0, textAlign: 'center'
        }
      },
      _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
          _materialUi.IconButton,
          {
            onClick: openContacts,
            style: { padding: '12px 4px' },
            iconStyle: { color: 'rgba(0, 0, 0, 0.54)' }
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-mail_outline', style: { fontSize: '20px', top: '4px' } })
        ),
        _react2.default.createElement(
          _materialUi.IconButton,
          {
            onClick: function onClick() {
              return actions.viewNotes('contract', contract._id);
            },
            style: { padding: '12px 4px' },
            iconStyle: { color: 'rgba(0, 0, 0, 0.54)' }
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-note_add', style: { color: 'rgba(0, 0, 0, 0.54)' } }),
          contract.notesCount && _react2.default.createElement(_redDot2.default, { style: { top: '-10px', left: '5px' }, color: '#00bcd4' })
        ),
        _react2.default.createElement(
          _materialUi.IconButton,
          {
            onClick: function onClick() {
              return actions.viewActivities('contract', contract._id);
            },
            style: { padding: '12px 4px' },
            iconStyle: { color: 'rgba(0, 0, 0, 0.54)' }
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-question_answer', style: { color: 'rgba(0, 0, 0, 0.54)' } }),
          contract.hasNewComments && _react2.default.createElement(_redDot2.default, { style: { top: '-10px', left: '6px' } })
        )
      )
    ),
    showContractYear && _react2.default.createElement(
      _materialUi.TableRowColumn,
      { colSpan: '1', style: { padding: 0, textAlign: 'center', whiteSpace: 'pre-wrap', fontSize: '10px' } },
      _moment2.default.utc(contract.startDate).format('D MMM YY') + ' -\n' + _moment2.default.utc(contract.endDate).format('D MMM YY') + '  '
    ),
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      { colSpan: '1', style: { padding: 0, fontSize: '10px', textAlign: 'center' } },
      (0, _moment2.default)(contract.updatedAt).calendar(null, {
        sameDay: 'h:mm a',
        lastDay: 'D MMM YY',
        lastWeek: 'D MMM YY',
        sameElse: 'D MMM YY'
      })
    ),
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '1',
        style: { padding: 0, textAlign: 'center', overflow: 'visible' }
      },
      forLandingPage ? _react2.default.createElement(_smallButtons.SmallRaisedButton, {
        labelStyle: { padding: '4px', top: 0 },
        label: 'Download',
        secondary: true
      }) : _react2.default.createElement(_actionButtons2.default, propsForActions)
    )
  );
};

exports.default = ContractRowDumb;

/***/ }),
/* 3389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

var _aphrodite = __webpack_require__(123);

var _materialUi = __webpack_require__(3);

var _archive = __webpack_require__(1142);

var _archive2 = _interopRequireDefault(_archive);

var _contractingUtils = __webpack_require__(124);

var _smallButtons = __webpack_require__(94);

var _downloadUploadButton = __webpack_require__(3390);

var _downloadUploadButton2 = _interopRequireDefault(_downloadUploadButton);

var _contractMailbox = __webpack_require__(1970);

var _contractMailbox2 = _interopRequireDefault(_contractMailbox);

var _exportTourWriter = __webpack_require__(1546);

var _exportTourWriter2 = _interopRequireDefault(_exportTourWriter);

var _markunreadMailbox = __webpack_require__(1971);

var _markunreadMailbox2 = _interopRequireDefault(_markunreadMailbox);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = _aphrodite.StyleSheet.create({
  container: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }
});

var ActionButtons = function (_Component) {
  _inherits(ActionButtons, _Component);

  function ActionButtons(props) {
    _classCallCheck(this, ActionButtons);

    var _this = _possibleConstructorReturn(this, (ActionButtons.__proto__ || Object.getPrototypeOf(ActionButtons)).call(this, props));

    _this.state = {
      showCopied: false
    };
    return _this;
  }

  _createClass(ActionButtons, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(ActionButtons.propTypes).filter(function (key) {
        return ActionButtons.propTypes[key] !== ActionButtons.propTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          actions = _props.actions,
          contract = _props.contract,
          disabled = _props.disabled,
          goIntoContractOrWizard = _props.goIntoContractOrWizard,
          openManageFolderDialog = _props.openManageFolderDialog,
          openMenu = _props.openMenu,
          resourceType = _props.resourceType,
          style = _props.style,
          templates = _props.templates,
          triggerNoAccessWarning = _props.triggerNoAccessWarning,
          viewingBy = _props.viewingBy,
          requestDataLoading = _props.requestDataLoading;


      var shownState = (0, _contractingUtils.getShownState)(_extends({ companyType: viewingBy }, contract));
      var inOutBox = _ramda2.default.contains(shownState, ['sending', 'bounced']);
      var readOnly = !_ramda2.default.contains('write', contract.access);
      var requestDL = function requestDL() {
        return requestDataLoading({ contractId: contract._id, files: contract.files });
      };
      var resendContract = function resendContract() {
        return actions.openResendContractDialog({
          contractId: contract._id,
          to: contract.to,
          toEmails: contract.toEmails,
          resendToEmails: contract.toEmails
        });
      };
      var moveToTrash = readOnly ? triggerNoAccessWarning : function () {
        return actions.moveToTrash(contract._id);
      };
      var moveToArchived = readOnly ? triggerNoAccessWarning : function () {
        return actions.moveToArchived(contract._id);
      };
      if (contract.isDeleted) {
        return _react2.default.createElement(_smallButtons.JiraFlatButton, {
          style: { minWidth: '64px' },
          labelStyle: { padding: 0 },
          label: 'Restore',
          onTouchTap: function onTouchTap() {
            return actions.restoreContract(contract._id);
          }
        });
      }
      if (contract.isArchived) {
        return _react2.default.createElement(_smallButtons.JiraFlatButton, {
          style: { minWidth: '64px' },
          labelStyle: { padding: 0 },
          label: 'Restore',
          onTouchTap: function onTouchTap() {
            return actions.restoreContractFromArchived(contract._id);
          }
        });
      }
      return _react2.default.createElement(
        'div',
        { className: 'moreActions ' + (0, _aphrodite.css)(styles.container), style: style, id: 'moreActions-' + contract._id },
        _react2.default.createElement(_downloadUploadButton2.default, {
          disabled: disabled,
          contract: contract,
          templates: templates,
          downloadContractPdf: actions.downloadContractPdf,
          goIntoContractOrWizard: goIntoContractOrWizard
        }),
        _react2.default.createElement(
          _materialUi.IconMenu,
          {
            iconButtonElement: _react2.default.createElement(_materialUi.IconButton, { disabled: disabled, iconClassName: 'tc-icon-more-vert', style: { paddingLeft: 0, width: '28px' }, iconStyle: { color: '#616061' } }),
            anchorOrigin: { horizontal: 'right', vertical: 'top' },
            targetOrigin: { horizontal: 'right', vertical: 'top' },
            onTouchTap: openMenu,
            onItemTouchTap: openMenu,
            desktop: true
          },
          resourceType === 'Contractor' && !contract.locationId ? _react2.default.createElement(_materialUi.MenuItem, {
            primaryText: 'Submit this workspace for data loading',
            onTouchTap: requestDL,
            disabled: contract.state === 'loading' || contract.state === 'loaded' || contract.state === 'rejected' || contract.rateConversionSetting !== 'defer',
            leftIcon: _react2.default.createElement(_markunreadMailbox2.default, { color: 'rgba(0, 0, 0, 0.67)' })
          }) : _react2.default.createElement('span', null),
          contract.viewerIsSender ? _react2.default.createElement(_materialUi.MenuItem, {
            primaryText: 'Resend',
            onTouchTap: resendContract,
            leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-near_me', color: 'rgba(0, 0, 0, 0.67)' })
          }) : _react2.default.createElement('span', null),
          contract.viewerIsSender && _react2.default.createElement(_materialUi.Divider, null),
          !inOutBox && _react2.default.createElement(
            _wrapper2.default,
            { amazonOrange: true, skipClick: true },
            _react2.default.createElement(_materialUi.MenuItem, {
              leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-create_new_folder', color: '#00bcd4' }),
              primaryText: 'Assign Folders',
              onTouchTap: readOnly ? triggerNoAccessWarning : openManageFolderDialog('assign') })
          ),
          _react2.default.createElement(_materialUi.MenuItem, {
            leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-folder_open' }),
            disabled: !(contract.folders && contract.folders.length),
            primaryText: 'Move Out of Folder',
            onTouchTap: openManageFolderDialog('moveOut')
          }),
          !inOutBox && _react2.default.createElement(_materialUi.Divider, null),
          _react2.default.createElement(_materialUi.MenuItem, { leftIcon: _react2.default.createElement(_archive2.default, null), primaryText: 'Move to Archived', onTouchTap: moveToArchived }),
          _react2.default.createElement(_materialUi.MenuItem, { leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-delete2', color: '#ff4081' }), primaryText: 'Move to Trash', onTouchTap: moveToTrash }),
          resourceType === 'Contractor' && _react2.default.createElement(_materialUi.Divider, null),
          _react2.default.createElement(_contractMailbox2.default, { contractId: contract._id }),
          _react2.default.createElement(_exportTourWriter2.default, { contractId: contract._id }),
          _react2.default.createElement(_exportTourWriter2.default, { contractId: contract._id, blackout: true })
        )
      );
    }
  }]);

  return ActionButtons;
}(_react.Component);

ActionButtons.propTypes = {
  actions: _react.PropTypes.object,
  contract: _react.PropTypes.object,
  contractMailboxLoding: _react.PropTypes.bool,
  contractMailboxMailbox: _react.PropTypes.string,
  disabled: _react.PropTypes.bool,
  folders: _react.PropTypes.array,
  getContractForwardingEmail: _react.PropTypes.func,
  goIntoContractOrWizard: _react.PropTypes.func,
  isFolder: _react.PropTypes.bool,
  onClickDiscardRequestsSentToSameName: _react.PropTypes.func,
  openManageFolderDialog: _react.PropTypes.func,
  openMenu: _react.PropTypes.func,
  resourceType: _react.PropTypes.string,
  routeName: _react.PropTypes.string,
  searchCategory: _react.PropTypes.string,
  style: _react.PropTypes.object,
  templates: _react.PropTypes.array,
  triggerNoAccessWarning: _react.PropTypes.func,
  viewingBy: _react.PropTypes.string,
  requestDataLoading: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user;
  return {
    folders: contracting.contractList.get('folders').toJS(),
    isFolder: contracting.contractList.get('isFolder'),
    resourceType: user.getIn(['user', 'type']),
    routeName: contracting.contractList.getIn(['list', 'listType']),
    searchCategory: contracting.contractList.get('searchCategory') || '',
    viewingBy: user.getIn(['user', 'type'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  onClickDiscardRequestsSentToSameName: function onClickDiscardRequestsSentToSameName(payload) {
    return { type: 'OPEN_DIALOG_SHOW_REQUESTS_WITH_SAME_NAME', payload: payload };
  },
  requestDataLoading: function requestDataLoading(payload) {
    return { type: 'OPEN_REQUEST_DL', payload: payload };
  }
})(ActionButtons);

/***/ }),
/* 3390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RowWidgets = function RowWidgets(_ref) {
  var disabled = _ref.disabled,
      contract = _ref.contract,
      templates = _ref.templates,
      downloadContractPdf = _ref.downloadContractPdf,
      goIntoContractOrWizard = _ref.goIntoContractOrWizard;
  var viewingBy = contract.viewingBy,
      locationId = contract.locationId,
      buyerChecked = contract.buyerChecked,
      files = contract.files,
      _id = contract._id,
      respondedContracts = contract.respondedContracts;

  var foundMatchedTemplate = _ramda2.default.find(_ramda2.default.allPass([_ramda2.default.eqProps('startDate', contract), _ramda2.default.eqProps('endDate', contract)]), templates);
  var fileExists = files && files.length;
  var tcContractsInRequest = Boolean(!locationId && respondedContracts && respondedContracts.length);
  return _react2.default.createElement(_materialUi.IconButton, {
    disabled: disabled,
    'data-cy': locationId || buyerChecked && viewingBy === 'Contractor' ? _id + 'downloadRates' : _id + 'loadRates',
    tooltip: function () {
      if (locationId) return 'Download Rates';
      if (viewingBy === 'Supplier') {
        if (foundMatchedTemplate) return 'Send Rates';
        return 'Load Rates';
      }
      if (fileExists || tcContractsInRequest) return 'Download Rates';
      return 'Upload Files';
    }(),
    tooltipPosition: 'top-center',
    iconClassName: locationId || fileExists && viewingBy === 'Contractor' || tcContractsInRequest ? 'tc-icon-get_app' : 'tc-icon-file_upload',
    onTouchTap: function onTouchTap(e) {
      if (locationId || fileExists && viewingBy === 'Contractor' || tcContractsInRequest) return downloadContractPdf(e.currentTarget);
      goIntoContractOrWizard();
    }
  });
};
RowWidgets.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};

exports.default = RowWidgets;

/***/ }),
/* 3391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _redDot = __webpack_require__(1056);

var _redDot2 = _interopRequireDefault(_redDot);

var _contractingUtils = __webpack_require__(124);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _archive = __webpack_require__(1142);

var _archive2 = _interopRequireDefault(_archive);

var _smallButtons = __webpack_require__(94);

var _updateRateConversionPriority = __webpack_require__(1542);

var _updateRateConversionPriority2 = _interopRequireDefault(_updateRateConversionPriority);

var _updateAssignee = __webpack_require__(1258);

var _updateAssignee2 = _interopRequireDefault(_updateAssignee);

var _arrowDropDown = __webpack_require__(559);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RateConversionRowDumb = function RateConversionRowDumb(_ref) {
  var contract = _ref.contract,
      actions = _ref.actions,
      showFolder = _ref.showFolder,
      showContractYear = _ref.showContractYear,
      inSearchResult = _ref.inSearchResult,
      openContacts = _ref.openContacts;

  var noReadAccess = !_ramda2.default.contains('read', contract.access);
  var viewingBy = contract.viewingBy,
      locationId = contract.locationId,
      respondedContracts = contract.respondedContracts,
      viewerIsSender = contract.viewerIsSender,
      partners = contract.partners,
      _contract$to = contract.to,
      to = _contract$to === undefined ? {} : _contract$to;

  var tcContractsInRequest = Boolean(!locationId && respondedContracts && respondedContracts.length);
  var shownState = (0, _contractingUtils.getShownState)(_extends({ companyType: viewingBy }, contract));
  var hasVersion = !_ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty)(contract.versions);
  var goIntoContractOrWizard = noReadAccess ? function () {} : function () {
    if (contract.viewingBy === 'Supplier' && !contract.locationId && !contract.buyerChecked) actions.goToSupplierWizard(contract._id);else actions.viewContract('contract', contract._id);
  };
  var hasEditingDraft = contract.hasDraft && contract.locationId && contract.viewingBy === 'Supplier';
  var readOnly = !_ramda2.default.contains('write', contract.access);
  var unread = !viewerIsSender && !contract.isViewed;
  var requestText = function () {
    if (tcContractsInRequest && viewingBy === 'Contractor') {
      return _react2.default.createElement(
        'span',
        { style: { color: 'green' } },
        respondedContracts.length,
        ' ',
        (0, _pluralize2.default)('contracts', respondedContracts.length)
      );
    }
    if (!locationId && viewingBy === 'Supplier' && shownState !== 'sent') {
      return _react2.default.createElement(
        'span',
        null,
        'Prepared for ',
        to.name
      );
    }
    return '';
  }();

  var _ref2 = function () {
    if (viewerIsSender) {
      return {
        displayName: contract.to.name,
        displayAvatar: contract.to.avatar
      };
    }
    // if viewer is receiver
    // display based receiver's partner list
    var partner = partners[0] || {};
    return {
      displayName: partner.name || contract.from.name,
      logoToDisplay: partner.avatar || contract.from.avatar
    };
  }(),
      displayName = _ref2.displayName,
      logoToDisplay = _ref2.logoToDisplay;

  var displayLoc = Boolean(locationId && displayName !== contract.locationName);
  return _react2.default.createElement(
    _materialUi.TableRow,
    {
      selectable: false,
      'data-cy': contract._id + 'contractRow',
      style: { height: '56px', overflow: 'visible' }
    },
    inSearchResult && _react2.default.createElement(_materialUi.TableRowColumn, { colSpan: '1' }),
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '1',
        style: { padding: inSearchResult ? '0' : '0 16px', overflow: 'visible' }
      },
      _ramda2.default.call(_ramda2.default.cond([[function () {
        return logoToDisplay;
      }, _ramda2.default.always(_react2.default.createElement(_materialUi.Avatar, { src: logoToDisplay, style: { marginTop: '4px' } }))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(
        _materialUi.Avatar,
        null,
        _ramda2.default.head(displayName || '')
      ))]]))
    ),
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '6',
        style: { padding: 0, color: noReadAccess ? 'rgba(0, 0, 0, 0.44)' : '' }
      },
      _react2.default.createElement(
        'span',
        {
          style: { height: '48px', display: 'table-cell', verticalAlign: 'middle', cursor: noReadAccess ? '' : 'pointer' },
          onClick: goIntoContractOrWizard
        },
        _react2.default.createElement(
          'div',
          { style: { fontWeight: unread ? 'bold' : '', lineHeight: '12px', fontSize: '12px' } },
          _react2.default.createElement(
            'div',
            null,
            viewerIsSender ? contract.to.name : displayName,
            '\xA0',
            _react2.default.createElement(
              'small',
              null,
              _react2.default.createElement(
                'i',
                null,
                hasVersion ? '(v.' + (_ramda2.default.path(['versions', 'length'], contract) + 1) + ')' : ''
              )
            ),
            _react2.default.createElement(
              'small',
              {
                style: { color: 'rgba(0, 0, 0, 0.44)' },
                'data-cy': 'folder-' + contract.folders.join(', ')
              },
              showFolder && !_ramda2.default.isEmpty(contract.folders) ? ' (' + contract.folders.join(', ') + ')' : ''
            ),
            _react2.default.createElement(
              'small',
              { style: { color: 'red' } },
              showFolder && contract.isDeleted ? 'Trash' : ''
            ),
            _react2.default.createElement(
              'small',
              { style: { color: 'red' } },
              showFolder && contract.isArchived ? 'Archived' : ''
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { fontWeight: unread ? 'bold' : '', display: 'flex', alignItems: 'center', lineHeight: '16px', fontSize: '12px' } },
          displayLoc && _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-location_on', style: { fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)', marginRight: '8px' } }),
          displayLoc && contract.locationName,
          _ramda2.default.path(['supplierInfo', 'marketInfo'], contract) ? _react2.default.createElement(
            'small',
            null,
            '\xA0',
            '(' + _ramda2.default.path(['supplierInfo', 'marketInfo'], contract) + ')'
          ) : _react2.default.createElement('span', null),
          hasEditingDraft ? _react2.default.createElement(
            'span',
            {
              style: { marginLeft: '12px', color: 'red' }
            },
            'This contract has a\xA0',
            _react2.default.createElement(
              'a',
              { href: '/contracting/draft/' + contract._id + '/details', onClick: function onClick(e) {
                  return e.stopPropagation();
                } },
              'draft'
            ),
            '.'
          ) : _react2.default.createElement('span', null),
          requestText,
          _react2.default.createElement(
            'span',
            { style: { color: 'rgba(0, 0, 0, 0.44)' } },
            ' ',
            readOnly && '(READ-ONLY)'
          )
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '2',
        style: { padding: '0 0 0 8px', fontSize: '10px' }
      },
      contract.rateConversionStatus
    ),
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '1',
        style: { padding: '0 0 0 8px', fontSize: '10px' }
      },
      _react2.default.createElement(_updateRateConversionPriority2.default, {
        priorty: contract.priority || 'Medium',
        contractId: contract._id,
        button: _react2.default.createElement(_smallButtons.SmallFlatButton, {
          labelStyle: { padding: 0, fontSize: '10px', color: (0, _contractingUtils.getPriorityColor)(contract.priority || 'Medium') },
          icon: _react2.default.createElement(_arrowDropDown2.default, { style: { fill: 'rgba(0, 0, 0, 0.54)', margin: 0 } }),
          labelPosition: 'before',
          label: contract.priority || 'Medium'
        })
      })
    ),
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '1',
        style: { padding: 0, fontSize: '10px' }
      },
      _react2.default.createElement(_updateAssignee2.default, {
        assignee: contract.assignee,
        contractId: contract._id,
        isContainer: true,
        files: contract.files
      })
    ),
    showContractYear && _react2.default.createElement(
      _materialUi.TableRowColumn,
      { colSpan: '1', style: { padding: 0, textAlign: 'center', whiteSpace: 'pre-wrap', fontSize: '10px' } },
      _moment2.default.utc(contract.startDate).format('D MMM YY') + ' -\n' + _moment2.default.utc(contract.endDate).format('D MMM YY') + '  '
    ),
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '1',
        style: { padding: 0, fontSize: '11px', textAlign: 'center' }
      },
      (0, _moment2.default)(contract.updatedAt).calendar(null, {
        sameDay: 'h:mm a',
        lastDay: 'D MMM YY',
        lastWeek: 'D MMM YY',
        sameElse: 'D MMM YY'
      })
    ),
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '2',
        style: { textOverflow: 'none', paddingLeft: 0, paddingRight: 0 }
      },
      _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
          _materialUi.IconButton,
          {
            onClick: openContacts,
            style: { padding: '12px 4px' },
            iconStyle: { color: 'rgba(0, 0, 0, 0.54)' }
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-mail_outline', style: { fontSize: '20px', top: '4px' } })
        ),
        _react2.default.createElement(
          _materialUi.IconButton,
          {
            onClick: function onClick() {
              return actions.viewNotes('contract', contract._id);
            },
            style: { padding: '12px 4px' },
            iconStyle: { color: 'rgba(0, 0, 0, 0.54)' }
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-note_add', style: { color: 'rgba(0, 0, 0, 0.54)' } }),
          contract.notesCount && _react2.default.createElement(_redDot2.default, { style: { top: '-10px', left: '5px' }, color: '#00bcd4' })
        ),
        _react2.default.createElement(
          _materialUi.IconButton,
          {
            onClick: function onClick() {
              return actions.viewActivities('contract', contract._id);
            },
            style: { padding: '12px 4px' },
            iconStyle: { color: 'rgba(0, 0, 0, 0.54)' }
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-question_answer', style: { color: 'rgba(0, 0, 0, 0.54)' } }),
          contract.hasNewComments && _react2.default.createElement(_redDot2.default, { style: { top: '-10px', left: '6px' } })
        ),
        _react2.default.createElement(
          _materialUi.IconMenu,
          {
            iconButtonElement: _react2.default.createElement(_materialUi.IconButton, { iconClassName: 'tc-icon-more-vert', style: { padding: '12px 4px', width: '28px' }, iconStyle: { color: '#616061' } }),
            anchorOrigin: { horizontal: 'right', vertical: 'top' },
            targetOrigin: { horizontal: 'right', vertical: 'top' },
            desktop: true
          },
          contract.isArchived ? _react2.default.createElement(_materialUi.MenuItem, { leftIcon: _react2.default.createElement(_archive2.default, null), primaryText: 'Unarchive', onTouchTap: function onTouchTap() {
              return actions.restoreContractFromArchived(contract._id);
            } }) : _react2.default.createElement(_materialUi.MenuItem, { leftIcon: _react2.default.createElement(_archive2.default, null), primaryText: 'Archive', onTouchTap: function onTouchTap() {
              return actions.moveToArchived(contract._id);
            } })
        )
      )
    )
  );
};

exports.default = RateConversionRowDumb;

/***/ }),
/* 3392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationUnfoldMore = function NavigationUnfoldMore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z' })
  );
};
NavigationUnfoldMore = (0, _pure2.default)(NavigationUnfoldMore);
NavigationUnfoldMore.displayName = 'NavigationUnfoldMore';
NavigationUnfoldMore.muiName = 'SvgIcon';

exports.default = NavigationUnfoldMore;

/***/ }),
/* 3393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _assigneeFilter = __webpack_require__(2001);

var _assigneeFilter2 = _interopRequireDefault(_assigneeFilter);

var _priorityFilter = __webpack_require__(3394);

var _priorityFilter2 = _interopRequireDefault(_priorityFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RateConversionTableHeader = function RateConversionTableHeader(_ref) {
  var sort = _ref.sort,
      getSortIcon = _ref.getSortIcon,
      sortValue = _ref.sortValue,
      sortRule = _ref.sortRule,
      assigneeFilter = _ref.assigneeFilter,
      filterByAssignee = _ref.filterByAssignee,
      priorityFilter = _ref.priorityFilter,
      filterByPriority = _ref.filterByPriority;

  return _react2.default.createElement(
    _materialUi.TableRow,
    null,
    _react2.default.createElement(_materialUi.TableHeaderColumn, { colSpan: '1' }),
    _react2.default.createElement(
      _materialUi.TableHeaderColumn,
      { colSpan: '6', style: { padding: 0 } },
      'Contract'
    ),
    _react2.default.createElement(
      _materialUi.TableHeaderColumn,
      {
        'data-walkthru': 'contractListStatus',
        colSpan: '2',
        style: { padding: '0 0 0 8px' }
      },
      _react2.default.createElement(
        'div',
        {
          className: 'flex-tc-sb',
          style: { justifyContent: 'center', cursor: 'pointer' },
          onClick: function onClick() {
            return sort('rateConversionStatus');
          }
        },
        'Rate Conversion Status',
        ' ',
        getSortIcon(_ramda2.default.equals('rateConversionStatus', sortValue), sortRule)
      )
    ),
    _react2.default.createElement(
      _materialUi.TableHeaderColumn,
      { 'data-walkthru': 'priority', colSpan: '1', style: { padding: 0 } },
      _react2.default.createElement(_priorityFilter2.default, { filter: priorityFilter, filterByPriority: filterByPriority })
    ),
    _react2.default.createElement(
      _materialUi.TableHeaderColumn,
      { colSpan: '1', style: { padding: 0, overflow: 'hidden' } },
      _react2.default.createElement(_assigneeFilter2.default, { filter: assigneeFilter, filterByAssignee: filterByAssignee, isContainer: true })
    ),
    _react2.default.createElement(
      _materialUi.TableHeaderColumn,
      { colSpan: '1', style: { padding: 0, textAlign: 'center' } },
      'Periods'
    ),
    _react2.default.createElement(
      _materialUi.TableHeaderColumn,
      { colSpan: '1', style: { padding: 0, textAlign: 'center' } },
      _react2.default.createElement(
        'div',
        {
          className: 'flex-tc-sb',
          style: { justifyContent: 'center', cursor: 'pointer' },
          onClick: function onClick() {
            return sort('updatedAt');
          }
        },
        'Modified ',
        getSortIcon(_ramda2.default.equals('updatedAt', sortValue), sortRule)
      )
    ),
    _react2.default.createElement(
      _materialUi.TableHeaderColumn,
      { colSpan: '2', style: { padding: 0 } },
      'Contacts \xA0 Notes \xA0 Activity'
    )
  );
};

exports.default = RateConversionTableHeader;

/***/ }),
/* 3394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.priorities = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _flatDropDownMenu = __webpack_require__(494);

var _flatDropDownMenu2 = _interopRequireDefault(_flatDropDownMenu);

var _arrowDropDown = __webpack_require__(559);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _smallButtons = __webpack_require__(94);

var _contractingUtils = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var priorities = exports.priorities = ['Highest', 'High', 'Medium', 'Low', 'Lowest'];

var PriorityFilter = function (_Component) {
  _inherits(PriorityFilter, _Component);

  function PriorityFilter() {
    _classCallCheck(this, PriorityFilter);

    var _this = _possibleConstructorReturn(this, (PriorityFilter.__proto__ || Object.getPrototypeOf(PriorityFilter)).call(this));

    _this.onClick = function (userId) {
      return function () {
        var filterByPriority = _this.props.filterByPriority;

        filterByPriority(userId);
      };
    };

    return _this;
  }

  _createClass(PriorityFilter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          filter = _props.filter,
          button = _props.button;

      var filterLabel = function () {
        if (filter) return filter;
        return 'Priority';
      }();
      return _react2.default.createElement(
        _flatDropDownMenu2.default,
        {
          button: button || _react2.default.createElement(_smallButtons.JiraFlatButton, {
            labelStyle: { fontSize: '12px', fontWeight: filter ? 'bold' : 'normal', color: filter ? (0, _contractingUtils.getPriorityColor)(filter) : 'rgba(0, 0, 0, 0.54)' },
            icon: _react2.default.createElement(_arrowDropDown2.default, { style: { fill: 'rgba(0, 0, 0, 0.54)', margin: 0 } }),
            labelPosition: 'before',
            label: filterLabel
          })
        },
        _react2.default.createElement(_materialUi.MenuItem, {
          primaryText: 'All',
          onClick: this.onClick(null)
        }),
        _react2.default.createElement(_materialUi.Divider, null),
        priorities.map(function (str) {
          return _react2.default.createElement(_materialUi.MenuItem, {
            key: str,
            primaryText: str,
            disabled: str === filter,
            leftIcon: (0, _contractingUtils.getPriorityIcon)(str),
            onClick: _this2.onClick(str)
          });
        })
      );
    }
  }]);

  return PriorityFilter;
}(_react.Component);

PriorityFilter.propTypes = {
  filterByPriority: _react.PropTypes.func,
  filter: _react.PropTypes.string,
  button: _react.PropTypes.node,
  usersArray: _react.PropTypes.array,
  isContainer: _react.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    usersArray: state.settings.get('allActiveUsers').toJS ? state.settings.get('allActiveUsers').toJS() : state.settings.get('allActiveUsers')
  };
})(PriorityFilter);

/***/ }),
/* 3395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationOndemandVideo = function NotificationOndemandVideo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z' })
  );
};
NotificationOndemandVideo = (0, _pure2.default)(NotificationOndemandVideo);
NotificationOndemandVideo.displayName = 'NotificationOndemandVideo';
NotificationOndemandVideo.muiName = 'SvgIcon';

exports.default = NotificationOndemandVideo;

/***/ }),
/* 3396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _contractListActions = __webpack_require__(563);

var _upgradeActions = __webpack_require__(611);

var _folderFieldSaveButton = __webpack_require__(3397);

var _folderFieldSaveButton2 = _interopRequireDefault(_folderFieldSaveButton);

var _lock = __webpack_require__(578);

var _lock2 = _interopRequireDefault(_lock);

var _unarchive = __webpack_require__(2003);

var _unarchive2 = _interopRequireDefault(_unarchive);

var _highlight = __webpack_require__(1213);

var _highlight2 = _interopRequireDefault(_highlight);

var _errorOutline = __webpack_require__(1515);

var _errorOutline2 = _interopRequireDefault(_errorOutline);

var _send = __webpack_require__(577);

var _send2 = _interopRequireDefault(_send);

var _archive = __webpack_require__(1142);

var _archive2 = _interopRequireDefault(_archive);

var _addCircleOutline = __webpack_require__(1259);

var _addCircleOutline2 = _interopRequireDefault(_addCircleOutline);

var _selectAll = __webpack_require__(2004);

var _selectAll2 = _interopRequireDefault(_selectAll);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  getContractFolders: _react.PropTypes.func,
  changeRoute: _react.PropTypes.func,
  folderLoading: _react.PropTypes.bool,
  folders: _react.PropTypes.array,
  className: _react.PropTypes.string,
  routeName: _react.PropTypes.string,
  companyType: _react.PropTypes.string,
  newFolderName: _react.PropTypes.string,
  newFolderErrorText: _react.PropTypes.string,
  renameFolderError: _react.PropTypes.string,
  folderToBeRenamedIndex: _react.PropTypes.number,
  outBoxCount: _react.PropTypes.number,
  bouncedCount: _react.PropTypes.number,
  rcCount: _react.PropTypes.number,
  originalFolder: _react.PropTypes.string,
  updateProps: _react.PropTypes.func,
  deleteFolder: _react.PropTypes.func,
  saveNewFolder: _react.PropTypes.func,
  updateFolders: _react.PropTypes.func,
  isBasicUser: _react.PropTypes.bool,
  userId: _react.PropTypes.string,
  openUpgradeFrom: _react.PropTypes.func,
  createNewFolder: _react.PropTypes.bool
};

var ContractListLeftNav = function (_Component) {
  _inherits(ContractListLeftNav, _Component);

  function ContractListLeftNav(props) {
    _classCallCheck(this, ContractListLeftNav);

    var _this = _possibleConstructorReturn(this, (ContractListLeftNav.__proto__ || Object.getPrototypeOf(ContractListLeftNav)).call(this, props));

    _this.renderDefaultMenuItems = function (icon, primaryText, queryParam) {
      var _this$props = _this.props,
          changeRoute = _this$props.changeRoute,
          routeName = _this$props.routeName;

      var isActive = routeName.toLowerCase() === queryParam.toLowerCase();
      return _react2.default.createElement(
        'div',
        {
          key: primaryText,
          className: 'contracting-left-nav-widget-link ' + primaryText.toLowerCase().replace(' ', '-') + ' ' + (isActive ? 'is-active' : ''),
          style: { color: isActive ? '#00bcd4' : 'white', fontSize: '14px', display: 'flex', alignItem: 'center' },
          onClick: function onClick() {
            return changeRoute(queryParam);
          }
        },
        _ramda2.default.is(String, icon) ? _react2.default.createElement(_materialUi.FontIcon, {
          className: icon,
          color: isActive ? '#00bcd4' : 'white',
          style: { width: '36px' }
        }) : (0, _react.cloneElement)(icon, { color: isActive ? '#00bcd4' : 'white', style: { width: '36px' } }),
        _react2.default.createElement(
          'span',
          { style: { lineHeight: '24px', width: '70%' } },
          primaryText
        )
      );
    };

    _this.renderMenuItem = _ramda2.default.curry(function (icon, folderName, index) {
      var _this$props2 = _this.props,
          changeRoute = _this$props2.changeRoute,
          folderToBeRenamedIndex = _this$props2.folderToBeRenamedIndex,
          routeName = _this$props2.routeName,
          folders = _this$props2.folders,
          updateProps = _this$props2.updateProps,
          updateFolders = _this$props2.updateFolders,
          deleteFolder = _this$props2.deleteFolder,
          renameFolderError = _this$props2.renameFolderError,
          originalFolder = _this$props2.originalFolder;

      var isActive = routeName.toLowerCase() === folderName.toLowerCase();
      if (folderToBeRenamedIndex === index) {
        return _react2.default.createElement(_folderFieldSaveButton2.default, {
          key: index,
          errorText: renameFolderError,
          value: folderName,
          onChange: function onChange(_ref) {
            var value = _ref.target.value;
            return updateProps({ folders: _ramda2.default.update(folderToBeRenamedIndex, value, folders), renameFolderError: undefined });
          },
          label: 'save',
          onTouchTap: function onTouchTap() {
            if (_ramda2.default.contains(folderName, _ramda2.default.remove(folderToBeRenamedIndex, 1, folders))) updateProps({ renameFolderError: 'Duplicate folder' });else updateFolders({ folders: folders, originalFolder: originalFolder, newFolderName: folders[folderToBeRenamedIndex] });
          },
          cancelFn: function cancelFn() {
            return updateProps({ folders: _ramda2.default.update(folderToBeRenamedIndex, originalFolder, folders), folderToBeRenamedIndex: undefined, renameFolderError: undefined, originalFolder: undefined });
          }
        });
      }
      return _react2.default.createElement(
        'div',
        {
          key: index,
          'data-cy': folderName,
          className: 'contracting-left-nav-widget-link ' + (isActive ? 'is-active' : ''),
          style: { color: isActive ? '#00bcd4' : 'white', fontSize: '12px', display: 'flex', alignItem: 'center' }
        },
        _react2.default.createElement(_materialUi.FontIcon, {
          className: icon,
          color: isActive ? '#00bcd4' : 'white',
          style: { width: '36px' },
          onClick: function onClick() {
            return changeRoute(folderName, true);
          }
        }),
        _react2.default.createElement(
          'span',
          { style: { lineHeight: '24px', width: '70%' }, onClick: function onClick() {
              return changeRoute(folderName, true);
            } },
          folderName
        ),
        _react2.default.createElement(
          _materialUi.IconMenu,
          {
            iconButtonElement: _react2.default.createElement(_materialUi.IconButton, { iconClassName: 'tc-icon-more_vert', iconStyle: { color: 'white' }, style: { height: '30px', padding: '0' } }),
            style: { display: isNaN(folderToBeRenamedIndex) ? 'inline-block' : 'none' }
          },
          _react2.default.createElement(_materialUi.MenuItem, {
            primaryText: 'Rename',
            leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-mode_edit', color: '#00bcd4' }),
            onTouchTap: function onTouchTap() {
              return updateProps({ folderToBeRenamedIndex: index, originalFolder: folderName });
            }
          }),
          _react2.default.createElement(_materialUi.MenuItem, {
            primaryText: 'Delete Folder',
            leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-delete2', color: '#ff4081' }),
            onTouchTap: function onTouchTap() {
              var confirmed = window.confirm('Are you sure you want to delete this folder? Please note that all files inside this folder will NOT be removed.');
              if (confirmed) {
                deleteFolder(folderName);
                if (routeName === folderName) changeRoute('all contracts');
              }
            }
          })
        )
      );
    });
    return _this;
  }

  _createClass(ContractListLeftNav, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var getContractFolders = this.props.getContractFolders;

      getContractFolders();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          folderLoading = _props.folderLoading,
          folders = _props.folders,
          className = _props.className,
          companyType = _props.companyType,
          newFolderName = _props.newFolderName,
          routeName = _props.routeName,
          updateProps = _props.updateProps,
          saveNewFolder = _props.saveNewFolder,
          newFolderErrorText = _props.newFolderErrorText,
          createNewFolder = _props.createNewFolder;

      var defaultFolders = companyType === 'Contractor' ? [{
        primaryText: 'Received Rates',
        queryParam: 'recent',
        icon: 'tc-icon-inbox'
      }, {
        primaryText: 'Requests Sent',
        queryParam: 'sent',
        icon: _react2.default.createElement(_send2.default, null)
      }] : [{
        primaryText: 'Requests',
        queryParam: 'recent',
        icon: 'tc-icon-inbox'
      }, {
        primaryText: 'Rates Sent',
        queryParam: 'sent',
        icon: _react2.default.createElement(_send2.default, null)
      }];
      return _react2.default.createElement(
        _materialUi.Paper,
        { className: (className || '') + ' contracting-left-nav-widget', style: { backgroundColor: '#383E4B', flex: '1' }, zDepth: 2 },
        defaultFolders.map(function (folder) {
          return _this2.renderDefaultMenuItems(folder.icon, folder.primaryText, folder.queryParam);
        }),
        Boolean(this.props.bouncedCount) && _react2.default.createElement(
          'div',
          {
            className: 'contracting-left-nav-widget-link ' + (routeName.toLowerCase() === 'outbox' ? 'is-active' : ''),
            style: { color: routeName.toLowerCase() === 'outbox' ? '#00bcd4' : 'white', fontSize: '14px', display: 'flex', alignItem: 'center', overflow: 'visible' },
            onClick: function onClick() {
              return _this2.props.changeRoute('outBox');
            }
          },
          _react2.default.createElement(
            'div',
            {
              style: { width: '36px' }
            },
            this.props.isBasicUser ? _react2.default.createElement(_lock2.default, { style: { color: '#FFD700' } }) : _react2.default.createElement(_unarchive2.default, { style: { color: routeName.toLowerCase() === 'outbox' ? '#00bcd4' : 'white' } })
          ),
          _react2.default.createElement(
            'span',
            {
              style: { lineHeight: '24px', width: '77%', display: 'flex', justifyContent: 'space-between' },
              'aria-label': this.props.isBasicUser ? 'Upgrade to see which ' + (companyType === 'Supplier' ? 'contracts' : 'requests') + ' were bounced.' : '',
              className: this.props.isBasicUser ? 'hint--top' : ''
            },
            _react2.default.createElement(
              'span',
              null,
              'Outbox'
            ),
            _react2.default.createElement(_errorOutline2.default, { style: { color: '#f44336' } })
          )
        ),
        this.renderDefaultMenuItems(_react2.default.createElement(_selectAll2.default, null), 'All Contracts', 'all contracts'),
        this.renderDefaultMenuItems(_react2.default.createElement(_archive2.default, null), 'Archived', 'archived'),
        this.renderDefaultMenuItems('tc-icon-delete2', 'Trash', 'trash'),
        Boolean(this.props.rcCount) && _react2.default.createElement(_materialUi.Divider, { style: { backgroundColor: 'rgba(255, 255, 255, 0.2)' } }),
        Boolean(this.props.rcCount) && _react2.default.createElement(
          'div',
          {
            className: 'contracting-left-nav-widget-link ' + (routeName.toLowerCase() === 'rate-conversion' ? 'is-active' : ''),
            style: { color: routeName.toLowerCase() === 'rate-conversion' ? '#00bcd4' : 'white', fontSize: '14px', display: 'flex', alignItem: 'center', overflow: 'visible' },
            onClick: function onClick() {
              return _this2.props.changeRoute('rate-conversion');
            }
          },
          _react2.default.createElement(
            'div',
            {
              style: { width: '36px' }
            },
            _react2.default.createElement(_highlight2.default, { style: { color: routeName.toLowerCase() === 'rate-conversion' ? '#00bcd4' : 'white' } })
          ),
          _react2.default.createElement(
            'span',
            {
              style: { lineHeight: '24px', width: '77%', display: 'flex', justifyContent: 'space-between' }
            },
            _react2.default.createElement(
              'span',
              null,
              'Rate Conversions'
            )
          )
        ),
        _react2.default.createElement(_materialUi.Divider, { style: { backgroundColor: 'rgba(255, 255, 255, 0.2)' } }),
        _react2.default.createElement(
          _wrapper2.default,
          { amazonOrange: true, skipClick: true },
          _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb', style: { padding: '0 16px' } },
            _react2.default.createElement(
              'div',
              { style: { color: 'white' } },
              'Folders'
            ),
            _react2.default.createElement(
              _materialUi.IconButton,
              {
                style: { paddingRight: '6px' },
                iconStyle: { color: '#f1ebeb' },
                onTouchTap: function onTouchTap() {
                  return updateProps({ createNewFolder: true });
                }
              },
              _react2.default.createElement(_addCircleOutline2.default, null)
            )
          )
        ),
        createNewFolder ? _react2.default.createElement(_folderFieldSaveButton2.default, {
          id: 'new folder',
          hintText: 'New Folder',
          errorText: newFolderErrorText,
          value: newFolderName || '',
          onChange: function onChange(_, val) {
            return updateProps({ newFolderName: val, newFolderErrorText: '' });
          },
          label: 'Save',
          onTouchTap: function onTouchTap() {
            if (_ramda2.default.contains(newFolderName, folders)) updateProps({ newFolderErrorText: 'Folder Exists' });else saveNewFolder(newFolderName);
          },
          cancelFn: function cancelFn() {
            return updateProps({ newFolderName: '', newFolderErrorText: '', createNewFolder: false });
          }
        }) : _react2.default.createElement('span', null),
        folderLoading ? _react2.default.createElement(_materialUi.CircularProgress, { size: 40, style: { marginLeft: '40%' } }) : folders.map(this.renderMenuItem('tc-icon-folder_open'))
      );
    }
  }]);

  return ContractListLeftNav;
}(_react.Component);

ContractListLeftNav.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting,
      user = _ref2.user;
  return {
    folders: contracting.contractList.get('folders').toJS(),
    outBoxCount: contracting.contractList.get('outBoxCount'),
    bouncedCount: contracting.contractList.get('bouncedCount'),
    rcCount: contracting.contractList.get('rcCount'),
    newFolderName: contracting.contractList.get('newFolderName'),
    newFolderErrorText: contracting.contractList.get('newFolderErrorText'),
    renameFolderError: contracting.contractList.get('renameFolderError'),
    originalFolder: contracting.contractList.get('originalFolder'),
    folderToBeRenamedIndex: contracting.contractList.get('folderToBeRenamedIndex'),
    folderLoading: contracting.contractList.get('folderLoading'),
    createNewFolder: contracting.contractList.get('createNewFolder'),
    companyType: user.getIn(['user', 'type']),
    userId: user.get('id'),
    isBasicUser: user.get('billingPlan') === 'basic'
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { openUpgradeFrom: _upgradeActions.openUpgradeFrom, getContractFolders: _contractListActions.getContractFolders })(ContractListLeftNav);

/***/ }),
/* 3397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _nodeUuid = __webpack_require__(219);

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldAndButton = function FieldAndButton(_ref) {
  var hintText = _ref.hintText,
      errorText = _ref.errorText,
      value = _ref.value,
      label = _ref.label,
      onTouchTap = _ref.onTouchTap,
      onChange = _ref.onChange,
      cancelFn = _ref.cancelFn;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_materialUi.TextField, {
      id: _nodeUuid2.default.v1(),
      hintText: hintText,
      hintStyle: { color: 'rgba(255, 255, 255, 0.5)' },
      inputStyle: { color: 'white' },
      errorText: errorText,
      underlineStyle: { borderBottomColor: '#00bcd4' },
      style: { width: '80%', marginLeft: '8%' },
      value: value,
      onChange: onChange
    }),
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '8px' } },
      _react2.default.createElement(_materialUi.RaisedButton, {
        label: 'Cancel',
        style: { minWidth: '68px', marginLeft: '8%' },
        overlayStyle: { height: '32px' },
        buttonStyle: { height: '32px', lineHeight: '32px' },
        onTouchTap: cancelFn
      }),
      _react2.default.createElement(_materialUi.RaisedButton, {
        label: label,
        secondary: true,
        style: { minWidth: '68px', marginLeft: '8%' },
        overlayStyle: { height: '32px' },
        buttonStyle: { height: '32px', lineHeight: '32px' },
        onTouchTap: onTouchTap
      })
    )
  );
};

exports.default = FieldAndButton;

/***/ }),
/* 3398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _titlecase = __webpack_require__(549);

var _contractListActions = __webpack_require__(563);

var _bulkActions = __webpack_require__(3399);

var _bulkActions2 = _interopRequireDefault(_bulkActions);

var _filtersSearch = __webpack_require__(3400);

var _filtersSearch2 = _interopRequireDefault(_filtersSearch);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopBar = function TopBar(_ref) {
  var routeName = _ref.routeName,
      selectedContracts = _ref.selectedContracts,
      allContractIds = _ref.allContractIds,
      unselectAll = _ref.unselectAll,
      moveAllToTrash = _ref.moveAllToTrash,
      moveAllToArchived = _ref.moveAllToArchived,
      restoreAll = _ref.restoreAll,
      restoreAllFromArchived = _ref.restoreAllFromArchived,
      updateProps = _ref.updateProps,
      stateChange = _ref.stateChange,
      openBulkResendDialog = _ref.openBulkResendDialog,
      downloadPdfZip = _ref.downloadPdfZip,
      forFiltersAndSearch = _ref.forFiltersAndSearch,
      isFolder = _ref.isFolder;

  if (selectedContracts.length) {
    return _react2.default.createElement(
      _materialUi.Paper,
      { style: { backgroundColor: 'rgb(218, 244, 247)', color: '#00bcd4', height: '49px', minHeight: '49px', display: 'flex', alignItems: 'center', fontSize: '18px' } },
      _react2.default.createElement(
        'div',
        { style: { width: '20%', display: 'flex', alignItems: 'center', cursor: 'pointer' }, onClick: unselectAll },
        _react2.default.createElement(_materialUi.IconButton, { iconClassName: 'tc-icon-arrow_back', iconStyle: { color: '#00bcd4' } }),
        'Back'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '80%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
        _react2.default.createElement(
          'div',
          null,
          selectedContracts.length,
          ' item',
          allContractIds.length > 1 ? 's' : '',
          ' selected',
          _react2.default.createElement(
            'u',
            {
              style: { marginLeft: '16px', fontSize: '14px', cursor: 'pointer', display: allContractIds.length > selectedContracts.length ? 'inline-block' : 'none' },
              onClick: function onClick() {
                return updateProps({ selectedContracts: allContractIds, allContractIds: [] });
              }
            },
            'Select All ',
            allContractIds.length,
            ' Item',
            allContractIds.length > 1 ? 's' : ''
          )
        ),
        _ramda2.default.call(_ramda2.default.cond([[function () {
          return routeName === 'trash' || routeName === 'archived';
        }, _ramda2.default.always(_react2.default.createElement(_materialUi.MenuItem, {
          desktop: true,
          leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-restore' }),
          primaryText: 'Restore',
          onTouchTap: function onTouchTap() {
            if (routeName === 'trash') restoreAll(selectedContracts);else restoreAllFromArchived(selectedContracts);
          }
        }))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(_bulkActions2.default, {
          openManageFolderDialog: function openManageFolderDialog(folderAction) {
            return function () {
              return updateProps({ manageFolderDialogOpen: true, selectedFolders: isFolder ? [routeName] : [], folderAction: folderAction });
            };
          },
          moveToTrash: function moveToTrash() {
            return moveAllToTrash(selectedContracts);
          },
          moveToArchived: function moveToArchived() {
            return moveAllToArchived(selectedContracts);
          },
          stateChange: stateChange(selectedContracts),
          unselectAll: unselectAll,
          downloadPdfZip: downloadPdfZip,
          openBulkResendDialog: openBulkResendDialog
        }))]]))
      )
    );
  }
  return _react2.default.createElement(
    'div',
    { className: 'flex-tc-sb', style: { backgroundColor: 'rgba(0, 0, 0, 0.1)', color: 'white', fontSize: '18px', minHeight: '49px' } },
    _react2.default.createElement(_filtersSearch2.default, _extends({}, forFiltersAndSearch, {
      updateProps: updateProps
    }))
  );
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting,
      user = _ref2.user;
  return {
    companyType: user.getIn(['user', 'type']),
    selectedContracts: contracting.contractList.get('selectedContracts').toJS(),
    allContractIds: contracting.contractList.get('allContractIds').toJS(),
    isFolder: contracting.contractList.get('isFolder')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { downloadPdfZip: _contractListActions.downloadPdfZip })(TopBar);

/***/ }),
/* 3399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _getApp = __webpack_require__(1558);

var _getApp2 = _interopRequireDefault(_getApp);

var _send = __webpack_require__(577);

var _send2 = _interopRequireDefault(_send);

var _archive = __webpack_require__(1142);

var _archive2 = _interopRequireDefault(_archive);

var _contractingUtils = __webpack_require__(124);

var _upgradeActions = __webpack_require__(611);

var _exportTourWriter = __webpack_require__(1546);

var _exportTourWriter2 = _interopRequireDefault(_exportTourWriter);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BulkActions = function BulkActions(_ref) {
  var downloadPdfZip = _ref.downloadPdfZip,
      extraPropsForIconMenu = _ref.extraPropsForIconMenu,
      isFolder = _ref.isFolder,
      moveToArchived = _ref.moveToArchived,
      moveToTrash = _ref.moveToTrash,
      openBulkResendDialog = _ref.openBulkResendDialog,
      openManageFolderDialog = _ref.openManageFolderDialog,
      resourceType = _ref.resourceType,
      routeName = _ref.routeName,
      stateChange = _ref.stateChange,
      unselectAll = _ref.unselectAll;

  var inContractRequest = resourceType === 'Contractor' && routeName === 'sent' || resourceType === 'Supplier' && routeName === 'recent';
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _materialUi.IconMenu,
      _extends({
        iconButtonElement: _react2.default.createElement(_materialUi.RaisedButton, {
          label: 'Bulk Actions',
          style: { marginRight: '6px' },
          secondary: true
        }),
        anchorOrigin: { horizontal: 'right', vertical: 'top' },
        targetOrigin: { horizontal: 'right', vertical: 'top' }
      }, extraPropsForIconMenu, {
        desktop: true
      }),
      _react2.default.createElement(_materialUi.MenuItem, {
        leftIcon: _react2.default.createElement(_getApp2.default, null),
        primaryText: 'Download All',
        onTouchTap: downloadPdfZip,
        disabled: inContractRequest
      }),
      _react2.default.createElement(_materialUi.Divider, null),
      resourceType === 'Contractor' ? _react2.default.createElement(_materialUi.MenuItem, {
        leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: (0, _contractingUtils.getStatusIcon)('accepted'), color: (0, _contractingUtils.getStatusColor)('accepted') }),
        primaryText: 'Mark All as Accepted',
        onTouchTap: function onTouchTap() {
          stateChange('accepted');
          unselectAll();
        }
      }) : _react2.default.createElement('span', null),
      resourceType === 'Contractor' ? _react2.default.createElement(_materialUi.MenuItem, {
        leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: (0, _contractingUtils.getStatusIcon)('loading'), color: (0, _contractingUtils.getStatusColor)('loading') }),
        primaryText: 'Mark All as Loading',
        onTouchTap: function onTouchTap() {
          stateChange('loading');
          unselectAll();
        }
      }) : _react2.default.createElement('span', null),
      resourceType === 'Contractor' ? _react2.default.createElement(_materialUi.MenuItem, {
        leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: (0, _contractingUtils.getStatusIcon)('loaded'), color: (0, _contractingUtils.getStatusColor)('loaded') }),
        primaryText: 'Mark All as Loaded',
        onTouchTap: function onTouchTap() {
          stateChange('loaded');
          unselectAll();
        }
      }) : _react2.default.createElement('span', null),
      resourceType === 'Contractor' ? _react2.default.createElement(_materialUi.MenuItem, {
        leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: (0, _contractingUtils.getStatusIcon)('rejected'), color: (0, _contractingUtils.getStatusColor)('rejected') }),
        primaryText: 'Mark All as Rejected',
        onTouchTap: function onTouchTap() {
          stateChange('rejected');
          unselectAll();
        }
      }) : _react2.default.createElement('span', null),
      resourceType === 'Contractor' ? _react2.default.createElement(_materialUi.Divider, null) : _react2.default.createElement('span', null),
      _react2.default.createElement(_materialUi.MenuItem, {
        disabled: routeName === 'recent',
        primaryText: 'Resend ' + (resourceType === 'Contractor' ? 'Requests' : 'Contracts'),
        onTouchTap: openBulkResendDialog,
        leftIcon: _react2.default.createElement(_send2.default, { color: 'rgba(0, 0, 0, 0.67)' })
      }),
      _react2.default.createElement(_materialUi.Divider, null),
      _react2.default.createElement(
        _wrapper2.default,
        { amazonOrange: true, skipClick: true },
        _react2.default.createElement(_materialUi.MenuItem, {
          leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-create_new_folder', color: '#00bcd4' }),
          primaryText: 'Assign Folders',
          onTouchTap: openManageFolderDialog('assign')
        })
      ),
      isFolder && _react2.default.createElement(_materialUi.MenuItem, {
        leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-folder_open' }),
        primaryText: 'Move Out of Folder',
        onTouchTap: openManageFolderDialog('moveOut')
      }),
      _react2.default.createElement(_materialUi.Divider, null),
      _react2.default.createElement(_materialUi.MenuItem, {
        leftIcon: _react2.default.createElement(_archive2.default, null),
        primaryText: 'Move to Archived',
        onTouchTap: moveToArchived
      }),
      _react2.default.createElement(_materialUi.MenuItem, {
        leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-delete2', color: '#ff4081' }),
        primaryText: 'Move to Trash',
        onTouchTap: moveToTrash
      }),
      _react2.default.createElement(_exportTourWriter2.default, null),
      _react2.default.createElement(_exportTourWriter2.default, { blackout: true })
    )
  );
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var user = _ref2.user,
      contracting = _ref2.contracting;
  return {
    resourceType: user.getIn(['user', 'type']),
    billingPlan: user.get('billingPlan'),
    folders: contracting.contractList.get('folders').toJS(),
    routeName: contracting.contractList.getIn(['list', 'listType']),
    isFolder: contracting.contractList.get('isFolder'),
    searchCategory: contracting.contractList.get('searchCategory') || ''
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  openUpgradeFrom: _upgradeActions.openUpgradeFrom
})(BulkActions);

/***/ }),
/* 3400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _smallButtons = __webpack_require__(94);

var _materialUi = __webpack_require__(3);

var _redDot = __webpack_require__(1056);

var _redDot2 = _interopRequireDefault(_redDot);

var _fuzzySearch = __webpack_require__(3401);

var _fuzzySearch2 = _interopRequireDefault(_fuzzySearch);

var _preciseSearch = __webpack_require__(3402);

var _preciseSearch2 = _interopRequireDefault(_preciseSearch);

var _tune = __webpack_require__(3404);

var _tune2 = _interopRequireDefault(_tune);

var _aphrodite = __webpack_require__(123);

var _aphrodite2 = _interopRequireDefault(_aphrodite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  searchParams: _react.PropTypes.object,
  search: _react.PropTypes.func,
  updateSearchParams: _react.PropTypes.func,
  listType: _react.PropTypes.string,
  pathBeforeSearch: _react.PropTypes.string,
  updateProps: _react.PropTypes.func,
  changeRoute: _react.PropTypes.func
};
var styles = _aphrodite2.default.StyleSheet.create({
  container: { borderBottom: '1px solid rgba(0, 0, 0, 0.1)', display: 'flex', flexDirection: 'column', width: '100%' },
  chips: { paddingBottom: '8px', display: 'flex', marginLeft: '2%' },
  searchStyle: { position: 'relative', display: 'inline-block', marginLeft: '1%', fontSize: '11px', height: '24px', lineHeight: '24px', cursor: 'pointer', width: '104px' }
});

var FilterAndSearch = function (_React$Component) {
  _inherits(FilterAndSearch, _React$Component);

  function FilterAndSearch() {
    _classCallCheck(this, FilterAndSearch);

    return _possibleConstructorReturn(this, (FilterAndSearch.__proto__ || Object.getPrototypeOf(FilterAndSearch)).apply(this, arguments));
  }

  _createClass(FilterAndSearch, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          searchParams = _props.searchParams,
          search = _props.search,
          updateSearchParams = _props.updateSearchParams,
          listType = _props.listType,
          pathBeforeSearch = _props.pathBeforeSearch;

      var searchFiltersSelected = ['locationSearchInput', 'companySearchInput', 'stateFilterForBuyer', 'stateFilterForSupplier', 'rateConversionStatusFilter', 'contractTypeFilter', 'readUnreadFilter', 'newActivity', 'otherSideRead', 'showRateContainers', 'showArchivedDeleted'].reduce(function (result, key) {
        if (_ramda2.default.is(Array, searchParams[key])) {
          if (!_ramda2.default.isEmpty(searchParams[key])) result.push(key);
        } else if (searchParams[key]) result.push(key);
        return result;
      }, []);
      return _react2.default.createElement(
        'div',
        { className: _aphrodite2.default.css(styles.container) },
        searchParams.openAdvanceSearch ? _react2.default.createElement(
          'div',
          { className: 'flex-tc-sb', style: { position: 'relative', top: '1px' } },
          _react2.default.createElement('div', null),
          _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb' },
            _react2.default.createElement(_smallButtons.SmallFlatButton, {
              label: 'Clear Search',
              labelStyle: { padding: '0 8px' },
              icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-close', style: { margin: '0 0 0 8px' } }),
              onTouchTap: function onTouchTap() {
                _this2.props.changeRoute(pathBeforeSearch || 'recent');
              }
            }),
            _react2.default.createElement(_smallButtons.SmallFlatButton, {
              label: 'Minimize Search',
              labelStyle: { padding: '0 8px' },
              style: { marginLeft: '8px' },
              icon: _react2.default.createElement(_tune2.default, { style: { margin: '0 0 0 8px' } }),
              onTouchTap: function onTouchTap() {
                return updateSearchParams({ openAdvanceSearch: false });
              }
            })
          )
        ) : _react2.default.createElement(
          'div',
          { className: 'flex-tc-sb', style: { position: 'relative', top: '1px' } },
          _react2.default.createElement(_fuzzySearch2.default, { updateSearchParams: updateSearchParams, search: search, searchParams: searchParams, changeRoute: this.props.changeRoute }),
          _react2.default.createElement(
            _materialUi.IconButton,
            {
              tooltip: !searchParams.openAdvanceSearch ? 'Advance Search' : 'Hide advance search',
              onTouchTap: function onTouchTap() {
                return updateSearchParams({ openAdvanceSearch: true });
              }
            },
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(_tune2.default, null),
              Boolean(listType === 'search' && searchFiltersSelected.length && !searchParams.openAdvanceSearch) && _react2.default.createElement(_redDot2.default, { style: { top: '-36px', left: '7px' } })
            )
          )
        ),
        searchParams.openAdvanceSearch && _react2.default.createElement(_preciseSearch2.default, { updateSearchParams: updateSearchParams, search: search, searchParams: searchParams })
      );
    }
  }]);

  return FilterAndSearch;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user;
  return {
    pathBeforeSearch: contracting.contractList.get('pathBeforeSearch'),
    searchParams: contracting.contractList.get('searchParams').toJS(),
    listType: contracting.contractList.getIn(['list', 'listType']),
    companyType: user.getIn(['user', 'type'])
  };
};

FilterAndSearch.propTypes = propTypes;

exports.default = (0, _reactRedux.connect)(mapStateToProps)(FilterAndSearch);

/***/ }),
/* 3401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _aphrodite = __webpack_require__(123);

var _aphrodite2 = _interopRequireDefault(_aphrodite);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = _aphrodite2.default.StyleSheet.create({
  searchContainer: { width: '90%', display: 'flex' },
  searchBox: { border: '1px solid #00bcd4', display: 'flex', borderRadius: '2px', height: '34px', justifyContent: 'space-between', backgroundColor: 'white' }
});
var propTypes = {
  isSingleLocation: _react.PropTypes.bool,
  search: _react.PropTypes.func,
  pathBeforeSearch: _react.PropTypes.string,
  companyType: _react.PropTypes.string,
  changeRoute: _react.PropTypes.func,
  searchParams: _react.PropTypes.object,
  updateSearchParams: _react.PropTypes.func
};

var FuzzySearch = function (_Component) {
  _inherits(FuzzySearch, _Component);

  function FuzzySearch(props) {
    _classCallCheck(this, FuzzySearch);

    var _this = _possibleConstructorReturn(this, (FuzzySearch.__proto__ || Object.getPrototypeOf(FuzzySearch)).call(this, props));

    _this.setStateAndDosearch = function (updater) {
      return _this.setState(updater, _this.doSearch);
    };

    _this.doSearch = function () {
      return _this.props.search(_extends({}, _this.props.searchParams, { searchingAllYears: true }, _this.state));
    };

    _this.state = {
      searchInput: props.searchParams.searchInput || '',
      showRateContainers: props.searchParams.showRateContainers || false,
      showArchivedDeleted: props.searchParams.showArchivedDeleted || false
    };
    return _this;
  }

  _createClass(FuzzySearch, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isSingleLocation = _props.isSingleLocation,
          pathBeforeSearch = _props.pathBeforeSearch,
          changeRoute = _props.changeRoute,
          companyType = _props.companyType;

      var showOptions = Boolean(this.state.searchInput && companyType === 'Contractor');
      return _react2.default.createElement(
        'div',
        { className: '' + _aphrodite2.default.css(styles.searchContainer) },
        _react2.default.createElement(
          'div',
          { className: 'fuzzySearch ' + _aphrodite2.default.css(styles.searchBox), style: { width: showOptions ? 'calc(100% - 420px)' : '100%' } },
          _react2.default.createElement(_materialUi.TextField, {
            hintText: 'Search Company, Email' + (isSingleLocation ? '' : ', Property Name') + '...',
            value: this.state.searchInput,
            inputStyle: { bottom: '2px' },
            style: { width: '70%', height: '35px', marginLeft: '4px' },
            hintStyle: { bottom: '6px', fontSize: '13px' },
            onKeyDown: function onKeyDown(e) {
              if (e.keyCode === 13) _this2.doSearch();
            },
            underlineShow: false,
            onChange: function onChange(_, value) {
              return _this2.setState({ searchInput: value });
            }
          }),
          _react2.default.createElement(_materialUi.IconButton, {
            iconClassName: 'tc-icon-close',
            iconStyle: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' },
            style: { padding: '0', top: '4px', height: '34px', display: this.state.searchInput ? 'inline-block' : 'none' },
            onTouchTap: function onTouchTap() {
              _this2.setState({ searchInput: '' });
              changeRoute(pathBeforeSearch || 'recent');
            }
          }),
          _react2.default.createElement(_materialUi.RaisedButton, {
            label: 'Search All Periods',
            labelStyle: { top: '-1px' },
            style: { height: '32px', minWidth: '185px', width: '185px' },
            overlayStyle: { height: '32px' },
            buttonStyle: { height: '32px', lineHeight: '32px' },
            secondary: true,
            onClick: this.doSearch
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '420px', display: showOptions ? 'flex' : 'none', paddingLeft: '1em' }, className: 'flex-center' },
          _react2.default.createElement(_materialUi.Checkbox, {
            label: 'Show Archived or Deleted',
            checked: this.state.showArchivedDeleted,
            labelStyle: { fontSize: '12px' },
            style: { width: '220px' },
            onCheck: function onCheck() {
              return _this2.setStateAndDosearch({ showArchivedDeleted: !_this2.state.showArchivedDeleted });
            }
          }),
          _react2.default.createElement(_materialUi.Checkbox, {
            label: 'Show Workspaces',
            checked: this.state.showRateContainers,
            labelStyle: { fontSize: '12px' },
            style: { width: '200px' },
            onCheck: function onCheck() {
              return _this2.setStateAndDosearch({ showRateContainers: !_this2.state.showRateContainers });
            }
          })
        )
      );
    }
  }]);

  return FuzzySearch;
}(_react.Component);

FuzzySearch.propTypes = propTypes;
var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user,
      contracting = _ref.contracting;
  return {
    companyType: user.getIn(['user', 'type']),
    folders: contracting.contractList.get('folders').toJS(),
    isSingleLocation: user.getIn(['user', 'company', 'oneOrMultiProperties']),
    pathBeforeSearch: contracting.contractList.get('pathBeforeSearch')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(FuzzySearch);

/***/ }),
/* 3402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _folderFilters = __webpack_require__(3403);

var _folderFilters2 = _interopRequireDefault(_folderFilters);

var _reactRedux = __webpack_require__(6);

var _lock = __webpack_require__(578);

var _lock2 = _interopRequireDefault(_lock);

var _upgradeActions = __webpack_require__(611);

var _materialUi = __webpack_require__(3);

var _redDot = __webpack_require__(1056);

var _redDot2 = _interopRequireDefault(_redDot);

var _updateRateConversionStatus = __webpack_require__(2005);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  isSingleLocation: _react.PropTypes.bool,
  companyType: _react.PropTypes.string,
  searchParams: _react.PropTypes.shape({
    companySearchInput: _react.PropTypes.string,
    locationSearchInput: _react.PropTypes.string,
    searchInput: _react.PropTypes.string,
    searchCategory: _react.PropTypes.string,
    stateFilterForBuyer: _react.PropTypes.array,
    stateFilterForSupplier: _react.PropTypes.array,
    sentFilter: _react.PropTypes.array,
    readUnreadFilter: _react.PropTypes.array,
    otherSideRead: _react.PropTypes.array,
    contractTypeFilter: _react.PropTypes.array,
    openAdvanceSearch: _react.PropTypes.bool,
    newActivity: _react.PropTypes.bool,
    showRateContainers: _react.PropTypes.bool,
    showArchivedDeleted: _react.PropTypes.bool,
    searchingAllYears: _react.PropTypes.bool
  }),
  updateProps: _react.PropTypes.func,
  search: _react.PropTypes.func,
  folders: _react.PropTypes.array,
  billingPlan: _react.PropTypes.string,
  openUpgradeFrom: _react.PropTypes.func,
  userId: _react.PropTypes.string
};

var PreciseSearch = function (_Component) {
  _inherits(PreciseSearch, _Component);

  function PreciseSearch(props) {
    _classCallCheck(this, PreciseSearch);

    var _this = _possibleConstructorReturn(this, (PreciseSearch.__proto__ || Object.getPrototypeOf(PreciseSearch)).call(this, props));

    _this.state = props.searchParams;
    return _this;
  }

  _createClass(PreciseSearch, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isSingleLocation = _props.isSingleLocation,
          searchParams = _props.searchParams,
          companyType = _props.companyType,
          search = _props.search,
          folders = _props.folders,
          openUpgradeFrom = _props.openUpgradeFrom;
      var _state = this.state,
          stateFilterForBuyer = _state.stateFilterForBuyer,
          stateFilterForSupplier = _state.stateFilterForSupplier,
          contractTypeFilter = _state.contractTypeFilter,
          rateConversionStatusFilter = _state.rateConversionStatusFilter,
          readUnreadFilter = _state.readUnreadFilter,
          companySearchInput = _state.companySearchInput,
          locationSearchInput = _state.locationSearchInput,
          otherSideRead = _state.otherSideRead;

      var stateFilter = companyType === 'Supplier' ? stateFilterForSupplier : stateFilterForBuyer;
      // const onlySentSelected = (!stateFilter.length || !(stateFilter.length === 1 && stateFilter[0] === 'sent'));
      var describeAllStateFilters = [companyType === 'Supplier' ? { state: 'request' } : null, { state: 'sent', subStates: ['bounced', 'delivered', 'opened'] }, companyType === 'Supplier' ? null : { state: 'received' }, { state: 'accepted' }, { state: 'rejected' }, { state: 'loading' }, { state: 'loaded' }].filter(function (x) {
        return x;
      });
      var isSupplier = companyType === 'Supplier';
      var readUnreadFilterDoesNotApply = function () {
        if (isSupplier) {
          return !_ramda2.default.contains('request', stateFilter);
        }
        return stateFilter.length === 1 && stateFilter[0] === 'sent';
      }();
      return _react2.default.createElement(
        'div',
        { style: { paddingLeft: '24px', display: 'flex', position: 'relative', top: '-8px' } },
        _react2.default.createElement(
          'div',
          { style: { width: '33%', display: 'flex', flexDirection: 'column' } },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex' } },
            _react2.default.createElement(
              'small',
              { style: { width: '120px', color: 'rgba(0, 0, 0, 0.74)', position: 'relative', top: '20px' } },
              'Folder:'
            ),
            _react2.default.createElement(_folderFilters2.default, {
              companyType: companyType,
              searchParams: this.state,
              onChange: function onChange(newParams) {
                return _this2.setState(newParams);
              },
              folders: folders,
              underlineStyle: { borderTopColor: '#00bcd4', margin: 0 },
              style: { width: '150px' },
              labelStyle: { textAlign: 'left', paddingLeft: 0, paddingRight: '12px', fontSize: '12px' },
              iconStyle: { fill: '#00bcd4', width: '30px' }
            })
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'flex' } },
            _react2.default.createElement(
              'small',
              { style: { width: '120px', color: 'rgba(0, 0, 0, 0.74)', position: 'relative', top: '20px' } },
              'Company/Email:'
            ),
            _react2.default.createElement(_materialUi.TextField, {
              id: 'companySearchInput',
              value: companySearchInput,
              style: { width: '150px', fontSize: '12px' },
              underlineStyle: { borderBottomColor: '#00bcd4' },
              onKeyDown: function onKeyDown(e) {
                if (e.keyCode === 13) search(_ramda2.default.merge(_this2.state, { searchingAllYears: searchParams.searchingAllYears }));
              },
              onChange: function onChange(_, value) {
                return _this2.setState({ companySearchInput: value });
              }
            })
          ),
          isSingleLocation ? _react2.default.createElement('span', null) : _react2.default.createElement(
            'div',
            { style: { display: 'flex' } },
            _react2.default.createElement(
              'small',
              { style: { width: '120px', color: 'rgba(0, 0, 0, 0.74)', position: 'relative', top: '20px' } },
              'Property Name:'
            ),
            _react2.default.createElement(_materialUi.TextField, {
              id: 'locationSearchInput',
              value: locationSearchInput,
              style: { width: '150px', fontSize: '12px' },
              underlineStyle: { borderBottomColor: '#00bcd4' },
              onKeyDown: function onKeyDown(e) {
                if (e.keyCode === 13) search(_ramda2.default.merge(_this2.state, { searchingAllYears: searchParams.searchingAllYears }));
              },
              onChange: function onChange(_, value) {
                return _this2.setState({ locationSearchInput: value });
              }
            })
          ),
          companyType === 'Contractor' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_materialUi.Checkbox, {
              label: 'Show Archived or Deleted',
              checked: this.state.showArchivedDeleted,
              labelStyle: { fontSize: '12px' },
              style: { width: '220px' },
              onCheck: function onCheck() {
                return _this2.setState({ showArchivedDeleted: !_this2.state.showArchivedDeleted });
              }
            }),
            _react2.default.createElement(_materialUi.Checkbox, {
              label: 'Show Workspaces',
              checked: this.state.showRateContainers,
              labelStyle: { fontSize: '12px' },
              style: { width: '250px' },
              onCheck: function onCheck() {
                return _this2.setState({ showRateContainers: !_this2.state.showRateContainers });
              }
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '30%', padding: '16px 32px' } },
          _react2.default.createElement(
            'small',
            { style: { width: '120px', color: 'rgba(0, 0, 0, 0.74)', display: 'block', marginBottom: '8px' } },
            'Statuses:'
          ),
          _react2.default.createElement(
            'div',
            null,
            describeAllStateFilters.map(function (obj, i) {
              var onCheck = function onCheck(_, inputChecked) {
                if (obj.subStates) {
                  _this2.setState(_defineProperty({}, obj.state + 'Filter', inputChecked ? obj.subStates : []));
                }
                _this2.setState(_defineProperty({}, 'stateFilterFor' + (isSupplier ? 'Supplier' : 'Buyer'), inputChecked ? _ramda2.default.append(obj.state, stateFilter) : stateFilter.filter(function (str) {
                  return str !== obj.state;
                })));
              };
              var subStateFilter = _this2.state[obj.state + 'Filter'] || [];
              var checked = _ramda2.default.contains(obj.state, stateFilter);
              if (!obj.subStates) {
                return _react2.default.createElement(_materialUi.Checkbox, {
                  checked: checked,
                  key: i,
                  labelStyle: { fontSize: '12px', width: '90px' },
                  label: obj.state,
                  onCheck: onCheck
                });
              }
              return _react2.default.createElement(
                'div',
                { key: i },
                _react2.default.createElement(_materialUi.Checkbox, {
                  checked: checked,
                  labelStyle: { fontSize: '12px', width: '90px' },
                  label: obj.state,
                  onCheck: onCheck
                }),
                _react2.default.createElement(
                  'div',
                  {
                    style: { marginLeft: '16px', display: checked ? 'block' : 'none' },
                    className: _this2.props.billingPlan === 'basic' ? 'hint--top' : '',
                    'aria-label': _this2.props.billingPlan === 'basic' ? 'Upgrade to filter all sent status' : ''
                  },
                  obj.subStates.map(function (subState, subI) {
                    var onCheckSubstate = function onCheckSubstate(_, inputChecked) {
                      _this2.setState(_defineProperty({}, obj.state + 'Filter', inputChecked ? _ramda2.default.append(subState, subStateFilter) : subStateFilter.filter(function (str) {
                        return str !== subState;
                      })));
                    };
                    var subStateChecked = _ramda2.default.contains(subState, subStateFilter);
                    if (_this2.props.billingPlan === 'basic') {
                      return _react2.default.createElement(_materialUi.Checkbox, {
                        key: subI,
                        checked: subStateChecked,
                        checkedIcon: _react2.default.createElement(_lock2.default, { style: { fill: '#FFD700' } }),
                        labelStyle: { fontSize: '12px' },
                        label: subState,
                        onCheck: function onCheck() {
                          return openUpgradeFrom('contractListSentFilters');
                        }
                      });
                    }
                    return _react2.default.createElement(_materialUi.Checkbox, { checked: subStateChecked, key: subI, labelStyle: { fontSize: '12px' }, label: subState, onCheck: onCheckSubstate });
                  })
                )
              );
            })
          ),
          companyType === 'Contractor' && _react2.default.createElement(
            'div',
            { style: { paddingTop: '16px', marginTop: '16px', borderTop: '1px solid #e0e0e0' } },
            _react2.default.createElement(
              'small',
              { style: { width: '220px', color: 'rgba(0, 0, 0, 0.74)', display: 'block', marginBottom: '8px' } },
              'TC Rate Conversion Statuses:'
            ),
            _react2.default.createElement(
              'div',
              null,
              _updateRateConversionStatus.statuses.map(function (status) {
                return _react2.default.createElement(_materialUi.Checkbox, {
                  key: status,
                  labelStyle: { fontSize: '12px' },
                  label: status,
                  checked: _ramda2.default.contains(status, rateConversionStatusFilter),
                  onCheck: function onCheck(_, inputChecked) {
                    return _this2.setState({
                      rateConversionStatusFilter: inputChecked ? _ramda2.default.append(status, rateConversionStatusFilter) : rateConversionStatusFilter.filter(function (str) {
                        return str !== status;
                      })
                    });
                  }
                });
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '37%', paddingTop: '16px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' } },
          companyType === 'Contractor' && _react2.default.createElement(
            'div',
            { style: { marginBottom: '16px', borderBottom: '1px solid #e0e0e0', paddingBottom: '16px' } },
            _react2.default.createElement(
              'small',
              { style: { color: readUnreadFilterDoesNotApply ? 'rgba(0, 0, 0, 0.54)' : 'rgba(0, 0, 0, 0.74)', display: 'block', marginBottom: '8px' } },
              'Contract Type (received rates):'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_materialUi.Checkbox, {
                labelStyle: { fontSize: '12px' },
                label: 'TourConnect Contract Format - New',
                disabled: readUnreadFilterDoesNotApply,
                checked: _ramda2.default.contains('tc-new', contractTypeFilter),
                onCheck: function onCheck(_, inputChecked) {
                  return _this2.setState({ contractTypeFilter: inputChecked ? _ramda2.default.append('tc-new', contractTypeFilter) : contractTypeFilter.filter(function (str) {
                      return str !== 'tc-new';
                    }) });
                }
              }),
              _react2.default.createElement(_materialUi.Checkbox, {
                labelStyle: { fontSize: '12px' },
                label: 'TourConnect Contract Format - Updates',
                disabled: readUnreadFilterDoesNotApply,
                checked: _ramda2.default.contains('tc-updates', contractTypeFilter),
                onCheck: function onCheck(_, inputChecked) {
                  return _this2.setState({ contractTypeFilter: inputChecked ? _ramda2.default.append('tc-updates', contractTypeFilter) : contractTypeFilter.filter(function (str) {
                      return str !== 'tc-updates';
                    }) });
                }
              }),
              _react2.default.createElement(_materialUi.Checkbox, {
                labelStyle: { fontSize: '12px' },
                label: 'External Contract Format - with Files',
                disabled: readUnreadFilterDoesNotApply,
                checked: _ramda2.default.contains('external-files', contractTypeFilter),
                onCheck: function onCheck(_, inputChecked) {
                  return _this2.setState({ contractTypeFilter: inputChecked ? _ramda2.default.append('external-files', contractTypeFilter) : contractTypeFilter.filter(function (str) {
                      return str !== 'external-files';
                    }) });
                }
              }),
              _react2.default.createElement(_materialUi.Checkbox, {
                labelStyle: { fontSize: '12px' },
                label: 'External Contract Format - without Files',
                disabled: readUnreadFilterDoesNotApply,
                checked: _ramda2.default.contains('external-nofiles', contractTypeFilter),
                onCheck: function onCheck(_, inputChecked) {
                  return _this2.setState({ contractTypeFilter: inputChecked ? _ramda2.default.append('external-nofiles', contractTypeFilter) : contractTypeFilter.filter(function (str) {
                      return str !== 'external-nofiles';
                    }) });
                }
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { borderBottom: '1px solid #e0e0e0', paddingBottom: '16px', marginBottom: '16px' } },
            _react2.default.createElement(
              'small',
              { style: { color: readUnreadFilterDoesNotApply ? 'rgba(0, 0, 0, 0.54)' : 'rgba(0, 0, 0, 0.74)', display: 'block', marginBottom: '8px' } },
              'Read/Unread:'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_materialUi.Checkbox, {
                labelStyle: { fontSize: '12px' },
                disabled: readUnreadFilterDoesNotApply,
                label: 'Read ' + (isSupplier ? 'Requests' : 'Received Rates'),
                checked: _ramda2.default.contains('read', readUnreadFilter),
                onCheck: function onCheck(_, inputChecked) {
                  return _this2.setState({ readUnreadFilter: inputChecked ? _ramda2.default.append('read', readUnreadFilter) : readUnreadFilter.filter(function (str) {
                      return str !== 'read';
                    }) });
                }
              }),
              _react2.default.createElement(_materialUi.Checkbox, {
                labelStyle: { fontSize: '12px', fontWeight: 'bold' },
                disabled: readUnreadFilterDoesNotApply,
                label: 'Unread ' + (isSupplier ? 'Requests' : 'Received Rates'),
                checked: _ramda2.default.contains('unread', readUnreadFilter),
                onCheck: function onCheck(_, inputChecked) {
                  return _this2.setState({ readUnreadFilter: inputChecked ? _ramda2.default.append('unread', readUnreadFilter) : readUnreadFilter.filter(function (str) {
                      return str !== 'unread';
                    }) });
                }
              }),
              _react2.default.createElement(_materialUi.Checkbox, {
                labelStyle: { fontSize: '12px' },
                label: 'Viewed / Downloaded Contracts',
                checked: _ramda2.default.contains('viewedDownloaded', otherSideRead || []),
                onCheck: function onCheck(_, inputChecked) {
                  return _this2.setState({ otherSideRead: inputChecked ? _ramda2.default.append('viewedDownloaded', otherSideRead) : otherSideRead.filter(function (str) {
                      return str !== 'viewedDownloaded';
                    }) });
                }
              }),
              _react2.default.createElement(_materialUi.Checkbox, {
                labelStyle: { fontSize: '12px' },
                label: 'Not Viewed / Downloaded Contracts',
                checked: _ramda2.default.contains('notViewedDownloaded', otherSideRead || []),
                onCheck: function onCheck(_, inputChecked) {
                  return _this2.setState({ otherSideRead: inputChecked ? _ramda2.default.append('notViewedDownloaded', otherSideRead) : otherSideRead.filter(function (str) {
                      return str !== 'notViewedDownloaded';
                    }) });
                }
              })
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_materialUi.Checkbox, {
              labelStyle: { fontSize: '12px' },
              label: _react2.default.createElement(
                'span',
                { style: { display: 'flex', alignItems: 'center' } },
                'New Activity ',
                _react2.default.createElement(_redDot2.default, { style: { left: '3px', top: '0px' } })
              ),
              checked: this.state.newActivity,
              onCheck: function onCheck(_, inputChecked) {
                return _this2.setState({ newActivity: inputChecked });
              }
            })
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center', marginTop: '16px', width: '100%', flexDirection: 'row-reverse' } },
            _react2.default.createElement(_materialUi.RaisedButton, {
              label: 'Search All Periods',
              labelStyle: { top: '4px' },
              style: { minWidth: '185px', width: '185px', marginLeft: '8px', height: '33px' },
              secondary: true,
              onTouchTap: function onTouchTap() {
                return search(_ramda2.default.merge(_this2.state, { searchingAllYears: true }));
              }
            })
          )
        )
      );
    }
  }]);

  return PreciseSearch;
}(_react.Component);

PreciseSearch.propTypes = propTypes;
var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user,
      contracting = _ref.contracting;
  return {
    companyType: user.getIn(['user', 'type']),
    userId: user.get('id'),
    billingPlan: user.get('billingPlan'),
    folders: contracting.contractList.get('folders').toJS(),
    isSingleLocation: user.getIn(['user', 'company', 'oneOrMultiProperties'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { openUpgradeFrom: _upgradeActions.openUpgradeFrom })(PreciseSearch);

/***/ }),
/* 3403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _selectAll = __webpack_require__(2004);

var _selectAll2 = _interopRequireDefault(_selectAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FolderFilters = function FolderFilters(_ref) {
  var companyType = _ref.companyType,
      searchParams = _ref.searchParams,
      onChange = _ref.onChange,
      folders = _ref.folders,
      styles = _objectWithoutProperties(_ref, ['companyType', 'searchParams', 'onChange', 'folders']);

  var defaultSections = companyType === 'Contractor' ? [{
    primaryText: 'Received Rates',
    queryParam: 'recent',
    icon: 'tc-icon-move_to_inbox'
  }, {
    primaryText: 'Requests Sent',
    queryParam: 'sent',
    icon: 'tc-icon-near_me'
  }] : [{
    primaryText: 'Requests',
    queryParam: 'recent',
    icon: 'tc-icon-move_to_inbox'
  }, {
    primaryText: 'Rates Sent',
    queryParam: 'sent',
    icon: 'tc-icon-near_me'
  }];
  var selectAFolder = function selectAFolder(value) {
    return function () {
      return onChange(_ramda2.default.merge(searchParams, { searchCategory: value, isFolder: true }));
    };
  };
  var selectDefault = function selectDefault(_, index, value) {
    return onChange(_ramda2.default.merge(searchParams, { searchCategory: value }));
  };
  return _react2.default.createElement(
    _materialUi.DropDownMenu,
    _extends({
      value: searchParams.searchCategory,
      onChange: selectDefault
    }, styles),
    folders && folders.length ? folders.map(function (folder, i) {
      return _react2.default.createElement(_materialUi.MenuItem, {
        key: 'folder' + i,
        primaryText: folder,
        value: folder,
        onTouchTap: selectAFolder(folder),
        label: (folder || '').substring(0, 12),
        leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-folder_open' })
      });
    }) : _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'You don\'t have any folders.', disabled: true })
  );
};

exports.default = FolderFilters;

/***/ }),
/* 3404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageTune = function ImageTune(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z' })
  );
};
ImageTune = (0, _pure2.default)(ImageTune);
ImageTune.displayName = 'ImageTune';
ImageTune.muiName = 'SvgIcon';

exports.default = ImageTune;

/***/ }),
/* 3405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FreeContractForContractorDialog = function (_Component) {
  _inherits(FreeContractForContractorDialog, _Component);

  function FreeContractForContractorDialog() {
    _classCallCheck(this, FreeContractForContractorDialog);

    return _possibleConstructorReturn(this, (FreeContractForContractorDialog.__proto__ || Object.getPrototypeOf(FreeContractForContractorDialog)).apply(this, arguments));
  }

  _createClass(FreeContractForContractorDialog, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.freeContractDialog.get('open') || this.props.freeContractDialog.get('open');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          freeContractDialog = _props.freeContractDialog,
          freeContractsLeft = _props.freeContractsLeft,
          closeDialog = _props.closeDialog,
          updateFreeContractsUsed = _props.updateFreeContractsUsed;

      var open = freeContractDialog.get('open');
      var contractUrl = freeContractDialog.get('url');
      var contractId = freeContractDialog.get('contractId');
      var goToUpgradePage = function goToUpgradePage() {
        return Promise.resolve(closeDialog()).then(function (_) {
          return _this2.context.router.push('/billing/free-trial-used');
        });
      };
      var useFreeContract = function useFreeContract(url) {
        return Promise.resolve(updateFreeContractsUsed(contractId)).then(function (_) {
          return _this2.context.router.push(url);
        });
      };
      var message = freeContractsLeft ? 'You have ' + freeContractsLeft + ' free contract' + (freeContractsLeft === 1 ? 's' : '') + ' left.\n                     To continue you can use one of your free trial contracts.' : 'You have used all of the contracts in your free trial. You can continue to download as many contracts as you wish;\n      however to access the full benefits of TourConnect, like online contract versions, tracking contract changes, or supplier messaging, please upgrade to the Connected Plan.';
      var dialogActions = [_react2.default.createElement(_materialUi.FlatButton, {
        label: 'Cancel',
        onTouchTap: closeDialog,
        secondary: true
      }), _react2.default.createElement(_materialUi.FlatButton, {
        label: freeContractsLeft ? 'Use Free Contract' : 'Upgrade',
        onTouchTap: freeContractsLeft ? function () {
          return useFreeContract(contractUrl);
        } : goToUpgradePage,
        primary: true
      })];

      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          title: freeContractsLeft ? 'Use Free Contract to Continue' : 'Upgrade to Continue',
          actions: dialogActions,
          open: open,
          contentStyle: { margin: '0 auto', width: '350px', verticalAlign: 'center' },
          bodyStyle: { paddingBottom: '12px', paddingTop: '12px' },
          actionsContainerStyle: { paddingTop: '0px' }
        },
        message
      );
    }
  }]);

  return FreeContractForContractorDialog;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting,
      user = _ref.user;
  return {
    freeContractDialog: contracting.freeContractDialog,
    freeContractsLeft: user.get('freeContractsLeft')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeDialog: function closeDialog() {
      return dispatch({ type: 'CLOSE_FREE_CONTRACT_DIALOG' });
    },
    updateFreeContractsUsed: function updateFreeContractsUsed(contractId) {
      return dispatch({ type: 'USED_AS_FREE_BY_CONTRACTOR', payload: { contractId: contractId } });
    }
  };
};

FreeContractForContractorDialog.propTypes = {
  closeDialog: _react.PropTypes.func,
  createFolder: _react.PropTypes.func,
  handleAddFolderInput: _react.PropTypes.func,
  updateFreeContractsUsed: _react.PropTypes.func,
  freeContractDialog: _react.PropTypes.object,
  freeContractsLeft: _react.PropTypes.number,
  open: _react.PropTypes.bool,
  input: _react.PropTypes.string
};
FreeContractForContractorDialog.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FreeContractForContractorDialog);

/***/ }),
/* 3406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _messageBox = __webpack_require__(1137);

var _messageBox2 = _interopRequireDefault(_messageBox);

var _contractListActions = __webpack_require__(563);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var propTypes = {
  open: _react.PropTypes.bool,
  partners: _react.PropTypes.array,
  onRequestClose: _react.PropTypes.func,
  sending: _react.PropTypes.bool,
  bulkResend: _react.PropTypes.func,
  customizedMessage: _react.PropTypes.string,
  companyType: _react.PropTypes.string,
  updateProps: _react.PropTypes.func,
  BCCToSelf: _react.PropTypes.bool,
  changeEmail: _react.PropTypes.bool,
  sent: _react.PropTypes.bool,
  showAllPartners: _react.PropTypes.bool,
  subject: _react.PropTypes.string
};

var BulkResendDialog = function (_Component) {
  _inherits(BulkResendDialog, _Component);

  function BulkResendDialog() {
    _classCallCheck(this, BulkResendDialog);

    return _possibleConstructorReturn(this, (BulkResendDialog.__proto__ || Object.getPrototypeOf(BulkResendDialog)).apply(this, arguments));
  }

  _createClass(BulkResendDialog, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          partners = _props.partners,
          onRequestClose = _props.onRequestClose,
          sending = _props.sending,
          bulkResend = _props.bulkResend,
          customizedMessage = _props.customizedMessage,
          updateProps = _props.updateProps,
          changeEmail = _props.changeEmail,
          sent = _props.sent,
          showAllPartners = _props.showAllPartners,
          subject = _props.subject;

      var isSupplier = this.props.companyType === 'Supplier';
      if (isNilOrEmpty(partners)) return _react2.default.createElement('div', null);
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          open: this.props.open,
          autoScrollBodyContent: true,
          title: 'Resend ' + (isSupplier ? 'Contracts' : 'Requests'),
          titleStyle: { backgroundColor: '#00BCD4', color: '#ffffff', fontSize: '18px', padding: '2%' },
          actions: [_react2.default.createElement(_flatButtonWithLoader2.default, { primary: true, label: sent ? 'Close' : 'Cancel', loader: sending, onTouchTap: onRequestClose }), _react2.default.createElement(_flatButtonWithLoader2.default, { disabled: sent, secondary: true, label: 'Resend', loader: sending, onTouchTap: bulkResend })]
        },
        sent ? _react2.default.createElement(
          'div',
          { style: { marginTop: '20px' } },
          'Congratulations, we\'ve resent your ',
          isSupplier ? 'contracts' : 'requests',
          '!'
        ) : _react2.default.createElement(
          'div',
          { style: { paddingTop: '8px' } },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'space-between' } },
            _react2.default.createElement(
              'div',
              { style: { width: '80%' } },
              partners.slice(0, showAllPartners || partners.length < 6 ? partners.length : 5).map(function (partner, i) {
                var noOfContracts = _ramda2.default.pathOr(1, ['contractIds', 'length'], partner);
                if (changeEmail && !partner.companyId) {
                  return _react2.default.createElement('input', {
                    key: i,
                    style: { width: '350px', marginBottom: '8px' },
                    value: partner.newEmail,
                    onChange: function onChange(_ref) {
                      var value = _ref.target.value;
                      return updateProps({
                        partners: _ramda2.default.update(i, _ramda2.default.merge(partner, { newEmail: value }), partners)
                      });
                    }
                  });
                }
                return _react2.default.createElement(
                  _materialUi.Chip,
                  { key: i, style: { marginBottom: '8px' } },
                  partner.avatar ? _react2.default.createElement(_materialUi.Avatar, { src: partner.avatar }) : _react2.default.createElement(
                    _materialUi.Avatar,
                    null,
                    _ramda2.default.head(partner.name || '')
                  ),
                  partner.name,
                  '\xA0(',
                  noOfContracts,
                  ' ',
                  (0, _pluralize2.default)(isSupplier ? 'contract' : 'request', noOfContracts),
                  ')'
                );
              }),
              partners.length >= 6 ? _react2.default.createElement(
                'a',
                { style: { cursor: 'pointer', display: 'block' }, onClick: function onClick() {
                    return updateProps({ showAllPartners: !showAllPartners });
                  } },
                showAllPartners ? 'Show Less' : 'Show All ' + partners.length + ' Partners'
              ) : _react2.default.createElement('a', null)
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'label',
              null,
              'Subject:'
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('input', {
              value: subject || '',
              style: { width: '100%' },
              onChange: function onChange(e) {
                return updateProps({ subject: e.target.value });
              }
            })
          ),
          _react2.default.createElement(
            'label',
            null,
            'Message:'
          ),
          _react2.default.createElement(_messageBox2.default, {
            value: customizedMessage,
            onChange: function onChange(value) {
              return updateProps({ customizedMessage: value });
            },
            placeholder: 'You can enter a message here.'
          })
        )
      );
    }
  }]);

  return BulkResendDialog;
}(_react.Component);

;

BulkResendDialog.propTypes = propTypes;
var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting,
      user = _ref2.user;
  return _extends({
    companyType: user.getIn(['user', 'type'])
  }, contracting.contractList.get('bulkResendDialog').toJS());
};
var mapActionToProps = function mapActionToProps(dispatch) {
  return {
    onRequestClose: function onRequestClose() {
      return dispatch((0, _contractListActions.closeBulkResendDialog)());
    },
    bulkResend: function bulkResend() {
      return dispatch(_contractListActions.bulkResend.apply(undefined, arguments));
    },
    updateProps: function updateProps() {
      return dispatch(_contractListActions.updateBulkResendDialogProps.apply(undefined, arguments));
    }
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapActionToProps)(BulkResendDialog);

/***/ }),
/* 3407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManageFolderDialog = function ManageFolderDialog(_ref) {
  var manageFolderDialogOpen = _ref.manageFolderDialogOpen,
      folderAction = _ref.folderAction,
      hoveringOverContractId = _ref.hoveringOverContractId,
      folders = _ref.folders,
      selectedContracts = _ref.selectedContracts,
      newFolderName = _ref.newFolderName,
      newFolderErrorText = _ref.newFolderErrorText,
      createFolderAndAssign = _ref.createFolderAndAssign,
      updateProps = _ref.updateProps,
      selectedFolders = _ref.selectedFolders,
      contractFolders = _ref.contractFolders,
      companyType = _ref.companyType,
      hideContractInFolder = _ref.hideContractInFolder;

  var isMoveOut = folderAction === 'moveOut';
  var bulkMovingContractsOut = selectedContracts && selectedContracts.length && isMoveOut;
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: manageFolderDialogOpen,
      contentStyle: { width: '400px' },
      onRequestClose: function onRequestClose() {
        return updateProps({ manageFolderDialogOpen: false, newFolderName: '', newFolderErrorText: '' });
      },
      title: _ramda2.default.call(_ramda2.default.cond([[function () {
        return bulkMovingContractsOut;
      }, _ramda2.default.always('Move ' + selectedContracts.length + ' contracts out of ' + selectedFolders[0])], [function () {
        return isMoveOut;
      }, _ramda2.default.always('Move out of folders')], [_ramda2.default.T, _ramda2.default.always('Assign contracts to folders')]])),
      actions: [_react2.default.createElement(_materialUi.FlatButton, { label: 'cancel', onTouchTap: function onTouchTap() {
          return updateProps({ manageFolderDialogOpen: false, newFolderName: '', newFolderErrorText: '', selectedFolders: [] });
        } }), _react2.default.createElement(_materialUi.FlatButton, { label: 'save', disabled: !newFolderName && _ramda2.default.propOr(0, 'length', selectedFolders) === 0, secondary: true, onTouchTap: function onTouchTap() {
          if (_ramda2.default.contains(newFolderName, folders)) updateProps({ newFolderErrorText: 'Folder Exists' });else {
            createFolderAndAssign({
              folderNames: newFolderName ? _ramda2.default.append(newFolderName, selectedFolders) : selectedFolders,
              contractIds: selectedContracts.length ? selectedContracts : [hoveringOverContractId],
              newFolderToCreate: newFolderName,
              hideContractInFolder: hideContractInFolder,
              moveOutOfFolders: isMoveOut
            });
            updateProps({ manageFolderDialogOpen: false, newFolderName: '', newFolderErrorText: '', folders: newFolderName ? _ramda2.default.append(newFolderName, folders) : folders, selectedFolders: [] });
          }
        }
      })]
    },
    bulkMovingContractsOut ? _react2.default.createElement('div', null) : _react2.default.createElement(
      'div',
      null,
      isMoveOut && _react2.default.createElement(
        'div',
        { style: { marginBottom: '24px' } },
        'Please select the folder(s) that you want to move your contract out of.'
      ),
      (isMoveOut ? contractFolders : folders).map(function (folder, folderIndex) {
        return _react2.default.createElement(_materialUi.Checkbox, {
          checked: _ramda2.default.contains(folder, selectedFolders),
          labelPosition: 'right',
          label: folder,
          key: folderIndex,
          onCheck: function onCheck(_, checked) {
            return updateProps({ selectedFolders: !checked ? _ramda2.default.reject(_ramda2.default.equals(folder), selectedFolders) : _ramda2.default.uniq(_ramda2.default.append(folder, selectedFolders)) });
          }
        });
      }),
      _react2.default.createElement(
        'div',
        { style: { display: folderAction === 'moveOut' ? 'none' : 'flex', alignItems: 'center' } },
        _react2.default.createElement(_materialUi.Checkbox, {
          style: { width: '40px' },
          checked: Boolean(newFolderName),
          onCheck: function onCheck() {
            return updateProps({ newFolderName: '', newFolderErrorText: '' });
          }
        }),
        _react2.default.createElement(_materialUi.TextField, { className: 'create-folder-input', id: 'create-folder-input', hintText: 'New Folder', value: newFolderName, errorText: newFolderErrorText, autoFocus: true, onChange: function onChange(_, val) {
            return updateProps({ newFolderName: val, newFolderErrorText: '' });
          } })
      ),
      _react2.default.createElement(
        'div',
        {
          style: { borderTop: '1px solid #e0e0e0', paddingTop: '12px', marginTop: '12px' }
        },
        _react2.default.createElement(
          'label',
          null,
          'Folder Setting:'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'small',
          null,
          'Making changes here affect all contracts in folders.'
        ),
        _react2.default.createElement(_materialUi.Checkbox, {
          style: { marginTop: '12px' },
          label: companyType === 'Contractor' ? 'Hide contracts from Received Rates or Requests Sent' : 'Hide contracts from Requests or Rates Sent',
          checked: hideContractInFolder,
          onCheck: function onCheck() {
            return updateProps({ hideContractInFolder: !hideContractInFolder });
          }
        })
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting,
      user = _ref2.user;
  return {
    companyType: user.getIn(['company', 'companyType']),
    hideContractInFolder: contracting.contractList.get('hideContractInFolder'),
    selectedFolders: contracting.contractList.get('selectedFolders').toJS(),
    folders: contracting.contractList.get('folders').toJS(),
    hoveringOverContractId: contracting.contractList.get('hoveringOverContractId'),
    selectedContracts: contracting.contractList.get('selectedContracts').toJS(),
    manageFolderDialogOpen: contracting.contractList.get('manageFolderDialogOpen'),
    newFolderName: contracting.contractList.get('newFolderName'),
    newFolderErrorText: contracting.contractList.get('newFolderErrorText'),
    folderAction: contracting.contractList.get('folderAction'),
    contractFolders: contracting.contractList.toJS().contractFolders
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ManageFolderDialog);

/***/ }),
/* 3408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _contractingPeriodsSelection = __webpack_require__(1961);

var _contractingPeriodsSelection2 = _interopRequireDefault(_contractingPeriodsSelection);

var _RateType = __webpack_require__(1257);

var _RateType2 = _interopRequireDefault(_RateType);

var _expandLess = __webpack_require__(1348);

var _expandLess2 = _interopRequireDefault(_expandLess);

var _smallButtons = __webpack_require__(94);

var _modeEdit = __webpack_require__(1268);

var _modeEdit2 = _interopRequireDefault(_modeEdit);

var _selectLocationsProducts = __webpack_require__(3409);

var _selectLocationsProducts2 = _interopRequireDefault(_selectLocationsProducts);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _immutable = __webpack_require__(26);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// How many cities do you operate in?
// We operate in one city/region.  We operate in multiple cities/regions.
// How many properties do you own/manage?
// We own/manage one property.    We own/manage multiple properties.
exports.default = function (props) {
  var newDraftStartDate = props.newDraftStartDate,
      newDraftEndDate = props.newDraftEndDate,
      templateName = props.templateName,
      draftRateType = props.draftRateType,
      draftCommissionPercentage = props.draftCommissionPercentage,
      draftNettCommission = props.draftNettCommission,
      oneOrMulti = props.oneOrMulti,
      _props$locations = props.locations,
      locations = _props$locations === undefined ? [] : _props$locations,
      updateProps = props.updateProps,
      datesInEditMode = props.datesInEditMode;

  var onClickEditDates = function onClickEditDates() {
    return updateProps({ datesInEditMode: true });
  };
  var minimize = function minimize() {
    return updateProps({ datesInEditMode: false });
  };
  return _react2.default.createElement(
    'div',
    { style: { marginTop: '30px' } },
    _react2.default.createElement(
      'div',
      { style: { margin: '0.5em 0 1em 0', width: '480px' }, className: 'flex-center' },
      _react2.default.createElement(
        'b',
        null,
        'Contracting Period:'
      ),
      _react2.default.createElement(
        'span',
        null,
        '\xA0\xA0\xA0',
        _moment2.default.utc(new Date(newDraftStartDate)).format('MMM DD YYYY'),
        ' - ',
        _moment2.default.utc(new Date(newDraftEndDate)).format('MMM DD YYYY')
      ),
      '\xA0\xA0\xA0',
      datesInEditMode ? _react2.default.createElement(_smallButtons.JiraFlatButton, {
        icon: _react2.default.createElement(_expandLess2.default, null),
        label: 'Minimize',
        onClick: minimize
      }) : _react2.default.createElement(_smallButtons.JiraFlatButton, { icon: _react2.default.createElement(_modeEdit2.default, null), onClick: onClickEditDates, label: 'Edit' })
    ),
    Boolean(datesInEditMode) && _react2.default.createElement(
      'div',
      {
        style: {
          backgroundColor: '#fafafa',
          borderRadius: '5px',
          padding: '8px 16px',
          border: '1px solid #e0e0e0',
          marginBottom: '16px'
        }
      },
      _react2.default.createElement(_contractingPeriodsSelection2.default, {
        required: true,
        startDate: newDraftStartDate,
        endDate: newDraftEndDate,
        onChange: function onChange(period) {
          return updateProps({ newDraftStartDate: period.startDate, newDraftEndDate: period.endDate, createDraftError: '' });
        }
      })
    ),
    _react2.default.createElement(
      'label',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Please select a rate type:'
      )
    ),
    _react2.default.createElement(_RateType2.default, {
      rateType: draftRateType,
      commissionPercentage: draftCommissionPercentage,
      nettCommission: draftNettCommission,
      updateRateType: function updateRateType(value) {
        return updateProps({ draftRateType: value });
      },
      updateCommission: function updateCommission(value) {
        return updateProps({ draftCommissionPercentage: value });
      },
      updateNettCommission: function updateNettCommission(value) {
        return updateProps({ draftNettCommission: value });
      }
    }),
    _react2.default.createElement(
      'div',
      { style: { marginTop: '16px' } },
      _react2.default.createElement(_selectLocationsProducts2.default, {
        style: { width: '80%', marginTop: '16px' },
        hasAccessToCreateLoc: true,
        locations: locations,
        updateProps: updateProps,
        checkAllLocations: function checkAllLocations(checked) {
          var updatedLocations = locations.map(function (loc) {
            return _ramda2.default.merge(loc, {
              checked: checked,
              products: loc.products.map(_ramda2.default.merge(_ramda2.default.__, { checked: checked }))
            });
          });
          updateProps({ locations: updatedLocations, createDraftError: '' });
        },
        checkLocation: function checkLocation(locationIndex, checked) {
          var updatedLocations = (0, _immutable.fromJS)(locations).setIn([locationIndex, 'checked'], checked).updateIn([locationIndex, 'products'], function (products) {
            return products.map(function (product) {
              return product.set('checked', checked);
            });
          }).toJS();
          updateProps({ locations: updatedLocations, createDraftError: '' });
        },
        checkProduct: function checkProduct(locationIndex, productIndex, checked) {
          var updatedLocations = (0, _immutable.fromJS)(locations).setIn([locationIndex, 'products', productIndex, 'checked'], checked).toJS();
          updateProps({ locations: updatedLocations, createDraftError: '' });
        }
      })
    )
  );
};

/***/ }),
/* 3409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _immutable = __webpack_require__(26);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var propTypes = {
  updateProps: _react.PropTypes.func,
  checkLocation: _react.PropTypes.func,
  checkAllLocations: _react.PropTypes.func,
  checkProduct: _react.PropTypes.func,
  isAccom: _react.PropTypes.bool,
  isSingleLoc: _react.PropTypes.bool,
  hasAccessToCreateLoc: _react.PropTypes.bool,
  style: _react.PropTypes.object,
  locations: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    locationId: _react.PropTypes.string,
    name: _react.PropTypes.string,
    contactInfoComplete: _react.PropTypes.bool,
    contactInfo: _react.PropTypes.shape({
      address: _react.PropTypes.shape({
        postal_code: _react.PropTypes.string,
        country: _react.PropTypes.string,
        address_1: _react.PropTypes.string,
        address_2: _react.PropTypes.string,
        city: _react.PropTypes.string,
        state: _react.PropTypes.string
      }),
      phone: _react.PropTypes.string,
      firstName: _react.PropTypes.string,
      lastName: _react.PropTypes.string
    }),
    products: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      productId: _react.PropTypes.string,
      name: _react.PropTypes.string,
      checked: _react.PropTypes.bool
    })),
    access: _react.PropTypes.arrayOf(_react.PropTypes.string),
    checked: _react.PropTypes.bool
  })).isRequired
};

var SelectLocationsProducts = function (_Component) {
  _inherits(SelectLocationsProducts, _Component);

  function SelectLocationsProducts(props) {
    _classCallCheck(this, SelectLocationsProducts);

    var _this = _possibleConstructorReturn(this, (SelectLocationsProducts.__proto__ || Object.getPrototypeOf(SelectLocationsProducts)).call(this, props));

    _this.toToggleShowTF = function () {
      return _this.setState({ showCreateLocTF: !_this.state.showCreateLocTF });
    };

    _this.state = {
      showCreateLocTF: !props.isSingleLoc
    };
    return _this;
  }

  _createClass(SelectLocationsProducts, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          updateProps = _props.updateProps,
          checkLocation = _props.checkLocation,
          checkAllLocations = _props.checkAllLocations,
          checkProduct = _props.checkProduct,
          isAccom = _props.isAccom,
          isSingleLoc = _props.isSingleLoc,
          hasAccessToCreateLoc = _props.hasAccessToCreateLoc,
          style = _props.style,
          locations = _props.locations;


      var containerStyle = _extends({
        borderRadius: '2px',
        border: '1px solid #e0e0e0'
      }, style);
      var selectedLocs = _ramda2.default.filter(_ramda2.default.both(_ramda2.default.propEq('checked', true), function (loc) {
        return loc.name;
      }), locations || []);
      var allChecked = _ramda2.default.all(_ramda2.default.either(_ramda2.default.propEq('checked', true), function (loc) {
        return !loc.name;
      }))(locations || []);

      var updateLocationProps = _ramda2.default.curry(function (locationIndex, updater) {
        var immutableNewLocs = (0, _immutable.fromJS)(locations).update(locationIndex, function (location) {
          return location.merge((0, _immutable.fromJS)(updater));
        });
        updateProps({ locations: immutableNewLocs.toJS() });
      });

      if (isSingleLoc) {
        return _react2.default.createElement('div', null);
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Please select the properties/locations you would like to create templates for:'
          )
        ),
        ' ',
        _react2.default.createElement(
          'span',
          { style: { color: 'red' } },
          '* Required'
        ),
        _react2.default.createElement(
          'div',
          { style: containerStyle },
          locations && locations.length > 1 ? _react2.default.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center' } },
            _react2.default.createElement(_materialUi.Checkbox, {
              label: 'Select All',
              checked: allChecked,
              disabled: locations.some(function (loc) {
                return loc.locationId && !_ramda2.default.contains('write', loc.access || []);
              }),
              style: { marginTop: '8px', fontWeight: 'bold', width: '50%' },
              onCheck: function onCheck() {
                return checkAllLocations(!allChecked);
              }
            }),
            _react2.default.createElement(
              'span',
              null,
              selectedLocs.length,
              ' property(s)/location(s) selected'
            )
          ) : _react2.default.createElement('span', null),
          locations.map(function (location, locationIndex) {
            var numProductsChecked = location.products ? location.products.filter(_ramda2.default.prop('checked')).length : 0;
            if (location.locationId) {
              return _react2.default.createElement(
                _materialUi.Card,
                {
                  key: location.locationId,
                  style: { boxShadow: '0' }
                },
                _react2.default.createElement(
                  _materialUi.CardHeader,
                  {
                    actAsExpander: true,
                    showExpandableButton: !isNilOrEmpty(location.products),
                    style: { fontWeight: 'normal', padding: '8px 8px 8px 16px', height: '48px' }
                  },
                  _react2.default.createElement(_materialUi.Checkbox, {
                    label: _react2.default.createElement(
                      'div',
                      { style: { display: 'flex', justifyContent: 'space-between' } },
                      location.name,
                      !isNilOrEmpty(location.products) && _react2.default.createElement(
                        'small',
                        null,
                        numProductsChecked + ' ' + (0, _pluralize2.default)('products', numProductsChecked) + ' selected'
                      )
                    ),
                    disabled: !_ramda2.default.contains('write', location.access),
                    checked: location.checked,
                    labelStyle: { textOverflow: 'ellipsis', overflowX: 'hidden', whiteSpace: 'nowrap' },
                    style: { bottom: '16px', width: '80%' },
                    onCheck: function onCheck() {
                      return checkLocation(locationIndex, !location.checked);
                    }
                  })
                ),
                !isNilOrEmpty(location.products) && _react2.default.createElement(
                  _materialUi.CardText,
                  { expandable: true, style: { paddingLeft: '52px', marginBottom: '12px', padding: '8px 8px 8px 16px' } },
                  location.products.map(function (product, productIndex) {
                    return _react2.default.createElement(_materialUi.Checkbox, { key: productIndex, label: product.name, checked: product.checked, onCheck: function onCheck() {
                        return checkProduct(locationIndex, productIndex, !product.checked);
                      } });
                  })
                )
              );
            }
            var duplicateLocName = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.any(_ramda2.default.compose(_ramda2.default.lt(1), _ramda2.default.length)), _ramda2.default.values, _ramda2.default.groupBy(_ramda2.default.prop('name'))), locations);
            return _react2.default.createElement(
              'div',
              {
                key: 'newlocName' + locationIndex
              },
              _react2.default.createElement(
                'div',
                {
                  style: { fontWeight: 'normal', padding: '8px 8px 8px 16px', height: '48px', display: 'flex', alignItems: 'center' }
                },
                _react2.default.createElement(_materialUi.Checkbox, {
                  checked: Boolean(location.name) || locations.length === 1,
                  disabled: !Boolean(location.name),
                  style: { width: '44px' },
                  onCheck: function onCheck() {
                    updateLocationProps(locationIndex, { name: '', products: [] });
                  }
                }),
                _react2.default.createElement(_materialUi.TextField, {
                  id: 'newlocName' + locationIndex,
                  defaultValue: location.name,
                  hintText: 'Enter a new ' + (isAccom ? 'property' : 'location') + ' name here...',
                  errorText: duplicateLocName ? 'Duplicate with another ' + (isAccom ? 'property' : 'location') : '',
                  onChange: function onChange(_, val) {
                    updateLocationProps(locationIndex, { name: val, checked: Boolean(val) });
                  }
                })
              )
            );
          }),
          !isSingleLoc && _ramda2.default.last(locations).name && _react2.default.createElement(
            'div',
            {
              style: { margin: '12px 0 18px 18px' },
              className: 'add-item-card-flex',
              onClick: function onClick() {
                updateProps({ locations: _ramda2.default.append({ name: '', products: [] }, locations) });
              }
            },
            _react2.default.createElement(
              'div',
              { style: { border: '1px dashed #00bcd4', height: '20px', width: '20px', display: 'inline-block' } },
              _react2.default.createElement(_materialUi.FontIcon, { style: { verticalAlign: 'middle', color: '#00bcd4', fontSize: '18px', marginTop: '-5px' }, className: 'tc-icon-add' })
            ),
            _react2.default.createElement(
              'span',
              { style: { marginLeft: '18px', color: '#00bcd4', display: 'inline-block', verticalAlign: 'middle' } },
              'Create a new ' + (isAccom ? 'property' : 'location')
            )
          )
        )
      );
    }
  }]);

  return SelectLocationsProducts;
}(_react.Component);

SelectLocationsProducts.propTypes = propTypes;

exports.default = SelectLocationsProducts;

/***/ }),
/* 3410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.priorities = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _contractingUtils = __webpack_require__(124);

var _flatDropDownMenu = __webpack_require__(494);

var _flatDropDownMenu2 = _interopRequireDefault(_flatDropDownMenu);

var _editButton = __webpack_require__(210);

var _editButton2 = _interopRequireDefault(_editButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var priorities = exports.priorities = ['Highest', 'High', 'Medium', 'Low', 'Lowest'];

var UpdateRateConversionSetting = function (_Component) {
  _inherits(UpdateRateConversionSetting, _Component);

  function UpdateRateConversionSetting() {
    _classCallCheck(this, UpdateRateConversionSetting);

    var _this = _possibleConstructorReturn(this, (UpdateRateConversionSetting.__proto__ || Object.getPrototypeOf(UpdateRateConversionSetting)).call(this));

    _this.updateRCSetting = function (newsetting) {
      return function () {
        var _this$props = _this.props,
            contractId = _this$props.contractId,
            updateRCSetting = _this$props.updateRCSetting;

        updateRCSetting({ contractId: contractId, updater: { rateConversionSetting: newsetting } });
      };
    };

    return _this;
  }

  _createClass(UpdateRateConversionSetting, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          setting = _props.setting,
          button = _props.button;

      return _react2.default.createElement(
        _flatDropDownMenu2.default,
        {
          button: button || _react2.default.createElement(_editButton2.default, null)
        },
        ['opt-in', 'opt-out'].map(function (str) {
          return _react2.default.createElement(_materialUi.MenuItem, {
            key: str,
            primaryText: str === 'opt-in' ? 'Yes' : 'No',
            disabled: str === setting,
            onClick: _this2.updateRCSetting(str)
          });
        })
      );
    }
  }]);

  return UpdateRateConversionSetting;
}(_react.Component);

UpdateRateConversionSetting.propTypes = {
  updateRCSetting: _react.PropTypes.func,
  contractId: _react.PropTypes.string,
  setting: _react.PropTypes.string,
  button: _react.PropTypes.node
};

exports.default = (0, _reactRedux.connect)(null, {
  updateRCSetting: function updateRCSetting(payload) {
    return { type: '[contract-request] UPDATE_RATE_CONVERSION_SETTING', payload: payload };
  }
})(UpdateRateConversionSetting);

/***/ }),
/* 3411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _termsCriteriaNode = __webpack_require__(1264);

var _termsCriteriaNode2 = _interopRequireDefault(_termsCriteriaNode);

var _billingInfoNode = __webpack_require__(1265);

var _billingInfoNode2 = _interopRequireDefault(_billingInfoNode);

var _policiesNode = __webpack_require__(1561);

var _policiesNode2 = _interopRequireDefault(_policiesNode);

var _checkinout = __webpack_require__(1267);

var _checkinout2 = _interopRequireDefault(_checkinout);

var _scrollToElement = __webpack_require__(859);

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _contractActivitiesProductsActions = __webpack_require__(493);

var _dialogConstants = __webpack_require__(616);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  getContractDetails: _react2.default.PropTypes.func,
  params: _react2.default.PropTypes.object,
  supplierInfo: _react2.default.PropTypes.object,
  billingInformation: _react2.default.PropTypes.object,
  locationPolicy: _react2.default.PropTypes.array,
  openAddEditContractDialog: _react2.default.PropTypes.func,
  supplierEditable: _react2.default.PropTypes.bool,
  checkIn: _react2.default.PropTypes.string,
  checkOut: _react2.default.PropTypes.string,
  earlyCheckIn: _react2.default.PropTypes.string,
  earlyCheckInFee: _react2.default.PropTypes.string,
  earlyCheckInCostType: _react2.default.PropTypes.string,
  earlyCheckInPercentageType: _react2.default.PropTypes.string,
  lateCheckOut: _react2.default.PropTypes.string,
  lateCheckOutFee: _react2.default.PropTypes.string,
  lateCheckOutCostType: _react2.default.PropTypes.string,
  lateCheckOutPercentageType: _react2.default.PropTypes.string,
  saveSupplierInfoChanges: _react2.default.PropTypes.func,
  contractId: _react2.default.PropTypes.string,
  openGlobalAlert: _react2.default.PropTypes.func
};

var DraftNTemplateContractDetails = function (_React$Component) {
  _inherits(DraftNTemplateContractDetails, _React$Component);

  function DraftNTemplateContractDetails() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DraftNTemplateContractDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DraftNTemplateContractDetails.__proto__ || Object.getPrototypeOf(DraftNTemplateContractDetails)).call.apply(_ref, [this].concat(args))), _this), _this.scroll = function () {
      if (window.location.hash) {
        var scrollToAnchor = function scrollToAnchor() {
          var element = document.querySelector(window.location.hash);
          if (element) (0, _scrollToElement2.default)(window.location.hash, { offset: -70 });
        };
        scrollToAnchor();
        window.onhashchange = scrollToAnchor;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DraftNTemplateContractDetails, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          getContractDetails = _props.getContractDetails,
          params = _props.params;

      getContractDetails(params.collection, params.contractId);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scroll();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes);
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          supplierInfo = _props2.supplierInfo,
          billingInformation = _props2.billingInformation,
          locationPolicy = _props2.locationPolicy,
          openAddEditContractDialog = _props2.openAddEditContractDialog,
          supplierEditable = _props2.supplierEditable,
          openGlobalAlert = _props2.openGlobalAlert,
          propsForCheckInCheckOut = _objectWithoutProperties(_props2, ['supplierInfo', 'billingInformation', 'locationPolicy', 'openAddEditContractDialog', 'supplierEditable', 'openGlobalAlert']);

      return _react2.default.createElement(
        'div',
        { style: { width: '80%' } },
        _react2.default.createElement(_termsCriteriaNode2.default, _extends({}, supplierInfo, { editable: supplierEditable, openAddEditContractDialog: openAddEditContractDialog, forSupplier: true })),
        _react2.default.createElement(_policiesNode2.default, {
          locationPolicy: locationPolicy,
          supplierEditable: supplierEditable,
          openAddEditContractDialog: openAddEditContractDialog,
          deleteLocationPolicy: function deleteLocationPolicy(policyType) {
            return function () {
              openGlobalAlert({
                text: 'Are sure you want to delete this policy?',
                onOk: function onOk() {
                  return _this2.props.saveSupplierInfoChanges({ contractId: _this2.props.contractId, data: { policyType: policyType }, updateType: 'DELETE_LOCATION_POLICY' });
                }
              });
            };
          }
        }),
        _react2.default.createElement(_checkinout2.default, _extends({}, propsForCheckInCheckOut, { supplierEditable: supplierEditable, openAddEditContractDialog: openAddEditContractDialog })),
        _react2.default.createElement(_billingInfoNode2.default, _extends({}, billingInformation, { supplierEditable: supplierEditable, openAddEditContractDialog: openAddEditContractDialog }))
      );
    }
  }]);

  return DraftNTemplateContractDetails;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return _extends({
    supplierEditable: contracting.contractActivitiesProducts.getIn(['leftNav', 'supplierEditable'])
  }, contracting.contractActivitiesProducts.get('rightSideContent').toJS());
};
var mapDispatchToProps = {
  getContractDetails: _contractActivitiesProductsActions.getContractDetails,
  saveSupplierInfoChanges: _dialogConstants.saveSupplierInfoChanges,
  openGlobalAlert: function openGlobalAlert(payload) {
    return {
      type: 'open_global_alert',
      payload: payload
    };
  }
};
DraftNTemplateContractDetails.propTypes = propTypes;
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DraftNTemplateContractDetails);

/***/ }),
/* 3412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _reactRouter = __webpack_require__(67);

var _reactRouterRedux = __webpack_require__(27);

var _chevronRight = __webpack_require__(1204);

var _chevronRight2 = _interopRequireDefault(_chevronRight);

var _questionAnswer = __webpack_require__(3413);

var _questionAnswer2 = _interopRequireDefault(_questionAnswer);

var _speakerNotes = __webpack_require__(1968);

var _speakerNotes2 = _interopRequireDefault(_speakerNotes);

var _viewDay = __webpack_require__(2008);

var _viewDay2 = _interopRequireDefault(_viewDay);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _partnerNode = __webpack_require__(1055);

var _partnerNode2 = _interopRequireDefault(_partnerNode);

var _updateAssignee = __webpack_require__(1258);

var _updateAssignee2 = _interopRequireDefault(_updateAssignee);

var _addEditContractDialog = __webpack_require__(1548);

var _addEditContractDialog2 = _interopRequireDefault(_addEditContractDialog);

var _updateRateConversionPriority = __webpack_require__(1542);

var _updateRateConversionPriority2 = _interopRequireDefault(_updateRateConversionPriority);

var _updateRateConversionStatus = __webpack_require__(2005);

var _updateRateConversionStatus2 = _interopRequireDefault(_updateRateConversionStatus);

var _smallButtons = __webpack_require__(94);

var _resendOrUpdateDialog = __webpack_require__(1141);

var _resendOrUpdateDialog2 = _interopRequireDefault(_resendOrUpdateDialog);

var _modeEdit = __webpack_require__(1268);

var _modeEdit2 = _interopRequireDefault(_modeEdit);

var _emailTracking = __webpack_require__(2009);

var _emailTracking2 = _interopRequireDefault(_emailTracking);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _checkCircle = __webpack_require__(1044);

var _checkCircle2 = _interopRequireDefault(_checkCircle);

var _contractActivitiesProductsActions = __webpack_require__(493);

var _actions = __webpack_require__(737);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  contractId: _react.PropTypes.string,
  buyerInfo: _react.PropTypes.object,
  notesCount: _react.PropTypes.number,
  contractorEditable: _react.PropTypes.bool,
  openAddEditContractDialog: _react.PropTypes.func,
  isLatest: _react.PropTypes.bool,
  from: _react.PropTypes.object,
  to: _react.PropTypes.object,
  deadlineDate: _react.PropTypes.string,
  lastSent: _react.PropTypes.string,
  rateConversionStatus: _react.PropTypes.string,
  rateConversionSetting: _react.PropTypes.string,
  respondedContracts: _react.PropTypes.array,
  files: _react.PropTypes.array,
  getContractLeftNav: _react.PropTypes.func,
  params: _react.PropTypes.object,
  getContractDetails: _react.PropTypes.func,
  assignee: _react.PropTypes.object,
  priority: _react.PropTypes.string,
  startDate: _react.PropTypes.string,
  endDate: _react.PropTypes.string,
  openResendContractDialog: _react.PropTypes.func,
  payloadForResend: _react.PropTypes.object,
  leftNavLoaded: _react.PropTypes.bool,
  push: _react.PropTypes.func,
  goBack: _react.PropTypes.func,
  children: _react.PropTypes.any,
  getHistoryFeeds: _react.PropTypes.func,
  mostRecentSentActivity: _react.PropTypes.object,
  contractingRemindersSettings: _react.PropTypes.array,
  shouldSendReminders: _react.PropTypes.bool,
  buyerChecked: _react.PropTypes.bool,
  createdAt: _react.PropTypes.string,
  updateWorkspace: _react.PropTypes.func,
  getNotes: _react.PropTypes.func
};

var CRBuyerView = function (_Component) {
  _inherits(CRBuyerView, _Component);

  function CRBuyerView() {
    _classCallCheck(this, CRBuyerView);

    var _this = _possibleConstructorReturn(this, (CRBuyerView.__proto__ || Object.getPrototypeOf(CRBuyerView)).call(this));

    _this.clickShowRecipients = function () {
      return _this.setState({ showRecipients: !_this.state.showRecipients });
    };

    _this.resendContract = function () {
      return _this.props.openResendContractDialog(_this.props.payloadForResend);
    };

    _this.updateContractPeriod = function () {
      return _this.props.openAddEditContractDialog({
        type: 'UpdateContractPeriod',
        data: {
          title: 'Update Contract Period',
          newStartDate: _this.props.startDate,
          newEndDate: _this.props.endDate,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate
        }
      });
    };

    _this.goToDocuments = function () {
      return _this.props.contractId ? _this.props.push('/contracting/workspace/' + _this.props.contractId + '/documents') : null;
    };

    _this.goToNotes = function () {
      return _this.props.contractId ? _this.props.push('/contracting/workspace/' + _this.props.contractId + '/notes') : null;
    };

    _this.goToActivities = function () {
      return _this.props.contractId ? _this.props.push('/contracting/workspace/' + _this.props.contractId + '/activities') : null;
    };

    _this.goToWorkspaceList = function () {
      window.location = "https://app.tourconnect.com" + '/contracting/workspace-list?jwt=' + localStorage.getItem('jwt');
    };

    _this.onClickShouldSendReminders = function () {
      _this.props.updateWorkspace({
        contractId: _this.props.contractId,
        updater: { shouldSendReminders: !_this.props.shouldSendReminders }
      });
    };

    _this.state = {
      showRecipients: false
    };
    return _this;
  }

  _createClass(CRBuyerView, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          leftNavLoaded = _props.leftNavLoaded,
          params = _props.params,
          getContractDetails = _props.getContractDetails,
          getContractLeftNav = _props.getContractLeftNav,
          getHistoryFeeds = _props.getHistoryFeeds;

      if (!leftNavLoaded) {
        getContractDetails('contract', params.contractId);
        getContractLeftNav('contract', params.contractId);
        getHistoryFeeds('contract', params.contractId);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.leftNavLoaded && !this.props.leftNavLoaded) {
        this.props.getNotes({ historyFeedId: nextProps.historyFeedId });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          contractId = _props2.contractId,
          notesCount = _props2.notesCount,
          startDate = _props2.startDate,
          endDate = _props2.endDate,
          deadlineDate = _props2.deadlineDate,
          createdAt = _props2.createdAt,
          _props2$to = _props2.to,
          to = _props2$to === undefined ? {} : _props2$to,
          _props2$rateConversio = _props2.rateConversionStatus,
          rateConversionStatus = _props2$rateConversio === undefined ? '' : _props2$rateConversio,
          assignee = _props2.assignee,
          priority = _props2.priority,
          children = _props2.children,
          mostRecentSentActivity = _props2.mostRecentSentActivity,
          contractingRemindersSettings = _props2.contractingRemindersSettings,
          shouldSendReminders = _props2.shouldSendReminders,
          buyerChecked = _props2.buyerChecked,
          _props2$respondedCont = _props2.respondedContracts,
          respondedContracts = _props2$respondedCont === undefined ? [] : _props2$respondedCont,
          _props2$files = _props2.files,
          files = _props2$files === undefined ? [] : _props2$files;

      var reminderBasicRequirementMet = Boolean(mostRecentSentActivity && deadlineDate && rateConversionStatus.toLowerCase().indexOf('complete') === -1 && !(buyerChecked || respondedContracts.length || files.length));
      var reminderDates = contractingRemindersSettings.map(function (o) {
        var date = void 0;
        var fromDate = o.fromDate === 'deadline' ? deadlineDate : createdAt;
        if (o.priorAfter === 'prior') date = (0, _moment2.default)(fromDate).subtract(o.days, 'days').toISOString();else date = (0, _moment2.default)(fromDate).add(o.days, 'days').toISOString();
        return _extends({}, o, {
          date: date
        });
      }).filter(function (o) {
        return o.enabled && o.date && (0, _moment2.default)(o.date).isSameOrAfter(new Date());
      }).sort(_ramda2.default.ascend(_ramda2.default.prop('date')));
      var reminderRequirements = {
        'Rate Request was sent': Boolean(mostRecentSentActivity && deadlineDate),
        'Status is not complete': rateConversionStatus.toLowerCase().indexOf('complete') === -1,
        'Rates are not yet received.': !(buyerChecked || respondedContracts.length || files.length),
        'Company Settings': Boolean(reminderDates.length)
      };
      var pathN = window.location.pathname;
      var isHealthAndSafety = new Date(startDate).getUTCFullYear() === 2099;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'flex-tc-sb', style: { padding: '0.5em 1em', backgroundColor: '#00bcd4', color: '#fff' } },
          _react2.default.createElement(
            'div',
            { className: 'flex-center' },
            _react2.default.createElement(
              'div',
              { style: { fontSize: '1.5em', cursor: 'pointer' }, onClick: this.goToWorkspaceList },
              'Workspace List'
            ),
            _react2.default.createElement(_chevronRight2.default, { style: { height: '36px', width: '36px', color: '#fff' } }),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                to.name || ''
              ),
              '\xA0',
              isHealthAndSafety ? 'Health & Safety' : (startDate ? _moment2.default.utc(new Date(startDate)).format('MMM DD YYYY') : '') + ' - ' + (endDate ? _moment2.default.utc(new Date(endDate)).format('MMM DD YYYY') : ''),
              '\xA0Workspace'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'flex-center' },
            _react2.default.createElement(_materialUi.FlatButton, {
              icon: _react2.default.createElement(_viewDay2.default, { style: { color: '#fff', fill: '#fff' } }),
              label: 'Documents',
              backgroundColor: pathN.indexOf('/documents') > -1 ? 'rgba(0, 0, 0, 0.2)' : null,
              labelStyle: pathN.indexOf('/documents') > -1 ? { color: '#fff', fontWeight: 'bold' } : { color: '#fff' },
              disabled: pathN.indexOf('documents') > -1,
              onClick: this.goToDocuments
            }),
            _react2.default.createElement(_materialUi.FlatButton, {
              icon: _react2.default.createElement(_speakerNotes2.default, { style: { color: '#fff', fill: '#fff' } }),
              label: 'Internal Notes' + (notesCount ? ' (' + notesCount + ')' : ''),
              backgroundColor: pathN.indexOf('/notes') > -1 ? 'rgba(0, 0, 0, 0.2)' : null,
              labelStyle: pathN.indexOf('/notes') > -1 ? { color: '#fff', fontWeight: 'bold' } : { color: '#fff' },
              disabled: pathN.indexOf('notes') > -1,
              onClick: this.goToNotes
            }),
            _react2.default.createElement(_materialUi.FlatButton, {
              icon: _react2.default.createElement(_questionAnswer2.default, { style: { color: '#fff', fill: '#fff' } }),
              label: 'Activities',
              backgroundColor: pathN.indexOf('/activities') > -1 ? 'rgba(0, 0, 0, 0.2)' : null,
              labelStyle: pathN.indexOf('/activities') > -1 ? { color: '#fff', fontWeight: 'bold' } : { color: '#fff' },
              disabled: pathN.indexOf('activities') > -1,
              onClick: this.goToActivities
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', alignItems: 'flex-start' } },
          _react2.default.createElement(
            'div',
            { style: { width: '20%', paddingTop: '1em' } },
            _react2.default.createElement(
              _materialUi.Paper,
              { style: { padding: '1em' } },
              _react2.default.createElement(_partnerNode2.default, {
                forLeftNav: true,
                isReceiver: true,
                forSupplier: true,
                style: { marginBottom: '4px' }
              }),
              !isHealthAndSafety && _react2.default.createElement(
                'div',
                { style: { fontWeight: 'bolder', marginTop: '1em' } },
                'Contracting Period'
              ),
              !isHealthAndSafety && _react2.default.createElement(
                'div',
                { style: { margin: '0.5em 0 1em 0' }, className: 'flex-tc-sb' },
                startDate ? _moment2.default.utc(new Date(startDate)).format('MMM DD YYYY') : '',
                ' - ',
                endDate ? _moment2.default.utc(new Date(endDate)).format('MMM DD YYYY') : '',
                _react2.default.createElement(_smallButtons.JiraFlatButton, { icon: _react2.default.createElement(_modeEdit2.default, null), onClick: this.updateContractPeriod, label: 'Edit' })
              )
            ),
            _react2.default.createElement(
              _materialUi.Paper,
              { style: { padding: '1em', marginTop: '1em' } },
              _react2.default.createElement(
                'div',
                { className: 'flex-tc-sb', style: { marginBottom: '1em' } },
                _react2.default.createElement(
                  'b',
                  null,
                  'Assignee:\xA0'
                ),
                _react2.default.createElement(_updateAssignee2.default, {
                  contractId: contractId,
                  assignee: assignee,
                  isContainer: true
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'flex-tc-sb', style: { marginBottom: '1em' } },
                _react2.default.createElement(
                  'b',
                  null,
                  'Status:\xA0'
                ),
                _react2.default.createElement(_updateRateConversionStatus2.default, {
                  contractId: contractId,
                  rateConversionStatus: rateConversionStatus
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'flex-tc-sb' },
                _react2.default.createElement(
                  'b',
                  null,
                  'Priority:\xA0'
                ),
                _react2.default.createElement(_updateRateConversionPriority2.default, {
                  contractId: contractId,
                  priority: priority
                })
              )
            ),
            _react2.default.createElement(
              _materialUi.Paper,
              { style: { padding: '1em', marginTop: '1em' } },
              _react2.default.createElement(
                'div',
                { style: { fontWeight: 'bolder' } },
                'Rate Submission Deadline'
              ),
              _react2.default.createElement(
                'div',
                { style: { marginBottom: '1em' } },
                deadlineDate ? _moment2.default.utc(new Date(deadlineDate)).format('MMMM DD, YYYY') : 'NA'
              ),
              Boolean(mostRecentSentActivity) && _react2.default.createElement(
                'div',
                { style: { marginBottom: '1em' } },
                _react2.default.createElement(_materialUi.Toggle, {
                  toggled: shouldSendReminders,
                  onClick: this.onClickShouldSendReminders,
                  label: 'Auto Reminders: ' + (shouldSendReminders ? 'ON' : 'OFF'),
                  labelStyle: { fontWeight: 'bolder' }
                })
              ),
              function () {
                if (shouldSendReminders && mostRecentSentActivity) {
                  if (reminderDates[0] && reminderBasicRequirementMet) {
                    return _react2.default.createElement(
                      'div',
                      { style: { marginBottom: '1em' } },
                      _react2.default.createElement(
                        'div',
                        { style: { fontWeight: 'bolder' } },
                        'Next Scheduled Reminder:'
                      ),
                      _react2.default.createElement(
                        'div',
                        null,
                        (0, _moment2.default)(reminderDates[0].date).format('MMMM DD, YYYY')
                      )
                    );
                  }
                  return _react2.default.createElement(
                    'div',
                    { style: { marginBottom: '1em' } },
                    _react2.default.createElement(
                      'div',
                      { style: { fontWeight: 'bolder' } },
                      'No scheduled reminder'
                    ),
                    _react2.default.createElement(
                      'div',
                      {
                        style: {
                          marginTop: '8px',
                          backgroundColor: '#fafafa',
                          border: '1px solid #e0e0e0',
                          borderRadius: '4px',
                          padding: '8px'
                        }
                      },
                      'Requirements for Auto Reminders:',
                      Object.keys(reminderRequirements).map(function (label) {
                        return _react2.default.createElement(
                          'div',
                          { key: label, className: 'flex-center', style: { fontSize: '10px' } },
                          reminderRequirements[label] ? _react2.default.createElement(_checkCircle2.default, { style: { color: '#00bcd4', width: '16px', minWidth: '16px' } }) : _react2.default.createElement(_checkCircle2.default, { style: { color: '#e0e0e0', width: '16px', minWidth: '16px' } }),
                          label.indexOf('Company Settings') > -1 ? _react2.default.createElement(
                            'span',
                            null,
                            'Auto Reminder ',
                            _react2.default.createElement(
                              _reactRouter.Link,
                              { to: '/settings/contracting-settings' },
                              'Company Settings'
                            ),
                            ' are turned on and matches the dates'
                          ) : label
                        );
                      })
                    )
                  );
                }
              }(),
              _react2.default.createElement(
                'div',
                { style: { fontWeight: 'bolder' } },
                'Request Last Sent:'
              ),
              Boolean(mostRecentSentActivity) ? _react2.default.createElement(_emailTracking2.default, {
                inLeftNav: true,
                isSender: true,
                sentDate: mostRecentSentActivity.createdAt,
                showRecipients: this.state.showRecipients,
                clickShowRecipients: this.clickShowRecipients,
                recipients: _ramda2.default.propOr([], 'to', mostRecentSentActivity),
                rawEvents: _ramda2.default.propOr({}, 'events', mostRecentSentActivity)
              }) : 'NA',
              _react2.default.createElement(_smallButtons.JiraFlatButton, {
                style: { width: '100%', marginTop: '16px' },
                labelStyle: { padding: '0 4px', color: '#00bcd4' },
                label: deadlineDate ? 'Resend Request' : 'Send Request',
                onClick: this.resendContract
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { padding: '1em 0 0 1em', width: '80%' } },
            children
          )
        ),
        _react2.default.createElement(_resendOrUpdateDialog2.default, null),
        _react2.default.createElement(_addEditContractDialog2.default, { reducerName: 'contractActivitiesProducts' }),
        _react2.default.createElement(_loadingOverlay2.default, { loading: !this.props.contractId })
      );
    }
  }]);

  return CRBuyerView;
}(_react.Component);

CRBuyerView.propTypes = propTypes;

exports.default = (0, _reactRedux.connect)(function (_ref, _ref2) {
  var contracting = _ref.contracting,
      user = _ref.user;
  var params = _ref2.params;

  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  var rightSideContent = contracting.contractActivitiesProducts.get('rightSideContent').toJS();
  var activities = contracting.contractActivitiesProducts.get('activities').toJS();
  var notes = contracting.contractActivitiesProducts.get('notes').toJS();
  var mostRecentSentActivity = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.find(function (o) {
    return o.contracts && o.contracts.find(function (c) {
      return c.action && c.action.indexOf('Request') > -1;
    });
  }), _ramda2.default.propOr([], 'messageArray')), activities);
  return {
    contractId: leftNav.contractId,
    historyFeedId: leftNav.historyFeedId,
    leftNavLoaded: leftNav[params.contractId + 'Loaded'],
    notesCount: notes.length,
    viewingAs: leftNav.viewingAs,
    from: leftNav.from,
    to: leftNav.to,
    assignee: leftNav.assignee,
    priority: leftNav.priority,
    startDate: leftNav.startDate,
    endDate: leftNav.endDate,
    buyerChecked: leftNav.buyerChecked,
    rateConversionStatus: rightSideContent.rateConversionStatus,
    rateConversionSetting: rightSideContent.rateConversionSetting,
    isLatest: leftNav.isLatest,
    deadlineDate: rightSideContent.deadlineDate,
    shouldSendReminders: rightSideContent.shouldSendReminders,
    createdAt: rightSideContent.createdAt,
    contractingRemindersSettings: user.getIn(['companySettings']).contractingReminders,
    buyerInfo: rightSideContent.buyerInfo,
    files: rightSideContent.files,
    respondedContracts: leftNav.respondedContracts,
    lastSent: leftNav.lastSent,
    mostRecentSentActivity: mostRecentSentActivity,
    payloadForResend: {
      contractId: leftNav.contractId,
      to: leftNav.to,
      toEmails: leftNav.toEmails,
      resendToEmails: leftNav.toEmails,
      partner: _ramda2.default.pathOr({}, ['partners', 0], leftNav),
      deadlineDate: rightSideContent.deadlineDate
    }
  };
}, {
  getContractDetails: _contractActivitiesProductsActions.getContractDetails,
  getContractLeftNav: _contractActivitiesProductsActions.getContractLeftNav,
  openResendContractDialog: function openResendContractDialog(payload) {
    return { type: 'CHANGE_RESEND_CONTRACT_DIALOG_STATE', payload: payload };
  },
  push: _reactRouterRedux.push,
  goBack: _reactRouterRedux.goBack,
  openAddEditContractDialog: function openAddEditContractDialog(payload) {
    return { type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE', payload: payload };
  },
  updateWorkspace: function updateWorkspace(payload) {
    return { type: '[contract-request] UPDATE_CONTRACTING_WORKSPACE', payload: payload };
  },
  getHistoryFeeds: _contractActivitiesProductsActions.getHistoryFeeds,
  getNotes: _actions.getNotes
})(CRBuyerView);

/***/ }),
/* 3413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionQuestionAnswer = function ActionQuestionAnswer(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
  );
};
ActionQuestionAnswer = (0, _pure2.default)(ActionQuestionAnswer);
ActionQuestionAnswer.displayName = 'ActionQuestionAnswer';
ActionQuestionAnswer.muiName = 'SvgIcon';

exports.default = ActionQuestionAnswer;

/***/ }),
/* 3414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _attachFile = __webpack_require__(1270);

var _attachFile2 = _interopRequireDefault(_attachFile);

var _chromeReaderMode = __webpack_require__(1461);

var _chromeReaderMode2 = _interopRequireDefault(_chromeReaderMode);

var _description = __webpack_require__(561);

var _description2 = _interopRequireDefault(_description);

var _externalFiles = __webpack_require__(1996);

var _externalFiles2 = _interopRequireDefault(_externalFiles);

var _respondedContractList = __webpack_require__(1998);

var _respondedContractList2 = _interopRequireDefault(_respondedContractList);

var _rateConversion = __webpack_require__(2006);

var _rateConversion2 = _interopRequireDefault(_rateConversion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  rateConversionStatus: _react.PropTypes.string,
  respondedContracts: _react.PropTypes.array,
  files: _react.PropTypes.array
};

var CRBuyerViewMainContent = function (_Component) {
  _inherits(CRBuyerViewMainContent, _Component);

  function CRBuyerViewMainContent() {
    _classCallCheck(this, CRBuyerViewMainContent);

    return _possibleConstructorReturn(this, (CRBuyerViewMainContent.__proto__ || Object.getPrototypeOf(CRBuyerViewMainContent)).apply(this, arguments));
  }

  _createClass(CRBuyerViewMainContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rateConversionStatus = _props.rateConversionStatus,
          _props$respondedContr = _props.respondedContracts,
          respondedContracts = _props$respondedContr === undefined ? [] : _props$respondedContr,
          _props$files = _props.files,
          files = _props$files === undefined ? [] : _props$files;

      var converting = rateConversionStatus !== 'Awaiting Supplier Rates' && rateConversionStatus !== 'Conversion Complete' && rateConversionStatus !== 'Signed';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _materialUi.Card,
          null,
          _react2.default.createElement(_materialUi.CardHeader, {
            title: _react2.default.createElement(
              'div',
              { className: 'flex-center' },
              _react2.default.createElement(_attachFile2.default, null),
              '\xA0\xA0 Files (',
              files.length,
              ')'
            ),
            titleStyle: { fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' },
            actAsExpander: true,
            showExpandableButton: true
          }),
          _react2.default.createElement(
            _materialUi.CardText,
            { expandable: true, style: { padding: '1em 2em' } },
            _react2.default.createElement(_externalFiles2.default, null)
          )
        ),
        _react2.default.createElement(
          _materialUi.Card,
          {
            style: { marginTop: '1em' },
            initiallyExpanded: Boolean(respondedContracts.length)
          },
          _react2.default.createElement(_materialUi.CardHeader, {
            title: _react2.default.createElement(
              'div',
              { className: 'flex-center' },
              _react2.default.createElement(_chromeReaderMode2.default, null),
              '\xA0\xA0 TourConnect Format Rate Contracts (',
              respondedContracts.length,
              ')'
            ),
            titleStyle: { fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' },
            actAsExpander: true,
            showExpandableButton: true
          }),
          _react2.default.createElement(
            _materialUi.CardText,
            { expandable: true, style: { padding: '1em 2em' } },
            _react2.default.createElement(_respondedContractList2.default, null)
          )
        ),
        _react2.default.createElement(
          _materialUi.Card,
          {
            style: { marginTop: '1em' },
            initiallyExpanded: converting
          },
          _react2.default.createElement(_materialUi.CardHeader, {
            title: _react2.default.createElement(
              'div',
              { className: 'flex-center' },
              _react2.default.createElement(_description2.default, null),
              '\xA0\xA0 Rate Conversion'
            ),
            titleStyle: { fontSize: '16px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.67)', textTransform: 'uppercase' },
            actAsExpander: true,
            showExpandableButton: true
          }),
          _react2.default.createElement(
            _materialUi.CardText,
            { expandable: true, style: { padding: '1em 2em' } },
            _react2.default.createElement(_rateConversion2.default, null)
          )
        )
      );
    }
  }]);

  return CRBuyerViewMainContent;
}(_react.Component);

CRBuyerViewMainContent.propTypes = propTypes;

exports.default = (0, _reactRedux.connect)(function (_ref) {
  var contracting = _ref.contracting;

  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  var rightSideContent = contracting.contractActivitiesProducts.get('rightSideContent').toJS();
  return {
    rateConversionStatus: rightSideContent.rateConversionStatus,
    respondedContracts: leftNav.respondedContracts,
    files: leftNav.files
  };
})(CRBuyerViewMainContent);

/***/ }),
/* 3415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _comments = __webpack_require__(3416);

var _comments2 = _interopRequireDefault(_comments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  params: _propTypes2.default.object.isRequired,
  location: _propTypes2.default.object.isRequired
};

var ContractCommentsAndActivitiesRouter = function (_Component) {
  _inherits(ContractCommentsAndActivitiesRouter, _Component);

  function ContractCommentsAndActivitiesRouter() {
    _classCallCheck(this, ContractCommentsAndActivitiesRouter);

    return _possibleConstructorReturn(this, (ContractCommentsAndActivitiesRouter.__proto__ || Object.getPrototypeOf(ContractCommentsAndActivitiesRouter)).apply(this, arguments));
  }

  _createClass(ContractCommentsAndActivitiesRouter, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _propTypes2.default.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          contractId = _props.params.contractId,
          pathname = _props.location.pathname;

      var isInMessaging = _ramda2.default.contains('messaging', pathname);
      return _react2.default.createElement(_comments2.default, { contractId: contractId, isInMessaging: isInMessaging });
    }
  }]);

  return ContractCommentsAndActivitiesRouter;
}(_react.Component);

ContractCommentsAndActivitiesRouter.propTypes = propTypes;

var mapStateToProps = function mapStateToProps() {
  return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, function () {
  return {};
})(ContractCommentsAndActivitiesRouter);

/***/ }),
/* 3416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _accessCheckHelperFns = __webpack_require__(631);

var _comment = __webpack_require__(2010);

var _comment2 = _interopRequireDefault(_comment);

var _commentBox = __webpack_require__(1112);

var _commentBox2 = _interopRequireDefault(_commentBox);

var _contractActivitiesProductsActions = __webpack_require__(493);

var _commentActions = __webpack_require__(3424);

var _commentsTitle = __webpack_require__(3425);

var _commentsTitle2 = _interopRequireDefault(_commentsTitle);

var _sendMessage = __webpack_require__(2007);

var _sendMessage2 = _interopRequireDefault(_sendMessage);

var _resendOrUpdateDialog = __webpack_require__(1141);

var _resendOrUpdateDialog2 = _interopRequireDefault(_resendOrUpdateDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  container: {
    // backgroundColor: '#f0f0f0',
    // height: 'calc(100vh - 268px)',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingRight: '32px'
  },
  containerSupplier: {
    // height: 'calc(100vh - 168px) !important',
  },
  workspaceBody: {
    height: '100%'
  },
  commentBox: {
    margin: '0 0 16px 11%'
  },
  ContractContentMessages: {
    // backgroundColor: 'white',
    // overflowY: 'scroll',
    // padding: '0 2px',
    // flex: '1 1 auto',
    // overflowX: 'hidden',
    // margin: '8px 4%',
    // marginLeft: '10%',
    width: '100%',
    height: '100%',
    position: 'relative',
    '@media (min-width: 1000px)': {
      '&:before': {
        background: '#90a4ae',
        content: "''",
        display: 'block',
        height: '100%',
        left: '40px',
        position: 'absolute',
        top: '10px',
        width: '1px',
        zIndex: 0
      }
    }
  },
  heatherTitle: {
    flex: '0 1 auto'
  },
  commentDisabledContainer: {
    border: '1px dashed #bfbfbf',
    marginTop: '24px',
    padding: '16px',
    height: '80px'
  },
  commentDisabledText: {
    display: 'inline-block',
    marginLeft: '12px',
    width: '80%',
    position: 'relative',
    top: '4px'
  },
  actionBtnContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between'
  },
  dlBtn: {
    backgroundColor: '#e3f2fd'
  }
};

var propTypes = {
  contractId: _react.PropTypes.string.isRequired,
  viewerCompanyId: _react.PropTypes.string,
  className: _react.PropTypes.string,
  classNameMessages: _react.PropTypes.string,
  classNameCommentBox: _react.PropTypes.string,
  messageArray: _react.PropTypes.array,
  comment: _react.PropTypes.func,
  commentBox: _react.PropTypes.object,
  submitContractingComment: _react.PropTypes.func,
  historyFeedId: _react.PropTypes.string,
  companyType: _react.PropTypes.string,
  commentDisabled: _react.PropTypes.bool,
  addFileToContractInDB: _react.PropTypes.func,
  getHistoryFeeds: _react.PropTypes.func,
  isInMessaging: _react.PropTypes.bool,
  partner: _react.PropTypes.object,
  contentLoading: _react.PropTypes.bool,
  readOnly: _react.PropTypes.bool,
  contractingCommentInput: _react.PropTypes.func,
  contractingAddFile: _react.PropTypes.func,
  contractingCancelComment: _react.PropTypes.func,
  setContractingCommentBoxFocus: _react.PropTypes.func,
  classes: _react.PropTypes.object,
  filesInContract: _react.PropTypes.array,
  isWorkspace: _react.PropTypes.bool,
  openRLSendMsg: _react.PropTypes.func,
  openResendContractDialog: _react.PropTypes.func,
  supplierEmails: _react.PropTypes.array,
  templateFromDummy: _react.PropTypes.bool
};

var ContractCommentsAndActivities = function (_Component) {
  _inherits(ContractCommentsAndActivities, _Component);

  function ContractCommentsAndActivities(props) {
    _classCallCheck(this, ContractCommentsAndActivities);

    var _this = _possibleConstructorReturn(this, (ContractCommentsAndActivities.__proto__ || Object.getPrototypeOf(ContractCommentsAndActivities)).call(this, props));

    _this.onScroll = function () {
      if (_this.state.page * 5 < _this.props.messageArray.length && !_this.state.loading) {
        var ele = document.getElementById('activities');
        if (ele) {
          var scrollEleBound = ele.getBoundingClientRect();
          if (scrollEleBound.bottom < window.innerHeight + 150) {
            _this.setState({ loading: true });
            setTimeout(function () {
              _this.setState({ page: _this.state.page + 1, loading: false });
            }, 500);
          }
        }
      }
    };

    _this.timedUpdate = function () {
      if (!localStorage.stopAutoReload && !_this.props.contentLoading) _this.props.getHistoryFeeds('contract', _this.props.contractId);
    };

    _this.handleComment = function (input) {
      _this.setState({ currentComment: input });
    };

    _this.submitComment = function () {
      _this.setState({ disableSend: true }, function () {
        var _this$props = _this.props,
            commentBox = _this$props.commentBox,
            contractId = _this$props.contractId,
            historyFeedId = _this$props.historyFeedId;
        var attachedFiles = commentBox.attachedFiles;

        _this.props.submitContractingComment({
          files: attachedFiles,
          contractId: contractId,
          comment: _this.state.currentComment,
          historyFeedId: historyFeedId
        });
        _this.setState({ currentComment: '', disableSend: false });
        _this.clearInput();
      });
    };

    _this.timer = null;

    _this.defaultState = { // don't include object in values
      currentComment: '',
      disableSend: false
    };
    _this.state = _extends({
      page: 1,
      loading: false
    }, _this.defaultState);
    return _this;
  }

  _createClass(ContractCommentsAndActivities, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getHistoryFeeds('contract', this.props.contractId);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.addEventListener) {
        window.addEventListener('scroll', this.onScroll, true);
      } else {
        window.attachEvent('onscroll', this.onScroll);
      }
      // comment below timer temporarily as we currently don't have that kind of traffic in history feed
      // if (!this.timer) this.timer = setInterval(this.timedUpdate, 3e3);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (window.addEventListener) {
        window.removeEventListener('scroll', this.onScroll, true);
      } else {
        window.detachEvent('onScroll', this.onScroll);
      }
      // comment below timer temporarily as we currently don't have that kind of traffic in history feed
      // clearInterval(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          messageArray = _props.messageArray,
          commentBox = _props.commentBox,
          companyType = _props.companyType,
          commentDisabled = _props.commentDisabled,
          contractId = _props.contractId,
          viewerCompanyId = _props.viewerCompanyId,
          isInMessaging = _props.isInMessaging,
          partner = _props.partner,
          filesInContract = _props.filesInContract,
          readOnly = _props.readOnly,
          className = _props.className,
          classes = _props.classes,
          isWorkspace = _props.isWorkspace,
          openRLSendMsg = _props.openRLSendMsg,
          supplierEmails = _props.supplierEmails,
          templateFromDummy = _props.templateFromDummy,
          rest = _objectWithoutProperties(_props, ['messageArray', 'commentBox', 'companyType', 'commentDisabled', 'contractId', 'viewerCompanyId', 'isInMessaging', 'partner', 'filesInContract', 'readOnly', 'className', 'classes', 'isWorkspace', 'openRLSendMsg', 'supplierEmails', 'templateFromDummy']);
      // if (R.isEmpty(this.props.messageArray)) return <div/>;


      var onClickSendMsg = function onClickSendMsg(who) {
        return function () {
          return openRLSendMsg({
            who: who,
            emails: who === 'DL' ? ['dl@tourconnect.com'] : supplierEmails
          });
        };
      };
      var focused = commentBox.focused;

      var recipientName = partner ? partner.name : 'Unknown';
      return _react2.default.createElement(
        'div',
        {
          className: className || '' + classes.container + (companyType === 'Supplier' ? ' ' + this.props.classes.containerSupplier : '')
        },
        isInMessaging ? _react2.default.createElement(_commentsTitle2.default, { className: this.props.classes.heatherTitle, recipientName: recipientName, linkAction: function linkAction() {
            return _this2.context.router.push('/contracting/contract/' + contractId + '/details');
          } }) : _react2.default.createElement('div', null),
        function () {
          if (commentDisabled || readOnly) {
            return _react2.default.createElement(
              'div',
              { className: classes.commentDisabledContainer },
              _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-question_answer', color: '#bfbfbf', style: { top: '6px', float: 'left' } }),
              _react2.default.createElement(
                'div',
                { className: classes.commentDisabledText },
                'Message box is disabled because you do not have access.'
              )
            );
          }
          if (isWorkspace && companyType === 'Contractor') {
            return _react2.default.createElement(
              'div',
              { className: classes.commentBox },
              _react2.default.createElement(
                'div',
                { className: classes.actionBtnContainer },
                _react2.default.createElement(_materialUi.RaisedButton, {
                  label: 'Send Message to Partner',
                  onClick: onClickSendMsg('Supplier')
                })
              )
            );
          }
          if (!isWorkspace && companyType === 'Contractor' && templateFromDummy) {
            return _react2.default.createElement('div', { className: classes.commentBox });
          }
          return _react2.default.createElement(
            _materialUi.Paper,
            { className: classes.commentBox },
            _react2.default.createElement(_commentBox2.default, _extends({
              comment: _this2.state.currentComment,
              handleInput: _this2.handleComment,
              attachFile: _this2.props.contractingAddFile,
              setFocus: _this2.props.setContractingCommentBoxFocus,
              submitComment: _this2.submitComment,
              cancelComment: function cancelComment() {
                _this2.props.contractingCancelComment();
                _this2.setState({ currentComment: '' });
                _this2.clearInput();
              },
              setClear: function setClear(clear) {
                return _this2.clearInput = clear;
              },
              contractId: contractId,
              focused: focused,
              disableSend: _this2.state.disableSend
            }, rest))
          );
        }(),
        _react2.default.createElement(
          'div',
          {
            className: classes.ContractContentMessages,
            id: 'activities'
          },
          messageArray.slice(0, this.state.page * 5).map(function (message, key) {
            return _react2.default.createElement(_comment2.default, {
              key: key,
              msgObject: message,
              filesInContract: filesInContract,
              viewerCompanyId: viewerCompanyId,
              companyType: companyType,
              isInMessaging: isInMessaging,
              contractIdOfThread: contractId
            });
          }),
          this.state.loading && _react2.default.createElement(_materialUi.LinearProgress, null),
          this.state.page * 5 >= messageArray.length && _react2.default.createElement(
            'p',
            { style: { textAlign: 'center' } },
            _react2.default.createElement(
              'b',
              null,
              'Yay! You have seen it all!'
            )
          )
        ),
        _react2.default.createElement(_sendMessage2.default, { inActivityFeed: true }),
        _react2.default.createElement(_resendOrUpdateDialog2.default, null)
      );
    }
  }]);

  return ContractCommentsAndActivities;
}(_react.Component);

ContractCommentsAndActivities.propTypes = propTypes;

ContractCommentsAndActivities.defaultProps = {
  messageArray: []
};

var mapStateToProps = function mapStateToProps(state) {
  var contracting = state.contracting,
      user = state.user;

  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  var readOnly = !(0, _accessCheckHelperFns.checkLocAccess)(state, leftNav.locationId, 'contracting', 'write');
  var contactsOfThePartner = _ramda2.default.path(['partners', 0, 'contacts'], leftNav);
  return _extends({
    readOnly: readOnly,
    commentBox: contracting.commentBox,
    contentLoading: contracting.contractActivitiesProducts.get('contentLoading'),
    templateFromDummy: leftNav.templateFromDummy
  }, contracting.contractActivitiesProducts.get('activities').toJS(), {
    isWorkspace: !leftNav.locationId,
    viewerCompanyId: user.getIn(['company', 'companyId']),
    companyType: user.getIn(['user', 'type']),
    supplierEmails: contactsOfThePartner ? contactsOfThePartner.map(function (o) {
      return o.email;
    }) : state.dummyAcct.inCR.supplierEmails
  });
};
ContractCommentsAndActivities.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  getHistoryFeeds: _contractActivitiesProductsActions.getHistoryFeeds,
  contractingCommentInput: _commentActions.contractingCommentInput,
  contractingAddFile: _commentActions.contractingAddFile,
  contractingCancelComment: _commentActions.contractingCancelComment,
  setContractingCommentBoxFocus: _commentActions.setContractingCommentBoxFocus,
  submitContractingComment: _commentActions.submitContractingComment,
  openRLSendMsg: function openRLSendMsg(payload) {
    return { type: '{rl-send-message}OPEN_SEND_MESSAGE', payload: payload };
  },
  openResendContractDialog: function openResendContractDialog(payload) {
    return { type: 'CHANGE_RESEND_CONTRACT_DIALOG_STATE', payload: payload };
  }
})((0, _reactJss2.default)(styles)(ContractCommentsAndActivities));

/***/ }),
/* 3417 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
  var BREAK_TAG_REGEX, CHECKPOINT_PREFIX, CHECKPOINT_SUFFIX, DOCUMENT_POSITION_FOLLOWING, DOCUMENT_POSITION_PRECEDING, OUTLOOK_SPLITTER_QUERY_SELECTORS, OUTLOOK_SPLITTER_QUOTE_IDS, OUTLOOK_XPATH_SPLITTER_QUERIES, QUOTE_IDS, compareByDomPosition, elementIsAllContent, ensureTextNodeBetweenChildElements, findMicrosoftSplitter, findOutlookSplitterWithQuerySelector, findOutlookSplitterWithQuoteId, findOutlookSplitterWithXpathQuery, findParentDiv, hasTagName, isTextNodeWrappedInSpan, removeNodes;

  CHECKPOINT_PREFIX = '#!%!';

  CHECKPOINT_SUFFIX = '!%!#';

  exports.CHECKPOINT_PATTERN = new RegExp(CHECKPOINT_PREFIX + "\\d+" + CHECKPOINT_SUFFIX, 'g');

  QUOTE_IDS = ['OLK_SRC_BODY_SECTION'];

  exports.createEmailDocument = function(msgBody, dom) {
    var emailBodyElement, emailDocument, head, htmlElement;
    emailDocument = dom.implementation.createHTMLDocument();
    htmlElement = emailDocument.getElementsByTagName('html')[0];
    htmlElement.innerHTML = msgBody.trim();
    if (emailDocument.body == null) {
      emailBodyElement = emailDocument.getElementsByTagName('body')[0];
      emailDocument.body = emailBodyElement;
    }
    head = emailDocument.getElementsByTagName('head')[0];
    if (head) {
      emailDocument.documentElement.removeChild(head);
    }
    return emailDocument;
  };

  exports.addCheckpoints = function(htmlNode, counter) {
    var childNode, i, len, ref;
    if (htmlNode.nodeType === 3) {
      htmlNode.nodeValue = "" + (htmlNode.nodeValue.trim()) + CHECKPOINT_PREFIX + counter + CHECKPOINT_SUFFIX + "\n";
      counter++;
    }
    if (htmlNode.nodeType === 1) {
      if (!hasTagName(htmlNode, 'body')) {
        htmlNode.innerHTML = "  " + htmlNode.innerHTML + "  ";
      }
      ensureTextNodeBetweenChildElements(htmlNode);
      ref = htmlNode.childNodes;
      for (i = 0, len = ref.length; i < len; i++) {
        childNode = ref[i];
        counter = exports.addCheckpoints(childNode, counter);
      }
    }
    return counter;
  };

  exports.deleteQuotationTags = function(htmlNode, counter, quotationCheckpoints) {
    var childNode, childTagInQuotation, i, j, len, len1, quotationChildren, ref, ref1, tagInQuotation;
    tagInQuotation = true;
    if (htmlNode.nodeType === 3) {
      if (!quotationCheckpoints[counter]) {
        tagInQuotation = false;
      }
      counter++;
      return [counter, tagInQuotation];
    }
    if (htmlNode.nodeType === 1) {
      childTagInQuotation = false;
      quotationChildren = [];
      if (!hasTagName(htmlNode, 'body')) {
        htmlNode.innerHTML = "  " + htmlNode.innerHTML + "  ";
      }
      ensureTextNodeBetweenChildElements(htmlNode);
      ref = htmlNode.childNodes;
      for (i = 0, len = ref.length; i < len; i++) {
        childNode = ref[i];
        ref1 = exports.deleteQuotationTags(childNode, counter, quotationCheckpoints), counter = ref1[0], childTagInQuotation = ref1[1];
        tagInQuotation = tagInQuotation && childTagInQuotation;
        if (childTagInQuotation) {
          quotationChildren.push(childNode);
        }
      }
    }
    if (tagInQuotation) {
      return [counter, tagInQuotation];
    } else {
      for (j = 0, len1 = quotationChildren.length; j < len1; j++) {
        childNode = quotationChildren[j];
        htmlNode.removeChild(childNode);
      }
      return [counter, tagInQuotation];
    }
  };

  exports.cutGmailQuote = function(emailDocument) {
    var nodesArray;
    nodesArray = emailDocument.getElementsByClassName('gmail_quote');
    if (!(nodesArray.length > 0)) {
      return false;
    }
    removeNodes(nodesArray);
    return true;
  };

  exports.cutMicrosoftQuote = function(emailDocument) {
    var afterSplitter, parentElement, splitterElement;
    splitterElement = findMicrosoftSplitter(emailDocument);
    if (splitterElement == null) {
      return false;
    }
    parentElement = splitterElement.parentElement;
    afterSplitter = splitterElement.nextElementSibling;
    while (afterSplitter != null) {
      parentElement.removeChild(afterSplitter);
      afterSplitter = splitterElement.nextElementSibling;
    }
    parentElement.removeChild(splitterElement);
    return true;
  };

  exports.cutBlockQuote = function(emailDocument) {
    var blockquoteElement, div, parent, xpathQuery, xpathResult;
    xpathQuery = '(.//blockquote)[not(ancestor::blockquote)][last()]';
    xpathResult = emailDocument.evaluate(xpathQuery, emailDocument, null, 9, null);
    blockquoteElement = xpathResult.singleNodeValue;
    if (blockquoteElement == null) {
      return false;
    }
    div = emailDocument.createElement('div');
    parent = blockquoteElement.parentElement;
    parent.removeChild(blockquoteElement);
    return true;
  };

  exports.cutById = function(emailDocument) {
    var found, i, len, quoteElement, quoteId;
    found = false;
    for (i = 0, len = QUOTE_IDS.length; i < len; i++) {
      quoteId = QUOTE_IDS[i];
      quoteElement = emailDocument.getElementById(quoteId);
      if (quoteElement != null) {
        found = true;
        quoteElement.parentElement.removeChild(quoteElement);
      }
    }
    return found;
  };

  exports.cutFromBlock = function(emailDocument) {
    var afterSplitter, fromBlock, lastBlock, parentDiv, ref, splitterElement, textNode, xpathQuery, xpathResult;
    xpathQuery = "//*[starts-with(normalize-space(.), 'From:')]|//*[starts-with(normalize-space(.), 'Date:')]";
    xpathResult = emailDocument.evaluate(xpathQuery, emailDocument, null, 5, null);
    while (fromBlock = xpathResult.iterateNext()) {
      lastBlock = fromBlock;
    }
    if (lastBlock != null) {
      parentDiv = findParentDiv(lastBlock);
      if ((parentDiv != null) && !elementIsAllContent(parentDiv)) {
        parentDiv.parentElement.removeChild(parentDiv);
        return true;
      }
    }
    xpathQuery = "//text()[starts-with(normalize-space(.), 'From:')]|//text()[starts-with(normalize-space(.), 'Date:')]";
    xpathResult = emailDocument.evaluate(xpathQuery, emailDocument, null, 9, null);
    textNode = xpathResult.singleNodeValue;
    if (textNode == null) {
      return false;
    }
    if (isTextNodeWrappedInSpan(textNode)) {
      return false;
    }
    splitterElement = textNode.previousSibling;
    if (splitterElement != null) {
      if ((ref = splitterElement.parentElement) != null) {
        ref.removeChild(splitterElement);
      }
    }
    afterSplitter = textNode.nextSibling;
    while (afterSplitter != null) {
      afterSplitter.parentNode.removeChild(afterSplitter);
      afterSplitter = textNode.nextSibling;
    }
    textNode.parentNode.removeChild(textNode);
    return true;
  };

  findParentDiv = function(element) {
    while ((element != null) && (element.parentElement != null)) {
      if (hasTagName(element, 'div')) {
        return element;
      } else {
        element = element.parentElement;
      }
    }
    return null;
  };

  elementIsAllContent = function(element) {
    var maybeBody;
    maybeBody = element.parentElement;
    return (maybeBody != null) && hasTagName(maybeBody, 'body') && maybeBody.childNodes.length === 1;
  };

  isTextNodeWrappedInSpan = function(textNode) {
    var parentElement;
    parentElement = textNode.parentElement;
    return (parentElement != null) && hasTagName(parentElement, 'span') && parentElement.childNodes.length === 1;
  };

  BREAK_TAG_REGEX = new RegExp('<br\\s*[/]?>', 'gi');

  exports.replaceBreakTagsWithLineFeeds = function(emailDocument) {
    var currentHtml;
    currentHtml = emailDocument.body.innerHTML;
    return emailDocument.body.innerHTML = currentHtml.replace(BREAK_TAG_REGEX, "\n");
  };

  OUTLOOK_SPLITTER_QUERY_SELECTORS = {
    outlook2007: "div[style='border:none;border-top:solid #B5C4DF 1.0pt;padding:3.0pt 0cm 0cm 0cm']",
    outlookForAndroid: "div[style='border:none;border-top:solid #E1E1E1 1.0pt;padding:3.0pt 0cm 0cm 0cm']",
    windowsMail: "div[style='padding-top: 5px; border-top-color: rgb(229, 229, 229); border-top-width: 1px; border-top-style: solid;']"
  };

  OUTLOOK_XPATH_SPLITTER_QUERIES = {
    outlook2003: "//div/div[@class='MsoNormal' and @align='center' and @style='text-align:center']/font/span/hr[@size='3' and @width='100%' and @align='center' and @tabindex='-1']"
  };

  OUTLOOK_SPLITTER_QUOTE_IDS = {
    office365: '#divRplyFwdMsg'
  };

  findMicrosoftSplitter = function(emailDocument) {
    var _, possibleSplitterElements, querySelector, quoteId, splitterElement, xpathQuery;
    possibleSplitterElements = [];
    for (_ in OUTLOOK_SPLITTER_QUERY_SELECTORS) {
      querySelector = OUTLOOK_SPLITTER_QUERY_SELECTORS[_];
      if ((splitterElement = findOutlookSplitterWithQuerySelector(emailDocument, querySelector))) {
        possibleSplitterElements.push(splitterElement);
      }
    }
    for (_ in OUTLOOK_XPATH_SPLITTER_QUERIES) {
      xpathQuery = OUTLOOK_XPATH_SPLITTER_QUERIES[_];
      if ((splitterElement = findOutlookSplitterWithXpathQuery(emailDocument, xpathQuery))) {
        possibleSplitterElements.push(splitterElement);
      }
    }
    for (_ in OUTLOOK_SPLITTER_QUOTE_IDS) {
      quoteId = OUTLOOK_SPLITTER_QUOTE_IDS[_];
      if ((splitterElement = findOutlookSplitterWithQuoteId(emailDocument, quoteId))) {
        possibleSplitterElements.push(splitterElement);
      }
    }
    if (!possibleSplitterElements.length) {
      return null;
    }
    return possibleSplitterElements.sort(compareByDomPosition)[0];
  };

  DOCUMENT_POSITION_PRECEDING = 2;

  DOCUMENT_POSITION_FOLLOWING = 4;

  compareByDomPosition = function(elementA, elementB) {
    var documentPositionComparison;
    documentPositionComparison = elementA.compareDocumentPosition(elementB);
    if (documentPositionComparison & DOCUMENT_POSITION_PRECEDING) {
      return 1;
    } else if (documentPositionComparison & DOCUMENT_POSITION_FOLLOWING) {
      return -1;
    }
    return 0;
  };

  findOutlookSplitterWithXpathQuery = function(emailDocument, xpathQuery) {
    var splitterElement, xpathResult;
    xpathResult = emailDocument.evaluate(xpathQuery, emailDocument, null, 9, null);
    splitterElement = xpathResult.singleNodeValue;
    if (splitterElement != null) {
      splitterElement = splitterElement.parentElement.parentElement;
      splitterElement = splitterElement.parentElement.parentElement;
    }
    return splitterElement;
  };

  findOutlookSplitterWithQuerySelector = function(emailDocument, query) {
    var splitterElement, splitterResult;
    splitterResult = emailDocument.querySelectorAll(query);
    if (!(splitterResult.length > 1)) {
      return;
    }
    splitterElement = splitterResult[1];
    if ((splitterElement.parentElement != null) && splitterElement === splitterElement.parentElement.children[0]) {
      splitterElement = splitterElement.parentElement;
    }
    return splitterElement;
  };

  findOutlookSplitterWithQuoteId = function(emailDocument, id) {
    var splitterResult;
    splitterResult = emailDocument.querySelectorAll(id);
    if (!splitterResult.length) {
      return;
    }
    return splitterResult[0];
  };

  removeNodes = function(nodesArray) {
    var i, index, node, ref, ref1, results;
    results = [];
    for (index = i = ref = nodesArray.length - 1; ref <= 0 ? i <= 0 : i >= 0; index = ref <= 0 ? ++i : --i) {
      node = nodesArray[index];
      results.push(node != null ? (ref1 = node.parentNode) != null ? ref1.removeChild(node) : void 0 : void 0);
    }
    return results;
  };

  ensureTextNodeBetweenChildElements = function(element) {
    var currentNode, dom, newTextNode, results;
    dom = element.ownerDocument;
    currentNode = element.childNodes[0];
    if (!currentNode) {
      newTextNode = dom.createTextNode(' ');
      element.appendChild(newTextNode);
      return;
    }
    results = [];
    while (currentNode.nextSibling) {
      if (currentNode.nodeType === 1 && currentNode.nextSibling.nodeType === 1) {
        newTextNode = dom.createTextNode(' ');
        element.insertBefore(newTextNode, currentNode.nextSibling);
      }
      results.push(currentNode = currentNode.nextSibling);
    }
    return results;
  };

  hasTagName = function(element, tagName) {
    return element.tagName.toLowerCase() === tagName;
  };

}).call(this);


/***/ }),
/* 3418 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
  exports.DELIMITER = new RegExp('\r?\n');

  exports.FWD = new RegExp("^[-]+[ ]*Forwarded message[ ]*[-]+$", 'im');

  exports.ON_DATE_SMB_WROTE = new RegExp("(-*[>]?[ ]?(On|Le|W dniu|Op|Am|P\xe5|Den)[ ].*(,|u\u017cytkownik)(.*\n){0,2}.*(wrote|sent|a \xe9crit|napisa\u0142|schreef|verzond|geschreven|schrieb|skrev):?-*)");

  exports.ON_DATE_WROTE_SMB = new RegExp('(-*[>]?[ ]?(Op|Am)[ ].*(.*\n){0,2}.*(schreef|verzond|geschreven|schrieb)[ ]*.*:)');

  exports.QUOTATION = new RegExp('((?:s|(?:me*){2,}).*me*)[te]*$');

  exports.EMPTY_QUOTATION = new RegExp('((?:s|(?:me*){2,}))e*');

  exports.ORIGINAL_MESSAGE = new RegExp('[\\s]*[-]+[ ]*(Original Message|Reply Message|Urspr\xfcngliche Nachricht|Antwort Nachricht|Oprindelig meddelelse)[ ]*[-]+', 'i');

  exports.FROM_COLON_OR_DATE_COLON = new RegExp('(_+\r?\n)?[\\s]*(:?[*]?From|Van|De|Von|Fra|Fr\xe5n|Date|Datum|Envoy\xe9|Skickat|Sendt)[\\s]?:[*]? .*', 'i');

  exports.DATE_PERSON = new RegExp('(\\d+/\\d+/\\d+|\\d+\\.\\d+\\.\\d+).*@');

  exports.SPELLED_OUT_DATE = new RegExp('\\S{3,10}, \\d\\d? \\S{3,10} 20\\d\\d,? \\d\\d?:\\d\\d(:\\d\\d)?( \\S+){3,6}@\\S+:');

  exports.LINK = new RegExp('<(https?://[^>]*)>');

  exports.NORMALIZED_LINK = new RegExp('@@(https?://[^>@]*)@@');

  exports.PARENTHESIS_LINK = new RegExp('\\(https?://');

  exports.QUOT_PATTERN = new RegExp('^>+ ?');

  exports.NO_QUOT_LINE = new RegExp('^[^>].*[\S].*');

  exports.SPLITTER_PATTERNS = [exports.ORIGINAL_MESSAGE, exports.DATE_PERSON, exports.ON_DATE_SMB_WROTE, exports.ON_DATE_WROTE_SMB, exports.FROM_COLON_OR_DATE_COLON, exports.SPELLED_OUT_DATE];

  exports.BEGIN_FROM_OR_DATE = new RegExp('^From:|^Date');

}).call(this);


/***/ }),
/* 3419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertComment = function EditorInsertComment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
  );
};
EditorInsertComment = (0, _pure2.default)(EditorInsertComment);
EditorInsertComment.displayName = 'EditorInsertComment';
EditorInsertComment.muiName = 'SvgIcon';

exports.default = EditorInsertComment;

/***/ }),
/* 3420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationChatBubble = function CommunicationChatBubble(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z' })
  );
};
CommunicationChatBubble = (0, _pure2.default)(CommunicationChatBubble);
CommunicationChatBubble.displayName = 'CommunicationChatBubble';
CommunicationChatBubble.muiName = 'SvgIcon';

exports.default = CommunicationChatBubble;

/***/ }),
/* 3421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _fileDownload = __webpack_require__(1997);

var _fileDownload2 = _interopRequireDefault(_fileDownload);

var _add = __webpack_require__(2013);

var _add2 = _interopRequireDefault(_add);

var _removeRedEye = __webpack_require__(3422);

var _removeRedEye2 = _interopRequireDefault(_removeRedEye);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _aphrodite = __webpack_require__(123);

var _aphrodite2 = _interopRequireDefault(_aphrodite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Widgets = function Widgets(_ref, _ref2) {
  var addedToContractId = _ref.addedToContractId,
      downloadFn = _ref.downloadFn,
      addToContractFn = _ref.addToContractFn,
      hide = _ref.hide,
      addedToCurrentContract = _ref.addedToCurrentContract,
      inContractThread = _ref.inContractThread,
      allowFilesToBeAddedToContract = _ref.allowFilesToBeAddedToContract;
  var router = _ref2.router;

  var styleSheets = _aphrodite2.default.StyleSheet.create({
    container: { display: hide ? 'none' : 'flex', alignItems: 'center', justifyContent: 'space-between', marginLeft: '4px' },
    'flex-tc-sb': { display: 'flex', alignItems: 'center', justifyContent: 'space-between' }
  });

  return _react2.default.createElement(
    'div',
    { className: _aphrodite2.default.css(styleSheets.container) },
    _ramda2.default.call(_ramda2.default.cond([[function () {
      return inContractThread && addedToCurrentContract;
    }, _ramda2.default.always(_react2.default.createElement(
      'div',
      { className: _aphrodite2.default.css(styleSheets['flex-tc-sb']) },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-check', color: 'green' }),
      _react2.default.createElement(
        'span',
        { style: { color: 'green', paddingRight: '8px' } },
        'Added'
      )
    ))], [function () {
      return !inContractThread && addedToContractId;
    }, _ramda2.default.always(_react2.default.createElement(
      _materialUi.FlatButton,
      {
        style: { border: '1px solid green', height: '30px', lineHeight: '30px', minWidth: '130px' },
        onTouchTap: function onTouchTap() {
          return router.push('/contracting/contract/' + addedToContractId + '/details');
        }
      },
      _react2.default.createElement(
        'div',
        { className: _aphrodite2.default.css(styleSheets['flex-tc-sb']), style: { paddingLeft: '4px' } },
        _react2.default.createElement(_removeRedEye2.default, { color: 'green', style: { marginLeft: '0px', width: '20px', height: '20px' } }),
        _react2.default.createElement(
          'span',
          { style: { textTransform: 'none', color: 'green', padding: '0 4px' } },
          'View Contract'
        )
      )
    ))], [function () {
      return allowFilesToBeAddedToContract;
    }, _ramda2.default.always(_react2.default.createElement(
      _materialUi.FlatButton,
      {
        style: { border: '1px solid #49708A', height: '30px', lineHeight: '30px', minWidth: inContractThread ? '167px' : '137px' },
        onTouchTap: addToContractFn
      },
      _react2.default.createElement(
        'div',
        { className: _aphrodite2.default.css(styleSheets['flex-tc-sb']) },
        _react2.default.createElement(_add2.default, { color: '#49708A', style: { marginLeft: '0px' } }),
        _react2.default.createElement(
          'span',
          { style: { textTransform: 'none', color: '#49708A', padding: '0 4px' } },
          inContractThread ? 'Add to This Contract' : 'Add to Contract'
        )
      )
    ))]])),
    _react2.default.createElement(_materialUi.FlatButton, {
      icon: _react2.default.createElement(_fileDownload2.default, { color: '#49708A', style: { marginLeft: '0px' } }),
      style: { border: '1px solid #49708A', marginLeft: '4px', height: '30px', lineHeight: '30px', minWidth: '40px' },
      label: '',
      labelStyle: { textTransform: 'none', color: '#49708A', padding: '4px', verticalAlign: '', top: '-1px' },
      onTouchTap: downloadFn
    })
  );
};

Widgets.contextTypes = {
  router: _react.PropTypes.object.isRequired
};

exports.default = Widgets;

/***/ }),
/* 3422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageRemoveRedEye = function ImageRemoveRedEye(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
  );
};
ImageRemoveRedEye = (0, _pure2.default)(ImageRemoveRedEye);
ImageRemoveRedEye.displayName = 'ImageRemoveRedEye';
ImageRemoveRedEye.muiName = 'SvgIcon';

exports.default = ImageRemoveRedEye;

/***/ }),
/* 3423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRouterRedux = __webpack_require__(27);

var _activityWithIcon = __webpack_require__(1266);

var _activityWithIcon2 = _interopRequireDefault(_activityWithIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var propTypes = {
  contract: _react.PropTypes.object,
  routerPush: _react.PropTypes.func,
  companyType: _react.PropTypes.string
};

var styles = {};

var CommentContract = function (_React$Component) {
  _inherits(CommentContract, _React$Component);

  function CommentContract() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CommentContract);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommentContract.__proto__ || Object.getPrototypeOf(CommentContract)).call.apply(_ref, [this].concat(args))), _this), _this.jumpToContract = function () {
      var _this$props = _this.props,
          push = _this$props.routerPush,
          currentVersionId = _this$props.contract.currentVersionId;

      var url = '/contracting/contract/' + currentVersionId + '/details';
      push(url);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CommentContract, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var contract = this.props.contract;
      var contractName = contract.contractName,
          action = contract.action,
          emailChanged = contract.emailChanged,
          companyType = contract.companyType;

      var actionCheck = function () {
        if (action === 'Created') return 'Created';
        if (action === 'Contract Created') {
          if (companyType === 'Supplier') return 'Rates Sent';
          return 'Rates Received';
        }
        if (action === 'Contract Updated') return 'Contract Updated';
        if (action === 'Request Created') return 'Request Sent';
        if (action === 'Responded') return 'Responded To Contract Request';
        if (action === 'Downloaded') return 'Downloaded Contract';
        if (action === 'Viewed') return 'Viewed Contract';
        if (action === 'Resent Contract' || action === 'Resent Request') return action;
      }();
      return _react2.default.createElement(
        'div',
        { style: { padding: '8px' } },
        _react2.default.createElement(
          'div',
          { style: { display: contract.diff ? 'none' : 'block' } },
          _react2.default.createElement(
            'a',
            { style: { marginLeft: '0.5em', cursor: 'pointer' }, onClick: this.jumpToContract },
            action === 'Created' && contractName.indexOf('Rate request') > -1 ? contractName.replace('Rate request', 'Workspace') : contractName
          ),
          actionCheck ? _react2.default.createElement(
            'span',
            { style: { marginLeft: '0.5em', fontWeight: 'bold' } },
            actionCheck
          ) : undefined
        ),
        !isNilOrEmpty(emailChanged) && _react2.default.createElement(
          'div',
          { style: { lineHeight: '20px' } },
          'Changed Email from ',
          _react2.default.createElement(
            'span',
            { style: { color: '#00bcd4' } },
            _ramda2.default.path(['oldEmail'], emailChanged)
          ),
          ' to ',
          _react2.default.createElement(
            'span',
            { style: { color: '#00bcd4' } },
            _ramda2.default.path(['newEmail'], emailChanged)
          )
        ),
        _react2.default.createElement(_activityWithIcon2.default, contract)
      );
    }
  }]);

  return CommentContract;
}(_react2.default.Component);

CommentContract.propTypes = propTypes;

CommentContract.defaultProps = {
  showContactLink: false
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var user = _ref2.user,
      contracting = _ref2.contracting;
  return {
    isAnAdmin: user.get('isAnAdmin'),
    companyType: user.getIn(['user', 'type']),
    historyFeedId: contracting.contractActivitiesProducts.getIn(['activities', 'historyFeedId'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  routerPush: _reactRouterRedux.push
})((0, _reactJss2.default)(styles)(CommentContract));

/***/ }),
/* 3424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setContractingCommentBoxFocus = exports.contractingCancelComment = exports.contractingAddFile = exports.contractingCommentInput = undefined;
exports.submitContractingComment = submitContractingComment;

var _s3ContractingFilesUpload = __webpack_require__(1534);

var _s3ContractingFilesUpload2 = _interopRequireDefault(_s3ContractingFilesUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function submitContractingComment(opts) {
  return function (dispatch) {
    var contractId = opts.contractId,
        comment = opts.comment,
        historyFeedId = opts.historyFeedId;

    var files = opts.files || [];
    return dispatch({
      type: 'SUBMIT_CONTRACTING_COMMENT',
      payload: {
        contractId: contractId,
        historyFeedId: historyFeedId,
        files: files,
        message: comment
      }
    });
  };
}

var contractingCommentInput = exports.contractingCommentInput = function contractingCommentInput(payload) {
  return { type: 'HANDLE_CONTRACTING_COMMENT_INPUT', payload: payload };
};
var contractingAddFile = exports.contractingAddFile = function contractingAddFile(payload) {
  return { type: 'HANDLE_CONTRACTING_COMMENT_FILE_INPUT', payload: payload };
};
var contractingCancelComment = exports.contractingCancelComment = function contractingCancelComment(payload) {
  return { type: 'CANCEL_CONTRACTING_COMMENT', payload: payload };
};
var setContractingCommentBoxFocus = exports.setContractingCommentBoxFocus = function setContractingCommentBoxFocus(payload) {
  return { type: 'SET_CONTRACTING_COMMENT_FOCUS', payload: payload };
};

/***/ }),
/* 3425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  header: {
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    flexWrap: 'no-wrap',
    justifyContent: 'space-between',
    marginBottom: '8px',
    padding: '6px',
    textAlign: 'center'
  }
};

var CommentsTitle = function (_Component) {
  _inherits(CommentsTitle, _Component);

  function CommentsTitle() {
    _classCallCheck(this, CommentsTitle);

    return _possibleConstructorReturn(this, (CommentsTitle.__proto__ || Object.getPrototypeOf(CommentsTitle)).apply(this, arguments));
  }

  _createClass(CommentsTitle, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: '' + this.props.classes.header + (this.props.className ? ' ' + this.props.className : '') },
        _react2.default.createElement(
          'div',
          null,
          'These messages are associated with a contract with ',
          _react2.default.createElement(
            'b',
            null,
            this.props.recipientName
          ),
          '.'
        ),
        _react2.default.createElement(_materialUi.FlatButton, {
          label: 'View Contract',
          secondary: true,
          onTouchTap: this.props.linkAction,
          style: { border: '1px solid green', marginTop: '6px' },
          labelStyle: { color: 'green' }
        })
      );
    }
  }]);

  return CommentsTitle;
}(_react.Component);

CommentsTitle.propTypes = {
  classes: _react.PropTypes.object,
  className: _react.PropTypes.string,
  linkAction: _react.PropTypes.func,
  recipientName: _react.PropTypes.string
};

exports.default = (0, _reactJss2.default)(styles)(CommentsTitle);

/***/ }),
/* 3426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _materialUi = __webpack_require__(3);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _noteContent = __webpack_require__(2014);

var _noteContent2 = _interopRequireDefault(_noteContent);

var _commentBox = __webpack_require__(1112);

var _commentBox2 = _interopRequireDefault(_commentBox);

var _actions = __webpack_require__(476);

var _actions2 = __webpack_require__(737);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  container: {
    backgroundColor: 'rgb(240, 244, 247)',
    height: 'calc(100vh - 268px)',
    paddingLeft: '0 !important',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  containerSupplier: {
    height: 'calc(100vh - 168px) !important'
  },
  workspaceContent: {
    backgroundColor: 'white',
    flex: '1 1 auto',
    overflowX: 'hidden',
    overflowY: 'scroll',
    padding: '8px 2%'
  }
};

var NotesInContracting = function (_Component) {
  _inherits(NotesInContracting, _Component);

  function NotesInContracting(props) {
    _classCallCheck(this, NotesInContracting);

    var _this = _possibleConstructorReturn(this, (NotesInContracting.__proto__ || Object.getPrototypeOf(NotesInContracting)).call(this, props));

    _this.handleComment = function (input) {
      _this.setState({ currentComment: input });
    };

    _this.handleCancel = function () {
      _this.setState({ currentComment: '' });
      _this.setState({ disableSend: false });
      _this.clearInput();
    };

    _this.submitComment = function () {
      _this.setState({ disableSend: true }, function () {
        _this.props.sendMessage({
          contractHFIds: [_this.props.historyFeed],
          type: 'note',
          messageText: _this.state.currentComment,
          files: _this.state.attachedFiles
        });
      });
    };

    _this.handleAttachFile = function (fileList) {
      _this.setState({ attachedFiles: fileList });
    };

    _this.conversationDOM = function () {
      return document.getElementsByClassName('conversation')[0];
    };

    _this.scrollToBottom = (0, _lodash2.default)(function () {
      var container = _this.conversationDOM();
      if (container) container.scrollTop = container.scrollHeight - container.clientHeight;
    }, 100);

    _this.defaultState = { // don't include object in values
      currentComment: '',
      disableSend: false,
      attachedFiles: []
    };
    _this.state = _extends({}, _this.defaultState);
    return _this;
  }

  _createClass(NotesInContracting, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // load the internal notes content
      // this.props.changeSelection(urlVals.connectionId, 'notes', urlVals.contractId);
      if (this.props.body.length > 0) this.scrollToBottom();else this.props.getNotes();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.messageCreating && !this.state.disableSend) {
        // sending to server
        this.setState({ disableSend: true });
      }
      if (!nextProps.messageCreating && this.state.disableSend) {
        // message has been sent !
        this.setState({ disableSend: false });
        if (!nextProps.messageCreateError) {
          // and no error, wow
          this.setState(this.defaultState);
          this.clearInput();
        }
      }
      if (this.props.loading && !nextProps.loading && nextProps.body.length !== this.props.body.length) {
        this.scrollToBottom();
      }
    }
    // shouldComponentUpdate(nextProps, nextState) {
    //   return !R.equals(this.props.body, nextProps.body) || !R.equals(this.state, nextState);
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          body = _props.body,
          classes = _props.classes,
          companyType = _props.companyType;

      return _react2.default.createElement(
        'div',
        { className: '' + classes.container + (companyType === 'Supplier' ? ' ' + this.props.classes.containerSupplier : '') },
        _react2.default.createElement(
          'div',
          { className: 'conversation ' + classes.workspaceContent },
          body.map(function (message) {
            return _react2.default.createElement(_noteContent2.default, {
              key: message.messageId,
              itemId: message.messageId,
              bodyText: message.bodyText,
              bodyJson: message.bodyJson,
              attachments: message.attachments,
              authorname: message.creatorMeta.name || message.creatorEmail,
              timestamp: message.createdAt,
              handleRemove: _this2.props.deleteMessage,
              handleAddToContract: _this2.props.addFilesToContract,
              disallowAddToContract: companyType === 'Supplier',
              disabled: message.disabled || false
            });
          })
        ),
        _react2.default.createElement(_materialUi.Divider, null),
        _react2.default.createElement(_commentBox2.default, {
          comment: this.state.currentComment,
          handleInput: this.handleComment,
          attachFile: this.handleAttachFile,
          attachedFiles: this.state.attachedFiles,
          submitComment: this.submitComment,
          cancelComment: this.handleCancel,
          setClear: function setClear(clear) {
            return _this2.clearInput = clear;
          }
          // setFocus: PropTypes.func,
          , disableSend: this.state.disableSend,
          internal: true
        })
      );
    }
  }]);

  return NotesInContracting;
}(_react.Component);

NotesInContracting.propTypes = {
  body: _react.PropTypes.array,
  buyerId: _react.PropTypes.string,
  changeSelection: _react.PropTypes.func,
  classes: _react.PropTypes.object,
  companyType: _react.PropTypes.string,
  loading: _react.PropTypes.bool,
  historyFeed: _react.PropTypes.string,
  messageCreateError: _react.PropTypes.bool,
  messageCreating: _react.PropTypes.bool,
  sendMessage: _react.PropTypes.func,
  suppplierId: _react.PropTypes.string,
  deleteMessage: _react.PropTypes.func,
  addFilesToContract: _react.PropTypes.func,
  partnerId: _react.PropTypes.string,
  getNotes: _react.PropTypes.func
};

NotesInContracting.defaultProps = {
  body: []
};

exports.default = (0, _reactRedux.connect)(function (_ref) {
  var workspace = _ref.workspace,
      user = _ref.user,
      contracting = _ref.contracting;
  return {
    body: contracting.contractActivitiesProducts.get('notes').toJS(),
    messageCreating: workspace.messageCreating,
    messageCreateError: workspace.messageCreateError,
    loading: workspace.conversationsFetching,
    companyType: user.getIn(['user', 'type']),
    historyFeed: contracting.contractActivitiesProducts.getIn(['leftNav', 'historyFeedId']),
    supplierId: contracting.contractActivitiesProducts.getIn(['leftNav', 'supplierId']),
    buyerId: contracting.contractActivitiesProducts.getIn(['leftNav', 'buyerId']),
    email: contracting.contractActivitiesProducts.getIn(['leftNav', 'email'])
  };
}, {
  getNotes: _actions2.getNotes,
  sendMessage: _actions.sendMessage,
  deleteMessage: function deleteMessage(payload) {
    return { type: '{contract} DELETE_CONTRACT_NOTE', payload: payload };
  },
  addFilesToContract: _actions.addFilesToContract
})((0, _reactJss2.default)(styles)(NotesInContracting));

/***/ }),
/* 3427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _leftColumn = __webpack_require__(3428);

var _leftColumn2 = _interopRequireDefault(_leftColumn);

var _rightColumn = __webpack_require__(3430);

var _rightColumn2 = _interopRequireDefault(_rightColumn);

var _materialUi = __webpack_require__(3);

var _scrollToElement = __webpack_require__(859);

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

var _contractActivitiesProductsActions = __webpack_require__(493);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  getProductDetails: _react2.default.PropTypes.func,
  params: _react2.default.PropTypes.object,
  productDoesnotExistInDoc: _react2.default.PropTypes.bool,
  isProductEmpty: _react2.default.PropTypes.bool,
  ratePackageIndex: _react2.default.PropTypes.number,
  loading: _react2.default.PropTypes.bool
};

var Product = function (_React$Component) {
  _inherits(Product, _React$Component);

  function Product() {
    _classCallCheck(this, Product);

    return _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).apply(this, arguments));
  }

  _createClass(Product, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          params = _props.params,
          getProductDetails = _props.getProductDetails;

      getProductDetails(params.collection || 'contract', params.contractId, params.productId, params.ratePackage);
      var scrollToAnchor = function scrollToAnchor() {
        if (window.location.hash) {
          var element = document.querySelector(window.location.hash);
          if (element) (0, _scrollToElement2.default)(window.location.hash, { offset: -70 });
          if (element.onClick) element.click();
        }
      };
      scrollToAnchor();
      window.onhashchange = scrollToAnchor;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var params = nextProps.params,
          getProductDetails = nextProps.getProductDetails;

      if (this.props.params !== nextProps.params) getProductDetails(params.collection || 'contract', params.contractId, params.productId, params.ratePackage);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          productDoesnotExistInDoc = _props2.productDoesnotExistInDoc,
          extraProps = _objectWithoutProperties(_props2, ['productDoesnotExistInDoc']);

      if (this.props.loading) {
        return _react2.default.createElement(
          'div',
          { style: { textAlign: 'center', paddingTop: '56px' } },
          _react2.default.createElement(_materialUi.CircularProgress, { size: 100, thickness: 7 })
        );
      }
      if (productDoesnotExistInDoc) {
        return _react2.default.createElement(
          'div',
          { style: { marginTop: '50px', textAlign: 'center', fontSize: '20px' } },
          'This product does not exist in this document.'
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'product-column-flex' },
        _react2.default.createElement(_leftColumn2.default, extraProps),
        _react2.default.createElement(_rightColumn2.default, extraProps)
      );
    }
  }]);

  return Product;
}(_react2.default.Component);

Product.propTypes = propTypes;

exports.default = (0, _reactRedux.connect)(function (_ref) {
  var contracting = _ref.contracting;

  var rightSideContent = contracting.contractActivitiesProducts.toJS().rightSideContent;
  var allFields = ['extras', 'offers', 'seasons', 'seasonRates', 'blackouts', 'productPolicy', 'allocation'];
  var isProductEmpty = allFields.every(function (key) {
    return rightSideContent[key] && !rightSideContent[key].length;
  });
  return {
    loading: contracting.contractActivitiesProducts.get('contentLoading'),
    ratePackageIndex: rightSideContent.ratePackageIndex,
    isProductEmpty: isProductEmpty
  };
}, {
  getProductDetails: _contractActivitiesProductsActions.getProductDetails
})(Product);

/***/ }),
/* 3428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _leftThreeRates = __webpack_require__(3429);

var _leftThreeRates2 = _interopRequireDefault(_leftThreeRates);

var _leftFourOffers = __webpack_require__(2016);

var _leftFourOffers2 = _interopRequireDefault(_leftFourOffers);

var _leftExtras = __webpack_require__(2017);

var _leftExtras2 = _interopRequireDefault(_leftExtras);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeftColumn = function LeftColumn(props) {
  return _react2.default.createElement(
    'div',
    { style: { width: '65%', padding: '24px', float: 'left' } },
    _react2.default.createElement(_leftThreeRates2.default, props),
    _react2.default.createElement(_leftFourOffers2.default, props),
    _react2.default.createElement(_leftExtras2.default, props)
  );
};

LeftColumn.propTypes = {
  reducerName: _react.PropTypes.string.isRequired,
  openAddEditContractDialog: _react.PropTypes.func.isRequired,
  deleteFromProduct: _react.PropTypes.func,
  supplierEditable: _react.PropTypes.bool,
  contractState: _react.PropTypes.string,
  productType: _react.PropTypes.string
};

var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var contracting = _ref.contracting;
  var reducerName = _ref2.reducerName;
  return {
    supplierEditable: contracting[reducerName].getIn(['leftNav', 'supplierEditable']),
    contractState: contracting[reducerName].getIn(['leftNav', 'contractState']),
    productType: contracting[reducerName].getIn(['rightSideContent', 'productType'])
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(LeftColumn);

/***/ }),
/* 3429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rateTableTemplateContainer = __webpack_require__(632);

var _rateTableTemplateContainer2 = _interopRequireDefault(_rateTableTemplateContainer);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _seasonErrors = __webpack_require__(1976);

var _seasonErrors2 = _interopRequireDefault(_seasonErrors);

var _seasonForSeasonRates = __webpack_require__(2015);

var _seasonForSeasonRates2 = _interopRequireDefault(_seasonForSeasonRates);

var _helperLink = __webpack_require__(495);

var _helperLink2 = _interopRequireDefault(_helperLink);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  supplierEditable: _react.PropTypes.bool,
  seasonRates: _react.PropTypes.array,
  addRates: _react.PropTypes.func,
  deleteFromProduct: _react.PropTypes.func,
  editSeason: _react.PropTypes.func,
  openAddEditContractDialog: _react.PropTypes.func,
  productType: _react.PropTypes.string,
  overlappedSeasonRates: _react.PropTypes.array,
  notCompletedRatePackages: _react.PropTypes.array,
  existingSeasons: _react.PropTypes.array,
  selectedPackage: _react.PropTypes.string,
  ratePackages: _react.PropTypes.array,
  ratePackageNames: _react.PropTypes.array,
  contractingPeriod: _react.PropTypes.object,
  onRatePackageChange: _react.PropTypes.func,
  openGlobalAlert: _react.PropTypes.func
};

var LeftThreeRates = function (_Component) {
  _inherits(LeftThreeRates, _Component);

  function LeftThreeRates() {
    _classCallCheck(this, LeftThreeRates);

    var _this = _possibleConstructorReturn(this, (LeftThreeRates.__proto__ || Object.getPrototypeOf(LeftThreeRates)).call(this));

    _this.state = { selectedPackage: 'Primary' };
    return _this;
  }

  _createClass(LeftThreeRates, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          seasonRates = _props.seasonRates,
          existingSeasons = _props.existingSeasons,
          openAddEditContractDialog = _props.openAddEditContractDialog,
          productType = _props.productType,
          supplierEditable = _props.supplierEditable,
          _deleteFromProduct = _props.deleteFromProduct,
          contractingPeriod = _props.contractingPeriod,
          overlappedSeasonRates = _props.overlappedSeasonRates,
          openGlobalAlert = _props.openGlobalAlert;


      var arrayOfDates = existingSeasons ? existingSeasons.reduce(function (result, season) {
        return (0, _ramda.concat)(season.dateRanges || [], result);
      }, []) : [];
      var contractingPeriodCovered = _dateUtils2.default.checkIfFullSeasonCoveredForAProduct(contractingPeriod.startDate, contractingPeriod.endDate, arrayOfDates);
      return _react2.default.createElement(
        'div',
        { id: 'seasonRates' },
        _react2.default.createElement(_helperLink2.default, {
          labelStyle: { marginBottom: '12px' },
          value: 'seasons',
          showSync: Boolean(existingSeasons && existingSeasons.length),
          labelText: 'SEASONS & RATES'
        }),
        existingSeasons && existingSeasons.length ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_seasonErrors2.default, {
            startDate: contractingPeriod.startDate,
            endDate: contractingPeriod.endDate,
            editable: supplierEditable,
            existingSeasons: existingSeasons,
            openAddEditContractDialog: openAddEditContractDialog,
            seasonDateRanges: (0, _ramda.call)((0, _ramda.compose)((0, _ramda.filter)((0, _ramda.has)('seasonStartDate')), (0, _ramda.chain)((0, _ramda.propOr)([], 'dateRanges'))), existingSeasons)
          }),
          (seasonRates.length > existingSeasons.length ? seasonRates : existingSeasons).map(function (season, index) {
            var seasonName = season.seasonName,
                dateRanges = season.dateRanges;

            var rateSets = _ramda2.default.pathOr([], [index, 'rateSets'], seasonRates);
            var dateString = dateRanges && dateRanges.length ? _moment2.default.utc((dateRanges || [{}])[0].seasonStartDate).format('D MMM YYYY') + ' - ' + _moment2.default.utc((dateRanges || [{}])[0].seasonEndDate).format('D MMM YYYY') : '';
            var isNotContractingPeriod = seasonName !== dateString;
            return _react2.default.createElement(
              'div',
              { key: index, style: { marginBottom: '24px' } },
              _react2.default.createElement(_seasonForSeasonRates2.default, {
                existingSeasons: existingSeasons,
                isNotContractingPeriod: isNotContractingPeriod,
                dateRanges: dateRanges,
                seasonName: seasonName,
                contractingPeriod: contractingPeriod,
                seasonRatesIndex: index,
                deleteFromProduct: _deleteFromProduct,
                openAddEditContractDialog: openAddEditContractDialog,
                supplierEditable: supplierEditable
              }),
              _react2.default.createElement(
                'div',
                {
                  style: { border: !_ramda2.default.isEmpty(overlappedSeasonRates) && _ramda2.default.contains(index, overlappedSeasonRates) ? '1px solid red' : 'none', overflow: 'auto' }
                },
                !_ramda2.default.isEmpty(overlappedSeasonRates) && _ramda2.default.contains(index, overlappedSeasonRates) && _react2.default.createElement(
                  'div',
                  { style: { color: 'red', padding: '8px', whitespace: 'pre-wrap' } },
                  productType === 'Accommodation' ? 'Rate sets cannot have overlapping min/max night stays and be applied to the same days of the week.\n\nIn order to have two types of rates for the same days of the week, please either adjust the min/max night stays (so they aren\'t overlapping), or use a rate package.' : 'Rate sets cannot have overlapping days of the week.\n\nPlease either adjust the days of week (so they aren\'t overlapping), or use a rate package.'
                ),
                rateSets.map(function (rateSet, rateSetsIndex) {
                  return _react2.default.createElement(
                    'div',
                    {
                      style: { marginBottom: rateSetsIndex === rateSets.length - 1 ? '' : '16px' },
                      key: 'rateSet' + rateSetsIndex
                    },
                    _react2.default.createElement(_rateTableTemplateContainer2.default, {
                      productType: productType,
                      rateSet: rateSet,
                      showHeader: rateSetsIndex === 0,
                      supplierEditable: supplierEditable,
                      onEdit: function onEdit() {
                        openAddEditContractDialog({
                          type: 'editRates',
                          data: {
                            rateSets: rateSets,
                            rateSetsIndex: rateSetsIndex,
                            seasonRatesIndex: index,
                            seasonName: isNotContractingPeriod ? seasonName : dateString
                          }
                        });
                      },
                      rateSetsIndex: rateSetsIndex,
                      deleteFromProduct: function deleteFromProduct() {
                        openGlobalAlert({
                          text: 'Are you sure you want to delete this rate set?',
                          onOk: function onOk() {
                            return _deleteFromProduct({ seasonRatesIndex: index, rateSetsIndex: rateSetsIndex, updateType: 'DELETE_RATE_SET_FROM_SEASON' });
                          }
                        });
                      }
                    })
                  );
                })
              ),
              supplierEditable && ['Not Operating', 'Dynamic Rates'].indexOf(seasonName) < 0 ? _react2.default.createElement(
                'div',
                {
                  style: { marginTop: '8px', color: rateSets && rateSets.length ? '#00bcd4' : '#f44336', cursor: 'pointer' },
                  onClick: function onClick() {
                    openAddEditContractDialog({
                      type: 'editRates',
                      data: {
                        rateSets: _ramda2.default.append({ new: true }, rateSets),
                        rateSetsIndex: rateSets.length,
                        seasonRatesIndex: index,
                        seasonName: isNotContractingPeriod ? seasonName : dateString
                      }
                    });
                  }
                },
                '+ Add' + (rateSets && rateSets.length ? ' another' : '') + ' rate set to ' + seasonName
              ) : undefined
            );
          }),
          contractingPeriodCovered > 0 ? _react2.default.createElement(_addItemCard2.default, { text: 'Add rates to a new season', onClick: function onClick() {
              return openAddEditContractDialog({ type: 'addRates', title: 'Add Rate Set' });
            }, editable: supplierEditable, hide: !supplierEditable }) : undefined
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_addItemCard2.default, { text: 'Add rates', onClick: function onClick() {
              return openAddEditContractDialog({ type: 'addRates', title: 'Add Rate Set' });
            }, editable: supplierEditable })
        )
      );
    }
  }]);

  return LeftThreeRates;
}(_react.Component);

LeftThreeRates.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting;

  var leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  var rightContent = contracting.contractActivitiesProducts.get('rightSideContent').toJS();
  var draftErrors = contracting.contractActivitiesProducts.get('draftErrors').toJS();
  var productId = rightContent.productId;
  var overlappedSeasonRates = leftNav.contractState !== 'draft' ? [] : _ramda2.default.call(_ramda2.default.compose(_ramda2.default.pathOr([], ['rates', 'overlappedSeasonRates']), _ramda2.default.find(function (prod) {
    return prod.productId === productId && (rightContent.ratePackageName || '') === (prod.ratePackageName || '');
  })), draftErrors.products || []);
  return {
    seasonRates: rightContent.seasonRates || [],
    supplierEditable: leftNav.supplierEditable,
    contractState: leftNav.contractState,
    productName: leftNav.productName,
    overlappedSeasonRates: overlappedSeasonRates,
    contractingPeriod: { startDate: leftNav.startDate, endDate: leftNav.endDate },
    existingSeasons: rightContent.seasons || []
  };
};

var mapActions = {
  openGlobalAlert: function openGlobalAlert(payload) {
    return {
      type: 'open_global_alert',
      payload: payload
    };
  }
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapActions)(LeftThreeRates);

/***/ }),
/* 3430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _rightOne = __webpack_require__(2018);

var _rightOne2 = _interopRequireDefault(_rightOne);

var _rightTwoBlackouts = __webpack_require__(2019);

var _rightTwoBlackouts2 = _interopRequireDefault(_rightTwoBlackouts);

var _rightFourPickupDropoff = __webpack_require__(2020);

var _rightFourPickupDropoff2 = _interopRequireDefault(_rightFourPickupDropoff);

var _rightPolicies = __webpack_require__(3433);

var _rightPolicies2 = _interopRequireDefault(_rightPolicies);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  reducerName: _react.PropTypes.string,
  openAddEditContractDialog: _react.PropTypes.func,
  deleteFromProduct: _react.PropTypes.func,
  supplierEditable: _react.PropTypes.bool,
  contractState: _react.PropTypes.string,
  productType: _react.PropTypes.string,
  existingSeasons: _react.PropTypes.array,
  contractingPeriod: _react.PropTypes.object,
  openGlobalAlert: _react.PropTypes.func
};

var RightColumn = function (_Component) {
  _inherits(RightColumn, _Component);

  function RightColumn() {
    _classCallCheck(this, RightColumn);

    return _possibleConstructorReturn(this, (RightColumn.__proto__ || Object.getPrototypeOf(RightColumn)).apply(this, arguments));
  }

  _createClass(RightColumn, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          deleteFromProduct = _props.deleteFromProduct,
          openGlobalAlert = _props.openGlobalAlert,
          sharedProp = _objectWithoutProperties(_props, ['deleteFromProduct', 'openGlobalAlert']);

      return _react2.default.createElement(
        'div',
        { style: { padding: '24px', paddingLeft: '0', width: '35%', float: 'right' } },
        _react2.default.createElement(_rightOne2.default, sharedProp),
        _react2.default.createElement(_rightTwoBlackouts2.default, sharedProp),
        _react2.default.createElement(_rightFourPickupDropoff2.default, sharedProp),
        _react2.default.createElement(_rightPolicies2.default, _extends({}, sharedProp, {
          deletePolicy: function deletePolicy(policyType) {
            openGlobalAlert({
              text: 'Are you sure you want to delete this policy?',
              onOk: function onOk() {
                return deleteFromProduct({ policyType: policyType, updateType: 'DELETE_PRODUCT_POLICY_FROM_CONTRACT' });
              }
            });
          }
        }))
      );
    }
  }]);

  return RightColumn;
}(_react.Component);

RightColumn.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var contracting = _ref.contracting;
  var reducerName = _ref2.reducerName;

  var leftNav = contracting[reducerName].get('leftNav').toJS();
  var rightSideContent = contracting[reducerName].get('rightSideContent').toJS();
  var seasons = rightSideContent.seasons,
      seasonRates = rightSideContent.seasonRates;

  return {
    supplierEditable: contracting[reducerName].getIn(['leftNav', 'supplierEditable']),
    contractState: contracting[reducerName].getIn(['leftNav', 'contractState']),
    productType: contracting[reducerName].getIn(['rightSideContent', 'productType']),
    existingSeasons: (seasonRates || []).length > (seasons || []).length ? seasonRates : seasons || [],
    contractingPeriod: leftNav.startDate && leftNav.endDate ? { startDate: new Date(leftNav.startDate), endDate: new Date(leftNav.endDate) } : {}
  };
};

var mapActions = {
  openGlobalAlert: function openGlobalAlert(payload) {
    return {
      type: 'open_global_alert',
      payload: payload
    };
  }
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapActions)(RightColumn);

/***/ }),
/* 3431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _dateUtils = __webpack_require__(209);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

var _bookmark = __webpack_require__(3432);

var _bookmark2 = _interopRequireDefault(_bookmark);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SinglePickupDropOff = function SinglePickupDropOff(_ref) {
  var index = _ref.index,
      dateRanges = _ref.dateRanges,
      notes = _ref.notes,
      _ref$timeLocArray = _ref.timeLocArray,
      timeLocArray = _ref$timeLocArray === undefined ? [] : _ref$timeLocArray,
      _ref$classes = _ref.classes,
      classes = _ref$classes === undefined ? {} : _ref$classes;

  if (!notes && _ramda2.default.isEmpty(timeLocArray) && _ramda2.default.isEmpty(dateRanges)) return _react2.default.createElement('div', null);
  return _react2.default.createElement(
    'div',
    { style: { overflow: 'auto' }, className: classes[index + '-pickupdropoff'] },
    _react2.default.createElement(
      'div',
      {
        style: { fontSize: '12px',
          marginBottom: '0',
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          borderLeft: '1px solid #bababa',
          borderBottom: '1px solid #bababa',
          borderRight: '1px solid #bababa',
          borderTop: !index ? '1px solid #bababa' : '',
          color: '#262626', padding: '4px 8px'
        },
        className: classes[index + '-dateRanges']
      },
      _ramda2.default.isEmpty(dateRanges) && timeLocArray.length ? _react2.default.createElement(
        'span',
        { style: { color: 'red' } },
        'Missing Dates!!!'
      ) : (dateRanges || []).map(function (range, rangeIndex) {
        return _react2.default.createElement(
          'div',
          { key: rangeIndex, className: classes[index + '-dateRanges-' + rangeIndex] },
          _dateUtils2.default.displayRange(range, {
            start: classes[index + '-dateRanges-' + rangeIndex + '-seasonStartDate'],
            end: classes[index + '-dateRanges-' + rangeIndex + '-seasonEndDate']
          })
        );
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { padding: '4px 8px', borderLeft: '1px solid #bababa', borderBottom: '1px solid #bababa', borderRight: '1px solid #bababa', overflow: 'auto' } },
      (timeLocArray || []).map(function (_ref2, i) {
        var time = _ref2.time,
            location = _ref2.location;
        return _react2.default.createElement(
          'div',
          {
            key: i,
            style: { marginBottom: i === timeLocArray.length - 1 ? 0 : '8px', display: 'flex', flexDirection: 'column' },
            className: classes[index + '-timeLocArray-' + i]
          },
          _react2.default.createElement(
            'div',
            { style: { color: 'rgba(0,0,0,0.74)', whiteSpace: 'pre-wrap', display: location ? 'flex' : 'none', alignItems: 'center' } },
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-location_on', style: { fontSize: '19px', color: 'rgba(0, 0, 0, 0.54)' } }),
            _react2.default.createElement(
              'div',
              { style: { marginLeft: '4px' }, className: classes[index + '-timeLocArray-' + i + '-location'] },
              location
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { color: 'rgba(0,0,0,0.74)', whiteSpace: 'pre-wrap', display: time ? 'flex' : 'none', alignItems: 'center' } },
            _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-watch_later', style: { fontSize: '17px', color: 'rgba(0, 0, 0, 0.54)', left: '2px' } }),
            _react2.default.createElement(
              'div',
              { style: { marginLeft: '4px' }, className: classes[index + '-timeLocArray-' + i + '-time'] },
              time
            )
          )
        );
      }),
      _react2.default.createElement(
        'div',
        { style: { color: 'rgba(0,0,0,0.74)', whiteSpace: 'pre-wrap', marginTop: '16px', display: notes ? 'flex' : 'none', alignItems: 'flex-start' } },
        _react2.default.createElement(_bookmark2.default, { style: { width: '18px', height: '18px', color: 'rgba(0, 0, 0, 0.54)' } }),
        _react2.default.createElement(
          'span',
          { style: { textAlign: 'left', width: '90%' }, className: classes[index + '-notes'] },
          notes
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { color: 'rgba(0,0,0,0.74)', display: !notes && !(timeLocArray || []).some(function (obj) {
              return obj.location || obj.time;
            }) ? 'block' : 'none' } },
        'N/A'
      )
    )
  );
};

exports.default = SinglePickupDropOff;

/***/ }),
/* 3432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBookmark = function ActionBookmark(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z' })
  );
};
ActionBookmark = (0, _pure2.default)(ActionBookmark);
ActionBookmark.displayName = 'ActionBookmark';
ActionBookmark.muiName = 'SvgIcon';

exports.default = ActionBookmark;

/***/ }),
/* 3433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _addItemCard = __webpack_require__(256);

var _addItemCard2 = _interopRequireDefault(_addItemCard);

var _cancellation = __webpack_require__(1990);

var _cancellation2 = _interopRequireDefault(_cancellation);

var _group = __webpack_require__(1991);

var _group2 = _interopRequireDefault(_group);

var _freeofcharge = __webpack_require__(1992);

var _freeofcharge2 = _interopRequireDefault(_freeofcharge);

var _family = __webpack_require__(1993);

var _family2 = _interopRequireDefault(_family);

var _child = __webpack_require__(1994);

var _child2 = _interopRequireDefault(_child);

var _infant = __webpack_require__(1995);

var _infant2 = _interopRequireDefault(_infant);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var policiesInCaps = {
  cancellation: 'Cancellation',
  group: 'Group',
  freeOfCharge: 'Free of Charge',
  family: 'Family',
  child: 'Child',
  infant: 'Infant'
};

var propTypes = {
  openAddEditContractDialog: _react.PropTypes.func,
  deletePolicy: _react.PropTypes.func,
  supplierEditable: _react.PropTypes.bool,
  contractState: _react.PropTypes.string,
  existingSeasons: _react.PropTypes.array,
  contractingPeriod: _react.PropTypes.object,
  productPolicy: _react.PropTypes.array,
  productType: _react.PropTypes.string
};

var Policies = function (_Component) {
  _inherits(Policies, _Component);

  function Policies() {
    _classCallCheck(this, Policies);

    return _possibleConstructorReturn(this, (Policies.__proto__ || Object.getPrototypeOf(Policies)).apply(this, arguments));
  }

  _createClass(Policies, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          openAddEditContractDialog = _props.openAddEditContractDialog,
          _deletePolicy = _props.deletePolicy,
          supplierEditable = _props.supplierEditable,
          productPolicy = _props.productPolicy,
          existingSeasons = _props.existingSeasons,
          contractingPeriod = _props.contractingPeriod,
          productType = _props.productType;

      if (_ramda2.default.isEmpty(contractingPeriod)) return _react2.default.createElement('div', null);

      var policyObject = productPolicy && productPolicy.length ? productPolicy.reduce(function (result, policy) {
        if ((0, _ramda.equals)(policy.policyType, 'child')) {
          result.child = _extends({}, policy, {
            focChildrenAllowed: Boolean(policy.focChildrenCount)
          });
        } else result[policy.policyType] = policy;
        return result;
      }, {}) : {};
      var getEditStateInfo = function getEditStateInfo(policyType, action) {
        return {
          type: 'editProductPolicy',
          title: action + ' Product ' + policiesInCaps[policyType] + ' Policy',
          policyType: policyType
        };
      };
      var propsForCancellation = {
        supplierEditable: supplierEditable,
        deletePolicy: function deletePolicy() {
          return _deletePolicy('cancellation');
        },
        cancellationInfo: policyObject.cancellation,
        existingSeasons: existingSeasons,
        openAddEditContractDialog: openAddEditContractDialog,
        contractingPeriod: contractingPeriod,
        addCancellation: function addCancellation() {
          return openAddEditContractDialog({
            type: 'seasonalCancelPolicies',
            title: productType === 'Non-Accommodation' ? 'Add Product Specific Cancellation Policies' : 'Add Season Specific Cancellation Policies'
          });
        },
        editCancellation: function editCancellation() {
          return openAddEditContractDialog({
            type: 'seasonalCancelPolicies',
            title: productType === 'Non-Accommodation' ? 'Edit Product Specific Cancellation Policies' : 'Edit Season Specific Cancellation Policies'
          });
        }
      };
      var groupInfo = policyObject.group;
      var freeOfChargeInfo = policyObject.freeOfCharge;
      var familyInfo = policyObject.family;
      var childInfo = policyObject.child;
      var infantInfo = policyObject.infant;
      var getProps = function getProps(type) {
        var _ref;

        return _ref = {
          supplierEditable: supplierEditable,
          deletePolicy: function deletePolicy() {
            return _deletePolicy(type);
          }
        }, _defineProperty(_ref, 'add' + (type === 'freeOfCharge' ? 'FreeOfCharge' : policiesInCaps[type]), function undefined() {
          return openAddEditContractDialog(getEditStateInfo(type, 'Add'));
        }), _defineProperty(_ref, 'edit' + (type === 'freeOfCharge' ? 'FreeOfCharge' : policiesInCaps[type]), function undefined() {
          return openAddEditContractDialog(getEditStateInfo(type, 'Edit'));
        }), _ref;
      };
      var showAddButton = !groupInfo || !freeOfChargeInfo || !childInfo || !infantInfo;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '24px', marginBottom: '24px' } }),
        _react2.default.createElement(_cancellation2.default, _extends({
          label: productType === 'Non-Accommodation' ? 'PRODUCT SPECIFIC CANCELLATION POLICY' : 'SEASONAL CANCELLATION POLICIES'
        }, propsForCancellation)),
        _react2.default.createElement(_materialUi.Divider, { style: { marginTop: '24px', marginBottom: '24px' } }),
        _react2.default.createElement(
          'div',
          { style: { marginBottom: '12px', marginTop: '12px' } },
          _react2.default.createElement(
            'b',
            null,
            'OTHER ',
            productType === 'Non-Accommodation' ? 'PRODUCT' : 'ROOM',
            ' POLICIES'
          )
        ),
        groupInfo ? _react2.default.createElement(_group2.default, _extends({}, getProps('group'), { groupInfo: groupInfo })) : undefined,
        groupInfo ? _react2.default.createElement('br', null) : undefined,
        freeOfChargeInfo ? _react2.default.createElement(_freeofcharge2.default, _extends({}, getProps('freeOfCharge'), { freeOfChargeInfo: freeOfChargeInfo })) : undefined,
        freeOfChargeInfo ? _react2.default.createElement('br', null) : undefined,
        familyInfo ? _react2.default.createElement(_family2.default, _extends({}, getProps('family'), { familyInfo: familyInfo })) : undefined,
        familyInfo ? _react2.default.createElement('br', null) : undefined,
        childInfo ? _react2.default.createElement(_child2.default, _extends({}, getProps('child'), { childInfo: childInfo })) : undefined,
        childInfo ? _react2.default.createElement('br', null) : undefined,
        infantInfo ? _react2.default.createElement(_infant2.default, _extends({}, getProps('infant'), { infantInfo: infantInfo })) : undefined,
        infantInfo ? _react2.default.createElement('br', null) : undefined,
        showAddButton ? _react2.default.createElement(_addItemCard2.default, {
          onClick: function onClick() {
            return openAddEditContractDialog({ type: 'addProductPolicy', title: 'Add Product Policy' });
          },
          text: 'Add ' + (productType === 'Non-Accommodation' ? 'product' : 'room') + ' specific policies',
          editable: supplierEditable
        }) : undefined
      );
    }
  }]);

  return Policies;
}(_react.Component);

Policies.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;

  var docContainer = contracting.contractActivitiesProducts.toJS();
  return {
    productPolicy: _ramda2.default.pathOr([], ['rightSideContent', 'productPolicy'], docContainer)
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(Policies);

/***/ }),
/* 3434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _massRateChangeActions = __webpack_require__(3435);

var _massRateChangeHelpers = __webpack_require__(860);

var _containerHeader = __webpack_require__(3436);

var _containerHeader2 = _interopRequireDefault(_containerHeader);

var _leftNav = __webpack_require__(3437);

var _leftNav2 = _interopRequireDefault(_leftNav);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

var _actionArea = __webpack_require__(3440);

var _actionArea2 = _interopRequireDefault(_actionArea);

var _ratesDetail = __webpack_require__(3451);

var _ratesDetail2 = _interopRequireDefault(_ratesDetail);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MassRateChangeContainer = function (_Component) {
  _inherits(MassRateChangeContainer, _Component);

  function MassRateChangeContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MassRateChangeContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MassRateChangeContainer.__proto__ || Object.getPrototypeOf(MassRateChangeContainer)).call.apply(_ref, [this].concat(args))), _this), _this.getToBeUpdatedList = function (allUpdateCategories) {
      return _ramda2.default.compose(_ramda2.default.filter(function (obj) {
        return obj;
      }), _ramda2.default.flatten, _ramda2.default.map(function (updateTypeAsKey) {
        return _ramda2.default.map(function (rateTypeAsKey) {
          if ((0, _massRateChangeHelpers.checkIfUpdatesExist)(rateTypeAsKey)(allUpdateCategories[updateTypeAsKey].products)) {
            return { updateType: updateTypeAsKey, rateType: rateTypeAsKey };
          }
        })(['nett', 'discount', 'commission']);
      }))(['seasonRates', 'offers', 'extras']);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MassRateChangeContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          params = _props.params,
          dispatch = _props.dispatch,
          location = _props.location;
      // location.query has locationName in it;

      dispatch((0, _massRateChangeActions.getMassRateChangeData)({ contractId: params.contractId })).then(function () {
        return dispatch({ type: 'CHANGE_MASS_RATE_CHANGE_UPDATE_TYPE', payload: { updateType: params.updateType, locationName: location.query.locationName } });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          params = _props2.params,
          dispatch = _props2.dispatch,
          saving = _props2.saving,
          location = _props2.location,
          isDummyAccount = _props2.isDummyAccount,
          isAnAdmin = _props2.isAnAdmin,
          pureDocView = _props2.pureDocView,
          updateCategories = _objectWithoutProperties(_props2, ['params', 'dispatch', 'saving', 'location', 'isDummyAccount', 'isAnAdmin', 'pureDocView']);

      var contractId = params.contractId;

      var toBeUpdatedList = this.getToBeUpdatedList(updateCategories);
      var massRateChangeFn = function massRateChangeFn() {
        var allRatesRepaired = ['seasonRates', 'offers', 'extras'].map(function (type) {
          return {
            updateType: type,
            productUpdates: (0, _massRateChangeHelpers.repairAllProducts)(type, updateCategories[type].products)
          };
        });
        return dispatch((0, _massRateChangeActions.massRateChange)(contractId, allRatesRepaired, toBeUpdatedList));
      };
      var getMassRateChangeDataFn = function getMassRateChangeDataFn() {
        return dispatch((0, _massRateChangeActions.getMassRateChangeData)({ contractId: params.contractId }));
      };

      var shouldHideAppBars = isDummyAccount && !isAnAdmin || pureDocView;
      return _react2.default.createElement(
        'div',
        {
          className: shouldHideAppBars ? 'full-screen-page' : '',
          style: shouldHideAppBars ? { padding: '0 128px' } : {}
        },
        _react2.default.createElement(
          _materialUi.Paper,
          { style: { height: '600px' } },
          _react2.default.createElement(_containerHeader2.default, {
            saving: saving,
            closePopOver: function closePopOver() {
              return dispatch({ type: 'CLOSE_POPOVER_IN_MASS_RATE_CHANGE' });
            },
            massRateChange: massRateChangeFn,
            goToContract: function goToContract() {
              return _this2.context.router.goBack();
            },
            goToContractOrOpenPover: function goToContractOrOpenPover(event) {
              if (_ramda2.default.isEmpty(toBeUpdatedList)) _this2.context.router.goBack();else dispatch({ type: 'OPEN_POPOVER_WHEN_LEAVING_MASS_RATE_CHANGE', payload: { popOverAnchorEl: event.currentTarget } });
            }
          }),
          _react2.default.createElement(_leftNav2.default, {
            changeRateType: function changeRateType(newRateType, newUpdateType) {
              return dispatch({ type: 'CHANGE_MASS_RATE_CHANGE_RATE_TYPE', payload: { rateType: newRateType, updateType: newUpdateType } });
            },
            changeRoute: function changeRoute(newUpdateType) {
              _this2.context.router.push({ pathname: '/contracting/mass-rate-change/' + contractId + '/' + newUpdateType, query: location.query });
              dispatch({ type: 'CHANGE_MASS_RATE_CHANGE_UPDATE_TYPE', payload: { updateType: newUpdateType } });
            }
          }),
          _react2.default.createElement(_actionArea2.default, {
            onChangeNotApplyTo: function onChangeNotApplyTo() {
              return dispatch({ type: 'ON_CHANGE_NOT_APPLY_MASS_RATE_CHANGE_TO_EXTRA_CHILD' });
            },
            changeMeasure: function changeMeasure(measure) {
              return dispatch({ type: 'CHANGE_MASS_RATE_CHANGE_MEASURE', payload: { retailNettMeasure: measure } });
            },
            changeRoundSettings: function changeRoundSettings(payload) {
              return dispatch({ type: 'CHANGE_ROUNDING_SETTINGS_IN_MASS_RATE_CHANGE', payload: payload });
            }
          }),
          _react2.default.createElement(_ratesDetail2.default, null),
          _react2.default.createElement(_raisedButtonWithLoader2.default, {
            label: 'save changes',
            loader: saving,
            disabled: _ramda2.default.isEmpty(toBeUpdatedList),
            style: { float: 'right', marginTop: '8px', marginRight: '8px', marginBottom: '8px' },
            secondary: true,
            onTouchTap: massRateChangeFn
          }),
          _react2.default.createElement(_raisedButtonWithLoader2.default, {
            label: 'discard changes',
            loader: saving,
            disabled: _ramda2.default.isEmpty(toBeUpdatedList),
            style: { float: 'left', marginTop: '8px', marginLeft: '8px', marginBottom: '8px' },
            primary: true,
            onTouchTap: getMassRateChangeDataFn
          })
        )
      );
    }
  }]);

  return MassRateChangeContainer;
}(_react.Component);

;

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting,
      user = _ref2.user;
  return {
    updateType: contracting.massRateChange.get('updateType'),
    rateType: contracting.massRateChange.get('rateType'),
    saving: contracting.massRateChange.get('saving'),
    seasonRates: contracting.massRateChange.get('seasonRates').toJS(),
    offers: contracting.massRateChange.get('offers').toJS(),
    extras: contracting.massRateChange.get('extras').toJS(),
    isDummyAccount: user.get('isDummyAccount'),
    isAnAdmin: user.get('isAnAdmin'),
    pureDocView: user.get('pureDocView')
  };
};
MassRateChangeContainer.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(MassRateChangeContainer);

/***/ }),
/* 3435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getMassRateChangeData = getMassRateChangeData;
exports.massRateChange = massRateChange;

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _massRateChangeHelpers = __webpack_require__(860);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var credentialsAndHeaders = {
  credentials: 'same-origin',
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
};

var put = function put(body) {
  return _extends({ method: 'put', body: JSON.stringify(body) }, credentialsAndHeaders);
};

function getMassRateChangeData(_ref) {
  var contractId = _ref.contractId;

  return function (dispatch) {
    dispatch({ type: 'GETTING_MASS_RATE_CHANGE_DATA' });
    return fetch('/proxy/contracting/massRateChange/' + contractId, {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    }).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (_ref2) {
      var locationId = _ref2.locationId,
          allKindsOfRates = _objectWithoutProperties(_ref2, ['locationId']);

      return dispatch({ type: 'GOT_MASS_RATE_CHANGE_DATA', payload: { thisUpdateType: 'extras', allKindsOfRates: allKindsOfRates, locationId: locationId } });
    }).catch(function (err) {
      console.log(err.stack);
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Failed to get rates' });
    });
  };
}
// allKindsOfRatesInSchemaFormat = [{
//  updateType,
//  productUpdates,
// }]
function massRateChange(contractId, allKindsOfRatesInSchemaFormat, allUpdated) {
  return function (dispatch) {
    dispatch({ type: 'SAVING_MASS_RATE_CHANGE_DATA' });
    return fetch('/proxy/contracting/massRateChange/' + contractId, put({ allKindsOfRatesInSchemaFormat: allKindsOfRatesInSchemaFormat })).then(_checkStatus2.default).then(function (res) {
      return res.json();
    }).then(function (response) {
      return dispatch({ type: 'SAVED_MASS_RATE_CHANGE_DATA', payload: { allKindsOfRates: response, allUpdated: allUpdated } });
    }).catch(function (err) {
      return dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Mass Rate Change Failed' });
    });
  };
}

/***/ }),
/* 3436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _Popover = __webpack_require__(1358);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTitle = _ramda2.default.cond([[_ramda2.default.equals('offers'), _ramda2.default.always('Special Offers')], [_ramda2.default.equals('seasonRates'), _ramda2.default.always('Rates')], [_ramda2.default.equals('extras'), _ramda2.default.always('Extra')], [_ramda2.default.T, _ramda2.default.always('Rates')]]);

var HeaderBar = function HeaderBar(_ref) {
  var saving = _ref.saving,
      updateType = _ref.updateType,
      locationName = _ref.locationName,
      goToContract = _ref.goToContract,
      popOverOpen = _ref.popOverOpen,
      popOverAnchorEl = _ref.popOverAnchorEl,
      closePopOver = _ref.closePopOver,
      massRateChange = _ref.massRateChange,
      goToContractOrOpenPover = _ref.goToContractOrOpenPover;
  return _react2.default.createElement(
    'div',
    { style: { height: '48px', backgroundColor: '#00bcd4' } },
    _react2.default.createElement(
      _materialUi.IconButton,
      {
        iconClassName: 'tc-icon-arrow_back',
        iconStyle: { color: 'white' },
        onClick: goToContractOrOpenPover
      },
      _react2.default.createElement(
        _materialUi.Popover,
        {
          open: popOverOpen,
          anchorEl: popOverAnchorEl,
          anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
          targetOrigin: { horizontal: 'left', vertical: 'top' },
          animation: _Popover.PopoverAnimationFromTop,
          onRequestClose: closePopOver
        },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { color: 'black', width: '206px', padding: '12px' } },
            'You have unsaved changes.  Would you like to save them before you exit this tool?'
          ),
          _react2.default.createElement(_flatButtonWithLoader2.default, { label: 'Exit', secondary: true, onTouchTap: goToContract }),
          _react2.default.createElement(_flatButtonWithLoader2.default, { label: 'Save & Exit', secondary: true, style: { float: 'right' },
            loader: saving,
            onTouchTap: function onTouchTap() {
              massRateChange().then(function () {
                return goToContract();
              });
            }
          })
        )
      )
    ),
    _react2.default.createElement(
      'span',
      { style: { fontSize: '16px', position: 'relative', top: '-3px', color: 'white' } },
      'Edit ' + getTitle(updateType) + (locationName ? ' for ' + locationName : '')
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    updateType: contracting.massRateChange.get('updateType'),
    locationName: contracting.massRateChange.get('locationName'),
    popOverOpen: contracting.massRateChange.get('popOverOpen'),
    popOverAnchorEl: contracting.massRateChange.get('popOverAnchorEl')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(HeaderBar);

/***/ }),
/* 3437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _navMenuItem = __webpack_require__(3438);

var _navMenuItem2 = _interopRequireDefault(_navMenuItem);

var _massRateChangeHelpers = __webpack_require__(860);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LeftNav = function LeftNav(_ref) {
  var changeRateType = _ref.changeRateType,
      changeRoute = _ref.changeRoute,
      updateType = _ref.updateType,
      rateType = _ref.rateType,
      updated = _ref.updated,
      gettingData = _ref.gettingData,
      updateCategories = _objectWithoutProperties(_ref, ['changeRateType', 'changeRoute', 'updateType', 'rateType', 'updated', 'gettingData']);

  var checkIfIsMatched = function checkIfIsMatched(updateType1, rateType1, updateType2, rateType2) {
    return _ramda2.default.and(_ramda2.default.equals(updateType2, updateType1), _ramda2.default.equals(rateType1, rateType2));
  };
  var checkIfIsUpdated = function checkIfIsUpdated(updateType1, rateType1) {
    return _ramda2.default.any(function (pair) {
      return checkIfIsMatched(updateType1, rateType1, _ramda2.default.prop('updateType', pair), _ramda2.default.prop('rateType', pair));
    })(updated);
  };
  var equipSubMenusFn = function equipSubMenusFn(parentName) {
    return _ramda2.default.map(function (rateTypeAsSubMenu) {
      return {
        name: '     ' + rateTypeAsSubMenu,
        onTouchTap: function onTouchTap() {
          return changeRateType(rateTypeAsSubMenu, parentName);
        },
        isActive: checkIfIsMatched(parentName, rateTypeAsSubMenu, updateType, rateType),
        hasUnsavedChanges: (0, _massRateChangeHelpers.checkIfUpdatesExist)(rateTypeAsSubMenu)(updateCategories[parentName].products),
        isUpdated: checkIfIsUpdated(parentName, rateTypeAsSubMenu)
      };
    });
  };

  var menuItems = [{ name: 'RATES',
    onTouchTap: function onTouchTap() {
      return changeRoute('seasonRates');
    },
    gettingData: gettingData,
    subMenus: equipSubMenusFn('seasonRates')(updateCategories.seasonRates.subMenus)
  }, { name: 'SPECIAL OFFERS',
    onTouchTap: function onTouchTap() {
      return changeRoute('offers');
    },
    gettingData: gettingData,
    subMenus: equipSubMenusFn('offers')(updateCategories.offers.subMenus)
  }, { name: 'EXTRA',
    onTouchTap: function onTouchTap() {
      return changeRoute('extras');
    },
    gettingData: gettingData,
    subMenus: equipSubMenusFn('extras')(updateCategories.extras.subMenus)
  }];
  var renderMenuItem = function renderMenuItem(menuItemProps, key) {
    return _react2.default.createElement(
      'div',
      { style: { marginBottom: menuItemProps.subMenus ? '30px' : '0px' }, key: key },
      menuItemProps.name !== '     free' ? _react2.default.createElement(_navMenuItem2.default, _extends({}, menuItemProps, { key: key })) : _react2.default.createElement('div', null),
      menuItemProps.subMenus && menuItemProps.name !== '     free' ? menuItemProps.subMenus.map(renderMenuItem) : _react2.default.createElement('div', null)
    );
  };
  return _react2.default.createElement(
    'div',
    { className: 'contracting-left-nav-widget', style: { backgroundColor: '#383e4b', width: '20%', display: 'inline-block', height: '550px', padding: '39px 10px 40px 0px', float: 'left' } },
    menuItems.filter(function (menuItem) {
      return menuItem.subMenus.length;
    }).map(renderMenuItem)
  );
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    gettingData: contracting.massRateChange.get('gettingData'),
    updateType: contracting.massRateChange.get('updateType'),
    rateType: contracting.massRateChange.get('rateType'),
    updated: contracting.massRateChange.get('updated').toJS(),
    seasonRates: contracting.massRateChange.get('seasonRates').toJS(),
    offers: contracting.massRateChange.get('offers').toJS(),
    extras: contracting.massRateChange.get('extras').toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(LeftNav);

/***/ }),
/* 3438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _rightIcon = __webpack_require__(3439);

var _rightIcon2 = _interopRequireDefault(_rightIcon);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _massRateChangeHelpers = __webpack_require__(860);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var submMenuMap = {
  nett: '      nett rates',
  commission: '      commissions',
  discount: '      discounts'
};

var menuMap = {
  RATES: 'seasonRates',
  'SPECIAL OFFERS': 'offers',
  EXTRA: 'extras'
};

var MenuItem = function MenuItem(props) {
  var name = props.name,
      subMenus = props.subMenus,
      hasUnsavedChanges = props.hasUnsavedChanges,
      onTouchTap = props.onTouchTap,
      isActive = props.isActive,
      isUpdated = props.isUpdated,
      gettingData = props.gettingData;


  var getLabelColorFn = function getLabelColorFn() {
    if (hasUnsavedChanges) return '#ff4081';
    if (isActive) return '#00bcd4';
    return 'white';
  };
  if (!subMenus) {
    return _react2.default.createElement(
      'div',
      { className: 'contracting-left-nav-widget-link ' + (isActive ? 'is-active' : ''), style: { margin: '0', lineHeight: '16px', padding: '7px', paddingLeft: '24px' }, onClick: onTouchTap },
      _react2.default.createElement(
        'div',
        { style: { fontSize: '12px', color: getLabelColorFn(), display: 'inline-block', whiteSpace: 'pre', textTransform: 'uppercase' } },
        submMenuMap[name.trim()] || name
      ),
      isUpdated ? _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-check', color: '#00bcd4', style: { marginLeft: '5px', fontSize: '16px' } }) : _react2.default.createElement('span', null),
      _react2.default.createElement(_rightIcon2.default, { subMenus: subMenus, gettingData: gettingData })
    );
  }
  return _react2.default.createElement(
    'div',
    { style: { textTransform: 'uppercase', paddingBottom: '5px' } },
    _react2.default.createElement(
      'div',
      { style: { color: 'white', display: 'inline-block', whiteSpace: 'pre', paddingLeft: '24px' } },
      name
    ),
    _react2.default.createElement(_rightIcon2.default, { subMenus: subMenus, gettingData: gettingData })
  );
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting;
  return {
    seasonRates: contracting.massRateChange.get('seasonRates').toJS(),
    offers: contracting.massRateChange.get('offers').toJS(),
    extras: contracting.massRateChange.get('extras').toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(MenuItem);

/***/ }),
/* 3439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RightIcon = function RightIcon(_ref) {
  var subMenus = _ref.subMenus,
      gettingData = _ref.gettingData,
      isUpdated = _ref.isUpdated;

  if (subMenus) {
    if (gettingData) return _react2.default.createElement(_materialUi.CircularProgress, { size: 15, style: { float: 'right', top: '-16px' } });
    if (subMenus.length) return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-chevron-down', color: 'white', style: { float: 'right', marginRight: '10px', top: '-2px' } });
    return _react2.default.createElement('span', null);
  }
  return _react2.default.createElement('span', null);
};

exports.default = RightIcon;

/***/ }),
/* 3440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _header = __webpack_require__(3441);

var _header2 = _interopRequireDefault(_header);

var _products = __webpack_require__(3445);

var _products2 = _interopRequireDefault(_products);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionArea = function ActionArea(_ref) {
  var changeMeasure = _ref.changeMeasure,
      onChangeNotApplyTo = _ref.onChangeNotApplyTo,
      changeRoundSettings = _ref.changeRoundSettings;
  return _react2.default.createElement(
    'div',
    { style: { backgroundColor: '#fafafa', width: '45%', display: 'inline-block', height: '500px', borderBottom: 'solid 1px #eeeeee' } },
    _react2.default.createElement(
      'div',
      { style: { height: '450px', overflowY: 'scroll' } },
      _react2.default.createElement(_header2.default, { changeMeasure: changeMeasure, changeRoundSettings: changeRoundSettings }),
      _react2.default.createElement(_products2.default, { onChangeNotApplyTo: onChangeNotApplyTo })
    )
  );
};

exports.default = ActionArea;

/***/ }),
/* 3441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _nett = __webpack_require__(3442);

var _nett2 = _interopRequireDefault(_nett);

var _commission = __webpack_require__(3443);

var _commission2 = _interopRequireDefault(_commission);

var _discount = __webpack_require__(3444);

var _discount2 = _interopRequireDefault(_discount);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActionAreaHeader = function (_React$Component) {
  _inherits(ActionAreaHeader, _React$Component);

  function ActionAreaHeader() {
    _classCallCheck(this, ActionAreaHeader);

    var _this = _possibleConstructorReturn(this, (ActionAreaHeader.__proto__ || Object.getPrototypeOf(ActionAreaHeader)).call(this));

    _this.toggleShowRoundSettings = function () {
      return _this.setState({ showRoundSettings: !_this.state.showRoundSettings });
    };

    _this.state = {
      showRoundSettings: false
    };
    return _this;
  }

  _createClass(ActionAreaHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rateType = _props.rateType,
          changeMeasure = _props.changeMeasure,
          retailNettMeasure = _props.retailNettMeasure,
          changeRoundSettings = _props.changeRoundSettings,
          roundingSetting = _props.roundingSetting;

      var cents = roundingSetting && roundingSetting.get('cents') || 1;
      var roundType = roundingSetting && roundingSetting.get('roundType') || 'normal';
      var showRoundSettings = this.state.showRoundSettings;

      var HeaderContent = function () {
        if (rateType) {
          if (_ramda2.default.equals(rateType, 'nett')) return _nett2.default;
          if (_ramda2.default.equals(rateType, 'commission')) return _commission2.default;
          if (_ramda2.default.equals(rateType, 'discount')) return _discount2.default;
        }
        return _nett2.default;
      }();
      return _react2.default.createElement(
        'div',
        { style: { lineHeight: '48px', borderBottom: '1px solid #eeeeee', padding: '0 16px' } },
        _react2.default.createElement(_materialUi.Toggle, {
          toggled: showRoundSettings,
          label: 'Show Rounding Settings',
          labelPosition: 'right',
          style: { marginTop: '8px', width: '50%' },
          onToggle: this.toggleShowRoundSettings
        }),
        _react2.default.createElement(
          'div',
          {
            style: { borderBottom: '1px solid #eee', display: showRoundSettings ? 'flex' : 'none' }
          },
          _react2.default.createElement(
            'div',
            { style: { width: '50%' } },
            'Rounding Settings:',
            _react2.default.createElement(_materialUi.RadioButton, { label: 'Round to the neareast', checked: roundType === 'normal', onCheck: function onCheck() {
                return changeRoundSettings({ roundType: 'normal' });
              } }),
            _react2.default.createElement(_materialUi.RadioButton, { label: 'Always round up', checked: roundType === 'alwaysUp', onCheck: function onCheck() {
                return changeRoundSettings({ roundType: 'alwaysUp' });
              } }),
            _react2.default.createElement(_materialUi.RadioButton, { label: 'Always round down', checked: roundType === 'alwaysDown', onCheck: function onCheck() {
                return changeRoundSettings({ roundType: 'alwaysDown' });
              } })
          ),
          _react2.default.createElement(
            'div',
            { style: { width: '50%' } },
            'To the nearest:',
            _react2.default.createElement(_materialUi.RadioButton, { label: 'dollar', checked: cents === 100, onCheck: function onCheck() {
                return changeRoundSettings({ cents: 100 });
              } }),
            _react2.default.createElement(_materialUi.RadioButton, { label: '50 cents', checked: cents === 50, onCheck: function onCheck() {
                return changeRoundSettings({ cents: 50 });
              } }),
            _react2.default.createElement(_materialUi.RadioButton, { label: '25 cents', checked: cents === 25, onCheck: function onCheck() {
                return changeRoundSettings({ cents: 25 });
              } }),
            _react2.default.createElement(_materialUi.RadioButton, { label: '1 cent', checked: cents === 1, onCheck: function onCheck() {
                return changeRoundSettings({ cents: 1 });
              } })
          )
        ),
        _react2.default.createElement(HeaderContent, { changeMeasure: changeMeasure, retailNettMeasure: retailNettMeasure })
      );
    }
  }]);

  return ActionAreaHeader;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var massRateChange = _ref.contracting.massRateChange;
  return {
    roundingSetting: massRateChange.getIn([massRateChange.get('updateType'), 'roundingSetting']),
    rateType: massRateChange.get('rateType'),
    retailNettMeasure: massRateChange.getIn([massRateChange.get('updateType'), massRateChange.get('rateType') + 'Measure'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ActionAreaHeader);

/***/ }),
/* 3442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _measureToggle = __webpack_require__(1564);

var _measureToggle2 = _interopRequireDefault(_measureToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var changeMeasure = _ref.changeMeasure,
      retailNettMeasure = _ref.retailNettMeasure;
  return _react2.default.createElement(
    'div',
    { style: { color: 'rgba(0, 0, 0, 0.87)', display: 'inline-block', width: '30%', marginLeft: '40%', fontSize: '12px' } },
    'NETT RATE',
    _react2.default.createElement(
      'div',
      { style: { width: '40%', display: 'inline-block', marginLeft: '5%' } },
      _react2.default.createElement(_measureToggle2.default, { changeMeasure: changeMeasure, retailNettMeasure: retailNettMeasure })
    )
  );
};

/***/ }),
/* 3443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _measureToggle = __webpack_require__(1564);

var _measureToggle2 = _interopRequireDefault(_measureToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var changeMeasure = _ref.changeMeasure,
      retailNettMeasure = _ref.retailNettMeasure;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { color: 'rgba(0, 0, 0, 0.87)', display: 'inline-block', width: '21%', marginLeft: '39%', fontSize: '12px' } },
      'COMMISSION'
    ),
    _react2.default.createElement(
      'div',
      { style: { color: 'rgba(0, 0, 0, 0.87)', display: 'inline-block', width: '17%', marginLeft: '8%', fontSize: '12px' } },
      'RETAIL RATE'
    ),
    _react2.default.createElement(
      'div',
      { style: { width: '10%', display: 'inline-block' } },
      _react2.default.createElement(_measureToggle2.default, { changeMeasure: changeMeasure, retailNettMeasure: retailNettMeasure })
    )
  );
};

/***/ }),
/* 3444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _measureToggle = __webpack_require__(1564);

var _measureToggle2 = _interopRequireDefault(_measureToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var changeMeasure = _ref.changeMeasure,
      retailNettMeasure = _ref.retailNettMeasure;
  return _react2.default.createElement(
    'div',
    { style: { color: 'rgba(0, 0, 0, 0.87)', display: 'inline-block', width: '35%', marginLeft: '40%', fontSize: '12px' } },
    'DISCOUNT',
    _react2.default.createElement(
      'div',
      { style: { width: '40%', display: 'inline-block', marginLeft: '5%' } },
      _react2.default.createElement(_measureToggle2.default, { changeMeasure: changeMeasure, retailNettMeasure: retailNettMeasure })
    )
  );
};

/***/ }),
/* 3445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _singleProduct = __webpack_require__(3446);

var _singleProduct2 = _interopRequireDefault(_singleProduct);

var _massRateChangeHelpers = __webpack_require__(860);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ActionAreaProducts = function ActionAreaProducts(_ref) {
  var rateType = _ref.rateType,
      updateType = _ref.updateType,
      notApplyToExtraChild = _ref.notApplyToExtraChild,
      onChangeNotApplyTo = _ref.onChangeNotApplyTo,
      updateCategories = _objectWithoutProperties(_ref, ['rateType', 'updateType', 'notApplyToExtraChild', 'onChangeNotApplyTo']);

  var updateData = updateCategories[updateType];
  var filteredProducts = _ramda2.default.reject((0, _massRateChangeHelpers.checkIfProductWithNothingToShow)(updateType, rateType), _ramda2.default.propOr([], 'products')(updateData));

  var showNotApplyToExtraChildCheckbox = Boolean(rateType === 'nett' || rateType === 'commission');
  if (_ramda2.default.isEmpty(filteredProducts)) return _react2.default.createElement(
    'div',
    { style: { padding: '24px', textAlign: 'center' } },
    'There is no rates under this category.'
  );
  return _react2.default.createElement(
    'div',
    null,
    filteredProducts.length && filteredProducts.length > 1 ? _react2.default.createElement(_singleProduct2.default, { applyAll: true, noBottomBorder: showNotApplyToExtraChildCheckbox }) : _react2.default.createElement('div', null),
    _react2.default.createElement(
      'div',
      { style: { display: showNotApplyToExtraChildCheckbox ? 'block' : 'none', borderBottom: 'solid 1px #eeeeee' } },
      _react2.default.createElement(_materialUi.Checkbox, { onCheck: onChangeNotApplyTo, checked: notApplyToExtraChild, label: 'Do not apply to Extra Adult/Child', labelStyle: { color: 'rdga(0, 0, 0, 0.54)' }, style: { marginTop: '6px', marginBottom: '6px', marginLeft: '28px' } })
    ),
    _ramda2.default.call(_ramda2.default.compose(function (products) {
      return products.map(function (product, index) {
        return _react2.default.createElement(_singleProduct2.default, _extends({ key: index }, product));
      });
    }, _ramda2.default.flatten, _ramda2.default.values, _ramda2.default.groupBy(_ramda2.default.prop('productId'))), filteredProducts)
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    notApplyToExtraChild: contracting.massRateChange.getIn([contracting.massRateChange.get('updateType'), 'notApplyToExtraChildFor' + contracting.massRateChange.get('rateType')]),
    rateType: contracting.massRateChange.get('rateType'),
    updateType: contracting.massRateChange.get('updateType'),
    seasonRates: contracting.massRateChange.get('seasonRates').toJS(),
    offers: contracting.massRateChange.get('offers').toJS(),
    extras: contracting.massRateChange.get('extras').toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ActionAreaProducts);

/***/ }),
/* 3446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _widgets = __webpack_require__(3447);

var _widgets2 = _interopRequireDefault(_widgets);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SingleProduct = function SingleProduct(_ref) {
  var productName = _ref.productName,
      applyAll = _ref.applyAll,
      noBottomBorder = _ref.noBottomBorder,
      ratePackageName = _ref.ratePackageName,
      extraProps = _objectWithoutProperties(_ref, ['productName', 'applyAll', 'noBottomBorder', 'ratePackageName']);

  return _react2.default.createElement(
    'div',
    { style: { paddingLeft: '16px', paddingRight: '16px' } },
    _react2.default.createElement(
      'div',
      { style: { fontSize: '12px', textTransform: 'uppercase', paddingLeft: '16px', borderBottom: noBottomBorder ? 'none' : 'solid 1px #eeeeee', lineHeight: '61px' } },
      applyAll ? _react2.default.createElement(
        'div',
        { style: { width: '30%', color: 'rgba(0, 0, 0, 0.87)', display: 'inline-block' } },
        'APPLY ALL'
      ) : _react2.default.createElement(
        'div',
        { style: { width: '30%', display: 'inline-block', lineHeight: '14px', verticalAlign: 'middle' } },
        productName,
        ratePackageName ? ' - ' + ratePackageName : ''
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '70%', display: 'inline-block' } },
        _react2.default.createElement(_widgets2.default, _extends({ applyAll: applyAll }, extraProps))
      )
    )
  );
};

exports.default = SingleProduct;

/***/ }),
/* 3447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _commissionWidgets = __webpack_require__(3448);

var _commissionWidgets2 = _interopRequireDefault(_commissionWidgets);

var _nettWidgets = __webpack_require__(3449);

var _nettWidgets2 = _interopRequireDefault(_nettWidgets);

var _discountWidgets = __webpack_require__(3450);

var _discountWidgets2 = _interopRequireDefault(_discountWidgets);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Widgets = function Widgets(_ref) {
  var rateType = _ref.rateType,
      dispatch = _ref.dispatch,
      ratePackageIndex = _ref.ratePackageIndex,
      extraProps = _objectWithoutProperties(_ref, ['rateType', 'dispatch', 'ratePackageIndex']);

  var actionProps = {
    onChangeForApplyAll: function onChangeForApplyAll(payload) {
      return dispatch({ type: 'CHANGE_WIDGET_VALUE_FOR_APPLY_ALL', payload: payload });
    },
    onChangeForProduct: function onChangeForProduct(payload) {
      return dispatch({ type: 'CHANGE_WIDGET_VALUE_FOR_PRODUCT', payload: _extends({}, payload, { ratePackageIndex: ratePackageIndex }) });
    }
  };
  if (rateType === 'nett') return _react2.default.createElement(_nettWidgets2.default, _extends({}, extraProps, actionProps));
  if (rateType === 'commission') return _react2.default.createElement(_commissionWidgets2.default, _extends({}, extraProps, actionProps));
  return _react2.default.createElement(_discountWidgets2.default, _extends({}, extraProps, actionProps));
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    rateType: contracting.massRateChange.get('rateType')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Widgets);

/***/ }),
/* 3448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommissionWidgets = function CommissionWidgets(_ref) {
  var applyAll = _ref.applyAll,
      commissionForAll = _ref.commissionForAll,
      retailDiffForAll = _ref.retailDiffForAll,
      commission = _ref.commission,
      retailDiff = _ref.retailDiff,
      retailNettMeasure = _ref.retailNettMeasure,
      productId = _ref.productId,
      onChangeForApplyAll = _ref.onChangeForApplyAll,
      onChangeForProduct = _ref.onChangeForProduct;

  var isPerentage = retailNettMeasure === 'percentage';
  return _react2.default.createElement(
    'div',
    { style: { width: '100%' } },
    _react2.default.createElement(
      'div',
      { style: { width: '45%', display: 'inline-block', textAlign: 'center' } },
      _react2.default.createElement('input', {
        value: (applyAll ? commissionForAll : commission) || '',
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;

          if (!isNaN(value) && (0, _ramda.gte)(Number(value), 0)) {
            return applyAll ? onChangeForApplyAll({ key: 'commissionForAll', value: value }) : onChangeForProduct({ productId: productId, value: value, key: 'commission' });
          }
        },
        style: { width: '70px', textAlign: 'right', fontSize: '25px', position: 'relative', top: '4px' }
      }),
      _react2.default.createElement(
        'span',
        { style: { width: '10px', display: 'inline-block', marginLeft: '5px', fontSize: '16px' } },
        '%'
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { width: '35%', marginLeft: '10%', display: 'inline-block', textAlign: 'center' } },
      _react2.default.createElement(
        'span',
        { style: { width: '10px', display: 'inline-block', color: '#009688', marginRight: '3px', fontSize: '16px' } },
        isPerentage ? '' : '$ ',
        ' '
      ),
      _react2.default.createElement('input', {
        value: (applyAll ? retailDiffForAll : retailDiff) || '',
        onChange: function onChange(_ref3) {
          var value = _ref3.target.value;
          return applyAll ? onChangeForApplyAll({ key: 'retailDiffForAll', value: value }) : onChangeForProduct({ productId: productId, value: value, key: 'retailDiff' });
        },
        type: 'number',
        style: { width: '70px', textAlign: 'right', fontSize: '25px', position: 'relative', top: '4px' }
      }),
      _react2.default.createElement(
        'span',
        { style: { width: '10px', display: 'inline-block', color: '#009688', marginLeft: '5px', fontSize: '16px' } },
        isPerentage ? '%' : ''
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref4) {
  var contracting = _ref4.contracting;
  return {
    rateType: contracting.massRateChange.get('rateType'),
    retailDiffForAll: contracting.massRateChange.getIn([contracting.massRateChange.get('updateType'), 'retailDiffForAll']),
    commissionForAll: contracting.massRateChange.getIn([contracting.massRateChange.get('updateType'), 'commissionForAll']),
    retailNettMeasure: contracting.massRateChange.getIn([contracting.massRateChange.get('updateType'), contracting.massRateChange.get('rateType') + 'Measure'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CommissionWidgets);

/***/ }),
/* 3449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NettWidgets = function NettWidgets(props) {
  var rateType = props.rateType,
      retailNettMeasure = props.retailNettMeasure,
      applyAll = props.applyAll,
      onChangeForApplyAll = props.onChangeForApplyAll,
      onChangeForProduct = props.onChangeForProduct,
      nettDiffForAll = props.nettDiffForAll,
      nettDiff = props.nettDiff,
      productId = props.productId;

  var isPerentage = retailNettMeasure === 'percentage';
  return _react2.default.createElement(
    'div',
    { style: { marginLeft: '15%' } },
    _react2.default.createElement(
      'span',
      { style: { width: '10px', display: 'inline-block', color: '#009688', marginRight: '3px', fontSize: '16px' } },
      isPerentage ? '' : '$ ',
      ' '
    ),
    _react2.default.createElement('input', {
      value: (applyAll ? nettDiffForAll : nettDiff) || '',
      onChange: function onChange(_ref) {
        var value = _ref.target.value;
        return applyAll ? onChangeForApplyAll({ key: 'nettDiffForAll', value: value }) : onChangeForProduct({ productId: productId, value: value, key: 'nettDiff' });
      },
      type: 'number',
      style: { width: '70px', textAlign: 'right', fontSize: '25px', position: 'relative', top: '4px' }
    }),
    _react2.default.createElement(
      'span',
      { style: { width: '10px', display: 'inline-block', color: '#009688', marginLeft: '5px', fontSize: '16px' } },
      isPerentage ? '%' : ''
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    rateType: contracting.massRateChange.get('rateType'),
    nettDiffForAll: contracting.massRateChange.getIn([contracting.massRateChange.get('updateType'), 'nettDiffForAll']),
    retailNettMeasure: contracting.massRateChange.getIn([contracting.massRateChange.get('updateType'), contracting.massRateChange.get('rateType') + 'Measure'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(NettWidgets);

/***/ }),
/* 3450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscountWidgets = function DiscountWidgets(props) {
  var rateType = props.rateType,
      retailNettMeasure = props.retailNettMeasure,
      applyAll = props.applyAll,
      onChangeForApplyAll = props.onChangeForApplyAll,
      onChangeForProduct = props.onChangeForProduct,
      discountDiffForAll = props.discountDiffForAll,
      discountDiff = props.discountDiff,
      productId = props.productId;

  var isPerentage = retailNettMeasure === 'percentage';
  return _react2.default.createElement(
    'div',
    { style: { marginLeft: '15%' } },
    _react2.default.createElement(
      'span',
      { style: { width: '10px', display: 'inline-block', color: '#009688', marginRight: '3px', fontSize: '16px' } },
      isPerentage ? '' : '$ ',
      ' '
    ),
    _react2.default.createElement('input', {
      value: applyAll ? discountDiffForAll : discountDiff,
      onChange: function onChange(_ref) {
        var value = _ref.target.value;
        return applyAll ? onChangeForApplyAll({ key: 'discountDiffForAll', value: value }) : onChangeForProduct({ productId: productId, value: value, key: 'discountDiff' });
      },
      type: 'number',
      style: { width: '70px', textAlign: 'right', fontSize: '25px', position: 'relative', top: '4px' }
    }),
    _react2.default.createElement(
      'span',
      { style: { width: '10px', display: 'inline-block', color: '#009688', marginLeft: '5px', fontSize: '16px' } },
      isPerentage ? '%' : ''
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    rateType: contracting.massRateChange.get('rateType'),
    discountDiffForAll: contracting.massRateChange.getIn([contracting.massRateChange.get('updateType'), 'discountDiffForAll']),
    retailNettMeasure: contracting.massRateChange.getIn([contracting.massRateChange.get('updateType'), contracting.massRateChange.get('rateType') + 'Measure'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DiscountWidgets);

/***/ }),
/* 3451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _singleProduct = __webpack_require__(3452);

var _singleProduct2 = _interopRequireDefault(_singleProduct);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _massRateChangeHelpers = __webpack_require__(860);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var RatesDetailContainer = function RatesDetailContainer(_ref) {
  var updateType = _ref.updateType,
      rateType = _ref.rateType,
      updateCategories = _objectWithoutProperties(_ref, ['updateType', 'rateType']);

  var updateData = updateCategories[updateType];
  return _react2.default.createElement(
    'div',
    { style: { display: 'inline-block', padding: '0 24px 24px 24px', height: '500px', float: 'right', width: '35%', borderBottom: 'solid 1px #eeeeee' } },
    _react2.default.createElement(
      'div',
      { style: { overflowY: 'scroll', maxHeight: '476px' } },
      _ramda2.default.compose(function (products) {
        return products.map(function (product, index) {
          return _react2.default.createElement(_singleProduct2.default, _extends({ key: index }, product));
        });
      }, _ramda2.default.flatten, _ramda2.default.values, _ramda2.default.groupBy(_ramda2.default.prop('productId')), _ramda2.default.reject((0, _massRateChangeHelpers.checkIfProductWithNothingToShow)(updateType, rateType)), _ramda2.default.propOr([], 'products'))(updateData)
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    updateType: contracting.massRateChange.get('updateType'),
    rateType: contracting.massRateChange.get('rateType'),
    seasonRates: contracting.massRateChange.get('seasonRates').toJS(),
    offers: contracting.massRateChange.get('offers').toJS(),
    extras: contracting.massRateChange.get('extras').toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(RatesDetailContainer);

/***/ }),
/* 3452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _singleRatesInfo = __webpack_require__(3453);

var _singleRatesInfo2 = _interopRequireDefault(_singleRatesInfo);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _massRateChangeHelpers = __webpack_require__(860);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SingleProduct = function SingleProduct(_ref) {
  var productName = _ref.productName,
      ratePackageName = _ref.ratePackageName,
      updateType = _ref.updateType,
      rateType = _ref.rateType,
      extraProps = _objectWithoutProperties(_ref, ['productName', 'ratePackageName', 'updateType', 'rateType']);

  return _react2.default.createElement(
    'div',
    { style: { marginTop: '16px' } },
    _react2.default.createElement(
      'div',
      { style: {
          height: '48px',
          textOverflow: 'ellipsis',
          overflowX: 'hidden',
          whiteSpace: 'pre',
          textTransform: 'uppercase',
          lineHeight: '48px',
          fontWeight: 'bold',
          fontSize: '14px',
          color: 'rgba(0, 0, 0, 0.87)',
          borderBottom: 'solid 1px #eeeeee'
        }
      },
      productName,
      ' ',
      ratePackageName ? ' - ' + ratePackageName : ''
    ),
    _ramda2.default.equals(updateType, 'seasonRates') ? _ramda2.default.compose(function (seasonRates) {
      return seasonRates.map(function (seasonRate, index) {
        return _react2.default.createElement(_singleRatesInfo2.default, _extends({}, seasonRate, { ratePackageName: ratePackageName, key: index }));
      });
    }, _ramda2.default.propOr([], 'seasonRates'))(extraProps) : _ramda2.default.compose(function (rateSets) {
      return rateSets.map(function (rateSet, index) {
        return _react2.default.createElement(_singleRatesInfo2.default, _extends({}, rateSet, { ratePackageName: ratePackageName, key: index }));
      });
    }, _ramda2.default.pathOr([], [updateType, rateType]))(extraProps)
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    updateType: contracting.massRateChange.get('updateType'),
    rateType: contracting.massRateChange.get('rateType')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SingleProduct);

/***/ }),
/* 3453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rateTable = __webpack_require__(3454);

var _rateTable2 = _interopRequireDefault(_rateTable);

var _discount = __webpack_require__(3457);

var _discount2 = _interopRequireDefault(_discount);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var checkIfSeasonRateWithNotEmptyRateSets = function checkIfSeasonRateWithNotEmptyRateSets(extraProps, rateType) {
  return extraProps.rateSets[rateType];
};

var SingleRatesInfo = function SingleRatesInfo(_ref) {
  var updateType = _ref.updateType,
      rateType = _ref.rateType,
      extraProps = _objectWithoutProperties(_ref, ['updateType', 'rateType']);

  var subTitleName = _ramda2.default.cond([[_ramda2.default.equals('seasonRates'), _ramda2.default.always('seasonName')], [_ramda2.default.equals('extras'), _ramda2.default.always('extraType')], [_ramda2.default.equals('offers'), _ramda2.default.always('offerName')], [_ramda2.default.T, _ramda2.default.always('seasonName')]])(updateType);

  if (_ramda2.default.equals(updateType, 'seasonRates')) {
    if (!checkIfSeasonRateWithNotEmptyRateSets(extraProps, rateType)) return _react2.default.createElement('div', null);
    return _react2.default.createElement(
      'div',
      null,
      extraProps[subTitleName] !== 'All Year' ? _react2.default.createElement(
        'div',
        { style: { height: '32px', lineHeight: '32px', textTransform: 'uppercase', color: 'rgba(0, 0, 0, 0.54)', borderBottom: 'solid 1px #eeeeee' } },
        _react2.default.createElement(
          'b',
          { style: {
              display: 'inline-block',
              marginLeft: '5px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }
          },
          extraProps[subTitleName]
        )
      ) : _react2.default.createElement('div', null),
      _ramda2.default.compose(_ramda2.default.addIndex(_ramda2.default.map)(function (rateSet, index) {
        return _react2.default.createElement(_rateTable2.default, _extends({}, rateSet, { ratePackageName: extraProps.ratePackageName, key: index }));
      }), _ramda2.default.propOr([], rateType), _ramda2.default.propOr({}, 'rateSets'))(extraProps)
    );
  }
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { height: '48px', lineHeight: '48px', fontSize: '14px', color: 'rgba(0, 0, 0, 0.54)', borderBottom: 'solid 1px #eeeeee' } },
      _react2.default.createElement(
        'span',
        { style: {
            display: 'inline-block',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%'
          }
        },
        extraProps[subTitleName]
      )
    ),
    _ramda2.default.and(_ramda2.default.equals(rateType, 'discount'), _ramda2.default.equals(updateType, 'offers')) ? _react2.default.createElement(_discount2.default, extraProps) : _react2.default.createElement(_rateTable2.default, extraProps)
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    updateType: contracting.massRateChange.get('updateType'),
    rateType: contracting.massRateChange.get('rateType')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SingleRatesInfo);

/***/ }),
/* 3454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _nettRateRow = __webpack_require__(3455);

var _nettRateRow2 = _interopRequireDefault(_nettRateRow);

var _commissionRateRow = __webpack_require__(3456);

var _commissionRateRow2 = _interopRequireDefault(_commissionRateRow);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Table = function Table(_ref) {
  var rates = _ref.rates,
      updateType = _ref.updateType,
      rateType = _ref.rateType,
      commissionPercentage = _ref.commissionPercentage,
      initialCommissionPercentage = _ref.initialCommissionPercentage,
      ratePackageName = _ref.ratePackageName,
      extraProps = _objectWithoutProperties(_ref, ['rates', 'updateType', 'rateType', 'commissionPercentage', 'initialCommissionPercentage', 'ratePackageName']);

  var TableRow = rateType === 'nett' ? _nettRateRow2.default : _commissionRateRow2.default;
  var subTitleName = _ramda2.default.cond([[_ramda2.default.equals('seasonRates'), _ramda2.default.always('' + _ramda2.default.prop('rateSetName', extraProps) + (_ramda2.default.prop('rateSetCode', extraProps) ? '(' + _ramda2.default.prop('rateSetCode', extraProps) + ')' : ''))], [_ramda2.default.equals('extras'), _ramda2.default.always(_ramda2.default.prop('extraCode', extraProps))], [_ramda2.default.equals('offers'), _ramda2.default.always(_ramda2.default.prop('bookingCode', extraProps))], [_ramda2.default.T, _ramda2.default.always('')]])(updateType);
  var subTitleLabel = _ramda2.default.cond([[_ramda2.default.equals('seasonRates'), _ramda2.default.always('Rate set name: ')], [_ramda2.default.equals('extras'), _ramda2.default.always('Extra code: ')], [_ramda2.default.equals('offers'), _ramda2.default.always('Booking code: ')], [_ramda2.default.T, _ramda2.default.always('')]])(updateType);
  return _react2.default.createElement(
    'div',
    { style: { paddingTop: '8px', fontSize: '12px' } },
    _react2.default.createElement(
      'div',
      { style: { textTransform: 'uppercase' } },
      subTitleName ? _react2.default.createElement(
        'div',
        null,
        subTitleLabel,
        _react2.default.createElement(
          'b',
          null,
          subTitleName
        )
      ) : '',
      ratePackageName ? _react2.default.createElement(
        'div',
        null,
        'Rate Package: ',
        _react2.default.createElement(
          'b',
          null,
          ratePackageName
        )
      ) : ''
    ),
    rateType === 'commission' ? _react2.default.createElement(
      'div',
      { style: { fontSize: '12px', color: initialCommissionPercentage && initialCommissionPercentage !== commissionPercentage ? '#009688' : '' } },
      commissionPercentage ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'b',
          null,
          commissionPercentage
        ),
        ' % COMMISSION'
      ) : ''
    ) : _react2.default.createElement('div', null),
    _react2.default.createElement(TableRow, { isHeader: true }),
    _ramda2.default.compose(_ramda2.default.addIndex(_ramda2.default.map)(function (rateDetail, index) {
      return _react2.default.createElement(TableRow, _extends({ key: index, index: index }, rateDetail));
    }), _ramda2.default.reject(_ramda2.default.prop('notApplicable')))(rates)
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    rateType: contracting.massRateChange.get('rateType'),
    updateType: contracting.massRateChange.get('updateType')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Table);

/***/ }),
/* 3455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEven = function isEven(n) {
  return n % 2 === 0;
};

var NettRow = function NettRow(_ref) {
  var description = _ref.description,
      nettRate = _ref.nettRate,
      initialNettRate = _ref.initialNettRate,
      isHeader = _ref.isHeader,
      index = _ref.index;
  return _react2.default.createElement(
    'div',
    {
      style: {
        fontSize: '12px',
        height: isHeader ? '20px' : '25px',
        lineHeight: isHeader ? '20px' : '25px',
        backgroundColor: isEven(index) ? '#f5f5f5' : ''
      }
    },
    _react2.default.createElement(
      'span',
      { style: { display: 'inline-block', marginLeft: '3%', width: '40%' } },
      description
    ),
    _react2.default.createElement(
      'span',
      { style: { display: 'inline-block', color: isHeader ? 'rgba(0, 0, 0, 0.54)' : initialNettRate && initialNettRate !== nettRate ? '#009688' : 'rgba(0, 0, 0, 0.87)', marginLeft: '15%', width: '30%', textAlign: 'center' } },
      isHeader ? 'NETT' : '$' + (nettRate || 0)
    )
  );
};

exports.default = NettRow;

/***/ }),
/* 3456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEven = function isEven(n) {
  return n % 2 === 0;
};

var NettRow = function NettRow(_ref) {
  var description = _ref.description,
      nettRate = _ref.nettRate,
      retailRate = _ref.retailRate,
      isHeader = _ref.isHeader,
      index = _ref.index,
      initialNettRate = _ref.initialNettRate,
      initialRetailRate = _ref.initialRetailRate;
  return _react2.default.createElement(
    'div',
    {
      style: {
        fontSize: '12px',
        height: isHeader ? '20px' : '25px',
        lineHeight: isHeader ? '20px' : '25px',
        backgroundColor: isEven(index) ? '#f5f5f5' : ''
      }
    },
    _react2.default.createElement(
      'span',
      { style: { display: 'inline-block', marginLeft: '3%', width: '27%' } },
      description
    ),
    _react2.default.createElement(
      'span',
      { style: { display: 'inline-block', color: isHeader ? 'rgba(0, 0, 0, 0.54)' : initialRetailRate && initialRetailRate !== retailRate ? '#009688' : 'rgba(0, 0, 0, 0.87)', marginLeft: '5%', width: '30%', textAlign: 'center' } },
      isHeader ? 'RETAIL' : '$' + (retailRate || 0)
    ),
    _react2.default.createElement(
      'span',
      { style: { display: 'inline-block', color: isHeader ? 'rgba(0, 0, 0, 0.54)' : initialNettRate && initialNettRate !== nettRate ? '#009688' : 'rgba(0, 0, 0, 0.87)', marginLeft: '5%', width: '30%', textAlign: 'center' } },
      isHeader ? 'NETT' : '$' + (nettRate || 0)
    )
  );
};

exports.default = NettRow;

/***/ }),
/* 3457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Discount = function Discount(_ref) {
  var amount = _ref.amount,
      initialAmount = _ref.initialAmount,
      discountType = _ref.discountType,
      bookingCode = _ref.bookingCode;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { textTransform: 'uppercase', lineHeight: '32px', fontSize: '12px' } },
      bookingCode ? 'booking code: ' + bookingCode : ''
    ),
    _react2.default.createElement(
      'div',
      {
        style: {
          fontSize: '12px',
          height: '20px',
          lineHeight: '20px',
          backgroundColor: '#f5f5f5'
        }
      },
      _react2.default.createElement(
        'span',
        { style: { display: 'inline-block', marginLeft: '3%', width: '40%' } },
        'OFFER RATE'
      ),
      _react2.default.createElement(
        'span',
        { style: { display: 'inline-block', color: initialAmount && initialAmount !== amount ? '#009688' : 'rgba(0, 0, 0, 0.87)', marginLeft: '15%', width: '30%', textAlign: 'center' } },
        '' + (discountType === 'flatRate' ? '$' : '') + (amount || 0) + (discountType === 'percentage' ? '%' : '') + ' OFF'
      )
    )
  );
};

exports.default = Discount;

/***/ }),
/* 3458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dateRange = __webpack_require__(3459);

var _dateRange2 = _interopRequireDefault(_dateRange);

var _button = __webpack_require__(3460);

var _button2 = _interopRequireDefault(_button);

var _dashboardWidget = __webpack_require__(3466);

var _dashboardWidget2 = _interopRequireDefault(_dashboardWidget);

var _actions = __webpack_require__(3480);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var array = _propTypes2.default.array,
    func = _propTypes2.default.func,
    object = _propTypes2.default.object,
    string = _propTypes2.default.string,
    bool = _propTypes2.default.bool;


var styles = {
  container: {
    maxWidth: '1440px',
    margin: '0px auto',
    padding: '0px',
    marginTop: '8px'
  },
  navigation: {
    backgroundColor: 'rgba(0, 0, 0, 0.54'
  },
  accentColors: {
    total: {
      color: 'rgb(165, 165, 165)'
    },
    received: {
      color: 'rgb(239, 239, 123)'
    },
    accepted: {
      color: 'rgb(0, 86, 98)'
    },
    loaded: {
      color: 'rgb(63, 166, 65)'
    },
    bounced: {
      color: 'rgb(211, 74, 73)'
    }
  }
};

var ContractorDashboard = function (_Component) {
  _inherits(ContractorDashboard, _Component);

  function ContractorDashboard(props) {
    _classCallCheck(this, ContractorDashboard);

    var _this = _possibleConstructorReturn(this, (ContractorDashboard.__proto__ || Object.getPrototypeOf(ContractorDashboard)).call(this, props));

    _this.componentDidMount = function () {
      var _this$props = _this.props,
          loadContractFolders = _this$props.loadContractFolders,
          initialized = _this$props.initialized,
          loadDashboard = _this$props.loadDashboard;

      if (!initialized) {
        _this.initDashboard();
      } else {
        loadDashboard();
      }
      loadContractFolders();
    };

    _this.resetGlobalFilters = function () {
      var resetGlobalFilters = _this.props.resetGlobalFilters;

      _this.toggleGlobalFilterDrawer();
      resetGlobalFilters();
    };

    _this.onSubmitClick = function () {
      _this.toggleGlobalFilterDrawer();
      _this.props.loadDashboard();
    };

    _this.toggleGlobalFilterDrawer = function () {
      _this.setState({ isFilterOpen: !_this.state.isFilterOpen });
    };

    _this.initDashboard = function () {
      _this.props.initDashboard(_this.props.companyType);
    };

    _this.updateGlobalFilter = function (filterItem, value) {
      return _this.props.updateFilter(filterItem, value);
    };

    _this.state = {
      isFilterOpen: false,
      isDatePickerOpen: false
    };
    return _this;
  }

  _createClass(ContractorDashboard, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classes = _props.classes,
          globalFilters = _props.globalFilters,
          widgets = _props.widgets,
          updateGlobalListFilter = _props.updateGlobalListFilter,
          clearListFilter = _props.clearListFilter;

      return _react2.default.createElement(
        'div',
        { className: classes.container },
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', marginBottom: '8px' } },
          _react2.default.createElement(_button2.default, {
            filterLabel: 'Contract Filters',
            filters: globalFilters,
            isFilterOpen: this.state.isFilterOpen,
            onButtonClick: this.toggleGlobalFilterDrawer,
            onResetClick: this.resetGlobalFilters,
            onSubmitClick: this.onSubmitClick,
            updateGlobalFilter: this.updateGlobalFilter,
            clearListFilter: clearListFilter,
            updateGlobalListFilter: updateGlobalListFilter
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', flex: 1, justifyContent: 'space-evenly', marginBottom: '12px' } },
          _react2.default.createElement(
            'div',
            { style: { flexDirection: 'column', flexWrap: 'wrap', display: 'flex', marginRight: '44px' } },
            widgets.filter(function (item) {
              return item.y === 1;
            }).sort(function (a, b) {
              return a.x - b.x;
            }).map(function (widget, i) {
              return _react2.default.createElement(_dashboardWidget2.default, {
                containerStyle: { marginTop: i === 0 ? 0 : '12px' },
                data: widget.data,
                filters: widget.filters,
                grid: widget.size,
                isLoading: widget.isLoading,
                key: i,
                title: widget.name,
                type: widget.chart,
                updateFilter: _this2.props.updateWidgetFilter,
                widgetId: widget.id
              });
            })
          ),
          _react2.default.createElement(
            'div',
            { style: { flexWrap: 'wrap', display: 'flex' } },
            widgets.filter(function (item) {
              return item.y === 2;
            }).sort(function (a, b) {
              return a.x - b.x;
            }).map(function (widget, i) {
              return _react2.default.createElement(_dashboardWidget2.default, {
                containerStyle: { marginTop: i === 0 ? 0 : '12px' },
                data: widget.data,
                filters: widget.filters,
                grid: widget.size,
                isLoading: widget.isLoading,
                key: i,
                title: widget.name,
                type: widget.chart,
                updateFilter: _this2.props.updateWidgetFilter,
                widgetId: widget.id
              });
            })
          )
        )
      );
    }
  }]);

  return ContractorDashboard;
}(_react.Component);

ContractorDashboard.propTypes = {
  classes: object,
  dispatch: func,
  globalFilters: object,
  loadContractFolders: func,
  loadDashboard: func,
  resetGlobalFilters: func,
  updateFilter: func,
  updateWidgetFilter: func,
  widgets: array,
  companyType: string,
  clearListFilter: func,
  updateGlobalListFilter: func,
  initialized: bool
};

var mapDispatchToProps = {
  loadDashboard: _actions.loadDashboard,
  loadContractFolders: _actions.loadContractFolders,
  resetGlobalFilters: _actions.resetGlobalFilters,
  updateFilter: _actions.updateFilter,
  updateWidgetFilter: _actions.updateWidgetFilter,
  initDashboard: _actions.initDashboard,
  updateGlobalListFilter: _actions.updateGlobalListFilter,
  clearListFilter: _actions.clearListFilter
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contractingDashboard = _ref.contractingDashboard,
      user = _ref.user;
  return {
    companyType: user.getIn(['company', 'companyType']),
    initialized: contractingDashboard.initialized,
    globalFilters: contractingDashboard.globalFilters,
    widgets: contractingDashboard.items
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(ContractorDashboard));

/***/ }),
/* 3459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keyboardArrowDown = __webpack_require__(1350);

var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var array = _propTypes2.default.array,
    bool = _propTypes2.default.bool,
    func = _propTypes2.default.func,
    object = _propTypes2.default.object;

var DateRange = function (_Component) {
  _inherits(DateRange, _Component);

  function DateRange(props) {
    _classCallCheck(this, DateRange);

    var _this = _possibleConstructorReturn(this, (DateRange.__proto__ || Object.getPrototypeOf(DateRange)).call(this, props));

    _this.getRangeDates = function (timeValue, timeVar, format) {
      return {
        startDate: (0, _moment2.default)().clone().utc().add(timeVar, timeValue).startOf(timeValue === 'week' ? 'isoWeek' : timeValue).format(format || ''),
        endDate: (0, _moment2.default)().clone().utc().add(timeVar, timeValue).endOf(timeValue === 'week' ? 'isoWeek' : timeValue).format(format || '')
      };
    };

    _this.getDateRange = function (timeValue, timeVar) {
      var _this$getRangeDates = _this.getRangeDates(timeValue, timeVar, 'D MMM'),
          startDate = _this$getRangeDates.startDate,
          endDate = _this$getRangeDates.endDate;

      return startDate + ' - ' + endDate;
    };

    _this.handleClick = function (event) {
      _this.setState({
        anchorEl: event.currentTarget
      });
      _this.props.onButtonClick();
    };

    _this.handleItemClick = function (index) {
      console.log('click', index);
      console.log('selectedDate', _this.getRangeDates(_this.props.dateChoices[index].timeValue, _this.props.dateChoices[index].timeVar));

      _this.setState({ isCustomDate: index === -1 });
    };

    _this.handleRequestClose = function () {
      _this.props.onButtonClick();
    };

    _this.state = {
      isCustomDate: false
    };
    return _this;
  }

  _createClass(DateRange, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          dateChoices = _props.dateChoices,
          isCustomRange = _props.isCustomRange,
          isDatePickerOpen = _props.isDatePickerOpen,
          onButtonClick = _props.onButtonClick;


      return _react2.default.createElement(
        'div',
        null,
        !this.state.isCustomDate ? _react2.default.createElement(
          _materialUi.FlatButton,
          {
            backgroundColor: 'rgba(0,0,0,0.04)',
            icon: _react2.default.createElement(_keyboardArrowDown2.default, null),
            label: 'Select a date range',
            labelPosition: 'after',
            onClick: this.handleClick
          },
          _react2.default.createElement(
            _materialUi.Popover,
            {
              open: isDatePickerOpen,
              anchorEl: this.state.anchorEl,
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
              targetOrigin: { horizontal: 'right', vertical: 'top' },
              onRequestClose: this.handleRequestClose
            },
            _react2.default.createElement(
              _materialUi.List,
              null,
              dateChoices.map(function (options, i) {
                return _react2.default.createElement(_materialUi.ListItem, { key: i, primaryText: _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', justifyContent: 'space-between' } },
                    _react2.default.createElement(
                      'span',
                      { style: { paddingRight: '50px' } },
                      options.title
                    ),
                    _react2.default.createElement(
                      'span',
                      { style: { fontSize: '14px', fontWeight: 600 } },
                      _this2.getDateRange(options.timeValue, options.timeVar)
                    )
                  ), onClick: function onClick() {
                    return _this2.handleItemClick(i);
                  }
                });
              }),
              _react2.default.createElement(_materialUi.ListItem, { onClick: function onClick() {
                  return _this2.handleItemClick(-1);
                }, primaryText: 'Custom Range...' })
            )
          )
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_materialUi.FlatButton, {
            backgroundColor: 'rgba(0,0,0,0.04)',
            icon: _react2.default.createElement(_keyboardArrowDown2.default, null),
            label: 'Select a date range',
            labelPosition: 'after',
            onClick: this.handleClick
          })
        )
      );
    }
  }]);

  return DateRange;
}(_react.Component);

DateRange.propTypes = {
  dateChoices: array,
  isCustomRange: bool,
  isDatePickerOpen: bool,
  onButtonClick: func,
  style: object
};

exports.default = DateRange;

/***/ }),
/* 3460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _filterButton = __webpack_require__(2021);

var _filterButton2 = _interopRequireDefault(_filterButton);

var _filteredLabel = __webpack_require__(3461);

var _filteredLabel2 = _interopRequireDefault(_filteredLabel);

var _listFilter = __webpack_require__(3462);

var _listFilter2 = _interopRequireDefault(_listFilter);

var _toggleFilter = __webpack_require__(3464);

var _toggleFilter2 = _interopRequireDefault(_toggleFilter);

var _includingPeriod = __webpack_require__(3465);

var _includingPeriod2 = _interopRequireDefault(_includingPeriod);

var _datePicker = __webpack_require__(1003);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _filterList = __webpack_require__(2022);

var _filterList2 = _interopRequireDefault(_filterList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var bool = _propTypes2.default.bool,
    func = _propTypes2.default.func,
    object = _propTypes2.default.object,
    string = _propTypes2.default.string;

var DashboardFilterButton = function (_Component) {
  _inherits(DashboardFilterButton, _Component);

  function DashboardFilterButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DashboardFilterButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DashboardFilterButton.__proto__ || Object.getPrototypeOf(DashboardFilterButton)).call.apply(_ref, [this].concat(args))), _this), _this.onFilterChange = function (e) {
      var updateGlobalFilter = _this.props.updateGlobalFilter;

      var _e$target$value$split = e.target.value.split('::'),
          _e$target$value$split2 = _slicedToArray(_e$target$value$split, 2),
          filterItem = _e$target$value$split2[0],
          value = _e$target$value$split2[1];

      updateGlobalFilter(filterItem, value);
    }, _this.onListFilterChange = function (obj) {
      var updateGlobalFilter = _this.props.updateGlobalFilter;

      console.log({ obj: obj });
      updateGlobalFilter(obj.filterKey, obj.value);
    }, _this.onContractingPeriodFieldChange = function (value) {
      _this.props.updateGlobalFilter('contractingPeriod', value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DashboardFilterButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          filters = _props.filters,
          isFilterOpen = _props.isFilterOpen,
          onButtonClick = _props.onButtonClick,
          onResetClick = _props.onResetClick,
          onSubmitClick = _props.onSubmitClick,
          filterLabel = _props.filterLabel;


      var filterArray = Object.values(filters).filter(function (f) {
        return f.type !== 'date';
      });

      var filterCount = filterArray.filter(function (f) {
        return f.selectedValue;
      }).length;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_materialUi.FlatButton, {
          onTouchTap: onButtonClick,
          backgroundColor: 'rgba(0,0,0,0.04)',
          icon: _react2.default.createElement(_filterList2.default, null),
          label: filterCount ? _react2.default.createElement(_filteredLabel2.default, { label: 'Filtered', count: filterCount }) : filterLabel
        }),
        _react2.default.createElement(
          _materialUi.Drawer,
          {
            open: isFilterOpen,
            onRequestClose: onButtonClick
          },
          _react2.default.createElement(
            _materialUi.List,
            null,
            filterArray.sort(function (a, b) {
              return b.title - a.title;
            }).map(function (filter, i) {
              if (filter.type === 'contractingPeriod') {
                return _react2.default.createElement(_includingPeriod2.default, {
                  filterKey: filter.key,
                  key: i,
                  onFilterChange: _this2.onContractingPeriodFieldChange,
                  selectedValue: filter.selectedValue,
                  title: filter.title,
                  value: filter.value
                });
              }
              return filter.type === 'list' ? _react2.default.createElement(_listFilter2.default, {
                filterKey: filter.key,
                key: i,
                onListFilterChange: _this2.props.updateGlobalListFilter,
                clearListFilter: _this2.props.clearListFilter,
                title: filter.title,
                list: filter.list
              }) : _react2.default.createElement(_toggleFilter2.default, {
                filterKey: filter.key,
                key: i,
                onFilterChange: _this2.onFilterChange,
                selectedValue: filter.selectedValue,
                title: filter.title,
                value: filter.value
              });
            })
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'flex-tc-sb',
              style: { position: 'sticky', bottom: 0, width: '100%', padding: '8px', background: 'white' }
            },
            _react2.default.createElement(_materialUi.FlatButton, { label: 'Reset', onClick: onResetClick }),
            _react2.default.createElement(_materialUi.FlatButton, { label: 'Apply', secondary: true, onClick: onSubmitClick })
          )
        )
      );
    }
  }]);

  return DashboardFilterButton;
}(_react.Component);

DashboardFilterButton.propTypes = {
  filters: object,
  isFilterOpen: bool,
  onButtonClick: func,
  onResetClick: func,
  onSubmitClick: func,
  updateGlobalFilter: func,
  filterLabel: string,
  clearListFilter: func
};

exports.default = DashboardFilterButton;

/***/ }),
/* 3461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var number = _propTypes2.default.number,
    string = _propTypes2.default.string;


var FilteredLabel = function FilteredLabel(_ref) {
  var label = _ref.label,
      count = _ref.count;
  return _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(
      'span',
      null,
      label
    ),
    _react2.default.createElement('span', { style: {
        borderColor: 'rgb(189, 189, 189)',
        borderLeftStyle: 'solid',
        borderLeftWidth: '1px',
        minHeight: '28px',
        margin: '0 10px'
      }
    }),
    _react2.default.createElement(
      'span',
      null,
      count
    )
  );
};

FilteredLabel.propTypes = {
  label: string.isRequired,
  count: number
};

exports.default = FilteredLabel;

/***/ }),
/* 3462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__(3);

var _nestedItem = __webpack_require__(3463);

var _nestedItem2 = _interopRequireDefault(_nestedItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _propTypes2.default.object,
    array = _propTypes2.default.array;


var ListFilter = function ListFilter(_ref) {
  var filterKey = _ref.filterKey,
      clearListFilter = _ref.clearListFilter,
      onListFilterChange = _ref.onListFilterChange,
      title = _ref.title,
      list = _ref.list;

  var anyValueSelected = list.some(function (obj) {
    return obj.checked;
  });
  return _react2.default.createElement(_materialUi.ListItem, {
    primaryText: title,
    insetChildren: true,
    leftCheckbox: _react2.default.createElement(_materialUi.Checkbox, {
      disabled: !anyValueSelected,
      checked: anyValueSelected,
      onCheck: function onCheck() {
        return clearListFilter({ filterKey: filterKey });
      }
    }),
    primaryTogglesNestedList: true,
    nestedItems: list.map(function (obj, i) {
      return _react2.default.createElement(_materialUi.ListItem, {
        key: i,
        leftCheckbox: _react2.default.createElement(_materialUi.Checkbox, {
          checked: Boolean(obj.checked),
          onCheck: function onCheck(_, checked) {
            return onListFilterChange({ filterKey: filterKey, listIndex: i, checked: checked });
          }
        }),
        primaryText: obj.title
      });
    })
  });
};

ListFilter.propTypes = {
  filter: object,
  selectedValue: array
};

exports.default = ListFilter;

/***/ }),
/* 3463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _selectFields = __webpack_require__(141);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _propTypes2.default.object,
    string = _propTypes2.default.string;


var NestedItems = function NestedItems(_ref) {
  var filterKey = _ref.filterKey,
      _onChange = _ref.onChange,
      selectedValue = _ref.selectedValue,
      title = _ref.title,
      list = _ref.list;

  return _react2.default.createElement(
    'div',
    { style: { overflow: 'auto' } },
    _react2.default.createElement(_reactSelect2.default, {
      name: filterKey,
      style: { fontSize: '14px', zIndex: '0' },
      menuStyle: { height: '150px' },
      multi: true,
      layout: "l-paper-right multi-select",
      options: list.map(function (v) {
        return { label: v.title, value: v.value };
      }),
      value: selectedValue,
      onChange: function onChange(value) {
        return _onChange({ value: value, filterKey: filterKey });
      },
      placeholder: 'Please enter/select time',
      scrollMenuIntoView: true,
      clearable: false
    })
  );
};

NestedItems.propTypes = {
  filter: object,
  selectedValue: string
};

exports.default = NestedItems;

/***/ }),
/* 3464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bool = _propTypes2.default.bool,
    func = _propTypes2.default.func,
    string = _propTypes2.default.string;


var ToggleFilter = function ToggleFilter(_ref) {
  var filterKey = _ref.filterKey,
      onFilterChange = _ref.onFilterChange,
      selectedValue = _ref.selectedValue,
      title = _ref.title;
  return _react2.default.createElement(_materialUi.ListItem, {
    primaryText: title,
    rightToggle: _react2.default.createElement(_materialUi.Toggle, {
      value: filterKey + '::' + selectedValue,
      toggled: selectedValue,
      onToggle: onFilterChange
    })
  });
};

ToggleFilter.propTypes = {
  filterKey: string,
  onFilterChange: func,
  selectedValue: bool,
  title: string
};

exports.default = ToggleFilter;

/***/ }),
/* 3465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__(3);

var _datePicker = __webpack_require__(1003);

var _datePicker2 = _interopRequireDefault(_datePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var object = _propTypes2.default.object,
    string = _propTypes2.default.string;


var ListFilter = function ListFilter(_ref) {
  var filterKey = _ref.filterKey,
      onFilterChange = _ref.onFilterChange,
      selectedValue = _ref.selectedValue,
      title = _ref.title,
      value = _ref.value;

  var splitted = (selectedValue || '').split('|');
  var fromDate = splitted[0];
  var toDate = splitted[1];
  return _react2.default.createElement(_materialUi.ListItem, {
    primaryText: title,
    insetChildren: true,
    leftCheckbox: _react2.default.createElement(_materialUi.Checkbox, {
      disabled: !Boolean(selectedValue),
      value: filterKey + '::' + value,
      checked: Boolean(selectedValue),
      onCheck: function onCheck() {
        return onFilterChange('');
      }
    }),
    primaryTogglesNestedList: true,
    nestedListStyle: { textAlign: 'center' },
    nestedItems: [_react2.default.createElement(
      'div',
      { key: 0, className: 'flex-tc-sb' },
      _react2.default.createElement(_datePicker2.default, {
        'data-cy': 'fromDate',
        textFieldStyle: { width: '100%', fontSize: '12px' },
        onChange: function onChange(date) {
          return onFilterChange(date + '|' + (toDate || date));
        },
        value: fromDate,
        initialMonth: fromDate || toDate,
        floatingLabelText: 'From Date',
        closeOnSelect: true
      }),
      _react2.default.createElement(_datePicker2.default, {
        'data-cy': 'toDate',
        textFieldStyle: { width: '100%', fontSize: '12px' },
        onChange: function onChange(date) {
          return onFilterChange((fromDate || date) + '|' + date);
        },
        value: toDate,
        enableFrom: fromDate,
        initialMonth: toDate || fromDate,
        floatingLabelText: 'To Date',
        closeOnSelect: true
      })
    )]
  });
};

ListFilter.propTypes = {
  filter: object,
  selectedValue: string
};

exports.default = ListFilter;

/***/ }),
/* 3466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _filterButton = __webpack_require__(2021);

var _filterButton2 = _interopRequireDefault(_filterButton);

var _loading = __webpack_require__(3467);

var _loading2 = _interopRequireDefault(_loading);

var _error = __webpack_require__(3468);

var _error2 = _interopRequireDefault(_error);

var _helpOutline = __webpack_require__(1117);

var _helpOutline2 = _interopRequireDefault(_helpOutline);

var _charts = __webpack_require__(3469);

var charts = _interopRequireWildcard(_charts);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var any = _propTypes2.default.any,
    array = _propTypes2.default.array,
    bool = _propTypes2.default.bool,
    node = _propTypes2.default.node,
    object = _propTypes2.default.object,
    oneOf = _propTypes2.default.oneOf,
    string = _propTypes2.default.string,
    func = _propTypes2.default.func,
    number = _propTypes2.default.number;


var defaultStyles = {
  container: function container(props) {
    var grid = props.grid || [1, 1];
    var gutter = props.gutter || 12;
    return {
      width: grid[0] * 270 + gutter * (grid[0] - 1) + 'px',
      height: grid[1] * 100 + gutter * (grid[1] - 1) + 'px'
    };
  },
  title: {
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0',
    alignItems: 'center'
  },
  widgetContent: function widgetContent(props) {
    if (props.title) {
      return {
        height: 'calc(100% - 55px)',
        overflowY: 'auto',
        marginTop: '-8px'
      };
    }
    return {
      overflowY: 'auto',
      marginTop: '8px'
    };
  }
};

var styles = _extends({}, defaultStyles, styles);

var DashboardWidget = function (_Component) {
  _inherits(DashboardWidget, _Component);

  function DashboardWidget(props) {
    _classCallCheck(this, DashboardWidget);

    var _this = _possibleConstructorReturn(this, (DashboardWidget.__proto__ || Object.getPrototypeOf(DashboardWidget)).call(this, props));

    _this.onFilterChange = function (filterBy) {
      return function (i, item) {
        _this.handleFilterMenu();
        _this.props.updateFilter(_this.props.widgetId, filterBy, {
          filterLabel: item.label,
          filterValue: item.value
        });
      };
    };

    _this.getHelpText = function (text) {
      return _react2.default.createElement(
        'span',
        { className: 'hint--bottom hint--large hint--rounded', 'aria-label': text },
        _react2.default.createElement(_helpOutline2.default, { style: { width: '12px', height: '12px', color: 'rgb(117, 117, 117)' } })
      );
    };

    _this.handleFilterMenu = function () {
      _this.setState({ isFilterOpen: !_this.state.isFilterOpen });
    };

    _this.state = {
      isFilterOpen: false
    };
    return _this;
  }

  _createClass(DashboardWidget, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          containerStyle = _props.containerStyle,
          data = _props.data,
          error = _props.error,
          filters = _props.filters,
          grid = _props.grid,
          headerStyle = _props.headerStyle,
          helpText = _props.helpText,
          innerStyle = _props.innerStyle,
          isLoading = _props.isLoading,
          title = _props.title,
          titleStyle = _props.titleStyle,
          type = _props.type;

      if (error) {
        return _react2.default.createElement(
          _materialUi.Card,
          {
            className: classes.container,
            style: containerStyle,
            containerStyle: { height: '100%' }
          },
          _react2.default.createElement(_error2.default, { grid: grid })
        );
      }
      if (isLoading) {
        return _react2.default.createElement(
          _materialUi.Card,
          {
            className: classes.container,
            style: containerStyle,
            containerStyle: { height: '100%' }
          },
          _react2.default.createElement(_loading2.default, { grid: grid })
        );
      }

      var Chart = charts[type];
      return _react2.default.createElement(
        _materialUi.Card,
        {
          className: classes.container,
          style: containerStyle,
          containerStyle: { height: '100%' }
        },
        Boolean(title) && _react2.default.createElement(
          _materialUi.CardHeader,
          {
            className: classes.title,
            title: _react2.default.createElement(
              'span',
              null,
              title,
              helpText && _react2.default.createElement(
                'span',
                { style: { padding: '0 0 0 5px' } },
                this.getHelpText(helpText)
              )
            ),
            titleStyle: _extends({}, defaultStyles.title, titleStyle),
            style: _extends({}, headerStyle),
            textStyle: { padding: 0 }
          },
          _react2.default.createElement(
            'div',
            null,
            filters && Object.values(filters).map(function (_ref, i) {
              var filterItems = _ref.filterItems,
                  filterLabel = _ref.filterLabel,
                  filterBy = _ref.filterBy;
              return _react2.default.createElement(_filterButton2.default, {
                key: i,
                items: filterItems,
                filterLabel: filterLabel,
                style: { display: 'inline-block', marginLeft: '4px' },
                onButtonClick: _this2.handleFilterMenu,
                onFilterChange: _this2.onFilterChange(filterBy)
              });
            })
          )
        ),
        _react2.default.createElement(
          _materialUi.CardText,
          {
            className: classes.widgetContent,
            style: _extends({}, DashboardWidget.defaultProps.innerStyle, innerStyle)
          },
          !type ? children : _react2.default.createElement(Chart, { data: data })
        )
      );
    }
  }]);

  return DashboardWidget;
}(_react.Component);

DashboardWidget.defaultProps = {
  innerStyle: { padding: '0 11px' }
};

DashboardWidget.propTypes = {
  children: node,
  classes: object,
  containerStyle: object,
  data: any,
  error: any,
  filters: object,
  grid: array,
  headerStyle: object,
  helpText: string,
  innerStyle: object,
  isLoading: bool,
  title: string,
  titleStyle: object,
  updateFilter: func,
  widgetId: number,
  type: oneOf(['ContractActivityFeed', 'ContractFunnel', 'SentItems', 'ContractActivityStats', 'ContractTaskList', 'PotentialPartners'])
};

exports.default = (0, _reactJss2.default)(styles)(DashboardWidget);

/***/ }),
/* 3467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var string = _propTypes2.default.string;


var Loading = function Loading(_ref) {
  var grid = _ref.grid;
  return _react2.default.createElement(
    'div',
    { style: { background: 'rgb(241, 241, 241)', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' } },
    _react2.default.createElement(
      'svg',
      {
        width: grid && grid[0] !== 1 ? '100' : '50',
        height: grid && grid[0] !== 1 ? '100' : '50',
        viewBox: '0 0 250 240'
      },
      _react2.default.createElement('path', { fill: '#efefef', d: 'M164.9 108.9c-12.7 22-41.3 82.7-65.5 82.7-24.2 0-28.8-41.2-68.3-41.2-10 0-18.5 2.4-27.7 8.8V222c0 7.3 5.9 13.2 13.2 13.2h216.2c7.3 0 13.2-5.9 13.2-13.2V87.8c-19-23.9-43.5-44-81.1 21.1' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#cecece', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M232.8 235.2H16.6c-7.3 0-13.2-5.9-13.2-13.2V18c0-7.3 5.9-13.2 13.2-13.2h216.2c7.3 0 13.2 5.9 13.2 13.2v204c0 7.3-5.9 13.2-13.2 13.2z' }),
      _react2.default.createElement('path', { id: 'line', fill: 'none', stroke: '#cecece', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M246 87.8c-19-23.9-43.5-44-81.1 21-12.7 22-41.3 82.7-65.5 82.7-24.2 0-28.8-41.2-68.3-41.2-10 0-18.5 2.4-27.7 8.8' }),
      _react2.default.createElement(
        'circle',
        { r: '9.5', fill: '#fcfcfc', stroke: '#cecece', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4' },
        _react2.default.createElement(
          'animateMotion',
          { begin: '0s', dur: '3s', repeatCount: 'indefinite' },
          _react2.default.createElement('mpath', { xlinkHref: '#line' })
        )
      ),
      _react2.default.createElement(
        'circle',
        { r: '9.5', fill: '#fcfcfc', stroke: '#cecece', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4' },
        _react2.default.createElement(
          'animateMotion',
          { begin: '.5s', dur: '3s', repeatCount: 'indefinite' },
          _react2.default.createElement('mpath', { xlinkHref: '#line' })
        )
      ),
      _react2.default.createElement(
        'circle',
        { r: '9.5', fill: '#fcfcfc', stroke: '#cecece', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4' },
        _react2.default.createElement(
          'animateMotion',
          { begin: '1s', dur: '3s', repeatCount: 'indefinite' },
          _react2.default.createElement('mpath', { xlinkHref: '#line' })
        )
      )
    ),
    _react2.default.createElement(
      'p',
      { style: { color: 'rgb(136, 136, 136)', fontSize: '16px', fontWeight: '500', paddingTop: '25px', textAlign: 'center' } },
      'We\'re crunching some numbers...'
    )
  );
};

Loading.propTypes = {
  svgSize: string
};

exports.default = Loading;

/***/ }),
/* 3468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var string = _propTypes2.default.string;


var ErrorState = function ErrorState(_ref) {
  var grid = _ref.grid;
  return _react2.default.createElement(
    'div',
    { style: { background: 'rgb(255, 255, 255)', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' } },
    _react2.default.createElement(
      'svg',
      {
        width: grid && grid[0] !== 1 ? '250' : '200',
        height: grid && grid[0] !== 1 ? '250' : '200',
        viewBox: '0 0 600 600'
      },
      _react2.default.createElement('path', { fill: 'none', stroke: '#cecece', strokeLinecap: 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': '10', strokeWidth: '4', d: 'M310.2 242.6h-46.3c-13.5 0-24.4-10.9-24.4-24.4 0-13.5 10.9-24.4 24.4-24.4h31.6', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: '#efefef', d: 'M264.7 423.5L252 435.1l-89.4-100.2 12.8-11.5z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#cecece', strokeLinecap: 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': '10', strokeWidth: '4', d: 'M264.7 423.5L252 435.1l-89.4-100.2 12.8-11.5z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: '#efefef', d: 'M263.1 232.8l11.6 12.8L174.6 335 163 322.2z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#cecece', strokeLinecap: 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': '10', strokeWidth: '4', d: 'M263.1 232.8l11.6 12.8L174.6 335 163 322.2z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: '#efefef', d: 'M329.1 464.1H176.8v-.1c0-7.9 6.4-14.4 14.4-14.4h123.6c7.9 0 14.4 6.4 14.4 14.4v.1z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#cecece', strokeLinecap: 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': '10', strokeWidth: '4', d: 'M329.1 464.1H176.8v-.1c0-7.9 6.4-14.4 14.4-14.4h123.6c7.9 0 14.4 6.4 14.4 14.4v.1z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: '#efefef', d: 'M301.9 449.6H204v-.1c0-7.9 6.4-14.4 14.4-14.4h69.2c7.9 0 14.4 6.4 14.4 14.4v.1z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#cecece', strokeLinecap: 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': '10', strokeWidth: '4', d: 'M301.9 449.6H204v-.1c0-7.9 6.4-14.4 14.4-14.4h69.2c7.9 0 14.4 6.4 14.4 14.4v.1z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M268.3 435h-30.8v-9.5c0-8.4 6.8-15.3 15.3-15.3h.3c8.4 0 15.3 6.8 15.3 15.3v9.5z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#cecece', strokeLinecap: 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': '10', strokeWidth: '4', d: 'M268.3 435h-30.8v-9.5c0-8.4 6.8-15.3 15.3-15.3h.3c8.4 0 15.3 6.8 15.3 15.3v9.5z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M197.8 337.2l-22.5 13c-5.2 3-11.9.3-13.6-5.5-3.2-10.6-2.9-21.1.2-31.3 1.7-5.7 8.4-8.3 13.6-5.3l22.4 12.9c6.2 3.6 6.2 12.6-.1 16.2', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#cecece', strokeLinecap: 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': '10', strokeWidth: '4', d: 'M197.8 337.2l-22.5 13c-5.2 3-11.9.3-13.6-5.5-3.2-10.6-2.9-21.1.2-31.3 1.7-5.7 8.4-8.3 13.6-5.3l22.4 12.9c6.2 3.6 6.2 12.6-.1 16.2z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M282.3 248.6l-9.4 7.9c-3.7 3.1-9.2 2.6-12.3-1.1L250.3 243c-4.7-5.7-.7-14.3 6.7-14.3h18c10.5.1 15.3 13.2 7.3 19.9', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#cecece', strokeLinecap: 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': '10', strokeWidth: '4', d: 'M282.3 248.6l-9.4 7.9c-3.7 3.1-9.2 2.6-12.3-1.1L250.3 243c-4.7-5.7-.7-14.3 6.7-14.3h18c10.5.1 15.3 13.2 7.3 19.9z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: '#efefef', d: 'M437.1 224.7L327.5 334.4c-30.3-30.3-30.3-79.4 0-109.6 30.3-30.3 79.3-30.3 109.6-.1', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#cecece', strokeLinecap: 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': '10', strokeWidth: '4', d: 'M437.1 224.7L327.5 334.4c-30.3-30.3-30.3-79.4 0-109.6 30.3-30.3 79.3-30.3 109.6-.1z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: '#efefef', d: 'M352 208.8l-23.2-23.2c-11-11-28.8-11-39.7 0l-.6.6c-11 11-11 28.8 0 39.7l23.2 23.2 40.3-40.3z', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#cecece', strokeLinecap: 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': '10', strokeWidth: '4', d: 'M352 208.8l-23.2-23.2c-11-11-28.8-11-39.7 0l-.6.6c-11 11-11 28.8 0 39.7l23.2 23.2 40.3-40.3zm-30.5 119.6l109.7-109.6M306.3 244l40.4-40.4', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#f1ff3e', strokeLinecap: 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': '10', strokeWidth: '4', d: 'M350.6 338.2v21.6m23.7-45.2l10.6 18.7m11.9-41.2l15.2 15.2m8.5-38.9l18.7 10.7m4.3-33.8h21.6', strokePath: 'url(#a)' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#cecece', strokeLinecap: 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': '10', strokeWidth: '4', d: 'M134.9 464.1H371', strokePath: 'url(#a)' })
    ),
    _react2.default.createElement(
      'p',
      { style: { color: 'rgb(136, 136, 136)', textAlign: 'center' } },
      'Whoops! You\'ve shined a light on an error.',
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'a',
          { href: '' },
          'Let\'s try that again.'
        )
      )
    )
  );
};

ErrorState.propTypes = {
  svgSize: string
};

exports.default = ErrorState;

/***/ }),
/* 3469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PotentialPartners = exports.ContractTaskList = exports.ContractActivityStats = exports.SentItems = exports.ContractFunnel = exports.ContractActivityFeed = undefined;

var _contractActivityFeed = __webpack_require__(3470);

var _contractActivityFeed2 = _interopRequireDefault(_contractActivityFeed);

var _contractFunnel = __webpack_require__(3473);

var _contractFunnel2 = _interopRequireDefault(_contractFunnel);

var _sentItems = __webpack_require__(3475);

var _sentItems2 = _interopRequireDefault(_sentItems);

var _contractActivityStats = __webpack_require__(3477);

var _contractActivityStats2 = _interopRequireDefault(_contractActivityStats);

var _ContractTaskList2 = __webpack_require__(3478);

var _ContractTaskList3 = _interopRequireDefault(_ContractTaskList2);

var _PotentialPartners2 = __webpack_require__(3479);

var _PotentialPartners3 = _interopRequireDefault(_PotentialPartners2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ContractActivityFeed = _contractActivityFeed2.default;
exports.ContractFunnel = _contractFunnel2.default;
exports.SentItems = _sentItems2.default;
exports.ContractActivityStats = _contractActivityStats2.default;
exports.ContractTaskList = _ContractTaskList3.default;
exports.PotentialPartners = _PotentialPartners3.default;

/***/ }),
/* 3470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _contractingUtils = __webpack_require__(124);

var _empty = __webpack_require__(3471);

var _empty2 = _interopRequireDefault(_empty);

var _timeline = __webpack_require__(3472);

var _timeline2 = _interopRequireDefault(_timeline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var arrayOf = _propTypes2.default.arrayOf,
    func = _propTypes2.default.func,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string,
    array = _propTypes2.default.array;

var ContractActivityFeed = function (_Component) {
  _inherits(ContractActivityFeed, _Component);

  function ContractActivityFeed() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContractActivityFeed);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContractActivityFeed.__proto__ || Object.getPrototypeOf(ContractActivityFeed)).call.apply(_ref, [this].concat(args))), _this), _this.onItemClick = function (i) {
      var _this$props = _this.props,
          data = _this$props.data,
          dispatch = _this$props.dispatch;

      dispatch((0, _reactRouterRedux.push)('/contracting/contract/' + data.timeline[i].contractId + '/details'));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContractActivityFeed, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      if (!data.timeline.length) {
        return _react2.default.createElement(_empty2.default, { message: 'OooWee! It is a veritable desert out there. A different filter might get you more results.' });
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', flexWrap: 'wrap', borderBottom: '1px solid #efefef', marginBottom: '12px' } },
          data.stats.map(function (d, i) {
            return _react2.default.createElement(
              'div',
              { key: i, style: { flex: '1 0 15%', textAlign: 'center' } },
              _react2.default.createElement(
                'span',
                {
                  style: {
                    display: 'block',
                    fontSize: '24px',
                    lineHeight: '40px',
                    color: (0, _contractingUtils.getStatusColor)(d.label)
                  }
                },
                d.value
              ),
              _react2.default.createElement(
                'span',
                {
                  style: {
                    display: 'block',
                    fontSize: '14px',
                    textTransform: 'capitalize',
                    color: (0, _contractingUtils.getStatusColor)(d.label)
                  }
                },
                d.label
              ),
              _react2.default.createElement(
                'div',
                { className: 'flex-center', style: { flexDirection: 'column', display: d.updates ? 'flex' : 'none', justifyContent: 'center', marginBottom: '12px' } },
                _react2.default.createElement(
                  'small',
                  null,
                  d.updates,
                  ' Updates'
                )
              )
            );
          })
        ),
        _react2.default.createElement(_timeline2.default, { feed: data.timeline, onItemClick: this.onItemClick })
      );
    }
  }]);

  return ContractActivityFeed;
}(_react.Component);

ContractActivityFeed.propTypes = {
  data: shape({
    stats: array.isRequired,
    timeline: arrayOf(shape({
      label: string.isRequired,
      contractId: string.isRequired,
      timestamp: string.isRequired
    })).isRequired
  }).isRequired,
  dispatch: func
};

exports.default = (0, _reactRedux.connect)()(ContractActivityFeed);

/***/ }),
/* 3471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var array = _propTypes2.default.array,
    string = _propTypes2.default.string;


var EmptyState = function EmptyState(_ref) {
  var message = _ref.message;
  return _react2.default.createElement(
    'div',
    { style: { background: 'rgb(255, 255, 255)', width: '100%', height: '80%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' } },
    _react2.default.createElement(
      'svg',
      {
        width: '100%',
        viewBox: '0 0 1300 600'
      },
      _react2.default.createElement('path', { fill: '#fff', d: 'M775 406.8v29.1h15.6v-48h6.2c8.3 0 15.1-6.8 15.1-15.1V346c0-4.3-3.5-7.8-7.8-7.8s-7.8 3.5-7.8 7.8v26.3h-5.8V337c0-4.3-3.5-7.8-7.8-7.8s-7.8 3.5-7.8 7.8v54.2h-6.1c-.5 0-.9-.4-.9-.9v-15.4c0-4.3-3.5-7.8-7.8-7.8s-7.8 3.5-7.8 7.8v15.4c0 9.1 7.4 16.6 16.6 16.6h6.1z' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M775 406.8v29.1h15.6v-48h6.2c8.3 0 15.1-6.8 15.1-15.1V346c0-4.3-3.5-7.8-7.8-7.8s-7.8 3.5-7.8 7.8v26.3h-5.8V337c0-4.3-3.5-7.8-7.8-7.8s-7.8 3.5-7.8 7.8v54.2h-6.1c-.5 0-.9-.4-.9-.9v-15.4c0-4.3-3.5-7.8-7.8-7.8s-7.8 3.5-7.8 7.8v15.4c0 9.1 7.4 16.6 16.6 16.6h6.1z' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M782.5 344.9v5.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M782.5 344.9v5.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M804 352.4v5.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M804 352.4v5.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M804 368.9v4' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M804 368.9v4' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M782.5 394.4h.5v5.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M782.5 394.4h.5v5.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M759.5 382.9v3.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M759.5 382.9v3.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M751.3 459.9s77.1-51.8 185.4-52.5c108.8-.7 195.3 49.7 203.3 52.4l-388.7.1z' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M751.3 459.9s77.1-51.8 185.4-52.5c108.8-.7 195.3 49.7 203.3 52.4l-388.7.1z' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M167.1 459.7s77.1-53.2 185.4-53.2c73.5 0 144.1 42.9 242.8 42.9 72 0 112.7-16 194-16 97.5 0 172.3 25.5 175.3 26.5l-797.5-.2z' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M167.1 459.7s77.1-53.2 185.4-53.2c73.5 0 144.1 42.9 242.8 42.9 72 0 112.7-16 194-16 97.5 0 172.3 25.5 175.3 26.5l-797.5-.2z' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M99.2 459.9h1101.6' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M99.2 459.9h1101.6' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M691.2 294.8c0 19.9-16.1 36-36 36s-36-16.1-36-36 16.1-36 36-36 36 16.1 36 36' }),
      _react2.default.createElement('circle', { cx: '655.2', cy: '294.8', r: '36', fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M715.2 301.3h24' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M715.2 301.3h24' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M755.7 299.8h7.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M755.7 299.8h7.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M673.2 347.8h7.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M673.2 347.8h7.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M698.7 239.8h7.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M698.7 239.8h7.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M564.2 300.8h25.7' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M564.2 300.8h25.7' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M537.7 300.8h14.7' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M537.7 300.8h14.7' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M586.7 279.3h12' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M586.7 279.3h12' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M576.2 320.3h25.6' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M576.2 320.3h25.6' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M712.2 280.8h9.1' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M712.2 280.8h9.1' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M706.2 322.3h16.6' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M706.2 322.3h16.6' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M391.3 400.4v59.5h32v-98.3H436c17.1 0 31-13.9 31-31v-54.7c0-8.8-7.2-16-16-16s-16 7.2-16 16v53.7h-11.8v-72.1c0-8.8-7.2-16-16-16s-16 7.2-16 16v110.9h-12.4c-1.1 0-1.9-.9-1.9-1.9V335c0-8.8-7.2-16-16-16s-16 7.2-16 16v31.5c0 18.7 15.2 33.9 33.9 33.9h12.5z' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M391.3 400.4v59.5h32v-98.3H436c17.1 0 31-13.9 31-31v-54.7c0-8.8-7.2-16-16-16s-16 7.2-16 16v53.7h-11.8v-72.1c0-8.8-7.2-16-16-16s-16 7.2-16 16v110.9h-12.4c-1.1 0-1.9-.9-1.9-1.9V335c0-8.8-7.2-16-16-16s-16 7.2-16 16v31.5c0 18.7 15.2 33.9 33.9 33.9h12.5z' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M402 265.4v15.3' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M402 265.4v15.3' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M402 376.7v15.4' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M402 376.7v15.4' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M402 338.7v9.4' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M402 338.7v9.4' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M413.3 286.7v8.7' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M413.3 286.7v8.7' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M456 307.4v8.7' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M456 307.4v8.7' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M355 338.9v8.7' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M355 338.9v8.7' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M414 353.8v6.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M414 353.8v6.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M445.3 286.1v6.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M445.3 286.1v6.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M403.3 301.4v4.1' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M403.3 301.4v4.1' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M445.3 323.7v4' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M445.3 323.7v4' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M367.5 357.8v4.1' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M367.5 357.8v4.1' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M414 316.1v11.3' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M414 316.1v11.3' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M414 392.7v11.4' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M414 392.7v11.4' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M508.1 393.2h8.6v66.7h22v-39.7h9.8c11.8 0 21.3-9.6 21.3-21.3v-16.3c0-6.1-4.9-11-11-11s-11 4.9-11 11v15.7h-9.1v-60.7c0-6.1-4.9-11-11-11s-11 4.9-11 11v33.7h-8.6c-.7 0-1.3-.6-1.3-1.3v-21.7c0-6.1-4.9-11-11-11s-11 4.9-11 11V370c0 12.8 10.4 23.2 23.3 23.2' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M508.1 393.2h8.6v66.7h22v-39.7h9.8c11.8 0 21.3-9.6 21.3-21.3v-16.3c0-6.1-4.9-11-11-11s-11 4.9-11 11v15.7h-9.1v-60.7c0-6.1-4.9-11-11-11s-11 4.9-11 11v33.7h-8.6c-.7 0-1.3-.6-1.3-1.3v-21.7c0-6.1-4.9-11-11-11s-11 4.9-11 11V370c0 12.8 10.4 23.2 23.3 23.2z' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M525.5 343.4v6.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M525.5 343.4v6.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M530.5 368.9v5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M530.5 368.9v5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M526.5 389.9v4.6' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M526.5 389.9v4.6' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M492 353.4v6' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M492 353.4v6' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M499 364.4v6' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M499 364.4v6' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M556.5 383.4v7' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M556.5 383.4v7' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M562.5 396.9v2.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M562.5 396.9v2.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M873 397.2h8.6v62.7h22v-21h.9c15 0 27.2-12.2 27.2-27.2v-69.8c0-6.1-4.9-11-11-11s-11 4.9-11 11v69.8c0 2.9-2.3 5.2-5.2 5.2h-.9V302.6c0-6.1-4.9-11-11-11s-11 4.9-11 11v72.7H873c-.7 0-1.3-.6-1.3-1.3v-37c0-6.1-4.9-11-11-11s-11 4.9-11 11v37c0 12.8 10.4 23.2 23.3 23.2' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M873 397.2h8.6v62.7h22v-21h.9c15 0 27.2-12.2 27.2-27.2v-69.8c0-6.1-4.9-11-11-11s-11 4.9-11 11v69.8c0 2.9-2.3 5.2-5.2 5.2h-.9V302.6c0-6.1-4.9-11-11-11s-11 4.9-11 11v72.7H873c-.7 0-1.3-.6-1.3-1.3v-37c0-6.1-4.9-11-11-11s-11 4.9-11 11v37c0 12.8 10.4 23.2 23.3 23.2z' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M856.5 343.9v5.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M856.5 343.9v5.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M863.5 359.9v6' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M863.5 359.9v6' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M863.5 337.4v3.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M863.5 337.4v3.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M858 373.9v7.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M858 373.9v7.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M888.5 314.9v7' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M888.5 314.9v7' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M897 302.4v3' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M897 302.4v3' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M896.5 336.9v14.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M896.5 336.9v14.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M896.5 375.4v10' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M896.5 375.4v10' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M888.5 356.4v3' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M888.5 356.4v3' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M918.5 354.9v6.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M918.5 354.9v6.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M924.5 373.9v6' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M924.5 373.9v6' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M924.5 404.1v4.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M924.5 404.1v4.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M918.5 386.9v2.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M918.5 386.9v2.5' }),
      _react2.default.createElement('path', { fill: '#fff', d: 'M924.5 344.9v-.5 2.5' }),
      _react2.default.createElement('path', { fill: 'none', stroke: '#e1e4e5', strokeLinecap: 'round', strokeLinejoin: 'round', strokeMiterlimit: '10', strokeWidth: '4', d: 'M924.5 344.9v-.5 2.5' })
    ),
    _react2.default.createElement(
      'p',
      { style: { color: 'rgb(136, 136, 136)', padding: '0 35px', textAlign: 'center' } },
      message
    )
  );
};

EmptyState.propTypes = {
  svgSize: array,
  message: string
};

exports.default = EmptyState;

/***/ }),
/* 3472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrayOf = _propTypes2.default.arrayOf,
    object = _propTypes2.default.object,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string;


var styles = {
  container: {
    position: 'relative',
    // overflowY: 'auto',
    '&:before': {
      background: 'rgb(189, 189, 189)',
      content: '""',
      display: 'block',
      height: '90%',
      left: '11px',
      position: 'absolute',
      top: '10px',
      width: '2px',
      zIndex: '0'
    }
  },
  item: {
    cursor: 'pointer',
    display: 'flex',
    left: '2px',
    position: 'relative',
    '&:not(:first-child)': {
      marginTop: '20px'
    }
  },
  marker: {
    display: 'block',
    marginRight: '10px',
    position: 'relative',
    '& svg': {
      display: 'block',
      color: 'rgb(0, 188, 212)',
      fill: 'rgb(0, 188, 212)',
      height: '20px',
      width: '20px',
      userSelect: 'none',
      transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
      fontSize: '24px' }
  },
  content: {
    display: 'block'
  }
};

var Timeline = function Timeline(_ref) {
  var classes = _ref.classes,
      feed = _ref.feed,
      onItemClick = _ref.onItemClick;
  return _react2.default.createElement(
    'div',
    { className: classes.container },
    feed.map(function (d, i) {
      return _react2.default.createElement(
        'div',
        { key: i, className: classes.item, onClick: function onClick() {
            return onItemClick(i);
          } },
        _react2.default.createElement(
          'div',
          { className: classes.marker },
          _react2.default.createElement(
            'svg',
            { viewBox: '0 0 20 20' },
            _react2.default.createElement('circle', { cx: '10', cy: '10', r: '8' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: classes.content },
          _react2.default.createElement(
            'div',
            { style: { color: '#a5a5a5', display: 'block', fontSize: '12px' } },
            (0, _moment2.default)(d.timestamp).clone().fromNow()
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'block', fontSize: '14px' } },
            d.label
          )
        )
      );
    })
  );
};

Timeline.propTypes = {
  classes: object,
  feed: arrayOf(shape({
    label: string.isRequired,
    timestamp: string.isRequired
  })).isRequired
};

exports.default = (0, _reactJss2.default)(styles)(Timeline);

/***/ }),
/* 3473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _funnel = __webpack_require__(3474);

var _funnel2 = _interopRequireDefault(_funnel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrayOf = _propTypes2.default.arrayOf,
    number = _propTypes2.default.number,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string;


var ContractFunnel = function ContractFunnel(_ref) {
  var data = _ref.data;
  return _react2.default.createElement(_funnel2.default, { data: data });
};

ContractFunnel.propTypes = {
  data: arrayOf(shape({
    label: string.isRequired,
    value: number.isRequired
  })).isRequired
};

exports.default = ContractFunnel;

/***/ }),
/* 3474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__(3);

var _contractingUtils = __webpack_require__(124);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _checkCircle = __webpack_require__(1044);

var _checkCircle2 = _interopRequireDefault(_checkCircle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrayOf = _propTypes2.default.arrayOf,
    number = _propTypes2.default.number,
    object = _propTypes2.default.object,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string;


var styles = {};

var getPercentage = function getPercentage(total, compare) {
  return total ? compare / total : 0;
};

var Funnel = function Funnel(_ref) {
  var classes = _ref.classes,
      data = _ref.data;
  return _react2.default.createElement(
    _materialUi.Stepper,
    { orientation: 'vertical' },
    data.map(function (step, i) {
      // Only calculate going forward for > 0 index
      var percentage = Math.round(getPercentage(data[0].value, step.value) * 100);

      return _react2.default.createElement(
        _materialUi.Step,
        { style: { padding: '8px auto', marginTop: 0 }, key: i },
        _react2.default.createElement(
          _materialUi.StepLabel,
          { style: { height: '36px' }, completed: i === data.length - 1, icon: i !== data.length - 1 ? i + 1 : _react2.default.createElement(_checkCircle2.default, { style: { fill: (0, _contractingUtils.getStatusColor)(step.status) } }) },
          _react2.default.createElement(
            'div',
            { style: { color: '#383838', fontSize: '14px', fontWeight: '600', minWidth: '125px', padding: '0 16px' } },
            percentage,
            '% \xA0',
            _react2.default.createElement(
              'small',
              { style: { fontWeight: '400' } },
              Boolean(i) ? '(' + step.value + '/' + data[0].value + ')' : '(' + step.value + ')'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { height: '100%', width: '100%', display: 'flex' } },
            _react2.default.createElement(
              'svg',
              { style: { height: '100%', width: '100%' } },
              _react2.default.createElement('rect', { style: { fill: 'rgb(200, 200, 200)', width: '100%', height: '100%' } }),
              _react2.default.createElement(
                'rect',
                { style: { fill: (0, _contractingUtils.getStatusColor)(step.status), width: percentage + '%', height: '100%' } },
                _react2.default.createElement('animate', { attributeName: 'width', from: '0', to: percentage + '%', dur: '0.5s', fill: 'freeze' })
              ),
              _react2.default.createElement(
                'text',
                { textAnchor: 'start', y: '50%', dy: '.35em' },
                _react2.default.createElement(
                  'tspan',
                  { x: '2%', style: { fontSize: '11px' } },
                  step.leftLbl
                )
              ),
              _react2.default.createElement(
                'text',
                { textAnchor: 'end', y: '50%', dy: '.35em' },
                _react2.default.createElement(
                  'tspan',
                  { x: '95%' },
                  step.label
                )
              )
            )
          )
        )
      );
    })
  );
};

Funnel.propTypes = {
  classes: object,
  data: arrayOf(shape({
    label: string.isRequired,
    value: number.isRequired
  })).isRequired
};

exports.default = (0, _reactJss2.default)(styles)(Funnel);

/***/ }),
/* 3475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bar = __webpack_require__(3476);

var _bar2 = _interopRequireDefault(_bar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var array = _propTypes2.default.array,
    func = _propTypes2.default.func,
    object = _propTypes2.default.object,
    string = _propTypes2.default.string;


var getPercentage = function getPercentage(total, compare) {
  return compare / total;
};

var SentItems = function (_Component) {
  _inherits(SentItems, _Component);

  function SentItems() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SentItems);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SentItems.__proto__ || Object.getPrototypeOf(SentItems)).call.apply(_ref, [this].concat(args))), _this), _this.onItemClick = function (label) {
      var data = _this.props.data;

      var clickedItem = data.filter(function (d) {
        return d.label === label;
      }).reduce(function (a, b) {
        return b.label;
      }, '');
      switch (clickedItem) {
        case 'bounce':
          _this.goToContractList('bounced');
          break;
        case 'delivered':
          _this.goToContractList('delivered');
          break;
        case 'open':
          _this.goToContractList('opened');
          break;
        default:
      }
    }, _this.goToContractList = function (filter) {
      var _query;

      _this.props.push({
        pathname: '/contracting/contract-list/search',
        query: (_query = {
          openAdvanceSearch: true,
          searchCategory: 'all contracts',
          searchingAllYears: false
        }, _defineProperty(_query, _this.props.companyType === 'Contractor' ? 'stateFilterForBuyer' : 'stateFilterForSupplier', ['sent']), _defineProperty(_query, 'sentFilter', [filter]), _query)
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SentItems, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;

      var processed = data.filter(function (d) {
        return d.label === 'processed';
      })[0].value;
      return _react2.default.createElement(
        'div',
        null,
        data.filter(function (d) {
          return d.label !== 'processed';
        }).map(function (d, i) {
          var percent = d.value > 0 ? Math.round(getPercentage(processed, d.value) * 100) : 0;
          return _react2.default.createElement(_bar2.default, { key: i, label: d.label, percent: percent, value: d.value || 0, onItemClick: _this2.onItemClick });
        })
      );
    }
  }]);

  return SentItems;
}(_react.Component);

SentItems.propTypes = {
  data: array,
  push: func,
  style: object,
  companyType: string
};

exports.default = (0, _reactRedux.connect)(function (_ref2) {
  var user = _ref2.user;
  return {
    companyType: user.getIn(['company', 'companyType'])
  };
}, {
  push: _reactRouterRedux.push
})(SentItems);

/***/ }),
/* 3476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var number = _propTypes2.default.number,
    object = _propTypes2.default.object,
    string = _propTypes2.default.string;


var styles = {};

var Bars = function Bars(_ref) {
  var classes = _ref.classes,
      label = _ref.label,
      onItemClick = _ref.onItemClick,
      percent = _ref.percent,
      value = _ref.value;

  var percentage = percent + '%';
  return _react2.default.createElement(
    'div',
    { style: { marginBottom: '20px' } },
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', justifyContent: 'space-between', marginBottom: '2px' } },
      _react2.default.createElement(
        'p',
        { style: { fontSize: '14px', fontWeight: 600, margin: '0', padding: 0, textTransform: 'capitalize' } },
        label + ' rate'
      ),
      _react2.default.createElement(
        'p',
        { style: { borderBottom: '2px dashed', color: 'rgb(255, 64, 129)', cursor: 'pointer', fontSize: '14px', fontWeight: 600, margin: '0 15px 0 0', padding: 0, textTransform: 'capitalize' }, onClick: function onClick() {
            return onItemClick(label);
          } },
        '' + percentage
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { height: '25px', width: '100%', display: 'flex' } },
      _react2.default.createElement(
        'svg',
        { style: { height: '100%', width: '100%' } },
        _react2.default.createElement('rect', { style: { fill: 'rgb(242, 242, 242)', width: '100%' } }),
        _react2.default.createElement(
          'rect',
          { style: { fill: 'rgb(0, 188, 212)', width: '' + percentage } },
          _react2.default.createElement('animate', { attributeName: 'width', from: '0', to: '' + percentage, dur: '0.5s', fill: 'freeze' })
        )
      )
    )
  );
};

Bars.propTypes = {
  label: string,
  percent: number,
  total: number,
  style: object
};

exports.default = (0, _reactJss2.default)(styles)(Bars);

/***/ }),
/* 3477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _contractingUtils = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var array = _propTypes2.default.array,
    bool = _propTypes2.default.bool,
    node = _propTypes2.default.node,
    object = _propTypes2.default.object;


var Stats = function Stats(_ref) {
  var classes = _ref.classes,
      data = _ref.data;

  return _react2.default.createElement(
    'div',
    { style: { display: 'flex', flexWrap: 'wrap' } },
    data.sort(function (a, b) {
      return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
    }).map(function (d, i) {
      return _react2.default.createElement(
        'div',
        { key: i, style: { flex: '1 0 50%', padding: '8px', textAlign: 'center' } },
        _react2.default.createElement(
          'span',
          {
            style: {
              display: 'block',
              fontSize: '28px',
              lineHeight: '40px',
              color: (0, _contractingUtils.getStatusColor)(d.label)
            }
          },
          d.value
        ),
        _react2.default.createElement(
          'span',
          {
            style: {
              display: 'block',
              fontSize: '14px',
              textTransform: 'capitalize',
              color: (0, _contractingUtils.getStatusColor)(d.label)
            }
          },
          d.label
        )
      );
    })
  );
};

Stats.propTypes = {
  data: array,
  style: object
};

exports.default = Stats;

/***/ }),
/* 3478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(27);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _smallButtons = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var string = _propTypes2.default.string,
    func = _propTypes2.default.func,
    object = _propTypes2.default.object;

var ContractTaskList = function (_Component) {
  _inherits(ContractTaskList, _Component);

  function ContractTaskList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContractTaskList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContractTaskList.__proto__ || Object.getPrototypeOf(ContractTaskList)).call.apply(_ref, [this].concat(args))), _this), _this.goToContractList = function (additionalQuery, label) {
      return function () {
        _this.track(label);
        var query = _extends({
          searchCategory: 'all contracts',
          searchingAllYears: false
        }, additionalQuery);

        _this.props.push({
          pathname: '/contracting/contract-list/search',
          query: query
        });
      };
    }, _this.track = function (label) {
      window.dataLayer.push({
        event: 'TRACK_EVENT',
        ev: {
          category: 'Click Contract Task List',
          action: label
        }
      });
    }, _this.goToTemplateList = function (additionalQuery, label) {
      return function () {
        _this.track(label);
        var query = _extends({
          searchingAllYears: false
        }, additionalQuery);

        _this.props.push({
          pathname: '/contracting/template-list',
          query: query
        });
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContractTaskList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$data = _props.data,
          tcFormatNewPending = _props$data.tcFormatNewPending,
          tcFormatUpdatesPending = _props$data.tcFormatUpdatesPending,
          externalWFilesPending = _props$data.externalWFilesPending,
          externalTotalPending = _props$data.externalTotalPending,
          tcFormatLoading = _props$data.tcFormatLoading,
          tcFormatTotalToBeLoaded = _props$data.tcFormatTotalToBeLoaded,
          externalFormatLoading = _props$data.externalFormatLoading,
          externalFormatTotalToBeLoaded = _props$data.externalFormatTotalToBeLoaded,
          requests = _props$data.requests,
          unfinishedDrafts = _props$data.unfinishedDrafts,
          notSentTemplates = _props$data.notSentTemplates,
          companyType = _props.companyType;

      var processedData = function () {
        if (companyType === 'Supplier') {
          return [{
            giantLabel: 'Rate Requests',
            width: '35%',
            color: '#31b5f7bd',
            onClick: function onClick() {
              _this2.track('Rate Requests');
              _this2.props.push('/contracting/contract-list/recent');
            },
            secondary: [{
              label: 'Outstanding Rate Requests',
              value: requests,
              width: '100%',
              onClick: function onClick() {
                _this2.track('Outstanding Rate Requests');
                _this2.props.push('/contracting/contract-list/recent');
              }
            }]
          }, {
            giantLabel: 'Templates to be Actioned',
            width: '65%',
            onClick: _this2.goToTemplateList({
              statusesFilter: ['not sent', 'draft', 'new draft']
            }, 'Templates to be Actioned'),
            color: '#43a669ad',
            secondary: [{
              label: 'Unfinished Drafts',
              value: unfinishedDrafts,
              width: '48%',
              onClick: _this2.goToTemplateList({
                statusesFilter: ['draft', 'new draft']
              }, 'Templates to be Actioned')
            }, {
              label: 'Templates Not Sent',
              value: notSentTemplates,
              width: '48%',
              onClick: _this2.goToTemplateList({
                statusesFilter: ['not sent']
              }, 'Templates to be Actioned')
            }]
          }];
        }
        return [{
          giantLabel: 'Waiting to be Accepted',
          width: '50%',
          onClick: _this2.goToContractList({
            stateFilterForBuyer: ['received']
          }, 'Waiting to be Accepted'),
          color: '#31b5f7bd',
          secondary: [{
            label: 'TourConnect Format',
            value: tcFormatNewPending + tcFormatUpdatesPending,
            onClick: _this2.goToContractList({
              stateFilterForBuyer: ['received'],
              contractTypeFilter: ['tc-new', 'tc-updates']
            }, 'TourConnect Format'),
            width: '48%',
            third: [{
              label: tcFormatNewPending + ' New',
              onClick: _this2.goToContractList({
                stateFilterForBuyer: ['received'],
                contractTypeFilter: ['tc-new']
              }, tcFormatNewPending + ' New')
            }, {
              label: tcFormatUpdatesPending + ' Updates',
              onClick: _this2.goToContractList({
                stateFilterForBuyer: ['received'],
                contractTypeFilter: ['tc-updates']
              }, tcFormatUpdatesPending + ' Updates')
            }]
          }, {
            label: 'External Format',
            value: externalTotalPending,
            onClick: _this2.goToContractList({
              stateFilterForBuyer: ['received'],
              contractTypeFilter: ['external-files', 'external-nofiles']
            }, 'External Format'),
            width: '48%',
            third: [{
              label: externalWFilesPending + ' with Files',
              onClick: _this2.goToContractList({
                stateFilterForBuyer: ['received'],
                contractTypeFilter: ['external-files']
              }, externalWFilesPending + ' with Files')
            }]
          }]
        }, {
          giantLabel: 'Waiting to be Loaded',
          width: '50%',
          onClick: _this2.goToContractList({
            stateFilterForBuyer: ['loading', 'accepted']
          }, 'Waiting to be Loaded'),
          color: '#43a669ad',
          secondary: [{
            label: 'TourConnect Format',
            value: tcFormatTotalToBeLoaded,
            onClick: _this2.goToContractList({
              stateFilterForBuyer: ['loading', 'accepted'],
              contractTypeFilter: ['tc-new', 'tc-updates']
            }, 'TourConnect Format'),
            width: '48%',
            third: [{
              label: tcFormatLoading + ' Loading',
              onClick: _this2.goToContractList({
                stateFilterForBuyer: ['loading'],
                contractTypeFilter: ['tc-new', 'tc-updates']
              }, tcFormatLoading + ' Loading')
            }]
          }, {
            label: 'External Format',
            value: externalFormatTotalToBeLoaded,
            onClick: _this2.goToContractList({
              stateFilterForBuyer: ['loading', 'accepted'],
              contractTypeFilter: ['external-files', 'external-nofiles']
            }, 'External Format'),
            width: '48%',
            third: [{
              label: externalFormatLoading + ' Loading',
              onClick: _this2.goToContractList({
                stateFilterForBuyer: ['loading'],
                contractTypeFilter: ['external-files', 'external-nofiles']
              }, externalFormatLoading + ' Loading')
            }]
          }]
        }];
      }();
      var flexStyle = { display: 'flex', alignItem: 'flex-start', justifyContent: 'space-between' };
      return _react2.default.createElement(
        'div',
        { style: flexStyle },
        processedData.map(function (_ref2, i) {
          var giantLabel = _ref2.giantLabel,
              color = _ref2.color,
              secondary = _ref2.secondary,
              query = _ref2.query,
              onClick = _ref2.onClick,
              width = _ref2.width;
          return _react2.default.createElement(
            'div',
            { key: i, style: { borderRight: !i ? '1px solid #efefef' : '', width: width, textAlign: 'center', padding: '0 16px' } },
            _react2.default.createElement(_materialUi.RaisedButton, {
              label: giantLabel,
              labelStyle: { textTransform: 'none', fontSize: '20px', color: 'white', lineHeight: '48px' },
              onClick: onClick,
              style: { height: '48px' },
              backgroundColor: color
            }),
            _react2.default.createElement(
              'div',
              { style: flexStyle },
              secondary.map(function (_ref3, si) {
                var label = _ref3.label,
                    value = _ref3.value,
                    third = _ref3.third,
                    secondClick = _ref3.onClick,
                    secondWidth = _ref3.width;
                return _react2.default.createElement(
                  'div',
                  { key: si, style: { width: secondWidth } },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'a',
                      {
                        style: { display: 'block', fontSize: '1.5vw', lineHeight: '54px', textDecoration: 'underline', cursor: 'pointer' },
                        onClick: secondClick
                      },
                      value
                    ),
                    _react2.default.createElement(
                      'span',
                      { style: { display: 'block', fontSize: '14px' } },
                      label
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: { width: '100%', margin: '8px auto', justifyContent: 'center', flexWrap: 'wrap' }, className: 'flex-tc-sb' },
                    Boolean(third) && third.map(function (_ref4, ti) {
                      var smallLabel = _ref4.label,
                          thirdClick = _ref4.onClick;
                      return _react2.default.createElement(_smallButtons.JiraFlatButton, {
                        key: ti,
                        label: smallLabel,
                        style: { marginLeft: ti ? '4px' : 0 },
                        labelStyle: { padding: '2px 4px' },
                        onTouchTap: thirdClick
                      });
                    })
                  )
                );
              })
            )
          );
        })
      );
    }
  }]);

  return ContractTaskList;
}(_react.Component);

ContractTaskList.propTypes = {
  data: object,
  dispatch: func,
  style: object,
  companyId: string
};

exports.default = (0, _reactRedux.connect)(function (_ref5) {
  var user = _ref5.user;
  return {
    companyId: user.getIn(['company', 'companyId']),
    companyType: user.getIn(['company', 'companyType'])
  };
}, {
  push: _reactRouterRedux.push
})(ContractTaskList);

/***/ }),
/* 3479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(67);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var array = _propTypes2.default.array,
    bool = _propTypes2.default.bool,
    node = _propTypes2.default.node,
    object = _propTypes2.default.object;


var PotentialPartners = function PotentialPartners(_ref) {
  var classes = _ref.classes,
      data = _ref.data;

  var countries = data.countries.length === 1 ? data.countries[0] : _ramda2.default.dropLast(1, data.countries).join(', ') + ' and ' + _ramda2.default.last(data.countries);
  return _react2.default.createElement(
    'div',
    { style: { padding: '8px' } },
    _react2.default.createElement(
      'div',
      { style: { textAlign: 'center' } },
      'You have sent rates to'
    ),
    _react2.default.createElement(
      'div',
      { style: { textAlign: 'center', margin: '8px 0' } },
      _react2.default.createElement(
        'span',
        { style: { fontSize: '18px' } },
        data.sentCount || 0
      ),
      '\xA0 out of \xA0',
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/partner-finder/results', style: { fontSize: '18px' } },
        data.totalCount || 0
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { textAlign: 'center' } },
      'Buyers that send travelers to ',
      countries,
      '.'
    )
  );
};

PotentialPartners.propTypes = {
  data: object,
  style: object
};

exports.default = PotentialPartners;

/***/ }),
/* 3480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateWidgetFilter = exports.updateFilter = exports.loadContractFolders = exports.resetGlobalFilters = exports.clearListFilter = exports.updateGlobalListFilter = exports.loadDashboard = exports.initDashboard = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _supplierInitialState = __webpack_require__(3481);

var _supplierInitialState2 = _interopRequireDefault(_supplierInitialState);

var _contractorInitialState = __webpack_require__(3482);

var _contractorInitialState2 = _interopRequireDefault(_contractorInitialState);

var _constants = __webpack_require__(652);

var cnt = _interopRequireWildcard(_constants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initDashboard = exports.initDashboard = function initDashboard(companyType) {
  return function (dispatch, getState) {
    if (companyType === 'Supplier') {
      var _getState$user$toJS = getState().user.toJS(),
          locationsList = _getState$user$toJS.locAccess,
          productType = _getState$user$toJS.company.productType;

      return dispatch({
        type: cnt.INIT_DASHBOARD,
        payload: {
          initialState: _extends({}, _supplierInitialState2.default, {
            globalFilters: _extends({}, _supplierInitialState2.default.globalFilters, {
              locations: _extends({}, _supplierInitialState2.default.globalFilters.locations, {
                list: locationsList.filter(function (obj) {
                  return obj.contracting.indexOf('read') > -1;
                }).map(function (obj) {
                  return _ramda2.default.assoc('title', obj.property_name, obj);
                }),
                title: productType === 'Accommodation' ? 'Properties' : 'Locations'
              })
            })
          })
        }
      });
    }
    return dispatch({
      type: cnt.INIT_DASHBOARD,
      payload: {
        initialState: _contractorInitialState2.default
      }
    });
  };
};

var loadDashboard = exports.loadDashboard = function loadDashboard() {
  return {
    type: cnt.LOAD_DASHBOARD
  };
};

var updateGlobalListFilter = exports.updateGlobalListFilter = function updateGlobalListFilter(payload) {
  return {
    type: cnt.UPDATE_GLOBAL_LIST_FILTER,
    payload: payload
  };
};

var clearListFilter = exports.clearListFilter = function clearListFilter(payload) {
  return {
    type: cnt.CLEAR_GLOBAL_LIST_FILTER,
    payload: payload
  };
};

var resetGlobalFilters = exports.resetGlobalFilters = function resetGlobalFilters() {
  return {
    type: cnt.RESET_GLOBAL_DASHBOARD_FILTER
  };
};

var loadContractFolders = exports.loadContractFolders = function loadContractFolders() {
  return {
    type: cnt.LOAD_FOLDERS
  };
};

var updateFilter = exports.updateFilter = function updateFilter(filterItem, value) {
  return {
    type: cnt.UPDATE_GLOBAL_FILTER, payload: { filterItem: filterItem, value: value }
  };
};

var updateWidgetFilter = exports.updateWidgetFilter = function updateWidgetFilter(id, filterBy, filterObjSelected) {
  return {
    type: cnt.UPDATE_WIDGET_FILTER, payload: { id: id, filterBy: filterBy, filterObjSelected: filterObjSelected }
  };
};

/***/ }),
/* 3481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  initialized: true,
  globalFilters: {
    // contractingPeriod: {
    //   key: 'contractingPeriod',
    //   // title: 'Contracting Period',
    //   // type: 'list',
    //   // value: [{ startDate: '2019-04-01T00:00:00.000Z', endDate: '2020-03-31T00:00:00.000Z' }],
    //   title: 'Contract Period contains:',
    //   type: 'contractingPeriod',
    //   selectedValue: '',
    // },
    dateRange: {
      key: 'dateRange',
      isCustomRange: false,
      selectedValue: '',
      type: 'date',
      dateChoices: [{ title: 'This Week', timeValue: 'week', timeVar: 0 }, { title: 'Last Week', timeValue: 'week', timeVar: -1 }, { title: 'This Month', timeValue: 'month', timeVar: 0 }, { title: 'Last Month', timeValue: 'month', timeVar: -1 }, { title: 'This Quarter', timeValue: 'quarter', timeVar: 0 }, { title: 'Last Quarter', timeValue: 'quarter', timeVar: -1 }]
    },
    folder: {
      key: 'folder',
      title: 'Folder',
      type: 'list',
      list: []
    },
    locations: {
      key: 'locations',
      title: 'Locations',
      type: 'list',
      list: []
    }
  },
  items: [{
    id: 1,
    chart: 'ContractFunnel',
    error: false,
    isLoading: true,
    lastSync: null,
    name: 'Contracting Progress Funnel',
    size: [3, 3],
    url: '/analytics/contracts',
    x: 1,
    y: 1
  }, {
    id: 2,
    chart: 'ContractTaskList',
    data: {},
    error: false,
    isLoading: true,
    lastSync: null,
    name: 'Contracting Task List',
    size: [3, 2],
    url: '/analytics/contracts/tasks',
    x: 2,
    y: 1
  }, {
    id: 3,
    chart: 'SentItems',
    error: false,
    isLoading: true,
    lastSync: null,
    name: 'Tracking for Sent Rates',
    size: [3, 2.5],
    url: '/analytics/sentItems',
    x: 4,
    y: 1
  }, {
    id: 4,
    chart: 'ContractActivityStats',
    error: false,
    isLoading: true,
    lastSync: null,
    name: 'Productivity',
    size: [2, 2],
    url: '/analytics/contracts/activity',
    x: 1,
    y: 2
  }, {
    id: 5,
    chart: 'PotentialPartners',
    error: false,
    isLoading: true,
    lastSync: null,
    name: 'Sales Opportunities',
    size: [2, 1.5],
    url: '/analytics/contracts/potentialPartners',
    x: 1,
    y: 2
  }, {
    id: 6,
    chart: 'ContractActivityFeed', // combined ContractActivityStats with the feed
    error: false,
    filters: {}, // { userId: { filterBy: 'userId', filterItems: [], filterValue: '' }, days: { filterBy: 'days', filterItems: [], filterValue: '' } }
    isLoading: true,
    lastSync: null,
    name: 'Your Partners\' Activities',
    size: [2, 4],
    url: '/analytics/contracts/feed',
    x: 3,
    y: 2
  }]
};

/***/ }),
/* 3482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  initialized: true,
  globalFilters: {
    // contractingPeriod: {
    //   key: 'contractingPeriod',
    //   // title: 'Contracting Period',
    //   // type: 'list',
    //   // value: [{ startDate: '2019-04-01T00:00:00.000Z', endDate: '2020-03-31T00:00:00.000Z' }],
    //   title: 'Contract Period contains:',
    //   type: 'contractingPeriod',
    //   selectedValue: '',
    // },
    dateRange: {
      key: 'dateRange',
      isCustomRange: false,
      selectedValue: '',
      type: 'date',
      dateChoices: [{ title: 'This Week', timeValue: 'week', timeVar: 0 }, { title: 'Last Week', timeValue: 'week', timeVar: -1 }, { title: 'This Month', timeValue: 'month', timeVar: 0 }, { title: 'Last Month', timeValue: 'month', timeVar: -1 }, { title: 'This Quarter', timeValue: 'quarter', timeVar: 0 }, { title: 'Last Quarter', timeValue: 'quarter', timeVar: -1 }]
    },
    folder: {
      key: 'folder',
      title: 'Folder',
      type: 'list',
      list: [],
      selectedValue: null
    },
    isTcContract: {
      key: 'isTcContract',
      title: 'Only TourConnect Format',
      type: 'checkbox',
      value: false,
      selectedValue: false
    }
  },
  items: [{
    id: 1,
    chart: 'ContractFunnel',
    error: false,
    isLoading: true,
    lastSync: null,
    name: 'Contracting Progress Funnel',
    size: [3, 3],
    url: '/analytics/contracts',
    x: 2,
    y: 1
  }, {
    id: 2,
    chart: 'ContractActivityStats',
    error: false,
    isLoading: true,
    lastSync: null,
    name: '',
    size: [3, 1],
    url: '/analytics/contracts/trashArchived',
    x: 3,
    y: 1
  }, {
    id: 3,
    chart: 'ContractTaskList',
    data: {},
    error: false,
    isLoading: true,
    lastSync: null,
    name: 'Contract Task List',
    size: [3, 2.5],
    url: '/analytics/contracts/tasks',
    x: 4,
    y: 1
  }, {
    id: 4,
    chart: 'ContractFunnel',
    data: {},
    error: false,
    isLoading: true,
    lastSync: null,
    name: 'Contracting Updates Funnel',
    size: [3, 2.5],
    url: '/analytics/updates',
    x: 5,
    y: 1
  }, {
    id: 5,
    chart: 'SentItems',
    error: false,
    isLoading: true,
    lastSync: null,
    name: 'Tracking for Contract Requests',
    size: [3, 2.5],
    url: '/analytics/sentItems',
    x: 6,
    y: 1
  }, {
    id: 6,
    chart: 'ContractActivityFeed', // combined ContractActivityStats with the feed
    error: false,
    filters: {}, // { userId: { filterBy: 'userId', filterItems: [], filterValue: '' }, days: { filterBy: 'days', filterItems: [], filterValue: '' } }
    isLoading: true,
    lastSync: null,
    name: 'Recent Activity',
    size: [2, 10.5],
    url: '/analytics/contracts/feed',
    x: 1,
    y: 2
  }]
};

/***/ }),
/* 3483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _reportList = __webpack_require__(3484);

var _reportList2 = _interopRequireDefault(_reportList);

var _rightSide = __webpack_require__(3485);

var _rightSide2 = _interopRequireDefault(_rightSide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractingReports = function (_Component) {
  _inherits(ContractingReports, _Component);

  function ContractingReports() {
    _classCallCheck(this, ContractingReports);

    return _possibleConstructorReturn(this, (ContractingReports.__proto__ || Object.getPrototypeOf(ContractingReports)).apply(this, arguments));
  }

  _createClass(ContractingReports, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'Grid' },
        _react2.default.createElement(
          _materialUi.Paper,
          { className: 'Grid-cell Grid--full' },
          _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb' },
            _react2.default.createElement(
              'div',
              { style: {
                  width: '20%',
                  fontSize: '16px',
                  backgroundColor: '#383E4B',
                  color: 'white',
                  paddingBottom: '24px'
                }
              },
              _react2.default.createElement(_reportList2.default, null)
            ),
            _react2.default.createElement(
              'div',
              {
                style: {
                  width: '80%',
                  textAlign: 'center'
                }
              },
              _react2.default.createElement(_rightSide2.default, null)
            )
          )
        )
      );
    }
  }]);

  return ContractingReports;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var currentYear = _ref.contracting.currentYear;
  return {
    startDate: currentYear.startDate,
    endDate: currentYear.endDate
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ContractingReports);

/***/ }),
/* 3484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _actions = __webpack_require__(1005);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportList = function ReportList(props) {
  var updateProps = props.updateProps,
      contractingReports = props.contractingReports,
      plan = props.plan;


  var reports = [{
    reportName: 'Progress Report',
    key: 'progress'
  }, {
    reportName: 'Allocation Report',
    key: 'allotment'
  }, {
    reportName: 'Blackout Dates',
    key: 'blackout'
  }];

  return _react2.default.createElement(
    'div',
    { style: { display: 'block' } },
    reports.map(function (report, i) {
      var isActive = contractingReports.selectedReport === report.key;
      var className = isActive ? 'report is-active' : 'report';
      return _react2.default.createElement(
        'div',
        {
          key: i,
          className: className,
          style: { padding: '3% 0', marginTop: '5px' },
          onClick: function onClick() {
            return updateProps({ selectedReport: report.key, showSuggestionConfirmation: false });
          }
        },
        _react2.default.createElement(
          'span',
          {
            style: { color: isActive ? 'rgb(0, 188, 212)' : '#ffffff', fontSize: '14px', marginLeft: '40px' }
          },
          report.reportName
        )
      );
    }),
    _react2.default.createElement(
      'div',
      { style: { marginTop: '60%', cursor: 'pointer' } },
      _react2.default.createElement(
        'div',
        {
          className: contractingReports.selectedReport === 'suggestion' ? 'report is-active' : 'report',
          style: { padding: '3% 0', marginTop: '5px' },
          onClick: function onClick() {
            return updateProps({ selectedReport: 'suggestion' });
          }
        },
        _react2.default.createElement(
          'span',
          { style: { color: contractingReports.selectedReport === 'suggestion' ? '#bdbdbd' : '#ffffff', fontSize: '14px' } },
          _react2.default.createElement(
            'span',
            { style: { marginLeft: '40px', fontSize: '14px' } },
            'Suggest A Report'
          )
        )
      )
    )
  );
};

ReportList.propTypes = {
  updateProps: _react.PropTypes.func,
  contractingReports: _react.PropTypes.object,
  plan: _react.PropTypes.string
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProps: function updateProps() {
      return dispatch(_actions.updateCReportProps.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contractingReports = _ref.contractingReports,
      user = _ref.user;
  return {
    contractingReports: contractingReports.toJS(),
    plan: user.get('billingPlan')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReportList);

/***/ }),
/* 3485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _lock = __webpack_require__(578);

var _lock2 = _interopRequireDefault(_lock);

var _actions = __webpack_require__(1005);

var _progressReport = __webpack_require__(3486);

var _progressReport2 = _interopRequireDefault(_progressReport);

var _upgradeActions = __webpack_require__(611);

var _allotment = __webpack_require__(3487);

var _allotment2 = _interopRequireDefault(_allotment);

var _blackout = __webpack_require__(3490);

var _blackout2 = _interopRequireDefault(_blackout);

var _suggestion = __webpack_require__(3493);

var _suggestion2 = _interopRequireDefault(_suggestion);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);
var propTypes = {
  updateProps: _react.PropTypes.func,
  contractingReports: _react.PropTypes.object,
  plan: _react.PropTypes.string,
  companyType: _react.PropTypes.string,
  currentYear: _react.PropTypes.object,
  openUpgradeFrom: _react.PropTypes.func,
  userId: _react.PropTypes.string
};

var ReportList = function (_Component) {
  _inherits(ReportList, _Component);

  function ReportList() {
    _classCallCheck(this, ReportList);

    return _possibleConstructorReturn(this, (ReportList.__proto__ || Object.getPrototypeOf(ReportList)).apply(this, arguments));
  }

  _createClass(ReportList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          companyType = _props.companyType,
          contractingReports = _props.contractingReports,
          currentYear = _props.currentYear,
          openUpgradeFrom = _props.openUpgradeFrom,
          plan = _props.plan,
          updateProps = _props.updateProps,
          userId = _props.userId;

      var downloadFile = function downloadFile(reportType, startDate, endDate) {
        window.open(window.location.protocol + '//' + window.location.host + '/proxy/contracting/' + reportType + '?startDate=' + startDate + '&endDate=' + endDate);
        updateProps({ generatingReport: false });
      };

      var generateRightSide = function generateRightSide(label) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { clear: 'both', padding: '0 8px' } },
            _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('ALLOTMENT REPORT'), _ramda2.default.always(_react2.default.createElement(_allotment2.default, null))], [_ramda2.default.equals('BLACKOUT DATES REPORT'), _ramda2.default.always(_react2.default.createElement(_blackout2.default, { companyType: companyType }))], [_ramda2.default.equals('PROGRESS REPORT'), _ramda2.default.always(_react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_progressReport2.default, null)
            ))]]), label),
            _react2.default.createElement(
              _wrapper2.default,
              { blocker: true, slug: 'upgrade-rates-reports', lockIcon: true, amazonOrange: true },
              _react2.default.createElement(_materialUi.RaisedButton, {
                label: contractingReports.generatingReport ? 'report is being generated.' : 'download ' + label,
                onTouchTap: function onTouchTap() {
                  updateProps({ generatingReport: true });
                  if (contractingReports.selectedReport === 'allotment' && contractingReports.alloReport === 'detailed') {
                    return downloadFile('detailedAllotmentReport', currentYear.startDate, currentYear.endDate);
                  }
                  if (contractingReports.selectedReport === 'allotment' && contractingReports.alloReport === 'summary') {
                    return downloadFile('summaryAllotmentReport', currentYear.startDate, currentYear.endDate);
                  }
                  if (contractingReports.selectedReport === 'blackout' && contractingReports.blackoutReport === 'newContracts') {
                    return downloadFile('blackoutNCReport', currentYear.startDate, currentYear.endDate);
                  }
                  if (contractingReports.selectedReport === 'blackout' && contractingReports.blackoutReport === 'templates') {
                    return downloadFile('blackoutTemplatesReport', currentYear.startDate, currentYear.endDate);
                  }
                  return downloadFile('progressReport', currentYear.startDate, currentYear.endDate);
                },
                secondary: true,
                style: { marginTop: '32px' },
                disabled: isNilOrEmpty(contractingReports.startDate) || contractingReports.generatingReport
              })
            )
          )
        );
      };

      return _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('progress'), _ramda2.default.always(generateRightSide('PROGRESS REPORT'))], [_ramda2.default.equals('allotment'), _ramda2.default.always(generateRightSide('ALLOTMENT REPORT'))], [_ramda2.default.equals('blackout'), _ramda2.default.always(generateRightSide('BLACKOUT DATES REPORT'))], [_ramda2.default.equals('suggestion'), _ramda2.default.always(_react2.default.createElement(_suggestion2.default, null))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement('span', null))]]), contractingReports.selectedReport);
    }
  }]);

  return ReportList;
}(_react.Component);

ReportList.propTypes = propTypes;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProps: function updateProps() {
      return dispatch(_actions.updateCReportProps.apply(undefined, arguments));
    },
    openUpgradeFrom: function openUpgradeFrom() {
      return dispatch((0, _upgradeActions.openUpgradeFrom)('downloadContractingReportBtn'));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contractingReports = _ref.contractingReports,
      user = _ref.user,
      contracting = _ref.contracting;
  return {
    contractingReports: contractingReports.toJS(),
    currentYear: contracting.currentYear,
    plan: user.get('billingPlan'),
    companyType: user.getIn(['user', 'type'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReportList);

/***/ }),
/* 3486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var border = '1px solid #e0e0e0';
  return _react2.default.createElement(
    _materialUi.Table,
    { style: { border: '1px solid #e0e0e0' } },
    _react2.default.createElement(
      _materialUi.TableHeader,
      { displaySelectAll: false, adjustForCheckbox: false },
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '32px' } },
        _react2.default.createElement(_materialUi.TableHeaderColumn, { style: { height: '32px' } }),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Partner Name or Email'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '2' },
          'Location Name'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '2' },
          'Status'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '2' },
          'Last Updated'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '1' },
          'Folder'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '3' },
          'Supplier First Name'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '3' },
          'Supplier Last Name'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '2' },
          'Supplier Email'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '2' },
          'Corporate Phone'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.TableBody,
      { selectable: false, displayRowCheckbox: false },
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '24px' } },
        _react2.default.createElement(
          _materialUi.TableRowColumn,
          { style: { height: '24px', textAlign: 'center', padding: 0 } },
          '1'
        ),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '2' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '2' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '2' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '1' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '3' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '3' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '2' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '2' })
      ),
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '24px' } },
        _react2.default.createElement(
          _materialUi.TableRowColumn,
          { style: { height: '24px', textAlign: 'center', padding: 0 } },
          '2'
        ),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '2' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '2' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '2' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '1' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '3' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '3' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '2' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '2' })
      )
    )
  );
};

/***/ }),
/* 3487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _actions = __webpack_require__(1005);

var _detailedAllotment = __webpack_require__(3488);

var _detailedAllotment2 = _interopRequireDefault(_detailedAllotment);

var _summaryAllotment = __webpack_require__(3489);

var _summaryAllotment2 = _interopRequireDefault(_summaryAllotment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Allotments = function Allotments(props) {
  var updateProps = props.updateProps,
      contractingReports = props.contractingReports;


  var allotmentReportOptions = [{
    reportName: 'Allocation Report',
    key: 'detailed'
  }, {
    reportName: 'Allotment Summary Report',
    key: 'summary'
  }];

  return _react2.default.createElement(
    'div',
    { style: { paddingTop: '16px' } },
    _react2.default.createElement(
      'div',
      { className: 'flex-tc-sb', style: { width: '60%', marginBottom: '16px' } },
      _react2.default.createElement(
        'label',
        null,
        'Select An Allocation Report Type:'
      ),
      _react2.default.createElement(
        _materialUi.SelectField,
        {
          value: contractingReports.alloReport,
          labelStyle: { fontSize: '14px' },
          style: { marginLeft: '16px' }
        },
        allotmentReportOptions.map(function (report, i) {
          return _react2.default.createElement(_materialUi.MenuItem, {
            key: i,
            value: report.key,
            primaryText: report.reportName,
            onTouchTap: function onTouchTap() {
              return updateProps({ alloReport: report.key });
            }
          });
        })
      )
    ),
    contractingReports.alloReport === 'detailed' ? _react2.default.createElement(_detailedAllotment2.default, null) : _react2.default.createElement(_summaryAllotment2.default, null)
  );
};

Allotments.propTypes = {
  updateProps: _react.PropTypes.func.isRequired,
  contractingReports: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProps: function updateProps() {
      return dispatch(_actions.updateCReportProps.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contractingReports = _ref.contractingReports;
  return {
    contractingReports: contractingReports.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Allotments);

/***/ }),
/* 3488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var border = '1px solid #e0e0e0';
  var tableBodyRowStyle = {
    borderLeft: border,
    fontSize: '8px',
    height: '24px',
    padding: 0,
    textAlign: 'center'
  };
  var tableHeaderRowStyle = {
    borderLeft: border,
    color: 'black',
    fontSize: '8px',
    fontWeight: 'bold',
    height: '32px',
    padding: 0,
    textAlign: 'center'
  };
  return _react2.default.createElement(
    _materialUi.Table,
    { style: { border: border } },
    _react2.default.createElement(
      _materialUi.TableHeader,
      { displaySelectAll: false, adjustForCheckbox: false },
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '32px' } },
        _react2.default.createElement(_materialUi.TableHeaderColumn, { style: { height: '32px' }, colSpan: '1' }),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: tableHeaderRowStyle, colSpan: '4' },
          'Partner Name or Email'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: tableHeaderRowStyle, colSpan: '4' },
          'Location Name'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: tableHeaderRowStyle, colSpan: '4' },
          'Product or Room Type'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: tableHeaderRowStyle, colSpan: '4' },
          'Allocation Start'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: tableHeaderRowStyle, colSpan: '4' },
          'Allocation End'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: tableHeaderRowStyle, colSpan: '4' },
          'Allocation Type'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: tableHeaderRowStyle, colSpan: '4' },
          '# of Rooms'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: tableHeaderRowStyle, colSpan: '4' },
          'Release Back'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.TableBody,
      { selectable: false, displayRowCheckbox: false },
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '24px' } },
        _react2.default.createElement(
          _materialUi.TableRowColumn,
          { style: { height: '24px', textAlign: 'center', padding: 0 }, colSpan: '1' },
          '1'
        ),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' })
      ),
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '24px' } },
        _react2.default.createElement(
          _materialUi.TableRowColumn,
          { style: { height: '24px', textAlign: 'center', padding: 0 } },
          '2'
        ),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: tableBodyRowStyle, colSpan: '4' })
      )
    )
  );
};

/***/ }),
/* 3489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var border = '1px solid #e0e0e0';
  return _react2.default.createElement(
    _materialUi.Table,
    { style: { border: '1px solid #e0e0e0' } },
    _react2.default.createElement(
      _materialUi.TableHeader,
      { displaySelectAll: false, adjustForCheckbox: false },
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '32px' } },
        _react2.default.createElement(_materialUi.TableHeaderColumn, { style: { height: '32px' }, colSpan: '1' }),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Location Name'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Room Type'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Allotment Start'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Allotment End'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '6' },
          'Total # of Rooms on Allotment'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.TableBody,
      { selectable: false, displayRowCheckbox: false },
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '24px' } },
        _react2.default.createElement(
          _materialUi.TableRowColumn,
          { style: { height: '24px', textAlign: 'center', padding: 0 }, colSpan: '1' },
          '1'
        ),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '6' })
      ),
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '24px' } },
        _react2.default.createElement(
          _materialUi.TableRowColumn,
          { style: { height: '24px', textAlign: 'center', padding: 0 } },
          '2'
        ),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '6' })
      )
    )
  );
};

/***/ }),
/* 3490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _actions = __webpack_require__(1005);

var _contractsBlackoutsReport = __webpack_require__(3491);

var _contractsBlackoutsReport2 = _interopRequireDefault(_contractsBlackoutsReport);

var _templatesBlackoutsReport = __webpack_require__(3492);

var _templatesBlackoutsReport2 = _interopRequireDefault(_templatesBlackoutsReport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Blackout = function Blackout(props) {
  var updateProps = props.updateProps,
      contractingReports = props.contractingReports,
      companyType = props.companyType;


  var blackoutReportTypes = [{
    reportName: 'Templates',
    key: 'templates'
  }, {
    reportName: 'Contracts',
    key: 'newContracts'
  }];

  return _react2.default.createElement(
    'div',
    { style: { paddingTop: '16px' } },
    companyType === 'Supplier' && _react2.default.createElement(
      'div',
      { className: 'flex-tc-sb', style: { width: '60%', marginBottom: '16px' } },
      _react2.default.createElement(
        'label',
        null,
        'Select A Blackout Dates Report Type:'
      ),
      _react2.default.createElement(
        _materialUi.SelectField,
        {
          value: contractingReports.blackoutReport,
          labelStyle: { fontSize: '14px' },
          style: { marginLeft: '16px' }
        },
        blackoutReportTypes.map(function (report, i) {
          return _react2.default.createElement(_materialUi.MenuItem, {
            key: i,
            value: report.key,
            primaryText: report.reportName,
            onTouchTap: function onTouchTap() {
              return updateProps({ blackoutReport: report.key });
            }
          });
        })
      )
    ),
    companyType === 'Supplier' && contractingReports.blackoutReport === 'templates' ? _react2.default.createElement(_templatesBlackoutsReport2.default, null) : _react2.default.createElement(_contractsBlackoutsReport2.default, null)
  );
};

Blackout.propTypes = {
  updateProps: _react.PropTypes.func,
  contractingReports: _react.PropTypes.object,
  companyType: _react.PropTypes.string
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProps: function updateProps() {
      return dispatch(_actions.updateCReportProps.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var contractingReports = _ref.contractingReports;
  return {
    contractingReports: contractingReports.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Blackout);

/***/ }),
/* 3491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var border = '1px solid #e0e0e0';
  return _react2.default.createElement(
    _materialUi.Table,
    { style: { border: '1px solid #e0e0e0' } },
    _react2.default.createElement(
      _materialUi.TableHeader,
      { displaySelectAll: false, adjustForCheckbox: false },
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '32px' } },
        _react2.default.createElement(_materialUi.TableHeaderColumn, { style: { height: '32px' }, colSpan: '1' }),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Partner Name or Email'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Location Name'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Product Name'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Blackout Start'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Blackout End'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Blackout Name'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Blackout Issued On'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Contract Link'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.TableBody,
      { selectable: false, displayRowCheckbox: false },
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '24px' } },
        _react2.default.createElement(
          _materialUi.TableRowColumn,
          { style: { height: '24px', textAlign: 'center', padding: 0 }, colSpan: '1' },
          '1'
        ),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' })
      ),
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '24px' } },
        _react2.default.createElement(
          _materialUi.TableRowColumn,
          { style: { height: '24px', textAlign: 'center', padding: 0 } },
          '2'
        ),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' })
      )
    )
  );
};

/***/ }),
/* 3492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var border = '1px solid #e0e0e0';
  return _react2.default.createElement(
    _materialUi.Table,
    { style: { border: '1px solid #e0e0e0' } },
    _react2.default.createElement(
      _materialUi.TableHeader,
      { displaySelectAll: false, adjustForCheckbox: false },
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '32px' } },
        _react2.default.createElement(_materialUi.TableHeaderColumn, { style: { height: '32px' }, colSpan: '1' }),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Template Name'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Location Name'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Product Name'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Blackout Start'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Blackout End'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Blackout Name'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Blackout Issued On'
        ),
        _react2.default.createElement(
          _materialUi.TableHeaderColumn,
          { style: { padding: 0, fontSize: '8px', fontWeight: 'bold', color: 'black', textAlign: 'center', height: '32px', borderLeft: border }, colSpan: '4' },
          'Template Link'
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.TableBody,
      { selectable: false, displayRowCheckbox: false },
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '24px' } },
        _react2.default.createElement(
          _materialUi.TableRowColumn,
          { style: { height: '24px', textAlign: 'center', padding: 0 }, colSpan: '1' },
          '1'
        ),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' })
      ),
      _react2.default.createElement(
        _materialUi.TableRow,
        { style: { height: '24px' } },
        _react2.default.createElement(
          _materialUi.TableRowColumn,
          { style: { height: '24px', textAlign: 'center', padding: 0 } },
          '2'
        ),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' }),
        _react2.default.createElement(_materialUi.TableRowColumn, { style: { padding: 0, fontSize: '8px', textAlign: 'center', height: '24px', borderLeft: border }, colSpan: '4' })
      )
    )
  );
};

/***/ }),
/* 3493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _actions = __webpack_require__(1005);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var Suggestion = function Suggestion(props) {
  var updateProps = props.updateProps,
      contractingReports = props.contractingReports,
      submitSugg = props.submitSugg,
      companyName = props.companyName;


  return _react2.default.createElement(
    'div',
    { style: { padding: '0 16px' } },
    _react2.default.createElement(
      'div',
      { style: { textAlign: 'left', display: 'block' } },
      'Suggest A Report'
    ),
    _react2.default.createElement(
      'div',
      { style: { marginTop: '3%' } },
      _react2.default.createElement(_materialUi.TextField, {
        id: 'reportSugg',
        hintText: 'Enter your suggestions here...',
        multiLine: true,
        onChange: function onChange(_ref) {
          var value = _ref.target.value;
          return updateProps({ suggestion: value });
        },
        underlineShow: false,
        style: { whiteSpace: 'pre-wrap', width: '100%', border: '1px solid rgba(0, 0, 0, 0.12)', borderRadius: '3px', minHeight: '150px', padding: '5px', maxHeight: '150px', overflowY: 'scroll' }
      })
    ),
    _react2.default.createElement(
      'div',
      { style: { display: 'block', textAlign: 'right' } },
      _react2.default.createElement(_materialUi.RaisedButton, {
        secondary: true,
        label: 'Submit',
        style: { marginTop: '3%' },
        disabled: isNilOrEmpty(contractingReports.suggestion),
        onTouchTap: function onTouchTap() {
          submitSugg(contractingReports.suggestion, companyName);
          updateProps({ suggestion: '' });
        }
      })
    ),
    contractingReports.showSuggestionConfirmation ? _react2.default.createElement(
      'div',
      { style: { fontWeight: 600, color: 'green' } },
      'Thanks for the suggestion!'
    ) : _react2.default.createElement('span', null)
  );
};

Suggestion.propTypes = {
  updateProps: _react.PropTypes.func,
  contractingReports: _react.PropTypes.object,
  submitSugg: _react.PropTypes.func,
  companyName: _react.PropTypes.string
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProps: function updateProps() {
      return dispatch(_actions.updateCReportProps.apply(undefined, arguments));
    },
    submitSugg: function submitSugg(payload, companyName) {
      return dispatch((0, _actions.submitReportSugg)(payload, companyName));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contractingReports = _ref2.contractingReports,
      user = _ref2.user;
  return {
    contractingReports: contractingReports.toJS(),
    companyName: user.getIn(['company', 'companyName'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Suggestion);

/***/ }),
/* 3494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _actions = __webpack_require__(1005);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  generatingReport: _react.PropTypes.bool,
  params: _react.PropTypes.object,
  goBack: _react.PropTypes.func,
  getAvailDocsForDiffReport: _react.PropTypes.func,
  clearStore: _react.PropTypes.func
};

var DiffReportContainer = function (_React$Component) {
  _inherits(DiffReportContainer, _React$Component);

  function DiffReportContainer(props) {
    _classCallCheck(this, DiffReportContainer);

    var _this = _possibleConstructorReturn(this, (DiffReportContainer.__proto__ || Object.getPrototypeOf(DiffReportContainer)).call(this, props));

    _this.onClickGoBack = function () {
      if (window.history && window.history.length > 1) {
        return _this.props.goBack();
      }
      window.close();
    };

    _this.state = {};
    return _this;
  }

  _createClass(DiffReportContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var collection = this.props.params.collection;
      var _props$location$query = this.props.location.query,
          locationId = _props$location$query.locationId,
          buyerId = _props$location$query.buyerId,
          email = _props$location$query.email;

      if (locationId) {
        this.props.getAvailDocsForDiffReport({ collection: collection, locationId: locationId, buyerId: buyerId, email: email });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearStore();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return _react2.default.createElement(
        'div',
        { className: 'full-screen-page' },
        children,
        _react2.default.createElement(
          'div',
          {
            style: { position: 'fixed', top: 6, right: 16, cursor: 'pointer', zIndex: 20 },
            onClick: this.onClickGoBack
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-close', style: { fontSize: '36px', color: 'rgba(0, 0, 0, 0.54)' } })
        )
      );
    }
  }]);

  return DiffReportContainer;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  _objectDestructuringEmpty(_ref);

  return {};
};

var mapDispatchToProps = {
  goBack: _reactRouterRedux.goBack,
  push: _reactRouterRedux.push,
  getAvailDocsForDiffReport: _actions.getAvailDocsForDiffReport,
  clearStore: _actions.clearStore
};
DiffReportContainer.propTypes = propTypes;
DiffReportContainer.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DiffReportContainer);

/***/ }),
/* 3495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _content = __webpack_require__(3496);

var _content2 = _interopRequireDefault(_content);

var _actions = __webpack_require__(1005);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  availDocs: _react.PropTypes.array,
  generatingReport: _react.PropTypes.bool,
  diffMetaData: _react.PropTypes.object,
  rawDiffData: _react.PropTypes.array,
  getDiffReport: _react.PropTypes.func,
  params: _react.PropTypes.object,
  goBack: _react.PropTypes.func,
  ratesSummary: _react.PropTypes.object
};

var DiffReportContainer = function (_React$Component) {
  _inherits(DiffReportContainer, _React$Component);

  function DiffReportContainer(props) {
    _classCallCheck(this, DiffReportContainer);

    var _this = _possibleConstructorReturn(this, (DiffReportContainer.__proto__ || Object.getPrototypeOf(DiffReportContainer)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(DiffReportContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var collection = this.props.params.collection;
      var baseId = this.props.params.baseId;
      var compareId = this.props.params.compareId;
      this.props.getDiffReport(collection + ':' + compareId + ':' + baseId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.params !== this.props.params) {
        var collection = nextProps.params.collection;
        var baseId = nextProps.params.baseId;
        var compareId = nextProps.params.compareId;
        this.props.getDiffReport(collection + ':' + compareId + ':' + baseId);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          rawDiffData = _props.rawDiffData,
          diffMetaData = _props.diffMetaData,
          generatingReport = _props.generatingReport,
          availDocs = _props.availDocs,
          ratesSummary = _props.ratesSummary;

      if (generatingReport) {
        return _react2.default.createElement(
          'div',
          { style: { paddingTop: '150px', textAlign: 'center' } },
          _react2.default.createElement(_materialUi.CircularProgress, { size: 100, thickness: 7 }),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '16px' } },
            ' We are working hard to generate the report, thanks for your patience!'
          )
        );
      }
      return _react2.default.createElement(_content2.default, {
        diffMetaData: diffMetaData,
        rawDiffData: rawDiffData,
        availDocs: availDocs,
        ratesSummary: ratesSummary
      });
    }
  }]);

  return DiffReportContainer;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var contractingReports = _ref.contractingReports;
  return _extends({
    generatingReport: contractingReports.get('generatingReport')
  }, contractingReports.get('diff'));
};

var mapDispatchToProps = { getDiffReport: _actions.getDiffReport, goBack: _reactRouterRedux.goBack };
DiffReportContainer.propTypes = propTypes;
DiffReportContainer.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DiffReportContainer);

/***/ }),
/* 3496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _leftNav = __webpack_require__(3497);

var _leftNav2 = _interopRequireDefault(_leftNav);

var _policyNotesContent = __webpack_require__(2023);

var _policyNotesContent2 = _interopRequireDefault(_policyNotesContent);

var _ratePackageContent = __webpack_require__(2025);

var _ratePackageContent2 = _interopRequireDefault(_ratePackageContent);

var _docSelector = __webpack_require__(2026);

var _docSelector2 = _interopRequireDefault(_docSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  container: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  rightContainer: { marginLeft: '30%', width: '70%', marginBottom: '500px', position: 'fixed', height: '100vh', overflow: 'hidden' },
  sideBySide: { overflowY: 'scroll', position: 'absolute', width: '100%' },
  emptyContainer: {
    textAlign: 'center',
    marginTop: '160px',
    fontSize: '30px',
    fontWeight: '300'
  },
  docsHeaderContainer: {
    width: '100%',
    marginLeft: '1px',
    zIndex: 25,
    backgroundColor: '#efefef !important',
    position: 'absolute',
    top: 0
  },
  docHeader: {
    width: '50%',
    fontSize: '18px',
    fontWeight: '300',
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    lineHeight: '24px',
    padding: '12px'
  },
  sectionContainer: {
    marginBottom: '24px'
  },
  fixHeader: {
    position: 'fixed',
    width: '100%',
    backgroundColor: '#464545 !important',
    zIndex: 15
  },
  mainDiffHeader: {
    fontSize: '24px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: 'white',
    lineHeight: '48px',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    padding: '0 36px'
  }
};
var propTypes = {
  rawDiffData: _react2.default.PropTypes.array,
  classes: _react2.default.PropTypes.object,
  diffMetaData: _react2.default.PropTypes.object,
  availDocs: _react2.default.PropTypes.array,
  ratesSummary: _react2.default.PropTypes.object
};

var DiffingContent = function (_React$Component) {
  _inherits(DiffingContent, _React$Component);

  function DiffingContent() {
    _classCallCheck(this, DiffingContent);

    var _this = _possibleConstructorReturn(this, (DiffingContent.__proto__ || Object.getPrototypeOf(DiffingContent)).call(this));

    _this.lastScrollTop = 0;

    _this.onScroll = function () {
      var rightSideElement = document.getElementById('diff-content');
      var currentScrollTop = rightSideElement.scrollTop;
      var isScrollingUp = currentScrollTop > _this.lastScrollTop;
      _this.lastScrollTop = currentScrollTop;
      // Mark highlighted nav item
      var allAnchorIds = _ramda2.default.chain(function (obj) {
        return (obj.pageSections || []).map(function (item) {
          return '' + (obj.ratePackageId || 'policyNotes') + item.type;
        });
      }, _this.props.rawDiffData);
      var stop = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var id = _step.value;

          var ele = document.getElementById(id);
          if (ele && !stop) {
            var scrollEleBound = ele.getBoundingClientRect();
            var top = scrollEleBound.top;
            var bottom = scrollEleBound.bottom;
            if ((isScrollingUp && top < window.innerHeight * 0.8 && top > window.innerHeight * 0.5 || !isScrollingUp && bottom > window.innerHeight * 0.4 && bottom < window.innerHeight * 0.6) && _this.state.anchorId !== id) {
              // stop = true;
              _this.setState({ anchorId: id }, function () {
                // scroll left nav item into view if they are hidden
                var navEle = document.getElementById('nav-' + id);
                if (!navEle) console.log({ navEle: 'nav-' + id });
                if (navEle) {
                  var bound = _ramda2.default.pick(['y', 'height', 'top', 'bottom'], navEle.getBoundingClientRect());
                  // if the nav item is under
                  if (bound.bottom > window.innerHeight) {
                    document.getElementById('diffingLeftNav').scrollTop += bound.bottom - window.innerHeight;
                  }
                  // if nav item is over
                  if (bound.top < 0) {
                    document.getElementById('diffingLeftNav').scrollTop += bound.top - 50;
                  }
                }
              });
            }
          }
        };

        for (var _iterator = allAnchorIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
        // Get page title (header) that should be fixed on top of the right side content
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var offSetTop = _this.getOffSetTop();
      var keepGoing = true;
      _this.props.rawDiffData.forEach(function (_ref, index, array) {
        var header = _ref.header;

        var headerEle = document.getElementById(header);
        var bodyEle = document.getElementById(header + '-body');
        if (headerEle && keepGoing) {
          var sectionBound = _ramda2.default.pick(['top', 'bottom'], headerEle.getBoundingClientRect());
          var bodyBound = _ramda2.default.pick(['top', 'bottom', 'height'], bodyEle.getBoundingClientRect());
          if (sectionBound.top <= offSetTop && sectionBound.bottom > offSetTop && bodyBound.height > 400) {
            if (_this.state.highlightedHeader !== header) _this.setState(_defineProperty({ highlightedHeader: header }, header, true));
          }
          var nextEle = index + 1 !== array.length ? document.getElementById(array[index + 1].header) : null;
          if (nextEle && nextEle.getBoundingClientRect().top > 100) keepGoing = false;
        }
      });
    };

    _this.getOffSetTop = function () {
      var _this$props = _this.props,
          _this$props$availDocs = _this$props.availDocs,
          availDocs = _this$props$availDocs === undefined ? [] : _this$props$availDocs,
          _this$props$diffMetaD = _this$props.diffMetaData,
          diffMetaData = _this$props$diffMetaD === undefined ? {} : _this$props$diffMetaD;

      return availDocs && availDocs.length && diffMetaData.collection === 'template' ? 104 : 74;
    };

    _this.scrollToFunc = function (hash, header) {
      var rightSideElement = document.getElementById('diff-content');
      var scrollToAnchor = function scrollToAnchor() {
        var element = document.getElementById(hash);
        if (element) {
          var bound = _ramda2.default.pick(['y', 'height', 'top', 'bottom'], element.getBoundingClientRect());
          rightSideElement.scrollTop += bound.top - _this.getOffSetTop() - 80;
          _this.lastScrollTop = rightSideElement.scrollTop;
        }
      };
      _this.setState({ anchorId: hash, highlightedHeader: header || _this.state.highlightedHeader });
      scrollToAnchor();
    };

    _this.state = {
      anchorId: '',
      highlightedHeader: ''
    };
    return _this;
  }

  _createClass(DiffingContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.addEventListener) {
        window.addEventListener('scroll', this.onScroll, true);
      } else {
        window.attachEvent('onscroll', this.onScroll);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (window.addEventListener) {
        window.removeEventListener('scroll', this.onScroll, true);
      } else {
        window.detachEvent('onScroll', this.onScroll);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react2.default.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$rawDiffData = _props.rawDiffData,
          rawDiffData = _props$rawDiffData === undefined ? [] : _props$rawDiffData,
          classes = _props.classes,
          _props$diffMetaData = _props.diffMetaData,
          diffMetaData = _props$diffMetaData === undefined ? {} : _props$diffMetaData,
          _props$availDocs = _props.availDocs,
          availDocs = _props$availDocs === undefined ? [] : _props$availDocs,
          ratesSummary = _props.ratesSummary;
      var emptyContainer = classes.emptyContainer,
          sectionContainer = classes.sectionContainer,
          fixHeader = classes.fixHeader,
          mainDiffHeader = classes.mainDiffHeader,
          container = classes.container,
          docsHeaderContainer = classes.docsHeaderContainer,
          docHeader = classes.docHeader,
          rightContainer = classes.rightContainer,
          sideBySide = classes.sideBySide;
      var _diffMetaData$compare = diffMetaData.compareDoc,
          compareDoc = _diffMetaData$compare === undefined ? {} : _diffMetaData$compare,
          _diffMetaData$baseDoc = diffMetaData.baseDoc,
          baseDoc = _diffMetaData$baseDoc === undefined ? {} : _diffMetaData$baseDoc;

      var getTimeLabel = function getTimeLabel(doc) {
        return _moment2.default.utc(doc.startDate).format('DD MMM YYYY') + '-' + _moment2.default.utc(doc.endDate).format('DD MMM YYYY');
      };
      return _react2.default.createElement(
        'div',
        { className: container },
        _react2.default.createElement(_leftNav2.default, {
          anchorId: this.state.anchorId,
          scrollToFunc: this.scrollToFunc,
          navItems: rawDiffData,
          supplierName: diffMetaData.supplierName,
          locationName: diffMetaData.locationName,
          productType: diffMetaData.productType,
          ratesSummary: ratesSummary,
          highlightedHeader: this.state.highlightedHeader
        }),
        _react2.default.createElement(
          'div',
          { className: rightContainer },
          availDocs && availDocs.length ? _react2.default.createElement(
            _materialUi.Paper,
            { className: '' + docsHeaderContainer },
            _react2.default.createElement(_docSelector2.default, {
              inHeader: true,
              availDocs: availDocs,
              initialBaseDocId: baseDoc._id,
              initialCompareDocId: compareDoc._id,
              collection: diffMetaData.collection
            })
          ) : _react2.default.createElement(
            _materialUi.Paper,
            { className: 'flex-center ' + docsHeaderContainer, style: { lineHeight: '48px' } },
            _react2.default.createElement(
              'div',
              { className: docHeader },
              getTimeLabel(compareDoc) + '\n',
              _react2.default.createElement(
                'small',
                null,
                compareDoc.templateName,
                ' (',
                compareDoc.version,
                ')'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: docHeader },
              getTimeLabel(baseDoc) + '\n',
              _react2.default.createElement(
                'small',
                null,
                baseDoc.templateName,
                ' (',
                baseDoc.version,
                ')'
              )
            )
          ),
          !(rawDiffData && rawDiffData.length) && _react2.default.createElement(
            'div',
            { className: emptyContainer },
            'There is no difference between these two documents.'
          ),
          _react2.default.createElement(
            'div',
            {
              className: sideBySide,
              id: 'diff-content',
              style: {
                height: 'calc(100vh - ' + this.getOffSetTop() + 'px)',
                top: this.getOffSetTop() + 'px'
              }
            },
            rawDiffData.map(function (_ref2, index) {
              var header = _ref2.header,
                  mainType = _ref2.mainType,
                  _ref2$pageSections = _ref2.pageSections,
                  pageSections = _ref2$pageSections === undefined ? [] : _ref2$pageSections,
                  ratePackageId = _ref2.ratePackageId;

              var headerFixed = _this2.state.highlightedHeader === header;
              return _react2.default.createElement(
                'div',
                {
                  className: sectionContainer,
                  key: ratePackageId || mainType,
                  id: header,
                  style: { marginTop: !index && _this2.state.highlightedHeader ? _this2.getOffSetTop() - 14 + 'px' : '20px' }
                },
                _react2.default.createElement(
                  'div',
                  { className: mainDiffHeader + ' ' + (headerFixed ? fixHeader : ''), style: headerFixed ? { top: _this2.getOffSetTop() } : {} },
                  header
                ),
                _react2.default.createElement(
                  'div',
                  { style: { padding: '0 36px' }, id: header + '-body' },
                  pageSections.map(function (_ref3) {
                    var type = _ref3.type,
                        label = _ref3.label,
                        thisDiffBlock = _ref3.thisDiffBlock,
                        updateSummary = _ref3.updateSummary;

                    var PageComponent = mainType === 'policyNotes' ? _policyNotesContent2.default : _ratePackageContent2.default;
                    return _react2.default.createElement(PageComponent, {
                      key: type,
                      diffBlock: thisDiffBlock,
                      ratePackageId: ratePackageId,
                      updateSummary: updateSummary,
                      type: type,
                      label: label
                    });
                  })
                )
              );
            })
          )
        )
      );
    }
  }]);

  return DiffingContent;
}(_react2.default.Component);

DiffingContent.propTypes = propTypes;
exports.default = (0, _reactJss2.default)(styles)(DiffingContent);

/***/ }),
/* 3497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _sectionUpdateSummary = __webpack_require__(1262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  a: {
    whiteSpace: 'wrap',
    fontWeight: '500',
    cursor: 'pointer'
  },
  leftNavContainer: { position: 'fixed', height: 'calc(100% + 96px)', paddingTop: '24px', overflowY: 'scroll', width: '30%' },
  overallRatesSummary: { fontSize: '12px', fontWeight: '400', textTransform: 'none', marginLeft: '12px', lineHeight: '24px' },
  pageSummaryHeader: { fontSize: '18px !important', color: 'white !important', cursor: 'pointer', textTransform: 'uppercase' },
  ratePackagePricingSummary: { fontSize: '12px', fontWeight: '400', textTransform: 'none', marginLeft: '12px', lineHeight: '24px', marginBottom: '8px' }
};

var DiffingLeftNav = function (_React$Component) {
  _inherits(DiffingLeftNav, _React$Component);

  function DiffingLeftNav() {
    _classCallCheck(this, DiffingLeftNav);

    return _possibleConstructorReturn(this, (DiffingLeftNav.__proto__ || Object.getPrototypeOf(DiffingLeftNav)).apply(this, arguments));
  }

  _createClass(DiffingLeftNav, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          navItems = _props.navItems,
          classes = _props.classes,
          locationName = _props.locationName,
          supplierName = _props.supplierName,
          ratesSummary = _props.ratesSummary,
          productType = _props.productType,
          scrollToFunc = _props.scrollToFunc,
          anchorId = _props.anchorId,
          highlightedHeader = _props.highlightedHeader;
      var a = classes.a,
          leftNavContainer = classes.leftNavContainer,
          overallRatesSummary = classes.overallRatesSummary,
          pageSummaryHeader = classes.pageSummaryHeader,
          ratePackagePricingSummary = classes.ratePackagePricingSummary;

      var isComparingVersions = !Boolean(ratesSummary && !_ramda2.default.isEmpty(ratesSummary));
      /* Main Structure
      {
        ratesSummary: { nettAmountDiff, nettPercentDiff, extraAmountDiff, extraPercentDiff }
        navItems: [{
         mainType: 'policyNotes' OR 'ratePackage'
         header: 'Policies & Notes' OR <Product Name + Rate Package Name>
         nettAmountDiff
         nettPercentDiff
         extraAmountDiff
         extraPercentDiff
         pageSections: [{
          label: 'Updated Peak/High Season',
          updateSummary: [{
            text: 'Updated Dates',
          }, {
            text: 'Nightly - Saturday',
            subLabels: [{
              text: 'Pricing Changed',
              nettRate: { amounts: [20, 21, 20], percents: [8, 9, 8] }
            }, {
              text: 'Days of Week',
            }]
          }]
         }]
       }]
      }
       */
      return _react2.default.createElement(
        _materialUi.Paper,
        { id: 'diffingLeftNav', className: 'settings-left-nav ' + leftNavContainer },
        _react2.default.createElement(
          'div',
          {
            className: 'settings-left-nav-inner settings-left-nav-heading',
            style: { marginTop: '74px', backgroundColor: '#00bcd4', minHeight: '48px' }
          },
          _react2.default.createElement(
            'span',
            { style: { fontSize: '16px', fontWeight: '400', color: 'white', display: 'inline-block', lineHeight: '32px' } },
            supplierName === locationName ? locationName : '' + (supplierName ? supplierName + ' - ' : '') + locationName
          )
        ),
        !isComparingVersions && _react2.default.createElement(
          'div',
          { style: { padding: '8px' } },
          _react2.default.createElement(
            'div',
            { className: 'flex-center', style: { lineHeight: '24px', color: 'rgba(0, 0, 0, 0.54) !important', fontWeight: '400' } },
            _react2.default.createElement(_materialUi.FontIcon, { color: 'rgba(0, 0, 0, 0.54)', style: { fontSize: '16px' }, className: 'tc-icon-info' }),
            '\xA0Price Changed: ',
            ratesSummary.nettAmountDiff || ratesSummary.extraAmountDiff ? '' : 'N/A'
          ),
          Boolean(ratesSummary.nettAmountDiff || ratesSummary.extraAmountDiff) && _react2.default.createElement(
            'ul',
            { className: overallRatesSummary, style: { paddingLeft: '8px' } },
            _react2.default.createElement(
              'li',
              null,
              productType === 'Accommodation' ? 'Room Types' : 'Products',
              ':\xA0',
              ratesSummary.nettAmountDiff ? (0, _sectionUpdateSummary.getPricingChangesComponent)(ratesSummary.nettAmountDiff, ratesSummary.nettPercentDiff) : ': N/A'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Extras:\xA0',
              ratesSummary.extraAmountDiff ? (0, _sectionUpdateSummary.getPricingChangesComponent)(ratesSummary.extraAmountDiff, ratesSummary.extraPercentDiff) : ': N/A'
            )
          )
        ),
        navItems.map(function (_ref, navIndex) {
          var mainType = _ref.mainType,
              addedOrRemoved = _ref.addedOrRemoved,
              header = _ref.header,
              _ref$pageSections = _ref.pageSections,
              pageSections = _ref$pageSections === undefined ? [] : _ref$pageSections,
              ratePackageId = _ref.ratePackageId,
              nettAmountDiff = _ref.nettAmountDiff,
              nettPercentDiff = _ref.nettPercentDiff,
              extraPercentDiff = _ref.extraPercentDiff,
              extraAmountDiff = _ref.extraAmountDiff;
          return _react2.default.createElement(
            'div',
            { key: header, className: 'connections-widget', style: { marginTop: navIndex ? '-8px' : '0' } },
            _react2.default.createElement(
              'div',
              {
                className: 'connections-widget-link ' + pageSummaryHeader,
                style: { backgroundColor: highlightedHeader === header ? '#464545' : 'rgba(0, 0, 0, 0.3)' },
                onClick: function onClick() {
                  return scrollToFunc(header);
                }
              },
              _react2.default.createElement(
                'a',
                { className: a, style: { color: 'white' } },
                header
              )
            ),
            mainType !== 'policyNotes' && Boolean(pageSections.length) && !isComparingVersions && !addedOrRemoved && _react2.default.createElement(
              'div',
              { style: { padding: '4px', color: 'rgba(0, 0, 0, 0.54)' } },
              _react2.default.createElement(
                'div',
                { className: 'flex-center' },
                _react2.default.createElement(_materialUi.FontIcon, { color: 'rgba(0, 0, 0, 0.54)', style: { fontSize: '16px' }, className: 'tc-icon-info' }),
                '\xA0PRICE CHANGED: ',
                nettAmountDiff || extraAmountDiff ? '' : 'N/A'
              ),
              Boolean(nettAmountDiff || extraAmountDiff) && _react2.default.createElement(
                'ul',
                { className: ratePackagePricingSummary, style: { paddingLeft: '8px' } },
                _react2.default.createElement(
                  'li',
                  null,
                  productType === 'Accommodation' ? 'Room Type: ' : 'Product: ',
                  nettAmountDiff ? (0, _sectionUpdateSummary.getPricingChangesComponent)(nettAmountDiff, nettPercentDiff) : 'N/A'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Extras:\xA0',
                  extraAmountDiff ? (0, _sectionUpdateSummary.getPricingChangesComponent)(extraAmountDiff, extraPercentDiff) : ': N/A'
                )
              )
            ),
            pageSections.map(function (_ref2, subItemIndex) {
              var type = _ref2.type,
                  label = _ref2.label,
                  _ref2$updateSummary = _ref2.updateSummary,
                  updateSummary = _ref2$updateSummary === undefined ? [] : _ref2$updateSummary;

              var thisAnchor = '' + (ratePackageId || 'policyNotes') + type;
              var isActive = anchorId && anchorId === thisAnchor || !anchorId && subItemIndex === 0 && navIndex === 0;
              return _react2.default.createElement(
                'div',
                {
                  key: label,
                  id: 'nav-' + thisAnchor,
                  className: 'connections-widget-link ' + (isActive ? 'is-active' : ''),
                  onClick: function onClick() {
                    scrollToFunc(thisAnchor, header);
                  }
                },
                _react2.default.createElement(
                  'a',
                  { className: a, style: { color: isActive ? '#00bcd4' : 'rgba(0, 0, 0, 0.84)', fontSize: '14px' } },
                  label,
                  Boolean(updateSummary.length) && _react2.default.createElement(_sectionUpdateSummary.UpdateSummary, {
                    updateSummary: updateSummary
                  })
                )
              );
            })
          );
        })
      );
    }
  }]);

  return DiffingLeftNav;
}(_react2.default.Component);

exports.default = (0, _reactJss2.default)(styles)(DiffingLeftNav);

/***/ }),
/* 3498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckInCheckOutDiff = exports.BillingDiff = exports.InsuranceDiff = exports.LocPolicyDiff = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _textDff = __webpack_require__(1565);

var _textDff2 = _interopRequireDefault(_textDff);

var _policyMain = __webpack_require__(1562);

var _policyMain2 = _interopRequireDefault(_policyMain);

var _ratePackageElements = __webpack_require__(2024);

var _billingInfoNode = __webpack_require__(1265);

var _checkinout = __webpack_require__(1267);

var _checkinout2 = _interopRequireDefault(_checkinout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LocPolicyDiff = exports.LocPolicyDiff = function LocPolicyDiff(_ref) {
  var diff = _ref.diff,
      isLeft = _ref.isLeft,
      originalData = _ref.originalData,
      policyType = _ref.policyType;

  var classes = (0, _ratePackageElements.getClassesForType2)(isLeft, diff, originalData, policyType, []);
  var data = originalData[isLeft ? 'lhs' : 'rhs'];
  return _react2.default.createElement(_policyMain2.default, {
    policyType: policyType,
    policyProps: _defineProperty({
      hideLabel: true,
      classes: classes
    }, policyType + 'Info', _extends({}, data))
  });
};
var setIn = function setIn(path, value, obj) {
  var lensPath = _ramda2.default.lensPath(path);
  return _ramda2.default.set(lensPath, value, obj);
};
var InsuranceDiff = exports.InsuranceDiff = function InsuranceDiff(_ref3) {
  var diff = _ref3.diff,
      isLeft = _ref3.isLeft,
      originalData = _ref3.originalData;

  var classes = (0, _ratePackageElements.getClassesForType2)(isLeft, diff, originalData, 'insurance', ['insuranceFiles']);
  var data = originalData[isLeft ? 'lhs' : 'rhs'];
  return _react2.default.createElement(_billingInfoNode.InsuranceInfoDisplay, _extends({
    hideLabel: true
  }, data, {
    classes: classes
  }));
};

var BillingDiff = exports.BillingDiff = function BillingDiff(_ref4) {
  var diff = _ref4.diff,
      isLeft = _ref4.isLeft,
      originalData = _ref4.originalData;

  var classes = (0, _ratePackageElements.getClassesForType2)(isLeft, diff, originalData, 'billing', []);
  var data = originalData[isLeft ? 'lhs' : 'rhs'];
  return _react2.default.createElement(_billingInfoNode.BillingInfoDisplay, _extends({
    hideLabel: true
  }, data, {
    classes: classes
  }));
};

var CheckInCheckOutDiff = exports.CheckInCheckOutDiff = function CheckInCheckOutDiff(_ref5) {
  var diff = _ref5.diff,
      isLeft = _ref5.isLeft,
      originalData = _ref5.originalData;

  var classes = (0, _ratePackageElements.getClassesForType2)(isLeft, diff, originalData, 'checkInCheckOut', []);
  var data = originalData[isLeft ? 'lhs' : 'rhs'];
  return _react2.default.createElement(_checkinout2.default, _extends({
    inDiffing: true
  }, data, {
    classes: classes
  }));
};

/***/ }),
/* 3499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _docSelector = __webpack_require__(2026);

var _docSelector2 = _interopRequireDefault(_docSelector);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRouterRedux = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  allTemplates: _react.PropTypes.array,
  replace: _react.PropTypes.func,
  params: _react.PropTypes.object,
  availDocs: _react.PropTypes.array,
  loadingDocs: _react.PropTypes.bool
};
var styles = {
  container: { marginTop: '40px' },
  selectionContainer: {
    width: '80%',
    margin: '60px auto 0',
    display: 'flex',
    alignItems: 'flex-start'
  },
  compareDocContainer: {
    width: '40%',
    textAlign: 'center',
    fontWeight: 'bold'
  },
  baseDocContainer: {
    width: '40%',
    marginLeft: '20%',
    textAlign: 'center',
    fontWeight: 'bold'
  },
  flexEnd: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
};

var SelectDocsForDiffReport = function (_React$Component) {
  _inherits(SelectDocsForDiffReport, _React$Component);

  function SelectDocsForDiffReport(props) {
    _classCallCheck(this, SelectDocsForDiffReport);

    var _this = _possibleConstructorReturn(this, (SelectDocsForDiffReport.__proto__ || Object.getPrototypeOf(SelectDocsForDiffReport)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(SelectDocsForDiffReport, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          _props$availDocs = _props.availDocs,
          availDocs = _props$availDocs === undefined ? [] : _props$availDocs,
          params = _props.params,
          location = _props.location,
          loadingDocs = _props.loadingDocs;
      var container = classes.container,
          selectionContainer = classes.selectionContainer,
          compareDocContainer = classes.compareDocContainer,
          baseDocContainer = classes.baseDocContainer;

      var collection = params.collection;
      var baseId = params.baseId;
      var _location$query = location.query,
          locationName = _location$query.locationName,
          companyName = _location$query.companyName;

      return _react2.default.createElement(
        'div',
        { className: container },
        _react2.default.createElement(
          'h4',
          { style: { textAlign: 'center' } },
          companyName ? companyName + ' - ' : '',
          locationName
        ),
        _react2.default.createElement(
          'div',
          { className: selectionContainer },
          _react2.default.createElement(
            'div',
            { className: compareDocContainer },
            'Compare with'
          ),
          _react2.default.createElement(
            'div',
            { className: baseDocContainer },
            'Base ',
            collection === 'template' ? 'Template' : 'Contract'
          )
        ),
        _react2.default.createElement(_docSelector2.default, {
          availDocs: availDocs,
          initialBaseDocId: baseId,
          collection: collection,
          loadingDocs: loadingDocs
        })
      );
    }
  }]);

  return SelectDocsForDiffReport;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var contractingReports = _ref.contractingReports;
  return _extends({}, contractingReports.get('diff'));
};

var mapDispatchToProps = {
  replace: _reactRouterRedux.replace
};
SelectDocsForDiffReport.propTypes = propTypes;
SelectDocsForDiffReport.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(SelectDocsForDiffReport));

/***/ }),
/* 3500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _materialUi = __webpack_require__(3);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _description = __webpack_require__(561);

var _description2 = _interopRequireDefault(_description);

var _extension = __webpack_require__(2027);

var _extension2 = _interopRequireDefault(_extension);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _flatDropDownMenu = __webpack_require__(494);

var _flatDropDownMenu2 = _interopRequireDefault(_flatDropDownMenu);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  container: {
    marginBottom: '56px',
    backgroundColor: 'white',
    minHeight: '400px',
    display: 'flex',
    alignItems: 'stretch'
  },
  leftSide: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    color: 'white',
    fontSize: '18px',
    width: '20%',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '250px',
    overflow: 'hidden'
  },
  btnDiv: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    color: 'white',
    fontSize: '18px',
    height: '48px',
    minHeight: '48px',
    textAlign: 'center'
  }
};

var TemplateListContainer = function (_Component) {
  _inherits(TemplateListContainer, _Component);

  function TemplateListContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TemplateListContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TemplateListContainer.__proto__ || Object.getPrototypeOf(TemplateListContainer)).call.apply(_ref, [this].concat(args))), _this), _this.renderMenuItem = _ramda2.default.curry(function (icon, label, route) {
      var isActive = window.location.href.indexOf(route) > -1;
      return _react2.default.createElement(
        'div',
        {
          className: 'contracting-left-nav-widget-link ' + (isActive ? 'is-active' : ''),
          style: { color: isActive ? '#00bcd4' : 'white', fontSize: '14px', display: 'flex', alignItem: 'center' },
          onClick: function onClick() {
            return _this.props.push(route);
          }
        },
        _ramda2.default.is(String, icon) ? _react2.default.createElement(_materialUi.FontIcon, {
          className: icon,
          color: isActive ? '#00bcd4' : 'white',
          style: { width: '36px' }
        }) : (0, _react.cloneElement)(icon, { color: isActive ? '#00bcd4' : 'white', style: { width: '36px' } }),
        _react2.default.createElement(
          'span',
          { style: { lineHeight: '24px', width: '80%' } },
          label
        )
      );
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TemplateListContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          push = _props.push,
          _props$templates = _props.templates,
          templates = _props$templates === undefined ? [] : _props$templates;

      var queuedUpdatesCount = templates.filter(function (obj) {
        return obj.stagedUpdates && obj.stagedUpdates.length;
      }).length;
      return _react2.default.createElement(
        _materialUi.Paper,
        { className: classes.container },
        _react2.default.createElement(
          'div',
          { className: classes.leftSide },
          _react2.default.createElement(
            'div',
            { className: classes.btnDiv },
            _react2.default.createElement(
              _flatDropDownMenu2.default,
              {
                button: _react2.default.createElement(_materialUi.RaisedButton, {
                  primary: true,
                  label: 'Create Template',
                  style: { marginTop: '6px', minWidth: '250px' },
                  icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-add' })
                })
              },
              _react2.default.createElement(_materialUi.MenuItem, {
                primaryText: 'Rate Template',
                onTouchTap: function onTouchTap() {
                  return push('/contracting/create-template-draft');
                }
              }),
              _react2.default.createElement(_materialUi.Divider, null),
              _react2.default.createElement(_materialUi.MenuItem, {
                primaryText: 'Template Group',
                onTouchTap: function onTouchTap() {
                  return push('/contracting/create-template-group');
                }
              }),
              _react2.default.createElement(_materialUi.Divider, null),
              _react2.default.createElement(
                _wrapper2.default,
                { amazonOrange: true, lockIcon: true, skipClick: true },
                _react2.default.createElement(_materialUi.MenuItem, {
                  primaryText: 'Corporate Policies & Notes',
                  onTouchTap: function onTouchTap() {
                    return push('/contracting/create-master-template');
                  }
                })
              )
            )
          ),
          _react2.default.createElement(
            _materialUi.Paper,
            {
              className: 'contracting-left-nav-widget',
              style: { backgroundColor: '#383E4B', flex: '1' },
              zDepth: 2
            },
            this.renderMenuItem(_react2.default.createElement(_description2.default, null), 'Rate Templates', '/contracting/template-list'),
            _react2.default.createElement(_materialUi.Divider, { style: { backgroundColor: 'rgba(255, 255, 255, 0.2)', margin: '16px 0' } }),
            _react2.default.createElement(
              _wrapper2.default,
              { amazonOrange: true, slug: 'upgrade-rates-corp', skipClick: true },
              this.renderMenuItem(_react2.default.createElement(_extension2.default, null), 'Corporate Policies & Notes', '/contracting/master-template-list?type=policyNotes')
            ),
            Boolean(queuedUpdatesCount) && _react2.default.createElement(_materialUi.Divider, { style: { backgroundColor: 'rgba(255, 255, 255, 0.2)', margin: '16px 0' } }),
            Boolean(queuedUpdatesCount) && this.renderMenuItem(_react2.default.createElement(_description2.default, null), 'Updates Queue', '/contracting/supplier-updates-queue')
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '80%' } },
          children
        )
      );
    }
  }]);

  return TemplateListContainer;
}(_react.Component);

TemplateListContainer.propTypes = {
  children: _react.PropTypes.node,
  location: _react.PropTypes.object,
  push: _react.PropTypes.func,
  classes: _react.PropTypes.object,
  openCreateDraftDialog: _react.PropTypes.func,
  templates: _react.PropTypes.array
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    templates: contracting.templateList.toJS().templates
  };
};

var mapDispatchToProps = {
  push: _reactRouterRedux.push
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(TemplateListContainer));

/***/ }),
/* 3501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _templateListActions = __webpack_require__(877);

var _list = __webpack_require__(3502);

var _list2 = _interopRequireDefault(_list);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _inDialog = __webpack_require__(3510);

var _inDialog2 = _interopRequireDefault(_inDialog);

var _createGroupDialog = __webpack_require__(3511);

var _createGroupDialog2 = _interopRequireDefault(_createGroupDialog);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var MainTemplatesListContainer = function (_Component) {
  _inherits(MainTemplatesListContainer, _Component);

  function MainTemplatesListContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MainTemplatesListContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MainTemplatesListContainer.__proto__ || Object.getPrototypeOf(MainTemplatesListContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onExpandChange = function (docs, locationId, expandedName, expanded) {
      var updateLocationProps = _this.props.updateLocationProps;

      updateLocationProps({ locationId: locationId, value: _defineProperty({}, expandedName, !expanded) });
      // const templateIds = docs.filter(doc => isNaN(doc.partnersCount)).map(R.prop('_id'));
      // if (!R.isEmpty(templateIds)) this.props.getContractsCount(templateIds);
    }, _this.getRouteName = function (pathname) {
      var location = _this.props.location;

      return _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.contains('draft'), _ramda2.default.always('drafts')], [_ramda2.default.contains('template-groups'), _ramda2.default.always('groups')], [_ramda2.default.T, _ramda2.default.always('templates')]]), pathname || location.pathname);
    }, _this.updateSearchFiltersFromQuery = function (query) {
      var updatedQ = _ramda2.default.mapObjIndexed(function (val, key) {
        if (_ramda2.default.contains('Filter', key) && _ramda2.default.is(String, val)) return [val];
        if (key === 'searchingAllYears') return val === 'true';
        return val;
      }, query);
      _this.props.updateFilters(updatedQ);
    }, _this.changeRoute = function (route) {
      return _this.props.router.push('/contracting/' + route);
    }, _this.createDraft = function () {
      var _this$props = _this.props,
          newDraftStartDate = _this$props.newDraftStartDate,
          newDraftEndDate = _this$props.newDraftEndDate,
          locations = _this$props.locations,
          newDraftName = _this$props.newDraftName,
          updateProps = _this$props.updateProps,
          createDraft = _this$props.createDraft,
          draftRateType = _this$props.draftRateType,
          draftCommissionPercentage = _this$props.draftCommissionPercentage,
          draftNettCommission = _this$props.draftNettCommission;

      var updatedContactInfoComplete = function updatedContactInfoComplete(contactInfo) {
        return contactInfo.address && (contactInfo.address.address_1 || contactInfo.formattedAddress) && contactInfo.phone && contactInfo.firstName && contactInfo.lastName;
      };
      var locationsValid = locations.filter(_ramda2.default.propEq('checked', true)).every(function (loc) {
        return loc.contactInfoComplete || updatedContactInfoComplete(loc.contactInfo);
      });
      var dataValid = _ramda2.default.call(_ramda2.default.allPass([function () {
        return newDraftStartDate;
      }, function () {
        return newDraftEndDate;
      }, function () {
        return _ramda2.default.any(_ramda2.default.propEq('checked', true), locations);
      }, function () {
        return newDraftName;
      }, function () {
        return locationsValid;
      }]));
      if (dataValid) {
        createDraft({
          startDate: newDraftStartDate,
          endDate: newDraftEndDate,
          locations: locations,
          templateName: newDraftName,
          draftRateType: draftRateType,
          draftCommissionPercentage: draftCommissionPercentage,
          draftNettCommission: draftNettCommission
        }).then(function (res) {
          var draftsLength = _ramda2.default.pathOr(0, ['payload', 'drafts', 'length'], res);
          var firstDraft = _ramda2.default.pathOr({}, ['payload', 'drafts', 0], res);
          if (draftsLength > 1) _this.props.router.push('/contracting/template-list');
          if (draftsLength === 1) _this.props.router.push('/contracting/draft/' + firstDraft.originalContractId + '/details');
        });
      } else updateProps({ createDraftError: 'Please fill all required fields' });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MainTemplatesListContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = 'Templates';
      var _props = this.props,
          getLocationsAndProducts = _props.getLocationsAndProducts,
          updateProps = _props.updateProps,
          locations = _props.locations,
          getTemplates = _props.getTemplates;

      if (isNilOrEmpty(locations)) getLocationsAndProducts();
      var query = _ramda2.default.propOr({}, 'query', location);
      if (!isNilOrEmpty(query)) updateProps(query);
      getTemplates();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.location.search) {
        this.updateSearchFiltersFromQuery(this.props.location.query);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.location.search !== this.props.location.search) {
        this.updateSearchFiltersFromQuery(nextProps.location.query);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var route = this.getRouteName();

      var _props2 = this.props,
          sendTemplateDialogOpen = _props2.sendTemplateDialogOpen,
          contractsSent = _props2.contractsSent,
          templateToBeSent = _props2.templateToBeSent,
          templateGroupToBeSent = _props2.templateGroupToBeSent,
          extraProps = _objectWithoutProperties(_props2, ['sendTemplateDialogOpen', 'contractsSent', 'templateToBeSent', 'templateGroupToBeSent']);

      var updateProps = extraProps.updateProps,
          showLoadingOverlay = extraProps.showLoadingOverlay,
          overlayText = extraProps.overlayText;

      var allProps = _extends({}, extraProps, {
        onExpandChange: this.onExpandChange,
        router: this.props.router,
        route: route
      });
      return _react2.default.createElement(
        'div',
        { style: { width: '100%' } },
        _react2.default.createElement(_list2.default, allProps),
        _react2.default.createElement(_loadingOverlay2.default, { loading: showLoadingOverlay, text: overlayText }),
        _react2.default.createElement(_inDialog2.default, { updateProps: updateProps, createDraft: this.createDraft }),
        _react2.default.createElement(_createGroupDialog2.default, { updateProps: updateProps, getTemplates: extraProps.getTemplates })
      );
    }
  }]);

  return MainTemplatesListContainer;
}(_react.Component);

MainTemplatesListContainer.propTypes = {
  children: _react.PropTypes.node,
  templateToBeSent: _react.PropTypes.object,
  templateGroupToBeSent: _react.PropTypes.object,
  drafts: _react.PropTypes.array,
  templates: _react.PropTypes.array,
  locations: _react.PropTypes.array,
  templatesLoaded: _react.PropTypes.bool,
  showLoadingOverlay: _react.PropTypes.bool,
  overlayText: _react.PropTypes.string,
  sendTemplateDialogOpen: _react.PropTypes.bool,
  contractsSent: _react.PropTypes.bool,
  isSingleLoc: _react.PropTypes.bool,
  updateProps: _react.PropTypes.func,
  listRefreshing: _react.PropTypes.bool,
  updateTemplateProps: _react.PropTypes.func,
  updateDraftProps: _react.PropTypes.func,
  deleteTemplate: _react.PropTypes.func,
  deleteDraft: _react.PropTypes.func,
  getContractsCount: _react.PropTypes.func,
  getLocationsAndProducts: _react.PropTypes.func,
  getTemplates: _react.PropTypes.func,
  updateLocationProps: _react.PropTypes.func,
  router: _react.PropTypes.object,
  updateFilters: _react.PropTypes.func,
  location: _react.PropTypes.object
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting,
      user = _ref2.user;
  return _extends({
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop'
  }, contracting.templateList.toJS(), {
    currentYear: contracting.currentYear,
    allContractPeriods: contracting.contractPeriods
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProps: function updateProps(payload) {
      return dispatch((0, _templateListActions.updateProps)(payload));
    },
    updateTemplateProps: function updateTemplateProps() {
      return dispatch(_templateListActions.updateTemplateProps.apply(undefined, arguments));
    },
    updateDraftProps: function updateDraftProps() {
      return dispatch(_templateListActions.updateDraftProps.apply(undefined, arguments));
    },
    deleteTemplate: function deleteTemplate() {
      return dispatch(_templateListActions.deleteTemplate.apply(undefined, arguments));
    },
    deleteDraft: function deleteDraft() {
      return dispatch(_templateListActions.deleteDraft.apply(undefined, arguments));
    },
    getTemplates: function getTemplates() {
      return dispatch((0, _templateListActions.getTemplates)());
    },
    getLocationsAndProducts: function getLocationsAndProducts() {
      return dispatch((0, _templateListActions.getLocationsAndProducts)());
    },
    createDraft: function createDraft() {
      return dispatch(_templateListActions.createDraft.apply(undefined, arguments));
    },
    getContractsCount: function getContractsCount() {
      return dispatch(_templateListActions.getContractsCount.apply(undefined, arguments));
    },
    updateLocationProps: function updateLocationProps() {
      return dispatch(_templateListActions.updateLocationProps.apply(undefined, arguments));
    },
    saveNewTemplateName: _ramda2.default.curry(function (templateOrDraft, id, newName) {
      if (newName && newName.trim()) dispatch((0, _templateListActions.saveNewTemplateName)(templateOrDraft, id, newName));else window.alert('Template name cannot be empty.');
    }),
    downloadPdfZip: function downloadPdfZip() {
      return dispatch(_templateListActions.downloadPdfZip.apply(undefined, arguments));
    },
    archiveUnarchive: function archiveUnarchive() {
      return dispatch(_templateListActions.archiveUnarchive.apply(undefined, arguments));
    },
    router: {
      push: function push() {
        return dispatch(_reactRouterRedux.push.apply(undefined, arguments));
      },
      replace: function replace() {
        return dispatch(_reactRouterRedux.replace.apply(undefined, arguments));
      },
      goBack: function goBack() {
        return dispatch(_reactRouterRedux.goBack.apply(undefined, arguments));
      }
    },
    updateFilters: function updateFilters() {
      return dispatch(_templateListActions.updateFilters.apply(undefined, arguments));
    }
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MainTemplatesListContainer);

/***/ }),
/* 3502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _singleLoc = __webpack_require__(1143);

var _singleLoc2 = _interopRequireDefault(_singleLoc);

var _locationGroup = __webpack_require__(3504);

var _locationGroup2 = _interopRequireDefault(_locationGroup);

var _DateGroup = __webpack_require__(3505);

var _DateGroup2 = _interopRequireDefault(_DateGroup);

var _NameGroup = __webpack_require__(3506);

var _NameGroup2 = _interopRequireDefault(_NameGroup);

var _templateGroupBox = __webpack_require__(3507);

var _templateGroupBox2 = _interopRequireDefault(_templateGroupBox);

var _pagination = __webpack_require__(870);

var _pagination2 = _interopRequireDefault(_pagination);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _editGroupDialog = __webpack_require__(3508);

var _editGroupDialog2 = _interopRequireDefault(_editGroupDialog);

var _searchFilter = __webpack_require__(3509);

var _searchFilter2 = _interopRequireDefault(_searchFilter);

var _materialUi = __webpack_require__(3);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _publishDraftDialog = __webpack_require__(1260);

var _publishDraftDialog2 = _interopRequireDefault(_publishDraftDialog);

var _zeroState = __webpack_require__(2002);

var _zeroState2 = _interopRequireDefault(_zeroState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var TemplateOrDraftList = function TemplateOrDraftList(_ref) {
  var route = _ref.route,
      locations = _ref.locations,
      templateGroups = _ref.templateGroups,
      templates = _ref.templates,
      allContractPeriods = _ref.allContractPeriods,
      currentYear = _ref.currentYear,
      statusesFilter = _ref.statusesFilter,
      saveNewTemplateName = _ref.saveNewTemplateName,
      drafts = _ref.drafts,
      isTourRunning = _ref.isTourRunning,
      router = _ref.router,
      deleteTemplate = _ref.deleteTemplate,
      archiveUnarchive = _ref.archiveUnarchive,
      updateTemplateProps = _ref.updateTemplateProps,
      deleteDraft = _ref.deleteDraft,
      updateDraftProps = _ref.updateDraftProps,
      _onExpandChange = _ref.onExpandChange,
      updateProps = _ref.updateProps,
      updateFilters = _ref.updateFilters,
      templateListPage = _ref.templateListPage,
      downloadPdfZip = _ref.downloadPdfZip,
      showType = _ref.showType,
      searchInput = _ref.searchInput,
      searchingAllYears = _ref.searchingAllYears,
      listRefreshing = _ref.listRefreshing,
      templatesLoaded = _ref.templatesLoaded;

  var isSingleLoc = !(locations && locations.filter(function (loc) {
    return loc.name;
  }).length > 1);
  // const currentPage = route === 'templates' ? templateListPage : draftListPage;
  // const currentDocs = route === 'templates' ? templates : drafts;
  var currentPage = templateListPage;

  var isDatesMatch = function isDatesMatch(doc) {
    return (0, _moment2.default)(doc.startDate).isBetween(currentYear.startDate, currentYear.endDate, 'day', '[]') || (0, _moment2.default)(doc.endDate).isBetween(currentYear.startDate, currentYear.endDate, 'day', '[]') || (0, _moment2.default)(doc.startDate).isBefore(currentYear.startDate, 'day') && (0, _moment2.default)(doc.endDate).isAfter(currentYear.endDate, 'day');
  };
  var currentDocs = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.sort(function (objA, objB) {
    if (objA.updatedAt > objB.updatedAt) return -1;
    return 1;
  }), _ramda2.default.filter(function (doc) {
    if (_ramda2.default.isEmpty(statusesFilter)) return !doc.isArchived;
    if (statusesFilter.indexOf('not sent') > -1 && doc.partnersCount === 0) return true;
    return statusesFilter.indexOf(doc.shownStatus) > -1;
  }), _ramda2.default.filter(function (doc) {
    if (searchingAllYears) return true;
    if (!currentYear || _ramda2.default.isEmpty(currentYear)) return true;
    return isDatesMatch(doc, currentYear);
  })), _ramda2.default.concat(templates, drafts));
  var actionFuncs = {
    saveNewTemplateName: saveNewTemplateName,
    deleteTemplate: deleteTemplate,
    updateTemplateProps: updateTemplateProps,
    deleteDraft: deleteDraft,
    updateProps: updateProps,
    updateDraftProps: updateDraftProps,
    router: router,
    archiveUnarchive: archiveUnarchive
  };
  var getContent = function getContent() {
    if (templatesLoaded && _ramda2.default.isEmpty(currentDocs)) {
      return _react2.default.createElement(_zeroState2.default, {
        softZero: !searchingAllYears || !_ramda2.default.isEmpty(statusesFilter),
        title: 'Welcome to the Rate Templates, where you can manage all of your static rates in one place.',
        buttonTitle: 'Start by creating a rate template',
        buttonList: [{
          label: 'Create a Rate Template',
          func: function func() {
            return router.push('/contracting/create-template-draft');
          }
        }, {
          label: 'Request a Demo',
          func: function func() {
            return window.open('https://app.hubspot.com/meetings/andrew157');
          }
        }],
        videoLink: 'https://vimeo.com/313071664'
      });
    }
    if (!showType) {
      var processedDocs = searchInput ? currentDocs.filter(_ramda2.default.compose(_ramda2.default.test(new RegExp(searchInput, 'i')), _ramda2.default.converge(_ramda2.default.concat, [function (doc) {
        return _ramda2.default.prop('templateName', doc) || _ramda2.default.prop('buyerCompanyName', doc) || _ramda2.default.propOr('', 'email', doc);
      }, _ramda2.default.propOr('', 'locationName')]))) : currentDocs;
      if (searchInput && isNilOrEmpty(processedDocs)) return _react2.default.createElement(
        'div',
        { style: { minHeight: '400px', fontSize: '24px', textAlign: 'center', margin: '50px' } },
        'There are no files that matches your search.'
      );
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_singleLoc2.default, _extends({
          route: route,
          router: router,
          showLocName: !isSingleLoc,
          docs: _ramda2.default.slice((currentPage - 1) * 20, currentPage * 20, processedDocs)
        }, actionFuncs)),
        _react2.default.createElement(_pagination2.default, {
          currentPage: currentPage,
          totalPages: Math.ceil(processedDocs.length / 20),
          goToPage: function goToPage(page) {
            return updateProps(_defineProperty({}, route === 'templates' ? 'templateListPage' : 'draftListPage', page));
          },
          noOfPagesToShow: 5
        })
      );
    }
    if (showType === 'location') {
      var processedLocs = searchInput ? locations.filter(_ramda2.default.compose(_ramda2.default.test(new RegExp(searchInput, 'i')), _ramda2.default.propOr('', 'name'))) : locations;
      if (searchInput && isNilOrEmpty(processedLocs)) return _react2.default.createElement(
        'div',
        { style: { minHeight: '400px', fontSize: '24px', textAlign: 'center', margin: '50px' } },
        'There are no files that matches your search.'
      );
      return _react2.default.createElement(
        'div',
        null,
        processedLocs.filter(function (loc) {
          var docs = _ramda2.default.filter(_ramda2.default.propEq('locationId', loc.locationId), currentDocs);
          return !_ramda2.default.isEmpty(docs);
        }).map(function (loc, locIndex) {
          var docs = _ramda2.default.filter(_ramda2.default.propEq('locationId', loc.locationId), currentDocs);
          return _react2.default.createElement(_locationGroup2.default, {
            key: locIndex,
            docs: docs,
            locationName: loc.name,
            expanded: isTourRunning && locIndex === 0 ? true : loc[route + 'Expanded'],
            onExpandChange: function onExpandChange() {
              return _onExpandChange(docs, loc.locationId, route + 'Expanded', loc[route + 'Expanded']);
            },
            actions: actionFuncs
          });
        })
      );
    }
    if (showType === 'date') {
      return _react2.default.createElement(
        'div',
        null,
        allContractPeriods.filter(function (_ref2) {
          var startDate = _ref2.startDate,
              endDate = _ref2.endDate;

          var docs = _ramda2.default.filter(function (doc) {
            return doc.startDate === startDate && doc.endDate === endDate;
          }, currentDocs);
          return !_ramda2.default.isEmpty(docs);
        }).map(function (_ref3, dateIndex) {
          var startDate = _ref3.startDate,
              endDate = _ref3.endDate;

          var docs = _ramda2.default.filter(function (doc) {
            return doc.startDate === startDate && doc.endDate === endDate;
          }, currentDocs);
          return _react2.default.createElement(_DateGroup2.default, {
            key: dateIndex,
            docs: docs,
            contractPeriod: { startDate: startDate, endDate: endDate },
            actions: actionFuncs
          });
        })
      );
    }
    if (showType === 'templateName') {
      var allTemplateNames = _ramda2.default.keys(_ramda2.default.groupBy(_ramda2.default.prop('templateName'), currentDocs));
      return _react2.default.createElement(
        'div',
        null,
        allTemplateNames.map(function (templateName, dateIndex) {
          var docs = _ramda2.default.filter(function (doc) {
            return doc.templateName === templateName;
          }, currentDocs);
          return _react2.default.createElement(_NameGroup2.default, {
            key: dateIndex,
            docs: docs,
            templateName: templateName,
            actions: actionFuncs
          });
        })
      );
    }
    if (showType === 'group') {
      var processedGroups = searchInput ? templateGroups.filter(_ramda2.default.compose(_ramda2.default.test(new RegExp(searchInput, 'i')), _ramda2.default.propOr('', 'groupName'))) : templateGroups;
      if (searchInput && isNilOrEmpty(processedGroups)) return _react2.default.createElement(
        'div',
        { style: { minHeight: '400px', fontSize: '24px', textAlign: 'center', margin: '50px' } },
        'There are no files that matches your search.'
      );
      return _react2.default.createElement(
        'div',
        null,
        !processedGroups.length ? _react2.default.createElement(
          'div',
          { style: { padding: '24px', textAlign: 'center', fontSize: '20px' } },
          'You haven\'t create any template groups.'
        ) : _react2.default.createElement('div', null),
        processedGroups.map(function (group, i) {
          var docs = _ramda2.default.filter(_ramda2.default.compose(_ramda2.default.contains(group._id), _ramda2.default.propOr([], 'templateGroups')), templates);
          return _react2.default.createElement(_templateGroupBox2.default, {
            key: i,
            router: router,
            allTemplates: _ramda2.default.filter(_ramda2.default.both(_ramda2.default.eqProps('startDate', group), _ramda2.default.eqProps('endDate', group)), templates),
            templateGroup: group,
            childrenLength: docs.length,
            updateProps: updateProps,
            docs: docs,
            downloadPdfZip: downloadPdfZip,
            expanded: isTourRunning && i === 0
          });
        }),
        _react2.default.createElement(_editGroupDialog2.default, { updateProps: updateProps })
      );
    }
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_searchFilter2.default, {
      route: route,
      updateFilters: function updateFilters(payload) {
        router.replace({
          pathname: '/contracting/template-list',
          query: _extends({
            showType: showType,
            searchInput: searchInput,
            statusesFilter: statusesFilter,
            searchingAllYears: searchingAllYears
          }, payload)
        });
      },
      updateProps: updateProps,
      showType: showType,
      searchInput: searchInput,
      isSingleLoc: isSingleLoc,
      allContractPeriods: allContractPeriods,
      statusesFilter: statusesFilter,
      currentDocs: currentDocs,
      templates: templates
    }),
    listRefreshing ? _react2.default.createElement(_materialUi.CircularProgress, { style: { marginLeft: '45%' } }) : _react2.default.createElement('span', null),
    getContent(),
    _react2.default.createElement(_publishDraftDialog2.default, null)
  );
};

exports.default = TemplateOrDraftList;

/***/ }),
/* 3503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(67);

var _aphrodite = __webpack_require__(123);

var _reactRouterRedux = __webpack_require__(27);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _cancelConfirmButtons = __webpack_require__(2028);

var _cancelConfirmButtons2 = _interopRequireDefault(_cancelConfirmButtons);

var _send = __webpack_require__(577);

var _send2 = _interopRequireDefault(_send);

var _archive = __webpack_require__(1142);

var _archive2 = _interopRequireDefault(_archive);

var _unarchive = __webpack_require__(2003);

var _unarchive2 = _interopRequireDefault(_unarchive);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _templateListActions = __webpack_require__(877);

var _contractingUtils = __webpack_require__(124);

var _templateStagedUpdatesTextFlag = __webpack_require__(1559);

var _templateStagedUpdatesTextFlag2 = _interopRequireDefault(_templateStagedUpdatesTextFlag);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getGenitiveCase = function getGenitiveCase(string) {
  if (!string) return string;
  if (string.slice(-1) === 's') return string + '\'';
  return string + '\'s';
};

var styles = _aphrodite.StyleSheet.create({
  container: {
    height: '56px',
    display: 'flex',
    paddingLeft: '16px',
    alignItems: 'center',
    cursor: 'pointer'
  },
  texts: { width: '66%', color: 'rgba(0, 0, 0, 0.77)', height: '56px', paddingTop: '5px' },
  companyName: {
    fontSize: '14px',
    color: '#00838f',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '90%'
  },
  locationName: { fontSize: '13px' },
  actions: {
    width: '20%',
    marginLeft: '1%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  commentsButton: { padding: '0', height: '24px', width: '24px', top: '4px' },
  yearNtimestamp: {
    color: 'rgba(0, 0, 0, 0.77)',
    flexDirection: 'column',
    textAlign: 'right',
    width: '10%'
  },
  comments: { marginLeft: '8px', width: '10%', cursor: 'pointer' }
});

var TemplateRow = function TemplateRow(_ref) {
  var style = _ref.style,
      isTemplate = _ref.isTemplate,
      template = _ref.template,
      viewTemplate = _ref.viewTemplate,
      viewPartners = _ref.viewPartners,
      updateTemplateProps = _ref.updateTemplateProps,
      deleteTemplate = _ref.deleteTemplate,
      archiveUnarchive = _ref.archiveUnarchive,
      saveNewTemplateName = _ref.saveNewTemplateName,
      doNotShowActionButtons = _ref.doNotShowActionButtons,
      showLocName = _ref.showLocName,
      downloadContractPdf = _ref.downloadContractPdf,
      companyName = _ref.companyName,
      openDialogSaveAsTemplate = _ref.openDialogSaveAsTemplate,
      push = _ref.push;
  var _id = template._id,
      partnersCount = template.partnersCount,
      templateHasDraft = template.templateHasDraft,
      templateName = template.templateName,
      _template$stagedUpdat = template.stagedUpdates,
      stagedUpdates = _template$stagedUpdat === undefined ? [] : _template$stagedUpdat,
      updateInitiated = template.updateInitiated,
      startDate = template.startDate,
      endDate = template.endDate,
      locationId = template.locationId,
      locationName = template.locationName;

  var showCancelConfirm = template.showDeleteConfirmButton || template.showEditNameConfirmButton;
  // if (!R.contains('read', template.access)) {
  //   return (
  //     <NoAccessRow
  //       locationName={locationName}
  //       templateName={templateName}
  //       doc={template}
  //       showLocName={showLocName}
  //       style={style}
  //     />
  //   );
  // }
  var goToSendAssets = function goToSendAssets() {
    return window.location = "https://app.tourconnect.com" + '/partner-management/send-assets?' + _queryString2.default.stringify({
      go_back_to: window.location.href,
      templateids: [template._id],
      message: 'Please find ' + getGenitiveCase(template.locationName === companyName ? template.locationName : template.locationName + ' - ' + companyName) + ' ' + (0, _moment2.default)(startDate).utc().format('DD MMM YYYY') + ' - ' + (0, _moment2.default)(endDate).utc().format('DD MMM YYYY') + ' rates below. We are using TourConnect as they provide several standardised download formats that should make it easy for you to read and load our rates.\n\nIf you have any questions please let me know and thank you for your support.',
      subject: getGenitiveCase(template.locationName === companyName ? template.locationName : template.locationName + ' - ' + companyName) + ' ' + (0, _moment2.default)(startDate).utc().get('year') + '-' + (0, _moment2.default)(endDate).utc().get('year') + ' Rates'
    }) + '&jwt=' + localStorage.getItem('jwt');
  };
  return _react2.default.createElement(
    _materialUi.TableRow,
    {
      className: 'templateRow',
      selectable: false,
      style: _extends({ overflow: 'visible' }, style)
    },
    _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        colSpan: '20',
        style: { padding: '0 0 0 16px', fontSize: '14px', color: '#00838f', cursor: 'pointer' }
      },
      _react2.default.createElement(
        'div',
        { onClick: viewTemplate },
        !template.showEditNameConfirmButton ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-description',
            color: 'rgba(0, 0, 0, 0.64)',
            style: { fontSize: '18px', top: '2px' }
          }),
          templateName,
          ' ',
          _react2.default.createElement(
            'span',
            { style: { color: 'rgba(0, 0, 0, 0.54)' } },
            !_ramda2.default.contains('write', template.access) ? '(READ-ONLY)' : ''
          )
        ) : _react2.default.createElement('input', {
          style: { height: '32px', width: '90%' },
          autoFocus: true,
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          value: template.newTemplateName,
          onChange: function onChange(_ref2) {
            var value = _ref2.target.value;
            return updateTemplateProps({ newTemplateName: value, errorText: '' });
          }
        }),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.locationName) },
          showLocName ? _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_materialUi.FontIcon, {
              className: 'tc-icon-location_on',
              color: 'rgba(0, 0, 0, 0.54)',
              style: { fontSize: '14px' }
            }),
            locationName,
            '\xA0'
          ) : _react2.default.createElement('span', null),
          function () {
            if (stagedUpdates.length) {
              return _react2.default.createElement(_templateStagedUpdatesTextFlag2.default, {
                stagedUpdates: stagedUpdates,
                updateInitiated: updateInitiated,
                isEditedTemplate: templateHasDraft,
                refreshSection: 'list'
              });
            }
            if (templateHasDraft) {
              return _react2.default.createElement(
                'span',
                { style: { marginLeft: '12px', color: 'red', zIndex: '200' } },
                'This template has a',
                ' ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    onClick: function onClick(e) {
                      return e.stopPropagation();
                    },
                    to: '/contracting/draft/' + template._id + '/details'
                  },
                  'draft'
                ),
                '.'
              );
            }
          }()
        )
      )
    ),
    !showCancelConfirm ? [_react2.default.createElement(
      _materialUi.TableRowColumn,
      { key: 'partners', colSpan: '3', style: { textAlign: 'center', padding: 0 } },
      isTemplate && _react2.default.createElement(_materialUi.FlatButton, {
        secondary: true,
        onTouchTap: viewPartners,
        className: 'partnersCount ' + (0, _aphrodite.css)(styles.comments),
        icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-users' }),
        label: '' + (partnersCount || 0)
      })
    ), _react2.default.createElement(
      _materialUi.TableRowColumn,
      { key: 'status', colSpan: '3', style: { textAlign: 'center', padding: 0 } },
      _react2.default.createElement(
        'div',
        { style: { color: (0, _contractingUtils.getTemplateStatusColor)(template.shownStatus), padding: 0 } },
        template.shownStatus
      )
    ), _react2.default.createElement(
      _materialUi.TableRowColumn,
      { key: 'period', colSpan: '3', style: { textAlign: 'center', padding: 0 } },
      new Date(template.startDate).getUTCFullYear() + '-' + new Date(template.endDate).getUTCFullYear()
    ), _react2.default.createElement(
      _materialUi.TableRowColumn,
      { key: 'timestamp', colSpan: '3', style: { textAlign: 'center', padding: 0 } },
      _react2.default.createElement(
        'span',
        { style: { fontSize: '11px', color: 'rgba(0, 0, 0, 0.45)' } },
        (0, _moment2.default)(template.updatedAt).calendar(null, {
          sameDay: '[Today]',
          lastDay: '[Yesterday]',
          lastWeek: '[Last] dddd',
          sameElse: 'DD/MM/YYYY'
        })
      )
    ), _react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        key: 'actions',
        colSpan: '4',
        style: {
          overflow: 'visible',
          textAlign: 'center',
          padding: 0,
          display: doNotShowActionButtons ? 'none' : ''
        }
      },
      _react2.default.createElement(
        'div',
        { style: { display: 'flex', alignItems: 'center' } },
        _react2.default.createElement(
          _materialUi.IconButton,
          {
            disabled: !isTemplate,
            tooltip: 'Download Template',
            tooltipPosition: 'top-right',
            onClick: function onClick(e) {
              return e.stopPropagation();
            },
            style: { padding: '0', width: '48px', height: '24px' },
            onTouchTap: function onTouchTap(e) {
              return downloadContractPdf(template._id, e.currentTarget);
            }
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-get_app', color: 'rgba(0, 0, 0, 0.54)' })
        ),
        _react2.default.createElement(
          _materialUi.IconButton,
          {
            disabled: !isTemplate,
            tooltip: 'Send Template',
            tooltipPosition: 'top-right',
            onClick: function onClick(e) {
              return e.stopPropagation();
            },
            style: { padding: '0', width: '36px', height: '24px' },
            onTouchTap: goToSendAssets
          },
          _react2.default.createElement(_send2.default, { color: 'rgba(0, 0, 0, 0.54)' })
        ),
        _react2.default.createElement(
          _materialUi.IconMenu,
          {
            iconButtonElement: _react2.default.createElement(_materialUi.IconButton, {
              iconClassName: 'tc-icon-more-vert',
              iconStyle: { color: 'rgba(0, 0, 0, 0.54)', top: '2px' },
              style: { padding: '0', width: '24px', height: '24px' }
            })
          },
          _react2.default.createElement(_materialUi.MenuItem, {
            leftIcon: _react2.default.createElement(_materialUi.FontIcon, {
              className: 'tc-icon-delete2',
              color: Boolean(partnersCount) ? '#e0e0e0' : 'red'
            }),
            primaryText: 'Delete Template',
            disabled: Boolean(partnersCount),
            onTouchTap: function onTouchTap() {
              return updateTemplateProps({ showDeleteConfirmButton: true });
            }
          }),
          isTemplate && _react2.default.createElement(_materialUi.MenuItem, {
            leftIcon: template.isArchived ? _react2.default.createElement(_unarchive2.default, null) : _react2.default.createElement(_archive2.default, null),
            primaryText: template.isArchived ? 'Unarchive Template' : 'Archive Template',
            onTouchTap: archiveUnarchive
          }),
          _react2.default.createElement(_materialUi.MenuItem, {
            leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-mode_edit', color: '#00bcd4' }),
            primaryText: 'Edit Template Name',
            onTouchTap: function onTouchTap() {
              return updateTemplateProps({
                showEditNameConfirmButton: true,
                newTemplateName: template.templateName
              });
            }
          }),
          isTemplate && _react2.default.createElement(
            _wrapper2.default,
            { amazonOrange: true },
            _react2.default.createElement(_materialUi.MenuItem, {
              leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-swap_horiz', color: '#00bcd4' }),
              primaryText: 'Compare Templates',
              onTouchTap: function onTouchTap() {
                return push('/contracting/reports/diff/template/' + _id + '?locationId=' + locationId + '&locationName=' + locationName);
              }
            })
          ),
          isTemplate && _react2.default.createElement(_materialUi.MenuItem, {
            leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-content_copy', color: '#00bcd4' }),
            primaryText: 'Make a copy',
            onTouchTap: function onTouchTap() {
              return openDialogSaveAsTemplate(_id, { startDate: startDate, endDate: endDate });
            }
          })
        )
      )
    )] : [_react2.default.createElement(
      _materialUi.TableRowColumn,
      {
        key: 'errorText',
        colSpan: '6',
        style: { color: 'red', padding: 0, whiteSpace: 'pre-wrap' }
      },
      template.errorText
    ), _react2.default.createElement(
      _materialUi.TableRowColumn,
      { key: 'editState', colSpan: '10', style: { padding: 0 } },
      _react2.default.createElement(_cancelConfirmButtons2.default, {
        callingApi: template.savingName,
        disableConfirmBtn: Boolean(template.showEditNameConfirmButton && (!template.newTemplateName || !template.newTemplateName.trim() || template.newTemplateName === template.templateName || template.errorText)),
        forDelete: template.showDeleteConfirmButton,
        confirmLabel: template.showDeleteConfirmButton ? 'Yes, Delete' : 'Confirm Change',
        cancelLabel: 'Nevermind',
        cancelFn: function cancelFn() {
          return updateTemplateProps({
            showDeleteConfirmButton: false,
            errorText: '',
            showEditNameConfirmButton: false,
            newTemplateName: ''
          });
        },
        confirmFn: template.showDeleteConfirmButton ? deleteTemplate : function () {
          return saveNewTemplateName(template.newTemplateName);
        }
      })
    )]
  );
};

TemplateRow.propTypes = {
  companyName: _react.PropTypes.string,
  isAccom: _react.PropTypes.bool,
  template: _react.PropTypes.object,
  actions: _react.PropTypes.object,
  apiUrl: _react.PropTypes.string,
  resourceType: _react.PropTypes.string,
  showFolder: _react.PropTypes.bool,
  updateProps: _react.PropTypes.func,
  hoveringOverContractId: _react.PropTypes.string,
  downloadContractPdf: _react.PropTypes.func,
  push: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var user = _ref3.user;
  return {
    companyName: user.getIn(['company', 'companyName'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  push: _reactRouterRedux.push,
  downloadContractPdf: _templateListActions.downloadContractPdf,
  openDialogSaveAsTemplate: function openDialogSaveAsTemplate(contractId, contractYear) {
    return { type: 'OPEN_AS_SAVE_CONTRACT_AS_TEMPLATE', payload: { contractId: contractId, contractYear: contractYear } };
  }
})(TemplateRow);

/***/ }),
/* 3504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _singleLoc = __webpack_require__(1143);

var _singleLoc2 = _interopRequireDefault(_singleLoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  locationName: _react2.default.PropTypes.string,
  docs: _react2.default.PropTypes.array,
  onExpandChange: _react2.default.PropTypes.func,
  expanded: _react2.default.PropTypes.bool,
  templateLength: _react2.default.PropTypes.number,
  draftLength: _react2.default.PropTypes.number,
  actions: _react2.default.PropTypes.object
};

var LocationGroup = function LocationGroup(_ref) {
  var locationName = _ref.locationName,
      docs = _ref.docs,
      onExpandChange = _ref.onExpandChange,
      expanded = _ref.expanded,
      actions = _ref.actions;

  if (_ramda2.default.isEmpty(docs)) return _react2.default.createElement('div', null);
  return _react2.default.createElement(
    _materialUi.Card,
    { onExpandChange: onExpandChange, expanded: expanded, style: { boxShadow: 'none', borderBottom: '1px solid #e0e0e0' } },
    _react2.default.createElement(_materialUi.CardHeader, {
      title: _react2.default.createElement(
        'div',
        { style: { color: 'rgba(0, 0, 0, 0.64)' } },
        _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-location_on', color: 'rgba(0, 0, 0, 0.64)' }),
        locationName
      ),
      subtitle: _react2.default.createElement(
        'div',
        { style: { paddingLeft: '30px' } },
        docs.length,
        ' ',
        (0, _pluralize2.default)('template', docs.length)
      ),
      style: { padding: '8px 16px' },
      actAsExpander: true,
      showExpandableButton: true
    }),
    _react2.default.createElement(
      _materialUi.CardText,
      {
        expandable: true,
        style: { paddingTop: '0px' }
      },
      _react2.default.createElement(_singleLoc2.default, _extends({
        docs: docs,
        showLocName: false
      }, actions))
    )
  );
};
LocationGroup.propTypes = propTypes;
exports.default = LocationGroup;

/***/ }),
/* 3505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _singleLoc = __webpack_require__(1143);

var _singleLoc2 = _interopRequireDefault(_singleLoc);

var _today = __webpack_require__(2029);

var _today2 = _interopRequireDefault(_today);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  dateString: _react2.default.PropTypes.string,
  docs: _react2.default.PropTypes.array,
  onExpandChange: _react2.default.PropTypes.func,
  expanded: _react2.default.PropTypes.bool,
  templateLength: _react2.default.PropTypes.number,
  draftLength: _react2.default.PropTypes.number,
  actions: _react2.default.PropTypes.object
};

var DateGroup = function DateGroup(_ref) {
  var contractPeriod = _ref.contractPeriod,
      docs = _ref.docs,
      onExpandChange = _ref.onExpandChange,
      expanded = _ref.expanded,
      actions = _ref.actions;

  if (_ramda2.default.isEmpty(docs)) return _react2.default.createElement('div', null);
  return _react2.default.createElement(
    _materialUi.Card,
    { onExpandChange: onExpandChange, expanded: expanded, style: { boxShadow: 'none', borderBottom: '1px solid #e0e0e0' } },
    _react2.default.createElement(_materialUi.CardHeader, {
      title: _react2.default.createElement(
        'div',
        { style: { color: 'rgba(0, 0, 0, 0.64)' }, className: 'flex-center' },
        _react2.default.createElement(_today2.default, { color: 'rgba(0, 0, 0, 0.64)' }),
        '\xA0',
        _moment2.default.utc(contractPeriod.startDate).format('D MMM YYYY'),
        '-',
        _moment2.default.utc(contractPeriod.endDate).format('D MMM YYYY')
      ),
      subtitle: _react2.default.createElement(
        'div',
        { style: { paddingLeft: '30px' } },
        docs.length,
        ' ',
        (0, _pluralize2.default)('template', docs.length)
      ),
      style: { padding: '8px 16px' },
      actAsExpander: true,
      showExpandableButton: true
    }),
    _react2.default.createElement(
      _materialUi.CardText,
      {
        expandable: true,
        style: { paddingTop: '0px' }
      },
      _react2.default.createElement(_singleLoc2.default, _extends({
        docs: docs,
        showLocName: true
      }, actions))
    )
  );
};
DateGroup.propTypes = propTypes;
exports.default = DateGroup;

/***/ }),
/* 3506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _singleLoc = __webpack_require__(1143);

var _singleLoc2 = _interopRequireDefault(_singleLoc);

var _fontDownload = __webpack_require__(2030);

var _fontDownload2 = _interopRequireDefault(_fontDownload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  templateName: _react2.default.PropTypes.string,
  docs: _react2.default.PropTypes.array,
  onExpandChange: _react2.default.PropTypes.func,
  expanded: _react2.default.PropTypes.bool,
  templateLength: _react2.default.PropTypes.number,
  draftLength: _react2.default.PropTypes.number,
  actions: _react2.default.PropTypes.object
};

var TemplateNameGroup = function TemplateNameGroup(_ref) {
  var templateName = _ref.templateName,
      docs = _ref.docs,
      onExpandChange = _ref.onExpandChange,
      expanded = _ref.expanded,
      actions = _ref.actions;

  if (_ramda2.default.isEmpty(docs)) return _react2.default.createElement('div', null);
  return _react2.default.createElement(
    _materialUi.Card,
    { onExpandChange: onExpandChange, expanded: expanded, style: { boxShadow: 'none', borderBottom: '1px solid #e0e0e0' } },
    _react2.default.createElement(_materialUi.CardHeader, {
      title: _react2.default.createElement(
        'div',
        { style: { color: 'rgba(0, 0, 0, 0.64)' }, className: 'flex-center' },
        _react2.default.createElement(_fontDownload2.default, { color: 'rgba(0, 0, 0, 0.64)' }),
        ' \xA0',
        templateName
      ),
      subtitle: _react2.default.createElement(
        'div',
        { style: { paddingLeft: '30px' } },
        docs.length,
        ' ',
        (0, _pluralize2.default)('template', docs.length)
      ),
      style: { padding: '8px 16px' },
      actAsExpander: true,
      showExpandableButton: true
    }),
    _react2.default.createElement(
      _materialUi.CardText,
      {
        style: { paddingTop: '0px' },
        expandable: true
      },
      _react2.default.createElement(_singleLoc2.default, _extends({
        docs: docs,
        showLocName: true
      }, actions))
    )
  );
};
TemplateNameGroup.propTypes = propTypes;
exports.default = TemplateNameGroup;

/***/ }),
/* 3507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _singleLoc = __webpack_require__(1143);

var _singleLoc2 = _interopRequireDefault(_singleLoc);

var _link = __webpack_require__(1254);

var _link2 = _interopRequireDefault(_link);

var _send = __webpack_require__(577);

var _send2 = _interopRequireDefault(_send);

var _getApp = __webpack_require__(1558);

var _getApp2 = _interopRequireDefault(_getApp);

var _templateListActions = __webpack_require__(877);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _aphrodite = __webpack_require__(123);

var _aphrodite2 = _interopRequireDefault(_aphrodite);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = _aphrodite2.default.StyleSheet.create({
  container: { height: '56px', display: 'flex', paddingLeft: '16px', alignItems: 'center', width: '93%' },
  texts: { width: '75%', color: 'rgba(0, 0, 0, 0.77)', cursor: 'pointer' },
  companyName: { fontSize: '14px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', width: '90%', display: 'flex', alignItems: 'center' },
  locationName: { fontSize: '13px', marginLeft: '28px', color: '#00bcd4' },
  actions: { width: '20%', marginLeft: '1%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  commentsButton: { padding: '0', height: '24px', width: '24px', top: '4px' },
  yearNtimestamp: { color: 'rgba(0, 0, 0, 0.77)', flexDirection: 'column', textAlign: 'right', width: '10%' },
  comments: { display: 'inline-block', marginLeft: '8px', width: '10%', cursor: 'pointer' }
});
var getGenitiveCase = function getGenitiveCase(string) {
  if (!string) return string;
  if (string.slice(-1) === 's') return string + '\'';
  return string + '\'s';
};

var TemplateGroupBox = function (_React$Component) {
  _inherits(TemplateGroupBox, _React$Component);

  function TemplateGroupBox(props) {
    _classCallCheck(this, TemplateGroupBox);

    var _this = _possibleConstructorReturn(this, (TemplateGroupBox.__proto__ || Object.getPrototypeOf(TemplateGroupBox)).call(this, props));

    _this.goToSendAssets = function () {
      var _this$props = _this.props,
          companyName = _this$props.companyName,
          templateGroup = _this$props.templateGroup;

      window.location = "https://app.tourconnect.com" + '/partner-management/send-assets?' + _queryString2.default.stringify({
        go_back_to: window.location.href,
        templategroupid: [templateGroup._id],
        message: 'Please find ' + getGenitiveCase(companyName) + ' ' + (0, _moment2.default)(templateGroup.startDate).utc().format('DD MMM YYYY') + ' - ' + (0, _moment2.default)(templateGroup.endDate).utc().format('DD MMM YYYY') + ' rates below. We are using TourConnect as they provide several standardised download formats that should make it easy for you to read and load our rates.\n\nIf you have any questions please let me know and thank you for your support.',
        subject: companyName + ' ' + (0, _moment2.default)(templateGroup.startDate).utc().get('year') + '-' + (0, _moment2.default)(templateGroup.endDate).utc().get('year') + ' Rates'
      }) + '&jwt=' + localStorage.getItem('jwt');
    };

    _this.state = {
      showPartners: false,
      expanded: props.expanded || false
    };
    return _this;
  }

  _createClass(TemplateGroupBox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.expanded !== nextProps.expanded) {
        this.setState({ expanded: nextProps.expanded });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          templateGroup = _props.templateGroup,
          docs = _props.docs,
          allTemplates = _props.allTemplates,
          onExpandChange = _props.onExpandChange,
          router = _props.router,
          updateProps = _props.updateProps,
          downloadPdfZip = _props.downloadPdfZip,
          editTemplateGroup = _props.editTemplateGroup;
      var _state = this.state,
          expanded = _state.expanded,
          showPartners = _state.showPartners;

      return _react2.default.createElement(
        _materialUi.Card,
        {
          onExpandChange: function onExpandChange() {
            return _this2.setState({ expanded: !expanded });
          },
          expanded: expanded,
          style: { boxShadow: 'none', borderBottom: '1px solid #e0e0e0' }
        },
        _react2.default.createElement(
          _materialUi.CardHeader,
          {
            style: { padding: '6px' },
            textStyle: { display: 'none' },
            showExpandableButton: true
          },
          _react2.default.createElement(
            'div',
            { className: _aphrodite2.default.css(styles.container) },
            _react2.default.createElement(
              'div',
              { className: _aphrodite2.default.css(styles.texts), onClick: function onClick() {
                  return _this2.setState({ expanded: !expanded });
                } },
              _react2.default.createElement(
                'div',
                { className: _aphrodite2.default.css(styles.companyName) },
                _react2.default.createElement(_link2.default, { color: 'rgba(0, 0, 0, 0.65)', style: { marginRight: '4px' } }),
                templateGroup.groupName
              ),
              _react2.default.createElement(
                'div',
                { className: _aphrodite2.default.css(styles.locationName) },
                docs.length + ' ' + (0, _pluralize2.default)('template', docs.length)
              )
            ),
            _react2.default.createElement(_materialUi.FlatButton, {
              secondary: true,
              className: _aphrodite2.default.css(styles.comments),
              onTouchTap: function onTouchTap() {
                return _this2.setState({ showPartners: true });
              },
              icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-users' }),
              label: '' + _ramda2.default.pathOr(0, ['sentPartners', 'length'], templateGroup)
            }),
            _react2.default.createElement(
              'div',
              { className: _aphrodite2.default.css(styles.yearNtimestamp) },
              (0, _moment2.default)(templateGroup.startDate).get('year'),
              ' - ',
              (0, _moment2.default)(templateGroup.endDate).get('year')
            ),
            _react2.default.createElement(
              _materialUi.IconButton,
              {
                tooltip: 'Download All',
                tooltipPosition: 'top-right',
                onClick: function onClick(e) {
                  return e.stopPropagation();
                },
                style: { padding: '0', width: '36px', height: '24px' },
                onTouchTap: function onTouchTap() {
                  return downloadPdfZip(_ramda2.default.map(_ramda2.default.pick(['_id', 'templateName', 'locationName']), docs), templateGroup.groupName);
                }
              },
              _react2.default.createElement(_getApp2.default, { color: 'rgba(0, 0, 0, 0.54)' })
            ),
            _react2.default.createElement(
              _materialUi.IconButton,
              {
                tooltip: 'Send Template Group',
                tooltipPosition: 'top-right',
                onClick: function onClick(e) {
                  return e.stopPropagation();
                },
                style: { padding: '0', width: '36px', height: '24px' },
                onTouchTap: this.goToSendAssets
              },
              _react2.default.createElement(_send2.default, { color: 'rgba(0, 0, 0, 0.54)' })
            ),
            _react2.default.createElement(
              _materialUi.IconMenu,
              {
                iconButtonElement: _react2.default.createElement(_materialUi.IconButton, {
                  iconClassName: 'tc-icon-more_vert',
                  iconStyle: { color: 'rgba(0, 0, 0, 0.54)' },
                  style: { padding: '0', width: '36px', height: '24px' },
                  tooltip: 'More Actions'
                })
              },
              _react2.default.createElement(_materialUi.MenuItem, {
                leftIcon: _react2.default.createElement(_materialUi.FontIcon, {
                  className: 'tc-icon-mode_edit',
                  color: '#00bcd4'
                }),
                primaryText: 'Edit Template Group',
                tooltipPosition: 'top-right',
                onTouchTap: function onTouchTap() {
                  return updateProps({
                    editGroupName: templateGroup.groupName,
                    editGroupId: templateGroup._id,
                    selectedTemplatesForGroup: docs,
                    editDialogOpen: true,
                    groupWizardTemplates: allTemplates
                  });
                }
              }),
              _react2.default.createElement(_materialUi.MenuItem, {
                leftIcon: _react2.default.createElement(_materialUi.FontIcon, {
                  className: 'tc-icon-delete2',
                  color: '#ff4081'
                }),
                primaryText: 'Delete Template Group',
                tooltipPosition: 'top-right',
                onTouchTap: function onTouchTap() {
                  return editTemplateGroup({
                    groupId: templateGroup._id,
                    isArchived: true
                  });
                }
              })
            )
          )
        ),
        _react2.default.createElement(
          _materialUi.CardText,
          {
            expandable: true,
            style: { paddingTop: '0px' }
          },
          _react2.default.createElement(_singleLoc2.default, {
            docs: docs,
            router: router,
            showLocName: true,
            doNotShowActionButtons: true
          })
        ),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            autoScrollBodyContent: true,
            open: showPartners,
            titleStyle: { padding: '8px 16px' },
            title: _react2.default.createElement(
              'div',
              { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
              _react2.default.createElement(
                'div',
                null,
                templateGroup.groupName + ' - Partner List'
              ),
              _react2.default.createElement(_materialUi.IconButton, {
                iconClassName: 'tc-icon-close',
                iconStyle: { color: 'red', fontSize: '32px' },
                onTouchTap: function onTouchTap() {
                  return _this2.setState({ showPartners: false });
                }
              })
            ),
            onRequestClose: function onRequestClose() {
              return _this2.setState({ showPartners: false });
            },
            bodyStyle: { padding: '2px 24px 24px' },
            modal: true
          },
          _ramda2.default.pathOr(0, ['sentPartners', 'length'], templateGroup) ? _react2.default.createElement(
            _materialUi.Table,
            null,
            _react2.default.createElement(
              _materialUi.TableHeader,
              { displaySelectAll: false, adjustForCheckbox: false },
              _react2.default.createElement(
                _materialUi.TableRow,
                null,
                _react2.default.createElement(
                  _materialUi.TableHeaderColumn,
                  null,
                  'Buyer Company Name'
                ),
                _react2.default.createElement(
                  _materialUi.TableHeaderColumn,
                  null,
                  'Email'
                ),
                _react2.default.createElement(
                  _materialUi.TableHeaderColumn,
                  null,
                  'Issued On'
                )
              )
            ),
            _react2.default.createElement(
              _materialUi.TableBody,
              { displayRowCheckbox: false },
              _ramda2.default.propOr([], 'sentPartners', templateGroup).map(function (_ref, i) {
                var buyerCompanyName = _ref.buyerCompanyName,
                    email = _ref.email,
                    createdAt = _ref.createdAt;
                return _react2.default.createElement(
                  _materialUi.TableRow,
                  { key: i },
                  _react2.default.createElement(
                    _materialUi.TableRowColumn,
                    null,
                    buyerCompanyName
                  ),
                  _react2.default.createElement(
                    _materialUi.TableRowColumn,
                    null,
                    !email ? 'via TourConnect' : email
                  ),
                  _react2.default.createElement(
                    _materialUi.TableRowColumn,
                    null,
                    (0, _moment2.default)(createdAt).calendar(null, {
                      sameDay: '[Today]',
                      lastDay: '[Yesterday]',
                      lastWeek: '[Last] dddd',
                      sameElse: 'DD/MM/YYYY'
                    })
                  )
                );
              })
            )
          ) : _react2.default.createElement(
            'div',
            { style: { padding: '32px 16px' } },
            'This template group hasn\'t been sent to any partners yet.'
          )
        )
      );
    }
  }]);

  return TemplateGroupBox;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
  var user = _ref2.user;
  return {
    companyName: user.getIn(['company', 'companyName'])
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { editTemplateGroup: _templateListActions.editTemplateGroup })(TemplateGroupBox);

/***/ }),
/* 3508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _stepTwoTemplates = __webpack_require__(2031);

var _stepTwoTemplates2 = _interopRequireDefault(_stepTwoTemplates);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _templateListActions = __webpack_require__(877);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var EditGroupDialog = function EditGroupDialog(_ref) {
  var editDialogOpen = _ref.editDialogOpen,
      editGroupName = _ref.editGroupName,
      editGroup = _ref.editGroup,
      editGroupError = _ref.editGroupError,
      editGroupId = _ref.editGroupId,
      selectedTemplatesForGroup = _ref.selectedTemplatesForGroup,
      groupWizardTemplates = _ref.groupWizardTemplates,
      updateProps = _ref.updateProps,
      proceedEditing = _ref.proceedEditing;

  var closeDialog = function closeDialog() {
    return updateProps({
      editGroupName: '',
      editGroupId: '',
      editGroupStartDate: '',
      editGroupEndDate: '',
      selectedTemplatesForGroup: [],
      editDialogOpen: false,
      editGroupError: '',
      updatingGroup: false,
      groupUpdated: false,
      proceedEditing: false,
      groupWizardTemplates: []
    });
  };
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: editDialogOpen,
      autoScrollBodyContent: true,
      onRequestClose: closeDialog,
      titleStyle: { padding: '8px 16px' },
      actions: [_react2.default.createElement(
        'div',
        { key: 'error', style: { color: 'red' } },
        editGroupError
      ), _react2.default.createElement(_flatButtonWithLoader2.default, {
        key: 'cancel',
        label: 'Cancel',
        onTouchTap: closeDialog
      }), proceedEditing ? _react2.default.createElement(_flatButtonWithLoader2.default, {
        key: 'save',
        secondary: true,
        label: 'Save',
        onTouchTap: function onTouchTap() {
          if (!editGroupName) {
            updateProps({ editGroupError: 'Group Name cannot be empty.' });
            (0, _lodash2.default)(function () {
              return updateProps({ editGroupError: '' });
            }, 4000)();
          } else if (isNilOrEmpty(selectedTemplatesForGroup)) {
            updateProps({ editGroupError: 'Please include at least one template in this group.' });
            (0, _lodash2.default)(function () {
              return updateProps({ editGroupError: '' });
            }, 4000)();
          } else editGroup({ groupId: editGroupId, newGroupName: editGroupName, templates: selectedTemplatesForGroup });
        }
      }) : _react2.default.createElement(_materialUi.RaisedButton, {
        key: 'save',
        secondary: true,
        labelStyle: { textTransform: 'none' },
        label: 'Okay, Edit Group',
        onTouchTap: function onTouchTap() {
          return updateProps({ proceedEditing: true });
        }
      })],
      title: proceedEditing ? _react2.default.createElement(
        'div',
        { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
        _react2.default.createElement(
          'div',
          null,
          'Edit\xA0',
          _react2.default.createElement(
            'i',
            null,
            '' + editGroupName
          )
        ),
        _react2.default.createElement(_materialUi.IconButton, {
          iconClassName: 'tc-icon-close',
          iconStyle: { color: 'red', fontSize: '32px' },
          onTouchTap: closeDialog
        })
      ) : 'Please read this message before you continue'
    },
    proceedEditing ? _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_materialUi.TextField, {
        floatingLabelText: 'Group Name',
        value: editGroupName,
        onChange: function onChange(_, val) {
          return updateProps({ editGroupName: val });
        }
      }),
      _react2.default.createElement(_stepTwoTemplates2.default, {
        templates: groupWizardTemplates,
        updateProps: updateProps,
        selectedTemplatesForGroup: selectedTemplatesForGroup
      })
    ) : _react2.default.createElement(
      'div',
      { style: { padding: '32px' } },
      'We allow you to edit your template group name, and add or remove templates within that group. This will only affect any future contracts that you send, and it will not affect any contracts that you have already issued. If you need to send a new template to your partners, you can do that individually.'
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting,
      user = _ref2.user;
  return {
    editGroupName: contracting.templateList.get('editGroupName'),
    editGroupError: contracting.templateList.get('editGroupError'),
    editGroupId: contracting.templateList.get('editGroupId'),
    selectedTemplatesForGroup: contracting.templateList.get('selectedTemplatesForGroup').toJS(),
    groupWizardTemplates: contracting.templateList.get('groupWizardTemplates').toJS(),
    editDialogOpen: contracting.templateList.get('editDialogOpen'),
    proceedEditing: contracting.templateList.get('proceedEditing')
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    editGroup: function editGroup() {
      return dispatch(_templateListActions.editTemplateGroup.apply(undefined, arguments));
    }
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EditGroupDialog);

/***/ }),
/* 3509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _smallButtons = __webpack_require__(94);

var _flatDropDownMenu = __webpack_require__(494);

var _flatDropDownMenu2 = _interopRequireDefault(_flatDropDownMenu);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _aphrodite = __webpack_require__(123);

var _aphrodite2 = _interopRequireDefault(_aphrodite);

var _link = __webpack_require__(1254);

var _link2 = _interopRequireDefault(_link);

var _today = __webpack_require__(2029);

var _today2 = _interopRequireDefault(_today);

var _fontDownload = __webpack_require__(2030);

var _fontDownload2 = _interopRequireDefault(_fontDownload);

var _contractingUtils = __webpack_require__(124);

var _titlecase = __webpack_require__(549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchAndFilter = function SearchAndFilter(_ref) {
  var route = _ref.route,
      updateFilters = _ref.updateFilters,
      showType = _ref.showType,
      searchInput = _ref.searchInput,
      isSingleLoc = _ref.isSingleLoc,
      statusesFilter = _ref.statusesFilter,
      updateProps = _ref.updateProps;

  var search = function search() {
    return updateFilters({
      searchInput: searchInput,
      templateListPage: 1,
      draftListPage: 1
    });
  };
  var styleSheets = _aphrodite2.default.StyleSheet.create({
    containerDiv: { borderBottom: '1px solid rgba(0, 0, 0, 0.1)', backgroundColor: 'rgba(0, 0, 0, 0.05)', display: 'flex', flexDirection: 'column', paddingRight: '4px' },
    searchNStatusFilterNButtonsContainerDiv: { display: 'flex', height: '51px' },
    searchDiv: { border: '1px solid #00bcd4', width: '85%', marginLeft: '2%', display: 'flex', borderRadius: '2px', height: '34px', top: '10px', position: 'relative', justifyContent: 'space-between', backgroundColor: 'white' },
    closeIconButton: { padding: '0', height: '34px', top: '4px', display: searchInput ? 'inline-block' : 'none' },
    buttonsDiv: { display: 'flex', height: '36px', position: 'relative', top: '8px', minWidth: '240px', flexDirection: 'row-reverse' }
  });
  return _react2.default.createElement(
    'div',
    { className: _aphrodite2.default.css(styleSheets.containerDiv) },
    _react2.default.createElement(
      'div',
      { className: _aphrodite2.default.css(styleSheets.searchNStatusFilterNButtonsContainerDiv) },
      _react2.default.createElement(
        'div',
        { className: _aphrodite2.default.css(styleSheets.searchDiv) },
        _react2.default.createElement(
          _flatDropDownMenu2.default,
          {
            desktop: true,
            style: { marginLeft: '8px', cursor: 'pointer' },
            button: _react2.default.createElement(_smallButtons.JiraFlatButton, {
              style: { fontSize: '14px', padding: '0', width: '140px', height: '32px' },
              icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-arrow-drop-down', color: 'rgba(0, 0, 0, 0.75)', style: { fontSize: '20px' } }),
              labelPosition: 'before',
              label: function () {
                if (!showType) return (0, _titlecase.toLaxTitleCase)(route);
                if (route === 'templates' && showType === 'group') return 'Template Groups';
                if (showType === 'location') return 'Locations';
                if (showType === 'date') return 'Contract Period';
                if (showType === 'templateName') return 'Template Name';
              }()
            })
          },
          _react2.default.createElement(_materialUi.MenuItem, {
            style: { color: !showType ? '#ff4081' : '' },
            primaryText: 'Templates',
            leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-' + (route === 'drafts' ? 'receipt' : 'description') }),
            onTouchTap: function onTouchTap() {
              return updateFilters({ showType: undefined, searchInput: '' });
            }
          }),
          _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Group By', disabled: true }),
          _react2.default.createElement(_materialUi.MenuItem, {
            style: { color: showType === 'group' ? '#ff4081' : '' },
            primaryText: 'Template Groups',
            leftIcon: _react2.default.createElement(_link2.default, null),
            onTouchTap: function onTouchTap() {
              return updateFilters({ showType: 'group', searchInput: '' });
            }
          }),
          !isSingleLoc && _react2.default.createElement(_materialUi.MenuItem, {
            style: { color: showType === 'location' ? '#ff4081' : '' },
            primaryText: 'Locations',
            leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-location_on' }),
            onTouchTap: function onTouchTap() {
              return updateFilters({ showType: 'location', searchInput: '' });
            }
          }),
          _react2.default.createElement(_materialUi.MenuItem, {
            style: { color: showType === 'templateName' ? '#ff4081' : '' },
            primaryText: 'Template Name',
            leftIcon: _react2.default.createElement(_fontDownload2.default, null),
            onTouchTap: function onTouchTap() {
              return updateFilters({ showType: 'templateName', searchInput: '' });
            }
          }),
          _react2.default.createElement(_materialUi.MenuItem, {
            style: { color: showType === 'date' ? '#ff4081' : '' },
            primaryText: 'Contract Period',
            leftIcon: _react2.default.createElement(_today2.default, null),
            onTouchTap: function onTouchTap() {
              return updateFilters({ showType: 'date', searchInput: '' });
            }
          })
        ),
        _react2.default.createElement(_materialUi.TextField, {
          hintText: _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('location'), _ramda2.default.always('Search by Location Name...')], [_ramda2.default.equals('group'), _ramda2.default.always('Search by Group Name...')], [_ramda2.default.T, _ramda2.default.always('Search by Template Name ' + (isSingleLoc ? '' : ', Location Name') + '...')]]), showType),
          inputStyle: { bottom: '2px' },
          value: searchInput || '',
          style: { width: searchInput ? '60%' : '67%', height: '35px', marginLeft: '8px' },
          hintStyle: { bottom: '6px', fontSize: '13px' },
          underlineShow: false,
          onKeyDown: function onKeyDown(e) {
            if (e.keyCode === 13) search();
          },
          onChange: function onChange(_, value) {
            return updateFilters({ searchInput: value });
          }
        }),
        _react2.default.createElement(_materialUi.IconButton, {
          iconClassName: 'tc-icon-close',
          iconStyle: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px' },
          className: _aphrodite2.default.css(styleSheets.closeIconButton),
          onTouchTap: function onTouchTap() {
            return updateFilters({ searchInput: '', templateListPage: 1, draftListPage: 1 });
          }
        }),
        _react2.default.createElement(_materialUi.RaisedButton, {
          label: 'Search',
          style: { height: '32px', minWidth: '82px', width: '82px' },
          overlayStyle: { height: '32px' },
          buttonStyle: { height: '32px', lineHeight: '32px' },
          secondary: true,
          onTouchTap: search
        })
      ),
      _react2.default.createElement(
        _materialUi.DropDownMenu,
        { autoWidth: true, value: 'Template Statuses', underlineStyle: { borderTopColor: '#00bcd4' }, iconStyle: { fill: '#00bcd4' }, style: { top: '-4px' } },
        ['new draft', 'draft', 'completed', 'archived', 'not sent'].map(function (status, i) {
          var foundIndex = _ramda2.default.findIndex(_ramda2.default.equals(status), statusesFilter);
          return _react2.default.createElement(_materialUi.MenuItem, {
            key: i,
            value: status,
            checked: Boolean(foundIndex > -1),
            onTouchTap: function onTouchTap() {
              var newStatuses = foundIndex > -1 ? _ramda2.default.remove(foundIndex, 1, statusesFilter) : _ramda2.default.append(status, statusesFilter);
              updateFilters({ statusesFilter: newStatuses });
            },
            style: { color: (0, _contractingUtils.getTemplateStatusColor)(status) },
            primaryText: status
          });
        }),
        _react2.default.createElement(_materialUi.MenuItem, { value: 'Template Statuses', label: 'Template Statuses', style: { display: 'none' } })
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { paddingBottom: '8px', display: statusesFilter && statusesFilter.length ? 'flex' : 'none', marginLeft: '2%' } },
      (statusesFilter || []).map(function (status, index) {
        return _react2.default.createElement(
          _materialUi.Chip,
          {
            key: index,
            style: { marginRight: '8px' },
            labelColor: (0, _contractingUtils.getTemplateStatusColor)(status),
            onRequestDelete: function onRequestDelete() {
              return updateFilters({ statusesFilter: _ramda2.default.remove(index, 1, statusesFilter) });
            }
          },
          status
        );
      })
    )
  );
};

exports.default = SearchAndFilter;

/***/ }),
/* 3510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _createDraftForm = __webpack_require__(1960);

var _createDraftForm2 = _interopRequireDefault(_createDraftForm);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateDraftDialog = function CreateDraftDialog(_ref) {
  var dialogOpen = _ref.dialogOpen,
      creatingDraft = _ref.creatingDraft,
      updateProps = _ref.updateProps,
      createDraft = _ref.createDraft,
      createDraftError = _ref.createDraftError,
      locations = _ref.locations;

  var actionButtons = [_react2.default.createElement(
    'div',
    { key: 'createDraftError', style: { color: 'red' } },
    createDraftError
  ), _react2.default.createElement(_flatButtonWithLoader2.default, {
    key: 'cancel',
    label: 'cancel',
    primary: true,
    onTouchTap: function onTouchTap() {
      return updateProps({ dialogOpen: false });
    }
  }), _react2.default.createElement(_flatButtonWithLoader2.default, {
    key: 'create',
    label: 'create',
    loader: creatingDraft,
    secondary: true,
    disabled: !_ramda2.default.any(_ramda2.default.propEq('checked', true), locations),
    onTouchTap: createDraft
  })];
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      titleStyle: { padding: '12px 24px' },
      title: _react2.default.createElement(
        'div',
        { style: { backgroundColor: '#00bcd4', color: 'white', fontSize: '20px', display: 'flex', justifyContent: 'space-between' } },
        'Create Template Draft',
        _react2.default.createElement(_materialUi.FontIcon, {
          className: 'tc-icon-close',
          style: { cursor: 'pointer', color: 'white', fontSize: '24px', top: '4px' },
          onTouchTap: function onTouchTap() {
            return updateProps({ dialogOpen: false });
          }
        })
      ),
      open: dialogOpen,
      autoScrollBodyContent: true,
      onRequestClose: function onRequestClose() {
        return updateProps({ dialogOpen: false });
      },
      actions: actionButtons
    },
    _react2.default.createElement(_createDraftForm2.default, { updateProps: updateProps })
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    dialogOpen: contracting.templateList.get('dialogOpen'),
    createDraftError: contracting.templateList.get('createDraftError'),
    creatingDraft: contracting.templateList.get('creatingDraft'),
    locations: contracting.templateList.get('locations').toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CreateDraftDialog);

/***/ }),
/* 3511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _createGroupWizard = __webpack_require__(2033);

var _createGroupWizard2 = _interopRequireDefault(_createGroupWizard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateGroupDialog = function CreateGroupDialog(_ref) {
  var createTemplateGroupOpen = _ref.createTemplateGroupOpen,
      updateProps = _ref.updateProps,
      groupCreated = _ref.groupCreated,
      getTemplates = _ref.getTemplates;
  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      titleStyle: { padding: '12px 24px' },
      onRequestClose: function onRequestClose() {
        return updateProps({ createTemplateGroupOpen: false });
      },
      title: groupCreated ? _react2.default.createElement(
        'div',
        { style: { backgroundColor: '#00bcd4', color: 'white', fontSize: '20px', textAlign: 'center' } },
        'Create Template Group'
      ) : _react2.default.createElement(
        'div',
        { style: { backgroundColor: '#00bcd4', color: 'white', fontSize: '20px', display: 'flex', justifyContent: 'space-between' } },
        'Create Template Group',
        _react2.default.createElement(_materialUi.FontIcon, {
          className: 'tc-icon-close',
          style: { cursor: 'pointer', color: 'white', fontSize: '24px', top: '4px' },
          onTouchTap: function onTouchTap() {
            return updateProps({ createTemplateGroupOpen: false });
          }
        })
      ),
      autoScrollBodyContent: true,
      contentStyle: { transform: 'none' },
      style: { transform: 'none' },
      open: createTemplateGroupOpen
    },
    _react2.default.createElement(_createGroupWizard2.default, {
      afterCreationFn: function afterCreationFn() {
        updateProps({ createTemplateGroupOpen: false, showType: 'group' });
        getTemplates();
      }
    })
  );
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return {
    createTemplateGroupOpen: contracting.templateList.get('createTemplateGroupOpen'),
    groupCreated: contracting.templateList.get('groupCreated')
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(CreateGroupDialog);

/***/ }),
/* 3512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var convertToYY = function convertToYY(_ref) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate;
  return startDate && endDate ? _moment2.default.utc(startDate).format('D MMM YYYY') + ' - ' + _moment2.default.utc(endDate).format('D MMM YYYY') : '';
};

var StepOneNameNdates = function StepOneNameNdates(_ref2) {
  var newGroupName = _ref2.newGroupName,
      allContractPeriods = _ref2.allContractPeriods,
      updateProps = _ref2.updateProps,
      selectContractYear = _ref2.selectContractYear,
      newGroupStartDate = _ref2.newGroupStartDate,
      newGroupEndDate = _ref2.newGroupEndDate;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'label',
      null,
      _react2.default.createElement(
        'b',
        null,
        'Please enter a name for the group:'
      )
    ),
    ' ',
    _react2.default.createElement(
      'span',
      { style: { color: 'red' } },
      '* Required'
    ),
    _react2.default.createElement(_materialUi.TextField, {
      style: { display: 'block', width: '200px' },
      hintText: 'Name the new group',
      defaultValue: newGroupName,
      onChange: function onChange(_, value) {
        return updateProps({ newGroupName: value, editroupError: '' });
      }
    }),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'label',
      { style: { marginBottom: '16px' } },
      _react2.default.createElement(
        'b',
        null,
        'Please select a contracting period for the group:'
      )
    ),
    ' ',
    _react2.default.createElement(
      'span',
      { style: { color: 'red' } },
      '* Required'
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      _materialUi.SelectField,
      {
        autoWidth: true,
        hintText: 'Click to select',
        iconStyle: { fill: 'rgba(0, 0, 0, 0.75)' },
        value: convertToYY({ startDate: newGroupStartDate, endDate: newGroupEndDate })
      },
      _ramda2.default.sort(_ramda2.default.ifElse(_ramda2.default.useWith(_ramda2.default.gt, [_ramda2.default.prop('endDate'), _ramda2.default.prop('endDate')]), _ramda2.default.always(-1), _ramda2.default.always(1)), allContractPeriods).map(function (obj, i) {
        return _react2.default.createElement(_materialUi.MenuItem, {
          key: i,
          value: convertToYY(obj),
          onTouchTap: function onTouchTap() {
            return selectContractYear(obj);
          },
          primaryText: convertToYY(obj)
        });
      })
    )
  );
};

exports.default = StepOneNameNdates;

/***/ }),
/* 3513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _createGroupWizard = __webpack_require__(2033);

var _createGroupWizard2 = _interopRequireDefault(_createGroupWizard);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var CreateTemplateGroupRouter = function (_React$Component) {
  _inherits(CreateTemplateGroupRouter, _React$Component);

  function CreateTemplateGroupRouter() {
    _classCallCheck(this, CreateTemplateGroupRouter);

    return _possibleConstructorReturn(this, (CreateTemplateGroupRouter.__proto__ || Object.getPrototypeOf(CreateTemplateGroupRouter)).apply(this, arguments));
  }

  _createClass(CreateTemplateGroupRouter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _materialUi.Paper,
        { style: { width: '800px', margin: 'auto auto 64px auto' } },
        _react2.default.createElement(
          'div',
          { style: { backgroundColor: '#00bcd4', color: '#fff', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'space-between' } },
          _react2.default.createElement(
            'h4',
            { style: { width: '50%', color: '#FFFFFF', fontWeight: '500', paddingRight: '32px', textAlign: 'right' } },
            'Create Template Group'
          ),
          _react2.default.createElement(_materialUi.FlatButton, {
            icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-arrow_back', color: 'white' }),
            label: 'back',
            style: { color: 'white' },
            onTouchTap: function onTouchTap() {
              return _this2.context.router.goBack();
            }
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { padding: '12px 12px 24px 12px' } },
          _react2.default.createElement(_createGroupWizard2.default, {
            afterCreationFn: function afterCreationFn() {
              return _this2.context.router.push('/contracting/template-list?showType=group');
            }
          })
        )
      );
    }
  }]);

  return CreateTemplateGroupRouter;
}(_react2.default.Component);

CreateTemplateGroupRouter.propTypes = {
  updateProps: _react2.default.PropTypes.func,
  getTemplates: _react2.default.PropTypes.func,
  createGroupError: _react2.default.PropTypes.string,
  allContractPeriods: _react2.default.PropTypes.array
};
var mapStateToProps = function mapStateToProps(_ref) {
  var contracting = _ref.contracting;
  return {
    allContractPeriods: contracting.templateList.toJS().allContractPeriods
  };
};
CreateTemplateGroupRouter.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(CreateTemplateGroupRouter);

/***/ }),
/* 3514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _templateListActions = __webpack_require__(877);

var _formWithButtons = __webpack_require__(1959);

var _formWithButtons2 = _interopRequireDefault(_formWithButtons);

var _selectTemplate = __webpack_require__(2032);

var _selectTemplate2 = _interopRequireDefault(_selectTemplate);

var _saveAsTemplate = __webpack_require__(1989);

var _saveAsTemplate2 = _interopRequireDefault(_saveAsTemplate);

var _dialogConstants = __webpack_require__(616);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var invisibleStepper = ['wannaCopy', 'templateList', 'saveAsForm'];

var CreateTemplateDraftRouter = function (_React$Component) {
  _inherits(CreateTemplateDraftRouter, _React$Component);

  function CreateTemplateDraftRouter(props) {
    _classCallCheck(this, CreateTemplateDraftRouter);

    var _this = _possibleConstructorReturn(this, (CreateTemplateDraftRouter.__proto__ || Object.getPrototypeOf(CreateTemplateDraftRouter)).call(this, props));

    _this.goToSaveAsForm = function () {
      return _this.setState({
        show: 'saveAsForm'
      });
    };

    _this.fromScratch = function () {
      return _this.setState({
        show: 'startFromScratch'
      });
    };

    _this.yesIWantToCopy = function () {
      return _this.setState({
        show: 'templateList'
      });
    };

    _this.goBack = function () {
      var rateTemplatesCount = _this.props.rateTemplatesCount;
      var show = _this.state.show;

      if (!rateTemplatesCount || show === 'wannaCopy') _this.context.router.goBack();else if (show === 'startFromScratch') {
        _this.setState({ show: 'wannaCopy' });
      } else {
        _this.setState({ show: invisibleStepper[invisibleStepper.indexOf(show) - 1] });
      }
    };

    _this.selectATemplate = function (template) {
      _this.setState({ selectedTemplate: template });
      _this.props.updatePropsForSaveAs({
        newDraftStartDate: template.startDate,
        newDraftEndDate: template.endDate,
        contractId: template._id,
        sourceTemplatePeriod: {
          startDate: template.startDate,
          endDate: template.endDate
        }
      });
    };

    _this.unselect = function () {
      _this.setState({ selectedTemplate: null });
      _this.props.updatePropsForSaveAs({
        sourceTemplatePeriod: {},
        newDraftStartDate: undefined,
        newDraftEndDate: undefined,
        contractId: undefined
      });
    };

    _this.saveAsNewTemplate = function () {
      _this.props.saveAsANewTemplateWithDispatch({
        contractId: _this.props.saveAsReducerState.contractId,
        templateName: _this.props.saveAsReducerState.templateName,
        startDate: _this.props.saveAsReducerState.newDraftStartDate,
        endDate: _this.props.saveAsReducerState.newDraftEndDate
      });
    };

    _this.onSaveAsDismiss = function () {
      _this.props.clearSaveAsReducerState();
    };

    _this.state = {
      show: props.rateTemplatesCount ? 'wannaCopy' : 'startFromScratch',
      selectedTemplate: null
    };
    return _this;
  }

  _createClass(CreateTemplateDraftRouter, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.rateTemplatesCount && nextProps.rateTemplatesCount) {
        this.setState({
          show: 'wannaCopy'
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // const { startDate, endDate, locationId, buyerName } = location.query;
      var _props = this.props,
          templates = _props.templates,
          saveAsReducerState = _props.saveAsReducerState,
          updatePropsForSaveAs = _props.updatePropsForSaveAs;
      var _state = this.state,
          show = _state.show,
          selectedTemplate = _state.selectedTemplate;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _materialUi.Stepper,
          { style: { marginTop: '24px' }, activeStep: 0 },
          _react2.default.createElement(
            _materialUi.Step,
            null,
            _react2.default.createElement(
              _materialUi.StepLabel,
              { style: { height: '32px', paddingLeft: 0 } },
              _react2.default.createElement(
                'div',
                { style: { width: '100%', textAlign: 'center' } },
                'Create Rate Template'
              )
            )
          ),
          _react2.default.createElement(
            _materialUi.Step,
            null,
            _react2.default.createElement(
              _materialUi.StepLabel,
              { style: { height: '32px', paddingLeft: 0 } },
              _react2.default.createElement(
                'div',
                { style: { width: '100%', textAlign: 'center' } },
                'Enter Rates & Required Information'
              )
            )
          ),
          _react2.default.createElement(
            _materialUi.Step,
            null,
            _react2.default.createElement(
              _materialUi.StepLabel,
              { style: { height: '32px', paddingLeft: 0 } },
              _react2.default.createElement(
                'div',
                { style: { width: '100%', textAlign: 'center' } },
                'Review & Finalise'
              )
            )
          ),
          _react2.default.createElement(
            _materialUi.Step,
            null,
            _react2.default.createElement(
              _materialUi.StepLabel,
              { style: { height: '32px', paddingLeft: 0 } },
              _react2.default.createElement(
                'div',
                { style: { width: '100%', textAlign: 'center' } },
                'Send Rates to Partners'
              )
            )
          )
        ),
        _react2.default.createElement(
          _materialUi.Paper,
          { style: { width: '700px', margin: '32px auto auto' } },
          _react2.default.createElement(
            'div',
            { style: { backgroundColor: '#00bcd4', color: '#fff', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'space-between' } },
            _react2.default.createElement(
              'h4',
              { style: { width: '50%', color: '#FFFFFF', fontWeight: '500', paddingRight: '32px', textAlign: 'right' } },
              'Create Rate Template'
            ),
            _react2.default.createElement(_materialUi.FlatButton, {
              icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-arrow_back', color: 'white' }),
              label: 'back',
              style: { color: 'white' },
              onTouchTap: this.goBack
            })
          ),
          function () {
            if (show === 'wannaCopy') {
              return _react2.default.createElement(
                'div',
                { style: { padding: '24px' } },
                _react2.default.createElement(
                  'div',
                  { style: { fontSize: '14px' } },
                  'Would you like to use a copy of an existing rate template, then make changes?'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'div',
                  { className: 'flex-tc-sb', style: { marginTop: '32px' } },
                  _react2.default.createElement(_materialUi.RaisedButton, {
                    primary: true,
                    labelStyle: { textTransform: 'none' },
                    onClick: _this2.fromScratch,
                    label: 'No, start from scratch'
                  }),
                  _react2.default.createElement(_materialUi.RaisedButton, {
                    secondary: true,
                    labelStyle: { textTransform: 'none' },
                    label: 'Yes',
                    onClick: _this2.yesIWantToCopy
                  })
                )
              );
            }
            if (show === 'templateList') {
              return _react2.default.createElement(
                'div',
                { style: { margin: '16px 32px' } },
                _react2.default.createElement(_selectTemplate2.default, {
                  style: { maxHeight: '500px', overflowY: 'scroll' },
                  templates: templates,
                  selectedTemplates: selectedTemplate ? [selectedTemplate] : [],
                  label: 'Select',
                  selectedComponent: _react2.default.createElement(_materialUi.FlatButton, {
                    label: 'Unselect',
                    style: { position: 'relative', top: '-8px' },
                    secondary: true,
                    onClick: _this2.unselect
                  }),
                  onConfirm: _this2.selectATemplate
                }),
                _react2.default.createElement(_materialUi.RaisedButton, {
                  style: { margin: '16px 0 32px' },
                  secondary: true,
                  onClick: _this2.goToSaveAsForm,
                  disabled: !selectedTemplate,
                  label: 'Next'
                })
              );
            }
            if (show === 'saveAsForm') {
              return _react2.default.createElement(
                'div',
                {
                  style: { padding: '12px' }
                },
                _react2.default.createElement(_saveAsTemplate2.default, _extends({}, saveAsReducerState, {
                  onFieldChange: function onFieldChange(_ref) {
                    var key = _ref.key,
                        value = _ref.value;
                    return updatePropsForSaveAs(_defineProperty({}, key, value));
                  },
                  saveAsANewTemplate: _this2.saveAsNewTemplate,
                  onRequestClose: _this2.onSaveAsDismiss
                }))
              );
            }
            if (show === 'startFromScratch') {
              return _react2.default.createElement(_formWithButtons2.default, {
                style: { padding: '12px 24px 24px 24px' },
                prefillData: _this2.props.location.query,
                copyDataFromTemplate: selectedTemplate
              });
            }
          }()
        )
      );
    }
  }]);

  return CreateTemplateDraftRouter;
}(_react2.default.Component);

CreateTemplateDraftRouter.propTypes = {
  location: _react2.default.PropTypes.object,
  updateProps: _react2.default.PropTypes.func,
  rateTemplatesCount: _react2.default.PropTypes.number,
  saveAsReducerState: _react2.default.PropTypes.object,
  templates: _react2.default.PropTypes.array,
  updatePropsForSaveAs: _react2.default.PropTypes.func,
  clearSaveAsReducerState: _react2.default.PropTypes.func,
  saveAsANewTemplateWithDispatch: _react2.default.PropTypes.func
};
CreateTemplateDraftRouter.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting,
      user = _ref2.user;
  return {
    rateTemplatesCount: user.get('rateTemplatesCount'),
    templates: contracting.templateList.get('templates').toJS(),
    saveAsReducerState: contracting.publishDraftDialog.toJS()
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProps: function updateProps(payload) {
      return dispatch((0, _templateListActions.updateProps)(payload));
    },
    updatePropsForSaveAs: function updatePropsForSaveAs(payload) {
      return dispatch({ type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG', payload: payload });
    },
    saveAsANewTemplateWithDispatch: function saveAsANewTemplateWithDispatch(payload) {
      return dispatch((0, _dialogConstants.saveAsANewTemplate)(payload));
    },
    clearSaveAsReducerState: function clearSaveAsReducerState() {
      return dispatch({ type: 'CLOSE_PUBLISH_DRAFT_DIALOG' });
    }
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CreateTemplateDraftRouter);

/***/ }),
/* 3515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _simpleContractList = __webpack_require__(3516);

var _simpleContractList2 = _interopRequireDefault(_simpleContractList);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _queryString = __webpack_require__(125);

var _queryString2 = _interopRequireDefault(_queryString);

var _aphrodite = __webpack_require__(123);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _materialUi = __webpack_require__(3);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = _aphrodite.StyleSheet.create({
  container: { height: '56px', display: 'flex', paddingLeft: '16px', borderBottom: '1px solid rgba(0, 0, 0, 0.1)', alignItems: 'center' },
  texts: { width: '70%', color: 'rgba(0, 0, 0, 0.77)', cursor: 'pointer' },
  profileImage: { width: '7%', textAlign: 'left' },
  companyName: { fontSize: '14px' },
  locationName: { fontSize: '13px' },
  commentsButton: { padding: '0', height: '24px', width: '24px', top: '4px' },
  yearNtimestamp: { display: 'flex', color: 'rgba(0, 0, 0, 0.77)', flexDirection: 'column', textAlign: 'right', width: '10%' },
  comments: { display: 'inline-block', marginLeft: '8px', width: '4%', cursor: 'pointer' }
});
var getGenitiveCase = function getGenitiveCase(string) {
  if (!string) return string;
  if (string.slice(-1) === 's') return string + '\'';
  return string + '\'s';
};
var PartnerList = function PartnerList(_ref) {
  var sentPartners = _ref.sentPartners,
      template = _ref.template,
      sendingContracts = _ref.sendingContracts,
      companyName = _ref.companyName;

  if (!template._id) return _react2.default.createElement('div', null);
  var goToSendAssets = function goToSendAssets() {
    return window.location = "https://app.tourconnect.com" + '/partner-management/send-assets?' + _queryString2.default.stringify({
      go_back_to: window.location.href,
      templateids: [template._id],
      message: 'Please find ' + getGenitiveCase(template.locationName === companyName ? template.locationName : template.locationName + ' - ' + companyName) + ' ' + (0, _moment2.default)(template.startDate).utc().format('DD MMM YYYY') + ' - ' + (0, _moment2.default)(template.endDate).utc().format('DD MMM YYYY') + ' rates below. We are using TourConnect as they provide several standardised download formats that should make it easy for you to read and load our rates.\n\nIf you have any questions please let me know and thank you for your support.',
      subject: getGenitiveCase(template.locationName === companyName ? template.locationName : template.locationName + ' - ' + companyName) + ' ' + (0, _moment2.default)(template.startDate).utc().get('year') + '-' + (0, _moment2.default)(template.endDate).utc().get('year') + ' Rates'
    }) + '&jwt=' + localStorage.getItem('jwt');
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { width: '90%', margin: 'auto' } },
      _react2.default.createElement(_materialUi.RaisedButton, {
        label: 'Send to More Partners',
        secondary: true,
        labelStyle: { textTransform: 'none' },
        style: { float: 'right', margin: '16px 64px 0 0' },
        onTouchTap: goToSendAssets
      }),
      _react2.default.createElement(_simpleContractList2.default, {
        contracts: sentPartners.map(function (obj) {
          // Have to do this because stupid me modified "versions" in graphql when I should just use the another field "allVersions"
          // for that purpose, so here we have to change it back
          return _extends({}, obj, { versions: _ramda2.default.dropLast(1, obj.versions), viewerIsSender: true });
        }),
        header: sentPartners.length + ' ' + (0, _pluralize2.default)('partner', sentPartners.length) + ' ' + (0, _pluralize2.default)('have', sentPartners.length) + ' received this template.'
      })
    ),
    _react2.default.createElement(_loadingOverlay2.default, { loading: sendingContracts })
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting,
      user = _ref2.user;
  return {
    template: {
      _id: contracting.contractActivitiesProducts.getIn(['leftNav', 'contractId']),
      startDate: contracting.contractActivitiesProducts.getIn(['leftNav', 'startDate']),
      endDate: contracting.contractActivitiesProducts.getIn(['leftNav', 'endDate']),
      templateId: contracting.contractActivitiesProducts.getIn(['leftNav', 'contractId']),
      locationId: contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId']),
      templateName: contracting.contractActivitiesProducts.getIn(['leftNav', 'templateName']),
      locationName: contracting.contractActivitiesProducts.getIn(['leftNav', 'locationName']),
      supplierInfo: {
        marketInfo: contracting.contractActivitiesProducts.getIn(['leftNav', 'supplierInfo', 'marketInfo'])
      }
    },
    companyName: user.getIn(['company', 'companyName']),
    sendingContracts: contracting.supplierWizard.get('sendingContracts'),
    sentPartners: contracting.contractActivitiesProducts.getIn(['leftNav', 'sentPartners']) ? contracting.contractActivitiesProducts.getIn(['leftNav', 'sentPartners']).toJS() : []
  };
};
PartnerList.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(PartnerList);

/***/ }),
/* 3516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _aphrodite = __webpack_require__(123);

var _contractingUtils = __webpack_require__(124);

var _redDot = __webpack_require__(1056);

var _redDot2 = _interopRequireDefault(_redDot);

var _materialUi = __webpack_require__(3);

var _borderColor = __webpack_require__(2000);

var _borderColor2 = _interopRequireDefault(_borderColor);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = _aphrodite.StyleSheet.create({
  container: { height: '56px', display: 'flex', paddingLeft: '16px', borderBottom: '1px solid rgba(0, 0, 0, 0.1)', alignItems: 'center' },
  texts: { color: 'rgba(0, 0, 0, 0.77)', cursor: 'pointer', marginLeft: '4px' },
  profileImage: { width: '7%', textAlign: 'left' },
  companyName: { fontSize: '13px', display: 'flex', alignItems: 'center' },
  locationName: { fontSize: '11px' },
  commentsButton: { padding: '0', height: '24px', width: '24px', top: '4px' },
  yearNtimestamp: { display: 'flex', color: 'rgba(0, 0, 0, 0.77)', flexDirection: 'column', textAlign: 'right', width: '10%' },
  comments: { display: 'inline-block', marginLeft: '8px', width: '4%', cursor: 'pointer' }
});
var SimpleContractList = function SimpleContractList(_ref, context) {
  var _ref$contracts = _ref.contracts,
      contracts = _ref$contracts === undefined ? [] : _ref$contracts,
      header = _ref.header,
      viewingBy = _ref.viewingBy,
      style = _ref.style,
      _ref$inRequest = _ref.inRequest,
      inRequest = _ref$inRequest === undefined ? {} : _ref$inRequest;
  var fileContractForRequest = inRequest.fileContractForRequest,
      _inRequest$removingCo = inRequest.removingContractIds,
      removingContractIds = _inRequest$removingCo === undefined ? [] : _inRequest$removingCo,
      filingContractId = inRequest.filingContractId,
      requestId = inRequest.requestId,
      onCheckContract = inRequest.onCheckContract,
      allCheckedIds = inRequest.allCheckedIds,
      hideBtns = inRequest.hideBtns;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: _extends({ width: '90%', margin: 'auto' }, style) },
      _react2.default.createElement(
        _materialUi.Card,
        { style: { margin: '16px auto', display: contracts.length ? 'block' : 'none' }, initiallyExpanded: true },
        _react2.default.createElement(_materialUi.CardHeader, {
          style: { width: '100%', padding: '6px', display: header ? 'inherit' : 'none' },
          textStyle: { padding: 0 },
          title: _react2.default.createElement(
            'div',
            {
              style: { height: '40px', lineHeight: '40px', paddingLeft: '16px', fontSize: '16px', display: 'flex', justifyContent: 'space-between' }
            },
            header
          ),
          actAsExpander: true
        }),
        _react2.default.createElement(
          _materialUi.CardText,
          { expandable: true },
          contracts.map(function (contract, i) {
            var displayState = (0, _contractingUtils.getShownState)(_extends({ companyType: viewingBy }, contract));

            var _ref2 = function () {
              if (requestId && contract.versions.indexOf(requestId) === -1) {
                return {
                  nameToDisplay: contract.from.emailAlias || contract.from.email,
                  logoToDisplay: contract.from.avatar
                };
              }
              if (contract.viewerIsSender) {
                return {
                  nameToDisplay: contract.to.name,
                  logoToDisplay: contract.to.avatar
                };
              }
              // if viewer is receiver
              // display based receiver's partner list
              var partner = contract.partners[0] || {};
              return {
                nameToDisplay: partner.name || contract.from.name,
                logoToDisplay: partner.avatar || contract.from.avatar
              };
            }(),
                nameToDisplay = _ref2.nameToDisplay,
                logoToDisplay = _ref2.logoToDisplay;

            return _react2.default.createElement(
              'div',
              {
                className: (0, _aphrodite.css)(styles.container),
                key: i,
                style: removingContractIds.indexOf(contract._id) > -1 ? { filter: 'blur(2px)' } : {}
              },
              _react2.default.createElement(
                'div',
                {
                  className: (0, _aphrodite.css)(styles.texts),
                  style: { width: '70%' },
                  onClick: function onClick() {
                    return context.router.push('/contracting/contract/' + contract._id + '/details');
                  }
                },
                _react2.default.createElement(
                  'div',
                  { className: (0, _aphrodite.css)(styles.companyName) },
                  nameToDisplay,
                  ' ',
                  contract.versions.length <= 1 ? '' : '(v.' + (contract.versions.length + 1) + ')',
                  Boolean(contract.signatures && contract.signatures.length) && _react2.default.createElement(
                    'span',
                    { className: 'hint--top', 'aria-label': 'Signed' },
                    '\xA0\xA0',
                    _react2.default.createElement(_borderColor2.default, { style: { height: '18px', width: '18px', color: '#2e7d32' } })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: (0, _aphrodite.css)(styles.locationName) },
                  _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-location_on', style: { fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)', marginRight: '8px' } }),
                  contract.locationName,
                  _ramda2.default.path(['supplierInfo', 'marketInfo'], contract) ? _react2.default.createElement(
                    'small',
                    null,
                    '\xA0',
                    '(' + _ramda2.default.path(['supplierInfo', 'marketInfo'], contract) + ')'
                  ) : _react2.default.createElement('span', null),
                  contract.hasDraft && contract.viewingBy === 'Supplier' || contract.templateHasDraft && contract.templateFromDummy ? _react2.default.createElement(
                    'span',
                    {
                      style: { marginLeft: '12px', color: 'red' }
                    },
                    'This contract has a draft.'
                  ) : _react2.default.createElement('span', null)
                )
              ),
              _react2.default.createElement(
                'div',
                { className: (0, _aphrodite.css)(styles.comments), onClick: function onClick() {
                    return context.router.push('/contracting/contract/' + contract._id + '/activities');
                  } },
                _react2.default.createElement(_materialUi.IconButton, { iconClassName: 'tc-icon-question_answer', className: (0, _aphrodite.css)(styles.commentsButton), iconStyle: { color: 'rgba(0, 0, 0, 0.54)' } }),
                contract[viewingBy === 'Supplier' ? 'supplierHasNewComments' : 'buyerHasNewComments'] ? _react2.default.createElement(_redDot2.default, null) : _react2.default.createElement('span', null)
              ),
              _react2.default.createElement(
                'div',
                { style: { color: (0, _contractingUtils.getStatusColor)(displayState), width: '10%', textAlign: 'center' } },
                displayState
              ),
              _react2.default.createElement(
                'div',
                { className: (0, _aphrodite.css)(styles.yearNtimestamp) },
                _react2.default.createElement(
                  'span',
                  { style: { fontSize: '11px', color: 'rgba(0, 0, 0, 0.45)' } },
                  (0, _moment2.default)(contract.createdAt).calendar(null, {
                    sameDay: 'h:mm a',
                    lastDay: 'D MMM YY',
                    lastWeek: 'D MMM YY',
                    sameElse: 'D MMM YY'
                  })
                )
              )
            );
          })
        )
      )
    )
  );
};

SimpleContractList.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(function (_ref3) {
  var user = _ref3.user;
  return { viewingBy: user.getIn(['user', 'type']) };
})(SimpleContractList);

/***/ }),
/* 3517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _allLogs = __webpack_require__(3518);

var _allLogs2 = _interopRequireDefault(_allLogs);

var _materialUi = __webpack_require__(3);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangeLogRouter = function ChangeLogRouter(props) {
  var changeLogs = props.changeLogs,
      loadingLogs = props.loadingLogs,
      goBack = props.goBack;

  return _react2.default.createElement(
    'div',
    { className: 'full-screen-page' },
    _react2.default.createElement(_loadingOverlay2.default, { loading: loadingLogs }),
    _react2.default.createElement(_allLogs2.default, { logs: changeLogs }),
    _react2.default.createElement(
      'div',
      {
        style: { position: 'fixed', top: 6, right: 16, cursor: 'pointer', zIndex: 20 },
        onClick: goBack
      },
      _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-close', style: { fontSize: '36px', color: 'rgba(0, 0, 0, 0.54)' } })
    )
  );
};

var mapState = function mapState(_ref) {
  var contracting = _ref.contracting;
  return {
    changeLogs: contracting.contractActivitiesProducts.get('changeLogs').toJS(),
    loadingLogs: contracting.contractActivitiesProducts.get('loadingLogs')
  };
};

exports.default = (0, _reactRedux.connect)(mapState, { goBack: _reactRouterRedux.goBack })(ChangeLogRouter);

/***/ }),
/* 3518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _editLog = __webpack_require__(3519);

var _editLog2 = _interopRequireDefault(_editLog);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _reactRouterRedux = __webpack_require__(27);

var _sideBySideComparisonModal = __webpack_require__(3520);

var _sideBySideComparisonModal2 = _interopRequireDefault(_sideBySideComparisonModal);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  foldAll: {
    margin: '16px 16px 0'
  },
  logContainer: {
    display: 'inline-block',
    borderRadius: '10px !important',
    margin: '0 2em 2em 2em',
    padding: '16px',
    width: 'calc(100% - 4em)'
  },
  logHeader: {},
  logBody: {
    borderTop: '1px solid #e0e0e0',
    paddingTop: '12px',
    marginTop: '12px',
    whiteSpace: 'pre-wrap'
  },
  dateSplit: {
    color: '#3e5a6d',
    fontSize: '14px',
    padding: '1em 0 1em 1em',
    display: 'flex',
    alignItems: 'center'
  },
  rateSheetsBox: {
    border: '2px solid #e0e0e0',
    borderRadius: '4px'
  },
  rateSheetsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e0e0e0',
    padding: '8px'
  }
};

var c = function (_Component) {
  _inherits(c, _Component);

  function c() {
    _classCallCheck(this, c);

    var _this = _possibleConstructorReturn(this, (c.__proto__ || Object.getPrototypeOf(c)).call(this));

    _this.onCheckFoldAll = function () {
      return _this.setState({ allFolded: !_this.state.allFolded });
    };

    _this.openDialog = function (index) {
      return function () {
        return _this.setState({ openSideBySide: true, logIndexToOpen: index });
      };
    };

    _this.closeDialog = function () {
      return _this.setState({ openSideBySide: false, logIndexToOpen: -1 });
    };

    _this.state = {
      openSideBySide: false,
      logIndexToOpen: -1,
      allFolded: false
    };
    return _this;
  }

  _createClass(c, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$logs = _props.logs,
          logs = _props$logs === undefined ? [] : _props$logs,
          css = _props.classes,
          push = _props.push;
      var allFolded = this.state.allFolded;

      return _react2.default.createElement(
        'div',
        { style: { marginTop: '32px', padding: '0 6em' } },
        _react2.default.createElement(_materialUi.Checkbox, {
          label: allFolded ? 'Expand All' : 'Collapse All',
          checked: allFolded,
          onCheck: this.onCheckFoldAll,
          className: css.foldAll
        }),
        logs.map(function (log, i) {
          var prev = logs[i - 1];
          var dayActorLabel = !prev || !(0, _moment2.default)(prev.createdAt).isSame(log.createdAt, 'day') || prev.actor !== log.actor || prev.action !== log.action ? _react2.default.createElement(
            'div',
            { className: css.dateSplit },
            _react2.default.createElement(
              'div',
              null,
              (0, _moment2.default)(log.createdAt).format('DD MMMM YYYY')
            ),
            '\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0',
            _react2.default.createElement(
              'b',
              null,
              log.actor
            ),
            '\xA0',
            _react2.default.createElement(
              'b',
              null,
              log.action
            ),
            '\xA0this template ',
            log.version ? '(version ' + log.version + ')' : ''
          ) : null;
          return _react2.default.createElement(
            'div',
            { key: i },
            dayActorLabel,
            _react2.default.createElement(
              _materialUi.Paper,
              {
                style: allFolded || log.action !== 'edited' && !log.message ? { display: 'none' } : {},
                className: css.logContainer
              },
              _react2.default.createElement(
                'div',
                { className: css.logHeader },
                _react2.default.createElement(
                  'small',
                  null,
                  (0, _moment2.default)(log.createdAt).format('D MMM YYYY, H:mm')
                )
              ),
              function () {
                if (log.action === 'edited') {
                  return _react2.default.createElement(
                    'div',
                    {
                      className: css.logBody
                    },
                    _react2.default.createElement(_editLog2.default, log),
                    _react2.default.createElement(
                      'a',
                      { onClick: _this2.openDialog(i), style: { cursor: 'pointer' } },
                      'Open side by side comparison'
                    )
                  );
                }
                if (log.message) {
                  return _react2.default.createElement(
                    'div',
                    {
                      className: css.logBody
                    },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        'Subject: '
                      ),
                      log.message.bodyJson.subject
                    ),
                    _react2.default.createElement(
                      'b',
                      null,
                      'Message: '
                    ),
                    log.message.bodyJson.message,
                    Boolean(log.message.bodyJson.rateDocIds && log.message.bodyJson.rateDocIds.length) && _react2.default.createElement(
                      'div',
                      { className: css.rateSheetsBox },
                      _react2.default.createElement(
                        'div',
                        { className: css.rateSheetsHeader },
                        _react2.default.createElement(
                          'div',
                          { style: { fontSize: '16px' } },
                          'Rate Sheets'
                        ),
                        _react2.default.createElement(_materialUi.FlatButton, {
                          label: 'View Rates',
                          style: { border: '1px solid #e0e0e0' },
                          onClick: function onClick() {
                            return push('/contracting/contract/' + log.message.contractId + '/policies');
                          }
                        })
                      ),
                      _ramda2.default.values(log.message.bodyJson.rateDocsMap || {}).map(function (obj) {
                        return _react2.default.createElement(
                          'div',
                          { key: obj.threadId, style: { padding: '8px' } },
                          obj.locationName
                        );
                      })
                    )
                  );
                }
              }()
            )
          );
        }, { nodes: [], grouped: [] }),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            open: this.state.openSideBySide,
            onRequestClose: this.closeDialog,
            contentStyle: { width: '880px', maxWidth: '880px' },
            title: 'Side by Side Comparison',
            autoScrollBodyContent: true,
            actions: [_react2.default.createElement(_materialUi.FlatButton, {
              key: 'dismiss',
              label: 'Dismiss',
              secondary: true,
              onClick: this.closeDialog
            })]
          },
          Boolean(logs[this.state.logIndexToOpen]) && _react2.default.createElement(_sideBySideComparisonModal2.default, logs[this.state.logIndexToOpen])
        )
      );
    }
  }]);

  return c;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(null, { push: _reactRouterRedux.push })((0, _reactJss2.default)(styles)(c));

/***/ }),
/* 3519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _sectionUpdateSummary = __webpack_require__(1262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditLog = function EditLog(props) {
  var summaryByPage = props.summaryByPage;

  return _react2.default.createElement(
    'div',
    null,
    (summaryByPage || []).length ? summaryByPage.map(function (_ref, index) {
      var header = _ref.header,
          pageSections = _ref.pageSections;

      return _react2.default.createElement(
        'div',
        { key: header, style: { marginTop: index ? '8px' : '0' } },
        _react2.default.createElement(
          'div',
          { style: { fontSize: '16px', fontWeight: 'bold' } },
          header
        ),
        _react2.default.createElement(
          'div',
          null,
          pageSections.map(function (_ref2) {
            var label = _ref2.label,
                _ref2$updateSummary = _ref2.updateSummary,
                updateSummary = _ref2$updateSummary === undefined ? [] : _ref2$updateSummary;

            return _react2.default.createElement(
              'div',
              {
                key: label
              },
              _react2.default.createElement(
                'span',
                null,
                label,
                Boolean(updateSummary.length) && _react2.default.createElement(_sectionUpdateSummary.UpdateSummary, {
                  updateSummary: updateSummary
                })
              )
            );
          })
        )
      );
    }) : _react2.default.createElement(
      'span',
      null,
      'You haven\'t made any changes yet.'
    )
  );
};

exports.default = EditLog;

/***/ }),
/* 3520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _policyNotesContent = __webpack_require__(2023);

var _policyNotesContent2 = _interopRequireDefault(_policyNotesContent);

var _ratePackageContent = __webpack_require__(2025);

var _ratePackageContent2 = _interopRequireDefault(_ratePackageContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SideBySideComparison = function SideBySideComparison(props) {
  var summaryByPage = props.summaryByPage;

  return _react2.default.createElement(
    'div',
    null,
    summaryByPage.map(function (_ref, index) {
      var header = _ref.header,
          mainType = _ref.mainType,
          _ref$pageSections = _ref.pageSections,
          pageSections = _ref$pageSections === undefined ? [] : _ref$pageSections,
          ratePackageId = _ref.ratePackageId;

      return _react2.default.createElement(
        'div',
        {
          style: { marginTop: !index ? '10px' : '20px', fontSize: '14px' }
        },
        _react2.default.createElement(
          'h4',
          null,
          header
        ),
        _react2.default.createElement(
          'div',
          { style: { padding: '0 36px' }, id: header + '-body' },
          pageSections.map(function (_ref2) {
            var type = _ref2.type,
                label = _ref2.label,
                thisDiffBlock = _ref2.thisDiffBlock,
                updateSummary = _ref2.updateSummary;

            var PageComponent = mainType === 'policyNotes' ? _policyNotesContent2.default : _ratePackageContent2.default;
            return _react2.default.createElement(PageComponent, {
              key: type,
              diffBlock: thisDiffBlock,
              ratePackageId: ratePackageId,
              updateSummary: updateSummary,
              type: type,
              label: label
            });
          })
        )
      );
    })
  );
};

exports.default = SideBySideComparison;

/***/ }),
/* 3521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _settingsActions = __webpack_require__(976);

var _settingsLeftNav = __webpack_require__(3522);

var _settingsLeftNav2 = _interopRequireDefault(_settingsLeftNav);

var _reactRouterRedux = __webpack_require__(27);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _settings = __webpack_require__(3523);

var _settings2 = _interopRequireDefault(_settings);

var _index = __webpack_require__(2039);

var _index2 = _interopRequireDefault(_index);

var _actions = __webpack_require__(253);

var _accessCheckHelperFns = __webpack_require__(631);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsContainer = function (_Component) {
  _inherits(SettingsContainer, _Component);

  function SettingsContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SettingsContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SettingsContainer.__proto__ || Object.getPrototypeOf(SettingsContainer)).call.apply(_ref, [this].concat(args))), _this), _this.resetPassword = function () {
      var dispatch = _this.props.dispatch;

      var _this$props$settings$ = _this.props.settings.toJS(),
          oldPassword = _this$props$settings$.oldPassword,
          newPassword = _this$props$settings$.newPassword,
          confNewPassword = _this$props$settings$.confNewPassword;

      // client-side validation


      var errorMessage = void 0;
      var errorFields = void 0;

      if (oldPassword === '' || newPassword === '' || confNewPassword === '') {
        errorMessage = 'Fields cannot be blank';
        errorFields = ['oldPasswordError', 'newPasswordError'];
      } else if (newPassword !== confNewPassword) {
        errorMessage = 'New passwords must match';
        errorFields = ['newPasswordError'];
      }

      // more client side validation goes here

      if (errorMessage) return dispatch((0, _settingsActions.passwordResetError)(errorMessage, errorFields));

      return dispatch((0, _settingsActions.resetPassword)(oldPassword, newPassword)).catch(function (err) {
        console.log(err);
      });
    }, _this.toggleConnectionNotifications = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          settings = _this$props.settings;

      var newNotifValue = !settings.get('connectionNotificationsEnabled');
      return dispatch((0, _settingsActions.toggleConnectionNotifications)(newNotifValue)).catch(function (err) {
        console.log(err);
      });
    }, _this.onChangeRoute = function (route) {
      if (route === 'company-settings') {
        var adminAccess = (0, _accessCheckHelperFns.getFeatureAccess)({ user: _this.props.user }, '', 'admin');
        if (_ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty)(adminAccess)) return _this.props.dispatch((0, _accessCheckHelperFns.triggerNoAccessWarning)({ featureName: 'admin', access: 'read' }));
      }
      return _this.props.push('/settings/' + route);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SettingsContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          dispatch = _props.dispatch,
          history = _props.history,
          params = _props.params;


      dispatch((0, _actions.getUsersByFilter)('team'));

      if (this.props.settings.get('isHydratedFromServer') === false) {
        return dispatch((0, _settingsActions.hydrateFromServer)()).catch(function (err) {
          console.log(err);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          user = _props2.user,
          settings = _props2.settings;

      var props = _extends({
        resetPassword: this.resetPassword,
        passwordInputModified: function passwordInputModified(passType, event) {
          return dispatch((0, _settingsActions.passwordInputModified)(passType, event.target.value));
        },
        toggleConnectionNotifications: this.toggleConnectionNotifications,
        addTempUser: function addTempUser() {
          return dispatch((0, _settingsActions.addTempUser)());
        },
        deleteTempUser: function deleteTempUser(key) {
          return dispatch((0, _settingsActions.deleteTempUser)(key));
        },
        tempUserPropModified: function tempUserPropModified(key, propName, newValue) {
          return dispatch((0, _settingsActions.tempUserPropModified)(key, propName, newValue));
        },
        addNewUsers: function addNewUsers(clickedButton) {
          return dispatch((0, _settingsActions.addNewUsers)(clickedButton, settings.get('tempUsers'), settings.get('currentUserRole')));
        },
        clearAddUserMessage: function clearAddUserMessage() {
          return dispatch((0, _settingsActions.clearAddUserMessage)());
        },
        clearEditUserMessage: function clearEditUserMessage() {
          return dispatch((0, _settingsActions.clearEditUserMessage)());
        },
        approveOrRejectUser: function approveOrRejectUser(userObject, action) {
          return dispatch((0, _settingsActions.approveOrRejectUser)(userObject, action));
        },
        disableUser: function disableUser(userObject) {
          return dispatch((0, _settingsActions.disableUser)(userObject));
        },
        updateUserBeingEdited: function updateUserBeingEdited(userObject) {
          return dispatch((0, _settingsActions.updateUserBeingEdited)(userObject));
        },
        editUserPropModified: function editUserPropModified(propName, newValue) {
          return dispatch((0, _settingsActions.editUserPropModified)(propName, newValue));
        },
        saveUserBeingEdited: function saveUserBeingEdited(userObject) {
          return dispatch((0, _settingsActions.saveUserBeingEdited)(userObject));
        },
        disassociateSecondaryEmail: function disassociateSecondaryEmail(id) {
          return dispatch((0, _settingsActions.confirmedDisassociateSecondaryEmail)(id));
        },
        resendSecondaryEmailConfirmationLink: function resendSecondaryEmailConfirmationLink(email) {
          return dispatch((0, _settingsActions.resendSecondaryEmailConfirmationLink)(email));
        },
        addSecondaryEmail: function addSecondaryEmail(email) {
          return dispatch((0, _settingsActions.addSecondaryEmail)(email));
        },
        resendConfirmationLink: function resendConfirmationLink(email) {
          return dispatch((0, _settingsActions.resendConfirmationLink)(email));
        },
        clearManageUsersMessage: function clearManageUsersMessage() {
          return dispatch((0, _settingsActions.clearManageUsersMessage)());
        }
      }, this.props);

      if (!user.user.userID) return false;
      return _react2.default.createElement(
        'div',
        { className: 'l-app-content l-left-nav-with-content', style: { paddingTop: '65px' } },
        _react2.default.createElement(_settingsLeftNav2.default, _extends({ className: 'settings-left-nav l-left-nav' }, this.props)),
        _react2.default.createElement(
          'div',
          { className: 'l-left-nav-content' },
          _react2.default.createElement(_settings2.default, _extends({ activeRoute: this.props.params.activeRoute, onChangeRoute: this.onChangeRoute }, props))
        )
      );
    }
  }]);

  return SettingsContainer;
}(_react.Component);

SettingsContainer.propTypes = {
  dispatch: _react.PropTypes.func,
  history: _react.PropTypes.object,
  params: _react.PropTypes.object,
  settings: _react.PropTypes.object,
  user: _react.PropTypes.object,
  children: _react.PropTypes.any
};

var select = function select(state) {
  return {
    settings: state.settings,
    billing: state.billing.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(select, { push: _reactRouterRedux.push })(SettingsContainer);

/* jshint ignore:end */

/***/ }),
/* 3522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _person = __webpack_require__(1460);

var _person2 = _interopRequireDefault(_person);

var _locationCity = __webpack_require__(2034);

var _locationCity2 = _interopRequireDefault(_locationCity);

var _creditCard = __webpack_require__(2035);

var _creditCard2 = _interopRequireDefault(_creditCard);

var _navLink = __webpack_require__(1049);

var _navLink2 = _interopRequireDefault(_navLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingsLeftNav = function SettingsLeftNav(props) {
  var _props$user = props.user,
      userType = _props$user.userType,
      company = _props$user.company,
      className = props.className;

  var billingEnabled = company.billingEnabled;
  var companySettings = [{ text: 'Manage Users', anchorId: 'manage-users' }, { text: 'Associated Emails', anchorId: 'secondary-emails' }];
  if (userType === 'Contractor') {
    companySettings.push({ text: 'Forwarding Address', anchorId: 'emailForwarding' });
    companySettings.push({ text: 'Contract Settings', anchorId: 'contracting-settings' });
  }
  var navItems = [{
    icon: _react2.default.createElement(_person2.default, { color: 'rgba(0, 0, 0, 0.54)' }),
    heading: 'My Settings',
    items: [{ text: 'Personal Details', anchorId: 'personalDetails' }, { text: 'Access Level', anchorId: 'accessLevel' }, { text: 'Notifications', anchorId: 'notifications' }, { text: 'Rate Format', anchorId: 'rateFormat' }]
  }, {
    icon: _react2.default.createElement(_locationCity2.default, { color: 'rgba(0, 0, 0, 0.54)' }),
    heading: 'Company Settings',
    items: companySettings
  }];
  if (billingEnabled) {
    navItems.push({
      icon: _react2.default.createElement(_creditCard2.default, { color: 'rgba(0, 0, 0, 0.54)' }),
      heading: 'Billing Settings',
      items: [{ text: 'Billing', anchorId: 'billing' }]
    });
  }
  return _react2.default.createElement(
    'div',
    { className: className, style: { marginTop: '-65px' } },
    _react2.default.createElement(
      'div',
      { className: 'settings-left-nav-inner' },
      navItems.map(function (obj) {
        return [_react2.default.createElement(
          'div',
          { key: 'heading', className: 'settings-left-nav-heading flex-center' },
          obj.icon,
          obj.heading
        ), _react2.default.createElement(
          'div',
          { key: 'widget', className: 'connections-widget' },
          obj.items.map(function (setting) {
            return _react2.default.createElement(
              _navLink2.default,
              _extends({
                key: setting.anchorId
              }, props, {
                classes: 'nav-link connections-widget-link',
                activeRoutes: [],
                routeName: '/settings/' + setting.anchorId
              }),
              setting.text
            );
          })
        )];
      })
    )
  );
};

SettingsLeftNav.propTypes = {
  className: _propTypes2.default.string,
  user: _propTypes2.default.object,
  billing: _propTypes2.default.object
};

exports.default = SettingsLeftNav;

/***/ }),
/* 3523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(6);

var _person = __webpack_require__(1460);

var _person2 = _interopRequireDefault(_person);

var _locationCity = __webpack_require__(2034);

var _locationCity2 = _interopRequireDefault(_locationCity);

var _creditCard = __webpack_require__(2035);

var _creditCard2 = _interopRequireDefault(_creditCard);

var _materialUi = __webpack_require__(3);

var _scrollToElement = __webpack_require__(859);

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

var _assocEmails = __webpack_require__(3524);

var _assocEmails2 = _interopRequireDefault(_assocEmails);

var _manageUsers = __webpack_require__(3525);

var _manageUsers2 = _interopRequireDefault(_manageUsers);

var _emailForwarding = __webpack_require__(3535);

var _emailForwarding2 = _interopRequireDefault(_emailForwarding);

var _personalDetails = __webpack_require__(3537);

var _personalDetails2 = _interopRequireDefault(_personalDetails);

var _accessLevel = __webpack_require__(3538);

var _accessLevel2 = _interopRequireDefault(_accessLevel);

var _container = __webpack_require__(3539);

var _container2 = _interopRequireDefault(_container);

var _index = __webpack_require__(2039);

var _index2 = _interopRequireDefault(_index);

var _contractSettings = __webpack_require__(3543);

var _contractSettings2 = _interopRequireDefault(_contractSettings);

var _rateFormatSetting = __webpack_require__(3545);

var _rateFormatSetting2 = _interopRequireDefault(_rateFormatSetting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* globals document */

var Settings = function (_React$Component) {
  _inherits(Settings, _React$Component);

  function Settings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Settings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Settings.__proto__ || Object.getPrototypeOf(Settings)).call.apply(_ref, [this].concat(args))), _this), _this.scrollToAnchor = function (activeRoute) {
      var element = document.querySelector('#' + activeRoute);
      if (element) (0, _scrollToElement2.default)('#' + activeRoute, { offset: -70 });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Settings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var activeRoute = this.props.activeRoute;

      if (activeRoute) {
        this.scrollToAnchor(activeRoute);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var activeRoute = this.props.activeRoute;

      if (activeRoute !== nextProps.activeRoute) this.scrollToAnchor(nextProps.activeRoute);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          userType = _props.userType,
          billingEnabled = _props.billingEnabled;

      return _react2.default.createElement(
        'div',
        { style: { marginBottom: '32px' } },
        _react2.default.createElement(
          _materialUi.Paper,
          { style: { padding: '32px' } },
          _react2.default.createElement(
            'div',
            { className: 'flex-center', style: { fontSize: '30px', fontWeight: 450, textTransform: 'uppercase', color: 'rgba(0, 0, 0, 0.54)' } },
            _react2.default.createElement(_person2.default, { color: 'rgba(0, 0, 0, 0.54)', style: { width: '40px', height: '40px' } }),
            ' My Settings'
          ),
          _react2.default.createElement(
            'div',
            { id: 'personalDetails', style: { marginTop: '40px' } },
            _react2.default.createElement(_personalDetails2.default, null)
          ),
          _react2.default.createElement(
            'div',
            { id: 'accessLevel', style: { marginTop: '40px' } },
            _react2.default.createElement(_accessLevel2.default, null)
          ),
          _react2.default.createElement(
            'div',
            { id: 'notifications', style: { marginTop: '40px' } },
            _react2.default.createElement(_container2.default, null)
          ),
          _react2.default.createElement(
            'div',
            { id: 'rateFormat', style: { marginTop: '40px' } },
            _react2.default.createElement(_rateFormatSetting2.default, null)
          )
        ),
        _react2.default.createElement(
          _materialUi.Paper,
          { style: { padding: '32px', marginTop: '32px' } },
          _react2.default.createElement(
            'div',
            { className: 'flex-center', style: { fontSize: '30px', fontWeight: 450, textTransform: 'uppercase', color: 'rgba(0, 0, 0, 0.54)' } },
            _react2.default.createElement(_locationCity2.default, { color: 'rgba(0, 0, 0, 0.54)', style: { width: '40px', height: '40px' } }),
            ' Company Settings'
          ),
          _react2.default.createElement(
            'div',
            { id: 'manage-users', style: { marginTop: '40px' } },
            _react2.default.createElement(_manageUsers2.default, null)
          ),
          _react2.default.createElement(
            'div',
            { id: 'secondary-emails', style: { marginTop: '40px' } },
            _react2.default.createElement(_assocEmails2.default, null)
          ),
          userType === 'Contractor' ? _react2.default.createElement(
            'div',
            { id: 'emailForwarding', style: { marginTop: '40px' } },
            _react2.default.createElement(_emailForwarding2.default, null)
          ) : null,
          userType === 'Contractor' ? _react2.default.createElement(
            'div',
            { id: 'contracting-settings', style: { marginTop: '40px' } },
            _react2.default.createElement(_contractSettings2.default, null)
          ) : null
        ),
        billingEnabled && _react2.default.createElement(
          _materialUi.Paper,
          { style: { padding: '32px', marginTop: '32px' } },
          _react2.default.createElement(
            'div',
            { className: 'flex-center', style: { fontSize: '30px', fontWeight: 450, textTransform: 'uppercase', color: 'rgba(0, 0, 0, 0.54)' } },
            _react2.default.createElement(_creditCard2.default, { color: 'rgba(0, 0, 0, 0.54)', style: { width: '40px', height: '40px' } }),
            ' Billing Settings'
          ),
          _react2.default.createElement(
            'div',
            { id: 'billing', style: { marginTop: '40px' } },
            _react2.default.createElement(_index2.default, this.props)
          )
        )
      );
    }
  }]);

  return Settings;
}(_react2.default.Component);

Settings.propTypes = {
  activeRoute: _propTypes2.default.string,
  billingEnabled: _propTypes2.default.bool,
  onRouteChange: _propTypes2.default.func,
  userType: _propTypes2.default.string
};

var select = function select(_ref2) {
  var user = _ref2.user;
  return {
    userType: user.getIn(['user', 'type']),
    billingEnabled: user.toJS().company.billingEnabled
  };
};

exports.default = (0, _reactRedux.connect)(select)(Settings);

/***/ }),
/* 3524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _validations = __webpack_require__(871);

var _settingsActions = __webpack_require__(976);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var AssocEmails = function (_Component) {
  _inherits(AssocEmails, _Component);

  function AssocEmails(props) {
    _classCallCheck(this, AssocEmails);

    var _this = _possibleConstructorReturn(this, (AssocEmails.__proto__ || Object.getPrototypeOf(AssocEmails)).call(this, props));

    _this.state = {
      editingEmailObj: {},
      showAddEmail: false,
      tempSecondaryEmail: ''
    };
    return _this;
  }

  _createClass(AssocEmails, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          settings = _props.settings,
          resendConfirmLink = _props.resendConfirmLink,
          addSecEmail = _props.addSecEmail,
          removeSecEmail = _props.removeSecEmail,
          updateProp = _props.updateProp;
      var _state = this.state,
          editingEmailObj = _state.editingEmailObj,
          showAddEmail = _state.showAddEmail,
          tempSecondaryEmail = _state.tempSecondaryEmail;

      var secondaryEmails = settings.secondaryEmails;
      var secondaryEmailsInfo = _ramda2.default.propOr({}, 'secondaryEmailsInfo', settings);
      var resetState = function resetState() {
        return _this2.setState({ editingEmailObj: {}, showAddEmail: false, tempSecondaryEmail: '' });
      };
      var fullWidth = _ramda2.default.isEmpty(editingEmailObj) || !_ramda2.default.isEmpty(editingEmailObj) && editingEmailObj.is_confirmed;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { paddingBottom: '12px', borderBottom: '1px solid #e6e9ec', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' } },
          _react2.default.createElement(
            'div',
            { style: { fontSize: '24px', fontWeight: 400 } },
            'Associated Emails'
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center' } },
            _react2.default.createElement(_materialUi.RaisedButton, { label: 'Associated Email', icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-add', style: { fontSize: '16px', marginTop: '-3px' } }), onTouchTap: function onTouchTap() {
                return _this2.setState({ showAddEmail: true });
              }, secondary: true })
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _ramda2.default.isEmpty(secondaryEmails) ? _react2.default.createElement(
            'div',
            null,
            'You do not have any associated emails.'
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _materialUi.Table,
              { selectable: false, bodyStyle: { maxHeight: '300px', overflowY: 'scroll' } },
              _react2.default.createElement(
                _materialUi.TableHeader,
                { displaySelectAll: false, adjustForCheckbox: false },
                _react2.default.createElement(
                  _materialUi.TableRow,
                  null,
                  _react2.default.createElement(
                    _materialUi.TableHeaderColumn,
                    { style: { width: fullWidth ? '45%' : '40%', textAlign: 'center' } },
                    'Email'
                  ),
                  _react2.default.createElement(
                    _materialUi.TableHeaderColumn,
                    { style: { width: fullWidth ? '40%' : '20%', textAlign: 'center' } },
                    'Status'
                  ),
                  _react2.default.createElement(_materialUi.TableHeaderColumn, { style: { padding: '0' } })
                )
              ),
              _react2.default.createElement(
                _materialUi.TableBody,
                { displayRowCheckbox: false },
                secondaryEmails.map(function (emailObj, i) {
                  return _react2.default.createElement(
                    _materialUi.TableRow,
                    { key: i },
                    _react2.default.createElement(
                      _materialUi.TableRowColumn,
                      { style: { width: fullWidth ? '45%' : '40%' } },
                      emailObj.email
                    ),
                    _react2.default.createElement(
                      _materialUi.TableRowColumn,
                      { style: { width: fullWidth ? '40%' : '20%', textAlign: 'center' } },
                      emailObj.is_confirmed ? 'Confirmed' : 'Pending'
                    ),
                    _ramda2.default.equals(_ramda2.default.propOr('', '_id', editingEmailObj), emailObj._id) ? _react2.default.createElement(
                      _materialUi.TableRowColumn,
                      { style: { padding: '0', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' } },
                      !emailObj.is_confirmed && _react2.default.createElement(_materialUi.FlatButton, {
                        onTouchTap: function onTouchTap() {
                          resendConfirmLink(emailObj.email);
                          resetState();
                        },
                        secondary: true,
                        label: 'Resend Confirmation'
                      }),
                      _react2.default.createElement(_materialUi.FlatButton, {
                        onTouchTap: function onTouchTap() {
                          var confirm = window.confirm('Are you sure that you want to remove ' + emailObj.email + ' ?');
                          if (confirm) {
                            removeSecEmail(emailObj._id);
                            resetState();
                          }
                        },
                        label: 'Remove',
                        primary: true
                      }),
                      _react2.default.createElement(_materialUi.FontIcon, {
                        onTouchTap: function onTouchTap() {
                          return resetState();
                        },
                        className: 'tc-icon-close',
                        style: { fontSize: '14px', color: 'rgba(0, 0, 0, 0.54)', cursor: 'pointer', margin: '4px 10px 0 0' }
                      })
                    ) : _react2.default.createElement(
                      _materialUi.TableRowColumn,
                      { style: { padding: '0', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' } },
                      _react2.default.createElement(_materialUi.FontIcon, {
                        className: 'tc-icon-mode_edit',
                        style: { fontSize: '12px', color: 'rgb(0, 165, 187)', cursor: 'pointer', margin: '0 10px' },
                        onTouchTap: function onTouchTap() {
                          return _this2.setState({ editingEmailObj: emailObj });
                        }
                      })
                    )
                  );
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            title: 'Add New Associated Email',
            actions: [_react2.default.createElement(_materialUi.FlatButton, {
              onTouchTap: function onTouchTap() {
                resetState();
                updateProp({ secondaryEmailsInfo: {} });
              },
              label: 'Cancel',
              primary: true,
              style: { marginLeft: '10px' }
            }), _react2.default.createElement(_materialUi.FlatButton, {
              onTouchTap: function onTouchTap() {
                addSecEmail(tempSecondaryEmail).then(function (res) {
                  if (!_ramda2.default.propOr(false, 'error', res.payload)) {
                    resetState();
                  }
                });
              },
              label: 'Add',
              secondary: true,
              disabled: _ramda2.default.isEmpty(tempSecondaryEmail) || !(0, _validations.isValidEmail)(tempSecondaryEmail)
            })],
            modal: true,
            open: showAddEmail,
            onRequestClose: function onRequestClose() {
              return resetState();
            }
          },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', flexDirection: 'column' } },
            !isNilOrEmpty(_ramda2.default.propOr('', 'error', secondaryEmailsInfo)) && _react2.default.createElement(
              'div',
              { style: { color: 'red', display: 'flex', width: '95%', margin: '0 0 10px 20px' } },
              secondaryEmailsInfo.message
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', justifyContent: 'center' } },
              _react2.default.createElement(_materialUi.TextField, {
                hintText: 'Email',
                value: tempSecondaryEmail,
                onChange: function onChange(_ref) {
                  var value = _ref.target.value;
                  return _this2.setState({ tempSecondaryEmail: value });
                },
                style: { width: '95%' }
              })
            )
          )
        )
      );
    }
  }]);

  return AssocEmails;
}(_react.Component);

AssocEmails.propTypes = {
  resendConfirmLink: _react.PropTypes.func,
  settings: _react.PropTypes.object,
  addSecEmail: _react.PropTypes.func,
  removeSecEmail: _react.PropTypes.func,
  updateProp: _react.PropTypes.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resendConfirmLink: function resendConfirmLink(email) {
      return dispatch((0, _settingsActions.resendSecondaryEmailConfirmationLink)(email));
    },
    removeSecEmail: function removeSecEmail(id) {
      return dispatch((0, _settingsActions.confirmedDisassociateSecondaryEmail)(id));
    },
    addSecEmail: function addSecEmail(email) {
      return dispatch((0, _settingsActions.addSecondaryEmail)(email));
    },
    updateProp: function updateProp() {
      return dispatch(_settingsActions.updateSettingsProps.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var settings = _ref2.settings;
  return {
    settings: settings.toJS()
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AssocEmails);

/***/ }),
/* 3525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _container = __webpack_require__(3526);

var _container2 = _interopRequireDefault(_container);

var _actions = __webpack_require__(253);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var ManageUsers = function ManageUsers(props) {
  var updateProp = props.updateProp,
      companyType = props.companyType,
      corporateAccess = props.corporateAccess,
      isSingleLoc = props.isSingleLoc,
      locAccess = props.locAccess;


  var canUserAddNewUser = function canUserAddNewUser() {
    if (companyType === 'Supplier') {
      var locsUserCanEdit = isSingleLoc ? _ramda2.default.contains('write', _ramda2.default.pathOr([], [0, 'admin'], locAccess)) : _ramda2.default.contains('write', corporateAccess);
      return !isNilOrEmpty(locsUserCanEdit);
    }
    return _ramda2.default.contains('write', corporateAccess);
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: 'flex-tc-sb', style: { paddingBottom: '12px' } },
      _react2.default.createElement(
        'div',
        { style: { fontSize: '24px', fontWeight: 400 } },
        'Manage Users'
      ),
      _react2.default.createElement(_materialUi.RaisedButton, {
        label: 'Add New User',
        icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-add', style: { fontSize: '16px', marginTop: '-3px' } }),
        onTouchTap: function onTouchTap() {
          if (canUserAddNewUser()) {
            updateProp({ addingNewUserDialog: true });
          } else {
            updateProp({ noAccessDialog: true, requestingAccessToFeature: 'User Management', requestAccessData: { type: 'profileAccess' } });
          }
        },
        secondary: true
      })
    ),
    _react2.default.createElement(_materialUi.Divider, null),
    _react2.default.createElement(_container2.default, null)
  );
};

ManageUsers.propTypes = {
  updateProp: _react.PropTypes.func,
  companyType: _react.PropTypes.string,
  isSingleLoc: _react.PropTypes.bool,
  corporateAccess: _react.PropTypes.array,
  locAccess: _react.PropTypes.array
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateUMProps.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user;
  return {
    companyType: user.getIn(['user', 'type']),
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
    corporateAccess: user.get('corporateAccess'),
    locAccess: user.get('locAccess')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ManageUsers);

/***/ }),
/* 3526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _header = __webpack_require__(3527);

var _header2 = _interopRequireDefault(_header);

var _loc = __webpack_require__(3529);

var _loc2 = _interopRequireDefault(_loc);

var _team = __webpack_require__(3531);

var _team2 = _interopRequireDefault(_team);

var _singleLocOrBuyer = __webpack_require__(3532);

var _singleLocOrBuyer2 = _interopRequireDefault(_singleLocOrBuyer);

var _multiLoc = __webpack_require__(3533);

var _multiLoc2 = _interopRequireDefault(_multiLoc);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _actions = __webpack_require__(253);

var _editUserDialog = __webpack_require__(3534);

var _editUserDialog2 = _interopRequireDefault(_editUserDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserManagement = function (_Component) {
  _inherits(UserManagement, _Component);

  function UserManagement() {
    _classCallCheck(this, UserManagement);

    return _possibleConstructorReturn(this, (UserManagement.__proto__ || Object.getPrototypeOf(UserManagement)).apply(this, arguments));
  }

  _createClass(UserManagement, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        muiTheme: this.context.muiTheme
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getUsers(this.props.viewBy);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          viewBy = _props.viewBy,
          isSingleLoc = _props.isSingleLoc,
          isBuyer = _props.isBuyer;


      return _react2.default.createElement(
        'div',
        { style: { width: '100%' } },
        _react2.default.createElement(_header2.default, null),
        _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('location'), _ramda2.default.always(_react2.default.createElement(_loc2.default, null))], [_ramda2.default.equals('team'), _ramda2.default.always(_react2.default.createElement(_team2.default, null))], [_ramda2.default.equals('user'), _ramda2.default.always(isSingleLoc || isBuyer ? _react2.default.createElement(_singleLocOrBuyer2.default, null) : _react2.default.createElement(_multiLoc2.default, null))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement('span', null))]]), viewBy),
        _react2.default.createElement(_editUserDialog2.default, null)
      );
    }
  }]);

  return UserManagement;
}(_react.Component);

UserManagement.contextTypes = {
  muiTheme: _react.PropTypes.object
};

UserManagement.childContextTypes = {
  muiTheme: _react.PropTypes.object
};

UserManagement.propTypes = {
  viewBy: _react.PropTypes.string,
  getUsers: _react.PropTypes.func,
  isSingleLoc: _react.PropTypes.bool,
  isBuyer: _react.PropTypes.bool
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getUsers: function getUsers(viewBy) {
      return dispatch((0, _actions.getUsersByFilter)(viewBy));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var userManagement = _ref.userManagement,
      user = _ref.user;
  return {
    viewBy: userManagement.get('viewBy'),
    isBuyer: user.getIn(['user', 'type']) === 'Contractor',
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop'
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserManagement);

/***/ }),
/* 3527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _actions = __webpack_require__(253);

var _container = __webpack_require__(3528);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(props) {
  var viewBy = props.viewBy,
      updateProp = props.updateProp,
      getUsers = props.getUsers,
      companyType = props.companyType,
      isSingleLoc = props.isSingleLoc,
      isAccom = props.isAccom;


  var views = companyType === 'Contractor' || isSingleLoc ? [{ label: 'Team', value: 'team' }, { label: 'User', value: 'user' }] : [{ label: isAccom ? 'Property' : 'Location', value: 'location' }, { label: 'Team', value: 'team' }, { label: 'User', value: 'user' }];

  return _react2.default.createElement(
    'div',
    { style: { marginTop: '12px', width: '100%' } },
    _react2.default.createElement(
      'div',
      { style: { height: '55px', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
      _react2.default.createElement(
        'div',
        { style: { display: 'flex', alignItems: 'center', padding: '0 2%' } },
        _react2.default.createElement(
          'div',
          { style: { fontSize: '15px' } },
          'Viewing By:'
        ),
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '-5px' } },
          _react2.default.createElement(
            _materialUi.DropDownMenu,
            { value: viewBy, autoWidth: true, underlineStyle: { borderTopColor: '#00bcd4' }, style: { marginTop: '4px' } },
            views.map(function (view, i) {
              return _react2.default.createElement(_materialUi.MenuItem, {
                key: i,
                primaryText: view.label,
                value: view.value,
                onTouchTap: function onTouchTap() {
                  updateProp({ viewBy: view.value });
                  getUsers(view.value);
                }
              });
            })
          )
        )
      )
    ),
    _react2.default.createElement(_container2.default, null)
  );
};

Header.propTypes = {
  viewBy: _react.PropTypes.string,
  updateProp: _react.PropTypes.func,
  getUsers: _react.PropTypes.func,
  companyType: _react.PropTypes.string,
  isSingleLoc: _react.PropTypes.bool,
  triggerNoAccessWarning: _react.PropTypes.func,
  isAccom: _react.PropTypes.bool
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    triggerNoAccessWarning: function triggerNoAccessWarning(payload) {
      return dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload: payload });
    },
    updateProp: function updateProp() {
      return dispatch(_actions.updateUMProps.apply(undefined, arguments));
    },
    getUsers: function getUsers(viewBy) {
      return dispatch((0, _actions.getUsersByFilter)(viewBy));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var userManagement = _ref.userManagement,
      user = _ref.user;
  return {
    viewBy: userManagement.get('viewBy'),
    companyType: user.getIn(['user', 'type']),
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
    isAccom: user.getIn(['company', 'productType']) === 'Accommodation'
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Header);

/***/ }),
/* 3528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(253);

var _materialUi = __webpack_require__(3);

var _userInfo = __webpack_require__(2036);

var _userInfo2 = _interopRequireDefault(_userInfo);

var _multiLocPermissions = __webpack_require__(2037);

var _multiLocPermissions2 = _interopRequireDefault(_multiLocPermissions);

var _singleLocPermissions = __webpack_require__(2038);

var _singleLocPermissions2 = _interopRequireDefault(_singleLocPermissions);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _validations = __webpack_require__(871);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var propTypes = {
  addingNewUserDialog: _react.PropTypes.bool,
  updateProp: _react.PropTypes.func,
  locations: _react.PropTypes.array,
  addNewUser: _react.PropTypes.func,
  companyName: _react.PropTypes.string,
  viewBy: _react.PropTypes.string,
  corporateAccess: _react.PropTypes.array,
  locAccess: _react.PropTypes.array,
  isSingleLoc: _react.PropTypes.bool,
  isAccom: _react.PropTypes.bool,
  isBuyer: _react.PropTypes.bool
};

var AddNewUser = function (_Component) {
  _inherits(AddNewUser, _Component);

  function AddNewUser(props) {
    _classCallCheck(this, AddNewUser);

    var _this = _possibleConstructorReturn(this, (AddNewUser.__proto__ || Object.getPrototypeOf(AddNewUser)).call(this, props));

    _this.componentWillReceiveProps = function (newProps) {
      if (newProps.addingNewUserDialog === false) _this.clearStore();
    };

    _this.handleNext = function () {
      var stepIndex = _this.state.stepIndex;

      if (stepIndex === 0) {
        _this.setState({
          stepIndex: stepIndex + 1
        });
      }
    };

    _this.handlePrev = function () {
      var stepIndex = _this.state.stepIndex;

      if (stepIndex > 0) {
        _this.setState({ stepIndex: stepIndex - 1 });
      }
    };

    _this.clearStore = function () {
      _this.setState({
        stepIndex: 0,
        userInfo: {},
        selectedLocs: []
      });
    };

    _this.state = {
      stepIndex: 0,
      userInfo: {},
      selectedLocs: [],
      corporateProfile: []
    };
    return _this;
  }

  _createClass(AddNewUser, [{
    key: 'getStepContent',
    value: function getStepContent(stepIndex) {
      var _this2 = this;

      var locsUserHasEditAccessTo = _ramda2.default.contains('write', this.props.corporateAccess) ? this.props.locations : this.props.locAccess.filter(function (loc) {
        return _ramda2.default.contains('write', loc.admin);
      });
      var multiLocAcctUserOnlyHasAccessToOneLoc = [{
        admin: _ramda2.default.pathOr([], ['selectedLocs', 0, 'admin'], this.state),
        contracting: _ramda2.default.pathOr([], ['selectedLocs', 0, 'contracting'], this.state),
        profile: _ramda2.default.pathOr([], ['selectedLocs', 0, 'profile'], this.state),
        label: _ramda2.default.pathOr('', [0, 'property_name'], locsUserHasEditAccessTo),
        locId: _ramda2.default.pathOr('', [0, '_id'], locsUserHasEditAccessTo),
        teams: _ramda2.default.pathOr([], ['selectedLocs', 0, 'teams'], this.state),
        value: _ramda2.default.pathOr('', [0, 'property_name'], locsUserHasEditAccessTo)
      }];
      switch (stepIndex) {
        case 0:
          return _react2.default.createElement(_userInfo2.default, _extends({
            editUserInfo: function editUserInfo(userInfo) {
              return _this2.setState({ userInfo: _ramda2.default.merge(_this2.state.userInfo, userInfo) });
            }
          }, this.state.userInfo));
        case 1:
          return this.props.isSingleLoc || this.props.isBuyer ? _react2.default.createElement(_singleLocPermissions2.default, {
            isAccom: this.props.isAccom,
            userName: _ramda2.default.pathOr('', ['userInfo', 'firstName'], this.state) + ' ' + _ramda2.default.pathOr('', ['userInfo', 'lastName'], this.state),
            onLocSelection: function onLocSelection(selectedLocs) {
              return _this2.setState({ selectedLocs: selectedLocs });
            },
            selectedLocs: this.state.selectedLocs,
            showCorporateProfileRadioButtons: _ramda2.default.contains('write', this.props.corporateAccess),
            onCorporateLocCheck: function onCorporateLocCheck() {
              if (isNilOrEmpty(_this2.state.corporateProfile)) {
                _this2.setState({ corporateProfile: ['createLocation', 'read', 'write'] });
              } else {
                _this2.setState({ corporateProfile: [] });
              }
            }
          }) : _react2.default.createElement(_multiLocPermissions2.default, {
            isAccom: this.props.isAccom,
            locations: locsUserHasEditAccessTo,
            userName: _ramda2.default.pathOr('', ['userInfo', 'firstName'], this.state) + ' ' + _ramda2.default.pathOr('', ['userInfo', 'lastName'], this.state),
            onLocSelection: function onLocSelection(selectedLocs) {
              return _this2.setState({ selectedLocs: selectedLocs });
            },
            selectedLocs: locsUserHasEditAccessTo.length === 1 ? multiLocAcctUserOnlyHasAccessToOneLoc : this.state.selectedLocs,
            onlyHasAccessToOneLoc: locsUserHasEditAccessTo.length === 1,
            corporateProfileAccess: !isNilOrEmpty(this.state.corporateProfile),
            showCorporateProfileRadioButtons: _ramda2.default.contains('write', this.props.corporateAccess),
            onCorporateLocCheck: function onCorporateLocCheck() {
              if (isNilOrEmpty(_this2.state.corporateProfile)) {
                _this2.setState({ corporateProfile: ['createLocation', 'read', 'write'] });
              } else {
                _this2.setState({ corporateProfile: [] });
              }
            }
          });
        default:
          return _react2.default.createElement('span', null);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          addingNewUserDialog = _props.addingNewUserDialog,
          updateProp = _props.updateProp,
          addNewUser = _props.addNewUser,
          companyName = _props.companyName,
          viewBy = _props.viewBy,
          locations = _props.locations,
          isSingleLoc = _props.isSingleLoc;
      var _state = this.state,
          stepIndex = _state.stepIndex,
          userInfo = _state.userInfo,
          selectedLocs = _state.selectedLocs,
          corporateProfile = _state.corporateProfile;


      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          title: _react2.default.createElement(
            'div',
            { style: { padding: 0 } },
            _react2.default.createElement(
              'div',
              { style: { padding: '10px 20px', width: '100%', backgroundColor: 'rgb(0, 188, 212)', color: 'white' } },
              'Add New User'
            ),
            _react2.default.createElement(
              _materialUi.Stepper,
              { activeStep: stepIndex, style: { height: '60px', width: '80%', margin: '0 auto' } },
              _react2.default.createElement(
                _materialUi.Step,
                null,
                _react2.default.createElement(
                  _materialUi.StepLabel,
                  null,
                  'User Info'
                )
              ),
              _react2.default.createElement(
                _materialUi.Step,
                null,
                _react2.default.createElement(
                  _materialUi.StepLabel,
                  null,
                  'Set Permissions'
                )
              )
            )
          ),
          actions: [_react2.default.createElement(_materialUi.FlatButton, {
            label: 'Back',
            disabled: stepIndex === 0,
            onTouchTap: this.handlePrev,
            style: { float: 'left' }
          }), _react2.default.createElement(_materialUi.FlatButton, {
            label: 'Cancel',
            primary: true,
            onTouchTap: function onTouchTap() {
              updateProp({ addingNewUserDialog: false });
              _this3.clearStore();
            }
          }), _react2.default.createElement(_materialUi.FlatButton, {
            label: stepIndex === 1 ? 'Submit' : 'Next',
            secondary: true,
            disabled: stepIndex === 0 && _ramda2.default.isEmpty(_ramda2.default.propOr('', 'firstName', userInfo)) || _ramda2.default.isEmpty(_ramda2.default.propOr('', 'lastName', userInfo)) || _ramda2.default.isEmpty(_ramda2.default.propOr('', 'email', userInfo)) || !(0, _validations.isValidEmail)(_ramda2.default.propOr('', 'email', userInfo)),
            onTouchTap: function onTouchTap() {
              _this3.handleNext();
              if (stepIndex === 0 && (isSingleLoc || _this3.props.isBuyer)) {
                _this3.setState({ selectedLocs: [{
                    admin: [],
                    contracting: [],
                    profile: [],
                    label: _ramda2.default.pathOr('', [0, 'property_name'], locations),
                    locId: _ramda2.default.pathOr(undefined, [0, '_id'], locations),
                    teams: [],
                    value: _ramda2.default.pathOr('', [0, 'property_name'], locations)
                  }] });
              }
              if (stepIndex === 1) {
                addNewUser({ userInfo: userInfo, selectedLocs: selectedLocs, companyName: companyName, viewBy: viewBy, corporateProfile: corporateProfile });
              }
            }
          })],
          modal: true,
          autoScrollBodyContent: true,
          open: addingNewUserDialog,
          onRequestClose: function onRequestClose() {
            return updateProp({ addingNewUserDialog: false });
          },
          bodyStyle: { minHeight: '200px' },
          contentStyle: { width: '75%' }
        },
        _react2.default.createElement(
          'div',
          { style: { margin: '20px 0 15px 20px' } },
          this.getStepContent(stepIndex)
        )
      );
    }
  }]);

  return AddNewUser;
}(_react.Component);

AddNewUser.propTypes = propTypes;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateUMProps.apply(undefined, arguments));
    },
    addNewUser: function addNewUser() {
      return dispatch(_actions.addUser.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var userManagement = _ref.userManagement,
      user = _ref.user;
  return {
    viewBy: userManagement.get('viewBy'),
    addingNewUserDialog: userManagement.get('addingNewUserDialog'),
    locations: user.get('allLocations'),
    companyName: user.getIn(['company', 'companyName']),
    isBuyer: user.getIn(['user', 'type']) === 'Contractor',
    corporateAccess: user.get('corporateAccess'),
    locAccess: user.get('locAccess'),
    userId: user.get('id'),
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
    isAccom: user.getIn(['company', 'productType']) === 'Accommodation'
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddNewUser);

/***/ }),
/* 3529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(253);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _teamPermissionOptions = __webpack_require__(1006);

var _noLocs = __webpack_require__(3530);

var _noLocs2 = _interopRequireDefault(_noLocs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var propTypes = {
  updateProp: _react.PropTypes.func,
  locations: _react.PropTypes.array,
  userId: _react.PropTypes.string,
  locAccess: _react.PropTypes.array,
  locationSort: _react.PropTypes.array,
  triggerNoAccessWarning: _react.PropTypes.func
};

var LocView = function (_Component) {
  _inherits(LocView, _Component);

  function LocView(props) {
    _classCallCheck(this, LocView);

    var _this = _possibleConstructorReturn(this, (LocView.__proto__ || Object.getPrototypeOf(LocView)).call(this, props));

    _this.state = {
      // expandedLocId: '',
      sortBy: '', // name or email
      sortDirection: 'forward', // forward (a to z) or backward (z to a)
      sortedUsers: null
    };
    return _this;
  }

  _createClass(LocView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          updateProp = _props.updateProp,
          userId = _props.userId,
          locationSort = _props.locationSort,
          isAccom = _props.isAccom;
      var _state = this.state,
          sortDirection = _state.sortDirection,
          sortedUsers = _state.sortedUsers,
          sortBy = _state.sortBy;

      var sortedByLocs = _ramda2.default.uniq(_ramda2.default.pluck('locId')(locationSort)).reduce(function (result, locId) {
        result.push({
          locId: locId,
          locName: _ramda2.default.uniq(_ramda2.default.pluck('locName')(locationSort.filter(function (loc) {
            return loc.locId === locId;
          })))[0],
          users: locationSort.filter(function (loc) {
            return loc.locId === locId;
          })
        });
        return result;
      }, []);

      var alphaSort = function alphaSort(toBeSorted, direction, fieldName) {
        if (direction === 'forward') return toBeSorted.sort(function (a, b) {
          return a[fieldName] > b[fieldName] ? 1 : b[fieldName] > a[fieldName] ? -1 : 0;
        });
        return toBeSorted.sort(function (a, b) {
          return a[fieldName] < b[fieldName] ? 1 : b[fieldName] < a[fieldName] ? -1 : 0;
        });
      };

      var sortAZZA = function sortAZZA(field, usersToSort) {
        return _react2.default.createElement(_materialUi.IconButton, {
          iconClassName: _ramda2.default.equals(field, sortBy) ? _ramda2.default.equals(sortDirection, 'forward') ? 'tc-icon-move-down' : 'tc-icon-move-up' : 'tc-icon-move-down',
          iconStyle: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', marginTop: '5px' },
          tooltip: _ramda2.default.equals(sortDirection, 'forward') ? 'A-Z' : 'Z-A',
          onTouchTap: function onTouchTap() {
            var fieldName = field === 'email' ? 'email' : 'firstName';
            var sorted = _ramda2.default.equals(sortDirection, 'forward') ? alphaSort(usersToSort, 'forward', fieldName) : alphaSort(usersToSort, 'backwards', fieldName);
            _this2.setState({ sortBy: field, sortDirection: _ramda2.default.equals(sortDirection, 'forward') ? 'backward' : 'forward', sortedUsers: sorted });
          }
        });
      };

      return _react2.default.createElement(
        'div',
        { style: { width: '100%' } },
        _ramda2.default.isEmpty(sortedByLocs) ? _react2.default.createElement(_noLocs2.default, null) : _react2.default.createElement(
          'div',
          null,
          sortedByLocs.map(function (loc, i) {
            var isUserInListOfLocUsers = _ramda2.default.contains(userId, _ramda2.default.pluck('userId')(loc.users));
            var findUserObj = _ramda2.default.propOr({}, 0, loc.users.filter(function (obj) {
              return obj.userId === userId;
            }));
            var userAccessInUserManagement = _ramda2.default.uniq(isUserInListOfLocUsers && findUserObj.admin ? findUserObj.admin : []);
            var location = sortedByLocs.filter(function (obj) {
              return obj.locId === loc.locId;
            });
            var locationUsers = sortedUsers ? sortedUsers : _ramda2.default.pathOr([], [0, 'users'], location);
            var numOfUsers = _ramda2.default.propOr(0, 'length', locationUsers);
            var shouldCardExpand = numOfUsers > 0 && _ramda2.default.contains('read', userAccessInUserManagement);
            return _react2.default.createElement(
              _materialUi.Card,
              {
                key: i,
                onTouchTap: function onTouchTap() {
                  if (!_ramda2.default.contains('read', userAccessInUserManagement)) {
                    _this2.props.triggerNoAccessWarning({ noAccessDialog: true, requestingAccessToFeature: 'User Management', requestAccessData: { type: 'locationAccess', loc: _ramda2.default.omit(['users'], loc) } });
                  }
                },
                style: { backgroundColor: '#fafafa', boxShadow: 'none', borderBottom: _ramda2.default.equals(i, sortedByLocs.length - 1) ? '' : '1px solid #e0e0e0', marginBottom: '4px' }
              },
              _react2.default.createElement(
                _materialUi.CardHeader,
                { actAsExpander: shouldCardExpand, showExpandableButton: shouldCardExpand, textStyle: { display: 'none' } },
                _react2.default.createElement(
                  'div',
                  { style: { display: 'flex', justifyContent: 'space-between', width: '95%' } },
                  _react2.default.createElement(
                    'div',
                    null,
                    loc.locName.charAt(0).toUpperCase() + loc.locName.slice(1)
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    numOfUsers,
                    ' ',
                    _ramda2.default.equals(numOfUsers, 1) ? 'User' : 'Users'
                  )
                )
              ),
              _react2.default.createElement(
                _materialUi.CardText,
                { expandable: true, style: { padding: 0 } },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    _materialUi.Table,
                    { wrapperStyle: { overflow: 'visible' }, style: { backgroundColor: '#fafafa' }, bodyStyle: { overflow: 'visible' } },
                    _react2.default.createElement(
                      _materialUi.TableHeader,
                      { adjustForCheckbox: false, displaySelectAll: false },
                      _react2.default.createElement(
                        _materialUi.TableRow,
                        null,
                        _react2.default.createElement(
                          _materialUi.TableHeaderColumn,
                          { style: { width: '23%', textAlign: 'center' } },
                          _react2.default.createElement(
                            'span',
                            null,
                            'Name'
                          ),
                          sortAZZA('name', locationUsers)
                        ),
                        _react2.default.createElement(
                          _materialUi.TableHeaderColumn,
                          { style: { width: '23%', textAlign: 'center' } },
                          _react2.default.createElement(
                            'span',
                            null,
                            'Email'
                          ),
                          sortAZZA('email', locationUsers)
                        ),
                        _react2.default.createElement(
                          _materialUi.TableHeaderColumn,
                          { style: { width: '18%', textAlign: 'center' } },
                          'Team(s)'
                        ),
                        _react2.default.createElement(
                          _materialUi.TableHeaderColumn,
                          { style: { width: '9%', padding: 0, textAlign: 'center' } },
                          _react2.default.createElement(
                            'div',
                            { style: { overflow: 'hidden', wordWrap: 'break-word', whiteSpace: 'pre-wrap', display: 'flex', alignContent: 'flex-start', justifyContent: 'flex-start' } },
                            'Create ',
                            isAccom ? 'Property' : 'Location'
                          )
                        ),
                        _react2.default.createElement(
                          _materialUi.TableHeaderColumn,
                          { style: { width: '9%', padding: 0, textAlign: 'center', overflow: 'hidden' } },
                          'User ',
                          _react2.default.createElement('br', null),
                          ' Management'
                        ),
                        _react2.default.createElement(
                          _materialUi.TableHeaderColumn,
                          { style: { width: '9%', padding: 0, textAlign: 'center', overflow: 'hidden' } },
                          'Contracting'
                        ),
                        _react2.default.createElement(_materialUi.TableHeaderColumn, { style: { width: '9%' } })
                      )
                    ),
                    _react2.default.createElement(
                      _materialUi.TableBody,
                      { displayRowCheckbox: false },
                      locationUsers.map(function (user, j) {
                        var userAccess = _ramda2.default.cond([[_ramda2.default.equals('profile'), _ramda2.default.always(isNilOrEmpty(user.profile) ? ['read'] : ['read', 'write'])], [_ramda2.default.T, function (feature) {
                          return _ramda2.default.prop(0, _ramda2.default.pluck('value')(_teamPermissionOptions.availableAccess.filter(function (obj) {
                            return _ramda2.default.equals(obj.value, _ramda2.default.pathOr([], [j, feature], locationUsers));
                          })));
                        }]]);
                        var accessIcons = _ramda2.default.cond([[_ramda2.default.equals(['read', 'write']), _ramda2.default.always(_react2.default.createElement(
                          'span',
                          { style: { width: '100%' } },
                          _react2.default.createElement(_materialUi.IconButton, { tooltip: 'Read Access', iconClassName: 'tc-icon-remove_red_eye', iconStyle: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', padding: 0, marginTop: '5px' }, style: { width: '50%' } }),
                          _react2.default.createElement(_materialUi.IconButton, { tooltip: 'Write Access', iconClassName: 'tc-icon-mode_edit', iconStyle: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', padding: 0, marginTop: '5px' }, style: { width: '50%' } })
                        ))], [_ramda2.default.equals(['read']), _ramda2.default.always(_react2.default.createElement(
                          'span',
                          null,
                          _react2.default.createElement(_materialUi.IconButton, { tooltip: 'Read Access', iconClassName: 'tc-icon-remove_red_eye', iconStyle: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', padding: 0, marginTop: '5px' } })
                        ))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(
                          'span',
                          null,
                          _react2.default.createElement(_materialUi.IconButton, { tooltip: 'No Access', iconClassName: 'tc-icon-block', iconStyle: { color: 'rgba(255, 64, 129, 0.8)', fontSize: '14px', padding: 0, marginTop: '5px' } })
                        ))]]);
                        return _react2.default.createElement(
                          _materialUi.TableRow,
                          { key: j },
                          _react2.default.createElement(
                            _materialUi.TableRowColumn,
                            { style: { width: '23%' } },
                            user.firstName + ' ' + user.lastName
                          ),
                          _react2.default.createElement(
                            _materialUi.TableRowColumn,
                            { style: { width: '23%' } },
                            user.email
                          ),
                          _react2.default.createElement(
                            _materialUi.TableRowColumn,
                            { style: { width: '18%' } },
                            user.teams.sort(function (a, b) {
                              return a > b ? 1 : b > a ? -1 : 0;
                            }).join(', ')
                          ),
                          _react2.default.createElement(
                            _materialUi.TableRowColumn,
                            { style: { width: '9%', padding: 0, overflow: 'visible', textAlign: 'center', borderLeft: '1px solid #D3D3D3' } },
                            accessIcons(userAccess('profile'))
                          ),
                          _react2.default.createElement(
                            _materialUi.TableRowColumn,
                            { style: { width: '9%', padding: 0, overflow: 'visible', textAlign: 'center', borderLeft: '1px solid #D3D3D3', borderRight: '1px solid #D3D3D3' } },
                            accessIcons(userAccess('admin'))
                          ),
                          _react2.default.createElement(
                            _materialUi.TableRowColumn,
                            { style: { width: '9%', padding: 0, overflow: 'visible', textAlign: 'center', borderRight: '1px solid #D3D3D3' } },
                            accessIcons(userAccess('contracting'))
                          ),
                          _react2.default.createElement(
                            _materialUi.TableRowColumn,
                            { style: { width: '9%', padding: 0, textAlign: 'right' } },
                            _react2.default.createElement(
                              _materialUi.IconMenu,
                              { iconButtonElement: _react2.default.createElement(_materialUi.IconButton, { iconClassName: 'tc-icon-more-vert', iconStyle: { color: 'rgba(0, 0, 0, 0.54)' } }) },
                              _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Edit', onTouchTap: function onTouchTap() {
                                  if (_ramda2.default.contains('write', userAccessInUserManagement)) {
                                    var selectedUser = locationUsers[j];
                                    var locName = _ramda2.default.propOr('', 'locName', selectedUser);
                                    var locs = [{ label: locName, value: locName, locId: selectedUser.locId, locName: locName }];
                                    updateProp({
                                      editUserDialog: true,
                                      editedUser: _ramda2.default.merge(selectedUser, { allLocsSelected: false, locs: locs }),
                                      originalUser: _ramda2.default.merge(selectedUser, { locs: locs }) });
                                    if (sortedUsers) _this2.setState({ sortedUsers: null, sortBy: '', sortDirection: 'forward' });
                                  } else {
                                    _this2.props.triggerNoAccessWarning({ noAccessDialog: true, requestingAccessToFeature: 'User Management', requestAccessData: { type: 'locationAccess', loc: _ramda2.default.omit(['users'], loc) } });
                                  }
                                }
                              })
                            )
                          )
                        );
                      })
                    )
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);

  return LocView;
}(_react.Component);

LocView.propTypes = propTypes;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateUMProps.apply(undefined, arguments));
    },
    triggerNoAccessWarning: function triggerNoAccessWarning(payload) {
      return dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload: payload });
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var userManagement = _ref.userManagement,
      user = _ref.user;
  return {
    userId: user.get('id'),
    locAccess: user.get('locAccess'),
    locationSort: userManagement.get('locationSort').toJS(),
    isAccom: user.getIn(['company', 'productType']) === 'Accommodation'
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LocView);

/***/ }),
/* 3530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _globalErrorsDisplayActions = __webpack_require__(486);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoLocs = function NoLocs(props) {
  var corporateAccess = props.corporateAccess,
      requestingAccess = props.requestingAccess,
      requestAccessError = props.requestAccessError,
      requestAccess = props.requestAccess,
      companyType = props.companyType,
      firstName = props.firstName,
      lastName = props.lastName;


  return _react2.default.createElement(
    'div',
    { style: { textAlign: 'center', fontSize: '24px', padding: '5%' } },
    'You do not have any locations.',
    _react2.default.createElement('br', null),
    _react2.default.createElement('br', null),
    _ramda2.default.contains('createLocation', corporateAccess) ? _react2.default.createElement(
      'div',
      { style: { fontSize: '14px' } },
      'Please click ',
      _react2.default.createElement(
        'a',
        { href: '/profile', style: { cursor: 'pointer' } },
        'here'
      ),
      ' to add a location.'
    ) : _react2.default.createElement(
      'div',
      { style: { lineHeight: 1.5, fontSize: '14px' } },
      _react2.default.createElement(
        'div',
        null,
        requestingAccess ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_materialUi.CircularProgress, null)
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            null,
            'The administrator has not given you access to add locations. If you believe this is in error, please click',
            _react2.default.createElement(
              'a',
              {
                style: { cursor: requestAccessError ? 'not-allowed' : 'pointer', color: requestAccessError ? 'rgb(84, 84, 84)' : '' },
                onTouchTap: function onTouchTap() {
                  if (!requestAccessError) requestAccess({ feature: 'the corporate profile', companyType: companyType, firstName: firstName, lastName: lastName });
                }
              },
              ' here'
            ),
            ' to request access.'
          ),
          _react2.default.createElement(
            'div',
            null,
            !requestingAccess && requestAccessError && _react2.default.createElement(
              'div',
              { style: { color: 'red', fontSize: '16px', marginTop: '10px' } },
              requestAccessError
            )
          )
        )
      )
    )
  );
};

NoLocs.propTypes = {
  corporateAccess: _react.PropTypes.array,
  requestingAccess: _react.PropTypes.bool,
  requestAccessError: _react.PropTypes.string,
  requestAccess: _react.PropTypes.func,
  companyType: _react.PropTypes.string,
  firstName: _react.PropTypes.string,
  lastName: _react.PropTypes.string
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    requestAccess: function requestAccess(payload) {
      return dispatch((0, _globalErrorsDisplayActions.requestAccessFromAdmin)(payload));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var globalErrors = _ref.globalErrors,
      user = _ref.user;
  return {
    companyType: user.getIn(['user', 'type']),
    corporateAccess: user.get('corporateAccess'),
    firstName: user.get('firstName'),
    lastName: user.get('lastName'),
    requestingAccess: globalErrors.get('requestingAccess'),
    requestAccessError: globalErrors.get('requestAccessError')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NoLocs);

/***/ }),
/* 3531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(253);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _teamPermissionOptions = __webpack_require__(1006);

var _accessIcons = __webpack_require__(1272);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var propTypes = {
  updateProp: _react.PropTypes.func,
  userManagementReducer: _react.PropTypes.object,
  userId: _react.PropTypes.string,
  locations: _react.PropTypes.array,
  companyType: _react.PropTypes.string,
  isSingleLoc: _react.PropTypes.bool,
  locAccess: _react.PropTypes.array,
  triggerNoAccessWarning: _react.PropTypes.func
};

var TeamView = function (_Component) {
  _inherits(TeamView, _Component);

  function TeamView(props) {
    _classCallCheck(this, TeamView);

    var _this = _possibleConstructorReturn(this, (TeamView.__proto__ || Object.getPrototypeOf(TeamView)).call(this, props));

    _this.state = {
      sortBy: '', // name or email
      sortDirection: 'forward', // forward (a to z) or backward (z to a)
      sortedMembers: null,
      showAllLocNames: false
    };
    return _this;
  }

  _createClass(TeamView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          updateProp = _props.updateProp,
          userManagementReducer = _props.userManagementReducer,
          locations = _props.locations,
          userId = _props.userId,
          companyType = _props.companyType,
          isSingleLoc = _props.isSingleLoc,
          locAccess = _props.locAccess;
      var _state = this.state,
          sortDirection = _state.sortDirection,
          sortBy = _state.sortBy,
          sortedMembers = _state.sortedMembers,
          showAllLocNames = _state.showAllLocNames,
          anchorEl = _state.anchorEl;


      var showLocColumn = !_ramda2.default.equals(companyType, 'Contractor') && !isSingleLoc;

      var sortAZZA = function sortAZZA(field, membersToSort) {
        return _react2.default.createElement(_materialUi.IconButton, {
          iconClassName: _ramda2.default.equals(field, sortBy) ? _ramda2.default.equals(sortDirection, 'forward') ? 'tc-icon-move-down' : 'tc-icon-move-up' : 'tc-icon-move-down',
          iconStyle: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', marginTop: '5px' },
          tooltip: _ramda2.default.equals(sortDirection, 'forward') ? 'A-Z' : 'Z-A',
          onTouchTap: function onTouchTap() {
            var fieldName = field === 'email' ? 'email' : 'firstName';
            var sorted = _ramda2.default.equals(sortDirection, 'forward') ? membersToSort.sort(function (a, b) {
              return a[fieldName] > b[fieldName] ? 1 : b[fieldName] > a[fieldName] ? -1 : 0;
            }) : membersToSort.sort(function (a, b) {
              return a[fieldName] < b[fieldName] ? 1 : b[fieldName] < a[fieldName] ? -1 : 0;
            });
            _this2.setState({
              sortBy: field,
              sortDirection: _ramda2.default.equals(sortDirection, 'forward') ? 'backward' : 'forward',
              sortedMembers: sorted
            });
          }
        });
      };

      return _react2.default.createElement(
        'div',
        { style: { width: '100%' } },
        _teamPermissionOptions.teams.map(function (team, i) {
          var members = sortedMembers ? sortedMembers : _ramda2.default.propOr([], team, userManagementReducer);
          var userAccessInTeam = isSingleLoc ? _ramda2.default.pathOr([], [0, 'admin'], locAccess) : _ramda2.default.uniq(_ramda2.default.pathOr([], [0, team], members.filter(function (mem) {
            return mem.userId === userId;
          })));
          var numOfUsersInTeam = _ramda2.default.propOr(0, 'length', members);
          var shouldCardExpand = !_ramda2.default.propEq('length', 0, members);
          return _react2.default.createElement(
            _materialUi.Card,
            {
              key: i,
              style: { backgroundColor: '#fafafa', boxShadow: 'none', borderBottom: _ramda2.default.equals(i, _teamPermissionOptions.teams.length - 1) ? '' : '1px solid #e0e0e0', marginBottom: '4px' }
            },
            _react2.default.createElement(
              _materialUi.CardHeader,
              { actAsExpander: shouldCardExpand, showExpandableButton: shouldCardExpand, textStyle: { display: 'none' } },
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', justifyContent: 'space-between', width: '95%' } },
                _react2.default.createElement(
                  'div',
                  null,
                  'Team ',
                  team.charAt(0).toUpperCase() + team.slice(1)
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  numOfUsersInTeam,
                  ' ',
                  _ramda2.default.equals(numOfUsersInTeam, 1) ? 'User' : 'Users'
                )
              )
            ),
            _react2.default.createElement(
              _materialUi.CardText,
              { expandable: true, style: { padding: 0 } },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _materialUi.Table,
                  { style: { backgroundColor: '#fafafa' }, wrapperStyle: { overflow: 'visible' }, bodyStyle: { overflow: 'visible' } },
                  _react2.default.createElement(
                    _materialUi.TableHeader,
                    { adjustForCheckbox: false, displaySelectAll: false },
                    _react2.default.createElement(
                      _materialUi.TableRow,
                      null,
                      _react2.default.createElement(
                        _materialUi.TableHeaderColumn,
                        { style: { width: '21%', textAlign: 'center' } },
                        _react2.default.createElement(
                          'span',
                          null,
                          'Name'
                        ),
                        sortAZZA('name', members)
                      ),
                      _react2.default.createElement(
                        _materialUi.TableHeaderColumn,
                        { style: { width: '21%', textAlign: 'center' } },
                        _react2.default.createElement(
                          'span',
                          { style: { marginLeft: '5px' } },
                          _react2.default.createElement(
                            'span',
                            null,
                            'Email'
                          ),
                          sortAZZA('email', members)
                        )
                      ),
                      showLocColumn && _react2.default.createElement(
                        _materialUi.TableHeaderColumn,
                        { style: { width: '22%', textAlign: 'center' } },
                        _react2.default.createElement(
                          'span',
                          { style: { marginLeft: '6px' } },
                          'Location(s)'
                        )
                      ),
                      Boolean(companyType === 'Contractor' || isSingleLoc) && _react2.default.createElement(
                        _materialUi.TableHeaderColumn,
                        { style: { width: '9%', padding: 0, textAlign: 'center', overflow: 'hidden' } },
                        'User ',
                        _react2.default.createElement('br', null),
                        ' Management'
                      ),
                      Boolean(companyType === 'Contractor' || isSingleLoc) && _react2.default.createElement(
                        _materialUi.TableHeaderColumn,
                        { style: { width: '9%', padding: 0, textAlign: 'center', overflow: 'hidden' } },
                        'Contracting'
                      ),
                      _react2.default.createElement(_materialUi.TableHeaderColumn, { style: { width: '9%' } })
                    )
                  ),
                  _react2.default.createElement(
                    _materialUi.TableBody,
                    { displayRowCheckbox: false },
                    members.map(function (member, j) {
                      var numOfLocs = _ramda2.default.pathOr(0, ['locNames', 'length'], member);
                      var multiLocShowNum = numOfLocs > 1 ? numOfLocs + ' Locations' : _ramda2.default.pluck('locName')(member.locNames).join(', ');
                      var userAccess = _ramda2.default.cond([[_ramda2.default.equals('profile'), _ramda2.default.always(isNilOrEmpty(member.profile) ? ['read'] : ['read', 'write'])], [_ramda2.default.T, function (feature) {
                        return _ramda2.default.prop(0, _ramda2.default.pluck('value')(_teamPermissionOptions.availableAccess.filter(function (obj) {
                          return _ramda2.default.equals(obj.value, member[feature]);
                        })));
                      }]]);
                      return _react2.default.createElement(
                        _materialUi.TableRow,
                        { key: j },
                        _react2.default.createElement(
                          _materialUi.TableRowColumn,
                          { style: { width: '21%' } },
                          member.firstName + ' ' + member.lastName
                        ),
                        _react2.default.createElement(
                          _materialUi.TableRowColumn,
                          { style: { width: '21%' } },
                          member.email
                        ),
                        showLocColumn && _react2.default.createElement(
                          _materialUi.TableRowColumn,
                          {
                            style: { width: '22%', cursor: numOfLocs > 1 ? 'pointer' : 'default', textAlign: 'center' },
                            onTouchTap: numOfLocs > 1 ? function (e) {
                              e.preventDefault();
                              _this2.setState({ showAllLocNames: true, anchorEl: e.currentTarget });
                            } : function () {}
                          },
                          multiLocShowNum,
                          numOfLocs > 1 && showAllLocNames && _react2.default.createElement(
                            _materialUi.Popover,
                            {
                              open: showAllLocNames,
                              onRequestClose: function onRequestClose() {
                                return _this2.setState({ showAllLocNames: false, anchorEl: null });
                              },
                              anchorEl: anchorEl,
                              anchorOrigin: { horizontal: 'middle', vertical: 'bottom' },
                              targetOrigin: { horizontal: 'left', vertical: 'top' }
                            },
                            _react2.default.createElement(
                              _materialUi.Menu,
                              null,
                              member.locNames.map(function (loc, l) {
                                return _react2.default.createElement(_materialUi.MenuItem, { key: l, primaryText: loc, style: { cursor: 'default' } });
                              })
                            )
                          )
                        ),
                        Boolean(companyType === 'Contractor' || isSingleLoc) && _react2.default.createElement(
                          _materialUi.TableRowColumn,
                          { style: { width: '9%', padding: '0', overflow: 'visible', textAlign: 'center', borderLeft: '1px solid #D3D3D3', borderRight: '1px solid #D3D3D3' } },
                          (0, _accessIcons.getAccessIcons)(userAccess('admin'))
                        ),
                        Boolean(companyType === 'Contractor' || isSingleLoc) && _react2.default.createElement(
                          _materialUi.TableRowColumn,
                          { style: { width: '9%', padding: '0', overflow: 'visible', textAlign: 'center', borderRight: '1px solid #D3D3D3' } },
                          (0, _accessIcons.getAccessIcons)(userAccess('contracting'))
                        ),
                        _react2.default.createElement(
                          _materialUi.TableRowColumn,
                          { style: { width: '9%', padding: 0, textAlign: 'right' } },
                          _react2.default.createElement(
                            _materialUi.IconMenu,
                            { iconButtonElement: _react2.default.createElement(_materialUi.IconButton, { iconClassName: 'tc-icon-more-vert', iconStyle: { color: 'rgba(0, 0, 0, 0.54)' } }) },
                            _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Edit', onTouchTap: function onTouchTap() {
                                if (_ramda2.default.contains('write', userAccessInTeam)) {
                                  updateProp({
                                    editUserDialog: true,
                                    editedUser: _ramda2.default.merge(members[j], {
                                      allLocsSelected: _ramda2.default.equals(_ramda2.default.pathOr(0, [j, 'locs', 'length'], members), locations.length),
                                      locs: _ramda2.default.pathOr([], [j, 'locs'], members).map(function (loc) {
                                        return {
                                          label: loc.locName,
                                          value: loc.locName,
                                          locId: loc.locId,
                                          locName: loc.locName,
                                          _id: _ramda2.default.pathOr('', [0, '_id'], _ramda2.default.propOr([], 'locs', members[j]).filter(function (obj) {
                                            return obj.locId === loc.locId;
                                          }))
                                        };
                                      })
                                    }),
                                    originalUser: members[j] });
                                  if (sortedMembers) _this2.setState({ sortedMembers: null, sortBy: '', sortDirection: 'forward' });
                                } else {
                                  _this2.props.triggerNoAccessWarning({ noAccessDialog: true, requestingAccessToFeature: 'User Management', requestAccessData: { type: 'teamAccess', team: team } });
                                }
                              }
                            })
                          )
                        )
                      );
                    })
                  )
                )
              )
            )
          );
        })
      );
    }
  }]);

  return TeamView;
}(_react.Component);

TeamView.propTypes = propTypes;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    triggerNoAccessWarning: function triggerNoAccessWarning(payload) {
      return dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload: payload });
    },
    updateProp: function updateProp() {
      return dispatch(_actions.updateUMProps.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var userManagement = _ref.userManagement,
      user = _ref.user;
  return {
    userManagementReducer: userManagement.toJS(),
    locations: user.get('allLocations'),
    locAccess: user.get('locAccess'),
    userId: user.get('id'),
    companyType: user.getIn(['user', 'type']),
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop'
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TeamView);

/***/ }),
/* 3532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _titlecase = __webpack_require__(549);

var _actions = __webpack_require__(253);

var _settingsActions = __webpack_require__(976);

var _teamPermissionOptions = __webpack_require__(1006);

var _accessIcons = __webpack_require__(1272);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  cell: { width: '9%', padding: 0, overflow: 'visible', textAlign: 'center', borderLeft: '1px solid #D3D3D3' }
};

var SingleLocOrBuyer = function (_Component) {
  _inherits(SingleLocOrBuyer, _Component);

  function SingleLocOrBuyer() {
    _classCallCheck(this, SingleLocOrBuyer);

    var _this = _possibleConstructorReturn(this, (SingleLocOrBuyer.__proto__ || Object.getPrototypeOf(SingleLocOrBuyer)).call(this));

    _this.state = {
      sortBy: '', // name or email
      sortDirection: 'forward', // forward (a to z) or backward (z to a)
      sortedMembers: null
    };
    return _this;
  }

  _createClass(SingleLocOrBuyer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          settings = _props.settings,
          corporateAdminAccess = _props.corporateAdminAccess,
          allLocations = _props.allLocations,
          isBuyer = _props.isBuyer,
          userManagementReducer = _props.userManagementReducer,
          updateProp = _props.updateProp,
          resendConfirmationLink = _props.resendConfirmationLink,
          userId = _props.userId,
          removeUser = _props.removeUser,
          isAccom = _props.isAccom;
      var _state = this.state,
          sortDirection = _state.sortDirection,
          sortBy = _state.sortBy,
          sortedMembers = _state.sortedMembers;

      var usersArray = _ramda2.default.propOr([], 'usersArray', userManagementReducer);
      var singleLocationInfo = _ramda2.default.pathOr([], [0], allLocations);
      var addUserMessage = settings.get('addUserMessage');
      var manageUsersMessage = settings.get('manageUsersMessage') ? _react2.default.createElement(
        'p',
        { style: { color: 'green' } },
        settings.get('manageUsersMessage')
      ) : undefined;
      var sortAZZA = function sortAZZA(field, membersToSort) {
        return _react2.default.createElement(_materialUi.IconButton, {
          iconClassName: _ramda2.default.equals(field, sortBy) && !_ramda2.default.equals(sortDirection, 'forward') ? 'tc-icon-move-up' : 'tc-icon-move-down',
          iconStyle: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', marginTop: '5px' },
          tooltip: _ramda2.default.equals(sortDirection, 'forward') ? 'A-Z' : 'Z-A',
          onTouchTap: function onTouchTap() {
            var fieldName = field === 'email' ? 'email' : 'first_name';
            var sorted = _ramda2.default.equals(sortDirection, 'forward') ? membersToSort.sort(function (a, b) {
              return a[fieldName] > b[fieldName] ? 1 : b[fieldName] > a[fieldName] ? -1 : 0;
            }) : membersToSort.sort(function (a, b) {
              return a[fieldName] < b[fieldName] ? 1 : b[fieldName] < a[fieldName] ? -1 : 0;
            });
            _this2.setState({
              sortBy: field,
              sortDirection: _ramda2.default.equals(sortDirection, 'forward') ? 'backward' : 'forward',
              sortedMembers: sorted
            });
          }
        });
      };
      var users = sortedMembers ? sortedMembers : usersArray;

      return _react2.default.createElement(
        'div',
        null,
        this.props.settings.get('addUserMessage').hasOwnProperty('emailExists') && addUserMessage.emailExists === false && addUserMessage.message && _react2.default.createElement(
          'p',
          { style: { color: 'green' } },
          addUserMessage.message
        ),
        manageUsersMessage,
        _react2.default.createElement(
          _materialUi.Table,
          { style: { backgroundColor: '#fafafa' }, selectable: false, wrapperStyle: { overflow: 'visible' }, bodyStyle: { overflow: 'visible' } },
          _react2.default.createElement(
            _materialUi.TableHeader,
            { displaySelectAll: false, adjustForCheckbox: false },
            _react2.default.createElement(
              _materialUi.TableRow,
              null,
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { style: { width: '20%', textAlign: 'center' } },
                _react2.default.createElement(
                  'span',
                  null,
                  'Name'
                ),
                sortAZZA('name', users)
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { style: { width: '20%', textAlign: 'center' } },
                _react2.default.createElement(
                  'span',
                  null,
                  'Email'
                ),
                sortAZZA('email', users)
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { style: { width: '12%', textAlign: 'center' } },
                'Status'
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { style: { width: '12%', textAlign: 'center' } },
                'Team'
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { style: { width: '9%', padding: 0, textAlign: 'center', overflow: 'hidden' } },
                'Profile'
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { style: { width: '9%', padding: 0, textAlign: 'center', overflow: 'hidden' } },
                'User ',
                _react2.default.createElement('br', null),
                ' Management'
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { style: { width: '9%', padding: 0, textAlign: 'center', overflow: 'hidden' } },
                'Contracting'
              ),
              _react2.default.createElement(_materialUi.TableHeaderColumn, { style: { width: '9%' } })
            )
          ),
          _react2.default.createElement(
            _materialUi.TableBody,
            { displayRowCheckbox: false },
            users.map(function (user, index) {
              var status = function () {
                if (user.status === 'pending') return 'Pending for Approval';
                if (user.status === 'approved') {
                  if (user.confirmed_at) return 'Email Confirmed';
                  return 'Email Not Confirmed';
                }
                if (user.status === 'rejected') return 'Rejected';
              }();
              var userAccess = function userAccess(feature) {
                return user[feature];
              };
              var userName = user.first_name || user.last_name ? (0, _titlecase.toLaxTitleCase)(user.first_name + ' ' + user.last_name) : '';
              var teamString = user.teams.sort(function (a, b) {
                if (a > b) return 1;
                if (b > a) return -1;
                return 0;
              }).join(', ');
              return _react2.default.createElement(
                _materialUi.TableRow,
                { key: index },
                _react2.default.createElement(
                  _materialUi.TableRowColumn,
                  { style: { width: '20%' } },
                  userName
                ),
                _react2.default.createElement(
                  _materialUi.TableRowColumn,
                  { style: { width: '20%' } },
                  user.email
                ),
                _react2.default.createElement(
                  _materialUi.TableRowColumn,
                  { style: { width: '12%' } },
                  status
                ),
                _react2.default.createElement(
                  _materialUi.TableRowColumn,
                  { style: { width: '12%' } },
                  teamString
                ),
                _react2.default.createElement(
                  _materialUi.TableRowColumn,
                  { style: styles.cell },
                  (0, _accessIcons.getAccessIcons)(userAccess('profile'))
                ),
                _react2.default.createElement(
                  _materialUi.TableRowColumn,
                  { style: styles.cell },
                  (0, _accessIcons.getAccessIcons)(userAccess('admin'))
                ),
                _react2.default.createElement(
                  _materialUi.TableRowColumn,
                  { style: styles.cell },
                  (0, _accessIcons.getAccessIcons)(userAccess('contracting'))
                ),
                _react2.default.createElement(
                  _materialUi.TableRowColumn,
                  { style: { width: '9%', padding: 0, textAlign: 'right' } },
                  _react2.default.createElement(
                    _materialUi.IconMenu,
                    {
                      iconButtonElement: _react2.default.createElement(_materialUi.IconButton, {
                        iconClassName: 'tc-icon-more-vert',
                        iconStyle: { color: 'rgba(0, 0, 0, 0.54)' }
                      })
                    },
                    _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Edit', onTouchTap: function onTouchTap() {
                        if (_ramda2.default.contains('write', corporateAdminAccess)) {
                          var obj = _ramda2.default.merge(user, {
                            locAccess: isBuyer ? [] : [{
                              label: _ramda2.default.propOr('', 'property_name', singleLocationInfo),
                              value: _ramda2.default.propOr('', 'property_name', singleLocationInfo),
                              locId: _ramda2.default.propOr('', '_id', singleLocationInfo),
                              locName: _ramda2.default.propOr('', 'property_name', singleLocationInfo),
                              _id: _ramda2.default.propOr('', '_id', singleLocationInfo),
                              profile: user.profile,
                              contracting: user.contracting,
                              teams: user.teams,
                              admin: user.admin
                            }],
                            firstName: _ramda2.default.propOr('', 'first_name', user),
                            lastName: _ramda2.default.propOr('', 'last_name', user),
                            userId: user._id
                          });
                          updateProp({
                            editUserDialog: true,
                            editedUser: obj,
                            originalUser: obj });
                          if (sortedMembers) _this2.setState({ sortedMembers: null, sortBy: '', sortDirection: 'forward' });
                        } else {
                          _this2.props.triggerNoAccessWarning({ noAccessDialog: true, requestingAccessToFeature: 'User Management', requestAccessData: { type: 'userAccess' } });
                        }
                      }
                    }),
                    user.status.toLowerCase() === 'approved' && !user.confirmed_at && _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Resend Confirmation Link', onTouchTap: function onTouchTap() {
                        return resendConfirmationLink(user.email);
                      } }),
                    _ramda2.default.contains('write', corporateAdminAccess) && userId !== user._id && _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'delete user', onTouchTap: function onTouchTap() {
                        return removeUser(user._id);
                      } })
                  )
                )
              );
            })
          )
        ),
        _react2.default.createElement('br', null)
      );
    }
  }]);

  return SingleLocOrBuyer;
}(_react.Component);

SingleLocOrBuyer.propTypes = {
  settings: _react.PropTypes.object,
  userManagementReducer: _react.PropTypes.object,
  resendConfirmationLink: _react.PropTypes.func,
  updateProp: _react.PropTypes.func,
  userId: _react.PropTypes.string,
  removeUser: _react.PropTypes.func,
  corporateAdminAccess: _react.PropTypes.array,
  allLocations: _react.PropTypes.array,
  isBuyer: _react.PropTypes.bool,
  triggerNoAccessWarning: _react.PropTypes.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    triggerNoAccessWarning: function triggerNoAccessWarning(payload) {
      return dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload: payload });
    },
    updateProp: function updateProp() {
      return dispatch(_actions.updateUMProps.apply(undefined, arguments));
    },
    resendConfirmationLink: function resendConfirmationLink(email) {
      return dispatch((0, _settingsActions.resendConfirmationLink)(email));
    },
    removeUser: function removeUser() {
      return dispatch(_actions.deleteUser.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var settings = _ref.settings,
      user = _ref.user,
      userManagement = _ref.userManagement;
  return {
    settings: settings,
    corporateAdminAccess: user.get('corporateAdminAccess'),
    userManagementReducer: userManagement.toJS(),
    allLocations: user.get('allLocations'),
    isBuyer: user.getIn(['user', 'type']) === 'Contractor',
    userId: user.get('id'),
    isAccom: user.getIn(['company', 'productType']) === 'Accommodation'
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SingleLocOrBuyer);

/***/ }),
/* 3533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _titlecase = __webpack_require__(549);

var _actions = __webpack_require__(253);

var _teamPermissionOptions = __webpack_require__(1006);

var _settingsActions = __webpack_require__(976);

var _accessIcons = __webpack_require__(1272);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var MultiLoc = function (_Component) {
  _inherits(MultiLoc, _Component);

  function MultiLoc() {
    _classCallCheck(this, MultiLoc);

    var _this = _possibleConstructorReturn(this, (MultiLoc.__proto__ || Object.getPrototypeOf(MultiLoc)).call(this));

    _this.state = {
      addNewUserDialog: false,
      editUserDialog: false,
      sortBy: '', // name or email
      sortDirection: 'forward', // forward (a to z) or backward (z to a)
      sortedMembers: null,
      expandedRows: []
    };
    return _this;
  }

  _createClass(MultiLoc, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          settings = _props.settings,
          corporateAccess = _props.corporateAccess,
          locAccess = _props.locAccess,
          userManagementReducer = _props.userManagementReducer,
          updateProp = _props.updateProp,
          removeUser = _props.removeUser,
          userId = _props.userId,
          resendConfirmationLink = _props.resendConfirmationLink,
          isAccom = _props.isAccom;
      var _state = this.state,
          sortDirection = _state.sortDirection,
          sortBy = _state.sortBy,
          sortedMembers = _state.sortedMembers,
          expandedRows = _state.expandedRows;

      var usersArray = _ramda2.default.propOr([], 'usersArray', userManagementReducer);
      var addUserMessage = settings.get('addUserMessage');
      var manageUsersMessage = settings.get('manageUsersMessage') ? _react2.default.createElement(
        'p',
        { style: { color: 'green' } },
        settings.get('manageUsersMessage')
      ) : undefined;
      var sortAZZA = function sortAZZA(field, membersToSort) {
        return _react2.default.createElement(_materialUi.IconButton, {
          iconClassName: _ramda2.default.equals(field, sortBy) ? _ramda2.default.equals(sortDirection, 'forward') ? 'tc-icon-move-down' : 'tc-icon-move-up' : 'tc-icon-move-down',
          iconStyle: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', marginTop: '5px' },
          tooltip: _ramda2.default.equals(sortDirection, 'forward') ? 'A-Z' : 'Z-A',
          onTouchTap: function onTouchTap() {
            var fieldName = field === 'email' ? 'email' : 'first_name';
            var sorted = _ramda2.default.equals(sortDirection, 'forward') ? membersToSort.sort(function (a, b) {
              return a[fieldName] > b[fieldName] ? 1 : b[fieldName] > a[fieldName] ? -1 : 0;
            }) : membersToSort.sort(function (a, b) {
              return a[fieldName] < b[fieldName] ? 1 : b[fieldName] < a[fieldName] ? -1 : 0;
            });
            _this2.setState({
              sortBy: field,
              sortDirection: _ramda2.default.equals(sortDirection, 'forward') ? 'backward' : 'forward',
              sortedMembers: sorted
            });
          }
        });
      };
      var users = sortedMembers ? sortedMembers : usersArray;

      return _react2.default.createElement(
        'div',
        null,
        this.props.settings.get('addUserMessage').hasOwnProperty('emailExists') && addUserMessage.emailExists === false && addUserMessage.message && _react2.default.createElement(
          'p',
          { style: { color: 'green' } },
          addUserMessage.message
        ),
        manageUsersMessage,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { padding: '0 1%', display: 'flex', flexDirection: 'row', borderBottom: isNilOrEmpty(expandedRows) ? '1px solid #e0e0e0' : '', width: '100%', color: 'rgb(158, 158, 158)', fontSize: '12px' } },
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', width: '24%', justifyContent: 'center', alignItems: 'center' } },
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center' } },
                'Name ',
                sortAZZA('name', this.props.settings.get('usersArray'))
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', width: '24%', justifyContent: 'center', alignItems: 'center' } },
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center' } },
                'Email ',
                sortAZZA('email', this.props.settings.get('usersArray'))
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', width: '24%', justifyContent: 'center', alignItems: 'center' } },
              'Status'
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', width: '9%', justifyContent: 'center', alignItems: 'center', textAlign: 'center' } },
              _react2.default.createElement(
                'div',
                { style: { wordWrap: 'break-word', whiteSpace: 'pre-wrap', display: 'flex', alignContent: 'flex-start', justifyContent: 'flex-start' } },
                '# of ',
                isAccom ? 'Properties' : 'Locations'
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', width: '9%', justifyContent: 'center', alignItems: 'center', textAlign: 'center' } },
              _react2.default.createElement(
                'div',
                { style: { wordWrap: 'break-word', whiteSpace: 'pre-wrap', display: 'flex', alignContent: 'flex-start', justifyContent: 'flex-start' } },
                'Corporate Profile'
              )
            ),
            _react2.default.createElement('div', { style: { display: 'flex', width: '10%' } })
          ),
          _react2.default.createElement(
            'div',
            null,
            users.map(function (user, index) {
              var status = function () {
                if (user.status === 'pending') return 'Pending for Approval';
                if (user.status === 'approved') {
                  if (user.confirmed_at) return 'Email Confirmed';
                  return 'Email Not Confirmed';
                }
                if (user.status === 'rejected') return 'Rejected';
              }();
              var userAccess = function userAccess(feature) {
                return _ramda2.default.prop(0, _ramda2.default.pluck('value')(_teamPermissionOptions.availableAccess.filter(function (obj) {
                  return _ramda2.default.equals(obj.value, user[feature]);
                })));
              };
              var findUser = usersArray.filter(function (obj) {
                return obj._id === user._id;
              });
              var expanded = _ramda2.default.contains(index, _this2.state.expandedRows);
              return _react2.default.createElement(
                'div',
                { key: index, style: { border: expanded ? '2px solid #e0e0e0' : '', padding: '0 1%' } },
                _react2.default.createElement(
                  'div',
                  { style: { display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', borderBottom: expanded ? '' : '1px solid #e0e0e0' } },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', width: '24%', overflow: 'hidden' } },
                    _react2.default.createElement(
                      'span',
                      { style: { maxWidth: '250px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' } },
                      user.first_name || user.last_name ? (0, _titlecase.toLaxTitleCase)(user.first_name + ' ' + user.last_name) : ''
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', width: '24%', overflow: 'hidden' } },
                    _react2.default.createElement(
                      'span',
                      { style: { maxWidth: '250px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' } },
                      user.email
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', width: '24%', justifyContent: 'center' } },
                    status
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', width: '9%', justifyContent: 'center' } },
                    _ramda2.default.pathOr(0, [0, 'locAccess', 'length'], findUser)
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', width: '9%', justifyContent: 'center' } },
                    (0, _accessIcons.getCreateLocIcon)(user.profile || [])
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', width: '10%', padding: 0, textAlign: 'right' } },
                    _ramda2.default.isEmpty(_ramda2.default.pathOr([], [0, 'locAccess'], findUser)) && _ramda2.default.contains('write', corporateAccess) ? _react2.default.createElement(
                      _materialUi.IconMenu,
                      { iconButtonElement: _react2.default.createElement(_materialUi.IconButton, { iconClassName: 'tc-icon-more-vert', iconStyle: { padding: 0 } }) },
                      _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Edit', onTouchTap: function onTouchTap() {
                          if (_ramda2.default.contains('write', _ramda2.default.pathOr([], [0, 'admin'], locAccess))) {
                            var obj = _ramda2.default.merge(_ramda2.default.propOr({}, 0, findUser), {
                              locs: [],
                              teams: [],
                              admin: [],
                              firstName: _ramda2.default.propOr('', 'first_name', user),
                              lastName: _ramda2.default.propOr('', 'last_name', user),
                              userId: user._id
                            });
                            var processedUser = _extends({
                              firstName: _ramda2.default.propOr('', 'first_name', user),
                              lastName: _ramda2.default.propOr('', 'last_name', user),
                              userId: user._id
                            }, user);
                            updateProp({
                              editUserDialog: true,
                              editedUser: _ramda2.default.merge(processedUser, { allLocsSelected: false }),
                              originalUser: processedUser });
                            if (sortedMembers) _this2.setState({ sortedMembers: null, sortBy: '', sortDirection: 'forward' });
                          } else {
                            _this2.props.triggerNoAccessWarning({ noAccessDialog: true, requestingAccessToFeature: 'User Management', requestAccessData: { type: 'userAccess' } });
                          }
                        }
                      }),
                      user.status.toLowerCase() === 'approved' && !user.confirmed_at && _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Resend Confirmation Link', onTouchTap: function onTouchTap() {
                          return resendConfirmationLink(user.email);
                        } }),
                      _ramda2.default.contains('write', corporateAccess) && userId !== user._id && _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Delete User', onTouchTap: function onTouchTap() {
                          return removeUser(user._id);
                        } })
                    ) : _react2.default.createElement(_materialUi.IconButton, { iconClassName: expanded ? 'tc-icon-expand_less' : 'tc-icon-expand_more', iconStyle: { padding: 0 }, onTouchTap: function onTouchTap() {
                        return _this2.setState({ expandedRows: expanded ? _ramda2.default.without([index], _this2.state.expandedRows) : _ramda2.default.append(index, _this2.state.expandedRows) });
                      } })
                  )
                ),
                expanded && _react2.default.createElement(
                  'div',
                  { style: { padding: '1% 4%' } },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', flexDirection: 'row', borderBottom: '1px solid #e0e0e0', width: '100%', color: 'rgb(158, 158, 158)', fontSize: '12px' } },
                    _react2.default.createElement(
                      'div',
                      { style: { display: 'flex', width: '35%', justifyContent: 'center', alignItems: 'center' } },
                      isAccom ? 'Property' : 'Location',
                      ' Name'
                    ),
                    _react2.default.createElement(
                      'div',
                      { style: { display: 'flex', width: '25%', justifyContent: 'center', alignItems: 'center' } },
                      'Team(s)'
                    ),
                    _react2.default.createElement(
                      'div',
                      { style: { display: 'flex', width: '10%', justifyContent: 'center', alignItems: 'center', textAlign: 'center' } },
                      'Profile'
                    ),
                    _react2.default.createElement(
                      'div',
                      { style: { display: 'flex', width: '10%', justifyContent: 'center', alignItems: 'center', textAlign: 'center', marginRight: '4%' } },
                      _react2.default.createElement(
                        'div',
                        { style: { wordWrap: 'break-word', whiteSpace: 'pre-wrap' } },
                        'User Management'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { style: { display: 'flex', width: '10%', justifyContent: 'center', alignItems: 'center', textAlign: 'center' } },
                      'Contracting'
                    ),
                    _react2.default.createElement('div', { style: { display: 'flex', width: '10%', justifyContent: 'center', alignItems: 'center', textAlign: 'center' } })
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _ramda2.default.pathOr([], [0, 'locAccess'], findUser).map(function (loc, i) {
                      var locationAccess = function locationAccess(feature) {
                        return loc[feature];
                      };
                      return _react2.default.createElement(
                        'div',
                        { key: i, style: { display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', borderBottom: expanded ? '' : '1px solid #e0e0e0' } },
                        _react2.default.createElement(
                          'div',
                          { style: { display: 'flex', width: '35%', overflow: 'hidden' } },
                          _react2.default.createElement(
                            'span',
                            { style: { maxWidth: '250px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' } },
                            (0, _titlecase.toLaxTitleCase)(loc.property_name)
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { style: { display: 'flex', width: '25%', justifyContent: 'center' } },
                          loc.teams.sort(function (a, b) {
                            return a > b ? 1 : b > a ? -1 : 0;
                          }).join(', ')
                        ),
                        _react2.default.createElement(
                          'div',
                          { style: { display: 'flex', width: '10%', justifyContent: 'center' } },
                          (0, _accessIcons.getAccessIcons)(locationAccess('profile'))
                        ),
                        _react2.default.createElement(
                          'div',
                          { style: { display: 'flex', width: '10%', justifyContent: 'center', marginRight: '4%' } },
                          (0, _accessIcons.getAccessIcons)(locationAccess('admin'))
                        ),
                        _react2.default.createElement(
                          'div',
                          { style: { display: 'flex', width: '10%', justifyContent: 'center' } },
                          (0, _accessIcons.getAccessIcons)(locationAccess('contracting'))
                        ),
                        _react2.default.createElement(
                          'div',
                          { style: { display: 'flex', width: '10%', padding: 0, textAlign: 'right' } },
                          _react2.default.createElement(
                            _materialUi.IconMenu,
                            { iconButtonElement: _react2.default.createElement(_materialUi.IconButton, { iconClassName: 'tc-icon-more-vert', iconStyle: { padding: 0 } }) },
                            _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Edit', onTouchTap: function onTouchTap() {
                                // only allow user to modify permission that they themselves have
                                // User Management access too
                                var processedLocAccess = user.locAccess.map(function (obj) {
                                  if (locAccess.some(function (access) {
                                    return access.locId === obj.locId && access.admin.indexOf('write') > -1;
                                  })) {
                                    return _extends({}, obj, { disabled: false });
                                  }
                                  return _extends({}, obj, { disabled: true });
                                });
                                if (processedLocAccess.some(function (obj) {
                                  return !obj.disabled;
                                })) {
                                  var processedUser = _extends({}, user, {
                                    firstName: _ramda2.default.propOr('', 'first_name', user),
                                    lastName: _ramda2.default.propOr('', 'last_name', user),
                                    userId: user._id,
                                    locAccess: processedLocAccess
                                  });
                                  updateProp({
                                    editUserDialog: true,
                                    editedUser: _ramda2.default.merge(processedUser, { allLocsSelected: false }),
                                    originalUser: processedUser });
                                  if (sortedMembers) _this2.setState({ sortedMembers: null, sortBy: '', sortDirection: 'forward' });
                                } else {
                                  _this2.props.triggerNoAccessWarning({ noAccessDialog: true, requestingAccessToFeature: 'User Management', requestAccessData: { type: 'userAccess' } });
                                }
                              }
                            }),
                            user.status.toLowerCase() === 'approved' && !user.confirmed_at && _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Resend Confirmation Link', onTouchTap: function onTouchTap() {
                                return resendConfirmationLink(user.email);
                              } }),
                            _ramda2.default.contains('write', corporateAccess) && userId !== user._id && _react2.default.createElement(_materialUi.MenuItem, { primaryText: 'Delete User', onTouchTap: function onTouchTap() {
                                return removeUser(user._id);
                              } })
                          )
                        )
                      );
                    })
                  )
                )
              );
            })
          )
        ),
        _react2.default.createElement('br', null)
      );
    }
  }]);

  return MultiLoc;
}(_react.Component);

MultiLoc.propTypes = {
  settings: _react.PropTypes.object,
  corporateAccess: _react.PropTypes.array,
  locAccess: _react.PropTypes.array,
  updateProp: _react.PropTypes.func,
  userManagementReducer: _react.PropTypes.object,
  resendConfirmationLink: _react.PropTypes.func,
  userId: _react.PropTypes.string,
  removeUser: _react.PropTypes.func,
  triggerNoAccessWarning: _react.PropTypes.func,
  isAccom: _react.PropTypes.bool
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    triggerNoAccessWarning: function triggerNoAccessWarning(payload) {
      return dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload: payload });
    },
    updateProp: function updateProp() {
      return dispatch(_actions.updateUMProps.apply(undefined, arguments));
    },
    resendConfirmationLink: function resendConfirmationLink(email) {
      return dispatch((0, _settingsActions.resendConfirmationLink)(email));
    },
    removeUser: function removeUser() {
      return dispatch(_actions.deleteUser.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var settings = _ref.settings,
      user = _ref.user,
      userManagement = _ref.userManagement;
  return {
    settings: settings,
    corporateAccess: user.get('corporateAccess'),
    locAccess: user.get('locAccess'),
    userManagementReducer: userManagement.toJS(),
    userId: user.get('id'),
    isAccom: user.getIn(['company', 'productType']) === 'Accommodation'
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MultiLoc);

/***/ }),
/* 3534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _teamPermissionOptions = __webpack_require__(1006);

var _actions = __webpack_require__(253);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _userInfo = __webpack_require__(2036);

var _userInfo2 = _interopRequireDefault(_userInfo);

var _singleLocPermissions = __webpack_require__(2038);

var _singleLocPermissions2 = _interopRequireDefault(_singleLocPermissions);

var _multiLocPermissions = __webpack_require__(2037);

var _multiLocPermissions2 = _interopRequireDefault(_multiLocPermissions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var EditUserDialog = function (_Component) {
  _inherits(EditUserDialog, _Component);

  function EditUserDialog(props) {
    _classCallCheck(this, EditUserDialog);

    var _this = _possibleConstructorReturn(this, (EditUserDialog.__proto__ || Object.getPrototypeOf(EditUserDialog)).call(this, props));

    _this.onCorporateLocCheck = function () {
      var _this$props = _this.props,
          editedUser = _this$props.editedUser,
          updateProp = _this$props.updateProp;

      var corporateProfile = isNilOrEmpty(editedUser.profile) ? ['createLocation', 'read', 'write'] : [];
      updateProp({
        editedUser: _extends({}, editedUser, {
          profile: corporateProfile
        })
      });
    };

    _this.state = {
      showConfirmDeleteUser: false
    };
    return _this;
  }

  _createClass(EditUserDialog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          editUserDialogOpen = _props.editUserDialogOpen,
          updateProp = _props.updateProp,
          _props$editedUser = _props.editedUser,
          editedUser = _props$editedUser === undefined ? {} : _props$editedUser,
          originalUser = _props.originalUser,
          updateUser = _props.updateUser,
          locations = _props.locations,
          deletingUser = _props.deletingUser,
          updatingUser = _props.updatingUser,
          viewBy = _props.viewBy,
          companyType = _props.companyType,
          isSingleLoc = _props.isSingleLoc,
          companyName = _props.companyName,
          updateUserError = _props.updateUserError,
          userId = _props.userId,
          approveOrRejectUser = _props.approveOrRejectUser,
          approvingRejectingUser = _props.approvingRejectingUser,
          isAccom = _props.isAccom,
          locAccess = _props.locAccess;


      var showLoc = !_ramda2.default.equals(companyType, 'Contractor') && !isSingleLoc;
      var editingSelf = userId === originalUser.userId;

      var locsUserHasEditAccessTo = locations.map(function (loc) {
        if (locAccess.some(function (access) {
          return access.locId === loc._id && access.admin.indexOf('write') > -1;
        })) {
          return _extends({}, loc, { disabled: false });
        }
        return _extends({}, loc, { disabled: true });
      });
      var clearStore = function clearStore() {
        _this2.setState({ showConfirmDeleteUser: false });
        updateProp({ editUserDialog: false, editedUser: {}, originalUser: {} });
      };
      var actions = [_react2.default.createElement(_materialUi.FlatButton, {
        label: 'Cancel',
        primary: true,
        onTouchTap: function onTouchTap() {
          return clearStore();
        }
      }), _react2.default.createElement(_materialUi.FlatButton, {
        label: 'Submit',
        secondary: true,
        disabled: _ramda2.default.equals(originalUser, _ramda2.default.omit(['allLocsSelected'], editedUser)) || _ramda2.default.isEmpty(editedUser.firstName) || _ramda2.default.isEmpty(editedUser.lastName) || _ramda2.default.isEmpty(editedUser.email) || editingSelf && _ramda2.default.equals(originalUser.firstName, editedUser.firstName) && _ramda2.default.equals(originalUser.lastName, editedUser.lastName) && _ramda2.default.equals(originalUser.email, editedUser.email) || deletingUser || updatingUser || !isNilOrEmpty(updateUserError),
        onTouchTap: function onTouchTap() {
          var userRemovedLoc = _ramda2.default.path(['locAccess', 'length'], originalUser) !== _ramda2.default.path(['locAccess', 'length'], editedUser);
          var removedLocs = originalUser.locAccess.filter(function (loc) {
            return !_ramda2.default.contains(loc.locId, _ramda2.default.pluck('locId')(editedUser.locAccess));
          });
          var addRemovedLocsToEditedUser = userRemovedLoc ? _ramda2.default.merge(editedUser, { removedLocs: removedLocs }) : editedUser;
          updateUser(_ramda2.default.merge(addRemovedLocsToEditedUser, { viewBy: viewBy }));
          clearStore();
        }
      })];
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          title: 'Editing User: ' + _ramda2.default.propOr('', 'firstName', originalUser) + ' ' + _ramda2.default.propOr('', 'lastName', originalUser),
          actions: actions,
          modal: true,
          open: editUserDialogOpen,
          autoScrollBodyContent: true,
          bodyStyle: { minHeight: '300px' }
        },
        !isNilOrEmpty(updateUserError) && !updatingUser && _react2.default.createElement(
          'div',
          { style: { color: 'red', fontWeight: 600 } },
          'There\'s an error in updating the user: ',
          updateUserError,
          '.'
        ),
        editingSelf && _react2.default.createElement(
          'div',
          { style: { fontWeight: 600, margin: '16px' } },
          'Note: You cannot edit your own access, only your name and email.'
        ),
        _react2.default.createElement(_userInfo2.default, _extends({
          editUserInfo: function editUserInfo(userInfo) {
            return updateProp({ editedUser: _extends({}, editedUser, userInfo) });
          }
        }, editedUser)),
        _react2.default.createElement(
          'div',
          { style: { display: editingSelf ? 'none' : 'block' } },
          !isNilOrEmpty(_ramda2.default.propOr('', 'status', editedUser)) && _react2.default.createElement(
            'div',
            { style: { margin: '10px 0 15px 0', display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'center', width: '100%' } },
            _react2.default.createElement(
              'div',
              { style: { width: '20%' } },
              'Email Status'
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', flexDirection: 'row', width: '75%' } },
              editedUser.status === 'pending' ? _react2.default.createElement(
                'div',
                { style: { display: 'inline-block' } },
                _react2.default.createElement(
                  'span',
                  { style: { marginRight: '10px' } },
                  'Pending for Approval: '
                ),
                _react2.default.createElement(_materialUi.RaisedButton, {
                  label: 'Approve',
                  disabled: approvingRejectingUser,
                  secondary: true,
                  onTouchTap: function onTouchTap() {
                    approveOrRejectUser(editedUser, 'approve').then(function (res) {
                      var updatedUser = _ramda2.default.pathOr([], ['payload', 'usersArray'], res).filter(function (obj) {
                        return obj._id === editedUser.userId;
                      });
                      updateProp({
                        editedUser: _ramda2.default.merge(editedUser, {
                          status: _ramda2.default.pathOr('pending', [0, 'status'], updatedUser)
                        })
                      });
                    });
                  },
                  style: { marginRight: '10px' }
                }),
                _react2.default.createElement(_materialUi.RaisedButton, {
                  label: 'Reject',
                  disabled: approvingRejectingUser,
                  primary: true,
                  onTouchTap: function onTouchTap() {
                    approveOrRejectUser(editedUser, 'reject').then(function (res) {
                      var updatedUser = _ramda2.default.pathOr([], ['payload', 'usersArray'], res).filter(function (obj) {
                        return obj._id === editedUser.userId;
                      });
                      updateProp({
                        editedUser: _ramda2.default.merge(editedUser, {
                          status: _ramda2.default.pathOr('pending', [0, 'status'], updatedUser)
                        })
                      });
                    });
                  }
                })
              ) : _react2.default.createElement(
                'div',
                { style: { fontWeight: 'bold' } },
                _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('pending'), _ramda2.default.always('Pending for Approval')], [_ramda2.default.equals('approved'), _ramda2.default.always(editedUser.confirmed_at ? 'Email Confirmed' : 'Email Not Confirmed')], [_ramda2.default.equals('rejected'), _ramda2.default.always('Rejected')]]), editedUser.status)
              )
            )
          ),
          !showLoc ? _react2.default.createElement(_singleLocPermissions2.default, {
            isAccom: isAccom,
            userName: _ramda2.default.pathOr('', ['firstName'], editedUser) + ' ' + _ramda2.default.pathOr('', ['lastName'], editedUser),
            onLocSelection: function onLocSelection(selectedLocs) {
              return updateProp({
                editedUser: _extends({}, editedUser, selectedLocs[0], {
                  locAccess: _ramda2.default.isEmpty(editedUser.locAccess) ? [] : selectedLocs
                }) });
            }
            // if locAccess is empty, it's a buyer
            , selectedLocs: _ramda2.default.isEmpty(editedUser.locAccess) ? [editedUser] : editedUser.locAccess,
            corporateProfileAccess: !isNilOrEmpty(editedUser.profile),
            showCorporateProfileRadioButtons: _ramda2.default.contains('write', this.props.corporateAccess),
            onCorporateLocCheck: this.onCorporateLocCheck
          }) : _react2.default.createElement(_multiLocPermissions2.default, {
            isAccom: isAccom,
            isSingleLoc: isSingleLoc,
            locations: locsUserHasEditAccessTo,
            userName: _ramda2.default.pathOr('', ['firstName'], editedUser) + ' ' + _ramda2.default.pathOr('', ['lastName'], editedUser),
            onLocSelection: function onLocSelection(selectedLocs) {
              return updateProp({ editedUser: _extends({}, editedUser, { locAccess: selectedLocs }) });
            },
            selectedLocs: (editedUser.locAccess || []).map(function (obj) {
              return _extends({}, obj, { value: obj.locId, label: obj.property_name });
            }),
            onlyHasAccessToOneLoc: locsUserHasEditAccessTo.length === 1,
            corporateProfileAccess: !isNilOrEmpty(editedUser.profile),
            showCorporateProfileRadioButtons: _ramda2.default.contains('write', this.props.corporateAccess),
            onCorporateLocCheck: this.onCorporateLocCheck,
            allLocsSameTeamAndLocs: false
          })
        )
      );
    }
  }]);

  return EditUserDialog;
}(_react.Component);

EditUserDialog.propTypes = {
  editUserDialogOpen: _react.PropTypes.bool,
  updateProp: _react.PropTypes.func,
  editedUser: _react.PropTypes.object,
  originalUser: _react.PropTypes.object,
  locations: _react.PropTypes.array,
  updateUser: _react.PropTypes.func,
  deletingUser: _react.PropTypes.bool,
  updatingUser: _react.PropTypes.bool,
  viewBy: _react.PropTypes.string,
  companyType: _react.PropTypes.string,
  isSingleLoc: _react.PropTypes.bool,
  companyName: _react.PropTypes.string,
  updateUserError: _react.PropTypes.string,
  userId: _react.PropTypes.string,
  approveOrRejectUser: _react.PropTypes.func,
  approvingRejectingUser: _react.PropTypes.bool,
  isAccom: _react.PropTypes.bool,
  corporateAccess: _react.PropTypes.array,
  locAccess: _react.PropTypes.array
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateUMProps.apply(undefined, arguments));
    },
    updateUser: function updateUser() {
      return dispatch(_actions.editUser.apply(undefined, arguments));
    },
    approveOrRejectUser: function approveOrRejectUser(user, action) {
      return dispatch((0, _actions.approveOrRejectUser)(user, action));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var userManagement = _ref.userManagement,
      user = _ref.user;
  return {
    userId: user.get('id'),
    editUserDialogOpen: userManagement.get('editUserDialog'),
    editedUser: userManagement.get('editedUser').toJS(),
    originalUser: userManagement.get('originalUser').toJS(),
    locations: user.get('allLocations'),
    deletingUser: userManagement.get('deletingUser'),
    updatingUser: userManagement.get('updatingUser'),
    viewBy: userManagement.get('viewBy'),
    companyType: user.getIn(['user', 'type']),
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
    companyName: user.getIn(['company', 'companyName']),
    isAccom: user.getIn(['company', 'productType']) === 'Accommodation',
    updateUserError: userManagement.get('updateUserError'),
    approvingRejectingUser: userManagement.get('approvingRejectingUser'),
    corporateAccess: user.get('corporateAccess'),
    locAccess: user.get('locAccess')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EditUserDialog);

/***/ }),
/* 3535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _getInboundEmail = __webpack_require__(3536);

var _getInboundEmail2 = _interopRequireDefault(_getInboundEmail);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailForwarding = function EmailForwarding() {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { paddingBottom: '12px', borderBottom: '1px solid #e6e9ec', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' } },
      _react2.default.createElement(
        'div',
        { style: { fontSize: '24px', fontWeight: 400 } },
        'Forwarding Address'
      ),
      _react2.default.createElement('div', { style: { display: 'flex', alignItems: 'center' } })
    ),
    _react2.default.createElement(
      'div',
      { style: { marginTop: '20px' } },
      _react2.default.createElement(_getInboundEmail2.default, { buttonStyle: {}, ButtonElement: _raisedButtonWithLoader2.default })
    )
  );
};

exports.default = EmailForwarding;

/***/ }),
/* 3536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _materialUi = __webpack_require__(3);

var _http = __webpack_require__(118);

var _checkStatus = __webpack_require__(53);

var _checkStatus2 = _interopRequireDefault(_checkStatus);

var _jquery = __webpack_require__(251);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var copyLink = function copyLink(element) {
  var $temp = (0, _jquery2.default)('<input>');
  (0, _jquery2.default)('body').append($temp);
  $temp.val((0, _jquery2.default)(element).text()).select();
  document.execCommand('copy');
  $temp.remove();
};

var GetInboundEmail = function (_React$Component) {
  _inherits(GetInboundEmail, _React$Component);

  function GetInboundEmail() {
    _classCallCheck(this, GetInboundEmail);

    var _this = _possibleConstructorReturn(this, (GetInboundEmail.__proto__ || Object.getPrototypeOf(GetInboundEmail)).call(this));

    _this.onButtonClick = function () {
      if (_this.state.inboundEmail) _this.setState({ dialogOpen: true });else {
        _this.setState({ dialogOpen: true, gettingInboundEmail: true });
        (0, _http.get)('/proxy/contracting/inboundEmail').then(_checkStatus2.default).then(function (res) {
          return res.json();
        }).then(function (res) {
          _this.setState({ inboundEmail: res.email, gettingInboundEmail: false });
        }).catch(function (err) {
          console.log(err);
          _this.setState({ gettingInboundEmail: false });
        });
      }
    };

    _this.closeDialog = function () {
      return _this.setState({ dialogOpen: false, text: '' });
    };

    _this.state = {
      inboundEmail: '',
      dialogOpen: false,
      gettingInboundEmail: false
    };
    return _this;
  }

  _createClass(GetInboundEmail, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          gettingInboundEmail = _state.gettingInboundEmail,
          dialogOpen = _state.dialogOpen,
          inboundEmail = _state.inboundEmail,
          text = _state.text;
      var _props = this.props,
          ButtonElement = _props.ButtonElement,
          style = _props.style,
          buttonStyle = _props.buttonStyle;

      return _react2.default.createElement(
        'div',
        { style: style },
        _react2.default.createElement(ButtonElement, {
          style: buttonStyle,
          loader: gettingInboundEmail,
          secondary: true,
          label: 'Get Forwarding Email',
          onTouchTap: this.onButtonClick
        }),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            style: { padding: '0 2%', textAlign: 'center' },
            open: dialogOpen,
            onRequestClose: this.closeDialog,
            actions: _react2.default.createElement(
              'div',
              { className: 'flex-tc-sb' },
              _react2.default.createElement(
                'small',
                null,
                text
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_materialUi.RaisedButton, {
                  label: 'Copy Link',
                  style: { marginLeft: '8px' },
                  secondary: true,
                  onTouchTap: function onTouchTap() {
                    copyLink('#inboundEmail');
                    _this2.setState({ text: 'Link successfully copied!' });
                  }
                }),
                _react2.default.createElement(_materialUi.RaisedButton, {
                  label: 'Dismiss',
                  style: { marginLeft: '8px' },
                  onTouchTap: this.closeDialog
                })
              )
            )
          },
          'Ask your partner to send email to or cc this address.',
          _react2.default.createElement('br', null),
          'TourConnect will pick it up so you can work with the content of the email.',
          _react2.default.createElement(
            'span',
            { id: 'inboundEmail', style: { display: 'none' } },
            inboundEmail
          ),
          inboundEmail ? _react2.default.createElement(_materialUi.TextField, {
            id: 'inboundEmailField',
            value: inboundEmail,
            style: { width: '100%' },
            inputStyle: { fontSize: '12px', textAlign: 'center' },
            readOnly: true
          }) : _react2.default.createElement(_materialUi.CircularProgress, null)
        )
      );
    }
  }]);

  return GetInboundEmail;
}(_react2.default.Component);

GetInboundEmail.defaultProps = {
  style: {},
  buttonStyle: { float: 'right', marginRight: '2%' },
  ButtonElement: _flatButtonWithLoader2.default
};
GetInboundEmail.propTypes = {
  style: _react.PropTypes.object,
  buttonStyle: _react.PropTypes.object,
  ButtonElement: _react.PropTypes.func
};
var mapStateToProps = function mapStateToProps(_ref) {
  var contractingDashboard = _ref.contractingDashboard;
  return {
    showInboundEmail: contractingDashboard.showInboundEmail,
    inboundEmail: contractingDashboard.inboundEmail,
    gettingInboundEmail: contractingDashboard.gettingInboundEmail
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(GetInboundEmail);

/***/ }),
/* 3537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _settingsActions = __webpack_require__(976);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PersonalDetails = function (_Component) {
  _inherits(PersonalDetails, _Component);

  function PersonalDetails(props) {
    _classCallCheck(this, PersonalDetails);

    var _this = _possibleConstructorReturn(this, (PersonalDetails.__proto__ || Object.getPrototypeOf(PersonalDetails)).call(this, props));

    _this.state = {
      editingField: '',
      oldValue: '',
      newValue: '',
      firstName: '',
      lastName: '',
      oldPw: '',
      newPw: '',
      confirmPw: ''
    };
    return _this;
  }

  _createClass(PersonalDetails, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          currentEmail = _props.currentEmail,
          settings = _props.settings,
          userId = _props.userId,
          updateUser = _props.updateUser,
          updatePW = _props.updatePW,
          emailAlias = _props.emailAlias;

      var editUserMessage = settings.editUserMessage;
      var passResetMessage = settings.passResetMessage;
      var userObj = _ramda2.default.propOr([], 'usersArray', settings).filter(function (user) {
        return user._id === userId;
      })[0];
      var _state = this.state,
          editingField = _state.editingField,
          newValue = _state.newValue,
          oldPw = _state.oldPw,
          newPw = _state.newPw,
          confirmPw = _state.confirmPw,
          firstName = _state.firstName,
          lastName = _state.lastName,
          oldValue = _state.oldValue;


      var fields = [{ text: 'Name', value: _ramda2.default.propOr('', 'first_name', userObj) + ' ' + _ramda2.default.propOr('', 'last_name', userObj), updateKey: 'name' }, { text: 'Email', value: currentEmail, updateKey: 'email' }, { text: 'Password', value: '***********', updateKey: 'Password' }];

      var pwFields = [{ text: 'Old Password', stateVal: 'oldPw', value: oldPw }, { text: 'New Password', stateVal: 'newPw', value: newPw }, { text: 'Confirm New Password', stateVal: 'confirmPw', value: confirmPw }];

      var resetState = function resetState() {
        return _this2.setState({
          editingField: '',
          oldValue: '',
          newValue: '',
          oldPw: '',
          newPw: '',
          confirmPw: '',
          firstName: '',
          lastName: ''
        });
      };

      var cancelButton = _react2.default.createElement(_materialUi.FlatButton, { label: 'Cancel', primary: true, onTouchTap: function onTouchTap() {
          return resetState();
        } });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { fontSize: '24px', fontWeight: 400, marginTop: '4px', paddingBottom: '12px', borderBottom: '1px solid #e6e9ec' } },
          'Personal Details'
        ),
        _react2.default.createElement(
          'div',
          { style: { margin: '0 30px' } },
          fields.map(function (field, i) {
            return _react2.default.createElement(
              'div',
              { key: i, style: { marginTop: '10px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', fontSize: '14px' } },
              _react2.default.createElement(
                'div',
                { style: { fontWeight: _ramda2.default.equals(editingField, field.text) && 600 } },
                field.text
              ),
              _react2.default.createElement(
                'div',
                null,
                _ramda2.default.equals(editingField, field.updateKey) ? _react2.default.createElement(
                  'div',
                  null,
                  editingField === 'Password' ? _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', flexDirection: 'column' } },
                    pwFields.map(function (pwField, j) {
                      return _react2.default.createElement(
                        'div',
                        { key: j, style: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' } },
                        _react2.default.createElement(
                          'div',
                          { style: { marginRight: '10px' } },
                          pwField.text
                        ),
                        _react2.default.createElement(_materialUi.TextField, { type: 'password', id: pwField.text, value: pwField.value, onChange: function onChange(_ref) {
                            var value = _ref.target.value;
                            return _this2.setState(_defineProperty({}, pwField.stateVal, value));
                          } })
                      );
                    }),
                    !_ramda2.default.isEmpty(newPw) && newPw.length < 6 && _react2.default.createElement(
                      'div',
                      { style: { color: 'red', textAlign: 'center' } },
                      'Password should have at least 6 characters!'
                    ),
                    !_ramda2.default.isEmpty(confirmPw) && !_ramda2.default.isEmpty(newPw) && !_ramda2.default.equals(newPw, confirmPw) && _react2.default.createElement(
                      'div',
                      { style: { color: 'red', textAlign: 'center' } },
                      'New passwords do not match!'
                    ),
                    _ramda2.default.propEq('error', true, passResetMessage) && _react2.default.createElement(
                      'div',
                      { style: { color: 'red', textAlign: 'center' } },
                      passResetMessage.errorMessage
                    ),
                    _react2.default.createElement(
                      'div',
                      { style: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' } },
                      _react2.default.createElement(_materialUi.FlatButton, {
                        label: 'Save',
                        secondary: true,
                        disabled: _ramda2.default.isEmpty(oldPw) || _ramda2.default.isEmpty(newPw) || !_ramda2.default.equals(newPw, confirmPw) || newPw.length < 6,
                        onTouchTap: function onTouchTap() {
                          updatePW(oldPw, newPw);
                          if (_ramda2.default.propEq('error', false, passResetMessage)) {
                            resetState();
                          }
                        }
                      }),
                      cancelButton
                    )
                  ) : _react2.default.createElement(
                    'div',
                    { style: { textAlign: 'right', display: 'flex', alignItems: 'center' } },
                    field.updateKey === 'name' ? _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(_materialUi.TextField, {
                        id: 'firstName',
                        value: firstName,
                        style: { fontSize: '14px', width: '35%' },
                        onChange: function onChange(_ref2) {
                          var value = _ref2.target.value;
                          return _this2.setState({ firstName: value });
                        }
                      }),
                      _react2.default.createElement(_materialUi.TextField, {
                        id: 'lastName',
                        value: lastName,
                        style: { fontSize: '14px', marginLeft: '10px', width: '35%' },
                        onChange: function onChange(_ref3) {
                          var value = _ref3.target.value;
                          return _this2.setState({ lastName: value });
                        }
                      })
                    ) : _react2.default.createElement(_materialUi.TextField, {
                      id: field.text,
                      value: newValue,
                      style: { fontSize: '14px' },
                      onChange: function onChange(_ref4) {
                        var value = _ref4.target.value;
                        return _this2.setState({ newValue: value });
                      }
                    }),
                    _react2.default.createElement(_materialUi.FlatButton, {
                      label: 'Save',
                      secondary: true,
                      disabled: editingField === 'name' ? _ramda2.default.isEmpty(firstName) || _ramda2.default.isEmpty(lastName) : _ramda2.default.isEmpty(newValue),
                      onTouchTap: function onTouchTap() {
                        if (field.updateKey === 'name') {
                          updateUser(_ramda2.default.merge(userObj, { first_name: firstName, last_name: lastName }));
                          resetState();
                        } else {
                          updateUser(_ramda2.default.merge(userObj, _defineProperty({}, editingField, newValue)));
                          if (!_ramda2.default.propEq('emailExists', true, editUserMessage)) {
                            resetState();
                          }
                        }
                      }
                    }),
                    cancelButton,
                    _ramda2.default.propEq('emailExists', true, editUserMessage) && _react2.default.createElement(
                      'div',
                      { style: { color: 'red' } },
                      editUserMessage.message
                    )
                  )
                ) : _react2.default.createElement(
                  'div',
                  { style: { display: 'inline-block' } },
                  field.value,
                  _react2.default.createElement(_materialUi.FontIcon, {
                    className: 'tc-icon-mode_edit',
                    style: { fontSize: '12px', color: 'rgb(0, 165, 187)', cursor: 'pointer', marginLeft: '10px' },
                    onTouchTap: function onTouchTap() {
                      _this2.setState({
                        editingField: field.updateKey,
                        oldValue: field.value,
                        newValue: field.value,
                        firstName: _ramda2.default.propOr('', 'first_name', userObj),
                        lastName: _ramda2.default.propOr('', 'last_name', userObj)
                      });
                    }
                  })
                )
              )
            );
          }),
          _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb', style: { marginTop: '10px', display: emailAlias ? 'flex' : 'none' } },
            'Email Alias',
            _react2.default.createElement(
              'div',
              {
                className: 'hint--top',
                'aria-label': 'Please contact support@tourconnect.com to edit'
              },
              emailAlias,
              _react2.default.createElement(_materialUi.FontIcon, {
                className: 'tc-icon-mode_edit',
                style: { fontSize: '12px', marginLeft: '10px' }
              })
            )
          )
        )
      );
    }
  }]);

  return PersonalDetails;
}(_react.Component);

PersonalDetails.propTypes = {
  currentEmail: _react.PropTypes.string,
  updateUser: _react.PropTypes.func,
  settings: _react.PropTypes.object,
  userId: _react.PropTypes.string,
  updatePW: _react.PropTypes.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateUser: function updateUser(userObject) {
      return dispatch((0, _settingsActions.saveUserBeingEdited)(userObject));
    },
    updatePW: function updatePW(oldPassword, newPassword) {
      return dispatch((0, _settingsActions.resetPassword)(oldPassword, newPassword));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref5) {
  var user = _ref5.user,
      settings = _ref5.settings;
  return {
    currentEmail: settings.get('currentUserEmail'),
    userId: user.get('id'),
    settings: settings.toJS(),
    emailAlias: user.get('emailAlias')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PersonalDetails);

/***/ }),
/* 3538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _accessIcons = __webpack_require__(1272);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var border = '1px solid #D3D3D3';
var styles = {
  cell: { padding: 0, textAlign: 'center', overflow: 'visible', borderLeft: border }
};

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var AccessLevel = function AccessLevel(props) {
  var userId = props.userId,
      corporateAccess = props.corporateAccess,
      locAccess = props.locAccess,
      isSingleLoc = props.isSingleLoc,
      companyType = props.companyType,
      adminTeam = props.adminTeam,
      contractingTeam = props.contractingTeam,
      isAccom = props.isAccom;

  var isBuyer = companyType === 'Contractor';
  var isBuyerOrSingleLoc = isBuyer || isSingleLoc;
  var isMultiLoc = !isBuyerOrSingleLoc;
  var isOnAdminTeam = !isNilOrEmpty(adminTeam.filter(function (obj) {
    return obj.userId === userId;
  }));
  var isOnContractingTeam = !isNilOrEmpty(contractingTeam.filter(function (obj) {
    return obj.userId === userId;
  }));
  var userTeams = [];
  if (isOnAdminTeam) userTeams.push('admin');
  if (isOnContractingTeam) userTeams.push('contracting');
  var alphaSortLocs = (locAccess || []).filter(function (o) {
    return !o.isHidden && !o.is_archived;
  }).sort(function (a, b) {
    if (a.property_name > b.property_name) return 1;
    if (b.property_name > a.property_name) return -1;
    return 0;
  });
  /*
  * Buyer:         Team(s) | Profile | User Management | Contracting
  * Single Loc:    Team(s) | Profile | User Management | Contracting
  * Multi Loc:     Location | Team(s) | Profile | User Management | Contracting
  *   (Multi Loc will include "Corporate Profile")
  */
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { fontSize: '24px', fontWeight: 400, marginTop: '4px', paddingBottom: '12px', borderBottom: '1px solid #e6e9ec' } },
      'Access Level\xA0',
      _react2.default.createElement(
        'small',
        { style: { fontSize: '12px' } },
        '(Note: You cannot edit your own access level)'
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _materialUi.Table,
        { fixedHeader: true, style: { maxHeight: '400px' } },
        _react2.default.createElement(
          _materialUi.TableHeader,
          { adjustForCheckbox: false, displaySelectAll: false },
          _react2.default.createElement(
            _materialUi.TableRow,
            null,
            isMultiLoc && _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              {
                colSpan: 6,
                style: styles.cell
              },
              isAccom ? 'Property' : 'Location'
            ),
            _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              {
                colSpan: 3,
                style: styles.cell
              },
              'Team(s)'
            ),
            _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              {
                colSpan: 3,
                style: styles.cell
              },
              'Profile'
            ),
            _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              {
                colSpan: 3,
                style: styles.cell
              },
              _react2.default.createElement(
                'div',
                { style: { wordWrap: 'break-word', whiteSpace: 'pre-wrap' } },
                'User Management'
              )
            ),
            _react2.default.createElement(
              _materialUi.TableHeaderColumn,
              {
                colSpan: 3,
                style: _extends({}, styles.cell, {
                  borderRight: border
                })
              },
              'Contracting'
            )
          )
        ),
        _react2.default.createElement(
          _materialUi.TableBody,
          { displayRowCheckbox: false, style: { width: '99%' } },
          isMultiLoc && _react2.default.createElement(
            _materialUi.TableRow,
            { style: { borderLeft: border, borderRight: border } },
            _react2.default.createElement(
              _materialUi.TableRowColumn,
              {
                colSpan: 6
              },
              'Corporate Profile'
            ),
            _react2.default.createElement(_materialUi.TableRowColumn, { colSpan: 3 }),
            _react2.default.createElement(
              _materialUi.TableRowColumn,
              {
                colSpan: 3,
                style: { overflow: 'visible', textAlign: 'center' }
              },
              (0, _accessIcons.getCreateLocIcon)(corporateAccess || [])
            ),
            _react2.default.createElement(_materialUi.TableRowColumn, {
              colSpan: 6
            })
          ),
          alphaSortLocs.map(function (loc, i) {
            return _react2.default.createElement(
              _materialUi.TableRow,
              { key: i, style: { borderBottom: border } },
              isMultiLoc && _react2.default.createElement(
                _materialUi.TableRowColumn,
                {
                  colSpan: 6,
                  style: { borderLeft: border }
                },
                loc.property_name
              ),
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                { colSpan: 3, style: styles.cell },
                loc.teams.sort(function (a, b) {
                  if (a > b) return 1;
                  if (b > a) return -1;
                  return 0;
                }).join(', ')
              ),
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                {
                  colSpan: 3,
                  style: styles.cell
                },
                isBuyerOrSingleLoc ? (0, _accessIcons.getCreateLocIcon)(corporateAccess || []) : (0, _accessIcons.getAccessIcons)(loc.profile)
              ),
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                {
                  colSpan: 3,
                  style: styles.cell
                },
                (0, _accessIcons.getAccessIcons)(loc.admin)
              ),
              _react2.default.createElement(
                _materialUi.TableRowColumn,
                {
                  colSpan: 3,
                  style: _extends({}, styles.cell, {
                    borderRight: border
                  })
                },
                (0, _accessIcons.getAccessIcons)(loc.contracting)
              )
            );
          })
        )
      )
    )
  );
};

AccessLevel.propTypes = {
  corporateAccess: _react.PropTypes.array,
  locAccess: _react.PropTypes.array,
  isSingleLoc: _react.PropTypes.bool,
  companyType: _react.PropTypes.string,
  userId: _react.PropTypes.string,
  adminTeam: _react.PropTypes.array,
  contractingTeam: _react.PropTypes.array,
  isAccom: _react.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user,
      userManagement = _ref.userManagement;
  return {
    companyType: user.getIn(['user', 'type']),
    corporateAccess: user.get('corporateAccess'),
    locAccess: user.get('locAccess'),
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
    adminTeam: userManagement.get('admin').toJS(),
    contractingTeam: userManagement.get('contracting').toJS(),
    userId: user.get('id'),
    isAccom: user.getIn(['company', 'productType']) === 'Accommodation'
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AccessLevel);

/***/ }),
/* 3539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _template = __webpack_require__(1566);

var _template2 = _interopRequireDefault(_template);

var _userActions = __webpack_require__(868);

var _notificationOptions = __webpack_require__(1567);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var checkAssetReceivingSettings = function checkAssetReceivingSettings(direct, settings, notifications) {
  return settings.every(function (s) {
    if (s.settings) return checkAssetReceivingSettings(direct, s.settings, notifications);
    var value = _ramda2.default.path([s.type, s.key], notifications) || [];
    return direct ? value.indexOf('noDirect') === -1 : value.indexOf('email') > -1;
  });
};

var Notifications = function (_Component) {
  _inherits(Notifications, _Component);

  function Notifications() {
    _classCallCheck(this, Notifications);

    return _possibleConstructorReturn(this, (Notifications.__proto__ || Object.getPrototypeOf(Notifications)).apply(this, arguments));
  }

  _createClass(Notifications, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          notifications = _props.notifications,
          editNotifications = _props.editNotifications,
          plan = _props.plan,
          locAccess = _props.locAccess,
          corporateContractingAccess = _props.corporateContractingAccess,
          companyType = _props.companyType;


      var sharedProps = {
        updateNotification: function updateNotification(type, value) {
          return editNotifications(_ramda2.default.merge(notifications, _defineProperty({}, type, _ramda2.default.merge(notifications[type], value))));
        }
      };

      var isPaidUser = plan === 'connected' || plan === 'unlimited';
      var hasContractingAccess = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.complement(_ramda2.default.isEmpty), _ramda2.default.concat(corporateContractingAccess), _ramda2.default.chain(_ramda2.default.prop('contracting'))), locAccess);
      var toggleAll = function toggleAll(direct) {
        return function (_, toggled) {
          var assetReceivingOption = (0, _notificationOptions.options)(true, isPaidUser, companyType, hasContractingAccess)[2];
          var obj = {};
          var updateSetting = function updateSetting(s) {
            var value = _ramda2.default.path([s.type, s.key], notifications) || [];
            obj[s.type] = obj[s.type] || {};
            if (direct) {
              obj[s.type][s.key] = toggled ? value.filter(function (x) {
                return x !== 'noDirect';
              }) : [].concat(_toConsumableArray(value), ['noDirect']);
            } else {
              obj[s.type][s.key] = toggled ? [].concat(_toConsumableArray(value), ['email']) : value.filter(function (x) {
                return x !== 'email';
              });
            }
          };
          assetReceivingOption.settings.forEach(function (s) {
            if (s.settings) {
              s.settings.forEach(updateSetting);
            } else {
              updateSetting(s);
            }
          });
          editNotifications(obj);
        };
      };
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { fontSize: '26px', fontWeight: 400, marginTop: '4px', paddingBottom: '12px', borderBottom: '1px solid #e6e9ec' } },
          'Notifications'
        ),
        _react2.default.createElement(
          'div',
          { style: { margin: '0 5px 0 10px' } },
          (0, _notificationOptions.options)(true, isPaidUser, companyType, hasContractingAccess).map(function (option, i) {
            var allDirectChecked = option.assetReceiving ? checkAssetReceivingSettings(true, option.settings, notifications) : false;
            var allIndirectChecked = option.assetReceiving ? checkAssetReceivingSettings(false, option.settings, notifications) : false;
            return _react2.default.createElement(_template2.default, _extends({
              key: i
            }, sharedProps, option, {
              notifications: notifications,
              allDirectChecked: allDirectChecked,
              allIndirectChecked: allIndirectChecked,
              toggleAllDirect: toggleAll(true),
              toggleAllIndirect: toggleAll(false)
            }));
          })
        )
      );
    }
  }]);

  return Notifications;
}(_react.Component);

Notifications.propTypes = {
  notifications: _react.PropTypes.object,
  editNotifications: _react.PropTypes.func,
  plan: _react.PropTypes.string,
  companyType: _react.PropTypes.string,
  locAccess: _react.PropTypes.array,
  corporateContractingAccess: _react.PropTypes.array
};

var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user;
  return {
    notifications: user.get('notifications'),
    plan: user.get('billingPlan'),
    locAccess: user.get('locAccess'),
    corporateContractingAccess: user.get('corporateContractingAccess'),
    companyType: user.getIn(['user', 'type'])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    editNotifications: function editNotifications() {
      return dispatch(_userActions.editNotificationSettings.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Notifications);

/***/ }),
/* 3540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _icon = __webpack_require__(66);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreditCard = function CreditCard(_ref) {
  var cardType = _ref.cardType,
      cardNumber = _ref.cardNumber,
      cardExpYear = _ref.cardExpYear,
      cardExpMonth = _ref.cardExpMonth,
      nameOnCard = _ref.nameOnCard;

  var cardIcon = function cardIcon(brand) {
    switch (brand.toLowerCase()) {
      case 'american express':
        return 'amex';
      case 'visa':
      case 'mastercard':
      case 'discover':
        return brand.toLowerCase();
      default:
        return '';
    }
  };

  return _react2.default.createElement(
    _materialUi.Paper,
    { style: { backgroundColor: '#fbfbfb', borderRadius: '18px', boxShadow: 'rgba(0, 0, 0, 0.58) 0px 0 1px', padding: '20px 30px', margin: '0 auto' } },
    _react2.default.createElement(
      'p',
      { style: { textAlign: 'right', margin: '-15px 0 15px 0' } },
      _react2.default.createElement('tcIcon', { className: 'tc-icon-' + cardIcon(cardType), style: { fontSize: '50px' } })
    ),
    _react2.default.createElement(
      'p',
      { style: { fontSize: '18px', fontWeight: 300, letterSpacing: '5px', textAlign: 'center' } },
      'xxxx xxxx xxxx ',
      cardNumber
    ),
    _react2.default.createElement(
      'p',
      { style: { display: 'inline-block', margin: 0, textAlign: 'left' } },
      nameOnCard
    ),
    _react2.default.createElement(
      'p',
      { style: { display: 'inline-block', float: 'right', margin: 0, textAlign: 'right' } },
      ' ',
      cardExpMonth,
      ' / ',
      cardExpYear.toString().slice(-2)
    )
  );
};

exports.default = CreditCard;

/***/ }),
/* 3541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bool = _propTypes2.default.bool,
    func = _propTypes2.default.func,
    string = _propTypes2.default.string;


var CancelReason = function CancelReason(_ref) {
  var cancellationReason = _ref.cancellationReason,
      cancellationError = _ref.cancellationError,
      isOpen = _ref.isOpen,
      submitDisabled = _ref.submitDisabled,
      onAdditionalDetailsChange = _ref.onAdditionalDetailsChange,
      onCancelReasonChange = _ref.onCancelReasonChange,
      onCloseClick = _ref.onCloseClick,
      onSubmitClick = _ref.onSubmitClick;

  var actions = [_react2.default.createElement(_materialUi.FlatButton, {
    label: 'Nevermind, Go Back.',
    primary: true,
    onClick: onCloseClick
  }), _react2.default.createElement(_materialUi.FlatButton, {
    label: 'Cancel My Subscription',
    onClick: onSubmitClick,
    disabled: cancellationReason === null || submitDisabled
  })];

  var cancellationReasons = ["Just temporary. We'll be back.", 'Technical issues', "Didn't get what we expected.", 'It is too expensive.', 'Other'];

  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      actions: actions,
      title: 'Is This Really Goodbye?',
      open: isOpen,
      modal: true,
      onRequestClose: onCloseClick
    },
    _react2.default.createElement(
      'p',
      null,
      'We\'d love the opportunity to resolve any issue. Please reach out to ',
      _react2.default.createElement(
        'a',
        { href: 'mailto:support@tourconnect.com' },
        'support@tourconnect.com'
      ),
      ' before cancelling your account.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'If you would still like to proceed with cancelling your account, please let us know why and we\'d appreciated any additional details which could help us get better. Thank you.'
    ),
    _react2.default.createElement(
      _materialUi.SelectField,
      {
        autoWidth: true,
        floatingLabelText: 'Cancellation Reason',
        onChange: onCancelReasonChange,
        value: cancellationReason
      },
      cancellationReasons.map(function (reason, i) {
        return _react2.default.createElement(_materialUi.MenuItem, { key: i, value: reason, primaryText: reason });
      })
    ),
    _react2.default.createElement(_materialUi.TextField, {
      fullWidth: true,
      floatingLabelText: 'Please help us get better by providing us with a little more detail.',
      multiLine: true,
      onChange: onAdditionalDetailsChange,
      rows: 4,
      rowsMax: 6
    }),
    cancellationError && _react2.default.createElement(
      'p',
      { style: { color: 'red' } },
      cancellationError
    )
  );
};

CancelReason.propTypes = {
  cancellationReason: string,
  cancellationError: string,
  isOpen: bool,
  submitDisabled: bool,
  onAdditionalDetailsChange: func,
  onCancelReasonChange: func,
  onCloseClick: func,
  onSubmitClick: func
};

exports.default = CancelReason;

/***/ }),
/* 3542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  table: {
    borderTop: '1px solid #e0e0e0'
  },
  thead: {
    fontSize: '12px',
    fontWeight: 'bolder'
  },
  tr: {
    padding: '8px',
    borderBottom: '1px solid #e0e0e0'
  },
  flex: { display: 'flex' },
  flex1: {
    flex: 1
  },
  colSpan5: {
    width: '60%'
  },
  indent: {
    paddingLeft: '16px'
  },
  dateRange: {
    padding: '8px',
    borderBottom: '1px solid #e0e0e0',
    color: 'rgba(0, 0, 0, 0.44)'
  },
  boldTxt: { fontWeight: 'bold' },
  total: {
    borderBottom: '1px solid #e0e0e0',
    padding: '8px'
  },
  totalTr: {
    padding: '4px'
  },
  flex2: {
    flex: 2
  },
  lightText: {
    color: 'rgba(0, 0, 0, 0.44)'
  },
  alignRight: { textAlign: 'right' }
};

var InvoiceTable = function InvoiceTable(_ref) {
  var invoice = _ref.invoice,
      css = _ref.classes;

  if (!invoice) return _react2.default.createElement('div', null);
  var dateFormat = 'DD MMM YYYY';
  var linesGroupedByPeriod = _ramda2.default.groupWith(function (a, b) {
    return _ramda2.default.path(['period', 'start'], a) === _ramda2.default.path(['period', 'start'], b) && _ramda2.default.path(['period', 'end'], a) === _ramda2.default.path(['period', 'end'], b);
  }, invoice.lines.data);
  return _react2.default.createElement(
    'div',
    { className: css.table },
    _react2.default.createElement(
      'div',
      { className: css.flex + ' ' + css.tr + ' ' + css.thead },
      _react2.default.createElement(
        'div',
        { className: '' + css.colSpan5 },
        'DESCRIPTION'
      ),
      _react2.default.createElement(
        'div',
        { className: '' + css.flex1 },
        'QTY'
      ),
      _react2.default.createElement(
        'div',
        { className: '' + css.flex1 },
        'UNIT PRICE'
      ),
      _react2.default.createElement(
        'div',
        { className: css.flex1 + ' ' + css.alignRight },
        'AMOUNT'
      )
    ),
    linesGroupedByPeriod.map(function (lines, i) {
      var uniqProds = [];
      lines.forEach(function (line) {
        var linePlan = line.plan;

        var lineName = line.description || _ramda2.default.pathOr('', ['nickname'], linePlan) || _ramda2.default.pathOr('', ['name'], linePlan);
        if (linePlan.tiers) {
          linePlan.tiers.forEach(function (t, ti) {
            var min = ti === 0 ? 1 : linePlan.tiers[ti - 1].up_to + 1;
            var amountMatch = t.flat_amount && line.amount === t.flat_amount || t.amount && t.amount * line.quantity === line.amount;
            if (amountMatch) {
              if (ti === 0 && t.up_to) lineName = 'First ' + t.up_to;else if (min && t.up_to) lineName = 'Next ' + min + ' to ' + t.up_to;else if (!t.up_to) lineName = min + ' and above';
            }
          });
        }
        var obj = {
          amount: line.amount / 100,
          quantity: line.quantity,
          unitPrice: function () {
            if (_ramda2.default.path(['price', 'unit_amount'], line)) return _ramda2.default.path(['price', 'unit_amount'], line) / 100;
            if (line.quantity) return line.amount / (line.quantity * 100);
            return null;
          }(),
          lineName: lineName
        };
        var foundIndex = uniqProds.findIndex(function (p) {
          return p.name === linePlan.name;
        });
        if (foundIndex > -1) {
          uniqProds[foundIndex].lines.push(obj);
        } else {
          uniqProds.push(_extends({}, linePlan, {
            lines: [obj]
          }));
        }
      });
      return _react2.default.createElement(
        'div',
        { key: i },
        _react2.default.createElement(
          'div',
          {
            className: '' + css.dateRange
          },
          (0, _moment2.default)((_ramda2.default.path([0, 'period', 'start'], lines) || invoice.period_start) * 1000).format(dateFormat),
          ' - ',
          (0, _moment2.default)((_ramda2.default.path(['lines', 'data', 0, 'period', 'end'], invoice) || invoice.period_end) * 1000).format(dateFormat)
        ),
        uniqProds.map(function (prod, prodI) {
          return _react2.default.createElement(
            'div',
            { key: prodI },
            _react2.default.createElement(
              'div',
              { className: css.flex + ' ' + css.tr },
              _react2.default.createElement(
                'div',
                {
                  className: css.colSpan5 + ' ' + css.boldTxt
                },
                prod.name
              ),
              _react2.default.createElement('div', { className: '' + css.flex1 }),
              _react2.default.createElement('div', { className: css.flex1 }),
              _react2.default.createElement(
                'div',
                { className: css.flex1 + ' ' + css.alignRight },
                function () {
                  if (prod.lines.length === 1) {
                    return '$' + _ramda2.default.path(['lines', 0, 'amount'], prod).toFixed(2);
                  }
                }()
              )
            ),
            prod.lines.length > 1 && prod.lines.map(function (line, lineI) {
              return _react2.default.createElement(
                'div',
                { key: lineI, className: css.flex + ' ' + css.tr },
                _react2.default.createElement(
                  'div',
                  { className: css.colSpan5 + ' ' + css.indent },
                  function () {
                    var name = line.lineName || _ramda2.default.path(['lines', lineI + 1, 'lineName'], prod) || '';
                    if (line.amount && !line.unitPrice) {
                      return 'Flat fee for ' + name.toLowerCase();
                    }
                    return name;
                  }()
                ),
                _react2.default.createElement(
                  'div',
                  { className: '' + css.flex1 },
                  line.quantity
                ),
                _react2.default.createElement(
                  'div',
                  { className: '' + css.flex1 },
                  !_ramda2.default.isNil(line.unitPrice) ? '$' + line.unitPrice.toFixed(2) : ''
                ),
                _react2.default.createElement(
                  'div',
                  { className: css.flex1 + ' ' + css.alignRight },
                  !_ramda2.default.isNil(line.amount) ? '$' + line.amount.toFixed(2) : ''
                )
              );
            })
          );
        })
      );
    }),
    _react2.default.createElement(
      'div',
      { className: css.total },
      _react2.default.createElement(
        'div',
        { className: css.flex + ' ' + css.totalTr },
        _react2.default.createElement('div', { className: css.colSpan5 }),
        _react2.default.createElement(
          'div',
          { className: css.flex2 },
          'Subtotal:'
        ),
        _react2.default.createElement(
          'div',
          { className: css.flex1 + ' ' + css.alignRight },
          '$',
          (invoice.subtotal / 100).toFixed(2)
        )
      ),
      Boolean(invoice.discount) && _react2.default.createElement(
        'div',
        { className: css.flex + ' ' + css.totalTr },
        _react2.default.createElement('div', { className: css.colSpan5 }),
        _react2.default.createElement(
          'div',
          { className: css.flex2 + ' ' + css.lightText },
          _ramda2.default.path(['discount', 'coupon', 'id'], invoice),
          '(',
          _ramda2.default.path(['discount', 'coupon', 'amount_off'], invoice) ? '$' + _ramda2.default.path(['discount', 'coupon', 'amount_off'], invoice) / 100 + ' off' : _ramda2.default.path(['discount', 'coupon', 'percent_off'], invoice) / 100 + '% off',
          ')'
        ),
        _react2.default.createElement(
          'div',
          { className: css.flex1 + ' ' + css.alignRight },
          '-$',
          (_ramda2.default.pathOr(0, ['total_discount_amounts', 0, 'amount'], invoice) / 100).toFixed(2)
        )
      ),
      Boolean(invoice.tax) && _react2.default.createElement(
        'div',
        { className: css.flex + ' ' + css.totalTr },
        _react2.default.createElement('div', { className: css.colSpan5 }),
        _react2.default.createElement(
          'div',
          { className: css.flex2 + ' ' + css.lightText },
          'Tax(',
          _ramda2.default.path(['tax_percent'], invoice),
          '%)'
        ),
        _react2.default.createElement(
          'div',
          { className: css.flex1 + ' ' + css.alignRight },
          '$',
          (_ramda2.default.pathOr(0, ['tax'], invoice) / 100).toFixed(2)
        )
      ),
      _react2.default.createElement(
        'div',
        { className: css.flex + ' ' + css.totalTr },
        _react2.default.createElement('div', { className: css.colSpan5 }),
        _react2.default.createElement(
          'div',
          { className: css.flex2 },
          'Amount Due:'
        ),
        _react2.default.createElement(
          'div',
          { className: css.flex1 + ' ' + css.alignRight },
          '$',
          (invoice.amount_due / 100).toFixed(2)
        )
      )
    )
  );
};

exports.default = (0, _reactJss2.default)(styles)(InvoiceTable);

/***/ }),
/* 3543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _actions = __webpack_require__(3544);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractSettings = function ContractSettings(props) {
  var contractingReminders = props.contractingReminders,
      loading = props.loading,
      saveChange = props.saveSettings;

  var contractReminders = contractingReminders.map(function (e) {
    return _extends({}, e, {
      locked: false,
      text: e.days + ' days ' + e.priorAfter + ' ' + (e.fromDate === 'deadline' ? 'to deadline' : 'the request was sent')
    });
  });
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: {
          paddingBottom: '12px',
          borderBottom: '1px solid #e6e9ec',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between'
        }
      },
      _react2.default.createElement(
        'div',
        { style: { fontSize: '24px', fontWeight: 400 } },
        'Contract Settings'
      ),
      _react2.default.createElement('div', { style: { display: 'flex', alignItems: 'center' } })
    ),
    'Automated Contract Request Reminders (only sent if rates are not marked as received)',
    _react2.default.createElement(
      'div',
      { style: {
          marginTop: '20px'
        }
      },
      contractReminders.map(function (_ref, ix) {
        var locked = _ref.locked,
            enabled = _ref.enabled,
            text = _ref.text;
        return _react2.default.createElement(
          'div',
          {
            style: {
              borderBottom: '1px solid #e6e9ec',
              padding: '10px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center'
            },
            key: ix
          },
          _react2.default.createElement(
            'div',
            { style: locked ? { color: 'rgba(0, 0, 0, 0.24)' } : {} },
            text
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'hint--top',
              'aria-label': function () {
                if (locked) return 'These reminder are always sent';
                return enabled ? 'Turn off email reminder' : 'Turn on email reminder';
              }(),
              style: _extends({}, loading ? { opacity: '0.3' } : {})
            },
            _react2.default.createElement(_materialUi.Toggle, _extends({
              toggled: enabled,
              thumbStyle: enabled ? {} : { backgroundColor: '#ffcccc' },
              trackStyle: enabled ? {} : { backgroundColor: '#ff9d9d' }
            }, locked || loading ? { disabled: true } : {}, {
              onToggle: function onToggle() {
                saveChange({
                  companySettings: {
                    contractingReminders: contractingReminders.map(function (e, iy) {
                      if (ix !== iy) return e;
                      return _extends({}, e, {
                        enabled: !enabled
                      });
                    })
                  }
                });
              }
            }))
          )
        );
      })
    )
  );
};
ContractSettings.defaultProps = {
  contractingReminders: [],
  loading: true,
  loaded: false,
  saveSettings: function saveSettings() {}
};

ContractSettings.propTypes = {
  contractingReminders: _propTypes2.default.array,
  loading: _propTypes2.default.bool,
  loaded: _propTypes2.default.bool,
  saveSettings: _propTypes2.default.func
};

var select = function select(_ref2) {
  var _ref2$settingsReducer = _ref2.settingsReducer,
      contractingReminders = _ref2$settingsReducer.companySettings.contractingReminders,
      loading = _ref2$settingsReducer.loading,
      loaded = _ref2$settingsReducer.loaded;
  return {
    contractingReminders: contractingReminders,
    loading: loading,
    loaded: loaded
  };
};

exports.default = (0, _reactRedux.connect)(select, {
  saveSettings: _actions.saveSettings
})(ContractSettings);

/***/ }),
/* 3544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveSettings = exports.getSettings = undefined;

var _constants = __webpack_require__(657);

var cnt = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getSettings = exports.getSettings = function getSettings() {
  return { type: cnt.GET_SETTINGS };
};
var saveSettings = exports.saveSettings = function saveSettings(payload) {
  return { type: cnt.SAVE_SETTINGS, payload: payload };
};

/***/ }),
/* 3545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _rateFormatSelection = __webpack_require__(1224);

var _rateFormatSelection2 = _interopRequireDefault(_rateFormatSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RateFormat = function (_React$Component) {
  _inherits(RateFormat, _React$Component);

  function RateFormat() {
    _classCallCheck(this, RateFormat);

    var _this = _possibleConstructorReturn(this, (RateFormat.__proto__ || Object.getPrototypeOf(RateFormat)).call(this));

    _this.updateDownloadType = function (type) {
      if (localStorage) {
        localStorage.setItem('rateFormat', type);
      }
      _this.setState({ downloadType: type });
      _this.props.updateDownloadType(type);
    };

    _this.state = {
      downloadType: localStorage ? localStorage.getItem('rateFormat') : 'condensed'
    };
    return _this;
  }

  _createClass(RateFormat, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            style: { paddingBottom: '12px', borderBottom: '1px solid #e6e9ec', marginBottom: '24px' }
          },
          _react2.default.createElement(
            'div',
            { style: { fontSize: '24px', fontWeight: 400 } },
            'Rate Format Settings'
          )
        ),
        _react2.default.createElement(_rateFormatSelection2.default, {
          downloadType: this.state.downloadType,
          updateDownloadType: this.updateDownloadType
        }),
        _react2.default.createElement(
          'div',
          { style: { marginTop: '20px' } },
          _react2.default.createElement(_materialUi.Checkbox, {
            defaultChecked: localStorage.getItem('doNotShowRateFormatPop') === 'true' || localStorage.getItem('doNotShowRateFormatPop') === true,
            label: 'Do not show this preview when I download my rates',
            onCheck: function onCheck(_, checked) {
              return localStorage.setItem('doNotShowRateFormatPop', checked);
            }
          })
        )
      );
    }
  }]);

  return RateFormat;
}(_react2.default.Component);

var actions = {
  updateDownloadType: function updateDownloadType(type) {
    return { type: '[contracting-download]UPDATE_PROPS', payload: { downloadRateFormat: type } };
  }
};

exports.default = (0, _reactRedux.connect)(null, actions)(RateFormat);

/***/ }),
/* 3546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _billingActions = __webpack_require__(1108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpgradeContainer = function (_Component) {
  _inherits(UpgradeContainer, _Component);

  function UpgradeContainer(props) {
    _classCallCheck(this, UpgradeContainer);

    var _this = _possibleConstructorReturn(this, (UpgradeContainer.__proto__ || Object.getPrototypeOf(UpgradeContainer)).call(this, props));

    _this.onClose = function () {
      if (window.history.length === 1) {
        _this.props.push('/dashboard');
      } else {
        _this.props.goBack();
      }
    };

    _this.onUpgrade = function (selectedPlan, response) {
      var dispatch = _this.props.dispatch;

      dispatch((0, _billingActions.addSubscription)(selectedPlan.planId, response.id, response.card)).then(function () {
        dispatch((0, _billingActions.resetBillingError)());
        dispatch((0, _reactRouterRedux.push)('/dashboard'));
      }).catch(function (err) {
        console.log('onUpgrade Error', err);
      });
    };

    _this.state = {
      isProcessing: false
    };

    if (props.user && props.user.company && props.user.company.plan.toLowerCase() !== 'basic') props.replace('/settings/billing');
    return _this;
  }

  _createClass(UpgradeContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var dispatch = this.props.dispatch;

      dispatch((0, _billingActions.resetBillingError)());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      var extraProps = _extends({
        stripePublicKey: "pk_live_3DIaCH9RC6TUHFN58h8Rr0LW",
        onClose: this.onClose,
        onUpgrade: this.onUpgrade,
        user: props.user,
        profile: props.profile,
        isProcessing: props.billing.isLoading,
        header: 'Upgrade to unlock the power of TourConnect'
      }, props);

      return _react2.default.createElement(
        'div',
        null,
        children ? (0, _react.cloneElement)(children, extraProps) : undefined
      );
    }
  }]);

  return UpgradeContainer;
}(_react.Component);

var mapStateToProps = function mapStateToProps(store) {
  return {
    billing: store.billing.toJS(),
    profile: store.profile.toJS(),
    user: store.user.toJS(),
    route: store.route
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { goBack: _reactRouterRedux.goBack, push: _reactRouterRedux.push, replace: _reactRouterRedux.replace })(UpgradeContainer);

/***/ }),
/* 3547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _messagingActions = __webpack_require__(562);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _convsContainer = __webpack_require__(2040);

var _convsContainer2 = _interopRequireDefault(_convsContainer);

var _comment = __webpack_require__(2041);

var _comment2 = _interopRequireDefault(_comment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  params: _react.PropTypes.object,
  children: _react.PropTypes.node,
  selectedConv: _react.PropTypes.object,
  loadConvList: _react.PropTypes.func,
  updateProps: _react.PropTypes.func,
  initialLoadAMsg: _react.PropTypes.func,
  decrementUnreadCount: _react.PropTypes.func,
  convList: _react.PropTypes.array,
  getLatestContractingYear: _react.PropTypes.func
};
var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

var MessagingContainer = function (_Component) {
  _inherits(MessagingContainer, _Component);

  function MessagingContainer(props) {
    _classCallCheck(this, MessagingContainer);

    return _possibleConstructorReturn(this, (MessagingContainer.__proto__ || Object.getPrototypeOf(MessagingContainer)).call(this, props));
  }

  _createClass(MessagingContainer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var params = nextProps.params,
          selectedConv = nextProps.selectedConv;
      // if (!R.eqProps('convList', nextProps, this.props) && isNilOrEmpty(this.props.convList)) {
      //   if (params.convId)
      // }

      if (!_ramda2.default.eqProps('selectedConv', nextProps, this.props)) {
        if (isNilOrEmpty(this.props.selectedConv) && !isNilOrEmpty(nextProps.selectedConv)) {
          if (!params.convId && !params.contractId) {
            if (selectedConv.contractId) this.context.router.push('/messaging/' + params.filter + '/contract/' + selectedConv.contractId);else this.context.router.push('/messaging/' + params.filter + '/conversation/' + selectedConv._id);
          }
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          params = _props.params;

      return _react2.default.createElement(
        'div',
        { className: 'l-app-content l-left-nav-with-content', style: { paddingTop: '65px', backgroundColor: 'rgb(240, 244, 247)', borderRight: '1px solid #e0e0e0' } },
        _react2.default.createElement(_convsContainer2.default, {
          params: params
        }),
        _react2.default.createElement(
          'div',
          { className: 'l-left-nav-content', style: { backgroundColor: '#f0f4f7', width: 'calc(100% - 366px)', paddingLeft: 0 } },
          children || _react2.default.createElement(
            'div',
            { style: { textAlign: 'center', marginTop: '230px' } },
            _react2.default.createElement(_comment2.default, { style: { color: 'rgba(0, 0, 0, 0.24)', height: '56px', width: '56px' } })
          )
        )
      );
    }
  }]);

  return MessagingContainer;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var messaging = _ref.messaging;
  return _extends({}, messaging.conversations.toJS());
};
var mapDispatchToProps = {
  loadConvList: _messagingActions.loadConvList,
  updateProps: _messagingActions.updateProps,
  initialLoadAMsg: _messagingActions.initialLoadAMsg,
  decrementUnreadCount: function decrementUnreadCount() {
    return { type: 'DECREMENT_UNREAD_MESSAGES_COUNT' };
  }
};

MessagingContainer.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
MessagingContainer.propTypes = propTypes;
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MessagingContainer);

/***/ }),
/* 3548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _attachFile = __webpack_require__(1270);

var _attachFile2 = _interopRequireDefault(_attachFile);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _assignmentReturn = __webpack_require__(3549);

var _assignmentReturn2 = _interopRequireDefault(_assignmentReturn);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var isHovered = _ref.isHovered,
      hoveredDone = _ref.hoveredDone,
      toggleDone = _ref.toggleDone,
      conv = _ref.conv,
      markAsDone = _ref.markAsDone;
  return _react2.default.createElement(
    'div',
    { className: 'flex-tc-sb', style: { height: '24px', lineHeight: '24px', overflow: 'hidden' } },
    isHovered ? _react2.default.createElement(
      'div',
      {
        style: { fontSize: '12px', color: hoveredDone ? '#1F8CEB' : '', display: 'flex', alignItems: 'center' },
        onMouseEnter: function onMouseEnter() {
          return toggleDone(true);
        },
        onMouseLeave: function onMouseLeave() {
          return toggleDone(false);
        },
        onClick: function onClick(e) {
          e.stopPropagation();
          markAsDone(conv.messageId, !conv.archived);
        }
      },
      conv.archived ? _react2.default.createElement(_assignmentReturn2.default, {
        color: hoveredDone ? '#1F8CEB' : 'grey',
        style: { height: '18px', width: '18px' }
      }) : _react2.default.createElement(_materialUi.FontIcon, {
        className: 'tc-icon-check',
        color: hoveredDone ? '#1F8CEB' : 'grey',
        style: { fontSize: '18px' }
      }),
      conv.archived ? 'Reopen' : 'Done'
    ) : _react2.default.createElement(
      'div',
      { style: { fontSize: '12px', color: conv.hasSeen ? 'grey' : '#00bcd4', display: 'flex', alignItems: 'center' } },
      conv.attachements && conv.attachments.length ? _react2.default.createElement(_attachFile2.default, { style: { height: '16px', color: 'grey' } }) : null,
      (0, _moment2.default)(conv.createdAt).calendar(null, {
        sameDay: '[Today]',
        lastDay: 'DD/MM/YYYY',
        lastWeek: 'DD/MM/YYYY',
        sameElse: 'DD/MM/YYYY'
      })
    )
  );
};

/***/ }),
/* 3549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAssignmentReturn = function ActionAssignmentReturn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z' })
  );
};
ActionAssignmentReturn = (0, _pure2.default)(ActionAssignmentReturn);
ActionAssignmentReturn.displayName = 'ActionAssignmentReturn';
ActionAssignmentReturn.muiName = 'SvgIcon';

exports.default = ActionAssignmentReturn;

/***/ }),
/* 3550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _planer = __webpack_require__(2011);

var _planer2 = _interopRequireDefault(_planer);

var _messagingAvatar = __webpack_require__(1271);

var _messagingAvatar2 = _interopRequireDefault(_messagingAvatar);

var _actionDialog = __webpack_require__(3551);

var _actionDialog2 = _interopRequireDefault(_actionDialog);

var _regularAttachments = __webpack_require__(2012);

var _regularAttachments2 = _interopRequireDefault(_regularAttachments);

var _messageWrapper = __webpack_require__(2043);

var _messageWrapper2 = _interopRequireDefault(_messageWrapper);

var _messagingActions = __webpack_require__(562);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  messages: _react.PropTypes.array,
  loadingMessages: _react.PropTypes.bool,
  conv: _react.PropTypes.object,
  params: _react.PropTypes.object,
  viewerCompany: _react.PropTypes.object,
  updateProps: _react.PropTypes.func
};

var Messages = function (_React$Component) {
  _inherits(Messages, _React$Component);

  function Messages() {
    _classCallCheck(this, Messages);

    return _possibleConstructorReturn(this, (Messages.__proto__ || Object.getPrototypeOf(Messages)).apply(this, arguments));
  }

  _createClass(Messages, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // const hash = `#bottomEl`;
      // const element = document.querySelector(hash);
      // if (element) scrollTo(hash);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react2.default.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var messages = this.props.messages;

      return _react2.default.createElement(
        'div',
        { style: { padding: '16px 32px' } },
        messages.map(function (msg) {
          return _react2.default.createElement(
            _messageWrapper2.default,
            {
              key: msg.messageId,
              id: msg.messageId,
              avatarInfo: msg.creatorMeta,
              timestamp: msg.updatedAt,
              isSender: msg.viewerIsSender
            },
            _react2.default.createElement(
              'div',
              { style: { fontSize: '16px', fontWeight: 'bold', marginBottom: '16px' } },
              msg.subject
            ),
            _react2.default.createElement('div', {
              className: 'message-div',
              style: { display: msg.bodyText ? 'block' : 'none', overflow: 'hidden', whiteSpace: 'pre-wrap' },
              dangerouslySetInnerHTML: { __html: msg.bodyJson.emailBody.html ? msg.bodyJson.emailBody.html : msg.bodyText }
            }),
            _react2.default.createElement(_regularAttachments2.default, {
              uploads: msg.attachments,
              allowFilesToBeAddedToContract: true,
              addToContractFn: function addToContractFn(files) {
                return _this2.props.updateProps('action_dialog', {
                  open: true,
                  type: 'addToContract',
                  files: _ramda2.default.map(_ramda2.default.merge({ source: 'emailScrape' }), files),
                  msg: msg,
                  supplierInfo: {}
                });
              }
            })
          );
        }),
        _react2.default.createElement('div', { id: 'bottomEl' }),
        _react2.default.createElement(_actionDialog2.default, { updateProps: this.props.updateProps })
      );
    }
  }]);

  return Messages;
}(_react2.default.Component);

Messages.propTypes = propTypes;
var mapStateToProps = function mapStateToProps(_ref) {
  var messaging = _ref.messaging,
      user = _ref.user;
  return {
    messages: messaging.messages.toJS().list,
    conv: messaging.messages.toJS().conv,
    loadingMessages: messaging.messages.get('loadingMessages'),
    messagesLoaded: messaging.messages.get('messagesLoaded'),
    viewerCompany: user.toJS().company
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProps: function updateProps() {
      return dispatch(_messagingActions.updateProps.apply(undefined, arguments));
    }
  };
};
Messages.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Messages);

/***/ }),
/* 3551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _attachFile = __webpack_require__(1270);

var _attachFile2 = _interopRequireDefault(_attachFile);

var _arrowBack = __webpack_require__(1124);

var _arrowBack2 = _interopRequireDefault(_arrowBack);

var _search = __webpack_require__(1223);

var _search2 = _interopRequireDefault(_search);

var _addCircleOutline = __webpack_require__(1259);

var _addCircleOutline2 = _interopRequireDefault(_addCircleOutline);

var _messagingActions = __webpack_require__(562);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _contractInfoForm = __webpack_require__(3552);

var _contractInfoForm2 = _interopRequireDefault(_contractInfoForm);

var _matchedRequests = __webpack_require__(3554);

var _matchedRequests2 = _interopRequireDefault(_matchedRequests);

var _congratulation = __webpack_require__(3555);

var _congratulation2 = _interopRequireDefault(_congratulation);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = function mapStateToProps(_ref) {
  var messaging = _ref.messaging,
      user = _ref.user;
  return _extends({}, messaging.actionDialog.toJS(), {
    buyerCompanyName: user.getIn(['company', 'companyName']),
    buyerId: user.getIn(['company', 'companyId'])
  });
};
var mapDispatchToProps = {
  createContractWithFiles: _messagingActions.createContractWithFiles,
  searchContractRequest: _messagingActions.searchContractRequest,
  addFilesToRequestsInDialog: _messagingActions.addFilesToRequestsInDialog,
  getPartners: _messagingActions.getPartners
};
var propTypes = {
  open: _react.PropTypes.bool,
  searchingRequests: _react.PropTypes.bool,
  showRequests: _react.PropTypes.bool,
  files: _react.PropTypes.array,
  updateProps: _react.PropTypes.func,
  startDateValue: _react.PropTypes.string,
  endDateValue: _react.PropTypes.string,
  msg: _react.PropTypes.object,
  companyNameValue: _react.PropTypes.string,
  createContractWithFiles: _react.PropTypes.func,
  searchContractRequest: _react.PropTypes.func,
  createdContract: _react.PropTypes.object,
  updatedContract: _react.PropTypes.object,
  creatingContract: _react.PropTypes.bool,
  buyerCompanyName: _react.PropTypes.string,
  buyerId: _react.PropTypes.string,
  newPartner: _react.PropTypes.object,
  selectedPartner: _react.PropTypes.object,
  matchedRequestsByEmails: _react.PropTypes.array,
  partners: _react.PropTypes.array,
  loadingRequests: _react.PropTypes.bool,
  addFilesToRequestsInDialog: _react.PropTypes.func,
  searchedForRequests: _react.PropTypes.bool,
  allEmailsFromBody: _react.PropTypes.array,
  getPartners: _react.PropTypes.func,
  showNewPartnerForm: _react.PropTypes.bool
};
var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

/*
 step 1:
  show requests that we matched based on the emails we pull from the email body
  if no requests, ask user
  option one: search based on user inputs
  option two: create a new contract request

 */

var MessagingActionDialog = function (_React$Component) {
  _inherits(MessagingActionDialog, _React$Component);

  function MessagingActionDialog() {
    _classCallCheck(this, MessagingActionDialog);

    var _this = _possibleConstructorReturn(this, (MessagingActionDialog.__proto__ || Object.getPrototypeOf(MessagingActionDialog)).call(this));

    _this.chooseSearchRequests = function () {
      _this.setState({ step: 'searchRequests' });
    };

    _this.searchRequestsByInput = function () {
      _this.setState({ doSearchByInput: true });
      _this.props.searchContractRequest({
        companyId: _this.props.buyerId,
        companyType: 'Contractor',
        startDate: _this.props.startDateValue,
        endDate: _this.props.endDateValue,
        searchInput: _this.state.searchInput
      });
    };

    _this.state = {
      allEmailsFromBody: [],
      step: 'showOptions', // showOptions, searchRequests, createNewRequest
      searchInput: '',
      doSearchByInput: false
    };
    return _this;
  }

  _createClass(MessagingActionDialog, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.open && nextProps.open) {
        var msg = nextProps.msg,
            startDateValue = nextProps.startDateValue,
            endDateValue = nextProps.endDateValue,
            searchContractRequest = nextProps.searchContractRequest,
            getPartners = nextProps.getPartners,
            updateProps = nextProps.updateProps;

        var allEmailsFromBody = _ramda2.default.call(_ramda2.default.compose(_ramda2.default.reject(_ramda2.default.contains('staging.tourconnect.com')), _ramda2.default.uniq, _ramda2.default.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi)), msg.bodyText);
        updateProps('action_dialog', { allEmailsFromBody: allEmailsFromBody });
        searchContractRequest({
          companyId: this.props.buyerId,
          companyType: 'Contractor',
          startDate: startDateValue,
          endDate: endDateValue,
          emails: nextProps.newPartner.email ? _ramda2.default.uniq(_ramda2.default.append(nextProps.newPartner.email, allEmailsFromBody)) : allEmailsFromBody
        });
        getPartners();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          open = _props.open,
          searchingRequests = _props.searchingRequests,
          showRequests = _props.showRequests,
          files = _props.files,
          updateProps = _props.updateProps,
          matchedRequestsByEmails = _props.matchedRequestsByEmails,
          matchedRequestsByInput = _props.matchedRequestsByInput,
          createdContract = _props.createdContract,
          updatedContract = _props.updatedContract,
          addFilesToRequestsInDialog = _props.addFilesToRequestsInDialog,
          startDateValue = _props.startDateValue,
          endDateValue = _props.endDateValue,
          newPartner = _props.newPartner,
          selectedPartner = _props.selectedPartner,
          createContractWithFiles = _props.createContractWithFiles,
          msg = _props.msg,
          buyerCompanyName = _props.buyerCompanyName,
          buyerId = _props.buyerId,
          allEmailsFromBody = _props.allEmailsFromBody;

      var createContractWithFilesFn = function createContractWithFilesFn() {
        return createContractWithFiles({
          messageId: msg.messageId,
          buyerCompanyName: buyerCompanyName,
          buyerId: buyerId,
          startDate: startDateValue,
          endDate: endDateValue,
          files: _ramda2.default.map(_ramda2.default.compose(_ramda2.default.assoc('source', 'emailScrape'), _ramda2.default.omit(['logs'])), files),
          newPartner: newPartner,
          selectedPartner: selectedPartner
        });
      };
      if (!open) return _react2.default.createElement('div', null);
      var step = this.state.step;

      var searchOrCreateButtonsNode = _react2.default.createElement(
        'div',
        { className: 'flex-tc-sb', style: { marginTop: '16px', width: '80%' } },
        _react2.default.createElement(_materialUi.RaisedButton, {
          secondary: true,
          icon: _react2.default.createElement(_search2.default, null),
          label: 'Search Existing Requests',
          onTouchTap: this.chooseSearchRequests
        }),
        _react2.default.createElement(
          'div',
          null,
          'OR'
        ),
        _react2.default.createElement(_materialUi.RaisedButton, {
          secondary: true,
          icon: _react2.default.createElement(_addCircleOutline2.default, null),
          label: 'Add ' + (0, _pluralize2.default)('File', files.length) + ' to A New Contract',
          onTouchTap: function onTouchTap() {
            return _this2.setState({ step: 'createNewRequest' });
          }
        })
      );
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          open: open,
          autoScrollBodyContent: true,
          modal: true,
          bodyStyle: { padding: '24px' },
          titleStyle: { padding: '8px 16px' },
          title: _react2.default.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
            'Add ',
            (0, _pluralize2.default)('File', files.length),
            ' to Contract',
            _react2.default.createElement(_materialUi.IconButton, {
              iconClassName: 'tc-icon-close',
              iconStyle: { color: 'red', fontSize: '32px' },
              onTouchTap: function onTouchTap() {
                updateProps('action_dialog', { open: false });
              }
            })
          ),
          actions: _react2.default.createElement(
            'div',
            { className: 'flex-tc-sb' },
            _react2.default.createElement(
              'div',
              { style: { textAlign: 'left' } },
              'Selected ',
              (0, _pluralize2.default)('File', files.length),
              ':',
              files.map(function (file, i) {
                return _react2.default.createElement(
                  'div',
                  { key: i, style: { display: 'flex', alignItems: 'center' } },
                  _react2.default.createElement(_attachFile2.default, { style: { height: '16px', color: 'grey' } }),
                  _react2.default.createElement(
                    'span',
                    { style: { maxWidth: '380px', overflowX: 'hidden', textOverflow: 'ellipsis' } },
                    file.name
                  )
                );
              })
            ),
            _ramda2.default.call(_ramda2.default.cond([[function () {
              return searchingRequests;
            }, _ramda2.default.always(_react2.default.createElement('span', null))], [function () {
              return !_ramda2.default.isEmpty(createdContract) || !_ramda2.default.isEmpty(updatedContract);
            }, _ramda2.default.always(_react2.default.createElement('span', null))], [function () {
              return step === 'showOptions';
            }, _ramda2.default.always(_react2.default.createElement('span', null))], [_ramda2.default.T, _ramda2.default.always(_react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_materialUi.RaisedButton, {
                label: 'Back',
                onTouchTap: function onTouchTap() {
                  return _this2.setState({ step: 'showOptions' });
                },
                icon: _react2.default.createElement(_arrowBack2.default, null)
              }),
              step === 'searchRequests' ? _react2.default.createElement(_raisedButtonWithLoader2.default, {
                secondary: true,
                style: { marginLeft: '4px' },
                label: 'Search',
                loader: searchingRequests,
                icon: _react2.default.createElement(_search2.default, null),
                disabled: !this.state.searchInput.trim(),
                onTouchTap: this.searchRequestsByInput
              }) : _react2.default.createElement(_raisedButtonWithLoader2.default, {
                secondary: true,
                style: { marginLeft: '4px' },
                label: 'Create New Contract',
                loader: this.props.creatingContract,
                icon: _react2.default.createElement(_addCircleOutline2.default, null),
                disabled: !startDateValue || !endDateValue || startDateValue >= endDateValue || !(newPartner.email && newPartner.companyName || selectedPartner.partnerId && selectedPartner.contactIds.length),
                onTouchTap: createContractWithFilesFn
              })
            ))]]))
          )
        },
        _ramda2.default.call(_ramda2.default.cond([[function () {
          return searchingRequests;
        }, _ramda2.default.always(_react2.default.createElement(
          'div',
          { style: { display: 'flex', alignItems: 'center' } },
          _react2.default.createElement(_materialUi.CircularProgress, null),
          'Searching existing requests...'
        ))], [function () {
          return !_ramda2.default.isEmpty(createdContract) || !_ramda2.default.isEmpty(updatedContract);
        }, _ramda2.default.always(_react2.default.createElement(_congratulation2.default, {
          router: this.context.router,
          createdContract: createdContract,
          updateProps: updateProps,
          files: files
        }))], [function () {
          return step === 'showOptions';
        }, _ramda2.default.always(_react2.default.createElement(
          'div',
          null,
          !isNilOrEmpty(matchedRequestsByEmails) ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_matchedRequests2.default, {
              addFilesToRequestsInDialog: addFilesToRequestsInDialog,
              matchedRequests: matchedRequestsByEmails,
              files: files
            }),
            _react2.default.createElement('br', null),
            'Don\'t see the one you are looking for?'
          ) : _react2.default.createElement(
            'div',
            null,
            'We couldn\'t find any contracts based on the information from the message.',
            _react2.default.createElement('br', null),
            ' Would you like to:'
          ),
          searchOrCreateButtonsNode
        ))], [function () {
          return _this2.state.step === 'searchRequests';
        }, _ramda2.default.always(_react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Please enter your partner\'s information.'
            )
          ),
          _react2.default.createElement(_materialUi.TextField, {
            id: 'companyNameOrEmail',
            style: { width: '100%' },
            hintStyle: { fontSize: '12px' },
            inputStyle: { fontSize: '14px' },
            hintText: 'Enter company name or email here...',
            underlineStyle: { borderColor: '#00bcd4' },
            value: this.state.searchInput,
            onKeyDown: function onKeyDown(e) {
              if (e.keyCode === 13) _this2.searchRequestsByInput();
            },
            onChange: function onChange(_, val) {
              return _this2.setState({ searchInput: val });
            }
          }),
          !isNilOrEmpty(matchedRequestsByInput) && this.state.doSearchByInput && _react2.default.createElement(_matchedRequests2.default, {
            addFilesToRequestsInDialog: addFilesToRequestsInDialog,
            matchedRequests: matchedRequestsByInput,
            files: files
          })
        ))], [function () {
          return _this2.state.step === 'createNewRequest';
        }, _ramda2.default.always(_react2.default.createElement(_contractInfoForm2.default, _extends({}, this.props, {
          allEmailsFromBody: allEmailsFromBody
        })))]]))
      );
    }
  }]);

  return MessagingActionDialog;
}(_react2.default.Component);

MessagingActionDialog.propTypes = propTypes;
MessagingActionDialog.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MessagingActionDialog);

/***/ }),
/* 3552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _contractingYear = __webpack_require__(3553);

var _contractingYear2 = _interopRequireDefault(_contractingYear);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _reactSelect = __webpack_require__(52);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var ContractInfoForm = function ContractInfoForm(_ref) {
  var updateProps = _ref.updateProps,
      startDateValue = _ref.startDateValue,
      endDateValue = _ref.endDateValue,
      newPartner = _ref.newPartner,
      partners = _ref.partners,
      selectedPartner = _ref.selectedPartner,
      allEmailsFromBody = _ref.allEmailsFromBody,
      showNewPartnerForm = _ref.showNewPartnerForm;

  var dateError = function () {
    if (!startDateValue) return 'Start Date is required';
    if (!endDateValue) return 'End Date is required';
    if (startDateValue >= endDateValue) return 'End Date must be after the start date.';
  }();
  var partnerError = function () {
    if (selectedPartner && selectedPartner.partnerId && !(selectedPartner.contactIds && selectedPartner.contactIds.length)) {
      return 'Please select at least one contact';
    }
  }();
  var onSelectPartner = function onSelectPartner(_ref2) {
    var partner = _ref2.partner;

    updateProps('action_dialog', {
      selectedPartner: {
        partnerName: partner.name,
        partnerAvatar: partner.avatar,
        partnerId: partner.id,
        contacts: partner.contacts,
        emails: partner.contacts.map(function (obj) {
          return obj.email;
        }),
        contactIds: partner.contacts.map(function (obj) {
          return obj.id;
        })
      }
    });
  };
  var onCheckContact = function onCheckContact(contact) {
    return function (_, checked) {
      updateProps('action_dialog', {
        selectedPartner: _extends({}, selectedPartner, {
          emails: checked ? [].concat(_toConsumableArray(selectedPartner.emails), [contact.email]) : selectedPartner.emails.filter(function (email) {
            return email !== contact.email;
          }),
          contactIds: checked ? [].concat(_toConsumableArray(selectedPartner.contactIds), [contact.id]) : selectedPartner.contactIds.filter(function (id) {
            return id !== contact.id;
          })
        })
      });
    };
  };
  var onCheckShowNewPartnerForm = function onCheckShowNewPartnerForm(_, checked) {
    return updateProps('action_dialog', {
      showNewPartnerForm: checked,
      selectedPartner: checked ? {} : selectedPartner
    });
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_contractingYear2.default, {
      startDate: startDateValue,
      endDate: endDateValue,
      onChange: function onChange(_ref3) {
        var key = _ref3.key,
            value = _ref3.value;
        return updateProps('action_dialog', _defineProperty({}, key + 'Value', value));
      }
    }),
    _react2.default.createElement(
      'div',
      { style: { fontSize: '12px', color: 'red', clear: 'both' } },
      dateError
    ),
    _react2.default.createElement(
      'div',
      { style: { clear: 'both' } },
      _react2.default.createElement(
        'label',
        null,
        _react2.default.createElement(
          'b',
          null,
          'Please search for a partner:'
        )
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement('br', null),
      _react2.default.createElement(_reactSelect2.default, {
        wrapperStyle: { width: '100%' },
        name: 'select-partner',
        onChange: onSelectPartner,
        options: partners.map(function (partner) {
          return {
            value: partner.id,
            label: partner.name + ' ' + partner.contacts.length + ' (' + (0, _pluralize2.default)('contacts', partner.contacts.length) + ')',
            partner: partner
          };
        }),
        value: selectedPartner.partnerId,
        placeholder: 'Search & Pick A Partner',
        clearable: false,
        scrollMenuIntoView: false
      }),
      _react2.default.createElement(
        'div',
        { style: { fontSize: '12px', color: 'red', clear: 'both' } },
        partnerError
      ),
      _react2.default.createElement('br', null),
      Boolean(selectedPartner && selectedPartner.contacts && selectedPartner.contacts.length) && _react2.default.createElement(
        'div',
        { style: { marginBottom: '16px' } },
        selectedPartner.contacts.map(function (contact) {
          return _react2.default.createElement(_materialUi.Checkbox, {
            key: contact.id,
            label: contact.email,
            checked: selectedPartner.contactIds.indexOf(contact.id) > -1,
            onCheck: onCheckContact(contact)
          });
        })
      ),
      _react2.default.createElement(_materialUi.Checkbox, {
        label: _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Or enter new partner info (we will create new partner/contact):'
          )
        ),
        checked: showNewPartnerForm,
        onCheck: onCheckShowNewPartnerForm
      }),
      _react2.default.createElement(
        'div',
        { style: { visibility: showNewPartnerForm ? 'visible' : 'hidden', marginTop: '12px' } },
        _react2.default.createElement(
          'div',
          null,
          'Company Name (Required):'
        ),
        _react2.default.createElement(_materialUi.TextField, {
          id: 'companyName',
          style: { width: '100%' },
          hintStyle: { fontSize: '12px' },
          inputStyle: { fontSize: '14px' },
          hintText: 'Enter company name here...',
          underlineStyle: { borderColor: '#00bcd4' },
          value: newPartner.companyName,
          onChange: function onChange(_, val) {
            return updateProps('action_dialog', { newPartner: _ramda2.default.merge(newPartner, { companyName: val }) });
          }
        }),
        _react2.default.createElement(
          'div',
          null,
          'Email (Required):'
        ),
        _react2.default.createElement(_materialUi.TextField, {
          id: 'email',
          style: { width: '100%' },
          hintStyle: { fontSize: '12px' },
          inputStyle: { fontSize: '14px' },
          underlineStyle: { borderColor: '#00bcd4' },
          value: newPartner.email,
          onChange: function onChange(_, val) {
            return updateProps('action_dialog', {
              newPartner: _ramda2.default.merge(newPartner, { email: val }) // if email is modified, remove original supplierId
            });
          }
        }),
        !isNilOrEmpty(allEmailsFromBody) && _react2.default.createElement(
          'div',
          { style: { border: '1px dashed #e0e0e0', marginTop: '8px', padding: '8px', width: '100%' } },
          _react2.default.createElement(
            'small',
            null,
            'We have picked up below email addresses from the message:'
          ),
          allEmailsFromBody.map(function (email) {
            return _react2.default.createElement(
              'div',
              { key: email, className: 'flex-tc-sb', style: { marginBottom: '4px' } },
              _react2.default.createElement(
                'div',
                { style: { width: '80%', wordWrap: 'break-word' } },
                email
              ),
              _react2.default.createElement(_flatButtonWithLoader2.default, {
                onTouchTap: function onTouchTap() {
                  return updateProps('action_dialog', {
                    newPartner: _ramda2.default.merge(newPartner, { email: email }) // if email is modified, remove original supplierId
                  });
                },
                style: { border: '1px solid #00bcd4', height: '24px', lineHeight: '24px', verticalAlign: 'top' },
                label: 'Use this address',
                labelStyle: { textTransform: 'none', color: '#00bcd4', padding: '0 4px', verticalAlign: '', top: '-1px' }
              })
            );
          })
        )
      )
    )
  );
};

exports.default = ContractInfoForm;

/***/ }),
/* 3553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _datePicker = __webpack_require__(1003);

var _datePicker2 = _interopRequireDefault(_datePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractingYear = function ContractingYear(_ref) {
  var endDate = _ref.endDate,
      endDateError = _ref.endDateError,
      _onChange = _ref.onChange,
      startDate = _ref.startDate,
      startDateError = _ref.startDateError,
      style = _ref.style;
  return _react2.default.createElement(
    'div',
    { style: style },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'b',
        null,
        'What dates would you like the rates to be valid for?'
      ),
      _react2.default.createElement(
        'small',
        { style: { color: 'red' } },
        '* Required'
      )
    ),
    _react2.default.createElement(_datePicker2.default, {
      'data-cy': 'startDate',
      containerStyle: { float: 'left', display: 'inline-block', verticalAlign: 'top' },
      textFieldStyle: { float: 'left', width: '100%', fontSize: '12px' },
      errorText: startDateError,
      onChange: function onChange(date) {
        return _onChange({ key: 'startDate', value: date });
      },
      initialMonth: startDate || endDate,
      value: startDate,
      floatingLabelText: 'Start Date',
      closeOnSelect: true
    }),
    _react2.default.createElement(_datePicker2.default, {
      'data-cy': 'endDate',
      containerStyle: {
        float: 'left', marginLeft: '32px', display: 'inline-block', verticalAlign: 'top'
      },
      textFieldStyle: { float: 'left', width: '100%', fontSize: '12px' },
      errorText: endDateError,
      onChange: function onChange(date) {
        return _onChange({ key: 'endDate', value: date });
      },
      floatingLabelText: 'End Date',
      initialMonth: endDate || startDate,
      value: endDate,
      closeOnSelect: true
    }),
    _react2.default.createElement('br', null)
  );
};

ContractingYear.propTypes = {
  style: _propTypes2.default.object,
  onChange: _propTypes2.default.func.isRequired,
  startDateError: _propTypes2.default.string,
  endDateError: _propTypes2.default.string,
  startDate: _propTypes2.default.string.isRequired,
  endDate: _propTypes2.default.string.isRequired
};

exports.default = ContractingYear;

/***/ }),
/* 3554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _attachFile = __webpack_require__(1270);

var _attachFile2 = _interopRequireDefault(_attachFile);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _add = __webpack_require__(2013);

var _add2 = _interopRequireDefault(_add);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);
var ProfileImage = function ProfileImage(_ref) {
  var profileImageUrl = _ref.profileImageUrl,
      isExternal = _ref.isExternal,
      name = _ref.name;

  if (isExternal) {
    return _react2.default.createElement(
      _materialUi.Avatar,
      { size: 30, backgroundColor: 'rgba(0, 0, 0, 0.1)' },
      _react2.default.createElement(
        'span',
        { style: { fontSize: '9px', color: 'rgba(0, 0, 0, 0.67)' } },
        'offline'
      )
    );
  }
  if (profileImageUrl) return _react2.default.createElement(_materialUi.Avatar, { size: 30, src: profileImageUrl });
  return _react2.default.createElement(
    _materialUi.Avatar,
    { size: 30 },
    _ramda2.default.head(name)
  );
};
var MatchedRequests = function MatchedRequests(_ref2, _ref3) {
  var addFilesToRequestsInDialog = _ref2.addFilesToRequestsInDialog,
      matchedRequests = _ref2.matchedRequests,
      files = _ref2.files;
  var router = _ref3.router;

  var matchedRequestsGroupedByDates = function () {
    if (matchedRequests && matchedRequests.length) {
      return _ramda2.default.groupBy(function (request) {
        return _moment2.default.utc(request.startDate).format('D MMM YYYY') + ' - ' + _moment2.default.utc(request.endDate).format('D MMM YYYY');
      }, matchedRequests);
    }
    return [];
  }();
  return _react2.default.createElement(
    'div',
    null,
    'We\u2019ve found the following ',
    (0, _pluralize2.default)('contract', matchedRequests.length),
    '.',
    _ramda2.default.keys(matchedRequestsGroupedByDates).map(function (yearString) {
      var requests = matchedRequestsGroupedByDates[yearString];
      return _react2.default.createElement(
        'div',
        { style: { marginTop: '8px' }, key: yearString },
        _react2.default.createElement(
          'b',
          null,
          'Contract Period: ',
          yearString
        ),
        _react2.default.createElement(
          'div',
          { style: { border: '2px solid #e0e0e0', width: '100%', marginTop: '4px' } },
          requests.map(function (request, requestIndex) {
            return _react2.default.createElement(
              'div',
              { key: request._id, style: { padding: '8px', borderBottom: requestIndex < requests.length - 1 ? '1px solid #e0e0e0' : 'none' } },
              _react2.default.createElement(
                'div',
                { className: 'flex-tc-sb', style: { marginBottom: '4px', flexWrap: 'wrap' } },
                _react2.default.createElement(ProfileImage, {
                  profileImageUrl: request.to.avatar,
                  name: request.to.name || ''
                }),
                _react2.default.createElement(
                  'div',
                  { style: { marginLeft: '4px', width: '50%' } },
                  _react2.default.createElement(
                    'small',
                    { style: { display: 'block' } },
                    request.to.name,
                    ' (',
                    (request.files ? request.files.length : 0) + ' files',
                    ')'
                  ),
                  _react2.default.createElement(
                    'small',
                    null,
                    request.toEmails.join(', ')
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { style: { marginLeft: '4px', width: '260px' }, className: 'flex-tc-sb' },
                  _react2.default.createElement(
                    _flatButtonWithLoader2.default,
                    {
                      style: { border: '1px solid #49708A', height: '30px', lineHeight: '30px', minWidth: '167px' },
                      onTouchTap: function onTouchTap() {
                        return addFilesToRequestsInDialog(request, _ramda2.default.map(_ramda2.default.compose(_ramda2.default.assoc('source', 'emailScrape'), _ramda2.default.omit(['logs'])), files));
                      }
                    },
                    _react2.default.createElement(
                      'div',
                      { className: 'flex-tc-sb' },
                      _react2.default.createElement(_add2.default, { color: '#49708A', style: { marginLeft: '0px' } }),
                      _react2.default.createElement(
                        'span',
                        { style: { textTransform: 'none', color: '#49708A', padding: '0 4px' } },
                        'Add to This Contract'
                      )
                    )
                  ),
                  _react2.default.createElement(_flatButtonWithLoader2.default, {
                    onTouchTap: function onTouchTap() {
                      return router.push('/contracting/contract/' + request._id + '/details');
                    },
                    style: { border: '1px solid #49708A', height: '30px', lineHeight: '30px', marginLeft: '4px', minWidth: '60px' },
                    label: 'Open',
                    labelStyle: { textTransform: 'none', color: '#49708A', padding: '0 4px', verticalAlign: '', top: '-1px' }
                  })
                )
              )
            );
          })
        )
      );
    })
  );
};
MatchedRequests.contextTypes = {
  router: _react.PropTypes.object.isRequired
};

exports.default = MatchedRequests;

/***/ }),
/* 3555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _raisedButtonWithLoader = __webpack_require__(132);

var _raisedButtonWithLoader2 = _interopRequireDefault(_raisedButtonWithLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CongratulationPage = function CongratulationPage(_ref) {
  var files = _ref.files,
      updateProps = _ref.updateProps,
      router = _ref.router,
      createdContract = _ref.createdContract;
  return _react2.default.createElement(
    'div',
    { style: { textAlign: 'center' } },
    'Your ',
    (0, _pluralize2.default)('file', files.length),
    ' ',
    (0, _pluralize2.default)('was', files.length),
    ' successfully added!',
    _react2.default.createElement('br', null),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'div',
      { style: { textAlign: 'center' } },
      _react2.default.createElement(_flatButtonWithLoader2.default, {
        secondary: true,
        label: 'Go to Contract List',
        onTouchTap: function onTouchTap() {
          updateProps('action_dialog', { open: false });
          router.replace('/messaging/notdone/contract/' + createdContract._id);
          router.push('/contracting/contract-list/recent');
        }
      }),
      _react2.default.createElement(_raisedButtonWithLoader2.default, {
        secondary: true,
        label: 'View Contract',
        onTouchTap: function onTouchTap() {
          updateProps('action_dialog', { open: false });
          router.push('/contracting/contract/' + createdContract._id + '/details');
        }
      })
    )
  );
};
exports.default = CongratulationPage;

/***/ }),
/* 3556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _container = __webpack_require__(3557);

var _container2 = _interopRequireDefault(_container);

var _container3 = __webpack_require__(3558);

var _container4 = _interopRequireDefault(_container3);

var _materialUi = __webpack_require__(3);

var _actions = __webpack_require__(226);

var _metaDataActions = __webpack_require__(1113);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _improveFeedContainer = __webpack_require__(3570);

var _improveFeedContainer2 = _interopRequireDefault(_improveFeedContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  initialNewsfeedLoad: _react.PropTypes.func,
  loadMore: _react.PropTypes.func,
  changeNewsfeedFilter: _react.PropTypes.func,
  getHashtags: _react.PropTypes.func,
  getMetadata: _react.PropTypes.func,
  updateProps: _react.PropTypes.func,
  user: _react.PropTypes.object,
  newsfeed: _react.PropTypes.array,
  ownerMetaData: _react.PropTypes.object,
  isAdmin: _react.PropTypes.bool
};

var NewsFeed = function (_Component) {
  _inherits(NewsFeed, _Component);

  function NewsFeed() {
    _classCallCheck(this, NewsFeed);

    return _possibleConstructorReturn(this, (NewsFeed.__proto__ || Object.getPrototypeOf(NewsFeed)).apply(this, arguments));
  }

  _createClass(NewsFeed, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          getHashtags = _props.getHashtags,
          initialNewsfeedLoad = _props.initialNewsfeedLoad,
          newsfeed = _props.newsfeed,
          getMetadata = _props.getMetadata;

      getHashtags();
      getMetadata();
      if (_ramda2.default.isEmpty(newsfeed)) initialNewsfeedLoad();
      this.props.updateProps({
        selectedLeftNav: 'News Feed',
        filterType: ''
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.updateProps({ newsfeed: [] });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          ownerMetaData = _props2.ownerMetaData,
          isAdmin = _props2.isAdmin;

      return _react2.default.createElement(
        'div',
        { className: 'l-app-content' },
        _react2.default.createElement(
          'div',
          { className: 'newsfeed-container' },
          _react2.default.createElement(
            'div',
            { className: 'left-nav-mobile-breakpoint' },
            _react2.default.createElement(_container2.default, { changeNewsfeedFilter: this.props.changeNewsfeedFilter, isAdmin: isAdmin }),
            ownerMetaData.gotMetaDataCount && isAdmin && _react2.default.createElement(
              _materialUi.Paper,
              { style: { padding: '3%', marginBottom: '24px' } },
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'div',
                null,
                'This data is for TC Admins only'
              ),
              _react2.default.createElement('br', null),
              ['postsCount', 'followsCount', 'followersCount'].map(function (key) {
                return _react2.default.createElement(
                  'div',
                  {
                    key: key,
                    style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px', cursor: 'pointer' },
                    onClick: function onClick() {
                      return _this2.context.router.push('/newsfeed/meta/' + _ramda2.default.replace('Count', '', key));
                    }
                  },
                  _react2.default.createElement(
                    'a',
                    null,
                    _ramda2.default.replace('Count', '', key).toUpperCase()
                  ),
                  _react2.default.createElement(
                    'a',
                    null,
                    ownerMetaData[key]
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-feed' },
            _react2.default.createElement(_container4.default, { loadMore: this.props.loadMore, changeNewsfeedFilter: this.props.changeNewsfeedFilter })
          ),
          _react2.default.createElement(
            'div',
            { className: 'right-side-mobile-breakpoint' },
            _react2.default.createElement(_improveFeedContainer2.default, ownerMetaData)
          )
        )
      );
    }
  }]);

  return NewsFeed;
}(_react.Component);

NewsFeed.propTypes = propTypes;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    initialNewsfeedLoad: function initialNewsfeedLoad() {
      return dispatch(_actions.initialNewsfeedLoad.apply(undefined, arguments));
    },
    loadMore: function loadMore() {
      return dispatch(_actions.loadMore.apply(undefined, arguments));
    },
    changeNewsfeedFilter: function changeNewsfeedFilter() {
      return dispatch(_actions.changeNewsfeedFilter.apply(undefined, arguments));
    },
    getHashtags: function getHashtags() {
      return dispatch(_actions.getHashtags.apply(undefined, arguments));
    },
    getMetadata: function getMetadata() {
      return dispatch(_metaDataActions.getMetadata.apply(undefined, arguments));
    },
    updateProps: function updateProps() {
      return dispatch(_actions.updateProps.apply(undefined, arguments));
    }
  };
};

var mapStateToProps = function mapStateToProps(_ref) {
  var newsfeed = _ref.newsfeed,
      user = _ref.user,
      newsfeedMetaData = _ref.newsfeedMetaData;
  return {
    newsfeed: newsfeed.get('newsfeed').toJS(),
    ownerMetaData: newsfeedMetaData.toJS(),
    isAdmin: user.get('isAnAdmin')
  };
};

NewsFeed.contextTypes = {
  router: _react.PropTypes.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NewsFeed);

/***/ }),
/* 3557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(226);

var _profileImage = __webpack_require__(548);

var _profileImage2 = _interopRequireDefault(_profileImage);

var _materialUi = __webpack_require__(3);

var _viewDay = __webpack_require__(2008);

var _viewDay2 = _interopRequireDefault(_viewDay);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var logoGlobeSrc = __webpack_require__(231);


var propTypes = {
  selectedLeftNav: _react.PropTypes.string,
  updateProp: _react.PropTypes.func,
  newsfeedReducer: _react.PropTypes.object,
  profileImageUrl: _react.PropTypes.string,
  companyName: _react.PropTypes.string,
  email: _react.PropTypes.string,
  firstName: _react.PropTypes.string,
  lastName: _react.PropTypes.string,
  changeNewsfeedFilter: _react.PropTypes.func,
  isAdmin: _react.PropTypes.bool
};

var LeftNav = function (_Component) {
  _inherits(LeftNav, _Component);

  function LeftNav() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LeftNav);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LeftNav.__proto__ || Object.getPrototypeOf(LeftNav)).call.apply(_ref, [this].concat(args))), _this), _this.changeLeftNav = function (selectedValue, filter, filterType) {
      var _this$props = _this.props,
          selectedLeftNav = _this$props.selectedLeftNav,
          changeNewsfeedFilter = _this$props.changeNewsfeedFilter,
          updateProp = _this$props.updateProp;

      if (selectedLeftNav !== selectedValue) {
        updateProp({ selectedLeftNav: selectedValue });
        changeNewsfeedFilter(filter, filterType);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LeftNav, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          newsfeedReducer = _props.newsfeedReducer,
          profileImageUrl = _props.profileImageUrl,
          companyName = _props.companyName,
          email = _props.email,
          firstName = _props.firstName,
          lastName = _props.lastName,
          isAdmin = _props.isAdmin;


      var isSelected = function isSelected(text) {
        return _ramda2.default.propEq('selectedLeftNav', text, newsfeedReducer);
      };

      var textStyle = function textStyle(text) {
        return {
          fontWeight: isSelected(text) ? '600' : '',
          fontSize: '15px',
          margin: '1px 0 0 8px',
          fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
          color: 'rgba(0, 0, 0, 0.54)',
          cursor: 'pointer'
        };
      };

      var userName = function userName() {
        return _react2.default.createElement(
          'div',
          { style: { display: 'inline-block', width: '100%', height: '50px', cursor: 'pointer', marginBottom: '25px' }, onTouchTap: function onTouchTap() {
              return _this2.context.router.push('/profile');
            } },
          _react2.default.createElement(
            'span',
            { style: { float: 'left' } },
            _react2.default.createElement(_profileImage2.default, {
              className: 'profile-link-image',
              companySlugName: companyName || email,
              imageUrl: profileImageUrl
            })
          ),
          _react2.default.createElement(
            'span',
            { style: { float: 'left', margin: '10px', fontSize: '16px' } },
            firstName || lastName ? firstName + ' ' + lastName : email
          )
        );
      };

      var newFeedLink = function newFeedLink() {
        return _react2.default.createElement(
          'div',
          { onTouchTap: function onTouchTap() {
              return _this2.changeLeftNav('News Feed', null, null);
            }, style: { backgroundColor: isSelected('News Feed') ? '#e7e8ea' : '' }, className: 'nav-add-hover' },
          _react2.default.createElement(_viewDay2.default, { color: 'gray' }),
          _react2.default.createElement(
            'span',
            { style: textStyle('News Feed') },
            'Home'
          )
        );
      };

      var categories = [{ text: 'Network Updates', icon: logoGlobeSrc, value: 'tourconnect' }, { text: 'New Location', icon: 'tc-icon-location_on', iconColor: 'gray', value: 'new_location' }, { text: 'New Product', icon: 'tc-icon-card_travel', iconColor: '#e397e3', value: 'new_product' }, { text: 'New Membership', icon: 'tc-icon-verified_user', iconColor: '#97E397', value: 'new_membership' }];

      var listCategories = function listCategories() {
        return (isAdmin ? categories.concat([{ text: 'Admin', icon: 'tc-icon-portrait', iconColor: 'rgb(255, 64, 129)', value: 'general' }]) : categories).map(function (item, i) {
          var divStyle = { margin: '7px 0px', backgroundColor: isSelected(item.text) ? '#e7e8ea' : '' };
          if (item.text === 'Network Updates') {
            return _react2.default.createElement(
              'div',
              {
                onTouchTap: function onTouchTap() {
                  return _this2.changeLeftNav(item.text, item, 'category');
                },
                key: i,
                style: divStyle,
                className: 'nav-add-hover'
              },
              _react2.default.createElement('img', { src: logoGlobeSrc, width: '21', style: { display: 'inline-flex', verticalAlign: 'top' } }),
              _react2.default.createElement(
                'span',
                { style: textStyle(item.text) },
                item.text
              )
            );
          }
          return _react2.default.createElement(
            'div',
            { onTouchTap: function onTouchTap() {
                return _this2.changeLeftNav(item.text, item, 'category');
              }, key: i, style: divStyle, className: 'nav-add-hover' },
            _react2.default.createElement(_materialUi.FontIcon, { color: item.iconColor, className: item.icon, style: { fontSize: '20px' } }),
            _react2.default.createElement(
              'span',
              { style: textStyle(item.text) },
              item.text
            )
          );
        });
      };

      return _react2.default.createElement(
        'div',
        { style: { padding: '0 10px' } },
        newFeedLink(),
        _react2.default.createElement(
          'div',
          { style: { width: '100%', marginTop: '15px' } },
          _react2.default.createElement(
            'div',
            { style: { fontWeight: 600 } },
            'Featured Categories'
          ),
          listCategories()
        )
      );
    }
  }]);

  return LeftNav;
}(_react.Component);

LeftNav.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref2) {
  var user = _ref2.user,
      newsfeed = _ref2.newsfeed;
  return {
    profileImageUrl: user.getIn(['company', 'profileImageUrl']),
    companyName: user.getIn(['company', 'companyName']),
    email: user.getIn(['user', 'email']),
    firstName: user.getIn(['user', 'firstName']),
    lastName: user.getIn(['user', 'lastName']),
    newsfeedReducer: newsfeed.toJS()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateProps.apply(undefined, arguments));
    }
  };
};

LeftNav.contextTypes = {
  router: _react.PropTypes.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LeftNav);

/***/ }),
/* 3558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _container = __webpack_require__(3559);

var _container2 = _interopRequireDefault(_container);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _singlePostContainer = __webpack_require__(1154);

var _singlePostContainer2 = _interopRequireDefault(_singlePostContainer);

var _reactInfiniteScrollComponent = __webpack_require__(3568);

var _reactInfiniteScrollComponent2 = _interopRequireDefault(_reactInfiniteScrollComponent);

var _loadingBox = __webpack_require__(1274);

var _loadingBox2 = _interopRequireDefault(_loadingBox);

var _filterHeader = __webpack_require__(3569);

var _filterHeader2 = _interopRequireDefault(_filterHeader);

var _aphrodite = __webpack_require__(123);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  selectedLeftNav: _react.PropTypes.string,
  newsfeed: _react.PropTypes.array,
  loadMore: _react.PropTypes.func,
  changeNewsfeedFilter: _react.PropTypes.func,
  hasMore: _react.PropTypes.bool,
  filter: _react.PropTypes.object,
  filterType: _react.PropTypes.string
};

var Feed = function (_Component) {
  _inherits(Feed, _Component);

  function Feed() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Feed);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Feed.__proto__ || Object.getPrototypeOf(Feed)).call.apply(_ref, [this].concat(args))), _this), _this.filterByHashTag = function (tag) {
      return _this.props.changeNewsfeedFilter({ value: _ramda2.default.replace('#', '', tag), text: tag }, 'hashtag');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Feed, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          newsfeed = _props.newsfeed,
          hasMore = _props.hasMore,
          loadMore = _props.loadMore,
          filter = _props.filter,
          filterType = _props.filterType;


      var loaderComponent = [1, 2, 3].map(function (_, i) {
        return _react2.default.createElement(_loadingBox2.default, { key: i });
      });
      var firstPostNotLoaded = false || !_ramda2.default.isEmpty(newsfeed) && newsfeed.slice(0, 1).some(function (obj) {
        return !_ramda2.default.prop('loaded', obj);
      });

      var styles = _aphrodite.StyleSheet.create({
        newsfeedContainer: {
          position: 'relative',
          '@media (min-width: 1000px)': {
            ':before': {
              background: '#E0E0E0',
              content: "''",
              display: 'block',
              height: '100%',
              left: '30px',
              position: 'absolute',
              top: '10px',
              width: '2px',
              zIndex: 0
            }
          }
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'Grid' },
        filterType && filter && filter.value ? _react2.default.createElement(_filterHeader2.default, {
          filterType: filterType,
          iconClassName: _ramda2.default.prop('icon', filter),
          iconColor: _ramda2.default.prop('iconColor', filter),
          text: filter.text
        }) : _react2.default.createElement(_container2.default, null),
        _react2.default.createElement(
          'div',
          { style: { width: '100%' }, className: (0, _aphrodite.css)(styles.newsfeedContainer) },
          newsfeed.loadingNF && loaderComponent,
          _react2.default.createElement(
            _reactInfiniteScrollComponent2.default,
            {
              next: loadMore,
              hasMore: hasMore,
              scrollThreshold: 0.6,
              loader: loaderComponent,
              endMessage: _react2.default.createElement(
                'p',
                { style: { textAlign: 'center' } },
                _react2.default.createElement(
                  'b',
                  null,
                  'Yay! You have seen it all!'
                )
              )
            },
            newsfeed.map(function (post, i) {
              return _react2.default.createElement(_singlePostContainer2.default, _extends({ key: i }, post, { filterByHashTag: _this2.filterByHashTag }));
            })
          )
        )
      );
    }
  }]);

  return Feed;
}(_react.Component);

Feed.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref2) {
  var newsfeed = _ref2.newsfeed;
  return {
    selectedLeftNav: newsfeed.toJS().selectedLeftNav,
    newsfeed: newsfeed.toJS().newsfeed,
    hasMore: newsfeed.toJS().hasMore,
    filterType: newsfeed.toJS().filterType,
    filter: newsfeed.toJS().filter
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Feed);

/***/ }),
/* 3559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _profileImage = __webpack_require__(548);

var _profileImage2 = _interopRequireDefault(_profileImage);

var _actions = __webpack_require__(226);

var _materialUi = __webpack_require__(3);

var _flatButtonWithLoader = __webpack_require__(88);

var _flatButtonWithLoader2 = _interopRequireDefault(_flatButtonWithLoader);

var _insertPhoto = __webpack_require__(1454);

var _insertPhoto2 = _interopRequireDefault(_insertPhoto);

var _category = __webpack_require__(3560);

var _category2 = _interopRequireDefault(_category);

var _locations = __webpack_require__(3563);

var _locations2 = _interopRequireDefault(_locations);

var _message = __webpack_require__(3565);

var _message2 = _interopRequireDefault(_message);

var _uploadFiles = __webpack_require__(3567);

var _uploadFiles2 = _interopRequireDefault(_uploadFiles);

var _uploadFromMM = __webpack_require__(1855);

var _uploadFromMM2 = _interopRequireDefault(_uploadFromMM);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var propTypes = {
  profileImageUrl: _react.PropTypes.string,
  companyName: _react.PropTypes.string,
  email: _react.PropTypes.string,
  updateProp: _react.PropTypes.func,
  newsfeedReducer: _react.PropTypes.object,
  savePost: _react.PropTypes.func,
  locations: _react.PropTypes.array,
  MMFiles: _react.PropTypes.array
};

var NewPost = function (_Component) {
  _inherits(NewPost, _Component);

  function NewPost(props) {
    _classCallCheck(this, NewPost);

    var _this = _possibleConstructorReturn(this, (NewPost.__proto__ || Object.getPrototypeOf(NewPost)).call(this, props));

    _this.clearStore = function () {
      var initialState = {
        subCategoryExpanded: false,
        locExpanded: false,
        category: 'Updates',
        addFilesExpanded: false,
        messageExpanded: true,
        errors: []
      };
      var initialReducer = {
        showNewPostDialog: false,
        postMessage: '',
        selectedFiles: [],
        selectedMainCategory: 'Updates',
        selectedSubCategory: '',
        selectedHashtags: []
      };
      if (!_ramda2.default.propEq('length', 1, _this.props.locations)) {
        initialReducer.corporateLocSelected = false;
        initialReducer.selectedLocations = [];
      }
      _this.setState(initialState);
      _this.props.updateProp(initialReducer);
    };

    _this.toggleUploadFiles = function () {
      _this.setState({ addFilesExpanded: !_this.state.addFilesExpanded, locExpanded: false, subCategoryExpanded: false, messageExpanded: false, uploadFromMMExpanded: false });
      setTimeout(function () {
        return window.dispatchEvent(new Event('resize'));
      }, 0);
    };

    _this.displayErrorMsg = function () {
      var locations = _this.props.locations;
      var _this$props$newsfeedR = _this.props.newsfeedReducer,
          selectedLocations = _this$props$newsfeedR.selectedLocations,
          postMessage = _this$props$newsfeedR.postMessage,
          selectedSubCategory = _this$props$newsfeedR.selectedSubCategory,
          uploadingFile = _this$props$newsfeedR.uploadingFile;

      var errors = [];
      if (isNilOrEmpty(selectedSubCategory)) errors.push('Please select a category.');
      if (isNilOrEmpty(selectedLocations) && _ramda2.default.propOr(0, 'length', locations) > 1) errors.push('Please select which locations this post applies to.');
      if (!postMessage) errors.push('Please enter a message.');
      if (uploadingFile) errors.push('Please wait for all files to finish uploading.');
      _this.setState({ errors: errors });
    };

    _this.state = {
      subCategoryExpanded: false,
      locExpanded: false,
      category: 'general',
      addFilesExpanded: false,
      errors: [],
      messageExpanded: true,
      uploadFromMMExpanded: false
    };
    return _this;
  }

  _createClass(NewPost, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          locations = _props.locations,
          updateProp = _props.updateProp;

      if (_ramda2.default.propEq('length', 1, locations)) {
        updateProp({
          selectedLocations: [{ locationId: _ramda2.default.pathOr('', [0, '_id'], locations), name: _ramda2.default.pathOr('', [0, 'property_name'], locations) }],
          corporateLocSelected: true
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearStore();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          companyName = _props2.companyName,
          email = _props2.email,
          locations = _props2.locations,
          MMFiles = _props2.MMFiles,
          newsfeedReducer = _props2.newsfeedReducer,
          profileImageUrl = _props2.profileImageUrl,
          savePost = _props2.savePost,
          updateProp = _props2.updateProp;
      var selectedLocations = newsfeedReducer.selectedLocations,
          postMessage = newsfeedReducer.postMessage,
          selectedSubCategory = newsfeedReducer.selectedSubCategory,
          uploadingFile = newsfeedReducer.uploadingFile;

      var postContentComplete = !isNilOrEmpty(selectedLocations) && postMessage && !isNilOrEmpty(selectedSubCategory) && !uploadingFile;
      var selectedFilesNotFromMM = newsfeedReducer.selectedFiles.filter(function (file) {
        return !_ramda2.default.contains('tags', _ramda2.default.keys(file));
      });

      return _react2.default.createElement(
        _materialUi.Card,
        { style: { width: '89%', margin: '0 0 2% 11%' } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { float: 'left', width: '50px', padding: '1% 2%' } },
            _react2.default.createElement(_profileImage2.default, {
              className: 'profile-link-image',
              companySlugName: companyName || email,
              imageUrl: profileImageUrl,
              style: { border: '0.5px solid #D3D3D3' }
            })
          ),
          _react2.default.createElement(
            'div',
            { style: {
                float: 'left',
                color: 'rgba(0, 0, 0, 0.54)',
                fontSize: '16px',
                padding: '16px 2%',
                width: 'calc(100% - 50px)',
                overflowY: 'hidden',
                overflowX: 'hidden',
                fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" }
            },
            'Post a new message or announcement'
          )
        ),
        isNilOrEmpty(locations) ? _react2.default.createElement(
          'div',
          { style: { padding: '64px', textAlign: 'center' } },
          'In order to create a post, please ',
          _react2.default.createElement(
            'a',
            { style: { cursor: 'pointer' }, onClick: function onClick() {
                // Ghetto solution, in case user finished profile, but the locations aren't updated to userReducer.
                // TODO: will fix when we redo profile
                window.location = '/profile';
              }
            },
            'complete your profile'
          ),
          '.'
        ) : _react2.default.createElement(
          'div',
          null,
          !isNilOrEmpty(this.state.errors) && _react2.default.createElement(
            'div',
            { style: { color: 'red', padding: '8px' } },
            this.state.errors.map(function (error, i) {
              return _react2.default.createElement(
                'span',
                { key: i },
                error,
                _react2.default.createElement('br', null)
              );
            })
          ),
          _react2.default.createElement(_category2.default, {
            onCardExpand: function onCardExpand() {
              return _this2.setState({ subCategoryExpanded: !_this2.state.subCategoryExpanded, locExpanded: false, addFilesExpanded: false, uploadFromMMExpanded: false });
            },
            expanded: this.state.subCategoryExpanded,
            mainCategorySelect: function mainCategorySelect(value) {
              updateProp({ selectedMainCategory: value });
              _this2.setState({ subCategoryExpanded: true });
            },
            subCategorySelect: function subCategorySelect(value, hashtag) {
              return updateProp({ selectedSubCategory: value, subCategoryHash: hashtag });
            }
          }),
          _ramda2.default.propOr(0, 'length', locations) > 1 && _react2.default.createElement(_locations2.default, {
            expanded: this.state.locExpanded,
            onCardExpand: function onCardExpand() {
              return _this2.setState({ locExpanded: !_this2.state.locExpanded, addFilesExpanded: false, subCategoryExpanded: false, uploadFromMMExpanded: false });
            }
          }),
          !isNilOrEmpty(MMFiles) && _react2.default.createElement(_uploadFromMM2.default, {
            onCardExpand: function onCardExpand(newExpandedState) {
              return _this2.setState({ locExpanded: false, addFilesExpanded: false, subCategoryExpanded: false, uploadFromMMExpanded: newExpandedState });
            },
            onChangeSelection: function onChangeSelection(selectedFiles) {
              return updateProp({ selectedFiles: selectedFiles });
            },
            savingPost: newsfeedReducer.savingPost
          }),
          _react2.default.createElement(_message2.default, {
            closeExpandedArea: function closeExpandedArea() {
              return _this2.setState({ locExpanded: false, addFilesExpanded: false, subCategoryExpanded: false, uploadFromMMExpanded: false });
            },
            expanded: this.state.messageExpanded,
            onCardExpand: function onCardExpand() {
              return _this2.setState({ messageExpanded: true, locExpanded: false, addFilesExpanded: false, subCategoryExpanded: false, uploadFromMMExpanded: false });
            }
          }),
          this.state.addFilesExpanded ? _react2.default.createElement(_uploadFiles2.default, {
            expanded: this.state.addFilesExpanded,
            onCardExpand: this.toggleUploadFiles,
            selectedFilesNotFromMM: selectedFilesNotFromMM
          }) : _react2.default.createElement('span', null)
        ),
        _react2.default.createElement(
          _materialUi.CardActions,
          null,
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-block', width: '100%' } },
            !isNilOrEmpty(locations) && !this.state.addFilesExpanded && _react2.default.createElement(_flatButtonWithLoader2.default, {
              onTouchTap: this.toggleUploadFiles,
              label: _ramda2.default.isEmpty(newsfeedReducer.selectedFiles) || selectedFilesNotFromMM.length === 0 ? 'Upload Files' : 'Upload Files (' + _ramda2.default.prop('length', selectedFilesNotFromMM) + ' Uploaded)',
              secondary: true,
              icon: _react2.default.createElement(_insertPhoto2.default, { color: 'rgb(0, 188, 212)' }),
              disabled: newsfeedReducer.savingPost,
              style: { float: 'left', display: 'inline-block' }
            }),
            _react2.default.createElement(
              'div',
              { style: { float: 'right', display: 'inline-block' } },
              _react2.default.createElement(_flatButtonWithLoader2.default, {
                label: 'Cancel',
                primary: true,
                onTouchTap: this.clearStore,
                disabled: newsfeedReducer.savingPost
              }),
              !isNilOrEmpty(locations) && _react2.default.createElement(_flatButtonWithLoader2.default, {
                label: 'Post',
                loader: newsfeedReducer.savingPost,
                secondary: true,
                onTouchTap: function onTouchTap() {
                  if (postContentComplete) {
                    savePost();
                    _this2.clearStore();
                  } else {
                    _this2.displayErrorMsg();
                  }
                }
              })
            )
          )
        )
      );
    }
  }]);

  return NewPost;
}(_react.Component);

NewPost.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user,
      newsfeed = _ref.newsfeed,
      profile = _ref.profile;
  return {
    profileImageUrl: user.getIn(['company', 'profileImageUrl']),
    companyName: user.getIn(['company', 'companyName']),
    email: user.getIn(['user', 'email']),
    locations: user.get('mrLocations'),
    newsfeedReducer: newsfeed.toJS(),
    MMFiles: profile.get('media') ? profile.get('media').toJS() : []
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateProps.apply(undefined, arguments));
    },
    savePost: function savePost() {
      return dispatch(_actions.submitPost.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NewPost);

/***/ }),
/* 3560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _localOffer = __webpack_require__(3561);

var _localOffer2 = _interopRequireDefault(_localOffer);

var _categoryOptions = __webpack_require__(3562);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var Category = function Category(props) {
  var onCardExpand = props.onCardExpand,
      expanded = props.expanded,
      mainCategorySelect = props.mainCategorySelect,
      subCategorySelect = props.subCategorySelect,
      selectedSubCategory = props.selectedSubCategory,
      savingPost = props.savingPost,
      selectedMainCategory = props.selectedMainCategory;


  var getHashtag = function getHashtag(mainCategoryVal) {
    return _ramda2.default.call(_ramda2.default.compose(_ramda2.default.prop(0), _ramda2.default.pluck('hashtag'), _ramda2.default.filter(function (obj) {
      return obj.val === mainCategoryVal;
    }), _ramda2.default.chain(function (obj) {
      return obj.subCategories;
    })), _categoryOptions.mainCategories);
  };

  var subCategorySelection = _ramda2.default.call(_ramda2.default.cond([[_ramda2.default.equals('Industry Insights'), _ramda2.default.always(_ramda2.default.path([1, 'subCategories'], _categoryOptions.mainCategories))], [_ramda2.default.equals('Training & Famils'), _ramda2.default.always(_ramda2.default.path([2, 'subCategories'], _categoryOptions.mainCategories))], [_ramda2.default.equals('Destination Updates'), _ramda2.default.always(_ramda2.default.path([3, 'subCategories'], _categoryOptions.mainCategories))], [_ramda2.default.T, _ramda2.default.always(_ramda2.default.path([0, 'subCategories'], _categoryOptions.mainCategories))]]), selectedMainCategory);

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _materialUi.Tabs,
      {
        tabItemContainerStyle: { backgroundColor: 'white', borderBottom: '1px solid #e0e0e0', justifyContent: 'space-between', padding: '0 10px' },
        onChange: mainCategorySelect,
        inkBarStyle: { display: 'none' }
      },
      _categoryOptions.mainCategories.map(function (obj, i) {
        return _react2.default.createElement(_materialUi.Tab, {
          key: i,
          label: obj.mainCategory,
          value: obj.mainCategory,
          style: _extends({}, { color: 'rgba(0, 0, 0, 0.54)', fontSize: '12px', width: 'auto' }, obj.mainCategory === selectedMainCategory ? { fontWeight: 600 } : {})
        });
      })
    ),
    _react2.default.createElement(
      _materialUi.Card,
      {
        expanded: expanded,
        onExpandChange: onCardExpand,
        style: { boxShadow: 'none', borderBottom: '1px solid #e0e0e0', marginBottom: '4px' }
      },
      _react2.default.createElement(
        _materialUi.CardHeader,
        { actAsExpander: true, showExpandableButton: true, textStyle: { display: 'none' } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _materialUi.FontIcon,
            null,
            _react2.default.createElement(_localOffer2.default, { color: 'rgba(0, 0, 0, 0.54)', style: { verticalAlign: 'bottom' } }),
            _react2.default.createElement(
              'span',
              { style: { fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)', marginLeft: '15px' } },
              'Choose Category',
              !isNilOrEmpty(selectedSubCategory) && !expanded && _react2.default.createElement(
                'span',
                null,
                ' - ',
                _react2.default.createElement(
                  'span',
                  { style: { color: '#00bcd4' } },
                  _ramda2.default.call(_ramda2.default.compose(_ramda2.default.view(_ramda2.default.lensProp('text')), _ramda2.default.prop(0), _ramda2.default.filter(function (item) {
                    return item.val === selectedSubCategory;
                  }), _ramda2.default.flatten, _ramda2.default.pluck('subCategories')), _categoryOptions.mainCategories),
                  ' selected'
                )
              )
            )
          )
        )
      ),
      _react2.default.createElement(
        _materialUi.CardText,
        { expandable: true, style: { padding: 0 } },
        _react2.default.createElement(
          'div',
          { style: { paddingLeft: '55px' } },
          _react2.default.createElement(
            _materialUi.RadioButtonGroup,
            { name: 'subCategory', onChange: function onChange(_, value) {
                return subCategorySelect(value, getHashtag(value));
              }, valueSelected: selectedSubCategory },
            subCategorySelection.map(function (subCategory, i) {
              return _react2.default.createElement(_materialUi.RadioButton, {
                key: i,
                label: subCategory.text,
                value: subCategory.val,
                disabled: savingPost
              });
            })
          )
        )
      )
    )
  );
};

Category.propTypes = {
  onCardExpand: _react.PropTypes.func,
  expanded: _react.PropTypes.bool,
  mainCategorySelect: _react.PropTypes.func,
  subCategorySelect: _react.PropTypes.func,
  selectedSubCategory: _react.PropTypes.string,
  savingPost: _react.PropTypes.bool,
  selectedMainCategory: _react.PropTypes.string
};

var mapStateToProps = function mapStateToProps(_ref) {
  var newsfeed = _ref.newsfeed;
  return {
    selectedSubCategory: newsfeed.get('selectedSubCategory'),
    savingPost: newsfeed.get('savingPost'),
    selectedMainCategory: newsfeed.get('selectedMainCategory')
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Category);

/***/ }),
/* 3561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalOffer = function MapsLocalOffer(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z' })
  );
};
MapsLocalOffer = (0, _pure2.default)(MapsLocalOffer);
MapsLocalOffer.displayName = 'MapsLocalOffer';
MapsLocalOffer.muiName = 'SvgIcon';

exports.default = MapsLocalOffer;

/***/ }),
/* 3562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSubcategoriesFromMain = exports.mainCategories = undefined;

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mainCategories = exports.mainCategories = [{
  mainCategory: 'Updates',
  subCategories: [{ text: 'General Update', val: 'general', hashtag: '#update' }, { text: 'Special Offers', val: 'special_offers', hashtag: '#specialoffer' }, { text: 'New Products', val: 'new_product', hashtag: '#newproduct' }, { text: 'New Locations', val: 'new_location', hashtag: '#newlocation' }, { text: 'New Packages', val: 'new_package', hashtag: '#newpackage' }, { text: 'Property Renovations', val: 'property_renovations', hashtag: '#renovations' }, { text: 'New Blackout Dates', val: 'blackout_dates', hashtag: '#blackouts' }, { text: 'Team Update', val: 'team_update', hashtag: '#teamupdate' }, { text: 'Marketing Coop Opportunity', val: 'marketing_coop_opportunity', hashtag: '#mktgcoop' }]
}, {
  mainCategory: 'Industry Insights',
  subCategories: [{ text: 'Industry Knowledge & Questions', val: 'industry_knowledge', hashtag: '#help' }, { text: 'Recommendations', val: 'recommendations', hashtag: '#recommendations' }, { text: 'Industry Events', val: 'events', hashtag: '#events' }, { text: 'Job Postings', val: 'jobs', hashtag: '#jobs' }, { text: 'Industry Lobbying', val: 'lobbying', hashtag: '#lobbying' }, { text: 'Surveys', val: 'survey', hashtag: '#survey' }]
}, {
  mainCategory: 'Training & Famils',
  subCategories: [{ text: 'Buyer/Agent Training Materials', val: 'buyer_agent_training_materials', hashtag: '#training' }, { text: 'Webinar Announcements', val: 'webinar_announcements', hashtag: '#webinar' }, { text: 'Famil Trips', val: 'famil_trips', hashtag: '#famtrip' }, { text: 'In-Market Sales Trips', val: 'inmarket_sales_trips', hashtag: '#salestrip' }]
}, {
  mainCategory: 'Destination Updates',
  subCategories: [{ text: 'Visitation Statistics', val: 'visitation_statistics', hashtag: '#stats' }, { text: 'Destination Itineraries', val: 'destination_itineraries', hashtag: '#itineraries' }, { text: 'Destination Specialist Updates', val: 'destination_specialist_updates', hashtag: '#specialists' }, { text: 'Disaster Recovery Update', val: 'disaster_recovery_update', hashtag: '#openforbiz' }]
}];

// returns array of vals for main category
var getSubcategoriesFromMain = exports.getSubcategoriesFromMain = function getSubcategoriesFromMain(mainCategory) {
  return _ramda2.default.call(_ramda2.default.compose(_ramda2.default.pluck('val'), _ramda2.default.prop(0), _ramda2.default.pluck('subCategories'), _ramda2.default.filter(function (obj) {
    return obj.mainCategory === mainCategory;
  })), mainCategories);
};

/***/ }),
/* 3563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(226);

var _materialUi = __webpack_require__(3);

var _place = __webpack_require__(3564);

var _place2 = _interopRequireDefault(_place);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Locations = function Locations(props) {
  var updateProp = props.updateProp,
      expanded = props.expanded,
      onCardExpand = props.onCardExpand,
      locations = props.locations,
      savingPost = props.savingPost,
      corporateLocSelected = props.corporateLocSelected,
      selectedLocations = props.selectedLocations;


  return _react2.default.createElement(
    _materialUi.Card,
    {
      expanded: expanded,
      onExpandChange: onCardExpand,
      style: { boxShadow: 'none', borderBottom: '1px solid #e0e0e0', marginBottom: '4px' }
    },
    _react2.default.createElement(
      _materialUi.CardHeader,
      { actAsExpander: true, showExpandableButton: true, textStyle: { display: 'none' } },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _materialUi.FontIcon,
          null,
          _react2.default.createElement(_place2.default, { color: 'rgba(0, 0, 0, 0.54)', style: { verticalAlign: 'bottom' } }),
          _react2.default.createElement(
            'span',
            { style: { fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)', marginLeft: '15px' } },
            'Choose Location(s)',
            selectedLocations.length > 0 && !expanded && _react2.default.createElement(
              'span',
              null,
              ' - ',
              _react2.default.createElement(
                'span',
                { style: { color: '#00bcd4' } },
                _ramda2.default.propOr(0, 'length', selectedLocations),
                ' of ',
                _ramda2.default.propOr(0, 'length', locations),
                ' selected'
              )
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _materialUi.CardText,
      { expandable: true, style: { padding: 0 } },
      _react2.default.createElement(
        'div',
        { style: { paddingLeft: '55px' } },
        _react2.default.createElement(_materialUi.Checkbox, {
          label: _react2.default.createElement(
            'div',
            { style: { fontSize: '16px' } },
            'CORPORATE'
          ),
          checked: corporateLocSelected,
          onCheck: function onCheck() {
            return updateProp({
              corporateLocSelected: !corporateLocSelected,
              selectedLocations: _ramda2.default.equals(true, corporateLocSelected) ? [] : locations.map(function (loc) {
                return { locationId: loc._id, name: loc.property_name };
              })
            });
          },
          disabled: savingPost
        }),
        locations.map(function (loc, i) {
          var checked = _ramda2.default.contains(loc.property_name, _ramda2.default.pluck('name')(selectedLocations));
          return _react2.default.createElement(_materialUi.Checkbox, {
            key: i,
            label: loc.property_name,
            disabled: corporateLocSelected || savingPost,
            checked: checked,
            onCheck: _ramda2.default.ifElse(function () {
              return checked;
            }, function () {
              return updateProp({ selectedLocations: _ramda2.default.without([{ locationId: loc._id, name: loc.property_name }], selectedLocations) });
            }, function () {
              return updateProp({
                selectedLocations: selectedLocations.concat([{ locationId: loc._id, name: loc.property_name }]),
                corporateLocSelected: locations.length === selectedLocations.length + 1
              });
            })
          });
        })
      )
    )
  );
};

Locations.propTypes = {
  updateProp: _react.PropTypes.func,
  expanded: _react.PropTypes.bool,
  onCardExpand: _react.PropTypes.func,
  locations: _react.PropTypes.array,
  savingPost: _react.PropTypes.bool,
  selectedLocations: _react.PropTypes.array,
  corporateLocSelected: _react.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(_ref) {
  var newsfeed = _ref.newsfeed,
      user = _ref.user;
  return {
    locations: user.get('mrLocations'),
    savingPost: newsfeed.get('savingPost'),
    selectedLocations: newsfeed.get('selectedLocations').toJS(),
    corporateLocSelected: newsfeed.get('corporateLocSelected')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateProps.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Locations);

/***/ }),
/* 3564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsPlace = function MapsPlace(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
  );
};
MapsPlace = (0, _pure2.default)(MapsPlace);
MapsPlace.displayName = 'MapsPlace';
MapsPlace.muiName = 'SvgIcon';

exports.default = MapsPlace;

/***/ }),
/* 3565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(226);

var _materialUi = __webpack_require__(3);

var _message = __webpack_require__(3566);

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import { MentionsInput, Mention } from 'react-mentions';
// import MentionsInputStyle from './MentionsInputStyle';
// import { getHashTagsFromString } from '../../helperFuncs';


var Message = function (_Component) {
  _inherits(Message, _Component);

  function Message(props) {
    _classCallCheck(this, Message);

    var _this = _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).call(this, props));

    _this.state = {
      isFocused: false,
      postMessage: ''
    };
    return _this;
  }

  _createClass(Message, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          updateProp = _props.updateProp,
          closeExpandedArea = _props.closeExpandedArea,
          savingPost = _props.savingPost,
          hashtags = _props.hashtags,
          postMessage = _props.postMessage,
          expanded = _props.expanded,
          onCardExpand = _props.onCardExpand;

      // const formatHashtags = hashtags.map(item => ({ id: item._id, display: item.hashtag }));

      return expanded ? _react2.default.createElement(
        'div',
        { style: { padding: '10px 12px', height: '150px', overflow: 'hidden' }, onClick: function onClick() {
            return closeExpandedArea();
          } },
        _react2.default.createElement(_materialUi.TextField, {
          id: 'postMessage',
          underlineShow: false,
          multiLine: true,
          rowsMax: 5,
          hintText: 'Type your message here',
          hintStyle: { position: 'absolute', height: '95%', width: '97%' },
          style: { width: '100%' },
          value: postMessage,
          onChange: function onChange(_ref) {
            var value = _ref.target.value;
            return updateProp({ postMessage: value });
          },
          textareaStyle: { minHeight: '140px', height: '100%', marginTop: '-5px' },
          disabled: savingPost
        })
      ) : _react2.default.createElement(
        _materialUi.Card,
        {
          expanded: expanded,
          onExpandChange: onCardExpand,
          style: { boxShadow: 'none', marginBottom: '4px' }
        },
        _react2.default.createElement(
          _materialUi.CardHeader,
          { actAsExpander: true, showExpandableButton: true, textStyle: { display: 'none' } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _materialUi.FontIcon,
              null,
              _react2.default.createElement(_message2.default, { color: 'rgba(0, 0, 0, 0.54)', style: { verticalAlign: 'bottom' } }),
              _react2.default.createElement(
                'span',
                { style: { fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)', marginLeft: '15px' } },
                'Message'
              )
            )
          )
        )
      );
    }
  }]);

  return Message;
}(_react.Component);

Message.propTypes = {
  updateProp: _react.PropTypes.func,
  closeExpandedArea: _react.PropTypes.func,
  savingPost: _react.PropTypes.bool,
  hashtags: _react.PropTypes.array,
  selectedHashtags: _react.PropTypes.array,
  postMessage: _react.PropTypes.string,
  expanded: _react.PropTypes.bool,
  onCardExpand: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var newsfeed = _ref2.newsfeed;
  return {
    savingPost: newsfeed.get('savingPost'),
    hashtags: newsfeed.get('hashtags').toJS(),
    postMessage: newsfeed.get('postMessage')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateProps.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Message);

/***/ }),
/* 3566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationMessage = function CommunicationMessage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
  );
};
CommunicationMessage = (0, _pure2.default)(CommunicationMessage);
CommunicationMessage.displayName = 'CommunicationMessage';
CommunicationMessage.muiName = 'SvgIcon';

exports.default = CommunicationMessage;

/***/ }),
/* 3567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(226);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _dropzone = __webpack_require__(1946);

var _dropzone2 = _interopRequireDefault(_dropzone);

var _container = __webpack_require__(1273);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isEmpty, _ramda2.default.isNil);

var UploadFiles = function UploadFiles(props) {
  var expanded = props.expanded,
      onCardExpand = props.onCardExpand,
      updateProp = props.updateProp,
      selectedFiles = props.selectedFiles,
      savingPost = props.savingPost,
      uploadingFile = props.uploadingFile,
      selectedFilesNotFromMM = props.selectedFilesNotFromMM;


  return _react2.default.createElement(
    _materialUi.Card,
    {
      expanded: expanded,
      onExpandChange: savingPost ? null : onCardExpand,
      style: { boxShadow: 'none', borderTop: '1px solid #e0e0e0' }
    },
    _react2.default.createElement(
      _materialUi.CardText,
      { expandable: true, style: { padding: '0 30px' } },
      _react2.default.createElement(
        'div',
        { style: { marginTop: '10px' } },
        _react2.default.createElement(_dropzone2.default, {
          addFilesMessage: 'Drag and drop files here to upload',
          acceptedFileTypes: '.jpg, .png, .jpeg, .mp4, .pdf',
          arrayOfPhotoTypes: ['image/jpeg', 'image/png'],
          arrayOfAcceptedFileTypes: ['image/jpeg', 'image/png', 'video/mp4', 'application/pdf'],
          addRemoveLinks: false,
          showFiletypeIcon: false,
          allFiles: selectedFiles,
          showThumbnailPreviews: false,
          uploadingFile: function uploadingFile() {
            return updateProp({ uploadingFile: true });
          },
          suggestedMinFileSize: '50',
          finishedFileUploadCB: function finishedFileUploadCB(imageUrl, fileType, fileName, fileSize) {
            selectedFiles.unshift({
              url: imageUrl,
              mediaType: fileType,
              name: fileName,
              size: fileSize,
              created_at: new Date()
            });
            updateProp({
              selectedFiles: selectedFiles,
              uploadingFile: false
            });
          }
        }),
        uploadingFile && _react2.default.createElement(_materialUi.LinearProgress, { mode: 'indeterminate' })
      ),
      !isNilOrEmpty(selectedFilesNotFromMM) && _react2.default.createElement(
        'div',
        { style: { marginTop: '10px', overflowY: 'scroll', height: '150px', display: 'flex' } },
        _react2.default.createElement(_container2.default, {
          showFileName: true,
          files: selectedFilesNotFromMM,
          removeFile: function removeFile(fileUrl) {
            return updateProp({ selectedFiles: selectedFiles.filter(function (object) {
                return object.url !== fileUrl;
              }) });
          }
        })
      )
    )
  );
};

UploadFiles.propTypes = {
  expanded: _react.PropTypes.bool,
  onCardExpand: _react.PropTypes.func,
  updateProp: _react.PropTypes.func,
  selectedFiles: _react.PropTypes.array,
  savingPost: _react.PropTypes.bool,
  uploadingFile: _react.PropTypes.bool,
  selectedFilesNotFromMM: _react.PropTypes.array
};

var mapStateToProps = function mapStateToProps(_ref) {
  var newsfeed = _ref.newsfeed;
  return {
    selectedFiles: newsfeed.get('selectedFiles').toJS(),
    savingPost: newsfeed.get('savingPost'),
    uploadingFile: newsfeed.get('uploadingFile')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateProp: function updateProp() {
      return dispatch(_actions.updateProps.apply(undefined, arguments));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UploadFiles);

/***/ }),
/* 3568 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["InfiniteScroll"] = factory(require("react"));
	else
		root["InfiniteScroll"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_7__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _react = __webpack_require__(7);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = __webpack_require__(5);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _utilsThrottle = __webpack_require__(1);

	var _utilsThrottle2 = _interopRequireDefault(_utilsThrottle);

	var InfiniteScroll = (function (_Component) {
	  _inherits(InfiniteScroll, _Component);

	  function InfiniteScroll(props) {
	    _classCallCheck(this, InfiniteScroll);

	    _get(Object.getPrototypeOf(InfiniteScroll.prototype), 'constructor', this).call(this);
	    this.state = {
	      showLoader: false,
	      lastScrollTop: 0,
	      actionTriggered: false,
	      pullToRefreshThresholdBreached: false
	    };
	    // variables to keep track of pull down behaviour
	    this.startY = 0;
	    this.currentY = 0;
	    this.dragging = false;
	    // will be populated in componentDidMount
	    // based on the height of the pull down element
	    this.maxPullDownDistance = 0;

	    this.onScrollListener = this.onScrollListener.bind(this);
	    this.throttledOnScrollListener = (0, _utilsThrottle2['default'])(this.onScrollListener, 150).bind(this);
	    this.onStart = this.onStart.bind(this);
	    this.onMove = this.onMove.bind(this);
	    this.onEnd = this.onEnd.bind(this);
	  }

	  _createClass(InfiniteScroll, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.el = this.props.height ? this._infScroll : window;
	      this.el.addEventListener('scroll', this.throttledOnScrollListener);

	      if (this.props.pullDownToRefresh) {
	        document.addEventListener('touchstart', this.onStart);
	        document.addEventListener('touchmove', this.onMove);
	        document.addEventListener('touchend', this.onEnd);

	        document.addEventListener('mousedown', this.onStart);
	        document.addEventListener('mousemove', this.onMove);
	        document.addEventListener('mouseup', this.onEnd);

	        // get BCR of pullDown element to position it above
	        this.maxPullDownDistance = this._pullDown.firstChild.getBoundingClientRect().height;
	        this.forceUpdate();

	        if (typeof this.props.refreshFunction !== 'function') {
	          throw new Error('Mandatory prop "refreshFunction" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage\'');
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.el.removeEventListener('scroll', this.throttledOnScrollListener);

	      if (this.props.pullDownToRefresh) {
	        document.removeEventListener('touchstart', this.onStart);
	        document.removeEventListener('touchmove', this.onMove);
	        document.removeEventListener('touchend', this.onEnd);

	        document.removeEventListener('mousedown', this.onStart);
	        document.removeEventListener('mousemove', this.onMove);
	        document.removeEventListener('mouseup', this.onEnd);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      // new data was sent in
	      this.setState({
	        showLoader: false,
	        actionTriggered: false,
	        pullToRefreshThresholdBreached: false
	      });
	    }
	  }, {
	    key: 'onStart',
	    value: function onStart(evt) {
	      if (this.state.lastScrollTop) return;

	      this.dragging = true;
	      this.startY = evt.pageY || evt.touches[0].pageY;
	      this.currentY = this.startY;

	      this._infScroll.style.willChange = 'transform';
	      this._infScroll.style.transition = 'transform 0.2s cubic-bezier(0,0,0.31,1)';
	    }
	  }, {
	    key: 'onMove',
	    value: function onMove(evt) {
	      if (!this.dragging) return;
	      this.currentY = evt.pageY || evt.touches[0].pageY;

	      // user is scrolling down to up
	      if (this.currentY < this.startY) return;

	      if (this.currentY - this.startY >= this.props.pullDownToRefreshThreshold) {
	        this.setState({
	          pullToRefreshThresholdBreached: true
	        });
	      }

	      // so you can drag upto 1.5 times of the maxPullDownDistance
	      if (this.currentY - this.startY > this.maxPullDownDistance * 1.5) return;

	      this._infScroll.style.overflow = 'visible';
	      this._infScroll.style.transform = 'translate3d(0px, ' + (this.currentY - this.startY) + 'px, 0px)';
	    }
	  }, {
	    key: 'onEnd',
	    value: function onEnd(evt) {
	      var _this = this;

	      this.startY = 0;
	      this.currentY = 0;

	      this.dragging = false;

	      if (this.state.pullToRefreshThresholdBreached) {
	        this.props.refreshFunction && this.props.refreshFunction();
	      }

	      requestAnimationFrame(function () {
	        _this._infScroll.style.overflow = 'auto';
	        _this._infScroll.style.transform = 'none';
	        _this._infScroll.style.willChange = 'none';
	      });
	    }
	  }, {
	    key: 'isElementAtBottom',
	    value: function isElementAtBottom(target) {
	      var scrollThreshold = arguments.length <= 1 || arguments[1] === undefined ? 0.8 : arguments[1];

	      var clientHeight = target === document.body || target === document.documentElement ? window.screen.availHeight : target.clientHeight;

	      var scrolled = scrollThreshold * (target.scrollHeight - target.scrollTop);
	      return scrolled <= clientHeight;
	    }
	  }, {
	    key: 'onScrollListener',
	    value: function onScrollListener(event) {
	      var target = this.props.height ? event.target : document.documentElement.scrollTop ? document.documentElement : document.body;

	      // if user scrolls up, remove action trigger lock
	      if (target.scrollTop < this.state.lastScrollTop) {
	        this.setState({
	          actionTriggered: false,
	          lastScrollTop: target.scrollTop
	        });
	        return; // user's going up, we don't care
	      }

	      // return immediately if the action has already been triggered,
	      // prevents multiple triggers.
	      if (this.state.actionTriggered) return;

	      var atBottom = this.isElementAtBottom(target, this.props.scrollThreshold);

	      // call the `next` function in the props to trigger the next data fetch
	      if (atBottom && this.props.hasMore) {
	        this.props.next();
	        this.setState({ actionTriggered: true, showLoader: true });
	      }
	      this.setState({ lastScrollTop: target.scrollTop });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;

	      var style = _extends({
	        height: this.props.height || 'auto',
	        overflow: 'auto',
	        WebkitOverflowScrolling: 'touch'
	      }, this.props.style);
	      var hasChildren = this.props.hasChildren || !!(this.props.children && this.props.children.length);

	      // because heighted infiniteScroll visualy breaks
	      // on drag down as overflow becomes visible
	      var outerDivStyle = this.props.pullDownToRefresh && this.props.height ? { overflow: 'auto' } : {};
	      return _react2['default'].createElement(
	        'div',
	        { style: outerDivStyle },
	        _react2['default'].createElement(
	          'div',
	          {
	            className: 'infinite-scroll-component',
	            ref: function (infScroll) {
	              return _this2._infScroll = infScroll;
	            },
	            style: style
	          },
	          this.props.pullDownToRefresh && _react2['default'].createElement(
	            'div',
	            {
	              style: { position: 'relative' },
	              ref: function (pullDown) {
	                return _this2._pullDown = pullDown;
	              }
	            },
	            _react2['default'].createElement(
	              'div',
	              { style: {
	                  position: 'absolute',
	                  left: 0,
	                  right: 0,
	                  top: -1 * this.maxPullDownDistance
	                } },
	              !this.state.pullToRefreshThresholdBreached && this.props.pullDownToRefreshContent,
	              this.state.pullToRefreshThresholdBreached && this.props.releaseToRefreshContent
	            )
	          ),
	          this.props.children,
	          !this.state.showLoader && !hasChildren && this.props.hasMore && this.props.loader,
	          this.state.showLoader && this.props.loader,
	          !this.props.hasMore && this.props.endMessage
	        )
	      );
	    }
	  }]);

	  return InfiniteScroll;
	})(_react.Component);

	exports['default'] = InfiniteScroll;

	InfiniteScroll.defaultProps = {
	  pullDownToRefreshContent: _react2['default'].createElement(
	    'h3',
	    null,
	    'Pull down to refresh'
	  ),
	  releaseToRefreshContent: _react2['default'].createElement(
	    'h3',
	    null,
	    'Release to refresh'
	  ),
	  pullDownToRefreshThreshold: 100,
	  disableBrowserPullToRefresh: true
	};

	InfiniteScroll.propTypes = {
	  next: _propTypes2['default'].func,
	  hasMore: _propTypes2['default'].bool,
	  children: _propTypes2['default'].node,
	  loader: _propTypes2['default'].node.isRequired,
	  scrollThreshold: _propTypes2['default'].number,
	  endMessage: _propTypes2['default'].node,
	  style: _propTypes2['default'].object,
	  height: _propTypes2['default'].number,
	  hasChildren: _propTypes2['default'].bool,
	  pullDownToRefresh: _propTypes2['default'].bool,
	  pullDownToRefreshContent: _propTypes2['default'].node,
	  releaseToRefreshContent: _propTypes2['default'].node,
	  pullDownToRefreshThreshold: _propTypes2['default'].number,
	  refreshFunction: _propTypes2['default'].func
	};
	module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// https://remysharp.com/2010/07/21/throttling-function-calls
	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = throttle;

	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last, deferTimer;
	  return function () {
	    var context = scope || this;

	    var now = +new Date(),
	        args = arguments;
	    if (last && now < last + threshhold) {
	      // hold on to it
	      clearTimeout(deferTimer);
	      deferTimer = setTimeout(function () {
	        last = now;
	        fn.apply(context, args);
	      }, threshhold);
	    } else {
	      last = now;
	      fn.apply(context, args);
	    }
	  };
	}

	module.exports = exports["default"];

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */

	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}

	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};

	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};

	module.exports = emptyFunction;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */

	'use strict';

	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */

	var validateFormat = function validateFormat(format) {};

	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}

	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);

	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }

	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}

	module.exports = invariant;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */

	'use strict';

	var emptyFunction = __webpack_require__(2);
	var invariant = __webpack_require__(3);
	var ReactPropTypesSecret = __webpack_require__(6);

	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };

	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */

	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;

	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };

	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(4)();
	}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */

	'use strict';

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	module.exports = ReactPropTypesSecret;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ })
/******/ ])
});
;

/***/ }),
/* 3569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logoGlobeSrc = __webpack_require__(231);

var FilterHeader = function FilterHeader(_ref) {
  var iconClassName = _ref.iconClassName,
      iconColor = _ref.iconColor,
      text = _ref.text;

  return _react2.default.createElement(
    'div',
    { style: { display: 'flex', width: '100%', alignItems: 'center', margin: '0 0 2% 11%' } },
    text === 'Recommendations' && _react2.default.createElement('img', { src: logoGlobeSrc, width: '42' }),
    iconClassName && _react2.default.createElement(_materialUi.FontIcon, { color: iconColor, className: iconClassName, style: { fontSize: '28px' } }),
    _react2.default.createElement(
      'div',
      { style: { display: 'inline-block', fontSize: '20px', fontWeight: 600, marginLeft: '2%' } },
      text
    )
  );
};

exports.default = FilterHeader;

/***/ }),
/* 3570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(67);

var _materialUi = __webpack_require__(3);

var _check = __webpack_require__(854);

var _check2 = _interopRequireDefault(_check);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImproveFeedContainer = function ImproveFeedContainer(_ref) {
  var commentCount = _ref.commentCount,
      postsCount = _ref.postsCount,
      likesCount = _ref.likesCount;

  return _react2.default.createElement(
    _materialUi.Paper,
    null,
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h4',
        { style: { padding: '20px', margin: 0, textAlign: 'center' } },
        'Improve Your Feed'
      )
    ),
    _react2.default.createElement('hr', null),
    _react2.default.createElement(
      _materialUi.List,
      { style: { padding: '0 20px 20px 20px' } },
      _react2.default.createElement(_materialUi.ListItem, { disabled: true, style: _extends({}, { fontSize: '14px', lineHeight: '16px' }, postsCount > 0 && { textDecoration: 'line-through', color: 'rgb(224, 224, 224)' }), primaryText: 'Make your first post', leftIcon: _react2.default.createElement(_check2.default, { color: postsCount > 0 ? '#1cd81c' : 'rgb(224, 224, 224)' }) }),
      _react2.default.createElement(_materialUi.ListItem, { style: { fontSize: '14px', lineHeight: '16px' }, primaryText: _react2.default.createElement(
          _reactRouter.Link,
          { to: '/connections/add-connections' },
          'Find your peers & partners on TourConnect'
        ), leftIcon: _react2.default.createElement(_check2.default, { color: 'rgb(224, 224, 224)' }) }),
      _react2.default.createElement(_materialUi.ListItem, { disabled: true, style: _extends({}, { fontSize: '14px', lineHeight: '16px' }, likesCount > 4 && { textDecoration: 'line-through', color: 'rgb(224, 224, 224)' }), primaryText: 'Like ' + (5 - likesCount > 0 ? 5 - likesCount : 5) + ' more posts', leftIcon: _react2.default.createElement(_check2.default, { color: likesCount > 4 ? '#1cd81c' : 'rgb(224, 224, 224)' }) }),
      _react2.default.createElement(_materialUi.ListItem, { disabled: true, style: _extends({}, { fontSize: '14px', lineHeight: '16px' }, commentCount > 0 && { textDecoration: 'line-through', color: 'rgb(224, 224, 224)' }), primaryText: 'Make your first comment', leftIcon: _react2.default.createElement(_check2.default, { color: commentCount > 0 ? '#1cd81c' : 'rgb(224, 224, 224)' }) })
    )
  );
};

exports.default = ImproveFeedContainer;

/***/ }),
/* 3571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(1007);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InternalPost = function (_Component) {
  _inherits(InternalPost, _Component);

  function InternalPost() {
    _classCallCheck(this, InternalPost);

    return _possibleConstructorReturn(this, (InternalPost.__proto__ || Object.getPrototypeOf(InternalPost)).apply(this, arguments));
  }

  _createClass(InternalPost, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          getAPost = _props.getAPost,
          params = _props.params;

      getAPost(params.postId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          params = _props2.params,
          props = _objectWithoutProperties(_props2, ['children', 'params']);

      return _react2.default.createElement(
        'div',
        null,
        children ? (0, _react.cloneElement)(children, _extends({}, props, { postId: params.postId, displayType: 'internalPostPage' })) : undefined
      );
    }
  }]);

  return InternalPost;
}(_react.Component);

InternalPost.propTypes = {
  children: _react.PropTypes.object,
  params: _react.PropTypes.object,
  getAPost: _react.PropTypes.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getAPost: function getAPost(postId) {
      return dispatch((0, _actions.getPost)(postId));
    }
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(InternalPost);

/***/ }),
/* 3572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _metaDataActions = __webpack_require__(1113);

var _actions = __webpack_require__(226);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _react.PropTypes.node,
  location: _react.PropTypes.object,
  getPosts: _react.PropTypes.func,
  getFollowers: _react.PropTypes.func,
  getFollows: _react.PropTypes.func,
  getMetadata: _react.PropTypes.func,
  updateNewsFeedProps: _react.PropTypes.func,
  gotMetaDataCount: _react.PropTypes.bool,
  followersCount: _react.PropTypes.number,
  followsCount: _react.PropTypes.number,
  postsCount: _react.PropTypes.number,
  followers: _react.PropTypes.array,
  follows: _react.PropTypes.array,
  posts: _react.PropTypes.array,
  loading: _react.PropTypes.bool
};

var NewsfeedMetaDataContainer = function (_Component) {
  _inherits(NewsfeedMetaDataContainer, _Component);

  function NewsfeedMetaDataContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NewsfeedMetaDataContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewsfeedMetaDataContainer.__proto__ || Object.getPrototypeOf(NewsfeedMetaDataContainer)).call.apply(_ref, [this].concat(args))), _this), _this.getRouteName = function (props) {
      var location = props.location;

      if (_ramda2.default.contains('posts', location.pathname)) return 'posts';
      if (_ramda2.default.contains('followers', location.pathname)) return 'followers';
      return 'follows';
    }, _this.loadData = function (routeName) {
      var _this$props = _this.props,
          getPosts = _this$props.getPosts,
          getFollowers = _this$props.getFollowers,
          getFollows = _this$props.getFollows,
          posts = _this$props.posts,
          follows = _this$props.follows,
          followers = _this$props.followers;

      if (routeName === 'posts') {
        if (_ramda2.default.isEmpty(posts)) getPosts();
      }
      if (routeName === 'follows') {
        if (_ramda2.default.isEmpty(follows)) getFollows();
      }
      if (routeName === 'followers') {
        if (_ramda2.default.isEmpty(followers)) getFollowers();
      }
    }, _this.handleRouteChange = function (routeName) {
      _this.context.router.push('/newsfeed/meta/' + routeName);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NewsfeedMetaDataContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          gotMetaDataCount = _props.gotMetaDataCount,
          getMetadata = _props.getMetadata;

      if (!gotMetaDataCount) getMetadata();
      var routeName = this.getRouteName(this.props);
      this.loadData(routeName);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var previousRouteName = this.getRouteName(this.props);
      var newRouteName = this.getRouteName(nextProps);
      if (previousRouteName !== newRouteName) this.loadData(newRouteName);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.updateNewsFeedProps({ newsfeed: [] });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          extraProps = _objectWithoutProperties(_props2, ['children']);

      var routeName = this.getRouteName(this.props);
      return _react2.default.createElement(
        _materialUi.Paper,
        { className: 'l-app-content' },
        _react2.default.createElement(
          _materialUi.Tabs,
          {
            value: routeName,
            onChange: this.handleRouteChange
          },
          _react2.default.createElement(_materialUi.Tab, { label: 'Posts', value: 'posts' }),
          _react2.default.createElement(_materialUi.Tab, { label: 'Follows', value: 'follows' }),
          _react2.default.createElement(_materialUi.Tab, { label: 'Followers', value: 'followers' })
        ),
        children ? (0, _react.cloneElement)(children, extraProps) : undefined
      );
    }
  }]);

  return NewsfeedMetaDataContainer;
}(_react.Component);

NewsfeedMetaDataContainer.propTypes = propTypes;
NewsfeedMetaDataContainer.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var newsfeedMetaData = _ref2.newsfeedMetaData,
      newsfeed = _ref2.newsfeed;
  return _extends({}, newsfeedMetaData.toJS(), {
    posts: newsfeed.get('newsfeed').toJS()
  });
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getPosts: function getPosts() {
      return dispatch(_metaDataActions.getPosts.apply(undefined, arguments));
    },
    getFollowers: function getFollowers() {
      return dispatch(_metaDataActions.getFollowers.apply(undefined, arguments));
    },
    getFollows: function getFollows() {
      return dispatch(_metaDataActions.getFollows.apply(undefined, arguments));
    },
    getMetadata: function getMetadata() {
      return dispatch(_metaDataActions.getMetadata.apply(undefined, arguments));
    },
    updateNewsFeedProps: function updateNewsFeedProps() {
      return dispatch(_actions.updateProps.apply(undefined, arguments));
    }
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NewsfeedMetaDataContainer);

/***/ }),
/* 3573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _singlePostContainer = __webpack_require__(1154);

var _singlePostContainer2 = _interopRequireDefault(_singlePostContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OwnPosts = function OwnPosts(_ref) {
  var posts = _ref.posts;

  return _react2.default.createElement(
    'div',
    { style: { width: '50%', margin: 'auto' } },
    posts.map(function (post) {
      return _react2.default.createElement(_singlePostContainer2.default, _extends({ key: post.postId }, post));
    })
  );
};

exports.default = OwnPosts;

/***/ }),
/* 3574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _displayCompanyWithLocs = __webpack_require__(2044);

var _displayCompanyWithLocs2 = _interopRequireDefault(_displayCompanyWithLocs);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Followers = function Followers(_ref) {
  var followers = _ref.followers;

  return _react2.default.createElement(
    'div',
    { style: { width: '60%', margin: '24px auto' } },
    followers.map(function (_ref2) {
      var locationId = _ref2.locationId,
          name = _ref2.name,
          connectedCompanyWithLocs = _ref2.connectedCompanyWithLocs;

      var numOfCompanies = _ramda2.default.length(connectedCompanyWithLocs);
      var totalLocs = _ramda2.default.length(_ramda2.default.chain(_ramda2.default.prop('locations'), connectedCompanyWithLocs));
      return _react2.default.createElement(
        _materialUi.Card,
        {
          key: locationId,
          style: { width: '90%', margin: '24px auto 0 0' },
          expandable: true
        },
        _react2.default.createElement(_materialUi.CardHeader, {
          actAsExpander: true,
          showExpandableButton: true,
          avatar: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-location_on' }),
          title: name + ' : ' + numOfCompanies + ' ' + (0, _pluralize2.default)('company', numOfCompanies) + ', ' + totalLocs + ' ' + (0, _pluralize2.default)('location', totalLocs)
        }),
        _react2.default.createElement(
          _materialUi.CardText,
          { style: { paddingLeft: '32px' }, expandable: true },
          connectedCompanyWithLocs.map(function (companyWithLocs) {
            return _react2.default.createElement(_displayCompanyWithLocs2.default, _extends({ key: companyWithLocs.companyId }, companyWithLocs));
          })
        )
      );
    })
  );
};

exports.default = Followers;

/***/ }),
/* 3575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _displayCompanyWithLocs = __webpack_require__(2044);

var _displayCompanyWithLocs2 = _interopRequireDefault(_displayCompanyWithLocs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Follows = function Follows(_ref) {
  var follows = _ref.follows;

  return _react2.default.createElement(
    'div',
    { style: { width: '50%', margin: 'auto' } },
    follows.map(function (companyWithLocs, index) {
      return _react2.default.createElement(
        _materialUi.Paper,
        { key: companyWithLocs.companyId, style: { marginTop: '24px' } },
        index + 1,
        ': ',
        _react2.default.createElement(_displayCompanyWithLocs2.default, companyWithLocs)
      );
    })
  );
};

exports.default = Follows;

/***/ }),
/* 3576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _connectionList = __webpack_require__(3577);

var _connectionList2 = _interopRequireDefault(_connectionList);

var _convsContainer = __webpack_require__(2040);

var _convsContainer2 = _interopRequireDefault(_convsContainer);

var _rgtMsgsRouter = __webpack_require__(2042);

var _rgtMsgsRouter2 = _interopRequireDefault(_rgtMsgsRouter);

var _content = __webpack_require__(3581);

var _content2 = _interopRequireDefault(_content);

var _actions = __webpack_require__(476);

var _placeholder = __webpack_require__(3587);

var _placeholder2 = _interopRequireDefault(_placeholder);

var _list = __webpack_require__(3589);

var _list2 = _interopRequireDefault(_list);

var _body = __webpack_require__(3590);

var _body2 = _interopRequireDefault(_body);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  container: {
    marginTop: '65px',
    backgroundColor: 'white',
    borderRight: '1px solid rgb(224, 224, 224)',
    borderLeft: '1px solid rgb(224, 224, 224)',
    display: 'flex',
    paddingLeft: '',
    height: 'calc(100% - 65px)',
    marginRight: '60px',
    marginLeft: '60px'
  },
  connectionList: {
    flex: '0 0 auto',
    width: '294px',
    height: '100%',
    backgroundColor: 'rgb(240, 240, 240)',
    display: 'flex',
    flexDirection: 'column'
  },
  channelList: {
    flex: '0 0 auto'
  },
  body: {
    flex: '3 1 auto'
  },
  ContractContent: _content.styles.content,
  ContractContentMessages: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    marginTop: '-7px',
    padding: '5px',
    height: 'calc(100% - 257px)',
    backgroundColor: 'white'
  },
  ContractContentMessageBox: {
    '& div': {
      marginTop: '0 !important'
    }
  },
  InboxConvList: {},
  InboxContent: {
    height: '100%',
    backgroundColor: 'rgb(250, 250, 250)'
  }
};

var Workspace = function (_Component) {
  _inherits(Workspace, _Component);

  function Workspace() {
    _classCallCheck(this, Workspace);

    return _possibleConstructorReturn(this, (Workspace.__proto__ || Object.getPrototypeOf(Workspace)).apply(this, arguments));
  }

  _createClass(Workspace, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.syncPropsFromUrl(this.props);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.getConnections();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.syncPropsFromUrl(newProps);
    }
  }, {
    key: 'syncPropsFromUrl',
    value: function syncPropsFromUrl(props) {
      var urlVals = {
        connectionId: props.params.connectionId || null,
        channelId: props.params.channelId || null
      };
      // sync Url to Store (all values)
      if (props.selectedConnection !== urlVals.connectionId || props.selectedChannel !== urlVals.channelId) {
        this.props.changeSelection(urlVals.connectionId, urlVals.channelId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          params = _props.params,
          classes = _props.classes,
          connections = _props.connections;
      var connectionId = params.connectionId;

      if (connections.length === 0) return _react2.default.createElement(_placeholder2.default, null);
      return _react2.default.createElement(
        'div',
        { className: '' + classes.container },
        _react2.default.createElement(_connectionList2.default, { className: classes.connectionList }),
        connectionId === 'inbox' ? _react2.default.createElement(_convsContainer2.default, { params: params, className: classes.InboxConvList }) : undefined,
        connectionId === 'inbox' ? _react2.default.createElement(_rgtMsgsRouter2.default, { params: this.props.params, className: classes.InboxContent }) : undefined,
        connectionId === 'bulkmessages' ? _react2.default.createElement(_list2.default, null) : undefined,
        connectionId === 'bulkmessages' ? _react2.default.createElement(_body2.default, null) : undefined,
        ['inbox', 'bulkmessages'].indexOf(connectionId) < 0 ? _react2.default.createElement(_content2.default, { className: classes.body }) : undefined
      );
    }
  }]);

  return Workspace;
}(_react.Component);

Workspace.propTypes = {
  children: _react.PropTypes.any,
  changeSelection: _react.PropTypes.func,
  classes: _react.PropTypes.object,
  connections: _react.PropTypes.array,
  getConnections: _react.PropTypes.func,
  params: _react.PropTypes.shape({
    connectionId: _react.PropTypes.string,
    channelId: _react.PropTypes.string
  }),
  selectChannel: _react.PropTypes.func,
  selectConnection: _react.PropTypes.func,
  selectContract: _react.PropTypes.func,
  selectedChannel: _react.PropTypes.string,
  selectedContractId: _react.PropTypes.string
};

var select = function select(state) {
  return {
    user: state.user.toJS(),
    selectedConnection: state.workspace.selectedConnection,
    selectedChannel: state.workspace.selectedChannel,
    selectedContract: state.workspace.selectedContract,
    connections: state.workspace.connections
  };
};

exports.default = (0, _reactRedux.connect)(select, {
  getConnections: _actions.getConnections,
  selectConnection: _actions.selectConnection,
  selectChannel: _actions.selectChannel,
  selectContract: _actions.selectContract,
  resetChannel: _actions.resetChannel,
  changeSelection: _actions.changeSelection
})((0, _reactJss2.default)(styles)(Workspace));

/***/ }),
/* 3577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _moreVert = __webpack_require__(876);

var _moreVert2 = _interopRequireDefault(_moreVert);

var _addCircleOutline = __webpack_require__(1259);

var _addCircleOutline2 = _interopRequireDefault(_addCircleOutline);

var _recentActors = __webpack_require__(3578);

var _recentActors2 = _interopRequireDefault(_recentActors);

var _liveHelp = __webpack_require__(1854);

var _liveHelp2 = _interopRequireDefault(_liveHelp);

var _colors = __webpack_require__(259);

var _reactRouterRedux = __webpack_require__(27);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _actions = __webpack_require__(476);

var _connectionListItem = __webpack_require__(3579);

var _connectionListItem2 = _interopRequireDefault(_connectionListItem);

var _connectionListSearch = __webpack_require__(3580);

var _connectionListSearch2 = _interopRequireDefault(_connectionListSearch);

var _actions2 = __webpack_require__(1111);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  connectionsListTitle: {
    alignItems: 'center',
    backgroundColor: 'rgb(0, 161, 186)',
    display: 'flex',
    minHeight: '48px !important',
    justifyContent: 'space-around',
    paddingLeft: '15px !important'
  },
  partnersTitle: {
    color: 'white !important',
    fontSize: '18px',
    flex: '1 1 auto',
    '&.loading': {
      cursor: 'wait'
    }
  },
  connectionRow: {
    //    paddingTop: '5px',
    height: '100%',
    overflow: 'auto'
  },
  connectionItem: {
    height: '58px !important',
    color: '#757575 !important', // #00bcd4 < -- selected
    borderLeft: '3px solid transparent !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .avatarIcon': {
      fill: '#757575 !important'
    },
    '&:hover': {
      backgroundColor: 'transparent !important',
      borderLeft: '3px solid #ff4081 !important',
      color: '#ff4081 !important',
      '&:not(.selected) .avatarIcon': {
        fill: '#ff4081 !important'
      }
    },
    '&.selected': {
      color: '#00bcd4 !important',
      backgroundColor: 'transparent !important',
      borderLeft: '3px solid #00bcd4 !important',
      '& .avatarIcon': {
        fill: '#00bcd4 !important'
      }
    },
    '&.disabled': {
      opacity: '0.3'
    }
  },
  workspaceAvatar: {
    border: 'solid 1px #bbb',
    cursor: 'pointer',
    flex: '0 0 auto',
    left: '0 !important',
    marginLeft: '10px',
    position: 'relative !important',
    top: 'inherit !important',
    '&.unread:after': {
      backgroundColor: '#FF0000',
      borderRadius: '50%',
      content: 'close-quote',
      height: '10px',
      left: '28px',
      top: '30px',
      opacity: '0.8',
      pointerEvents: 'none',
      position: 'absolute',
      width: '10px'
    }
  },
  workspaceMenuItem: {},
  iconMenu: {
    '& > button': {
      padding: '12px 0 12px 0 !important',
      width: '36px !important'
    }
  },
  lastSystemChannel: {
    borderBottom: '1px solid #bbb'
  }
};

var ConnectionList = function (_Component) {
  _inherits(ConnectionList, _Component);

  function ConnectionList(props) {
    _classCallCheck(this, ConnectionList);

    var _this = _possibleConstructorReturn(this, (ConnectionList.__proto__ || Object.getPrototypeOf(ConnectionList)).call(this, props));

    _this._updateSearch = function (searchValue) {
      _this.setState({ searchValue: searchValue });
    };

    _this.timer = null;

    _this.timedUpdate = function () {
      if (!localStorage.stopAutoReload && !_this.props.connectionsFetching) _this.props.getConnections();
    };

    _this.switchChannel = function (connectionId) {
      if (connectionId === 'inbox') {
        _this.props.routerPush('/workspace/' + connectionId);
      } else _this.props.routerPush('/workspace/' + connectionId + '/general');
      var connectionIx = _this.props.connections.map(function (e) {
        return e.id;
      }).indexOf(connectionId);
      var lastChannel = _this.props.connections[connectionIx].lastChannel;
      if (lastChannel) {
        _this.props.routerPush('/workspace/' + connectionId + '/' + lastChannel);
      } else {
        _this.props.routerPush('/workspace/' + connectionId);
      }
    };

    _this.state = {
      searchValue: ''
    };
    return _this;
  }

  _createClass(ConnectionList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.timer) this.timer = setInterval(this.timedUpdate, 6e3);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          connectionsFetching = _props.connectionsFetching,
          selectedConnection = _props.selectedConnection,
          connections = _props.connections,
          classes = _props.classes;

      var iconButtonElement = _react2.default.createElement(
        _materialUi.IconButton,
        { touch: true },
        _react2.default.createElement(_moreVert2.default, { color: _colors.grey400 })
      );
      var rightIconMenu = function rightIconMenu(key) {
        return _react2.default.createElement(
          _materialUi.IconMenu,
          { iconButtonElement: iconButtonElement, className: classes.iconMenu },
          _react2.default.createElement(
            _materialUi.MenuItem,
            { className: classes.workspaceMenuItem, onClick: function onClick() {
                _this2.props.archiveConnection(key);
              }
            },
            ' Archive'
          ),
          _react2.default.createElement(
            _materialUi.MenuItem,
            { className: classes.workspaceMenuItem, onClick: function onClick() {
                window.location = "https://app.tourconnect.com" + '/partner-management/partner-details/' + key + '?jwt=' + localStorage.getItem('jwt');
              }
            },
            'Partner Details'
          )
        );
      };
      var lastSystemChannel = void 0;
      connections.some(function (e) {
        if (e.archivable) {
          return false;
        }
        lastSystemChannel = e.id;
      });
      return _react2.default.createElement(
        'div',
        { className: this.props.className },
        _react2.default.createElement(
          'div',
          { className: '' + classes.connectionsListTitle + (connectionsFetching ? ' loading' : '') },
          _react2.default.createElement(
            'div',
            { className: classes.partnersTitle },
            'Channels'
          ),
          _react2.default.createElement(
            _materialUi.IconButton,
            { iconStyle: { color: _colors.white }, onTouchTap: function onTouchTap() {
                _this2.props.openMassDialog();
              } },
            _react2.default.createElement(_addCircleOutline2.default, null)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: classes.connectionRow },
          [].concat(_toConsumableArray(connections.filter(function (e) {
            return !e.archivable;
          })), [{
            id: 'search',
            component: connections.filter(function (e) {
              return e.archivable;
            }).length > 0 ? _react2.default.createElement(_connectionListSearch2.default, { key: 'id', searchUpdate: this._updateSearch }) : _react2.default.createElement('span', { key: 'nosearch' })
          }], _toConsumableArray(connections.filter(function (e) {
            return e.archivable && (!_this2.state.searchValue || new RegExp('^.*' + _this2.state.searchValue.split(' ').join('.*') + '.*$', 'gi').test(e.name.replace(/ {2}/g, ' ')));
          })))
          // hiding all others for now
          .filter(function (o) {
            return ['bulkmessages', 'inbox'].indexOf(o.id) > -1;
          }).map(function (connection) {
            var newAttributes = {};
            // const iconClassName = (selectedConnection === connection.id ? classes.iconStylesSelected : classes.iconStyles);
            switch (connection.id) {
              case 'bulkmessages':
                newAttributes.icon = _react2.default.createElement(_recentActors2.default, { className: 'avatarIcon' });
                newAttributes.avatarText = null;
                break;
              case 'inbox':
                newAttributes.icon = _react2.default.createElement(_liveHelp2.default, { className: 'avatarIcon' });
                newAttributes.avatarText = null;
                break;
              default:
                if (connection.avatar) {
                  newAttributes.avatarText = null;
                }
                break;
            }
            return _extends({}, connection, newAttributes);
          }).map(function (connection) {
            var component = connection.component || _react2.default.createElement(
              'div',
              {
                className: '' + classes.connectionItem + (connection.disabled ? ' disabled' : '') + (selectedConnection === connection.id ? ' selected' : '') + (lastSystemChannel === connection.id ? ' ' + classes.lastSystemChannel : '')
                // value={connection.id}
                , key: connection.id
              },
              _react2.default.createElement(
                _materialUi.Avatar,
                _extends({
                  onTouchTap: function onTouchTap() {
                    _this2.switchChannel(connection.id);
                  },
                  className: '' + classes.workspaceAvatar + (connection.unread ? ' unread' : '')
                }, connection.avatar ? { src: connection.avatar } : {}, connection.icon ? { icon: connection.icon, style: {
                    backgroundColor: 'none',
                    border: 'none'
                  } } : {}),
                connection.avatarText
              ),
              _react2.default.createElement(_connectionListItem2.default, _extends({
                name: connection.name,
                lastUnread: connection.lastUnread,
                onTouchTap: function onTouchTap() {
                  _this2.switchChannel(connection.id);
                },
                noArchive: connection.archivable !== true
              }, connection.unread ? { unread: true } : {})),
              connection.archivable ? rightIconMenu(connection.id) : _react2.default.createElement(
                'div',
                null,
                '\xA0'
              )
            );
            if (connection.id === 'bulkmessages') {
              return _react2.default.createElement(
                _wrapper2.default,
                { amazonOrange: true, skipClick: true },
                component
              );
            }
            return component;
          })
        )
      );
    }
  }]);

  return ConnectionList;
}(_react.Component);

ConnectionList.propTypes = {
  archiveConnection: _propTypes2.default.func,
  classes: _propTypes2.default.object,
  className: _propTypes2.default.string,
  connections: _propTypes2.default.array,
  connectionsFetching: _propTypes2.default.bool,
  getConnections: _propTypes2.default.func,
  openMassDialog: _propTypes2.default.func,
  routerPush: _propTypes2.default.func,
  routerReplace: _propTypes2.default.func,
  selectedConnection: _propTypes2.default.string
};

var select = function select(state) {
  return {
    connections: state.workspace.connections,
    connectionsFetching: state.workspace.connectionsFetching,
    selectedConnection: state.workspace.selectedConnection
  };
};

exports.default = (0, _reactRedux.connect)(select, {
  routerPush: _reactRouterRedux.push,
  routerReplace: _reactRouterRedux.replace,
  archiveConnection: _actions.archiveConnection,
  getConnections: _actions.getConnections,
  openMassDialog: _actions2.openModal
})((0, _reactJss2.default)(styles)(ConnectionList));

/***/ }),
/* 3578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvRecentActors = function AvRecentActors(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z' })
  );
};
AvRecentActors = (0, _pure2.default)(AvRecentActors);
AvRecentActors.displayName = 'AvRecentActors';
AvRecentActors.muiName = 'SvgIcon';

exports.default = AvRecentActors;

/***/ }),
/* 3579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-start',
    flex: '1 1 auto',
    marginLeft: '10px',
    cursor: 'pointer',
    maxHeight: '58px',
    '&.unread': {
      fontWeight: 'bolder'
    },
    '&.noarchive': {}
  },
  firstLine: {
    maxWidth: '183px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    wordWrap: 'break-word',
    '&.with-second-line': {
      whiteSpace: 'nowrap'
    },
    '&.no-second-line': {
      display: '-webkit-box',
      '-webkit-line-clamp': '2',
      '-webkit-box-orient': 'vertical'
    }
  },
  secondLine: {
    fontSize: '12px'
  }
};

var ConnectionListItem = function (_Component) {
  _inherits(ConnectionListItem, _Component);

  function ConnectionListItem(props) {
    _classCallCheck(this, ConnectionListItem);

    var _this = _possibleConstructorReturn(this, (ConnectionListItem.__proto__ || Object.getPrototypeOf(ConnectionListItem)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(ConnectionListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          unread = _props.unread,
          onTouchTap = _props.onTouchTap,
          lastUnread = _props.lastUnread,
          name = _props.name,
          noArchive = _props.noArchive;

      var secondLineClass = lastUnread ? 'with-second-line' : 'no-second-line';
      return _react2.default.createElement(
        'div',
        { className: '' + classes.container + (unread ? ' unread' : '') + (noArchive ? ' noarchive' : ''), onTouchTap: onTouchTap },
        _react2.default.createElement(
          'div',
          { className: classes.firstLine + ' ' + secondLineClass },
          name
        ),
        lastUnread ? _react2.default.createElement(
          'div',
          { className: classes.secondLine },
          (0, _moment2.default)(lastUnread).fromNow()
        ) : undefined
      );
    }
  }]);

  return ConnectionListItem;
}(_react.Component);

ConnectionListItem.propTypes = {
  classes: _propTypes2.default.object,
  lastUnread: _propTypes2.default.string,
  name: _propTypes2.default.string,
  onTouchTap: _propTypes2.default.func,
  unread: _propTypes2.default.bool,
  noArchive: _propTypes2.default.bool
};

exports.default = (0, _reactJss2.default)(styles)(ConnectionListItem);

/***/ }),
/* 3580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _TextField = __webpack_require__(626);

var _TextField2 = _interopRequireDefault(_TextField);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {};

var ConnnectionListSearch = function (_Component) {
  _inherits(ConnnectionListSearch, _Component);

  function ConnnectionListSearch(props) {
    _classCallCheck(this, ConnnectionListSearch);

    var _this = _possibleConstructorReturn(this, (ConnnectionListSearch.__proto__ || Object.getPrototypeOf(ConnnectionListSearch)).call(this, props));

    _this.state = {
      partnerFilter: ''
    };
    return _this;
  }

  _createClass(ConnnectionListSearch, [{
    key: '_updateValue',
    value: function _updateValue(type) {
      var _this2 = this;

      if (this.state.partnerFilter !== this.refs[type].getValue()) {
        this.setState(_defineProperty({}, type, this.refs[type].getValue()), function () {
          _this2.props.searchUpdate(_this2.state.partnerFilter);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_TextField2.default, {
        hintText: 'Search for a partner',
        ref: 'partnerFilter',
        onChange: (0, _lodash2.default)(this._updateValue.bind(this, 'partnerFilter'), 400),
        underlineShow: false,
        hintStyle: { marginLeft: '24px', fontSize: '12px', color: 'black' },
        inputStyle: {
          border: '1px solid #00bcd4',
          width: '100%',
          marginLeft: '14px',
          bottom: '-10px',
          height: '28px',
          paddingLeft: '10px',
          fontSize: '12px',
          backgroundColor: 'rgba(255, 255, 255, 0.7)'
        }
      });
    }
  }]);

  return ConnnectionListSearch;
}(_react.Component);

ConnnectionListSearch.propTypes = {
  classes: _propTypes2.default.object,
  searchUpdate: _propTypes2.default.func
};

ConnnectionListSearch.defaultProps = {
  searchUpdate: console.log
};

exports.default = (0, _reactJss2.default)(styles)(ConnnectionListSearch);

/***/ }),
/* 3581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _lodash = __webpack_require__(140);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRouterRedux = __webpack_require__(27);

var _actions = __webpack_require__(476);

var _contentMessage = __webpack_require__(3582);

var _contentMessage2 = _interopRequireDefault(_contentMessage);

var _contentComment = __webpack_require__(3584);

var _contentComment2 = _interopRequireDefault(_contentComment);

var _noteContent = __webpack_require__(2014);

var _noteContent2 = _interopRequireDefault(_noteContent);

var _channelList = __webpack_require__(3585);

var _channelList2 = _interopRequireDefault(_channelList);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _wrapper = __webpack_require__(232);

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  content: {
    backgroundColor: 'rgb(240, 244, 247)',
    height: '100%',
    paddingLeft: '0 !important',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  activities: {
    backgroundColor: 'white',
    flex: '1 1 auto',
    overflowX: 'hidden',
    overflowY: 'scroll',
    padding: '8px 2%'
  }
};

var WorkspaceContent = function (_Component) {
  _inherits(WorkspaceContent, _Component);

  function WorkspaceContent(props) {
    _classCallCheck(this, WorkspaceContent);

    var _this = _possibleConstructorReturn(this, (WorkspaceContent.__proto__ || Object.getPrototypeOf(WorkspaceContent)).call(this, props));

    _this.onScroll = function (_ref) {
      var target = _ref.target;

      if (target.scrollTop === target.scrollHeight - target.clientHeight) {
        _this.props.markRead();
      }
    };

    _this.conversationDOM = function () {
      return document.getElementsByClassName('conversation')[0];
    };

    _this.scrollToBottom = (0, _lodash2.default)(function () {
      var container = _this.conversationDOM();
      if (container) container.scrollTop = container.scrollHeight - container.clientHeight;
    }, 100);

    _this.timedUpdate = function () {
      if (!localStorage.stopAutoReload && !_this.props.loading) _this.props.getConversations();
    };

    _this.timer = null;
    return _this;
  }

  _createClass(WorkspaceContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToBottom();
      if (!this.timer) this.timer = setInterval(this.timedUpdate, 3e3);
      // trigger because the container might not need scrolling
      this.onScroll({ target: this.conversationDOM() });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.loading && !nextProps.loading && nextProps.body.length !== this.props.body.length) {
        this.scrollToBottom();
      } else if (this.props.selectedChannel !== nextProps.selectedChannel || this.props.selectedConnection !== nextProps.selectedConnection) {
        // the user might had switched channels, and the container might not need scrolling
        this.onScroll({ target: this.conversationDOM() });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          body = _props.body,
          selectedChannel = _props.selectedChannel,
          selectedContract = _props.selectedContract,
          classes = _props.classes,
          partnerLocked = _props.partnerLocked;

      var showCommentBox = selectedChannel && selectedChannel !== 'contracting' && selectedContract !== 'contracting' && !partnerLocked;
      return _react2.default.createElement(
        'div',
        { className: (this.props.className || '') + ' ' + classes.content },
        _react2.default.createElement(_channelList2.default, null),
        _react2.default.createElement(
          'div',
          { className: 'conversation ' + classes.activities, onScroll: this.onScroll },
          body.filter(function (message) {
            return message.text;
          }).map(function (message) {
            return message.type === 'note' ? _react2.default.createElement(_noteContent2.default, {
              itemId: message.key,
              bodyText: message.text,
              attachments: message.attachments,
              authorname: message.participant.name,
              timestamp: message.timestamp,
              handleRemove: function handleRemove(key) {
                console.log(key);
              }
            }) : _react2.default.createElement(_contentMessage2.default, message);
          })
        ),
        _react2.default.createElement(_materialUi.Divider, null),
        showCommentBox && _react2.default.createElement(_contentComment2.default, selectedChannel === 'notes' ? { internal: true } : {}),
        Boolean(partnerLocked) && _react2.default.createElement(
          _wrapper2.default,
          {
            amazonOrange: true,
            slug: 'upgrade-page-lkd-partners',
            blocker: true,
            skipBack: true
          },
          _react2.default.createElement(
            'div',
            {
              style: { position: 'relative' }
            },
            _react2.default.createElement(
              'div',
              {
                style: {
                  position: 'absolute',
                  height: '300px',
                  width: '100%',
                  backgroundColor: 'rgba(255, 193, 7, 0.5)',
                  fontSize: '24px',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  paddingTop: '2em'
                }
              },
              'This partner is locked.',
              _react2.default.createElement('br', null),
              _react2.default.createElement('br', null),
              'Upgrade to Interact'
            ),
            _react2.default.createElement(_contentComment2.default, null)
          )
        )
      );
    }
  }]);

  return WorkspaceContent;
}(_react.Component);

WorkspaceContent.defaultProps = {
  conversationCommentHeight: 205
};

WorkspaceContent.propTypes = {
  body: _react.PropTypes.array,
  classes: _react.PropTypes.object,
  className: _react.PropTypes.string,
  contractId: _react.PropTypes.string,
  conversationCommentHeight: _react.PropTypes.number,
  getConversations: _react.PropTypes.func,
  loading: _react.PropTypes.bool,
  markRead: _react.PropTypes.func,
  participanName: _react.PropTypes.string,
  routerPush: _react.PropTypes.func,
  selectedChannel: _react.PropTypes.string,
  selectedConnection: _react.PropTypes.string,
  selectedContract: _react.PropTypes.string,
  partnerLocked: _react.PropTypes.bool
};

var select = function select(state) {
  return {
    body: state.workspace.conversations,
    partnerLocked: state.workspace.partnerLocked,
    contractId: state.workspace.conversationsContractId,
    loading: state.workspace.conversationsFetching,
    participanName: state.workspace.conversationsParticipantName,
    selectedChannel: state.workspace.selectedChannel,
    selectedConnection: state.workspace.selectedConnection,
    selectedContract: state.workspace.selectedContract
  };
};

exports.default = (0, _reactRedux.connect)(select, {
  getConversations: _actions.getConversations,
  markRead: _actions.markRead,
  routerPush: _reactRouterRedux.push
})((0, _reactJss2.default)(styles)(WorkspaceContent));
exports.styles = styles;

/***/ }),
/* 3582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(27);

var _reactRedux = __webpack_require__(6);

var _historyAction = __webpack_require__(3583);

var _historyAction2 = _interopRequireDefault(_historyAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var contentMessage = function (_Component) {
  _inherits(contentMessage, _Component);

  function contentMessage() {
    _classCallCheck(this, contentMessage);

    return _possibleConstructorReturn(this, (contentMessage.__proto__ || Object.getPrototypeOf(contentMessage)).apply(this, arguments));
  }

  _createClass(contentMessage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_historyAction2.default, this.props);
    }
  }]);

  return contentMessage;
}(_react.Component);

contentMessage.defaultProps = {
  attachments: []
};
contentMessage.propTypes = {
  myCompanyId: _react.PropTypes.string,
  participant: _react.PropTypes.object,
  routerPush: _react.PropTypes.func
};

var select = function select(state) {
  return {
    myCompanyId: state.user.getIn(['company', 'companyId'])
  };
};

exports.default = (0, _reactRedux.connect)(select, {
  routerPush: _reactRouterRedux.push
})(contentMessage);

/***/ }),
/* 3583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _messageWrapper = __webpack_require__(2043);

var _messageWrapper2 = _interopRequireDefault(_messageWrapper);

var _activityWithIcon = __webpack_require__(1266);

var _activityWithIcon2 = _interopRequireDefault(_activityWithIcon);

var _api = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  TODO: For contract actions use contracting / comments / comment.js
*/
var styles = {
  contractName: {
    whiteSpace: 'nowrap',
    marginTop: '10px',
    fontSize: '0.8em',
    marginRight: '4px'
  },
  subTitle: {
    whiteSpace: 'nowrap',
    fontWeight: 'bolder',
    marginBottom: '10px'
  },
  iconColor: {
    color: 'rgba(0, 0, 0, 0.54) !important'
  },
  button: {
    padding: '0 !important',
    height: '27px !important',
    marginTop: '10px !important',
    width: '37px !important'
  },
  textBody: {
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap'
  },
  hideQuote: {
    display: 'none'
  },
  fileAttachment: {
    marginTop: '10px'
  },
  HTMLMessage: {
    display: 'block',
    fontSize: '14px',
    whiteSpace: 'pre-wrap',
    lineHeight: '20px',
    width: '100%',
    overflowX: 'hidden',
    '& img': {
      display: 'none'
    },
    '& blockquote[type=\'cite\']': { // Outlook
      display: 'none'
    },
    '& div[class=\'\']': { // Outlook padding
      display: 'none'
    },
    '& .gmail_extra': { // Gmail
      display: 'none'
    },
    '& .gmail_quote': { // Gmail Quote
      display: 'none'
    },
    '& div[dir=\'ltr\']+br': { // Gmail padding
      display: 'none'
    },
    '& .gmail_signature': { // Gmail Signature
      display: 'none'
    }
  }
};

var historyAction = function (_Component) {
  _inherits(historyAction, _Component);

  function historyAction() {
    _classCallCheck(this, historyAction);

    return _possibleConstructorReturn(this, (historyAction.__proto__ || Object.getPrototypeOf(historyAction)).apply(this, arguments));
  }

  _createClass(historyAction, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          attachments = _props.attachments,
          bodyJson = _props.bodyJson,
          contractId = _props.contractId,
          participant = _props.participant,
          text = _props.text,
          timestamp = _props.timestamp,
          classes = _props.classes,
          isSender = _props.isSender,
          type = _props.type;

      var contractName = bodyJson && bodyJson.contractName ? bodyJson.contractName : '';
      var subTitle = bodyJson && bodyJson.subject !== text ? bodyJson.subject : '';
      var subSubject = bodyJson && bodyJson.messageSubject !== text ? bodyJson.messageSubject : '';
      // if (bodyJson && bodyJson.fromEmail && bodyJson.msgId) { // message from an email with a file

      // }
      var htmlText = null;
      if (bodyJson) {
        if (type === 'email' && bodyJson.html) {
          htmlText = bodyJson.html;
        } else if (!text && bodyJson.message) {
          htmlText = bodyJson.message;
        }
      }
      if (text.indexOf('<p') > -1) {
        htmlText = text;
      }
      return _react2.default.createElement(
        _messageWrapper2.default,
        {
          avatarInfo: {
            name: participant.name,
            avatarUrl: participant.avatar || participant.profileImageUrl
          },
          timestamp: new Date(timestamp || new Date()).toString(),
          isSender: isSender
        },
        subTitle ? _react2.default.createElement(
          'div',
          { className: classes.subTitle },
          subTitle
        ) : null,
        subSubject ? _react2.default.createElement(
          'div',
          { className: classes.subTitle },
          subSubject
        ) : null,
        !htmlText ? _react2.default.createElement(
          'div',
          { className: classes.textBody },
          text
        ) : null,
        htmlText ? _react2.default.createElement('div', {
          className: 'message-div ' + classes.HTMLMessage,
          dangerouslySetInnerHTML: { __html: htmlText }
        }) : null,
        contractId ? _react2.default.createElement(_activityWithIcon2.default
        /*            diff
                    amendment
                    editHistory={[]}*/
        , _extends({ lastestContractId: contractId
          /*            importedFields*/
        }, bodyJson && bodyJson.statusChanged ? { statusChanged: bodyJson.statusChanged } : {})) : null,
        (attachments || []).map(function (file, ix) {
          return _react2.default.createElement(_activityWithIcon2.default, {
            className: classes.fileAttachment,
            file: file,
            key: ix
          });
        }),
        contractId ? _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'flex-end' } },
          _react2.default.createElement(
            'div',
            { className: classes.contractName },
            contractName
          ),
          _react2.default.createElement(_materialUi.IconButton, {
            iconClassName: 'tc-icon-question_answer ' + classes.iconColor,
            tooltip: 'Contract Activities',
            onTouchTap: function onTouchTap() {
              return _this2.props.routerPush('/contracting/contract/' + contractId + '/activities');
            },
            className: classes.button
          }),
          _react2.default.createElement(_materialUi.IconButton, {
            iconClassName: 'tc-icon-insert-drive-file ' + classes.iconColor,
            tooltip: 'View Contract',
            onTouchTap: function onTouchTap() {
              return _this2.props.routerPush('/contracting/contract/' + contractId + '/details');
            },
            className: classes.button
          })
        ) : null
      );
    }
  }]);

  return historyAction;
}(_react.Component);

historyAction.defaultProps = {
  attachments: [],
  routerPush: function routerPush(location) {
    console.log(location);
  }
};
historyAction.propTypes = {
  attachments: _react.PropTypes.array,
  bodyJson: _react.PropTypes.object,
  classes: _react.PropTypes.object,
  contractId: _react.PropTypes.string,
  isSender: _react.PropTypes.bool,
  participant: _react.PropTypes.object,
  routerPush: _react.PropTypes.func,
  text: _react.PropTypes.string,
  timestamp: _react.PropTypes.number,
  type: _react.PropTypes.string
};

exports.default = (0, _reactJss2.default)(styles)(historyAction);

/***/ }),
/* 3584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _commentBox = __webpack_require__(1112);

var _commentBox2 = _interopRequireDefault(_commentBox);

var _actions = __webpack_require__(476);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  commentBox: {
    backgroundColor: 'white',
    marginBottom: '3px'
  }
};

var Comment = function (_Component) {
  _inherits(Comment, _Component);

  function Comment(props) {
    _classCallCheck(this, Comment);

    var _this = _possibleConstructorReturn(this, (Comment.__proto__ || Object.getPrototypeOf(Comment)).call(this, props));

    _this.handleComment = function (input) {
      _this.setState({ currentComment: input });
    };

    _this.handleCancel = function () {
      _this.setState({ currentComment: '', attachedFiles: [] });
      _this.setState({ disableSend: false });
      _this.clearInput();
    };

    _this.submitComment = function () {
      _this.setState({ disableSend: true }, function () {
        _this.props.sendMessage({
          messageText: _this.state.currentComment,
          files: _this.state.attachedFiles
        });
      });
    };

    _this.handleAttachFile = function (fileList) {
      _this.setState({ attachedFiles: fileList });
    };

    _this.defaultState = { // don't include object in values
      currentComment: '',
      disableSend: false,
      attachedFiles: []
    };
    _this.state = _extends({}, _this.defaultState);
    return _this;
  }

  _createClass(Comment, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.messageCreating && !this.state.disableSend) {
        // sending to server
        this.setState({ disableSend: true });
      }
      if (!newProps.messageCreating && this.state.disableSend) {
        // message has been sent !
        this.setState({ disableSend: false });
        if (!newProps.messageCreateError) {
          // and no error, wow
          this.setState(this.defaultState);
          this.clearInput();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_commentBox2.default, _extends({
        comment: this.state.currentComment,
        handleInput: this.handleComment,
        attachFile: this.handleAttachFile,
        attachedFiles: this.state.attachedFiles,
        submitComment: this.submitComment,
        cancelComment: this.handleCancel,
        disableSend: this.state.disableSend,
        className: this.props.classes.commentBox,
        setClear: function setClear(clear) {
          return _this2.clearInput = clear;
        }
      }, this.props.internal ? { internal: true } : {}));
    }
  }]);

  return Comment;
}(_react.Component);

Comment.propTypes = {
  selectedChannel: _react.PropTypes.string,
  sendMessage: _react.PropTypes.func,
  messageCreating: _react.PropTypes.bool,
  messageCreateError: _react.PropTypes.bool,
  classes: _react.PropTypes.object,
  internal: _react.PropTypes.bool
};

Comment.defaultProps = {
  internal: false
};

var select = function select(state) {
  return {
    selectedChannel: state.workspace.selectedChannel,
    messageCreating: state.workspace.messageCreating,
    messageCreateError: state.workspace.messageCreateError
  };
};

exports.default = (0, _reactRedux.connect)(select, { sendMessage: _actions.sendMessage })((0, _reactJss2.default)(styles)(Comment));

/***/ }),
/* 3585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(55);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _leftNav = __webpack_require__(3586);

var _reactRouterRedux = __webpack_require__(27);

var _actions = __webpack_require__(476);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = _extends({}, _leftNav.defaultStyle, {
  container: {
    display: 'flex',
    minHeight: '48px !important',
    backgroundColor: 'rgb(0, 179, 207)',
    alignItems: 'center',
    '&.loading': {
      cursor: 'wait'
    }
  },
  channelsTitle: {
    color: 'white',
    fontSize: '18px',
    flex: '1 0 auto',
    lineHeight: '48px',
    paddingLeft: '10px'
  },
  channel: {
    color: 'white !important',
    flex: '0 0 auto',
    minWidth: '68px !important',
    '&.disabled': {
      backgroundColor: 'rgb(0, 161, 186) !important'
    },
    '&.unread > div > span': {
      fontWeight: 'bolder !important'
    },
    marginRight: '20px !important'
  },
  popIconMenu: {
    height: '25px !important',
    width: '25px !important',
    '& div > svg': {
      width: '18px !important',
      height: '28px !important',
      marginTop: '-17px'
    }
  }
});

var ChannelList = function (_Component) {
  _inherits(ChannelList, _Component);

  function ChannelList(props) {
    _classCallCheck(this, ChannelList);

    var _this = _possibleConstructorReturn(this, (ChannelList.__proto__ || Object.getPrototypeOf(ChannelList)).call(this, props));

    _this.timer = null;

    _this.timedUpdate = function () {
      if (!localStorage.stopAutoReload && !_this.props.channelsFetching) _this.props.getChannels();
    };

    _this.state = {};
    return _this;
  }

  _createClass(ChannelList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.timer) this.timer = setInterval(this.timedUpdate, 4e3);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          channelsFetching = _props.channelsFetching,
          channels = _props.channels,
          channelsTitle = _props.channelsTitle,
          companyName = _props.companyName,
          selectedChannel = _props.selectedChannel,
          selectedConnection = _props.selectedConnection,
          selectedContract = _props.selectedContract,
          classes = _props.classes;

      var selectedItem = selectedChannel + (selectedContract ? ':' + selectedContract : '');

      return selectedConnection ? _react2.default.createElement(
        'div',
        { className: classes.container + ' ' + (channelsFetching ? ' loading' : '') },
        _react2.default.createElement(
          'div',
          { className: classes.channelsTitle },
          channelsTitle
        )
      )
      // Empty Connectionless content
      : _react2.default.createElement(
        'div',
        { className: classes.container },
        _react2.default.createElement(
          'div',
          { className: '' + classes.channelsTitle },
          'Select a Channel'
        )
      );
    }
  }]);

  return ChannelList;
}(_react.Component);

ChannelList.defaultProps = {
  channelsTitle: ''
};
ChannelList.propTypes = {
  archiveConversation: _propTypes2.default.func,
  channels: _propTypes2.default.array,
  channelsFetching: _propTypes2.default.bool,
  channelsTitle: _propTypes2.default.string,
  routerPush: _propTypes2.default.func,
  selectedContract: _propTypes2.default.string,
  selectedChannel: _propTypes2.default.string,
  selectedConnection: _propTypes2.default.string,
  classes: _propTypes2.default.object,
  getChannels: _propTypes2.default.func,
  companyName: _propTypes2.default.string,
  className: _propTypes2.default.string
};

var select = function select(state) {
  return {
    channels: state.workspace.channels,
    channelsFetching: state.workspace.channelsFetching,
    channelsTitle: state.workspace.channelsTitle,
    selectedChannel: state.workspace.selectedChannel,
    selectedConnection: state.workspace.selectedConnection,
    selectedContract: state.workspace.selectedContract,
    companyName: state.user.getIn(['company', 'companyName'])
  };
};
exports.default = (0, _reactRedux.connect)(select, {
  routerPush: _reactRouterRedux.push,
  archiveConversation: _actions.archiveConversation,
  getChannels: _actions.getChannels
})((0, _reactJss2.default)(styles)(ChannelList));

/***/ }),
/* 3586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStyle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultStyle = exports.defaultStyle = {
  workspaceLeftnavContent: {
    overflowY: 'scroll',
    overflowX: 'none',
    '& .flex-tc-sb': {
      padding: '0 16px'
    },
    '&::-webkit-scrollbar': {
      width: '0 !important'
    },
    '-ms-overflow-style': 'none'
  },
  slimProgress: {
    height: '1px !important',
    position: 'absolute !important'
  },
  workspaceMenuItem: {
    fontSize: '0.9em !important',
    lineHeight: '20px !important',
    minHeight: '20px !important'
  },
  leftNavClass: {
    marginTop: '0 !important',
    backgroundColor: 'rgb(240, 240, 240)',
    color: '#757575 !important' // #00bcd4 < -- selected
  },
  workspaceConnectionList: {
    padding: '0 !important',
    '& div > span': {
      height: '58px'
    }
  }
};

function wrapState(ComposedComponent) {
  var SelectableListClass = function (_Component) {
    _inherits(SelectableListClass, _Component);

    function SelectableListClass() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, SelectableListClass);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectableListClass.__proto__ || Object.getPrototypeOf(SelectableListClass)).call.apply(_ref, [this].concat(args))), _this), _this.handleRequestChange = function (event, index) {
        _this.setState({
          selectedIndex: index
        }, function () {
          if (_this.props.selectAction) {
            _this.props.selectAction(_this.state.selectedIndex);
          }
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SelectableListClass, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.setState({
          selectedIndex: this.props.defaultValue
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(newProps) {
        if (this.props.defaultValue !== newProps.defaultValue) {
          this.setState({
            selectedIndex: newProps.defaultValue
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'div',
          { className: this.props.className + ' ' + this.props.classes.leftNavClass },
          _react2.default.createElement(
            'div',
            { className: 'workspace-leftnav-content ' + this.props.classes.workspaceLeftnavContent },
            _react2.default.createElement(
              ComposedComponent,
              {
                value: this.state.selectedIndex,
                onChange: this.handleRequestChange,
                className: this.props.classes.workspaceConnectionList
              },
              this.props.children
            )
          )
        );
      }
    }]);

    return SelectableListClass;
  }(_react.Component);

  SelectableListClass.propTypes = {
    children: _react.PropTypes.node.isRequired,
    defaultValue: _react.PropTypes.number.isRequired
  };

  SelectableListClass.propTypes = {
    children: _react.PropTypes.any,
    className: _react.PropTypes.string,
    classes: _react.PropTypes.object,
    selectAction: _react.PropTypes.func
  };

  return SelectableListClass;
}

exports.default = wrapState((0, _materialUi.makeSelectable)(_materialUi.List));

/***/ }),
/* 3587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(27);

var _workspace_placeholder = __webpack_require__(3588);

var _workspace_placeholder2 = _interopRequireDefault(_workspace_placeholder);

var _actions = __webpack_require__(476);

var _actions2 = __webpack_require__(1111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& div': {
      textAlign: 'center'
    }
  },
  startConversation: {
    marginTop: '10px',
    '& > div': {
      margin: '20px'
    }
  },
  title: {
    fontSize: '16px',
    color: 'rgba(0,0,0,0.54)'
  },
  placeHolderImage: {
    minHeight: '375px'
  }
};

var Placeholder = function (_Component) {
  _inherits(Placeholder, _Component);

  function Placeholder() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Placeholder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Placeholder.__proto__ || Object.getPrototypeOf(Placeholder)).call.apply(_ref, [this].concat(args))), _this), _this.timer = null, _this.timedUpdate = function () {
      if (!localStorage.stopAutoReload && !_this.props.connectionsFetching) _this.props.getConnections();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Placeholder, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.timer) this.timer = setInterval(this.timedUpdate, 4e3);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classes = this.props.classes;

      return _react2.default.createElement(
        'div',
        { className: classes.container + ' l-app-content' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('img', { src: _workspace_placeholder2.default, className: classes.placeHolderImage })
          ),
          _react2.default.createElement(
            'div',
            { className: classes.title },
            'Welcome to the Messaging Workspace',
            _react2.default.createElement('br', null),
            'Here, you can chat with your partners, or respond to contract-related messages.'
          ),
          _react2.default.createElement(
            'div',
            { className: classes.startConversation },
            _react2.default.createElement(_materialUi.RaisedButton, {
              label: 'Compose a new Message',
              secondary: true,
              buttonStyle: { zIndex: 'inherited' },
              onTouchTap: function onTouchTap() {
                _this2.props.openMassDialog();
              }
            })
          )
        )
      );
    }
  }]);

  return Placeholder;
}(_react.Component);

Placeholder.propTypes = {
  connectionsFetching: _react.PropTypes.bool,
  classes: _react.PropTypes.object,
  getConnections: _react.PropTypes.func,
  routerPush: _react.PropTypes.func,
  openMassDialog: _react.PropTypes.func
};

var select = function select(state) {
  return {
    connectionsFetching: state.workspace.connectionsFetching
  };
};

exports.default = (0, _reactRedux.connect)(select, { routerPush: _reactRouterRedux.push, getConnections: _actions.getConnections, openMassDialog: _actions2.openModal })((0, _reactJss2.default)(styles)(Placeholder));

/***/ }),
/* 3588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7835aa7355d627e8224031f8845db755.svg";

/***/ }),
/* 3589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _List = __webpack_require__(1790);

var _reactRedux = __webpack_require__(6);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRouterRedux = __webpack_require__(27);

var _actions = __webpack_require__(476);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectableList = (0, _List.makeSelectable)(_List.List);

var styles = {
  main: {
    width: '334px',
    height: '100%',
    overflowVertical: 'auto'
  },
  semitransparent: {
    opacity: '0.8'
  },
  list: {
    padding: '0px !important'
  },
  listItem: {
    fontSize: '14px !important',
    borderBottom: '1px solid rgb(224, 224, 224) !important',
    '&>div>div': {
      padding: '10px 10px 10px !important'
    }
  },
  secondaryText: {
    fontSize: '11px !important'
  },
  channelsTitle: {
    color: 'white',
    fontSize: '18px',
    flex: '1 0 auto',
    lineHeight: '48px',
    paddingLeft: '10px',
    backgroundColor: 'rgb(0, 179, 207)',
    height: '48px'
  }
};

var massMessagingList = function (_React$Component) {
  _inherits(massMessagingList, _React$Component);

  function massMessagingList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, massMessagingList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = massMessagingList.__proto__ || Object.getPrototypeOf(massMessagingList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      searchTxt: ''
    }, _this.handleChange = function (event, index) {
      if (!_this.props.conversationsFetching) {
        // do not allow a new selection if something is being loaded
        _this.props.routerPush('/workspace/bulkmessages/' + index);
      } else {
        return false;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(massMessagingList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          channels = _props.channels,
          selectedChannel = _props.selectedChannel,
          conversationsFetching = _props.conversationsFetching;

      var channelsFormated = channels.map(function (channel) {
        var retVal = {};
        if ((0, _moment2.default)().startOf('day').diff((0, _moment2.default)(channel.sentAt || channel.createdAt), 'days') < 1) {
          retVal.sentAtFormatted = (0, _moment2.default)(channel.sentAt || channel.createdAt).format('[Today at] h:ma');
        } else {
          retVal.sentAtFormatted = (0, _moment2.default)(channel.sentAt || channel.createdAt).format('MMM DD YYYY [at] ha');
        }
        return _extends(channel, retVal);
      });
      return _react2.default.createElement(
        'div',
        { className: classes.main },
        _react2.default.createElement(
          'div',
          { className: classes.channelsTitle },
          'Bulk Message Center ',
          _react2.default.createElement(
            'small',
            null,
            '(Beta)'
          )
        ),
        _react2.default.createElement(
          SelectableList,
          { selectedItemStyle: { backgroundColor: 'rgba(0, 0, 0, 0.1)' }, value: selectedChannel, onChange: this.handleChange, className: '' + classes.list + (conversationsFetching ? ' ' + classes.semitransparent : '') },
          channelsFormated.map(function (channel) {
            return _react2.default.createElement(_List.ListItem, {
              className: classes.listItem,
              value: channel.channelId,
              key: channel.channelId,
              primaryText: channel.channelName,
              secondaryText: channel.sentBy ? _react2.default.createElement(
                'div',
                { className: classes.secondaryText },
                'Sent ',
                channel.sentAtFormatted,
                ' by ',
                channel.sentBy.name || channel.sentBy.email,
                ' to ',
                channel.recipients.length,
                ' ',
                (0, _pluralize2.default)('Partner', channel.recipients.length)
              ) : undefined,
              secondaryTextLines: 1
            });
          })
        )
      );
    }
  }]);

  return massMessagingList;
}(_react2.default.Component);

massMessagingList.propTypes = {
  channels: _react.PropTypes.array,
  classes: _react.PropTypes.object,
  conversationsFetching: _react.PropTypes.bool,
  handleConfirm: _react.PropTypes.func,
  howMany: _react.PropTypes.number,
  routerPush: _react.PropTypes.func,
  selectChannel: _react.PropTypes.func,
  selectedChannel: _react.PropTypes.string
};

massMessagingList.defaultProps = {
  handleConfirm: function handleConfirm() {
    console.log('confirmed');
  },
  howMany: 0
};

var select = function select(state) {
  return {
    channels: state.workspace.channels,
    selectedChannel: state.workspace.selectedChannel,
    conversationsFetching: state.workspace.conversationsFetching
  };
};

exports.default = (0, _reactRedux.connect)(select, {
  selectChannel: _actions.selectChannel,
  routerPush: _reactRouterRedux.push
})((0, _reactJss2.default)(styles)(massMessagingList));

/***/ }),
/* 3590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _materialUi = __webpack_require__(3);

var _TextField = __webpack_require__(626);

var _TextField2 = _interopRequireDefault(_TextField);

var _Card = __webpack_require__(1776);

var _timelapse = __webpack_require__(3591);

var _timelapse2 = _interopRequireDefault(_timelapse);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _Chip = __webpack_require__(1783);

var _Chip2 = _interopRequireDefault(_Chip);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _bodyCss = __webpack_require__(3592);

var _bodyCss2 = _interopRequireDefault(_bodyCss);

var _pagination = __webpack_require__(870);

var _pagination2 = _interopRequireDefault(_pagination);

var _api = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var eventPriority = {
  null: -1,
  processing: 0,
  redirected: 0,
  processed: 1,
  deferred: 2,
  dropped: 3,
  bounced: 4,
  delivered: 5,
  open: 6,
  click: 7
};

var massMessagingBody = function (_React$Component) {
  _inherits(massMessagingBody, _React$Component);

  function massMessagingBody() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, massMessagingBody);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = massMessagingBody.__proto__ || Object.getPrototypeOf(massMessagingBody)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      partnerFilter: '',
      currentPage: 1
    }, _this.switchPage = function (newPage) {
      _this.setState({ currentPage: newPage });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(massMessagingBody, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var retVal = this.state.partnerFilter !== nextState.partnerFilter || this.state.currentPage !== nextState.currentPage || this.props.conversationsFetching !== nextProps.conversationsFetching; // stops the flickering while switching bulkMessage
      return retVal;
    }
  }, {
    key: '_updateValue',
    value: function _updateValue(type) {
      this.setState(_defineProperty({}, type, this.refs[type].getValue()));
    }
  }, {
    key: '_handleFileClick',
    value: function _handleFileClick(path) {
      window.open(_api.fileUrls.getDownloadUrlSync(path));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          partnerFilter = _state.partnerFilter,
          currentPage = _state.currentPage;
      var _props = this.props,
          classes = _props.classes,
          title = _props.title,
          bulkMessage = _props.bulkMessage,
          conversationsFetching = _props.conversationsFetching,
          selectedChannel = _props.selectedChannel;
      var recipients = bulkMessage.recipients,
          stats = bulkMessage.stats,
          subject = bulkMessage.subject,
          body = bulkMessage.body,
          _bulkMessage$attachme = bulkMessage.attachments,
          attachments = _bulkMessage$attachme === undefined ? [] : _bulkMessage$attachme;

      var sentData = null;
      if (bulkMessage.sentAt) {
        sentData = 'Sent on ' + (0, _moment2.default)(bulkMessage.sentAt).format('MMM DD YYYY [at] h:mma');
        if (bulkMessage.sentBy) {
          var sentBy = bulkMessage.sentBy;

          var author = sentBy.name || sentBy.email;
          sentData += ' by ' + author;
        }
      }
      var recipientsFormatted = (recipients || []).map(function (e) {
        // build searchable text fields
        var contactReduced = (e.to || []).reduce(function (prev, curr) {
          return prev + ' ' + (curr.firstName || '') + ' ' + (curr.last_name || '');
        }, '');
        return _extends({}, e, { searchText: (e.partnerName + ' ' + contactReduced).replace(/ {2}/g, ' ') });
      }).filter(function (e) {
        // search using a broad match consider spaces as wildcards
        if (partnerFilter.trim().length < 1) return true;
        return new RegExp('^.*' + partnerFilter.split(' ').join('.*') + '.*$', 'gi').test(e.searchText);
      }).map(function (recipient) {
        var retVal = {
          avatarText: recipient.partnerAvatar ? undefined : (recipient.partnerName || recipient.email)[0].toUpperCase(),
          to: recipient.to || []
        };
        return _extends({}, recipient, retVal); // extend the object with changes
      });
      var icons = {
        'open': function open(className) {
          return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-email-open-outline ' + (classes[className] || '') });
        },
        'click': function click(className) {
          return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-checkbox-marked-circle ' + (classes[className] || '') });
        },
        'delivered': function delivered(className) {
          return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-email-outline ' + (classes[className] || '') });
        },
        'redirected': function redirected(className) {
          return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-email ' + (classes[className] || '') });
        },
        'bounce': function bounce(className) {
          return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-error ' + (classes[className] || '') });
        },
        'bounced': function bounced(className) {
          return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-error ' + (classes[className] || '') });
        },
        'dropped': function dropped(className) {
          return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-error ' + (classes[className] || '') });
        },
        'spam report': function spamReport(className) {
          return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-error ' + (classes[className] || '') });
        },
        'processed': function processed(className) {
          return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-paperplane ' + (classes[className] || '') });
        },
        'deferred': function deferred(className) {
          return _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-paperplane ' + (classes[className] || '') });
        },
        'processing': function processing(className) {
          return _react2.default.createElement(_timelapse2.default, { style: _extends({}, _bodyCss.styles[className], { width: _bodyCss.styles[className].svgSize, height: _bodyCss.styles[className].svgSize }) });
        },
        'notified in system': function notifiedInSystem(className) {
          return _react2.default.createElement(_timelapse2.default, { style: _extends({}, _bodyCss.styles[className], { width: _bodyCss.styles[className].svgSize, height: _bodyCss.styles[className].svgSize }) });
        }
      };
      // fontSize: classes..fontSize
      var txtReplace = {
        'open': 'opened',
        'click': 'clicked'
      };
      var onClickResend = function onClickResend() {
        return _this2.props.resendBulkMessage({
          bulkMessageId: bulkMessage.bulkMessageId,
          companyId: bulkMessage.owner
        });
      };
      return _react2.default.createElement(
        'div',
        { className: classes.main },
        _react2.default.createElement(
          'div',
          { className: classes.title },
          title,
          '\xA0'
        ),
        _react2.default.createElement(
          'div',
          { className: '' + classes.body + (conversationsFetching ? ' ' + classes.semitransparent : '') + (selectedChannel ? '' : ' ' + classes.hidden) },
          _react2.default.createElement(
            'div',
            { className: classes.sentData },
            sentData ? _react2.default.createElement(
              'span',
              null,
              sentData
            ) : _react2.default.createElement(
              'span',
              null,
              'Not sent yet'
            ),
            Boolean(this.props.isAnAdmin) && _react2.default.createElement(_materialUi.FlatButton, {
              primary: true,
              label: 'Resend (Admin Only)',
              onTouchTap: onClickResend,
              size: 'small'
            })
          ),
          _react2.default.createElement(
            _Card.Card,
            { className: classes.firstCard },
            _react2.default.createElement(_Card.CardHeader, {
              className: classes.headerContainer,
              title: _react2.default.createElement(
                'div',
                { className: classes.cardHeader },
                _react2.default.createElement(
                  'div',
                  { className: classes.flexItem },
                  _react2.default.createElement(
                    'div',
                    { style: { paddingLeft: '48px' } },
                    recipients.length,
                    ' ',
                    (0, _pluralize2.default)('Partner', recipients.length)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: classes.flexItem + ' centerText' },
                  parseInt((stats || {}).opens || 0, 10),
                  '% opened'
                ),
                _react2.default.createElement(
                  'div',
                  { className: classes.flexItem + ' ' + classes.messageRowDelivered },
                  parseInt((stats || {}).delivered || 0, 10),
                  '% delivered'
                )
              ),
              actAsExpander: true,
              showExpandableButton: true
            }),
            _react2.default.createElement(
              _Card.CardText,
              { expandable: true, className: classes.cardText },
              _react2.default.createElement(_TextField2.default, {
                hintText: 'Search for a partner',
                ref: 'partnerFilter',
                onChange: this._updateValue.bind(this, 'partnerFilter'),
                fullWidth: true,
                className: classes.searchBox,
                underlineShow: false,
                hintStyle: { marginLeft: '10px', fontSize: '12px' },
                inputStyle: {
                  border: '1px solid #00bcd4',
                  bottom: '-10px',
                  height: '28px',
                  paddingLeft: '10px',
                  fontSize: '12px'
                }
              }),
              recipientsFormatted.slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5).map(function (e) {
                var maxEventTxt = txtReplace[e.maxEvent] || e.maxEvent;
                return _extends({}, e, {
                  maxEventTxt: '' + maxEventTxt.charAt(0).toUpperCase() + maxEventTxt.substr(1)
                });
              }).map(function (partner, i) {
                return _react2.default.createElement(
                  _Card.Card,
                  { key: partner.partnerName + '-' + (i + (currentPage - 1) * 5) },
                  _react2.default.createElement(_Card.CardHeader, {
                    className: classes.headerContainer,
                    title: _react2.default.createElement(
                      'div',
                      { className: classes.partnerRow },
                      _react2.default.createElement(
                        'div',
                        { className: '' + classes.partnerRowPartnerInfo },
                        _react2.default.createElement(
                          _materialUi.Avatar,
                          partner.partnerAvatar ? { src: partner.partnerAvatar } : {},
                          partner.avatarText
                        ),
                        partner.partnerId ? _react2.default.createElement(
                          'a',
                          {
                            className: classes.partnerRowCompanyName,
                            target: '_blank',
                            href: "https://app.tourconnect.com" + '/partner-management/partner-details/' + partner.partnerId + '?jwt=' + localStorage.getItem('jwt')
                          },
                          partner.partnerName
                        ) : _react2.default.createElement(
                          'div',
                          {
                            className: classes.partnerRowCompanyName
                          },
                          partner.partnerName
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: classes.partnerRowStatus + ' centerText' },
                        _react2.default.createElement(
                          'div',
                          null,
                          icons[partner.maxEvent]('partnerRowStatusIcon') || undefined
                        ),
                        _react2.default.createElement(
                          'div',
                          null,
                          partner.maxEventTxt
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: '' + classes.partnerRowcontacts },
                        partner.to.length,
                        ' ',
                        (0, _pluralize2.default)('contact', partner.to.length)
                      )
                    ),
                    showExpandableButton: true
                  }),
                  _react2.default.createElement(
                    _Card.CardText,
                    { expandable: true, className: classes.cardText },
                    _react2.default.createElement(
                      'div',
                      { style: { marginRight: '158px' } },
                      partner.to.map(function (contact) {
                        var maxEventTxt = txtReplace[contact.maxEvent] || contact.maxEvent;
                        return _extends({}, contact, {
                          displayName: contact.email,
                          maxEventTxt: '' + maxEventTxt.charAt(0).toUpperCase() + maxEventTxt.substr(1)
                        });
                      }).map(function (contact, contacti) {
                        return _react2.default.createElement(
                          'div',
                          { key: contacti, style: { display: 'flex', flexWrap: 'nowrap' } },
                          _react2.default.createElement(
                            'div',
                            { style: { marginLeft: '52px', width: '350px' } },
                            contact.displayName
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'centerText', style: { marginLeft: '24px' } },
                            icons[contact.maxEvent]('userRowStatusIcon') || undefined,
                            contact.maxEventTxt
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: classes.flexItem },
                            '\xA0'
                          )
                        );
                      })
                    ),
                    eventPriority[partner.maxEventFromDirectRecipient] <= 4 && eventPriority[partner.maxEvent] > 4 && _react2.default.createElement(
                      'div',
                      { style: { marginTop: '24px', marginLeft: '48px', fontSize: '12px', fontStyle: 'italic' } },
                      'Note: some of the contacts for this partners have TourConnect account(s) and this message has been redirected to other users from the same account as notifications.'
                    )
                  )
                );
              }),
              recipientsFormatted.length > 5 ? _react2.default.createElement(_pagination2.default, {
                currentPage: currentPage,
                totalPages: Math.ceil(recipientsFormatted.length / 5),
                goToPage: this.switchPage,
                noOfPagesToShow: 5
              }) : undefined
            )
          ),
          _react2.default.createElement(
            _Card.Card,
            null,
            _react2.default.createElement(_Card.CardHeader, {
              className: classes.headerContainer,
              title: _react2.default.createElement(
                'div',
                { className: classes.cardHeader },
                _react2.default.createElement(
                  'div',
                  { className: classes.titleStart },
                  _react2.default.createElement(
                    'div',
                    null,
                    'Subject & Content'
                  )
                )
              ),
              actAsExpander: true,
              showExpandableButton: true
            }),
            _react2.default.createElement(
              _Card.CardText,
              { expandable: true, className: classes.cardTextMessage },
              _react2.default.createElement(
                'p',
                { className: classes.cardTextTitle },
                subject
              ),
              _react2.default.createElement('p', { className: 'message-div ' + classes.messageBody, dangerouslySetInnerHTML: { __html: body } }),
              _react2.default.createElement(
                'div',
                { className: classes.fileAttachment },
                attachments.filter(function (file) {
                  return file.source !== 'template' && file.source !== 'request';
                }).map(function (file, i) {
                  return _react2.default.createElement(
                    _Chip2.default,
                    _defineProperty({
                      key: i,
                      onTouchTap: function onTouchTap() {
                        _this2._handleFileClick(file.path);
                      },
                      className: classes.chip
                    }, 'key', file.name),
                    _react2.default.createElement(_materialUi.Avatar, { color: '#616061', icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-attach_file ' + classes.attachmentIcon }) }),
                    file.name
                  );
                }),
                attachments.filter(function (file) {
                  return file.source === 'request';
                }).map(function (request, i) {
                  return _react2.default.createElement(
                    _Chip2.default,
                    { key: i },
                    request.startDate ? _moment2.default.utc(request.startDate).format('MMM DDD YYYY') + '-' + _moment2.default.utc(request.startDate).format('MMM DDD YYYY') + ' Rate Request' : request.fallbackName
                  );
                }),
                attachments.filter(function (file) {
                  return file.source === 'template';
                }).map(function (template, i) {
                  return _react2.default.createElement(
                    _Chip2.default,
                    { key: i },
                    template.locationName ? template.locationName + '-' + template.templateName : template.templateName
                  );
                })
              )
            )
          ),
          _react2.default.createElement(_loadingOverlay2.default, {
            loading: conversationsFetching,
            style: {
              position: 'absolute',
              backgroundColor: 'rgba(0, 0, 0, 0.4)'
            }
          })
        )
      );
    }
  }]);

  return massMessagingBody;
}(_react2.default.Component);

massMessagingBody.propTypes = {
  bulkMessage: _react.PropTypes.object,
  classes: _react.PropTypes.object,
  conversationsFetching: _react.PropTypes.bool,
  handleConfirm: _react.PropTypes.func,
  howMany: _react.PropTypes.number,
  title: _react.PropTypes.string,
  selectedChannel: _react.PropTypes.string,
  resendBulkMessage: _react.PropTypes.func
};

massMessagingBody.defaultProps = {
  handleConfirm: function handleConfirm() {
    console.log('confirmed');
  },
  howMany: 0,
  bulkMessage: { recipients: [], title: ' ' }
};

var select = function select(state) {
  return {
    bulkMessage: state.workspace.conversations[0],
    title: state.workspace.conversationsTitle,
    conversationsFetching: state.workspace.conversationsFetching,
    selectedChannel: state.workspace.selectedChannel,
    isAnAdmin: state.user.get('isAnAdmin')
  };
};

exports.default = (0, _reactRedux.connect)(select, {
  routerPush: _reactRouterRedux.push,
  resendBulkMessage: function resendBulkMessage(payload) {
    return { type: 'ADMIN_RESEND_BULK_MESSAGE', payload: payload };
  }
})((0, _bodyCss2.default)(massMessagingBody));

/***/ }),
/* 3591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(12);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(11);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageTimelapse = function ImageTimelapse(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
  );
};
ImageTimelapse = (0, _pure2.default)(ImageTimelapse);
ImageTimelapse.displayName = 'ImageTimelapse';
ImageTimelapse.muiName = 'SvgIcon';

exports.default = ImageTimelapse;

/***/ }),
/* 3592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  main: {
    width: 'calc(100% - 628px)', // 294+334
    backgroundColor: 'rgb(250, 250, 250)'
  },
  semitransparent: {
    opacity: '0.5'
  },
  hidden: {
    display: 'none'
  },
  title: {
    color: 'white',
    fontSize: '18px',
    width: '100%',
    lineHeight: '48px',
    paddingLeft: '10px',
    backgroundColor: 'rgb(0, 161, 186)'
  },
  body: {
    padding: '13px',
    height: 'calc(100% - 48px)',
    overflowY: 'auto',
    position: 'relative'
  },
  sentData: {
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  firstCard: {
    marginBottom: '20px'
  },
  flexItem: {
    flexGrow: 1,
    flexBasis: 0,
    // minWidth: '250px',
    // maxWidth: '250px',
    '&.centerText': {
      textAlign: 'center'
    }
  },
  headerIcon: {
    color: 'rgb(0, 179, 207) !important',
    lineHeight: '20px',
    marginRight: '12px'
  },
  headerContainer: {
    color: '#616061 !important',
    '&>div': {
      width: '100%'
    }
  },
  cardHeader: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    color: '#616061 !important',
    margin: '0 0 0 16px'
  },
  cardText: {
    color: '#616061 !important'
  },
  cardTextMessage: {
    color: '#616061 !important',
    padding: '0 60px 16px 60px !important',
    '&>p': {
      color: '#616061 !important',
      fontSize: '13px !important'
    }
  },
  cardTextTitle: {
    borderBottom: '1px solid #dadada',
    paddingBottom: '6px',
    marginBottom: '0'
  },
  titleStart: {
    display: 'flex',
    flexWrap: 'nowrap'
  },
  messageRowDelivered: {
    textAlign: 'right',
    paddingRight: '30px'
  },
  partnerRow: {
    display: 'flex',
    flexWrap: 'nowrap',
    color: '#616061 !important'
  },
  partnerRowPartnerInfo: {
    display: 'flex',
    flexWrap: 'nowrap'
  },
  partnerRowCompanyName: {
    lineHeight: '40px',
    marginLeft: '12px',
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'noWrap',
    width: '350px'
  },
  partnerRowcontacts: {
    lineHeight: '40px',
    textAlign: 'right',
    marginLeft: '24px'
  },
  partnerRowStatus: {
    display: 'flex',
    flexWrap: 'nowrap',
    lineHeight: '40px',
    justifyContent: 'center',
    marginLeft: '24px'
  },
  partnerRowStatusIcon: {
    marginTop: '12px',
    marginRight: '6px',
    fontSize: '17px !important',
    svgSize: 17
  },
  userRowStatusIcon: {
    marginTop: '0',
    marginRight: '4px',
    fontSize: '12px !important',
    svgSize: 12
  },
  tableBody: {
    '&>tr>td': {
      color: '#616061 !important'
    }
  },
  serchBox: {
    height: '35px'
  },
  messageBody: {
    marginTop: '12px',
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: '1em',
    overflowX: 'hidden',
    whiteSpace: 'pre-wrap',
    width: '100%'
  },
  fileAttachment: {
    marginTop: '16px',
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: '4px !important',
    '&>span': {
      color: '#616061 !important',
      fontSize: '13px !important'
    }
  },
  attachmentIcon: {
    fontSize: '19px !important'
  }
};

exports.default = function (component) {
  return (0, _reactJss2.default)(styles)(component);
};

/***/ }),
/* 3593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _container = __webpack_require__(3594);

var _container2 = _interopRequireDefault(_container);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _actions = __webpack_require__(3596);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssetsConsolidationRouter = function (_Component) {
  _inherits(AssetsConsolidationRouter, _Component);

  function AssetsConsolidationRouter() {
    _classCallCheck(this, AssetsConsolidationRouter);

    return _possibleConstructorReturn(this, (AssetsConsolidationRouter.__proto__ || Object.getPrototypeOf(AssetsConsolidationRouter)).apply(this, arguments));
  }

  _createClass(AssetsConsolidationRouter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          params = _props.params,
          location = _props.location,
          getInfoFromToken = _props.getInfoFromToken,
          updateProps = _props.updateProps;

      updateProps({ hashToken: params.hashToken, associateEmail: _ramda2.default.pathOr('', ['query', 'associateEmail'], location) });
      getInfoFromToken(params.hashToken);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearStore();
    }
  }, {
    key: 'render',
    value: function render() {
      var params = this.props.params;

      var props = {
        hashToken: params.hashToken
      };
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_container2.default, props)
      );
    }
  }]);

  return AssetsConsolidationRouter;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(null, {
  getInfoFromToken: _actions.getInfoFromToken,
  updateProps: _actions.updateProps,
  clearStore: _actions.clearStore
})(AssetsConsolidationRouter);

/***/ }),
/* 3594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _dumbComponent = __webpack_require__(3595);

var _dumbComponent2 = _interopRequireDefault(_dumbComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssetsConsolidationContainer = function AssetsConsolidationContainer(props) {
  return _react2.default.createElement(_dumbComponent2.default, props);
};

var mapStateToProps = function mapStateToProps(_ref) {
  var assetsConsolidation = _ref.assetsConsolidation,
      user = _ref.user;

  return _extends({}, assetsConsolidation, {
    consolidationSuccess: assetsConsolidation.consolidationSuccess,
    companyType: user.toJS().company.companyType
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AssetsConsolidationContainer);

/***/ }),
/* 3595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  hashToken: _react.PropTypes.string,
  rates: _react.PropTypes.array,
  requests: _react.PropTypes.array,
  processingToken: _react.PropTypes.bool,
  gettingAssets: _react.PropTypes.bool,
  errorText: _react.PropTypes.string
};

var AssetsConsolidationComponent = function (_React$Component) {
  _inherits(AssetsConsolidationComponent, _React$Component);

  function AssetsConsolidationComponent(props) {
    _classCallCheck(this, AssetsConsolidationComponent);

    var _this = _possibleConstructorReturn(this, (AssetsConsolidationComponent.__proto__ || Object.getPrototypeOf(AssetsConsolidationComponent)).call(this, props));

    _this.progress = function () {
      var diff = Math.random() * (90 - (_this.state || {}).completed);
      var newVal = (_this.state || {}).completed + diff;
      var seconds = (_this.state || {}).seconds;
      if (_this.props.errorText) {
        clearInterval(_this.timer);
      } else if (_this.props.consolidationSuccess && seconds >= 5) {
        _this.setState({ completed: 100, seconds: seconds + 1 });
        clearInterval(_this.timer);
      } else {
        _this.setState({ completed: newVal, seconds: seconds + 1 });
      }
    };

    _this.state = {
      completed: Math.random() * 80,
      seconds: 0
    };
    return _this;
  }

  _createClass(AssetsConsolidationComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.timer) this.timer = setInterval(function () {
        return _this2.progress();
      }, 1000);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var propKeys = _ramda2.default.keys(propTypes).filter(function (key) {
        return propTypes[key] !== _react.PropTypes.func;
      });
      return !_ramda2.default.equals(_ramda2.default.pick(propKeys, this.props), _ramda2.default.pick(propKeys, nextProps)) || !_ramda2.default.equals(this.state, nextState);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.completed < 100 && this.state.seconds >= 8 && nextProps.consolidationSuccess) {
        this.setState({ completed: 100 });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          gettingAssets = _props.gettingAssets,
          rates = _props.rates,
          requests = _props.requests,
          companyType = _props.companyType,
          associateEmail = _props.associateEmail,
          consolidationSuccess = _props.consolidationSuccess,
          errorText = _props.errorText;

      var assetLabel = companyType === 'Supplier' ? 'Requests' : 'Contracts';
      var docs = (companyType === 'Supplier' ? requests : rates) || [];
      return _react2.default.createElement(
        'div',
        { className: 'full-screen-page', style: { padding: '150px 20%', textAlign: 'center' } },
        Boolean(gettingAssets) && _react2.default.createElement(
          'div',
          { style: { fontSize: '16px' } },
          'Processing...'
        ),
        Boolean(errorText) && _react2.default.createElement(
          'div',
          { style: { fontSize: '16px' } },
          errorText
        ),
        !gettingAssets && this.state.completed < 100 && !errorText && _react2.default.createElement(
          'div',
          { style: { fontSize: '16px', width: '70%', margin: 'auto' } },
          'We are adding ',
          associateEmail ? associateEmail + ' as an associated email, and ' : '',
          docs.length,
          ' ',
          (0, _pluralize2.default)(assetLabel, docs.length),
          ' to your account. Thank you for your patience.'
        ),
        this.state.completed >= 100 && _react2.default.createElement(
          'div',
          { style: { fontSize: '16px', width: '70%', margin: 'auto' } },
          associateEmail ? 'Congratulations! We\'ve added ' + associateEmail + ', and the ' + (0, _pluralize2.default)(assetLabel, docs.length) + ' sent to that email address to your account.' : 'Congratulations! We\'ve added ' + (docs || []).length + ' ' + (0, _pluralize2.default)(assetLabel, docs.length) + ' to your account.'
        ),
        _react2.default.createElement(_materialUi.LinearProgress, { style: { flexGrow: 1, height: '12px', borderRadius: '5px', width: '50%', margin: '32px auto' }, color: '#0097a7', mode: 'determinate', max: 100, min: 0, value: this.state.completed }),
        Boolean(this.state.completed >= 100) && _react2.default.createElement(_materialUi.RaisedButton, {
          'data-cy': 'goto-contract-list',
          label: 'View Contract List',
          labelStyle: { textTransform: 'none' },
          secondary: true,
          onTouchTap: function onTouchTap() {
            return _this3.context.router.push('/contracting/contract-list/recent');
          }
        })
      );
    }
  }]);

  return AssetsConsolidationComponent;
}(_react2.default.Component);

AssetsConsolidationComponent.propTypes = propTypes;
AssetsConsolidationComponent.contextTypes = {
  router: _react.PropTypes.object.isRequired
};
exports.default = AssetsConsolidationComponent;

/***/ }),
/* 3596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateProps = updateProps;
exports.getInfoFromToken = getInfoFromToken;
exports.clearStore = clearStore;

var _constants = __webpack_require__(655);

var constants = _interopRequireWildcard(_constants);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isNilOrEmpty = _ramda2.default.either(_ramda2.default.isNil, _ramda2.default.isEmpty);

function updateProps(payload) {
  return { type: constants.UPDATE_PROPS, payload: payload };
}

function getInfoFromToken(hashToken) {
  return { type: constants.PROCESS_HASHTOKEN, payload: { hashToken: hashToken } };
}

function clearStore() {
  return { type: constants.CLEAR_STORE };
}

/***/ }),
/* 3597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRedux = __webpack_require__(6);

var _generalInfo = __webpack_require__(3598);

var _generalInfo2 = _interopRequireDefault(_generalInfo);

var _contacts = __webpack_require__(3599);

var _contacts2 = _interopRequireDefault(_contacts);

var _contractingFiles = __webpack_require__(3600);

var _contractingFiles2 = _interopRequireDefault(_contractingFiles);

var _newActivity = __webpack_require__(3601);

var _newActivity2 = _interopRequireDefault(_newActivity);

var _activities = __webpack_require__(3602);

var _activities2 = _interopRequireDefault(_activities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  content: {
    backgroundColor: 'rgb(240, 244, 247)',
    minHeight: 'calc(100% - 65px)',
    paddingLeft: '0 !important',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    marginTop: '65px',
    flexFlow: 'row wrap',
    textAlign: 'content',
    '& > *': {
      flex: '1 100%'
    }
  },
  main: {
    textAlign: 'left',
    '@media all and (min-width: 800px)': {
      flex: '3 0px',
      order: '2'
    }
  },
  leftColumn: {
    '@media all and (min-width: 600px)': {
      flex: '1 0 0'
    },
    '@media all and (min-width: 800px)': {
      order: '1'
    }
  },
  errorOverlay: {
    height: '100%',
    width: '100%',
    position: 'fixed',
    zIndex: 1000,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    overflowX: 'hidden',
    transition: '0.5s',
    textAlign: 'center',
    paddingTop: '20%'
  },
  errorText: {
    color: 'white',
    marginTop: '24px',
    fontSize: '24px',
    whiteSpace: 'pre-wrap',
    width: '50%',
    margin: 'auto'
  }
};

var partnerDetails = function (_Component) {
  _inherits(partnerDetails, _Component);

  function partnerDetails(props) {
    _classCallCheck(this, partnerDetails);

    return _possibleConstructorReturn(this, (partnerDetails.__proto__ || Object.getPrototypeOf(partnerDetails)).call(this, props));
  }

  _createClass(partnerDetails, [{
    key: 'render',
    value: function render() {
      var classes = this.props.classes;

      return _react2.default.createElement(
        'div',
        { className: classes.content },
        _react2.default.createElement(
          'div',
          { className: classes.leftColumn },
          _react2.default.createElement(_generalInfo2.default, null),
          _react2.default.createElement(_contacts2.default, null),
          _react2.default.createElement(_contractingFiles2.default, null)
        ),
        _react2.default.createElement(
          'div',
          { className: classes.main },
          _react2.default.createElement(_newActivity2.default, null),
          _react2.default.createElement(_activities2.default, null)
        ),
        Boolean(this.props.error) && _react2.default.createElement(
          'div',
          { className: classes.errorOverlay },
          _react2.default.createElement(
            'div',
            { className: classes.errorText },
            this.props.error
          )
        )
      );
    }
  }]);

  return partnerDetails;
}(_react.Component);

partnerDetails.propTypes = {
  classes: _react.PropTypes.object
};

var select = function select(_ref) {
  var store = _ref.partnerDetails;
  return {
    partnerInfo: store.partnerInfo,
    error: store.error
  };
};

exports.default = (0, _reactRedux.connect)(select, {})((0, _reactJss2.default)(styles)(partnerDetails));

/***/ }),
/* 3598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRedux = __webpack_require__(6);

var _Avatar = __webpack_require__(1040);

var _Avatar2 = _interopRequireDefault(_Avatar);

var _CircularProgress = __webpack_require__(856);

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _Paper = __webpack_require__(228);

var _Paper2 = _interopRequireDefault(_Paper);

var _RefreshIndicator = __webpack_require__(1043);

var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  content: {
    margin: '1em',
    textAlign: 'center',
    display: 'flex',
    padding: '1em',
    justifyContent: 'space-between',
    borderRadius: '10px !important'
  },
  avatar: {
    border: 'solid 1px #bbb',
    flex: '0 0 auto',
    left: '0 !important',
    position: 'relative !important',
    top: 'inherit !important'
  },
  companyName: {
    flex: '1 1 auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'left',
    paddingLeft: '1em',
    fontSize: '1em'
  },
  loading: {
    margin: 'auto'
  },
  refresh: {
    display: 'inline-block',
    position: 'relative'
  }
};

var GeneralInfo = function (_Component) {
  _inherits(GeneralInfo, _Component);

  function GeneralInfo(props) {
    _classCallCheck(this, GeneralInfo);

    return _possibleConstructorReturn(this, (GeneralInfo.__proto__ || Object.getPrototypeOf(GeneralInfo)).call(this, props));
  }

  _createClass(GeneralInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          _props$partnerInfo = _props.partnerInfo;
      _props$partnerInfo = _props$partnerInfo === undefined ? {} : _props$partnerInfo;
      var _props$partnerInfo$co = _props$partnerInfo.companyName,
          companyName = _props$partnerInfo$co === undefined ? '?' : _props$partnerInfo$co,
          profileImageUrl = _props$partnerInfo.profileImageUrl,
          partnerInfoLoading = _props.partnerInfoLoading,
          partnerInfoLoaded = _props.partnerInfoLoaded;

      var whatToShow = function () {
        if (partnerInfoLoading) return 'loading';
        if (partnerInfoLoaded) return 'loaded';
        return 'errored';
      }();
      return {
        'loaded': _react2.default.createElement(
          _Paper2.default,
          { className: classes.content },
          _react2.default.createElement(
            _Avatar2.default,
            _extends({
              className: classes.avatar
            }, profileImageUrl ? { src: profileImageUrl } : {}),
            profileImageUrl ? null : companyName[0].toUpperCase()
          ),
          _react2.default.createElement(
            'div',
            { className: classes.companyName },
            companyName
          )
        ),
        'loading': _react2.default.createElement(
          _Paper2.default,
          { className: classes.content },
          _react2.default.createElement(
            'div',
            { className: classes.loading },
            _react2.default.createElement(_CircularProgress2.default, null)
          )
        ),
        'errored': _react2.default.createElement(
          _Paper2.default,
          { className: classes.content },
          _react2.default.createElement(
            'div',
            { className: classes.loading },
            _react2.default.createElement(_RefreshIndicator2.default, {
              percentage: 80,
              size: 60,
              left: 0,
              top: 0,
              color: 'red',
              status: 'ready',
              style: styles.refresh
            })
          )
        )
      }[whatToShow];
    }
  }]);

  return GeneralInfo;
}(_react.Component);

GeneralInfo.propTypes = {
  classes: _react.PropTypes.object,
  partnerInfo: _react.PropTypes.object,
  partnerInfoLoaded: _react.PropTypes.bool,
  partnerInfoLoading: _react.PropTypes.bool
};

var select = function select(_ref) {
  var store = _ref.partnerDetails;
  return {
    partnerInfo: store.partnerInfo,
    partnerInfoLoaded: store.partnerInfoLoaded,
    partnerInfoLoading: store.partnerInfoLoading
  };
};

exports.default = (0, _reactRedux.connect)(select, {})((0, _reactJss2.default)(styles)(GeneralInfo));

/***/ }),
/* 3599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Paper = __webpack_require__(228);

var _Paper2 = _interopRequireDefault(_Paper);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRedux = __webpack_require__(6);

var _Avatar = __webpack_require__(1040);

var _Avatar2 = _interopRequireDefault(_Avatar);

var _CircularProgress = __webpack_require__(856);

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _RefreshIndicator = __webpack_require__(1043);

var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  content: {
    margin: '1em',
    textAlign: 'left',
    padding: '1em',
    borderRadius: '10px !important'
  },
  header: {
    fontSize: '1em',
    marginBottom: '1em'
  },
  contactList: {},
  contact: {
    display: 'flex',
    padding: '1em',
    justifyContent: 'space-between'
  },
  avatar: {
    border: 'solid 1px #bbb',
    cursor: 'pointer',
    flex: '0 0 auto',
    left: '0 !important',
    position: 'relative !important',
    top: 'inherit !important'
  },
  contactDetails: {
    flex: '1 1 auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'left',
    paddingLeft: '1em',
    fontSize: '1em'
  },
  contactName: {},
  email: {
    fontSize: '0.9em'
  },
  type: {
    fontSize: '0.9em'
  },
  phone: {
    fontSize: '0.9em'
  },
  loading: {
    margin: 'auto',
    textAlign: 'center'
  },
  refresh: {
    display: 'inline-block',
    position: 'relative'
  }
};

var Contacts = function (_Component) {
  _inherits(Contacts, _Component);

  function Contacts(props) {
    _classCallCheck(this, Contacts);

    return _possibleConstructorReturn(this, (Contacts.__proto__ || Object.getPrototypeOf(Contacts)).call(this, props));
  }

  _createClass(Contacts, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          contacts = _props.contacts,
          contactsLoading = _props.contactsLoading,
          contactsLoaded = _props.contactsLoaded;

      var whatToShow = function () {
        if (contactsLoading) return 'loading';
        if (contactsLoaded) return 'loaded';
        return 'errored';
      }();
      return _react2.default.createElement(
        _Paper2.default,
        { className: classes.content },
        whatToShow === 'loaded' ? _react2.default.createElement(
          'div',
          { className: classes.header },
          (0, _pluralize2.default)('Contact', contacts.length)
        ) : undefined,
        {
          loading: _react2.default.createElement(
            'div',
            { className: classes.loading },
            _react2.default.createElement(_CircularProgress2.default, null)
          ),
          errored: _react2.default.createElement(
            'div',
            { className: classes.loading },
            _react2.default.createElement(_RefreshIndicator2.default, {
              percentage: 80,
              size: 60,
              left: 0,
              top: 0,
              color: 'red',
              status: 'ready',
              style: styles.refresh
            })
          ),
          loaded: _react2.default.createElement(
            'div',
            { className: classes.contactList },
            contacts.map(function (_ref, index) {
              var _ref$name = _ref.name,
                  name = _ref$name === undefined ? '?' : _ref$name,
                  type = _ref.type,
                  phone = _ref.phone,
                  fax = _ref.fax,
                  email = _ref.email,
                  avatarUrl = _ref.avatarUrl;
              return _react2.default.createElement(
                'div',
                { className: classes.contact, key: index },
                _react2.default.createElement(
                  _Avatar2.default,
                  _extends({
                    className: classes.avatar
                  }, avatarUrl ? { src: avatarUrl } : {}),
                  avatarUrl ? null : (name || '?').replace(/undefined/g, '')[0] || '👤'
                ),
                _react2.default.createElement(
                  'div',
                  { className: classes.contactDetails },
                  Boolean(name) ? _react2.default.createElement(
                    'div',
                    { className: classes.contactName },
                    name.replace(/undefined/g, '')
                  ) : undefined,
                  Boolean(type) ? _react2.default.createElement(
                    'div',
                    { className: classes.type },
                    type
                  ) : undefined,
                  Boolean(email) ? _react2.default.createElement(
                    'div',
                    { className: classes.email },
                    '\u2709\uFE0F ',
                    _react2.default.createElement(
                      'a',
                      { href: 'mailto:' + email },
                      email
                    )
                  ) : undefined,
                  Boolean(phone) ? _react2.default.createElement(
                    'div',
                    { className: classes.phone },
                    '\uD83D\uDCDE ',
                    _react2.default.createElement(
                      'a',
                      { href: 'tel:' + phone },
                      phone
                    )
                  ) : undefined,
                  Boolean(fax) ? _react2.default.createElement(
                    'div',
                    { className: classes.phone },
                    '\uD83D\uDCE0 ',
                    fax
                  ) : undefined
                )
              );
            })
          )
        }[whatToShow]
      );
    }
  }]);

  return Contacts;
}(_react.Component);

Contacts.propTypes = {
  classes: _react.PropTypes.object,
  contacts: _react.PropTypes.array,
  contactsLoaded: _react.PropTypes.bool,
  contactsLoading: _react.PropTypes.bool
};

var select = function select(_ref2) {
  var store = _ref2.partnerDetails;
  return {
    contacts: store.contacts,
    contactsLoading: store.contactsLoading,
    contactsLoaded: store.contactsLoaded
  };
};

exports.default = (0, _reactRedux.connect)(select, {})((0, _reactJss2.default)(styles)(Contacts));

/***/ }),
/* 3600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _titlecase = __webpack_require__(549);

var _Paper = __webpack_require__(228);

var _Paper2 = _interopRequireDefault(_Paper);

var _Divider = __webpack_require__(1349);

var _Divider2 = _interopRequireDefault(_Divider);

var _FontIcon = __webpack_require__(1079);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _CircularProgress = __webpack_require__(856);

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _RefreshIndicator = __webpack_require__(1043);

var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);

var _contractingUtils = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  content: {
    margin: '1em',
    textAlign: 'center',
    padding: '1em',
    backgroundColor: '#f4f6fa !important',
    borderRadius: '10px !important',
    '&.loading': {
      opacity: '0.7'
    }
  },
  header: {
    fontSize: '1em',
    marginBottom: '0.4em',
    textAlign: 'left'
  },
  yearSplit: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  yearSplitDivider: {
    flex: '1 0 auto'
  },
  yearSplitLabel: {
    flex: '0 1 auto',
    paddingLeft: '1em',
    fontSize: '0.7em',
    color: '#9e9e9e'
  },
  contractItemRow: {
    cursor: 'pointer',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '&>.hoverText': {
      fontSize: '0.8em',
      visibility: 'hidden'
    },
    '&:hover>.hoverText': {
      visibility: 'visible !important'
    }
  },
  contractItem: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: '2.2em',
    '&.splitBorder': {
      borderTop: '1px solid #e0e0e0',
      marginTop: '0.5em',
      paddingTop: '0.8em'
    }
  },
  contractItemIcon: {
    flex: '0 1 auto',
    display: 'flex',
    flexDirection: 'column'
  },
  contractItemIconFontIcon: {
    color: '#9e9e9e !important'
  },
  contractItemIconTextCaption: {
    fontSize: '0.7em'
  },
  contractItemDesc: {
    fontSize: '0.8em',
    marginLeft: '1em',
    color: '#616161',
    display: 'flex',
    flexDirection: 'column'
  },
  contractItemDescContractName: {
    textAlign: 'left'
  },
  contractItemDescFontIcon: {
    color: '#9e9e9e !important',
    fontSize: '1.6em !important',
    marginRight: '0.2em'
  },
  templateName: {
    display: 'flex',
    flexDirection: 'row',
    flex: '1 1 auto',
    alignItems: 'center'
  },
  templateNameText: {
    overflow: 'hidden',
    height: '2em',
    textAlign: 'left'
  },
  loading: {
    margin: 'auto',
    textAlign: 'center',
    paddingBottom: '1em'
  },
  refresh: {
    display: 'inline-block',
    position: 'relative'
  }
};

var ContractingFiles = function (_Component) {
  _inherits(ContractingFiles, _Component);

  function ContractingFiles(props) {
    _classCallCheck(this, ContractingFiles);

    var _this = _possibleConstructorReturn(this, (ContractingFiles.__proto__ || Object.getPrototypeOf(ContractingFiles)).call(this, props));

    _this.jumpToContract = function (contractId) {
      var url = '/contracting/contract/' + contractId + '/activities';
      _this.props.routerPush(url);
    };

    return _this;
  }

  _createClass(ContractingFiles, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classes = _props.classes,
          files = _props.files,
          companyId = _props.companyId,
          filesLoading = _props.filesLoading,
          filesLoaded = _props.filesLoaded,
          resourceType = _props.resourceType;

      var listItems = files.reduce(function (data, current) {
        var year = (0, _moment2.default)(current.startDate).format('YYYY');
        data[year] = [].concat(_toConsumableArray(data[year] || []), [_extends({}, current, {
          shownState: (0, _contractingUtils.getShownState)(_extends({}, current, { companyType: (0, _titlecase.toLaxTitleCase)(resourceType) })),
          startYear: (0, _moment2.default)(current.startDate).format('YYYY'),
          endYear: (0, _moment2.default)(current.endDate).format('YYYY')
        })]);
        return data;
      }, {});
      if (filesLoaded) {
        return _react2.default.createElement(
          _Paper2.default,
          { className: '' + classes.content + (filesLoading ? ' loading' : '') },
          _react2.default.createElement(
            'div',
            { className: classes.header },
            'Contracting Files'
          ),
          Object.keys(listItems).sort(function (a, b) {
            return ~~b - ~~a;
          }).map(function (year) {
            return _react2.default.createElement(
              'div',
              { key: year },
              _react2.default.createElement(
                'div',
                { className: classes.yearSplit },
                _react2.default.createElement(_Divider2.default, { className: classes.yearSplitDivider }),
                _react2.default.createElement(
                  'div',
                  { className: classes.yearSplitLabel },
                  year
                )
              ),
              listItems[year].map(function (_ref, ix) {
                var companyName = _ref.companyName,
                    endDate = _ref.endDate,
                    endYear = _ref.endYear,
                    id = _ref._id,
                    locationName = _ref.locationName,
                    startDate = _ref.startDate,
                    startYear = _ref.startYear,
                    state = _ref.shownState,
                    templateName = _ref.templateName,
                    supplierId = _ref.supplierId;
                return _react2.default.createElement(
                  'div',
                  { key: id, className: classes.contractItemRow, onTouchTap: function onTouchTap() {
                      _this2.jumpToContract(id);
                    } },
                  _react2.default.createElement(
                    'div',
                    {
                      className: classes.contractItem + ' ' + (ix > 0 ? ' splitBorder' : '')
                    },
                    _react2.default.createElement(
                      'div',
                      { className: classes.contractItemIcon },
                      _react2.default.createElement(_FontIcon2.default, { className: 'tc-icon-description ' + classes.contractItemIconFontIcon }),
                      _react2.default.createElement(
                        'div',
                        { className: '' + classes.contractItemIconTextCaption, style: { color: (0, _contractingUtils.getStatusColor)(state) } },
                        state.replace(/^\w/, function (c) {
                          return c.toUpperCase();
                        })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: classes.contractItemDesc },
                      _react2.default.createElement(
                        'div',
                        { className: classes.contractItemDescContractName },
                        companyName !== locationName ? locationName : null,
                        ' ',
                        startYear !== endYear ? startYear + '-' + endYear : startYear
                      ),
                      companyId === supplierId ? _react2.default.createElement(
                        'div',
                        { className: classes.templateName },
                        _react2.default.createElement(_FontIcon2.default, { className: 'tc-icon-receipt ' + classes.contractItemDescFontIcon }),
                        _react2.default.createElement(
                          'div',
                          { className: classes.templateNameText },
                          templateName
                        )
                      ) : undefined
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'hoverText' },
                    'View'
                  )
                );
              })
            );
          })
        );
      }
      if (filesLoading) {
        return _react2.default.createElement(
          _Paper2.default,
          { className: classes.content },
          _react2.default.createElement(
            'div',
            { className: classes.loading },
            _react2.default.createElement(_CircularProgress2.default, null)
          )
        );
      }
      return _react2.default.createElement(
        _Paper2.default,
        { className: classes.content },
        _react2.default.createElement(
          'div',
          { className: classes.loading },
          _react2.default.createElement(_RefreshIndicator2.default, {
            percentage: 80,
            size: 60,
            left: 0,
            top: 0,
            color: 'red',
            status: 'ready',
            style: styles.refresh
          })
        )
      );
    }
  }]);

  return ContractingFiles;
}(_react.Component);

ContractingFiles.propTypes = {
  classes: _react.PropTypes.object,
  companyId: _react.PropTypes.string,
  files: _react.PropTypes.array,
  routerPush: _react.PropTypes.func,
  filesLoading: _react.PropTypes.bool,
  filesLoaded: _react.PropTypes.bool,
  resourceType: _react.PropTypes.string
};

var select = function select(_ref2) {
  var _ref2$partnerDetails = _ref2.partnerDetails,
      files = _ref2$partnerDetails.files,
      filesLoading = _ref2$partnerDetails.filesLoading,
      filesLoaded = _ref2$partnerDetails.filesLoaded,
      resourceType = _ref2$partnerDetails.resourceType,
      user = _ref2.user;
  return {
    companyId: user.getIn(['company', 'companyId']),
    files: files,
    filesLoaded: filesLoaded,
    filesLoading: filesLoading,
    resourceType: resourceType
  };
};

exports.default = (0, _reactRedux.connect)(select, { routerPush: _reactRouterRedux.push })((0, _reactJss2.default)(styles)(ContractingFiles));

/***/ }),
/* 3601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRedux = __webpack_require__(6);

var _Tabs = __webpack_require__(1362);

var _CircularProgress = __webpack_require__(856);

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _FontIcon = __webpack_require__(1079);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _Paper = __webpack_require__(228);

var _Paper2 = _interopRequireDefault(_Paper);

var _RefreshIndicator = __webpack_require__(1043);

var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);

var _TextField = __webpack_require__(626);

var _TextField2 = _interopRequireDefault(_TextField);

var _commentBox = __webpack_require__(1112);

var _commentBox2 = _interopRequireDefault(_commentBox);

var _actions = __webpack_require__(1455);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  content: {
    margin: '1em',
    padding: '1em 1em 1em 1em',
    borderRadius: '10px !important'
  },
  tabs: {
    '&>div:first-of-type': {
      backgroundColor: 'transparent !important'
    },
    '&>div:nth-of-type(2)': {
      borderBottom: '0.1em solid #e0e0e0 !important'
    }
  },
  tab: {
    textTransform: 'none !important',
    color: '#90a4ae !important',
    fontSize: '1.3em !important',
    '&.active': {
      color: '#3e5a6d !important'
    },
    '&>div>div': {
      flexDirection: 'row !important',
      height: 'inherit !important'
    },
    '&>div>div>*': {
      margin: '0.3em !important'
    }
  },
  tabContent: {
    marginTop: '3em',
    '@media (min-width: 1000px)': {
      '&:before': {
        background: '#90a4ae',
        content: "''",
        display: 'block',
        height: '100%',
        left: '40px',
        position: 'absolute',
        top: '10px',
        width: '1px',
        zIndex: 0
      }
    }
  },
  inkBarStyle: {
    background: '#3e5a6d',
    height: '0.4em'
  },
  tabIcon: {
    color: '#90a4ae !important',
    '&.active': {
      color: '#3e5a6d !important'
    }
  },
  subjectInput: {
    padding: '0 18px 0 18px',
    width: '100% !important'
  },
  loading: {
    margin: 'auto',
    textAlign: 'center',
    paddingBottom: '1em'
  },
  refresh: {
    display: 'inline-block',
    position: 'relative'
  }
};

var NewActivity = function (_Component) {
  _inherits(NewActivity, _Component);

  function NewActivity(props) {
    _classCallCheck(this, NewActivity);

    var _this = _possibleConstructorReturn(this, (NewActivity.__proto__ || Object.getPrototypeOf(NewActivity)).call(this, props));

    _this.handleActive = function (tab) {
      var activeTab = tab.props['data-activity'];

      _this.setState({
        activeTab: activeTab
      });
    };

    _this.updateDimensions = function () {
      var findDom = (document.getElementsByClassName(_this.props.classes.tabs) || [null])[0];
      if (findDom && findDom.clientWidth) {
        var width = findDom.clientWidth;
        _this.setState({ width: width });
      }
    };

    _this.handleChange = function (_ref) {
      var _ref$target = _ref.target,
          name = _ref$target.name,
          value = _ref$target.value;

      _this.setState(_defineProperty({}, name, value));
    };

    _this.sendActivity = function () {
      var _this$state = _this.state,
          activeTab = _this$state.activeTab,
          rates = _this$state.rates,
          attachedFiles = _this$state.attachedFiles,
          subject = _this$state.subject,
          comment = _this$state.comment;
      var _this$props$partnerIn = _this.props.partnerInfo,
          companyName = _this$props$partnerIn.companyName,
          _this$props$partnerIn2 = _this$props$partnerIn.companyId,
          companyId = _this$props$partnerIn2 === undefined ? '' : _this$props$partnerIn2;

      var isEmail = companyId.indexOf('@') > -1;
      switch (activeTab) {
        case 'internalNote':
          // sending a note
          // TODO: NOW
          _this.props.sendMessage({
            partnerId: companyId,
            message: {
              files: attachedFiles,
              messageText: comment,
              messageSubject: subject,
              type: 'note'
            }
          });
          break;
        case 'message':
          if (rates.length > 0) {
            // sending rates
            if (_this.props.isSupplier) {
              // Supplier
              var _rates$ = rates[0],
                  startDate = _rates$.startDate,
                  endDate = _rates$.endDate,
                  _rates$$templateGroup = _rates$.templateGroups,
                  templateGroups = _rates$$templateGroup === undefined ? [''] : _rates$$templateGroup;

              _this.props.sendRates({
                startDate: startDate,
                endDate: endDate,
                templates: rates,
                templateGroupId: templateGroups[0],
                message: comment,
                bccSelf: false,
                partners: [{
                  companyName: companyName,
                  companyId: isEmail ? null : companyId,
                  email: isEmail ? companyId : null
                }],
                subject: subject
              });
            } else {
              // Buyer
              var _rates$2 = rates[0],
                  _endDate = _rates$2.endDate,
                  forGroupQuote = _rates$2.forGroupQuote,
                  _startDate = _rates$2.startDate,
                  submissionCriteria = _rates$2.submissionCriteria,
                  taxId = _rates$2.taxId,
                  termsAndConditions = _rates$2.termsAndConditions,
                  termsRadioButtonValue = _rates$2.termsRadioButtonValue;

              _this.props.sendRateRequest(_extends({
                customizedMessage: comment,
                endDate: _endDate,
                startDate: _startDate,
                subject: subject,
                taxId: taxId,
                forGroupQuote: forGroupQuote,
                contractPartners: [{
                  companyName: companyName,
                  companyId: isEmail ? null : companyId,
                  email: isEmail ? companyId : null,
                  companyType: 'Supplier'
                }]
              }, forGroupQuote === 'yes' ? {
                submissionCriteria: submissionCriteria
              } : {}, termsRadioButtonValue === 'yes' ? {
                termsAndConditions: termsAndConditions
              } : {}));
            }
          } else {
            // sending a message
            _this.props.sendMessage({
              partnerId: companyId,
              message: {
                files: attachedFiles,
                messageText: comment,
                messageSubject: subject
              }
            });
          }
          break;
        default:
      }
    };

    _this.state = {
      activeTab: '',
      attachedFiles: [],
      comment: '',
      rates: [],
      subject: ''
    };
    return _this;
  }

  _createClass(NewActivity, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleActive({ props: { 'data-activity': 'message' } });
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.newActivitySending && !this.props.newActivitySending && !this.props.newActivitySendingError) {
        this.setState({
          comment: '',
          subject: '',
          attachedFiles: [],
          rates: []
        });
        this.clearInput();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          action = _props.action,
          classes = _props.classes,
          newActivitySending = _props.newActivitySending,
          partnerInfoLoaded = _props.partnerInfoLoaded,
          partnerInfoLoading = _props.partnerInfoLoading,
          companyType = _props.partnerInfo.companyType;
      var _state = this.state,
          activeTab = _state.activeTab,
          width = _state.width;

      if (partnerInfoLoading) {
        return _react2.default.createElement(
          _Paper2.default,
          { className: classes.content },
          _react2.default.createElement(
            'div',
            { className: classes.loading },
            _react2.default.createElement(_CircularProgress2.default, null)
          )
        );
      }
      if (partnerInfoLoaded) {
        return _react2.default.createElement(
          _Paper2.default,
          { className: classes.content },
          _react2.default.createElement(
            _Tabs.Tabs,
            {
              className: classes.tabs,
              inkBarStyle: styles.inkBarStyle
            },
            [_react2.default.createElement(
              _Tabs.Tab,
              {
                label: 'Message',
                'data-activity': 'message',
                key: 'message',
                onActive: this.handleActive,
                className: '' + classes.tab + (activeTab === 'message' ? ' active' : ''),
                icon: _react2.default.createElement(
                  _FontIcon2.default,
                  { className: 'material-icons ' + classes.tabIcon + (activeTab === 'message' ? ' active' : '') },
                  'mail'
                )
              },
              _react2.default.createElement(_TextField2.default, {
                hintText: 'Enter subject here...',
                name: 'subject',
                className: classes.subjectInput,
                value: this.state.subject,
                underlineStyle: { position: 'relative' },
                onChange: this.handleChange,
                disabled: newActivitySending,
                errorText: Boolean(this.state.rates.length > 0 && !this.state.subject) && 'Required'
              })
            ), _react2.default.createElement(_Tabs.Tab, {
              label: 'Internal Note',
              'data-activity': 'internalNote',
              key: 'internalNote',
              onActive: this.handleActive,
              className: '' + classes.tab + (activeTab === 'internalNote' ? ' active' : ''),
              icon: _react2.default.createElement(
                _FontIcon2.default,
                { className: 'material-icons ' + classes.tabIcon + (activeTab === 'internalNote' ? ' active' : '') },
                'border_color'
              )
            }), _react2.default.createElement(_Tabs.Tab, {
              label: '',
              key: 'spacer0',
              disabled: true,
              className: classes.tab
            })].concat(_toConsumableArray(width > 650 ? [_react2.default.createElement(_Tabs.Tab, {
              label: '',
              key: 'spacer1',
              disabled: true,
              className: classes.tab
            })] : []), _toConsumableArray(width > 800 ? [_react2.default.createElement(_Tabs.Tab, {
              label: '',
              key: 'spacer2',
              disabled: true,
              className: classes.tab
            })] : [])).map(function (e) {
              return e;
            })
          ),
          _react2.default.createElement(_commentBox2.default, _extends({
            hintText: 'Enter message body here...',
            hideMesageBoxIcon: true,
            borderless: true,
            attachedFiles: this.state.attachedFiles,
            setRates: function setRates(rates) {
              return _this2.setState({ rates: rates });
            },
            hideActions: this.state.rates.length > 0 && !this.state.subject,
            disableSend: newActivitySending,
            attachFile: function attachFile(fileList) {
              action('attachFile')(fileList);
              _this2.setState({ attachedFiles: fileList });
            },
            comment: this.state.comment,
            cancelComment: function cancelComment() {
              _this2.setState({ comment: '', subject: '' });
              _this2.clearInput();
            },
            setClear: function setClear(clear) {
              return _this2.clearInput = clear;
            },
            handleInput: function handleInput(textInput) {
              action('handleInput')(textInput);
              _this2.setState({ comment: textInput });
            },
            submitComment: function submitComment() {
              action('submitComment');
              _this2.sendActivity();
            }
          }, activeTab === 'internalNote' ? { internal: true } : { showContracting: true, receiverCompanyType: companyType }))
        );
      }
      return _react2.default.createElement(
        _Paper2.default,
        { className: classes.content },
        _react2.default.createElement(
          'div',
          { className: classes.loading },
          _react2.default.createElement(_RefreshIndicator2.default, {
            percentage: 80,
            size: 60,
            left: 0,
            top: 0,
            color: 'red',
            status: 'ready',
            style: styles.refresh
          })
        )
      );
    }
  }]);

  return NewActivity;
}(_react.Component);

NewActivity.defaultProps = {
  action: function action() {
    return function () {};
  },
  partnerInfo: {}
};

NewActivity.propTypes = {
  action: _react.PropTypes.func.isRequired,
  classes: _react.PropTypes.object,
  isSupplier: _react.PropTypes.bool,
  newActivitySending: _react.PropTypes.bool,
  newActivitySendingError: _react.PropTypes.bool,
  partnerInfo: _react.PropTypes.object,
  partnerInfoLoaded: _react.PropTypes.bool,
  partnerInfoLoading: _react.PropTypes.bool,
  sendMessage: _react.PropTypes.func,
  sendRateRequest: _react.PropTypes.func,
  sendRates: _react.PropTypes.func
};

var select = function select(_ref2) {
  var _ref2$partnerDetails = _ref2.partnerDetails,
      newActivitySending = _ref2$partnerDetails.newActivitySending,
      newActivitySendingError = _ref2$partnerDetails.newActivitySendingError,
      partnerInfo = _ref2$partnerDetails.partnerInfo,
      partnerInfoLoaded = _ref2$partnerDetails.partnerInfoLoaded,
      partnerInfoLoading = _ref2$partnerDetails.partnerInfoLoading,
      user = _ref2.user;
  return {
    isSupplier: user.getIn(['user', 'type']) === 'Supplier',
    newActivitySending: newActivitySending,
    newActivitySendingError: newActivitySendingError,
    partnerInfo: partnerInfo,
    partnerInfoLoaded: partnerInfoLoaded,
    partnerInfoLoading: partnerInfoLoading
  };
};

exports.default = (0, _reactRedux.connect)(select, { sendMessage: _actions.sendMessage, sendRates: _actions.sendRates, sendRateRequest: _actions.sendRateRequest })((0, _reactJss2.default)(styles)(NewActivity));

/***/ }),
/* 3602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRedux = __webpack_require__(6);

var _Tabs = __webpack_require__(1362);

var _Paper = __webpack_require__(228);

var _Paper2 = _interopRequireDefault(_Paper);

var _CircularProgress = __webpack_require__(856);

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _RefreshIndicator = __webpack_require__(1043);

var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);

var _activityList = __webpack_require__(3603);

var _activityList2 = _interopRequireDefault(_activityList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  content: {
    margin: '1em',
    padding: '1em',
    borderRadius: '10px !important',
    '&.loading': {
      opacity: '0.7'
    }
  },
  tabs: {
    '&>div:first-of-type': {
      backgroundColor: 'transparent !important'
    },
    '&>div:nth-of-type(2)': {
      borderBottom: '0.1em solid #3e5a6d !important'
    }
  },
  tab: {
    textTransform: 'none !important',
    color: '#90a4ae !important',
    fontSize: '1.3em !important',
    '&.active': {
      color: '#3e5a6d !important'
    }
  },
  tabContent: {
    marginTop: '3em',
    '@media (min-width: 1000px)': {
      '&:before': {
        background: '#90a4ae',
        content: "''",
        display: 'block',
        height: '100%',
        left: '40px',
        position: 'absolute',
        top: '10px',
        width: '1px',
        zIndex: 0
      }
    }
  },
  inkBarStyle: {
    background: '#3e5a6d',
    height: '0.4em'
  },
  loading: {
    margin: 'auto',
    textAlign: 'center',
    paddingBottom: '1em'
  },
  refresh: {
    display: 'inline-block',
    position: 'relative'
  }
};

var Activities = function (_Component) {
  _inherits(Activities, _Component);

  function Activities(props) {
    _classCallCheck(this, Activities);

    var _this = _possibleConstructorReturn(this, (Activities.__proto__ || Object.getPrototypeOf(Activities)).call(this, props));

    _this.handleActive = function (tab) {
      var filter = tab.props.filter;

      _this.setState({
        activeTab: filter
      });
    };

    _this.updateDimensions = function () {
      var findDom = (document.getElementsByClassName(_this.props.classes.tabs) || [null])[0];
      if (findDom && findDom.clientWidth) {
        var width = findDom.clientWidth;
        _this.setState({ width: width });
      }
    };

    _this.state = {
      activeTab: '',
      width: null
    };
    return _this;
  }

  _createClass(Activities, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleActive({ props: { filter: 'all' } });
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          activitiesLoaded = _props.activitiesLoaded,
          activitiesLoading = _props.activitiesLoading,
          allActivities = _props.activities;
      var _state = this.state,
          activeTab = _state.activeTab,
          width = _state.width;

      var activities = [].concat(_toConsumableArray(function () {
        switch (activeTab) {
          case 'notes':
            return allActivities.filter(function (e) {
              return e.type === 'note';
            });
          case 'contracting':
            return allActivities.filter(function (e) {
              return Boolean(e.contracts && e.contracts.length);
            });
          case 'messages':
            return allActivities.filter(function (e) {
              return e.type !== 'note' && Boolean(e.bodyText);
            });
          default:
            return allActivities;
        }
      }()));
      if (activitiesLoaded) {
        return _react2.default.createElement(
          _Paper2.default,
          { className: '' + classes.content + (activitiesLoading ? ' loading' : '') },
          _react2.default.createElement(
            _Tabs.Tabs,
            {
              className: classes.tabs,
              inkBarStyle: styles.inkBarStyle
            },
            [_react2.default.createElement(
              _Tabs.Tab,
              {
                label: 'All Activities',
                filter: 'all',
                key: 'all',
                onActive: this.handleActive,
                className: '' + classes.tab + (activeTab === 'all' ? ' active' : '')
              },
              _react2.default.createElement(_activityList2.default, { className: classes.tabContent, activities: activities })
            ), _react2.default.createElement(
              _Tabs.Tab,
              {
                label: 'Contracting',
                filter: 'contracting',
                key: 'contracting',
                onActive: this.handleActive,
                className: '' + classes.tab + (activeTab === 'contracting' ? ' active' : '')
              },
              _react2.default.createElement(_activityList2.default, { className: classes.tabContent, activities: activities })
            ), _react2.default.createElement(
              _Tabs.Tab,
              {
                label: 'Messages',
                filter: 'messages',
                key: 'messages',
                onActive: this.handleActive,
                className: '' + classes.tab + (activeTab === 'messages' ? ' active' : '')
              },
              _react2.default.createElement(_activityList2.default, { className: classes.tabContent, activities: activities })
            ), _react2.default.createElement(
              _Tabs.Tab,
              {
                label: 'Internal Notes',
                filter: 'notes',
                key: 'notes',
                onActive: this.handleActive,
                className: '' + classes.tab + (activeTab === 'notes' ? ' active' : '')
              },
              _react2.default.createElement(_activityList2.default, { className: classes.tabContent, activities: activities })
            )].concat(_toConsumableArray(width > 650 ? [_react2.default.createElement(_Tabs.Tab, {
              label: '',
              key: 'spacer1',
              disabled: true,
              className: classes.tab
            })] : []), _toConsumableArray(width > 800 ? [_react2.default.createElement(_Tabs.Tab, {
              label: '',
              key: 'spacer2',
              disabled: true,
              className: classes.tab
            })] : [])).map(function (e) {
              return e;
            })
          )
        );
      }
      if (activitiesLoading) {
        return _react2.default.createElement(
          _Paper2.default,
          { className: classes.content },
          _react2.default.createElement(
            'div',
            { className: classes.loading },
            _react2.default.createElement(_CircularProgress2.default, null)
          )
        );
      }
      return _react2.default.createElement(
        _Paper2.default,
        { className: classes.content },
        _react2.default.createElement(
          'div',
          { className: classes.loading },
          _react2.default.createElement(_RefreshIndicator2.default, {
            percentage: 80,
            size: 60,
            left: 0,
            top: 0,
            color: 'red',
            status: 'ready',
            style: styles.refresh
          })
        )
      );
    }
  }]);

  return Activities;
}(_react.Component);

Activities.propTypes = {
  activities: _react.PropTypes.array,
  activitiesLoaded: _react.PropTypes.bool,
  activitiesLoading: _react.PropTypes.bool,
  classes: _react.PropTypes.object
};

var select = function select(_ref) {
  var store = _ref.partnerDetails;
  return {
    activities: store.activities,
    activitiesLoaded: store.activitiesLoaded,
    activitiesLoading: store.activitiesLoading
  };
};

exports.default = (0, _reactRedux.connect)(select, {})((0, _reactJss2.default)(styles)(Activities));

/***/ }),
/* 3603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRedux = __webpack_require__(6);

var _comment = __webpack_require__(2010);

var _comment2 = _interopRequireDefault(_comment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var styles = {
  dateSplit: {
    color: '#3e5a6d',
    fontSize: '2em',
    padding: '1em 0 1.5em 100px'
  }
};

var ActivityList = function ActivityList(props) {
  var className = props.className,
      activities = props.activities,
      classes = props.classes;

  var dateDesc = {};
  var listItems = activities.reduce(function (data, current) {
    var dateVal = (0, _moment2.default)(current.createdAt).format('YYYYMM').toString();
    dateDesc[dateVal] = (0, _moment2.default)(current.createdAt).format('MMMM YYYY');
    data[dateVal] = [].concat(_toConsumableArray(data[dateVal] || []), [{ msgObject: current }]);
    return data;
  }, {});
  return _react2.default.createElement(
    'div',
    { className: className },
    Object.keys(listItems).sort(function (a, b) {
      return ~~b - ~~a;
    }).map(function (dateVal) {
      return _react2.default.createElement(
        'div',
        { key: dateVal },
        _react2.default.createElement(
          'div',
          { className: classes.dateSplit },
          dateDesc[dateVal]
        ),
        listItems[dateVal].map(function (e) {
          return _react2.default.createElement(_comment2.default, _extends({ showContactLink: true }, e, { key: e.key || e.msgObject.messageId }));
        })
      );
    })
  );
};

ActivityList.propTypes = {
  className: _react.PropTypes.string,
  activities: _react.PropTypes.array,
  classes: _react.PropTypes.object,
  companyId: _react.PropTypes.string
};
var select = function select(_ref) {
  var user = _ref.user;
  return {
    companyId: user.getIn(['company', 'companyId'])
  };
};

exports.default = (0, _reactRedux.connect)(select, {})((0, _reactJss2.default)(styles)(ActivityList));

/***/ }),
/* 3604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _materialUi = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(27);

var _actions = __webpack_require__(2045);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateSecondaryTemplateRouter = function (_Component) {
  _inherits(CreateSecondaryTemplateRouter, _Component);

  function CreateSecondaryTemplateRouter() {
    _classCallCheck(this, CreateSecondaryTemplateRouter);

    return _possibleConstructorReturn(this, (CreateSecondaryTemplateRouter.__proto__ || Object.getPrototypeOf(CreateSecondaryTemplateRouter)).apply(this, arguments));
  }

  _createClass(CreateSecondaryTemplateRouter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          goBack = _props.goBack,
          templateName = _props.templateName,
          createTemplate = _props.createTemplate,
          typeName = _props.typeName,
          creating = _props.creating;

      return _react2.default.createElement(
        'div',
        { className: 'l-app-content' },
        _react2.default.createElement(
          _materialUi.Paper,
          { className: classes.paperContainer },
          _react2.default.createElement(
            'div',
            { className: classes.headerContainer },
            _react2.default.createElement(
              'h4',
              { className: classes.title },
              'Create Corporate Policies & Notes Template'
            ),
            _react2.default.createElement(_materialUi.FlatButton, {
              icon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-arrow_back', color: 'white' }),
              label: 'back',
              style: { color: 'white' },
              onTouchTap: goBack
            })
          ),
          _react2.default.createElement(
            'div',
            { className: classes.body },
            _react2.default.createElement(
              'p',
              { style: { color: 'rgba(0, 0, 0, 0.54)' } },
              'Corporate Policies & Notes allow you to create master policies that can be shared across multiple templates. If you ever need to update these policies or notes, all you\u2019ll need to do is update the master, and we\u2019ll update the associated templates.'
            ),
            _react2.default.createElement(_materialUi.TextField, {
              value: templateName,
              floatingLabelText: 'Template Name',
              underlineStyle: { borderColor: '#00bcd4' },
              onChange: typeName
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_materialUi.RaisedButton, {
              label: creating ? 'Creating' : 'Create',
              disabled: creating,
              secondary: true,
              onTouchTap: createTemplate
            })
          )
        )
      );
    }
  }]);

  return CreateSecondaryTemplateRouter;
}(_react.Component);

CreateSecondaryTemplateRouter.propTypes = {
  goBack: _react.PropTypes.func,
  replace: _react.PropTypes.func,
  classes: _react.PropTypes.object,
  createTemplate: _react.PropTypes.func,
  templateName: _react.PropTypes.string,
  typeName: _react.PropTypes.func,
  creating: _react.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(_ref) {
  var createNew = _ref.contracting.masterTemplate.createNew;
  return createNew;
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  goBack: _reactRouterRedux.goBack,
  createTemplate: _actions.createTemplate,
  typeName: _actions.typeName
})((0, _reactJss2.default)({
  paperContainer: {
    width: '700px',
    margin: 'auto'
  },
  headerContainer: {
    backgroundColor: '#00bcd4',
    color: '#fff',
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  title: {
    width: '70%',
    color: '#FFFFFF',
    fontWeight: '500',
    paddingRight: '32px',
    textAlign: 'right'
  },
  body: {
    padding: '24px',
    paddingBottom: '32px'
  }
})(CreateSecondaryTemplateRouter));

/***/ }),
/* 3605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _materialUi = __webpack_require__(3);

var _actions = __webpack_require__(741);

var _actions2 = __webpack_require__(2045);

var _deviceHub = __webpack_require__(2046);

var _deviceHub2 = _interopRequireDefault(_deviceHub);

var _extension = __webpack_require__(2027);

var _extension2 = _interopRequireDefault(_extension);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _reactRouterRedux = __webpack_require__(27);

var _moment = __webpack_require__(17);

var _moment2 = _interopRequireDefault(_moment);

var _contractingUtils = __webpack_require__(124);

var _reactRouter = __webpack_require__(67);

var _cancelConfirmButtons = __webpack_require__(2028);

var _cancelConfirmButtons2 = _interopRequireDefault(_cancelConfirmButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  cell: { padding: 0, textAlign: 'center', height: '40px', overflow: 'visible' }
};

var masterTemplateList = function (_React$Component) {
  _inherits(masterTemplateList, _React$Component);

  function masterTemplateList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, masterTemplateList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = masterTemplateList.__proto__ || Object.getPrototypeOf(masterTemplateList)).call.apply(_ref, [this].concat(args))), _this), _this.goToSecondary = function (id) {
      return function () {
        return _this.props.push('/contracting/master-template/' + id);
      };
    }, _this.goToAssociatedTemplates = function (id) {
      return function () {
        _this.goToSecondary(id)();
        _this.props.toggleAssoicatedTemplates();
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(masterTemplateList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          list = _props.list,
          css = _props.classes,
          push = _props.push,
          updateSecondaryTemplateProps = _props.updateSecondaryTemplateProps,
          deleteTemplate = _props.deleteTemplate,
          renameTemplate = _props.renameTemplate;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _materialUi.Table,
          {
            bodyStyle: { overflow: 'visible' },
            style: { overflow: 'visible' },
            wrapperStyle: { overflow: 'visible' }
          },
          _react2.default.createElement(
            _materialUi.TableHeader,
            { displaySelectAll: false, adjustForCheckbox: false },
            _react2.default.createElement(
              _materialUi.TableRow,
              null,
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { colSpan: '15', style: { height: '40px' } },
                'Name'
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { colSpan: '3', style: styles.cell },
                'Associated Templates'
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { colSpan: '3', style: styles.cell },
                'Status'
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { colSpan: '3', style: styles.cell },
                'Modified'
              ),
              _react2.default.createElement(
                _materialUi.TableHeaderColumn,
                { colSpan: '2', style: styles.cell },
                'Actions'
              )
            )
          ),
          _react2.default.createElement(
            _materialUi.TableBody,
            { displayRowCheckbox: false, style: { overflow: 'visible' } },
            list.map(function (_ref2, i) {
              var _id = _ref2._id,
                  templateName = _ref2.templateName,
                  status = _ref2.status,
                  hasDraft = _ref2.hasDraft,
                  type = _ref2.type,
                  _ref2$templates = _ref2.templates,
                  templates = _ref2$templates === undefined ? [] : _ref2$templates,
                  updatedAt = _ref2.updatedAt,
                  more = _objectWithoutProperties(_ref2, ['_id', 'templateName', 'status', 'hasDraft', 'type', 'templates', 'updatedAt']);

              var id = '' + (status === 'draft' ? 'draft:' : '') + _id;
              return _react2.default.createElement(
                _materialUi.TableRow,
                { key: i, selectable: false, style: { overflow: 'visible', borderBottom: '1px solid #e0e0e0' } },
                _react2.default.createElement(
                  _materialUi.TableRowColumn,
                  { colSpan: '15', style: { height: '40px', cursor: 'pointer' } },
                  _react2.default.createElement(
                    'div',
                    { onClick: _this2.goToSecondary(id) },
                    !more.showEditNameConfirmButton ? _react2.default.createElement(
                      'div',
                      { className: 'flex-center' },
                      _react2.default.createElement(_extension2.default, {
                        color: 'rgba(0, 0, 0, 0.44)',
                        style: { width: '18px', height: '18px' }
                      }),
                      '\xA0',
                      templateName,
                      '\xA0',
                      _react2.default.createElement(
                        'small',
                        null,
                        more.version > 1 ? '(v.' + more.version + ')' : ''
                      )
                    ) : _react2.default.createElement('input', {
                      style: { height: '32px', width: '90%' },
                      autoFocus: true,
                      onClick: function onClick(e) {
                        return e.stopPropagation();
                      },
                      value: more.newTemplateName,
                      onChange: function onChange(_ref3) {
                        var value = _ref3.target.value;
                        return updateSecondaryTemplateProps({
                          id: _id,
                          newTemplateName: value,
                          errorText: ''
                        });
                      }
                    }),
                    _react2.default.createElement(
                      'div',
                      null,
                      hasDraft ? _react2.default.createElement(
                        'span',
                        { style: { marginLeft: '12px', color: 'red', zIndex: '200' } },
                        'This template has a',
                        ' ',
                        _react2.default.createElement(
                          _reactRouter.Link,
                          {
                            onClick: function onClick(e) {
                              return e.stopPropagation();
                            },
                            to: '/contracting/master-template/draft:' + _id
                          },
                          'draft'
                        ),
                        '.'
                      ) : _react2.default.createElement('span', null)
                    )
                  )
                ),
                !(more.showDeleteConfirmButton || more.showEditNameConfirmButton) ? [_react2.default.createElement(
                  _materialUi.TableRowColumn,
                  {
                    key: 'templates',
                    colSpan: '3',
                    style: _extends({}, styles.cell, { cursor: 'pointer' })
                  },
                  _react2.default.createElement(
                    'div',
                    {
                      onClick: _this2.goToAssociatedTemplates(id)
                    },
                    templates.length
                  )
                ), _react2.default.createElement(
                  _materialUi.TableRowColumn,
                  {
                    key: 'status',
                    colSpan: '3',
                    style: _extends({}, styles.cell, { color: (0, _contractingUtils.getTemplateStatusColor)(status) })
                  },
                  status
                ), _react2.default.createElement(
                  _materialUi.TableRowColumn,
                  { key: 'ts', colSpan: '3', style: styles.cell },
                  (0, _moment2.default)(updatedAt).calendar(null, {
                    sameDay: '[Today]',
                    lastDay: '[Yesterday]',
                    lastWeek: '[Last] dddd',
                    sameElse: 'DD/MM/YYYY'
                  })
                ), _react2.default.createElement(
                  _materialUi.TableRowColumn,
                  { key: 'actions', colSpan: '2', style: styles.cell },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'center' } },
                    _react2.default.createElement(
                      _materialUi.IconButton,
                      {
                        disabled: status === 'draft',
                        tooltip: 'Apply to Templates',
                        tooltipPosition: 'top-right',
                        onClick: function onClick(e) {
                          return e.stopPropagation();
                        },
                        style: { padding: '0', width: '36px', height: '24px' },
                        onTouchTap: function onTouchTap() {
                          return push('/contracting/master-template/' + _id + '/associate');
                        }
                      },
                      _react2.default.createElement(_deviceHub2.default, { color: 'rgba(0, 0, 0, 0.54)' })
                    ),
                    _react2.default.createElement(
                      _materialUi.IconMenu,
                      {
                        iconButtonElement: _react2.default.createElement(_materialUi.IconButton, {
                          iconClassName: 'tc-icon-more-vert',
                          iconStyle: { color: 'rgba(0, 0, 0, 0.54)', top: '2px' },
                          style: { padding: '0', width: '24px', height: '24px' }
                        })
                      },
                      _react2.default.createElement(_materialUi.MenuItem, {
                        leftIcon: _react2.default.createElement(_materialUi.FontIcon, {
                          className: 'tc-icon-delete2',
                          color: Boolean(templates.length) ? '#e0e0e0' : 'red'
                        }),
                        primaryText: 'Delete Template',
                        disabled: Boolean(templates.length),
                        onTouchTap: function onTouchTap() {
                          return updateSecondaryTemplateProps({ id: _id, showDeleteConfirmButton: true });
                        }
                      }),
                      _react2.default.createElement(_materialUi.MenuItem, {
                        leftIcon: _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-mode_edit', color: '#00bcd4' }),
                        primaryText: 'Edit Template Name',
                        onTouchTap: function onTouchTap() {
                          return updateSecondaryTemplateProps({
                            id: _id,
                            showEditNameConfirmButton: true,
                            newTemplateName: templateName
                          });
                        }
                      })
                    )
                  )
                )] : [_react2.default.createElement(
                  _materialUi.TableRowColumn,
                  {
                    key: 'errorText',
                    colSpan: '3',
                    style: { color: 'red', padding: 0, whiteSpace: 'pre-wrap' }
                  },
                  more.errorText
                ), _react2.default.createElement(
                  _materialUi.TableRowColumn,
                  { key: 'editState', colSpan: '8', style: { padding: 0 } },
                  _react2.default.createElement(_cancelConfirmButtons2.default, {
                    callingApi: more.savingName,
                    disableConfirmBtn: Boolean(more.showEditNameConfirmButton && (!more.newTemplateName || !more.newTemplateName.trim() || more.newTemplateName === templateName || more.errorText)),
                    forDelete: more.showDeleteConfirmButton,
                    confirmLabel: more.showDeleteConfirmButton ? 'Yes, Delete' : 'Confirm Change',
                    cancelLabel: 'Nevermind',
                    cancelFn: function cancelFn() {
                      return updateSecondaryTemplateProps({
                        id: _id,
                        showDeleteConfirmButton: false,
                        errorText: '',
                        showEditNameConfirmButton: false,
                        newTemplateName: ''
                      });
                    },
                    confirmFn: more.showDeleteConfirmButton ? function () {
                      return deleteTemplate({ id: _id });
                    } : function () {
                      return renameTemplate({ id: _id, newName: more.newTemplateName });
                    }
                  })
                )]
              );
            })
          )
        )
      );
    }
  }]);

  return masterTemplateList;
}(_react2.default.Component);

masterTemplateList.propTypes = {
  list: _react.PropTypes.array,
  classes: _react.PropTypes.object,
  push: _react.PropTypes.func,
  updateSecondaryTemplateProps: _react.PropTypes.func,
  toggleAssoicatedTemplates: _react.PropTypes.func,
  deleteTemplate: _react.PropTypes.func,
  renameTemplate: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref4) {
  var contracting = _ref4.contracting;
  return _extends({}, contracting.masterTemplate.list);
};

var mapDispatchToProps = {
  push: _reactRouterRedux.push,
  toggleAssoicatedTemplates: _actions.toggleAssoicatedTemplates,
  updateSecondaryTemplateProps: _actions2.updateSecondaryTemplateProps,
  renameTemplate: _actions2.renameTemplate,
  deleteTemplate: _actions2.deleteTemplate
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(masterTemplateList));

/***/ }),
/* 3606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _simpleTemplateList = __webpack_require__(1275);

var _simpleTemplateList2 = _interopRequireDefault(_simpleTemplateList);

var _reactRedux = __webpack_require__(6);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _materialUi = __webpack_require__(3);

var _actions = __webpack_require__(1263);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  templates: _react.PropTypes.array,
  sendUpdatesFromQueue: _react.PropTypes.func,
  clearState: _react.PropTypes.func,
  sendingUpdates: _react.PropTypes.bool,
  updateProcessInitiated: _react.PropTypes.bool,
  error: _react.PropTypes.string
};

var SupplierUpdatesQueueRouter = function (_Component) {
  _inherits(SupplierUpdatesQueueRouter, _Component);

  function SupplierUpdatesQueueRouter() {
    _classCallCheck(this, SupplierUpdatesQueueRouter);

    var _this = _possibleConstructorReturn(this, (SupplierUpdatesQueueRouter.__proto__ || Object.getPrototypeOf(SupplierUpdatesQueueRouter)).call(this));

    _this.openDialog = function () {
      return _this.setState({ openDialog: true });
    };

    _this.closeDialog = function () {
      _this.setState({ openDialog: false, subject: '' });
      _this.props.clearState();
    };

    _this.updateSubject = function (_ref) {
      var value = _ref.target.value;
      return _this.setState({ subject: value });
    };

    _this.sendUpdatesFromQueue = function () {
      var templateIds = _this.props.templates.filter(function (obj) {
        return obj.stagedUpdates && obj.stagedUpdates.length;
      }).map(function (obj) {
        return obj._id;
      });
      _this.props.sendUpdatesFromQueue(templateIds, _this.state.subject);
    };

    _this.state = {
      openDialog: false,
      subject: ''
    };
    return _this;
  }

  _createClass(SupplierUpdatesQueueRouter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$templates = _props.templates,
          templates = _props$templates === undefined ? [] : _props$templates,
          sendingUpdates = _props.sendingUpdates,
          updateProcessInitiated = _props.updateProcessInitiated,
          error = _props.error;
      var _state = this.state,
          openDialog = _state.openDialog,
          subject = _state.subject;

      var queuedTemplates = templates.filter(function (obj) {
        return obj.stagedUpdates && obj.stagedUpdates.length;
      });
      var queuedNonInitiatedTemplates = templates.filter(function (obj) {
        return obj.stagedUpdates && obj.stagedUpdates.length && !obj.updateInitiated;
      });
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            className: 'flex-tc-sb',
            style: {
              height: '51px',
              backgroundColor: 'rgba(0, 0, 0, 0.05)',
              padding: '0 16px',
              borderBottom: '1px solid #e0e0e0'
            }
          },
          _react2.default.createElement(
            'span',
            { style: { lineHeight: '51px' } },
            'You have ',
            queuedTemplates.length,
            ' ',
            (0, _pluralize2.default)('template', queuedTemplates.length),
            ' queued for updates.'
          ),
          _react2.default.createElement(_materialUi.RaisedButton, {
            secondary: true,
            disabled: !queuedNonInitiatedTemplates.length,
            onTouchTap: this.openDialog,
            label: 'Send All Updates'
          })
        ),
        Boolean(queuedTemplates.length) && _react2.default.createElement(_simpleTemplateList2.default, { templates: queuedTemplates }),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            open: openDialog,
            contentStyle: { width: '450px', padding: '16px 8px' },
            onRequestClose: this.closeDialog,
            modal: true,
            actionsContainerStyle: { textAlign: 'center', paddingBottom: '24px' },
            actions: [_react2.default.createElement(_materialUi.RaisedButton, {
              key: '1',
              secondary: true,
              disabled: sendingUpdates || !subject,
              label: updateProcessInitiated ? 'Dismiss' : 'Send',
              onTouchTap: updateProcessInitiated ? this.closeDialog : this.sendUpdatesFromQueue
            })]
          },
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'right', marginBottom: '12px' } },
            _react2.default.createElement(_materialUi.FontIcon, {
              className: 'tc-icon-close',
              style: { cursor: 'pointer', display: sendingUpdates ? 'none' : 'default' },
              onClick: this.closeDialog
            })
          ),
          function () {
            if (sendingUpdates) {
              return _react2.default.createElement(
                'div',
                { style: { textAlign: 'center' } },
                _react2.default.createElement(_materialUi.CircularProgress, { style: { margin: 'auto' }, size: 50 }),
                _react2.default.createElement('br', null),
                'Please hold...'
              );
            }
            if (updateProcessInitiated) {
              return 'Great! We have received your request and are processing your updates. Feel free to continue working in the system.';
            }
            if (error) return error;
            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                { style: { color: 'rgba(0, 0, 0, 0.64)' } },
                'Please add a subject:'
              ),
              _react2.default.createElement('input', {
                value: subject,
                autoFocus: true,
                onChange: _this2.updateSubject,
                style: {
                  width: '87%',
                  height: '24px',
                  marginTop: '8px',
                  marginBottom: '16px',
                  paddingLeft: '4px'
                }
              }),
              'Templates to be updated:',
              queuedTemplates.map(function (template) {
                return _react2.default.createElement(
                  'div',
                  {
                    key: template._id,
                    style: { fontSize: '12px' }
                  },
                  _react2.default.createElement(_materialUi.FontIcon, {
                    className: 'tc-icon-attach_file',
                    style: { fontSize: '12px', color: 'rgba(0, 0, 0, 0.44)' }
                  }),
                  '\xA0',
                  template.templateName
                );
              })
            );
          }()
        )
      );
    }
  }]);

  return SupplierUpdatesQueueRouter;
}(_react.Component);

SupplierUpdatesQueueRouter.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref2) {
  var contracting = _ref2.contracting;
  return _extends({
    templates: contracting.templateList.toJS().templates
  }, contracting.supplierUpdatesQueue);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  sendUpdatesFromQueue: _actions.sendUpdatesFromQueue,
  clearState: _actions.clearState
})(SupplierUpdatesQueueRouter);

/***/ }),
/* 3607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _actions = __webpack_require__(741);

var _policyNotes = __webpack_require__(3608);

var _policyNotes2 = _interopRequireDefault(_policyNotes);

var _description = __webpack_require__(561);

var _description2 = _interopRequireDefault(_description);

var _deviceHub = __webpack_require__(2046);

var _deviceHub2 = _interopRequireDefault(_deviceHub);

var _associatedTemplateList = __webpack_require__(3609);

var _associatedTemplateList2 = _interopRequireDefault(_associatedTemplateList);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _styles = __webpack_require__(1276);

var _styles2 = _interopRequireDefault(_styles);

var _ramda = __webpack_require__(2);

var _ramda2 = _interopRequireDefault(_ramda);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _editHistories = __webpack_require__(1261);

var _editHistories2 = _interopRequireDefault(_editHistories);

var _smallButtons = __webpack_require__(94);

var _editDialog = __webpack_require__(3610);

var _editDialog2 = _interopRequireDefault(_editDialog);

var _finaliseDialog = __webpack_require__(3611);

var _finaliseDialog2 = _interopRequireDefault(_finaliseDialog);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _watermark = __webpack_require__(1547);

var _watermark2 = _interopRequireDefault(_watermark);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import { Link } from 'react-router';


var SecondaryTemplateRouter = function (_Component) {
  _inherits(SecondaryTemplateRouter, _Component);

  function SecondaryTemplateRouter() {
    _classCallCheck(this, SecondaryTemplateRouter);

    var _this = _possibleConstructorReturn(this, (SecondaryTemplateRouter.__proto__ || Object.getPrototypeOf(SecondaryTemplateRouter)).call(this));

    _this.toggleShowChangesPopover = function (e) {
      return _this.setState({
        showDraftChangesPopoverOpen: !_this.state.showDraftChangesPopoverOpen,
        showDraftChangesPopoverAnchor: e && e.currentTarget
      });
    };

    _this.state = {
      showDraftChangesPopoverOpen: false,
      showDraftChangesPopoverAnchor: null,
      showTemplates: false
    };
    return _this;
  }

  _createClass(SecondaryTemplateRouter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showDraftChangesPopoverOpen = _state.showDraftChangesPopoverOpen,
          showDraftChangesPopoverAnchor = _state.showDraftChangesPopoverAnchor;
      var _props = this.props,
          classes = _props.classes,
          children = _props.children,
          doc = _props.doc,
          createNGoToDraft = _props.createNGoToDraft,
          discardDraft = _props.discardDraft,
          replace = _props.replace,
          push = _props.push,
          goBack = _props.goBack,
          clickFinalise = _props.clickFinalise,
          toggleAssoicatedTemplates = _props.toggleAssoicatedTemplates;
      var type = doc.type,
          status = doc.status,
          templateName = doc.templateName,
          _doc$templates = doc.templates,
          templates = _doc$templates === undefined ? [] : _doc$templates,
          isLatest = doc.isLatest,
          allVersions = doc.allVersions,
          version = doc.version;

      var routerActions = function routerActions() {
        var applyToBtn = _react2.default.createElement(_materialUi.FlatButton, {
          key: 'applyToBtn',
          label: 'Apply to Templates',
          backgroundColor: window.location.href.indexOf('associate') > -1 ? 'rgba(0, 0, 0, 0.3)' : '',
          hoverColor: 'rgba(0, 0, 0, 0.15)',
          labelStyle: { textTransform: 'none' },
          style: { color: 'white' },
          disabled: doc.originFrom === 'initial',
          onTouchTap: function onTouchTap() {
            return replace('/contracting/master-template/' + (doc.status === 'draft' ? doc.draftId : doc._id) + '/associate?type=' + type);
          },
          icon: _react2.default.createElement(_deviceHub2.default, { style: { color: 'white', fontSize: '22px' } })
        });
        var associatedBtn = _react2.default.createElement(_materialUi.FlatButton, {
          key: 'associatedBtn',
          label: templates.length + ' Associated ' + (0, _pluralize2.default)('Template', templates.length),
          labelStyle: { textTransform: 'none', paddingRight: '8px' },
          hoverColor: 'rgba(0, 0, 0, 0.15)',
          style: { color: 'white', minWidth: '68px' },
          onTouchTap: toggleAssoicatedTemplates,
          icon: _react2.default.createElement(_description2.default, { style: { color: 'white', fontSize: '22px', marginLeft: '8px' } })
        });
        var clickFinaliseBtn = _react2.default.createElement(_materialUi.RaisedButton, {
          key: 'clickFinaliseBtn',
          label: 'Finalise',
          disabled: _ramda2.default.isEmpty(doc.rawDiffData),
          secondary: true,
          labelStyle: { textTransform: 'none', paddingRight: '12px' },
          style: { color: 'white', minWidth: '68px', marginLeft: '16px' },
          onTouchTap: clickFinalise
        });
        var editBtn = _react2.default.createElement(_materialUi.FlatButton, {
          key: 'editBtn',
          label: 'Edit',
          labelStyle: { textTransform: 'none', paddingRight: '12px' },
          hoverColor: 'rgba(0, 0, 0, 0.15)',
          style: { color: 'white', minWidth: '68px', marginLeft: '16px' },
          onTouchTap: function onTouchTap() {
            if (doc.hasDraft) {
              push('/contracting/master-template/draft:' + doc._id);
            } else createNGoToDraft();
          },
          icon: _react2.default.createElement(_materialUi.FontIcon, {
            className: 'tc-icon-mode_edit',
            style: { fontSize: '22px', marginLeft: '8px' }
          })
        });
        var closeBtn = _react2.default.createElement(
          'div',
          {
            key: 'closeBtn',
            className: classes.closeBtn,
            onClick: goBack
          },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-close', style: { fontSize: '36px', color: '#fff' } })
        );
        if (status === 'draft') {
          return [associatedBtn, clickFinaliseBtn, closeBtn];
        }
        if (!isLatest) {
          return [closeBtn];
        }
        return [applyToBtn, associatedBtn, editBtn, closeBtn];
      };
      var versionsNode = allVersions && allVersions.length > 1 ? _react2.default.createElement(
        _materialUi.IconMenu,
        {
          desktop: true,
          style: { marginLeft: '4px', cursor: 'pointer' },
          iconButtonElement: _react2.default.createElement(_smallButtons.SmallRaisedButton, {
            labelStyle: {
              padding: '0 6px',
              fontSize: '12px'
            },
            style: { marginLeft: '8px' },
            label: '(Version ' + version + ')'
          })
        },
        allVersions.map(function (v, i) {
          return _react2.default.createElement(_materialUi.MenuItem, {
            key: v,
            disabled: v === doc._id,
            primaryText: 'Version ' + (i + 1),
            onTouchTap: function onTouchTap() {
              return replace('/contracting/master-template/' + v);
            }
          });
        })
      ) : '';

      var _ref = function () {
        if (type === 'policyNotes') {
          return {
            ContentNode: _policyNotes2.default,
            typeLabel: 'Corporate Policies & Notes'
          };
        }
        return {
          ContentNode: 'div'
        };
      }(),
          ContentNode = _ref.ContentNode,
          typeLabel = _ref.typeLabel;

      return _react2.default.createElement(
        'div',
        { className: 'full-screen-page' },
        _react2.default.createElement(
          'div',
          {
            className: classes.topbar
          },
          _react2.default.createElement(
            'span',
            {
              className: classes.topBarTitle,
              onClick: function onClick() {
                return push('/contracting/master-template-list?type=' + type);
              }
            },
            typeLabel,
            ' Templates'
          ),
          _react2.default.createElement(
            'span',
            { style: { fontSize: 18 } },
            '\xA0>\xA0'
          ),
          _react2.default.createElement(
            'span',
            {
              className: classes.topBarTitle,
              onClick: function onClick() {
                return replace('/contracting/master-template/' + doc._id);
              }
            },
            templateName
          ),
          versionsNode
        ),
        _react2.default.createElement(
          'div',
          { className: classes.topbarActions },
          routerActions()
        ),
        _react2.default.createElement(
          'div',
          { className: classes.body },
          !isLatest && !doc.loading && _react2.default.createElement(_watermark2.default, { texts: ['Old Version', 'Old Version', 'Old Version', 'Old Version'] }),
          function () {
            if (status === 'draft' && doc.originFrom === 'edited') {
              return _react2.default.createElement(
                'div',
                {
                  className: 'flex-tc-sb ' + classes.subTitle
                },
                _react2.default.createElement(
                  'span',
                  null,
                  'This draft was created from this',
                  ' ',
                  _react2.default.createElement(
                    'a',
                    {
                      style: { cursor: 'pointer' },
                      onClick: function onClick() {
                        return replace('/contracting/master-template/' + doc.draftId);
                      }
                    },
                    'template'
                  ),
                  '.'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'flex-center' },
                  _react2.default.createElement(_materialUi.FlatButton, {
                    secondary: true,
                    label: _ramda2.default.isEmpty(doc.rawDiffData) ? 'You haven\'t made any changes yet.' : 'View Changes',
                    labelStyle: _styles2.default.flatBtnLabelStyle,
                    style: {
                      height: '30px',
                      display: 'block',
                      border: _ramda2.default.isEmpty(doc.rawDiffData) ? 'none' : '1px solid #00bcd4'
                    },
                    disabled: _ramda2.default.isEmpty(doc.rawDiffData),
                    onTouchTap: _this2.toggleShowChangesPopover
                  }),
                  _react2.default.createElement(_materialUi.FlatButton, {
                    primary: true,
                    label: _ramda2.default.isEmpty(doc.rawDiffData) ? 'Discard Draft' : 'Discard Changes',
                    labelStyle: _styles2.default.flatBtnLabelStyle,
                    style: { height: '30px', border: '1px solid #ff4081', marginLeft: '8px' },
                    onTouchTap: discardDraft
                  })
                )
              );
            }
            if (status === 'completed' && doc.hasDraft) {
              return _react2.default.createElement(
                'div',
                {
                  className: classes.subTitle
                },
                _react2.default.createElement(
                  'span',
                  null,
                  'This template has a',
                  ' ',
                  _react2.default.createElement(
                    'a',
                    {
                      style: { cursor: 'pointer' },
                      onClick: function onClick() {
                        return replace('/contracting/master-template/draft:' + doc._id);
                      }
                    },
                    'draft'
                  ),
                  '.'
                )
              );
            }
            return _react2.default.createElement('div', null);
          }(),
          _react2.default.createElement(
            'div',
            { className: classes.content },
            children ? children : _react2.default.createElement(ContentNode, null)
          )
        ),
        _react2.default.createElement(
          _materialUi.Popover,
          {
            open: showDraftChangesPopoverOpen,
            anchorEl: showDraftChangesPopoverAnchor,
            anchorOrigin: { horizontal: 'middle', vertical: 'bottom' },
            targetOrigin: { horizontal: 'right', vertical: 'top' },
            onRequestClose: this.toggleShowChangesPopover,
            style: { padding: '16px' }
          },
          _react2.default.createElement(_editHistories2.default, {
            diffSummary: {
              summaryByPage: doc.rawDiffData,
              ratesSummary: doc.ratesSummary
            }
          })
        ),
        _react2.default.createElement(_loadingOverlay2.default, { loading: doc.loading }),
        _react2.default.createElement(_editDialog2.default, null),
        _react2.default.createElement(_finaliseDialog2.default, { typeLabel: typeLabel }),
        _react2.default.createElement(_associatedTemplateList2.default, { typeLabel: typeLabel })
      );
    }
  }]);

  return SecondaryTemplateRouter;
}(_react.Component);

SecondaryTemplateRouter.propTypes = {
  children: _react.PropTypes.node,
  goBack: _react.PropTypes.func,
  classes: _react.PropTypes.object,
  doc: _react.PropTypes.object,
  createNGoToDraft: _react.PropTypes.func,
  push: _react.PropTypes.func,
  replace: _react.PropTypes.func,
  clickFinalise: _react.PropTypes.func,
  discardDraft: _react.PropTypes.func,
  toggleAssoicatedTemplates: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var docs = _ref2.contracting.masterTemplate.docs;

  return {
    doc: docs[docs.currentId] || {}
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  goBack: _reactRouterRedux.goBack,
  push: _reactRouterRedux.push,
  createNGoToDraft: _actions.createNGoToDraft,
  replace: _reactRouterRedux.replace,
  clickFinalise: _actions.clickFinalise,
  discardDraft: _actions.discardDraft,
  toggleAssoicatedTemplates: _actions.toggleAssoicatedTemplates
})((0, _reactJss2.default)(_styles2.default)(SecondaryTemplateRouter));

/***/ }),
/* 3608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(27);

var _actions = __webpack_require__(741);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _styles = __webpack_require__(1276);

var _styles2 = _interopRequireDefault(_styles);

var _termsCriteriaNode = __webpack_require__(1264);

var _termsCriteriaNode2 = _interopRequireDefault(_termsCriteriaNode);

var _billingInfoNode = __webpack_require__(1265);

var _billingInfoNode2 = _interopRequireDefault(_billingInfoNode);

var _policiesNode = __webpack_require__(1561);

var _policiesNode2 = _interopRequireDefault(_policiesNode);

var _checkinout = __webpack_require__(1267);

var _checkinout2 = _interopRequireDefault(_checkinout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PolicyNotesTemplate = function PolicyNotesTemplate(props) {
  var doc = props.doc,
      openEditDialog = props.openEditDialog,
      saveSupplierInfoChanges = props.saveSupplierInfoChanges;

  var status = doc.status,
      supplierInfo = doc.supplierInfo,
      billingInformation = doc.billingInformation,
      locationPolicy = doc.locationPolicy,
      propsForCheckInCheckOut = _objectWithoutProperties(doc, ['status', 'supplierInfo', 'billingInformation', 'locationPolicy']);

  var editable = status === 'draft';
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_termsCriteriaNode2.default, _extends({}, supplierInfo, {
      editable: editable,
      openAddEditContractDialog: openEditDialog,
      forSupplier: true,
      inMaster: true
    })),
    _react2.default.createElement(_policiesNode2.default, {
      locationPolicy: locationPolicy,
      supplierEditable: editable,
      openAddEditContractDialog: openEditDialog,
      deleteLocationPolicy: function deleteLocationPolicy(policyType) {
        return function () {
          var confirmed = window.confirm('Are sure you want to delete this policy?');
          if (confirmed) saveSupplierInfoChanges({
            contractId: props.contractId,
            doc: { policyType: policyType },
            updateType: 'DELETE_LOCATION_POLICY'
          });
        };
      },
      inMaster: true
    }),
    _react2.default.createElement(_checkinout2.default, _extends({}, propsForCheckInCheckOut, {
      supplierEditable: editable,
      openAddEditContractDialog: openEditDialog,
      inMaster: true
    })),
    _react2.default.createElement(_billingInfoNode2.default, _extends({}, billingInformation, {
      supplierEditable: editable,
      openAddEditContractDialog: openEditDialog,
      inMaster: true
    }))
  );
};

PolicyNotesTemplate.propTypes = {
  doc: _react.PropTypes.object,
  classes: _react.PropTypes.object,
  location: _react.PropTypes.object,
  openEditDialog: _react.PropTypes.func,
  saveSupplierInfoChanges: _react.PropTypes.func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var docs = _ref.contracting.masterTemplate.docs;

  return {
    doc: docs[docs.currentId] || {}
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  goBack: _reactRouterRedux.goBack,
  openEditDialog: _actions.openEditDialog,
  saveSupplierInfoChanges: _actions.saveSupplierInfoChanges
})((0, _reactJss2.default)(_styles2.default)(PolicyNotesTemplate));

/***/ }),
/* 3609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _materialUi = __webpack_require__(3);

var _simpleTemplateList = __webpack_require__(1275);

var _simpleTemplateList2 = _interopRequireDefault(_simpleTemplateList);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(741);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssociatedTemplateListDialog = function AssociatedTemplateListDialog(props) {
  var open = props.open,
      toggleAssoicatedTemplates = props.toggleAssoicatedTemplates,
      _props$doc$templates = props.doc.templates,
      templates = _props$doc$templates === undefined ? [] : _props$doc$templates,
      typeLabel = props.typeLabel;

  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: open,
      title: _react2.default.createElement(
        'div',
        { className: 'flex-tc-sb' },
        templates.length,
        ' Associated ',
        (0, _pluralize2.default)('Template', templates.length),
        _react2.default.createElement(
          'div',
          { onClick: toggleAssoicatedTemplates },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-close', style: { fontSize: '24px', cursor: 'pointer' } })
        )
      ),
      onRequestClose: toggleAssoicatedTemplates,
      bodyStyle: { padding: '6px 16px', marginTop: '1px' },
      autoScrollBodyContent: true
    },
    templates.length ? _react2.default.createElement(_simpleTemplateList2.default, {
      templates: templates
    }) : _react2.default.createElement(
      'div',
      { style: { padding: '32px 0' } },
      'This ',
      typeLabel,
      ' template is not assoicated with any templates.'
    )
  );
};

AssociatedTemplateListDialog.propTypes = {
  open: _react.PropTypes.bool,
  toggleAssoicatedTemplates: _react.PropTypes.func,
  doc: _react.PropTypes.object,
  typeLabel: _react.PropTypes.string
};

var mapStateToProps = function mapStateToProps(_ref) {
  var docs = _ref.contracting.masterTemplate.docs;

  return {
    open: docs.showAssociatedTemplates,
    doc: docs[docs.currentId] || {}
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  toggleAssoicatedTemplates: _actions.toggleAssoicatedTemplates
})(AssociatedTemplateListDialog);

/***/ }),
/* 3610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(3);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(741);

var _billingInfo = __webpack_require__(1975);

var _billingInfo2 = _interopRequireDefault(_billingInfo);

var _editCheckinCheckout = __webpack_require__(1977);

var _editCheckinCheckout2 = _interopRequireDefault(_editCheckinCheckout);

var _extraPolicyDivs = __webpack_require__(1978);

var _extraPolicyDivs2 = _interopRequireDefault(_extraPolicyDivs);

var _termsCriteria = __webpack_require__(1981);

var _termsCriteria2 = _interopRequireDefault(_termsCriteria);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  editDialog: _react.PropTypes.object,
  onRequestClose: _react.PropTypes.func,
  saveSupplierInfoChanges: _react.PropTypes.func
};

var AddEditDialog = function (_Component) {
  _inherits(AddEditDialog, _Component);

  function AddEditDialog() {
    _classCallCheck(this, AddEditDialog);

    return _possibleConstructorReturn(this, (AddEditDialog.__proto__ || Object.getPrototypeOf(AddEditDialog)).apply(this, arguments));
  }

  _createClass(AddEditDialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          editDialog = _props.editDialog,
          extraProps = _objectWithoutProperties(_props, ['editDialog']);

      var open = editDialog.open,
          note = editDialog.note,
          type = editDialog.type,
          _editDialog$data = editDialog.data,
          data = _editDialog$data === undefined ? {} : _editDialog$data,
          saving = editDialog.saving,
          example = editDialog.example;

      var ContentNode = function () {
        switch (type) {
          case 'billingInfo':
            return _billingInfo2.default;
          case 'checkInOut':
            return _editCheckinCheckout2.default;
          case 'policy':
            return _extraPolicyDivs2.default;
          case 'corporateIdentificationNumber':
          case 'termsAndConditions':
          case 'submissionCriteria':
          case 'marketInfo':
            return _termsCriteria2.default;
          default:
            return 'div';
        }
      }();
      var px550 = {
        submissionCriteria: 'submissionCriteria',
        termsConditions: 'termsConditions',
        billingInfo: 'billingInfo',
        policy: data.policyType !== 'cancellation'
      };
      var percent45 = {
        checkInOut: 'checkInOut'
      };
      var percent30 = {
        policy: data.policyType === 'cancellation'
      };

      var width = function () {
        if (px550[type]) return '550px';
        if (percent45[type]) return '45%';
        if (!percent30[type]) return '30%';
        return '100%';
      }();
      var propsForContent = _extends({
        data: data,
        saving: saving,
        note: note,
        example: example
      }, extraProps);
      return _react2.default.createElement(
        _materialUi.Dialog,
        {
          autoScrollBodyContent: true,
          bodyStyle: { padding: '0', paddingBottom: '12px' },
          contentStyle: { maxWidth: '880px', width: width },
          open: open,
          title: data.title ? _react2.default.createElement(
            'div',
            { style: { backgroundColor: '#00BCD4', color: 'white', fontSize: '18px', padding: '16px 2%' } },
            data.title
          ) : undefined
        },
        _react2.default.createElement(ContentNode, propsForContent)
      );
    }
  }]);

  return AddEditDialog;
}(_react.Component);

AddEditDialog.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(_ref) {
  var masterTemplate = _ref.contracting.masterTemplate;

  return {
    editDialog: masterTemplate.editDialog
  };
};

var mapDispatchToProps = {
  saveSupplierInfoChanges: _actions.saveSupplierInfoChanges,
  onRequestClose: _actions.cancelEdit,
  onTextFieldChange: _actions.onTextFieldChange,
  attachInsFile: _actions.attachInsFile,
  removeInsFile: _actions.removeInsFile,
  saveBillingInfoChanges: _actions.saveBillingInfoChanges
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddEditDialog);

/***/ }),
/* 3611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _materialUi = __webpack_require__(3);

var _simpleTemplateList = __webpack_require__(1275);

var _simpleTemplateList2 = _interopRequireDefault(_simpleTemplateList);

var _emailToPartners = __webpack_require__(1540);

var _emailToPartners2 = _interopRequireDefault(_emailToPartners);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(741);

var _supplierWizardComplete = __webpack_require__(1057);

var _supplierWizardComplete2 = _interopRequireDefault(_supplierWizardComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FinaliseDialog = function FinaliseDialog(props) {
  var open = props.open,
      loadingBuyers = props.loadingBuyers,
      buyers = props.buyers,
      _props$doc$templates = props.doc.templates,
      templates = _props$doc$templates === undefined ? [] : _props$doc$templates,
      typeLabel = props.typeLabel,
      callingApi = props.callingApi,
      sendUpdatesSuccess = props.sendUpdatesSuccess,
      closeFinaliseDialog = props.closeFinaliseDialog,
      finalise = props.finalise;

  return _react2.default.createElement(
    _materialUi.Dialog,
    {
      open: open,
      title: _react2.default.createElement(
        'div',
        { className: 'flex-tc-sb' },
        'Finalise ',
        typeLabel,
        _react2.default.createElement(
          'div',
          { onClick: closeFinaliseDialog },
          _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-close', style: { fontSize: '24px', cursor: 'pointer' } })
        )
      ),
      modal: true,
      onRequestClose: closeFinaliseDialog,
      contentStyle: { maxWidth: '880px', width: '880px' },
      autoScrollBodyContent: true,
      actions: sendUpdatesSuccess ? [_react2.default.createElement(_materialUi.FlatButton, {
        key: 'dismiss',
        label: 'Dismiss',
        secondary: true,
        onTouchTap: closeFinaliseDialog
      })] : [_react2.default.createElement(_materialUi.FlatButton, {
        key: 'cancel',
        label: 'Cancel',
        disabled: callingApi,
        primary: true,
        onTouchTap: closeFinaliseDialog
      }), _react2.default.createElement(_materialUi.FlatButton, {
        key: 'confirm',
        label: 'Confirm',
        disabled: callingApi,
        secondary: true,
        onTouchTap: finalise
      })]
    },
    function () {
      if (loadingBuyers) {
        return _react2.default.createElement(
          'div',
          { style: { marginTop: '32px', textAlign: 'center' } },
          _react2.default.createElement(_materialUi.CircularProgress, { size: 120 })
        );
      }
      return _react2.default.createElement(
        'div',
        { style: { display: 'flex', alignItems: 'stretch' } },
        _react2.default.createElement(
          'div',
          { style: { width: buyers.length ? '50%' : '100%', padding: '16px 8px' } },
          sendUpdatesSuccess ? _react2.default.createElement(
            'p',
            { style: { textAlign: 'center' } },
            _react2.default.createElement('img', { src: _supplierWizardComplete2.default, style: { width: '24px', marginRight: '4px' } }),
            _react2.default.createElement(
              'span',
              null,
              (0, _pluralize2.default)('This', templates.length),
              ' ',
              (0, _pluralize2.default)('template', templates.length),
              ' ',
              (0, _pluralize2.default)('has', templates.length),
              ' been successfully updated.'
            ),
            _react2.default.createElement('img', { src: _supplierWizardComplete2.default, style: { width: '24px', marginLeft: '4px' } })
          ) : _react2.default.createElement(
            'p',
            null,
            'The following ',
            (0, _pluralize2.default)('template', templates.length),
            ' will be automatically updated:'
          ),
          templates.length ? _react2.default.createElement(_simpleTemplateList2.default, {
            templates: templates,
            makeItShorter: true
          }) : _react2.default.createElement(
            'div',
            { style: { padding: '32px 0' } },
            'This ',
            typeLabel,
            ' template is not assoicated with any templates.'
          )
        ),
        Boolean(buyers.length) && _react2.default.createElement(
          'div',
          { style: { width: '50%', borderLeft: '1px solid #e0e0e0', padding: '16px 8px' } },
          sendUpdatesSuccess ? _react2.default.createElement(
            'p',
            { style: { textAlign: 'center' } },
            _react2.default.createElement('img', { src: _supplierWizardComplete2.default, style: { width: '24px', marginRight: '4px' } }),
            _react2.default.createElement(
              'span',
              null,
              'We have successfully issued updates to ',
              (0, _pluralize2.default)('this', buyers.length),
              ' ',
              (0, _pluralize2.default)('partner', buyers.length),
              '.'
            ),
            _react2.default.createElement('img', { src: _supplierWizardComplete2.default, style: { width: '24px', marginLeft: '4px' } })
          ) : _react2.default.createElement(
            'p',
            null,
            'We will issue updates to the following ',
            (0, _pluralize2.default)('partner', buyers.length),
            '.'
          ),
          _react2.default.createElement(_emailToPartners2.default, {
            partners: buyers.map(function (buyer) {
              return _extends({}, buyer, {
                subText: '(' + buyer.templateIds.length + ' ' + (0, _pluralize2.default)('contract', buyer.templateIds.length) + ')'
              });
            }),
            justPartners: true,
            defaultShowNumOfPartners: 8
          })
        )
      );
    }()
  );
};

FinaliseDialog.propTypes = {
  open: _react.PropTypes.bool,
  closeFinaliseDialog: _react.PropTypes.func,
  doc: _react.PropTypes.object,
  typeLabel: _react.PropTypes.string,
  finalise: _react.PropTypes.func,
  callingApi: _react.PropTypes.bool,
  finaliseSuccess: _react.PropTypes.bool,
  sendUpdatesSuccess: _react.PropTypes.bool,
  loadingBuyers: _react.PropTypes.bool,
  buyers: _react.PropTypes.array
};

var mapStateToProps = function mapStateToProps(_ref) {
  var _ref$contracting$mast = _ref.contracting.masterTemplate,
      docs = _ref$contracting$mast.docs,
      finaliseDialog = _ref$contracting$mast.finaliseDialog;

  return _extends({
    doc: docs[docs.currentId] || {}
  }, finaliseDialog);
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  closeFinaliseDialog: _actions.closeFinaliseDialog,
  finalise: _actions.finalise
})(FinaliseDialog);

/***/ }),
/* 3612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(741);

var _reactRouterRedux = __webpack_require__(27);

var _materialUi = __webpack_require__(3);

var _simpleTemplateList = __webpack_require__(1275);

var _simpleTemplateList2 = _interopRequireDefault(_simpleTemplateList);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _overwriteRules = __webpack_require__(2047);

var _overwriteRules2 = _interopRequireDefault(_overwriteRules);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _styles = __webpack_require__(1276);

var _styles2 = _interopRequireDefault(_styles);

var _pluralize = __webpack_require__(68);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _supplierWizardComplete = __webpack_require__(1057);

var _supplierWizardComplete2 = _interopRequireDefault(_supplierWizardComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssociateSecondaryToTemplatesWizard = function AssociateSecondaryToTemplatesWizard(_ref) {
  var goBack = _ref.goBack,
      selectUnselectDraft = _ref.selectUnselectDraft,
      allTemplatesDrafts = _ref.allTemplatesDrafts,
      callingApi = _ref.callingApi,
      successDialogOpen = _ref.successDialogOpen,
      classes = _ref.classes,
      applyToTemplates = _ref.applyToTemplates,
      doc = _ref.doc,
      clickOk = _ref.clickOk,
      sameAsCorporatePolicyNotes = _ref.sameAsCorporatePolicyNotes;

  var filtered = allTemplatesDrafts.filter(function (obj) {
    return !obj.isArchived && obj.policyNotesTemplateId !== doc._id;
  }).sort(function (objA, objB) {
    if (objA.updatedAt > objB.updatedAt) return -1;
    return 1;
  });
  var totalSelected = allTemplatesDrafts.filter(function (obj) {
    return obj.checked;
  }).length;
  return _react2.default.createElement(
    'div',
    { style: { padding: '16px 0' } },
    _react2.default.createElement(
      'div',
      { className: 'flex-tc-stretch' },
      _react2.default.createElement(
        'div',
        { style: { padding: '16px', width: '70%' } },
        _react2.default.createElement(
          'div',
          { className: classes.applyStepperLabel },
          'Step 1: Select the templates that you\u2019d like to apply the Corporate Policies & Notes to'
        ),
        _react2.default.createElement(
          'i',
          null,
          'Note: At the present, you cannot apply Corporate Policies & Notes directly to completed templates. We hope to provide you with this ability in the near future.'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_simpleTemplateList2.default, { templates: filtered, selectOrUnselect: selectUnselectDraft })
      ),
      _react2.default.createElement(_overwriteRules2.default, {
        classes: classes
      })
    ),
    _react2.default.createElement(
      'div',
      { className: classes.bottomBar + ' flex-tc-sb ' + (totalSelected ? 'is-active' : '') },
      totalSelected,
      ' ',
      (0, _pluralize2.default)('templates', totalSelected),
      ' selected. \xA0',
      _react2.default.createElement(_materialUi.RaisedButton, {
        label: 'Apply',
        primary: true,
        disabled: !totalSelected || callingApi || !sameAsCorporatePolicyNotes.length,
        onTouchTap: applyToTemplates
      })
    ),
    _react2.default.createElement(
      _materialUi.Dialog,
      {
        open: successDialogOpen,
        contentStyle: { textAlign: 'center' }
      },
      _react2.default.createElement('img', {
        alt: '',
        src: _supplierWizardComplete2.default,
        style: { width: '25%', display: 'block', margin: 'auto' }
      }),
      _react2.default.createElement(
        'h4',
        null,
        doc.templateName,
        ' has been applied to selected templates successfully.'
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '100%' }, className: 'flex-tc-sb' },
        _react2.default.createElement(_materialUi.RaisedButton, {
          primary: true,
          label: 'View My Templates',
          onTouchTap: goBack
        }),
        _react2.default.createElement(_materialUi.RaisedButton, { secondary: true, label: 'View All Associated Templates', onTouchTap: clickOk })
      )
    ),
    _react2.default.createElement(_loadingOverlay2.default, { loading: callingApi })
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var _ref2$contracting$mas = _ref2.contracting.masterTemplate,
      applyMasterToTemplatesReducer = _ref2$contracting$mas.applyMasterToTemplatesReducer,
      docs = _ref2$contracting$mas.docs;

  return _extends({}, applyMasterToTemplatesReducer, {
    doc: docs[docs.currentId]
  });
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  goBack: _reactRouterRedux.goBack,
  selectUnselectDraft: _actions.selectUnselectDraft,
  applyToTemplates: _actions.applyToTemplates,
  clickOk: _actions.clickOk
})((0, _reactJss2.default)(_styles2.default)(AssociateSecondaryToTemplatesWizard));

/***/ }),
/* 3613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _actions = __webpack_require__(741);

var _materialUi = __webpack_require__(3);

var _loadingOverlay = __webpack_require__(216);

var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);

var _reactJss = __webpack_require__(39);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _styles = __webpack_require__(1276);

var _styles2 = _interopRequireDefault(_styles);

var _reactRouterRedux = __webpack_require__(27);

var _overwriteRules = __webpack_require__(2047);

var _overwriteRules2 = _interopRequireDefault(_overwriteRules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickMasterWizard = function PickMasterWizard(_ref) {
  var masterList = _ref.masterList,
      callingApi = _ref.callingApi,
      classes = _ref.classes,
      applyToTemplates = _ref.applyToTemplates,
      goBack = _ref.goBack,
      replace = _ref.replace,
      selectMaster = _ref.selectMaster,
      sameAsCorporatePolicyNotes = _ref.sameAsCorporatePolicyNotes;

  var totalSelected = masterList.filter(function (obj) {
    return obj.checked;
  }).length;
  return _react2.default.createElement(
    'div',
    { className: 'full-screen-page' },
    _react2.default.createElement(
      'div',
      {
        className: classes.topbar
      },
      _react2.default.createElement(
        'span',
        null,
        'Pick A Corporate Policies & Notes Template'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: classes.topbarActions },
      _react2.default.createElement(
        'div',
        {
          key: 'closeBtn',
          className: classes.closeBtn,
          onClick: goBack
        },
        _react2.default.createElement(_materialUi.FontIcon, { className: 'tc-icon-close', style: { fontSize: '36px', color: '#fff' } })
      )
    ),
    masterList.length ? _react2.default.createElement(
      'div',
      { className: classes.body, style: { padding: '70px 20%' } },
      _react2.default.createElement(
        'div',
        { className: 'flex-tc-stretch' },
        _react2.default.createElement(
          'div',
          { style: { padding: '16px', width: '70%' } },
          _react2.default.createElement(
            'div',
            { className: classes.applyStepperLabel },
            'Step 1: Select the Corporate Policies & Notes template that you\u2019d like to apply'
          ),
          masterList.map(function (obj) {
            return _react2.default.createElement(_materialUi.RadioButton, {
              key: obj._id,
              checked: Boolean(obj.checked),
              onCheck: function onCheck() {
                return selectMaster({ id: obj._id });
              },
              label: obj.templateName
            });
          })
        ),
        _react2.default.createElement(_overwriteRules2.default, {
          classes: classes,
          style: { width: '50%' }
        })
      )
    ) : _react2.default.createElement(
      'div',
      {
        className: classes.body,
        style: {
          padding: '70px 20%',
          textAlign: 'center'
        }
      },
      _react2.default.createElement(
        'div',
        { style: { fontSize: '16px', margin: '32px auto', color: 'rgba(0, 0, 0, 0.74)' } },
        'You do not have any Corporate Policies & Notes templates to apply.'
      ),
      _react2.default.createElement(
        'p',
        { style: { color: 'rgba(0, 0, 0, 0.54)' } },
        'What is a Corporate Policies & Notes template?'
      ),
      _react2.default.createElement(
        'p',
        { style: { color: 'rgba(0, 0, 0, 0.54)' } },
        'Corporate Policies & Notes allow you to create master policies that can be shared across multiple templates. If you ever need to update these policies or notes, all you\u2019ll need to do is update the master, and we\u2019ll update the associated templates.'
      ),
      _react2.default.createElement(_materialUi.RaisedButton, {
        label: 'Create a Corporate Policies & Notes Template',
        primary: true,
        onTouchTap: function onTouchTap() {
          return replace('/contracting/create-master-template');
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { className: classes.bottomBar + ' flex-center ' + (totalSelected ? 'is-active' : '') },
      _react2.default.createElement(_materialUi.RaisedButton, {
        label: 'Apply',
        primary: true,
        disabled: !totalSelected || callingApi || !sameAsCorporatePolicyNotes.length,
        onTouchTap: applyToTemplates
      })
    ),
    _react2.default.createElement(_loadingOverlay2.default, { loading: callingApi })
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var applyMasterToTemplatesReducer = _ref2.contracting.masterTemplate.applyMasterToTemplatesReducer;

  return _extends({}, applyMasterToTemplatesReducer);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  replace: _reactRouterRedux.replace,
  applyToTemplates: _actions.applyToTemplates,
  selectMaster: _actions.selectMaster,
  goBack: _reactRouterRedux.goBack
})((0, _reactJss2.default)(_styles2.default)(PickMasterWizard));

/***/ }),
/* 3614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IntercomAnalytics = function () {
  function IntercomAnalytics() {
    _classCallCheck(this, IntercomAnalytics);
  }

  _createClass(IntercomAnalytics, [{
    key: 'trackPage',
    value: function trackPage() {
      var _this = this;

      // Need to get event loop time to handle history push
      setTimeout(function () {
        // Remove TourConnect from document title
        // Remove all ObjectID in document title
        // Remove any double spaces
        _this.track('Viewed ' + document.title.substr(0, document.title.indexOf('- TourConnect')).trim().replace(/[0-9a-fA-F]{24}/g, '').replace(/ +(?= )/g, ''));
      }, 0);
    }
  }, {
    key: 'track',
    value: function track(name, values) {
      try {
        window.Intercom('trackEvent', name, _extends({}, values));
      } catch (e) {
        return;
      }
    }
  }]);

  return IntercomAnalytics;
}();

var analyticsService = new IntercomAnalytics();

exports.default = analyticsService;

/***/ })
],[2643]);


// WEBPACK FOOTER //
// app.js